
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d7Bg1", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $98d8d45cc0a53a04$export$6503ec6e8aabbaf; }, function (v) { return $98d8d45cc0a53a04$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $98d8d45cc0a53a04$export$f7ad0328861e2f03; }, function (v) { return $98d8d45cc0a53a04$export$f7ad0328861e2f03 = v; });
var $98d8d45cc0a53a04$export$6503ec6e8aabbaf;
var $98d8d45cc0a53a04$export$f7ad0328861e2f03;
"use strict";
var $98d8d45cc0a53a04$var$mapping = new Map();
function $98d8d45cc0a53a04$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$98d8d45cc0a53a04$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $98d8d45cc0a53a04$var$resolve(id) {
    var resolved = $98d8d45cc0a53a04$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$98d8d45cc0a53a04$export$6503ec6e8aabbaf = $98d8d45cc0a53a04$var$register;
$98d8d45cc0a53a04$export$f7ad0328861e2f03 = $98d8d45cc0a53a04$var$resolve;

});

parcelRegister("kKhpr", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $f1a59ba2c6c2996d$export$ffb0004e005737fa; }, function (v) { return $f1a59ba2c6c2996d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $f1a59ba2c6c2996d$export$34b9dba7ce09269b; }, function (v) { return $f1a59ba2c6c2996d$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $f1a59ba2c6c2996d$export$25062201e9e25d76; }, function (v) { return $f1a59ba2c6c2996d$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f1a59ba2c6c2996d$export$ffb0004e005737fa;
var $f1a59ba2c6c2996d$export$34b9dba7ce09269b;
var $f1a59ba2c6c2996d$export$25062201e9e25d76;
'use strict';

var $3ZYaX = parcelRequire("3ZYaX");
var $f1a59ba2c6c2996d$var$k = Symbol.for("react.element"), $f1a59ba2c6c2996d$var$l = Symbol.for("react.fragment"), $f1a59ba2c6c2996d$var$m = Object.prototype.hasOwnProperty, $f1a59ba2c6c2996d$var$n = $3ZYaX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $f1a59ba2c6c2996d$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $f1a59ba2c6c2996d$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$f1a59ba2c6c2996d$var$m.call(a, b) && !$f1a59ba2c6c2996d$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $f1a59ba2c6c2996d$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $f1a59ba2c6c2996d$var$n.current
    };
}
$f1a59ba2c6c2996d$export$ffb0004e005737fa = $f1a59ba2c6c2996d$var$l;
$f1a59ba2c6c2996d$export$34b9dba7ce09269b = $f1a59ba2c6c2996d$var$q;
$f1a59ba2c6c2996d$export$25062201e9e25d76 = $f1a59ba2c6c2996d$var$q;

});
parcelRegister("3ZYaX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2EgHj"));

});
parcelRegister("2EgHj", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $1edc44f88a20942d$export$dca3b0875bd9a954; }, function (v) { return $1edc44f88a20942d$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $1edc44f88a20942d$export$16fa2f45be04daa8; }, function (v) { return $1edc44f88a20942d$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $1edc44f88a20942d$export$ffb0004e005737fa; }, function (v) { return $1edc44f88a20942d$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $1edc44f88a20942d$export$e2c29f18771995cb; }, function (v) { return $1edc44f88a20942d$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $1edc44f88a20942d$export$221d75b3f55bb0bd; }, function (v) { return $1edc44f88a20942d$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $1edc44f88a20942d$export$5f8d39834fd61797; }, function (v) { return $1edc44f88a20942d$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $1edc44f88a20942d$export$74bf444e3cd11ea5; }, function (v) { return $1edc44f88a20942d$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $1edc44f88a20942d$export$ae55be85d98224ed; }, function (v) { return $1edc44f88a20942d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $1edc44f88a20942d$export$3ba232387fd5d6dd; }, function (v) { return $1edc44f88a20942d$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $1edc44f88a20942d$export$e530037191fcd5d7; }, function (v) { return $1edc44f88a20942d$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $1edc44f88a20942d$export$fd42f52fd3ae1109; }, function (v) { return $1edc44f88a20942d$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $1edc44f88a20942d$export$c8a8987d4410bf2d; }, function (v) { return $1edc44f88a20942d$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $1edc44f88a20942d$export$d38cd72104c1f0e9; }, function (v) { return $1edc44f88a20942d$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $1edc44f88a20942d$export$7d1e3a5e95ceca43; }, function (v) { return $1edc44f88a20942d$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $1edc44f88a20942d$export$257a8862b851cb5b; }, function (v) { return $1edc44f88a20942d$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $1edc44f88a20942d$export$a8257692ac88316c; }, function (v) { return $1edc44f88a20942d$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $1edc44f88a20942d$export$488013bae63b21da; }, function (v) { return $1edc44f88a20942d$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $1edc44f88a20942d$export$7c73462e0d25e514; }, function (v) { return $1edc44f88a20942d$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $1edc44f88a20942d$export$7568632d0d33d16d; }, function (v) { return $1edc44f88a20942d$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $1edc44f88a20942d$export$88948ce120ea2619; }, function (v) { return $1edc44f88a20942d$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $1edc44f88a20942d$export$35808ee640e87ca7; }, function (v) { return $1edc44f88a20942d$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $1edc44f88a20942d$export$fae74005e78b1a27; }, function (v) { return $1edc44f88a20942d$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $1edc44f88a20942d$export$dc8fbce3eb94dc1e; }, function (v) { return $1edc44f88a20942d$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $1edc44f88a20942d$export$6a7bc4e911dc01cf; }, function (v) { return $1edc44f88a20942d$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $1edc44f88a20942d$export$6d9c69b0de29b591; }, function (v) { return $1edc44f88a20942d$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $1edc44f88a20942d$export$f680877a34711e37; }, function (v) { return $1edc44f88a20942d$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $1edc44f88a20942d$export$d5a552a76deda3c2; }, function (v) { return $1edc44f88a20942d$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $1edc44f88a20942d$export$aaabe4eda9ed9969; }, function (v) { return $1edc44f88a20942d$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $1edc44f88a20942d$export$e5c5a5f917a5871c; }, function (v) { return $1edc44f88a20942d$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $1edc44f88a20942d$export$1538c33de8887b59; }, function (v) { return $1edc44f88a20942d$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $1edc44f88a20942d$export$13e3392192263954; }, function (v) { return $1edc44f88a20942d$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $1edc44f88a20942d$export$b8f5890fc79d6aca; }, function (v) { return $1edc44f88a20942d$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $1edc44f88a20942d$export$60241385465d0a34; }, function (v) { return $1edc44f88a20942d$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $1edc44f88a20942d$export$306c0aa65ff9ec16; }, function (v) { return $1edc44f88a20942d$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $1edc44f88a20942d$export$7b286972b8d8ccbf; }, function (v) { return $1edc44f88a20942d$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $1edc44f88a20942d$export$83d89fbfd8236492; }, function (v) { return $1edc44f88a20942d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1edc44f88a20942d$export$dca3b0875bd9a954;
var $1edc44f88a20942d$export$16fa2f45be04daa8;
var $1edc44f88a20942d$export$ffb0004e005737fa;
var $1edc44f88a20942d$export$e2c29f18771995cb;
var $1edc44f88a20942d$export$221d75b3f55bb0bd;
var $1edc44f88a20942d$export$5f8d39834fd61797;
var $1edc44f88a20942d$export$74bf444e3cd11ea5;
var $1edc44f88a20942d$export$ae55be85d98224ed;
var $1edc44f88a20942d$export$3ba232387fd5d6dd;
var $1edc44f88a20942d$export$e530037191fcd5d7;
var $1edc44f88a20942d$export$fd42f52fd3ae1109;
var $1edc44f88a20942d$export$c8a8987d4410bf2d;
var $1edc44f88a20942d$export$d38cd72104c1f0e9;
var $1edc44f88a20942d$export$7d1e3a5e95ceca43;
var $1edc44f88a20942d$export$257a8862b851cb5b;
var $1edc44f88a20942d$export$a8257692ac88316c;
var $1edc44f88a20942d$export$488013bae63b21da;
var $1edc44f88a20942d$export$7c73462e0d25e514;
var $1edc44f88a20942d$export$7568632d0d33d16d;
var $1edc44f88a20942d$export$88948ce120ea2619;
var $1edc44f88a20942d$export$35808ee640e87ca7;
var $1edc44f88a20942d$export$fae74005e78b1a27;
var $1edc44f88a20942d$export$dc8fbce3eb94dc1e;
var $1edc44f88a20942d$export$6a7bc4e911dc01cf;
var $1edc44f88a20942d$export$6d9c69b0de29b591;
var $1edc44f88a20942d$export$f680877a34711e37;
var $1edc44f88a20942d$export$d5a552a76deda3c2;
var $1edc44f88a20942d$export$aaabe4eda9ed9969;
var $1edc44f88a20942d$export$e5c5a5f917a5871c;
var $1edc44f88a20942d$export$1538c33de8887b59;
var $1edc44f88a20942d$export$13e3392192263954;
var $1edc44f88a20942d$export$b8f5890fc79d6aca;
var $1edc44f88a20942d$export$60241385465d0a34;
var $1edc44f88a20942d$export$306c0aa65ff9ec16;
var $1edc44f88a20942d$export$7b286972b8d8ccbf;
var $1edc44f88a20942d$export$83d89fbfd8236492;
'use strict';
var $1edc44f88a20942d$var$l = Symbol.for("react.element"), $1edc44f88a20942d$var$n = Symbol.for("react.portal"), $1edc44f88a20942d$var$p = Symbol.for("react.fragment"), $1edc44f88a20942d$var$q = Symbol.for("react.strict_mode"), $1edc44f88a20942d$var$r = Symbol.for("react.profiler"), $1edc44f88a20942d$var$t = Symbol.for("react.provider"), $1edc44f88a20942d$var$u = Symbol.for("react.context"), $1edc44f88a20942d$var$v = Symbol.for("react.forward_ref"), $1edc44f88a20942d$var$w = Symbol.for("react.suspense"), $1edc44f88a20942d$var$x = Symbol.for("react.memo"), $1edc44f88a20942d$var$y = Symbol.for("react.lazy"), $1edc44f88a20942d$var$z = Symbol.iterator;
function $1edc44f88a20942d$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1edc44f88a20942d$var$z && a[$1edc44f88a20942d$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1edc44f88a20942d$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1edc44f88a20942d$var$C = Object.assign, $1edc44f88a20942d$var$D = {};
function $1edc44f88a20942d$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1edc44f88a20942d$var$D;
    this.updater = e || $1edc44f88a20942d$var$B;
}
$1edc44f88a20942d$var$E.prototype.isReactComponent = {};
$1edc44f88a20942d$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1edc44f88a20942d$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1edc44f88a20942d$var$F() {}
$1edc44f88a20942d$var$F.prototype = $1edc44f88a20942d$var$E.prototype;
function $1edc44f88a20942d$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1edc44f88a20942d$var$D;
    this.updater = e || $1edc44f88a20942d$var$B;
}
var $1edc44f88a20942d$var$H = $1edc44f88a20942d$var$G.prototype = new $1edc44f88a20942d$var$F;
$1edc44f88a20942d$var$H.constructor = $1edc44f88a20942d$var$G;
$1edc44f88a20942d$var$C($1edc44f88a20942d$var$H, $1edc44f88a20942d$var$E.prototype);
$1edc44f88a20942d$var$H.isPureReactComponent = !0;
var $1edc44f88a20942d$var$I = Array.isArray, $1edc44f88a20942d$var$J = Object.prototype.hasOwnProperty, $1edc44f88a20942d$var$K = {
    current: null
}, $1edc44f88a20942d$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1edc44f88a20942d$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1edc44f88a20942d$var$J.call(b, d) && !$1edc44f88a20942d$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1edc44f88a20942d$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1edc44f88a20942d$var$K.current
    };
}
function $1edc44f88a20942d$var$N(a, b) {
    return {
        $$typeof: $1edc44f88a20942d$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1edc44f88a20942d$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1edc44f88a20942d$var$l;
}
function $1edc44f88a20942d$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1edc44f88a20942d$var$P = /\/+/g;
function $1edc44f88a20942d$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1edc44f88a20942d$var$escape("" + a.key) : b.toString(36);
}
function $1edc44f88a20942d$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1edc44f88a20942d$var$l:
                case $1edc44f88a20942d$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1edc44f88a20942d$var$Q(h, 0) : d, $1edc44f88a20942d$var$I(c) ? (e = "", null != a && (e = a.replace($1edc44f88a20942d$var$P, "$&/") + "/"), $1edc44f88a20942d$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1edc44f88a20942d$var$O(c) && (c = $1edc44f88a20942d$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1edc44f88a20942d$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1edc44f88a20942d$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1edc44f88a20942d$var$Q(k, g);
        h += $1edc44f88a20942d$var$R(k, b, e, f, c);
    }
    else if (f = $1edc44f88a20942d$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1edc44f88a20942d$var$Q(k, g++), h += $1edc44f88a20942d$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1edc44f88a20942d$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1edc44f88a20942d$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1edc44f88a20942d$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1edc44f88a20942d$var$U = {
    current: null
}, $1edc44f88a20942d$var$V = {
    transition: null
}, $1edc44f88a20942d$var$W = {
    ReactCurrentDispatcher: $1edc44f88a20942d$var$U,
    ReactCurrentBatchConfig: $1edc44f88a20942d$var$V,
    ReactCurrentOwner: $1edc44f88a20942d$var$K
};
function $1edc44f88a20942d$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1edc44f88a20942d$export$dca3b0875bd9a954 = {
    map: $1edc44f88a20942d$var$S,
    forEach: function(a, b, e) {
        $1edc44f88a20942d$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1edc44f88a20942d$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1edc44f88a20942d$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1edc44f88a20942d$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1edc44f88a20942d$export$16fa2f45be04daa8 = $1edc44f88a20942d$var$E;
$1edc44f88a20942d$export$ffb0004e005737fa = $1edc44f88a20942d$var$p;
$1edc44f88a20942d$export$e2c29f18771995cb = $1edc44f88a20942d$var$r;
$1edc44f88a20942d$export$221d75b3f55bb0bd = $1edc44f88a20942d$var$G;
$1edc44f88a20942d$export$5f8d39834fd61797 = $1edc44f88a20942d$var$q;
$1edc44f88a20942d$export$74bf444e3cd11ea5 = $1edc44f88a20942d$var$w;
$1edc44f88a20942d$export$ae55be85d98224ed = $1edc44f88a20942d$var$W;
$1edc44f88a20942d$export$3ba232387fd5d6dd = $1edc44f88a20942d$var$X;
$1edc44f88a20942d$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1edc44f88a20942d$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1edc44f88a20942d$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1edc44f88a20942d$var$J.call(b, f) && !$1edc44f88a20942d$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1edc44f88a20942d$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1edc44f88a20942d$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1edc44f88a20942d$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1edc44f88a20942d$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1edc44f88a20942d$export$c8a8987d4410bf2d = $1edc44f88a20942d$var$M;
$1edc44f88a20942d$export$d38cd72104c1f0e9 = function(a) {
    var b = $1edc44f88a20942d$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1edc44f88a20942d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1edc44f88a20942d$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1edc44f88a20942d$var$v,
        render: a
    };
};
$1edc44f88a20942d$export$a8257692ac88316c = $1edc44f88a20942d$var$O;
$1edc44f88a20942d$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1edc44f88a20942d$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1edc44f88a20942d$var$T
    };
};
$1edc44f88a20942d$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1edc44f88a20942d$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1edc44f88a20942d$export$7568632d0d33d16d = function(a) {
    var b = $1edc44f88a20942d$var$V.transition;
    $1edc44f88a20942d$var$V.transition = {};
    try {
        a();
    } finally{
        $1edc44f88a20942d$var$V.transition = b;
    }
};
$1edc44f88a20942d$export$88948ce120ea2619 = $1edc44f88a20942d$var$X;
$1edc44f88a20942d$export$35808ee640e87ca7 = function(a, b) {
    return $1edc44f88a20942d$var$U.current.useCallback(a, b);
};
$1edc44f88a20942d$export$fae74005e78b1a27 = function(a) {
    return $1edc44f88a20942d$var$U.current.useContext(a);
};
$1edc44f88a20942d$export$dc8fbce3eb94dc1e = function() {};
$1edc44f88a20942d$export$6a7bc4e911dc01cf = function(a) {
    return $1edc44f88a20942d$var$U.current.useDeferredValue(a);
};
$1edc44f88a20942d$export$6d9c69b0de29b591 = function(a, b) {
    return $1edc44f88a20942d$var$U.current.useEffect(a, b);
};
$1edc44f88a20942d$export$f680877a34711e37 = function() {
    return $1edc44f88a20942d$var$U.current.useId();
};
$1edc44f88a20942d$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1edc44f88a20942d$var$U.current.useImperativeHandle(a, b, e);
};
$1edc44f88a20942d$export$aaabe4eda9ed9969 = function(a, b) {
    return $1edc44f88a20942d$var$U.current.useInsertionEffect(a, b);
};
$1edc44f88a20942d$export$e5c5a5f917a5871c = function(a, b) {
    return $1edc44f88a20942d$var$U.current.useLayoutEffect(a, b);
};
$1edc44f88a20942d$export$1538c33de8887b59 = function(a, b) {
    return $1edc44f88a20942d$var$U.current.useMemo(a, b);
};
$1edc44f88a20942d$export$13e3392192263954 = function(a, b, e) {
    return $1edc44f88a20942d$var$U.current.useReducer(a, b, e);
};
$1edc44f88a20942d$export$b8f5890fc79d6aca = function(a) {
    return $1edc44f88a20942d$var$U.current.useRef(a);
};
$1edc44f88a20942d$export$60241385465d0a34 = function(a) {
    return $1edc44f88a20942d$var$U.current.useState(a);
};
$1edc44f88a20942d$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1edc44f88a20942d$var$U.current.useSyncExternalStore(a, b, e);
};
$1edc44f88a20942d$export$7b286972b8d8ccbf = function() {
    return $1edc44f88a20942d$var$U.current.useTransition();
};
$1edc44f88a20942d$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("1rKN8", function(module, exports) {
'use strict';
function $10dc9be42eb192ae$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($10dc9be42eb192ae$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$10dc9be42eb192ae$var$checkDCE();

module.exports = (parcelRequire("178bf"));

});
parcelRegister("178bf", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0cfcca548ca5090c$export$ae55be85d98224ed; }, function (v) { return $0cfcca548ca5090c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $0cfcca548ca5090c$export$d39a5bbd09211389; }, function (v) { return $0cfcca548ca5090c$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $0cfcca548ca5090c$export$882461b6382ed46c; }, function (v) { return $0cfcca548ca5090c$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $0cfcca548ca5090c$export$466bfc07425424d5; }, function (v) { return $0cfcca548ca5090c$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $0cfcca548ca5090c$export$cd75ccfd720a3cd4; }, function (v) { return $0cfcca548ca5090c$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $0cfcca548ca5090c$export$fa8d919ba61d84db; }, function (v) { return $0cfcca548ca5090c$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $0cfcca548ca5090c$export$757ceba2d55c277e; }, function (v) { return $0cfcca548ca5090c$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $0cfcca548ca5090c$export$b3890eb0ae9dca99; }, function (v) { return $0cfcca548ca5090c$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $0cfcca548ca5090c$export$502457920280e6be; }, function (v) { return $0cfcca548ca5090c$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $0cfcca548ca5090c$export$c78a37762a8d58e1; }, function (v) { return $0cfcca548ca5090c$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $0cfcca548ca5090c$export$dc54d992c10e8a18; }, function (v) { return $0cfcca548ca5090c$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $0cfcca548ca5090c$export$83d89fbfd8236492; }, function (v) { return $0cfcca548ca5090c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0cfcca548ca5090c$export$ae55be85d98224ed;
var $0cfcca548ca5090c$export$d39a5bbd09211389;
var $0cfcca548ca5090c$export$882461b6382ed46c;
var $0cfcca548ca5090c$export$466bfc07425424d5;
var $0cfcca548ca5090c$export$cd75ccfd720a3cd4;
var $0cfcca548ca5090c$export$fa8d919ba61d84db;
var $0cfcca548ca5090c$export$757ceba2d55c277e;
var $0cfcca548ca5090c$export$b3890eb0ae9dca99;
var $0cfcca548ca5090c$export$502457920280e6be;
var $0cfcca548ca5090c$export$c78a37762a8d58e1;
var $0cfcca548ca5090c$export$dc54d992c10e8a18;
var $0cfcca548ca5090c$export$83d89fbfd8236492;
'use strict';

var $3ZYaX = parcelRequire("3ZYaX");

var $gZs9N = parcelRequire("gZs9N");
function $0cfcca548ca5090c$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0cfcca548ca5090c$var$da = new Set, $0cfcca548ca5090c$var$ea = {};
function $0cfcca548ca5090c$var$fa(a, b) {
    $0cfcca548ca5090c$var$ha(a, b);
    $0cfcca548ca5090c$var$ha(a + "Capture", b);
}
function $0cfcca548ca5090c$var$ha(a, b) {
    $0cfcca548ca5090c$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0cfcca548ca5090c$var$da.add(b[a]);
}
var $0cfcca548ca5090c$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0cfcca548ca5090c$var$ja = Object.prototype.hasOwnProperty, $0cfcca548ca5090c$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0cfcca548ca5090c$var$la = {}, $0cfcca548ca5090c$var$ma = {};
function $0cfcca548ca5090c$var$oa(a) {
    if ($0cfcca548ca5090c$var$ja.call($0cfcca548ca5090c$var$ma, a)) return !0;
    if ($0cfcca548ca5090c$var$ja.call($0cfcca548ca5090c$var$la, a)) return !1;
    if ($0cfcca548ca5090c$var$ka.test(a)) return $0cfcca548ca5090c$var$ma[a] = !0;
    $0cfcca548ca5090c$var$la[a] = !0;
    return !1;
}
function $0cfcca548ca5090c$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0cfcca548ca5090c$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0cfcca548ca5090c$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0cfcca548ca5090c$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0cfcca548ca5090c$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0cfcca548ca5090c$var$z[b] = new $0cfcca548ca5090c$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0cfcca548ca5090c$var$ra = /[\-:]([a-z])/g;
function $0cfcca548ca5090c$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0cfcca548ca5090c$var$ra, $0cfcca548ca5090c$var$sa);
    $0cfcca548ca5090c$var$z[b] = new $0cfcca548ca5090c$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0cfcca548ca5090c$var$ra, $0cfcca548ca5090c$var$sa);
    $0cfcca548ca5090c$var$z[b] = new $0cfcca548ca5090c$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0cfcca548ca5090c$var$ra, $0cfcca548ca5090c$var$sa);
    $0cfcca548ca5090c$var$z[b] = new $0cfcca548ca5090c$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0cfcca548ca5090c$var$z.xlinkHref = new $0cfcca548ca5090c$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0cfcca548ca5090c$var$z[a] = new $0cfcca548ca5090c$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0cfcca548ca5090c$var$ta(a, b, c, d) {
    var e = $0cfcca548ca5090c$var$z.hasOwnProperty(b) ? $0cfcca548ca5090c$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0cfcca548ca5090c$var$qa(b, c, e, d) && (c = null), d || null === e ? $0cfcca548ca5090c$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0cfcca548ca5090c$var$ua = $3ZYaX.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0cfcca548ca5090c$var$va = Symbol.for("react.element"), $0cfcca548ca5090c$var$wa = Symbol.for("react.portal"), $0cfcca548ca5090c$var$ya = Symbol.for("react.fragment"), $0cfcca548ca5090c$var$za = Symbol.for("react.strict_mode"), $0cfcca548ca5090c$var$Aa = Symbol.for("react.profiler"), $0cfcca548ca5090c$var$Ba = Symbol.for("react.provider"), $0cfcca548ca5090c$var$Ca = Symbol.for("react.context"), $0cfcca548ca5090c$var$Da = Symbol.for("react.forward_ref"), $0cfcca548ca5090c$var$Ea = Symbol.for("react.suspense"), $0cfcca548ca5090c$var$Fa = Symbol.for("react.suspense_list"), $0cfcca548ca5090c$var$Ga = Symbol.for("react.memo"), $0cfcca548ca5090c$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0cfcca548ca5090c$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0cfcca548ca5090c$var$Ja = Symbol.iterator;
function $0cfcca548ca5090c$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0cfcca548ca5090c$var$Ja && a[$0cfcca548ca5090c$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0cfcca548ca5090c$var$A = Object.assign, $0cfcca548ca5090c$var$La;
function $0cfcca548ca5090c$var$Ma(a) {
    if (void 0 === $0cfcca548ca5090c$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0cfcca548ca5090c$var$La = b && b[1] || "";
    }
    return "\n" + $0cfcca548ca5090c$var$La + a;
}
var $0cfcca548ca5090c$var$Na = !1;
function $0cfcca548ca5090c$var$Oa(a, b) {
    if (!a || $0cfcca548ca5090c$var$Na) return "";
    $0cfcca548ca5090c$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0cfcca548ca5090c$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0cfcca548ca5090c$var$Ma(a) : "";
}
function $0cfcca548ca5090c$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0cfcca548ca5090c$var$Ma(a.type);
        case 16:
            return $0cfcca548ca5090c$var$Ma("Lazy");
        case 13:
            return $0cfcca548ca5090c$var$Ma("Suspense");
        case 19:
            return $0cfcca548ca5090c$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0cfcca548ca5090c$var$Oa(a.type, !1), a;
        case 11:
            return a = $0cfcca548ca5090c$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0cfcca548ca5090c$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0cfcca548ca5090c$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0cfcca548ca5090c$var$ya:
            return "Fragment";
        case $0cfcca548ca5090c$var$wa:
            return "Portal";
        case $0cfcca548ca5090c$var$Aa:
            return "Profiler";
        case $0cfcca548ca5090c$var$za:
            return "StrictMode";
        case $0cfcca548ca5090c$var$Ea:
            return "Suspense";
        case $0cfcca548ca5090c$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0cfcca548ca5090c$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0cfcca548ca5090c$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0cfcca548ca5090c$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0cfcca548ca5090c$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0cfcca548ca5090c$var$Qa(a.type) || "Memo";
        case $0cfcca548ca5090c$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0cfcca548ca5090c$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0cfcca548ca5090c$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0cfcca548ca5090c$var$Qa(b);
        case 8:
            return b === $0cfcca548ca5090c$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0cfcca548ca5090c$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0cfcca548ca5090c$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0cfcca548ca5090c$var$Ua(a) {
    var b = $0cfcca548ca5090c$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0cfcca548ca5090c$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0cfcca548ca5090c$var$Ua(a));
}
function $0cfcca548ca5090c$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0cfcca548ca5090c$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0cfcca548ca5090c$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0cfcca548ca5090c$var$Ya(a, b) {
    var c = b.checked;
    return $0cfcca548ca5090c$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0cfcca548ca5090c$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0cfcca548ca5090c$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0cfcca548ca5090c$var$ab(a, b) {
    b = b.checked;
    null != b && $0cfcca548ca5090c$var$ta(a, "checked", b, !1);
}
function $0cfcca548ca5090c$var$bb(a, b) {
    $0cfcca548ca5090c$var$ab(a, b);
    var c = $0cfcca548ca5090c$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0cfcca548ca5090c$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0cfcca548ca5090c$var$cb(a, b.type, $0cfcca548ca5090c$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0cfcca548ca5090c$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0cfcca548ca5090c$var$cb(a, b, c) {
    if ("number" !== b || $0cfcca548ca5090c$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0cfcca548ca5090c$var$eb = Array.isArray;
function $0cfcca548ca5090c$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0cfcca548ca5090c$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0cfcca548ca5090c$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0cfcca548ca5090c$var$p(91));
    return $0cfcca548ca5090c$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0cfcca548ca5090c$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0cfcca548ca5090c$var$p(92));
            if ($0cfcca548ca5090c$var$eb(c)) {
                if (1 < c.length) throw Error($0cfcca548ca5090c$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0cfcca548ca5090c$var$Sa(c)
    };
}
function $0cfcca548ca5090c$var$ib(a, b) {
    var c = $0cfcca548ca5090c$var$Sa(b.value), d = $0cfcca548ca5090c$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0cfcca548ca5090c$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0cfcca548ca5090c$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0cfcca548ca5090c$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0cfcca548ca5090c$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0cfcca548ca5090c$var$mb, $0cfcca548ca5090c$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0cfcca548ca5090c$var$mb = $0cfcca548ca5090c$var$mb || document.createElement("div");
        $0cfcca548ca5090c$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0cfcca548ca5090c$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0cfcca548ca5090c$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0cfcca548ca5090c$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0cfcca548ca5090c$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0cfcca548ca5090c$var$pb).forEach(function(a) {
    $0cfcca548ca5090c$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0cfcca548ca5090c$var$pb[b] = $0cfcca548ca5090c$var$pb[a];
    });
});
function $0cfcca548ca5090c$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0cfcca548ca5090c$var$pb.hasOwnProperty(a) && $0cfcca548ca5090c$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0cfcca548ca5090c$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0cfcca548ca5090c$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0cfcca548ca5090c$var$tb = $0cfcca548ca5090c$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0cfcca548ca5090c$var$ub(a, b) {
    if (b) {
        if ($0cfcca548ca5090c$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0cfcca548ca5090c$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0cfcca548ca5090c$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0cfcca548ca5090c$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0cfcca548ca5090c$var$p(62));
    }
}
function $0cfcca548ca5090c$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0cfcca548ca5090c$var$wb = null;
function $0cfcca548ca5090c$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0cfcca548ca5090c$var$yb = null, $0cfcca548ca5090c$var$zb = null, $0cfcca548ca5090c$var$Ab = null;
function $0cfcca548ca5090c$var$Bb(a) {
    if (a = $0cfcca548ca5090c$var$Cb(a)) {
        if ("function" !== typeof $0cfcca548ca5090c$var$yb) throw Error($0cfcca548ca5090c$var$p(280));
        var b = a.stateNode;
        b && (b = $0cfcca548ca5090c$var$Db(b), $0cfcca548ca5090c$var$yb(a.stateNode, a.type, b));
    }
}
function $0cfcca548ca5090c$var$Eb(a) {
    $0cfcca548ca5090c$var$zb ? $0cfcca548ca5090c$var$Ab ? $0cfcca548ca5090c$var$Ab.push(a) : $0cfcca548ca5090c$var$Ab = [
        a
    ] : $0cfcca548ca5090c$var$zb = a;
}
function $0cfcca548ca5090c$var$Fb() {
    if ($0cfcca548ca5090c$var$zb) {
        var a = $0cfcca548ca5090c$var$zb, b = $0cfcca548ca5090c$var$Ab;
        $0cfcca548ca5090c$var$Ab = $0cfcca548ca5090c$var$zb = null;
        $0cfcca548ca5090c$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0cfcca548ca5090c$var$Bb(b[a]);
    }
}
function $0cfcca548ca5090c$var$Gb(a, b) {
    return a(b);
}
function $0cfcca548ca5090c$var$Hb() {}
var $0cfcca548ca5090c$var$Ib = !1;
function $0cfcca548ca5090c$var$Jb(a, b, c) {
    if ($0cfcca548ca5090c$var$Ib) return a(b, c);
    $0cfcca548ca5090c$var$Ib = !0;
    try {
        return $0cfcca548ca5090c$var$Gb(a, b, c);
    } finally{
        if ($0cfcca548ca5090c$var$Ib = !1, null !== $0cfcca548ca5090c$var$zb || null !== $0cfcca548ca5090c$var$Ab) $0cfcca548ca5090c$var$Hb(), $0cfcca548ca5090c$var$Fb();
    }
}
function $0cfcca548ca5090c$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0cfcca548ca5090c$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0cfcca548ca5090c$var$p(231, b, typeof c));
    return c;
}
var $0cfcca548ca5090c$var$Lb = !1;
if ($0cfcca548ca5090c$var$ia) try {
    var $0cfcca548ca5090c$var$Mb = {};
    Object.defineProperty($0cfcca548ca5090c$var$Mb, "passive", {
        get: function() {
            $0cfcca548ca5090c$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0cfcca548ca5090c$var$Mb, $0cfcca548ca5090c$var$Mb);
    window.removeEventListener("test", $0cfcca548ca5090c$var$Mb, $0cfcca548ca5090c$var$Mb);
} catch (a) {
    $0cfcca548ca5090c$var$Lb = !1;
}
function $0cfcca548ca5090c$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0cfcca548ca5090c$var$Ob = !1, $0cfcca548ca5090c$var$Pb = null, $0cfcca548ca5090c$var$Qb = !1, $0cfcca548ca5090c$var$Rb = null, $0cfcca548ca5090c$var$Sb = {
    onError: function(a) {
        $0cfcca548ca5090c$var$Ob = !0;
        $0cfcca548ca5090c$var$Pb = a;
    }
};
function $0cfcca548ca5090c$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0cfcca548ca5090c$var$Ob = !1;
    $0cfcca548ca5090c$var$Pb = null;
    $0cfcca548ca5090c$var$Nb.apply($0cfcca548ca5090c$var$Sb, arguments);
}
function $0cfcca548ca5090c$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0cfcca548ca5090c$var$Tb.apply(this, arguments);
    if ($0cfcca548ca5090c$var$Ob) {
        if ($0cfcca548ca5090c$var$Ob) {
            var l = $0cfcca548ca5090c$var$Pb;
            $0cfcca548ca5090c$var$Ob = !1;
            $0cfcca548ca5090c$var$Pb = null;
        } else throw Error($0cfcca548ca5090c$var$p(198));
        $0cfcca548ca5090c$var$Qb || ($0cfcca548ca5090c$var$Qb = !0, $0cfcca548ca5090c$var$Rb = l);
    }
}
function $0cfcca548ca5090c$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0cfcca548ca5090c$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0cfcca548ca5090c$var$Xb(a) {
    if ($0cfcca548ca5090c$var$Vb(a) !== a) throw Error($0cfcca548ca5090c$var$p(188));
}
function $0cfcca548ca5090c$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0cfcca548ca5090c$var$Vb(a);
        if (null === b) throw Error($0cfcca548ca5090c$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0cfcca548ca5090c$var$Xb(e), a;
                if (f === d) return $0cfcca548ca5090c$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0cfcca548ca5090c$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0cfcca548ca5090c$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0cfcca548ca5090c$var$p(190));
    }
    if (3 !== c.tag) throw Error($0cfcca548ca5090c$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0cfcca548ca5090c$var$Zb(a) {
    a = $0cfcca548ca5090c$var$Yb(a);
    return null !== a ? $0cfcca548ca5090c$var$$b(a) : null;
}
function $0cfcca548ca5090c$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0cfcca548ca5090c$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0cfcca548ca5090c$var$ac = $gZs9N.unstable_scheduleCallback, $0cfcca548ca5090c$var$bc = $gZs9N.unstable_cancelCallback, $0cfcca548ca5090c$var$cc = $gZs9N.unstable_shouldYield, $0cfcca548ca5090c$var$dc = $gZs9N.unstable_requestPaint, $0cfcca548ca5090c$var$B = $gZs9N.unstable_now, $0cfcca548ca5090c$var$ec = $gZs9N.unstable_getCurrentPriorityLevel, $0cfcca548ca5090c$var$fc = $gZs9N.unstable_ImmediatePriority, $0cfcca548ca5090c$var$gc = $gZs9N.unstable_UserBlockingPriority, $0cfcca548ca5090c$var$hc = $gZs9N.unstable_NormalPriority, $0cfcca548ca5090c$var$ic = $gZs9N.unstable_LowPriority, $0cfcca548ca5090c$var$jc = $gZs9N.unstable_IdlePriority, $0cfcca548ca5090c$var$kc = null, $0cfcca548ca5090c$var$lc = null;
function $0cfcca548ca5090c$var$mc(a) {
    if ($0cfcca548ca5090c$var$lc && "function" === typeof $0cfcca548ca5090c$var$lc.onCommitFiberRoot) try {
        $0cfcca548ca5090c$var$lc.onCommitFiberRoot($0cfcca548ca5090c$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0cfcca548ca5090c$var$oc = Math.clz32 ? Math.clz32 : $0cfcca548ca5090c$var$nc, $0cfcca548ca5090c$var$pc = Math.log, $0cfcca548ca5090c$var$qc = Math.LN2;
function $0cfcca548ca5090c$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0cfcca548ca5090c$var$pc(a) / $0cfcca548ca5090c$var$qc | 0) | 0;
}
var $0cfcca548ca5090c$var$rc = 64, $0cfcca548ca5090c$var$sc = 4194304;
function $0cfcca548ca5090c$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0cfcca548ca5090c$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0cfcca548ca5090c$var$tc(h) : (f &= g, 0 !== f && (d = $0cfcca548ca5090c$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0cfcca548ca5090c$var$tc(g) : 0 !== f && (d = $0cfcca548ca5090c$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0cfcca548ca5090c$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0cfcca548ca5090c$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0cfcca548ca5090c$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0cfcca548ca5090c$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0cfcca548ca5090c$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0cfcca548ca5090c$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0cfcca548ca5090c$var$yc() {
    var a = $0cfcca548ca5090c$var$rc;
    $0cfcca548ca5090c$var$rc <<= 1;
    0 === ($0cfcca548ca5090c$var$rc & 4194240) && ($0cfcca548ca5090c$var$rc = 64);
    return a;
}
function $0cfcca548ca5090c$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0cfcca548ca5090c$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0cfcca548ca5090c$var$oc(b);
    a[b] = c;
}
function $0cfcca548ca5090c$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0cfcca548ca5090c$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0cfcca548ca5090c$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0cfcca548ca5090c$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0cfcca548ca5090c$var$C = 0;
function $0cfcca548ca5090c$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0cfcca548ca5090c$var$Ec, $0cfcca548ca5090c$var$Fc, $0cfcca548ca5090c$var$Gc, $0cfcca548ca5090c$var$Hc, $0cfcca548ca5090c$var$Ic, $0cfcca548ca5090c$var$Jc = !1, $0cfcca548ca5090c$var$Kc = [], $0cfcca548ca5090c$var$Lc = null, $0cfcca548ca5090c$var$Mc = null, $0cfcca548ca5090c$var$Nc = null, $0cfcca548ca5090c$var$Oc = new Map, $0cfcca548ca5090c$var$Pc = new Map, $0cfcca548ca5090c$var$Qc = [], $0cfcca548ca5090c$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0cfcca548ca5090c$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0cfcca548ca5090c$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0cfcca548ca5090c$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0cfcca548ca5090c$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0cfcca548ca5090c$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0cfcca548ca5090c$var$Pc.delete(b.pointerId);
    }
}
function $0cfcca548ca5090c$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0cfcca548ca5090c$var$Cb(b), null !== b && $0cfcca548ca5090c$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0cfcca548ca5090c$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0cfcca548ca5090c$var$Lc = $0cfcca548ca5090c$var$Tc($0cfcca548ca5090c$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0cfcca548ca5090c$var$Mc = $0cfcca548ca5090c$var$Tc($0cfcca548ca5090c$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0cfcca548ca5090c$var$Nc = $0cfcca548ca5090c$var$Tc($0cfcca548ca5090c$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0cfcca548ca5090c$var$Oc.set(f, $0cfcca548ca5090c$var$Tc($0cfcca548ca5090c$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0cfcca548ca5090c$var$Pc.set(f, $0cfcca548ca5090c$var$Tc($0cfcca548ca5090c$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0cfcca548ca5090c$var$Vc(a) {
    var b = $0cfcca548ca5090c$var$Wc(a.target);
    if (null !== b) {
        var c = $0cfcca548ca5090c$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0cfcca548ca5090c$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0cfcca548ca5090c$var$Ic(a.priority, function() {
                        $0cfcca548ca5090c$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0cfcca548ca5090c$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0cfcca548ca5090c$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0cfcca548ca5090c$var$wb = d;
            c.target.dispatchEvent(d);
            $0cfcca548ca5090c$var$wb = null;
        } else return b = $0cfcca548ca5090c$var$Cb(c), null !== b && $0cfcca548ca5090c$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0cfcca548ca5090c$var$Zc(a, b, c) {
    $0cfcca548ca5090c$var$Xc(a) && c.delete(b);
}
function $0cfcca548ca5090c$var$$c() {
    $0cfcca548ca5090c$var$Jc = !1;
    null !== $0cfcca548ca5090c$var$Lc && $0cfcca548ca5090c$var$Xc($0cfcca548ca5090c$var$Lc) && ($0cfcca548ca5090c$var$Lc = null);
    null !== $0cfcca548ca5090c$var$Mc && $0cfcca548ca5090c$var$Xc($0cfcca548ca5090c$var$Mc) && ($0cfcca548ca5090c$var$Mc = null);
    null !== $0cfcca548ca5090c$var$Nc && $0cfcca548ca5090c$var$Xc($0cfcca548ca5090c$var$Nc) && ($0cfcca548ca5090c$var$Nc = null);
    $0cfcca548ca5090c$var$Oc.forEach($0cfcca548ca5090c$var$Zc);
    $0cfcca548ca5090c$var$Pc.forEach($0cfcca548ca5090c$var$Zc);
}
function $0cfcca548ca5090c$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0cfcca548ca5090c$var$Jc || ($0cfcca548ca5090c$var$Jc = !0, $gZs9N.unstable_scheduleCallback($gZs9N.unstable_NormalPriority, $0cfcca548ca5090c$var$$c)));
}
function $0cfcca548ca5090c$var$bd(a) {
    function b(b) {
        return $0cfcca548ca5090c$var$ad(b, a);
    }
    if (0 < $0cfcca548ca5090c$var$Kc.length) {
        $0cfcca548ca5090c$var$ad($0cfcca548ca5090c$var$Kc[0], a);
        for(var c = 1; c < $0cfcca548ca5090c$var$Kc.length; c++){
            var d = $0cfcca548ca5090c$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0cfcca548ca5090c$var$Lc && $0cfcca548ca5090c$var$ad($0cfcca548ca5090c$var$Lc, a);
    null !== $0cfcca548ca5090c$var$Mc && $0cfcca548ca5090c$var$ad($0cfcca548ca5090c$var$Mc, a);
    null !== $0cfcca548ca5090c$var$Nc && $0cfcca548ca5090c$var$ad($0cfcca548ca5090c$var$Nc, a);
    $0cfcca548ca5090c$var$Oc.forEach(b);
    $0cfcca548ca5090c$var$Pc.forEach(b);
    for(c = 0; c < $0cfcca548ca5090c$var$Qc.length; c++)d = $0cfcca548ca5090c$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0cfcca548ca5090c$var$Qc.length && (c = $0cfcca548ca5090c$var$Qc[0], null === c.blockedOn);)$0cfcca548ca5090c$var$Vc(c), null === c.blockedOn && $0cfcca548ca5090c$var$Qc.shift();
}
var $0cfcca548ca5090c$var$cd = $0cfcca548ca5090c$var$ua.ReactCurrentBatchConfig, $0cfcca548ca5090c$var$dd = !0;
function $0cfcca548ca5090c$var$ed(a, b, c, d) {
    var e = $0cfcca548ca5090c$var$C, f = $0cfcca548ca5090c$var$cd.transition;
    $0cfcca548ca5090c$var$cd.transition = null;
    try {
        $0cfcca548ca5090c$var$C = 1, $0cfcca548ca5090c$var$fd(a, b, c, d);
    } finally{
        $0cfcca548ca5090c$var$C = e, $0cfcca548ca5090c$var$cd.transition = f;
    }
}
function $0cfcca548ca5090c$var$gd(a, b, c, d) {
    var e = $0cfcca548ca5090c$var$C, f = $0cfcca548ca5090c$var$cd.transition;
    $0cfcca548ca5090c$var$cd.transition = null;
    try {
        $0cfcca548ca5090c$var$C = 4, $0cfcca548ca5090c$var$fd(a, b, c, d);
    } finally{
        $0cfcca548ca5090c$var$C = e, $0cfcca548ca5090c$var$cd.transition = f;
    }
}
function $0cfcca548ca5090c$var$fd(a, b, c, d) {
    if ($0cfcca548ca5090c$var$dd) {
        var e = $0cfcca548ca5090c$var$Yc(a, b, c, d);
        if (null === e) $0cfcca548ca5090c$var$hd(a, b, d, $0cfcca548ca5090c$var$id, c), $0cfcca548ca5090c$var$Sc(a, d);
        else if ($0cfcca548ca5090c$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0cfcca548ca5090c$var$Sc(a, d), b & 4 && -1 < $0cfcca548ca5090c$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0cfcca548ca5090c$var$Cb(e);
                null !== f && $0cfcca548ca5090c$var$Ec(f);
                f = $0cfcca548ca5090c$var$Yc(a, b, c, d);
                null === f && $0cfcca548ca5090c$var$hd(a, b, d, $0cfcca548ca5090c$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0cfcca548ca5090c$var$hd(a, b, d, null, c);
    }
}
var $0cfcca548ca5090c$var$id = null;
function $0cfcca548ca5090c$var$Yc(a, b, c, d) {
    $0cfcca548ca5090c$var$id = null;
    a = $0cfcca548ca5090c$var$xb(d);
    a = $0cfcca548ca5090c$var$Wc(a);
    if (null !== a) {
        if (b = $0cfcca548ca5090c$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0cfcca548ca5090c$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0cfcca548ca5090c$var$id = a;
    return null;
}
function $0cfcca548ca5090c$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0cfcca548ca5090c$var$ec()){
                case $0cfcca548ca5090c$var$fc:
                    return 1;
                case $0cfcca548ca5090c$var$gc:
                    return 4;
                case $0cfcca548ca5090c$var$hc:
                case $0cfcca548ca5090c$var$ic:
                    return 16;
                case $0cfcca548ca5090c$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0cfcca548ca5090c$var$kd = null, $0cfcca548ca5090c$var$ld = null, $0cfcca548ca5090c$var$md = null;
function $0cfcca548ca5090c$var$nd() {
    if ($0cfcca548ca5090c$var$md) return $0cfcca548ca5090c$var$md;
    var a, b = $0cfcca548ca5090c$var$ld, c = b.length, d, e = "value" in $0cfcca548ca5090c$var$kd ? $0cfcca548ca5090c$var$kd.value : $0cfcca548ca5090c$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0cfcca548ca5090c$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0cfcca548ca5090c$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0cfcca548ca5090c$var$pd() {
    return !0;
}
function $0cfcca548ca5090c$var$qd() {
    return !1;
}
function $0cfcca548ca5090c$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0cfcca548ca5090c$var$pd : $0cfcca548ca5090c$var$qd;
        this.isPropagationStopped = $0cfcca548ca5090c$var$qd;
        return this;
    }
    $0cfcca548ca5090c$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0cfcca548ca5090c$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0cfcca548ca5090c$var$pd);
        },
        persist: function() {},
        isPersistent: $0cfcca548ca5090c$var$pd
    });
    return b;
}
var $0cfcca548ca5090c$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0cfcca548ca5090c$var$td = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$sd), $0cfcca548ca5090c$var$ud = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$sd, {
    view: 0,
    detail: 0
}), $0cfcca548ca5090c$var$vd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$ud), $0cfcca548ca5090c$var$wd, $0cfcca548ca5090c$var$xd, $0cfcca548ca5090c$var$yd, $0cfcca548ca5090c$var$Ad = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0cfcca548ca5090c$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0cfcca548ca5090c$var$yd && ($0cfcca548ca5090c$var$yd && "mousemove" === a.type ? ($0cfcca548ca5090c$var$wd = a.screenX - $0cfcca548ca5090c$var$yd.screenX, $0cfcca548ca5090c$var$xd = a.screenY - $0cfcca548ca5090c$var$yd.screenY) : $0cfcca548ca5090c$var$xd = $0cfcca548ca5090c$var$wd = 0, $0cfcca548ca5090c$var$yd = a);
        return $0cfcca548ca5090c$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0cfcca548ca5090c$var$xd;
    }
}), $0cfcca548ca5090c$var$Bd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Ad), $0cfcca548ca5090c$var$Cd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$Ad, {
    dataTransfer: 0
}), $0cfcca548ca5090c$var$Dd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Cd), $0cfcca548ca5090c$var$Ed = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$ud, {
    relatedTarget: 0
}), $0cfcca548ca5090c$var$Fd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Ed), $0cfcca548ca5090c$var$Gd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0cfcca548ca5090c$var$Hd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Gd), $0cfcca548ca5090c$var$Id = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0cfcca548ca5090c$var$Jd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Id), $0cfcca548ca5090c$var$Kd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$sd, {
    data: 0
}), $0cfcca548ca5090c$var$Ld = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Kd), $0cfcca548ca5090c$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0cfcca548ca5090c$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0cfcca548ca5090c$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0cfcca548ca5090c$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0cfcca548ca5090c$var$Od[a]) ? !!b[a] : !1;
}
function $0cfcca548ca5090c$var$zd() {
    return $0cfcca548ca5090c$var$Pd;
}
var $0cfcca548ca5090c$var$Qd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0cfcca548ca5090c$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0cfcca548ca5090c$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0cfcca548ca5090c$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0cfcca548ca5090c$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0cfcca548ca5090c$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0cfcca548ca5090c$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0cfcca548ca5090c$var$Rd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Qd), $0cfcca548ca5090c$var$Sd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0cfcca548ca5090c$var$Td = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Sd), $0cfcca548ca5090c$var$Ud = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0cfcca548ca5090c$var$zd
}), $0cfcca548ca5090c$var$Vd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Ud), $0cfcca548ca5090c$var$Wd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0cfcca548ca5090c$var$Xd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Wd), $0cfcca548ca5090c$var$Yd = $0cfcca548ca5090c$var$A({}, $0cfcca548ca5090c$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0cfcca548ca5090c$var$Zd = $0cfcca548ca5090c$var$rd($0cfcca548ca5090c$var$Yd), $0cfcca548ca5090c$var$$d = [
    9,
    13,
    27,
    32
], $0cfcca548ca5090c$var$ae = $0cfcca548ca5090c$var$ia && "CompositionEvent" in window, $0cfcca548ca5090c$var$be = null;
$0cfcca548ca5090c$var$ia && "documentMode" in document && ($0cfcca548ca5090c$var$be = document.documentMode);
var $0cfcca548ca5090c$var$ce = $0cfcca548ca5090c$var$ia && "TextEvent" in window && !$0cfcca548ca5090c$var$be, $0cfcca548ca5090c$var$de = $0cfcca548ca5090c$var$ia && (!$0cfcca548ca5090c$var$ae || $0cfcca548ca5090c$var$be && 8 < $0cfcca548ca5090c$var$be && 11 >= $0cfcca548ca5090c$var$be), $0cfcca548ca5090c$var$ee = String.fromCharCode(32), $0cfcca548ca5090c$var$fe = !1;
function $0cfcca548ca5090c$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0cfcca548ca5090c$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0cfcca548ca5090c$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0cfcca548ca5090c$var$ie = !1;
function $0cfcca548ca5090c$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0cfcca548ca5090c$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0cfcca548ca5090c$var$fe = !0;
            return $0cfcca548ca5090c$var$ee;
        case "textInput":
            return a = b.data, a === $0cfcca548ca5090c$var$ee && $0cfcca548ca5090c$var$fe ? null : a;
        default:
            return null;
    }
}
function $0cfcca548ca5090c$var$ke(a, b) {
    if ($0cfcca548ca5090c$var$ie) return "compositionend" === a || !$0cfcca548ca5090c$var$ae && $0cfcca548ca5090c$var$ge(a, b) ? (a = $0cfcca548ca5090c$var$nd(), $0cfcca548ca5090c$var$md = $0cfcca548ca5090c$var$ld = $0cfcca548ca5090c$var$kd = null, $0cfcca548ca5090c$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0cfcca548ca5090c$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0cfcca548ca5090c$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0cfcca548ca5090c$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0cfcca548ca5090c$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0cfcca548ca5090c$var$ne(a, b, c, d) {
    $0cfcca548ca5090c$var$Eb(d);
    b = $0cfcca548ca5090c$var$oe(b, "onChange");
    0 < b.length && (c = new $0cfcca548ca5090c$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0cfcca548ca5090c$var$pe = null, $0cfcca548ca5090c$var$qe = null;
function $0cfcca548ca5090c$var$re(a) {
    $0cfcca548ca5090c$var$se(a, 0);
}
function $0cfcca548ca5090c$var$te(a) {
    var b = $0cfcca548ca5090c$var$ue(a);
    if ($0cfcca548ca5090c$var$Wa(b)) return a;
}
function $0cfcca548ca5090c$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0cfcca548ca5090c$var$we = !1;
if ($0cfcca548ca5090c$var$ia) {
    var $0cfcca548ca5090c$var$xe;
    if ($0cfcca548ca5090c$var$ia) {
        var $0cfcca548ca5090c$var$ye = "oninput" in document;
        if (!$0cfcca548ca5090c$var$ye) {
            var $0cfcca548ca5090c$var$ze = document.createElement("div");
            $0cfcca548ca5090c$var$ze.setAttribute("oninput", "return;");
            $0cfcca548ca5090c$var$ye = "function" === typeof $0cfcca548ca5090c$var$ze.oninput;
        }
        $0cfcca548ca5090c$var$xe = $0cfcca548ca5090c$var$ye;
    } else $0cfcca548ca5090c$var$xe = !1;
    $0cfcca548ca5090c$var$we = $0cfcca548ca5090c$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0cfcca548ca5090c$var$Ae() {
    $0cfcca548ca5090c$var$pe && ($0cfcca548ca5090c$var$pe.detachEvent("onpropertychange", $0cfcca548ca5090c$var$Be), $0cfcca548ca5090c$var$qe = $0cfcca548ca5090c$var$pe = null);
}
function $0cfcca548ca5090c$var$Be(a) {
    if ("value" === a.propertyName && $0cfcca548ca5090c$var$te($0cfcca548ca5090c$var$qe)) {
        var b = [];
        $0cfcca548ca5090c$var$ne(b, $0cfcca548ca5090c$var$qe, a, $0cfcca548ca5090c$var$xb(a));
        $0cfcca548ca5090c$var$Jb($0cfcca548ca5090c$var$re, b);
    }
}
function $0cfcca548ca5090c$var$Ce(a, b, c) {
    "focusin" === a ? ($0cfcca548ca5090c$var$Ae(), $0cfcca548ca5090c$var$pe = b, $0cfcca548ca5090c$var$qe = c, $0cfcca548ca5090c$var$pe.attachEvent("onpropertychange", $0cfcca548ca5090c$var$Be)) : "focusout" === a && $0cfcca548ca5090c$var$Ae();
}
function $0cfcca548ca5090c$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0cfcca548ca5090c$var$te($0cfcca548ca5090c$var$qe);
}
function $0cfcca548ca5090c$var$Ee(a, b) {
    if ("click" === a) return $0cfcca548ca5090c$var$te(b);
}
function $0cfcca548ca5090c$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0cfcca548ca5090c$var$te(b);
}
function $0cfcca548ca5090c$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0cfcca548ca5090c$var$He = "function" === typeof Object.is ? Object.is : $0cfcca548ca5090c$var$Ge;
function $0cfcca548ca5090c$var$Ie(a, b) {
    if ($0cfcca548ca5090c$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0cfcca548ca5090c$var$ja.call(b, e) || !$0cfcca548ca5090c$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0cfcca548ca5090c$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0cfcca548ca5090c$var$Ke(a, b) {
    var c = $0cfcca548ca5090c$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0cfcca548ca5090c$var$Je(c);
    }
}
function $0cfcca548ca5090c$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0cfcca548ca5090c$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0cfcca548ca5090c$var$Me() {
    for(var a = window, b = $0cfcca548ca5090c$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0cfcca548ca5090c$var$Xa(a.document);
    }
    return b;
}
function $0cfcca548ca5090c$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0cfcca548ca5090c$var$Oe(a) {
    var b = $0cfcca548ca5090c$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0cfcca548ca5090c$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0cfcca548ca5090c$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0cfcca548ca5090c$var$Ke(c, f);
                var g = $0cfcca548ca5090c$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0cfcca548ca5090c$var$Pe = $0cfcca548ca5090c$var$ia && "documentMode" in document && 11 >= document.documentMode, $0cfcca548ca5090c$var$Qe = null, $0cfcca548ca5090c$var$Re = null, $0cfcca548ca5090c$var$Se = null, $0cfcca548ca5090c$var$Te = !1;
function $0cfcca548ca5090c$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0cfcca548ca5090c$var$Te || null == $0cfcca548ca5090c$var$Qe || $0cfcca548ca5090c$var$Qe !== $0cfcca548ca5090c$var$Xa(d) || (d = $0cfcca548ca5090c$var$Qe, "selectionStart" in d && $0cfcca548ca5090c$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0cfcca548ca5090c$var$Se && $0cfcca548ca5090c$var$Ie($0cfcca548ca5090c$var$Se, d) || ($0cfcca548ca5090c$var$Se = d, d = $0cfcca548ca5090c$var$oe($0cfcca548ca5090c$var$Re, "onSelect"), 0 < d.length && (b = new $0cfcca548ca5090c$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0cfcca548ca5090c$var$Qe)));
}
function $0cfcca548ca5090c$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0cfcca548ca5090c$var$We = {
    animationend: $0cfcca548ca5090c$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0cfcca548ca5090c$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0cfcca548ca5090c$var$Ve("Animation", "AnimationStart"),
    transitionend: $0cfcca548ca5090c$var$Ve("Transition", "TransitionEnd")
}, $0cfcca548ca5090c$var$Xe = {}, $0cfcca548ca5090c$var$Ye = {};
$0cfcca548ca5090c$var$ia && ($0cfcca548ca5090c$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0cfcca548ca5090c$var$We.animationend.animation, delete $0cfcca548ca5090c$var$We.animationiteration.animation, delete $0cfcca548ca5090c$var$We.animationstart.animation), "TransitionEvent" in window || delete $0cfcca548ca5090c$var$We.transitionend.transition);
function $0cfcca548ca5090c$var$Ze(a) {
    if ($0cfcca548ca5090c$var$Xe[a]) return $0cfcca548ca5090c$var$Xe[a];
    if (!$0cfcca548ca5090c$var$We[a]) return a;
    var b = $0cfcca548ca5090c$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0cfcca548ca5090c$var$Ye) return $0cfcca548ca5090c$var$Xe[a] = b[c];
    return a;
}
var $0cfcca548ca5090c$var$$e = $0cfcca548ca5090c$var$Ze("animationend"), $0cfcca548ca5090c$var$af = $0cfcca548ca5090c$var$Ze("animationiteration"), $0cfcca548ca5090c$var$bf = $0cfcca548ca5090c$var$Ze("animationstart"), $0cfcca548ca5090c$var$cf = $0cfcca548ca5090c$var$Ze("transitionend"), $0cfcca548ca5090c$var$df = new Map, $0cfcca548ca5090c$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0cfcca548ca5090c$var$ff(a, b) {
    $0cfcca548ca5090c$var$df.set(a, b);
    $0cfcca548ca5090c$var$fa(b, [
        a
    ]);
}
for(var $0cfcca548ca5090c$var$gf = 0; $0cfcca548ca5090c$var$gf < $0cfcca548ca5090c$var$ef.length; $0cfcca548ca5090c$var$gf++){
    var $0cfcca548ca5090c$var$hf = $0cfcca548ca5090c$var$ef[$0cfcca548ca5090c$var$gf], $0cfcca548ca5090c$var$jf = $0cfcca548ca5090c$var$hf.toLowerCase(), $0cfcca548ca5090c$var$kf = $0cfcca548ca5090c$var$hf[0].toUpperCase() + $0cfcca548ca5090c$var$hf.slice(1);
    $0cfcca548ca5090c$var$ff($0cfcca548ca5090c$var$jf, "on" + $0cfcca548ca5090c$var$kf);
}
$0cfcca548ca5090c$var$ff($0cfcca548ca5090c$var$$e, "onAnimationEnd");
$0cfcca548ca5090c$var$ff($0cfcca548ca5090c$var$af, "onAnimationIteration");
$0cfcca548ca5090c$var$ff($0cfcca548ca5090c$var$bf, "onAnimationStart");
$0cfcca548ca5090c$var$ff("dblclick", "onDoubleClick");
$0cfcca548ca5090c$var$ff("focusin", "onFocus");
$0cfcca548ca5090c$var$ff("focusout", "onBlur");
$0cfcca548ca5090c$var$ff($0cfcca548ca5090c$var$cf, "onTransitionEnd");
$0cfcca548ca5090c$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0cfcca548ca5090c$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0cfcca548ca5090c$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0cfcca548ca5090c$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0cfcca548ca5090c$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0cfcca548ca5090c$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0cfcca548ca5090c$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0cfcca548ca5090c$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0cfcca548ca5090c$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0cfcca548ca5090c$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0cfcca548ca5090c$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0cfcca548ca5090c$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0cfcca548ca5090c$var$lf));
function $0cfcca548ca5090c$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0cfcca548ca5090c$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0cfcca548ca5090c$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0cfcca548ca5090c$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0cfcca548ca5090c$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0cfcca548ca5090c$var$Qb) throw a = $0cfcca548ca5090c$var$Rb, $0cfcca548ca5090c$var$Qb = !1, $0cfcca548ca5090c$var$Rb = null, a;
}
function $0cfcca548ca5090c$var$D(a, b) {
    var c = b[$0cfcca548ca5090c$var$of];
    void 0 === c && (c = b[$0cfcca548ca5090c$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0cfcca548ca5090c$var$pf(b, a, 2, !1), c.add(d));
}
function $0cfcca548ca5090c$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0cfcca548ca5090c$var$pf(c, a, d, b);
}
var $0cfcca548ca5090c$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0cfcca548ca5090c$var$sf(a) {
    if (!a[$0cfcca548ca5090c$var$rf]) {
        a[$0cfcca548ca5090c$var$rf] = !0;
        $0cfcca548ca5090c$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0cfcca548ca5090c$var$mf.has(b) || $0cfcca548ca5090c$var$qf(b, !1, a), $0cfcca548ca5090c$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0cfcca548ca5090c$var$rf] || (b[$0cfcca548ca5090c$var$rf] = !0, $0cfcca548ca5090c$var$qf("selectionchange", !1, b));
    }
}
function $0cfcca548ca5090c$var$pf(a, b, c, d) {
    switch($0cfcca548ca5090c$var$jd(b)){
        case 1:
            var e = $0cfcca548ca5090c$var$ed;
            break;
        case 4:
            e = $0cfcca548ca5090c$var$gd;
            break;
        default:
            e = $0cfcca548ca5090c$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0cfcca548ca5090c$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0cfcca548ca5090c$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0cfcca548ca5090c$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0cfcca548ca5090c$var$Jb(function() {
        var d = f, e = $0cfcca548ca5090c$var$xb(c), g = [];
        a: {
            var h = $0cfcca548ca5090c$var$df.get(a);
            if (void 0 !== h) {
                var k = $0cfcca548ca5090c$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0cfcca548ca5090c$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0cfcca548ca5090c$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0cfcca548ca5090c$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0cfcca548ca5090c$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0cfcca548ca5090c$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0cfcca548ca5090c$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0cfcca548ca5090c$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0cfcca548ca5090c$var$Vd;
                        break;
                    case $0cfcca548ca5090c$var$$e:
                    case $0cfcca548ca5090c$var$af:
                    case $0cfcca548ca5090c$var$bf:
                        k = $0cfcca548ca5090c$var$Hd;
                        break;
                    case $0cfcca548ca5090c$var$cf:
                        k = $0cfcca548ca5090c$var$Xd;
                        break;
                    case "scroll":
                        k = $0cfcca548ca5090c$var$vd;
                        break;
                    case "wheel":
                        k = $0cfcca548ca5090c$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0cfcca548ca5090c$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0cfcca548ca5090c$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0cfcca548ca5090c$var$Kb(w, x), null != F && t.push($0cfcca548ca5090c$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0cfcca548ca5090c$var$wb && (n = c.relatedTarget || c.fromElement) && ($0cfcca548ca5090c$var$Wc(n) || n[$0cfcca548ca5090c$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0cfcca548ca5090c$var$Wc(n) : null, null !== n && (J = $0cfcca548ca5090c$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0cfcca548ca5090c$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0cfcca548ca5090c$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0cfcca548ca5090c$var$ue(k);
                        u = null == n ? h : $0cfcca548ca5090c$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0cfcca548ca5090c$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0cfcca548ca5090c$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0cfcca548ca5090c$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0cfcca548ca5090c$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0cfcca548ca5090c$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0cfcca548ca5090c$var$vf(t);
                                x = $0cfcca548ca5090c$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0cfcca548ca5090c$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0cfcca548ca5090c$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0cfcca548ca5090c$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0cfcca548ca5090c$var$ve;
                else if ($0cfcca548ca5090c$var$me(h)) {
                    if ($0cfcca548ca5090c$var$we) na = $0cfcca548ca5090c$var$Fe;
                    else {
                        na = $0cfcca548ca5090c$var$De;
                        var xa = $0cfcca548ca5090c$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0cfcca548ca5090c$var$Ee);
                if (na && (na = na(a, d))) {
                    $0cfcca548ca5090c$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0cfcca548ca5090c$var$cb(h, "number", h.value);
            }
            xa = d ? $0cfcca548ca5090c$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0cfcca548ca5090c$var$me(xa) || "true" === xa.contentEditable) $0cfcca548ca5090c$var$Qe = xa, $0cfcca548ca5090c$var$Re = d, $0cfcca548ca5090c$var$Se = null;
                    break;
                case "focusout":
                    $0cfcca548ca5090c$var$Se = $0cfcca548ca5090c$var$Re = $0cfcca548ca5090c$var$Qe = null;
                    break;
                case "mousedown":
                    $0cfcca548ca5090c$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0cfcca548ca5090c$var$Te = !1;
                    $0cfcca548ca5090c$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0cfcca548ca5090c$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0cfcca548ca5090c$var$Ue(g, c, e);
            }
            var $a;
            if ($0cfcca548ca5090c$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0cfcca548ca5090c$var$ie ? $0cfcca548ca5090c$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0cfcca548ca5090c$var$de && "ko" !== c.locale && ($0cfcca548ca5090c$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0cfcca548ca5090c$var$ie && ($a = $0cfcca548ca5090c$var$nd()) : ($0cfcca548ca5090c$var$kd = e, $0cfcca548ca5090c$var$ld = "value" in $0cfcca548ca5090c$var$kd ? $0cfcca548ca5090c$var$kd.value : $0cfcca548ca5090c$var$kd.textContent, $0cfcca548ca5090c$var$ie = !0)), xa = $0cfcca548ca5090c$var$oe(d, ba), 0 < xa.length && (ba = new $0cfcca548ca5090c$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0cfcca548ca5090c$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0cfcca548ca5090c$var$ce ? $0cfcca548ca5090c$var$je(a, c) : $0cfcca548ca5090c$var$ke(a, c)) d = $0cfcca548ca5090c$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0cfcca548ca5090c$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0cfcca548ca5090c$var$se(g, b);
    });
}
function $0cfcca548ca5090c$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0cfcca548ca5090c$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0cfcca548ca5090c$var$Kb(a, c), null != f && d.unshift($0cfcca548ca5090c$var$tf(a, f, e)), f = $0cfcca548ca5090c$var$Kb(a, b), null != f && d.push($0cfcca548ca5090c$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0cfcca548ca5090c$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0cfcca548ca5090c$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0cfcca548ca5090c$var$Kb(c, f), null != k && g.unshift($0cfcca548ca5090c$var$tf(c, k, h))) : e || (k = $0cfcca548ca5090c$var$Kb(c, f), null != k && g.push($0cfcca548ca5090c$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0cfcca548ca5090c$var$xf = /\r\n?/g, $0cfcca548ca5090c$var$yf = /\u0000|\uFFFD/g;
function $0cfcca548ca5090c$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0cfcca548ca5090c$var$xf, "\n").replace($0cfcca548ca5090c$var$yf, "");
}
function $0cfcca548ca5090c$var$Af(a, b, c) {
    b = $0cfcca548ca5090c$var$zf(b);
    if ($0cfcca548ca5090c$var$zf(a) !== b && c) throw Error($0cfcca548ca5090c$var$p(425));
}
function $0cfcca548ca5090c$var$Bf() {}
var $0cfcca548ca5090c$var$Cf = null, $0cfcca548ca5090c$var$Df = null;
function $0cfcca548ca5090c$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0cfcca548ca5090c$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0cfcca548ca5090c$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0cfcca548ca5090c$var$Hf = "function" === typeof Promise ? Promise : void 0, $0cfcca548ca5090c$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0cfcca548ca5090c$var$Hf ? function(a) {
    return $0cfcca548ca5090c$var$Hf.resolve(null).then(a).catch($0cfcca548ca5090c$var$If);
} : $0cfcca548ca5090c$var$Ff;
function $0cfcca548ca5090c$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0cfcca548ca5090c$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0cfcca548ca5090c$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0cfcca548ca5090c$var$bd(b);
}
function $0cfcca548ca5090c$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0cfcca548ca5090c$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0cfcca548ca5090c$var$Nf = Math.random().toString(36).slice(2), $0cfcca548ca5090c$var$Of = "__reactFiber$" + $0cfcca548ca5090c$var$Nf, $0cfcca548ca5090c$var$Pf = "__reactProps$" + $0cfcca548ca5090c$var$Nf, $0cfcca548ca5090c$var$uf = "__reactContainer$" + $0cfcca548ca5090c$var$Nf, $0cfcca548ca5090c$var$of = "__reactEvents$" + $0cfcca548ca5090c$var$Nf, $0cfcca548ca5090c$var$Qf = "__reactListeners$" + $0cfcca548ca5090c$var$Nf, $0cfcca548ca5090c$var$Rf = "__reactHandles$" + $0cfcca548ca5090c$var$Nf;
function $0cfcca548ca5090c$var$Wc(a) {
    var b = a[$0cfcca548ca5090c$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0cfcca548ca5090c$var$uf] || c[$0cfcca548ca5090c$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0cfcca548ca5090c$var$Mf(a); null !== a;){
                if (c = a[$0cfcca548ca5090c$var$Of]) return c;
                a = $0cfcca548ca5090c$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0cfcca548ca5090c$var$Cb(a) {
    a = a[$0cfcca548ca5090c$var$Of] || a[$0cfcca548ca5090c$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0cfcca548ca5090c$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0cfcca548ca5090c$var$p(33));
}
function $0cfcca548ca5090c$var$Db(a) {
    return a[$0cfcca548ca5090c$var$Pf] || null;
}
var $0cfcca548ca5090c$var$Sf = [], $0cfcca548ca5090c$var$Tf = -1;
function $0cfcca548ca5090c$var$Uf(a) {
    return {
        current: a
    };
}
function $0cfcca548ca5090c$var$E(a) {
    0 > $0cfcca548ca5090c$var$Tf || (a.current = $0cfcca548ca5090c$var$Sf[$0cfcca548ca5090c$var$Tf], $0cfcca548ca5090c$var$Sf[$0cfcca548ca5090c$var$Tf] = null, $0cfcca548ca5090c$var$Tf--);
}
function $0cfcca548ca5090c$var$G(a, b) {
    $0cfcca548ca5090c$var$Tf++;
    $0cfcca548ca5090c$var$Sf[$0cfcca548ca5090c$var$Tf] = a.current;
    a.current = b;
}
var $0cfcca548ca5090c$var$Vf = {}, $0cfcca548ca5090c$var$H = $0cfcca548ca5090c$var$Uf($0cfcca548ca5090c$var$Vf), $0cfcca548ca5090c$var$Wf = $0cfcca548ca5090c$var$Uf(!1), $0cfcca548ca5090c$var$Xf = $0cfcca548ca5090c$var$Vf;
function $0cfcca548ca5090c$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0cfcca548ca5090c$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0cfcca548ca5090c$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0cfcca548ca5090c$var$$f() {
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf);
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$H);
}
function $0cfcca548ca5090c$var$ag(a, b, c) {
    if ($0cfcca548ca5090c$var$H.current !== $0cfcca548ca5090c$var$Vf) throw Error($0cfcca548ca5090c$var$p(168));
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$H, b);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$Wf, c);
}
function $0cfcca548ca5090c$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0cfcca548ca5090c$var$p(108, $0cfcca548ca5090c$var$Ra(a) || "Unknown", e));
    return $0cfcca548ca5090c$var$A({}, c, d);
}
function $0cfcca548ca5090c$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0cfcca548ca5090c$var$Vf;
    $0cfcca548ca5090c$var$Xf = $0cfcca548ca5090c$var$H.current;
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$H, a);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$Wf, $0cfcca548ca5090c$var$Wf.current);
    return !0;
}
function $0cfcca548ca5090c$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0cfcca548ca5090c$var$p(169));
    c ? (a = $0cfcca548ca5090c$var$bg(a, b, $0cfcca548ca5090c$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf), $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$H), $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$H, a)) : $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$Wf, c);
}
var $0cfcca548ca5090c$var$eg = null, $0cfcca548ca5090c$var$fg = !1, $0cfcca548ca5090c$var$gg = !1;
function $0cfcca548ca5090c$var$hg(a) {
    null === $0cfcca548ca5090c$var$eg ? $0cfcca548ca5090c$var$eg = [
        a
    ] : $0cfcca548ca5090c$var$eg.push(a);
}
function $0cfcca548ca5090c$var$ig(a) {
    $0cfcca548ca5090c$var$fg = !0;
    $0cfcca548ca5090c$var$hg(a);
}
function $0cfcca548ca5090c$var$jg() {
    if (!$0cfcca548ca5090c$var$gg && null !== $0cfcca548ca5090c$var$eg) {
        $0cfcca548ca5090c$var$gg = !0;
        var a = 0, b = $0cfcca548ca5090c$var$C;
        try {
            var c = $0cfcca548ca5090c$var$eg;
            for($0cfcca548ca5090c$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0cfcca548ca5090c$var$eg = null;
            $0cfcca548ca5090c$var$fg = !1;
        } catch (e) {
            throw null !== $0cfcca548ca5090c$var$eg && ($0cfcca548ca5090c$var$eg = $0cfcca548ca5090c$var$eg.slice(a + 1)), $0cfcca548ca5090c$var$ac($0cfcca548ca5090c$var$fc, $0cfcca548ca5090c$var$jg), e;
        } finally{
            $0cfcca548ca5090c$var$C = b, $0cfcca548ca5090c$var$gg = !1;
        }
    }
    return null;
}
var $0cfcca548ca5090c$var$kg = [], $0cfcca548ca5090c$var$lg = 0, $0cfcca548ca5090c$var$mg = null, $0cfcca548ca5090c$var$ng = 0, $0cfcca548ca5090c$var$og = [], $0cfcca548ca5090c$var$pg = 0, $0cfcca548ca5090c$var$qg = null, $0cfcca548ca5090c$var$rg = 1, $0cfcca548ca5090c$var$sg = "";
function $0cfcca548ca5090c$var$tg(a, b) {
    $0cfcca548ca5090c$var$kg[$0cfcca548ca5090c$var$lg++] = $0cfcca548ca5090c$var$ng;
    $0cfcca548ca5090c$var$kg[$0cfcca548ca5090c$var$lg++] = $0cfcca548ca5090c$var$mg;
    $0cfcca548ca5090c$var$mg = a;
    $0cfcca548ca5090c$var$ng = b;
}
function $0cfcca548ca5090c$var$ug(a, b, c) {
    $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$rg;
    $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$sg;
    $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$qg;
    $0cfcca548ca5090c$var$qg = a;
    var d = $0cfcca548ca5090c$var$rg;
    a = $0cfcca548ca5090c$var$sg;
    var e = 32 - $0cfcca548ca5090c$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0cfcca548ca5090c$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0cfcca548ca5090c$var$rg = 1 << 32 - $0cfcca548ca5090c$var$oc(b) + e | c << e | d;
        $0cfcca548ca5090c$var$sg = f + a;
    } else $0cfcca548ca5090c$var$rg = 1 << f | c << e | d, $0cfcca548ca5090c$var$sg = a;
}
function $0cfcca548ca5090c$var$vg(a) {
    null !== a.return && ($0cfcca548ca5090c$var$tg(a, 1), $0cfcca548ca5090c$var$ug(a, 1, 0));
}
function $0cfcca548ca5090c$var$wg(a) {
    for(; a === $0cfcca548ca5090c$var$mg;)$0cfcca548ca5090c$var$mg = $0cfcca548ca5090c$var$kg[--$0cfcca548ca5090c$var$lg], $0cfcca548ca5090c$var$kg[$0cfcca548ca5090c$var$lg] = null, $0cfcca548ca5090c$var$ng = $0cfcca548ca5090c$var$kg[--$0cfcca548ca5090c$var$lg], $0cfcca548ca5090c$var$kg[$0cfcca548ca5090c$var$lg] = null;
    for(; a === $0cfcca548ca5090c$var$qg;)$0cfcca548ca5090c$var$qg = $0cfcca548ca5090c$var$og[--$0cfcca548ca5090c$var$pg], $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg] = null, $0cfcca548ca5090c$var$sg = $0cfcca548ca5090c$var$og[--$0cfcca548ca5090c$var$pg], $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg] = null, $0cfcca548ca5090c$var$rg = $0cfcca548ca5090c$var$og[--$0cfcca548ca5090c$var$pg], $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg] = null;
}
var $0cfcca548ca5090c$var$xg = null, $0cfcca548ca5090c$var$yg = null, $0cfcca548ca5090c$var$I = !1, $0cfcca548ca5090c$var$zg = null;
function $0cfcca548ca5090c$var$Ag(a, b) {
    var c = $0cfcca548ca5090c$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0cfcca548ca5090c$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0cfcca548ca5090c$var$xg = a, $0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0cfcca548ca5090c$var$xg = a, $0cfcca548ca5090c$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0cfcca548ca5090c$var$qg ? {
                id: $0cfcca548ca5090c$var$rg,
                overflow: $0cfcca548ca5090c$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0cfcca548ca5090c$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0cfcca548ca5090c$var$xg = a, $0cfcca548ca5090c$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0cfcca548ca5090c$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0cfcca548ca5090c$var$Eg(a) {
    if ($0cfcca548ca5090c$var$I) {
        var b = $0cfcca548ca5090c$var$yg;
        if (b) {
            var c = b;
            if (!$0cfcca548ca5090c$var$Cg(a, b)) {
                if ($0cfcca548ca5090c$var$Dg(a)) throw Error($0cfcca548ca5090c$var$p(418));
                b = $0cfcca548ca5090c$var$Lf(c.nextSibling);
                var d = $0cfcca548ca5090c$var$xg;
                b && $0cfcca548ca5090c$var$Cg(a, b) ? $0cfcca548ca5090c$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0cfcca548ca5090c$var$I = !1, $0cfcca548ca5090c$var$xg = a);
            }
        } else {
            if ($0cfcca548ca5090c$var$Dg(a)) throw Error($0cfcca548ca5090c$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0cfcca548ca5090c$var$I = !1;
            $0cfcca548ca5090c$var$xg = a;
        }
    }
}
function $0cfcca548ca5090c$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0cfcca548ca5090c$var$xg = a;
}
function $0cfcca548ca5090c$var$Gg(a) {
    if (a !== $0cfcca548ca5090c$var$xg) return !1;
    if (!$0cfcca548ca5090c$var$I) return $0cfcca548ca5090c$var$Fg(a), $0cfcca548ca5090c$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0cfcca548ca5090c$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0cfcca548ca5090c$var$yg)) {
        if ($0cfcca548ca5090c$var$Dg(a)) throw $0cfcca548ca5090c$var$Hg(), Error($0cfcca548ca5090c$var$p(418));
        for(; b;)$0cfcca548ca5090c$var$Ag(a, b), b = $0cfcca548ca5090c$var$Lf(b.nextSibling);
    }
    $0cfcca548ca5090c$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0cfcca548ca5090c$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0cfcca548ca5090c$var$yg = null;
        }
    } else $0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$xg ? $0cfcca548ca5090c$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0cfcca548ca5090c$var$Hg() {
    for(var a = $0cfcca548ca5090c$var$yg; a;)a = $0cfcca548ca5090c$var$Lf(a.nextSibling);
}
function $0cfcca548ca5090c$var$Ig() {
    $0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$xg = null;
    $0cfcca548ca5090c$var$I = !1;
}
function $0cfcca548ca5090c$var$Jg(a) {
    null === $0cfcca548ca5090c$var$zg ? $0cfcca548ca5090c$var$zg = [
        a
    ] : $0cfcca548ca5090c$var$zg.push(a);
}
var $0cfcca548ca5090c$var$Kg = $0cfcca548ca5090c$var$ua.ReactCurrentBatchConfig;
function $0cfcca548ca5090c$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0cfcca548ca5090c$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0cfcca548ca5090c$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0cfcca548ca5090c$var$p(284));
        if (!c._owner) throw Error($0cfcca548ca5090c$var$p(290, a));
    }
    return a;
}
function $0cfcca548ca5090c$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0cfcca548ca5090c$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0cfcca548ca5090c$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0cfcca548ca5090c$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0cfcca548ca5090c$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0cfcca548ca5090c$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0cfcca548ca5090c$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0cfcca548ca5090c$var$Ha && $0cfcca548ca5090c$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0cfcca548ca5090c$var$Lg(a, b, c), d.return = a, d;
        d = $0cfcca548ca5090c$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0cfcca548ca5090c$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0cfcca548ca5090c$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0cfcca548ca5090c$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0cfcca548ca5090c$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0cfcca548ca5090c$var$va:
                    return c = $0cfcca548ca5090c$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0cfcca548ca5090c$var$Lg(a, null, b), c.return = a, c;
                case $0cfcca548ca5090c$var$wa:
                    return b = $0cfcca548ca5090c$var$Sg(b, a.mode, c), b.return = a, b;
                case $0cfcca548ca5090c$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0cfcca548ca5090c$var$eb(b) || $0cfcca548ca5090c$var$Ka(b)) return b = $0cfcca548ca5090c$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0cfcca548ca5090c$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0cfcca548ca5090c$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0cfcca548ca5090c$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0cfcca548ca5090c$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0cfcca548ca5090c$var$eb(c) || $0cfcca548ca5090c$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0cfcca548ca5090c$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0cfcca548ca5090c$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0cfcca548ca5090c$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0cfcca548ca5090c$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0cfcca548ca5090c$var$eb(d) || $0cfcca548ca5090c$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0cfcca548ca5090c$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0cfcca548ca5090c$var$Ka(h);
        if ("function" !== typeof l) throw Error($0cfcca548ca5090c$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0cfcca548ca5090c$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0cfcca548ca5090c$var$I && $0cfcca548ca5090c$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0cfcca548ca5090c$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0cfcca548ca5090c$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0cfcca548ca5090c$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0cfcca548ca5090c$var$Ha && $0cfcca548ca5090c$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0cfcca548ca5090c$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0cfcca548ca5090c$var$ya ? (d = $0cfcca548ca5090c$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0cfcca548ca5090c$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0cfcca548ca5090c$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0cfcca548ca5090c$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0cfcca548ca5090c$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0cfcca548ca5090c$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0cfcca548ca5090c$var$eb(f)) return n(a, d, f, h);
            if ($0cfcca548ca5090c$var$Ka(f)) return t(a, d, f, h);
            $0cfcca548ca5090c$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0cfcca548ca5090c$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0cfcca548ca5090c$var$Ug = $0cfcca548ca5090c$var$Og(!0), $0cfcca548ca5090c$var$Vg = $0cfcca548ca5090c$var$Og(!1), $0cfcca548ca5090c$var$Wg = $0cfcca548ca5090c$var$Uf(null), $0cfcca548ca5090c$var$Xg = null, $0cfcca548ca5090c$var$Yg = null, $0cfcca548ca5090c$var$Zg = null;
function $0cfcca548ca5090c$var$$g() {
    $0cfcca548ca5090c$var$Zg = $0cfcca548ca5090c$var$Yg = $0cfcca548ca5090c$var$Xg = null;
}
function $0cfcca548ca5090c$var$ah(a) {
    var b = $0cfcca548ca5090c$var$Wg.current;
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wg);
    a._currentValue = b;
}
function $0cfcca548ca5090c$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0cfcca548ca5090c$var$ch(a, b) {
    $0cfcca548ca5090c$var$Xg = a;
    $0cfcca548ca5090c$var$Zg = $0cfcca548ca5090c$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0cfcca548ca5090c$var$dh = !0), a.firstContext = null);
}
function $0cfcca548ca5090c$var$eh(a) {
    var b = a._currentValue;
    if ($0cfcca548ca5090c$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0cfcca548ca5090c$var$Yg) {
            if (null === $0cfcca548ca5090c$var$Xg) throw Error($0cfcca548ca5090c$var$p(308));
            $0cfcca548ca5090c$var$Yg = a;
            $0cfcca548ca5090c$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0cfcca548ca5090c$var$Yg = $0cfcca548ca5090c$var$Yg.next = a;
    }
    return b;
}
var $0cfcca548ca5090c$var$fh = null;
function $0cfcca548ca5090c$var$gh(a) {
    null === $0cfcca548ca5090c$var$fh ? $0cfcca548ca5090c$var$fh = [
        a
    ] : $0cfcca548ca5090c$var$fh.push(a);
}
function $0cfcca548ca5090c$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0cfcca548ca5090c$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0cfcca548ca5090c$var$ih(a, d);
}
function $0cfcca548ca5090c$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0cfcca548ca5090c$var$jh = !1;
function $0cfcca548ca5090c$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0cfcca548ca5090c$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0cfcca548ca5090c$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0cfcca548ca5090c$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0cfcca548ca5090c$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0cfcca548ca5090c$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0cfcca548ca5090c$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0cfcca548ca5090c$var$ih(a, c);
}
function $0cfcca548ca5090c$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0cfcca548ca5090c$var$Cc(a, c);
    }
}
function $0cfcca548ca5090c$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0cfcca548ca5090c$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0cfcca548ca5090c$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0cfcca548ca5090c$var$A({}, q, r);
                            break a;
                        case 2:
                            $0cfcca548ca5090c$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0cfcca548ca5090c$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0cfcca548ca5090c$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0cfcca548ca5090c$var$p(191, e));
            e.call(d);
        }
    }
}
var $0cfcca548ca5090c$var$th = {}, $0cfcca548ca5090c$var$uh = $0cfcca548ca5090c$var$Uf($0cfcca548ca5090c$var$th), $0cfcca548ca5090c$var$vh = $0cfcca548ca5090c$var$Uf($0cfcca548ca5090c$var$th), $0cfcca548ca5090c$var$wh = $0cfcca548ca5090c$var$Uf($0cfcca548ca5090c$var$th);
function $0cfcca548ca5090c$var$xh(a) {
    if (a === $0cfcca548ca5090c$var$th) throw Error($0cfcca548ca5090c$var$p(174));
    return a;
}
function $0cfcca548ca5090c$var$yh(a, b) {
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$wh, b);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$vh, a);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$uh, $0cfcca548ca5090c$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0cfcca548ca5090c$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0cfcca548ca5090c$var$lb(b, a);
    }
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$uh);
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$uh, b);
}
function $0cfcca548ca5090c$var$zh() {
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$uh);
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$vh);
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$wh);
}
function $0cfcca548ca5090c$var$Ah(a) {
    $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$wh.current);
    var b = $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$uh.current);
    var c = $0cfcca548ca5090c$var$lb(b, a.type);
    b !== c && ($0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$vh, a), $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$uh, c));
}
function $0cfcca548ca5090c$var$Bh(a) {
    $0cfcca548ca5090c$var$vh.current === a && ($0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$uh), $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$vh));
}
var $0cfcca548ca5090c$var$L = $0cfcca548ca5090c$var$Uf(0);
function $0cfcca548ca5090c$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0cfcca548ca5090c$var$Dh = [];
function $0cfcca548ca5090c$var$Eh() {
    for(var a = 0; a < $0cfcca548ca5090c$var$Dh.length; a++)$0cfcca548ca5090c$var$Dh[a]._workInProgressVersionPrimary = null;
    $0cfcca548ca5090c$var$Dh.length = 0;
}
var $0cfcca548ca5090c$var$Fh = $0cfcca548ca5090c$var$ua.ReactCurrentDispatcher, $0cfcca548ca5090c$var$Gh = $0cfcca548ca5090c$var$ua.ReactCurrentBatchConfig, $0cfcca548ca5090c$var$Hh = 0, $0cfcca548ca5090c$var$M = null, $0cfcca548ca5090c$var$N = null, $0cfcca548ca5090c$var$O = null, $0cfcca548ca5090c$var$Ih = !1, $0cfcca548ca5090c$var$Jh = !1, $0cfcca548ca5090c$var$Kh = 0, $0cfcca548ca5090c$var$Lh = 0;
function $0cfcca548ca5090c$var$P() {
    throw Error($0cfcca548ca5090c$var$p(321));
}
function $0cfcca548ca5090c$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0cfcca548ca5090c$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0cfcca548ca5090c$var$Nh(a, b, c, d, e, f) {
    $0cfcca548ca5090c$var$Hh = f;
    $0cfcca548ca5090c$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0cfcca548ca5090c$var$Fh.current = null === a || null === a.memoizedState ? $0cfcca548ca5090c$var$Oh : $0cfcca548ca5090c$var$Ph;
    a = c(d, e);
    if ($0cfcca548ca5090c$var$Jh) {
        f = 0;
        do {
            $0cfcca548ca5090c$var$Jh = !1;
            $0cfcca548ca5090c$var$Kh = 0;
            if (25 <= f) throw Error($0cfcca548ca5090c$var$p(301));
            f += 1;
            $0cfcca548ca5090c$var$O = $0cfcca548ca5090c$var$N = null;
            b.updateQueue = null;
            $0cfcca548ca5090c$var$Fh.current = $0cfcca548ca5090c$var$Qh;
            a = c(d, e);
        }while ($0cfcca548ca5090c$var$Jh);
    }
    $0cfcca548ca5090c$var$Fh.current = $0cfcca548ca5090c$var$Rh;
    b = null !== $0cfcca548ca5090c$var$N && null !== $0cfcca548ca5090c$var$N.next;
    $0cfcca548ca5090c$var$Hh = 0;
    $0cfcca548ca5090c$var$O = $0cfcca548ca5090c$var$N = $0cfcca548ca5090c$var$M = null;
    $0cfcca548ca5090c$var$Ih = !1;
    if (b) throw Error($0cfcca548ca5090c$var$p(300));
    return a;
}
function $0cfcca548ca5090c$var$Sh() {
    var a = 0 !== $0cfcca548ca5090c$var$Kh;
    $0cfcca548ca5090c$var$Kh = 0;
    return a;
}
function $0cfcca548ca5090c$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0cfcca548ca5090c$var$O ? $0cfcca548ca5090c$var$M.memoizedState = $0cfcca548ca5090c$var$O = a : $0cfcca548ca5090c$var$O = $0cfcca548ca5090c$var$O.next = a;
    return $0cfcca548ca5090c$var$O;
}
function $0cfcca548ca5090c$var$Uh() {
    if (null === $0cfcca548ca5090c$var$N) {
        var a = $0cfcca548ca5090c$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0cfcca548ca5090c$var$N.next;
    var b = null === $0cfcca548ca5090c$var$O ? $0cfcca548ca5090c$var$M.memoizedState : $0cfcca548ca5090c$var$O.next;
    if (null !== b) $0cfcca548ca5090c$var$O = b, $0cfcca548ca5090c$var$N = a;
    else {
        if (null === a) throw Error($0cfcca548ca5090c$var$p(310));
        $0cfcca548ca5090c$var$N = a;
        a = {
            memoizedState: $0cfcca548ca5090c$var$N.memoizedState,
            baseState: $0cfcca548ca5090c$var$N.baseState,
            baseQueue: $0cfcca548ca5090c$var$N.baseQueue,
            queue: $0cfcca548ca5090c$var$N.queue,
            next: null
        };
        null === $0cfcca548ca5090c$var$O ? $0cfcca548ca5090c$var$M.memoizedState = $0cfcca548ca5090c$var$O = a : $0cfcca548ca5090c$var$O = $0cfcca548ca5090c$var$O.next = a;
    }
    return $0cfcca548ca5090c$var$O;
}
function $0cfcca548ca5090c$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0cfcca548ca5090c$var$Wh(a) {
    var b = $0cfcca548ca5090c$var$Uh(), c = b.queue;
    if (null === c) throw Error($0cfcca548ca5090c$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0cfcca548ca5090c$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0cfcca548ca5090c$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0cfcca548ca5090c$var$M.lanes |= m;
                $0cfcca548ca5090c$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0cfcca548ca5090c$var$He(d, b.memoizedState) || ($0cfcca548ca5090c$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0cfcca548ca5090c$var$M.lanes |= f, $0cfcca548ca5090c$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0cfcca548ca5090c$var$Xh(a) {
    var b = $0cfcca548ca5090c$var$Uh(), c = b.queue;
    if (null === c) throw Error($0cfcca548ca5090c$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0cfcca548ca5090c$var$He(f, b.memoizedState) || ($0cfcca548ca5090c$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0cfcca548ca5090c$var$Yh() {}
function $0cfcca548ca5090c$var$Zh(a, b) {
    var c = $0cfcca548ca5090c$var$M, d = $0cfcca548ca5090c$var$Uh(), e = b(), f = !$0cfcca548ca5090c$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0cfcca548ca5090c$var$dh = !0);
    d = d.queue;
    $0cfcca548ca5090c$var$$h($0cfcca548ca5090c$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0cfcca548ca5090c$var$O && $0cfcca548ca5090c$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0cfcca548ca5090c$var$bi(9, $0cfcca548ca5090c$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0cfcca548ca5090c$var$Q) throw Error($0cfcca548ca5090c$var$p(349));
        0 !== ($0cfcca548ca5090c$var$Hh & 30) || $0cfcca548ca5090c$var$di(c, b, e);
    }
    return e;
}
function $0cfcca548ca5090c$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0cfcca548ca5090c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0cfcca548ca5090c$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0cfcca548ca5090c$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0cfcca548ca5090c$var$ei(b) && $0cfcca548ca5090c$var$fi(a);
}
function $0cfcca548ca5090c$var$ai(a, b, c) {
    return c(function() {
        $0cfcca548ca5090c$var$ei(b) && $0cfcca548ca5090c$var$fi(a);
    });
}
function $0cfcca548ca5090c$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0cfcca548ca5090c$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0cfcca548ca5090c$var$fi(a) {
    var b = $0cfcca548ca5090c$var$ih(a, 1);
    null !== b && $0cfcca548ca5090c$var$gi(b, a, 1, -1);
}
function $0cfcca548ca5090c$var$hi(a) {
    var b = $0cfcca548ca5090c$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0cfcca548ca5090c$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0cfcca548ca5090c$var$ii.bind(null, $0cfcca548ca5090c$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0cfcca548ca5090c$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0cfcca548ca5090c$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0cfcca548ca5090c$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0cfcca548ca5090c$var$ji() {
    return $0cfcca548ca5090c$var$Uh().memoizedState;
}
function $0cfcca548ca5090c$var$ki(a, b, c, d) {
    var e = $0cfcca548ca5090c$var$Th();
    $0cfcca548ca5090c$var$M.flags |= a;
    e.memoizedState = $0cfcca548ca5090c$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0cfcca548ca5090c$var$li(a, b, c, d) {
    var e = $0cfcca548ca5090c$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0cfcca548ca5090c$var$N) {
        var g = $0cfcca548ca5090c$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0cfcca548ca5090c$var$Mh(d, g.deps)) {
            e.memoizedState = $0cfcca548ca5090c$var$bi(b, c, f, d);
            return;
        }
    }
    $0cfcca548ca5090c$var$M.flags |= a;
    e.memoizedState = $0cfcca548ca5090c$var$bi(1 | b, c, f, d);
}
function $0cfcca548ca5090c$var$mi(a, b) {
    return $0cfcca548ca5090c$var$ki(8390656, 8, a, b);
}
function $0cfcca548ca5090c$var$$h(a, b) {
    return $0cfcca548ca5090c$var$li(2048, 8, a, b);
}
function $0cfcca548ca5090c$var$ni(a, b) {
    return $0cfcca548ca5090c$var$li(4, 2, a, b);
}
function $0cfcca548ca5090c$var$oi(a, b) {
    return $0cfcca548ca5090c$var$li(4, 4, a, b);
}
function $0cfcca548ca5090c$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0cfcca548ca5090c$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0cfcca548ca5090c$var$li(4, 4, $0cfcca548ca5090c$var$pi.bind(null, b, a), c);
}
function $0cfcca548ca5090c$var$ri() {}
function $0cfcca548ca5090c$var$si(a, b) {
    var c = $0cfcca548ca5090c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0cfcca548ca5090c$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0cfcca548ca5090c$var$ti(a, b) {
    var c = $0cfcca548ca5090c$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0cfcca548ca5090c$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0cfcca548ca5090c$var$ui(a, b, c) {
    if (0 === ($0cfcca548ca5090c$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0cfcca548ca5090c$var$dh = !0), a.memoizedState = c;
    $0cfcca548ca5090c$var$He(c, b) || (c = $0cfcca548ca5090c$var$yc(), $0cfcca548ca5090c$var$M.lanes |= c, $0cfcca548ca5090c$var$rh |= c, a.baseState = !0);
    return b;
}
function $0cfcca548ca5090c$var$vi(a, b) {
    var c = $0cfcca548ca5090c$var$C;
    $0cfcca548ca5090c$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0cfcca548ca5090c$var$Gh.transition;
    $0cfcca548ca5090c$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0cfcca548ca5090c$var$C = c, $0cfcca548ca5090c$var$Gh.transition = d;
    }
}
function $0cfcca548ca5090c$var$wi() {
    return $0cfcca548ca5090c$var$Uh().memoizedState;
}
function $0cfcca548ca5090c$var$xi(a, b, c) {
    var d = $0cfcca548ca5090c$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0cfcca548ca5090c$var$zi(a)) $0cfcca548ca5090c$var$Ai(b, c);
    else if (c = $0cfcca548ca5090c$var$hh(a, b, c, d), null !== c) {
        var e = $0cfcca548ca5090c$var$R();
        $0cfcca548ca5090c$var$gi(c, a, d, e);
        $0cfcca548ca5090c$var$Bi(c, b, d);
    }
}
function $0cfcca548ca5090c$var$ii(a, b, c) {
    var d = $0cfcca548ca5090c$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0cfcca548ca5090c$var$zi(a)) $0cfcca548ca5090c$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0cfcca548ca5090c$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0cfcca548ca5090c$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0cfcca548ca5090c$var$hh(a, b, e, d);
        null !== c && (e = $0cfcca548ca5090c$var$R(), $0cfcca548ca5090c$var$gi(c, a, d, e), $0cfcca548ca5090c$var$Bi(c, b, d));
    }
}
function $0cfcca548ca5090c$var$zi(a) {
    var b = a.alternate;
    return a === $0cfcca548ca5090c$var$M || null !== b && b === $0cfcca548ca5090c$var$M;
}
function $0cfcca548ca5090c$var$Ai(a, b) {
    $0cfcca548ca5090c$var$Jh = $0cfcca548ca5090c$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0cfcca548ca5090c$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0cfcca548ca5090c$var$Cc(a, c);
    }
}
var $0cfcca548ca5090c$var$Rh = {
    readContext: $0cfcca548ca5090c$var$eh,
    useCallback: $0cfcca548ca5090c$var$P,
    useContext: $0cfcca548ca5090c$var$P,
    useEffect: $0cfcca548ca5090c$var$P,
    useImperativeHandle: $0cfcca548ca5090c$var$P,
    useInsertionEffect: $0cfcca548ca5090c$var$P,
    useLayoutEffect: $0cfcca548ca5090c$var$P,
    useMemo: $0cfcca548ca5090c$var$P,
    useReducer: $0cfcca548ca5090c$var$P,
    useRef: $0cfcca548ca5090c$var$P,
    useState: $0cfcca548ca5090c$var$P,
    useDebugValue: $0cfcca548ca5090c$var$P,
    useDeferredValue: $0cfcca548ca5090c$var$P,
    useTransition: $0cfcca548ca5090c$var$P,
    useMutableSource: $0cfcca548ca5090c$var$P,
    useSyncExternalStore: $0cfcca548ca5090c$var$P,
    useId: $0cfcca548ca5090c$var$P,
    unstable_isNewReconciler: !1
}, $0cfcca548ca5090c$var$Oh = {
    readContext: $0cfcca548ca5090c$var$eh,
    useCallback: function(a, b) {
        $0cfcca548ca5090c$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0cfcca548ca5090c$var$eh,
    useEffect: $0cfcca548ca5090c$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0cfcca548ca5090c$var$ki(4194308, 4, $0cfcca548ca5090c$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0cfcca548ca5090c$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0cfcca548ca5090c$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0cfcca548ca5090c$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0cfcca548ca5090c$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0cfcca548ca5090c$var$xi.bind(null, $0cfcca548ca5090c$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0cfcca548ca5090c$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0cfcca548ca5090c$var$hi,
    useDebugValue: $0cfcca548ca5090c$var$ri,
    useDeferredValue: function(a) {
        return $0cfcca548ca5090c$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0cfcca548ca5090c$var$hi(!1), b = a[0];
        a = $0cfcca548ca5090c$var$vi.bind(null, a[1]);
        $0cfcca548ca5090c$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0cfcca548ca5090c$var$M, e = $0cfcca548ca5090c$var$Th();
        if ($0cfcca548ca5090c$var$I) {
            if (void 0 === c) throw Error($0cfcca548ca5090c$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0cfcca548ca5090c$var$Q) throw Error($0cfcca548ca5090c$var$p(349));
            0 !== ($0cfcca548ca5090c$var$Hh & 30) || $0cfcca548ca5090c$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0cfcca548ca5090c$var$mi($0cfcca548ca5090c$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0cfcca548ca5090c$var$bi(9, $0cfcca548ca5090c$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0cfcca548ca5090c$var$Th(), b = $0cfcca548ca5090c$var$Q.identifierPrefix;
        if ($0cfcca548ca5090c$var$I) {
            var c = $0cfcca548ca5090c$var$sg;
            var d = $0cfcca548ca5090c$var$rg;
            c = (d & ~(1 << 32 - $0cfcca548ca5090c$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0cfcca548ca5090c$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0cfcca548ca5090c$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0cfcca548ca5090c$var$Ph = {
    readContext: $0cfcca548ca5090c$var$eh,
    useCallback: $0cfcca548ca5090c$var$si,
    useContext: $0cfcca548ca5090c$var$eh,
    useEffect: $0cfcca548ca5090c$var$$h,
    useImperativeHandle: $0cfcca548ca5090c$var$qi,
    useInsertionEffect: $0cfcca548ca5090c$var$ni,
    useLayoutEffect: $0cfcca548ca5090c$var$oi,
    useMemo: $0cfcca548ca5090c$var$ti,
    useReducer: $0cfcca548ca5090c$var$Wh,
    useRef: $0cfcca548ca5090c$var$ji,
    useState: function() {
        return $0cfcca548ca5090c$var$Wh($0cfcca548ca5090c$var$Vh);
    },
    useDebugValue: $0cfcca548ca5090c$var$ri,
    useDeferredValue: function(a) {
        var b = $0cfcca548ca5090c$var$Uh();
        return $0cfcca548ca5090c$var$ui(b, $0cfcca548ca5090c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0cfcca548ca5090c$var$Wh($0cfcca548ca5090c$var$Vh)[0], b = $0cfcca548ca5090c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0cfcca548ca5090c$var$Yh,
    useSyncExternalStore: $0cfcca548ca5090c$var$Zh,
    useId: $0cfcca548ca5090c$var$wi,
    unstable_isNewReconciler: !1
}, $0cfcca548ca5090c$var$Qh = {
    readContext: $0cfcca548ca5090c$var$eh,
    useCallback: $0cfcca548ca5090c$var$si,
    useContext: $0cfcca548ca5090c$var$eh,
    useEffect: $0cfcca548ca5090c$var$$h,
    useImperativeHandle: $0cfcca548ca5090c$var$qi,
    useInsertionEffect: $0cfcca548ca5090c$var$ni,
    useLayoutEffect: $0cfcca548ca5090c$var$oi,
    useMemo: $0cfcca548ca5090c$var$ti,
    useReducer: $0cfcca548ca5090c$var$Xh,
    useRef: $0cfcca548ca5090c$var$ji,
    useState: function() {
        return $0cfcca548ca5090c$var$Xh($0cfcca548ca5090c$var$Vh);
    },
    useDebugValue: $0cfcca548ca5090c$var$ri,
    useDeferredValue: function(a) {
        var b = $0cfcca548ca5090c$var$Uh();
        return null === $0cfcca548ca5090c$var$N ? b.memoizedState = a : $0cfcca548ca5090c$var$ui(b, $0cfcca548ca5090c$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0cfcca548ca5090c$var$Xh($0cfcca548ca5090c$var$Vh)[0], b = $0cfcca548ca5090c$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0cfcca548ca5090c$var$Yh,
    useSyncExternalStore: $0cfcca548ca5090c$var$Zh,
    useId: $0cfcca548ca5090c$var$wi,
    unstable_isNewReconciler: !1
};
function $0cfcca548ca5090c$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0cfcca548ca5090c$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0cfcca548ca5090c$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0cfcca548ca5090c$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0cfcca548ca5090c$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0cfcca548ca5090c$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0cfcca548ca5090c$var$R(), e = $0cfcca548ca5090c$var$yi(a), f = $0cfcca548ca5090c$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0cfcca548ca5090c$var$nh(a, f, e);
        null !== b && ($0cfcca548ca5090c$var$gi(b, a, e, d), $0cfcca548ca5090c$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0cfcca548ca5090c$var$R(), e = $0cfcca548ca5090c$var$yi(a), f = $0cfcca548ca5090c$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0cfcca548ca5090c$var$nh(a, f, e);
        null !== b && ($0cfcca548ca5090c$var$gi(b, a, e, d), $0cfcca548ca5090c$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0cfcca548ca5090c$var$R(), d = $0cfcca548ca5090c$var$yi(a), e = $0cfcca548ca5090c$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0cfcca548ca5090c$var$nh(a, e, d);
        null !== b && ($0cfcca548ca5090c$var$gi(b, a, d, c), $0cfcca548ca5090c$var$oh(b, a, d));
    }
};
function $0cfcca548ca5090c$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0cfcca548ca5090c$var$Ie(c, d) || !$0cfcca548ca5090c$var$Ie(e, f) : !0;
}
function $0cfcca548ca5090c$var$Gi(a, b, c) {
    var d = !1, e = $0cfcca548ca5090c$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0cfcca548ca5090c$var$eh(f) : (e = $0cfcca548ca5090c$var$Zf(b) ? $0cfcca548ca5090c$var$Xf : $0cfcca548ca5090c$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0cfcca548ca5090c$var$Yf(a, e) : $0cfcca548ca5090c$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0cfcca548ca5090c$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0cfcca548ca5090c$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0cfcca548ca5090c$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0cfcca548ca5090c$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0cfcca548ca5090c$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0cfcca548ca5090c$var$eh(f) : (f = $0cfcca548ca5090c$var$Zf(b) ? $0cfcca548ca5090c$var$Xf : $0cfcca548ca5090c$var$H.current, e.context = $0cfcca548ca5090c$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0cfcca548ca5090c$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0cfcca548ca5090c$var$Ei.enqueueReplaceState(e, e.state, null), $0cfcca548ca5090c$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0cfcca548ca5090c$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0cfcca548ca5090c$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0cfcca548ca5090c$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0cfcca548ca5090c$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0cfcca548ca5090c$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0cfcca548ca5090c$var$Ni(a, b, c) {
    c = $0cfcca548ca5090c$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0cfcca548ca5090c$var$Oi || ($0cfcca548ca5090c$var$Oi = !0, $0cfcca548ca5090c$var$Pi = d);
        $0cfcca548ca5090c$var$Li(a, b);
    };
    return c;
}
function $0cfcca548ca5090c$var$Qi(a, b, c) {
    c = $0cfcca548ca5090c$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0cfcca548ca5090c$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0cfcca548ca5090c$var$Li(a, b);
        "function" !== typeof d && (null === $0cfcca548ca5090c$var$Ri ? $0cfcca548ca5090c$var$Ri = new Set([
            this
        ]) : $0cfcca548ca5090c$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0cfcca548ca5090c$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0cfcca548ca5090c$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0cfcca548ca5090c$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0cfcca548ca5090c$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0cfcca548ca5090c$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0cfcca548ca5090c$var$mh(-1, 1), b.tag = 2, $0cfcca548ca5090c$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0cfcca548ca5090c$var$Wi = $0cfcca548ca5090c$var$ua.ReactCurrentOwner, $0cfcca548ca5090c$var$dh = !1;
function $0cfcca548ca5090c$var$Xi(a, b, c, d) {
    b.child = null === a ? $0cfcca548ca5090c$var$Vg(b, null, c, d) : $0cfcca548ca5090c$var$Ug(b, a.child, c, d);
}
function $0cfcca548ca5090c$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0cfcca548ca5090c$var$ch(b, e);
    d = $0cfcca548ca5090c$var$Nh(a, b, c, d, f, e);
    c = $0cfcca548ca5090c$var$Sh();
    if (null !== a && !$0cfcca548ca5090c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0cfcca548ca5090c$var$Zi(a, b, e);
    $0cfcca548ca5090c$var$I && c && $0cfcca548ca5090c$var$vg(b);
    b.flags |= 1;
    $0cfcca548ca5090c$var$Xi(a, b, d, e);
    return b.child;
}
function $0cfcca548ca5090c$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0cfcca548ca5090c$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0cfcca548ca5090c$var$bj(a, b, f, d, e);
        a = $0cfcca548ca5090c$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0cfcca548ca5090c$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0cfcca548ca5090c$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0cfcca548ca5090c$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0cfcca548ca5090c$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0cfcca548ca5090c$var$Ie(f, d) && a.ref === b.ref) {
            if ($0cfcca548ca5090c$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0cfcca548ca5090c$var$dh = !0);
            else return b.lanes = a.lanes, $0cfcca548ca5090c$var$Zi(a, b, e);
        }
    }
    return $0cfcca548ca5090c$var$cj(a, b, c, d, e);
}
function $0cfcca548ca5090c$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$ej, $0cfcca548ca5090c$var$fj), $0cfcca548ca5090c$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$ej, $0cfcca548ca5090c$var$fj), $0cfcca548ca5090c$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$ej, $0cfcca548ca5090c$var$fj);
            $0cfcca548ca5090c$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$ej, $0cfcca548ca5090c$var$fj), $0cfcca548ca5090c$var$fj |= d;
    $0cfcca548ca5090c$var$Xi(a, b, e, c);
    return b.child;
}
function $0cfcca548ca5090c$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0cfcca548ca5090c$var$cj(a, b, c, d, e) {
    var f = $0cfcca548ca5090c$var$Zf(c) ? $0cfcca548ca5090c$var$Xf : $0cfcca548ca5090c$var$H.current;
    f = $0cfcca548ca5090c$var$Yf(b, f);
    $0cfcca548ca5090c$var$ch(b, e);
    c = $0cfcca548ca5090c$var$Nh(a, b, c, d, f, e);
    d = $0cfcca548ca5090c$var$Sh();
    if (null !== a && !$0cfcca548ca5090c$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0cfcca548ca5090c$var$Zi(a, b, e);
    $0cfcca548ca5090c$var$I && d && $0cfcca548ca5090c$var$vg(b);
    b.flags |= 1;
    $0cfcca548ca5090c$var$Xi(a, b, c, e);
    return b.child;
}
function $0cfcca548ca5090c$var$hj(a, b, c, d, e) {
    if ($0cfcca548ca5090c$var$Zf(c)) {
        var f = !0;
        $0cfcca548ca5090c$var$cg(b);
    } else f = !1;
    $0cfcca548ca5090c$var$ch(b, e);
    if (null === b.stateNode) $0cfcca548ca5090c$var$ij(a, b), $0cfcca548ca5090c$var$Gi(b, c, d), $0cfcca548ca5090c$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0cfcca548ca5090c$var$eh(l) : (l = $0cfcca548ca5090c$var$Zf(c) ? $0cfcca548ca5090c$var$Xf : $0cfcca548ca5090c$var$H.current, l = $0cfcca548ca5090c$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0cfcca548ca5090c$var$Hi(b, g, d, l);
        $0cfcca548ca5090c$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0cfcca548ca5090c$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0cfcca548ca5090c$var$Wf.current || $0cfcca548ca5090c$var$jh ? ("function" === typeof m && ($0cfcca548ca5090c$var$Di(b, c, m, d), k = b.memoizedState), (h = $0cfcca548ca5090c$var$jh || $0cfcca548ca5090c$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0cfcca548ca5090c$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0cfcca548ca5090c$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0cfcca548ca5090c$var$eh(k) : (k = $0cfcca548ca5090c$var$Zf(c) ? $0cfcca548ca5090c$var$Xf : $0cfcca548ca5090c$var$H.current, k = $0cfcca548ca5090c$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0cfcca548ca5090c$var$Hi(b, g, d, k);
        $0cfcca548ca5090c$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0cfcca548ca5090c$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0cfcca548ca5090c$var$Wf.current || $0cfcca548ca5090c$var$jh ? ("function" === typeof y && ($0cfcca548ca5090c$var$Di(b, c, y, d), n = b.memoizedState), (l = $0cfcca548ca5090c$var$jh || $0cfcca548ca5090c$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0cfcca548ca5090c$var$jj(a, b, c, d, f, e);
}
function $0cfcca548ca5090c$var$jj(a, b, c, d, e, f) {
    $0cfcca548ca5090c$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0cfcca548ca5090c$var$dg(b, c, !1), $0cfcca548ca5090c$var$Zi(a, b, f);
    d = b.stateNode;
    $0cfcca548ca5090c$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0cfcca548ca5090c$var$Ug(b, a.child, null, f), b.child = $0cfcca548ca5090c$var$Ug(b, null, h, f)) : $0cfcca548ca5090c$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0cfcca548ca5090c$var$dg(b, c, !0);
    return b.child;
}
function $0cfcca548ca5090c$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0cfcca548ca5090c$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0cfcca548ca5090c$var$ag(a, b.context, !1);
    $0cfcca548ca5090c$var$yh(a, b.containerInfo);
}
function $0cfcca548ca5090c$var$lj(a, b, c, d, e) {
    $0cfcca548ca5090c$var$Ig();
    $0cfcca548ca5090c$var$Jg(e);
    b.flags |= 256;
    $0cfcca548ca5090c$var$Xi(a, b, c, d);
    return b.child;
}
var $0cfcca548ca5090c$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0cfcca548ca5090c$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0cfcca548ca5090c$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0cfcca548ca5090c$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, e & 1);
    if (null === a) {
        $0cfcca548ca5090c$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0cfcca548ca5090c$var$pj(g, d, 0, null), a = $0cfcca548ca5090c$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0cfcca548ca5090c$var$nj(c), b.memoizedState = $0cfcca548ca5090c$var$mj, a) : $0cfcca548ca5090c$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0cfcca548ca5090c$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0cfcca548ca5090c$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0cfcca548ca5090c$var$Pg(h, f) : (f = $0cfcca548ca5090c$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0cfcca548ca5090c$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0cfcca548ca5090c$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0cfcca548ca5090c$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0cfcca548ca5090c$var$qj(a, b) {
    b = $0cfcca548ca5090c$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0cfcca548ca5090c$var$sj(a, b, c, d) {
    null !== d && $0cfcca548ca5090c$var$Jg(d);
    $0cfcca548ca5090c$var$Ug(b, a.child, null, c);
    a = $0cfcca548ca5090c$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0cfcca548ca5090c$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0cfcca548ca5090c$var$Ki(Error($0cfcca548ca5090c$var$p(422))), $0cfcca548ca5090c$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0cfcca548ca5090c$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0cfcca548ca5090c$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0cfcca548ca5090c$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0cfcca548ca5090c$var$nj(g);
        b.memoizedState = $0cfcca548ca5090c$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0cfcca548ca5090c$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0cfcca548ca5090c$var$p(419));
        d = $0cfcca548ca5090c$var$Ki(f, d, void 0);
        return $0cfcca548ca5090c$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0cfcca548ca5090c$var$dh || h) {
        d = $0cfcca548ca5090c$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0cfcca548ca5090c$var$ih(a, e), $0cfcca548ca5090c$var$gi(d, a, e, -1));
        }
        $0cfcca548ca5090c$var$tj();
        d = $0cfcca548ca5090c$var$Ki(Error($0cfcca548ca5090c$var$p(421)));
        return $0cfcca548ca5090c$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0cfcca548ca5090c$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$Lf(e.nextSibling);
    $0cfcca548ca5090c$var$xg = b;
    $0cfcca548ca5090c$var$I = !0;
    $0cfcca548ca5090c$var$zg = null;
    null !== a && ($0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$rg, $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$sg, $0cfcca548ca5090c$var$og[$0cfcca548ca5090c$var$pg++] = $0cfcca548ca5090c$var$qg, $0cfcca548ca5090c$var$rg = a.id, $0cfcca548ca5090c$var$sg = a.overflow, $0cfcca548ca5090c$var$qg = b);
    b = $0cfcca548ca5090c$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0cfcca548ca5090c$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0cfcca548ca5090c$var$bh(a.return, b, c);
}
function $0cfcca548ca5090c$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0cfcca548ca5090c$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0cfcca548ca5090c$var$Xi(a, b, d.children, c);
    d = $0cfcca548ca5090c$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0cfcca548ca5090c$var$vj(a, c, b);
            else if (19 === a.tag) $0cfcca548ca5090c$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0cfcca548ca5090c$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0cfcca548ca5090c$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0cfcca548ca5090c$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0cfcca548ca5090c$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0cfcca548ca5090c$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0cfcca548ca5090c$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0cfcca548ca5090c$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0cfcca548ca5090c$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0cfcca548ca5090c$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0cfcca548ca5090c$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0cfcca548ca5090c$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0cfcca548ca5090c$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0cfcca548ca5090c$var$kj(b);
            $0cfcca548ca5090c$var$Ig();
            break;
        case 5:
            $0cfcca548ca5090c$var$Ah(b);
            break;
        case 1:
            $0cfcca548ca5090c$var$Zf(b.type) && $0cfcca548ca5090c$var$cg(b);
            break;
        case 4:
            $0cfcca548ca5090c$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, $0cfcca548ca5090c$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0cfcca548ca5090c$var$oj(a, b, c);
                $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, $0cfcca548ca5090c$var$L.current & 1);
                a = $0cfcca548ca5090c$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, $0cfcca548ca5090c$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0cfcca548ca5090c$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, $0cfcca548ca5090c$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0cfcca548ca5090c$var$dj(a, b, c);
    }
    return $0cfcca548ca5090c$var$Zi(a, b, c);
}
var $0cfcca548ca5090c$var$zj, $0cfcca548ca5090c$var$Aj, $0cfcca548ca5090c$var$Bj, $0cfcca548ca5090c$var$Cj;
$0cfcca548ca5090c$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0cfcca548ca5090c$var$Aj = function() {};
$0cfcca548ca5090c$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0cfcca548ca5090c$var$Ya(a, e);
                d = $0cfcca548ca5090c$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0cfcca548ca5090c$var$A({}, e, {
                    value: void 0
                });
                d = $0cfcca548ca5090c$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0cfcca548ca5090c$var$gb(a, e);
                d = $0cfcca548ca5090c$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0cfcca548ca5090c$var$Bf);
        }
        $0cfcca548ca5090c$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0cfcca548ca5090c$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0cfcca548ca5090c$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0cfcca548ca5090c$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0cfcca548ca5090c$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0cfcca548ca5090c$var$Dj(a, b) {
    if (!$0cfcca548ca5090c$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0cfcca548ca5090c$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0cfcca548ca5090c$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0cfcca548ca5090c$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0cfcca548ca5090c$var$S(b), null;
        case 1:
            return $0cfcca548ca5090c$var$Zf(b.type) && $0cfcca548ca5090c$var$$f(), $0cfcca548ca5090c$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0cfcca548ca5090c$var$zh();
            $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf);
            $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$H);
            $0cfcca548ca5090c$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0cfcca548ca5090c$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0cfcca548ca5090c$var$zg && ($0cfcca548ca5090c$var$Fj($0cfcca548ca5090c$var$zg), $0cfcca548ca5090c$var$zg = null));
            $0cfcca548ca5090c$var$Aj(a, b);
            $0cfcca548ca5090c$var$S(b);
            return null;
        case 5:
            $0cfcca548ca5090c$var$Bh(b);
            var e = $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0cfcca548ca5090c$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0cfcca548ca5090c$var$p(166));
                    $0cfcca548ca5090c$var$S(b);
                    return null;
                }
                a = $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$uh.current);
                if ($0cfcca548ca5090c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0cfcca548ca5090c$var$Of] = b;
                    d[$0cfcca548ca5090c$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0cfcca548ca5090c$var$D("cancel", d);
                            $0cfcca548ca5090c$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0cfcca548ca5090c$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0cfcca548ca5090c$var$lf.length; e++)$0cfcca548ca5090c$var$D($0cfcca548ca5090c$var$lf[e], d);
                            break;
                        case "source":
                            $0cfcca548ca5090c$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0cfcca548ca5090c$var$D("error", d);
                            $0cfcca548ca5090c$var$D("load", d);
                            break;
                        case "details":
                            $0cfcca548ca5090c$var$D("toggle", d);
                            break;
                        case "input":
                            $0cfcca548ca5090c$var$Za(d, f);
                            $0cfcca548ca5090c$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0cfcca548ca5090c$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0cfcca548ca5090c$var$hb(d, f), $0cfcca548ca5090c$var$D("invalid", d);
                    }
                    $0cfcca548ca5090c$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0cfcca548ca5090c$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0cfcca548ca5090c$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0cfcca548ca5090c$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0cfcca548ca5090c$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0cfcca548ca5090c$var$Va(d);
                            $0cfcca548ca5090c$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0cfcca548ca5090c$var$Va(d);
                            $0cfcca548ca5090c$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0cfcca548ca5090c$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0cfcca548ca5090c$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0cfcca548ca5090c$var$Of] = b;
                    a[$0cfcca548ca5090c$var$Pf] = d;
                    $0cfcca548ca5090c$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0cfcca548ca5090c$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0cfcca548ca5090c$var$D("cancel", a);
                                $0cfcca548ca5090c$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0cfcca548ca5090c$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0cfcca548ca5090c$var$lf.length; e++)$0cfcca548ca5090c$var$D($0cfcca548ca5090c$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0cfcca548ca5090c$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0cfcca548ca5090c$var$D("error", a);
                                $0cfcca548ca5090c$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0cfcca548ca5090c$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0cfcca548ca5090c$var$Za(a, d);
                                e = $0cfcca548ca5090c$var$Ya(a, d);
                                $0cfcca548ca5090c$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0cfcca548ca5090c$var$A({}, d, {
                                    value: void 0
                                });
                                $0cfcca548ca5090c$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0cfcca548ca5090c$var$hb(a, d);
                                e = $0cfcca548ca5090c$var$gb(a, d);
                                $0cfcca548ca5090c$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0cfcca548ca5090c$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0cfcca548ca5090c$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0cfcca548ca5090c$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0cfcca548ca5090c$var$ob(a, k) : "number" === typeof k && $0cfcca548ca5090c$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0cfcca548ca5090c$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0cfcca548ca5090c$var$D("scroll", a) : null != k && $0cfcca548ca5090c$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0cfcca548ca5090c$var$Va(a);
                                $0cfcca548ca5090c$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0cfcca548ca5090c$var$Va(a);
                                $0cfcca548ca5090c$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0cfcca548ca5090c$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0cfcca548ca5090c$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0cfcca548ca5090c$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0cfcca548ca5090c$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0cfcca548ca5090c$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0cfcca548ca5090c$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0cfcca548ca5090c$var$p(166));
                c = $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$wh.current);
                $0cfcca548ca5090c$var$xh($0cfcca548ca5090c$var$uh.current);
                if ($0cfcca548ca5090c$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0cfcca548ca5090c$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0cfcca548ca5090c$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0cfcca548ca5090c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0cfcca548ca5090c$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0cfcca548ca5090c$var$Of] = b, b.stateNode = d;
            }
            $0cfcca548ca5090c$var$S(b);
            return null;
        case 13:
            $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0cfcca548ca5090c$var$I && null !== $0cfcca548ca5090c$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0cfcca548ca5090c$var$Hg(), $0cfcca548ca5090c$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0cfcca548ca5090c$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0cfcca548ca5090c$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0cfcca548ca5090c$var$p(317));
                        f[$0cfcca548ca5090c$var$Of] = b;
                    } else $0cfcca548ca5090c$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0cfcca548ca5090c$var$S(b);
                    f = !1;
                } else null !== $0cfcca548ca5090c$var$zg && ($0cfcca548ca5090c$var$Fj($0cfcca548ca5090c$var$zg), $0cfcca548ca5090c$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0cfcca548ca5090c$var$L.current & 1) ? 0 === $0cfcca548ca5090c$var$T && ($0cfcca548ca5090c$var$T = 3) : $0cfcca548ca5090c$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0cfcca548ca5090c$var$S(b);
            return null;
        case 4:
            return $0cfcca548ca5090c$var$zh(), $0cfcca548ca5090c$var$Aj(a, b), null === a && $0cfcca548ca5090c$var$sf(b.stateNode.containerInfo), $0cfcca548ca5090c$var$S(b), null;
        case 10:
            return $0cfcca548ca5090c$var$ah(b.type._context), $0cfcca548ca5090c$var$S(b), null;
        case 17:
            return $0cfcca548ca5090c$var$Zf(b.type) && $0cfcca548ca5090c$var$$f(), $0cfcca548ca5090c$var$S(b), null;
        case 19:
            $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L);
            f = b.memoizedState;
            if (null === f) return $0cfcca548ca5090c$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0cfcca548ca5090c$var$Dj(f, !1);
                else {
                    if (0 !== $0cfcca548ca5090c$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0cfcca548ca5090c$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0cfcca548ca5090c$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, $0cfcca548ca5090c$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0cfcca548ca5090c$var$B() > $0cfcca548ca5090c$var$Gj && (b.flags |= 128, d = !0, $0cfcca548ca5090c$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0cfcca548ca5090c$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0cfcca548ca5090c$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0cfcca548ca5090c$var$I) return $0cfcca548ca5090c$var$S(b), null;
                    } else 2 * $0cfcca548ca5090c$var$B() - f.renderingStartTime > $0cfcca548ca5090c$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0cfcca548ca5090c$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0cfcca548ca5090c$var$B(), b.sibling = null, c = $0cfcca548ca5090c$var$L.current, $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$L, d ? c & 1 | 2 : c & 1), b;
            $0cfcca548ca5090c$var$S(b);
            return null;
        case 22:
        case 23:
            return $0cfcca548ca5090c$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0cfcca548ca5090c$var$fj & 1073741824) && ($0cfcca548ca5090c$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0cfcca548ca5090c$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0cfcca548ca5090c$var$p(156, b.tag));
}
function $0cfcca548ca5090c$var$Ij(a, b) {
    $0cfcca548ca5090c$var$wg(b);
    switch(b.tag){
        case 1:
            return $0cfcca548ca5090c$var$Zf(b.type) && $0cfcca548ca5090c$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0cfcca548ca5090c$var$zh(), $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf), $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$H), $0cfcca548ca5090c$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0cfcca548ca5090c$var$Bh(b), null;
        case 13:
            $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0cfcca548ca5090c$var$p(340));
                $0cfcca548ca5090c$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L), null;
        case 4:
            return $0cfcca548ca5090c$var$zh(), null;
        case 10:
            return $0cfcca548ca5090c$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0cfcca548ca5090c$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0cfcca548ca5090c$var$Jj = !1, $0cfcca548ca5090c$var$U = !1, $0cfcca548ca5090c$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0cfcca548ca5090c$var$V = null;
function $0cfcca548ca5090c$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0cfcca548ca5090c$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0cfcca548ca5090c$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0cfcca548ca5090c$var$W(a, b, d);
    }
}
var $0cfcca548ca5090c$var$Nj = !1;
function $0cfcca548ca5090c$var$Oj(a, b) {
    $0cfcca548ca5090c$var$Cf = $0cfcca548ca5090c$var$dd;
    a = $0cfcca548ca5090c$var$Me();
    if ($0cfcca548ca5090c$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0cfcca548ca5090c$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0cfcca548ca5090c$var$dd = !1;
    for($0cfcca548ca5090c$var$V = b; null !== $0cfcca548ca5090c$var$V;)if (b = $0cfcca548ca5090c$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0cfcca548ca5090c$var$V = a;
    else for(; null !== $0cfcca548ca5090c$var$V;){
        b = $0cfcca548ca5090c$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0cfcca548ca5090c$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0cfcca548ca5090c$var$p(163));
            }
        } catch (F) {
            $0cfcca548ca5090c$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0cfcca548ca5090c$var$V = a;
            break;
        }
        $0cfcca548ca5090c$var$V = b.return;
    }
    n = $0cfcca548ca5090c$var$Nj;
    $0cfcca548ca5090c$var$Nj = !1;
    return n;
}
function $0cfcca548ca5090c$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0cfcca548ca5090c$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0cfcca548ca5090c$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0cfcca548ca5090c$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0cfcca548ca5090c$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0cfcca548ca5090c$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0cfcca548ca5090c$var$Of], delete b[$0cfcca548ca5090c$var$Pf], delete b[$0cfcca548ca5090c$var$of], delete b[$0cfcca548ca5090c$var$Qf], delete b[$0cfcca548ca5090c$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0cfcca548ca5090c$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0cfcca548ca5090c$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0cfcca548ca5090c$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0cfcca548ca5090c$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0cfcca548ca5090c$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0cfcca548ca5090c$var$Vj(a, b, c), a = a.sibling; null !== a;)$0cfcca548ca5090c$var$Vj(a, b, c), a = a.sibling;
}
function $0cfcca548ca5090c$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0cfcca548ca5090c$var$Wj(a, b, c), a = a.sibling; null !== a;)$0cfcca548ca5090c$var$Wj(a, b, c), a = a.sibling;
}
var $0cfcca548ca5090c$var$X = null, $0cfcca548ca5090c$var$Xj = !1;
function $0cfcca548ca5090c$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0cfcca548ca5090c$var$Zj(a, b, c), c = c.sibling;
}
function $0cfcca548ca5090c$var$Zj(a, b, c) {
    if ($0cfcca548ca5090c$var$lc && "function" === typeof $0cfcca548ca5090c$var$lc.onCommitFiberUnmount) try {
        $0cfcca548ca5090c$var$lc.onCommitFiberUnmount($0cfcca548ca5090c$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0cfcca548ca5090c$var$U || $0cfcca548ca5090c$var$Lj(c, b);
        case 6:
            var d = $0cfcca548ca5090c$var$X, e = $0cfcca548ca5090c$var$Xj;
            $0cfcca548ca5090c$var$X = null;
            $0cfcca548ca5090c$var$Yj(a, b, c);
            $0cfcca548ca5090c$var$X = d;
            $0cfcca548ca5090c$var$Xj = e;
            null !== $0cfcca548ca5090c$var$X && ($0cfcca548ca5090c$var$Xj ? (a = $0cfcca548ca5090c$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0cfcca548ca5090c$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0cfcca548ca5090c$var$X && ($0cfcca548ca5090c$var$Xj ? (a = $0cfcca548ca5090c$var$X, c = c.stateNode, 8 === a.nodeType ? $0cfcca548ca5090c$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0cfcca548ca5090c$var$Kf(a, c), $0cfcca548ca5090c$var$bd(a)) : $0cfcca548ca5090c$var$Kf($0cfcca548ca5090c$var$X, c.stateNode));
            break;
        case 4:
            d = $0cfcca548ca5090c$var$X;
            e = $0cfcca548ca5090c$var$Xj;
            $0cfcca548ca5090c$var$X = c.stateNode.containerInfo;
            $0cfcca548ca5090c$var$Xj = !0;
            $0cfcca548ca5090c$var$Yj(a, b, c);
            $0cfcca548ca5090c$var$X = d;
            $0cfcca548ca5090c$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0cfcca548ca5090c$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0cfcca548ca5090c$var$Mj(c, b, g) : 0 !== (f & 4) && $0cfcca548ca5090c$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0cfcca548ca5090c$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0cfcca548ca5090c$var$U && ($0cfcca548ca5090c$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0cfcca548ca5090c$var$W(c, b, h);
            }
            $0cfcca548ca5090c$var$Yj(a, b, c);
            break;
        case 21:
            $0cfcca548ca5090c$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0cfcca548ca5090c$var$U = (d = $0cfcca548ca5090c$var$U) || null !== c.memoizedState, $0cfcca548ca5090c$var$Yj(a, b, c), $0cfcca548ca5090c$var$U = d) : $0cfcca548ca5090c$var$Yj(a, b, c);
            break;
        default:
            $0cfcca548ca5090c$var$Yj(a, b, c);
    }
}
function $0cfcca548ca5090c$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0cfcca548ca5090c$var$Kj);
        b.forEach(function(b) {
            var d = $0cfcca548ca5090c$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0cfcca548ca5090c$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0cfcca548ca5090c$var$X = h.stateNode;
                        $0cfcca548ca5090c$var$Xj = !1;
                        break a;
                    case 3:
                        $0cfcca548ca5090c$var$X = h.stateNode.containerInfo;
                        $0cfcca548ca5090c$var$Xj = !0;
                        break a;
                    case 4:
                        $0cfcca548ca5090c$var$X = h.stateNode.containerInfo;
                        $0cfcca548ca5090c$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0cfcca548ca5090c$var$X) throw Error($0cfcca548ca5090c$var$p(160));
            $0cfcca548ca5090c$var$Zj(f, g, e);
            $0cfcca548ca5090c$var$X = null;
            $0cfcca548ca5090c$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0cfcca548ca5090c$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0cfcca548ca5090c$var$dk(b, a), b = b.sibling;
}
function $0cfcca548ca5090c$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            if (d & 4) {
                try {
                    $0cfcca548ca5090c$var$Pj(3, a, a.return), $0cfcca548ca5090c$var$Qj(3, a);
                } catch (t) {
                    $0cfcca548ca5090c$var$W(a, a.return, t);
                }
                try {
                    $0cfcca548ca5090c$var$Pj(5, a, a.return);
                } catch (t) {
                    $0cfcca548ca5090c$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            d & 512 && null !== c && $0cfcca548ca5090c$var$Lj(c, c.return);
            break;
        case 5:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            d & 512 && null !== c && $0cfcca548ca5090c$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0cfcca548ca5090c$var$ob(e, "");
                } catch (t) {
                    $0cfcca548ca5090c$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0cfcca548ca5090c$var$ab(e, f);
                    $0cfcca548ca5090c$var$vb(h, g);
                    var l = $0cfcca548ca5090c$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0cfcca548ca5090c$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0cfcca548ca5090c$var$nb(e, q) : "children" === m ? $0cfcca548ca5090c$var$ob(e, q) : $0cfcca548ca5090c$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0cfcca548ca5090c$var$bb(e, f);
                            break;
                        case "textarea":
                            $0cfcca548ca5090c$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0cfcca548ca5090c$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0cfcca548ca5090c$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0cfcca548ca5090c$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0cfcca548ca5090c$var$Pf] = f;
                } catch (t) {
                    $0cfcca548ca5090c$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0cfcca548ca5090c$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0cfcca548ca5090c$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0cfcca548ca5090c$var$bd(b.containerInfo);
            } catch (t) {
                $0cfcca548ca5090c$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            break;
        case 13:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0cfcca548ca5090c$var$fk = $0cfcca548ca5090c$var$B()));
            d & 4 && $0cfcca548ca5090c$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0cfcca548ca5090c$var$U = (l = $0cfcca548ca5090c$var$U) || m, $0cfcca548ca5090c$var$ck(b, a), $0cfcca548ca5090c$var$U = l) : $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0cfcca548ca5090c$var$V = a, m = a.child; null !== m;){
                    for(q = $0cfcca548ca5090c$var$V = m; null !== $0cfcca548ca5090c$var$V;){
                        r = $0cfcca548ca5090c$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0cfcca548ca5090c$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0cfcca548ca5090c$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0cfcca548ca5090c$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0cfcca548ca5090c$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0cfcca548ca5090c$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0cfcca548ca5090c$var$V = y) : $0cfcca548ca5090c$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0cfcca548ca5090c$var$rb("display", g));
                            } catch (t) {
                                $0cfcca548ca5090c$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0cfcca548ca5090c$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0cfcca548ca5090c$var$ck(b, a);
            $0cfcca548ca5090c$var$ek(a);
            d & 4 && $0cfcca548ca5090c$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0cfcca548ca5090c$var$ck(b, a), $0cfcca548ca5090c$var$ek(a);
    }
}
function $0cfcca548ca5090c$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0cfcca548ca5090c$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0cfcca548ca5090c$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0cfcca548ca5090c$var$ob(e, ""), d.flags &= -33);
                    var f = $0cfcca548ca5090c$var$Uj(a);
                    $0cfcca548ca5090c$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0cfcca548ca5090c$var$Uj(a);
                    $0cfcca548ca5090c$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0cfcca548ca5090c$var$p(161));
            }
        } catch (k) {
            $0cfcca548ca5090c$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0cfcca548ca5090c$var$hk(a, b, c) {
    $0cfcca548ca5090c$var$V = a;
    $0cfcca548ca5090c$var$ik(a, b, c);
}
function $0cfcca548ca5090c$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0cfcca548ca5090c$var$V;){
        var e = $0cfcca548ca5090c$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0cfcca548ca5090c$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0cfcca548ca5090c$var$U;
                h = $0cfcca548ca5090c$var$Jj;
                var l = $0cfcca548ca5090c$var$U;
                $0cfcca548ca5090c$var$Jj = g;
                if (($0cfcca548ca5090c$var$U = k) && !l) for($0cfcca548ca5090c$var$V = e; null !== $0cfcca548ca5090c$var$V;)g = $0cfcca548ca5090c$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0cfcca548ca5090c$var$jk(e) : null !== k ? (k.return = g, $0cfcca548ca5090c$var$V = k) : $0cfcca548ca5090c$var$jk(e);
                for(; null !== f;)$0cfcca548ca5090c$var$V = f, $0cfcca548ca5090c$var$ik(f, b, c), f = f.sibling;
                $0cfcca548ca5090c$var$V = e;
                $0cfcca548ca5090c$var$Jj = h;
                $0cfcca548ca5090c$var$U = l;
            }
            $0cfcca548ca5090c$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0cfcca548ca5090c$var$V = f) : $0cfcca548ca5090c$var$kk(a, b, c);
    }
}
function $0cfcca548ca5090c$var$kk(a) {
    for(; null !== $0cfcca548ca5090c$var$V;){
        var b = $0cfcca548ca5090c$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0cfcca548ca5090c$var$U || $0cfcca548ca5090c$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0cfcca548ca5090c$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0cfcca548ca5090c$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0cfcca548ca5090c$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0cfcca548ca5090c$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0cfcca548ca5090c$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0cfcca548ca5090c$var$p(163));
                }
                $0cfcca548ca5090c$var$U || b.flags & 512 && $0cfcca548ca5090c$var$Rj(b);
            } catch (r) {
                $0cfcca548ca5090c$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0cfcca548ca5090c$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0cfcca548ca5090c$var$V = c;
            break;
        }
        $0cfcca548ca5090c$var$V = b.return;
    }
}
function $0cfcca548ca5090c$var$gk(a) {
    for(; null !== $0cfcca548ca5090c$var$V;){
        var b = $0cfcca548ca5090c$var$V;
        if (b === a) {
            $0cfcca548ca5090c$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0cfcca548ca5090c$var$V = c;
            break;
        }
        $0cfcca548ca5090c$var$V = b.return;
    }
}
function $0cfcca548ca5090c$var$jk(a) {
    for(; null !== $0cfcca548ca5090c$var$V;){
        var b = $0cfcca548ca5090c$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0cfcca548ca5090c$var$Qj(4, b);
                    } catch (k) {
                        $0cfcca548ca5090c$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0cfcca548ca5090c$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0cfcca548ca5090c$var$Rj(b);
                    } catch (k) {
                        $0cfcca548ca5090c$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0cfcca548ca5090c$var$Rj(b);
                    } catch (k) {
                        $0cfcca548ca5090c$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0cfcca548ca5090c$var$W(b, b.return, k);
        }
        if (b === a) {
            $0cfcca548ca5090c$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0cfcca548ca5090c$var$V = h;
            break;
        }
        $0cfcca548ca5090c$var$V = b.return;
    }
}
var $0cfcca548ca5090c$var$lk = Math.ceil, $0cfcca548ca5090c$var$mk = $0cfcca548ca5090c$var$ua.ReactCurrentDispatcher, $0cfcca548ca5090c$var$nk = $0cfcca548ca5090c$var$ua.ReactCurrentOwner, $0cfcca548ca5090c$var$ok = $0cfcca548ca5090c$var$ua.ReactCurrentBatchConfig, $0cfcca548ca5090c$var$K = 0, $0cfcca548ca5090c$var$Q = null, $0cfcca548ca5090c$var$Y = null, $0cfcca548ca5090c$var$Z = 0, $0cfcca548ca5090c$var$fj = 0, $0cfcca548ca5090c$var$ej = $0cfcca548ca5090c$var$Uf(0), $0cfcca548ca5090c$var$T = 0, $0cfcca548ca5090c$var$pk = null, $0cfcca548ca5090c$var$rh = 0, $0cfcca548ca5090c$var$qk = 0, $0cfcca548ca5090c$var$rk = 0, $0cfcca548ca5090c$var$sk = null, $0cfcca548ca5090c$var$tk = null, $0cfcca548ca5090c$var$fk = 0, $0cfcca548ca5090c$var$Gj = Infinity, $0cfcca548ca5090c$var$uk = null, $0cfcca548ca5090c$var$Oi = !1, $0cfcca548ca5090c$var$Pi = null, $0cfcca548ca5090c$var$Ri = null, $0cfcca548ca5090c$var$vk = !1, $0cfcca548ca5090c$var$wk = null, $0cfcca548ca5090c$var$xk = 0, $0cfcca548ca5090c$var$yk = 0, $0cfcca548ca5090c$var$zk = null, $0cfcca548ca5090c$var$Ak = -1, $0cfcca548ca5090c$var$Bk = 0;
function $0cfcca548ca5090c$var$R() {
    return 0 !== ($0cfcca548ca5090c$var$K & 6) ? $0cfcca548ca5090c$var$B() : -1 !== $0cfcca548ca5090c$var$Ak ? $0cfcca548ca5090c$var$Ak : $0cfcca548ca5090c$var$Ak = $0cfcca548ca5090c$var$B();
}
function $0cfcca548ca5090c$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0cfcca548ca5090c$var$K & 2) && 0 !== $0cfcca548ca5090c$var$Z) return $0cfcca548ca5090c$var$Z & -$0cfcca548ca5090c$var$Z;
    if (null !== $0cfcca548ca5090c$var$Kg.transition) return 0 === $0cfcca548ca5090c$var$Bk && ($0cfcca548ca5090c$var$Bk = $0cfcca548ca5090c$var$yc()), $0cfcca548ca5090c$var$Bk;
    a = $0cfcca548ca5090c$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0cfcca548ca5090c$var$jd(a.type);
    return a;
}
function $0cfcca548ca5090c$var$gi(a, b, c, d) {
    if (50 < $0cfcca548ca5090c$var$yk) throw $0cfcca548ca5090c$var$yk = 0, $0cfcca548ca5090c$var$zk = null, Error($0cfcca548ca5090c$var$p(185));
    $0cfcca548ca5090c$var$Ac(a, c, d);
    if (0 === ($0cfcca548ca5090c$var$K & 2) || a !== $0cfcca548ca5090c$var$Q) a === $0cfcca548ca5090c$var$Q && (0 === ($0cfcca548ca5090c$var$K & 2) && ($0cfcca548ca5090c$var$qk |= c), 4 === $0cfcca548ca5090c$var$T && $0cfcca548ca5090c$var$Ck(a, $0cfcca548ca5090c$var$Z)), $0cfcca548ca5090c$var$Dk(a, d), 1 === c && 0 === $0cfcca548ca5090c$var$K && 0 === (b.mode & 1) && ($0cfcca548ca5090c$var$Gj = $0cfcca548ca5090c$var$B() + 500, $0cfcca548ca5090c$var$fg && $0cfcca548ca5090c$var$jg());
}
function $0cfcca548ca5090c$var$Dk(a, b) {
    var c = a.callbackNode;
    $0cfcca548ca5090c$var$wc(a, b);
    var d = $0cfcca548ca5090c$var$uc(a, a === $0cfcca548ca5090c$var$Q ? $0cfcca548ca5090c$var$Z : 0);
    if (0 === d) null !== c && $0cfcca548ca5090c$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0cfcca548ca5090c$var$bc(c);
        if (1 === b) 0 === a.tag ? $0cfcca548ca5090c$var$ig($0cfcca548ca5090c$var$Ek.bind(null, a)) : $0cfcca548ca5090c$var$hg($0cfcca548ca5090c$var$Ek.bind(null, a)), $0cfcca548ca5090c$var$Jf(function() {
            0 === ($0cfcca548ca5090c$var$K & 6) && $0cfcca548ca5090c$var$jg();
        }), c = null;
        else {
            switch($0cfcca548ca5090c$var$Dc(d)){
                case 1:
                    c = $0cfcca548ca5090c$var$fc;
                    break;
                case 4:
                    c = $0cfcca548ca5090c$var$gc;
                    break;
                case 16:
                    c = $0cfcca548ca5090c$var$hc;
                    break;
                case 536870912:
                    c = $0cfcca548ca5090c$var$jc;
                    break;
                default:
                    c = $0cfcca548ca5090c$var$hc;
            }
            c = $0cfcca548ca5090c$var$Fk(c, $0cfcca548ca5090c$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0cfcca548ca5090c$var$Gk(a, b) {
    $0cfcca548ca5090c$var$Ak = -1;
    $0cfcca548ca5090c$var$Bk = 0;
    if (0 !== ($0cfcca548ca5090c$var$K & 6)) throw Error($0cfcca548ca5090c$var$p(327));
    var c = a.callbackNode;
    if ($0cfcca548ca5090c$var$Hk() && a.callbackNode !== c) return null;
    var d = $0cfcca548ca5090c$var$uc(a, a === $0cfcca548ca5090c$var$Q ? $0cfcca548ca5090c$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0cfcca548ca5090c$var$Ik(a, d);
    else {
        b = d;
        var e = $0cfcca548ca5090c$var$K;
        $0cfcca548ca5090c$var$K |= 2;
        var f = $0cfcca548ca5090c$var$Jk();
        if ($0cfcca548ca5090c$var$Q !== a || $0cfcca548ca5090c$var$Z !== b) $0cfcca548ca5090c$var$uk = null, $0cfcca548ca5090c$var$Gj = $0cfcca548ca5090c$var$B() + 500, $0cfcca548ca5090c$var$Kk(a, b);
        for(;;)try {
            $0cfcca548ca5090c$var$Lk();
            break;
        } catch (h) {
            $0cfcca548ca5090c$var$Mk(a, h);
        }
        $0cfcca548ca5090c$var$$g();
        $0cfcca548ca5090c$var$mk.current = f;
        $0cfcca548ca5090c$var$K = e;
        null !== $0cfcca548ca5090c$var$Y ? b = 0 : ($0cfcca548ca5090c$var$Q = null, $0cfcca548ca5090c$var$Z = 0, b = $0cfcca548ca5090c$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0cfcca548ca5090c$var$xc(a), 0 !== e && (d = e, b = $0cfcca548ca5090c$var$Nk(a, e)));
        if (1 === b) throw c = $0cfcca548ca5090c$var$pk, $0cfcca548ca5090c$var$Kk(a, 0), $0cfcca548ca5090c$var$Ck(a, d), $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B()), c;
        if (6 === b) $0cfcca548ca5090c$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0cfcca548ca5090c$var$Ok(e) && (b = $0cfcca548ca5090c$var$Ik(a, d), 2 === b && (f = $0cfcca548ca5090c$var$xc(a), 0 !== f && (d = f, b = $0cfcca548ca5090c$var$Nk(a, f))), 1 === b)) throw c = $0cfcca548ca5090c$var$pk, $0cfcca548ca5090c$var$Kk(a, 0), $0cfcca548ca5090c$var$Ck(a, d), $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0cfcca548ca5090c$var$p(345));
                case 2:
                    $0cfcca548ca5090c$var$Pk(a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk);
                    break;
                case 3:
                    $0cfcca548ca5090c$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0cfcca548ca5090c$var$fk + 500 - $0cfcca548ca5090c$var$B(), 10 < b)) {
                        if (0 !== $0cfcca548ca5090c$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0cfcca548ca5090c$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0cfcca548ca5090c$var$Ff($0cfcca548ca5090c$var$Pk.bind(null, a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk), b);
                        break;
                    }
                    $0cfcca548ca5090c$var$Pk(a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk);
                    break;
                case 4:
                    $0cfcca548ca5090c$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0cfcca548ca5090c$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0cfcca548ca5090c$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0cfcca548ca5090c$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0cfcca548ca5090c$var$Ff($0cfcca548ca5090c$var$Pk.bind(null, a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk), d);
                        break;
                    }
                    $0cfcca548ca5090c$var$Pk(a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk);
                    break;
                case 5:
                    $0cfcca548ca5090c$var$Pk(a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk);
                    break;
                default:
                    throw Error($0cfcca548ca5090c$var$p(329));
            }
        }
    }
    $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B());
    return a.callbackNode === c ? $0cfcca548ca5090c$var$Gk.bind(null, a) : null;
}
function $0cfcca548ca5090c$var$Nk(a, b) {
    var c = $0cfcca548ca5090c$var$sk;
    a.current.memoizedState.isDehydrated && ($0cfcca548ca5090c$var$Kk(a, b).flags |= 256);
    a = $0cfcca548ca5090c$var$Ik(a, b);
    2 !== a && (b = $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$tk = c, null !== b && $0cfcca548ca5090c$var$Fj(b));
    return a;
}
function $0cfcca548ca5090c$var$Fj(a) {
    null === $0cfcca548ca5090c$var$tk ? $0cfcca548ca5090c$var$tk = a : $0cfcca548ca5090c$var$tk.push.apply($0cfcca548ca5090c$var$tk, a);
}
function $0cfcca548ca5090c$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0cfcca548ca5090c$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0cfcca548ca5090c$var$Ck(a, b) {
    b &= ~$0cfcca548ca5090c$var$rk;
    b &= ~$0cfcca548ca5090c$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0cfcca548ca5090c$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0cfcca548ca5090c$var$Ek(a) {
    if (0 !== ($0cfcca548ca5090c$var$K & 6)) throw Error($0cfcca548ca5090c$var$p(327));
    $0cfcca548ca5090c$var$Hk();
    var b = $0cfcca548ca5090c$var$uc(a, 0);
    if (0 === (b & 1)) return $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B()), null;
    var c = $0cfcca548ca5090c$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0cfcca548ca5090c$var$xc(a);
        0 !== d && (b = d, c = $0cfcca548ca5090c$var$Nk(a, d));
    }
    if (1 === c) throw c = $0cfcca548ca5090c$var$pk, $0cfcca548ca5090c$var$Kk(a, 0), $0cfcca548ca5090c$var$Ck(a, b), $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B()), c;
    if (6 === c) throw Error($0cfcca548ca5090c$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0cfcca548ca5090c$var$Pk(a, $0cfcca548ca5090c$var$tk, $0cfcca548ca5090c$var$uk);
    $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B());
    return null;
}
function $0cfcca548ca5090c$var$Qk(a, b) {
    var c = $0cfcca548ca5090c$var$K;
    $0cfcca548ca5090c$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0cfcca548ca5090c$var$K = c, 0 === $0cfcca548ca5090c$var$K && ($0cfcca548ca5090c$var$Gj = $0cfcca548ca5090c$var$B() + 500, $0cfcca548ca5090c$var$fg && $0cfcca548ca5090c$var$jg());
    }
}
function $0cfcca548ca5090c$var$Rk(a) {
    null !== $0cfcca548ca5090c$var$wk && 0 === $0cfcca548ca5090c$var$wk.tag && 0 === ($0cfcca548ca5090c$var$K & 6) && $0cfcca548ca5090c$var$Hk();
    var b = $0cfcca548ca5090c$var$K;
    $0cfcca548ca5090c$var$K |= 1;
    var c = $0cfcca548ca5090c$var$ok.transition, d = $0cfcca548ca5090c$var$C;
    try {
        if ($0cfcca548ca5090c$var$ok.transition = null, $0cfcca548ca5090c$var$C = 1, a) return a();
    } finally{
        $0cfcca548ca5090c$var$C = d, $0cfcca548ca5090c$var$ok.transition = c, $0cfcca548ca5090c$var$K = b, 0 === ($0cfcca548ca5090c$var$K & 6) && $0cfcca548ca5090c$var$jg();
    }
}
function $0cfcca548ca5090c$var$Hj() {
    $0cfcca548ca5090c$var$fj = $0cfcca548ca5090c$var$ej.current;
    $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$ej);
}
function $0cfcca548ca5090c$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0cfcca548ca5090c$var$Gf(c));
    if (null !== $0cfcca548ca5090c$var$Y) for(c = $0cfcca548ca5090c$var$Y.return; null !== c;){
        var d = c;
        $0cfcca548ca5090c$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0cfcca548ca5090c$var$$f();
                break;
            case 3:
                $0cfcca548ca5090c$var$zh();
                $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$Wf);
                $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$H);
                $0cfcca548ca5090c$var$Eh();
                break;
            case 5:
                $0cfcca548ca5090c$var$Bh(d);
                break;
            case 4:
                $0cfcca548ca5090c$var$zh();
                break;
            case 13:
                $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L);
                break;
            case 19:
                $0cfcca548ca5090c$var$E($0cfcca548ca5090c$var$L);
                break;
            case 10:
                $0cfcca548ca5090c$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0cfcca548ca5090c$var$Hj();
        }
        c = c.return;
    }
    $0cfcca548ca5090c$var$Q = a;
    $0cfcca548ca5090c$var$Y = a = $0cfcca548ca5090c$var$Pg(a.current, null);
    $0cfcca548ca5090c$var$Z = $0cfcca548ca5090c$var$fj = b;
    $0cfcca548ca5090c$var$T = 0;
    $0cfcca548ca5090c$var$pk = null;
    $0cfcca548ca5090c$var$rk = $0cfcca548ca5090c$var$qk = $0cfcca548ca5090c$var$rh = 0;
    $0cfcca548ca5090c$var$tk = $0cfcca548ca5090c$var$sk = null;
    if (null !== $0cfcca548ca5090c$var$fh) {
        for(b = 0; b < $0cfcca548ca5090c$var$fh.length; b++)if (c = $0cfcca548ca5090c$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0cfcca548ca5090c$var$fh = null;
    }
    return a;
}
function $0cfcca548ca5090c$var$Mk(a, b) {
    do {
        var c = $0cfcca548ca5090c$var$Y;
        try {
            $0cfcca548ca5090c$var$$g();
            $0cfcca548ca5090c$var$Fh.current = $0cfcca548ca5090c$var$Rh;
            if ($0cfcca548ca5090c$var$Ih) {
                for(var d = $0cfcca548ca5090c$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0cfcca548ca5090c$var$Ih = !1;
            }
            $0cfcca548ca5090c$var$Hh = 0;
            $0cfcca548ca5090c$var$O = $0cfcca548ca5090c$var$N = $0cfcca548ca5090c$var$M = null;
            $0cfcca548ca5090c$var$Jh = !1;
            $0cfcca548ca5090c$var$Kh = 0;
            $0cfcca548ca5090c$var$nk.current = null;
            if (null === c || null === c.return) {
                $0cfcca548ca5090c$var$T = 1;
                $0cfcca548ca5090c$var$pk = b;
                $0cfcca548ca5090c$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0cfcca548ca5090c$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0cfcca548ca5090c$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0cfcca548ca5090c$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0cfcca548ca5090c$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0cfcca548ca5090c$var$Si(f, l, b);
                            $0cfcca548ca5090c$var$tj();
                            break a;
                        }
                        k = Error($0cfcca548ca5090c$var$p(426));
                    }
                } else if ($0cfcca548ca5090c$var$I && h.mode & 1) {
                    var J = $0cfcca548ca5090c$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0cfcca548ca5090c$var$Vi(J, g, h, f, b);
                        $0cfcca548ca5090c$var$Jg($0cfcca548ca5090c$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0cfcca548ca5090c$var$Ji(k, h);
                4 !== $0cfcca548ca5090c$var$T && ($0cfcca548ca5090c$var$T = 2);
                null === $0cfcca548ca5090c$var$sk ? $0cfcca548ca5090c$var$sk = [
                    f
                ] : $0cfcca548ca5090c$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0cfcca548ca5090c$var$Ni(f, k, b);
                            $0cfcca548ca5090c$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0cfcca548ca5090c$var$Ri || !$0cfcca548ca5090c$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0cfcca548ca5090c$var$Qi(f, h, b);
                                $0cfcca548ca5090c$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0cfcca548ca5090c$var$Sk(c);
        } catch (na) {
            b = na;
            $0cfcca548ca5090c$var$Y === c && null !== c && ($0cfcca548ca5090c$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0cfcca548ca5090c$var$Jk() {
    var a = $0cfcca548ca5090c$var$mk.current;
    $0cfcca548ca5090c$var$mk.current = $0cfcca548ca5090c$var$Rh;
    return null === a ? $0cfcca548ca5090c$var$Rh : a;
}
function $0cfcca548ca5090c$var$tj() {
    if (0 === $0cfcca548ca5090c$var$T || 3 === $0cfcca548ca5090c$var$T || 2 === $0cfcca548ca5090c$var$T) $0cfcca548ca5090c$var$T = 4;
    null === $0cfcca548ca5090c$var$Q || 0 === ($0cfcca548ca5090c$var$rh & 268435455) && 0 === ($0cfcca548ca5090c$var$qk & 268435455) || $0cfcca548ca5090c$var$Ck($0cfcca548ca5090c$var$Q, $0cfcca548ca5090c$var$Z);
}
function $0cfcca548ca5090c$var$Ik(a, b) {
    var c = $0cfcca548ca5090c$var$K;
    $0cfcca548ca5090c$var$K |= 2;
    var d = $0cfcca548ca5090c$var$Jk();
    if ($0cfcca548ca5090c$var$Q !== a || $0cfcca548ca5090c$var$Z !== b) $0cfcca548ca5090c$var$uk = null, $0cfcca548ca5090c$var$Kk(a, b);
    for(;;)try {
        $0cfcca548ca5090c$var$Tk();
        break;
    } catch (e) {
        $0cfcca548ca5090c$var$Mk(a, e);
    }
    $0cfcca548ca5090c$var$$g();
    $0cfcca548ca5090c$var$K = c;
    $0cfcca548ca5090c$var$mk.current = d;
    if (null !== $0cfcca548ca5090c$var$Y) throw Error($0cfcca548ca5090c$var$p(261));
    $0cfcca548ca5090c$var$Q = null;
    $0cfcca548ca5090c$var$Z = 0;
    return $0cfcca548ca5090c$var$T;
}
function $0cfcca548ca5090c$var$Tk() {
    for(; null !== $0cfcca548ca5090c$var$Y;)$0cfcca548ca5090c$var$Uk($0cfcca548ca5090c$var$Y);
}
function $0cfcca548ca5090c$var$Lk() {
    for(; null !== $0cfcca548ca5090c$var$Y && !$0cfcca548ca5090c$var$cc();)$0cfcca548ca5090c$var$Uk($0cfcca548ca5090c$var$Y);
}
function $0cfcca548ca5090c$var$Uk(a) {
    var b = $0cfcca548ca5090c$var$Vk(a.alternate, a, $0cfcca548ca5090c$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0cfcca548ca5090c$var$Sk(a) : $0cfcca548ca5090c$var$Y = b;
    $0cfcca548ca5090c$var$nk.current = null;
}
function $0cfcca548ca5090c$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0cfcca548ca5090c$var$Ej(c, b, $0cfcca548ca5090c$var$fj), null !== c) {
                $0cfcca548ca5090c$var$Y = c;
                return;
            }
        } else {
            c = $0cfcca548ca5090c$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0cfcca548ca5090c$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0cfcca548ca5090c$var$T = 6;
                $0cfcca548ca5090c$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0cfcca548ca5090c$var$Y = b;
            return;
        }
        $0cfcca548ca5090c$var$Y = b = a;
    }while (null !== b);
    0 === $0cfcca548ca5090c$var$T && ($0cfcca548ca5090c$var$T = 5);
}
function $0cfcca548ca5090c$var$Pk(a, b, c) {
    var d = $0cfcca548ca5090c$var$C, e = $0cfcca548ca5090c$var$ok.transition;
    try {
        $0cfcca548ca5090c$var$ok.transition = null, $0cfcca548ca5090c$var$C = 1, $0cfcca548ca5090c$var$Wk(a, b, c, d);
    } finally{
        $0cfcca548ca5090c$var$ok.transition = e, $0cfcca548ca5090c$var$C = d;
    }
    return null;
}
function $0cfcca548ca5090c$var$Wk(a, b, c, d) {
    do $0cfcca548ca5090c$var$Hk();
    while (null !== $0cfcca548ca5090c$var$wk);
    if (0 !== ($0cfcca548ca5090c$var$K & 6)) throw Error($0cfcca548ca5090c$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0cfcca548ca5090c$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0cfcca548ca5090c$var$Bc(a, f);
    a === $0cfcca548ca5090c$var$Q && ($0cfcca548ca5090c$var$Y = $0cfcca548ca5090c$var$Q = null, $0cfcca548ca5090c$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0cfcca548ca5090c$var$vk || ($0cfcca548ca5090c$var$vk = !0, $0cfcca548ca5090c$var$Fk($0cfcca548ca5090c$var$hc, function() {
        $0cfcca548ca5090c$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0cfcca548ca5090c$var$ok.transition;
        $0cfcca548ca5090c$var$ok.transition = null;
        var g = $0cfcca548ca5090c$var$C;
        $0cfcca548ca5090c$var$C = 1;
        var h = $0cfcca548ca5090c$var$K;
        $0cfcca548ca5090c$var$K |= 4;
        $0cfcca548ca5090c$var$nk.current = null;
        $0cfcca548ca5090c$var$Oj(a, c);
        $0cfcca548ca5090c$var$dk(c, a);
        $0cfcca548ca5090c$var$Oe($0cfcca548ca5090c$var$Df);
        $0cfcca548ca5090c$var$dd = !!$0cfcca548ca5090c$var$Cf;
        $0cfcca548ca5090c$var$Df = $0cfcca548ca5090c$var$Cf = null;
        a.current = c;
        $0cfcca548ca5090c$var$hk(c, a, e);
        $0cfcca548ca5090c$var$dc();
        $0cfcca548ca5090c$var$K = h;
        $0cfcca548ca5090c$var$C = g;
        $0cfcca548ca5090c$var$ok.transition = f;
    } else a.current = c;
    $0cfcca548ca5090c$var$vk && ($0cfcca548ca5090c$var$vk = !1, $0cfcca548ca5090c$var$wk = a, $0cfcca548ca5090c$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0cfcca548ca5090c$var$Ri = null);
    $0cfcca548ca5090c$var$mc(c.stateNode, d);
    $0cfcca548ca5090c$var$Dk(a, $0cfcca548ca5090c$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0cfcca548ca5090c$var$Oi) throw $0cfcca548ca5090c$var$Oi = !1, a = $0cfcca548ca5090c$var$Pi, $0cfcca548ca5090c$var$Pi = null, a;
    0 !== ($0cfcca548ca5090c$var$xk & 1) && 0 !== a.tag && $0cfcca548ca5090c$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0cfcca548ca5090c$var$zk ? $0cfcca548ca5090c$var$yk++ : ($0cfcca548ca5090c$var$yk = 0, $0cfcca548ca5090c$var$zk = a) : $0cfcca548ca5090c$var$yk = 0;
    $0cfcca548ca5090c$var$jg();
    return null;
}
function $0cfcca548ca5090c$var$Hk() {
    if (null !== $0cfcca548ca5090c$var$wk) {
        var a = $0cfcca548ca5090c$var$Dc($0cfcca548ca5090c$var$xk), b = $0cfcca548ca5090c$var$ok.transition, c = $0cfcca548ca5090c$var$C;
        try {
            $0cfcca548ca5090c$var$ok.transition = null;
            $0cfcca548ca5090c$var$C = 16 > a ? 16 : a;
            if (null === $0cfcca548ca5090c$var$wk) var d = !1;
            else {
                a = $0cfcca548ca5090c$var$wk;
                $0cfcca548ca5090c$var$wk = null;
                $0cfcca548ca5090c$var$xk = 0;
                if (0 !== ($0cfcca548ca5090c$var$K & 6)) throw Error($0cfcca548ca5090c$var$p(331));
                var e = $0cfcca548ca5090c$var$K;
                $0cfcca548ca5090c$var$K |= 4;
                for($0cfcca548ca5090c$var$V = a.current; null !== $0cfcca548ca5090c$var$V;){
                    var f = $0cfcca548ca5090c$var$V, g = f.child;
                    if (0 !== ($0cfcca548ca5090c$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0cfcca548ca5090c$var$V = l; null !== $0cfcca548ca5090c$var$V;){
                                    var m = $0cfcca548ca5090c$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0cfcca548ca5090c$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0cfcca548ca5090c$var$V = q;
                                    else for(; null !== $0cfcca548ca5090c$var$V;){
                                        m = $0cfcca548ca5090c$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0cfcca548ca5090c$var$Sj(m);
                                        if (m === l) {
                                            $0cfcca548ca5090c$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0cfcca548ca5090c$var$V = r;
                                            break;
                                        }
                                        $0cfcca548ca5090c$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0cfcca548ca5090c$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0cfcca548ca5090c$var$V = g;
                    else b: for(; null !== $0cfcca548ca5090c$var$V;){
                        f = $0cfcca548ca5090c$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0cfcca548ca5090c$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0cfcca548ca5090c$var$V = x;
                            break b;
                        }
                        $0cfcca548ca5090c$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0cfcca548ca5090c$var$V = w; null !== $0cfcca548ca5090c$var$V;){
                    g = $0cfcca548ca5090c$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0cfcca548ca5090c$var$V = u;
                    else b: for(g = w; null !== $0cfcca548ca5090c$var$V;){
                        h = $0cfcca548ca5090c$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0cfcca548ca5090c$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0cfcca548ca5090c$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0cfcca548ca5090c$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0cfcca548ca5090c$var$V = F;
                            break b;
                        }
                        $0cfcca548ca5090c$var$V = h.return;
                    }
                }
                $0cfcca548ca5090c$var$K = e;
                $0cfcca548ca5090c$var$jg();
                if ($0cfcca548ca5090c$var$lc && "function" === typeof $0cfcca548ca5090c$var$lc.onPostCommitFiberRoot) try {
                    $0cfcca548ca5090c$var$lc.onPostCommitFiberRoot($0cfcca548ca5090c$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0cfcca548ca5090c$var$C = c, $0cfcca548ca5090c$var$ok.transition = b;
        }
    }
    return !1;
}
function $0cfcca548ca5090c$var$Xk(a, b, c) {
    b = $0cfcca548ca5090c$var$Ji(c, b);
    b = $0cfcca548ca5090c$var$Ni(a, b, 1);
    a = $0cfcca548ca5090c$var$nh(a, b, 1);
    b = $0cfcca548ca5090c$var$R();
    null !== a && ($0cfcca548ca5090c$var$Ac(a, 1, b), $0cfcca548ca5090c$var$Dk(a, b));
}
function $0cfcca548ca5090c$var$W(a, b, c) {
    if (3 === a.tag) $0cfcca548ca5090c$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0cfcca548ca5090c$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0cfcca548ca5090c$var$Ri || !$0cfcca548ca5090c$var$Ri.has(d))) {
                a = $0cfcca548ca5090c$var$Ji(c, a);
                a = $0cfcca548ca5090c$var$Qi(b, a, 1);
                b = $0cfcca548ca5090c$var$nh(b, a, 1);
                a = $0cfcca548ca5090c$var$R();
                null !== b && ($0cfcca548ca5090c$var$Ac(b, 1, a), $0cfcca548ca5090c$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0cfcca548ca5090c$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0cfcca548ca5090c$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0cfcca548ca5090c$var$Q === a && ($0cfcca548ca5090c$var$Z & c) === c && (4 === $0cfcca548ca5090c$var$T || 3 === $0cfcca548ca5090c$var$T && ($0cfcca548ca5090c$var$Z & 130023424) === $0cfcca548ca5090c$var$Z && 500 > $0cfcca548ca5090c$var$B() - $0cfcca548ca5090c$var$fk ? $0cfcca548ca5090c$var$Kk(a, 0) : $0cfcca548ca5090c$var$rk |= c);
    $0cfcca548ca5090c$var$Dk(a, b);
}
function $0cfcca548ca5090c$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0cfcca548ca5090c$var$sc, $0cfcca548ca5090c$var$sc <<= 1, 0 === ($0cfcca548ca5090c$var$sc & 130023424) && ($0cfcca548ca5090c$var$sc = 4194304)));
    var c = $0cfcca548ca5090c$var$R();
    a = $0cfcca548ca5090c$var$ih(a, b);
    null !== a && ($0cfcca548ca5090c$var$Ac(a, b, c), $0cfcca548ca5090c$var$Dk(a, c));
}
function $0cfcca548ca5090c$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0cfcca548ca5090c$var$Yk(a, c);
}
function $0cfcca548ca5090c$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0cfcca548ca5090c$var$p(314));
    }
    null !== d && d.delete(b);
    $0cfcca548ca5090c$var$Yk(a, c);
}
var $0cfcca548ca5090c$var$Vk;
$0cfcca548ca5090c$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0cfcca548ca5090c$var$Wf.current) $0cfcca548ca5090c$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0cfcca548ca5090c$var$dh = !1, $0cfcca548ca5090c$var$yj(a, b, c);
            $0cfcca548ca5090c$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0cfcca548ca5090c$var$dh = !1, $0cfcca548ca5090c$var$I && 0 !== (b.flags & 1048576) && $0cfcca548ca5090c$var$ug(b, $0cfcca548ca5090c$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0cfcca548ca5090c$var$ij(a, b);
            a = b.pendingProps;
            var e = $0cfcca548ca5090c$var$Yf(b, $0cfcca548ca5090c$var$H.current);
            $0cfcca548ca5090c$var$ch(b, c);
            e = $0cfcca548ca5090c$var$Nh(null, b, d, a, e, c);
            var f = $0cfcca548ca5090c$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0cfcca548ca5090c$var$Zf(d) ? (f = !0, $0cfcca548ca5090c$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0cfcca548ca5090c$var$kh(b), e.updater = $0cfcca548ca5090c$var$Ei, b.stateNode = e, e._reactInternals = b, $0cfcca548ca5090c$var$Ii(b, d, a, c), b = $0cfcca548ca5090c$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0cfcca548ca5090c$var$I && f && $0cfcca548ca5090c$var$vg(b), $0cfcca548ca5090c$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0cfcca548ca5090c$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0cfcca548ca5090c$var$Zk(d);
                a = $0cfcca548ca5090c$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0cfcca548ca5090c$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0cfcca548ca5090c$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0cfcca548ca5090c$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0cfcca548ca5090c$var$$i(null, b, d, $0cfcca548ca5090c$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0cfcca548ca5090c$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0cfcca548ca5090c$var$Ci(d, e), $0cfcca548ca5090c$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0cfcca548ca5090c$var$Ci(d, e), $0cfcca548ca5090c$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0cfcca548ca5090c$var$kj(b);
                if (null === a) throw Error($0cfcca548ca5090c$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0cfcca548ca5090c$var$lh(a, b);
                $0cfcca548ca5090c$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0cfcca548ca5090c$var$Ji(Error($0cfcca548ca5090c$var$p(423)), b);
                        b = $0cfcca548ca5090c$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0cfcca548ca5090c$var$Ji(Error($0cfcca548ca5090c$var$p(424)), b);
                        b = $0cfcca548ca5090c$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0cfcca548ca5090c$var$yg = $0cfcca548ca5090c$var$Lf(b.stateNode.containerInfo.firstChild), $0cfcca548ca5090c$var$xg = b, $0cfcca548ca5090c$var$I = !0, $0cfcca548ca5090c$var$zg = null, c = $0cfcca548ca5090c$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0cfcca548ca5090c$var$Ig();
                    if (d === e) {
                        b = $0cfcca548ca5090c$var$Zi(a, b, c);
                        break a;
                    }
                    $0cfcca548ca5090c$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0cfcca548ca5090c$var$Ah(b), null === a && $0cfcca548ca5090c$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0cfcca548ca5090c$var$Ef(d, e) ? g = null : null !== f && $0cfcca548ca5090c$var$Ef(d, f) && (b.flags |= 32), $0cfcca548ca5090c$var$gj(a, b), $0cfcca548ca5090c$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0cfcca548ca5090c$var$Eg(b), null;
        case 13:
            return $0cfcca548ca5090c$var$oj(a, b, c);
        case 4:
            return $0cfcca548ca5090c$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0cfcca548ca5090c$var$Ug(b, null, d, c) : $0cfcca548ca5090c$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0cfcca548ca5090c$var$Ci(d, e), $0cfcca548ca5090c$var$Yi(a, b, d, e, c);
        case 7:
            return $0cfcca548ca5090c$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0cfcca548ca5090c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0cfcca548ca5090c$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0cfcca548ca5090c$var$G($0cfcca548ca5090c$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0cfcca548ca5090c$var$He(f.value, g)) {
                        if (f.children === e.children && !$0cfcca548ca5090c$var$Wf.current) {
                            b = $0cfcca548ca5090c$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0cfcca548ca5090c$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0cfcca548ca5090c$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0cfcca548ca5090c$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0cfcca548ca5090c$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0cfcca548ca5090c$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0cfcca548ca5090c$var$ch(b, c), e = $0cfcca548ca5090c$var$eh(e), d = d(e), b.flags |= 1, $0cfcca548ca5090c$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0cfcca548ca5090c$var$Ci(d, b.pendingProps), e = $0cfcca548ca5090c$var$Ci(d.type, e), $0cfcca548ca5090c$var$$i(a, b, d, e, c);
        case 15:
            return $0cfcca548ca5090c$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0cfcca548ca5090c$var$Ci(d, e), $0cfcca548ca5090c$var$ij(a, b), b.tag = 1, $0cfcca548ca5090c$var$Zf(d) ? (a = !0, $0cfcca548ca5090c$var$cg(b)) : a = !1, $0cfcca548ca5090c$var$ch(b, c), $0cfcca548ca5090c$var$Gi(b, d, e), $0cfcca548ca5090c$var$Ii(b, d, e, c), $0cfcca548ca5090c$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0cfcca548ca5090c$var$xj(a, b, c);
        case 22:
            return $0cfcca548ca5090c$var$dj(a, b, c);
    }
    throw Error($0cfcca548ca5090c$var$p(156, b.tag));
};
function $0cfcca548ca5090c$var$Fk(a, b) {
    return $0cfcca548ca5090c$var$ac(a, b);
}
function $0cfcca548ca5090c$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0cfcca548ca5090c$var$Bg(a, b, c, d) {
    return new $0cfcca548ca5090c$var$$k(a, b, c, d);
}
function $0cfcca548ca5090c$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0cfcca548ca5090c$var$Zk(a) {
    if ("function" === typeof a) return $0cfcca548ca5090c$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0cfcca548ca5090c$var$Da) return 11;
        if (a === $0cfcca548ca5090c$var$Ga) return 14;
    }
    return 2;
}
function $0cfcca548ca5090c$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0cfcca548ca5090c$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0cfcca548ca5090c$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0cfcca548ca5090c$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0cfcca548ca5090c$var$ya:
            return $0cfcca548ca5090c$var$Tg(c.children, e, f, b);
        case $0cfcca548ca5090c$var$za:
            g = 8;
            e |= 8;
            break;
        case $0cfcca548ca5090c$var$Aa:
            return a = $0cfcca548ca5090c$var$Bg(12, c, b, e | 2), a.elementType = $0cfcca548ca5090c$var$Aa, a.lanes = f, a;
        case $0cfcca548ca5090c$var$Ea:
            return a = $0cfcca548ca5090c$var$Bg(13, c, b, e), a.elementType = $0cfcca548ca5090c$var$Ea, a.lanes = f, a;
        case $0cfcca548ca5090c$var$Fa:
            return a = $0cfcca548ca5090c$var$Bg(19, c, b, e), a.elementType = $0cfcca548ca5090c$var$Fa, a.lanes = f, a;
        case $0cfcca548ca5090c$var$Ia:
            return $0cfcca548ca5090c$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0cfcca548ca5090c$var$Ba:
                    g = 10;
                    break a;
                case $0cfcca548ca5090c$var$Ca:
                    g = 9;
                    break a;
                case $0cfcca548ca5090c$var$Da:
                    g = 11;
                    break a;
                case $0cfcca548ca5090c$var$Ga:
                    g = 14;
                    break a;
                case $0cfcca548ca5090c$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0cfcca548ca5090c$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0cfcca548ca5090c$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0cfcca548ca5090c$var$Tg(a, b, c, d) {
    a = $0cfcca548ca5090c$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0cfcca548ca5090c$var$pj(a, b, c, d) {
    a = $0cfcca548ca5090c$var$Bg(22, a, d, b);
    a.elementType = $0cfcca548ca5090c$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0cfcca548ca5090c$var$Qg(a, b, c) {
    a = $0cfcca548ca5090c$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0cfcca548ca5090c$var$Sg(a, b, c) {
    b = $0cfcca548ca5090c$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0cfcca548ca5090c$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0cfcca548ca5090c$var$zc(0);
    this.expirationTimes = $0cfcca548ca5090c$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0cfcca548ca5090c$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0cfcca548ca5090c$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0cfcca548ca5090c$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0cfcca548ca5090c$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0cfcca548ca5090c$var$kh(f);
    return a;
}
function $0cfcca548ca5090c$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0cfcca548ca5090c$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0cfcca548ca5090c$var$dl(a) {
    if (!a) return $0cfcca548ca5090c$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0cfcca548ca5090c$var$Vb(a) !== a || 1 !== a.tag) throw Error($0cfcca548ca5090c$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0cfcca548ca5090c$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0cfcca548ca5090c$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0cfcca548ca5090c$var$Zf(c)) return $0cfcca548ca5090c$var$bg(a, c, b);
    }
    return b;
}
function $0cfcca548ca5090c$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0cfcca548ca5090c$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0cfcca548ca5090c$var$dl(null);
    c = a.current;
    d = $0cfcca548ca5090c$var$R();
    e = $0cfcca548ca5090c$var$yi(c);
    f = $0cfcca548ca5090c$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0cfcca548ca5090c$var$nh(c, f, e);
    a.current.lanes = e;
    $0cfcca548ca5090c$var$Ac(a, e, d);
    $0cfcca548ca5090c$var$Dk(a, d);
    return a;
}
function $0cfcca548ca5090c$var$fl(a, b, c, d) {
    var e = b.current, f = $0cfcca548ca5090c$var$R(), g = $0cfcca548ca5090c$var$yi(e);
    c = $0cfcca548ca5090c$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0cfcca548ca5090c$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0cfcca548ca5090c$var$nh(e, b, g);
    null !== a && ($0cfcca548ca5090c$var$gi(a, e, g, f), $0cfcca548ca5090c$var$oh(a, e, g));
    return g;
}
function $0cfcca548ca5090c$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0cfcca548ca5090c$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0cfcca548ca5090c$var$il(a, b) {
    $0cfcca548ca5090c$var$hl(a, b);
    (a = a.alternate) && $0cfcca548ca5090c$var$hl(a, b);
}
function $0cfcca548ca5090c$var$jl() {
    return null;
}
var $0cfcca548ca5090c$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0cfcca548ca5090c$var$ll(a) {
    this._internalRoot = a;
}
$0cfcca548ca5090c$var$ml.prototype.render = $0cfcca548ca5090c$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0cfcca548ca5090c$var$p(409));
    $0cfcca548ca5090c$var$fl(a, b, null, null);
};
$0cfcca548ca5090c$var$ml.prototype.unmount = $0cfcca548ca5090c$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0cfcca548ca5090c$var$Rk(function() {
            $0cfcca548ca5090c$var$fl(null, a, null, null);
        });
        b[$0cfcca548ca5090c$var$uf] = null;
    }
};
function $0cfcca548ca5090c$var$ml(a) {
    this._internalRoot = a;
}
$0cfcca548ca5090c$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0cfcca548ca5090c$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0cfcca548ca5090c$var$Qc.length && 0 !== b && b < $0cfcca548ca5090c$var$Qc[c].priority; c++);
        $0cfcca548ca5090c$var$Qc.splice(c, 0, a);
        0 === c && $0cfcca548ca5090c$var$Vc(a);
    }
};
function $0cfcca548ca5090c$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0cfcca548ca5090c$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0cfcca548ca5090c$var$pl() {}
function $0cfcca548ca5090c$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0cfcca548ca5090c$var$gl(g);
                f.call(a);
            };
        }
        var g = $0cfcca548ca5090c$var$el(b, d, a, 0, null, !1, !1, "", $0cfcca548ca5090c$var$pl);
        a._reactRootContainer = g;
        a[$0cfcca548ca5090c$var$uf] = g.current;
        $0cfcca548ca5090c$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0cfcca548ca5090c$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0cfcca548ca5090c$var$gl(k);
            h.call(a);
        };
    }
    var k = $0cfcca548ca5090c$var$bl(a, 0, !1, null, null, !1, !1, "", $0cfcca548ca5090c$var$pl);
    a._reactRootContainer = k;
    a[$0cfcca548ca5090c$var$uf] = k.current;
    $0cfcca548ca5090c$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0cfcca548ca5090c$var$Rk(function() {
        $0cfcca548ca5090c$var$fl(b, k, c, d);
    });
    return k;
}
function $0cfcca548ca5090c$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0cfcca548ca5090c$var$gl(g);
                h.call(a);
            };
        }
        $0cfcca548ca5090c$var$fl(b, g, a, e);
    } else g = $0cfcca548ca5090c$var$ql(c, b, a, e, d);
    return $0cfcca548ca5090c$var$gl(g);
}
$0cfcca548ca5090c$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0cfcca548ca5090c$var$tc(b.pendingLanes);
                0 !== c && ($0cfcca548ca5090c$var$Cc(b, c | 1), $0cfcca548ca5090c$var$Dk(b, $0cfcca548ca5090c$var$B()), 0 === ($0cfcca548ca5090c$var$K & 6) && ($0cfcca548ca5090c$var$Gj = $0cfcca548ca5090c$var$B() + 500, $0cfcca548ca5090c$var$jg()));
            }
            break;
        case 13:
            $0cfcca548ca5090c$var$Rk(function() {
                var b = $0cfcca548ca5090c$var$ih(a, 1);
                if (null !== b) {
                    var c = $0cfcca548ca5090c$var$R();
                    $0cfcca548ca5090c$var$gi(b, a, 1, c);
                }
            }), $0cfcca548ca5090c$var$il(a, 1);
    }
};
$0cfcca548ca5090c$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0cfcca548ca5090c$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0cfcca548ca5090c$var$R();
            $0cfcca548ca5090c$var$gi(b, a, 134217728, c);
        }
        $0cfcca548ca5090c$var$il(a, 134217728);
    }
};
$0cfcca548ca5090c$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0cfcca548ca5090c$var$yi(a), c = $0cfcca548ca5090c$var$ih(a, b);
        if (null !== c) {
            var d = $0cfcca548ca5090c$var$R();
            $0cfcca548ca5090c$var$gi(c, a, b, d);
        }
        $0cfcca548ca5090c$var$il(a, b);
    }
};
$0cfcca548ca5090c$var$Hc = function() {
    return $0cfcca548ca5090c$var$C;
};
$0cfcca548ca5090c$var$Ic = function(a, b) {
    var c = $0cfcca548ca5090c$var$C;
    try {
        return $0cfcca548ca5090c$var$C = a, b();
    } finally{
        $0cfcca548ca5090c$var$C = c;
    }
};
$0cfcca548ca5090c$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0cfcca548ca5090c$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0cfcca548ca5090c$var$Db(d);
                        if (!e) throw Error($0cfcca548ca5090c$var$p(90));
                        $0cfcca548ca5090c$var$Wa(d);
                        $0cfcca548ca5090c$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0cfcca548ca5090c$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0cfcca548ca5090c$var$fb(a, !!c.multiple, b, !1);
    }
};
$0cfcca548ca5090c$var$Gb = $0cfcca548ca5090c$var$Qk;
$0cfcca548ca5090c$var$Hb = $0cfcca548ca5090c$var$Rk;
var $0cfcca548ca5090c$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0cfcca548ca5090c$var$Cb,
        $0cfcca548ca5090c$var$ue,
        $0cfcca548ca5090c$var$Db,
        $0cfcca548ca5090c$var$Eb,
        $0cfcca548ca5090c$var$Fb,
        $0cfcca548ca5090c$var$Qk
    ]
}, $0cfcca548ca5090c$var$tl = {
    findFiberByHostInstance: $0cfcca548ca5090c$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0cfcca548ca5090c$var$ul = {
    bundleType: $0cfcca548ca5090c$var$tl.bundleType,
    version: $0cfcca548ca5090c$var$tl.version,
    rendererPackageName: $0cfcca548ca5090c$var$tl.rendererPackageName,
    rendererConfig: $0cfcca548ca5090c$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0cfcca548ca5090c$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0cfcca548ca5090c$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0cfcca548ca5090c$var$tl.findFiberByHostInstance || $0cfcca548ca5090c$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0cfcca548ca5090c$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0cfcca548ca5090c$var$vl.isDisabled && $0cfcca548ca5090c$var$vl.supportsFiber) try {
        $0cfcca548ca5090c$var$kc = $0cfcca548ca5090c$var$vl.inject($0cfcca548ca5090c$var$ul), $0cfcca548ca5090c$var$lc = $0cfcca548ca5090c$var$vl;
    } catch (a) {}
}
$0cfcca548ca5090c$export$ae55be85d98224ed = $0cfcca548ca5090c$var$sl;
$0cfcca548ca5090c$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0cfcca548ca5090c$var$nl(b)) throw Error($0cfcca548ca5090c$var$p(200));
    return $0cfcca548ca5090c$var$cl(a, b, null, c);
};
$0cfcca548ca5090c$export$882461b6382ed46c = function(a, b) {
    if (!$0cfcca548ca5090c$var$nl(a)) throw Error($0cfcca548ca5090c$var$p(299));
    var c = !1, d = "", e = $0cfcca548ca5090c$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0cfcca548ca5090c$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0cfcca548ca5090c$var$uf] = b.current;
    $0cfcca548ca5090c$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0cfcca548ca5090c$var$ll(b);
};
$0cfcca548ca5090c$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0cfcca548ca5090c$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0cfcca548ca5090c$var$p(268, a));
    }
    a = $0cfcca548ca5090c$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0cfcca548ca5090c$export$cd75ccfd720a3cd4 = function(a) {
    return $0cfcca548ca5090c$var$Rk(a);
};
$0cfcca548ca5090c$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0cfcca548ca5090c$var$ol(b)) throw Error($0cfcca548ca5090c$var$p(200));
    return $0cfcca548ca5090c$var$rl(null, a, b, !0, c);
};
$0cfcca548ca5090c$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0cfcca548ca5090c$var$nl(a)) throw Error($0cfcca548ca5090c$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0cfcca548ca5090c$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0cfcca548ca5090c$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0cfcca548ca5090c$var$uf] = b.current;
    $0cfcca548ca5090c$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0cfcca548ca5090c$var$ml(b);
};
$0cfcca548ca5090c$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0cfcca548ca5090c$var$ol(b)) throw Error($0cfcca548ca5090c$var$p(200));
    return $0cfcca548ca5090c$var$rl(null, a, b, !1, c);
};
$0cfcca548ca5090c$export$502457920280e6be = function(a) {
    if (!$0cfcca548ca5090c$var$ol(a)) throw Error($0cfcca548ca5090c$var$p(40));
    return a._reactRootContainer ? ($0cfcca548ca5090c$var$Rk(function() {
        $0cfcca548ca5090c$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0cfcca548ca5090c$var$uf] = null;
        });
    }), !0) : !1;
};
$0cfcca548ca5090c$export$c78a37762a8d58e1 = $0cfcca548ca5090c$var$Qk;
$0cfcca548ca5090c$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0cfcca548ca5090c$var$ol(c)) throw Error($0cfcca548ca5090c$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0cfcca548ca5090c$var$p(38));
    return $0cfcca548ca5090c$var$rl(a, b, c, !1, d);
};
$0cfcca548ca5090c$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("gZs9N", function(module, exports) {
'use strict';

module.exports = (parcelRequire("giLc8"));

});
parcelRegister("giLc8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $bde2efa6d68d220c$export$c4744153514ff05d; }, function (v) { return $bde2efa6d68d220c$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $bde2efa6d68d220c$export$3e506c1ccc9cc1a7; }, function (v) { return $bde2efa6d68d220c$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $bde2efa6d68d220c$export$e26fe2ed2fa76875; }, function (v) { return $bde2efa6d68d220c$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $bde2efa6d68d220c$export$502329bbf4b505b1; }, function (v) { return $bde2efa6d68d220c$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $bde2efa6d68d220c$export$6e3807111c4874c4; }, function (v) { return $bde2efa6d68d220c$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $bde2efa6d68d220c$export$c27134553091fb3a; }, function (v) { return $bde2efa6d68d220c$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $bde2efa6d68d220c$export$33ee1acdc04fd2a2; }, function (v) { return $bde2efa6d68d220c$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $bde2efa6d68d220c$export$b00a404bbd5edef2; }, function (v) { return $bde2efa6d68d220c$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $bde2efa6d68d220c$export$8352ce38b91d0c62; }, function (v) { return $bde2efa6d68d220c$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $bde2efa6d68d220c$export$d66a1c1c77bd778b; }, function (v) { return $bde2efa6d68d220c$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $bde2efa6d68d220c$export$d3dfb8e4810cb555; }, function (v) { return $bde2efa6d68d220c$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $bde2efa6d68d220c$export$839f9183b0465a69; }, function (v) { return $bde2efa6d68d220c$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $bde2efa6d68d220c$export$72fdf0e06517287b; }, function (v) { return $bde2efa6d68d220c$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $bde2efa6d68d220c$export$4b844e58a3e414b4; }, function (v) { return $bde2efa6d68d220c$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $bde2efa6d68d220c$export$816d2913ae6b83b1; }, function (v) { return $bde2efa6d68d220c$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $bde2efa6d68d220c$export$61bcfe829111a1d0; }, function (v) { return $bde2efa6d68d220c$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $bde2efa6d68d220c$export$7ee8c9beb337bc3f; }, function (v) { return $bde2efa6d68d220c$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $bde2efa6d68d220c$export$b5836b71941fa3ed; }, function (v) { return $bde2efa6d68d220c$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $bde2efa6d68d220c$export$cf845f2c119da08a; }, function (v) { return $bde2efa6d68d220c$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bde2efa6d68d220c$export$c4744153514ff05d;
var $bde2efa6d68d220c$export$3e506c1ccc9cc1a7;
var $bde2efa6d68d220c$export$e26fe2ed2fa76875;
var $bde2efa6d68d220c$export$502329bbf4b505b1;
var $bde2efa6d68d220c$export$6e3807111c4874c4;
var $bde2efa6d68d220c$export$c27134553091fb3a;
var $bde2efa6d68d220c$export$33ee1acdc04fd2a2;
var $bde2efa6d68d220c$export$b00a404bbd5edef2;
var $bde2efa6d68d220c$export$8352ce38b91d0c62;
var $bde2efa6d68d220c$export$d66a1c1c77bd778b;
var $bde2efa6d68d220c$export$d3dfb8e4810cb555;
var $bde2efa6d68d220c$export$839f9183b0465a69;
var $bde2efa6d68d220c$export$72fdf0e06517287b;
var $bde2efa6d68d220c$export$4b844e58a3e414b4;
var $bde2efa6d68d220c$export$816d2913ae6b83b1;
var $bde2efa6d68d220c$export$61bcfe829111a1d0;
var $bde2efa6d68d220c$export$7ee8c9beb337bc3f;
var $bde2efa6d68d220c$export$b5836b71941fa3ed;
var $bde2efa6d68d220c$export$cf845f2c119da08a;
'use strict';
function $bde2efa6d68d220c$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bde2efa6d68d220c$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bde2efa6d68d220c$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bde2efa6d68d220c$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bde2efa6d68d220c$var$g(C, c)) n < e && 0 > $bde2efa6d68d220c$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bde2efa6d68d220c$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bde2efa6d68d220c$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bde2efa6d68d220c$var$l = performance;
    $bde2efa6d68d220c$export$c4744153514ff05d = function() {
        return $bde2efa6d68d220c$var$l.now();
    };
} else {
    var $bde2efa6d68d220c$var$p = Date, $bde2efa6d68d220c$var$q = $bde2efa6d68d220c$var$p.now();
    $bde2efa6d68d220c$export$c4744153514ff05d = function() {
        return $bde2efa6d68d220c$var$p.now() - $bde2efa6d68d220c$var$q;
    };
}
var $bde2efa6d68d220c$var$r = [], $bde2efa6d68d220c$var$t = [], $bde2efa6d68d220c$var$u = 1, $bde2efa6d68d220c$var$v = null, $bde2efa6d68d220c$var$y = 3, $bde2efa6d68d220c$var$z = !1, $bde2efa6d68d220c$var$A = !1, $bde2efa6d68d220c$var$B = !1, $bde2efa6d68d220c$var$D = "function" === typeof setTimeout ? setTimeout : null, $bde2efa6d68d220c$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bde2efa6d68d220c$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bde2efa6d68d220c$var$G(a) {
    for(var b = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$t); null !== b;){
        if (null === b.callback) $bde2efa6d68d220c$var$k($bde2efa6d68d220c$var$t);
        else if (b.startTime <= a) $bde2efa6d68d220c$var$k($bde2efa6d68d220c$var$t), b.sortIndex = b.expirationTime, $bde2efa6d68d220c$var$f($bde2efa6d68d220c$var$r, b);
        else break;
        b = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$t);
    }
}
function $bde2efa6d68d220c$var$H(a) {
    $bde2efa6d68d220c$var$B = !1;
    $bde2efa6d68d220c$var$G(a);
    if (!$bde2efa6d68d220c$var$A) {
        if (null !== $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r)) $bde2efa6d68d220c$var$A = !0, $bde2efa6d68d220c$var$I($bde2efa6d68d220c$var$J);
        else {
            var b = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$t);
            null !== b && $bde2efa6d68d220c$var$K($bde2efa6d68d220c$var$H, b.startTime - a);
        }
    }
}
function $bde2efa6d68d220c$var$J(a, b) {
    $bde2efa6d68d220c$var$A = !1;
    $bde2efa6d68d220c$var$B && ($bde2efa6d68d220c$var$B = !1, $bde2efa6d68d220c$var$E($bde2efa6d68d220c$var$L), $bde2efa6d68d220c$var$L = -1);
    $bde2efa6d68d220c$var$z = !0;
    var c = $bde2efa6d68d220c$var$y;
    try {
        $bde2efa6d68d220c$var$G(b);
        for($bde2efa6d68d220c$var$v = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r); null !== $bde2efa6d68d220c$var$v && (!($bde2efa6d68d220c$var$v.expirationTime > b) || a && !$bde2efa6d68d220c$var$M());){
            var d = $bde2efa6d68d220c$var$v.callback;
            if ("function" === typeof d) {
                $bde2efa6d68d220c$var$v.callback = null;
                $bde2efa6d68d220c$var$y = $bde2efa6d68d220c$var$v.priorityLevel;
                var e = d($bde2efa6d68d220c$var$v.expirationTime <= b);
                b = $bde2efa6d68d220c$export$c4744153514ff05d();
                "function" === typeof e ? $bde2efa6d68d220c$var$v.callback = e : $bde2efa6d68d220c$var$v === $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r) && $bde2efa6d68d220c$var$k($bde2efa6d68d220c$var$r);
                $bde2efa6d68d220c$var$G(b);
            } else $bde2efa6d68d220c$var$k($bde2efa6d68d220c$var$r);
            $bde2efa6d68d220c$var$v = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r);
        }
        if (null !== $bde2efa6d68d220c$var$v) var w = !0;
        else {
            var m = $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$t);
            null !== m && $bde2efa6d68d220c$var$K($bde2efa6d68d220c$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bde2efa6d68d220c$var$v = null, $bde2efa6d68d220c$var$y = c, $bde2efa6d68d220c$var$z = !1;
    }
}
var $bde2efa6d68d220c$var$N = !1, $bde2efa6d68d220c$var$O = null, $bde2efa6d68d220c$var$L = -1, $bde2efa6d68d220c$var$P = 5, $bde2efa6d68d220c$var$Q = -1;
function $bde2efa6d68d220c$var$M() {
    return $bde2efa6d68d220c$export$c4744153514ff05d() - $bde2efa6d68d220c$var$Q < $bde2efa6d68d220c$var$P ? !1 : !0;
}
function $bde2efa6d68d220c$var$R() {
    if (null !== $bde2efa6d68d220c$var$O) {
        var a = $bde2efa6d68d220c$export$c4744153514ff05d();
        $bde2efa6d68d220c$var$Q = a;
        var b = !0;
        try {
            b = $bde2efa6d68d220c$var$O(!0, a);
        } finally{
            b ? $bde2efa6d68d220c$var$S() : ($bde2efa6d68d220c$var$N = !1, $bde2efa6d68d220c$var$O = null);
        }
    } else $bde2efa6d68d220c$var$N = !1;
}
var $bde2efa6d68d220c$var$S;
if ("function" === typeof $bde2efa6d68d220c$var$F) $bde2efa6d68d220c$var$S = function() {
    $bde2efa6d68d220c$var$F($bde2efa6d68d220c$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bde2efa6d68d220c$var$T = new MessageChannel, $bde2efa6d68d220c$var$U = $bde2efa6d68d220c$var$T.port2;
    $bde2efa6d68d220c$var$T.port1.onmessage = $bde2efa6d68d220c$var$R;
    $bde2efa6d68d220c$var$S = function() {
        $bde2efa6d68d220c$var$U.postMessage(null);
    };
} else $bde2efa6d68d220c$var$S = function() {
    $bde2efa6d68d220c$var$D($bde2efa6d68d220c$var$R, 0);
};
function $bde2efa6d68d220c$var$I(a) {
    $bde2efa6d68d220c$var$O = a;
    $bde2efa6d68d220c$var$N || ($bde2efa6d68d220c$var$N = !0, $bde2efa6d68d220c$var$S());
}
function $bde2efa6d68d220c$var$K(a, b) {
    $bde2efa6d68d220c$var$L = $bde2efa6d68d220c$var$D(function() {
        a($bde2efa6d68d220c$export$c4744153514ff05d());
    }, b);
}
$bde2efa6d68d220c$export$3e506c1ccc9cc1a7 = 5;
$bde2efa6d68d220c$export$e26fe2ed2fa76875 = 1;
$bde2efa6d68d220c$export$502329bbf4b505b1 = 4;
$bde2efa6d68d220c$export$6e3807111c4874c4 = 3;
$bde2efa6d68d220c$export$c27134553091fb3a = null;
$bde2efa6d68d220c$export$33ee1acdc04fd2a2 = 2;
$bde2efa6d68d220c$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bde2efa6d68d220c$export$8352ce38b91d0c62 = function() {
    $bde2efa6d68d220c$var$A || $bde2efa6d68d220c$var$z || ($bde2efa6d68d220c$var$A = !0, $bde2efa6d68d220c$var$I($bde2efa6d68d220c$var$J));
};
$bde2efa6d68d220c$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bde2efa6d68d220c$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bde2efa6d68d220c$export$d3dfb8e4810cb555 = function() {
    return $bde2efa6d68d220c$var$y;
};
$bde2efa6d68d220c$export$839f9183b0465a69 = function() {
    return $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r);
};
$bde2efa6d68d220c$export$72fdf0e06517287b = function(a) {
    switch($bde2efa6d68d220c$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bde2efa6d68d220c$var$y;
    }
    var c = $bde2efa6d68d220c$var$y;
    $bde2efa6d68d220c$var$y = b;
    try {
        return a();
    } finally{
        $bde2efa6d68d220c$var$y = c;
    }
};
$bde2efa6d68d220c$export$4b844e58a3e414b4 = function() {};
$bde2efa6d68d220c$export$816d2913ae6b83b1 = function() {};
$bde2efa6d68d220c$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bde2efa6d68d220c$var$y;
    $bde2efa6d68d220c$var$y = a;
    try {
        return b();
    } finally{
        $bde2efa6d68d220c$var$y = c;
    }
};
$bde2efa6d68d220c$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bde2efa6d68d220c$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bde2efa6d68d220c$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bde2efa6d68d220c$var$f($bde2efa6d68d220c$var$t, a), null === $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$r) && a === $bde2efa6d68d220c$var$h($bde2efa6d68d220c$var$t) && ($bde2efa6d68d220c$var$B ? ($bde2efa6d68d220c$var$E($bde2efa6d68d220c$var$L), $bde2efa6d68d220c$var$L = -1) : $bde2efa6d68d220c$var$B = !0, $bde2efa6d68d220c$var$K($bde2efa6d68d220c$var$H, c - d))) : (a.sortIndex = e, $bde2efa6d68d220c$var$f($bde2efa6d68d220c$var$r, a), $bde2efa6d68d220c$var$A || $bde2efa6d68d220c$var$z || ($bde2efa6d68d220c$var$A = !0, $bde2efa6d68d220c$var$I($bde2efa6d68d220c$var$J)));
    return a;
};
$bde2efa6d68d220c$export$b5836b71941fa3ed = $bde2efa6d68d220c$var$M;
$bde2efa6d68d220c$export$cf845f2c119da08a = function(a) {
    var b = $bde2efa6d68d220c$var$y;
    return function() {
        var c = $bde2efa6d68d220c$var$y;
        $bde2efa6d68d220c$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bde2efa6d68d220c$var$y = c;
        }
    };
};

});




parcelRegister("fPx1S", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $b8653d57b9631a89$export$306c0aa65ff9ec16; }, function (v) { return $b8653d57b9631a89$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b8653d57b9631a89$export$306c0aa65ff9ec16;
'use strict';

var $3ZYaX = parcelRequire("3ZYaX");
function $b8653d57b9631a89$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b8653d57b9631a89$var$k = "function" === typeof Object.is ? Object.is : $b8653d57b9631a89$var$h, $b8653d57b9631a89$var$l = $3ZYaX.useState, $b8653d57b9631a89$var$m = $3ZYaX.useEffect, $b8653d57b9631a89$var$n = $3ZYaX.useLayoutEffect, $b8653d57b9631a89$var$p = $3ZYaX.useDebugValue;
function $b8653d57b9631a89$var$q(a, b) {
    var d = b(), f = $b8653d57b9631a89$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $b8653d57b9631a89$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $b8653d57b9631a89$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $b8653d57b9631a89$var$m(function() {
        $b8653d57b9631a89$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $b8653d57b9631a89$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $b8653d57b9631a89$var$p(d);
    return d;
}
function $b8653d57b9631a89$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$b8653d57b9631a89$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $b8653d57b9631a89$var$t(a, b) {
    return b();
}
var $b8653d57b9631a89$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $b8653d57b9631a89$var$t : $b8653d57b9631a89$var$q;
$b8653d57b9631a89$export$306c0aa65ff9ec16 = void 0 !== $3ZYaX.useSyncExternalStore ? $3ZYaX.useSyncExternalStore : $b8653d57b9631a89$var$u;

});

parcelRegister("2KSUA", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.21';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("6eIWH", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $48a6ea3057d1576d$export$bf730a2d8bf68b42; }, function (v) { return $48a6ea3057d1576d$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $48a6ea3057d1576d$export$bf730a2d8bf68b42;
'use strict';

var $3ZYaX = parcelRequire("3ZYaX");

var $fDTdX = parcelRequire("fDTdX");
function $48a6ea3057d1576d$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $48a6ea3057d1576d$var$q = "function" === typeof Object.is ? Object.is : $48a6ea3057d1576d$var$p, $48a6ea3057d1576d$var$r = $fDTdX.useSyncExternalStore, $48a6ea3057d1576d$var$t = $3ZYaX.useRef, $48a6ea3057d1576d$var$u = $3ZYaX.useEffect, $48a6ea3057d1576d$var$v = $3ZYaX.useMemo, $48a6ea3057d1576d$var$w = $3ZYaX.useDebugValue;
$48a6ea3057d1576d$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $48a6ea3057d1576d$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $48a6ea3057d1576d$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($48a6ea3057d1576d$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $48a6ea3057d1576d$var$r(a, c[0], c[1]);
    $48a6ea3057d1576d$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $48a6ea3057d1576d$var$w(d);
    return d;
};

});
parcelRegister("fDTdX", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fPx1S"));

});


parcelRegister("f70Wr", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $b0083d77074b31be$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(_n) {
                            void 0 !== o[_n] || u(o, _n) || (f[_n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $b0083d77074b31be$export$2e2bcd8739ae039 = fn;

});

parcelRegister("ap4Qn", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $fzRvK = parcelRequire("fzRvK");

var $bAmBy = parcelRequire("bAmBy");

var $kiBtM = parcelRequire("kiBtM");

var $8InRi = parcelRequire("8InRi");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $792fff0b0994c504$var$createInstance(defaultConfig) {
    var context = new $bAmBy(defaultConfig);
    var instance = $fzRvK($bAmBy.prototype.request, context);
    // Copy axios.prototype to instance
    $fEpHk.extend(instance, $bAmBy.prototype, context);
    // Copy context to instance
    $fEpHk.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $792fff0b0994c504$var$createInstance($kiBtM(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $792fff0b0994c504$var$axios = $792fff0b0994c504$var$createInstance($8InRi);
// Expose Axios class to allow class inheritance
$792fff0b0994c504$var$axios.Axios = $bAmBy;

// Expose Cancel & CancelToken
$792fff0b0994c504$var$axios.Cancel = (parcelRequire("elw5R"));

$792fff0b0994c504$var$axios.CancelToken = (parcelRequire("hOL52"));

$792fff0b0994c504$var$axios.isCancel = (parcelRequire("aOO7p"));

$792fff0b0994c504$var$axios.VERSION = (parcelRequire("cApdT")).version;
// Expose all/spread
$792fff0b0994c504$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$792fff0b0994c504$var$axios.spread = (parcelRequire("2kTco"));

// Expose isAxiosError
$792fff0b0994c504$var$axios.isAxiosError = (parcelRequire("aicZ6"));
module.exports = $792fff0b0994c504$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $792fff0b0994c504$var$axios;

});
parcelRegister("fEpHk", function(module, exports) {
'use strict';

var $fzRvK = parcelRequire("fzRvK");
// utils is a library of generic helper functions non-specific to axios
var $b64e8679f3132718$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $b64e8679f3132718$var$isArray(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $b64e8679f3132718$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $b64e8679f3132718$var$isBuffer(val) {
    return val !== null && !$b64e8679f3132718$var$isUndefined(val) && val.constructor !== null && !$b64e8679f3132718$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $b64e8679f3132718$var$isArrayBuffer(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $b64e8679f3132718$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $b64e8679f3132718$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $b64e8679f3132718$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $b64e8679f3132718$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $b64e8679f3132718$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $b64e8679f3132718$var$isPlainObject(val) {
    if ($b64e8679f3132718$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $b64e8679f3132718$var$isDate(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $b64e8679f3132718$var$isFile(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $b64e8679f3132718$var$isBlob(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $b64e8679f3132718$var$isFunction(val) {
    return $b64e8679f3132718$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $b64e8679f3132718$var$isStream(val) {
    return $b64e8679f3132718$var$isObject(val) && $b64e8679f3132718$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $b64e8679f3132718$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $b64e8679f3132718$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $b64e8679f3132718$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $b64e8679f3132718$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($b64e8679f3132718$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $b64e8679f3132718$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($b64e8679f3132718$var$isPlainObject(result[key]) && $b64e8679f3132718$var$isPlainObject(val)) result[key] = $b64e8679f3132718$var$merge(result[key], val);
        else if ($b64e8679f3132718$var$isPlainObject(val)) result[key] = $b64e8679f3132718$var$merge({}, val);
        else if ($b64e8679f3132718$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$b64e8679f3132718$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $b64e8679f3132718$var$extend(a, b, thisArg) {
    $b64e8679f3132718$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $fzRvK(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $b64e8679f3132718$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $b64e8679f3132718$var$isArray,
    isArrayBuffer: $b64e8679f3132718$var$isArrayBuffer,
    isBuffer: $b64e8679f3132718$var$isBuffer,
    isFormData: $b64e8679f3132718$var$isFormData,
    isArrayBufferView: $b64e8679f3132718$var$isArrayBufferView,
    isString: $b64e8679f3132718$var$isString,
    isNumber: $b64e8679f3132718$var$isNumber,
    isObject: $b64e8679f3132718$var$isObject,
    isPlainObject: $b64e8679f3132718$var$isPlainObject,
    isUndefined: $b64e8679f3132718$var$isUndefined,
    isDate: $b64e8679f3132718$var$isDate,
    isFile: $b64e8679f3132718$var$isFile,
    isBlob: $b64e8679f3132718$var$isBlob,
    isFunction: $b64e8679f3132718$var$isFunction,
    isStream: $b64e8679f3132718$var$isStream,
    isURLSearchParams: $b64e8679f3132718$var$isURLSearchParams,
    isStandardBrowserEnv: $b64e8679f3132718$var$isStandardBrowserEnv,
    forEach: $b64e8679f3132718$var$forEach,
    merge: $b64e8679f3132718$var$merge,
    extend: $b64e8679f3132718$var$extend,
    trim: $b64e8679f3132718$var$trim,
    stripBOM: $b64e8679f3132718$var$stripBOM
};

});
parcelRegister("fzRvK", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("bAmBy", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $3OEy7 = parcelRequire("3OEy7");

var $fcjxu = parcelRequire("fcjxu");

var $iKJCo = parcelRequire("iKJCo");

var $kiBtM = parcelRequire("kiBtM");

var $jh6a6 = parcelRequire("jh6a6");
var $86f4975438d0363c$var$validators = $jh6a6.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $86f4975438d0363c$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $fcjxu(),
        response: new $fcjxu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $86f4975438d0363c$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $kiBtM(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $jh6a6.assertOptions(transitional, {
        silentJSONParsing: $86f4975438d0363c$var$validators.transitional($86f4975438d0363c$var$validators.boolean),
        forcedJSONParsing: $86f4975438d0363c$var$validators.transitional($86f4975438d0363c$var$validators.boolean),
        clarifyTimeoutError: $86f4975438d0363c$var$validators.transitional($86f4975438d0363c$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $iKJCo,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $iKJCo(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$86f4975438d0363c$var$Axios.prototype.getUri = function getUri(config) {
    config = $kiBtM(this.defaults, config);
    return $3OEy7(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$fEpHk.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $86f4975438d0363c$var$Axios.prototype[method] = function(url, config) {
        return this.request($kiBtM(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$fEpHk.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $86f4975438d0363c$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($kiBtM(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $86f4975438d0363c$var$Axios;

});
parcelRegister("3OEy7", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
function $2c757ede6ca43b94$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($fEpHk.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $fEpHk.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($fEpHk.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $fEpHk.forEach(val, function parseValue(v) {
                if ($fEpHk.isDate(v)) v = v.toISOString();
                else if ($fEpHk.isObject(v)) v = JSON.stringify(v);
                parts.push($2c757ede6ca43b94$var$encode(key) + '=' + $2c757ede6ca43b94$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("fcjxu", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
function $b107220cebc3e710$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $b107220cebc3e710$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $b107220cebc3e710$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $b107220cebc3e710$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $fEpHk.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $b107220cebc3e710$var$InterceptorManager;

});

parcelRegister("iKJCo", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $4jhu6 = parcelRequire("4jhu6");

var $aOO7p = parcelRequire("aOO7p");

var $8InRi = parcelRequire("8InRi");

var $elw5R = parcelRequire("elw5R");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $da6fe8b163a8fb62$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $elw5R('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $da6fe8b163a8fb62$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $4jhu6.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $fEpHk.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $fEpHk.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $8InRi.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $da6fe8b163a8fb62$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $4jhu6.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$aOO7p(reason)) {
            $da6fe8b163a8fb62$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $4jhu6.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("4jhu6", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $8InRi = parcelRequire("8InRi");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $8InRi;
    /*eslint no-param-reassign:0*/ $fEpHk.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("8InRi", function(module, exports) {

var $azxOk = parcelRequire("azxOk");
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $hJyw6 = parcelRequire("hJyw6");

var $eRzmw = parcelRequire("eRzmw");
var $6584f09e848975f5$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $6584f09e848975f5$var$setContentTypeIfUnset(headers, value) {
    if (!$fEpHk.isUndefined(headers) && $fEpHk.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}


function $6584f09e848975f5$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("i3OX1"));
    else if (typeof $azxOk !== 'undefined' && Object.prototype.toString.call($azxOk) === '[object process]') // For node use HTTP adapter
    adapter = (parcelRequire("i3OX1"));
    return adapter;
}
function $6584f09e848975f5$var$stringifySafely(rawValue, parser, encoder) {
    if ($fEpHk.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $fEpHk.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $6584f09e848975f5$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $6584f09e848975f5$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $hJyw6(headers, 'Accept');
            $hJyw6(headers, 'Content-Type');
            if ($fEpHk.isFormData(data) || $fEpHk.isArrayBuffer(data) || $fEpHk.isBuffer(data) || $fEpHk.isStream(data) || $fEpHk.isFile(data) || $fEpHk.isBlob(data)) return data;
            if ($fEpHk.isArrayBufferView(data)) return data.buffer;
            if ($fEpHk.isURLSearchParams(data)) {
                $6584f09e848975f5$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($fEpHk.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $6584f09e848975f5$var$setContentTypeIfUnset(headers, 'application/json');
                return $6584f09e848975f5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $6584f09e848975f5$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $fEpHk.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $eRzmw(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$fEpHk.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $6584f09e848975f5$var$defaults.headers[method] = {};
});
$fEpHk.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $6584f09e848975f5$var$defaults.headers[method] = $fEpHk.merge($6584f09e848975f5$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $6584f09e848975f5$var$defaults;

});
parcelRegister("azxOk", function(module, exports) {
// shim for using process in browser
var $7b2766631c4d901a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $7b2766631c4d901a$var$cachedSetTimeout;
var $7b2766631c4d901a$var$cachedClearTimeout;
function $7b2766631c4d901a$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $7b2766631c4d901a$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $7b2766631c4d901a$var$cachedSetTimeout = setTimeout;
        else $7b2766631c4d901a$var$cachedSetTimeout = $7b2766631c4d901a$var$defaultSetTimout;
    } catch (e) {
        $7b2766631c4d901a$var$cachedSetTimeout = $7b2766631c4d901a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $7b2766631c4d901a$var$cachedClearTimeout = clearTimeout;
        else $7b2766631c4d901a$var$cachedClearTimeout = $7b2766631c4d901a$var$defaultClearTimeout;
    } catch (e) {
        $7b2766631c4d901a$var$cachedClearTimeout = $7b2766631c4d901a$var$defaultClearTimeout;
    }
})();
function $7b2766631c4d901a$var$runTimeout(fun) {
    if ($7b2766631c4d901a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($7b2766631c4d901a$var$cachedSetTimeout === $7b2766631c4d901a$var$defaultSetTimout || !$7b2766631c4d901a$var$cachedSetTimeout) && setTimeout) {
        $7b2766631c4d901a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7b2766631c4d901a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $7b2766631c4d901a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $7b2766631c4d901a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $7b2766631c4d901a$var$runClearTimeout(marker) {
    if ($7b2766631c4d901a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($7b2766631c4d901a$var$cachedClearTimeout === $7b2766631c4d901a$var$defaultClearTimeout || !$7b2766631c4d901a$var$cachedClearTimeout) && clearTimeout) {
        $7b2766631c4d901a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $7b2766631c4d901a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $7b2766631c4d901a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $7b2766631c4d901a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $7b2766631c4d901a$var$queue = [];
var $7b2766631c4d901a$var$draining = false;
var $7b2766631c4d901a$var$currentQueue;
var $7b2766631c4d901a$var$queueIndex = -1;
function $7b2766631c4d901a$var$cleanUpNextTick() {
    if (!$7b2766631c4d901a$var$draining || !$7b2766631c4d901a$var$currentQueue) return;
    $7b2766631c4d901a$var$draining = false;
    if ($7b2766631c4d901a$var$currentQueue.length) $7b2766631c4d901a$var$queue = $7b2766631c4d901a$var$currentQueue.concat($7b2766631c4d901a$var$queue);
    else $7b2766631c4d901a$var$queueIndex = -1;
    if ($7b2766631c4d901a$var$queue.length) $7b2766631c4d901a$var$drainQueue();
}
function $7b2766631c4d901a$var$drainQueue() {
    if ($7b2766631c4d901a$var$draining) return;
    var timeout = $7b2766631c4d901a$var$runTimeout($7b2766631c4d901a$var$cleanUpNextTick);
    $7b2766631c4d901a$var$draining = true;
    var len = $7b2766631c4d901a$var$queue.length;
    while(len){
        $7b2766631c4d901a$var$currentQueue = $7b2766631c4d901a$var$queue;
        $7b2766631c4d901a$var$queue = [];
        while(++$7b2766631c4d901a$var$queueIndex < len)if ($7b2766631c4d901a$var$currentQueue) $7b2766631c4d901a$var$currentQueue[$7b2766631c4d901a$var$queueIndex].run();
        $7b2766631c4d901a$var$queueIndex = -1;
        len = $7b2766631c4d901a$var$queue.length;
    }
    $7b2766631c4d901a$var$currentQueue = null;
    $7b2766631c4d901a$var$draining = false;
    $7b2766631c4d901a$var$runClearTimeout(timeout);
}
$7b2766631c4d901a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $7b2766631c4d901a$var$queue.push(new $7b2766631c4d901a$var$Item(fun, args));
    if ($7b2766631c4d901a$var$queue.length === 1 && !$7b2766631c4d901a$var$draining) $7b2766631c4d901a$var$runTimeout($7b2766631c4d901a$var$drainQueue);
};
// v8 likes predictible objects
function $7b2766631c4d901a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$7b2766631c4d901a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$7b2766631c4d901a$var$process.title = 'browser';
$7b2766631c4d901a$var$process.browser = true;
$7b2766631c4d901a$var$process.env = {};
$7b2766631c4d901a$var$process.argv = [];
$7b2766631c4d901a$var$process.version = ''; // empty string to avoid regexp issues
$7b2766631c4d901a$var$process.versions = {};
function $7b2766631c4d901a$var$noop() {}
$7b2766631c4d901a$var$process.on = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.addListener = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.once = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.off = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.removeListener = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.removeAllListeners = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.emit = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.prependListener = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.prependOnceListener = $7b2766631c4d901a$var$noop;
$7b2766631c4d901a$var$process.listeners = function(name) {
    return [];
};
$7b2766631c4d901a$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$7b2766631c4d901a$var$process.cwd = function() {
    return '/';
};
$7b2766631c4d901a$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$7b2766631c4d901a$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hJyw6", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $fEpHk.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("eRzmw", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("i3OX1", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");

var $1ANXA = parcelRequire("1ANXA");

var $a5S23 = parcelRequire("a5S23");

var $3OEy7 = parcelRequire("3OEy7");

var $6BDtY = parcelRequire("6BDtY");

var $lIOKp = parcelRequire("lIOKp");

var $lAwSe = parcelRequire("lAwSe");

var $ij1Qq = parcelRequire("ij1Qq");

var $8InRi = parcelRequire("8InRi");

var $elw5R = parcelRequire("elw5R");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($fEpHk.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $6BDtY(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $3OEy7(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $lIOKp(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1ANXA(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($ij1Qq('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($ij1Qq('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $8InRi.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($ij1Qq(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($fEpHk.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $lAwSe(fullPath)) && config.xsrfCookieName ? $a5S23.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $fEpHk.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$fEpHk.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $elw5R('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("1ANXA", function(module, exports) {
'use strict';

var $ij1Qq = parcelRequire("ij1Qq");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($ij1Qq('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("ij1Qq", function(module, exports) {
'use strict';

var $eRzmw = parcelRequire("eRzmw");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $eRzmw(error, config, code, request, response);
};

});


parcelRegister("a5S23", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
module.exports = $fEpHk.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($fEpHk.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($fEpHk.isString(path)) cookie.push('path=' + path);
            if ($fEpHk.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("6BDtY", function(module, exports) {
'use strict';

var $88TX3 = parcelRequire("88TX3");

var $cO3eA = parcelRequire("cO3eA");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$88TX3(requestedURL)) return $cO3eA(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("88TX3", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("cO3eA", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("lIOKp", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fd0512706f4f6ff1$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $fEpHk.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $fEpHk.trim(line.substr(0, i)).toLowerCase();
        val = $fEpHk.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fd0512706f4f6ff1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("lAwSe", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
module.exports = $fEpHk.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $fEpHk.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("elw5R", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $a71bebf778ef026d$var$Cancel(message) {
    this.message = message;
}
$a71bebf778ef026d$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$a71bebf778ef026d$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $a71bebf778ef026d$var$Cancel;

});




parcelRegister("aOO7p", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("kiBtM", function(module, exports) {
'use strict';

var $fEpHk = parcelRequire("fEpHk");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($fEpHk.isPlainObject(target) && $fEpHk.isPlainObject(source)) return $fEpHk.merge(target, source);
        else if ($fEpHk.isPlainObject(source)) return $fEpHk.merge({}, source);
        else if ($fEpHk.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$fEpHk.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$fEpHk.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$fEpHk.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$fEpHk.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$fEpHk.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $fEpHk.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $fEpHk.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("jh6a6", function(module, exports) {
'use strict';

var $cApdT = parcelRequire("cApdT");
var $e0846278efe3eb5c$require$VERSION = $cApdT.version;
var $e0846278efe3eb5c$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $e0846278efe3eb5c$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $e0846278efe3eb5c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $e0846278efe3eb5c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $e0846278efe3eb5c$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$e0846278efe3eb5c$var$deprecatedWarnings[opt]) {
            $e0846278efe3eb5c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $e0846278efe3eb5c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $e0846278efe3eb5c$var$assertOptions,
    validators: $e0846278efe3eb5c$var$validators
};

});
parcelRegister("cApdT", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("hOL52", function(module, exports) {
'use strict';

var $elw5R = parcelRequire("elw5R");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $cf8ba054573ff060$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $elw5R(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $cf8ba054573ff060$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $cf8ba054573ff060$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $cf8ba054573ff060$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $cf8ba054573ff060$var$CancelToken.source = function source() {
    var cancel;
    var token = new $cf8ba054573ff060$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $cf8ba054573ff060$var$CancelToken;

});

parcelRegister("2kTco", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("aicZ6", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("i1cQJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Field", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_field["default"];
    }
});
Object.defineProperty(module.exports, "Control", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_control["default"];
    }
});
Object.defineProperty(module.exports, "Input", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_input["default"];
    }
});
Object.defineProperty(module.exports, "Label", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_label["default"];
    }
});
Object.defineProperty(module.exports, "Textarea", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_textarea["default"];
    }
});
Object.defineProperty(module.exports, "Select", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_select["default"];
    }
});
Object.defineProperty(module.exports, "Checkbox", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_checkbox["default"];
    }
});
Object.defineProperty(module.exports, "Radio", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_radio["default"];
    }
});
Object.defineProperty(module.exports, "Help", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_help["default"];
    }
});
Object.defineProperty(module.exports, "InputFile", {
    enumerable: true,
    get: function get() {
        return $d1e2499ef56afa2a$var$_inputFile["default"];
    }
});

var $d1e2499ef56afa2a$var$_field = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("5G5eE")));

var $d1e2499ef56afa2a$var$_control = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("dtgso")));

var $d1e2499ef56afa2a$var$_input = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("6TL8a")));

var $d1e2499ef56afa2a$var$_label = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("4E8AF")));

var $d1e2499ef56afa2a$var$_textarea = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("fJzEe")));

var $d1e2499ef56afa2a$var$_select = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("7yqE3")));

var $d1e2499ef56afa2a$var$_checkbox = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("9qcsG")));

var $d1e2499ef56afa2a$var$_radio = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("ahSAq")));

var $d1e2499ef56afa2a$var$_help = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("grhJL")));

var $d1e2499ef56afa2a$var$_inputFile = $d1e2499ef56afa2a$var$_interopRequireDefault((parcelRequire("ijjDf")));
function $d1e2499ef56afa2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("5G5eE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $4224ef9dceffd911$var$_field["default"];
    }
});

var $4224ef9dceffd911$var$_field = $4224ef9dceffd911$var$_interopRequireDefault((parcelRequire("jL2do")));
function $4224ef9dceffd911$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("jL2do", function(module, exports) {
"use strict";
function $e6241ff2c639c56c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e6241ff2c639c56c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $e6241ff2c639c56c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e6241ff2c639c56c$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e6241ff2c639c56c$var$_react = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e6241ff2c639c56c$var$_propTypes = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $e6241ff2c639c56c$var$_classnames2 = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e6241ff2c639c56c$var$_fieldLabel = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("6MrI6")));

var $e6241ff2c639c56c$var$_fieldBody = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("5peho")));

var $e6241ff2c639c56c$var$_element = $e6241ff2c639c56c$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $1tqZN = parcelRequire("1tqZN");

var $e6241ff2c639c56c$var$_context = $e6241ff2c639c56c$var$_interopRequireWildcard((parcelRequire("8c2pz")));
function $e6241ff2c639c56c$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $e6241ff2c639c56c$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $e6241ff2c639c56c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $e6241ff2c639c56c$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $e6241ff2c639c56c$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $e6241ff2c639c56c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e6241ff2c639c56c$var$_extends() {
    $e6241ff2c639c56c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e6241ff2c639c56c$var$_extends.apply(this, arguments);
}
function $e6241ff2c639c56c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e6241ff2c639c56c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e6241ff2c639c56c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e6241ff2c639c56c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e6241ff2c639c56c$var$Field = function Field(_ref) {
    var _classnames;
    var className = _ref.className, align = _ref.align, multiline = _ref.multiline, horizontal = _ref.horizontal, kind = _ref.kind, size = _ref.size, props = $e6241ff2c639c56c$var$_objectWithoutProperties(_ref, [
        "className",
        "align",
        "multiline",
        "horizontal",
        "kind",
        "size"
    ]);
    var context = (0, $e6241ff2c639c56c$var$_context["default"])();
    var k = null;
    if (kind === 'addons') k = 'has-addons';
    else if (kind === 'group') k = 'is-grouped';
    return /*#__PURE__*/ $e6241ff2c639c56c$var$_react["default"].createElement($e6241ff2c639c56c$var$_context.FieldContext.Provider, {
        value: {
            size: size || context.size
        }
    }, /*#__PURE__*/ $e6241ff2c639c56c$var$_react["default"].createElement($e6241ff2c639c56c$var$_element["default"], $e6241ff2c639c56c$var$_extends({}, props, {
        className: (0, $e6241ff2c639c56c$var$_classnames2["default"])('field', className, (_classnames = {}, $e6241ff2c639c56c$var$_defineProperty(_classnames, "".concat(k), k), $e6241ff2c639c56c$var$_defineProperty(_classnames, "".concat(k, "-").concat((0, $1tqZN.normalizeAlign)(align)), k === 'is-grouped' && align), $e6241ff2c639c56c$var$_defineProperty(_classnames, "".concat(k, "-multiline"), k === 'is-grouped' && multiline), $e6241ff2c639c56c$var$_defineProperty(_classnames, 'is-horizontal', horizontal), _classnames))
    })));
};
$e6241ff2c639c56c$var$Field.Label = $e6241ff2c639c56c$var$_fieldLabel["default"];
$e6241ff2c639c56c$var$Field.Body = $e6241ff2c639c56c$var$_fieldBody["default"];
$e6241ff2c639c56c$var$Field.defaultProps = {};
var $e6241ff2c639c56c$var$_default = $e6241ff2c639c56c$var$Field;
module.exports["default"] = $e6241ff2c639c56c$var$_default;

});
parcelRegister("9C0qR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6ff7ff862d7a82f5$var$ReactIs, $6ff7ff862d7a82f5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("5Wfvc"))();

});
parcelRegister("5Wfvc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $hFFwz = parcelRequire("hFFwz");
function $452e64ed1ae8d652$var$emptyFunction() {}
function $452e64ed1ae8d652$var$emptyFunctionWithReset() {}
$452e64ed1ae8d652$var$emptyFunctionWithReset.resetWarningCache = $452e64ed1ae8d652$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $hFFwz) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $452e64ed1ae8d652$var$emptyFunctionWithReset,
        resetWarningCache: $452e64ed1ae8d652$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("hFFwz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $cdd679e0363db633$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $cdd679e0363db633$var$ReactPropTypesSecret;

});



parcelRegister("ehbpI", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === 'string' || argType === 'number') classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === 'object') {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(' ');
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("6MrI6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4efcb87d69cf1002$var$_react = $4efcb87d69cf1002$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $4efcb87d69cf1002$var$_propTypes = $4efcb87d69cf1002$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $4efcb87d69cf1002$var$_classnames2 = $4efcb87d69cf1002$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $4efcb87d69cf1002$var$_element = $4efcb87d69cf1002$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $4efcb87d69cf1002$var$_context = $4efcb87d69cf1002$var$_interopRequireDefault((parcelRequire("8c2pz")));
function $4efcb87d69cf1002$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4efcb87d69cf1002$var$_extends() {
    $4efcb87d69cf1002$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4efcb87d69cf1002$var$_extends.apply(this, arguments);
}
function $4efcb87d69cf1002$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4efcb87d69cf1002$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4efcb87d69cf1002$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4efcb87d69cf1002$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4efcb87d69cf1002$var$FieldLabel = function FieldLabel(_ref) {
    var className = _ref.className, size = _ref.size, props = $4efcb87d69cf1002$var$_objectWithoutProperties(_ref, [
        "className",
        "size"
    ]);
    var context = (0, $4efcb87d69cf1002$var$_context["default"])();
    return /*#__PURE__*/ $4efcb87d69cf1002$var$_react["default"].createElement($4efcb87d69cf1002$var$_element["default"], $4efcb87d69cf1002$var$_extends({}, props, {
        className: (0, $4efcb87d69cf1002$var$_classnames2["default"])('field-label', className, $4efcb87d69cf1002$var$_defineProperty({}, "is-".concat(size), size || context.size))
    }));
};
$4efcb87d69cf1002$var$FieldLabel.defaultProps = {};
var $4efcb87d69cf1002$var$_default = $4efcb87d69cf1002$var$FieldLabel;
module.exports["default"] = $4efcb87d69cf1002$var$_default;

});
parcelRegister("bQWwh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8a11f1d7c35c17b4$var$_element = $8a11f1d7c35c17b4$var$_interopRequireDefault((parcelRequire("9dxK4")));
function $8a11f1d7c35c17b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $8a11f1d7c35c17b4$var$_default = $8a11f1d7c35c17b4$var$_element["default"];
module.exports["default"] = $8a11f1d7c35c17b4$var$_default;

});
parcelRegister("9dxK4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.useElementClassNames = void 0;

var $6b5f8069271a950d$var$_react = $6b5f8069271a950d$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $6b5f8069271a950d$var$_propTypes = $6b5f8069271a950d$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $6b5f8069271a950d$var$_classnames3 = $6b5f8069271a950d$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $1tqZN = parcelRequire("1tqZN");
function $6b5f8069271a950d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6b5f8069271a950d$var$_extends() {
    $6b5f8069271a950d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b5f8069271a950d$var$_extends.apply(this, arguments);
}
function $6b5f8069271a950d$var$_slicedToArray(arr, i) {
    return $6b5f8069271a950d$var$_arrayWithHoles(arr) || $6b5f8069271a950d$var$_iterableToArrayLimit(arr, i) || $6b5f8069271a950d$var$_unsupportedIterableToArray(arr, i) || $6b5f8069271a950d$var$_nonIterableRest();
}
function $6b5f8069271a950d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b5f8069271a950d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6b5f8069271a950d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b5f8069271a950d$var$_arrayLikeToArray(o, minLen);
}
function $6b5f8069271a950d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b5f8069271a950d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6b5f8069271a950d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $6b5f8069271a950d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6b5f8069271a950d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6b5f8069271a950d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b5f8069271a950d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6b5f8069271a950d$var$buildResponsiveness = function buildResponsiveness(currentViewport) {
    var _classnames;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, display = _ref.display, textAlign = _ref.textAlign, textSize = _ref.textSize, only = _ref.only, invisible = _ref.invisible;
    var suffix = only ? '-only' : '';
    return (0, $6b5f8069271a950d$var$_classnames3["default"])((_classnames = {}, $6b5f8069271a950d$var$_defineProperty(_classnames, "is-".concat(display, "-").concat(currentViewport).concat(suffix), display), $6b5f8069271a950d$var$_defineProperty(_classnames, "has-text-".concat((0, $1tqZN.normalizeAlign)(textAlign), "-").concat(currentViewport).concat(suffix), textAlign), $6b5f8069271a950d$var$_defineProperty(_classnames, "is-size-".concat(textSize, "-").concat(currentViewport).concat(suffix), textSize), $6b5f8069271a950d$var$_defineProperty(_classnames, "is-invisible-".concat(currentViewport).concat(suffix), invisible), _classnames));
};
var $6b5f8069271a950d$var$useElementClassNames = function useElementClassNames(_ref2) {
    var _classnames2;
    var textColor = _ref2.textColor, backgroundColor = _ref2.backgroundColor, colorVariant = _ref2.colorVariant, flexDirection = _ref2.flexDirection, flexWrap = _ref2.flexWrap, justifyContent = _ref2.justifyContent, alignContent = _ref2.alignContent, alignItems = _ref2.alignItems, flexGrow = _ref2.flexGrow, ratio = _ref2.ratio, clearfix = _ref2.clearfix, paddingless = _ref2.paddingless, pull = _ref2.pull, marginless = _ref2.marginless, overlay = _ref2.overlay, clipped = _ref2.clipped, radiusless = _ref2.radiusless, shadowless = _ref2.shadowless, unselectable = _ref2.unselectable, invisible = _ref2.invisible, clickable = _ref2.clickable, srOnly = _ref2.srOnly, display = _ref2.display, m = _ref2.m, mt = _ref2.mt, mr = _ref2.mr, mb = _ref2.mb, ml = _ref2.ml, mx = _ref2.mx, my = _ref2.my, p = _ref2.p, pt = _ref2.pt, pr = _ref2.pr, pb = _ref2.pb, pl = _ref2.pl, px = _ref2.px, py = _ref2.py, textWeight = _ref2.textWeight, textTransform = _ref2.textTransform, italic = _ref2.italic, textSize = _ref2.textSize, textAlign = _ref2.textAlign, textFamily = _ref2.textFamily, mobile = _ref2.mobile, tablet = _ref2.tablet, desktop = _ref2.desktop, widescreen = _ref2.widescreen, fullhd = _ref2.fullhd, touch = _ref2.touch, untilWidescreen = _ref2.untilWidescreen, untilFullhd = _ref2.untilFullhd, props = $6b5f8069271a950d$var$_objectWithoutProperties(_ref2, [
        "textColor",
        "backgroundColor",
        "colorVariant",
        "flexDirection",
        "flexWrap",
        "justifyContent",
        "alignContent",
        "alignItems",
        "flexGrow",
        "ratio",
        "clearfix",
        "paddingless",
        "pull",
        "marginless",
        "overlay",
        "clipped",
        "radiusless",
        "shadowless",
        "unselectable",
        "invisible",
        "clickable",
        "srOnly",
        "display",
        "m",
        "mt",
        "mr",
        "mb",
        "ml",
        "mx",
        "my",
        "p",
        "pt",
        "pr",
        "pb",
        "pl",
        "px",
        "py",
        "textWeight",
        "textTransform",
        "italic",
        "textSize",
        "textAlign",
        "textFamily",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch",
        "untilWidescreen",
        "untilFullhd"
    ]);
    return [
        (0, $6b5f8069271a950d$var$_classnames3["default"])((_classnames2 = {}, $6b5f8069271a950d$var$_defineProperty(_classnames2, "has-text-".concat(textColor), textColor), $6b5f8069271a950d$var$_defineProperty(_classnames2, "has-background-".concat(backgroundColor), backgroundColor), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-".concat(colorVariant), colorVariant), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-flex-direction-".concat(flexDirection), flexDirection), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-flex-wrap-".concat(flexWrap), flexWrap), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-justify-content-".concat(justifyContent), justifyContent), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-align-content-".concat(alignContent), alignContent), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-align-items-".concat(alignItems), alignItems), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-flex-grow-".concat(flexGrow), flexGrow), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-clearfix', clearfix), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-pulled-".concat(pull), pull), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-marginless', marginless), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-paddingless', paddingless), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-overlay', overlay), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-clipped', clipped), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-radiusless', radiusless), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-shadowless', shadowless), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-unselectable', unselectable), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-".concat(display), display), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-invisible', invisible), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-sr-only', srOnly), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-clickable', clickable), $6b5f8069271a950d$var$_defineProperty(_classnames2, "m-".concat(m), m), $6b5f8069271a950d$var$_defineProperty(_classnames2, "mt-".concat(mt), mt), $6b5f8069271a950d$var$_defineProperty(_classnames2, "mr-".concat(mr), mr), $6b5f8069271a950d$var$_defineProperty(_classnames2, "mb-".concat(mb), mb), $6b5f8069271a950d$var$_defineProperty(_classnames2, "ml-".concat(ml), ml), $6b5f8069271a950d$var$_defineProperty(_classnames2, "mx-".concat(mx), mx), $6b5f8069271a950d$var$_defineProperty(_classnames2, "my-".concat(my), my), $6b5f8069271a950d$var$_defineProperty(_classnames2, "p-".concat(p), p), $6b5f8069271a950d$var$_defineProperty(_classnames2, "pt-".concat(pt), pt), $6b5f8069271a950d$var$_defineProperty(_classnames2, "pr-".concat(pr), pr), $6b5f8069271a950d$var$_defineProperty(_classnames2, "pb-".concat(pb), pb), $6b5f8069271a950d$var$_defineProperty(_classnames2, "pl-".concat(pl), pl), $6b5f8069271a950d$var$_defineProperty(_classnames2, "px-".concat(px), px), $6b5f8069271a950d$var$_defineProperty(_classnames2, "py-".concat(py), py), $6b5f8069271a950d$var$_defineProperty(_classnames2, "has-text-".concat((0, $1tqZN.normalizeAlign)(textAlign)), textAlign), $6b5f8069271a950d$var$_defineProperty(_classnames2, "has-text-weight-".concat(textWeight), textWeight), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-size-".concat(textSize), textSize), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-".concat(textTransform), textTransform), $6b5f8069271a950d$var$_defineProperty(_classnames2, "is-family-".concat(textFamily), textFamily), $6b5f8069271a950d$var$_defineProperty(_classnames2, 'is-italic', italic), _classnames2), $6b5f8069271a950d$var$buildResponsiveness('mobile', mobile), $6b5f8069271a950d$var$buildResponsiveness('tablet', tablet), $6b5f8069271a950d$var$buildResponsiveness('desktop', desktop), $6b5f8069271a950d$var$buildResponsiveness('widescreen', widescreen), $6b5f8069271a950d$var$buildResponsiveness('fullhd', fullhd), $6b5f8069271a950d$var$buildResponsiveness('touch', touch), $6b5f8069271a950d$var$buildResponsiveness('until-widescreen', untilWidescreen), $6b5f8069271a950d$var$buildResponsiveness('until-fullhd', untilFullhd)),
        props
    ];
};
module.exports.useElementClassNames = $6b5f8069271a950d$var$useElementClassNames;
var $6b5f8069271a950d$var$Element = function Element(_ref3) {
    var className = _ref3.className, renderAs = _ref3.renderAs, domRef = _ref3.domRef, children = _ref3.children, allProps = $6b5f8069271a950d$var$_objectWithoutProperties(_ref3, [
        "className",
        "renderAs",
        "domRef",
        "children"
    ]);
    var RenderAs = renderAs;
    var _useElementClassNames = $6b5f8069271a950d$var$useElementClassNames(allProps), _useElementClassNames2 = $6b5f8069271a950d$var$_slicedToArray(_useElementClassNames, 2), classNames = _useElementClassNames2[0], props = _useElementClassNames2[1];
    return /*#__PURE__*/ $6b5f8069271a950d$var$_react["default"].createElement(RenderAs, $6b5f8069271a950d$var$_extends({
        ref: domRef,
        className: (0, $6b5f8069271a950d$var$_classnames3["default"])(className, classNames) || undefined
    }, props), children);
};
$6b5f8069271a950d$var$Element.defaultProps = {
    renderAs: 'div'
};
var $6b5f8069271a950d$var$_default = $6b5f8069271a950d$var$Element;
module.exports["default"] = $6b5f8069271a950d$var$_default;

});
parcelRegister("1tqZN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeStatus = module.exports.normalizeAlign = void 0;
var $112d70ad1314517f$var$normalizeAlign = function normalizeAlign(align) {
    var map = {
        justify: 'justifyed',
        center: 'centered'
    };
    return map[align] || align;
};
module.exports.normalizeAlign = $112d70ad1314517f$var$normalizeAlign;
var $112d70ad1314517f$var$normalizeStatus = function normalizeStatus(status) {
    var map = {
        focus: 'focused',
        hover: 'hovered',
        active: 'active'
    };
    return map[status] || status;
};
module.exports.normalizeStatus = $112d70ad1314517f$var$normalizeStatus;

});



parcelRegister("8c2pz", function(module, exports) {
"use strict";
function $5f715094a55425b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5f715094a55425b4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5f715094a55425b4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5f715094a55425b4$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.FieldContext = void 0;

var $5f715094a55425b4$var$_react = $5f715094a55425b4$var$_interopRequireWildcard((parcelRequire("3ZYaX")));
function $5f715094a55425b4$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $5f715094a55425b4$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $5f715094a55425b4$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $5f715094a55425b4$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $5f715094a55425b4$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $5f715094a55425b4$var$FieldContext = /*#__PURE__*/ $5f715094a55425b4$var$_react["default"].createContext({
    size: undefined
});
module.exports.FieldContext = $5f715094a55425b4$var$FieldContext;
var $5f715094a55425b4$var$useFieldContext = function useFieldContext() {
    return (0, $5f715094a55425b4$var$_react.useContext)($5f715094a55425b4$var$FieldContext);
};
var $5f715094a55425b4$var$_default = $5f715094a55425b4$var$useFieldContext;
module.exports["default"] = $5f715094a55425b4$var$_default;

});


parcelRegister("5peho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3efa5d2ef70508f3$var$_react = $3efa5d2ef70508f3$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $3efa5d2ef70508f3$var$_classnames = $3efa5d2ef70508f3$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3efa5d2ef70508f3$var$_element = $3efa5d2ef70508f3$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $3efa5d2ef70508f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3efa5d2ef70508f3$var$_extends() {
    $3efa5d2ef70508f3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3efa5d2ef70508f3$var$_extends.apply(this, arguments);
}
function $3efa5d2ef70508f3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3efa5d2ef70508f3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3efa5d2ef70508f3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3efa5d2ef70508f3$var$FieldBody = function FieldBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $3efa5d2ef70508f3$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $3efa5d2ef70508f3$var$_react["default"].createElement($3efa5d2ef70508f3$var$_element["default"], $3efa5d2ef70508f3$var$_extends({}, props, {
        className: (0, $3efa5d2ef70508f3$var$_classnames["default"])('field-body', className, {})
    }), children);
};
$3efa5d2ef70508f3$var$FieldBody.defaultProps = {};
var $3efa5d2ef70508f3$var$_default = $3efa5d2ef70508f3$var$FieldBody;
module.exports["default"] = $3efa5d2ef70508f3$var$_default;

});



parcelRegister("dtgso", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9ceabfc9e7ef2cf8$var$_react = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9ceabfc9e7ef2cf8$var$_propTypes = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $9ceabfc9e7ef2cf8$var$_classnames = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9ceabfc9e7ef2cf8$var$_element = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $9ceabfc9e7ef2cf8$var$_icon = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("71Via")));

var $9ceabfc9e7ef2cf8$var$_context = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("8c2pz")));

var $9ceabfc9e7ef2cf8$var$_button = $9ceabfc9e7ef2cf8$var$_interopRequireDefault((parcelRequire("7aX84")));
function $9ceabfc9e7ef2cf8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9ceabfc9e7ef2cf8$var$_extends() {
    $9ceabfc9e7ef2cf8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9ceabfc9e7ef2cf8$var$_extends.apply(this, arguments);
}
function $9ceabfc9e7ef2cf8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9ceabfc9e7ef2cf8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9ceabfc9e7ef2cf8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9ceabfc9e7ef2cf8$var$Control = function Control(_ref) {
    var children = _ref.children, className = _ref.className, fullwidth = _ref.fullwidth, loading = _ref.loading, iconType = _ref.iconType, props = $9ceabfc9e7ef2cf8$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "fullwidth",
        "loading",
        "iconType"
    ]);
    var context = (0, $9ceabfc9e7ef2cf8$var$_context["default"])();
    var isIcon = function isIcon(child) {
        return child.type === (iconType || $9ceabfc9e7ef2cf8$var$_icon["default"]) && (child.props.align === 'left' || child.props.align === 'right');
    };
    var updatedChildren = $9ceabfc9e7ef2cf8$var$_react["default"].Children.map(children, function(child) {
        if (!child || !isIcon(child) && child.type !== $9ceabfc9e7ef2cf8$var$_button["default"]) return child;
        return /*#__PURE__*/ $9ceabfc9e7ef2cf8$var$_react["default"].cloneElement(child, {
            size: child.props.size || context.size
        });
    });
    var icons = $9ceabfc9e7ef2cf8$var$_react["default"].Children.toArray(updatedChildren).filter(isIcon).reduce(function(acc, icon) {
        return {
            iconLeft: acc.iconLeft || icon.props.align === 'left',
            iconRight: acc.iconRight || icon.props.align === 'right'
        };
    }, {
        iconLeft: false,
        iconRight: false
    });
    return /*#__PURE__*/ $9ceabfc9e7ef2cf8$var$_react["default"].createElement($9ceabfc9e7ef2cf8$var$_element["default"], $9ceabfc9e7ef2cf8$var$_extends({}, props, {
        className: (0, $9ceabfc9e7ef2cf8$var$_classnames["default"])('control', className, {
            'is-expanded': fullwidth,
            'has-icons-left': icons.iconLeft,
            'has-icons-right': icons.iconRight,
            'is-loading': loading
        })
    }), updatedChildren);
};
$9ceabfc9e7ef2cf8$var$Control.defaultProps = {};
var $9ceabfc9e7ef2cf8$var$_default = $9ceabfc9e7ef2cf8$var$Control;
module.exports["default"] = $9ceabfc9e7ef2cf8$var$_default;

});
parcelRegister("71Via", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $51e511606cc4a0fa$var$_icon = $51e511606cc4a0fa$var$_interopRequireDefault((parcelRequire("5bGoK")));
function $51e511606cc4a0fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $51e511606cc4a0fa$var$_default = $51e511606cc4a0fa$var$_icon["default"];
module.exports["default"] = $51e511606cc4a0fa$var$_default;

});
parcelRegister("5bGoK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3c6ede3caf3264d7$var$_react = $3c6ede3caf3264d7$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $3c6ede3caf3264d7$var$_propTypes = $3c6ede3caf3264d7$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $3c6ede3caf3264d7$var$_classnames2 = $3c6ede3caf3264d7$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3c6ede3caf3264d7$var$_text = $3c6ede3caf3264d7$var$_interopRequireDefault((parcelRequire("k9uG3")));

var $3c6ede3caf3264d7$var$_element = $3c6ede3caf3264d7$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $3c6ede3caf3264d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3c6ede3caf3264d7$var$_extends() {
    $3c6ede3caf3264d7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c6ede3caf3264d7$var$_extends.apply(this, arguments);
}
function $3c6ede3caf3264d7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3c6ede3caf3264d7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3c6ede3caf3264d7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3c6ede3caf3264d7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3c6ede3caf3264d7$var$Icon = function Icon(_ref) {
    var _classnames;
    var size = _ref.size, color = _ref.color, className = _ref.className, align = _ref.align, text = _ref.text, props = $3c6ede3caf3264d7$var$_objectWithoutProperties(_ref, [
        "size",
        "color",
        "className",
        "align",
        "text"
    ]);
    if (text !== undefined) console.warn('[Deprecation] Text prop for Icon Component its deprecated, please use Icon.Text Component instead');
    return /*#__PURE__*/ $3c6ede3caf3264d7$var$_react["default"].createElement($3c6ede3caf3264d7$var$_element["default"], $3c6ede3caf3264d7$var$_extends({}, props, {
        className: (0, $3c6ede3caf3264d7$var$_classnames2["default"])(className, (_classnames = {
            icon: !text
        }, $3c6ede3caf3264d7$var$_defineProperty(_classnames, "is-".concat(size), size), $3c6ede3caf3264d7$var$_defineProperty(_classnames, "is-".concat(align), align), $3c6ede3caf3264d7$var$_defineProperty(_classnames, "has-text-".concat(color), color), $3c6ede3caf3264d7$var$_defineProperty(_classnames, 'icon-text', text), _classnames))
    }));
};
$3c6ede3caf3264d7$var$Icon.defaultProps = {
    renderAs: 'span'
};
$3c6ede3caf3264d7$var$Icon.Text = $3c6ede3caf3264d7$var$_text["default"];
var $3c6ede3caf3264d7$var$_default = $3c6ede3caf3264d7$var$Icon;
module.exports["default"] = $3c6ede3caf3264d7$var$_default;

});
parcelRegister("k9uG3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $eabc71c4229215b0$var$_text = $eabc71c4229215b0$var$_interopRequireDefault((parcelRequire("kQfhP")));
function $eabc71c4229215b0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $eabc71c4229215b0$var$_default = $eabc71c4229215b0$var$_text["default"];
module.exports["default"] = $eabc71c4229215b0$var$_default;

});
parcelRegister("kQfhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f2c4858f0c0df331$var$_react = $f2c4858f0c0df331$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $f2c4858f0c0df331$var$_propTypes = $f2c4858f0c0df331$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $f2c4858f0c0df331$var$_classnames = $f2c4858f0c0df331$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $f2c4858f0c0df331$var$_element = $f2c4858f0c0df331$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $f2c4858f0c0df331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f2c4858f0c0df331$var$_extends() {
    $f2c4858f0c0df331$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f2c4858f0c0df331$var$_extends.apply(this, arguments);
}
function $f2c4858f0c0df331$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f2c4858f0c0df331$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f2c4858f0c0df331$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f2c4858f0c0df331$var$Text = function Text(_ref) {
    var className = _ref.className, props = $f2c4858f0c0df331$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $f2c4858f0c0df331$var$_react["default"].createElement($f2c4858f0c0df331$var$_element["default"], $f2c4858f0c0df331$var$_extends({
        className: (0, $f2c4858f0c0df331$var$_classnames["default"])('icon-text', className)
    }, props));
};
$f2c4858f0c0df331$var$Text.defaultProps = {
    renderAs: 'span'
};
var $f2c4858f0c0df331$var$_default = $f2c4858f0c0df331$var$Text;
module.exports["default"] = $f2c4858f0c0df331$var$_default;

});




parcelRegister("7aX84", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5397555f503ffd21$var$_button = $5397555f503ffd21$var$_interopRequireDefault((parcelRequire("4ALe8")));
function $5397555f503ffd21$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $5397555f503ffd21$var$_default = $5397555f503ffd21$var$_button["default"];
module.exports["default"] = $5397555f503ffd21$var$_default;

});
parcelRegister("4ALe8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $357f287f8dc57747$var$_react = $357f287f8dc57747$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $357f287f8dc57747$var$_propTypes = $357f287f8dc57747$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $357f287f8dc57747$var$_classnames2 = $357f287f8dc57747$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $357f287f8dc57747$var$_buttonGroup = $357f287f8dc57747$var$_interopRequireDefault((parcelRequire("1ZrCA")));

var $357f287f8dc57747$var$_element = $357f287f8dc57747$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $1tqZN = parcelRequire("1tqZN");
function $357f287f8dc57747$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $357f287f8dc57747$var$_extends() {
    $357f287f8dc57747$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $357f287f8dc57747$var$_extends.apply(this, arguments);
}
function $357f287f8dc57747$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $357f287f8dc57747$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $357f287f8dc57747$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $357f287f8dc57747$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $357f287f8dc57747$var$Button = function Button(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, renderAs = _ref.renderAs, color = _ref.color, size = _ref.size, outlined = _ref.outlined, inverted = _ref.inverted, submit = _ref.submit, reset = _ref.reset, fullwidth = _ref.fullwidth, status = _ref.status, loading = _ref.loading, disabled = _ref.disabled, remove = _ref.remove, isSelected = _ref.isSelected, isStatic = _ref.isStatic, rounded = _ref.rounded, onClick = _ref.onClick, text = _ref.text, props = $357f287f8dc57747$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "renderAs",
        "color",
        "size",
        "outlined",
        "inverted",
        "submit",
        "reset",
        "fullwidth",
        "status",
        "loading",
        "disabled",
        "remove",
        "isSelected",
        "isStatic",
        "rounded",
        "onClick",
        "text"
    ]);
    var otherProps = {};
    if (submit) otherProps = {
        type: 'submit',
        renderAs: 'button'
    };
    if (reset) otherProps = {
        type: 'reset',
        renderAs: 'button'
    };
    if (isStatic) otherProps = {
        renderAs: 'span'
    };
    return /*#__PURE__*/ $357f287f8dc57747$var$_react["default"].createElement($357f287f8dc57747$var$_element["default"], $357f287f8dc57747$var$_extends({
        tabIndex: disabled ? -1 : 0,
        renderAs: renderAs
    }, props, otherProps, {
        disabled: disabled,
        onClick: disabled ? undefined : onClick,
        className: (0, $357f287f8dc57747$var$_classnames2["default"])(className, (_classnames = {}, $357f287f8dc57747$var$_defineProperty(_classnames, "is-".concat(color), color), $357f287f8dc57747$var$_defineProperty(_classnames, "is-".concat(size), size), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-selected', isSelected), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-static', isStatic), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-rounded', rounded), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-outlined', outlined), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-inverted', inverted), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), $357f287f8dc57747$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeStatus)(status)), status), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-loading', loading), $357f287f8dc57747$var$_defineProperty(_classnames, 'is-text', text), $357f287f8dc57747$var$_defineProperty(_classnames, "delete", remove), $357f287f8dc57747$var$_defineProperty(_classnames, "button", !remove), _classnames))
    }), children);
};
$357f287f8dc57747$var$Button.Group = $357f287f8dc57747$var$_buttonGroup["default"];
$357f287f8dc57747$var$Button.defaultProps = {
    renderAs: 'button'
};
var $357f287f8dc57747$var$_default = $357f287f8dc57747$var$Button;
module.exports["default"] = $357f287f8dc57747$var$_default;

});
parcelRegister("1ZrCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1730e9f940198bec$var$_react = $1730e9f940198bec$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $1730e9f940198bec$var$_propTypes = $1730e9f940198bec$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $1730e9f940198bec$var$_classnames2 = $1730e9f940198bec$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $1730e9f940198bec$var$_element = $1730e9f940198bec$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $1tqZN = parcelRequire("1tqZN");
function $1730e9f940198bec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1730e9f940198bec$var$_extends() {
    $1730e9f940198bec$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1730e9f940198bec$var$_extends.apply(this, arguments);
}
function $1730e9f940198bec$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1730e9f940198bec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1730e9f940198bec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1730e9f940198bec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1730e9f940198bec$var$ButtonGroup = function ButtonGroup(_ref) {
    var _classnames;
    var className = _ref.className, hasAddons = _ref.hasAddons, align = _ref.align, size = _ref.size, props = $1730e9f940198bec$var$_objectWithoutProperties(_ref, [
        "className",
        "hasAddons",
        "align",
        "size"
    ]);
    return /*#__PURE__*/ $1730e9f940198bec$var$_react["default"].createElement($1730e9f940198bec$var$_element["default"], $1730e9f940198bec$var$_extends({}, props, {
        className: (0, $1730e9f940198bec$var$_classnames2["default"])('buttons', className, (_classnames = {
            'has-addons': hasAddons
        }, $1730e9f940198bec$var$_defineProperty(_classnames, "is-".concat([
            (0, $1tqZN.normalizeAlign)(align)
        ]), align), $1730e9f940198bec$var$_defineProperty(_classnames, "are-".concat(size), size), _classnames))
    }));
};
$1730e9f940198bec$var$ButtonGroup.defaultProps = {
    renderAs: 'div'
};
var $1730e9f940198bec$var$_default = $1730e9f940198bec$var$ButtonGroup;
module.exports["default"] = $1730e9f940198bec$var$_default;

});




parcelRegister("6TL8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $505c704c206d1ff7$var$_react = $505c704c206d1ff7$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $505c704c206d1ff7$var$_propTypes = $505c704c206d1ff7$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $505c704c206d1ff7$var$_classnames2 = $505c704c206d1ff7$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $505c704c206d1ff7$var$_element = $505c704c206d1ff7$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $505c704c206d1ff7$var$_context = $505c704c206d1ff7$var$_interopRequireDefault((parcelRequire("8c2pz")));

var $1tqZN = parcelRequire("1tqZN");
function $505c704c206d1ff7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $505c704c206d1ff7$var$_extends() {
    $505c704c206d1ff7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $505c704c206d1ff7$var$_extends.apply(this, arguments);
}
function $505c704c206d1ff7$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $505c704c206d1ff7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $505c704c206d1ff7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $505c704c206d1ff7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $505c704c206d1ff7$var$Input = function Input(_ref) {
    var _classnames;
    var className = _ref.className, size = _ref.size, color = _ref.color, readOnly = _ref.readOnly, isStatic = _ref.isStatic, status = _ref.status, rounded = _ref.rounded, props = $505c704c206d1ff7$var$_objectWithoutProperties(_ref, [
        "className",
        "size",
        "color",
        "readOnly",
        "isStatic",
        "status",
        "rounded"
    ]);
    var context = (0, $505c704c206d1ff7$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $505c704c206d1ff7$var$_react["default"].createElement($505c704c206d1ff7$var$_element["default"], $505c704c206d1ff7$var$_extends({}, props, {
        readOnly: readOnly || isStatic,
        className: (0, $505c704c206d1ff7$var$_classnames2["default"])('input', className, (_classnames = {
            'is-static': isStatic
        }, $505c704c206d1ff7$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeStatus)(status)), status), $505c704c206d1ff7$var$_defineProperty(_classnames, 'is-rounded', rounded), $505c704c206d1ff7$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $505c704c206d1ff7$var$_defineProperty(_classnames, "is-".concat(color), color), _classnames))
    }));
};
$505c704c206d1ff7$var$Input.defaultProps = {
    renderAs: 'input'
};
var $505c704c206d1ff7$var$_default = $505c704c206d1ff7$var$Input;
module.exports["default"] = $505c704c206d1ff7$var$_default;

});

parcelRegister("4E8AF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $36218fbe3a177e91$var$_react = $36218fbe3a177e91$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $36218fbe3a177e91$var$_propTypes = $36218fbe3a177e91$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $36218fbe3a177e91$var$_classnames2 = $36218fbe3a177e91$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $36218fbe3a177e91$var$_element = $36218fbe3a177e91$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $36218fbe3a177e91$var$_context = $36218fbe3a177e91$var$_interopRequireDefault((parcelRequire("8c2pz")));
function $36218fbe3a177e91$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $36218fbe3a177e91$var$_extends() {
    $36218fbe3a177e91$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $36218fbe3a177e91$var$_extends.apply(this, arguments);
}
function $36218fbe3a177e91$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $36218fbe3a177e91$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $36218fbe3a177e91$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $36218fbe3a177e91$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $36218fbe3a177e91$var$Label = function Label(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $36218fbe3a177e91$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    var context = (0, $36218fbe3a177e91$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $36218fbe3a177e91$var$_react["default"].createElement($36218fbe3a177e91$var$_element["default"], $36218fbe3a177e91$var$_extends({}, props, {
        className: (0, $36218fbe3a177e91$var$_classnames2["default"])('label', className, $36218fbe3a177e91$var$_defineProperty({}, "is-".concat(calculatedSize), calculatedSize))
    }), children);
};
$36218fbe3a177e91$var$Label.defaultProps = {
    renderAs: 'label'
};
var $36218fbe3a177e91$var$_default = $36218fbe3a177e91$var$Label;
module.exports["default"] = $36218fbe3a177e91$var$_default;

});

parcelRegister("fJzEe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b746b5f05d1f751d$var$_react = $b746b5f05d1f751d$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $b746b5f05d1f751d$var$_propTypes = $b746b5f05d1f751d$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $b746b5f05d1f751d$var$_classnames2 = $b746b5f05d1f751d$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b746b5f05d1f751d$var$_element = $b746b5f05d1f751d$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $b746b5f05d1f751d$var$_context = $b746b5f05d1f751d$var$_interopRequireDefault((parcelRequire("8c2pz")));

var $1tqZN = parcelRequire("1tqZN");
function $b746b5f05d1f751d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b746b5f05d1f751d$var$_extends() {
    $b746b5f05d1f751d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b746b5f05d1f751d$var$_extends.apply(this, arguments);
}
function $b746b5f05d1f751d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b746b5f05d1f751d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b746b5f05d1f751d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b746b5f05d1f751d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b746b5f05d1f751d$var$Textarea = function Textarea(_ref) {
    var _classnames;
    var className = _ref.className, size = _ref.size, color = _ref.color, status = _ref.status, fixedSize = _ref.fixedSize, props = $b746b5f05d1f751d$var$_objectWithoutProperties(_ref, [
        "className",
        "size",
        "color",
        "status",
        "fixedSize"
    ]);
    var context = (0, $b746b5f05d1f751d$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $b746b5f05d1f751d$var$_react["default"].createElement($b746b5f05d1f751d$var$_element["default"], $b746b5f05d1f751d$var$_extends({}, props, {
        className: (0, $b746b5f05d1f751d$var$_classnames2["default"])('textarea', className, (_classnames = {}, $b746b5f05d1f751d$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeStatus)(status)), status), $b746b5f05d1f751d$var$_defineProperty(_classnames, 'has-fixed-size', fixedSize), $b746b5f05d1f751d$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $b746b5f05d1f751d$var$_defineProperty(_classnames, "is-".concat(color), color), _classnames))
    }));
};
$b746b5f05d1f751d$var$Textarea.defaultProps = {
    renderAs: 'textarea'
};
var $b746b5f05d1f751d$var$_default = $b746b5f05d1f751d$var$Textarea;
module.exports["default"] = $b746b5f05d1f751d$var$_default;

});

parcelRegister("7yqE3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $58006083ceed4c22$var$_react = $58006083ceed4c22$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $58006083ceed4c22$var$_propTypes = $58006083ceed4c22$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $58006083ceed4c22$var$_classnames3 = $58006083ceed4c22$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $58006083ceed4c22$var$_element = $58006083ceed4c22$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $58006083ceed4c22$var$_context = $58006083ceed4c22$var$_interopRequireDefault((parcelRequire("8c2pz")));

var $1tqZN = parcelRequire("1tqZN");
function $58006083ceed4c22$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $58006083ceed4c22$var$_extends() {
    $58006083ceed4c22$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $58006083ceed4c22$var$_extends.apply(this, arguments);
}
function $58006083ceed4c22$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $58006083ceed4c22$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $58006083ceed4c22$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $58006083ceed4c22$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $58006083ceed4c22$var$Select = function Select(_ref) {
    var _classnames;
    var className = _ref.className, rounded = _ref.rounded, style = _ref.style, size = _ref.size, color = _ref.color, loading = _ref.loading, status = _ref.status, disabled = _ref.disabled, value = _ref.value, multiple = _ref.multiple, children = _ref.children, name = _ref.name, domRef = _ref.domRef, fullwidth = _ref.fullwidth, props = $58006083ceed4c22$var$_objectWithoutProperties(_ref, [
        "className",
        "rounded",
        "style",
        "size",
        "color",
        "loading",
        "status",
        "disabled",
        "value",
        "multiple",
        "children",
        "name",
        "domRef",
        "fullwidth"
    ]);
    var context = (0, $58006083ceed4c22$var$_context["default"])();
    var calculatedSize = size || context.size;
    return /*#__PURE__*/ $58006083ceed4c22$var$_react["default"].createElement($58006083ceed4c22$var$_element["default"], {
        domRef: domRef,
        className: (0, $58006083ceed4c22$var$_classnames3["default"])('select', className, (_classnames = {}, $58006083ceed4c22$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $58006083ceed4c22$var$_defineProperty(_classnames, "is-".concat(color), color), $58006083ceed4c22$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), $58006083ceed4c22$var$_defineProperty(_classnames, 'is-loading', loading), $58006083ceed4c22$var$_defineProperty(_classnames, 'is-multiple', multiple), $58006083ceed4c22$var$_defineProperty(_classnames, 'is-rounded', rounded), _classnames)),
        style: style
    }, /*#__PURE__*/ $58006083ceed4c22$var$_react["default"].createElement($58006083ceed4c22$var$_element["default"], $58006083ceed4c22$var$_extends({}, props, {
        className: (0, $58006083ceed4c22$var$_classnames3["default"])($58006083ceed4c22$var$_defineProperty({}, "is-".concat((0, $1tqZN.normalizeStatus)(status)), status)),
        multiple: multiple,
        value: value,
        disabled: disabled,
        name: name
    }), children));
};
$58006083ceed4c22$var$Select.defaultProps = {
    renderAs: 'select'
};
var $58006083ceed4c22$var$_default = $58006083ceed4c22$var$Select;
module.exports["default"] = $58006083ceed4c22$var$_default;

});

parcelRegister("9qcsG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6dc035640fdc6e92$var$_react = $6dc035640fdc6e92$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $6dc035640fdc6e92$var$_propTypes = $6dc035640fdc6e92$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $6dc035640fdc6e92$var$_classnames = $6dc035640fdc6e92$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $6dc035640fdc6e92$var$_element = $6dc035640fdc6e92$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $6dc035640fdc6e92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6dc035640fdc6e92$var$_extends() {
    $6dc035640fdc6e92$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6dc035640fdc6e92$var$_extends.apply(this, arguments);
}
function $6dc035640fdc6e92$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6dc035640fdc6e92$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6dc035640fdc6e92$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6dc035640fdc6e92$var$Checkbox = function Checkbox(_ref) {
    var className = _ref.className, style = _ref.style, disabled = _ref.disabled, children = _ref.children, domRef = _ref.domRef, props = $6dc035640fdc6e92$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "disabled",
        "children",
        "domRef"
    ]);
    return /*#__PURE__*/ $6dc035640fdc6e92$var$_react["default"].createElement($6dc035640fdc6e92$var$_element["default"], {
        renderAs: "label",
        domRef: domRef,
        disabled: disabled,
        className: (0, $6dc035640fdc6e92$var$_classnames["default"])('checkbox', className),
        style: style
    }, /*#__PURE__*/ $6dc035640fdc6e92$var$_react["default"].createElement($6dc035640fdc6e92$var$_element["default"], $6dc035640fdc6e92$var$_extends({
        type: "checkbox",
        disabled: disabled
    }, props)), " ", children);
};
$6dc035640fdc6e92$var$Checkbox.defaultProps = {
    renderAs: 'input'
};
var $6dc035640fdc6e92$var$_default = $6dc035640fdc6e92$var$Checkbox;
module.exports["default"] = $6dc035640fdc6e92$var$_default;

});

parcelRegister("ahSAq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $77d5d5abf8af6ef3$var$_react = $77d5d5abf8af6ef3$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $77d5d5abf8af6ef3$var$_propTypes = $77d5d5abf8af6ef3$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $77d5d5abf8af6ef3$var$_classnames = $77d5d5abf8af6ef3$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $77d5d5abf8af6ef3$var$_element = $77d5d5abf8af6ef3$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $77d5d5abf8af6ef3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $77d5d5abf8af6ef3$var$_extends() {
    $77d5d5abf8af6ef3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $77d5d5abf8af6ef3$var$_extends.apply(this, arguments);
}
function $77d5d5abf8af6ef3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $77d5d5abf8af6ef3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $77d5d5abf8af6ef3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $77d5d5abf8af6ef3$var$Radio = function Radio(_ref) {
    var className = _ref.className, style = _ref.style, disabled = _ref.disabled, checked = _ref.checked, value = _ref.value, name = _ref.name, children = _ref.children, domRef = _ref.domRef, props = $77d5d5abf8af6ef3$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "disabled",
        "checked",
        "value",
        "name",
        "children",
        "domRef"
    ]);
    return /*#__PURE__*/ $77d5d5abf8af6ef3$var$_react["default"].createElement($77d5d5abf8af6ef3$var$_element["default"], {
        renderAs: "label",
        domRef: domRef,
        disabled: disabled,
        className: (0, $77d5d5abf8af6ef3$var$_classnames["default"])('radio', className),
        style: style
    }, /*#__PURE__*/ $77d5d5abf8af6ef3$var$_react["default"].createElement($77d5d5abf8af6ef3$var$_element["default"], $77d5d5abf8af6ef3$var$_extends({}, props, {
        name: name,
        checked: checked,
        type: "radio",
        value: value,
        disabled: disabled
    })), ' ', children);
};
$77d5d5abf8af6ef3$var$Radio.defaultProps = {
    renderAs: 'input'
};
var $77d5d5abf8af6ef3$var$_default = $77d5d5abf8af6ef3$var$Radio;
module.exports["default"] = $77d5d5abf8af6ef3$var$_default;

});

parcelRegister("grhJL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bf7ced317a0716c8$var$_react = $bf7ced317a0716c8$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $bf7ced317a0716c8$var$_propTypes = $bf7ced317a0716c8$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $bf7ced317a0716c8$var$_classnames2 = $bf7ced317a0716c8$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $bf7ced317a0716c8$var$_element = $bf7ced317a0716c8$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $bf7ced317a0716c8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bf7ced317a0716c8$var$_extends() {
    $bf7ced317a0716c8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bf7ced317a0716c8$var$_extends.apply(this, arguments);
}
function $bf7ced317a0716c8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bf7ced317a0716c8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bf7ced317a0716c8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bf7ced317a0716c8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bf7ced317a0716c8$var$Help = function Help(_ref) {
    var className = _ref.className, children = _ref.children, color = _ref.color, props = $bf7ced317a0716c8$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "color"
    ]);
    return /*#__PURE__*/ $bf7ced317a0716c8$var$_react["default"].createElement($bf7ced317a0716c8$var$_element["default"], $bf7ced317a0716c8$var$_extends({}, props, {
        className: (0, $bf7ced317a0716c8$var$_classnames2["default"])('help', className, $bf7ced317a0716c8$var$_defineProperty({}, "is-".concat(color), color))
    }), children);
};
$bf7ced317a0716c8$var$Help.defaultProps = {
    renderAs: 'p'
};
var $bf7ced317a0716c8$var$_default = $bf7ced317a0716c8$var$Help;
module.exports["default"] = $bf7ced317a0716c8$var$_default;

});

parcelRegister("ijjDf", function(module, exports) {
"use strict";
function $d5493addd553bb97$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d5493addd553bb97$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d5493addd553bb97$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d5493addd553bb97$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d5493addd553bb97$var$_react = $d5493addd553bb97$var$_interopRequireWildcard((parcelRequire("3ZYaX")));

var $d5493addd553bb97$var$_propTypes = $d5493addd553bb97$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $d5493addd553bb97$var$_classnames2 = $d5493addd553bb97$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $d5493addd553bb97$var$_element = $d5493addd553bb97$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $d5493addd553bb97$var$_context = $d5493addd553bb97$var$_interopRequireDefault((parcelRequire("8c2pz")));

var $1tqZN = parcelRequire("1tqZN");
function $d5493addd553bb97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d5493addd553bb97$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $d5493addd553bb97$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $d5493addd553bb97$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $d5493addd553bb97$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $d5493addd553bb97$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d5493addd553bb97$var$_extends() {
    $d5493addd553bb97$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d5493addd553bb97$var$_extends.apply(this, arguments);
}
function $d5493addd553bb97$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d5493addd553bb97$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d5493addd553bb97$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d5493addd553bb97$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d5493addd553bb97$var$InputFile = function InputFile(_ref) {
    var _classnames;
    var className = _ref.className, style = _ref.style, onChange = _ref.onChange, color = _ref.color, size = _ref.size, fullwidth = _ref.fullwidth, align = _ref.align, boxed = _ref.boxed, name = _ref.name, label = _ref.label, icon = _ref.icon, inputProps = _ref.inputProps, filename = _ref.filename, value = _ref.value, props = $d5493addd553bb97$var$_objectWithoutProperties(_ref, [
        "className",
        "style",
        "onChange",
        "color",
        "size",
        "fullwidth",
        "align",
        "boxed",
        "name",
        "label",
        "icon",
        "inputProps",
        "filename",
        "value"
    ]);
    var ref = (0, $d5493addd553bb97$var$_react.useRef)();
    var context = (0, $d5493addd553bb97$var$_context["default"])();
    var calculatedSize = size || context.size;
    (0, $d5493addd553bb97$var$_react.useEffect)(function() {
        if (!ref.current) return;
        if (value) ref.current.files = value;
        else ref.current.value = '';
    }, [
        value
    ]);
    return /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement($d5493addd553bb97$var$_element["default"], $d5493addd553bb97$var$_extends({
        style: style
    }, props, {
        className: (0, $d5493addd553bb97$var$_classnames2["default"])('file', className, (_classnames = {}, $d5493addd553bb97$var$_defineProperty(_classnames, "is-".concat(calculatedSize), calculatedSize), $d5493addd553bb97$var$_defineProperty(_classnames, "is-".concat(color), color), $d5493addd553bb97$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeAlign)(align)), align), $d5493addd553bb97$var$_defineProperty(_classnames, 'has-name', !!filename), $d5493addd553bb97$var$_defineProperty(_classnames, 'is-boxed', boxed), $d5493addd553bb97$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("label", {
        className: "file-label"
    }, /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("input", $d5493addd553bb97$var$_extends({}, inputProps, {
        name: name,
        type: "file",
        className: "file-input",
        onChange: onChange,
        ref: ref
    })), /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("span", {
        className: "file-cta"
    }, icon && /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("span", {
        className: "file-icon"
    }, icon), /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("span", {
        className: "file-label"
    }, label)), filename && /*#__PURE__*/ $d5493addd553bb97$var$_react["default"].createElement("span", {
        className: "file-name"
    }, filename)));
};
$d5493addd553bb97$var$InputFile.defaultProps = {
    label: 'Choose a file...',
    inputProps: {}
};
var $d5493addd553bb97$var$_default = $d5493addd553bb97$var$InputFile;
module.exports["default"] = $d5493addd553bb97$var$_default;

});


parcelRegister("gSp2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c4951d91280c6624$var$_box = $c4951d91280c6624$var$_interopRequireDefault((parcelRequire("fijAP")));
function $c4951d91280c6624$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c4951d91280c6624$var$_default = $c4951d91280c6624$var$_box["default"];
module.exports["default"] = $c4951d91280c6624$var$_default;

});
parcelRegister("fijAP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b227bc37625368b8$var$_react = $b227bc37625368b8$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $b227bc37625368b8$var$_classnames = $b227bc37625368b8$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b227bc37625368b8$var$_element = $b227bc37625368b8$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $b227bc37625368b8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b227bc37625368b8$var$_extends() {
    $b227bc37625368b8$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b227bc37625368b8$var$_extends.apply(this, arguments);
}
function $b227bc37625368b8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b227bc37625368b8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b227bc37625368b8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b227bc37625368b8$var$Box = function Box(_ref) {
    var children = _ref.children, className = _ref.className, props = $b227bc37625368b8$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $b227bc37625368b8$var$_react["default"].createElement($b227bc37625368b8$var$_element["default"], $b227bc37625368b8$var$_extends({}, props, {
        className: (0, $b227bc37625368b8$var$_classnames["default"])('box', className)
    }), children);
};
$b227bc37625368b8$var$Box.defaultProps = {};
var $b227bc37625368b8$var$_default = $b227bc37625368b8$var$Box;
module.exports["default"] = $b227bc37625368b8$var$_default;

});


parcelRegister("6xV2r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4c4211cd9d087987$var$_block = $4c4211cd9d087987$var$_interopRequireDefault((parcelRequire("jSXUh")));
function $4c4211cd9d087987$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4c4211cd9d087987$var$_default = $4c4211cd9d087987$var$_block["default"];
module.exports["default"] = $4c4211cd9d087987$var$_default;

});
parcelRegister("jSXUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e7a187b5bea7811c$var$_react = $e7a187b5bea7811c$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e7a187b5bea7811c$var$_classnames = $e7a187b5bea7811c$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e7a187b5bea7811c$var$_element = $e7a187b5bea7811c$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $e7a187b5bea7811c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e7a187b5bea7811c$var$_extends() {
    $e7a187b5bea7811c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e7a187b5bea7811c$var$_extends.apply(this, arguments);
}
function $e7a187b5bea7811c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e7a187b5bea7811c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e7a187b5bea7811c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e7a187b5bea7811c$var$Block = function Block(_ref) {
    var className = _ref.className, props = $e7a187b5bea7811c$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $e7a187b5bea7811c$var$_react["default"].createElement($e7a187b5bea7811c$var$_element["default"], $e7a187b5bea7811c$var$_extends({}, props, {
        className: (0, $e7a187b5bea7811c$var$_classnames["default"])('block', className)
    }));
};
$e7a187b5bea7811c$var$Block.defaultProps = {};
var $e7a187b5bea7811c$var$_default = $e7a187b5bea7811c$var$Block;
module.exports["default"] = $e7a187b5bea7811c$var$_default;

});


parcelRegister("cS4fv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $95edd2f325ed9951$var$_breadcrumb = $95edd2f325ed9951$var$_interopRequireDefault((parcelRequire("3oLQL")));
function $95edd2f325ed9951$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $95edd2f325ed9951$var$_default = $95edd2f325ed9951$var$_breadcrumb["default"];
module.exports["default"] = $95edd2f325ed9951$var$_default;

});
parcelRegister("3oLQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2798bafc7a965ece$var$_react = $2798bafc7a965ece$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $2798bafc7a965ece$var$_propTypes = $2798bafc7a965ece$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $2798bafc7a965ece$var$_classnames2 = $2798bafc7a965ece$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $2798bafc7a965ece$var$_element = $2798bafc7a965ece$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $2798bafc7a965ece$var$_item = $2798bafc7a965ece$var$_interopRequireDefault((parcelRequire("hSMGR")));
function $2798bafc7a965ece$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2798bafc7a965ece$var$_extends() {
    $2798bafc7a965ece$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2798bafc7a965ece$var$_extends.apply(this, arguments);
}
function $2798bafc7a965ece$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2798bafc7a965ece$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2798bafc7a965ece$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2798bafc7a965ece$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2798bafc7a965ece$var$Breadcrumb = function Breadcrumb(_ref) {
    var _classnames;
    var className = _ref.className, separator = _ref.separator, size = _ref.size, align = _ref.align, children = _ref.children, props = $2798bafc7a965ece$var$_objectWithoutProperties(_ref, [
        "className",
        "separator",
        "size",
        "align",
        "children"
    ]);
    return /*#__PURE__*/ $2798bafc7a965ece$var$_react["default"].createElement($2798bafc7a965ece$var$_element["default"], $2798bafc7a965ece$var$_extends({}, props, {
        className: (0, $2798bafc7a965ece$var$_classnames2["default"])('breadcrumb', className, (_classnames = {}, $2798bafc7a965ece$var$_defineProperty(_classnames, "has-".concat(separator, "-separator"), separator), $2798bafc7a965ece$var$_defineProperty(_classnames, "is-".concat(size), size), $2798bafc7a965ece$var$_defineProperty(_classnames, "is-".concat(align), align), _classnames))
    }), /*#__PURE__*/ $2798bafc7a965ece$var$_react["default"].createElement("ul", null, children));
};
$2798bafc7a965ece$var$Breadcrumb.Item = $2798bafc7a965ece$var$_item["default"];
$2798bafc7a965ece$var$Breadcrumb.defaultProps = {
    separator: undefined,
    renderAs: 'nav',
    size: undefined,
    align: undefined
};
var $2798bafc7a965ece$var$_default = $2798bafc7a965ece$var$Breadcrumb;
module.exports["default"] = $2798bafc7a965ece$var$_default;

});
parcelRegister("hSMGR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d04d3faf610041aa$var$_react = $d04d3faf610041aa$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $d04d3faf610041aa$var$_propTypes = $d04d3faf610041aa$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $d04d3faf610041aa$var$_classnames = $d04d3faf610041aa$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $d04d3faf610041aa$var$_element = $d04d3faf610041aa$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $d04d3faf610041aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d04d3faf610041aa$var$_extends() {
    $d04d3faf610041aa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d04d3faf610041aa$var$_extends.apply(this, arguments);
}
function $d04d3faf610041aa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d04d3faf610041aa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d04d3faf610041aa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d04d3faf610041aa$var$BreadcrumbItem = function BreadcrumbItem(_ref) {
    var className = _ref.className, active = _ref.active, children = _ref.children, props = $d04d3faf610041aa$var$_objectWithoutProperties(_ref, [
        "className",
        "active",
        "children"
    ]);
    return /*#__PURE__*/ $d04d3faf610041aa$var$_react["default"].createElement($d04d3faf610041aa$var$_element["default"], $d04d3faf610041aa$var$_extends({}, props, {
        className: (0, $d04d3faf610041aa$var$_classnames["default"])(className, {
            'is-active': active
        })
    }), children);
};
$d04d3faf610041aa$var$BreadcrumbItem.defaultProps = {
    renderAs: 'li'
};
var $d04d3faf610041aa$var$_default = $d04d3faf610041aa$var$BreadcrumbItem;
module.exports["default"] = $d04d3faf610041aa$var$_default;

});



parcelRegister("8qLA6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6235a91c6b3f89de$var$_card = $6235a91c6b3f89de$var$_interopRequireDefault((parcelRequire("jqtus")));
function $6235a91c6b3f89de$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $6235a91c6b3f89de$var$_default = $6235a91c6b3f89de$var$_card["default"];
module.exports["default"] = $6235a91c6b3f89de$var$_default;

});
parcelRegister("jqtus", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e2475228591bd28b$var$_react = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e2475228591bd28b$var$_classnames = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e2475228591bd28b$var$_image = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("8T4yZ")));

var $e2475228591bd28b$var$_content = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("eNFEK")));

var $e2475228591bd28b$var$_header = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("2hDyd")));

var $e2475228591bd28b$var$_footer = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("kQNc1")));

var $e2475228591bd28b$var$_element = $e2475228591bd28b$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $e2475228591bd28b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e2475228591bd28b$var$_extends() {
    $e2475228591bd28b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e2475228591bd28b$var$_extends.apply(this, arguments);
}
function $e2475228591bd28b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e2475228591bd28b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e2475228591bd28b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e2475228591bd28b$var$Card = function Card(_ref) {
    var className = _ref.className, children = _ref.children, props = $e2475228591bd28b$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $e2475228591bd28b$var$_react["default"].createElement($e2475228591bd28b$var$_element["default"], $e2475228591bd28b$var$_extends({
        className: (0, $e2475228591bd28b$var$_classnames["default"])('card', className)
    }, props), children);
};
$e2475228591bd28b$var$Card.Image = $e2475228591bd28b$var$_image["default"];
$e2475228591bd28b$var$Card.Content = $e2475228591bd28b$var$_content["default"];
$e2475228591bd28b$var$Card.Header = $e2475228591bd28b$var$_header["default"];
$e2475228591bd28b$var$Card.Footer = $e2475228591bd28b$var$_footer["default"];
$e2475228591bd28b$var$Card.defaultProps = {};
var $e2475228591bd28b$var$_default = $e2475228591bd28b$var$Card;
module.exports["default"] = $e2475228591bd28b$var$_default;

});
parcelRegister("8T4yZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6786fffa95a3199a$var$_react = $6786fffa95a3199a$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $6786fffa95a3199a$var$_classnames = $6786fffa95a3199a$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $6786fffa95a3199a$var$_image = $6786fffa95a3199a$var$_interopRequireDefault((parcelRequire("dddYs")));

var $6786fffa95a3199a$var$_element = $6786fffa95a3199a$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $6786fffa95a3199a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6786fffa95a3199a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6786fffa95a3199a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6786fffa95a3199a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6786fffa95a3199a$var$CardImage = function CardImage(_ref) {
    var className = _ref.className, domRef = _ref.domRef, props = $6786fffa95a3199a$var$_objectWithoutProperties(_ref, [
        "className",
        "domRef"
    ]);
    return /*#__PURE__*/ $6786fffa95a3199a$var$_react["default"].createElement($6786fffa95a3199a$var$_element["default"], {
        domRef: domRef,
        className: (0, $6786fffa95a3199a$var$_classnames["default"])('card-image', className)
    }, /*#__PURE__*/ $6786fffa95a3199a$var$_react["default"].createElement($6786fffa95a3199a$var$_image["default"], props));
};
$6786fffa95a3199a$var$CardImage.defaultProps = {};
var $6786fffa95a3199a$var$_default = $6786fffa95a3199a$var$CardImage;
module.exports["default"] = $6786fffa95a3199a$var$_default;

});
parcelRegister("dddYs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $99e7543f18f64b5b$var$_image = $99e7543f18f64b5b$var$_interopRequireDefault((parcelRequire("8Tuw8")));
function $99e7543f18f64b5b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $99e7543f18f64b5b$var$_default = $99e7543f18f64b5b$var$_image["default"];
module.exports["default"] = $99e7543f18f64b5b$var$_default;

});
parcelRegister("8Tuw8", function(module, exports) {
"use strict";
function $679b21e179f86c6f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $679b21e179f86c6f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $679b21e179f86c6f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $679b21e179f86c6f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $679b21e179f86c6f$var$_react = $679b21e179f86c6f$var$_interopRequireWildcard((parcelRequire("3ZYaX")));

var $679b21e179f86c6f$var$_propTypes = $679b21e179f86c6f$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $679b21e179f86c6f$var$_classnames2 = $679b21e179f86c6f$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $679b21e179f86c6f$var$_element = $679b21e179f86c6f$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $679b21e179f86c6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $679b21e179f86c6f$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $679b21e179f86c6f$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $679b21e179f86c6f$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $679b21e179f86c6f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $679b21e179f86c6f$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $679b21e179f86c6f$var$_extends() {
    $679b21e179f86c6f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $679b21e179f86c6f$var$_extends.apply(this, arguments);
}
function $679b21e179f86c6f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $679b21e179f86c6f$var$_slicedToArray(arr, i) {
    return $679b21e179f86c6f$var$_arrayWithHoles(arr) || $679b21e179f86c6f$var$_iterableToArrayLimit(arr, i) || $679b21e179f86c6f$var$_unsupportedIterableToArray(arr, i) || $679b21e179f86c6f$var$_nonIterableRest();
}
function $679b21e179f86c6f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $679b21e179f86c6f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $679b21e179f86c6f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $679b21e179f86c6f$var$_arrayLikeToArray(o, minLen);
}
function $679b21e179f86c6f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $679b21e179f86c6f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $679b21e179f86c6f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $679b21e179f86c6f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $679b21e179f86c6f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $679b21e179f86c6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $679b21e179f86c6f$var$Image = function Image(_ref) {
    var _classnames;
    var className = _ref.className, alt = _ref.alt, size = _ref.size, fallback = _ref.fallback, rounded = _ref.rounded, src = _ref.src, fullwidth = _ref.fullwidth, props = $679b21e179f86c6f$var$_objectWithoutProperties(_ref, [
        "className",
        "alt",
        "size",
        "fallback",
        "rounded",
        "src",
        "fullwidth"
    ]);
    var _useState = (0, $679b21e179f86c6f$var$_react.useState)({
        src: src
    }), _useState2 = $679b21e179f86c6f$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    (0, $679b21e179f86c6f$var$_react.useEffect)(function() {
        setState({
            src: src
        });
    }, [
        src
    ]);
    var s = size;
    if (typeof size === 'number') s = "".concat(s, "x").concat(s);
    return /*#__PURE__*/ $679b21e179f86c6f$var$_react["default"].createElement($679b21e179f86c6f$var$_element["default"], $679b21e179f86c6f$var$_extends({}, props, {
        className: (0, $679b21e179f86c6f$var$_classnames2["default"])('image', className, (_classnames = {}, $679b21e179f86c6f$var$_defineProperty(_classnames, "is-".concat(s), s), $679b21e179f86c6f$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $679b21e179f86c6f$var$_react["default"].createElement("img", {
        className: (0, $679b21e179f86c6f$var$_classnames2["default"])({
            'is-rounded': rounded
        }),
        onError: function onError() {
            return state.src !== fallback && setState({
                src: fallback
            });
        },
        src: state.src,
        alt: alt
    }));
};
$679b21e179f86c6f$var$Image.defaultProps = {
    renderAs: 'figure'
};
var $679b21e179f86c6f$var$_default = $679b21e179f86c6f$var$Image;
module.exports["default"] = $679b21e179f86c6f$var$_default;

});



parcelRegister("eNFEK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ac65f45abf009c82$var$_react = $ac65f45abf009c82$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $ac65f45abf009c82$var$_classnames = $ac65f45abf009c82$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $ac65f45abf009c82$var$_element = $ac65f45abf009c82$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $ac65f45abf009c82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ac65f45abf009c82$var$_extends() {
    $ac65f45abf009c82$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ac65f45abf009c82$var$_extends.apply(this, arguments);
}
function $ac65f45abf009c82$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ac65f45abf009c82$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ac65f45abf009c82$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ac65f45abf009c82$var$CardContent = function CardContent(_ref) {
    var className = _ref.className, props = $ac65f45abf009c82$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $ac65f45abf009c82$var$_react["default"].createElement($ac65f45abf009c82$var$_element["default"], $ac65f45abf009c82$var$_extends({}, props, {
        className: (0, $ac65f45abf009c82$var$_classnames["default"])('card-content', className)
    }));
};
$ac65f45abf009c82$var$CardContent.defaultProps = {};
var $ac65f45abf009c82$var$_default = $ac65f45abf009c82$var$CardContent;
module.exports["default"] = $ac65f45abf009c82$var$_default;

});

parcelRegister("2hDyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $1a9bd94b6f24dbf5$var$_header["default"];
    }
});

var $1a9bd94b6f24dbf5$var$_header = $1a9bd94b6f24dbf5$var$_interopRequireDefault((parcelRequire("kEBlt")));
function $1a9bd94b6f24dbf5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("kEBlt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f09483194525f42c$var$_react = $f09483194525f42c$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $f09483194525f42c$var$_classnames = $f09483194525f42c$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $f09483194525f42c$var$_headerTitle = $f09483194525f42c$var$_interopRequireDefault((parcelRequire("jZJzm")));

var $f09483194525f42c$var$_headerIcon = $f09483194525f42c$var$_interopRequireDefault((parcelRequire("9EuHA")));

var $f09483194525f42c$var$_element = $f09483194525f42c$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $f09483194525f42c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f09483194525f42c$var$_extends() {
    $f09483194525f42c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f09483194525f42c$var$_extends.apply(this, arguments);
}
function $f09483194525f42c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f09483194525f42c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f09483194525f42c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f09483194525f42c$var$CardHeader = function CardHeader(_ref) {
    var className = _ref.className, props = $f09483194525f42c$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $f09483194525f42c$var$_react["default"].createElement($f09483194525f42c$var$_element["default"], $f09483194525f42c$var$_extends({}, props, {
        className: (0, $f09483194525f42c$var$_classnames["default"])('card-header', className)
    }));
};
$f09483194525f42c$var$CardHeader.Title = $f09483194525f42c$var$_headerTitle["default"];
$f09483194525f42c$var$CardHeader.Icon = $f09483194525f42c$var$_headerIcon["default"];
$f09483194525f42c$var$CardHeader.defaultProps = {};
var $f09483194525f42c$var$_default = $f09483194525f42c$var$CardHeader;
module.exports["default"] = $f09483194525f42c$var$_default;

});
parcelRegister("jZJzm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e8e70ff8ced5d6ce$var$_react = $e8e70ff8ced5d6ce$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e8e70ff8ced5d6ce$var$_classnames = $e8e70ff8ced5d6ce$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e8e70ff8ced5d6ce$var$_element = $e8e70ff8ced5d6ce$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $e8e70ff8ced5d6ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e8e70ff8ced5d6ce$var$_extends() {
    $e8e70ff8ced5d6ce$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8e70ff8ced5d6ce$var$_extends.apply(this, arguments);
}
function $e8e70ff8ced5d6ce$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8e70ff8ced5d6ce$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8e70ff8ced5d6ce$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e8e70ff8ced5d6ce$var$CardHeaderTitle = function CardHeaderTitle(_ref) {
    var className = _ref.className, props = $e8e70ff8ced5d6ce$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $e8e70ff8ced5d6ce$var$_react["default"].createElement($e8e70ff8ced5d6ce$var$_element["default"], $e8e70ff8ced5d6ce$var$_extends({}, props, {
        className: (0, $e8e70ff8ced5d6ce$var$_classnames["default"])('card-header-title', className)
    }));
};
$e8e70ff8ced5d6ce$var$CardHeaderTitle.defaultProps = {};
var $e8e70ff8ced5d6ce$var$_default = $e8e70ff8ced5d6ce$var$CardHeaderTitle;
module.exports["default"] = $e8e70ff8ced5d6ce$var$_default;

});

parcelRegister("9EuHA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $706faa4921234b17$var$_react = $706faa4921234b17$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $706faa4921234b17$var$_classnames = $706faa4921234b17$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $706faa4921234b17$var$_element = $706faa4921234b17$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $706faa4921234b17$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $706faa4921234b17$var$_extends() {
    $706faa4921234b17$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $706faa4921234b17$var$_extends.apply(this, arguments);
}
function $706faa4921234b17$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $706faa4921234b17$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $706faa4921234b17$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $706faa4921234b17$var$CardHeaderIcon = function CardHeaderIcon(_ref) {
    var className = _ref.className, props = $706faa4921234b17$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $706faa4921234b17$var$_react["default"].createElement($706faa4921234b17$var$_element["default"], $706faa4921234b17$var$_extends({}, props, {
        className: (0, $706faa4921234b17$var$_classnames["default"])('card-header-icon', className)
    }));
};
$706faa4921234b17$var$CardHeaderIcon.defaultProps = {};
var $706faa4921234b17$var$_default = $706faa4921234b17$var$CardHeaderIcon;
module.exports["default"] = $706faa4921234b17$var$_default;

});



parcelRegister("kQNc1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $f2ded2a7035a14e5$var$_footer["default"];
    }
});

var $f2ded2a7035a14e5$var$_footer = $f2ded2a7035a14e5$var$_interopRequireDefault((parcelRequire("5kbKV")));
function $f2ded2a7035a14e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("5kbKV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3e07f07434607a65$var$_react = $3e07f07434607a65$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $3e07f07434607a65$var$_classnames = $3e07f07434607a65$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3e07f07434607a65$var$_footerItem = $3e07f07434607a65$var$_interopRequireDefault((parcelRequire("jPMAs")));

var $3e07f07434607a65$var$_element = $3e07f07434607a65$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $3e07f07434607a65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3e07f07434607a65$var$_extends() {
    $3e07f07434607a65$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3e07f07434607a65$var$_extends.apply(this, arguments);
}
function $3e07f07434607a65$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3e07f07434607a65$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3e07f07434607a65$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3e07f07434607a65$var$CardFooter = function CardFooter(_ref) {
    var className = _ref.className, props = $3e07f07434607a65$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $3e07f07434607a65$var$_react["default"].createElement($3e07f07434607a65$var$_element["default"], $3e07f07434607a65$var$_extends({}, props, {
        className: (0, $3e07f07434607a65$var$_classnames["default"])('card-footer', className)
    }));
};
$3e07f07434607a65$var$CardFooter.Item = $3e07f07434607a65$var$_footerItem["default"];
$3e07f07434607a65$var$CardFooter.defaultProps = {};
var $3e07f07434607a65$var$_default = $3e07f07434607a65$var$CardFooter;
module.exports["default"] = $3e07f07434607a65$var$_default;

});
parcelRegister("jPMAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e708781f278573f0$var$_react = $e708781f278573f0$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e708781f278573f0$var$_classnames = $e708781f278573f0$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e708781f278573f0$var$_element = $e708781f278573f0$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $e708781f278573f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e708781f278573f0$var$_extends() {
    $e708781f278573f0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e708781f278573f0$var$_extends.apply(this, arguments);
}
function $e708781f278573f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e708781f278573f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e708781f278573f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e708781f278573f0$var$CardFooterItem = function CardFooterItem(_ref) {
    var className = _ref.className, props = $e708781f278573f0$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $e708781f278573f0$var$_react["default"].createElement($e708781f278573f0$var$_element["default"], $e708781f278573f0$var$_extends({}, props, {
        className: (0, $e708781f278573f0$var$_classnames["default"])('card-footer-item', className)
    }));
};
$e708781f278573f0$var$CardFooterItem.defaultProps = {};
var $e708781f278573f0$var$_default = $e708781f278573f0$var$CardFooterItem;
module.exports["default"] = $e708781f278573f0$var$_default;

});





parcelRegister("eoemi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a79e71e1873b7c9e$var$_columns = $a79e71e1873b7c9e$var$_interopRequireDefault((parcelRequire("iXjqx")));
function $a79e71e1873b7c9e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $a79e71e1873b7c9e$var$_default = $a79e71e1873b7c9e$var$_columns["default"];
module.exports["default"] = $a79e71e1873b7c9e$var$_default;

});
parcelRegister("iXjqx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dcccce783a65d4a0$var$_react = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $dcccce783a65d4a0$var$_propTypes = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $dcccce783a65d4a0$var$_classnames = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $dcccce783a65d4a0$var$_column = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("cwfwC")));

var $dcccce783a65d4a0$var$_constants = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("2JZlQ")));

var $dcccce783a65d4a0$var$_element = $dcccce783a65d4a0$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $dcccce783a65d4a0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dcccce783a65d4a0$var$_extends() {
    $dcccce783a65d4a0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dcccce783a65d4a0$var$_extends.apply(this, arguments);
}
function $dcccce783a65d4a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dcccce783a65d4a0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dcccce783a65d4a0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dcccce783a65d4a0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $dcccce783a65d4a0$var$Columns = function Columns(_ref) {
    var _classNames;
    var className = _ref.className, breakpoint = _ref.breakpoint, gap = _ref.gap, multiline = _ref.multiline, centered = _ref.centered, vCentered = _ref.vCentered, variableGap = _ref.variableGap, _ref$mobile = _ref.mobile, mobile = _ref$mobile === void 0 ? {} : _ref$mobile, _ref$tablet = _ref.tablet, tablet = _ref$tablet === void 0 ? {} : _ref$tablet, _ref$desktop = _ref.desktop, desktop = _ref$desktop === void 0 ? {} : _ref$desktop, _ref$widescreen = _ref.widescreen, widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen, _ref$fullhd = _ref.fullhd, fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd, _ref$touch = _ref.touch, touch = _ref$touch === void 0 ? {} : _ref$touch, props = $dcccce783a65d4a0$var$_objectWithoutProperties(_ref, [
        "className",
        "breakpoint",
        "gap",
        "multiline",
        "centered",
        "vCentered",
        "variableGap",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch"
    ]);
    return /*#__PURE__*/ $dcccce783a65d4a0$var$_react["default"].createElement($dcccce783a65d4a0$var$_element["default"], $dcccce783a65d4a0$var$_extends({}, props, {
        mobile: mobile,
        tablet: tablet,
        desktop: desktop,
        widescreen: widescreen,
        fullhd: fullhd,
        touch: touch,
        className: (0, $dcccce783a65d4a0$var$_classnames["default"])(className, 'columns', (_classNames = {}, $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(breakpoint), breakpoint), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(gap), gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, 'is-multiline', multiline), $dcccce783a65d4a0$var$_defineProperty(_classNames, 'is-centered', centered), $dcccce783a65d4a0$var$_defineProperty(_classNames, 'is-vcentered', vCentered), $dcccce783a65d4a0$var$_defineProperty(_classNames, 'is-variable', gap !== undefined || [
            touch,
            mobile,
            tablet,
            desktop,
            widescreen,
            fullhd
        ].find(function(b) {
            return b.gap !== undefined;
        })), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(touch.gap, "-touch"), touch.gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(mobile.gap, "-mobile"), mobile.gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(tablet.gap, "-tablet"), tablet.gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(desktop.gap, "-desktop"), desktop.gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(widescreen.gap, "-widescreen"), widescreen.gap !== undefined), $dcccce783a65d4a0$var$_defineProperty(_classNames, "is-".concat(fullhd.gap, "-fullhd"), fullhd.gap !== undefined), _classNames))
    }));
};
$dcccce783a65d4a0$var$Columns.Column = $dcccce783a65d4a0$var$_column["default"];
$dcccce783a65d4a0$var$Columns.CONSTANTS = $dcccce783a65d4a0$var$_constants["default"];
$dcccce783a65d4a0$var$Columns.defaultProps = {
    multiline: true
};
var $dcccce783a65d4a0$var$_default = $dcccce783a65d4a0$var$Columns;
module.exports["default"] = $dcccce783a65d4a0$var$_default;

});
parcelRegister("cwfwC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $025a2329ead53de6$var$_react = $025a2329ead53de6$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $025a2329ead53de6$var$_propTypes = $025a2329ead53de6$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $025a2329ead53de6$var$_classnames = $025a2329ead53de6$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $025a2329ead53de6$var$_element = $025a2329ead53de6$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $025a2329ead53de6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $025a2329ead53de6$var$_extends() {
    $025a2329ead53de6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $025a2329ead53de6$var$_extends.apply(this, arguments);
}
function $025a2329ead53de6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $025a2329ead53de6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $025a2329ead53de6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $025a2329ead53de6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $025a2329ead53de6$var$Column = function Column(_ref) {
    var _classNames;
    var children = _ref.children, className = _ref.className, size = _ref.size, offset = _ref.offset, narrow = _ref.narrow, _ref$mobile = _ref.mobile, mobile = _ref$mobile === void 0 ? {} : _ref$mobile, _ref$tablet = _ref.tablet, tablet = _ref$tablet === void 0 ? {} : _ref$tablet, _ref$desktop = _ref.desktop, desktop = _ref$desktop === void 0 ? {} : _ref$desktop, _ref$widescreen = _ref.widescreen, widescreen = _ref$widescreen === void 0 ? {} : _ref$widescreen, _ref$fullhd = _ref.fullhd, fullhd = _ref$fullhd === void 0 ? {} : _ref$fullhd, _ref$touch = _ref.touch, touch = _ref$touch === void 0 ? {} : _ref$touch, props = $025a2329ead53de6$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "offset",
        "narrow",
        "mobile",
        "tablet",
        "desktop",
        "widescreen",
        "fullhd",
        "touch"
    ]);
    return /*#__PURE__*/ $025a2329ead53de6$var$_react["default"].createElement($025a2329ead53de6$var$_element["default"], $025a2329ead53de6$var$_extends({}, props, {
        mobile: mobile,
        tablet: tablet,
        desktop: desktop,
        widescreen: widescreen,
        fullhd: fullhd,
        touch: touch,
        className: (0, $025a2329ead53de6$var$_classnames["default"])(className, 'column', (_classNames = {}, $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(size), size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(touch.size, "-mobile"), touch.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(mobile.size, "-mobile"), mobile.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(tablet.size, "-tablet"), tablet.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(desktop.size, "-desktop"), desktop.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(widescreen.size, "-widescreen"), widescreen.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-".concat(fullhd.size, "-fullhd"), fullhd.size), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(touch.offset, "-mobile"), touch.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(mobile.offset, "-mobile"), mobile.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(tablet.offset, "-tablet"), tablet.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(desktop.offset, "-desktop"), desktop.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(widescreen.offset, "-widescreen"), widescreen.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(fullhd.offset, "-fullhd"), fullhd.offset), $025a2329ead53de6$var$_defineProperty(_classNames, "is-offset-".concat(offset), offset), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow', narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-touch', touch.narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-mobile', mobile.narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-tablet', tablet.narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-desktop', desktop.narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-widescreen', widescreen.narrow), $025a2329ead53de6$var$_defineProperty(_classNames, 'is-narrow-fullhd', fullhd.narrow), _classNames))
    }), children);
};
$025a2329ead53de6$var$Column.defaultProps = {};
var $025a2329ead53de6$var$_default = $025a2329ead53de6$var$Column;
module.exports["default"] = $025a2329ead53de6$var$_default;

});

parcelRegister("2JZlQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $1fef5fd4b7187595$var$_default = {
    SIZES: {
        THREEQUARTERS: 'three-quarters',
        TWOTHIRDS: 'two-thirds',
        HALF: 'half',
        ONETHIRD: 'one-third',
        ONEQUARTER: 'one-quarter',
        ONEFIFTH: 'one-fifth',
        TWOFIFTHS: 'two-fifths',
        THREEFIFTHS: 'three-fifths',
        FOURFIFTHS: 'four-fifths'
    }
};
module.exports["default"] = $1fef5fd4b7187595$var$_default;

});



parcelRegister("ccw4O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8e1f7ccac55e6b63$var$_container = $8e1f7ccac55e6b63$var$_interopRequireDefault((parcelRequire("2UG9o")));
function $8e1f7ccac55e6b63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $8e1f7ccac55e6b63$var$_default = $8e1f7ccac55e6b63$var$_container["default"];
module.exports["default"] = $8e1f7ccac55e6b63$var$_default;

});
parcelRegister("2UG9o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $21f181f5f335c9cb$var$_react = $21f181f5f335c9cb$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $21f181f5f335c9cb$var$_propTypes = $21f181f5f335c9cb$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $21f181f5f335c9cb$var$_classnames2 = $21f181f5f335c9cb$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $21f181f5f335c9cb$var$_element = $21f181f5f335c9cb$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $21f181f5f335c9cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $21f181f5f335c9cb$var$_extends() {
    $21f181f5f335c9cb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21f181f5f335c9cb$var$_extends.apply(this, arguments);
}
function $21f181f5f335c9cb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21f181f5f335c9cb$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $21f181f5f335c9cb$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $21f181f5f335c9cb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $21f181f5f335c9cb$var$Container = function Container(_ref) {
    var children = _ref.children, max = _ref.max, breakpoint = _ref.breakpoint, className = _ref.className, props = $21f181f5f335c9cb$var$_objectWithoutProperties(_ref, [
        "children",
        "max",
        "breakpoint",
        "className"
    ]);
    var canSetMax = [
        'desktop',
        'widescreen'
    ].includes(breakpoint);
    return /*#__PURE__*/ $21f181f5f335c9cb$var$_react["default"].createElement($21f181f5f335c9cb$var$_element["default"], $21f181f5f335c9cb$var$_extends({}, props, {
        className: (0, $21f181f5f335c9cb$var$_classnames2["default"])('container', className, $21f181f5f335c9cb$var$_defineProperty({}, "is-".concat(canSetMax && max ? 'max-' : '').concat(breakpoint), breakpoint))
    }), children);
};
$21f181f5f335c9cb$var$Container.defaultProps = {};
var $21f181f5f335c9cb$var$_default = $21f181f5f335c9cb$var$Container;
module.exports["default"] = $21f181f5f335c9cb$var$_default;

});


parcelRegister("oBrvI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $049f49597983fb7e$var$_content = $049f49597983fb7e$var$_interopRequireDefault((parcelRequire("dZO6y")));
function $049f49597983fb7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $049f49597983fb7e$var$_default = $049f49597983fb7e$var$_content["default"];
module.exports["default"] = $049f49597983fb7e$var$_default;

});
parcelRegister("dZO6y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a307d6a0068e30ab$var$_react = $a307d6a0068e30ab$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $a307d6a0068e30ab$var$_propTypes = $a307d6a0068e30ab$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $a307d6a0068e30ab$var$_classnames2 = $a307d6a0068e30ab$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $a307d6a0068e30ab$var$_element = $a307d6a0068e30ab$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $a307d6a0068e30ab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a307d6a0068e30ab$var$_extends() {
    $a307d6a0068e30ab$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a307d6a0068e30ab$var$_extends.apply(this, arguments);
}
function $a307d6a0068e30ab$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a307d6a0068e30ab$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a307d6a0068e30ab$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a307d6a0068e30ab$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a307d6a0068e30ab$var$Content = function Content(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $a307d6a0068e30ab$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    return /*#__PURE__*/ $a307d6a0068e30ab$var$_react["default"].createElement($a307d6a0068e30ab$var$_element["default"], $a307d6a0068e30ab$var$_extends({}, props, {
        className: (0, $a307d6a0068e30ab$var$_classnames2["default"])('content', className, $a307d6a0068e30ab$var$_defineProperty({}, "is-".concat(size), size))
    }), children);
};
$a307d6a0068e30ab$var$Content.defaultProps = {};
var $a307d6a0068e30ab$var$_default = $a307d6a0068e30ab$var$Content;
module.exports["default"] = $a307d6a0068e30ab$var$_default;

});


parcelRegister("jSK5O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e796d0892b547ad9$var$_footer = $e796d0892b547ad9$var$_interopRequireDefault((parcelRequire("4FiTa")));
function $e796d0892b547ad9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e796d0892b547ad9$var$_default = $e796d0892b547ad9$var$_footer["default"];
module.exports["default"] = $e796d0892b547ad9$var$_default;

});
parcelRegister("4FiTa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $3659a4aeffabffd4$var$_react = $3659a4aeffabffd4$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $3659a4aeffabffd4$var$_propTypes = $3659a4aeffabffd4$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $3659a4aeffabffd4$var$_classnames = $3659a4aeffabffd4$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3659a4aeffabffd4$var$_element = $3659a4aeffabffd4$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $3659a4aeffabffd4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $3659a4aeffabffd4$var$_extends() {
    $3659a4aeffabffd4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3659a4aeffabffd4$var$_extends.apply(this, arguments);
}
function $3659a4aeffabffd4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3659a4aeffabffd4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3659a4aeffabffd4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3659a4aeffabffd4$var$Footer = function Footer(_ref) {
    var className = _ref.className, props = $3659a4aeffabffd4$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $3659a4aeffabffd4$var$_react["default"].createElement($3659a4aeffabffd4$var$_element["default"], $3659a4aeffabffd4$var$_extends({}, props, {
        className: (0, $3659a4aeffabffd4$var$_classnames["default"])('footer', className)
    }));
};
$3659a4aeffabffd4$var$Footer.defaultProps = {
    renderAs: 'footer'
};
var $3659a4aeffabffd4$var$_default = $3659a4aeffabffd4$var$Footer;
module.exports["default"] = $3659a4aeffabffd4$var$_default;

});


parcelRegister("7q8EC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5671ac9ec11668f2$var$_heading = $5671ac9ec11668f2$var$_interopRequireDefault((parcelRequire("fSgol")));
function $5671ac9ec11668f2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $5671ac9ec11668f2$var$_default = $5671ac9ec11668f2$var$_heading["default"];
module.exports["default"] = $5671ac9ec11668f2$var$_default;

});
parcelRegister("fSgol", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b8e89d2dcc19e9af$var$_react = $b8e89d2dcc19e9af$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $b8e89d2dcc19e9af$var$_propTypes = $b8e89d2dcc19e9af$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $b8e89d2dcc19e9af$var$_classnames2 = $b8e89d2dcc19e9af$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b8e89d2dcc19e9af$var$_element = $b8e89d2dcc19e9af$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $b8e89d2dcc19e9af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b8e89d2dcc19e9af$var$_extends() {
    $b8e89d2dcc19e9af$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8e89d2dcc19e9af$var$_extends.apply(this, arguments);
}
function $b8e89d2dcc19e9af$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b8e89d2dcc19e9af$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b8e89d2dcc19e9af$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b8e89d2dcc19e9af$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b8e89d2dcc19e9af$var$Heading = function Heading(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, size = _ref.size, subtitle = _ref.subtitle, weight = _ref.weight, spaced = _ref.spaced, heading = _ref.heading, props = $b8e89d2dcc19e9af$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "subtitle",
        "weight",
        "spaced",
        "heading"
    ]);
    return /*#__PURE__*/ $b8e89d2dcc19e9af$var$_react["default"].createElement($b8e89d2dcc19e9af$var$_element["default"], $b8e89d2dcc19e9af$var$_extends({}, props, {
        className: (0, $b8e89d2dcc19e9af$var$_classnames2["default"])(className, (_classnames = {
            title: !subtitle && !heading,
            subtitle: subtitle,
            heading: heading
        }, $b8e89d2dcc19e9af$var$_defineProperty(_classnames, "is-".concat(size), size), $b8e89d2dcc19e9af$var$_defineProperty(_classnames, "has-text-weight-".concat(weight), weight), $b8e89d2dcc19e9af$var$_defineProperty(_classnames, 'is-spaced', spaced && !subtitle), _classnames))
    }), children);
};
$b8e89d2dcc19e9af$var$Heading.defaultProps = {
    renderAs: 'h1'
};
var $b8e89d2dcc19e9af$var$_default = $b8e89d2dcc19e9af$var$Heading;
module.exports["default"] = $b8e89d2dcc19e9af$var$_default;

});


parcelRegister("94oV6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $69a7d15a3e3c5cc6$var$_hero = $69a7d15a3e3c5cc6$var$_interopRequireDefault((parcelRequire("dz1pf")));
function $69a7d15a3e3c5cc6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $69a7d15a3e3c5cc6$var$_default = $69a7d15a3e3c5cc6$var$_hero["default"];
module.exports["default"] = $69a7d15a3e3c5cc6$var$_default;

});
parcelRegister("dz1pf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9dffa27bd33153f0$var$_react = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9dffa27bd33153f0$var$_propTypes = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $9dffa27bd33153f0$var$_classnames2 = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9dffa27bd33153f0$var$_heroHeader = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("9fdUS")));

var $9dffa27bd33153f0$var$_heroBody = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("kd8Md")));

var $9dffa27bd33153f0$var$_heroFooter = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("bWvM4")));

var $9dffa27bd33153f0$var$_element = $9dffa27bd33153f0$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $9dffa27bd33153f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9dffa27bd33153f0$var$_extends() {
    $9dffa27bd33153f0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dffa27bd33153f0$var$_extends.apply(this, arguments);
}
function $9dffa27bd33153f0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9dffa27bd33153f0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9dffa27bd33153f0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9dffa27bd33153f0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9dffa27bd33153f0$var$Hero = function Hero(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, gradient = _ref.gradient, size = _ref.size, hasNavbar = _ref.hasNavbar, props = $9dffa27bd33153f0$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "gradient",
        "size",
        "hasNavbar"
    ]);
    return /*#__PURE__*/ $9dffa27bd33153f0$var$_react["default"].createElement($9dffa27bd33153f0$var$_element["default"], $9dffa27bd33153f0$var$_extends({}, props, {
        className: (0, $9dffa27bd33153f0$var$_classnames2["default"])('hero', className, (_classnames = {}, $9dffa27bd33153f0$var$_defineProperty(_classnames, "is-".concat(color), color), $9dffa27bd33153f0$var$_defineProperty(_classnames, "is-".concat(size), size && !hasNavbar), $9dffa27bd33153f0$var$_defineProperty(_classnames, 'is-bold', gradient), $9dffa27bd33153f0$var$_defineProperty(_classnames, 'is-fullheight-with-navbar', hasNavbar), _classnames))
    }), children);
};
$9dffa27bd33153f0$var$Hero.Header = $9dffa27bd33153f0$var$_heroHeader["default"];
$9dffa27bd33153f0$var$Hero.Body = $9dffa27bd33153f0$var$_heroBody["default"];
$9dffa27bd33153f0$var$Hero.Footer = $9dffa27bd33153f0$var$_heroFooter["default"];
$9dffa27bd33153f0$var$Hero.defaultProps = {
    renderAs: 'section'
};
var $9dffa27bd33153f0$var$_default = $9dffa27bd33153f0$var$Hero;
module.exports["default"] = $9dffa27bd33153f0$var$_default;

});
parcelRegister("9fdUS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6bb04f47d14095ac$var$_react = $6bb04f47d14095ac$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $6bb04f47d14095ac$var$_propTypes = $6bb04f47d14095ac$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $6bb04f47d14095ac$var$_classnames = $6bb04f47d14095ac$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $6bb04f47d14095ac$var$_element = $6bb04f47d14095ac$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $6bb04f47d14095ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6bb04f47d14095ac$var$_extends() {
    $6bb04f47d14095ac$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6bb04f47d14095ac$var$_extends.apply(this, arguments);
}
function $6bb04f47d14095ac$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6bb04f47d14095ac$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6bb04f47d14095ac$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6bb04f47d14095ac$var$HeroHeader = function HeroHeader(_ref) {
    var className = _ref.className, props = $6bb04f47d14095ac$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $6bb04f47d14095ac$var$_react["default"].createElement($6bb04f47d14095ac$var$_element["default"], $6bb04f47d14095ac$var$_extends({}, props, {
        className: (0, $6bb04f47d14095ac$var$_classnames["default"])(className, 'hero-head')
    }));
};
$6bb04f47d14095ac$var$HeroHeader.defaultProps = {
    renderAs: 'header'
};
var $6bb04f47d14095ac$var$_default = $6bb04f47d14095ac$var$HeroHeader;
module.exports["default"] = $6bb04f47d14095ac$var$_default;

});

parcelRegister("kd8Md", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $eb6bd4626b83905d$var$_react = $eb6bd4626b83905d$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $eb6bd4626b83905d$var$_propTypes = $eb6bd4626b83905d$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $eb6bd4626b83905d$var$_classnames = $eb6bd4626b83905d$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $eb6bd4626b83905d$var$_element = $eb6bd4626b83905d$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $eb6bd4626b83905d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $eb6bd4626b83905d$var$_extends() {
    $eb6bd4626b83905d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eb6bd4626b83905d$var$_extends.apply(this, arguments);
}
function $eb6bd4626b83905d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eb6bd4626b83905d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eb6bd4626b83905d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $eb6bd4626b83905d$var$HeroBody = function HeroBody(_ref) {
    var className = _ref.className, props = $eb6bd4626b83905d$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $eb6bd4626b83905d$var$_react["default"].createElement($eb6bd4626b83905d$var$_element["default"], $eb6bd4626b83905d$var$_extends({}, props, {
        className: (0, $eb6bd4626b83905d$var$_classnames["default"])(className, 'hero-body')
    }));
};
$eb6bd4626b83905d$var$HeroBody.defaultProps = {
    renderAs: 'div'
};
var $eb6bd4626b83905d$var$_default = $eb6bd4626b83905d$var$HeroBody;
module.exports["default"] = $eb6bd4626b83905d$var$_default;

});

parcelRegister("bWvM4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8b1dc233f14bfcec$var$_react = $8b1dc233f14bfcec$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $8b1dc233f14bfcec$var$_propTypes = $8b1dc233f14bfcec$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $8b1dc233f14bfcec$var$_classnames = $8b1dc233f14bfcec$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $8b1dc233f14bfcec$var$_element = $8b1dc233f14bfcec$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $8b1dc233f14bfcec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8b1dc233f14bfcec$var$_extends() {
    $8b1dc233f14bfcec$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8b1dc233f14bfcec$var$_extends.apply(this, arguments);
}
function $8b1dc233f14bfcec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8b1dc233f14bfcec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8b1dc233f14bfcec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8b1dc233f14bfcec$var$HeroFooter = function HeroFooter(_ref) {
    var className = _ref.className, props = $8b1dc233f14bfcec$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $8b1dc233f14bfcec$var$_react["default"].createElement($8b1dc233f14bfcec$var$_element["default"], $8b1dc233f14bfcec$var$_extends({}, props, {
        className: (0, $8b1dc233f14bfcec$var$_classnames["default"])(className, 'hero-foot')
    }));
};
$8b1dc233f14bfcec$var$HeroFooter.defaultProps = {
    renderAs: 'footer'
};
var $8b1dc233f14bfcec$var$_default = $8b1dc233f14bfcec$var$HeroFooter;
module.exports["default"] = $8b1dc233f14bfcec$var$_default;

});



parcelRegister("dpDsx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9c3c37f401846199$var$_level = $9c3c37f401846199$var$_interopRequireDefault((parcelRequire("glLHg")));
function $9c3c37f401846199$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $9c3c37f401846199$var$_default = $9c3c37f401846199$var$_level["default"];
module.exports["default"] = $9c3c37f401846199$var$_default;

});
parcelRegister("glLHg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $be739b1af6c0b766$var$_react = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $be739b1af6c0b766$var$_propTypes = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $be739b1af6c0b766$var$_classnames2 = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $be739b1af6c0b766$var$_levelSide = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("1TXou")));

var $be739b1af6c0b766$var$_levelItem = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("fPWSD")));

var $be739b1af6c0b766$var$_element = $be739b1af6c0b766$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $be739b1af6c0b766$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $be739b1af6c0b766$var$_extends() {
    $be739b1af6c0b766$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be739b1af6c0b766$var$_extends.apply(this, arguments);
}
function $be739b1af6c0b766$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be739b1af6c0b766$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $be739b1af6c0b766$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $be739b1af6c0b766$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $be739b1af6c0b766$var$Level = function Level(_ref) {
    var children = _ref.children, className = _ref.className, breakpoint = _ref.breakpoint, props = $be739b1af6c0b766$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "breakpoint"
    ]);
    return /*#__PURE__*/ $be739b1af6c0b766$var$_react["default"].createElement($be739b1af6c0b766$var$_element["default"], $be739b1af6c0b766$var$_extends({}, props, {
        className: (0, $be739b1af6c0b766$var$_classnames2["default"])('level', className, $be739b1af6c0b766$var$_defineProperty({}, "is-".concat(breakpoint), breakpoint))
    }), children);
};
$be739b1af6c0b766$var$Level.Side = $be739b1af6c0b766$var$_levelSide["default"];
$be739b1af6c0b766$var$Level.Item = $be739b1af6c0b766$var$_levelItem["default"];
$be739b1af6c0b766$var$Level.defaultProps = {
    renderAs: 'nav'
};
var $be739b1af6c0b766$var$_default = $be739b1af6c0b766$var$Level;
module.exports["default"] = $be739b1af6c0b766$var$_default;

});
parcelRegister("1TXou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1628ffea6e44d622$var$_react = $1628ffea6e44d622$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $1628ffea6e44d622$var$_propTypes = $1628ffea6e44d622$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $1628ffea6e44d622$var$_classnames2 = $1628ffea6e44d622$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $1628ffea6e44d622$var$_element = $1628ffea6e44d622$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $1628ffea6e44d622$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1628ffea6e44d622$var$_extends() {
    $1628ffea6e44d622$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1628ffea6e44d622$var$_extends.apply(this, arguments);
}
function $1628ffea6e44d622$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1628ffea6e44d622$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1628ffea6e44d622$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1628ffea6e44d622$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1628ffea6e44d622$var$LevelSide = function LevelSide(_ref) {
    var className = _ref.className, align = _ref.align, props = $1628ffea6e44d622$var$_objectWithoutProperties(_ref, [
        "className",
        "align"
    ]);
    return /*#__PURE__*/ $1628ffea6e44d622$var$_react["default"].createElement($1628ffea6e44d622$var$_element["default"], $1628ffea6e44d622$var$_extends({}, props, {
        className: (0, $1628ffea6e44d622$var$_classnames2["default"])(className, $1628ffea6e44d622$var$_defineProperty({}, "level-".concat(align), align))
    }));
};
$1628ffea6e44d622$var$LevelSide.defaultProps = {
    align: 'left'
};
var $1628ffea6e44d622$var$_default = $1628ffea6e44d622$var$LevelSide;
module.exports["default"] = $1628ffea6e44d622$var$_default;

});

parcelRegister("fPWSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b8794acf748a68e5$var$_react = $b8794acf748a68e5$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $b8794acf748a68e5$var$_classnames = $b8794acf748a68e5$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b8794acf748a68e5$var$_element = $b8794acf748a68e5$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $b8794acf748a68e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b8794acf748a68e5$var$_extends() {
    $b8794acf748a68e5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8794acf748a68e5$var$_extends.apply(this, arguments);
}
function $b8794acf748a68e5$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b8794acf748a68e5$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b8794acf748a68e5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b8794acf748a68e5$var$LevelItem = function LevelItem(_ref) {
    var children = _ref.children, className = _ref.className, props = $b8794acf748a68e5$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $b8794acf748a68e5$var$_react["default"].createElement($b8794acf748a68e5$var$_element["default"], $b8794acf748a68e5$var$_extends({}, props, {
        className: (0, $b8794acf748a68e5$var$_classnames["default"])('level-item', className, {})
    }), children);
};
var $b8794acf748a68e5$var$_default = $b8794acf748a68e5$var$LevelItem;
module.exports["default"] = $b8794acf748a68e5$var$_default;

});



parcelRegister("l9pa5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f65df4d69aa264ff$var$_media = $f65df4d69aa264ff$var$_interopRequireDefault((parcelRequire("4dBuG")));
function $f65df4d69aa264ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f65df4d69aa264ff$var$_default = $f65df4d69aa264ff$var$_media["default"];
module.exports["default"] = $f65df4d69aa264ff$var$_default;

});
parcelRegister("4dBuG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $312575d4e73f2592$var$_react = $312575d4e73f2592$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $312575d4e73f2592$var$_propTypes = $312575d4e73f2592$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $312575d4e73f2592$var$_classnames = $312575d4e73f2592$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $312575d4e73f2592$var$_mediaItem = $312575d4e73f2592$var$_interopRequireDefault((parcelRequire("8Ctz0")));

var $312575d4e73f2592$var$_element = $312575d4e73f2592$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $312575d4e73f2592$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $312575d4e73f2592$var$_extends() {
    $312575d4e73f2592$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $312575d4e73f2592$var$_extends.apply(this, arguments);
}
function $312575d4e73f2592$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $312575d4e73f2592$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $312575d4e73f2592$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $312575d4e73f2592$var$Media = function Media(_ref) {
    var children = _ref.children, className = _ref.className, props = $312575d4e73f2592$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $312575d4e73f2592$var$_react["default"].createElement($312575d4e73f2592$var$_element["default"], $312575d4e73f2592$var$_extends({}, props, {
        className: (0, $312575d4e73f2592$var$_classnames["default"])('media', className, {})
    }), children);
};
$312575d4e73f2592$var$Media.Item = $312575d4e73f2592$var$_mediaItem["default"];
$312575d4e73f2592$var$Media.defaultProps = {
    renderAs: 'article'
};
var $312575d4e73f2592$var$_default = $312575d4e73f2592$var$Media;
module.exports["default"] = $312575d4e73f2592$var$_default;

});
parcelRegister("8Ctz0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $6468ce14c9888bc1$var$_react = $6468ce14c9888bc1$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $6468ce14c9888bc1$var$_propTypes = $6468ce14c9888bc1$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $6468ce14c9888bc1$var$_classnames2 = $6468ce14c9888bc1$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $6468ce14c9888bc1$var$_element = $6468ce14c9888bc1$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $6468ce14c9888bc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6468ce14c9888bc1$var$_extends() {
    $6468ce14c9888bc1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6468ce14c9888bc1$var$_extends.apply(this, arguments);
}
function $6468ce14c9888bc1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6468ce14c9888bc1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6468ce14c9888bc1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6468ce14c9888bc1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6468ce14c9888bc1$var$MediaItem = function MediaItem(_ref) {
    var children = _ref.children, className = _ref.className, align = _ref.align, props = $6468ce14c9888bc1$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "align"
    ]);
    var p = align === 'center' ? 'content' : align;
    return /*#__PURE__*/ $6468ce14c9888bc1$var$_react["default"].createElement($6468ce14c9888bc1$var$_element["default"], $6468ce14c9888bc1$var$_extends({}, props, {
        className: (0, $6468ce14c9888bc1$var$_classnames2["default"])(className, $6468ce14c9888bc1$var$_defineProperty({}, "media-".concat(p), p))
    }), children);
};
$6468ce14c9888bc1$var$MediaItem.defaultProps = {
    align: 'center'
};
var $6468ce14c9888bc1$var$_default = $6468ce14c9888bc1$var$MediaItem;
module.exports["default"] = $6468ce14c9888bc1$var$_default;

});



parcelRegister("3ygFC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $29617a6dce2783f1$var$_notification = $29617a6dce2783f1$var$_interopRequireDefault((parcelRequire("k9wvg")));
function $29617a6dce2783f1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $29617a6dce2783f1$var$_default = $29617a6dce2783f1$var$_notification["default"];
module.exports["default"] = $29617a6dce2783f1$var$_default;

});
parcelRegister("k9wvg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $eabddc61fc7641b1$var$_react = $eabddc61fc7641b1$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $eabddc61fc7641b1$var$_propTypes = $eabddc61fc7641b1$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $eabddc61fc7641b1$var$_classnames2 = $eabddc61fc7641b1$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $eabddc61fc7641b1$var$_element = $eabddc61fc7641b1$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $eabddc61fc7641b1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $eabddc61fc7641b1$var$_extends() {
    $eabddc61fc7641b1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $eabddc61fc7641b1$var$_extends.apply(this, arguments);
}
function $eabddc61fc7641b1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eabddc61fc7641b1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eabddc61fc7641b1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eabddc61fc7641b1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $eabddc61fc7641b1$var$Notification = function Notification(_ref) {
    var _classnames;
    var className = _ref.className, color = _ref.color, light = _ref.light, props = $eabddc61fc7641b1$var$_objectWithoutProperties(_ref, [
        "className",
        "color",
        "light"
    ]);
    return /*#__PURE__*/ $eabddc61fc7641b1$var$_react["default"].createElement($eabddc61fc7641b1$var$_element["default"], $eabddc61fc7641b1$var$_extends({}, props, {
        className: (0, $eabddc61fc7641b1$var$_classnames2["default"])('notification', (_classnames = {}, $eabddc61fc7641b1$var$_defineProperty(_classnames, "is-".concat(color), color), $eabddc61fc7641b1$var$_defineProperty(_classnames, 'is-light', light), _classnames), className)
    }));
};
var $eabddc61fc7641b1$var$_default = $eabddc61fc7641b1$var$Notification;
module.exports["default"] = $eabddc61fc7641b1$var$_default;

});


parcelRegister("7DfyH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $58e83e8bd8f4b3e8$var$_progress = $58e83e8bd8f4b3e8$var$_interopRequireDefault((parcelRequire("1FA5x")));
function $58e83e8bd8f4b3e8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $58e83e8bd8f4b3e8$var$_default = $58e83e8bd8f4b3e8$var$_progress["default"];
module.exports["default"] = $58e83e8bd8f4b3e8$var$_default;

});
parcelRegister("1FA5x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $13759d25a82b5dba$var$_react = $13759d25a82b5dba$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $13759d25a82b5dba$var$_propTypes = $13759d25a82b5dba$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $13759d25a82b5dba$var$_classnames2 = $13759d25a82b5dba$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $13759d25a82b5dba$var$_element = $13759d25a82b5dba$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $13759d25a82b5dba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $13759d25a82b5dba$var$_extends() {
    $13759d25a82b5dba$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $13759d25a82b5dba$var$_extends.apply(this, arguments);
}
function $13759d25a82b5dba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $13759d25a82b5dba$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $13759d25a82b5dba$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $13759d25a82b5dba$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $13759d25a82b5dba$var$Progress = function Progress(_ref) {
    var _classnames;
    var className = _ref.className, value = _ref.value, max = _ref.max, color = _ref.color, size = _ref.size, props = $13759d25a82b5dba$var$_objectWithoutProperties(_ref, [
        "className",
        "value",
        "max",
        "color",
        "size"
    ]);
    return /*#__PURE__*/ $13759d25a82b5dba$var$_react["default"].createElement($13759d25a82b5dba$var$_element["default"], $13759d25a82b5dba$var$_extends({}, props, {
        value: value,
        max: max,
        className: (0, $13759d25a82b5dba$var$_classnames2["default"])('progress', className, (_classnames = {}, $13759d25a82b5dba$var$_defineProperty(_classnames, "is-".concat(color), color), $13759d25a82b5dba$var$_defineProperty(_classnames, "is-".concat(size), size), _classnames))
    }));
};
$13759d25a82b5dba$var$Progress.defaultProps = {
    renderAs: 'progress'
};
var $13759d25a82b5dba$var$_default = $13759d25a82b5dba$var$Progress;
module.exports["default"] = $13759d25a82b5dba$var$_default;

});


parcelRegister("egHUh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a6349e46be51198c$var$_section = $a6349e46be51198c$var$_interopRequireDefault((parcelRequire("jZoyU")));
function $a6349e46be51198c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $a6349e46be51198c$var$_default = $a6349e46be51198c$var$_section["default"];
module.exports["default"] = $a6349e46be51198c$var$_default;

});
parcelRegister("jZoyU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e8d6c45bf1fc0b3d$var$_react = $e8d6c45bf1fc0b3d$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $e8d6c45bf1fc0b3d$var$_propTypes = $e8d6c45bf1fc0b3d$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $e8d6c45bf1fc0b3d$var$_classnames2 = $e8d6c45bf1fc0b3d$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $e8d6c45bf1fc0b3d$var$_element = $e8d6c45bf1fc0b3d$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $e8d6c45bf1fc0b3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $e8d6c45bf1fc0b3d$var$_extends() {
    $e8d6c45bf1fc0b3d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8d6c45bf1fc0b3d$var$_extends.apply(this, arguments);
}
function $e8d6c45bf1fc0b3d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e8d6c45bf1fc0b3d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8d6c45bf1fc0b3d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8d6c45bf1fc0b3d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $e8d6c45bf1fc0b3d$var$Section = function Section(_ref) {
    var children = _ref.children, className = _ref.className, size = _ref.size, props = $e8d6c45bf1fc0b3d$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size"
    ]);
    return /*#__PURE__*/ $e8d6c45bf1fc0b3d$var$_react["default"].createElement($e8d6c45bf1fc0b3d$var$_element["default"], $e8d6c45bf1fc0b3d$var$_extends({}, props, {
        className: (0, $e8d6c45bf1fc0b3d$var$_classnames2["default"])('section', className, $e8d6c45bf1fc0b3d$var$_defineProperty({}, "is-".concat(size), size))
    }), children);
};
$e8d6c45bf1fc0b3d$var$Section.defaultProps = {
    renderAs: 'section'
};
var $e8d6c45bf1fc0b3d$var$_default = $e8d6c45bf1fc0b3d$var$Section;
module.exports["default"] = $e8d6c45bf1fc0b3d$var$_default;

});


parcelRegister("ghmoh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bd9f9a33c3cfda10$var$_tabs = $bd9f9a33c3cfda10$var$_interopRequireDefault((parcelRequire("hOZMc")));
function $bd9f9a33c3cfda10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $bd9f9a33c3cfda10$var$_default = $bd9f9a33c3cfda10$var$_tabs["default"];
module.exports["default"] = $bd9f9a33c3cfda10$var$_default;

});
parcelRegister("hOZMc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $cf9706b164eb0341$var$_react = $cf9706b164eb0341$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $cf9706b164eb0341$var$_propTypes = $cf9706b164eb0341$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $cf9706b164eb0341$var$_classnames2 = $cf9706b164eb0341$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $cf9706b164eb0341$var$_tab = $cf9706b164eb0341$var$_interopRequireDefault((parcelRequire("b5Z9u")));

var $cf9706b164eb0341$var$_element = $cf9706b164eb0341$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $1tqZN = parcelRequire("1tqZN");
function $cf9706b164eb0341$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $cf9706b164eb0341$var$_extends() {
    $cf9706b164eb0341$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cf9706b164eb0341$var$_extends.apply(this, arguments);
}
function $cf9706b164eb0341$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cf9706b164eb0341$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cf9706b164eb0341$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cf9706b164eb0341$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $cf9706b164eb0341$var$Tabs = function Tabs(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, align = _ref.align, size = _ref.size, type = _ref.type, fullwidth = _ref.fullwidth, props = $cf9706b164eb0341$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "align",
        "size",
        "type",
        "fullwidth"
    ]);
    return /*#__PURE__*/ $cf9706b164eb0341$var$_react["default"].createElement($cf9706b164eb0341$var$_element["default"], $cf9706b164eb0341$var$_extends({}, props, {
        className: (0, $cf9706b164eb0341$var$_classnames2["default"])('tabs', className, (_classnames = {}, $cf9706b164eb0341$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeAlign)(align)), align), $cf9706b164eb0341$var$_defineProperty(_classnames, "is-".concat(size), size), $cf9706b164eb0341$var$_defineProperty(_classnames, 'is-toggle', type === 'toggle-rounded'), $cf9706b164eb0341$var$_defineProperty(_classnames, "is-".concat(type), type), $cf9706b164eb0341$var$_defineProperty(_classnames, 'is-fullwidth', fullwidth), _classnames))
    }), /*#__PURE__*/ $cf9706b164eb0341$var$_react["default"].createElement("ul", null, children));
};
$cf9706b164eb0341$var$Tabs.Tab = $cf9706b164eb0341$var$_tab["default"];
var $cf9706b164eb0341$var$_default = $cf9706b164eb0341$var$Tabs;
module.exports["default"] = $cf9706b164eb0341$var$_default;

});
parcelRegister("b5Z9u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $813f98d9ffd8ab19$var$_react = $813f98d9ffd8ab19$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $813f98d9ffd8ab19$var$_propTypes = $813f98d9ffd8ab19$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $813f98d9ffd8ab19$var$_classnames = $813f98d9ffd8ab19$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $813f98d9ffd8ab19$var$_element = $813f98d9ffd8ab19$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $813f98d9ffd8ab19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $813f98d9ffd8ab19$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $813f98d9ffd8ab19$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $813f98d9ffd8ab19$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $813f98d9ffd8ab19$var$Tab = function Tab(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, active = _ref.active, domRef = _ref.domRef, props = $813f98d9ffd8ab19$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "style",
        "active",
        "domRef"
    ]);
    return /*#__PURE__*/ $813f98d9ffd8ab19$var$_react["default"].createElement("li", {
        ref: domRef,
        style: style,
        className: (0, $813f98d9ffd8ab19$var$_classnames["default"])(className, {
            'is-active': active
        })
    }, /*#__PURE__*/ $813f98d9ffd8ab19$var$_react["default"].createElement($813f98d9ffd8ab19$var$_element["default"], props, children));
};
$813f98d9ffd8ab19$var$Tab.defaultProps = {
    renderAs: 'a'
};
var $813f98d9ffd8ab19$var$_default = $813f98d9ffd8ab19$var$Tab;
module.exports["default"] = $813f98d9ffd8ab19$var$_default;

});



parcelRegister("9Q8hv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $729f64e69b35ea0a$var$_table = $729f64e69b35ea0a$var$_interopRequireDefault((parcelRequire("je953")));
function $729f64e69b35ea0a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $729f64e69b35ea0a$var$_default = $729f64e69b35ea0a$var$_table["default"];
module.exports["default"] = $729f64e69b35ea0a$var$_default;

});
parcelRegister("je953", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $dff65e5254d1d679$var$_react = $dff65e5254d1d679$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $dff65e5254d1d679$var$_propTypes = $dff65e5254d1d679$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $dff65e5254d1d679$var$_classnames2 = $dff65e5254d1d679$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $dff65e5254d1d679$var$_element = $dff65e5254d1d679$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $dff65e5254d1d679$var$_container = $dff65e5254d1d679$var$_interopRequireDefault((parcelRequire("5TRaW")));
function $dff65e5254d1d679$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dff65e5254d1d679$var$_extends() {
    $dff65e5254d1d679$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dff65e5254d1d679$var$_extends.apply(this, arguments);
}
function $dff65e5254d1d679$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dff65e5254d1d679$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $dff65e5254d1d679$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $dff65e5254d1d679$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $dff65e5254d1d679$var$Table = function Table(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, size = _ref.size, striped = _ref.striped, bordered = _ref.bordered, hoverable = _ref.hoverable, props = $dff65e5254d1d679$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "size",
        "striped",
        "bordered",
        "hoverable"
    ]);
    return /*#__PURE__*/ $dff65e5254d1d679$var$_react["default"].createElement($dff65e5254d1d679$var$_element["default"], $dff65e5254d1d679$var$_extends({}, props, {
        renderAs: "table",
        className: (0, $dff65e5254d1d679$var$_classnames2["default"])('table', className, (_classnames = {}, $dff65e5254d1d679$var$_defineProperty(_classnames, "is-".concat(size), size), $dff65e5254d1d679$var$_defineProperty(_classnames, 'is-bordered', bordered), $dff65e5254d1d679$var$_defineProperty(_classnames, 'is-striped', striped), $dff65e5254d1d679$var$_defineProperty(_classnames, 'is-hoverable', hoverable), _classnames))
    }), children);
};
$dff65e5254d1d679$var$Table.defaultProps = {};
$dff65e5254d1d679$var$Table.Container = $dff65e5254d1d679$var$_container["default"];
var $dff65e5254d1d679$var$_default = $dff65e5254d1d679$var$Table;
module.exports["default"] = $dff65e5254d1d679$var$_default;

});
parcelRegister("5TRaW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $44bb565e81ce1974$var$_react = $44bb565e81ce1974$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $44bb565e81ce1974$var$_classnames = $44bb565e81ce1974$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $44bb565e81ce1974$var$_element = $44bb565e81ce1974$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $44bb565e81ce1974$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $44bb565e81ce1974$var$_extends() {
    $44bb565e81ce1974$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $44bb565e81ce1974$var$_extends.apply(this, arguments);
}
function $44bb565e81ce1974$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $44bb565e81ce1974$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $44bb565e81ce1974$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $44bb565e81ce1974$var$TableContainer = function TableContainer(_ref) {
    var className = _ref.className, props = $44bb565e81ce1974$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $44bb565e81ce1974$var$_react["default"].createElement($44bb565e81ce1974$var$_element["default"], $44bb565e81ce1974$var$_extends({}, props, {
        className: (0, $44bb565e81ce1974$var$_classnames["default"])('table-container', className)
    }));
};
$44bb565e81ce1974$var$TableContainer.defaultProps = {};
var $44bb565e81ce1974$var$_default = $44bb565e81ce1974$var$TableContainer;
module.exports["default"] = $44bb565e81ce1974$var$_default;

});



parcelRegister("2xS2j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $1da8944f9bf17684$var$_tag = $1da8944f9bf17684$var$_interopRequireDefault((parcelRequire("cUoPT")));
function $1da8944f9bf17684$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1da8944f9bf17684$var$_default = $1da8944f9bf17684$var$_tag["default"];
module.exports["default"] = $1da8944f9bf17684$var$_default;

});
parcelRegister("cUoPT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $965dfaed62e879dd$var$_react = $965dfaed62e879dd$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $965dfaed62e879dd$var$_propTypes = $965dfaed62e879dd$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $965dfaed62e879dd$var$_classnames2 = $965dfaed62e879dd$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $965dfaed62e879dd$var$_tagGroup = $965dfaed62e879dd$var$_interopRequireDefault((parcelRequire("9SJuh")));

var $965dfaed62e879dd$var$_element = $965dfaed62e879dd$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $965dfaed62e879dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $965dfaed62e879dd$var$_extends() {
    $965dfaed62e879dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $965dfaed62e879dd$var$_extends.apply(this, arguments);
}
function $965dfaed62e879dd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $965dfaed62e879dd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $965dfaed62e879dd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $965dfaed62e879dd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $965dfaed62e879dd$var$Tag = function Tag(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, size = _ref.size, rounded = _ref.rounded, remove = _ref.remove, props = $965dfaed62e879dd$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "size",
        "rounded",
        "remove"
    ]);
    return /*#__PURE__*/ $965dfaed62e879dd$var$_react["default"].createElement($965dfaed62e879dd$var$_element["default"], $965dfaed62e879dd$var$_extends({}, props, {
        className: (0, $965dfaed62e879dd$var$_classnames2["default"])('tag', className, (_classnames = {}, $965dfaed62e879dd$var$_defineProperty(_classnames, "is-".concat(size), size), $965dfaed62e879dd$var$_defineProperty(_classnames, "is-".concat(color), color), $965dfaed62e879dd$var$_defineProperty(_classnames, 'is-rounded', rounded), $965dfaed62e879dd$var$_defineProperty(_classnames, 'is-delete', remove), _classnames))
    }), !remove && children);
};
$965dfaed62e879dd$var$Tag.Group = $965dfaed62e879dd$var$_tagGroup["default"];
$965dfaed62e879dd$var$Tag.defaultProps = {
    renderAs: 'span'
};
var $965dfaed62e879dd$var$_default = $965dfaed62e879dd$var$Tag;
module.exports["default"] = $965dfaed62e879dd$var$_default;

});
parcelRegister("9SJuh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $731c71100d4c933e$var$_react = $731c71100d4c933e$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $731c71100d4c933e$var$_propTypes = $731c71100d4c933e$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $731c71100d4c933e$var$_classnames = $731c71100d4c933e$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $731c71100d4c933e$var$_element = $731c71100d4c933e$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $731c71100d4c933e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $731c71100d4c933e$var$_extends() {
    $731c71100d4c933e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $731c71100d4c933e$var$_extends.apply(this, arguments);
}
function $731c71100d4c933e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $731c71100d4c933e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $731c71100d4c933e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $731c71100d4c933e$var$TagGroup = function TagGroup(_ref) {
    var children = _ref.children, className = _ref.className, gapless = _ref.gapless, hasAddons = _ref.hasAddons, props = $731c71100d4c933e$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "gapless",
        "hasAddons"
    ]);
    return /*#__PURE__*/ $731c71100d4c933e$var$_react["default"].createElement($731c71100d4c933e$var$_element["default"], $731c71100d4c933e$var$_extends({}, props, {
        className: (0, $731c71100d4c933e$var$_classnames["default"])('tags', className, {
            'has-addons': gapless || hasAddons
        })
    }), children);
};
$731c71100d4c933e$var$TagGroup.defaultProps = {
    renderAs: 'span'
};
var $731c71100d4c933e$var$_default = $731c71100d4c933e$var$TagGroup;
module.exports["default"] = $731c71100d4c933e$var$_default;

});



parcelRegister("dhWki", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9aca1b4e67dd693c$var$_tile = $9aca1b4e67dd693c$var$_interopRequireDefault((parcelRequire("23mmq")));
function $9aca1b4e67dd693c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $9aca1b4e67dd693c$var$_default = $9aca1b4e67dd693c$var$_tile["default"];
module.exports["default"] = $9aca1b4e67dd693c$var$_default;

});
parcelRegister("23mmq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $17ed34f768f87dbd$var$_react = $17ed34f768f87dbd$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $17ed34f768f87dbd$var$_propTypes = $17ed34f768f87dbd$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $17ed34f768f87dbd$var$_classnames2 = $17ed34f768f87dbd$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $17ed34f768f87dbd$var$_element = $17ed34f768f87dbd$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $17ed34f768f87dbd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $17ed34f768f87dbd$var$_extends() {
    $17ed34f768f87dbd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17ed34f768f87dbd$var$_extends.apply(this, arguments);
}
function $17ed34f768f87dbd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17ed34f768f87dbd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $17ed34f768f87dbd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $17ed34f768f87dbd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $17ed34f768f87dbd$var$Tile = function Tile(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, kind = _ref.kind, vertical = _ref.vertical, size = _ref.size, color = _ref.color, props = $17ed34f768f87dbd$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "kind",
        "vertical",
        "size",
        "color"
    ]);
    return /*#__PURE__*/ $17ed34f768f87dbd$var$_react["default"].createElement($17ed34f768f87dbd$var$_element["default"], $17ed34f768f87dbd$var$_extends({}, props, {
        className: (0, $17ed34f768f87dbd$var$_classnames2["default"])('tile', className, (_classnames = {}, $17ed34f768f87dbd$var$_defineProperty(_classnames, "is-".concat(kind), kind), $17ed34f768f87dbd$var$_defineProperty(_classnames, "is-".concat(size), size), $17ed34f768f87dbd$var$_defineProperty(_classnames, "is-".concat(color), color), $17ed34f768f87dbd$var$_defineProperty(_classnames, 'is-vertical', vertical), _classnames))
    }), children);
};
var $17ed34f768f87dbd$var$_default = $17ed34f768f87dbd$var$Tile;
module.exports["default"] = $17ed34f768f87dbd$var$_default;

});


parcelRegister("gmpiO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $be9253f71891ce8d$var$_modal = $be9253f71891ce8d$var$_interopRequireDefault((parcelRequire("3w6Kr")));
function $be9253f71891ce8d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $be9253f71891ce8d$var$_default = $be9253f71891ce8d$var$_modal["default"];
module.exports["default"] = $be9253f71891ce8d$var$_default;

});
parcelRegister("3w6Kr", function(module, exports) {
"use strict";
function $28f99846f345a8c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $28f99846f345a8c9$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $28f99846f345a8c9$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $28f99846f345a8c9$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $28f99846f345a8c9$var$_react = $28f99846f345a8c9$var$_interopRequireWildcard((parcelRequire("3ZYaX")));

var $28f99846f345a8c9$var$_reactDom = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("1rKN8")));

var $28f99846f345a8c9$var$_propTypes = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $28f99846f345a8c9$var$_classnames = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $28f99846f345a8c9$var$_content = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("7Z0km")));

var $28f99846f345a8c9$var$_card = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("jFUX8")));

var $2dEAV = parcelRequire("2dEAV");

var $28f99846f345a8c9$var$_element = $28f99846f345a8c9$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $28f99846f345a8c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $28f99846f345a8c9$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $28f99846f345a8c9$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $28f99846f345a8c9$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $28f99846f345a8c9$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $28f99846f345a8c9$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $28f99846f345a8c9$var$_slicedToArray(arr, i) {
    return $28f99846f345a8c9$var$_arrayWithHoles(arr) || $28f99846f345a8c9$var$_iterableToArrayLimit(arr, i) || $28f99846f345a8c9$var$_unsupportedIterableToArray(arr, i) || $28f99846f345a8c9$var$_nonIterableRest();
}
function $28f99846f345a8c9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $28f99846f345a8c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $28f99846f345a8c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $28f99846f345a8c9$var$_arrayLikeToArray(o, minLen);
}
function $28f99846f345a8c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $28f99846f345a8c9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $28f99846f345a8c9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $28f99846f345a8c9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $28f99846f345a8c9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $28f99846f345a8c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $28f99846f345a8c9$var$KEYCODES = {
    ESCAPE: 27
};
var $28f99846f345a8c9$var$Modal = function Modal(_ref) {
    var domRef = _ref.domRef, children = _ref.children, className = _ref.className, show = _ref.show, closeOnBlur = _ref.closeOnBlur, showClose = _ref.showClose, onClose = _ref.onClose, closeOnEsc = _ref.closeOnEsc, props = $28f99846f345a8c9$var$_objectWithoutProperties(_ref, [
        "domRef",
        "children",
        "className",
        "show",
        "closeOnBlur",
        "showClose",
        "onClose",
        "closeOnEsc"
    ]);
    var ref = (0, $28f99846f345a8c9$var$_react.useRef)(domRef);
    var _useState = (0, $28f99846f345a8c9$var$_react.useState)(), _useState2 = $28f99846f345a8c9$var$_slicedToArray(_useState, 2), portalContainer = _useState2[0], setPortalContainer = _useState2[1];
    (0, $28f99846f345a8c9$var$_react.useEffect)(function() {
        if (!show) return undefined;
        var doc = props.document || document;
        var container = doc.createElement('div');
        container.setAttribute('class', 'modal-container');
        doc.body.appendChild(container);
        setPortalContainer(container);
        var handleKeydown = function handleKeydown(evt) {
            if (evt.keyCode === $28f99846f345a8c9$var$KEYCODES.ESCAPE && show) onClose();
        };
        if (closeOnEsc) doc.addEventListener('keydown', handleKeydown);
        return function() {
            doc.removeEventListener('keydown', handleKeydown);
            container.parentNode.removeChild(container);
        };
    }, [
        show
    ]);
    if (!portalContainer) return null;
    return /*#__PURE__*/ $28f99846f345a8c9$var$_reactDom["default"].createPortal(/*#__PURE__*/ $28f99846f345a8c9$var$_react["default"].createElement($2dEAV.ModalContext.Provider, {
        value: {
            onClose: onClose
        }
    }, /*#__PURE__*/ $28f99846f345a8c9$var$_react["default"].createElement($28f99846f345a8c9$var$_element["default"], {
        domRef: ref,
        className: (0, $28f99846f345a8c9$var$_classnames["default"])('modal', className, {
            'is-active': show
        })
    }, /*#__PURE__*/ $28f99846f345a8c9$var$_react["default"].createElement("div", {
        role: "presentation",
        className: "modal-background",
        onClick: closeOnBlur ? onClose : undefined
    }), children, showClose && /*#__PURE__*/ $28f99846f345a8c9$var$_react["default"].createElement("button", {
        type: "button",
        onClick: onClose,
        className: "modal-close is-large",
        "aria-label": "close"
    }))), portalContainer);
};
$28f99846f345a8c9$var$Modal.Content = $28f99846f345a8c9$var$_content["default"];
$28f99846f345a8c9$var$Modal.Card = $28f99846f345a8c9$var$_card["default"];
$28f99846f345a8c9$var$Modal.defaultProps = {
    closeOnEsc: true,
    showClose: true,
    // Expose mount point for testing
    document: undefined
};
var $28f99846f345a8c9$var$_default = $28f99846f345a8c9$var$Modal;
module.exports["default"] = $28f99846f345a8c9$var$_default;

});
parcelRegister("7Z0km", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5cfe7be9fe34a010$var$_react = $5cfe7be9fe34a010$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $5cfe7be9fe34a010$var$_classnames = $5cfe7be9fe34a010$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $5cfe7be9fe34a010$var$_element = $5cfe7be9fe34a010$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $5cfe7be9fe34a010$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5cfe7be9fe34a010$var$_extends() {
    $5cfe7be9fe34a010$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cfe7be9fe34a010$var$_extends.apply(this, arguments);
}
function $5cfe7be9fe34a010$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5cfe7be9fe34a010$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5cfe7be9fe34a010$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5cfe7be9fe34a010$var$ModalContent = function ModalContent(_ref) {
    var children = _ref.children, className = _ref.className, props = $5cfe7be9fe34a010$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $5cfe7be9fe34a010$var$_react["default"].createElement($5cfe7be9fe34a010$var$_element["default"], $5cfe7be9fe34a010$var$_extends({}, props, {
        className: (0, $5cfe7be9fe34a010$var$_classnames["default"])('modal-content', className)
    }), children);
};
var $5cfe7be9fe34a010$var$_default = $5cfe7be9fe34a010$var$ModalContent;
module.exports["default"] = $5cfe7be9fe34a010$var$_default;

});

parcelRegister("jFUX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $e52e064651b82167$var$_card = $e52e064651b82167$var$_interopRequireDefault((parcelRequire("dpa69")));
function $e52e064651b82167$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e52e064651b82167$var$_default = $e52e064651b82167$var$_card["default"];
module.exports["default"] = $e52e064651b82167$var$_default;

});
parcelRegister("dpa69", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9c25717ad77a8e02$var$_react = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9c25717ad77a8e02$var$_classnames = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9c25717ad77a8e02$var$_header = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("3dFtA")));

var $9c25717ad77a8e02$var$_body = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("ZC3IK")));

var $9c25717ad77a8e02$var$_footer = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("czTYR")));

var $9c25717ad77a8e02$var$_title = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("iQ221")));

var $9c25717ad77a8e02$var$_element = $9c25717ad77a8e02$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $9c25717ad77a8e02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9c25717ad77a8e02$var$_extends() {
    $9c25717ad77a8e02$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9c25717ad77a8e02$var$_extends.apply(this, arguments);
}
function $9c25717ad77a8e02$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9c25717ad77a8e02$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9c25717ad77a8e02$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9c25717ad77a8e02$var$ModalCard = function ModalCard(_ref) {
    var className = _ref.className, onClose = _ref.onClose, children = _ref.children, props = $9c25717ad77a8e02$var$_objectWithoutProperties(_ref, [
        "className",
        "onClose",
        "children"
    ]);
    return /*#__PURE__*/ $9c25717ad77a8e02$var$_react["default"].createElement($9c25717ad77a8e02$var$_element["default"], $9c25717ad77a8e02$var$_extends({}, props, {
        className: (0, $9c25717ad77a8e02$var$_classnames["default"])('modal-card', className)
    }), children);
};
$9c25717ad77a8e02$var$ModalCard.Header = $9c25717ad77a8e02$var$_header["default"];
$9c25717ad77a8e02$var$ModalCard.Body = $9c25717ad77a8e02$var$_body["default"];
$9c25717ad77a8e02$var$ModalCard.Footer = $9c25717ad77a8e02$var$_footer["default"];
$9c25717ad77a8e02$var$ModalCard.Title = $9c25717ad77a8e02$var$_title["default"];
$9c25717ad77a8e02$var$ModalCard.defaultProps = {};
var $9c25717ad77a8e02$var$_default = $9c25717ad77a8e02$var$ModalCard;
module.exports["default"] = $9c25717ad77a8e02$var$_default;

});
parcelRegister("3dFtA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2582c24cddd750b3$var$_react = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $2582c24cddd750b3$var$_propTypes = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $2582c24cddd750b3$var$_classnames = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $2582c24cddd750b3$var$_button = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("7aX84")));

var $2582c24cddd750b3$var$_element = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("bQWwh")));

var $2582c24cddd750b3$var$_context = $2582c24cddd750b3$var$_interopRequireDefault((parcelRequire("2dEAV")));
function $2582c24cddd750b3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2582c24cddd750b3$var$_extends() {
    $2582c24cddd750b3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2582c24cddd750b3$var$_extends.apply(this, arguments);
}
function $2582c24cddd750b3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2582c24cddd750b3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2582c24cddd750b3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2582c24cddd750b3$var$ModalCardHead = function ModalCardHead(_ref) {
    var children = _ref.children, className = _ref.className, showClose = _ref.showClose, props = $2582c24cddd750b3$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "showClose"
    ]);
    var _useModalContext = (0, $2582c24cddd750b3$var$_context["default"])(), onClose = _useModalContext.onClose;
    return /*#__PURE__*/ $2582c24cddd750b3$var$_react["default"].createElement($2582c24cddd750b3$var$_element["default"], $2582c24cddd750b3$var$_extends({}, props, {
        className: (0, $2582c24cddd750b3$var$_classnames["default"])('modal-card-head', className)
    }), children, showClose && /*#__PURE__*/ $2582c24cddd750b3$var$_react["default"].createElement($2582c24cddd750b3$var$_button["default"], {
        remove: true,
        onClick: onClose
    }));
};
$2582c24cddd750b3$var$ModalCardHead.defaultProps = {
    showClose: true,
    renderAs: 'header'
};
var $2582c24cddd750b3$var$_default = $2582c24cddd750b3$var$ModalCardHead;
module.exports["default"] = $2582c24cddd750b3$var$_default;

});
parcelRegister("2dEAV", function(module, exports) {
"use strict";
function $19dc48ea21974060$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $19dc48ea21974060$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $19dc48ea21974060$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $19dc48ea21974060$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.ModalContext = void 0;

var $19dc48ea21974060$var$_react = $19dc48ea21974060$var$_interopRequireWildcard((parcelRequire("3ZYaX")));
function $19dc48ea21974060$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $19dc48ea21974060$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $19dc48ea21974060$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $19dc48ea21974060$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $19dc48ea21974060$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $19dc48ea21974060$var$ModalContext = /*#__PURE__*/ $19dc48ea21974060$var$_react["default"].createContext({
    onClose: function onClose() {}
});
module.exports.ModalContext = $19dc48ea21974060$var$ModalContext;
var $19dc48ea21974060$var$useModalContext = function useModalContext() {
    return (0, $19dc48ea21974060$var$_react.useContext)($19dc48ea21974060$var$ModalContext);
};
var $19dc48ea21974060$var$_default = $19dc48ea21974060$var$useModalContext;
module.exports["default"] = $19dc48ea21974060$var$_default;

});


parcelRegister("ZC3IK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0b933858e3a2fb93$var$_react = $0b933858e3a2fb93$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $0b933858e3a2fb93$var$_propTypes = $0b933858e3a2fb93$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $0b933858e3a2fb93$var$_classnames = $0b933858e3a2fb93$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $0b933858e3a2fb93$var$_element = $0b933858e3a2fb93$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $0b933858e3a2fb93$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0b933858e3a2fb93$var$_extends() {
    $0b933858e3a2fb93$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0b933858e3a2fb93$var$_extends.apply(this, arguments);
}
function $0b933858e3a2fb93$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0b933858e3a2fb93$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0b933858e3a2fb93$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0b933858e3a2fb93$var$ModalCardBody = function ModalCardBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $0b933858e3a2fb93$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $0b933858e3a2fb93$var$_react["default"].createElement($0b933858e3a2fb93$var$_element["default"], $0b933858e3a2fb93$var$_extends({}, props, {
        className: (0, $0b933858e3a2fb93$var$_classnames["default"])('modal-card-body', className)
    }), children);
};
$0b933858e3a2fb93$var$ModalCardBody.defaultProps = {
    renderAs: 'section'
};
var $0b933858e3a2fb93$var$_default = $0b933858e3a2fb93$var$ModalCardBody;
module.exports["default"] = $0b933858e3a2fb93$var$_default;

});

parcelRegister("czTYR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $92842d7beaf2fd58$var$_react = $92842d7beaf2fd58$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $92842d7beaf2fd58$var$_propTypes = $92842d7beaf2fd58$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $92842d7beaf2fd58$var$_classnames = $92842d7beaf2fd58$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $92842d7beaf2fd58$var$_element = $92842d7beaf2fd58$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $92842d7beaf2fd58$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $92842d7beaf2fd58$var$_extends() {
    $92842d7beaf2fd58$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $92842d7beaf2fd58$var$_extends.apply(this, arguments);
}
function $92842d7beaf2fd58$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $92842d7beaf2fd58$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $92842d7beaf2fd58$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $92842d7beaf2fd58$var$ModalCardFoot = function ModalCardFoot(_ref) {
    var children = _ref.children, className = _ref.className, props = $92842d7beaf2fd58$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $92842d7beaf2fd58$var$_react["default"].createElement($92842d7beaf2fd58$var$_element["default"], $92842d7beaf2fd58$var$_extends({}, props, {
        className: (0, $92842d7beaf2fd58$var$_classnames["default"])('modal-card-foot', className)
    }), children);
};
$92842d7beaf2fd58$var$ModalCardFoot.defaultProps = {
    renderAs: 'footer'
};
var $92842d7beaf2fd58$var$_default = $92842d7beaf2fd58$var$ModalCardFoot;
module.exports["default"] = $92842d7beaf2fd58$var$_default;

});

parcelRegister("iQ221", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $db6ea8bf7d4170d1$var$_react = $db6ea8bf7d4170d1$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $db6ea8bf7d4170d1$var$_propTypes = $db6ea8bf7d4170d1$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $db6ea8bf7d4170d1$var$_classnames = $db6ea8bf7d4170d1$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $db6ea8bf7d4170d1$var$_element = $db6ea8bf7d4170d1$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $db6ea8bf7d4170d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $db6ea8bf7d4170d1$var$_extends() {
    $db6ea8bf7d4170d1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $db6ea8bf7d4170d1$var$_extends.apply(this, arguments);
}
function $db6ea8bf7d4170d1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $db6ea8bf7d4170d1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $db6ea8bf7d4170d1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $db6ea8bf7d4170d1$var$ModalCardTitle = function ModalCardTitle(_ref) {
    var children = _ref.children, className = _ref.className, props = $db6ea8bf7d4170d1$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $db6ea8bf7d4170d1$var$_react["default"].createElement($db6ea8bf7d4170d1$var$_element["default"], $db6ea8bf7d4170d1$var$_extends({}, props, {
        className: (0, $db6ea8bf7d4170d1$var$_classnames["default"])('modal-card-title', className)
    }), children);
};
$db6ea8bf7d4170d1$var$ModalCardTitle.defaultProps = {
    renderAs: 'p'
};
var $db6ea8bf7d4170d1$var$_default = $db6ea8bf7d4170d1$var$ModalCardTitle;
module.exports["default"] = $db6ea8bf7d4170d1$var$_default;

});





parcelRegister("4xbzi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $34d337b14e87f0fa$var$_dropdown = $34d337b14e87f0fa$var$_interopRequireDefault((parcelRequire("bsiGb")));
function $34d337b14e87f0fa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $34d337b14e87f0fa$var$_default = $34d337b14e87f0fa$var$_dropdown["default"];
module.exports["default"] = $34d337b14e87f0fa$var$_default;

});
parcelRegister("bsiGb", function(module, exports) {
"use strict";
function $8570cc983277a8ed$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $8570cc983277a8ed$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $8570cc983277a8ed$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8570cc983277a8ed$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8570cc983277a8ed$var$_react = $8570cc983277a8ed$var$_interopRequireWildcard((parcelRequire("3ZYaX")));

var $8570cc983277a8ed$var$_propTypes = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $8570cc983277a8ed$var$_classnames = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $8570cc983277a8ed$var$_item = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("lLsIX")));

var $8570cc983277a8ed$var$_divider = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("dG6ad")));

var $8570cc983277a8ed$var$_button = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("7aX84")));

var $8570cc983277a8ed$var$_element = $8570cc983277a8ed$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $8570cc983277a8ed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8570cc983277a8ed$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $8570cc983277a8ed$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $8570cc983277a8ed$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $8570cc983277a8ed$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $8570cc983277a8ed$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8570cc983277a8ed$var$_extends() {
    $8570cc983277a8ed$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8570cc983277a8ed$var$_extends.apply(this, arguments);
}
function $8570cc983277a8ed$var$_slicedToArray(arr, i) {
    return $8570cc983277a8ed$var$_arrayWithHoles(arr) || $8570cc983277a8ed$var$_iterableToArrayLimit(arr, i) || $8570cc983277a8ed$var$_unsupportedIterableToArray(arr, i) || $8570cc983277a8ed$var$_nonIterableRest();
}
function $8570cc983277a8ed$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8570cc983277a8ed$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8570cc983277a8ed$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8570cc983277a8ed$var$_arrayLikeToArray(o, minLen);
}
function $8570cc983277a8ed$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8570cc983277a8ed$var$_iterableToArrayLimit(arr, i) {
    var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8570cc983277a8ed$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $8570cc983277a8ed$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8570cc983277a8ed$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8570cc983277a8ed$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8570cc983277a8ed$var$Dropdown = function Dropdown(_ref) {
    var className = _ref.className, children = _ref.children, value = _ref.value, color = _ref.color, align = _ref.align, right = _ref.right, up = _ref.up, hoverable = _ref.hoverable, label = _ref.label, onChange = _ref.onChange, closeOnSelect = _ref.closeOnSelect, icon = _ref.icon, domRef = _ref.domRef, disabled = _ref.disabled, props = $8570cc983277a8ed$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "value",
        "color",
        "align",
        "right",
        "up",
        "hoverable",
        "label",
        "onChange",
        "closeOnSelect",
        "icon",
        "domRef",
        "disabled"
    ]);
    var ref = (0, $8570cc983277a8ed$var$_react.useRef)(domRef);
    var _useState = (0, $8570cc983277a8ed$var$_react.useState)(false), _useState2 = $8570cc983277a8ed$var$_slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var close = function close(evt) {
        // IDK yet how to test using the ref in enzime
        // istanbul ignore if
        if (hoverable || evt && ref && ref.current && ref.current.contains(evt.target)) return;
        if (ref.current) setIsOpen(false);
    };
    var onSelect = function onSelect(selectedValue) {
        return function() {
            if (onChange) onChange(selectedValue);
            if (closeOnSelect) close();
        };
    };
    (0, $8570cc983277a8ed$var$_react.useEffect)(function() {
        window.addEventListener('click', close);
        return function() {
            window.removeEventListener('click', close);
        };
    }, []);
    var current = label;
    var childrenArray = $8570cc983277a8ed$var$_react["default"].Children.map(children, function(child, i) {
        if (child.type === $8570cc983277a8ed$var$_item["default"] && (i === 0 && !label || child.props.value === value)) current = child.props.children;
        return /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].cloneElement(child, child.type === $8570cc983277a8ed$var$_item["default"] ? {
            active: child.props.value === value,
            onClick: onSelect(child.props.value)
        } : {});
    });
    return /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement($8570cc983277a8ed$var$_element["default"], $8570cc983277a8ed$var$_extends({}, props, {
        domRef: ref,
        className: (0, $8570cc983277a8ed$var$_classnames["default"])('dropdown', className, {
            'is-active': isOpen,
            'is-up': up,
            'is-right': right || align === 'right',
            'is-hoverable': hoverable
        })
    }), /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement("div", {
        className: "dropdown-trigger",
        role: "presentation",
        onClick: function onClick() {
            if (disabled) return;
            setIsOpen(function(open) {
                return !open;
            });
        }
    }, /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement($8570cc983277a8ed$var$_button["default"], {
        disabled: disabled,
        color: color
    }, /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement("span", null, current), icon)), /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement("div", {
        className: "dropdown-menu",
        id: "dropdown-menu",
        role: "menu"
    }, /*#__PURE__*/ $8570cc983277a8ed$var$_react["default"].createElement("div", {
        className: "dropdown-content"
    }, childrenArray)));
};
$8570cc983277a8ed$var$Dropdown.Item = $8570cc983277a8ed$var$_item["default"];
$8570cc983277a8ed$var$Dropdown.Divider = $8570cc983277a8ed$var$_divider["default"];
$8570cc983277a8ed$var$Dropdown.defaultProps = {
    closeOnSelect: true
};
var $8570cc983277a8ed$var$_default = $8570cc983277a8ed$var$Dropdown;
module.exports["default"] = $8570cc983277a8ed$var$_default;

});
parcelRegister("lLsIX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $fd8444c33255767f$var$_react = $fd8444c33255767f$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $fd8444c33255767f$var$_propTypes = $fd8444c33255767f$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $fd8444c33255767f$var$_classnames = $fd8444c33255767f$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $fd8444c33255767f$var$_element = $fd8444c33255767f$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $fd8444c33255767f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fd8444c33255767f$var$_extends() {
    $fd8444c33255767f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fd8444c33255767f$var$_extends.apply(this, arguments);
}
function $fd8444c33255767f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fd8444c33255767f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fd8444c33255767f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $fd8444c33255767f$var$DropdownItem = function DropdownItem(_ref) {
    var active = _ref.active, children = _ref.children, value = _ref.value, className = _ref.className, props = $fd8444c33255767f$var$_objectWithoutProperties(_ref, [
        "active",
        "children",
        "value",
        "className"
    ]);
    return /*#__PURE__*/ $fd8444c33255767f$var$_react["default"].createElement($fd8444c33255767f$var$_element["default"], $fd8444c33255767f$var$_extends({
        title: value
    }, props, {
        role: "presentation",
        className: (0, $fd8444c33255767f$var$_classnames["default"])(className, 'dropdown-item', {
            'is-active': active
        })
    }), children);
};
$fd8444c33255767f$var$DropdownItem.defaultProps = {};
var $fd8444c33255767f$var$_default = $fd8444c33255767f$var$DropdownItem;
module.exports["default"] = $fd8444c33255767f$var$_default;

});

parcelRegister("dG6ad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9f53fa94bc158737$var$_react = $9f53fa94bc158737$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9f53fa94bc158737$var$_classnames = $9f53fa94bc158737$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9f53fa94bc158737$var$_element = $9f53fa94bc158737$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $9f53fa94bc158737$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9f53fa94bc158737$var$_extends() {
    $9f53fa94bc158737$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9f53fa94bc158737$var$_extends.apply(this, arguments);
}
function $9f53fa94bc158737$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9f53fa94bc158737$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9f53fa94bc158737$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9f53fa94bc158737$var$DropdownDivider = function DropdownDivider(_ref) {
    var className = _ref.className, props = $9f53fa94bc158737$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $9f53fa94bc158737$var$_react["default"].createElement($9f53fa94bc158737$var$_element["default"], $9f53fa94bc158737$var$_extends({}, props, {
        className: (0, $9f53fa94bc158737$var$_classnames["default"])('dropdown-divider', className)
    }));
};
$9f53fa94bc158737$var$DropdownDivider.defaultProps = {
    renderAs: 'hr'
};
var $9f53fa94bc158737$var$_default = $9f53fa94bc158737$var$DropdownDivider;
module.exports["default"] = $9f53fa94bc158737$var$_default;

});



parcelRegister("1UAhC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $16472a80b48b70da$var$_loader = $16472a80b48b70da$var$_interopRequireDefault((parcelRequire("fm5s5")));
function $16472a80b48b70da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $16472a80b48b70da$var$_default = $16472a80b48b70da$var$_loader["default"];
module.exports["default"] = $16472a80b48b70da$var$_default;

});
parcelRegister("fm5s5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b2dd23c488095cd4$var$_react = $b2dd23c488095cd4$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $b2dd23c488095cd4$var$_classnames = $b2dd23c488095cd4$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b2dd23c488095cd4$var$_element = $b2dd23c488095cd4$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $b2dd23c488095cd4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b2dd23c488095cd4$var$_extends() {
    $b2dd23c488095cd4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2dd23c488095cd4$var$_extends.apply(this, arguments);
}
function $b2dd23c488095cd4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b2dd23c488095cd4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b2dd23c488095cd4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b2dd23c488095cd4$var$Loader = function Loader(_ref) {
    var children = _ref.children, className = _ref.className, props = $b2dd23c488095cd4$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $b2dd23c488095cd4$var$_react["default"].createElement($b2dd23c488095cd4$var$_element["default"], $b2dd23c488095cd4$var$_extends({}, props, {
        className: (0, $b2dd23c488095cd4$var$_classnames["default"])('loader', className)
    }), children);
};
var $b2dd23c488095cd4$var$_default = $b2dd23c488095cd4$var$Loader;
module.exports["default"] = $b2dd23c488095cd4$var$_default;

});


parcelRegister("kUKI3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f39d45255efaa90b$var$_navbar = $f39d45255efaa90b$var$_interopRequireDefault((parcelRequire("fGCDx")));
function $f39d45255efaa90b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f39d45255efaa90b$var$_default = $f39d45255efaa90b$var$_navbar["default"];
module.exports["default"] = $f39d45255efaa90b$var$_default;

});
parcelRegister("fGCDx", function(module, exports) {
"use strict";
function $b6b8bfb9ec31d351$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b6b8bfb9ec31d351$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b6b8bfb9ec31d351$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b6b8bfb9ec31d351$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b6b8bfb9ec31d351$var$_react = $b6b8bfb9ec31d351$var$_interopRequireWildcard((parcelRequire("3ZYaX")));

var $b6b8bfb9ec31d351$var$_propTypes = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $b6b8bfb9ec31d351$var$_classnames2 = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $b6b8bfb9ec31d351$var$_brand = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("hzuCF")));

var $b6b8bfb9ec31d351$var$_burger = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("8PrCf")));

var $b6b8bfb9ec31d351$var$_menu = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("7fzgc")));

var $b6b8bfb9ec31d351$var$_item = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("iozth")));

var $b6b8bfb9ec31d351$var$_dropdown = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("7sUzh")));

var $b6b8bfb9ec31d351$var$_divider = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("7RLsD")));

var $b6b8bfb9ec31d351$var$_link = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("GI2jE")));

var $b6b8bfb9ec31d351$var$_container = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("e0Mwj")));

var $3fyjE = parcelRequire("3fyjE");

var $b6b8bfb9ec31d351$var$_element = $b6b8bfb9ec31d351$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $b6b8bfb9ec31d351$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $b6b8bfb9ec31d351$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $b6b8bfb9ec31d351$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $b6b8bfb9ec31d351$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $b6b8bfb9ec31d351$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $b6b8bfb9ec31d351$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b6b8bfb9ec31d351$var$_extends() {
    $b6b8bfb9ec31d351$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b6b8bfb9ec31d351$var$_extends.apply(this, arguments);
}
function $b6b8bfb9ec31d351$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b6b8bfb9ec31d351$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b6b8bfb9ec31d351$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b6b8bfb9ec31d351$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b6b8bfb9ec31d351$var$Navbar = function Navbar(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, fixed = _ref.fixed, transparent = _ref.transparent, color = _ref.color, active = _ref.active, size = _ref.size, props = $b6b8bfb9ec31d351$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "fixed",
        "transparent",
        "color",
        "active",
        "size"
    ]);
    (0, $b6b8bfb9ec31d351$var$_react.useEffect)(function() {
        var html = window.document.querySelector('html');
        if (!html.classList.contains("has-navbar-fixed-".concat(fixed))) {
            html.classList.remove('has-navbar-fixed-top');
            html.classList.remove('has-navbar-fixed-bottom');
        }
        if (fixed) html.classList.add("has-navbar-fixed-".concat(fixed));
        return function() {
            return window.document.querySelector('html').classList.remove("has-navbar-fixed-".concat(fixed));
        };
    }, [
        fixed
    ]);
    return /*#__PURE__*/ $b6b8bfb9ec31d351$var$_react["default"].createElement($3fyjE.ShowContext.Provider, {
        value: active
    }, /*#__PURE__*/ $b6b8bfb9ec31d351$var$_react["default"].createElement($b6b8bfb9ec31d351$var$_element["default"], $b6b8bfb9ec31d351$var$_extends({}, props, {
        role: "navigation",
        className: (0, $b6b8bfb9ec31d351$var$_classnames2["default"])('navbar', className, (_classnames = {
            'is-transparent': transparent
        }, $b6b8bfb9ec31d351$var$_defineProperty(_classnames, "is-fixed-".concat(fixed), fixed), $b6b8bfb9ec31d351$var$_defineProperty(_classnames, "is-".concat(color), color), $b6b8bfb9ec31d351$var$_defineProperty(_classnames, "is-spaced", size === 'large'), _classnames))
    }), children));
};
$b6b8bfb9ec31d351$var$Navbar.defaultProps = {
    renderAs: 'nav'
};
$b6b8bfb9ec31d351$var$Navbar.Brand = $b6b8bfb9ec31d351$var$_brand["default"];
$b6b8bfb9ec31d351$var$Navbar.Burger = $b6b8bfb9ec31d351$var$_burger["default"];
$b6b8bfb9ec31d351$var$Navbar.Menu = $b6b8bfb9ec31d351$var$_menu["default"];
$b6b8bfb9ec31d351$var$Navbar.Item = $b6b8bfb9ec31d351$var$_item["default"];
$b6b8bfb9ec31d351$var$Navbar.Dropdown = $b6b8bfb9ec31d351$var$_dropdown["default"];
$b6b8bfb9ec31d351$var$Navbar.Link = $b6b8bfb9ec31d351$var$_link["default"];
$b6b8bfb9ec31d351$var$Navbar.Divider = $b6b8bfb9ec31d351$var$_divider["default"];
$b6b8bfb9ec31d351$var$Navbar.Container = $b6b8bfb9ec31d351$var$_container["default"];
var $b6b8bfb9ec31d351$var$_default = $b6b8bfb9ec31d351$var$Navbar;
module.exports["default"] = $b6b8bfb9ec31d351$var$_default;

});
parcelRegister("hzuCF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ccad7595bc6538d3$var$_react = $ccad7595bc6538d3$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $ccad7595bc6538d3$var$_classnames = $ccad7595bc6538d3$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $ccad7595bc6538d3$var$_element = $ccad7595bc6538d3$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $ccad7595bc6538d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ccad7595bc6538d3$var$_extends() {
    $ccad7595bc6538d3$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ccad7595bc6538d3$var$_extends.apply(this, arguments);
}
function $ccad7595bc6538d3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ccad7595bc6538d3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ccad7595bc6538d3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ccad7595bc6538d3$var$NavbarBrand = function NavbarBrand(_ref) {
    var className = _ref.className, children = _ref.children, props = $ccad7595bc6538d3$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $ccad7595bc6538d3$var$_react["default"].createElement($ccad7595bc6538d3$var$_element["default"], $ccad7595bc6538d3$var$_extends({}, props, {
        className: (0, $ccad7595bc6538d3$var$_classnames["default"])('navbar-brand', className)
    }), children);
};
$ccad7595bc6538d3$var$NavbarBrand.defaultProps = {};
var $ccad7595bc6538d3$var$_default = $ccad7595bc6538d3$var$NavbarBrand;
module.exports["default"] = $ccad7595bc6538d3$var$_default;

});

parcelRegister("8PrCf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $66d882145ffddf99$var$_react = $66d882145ffddf99$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $66d882145ffddf99$var$_classnames = $66d882145ffddf99$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3fyjE = parcelRequire("3fyjE");

var $66d882145ffddf99$var$_element = $66d882145ffddf99$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $66d882145ffddf99$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $66d882145ffddf99$var$_extends() {
    $66d882145ffddf99$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $66d882145ffddf99$var$_extends.apply(this, arguments);
}
function $66d882145ffddf99$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $66d882145ffddf99$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $66d882145ffddf99$var$ownKeys(Object(source), true).forEach(function(key) {
            $66d882145ffddf99$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $66d882145ffddf99$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $66d882145ffddf99$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $66d882145ffddf99$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $66d882145ffddf99$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $66d882145ffddf99$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $66d882145ffddf99$var$NavbarBurger = function NavbarBurger(_ref) {
    var style = _ref.style, className = _ref.className, props = $66d882145ffddf99$var$_objectWithoutProperties(_ref, [
        "style",
        "className"
    ]);
    return /*#__PURE__*/ $66d882145ffddf99$var$_react["default"].createElement($3fyjE.ShowContext.Consumer, null, function(active) {
        return /*#__PURE__*/ $66d882145ffddf99$var$_react["default"].createElement($66d882145ffddf99$var$_element["default"], $66d882145ffddf99$var$_extends({
            role: "button",
            tabIndex: "0",
            style: $66d882145ffddf99$var$_objectSpread({
                outline: 'none'
            }, style),
            className: (0, $66d882145ffddf99$var$_classnames["default"])('navbar-burger', className, {
                'is-active': active
            })
        }, props), /*#__PURE__*/ $66d882145ffddf99$var$_react["default"].createElement("span", null), /*#__PURE__*/ $66d882145ffddf99$var$_react["default"].createElement("span", null), /*#__PURE__*/ $66d882145ffddf99$var$_react["default"].createElement("span", null));
    });
};
$66d882145ffddf99$var$NavbarBurger.defaultProps = {};
var $66d882145ffddf99$var$_default = $66d882145ffddf99$var$NavbarBurger;
module.exports["default"] = $66d882145ffddf99$var$_default;

});
parcelRegister("3fyjE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ShowContext = void 0;

var $25dd6442e2d31003$var$_react = $25dd6442e2d31003$var$_interopRequireDefault((parcelRequire("3ZYaX")));
function $25dd6442e2d31003$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $25dd6442e2d31003$var$ShowContext = /*#__PURE__*/ $25dd6442e2d31003$var$_react["default"].createContext(false);
module.exports.ShowContext = $25dd6442e2d31003$var$ShowContext;

});


parcelRegister("7fzgc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $547549128aa80e1e$var$_react = $547549128aa80e1e$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $547549128aa80e1e$var$_classnames = $547549128aa80e1e$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $3fyjE = parcelRequire("3fyjE");

var $547549128aa80e1e$var$_element = $547549128aa80e1e$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $547549128aa80e1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $547549128aa80e1e$var$_extends() {
    $547549128aa80e1e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $547549128aa80e1e$var$_extends.apply(this, arguments);
}
function $547549128aa80e1e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $547549128aa80e1e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $547549128aa80e1e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $547549128aa80e1e$var$NavbarMenu = function NavbarMenu(_ref) {
    var className = _ref.className, children = _ref.children, props = $547549128aa80e1e$var$_objectWithoutProperties(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ $547549128aa80e1e$var$_react["default"].createElement($3fyjE.ShowContext.Consumer, null, function(active) {
        return /*#__PURE__*/ $547549128aa80e1e$var$_react["default"].createElement($547549128aa80e1e$var$_element["default"], $547549128aa80e1e$var$_extends({}, props, {
            className: (0, $547549128aa80e1e$var$_classnames["default"])('navbar-menu', className, {
                'is-active': active
            })
        }), children);
    });
};
$547549128aa80e1e$var$NavbarMenu.defaultProps = {};
var $547549128aa80e1e$var$_default = $547549128aa80e1e$var$NavbarMenu;
module.exports["default"] = $547549128aa80e1e$var$_default;

});

parcelRegister("iozth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d645fbb9c85ea3bc$var$_react = $d645fbb9c85ea3bc$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $d645fbb9c85ea3bc$var$_propTypes = $d645fbb9c85ea3bc$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $d645fbb9c85ea3bc$var$_classnames = $d645fbb9c85ea3bc$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $d645fbb9c85ea3bc$var$_dropdown = $d645fbb9c85ea3bc$var$_interopRequireDefault((parcelRequire("7sUzh")));

var $d645fbb9c85ea3bc$var$_element = $d645fbb9c85ea3bc$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $d645fbb9c85ea3bc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d645fbb9c85ea3bc$var$_extends() {
    $d645fbb9c85ea3bc$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d645fbb9c85ea3bc$var$_extends.apply(this, arguments);
}
function $d645fbb9c85ea3bc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d645fbb9c85ea3bc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d645fbb9c85ea3bc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d645fbb9c85ea3bc$var$NavbarItem = function NavbarItem(_ref) {
    var _dropdown$props;
    var className = _ref.className, active = _ref.active, children = _ref.children, hoverable = _ref.hoverable, renderAs = _ref.renderAs, arrowless = _ref.arrowless, props = $d645fbb9c85ea3bc$var$_objectWithoutProperties(_ref, [
        "className",
        "active",
        "children",
        "hoverable",
        "renderAs",
        "arrowless"
    ]);
    var as = renderAs;
    var dropdown = $d645fbb9c85ea3bc$var$_react["default"].Children.toArray(children).find(function(child) {
        return child.type === $d645fbb9c85ea3bc$var$_dropdown["default"];
    });
    if (dropdown && renderAs === 'a') as = 'div';
    return /*#__PURE__*/ $d645fbb9c85ea3bc$var$_react["default"].createElement($d645fbb9c85ea3bc$var$_element["default"], $d645fbb9c85ea3bc$var$_extends({}, props, {
        renderAs: as,
        className: (0, $d645fbb9c85ea3bc$var$_classnames["default"])('navbar-item', className, {
            'is-active': active,
            'has-dropdown': dropdown,
            'is-hoverable': hoverable,
            'has-dropdown-up': dropdown && ((_dropdown$props = dropdown.props) === null || _dropdown$props === void 0 ? void 0 : _dropdown$props.up),
            'is-arrowless': arrowless
        })
    }), children);
};
$d645fbb9c85ea3bc$var$NavbarItem.defaultProps = {
    renderAs: 'a'
};
var $d645fbb9c85ea3bc$var$_default = $d645fbb9c85ea3bc$var$NavbarItem;
module.exports["default"] = $d645fbb9c85ea3bc$var$_default;

});
parcelRegister("7sUzh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $56f70729a1c0d77f$var$_react = $56f70729a1c0d77f$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $56f70729a1c0d77f$var$_propTypes = $56f70729a1c0d77f$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $56f70729a1c0d77f$var$_classnames = $56f70729a1c0d77f$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $56f70729a1c0d77f$var$_element = $56f70729a1c0d77f$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $56f70729a1c0d77f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $56f70729a1c0d77f$var$_extends() {
    $56f70729a1c0d77f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $56f70729a1c0d77f$var$_extends.apply(this, arguments);
}
function $56f70729a1c0d77f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $56f70729a1c0d77f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $56f70729a1c0d77f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $56f70729a1c0d77f$var$NavbarDropdown = function NavbarDropdown(_ref) {
    var className = _ref.className, boxed = _ref.boxed, right = _ref.right, children = _ref.children, props = $56f70729a1c0d77f$var$_objectWithoutProperties(_ref, [
        "className",
        "boxed",
        "right",
        "children"
    ]);
    return /*#__PURE__*/ $56f70729a1c0d77f$var$_react["default"].createElement($56f70729a1c0d77f$var$_element["default"], $56f70729a1c0d77f$var$_extends({}, props, {
        className: (0, $56f70729a1c0d77f$var$_classnames["default"])('navbar-dropdown', className, {
            'is-boxed': boxed,
            'is-right': right
        })
    }), children);
};
$56f70729a1c0d77f$var$NavbarDropdown.defaultProps = {
    renderAs: 'div'
};
var $56f70729a1c0d77f$var$_default = $56f70729a1c0d77f$var$NavbarDropdown;
module.exports["default"] = $56f70729a1c0d77f$var$_default;

});


parcelRegister("7RLsD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5ba24c635eeeccd2$var$_react = $5ba24c635eeeccd2$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $5ba24c635eeeccd2$var$_propTypes = $5ba24c635eeeccd2$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $5ba24c635eeeccd2$var$_classnames = $5ba24c635eeeccd2$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $5ba24c635eeeccd2$var$_element = $5ba24c635eeeccd2$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $5ba24c635eeeccd2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5ba24c635eeeccd2$var$_extends() {
    $5ba24c635eeeccd2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ba24c635eeeccd2$var$_extends.apply(this, arguments);
}
function $5ba24c635eeeccd2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5ba24c635eeeccd2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5ba24c635eeeccd2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5ba24c635eeeccd2$var$NavbarDivider = function NavbarDivider(_ref) {
    var className = _ref.className, props = $5ba24c635eeeccd2$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $5ba24c635eeeccd2$var$_react["default"].createElement($5ba24c635eeeccd2$var$_element["default"], $5ba24c635eeeccd2$var$_extends({}, props, {
        className: (0, $5ba24c635eeeccd2$var$_classnames["default"])('navbar-divider', className)
    }));
};
$5ba24c635eeeccd2$var$NavbarDivider.defaultProps = {
    renderAs: 'hr'
};
var $5ba24c635eeeccd2$var$_default = $5ba24c635eeeccd2$var$NavbarDivider;
module.exports["default"] = $5ba24c635eeeccd2$var$_default;

});

parcelRegister("GI2jE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0806150f988bdc26$var$_react = $0806150f988bdc26$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $0806150f988bdc26$var$_propTypes = $0806150f988bdc26$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $0806150f988bdc26$var$_classnames = $0806150f988bdc26$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $0806150f988bdc26$var$_element = $0806150f988bdc26$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $0806150f988bdc26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0806150f988bdc26$var$_extends() {
    $0806150f988bdc26$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0806150f988bdc26$var$_extends.apply(this, arguments);
}
function $0806150f988bdc26$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0806150f988bdc26$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0806150f988bdc26$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0806150f988bdc26$var$NavbarLink = function NavbarLink(_ref) {
    var className = _ref.className, children = _ref.children, arrowless = _ref.arrowless, props = $0806150f988bdc26$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "arrowless"
    ]);
    return /*#__PURE__*/ $0806150f988bdc26$var$_react["default"].createElement($0806150f988bdc26$var$_element["default"], $0806150f988bdc26$var$_extends({}, props, {
        className: (0, $0806150f988bdc26$var$_classnames["default"])('navbar-link', className, {
            'is-arrowless': arrowless
        })
    }), children);
};
$0806150f988bdc26$var$NavbarLink.defaultProps = {
    renderAs: 'span'
};
var $0806150f988bdc26$var$_default = $0806150f988bdc26$var$NavbarLink;
module.exports["default"] = $0806150f988bdc26$var$_default;

});

parcelRegister("e0Mwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a336b3d8f6d05b6f$var$_react = $a336b3d8f6d05b6f$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $a336b3d8f6d05b6f$var$_propTypes = $a336b3d8f6d05b6f$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $a336b3d8f6d05b6f$var$_classnames2 = $a336b3d8f6d05b6f$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $a336b3d8f6d05b6f$var$_element = $a336b3d8f6d05b6f$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $a336b3d8f6d05b6f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a336b3d8f6d05b6f$var$_extends() {
    $a336b3d8f6d05b6f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a336b3d8f6d05b6f$var$_extends.apply(this, arguments);
}
function $a336b3d8f6d05b6f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a336b3d8f6d05b6f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a336b3d8f6d05b6f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a336b3d8f6d05b6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a336b3d8f6d05b6f$var$alignMapper = {
    left: 'start',
    right: 'end'
};
var $a336b3d8f6d05b6f$var$NavbarContainer = function NavbarContainer(_ref) {
    var className = _ref.className, children = _ref.children, align = _ref.align, props = $a336b3d8f6d05b6f$var$_objectWithoutProperties(_ref, [
        "className",
        "children",
        "align"
    ]);
    return /*#__PURE__*/ $a336b3d8f6d05b6f$var$_react["default"].createElement($a336b3d8f6d05b6f$var$_element["default"], $a336b3d8f6d05b6f$var$_extends({}, props, {
        className: (0, $a336b3d8f6d05b6f$var$_classnames2["default"])($a336b3d8f6d05b6f$var$_defineProperty({}, "navbar-".concat($a336b3d8f6d05b6f$var$alignMapper[align]), $a336b3d8f6d05b6f$var$alignMapper[align]), className)
    }), children);
};
$a336b3d8f6d05b6f$var$NavbarContainer.defaultProps = {
    align: 'left'
};
var $a336b3d8f6d05b6f$var$_default = $a336b3d8f6d05b6f$var$NavbarContainer;
module.exports["default"] = $a336b3d8f6d05b6f$var$_default;

});



parcelRegister("6kRXO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $49ce7869030b7790$var$_pagination = $49ce7869030b7790$var$_interopRequireDefault((parcelRequire("10T2X")));
function $49ce7869030b7790$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $49ce7869030b7790$var$_default = $49ce7869030b7790$var$_pagination["default"];
module.exports["default"] = $49ce7869030b7790$var$_default;

});
parcelRegister("10T2X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0bd07da97e079f63$var$_react = $0bd07da97e079f63$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $0bd07da97e079f63$var$_propTypes = $0bd07da97e079f63$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $0bd07da97e079f63$var$_classnames2 = $0bd07da97e079f63$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $1tqZN = parcelRequire("1tqZN");

var $0bd07da97e079f63$var$_element = $0bd07da97e079f63$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $0bd07da97e079f63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $0bd07da97e079f63$var$_extends() {
    $0bd07da97e079f63$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd07da97e079f63$var$_extends.apply(this, arguments);
}
function $0bd07da97e079f63$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0bd07da97e079f63$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0bd07da97e079f63$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0bd07da97e079f63$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0bd07da97e079f63$var$getFirstPage = function getFirstPage(current, last, delta) {
    if (current === 1) return 1;
    var minPage = last - delta * 2;
    var page = Math.min(current - delta, minPage);
    return page <= 0 ? 1 : page;
};
var $0bd07da97e079f63$var$getLastPage = function getLastPage(current, total, delta) {
    if (current === total) return total;
    var maxPage = delta * 2 + 1;
    var page = Math.max(current + delta, maxPage);
    return page > total ? total : page;
};
var $0bd07da97e079f63$var$Pagination = function Pagination(_ref) {
    var _classnames;
    var current = _ref.current, disabled = _ref.disabled, total = _ref.total, next = _ref.next, previous = _ref.previous, showPrevNext = _ref.showPrevNext, showFirstLast = _ref.showFirstLast, delta = _ref.delta, autoHide = _ref.autoHide, className = _ref.className, size = _ref.size, align = _ref.align, rounded = _ref.rounded, onChange = _ref.onChange, props = $0bd07da97e079f63$var$_objectWithoutProperties(_ref, [
        "current",
        "disabled",
        "total",
        "next",
        "previous",
        "showPrevNext",
        "showFirstLast",
        "delta",
        "autoHide",
        "className",
        "size",
        "align",
        "rounded",
        "onChange"
    ]);
    if (total <= 1 && autoHide || current > total) return null;
    var lastPage = $0bd07da97e079f63$var$getLastPage(current, total, delta);
    var firstPage = $0bd07da97e079f63$var$getFirstPage(current, lastPage, delta);
    var prevDisabled = current === 1 || disabled;
    var nextDisabled = current === total || disabled;
    return /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement($0bd07da97e079f63$var$_element["default"], $0bd07da97e079f63$var$_extends({}, props, {
        className: (0, $0bd07da97e079f63$var$_classnames2["default"])('pagination', className, (_classnames = {}, $0bd07da97e079f63$var$_defineProperty(_classnames, "is-".concat(size), size), $0bd07da97e079f63$var$_defineProperty(_classnames, "is-".concat((0, $1tqZN.normalizeAlign)(align)), align), $0bd07da97e079f63$var$_defineProperty(_classnames, 'is-rounded', rounded), _classnames)),
        "aria-label": "pagination"
    }), showPrevNext && /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement($0bd07da97e079f63$var$_react["default"].Fragment, null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: prevDisabled ? undefined : function() {
            return onChange(current - 1);
        },
        className: "pagination-previous",
        title: "This is the first page",
        disabled: prevDisabled
    }, previous), /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        onClick: nextDisabled ? undefined : function() {
            return onChange(current + 1);
        },
        className: "pagination-next",
        disabled: nextDisabled
    }, next)), delta > 0 && /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement($0bd07da97e079f63$var$_react["default"].Fragment, null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("ul", {
        className: "pagination-list"
    }, showFirstLast && current !== 1 && firstPage !== 1 && /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement($0bd07da97e079f63$var$_react["default"].Fragment, null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("li", {
        key: 1
    }, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "pagination-link",
        onClick: function onClick() {
            return onChange(1);
        },
        "aria-label": "Page 1",
        "aria-current": "page",
        disabled: disabled
    }, "1")), /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("li", null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("span", {
        className: "pagination-ellipsis"
    }, "\u2026"))), Array(lastPage - firstPage + 1).fill(0).map(function(_, i) {
        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        $0bd07da97e079f63$var$_react["default"].createElement("li", {
            key: i + firstPage
        }, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("a", {
            role: "button",
            tabIndex: 0,
            className: (0, $0bd07da97e079f63$var$_classnames2["default"])('pagination-link', {
                'is-current': current === i + firstPage
            }),
            onClick: current === firstPage + i ? undefined : function() {
                return onChange(firstPage + i);
            },
            "aria-label": "Page ".concat(i + firstPage),
            "aria-current": "page",
            disabled: disabled
        }, i + firstPage)));
    }), showFirstLast && current !== lastPage && total !== lastPage && /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement($0bd07da97e079f63$var$_react["default"].Fragment, null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("li", {
        key: total
    }, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("span", {
        className: "pagination-ellipsis"
    }, "\u2026")), /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("li", null, /*#__PURE__*/ $0bd07da97e079f63$var$_react["default"].createElement("a", {
        role: "button",
        tabIndex: 0,
        className: "pagination-link",
        onClick: function onClick() {
            return onChange(total);
        },
        "aria-label": "Page ".concat(total),
        "aria-current": "page",
        disabled: disabled
    }, total))))));
};
$0bd07da97e079f63$var$Pagination.defaultProps = {
    total: 1,
    current: 1,
    delta: 1,
    next: 'Next',
    previous: 'Previous',
    renderAs: 'nav',
    showPrevNext: true,
    autoHide: true
};
var $0bd07da97e079f63$var$_default = $0bd07da97e079f63$var$Pagination;
module.exports["default"] = $0bd07da97e079f63$var$_default;

});


parcelRegister("3tZmh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $2893ad04b18c2847$var$_menu = $2893ad04b18c2847$var$_interopRequireDefault((parcelRequire("g2Kpm")));
function $2893ad04b18c2847$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2893ad04b18c2847$var$_default = $2893ad04b18c2847$var$_menu["default"];
module.exports["default"] = $2893ad04b18c2847$var$_default;

});
parcelRegister("g2Kpm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $bae0d4ea14e68943$var$_react = $bae0d4ea14e68943$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $bae0d4ea14e68943$var$_propTypes = $bae0d4ea14e68943$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $bae0d4ea14e68943$var$_classnames = $bae0d4ea14e68943$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $bae0d4ea14e68943$var$_list = $bae0d4ea14e68943$var$_interopRequireDefault((parcelRequire("4gRSq")));

var $bae0d4ea14e68943$var$_element = $bae0d4ea14e68943$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $bae0d4ea14e68943$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bae0d4ea14e68943$var$_extends() {
    $bae0d4ea14e68943$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bae0d4ea14e68943$var$_extends.apply(this, arguments);
}
function $bae0d4ea14e68943$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bae0d4ea14e68943$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bae0d4ea14e68943$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bae0d4ea14e68943$var$Menu = function Menu(_ref) {
    var className = _ref.className, props = $bae0d4ea14e68943$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $bae0d4ea14e68943$var$_react["default"].createElement($bae0d4ea14e68943$var$_element["default"], $bae0d4ea14e68943$var$_extends({}, props, {
        className: (0, $bae0d4ea14e68943$var$_classnames["default"])('menu', className)
    }));
};
$bae0d4ea14e68943$var$Menu.List = $bae0d4ea14e68943$var$_list["default"];
$bae0d4ea14e68943$var$Menu.defaultProps = {
    renderAs: 'aside'
};
var $bae0d4ea14e68943$var$_default = $bae0d4ea14e68943$var$Menu;
module.exports["default"] = $bae0d4ea14e68943$var$_default;

});
parcelRegister("4gRSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $31c272dc6974c061$var$_list["default"];
    }
});

var $31c272dc6974c061$var$_list = $31c272dc6974c061$var$_interopRequireDefault((parcelRequire("95lMf")));
function $31c272dc6974c061$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("95lMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $69d57932cb132dc1$var$_react = $69d57932cb132dc1$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $69d57932cb132dc1$var$_propTypes = $69d57932cb132dc1$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $69d57932cb132dc1$var$_classnames = $69d57932cb132dc1$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $69d57932cb132dc1$var$_item = $69d57932cb132dc1$var$_interopRequireDefault((parcelRequire("kHB4r")));

var $69d57932cb132dc1$var$_element = $69d57932cb132dc1$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $69d57932cb132dc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $69d57932cb132dc1$var$_extends() {
    $69d57932cb132dc1$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $69d57932cb132dc1$var$_extends.apply(this, arguments);
}
function $69d57932cb132dc1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $69d57932cb132dc1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $69d57932cb132dc1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $69d57932cb132dc1$var$MenuList = function MenuList(_ref) {
    var className = _ref.className, title = _ref.title, props = $69d57932cb132dc1$var$_objectWithoutProperties(_ref, [
        "className",
        "title"
    ]);
    return /*#__PURE__*/ $69d57932cb132dc1$var$_react["default"].createElement($69d57932cb132dc1$var$_react["default"].Fragment, null, title && /*#__PURE__*/ $69d57932cb132dc1$var$_react["default"].createElement("p", {
        className: "menu-label"
    }, title), /*#__PURE__*/ $69d57932cb132dc1$var$_react["default"].createElement($69d57932cb132dc1$var$_element["default"], $69d57932cb132dc1$var$_extends({
        className: (0, $69d57932cb132dc1$var$_classnames["default"])('menu-list', className)
    }, props)));
};
$69d57932cb132dc1$var$MenuList.Item = $69d57932cb132dc1$var$_item["default"];
$69d57932cb132dc1$var$MenuList.defaultProps = {
    renderAs: 'ul'
};
var $69d57932cb132dc1$var$_default = $69d57932cb132dc1$var$MenuList;
module.exports["default"] = $69d57932cb132dc1$var$_default;

});
parcelRegister("kHB4r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f124944620c56133$var$_react = $f124944620c56133$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $f124944620c56133$var$_propTypes = $f124944620c56133$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $f124944620c56133$var$_classnames = $f124944620c56133$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $f124944620c56133$var$_list = $f124944620c56133$var$_interopRequireDefault((parcelRequire("95lMf")));

var $f124944620c56133$var$_element = $f124944620c56133$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $f124944620c56133$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f124944620c56133$var$_extends() {
    $f124944620c56133$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f124944620c56133$var$_extends.apply(this, arguments);
}
function $f124944620c56133$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f124944620c56133$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f124944620c56133$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f124944620c56133$var$MenuListItem = function MenuListItem(_ref) {
    var children = _ref.children, active = _ref.active, className = _ref.className, ref = _ref.domRef, props = $f124944620c56133$var$_objectWithoutProperties(_ref, [
        "children",
        "active",
        "className",
        "domRef"
    ]);
    if (typeof children !== 'string' && $f124944620c56133$var$_react["default"].Children.toArray(children).length === 1 && $f124944620c56133$var$_react["default"].Children.only(children).type === $f124944620c56133$var$_list["default"]) {
        var child = $f124944620c56133$var$_react["default"].Children.only(children);
        return /*#__PURE__*/ $f124944620c56133$var$_react["default"].createElement("li", {
            ref: ref
        }, /*#__PURE__*/ $f124944620c56133$var$_react["default"].createElement($f124944620c56133$var$_element["default"], $f124944620c56133$var$_extends({
            className: (0, $f124944620c56133$var$_classnames["default"])(className, {
                'is-active': active
            })
        }, props), child.props.title), /*#__PURE__*/ $f124944620c56133$var$_react["default"].cloneElement(child, {
            title: undefined
        }));
    }
    return /*#__PURE__*/ $f124944620c56133$var$_react["default"].createElement("li", {
        ref: ref
    }, /*#__PURE__*/ $f124944620c56133$var$_react["default"].createElement($f124944620c56133$var$_element["default"], $f124944620c56133$var$_extends({
        className: (0, $f124944620c56133$var$_classnames["default"])(className, {
            'is-active': active
        })
    }, props), children));
};
$f124944620c56133$var$MenuListItem.defaultProps = {
    renderAs: 'a'
};
var $f124944620c56133$var$_default = $f124944620c56133$var$MenuListItem;
module.exports["default"] = $f124944620c56133$var$_default;

});





parcelRegister("5zMq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $40f5c7ce5ddc3701$var$_message = $40f5c7ce5ddc3701$var$_interopRequireDefault((parcelRequire("aJYcm")));
function $40f5c7ce5ddc3701$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $40f5c7ce5ddc3701$var$_default = $40f5c7ce5ddc3701$var$_message["default"];
module.exports["default"] = $40f5c7ce5ddc3701$var$_default;

});
parcelRegister("aJYcm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $7d1ccd7b00f4146e$var$_react = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $7d1ccd7b00f4146e$var$_propTypes = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $7d1ccd7b00f4146e$var$_classnames2 = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $7d1ccd7b00f4146e$var$_body = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("dyWIE")));

var $7d1ccd7b00f4146e$var$_header = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("bCpvK")));

var $7d1ccd7b00f4146e$var$_element = $7d1ccd7b00f4146e$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $7d1ccd7b00f4146e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7d1ccd7b00f4146e$var$_extends() {
    $7d1ccd7b00f4146e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d1ccd7b00f4146e$var$_extends.apply(this, arguments);
}
function $7d1ccd7b00f4146e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d1ccd7b00f4146e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7d1ccd7b00f4146e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7d1ccd7b00f4146e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7d1ccd7b00f4146e$var$Message = function Message(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, color = _ref.color, size = _ref.size, props = $7d1ccd7b00f4146e$var$_objectWithoutProperties(_ref, [
        "children",
        "className",
        "color",
        "size"
    ]);
    return /*#__PURE__*/ $7d1ccd7b00f4146e$var$_react["default"].createElement($7d1ccd7b00f4146e$var$_element["default"], $7d1ccd7b00f4146e$var$_extends({}, props, {
        className: (0, $7d1ccd7b00f4146e$var$_classnames2["default"])('message', className, (_classnames = {}, $7d1ccd7b00f4146e$var$_defineProperty(_classnames, "is-".concat(color), color), $7d1ccd7b00f4146e$var$_defineProperty(_classnames, "is-".concat(size), size), _classnames))
    }), children);
};
$7d1ccd7b00f4146e$var$Message.Body = $7d1ccd7b00f4146e$var$_body["default"];
$7d1ccd7b00f4146e$var$Message.Header = $7d1ccd7b00f4146e$var$_header["default"];
$7d1ccd7b00f4146e$var$Message.defaultProps = {
    renderAs: 'article'
};
var $7d1ccd7b00f4146e$var$_default = $7d1ccd7b00f4146e$var$Message;
module.exports["default"] = $7d1ccd7b00f4146e$var$_default;

});
parcelRegister("dyWIE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9dfbffbcde960c45$var$_react = $9dfbffbcde960c45$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9dfbffbcde960c45$var$_classnames = $9dfbffbcde960c45$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9dfbffbcde960c45$var$_element = $9dfbffbcde960c45$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $9dfbffbcde960c45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9dfbffbcde960c45$var$_extends() {
    $9dfbffbcde960c45$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dfbffbcde960c45$var$_extends.apply(this, arguments);
}
function $9dfbffbcde960c45$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9dfbffbcde960c45$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9dfbffbcde960c45$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9dfbffbcde960c45$var$MessageBody = function MessageBody(_ref) {
    var children = _ref.children, className = _ref.className, props = $9dfbffbcde960c45$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $9dfbffbcde960c45$var$_react["default"].createElement($9dfbffbcde960c45$var$_element["default"], $9dfbffbcde960c45$var$_extends({}, props, {
        className: (0, $9dfbffbcde960c45$var$_classnames["default"])('message-body', className)
    }), children);
};
var $9dfbffbcde960c45$var$_default = $9dfbffbcde960c45$var$MessageBody;
module.exports["default"] = $9dfbffbcde960c45$var$_default;

});

parcelRegister("bCpvK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $87570847a8e06d24$var$_react = $87570847a8e06d24$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $87570847a8e06d24$var$_classnames = $87570847a8e06d24$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $87570847a8e06d24$var$_element = $87570847a8e06d24$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $87570847a8e06d24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $87570847a8e06d24$var$_extends() {
    $87570847a8e06d24$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $87570847a8e06d24$var$_extends.apply(this, arguments);
}
function $87570847a8e06d24$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $87570847a8e06d24$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $87570847a8e06d24$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $87570847a8e06d24$var$MessageHeader = function MessageHeader(_ref) {
    var children = _ref.children, className = _ref.className, props = $87570847a8e06d24$var$_objectWithoutProperties(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ $87570847a8e06d24$var$_react["default"].createElement($87570847a8e06d24$var$_element["default"], $87570847a8e06d24$var$_extends({}, props, {
        className: (0, $87570847a8e06d24$var$_classnames["default"])('message-header', className)
    }), children);
};
var $87570847a8e06d24$var$_default = $87570847a8e06d24$var$MessageHeader;
module.exports["default"] = $87570847a8e06d24$var$_default;

});



parcelRegister("kT9TC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f3509ed9f66a28f7$var$_panel = $f3509ed9f66a28f7$var$_interopRequireDefault((parcelRequire("lo4Gw")));
function $f3509ed9f66a28f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f3509ed9f66a28f7$var$_default = $f3509ed9f66a28f7$var$_panel["default"];
module.exports["default"] = $f3509ed9f66a28f7$var$_default;

});
parcelRegister("lo4Gw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f91f79298fd6abee$var$_react = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $f91f79298fd6abee$var$_propTypes = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $f91f79298fd6abee$var$_classnames2 = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $f91f79298fd6abee$var$_block = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("c0WQo")));

var $f91f79298fd6abee$var$_header = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("dt1Bt")));

var $f91f79298fd6abee$var$_icon = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("5RRSD")));

var $f91f79298fd6abee$var$_tabs = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("26GXQ")));

var $f91f79298fd6abee$var$_element = $f91f79298fd6abee$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $f91f79298fd6abee$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f91f79298fd6abee$var$_extends() {
    $f91f79298fd6abee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f91f79298fd6abee$var$_extends.apply(this, arguments);
}
function $f91f79298fd6abee$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f91f79298fd6abee$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f91f79298fd6abee$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f91f79298fd6abee$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $f91f79298fd6abee$var$Panel = function Panel(_ref) {
    var color = _ref.color, className = _ref.className, props = $f91f79298fd6abee$var$_objectWithoutProperties(_ref, [
        "color",
        "className"
    ]);
    return /*#__PURE__*/ $f91f79298fd6abee$var$_react["default"].createElement($f91f79298fd6abee$var$_element["default"], $f91f79298fd6abee$var$_extends({}, props, {
        className: (0, $f91f79298fd6abee$var$_classnames2["default"])('panel', className, $f91f79298fd6abee$var$_defineProperty({}, "is-".concat(color), color))
    }));
};
$f91f79298fd6abee$var$Panel.Header = $f91f79298fd6abee$var$_header["default"];
$f91f79298fd6abee$var$Panel.Tabs = $f91f79298fd6abee$var$_tabs["default"];
$f91f79298fd6abee$var$Panel.Block = $f91f79298fd6abee$var$_block["default"];
$f91f79298fd6abee$var$Panel.Icon = $f91f79298fd6abee$var$_icon["default"];
$f91f79298fd6abee$var$Panel.defaultProps = {
    renderAs: 'nav'
};
var $f91f79298fd6abee$var$_default = $f91f79298fd6abee$var$Panel;
module.exports["default"] = $f91f79298fd6abee$var$_default;

});
parcelRegister("c0WQo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8bf3214e9a305f8a$var$_react = $8bf3214e9a305f8a$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $8bf3214e9a305f8a$var$_propTypes = $8bf3214e9a305f8a$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $8bf3214e9a305f8a$var$_classnames = $8bf3214e9a305f8a$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $8bf3214e9a305f8a$var$_element = $8bf3214e9a305f8a$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $8bf3214e9a305f8a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $8bf3214e9a305f8a$var$_extends() {
    $8bf3214e9a305f8a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8bf3214e9a305f8a$var$_extends.apply(this, arguments);
}
function $8bf3214e9a305f8a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8bf3214e9a305f8a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8bf3214e9a305f8a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $8bf3214e9a305f8a$var$PanelBlock = function PanelBlock(_ref) {
    var className = _ref.className, active = _ref.active, props = $8bf3214e9a305f8a$var$_objectWithoutProperties(_ref, [
        "className",
        "active"
    ]);
    return /*#__PURE__*/ $8bf3214e9a305f8a$var$_react["default"].createElement($8bf3214e9a305f8a$var$_element["default"], $8bf3214e9a305f8a$var$_extends({}, props, {
        className: (0, $8bf3214e9a305f8a$var$_classnames["default"])('panel-block', className, {
            'is-active': active
        })
    }));
};
var $8bf3214e9a305f8a$var$_default = $8bf3214e9a305f8a$var$PanelBlock;
module.exports["default"] = $8bf3214e9a305f8a$var$_default;

});

parcelRegister("dt1Bt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $9cdf3a3518650415$var$_react = $9cdf3a3518650415$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $9cdf3a3518650415$var$_classnames = $9cdf3a3518650415$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $9cdf3a3518650415$var$_element = $9cdf3a3518650415$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $9cdf3a3518650415$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9cdf3a3518650415$var$_extends() {
    $9cdf3a3518650415$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9cdf3a3518650415$var$_extends.apply(this, arguments);
}
function $9cdf3a3518650415$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9cdf3a3518650415$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9cdf3a3518650415$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9cdf3a3518650415$var$PanelHeader = function PanelHeader(_ref) {
    var className = _ref.className, props = $9cdf3a3518650415$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $9cdf3a3518650415$var$_react["default"].createElement($9cdf3a3518650415$var$_element["default"], $9cdf3a3518650415$var$_extends({}, props, {
        className: (0, $9cdf3a3518650415$var$_classnames["default"])('panel-heading', className)
    }));
};
var $9cdf3a3518650415$var$_default = $9cdf3a3518650415$var$PanelHeader;
module.exports["default"] = $9cdf3a3518650415$var$_default;

});

parcelRegister("5RRSD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $445bb27637a8a6a7$var$_react = $445bb27637a8a6a7$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $445bb27637a8a6a7$var$_propTypes = $445bb27637a8a6a7$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $445bb27637a8a6a7$var$_classnames = $445bb27637a8a6a7$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $445bb27637a8a6a7$var$_element = $445bb27637a8a6a7$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $445bb27637a8a6a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $445bb27637a8a6a7$var$_extends() {
    $445bb27637a8a6a7$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $445bb27637a8a6a7$var$_extends.apply(this, arguments);
}
function $445bb27637a8a6a7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $445bb27637a8a6a7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $445bb27637a8a6a7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $445bb27637a8a6a7$var$PanelIcon = function PanelIcon(_ref) {
    var className = _ref.className, props = $445bb27637a8a6a7$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $445bb27637a8a6a7$var$_react["default"].createElement($445bb27637a8a6a7$var$_element["default"], $445bb27637a8a6a7$var$_extends({}, props, {
        className: (0, $445bb27637a8a6a7$var$_classnames["default"])('panel-icon', className)
    }));
};
$445bb27637a8a6a7$var$PanelIcon.defaultProps = {
    renderAs: 'span'
};
var $445bb27637a8a6a7$var$_default = $445bb27637a8a6a7$var$PanelIcon;
module.exports["default"] = $445bb27637a8a6a7$var$_default;

});

parcelRegister("26GXQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $188d782239dc60c6$var$_tabs["default"];
    }
});

var $188d782239dc60c6$var$_tabs = $188d782239dc60c6$var$_interopRequireDefault((parcelRequire("klWls")));
function $188d782239dc60c6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}

});
parcelRegister("klWls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ed1306ef7dce6b1a$var$_react = $ed1306ef7dce6b1a$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $ed1306ef7dce6b1a$var$_classnames = $ed1306ef7dce6b1a$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $ed1306ef7dce6b1a$var$_tab = $ed1306ef7dce6b1a$var$_interopRequireDefault((parcelRequire("beinh")));

var $ed1306ef7dce6b1a$var$_element = $ed1306ef7dce6b1a$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $ed1306ef7dce6b1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $ed1306ef7dce6b1a$var$_extends() {
    $ed1306ef7dce6b1a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ed1306ef7dce6b1a$var$_extends.apply(this, arguments);
}
function $ed1306ef7dce6b1a$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ed1306ef7dce6b1a$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ed1306ef7dce6b1a$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ed1306ef7dce6b1a$var$PanelTabs = function PanelTabs(_ref) {
    var className = _ref.className, props = $ed1306ef7dce6b1a$var$_objectWithoutProperties(_ref, [
        "className"
    ]);
    return /*#__PURE__*/ $ed1306ef7dce6b1a$var$_react["default"].createElement($ed1306ef7dce6b1a$var$_element["default"], $ed1306ef7dce6b1a$var$_extends({}, props, {
        className: (0, $ed1306ef7dce6b1a$var$_classnames["default"])('panel-tabs', className)
    }));
};
$ed1306ef7dce6b1a$var$PanelTabs.Tab = $ed1306ef7dce6b1a$var$_tab["default"];
var $ed1306ef7dce6b1a$var$_default = $ed1306ef7dce6b1a$var$PanelTabs;
module.exports["default"] = $ed1306ef7dce6b1a$var$_default;

});
parcelRegister("beinh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $82cf41549c38c1a2$var$_react = $82cf41549c38c1a2$var$_interopRequireDefault((parcelRequire("3ZYaX")));

var $82cf41549c38c1a2$var$_propTypes = $82cf41549c38c1a2$var$_interopRequireDefault((parcelRequire("9C0qR")));

var $82cf41549c38c1a2$var$_classnames = $82cf41549c38c1a2$var$_interopRequireDefault((parcelRequire("ehbpI")));

var $82cf41549c38c1a2$var$_element = $82cf41549c38c1a2$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $82cf41549c38c1a2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $82cf41549c38c1a2$var$_extends() {
    $82cf41549c38c1a2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82cf41549c38c1a2$var$_extends.apply(this, arguments);
}
function $82cf41549c38c1a2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $82cf41549c38c1a2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $82cf41549c38c1a2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $82cf41549c38c1a2$var$PanelTabsTab = function PanelTabsTab(_ref) {
    var className = _ref.className, active = _ref.active, props = $82cf41549c38c1a2$var$_objectWithoutProperties(_ref, [
        "className",
        "active"
    ]);
    return /*#__PURE__*/ $82cf41549c38c1a2$var$_react["default"].createElement($82cf41549c38c1a2$var$_element["default"], $82cf41549c38c1a2$var$_extends({}, props, {
        className: (0, $82cf41549c38c1a2$var$_classnames["default"])(className, {
            'is-active': active
        })
    }));
};
$82cf41549c38c1a2$var$PanelTabsTab.defaultProps = {
    renderAs: 'a'
};
var $82cf41549c38c1a2$var$_default = $82cf41549c38c1a2$var$PanelTabsTab;
module.exports["default"] = $82cf41549c38c1a2$var$_default;

});





parcelRegister("lt4Vl", function(module, exports) {

!function(e, t) {
    t(module.exports, (parcelRequire("3ZYaX")));
}(module.exports, function(e, t) {
    "use strict";
    function n(e, t, n, o, r, i, u) {
        try {
            var l = e[i](u), s = l.value;
        } catch (e) {
            return void n(e);
        }
        l.done ? t(s) : Promise.resolve(s).then(o, r);
    }
    function o(e) {
        return function() {
            var t = this, o = arguments;
            return new Promise(function(r, i) {
                var u = e.apply(t, o);
                function l(e) {
                    n(u, r, i, l, s, "next", e);
                }
                function s(e) {
                    n(u, r, i, l, s, "throw", e);
                }
                l(void 0);
            });
        };
    }
    function r() {
        return (r = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var o in n)Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
            }
            return e;
        }).apply(this, arguments);
    }
    function i(e, t) {
        if (null == e) return {};
        var n, o, r = {}, i = Object.keys(e);
        for(o = 0; o < i.length; o++)n = i[o], t.indexOf(n) >= 0 || (r[n] = e[n]);
        return r;
    }
    function u(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
    var l = {
        init: "init"
    }, s = function(e) {
        var t = e.value;
        return void 0 === t ? "" : t;
    }, a = function() {
        return t.createElement(t.Fragment, null, "\xa0");
    }, c = {
        Cell: s,
        width: 150,
        minWidth: 0,
        maxWidth: Number.MAX_SAFE_INTEGER
    };
    function d() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        return t.reduce(function(e, t) {
            var n = t.style, o = t.className;
            return e = r({}, e, {}, i(t, [
                "style",
                "className"
            ])), n && (e.style = e.style ? r({}, e.style || {}, {}, n || {}) : n), o && (e.className = e.className ? e.className + " " + o : o), "" === e.className && delete e.className, e;
        }, {});
    }
    var f = function(e, t) {
        return void 0 === t && (t = {}), function(n) {
            return void 0 === n && (n = {}), [].concat(e, [
                n
            ]).reduce(function(e, o) {
                return function e(t, n, o) {
                    return "function" == typeof n ? e({}, n(t, o)) : Array.isArray(n) ? d.apply(void 0, [
                        t
                    ].concat(n)) : d(t, n);
                }(e, o, r({}, t, {
                    userProps: n
                }));
            }, {});
        };
    }, p = function(e, t, n, o) {
        return void 0 === n && (n = {}), e.reduce(function(e, t) {
            return t(e, n);
        }, t);
    }, g = function(e, t, n) {
        return void 0 === n && (n = {}), e.forEach(function(e) {
            e(t, n);
        });
    };
    function v(e, t, n, o) {
        e.findIndex(function(e) {
            return e.pluginName === n;
        });
        t.forEach(function(t) {
            e.findIndex(function(e) {
                return e.pluginName === t;
            });
        });
    }
    function m(e, t) {
        return "function" == typeof e ? e(t) : e;
    }
    function h(e) {
        var n = t.useRef();
        return n.current = e, t.useCallback(function() {
            return n.current;
        }, []);
    }
    var y = "undefined" != typeof document ? t.useLayoutEffect : t.useEffect;
    function w(e, n) {
        var o = t.useRef(!1);
        y(function() {
            o.current && e(), o.current = !0;
        }, n);
    }
    function R(e, t, n) {
        return void 0 === n && (n = {}), function(o, i) {
            void 0 === i && (i = {});
            var u = "string" == typeof o ? t[o] : o;
            if (void 0 === u) throw console.info(t), new Error("Renderer Error \u261D\uFE0F");
            return b(u, r({}, e, {
                column: t
            }, n, {}, i));
        };
    }
    function b(e, n) {
        var o;
        return function(e) {
            var t;
            return "function" == typeof e && (t = Object.getPrototypeOf(e)).prototype && t.prototype.isReactComponent;
        }(o = e) || "function" == typeof o || function(e) {
            return "object" == typeof e && "symbol" == typeof e.$$typeof && [
                "react.memo",
                "react.forward_ref"
            ].includes(e.$$typeof.description);
        }(o) ? t.createElement(e, n) : e;
    }
    function S(e, t, n) {
        return void 0 === n && (n = 0), e.map(function(e) {
            return x(e = r({}, e, {
                parent: t,
                depth: n
            })), e.columns && (e.columns = S(e.columns, e, n + 1)), e;
        });
    }
    function C(e) {
        return G(e, "columns");
    }
    function x(e) {
        var t = e.id, n = e.accessor, o = e.Header;
        if ("string" == typeof n) {
            t = t || n;
            var r = n.split(".");
            n = function(e) {
                return function(e, t, n) {
                    if (!t) return e;
                    var o, r = "function" == typeof t ? t : JSON.stringify(t), i = E.get(r) || function() {
                        var e = function(e) {
                            return (function e(t, n) {
                                void 0 === n && (n = []);
                                if (Array.isArray(t)) for(var o = 0; o < t.length; o += 1)e(t[o], n);
                                else n.push(t);
                                return n;
                            })(e).map(function(e) {
                                return String(e).replace(".", "_");
                            }).join(".").replace(T, ".").replace(O, "").split(".");
                        }(t);
                        return E.set(r, e), e;
                    }();
                    try {
                        o = i.reduce(function(e, t) {
                            return e[t];
                        }, e);
                    } catch (e) {}
                    return void 0 !== o ? o : n;
                }(e, r);
            };
        }
        if (!t && "string" == typeof o && o && (t = o), !t && e.columns) throw console.error(e), new Error('A column ID (or unique "Header" value) is required!');
        if (!t) throw console.error(e), new Error("A column ID (or string accessor) is required!");
        return Object.assign(e, {
            id: t,
            accessor: n
        }), e;
    }
    function P(e, t) {
        if (!t) throw new Error;
        return Object.assign(e, r({
            Header: a,
            Footer: a
        }, c, {}, t, {}, e)), Object.assign(e, {
            originalWidth: e.width
        }), e;
    }
    function B(e, t, n) {
        void 0 === n && (n = function() {
            return {};
        });
        for(var o = [], i = e, u = 0, l = function() {
            return u++;
        }, s = function() {
            var e = {
                headers: []
            }, u = [], s = i.some(function(e) {
                return e.parent;
            });
            i.forEach(function(o) {
                var i, a = [].concat(u).reverse()[0];
                if (s) {
                    if (o.parent) i = r({}, o.parent, {
                        originalId: o.parent.id,
                        id: o.parent.id + "_" + l(),
                        headers: [
                            o
                        ]
                    }, n(o));
                    else i = P(r({
                        originalId: o.id + "_placeholder",
                        id: o.id + "_placeholder_" + l(),
                        placeholderOf: o,
                        headers: [
                            o
                        ]
                    }, n(o)), t);
                    a && a.originalId === i.originalId ? a.headers.push(o) : u.push(i);
                }
                e.headers.push(o);
            }), o.push(e), i = u;
        }; i.length;)s();
        return o.reverse();
    }
    var E = new Map;
    function I() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        for(var o = 0; o < t.length; o += 1)if (void 0 !== t[o]) return t[o];
    }
    function F(e) {
        if ("function" == typeof e) return e;
    }
    function G(e, t) {
        var n = [];
        return function e(o) {
            o.forEach(function(o) {
                o[t] ? e(o[t]) : n.push(o);
            });
        }(e), n;
    }
    function A(e, t) {
        var n = t.manualExpandedKey, o = t.expanded, r = t.expandSubRows, i = void 0 === r || r, u = [];
        return e.forEach(function(e) {
            return function e(t, r) {
                void 0 === r && (r = !0), t.isExpanded = t.original && t.original[n] || o[t.id], t.canExpand = t.subRows && !!t.subRows.length, r && u.push(t), t.subRows && t.subRows.length && t.isExpanded && t.subRows.forEach(function(t) {
                    return e(t, i);
                });
            }(e);
        }), u;
    }
    function k(e, t, n) {
        return F(e) || t[e] || n[e] || n.text;
    }
    function H(e, t, n) {
        return e ? e(t, n) : void 0 === t;
    }
    function W() {
        throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var z = null;
    var T = /\[/g, O = /\]/g;
    var M = function(e) {
        return r({
            role: "table"
        }, e);
    }, j = function(e) {
        return r({
            role: "rowgroup"
        }, e);
    }, L = function(e, t) {
        var n = t.column;
        return r({
            key: "header_" + n.id,
            colSpan: n.totalVisibleHeaderCount,
            role: "columnheader"
        }, e);
    }, N = function(e, t) {
        var n = t.column;
        return r({
            key: "footer_" + n.id,
            colSpan: n.totalVisibleHeaderCount
        }, e);
    }, D = function(e, t) {
        return r({
            key: "headerGroup_" + t.index,
            role: "row"
        }, e);
    }, V = function(e, t) {
        return r({
            key: "footerGroup_" + t.index
        }, e);
    }, _ = function(e, t) {
        return r({
            key: "row_" + t.row.id,
            role: "row"
        }, e);
    }, X = function(e, t) {
        var n = t.cell;
        return r({
            key: "cell_" + n.row.id + "_" + n.column.id,
            role: "cell"
        }, e);
    };
    function q() {
        return {
            useOptions: [],
            stateReducers: [],
            useControlledState: [],
            columns: [],
            columnsDeps: [],
            allColumns: [],
            allColumnsDeps: [],
            accessValue: [],
            materializedColumns: [],
            materializedColumnsDeps: [],
            useInstanceAfterData: [],
            visibleColumns: [],
            visibleColumnsDeps: [],
            headerGroups: [],
            headerGroupsDeps: [],
            useInstanceBeforeDimensions: [],
            useInstance: [],
            prepareRow: [],
            getTableProps: [
                M
            ],
            getTableBodyProps: [
                j
            ],
            getHeaderGroupProps: [
                D
            ],
            getFooterGroupProps: [
                V
            ],
            getHeaderProps: [
                L
            ],
            getFooterProps: [
                N
            ],
            getRowProps: [
                _
            ],
            getCellProps: [
                X
            ],
            useFinalInstance: []
        };
    }
    l.resetHiddenColumns = "resetHiddenColumns", l.toggleHideColumn = "toggleHideColumn", l.setHiddenColumns = "setHiddenColumns", l.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e) {
        e.getToggleHiddenProps = [
            U
        ], e.getToggleHideAllColumnsProps = [
            $
        ], e.stateReducers.push(J), e.useInstanceBeforeDimensions.push(Y), e.headerGroupsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.hiddenColumns
            ]);
        }), e.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHidden(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isVisible,
                title: "Toggle Column Visible"
            }
        ];
    }, $ = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleHideAllColumns(!e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !n.allColumnsHidden && !n.state.hiddenColumns.length,
                title: "Toggle All Columns Hidden",
                indeterminate: !n.allColumnsHidden && n.state.hiddenColumns.length
            }
        ];
    };
    function J(e, t, n, o) {
        if (t.type === l.init) return r({
            hiddenColumns: []
        }, e);
        if (t.type === l.resetHiddenColumns) return r({}, e, {
            hiddenColumns: o.initialState.hiddenColumns || []
        });
        if (t.type === l.toggleHideColumn) {
            var i = (void 0 !== t.value ? t.value : !e.hiddenColumns.includes(t.columnId)) ? [].concat(e.hiddenColumns, [
                t.columnId
            ]) : e.hiddenColumns.filter(function(e) {
                return e !== t.columnId;
            });
            return r({}, e, {
                hiddenColumns: i
            });
        }
        return t.type === l.setHiddenColumns ? r({}, e, {
            hiddenColumns: m(t.value, e.hiddenColumns)
        }) : t.type === l.toggleHideAllColumns ? r({}, e, {
            hiddenColumns: (void 0 !== t.value ? t.value : !e.hiddenColumns.length) ? o.allColumns.map(function(e) {
                return e.id;
            }) : []
        }) : void 0;
    }
    function Y(e) {
        var n = e.headers, o = e.state.hiddenColumns;
        t.useRef(!1).current;
        var r = 0;
        n.forEach(function(e) {
            return r += function e(t, n) {
                t.isVisible = n && !o.includes(t.id);
                var r = 0;
                return t.headers && t.headers.length ? t.headers.forEach(function(n) {
                    return r += e(n, t.isVisible);
                }) : r = t.isVisible ? 1 : 0, t.totalVisibleHeaderCount = r, r;
            }(e, !0);
        });
    }
    function Q(e) {
        var n = e.columns, o = e.flatHeaders, r = e.dispatch, i = e.allColumns, u = e.getHooks, s = e.state.hiddenColumns, a = e.autoResetHiddenColumns, c = void 0 === a || a, d = h(e), p = i.length === s.length, g = t.useCallback(function(e, t) {
            return r({
                type: l.toggleHideColumn,
                columnId: e,
                value: t
            });
        }, [
            r
        ]), v = t.useCallback(function(e) {
            return r({
                type: l.setHiddenColumns,
                value: e
            });
        }, [
            r
        ]), m = t.useCallback(function(e) {
            return r({
                type: l.toggleHideAllColumns,
                value: e
            });
        }, [
            r
        ]), y = f(u().getToggleHideAllColumnsProps, {
            instance: d()
        });
        o.forEach(function(e) {
            e.toggleHidden = function(t) {
                r({
                    type: l.toggleHideColumn,
                    columnId: e.id,
                    value: t
                });
            }, e.getToggleHiddenProps = f(u().getToggleHiddenProps, {
                instance: d(),
                column: e
            });
        });
        var R = h(c);
        w(function() {
            R() && r({
                type: l.resetHiddenColumns
            });
        }, [
            r,
            n
        ]), Object.assign(e, {
            allColumnsHidden: p,
            toggleHideColumn: g,
            setHiddenColumns: v,
            toggleHideAllColumns: m,
            getToggleHideAllColumnsProps: y
        });
    }
    var Z = {}, ee = {}, te = function(e, t, n) {
        return e;
    }, ne = function(e, t) {
        return e.subRows || [];
    }, oe = function(e, t, n) {
        return "" + (n ? [
            n.id,
            t
        ].join(".") : t);
    }, re = function(e) {
        return e;
    };
    function ie(e) {
        var t = e.initialState, n = void 0 === t ? Z : t, o = e.defaultColumn, u = void 0 === o ? ee : o, l = e.getSubRows, s = void 0 === l ? ne : l, a = e.getRowId, c = void 0 === a ? oe : a, d = e.stateReducer, f = void 0 === d ? te : d, p = e.useControlledState, g = void 0 === p ? re : p;
        return r({}, i(e, [
            "initialState",
            "defaultColumn",
            "getSubRows",
            "getRowId",
            "stateReducer",
            "useControlledState"
        ]), {
            initialState: n,
            defaultColumn: u,
            getSubRows: s,
            getRowId: c,
            stateReducer: f,
            useControlledState: g
        });
    }
    function ue(e, t) {
        void 0 === t && (t = 0);
        var n = 0, o = 0, r = 0, i = 0;
        return e.forEach(function(e) {
            var u = e.headers;
            if (e.totalLeft = t, u && u.length) {
                var l = ue(u, t), s = l[0], a = l[1], c = l[2], d = l[3];
                e.totalMinWidth = s, e.totalWidth = a, e.totalMaxWidth = c, e.totalFlexWidth = d;
            } else e.totalMinWidth = e.minWidth, e.totalWidth = Math.min(Math.max(e.minWidth, e.width), e.maxWidth), e.totalMaxWidth = e.maxWidth, e.totalFlexWidth = e.canResize ? e.totalWidth : 0;
            e.isVisible && (t += e.totalWidth, n += e.totalMinWidth, o += e.totalWidth, r += e.totalMaxWidth, i += e.totalFlexWidth);
        }), [
            n,
            o,
            r,
            i
        ];
    }
    function le(e) {
        var t = e.data, n = e.rows, o = e.flatRows, r = e.rowsById, i = e.column, u = e.getRowId, l = e.getSubRows, s = e.accessValueHooks, a = e.getInstance;
        t.forEach(function(e, c) {
            return function e(n, c, d, f, g) {
                void 0 === d && (d = 0);
                var v = n, m = u(n, c, f), h = r[m];
                if (h) h.subRows && h.originalSubRows.forEach(function(t, n) {
                    return e(t, n, d + 1, h);
                });
                else if ((h = {
                    id: m,
                    original: v,
                    index: c,
                    depth: d,
                    cells: [
                        {}
                    ]
                }).cells.map = W, h.cells.filter = W, h.cells.forEach = W, h.cells[0].getCellProps = W, h.values = {}, g.push(h), o.push(h), r[m] = h, h.originalSubRows = l(n, c), h.originalSubRows) {
                    var y = [];
                    h.originalSubRows.forEach(function(t, n) {
                        return e(t, n, d + 1, h, y);
                    }), h.subRows = y;
                }
                i.accessor && (h.values[i.id] = i.accessor(n, c, h, g, t)), h.values[i.id] = p(s, h.values[i.id], {
                    row: h,
                    column: i,
                    instance: a()
                });
            }(e, c, 0, void 0, n);
        });
    }
    l.resetExpanded = "resetExpanded", l.toggleRowExpanded = "toggleRowExpanded", l.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e) {
        e.getToggleAllRowsExpandedProps = [
            ae
        ], e.getToggleRowExpandedProps = [
            ce
        ], e.stateReducers.push(de), e.useInstance.push(fe), e.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onClick: function(e) {
                    n.toggleAllRowsExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle All Rows Expanded"
            }
        ];
    }, ce = function(e, t) {
        var n = t.row;
        return [
            e,
            {
                onClick: function() {
                    n.toggleRowExpanded();
                },
                style: {
                    cursor: "pointer"
                },
                title: "Toggle Row Expanded"
            }
        ];
    };
    function de(e, t, n, o) {
        if (t.type === l.init) return r({
            expanded: {}
        }, e);
        if (t.type === l.resetExpanded) return r({}, e, {
            expanded: o.initialState.expanded || {}
        });
        if (t.type === l.toggleAllRowsExpanded) {
            var s = t.value, a = o.rowsById, c = Object.keys(a).length === Object.keys(e.expanded).length;
            if (void 0 !== s ? s : !c) {
                var d = {};
                return Object.keys(a).forEach(function(e) {
                    d[e] = !0;
                }), r({}, e, {
                    expanded: d
                });
            }
            return r({}, e, {
                expanded: {}
            });
        }
        if (t.type === l.toggleRowExpanded) {
            var f, p = t.id, g = t.value, v = e.expanded[p], m = void 0 !== g ? g : !v;
            if (!v && m) return r({}, e, {
                expanded: r({}, e.expanded, (f = {}, f[p] = !0, f))
            });
            if (v && !m) {
                var h = e.expanded;
                h[p];
                return r({}, e, {
                    expanded: i(h, [
                        p
                    ].map(u))
                });
            }
            return e;
        }
    }
    function fe(e) {
        var n = e.data, o = e.rows, r = e.rowsById, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.paginateExpandedRows, a = void 0 === s || s, c = e.expandSubRows, d = void 0 === c || c, p = e.autoResetExpanded, g = void 0 === p || p, m = e.getHooks, y = e.plugins, R = e.state.expanded, b = e.dispatch;
        v(y, [
            "useSortBy",
            "useGroupBy",
            "usePivotColumns",
            "useGlobalFilter"
        ], "useExpanded");
        var S = h(g), C = Boolean(Object.keys(r).length && Object.keys(R).length);
        C && Object.keys(r).some(function(e) {
            return !R[e];
        }) && (C = !1), w(function() {
            S() && b({
                type: l.resetExpanded
            });
        }, [
            b,
            n
        ]);
        var x = t.useCallback(function(e, t) {
            b({
                type: l.toggleRowExpanded,
                id: e,
                value: t
            });
        }, [
            b
        ]), P = t.useCallback(function(e) {
            return b({
                type: l.toggleAllRowsExpanded,
                value: e
            });
        }, [
            b
        ]), B = t.useMemo(function() {
            return a ? A(o, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: d
            }) : o;
        }, [
            a,
            o,
            u,
            R,
            d
        ]), E = t.useMemo(function() {
            return function(e) {
                var t = 0;
                return Object.keys(e).forEach(function(e) {
                    var n = e.split(".");
                    t = Math.max(t, n.length);
                }), t;
            }(R);
        }, [
            R
        ]), I = h(e), F = f(m().getToggleAllRowsExpandedProps, {
            instance: I()
        });
        Object.assign(e, {
            preExpandedRows: o,
            expandedRows: B,
            rows: B,
            expandedDepth: E,
            isAllRowsExpanded: C,
            toggleRowExpanded: x,
            toggleAllRowsExpanded: P,
            getToggleAllRowsExpandedProps: F
        });
    }
    function pe(e, t) {
        var n = t.instance.getHooks, o = t.instance;
        e.toggleRowExpanded = function(t) {
            return o.toggleRowExpanded(e.id, t);
        }, e.getToggleRowExpandedProps = f(n().getToggleRowExpandedProps, {
            instance: o,
            row: e
        });
    }
    var ge = function(e, t, n) {
        return e = e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return String(o).toLowerCase().includes(String(n).toLowerCase());
            });
        });
    };
    ge.autoRemove = function(e) {
        return !e;
    };
    var ve = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o).toLowerCase() === String(n).toLowerCase();
            });
        });
    };
    ve.autoRemove = function(e) {
        return !e;
    };
    var me = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return void 0 === o || String(o) === String(n);
            });
        });
    };
    me.autoRemove = function(e) {
        return !e;
    };
    var he = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t].includes(n);
            });
        });
    };
    he.autoRemove = function(e) {
        return !e || !e.length;
    };
    var ye = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.every(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    ye.autoRemove = function(e) {
        return !e || !e.length;
    };
    var we = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return o && o.length && n.some(function(e) {
                    return o.includes(e);
                });
            });
        });
    };
    we.autoRemove = function(e) {
        return !e || !e.length;
    };
    var Re = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                var o = e.values[t];
                return n.includes(o);
            });
        });
    };
    Re.autoRemove = function(e) {
        return !e || !e.length;
    };
    var be = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] === n;
            });
        });
    };
    be.autoRemove = function(e) {
        return void 0 === e;
    };
    var Se = function(e, t, n) {
        return e.filter(function(e) {
            return t.some(function(t) {
                return e.values[t] == n;
            });
        });
    };
    Se.autoRemove = function(e) {
        return null == e;
    };
    var Ce = function(e, t, n) {
        var o = n || [], r = o[0], i = o[1];
        if ((r = "number" == typeof r ? r : -1 / 0) > (i = "number" == typeof i ? i : 1 / 0)) {
            var u = r;
            r = i, i = u;
        }
        return e.filter(function(e) {
            return t.some(function(t) {
                var n = e.values[t];
                return n >= r && n <= i;
            });
        });
    };
    Ce.autoRemove = function(e) {
        return !e || "number" != typeof e[0] && "number" != typeof e[1];
    };
    var xe = Object.freeze({
        __proto__: null,
        text: ge,
        exactText: ve,
        exactTextCase: me,
        includes: he,
        includesAll: ye,
        includesSome: we,
        includesValue: Re,
        exact: be,
        equals: Se,
        between: Ce
    });
    l.resetFilters = "resetFilters", l.setFilter = "setFilter", l.setAllFilters = "setAllFilters";
    var Pe = function(e) {
        e.stateReducers.push(Be), e.useInstance.push(Ee);
    };
    function Be(e, t, n, o) {
        if (t.type === l.init) return r({
            filters: []
        }, e);
        if (t.type === l.resetFilters) return r({}, e, {
            filters: o.initialState.filters || []
        });
        if (t.type === l.setFilter) {
            var i = t.columnId, u = t.filterValue, s = o.allColumns, a = o.filterTypes, c = s.find(function(e) {
                return e.id === i;
            });
            if (!c) throw new Error("React-Table: Could not find a column with id: " + i);
            var d = k(c.filter, a || {}, xe), f = e.filters.find(function(e) {
                return e.id === i;
            }), p = m(u, f && f.value);
            return H(d.autoRemove, p, c) ? r({}, e, {
                filters: e.filters.filter(function(e) {
                    return e.id !== i;
                })
            }) : r({}, e, f ? {
                filters: e.filters.map(function(e) {
                    return e.id === i ? {
                        id: i,
                        value: p
                    } : e;
                })
            } : {
                filters: [].concat(e.filters, [
                    {
                        id: i,
                        value: p
                    }
                ])
            });
        }
        if (t.type === l.setAllFilters) {
            var g = t.filters, v = o.allColumns, h = o.filterTypes;
            return r({}, e, {
                filters: m(g, e.filters).filter(function(e) {
                    var t = v.find(function(t) {
                        return t.id === e.id;
                    });
                    return !H(k(t.filter, h || {}, xe).autoRemove, e.value, t);
                })
            });
        }
    }
    function Ee(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.manualFilters, c = e.defaultCanFilter, d = void 0 !== c && c, f = e.disableFilters, p = e.state.filters, g = e.dispatch, v = e.autoResetFilters, m = void 0 === v || v, y = t.useCallback(function(e, t) {
            g({
                type: l.setFilter,
                columnId: e,
                filterValue: t
            });
        }, [
            g
        ]), R = t.useCallback(function(e) {
            g({
                type: l.setAllFilters,
                filters: e
            });
        }, [
            g
        ]);
        u.forEach(function(e) {
            var t = e.id, n = e.accessor, o = e.defaultCanFilter, r = e.disableFilters;
            e.canFilter = n ? I(!0 !== r && void 0, !0 !== f && void 0, !0) : I(o, d, !1), e.setFilter = function(t) {
                return y(e.id, t);
            };
            var i = p.find(function(e) {
                return e.id === t;
            });
            e.filterValue = i && i.value;
        });
        var b = t.useMemo(function() {
            if (a || !p.length) return [
                o,
                r,
                i
            ];
            var e = [], t = {};
            return [
                function n(o, r) {
                    void 0 === r && (r = 0);
                    var i = o;
                    return (i = p.reduce(function(e, t) {
                        var n = t.id, o = t.value, i = u.find(function(e) {
                            return e.id === n;
                        });
                        if (!i) return e;
                        0 === r && (i.preFilteredRows = e);
                        var l = k(i.filter, s || {}, xe);
                        return l ? (i.filteredRows = l(e, [
                            n
                        ], o), i.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i.id + "."), e);
                    }, o)).forEach(function(o) {
                        e.push(o), t[o.id] = o, o.subRows && (o.subRows = o.subRows && o.subRows.length > 0 ? n(o.subRows, r + 1) : o.subRows);
                    }), i;
                }(o),
                e,
                t
            ];
        }, [
            a,
            p,
            o,
            r,
            i,
            u,
            s
        ]), S = b[0], C = b[1], x = b[2];
        t.useMemo(function() {
            u.filter(function(e) {
                return !p.find(function(t) {
                    return t.id === e.id;
                });
            }).forEach(function(e) {
                e.preFilteredRows = S, e.filteredRows = S;
            });
        }, [
            S,
            p,
            u
        ]);
        var P = h(m);
        w(function() {
            P() && g({
                type: l.resetFilters
            });
        }, [
            g,
            a ? null : n
        ]), Object.assign(e, {
            preFilteredRows: o,
            preFilteredFlatRows: r,
            preFilteredRowsById: i,
            filteredRows: S,
            filteredFlatRows: C,
            filteredRowsById: x,
            rows: S,
            flatRows: C,
            rowsById: x,
            setFilter: y,
            setAllFilters: R
        });
    }
    Pe.pluginName = "useFilters", l.resetGlobalFilter = "resetGlobalFilter", l.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e) {
        e.stateReducers.push(Fe), e.useInstance.push(Ge);
    };
    function Fe(e, t, n, o) {
        if (t.type === l.resetGlobalFilter) return r({}, e, {
            globalFilter: o.initialState.globalFilter || void 0
        });
        if (t.type === l.setGlobalFilter) {
            var u = t.filterValue, s = o.userFilterTypes, a = k(o.globalFilter, s || {}, xe), c = m(u, e.globalFilter);
            if (H(a.autoRemove, c)) {
                e.globalFilter;
                return i(e, [
                    "globalFilter"
                ]);
            }
            return r({}, e, {
                globalFilter: c
            });
        }
    }
    function Ge(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.rowsById, u = e.allColumns, s = e.filterTypes, a = e.globalFilter, c = e.manualGlobalFilter, d = e.state.globalFilter, f = e.dispatch, p = e.autoResetGlobalFilter, g = void 0 === p || p, v = e.disableGlobalFilter, m = t.useCallback(function(e) {
            f({
                type: l.setGlobalFilter,
                filterValue: e
            });
        }, [
            f
        ]), y = t.useMemo(function() {
            if (c || void 0 === d) return [
                o,
                r,
                i
            ];
            var e = [], t = {}, n = k(a, s || {}, xe);
            if (!n) return console.warn("Could not find a valid 'globalFilter' option."), o;
            u.forEach(function(e) {
                var t = e.disableGlobalFilter;
                e.canFilter = I(!0 !== t && void 0, !0 !== v && void 0, !0);
            });
            var l = u.filter(function(e) {
                return !0 === e.canFilter;
            });
            return [
                function o(r) {
                    return (r = n(r, l.map(function(e) {
                        return e.id;
                    }), d)).forEach(function(n) {
                        e.push(n), t[n.id] = n, n.subRows = n.subRows && n.subRows.length ? o(n.subRows) : n.subRows;
                    }), r;
                }(o),
                e,
                t
            ];
        }, [
            c,
            d,
            a,
            s,
            u,
            o,
            r,
            i,
            v
        ]), R = y[0], b = y[1], S = y[2], C = h(g);
        w(function() {
            C() && f({
                type: l.resetGlobalFilter
            });
        }, [
            f,
            c ? null : n
        ]), Object.assign(e, {
            preGlobalFilteredRows: o,
            preGlobalFilteredFlatRows: r,
            preGlobalFilteredRowsById: i,
            globalFilteredRows: R,
            globalFilteredFlatRows: b,
            globalFilteredRowsById: S,
            rows: R,
            flatRows: b,
            rowsById: S,
            setGlobalFilter: m,
            disableGlobalFilter: v
        });
    }
    function Ae(e, t) {
        return t.reduce(function(e, t) {
            return e + ("number" == typeof t ? t : 0);
        }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({
        __proto__: null,
        sum: Ae,
        min: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e));
            }), t;
        },
        max: function(e) {
            var t = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.max(t, e));
            }), t;
        },
        minMax: function(e) {
            var t = e[0] || 0, n = e[0] || 0;
            return e.forEach(function(e) {
                "number" == typeof e && (t = Math.min(t, e), n = Math.max(n, e));
            }), t + ".." + n;
        },
        average: function(e) {
            return Ae(0, e) / e.length;
        },
        median: function(e) {
            if (!e.length) return null;
            var t = Math.floor(e.length / 2), n = [].concat(e).sort(function(e, t) {
                return e - t;
            });
            return e.length % 2 != 0 ? n[t] : (n[t - 1] + n[t]) / 2;
        },
        unique: function(e) {
            return Array.from(new Set(e).values());
        },
        uniqueCount: function(e) {
            return new Set(e).size;
        },
        count: function(e) {
            return e.length;
        }
    }), He = [], We = {};
    l.resetGroupBy = "resetGroupBy", l.setGroupBy = "setGroupBy", l.toggleGroupBy = "toggleGroupBy";
    var ze = function(e) {
        e.getGroupByToggleProps = [
            Te
        ], e.stateReducers.push(Oe), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.groupBy
            ]);
        }), e.visibleColumns.push(Me), e.useInstance.push(Le), e.prepareRow.push(Ne);
    };
    ze.pluginName = "useGroupBy";
    var Te = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canGroupBy ? function(e) {
                    e.persist(), n.toggleGroupBy();
                } : void 0,
                style: {
                    cursor: n.canGroupBy ? "pointer" : void 0
                },
                title: "Toggle GroupBy"
            }
        ];
    };
    function Oe(e, t, n, o) {
        if (t.type === l.init) return r({
            groupBy: []
        }, e);
        if (t.type === l.resetGroupBy) return r({}, e, {
            groupBy: o.initialState.groupBy || []
        });
        if (t.type === l.setGroupBy) return r({}, e, {
            groupBy: t.value
        });
        if (t.type === l.toggleGroupBy) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.groupBy.includes(i);
            return r({}, e, s ? {
                groupBy: [].concat(e.groupBy, [
                    i
                ])
            } : {
                groupBy: e.groupBy.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function Me(e, t) {
        var n = t.instance.state.groupBy, o = n.map(function(t) {
            return e.find(function(e) {
                return e.id === t;
            });
        }).filter(Boolean), r = e.filter(function(e) {
            return !n.includes(e.id);
        });
        return (e = [].concat(o, r)).forEach(function(e) {
            e.isGrouped = n.includes(e.id), e.groupedIndex = n.indexOf(e.id);
        }), e;
    }
    var je = {};
    function Le(e) {
        var n = e.data, o = e.rows, i = e.flatRows, u = e.rowsById, s = e.allColumns, a = e.flatHeaders, c = e.groupByFn, d = void 0 === c ? De : c, p = e.manualGroupBy, g = e.aggregations, m = void 0 === g ? je : g, y = e.plugins, R = e.state.groupBy, b = e.dispatch, S = e.autoResetGroupBy, C = void 0 === S || S, x = e.disableGroupBy, P = e.defaultCanGroupBy, B = e.getHooks;
        v(y, [
            "useColumnOrder",
            "useFilters"
        ], "useGroupBy");
        var E = h(e);
        s.forEach(function(t) {
            var n = t.accessor, o = t.defaultGroupBy, r = t.disableGroupBy;
            t.canGroupBy = n ? I(t.canGroupBy, !0 !== r && void 0, !0 !== x && void 0, !0) : I(t.canGroupBy, o, P, !1), t.canGroupBy && (t.toggleGroupBy = function() {
                return e.toggleGroupBy(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        var F = t.useCallback(function(e, t) {
            b({
                type: l.toggleGroupBy,
                columnId: e,
                value: t
            });
        }, [
            b
        ]), A = t.useCallback(function(e) {
            b({
                type: l.setGroupBy,
                value: e
            });
        }, [
            b
        ]);
        a.forEach(function(e) {
            e.getGroupByToggleProps = f(B().getGroupByToggleProps, {
                instance: E(),
                header: e
            });
        });
        var k = t.useMemo(function() {
            if (p || !R.length) return [
                o,
                i,
                u,
                He,
                We,
                i,
                u
            ];
            var e = R.filter(function(e) {
                return s.find(function(t) {
                    return t.id === e;
                });
            }), t = [], n = {}, l = [], a = {}, c = [], f = {}, g = function o(i, u, p) {
                if (void 0 === u && (u = 0), u === e.length) return i.map(function(e) {
                    return r({}, e, {
                        depth: u
                    });
                });
                var g = e[u], v = d(i, g);
                return Object.entries(v).map(function(r, i) {
                    var d = r[0], v = r[1], h = g + ":" + d, y = o(v, u + 1, h = p ? p + ">" + h : h), w = u ? G(v, "leafRows") : v, R = function(t, n, _o) {
                        var r = {};
                        return s.forEach(function(i) {
                            if (e.includes(i.id)) r[i.id] = n[0] ? n[0].values[i.id] : null;
                            else {
                                var u = "function" == typeof i.aggregate ? i.aggregate : m[i.aggregate] || ke[i.aggregate];
                                if (u) {
                                    var l = n.map(function(e) {
                                        return e.values[i.id];
                                    }), s = t.map(function(e) {
                                        var t = e.values[i.id];
                                        if (!_o && i.aggregateValue) {
                                            var n = "function" == typeof i.aggregateValue ? i.aggregateValue : m[i.aggregateValue] || ke[i.aggregateValue];
                                            if (!n) throw console.info({
                                                column: i
                                            }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                                            t = n(t, e, i);
                                        }
                                        return t;
                                    });
                                    r[i.id] = u(s, l);
                                } else {
                                    if (i.aggregate) throw console.info({
                                        column: i
                                    }), new Error("React Table: Invalid column.aggregate option for column listed above");
                                    r[i.id] = null;
                                }
                            }
                        }), r;
                    }(w, v, u), b = {
                        id: h,
                        isGrouped: !0,
                        groupByID: g,
                        groupByVal: d,
                        values: R,
                        subRows: y,
                        leafRows: w,
                        depth: u,
                        index: i
                    };
                    return y.forEach(function(e) {
                        t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
                    }), b;
                });
            }(o);
            return g.forEach(function(e) {
                t.push(e), n[e.id] = e, e.isGrouped ? (l.push(e), a[e.id] = e) : (c.push(e), f[e.id] = e);
            }), [
                g,
                t,
                n,
                l,
                a,
                c,
                f
            ];
        }, [
            p,
            R,
            o,
            i,
            u,
            s,
            m,
            d
        ]), H = k[0], W = k[1], z = k[2], T = k[3], O = k[4], M = k[5], j = k[6], L = h(C);
        w(function() {
            L() && b({
                type: l.resetGroupBy
            });
        }, [
            b,
            p ? null : n
        ]), Object.assign(e, {
            preGroupedRows: o,
            preGroupedFlatRow: i,
            preGroupedRowsById: u,
            groupedRows: H,
            groupedFlatRows: W,
            groupedRowsById: z,
            onlyGroupedFlatRows: T,
            onlyGroupedRowsById: O,
            nonGroupedFlatRows: M,
            nonGroupedRowsById: j,
            rows: H,
            flatRows: W,
            rowsById: z,
            toggleGroupBy: F,
            setGroupBy: A
        });
    }
    function Ne(e) {
        e.allCells.forEach(function(t) {
            var n;
            t.isGrouped = t.column.isGrouped && t.column.id === e.groupByID, t.isPlaceholder = !t.isGrouped && t.column.isGrouped, t.isAggregated = !t.isGrouped && !t.isPlaceholder && (null == (n = e.subRows) ? void 0 : n.length);
        });
    }
    function De(e, t) {
        return e.reduce(function(e, n, o) {
            var r = "" + n.values[t];
            return e[r] = Array.isArray(e[r]) ? e[r] : [], e[r].push(n), e;
        }, {});
    }
    var Ve = /([0-9]+)/gm;
    function _e(e, t) {
        return e === t ? 0 : e > t ? 1 : -1;
    }
    function Xe(e, t, n) {
        return [
            e.values[n],
            t.values[n]
        ];
    }
    function qe(e) {
        return "number" == typeof e ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : "string" == typeof e ? e : "";
    }
    var Ke = Object.freeze({
        __proto__: null,
        alphanumeric: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = qe(r), i = qe(i), r = r.split(Ve).filter(Boolean), i = i.split(Ve).filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = parseInt(u, 10), a = parseInt(l, 10), c = [
                    s,
                    a
                ].sort();
                if (isNaN(c[0])) {
                    if (u > l) return 1;
                    if (l > u) return -1;
                } else {
                    if (isNaN(c[1])) return isNaN(s) ? -1 : 1;
                    if (s > a) return 1;
                    if (a > s) return -1;
                }
            }
            return r.length - i.length;
        },
        datetime: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            return _e(r = r.getTime(), i = i.getTime());
        },
        basic: function(e, t, n) {
            var o = Xe(e, t, n);
            return _e(o[0], o[1]);
        },
        string: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1];
            for(r = r.split("").filter(Boolean), i = i.split("").filter(Boolean); r.length && i.length;){
                var u = r.shift(), l = i.shift(), s = u.toLowerCase(), a = l.toLowerCase();
                if (s > a) return 1;
                if (a > s) return -1;
                if (u > l) return 1;
                if (l > u) return -1;
            }
            return r.length - i.length;
        },
        number: function(e, t, n) {
            var o = Xe(e, t, n), r = o[0], i = o[1], u = /[^0-9.]/gi;
            return _e(r = Number(String(r).replace(u, "")), i = Number(String(i).replace(u, "")));
        }
    });
    l.resetSortBy = "resetSortBy", l.setSortBy = "setSortBy", l.toggleSortBy = "toggleSortBy", l.clearSortBy = "clearSortBy", c.sortType = "alphanumeric", c.sortDescFirst = !1;
    var Ue = function(e) {
        e.getSortByToggleProps = [
            $e
        ], e.stateReducers.push(Je), e.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e, t) {
        var n = t.instance, o = t.column, r = n.isMultiSortEvent, i = void 0 === r ? function(e) {
            return e.shiftKey;
        } : r;
        return [
            e,
            {
                onClick: o.canSort ? function(e) {
                    e.persist(), o.toggleSortBy(void 0, !n.disableMultiSort && i(e));
                } : void 0,
                style: {
                    cursor: o.canSort ? "pointer" : void 0
                },
                title: o.canSort ? "Toggle SortBy" : void 0
            }
        ];
    };
    function Je(e, t, n, o) {
        if (t.type === l.init) return r({
            sortBy: []
        }, e);
        if (t.type === l.resetSortBy) return r({}, e, {
            sortBy: o.initialState.sortBy || []
        });
        if (t.type === l.clearSortBy) return r({}, e, {
            sortBy: e.sortBy.filter(function(e) {
                return e.id !== t.columnId;
            })
        });
        if (t.type === l.setSortBy) return r({}, e, {
            sortBy: t.sortBy
        });
        if (t.type === l.toggleSortBy) {
            var i, u = t.columnId, s = t.desc, a = t.multi, c = o.allColumns, d = o.disableMultiSort, f = o.disableSortRemove, p = o.disableMultiRemove, g = o.maxMultiSortColCount, v = void 0 === g ? Number.MAX_SAFE_INTEGER : g, m = e.sortBy, h = c.find(function(e) {
                return e.id === u;
            }).sortDescFirst, y = m.find(function(e) {
                return e.id === u;
            }), w = m.findIndex(function(e) {
                return e.id === u;
            }), R = null != s, b = [];
            return "toggle" !== (i = !d && a ? y ? "toggle" : "add" : w !== m.length - 1 || 1 !== m.length ? "replace" : y ? "toggle" : "replace") || f || R || a && p || !(y && y.desc && !h || !y.desc && h) || (i = "remove"), "replace" === i ? b = [
                {
                    id: u,
                    desc: R ? s : h
                }
            ] : "add" === i ? (b = [].concat(m, [
                {
                    id: u,
                    desc: R ? s : h
                }
            ])).splice(0, b.length - v) : "toggle" === i ? b = m.map(function(e) {
                return e.id === u ? r({}, e, {
                    desc: R ? s : !y.desc
                }) : e;
            }) : "remove" === i && (b = m.filter(function(e) {
                return e.id !== u;
            })), r({}, e, {
                sortBy: b
            });
        }
    }
    function Ye(e) {
        var n = e.data, o = e.rows, r = e.flatRows, i = e.allColumns, u = e.orderByFn, s = void 0 === u ? Qe : u, a = e.sortTypes, c = e.manualSortBy, d = e.defaultCanSort, p = e.disableSortBy, g = e.flatHeaders, m = e.state.sortBy, y = e.dispatch, R = e.plugins, b = e.getHooks, S = e.autoResetSortBy, C = void 0 === S || S;
        v(R, [
            "useFilters",
            "useGlobalFilter",
            "useGroupBy",
            "usePivotColumns"
        ], "useSortBy");
        var x = t.useCallback(function(e) {
            y({
                type: l.setSortBy,
                sortBy: e
            });
        }, [
            y
        ]), P = t.useCallback(function(e, t, n) {
            y({
                type: l.toggleSortBy,
                columnId: e,
                desc: t,
                multi: n
            });
        }, [
            y
        ]), B = h(e);
        g.forEach(function(e) {
            var t = e.accessor, n = e.canSort, o = e.disableSortBy, r = e.id, i = t ? I(!0 !== o && void 0, !0 !== p && void 0, !0) : I(d, n, !1);
            e.canSort = i, e.canSort && (e.toggleSortBy = function(t, n) {
                return P(e.id, t, n);
            }, e.clearSortBy = function() {
                y({
                    type: l.clearSortBy,
                    columnId: e.id
                });
            }), e.getSortByToggleProps = f(b().getSortByToggleProps, {
                instance: B(),
                column: e
            });
            var u = m.find(function(e) {
                return e.id === r;
            });
            e.isSorted = !!u, e.sortedIndex = m.findIndex(function(e) {
                return e.id === r;
            }), e.isSortedDesc = e.isSorted ? u.desc : void 0;
        });
        var E = t.useMemo(function() {
            if (c || !m.length) return [
                o,
                r
            ];
            var e = [], t = m.filter(function(e) {
                return i.find(function(t) {
                    return t.id === e.id;
                });
            });
            return [
                function n(o) {
                    var r = s(o, t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        if (!t) throw new Error("React-Table: Could not find a column with id: " + e.id + " while sorting");
                        var n = t.sortType, o = F(n) || (a || {})[n] || Ke[n];
                        if (!o) throw new Error("React-Table: Could not find a valid sortType of '" + n + "' for column '" + e.id + "'.");
                        return function(t, _n) {
                            return o(t, _n, e.id, e.desc);
                        };
                    }), t.map(function(e) {
                        var t = i.find(function(t) {
                            return t.id === e.id;
                        });
                        return t && t.sortInverted ? e.desc : !e.desc;
                    }));
                    return r.forEach(function(t) {
                        e.push(t), t.subRows && 0 !== t.subRows.length && (t.subRows = n(t.subRows));
                    }), r;
                }(o),
                e
            ];
        }, [
            c,
            m,
            o,
            r,
            i,
            s,
            a
        ]), G = E[0], A = E[1], k = h(C);
        w(function() {
            k() && y({
                type: l.resetSortBy
            });
        }, [
            c ? null : n
        ]), Object.assign(e, {
            preSortedRows: o,
            preSortedFlatRows: r,
            sortedRows: G,
            sortedFlatRows: A,
            rows: G,
            flatRows: A,
            setSortBy: x,
            toggleSortBy: P
        });
    }
    function Qe(e, t, n) {
        return [].concat(e).sort(function(e, o) {
            for(var r = 0; r < t.length; r += 1){
                var i = t[r], u = !1 === n[r] || "desc" === n[r], l = i(e, o);
                if (0 !== l) return u ? -l : l;
            }
            return n[0] ? e.index - o.index : o.index - e.index;
        });
    }
    l.resetPage = "resetPage", l.gotoPage = "gotoPage", l.setPageSize = "setPageSize";
    var Ze = function(e) {
        e.stateReducers.push(et), e.useInstance.push(tt);
    };
    function et(e, t, n, o) {
        if (t.type === l.init) return r({
            pageSize: 10,
            pageIndex: 0
        }, e);
        if (t.type === l.resetPage) return r({}, e, {
            pageIndex: o.initialState.pageIndex || 0
        });
        if (t.type === l.gotoPage) {
            var i = o.pageCount, u = o.page, s = m(t.pageIndex, e.pageIndex), a = !1;
            return s > e.pageIndex ? a = -1 === i ? u.length >= e.pageSize : s < i : s < e.pageIndex && (a = s > -1), a ? r({}, e, {
                pageIndex: s
            }) : e;
        }
        if (t.type === l.setPageSize) {
            var c = t.pageSize, d = e.pageSize * e.pageIndex;
            return r({}, e, {
                pageIndex: Math.floor(d / c),
                pageSize: c
            });
        }
    }
    function tt(e) {
        var n = e.rows, o = e.autoResetPage, r = void 0 === o || o, i = e.manualExpandedKey, u = void 0 === i ? "expanded" : i, s = e.plugins, a = e.pageCount, c = e.paginateExpandedRows, d = void 0 === c || c, f = e.expandSubRows, p = void 0 === f || f, g = e.state, m = g.pageSize, y = g.pageIndex, R = g.expanded, b = g.globalFilter, S = g.filters, C = g.groupBy, x = g.sortBy, P = e.dispatch, B = e.data, E = e.manualPagination;
        v(s, [
            "useGlobalFilter",
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded"
        ], "usePagination");
        var I = h(r);
        w(function() {
            I() && P({
                type: l.resetPage
            });
        }, [
            P,
            E ? null : B,
            b,
            S,
            C,
            x
        ]);
        var F = E ? a : Math.ceil(n.length / m), G = t.useMemo(function() {
            return F > 0 ? [].concat(new Array(F)).fill(null).map(function(e, t) {
                return t;
            }) : [];
        }, [
            F
        ]), k = t.useMemo(function() {
            var e;
            if (E) e = n;
            else {
                var t = m * y, o = t + m;
                e = n.slice(t, o);
            }
            return d ? e : A(e, {
                manualExpandedKey: u,
                expanded: R,
                expandSubRows: p
            });
        }, [
            p,
            R,
            u,
            E,
            y,
            m,
            d,
            n
        ]), H = y > 0, W = -1 === F ? k.length >= m : y < F - 1, z = t.useCallback(function(e) {
            P({
                type: l.gotoPage,
                pageIndex: e
            });
        }, [
            P
        ]), T = t.useCallback(function() {
            return z(function(e) {
                return e - 1;
            });
        }, [
            z
        ]), O = t.useCallback(function() {
            return z(function(e) {
                return e + 1;
            });
        }, [
            z
        ]), M = t.useCallback(function(e) {
            P({
                type: l.setPageSize,
                pageSize: e
            });
        }, [
            P
        ]);
        Object.assign(e, {
            pageOptions: G,
            pageCount: F,
            page: k,
            canPreviousPage: H,
            canNextPage: W,
            gotoPage: z,
            previousPage: T,
            nextPage: O,
            setPageSize: M
        });
    }
    Ze.pluginName = "usePagination", l.resetPivot = "resetPivot", l.togglePivot = "togglePivot";
    var nt = function(e) {
        e.getPivotToggleProps = [
            rt
        ], e.stateReducers.push(it), e.useInstanceAfterData.push(ut), e.allColumns.push(lt), e.accessValue.push(st), e.materializedColumns.push(at), e.materializedColumnsDeps.push(ct), e.visibleColumns.push(dt), e.visibleColumnsDeps.push(ft), e.useInstance.push(pt), e.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e, t) {
        var n = t.header;
        return [
            e,
            {
                onClick: n.canPivot ? function(e) {
                    e.persist(), n.togglePivot();
                } : void 0,
                style: {
                    cursor: n.canPivot ? "pointer" : void 0
                },
                title: "Toggle Pivot"
            }
        ];
    };
    function it(e, t, n, o) {
        if (t.type === l.init) return r({
            pivotColumns: ot
        }, e);
        if (t.type === l.resetPivot) return r({}, e, {
            pivotColumns: o.initialState.pivotColumns || ot
        });
        if (t.type === l.togglePivot) {
            var i = t.columnId, u = t.value, s = void 0 !== u ? u : !e.pivotColumns.includes(i);
            return r({}, e, s ? {
                pivotColumns: [].concat(e.pivotColumns, [
                    i
                ])
            } : {
                pivotColumns: e.pivotColumns.filter(function(e) {
                    return e !== i;
                })
            });
        }
    }
    function ut(e) {
        e.allColumns.forEach(function(t) {
            t.isPivotSource = e.state.pivotColumns.includes(t.id);
        });
    }
    function lt(e, t) {
        var n = t.instance;
        return e.forEach(function(e) {
            e.isPivotSource = n.state.pivotColumns.includes(e.id), e.uniqueValues = new Set;
        }), e;
    }
    function st(e, t) {
        var n = t.column;
        return n.uniqueValues && void 0 !== e && n.uniqueValues.add(e), e;
    }
    function at(e, t) {
        var n = t.instance, o = n.allColumns, i = n.state;
        if (!i.pivotColumns.length || !i.groupBy || !i.groupBy.length) return e;
        var u = i.pivotColumns.map(function(e) {
            return o.find(function(t) {
                return t.id === e;
            });
        }).filter(Boolean), l = o.filter(function(e) {
            return !e.isPivotSource && !i.groupBy.includes(e.id) && !i.pivotColumns.includes(e.id);
        }), s = C(function e(t, n, o) {
            void 0 === t && (t = 0), void 0 === o && (o = []);
            var i = u[t];
            return i ? Array.from(i.uniqueValues).sort().map(function(u) {
                var l = r({}, i, {
                    Header: i.PivotHeader || "string" == typeof i.header ? i.Header + ": " + u : u,
                    isPivotGroup: !0,
                    parent: n,
                    depth: t,
                    id: n ? n.id + "." + i.id + "." + u : i.id + "." + u,
                    pivotValue: u
                });
                return l.columns = e(t + 1, l, [].concat(o, [
                    function(e) {
                        return e.values[i.id] === u;
                    }
                ])), l;
            }) : l.map(function(e) {
                return r({}, e, {
                    canPivot: !1,
                    isPivoted: !0,
                    parent: n,
                    depth: t,
                    id: "" + (n ? n.id + "." + e.id : e.id),
                    accessor: function(t, n, r) {
                        if (o.every(function(_e1) {
                            return _e1(r);
                        })) return r.values[e.id];
                    }
                });
            });
        }());
        return [].concat(e, s);
    }
    function ct(e, t) {
        var n = t.instance.state, o = n.pivotColumns, r = n.groupBy;
        return [].concat(e, [
            o,
            r
        ]);
    }
    function dt(e, t) {
        var n = t.instance.state;
        return e = e.filter(function(e) {
            return !e.isPivotSource;
        }), n.pivotColumns.length && n.groupBy && n.groupBy.length && (e = e.filter(function(e) {
            return e.isGrouped || e.isPivoted;
        })), e;
    }
    function ft(e, t) {
        var n = t.instance;
        return [].concat(e, [
            n.state.pivotColumns,
            n.state.groupBy
        ]);
    }
    function pt(e) {
        var t = e.columns, n = e.allColumns, o = e.flatHeaders, r = e.getHooks, i = e.plugins, u = e.dispatch, s = e.autoResetPivot, a = void 0 === s || s, c = e.manaulPivot, d = e.disablePivot, p = e.defaultCanPivot;
        v(i, [
            "useGroupBy"
        ], "usePivotColumns");
        var g = h(e);
        n.forEach(function(t) {
            var n = t.accessor, o = t.defaultPivot, r = t.disablePivot;
            t.canPivot = n ? I(t.canPivot, !0 !== r && void 0, !0 !== d && void 0, !0) : I(t.canPivot, o, p, !1), t.canPivot && (t.togglePivot = function() {
                return e.togglePivot(t.id);
            }), t.Aggregated = t.Aggregated || t.Cell;
        });
        o.forEach(function(e) {
            e.getPivotToggleProps = f(r().getPivotToggleProps, {
                instance: g(),
                header: e
            });
        });
        var m = h(a);
        w(function() {
            m() && u({
                type: l.resetPivot
            });
        }, [
            u,
            c ? null : t
        ]), Object.assign(e, {
            togglePivot: function(e, t) {
                u({
                    type: l.togglePivot,
                    columnId: e,
                    value: t
                });
            }
        });
    }
    function gt(e) {
        e.allCells.forEach(function(e) {
            e.isPivoted = e.column.isPivoted;
        });
    }
    l.resetSelectedRows = "resetSelectedRows", l.toggleAllRowsSelected = "toggleAllRowsSelected", l.toggleRowSelected = "toggleRowSelected", l.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e) {
        e.getToggleRowSelectedProps = [
            mt
        ], e.getToggleAllRowsSelectedProps = [
            ht
        ], e.getToggleAllPageRowsSelectedProps = [
            yt
        ], e.stateReducers.push(wt), e.useInstance.push(Rt), e.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e, t) {
        var n = t.instance, o = t.row, r = n.manualRowSelectedKey, i = void 0 === r ? "isSelected" : r;
        return [
            e,
            {
                onChange: function(e) {
                    o.toggleRowSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: !(!o.original || !o.original[i]) || o.isSelected,
                title: "Toggle Row Selected",
                indeterminate: o.isSomeSelected
            }
        ];
    }, ht = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllRowsSelected,
                title: "Toggle All Rows Selected",
                indeterminate: Boolean(!n.isAllRowsSelected && Object.keys(n.state.selectedRowIds).length)
            }
        ];
    }, yt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                onChange: function(e) {
                    n.toggleAllPageRowsSelected(e.target.checked);
                },
                style: {
                    cursor: "pointer"
                },
                checked: n.isAllPageRowsSelected,
                title: "Toggle All Current Page Rows Selected",
                indeterminate: Boolean(!n.isAllPageRowsSelected && n.page.some(function(e) {
                    var t = e.id;
                    return n.state.selectedRowIds[t];
                }))
            }
        ];
    };
    function wt(e, t, n, o) {
        if (t.type === l.init) return r({
            selectedRowIds: {}
        }, e);
        if (t.type === l.resetSelectedRows) return r({}, e, {
            selectedRowIds: o.initialState.selectedRowIds || {}
        });
        if (t.type === l.toggleAllRowsSelected) {
            var i = t.value, u = o.isAllRowsSelected, s = o.rowsById, a = o.nonGroupedRowsById, c = void 0 === a ? s : a, d = void 0 !== i ? i : !u, f = Object.assign({}, e.selectedRowIds);
            return d ? Object.keys(c).forEach(function(e) {
                f[e] = !0;
            }) : Object.keys(c).forEach(function(e) {
                delete f[e];
            }), r({}, e, {
                selectedRowIds: f
            });
        }
        if (t.type === l.toggleRowSelected) {
            var p = t.id, g = t.value, v = o.rowsById, m = o.selectSubRows, h = void 0 === m || m, y = o.getSubRows, w = e.selectedRowIds[p], R = void 0 !== g ? g : !w;
            if (w === R) return e;
            var b = r({}, e.selectedRowIds);
            return function e(t) {
                var n = v[t];
                if (n && (n.isGrouped || (R ? b[t] = !0 : delete b[t]), h && y(n))) return y(n).forEach(function(t) {
                    return e(t.id);
                });
            }(p), r({}, e, {
                selectedRowIds: b
            });
        }
        if (t.type === l.toggleAllPageRowsSelected) {
            var S = t.value, C = o.page, x = o.rowsById, P = o.selectSubRows, B = void 0 === P || P, E = o.isAllPageRowsSelected, I = o.getSubRows, F = void 0 !== S ? S : !E, G = r({}, e.selectedRowIds);
            return C.forEach(function(e) {
                return function e(t) {
                    var n = x[t];
                    if (n.isGrouped || (F ? G[t] = !0 : delete G[t]), B && I(n)) return I(n).forEach(function(t) {
                        return e(t.id);
                    });
                }(e.id);
            }), r({}, e, {
                selectedRowIds: G
            });
        }
        return e;
    }
    function Rt(e) {
        var n = e.data, o = e.rows, r = e.getHooks, i = e.plugins, u = e.rowsById, s = e.nonGroupedRowsById, a = void 0 === s ? u : s, c = e.autoResetSelectedRows, d = void 0 === c || c, p = e.state.selectedRowIds, g = e.selectSubRows, m = void 0 === g || g, y = e.dispatch, R = e.page, b = e.getSubRows;
        v(i, [
            "useFilters",
            "useGroupBy",
            "useSortBy",
            "useExpanded",
            "usePagination"
        ], "useRowSelect");
        var S = t.useMemo(function() {
            var e = [];
            return o.forEach(function(t) {
                var n = m ? function e(t, n, o) {
                    if (n[t.id]) return !0;
                    var r = o(t);
                    if (r && r.length) {
                        var i = !0, u = !1;
                        return r.forEach(function(t) {
                            u && !i || (e(t, n, o) ? u = !0 : i = !1);
                        }), !!i || !!u && null;
                    }
                    return !1;
                }(t, p, b) : !!p[t.id];
                t.isSelected = !!n, t.isSomeSelected = null === n, n && e.push(t);
            }), e;
        }, [
            o,
            m,
            p,
            b
        ]), C = Boolean(Object.keys(a).length && Object.keys(p).length), x = C;
        C && Object.keys(a).some(function(e) {
            return !p[e];
        }) && (C = !1), C || R && R.length && R.some(function(e) {
            var t = e.id;
            return !p[t];
        }) && (x = !1);
        var P = h(d);
        w(function() {
            P() && y({
                type: l.resetSelectedRows
            });
        }, [
            y,
            n
        ]);
        var B = t.useCallback(function(e) {
            return y({
                type: l.toggleAllRowsSelected,
                value: e
            });
        }, [
            y
        ]), E = t.useCallback(function(e) {
            return y({
                type: l.toggleAllPageRowsSelected,
                value: e
            });
        }, [
            y
        ]), I = t.useCallback(function(e, t) {
            return y({
                type: l.toggleRowSelected,
                id: e,
                value: t
            });
        }, [
            y
        ]), F = h(e), G = f(r().getToggleAllRowsSelectedProps, {
            instance: F()
        }), A = f(r().getToggleAllPageRowsSelectedProps, {
            instance: F()
        });
        Object.assign(e, {
            selectedFlatRows: S,
            isAllRowsSelected: C,
            isAllPageRowsSelected: x,
            toggleRowSelected: I,
            toggleAllRowsSelected: B,
            getToggleAllRowsSelectedProps: G,
            getToggleAllPageRowsSelectedProps: A,
            toggleAllPageRowsSelected: E
        });
    }
    function bt(e, t) {
        var n = t.instance;
        e.toggleRowSelected = function(t) {
            return n.toggleRowSelected(e.id, t);
        }, e.getToggleRowSelectedProps = f(n.getHooks().getToggleRowSelectedProps, {
            instance: n,
            row: e
        });
    }
    var St = function(e) {
        return {};
    }, Ct = function(e) {
        return {};
    };
    l.setRowState = "setRowState", l.setCellState = "setCellState", l.resetRowState = "resetRowState";
    var xt = function(e) {
        e.stateReducers.push(Pt), e.useInstance.push(Bt), e.prepareRow.push(Et);
    };
    function Pt(e, t, n, o) {
        var i = o.initialRowStateAccessor, u = void 0 === i ? St : i, s = o.initialCellStateAccessor, a = void 0 === s ? Ct : s, c = o.rowsById;
        if (t.type === l.init) return r({
            rowState: {}
        }, e);
        if (t.type === l.resetRowState) return r({}, e, {
            rowState: o.initialState.rowState || {}
        });
        if (t.type === l.setRowState) {
            var d, f = t.rowId, p = t.value, g = void 0 !== e.rowState[f] ? e.rowState[f] : u(c[f]);
            return r({}, e, {
                rowState: r({}, e.rowState, (d = {}, d[f] = m(p, g), d))
            });
        }
        if (t.type === l.setCellState) {
            var v, h, y, w, R, b = t.rowId, S = t.columnId, C = t.value, x = void 0 !== e.rowState[b] ? e.rowState[b] : u(c[b]), P = void 0 !== (null == x ? void 0 : null == (v = x.cellState) ? void 0 : v[S]) ? x.cellState[S] : a(null == (h = c[b]) ? void 0 : null == (y = h.cells) ? void 0 : y.find(function(e) {
                return e.column.id === S;
            }));
            return r({}, e, {
                rowState: r({}, e.rowState, (R = {}, R[b] = r({}, x, {
                    cellState: r({}, x.cellState || {}, (w = {}, w[S] = m(C, P), w))
                }), R))
            });
        }
    }
    function Bt(e) {
        var n = e.autoResetRowState, o = void 0 === n || n, r = e.data, i = e.dispatch, u = t.useCallback(function(e, t) {
            return i({
                type: l.setRowState,
                rowId: e,
                value: t
            });
        }, [
            i
        ]), s = t.useCallback(function(e, t, n) {
            return i({
                type: l.setCellState,
                rowId: e,
                columnId: t,
                value: n
            });
        }, [
            i
        ]), a = h(o);
        w(function() {
            a() && i({
                type: l.resetRowState
            });
        }, [
            r
        ]), Object.assign(e, {
            setRowState: u,
            setCellState: s
        });
    }
    function Et(e, t) {
        var n = t.instance, o = n.initialRowStateAccessor, r = void 0 === o ? St : o, i = n.initialCellStateAccessor, u = void 0 === i ? Ct : i, l = n.state.rowState;
        e && (e.state = void 0 !== l[e.id] ? l[e.id] : r(e), e.setState = function(t) {
            return n.setRowState(e.id, t);
        }, e.cells.forEach(function(t) {
            e.state.cellState || (e.state.cellState = {}), t.state = void 0 !== e.state.cellState[t.column.id] ? e.state.cellState[t.column.id] : u(t), t.setState = function(o) {
                return n.setCellState(e.id, t.column.id, o);
            };
        }));
    }
    xt.pluginName = "useRowState", l.resetColumnOrder = "resetColumnOrder", l.setColumnOrder = "setColumnOrder";
    var It = function(e) {
        e.stateReducers.push(Ft), e.visibleColumnsDeps.push(function(e, t) {
            var n = t.instance;
            return [].concat(e, [
                n.state.columnOrder
            ]);
        }), e.visibleColumns.push(Gt), e.useInstance.push(At);
    };
    function Ft(e, t, n, o) {
        return t.type === l.init ? r({
            columnOrder: []
        }, e) : t.type === l.resetColumnOrder ? r({}, e, {
            columnOrder: o.initialState.columnOrder || []
        }) : t.type === l.setColumnOrder ? r({}, e, {
            columnOrder: m(t.columnOrder, e.columnOrder)
        }) : void 0;
    }
    function Gt(e, t) {
        var n = t.instance.state.columnOrder;
        if (!n || !n.length) return e;
        for(var o = [].concat(n), r = [].concat(e), i = [], u = function() {
            var e = o.shift(), t = r.findIndex(function(t) {
                return t.id === e;
            });
            t > -1 && i.push(r.splice(t, 1)[0]);
        }; r.length && o.length;)u();
        return [].concat(i, r);
    }
    function At(e) {
        var n = e.dispatch;
        e.setColumnOrder = t.useCallback(function(e) {
            return n({
                type: l.setColumnOrder,
                columnOrder: e
            });
        }, [
            n
        ]);
    }
    It.pluginName = "useColumnOrder", c.canResize = !0, l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize";
    var kt = function(e) {
        e.getResizerProps = [
            Ht
        ], e.getHeaderProps.push({
            style: {
                position: "relative"
            }
        }), e.stateReducers.push(Wt), e.useInstance.push(Tt), e.useInstanceBeforeDimensions.push(zt);
    }, Ht = function(e, t) {
        var n = t.instance, o = t.header, r = n.dispatch, i = function(e, t) {
            var n = !1;
            if ("touchstart" === e.type) {
                if (e.touches && e.touches.length > 1) return;
                n = !0;
            }
            var o, i, u = (function(e) {
                var t = [];
                return function e(n) {
                    n.columns && n.columns.length && n.columns.map(e);
                    t.push(n);
                }(e), t;
            })(t).map(function(e) {
                return [
                    e.id,
                    e.totalWidth
                ];
            }), s = n ? Math.round(e.touches[0].clientX) : e.clientX, a = function() {
                window.cancelAnimationFrame(o), o = null, r({
                    type: l.columnDoneResizing
                });
            }, c = function() {
                window.cancelAnimationFrame(o), o = null, r({
                    type: l.columnResizing,
                    clientX: i
                });
            }, d = function(e) {
                i = e, o || (o = window.requestAnimationFrame(c));
            }, f = {
                mouse: {
                    moveEvent: "mousemove",
                    moveHandler: function(e) {
                        return d(e.clientX);
                    },
                    upEvent: "mouseup",
                    upHandler: function(e) {
                        document.removeEventListener("mousemove", f.mouse.moveHandler), document.removeEventListener("mouseup", f.mouse.upHandler), a();
                    }
                },
                touch: {
                    moveEvent: "touchmove",
                    moveHandler: function(e) {
                        return e.cancelable && (e.preventDefault(), e.stopPropagation()), d(e.touches[0].clientX), !1;
                    },
                    upEvent: "touchend",
                    upHandler: function(e) {
                        document.removeEventListener(f.touch.moveEvent, f.touch.moveHandler), document.removeEventListener(f.touch.upEvent, f.touch.moveHandler), a();
                    }
                }
            }, p = n ? f.touch : f.mouse, g = !!function() {
                if ("boolean" == typeof z) return z;
                var e = !1;
                try {
                    var t = {
                        get passive () {
                            return e = !0, !1;
                        }
                    };
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (t) {
                    e = !1;
                }
                return z = e;
            }() && {
                passive: !1
            };
            document.addEventListener(p.moveEvent, p.moveHandler, g), document.addEventListener(p.upEvent, p.upHandler, g), r({
                type: l.columnStartResizing,
                columnId: t.id,
                columnWidth: t.totalWidth,
                headerIdWidths: u,
                clientX: s
            });
        };
        return [
            e,
            {
                onMouseDown: function(e) {
                    return e.persist() || i(e, o);
                },
                onTouchStart: function(e) {
                    return e.persist() || i(e, o);
                },
                style: {
                    cursor: "col-resize"
                },
                draggable: !1,
                role: "separator"
            }
        ];
    };
    function Wt(e, t) {
        if (t.type === l.init) return r({
            columnResizing: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            columnResizing: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var n = t.clientX, o = t.columnId, i = t.columnWidth, u = t.headerIdWidths;
            return r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    startX: n,
                    headerIdWidths: u,
                    columnWidth: i,
                    isResizingColumn: o
                })
            });
        }
        if (t.type === l.columnResizing) {
            var s = t.clientX, a = e.columnResizing, c = a.startX, d = a.columnWidth, f = a.headerIdWidths, p = (s - c) / d, g = {};
            return (void 0 === f ? [] : f).forEach(function(e) {
                var t = e[0], n = e[1];
                g[t] = Math.max(n + n * p, 0);
            }), r({}, e, {
                columnResizing: r({}, e.columnResizing, {
                    columnWidths: r({}, e.columnResizing.columnWidths, {}, g)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            columnResizing: r({}, e.columnResizing, {
                startX: null,
                isResizingColumn: null
            })
        }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var zt = function(e) {
        var t = e.flatHeaders, n = e.disableResizing, o = e.getHooks, r = e.state.columnResizing, i = h(e);
        t.forEach(function(e) {
            var t = I(!0 !== e.disableResizing && void 0, !0 !== n && void 0, !0);
            e.canResize = t, e.width = r.columnWidths[e.id] || e.originalWidth || e.width, e.isResizing = r.isResizingColumn === e.id, t && (e.getResizerProps = f(o().getResizerProps, {
                instance: i(),
                header: e
            }));
        });
    };
    function Tt(e) {
        var n = e.plugins, o = e.dispatch, r = e.autoResetResize, i = void 0 === r || r, u = e.columns;
        v(n, [
            "useAbsoluteLayout"
        ], "useResizeColumns");
        var s = h(i);
        w(function() {
            s() && o({
                type: l.resetResize
            });
        }, [
            u
        ]);
        var a = t.useCallback(function() {
            return o({
                type: l.resetResize
            });
        }, [
            o
        ]);
        Object.assign(e, {
            resetResizing: a
        });
    }
    var Ot = {
        position: "absolute",
        top: 0
    }, Mt = function(e) {
        e.getTableBodyProps.push(jt), e.getRowProps.push(jt), e.getHeaderGroupProps.push(jt), e.getFooterGroupProps.push(jt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.column.totalLeft + "px",
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Ot, {
                        left: n.totalLeft + "px",
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e, t) {
        return [
            e,
            {
                style: {
                    position: "relative",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Lt = {
        display: "inline-block",
        boxSizing: "border-box"
    }, Nt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    width: t.instance.totalColumnsWidth + "px"
                }
            }
        ];
    }, Dt = function(e) {
        e.getRowProps.push(Nt), e.getHeaderGroupProps.push(Nt), e.getFooterGroupProps.push(Nt), e.getHeaderProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        }), e.getCellProps.push(function(e, t) {
            var n = t.cell;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.column.totalWidth + "px"
                    })
                }
            ];
        }), e.getFooterProps.push(function(e, t) {
            var n = t.column;
            return [
                e,
                {
                    style: r({}, Lt, {
                        width: n.totalWidth + "px"
                    })
                }
            ];
        });
    };
    function Vt(e) {
        e.getTableProps.push(_t), e.getRowProps.push(Xt), e.getHeaderGroupProps.push(Xt), e.getFooterGroupProps.push(Xt), e.getHeaderProps.push(qt), e.getCellProps.push(Kt), e.getFooterProps.push(Ut);
    }
    Dt.pluginName = "useBlockLayout", Vt.pluginName = "useFlexLayout";
    var _t = function(e, t) {
        return [
            e,
            {
                style: {
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, Xt = function(e, t) {
        return [
            e,
            {
                style: {
                    display: "flex",
                    flex: "1 0 auto",
                    minWidth: t.instance.totalColumnsMinWidth + "px"
                }
            }
        ];
    }, qt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    }, Kt = function(e, t) {
        var n = t.cell;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.column.totalFlexWidth + " 0 auto",
                    minWidth: n.column.totalMinWidth + "px",
                    width: n.column.totalWidth + "px"
                }
            }
        ];
    }, Ut = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                style: {
                    boxSizing: "border-box",
                    flex: n.totalFlexWidth ? n.totalFlexWidth + " 0 auto" : void 0,
                    minWidth: n.totalMinWidth + "px",
                    width: n.totalWidth + "px"
                }
            }
        ];
    };
    function $t(e) {
        e.stateReducers.push(Zt), e.getTableProps.push(Jt), e.getHeaderProps.push(Yt), e.getRowProps.push(Qt);
    }
    l.columnStartResizing = "columnStartResizing", l.columnResizing = "columnResizing", l.columnDoneResizing = "columnDoneResizing", l.resetResize = "resetResize", $t.pluginName = "useGridLayout";
    var Jt = function(e, t) {
        var n = t.instance;
        return [
            e,
            {
                style: {
                    display: "grid",
                    gridTemplateColumns: n.visibleColumns.map(function(e) {
                        var t;
                        return n.state.gridLayout.columnWidths[e.id] ? n.state.gridLayout.columnWidths[e.id] + "px" : (null == (t = n.state.columnResizing) ? void 0 : t.isResizingColumn) ? n.state.gridLayout.startWidths[e.id] + "px" : "number" == typeof e.width ? e.width + "px" : e.width;
                    }).join(" ")
                }
            }
        ];
    }, Yt = function(e, t) {
        var n = t.column;
        return [
            e,
            {
                id: "header-cell-" + n.id,
                style: {
                    position: "sticky",
                    gridColumn: "span " + n.totalVisibleHeaderCount
                }
            }
        ];
    }, Qt = function(e, t) {
        var n = t.row;
        return n.isExpanded ? [
            e,
            {
                style: {
                    gridColumn: "1 / " + (n.cells.length + 1)
                }
            }
        ] : [
            e,
            {}
        ];
    };
    function Zt(e, t, n, o) {
        if (t.type === l.init) return r({
            gridLayout: {
                columnWidths: {}
            }
        }, e);
        if (t.type === l.resetResize) return r({}, e, {
            gridLayout: {
                columnWidths: {}
            }
        });
        if (t.type === l.columnStartResizing) {
            var i = t.columnId, u = t.headerIdWidths, s = en(i);
            if (void 0 !== s) {
                var a = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = en(t.id), n));
                }, {}), c = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = t.minWidth, n));
                }, {}), d = o.visibleColumns.reduce(function(e, t) {
                    var n;
                    return r({}, e, ((n = {})[t.id] = t.maxWidth, n));
                }, {}), f = u.map(function(e) {
                    var t = e[0];
                    return [
                        t,
                        en(t)
                    ];
                });
                return r({}, e, {
                    gridLayout: r({}, e.gridLayout, {
                        startWidths: a,
                        minWidths: c,
                        maxWidths: d,
                        headerIdGridWidths: f,
                        columnWidth: s
                    })
                });
            }
            return e;
        }
        if (t.type === l.columnResizing) {
            var p = t.clientX, g = e.columnResizing.startX, v = e.gridLayout, m = v.columnWidth, h = v.minWidths, y = v.maxWidths, w = v.headerIdGridWidths, R = (p - g) / m, b = {};
            return (void 0 === w ? [] : w).forEach(function(e) {
                var t = e[0], n = e[1];
                b[t] = Math.min(Math.max(h[t], n + n * R), y[t]);
            }), r({}, e, {
                gridLayout: r({}, e.gridLayout, {
                    columnWidths: r({}, e.gridLayout.columnWidths, {}, b)
                })
            });
        }
        return t.type === l.columnDoneResizing ? r({}, e, {
            gridLayout: r({}, e.gridLayout, {
                startWidths: {},
                minWidths: {},
                maxWidths: {}
            })
        }) : void 0;
    }
    function en(e) {
        var t, n = null == (t = document.getElementById("header-cell-" + e)) ? void 0 : t.offsetWidth;
        if (void 0 !== n) return n;
    }
    e._UNSTABLE_usePivotColumns = nt, e.actions = l, e.defaultColumn = c, e.defaultGroupByFn = De, e.defaultOrderByFn = Qe, e.defaultRenderer = s, e.emptyRenderer = a, e.ensurePluginOrder = v, e.flexRender = b, e.functionalUpdate = m, e.loopHooks = g, e.makePropGetter = f, e.makeRenderer = R, e.reduceHooks = p, e.safeUseLayoutEffect = y, e.useAbsoluteLayout = Mt, e.useAsyncDebounce = function(e, n) {
        void 0 === n && (n = 0);
        var r = t.useRef({}), i = h(e), u = h(n);
        return t.useCallback(function() {
            var e = o(regeneratorRuntime.mark(function e() {
                var t, n, l, s = arguments;
                return regeneratorRuntime.wrap(function(e) {
                    for(;;)switch(e.prev = e.next){
                        case 0:
                            for(t = s.length, n = new Array(t), l = 0; l < t; l++)n[l] = s[l];
                            return r.current.promise || (r.current.promise = new Promise(function(_e1, t) {
                                r.current.resolve = _e1, r.current.reject = t;
                            })), r.current.timeout && clearTimeout(r.current.timeout), r.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e() {
                                return regeneratorRuntime.wrap(function(_e1) {
                                    for(;;)switch(_e1.prev = _e1.next){
                                        case 0:
                                            return delete r.current.timeout, _e1.prev = 1, _e1.t0 = r.current, _e1.next = 5, i().apply(void 0, n);
                                        case 5:
                                            _e1.t1 = _e1.sent, _e1.t0.resolve.call(_e1.t0, _e1.t1), _e1.next = 12;
                                            break;
                                        case 9:
                                            _e1.prev = 9, _e1.t2 = _e1.catch(1), r.current.reject(_e1.t2);
                                        case 12:
                                            return _e1.prev = 12, delete r.current.promise, _e1.finish(12);
                                        case 15:
                                        case "end":
                                            return _e1.stop();
                                    }
                                }, e, null, [
                                    [
                                        1,
                                        9,
                                        12,
                                        15
                                    ]
                                ]);
                            })), u()), e.abrupt("return", r.current.promise);
                        case 5:
                        case "end":
                            return e.stop();
                    }
                }, e);
            }));
            return function() {
                return e.apply(this, arguments);
            };
        }(), [
            i,
            u
        ]);
    }, e.useBlockLayout = Dt, e.useColumnOrder = It, e.useExpanded = se, e.useFilters = Pe, e.useFlexLayout = Vt, e.useGetLatest = h, e.useGlobalFilter = Ie, e.useGridLayout = $t, e.useGroupBy = ze, e.useMountedLayoutEffect = w, e.usePagination = Ze, e.useResizeColumns = kt, e.useRowSelect = vt, e.useRowState = xt, e.useSortBy = Ue, e.useTable = function(e) {
        for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)o[i - 1] = arguments[i];
        e = ie(e), o = [
            K
        ].concat(o);
        var u = t.useRef({}), s = h(u.current);
        Object.assign(s(), r({}, e, {
            plugins: o,
            hooks: q()
        })), o.filter(Boolean).forEach(function(e) {
            e(s().hooks);
        });
        var a = h(s().hooks);
        s().getHooks = a, delete s().hooks, Object.assign(s(), p(a().useOptions, ie(e)));
        var c = s(), d = c.data, v = c.columns, m = c.initialState, y = c.defaultColumn, w = c.getSubRows, b = c.getRowId, E = c.stateReducer, I = c.useControlledState, F = h(E), G = t.useCallback(function(e, t) {
            if (!t.type) throw console.info({
                action: t
            }), new Error("Unknown Action \uD83D\uDC46");
            return [].concat(a().stateReducers, Array.isArray(F()) ? F() : [
                F()
            ]).reduce(function(n, o) {
                return o(n, t, e, s()) || n;
            }, e);
        }, [
            a,
            F,
            s
        ]), A = t.useReducer(G, void 0, function() {
            return G(m, {
                type: l.init
            });
        }), k = A[0], H = A[1], W = p([].concat(a().useControlledState, [
            I
        ]), k, {
            instance: s()
        });
        Object.assign(s(), {
            state: W,
            dispatch: H
        });
        var z = t.useMemo(function() {
            return S(p(a().columns, v, {
                instance: s()
            }));
        }, [
            a,
            s,
            v
        ].concat(p(a().columnsDeps, [], {
            instance: s()
        })));
        s().columns = z;
        var T = t.useMemo(function() {
            return p(a().allColumns, C(z), {
                instance: s()
            }).map(x);
        }, [
            z,
            a,
            s
        ].concat(p(a().allColumnsDeps, [], {
            instance: s()
        })));
        s().allColumns = T;
        var O = t.useMemo(function() {
            for(var e = [], t = [], n = {}, o = [].concat(T); o.length;){
                var r = o.shift();
                le({
                    data: d,
                    rows: e,
                    flatRows: t,
                    rowsById: n,
                    column: r,
                    getRowId: b,
                    getSubRows: w,
                    accessValueHooks: a().accessValue,
                    getInstance: s
                });
            }
            return [
                e,
                t,
                n
            ];
        }, [
            T,
            d,
            b,
            w,
            a,
            s
        ]), M = O[0], j = O[1], L = O[2];
        Object.assign(s(), {
            rows: M,
            initialRows: [].concat(M),
            flatRows: j,
            rowsById: L
        }), g(a().useInstanceAfterData, s());
        var N = t.useMemo(function() {
            return p(a().visibleColumns, T, {
                instance: s()
            }).map(function(e) {
                return P(e, y);
            });
        }, [
            a,
            T,
            s,
            y
        ].concat(p(a().visibleColumnsDeps, [], {
            instance: s()
        })));
        T = t.useMemo(function() {
            var e = [].concat(N);
            return T.forEach(function(t) {
                e.find(function(e) {
                    return e.id === t.id;
                }) || e.push(t);
            }), e;
        }, [
            T,
            N
        ]), s().allColumns = T;
        var D = t.useMemo(function() {
            return p(a().headerGroups, B(N, y), s());
        }, [
            a,
            N,
            y,
            s
        ].concat(p(a().headerGroupsDeps, [], {
            instance: s()
        })));
        s().headerGroups = D;
        var V = t.useMemo(function() {
            return D.length ? D[0].headers : [];
        }, [
            D
        ]);
        s().headers = V, s().flatHeaders = D.reduce(function(e, t) {
            return [].concat(e, t.headers);
        }, []), g(a().useInstanceBeforeDimensions, s());
        var _ = N.filter(function(e) {
            return e.isVisible;
        }).map(function(e) {
            return e.id;
        }).sort().join("_");
        N = t.useMemo(function() {
            return N.filter(function(e) {
                return e.isVisible;
            });
        }, [
            N,
            _
        ]), s().visibleColumns = N;
        var X = ue(V), U = X[0], $ = X[1], J = X[2];
        return s().totalColumnsMinWidth = U, s().totalColumnsWidth = $, s().totalColumnsMaxWidth = J, g(a().useInstance, s()), [].concat(s().flatHeaders, s().allColumns).forEach(function(e) {
            e.render = R(s(), e), e.getHeaderProps = f(a().getHeaderProps, {
                instance: s(),
                column: e
            }), e.getFooterProps = f(a().getFooterProps, {
                instance: s(),
                column: e
            });
        }), s().headerGroups = t.useMemo(function() {
            return D.filter(function(e, t) {
                return e.headers = e.headers.filter(function(e) {
                    return e.headers ? function e(t) {
                        return t.filter(function(t) {
                            return t.headers ? e(t.headers) : t.isVisible;
                        }).length;
                    }(e.headers) : e.isVisible;
                }), !!e.headers.length && (e.getHeaderGroupProps = f(a().getHeaderGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), e.getFooterGroupProps = f(a().getFooterGroupProps, {
                    instance: s(),
                    headerGroup: e,
                    index: t
                }), !0);
            });
        }, [
            D,
            s,
            a
        ]), s().footerGroups = [].concat(s().headerGroups).reverse(), s().prepareRow = t.useCallback(function(e) {
            e.getRowProps = f(a().getRowProps, {
                instance: s(),
                row: e
            }), e.allCells = T.map(function(t) {
                var n = e.values[t.id], o = {
                    column: t,
                    row: e,
                    value: n
                };
                return o.getCellProps = f(a().getCellProps, {
                    instance: s(),
                    cell: o
                }), o.render = R(s(), t, {
                    row: e,
                    cell: o,
                    value: n
                }), o;
            }), e.cells = N.map(function(t) {
                return e.allCells.find(function(e) {
                    return e.column.id === t.id;
                });
            }), g(a().prepareRow, e, {
                instance: s()
            });
        }, [
            a,
            s,
            T,
            N
        ]), s().getTableProps = f(a().getTableProps, {
            instance: s()
        }), s().getTableBodyProps = f(a().getTableBodyProps, {
            instance: s()
        }), g(a().useFinalInstance, s()), s();
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("31tXu", function(module, exports) {

$parcel$export(module.exports, "useFormikContext", function () { return useFormikContext; });
$parcel$export(module.exports, "Formik", function () { return Formik; });
$parcel$export(module.exports, "Field", function () { return Field; });
$parcel$export(module.exports, "Form", function () { return Form; });
$parcel$export(module.exports, "FieldArray", function () { return FieldArray; });

var $a0HRr = parcelRequire("a0HRr");

var $fk1rf = parcelRequire("fk1rf");

var $3ZYaX = parcelRequire("3ZYaX");

var $e5cN7 = parcelRequire("e5cN7");

var $bVcmS = parcelRequire("bVcmS");

var $5mNmV = parcelRequire("5mNmV");

var $hnuZ8 = parcelRequire("hnuZ8");

var $6fGvd = parcelRequire("6fGvd");

var $frVnn = parcelRequire("frVnn");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var FormikContext = /*#__PURE__*/ (0, $3ZYaX.createContext)(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
    var formik = (0, $3ZYaX.useContext)(FormikContext);
    !!!formik && (0, $bVcmS.default)(false);
    return formik;
}
/** @private is the value an empty array? */ var isEmptyArray = function isEmptyArray(value) {
    return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */ var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
};
/** @private is the given object an Object? */ var isObject = function isObject(obj) {
    return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */ var isInteger = function isInteger(obj) {
    return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */ var isString = function isString(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */ // eslint-disable-next-line no-self-compare
var isNaN$1 = function isNaN1(obj) {
    return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */ var isEmptyChildren = function isEmptyChildren(children) {
    return (0, $3ZYaX.Children).count(children) === 0;
};
/** @private is the given object/value a promise? */ var isPromise = function isPromise(value) {
    return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */ var isInputEvent = function isInputEvent(value) {
    return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */ function getActiveElement(doc) {
    doc = doc || (typeof document !== 'undefined' ? document : undefined);
    if (typeof doc === 'undefined') return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
/**
 * Deeply get a value from an object via its path.
 */ function getIn(obj, key, def, p) {
    if (p === void 0) p = 0;
    var path = (0, $hnuZ8.default)(key);
    while(obj && p < path.length)obj = obj[path[p++]];
     // check if path is not in the end
    if (p !== path.length && !obj) return def;
    return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */ function setIn(obj, path, value) {
    var res = (0, $5mNmV.default)(obj); // this keeps inheritance when obj is a class
    var resVal = res;
    var i = 0;
    var pathArray = (0, $hnuZ8.default)(path);
    for(; i < pathArray.length - 1; i++){
        var currentPath = pathArray[i];
        var currentObj = getIn(obj, pathArray.slice(0, i + 1));
        if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) resVal = resVal[currentPath] = (0, $5mNmV.default)(currentObj);
        else {
            var nextPath = pathArray[i + 1];
            resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
        }
    } // Return original object if new value is the same as current
    if ((i === 0 ? obj : resVal)[pathArray[i]] === value) return obj;
    if (value === undefined) delete resVal[pathArray[i]];
    else resVal[pathArray[i]] = value;
     // If the path array has a single element, the loop did not run.
    // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.
    if (i === 0 && value === undefined) delete res[pathArray[i]];
    return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */ function setNestedObjectValues(object, value, visited, response) {
    if (visited === void 0) visited = new WeakMap();
    if (response === void 0) response = {};
    for(var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++){
        var k = _Object$keys[_i];
        var val = object[k];
        if (isObject(val)) {
            if (!visited.get(val)) {
                visited.set(val, true); // In order to keep array values consistent for both dot path  and
                // bracket syntax, we need to check if this is an array so that
                // this will output  { friends: [true] } and not { friends: { "0": true } }
                response[k] = Array.isArray(val) ? [] : {};
                setNestedObjectValues(val, value, visited, response[k]);
            }
        } else response[k] = value;
    }
    return response;
}
function formikReducer(state, msg) {
    switch(msg.type){
        case 'SET_VALUES':
            return _extends({}, state, {
                values: msg.payload
            });
        case 'SET_TOUCHED':
            return _extends({}, state, {
                touched: msg.payload
            });
        case 'SET_ERRORS':
            if ((0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(state.errors, msg.payload)) return state;
            return _extends({}, state, {
                errors: msg.payload
            });
        case 'SET_STATUS':
            return _extends({}, state, {
                status: msg.payload
            });
        case 'SET_ISSUBMITTING':
            return _extends({}, state, {
                isSubmitting: msg.payload
            });
        case 'SET_ISVALIDATING':
            return _extends({}, state, {
                isValidating: msg.payload
            });
        case 'SET_FIELD_VALUE':
            return _extends({}, state, {
                values: setIn(state.values, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_TOUCHED':
            return _extends({}, state, {
                touched: setIn(state.touched, msg.payload.field, msg.payload.value)
            });
        case 'SET_FIELD_ERROR':
            return _extends({}, state, {
                errors: setIn(state.errors, msg.payload.field, msg.payload.value)
            });
        case 'RESET_FORM':
            return _extends({}, state, msg.payload);
        case 'SET_FORMIK_STATE':
            return msg.payload(state);
        case 'SUBMIT_ATTEMPT':
            return _extends({}, state, {
                touched: setNestedObjectValues(state.values, true),
                isSubmitting: true,
                submitCount: state.submitCount + 1
            });
        case 'SUBMIT_FAILURE':
            return _extends({}, state, {
                isSubmitting: false
            });
        case 'SUBMIT_SUCCESS':
            return _extends({}, state, {
                isSubmitting: false
            });
        default:
            return state;
    }
} // Initial empty states // objects
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
    var _ref$validateOnChange = _ref.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref.isInitialValid, _ref$enableReinitiali = _ref.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref.onSubmit, rest = _objectWithoutPropertiesLoose(_ref, [
        "validateOnChange",
        "validateOnBlur",
        "validateOnMount",
        "isInitialValid",
        "enableReinitialize",
        "onSubmit"
    ]);
    var props = _extends({
        validateOnChange: validateOnChange,
        validateOnBlur: validateOnBlur,
        validateOnMount: validateOnMount,
        onSubmit: onSubmit
    }, rest);
    var initialValues = (0, $3ZYaX.useRef)(props.initialValues);
    var initialErrors = (0, $3ZYaX.useRef)(props.initialErrors || emptyErrors);
    var initialTouched = (0, $3ZYaX.useRef)(props.initialTouched || emptyTouched);
    var initialStatus = (0, $3ZYaX.useRef)(props.initialStatus);
    var isMounted = (0, $3ZYaX.useRef)(false);
    var fieldRegistry = (0, $3ZYaX.useRef)({});
    (0, $3ZYaX.useEffect)(function() {
        isMounted.current = true;
        return function() {
            isMounted.current = false;
        };
    }, []);
    var _React$useState = (0, $3ZYaX.useState)(0), setIteration = _React$useState[1];
    var stateRef = (0, $3ZYaX.useRef)({
        values: props.initialValues,
        errors: props.initialErrors || emptyErrors,
        touched: props.initialTouched || emptyTouched,
        status: props.initialStatus,
        isSubmitting: false,
        isValidating: false,
        submitCount: 0
    });
    var state = stateRef.current;
    var dispatch = (0, $3ZYaX.useCallback)(function(action) {
        var prev = stateRef.current;
        stateRef.current = formikReducer(prev, action); // force rerender
        if (prev !== stateRef.current) setIteration(function(x) {
            return x + 1;
        });
    }, []);
    var runValidateHandler = (0, $3ZYaX.useCallback)(function(values, field) {
        return new Promise(function(resolve, reject) {
            var maybePromisedErrors = props.validate(values, field);
            if (maybePromisedErrors == null) // use loose null check here on purpose
            resolve(emptyErrors);
            else if (isPromise(maybePromisedErrors)) maybePromisedErrors.then(function(errors) {
                resolve(errors || emptyErrors);
            }, function(actualException) {
                reject(actualException);
            });
            else resolve(maybePromisedErrors);
        });
    }, [
        props.validate
    ]);
    /**
   * Run validation against a Yup schema and optionally run a function if successful
   */ var runValidationSchema = (0, $3ZYaX.useCallback)(function(values, field) {
        var validationSchema = props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
        var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
        return new Promise(function(resolve, reject) {
            promise.then(function() {
                resolve(emptyErrors);
            }, function(err) {
                // Yup will throw a validation error if validation fails. We catch those and
                // resolve them into Formik errors. We can sniff if something is a Yup error
                // by checking error.name.
                // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
                if (err.name === 'ValidationError') resolve(yupToFormErrors(err));
                else reject(err);
            });
        });
    }, [
        props.validationSchema
    ]);
    var runSingleFieldLevelValidation = (0, $3ZYaX.useCallback)(function(field, value) {
        return new Promise(function(resolve) {
            return resolve(fieldRegistry.current[field].validate(value));
        });
    }, []);
    var runFieldLevelValidations = (0, $3ZYaX.useCallback)(function(values) {
        var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
            return isFunction(fieldRegistry.current[f].validate);
        }); // Construct an array with all of the field validation functions
        var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
            return runSingleFieldLevelValidation(f, getIn(values, f));
        }) : [
            Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')
        ]; // use special case ;)
        return Promise.all(fieldValidations).then(function(fieldErrorsList) {
            return fieldErrorsList.reduce(function(prev, curr, index) {
                if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') return prev;
                if (curr) prev = setIn(prev, fieldKeysWithValidation[index], curr);
                return prev;
            }, {});
        });
    }, [
        runSingleFieldLevelValidation
    ]); // Run all validations and return the result
    var runAllValidations = (0, $3ZYaX.useCallback)(function(values) {
        return Promise.all([
            runFieldLevelValidations(values),
            props.validationSchema ? runValidationSchema(values) : {},
            props.validate ? runValidateHandler(values) : {}
        ]).then(function(_ref2) {
            var fieldErrors = _ref2[0], schemaErrors = _ref2[1], validateErrors = _ref2[2];
            var combinedErrors = (0, $a0HRr.default).all([
                fieldErrors,
                schemaErrors,
                validateErrors
            ], {
                arrayMerge: arrayMerge
            });
            return combinedErrors;
        });
    }, [
        props.validate,
        props.validationSchema,
        runFieldLevelValidations,
        runValidateHandler,
        runValidationSchema
    ]); // Run all validations methods and update state accordingly
    var validateFormWithHighPriority = useEventCallback(function(values) {
        if (values === void 0) values = state.values;
        dispatch({
            type: 'SET_ISVALIDATING',
            payload: true
        });
        return runAllValidations(values).then(function(combinedErrors) {
            if (!!isMounted.current) {
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
                dispatch({
                    type: 'SET_ERRORS',
                    payload: combinedErrors
                });
            }
            return combinedErrors;
        });
    });
    (0, $3ZYaX.useEffect)(function() {
        if (validateOnMount && isMounted.current === true && (0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialValues.current, props.initialValues)) validateFormWithHighPriority(initialValues.current);
    }, [
        validateOnMount,
        validateFormWithHighPriority
    ]);
    var resetForm = (0, $3ZYaX.useCallback)(function(nextState) {
        var values = nextState && nextState.values ? nextState.values : initialValues.current;
        var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
        var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
        var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
        initialValues.current = values;
        initialErrors.current = errors;
        initialTouched.current = touched;
        initialStatus.current = status;
        var dispatchFn = function dispatchFn() {
            dispatch({
                type: 'RESET_FORM',
                payload: {
                    isSubmitting: !!nextState && !!nextState.isSubmitting,
                    errors: errors,
                    touched: touched,
                    status: status,
                    values: values,
                    isValidating: !!nextState && !!nextState.isValidating,
                    submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
                }
            });
        };
        if (props.onReset) {
            var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);
            if (isPromise(maybePromisedOnReset)) maybePromisedOnReset.then(dispatchFn);
            else dispatchFn();
        } else dispatchFn();
    }, [
        props.initialErrors,
        props.initialStatus,
        props.initialTouched,
        props.onReset
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialValues.current, props.initialValues)) {
            if (enableReinitialize) {
                initialValues.current = props.initialValues;
                resetForm();
                if (validateOnMount) validateFormWithHighPriority(initialValues.current);
            }
        }
    }, [
        enableReinitialize,
        props.initialValues,
        resetForm,
        validateOnMount,
        validateFormWithHighPriority
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialErrors.current, props.initialErrors)) {
            initialErrors.current = props.initialErrors || emptyErrors;
            dispatch({
                type: 'SET_ERRORS',
                payload: props.initialErrors || emptyErrors
            });
        }
    }, [
        enableReinitialize,
        props.initialErrors
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialTouched.current, props.initialTouched)) {
            initialTouched.current = props.initialTouched || emptyTouched;
            dispatch({
                type: 'SET_TOUCHED',
                payload: props.initialTouched || emptyTouched
            });
        }
    }, [
        enableReinitialize,
        props.initialTouched
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (enableReinitialize && isMounted.current === true && !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialStatus.current, props.initialStatus)) {
            initialStatus.current = props.initialStatus;
            dispatch({
                type: 'SET_STATUS',
                payload: props.initialStatus
            });
        }
    }, [
        enableReinitialize,
        props.initialStatus,
        props.initialTouched
    ]);
    var validateField = useEventCallback(function(name) {
        // This will efficiently validate a single field by avoiding state
        // changes if the validation function is synchronous. It's different from
        // what is called when using validateForm.
        if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
            var value = getIn(state.values, name);
            var maybePromise = fieldRegistry.current[name].validate(value);
            if (isPromise(maybePromise)) {
                // Only flip isValidating if the function is async.
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: true
                });
                return maybePromise.then(function(x) {
                    return x;
                }).then(function(error) {
                    dispatch({
                        type: 'SET_FIELD_ERROR',
                        payload: {
                            field: name,
                            value: error
                        }
                    });
                    dispatch({
                        type: 'SET_ISVALIDATING',
                        payload: false
                    });
                });
            } else {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: maybePromise
                    }
                });
                return Promise.resolve(maybePromise);
            }
        } else if (props.validationSchema) {
            dispatch({
                type: 'SET_ISVALIDATING',
                payload: true
            });
            return runValidationSchema(state.values, name).then(function(x) {
                return x;
            }).then(function(error) {
                dispatch({
                    type: 'SET_FIELD_ERROR',
                    payload: {
                        field: name,
                        value: getIn(error, name)
                    }
                });
                dispatch({
                    type: 'SET_ISVALIDATING',
                    payload: false
                });
            });
        }
        return Promise.resolve();
    });
    var registerField = (0, $3ZYaX.useCallback)(function(name, _ref3) {
        var validate = _ref3.validate;
        fieldRegistry.current[name] = {
            validate: validate
        };
    }, []);
    var unregisterField = (0, $3ZYaX.useCallback)(function(name) {
        delete fieldRegistry.current[name];
    }, []);
    var setTouched = useEventCallback(function(touched, shouldValidate) {
        dispatch({
            type: 'SET_TOUCHED',
            payload: touched
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var setErrors = (0, $3ZYaX.useCallback)(function(errors) {
        dispatch({
            type: 'SET_ERRORS',
            payload: errors
        });
    }, []);
    var setValues = useEventCallback(function(values, shouldValidate) {
        var resolvedValues = isFunction(values) ? values(state.values) : values;
        dispatch({
            type: 'SET_VALUES',
            payload: resolvedValues
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
    });
    var setFieldError = (0, $3ZYaX.useCallback)(function(field, value) {
        dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
                field: field,
                value: value
            }
        });
    }, []);
    var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
        dispatch({
            type: 'SET_FIELD_VALUE',
            payload: {
                field: field,
                value: value
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
        return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
    });
    var executeChange = (0, $3ZYaX.useCallback)(function(eventOrTextValue, maybePath) {
        // By default, assume that the first argument is a string. This allows us to use
        // handleChange with React Native and React Native Web's onChangeText prop which
        // provides just the value of the input.
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
        // so we handle like we would a normal HTML change event.
        if (!isString(eventOrTextValue)) {
            // If we can, persist the event
            // @see https://reactjs.org/docs/events.html#event-pooling
            if (eventOrTextValue.persist) eventOrTextValue.persist();
            var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
            var type = target.type, name = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options = target.options, multiple = target.multiple;
            field = maybePath ? maybePath : name ? name : id;
            val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
             ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
             ? getSelectedValues(options) : value;
        }
        if (field) // Set form fields by name
        setFieldValue(field, val);
    }, [
        setFieldValue,
        state.values
    ]);
    var handleChange = useEventCallback(function(eventOrPath) {
        if (isString(eventOrPath)) return function(event) {
            return executeChange(event, eventOrPath);
        };
        else executeChange(eventOrPath);
    });
    var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
        if (touched === void 0) touched = true;
        dispatch({
            type: 'SET_FIELD_TOUCHED',
            payload: {
                field: field,
                value: touched
            }
        });
        var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
        return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
    });
    var executeBlur = (0, $3ZYaX.useCallback)(function(e, path) {
        if (e.persist) e.persist();
        var _e$target = e.target, name = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
        var field = path ? path : name ? name : id;
        setFieldTouched(field, true);
    }, [
        setFieldTouched
    ]);
    var handleBlur = useEventCallback(function(eventOrString) {
        if (isString(eventOrString)) return function(event) {
            return executeBlur(event, eventOrString);
        };
        else executeBlur(eventOrString);
    });
    var setFormikState = (0, $3ZYaX.useCallback)(function(stateOrCb) {
        if (isFunction(stateOrCb)) dispatch({
            type: 'SET_FORMIK_STATE',
            payload: stateOrCb
        });
        else dispatch({
            type: 'SET_FORMIK_STATE',
            payload: function payload() {
                return stateOrCb;
            }
        });
    }, []);
    var setStatus = (0, $3ZYaX.useCallback)(function(status) {
        dispatch({
            type: 'SET_STATUS',
            payload: status
        });
    }, []);
    var setSubmitting = (0, $3ZYaX.useCallback)(function(isSubmitting) {
        dispatch({
            type: 'SET_ISSUBMITTING',
            payload: isSubmitting
        });
    }, []);
    var submitForm = useEventCallback(function() {
        dispatch({
            type: 'SUBMIT_ATTEMPT'
        });
        return validateFormWithHighPriority().then(function(combinedErrors) {
            // In case an error was thrown and passed to the resolved Promise,
            // `combinedErrors` can be an instance of an Error. We need to check
            // that and abort the submit.
            // If we don't do that, calling `Object.keys(new Error())` yields an
            // empty array, which causes the validation to pass and the form
            // to be submitted.
            var isInstanceOfError = combinedErrors instanceof Error;
            var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
            if (isActuallyValid) {
                // Proceed with submit...
                //
                // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
                // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
                // This would be fine in simple cases, but make it impossible to disable submit
                // buttons where people use callbacks or promises as side effects (which is basically
                // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
                //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
                // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
                // cleanup of isSubmitting on behalf of the consumer.
                var promiseOrUndefined;
                try {
                    promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
                    // via setSubmitting(false)
                    if (promiseOrUndefined === undefined) return;
                } catch (error) {
                    throw error;
                }
                return Promise.resolve(promiseOrUndefined).then(function(result) {
                    if (!!isMounted.current) dispatch({
                        type: 'SUBMIT_SUCCESS'
                    });
                    return result;
                })["catch"](function(_errors) {
                    if (!!isMounted.current) {
                        dispatch({
                            type: 'SUBMIT_FAILURE'
                        }); // This is a legit error rejected by the onSubmit fn
                        // so we don't want to break the promise chain
                        throw _errors;
                    }
                });
            } else if (!!isMounted.current) {
                // ^^^ Make sure Formik is still mounted before updating state
                dispatch({
                    type: 'SUBMIT_FAILURE'
                }); // throw combinedErrors;
                if (isInstanceOfError) throw combinedErrors;
            }
            return;
        });
    });
    var handleSubmit = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
         // Warn if form submission is triggered by a <button> without a
        var activeElement;
        submitForm()["catch"](function(reason) {
            console.warn("Warning: An unhandled error was caught from submitForm()", reason);
        });
    });
    var imperativeMethods = {
        resetForm: resetForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        setErrors: setErrors,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        setFormikState: setFormikState,
        submitForm: submitForm
    };
    var executeSubmit = useEventCallback(function() {
        return onSubmit(state.values, imperativeMethods);
    });
    var handleReset = useEventCallback(function(e) {
        if (e && e.preventDefault && isFunction(e.preventDefault)) e.preventDefault();
        if (e && e.stopPropagation && isFunction(e.stopPropagation)) e.stopPropagation();
        resetForm();
    });
    var getFieldMeta = (0, $3ZYaX.useCallback)(function(name) {
        return {
            value: getIn(state.values, name),
            error: getIn(state.errors, name),
            touched: !!getIn(state.touched, name),
            initialValue: getIn(initialValues.current, name),
            initialTouched: !!getIn(initialTouched.current, name),
            initialError: getIn(initialErrors.current, name)
        };
    }, [
        state.errors,
        state.touched,
        state.values
    ]);
    var getFieldHelpers = (0, $3ZYaX.useCallback)(function(name) {
        return {
            setValue: function setValue(value, shouldValidate) {
                return setFieldValue(name, value, shouldValidate);
            },
            setTouched: function setTouched(value, shouldValidate) {
                return setFieldTouched(name, value, shouldValidate);
            },
            setError: function setError(value) {
                return setFieldError(name, value);
            }
        };
    }, [
        setFieldValue,
        setFieldTouched,
        setFieldError
    ]);
    var getFieldProps = (0, $3ZYaX.useCallback)(function(nameOrOptions) {
        var isAnObject = isObject(nameOrOptions);
        var name = isAnObject ? nameOrOptions.name : nameOrOptions;
        var valueState = getIn(state.values, name);
        var field = {
            name: name,
            value: valueState,
            onChange: handleChange,
            onBlur: handleBlur
        };
        if (isAnObject) {
            var type = nameOrOptions.type, valueProp = nameOrOptions.value, is = nameOrOptions.as, multiple = nameOrOptions.multiple;
            if (type === 'checkbox') {
                if (valueProp === undefined) field.checked = !!valueState;
                else {
                    field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
                    field.value = valueProp;
                }
            } else if (type === 'radio') {
                field.checked = valueState === valueProp;
                field.value = valueProp;
            } else if (is === 'select' && multiple) {
                field.value = field.value || [];
                field.multiple = true;
            }
        }
        return field;
    }, [
        handleBlur,
        handleChange,
        state.values
    ]);
    var dirty = (0, $3ZYaX.useMemo)(function() {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(initialValues.current, state.values);
    }, [
        initialValues.current,
        state.values
    ]);
    var isValid = (0, $3ZYaX.useMemo)(function() {
        return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
    }, [
        isInitialValid,
        dirty,
        state.errors,
        props
    ]);
    var ctx = _extends({}, state, {
        initialValues: initialValues.current,
        initialErrors: initialErrors.current,
        initialTouched: initialTouched.current,
        initialStatus: initialStatus.current,
        handleBlur: handleBlur,
        handleChange: handleChange,
        handleReset: handleReset,
        handleSubmit: handleSubmit,
        resetForm: resetForm,
        setErrors: setErrors,
        setFormikState: setFormikState,
        setFieldTouched: setFieldTouched,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setStatus: setStatus,
        setSubmitting: setSubmitting,
        setTouched: setTouched,
        setValues: setValues,
        submitForm: submitForm,
        validateForm: validateFormWithHighPriority,
        validateField: validateField,
        isValid: isValid,
        dirty: dirty,
        unregisterField: unregisterField,
        registerField: registerField,
        getFieldProps: getFieldProps,
        getFieldMeta: getFieldMeta,
        getFieldHelpers: getFieldHelpers,
        validateOnBlur: validateOnBlur,
        validateOnChange: validateOnChange,
        validateOnMount: validateOnMount
    });
    return ctx;
}
function Formik(props) {
    var formikbag = useFormik(props);
    var component = props.component, children = props.children, render = props.render, innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />
    (0, $3ZYaX.useImperativeHandle)(innerRef, function() {
        return formikbag;
    });
    return (0, $3ZYaX.createElement)(FormikProvider, {
        value: formikbag
    }, component ? (0, $3ZYaX.createElement)(component, formikbag) : render ? render(formikbag) : children // children come last, always called
     ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? (0, $3ZYaX.Children).only(children) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
    var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
    console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */ function yupToFormErrors(yupError) {
    var errors = {};
    if (yupError.inner) {
        if (yupError.inner.length === 0) return setIn(errors, yupError.path, yupError.message);
        for(var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;){
            var _ref5;
            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref5 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref5 = _i.value;
            }
            var err = _ref5;
            if (!getIn(errors, err.path)) errors = setIn(errors, err.path, err.message);
        }
    }
    return errors;
}
/**
 * Validate a yup schema.
 */ function validateYupSchema(values, schema, sync, context) {
    if (sync === void 0) sync = false;
    var normalizedValues = prepareDataForValidation(values);
    return schema[sync ? 'validateSync' : 'validate'](normalizedValues, {
        abortEarly: false,
        context: context || normalizedValues
    });
}
/**
 * Recursively prepare values.
 */ function prepareDataForValidation(values) {
    var data = Array.isArray(values) ? [] : {};
    for(var k in values)if (Object.prototype.hasOwnProperty.call(values, k)) {
        var key = String(k);
        if (Array.isArray(values[key]) === true) data[key] = values[key].map(function(value) {
            if (Array.isArray(value) === true || (0, $fk1rf.default)(value)) return prepareDataForValidation(value);
            else return value !== '' ? value : undefined;
        });
        else if ((0, $fk1rf.default)(values[key])) data[key] = prepareDataForValidation(values[key]);
        else data[key] = values[key] !== '' ? values[key] : undefined;
    }
    return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */ function arrayMerge(target, source, options) {
    var destination = target.slice();
    source.forEach(function merge(e, i) {
        if (typeof destination[i] === 'undefined') {
            var cloneRequested = options.clone !== false;
            var shouldClone = cloneRequested && options.isMergeableObject(e);
            destination[i] = shouldClone ? (0, $a0HRr.default)(Array.isArray(e) ? [] : {}, e, options) : e;
        } else if (options.isMergeableObject(e)) destination[i] = (0, $a0HRr.default)(target[i], e, options);
        else if (target.indexOf(e) === -1) destination.push(e);
    });
    return destination;
}
/** Return multi select values based on an array of options */ function getSelectedValues(options) {
    return Array.from(options).filter(function(el) {
        return el.selected;
    }).map(function(el) {
        return el.value;
    });
}
/** Return the next value for a checkbox */ function getValueForCheckbox(currentValue, checked, valueProp) {
    // If the current value was a boolean, return a boolean
    if (typeof currentValue === 'boolean') return Boolean(checked);
     // If the currentValue was not a boolean we want to return an array
    var currentArrayOfValues = [];
    var isValueInArray = false;
    var index = -1;
    if (!Array.isArray(currentValue)) {
        // eslint-disable-next-line eqeqeq
        if (!valueProp || valueProp == 'true' || valueProp == 'false') return Boolean(checked);
    } else {
        // If the current value is already an array, use it
        currentArrayOfValues = currentValue;
        index = currentValue.indexOf(valueProp);
        isValueInArray = index >= 0;
    } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values
    if (checked && valueProp && !isValueInArray) return currentArrayOfValues.concat(valueProp);
     // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values
    if (!isValueInArray) return currentArrayOfValues;
     // If the checkbox was unchecked and the value is in the array, remove the value and return the array
    return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $3ZYaX.useLayoutEffect) : (0, $3ZYaX.useEffect);
function useEventCallback(fn) {
    var ref = (0, $3ZYaX.useRef)(fn); // we copy a ref to the callback scoped to the current state/props on each render
    useIsomorphicLayoutEffect(function() {
        ref.current = fn;
    });
    return (0, $3ZYaX.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(void 0, args);
    }, []);
}
function useField(propsOrFieldName) {
    var formik = useFormikContext();
    var getFieldProps = formik.getFieldProps, getFieldMeta = formik.getFieldMeta, getFieldHelpers = formik.getFieldHelpers, registerField = formik.registerField, unregisterField = formik.unregisterField;
    var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>
    var props = isAnObject ? propsOrFieldName : {
        name: propsOrFieldName
    };
    var fieldName = props.name, validateFn = props.validate;
    (0, $3ZYaX.useEffect)(function() {
        if (fieldName) registerField(fieldName, {
            validate: validateFn
        });
        return function() {
            if (fieldName) unregisterField(fieldName);
        };
    }, [
        registerField,
        unregisterField,
        fieldName,
        validateFn
    ]);
    !fieldName && (0, $bVcmS.default)(false);
    var fieldHelpers = (0, $3ZYaX.useMemo)(function() {
        return getFieldHelpers(fieldName);
    }, [
        getFieldHelpers,
        fieldName
    ]);
    return [
        getFieldProps(props),
        getFieldMeta(fieldName),
        fieldHelpers
    ];
}
function Field(_ref) {
    var validate = _ref.validate, name = _ref.name, render = _ref.render, children = _ref.children, is = _ref.as, component = _ref.component, className = _ref.className, props = _objectWithoutPropertiesLoose(_ref, [
        "validate",
        "name",
        "render",
        "children",
        "as",
        "component",
        "className"
    ]);
    var _useFormikContext = useFormikContext(), formik = _objectWithoutPropertiesLoose(_useFormikContext, [
        "validate",
        "validationSchema"
    ]);
    var registerField = formik.registerField, unregisterField = formik.unregisterField;
    (0, $3ZYaX.useEffect)(function() {
        registerField(name, {
            validate: validate
        });
        return function() {
            unregisterField(name);
        };
    }, [
        registerField,
        unregisterField,
        name,
        validate
    ]);
    var field = formik.getFieldProps(_extends({
        name: name
    }, props));
    var meta = formik.getFieldMeta(name);
    var legacyBag = {
        field: field,
        form: formik
    };
    if (render) return render(_extends({}, legacyBag, {
        meta: meta
    }));
    if (isFunction(children)) return children(_extends({}, legacyBag, {
        meta: meta
    }));
    if (component) {
        // This behavior is backwards compat with earlier Formik 0.9 to 1.x
        if (typeof component === 'string') {
            var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $3ZYaX.createElement)(component, _extends({
                ref: innerRef
            }, field, rest, {
                className: className
            }), children);
        } // We don't pass `meta` for backwards compat
        return (0, $3ZYaX.createElement)(component, _extends({
            field: field,
            form: formik
        }, props, {
            className: className
        }), children);
    } // default to input here so we can check for both `as` and `children` above
    var asElement = is || 'input';
    if (typeof asElement === 'string') {
        var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
            "innerRef"
        ]);
        return (0, $3ZYaX.createElement)(asElement, _extends({
            ref: _innerRef
        }, field, _rest, {
            className: className
        }), children);
    }
    return (0, $3ZYaX.createElement)(asElement, _extends({}, field, props, {
        className: className
    }), children);
}
var Form = /*#__PURE__*/ (0, $3ZYaX.forwardRef)(function(props, ref) {
    // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
    // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
    var action = props.action, rest = _objectWithoutPropertiesLoose(props, [
        "action"
    ]);
    var _action = action != null ? action : '#';
    var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
    return (0, $3ZYaX.createElement)("form", _extends({
        onSubmit: handleSubmit,
        ref: ref,
        onReset: handleReset,
        action: _action
    }, rest));
});
Form.displayName = 'Form';
/**
 * A public higher-order component to access the imperative API
 */ function withFormik(_ref) {
    var _ref$mapPropsToValues = _ref.mapPropsToValues, mapPropsToValues = _ref$mapPropsToValues === void 0 ? function(vanillaProps) {
        var val = {};
        for(var k in vanillaProps)if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') // @todo TypeScript fix
        val[k] = vanillaProps[k];
        return val;
    } : _ref$mapPropsToValues, config = _objectWithoutPropertiesLoose(_ref, [
        "mapPropsToValues"
    ]);
    return function createFormik(Component$1) {
        var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
        /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */ var C = /*#__PURE__*/ function(_React$Component) {
            _inheritsLoose(C, _React$Component);
            function C() {
                var _this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                _this = _React$Component.call.apply(_React$Component, [
                    this
                ].concat(args)) || this;
                _this.validate = function(values) {
                    return config.validate(values, _this.props);
                };
                _this.validationSchema = function() {
                    return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
                };
                _this.handleSubmit = function(values, actions) {
                    return config.handleSubmit(values, _extends({}, actions, {
                        props: _this.props
                    }));
                };
                _this.renderFormComponent = function(formikProps) {
                    return (0, $3ZYaX.createElement)(Component$1, _extends({}, _this.props, formikProps));
                };
                return _this;
            }
            var _proto = C.prototype;
            _proto.render = function render() {
                var _this$props = this.props, props = _objectWithoutPropertiesLoose(_this$props, [
                    "children"
                ]);
                return (0, $3ZYaX.createElement)(Formik, _extends({}, props, config, {
                    validate: config.validate && this.validate,
                    validationSchema: config.validationSchema && this.validationSchema,
                    initialValues: mapPropsToValues(this.props),
                    initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
                    initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
                    initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
                    onSubmit: this.handleSubmit,
                    children: this.renderFormComponent
                }));
            };
            return C;
        }((0, $3ZYaX.Component));
        C.displayName = "WithFormik(" + componentDisplayName + ")";
        return (0, (/*@__PURE__*/$parcel$interopDefault($6fGvd)))(C, Component$1 // cast type to ComponentClass (even if SFC)
        );
    };
}
/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */ function connect(Comp) {
    var C = function C(props) {
        return (0, $3ZYaX.createElement)(FormikConsumer, null, function(formik) {
            !!!formik && (0, $bVcmS.default)(false);
            return (0, $3ZYaX.createElement)(Comp, _extends({}, props, {
                formik: formik
            }));
        });
    };
    var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
    // For example, <Field.WrappedComponent /> gets us <FieldInner/>
    C.WrappedComponent = Comp;
    C.displayName = "FormikConnect(" + componentDisplayName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fGvd)))(C, Comp // cast type to ComponentClass (even if SFC)
    );
}
/**
 * Some array helpers!
 */ var move = function move(array, from, to) {
    var copy = copyArrayLike(array);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
    var copy = copyArrayLike(arrayLike);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
};
var insert = function insert(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy.splice(index, 0, value);
    return copy;
};
var replace = function replace(arrayLike, index, value) {
    var copy = copyArrayLike(arrayLike);
    copy[index] = value;
    return copy;
};
var copyArrayLike = function copyArrayLike(arrayLike) {
    if (!arrayLike) return [];
    else if (Array.isArray(arrayLike)) return [].concat(arrayLike);
    else {
        var maxIndex = Object.keys(arrayLike).map(function(key) {
            return parseInt(key);
        }).reduce(function(max, el) {
            return el > max ? el : max;
        }, 0);
        return Array.from(_extends({}, arrayLike, {
            length: maxIndex + 1
        }));
    }
};
var createAlterationHandler = function createAlterationHandler(alteration, defaultFunction) {
    var fn = typeof alteration === 'function' ? alteration : defaultFunction;
    return function(data) {
        if (Array.isArray(data) || isObject(data)) {
            var clone = copyArrayLike(data);
            return fn(clone);
        } // This can be assumed to be a primitive, which
        // is a case for top level validation errors
        return data;
    };
};
var FieldArrayInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FieldArrayInner, _React$Component);
    function FieldArrayInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this; // We need TypeScript generics on these, so we'll bind them in the constructor
        // @todo Fix TS 3.2.1
        _this.updateArrayField = function(fn, alterTouched, alterErrors) {
            var _this$props = _this.props, name = _this$props.name, setFormikState = _this$props.formik.setFormikState;
            setFormikState(function(prevState) {
                var updateErrors = createAlterationHandler(alterErrors, fn);
                var updateTouched = createAlterationHandler(alterTouched, fn); // values fn should be executed before updateErrors and updateTouched,
                // otherwise it causes an error with unshift.
                var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
                var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
                var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;
                if (isEmptyArray(fieldError)) fieldError = undefined;
                if (isEmptyArray(fieldTouched)) fieldTouched = undefined;
                return _extends({}, prevState, {
                    values: values,
                    errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
                    touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
                });
            });
        };
        _this.push = function(value) {
            return _this.updateArrayField(function(arrayLike) {
                return [].concat(copyArrayLike(arrayLike), [
                    (0, $frVnn.default)(value)
                ]);
            }, false, false);
        };
        _this.handlePush = function(value) {
            return function() {
                return _this.push(value);
            };
        };
        _this.swap = function(indexA, indexB) {
            return _this.updateArrayField(function(array) {
                return swap(array, indexA, indexB);
            }, true, true);
        };
        _this.handleSwap = function(indexA, indexB) {
            return function() {
                return _this.swap(indexA, indexB);
            };
        };
        _this.move = function(from, to) {
            return _this.updateArrayField(function(array) {
                return move(array, from, to);
            }, true, true);
        };
        _this.handleMove = function(from, to) {
            return function() {
                return _this.move(from, to);
            };
        };
        _this.insert = function(index, value) {
            return _this.updateArrayField(function(array) {
                return insert(array, index, value);
            }, function(array) {
                return insert(array, index, null);
            }, function(array) {
                return insert(array, index, null);
            });
        };
        _this.handleInsert = function(index, value) {
            return function() {
                return _this.insert(index, value);
            };
        };
        _this.replace = function(index, value) {
            return _this.updateArrayField(function(array) {
                return replace(array, index, value);
            }, false, false);
        };
        _this.handleReplace = function(index, value) {
            return function() {
                return _this.replace(index, value);
            };
        };
        _this.unshift = function(value) {
            var length = -1;
            _this.updateArrayField(function(array) {
                var arr = array ? [
                    value
                ].concat(array) : [
                    value
                ];
                length = arr.length;
                return arr;
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            }, function(array) {
                return array ? [
                    null
                ].concat(array) : [
                    null
                ];
            });
            return length;
        };
        _this.handleUnshift = function(value) {
            return function() {
                return _this.unshift(value);
            };
        };
        _this.handleRemove = function(index) {
            return function() {
                return _this.remove(index);
            };
        };
        _this.handlePop = function() {
            return function() {
                return _this.pop();
            };
        };
        _this.remove = _this.remove.bind(_assertThisInitialized(_this));
        _this.pop = _this.pop.bind(_assertThisInitialized(_this));
        return _this;
    }
    var _proto = FieldArrayInner.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.validateOnChange && this.props.formik.validateOnChange && !(0, (/*@__PURE__*/$parcel$interopDefault($e5cN7)))(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name))) this.props.formik.validateForm(this.props.formik.values);
    };
    _proto.remove = function remove(index) {
        // We need to make sure we also remove relevant pieces of `touched` and `errors`
        var result;
        this.updateArrayField(function(array) {
            var copy = array ? copyArrayLike(array) : [];
            if (!result) result = copy[index];
            if (isFunction(copy.splice)) copy.splice(index, 1);
             // if the array only includes undefined values we have to return an empty array
            return isFunction(copy.every) ? copy.every(function(v) {
                return v === undefined;
            }) ? [] : copy : copy;
        }, true, true);
        return result;
    };
    _proto.pop = function pop() {
        // Remove relevant pieces of `touched` and `errors` too!
        var result;
        this.updateArrayField(function(array) {
            var tmp = array.slice();
            if (!result) result = tmp && tmp.pop && tmp.pop();
            return tmp;
        }, true, true);
        return result;
    };
    _proto.render = function render() {
        var arrayHelpers = {
            push: this.push,
            pop: this.pop,
            swap: this.swap,
            move: this.move,
            insert: this.insert,
            replace: this.replace,
            unshift: this.unshift,
            remove: this.remove,
            handlePush: this.handlePush,
            handlePop: this.handlePop,
            handleSwap: this.handleSwap,
            handleMove: this.handleMove,
            handleInsert: this.handleInsert,
            handleReplace: this.handleReplace,
            handleUnshift: this.handleUnshift,
            handleRemove: this.handleRemove
        };
        var _this$props2 = this.props, component = _this$props2.component, render = _this$props2.render, children = _this$props2.children, name = _this$props2.name, _this$props2$formik = _this$props2.formik, restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, [
            "validate",
            "validationSchema"
        ]);
        var props = _extends({}, arrayHelpers, {
            form: restOfFormik,
            name: name
        });
        return component ? (0, $3ZYaX.createElement)(component, props) : render ? render(props) : children // children come last, always called
         ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? (0, $3ZYaX.Children).only(children) : null : null;
    };
    return FieldArrayInner;
}((0, $3ZYaX.Component));
FieldArrayInner.defaultProps = {
    validateOnChange: true
};
var FieldArray = /*#__PURE__*/ connect(FieldArrayInner);
var ErrorMessageImpl = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorMessageImpl, _React$Component);
    function ErrorMessageImpl() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = ErrorMessageImpl.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) return true;
        else return false;
    };
    _proto.render = function render() {
        var _this$props = this.props, component = _this$props.component, formik = _this$props.formik, render = _this$props.render, children = _this$props.children, name = _this$props.name, rest = _objectWithoutPropertiesLoose(_this$props, [
            "component",
            "formik",
            "render",
            "children",
            "name"
        ]);
        var touch = getIn(formik.touched, name);
        var error = getIn(formik.errors, name);
        return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? (0, $3ZYaX.createElement)(component, rest, error) : error : null;
    };
    return ErrorMessageImpl;
}((0, $3ZYaX.Component));
var ErrorMessage = /*#__PURE__*/ connect(ErrorMessageImpl);
/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */ var FastFieldInner = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(FastFieldInner, _React$Component);
    function FastFieldInner(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        var render = props.render, children = props.children, component = props.component, is = props.as, name = props.name;
        !!render && (0, $bVcmS.default)(false);
        !!(component && render) && (0, $bVcmS.default)(false);
        !!(is && children && isFunction(children)) && (0, $bVcmS.default)(false);
        !!(component && children && isFunction(children)) && (0, $bVcmS.default)(false);
        !!(render && children && !isEmptyChildren(children)) && (0, $bVcmS.default)(false);
        return _this;
    }
    var _proto = FastFieldInner.prototype;
    _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
        if (this.props.shouldUpdate) return this.props.shouldUpdate(props, this.props);
        else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) return true;
        else return false;
    };
    _proto.componentDidMount = function componentDidMount() {
        // Register the Field with the parent Formik. Parent will cycle through
        // registered Field's validate fns right prior to submit
        this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
            this.props.formik.unregisterField(prevProps.name);
            this.props.formik.registerField(this.props.name, {
                validate: this.props.validate
            });
        }
        if (this.props.validate !== prevProps.validate) this.props.formik.registerField(this.props.name, {
            validate: this.props.validate
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.props.formik.unregisterField(this.props.name);
    };
    _proto.render = function render() {
        var _this$props = this.props, name = _this$props.name, render = _this$props.render, is = _this$props.as, children = _this$props.children, component = _this$props.component, formik = _this$props.formik, props = _objectWithoutPropertiesLoose(_this$props, [
            "validate",
            "name",
            "render",
            "as",
            "children",
            "component",
            "shouldUpdate",
            "formik"
        ]);
        var restOfFormik = _objectWithoutPropertiesLoose(formik, [
            "validate",
            "validationSchema"
        ]);
        var field = formik.getFieldProps(_extends({
            name: name
        }, props));
        var meta = {
            value: getIn(formik.values, name),
            error: getIn(formik.errors, name),
            touched: !!getIn(formik.touched, name),
            initialValue: getIn(formik.initialValues, name),
            initialTouched: !!getIn(formik.initialTouched, name),
            initialError: getIn(formik.initialErrors, name)
        };
        var bag = {
            field: field,
            meta: meta,
            form: restOfFormik
        };
        if (render) return render(bag);
        if (isFunction(children)) return children(bag);
        if (component) {
            // This behavior is backwards compat with earlier Formik 0.9 to 1.x
            if (typeof component === 'string') {
                var innerRef = props.innerRef, rest = _objectWithoutPropertiesLoose(props, [
                    "innerRef"
                ]);
                return (0, $3ZYaX.createElement)(component, _extends({
                    ref: innerRef
                }, field, rest), children);
            } // We don't pass `meta` for backwards compat
            return (0, $3ZYaX.createElement)(component, _extends({
                field: field,
                form: formik
            }, props), children);
        } // default to input here so we can check for both `as` and `children` above
        var asElement = is || 'input';
        if (typeof asElement === 'string') {
            var _innerRef = props.innerRef, _rest = _objectWithoutPropertiesLoose(props, [
                "innerRef"
            ]);
            return (0, $3ZYaX.createElement)(asElement, _extends({
                ref: _innerRef
            }, field, _rest), children);
        }
        return (0, $3ZYaX.createElement)(asElement, _extends({}, field, props), children);
    };
    return FastFieldInner;
}((0, $3ZYaX.Component));
var FastField = /*#__PURE__*/ connect(FastFieldInner);

});
parcelRegister("a0HRr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $749bed5624ddd558$export$2e2bcd8739ae039; });
var $749bed5624ddd558$var$isMergeableObject = function isMergeableObject(value) {
    return $749bed5624ddd558$var$isNonNullObject(value) && !$749bed5624ddd558$var$isSpecial(value);
};
function $749bed5624ddd558$var$isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function $749bed5624ddd558$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || $749bed5624ddd558$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $749bed5624ddd558$var$canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var $749bed5624ddd558$var$REACT_ELEMENT_TYPE = $749bed5624ddd558$var$canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function $749bed5624ddd558$var$isReactElement(value) {
    return value.$$typeof === $749bed5624ddd558$var$REACT_ELEMENT_TYPE;
}
function $749bed5624ddd558$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $749bed5624ddd558$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $749bed5624ddd558$var$deepmerge($749bed5624ddd558$var$emptyTarget(value), value, options) : value;
}
function $749bed5624ddd558$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $749bed5624ddd558$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $749bed5624ddd558$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) Object.keys(target).forEach(function(key) {
        destination[key] = $749bed5624ddd558$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    Object.keys(source).forEach(function(key) {
        if (!options.isMergeableObject(source[key]) || !target[key]) destination[key] = $749bed5624ddd558$var$cloneUnlessOtherwiseSpecified(source[key], options);
        else destination[key] = $749bed5624ddd558$var$deepmerge(target[key], source[key], options);
    });
    return destination;
}
function $749bed5624ddd558$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $749bed5624ddd558$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $749bed5624ddd558$var$isMergeableObject;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $749bed5624ddd558$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $749bed5624ddd558$var$mergeObject(target, source, options);
}
$749bed5624ddd558$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return $749bed5624ddd558$var$deepmerge(prev, next, options);
    }, {});
};
var $749bed5624ddd558$var$deepmerge_1 = $749bed5624ddd558$var$deepmerge;
var $749bed5624ddd558$export$2e2bcd8739ae039 = $749bed5624ddd558$var$deepmerge_1;

});

parcelRegister("fk1rf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b279d6e7f7532862$export$2e2bcd8739ae039; });

var $bZ4Xc = parcelRequire("bZ4Xc");

var $hK0og = parcelRequire("hK0og");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $b279d6e7f7532862$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $b279d6e7f7532862$var$funcProto = Function.prototype, $b279d6e7f7532862$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $b279d6e7f7532862$var$funcToString = $b279d6e7f7532862$var$funcProto.toString;
/** Used to check objects for own properties. */ var $b279d6e7f7532862$var$hasOwnProperty = $b279d6e7f7532862$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $b279d6e7f7532862$var$objectCtorString = $b279d6e7f7532862$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $b279d6e7f7532862$var$isPlainObject(value) {
    if (!(0, $a2zJo.default)(value) || (0, $bZ4Xc.default)(value) != $b279d6e7f7532862$var$objectTag) return false;
    var proto = (0, $hK0og.default)(value);
    if (proto === null) return true;
    var Ctor = $b279d6e7f7532862$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $b279d6e7f7532862$var$funcToString.call(Ctor) == $b279d6e7f7532862$var$objectCtorString;
}
var $b279d6e7f7532862$export$2e2bcd8739ae039 = $b279d6e7f7532862$var$isPlainObject;

});
parcelRegister("bZ4Xc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b993beef0e78c8b$export$2e2bcd8739ae039; });

var $7xxe9 = parcelRequire("7xxe9");

var $hLfLe = parcelRequire("hLfLe");

var $01i9m = parcelRequire("01i9m");
/** `Object#toString` result references. */ var $8b993beef0e78c8b$var$nullTag = '[object Null]', $8b993beef0e78c8b$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $8b993beef0e78c8b$var$symToStringTag = (0, $7xxe9.default) ? (0, $7xxe9.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $8b993beef0e78c8b$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $8b993beef0e78c8b$var$undefinedTag : $8b993beef0e78c8b$var$nullTag;
    return $8b993beef0e78c8b$var$symToStringTag && $8b993beef0e78c8b$var$symToStringTag in Object(value) ? (0, $hLfLe.default)(value) : (0, $01i9m.default)(value);
}
var $8b993beef0e78c8b$export$2e2bcd8739ae039 = $8b993beef0e78c8b$var$baseGetTag;

});
parcelRegister("7xxe9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57d563b2e46175c6$export$2e2bcd8739ae039; });

var $4Dhps = parcelRequire("4Dhps");
/** Built-in value references. */ var $57d563b2e46175c6$var$Symbol = (0, $4Dhps.default).Symbol;
var $57d563b2e46175c6$export$2e2bcd8739ae039 = $57d563b2e46175c6$var$Symbol;

});
parcelRegister("4Dhps", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35f84f2429e20eb5$export$2e2bcd8739ae039; });

var $8SaGN = parcelRequire("8SaGN");
/** Detect free variable `self`. */ var $35f84f2429e20eb5$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $35f84f2429e20eb5$var$root = (0, $8SaGN.default) || $35f84f2429e20eb5$var$freeSelf || Function('return this')();
var $35f84f2429e20eb5$export$2e2bcd8739ae039 = $35f84f2429e20eb5$var$root;

});
parcelRegister("8SaGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $675ba889d4fa0c34$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $675ba889d4fa0c34$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $675ba889d4fa0c34$export$2e2bcd8739ae039 = $675ba889d4fa0c34$var$freeGlobal;

});



parcelRegister("hLfLe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cee30d3e1b354539$export$2e2bcd8739ae039; });

var $7xxe9 = parcelRequire("7xxe9");
/** Used for built-in method references. */ var $cee30d3e1b354539$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cee30d3e1b354539$var$hasOwnProperty = $cee30d3e1b354539$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cee30d3e1b354539$var$nativeObjectToString = $cee30d3e1b354539$var$objectProto.toString;
/** Built-in value references. */ var $cee30d3e1b354539$var$symToStringTag = (0, $7xxe9.default) ? (0, $7xxe9.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $cee30d3e1b354539$var$getRawTag(value) {
    var isOwn = $cee30d3e1b354539$var$hasOwnProperty.call(value, $cee30d3e1b354539$var$symToStringTag), tag = value[$cee30d3e1b354539$var$symToStringTag];
    try {
        value[$cee30d3e1b354539$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $cee30d3e1b354539$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$cee30d3e1b354539$var$symToStringTag] = tag;
        else delete value[$cee30d3e1b354539$var$symToStringTag];
    }
    return result;
}
var $cee30d3e1b354539$export$2e2bcd8739ae039 = $cee30d3e1b354539$var$getRawTag;

});

parcelRegister("01i9m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003e2c502fb230a7$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $003e2c502fb230a7$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $003e2c502fb230a7$var$nativeObjectToString = $003e2c502fb230a7$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $003e2c502fb230a7$var$objectToString(value) {
    return $003e2c502fb230a7$var$nativeObjectToString.call(value);
}
var $003e2c502fb230a7$export$2e2bcd8739ae039 = $003e2c502fb230a7$var$objectToString;

});


parcelRegister("hK0og", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cea7090ee4154ba2$export$2e2bcd8739ae039; });

var $jSEb8 = parcelRequire("jSEb8");
/** Built-in value references. */ var $cea7090ee4154ba2$var$getPrototype = (0, $jSEb8.default)(Object.getPrototypeOf, Object);
var $cea7090ee4154ba2$export$2e2bcd8739ae039 = $cea7090ee4154ba2$var$getPrototype;

});
parcelRegister("jSEb8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7923a139e70c913$export$2e2bcd8739ae039; });
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $e7923a139e70c913$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $e7923a139e70c913$export$2e2bcd8739ae039 = $e7923a139e70c913$var$overArg;

});


parcelRegister("a2zJo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74f5ceb99bfff438$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $74f5ceb99bfff438$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $74f5ceb99bfff438$export$2e2bcd8739ae039 = $74f5ceb99bfff438$var$isObjectLike;

});


parcelRegister("e5cN7", function(module, exports) {
'use strict';
var $a40b745fe60b01b7$var$isArray = Array.isArray;
var $a40b745fe60b01b7$var$keyList = Object.keys;
var $a40b745fe60b01b7$var$hasProp = Object.prototype.hasOwnProperty;
var $a40b745fe60b01b7$var$hasElementType = typeof Element !== 'undefined';
function $a40b745fe60b01b7$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = $a40b745fe60b01b7$var$isArray(a), arrB = $a40b745fe60b01b7$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$a40b745fe60b01b7$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $a40b745fe60b01b7$var$keyList(a);
        length = keys.length;
        if (length !== $a40b745fe60b01b7$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$a40b745fe60b01b7$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($a40b745fe60b01b7$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$a40b745fe60b01b7$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $a40b745fe60b01b7$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("bVcmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ade9c964151c19e$export$2e2bcd8739ae039; });
var $8ade9c964151c19e$var$isProduction = true;
function $8ade9c964151c19e$var$warning(condition, message) {
    if (!$8ade9c964151c19e$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $8ade9c964151c19e$export$2e2bcd8739ae039 = $8ade9c964151c19e$var$warning;

});

parcelRegister("5mNmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e854d6e7e9f0fff$export$2e2bcd8739ae039; });

var $jBV00 = parcelRequire("jBV00");
/** Used to compose bitmasks for cloning. */ var $3e854d6e7e9f0fff$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $3e854d6e7e9f0fff$var$clone(value) {
    return (0, $jBV00.default)(value, $3e854d6e7e9f0fff$var$CLONE_SYMBOLS_FLAG);
}
var $3e854d6e7e9f0fff$export$2e2bcd8739ae039 = $3e854d6e7e9f0fff$var$clone;

});
parcelRegister("jBV00", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e46dafde2c993dec$export$2e2bcd8739ae039; });

var $f6bcA = parcelRequire("f6bcA");

var $hWnRm = parcelRequire("hWnRm");

var $1Q2ls = parcelRequire("1Q2ls");

var $cy498 = parcelRequire("cy498");

var $2wSnw = parcelRequire("2wSnw");

var $3Hgc7 = parcelRequire("3Hgc7");

var $lW1js = parcelRequire("lW1js");

var $dyUR1 = parcelRequire("dyUR1");

var $lBjjk = parcelRequire("lBjjk");

var $4qPrG = parcelRequire("4qPrG");

var $3knRy = parcelRequire("3knRy");

var $01bPL = parcelRequire("01bPL");

var $agrpx = parcelRequire("agrpx");

var $8bdGX = parcelRequire("8bdGX");

var $739Nd = parcelRequire("739Nd");

var $eCrEi = parcelRequire("eCrEi");

var $5cAsX = parcelRequire("5cAsX");

var $5LmWO = parcelRequire("5LmWO");

var $izrsA = parcelRequire("izrsA");

var $5psQA = parcelRequire("5psQA");

var $6xWQa = parcelRequire("6xWQa");

var $gexm8 = parcelRequire("gexm8");
/** Used to compose bitmasks for cloning. */ var $e46dafde2c993dec$var$CLONE_DEEP_FLAG = 1, $e46dafde2c993dec$var$CLONE_FLAT_FLAG = 2, $e46dafde2c993dec$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $e46dafde2c993dec$var$argsTag = '[object Arguments]', $e46dafde2c993dec$var$arrayTag = '[object Array]', $e46dafde2c993dec$var$boolTag = '[object Boolean]', $e46dafde2c993dec$var$dateTag = '[object Date]', $e46dafde2c993dec$var$errorTag = '[object Error]', $e46dafde2c993dec$var$funcTag = '[object Function]', $e46dafde2c993dec$var$genTag = '[object GeneratorFunction]', $e46dafde2c993dec$var$mapTag = '[object Map]', $e46dafde2c993dec$var$numberTag = '[object Number]', $e46dafde2c993dec$var$objectTag = '[object Object]', $e46dafde2c993dec$var$regexpTag = '[object RegExp]', $e46dafde2c993dec$var$setTag = '[object Set]', $e46dafde2c993dec$var$stringTag = '[object String]', $e46dafde2c993dec$var$symbolTag = '[object Symbol]', $e46dafde2c993dec$var$weakMapTag = '[object WeakMap]';
var $e46dafde2c993dec$var$arrayBufferTag = '[object ArrayBuffer]', $e46dafde2c993dec$var$dataViewTag = '[object DataView]', $e46dafde2c993dec$var$float32Tag = '[object Float32Array]', $e46dafde2c993dec$var$float64Tag = '[object Float64Array]', $e46dafde2c993dec$var$int8Tag = '[object Int8Array]', $e46dafde2c993dec$var$int16Tag = '[object Int16Array]', $e46dafde2c993dec$var$int32Tag = '[object Int32Array]', $e46dafde2c993dec$var$uint8Tag = '[object Uint8Array]', $e46dafde2c993dec$var$uint8ClampedTag = '[object Uint8ClampedArray]', $e46dafde2c993dec$var$uint16Tag = '[object Uint16Array]', $e46dafde2c993dec$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $e46dafde2c993dec$var$cloneableTags = {};
$e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$argsTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$arrayTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$arrayBufferTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$dataViewTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$boolTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$dateTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$float32Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$float64Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$int8Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$int16Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$int32Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$mapTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$numberTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$objectTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$regexpTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$setTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$stringTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$symbolTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$uint8Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$uint8ClampedTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$uint16Tag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$uint32Tag] = true;
$e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$errorTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$funcTag] = $e46dafde2c993dec$var$cloneableTags[$e46dafde2c993dec$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $e46dafde2c993dec$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $e46dafde2c993dec$var$CLONE_DEEP_FLAG, isFlat = bitmask & $e46dafde2c993dec$var$CLONE_FLAT_FLAG, isFull = bitmask & $e46dafde2c993dec$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $izrsA.default)(value)) return value;
    var isArr = (0, $eCrEi.default)(value);
    if (isArr) {
        result = (0, $agrpx.default)(value);
        if (!isDeep) return (0, $lW1js.default)(value, result);
    } else {
        var tag = (0, $01bPL.default)(value), isFunc = tag == $e46dafde2c993dec$var$funcTag || tag == $e46dafde2c993dec$var$genTag;
        if ((0, $5cAsX.default)(value)) return (0, $3Hgc7.default)(value, isDeep);
        if (tag == $e46dafde2c993dec$var$objectTag || tag == $e46dafde2c993dec$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $739Nd.default)(value);
            if (!isDeep) return isFlat ? (0, $lBjjk.default)(value, (0, $2wSnw.default)(result, value)) : (0, $dyUR1.default)(value, (0, $cy498.default)(result, value));
        } else {
            if (!$e46dafde2c993dec$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $8bdGX.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $f6bcA.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $5psQA.default)(value)) value.forEach(function(subValue) {
        result.add($e46dafde2c993dec$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5LmWO.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $e46dafde2c993dec$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $3knRy.default) : (0, $4qPrG.default) : isFlat ? (0, $gexm8.default) : (0, $6xWQa.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $hWnRm.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $1Q2ls.default)(result, key, $e46dafde2c993dec$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $e46dafde2c993dec$export$2e2bcd8739ae039 = $e46dafde2c993dec$var$baseClone;

});
parcelRegister("f6bcA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $afe01b03d4f07ebb$export$2e2bcd8739ae039; });

var $kHwV8 = parcelRequire("kHwV8");

var $E1qrp = parcelRequire("E1qrp");

var $5RUw3 = parcelRequire("5RUw3");

var $3yskr = parcelRequire("3yskr");

var $6Mz8h = parcelRequire("6Mz8h");

var $jX32n = parcelRequire("jX32n");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $afe01b03d4f07ebb$var$Stack(entries) {
    var data = this.__data__ = new (0, $kHwV8.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$afe01b03d4f07ebb$var$Stack.prototype.clear = (0, $E1qrp.default);
$afe01b03d4f07ebb$var$Stack.prototype['delete'] = (0, $5RUw3.default);
$afe01b03d4f07ebb$var$Stack.prototype.get = (0, $3yskr.default);
$afe01b03d4f07ebb$var$Stack.prototype.has = (0, $6Mz8h.default);
$afe01b03d4f07ebb$var$Stack.prototype.set = (0, $jX32n.default);
var $afe01b03d4f07ebb$export$2e2bcd8739ae039 = $afe01b03d4f07ebb$var$Stack;

});
parcelRegister("kHwV8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1215c201dd404cd$export$2e2bcd8739ae039; });

var $bRUj5 = parcelRequire("bRUj5");

var $4X5mT = parcelRequire("4X5mT");

var $3pZJc = parcelRequire("3pZJc");

var $01kPd = parcelRequire("01kPd");

var $w8f6j = parcelRequire("w8f6j");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f1215c201dd404cd$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f1215c201dd404cd$var$ListCache.prototype.clear = (0, $bRUj5.default);
$f1215c201dd404cd$var$ListCache.prototype['delete'] = (0, $4X5mT.default);
$f1215c201dd404cd$var$ListCache.prototype.get = (0, $3pZJc.default);
$f1215c201dd404cd$var$ListCache.prototype.has = (0, $01kPd.default);
$f1215c201dd404cd$var$ListCache.prototype.set = (0, $w8f6j.default);
var $f1215c201dd404cd$export$2e2bcd8739ae039 = $f1215c201dd404cd$var$ListCache;

});
parcelRegister("bRUj5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a40524a37e6363f$export$2e2bcd8739ae039; });
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $8a40524a37e6363f$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $8a40524a37e6363f$export$2e2bcd8739ae039 = $8a40524a37e6363f$var$listCacheClear;

});

parcelRegister("4X5mT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $39b0d61e69d9cecb$export$2e2bcd8739ae039; });

var $fQrzt = parcelRequire("fQrzt");
/** Used for built-in method references. */ var $39b0d61e69d9cecb$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $39b0d61e69d9cecb$var$splice = $39b0d61e69d9cecb$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $39b0d61e69d9cecb$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $fQrzt.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $39b0d61e69d9cecb$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $39b0d61e69d9cecb$export$2e2bcd8739ae039 = $39b0d61e69d9cecb$var$listCacheDelete;

});
parcelRegister("fQrzt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b891196be0ba9221$export$2e2bcd8739ae039; });

var $knBco = parcelRequire("knBco");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $b891196be0ba9221$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $knBco.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $b891196be0ba9221$export$2e2bcd8739ae039 = $b891196be0ba9221$var$assocIndexOf;

});
parcelRegister("knBco", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed62cf8fde33a1fd$export$2e2bcd8739ae039; });
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ed62cf8fde33a1fd$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $ed62cf8fde33a1fd$export$2e2bcd8739ae039 = $ed62cf8fde33a1fd$var$eq;

});



parcelRegister("3pZJc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d396d19efab456$export$2e2bcd8739ae039; });

var $fQrzt = parcelRequire("fQrzt");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $27d396d19efab456$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $fQrzt.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $27d396d19efab456$export$2e2bcd8739ae039 = $27d396d19efab456$var$listCacheGet;

});

parcelRegister("01kPd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00403f870b422f4e$export$2e2bcd8739ae039; });

var $fQrzt = parcelRequire("fQrzt");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $00403f870b422f4e$var$listCacheHas(key) {
    return (0, $fQrzt.default)(this.__data__, key) > -1;
}
var $00403f870b422f4e$export$2e2bcd8739ae039 = $00403f870b422f4e$var$listCacheHas;

});

parcelRegister("w8f6j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $060962132ba72dcf$export$2e2bcd8739ae039; });

var $fQrzt = parcelRequire("fQrzt");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $060962132ba72dcf$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $fQrzt.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $060962132ba72dcf$export$2e2bcd8739ae039 = $060962132ba72dcf$var$listCacheSet;

});


parcelRegister("E1qrp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0784d79c33d1cb67$export$2e2bcd8739ae039; });

var $kHwV8 = parcelRequire("kHwV8");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $0784d79c33d1cb67$var$stackClear() {
    this.__data__ = new (0, $kHwV8.default);
    this.size = 0;
}
var $0784d79c33d1cb67$export$2e2bcd8739ae039 = $0784d79c33d1cb67$var$stackClear;

});

parcelRegister("5RUw3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $445dbde48afb0e33$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $445dbde48afb0e33$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
var $445dbde48afb0e33$export$2e2bcd8739ae039 = $445dbde48afb0e33$var$stackDelete;

});

parcelRegister("3yskr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $296a858b59d05359$export$2e2bcd8739ae039; });
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $296a858b59d05359$var$stackGet(key) {
    return this.__data__.get(key);
}
var $296a858b59d05359$export$2e2bcd8739ae039 = $296a858b59d05359$var$stackGet;

});

parcelRegister("6Mz8h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f027a6158408837$export$2e2bcd8739ae039; });
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4f027a6158408837$var$stackHas(key) {
    return this.__data__.has(key);
}
var $4f027a6158408837$export$2e2bcd8739ae039 = $4f027a6158408837$var$stackHas;

});

parcelRegister("jX32n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e865e22d14b29bf1$export$2e2bcd8739ae039; });

var $kHwV8 = parcelRequire("kHwV8");

var $aCU3U = parcelRequire("aCU3U");

var $8cY9B = parcelRequire("8cY9B");
/** Used as the size to enable large array optimizations. */ var $e865e22d14b29bf1$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $e865e22d14b29bf1$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kHwV8.default)) {
        var pairs = data.__data__;
        if (!(0, $aCU3U.default) || pairs.length < $e865e22d14b29bf1$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $8cY9B.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $e865e22d14b29bf1$export$2e2bcd8739ae039 = $e865e22d14b29bf1$var$stackSet;

});
parcelRegister("aCU3U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bc8f0bb18aad16b$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");

var $4Dhps = parcelRequire("4Dhps");
/* Built-in method references that are verified to be native. */ var $7bc8f0bb18aad16b$var$Map = (0, $bASuz.default)((0, $4Dhps.default), 'Map');
var $7bc8f0bb18aad16b$export$2e2bcd8739ae039 = $7bc8f0bb18aad16b$var$Map;

});
parcelRegister("bASuz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $870d5378ef6db60c$export$2e2bcd8739ae039; });

var $kRZnS = parcelRequire("kRZnS");

var $4Lz4l = parcelRequire("4Lz4l");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $870d5378ef6db60c$var$getNative(object, key) {
    var value = (0, $4Lz4l.default)(object, key);
    return (0, $kRZnS.default)(value) ? value : undefined;
}
var $870d5378ef6db60c$export$2e2bcd8739ae039 = $870d5378ef6db60c$var$getNative;

});
parcelRegister("kRZnS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f3185f7c57ce42df$export$2e2bcd8739ae039; });

var $1jJnc = parcelRequire("1jJnc");

var $bajf8 = parcelRequire("bajf8");

var $izrsA = parcelRequire("izrsA");

var $i8aSa = parcelRequire("i8aSa");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $f3185f7c57ce42df$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $f3185f7c57ce42df$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $f3185f7c57ce42df$var$funcProto = Function.prototype, $f3185f7c57ce42df$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f3185f7c57ce42df$var$funcToString = $f3185f7c57ce42df$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f3185f7c57ce42df$var$hasOwnProperty = $f3185f7c57ce42df$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $f3185f7c57ce42df$var$reIsNative = RegExp('^' + $f3185f7c57ce42df$var$funcToString.call($f3185f7c57ce42df$var$hasOwnProperty).replace($f3185f7c57ce42df$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $f3185f7c57ce42df$var$baseIsNative(value) {
    if (!(0, $izrsA.default)(value) || (0, $bajf8.default)(value)) return false;
    var pattern = (0, $1jJnc.default)(value) ? $f3185f7c57ce42df$var$reIsNative : $f3185f7c57ce42df$var$reIsHostCtor;
    return pattern.test((0, $i8aSa.default)(value));
}
var $f3185f7c57ce42df$export$2e2bcd8739ae039 = $f3185f7c57ce42df$var$baseIsNative;

});
parcelRegister("1jJnc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f5ac2f11532ca01$export$2e2bcd8739ae039; });

var $bZ4Xc = parcelRequire("bZ4Xc");

var $izrsA = parcelRequire("izrsA");
/** `Object#toString` result references. */ var $0f5ac2f11532ca01$var$asyncTag = '[object AsyncFunction]', $0f5ac2f11532ca01$var$funcTag = '[object Function]', $0f5ac2f11532ca01$var$genTag = '[object GeneratorFunction]', $0f5ac2f11532ca01$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0f5ac2f11532ca01$var$isFunction(value) {
    if (!(0, $izrsA.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $bZ4Xc.default)(value);
    return tag == $0f5ac2f11532ca01$var$funcTag || tag == $0f5ac2f11532ca01$var$genTag || tag == $0f5ac2f11532ca01$var$asyncTag || tag == $0f5ac2f11532ca01$var$proxyTag;
}
var $0f5ac2f11532ca01$export$2e2bcd8739ae039 = $0f5ac2f11532ca01$var$isFunction;

});
parcelRegister("izrsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d850cbe654ee324b$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d850cbe654ee324b$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $d850cbe654ee324b$export$2e2bcd8739ae039 = $d850cbe654ee324b$var$isObject;

});


parcelRegister("bajf8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $820f8e2aa69136f9$export$2e2bcd8739ae039; });

var $klgXO = parcelRequire("klgXO");
/** Used to detect methods masquerading as native. */ var $820f8e2aa69136f9$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $klgXO.default) && (0, $klgXO.default).keys && (0, $klgXO.default).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $820f8e2aa69136f9$var$isMasked(func) {
    return !!$820f8e2aa69136f9$var$maskSrcKey && $820f8e2aa69136f9$var$maskSrcKey in func;
}
var $820f8e2aa69136f9$export$2e2bcd8739ae039 = $820f8e2aa69136f9$var$isMasked;

});
parcelRegister("klgXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecf2ed719f58edcc$export$2e2bcd8739ae039; });

var $4Dhps = parcelRequire("4Dhps");
/** Used to detect overreaching core-js shims. */ var $ecf2ed719f58edcc$var$coreJsData = (0, $4Dhps.default)['__core-js_shared__'];
var $ecf2ed719f58edcc$export$2e2bcd8739ae039 = $ecf2ed719f58edcc$var$coreJsData;

});


parcelRegister("i8aSa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3316875a83ea5a5$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $d3316875a83ea5a5$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $d3316875a83ea5a5$var$funcToString = $d3316875a83ea5a5$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $d3316875a83ea5a5$var$toSource(func) {
    if (func != null) {
        try {
            return $d3316875a83ea5a5$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $d3316875a83ea5a5$export$2e2bcd8739ae039 = $d3316875a83ea5a5$var$toSource;

});


parcelRegister("4Lz4l", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3786c12d0bcf1cfa$export$2e2bcd8739ae039; });
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $3786c12d0bcf1cfa$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $3786c12d0bcf1cfa$export$2e2bcd8739ae039 = $3786c12d0bcf1cfa$var$getValue;

});



parcelRegister("8cY9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f9e1b050d7aafad$export$2e2bcd8739ae039; });

var $01kqm = parcelRequire("01kqm");

var $bwFmp = parcelRequire("bwFmp");

var $EsNGt = parcelRequire("EsNGt");

var $3tgNm = parcelRequire("3tgNm");

var $3WpMN = parcelRequire("3WpMN");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5f9e1b050d7aafad$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$5f9e1b050d7aafad$var$MapCache.prototype.clear = (0, $01kqm.default);
$5f9e1b050d7aafad$var$MapCache.prototype['delete'] = (0, $bwFmp.default);
$5f9e1b050d7aafad$var$MapCache.prototype.get = (0, $EsNGt.default);
$5f9e1b050d7aafad$var$MapCache.prototype.has = (0, $3tgNm.default);
$5f9e1b050d7aafad$var$MapCache.prototype.set = (0, $3WpMN.default);
var $5f9e1b050d7aafad$export$2e2bcd8739ae039 = $5f9e1b050d7aafad$var$MapCache;

});
parcelRegister("01kqm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003fefefb7d1e5e1$export$2e2bcd8739ae039; });

var $jAdTM = parcelRequire("jAdTM");

var $kHwV8 = parcelRequire("kHwV8");

var $aCU3U = parcelRequire("aCU3U");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $003fefefb7d1e5e1$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $jAdTM.default),
        'map': new ((0, $aCU3U.default) || (0, $kHwV8.default)),
        'string': new (0, $jAdTM.default)
    };
}
var $003fefefb7d1e5e1$export$2e2bcd8739ae039 = $003fefefb7d1e5e1$var$mapCacheClear;

});
parcelRegister("jAdTM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $03addfa17fa8b4bf$export$2e2bcd8739ae039; });

var $lWIP1 = parcelRequire("lWIP1");

var $1pRn4 = parcelRequire("1pRn4");

var $f25V2 = parcelRequire("f25V2");

var $ess10 = parcelRequire("ess10");

var $1E4sJ = parcelRequire("1E4sJ");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $03addfa17fa8b4bf$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$03addfa17fa8b4bf$var$Hash.prototype.clear = (0, $lWIP1.default);
$03addfa17fa8b4bf$var$Hash.prototype['delete'] = (0, $1pRn4.default);
$03addfa17fa8b4bf$var$Hash.prototype.get = (0, $f25V2.default);
$03addfa17fa8b4bf$var$Hash.prototype.has = (0, $ess10.default);
$03addfa17fa8b4bf$var$Hash.prototype.set = (0, $1E4sJ.default);
var $03addfa17fa8b4bf$export$2e2bcd8739ae039 = $03addfa17fa8b4bf$var$Hash;

});
parcelRegister("lWIP1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffa1c87893107257$export$2e2bcd8739ae039; });

var $2Wftm = parcelRequire("2Wftm");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $ffa1c87893107257$var$hashClear() {
    this.__data__ = (0, $2Wftm.default) ? (0, $2Wftm.default)(null) : {};
    this.size = 0;
}
var $ffa1c87893107257$export$2e2bcd8739ae039 = $ffa1c87893107257$var$hashClear;

});
parcelRegister("2Wftm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $223d000fa05d4ce3$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");
/* Built-in method references that are verified to be native. */ var $223d000fa05d4ce3$var$nativeCreate = (0, $bASuz.default)(Object, 'create');
var $223d000fa05d4ce3$export$2e2bcd8739ae039 = $223d000fa05d4ce3$var$nativeCreate;

});


parcelRegister("1pRn4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1081869f61511153$export$2e2bcd8739ae039; });
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1081869f61511153$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $1081869f61511153$export$2e2bcd8739ae039 = $1081869f61511153$var$hashDelete;

});

parcelRegister("f25V2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af1ba24cf679f3d6$export$2e2bcd8739ae039; });

var $2Wftm = parcelRequire("2Wftm");
/** Used to stand-in for `undefined` hash values. */ var $af1ba24cf679f3d6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $af1ba24cf679f3d6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $af1ba24cf679f3d6$var$hasOwnProperty = $af1ba24cf679f3d6$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $af1ba24cf679f3d6$var$hashGet(key) {
    var data = this.__data__;
    if (0, $2Wftm.default) {
        var result = data[key];
        return result === $af1ba24cf679f3d6$var$HASH_UNDEFINED ? undefined : result;
    }
    return $af1ba24cf679f3d6$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $af1ba24cf679f3d6$export$2e2bcd8739ae039 = $af1ba24cf679f3d6$var$hashGet;

});

parcelRegister("ess10", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8696979b2589160$export$2e2bcd8739ae039; });

var $2Wftm = parcelRequire("2Wftm");
/** Used for built-in method references. */ var $a8696979b2589160$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a8696979b2589160$var$hasOwnProperty = $a8696979b2589160$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a8696979b2589160$var$hashHas(key) {
    var data = this.__data__;
    return (0, $2Wftm.default) ? data[key] !== undefined : $a8696979b2589160$var$hasOwnProperty.call(data, key);
}
var $a8696979b2589160$export$2e2bcd8739ae039 = $a8696979b2589160$var$hashHas;

});

parcelRegister("1E4sJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $132cfd0a22b98ebe$export$2e2bcd8739ae039; });

var $2Wftm = parcelRequire("2Wftm");
/** Used to stand-in for `undefined` hash values. */ var $132cfd0a22b98ebe$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $132cfd0a22b98ebe$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $2Wftm.default) && value === undefined ? $132cfd0a22b98ebe$var$HASH_UNDEFINED : value;
    return this;
}
var $132cfd0a22b98ebe$export$2e2bcd8739ae039 = $132cfd0a22b98ebe$var$hashSet;

});



parcelRegister("bwFmp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8642c42c9246ed10$export$2e2bcd8739ae039; });

var $jC8GL = parcelRequire("jC8GL");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8642c42c9246ed10$var$mapCacheDelete(key) {
    var result = (0, $jC8GL.default)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $8642c42c9246ed10$export$2e2bcd8739ae039 = $8642c42c9246ed10$var$mapCacheDelete;

});
parcelRegister("jC8GL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4784e567fc26690$export$2e2bcd8739ae039; });

var $iQRXj = parcelRequire("iQRXj");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e4784e567fc26690$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $iQRXj.default)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $e4784e567fc26690$export$2e2bcd8739ae039 = $e4784e567fc26690$var$getMapData;

});
parcelRegister("iQRXj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db96efc7dcb61323$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $db96efc7dcb61323$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $db96efc7dcb61323$export$2e2bcd8739ae039 = $db96efc7dcb61323$var$isKeyable;

});



parcelRegister("EsNGt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $079a13b11d8bbd06$export$2e2bcd8739ae039; });

var $jC8GL = parcelRequire("jC8GL");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $079a13b11d8bbd06$var$mapCacheGet(key) {
    return (0, $jC8GL.default)(this, key).get(key);
}
var $079a13b11d8bbd06$export$2e2bcd8739ae039 = $079a13b11d8bbd06$var$mapCacheGet;

});

parcelRegister("3tgNm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28711bb547457060$export$2e2bcd8739ae039; });

var $jC8GL = parcelRequire("jC8GL");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $28711bb547457060$var$mapCacheHas(key) {
    return (0, $jC8GL.default)(this, key).has(key);
}
var $28711bb547457060$export$2e2bcd8739ae039 = $28711bb547457060$var$mapCacheHas;

});

parcelRegister("3WpMN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2deaca71fde6631d$export$2e2bcd8739ae039; });

var $jC8GL = parcelRequire("jC8GL");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2deaca71fde6631d$var$mapCacheSet(key, value) {
    var data = (0, $jC8GL.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2deaca71fde6631d$export$2e2bcd8739ae039 = $2deaca71fde6631d$var$mapCacheSet;

});




parcelRegister("hWnRm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0fa5c7c857aa139$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d0fa5c7c857aa139$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d0fa5c7c857aa139$export$2e2bcd8739ae039 = $d0fa5c7c857aa139$var$arrayEach;

});

parcelRegister("1Q2ls", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $156c7773d0fe8f65$export$2e2bcd8739ae039; });

var $1Uyns = parcelRequire("1Uyns");

var $knBco = parcelRequire("knBco");
/** Used for built-in method references. */ var $156c7773d0fe8f65$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $156c7773d0fe8f65$var$hasOwnProperty = $156c7773d0fe8f65$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $156c7773d0fe8f65$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($156c7773d0fe8f65$var$hasOwnProperty.call(object, key) && (0, $knBco.default)(objValue, value)) || value === undefined && !(key in object)) (0, $1Uyns.default)(object, key, value);
}
var $156c7773d0fe8f65$export$2e2bcd8739ae039 = $156c7773d0fe8f65$var$assignValue;

});
parcelRegister("1Uyns", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1645b00e75118168$export$2e2bcd8739ae039; });

var $cJPK7 = parcelRequire("cJPK7");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1645b00e75118168$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $cJPK7.default)) (0, $cJPK7.default)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $1645b00e75118168$export$2e2bcd8739ae039 = $1645b00e75118168$var$baseAssignValue;

});
parcelRegister("cJPK7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9461d309536d7fa4$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");
var $9461d309536d7fa4$var$defineProperty = function() {
    try {
        var func = (0, $bASuz.default)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $9461d309536d7fa4$export$2e2bcd8739ae039 = $9461d309536d7fa4$var$defineProperty;

});



parcelRegister("cy498", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922be05d5cd74bf3$export$2e2bcd8739ae039; });

var $bPqnl = parcelRequire("bPqnl");

var $6xWQa = parcelRequire("6xWQa");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $922be05d5cd74bf3$var$baseAssign(object, source) {
    return object && (0, $bPqnl.default)(source, (0, $6xWQa.default)(source), object);
}
var $922be05d5cd74bf3$export$2e2bcd8739ae039 = $922be05d5cd74bf3$var$baseAssign;

});
parcelRegister("bPqnl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89c8eabf16ab8add$export$2e2bcd8739ae039; });

var $1Q2ls = parcelRequire("1Q2ls");

var $1Uyns = parcelRequire("1Uyns");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $89c8eabf16ab8add$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $1Uyns.default)(object, key, newValue);
        else (0, $1Q2ls.default)(object, key, newValue);
    }
    return object;
}
var $89c8eabf16ab8add$export$2e2bcd8739ae039 = $89c8eabf16ab8add$var$copyObject;

});

parcelRegister("6xWQa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c4377a2fecab827$export$2e2bcd8739ae039; });

var $lyHp8 = parcelRequire("lyHp8");

var $3BCvi = parcelRequire("3BCvi");

var $i9SY8 = parcelRequire("i9SY8");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $4c4377a2fecab827$var$keys(object) {
    return (0, $i9SY8.default)(object) ? (0, $lyHp8.default)(object) : (0, $3BCvi.default)(object);
}
var $4c4377a2fecab827$export$2e2bcd8739ae039 = $4c4377a2fecab827$var$keys;

});
parcelRegister("lyHp8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb1e7128676ad135$export$2e2bcd8739ae039; });

var $5SGW7 = parcelRequire("5SGW7");

var $5fqMG = parcelRequire("5fqMG");

var $eCrEi = parcelRequire("eCrEi");

var $5cAsX = parcelRequire("5cAsX");

var $bRMkS = parcelRequire("bRMkS");

var $1rJzz = parcelRequire("1rJzz");
/** Used for built-in method references. */ var $fb1e7128676ad135$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e7128676ad135$var$hasOwnProperty = $fb1e7128676ad135$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $fb1e7128676ad135$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $eCrEi.default)(value), isArg = !isArr && (0, $5fqMG.default)(value), isBuff = !isArr && !isArg && (0, $5cAsX.default)(value), isType = !isArr && !isArg && !isBuff && (0, $1rJzz.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $5SGW7.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $fb1e7128676ad135$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    (0, $bRMkS.default)(key, length)))) result.push(key);
    return result;
}
var $fb1e7128676ad135$export$2e2bcd8739ae039 = $fb1e7128676ad135$var$arrayLikeKeys;

});
parcelRegister("5SGW7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44834d25e31ebd2a$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $44834d25e31ebd2a$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $44834d25e31ebd2a$export$2e2bcd8739ae039 = $44834d25e31ebd2a$var$baseTimes;

});

parcelRegister("5fqMG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d23213d5c3dfefe$export$2e2bcd8739ae039; });

var $cE4nY = parcelRequire("cE4nY");

var $a2zJo = parcelRequire("a2zJo");
/** Used for built-in method references. */ var $3d23213d5c3dfefe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3d23213d5c3dfefe$var$hasOwnProperty = $3d23213d5c3dfefe$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $3d23213d5c3dfefe$var$propertyIsEnumerable = $3d23213d5c3dfefe$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $3d23213d5c3dfefe$var$isArguments = (0, $cE4nY.default)(function() {
    return arguments;
}()) ? (0, $cE4nY.default) : function(value) {
    return (0, $a2zJo.default)(value) && $3d23213d5c3dfefe$var$hasOwnProperty.call(value, 'callee') && !$3d23213d5c3dfefe$var$propertyIsEnumerable.call(value, 'callee');
};
var $3d23213d5c3dfefe$export$2e2bcd8739ae039 = $3d23213d5c3dfefe$var$isArguments;

});
parcelRegister("cE4nY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $934c9f614e97df8d$export$2e2bcd8739ae039; });

var $bZ4Xc = parcelRequire("bZ4Xc");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $934c9f614e97df8d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $934c9f614e97df8d$var$baseIsArguments(value) {
    return (0, $a2zJo.default)(value) && (0, $bZ4Xc.default)(value) == $934c9f614e97df8d$var$argsTag;
}
var $934c9f614e97df8d$export$2e2bcd8739ae039 = $934c9f614e97df8d$var$baseIsArguments;

});


parcelRegister("eCrEi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa4a0fd07ff69057$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $aa4a0fd07ff69057$var$isArray = Array.isArray;
var $aa4a0fd07ff69057$export$2e2bcd8739ae039 = $aa4a0fd07ff69057$var$isArray;

});

parcelRegister("5cAsX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9a5c26eb1b351a$export$2e2bcd8739ae039; });

var $4Dhps = parcelRequire("4Dhps");

var $jgPT5 = parcelRequire("jgPT5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $4Dhps.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $jgPT5.default);
var $3c9a5c26eb1b351a$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("jgPT5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e077c2b2d6be2d1b$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $e077c2b2d6be2d1b$var$stubFalse() {
    return false;
}
var $e077c2b2d6be2d1b$export$2e2bcd8739ae039 = $e077c2b2d6be2d1b$var$stubFalse;

});


parcelRegister("bRMkS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a3a236de8544e83$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $8a3a236de8544e83$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $8a3a236de8544e83$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8a3a236de8544e83$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $8a3a236de8544e83$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $8a3a236de8544e83$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $8a3a236de8544e83$export$2e2bcd8739ae039 = $8a3a236de8544e83$var$isIndex;

});

parcelRegister("1rJzz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10dba9d6a263ecb8$export$2e2bcd8739ae039; });

var $3ldGl = parcelRequire("3ldGl");

var $fVZ5e = parcelRequire("fVZ5e");

var $l4Fbh = parcelRequire("l4Fbh");
/* Node.js helper references. */ var $10dba9d6a263ecb8$var$nodeIsTypedArray = (0, $l4Fbh.default) && (0, $l4Fbh.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $10dba9d6a263ecb8$var$isTypedArray = $10dba9d6a263ecb8$var$nodeIsTypedArray ? (0, $fVZ5e.default)($10dba9d6a263ecb8$var$nodeIsTypedArray) : (0, $3ldGl.default);
var $10dba9d6a263ecb8$export$2e2bcd8739ae039 = $10dba9d6a263ecb8$var$isTypedArray;

});
parcelRegister("3ldGl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26edf23dd4472166$export$2e2bcd8739ae039; });

var $bZ4Xc = parcelRequire("bZ4Xc");

var $cJ9WD = parcelRequire("cJ9WD");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $26edf23dd4472166$var$argsTag = '[object Arguments]', $26edf23dd4472166$var$arrayTag = '[object Array]', $26edf23dd4472166$var$boolTag = '[object Boolean]', $26edf23dd4472166$var$dateTag = '[object Date]', $26edf23dd4472166$var$errorTag = '[object Error]', $26edf23dd4472166$var$funcTag = '[object Function]', $26edf23dd4472166$var$mapTag = '[object Map]', $26edf23dd4472166$var$numberTag = '[object Number]', $26edf23dd4472166$var$objectTag = '[object Object]', $26edf23dd4472166$var$regexpTag = '[object RegExp]', $26edf23dd4472166$var$setTag = '[object Set]', $26edf23dd4472166$var$stringTag = '[object String]', $26edf23dd4472166$var$weakMapTag = '[object WeakMap]';
var $26edf23dd4472166$var$arrayBufferTag = '[object ArrayBuffer]', $26edf23dd4472166$var$dataViewTag = '[object DataView]', $26edf23dd4472166$var$float32Tag = '[object Float32Array]', $26edf23dd4472166$var$float64Tag = '[object Float64Array]', $26edf23dd4472166$var$int8Tag = '[object Int8Array]', $26edf23dd4472166$var$int16Tag = '[object Int16Array]', $26edf23dd4472166$var$int32Tag = '[object Int32Array]', $26edf23dd4472166$var$uint8Tag = '[object Uint8Array]', $26edf23dd4472166$var$uint8ClampedTag = '[object Uint8ClampedArray]', $26edf23dd4472166$var$uint16Tag = '[object Uint16Array]', $26edf23dd4472166$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $26edf23dd4472166$var$typedArrayTags = {};
$26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$float32Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$float64Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$int8Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$int16Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$int32Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$uint8Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$uint8ClampedTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$uint16Tag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$uint32Tag] = true;
$26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$argsTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$arrayTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$arrayBufferTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$boolTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$dataViewTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$dateTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$errorTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$funcTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$mapTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$numberTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$objectTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$regexpTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$setTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$stringTag] = $26edf23dd4472166$var$typedArrayTags[$26edf23dd4472166$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $26edf23dd4472166$var$baseIsTypedArray(value) {
    return (0, $a2zJo.default)(value) && (0, $cJ9WD.default)(value.length) && !!$26edf23dd4472166$var$typedArrayTags[(0, $bZ4Xc.default)(value)];
}
var $26edf23dd4472166$export$2e2bcd8739ae039 = $26edf23dd4472166$var$baseIsTypedArray;

});
parcelRegister("cJ9WD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $944166d81f804cd7$export$2e2bcd8739ae039; });
/** Used as references for various `Number` constants. */ var $944166d81f804cd7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $944166d81f804cd7$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $944166d81f804cd7$var$MAX_SAFE_INTEGER;
}
var $944166d81f804cd7$export$2e2bcd8739ae039 = $944166d81f804cd7$var$isLength;

});


parcelRegister("fVZ5e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b99b8fc7b874f813$export$2e2bcd8739ae039; });
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $b99b8fc7b874f813$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $b99b8fc7b874f813$export$2e2bcd8739ae039 = $b99b8fc7b874f813$var$baseUnary;

});

parcelRegister("l4Fbh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f579ea5d53903590$export$2e2bcd8739ae039; });

var $8SaGN = parcelRequire("8SaGN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $8SaGN.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
var $f579ea5d53903590$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("3BCvi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a02b1d855a87ae3$export$2e2bcd8739ae039; });

var $lX28Y = parcelRequire("lX28Y");

var $5n1u9 = parcelRequire("5n1u9");
/** Used for built-in method references. */ var $2a02b1d855a87ae3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2a02b1d855a87ae3$var$hasOwnProperty = $2a02b1d855a87ae3$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $2a02b1d855a87ae3$var$baseKeys(object) {
    if (!(0, $lX28Y.default)(object)) return (0, $5n1u9.default)(object);
    var result = [];
    for(var key in Object(object))if ($2a02b1d855a87ae3$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
var $2a02b1d855a87ae3$export$2e2bcd8739ae039 = $2a02b1d855a87ae3$var$baseKeys;

});
parcelRegister("lX28Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ffb0c561580d4397$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $ffb0c561580d4397$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ffb0c561580d4397$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $ffb0c561580d4397$var$objectProto;
    return value === proto;
}
var $ffb0c561580d4397$export$2e2bcd8739ae039 = $ffb0c561580d4397$var$isPrototype;

});

parcelRegister("5n1u9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e9040b392bd4d64$export$2e2bcd8739ae039; });

var $jSEb8 = parcelRequire("jSEb8");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3e9040b392bd4d64$var$nativeKeys = (0, $jSEb8.default)(Object.keys, Object);
var $3e9040b392bd4d64$export$2e2bcd8739ae039 = $3e9040b392bd4d64$var$nativeKeys;

});


parcelRegister("i9SY8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d383b4ef0f015eb3$export$2e2bcd8739ae039; });

var $1jJnc = parcelRequire("1jJnc");

var $cJ9WD = parcelRequire("cJ9WD");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $d383b4ef0f015eb3$var$isArrayLike(value) {
    return value != null && (0, $cJ9WD.default)(value.length) && !(0, $1jJnc.default)(value);
}
var $d383b4ef0f015eb3$export$2e2bcd8739ae039 = $d383b4ef0f015eb3$var$isArrayLike;

});



parcelRegister("2wSnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d78c05436f088af$export$2e2bcd8739ae039; });

var $bPqnl = parcelRequire("bPqnl");

var $gexm8 = parcelRequire("gexm8");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1d78c05436f088af$var$baseAssignIn(object, source) {
    return object && (0, $bPqnl.default)(source, (0, $gexm8.default)(source), object);
}
var $1d78c05436f088af$export$2e2bcd8739ae039 = $1d78c05436f088af$var$baseAssignIn;

});
parcelRegister("gexm8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd17d3f67d369fd6$export$2e2bcd8739ae039; });

var $lyHp8 = parcelRequire("lyHp8");

var $7NIPR = parcelRequire("7NIPR");

var $i9SY8 = parcelRequire("i9SY8");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $bd17d3f67d369fd6$var$keysIn(object) {
    return (0, $i9SY8.default)(object) ? (0, $lyHp8.default)(object, true) : (0, $7NIPR.default)(object);
}
var $bd17d3f67d369fd6$export$2e2bcd8739ae039 = $bd17d3f67d369fd6$var$keysIn;

});
parcelRegister("7NIPR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5adfe364af297064$export$2e2bcd8739ae039; });

var $izrsA = parcelRequire("izrsA");

var $lX28Y = parcelRequire("lX28Y");

var $16kar = parcelRequire("16kar");
/** Used for built-in method references. */ var $5adfe364af297064$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5adfe364af297064$var$hasOwnProperty = $5adfe364af297064$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $5adfe364af297064$var$baseKeysIn(object) {
    if (!(0, $izrsA.default)(object)) return (0, $16kar.default)(object);
    var isProto = (0, $lX28Y.default)(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$5adfe364af297064$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $5adfe364af297064$export$2e2bcd8739ae039 = $5adfe364af297064$var$baseKeysIn;

});
parcelRegister("16kar", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd5fecd966a4f33$export$2e2bcd8739ae039; });
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0cd5fecd966a4f33$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $0cd5fecd966a4f33$export$2e2bcd8739ae039 = $0cd5fecd966a4f33$var$nativeKeysIn;

});




parcelRegister("3Hgc7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b11f3232ea8832e$export$2e2bcd8739ae039; });

var $4Dhps = parcelRequire("4Dhps");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $4Dhps.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $2b11f3232ea8832e$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("lW1js", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff80086ee20065f3$export$2e2bcd8739ae039; });
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $ff80086ee20065f3$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $ff80086ee20065f3$export$2e2bcd8739ae039 = $ff80086ee20065f3$var$copyArray;

});

parcelRegister("dyUR1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dfa8d6124c8b4b6$export$2e2bcd8739ae039; });

var $bPqnl = parcelRequire("bPqnl");

var $1xRl5 = parcelRequire("1xRl5");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $9dfa8d6124c8b4b6$var$copySymbols(source, object) {
    return (0, $bPqnl.default)(source, (0, $1xRl5.default)(source), object);
}
var $9dfa8d6124c8b4b6$export$2e2bcd8739ae039 = $9dfa8d6124c8b4b6$var$copySymbols;

});
parcelRegister("1xRl5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12023f8c17cf10fa$export$2e2bcd8739ae039; });

var $2lmGD = parcelRequire("2lmGD");

var $cBu8i = parcelRequire("cBu8i");
/** Used for built-in method references. */ var $12023f8c17cf10fa$var$objectProto = Object.prototype;
/** Built-in value references. */ var $12023f8c17cf10fa$var$propertyIsEnumerable = $12023f8c17cf10fa$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $12023f8c17cf10fa$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $12023f8c17cf10fa$var$getSymbols = !$12023f8c17cf10fa$var$nativeGetSymbols ? (0, $cBu8i.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $2lmGD.default)($12023f8c17cf10fa$var$nativeGetSymbols(object), function(symbol) {
        return $12023f8c17cf10fa$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $12023f8c17cf10fa$export$2e2bcd8739ae039 = $12023f8c17cf10fa$var$getSymbols;

});
parcelRegister("2lmGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b4f240da3b9fc0a$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $1b4f240da3b9fc0a$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $1b4f240da3b9fc0a$export$2e2bcd8739ae039 = $1b4f240da3b9fc0a$var$arrayFilter;

});

parcelRegister("cBu8i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92d0508259234ae3$export$2e2bcd8739ae039; });
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $92d0508259234ae3$var$stubArray() {
    return [];
}
var $92d0508259234ae3$export$2e2bcd8739ae039 = $92d0508259234ae3$var$stubArray;

});



parcelRegister("lBjjk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb9c085ef3deee0a$export$2e2bcd8739ae039; });

var $bPqnl = parcelRequire("bPqnl");

var $9fDdn = parcelRequire("9fDdn");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $fb9c085ef3deee0a$var$copySymbolsIn(source, object) {
    return (0, $bPqnl.default)(source, (0, $9fDdn.default)(source), object);
}
var $fb9c085ef3deee0a$export$2e2bcd8739ae039 = $fb9c085ef3deee0a$var$copySymbolsIn;

});
parcelRegister("9fDdn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bc3eefca8419748$export$2e2bcd8739ae039; });

var $5okvD = parcelRequire("5okvD");

var $hK0og = parcelRequire("hK0og");

var $1xRl5 = parcelRequire("1xRl5");

var $cBu8i = parcelRequire("cBu8i");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6bc3eefca8419748$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6bc3eefca8419748$var$getSymbolsIn = !$6bc3eefca8419748$var$nativeGetSymbols ? (0, $cBu8i.default) : function(object) {
    var result = [];
    while(object){
        (0, $5okvD.default)(result, (0, $1xRl5.default)(object));
        object = (0, $hK0og.default)(object);
    }
    return result;
};
var $6bc3eefca8419748$export$2e2bcd8739ae039 = $6bc3eefca8419748$var$getSymbolsIn;

});
parcelRegister("5okvD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ecf1a5ed50def3e$export$2e2bcd8739ae039; });
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $3ecf1a5ed50def3e$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $3ecf1a5ed50def3e$export$2e2bcd8739ae039 = $3ecf1a5ed50def3e$var$arrayPush;

});



parcelRegister("4qPrG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33a17f26aa39381f$export$2e2bcd8739ae039; });

var $1L4W8 = parcelRequire("1L4W8");

var $1xRl5 = parcelRequire("1xRl5");

var $6xWQa = parcelRequire("6xWQa");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $33a17f26aa39381f$var$getAllKeys(object) {
    return (0, $1L4W8.default)(object, (0, $6xWQa.default), (0, $1xRl5.default));
}
var $33a17f26aa39381f$export$2e2bcd8739ae039 = $33a17f26aa39381f$var$getAllKeys;

});
parcelRegister("1L4W8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $147e028d68334a56$export$2e2bcd8739ae039; });

var $5okvD = parcelRequire("5okvD");

var $eCrEi = parcelRequire("eCrEi");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $147e028d68334a56$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $eCrEi.default)(object) ? result : (0, $5okvD.default)(result, symbolsFunc(object));
}
var $147e028d68334a56$export$2e2bcd8739ae039 = $147e028d68334a56$var$baseGetAllKeys;

});


parcelRegister("3knRy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26c5bffba20fe117$export$2e2bcd8739ae039; });

var $1L4W8 = parcelRequire("1L4W8");

var $9fDdn = parcelRequire("9fDdn");

var $gexm8 = parcelRequire("gexm8");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $26c5bffba20fe117$var$getAllKeysIn(object) {
    return (0, $1L4W8.default)(object, (0, $gexm8.default), (0, $9fDdn.default));
}
var $26c5bffba20fe117$export$2e2bcd8739ae039 = $26c5bffba20fe117$var$getAllKeysIn;

});

parcelRegister("01bPL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0039461097caef97$export$2e2bcd8739ae039; });

var $gTFOp = parcelRequire("gTFOp");

var $aCU3U = parcelRequire("aCU3U");

var $7LHy9 = parcelRequire("7LHy9");

var $HyJ7Z = parcelRequire("HyJ7Z");

var $M4x4N = parcelRequire("M4x4N");

var $bZ4Xc = parcelRequire("bZ4Xc");

var $i8aSa = parcelRequire("i8aSa");
/** `Object#toString` result references. */ var $0039461097caef97$var$mapTag = '[object Map]', $0039461097caef97$var$objectTag = '[object Object]', $0039461097caef97$var$promiseTag = '[object Promise]', $0039461097caef97$var$setTag = '[object Set]', $0039461097caef97$var$weakMapTag = '[object WeakMap]';
var $0039461097caef97$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $0039461097caef97$var$dataViewCtorString = (0, $i8aSa.default)((0, $gTFOp.default)), $0039461097caef97$var$mapCtorString = (0, $i8aSa.default)((0, $aCU3U.default)), $0039461097caef97$var$promiseCtorString = (0, $i8aSa.default)((0, $7LHy9.default)), $0039461097caef97$var$setCtorString = (0, $i8aSa.default)((0, $HyJ7Z.default)), $0039461097caef97$var$weakMapCtorString = (0, $i8aSa.default)((0, $M4x4N.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $0039461097caef97$var$getTag = (0, $bZ4Xc.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $gTFOp.default) && $0039461097caef97$var$getTag(new (0, $gTFOp.default)(new ArrayBuffer(1))) != $0039461097caef97$var$dataViewTag || (0, $aCU3U.default) && $0039461097caef97$var$getTag(new (0, $aCU3U.default)) != $0039461097caef97$var$mapTag || (0, $7LHy9.default) && $0039461097caef97$var$getTag((0, $7LHy9.default).resolve()) != $0039461097caef97$var$promiseTag || (0, $HyJ7Z.default) && $0039461097caef97$var$getTag(new (0, $HyJ7Z.default)) != $0039461097caef97$var$setTag || (0, $M4x4N.default) && $0039461097caef97$var$getTag(new (0, $M4x4N.default)) != $0039461097caef97$var$weakMapTag) $0039461097caef97$var$getTag = function(value) {
    var result = (0, $bZ4Xc.default)(value), Ctor = result == $0039461097caef97$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $i8aSa.default)(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $0039461097caef97$var$dataViewCtorString:
            return $0039461097caef97$var$dataViewTag;
        case $0039461097caef97$var$mapCtorString:
            return $0039461097caef97$var$mapTag;
        case $0039461097caef97$var$promiseCtorString:
            return $0039461097caef97$var$promiseTag;
        case $0039461097caef97$var$setCtorString:
            return $0039461097caef97$var$setTag;
        case $0039461097caef97$var$weakMapCtorString:
            return $0039461097caef97$var$weakMapTag;
    }
    return result;
};
var $0039461097caef97$export$2e2bcd8739ae039 = $0039461097caef97$var$getTag;

});
parcelRegister("gTFOp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4d2376577dcf4ea$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");

var $4Dhps = parcelRequire("4Dhps");
/* Built-in method references that are verified to be native. */ var $c4d2376577dcf4ea$var$DataView = (0, $bASuz.default)((0, $4Dhps.default), 'DataView');
var $c4d2376577dcf4ea$export$2e2bcd8739ae039 = $c4d2376577dcf4ea$var$DataView;

});

parcelRegister("7LHy9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a7eb442f2f66df7$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");

var $4Dhps = parcelRequire("4Dhps");
/* Built-in method references that are verified to be native. */ var $5a7eb442f2f66df7$var$Promise = (0, $bASuz.default)((0, $4Dhps.default), 'Promise');
var $5a7eb442f2f66df7$export$2e2bcd8739ae039 = $5a7eb442f2f66df7$var$Promise;

});

parcelRegister("HyJ7Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $082ef44cbf2fefdf$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");

var $4Dhps = parcelRequire("4Dhps");
/* Built-in method references that are verified to be native. */ var $082ef44cbf2fefdf$var$Set = (0, $bASuz.default)((0, $4Dhps.default), 'Set');
var $082ef44cbf2fefdf$export$2e2bcd8739ae039 = $082ef44cbf2fefdf$var$Set;

});

parcelRegister("M4x4N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0907ffde292ac89d$export$2e2bcd8739ae039; });

var $bASuz = parcelRequire("bASuz");

var $4Dhps = parcelRequire("4Dhps");
/* Built-in method references that are verified to be native. */ var $0907ffde292ac89d$var$WeakMap = (0, $bASuz.default)((0, $4Dhps.default), 'WeakMap');
var $0907ffde292ac89d$export$2e2bcd8739ae039 = $0907ffde292ac89d$var$WeakMap;

});


parcelRegister("agrpx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7790a94120f85a4c$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $7790a94120f85a4c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7790a94120f85a4c$var$hasOwnProperty = $7790a94120f85a4c$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7790a94120f85a4c$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $7790a94120f85a4c$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7790a94120f85a4c$export$2e2bcd8739ae039 = $7790a94120f85a4c$var$initCloneArray;

});

parcelRegister("8bdGX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f49f8bf84fe567b$export$2e2bcd8739ae039; });

var $cS43F = parcelRequire("cS43F");

var $6BSig = parcelRequire("6BSig");

var $kw4VA = parcelRequire("kw4VA");

var $2uTvv = parcelRequire("2uTvv");

var $jAQiz = parcelRequire("jAQiz");
/** `Object#toString` result references. */ var $5f49f8bf84fe567b$var$boolTag = '[object Boolean]', $5f49f8bf84fe567b$var$dateTag = '[object Date]', $5f49f8bf84fe567b$var$mapTag = '[object Map]', $5f49f8bf84fe567b$var$numberTag = '[object Number]', $5f49f8bf84fe567b$var$regexpTag = '[object RegExp]', $5f49f8bf84fe567b$var$setTag = '[object Set]', $5f49f8bf84fe567b$var$stringTag = '[object String]', $5f49f8bf84fe567b$var$symbolTag = '[object Symbol]';
var $5f49f8bf84fe567b$var$arrayBufferTag = '[object ArrayBuffer]', $5f49f8bf84fe567b$var$dataViewTag = '[object DataView]', $5f49f8bf84fe567b$var$float32Tag = '[object Float32Array]', $5f49f8bf84fe567b$var$float64Tag = '[object Float64Array]', $5f49f8bf84fe567b$var$int8Tag = '[object Int8Array]', $5f49f8bf84fe567b$var$int16Tag = '[object Int16Array]', $5f49f8bf84fe567b$var$int32Tag = '[object Int32Array]', $5f49f8bf84fe567b$var$uint8Tag = '[object Uint8Array]', $5f49f8bf84fe567b$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5f49f8bf84fe567b$var$uint16Tag = '[object Uint16Array]', $5f49f8bf84fe567b$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $5f49f8bf84fe567b$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $5f49f8bf84fe567b$var$arrayBufferTag:
            return (0, $cS43F.default)(object);
        case $5f49f8bf84fe567b$var$boolTag:
        case $5f49f8bf84fe567b$var$dateTag:
            return new Ctor(+object);
        case $5f49f8bf84fe567b$var$dataViewTag:
            return (0, $6BSig.default)(object, isDeep);
        case $5f49f8bf84fe567b$var$float32Tag:
        case $5f49f8bf84fe567b$var$float64Tag:
        case $5f49f8bf84fe567b$var$int8Tag:
        case $5f49f8bf84fe567b$var$int16Tag:
        case $5f49f8bf84fe567b$var$int32Tag:
        case $5f49f8bf84fe567b$var$uint8Tag:
        case $5f49f8bf84fe567b$var$uint8ClampedTag:
        case $5f49f8bf84fe567b$var$uint16Tag:
        case $5f49f8bf84fe567b$var$uint32Tag:
            return (0, $jAQiz.default)(object, isDeep);
        case $5f49f8bf84fe567b$var$mapTag:
            return new Ctor;
        case $5f49f8bf84fe567b$var$numberTag:
        case $5f49f8bf84fe567b$var$stringTag:
            return new Ctor(object);
        case $5f49f8bf84fe567b$var$regexpTag:
            return (0, $kw4VA.default)(object);
        case $5f49f8bf84fe567b$var$setTag:
            return new Ctor;
        case $5f49f8bf84fe567b$var$symbolTag:
            return (0, $2uTvv.default)(object);
    }
}
var $5f49f8bf84fe567b$export$2e2bcd8739ae039 = $5f49f8bf84fe567b$var$initCloneByTag;

});
parcelRegister("cS43F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95edad059b9d46b8$export$2e2bcd8739ae039; });

var $207le = parcelRequire("207le");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $95edad059b9d46b8$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $207le.default)(result).set(new (0, $207le.default)(arrayBuffer));
    return result;
}
var $95edad059b9d46b8$export$2e2bcd8739ae039 = $95edad059b9d46b8$var$cloneArrayBuffer;

});
parcelRegister("207le", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $175146b5aa11c15c$export$2e2bcd8739ae039; });

var $4Dhps = parcelRequire("4Dhps");
/** Built-in value references. */ var $175146b5aa11c15c$var$Uint8Array = (0, $4Dhps.default).Uint8Array;
var $175146b5aa11c15c$export$2e2bcd8739ae039 = $175146b5aa11c15c$var$Uint8Array;

});


parcelRegister("6BSig", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d00505d4b0aa22e$export$2e2bcd8739ae039; });

var $cS43F = parcelRequire("cS43F");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $4d00505d4b0aa22e$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $cS43F.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $4d00505d4b0aa22e$export$2e2bcd8739ae039 = $4d00505d4b0aa22e$var$cloneDataView;

});

parcelRegister("kw4VA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eefa9e584f187949$export$2e2bcd8739ae039; });
/** Used to match `RegExp` flags from their coerced string values. */ var $eefa9e584f187949$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $eefa9e584f187949$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $eefa9e584f187949$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $eefa9e584f187949$export$2e2bcd8739ae039 = $eefa9e584f187949$var$cloneRegExp;

});

parcelRegister("2uTvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d1970b18c707542$export$2e2bcd8739ae039; });

var $7xxe9 = parcelRequire("7xxe9");
/** Used to convert symbols to primitives and strings. */ var $1d1970b18c707542$var$symbolProto = (0, $7xxe9.default) ? (0, $7xxe9.default).prototype : undefined, $1d1970b18c707542$var$symbolValueOf = $1d1970b18c707542$var$symbolProto ? $1d1970b18c707542$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $1d1970b18c707542$var$cloneSymbol(symbol) {
    return $1d1970b18c707542$var$symbolValueOf ? Object($1d1970b18c707542$var$symbolValueOf.call(symbol)) : {};
}
var $1d1970b18c707542$export$2e2bcd8739ae039 = $1d1970b18c707542$var$cloneSymbol;

});

parcelRegister("jAQiz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e439f28709387e41$export$2e2bcd8739ae039; });

var $cS43F = parcelRequire("cS43F");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $e439f28709387e41$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $cS43F.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $e439f28709387e41$export$2e2bcd8739ae039 = $e439f28709387e41$var$cloneTypedArray;

});


parcelRegister("739Nd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522068e23a11b981$export$2e2bcd8739ae039; });

var $dlcyF = parcelRequire("dlcyF");

var $hK0og = parcelRequire("hK0og");

var $lX28Y = parcelRequire("lX28Y");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $522068e23a11b981$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !(0, $lX28Y.default)(object) ? (0, $dlcyF.default)((0, $hK0og.default)(object)) : {};
}
var $522068e23a11b981$export$2e2bcd8739ae039 = $522068e23a11b981$var$initCloneObject;

});
parcelRegister("dlcyF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0281a932d689f522$export$2e2bcd8739ae039; });

var $izrsA = parcelRequire("izrsA");
/** Built-in value references. */ var $0281a932d689f522$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $0281a932d689f522$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $izrsA.default)(proto)) return {};
        if ($0281a932d689f522$var$objectCreate) return $0281a932d689f522$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $0281a932d689f522$export$2e2bcd8739ae039 = $0281a932d689f522$var$baseCreate;

});


parcelRegister("5LmWO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $432324795ff63d72$export$2e2bcd8739ae039; });

var $3Nn5F = parcelRequire("3Nn5F");

var $fVZ5e = parcelRequire("fVZ5e");

var $l4Fbh = parcelRequire("l4Fbh");
/* Node.js helper references. */ var $432324795ff63d72$var$nodeIsMap = (0, $l4Fbh.default) && (0, $l4Fbh.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $432324795ff63d72$var$isMap = $432324795ff63d72$var$nodeIsMap ? (0, $fVZ5e.default)($432324795ff63d72$var$nodeIsMap) : (0, $3Nn5F.default);
var $432324795ff63d72$export$2e2bcd8739ae039 = $432324795ff63d72$var$isMap;

});
parcelRegister("3Nn5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c37dbfb55bd4149$export$2e2bcd8739ae039; });

var $01bPL = parcelRequire("01bPL");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $2c37dbfb55bd4149$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $2c37dbfb55bd4149$var$baseIsMap(value) {
    return (0, $a2zJo.default)(value) && (0, $01bPL.default)(value) == $2c37dbfb55bd4149$var$mapTag;
}
var $2c37dbfb55bd4149$export$2e2bcd8739ae039 = $2c37dbfb55bd4149$var$baseIsMap;

});


parcelRegister("5psQA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f05aa026c67e319$export$2e2bcd8739ae039; });

var $1kIpf = parcelRequire("1kIpf");

var $fVZ5e = parcelRequire("fVZ5e");

var $l4Fbh = parcelRequire("l4Fbh");
/* Node.js helper references. */ var $3f05aa026c67e319$var$nodeIsSet = (0, $l4Fbh.default) && (0, $l4Fbh.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $3f05aa026c67e319$var$isSet = $3f05aa026c67e319$var$nodeIsSet ? (0, $fVZ5e.default)($3f05aa026c67e319$var$nodeIsSet) : (0, $1kIpf.default);
var $3f05aa026c67e319$export$2e2bcd8739ae039 = $3f05aa026c67e319$var$isSet;

});
parcelRegister("1kIpf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f8a1ad6e0f780f2$export$2e2bcd8739ae039; });

var $01bPL = parcelRequire("01bPL");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $0f8a1ad6e0f780f2$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $0f8a1ad6e0f780f2$var$baseIsSet(value) {
    return (0, $a2zJo.default)(value) && (0, $01bPL.default)(value) == $0f8a1ad6e0f780f2$var$setTag;
}
var $0f8a1ad6e0f780f2$export$2e2bcd8739ae039 = $0f8a1ad6e0f780f2$var$baseIsSet;

});




parcelRegister("hnuZ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca6c9e9d4aa6ff5e$export$2e2bcd8739ae039; });

var $9A3tH = parcelRequire("9A3tH");

var $lW1js = parcelRequire("lW1js");

var $eCrEi = parcelRequire("eCrEi");

var $2oSMl = parcelRequire("2oSMl");

var $6AEBE = parcelRequire("6AEBE");

var $70zsu = parcelRequire("70zsu");

var $9gEC6 = parcelRequire("9gEC6");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $ca6c9e9d4aa6ff5e$var$toPath(value) {
    if ((0, $eCrEi.default)(value)) return (0, $9A3tH.default)(value, (0, $70zsu.default));
    return (0, $2oSMl.default)(value) ? [
        value
    ] : (0, $lW1js.default)((0, $6AEBE.default)((0, $9gEC6.default)(value)));
}
var $ca6c9e9d4aa6ff5e$export$2e2bcd8739ae039 = $ca6c9e9d4aa6ff5e$var$toPath;

});
parcelRegister("9A3tH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9a2c7dfc7740b9$export$2e2bcd8739ae039; });
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $6f9a2c7dfc7740b9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $6f9a2c7dfc7740b9$export$2e2bcd8739ae039 = $6f9a2c7dfc7740b9$var$arrayMap;

});

parcelRegister("2oSMl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1bf85094ce052e4e$export$2e2bcd8739ae039; });

var $bZ4Xc = parcelRequire("bZ4Xc");

var $a2zJo = parcelRequire("a2zJo");
/** `Object#toString` result references. */ var $1bf85094ce052e4e$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1bf85094ce052e4e$var$isSymbol(value) {
    return typeof value == 'symbol' || (0, $a2zJo.default)(value) && (0, $bZ4Xc.default)(value) == $1bf85094ce052e4e$var$symbolTag;
}
var $1bf85094ce052e4e$export$2e2bcd8739ae039 = $1bf85094ce052e4e$var$isSymbol;

});

parcelRegister("6AEBE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cc59a70c1c25e3a$export$2e2bcd8739ae039; });

var $kjiy6 = parcelRequire("kjiy6");
/** Used to match property names within property paths. */ var $4cc59a70c1c25e3a$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4cc59a70c1c25e3a$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4cc59a70c1c25e3a$var$stringToPath = (0, $kjiy6.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($4cc59a70c1c25e3a$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4cc59a70c1c25e3a$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $4cc59a70c1c25e3a$export$2e2bcd8739ae039 = $4cc59a70c1c25e3a$var$stringToPath;

});
parcelRegister("kjiy6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec93f86d892e2f09$export$2e2bcd8739ae039; });

var $engA8 = parcelRequire("engA8");
/** Used as the maximum memoize cache size. */ var $ec93f86d892e2f09$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $ec93f86d892e2f09$var$memoizeCapped(func) {
    var result = (0, $engA8.default)(func, function(key) {
        if (cache.size === $ec93f86d892e2f09$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $ec93f86d892e2f09$export$2e2bcd8739ae039 = $ec93f86d892e2f09$var$memoizeCapped;

});
parcelRegister("engA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b35b2730e210d2$export$2e2bcd8739ae039; });

var $8cY9B = parcelRequire("8cY9B");
/** Error message constants. */ var $02b35b2730e210d2$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $02b35b2730e210d2$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($02b35b2730e210d2$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($02b35b2730e210d2$var$memoize.Cache || (0, $8cY9B.default));
    return memoized;
}
// Expose `MapCache`.
$02b35b2730e210d2$var$memoize.Cache = (0, $8cY9B.default);
var $02b35b2730e210d2$export$2e2bcd8739ae039 = $02b35b2730e210d2$var$memoize;

});



parcelRegister("70zsu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51a409d4e9af03e6$export$2e2bcd8739ae039; });

var $2oSMl = parcelRequire("2oSMl");
/** Used as references for various `Number` constants. */ var $51a409d4e9af03e6$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $51a409d4e9af03e6$var$toKey(value) {
    if (typeof value == 'string' || (0, $2oSMl.default)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$51a409d4e9af03e6$var$INFINITY ? '-0' : result;
}
var $51a409d4e9af03e6$export$2e2bcd8739ae039 = $51a409d4e9af03e6$var$toKey;

});

parcelRegister("9gEC6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6bf51cb5bbfcc5a5$export$2e2bcd8739ae039; });

var $2FayE = parcelRequire("2FayE");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $6bf51cb5bbfcc5a5$var$toString(value) {
    return value == null ? '' : (0, $2FayE.default)(value);
}
var $6bf51cb5bbfcc5a5$export$2e2bcd8739ae039 = $6bf51cb5bbfcc5a5$var$toString;

});
parcelRegister("2FayE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f0799b270a651fc$export$2e2bcd8739ae039; });

var $7xxe9 = parcelRequire("7xxe9");

var $9A3tH = parcelRequire("9A3tH");

var $eCrEi = parcelRequire("eCrEi");

var $2oSMl = parcelRequire("2oSMl");
/** Used as references for various `Number` constants. */ var $1f0799b270a651fc$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $1f0799b270a651fc$var$symbolProto = (0, $7xxe9.default) ? (0, $7xxe9.default).prototype : undefined, $1f0799b270a651fc$var$symbolToString = $1f0799b270a651fc$var$symbolProto ? $1f0799b270a651fc$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $1f0799b270a651fc$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $eCrEi.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $9A3tH.default)(value, $1f0799b270a651fc$var$baseToString) + '';
    if ((0, $2oSMl.default)(value)) return $1f0799b270a651fc$var$symbolToString ? $1f0799b270a651fc$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$1f0799b270a651fc$var$INFINITY ? '-0' : result;
}
var $1f0799b270a651fc$export$2e2bcd8739ae039 = $1f0799b270a651fc$var$baseToString;

});



parcelRegister("6fGvd", function(module, exports) {
'use strict';

var $3bEOD = parcelRequire("3bEOD");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $012cba45d14f45a6$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $012cba45d14f45a6$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $012cba45d14f45a6$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $012cba45d14f45a6$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $012cba45d14f45a6$var$TYPE_STATICS = {};
$012cba45d14f45a6$var$TYPE_STATICS[$3bEOD.ForwardRef] = $012cba45d14f45a6$var$FORWARD_REF_STATICS;
$012cba45d14f45a6$var$TYPE_STATICS[$3bEOD.Memo] = $012cba45d14f45a6$var$MEMO_STATICS;
function $012cba45d14f45a6$var$getStatics(component) {
    // React v16.11 and below
    if ($3bEOD.isMemo(component)) return $012cba45d14f45a6$var$MEMO_STATICS;
     // React v16.12 and above
    return $012cba45d14f45a6$var$TYPE_STATICS[component['$$typeof']] || $012cba45d14f45a6$var$REACT_STATICS;
}
var $012cba45d14f45a6$var$defineProperty = Object.defineProperty;
var $012cba45d14f45a6$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $012cba45d14f45a6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $012cba45d14f45a6$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $012cba45d14f45a6$var$getPrototypeOf = Object.getPrototypeOf;
var $012cba45d14f45a6$var$objectPrototype = Object.prototype;
function $012cba45d14f45a6$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($012cba45d14f45a6$var$objectPrototype) {
            var inheritedComponent = $012cba45d14f45a6$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $012cba45d14f45a6$var$objectPrototype) $012cba45d14f45a6$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $012cba45d14f45a6$var$getOwnPropertyNames(sourceComponent);
        if ($012cba45d14f45a6$var$getOwnPropertySymbols) keys = keys.concat($012cba45d14f45a6$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $012cba45d14f45a6$var$getStatics(targetComponent);
        var sourceStatics = $012cba45d14f45a6$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$012cba45d14f45a6$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $012cba45d14f45a6$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $012cba45d14f45a6$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $012cba45d14f45a6$var$hoistNonReactStatics;

});
parcelRegister("3bEOD", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a3jeE"));

});
parcelRegister("a3jeE", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $75191af0d5812b6c$export$2b8d127b894957b9; }, function (v) { return $75191af0d5812b6c$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $75191af0d5812b6c$export$cea3a54a6425200c; }, function (v) { return $75191af0d5812b6c$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $75191af0d5812b6c$export$a7c73072b1a182ae; }, function (v) { return $75191af0d5812b6c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $75191af0d5812b6c$export$9f27bc3417b4524d; }, function (v) { return $75191af0d5812b6c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $75191af0d5812b6c$export$db77ccec0bb4ccac; }, function (v) { return $75191af0d5812b6c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $75191af0d5812b6c$export$8392c0c9d3dcbd35; }, function (v) { return $75191af0d5812b6c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $75191af0d5812b6c$export$ffb0004e005737fa; }, function (v) { return $75191af0d5812b6c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $75191af0d5812b6c$export$b624eff549462981; }, function (v) { return $75191af0d5812b6c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $75191af0d5812b6c$export$7897aa7841a5380c; }, function (v) { return $75191af0d5812b6c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $75191af0d5812b6c$export$602eac185826482c; }, function (v) { return $75191af0d5812b6c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $75191af0d5812b6c$export$e2c29f18771995cb; }, function (v) { return $75191af0d5812b6c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $75191af0d5812b6c$export$5f8d39834fd61797; }, function (v) { return $75191af0d5812b6c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $75191af0d5812b6c$export$74bf444e3cd11ea5; }, function (v) { return $75191af0d5812b6c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $75191af0d5812b6c$export$92387174baf9b227; }, function (v) { return $75191af0d5812b6c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $75191af0d5812b6c$export$ec112efeb987d9c6; }, function (v) { return $75191af0d5812b6c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $75191af0d5812b6c$export$b706b080d889d2c9; }, function (v) { return $75191af0d5812b6c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $75191af0d5812b6c$export$5be5a87408f70ddc; }, function (v) { return $75191af0d5812b6c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $75191af0d5812b6c$export$45a5e7f76e0caa8d; }, function (v) { return $75191af0d5812b6c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $75191af0d5812b6c$export$455c2e768291efa6; }, function (v) { return $75191af0d5812b6c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $75191af0d5812b6c$export$9522e17588c12572; }, function (v) { return $75191af0d5812b6c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $75191af0d5812b6c$export$2110ac352bb060b9; }, function (v) { return $75191af0d5812b6c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $75191af0d5812b6c$export$56885ab8b9c456ab; }, function (v) { return $75191af0d5812b6c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $75191af0d5812b6c$export$d927fcb6adf8f9de; }, function (v) { return $75191af0d5812b6c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $75191af0d5812b6c$export$b82d16f27459e05a; }, function (v) { return $75191af0d5812b6c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $75191af0d5812b6c$export$522c17b4f5e123e8; }, function (v) { return $75191af0d5812b6c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $75191af0d5812b6c$export$1aabd8a0274ecfd6; }, function (v) { return $75191af0d5812b6c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $75191af0d5812b6c$export$9b621391a187a31a; }, function (v) { return $75191af0d5812b6c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $75191af0d5812b6c$export$f5bbd400c2f4426f; }, function (v) { return $75191af0d5812b6c$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $75191af0d5812b6c$export$2b8d127b894957b9;
var $75191af0d5812b6c$export$cea3a54a6425200c;
var $75191af0d5812b6c$export$a7c73072b1a182ae;
var $75191af0d5812b6c$export$9f27bc3417b4524d;
var $75191af0d5812b6c$export$db77ccec0bb4ccac;
var $75191af0d5812b6c$export$8392c0c9d3dcbd35;
var $75191af0d5812b6c$export$ffb0004e005737fa;
var $75191af0d5812b6c$export$b624eff549462981;
var $75191af0d5812b6c$export$7897aa7841a5380c;
var $75191af0d5812b6c$export$602eac185826482c;
var $75191af0d5812b6c$export$e2c29f18771995cb;
var $75191af0d5812b6c$export$5f8d39834fd61797;
var $75191af0d5812b6c$export$74bf444e3cd11ea5;
var $75191af0d5812b6c$export$92387174baf9b227;
var $75191af0d5812b6c$export$ec112efeb987d9c6;
var $75191af0d5812b6c$export$b706b080d889d2c9;
var $75191af0d5812b6c$export$5be5a87408f70ddc;
var $75191af0d5812b6c$export$45a5e7f76e0caa8d;
var $75191af0d5812b6c$export$455c2e768291efa6;
var $75191af0d5812b6c$export$9522e17588c12572;
var $75191af0d5812b6c$export$2110ac352bb060b9;
var $75191af0d5812b6c$export$56885ab8b9c456ab;
var $75191af0d5812b6c$export$d927fcb6adf8f9de;
var $75191af0d5812b6c$export$b82d16f27459e05a;
var $75191af0d5812b6c$export$522c17b4f5e123e8;
var $75191af0d5812b6c$export$1aabd8a0274ecfd6;
var $75191af0d5812b6c$export$9b621391a187a31a;
var $75191af0d5812b6c$export$f5bbd400c2f4426f;
'use strict';
var $75191af0d5812b6c$var$b = "function" === typeof Symbol && Symbol.for, $75191af0d5812b6c$var$c = $75191af0d5812b6c$var$b ? Symbol.for("react.element") : 60103, $75191af0d5812b6c$var$d = $75191af0d5812b6c$var$b ? Symbol.for("react.portal") : 60106, $75191af0d5812b6c$var$e = $75191af0d5812b6c$var$b ? Symbol.for("react.fragment") : 60107, $75191af0d5812b6c$var$f = $75191af0d5812b6c$var$b ? Symbol.for("react.strict_mode") : 60108, $75191af0d5812b6c$var$g = $75191af0d5812b6c$var$b ? Symbol.for("react.profiler") : 60114, $75191af0d5812b6c$var$h = $75191af0d5812b6c$var$b ? Symbol.for("react.provider") : 60109, $75191af0d5812b6c$var$k = $75191af0d5812b6c$var$b ? Symbol.for("react.context") : 60110, $75191af0d5812b6c$var$l = $75191af0d5812b6c$var$b ? Symbol.for("react.async_mode") : 60111, $75191af0d5812b6c$var$m = $75191af0d5812b6c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $75191af0d5812b6c$var$n = $75191af0d5812b6c$var$b ? Symbol.for("react.forward_ref") : 60112, $75191af0d5812b6c$var$p = $75191af0d5812b6c$var$b ? Symbol.for("react.suspense") : 60113, $75191af0d5812b6c$var$q = $75191af0d5812b6c$var$b ? Symbol.for("react.suspense_list") : 60120, $75191af0d5812b6c$var$r = $75191af0d5812b6c$var$b ? Symbol.for("react.memo") : 60115, $75191af0d5812b6c$var$t = $75191af0d5812b6c$var$b ? Symbol.for("react.lazy") : 60116, $75191af0d5812b6c$var$v = $75191af0d5812b6c$var$b ? Symbol.for("react.block") : 60121, $75191af0d5812b6c$var$w = $75191af0d5812b6c$var$b ? Symbol.for("react.fundamental") : 60117, $75191af0d5812b6c$var$x = $75191af0d5812b6c$var$b ? Symbol.for("react.responder") : 60118, $75191af0d5812b6c$var$y = $75191af0d5812b6c$var$b ? Symbol.for("react.scope") : 60119;
function $75191af0d5812b6c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $75191af0d5812b6c$var$c:
                switch(a = a.type, a){
                    case $75191af0d5812b6c$var$l:
                    case $75191af0d5812b6c$var$m:
                    case $75191af0d5812b6c$var$e:
                    case $75191af0d5812b6c$var$g:
                    case $75191af0d5812b6c$var$f:
                    case $75191af0d5812b6c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $75191af0d5812b6c$var$k:
                            case $75191af0d5812b6c$var$n:
                            case $75191af0d5812b6c$var$t:
                            case $75191af0d5812b6c$var$r:
                            case $75191af0d5812b6c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $75191af0d5812b6c$var$d:
                return u;
        }
    }
}
function $75191af0d5812b6c$var$A(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$m;
}
$75191af0d5812b6c$export$2b8d127b894957b9 = $75191af0d5812b6c$var$l;
$75191af0d5812b6c$export$cea3a54a6425200c = $75191af0d5812b6c$var$m;
$75191af0d5812b6c$export$a7c73072b1a182ae = $75191af0d5812b6c$var$k;
$75191af0d5812b6c$export$9f27bc3417b4524d = $75191af0d5812b6c$var$h;
$75191af0d5812b6c$export$db77ccec0bb4ccac = $75191af0d5812b6c$var$c;
$75191af0d5812b6c$export$8392c0c9d3dcbd35 = $75191af0d5812b6c$var$n;
$75191af0d5812b6c$export$ffb0004e005737fa = $75191af0d5812b6c$var$e;
$75191af0d5812b6c$export$b624eff549462981 = $75191af0d5812b6c$var$t;
$75191af0d5812b6c$export$7897aa7841a5380c = $75191af0d5812b6c$var$r;
$75191af0d5812b6c$export$602eac185826482c = $75191af0d5812b6c$var$d;
$75191af0d5812b6c$export$e2c29f18771995cb = $75191af0d5812b6c$var$g;
$75191af0d5812b6c$export$5f8d39834fd61797 = $75191af0d5812b6c$var$f;
$75191af0d5812b6c$export$74bf444e3cd11ea5 = $75191af0d5812b6c$var$p;
$75191af0d5812b6c$export$92387174baf9b227 = function(a) {
    return $75191af0d5812b6c$var$A(a) || $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$l;
};
$75191af0d5812b6c$export$ec112efeb987d9c6 = $75191af0d5812b6c$var$A;
$75191af0d5812b6c$export$b706b080d889d2c9 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$k;
};
$75191af0d5812b6c$export$5be5a87408f70ddc = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$h;
};
$75191af0d5812b6c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $75191af0d5812b6c$var$c;
};
$75191af0d5812b6c$export$455c2e768291efa6 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$n;
};
$75191af0d5812b6c$export$9522e17588c12572 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$e;
};
$75191af0d5812b6c$export$2110ac352bb060b9 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$t;
};
$75191af0d5812b6c$export$56885ab8b9c456ab = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$r;
};
$75191af0d5812b6c$export$d927fcb6adf8f9de = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$d;
};
$75191af0d5812b6c$export$b82d16f27459e05a = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$g;
};
$75191af0d5812b6c$export$522c17b4f5e123e8 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$f;
};
$75191af0d5812b6c$export$1aabd8a0274ecfd6 = function(a) {
    return $75191af0d5812b6c$var$z(a) === $75191af0d5812b6c$var$p;
};
$75191af0d5812b6c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $75191af0d5812b6c$var$e || a === $75191af0d5812b6c$var$m || a === $75191af0d5812b6c$var$g || a === $75191af0d5812b6c$var$f || a === $75191af0d5812b6c$var$p || a === $75191af0d5812b6c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $75191af0d5812b6c$var$t || a.$$typeof === $75191af0d5812b6c$var$r || a.$$typeof === $75191af0d5812b6c$var$h || a.$$typeof === $75191af0d5812b6c$var$k || a.$$typeof === $75191af0d5812b6c$var$n || a.$$typeof === $75191af0d5812b6c$var$w || a.$$typeof === $75191af0d5812b6c$var$x || a.$$typeof === $75191af0d5812b6c$var$y || a.$$typeof === $75191af0d5812b6c$var$v);
};
$75191af0d5812b6c$export$f5bbd400c2f4426f = $75191af0d5812b6c$var$z;

});



parcelRegister("frVnn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3f5e24d8ef6547f$export$2e2bcd8739ae039; });

var $jBV00 = parcelRequire("jBV00");
/** Used to compose bitmasks for cloning. */ var $b3f5e24d8ef6547f$var$CLONE_DEEP_FLAG = 1, $b3f5e24d8ef6547f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b3f5e24d8ef6547f$var$cloneDeep(value) {
    return (0, $jBV00.default)(value, $b3f5e24d8ef6547f$var$CLONE_DEEP_FLAG | $b3f5e24d8ef6547f$var$CLONE_SYMBOLS_FLAG);
}
var $b3f5e24d8ef6547f$export$2e2bcd8739ae039 = $b3f5e24d8ef6547f$var$cloneDeep;

});


parcelRegister("i1hPd", function(module, exports) {

var $UeyW6 = parcelRequire("UeyW6");

var $7w50Q = parcelRequire("7w50Q");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $UeyW6.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7w50Q;
module.exports = isBuffer;

});
parcelRegister("UeyW6", function(module, exports) {

var $eRle9 = parcelRequire("eRle9");
/** Detect free variable `self`. */ var $0a9086e2363f7fc4$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0a9086e2363f7fc4$var$root = $eRle9 || $0a9086e2363f7fc4$var$freeSelf || Function('return this')();
module.exports = $0a9086e2363f7fc4$var$root;

});
parcelRegister("eRle9", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ad167b36709d210e$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ad167b36709d210e$var$freeGlobal;

});


parcelRegister("7w50Q", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $578f68f174c3465b$var$stubFalse() {
    return false;
}
module.exports = $578f68f174c3465b$var$stubFalse;

});


parcelRegister("8PRF0", function(module, exports) {

var $eRle9 = parcelRequire("eRle9");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $eRle9.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("aoNgk", function(module, exports) {

var $9eM72 = parcelRequire("9eM72");
module.exports = $9eM72("lvUAD").then(()=>parcelRequire('30Ger'));

});
parcelRegister("9eM72", function(module, exports) {
"use strict";

function $6b9abdfc6a864b2d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("d7Bg1")).resolve(id));
}
module.exports = $6b9abdfc6a864b2d$var$load;

});


parcelRegister("6HyT4", function(module, exports) {

var $jEjAi = parcelRequire("jEjAi");

var $i8UNp = parcelRequire("i8UNp");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jEjAi.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $i8UNp;
module.exports = isBuffer;

});
parcelRegister("jEjAi", function(module, exports) {

var $baHLw = parcelRequire("baHLw");
/** Detect free variable `self`. */ var $e4e0f1c8a1ea9bbb$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e4e0f1c8a1ea9bbb$var$root = $baHLw || $e4e0f1c8a1ea9bbb$var$freeSelf || Function('return this')();
module.exports = $e4e0f1c8a1ea9bbb$var$root;

});
parcelRegister("baHLw", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $822293c9fce705f7$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $822293c9fce705f7$var$freeGlobal;

});


parcelRegister("i8UNp", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $d35507d1950d567a$var$stubFalse() {
    return false;
}
module.exports = $d35507d1950d567a$var$stubFalse;

});


parcelRegister("e2zM3", function(module, exports) {

var $baHLw = parcelRequire("baHLw");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $baHLw.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("lDJSj", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $fc10d34e83ba7aa7$export$a7c73072b1a182ae; }, function (v) { return $fc10d34e83ba7aa7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $fc10d34e83ba7aa7$export$9f27bc3417b4524d; }, function (v) { return $fc10d34e83ba7aa7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $fc10d34e83ba7aa7$export$db77ccec0bb4ccac; }, function (v) { return $fc10d34e83ba7aa7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $fc10d34e83ba7aa7$export$8392c0c9d3dcbd35; }, function (v) { return $fc10d34e83ba7aa7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $fc10d34e83ba7aa7$export$ffb0004e005737fa; }, function (v) { return $fc10d34e83ba7aa7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $fc10d34e83ba7aa7$export$b624eff549462981; }, function (v) { return $fc10d34e83ba7aa7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $fc10d34e83ba7aa7$export$7897aa7841a5380c; }, function (v) { return $fc10d34e83ba7aa7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $fc10d34e83ba7aa7$export$602eac185826482c; }, function (v) { return $fc10d34e83ba7aa7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $fc10d34e83ba7aa7$export$e2c29f18771995cb; }, function (v) { return $fc10d34e83ba7aa7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $fc10d34e83ba7aa7$export$5f8d39834fd61797; }, function (v) { return $fc10d34e83ba7aa7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $fc10d34e83ba7aa7$export$74bf444e3cd11ea5; }, function (v) { return $fc10d34e83ba7aa7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $fc10d34e83ba7aa7$export$92387174baf9b227; }, function (v) { return $fc10d34e83ba7aa7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $fc10d34e83ba7aa7$export$ec112efeb987d9c6; }, function (v) { return $fc10d34e83ba7aa7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $fc10d34e83ba7aa7$export$b706b080d889d2c9; }, function (v) { return $fc10d34e83ba7aa7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $fc10d34e83ba7aa7$export$5be5a87408f70ddc; }, function (v) { return $fc10d34e83ba7aa7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $fc10d34e83ba7aa7$export$45a5e7f76e0caa8d; }, function (v) { return $fc10d34e83ba7aa7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $fc10d34e83ba7aa7$export$455c2e768291efa6; }, function (v) { return $fc10d34e83ba7aa7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $fc10d34e83ba7aa7$export$9522e17588c12572; }, function (v) { return $fc10d34e83ba7aa7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $fc10d34e83ba7aa7$export$2110ac352bb060b9; }, function (v) { return $fc10d34e83ba7aa7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $fc10d34e83ba7aa7$export$56885ab8b9c456ab; }, function (v) { return $fc10d34e83ba7aa7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $fc10d34e83ba7aa7$export$d927fcb6adf8f9de; }, function (v) { return $fc10d34e83ba7aa7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $fc10d34e83ba7aa7$export$b82d16f27459e05a; }, function (v) { return $fc10d34e83ba7aa7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $fc10d34e83ba7aa7$export$522c17b4f5e123e8; }, function (v) { return $fc10d34e83ba7aa7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $fc10d34e83ba7aa7$export$1aabd8a0274ecfd6; }, function (v) { return $fc10d34e83ba7aa7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $fc10d34e83ba7aa7$export$9b621391a187a31a; }, function (v) { return $fc10d34e83ba7aa7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $fc10d34e83ba7aa7$export$f5bbd400c2f4426f; }, function (v) { return $fc10d34e83ba7aa7$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fc10d34e83ba7aa7$export$a7c73072b1a182ae;
var $fc10d34e83ba7aa7$export$9f27bc3417b4524d;
var $fc10d34e83ba7aa7$export$db77ccec0bb4ccac;
var $fc10d34e83ba7aa7$export$8392c0c9d3dcbd35;
var $fc10d34e83ba7aa7$export$ffb0004e005737fa;
var $fc10d34e83ba7aa7$export$b624eff549462981;
var $fc10d34e83ba7aa7$export$7897aa7841a5380c;
var $fc10d34e83ba7aa7$export$602eac185826482c;
var $fc10d34e83ba7aa7$export$e2c29f18771995cb;
var $fc10d34e83ba7aa7$export$5f8d39834fd61797;
var $fc10d34e83ba7aa7$export$74bf444e3cd11ea5;
var $fc10d34e83ba7aa7$export$92387174baf9b227;
var $fc10d34e83ba7aa7$export$ec112efeb987d9c6;
var $fc10d34e83ba7aa7$export$b706b080d889d2c9;
var $fc10d34e83ba7aa7$export$5be5a87408f70ddc;
var $fc10d34e83ba7aa7$export$45a5e7f76e0caa8d;
var $fc10d34e83ba7aa7$export$455c2e768291efa6;
var $fc10d34e83ba7aa7$export$9522e17588c12572;
var $fc10d34e83ba7aa7$export$2110ac352bb060b9;
var $fc10d34e83ba7aa7$export$56885ab8b9c456ab;
var $fc10d34e83ba7aa7$export$d927fcb6adf8f9de;
var $fc10d34e83ba7aa7$export$b82d16f27459e05a;
var $fc10d34e83ba7aa7$export$522c17b4f5e123e8;
var $fc10d34e83ba7aa7$export$1aabd8a0274ecfd6;
var $fc10d34e83ba7aa7$export$9b621391a187a31a;
var $fc10d34e83ba7aa7$export$f5bbd400c2f4426f;
'use strict';
var $fc10d34e83ba7aa7$var$b = 60103, $fc10d34e83ba7aa7$var$c = 60106, $fc10d34e83ba7aa7$var$d = 60107, $fc10d34e83ba7aa7$var$e = 60108, $fc10d34e83ba7aa7$var$f = 60114, $fc10d34e83ba7aa7$var$g = 60109, $fc10d34e83ba7aa7$var$h = 60110, $fc10d34e83ba7aa7$var$k = 60112, $fc10d34e83ba7aa7$var$l = 60113, $fc10d34e83ba7aa7$var$m = 60120, $fc10d34e83ba7aa7$var$n = 60115, $fc10d34e83ba7aa7$var$p = 60116, $fc10d34e83ba7aa7$var$q = 60121, $fc10d34e83ba7aa7$var$r = 60122, $fc10d34e83ba7aa7$var$u = 60117, $fc10d34e83ba7aa7$var$v = 60129, $fc10d34e83ba7aa7$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $fc10d34e83ba7aa7$var$x = Symbol.for;
    $fc10d34e83ba7aa7$var$b = $fc10d34e83ba7aa7$var$x("react.element");
    $fc10d34e83ba7aa7$var$c = $fc10d34e83ba7aa7$var$x("react.portal");
    $fc10d34e83ba7aa7$var$d = $fc10d34e83ba7aa7$var$x("react.fragment");
    $fc10d34e83ba7aa7$var$e = $fc10d34e83ba7aa7$var$x("react.strict_mode");
    $fc10d34e83ba7aa7$var$f = $fc10d34e83ba7aa7$var$x("react.profiler");
    $fc10d34e83ba7aa7$var$g = $fc10d34e83ba7aa7$var$x("react.provider");
    $fc10d34e83ba7aa7$var$h = $fc10d34e83ba7aa7$var$x("react.context");
    $fc10d34e83ba7aa7$var$k = $fc10d34e83ba7aa7$var$x("react.forward_ref");
    $fc10d34e83ba7aa7$var$l = $fc10d34e83ba7aa7$var$x("react.suspense");
    $fc10d34e83ba7aa7$var$m = $fc10d34e83ba7aa7$var$x("react.suspense_list");
    $fc10d34e83ba7aa7$var$n = $fc10d34e83ba7aa7$var$x("react.memo");
    $fc10d34e83ba7aa7$var$p = $fc10d34e83ba7aa7$var$x("react.lazy");
    $fc10d34e83ba7aa7$var$q = $fc10d34e83ba7aa7$var$x("react.block");
    $fc10d34e83ba7aa7$var$r = $fc10d34e83ba7aa7$var$x("react.server.block");
    $fc10d34e83ba7aa7$var$u = $fc10d34e83ba7aa7$var$x("react.fundamental");
    $fc10d34e83ba7aa7$var$v = $fc10d34e83ba7aa7$var$x("react.debug_trace_mode");
    $fc10d34e83ba7aa7$var$w = $fc10d34e83ba7aa7$var$x("react.legacy_hidden");
}
function $fc10d34e83ba7aa7$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $fc10d34e83ba7aa7$var$b:
                switch(a = a.type, a){
                    case $fc10d34e83ba7aa7$var$d:
                    case $fc10d34e83ba7aa7$var$f:
                    case $fc10d34e83ba7aa7$var$e:
                    case $fc10d34e83ba7aa7$var$l:
                    case $fc10d34e83ba7aa7$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $fc10d34e83ba7aa7$var$h:
                            case $fc10d34e83ba7aa7$var$k:
                            case $fc10d34e83ba7aa7$var$p:
                            case $fc10d34e83ba7aa7$var$n:
                            case $fc10d34e83ba7aa7$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $fc10d34e83ba7aa7$var$c:
                return t;
        }
    }
}
var $fc10d34e83ba7aa7$var$z = $fc10d34e83ba7aa7$var$g, $fc10d34e83ba7aa7$var$A = $fc10d34e83ba7aa7$var$b, $fc10d34e83ba7aa7$var$B = $fc10d34e83ba7aa7$var$k, $fc10d34e83ba7aa7$var$C = $fc10d34e83ba7aa7$var$d, $fc10d34e83ba7aa7$var$D = $fc10d34e83ba7aa7$var$p, $fc10d34e83ba7aa7$var$E = $fc10d34e83ba7aa7$var$n, $fc10d34e83ba7aa7$var$F = $fc10d34e83ba7aa7$var$c, $fc10d34e83ba7aa7$var$G = $fc10d34e83ba7aa7$var$f, $fc10d34e83ba7aa7$var$H = $fc10d34e83ba7aa7$var$e, $fc10d34e83ba7aa7$var$I = $fc10d34e83ba7aa7$var$l;
$fc10d34e83ba7aa7$export$a7c73072b1a182ae = $fc10d34e83ba7aa7$var$h;
$fc10d34e83ba7aa7$export$9f27bc3417b4524d = $fc10d34e83ba7aa7$var$z;
$fc10d34e83ba7aa7$export$db77ccec0bb4ccac = $fc10d34e83ba7aa7$var$A;
$fc10d34e83ba7aa7$export$8392c0c9d3dcbd35 = $fc10d34e83ba7aa7$var$B;
$fc10d34e83ba7aa7$export$ffb0004e005737fa = $fc10d34e83ba7aa7$var$C;
$fc10d34e83ba7aa7$export$b624eff549462981 = $fc10d34e83ba7aa7$var$D;
$fc10d34e83ba7aa7$export$7897aa7841a5380c = $fc10d34e83ba7aa7$var$E;
$fc10d34e83ba7aa7$export$602eac185826482c = $fc10d34e83ba7aa7$var$F;
$fc10d34e83ba7aa7$export$e2c29f18771995cb = $fc10d34e83ba7aa7$var$G;
$fc10d34e83ba7aa7$export$5f8d39834fd61797 = $fc10d34e83ba7aa7$var$H;
$fc10d34e83ba7aa7$export$74bf444e3cd11ea5 = $fc10d34e83ba7aa7$var$I;
$fc10d34e83ba7aa7$export$92387174baf9b227 = function() {
    return !1;
};
$fc10d34e83ba7aa7$export$ec112efeb987d9c6 = function() {
    return !1;
};
$fc10d34e83ba7aa7$export$b706b080d889d2c9 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$h;
};
$fc10d34e83ba7aa7$export$5be5a87408f70ddc = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$g;
};
$fc10d34e83ba7aa7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $fc10d34e83ba7aa7$var$b;
};
$fc10d34e83ba7aa7$export$455c2e768291efa6 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$k;
};
$fc10d34e83ba7aa7$export$9522e17588c12572 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$d;
};
$fc10d34e83ba7aa7$export$2110ac352bb060b9 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$p;
};
$fc10d34e83ba7aa7$export$56885ab8b9c456ab = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$n;
};
$fc10d34e83ba7aa7$export$d927fcb6adf8f9de = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$c;
};
$fc10d34e83ba7aa7$export$b82d16f27459e05a = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$f;
};
$fc10d34e83ba7aa7$export$522c17b4f5e123e8 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$e;
};
$fc10d34e83ba7aa7$export$1aabd8a0274ecfd6 = function(a) {
    return $fc10d34e83ba7aa7$var$y(a) === $fc10d34e83ba7aa7$var$l;
};
$fc10d34e83ba7aa7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $fc10d34e83ba7aa7$var$d || a === $fc10d34e83ba7aa7$var$f || a === $fc10d34e83ba7aa7$var$v || a === $fc10d34e83ba7aa7$var$e || a === $fc10d34e83ba7aa7$var$l || a === $fc10d34e83ba7aa7$var$m || a === $fc10d34e83ba7aa7$var$w || "object" === typeof a && null !== a && (a.$$typeof === $fc10d34e83ba7aa7$var$p || a.$$typeof === $fc10d34e83ba7aa7$var$n || a.$$typeof === $fc10d34e83ba7aa7$var$g || a.$$typeof === $fc10d34e83ba7aa7$var$h || a.$$typeof === $fc10d34e83ba7aa7$var$k || a.$$typeof === $fc10d34e83ba7aa7$var$u || a.$$typeof === $fc10d34e83ba7aa7$var$q || a[0] === $fc10d34e83ba7aa7$var$r) ? !0 : !1;
};
$fc10d34e83ba7aa7$export$f5bbd400c2f4426f = $fc10d34e83ba7aa7$var$y;

});

parcelRegister("feCW9", function(module, exports) {

var $UeyW6 = parcelRequire("UeyW6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $UeyW6.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("dIr8n", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $kG2Na = parcelRequire("kG2Na");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $kG2Na.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $kG2Na.default)(Rgb, rgb, (0, $kG2Na.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $kG2Na.default)(Hsl, hsl, (0, $kG2Na.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("kG2Na", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0d9e5559cb9daa1$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $f0d9e5559cb9daa1$export$8b58be045bf06082; });
function $f0d9e5559cb9daa1$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $f0d9e5559cb9daa1$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("f4Y7W", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "darker", function () { return darker; });
$parcel$export(module.exports, "brighter", function () { return brighter; });
$parcel$export(module.exports, "default", function () { return color; });
$parcel$export(module.exports, "hslConvert", function () { return hslConvert; });
$parcel$export(module.exports, "Rgb", function () { return Rgb; });
$parcel$export(module.exports, "rgbConvert", function () { return rgbConvert; });
$parcel$export(module.exports, "rgb", function () { return rgb; });
$parcel$export(module.exports, "hsl", function () { return hsl; });

var $1iwiL = parcelRequire("1iwiL");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp("^rgb\\(" + [
    reI,
    reI,
    reI
] + "\\)$"), reRgbPercent = new RegExp("^rgb\\(" + [
    reP,
    reP,
    reP
] + "\\)$"), reRgbaInteger = new RegExp("^rgba\\(" + [
    reI,
    reI,
    reI,
    reN
] + "\\)$"), reRgbaPercent = new RegExp("^rgba\\(" + [
    reP,
    reP,
    reP,
    reN
] + "\\)$"), reHslPercent = new RegExp("^hsl\\(" + [
    reN,
    reP,
    reP
] + "\\)$"), reHslaPercent = new RegExp("^hsla\\(" + [
    reN,
    reP,
    reP,
    reN
] + "\\)$");
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $1iwiL.default)(Color, color, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $1iwiL.default)(Rgb, rgb, (0, $1iwiL.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}
function rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $1iwiL.default)(Hsl, hsl, (0, $1iwiL.extend)(Color, {
    brighter: function(k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("1iwiL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f20875166d9b0e4$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $0f20875166d9b0e4$export$8b58be045bf06082; });
function $0f20875166d9b0e4$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $0f20875166d9b0e4$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("zZpsM", function(module, exports) {

$parcel$export(module.exports, "point", function () { return point; });
$parcel$export(module.exports, "default", function () { return $06c2e7af979202cc$export$2e2bcd8739ae039; });

var $fhvrq = parcelRequire("fhvrq");

var $50FzM = parcelRequire("50FzM");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > (0, $fhvrq.epsilon)) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > (0, $fhvrq.epsilon)) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $06c2e7af979202cc$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new (0, $50FzM.Cardinal)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

});
parcelRegister("fhvrq", function(module, exports) {

$parcel$export(module.exports, "epsilon", function () { return $02defb2e15c0d9cf$export$6c421550c66a327d; });
const $02defb2e15c0d9cf$export$2335f513bbd82c6d = Math.abs;
const $02defb2e15c0d9cf$export$b8b770ee6a0d9760 = Math.atan2;
const $02defb2e15c0d9cf$export$50d414a77b60d802 = Math.cos;
const $02defb2e15c0d9cf$export$8960430cfd85939f = Math.max;
const $02defb2e15c0d9cf$export$96ec731ed4dcb222 = Math.min;
const $02defb2e15c0d9cf$export$5de3937cb4b592ed = Math.sin;
const $02defb2e15c0d9cf$export$eba8049fb5020b81 = Math.sqrt;
const $02defb2e15c0d9cf$export$6c421550c66a327d = 1e-12;
const $02defb2e15c0d9cf$export$18c7bea995a110f = Math.PI;
const $02defb2e15c0d9cf$export$e51408a300e8929a = $02defb2e15c0d9cf$export$18c7bea995a110f / 2;
const $02defb2e15c0d9cf$export$a4b4b4d4d776fe92 = 2 * $02defb2e15c0d9cf$export$18c7bea995a110f;
function $02defb2e15c0d9cf$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $02defb2e15c0d9cf$export$18c7bea995a110f : Math.acos(x);
}
function $02defb2e15c0d9cf$export$41726bdb1fc63f(x) {
    return x >= 1 ? $02defb2e15c0d9cf$export$e51408a300e8929a : x <= -1 ? -$02defb2e15c0d9cf$export$e51408a300e8929a : Math.asin(x);
}

});

parcelRegister("50FzM", function(module, exports) {

$parcel$export(module.exports, "point", function () { return $3a5d33fd0e089ae9$export$105684a3041cb6f3; });
$parcel$export(module.exports, "Cardinal", function () { return $3a5d33fd0e089ae9$export$ee51ff373511cbeb; });
$parcel$export(module.exports, "default", function () { return $3a5d33fd0e089ae9$export$2e2bcd8739ae039; });
function $3a5d33fd0e089ae9$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $3a5d33fd0e089ae9$export$ee51ff373511cbeb(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$3a5d33fd0e089ae9$export$ee51ff373511cbeb.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $3a5d33fd0e089ae9$export$105684a3041cb6f3(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3; // falls through
            default:
                $3a5d33fd0e089ae9$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $3a5d33fd0e089ae9$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $3a5d33fd0e089ae9$export$ee51ff373511cbeb(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

});


parcelRegister("81X7f", function(module, exports) {

$parcel$export(module.exports, "rgb", function () { return rgb; });

var $3eFgO = parcelRequire("3eFgO");
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $3eFgO.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $3eFgO.default)(Rgb, rgb, (0, $3eFgO.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $3eFgO.default)(Hsl, hsl, (0, $3eFgO.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("3eFgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25b2b1479a0a841d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "extend", function () { return $25b2b1479a0a841d$export$8b58be045bf06082; });
function $25b2b1479a0a841d$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $25b2b1479a0a841d$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


var $e949ecf9b43cfcb0$exports = {};

(parcelRequire("d7Bg1")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"gFIzh\",\"index.7d4a26f0.js\",\"88GS3\",\"pages/qr-scanner/service-worker.js\",\"4lYg5\",\"team-tim-avatar.53775525.webp\",\"6Fccj\",\"beep.c98e88f2.mp3\",\"lvUAD\",\"xlsx.7d5fb964.js\"]"));

var $4801813bf62cee3c$exports = {};
'use strict';

$4801813bf62cee3c$exports = (parcelRequire("kKhpr"));



var $3ZYaX = parcelRequire("3ZYaX");
'use client';
const $619931fcf5fffd95$export$2fba198b5b2e37fa = /*#__PURE__*/ $3ZYaX.createContext(undefined);
const $619931fcf5fffd95$var$QueryClientSharingContext = /*#__PURE__*/ $3ZYaX.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $619931fcf5fffd95$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $619931fcf5fffd95$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $619931fcf5fffd95$export$2fba198b5b2e37fa;
}
const $619931fcf5fffd95$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $3ZYaX.useContext($619931fcf5fffd95$var$getQueryClientContext(context, $3ZYaX.useContext($619931fcf5fffd95$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $619931fcf5fffd95$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $3ZYaX.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $619931fcf5fffd95$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $3ZYaX.createElement($619931fcf5fffd95$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $3ZYaX.createElement(Context.Provider, {
        value: client
    }, children));
};


parcelRequire("3ZYaX");
var $6f672a7ea02fd929$export$882461b6382ed46c;
var $6f672a7ea02fd929$export$757ceba2d55c277e;
'use strict';

var $1rKN8 = parcelRequire("1rKN8");
var $6f672a7ea02fd929$var$i;
$6f672a7ea02fd929$export$882461b6382ed46c = $1rKN8.createRoot;
$6f672a7ea02fd929$export$757ceba2d55c277e = $1rKN8.hydrateRoot;


/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3ZYaX = parcelRequire("3ZYaX");

var $1rKN8 = parcelRequire("1rKN8");
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $f63a70a01eff4b4e$var$_extends() {
    $f63a70a01eff4b4e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f63a70a01eff4b4e$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $f63a70a01eff4b4e$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($f63a70a01eff4b4e$export$e19cd5f9376f8cee || ($f63a70a01eff4b4e$export$e19cd5f9376f8cee = {}));
const $f63a70a01eff4b4e$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $f63a70a01eff4b4e$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $f63a70a01eff4b4e$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $f63a70a01eff4b4e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $f63a70a01eff4b4e$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $f63a70a01eff4b4e$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $f63a70a01eff4b4e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $f63a70a01eff4b4e$export$fe53371bee54353d(to);
    }
    return $f63a70a01eff4b4e$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $f63a70a01eff4b4e$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $f63a70a01eff4b4e$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $f63a70a01eff4b4e$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $f63a70a01eff4b4e$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $f63a70a01eff4b4e$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $f63a70a01eff4b4e$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $f63a70a01eff4b4e$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $f63a70a01eff4b4e$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $f63a70a01eff4b4e$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $f63a70a01eff4b4e$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $f63a70a01eff4b4e$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $f63a70a01eff4b4e$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $f63a70a01eff4b4e$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $f63a70a01eff4b4e$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $f63a70a01eff4b4e$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $f63a70a01eff4b4e$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($f63a70a01eff4b4e$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push;
        let location = $f63a70a01eff4b4e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $f63a70a01eff4b4e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace;
        let location = $f63a70a01eff4b4e$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $f63a70a01eff4b4e$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $f63a70a01eff4b4e$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $f63a70a01eff4b4e$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($f63a70a01eff4b4e$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($f63a70a01eff4b4e$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $f63a70a01eff4b4e$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($f63a70a01eff4b4e$var$ResultType || ($f63a70a01eff4b4e$var$ResultType = {}));
const $f63a70a01eff4b4e$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $f63a70a01eff4b4e$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $f63a70a01eff4b4e$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $f63a70a01eff4b4e$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($f63a70a01eff4b4e$var$isIndexRoute(route)) {
            let indexRoute = $f63a70a01eff4b4e$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $f63a70a01eff4b4e$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $f63a70a01eff4b4e$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $f63a70a01eff4b4e$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $f63a70a01eff4b4e$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $f63a70a01eff4b4e$var$flattenRoutes(routes);
    $f63a70a01eff4b4e$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $f63a70a01eff4b4e$var$decodePath(pathname);
        matches = $f63a70a01eff4b4e$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $f63a70a01eff4b4e$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $f63a70a01eff4b4e$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $f63a70a01eff4b4e$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f63a70a01eff4b4e$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $f63a70a01eff4b4e$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $f63a70a01eff4b4e$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f63a70a01eff4b4e$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $f63a70a01eff4b4e$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $f63a70a01eff4b4e$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f63a70a01eff4b4e$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f63a70a01eff4b4e$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $f63a70a01eff4b4e$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f63a70a01eff4b4e$var$paramRe = /^:[\w-]+$/;
const $f63a70a01eff4b4e$var$dynamicSegmentValue = 3;
const $f63a70a01eff4b4e$var$indexRouteValue = 2;
const $f63a70a01eff4b4e$var$emptySegmentValue = 1;
const $f63a70a01eff4b4e$var$staticSegmentValue = 10;
const $f63a70a01eff4b4e$var$splatPenalty = -2;
const $f63a70a01eff4b4e$var$isSplat = (s)=>s === "*";
function $f63a70a01eff4b4e$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f63a70a01eff4b4e$var$isSplat)) initialScore += $f63a70a01eff4b4e$var$splatPenalty;
    if (index) initialScore += $f63a70a01eff4b4e$var$indexRouteValue;
    return segments.filter((s)=>!$f63a70a01eff4b4e$var$isSplat(s)).reduce((score, segment)=>score + ($f63a70a01eff4b4e$var$paramRe.test(segment) ? $f63a70a01eff4b4e$var$dynamicSegmentValue : segment === "" ? $f63a70a01eff4b4e$var$emptySegmentValue : $f63a70a01eff4b4e$var$staticSegmentValue), initialScore);
}
function $f63a70a01eff4b4e$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $f63a70a01eff4b4e$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $f63a70a01eff4b4e$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $f63a70a01eff4b4e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f63a70a01eff4b4e$export$a5c6d149b50c1d86($f63a70a01eff4b4e$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f63a70a01eff4b4e$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $f63a70a01eff4b4e$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $f63a70a01eff4b4e$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $f63a70a01eff4b4e$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $f63a70a01eff4b4e$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f63a70a01eff4b4e$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f63a70a01eff4b4e$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $f63a70a01eff4b4e$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $f63a70a01eff4b4e$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $f63a70a01eff4b4e$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $f63a70a01eff4b4e$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $f63a70a01eff4b4e$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $f63a70a01eff4b4e$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $f63a70a01eff4b4e$var$normalizeSearch(search),
        hash: $f63a70a01eff4b4e$var$normalizeHash(hash)
    };
}
function $f63a70a01eff4b4e$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f63a70a01eff4b4e$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $f63a70a01eff4b4e$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $f63a70a01eff4b4e$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $f63a70a01eff4b4e$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $f63a70a01eff4b4e$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $f63a70a01eff4b4e$export$8ccf933b0513f8d0(toArg);
    else {
        to = $f63a70a01eff4b4e$var$_extends({}, toArg);
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $f63a70a01eff4b4e$var$getInvalidPathError("?", "pathname", "search", to));
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $f63a70a01eff4b4e$var$getInvalidPathError("#", "pathname", "hash", to));
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $f63a70a01eff4b4e$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f63a70a01eff4b4e$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $f63a70a01eff4b4e$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $f63a70a01eff4b4e$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $f63a70a01eff4b4e$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $f63a70a01eff4b4e$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $f63a70a01eff4b4e$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $f63a70a01eff4b4e$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $f63a70a01eff4b4e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $f63a70a01eff4b4e$export$42a99a7a4bc0e76a extends Error {
}
class $f63a70a01eff4b4e$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $f63a70a01eff4b4e$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $f63a70a01eff4b4e$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $f63a70a01eff4b4e$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $f63a70a01eff4b4e$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $f63a70a01eff4b4e$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $f63a70a01eff4b4e$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $f63a70a01eff4b4e$var$unwrapTrackedPromise(value) {
    if (!$f63a70a01eff4b4e$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $f63a70a01eff4b4e$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $f63a70a01eff4b4e$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f63a70a01eff4b4e$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $f63a70a01eff4b4e$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $f63a70a01eff4b4e$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f63a70a01eff4b4e$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $f63a70a01eff4b4e$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $f63a70a01eff4b4e$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $f63a70a01eff4b4e$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $f63a70a01eff4b4e$var$validMutationMethods = new Set($f63a70a01eff4b4e$var$validMutationMethodsArr);
const $f63a70a01eff4b4e$var$validRequestMethodsArr = [
    "get",
    ...$f63a70a01eff4b4e$var$validMutationMethodsArr
];
const $f63a70a01eff4b4e$var$validRequestMethods = new Set($f63a70a01eff4b4e$var$validRequestMethodsArr);
const $f63a70a01eff4b4e$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $f63a70a01eff4b4e$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $f63a70a01eff4b4e$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f63a70a01eff4b4e$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $f63a70a01eff4b4e$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $f63a70a01eff4b4e$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $f63a70a01eff4b4e$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $f63a70a01eff4b4e$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $f63a70a01eff4b4e$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $f63a70a01eff4b4e$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f63a70a01eff4b4e$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $f63a70a01eff4b4e$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $f63a70a01eff4b4e$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $f63a70a01eff4b4e$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $f63a70a01eff4b4e$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $f63a70a01eff4b4e$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $f63a70a01eff4b4e$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $f63a70a01eff4b4e$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $f63a70a01eff4b4e$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $f63a70a01eff4b4e$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$f63a70a01eff4b4e$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $f63a70a01eff4b4e$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $f63a70a01eff4b4e$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $f63a70a01eff4b4e$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $f63a70a01eff4b4e$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $f63a70a01eff4b4e$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($f63a70a01eff4b4e$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $f63a70a01eff4b4e$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $f63a70a01eff4b4e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $f63a70a01eff4b4e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $f63a70a01eff4b4e$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $f63a70a01eff4b4e$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $f63a70a01eff4b4e$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $f63a70a01eff4b4e$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $f63a70a01eff4b4e$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f63a70a01eff4b4e$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $f63a70a01eff4b4e$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $f63a70a01eff4b4e$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $f63a70a01eff4b4e$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$f63a70a01eff4b4e$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $f63a70a01eff4b4e$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $f63a70a01eff4b4e$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $f63a70a01eff4b4e$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $f63a70a01eff4b4e$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $f63a70a01eff4b4e$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $f63a70a01eff4b4e$var$ResultType.error,
            error: $f63a70a01eff4b4e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $f63a70a01eff4b4e$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($f63a70a01eff4b4e$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($f63a70a01eff4b4e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f63a70a01eff4b4e$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($f63a70a01eff4b4e$var$isDeferredResult(result)) throw $f63a70a01eff4b4e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $f63a70a01eff4b4e$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $f63a70a01eff4b4e$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $f63a70a01eff4b4e$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $f63a70a01eff4b4e$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $f63a70a01eff4b4e$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($f63a70a01eff4b4e$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $f63a70a01eff4b4e$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f63a70a01eff4b4e$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $f63a70a01eff4b4e$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $f63a70a01eff4b4e$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $f63a70a01eff4b4e$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $f63a70a01eff4b4e$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $f63a70a01eff4b4e$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $f63a70a01eff4b4e$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $f63a70a01eff4b4e$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f63a70a01eff4b4e$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $f63a70a01eff4b4e$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $f63a70a01eff4b4e$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($f63a70a01eff4b4e$var$isRedirectResult(actionResult) || $f63a70a01eff4b4e$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $f63a70a01eff4b4e$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($f63a70a01eff4b4e$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $f63a70a01eff4b4e$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $f63a70a01eff4b4e$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($f63a70a01eff4b4e$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($f63a70a01eff4b4e$var$isDeferredResult(actionResult)) throw $f63a70a01eff4b4e$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $f63a70a01eff4b4e$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $f63a70a01eff4b4e$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $f63a70a01eff4b4e$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $f63a70a01eff4b4e$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $f63a70a01eff4b4e$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $f63a70a01eff4b4e$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $f63a70a01eff4b4e$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $f63a70a01eff4b4e$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $f63a70a01eff4b4e$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $f63a70a01eff4b4e$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $f63a70a01eff4b4e$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $f63a70a01eff4b4e$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $f63a70a01eff4b4e$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $f63a70a01eff4b4e$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($f63a70a01eff4b4e$var$isDeferredResult(result)) result = await $f63a70a01eff4b4e$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $f63a70a01eff4b4e$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($f63a70a01eff4b4e$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $f63a70a01eff4b4e$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($f63a70a01eff4b4e$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!$f63a70a01eff4b4e$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $f63a70a01eff4b4e$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $f63a70a01eff4b4e$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $f63a70a01eff4b4e$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($f63a70a01eff4b4e$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $f63a70a01eff4b4e$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Replace : $f63a70a01eff4b4e$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $f63a70a01eff4b4e$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($f63a70a01eff4b4e$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $f63a70a01eff4b4e$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $f63a70a01eff4b4e$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $f63a70a01eff4b4e$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f63a70a01eff4b4e$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $f63a70a01eff4b4e$var$callLoaderOrAction("loader", $f63a70a01eff4b4e$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $f63a70a01eff4b4e$var$ResultType.error,
                        error: $f63a70a01eff4b4e$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $f63a70a01eff4b4e$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $f63a70a01eff4b4e$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $f63a70a01eff4b4e$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $f63a70a01eff4b4e$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $f63a70a01eff4b4e$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $f63a70a01eff4b4e$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $f63a70a01eff4b4e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $f63a70a01eff4b4e$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $f63a70a01eff4b4e$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $f63a70a01eff4b4e$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $f63a70a01eff4b4e$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $f63a70a01eff4b4e$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $f63a70a01eff4b4e$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$f63a70a01eff4b4e$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $f63a70a01eff4b4e$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $f63a70a01eff4b4e$export$4d0306f8f6a4585b = Symbol("deferred");
function $f63a70a01eff4b4e$export$3336b097a6fbc59a(routes, opts) {
    $f63a70a01eff4b4e$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $f63a70a01eff4b4e$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $f63a70a01eff4b4e$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $f63a70a01eff4b4e$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f63a70a01eff4b4e$var$createLocation("", $f63a70a01eff4b4e$export$fe53371bee54353d(url), null, "default");
        let matches = $f63a70a01eff4b4e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f63a70a01eff4b4e$var$isValidMethod(method) && method !== "HEAD") {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $f63a70a01eff4b4e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $f63a70a01eff4b4e$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($f63a70a01eff4b4e$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $f63a70a01eff4b4e$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $f63a70a01eff4b4e$var$createLocation("", $f63a70a01eff4b4e$export$fe53371bee54353d(url), null, "default");
        let matches = $f63a70a01eff4b4e$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$f63a70a01eff4b4e$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $f63a70a01eff4b4e$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $f63a70a01eff4b4e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $f63a70a01eff4b4e$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $f63a70a01eff4b4e$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $f63a70a01eff4b4e$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($f63a70a01eff4b4e$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$f63a70a01eff4b4e$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $f63a70a01eff4b4e$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($f63a70a01eff4b4e$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $f63a70a01eff4b4e$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $f63a70a01eff4b4e$var$isResponse(result) ? result : $f63a70a01eff4b4e$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($f63a70a01eff4b4e$var$isQueryRouteResponse(e)) {
                if (e.type === $f63a70a01eff4b4e$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($f63a70a01eff4b4e$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f63a70a01eff4b4e$var$ResultType.error,
                error: error
            };
        } else {
            result = await $f63a70a01eff4b4e$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $f63a70a01eff4b4e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($f63a70a01eff4b4e$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($f63a70a01eff4b4e$var$isDeferredResult(result)) {
            let error = $f63a70a01eff4b4e$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $f63a70a01eff4b4e$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($f63a70a01eff4b4e$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($f63a70a01eff4b4e$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $f63a70a01eff4b4e$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $f63a70a01eff4b4e$var$_extends({}, context, {
                statusCode: $f63a70a01eff4b4e$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $f63a70a01eff4b4e$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $f63a70a01eff4b4e$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $f63a70a01eff4b4e$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $f63a70a01eff4b4e$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $f63a70a01eff4b4e$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$f63a70a01eff4b4e$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $f63a70a01eff4b4e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $f63a70a01eff4b4e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $f63a70a01eff4b4e$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $f63a70a01eff4b4e$export$fec11da027c70692(routes, context, error) {
    let newContext = $f63a70a01eff4b4e$var$_extends({}, context, {
        statusCode: $f63a70a01eff4b4e$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $f63a70a01eff4b4e$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $f63a70a01eff4b4e$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $f63a70a01eff4b4e$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $f63a70a01eff4b4e$export$cae722b0cc860f13(to ? to : ".", $f63a70a01eff4b4e$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $f63a70a01eff4b4e$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$f63a70a01eff4b4e$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $f63a70a01eff4b4e$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $f63a70a01eff4b4e$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $f63a70a01eff4b4e$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$f63a70a01eff4b4e$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$f63a70a01eff4b4e$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $f63a70a01eff4b4e$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $f63a70a01eff4b4e$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $f63a70a01eff4b4e$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$f63a70a01eff4b4e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$f63a70a01eff4b4e$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $f63a70a01eff4b4e$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $f63a70a01eff4b4e$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $f63a70a01eff4b4e$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $f63a70a01eff4b4e$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $f63a70a01eff4b4e$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($f63a70a01eff4b4e$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $f63a70a01eff4b4e$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $f63a70a01eff4b4e$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $f63a70a01eff4b4e$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $f63a70a01eff4b4e$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $f63a70a01eff4b4e$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $f63a70a01eff4b4e$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($f63a70a01eff4b4e$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $f63a70a01eff4b4e$var$shouldRevalidateLoader(match, $f63a70a01eff4b4e$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $f63a70a01eff4b4e$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $f63a70a01eff4b4e$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $f63a70a01eff4b4e$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $f63a70a01eff4b4e$var$shouldRevalidateLoader(fetcherMatch, $f63a70a01eff4b4e$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $f63a70a01eff4b4e$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $f63a70a01eff4b4e$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $f63a70a01eff4b4e$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $f63a70a01eff4b4e$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $f63a70a01eff4b4e$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $f63a70a01eff4b4e$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$f63a70a01eff4b4e$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $f63a70a01eff4b4e$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $f63a70a01eff4b4e$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $f63a70a01eff4b4e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $f63a70a01eff4b4e$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $f63a70a01eff4b4e$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $f63a70a01eff4b4e$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $f63a70a01eff4b4e$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $f63a70a01eff4b4e$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $f63a70a01eff4b4e$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($f63a70a01eff4b4e$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($f63a70a01eff4b4e$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $f63a70a01eff4b4e$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$f63a70a01eff4b4e$var$ABSOLUTE_URL_REGEX.test(location)) location = $f63a70a01eff4b4e$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $f63a70a01eff4b4e$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $f63a70a01eff4b4e$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $f63a70a01eff4b4e$var$ResultType.error ? $f63a70a01eff4b4e$var$ResultType.error : $f63a70a01eff4b4e$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $f63a70a01eff4b4e$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $f63a70a01eff4b4e$var$ResultType.error) return {
            type: resultType,
            error: new $f63a70a01eff4b4e$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $f63a70a01eff4b4e$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $f63a70a01eff4b4e$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($f63a70a01eff4b4e$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $f63a70a01eff4b4e$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $f63a70a01eff4b4e$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $f63a70a01eff4b4e$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($f63a70a01eff4b4e$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $f63a70a01eff4b4e$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $f63a70a01eff4b4e$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $f63a70a01eff4b4e$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $f63a70a01eff4b4e$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $f63a70a01eff4b4e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $f63a70a01eff4b4e$export$3e9cee6b33872309(!$f63a70a01eff4b4e$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($f63a70a01eff4b4e$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $f63a70a01eff4b4e$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $f63a70a01eff4b4e$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($f63a70a01eff4b4e$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $f63a70a01eff4b4e$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $f63a70a01eff4b4e$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $f63a70a01eff4b4e$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($f63a70a01eff4b4e$var$isErrorResult(result)) {
            let boundaryMatch = $f63a70a01eff4b4e$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $f63a70a01eff4b4e$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($f63a70a01eff4b4e$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $f63a70a01eff4b4e$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($f63a70a01eff4b4e$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $f63a70a01eff4b4e$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $f63a70a01eff4b4e$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $f63a70a01eff4b4e$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $f63a70a01eff4b4e$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $f63a70a01eff4b4e$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $f63a70a01eff4b4e$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $f63a70a01eff4b4e$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $f63a70a01eff4b4e$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $f63a70a01eff4b4e$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($f63a70a01eff4b4e$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $f63a70a01eff4b4e$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(path) : path;
    return $f63a70a01eff4b4e$export$fe53371bee54353d($f63a70a01eff4b4e$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $f63a70a01eff4b4e$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $f63a70a01eff4b4e$var$isDeferredResult(result) {
    return result.type === $f63a70a01eff4b4e$var$ResultType.deferred;
}
function $f63a70a01eff4b4e$var$isErrorResult(result) {
    return result.type === $f63a70a01eff4b4e$var$ResultType.error;
}
function $f63a70a01eff4b4e$var$isRedirectResult(result) {
    return (result && result.type) === $f63a70a01eff4b4e$var$ResultType.redirect;
}
function $f63a70a01eff4b4e$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $f63a70a01eff4b4e$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $f63a70a01eff4b4e$var$isRedirectResponse(result) {
    if (!$f63a70a01eff4b4e$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $f63a70a01eff4b4e$var$isQueryRouteResponse(obj) {
    return obj && $f63a70a01eff4b4e$var$isResponse(obj.response) && (obj.type === $f63a70a01eff4b4e$var$ResultType.data || obj.type === $f63a70a01eff4b4e$var$ResultType.error);
}
function $f63a70a01eff4b4e$var$isValidMethod(method) {
    return $f63a70a01eff4b4e$var$validRequestMethods.has(method.toLowerCase());
}
function $f63a70a01eff4b4e$var$isMutationMethod(method) {
    return $f63a70a01eff4b4e$var$validMutationMethods.has(method.toLowerCase());
}
async function $f63a70a01eff4b4e$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$f63a70a01eff4b4e$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($f63a70a01eff4b4e$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $f63a70a01eff4b4e$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $f63a70a01eff4b4e$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $f63a70a01eff4b4e$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $f63a70a01eff4b4e$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $f63a70a01eff4b4e$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $f63a70a01eff4b4e$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $f63a70a01eff4b4e$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $f63a70a01eff4b4e$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $f63a70a01eff4b4e$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $f63a70a01eff4b4e$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $f63a70a01eff4b4e$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $f63a70a01eff4b4e$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $f63a70a01eff4b4e$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $f63a70a01eff4b4e$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $f63a70a01eff4b4e$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $f63a70a01eff4b4e$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $f63a70a01eff4b4e$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $f63a70a01eff4b4e$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($f63a70a01eff4b4e$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $f63a70a01eff4b4e$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($f63a70a01eff4b4e$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $f63a70a01eff4b4e$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3ZYaX = parcelRequire("3ZYaX");

function $39b0bf07af9c8a3f$var$_extends() {
    $39b0bf07af9c8a3f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39b0bf07af9c8a3f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $39b0bf07af9c8a3f$export$3add0d5dce533e2e = /*#__PURE__*/ $3ZYaX.createContext(null);
const $39b0bf07af9c8a3f$export$145dfa71566a64dc = /*#__PURE__*/ $3ZYaX.createContext(null);
const $39b0bf07af9c8a3f$var$AwaitContext = /*#__PURE__*/ $3ZYaX.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $39b0bf07af9c8a3f$export$26749e8557646306 = /*#__PURE__*/ $3ZYaX.createContext(null);
const $39b0bf07af9c8a3f$export$c7914228fb69b0f5 = /*#__PURE__*/ $3ZYaX.createContext(null);
const $39b0bf07af9c8a3f$export$9072aa6dd1f93057 = /*#__PURE__*/ $3ZYaX.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $39b0bf07af9c8a3f$var$RouteErrorContext = /*#__PURE__*/ $3ZYaX.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $39b0bf07af9c8a3f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f63a70a01eff4b4e$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $39b0bf07af9c8a3f$export$9c954a9d03d32f4a() {
    return $3ZYaX.useContext($39b0bf07af9c8a3f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $39b0bf07af9c8a3f$export$45d76561a5302f2b() {
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return $3ZYaX.useContext($39b0bf07af9c8a3f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $39b0bf07af9c8a3f$export$1b3f31771c5d07c() {
    return $3ZYaX.useContext($39b0bf07af9c8a3f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $39b0bf07af9c8a3f$export$6c330e8992e8a295(pattern) {
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $39b0bf07af9c8a3f$export$45d76561a5302f2b();
    return $3ZYaX.useMemo(()=>(0, $f63a70a01eff4b4e$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $39b0bf07af9c8a3f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $39b0bf07af9c8a3f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3ZYaX.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $39b0bf07af9c8a3f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $39b0bf07af9c8a3f$var$useNavigateStable() : $39b0bf07af9c8a3f$var$useNavigateUnstable();
}
function $39b0bf07af9c8a3f$var$useNavigateUnstable() {
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let dataRouterContext = $3ZYaX.useContext($39b0bf07af9c8a3f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306);
    let { matches: matches } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $39b0bf07af9c8a3f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f63a70a01eff4b4e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $3ZYaX.useRef(false);
    $39b0bf07af9c8a3f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3ZYaX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f63a70a01eff4b4e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f63a70a01eff4b4e$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $39b0bf07af9c8a3f$var$OutletContext = /*#__PURE__*/ $3ZYaX.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $39b0bf07af9c8a3f$export$4138103a3ae699cc() {
    return $3ZYaX.useContext($39b0bf07af9c8a3f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $39b0bf07af9c8a3f$export$a3be3530d8e40d0b(context) {
    let outlet = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306);
    let { matches: matches } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $39b0bf07af9c8a3f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f63a70a01eff4b4e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $3ZYaX.useMemo(()=>(0, $f63a70a01eff4b4e$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $39b0bf07af9c8a3f$export$5d3fca4a98652595(routes, locationArg) {
    return $39b0bf07af9c8a3f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $39b0bf07af9c8a3f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306);
    let { matches: parentMatches } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $39b0bf07af9c8a3f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $f63a70a01eff4b4e$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $f63a70a01eff4b4e$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $39b0bf07af9c8a3f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f63a70a01eff4b4e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f63a70a01eff4b4e$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $39b0bf07af9c8a3f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $f63a70a01eff4b4e$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $39b0bf07af9c8a3f$var$DefaultErrorComponent() {
    let error = $39b0bf07af9c8a3f$export$ed527bf60f6e05f2();
    let message = (0, $f63a70a01eff4b4e$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, /*#__PURE__*/ $3ZYaX.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $3ZYaX.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $3ZYaX.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $39b0bf07af9c8a3f$var$defaultErrorElement = /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$DefaultErrorComponent, null);
class $39b0bf07af9c8a3f$var$RenderErrorBoundary extends $3ZYaX.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $39b0bf07af9c8a3f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $3ZYaX.useContext($39b0bf07af9c8a3f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $39b0bf07af9c8a3f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $39b0bf07af9c8a3f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $39b0bf07af9c8a3f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $3ZYaX.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $39b0bf07af9c8a3f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($39b0bf07af9c8a3f$var$DataRouterHook || {});
var $39b0bf07af9c8a3f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($39b0bf07af9c8a3f$var$DataRouterStateHook || {});
function $39b0bf07af9c8a3f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $39b0bf07af9c8a3f$var$useDataRouterContext(hookName) {
    let ctx = $3ZYaX.useContext($39b0bf07af9c8a3f$export$3add0d5dce533e2e);
    !ctx && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $39b0bf07af9c8a3f$var$useDataRouterState(hookName) {
    let state = $3ZYaX.useContext($39b0bf07af9c8a3f$export$145dfa71566a64dc);
    !state && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return state;
}
function $39b0bf07af9c8a3f$var$useRouteContext(hookName) {
    let route = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    !route && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $39b0bf07af9c8a3f$var$useCurrentRouteId(hookName) {
    let route = $39b0bf07af9c8a3f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $39b0bf07af9c8a3f$export$5fc8298006ad9e58() {
    return $39b0bf07af9c8a3f$var$useCurrentRouteId($39b0bf07af9c8a3f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $39b0bf07af9c8a3f$export$d0fd4b7106de2769() {
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $39b0bf07af9c8a3f$export$600dc272ed516c15() {
    let dataRouterContext = $39b0bf07af9c8a3f$var$useDataRouterContext($39b0bf07af9c8a3f$var$DataRouterHook.UseRevalidator);
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseRevalidator);
    return $3ZYaX.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $39b0bf07af9c8a3f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseMatches);
    return $3ZYaX.useMemo(()=>matches.map((m)=>(0, $f63a70a01eff4b4e$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $39b0bf07af9c8a3f$export$1448a5050d252c4d() {
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $39b0bf07af9c8a3f$var$useCurrentRouteId($39b0bf07af9c8a3f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $39b0bf07af9c8a3f$export$fd5d37484eab868d(routeId) {
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $39b0bf07af9c8a3f$export$fdc00f3f26066d5e() {
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseActionData);
    let routeId = $39b0bf07af9c8a3f$var$useCurrentRouteId($39b0bf07af9c8a3f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $39b0bf07af9c8a3f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $3ZYaX.useContext($39b0bf07af9c8a3f$var$RouteErrorContext);
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseRouteError);
    let routeId = $39b0bf07af9c8a3f$var$useCurrentRouteId($39b0bf07af9c8a3f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $39b0bf07af9c8a3f$export$78a72ddb39bdd145() {
    let value = $3ZYaX.useContext($39b0bf07af9c8a3f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $39b0bf07af9c8a3f$export$17f53340677d5831() {
    let value = $3ZYaX.useContext($39b0bf07af9c8a3f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $39b0bf07af9c8a3f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $39b0bf07af9c8a3f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $39b0bf07af9c8a3f$var$useDataRouterContext($39b0bf07af9c8a3f$var$DataRouterHook.UseBlocker);
    let state = $39b0bf07af9c8a3f$var$useDataRouterState($39b0bf07af9c8a3f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $3ZYaX.useState("");
    let blockerFunction = $3ZYaX.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $39b0bf07af9c8a3f$var$_extends({}, currentLocation, {
                pathname: (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $39b0bf07af9c8a3f$var$_extends({}, nextLocation, {
                pathname: (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $3ZYaX.useEffect(()=>{
        let key = String(++$39b0bf07af9c8a3f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $3ZYaX.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $f63a70a01eff4b4e$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $39b0bf07af9c8a3f$var$useNavigateStable() {
    let { router: router } = $39b0bf07af9c8a3f$var$useDataRouterContext($39b0bf07af9c8a3f$var$DataRouterHook.UseNavigateStable);
    let id = $39b0bf07af9c8a3f$var$useCurrentRouteId($39b0bf07af9c8a3f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $3ZYaX.useRef(false);
    $39b0bf07af9c8a3f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $3ZYaX.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $39b0bf07af9c8a3f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $39b0bf07af9c8a3f$var$alreadyWarned = {};
function $39b0bf07af9c8a3f$var$warningOnce(key, cond, message) {
    if (!cond && !$39b0bf07af9c8a3f$var$alreadyWarned[key]) $39b0bf07af9c8a3f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $39b0bf07af9c8a3f$var$START_TRANSITION = "startTransition";
const $39b0bf07af9c8a3f$var$startTransitionImpl = $3ZYaX[$39b0bf07af9c8a3f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $39b0bf07af9c8a3f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3ZYaX.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3ZYaX.useCallback((newState)=>{
        if (v7_startTransition && $39b0bf07af9c8a3f$var$startTransitionImpl) $39b0bf07af9c8a3f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3ZYaX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $3ZYaX.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3ZYaX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3ZYaX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $39b0bf07af9c8a3f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $39b0bf07af9c8a3f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $39b0bf07af9c8a3f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $3ZYaX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f63a70a01eff4b4e$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3ZYaX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3ZYaX.useCallback((newState)=>{
        v7_startTransition && $39b0bf07af9c8a3f$var$startTransitionImpl ? $39b0bf07af9c8a3f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3ZYaX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $39b0bf07af9c8a3f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$26749e8557646306);
    let { matches: matches } = $3ZYaX.useContext($39b0bf07af9c8a3f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $39b0bf07af9c8a3f$export$45d76561a5302f2b();
    let navigate = $39b0bf07af9c8a3f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $f63a70a01eff4b4e$export$cae722b0cc860f13)(to, (0, $f63a70a01eff4b4e$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $3ZYaX.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $39b0bf07af9c8a3f$export$910ae8079b2c2852(props) {
    return $39b0bf07af9c8a3f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $39b0bf07af9c8a3f$export$e7b0ac011bb776c6(_props) {
    (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $39b0bf07af9c8a3f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $f63a70a01eff4b4e$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$39b0bf07af9c8a3f$export$9c954a9d03d32f4a() && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $3ZYaX.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $39b0bf07af9c8a3f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $f63a70a01eff4b4e$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $3ZYaX.useMemo(()=>{
        let trailingPathname = (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $39b0bf07af9c8a3f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $39b0bf07af9c8a3f$export$5d3fca4a98652595($39b0bf07af9c8a3f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $39b0bf07af9c8a3f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$ResolveAwait, null, children));
}
var $39b0bf07af9c8a3f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($39b0bf07af9c8a3f$var$AwaitRenderStatus || {});
const $39b0bf07af9c8a3f$var$neverSettledPromise = new Promise(()=>{});
class $39b0bf07af9c8a3f$var$AwaitErrorBoundary extends $3ZYaX.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $39b0bf07af9c8a3f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $39b0bf07af9c8a3f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $39b0bf07af9c8a3f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $39b0bf07af9c8a3f$var$AwaitRenderStatus.error : promise._data !== undefined ? $39b0bf07af9c8a3f$var$AwaitRenderStatus.success : $39b0bf07af9c8a3f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $39b0bf07af9c8a3f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $39b0bf07af9c8a3f$var$AwaitRenderStatus.error && promise._error instanceof (0, $f63a70a01eff4b4e$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $39b0bf07af9c8a3f$var$neverSettledPromise;
        if (status === $39b0bf07af9c8a3f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $39b0bf07af9c8a3f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $39b0bf07af9c8a3f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $3ZYaX.createElement($39b0bf07af9c8a3f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $39b0bf07af9c8a3f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $39b0bf07af9c8a3f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $39b0bf07af9c8a3f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $3ZYaX.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $3ZYaX.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $3ZYaX.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $39b0bf07af9c8a3f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $39b0bf07af9c8a3f$export$e7b0ac011bb776c6) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $39b0bf07af9c8a3f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $39b0bf07af9c8a3f$export$daf73786167a7f72(matches) {
    return $39b0bf07af9c8a3f$var$_renderMatches(matches);
}
function $39b0bf07af9c8a3f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $3ZYaX.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $3ZYaX.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $3ZYaX.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $39b0bf07af9c8a3f$export$f30f7e456d254e83(routes, opts) {
    return (0, $f63a70a01eff4b4e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $39b0bf07af9c8a3f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f63a70a01eff4b4e$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $39b0bf07af9c8a3f$export$52b333d321859367
    }).initialize();
}



function $d7b8f401c6bc9326$var$_extends() {
    $d7b8f401c6bc9326$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d7b8f401c6bc9326$var$_extends.apply(this, arguments);
}
function $d7b8f401c6bc9326$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $d7b8f401c6bc9326$var$defaultMethod = "get";
const $d7b8f401c6bc9326$var$defaultEncType = "application/x-www-form-urlencoded";
function $d7b8f401c6bc9326$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $d7b8f401c6bc9326$var$isButtonElement(object) {
    return $d7b8f401c6bc9326$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $d7b8f401c6bc9326$var$isFormElement(object) {
    return $d7b8f401c6bc9326$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $d7b8f401c6bc9326$var$isInputElement(object) {
    return $d7b8f401c6bc9326$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $d7b8f401c6bc9326$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $d7b8f401c6bc9326$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$d7b8f401c6bc9326$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $d7b8f401c6bc9326$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $d7b8f401c6bc9326$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $d7b8f401c6bc9326$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $d7b8f401c6bc9326$var$_formDataSupportsSubmitter = null;
function $d7b8f401c6bc9326$var$isFormDataSubmitterSupported() {
    if ($d7b8f401c6bc9326$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $d7b8f401c6bc9326$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $d7b8f401c6bc9326$var$_formDataSupportsSubmitter = true;
    }
    return $d7b8f401c6bc9326$var$_formDataSupportsSubmitter;
}
const $d7b8f401c6bc9326$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $d7b8f401c6bc9326$var$getFormEncType(encType) {
    if (encType != null && !$d7b8f401c6bc9326$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $d7b8f401c6bc9326$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($d7b8f401c6bc9326$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $d7b8f401c6bc9326$var$defaultMethod;
        encType = $d7b8f401c6bc9326$var$getFormEncType(target.getAttribute("enctype")) || $d7b8f401c6bc9326$var$defaultEncType;
        formData = new FormData(target);
    } else if ($d7b8f401c6bc9326$var$isButtonElement(target) || $d7b8f401c6bc9326$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $d7b8f401c6bc9326$var$defaultMethod;
        encType = $d7b8f401c6bc9326$var$getFormEncType(target.getAttribute("formenctype")) || $d7b8f401c6bc9326$var$getFormEncType(form.getAttribute("enctype")) || $d7b8f401c6bc9326$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$d7b8f401c6bc9326$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($d7b8f401c6bc9326$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $d7b8f401c6bc9326$var$defaultMethod;
        action = null;
        encType = $d7b8f401c6bc9326$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $d7b8f401c6bc9326$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $d7b8f401c6bc9326$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $d7b8f401c6bc9326$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $d7b8f401c6bc9326$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $d7b8f401c6bc9326$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $d7b8f401c6bc9326$export$1f3f55432a00e06d(routes, opts) {
    return (0, $f63a70a01eff4b4e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d7b8f401c6bc9326$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f63a70a01eff4b4e$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d7b8f401c6bc9326$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $39b0bf07af9c8a3f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d7b8f401c6bc9326$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $f63a70a01eff4b4e$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d7b8f401c6bc9326$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $f63a70a01eff4b4e$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $d7b8f401c6bc9326$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $39b0bf07af9c8a3f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $d7b8f401c6bc9326$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $d7b8f401c6bc9326$var$_extends({}, state, {
        errors: $d7b8f401c6bc9326$var$deserializeErrors(state.errors)
    });
    return state;
}
function $d7b8f401c6bc9326$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f63a70a01eff4b4e$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $d7b8f401c6bc9326$export$7ad602f0e94e62d1 = /*#__PURE__*/ $3ZYaX.createContext({
    isTransitioning: false
});
const $d7b8f401c6bc9326$export$148fd98d095596d4 = /*#__PURE__*/ $3ZYaX.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d7b8f401c6bc9326$var$START_TRANSITION = "startTransition";
const $d7b8f401c6bc9326$var$startTransitionImpl = $3ZYaX[$d7b8f401c6bc9326$var$START_TRANSITION];
const $d7b8f401c6bc9326$var$FLUSH_SYNC = "flushSync";
const $d7b8f401c6bc9326$var$flushSyncImpl = $1rKN8[$d7b8f401c6bc9326$var$FLUSH_SYNC];
const $d7b8f401c6bc9326$var$USE_ID = "useId";
const $d7b8f401c6bc9326$var$useIdImpl = $3ZYaX[$d7b8f401c6bc9326$var$USE_ID];
function $d7b8f401c6bc9326$var$startTransitionSafe(cb) {
    if ($d7b8f401c6bc9326$var$startTransitionImpl) $d7b8f401c6bc9326$var$startTransitionImpl(cb);
    else cb();
}
function $d7b8f401c6bc9326$var$flushSyncSafe(cb) {
    if ($d7b8f401c6bc9326$var$flushSyncImpl) $d7b8f401c6bc9326$var$flushSyncImpl(cb);
    else cb();
}
class $d7b8f401c6bc9326$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d7b8f401c6bc9326$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $3ZYaX.useState(router.state);
    let [pendingState, setPendingState] = $3ZYaX.useState();
    let [vtContext, setVtContext] = $3ZYaX.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $3ZYaX.useState();
    let [transition, setTransition] = $3ZYaX.useState();
    let [interruption, setInterruption] = $3ZYaX.useState();
    let fetcherData = $3ZYaX.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $3ZYaX.useCallback((cb)=>{
        if (v7_startTransition) $d7b8f401c6bc9326$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $3ZYaX.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $d7b8f401c6bc9326$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $d7b8f401c6bc9326$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $d7b8f401c6bc9326$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $d7b8f401c6bc9326$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $d7b8f401c6bc9326$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $3ZYaX.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $3ZYaX.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d7b8f401c6bc9326$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $3ZYaX.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $3ZYaX.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $3ZYaX.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $3ZYaX.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $3ZYaX.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $3ZYaX.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $3ZYaX.createElement($d7b8f401c6bc9326$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $3ZYaX.createElement($d7b8f401c6bc9326$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $3ZYaX.createElement($d7b8f401c6bc9326$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $d7b8f401c6bc9326$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $39b0bf07af9c8a3f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $d7b8f401c6bc9326$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $3ZYaX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f63a70a01eff4b4e$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3ZYaX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3ZYaX.useCallback((newState)=>{
        v7_startTransition && $d7b8f401c6bc9326$var$startTransitionImpl ? $d7b8f401c6bc9326$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3ZYaX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $d7b8f401c6bc9326$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $3ZYaX.useRef();
    if (historyRef.current == null) historyRef.current = (0, $f63a70a01eff4b4e$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $3ZYaX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3ZYaX.useCallback((newState)=>{
        v7_startTransition && $d7b8f401c6bc9326$var$startTransitionImpl ? $d7b8f401c6bc9326$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3ZYaX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $d7b8f401c6bc9326$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $3ZYaX.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $3ZYaX.useCallback((newState)=>{
        v7_startTransition && $d7b8f401c6bc9326$var$startTransitionImpl ? $d7b8f401c6bc9326$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $3ZYaX.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $39b0bf07af9c8a3f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $d7b8f401c6bc9326$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $d7b8f401c6bc9326$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $d7b8f401c6bc9326$export$a6c7ac8248d6e38a = /*#__PURE__*/ $3ZYaX.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $d7b8f401c6bc9326$var$_objectWithoutPropertiesLoose(_ref7, $d7b8f401c6bc9326$var$_excluded);
    let { basename: basename } = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $d7b8f401c6bc9326$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($d7b8f401c6bc9326$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $39b0bf07af9c8a3f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $d7b8f401c6bc9326$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $3ZYaX.createElement("a", $d7b8f401c6bc9326$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $d7b8f401c6bc9326$export$b0d92dbee9b5b60d = /*#__PURE__*/ $3ZYaX.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $d7b8f401c6bc9326$var$_objectWithoutPropertiesLoose(_ref8, $d7b8f401c6bc9326$var$_excluded2);
    let path = (0, $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    let routerState = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $d7b8f401c6bc9326$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $3ZYaX.createElement($d7b8f401c6bc9326$export$a6c7ac8248d6e38a, $d7b8f401c6bc9326$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $d7b8f401c6bc9326$export$a7fed597f4b8afd8 = /*#__PURE__*/ $3ZYaX.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $d7b8f401c6bc9326$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $d7b8f401c6bc9326$var$_objectWithoutPropertiesLoose(_ref9, $d7b8f401c6bc9326$var$_excluded3);
    let submit = $d7b8f401c6bc9326$export$47c85c6e3a081d3();
    let formAction = $d7b8f401c6bc9326$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $3ZYaX.createElement("form", $d7b8f401c6bc9326$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $d7b8f401c6bc9326$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $d7b8f401c6bc9326$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $d7b8f401c6bc9326$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($d7b8f401c6bc9326$var$DataRouterHook || ($d7b8f401c6bc9326$var$DataRouterHook = {}));
var $d7b8f401c6bc9326$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($d7b8f401c6bc9326$var$DataRouterStateHook || ($d7b8f401c6bc9326$var$DataRouterStateHook = {}));
// Internal hooks
function $d7b8f401c6bc9326$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $d7b8f401c6bc9326$var$useDataRouterContext(hookName) {
    let ctx = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$3add0d5dce533e2e));
    !ctx && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d7b8f401c6bc9326$var$useDataRouterState(hookName) {
    let state = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$145dfa71566a64dc));
    !state && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $d7b8f401c6bc9326$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    let location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    let path = (0, $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $3ZYaX.useCallback((event)=>{
        if ($d7b8f401c6bc9326$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $f63a70a01eff4b4e$export$fe53371bee54353d)(location) === (0, $f63a70a01eff4b4e$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $d7b8f401c6bc9326$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $3ZYaX.useRef($d7b8f401c6bc9326$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $3ZYaX.useRef(false);
    let location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    let searchParams = $3ZYaX.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $d7b8f401c6bc9326$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    let setSearchParams = $3ZYaX.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $d7b8f401c6bc9326$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $d7b8f401c6bc9326$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $d7b8f401c6bc9326$var$fetcherId = 0;
let $d7b8f401c6bc9326$var$getUniqueFetcherId = ()=>"__" + String(++$d7b8f401c6bc9326$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $d7b8f401c6bc9326$export$47c85c6e3a081d3() {
    let { router: router } = $d7b8f401c6bc9326$var$useDataRouterContext($d7b8f401c6bc9326$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$26749e8557646306));
    let currentRouteId = (0, $39b0bf07af9c8a3f$export$5fc8298006ad9e58)();
    return $3ZYaX.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $d7b8f401c6bc9326$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $d7b8f401c6bc9326$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $d7b8f401c6bc9326$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $d7b8f401c6bc9326$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$26749e8557646306));
    let routeContext = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$9072aa6dd1f93057));
    !routeContext && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $d7b8f401c6bc9326$var$_extends({}, (0, $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f63a70a01eff4b4e$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $f63a70a01eff4b4e$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $d7b8f401c6bc9326$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $d7b8f401c6bc9326$var$useDataRouterContext($d7b8f401c6bc9326$var$DataRouterHook.UseFetcher);
    let state = $d7b8f401c6bc9326$var$useDataRouterState($d7b8f401c6bc9326$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $3ZYaX.useContext($d7b8f401c6bc9326$export$148fd98d095596d4);
    let route = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    !route && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $d7b8f401c6bc9326$var$useIdImpl ? $d7b8f401c6bc9326$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $3ZYaX.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($d7b8f401c6bc9326$var$getUniqueFetcherId());
    // Registration/cleanup
    $3ZYaX.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $3ZYaX.useCallback((href, opts)=>{
        !routeId && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $d7b8f401c6bc9326$export$47c85c6e3a081d3();
    let submit = $3ZYaX.useCallback((target, opts)=>{
        submitImpl(target, $d7b8f401c6bc9326$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $3ZYaX.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $3ZYaX.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $3ZYaX.createElement($d7b8f401c6bc9326$export$a7fed597f4b8afd8, $d7b8f401c6bc9326$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $f63a70a01eff4b4e$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $3ZYaX.useMemo(()=>$d7b8f401c6bc9326$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $d7b8f401c6bc9326$export$fa996778a3a31087() {
    let state = $d7b8f401c6bc9326$var$useDataRouterState($d7b8f401c6bc9326$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $d7b8f401c6bc9326$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $d7b8f401c6bc9326$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $d7b8f401c6bc9326$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $d7b8f401c6bc9326$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $d7b8f401c6bc9326$var$useDataRouterContext($d7b8f401c6bc9326$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $d7b8f401c6bc9326$var$useDataRouterState($d7b8f401c6bc9326$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $3ZYaX.useContext((0, $39b0bf07af9c8a3f$export$26749e8557646306));
    let location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    let matches = (0, $39b0bf07af9c8a3f$export$2378eb7f5ff86053)();
    let navigation = (0, $39b0bf07af9c8a3f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $3ZYaX.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $d7b8f401c6bc9326$var$usePageHide($3ZYaX.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $d7b8f401c6bc9326$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $d7b8f401c6bc9326$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($d7b8f401c6bc9326$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3ZYaX.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $d7b8f401c6bc9326$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $d7b8f401c6bc9326$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3ZYaX.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($d7b8f401c6bc9326$var$_extends({}, location, {
                    pathname: (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($d7b8f401c6bc9326$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $3ZYaX.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d7b8f401c6bc9326$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $3ZYaX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $d7b8f401c6bc9326$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $3ZYaX.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $d7b8f401c6bc9326$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $39b0bf07af9c8a3f$export$b273b3273281a049)(when);
    $3ZYaX.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $3ZYaX.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $d7b8f401c6bc9326$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $3ZYaX.useContext($d7b8f401c6bc9326$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $f63a70a01eff4b4e$export$3e9cee6b33872309)(false);
    let { basename: basename } = $d7b8f401c6bc9326$var$useDataRouterContext($d7b8f401c6bc9326$var$DataRouterHook.useViewTransitionState);
    let path = (0, $39b0bf07af9c8a3f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f63a70a01eff4b4e$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $f63a70a01eff4b4e$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f63a70a01eff4b4e$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("3ZYaX");
var $b46b478a1bec4671$exports = {};
'use strict';
function $b46b478a1bec4671$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b46b478a1bec4671$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b46b478a1bec4671$var$_arrayLikeToArray(o, minLen);
}
function $b46b478a1bec4671$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b46b478a1bec4671$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b46b478a1bec4671$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b46b478a1bec4671$var$shallow$1(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $b46b478a1bec4671$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $b46b478a1bec4671$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var _i = 0, _keysA = keysA; _i < _keysA.length; _i++){
        var keyA = _keysA[_i];
        if (!Object.prototype.hasOwnProperty.call(objB, keyA) || !Object.is(objA[keyA], objB[keyA])) return false;
    }
    return true;
}
var $b46b478a1bec4671$var$shallow = function(objA, objB) {
    return $b46b478a1bec4671$var$shallow$1(objA, objB);
};
$b46b478a1bec4671$exports.default = $b46b478a1bec4671$var$shallow;
$b46b478a1bec4671$exports.shallow = $b46b478a1bec4671$var$shallow$1;
$b46b478a1bec4671$exports = $b46b478a1bec4671$var$shallow;
$b46b478a1bec4671$exports.shallow = $b46b478a1bec4671$var$shallow$1;
$b46b478a1bec4671$exports.default = $b46b478a1bec4671$exports;



var $3ZYaX = parcelRequire("3ZYaX");
const $356f3b796f315527$export$1cf3d545f2d4635c = console;


// TYPES
// UTILS
const $c605a202d5350bab$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $c605a202d5350bab$export$8793edee2d425525() {
    return undefined;
}
function $c605a202d5350bab$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $c605a202d5350bab$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $c605a202d5350bab$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $c605a202d5350bab$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $c605a202d5350bab$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $c605a202d5350bab$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$c605a202d5350bab$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $c605a202d5350bab$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($c605a202d5350bab$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === 'function') return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $c605a202d5350bab$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $c605a202d5350bab$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $c605a202d5350bab$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $c605a202d5350bab$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $c605a202d5350bab$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($c605a202d5350bab$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $c605a202d5350bab$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$c605a202d5350bab$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $c605a202d5350bab$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($c605a202d5350bab$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($c605a202d5350bab$export$5fcb678681417b54(mutation.options.mutationKey) !== $c605a202d5350bab$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$c605a202d5350bab$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $c605a202d5350bab$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $c605a202d5350bab$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $c605a202d5350bab$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$c605a202d5350bab$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $c605a202d5350bab$export$2f07189bb9fa26a7(a, b) {
    return $c605a202d5350bab$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $c605a202d5350bab$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$c605a202d5350bab$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $c605a202d5350bab$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $c605a202d5350bab$export$7a8558113332b71e(a) && $c605a202d5350bab$export$7a8558113332b71e(b);
    if (array || $c605a202d5350bab$export$53b83ca8eaab0383(a) && $c605a202d5350bab$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $c605a202d5350bab$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $c605a202d5350bab$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $c605a202d5350bab$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $c605a202d5350bab$export$53b83ca8eaab0383(o) {
    if (!$c605a202d5350bab$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$c605a202d5350bab$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $c605a202d5350bab$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $c605a202d5350bab$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $c605a202d5350bab$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $c605a202d5350bab$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $c605a202d5350bab$export$4304cb76768ca134(callback) {
    $c605a202d5350bab$export$e772c8ff12451969(0).then(callback);
}
function $c605a202d5350bab$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $c605a202d5350bab$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $c605a202d5350bab$export$77a71fc411098696(prevData, data);
    return data;
}


function $f7e0cf734e43803a$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $c605a202d5350bab$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $c605a202d5350bab$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $f7e0cf734e43803a$export$520687f44db6e1ab = $f7e0cf734e43803a$export$316a8efd03cd1458();



class $05adadaed4d84884$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $c605a202d5350bab$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $c605a202d5350bab$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


class $27023d6fa7ca76c7$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}



class $01b2487d98fd4b28$export$86f1af424b2ca4de extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $c605a202d5350bab$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
}
const $01b2487d98fd4b28$export$6bf54661be5b02cf = new $01b2487d98fd4b28$export$86f1af424b2ca4de();




const $6b21af9567c004f2$var$onlineEvents = [
    'online',
    'offline'
];
class $6b21af9567c004f2$export$58774fb55d5ff7fc extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $c605a202d5350bab$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $6b21af9567c004f2$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $6b21af9567c004f2$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $6b21af9567c004f2$export$b113e788b2dd3fdc = new $6b21af9567c004f2$export$58774fb55d5ff7fc();



function $74b6b313428d4b70$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $74b6b313428d4b70$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $6b21af9567c004f2$export$b113e788b2dd3fdc).isOnline() : true;
}
class $74b6b313428d4b70$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $74b6b313428d4b70$export$986cc6445c1d323(value) {
    return value instanceof $74b6b313428d4b70$export$a8430ed4188f35a9;
}
function $74b6b313428d4b70$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $74b6b313428d4b70$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $01b2487d98fd4b28$export$6bf54661be5b02cf).isFocused() || config.networkMode !== 'always' && !(0, $6b21af9567c004f2$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $74b6b313428d4b70$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $c605a202d5350bab$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($74b6b313428d4b70$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}


// CLASS
class $2ee6d28a19199e77$export$17b8b19c814bcf56 extends (0, $05adadaed4d84884$export$e09608847fcc8c59) {
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $74b6b313428d4b70$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        isPaused: true
                    };
                case 'continue':
                    return {
                        ...state,
                        isPaused: false
                    };
                case 'loading':
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $74b6b313428d4b70$export$61b92f63f30245cf)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    };
                case 'error':
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $356f3b796f315527$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $2ee6d28a19199e77$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $2ee6d28a19199e77$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}





// CLASS
class $bdd382e6417b162b$export$d3c1860ee66f291a extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $c605a202d5350bab$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: 'observerOptionsUpdated',
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === 'success') notifyOptions.onSuccess = true;
        else if (action.type === 'error') notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== 'undefined' ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $2ee6d28a19199e77$export$a1659b54bac3252a)();
        const result = {
            ...state,
            isLoading: state.status === 'loading',
            isSuccess: state.status === 'success',
            isError: state.status === 'error',
            isIdle: state.status === 'idle',
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
}



var $fDTdX = parcelRequire("fDTdX");
'use client';
const $9578b3b33202736e$export$306c0aa65ff9ec16 = (0, $fDTdX.useSyncExternalStore);



function $2d05195a46cd471f$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


'use client';
function $1daf076503e453a3$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $c605a202d5350bab$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $619931fcf5fffd95$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $3ZYaX.useState(()=>new (0, $bdd382e6417b162b$export$d3c1860ee66f291a)(queryClient, options));
    $3ZYaX.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $9578b3b33202736e$export$306c0aa65ff9ec16)($3ZYaX.useCallback((onStoreChange)=>observer.subscribe((0, $f7e0cf734e43803a$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $3ZYaX.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($1daf076503e453a3$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $2d05195a46cd471f$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $1daf076503e453a3$var$noop() {}






class $8da9d3df7c0176bf$export$a06cf8c0066f0d4c extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($8da9d3df7c0176bf$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $8da9d3df7c0176bf$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $8da9d3df7c0176bf$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $c605a202d5350bab$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $8da9d3df7c0176bf$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($8da9d3df7c0176bf$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $c605a202d5350bab$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $c605a202d5350bab$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $c605a202d5350bab$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $c605a202d5350bab$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $c605a202d5350bab$export$6acf61af03e62db) || this.options.enabled === false || !(0, $c605a202d5350bab$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $01b2487d98fd4b28$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $8da9d3df7c0176bf$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $8da9d3df7c0176bf$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $74b6b313428d4b70$export$61b92f63f30245cf)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $c605a202d5350bab$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $c605a202d5350bab$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $8da9d3df7c0176bf$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $c605a202d5350bab$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $74b6b313428d4b70$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $8da9d3df7c0176bf$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $8da9d3df7c0176bf$var$shouldFetchOnMount(query, options) {
    return $8da9d3df7c0176bf$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $8da9d3df7c0176bf$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $8da9d3df7c0176bf$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $8da9d3df7c0176bf$var$isStale(query, options);
    }
    return false;
}
function $8da9d3df7c0176bf$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $8da9d3df7c0176bf$var$isStale(query, options);
}
function $8da9d3df7c0176bf$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $8da9d3df7c0176bf$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $c605a202d5350bab$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
'use client';
function $048956a891f241a9$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $048956a891f241a9$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $3ZYaX.createContext($048956a891f241a9$var$createValue()); // HOOK
const $048956a891f241a9$export$50dfac555130cafd = ()=>$3ZYaX.useContext($048956a891f241a9$var$QueryErrorResetBoundaryContext); // COMPONENT
const $048956a891f241a9$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $3ZYaX.useState(()=>$048956a891f241a9$var$createValue());
    return /*#__PURE__*/ $3ZYaX.createElement($048956a891f241a9$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




var $3ZYaX = parcelRequire("3ZYaX");
'use client';
const $7400e85568e14759$var$IsRestoringContext = /*#__PURE__*/ $3ZYaX.createContext(false);
const $7400e85568e14759$export$4da0178d6b5f553 = ()=>$3ZYaX.useContext($7400e85568e14759$var$IsRestoringContext);
const $7400e85568e14759$export$593807d4e94f9621 = $7400e85568e14759$var$IsRestoringContext.Provider;



var $3ZYaX = parcelRequire("3ZYaX");

'use client';
const $4f7c315d3461f4ec$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $4f7c315d3461f4ec$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $3ZYaX.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $4f7c315d3461f4ec$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $2d05195a46cd471f$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


const $f9d422589a39ca0e$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
    }
};
const $f9d422589a39ca0e$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $f9d422589a39ca0e$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $f9d422589a39ca0e$export$e0a3f29513afe430(result, isRestoring);
const $f9d422589a39ca0e$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


'use client';
function $c6ae92e200da3d68$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $619931fcf5fffd95$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $7400e85568e14759$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $048956a891f241a9$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $f9d422589a39ca0e$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $4f7c315d3461f4ec$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $4f7c315d3461f4ec$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $3ZYaX.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $9578b3b33202736e$export$306c0aa65ff9ec16)($3ZYaX.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $f7e0cf734e43803a$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $3ZYaX.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $f9d422589a39ca0e$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $f9d422589a39ca0e$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $4f7c315d3461f4ec$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


'use client';
function $407df0c050c02c45$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $c605a202d5350bab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $c6ae92e200da3d68$export$fff0865807e996c5)(parsedOptions, (0, $8da9d3df7c0176bf$export$a06cf8c0066f0d4c));
}









// CLASS
class $baf99b26bad67f11$export$62297b13309008b2 extends (0, $05adadaed4d84884$export$e09608847fcc8c59) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $c605a202d5350bab$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $c605a202d5350bab$export$8793edee2d425525)).catch((0, $c605a202d5350bab$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $c605a202d5350bab$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $c605a202d5350bab$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $74b6b313428d4b70$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $74b6b313428d4b70$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $74b6b313428d4b70$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case 'pause':
                    return {
                        ...state,
                        fetchStatus: 'paused'
                    };
                case 'continue':
                    return {
                        ...state,
                        fetchStatus: 'fetching'
                    };
                case 'fetch':
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $74b6b313428d4b70$export$61b92f63f30245cf)(this.options.networkMode) ? 'fetching' : 'paused',
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: 'loading'
                        }
                    };
                case 'success':
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success',
                        ...!action.manual && {
                            fetchStatus: 'idle',
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case 'error':
                    const error = action.error;
                    if ((0, $74b6b313428d4b70$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: 'idle'
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    };
                case 'invalidate':
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case 'setState':
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $356f3b796f315527$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $baf99b26bad67f11$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $baf99b26bad67f11$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}




// CLASS
class $88203739da9805a3$export$5dde0cd941da8468 extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $c605a202d5350bab$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $baf99b26bad67f11$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $c605a202d5350bab$export$c5d1efe363797780)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $c605a202d5350bab$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}






// CLASS
class $1d833e9e175c81bd$export$1fcfd9a244434844 extends (0, $27023d6fa7ca76c7$export$d26086b469ecdbcc) {
    build(client, options, state) {
        const mutation = new (0, $2ee6d28a19199e77$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $c605a202d5350bab$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $c605a202d5350bab$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $c605a202d5350bab$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}





function $933ce1a7f31c55af$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $933ce1a7f31c55af$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $933ce1a7f31c55af$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $933ce1a7f31c55af$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $933ce1a7f31c55af$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $933ce1a7f31c55af$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $933ce1a7f31c55af$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $933ce1a7f31c55af$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $933ce1a7f31c55af$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $933ce1a7f31c55af$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $13f267abc53e15f9$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $01b2487d98fd4b28$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $01b2487d98fd4b28$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $6b21af9567c004f2$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $6b21af9567c004f2$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $c605a202d5350bab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $c605a202d5350bab$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $c605a202d5350bab$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: 'active',
            ...filters
        };
        return (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $c605a202d5350bab$export$8793edee2d425525)).catch((0, $c605a202d5350bab$export$8793edee2d425525));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $c605a202d5350bab$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $f7e0cf734e43803a$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $c605a202d5350bab$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $c605a202d5350bab$export$8793edee2d425525));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $c605a202d5350bab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $c605a202d5350bab$export$8793edee2d425525)).catch((0, $c605a202d5350bab$export$8793edee2d425525));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $c605a202d5350bab$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $933ce1a7f31c55af$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $c605a202d5350bab$export$8793edee2d425525)).catch((0, $c605a202d5350bab$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $c605a202d5350bab$export$5fcb678681417b54)(queryKey) === (0, $c605a202d5350bab$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $c605a202d5350bab$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $c605a202d5350bab$export$5fcb678681417b54)(mutationKey) === (0, $c605a202d5350bab$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $c605a202d5350bab$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $c605a202d5350bab$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $88203739da9805a3$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $1d833e9e175c81bd$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $356f3b796f315527$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}



var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");
const $9dc9b58c4343865b$export$7c07b633a151f9c5 = new (0, $13f267abc53e15f9$export$405d0624ed55a03f)({
    defaultOptions: {
        //TODO: mutations clear cache on Success (by first string in key)
        queries: {
            select (data) {
                const d = data//TODO: try to improve types
                ;
                return d.data;
            },
            retry (failureCount, error) {
                if (error?.isAxiosError) {
                    const err = error.toJSON();
                    if (err.status >= 400) //TODO: improve codes to check
                    return false;
                }
                return failureCount <= 2;
            }
        }
    }
});
const $9dc9b58c4343865b$export$9f6abfd74295843b = (resourceName, apiFn, id, params, options)=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)([
        resourceName,
        id
    ], async ()=>apiFn(params ? {
            id: id,
            ...params
        } : id), {
        enabled: Boolean(id),
        ...options
    });
const $9dc9b58c4343865b$export$4e85cc9b40c906e6 = (resourceName, apiFn, params, options)=>{
    return (0, $407df0c050c02c45$export$dd0a697e1782aedd)([
        resourceName,
        params || {}
    ], async ()=>apiFn(params), options);
};
const $9dc9b58c4343865b$export$29ea95f3fea1dc1c = (key)=>{
    const [mutationState, setMutationState] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    $9dc9b58c4343865b$export$7c07b633a151f9c5.getMutationCache().subscribe((data)=>{
        if (data.mutation && (0, $2KSUA.isEmpty)((0, $2KSUA.xorWith)(key, data.mutation?.options.mutationKey, (0, $2KSUA.isEqual)))) setMutationState(data.mutation.state);
    });
    return mutationState;
};


var $f2bd57a5a837b3af$exports = {};
'use strict';
var $546f97235f30c7b6$exports = {};
'use strict';
var $546f97235f30c7b6$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === 'function' ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== 'object' || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var getInitialState = function getInitialState() {
        return initialState;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    var initialState = state = createState(setState, getState, api);
    return api;
};
var $546f97235f30c7b6$var$createStore = function createStore(createState) {
    return createState ? $546f97235f30c7b6$var$createStoreImpl(createState) : $546f97235f30c7b6$var$createStoreImpl;
};
var $546f97235f30c7b6$var$vanilla = function(createState) {
    return $546f97235f30c7b6$var$createStore(createState);
};
$546f97235f30c7b6$exports.createStore = $546f97235f30c7b6$var$createStore;
$546f97235f30c7b6$exports.default = $546f97235f30c7b6$var$vanilla;
$546f97235f30c7b6$exports = $546f97235f30c7b6$var$vanilla;
$546f97235f30c7b6$exports.createStore = $546f97235f30c7b6$var$createStore;
$546f97235f30c7b6$exports.default = $546f97235f30c7b6$exports;



var $3ZYaX = parcelRequire("3ZYaX");
var $aa814cc78137e5ae$exports = {};
'use strict';

$aa814cc78137e5ae$exports = (parcelRequire("6eIWH"));


var $f2bd57a5a837b3af$var$useDebugValue = $3ZYaX.useDebugValue;
var $f2bd57a5a837b3af$var$useSyncExternalStoreWithSelector = $aa814cc78137e5ae$exports.useSyncExternalStoreWithSelector;
var $f2bd57a5a837b3af$var$didWarnAboutEqualityFn = false;
var $f2bd57a5a837b3af$var$identity = function identity(arg) {
    return arg;
};
function $f2bd57a5a837b3af$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = $f2bd57a5a837b3af$var$identity;
    var slice = $f2bd57a5a837b3af$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $f2bd57a5a837b3af$var$useDebugValue(slice);
    return slice;
}
var $f2bd57a5a837b3af$var$createImpl = function createImpl(createState) {
    var api = typeof createState === 'function' ? $546f97235f30c7b6$exports.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $f2bd57a5a837b3af$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $f2bd57a5a837b3af$var$create = function create(createState) {
    return createState ? $f2bd57a5a837b3af$var$createImpl(createState) : $f2bd57a5a837b3af$var$createImpl;
};
var $f2bd57a5a837b3af$var$react = function(createState) {
    return $f2bd57a5a837b3af$var$create(createState);
};
$f2bd57a5a837b3af$exports.create = $f2bd57a5a837b3af$var$create;
$f2bd57a5a837b3af$exports.default = $f2bd57a5a837b3af$var$react;
$f2bd57a5a837b3af$exports.useStore = $f2bd57a5a837b3af$var$useStore;
Object.keys($546f97235f30c7b6$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($f2bd57a5a837b3af$exports, k)) Object.defineProperty($f2bd57a5a837b3af$exports, k, {
        enumerable: true,
        get: function() {
            return $546f97235f30c7b6$exports[k];
        }
    });
});
$f2bd57a5a837b3af$exports = $f2bd57a5a837b3af$var$react;
$f2bd57a5a837b3af$exports.create = $f2bd57a5a837b3af$var$create;
$f2bd57a5a837b3af$exports.useStore = $f2bd57a5a837b3af$var$useStore;
$f2bd57a5a837b3af$exports.createStore = $546f97235f30c7b6$exports.createStore;
$f2bd57a5a837b3af$exports.default = $f2bd57a5a837b3af$exports;


var $29dcdb827ef0bfdf$export$1be1fc439b849fdf;
var $29dcdb827ef0bfdf$export$95a3b7b12ab518f9;
var $29dcdb827ef0bfdf$export$6922d3b3a607469e;
var $29dcdb827ef0bfdf$export$9a6132153fba2e0;
var $29dcdb827ef0bfdf$export$4feba8a1bc8e9afd;
var $29dcdb827ef0bfdf$export$5c593627aef9f076;
'use strict';
function $29dcdb827ef0bfdf$var$_extends() {
    $29dcdb827ef0bfdf$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $29dcdb827ef0bfdf$var$_extends.apply(this, arguments);
}
function $29dcdb827ef0bfdf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $29dcdb827ef0bfdf$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $29dcdb827ef0bfdf$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $29dcdb827ef0bfdf$var$redux = $29dcdb827ef0bfdf$var$reduxImpl;
var $29dcdb827ef0bfdf$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $29dcdb827ef0bfdf$var$_excluded2 = [
    "connection"
];
var $29dcdb827ef0bfdf$var$trackedConnections = new Map();
var $29dcdb827ef0bfdf$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $29dcdb827ef0bfdf$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $29dcdb827ef0bfdf$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: 'untracked',
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $29dcdb827ef0bfdf$var$trackedConnections.get(options.name);
    if (existingConnection) return $29dcdb827ef0bfdf$var$_extends({
        type: 'tracked',
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $29dcdb827ef0bfdf$var$trackedConnections.set(options.name, newConnection);
    return $29dcdb827ef0bfdf$var$_extends({
        type: 'tracked',
        store: store
    }, newConnection);
};
var $29dcdb827ef0bfdf$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $29dcdb827ef0bfdf$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $29dcdb827ef0bfdf$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $29dcdb827ef0bfdf$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $29dcdb827ef0bfdf$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $29dcdb827ef0bfdf$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || 'anonymous'
            } : typeof nameOrAction === 'string' ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($29dcdb827ef0bfdf$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $29dcdb827ef0bfdf$var$_extends({}, $29dcdb827ef0bfdf$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === 'untracked') connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === 'function') {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case 'ACTION':
                    if (typeof message.payload !== 'string') {
                        console.error('[zustand devtools middleware] Unsupported action format');
                        return;
                    }
                    return $29dcdb827ef0bfdf$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === '__setState') {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== 'function') return;
                        api.dispatch(action);
                    });
                case 'DISPATCH':
                    switch(message.payload.type){
                        case 'RESET':
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($29dcdb827ef0bfdf$var$getTrackedConnectionState(options.name));
                        case 'COMMIT':
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($29dcdb827ef0bfdf$var$getTrackedConnectionState(options.name));
                        case 'ROLLBACK':
                            return $29dcdb827ef0bfdf$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($29dcdb827ef0bfdf$var$getTrackedConnectionState(options.name));
                            });
                        case 'JUMP_TO_STATE':
                        case 'JUMP_TO_ACTION':
                            return $29dcdb827ef0bfdf$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case 'IMPORT_STATE':
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case 'PAUSE_RECORDING':
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $29dcdb827ef0bfdf$var$devtools = $29dcdb827ef0bfdf$var$devtoolsImpl;
var $29dcdb827ef0bfdf$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error('[zustand devtools middleware] Could not parse the received json', e);
    }
    if (parsed !== undefined) f(parsed);
};
var $29dcdb827ef0bfdf$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $29dcdb827ef0bfdf$var$subscribeWithSelector = $29dcdb827ef0bfdf$var$subscribeWithSelectorImpl;
var $29dcdb827ef0bfdf$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $29dcdb827ef0bfdf$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $29dcdb827ef0bfdf$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $29dcdb827ef0bfdf$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $29dcdb827ef0bfdf$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $29dcdb827ef0bfdf$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $29dcdb827ef0bfdf$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($29dcdb827ef0bfdf$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $29dcdb827ef0bfdf$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $29dcdb827ef0bfdf$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $29dcdb827ef0bfdf$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $29dcdb827ef0bfdf$var$_extends({
            storage: $29dcdb827ef0bfdf$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $29dcdb827ef0bfdf$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($29dcdb827ef0bfdf$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        api.getInitialState = function() {
            return configResult;
        };
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $29dcdb827ef0bfdf$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === 'number' && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $29dcdb827ef0bfdf$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $29dcdb827ef0bfdf$var$persistImpl = function persistImpl(config, baseOptions) {
    if ('getStorage' in baseOptions || 'serialize' in baseOptions || 'deserialize' in baseOptions) return $29dcdb827ef0bfdf$var$oldImpl(config, baseOptions);
    return $29dcdb827ef0bfdf$var$newImpl(config, baseOptions);
};
var $29dcdb827ef0bfdf$var$persist = $29dcdb827ef0bfdf$var$persistImpl;
$29dcdb827ef0bfdf$export$1be1fc439b849fdf = $29dcdb827ef0bfdf$var$combine;
$29dcdb827ef0bfdf$export$95a3b7b12ab518f9 = $29dcdb827ef0bfdf$var$createJSONStorage;
$29dcdb827ef0bfdf$export$6922d3b3a607469e = $29dcdb827ef0bfdf$var$devtools;
$29dcdb827ef0bfdf$export$9a6132153fba2e0 = $29dcdb827ef0bfdf$var$persist;
$29dcdb827ef0bfdf$export$4feba8a1bc8e9afd = $29dcdb827ef0bfdf$var$redux;
$29dcdb827ef0bfdf$export$5c593627aef9f076 = $29dcdb827ef0bfdf$var$subscribeWithSelector;



var $f70Wr = parcelRequire("f70Wr");
function $b057e3b44276ba44$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}



function $143ffd39167373a2$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $143ffd39167373a2$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $143ffd39167373a2$export$2e2bcd8739ae039(o);
}


function $ae3f0819e3372146$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $39028f7a2e9d41b1$export$2e2bcd8739ae039(argument) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $143ffd39167373a2$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $5cd07d7a10c54769$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}



var $c468ed5e889a430e$var$MILLISECONDS_IN_HOUR = 3600000;
function $c468ed5e889a430e$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5cd07d7a10c54769$export$2e2bcd8739ae039)(dirtyDate, amount * $c468ed5e889a430e$var$MILLISECONDS_IN_HOUR);
}




var $df15ea422e6c097c$var$MILLISECONDS_IN_MINUTE = 60000;
function $df15ea422e6c097c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5cd07d7a10c54769$export$2e2bcd8739ae039)(dirtyDate, amount * $df15ea422e6c097c$var$MILLISECONDS_IN_MINUTE);
}





function $ffff430a208564ac$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}



function $7f0edb3b96fe70cc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $ffff430a208564ac$export$2e2bcd8739ae039)(dirtyDate, days);
}



function $a1d8421bf1d3b65c$export$2e2bcd8739ae039(dirtyInterval, options) {
    var _options$step;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}





var $337760cc38e3625f$var$defaultOptions = {};
function $337760cc38e3625f$export$430a3269e24b912e() {
    return $337760cc38e3625f$var$defaultOptions;
}
function $337760cc38e3625f$export$95365be1b0704abc(newOptions) {
    $337760cc38e3625f$var$defaultOptions = newOptions;
}


function $63a6eac007c76fc6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $9b8ab39a46fc8509$export$2e2bcd8739ae039(dirtyInterval, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.start);
    var endDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var startDateWeek = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(startDate, options);
    var endDateWeek = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    endTime = endDateWeek.getTime();
    var weeks = [];
    var currentWeek = startDateWeek;
    while(currentWeek.getTime() <= endTime){
        currentWeek.setHours(0);
        weeks.push((0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(currentWeek));
        currentWeek = (0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(currentWeek, 1);
        currentWeek.setHours(15);
    }
    return weeks;
}





function $d9677f7cca086b20$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $22569ca76183a9da$export$2e2bcd8739ae039(value) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $143ffd39167373a2$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $c157c1756df385fe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $22569ca76183a9da$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}





function $bf358204eecbb5df$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $5cd07d7a10c54769$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $62beb35edfbbec23$var$MILLISECONDS_IN_DAY = 86400000;
function $62beb35edfbbec23$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $62beb35edfbbec23$var$MILLISECONDS_IN_DAY) + 1;
}





function $01500e4e6887ae6d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $098f21ef6150de9b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $cee933d27c7d1beb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $098f21ef6150de9b$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $31538da948800fca$var$MILLISECONDS_IN_WEEK = 604800000;
function $31538da948800fca$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)(date).getTime() - (0, $cee933d27c7d1beb$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $31538da948800fca$var$MILLISECONDS_IN_WEEK) + 1;
}








function $3b0e493a0f171243$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $cd0cbe88f0dad20f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $c2745c0ff05b08d2$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $cd0cbe88f0dad20f$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $f7f10b8c1779482c$var$MILLISECONDS_IN_WEEK = 604800000;
function $f7f10b8c1779482c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(date, options).getTime() - (0, $c2745c0ff05b08d2$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $f7f10b8c1779482c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $f504d5a2f6b456f1$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $83ec4333ca1aec3f$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $83ec4333ca1aec3f$export$2e2bcd8739ae039 = $83ec4333ca1aec3f$var$formatters;


var $30824b3124c46733$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $30824b3124c46733$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $cd0cbe88f0dad20f$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $098f21ef6150de9b$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $f7f10b8c1779482c$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $31538da948800fca$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $62beb35edfbbec23$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $30824b3124c46733$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $83ec4333ca1aec3f$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $30824b3124c46733$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $30824b3124c46733$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $30824b3124c46733$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $30824b3124c46733$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $30824b3124c46733$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $30824b3124c46733$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $30824b3124c46733$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $30824b3124c46733$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $30824b3124c46733$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $30824b3124c46733$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $30824b3124c46733$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(minutes, 2);
}
function $30824b3124c46733$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $30824b3124c46733$var$formatTimezone(offset, dirtyDelimiter);
}
function $30824b3124c46733$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $30824b3124c46733$export$2e2bcd8739ae039 = $30824b3124c46733$var$formatters;


var $2d527a05a01a79d3$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $2d527a05a01a79d3$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $2d527a05a01a79d3$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $2d527a05a01a79d3$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $2d527a05a01a79d3$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $2d527a05a01a79d3$var$timeLongFormatter(timePattern, formatLong));
};
var $2d527a05a01a79d3$var$longFormatters = {
    p: $2d527a05a01a79d3$var$timeLongFormatter,
    P: $2d527a05a01a79d3$var$dateTimeLongFormatter
};
var $2d527a05a01a79d3$export$2e2bcd8739ae039 = $2d527a05a01a79d3$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bc6257ff1cff4410$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $47d0602003c48d0a$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $47d0602003c48d0a$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $47d0602003c48d0a$export$c6cc36aa33304772(token) {
    return $47d0602003c48d0a$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $47d0602003c48d0a$export$c6b49d6dceb604a1(token) {
    return $47d0602003c48d0a$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $47d0602003c48d0a$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $ab48e92d148f6909$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $ab48e92d148f6909$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ab48e92d148f6909$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $ab48e92d148f6909$export$2e2bcd8739ae039 = $ab48e92d148f6909$var$formatDistance;


function $f72d8a19fa29cb48$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $024ef9223fbe5036$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $024ef9223fbe5036$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $024ef9223fbe5036$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $024ef9223fbe5036$var$formatLong = {
    date: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $024ef9223fbe5036$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $024ef9223fbe5036$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $024ef9223fbe5036$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $024ef9223fbe5036$export$2e2bcd8739ae039 = $024ef9223fbe5036$var$formatLong;


var $7b53cc3ac3a7c91a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $7b53cc3ac3a7c91a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7b53cc3ac3a7c91a$var$formatRelativeLocale[token];
};
var $7b53cc3ac3a7c91a$export$2e2bcd8739ae039 = $7b53cc3ac3a7c91a$var$formatRelative;


function $d6d2bf1a4bf1655c$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $63a4583a884c7161$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $63a4583a884c7161$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $63a4583a884c7161$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $63a4583a884c7161$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $63a4583a884c7161$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $63a4583a884c7161$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $63a4583a884c7161$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $63a4583a884c7161$var$localize = {
    ordinalNumber: $63a4583a884c7161$var$ordinalNumber,
    era: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $63a4583a884c7161$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $63a4583a884c7161$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $63a4583a884c7161$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $63a4583a884c7161$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $63a4583a884c7161$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $63a4583a884c7161$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $63a4583a884c7161$export$2e2bcd8739ae039 = $63a4583a884c7161$var$localize;


function $a629bca763ef4d7c$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $a629bca763ef4d7c$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $a629bca763ef4d7c$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $a629bca763ef4d7c$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $a629bca763ef4d7c$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $f043287ac78d7734$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $68d8c3ea52548963$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $68d8c3ea52548963$var$parseOrdinalNumberPattern = /\d+/i;
var $68d8c3ea52548963$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $68d8c3ea52548963$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $68d8c3ea52548963$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $68d8c3ea52548963$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $68d8c3ea52548963$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $68d8c3ea52548963$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $68d8c3ea52548963$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $68d8c3ea52548963$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $68d8c3ea52548963$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $68d8c3ea52548963$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $68d8c3ea52548963$var$match = {
    ordinalNumber: (0, $f043287ac78d7734$export$2e2bcd8739ae039)({
        matchPattern: $68d8c3ea52548963$var$matchOrdinalNumberPattern,
        parsePattern: $68d8c3ea52548963$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $68d8c3ea52548963$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $68d8c3ea52548963$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $68d8c3ea52548963$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $68d8c3ea52548963$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $68d8c3ea52548963$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $68d8c3ea52548963$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $68d8c3ea52548963$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $68d8c3ea52548963$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $68d8c3ea52548963$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $68d8c3ea52548963$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $68d8c3ea52548963$export$2e2bcd8739ae039 = $68d8c3ea52548963$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b6e2f2035ec02d1e$var$locale = {
    code: 'en-US',
    formatDistance: (0, $ab48e92d148f6909$export$2e2bcd8739ae039),
    formatLong: (0, $024ef9223fbe5036$export$2e2bcd8739ae039),
    formatRelative: (0, $7b53cc3ac3a7c91a$export$2e2bcd8739ae039),
    localize: (0, $63a4583a884c7161$export$2e2bcd8739ae039),
    match: (0, $68d8c3ea52548963$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b6e2f2035ec02d1e$export$2e2bcd8739ae039 = $b6e2f2035ec02d1e$var$locale;


var $9bf1fd7b116fa75d$export$2e2bcd8739ae039 = (0, $b6e2f2035ec02d1e$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $b3177a4462e15523$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $b3177a4462e15523$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $b3177a4462e15523$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $b3177a4462e15523$var$doubleQuoteRegExp = /''/g;
var $b3177a4462e15523$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $b3177a4462e15523$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9bf1fd7b116fa75d$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $c157c1756df385fe$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $bc6257ff1cff4410$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $bf358204eecbb5df$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($b3177a4462e15523$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $2d527a05a01a79d3$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($b3177a4462e15523$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $b3177a4462e15523$var$cleanEscapedString(substring);
        var formatter = (0, $30824b3124c46733$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $47d0602003c48d0a$export$c6b49d6dceb604a1)(substring)) (0, $47d0602003c48d0a$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $47d0602003c48d0a$export$c6cc36aa33304772)(substring)) (0, $47d0602003c48d0a$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($b3177a4462e15523$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $b3177a4462e15523$var$cleanEscapedString(input) {
    var matched = input.match($b3177a4462e15523$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($b3177a4462e15523$var$doubleQuoteRegExp, "'");
}




function $77f154409ac96cff$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var originalDate = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getDate(), 2);
        var month = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getMonth() + 1, 2);
        var year = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getHours(), 2);
        var minute = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getMinutes(), 2);
        var second = (0, $f504d5a2f6b456f1$export$2e2bcd8739ae039)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}



function $11bfe019cf2a8df5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var hours = date.getHours();
    return hours;
}



function $80bdff59a66cc285$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}







function $ac69c6a7c3af73c1$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $193d204cbbea937a$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $ac69c6a7c3af73c1$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $3cbe7fa53b58a992$var$MILLISECONDS_IN_WEEK = 604800000;
function $3cbe7fa53b58a992$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(date, options).getTime() - (0, $193d204cbbea937a$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $3cbe7fa53b58a992$var$MILLISECONDS_IN_WEEK) + 1;
}



function $379899354a78c3bb$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $2d2bd3707ace1804$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $b7e820f063c8ba7a$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyLeftDate);
    var dateRight = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}



function $5676184ed61a60f3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfWeek = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}



function $cdb7bbd11c0ab34d$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $5676184ed61a60f3$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}



function $8b3f11de065b50b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $d989ae9468b066a3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $ec8d0215c60e3f6d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $d989ae9468b066a3$export$2e2bcd8739ae039)(dirtyDate, Date.now());
}




function $498b19e6888511e3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $d989ae9468b066a3$export$2e2bcd8739ae039)(dirtyDate, (0, $ffff430a208564ac$export$2e2bcd8739ae039)(Date.now(), 1));
}





function $f85dee25334cb4c9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $ffff430a208564ac$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



function $0ccc909ab832fceb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $d989ae9468b066a3$export$2e2bcd8739ae039)(dirtyDate, (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)(Date.now(), 1));
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $43fc9b1fade34ef5$export$dfd9b671c89acc8e = 7;
var $43fc9b1fade34ef5$export$3913210603d8e9ae = 365.2425;
var $43fc9b1fade34ef5$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $43fc9b1fade34ef5$export$91246f0b9bd9beff = 60000;
var $43fc9b1fade34ef5$export$7f72910d6dfd237a = 3600000;
var $43fc9b1fade34ef5$export$397c2d5776aa9055 = 1000;
var $43fc9b1fade34ef5$export$4dec998e48f9c246 = -$43fc9b1fade34ef5$export$81caae6e1cc7a622;
var $43fc9b1fade34ef5$export$f2f5ae5a8e2d8f9f = 60;
var $43fc9b1fade34ef5$export$3c58128db900d44e = 3;
var $43fc9b1fade34ef5$export$80d7e435f744f319 = 12;
var $43fc9b1fade34ef5$export$4db7641526e3241f = 4;
var $43fc9b1fade34ef5$export$698aec755e92c695 = 3600;
var $43fc9b1fade34ef5$export$a77c1a7ebebe2a5a = 60;
var $43fc9b1fade34ef5$export$815a9362476d2fe3 = $43fc9b1fade34ef5$export$698aec755e92c695 * 24;
var $43fc9b1fade34ef5$export$34804a017b31e2fe = $43fc9b1fade34ef5$export$815a9362476d2fe3 * 7;
var $43fc9b1fade34ef5$export$7271e9e3478110d1 = $43fc9b1fade34ef5$export$815a9362476d2fe3 * $43fc9b1fade34ef5$export$3913210603d8e9ae;
var $43fc9b1fade34ef5$export$8e6600bbdee7dabb = $43fc9b1fade34ef5$export$7271e9e3478110d1 / 12;
var $43fc9b1fade34ef5$export$be1dccf2de902d31 = $43fc9b1fade34ef5$export$8e6600bbdee7dabb * 3;




function $bbf3e9545cdc59c8$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var additionalDigits = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $bbf3e9545cdc59c8$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $bbf3e9545cdc59c8$var$parseYear(dateStrings.date, additionalDigits);
        date = $bbf3e9545cdc59c8$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $bbf3e9545cdc59c8$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $bbf3e9545cdc59c8$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $bbf3e9545cdc59c8$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $bbf3e9545cdc59c8$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $bbf3e9545cdc59c8$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $bbf3e9545cdc59c8$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $bbf3e9545cdc59c8$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($bbf3e9545cdc59c8$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($bbf3e9545cdc59c8$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($bbf3e9545cdc59c8$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $bbf3e9545cdc59c8$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $bbf3e9545cdc59c8$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $bbf3e9545cdc59c8$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($bbf3e9545cdc59c8$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $bbf3e9545cdc59c8$var$parseDateUnit(captures[1]);
    var month = $bbf3e9545cdc59c8$var$parseDateUnit(captures[2]) - 1;
    var day = $bbf3e9545cdc59c8$var$parseDateUnit(captures[3]);
    var week = $bbf3e9545cdc59c8$var$parseDateUnit(captures[4]);
    var dayOfWeek = $bbf3e9545cdc59c8$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$bbf3e9545cdc59c8$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $bbf3e9545cdc59c8$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$bbf3e9545cdc59c8$var$validateDate(year, month, day) || !$bbf3e9545cdc59c8$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $bbf3e9545cdc59c8$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $bbf3e9545cdc59c8$var$parseTime(timeString) {
    var captures = timeString.match($bbf3e9545cdc59c8$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $bbf3e9545cdc59c8$var$parseTimeUnit(captures[1]);
    var minutes = $bbf3e9545cdc59c8$var$parseTimeUnit(captures[2]);
    var seconds = $bbf3e9545cdc59c8$var$parseTimeUnit(captures[3]);
    if (!$bbf3e9545cdc59c8$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $43fc9b1fade34ef5$export$7f72910d6dfd237a) + minutes * (0, $43fc9b1fade34ef5$export$91246f0b9bd9beff) + seconds * 1000;
}
function $bbf3e9545cdc59c8$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $bbf3e9545cdc59c8$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($bbf3e9545cdc59c8$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$bbf3e9545cdc59c8$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $43fc9b1fade34ef5$export$7f72910d6dfd237a) + minutes * (0, $43fc9b1fade34ef5$export$91246f0b9bd9beff));
}
function $bbf3e9545cdc59c8$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $bbf3e9545cdc59c8$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $bbf3e9545cdc59c8$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $bbf3e9545cdc59c8$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($bbf3e9545cdc59c8$var$daysInMonths[month] || ($bbf3e9545cdc59c8$var$isLeapYearIndex(year) ? 29 : 28));
}
function $bbf3e9545cdc59c8$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($bbf3e9545cdc59c8$var$isLeapYearIndex(year) ? 366 : 365);
}
function $bbf3e9545cdc59c8$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $bbf3e9545cdc59c8$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $bbf3e9545cdc59c8$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}



function $e10dd564cb9779fe$export$2e2bcd8739ae039(newOptions) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var result = {};
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) result[property] = defaultOptions[property];
    for(var _property in newOptions)if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
        if (newOptions[_property] === undefined) delete result[_property];
        else result[_property] = newOptions[_property];
    }
    (0, $337760cc38e3625f$export$95365be1b0704abc)(result);
}





function $324e53a432e321d3$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $3cbe7fa53b58a992$export$2e2bcd8739ae039)(date, options) - week;
    date.setDate(date.getDate() - diff * 7);
    return date;
}




function $ddab2dd0c5e3aa81$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


var $080178742f5edc08$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $080178742f5edc08$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $080178742f5edc08$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $080178742f5edc08$export$2e2bcd8739ae039 = $080178742f5edc08$var$formatDistance;



var $8177f56ec0f916e1$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $8177f56ec0f916e1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8177f56ec0f916e1$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8177f56ec0f916e1$var$formatLong = {
    date: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $8177f56ec0f916e1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $8177f56ec0f916e1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $f72d8a19fa29cb48$export$2e2bcd8739ae039)({
        formats: $8177f56ec0f916e1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8177f56ec0f916e1$export$2e2bcd8739ae039 = $8177f56ec0f916e1$var$formatLong;


var $6c8054e6beeecd21$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $6c8054e6beeecd21$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6c8054e6beeecd21$var$formatRelativeLocale[token];
};
var $6c8054e6beeecd21$export$2e2bcd8739ae039 = $6c8054e6beeecd21$var$formatRelative;



var $4b73af7f41e8300d$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $4b73af7f41e8300d$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $4b73af7f41e8300d$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $4b73af7f41e8300d$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $4b73af7f41e8300d$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $4b73af7f41e8300d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $4b73af7f41e8300d$var$localize = {
    ordinalNumber: $4b73af7f41e8300d$var$ordinalNumber,
    era: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $4b73af7f41e8300d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $4b73af7f41e8300d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $4b73af7f41e8300d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $4b73af7f41e8300d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $d6d2bf1a4bf1655c$export$2e2bcd8739ae039)({
        values: $4b73af7f41e8300d$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $4b73af7f41e8300d$export$2e2bcd8739ae039 = $4b73af7f41e8300d$var$localize;




var $585b61c26de9f5ce$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $585b61c26de9f5ce$var$parseOrdinalNumberPattern = /\d+/i;
var $585b61c26de9f5ce$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $585b61c26de9f5ce$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $585b61c26de9f5ce$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $585b61c26de9f5ce$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $585b61c26de9f5ce$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $585b61c26de9f5ce$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $585b61c26de9f5ce$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $585b61c26de9f5ce$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $585b61c26de9f5ce$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $585b61c26de9f5ce$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $585b61c26de9f5ce$var$match = {
    ordinalNumber: (0, $f043287ac78d7734$export$2e2bcd8739ae039)({
        matchPattern: $585b61c26de9f5ce$var$matchOrdinalNumberPattern,
        parsePattern: $585b61c26de9f5ce$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $585b61c26de9f5ce$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $585b61c26de9f5ce$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $585b61c26de9f5ce$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $585b61c26de9f5ce$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $585b61c26de9f5ce$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $585b61c26de9f5ce$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $585b61c26de9f5ce$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $585b61c26de9f5ce$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $a629bca763ef4d7c$export$2e2bcd8739ae039)({
        matchPatterns: $585b61c26de9f5ce$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $585b61c26de9f5ce$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $585b61c26de9f5ce$export$2e2bcd8739ae039 = $585b61c26de9f5ce$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $b6ba373da694181e$var$locale = {
    code: 'fr',
    formatDistance: (0, $080178742f5edc08$export$2e2bcd8739ae039),
    formatLong: (0, $8177f56ec0f916e1$export$2e2bcd8739ae039),
    formatRelative: (0, $6c8054e6beeecd21$export$2e2bcd8739ae039),
    localize: (0, $4b73af7f41e8300d$export$2e2bcd8739ae039),
    match: (0, $585b61c26de9f5ce$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b6ba373da694181e$export$2e2bcd8739ae039 = $b6ba373da694181e$var$locale;



var $2KSUA = parcelRequire("2KSUA");
/**
 * Global date defaults
 */ (0, $e10dd564cb9779fe$export$2e2bcd8739ae039)({
    locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
    weekStartsOn: 1
});
const $74f17ceb9b5a08a5$export$2fccde50bde2ee57 = 60000;
const $74f17ceb9b5a08a5$export$3d8caa708e1aba59 = $74f17ceb9b5a08a5$export$2fccde50bde2ee57 * 60;
const $74f17ceb9b5a08a5$export$9137ac55187b996d = $74f17ceb9b5a08a5$export$3d8caa708e1aba59 * 24;
// Formatter commun pour forcer l'affichage sur 2 chiffres sans utiliser padStart
const $74f17ceb9b5a08a5$var$twoDigits = new Intl.NumberFormat('fr-FR', {
    minimumIntegerDigits: 2,
    useGrouping: false
});
const $74f17ceb9b5a08a5$export$4bfe88362359942c = (date)=>{
    if (!date) return '';
    return new Date(date).toLocaleString('fr-FR', {
        hour: 'numeric',
        minute: 'numeric'
    });
};
const $74f17ceb9b5a08a5$export$52abf2da991b9a1c = (date, time)=>{
    // The HTML time input field is blank
    if (time === '') return null;
    // Matching HH:MM in 24h time format with leading zero : https://stackoverflow.com/a/51177696
    const match = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.exec(time);
    // We return undefined if the provided time was not parseable
    if (!match) return;
    // We get the hours and minutes from the string and parse them as numbers
    const [hours, minutes] = time.split(':').map((number)=>Number(number));
    return (0, $df15ea422e6c097c$export$2e2bcd8739ae039)((0, $c468ed5e889a430e$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(date)), hours || 0), minutes || 0);
};
const $74f17ceb9b5a08a5$export$ecfc70c568cd6116 = (hours)=>{
    const hoursAsDate = new Date(hours * $74f17ceb9b5a08a5$export$3d8caa708e1aba59);
    return `${new Date(hoursAsDate).getUTCHours().toString().padStart(2, '0')}:${hoursAsDate.getUTCMinutes().toString().padStart(2, '0')}`;
};
const $74f17ceb9b5a08a5$export$3c074bd11f21ecb1 = (hours)=>{
    if (isNaN(hours) || hours < 0) return '00:00';
    const totalMinutes = Math.floor(hours * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
};
const $74f17ceb9b5a08a5$export$e7f31853fa46457 = (inputValue)=>{
    const match = /^(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])$/.exec(inputValue);
    if (!match) return;
    return (0, $2KSUA.round)(Number(match[1]) + Number(match[2]) / 60, 2);
};
const $74f17ceb9b5a08a5$export$217584d147ca6846 = (value)=>{
    const date = value ? new Date(value) : new Date();
    return {
        start: $74f17ceb9b5a08a5$export$42c81a444fbfb5d4(date),
        end: $74f17ceb9b5a08a5$export$ef8b6d9133084f4e(date)
    };
};
const $74f17ceb9b5a08a5$export$6e754b2c8f0d5534 = (duration)=>`${(0, $11bfe019cf2a8df5$export$2e2bcd8739ae039)(duration) - 1}:${(0, $80bdff59a66cc285$export$2e2bcd8739ae039)(duration)}`;
const $74f17ceb9b5a08a5$export$98ebe697bd430e5 = (inputValue)=>{
    const match = /([0-9][0-9]):([0-9][0-9])/.exec(inputValue);
    if (!match) throw 'Invalid time input value';
    return Number(match[1]) * 3600000 + Number(match[2]) * 60000;
};
const $74f17ceb9b5a08a5$export$97b9b3427470347a = (date)=>{
    return $74f17ceb9b5a08a5$export$fb9f91b434a357bf($74f17ceb9b5a08a5$var$buildDate(date));
};
const $74f17ceb9b5a08a5$export$7331dca2d8430ff9 = (date)=>{
    // Split the ISO date string to avoid timezone shifts (e.g. GMT-1 creating previous day)
    const parts = date.split('-');
    if (parts.length < 3) return (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(date);
    const [yearPart, monthPart, dayPart] = parts;
    const year = Number(yearPart);
    const month = Number(monthPart);
    const day = Number(dayPart);
    if ([
        year,
        month,
        day
    ].some((value)=>Number.isNaN(value))) // Fallback to parseISO to keep previous behavior while signalling bad input
    return (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(date);
    // Always build the Date at midnight UTC to match the form date exactly
    return new Date(Date.UTC(year, month - 1, day));
};
const $74f17ceb9b5a08a5$var$buildDate = (date)=>{
    if (!date) return new Date();
    else if (date instanceof Date) return date;
    return new Date(date);
};
const $74f17ceb9b5a08a5$export$efe19b760242b2fc = (date)=>(0, $3cbe7fa53b58a992$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    });
const $74f17ceb9b5a08a5$export$12d572480ceb6e58 = (date)=>(0, $ac69c6a7c3af73c1$export$2e2bcd8739ae039)(date, {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    });
const $74f17ceb9b5a08a5$export$d31a8caec75fa456 = (start, end)=>(0, $9b8ab39a46fc8509$export$2e2bcd8739ae039)({
        start: start,
        end: end
    }, {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
        weekStartsOn: 1
    });
const $74f17ceb9b5a08a5$export$4b3066ce4afafd88 = (date, week)=>(0, $324e53a432e321d3$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), week, {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    });
const $74f17ceb9b5a08a5$export$42c81a444fbfb5d4 = (date)=>(0, $63a6eac007c76fc6$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), {
        weekStartsOn: 1
    });
const $74f17ceb9b5a08a5$export$ef8b6d9133084f4e = (date)=>(0, $d9677f7cca086b20$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), {
        weekStartsOn: 1
    });
const $74f17ceb9b5a08a5$export$a155f41bf7aedf47 = (weekdaySundayBased)=>// If weekDay is 0, we are sunday !
    weekdaySundayBased === 0 ? 6 : weekdaySundayBased - 1;
const $74f17ceb9b5a08a5$export$9f679dbcb5959c9b = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), "EEEE dd MMMM yyyy H'h'mm", {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
const $74f17ceb9b5a08a5$export$d9576bc52e3509f3 = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'dd/MM/yy H:mm:ss', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
const $74f17ceb9b5a08a5$export$5c1c558c67b268ff = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'EEEE dd MMMM yyyy', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
const $74f17ceb9b5a08a5$export$3203edd9e5edd663 = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), "HH'h'mm", {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
const $74f17ceb9b5a08a5$export$d30d8547ed0ef255 = (date)=>new Date($74f17ceb9b5a08a5$var$buildDate(date)).toLocaleDateString();
const $74f17ceb9b5a08a5$export$3ae94a2503e890a1 = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'dd/MM/yyyy') : '';
const $74f17ceb9b5a08a5$export$28ab905ff7c66dbe = (date)=>date ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'dd/MM/yyyy HH:mm', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
const $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a = (timestamp)=>{
    // Convertir les millisecondes en minutes entières en traitant correctement les valeurs négatives
    // On applique le signe à la fin pour éviter l'arrondi vers -∞ sur les valeurs négatives
    const sign = timestamp < 0 ? '-' : '';
    const totalMinutesAbs = Math.floor(Math.abs(timestamp) / 60000);
    const hours = Math.floor(totalMinutesAbs / 60);
    const minutes = totalMinutesAbs % 60;
    const hoursStr = $74f17ceb9b5a08a5$var$twoDigits.format(hours);
    const minutesStr = $74f17ceb9b5a08a5$var$twoDigits.format(minutes);
    return `${sign}${hoursStr}h${minutesStr}`;
};
const $74f17ceb9b5a08a5$export$a7f242eff11c1345 = (date)=>date ? (0, $2KSUA.upperFirst)((0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'E d', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    })) : '';
const $74f17ceb9b5a08a5$export$1b92b828e6214ca1 = (date)=>date ? (0, $2KSUA.upperFirst)((0, $b3177a4462e15523$export$2e2bcd8739ae039)($74f17ceb9b5a08a5$var$buildDate(date), 'EEEE', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    })) : '';
const $74f17ceb9b5a08a5$export$df05c8d7c056b9c6 = (start, end)=>{
    return (0, $a1d8421bf1d3b65c$export$2e2bcd8739ae039)({
        start: $74f17ceb9b5a08a5$var$buildDate(start),
        end: $74f17ceb9b5a08a5$var$buildDate(end)
    });
};
const $74f17ceb9b5a08a5$export$429c68d3da02e8c1 = $74f17ceb9b5a08a5$export$df05c8d7c056b9c6($74f17ceb9b5a08a5$export$42c81a444fbfb5d4(new Date()), $74f17ceb9b5a08a5$export$ef8b6d9133084f4e(new Date()));
const $74f17ceb9b5a08a5$export$5d73a3fd931619b8 = (days)=>[
        {
            value: '',
            label: 'Toute la semaine',
            defaultSelected: true
        },
        ...days.map((day)=>({
                value: day.toString(),
                label: $74f17ceb9b5a08a5$export$a7f242eff11c1345(day)
            }))
    ];
const $74f17ceb9b5a08a5$export$dcb6c460bf415cf3 = (date)=>new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
const $74f17ceb9b5a08a5$export$7d98027883de41f3 = (isoString)=>{
    const datePart = isoString.split('T')[0];
    return datePart ? (0, $b3177a4462e15523$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(datePart), 'dd/MM/yyyy', {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
    }) : '';
};
const $74f17ceb9b5a08a5$export$fb9f91b434a357bf = (date)=>{
    return (0, $77f154409ac96cff$export$2e2bcd8739ae039)(date, {
        representation: 'date'
    });
};
const $74f17ceb9b5a08a5$export$98482d4a281b28ea = (start, end, contextual = true)=>{
    const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(start);
    const endDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(end);
    try {
        const dateRangeIsDay = (0, $a1d8421bf1d3b65c$export$2e2bcd8739ae039)({
            start: startDate,
            end: endDate
        }).length === 1;
        if (contextual) {
            const dataRangeTitle = dateRangeIsDay ? (0, $ec8d0215c60e3f6d$export$2e2bcd8739ae039)(startDate) ? "Aujourd'hui" : (0, $0ccc909ab832fceb$export$2e2bcd8739ae039)(startDate) ? 'Hier' : (0, $498b19e6888511e3$export$2e2bcd8739ae039)(startDate) ? 'Demain' : $74f17ceb9b5a08a5$export$5c1c558c67b268ff(startDate) : (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)(startDate) && (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)(endDate) ? 'Cette Semaine' : (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)((0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(startDate, 1)) && (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)((0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(endDate, 1)) ? 'Semaine Prochaine' : (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)((0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(startDate, 1)) && (0, $cdb7bbd11c0ab34d$export$2e2bcd8739ae039)((0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(endDate, 1)) ? "Semaine Pass\xe9e" : `Du ${$74f17ceb9b5a08a5$export$5c1c558c67b268ff(startDate)} au ${$74f17ceb9b5a08a5$export$5c1c558c67b268ff(endDate)}`;
            return dataRangeTitle;
        } else {
            const dateIs = dateRangeIsDay ? $74f17ceb9b5a08a5$export$5c1c558c67b268ff(start) : `Du ${$74f17ceb9b5a08a5$export$5c1c558c67b268ff(startDate)} au ${$74f17ceb9b5a08a5$export$5c1c558c67b268ff(endDate)}`;
            return dateIs;
        }
    } catch  {
        // Bad date range interval
        return 'Intervalle de dates invalide';
    }
};
const $74f17ceb9b5a08a5$export$f3e3e7d660379b73 = (timestamp)=>{
    // Gestion correcte des durées négatives en séparant le signe de la valeur absolue
    const sign = timestamp < 0 ? -1 : 1;
    const totalMinutesAbs = Math.floor(Math.abs(timestamp) / 60000);
    const hours = Math.floor(totalMinutesAbs / 60);
    const minutes = totalMinutesAbs % 60;
    const value = sign * (hours + minutes / 60);
    return Number(value.toFixed(2)).toString();
};
const $74f17ceb9b5a08a5$export$8f2f015a4a2c7583 = (inputDate, startDate, endDate)=>{
    const inputTime = inputDate.getHours() * 60 + inputDate.getMinutes();
    const startTime = startDate.getHours() * 60 + startDate.getMinutes();
    const endTime = endDate.getHours() * 60 + endDate.getMinutes();
    // Si la plage s'étend sur plusieurs jours (ex: 18h à 5h le lendemain)
    if (startTime > endTime) // L'heure doit être >= startTime OU <= endTime
    return inputTime >= startTime || inputTime <= endTime;
    else // Plage normale dans la même journée
    return inputTime >= startTime && inputTime <= endTime;
};
const $74f17ceb9b5a08a5$export$5eefd315c24a8505 = (date, startDate, endDate)=>{
    date = $74f17ceb9b5a08a5$var$buildDate(date);
    startDate = $74f17ceb9b5a08a5$var$buildDate(startDate);
    endDate = $74f17ceb9b5a08a5$var$buildDate(endDate);
    return (0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(date, startDate) || (0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(date, endDate) || (0, $379899354a78c3bb$export$2e2bcd8739ae039)(date, startDate) && (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(date, endDate);
};
const $74f17ceb9b5a08a5$export$5f5c3edd8240baca = (minutes)=>{
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    if (hours === 0) return `${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
    if (remainingMinutes === 0) return `${hours} heure${hours > 1 ? 's' : ''}`;
    return `${hours} heure${hours > 1 ? 's' : ''} ${remainingMinutes} minute${remainingMinutes > 1 ? 's' : ''}`;
};
const $74f17ceb9b5a08a5$export$6ea683876c36b8d2 = (date1, date2)=>{
    return (0, $5676184ed61a60f3$export$2e2bcd8739ae039)(date1, date2, {
        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
        weekStartsOn: 1
    });
};




function $9d8683737c4c4df2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $2KSUA = parcelRequire("2KSUA");
var $7093b8da8664ce76$export$d514d78c9201a2e7 = /*#__PURE__*/ function(FiltersResourcesEnum) {
    FiltersResourcesEnum["missions"] = "missions";
    FiltersResourcesEnum["workersRequests"] = "workersRequests";
    FiltersResourcesEnum["workPeriods"] = "workPeriods";
    FiltersResourcesEnum["clockings"] = "clockings";
    FiltersResourcesEnum["preBillings"] = "preBillings";
    FiltersResourcesEnum["kPI"] = "kPI";
    FiltersResourcesEnum["laborCostsCoefficients"] = "laborCostsCoefficients";
    FiltersResourcesEnum["payroll"] = "payroll";
    return FiltersResourcesEnum;
}({});
const $7093b8da8664ce76$var$now = new Date();
const $7093b8da8664ce76$var$initialStartEndisThisWeek = {
    start: (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)($7093b8da8664ce76$var$now),
    end: (0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)($7093b8da8664ce76$var$now)
};
const $7093b8da8664ce76$var$initialStartEndisToday = {
    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)($7093b8da8664ce76$var$now),
    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)($7093b8da8664ce76$var$now)
};
const $7093b8da8664ce76$export$6ca32c220786ee65 = {
    ["missions"]: {
        ...$7093b8da8664ce76$var$initialStartEndisThisWeek,
        periodSummary: [],
        isCancelled: [],
        start: (0, $74f17ceb9b5a08a5$export$217584d147ca6846)((0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date())).start,
        end: (0, $74f17ceb9b5a08a5$export$217584d147ca6846)((0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date())).end,
        employer: [],
        interimAgency: [],
        jobTitle: [],
        user: [],
        events: [],
        tags: [],
        service: [],
        'workPeriods.periodSummary': [],
        contractModel: [],
        summaryMinimalMode: true
    },
    ["workPeriods"]: {
        ...$7093b8da8664ce76$var$initialStartEndisToday,
        events: [],
        tags: []
    },
    ["kPI"]: {
        ...$7093b8da8664ce76$var$initialStartEndisToday
    },
    ["workersRequests"]: {
        isExpired: (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)($7093b8da8664ce76$var$now), 3),
        isComplete: [
            false
        ],
        isCancelled: [
            false
        ]
    },
    ["clockings"]: {
        ...$7093b8da8664ce76$var$initialStartEndisThisWeek
    },
    ["preBillings"]: {
        invoiceRef: [
            false
        ]
    },
    ["laborCostsCoefficients"]: {
        interimAgency: undefined,
        jobTitle: undefined
    },
    ["payroll"]: {
        end: (0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)($7093b8da8664ce76$var$now),
        start: (0, $9d8683737c4c4df2$export$2e2bcd8739ae039)((0, $f85dee25334cb4c9$export$2e2bcd8739ae039)($7093b8da8664ce76$var$now, 24)),
        service: undefined,
        jobTitle: undefined,
        user: [],
        weekStatuses: [],
        currentWorkerId: undefined
    }
};
const $7093b8da8664ce76$var$filtersSlice = (set)=>({
        ...(0, $2KSUA.cloneDeep)($7093b8da8664ce76$export$6ca32c220786ee65),
        pagination: {
            summary: {
                currentPage: 1,
                itemsPerPage: 20
            }
        },
        setFilters: (resource, filters)=>{
            set((0, $f70Wr.produce)((state)=>{
                state.filters[resource] = filters;
            }));
        },
        setPagination: (item, value)=>{
            set((0, $f70Wr.produce)((state)=>{
                state.filters.pagination[item] = value;
            }));
        }
    });
var $7093b8da8664ce76$export$2e2bcd8739ae039 = $7093b8da8664ce76$var$filtersSlice;



var $f70Wr = parcelRequire("f70Wr");
const $7e1497cc147edde1$var$sessionSlice = (set, get)=>({
        isNetworkOnError: false,
        isAuthenticated: false,
        isInitialized: false,
        isSuperAdmin: false,
        currentUser: undefined,
        currentUserRole: 'guest',
        currentOrganization: undefined,
        jwt: undefined,
        initializeSession: (user, jwt, role, organization, organizationRole)=>{
            set((0, $f70Wr.default)((state)=>{
                state.session.isInitialized = true;
                state.session.isAuthenticated = Boolean(user && jwt);
                state.session.isSuperAdmin = Boolean(user && user.roles.some((role)=>role.kind === 'superAdmin'));
                state.session.currentUser = user;
                state.session.currentUserRole = role || 'guest';
                state.session.jwt = jwt;
                state.session.currentOrganization = organization;
                state.session.currentOrganizationRole = organizationRole;
                if (!user) delete state.session.loggedAs;
            }));
        },
        logout: ()=>{
            get().session.initializeSession();
        },
        changeCurrentRole: (role)=>{
            set((0, $f70Wr.default)((state)=>{
                const { kind: kind } = role;
                state.session.currentUserRole = role.kind;
                if (kind === 'superAdmin' || kind === 'worker') {
                    state.session.currentOrganization = undefined;
                    state.session.currentOrganizationRole = undefined;
                } else {
                    state.session.currentOrganization = role.organization;
                    state.session.currentOrganizationRole = 'admin';
                }
                delete state.session.loggedAs;
            }));
        },
        loginAs: (role, organization, organizationRole)=>{
            const { session: session } = get();
            if (session.isSuperAdmin) {
                get().session.initializeSession(session.currentUser, session.jwt, role, organization, organizationRole);
                set((0, $f70Wr.default)((state)=>{
                    const { session: session } = get();
                    state.session.loggedAs = {
                        role: session.currentUserRole,
                        organization: session.currentOrganization
                    };
                }));
            }
        }
    });
var $7e1497cc147edde1$export$2e2bcd8739ae039 = $7e1497cc147edde1$var$sessionSlice;



var $2KSUA = parcelRequire("2KSUA");

var $f70Wr = parcelRequire("f70Wr");
const $6f4f45aec862cd22$var$appSlice = (set)=>({
        appNeedsUpdate: false,
        setAppNeedsUpdate: (needsUpdate)=>{
            set((0, $f70Wr.default)((state)=>{
                state.app.appNeedsUpdate = needsUpdate;
            }));
        }
    });
var $6f4f45aec862cd22$export$2e2bcd8739ae039 = $6f4f45aec862cd22$var$appSlice;


const $d6640a748633e476$var$store = (set, get)=>({
        filters: {
            ...(0, $7093b8da8664ce76$export$2e2bcd8739ae039)(set, get)
        },
        session: {
            ...(0, $7e1497cc147edde1$export$2e2bcd8739ae039)(set, get)
        },
        app: {
            ...(0, $6f4f45aec862cd22$export$2e2bcd8739ae039)(set, get)
        }
    });
const $d6640a748633e476$var$useStore = (0, $f2bd57a5a837b3af$exports.create)()((0, $29dcdb827ef0bfdf$export$9a6132153fba2e0)($d6640a748633e476$var$store, {
    name: 'session-state',
    partialize: (state)=>({
            session: state.session /*, filters: state.filters */ 
        }),
    merge: (persistedState, currentState)=>(0, $2KSUA.merge)(currentState, persistedState)
}));
var $d6640a748633e476$export$2e2bcd8739ae039 = $d6640a748633e476$var$useStore;


var $af74bddf98502919$exports = {};

$af74bddf98502919$exports = (parcelRequire("ap4Qn"));



const $64d0fc040ea287e7$var$baseURLHostname = '';
const $64d0fc040ea287e7$var$currentClientAppVersion = "277e83e744ab7890a8aa594a13c5b5487b3f9631";
const $64d0fc040ea287e7$var$axiosApi = (0, (/*@__PURE__*/$parcel$interopDefault($af74bddf98502919$exports))).create({
    // If NODE_ENV is not set or set to something else than 'development'
    // We then consider to be in production
    baseURL: $64d0fc040ea287e7$var$baseURLHostname ? new URL('/api/', $64d0fc040ea287e7$var$baseURLHostname).href : '/api'
});
$64d0fc040ea287e7$var$axiosApi.interceptors.response.use((res)=>res, (err)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($af74bddf98502919$exports))).isAxiosError(err)) {
        const error = err.toJSON();
        // If the server tells the client that its app version is unsupported
        // Server sends a 406 Not Acceptable
        // @ts-expect-error
        if (error.status === 406) (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().app.setAppNeedsUpdate(true);
    }
    return Promise.reject(err);
});
$64d0fc040ea287e7$var$axiosApi.interceptors.request.use((req)=>{
    if ((0, $d6640a748633e476$export$2e2bcd8739ae039).getState().app.appNeedsUpdate) // If app needs update, we cancel subsequent requests until the browser is (force) refreshed
    throw new (0, (/*@__PURE__*/$parcel$interopDefault($af74bddf98502919$exports))).Cancel('Version Not Supported');
    return req;
});
const $64d0fc040ea287e7$var$api = async ({ endpoint: endpoint, params: params, method: method, headers: headers })=>{
    if (!headers) headers = {};
    const { session: session } = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState();
    headers.role = session.currentUserRole;
    if (session.jwt) headers.authorization = session.jwt;
    if (session.currentOrganization?._id) headers.organization = session.currentOrganization._id.toString();
    // We set the current app version as header for all outgoing requests
    if ($64d0fc040ea287e7$var$currentClientAppVersion) headers['x-app-version'] = $64d0fc040ea287e7$var$currentClientAppVersion;
    const config = {
        method: method || 'get',
        url: endpoint,
        headers: {
            'Content-Type': 'application/json',
            ...headers
        }
    };
    if (params && method.toLocaleLowerCase() === 'get') config.params = params;
    else config.data = params;
    return await $64d0fc040ea287e7$var$axiosApi.request(config);
};
var $64d0fc040ea287e7$export$2e2bcd8739ae039 = $64d0fc040ea287e7$var$api;


const $902c882fc5795008$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/users',
        method: 'get',
        params: {
            sort: '-isCompleted lastName email',
            populate: [
                'roles.invitedBy'
            ],
            ...params
        }
    });
};
const $902c882fc5795008$export$85b9a36db797e02b = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/users/count',
        method: 'get',
        params: {
            sort: '-isCompleted lastName email',
            populate: [
                'roles.invitedBy'
            ],
            ...params
        }
    });
};
const $902c882fc5795008$export$3988ae62b71be9a3 = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${id}`,
        method: 'GET',
        params: {
            populate: [
                'roles.invitedBy',
                'associations.invitedBy',
                'associations.organization',
                'roles.organization'
            ]
        }
    });
};
const $902c882fc5795008$export$fe71a0c68bff6cfa = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/available`,
        method: 'get',
        params: params
    });
const $902c882fc5795008$export$b9517b7a6eca42 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/workers`,
        method: 'get',
        params: params
    });
const $902c882fc5795008$export$185802fd694ee1f5 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/users',
        method: 'post',
        params: params
    });
};
const $902c882fc5795008$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${id}`,
        method: 'put',
        params: payload
    });
};
const $902c882fc5795008$export$426c7c3041cfaae9 = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/workers/${id}`,
        method: 'put',
        params: payload
    });
};
const $902c882fc5795008$export$ca2ef174d9530ba8 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/${params.workerId}/employer-collaboration`,
        method: 'put',
        params: {
            isInactive: params.isInactive
        }
    });
};
const $902c882fc5795008$export$c37c5570c259cd71 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/me/roles/${params.roleId}`,
        method: 'put',
        params: params
    });
};
const $902c882fc5795008$export$9feaf61c98cee22d = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/me/associations/${params.associationId}`,
        method: 'put',
        params: params
    });
};
const $902c882fc5795008$export$4f83220ced1f1926 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${params.userId}/roles/organizations/discontinue`,
        method: 'put'
    });
};
const $902c882fc5795008$export$5e8ecda456681b1 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${params.userId}/roles/organizations`,
        method: 'put',
        params: params
    });
};
const $902c882fc5795008$export$26bad0a8ada7e224 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/${params.workerId}/associations/discontinue`,
        method: 'put'
    });
};
const $902c882fc5795008$export$6a56b013f2ed4a9d = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/${params.workerId}/associations/delete`,
        method: 'put'
    });
};
const $902c882fc5795008$export$b7b8758eb4069f1a = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${params.id}`,
        method: 'put',
        params: params
    });
};
const $902c882fc5795008$export$660d2107d760e392 = async (token)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/me/validate-new-email`,
        method: 'put',
        params: {
            token: token
        }
    });
};
const $902c882fc5795008$export$794c747ace225d95 = async (email)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/me/email`,
        method: 'put',
        params: {
            email: email
        }
    });
};
const $902c882fc5795008$export$4aeec04cfa7346cf = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/me/roles/${params.roleId}/notifications-settings`,
        params: params,
        method: 'put'
    });
const $902c882fc5795008$export$687929ae7add1389 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/users/request-new-password',
        method: 'post',
        params: params
    });
};
const $902c882fc5795008$export$dc726c8e334dd814 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/users/reset-password',
        method: 'post',
        params: params
    });
};
const $902c882fc5795008$export$45abfc3976589d02 = async (userId)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${userId}`,
        method: 'delete'
    });
};
const $902c882fc5795008$export$1a740b692a3204f0 = async (userId)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${userId}/qr`,
        method: 'get'
    });
};
const $902c882fc5795008$export$7a1171bdc1cc6c19 = async (workerId)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/${workerId}/qr`,
        method: 'get'
    });
};
const $902c882fc5795008$export$1df3c82ba2084fe8 = async (workerId)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers/${workerId}`,
        method: 'get'
    });
};
const $902c882fc5795008$export$b090d35aade55a29 = async (userId)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/users/${userId}/qr`,
        method: 'put'
    });
const $902c882fc5795008$export$73693bad9f5880b0 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/auth',
        method: 'post',
        params: params
    });
const $902c882fc5795008$export$68ae33dafb430cf8 = async ()=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/is-auth',
        method: 'get'
    });



const $e607e015ac40917d$export$7427a5686c370135 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('users', (0, $902c882fc5795008$export$e7aa7bc5c1b3cfb3), filters || {}, options);
const $e607e015ac40917d$export$e37258df366467dd = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('users/count', (0, $902c882fc5795008$export$85b9a36db797e02b), filters || {}, options);
const $e607e015ac40917d$export$68dae0b0cacaa18a = (id)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('users', (0, $902c882fc5795008$export$3988ae62b71be9a3), id);
const $e607e015ac40917d$export$f6b80d8903d7979c = (userId, options)=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)([
        'user',
        userId,
        'qr'
    ], async ()=>(0, $902c882fc5795008$export$1a740b692a3204f0)(userId), {
        enabled: Boolean(userId),
        ...options
    });
const $e607e015ac40917d$export$2be68f8f4faaddde = (workerId, options)=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)([
        'worker',
        workerId,
        'qr'
    ], async ()=>(0, $902c882fc5795008$export$7a1171bdc1cc6c19)(workerId), {
        enabled: Boolean(workerId),
        ...options
    });
const $e607e015ac40917d$export$1884facae6ee36d8 = (workerId, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('workers', (0, $902c882fc5795008$export$1df3c82ba2084fe8), workerId, undefined, options);
const $e607e015ac40917d$export$c8b4a8759ad58195 = (params, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('workers', (0, $902c882fc5795008$export$fe71a0c68bff6cfa), params, options);
const $e607e015ac40917d$export$ad43217ee1485bda = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('workers', (0, $902c882fc5795008$export$b9517b7a6eca42), filters || {}, options);
const $e607e015ac40917d$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'users'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'workers'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries($e607e015ac40917d$export$94e9afb1b933cd1a());
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'app-config'
    ]);
};
const $e607e015ac40917d$export$4a6f974b4208311 = ()=>[
        'users',
        'create'
    ];
const $e607e015ac40917d$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$185802fd694ee1f5), {
        mutationKey: $e607e015ac40917d$export$4a6f974b4208311(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdateMutationKey = ()=>[
        'users',
        'update'
    ];
const $e607e015ac40917d$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$722fbec263ad908a), {
        mutationKey: $e607e015ac40917d$var$useUpdateMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdatWorkerMutationKey = ()=>[
        'users',
        'workers',
        'update'
    ];
const $e607e015ac40917d$export$504dd55109c39a47 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$426c7c3041cfaae9), {
        mutationKey: $e607e015ac40917d$var$useUpdatWorkerMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdateEmailMutationKey = ()=>[
        'users',
        'update',
        'email'
    ];
const $e607e015ac40917d$export$5cd4fe36d9d62971 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$794c747ace225d95), {
        mutationKey: $e607e015ac40917d$var$useUpdateEmailMutationKey()
    });
const $e607e015ac40917d$var$useUpdateNotificationSettingsKey = ()=>[
        'users',
        'update',
        'notificaiton-settings'
    ];
const $e607e015ac40917d$export$a9f1384167413475 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$4aeec04cfa7346cf), {
        mutationKey: $e607e015ac40917d$var$useUpdateNotificationSettingsKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useCompleteProfileKey = ()=>[
        'users',
        'complete-profile'
    ];
const $e607e015ac40917d$export$cfcf74bf9df36337 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$b7b8758eb4069f1a), {
        mutationKey: $e607e015ac40917d$var$useCompleteProfileKey()
    });
const $e607e015ac40917d$export$1c1c8631916ac0e4 = ()=>[
        'users',
        'request-password'
    ];
const $e607e015ac40917d$export$ed9d7b7ba2731b5a = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$687929ae7add1389), {
        mutationKey: $e607e015ac40917d$export$1c1c8631916ac0e4()
    });
const $e607e015ac40917d$export$f805b1fed8a2f078 = ()=>[
        'users',
        'reset-password'
    ];
const $e607e015ac40917d$export$3177acf383c684f6 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$dc726c8e334dd814), {
        mutationKey: $e607e015ac40917d$export$f805b1fed8a2f078()
    });
const $e607e015ac40917d$var$useDeleteAccountMutationkey = ()=>[
        'users',
        'delete'
    ];
const $e607e015ac40917d$export$94986b58b70e2d42 = ()=>{
    return (0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$45abfc3976589d02), {
        mutationKey: $e607e015ac40917d$var$useDeleteAccountMutationkey()
    });
};
const $e607e015ac40917d$var$useValidateNewEmailMutationKey = ()=>[
        'users',
        'validate-new-email'
    ];
const $e607e015ac40917d$export$8008a84964b77b35 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$660d2107d760e392), {
        mutationKey: $e607e015ac40917d$var$useValidateNewEmailMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdateUserRoleMutationKey = ()=>[
        'users',
        'roles',
        'update'
    ];
const $e607e015ac40917d$export$757b8024a8e3c75e = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$c37c5570c259cd71), {
        mutationKey: $e607e015ac40917d$var$useUpdateUserRoleMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdateUserAssociationMutationKey = ()=>[
        'users',
        'associations',
        'update'
    ];
const $e607e015ac40917d$export$f85487c66297925e = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$9feaf61c98cee22d), {
        mutationKey: $e607e015ac40917d$var$useUpdateUserAssociationMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useDiscontinueUserOrganizationRoleMutationKey = ()=>[
        'users',
        'roles',
        'discontinue'
    ];
const $e607e015ac40917d$export$4583ff801616e47d = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$4f83220ced1f1926), {
        mutationKey: $e607e015ac40917d$var$useDiscontinueUserOrganizationRoleMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useUpdateUserOrganizationRoleMutationKey = ()=>[
        'users',
        'roles',
        'update'
    ];
const $e607e015ac40917d$export$f917a4c1de87afb7 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$5e8ecda456681b1), {
        mutationKey: $e607e015ac40917d$var$useUpdateUserOrganizationRoleMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useDiscontinueWorkerAssociationMutationKey = ()=>[
        'users',
        'associations',
        'discontinue'
    ];
const $e607e015ac40917d$export$c190e6a5197102e6 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$26bad0a8ada7e224), {
        mutationKey: $e607e015ac40917d$var$useDiscontinueWorkerAssociationMutationKey(),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useDeleteWorkerAssociationMutationKey = (workerId)=>[
        'worker',
        'association',
        'delete',
        workerId
    ];
const $e607e015ac40917d$export$2637f30f510c81e4 = (workerId)=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$6a56b013f2ed4a9d), {
        mutationKey: $e607e015ac40917d$var$useDeleteWorkerAssociationMutationKey(workerId),
        onSuccess: $e607e015ac40917d$var$onMutationSuccess
    });
const $e607e015ac40917d$var$useRegenerateUserQrCodeMutationKey = ()=>[
        'users',
        'qr-regenerate'
    ];
const $e607e015ac40917d$export$6b880607631b4612 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$b090d35aade55a29), {
        mutationKey: $e607e015ac40917d$var$useRegenerateUserQrCodeMutationKey(),
        onSuccess: (data, userId)=>{
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                'user',
                userId,
                'qr'
            ]);
        }
    });
const $e607e015ac40917d$var$useUpdateWorkerEmployerCollaborationMutationKey = ()=>[
        'users',
        'workers',
        'employer-collaboration',
        'update'
    ];
const $e607e015ac40917d$export$99d9b782d7ff82db = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$ca2ef174d9530ba8), {
        mutationKey: $e607e015ac40917d$var$useUpdateWorkerEmployerCollaborationMutationKey(),
        onSuccess: ()=>{
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                'missions'
            ]);
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                'workers'
            ]);
            $e607e015ac40917d$var$onMutationSuccess();
        }
    });
const $e607e015ac40917d$export$94e9afb1b933cd1a = ()=>[
        'users',
        'is-auth'
    ];
const $e607e015ac40917d$export$9e7b71bcd5abe16a = ()=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)($e607e015ac40917d$export$94e9afb1b933cd1a(), (0, $902c882fc5795008$export$68ae33dafb430cf8), {
        staleTime: 600000,
        onError: $e607e015ac40917d$var$onAuthFail,
        onSuccess: (data)=>{
            // Update session data in store
            const { session: session } = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState();
            // Get the last version of currently stored user role in API response
            // to update "currentRole" & "currentOrganization" in store
            const currentRole = session.currentUserRole && data.user.roles.find((role)=>role.kind === session.currentUserRole && role.organization?._id === session.currentOrganization?._id);
            // Get new version of "currentOrganization"
            let currentOrganization = currentRole?.organization;
            // When current user is Super Admin and "logged as" an organization we keep the stored "currentOrganization"
            // because the current store organization is not necessarily in the API response
            if (session.isSuperAdmin && session.loggedAs?.organization) currentOrganization = session.loggedAs?.organization;
            // Store session data
            (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.initializeSession(data.user, data.jwt, session.currentUserRole, currentOrganization, currentRole?.organizationRole || 'admin');
        }
    });
const $e607e015ac40917d$var$onAuthFail = (data)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($af74bddf98502919$exports))).isAxiosError(data)) {
        const error = data.toJSON();
        //@ts-expect-error
        if (error.status === 403 || error.status === 401) // Initialize session as guest when auth fail expect the failure is a network error or outdated app version error
        (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.initializeSession();
    }
};
const $e607e015ac40917d$var$useAuthMutationKey = ()=>[
        'users',
        'auth'
    ];
const $e607e015ac40917d$export$7d483d5f301dc18f = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $902c882fc5795008$export$73693bad9f5880b0), {
        mutationKey: $e607e015ac40917d$var$useAuthMutationKey(),
        onError: $e607e015ac40917d$var$onAuthFail,
        onSuccess: ({ data: data })=>{
            // Store session data on login success
            const activeRoles = data.user?.roles.filter((role)=>role.status === 'accepted');
            // If user is Super Admin, we prioritize this role as current role
            // Because Super Admin role is not always the first role in organizations array
            const superAdminRole = activeRoles.find((role)=>role.kind === 'superAdmin');
            const firstActiveRole = activeRoles[0];
            const currentRole = superAdminRole ?? firstActiveRole;
            (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.initializeSession(data.user, data.jwt, currentRole?.kind, currentRole?.organization, currentRole?.organizationRole);
        }
    });



parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
var $f0a9601245d0def2$exports = {};
"use strict";
function $f0a9601245d0def2$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f0a9601245d0def2$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f0a9601245d0def2$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f0a9601245d0def2$var$_typeof(obj);
}
Object.defineProperty($f0a9601245d0def2$exports, "__esModule", {
    value: true
});
Object.defineProperty($f0a9601245d0def2$exports, "Box", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_box["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Block", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_block["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Button", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_button["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Breadcrumb", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_breadcrumb["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Card", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_card["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Columns", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_columns["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Container", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_container["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Content", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_content["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Footer", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_footer["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Heading", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_heading["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Hero", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_hero["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Image", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_image["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Level", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_level["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Media", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_media["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Notification", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_notification["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Progress", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_progress["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Section", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_section["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Tabs", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_tabs["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Table", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_table["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Tag", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_tag["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Tile", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_tile["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Modal", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_modal["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Dropdown", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_dropdown["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Icon", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_icon["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Loader", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_loader["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Navbar", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_navbar["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Pagination", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_pagination["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Menu", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_menu["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Message", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_message["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Panel", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_panel["default"];
    }
});
Object.defineProperty($f0a9601245d0def2$exports, "Element", {
    enumerable: true,
    get: function get() {
        return $f0a9601245d0def2$var$_element["default"];
    }
});
$f0a9601245d0def2$exports.Form = void 0;

var $f0a9601245d0def2$var$Form = $f0a9601245d0def2$var$_interopRequireWildcard((parcelRequire("i1cQJ")));
$f0a9601245d0def2$exports.Form = $f0a9601245d0def2$var$Form;

var $f0a9601245d0def2$var$_box = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("gSp2K")));

var $f0a9601245d0def2$var$_block = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("6xV2r")));

var $f0a9601245d0def2$var$_button = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("7aX84")));

var $f0a9601245d0def2$var$_breadcrumb = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("cS4fv")));

var $f0a9601245d0def2$var$_card = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("8qLA6")));

var $f0a9601245d0def2$var$_columns = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("eoemi")));

var $f0a9601245d0def2$var$_container = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("ccw4O")));

var $f0a9601245d0def2$var$_content = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("oBrvI")));

var $f0a9601245d0def2$var$_footer = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("jSK5O")));

var $f0a9601245d0def2$var$_heading = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("7q8EC")));

var $f0a9601245d0def2$var$_hero = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("94oV6")));

var $f0a9601245d0def2$var$_image = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("dddYs")));

var $f0a9601245d0def2$var$_level = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("dpDsx")));

var $f0a9601245d0def2$var$_media = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("l9pa5")));

var $f0a9601245d0def2$var$_notification = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("3ygFC")));

var $f0a9601245d0def2$var$_progress = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("7DfyH")));

var $f0a9601245d0def2$var$_section = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("egHUh")));

var $f0a9601245d0def2$var$_tabs = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("ghmoh")));

var $f0a9601245d0def2$var$_table = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("9Q8hv")));

var $f0a9601245d0def2$var$_tag = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("2xS2j")));

var $f0a9601245d0def2$var$_tile = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("dhWki")));

var $f0a9601245d0def2$var$_modal = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("gmpiO")));

var $f0a9601245d0def2$var$_dropdown = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("4xbzi")));

var $f0a9601245d0def2$var$_icon = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("71Via")));

var $f0a9601245d0def2$var$_loader = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("1UAhC")));

var $f0a9601245d0def2$var$_navbar = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("kUKI3")));

var $f0a9601245d0def2$var$_pagination = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("6kRXO")));

var $f0a9601245d0def2$var$_menu = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("3tZmh")));

var $f0a9601245d0def2$var$_message = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("5zMq5")));

var $f0a9601245d0def2$var$_panel = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("kT9TC")));

var $f0a9601245d0def2$var$_element = $f0a9601245d0def2$var$_interopRequireDefault((parcelRequire("bQWwh")));
function $f0a9601245d0def2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f0a9601245d0def2$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $f0a9601245d0def2$var$_getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function $f0a9601245d0def2$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || $f0a9601245d0def2$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $f0a9601245d0def2$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}



parcelRequire("3ZYaX");

var $20d8ad5ef5e79686$exports = {};

$20d8ad5ef5e79686$exports = (parcelRequire("lt4Vl"));


const $318802042539b948$var$Table = ({ columns: columns, data: data, noDataMessage: noDataMessage, className: className, tableClassName: tableClassName, dataTest: dataTest, tableRef: tableRef })=>{
    const { getTableProps: getTableProps, getTableBodyProps: getTableBodyProps, headerGroups: headerGroups, rows: rows, prepareRow: prepareRow } = (0, $20d8ad5ef5e79686$exports.useTable)({
        columns: columns,
        data: data
    });
    return(// apply the table props
    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
        className: [
            'table-container pb-3',
            className
        ].join(' '),
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("table", {
                ...getTableProps(),
                className: [
                    'table is-striped is-hoverable is-fullwidth is-narrow',
                    tableClassName
                ].join(' '),
                "data-test": dataTest,
                ref: tableRef,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("thead", {
                        children: // Loop over the header rows
                        headerGroups.map((headerGroup)=>// Apply the header row props
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                                ...headerGroup.getHeaderGroupProps(),
                                children: // Loop over the headers in each row
                                headerGroup.headers.map((column)=>// Apply the header cell props
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        ...column.getHeaderProps({
                                            // TS 'any' workaround see react-table issue #1640
                                            className: column.className,
                                            style: {
                                                width: undefined,
                                                ...column.style
                                            }
                                        }),
                                        children: // Render the header
                                        column.render('Header')
                                    }))
                            }))
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tbody", {
                        ...getTableBodyProps(),
                        children: // Loop over the table rows
                        rows.map((row)=>{
                            // Prepare the row for display
                            prepareRow(row);
                            return(// Apply the row props
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                                ...row.getRowProps(),
                                children: // Loop over the rows cells
                                row.cells.map((cell)=>{
                                    //@ts-ignore
                                    const isHidden = cell.column.isHidden && cell.column.isHidden(cell, data);
                                    // Apply the cell prop
                                    if (isHidden) return null;
                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                        ...cell.getCellProps({
                                            //@ts-ignore
                                            rowSpan: cell.column.getRowSpan && cell.column.getRowSpan(cell, data),
                                            // TS 'any' workaround see react-table issue #1640
                                            className: cell.column.className,
                                            style: {
                                                width: undefined,
                                                ...row.style
                                            }
                                        }),
                                        children: // Render the cell contents
                                        cell.render('Cell')
                                    });
                                })
                            }));
                        })
                    })
                ]
            }),
            !rows[0] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                textAlign: "center",
                children: noDataMessage ?? "Aucun \xe9l\xe9ment \xe0 afficher"
            })
        ]
    }));
};
var $318802042539b948$export$2e2bcd8739ae039 = $318802042539b948$var$Table;



function $88915728c129ec8c$var$useFilters(resource) {
    const filters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[resource]);
    const setFilters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters.setFilters);
    return {
        filters: filters,
        setFilters: setFilters
    };
}
var $88915728c129ec8c$export$2e2bcd8739ae039 = $88915728c129ec8c$var$useFilters;



var $3ZYaX = parcelRequire("3ZYaX");
function $692d0667ec40027c$var$BanIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 5.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z",
        clipRule: "evenodd"
    }));
}
const $692d0667ec40027c$var$ForwardRef = $3ZYaX.forwardRef($692d0667ec40027c$var$BanIcon);
var $692d0667ec40027c$export$2e2bcd8739ae039 = $692d0667ec40027c$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $24f98ff5b23495eb$var$CalendarIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
        clipRule: "evenodd"
    }));
}
const $24f98ff5b23495eb$var$ForwardRef = $3ZYaX.forwardRef($24f98ff5b23495eb$var$CalendarIcon);
var $24f98ff5b23495eb$export$2e2bcd8739ae039 = $24f98ff5b23495eb$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $e9ef9c9c47c5e10d$var$DocumentTextIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z",
        clipRule: "evenodd"
    }));
}
const $e9ef9c9c47c5e10d$var$ForwardRef = $3ZYaX.forwardRef($e9ef9c9c47c5e10d$var$DocumentTextIcon);
var $e9ef9c9c47c5e10d$export$2e2bcd8739ae039 = $e9ef9c9c47c5e10d$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $49ec271fdb2fbc83$var$QrcodeIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z"
    }));
}
const $49ec271fdb2fbc83$var$ForwardRef = $3ZYaX.forwardRef($49ec271fdb2fbc83$var$QrcodeIcon);
var $49ec271fdb2fbc83$export$2e2bcd8739ae039 = $49ec271fdb2fbc83$var$ForwardRef;



var $2d012ef836db6bd8$var$ClockingStatusEnum = /*#__PURE__*/ function(ClockingStatusEnum) {
    ClockingStatusEnum["noMission"] = "Pas de Mission";
    ClockingStatusEnum["entry"] = "Entr\xe9e";
    ClockingStatusEnum["exit"] = "Sortie";
    ClockingStatusEnum["workPeriodDeleted"] = "Journ\xe9e supprim\xe9e";
    ClockingStatusEnum["replaced"] = "Interm\xe9diaire";
    return ClockingStatusEnum;
}($2d012ef836db6bd8$var$ClockingStatusEnum || {});
const $2d012ef836db6bd8$export$b70265791d2079d4 = (clocking)=>{
    if (!clocking.mission || !clocking.workPeriod || !clocking.type) return "Pas de Mission";
    const workPeriod = clocking.workPeriod;
    return workPeriod ? workPeriod[clocking.type].clocking?.item === clocking._id ? clocking.type === 'start' ? "Entr\xe9e" : "Sortie" : "Interm\xe9diaire" : "Journ\xe9e supprim\xe9e";
};



parcelRequire("3ZYaX");

const $8403deec6a28521e$export$6025088343704f9f = (roles, action, atLeastOneAction)=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentUserRole;
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentOrganization;
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentUser;
    const userOrganizationRole = currentOrganization && currentUser?.roles.find((r)=>r.organization?._id === currentOrganization._id);
    const atLeastOneAuthorizedAction = !atLeastOneAction || !userOrganizationRole?.crudActions || atLeastOneAction.some((action)=>userOrganizationRole.crudActions?.[action?.resource]?.[action.name]);
    const roleKinds = roles.map((r)=>typeof r === 'string' ? r : r.role);
    return Boolean(roles && roleKinds.includes(currentUserRole) && (!action || !userOrganizationRole?.crudActions || userOrganizationRole.crudActions?.[action?.resource]?.[action.name]) && atLeastOneAuthorizedAction);
};
const $8403deec6a28521e$export$3b37f8ef36140010 = (roles, action, atLeastOneAction)=>!$8403deec6a28521e$export$6025088343704f9f(roles, action, atLeastOneAction);
const $8403deec6a28521e$var$Protected = ({ roles: roles, children: children, action: action, atLeastOneAction: atLeastOneAction })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: $8403deec6a28521e$export$6025088343704f9f(roles, action, atLeastOneAction) && children
    });
var $8403deec6a28521e$export$2e2bcd8739ae039 = $8403deec6a28521e$var$Protected;






const $c52b637f8f8dea37$var$POPULATE = [
    'mission',
    'user',
    'mission.interimAgency',
    'mission.employer',
    'employer',
    'workPeriod'
];
var $c52b637f8f8dea37$export$e6ff43b4e5797b26 = /*#__PURE__*/ function(ClockingTypeEnum) {
    ClockingTypeEnum["start"] = "start";
    ClockingTypeEnum["end"] = "end";
    return ClockingTypeEnum;
}({});
const $c52b637f8f8dea37$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    const { start: start, end: end, user: user, workPeriod: workPeriod, ...rest } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/clockings',
        method: 'get',
        params: {
            sort: '-createdAt',
            'date>': start,
            'date<': end,
            populate: $c52b637f8f8dea37$var$POPULATE,
            limit: params?.limit,
            workPeriod: workPeriod,
            user: user
        }
    });
};
const $c52b637f8f8dea37$export$185802fd694ee1f5 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/clockings',
        method: 'post',
        params: params
    });
};



const $d19e678f97a3d4d6$export$556810fba3a25e86 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('clockings', (0, $c52b637f8f8dea37$export$e7aa7bc5c1b3cfb3), filters || {}, options);
//Mutations
const $d19e678f97a3d4d6$var$useCreateMutationKey = ()=>[
        'clockings',
        'create'
    ];
const $d19e678f97a3d4d6$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $c52b637f8f8dea37$export$185802fd694ee1f5), {
        mutationKey: $d19e678f97a3d4d6$var$useCreateMutationKey(),
        onSuccess: ()=>{
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                'clockings'
            ]);
        }
    });
const $d19e678f97a3d4d6$export$6e1909113a21f5d2 = (interval)=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)({
        queryFn: async ()=>(0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
                endpoint: '/version',
                method: 'head'
            }),
        refetchInterval: ()=>interval,
        refetchIntervalInBackground: true
    });




function $e94c78fdddee0309$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




const $ff82e5b471ec35cc$export$12e6eb457c26b96c = (doc, docToCompare)=>{
    const docId = doc?._id ? doc?._id.toString() : doc?.toString();
    const docIdToCompare = docToCompare?._id ? docToCompare?._id.toString() : docToCompare?.toString();
    return docId === docIdToCompare;
};
const $ff82e5b471ec35cc$export$9625e2739149ea7e = (docs, docOrId)=>docs.find((doc)=>$ff82e5b471ec35cc$export$12e6eb457c26b96c(doc, docOrId));
const $ff82e5b471ec35cc$export$f7ab4a0ab72c2665 = (doc)=>doc?._id ? doc?._id.toString() : doc?.toString();


const $25ffbf4bca475b04$export$9a57c514c234d759 = (user, options)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentOrganization;
    const internalRef = user.internalRef || user.associations && $25ffbf4bca475b04$export$8e03f956ff6d1de8({
        associations: user.associations
    }, currentOrganization);
    const offlineStatus = user.appAccess === 'none' && !options?.hideOfflineInfo ? ' - offline' : '';
    let label = `${user.lastName} ${user.firstName}${offlineStatus}`;
    if (internalRef) label += ` (${internalRef})`;
    return label;
};
const $25ffbf4bca475b04$export$91d1acdd7472079 = (worker, organization)=>worker.associations.find((association)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(association.organization, organization));
const $25ffbf4bca475b04$export$1a30e0a3340758be = (worker, interimAgency, employer)=>{
    const association = $25ffbf4bca475b04$export$91d1acdd7472079(worker, interimAgency);
    if (!association) return null;
    const laborCostCoefficientData = association.laborCostCoefficients.find((c)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(c.employer, employer));
    return laborCostCoefficientData?.kind === 'management' ? 'management' : 'delegation';
};
const $25ffbf4bca475b04$export$c33a4269214e2ec4 = (user, roleKind, organizationId)=>{
    if ((roleKind === 'employerMember' || roleKind === 'interimAgencyMember') && !organizationId) return;
    return user.roles.find((role)=>role.kind === roleKind && (!organizationId || (0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(organizationId, role.organization)));
};
const $25ffbf4bca475b04$export$8e03f956ff6d1de8 = (worker, organization)=>{
    const association = organization && $25ffbf4bca475b04$export$91d1acdd7472079(worker, organization);
    return association?.internalRef || '';
};
const $25ffbf4bca475b04$export$f5327d6ba0b1c3bb = (user, organization)=>{
    const association = $25ffbf4bca475b04$export$91d1acdd7472079(user, organization);
    return association?.availability;
};
const $25ffbf4bca475b04$var$checkWorkerIsAvailableForOrganizationInPeriod = (start, end, user, organization)=>{
    const availability = $25ffbf4bca475b04$export$f5327d6ba0b1c3bb(user, organization);
    return Boolean(!availability || $25ffbf4bca475b04$export$38c9d1ec7c4cfeb(start, end, availability));
};
const $25ffbf4bca475b04$export$38c9d1ec7c4cfeb = (start, end, availability)=>{
    const { absentFrom: absentFrom } = availability || {};
    let { absentTo: absentTo } = availability || {};
    if (!absentFrom) return true;
    if (!absentTo) absentTo = new Date(3000, 1, 1);
    if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(new Date(absentFrom), end) && (0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(absentTo), start)) return false;
    return true;
};
const $25ffbf4bca475b04$export$5935d3a9b1050649 = (date, user, organization)=>$25ffbf4bca475b04$var$checkWorkerIsAvailableForOrganizationInPeriod((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(date), (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(date), user, organization);
const $25ffbf4bca475b04$export$991c4a8cc675d611 = (user, organization)=>{
    const { absentFrom: absentFrom, absentTo: absentTo } = $25ffbf4bca475b04$export$f5327d6ba0b1c3bb(user, organization) || {};
    let label = `${$25ffbf4bca475b04$export$9a57c514c234d759(user)} s'est renseign\xe9 comme indisponible du 
  ${absentFrom && (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(absentFrom)}`;
    if (absentTo) label = `${label} au ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(absentTo)}`;
    else label = `${label} et pour une dur\xe9e indetermin\xe9e`;
    return label;
};
const $25ffbf4bca475b04$export$12c731bd2c9aa69b = (availability, user, short)=>{
    const { absentFrom: absentFrom, absentTo: absentTo } = availability;
    if (!absentFrom) return '';
    let label = short ? `Du ${absentFrom && (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(absentFrom)}` : `${$25ffbf4bca475b04$export$9a57c514c234d759(user)} s'est renseign\xe9 comme indisponible du 
  ${absentFrom && (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(absentFrom)}`;
    if (absentTo) label = `${label} au ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(absentTo)}`;
    else label = short ? `${label} au indetermin\xe9` : `${label} et pour une dur\xe9e indetermin\xe9e`;
    return label;
};
const $25ffbf4bca475b04$export$472a3a1acf73db3a = (user, roleKind, organization)=>{
    if (roleKind === 'worker' && organization) {
        const association = $25ffbf4bca475b04$export$91d1acdd7472079(user, organization);
        return association?.status;
    }
    return $25ffbf4bca475b04$export$c33a4269214e2ec4(user, roleKind, organization?._id)?.status;
};
const $25ffbf4bca475b04$export$6b3b70a0a244f047 = (user, organization)=>{
    const workerRole = $25ffbf4bca475b04$export$c33a4269214e2ec4(user, 'worker');
    return workerRole?.employerRelations.find((relation)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(relation.employer, organization));
};
const $25ffbf4bca475b04$export$a0936ca7c9219b40 = (user, organization)=>{
    const employerRelation = $25ffbf4bca475b04$export$6b3b70a0a244f047(user, organization);
    return employerRelation?.collaboration?.isInactive || false;
};
const $25ffbf4bca475b04$export$515cc9cea50b06c3 = (association, date)=>{
    if (!association.contractualSchedules || association.contractualSchedules.length === 0) return undefined;
    const targetDate = date || new Date();
    // Find entries valid at the target date
    const validEntries = association.contractualSchedules.filter((entry)=>{
        const effectiveFrom = new Date(entry.effectiveFrom);
        const effectiveTo = entry.effectiveTo ? new Date(entry.effectiveTo) : null;
        // Entry is valid if:
        // - effectiveFrom <= targetDate
        // - effectiveTo is null OR effectiveTo >= targetDate
        return effectiveFrom <= targetDate && (effectiveTo === null || effectiveTo >= targetDate);
    });
    if (validEntries.length === 0) // No valid entry at target date, return the most recent entry
    return association.contractualSchedules.sort((a, b)=>new Date(b.effectiveFrom).getTime() - new Date(a.effectiveFrom).getTime())[0];
    // Among valid entries, prefer the active one (effectiveTo === null)
    const activeEntry = validEntries.find((entry)=>entry.effectiveTo === null);
    if (activeEntry) return activeEntry;
    // If no active entry, return the most recent valid entry
    return validEntries.sort((a, b)=>new Date(b.effectiveFrom).getTime() - new Date(a.effectiveFrom).getTime())[0];
};
const $25ffbf4bca475b04$export$3ef3aade8b3d4986 = (date)=>{
    const dayOfWeek = date.getDay() // 0 = dimanche, 1 = lundi, ..., 6 = samedi
    ;
    // Convertir en monday-based (1 = lundi, 7 = dimanche)
    const mondayBasedDay = dayOfWeek === 0 ? 7 : dayOfWeek;
    const dayNames = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    return dayNames[mondayBasedDay - 1];
};
const $25ffbf4bca475b04$export$85e20ba768953e2a = (association)=>{
    if (!association?.contractualSchedules || association.contractualSchedules.length === 0) return false;
    return association.contractualSchedules.some((entry)=>entry.schedule !== null && entry.schedule !== undefined);
};
/** Day keys in ContractualWeeklySchedule, in order 0 (Monday) to 6 (Sunday). */ const $25ffbf4bca475b04$var$CONTRACTUAL_DAY_KEYS = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
const $25ffbf4bca475b04$export$7ae547bce694990c = (entry)=>{
    if (!entry.schedule) return null;
    const days = {};
    for(let dayIndex = 0; dayIndex < $25ffbf4bca475b04$var$CONTRACTUAL_DAY_KEYS.length; dayIndex++){
        const dayKey = $25ffbf4bca475b04$var$CONTRACTUAL_DAY_KEYS[dayIndex];
        const daySchedule = entry.schedule[dayKey];
        const slots = daySchedule?.timeSlots?.filter(Boolean) ?? [];
        if (slots.length === 0) continue;
        const startHour = Math.min(...slots.map((s)=>s.startHour));
        const endHour = Math.max(...slots.map((s)=>s.endHour));
        days[dayIndex] = {
            startHour: startHour,
            endHour: endHour
        };
    }
    return {
        start: new Date(),
        end: null,
        weekPatterns: [
            {
                days: days
            }
        ]
    };
};



parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");


var $3ZYaX = parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");
function $ad8d7b81ff84d54a$export$c5623aa1c38918b6() {
    const firstRender = (0, $3ZYaX.useRef)(true);
    (0, $3ZYaX.useEffect)(()=>{
        firstRender.current = false;
    }, []);
    return firstRender.current;
}


const $d6e87a2602347968$var$AutoSubmit = ({ values: values, errors: errors, submitForm: submitForm })=>{
    const firstRender = (0, $ad8d7b81ff84d54a$export$c5623aa1c38918b6)();
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (errors && Object.keys(errors).length > 0) return;
        if (!firstRender) submitForm();
    }, [
        values,
        submitForm
    ]);
    return null;
};
var $d6e87a2602347968$export$2e2bcd8739ae039 = $d6e87a2602347968$var$AutoSubmit;




var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");

parcelRequire("3ZYaX");

const $3d077e8ec4003af2$var$FieldColumn = ({ children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        narrow: true,
        style: {
            minWidth: 220
        },
        children: children
    });
};
var $3d077e8ec4003af2$export$2e2bcd8739ae039 = $3d077e8ec4003af2$var$FieldColumn;




var $3ZYaX = parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");
function $2c655d9e70ebd20e$var$AcademicCapIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M12 14l9-5-9-5-9 5 9 5z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
    }));
}
const $2c655d9e70ebd20e$var$ForwardRef = $3ZYaX.forwardRef($2c655d9e70ebd20e$var$AcademicCapIcon);
var $2c655d9e70ebd20e$export$2e2bcd8739ae039 = $2c655d9e70ebd20e$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $a4b021b8cd9c67c7$var$CalculatorIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
    }));
}
const $a4b021b8cd9c67c7$var$ForwardRef = $3ZYaX.forwardRef($a4b021b8cd9c67c7$var$CalculatorIcon);
var $a4b021b8cd9c67c7$export$2e2bcd8739ae039 = $a4b021b8cd9c67c7$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $825cadbc85a89039$var$CalendarIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
    }));
}
const $825cadbc85a89039$var$ForwardRef = $3ZYaX.forwardRef($825cadbc85a89039$var$CalendarIcon);
var $825cadbc85a89039$export$2e2bcd8739ae039 = $825cadbc85a89039$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $8484b39f982e716b$var$ChevronDownIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 9l-7 7-7-7"
    }));
}
const $8484b39f982e716b$var$ForwardRef = $3ZYaX.forwardRef($8484b39f982e716b$var$ChevronDownIcon);
var $8484b39f982e716b$export$2e2bcd8739ae039 = $8484b39f982e716b$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $5a8507055084759e$var$ChevronUpIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 15l7-7 7 7"
    }));
}
const $5a8507055084759e$var$ForwardRef = $3ZYaX.forwardRef($5a8507055084759e$var$ChevronUpIcon);
var $5a8507055084759e$export$2e2bcd8739ae039 = $5a8507055084759e$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $a7a011be8cb58dcb$var$ColorSwatchIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
    }));
}
const $a7a011be8cb58dcb$var$ForwardRef = $3ZYaX.forwardRef($a7a011be8cb58dcb$var$ColorSwatchIcon);
var $a7a011be8cb58dcb$export$2e2bcd8739ae039 = $a7a011be8cb58dcb$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $98c6a9e2e789f511$var$CreditCardIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    }));
}
const $98c6a9e2e789f511$var$ForwardRef = $3ZYaX.forwardRef($98c6a9e2e789f511$var$CreditCardIcon);
var $98c6a9e2e789f511$export$2e2bcd8739ae039 = $98c6a9e2e789f511$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $9ebd0210d45a1cac$var$CurrencyEuroIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $9ebd0210d45a1cac$var$ForwardRef = $3ZYaX.forwardRef($9ebd0210d45a1cac$var$CurrencyEuroIcon);
var $9ebd0210d45a1cac$export$2e2bcd8739ae039 = $9ebd0210d45a1cac$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $3f8e68bcf6ff6e0f$var$DocumentDuplicateIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
    }));
}
const $3f8e68bcf6ff6e0f$var$ForwardRef = $3ZYaX.forwardRef($3f8e68bcf6ff6e0f$var$DocumentDuplicateIcon);
var $3f8e68bcf6ff6e0f$export$2e2bcd8739ae039 = $3f8e68bcf6ff6e0f$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $fda9e85e7649b2f6$var$ExclamationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $fda9e85e7649b2f6$var$ForwardRef = $3ZYaX.forwardRef($fda9e85e7649b2f6$var$ExclamationCircleIcon);
var $fda9e85e7649b2f6$export$2e2bcd8739ae039 = $fda9e85e7649b2f6$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $9cce2377d82ad02c$var$EyeIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    }));
}
const $9cce2377d82ad02c$var$ForwardRef = $3ZYaX.forwardRef($9cce2377d82ad02c$var$EyeIcon);
var $9cce2377d82ad02c$export$2e2bcd8739ae039 = $9cce2377d82ad02c$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $fc76df2565052bd3$var$FlagIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
    }));
}
const $fc76df2565052bd3$var$ForwardRef = $3ZYaX.forwardRef($fc76df2565052bd3$var$FlagIcon);
var $fc76df2565052bd3$export$2e2bcd8739ae039 = $fc76df2565052bd3$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $cd99054e880ce1a7$var$HandIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
    }));
}
const $cd99054e880ce1a7$var$ForwardRef = $3ZYaX.forwardRef($cd99054e880ce1a7$var$HandIcon);
var $cd99054e880ce1a7$export$2e2bcd8739ae039 = $cd99054e880ce1a7$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $6229b32327934950$var$InformationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $6229b32327934950$var$ForwardRef = $3ZYaX.forwardRef($6229b32327934950$var$InformationCircleIcon);
var $6229b32327934950$export$2e2bcd8739ae039 = $6229b32327934950$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $4d3c66d4b09ff42b$var$PlusIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4v16m8-8H4"
    }));
}
const $4d3c66d4b09ff42b$var$ForwardRef = $3ZYaX.forwardRef($4d3c66d4b09ff42b$var$PlusIcon);
var $4d3c66d4b09ff42b$export$2e2bcd8739ae039 = $4d3c66d4b09ff42b$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $a326b8f6e31ceb86$var$QrcodeIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
    }));
}
const $a326b8f6e31ceb86$var$ForwardRef = $3ZYaX.forwardRef($a326b8f6e31ceb86$var$QrcodeIcon);
var $a326b8f6e31ceb86$export$2e2bcd8739ae039 = $a326b8f6e31ceb86$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $41a7a7521a465f27$var$QuestionMarkCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $41a7a7521a465f27$var$ForwardRef = $3ZYaX.forwardRef($41a7a7521a465f27$var$QuestionMarkCircleIcon);
var $41a7a7521a465f27$export$2e2bcd8739ae039 = $41a7a7521a465f27$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $17ae2fe7272e9982$var$SearchIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    }));
}
const $17ae2fe7272e9982$var$ForwardRef = $3ZYaX.forwardRef($17ae2fe7272e9982$var$SearchIcon);
var $17ae2fe7272e9982$export$2e2bcd8739ae039 = $17ae2fe7272e9982$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $151289adaee6f070$var$SwitchVerticalIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"
    }));
}
const $151289adaee6f070$var$ForwardRef = $3ZYaX.forwardRef($151289adaee6f070$var$SwitchVerticalIcon);
var $151289adaee6f070$export$2e2bcd8739ae039 = $151289adaee6f070$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $7a33237a6165cbf3$var$TagIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
    }));
}
const $7a33237a6165cbf3$var$ForwardRef = $3ZYaX.forwardRef($7a33237a6165cbf3$var$TagIcon);
var $7a33237a6165cbf3$export$2e2bcd8739ae039 = $7a33237a6165cbf3$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $1a0bf4c1ef962d88$var$TrashIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    }));
}
const $1a0bf4c1ef962d88$var$ForwardRef = $3ZYaX.forwardRef($1a0bf4c1ef962d88$var$TrashIcon);
var $1a0bf4c1ef962d88$export$2e2bcd8739ae039 = $1a0bf4c1ef962d88$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $786dfe9e4308f029$var$XCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $786dfe9e4308f029$var$ForwardRef = $3ZYaX.forwardRef($786dfe9e4308f029$var$XCircleIcon);
var $786dfe9e4308f029$export$2e2bcd8739ae039 = $786dfe9e4308f029$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");
function $c5f9d04dfd1bd9b2$var$ArrowNarrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $c5f9d04dfd1bd9b2$var$ForwardRef = $3ZYaX.forwardRef($c5f9d04dfd1bd9b2$var$ArrowNarrowDownIcon);
var $c5f9d04dfd1bd9b2$export$2e2bcd8739ae039 = $c5f9d04dfd1bd9b2$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $974649a7879a5b6d$var$ArrowNarrowLeftIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
        clipRule: "evenodd"
    }));
}
const $974649a7879a5b6d$var$ForwardRef = $3ZYaX.forwardRef($974649a7879a5b6d$var$ArrowNarrowLeftIcon);
var $974649a7879a5b6d$export$2e2bcd8739ae039 = $974649a7879a5b6d$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $2539fd7e092dd147$var$ArrowNarrowRightIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $2539fd7e092dd147$var$ForwardRef = $3ZYaX.forwardRef($2539fd7e092dd147$var$ArrowNarrowRightIcon);
var $2539fd7e092dd147$export$2e2bcd8739ae039 = $2539fd7e092dd147$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $077c554dc738a4e7$var$ArrowNarrowUpIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z",
        clipRule: "evenodd"
    }));
}
const $077c554dc738a4e7$var$ForwardRef = $3ZYaX.forwardRef($077c554dc738a4e7$var$ArrowNarrowUpIcon);
var $077c554dc738a4e7$export$2e2bcd8739ae039 = $077c554dc738a4e7$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $e540febb9d2f6e13$var$ChartPieIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"
    }));
}
const $e540febb9d2f6e13$var$ForwardRef = $3ZYaX.forwardRef($e540febb9d2f6e13$var$ChartPieIcon);
var $e540febb9d2f6e13$export$2e2bcd8739ae039 = $e540febb9d2f6e13$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $e3404f2a2f59579e$var$CheckCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $e3404f2a2f59579e$var$ForwardRef = $3ZYaX.forwardRef($e3404f2a2f59579e$var$CheckCircleIcon);
var $e3404f2a2f59579e$export$2e2bcd8739ae039 = $e3404f2a2f59579e$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $28ef1a36654d3a19$var$CheckIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
        clipRule: "evenodd"
    }));
}
const $28ef1a36654d3a19$var$ForwardRef = $3ZYaX.forwardRef($28ef1a36654d3a19$var$CheckIcon);
var $28ef1a36654d3a19$export$2e2bcd8739ae039 = $28ef1a36654d3a19$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $644da22e3067df9b$var$ClockIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z",
        clipRule: "evenodd"
    }));
}
const $644da22e3067df9b$var$ForwardRef = $3ZYaX.forwardRef($644da22e3067df9b$var$ClockIcon);
var $644da22e3067df9b$export$2e2bcd8739ae039 = $644da22e3067df9b$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $6a9f4bf1f76c2bc1$var$CogIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z",
        clipRule: "evenodd"
    }));
}
const $6a9f4bf1f76c2bc1$var$ForwardRef = $3ZYaX.forwardRef($6a9f4bf1f76c2bc1$var$CogIcon);
var $6a9f4bf1f76c2bc1$export$2e2bcd8739ae039 = $6a9f4bf1f76c2bc1$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $578b3a666305a9d8$var$FolderOpenIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"
    }));
}
const $578b3a666305a9d8$var$ForwardRef = $3ZYaX.forwardRef($578b3a666305a9d8$var$FolderOpenIcon);
var $578b3a666305a9d8$export$2e2bcd8739ae039 = $578b3a666305a9d8$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $ac09c55bd3bfbf82$var$LockClosedIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
        clipRule: "evenodd"
    }));
}
const $ac09c55bd3bfbf82$var$ForwardRef = $3ZYaX.forwardRef($ac09c55bd3bfbf82$var$LockClosedIcon);
var $ac09c55bd3bfbf82$export$2e2bcd8739ae039 = $ac09c55bd3bfbf82$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $bc1d02098d076a94$var$OfficeBuildingIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M4 4a2 2 0 012-2h8a2 2 0 012 2v12a1 1 0 110 2h-3a1 1 0 01-1-1v-2a1 1 0 00-1-1H9a1 1 0 00-1 1v2a1 1 0 01-1 1H4a1 1 0 110-2V4zm3 1h2v2H7V5zm2 4H7v2h2V9zm2-4h2v2h-2V5zm2 4h-2v2h2V9z",
        clipRule: "evenodd"
    }));
}
const $bc1d02098d076a94$var$ForwardRef = $3ZYaX.forwardRef($bc1d02098d076a94$var$OfficeBuildingIcon);
var $bc1d02098d076a94$export$2e2bcd8739ae039 = $bc1d02098d076a94$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $cdd6dd2b11084245$var$PencilIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
    }));
}
const $cdd6dd2b11084245$var$ForwardRef = $3ZYaX.forwardRef($cdd6dd2b11084245$var$PencilIcon);
var $cdd6dd2b11084245$export$2e2bcd8739ae039 = $cdd6dd2b11084245$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $6247d194571a5310$var$ThumbUpIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z"
    }));
}
const $6247d194571a5310$var$ForwardRef = $3ZYaX.forwardRef($6247d194571a5310$var$ThumbUpIcon);
var $6247d194571a5310$export$2e2bcd8739ae039 = $6247d194571a5310$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $5787a2d40ce8921c$var$UserIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z",
        clipRule: "evenodd"
    }));
}
const $5787a2d40ce8921c$var$ForwardRef = $3ZYaX.forwardRef($5787a2d40ce8921c$var$UserIcon);
var $5787a2d40ce8921c$export$2e2bcd8739ae039 = $5787a2d40ce8921c$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $4e76a2997dcc5e78$var$XIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $4e76a2997dcc5e78$var$ForwardRef = $3ZYaX.forwardRef($4e76a2997dcc5e78$var$XIcon);
var $4e76a2997dcc5e78$export$2e2bcd8739ae039 = $4e76a2997dcc5e78$var$ForwardRef;


function $82f622ad5caaffb5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82f622ad5caaffb5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $82f622ad5caaffb5$var$ownKeys(Object(source), !0).forEach(function(key) {
            $82f622ad5caaffb5$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $82f622ad5caaffb5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $82f622ad5caaffb5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $82f622ad5caaffb5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $82f622ad5caaffb5$var$_typeof(obj);
}
function $82f622ad5caaffb5$var$_wrapRegExp() {
    $82f622ad5caaffb5$var$_wrapRegExp = function(re, groups) {
        return new BabelRegExp(re, void 0, groups);
    };
    var _super = RegExp.prototype, _groups = new WeakMap();
    function BabelRegExp(re, flags, groups) {
        var _this = new RegExp(re, flags);
        return _groups.set(_this, groups || _groups.get(re)), $82f622ad5caaffb5$var$_setPrototypeOf(_this, BabelRegExp.prototype);
    }
    function buildGroups(result, re) {
        var g = _groups.get(re);
        return Object.keys(g).reduce(function(groups, name) {
            return groups[name] = result[g[name]], groups;
        }, Object.create(null));
    }
    return $82f622ad5caaffb5$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(str) {
        var result = _super.exec.call(this, str);
        return result && (result.groups = buildGroups(result, this)), result;
    }, BabelRegExp.prototype[Symbol.replace] = function(str, substitution) {
        if ("string" == typeof substitution) {
            var groups = _groups.get(this);
            return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function(_, name) {
                return "$" + groups[name];
            }));
        }
        if ("function" == typeof substitution) {
            var _this = this;
            return _super[Symbol.replace].call(this, str, function() {
                var args = arguments;
                return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args);
            });
        }
        return _super[Symbol.replace].call(this, str, substitution);
    }, $82f622ad5caaffb5$var$_wrapRegExp.apply(this, arguments);
}
function $82f622ad5caaffb5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $82f622ad5caaffb5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $82f622ad5caaffb5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $82f622ad5caaffb5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $82f622ad5caaffb5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $82f622ad5caaffb5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82f622ad5caaffb5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $82f622ad5caaffb5$var$_setPrototypeOf(subClass, superClass);
}
function $82f622ad5caaffb5$var$_setPrototypeOf(o, p) {
    $82f622ad5caaffb5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $82f622ad5caaffb5$var$_setPrototypeOf(o, p);
}
function $82f622ad5caaffb5$var$_slicedToArray(arr, i) {
    return $82f622ad5caaffb5$var$_arrayWithHoles(arr) || $82f622ad5caaffb5$var$_iterableToArrayLimit(arr, i) || $82f622ad5caaffb5$var$_unsupportedIterableToArray(arr, i) || $82f622ad5caaffb5$var$_nonIterableRest();
}
function $82f622ad5caaffb5$var$_toConsumableArray(arr) {
    return $82f622ad5caaffb5$var$_arrayWithoutHoles(arr) || $82f622ad5caaffb5$var$_iterableToArray(arr) || $82f622ad5caaffb5$var$_unsupportedIterableToArray(arr) || $82f622ad5caaffb5$var$_nonIterableSpread();
}
function $82f622ad5caaffb5$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $82f622ad5caaffb5$var$_arrayLikeToArray(arr);
}
function $82f622ad5caaffb5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $82f622ad5caaffb5$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $82f622ad5caaffb5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $82f622ad5caaffb5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $82f622ad5caaffb5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $82f622ad5caaffb5$var$_arrayLikeToArray(o, minLen);
}
function $82f622ad5caaffb5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $82f622ad5caaffb5$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $82f622ad5caaffb5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $82f622ad5caaffb5$var$noop = function noop() {};
var $82f622ad5caaffb5$var$_WINDOW = {};
var $82f622ad5caaffb5$var$_DOCUMENT = {};
var $82f622ad5caaffb5$var$_MUTATION_OBSERVER = null;
var $82f622ad5caaffb5$var$_PERFORMANCE = {
    mark: $82f622ad5caaffb5$var$noop,
    measure: $82f622ad5caaffb5$var$noop
};
try {
    if (typeof window !== 'undefined') $82f622ad5caaffb5$var$_WINDOW = window;
    if (typeof document !== 'undefined') $82f622ad5caaffb5$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $82f622ad5caaffb5$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $82f622ad5caaffb5$var$_PERFORMANCE = performance;
} catch (e) {}
var $82f622ad5caaffb5$var$_ref = $82f622ad5caaffb5$var$_WINDOW.navigator || {}, $82f622ad5caaffb5$var$_ref$userAgent = $82f622ad5caaffb5$var$_ref.userAgent, $82f622ad5caaffb5$var$userAgent = $82f622ad5caaffb5$var$_ref$userAgent === void 0 ? '' : $82f622ad5caaffb5$var$_ref$userAgent;
var $82f622ad5caaffb5$var$WINDOW = $82f622ad5caaffb5$var$_WINDOW;
var $82f622ad5caaffb5$var$DOCUMENT = $82f622ad5caaffb5$var$_DOCUMENT;
var $82f622ad5caaffb5$var$MUTATION_OBSERVER = $82f622ad5caaffb5$var$_MUTATION_OBSERVER;
var $82f622ad5caaffb5$var$PERFORMANCE = $82f622ad5caaffb5$var$_PERFORMANCE;
var $82f622ad5caaffb5$var$IS_BROWSER = !!$82f622ad5caaffb5$var$WINDOW.document;
var $82f622ad5caaffb5$var$IS_DOM = !!$82f622ad5caaffb5$var$DOCUMENT.documentElement && !!$82f622ad5caaffb5$var$DOCUMENT.head && typeof $82f622ad5caaffb5$var$DOCUMENT.addEventListener === 'function' && typeof $82f622ad5caaffb5$var$DOCUMENT.createElement === 'function';
var $82f622ad5caaffb5$var$IS_IE = ~$82f622ad5caaffb5$var$userAgent.indexOf('MSIE') || ~$82f622ad5caaffb5$var$userAgent.indexOf('Trident/');
var $82f622ad5caaffb5$var$_familyProxy, $82f622ad5caaffb5$var$_familyProxy2, $82f622ad5caaffb5$var$_familyProxy3, $82f622ad5caaffb5$var$_familyProxy4, $82f622ad5caaffb5$var$_familyProxy5;
var $82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $82f622ad5caaffb5$var$UNITS_IN_GRID = 16;
var $82f622ad5caaffb5$var$DEFAULT_CSS_PREFIX = 'fa';
var $82f622ad5caaffb5$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $82f622ad5caaffb5$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $82f622ad5caaffb5$var$DATA_PREFIX = 'data-prefix';
var $82f622ad5caaffb5$var$DATA_ICON = 'data-icon';
var $82f622ad5caaffb5$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $82f622ad5caaffb5$var$MUTATION_APPROACH_ASYNC = 'async';
var $82f622ad5caaffb5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $82f622ad5caaffb5$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e) {
        return false;
    }
}();
var $82f622ad5caaffb5$var$FAMILY_CLASSIC = 'classic';
var $82f622ad5caaffb5$var$FAMILY_SHARP = 'sharp';
var $82f622ad5caaffb5$var$FAMILIES = [
    $82f622ad5caaffb5$var$FAMILY_CLASSIC,
    $82f622ad5caaffb5$var$FAMILY_SHARP
];
function $82f622ad5caaffb5$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$82f622ad5caaffb5$var$FAMILY_CLASSIC];
        }
    });
}
var $82f622ad5caaffb5$var$PREFIX_TO_STYLE = $82f622ad5caaffb5$var$familyProxy(($82f622ad5caaffb5$var$_familyProxy = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy, $82f622ad5caaffb5$var$FAMILY_CLASSIC, {
    'fa': 'solid',
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fakd': 'kit',
    'fa-kit': 'kit',
    'fa-kit-duotone': 'kit'
}), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy, $82f622ad5caaffb5$var$FAMILY_SHARP, {
    'fa': 'solid',
    'fass': 'solid',
    'fa-solid': 'solid',
    'fasr': 'regular',
    'fa-regular': 'regular',
    'fasl': 'light',
    'fa-light': 'light',
    'fast': 'thin',
    'fa-thin': 'thin'
}), $82f622ad5caaffb5$var$_familyProxy));
var $82f622ad5caaffb5$var$STYLE_TO_PREFIX = $82f622ad5caaffb5$var$familyProxy(($82f622ad5caaffb5$var$_familyProxy2 = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy2, $82f622ad5caaffb5$var$FAMILY_CLASSIC, {
    solid: 'fas',
    regular: 'far',
    light: 'fal',
    thin: 'fat',
    duotone: 'fad',
    brands: 'fab',
    kit: 'fak'
}), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy2, $82f622ad5caaffb5$var$FAMILY_SHARP, {
    solid: 'fass',
    regular: 'fasr',
    light: 'fasl',
    thin: 'fast'
}), $82f622ad5caaffb5$var$_familyProxy2));
var $82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE = $82f622ad5caaffb5$var$familyProxy(($82f622ad5caaffb5$var$_familyProxy3 = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy3, $82f622ad5caaffb5$var$FAMILY_CLASSIC, {
    fab: 'fa-brands',
    fad: 'fa-duotone',
    fak: 'fa-kit',
    fal: 'fa-light',
    far: 'fa-regular',
    fas: 'fa-solid',
    fat: 'fa-thin'
}), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy3, $82f622ad5caaffb5$var$FAMILY_SHARP, {
    fass: 'fa-solid',
    fasr: 'fa-regular',
    fasl: 'fa-light',
    fast: 'fa-thin'
}), $82f622ad5caaffb5$var$_familyProxy3));
var $82f622ad5caaffb5$var$LONG_STYLE_TO_PREFIX = $82f622ad5caaffb5$var$familyProxy(($82f622ad5caaffb5$var$_familyProxy4 = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy4, $82f622ad5caaffb5$var$FAMILY_CLASSIC, {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
}), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy4, $82f622ad5caaffb5$var$FAMILY_SHARP, {
    'fa-solid': 'fass',
    'fa-regular': 'fasr',
    'fa-light': 'fasl',
    'fa-thin': 'fast'
}), $82f622ad5caaffb5$var$_familyProxy4));
var $82f622ad5caaffb5$var$ICON_SELECTION_SYNTAX_PATTERN = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/; // eslint-disable-line no-useless-escape
var $82f622ad5caaffb5$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $82f622ad5caaffb5$var$FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i;
var $82f622ad5caaffb5$var$FONT_WEIGHT_TO_PREFIX = $82f622ad5caaffb5$var$familyProxy(($82f622ad5caaffb5$var$_familyProxy5 = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy5, $82f622ad5caaffb5$var$FAMILY_CLASSIC, {
    900: 'fas',
    400: 'far',
    normal: 'far',
    300: 'fal',
    100: 'fat'
}), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_familyProxy5, $82f622ad5caaffb5$var$FAMILY_SHARP, {
    900: 'fass',
    400: 'fasr',
    300: 'fasl',
    100: 'fast'
}), $82f622ad5caaffb5$var$_familyProxy5));
var $82f622ad5caaffb5$var$oneToTen = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
var $82f622ad5caaffb5$var$oneToTwenty = $82f622ad5caaffb5$var$oneToTen.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]);
var $82f622ad5caaffb5$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $82f622ad5caaffb5$var$DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
};
var $82f622ad5caaffb5$var$prefixes = new Set();
Object.keys($82f622ad5caaffb5$var$STYLE_TO_PREFIX[$82f622ad5caaffb5$var$FAMILY_CLASSIC]).map($82f622ad5caaffb5$var$prefixes.add.bind($82f622ad5caaffb5$var$prefixes));
Object.keys($82f622ad5caaffb5$var$STYLE_TO_PREFIX[$82f622ad5caaffb5$var$FAMILY_SHARP]).map($82f622ad5caaffb5$var$prefixes.add.bind($82f622ad5caaffb5$var$prefixes));
var $82f622ad5caaffb5$var$RESERVED_CLASSES = [].concat($82f622ad5caaffb5$var$FAMILIES, $82f622ad5caaffb5$var$_toConsumableArray($82f622ad5caaffb5$var$prefixes), [
    '2xs',
    'xs',
    'sm',
    'lg',
    'xl',
    '2xl',
    'beat',
    'border',
    'fade',
    'beat-fade',
    'bounce',
    'flip-both',
    'flip-horizontal',
    'flip-vertical',
    'flip',
    'fw',
    'inverse',
    'layers-counter',
    'layers-text',
    'layers',
    'li',
    'pull-left',
    'pull-right',
    'pulse',
    'rotate-180',
    'rotate-270',
    'rotate-90',
    'rotate-by',
    'shake',
    'spin-pulse',
    'spin-reverse',
    'spin',
    'stack-1x',
    'stack-2x',
    'stack',
    'ul',
    $82f622ad5caaffb5$var$DUOTONE_CLASSES.GROUP,
    $82f622ad5caaffb5$var$DUOTONE_CLASSES.SWAP_OPACITY,
    $82f622ad5caaffb5$var$DUOTONE_CLASSES.PRIMARY,
    $82f622ad5caaffb5$var$DUOTONE_CLASSES.SECONDARY
]).concat($82f622ad5caaffb5$var$oneToTen.map(function(n) {
    return "".concat(n, "x");
})).concat($82f622ad5caaffb5$var$oneToTwenty.map(function(n) {
    return "w-".concat(n);
}));
var $82f622ad5caaffb5$var$initial = $82f622ad5caaffb5$var$WINDOW.FontAwesomeConfig || {};
function $82f622ad5caaffb5$var$getAttrConfig(attr) {
    var element = $82f622ad5caaffb5$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $82f622ad5caaffb5$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($82f622ad5caaffb5$var$DOCUMENT && typeof $82f622ad5caaffb5$var$DOCUMENT.querySelector === 'function') {
    var $82f622ad5caaffb5$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-auto-a11y',
            'autoA11y'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $82f622ad5caaffb5$var$attrs.forEach(function(_ref) {
        var _ref2 = $82f622ad5caaffb5$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $82f622ad5caaffb5$var$coerce($82f622ad5caaffb5$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $82f622ad5caaffb5$var$initial[key] = val;
    });
}
var $82f622ad5caaffb5$var$_default = {
    styleDefault: 'solid',
    familyDefault: 'classic',
    cssPrefix: $82f622ad5caaffb5$var$DEFAULT_CSS_PREFIX,
    replacementClass: $82f622ad5caaffb5$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    autoA11y: true,
    searchPseudoElements: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
}; // familyPrefix is deprecated but we must still support it if present
if ($82f622ad5caaffb5$var$initial.familyPrefix) $82f622ad5caaffb5$var$initial.cssPrefix = $82f622ad5caaffb5$var$initial.familyPrefix;
var $82f622ad5caaffb5$var$_config = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$_default), $82f622ad5caaffb5$var$initial);
if (!$82f622ad5caaffb5$var$_config.autoReplaceSvg) $82f622ad5caaffb5$var$_config.observeMutations = false;
var $82f622ad5caaffb5$var$config = {};
Object.keys($82f622ad5caaffb5$var$_default).forEach(function(key) {
    Object.defineProperty($82f622ad5caaffb5$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $82f622ad5caaffb5$var$_config[key] = val;
            $82f622ad5caaffb5$var$_onChangeCb.forEach(function(cb) {
                return cb($82f622ad5caaffb5$var$config);
            });
        },
        get: function get() {
            return $82f622ad5caaffb5$var$_config[key];
        }
    });
}); // familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($82f622ad5caaffb5$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $82f622ad5caaffb5$var$_config.cssPrefix = val;
        $82f622ad5caaffb5$var$_onChangeCb.forEach(function(cb) {
            return cb($82f622ad5caaffb5$var$config);
        });
    },
    get: function get() {
        return $82f622ad5caaffb5$var$_config.cssPrefix;
    }
});
$82f622ad5caaffb5$var$WINDOW.FontAwesomeConfig = $82f622ad5caaffb5$var$config;
var $82f622ad5caaffb5$var$_onChangeCb = [];
function $82f622ad5caaffb5$var$onChange(cb) {
    $82f622ad5caaffb5$var$_onChangeCb.push(cb);
    return function() {
        $82f622ad5caaffb5$var$_onChangeCb.splice($82f622ad5caaffb5$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $82f622ad5caaffb5$var$d = $82f622ad5caaffb5$var$UNITS_IN_GRID;
var $82f622ad5caaffb5$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $82f622ad5caaffb5$var$insertCss(css) {
    if (!css || !$82f622ad5caaffb5$var$IS_DOM) return;
    var style = $82f622ad5caaffb5$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $82f622ad5caaffb5$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $82f622ad5caaffb5$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $82f622ad5caaffb5$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $82f622ad5caaffb5$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $82f622ad5caaffb5$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $82f622ad5caaffb5$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $82f622ad5caaffb5$var$classArray(node) {
    if (node.classList) return $82f622ad5caaffb5$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $82f622ad5caaffb5$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $82f622ad5caaffb5$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($82f622ad5caaffb5$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $82f622ad5caaffb5$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $82f622ad5caaffb5$var$transformIsMeaningful(transform) {
    return transform.size !== $82f622ad5caaffb5$var$meaninglessTransform.size || transform.x !== $82f622ad5caaffb5$var$meaninglessTransform.x || transform.y !== $82f622ad5caaffb5$var$meaninglessTransform.y || transform.rotate !== $82f622ad5caaffb5$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $82f622ad5caaffb5$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $82f622ad5caaffb5$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $82f622ad5caaffb5$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $82f622ad5caaffb5$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $82f622ad5caaffb5$var$IS_IE) val += "translate(".concat(transform.x / $82f622ad5caaffb5$var$d - width / 2, "em, ").concat(transform.y / $82f622ad5caaffb5$var$d - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $82f622ad5caaffb5$var$d, "em), calc(-50% + ").concat(transform.y / $82f622ad5caaffb5$var$d, "em)) ");
    else val += "translate(".concat(transform.x / $82f622ad5caaffb5$var$d, "em, ").concat(transform.y / $82f622ad5caaffb5$var$d, "em) ");
    val += "scale(".concat(transform.size / $82f622ad5caaffb5$var$d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $82f622ad5caaffb5$var$d * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $82f622ad5caaffb5$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 6 Solid\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 6 Regular\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 6 Light\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 6 Thin\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 6 Duotone\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 6 Sharp\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 6 Brands\";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}";
function $82f622ad5caaffb5$var$css() {
    var dcp = $82f622ad5caaffb5$var$DEFAULT_CSS_PREFIX;
    var drc = $82f622ad5caaffb5$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $82f622ad5caaffb5$var$config.cssPrefix;
    var rc = $82f622ad5caaffb5$var$config.replacementClass;
    var s = $82f622ad5caaffb5$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $82f622ad5caaffb5$var$_cssInserted = false;
function $82f622ad5caaffb5$var$ensureCss() {
    if ($82f622ad5caaffb5$var$config.autoAddCss && !$82f622ad5caaffb5$var$_cssInserted) {
        $82f622ad5caaffb5$var$insertCss($82f622ad5caaffb5$var$css());
        $82f622ad5caaffb5$var$_cssInserted = true;
    }
}
var $82f622ad5caaffb5$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $82f622ad5caaffb5$var$css,
                insertCss: $82f622ad5caaffb5$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $82f622ad5caaffb5$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $82f622ad5caaffb5$var$ensureCss();
            }
        };
    }
};
var $82f622ad5caaffb5$var$w = $82f622ad5caaffb5$var$WINDOW || {};
if (!$82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER]) $82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER] = {};
if (!$82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].styles) $82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].hooks) $82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].shims) $82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER].shims = [];
var $82f622ad5caaffb5$var$namespace = $82f622ad5caaffb5$var$w[$82f622ad5caaffb5$var$NAMESPACE_IDENTIFIER];
var $82f622ad5caaffb5$var$functions = [];
var $82f622ad5caaffb5$var$listener = function listener() {
    $82f622ad5caaffb5$var$DOCUMENT.removeEventListener('DOMContentLoaded', listener);
    $82f622ad5caaffb5$var$loaded = 1;
    $82f622ad5caaffb5$var$functions.map(function(fn) {
        return fn();
    });
};
var $82f622ad5caaffb5$var$loaded = false;
if ($82f622ad5caaffb5$var$IS_DOM) {
    $82f622ad5caaffb5$var$loaded = ($82f622ad5caaffb5$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($82f622ad5caaffb5$var$DOCUMENT.readyState);
    if (!$82f622ad5caaffb5$var$loaded) $82f622ad5caaffb5$var$DOCUMENT.addEventListener('DOMContentLoaded', $82f622ad5caaffb5$var$listener);
}
function $82f622ad5caaffb5$var$domready(fn) {
    if (!$82f622ad5caaffb5$var$IS_DOM) return;
    $82f622ad5caaffb5$var$loaded ? setTimeout(fn, 0) : $82f622ad5caaffb5$var$functions.push(fn);
}
function $82f622ad5caaffb5$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $82f622ad5caaffb5$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($82f622ad5caaffb5$var$joinAttributes(attributes), ">").concat(children.map($82f622ad5caaffb5$var$toHtml).join(''), "</").concat(tag, ">");
}
function $82f622ad5caaffb5$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $82f622ad5caaffb5$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $82f622ad5caaffb5$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $82f622ad5caaffb5$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * ucs2decode() and codePointAt() are both works of Mathias Bynens and licensed under MIT
 *
 * Copyright Mathias Bynens <https://mathiasbynens.be/>

 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:

 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ function $82f622ad5caaffb5$var$ucs2decode(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            var extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) // eslint-disable-line eqeqeq
            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
function $82f622ad5caaffb5$var$toHex(unicode) {
    var decoded = $82f622ad5caaffb5$var$ucs2decode(unicode);
    return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function $82f622ad5caaffb5$var$codePointAt(string, index) {
    var size = string.length;
    var first = string.charCodeAt(index);
    var second;
    if (first >= 0xD800 && first <= 0xDBFF && size > index + 1) {
        second = string.charCodeAt(index + 1);
        if (second >= 0xDC00 && second <= 0xDFFF) return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
    return first;
}
function $82f622ad5caaffb5$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $82f622ad5caaffb5$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $82f622ad5caaffb5$var$normalizeIcons(icons);
    if (typeof $82f622ad5caaffb5$var$namespace.hooks.addPack === 'function' && !skipHooks) $82f622ad5caaffb5$var$namespace.hooks.addPack(prefix, $82f622ad5caaffb5$var$normalizeIcons(icons));
    else $82f622ad5caaffb5$var$namespace.styles[prefix] = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $82f622ad5caaffb5$var$defineIcons('fa', icons);
}
var $82f622ad5caaffb5$var$duotonePathRe = [
    /*#__PURE__*/ $82f622ad5caaffb5$var$_wrapRegExp(/path d="((?:(?!")[\s\S])+)".*path d="((?:(?!")[\s\S])+)"/, {
        d1: 1,
        d2: 2
    }),
    /*#__PURE__*/ $82f622ad5caaffb5$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)".*path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2,
        cls2: 3,
        d2: 4
    }),
    /*#__PURE__*/ $82f622ad5caaffb5$var$_wrapRegExp(/path class="((?:(?!")[\s\S])+)".*d="((?:(?!")[\s\S])+)"/, {
        cls1: 1,
        d1: 2
    })
];
var $82f622ad5caaffb5$var$_LONG_STYLE, $82f622ad5caaffb5$var$_PREFIXES, $82f622ad5caaffb5$var$_PREFIXES_FOR_FAMILY;
var $82f622ad5caaffb5$var$styles = $82f622ad5caaffb5$var$namespace.styles, $82f622ad5caaffb5$var$shims = $82f622ad5caaffb5$var$namespace.shims;
var $82f622ad5caaffb5$var$LONG_STYLE = ($82f622ad5caaffb5$var$_LONG_STYLE = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_LONG_STYLE, $82f622ad5caaffb5$var$FAMILY_CLASSIC, Object.values($82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE[$82f622ad5caaffb5$var$FAMILY_CLASSIC])), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_LONG_STYLE, $82f622ad5caaffb5$var$FAMILY_SHARP, Object.values($82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE[$82f622ad5caaffb5$var$FAMILY_SHARP])), $82f622ad5caaffb5$var$_LONG_STYLE);
var $82f622ad5caaffb5$var$_defaultUsablePrefix = null;
var $82f622ad5caaffb5$var$_byUnicode = {};
var $82f622ad5caaffb5$var$_byLigature = {};
var $82f622ad5caaffb5$var$_byOldName = {};
var $82f622ad5caaffb5$var$_byOldUnicode = {};
var $82f622ad5caaffb5$var$_byAlias = {};
var $82f622ad5caaffb5$var$PREFIXES = ($82f622ad5caaffb5$var$_PREFIXES = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_PREFIXES, $82f622ad5caaffb5$var$FAMILY_CLASSIC, Object.keys($82f622ad5caaffb5$var$PREFIX_TO_STYLE[$82f622ad5caaffb5$var$FAMILY_CLASSIC])), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_PREFIXES, $82f622ad5caaffb5$var$FAMILY_SHARP, Object.keys($82f622ad5caaffb5$var$PREFIX_TO_STYLE[$82f622ad5caaffb5$var$FAMILY_SHARP])), $82f622ad5caaffb5$var$_PREFIXES);
function $82f622ad5caaffb5$var$isReserved(name) {
    return ~$82f622ad5caaffb5$var$RESERVED_CLASSES.indexOf(name);
}
function $82f622ad5caaffb5$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$82f622ad5caaffb5$var$isReserved(iconName)) return iconName;
    else return null;
}
var $82f622ad5caaffb5$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $82f622ad5caaffb5$var$reduce($82f622ad5caaffb5$var$styles, function(o, style, prefix) {
            o[prefix] = $82f622ad5caaffb5$var$reduce(style, reducer, {});
            return o;
        }, {});
    };
    $82f622ad5caaffb5$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $82f622ad5caaffb5$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a) {
                return typeof a === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $82f622ad5caaffb5$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    }); // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $82f622ad5caaffb5$var$styles || $82f622ad5caaffb5$var$config.autoFetchSvg;
    var shimLookups = $82f622ad5caaffb5$var$reduce($82f622ad5caaffb5$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $82f622ad5caaffb5$var$_byOldName = shimLookups.names;
    $82f622ad5caaffb5$var$_byOldUnicode = shimLookups.unicodes;
    $82f622ad5caaffb5$var$_defaultUsablePrefix = $82f622ad5caaffb5$var$getCanonicalPrefix($82f622ad5caaffb5$var$config.styleDefault, {
        family: $82f622ad5caaffb5$var$config.familyDefault
    });
};
$82f622ad5caaffb5$var$onChange(function(c) {
    $82f622ad5caaffb5$var$_defaultUsablePrefix = $82f622ad5caaffb5$var$getCanonicalPrefix(c.styleDefault, {
        family: $82f622ad5caaffb5$var$config.familyDefault
    });
});
$82f622ad5caaffb5$var$build();
function $82f622ad5caaffb5$var$byUnicode(prefix, unicode) {
    return ($82f622ad5caaffb5$var$_byUnicode[prefix] || {})[unicode];
}
function $82f622ad5caaffb5$var$byLigature(prefix, ligature) {
    return ($82f622ad5caaffb5$var$_byLigature[prefix] || {})[ligature];
}
function $82f622ad5caaffb5$var$byAlias(prefix, alias) {
    return ($82f622ad5caaffb5$var$_byAlias[prefix] || {})[alias];
}
function $82f622ad5caaffb5$var$byOldName(name) {
    return $82f622ad5caaffb5$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $82f622ad5caaffb5$var$byOldUnicode(unicode) {
    var oldUnicode = $82f622ad5caaffb5$var$_byOldUnicode[unicode];
    var newUnicode = $82f622ad5caaffb5$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $82f622ad5caaffb5$var$getDefaultUsablePrefix() {
    return $82f622ad5caaffb5$var$_defaultUsablePrefix;
}
var $82f622ad5caaffb5$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $82f622ad5caaffb5$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $82f622ad5caaffb5$var$FAMILY_CLASSIC : _params$family;
    var style = $82f622ad5caaffb5$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    var prefix = $82f622ad5caaffb5$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $82f622ad5caaffb5$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $82f622ad5caaffb5$var$namespace.styles ? styleOrPrefix : null;
    return prefix || defined || null;
}
var $82f622ad5caaffb5$var$PREFIXES_FOR_FAMILY = ($82f622ad5caaffb5$var$_PREFIXES_FOR_FAMILY = {}, $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_PREFIXES_FOR_FAMILY, $82f622ad5caaffb5$var$FAMILY_CLASSIC, Object.keys($82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE[$82f622ad5caaffb5$var$FAMILY_CLASSIC])), $82f622ad5caaffb5$var$_defineProperty($82f622ad5caaffb5$var$_PREFIXES_FOR_FAMILY, $82f622ad5caaffb5$var$FAMILY_SHARP, Object.keys($82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE[$82f622ad5caaffb5$var$FAMILY_SHARP])), $82f622ad5caaffb5$var$_PREFIXES_FOR_FAMILY);
function $82f622ad5caaffb5$var$getCanonicalIcon(values) {
    var _famProps;
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var famProps = (_famProps = {}, $82f622ad5caaffb5$var$_defineProperty(_famProps, $82f622ad5caaffb5$var$FAMILY_CLASSIC, "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat($82f622ad5caaffb5$var$FAMILY_CLASSIC)), $82f622ad5caaffb5$var$_defineProperty(_famProps, $82f622ad5caaffb5$var$FAMILY_SHARP, "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat($82f622ad5caaffb5$var$FAMILY_SHARP)), _famProps);
    var givenPrefix = null;
    var family = $82f622ad5caaffb5$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$82f622ad5caaffb5$var$FAMILY_CLASSIC]) || values.some(function(v) {
        return $82f622ad5caaffb5$var$PREFIXES_FOR_FAMILY[$82f622ad5caaffb5$var$FAMILY_CLASSIC].includes(v);
    })) family = $82f622ad5caaffb5$var$FAMILY_CLASSIC;
    if (values.includes(famProps[$82f622ad5caaffb5$var$FAMILY_SHARP]) || values.some(function(v) {
        return $82f622ad5caaffb5$var$PREFIXES_FOR_FAMILY[$82f622ad5caaffb5$var$FAMILY_SHARP].includes(v);
    })) family = $82f622ad5caaffb5$var$FAMILY_SHARP;
    var canonical = values.reduce(function(acc, cls) {
        var iconName = $82f622ad5caaffb5$var$getIconName($82f622ad5caaffb5$var$config.cssPrefix, cls);
        if ($82f622ad5caaffb5$var$styles[cls]) {
            cls = $82f622ad5caaffb5$var$LONG_STYLE[family].includes(cls) ? $82f622ad5caaffb5$var$LONG_STYLE_TO_PREFIX[family][cls] : cls;
            givenPrefix = cls;
            acc.prefix = cls;
        } else if ($82f622ad5caaffb5$var$PREFIXES[family].indexOf(cls) > -1) {
            givenPrefix = cls;
            acc.prefix = $82f622ad5caaffb5$var$getCanonicalPrefix(cls, {
                family: family
            });
        } else if (iconName) acc.iconName = iconName;
        else if (cls !== $82f622ad5caaffb5$var$config.replacementClass && cls !== famProps[$82f622ad5caaffb5$var$FAMILY_CLASSIC] && cls !== famProps[$82f622ad5caaffb5$var$FAMILY_SHARP]) acc.rest.push(cls);
        if (!skipLookups && acc.prefix && acc.iconName) {
            var shim = givenPrefix === 'fa' ? $82f622ad5caaffb5$var$byOldName(acc.iconName) : {};
            var aliasIconName = $82f622ad5caaffb5$var$byAlias(acc.prefix, acc.iconName);
            if (shim.prefix) givenPrefix = null;
            acc.iconName = shim.iconName || aliasIconName || acc.iconName;
            acc.prefix = shim.prefix || acc.prefix;
            if (acc.prefix === 'far' && !$82f622ad5caaffb5$var$styles['far'] && $82f622ad5caaffb5$var$styles['fas'] && !$82f622ad5caaffb5$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
            // but only if we aren't auto-fetching SVGs
            acc.prefix = 'fas';
        }
        return acc;
    }, $82f622ad5caaffb5$var$emptyCanonicalIcon());
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (values.includes('fa-duotone') || values.includes('fad')) canonical.prefix = 'fad';
    if (!canonical.prefix && family === $82f622ad5caaffb5$var$FAMILY_SHARP && ($82f622ad5caaffb5$var$styles['fass'] || $82f622ad5caaffb5$var$config.autoFetchSvg)) {
        canonical.prefix = 'fass';
        canonical.iconName = $82f622ad5caaffb5$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $82f622ad5caaffb5$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $82f622ad5caaffb5$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    $82f622ad5caaffb5$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $82f622ad5caaffb5$var$defineIcons(key, additions[key]); // TODO can we stop doing this? We can't get the icons by 'fa-solid' any longer so this probably needs to change
                    var longPrefix = $82f622ad5caaffb5$var$PREFIX_TO_LONG_STYLE[$82f622ad5caaffb5$var$FAMILY_CLASSIC][key];
                    if (longPrefix) $82f622ad5caaffb5$var$defineIcons(longPrefix, additions[key]);
                    $82f622ad5caaffb5$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
    return Library;
}();
var $82f622ad5caaffb5$var$_plugins = [];
var $82f622ad5caaffb5$var$_hooks = {};
var $82f622ad5caaffb5$var$providers = {};
var $82f622ad5caaffb5$var$defaultProviderKeys = Object.keys($82f622ad5caaffb5$var$providers);
function $82f622ad5caaffb5$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $82f622ad5caaffb5$var$_plugins = nextPlugins;
    $82f622ad5caaffb5$var$_hooks = {};
    Object.keys($82f622ad5caaffb5$var$providers).forEach(function(k) {
        if ($82f622ad5caaffb5$var$defaultProviderKeys.indexOf(k) === -1) delete $82f622ad5caaffb5$var$providers[k];
    });
    $82f622ad5caaffb5$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($82f622ad5caaffb5$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$82f622ad5caaffb5$var$_hooks[hook]) $82f622ad5caaffb5$var$_hooks[hook] = [];
                $82f622ad5caaffb5$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($82f622ad5caaffb5$var$providers);
    });
    return obj;
}
function $82f622ad5caaffb5$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $82f622ad5caaffb5$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args)); // eslint-disable-line no-useless-call
    });
    return accumulator;
}
function $82f622ad5caaffb5$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $82f622ad5caaffb5$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $82f622ad5caaffb5$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $82f622ad5caaffb5$var$providers[hook] ? $82f622ad5caaffb5$var$providers[hook].apply(null, args) : undefined;
}
function $82f622ad5caaffb5$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $82f622ad5caaffb5$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $82f622ad5caaffb5$var$byAlias(prefix, iconName) || iconName;
    return $82f622ad5caaffb5$var$iconFromMapping($82f622ad5caaffb5$var$library.definitions, prefix, iconName) || $82f622ad5caaffb5$var$iconFromMapping($82f622ad5caaffb5$var$namespace.styles, prefix, iconName);
}
var $82f622ad5caaffb5$var$library = new $82f622ad5caaffb5$var$Library();
var $82f622ad5caaffb5$var$noAuto = function noAuto() {
    $82f622ad5caaffb5$var$config.autoReplaceSvg = false;
    $82f622ad5caaffb5$var$config.observeMutations = false;
    $82f622ad5caaffb5$var$callHooks('noAuto');
};
var $82f622ad5caaffb5$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($82f622ad5caaffb5$var$IS_DOM) {
            $82f622ad5caaffb5$var$callHooks('beforeI2svg', params);
            $82f622ad5caaffb5$var$callProvided('pseudoElements2svg', params);
            return $82f622ad5caaffb5$var$callProvided('i2svg', params);
        } else return Promise.reject('Operation requires a DOM of some kind.');
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($82f622ad5caaffb5$var$config.autoReplaceSvg === false) $82f622ad5caaffb5$var$config.autoReplaceSvg = true;
        $82f622ad5caaffb5$var$config.observeMutations = true;
        $82f622ad5caaffb5$var$domready(function() {
            $82f622ad5caaffb5$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $82f622ad5caaffb5$var$callHooks('watch', params);
        });
    }
};
var $82f622ad5caaffb5$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($82f622ad5caaffb5$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $82f622ad5caaffb5$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $82f622ad5caaffb5$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $82f622ad5caaffb5$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($82f622ad5caaffb5$var$config.cssPrefix, "-")) > -1 || _icon.match($82f622ad5caaffb5$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $82f622ad5caaffb5$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $82f622ad5caaffb5$var$getDefaultUsablePrefix(),
                iconName: $82f622ad5caaffb5$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $82f622ad5caaffb5$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $82f622ad5caaffb5$export$644d8ea042df96a6 = {
    noAuto: $82f622ad5caaffb5$var$noAuto,
    config: $82f622ad5caaffb5$var$config,
    dom: $82f622ad5caaffb5$var$dom,
    parse: $82f622ad5caaffb5$var$parse,
    library: $82f622ad5caaffb5$var$library,
    findIconDefinition: $82f622ad5caaffb5$var$findIconDefinition,
    toHtml: $82f622ad5caaffb5$var$toHtml
};
var $82f622ad5caaffb5$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $82f622ad5caaffb5$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($82f622ad5caaffb5$var$namespace.styles).length > 0 || $82f622ad5caaffb5$var$config.autoFetchSvg) && $82f622ad5caaffb5$var$IS_DOM && $82f622ad5caaffb5$var$config.autoReplaceSvg) $82f622ad5caaffb5$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $82f622ad5caaffb5$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $82f622ad5caaffb5$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$82f622ad5caaffb5$var$IS_DOM) return;
            var container = $82f622ad5caaffb5$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $82f622ad5caaffb5$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($82f622ad5caaffb5$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $82f622ad5caaffb5$var$joinStyles($82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $82f622ad5caaffb5$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
function $82f622ad5caaffb5$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var isUploadedIcon = prefix === 'fak';
    var attrClass = [
        $82f622ad5caaffb5$var$config.replacementClass,
        iconName ? "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'xmlns': 'http://www.w3.org/2000/svg',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf('fa-fw') ? {
        width: "".concat(width / height * 1, "em")
    } : {};
    if (watchable) content.attributes[$82f622ad5caaffb5$var$DATA_FA_I2SVG] = '';
    if (title) {
        content.children.push({
            tag: 'title',
            attributes: {
                id: content.attributes['aria-labelledby'] || "title-".concat(titleId || $82f622ad5caaffb5$var$nextUniqueId())
            },
            children: [
                title
            ]
        });
        delete content.attributes.title;
    }
    var args = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, uploadedIconWidthStyle), extra.styles)
    });
    var _ref2 = mask.found && main.found ? $82f622ad5caaffb5$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $82f622ad5caaffb5$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $82f622ad5caaffb5$var$asSymbol(args);
    else return $82f622ad5caaffb5$var$asIcon(args);
}
function $82f622ad5caaffb5$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    if (watchable) attributes[$82f622ad5caaffb5$var$DATA_FA_I2SVG] = '';
    var styles = $82f622ad5caaffb5$var$_objectSpread2({}, extra.styles);
    if ($82f622ad5caaffb5$var$transformIsMeaningful(transform)) {
        styles['transform'] = $82f622ad5caaffb5$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $82f622ad5caaffb5$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
function $82f622ad5caaffb5$var$makeLayersCounterAbstract(params) {
    var content = params.content, title = params.title, extra = params.extra;
    var attributes = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, extra.attributes), title ? {
        'title': title
    } : {}), {}, {
        'class': extra.classes.join(' ')
    });
    var styleString = $82f622ad5caaffb5$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    if (title) val.push({
        tag: 'span',
        attributes: {
            class: 'sr-only'
        },
        children: [
            title
        ]
    });
    return val;
}
var $82f622ad5caaffb5$var$styles$1 = $82f622ad5caaffb5$var$namespace.styles;
function $82f622ad5caaffb5$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $82f622ad5caaffb5$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat($82f622ad5caaffb5$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat($82f622ad5caaffb5$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-").concat($82f622ad5caaffb5$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $82f622ad5caaffb5$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $82f622ad5caaffb5$var$maybeNotifyMissing(iconName, prefix) {
    if (!$82f622ad5caaffb5$var$PRODUCTION && !$82f622ad5caaffb5$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $82f622ad5caaffb5$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $82f622ad5caaffb5$var$config.styleDefault !== null) prefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        var val = {
            found: false,
            width: 512,
            height: 512,
            icon: $82f622ad5caaffb5$var$callProvided('missingIconAbstract') || {}
        };
        if (givenPrefix === 'fa') {
            var shim = $82f622ad5caaffb5$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $82f622ad5caaffb5$var$styles$1[prefix] && $82f622ad5caaffb5$var$styles$1[prefix][iconName]) {
            var icon = $82f622ad5caaffb5$var$styles$1[prefix][iconName];
            return resolve($82f622ad5caaffb5$var$asFoundIcon(icon));
        }
        $82f622ad5caaffb5$var$maybeNotifyMissing(iconName, prefix);
        resolve($82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$missingIconResolutionMixin), {}, {
            icon: $82f622ad5caaffb5$var$config.showMissingIcons && iconName ? $82f622ad5caaffb5$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $82f622ad5caaffb5$var$noop$1 = function noop() {};
var $82f622ad5caaffb5$var$p = $82f622ad5caaffb5$var$config.measurePerformance && $82f622ad5caaffb5$var$PERFORMANCE && $82f622ad5caaffb5$var$PERFORMANCE.mark && $82f622ad5caaffb5$var$PERFORMANCE.measure ? $82f622ad5caaffb5$var$PERFORMANCE : {
    mark: $82f622ad5caaffb5$var$noop$1,
    measure: $82f622ad5caaffb5$var$noop$1
};
var $82f622ad5caaffb5$var$preamble = "FA \"6.5.1\"";
var $82f622ad5caaffb5$var$begin = function begin(name) {
    $82f622ad5caaffb5$var$p.mark("".concat($82f622ad5caaffb5$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $82f622ad5caaffb5$var$end(name);
    };
};
var $82f622ad5caaffb5$var$end = function end(name) {
    $82f622ad5caaffb5$var$p.mark("".concat($82f622ad5caaffb5$var$preamble, " ").concat(name, " ends"));
    $82f622ad5caaffb5$var$p.measure("".concat($82f622ad5caaffb5$var$preamble, " ").concat(name), "".concat($82f622ad5caaffb5$var$preamble, " ").concat(name, " begins"), "".concat($82f622ad5caaffb5$var$preamble, " ").concat(name, " ends"));
};
var $82f622ad5caaffb5$var$perf = {
    begin: $82f622ad5caaffb5$var$begin,
    end: $82f622ad5caaffb5$var$end
};
var $82f622ad5caaffb5$var$noop$2 = function noop() {};
function $82f622ad5caaffb5$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($82f622ad5caaffb5$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $82f622ad5caaffb5$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($82f622ad5caaffb5$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($82f622ad5caaffb5$var$DATA_ICON) : null;
    return prefix && icon;
}
function $82f622ad5caaffb5$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($82f622ad5caaffb5$var$config.replacementClass);
}
function $82f622ad5caaffb5$var$getMutator() {
    if ($82f622ad5caaffb5$var$config.autoReplaceSvg === true) return $82f622ad5caaffb5$var$mutators.replace;
    var mutator = $82f622ad5caaffb5$var$mutators[$82f622ad5caaffb5$var$config.autoReplaceSvg];
    return mutator || $82f622ad5caaffb5$var$mutators.replace;
}
function $82f622ad5caaffb5$var$createElementNS(tag) {
    return $82f622ad5caaffb5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $82f622ad5caaffb5$var$createElement(tag) {
    return $82f622ad5caaffb5$var$DOCUMENT.createElement(tag);
}
function $82f622ad5caaffb5$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $82f622ad5caaffb5$var$createElementNS : $82f622ad5caaffb5$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $82f622ad5caaffb5$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($82f622ad5caaffb5$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $82f622ad5caaffb5$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $82f622ad5caaffb5$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(_abstract) {
                node.parentNode.insertBefore($82f622ad5caaffb5$var$convertSVG(_abstract), node);
            });
            if (node.getAttribute($82f622ad5caaffb5$var$DATA_FA_I2SVG) === null && $82f622ad5caaffb5$var$config.keepOriginalSource) {
                var comment = $82f622ad5caaffb5$var$DOCUMENT.createComment($82f622ad5caaffb5$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var _abstract2 = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$82f622ad5caaffb5$var$classArray(node).indexOf($82f622ad5caaffb5$var$config.replacementClass)) return $82f622ad5caaffb5$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($82f622ad5caaffb5$var$config.cssPrefix, "-.*"));
        delete _abstract2[0].attributes.id;
        if (_abstract2[0].attributes.class) {
            var splitClasses = _abstract2[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $82f622ad5caaffb5$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            _abstract2[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = _abstract2.map(function(a) {
            return $82f622ad5caaffb5$var$toHtml(a);
        }).join('\n');
        node.setAttribute($82f622ad5caaffb5$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $82f622ad5caaffb5$var$performOperationSync(op) {
    op();
}
function $82f622ad5caaffb5$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $82f622ad5caaffb5$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $82f622ad5caaffb5$var$performOperationSync;
        if ($82f622ad5caaffb5$var$config.mutateApproach === $82f622ad5caaffb5$var$MUTATION_APPROACH_ASYNC) frame = $82f622ad5caaffb5$var$WINDOW.requestAnimationFrame || $82f622ad5caaffb5$var$performOperationSync;
        frame(function() {
            var mutator = $82f622ad5caaffb5$var$getMutator();
            var mark = $82f622ad5caaffb5$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $82f622ad5caaffb5$var$disabled = false;
function $82f622ad5caaffb5$var$disableObservation() {
    $82f622ad5caaffb5$var$disabled = true;
}
function $82f622ad5caaffb5$var$enableObservation() {
    $82f622ad5caaffb5$var$disabled = false;
}
var $82f622ad5caaffb5$var$mo = null;
function $82f622ad5caaffb5$var$observe(options) {
    if (!$82f622ad5caaffb5$var$MUTATION_OBSERVER) return;
    if (!$82f622ad5caaffb5$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $82f622ad5caaffb5$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $82f622ad5caaffb5$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $82f622ad5caaffb5$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $82f622ad5caaffb5$var$DOCUMENT : _options$observeMutat;
    $82f622ad5caaffb5$var$mo = new $82f622ad5caaffb5$var$MUTATION_OBSERVER(function(objects) {
        if ($82f622ad5caaffb5$var$disabled) return;
        var defaultPrefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix();
        $82f622ad5caaffb5$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$82f622ad5caaffb5$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($82f622ad5caaffb5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $82f622ad5caaffb5$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
            if (mutationRecord.type === 'attributes' && $82f622ad5caaffb5$var$isWatched(mutationRecord.target) && ~$82f622ad5caaffb5$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $82f622ad5caaffb5$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $82f622ad5caaffb5$var$getCanonicalIcon($82f622ad5caaffb5$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($82f622ad5caaffb5$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($82f622ad5caaffb5$var$DATA_ICON, iconName);
                } else if ($82f622ad5caaffb5$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$82f622ad5caaffb5$var$IS_DOM) return;
    $82f622ad5caaffb5$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $82f622ad5caaffb5$var$disconnect() {
    if (!$82f622ad5caaffb5$var$mo) return;
    $82f622ad5caaffb5$var$mo.disconnect();
}
function $82f622ad5caaffb5$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $82f622ad5caaffb5$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $82f622ad5caaffb5$var$getCanonicalIcon($82f622ad5caaffb5$var$classArray(node));
    if (!val.prefix) val.prefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $82f622ad5caaffb5$var$byLigature(val.prefix, node.innerText) || $82f622ad5caaffb5$var$byUnicode(val.prefix, $82f622ad5caaffb5$var$toHex(node.innerText));
    if (!val.iconName && $82f622ad5caaffb5$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $82f622ad5caaffb5$var$attributesParser(node) {
    var extraAttributes = $82f622ad5caaffb5$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    var title = node.getAttribute('title');
    var titleId = node.getAttribute('data-fa-title-id');
    if ($82f622ad5caaffb5$var$config.autoA11y) {
        if (title) extraAttributes['aria-labelledby'] = "".concat($82f622ad5caaffb5$var$config.replacementClass, "-title-").concat(titleId || $82f622ad5caaffb5$var$nextUniqueId());
        else {
            extraAttributes['aria-hidden'] = 'true';
            extraAttributes['focusable'] = 'false';
        }
    }
    return extraAttributes;
}
function $82f622ad5caaffb5$var$blankMeta() {
    return {
        iconName: null,
        title: null,
        titleId: null,
        prefix: null,
        transform: $82f622ad5caaffb5$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $82f622ad5caaffb5$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $82f622ad5caaffb5$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $82f622ad5caaffb5$var$attributesParser(node);
    var pluginMeta = $82f622ad5caaffb5$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $82f622ad5caaffb5$var$styleParser(node) : [];
    return $82f622ad5caaffb5$var$_objectSpread2({
        iconName: iconName,
        title: node.getAttribute('title'),
        titleId: node.getAttribute('data-fa-title-id'),
        prefix: prefix,
        transform: $82f622ad5caaffb5$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $82f622ad5caaffb5$var$styles$2 = $82f622ad5caaffb5$var$namespace.styles;
function $82f622ad5caaffb5$var$generateMutation(node) {
    var nodeMeta = $82f622ad5caaffb5$var$config.autoReplaceSvg === 'nest' ? $82f622ad5caaffb5$var$parseMeta(node, {
        styleParser: false
    }) : $82f622ad5caaffb5$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($82f622ad5caaffb5$var$LAYERS_TEXT_CLASSNAME)) return $82f622ad5caaffb5$var$callProvided('generateLayersText', node, nodeMeta);
    else return $82f622ad5caaffb5$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
var $82f622ad5caaffb5$var$knownPrefixes = new Set();
$82f622ad5caaffb5$var$FAMILIES.map(function(family) {
    $82f622ad5caaffb5$var$knownPrefixes.add("fa-".concat(family));
});
Object.keys($82f622ad5caaffb5$var$PREFIX_TO_STYLE[$82f622ad5caaffb5$var$FAMILY_CLASSIC]).map($82f622ad5caaffb5$var$knownPrefixes.add.bind($82f622ad5caaffb5$var$knownPrefixes));
Object.keys($82f622ad5caaffb5$var$PREFIX_TO_STYLE[$82f622ad5caaffb5$var$FAMILY_SHARP]).map($82f622ad5caaffb5$var$knownPrefixes.add.bind($82f622ad5caaffb5$var$knownPrefixes));
$82f622ad5caaffb5$var$knownPrefixes = $82f622ad5caaffb5$var$_toConsumableArray($82f622ad5caaffb5$var$knownPrefixes);
function $82f622ad5caaffb5$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$82f622ad5caaffb5$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $82f622ad5caaffb5$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($82f622ad5caaffb5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($82f622ad5caaffb5$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $82f622ad5caaffb5$var$config.autoFetchSvg ? $82f622ad5caaffb5$var$knownPrefixes : $82f622ad5caaffb5$var$FAMILIES.map(function(f) {
        return "fa-".concat(f);
    }).concat(Object.keys($82f622ad5caaffb5$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($82f622ad5caaffb5$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($82f622ad5caaffb5$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p) {
        return ".".concat(p, ":not([").concat($82f622ad5caaffb5$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $82f622ad5caaffb5$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e) {}
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $82f622ad5caaffb5$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $82f622ad5caaffb5$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e) {
            if (!$82f622ad5caaffb5$var$PRODUCTION) {
                if (e.name === 'MissingIcon') console.error(e);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $82f622ad5caaffb5$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e) {
            mark();
            reject(e);
        });
    });
}
function $82f622ad5caaffb5$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $82f622ad5caaffb5$var$generateMutation(node).then(function(mutation) {
        if (mutation) $82f622ad5caaffb5$var$perform([
            mutation
        ], callback);
    });
}
function $82f622ad5caaffb5$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $82f622ad5caaffb5$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $82f622ad5caaffb5$var$findIconDefinition(mask || {});
        return next(iconDefinition, $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $82f622ad5caaffb5$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $82f622ad5caaffb5$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $82f622ad5caaffb5$var$domVariants($82f622ad5caaffb5$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $82f622ad5caaffb5$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        if ($82f622ad5caaffb5$var$config.autoA11y) {
            if (title) attributes['aria-labelledby'] = "".concat($82f622ad5caaffb5$var$config.replacementClass, "-title-").concat(titleId || $82f622ad5caaffb5$var$nextUniqueId());
            else {
                attributes['aria-hidden'] = 'true';
                attributes['focusable'] = 'false';
            }
        }
        return $82f622ad5caaffb5$var$makeInlineSvgAbstract({
            icons: {
                main: $82f622ad5caaffb5$var$asFoundIcon(icon),
                mask: mask ? $82f622ad5caaffb5$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$meaninglessTransform), transform),
            symbol: symbol,
            title: title,
            maskId: maskId,
            titleId: titleId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $82f622ad5caaffb5$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $82f622ad5caaffb5$var$resolveIcons($82f622ad5caaffb5$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $82f622ad5caaffb5$var$onTree;
                accumulator.nodeCallback = $82f622ad5caaffb5$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $82f622ad5caaffb5$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $82f622ad5caaffb5$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $82f622ad5caaffb5$var$findIcon(iconName, prefix),
                    mask.iconName ? $82f622ad5caaffb5$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $82f622ad5caaffb5$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $82f622ad5caaffb5$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            title: title,
                            titleId: titleId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $82f622ad5caaffb5$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($82f622ad5caaffb5$var$transformIsMeaningful(transform)) nextChild = $82f622ad5caaffb5$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $82f622ad5caaffb5$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $82f622ad5caaffb5$var$domVariants({
                    type: 'layer'
                }, function() {
                    $82f622ad5caaffb5$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-layers")
                                ].concat($82f622ad5caaffb5$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $82f622ad5caaffb5$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $82f622ad5caaffb5$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $82f622ad5caaffb5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $82f622ad5caaffb5$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-layers-counter")
                            ].concat($82f622ad5caaffb5$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $82f622ad5caaffb5$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $82f622ad5caaffb5$var$meaninglessTransform : _params$transform, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $82f622ad5caaffb5$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $82f622ad5caaffb5$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $82f622ad5caaffb5$var$makeLayersTextAbstract({
                        content: content,
                        transform: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$meaninglessTransform), transform),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($82f622ad5caaffb5$var$config.cssPrefix, "-layers-text")
                            ].concat($82f622ad5caaffb5$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($82f622ad5caaffb5$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            if ($82f622ad5caaffb5$var$config.autoA11y && !title) extra.attributes['aria-hidden'] = 'true';
            return Promise.resolve([
                node,
                $82f622ad5caaffb5$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    title: title,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $82f622ad5caaffb5$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $82f622ad5caaffb5$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
function $82f622ad5caaffb5$var$hexValueFromContent(content) {
    var cleaned = content.replace($82f622ad5caaffb5$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = $82f622ad5caaffb5$var$codePointAt(cleaned, 0);
    var isPrependTen = codePoint >= $82f622ad5caaffb5$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $82f622ad5caaffb5$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return {
        value: isDoubled ? $82f622ad5caaffb5$var$toHex(cleaned[0]) : $82f622ad5caaffb5$var$toHex(cleaned),
        isSecondary: isPrependTen || isDoubled
    };
}
function $82f622ad5caaffb5$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $82f622ad5caaffb5$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c) {
            return c.getAttribute($82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $82f622ad5caaffb5$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family').match($82f622ad5caaffb5$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamily) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamily && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var family = ~[
                'Sharp'
            ].indexOf(fontFamily[2]) ? $82f622ad5caaffb5$var$FAMILY_SHARP : $82f622ad5caaffb5$var$FAMILY_CLASSIC;
            var prefix = ~[
                'Solid',
                'Regular',
                'Light',
                'Thin',
                'Duotone',
                'Brands',
                'Kit'
            ].indexOf(fontFamily[2]) ? $82f622ad5caaffb5$var$STYLE_TO_PREFIX[family][fontFamily[2].toLowerCase()] : $82f622ad5caaffb5$var$FONT_WEIGHT_TO_PREFIX[family][fontWeight];
            var _hexValueFromContent = $82f622ad5caaffb5$var$hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
            var isV4 = fontFamily[0].startsWith('FontAwesome');
            var iconName = $82f622ad5caaffb5$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $82f622ad5caaffb5$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            } // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($82f622ad5caaffb5$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($82f622ad5caaffb5$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $82f622ad5caaffb5$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $82f622ad5caaffb5$var$findIcon(iconName, prefix).then(function(main) {
                    var _abstract = $82f622ad5caaffb5$var$makeInlineSvgAbstract($82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $82f622ad5caaffb5$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $82f622ad5caaffb5$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = _abstract.map(function(a) {
                        return $82f622ad5caaffb5$var$toHtml(a);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $82f622ad5caaffb5$var$replace(node) {
    return Promise.all([
        $82f622ad5caaffb5$var$replaceForPosition(node, '::before'),
        $82f622ad5caaffb5$var$replaceForPosition(node, '::after')
    ]);
}
function $82f622ad5caaffb5$var$processable(node) {
    return node.parentNode !== document.head && !~$82f622ad5caaffb5$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($82f622ad5caaffb5$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
function $82f622ad5caaffb5$var$searchPseudoElements(root) {
    if (!$82f622ad5caaffb5$var$IS_DOM) return;
    return new Promise(function(resolve, reject) {
        var operations = $82f622ad5caaffb5$var$toArray(root.querySelectorAll('*')).filter($82f622ad5caaffb5$var$processable).map($82f622ad5caaffb5$var$replace);
        var end = $82f622ad5caaffb5$var$perf.begin('searchPseudoElements');
        $82f622ad5caaffb5$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $82f622ad5caaffb5$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $82f622ad5caaffb5$var$enableObservation();
            reject();
        });
    });
}
var $82f622ad5caaffb5$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $82f622ad5caaffb5$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $82f622ad5caaffb5$var$DOCUMENT : _params$node;
            if ($82f622ad5caaffb5$var$config.searchPseudoElements) $82f622ad5caaffb5$var$searchPseudoElements(node);
        };
    }
};
var $82f622ad5caaffb5$var$_unwatched = false;
var $82f622ad5caaffb5$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $82f622ad5caaffb5$var$disableObservation();
                    $82f622ad5caaffb5$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $82f622ad5caaffb5$var$observe($82f622ad5caaffb5$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $82f622ad5caaffb5$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($82f622ad5caaffb5$var$_unwatched) $82f622ad5caaffb5$var$enableObservation();
                else $82f622ad5caaffb5$var$observe($82f622ad5caaffb5$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $82f622ad5caaffb5$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $82f622ad5caaffb5$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $82f622ad5caaffb5$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $82f622ad5caaffb5$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $82f622ad5caaffb5$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $82f622ad5caaffb5$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $82f622ad5caaffb5$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $82f622ad5caaffb5$var$fillBlack(_abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (_abstract.attributes && (_abstract.attributes.fill || force)) _abstract.attributes.fill = 'black';
    return _abstract;
}
function $82f622ad5caaffb5$var$deGroup(_abstract2) {
    if (_abstract2.tag === 'g') return _abstract2.children;
    else return [
        _abstract2
    ];
}
var $82f622ad5caaffb5$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $82f622ad5caaffb5$var$emptyCanonicalIcon() : $82f622ad5caaffb5$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $82f622ad5caaffb5$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $82f622ad5caaffb5$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($82f622ad5caaffb5$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $82f622ad5caaffb5$var$_objectSpread2({}, trans.inner),
                children: [
                    $82f622ad5caaffb5$var$fillBlack($82f622ad5caaffb5$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $82f622ad5caaffb5$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $82f622ad5caaffb5$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $82f622ad5caaffb5$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, $82f622ad5caaffb5$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $82f622ad5caaffb5$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $82f622ad5caaffb5$var$_objectSpread2({
                    fill: 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    mask: "url(#".concat(maskId, ")")
                }, $82f622ad5caaffb5$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $82f622ad5caaffb5$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($82f622ad5caaffb5$var$WINDOW.matchMedia) reduceMotion = $82f622ad5caaffb5$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            }; // Ring
            gChildren.push({
                tag: 'path',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $82f622ad5caaffb5$var$_objectSpread2($82f622ad5caaffb5$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    'class': 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $82f622ad5caaffb5$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $82f622ad5caaffb5$var$plugins = [
    $82f622ad5caaffb5$var$InjectCSS,
    $82f622ad5caaffb5$var$ReplaceElements,
    $82f622ad5caaffb5$var$Layers,
    $82f622ad5caaffb5$var$LayersCounter,
    $82f622ad5caaffb5$var$LayersText,
    $82f622ad5caaffb5$var$PseudoElements,
    $82f622ad5caaffb5$var$MutationObserver$1,
    $82f622ad5caaffb5$var$PowerTransforms,
    $82f622ad5caaffb5$var$Masks,
    $82f622ad5caaffb5$var$MissingIconIndicator,
    $82f622ad5caaffb5$var$SvgSymbols
];
$82f622ad5caaffb5$var$registerPlugins($82f622ad5caaffb5$var$plugins, {
    mixoutsTo: $82f622ad5caaffb5$export$644d8ea042df96a6
});
var $82f622ad5caaffb5$export$4f8e844b2782642c = $82f622ad5caaffb5$export$644d8ea042df96a6.noAuto;
var $82f622ad5caaffb5$export$e506a1d27d1eaa20 = $82f622ad5caaffb5$export$644d8ea042df96a6.config;
var $82f622ad5caaffb5$export$b839f963c7dc0e34 = $82f622ad5caaffb5$export$644d8ea042df96a6.library;
var $82f622ad5caaffb5$export$df3a06d6289f983e = $82f622ad5caaffb5$export$644d8ea042df96a6.dom;
var $82f622ad5caaffb5$export$98e6a39c04603d36 = $82f622ad5caaffb5$export$644d8ea042df96a6.parse;
var $82f622ad5caaffb5$export$221fed4a47f597a5 = $82f622ad5caaffb5$export$644d8ea042df96a6.findIconDefinition;
var $82f622ad5caaffb5$export$a10125c086a4df16 = $82f622ad5caaffb5$export$644d8ea042df96a6.toHtml;
var $82f622ad5caaffb5$export$1ca1ec8b29a4ce27 = $82f622ad5caaffb5$export$644d8ea042df96a6.icon;
var $82f622ad5caaffb5$export$50a222d9023da98b = $82f622ad5caaffb5$export$644d8ea042df96a6.layer;
var $82f622ad5caaffb5$export$6f093cfa640b7166 = $82f622ad5caaffb5$export$644d8ea042df96a6.text;
var $82f622ad5caaffb5$export$e575061ef2a070eb = $82f622ad5caaffb5$export$644d8ea042df96a6.counter;




var $9C0qR = parcelRequire("9C0qR");

var $3ZYaX = parcelRequire("3ZYaX");
function $8dcedd691ebf60a0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8dcedd691ebf60a0$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $8dcedd691ebf60a0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $8dcedd691ebf60a0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $8dcedd691ebf60a0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8dcedd691ebf60a0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $8dcedd691ebf60a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $8dcedd691ebf60a0$var$_typeof(obj);
}
function $8dcedd691ebf60a0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8dcedd691ebf60a0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8dcedd691ebf60a0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8dcedd691ebf60a0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8dcedd691ebf60a0$var$_toConsumableArray(arr) {
    return $8dcedd691ebf60a0$var$_arrayWithoutHoles(arr) || $8dcedd691ebf60a0$var$_iterableToArray(arr) || $8dcedd691ebf60a0$var$_unsupportedIterableToArray(arr) || $8dcedd691ebf60a0$var$_nonIterableSpread();
}
function $8dcedd691ebf60a0$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $8dcedd691ebf60a0$var$_arrayLikeToArray(arr);
}
function $8dcedd691ebf60a0$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $8dcedd691ebf60a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8dcedd691ebf60a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8dcedd691ebf60a0$var$_arrayLikeToArray(o, minLen);
}
function $8dcedd691ebf60a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8dcedd691ebf60a0$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// Get CSS class list from a props object
function $8dcedd691ebf60a0$var$classList(props) {
    var _classes;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull; // map of CSS class names to properties
    var classes = (_classes = {
        'fa-beat': beat,
        'fa-fade': fade,
        'fa-beat-fade': beatFade,
        'fa-bounce': bounce,
        'fa-shake': shake,
        'fa-flash': flash,
        'fa-spin': spin,
        'fa-spin-reverse': spinReverse,
        'fa-spin-pulse': spinPulse,
        'fa-pulse': pulse,
        'fa-fw': fixedWidth,
        'fa-inverse': inverse,
        'fa-border': border,
        'fa-li': listItem,
        'fa-flip': flip === true,
        'fa-flip-horizontal': flip === 'horizontal' || flip === 'both',
        'fa-flip-vertical': flip === 'vertical' || flip === 'both'
    }, $8dcedd691ebf60a0$var$_defineProperty(_classes, "fa-".concat(size), typeof size !== 'undefined' && size !== null), $8dcedd691ebf60a0$var$_defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== 'undefined' && rotation !== null && rotation !== 0), $8dcedd691ebf60a0$var$_defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== 'undefined' && pull !== null), $8dcedd691ebf60a0$var$_defineProperty(_classes, 'fa-swap-opacity', props.swapOpacity), _classes); // map over all the keys in the classes object
    // return an array of the keys where the value for the key is not null
    return Object.keys(classes).map(function(key) {
        return classes[key] ? key : null;
    }).filter(function(key) {
        return key;
    });
}
// Camelize taken from humps
// humps is copyright © 2012+ Dom Christie
// Released under the MIT license.
// Performant way to determine if object coerces to a number
function $8dcedd691ebf60a0$var$_isNumerical(obj) {
    obj = obj - 0; // eslint-disable-next-line no-self-compare
    return obj === obj;
}
function $8dcedd691ebf60a0$var$camelize(string) {
    if ($8dcedd691ebf60a0$var$_isNumerical(string)) return string;
     // eslint-disable-next-line no-useless-escape
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
        return chr ? chr.toUpperCase() : '';
    }); // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
}
var $8dcedd691ebf60a0$var$_excluded = [
    "style"
];
function $8dcedd691ebf60a0$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
function $8dcedd691ebf60a0$var$styleToObject(style) {
    return style.split(';').map(function(s) {
        return s.trim();
    }).filter(function(s) {
        return s;
    }).reduce(function(acc, pair) {
        var i = pair.indexOf(':');
        var prop = $8dcedd691ebf60a0$var$camelize(pair.slice(0, i));
        var value = pair.slice(i + 1).trim();
        prop.startsWith('webkit') ? acc[$8dcedd691ebf60a0$var$capitalize(prop)] = value : acc[prop] = value;
        return acc;
    }, {});
}
function $8dcedd691ebf60a0$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof element === 'string') return element;
    var children = (element.children || []).map(function(child) {
        return $8dcedd691ebf60a0$var$convert(createElement, child);
    });
    /* eslint-disable dot-notation */ var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
        var val = element.attributes[key];
        switch(key){
            case 'class':
                acc.attrs['className'] = val;
                delete element.attributes['class'];
                break;
            case 'style':
                acc.attrs['style'] = $8dcedd691ebf60a0$var$styleToObject(val);
                break;
            default:
                if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) acc.attrs[key.toLowerCase()] = val;
                else acc.attrs[$8dcedd691ebf60a0$var$camelize(key)] = val;
        }
        return acc;
    }, {
        attrs: {}
    });
    var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = $8dcedd691ebf60a0$var$_objectWithoutProperties(extraProps, $8dcedd691ebf60a0$var$_excluded);
    mixins.attrs['style'] = $8dcedd691ebf60a0$var$_objectSpread2($8dcedd691ebf60a0$var$_objectSpread2({}, mixins.attrs['style']), existingStyle);
    /* eslint-enable */ return createElement.apply(void 0, [
        element.tag,
        $8dcedd691ebf60a0$var$_objectSpread2($8dcedd691ebf60a0$var$_objectSpread2({}, mixins.attrs), remaining)
    ].concat($8dcedd691ebf60a0$var$_toConsumableArray(children)));
}
var $8dcedd691ebf60a0$var$PRODUCTION = false;
try {
    $8dcedd691ebf60a0$var$PRODUCTION = true;
} catch (e) {}
function $8dcedd691ebf60a0$var$log() {
    if (!$8dcedd691ebf60a0$var$PRODUCTION && console && typeof console.error === 'function') {
        var _console;
        (_console = console).error.apply(_console, arguments);
    }
}
function $8dcedd691ebf60a0$var$normalizeIconArgs(icon) {
    // this has everything that it needs to be rendered which means it was probably imported
    // directly from an icon svg package
    if (icon && $8dcedd691ebf60a0$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName && icon.icon) return icon;
    if ((0, $82f622ad5caaffb5$export$98e6a39c04603d36).icon) return (0, $82f622ad5caaffb5$export$98e6a39c04603d36).icon(icon);
     // if the icon is null, there's nothing to do
    if (icon === null) return null;
     // if the icon is an object and has a prefix and an icon name, return it
    if (icon && $8dcedd691ebf60a0$var$_typeof(icon) === 'object' && icon.prefix && icon.iconName) return icon;
     // if it's an array with length of two
    if (Array.isArray(icon) && icon.length === 2) // use the first item as prefix, second as icon name
    return {
        prefix: icon[0],
        iconName: icon[1]
    };
     // if it's a string, use it as the icon name
    if (typeof icon === 'string') return {
        prefix: 'fas',
        iconName: icon
    };
}
// creates an object with a key of key
// and a value of value
// if certain conditions are met
function $8dcedd691ebf60a0$var$objectWithKey(key, value) {
    // if the value is a non-empty array
    // or it's not an array but it is truthy
    // then create the object with the key and the value
    // if not, return an empty array
    return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? $8dcedd691ebf60a0$var$_defineProperty({}, key, value) : {};
}
var $8dcedd691ebf60a0$export$2b9260d4a45c8710 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).forwardRef(function(props, ref) {
    var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title = props.title, titleId = props.titleId, maskId = props.maskId;
    var iconLookup = $8dcedd691ebf60a0$var$normalizeIconArgs(iconArgs);
    var classes = $8dcedd691ebf60a0$var$objectWithKey('classes', [].concat($8dcedd691ebf60a0$var$_toConsumableArray($8dcedd691ebf60a0$var$classList(props)), $8dcedd691ebf60a0$var$_toConsumableArray(className.split(' '))));
    var transform = $8dcedd691ebf60a0$var$objectWithKey('transform', typeof props.transform === 'string' ? (0, $82f622ad5caaffb5$export$98e6a39c04603d36).transform(props.transform) : props.transform);
    var mask = $8dcedd691ebf60a0$var$objectWithKey('mask', $8dcedd691ebf60a0$var$normalizeIconArgs(maskArgs));
    var renderedIcon = (0, $82f622ad5caaffb5$export$1ca1ec8b29a4ce27)(iconLookup, $8dcedd691ebf60a0$var$_objectSpread2($8dcedd691ebf60a0$var$_objectSpread2($8dcedd691ebf60a0$var$_objectSpread2($8dcedd691ebf60a0$var$_objectSpread2({}, classes), transform), mask), {}, {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $8dcedd691ebf60a0$var$log('Could not find icon', iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    Object.keys(props).forEach(function(key) {
        // eslint-disable-next-line no-prototype-builtins
        if (!$8dcedd691ebf60a0$export$2b9260d4a45c8710.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
    });
    return $8dcedd691ebf60a0$var$convertCurry(abstract[0], extraProps);
});
$8dcedd691ebf60a0$export$2b9260d4a45c8710.displayName = 'FontAwesomeIcon';
$8dcedd691ebf60a0$export$2b9260d4a45c8710.propTypes = {
    beat: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    border: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    beatFade: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    bounce: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    flash: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    mask: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string
    ]),
    maskId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    fixedWidth: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        true,
        false,
        'horizontal',
        'vertical',
        'both'
    ]),
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string
    ]),
    listItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    pull: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        'right',
        'left'
    ]),
    pulse: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        0,
        90,
        180,
        270
    ]),
    shake: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        '2xs',
        'xs',
        'sm',
        'lg',
        'xl',
        '2xl',
        '1x',
        '2x',
        '3x',
        '4x',
        '5x',
        '6x',
        '7x',
        '8x',
        '9x',
        '10x'
    ]),
    spin: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    spinPulse: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    spinReverse: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string
    ]),
    title: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    titleId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    transform: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object
    ]),
    swapOpacity: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool
};
$8dcedd691ebf60a0$export$2b9260d4a45c8710.defaultProps = {
    border: false,
    className: '',
    mask: null,
    maskId: null,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: null,
    listItem: false,
    pull: null,
    pulse: false,
    rotation: null,
    size: null,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: '',
    titleId: null,
    transform: null,
    swapOpacity: false
};
var $8dcedd691ebf60a0$var$convertCurry = $8dcedd691ebf60a0$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createElement);


var $42ee1027226cd96e$export$82e9f45cca5ba907 = "fab";
var $42ee1027226cd96e$export$155bdf1ceac204e7 = {
    prefix: 'fab',
    iconName: 'monero',
    icon: [
        496,
        512,
        [],
        "f3d0",
        "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
    ]
};
var $42ee1027226cd96e$export$3a040ca24382cf1c = {
    prefix: 'fab',
    iconName: 'hooli',
    icon: [
        640,
        512,
        [],
        "f427",
        "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
    ]
};
var $42ee1027226cd96e$export$2de47f03337052b6 = {
    prefix: 'fab',
    iconName: 'yelp',
    icon: [
        384,
        512,
        [],
        "f1e9",
        "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
    ]
};
var $42ee1027226cd96e$export$acc882c0b0e9e801 = {
    prefix: 'fab',
    iconName: 'cc-visa',
    icon: [
        576,
        512,
        [],
        "f1f0",
        "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
    ]
};
var $42ee1027226cd96e$export$8226e5267dd86de3 = {
    prefix: 'fab',
    iconName: 'lastfm',
    icon: [
        512,
        512,
        [],
        "f202",
        "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
    ]
};
var $42ee1027226cd96e$export$c0b2d6cff425a846 = {
    prefix: 'fab',
    iconName: 'shopware',
    icon: [
        512,
        512,
        [],
        "f5b5",
        "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
    ]
};
var $42ee1027226cd96e$export$e36098165f3fc869 = {
    prefix: 'fab',
    iconName: 'creative-commons-nc',
    icon: [
        496,
        512,
        [],
        "f4e8",
        "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
    ]
};
var $42ee1027226cd96e$export$a4ddb2c7f767be70 = {
    prefix: 'fab',
    iconName: 'aws',
    icon: [
        640,
        512,
        [],
        "f375",
        "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
    ]
};
var $42ee1027226cd96e$export$d65557a7abc2c5dc = {
    prefix: 'fab',
    iconName: 'redhat',
    icon: [
        512,
        512,
        [],
        "f7bc",
        "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
    ]
};
var $42ee1027226cd96e$export$73b6ef60226f6801 = {
    prefix: 'fab',
    iconName: 'yoast',
    icon: [
        448,
        512,
        [],
        "f2b1",
        "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
    ]
};
var $42ee1027226cd96e$export$7a31e37b2189232c = {
    prefix: 'fab',
    iconName: 'cloudflare',
    icon: [
        640,
        512,
        [],
        "e07d",
        "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
    ]
};
var $42ee1027226cd96e$export$c6f6a1beb6102ac = {
    prefix: 'fab',
    iconName: 'ups',
    icon: [
        384,
        512,
        [],
        "f7e0",
        "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
    ]
};
var $42ee1027226cd96e$export$b64ce7c5d150db12 = {
    prefix: 'fab',
    iconName: 'pixiv',
    icon: [
        448,
        512,
        [],
        "e640",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm171.5 84c41 0 76.3 12.9 101.4 35.2l0 0c25.2 22.2 39.8 54.1 39.8 88.8c.1 35.3-16.6 66.3-42.4 87c-25.9 20.8-60.6 32.4-98.8 32.4c-43.5 0-83.8-16.1-83.8-16.1v51.8c7.4 2.2 19.7 7 11.9 14.8H104.8c-7.7-7.8 3.6-12.4 12.1-14.8V175.5C97.1 190.9 87 204.3 81.8 214.2c6 19.4-5.3 18.5-5.3 18.5L56 199.7s72.7-83.7 179.5-83.7zm-3.6 222.9c30 0 56-11.3 73.9-29.2c17.9-18.1 27.9-41.6 28-70.2c-.1-29.3-9.5-54.6-26.7-73.6c-17.2-18.9-42.7-31.3-75.2-31.4c-26.7-.1-59.8 9-80.2 23.7V323.1c18.6 9.3 46.8 15.9 80.2 15.8z"
    ]
};
var $42ee1027226cd96e$export$9ab35a48e8f904bf = {
    prefix: 'fab',
    iconName: 'wpexplorer',
    icon: [
        512,
        512,
        [],
        "f2de",
        "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
    ]
};
var $42ee1027226cd96e$export$1661cbacae81932b = {
    prefix: 'fab',
    iconName: 'dyalog',
    icon: [
        416,
        512,
        [],
        "f399",
        "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
    ]
};
var $42ee1027226cd96e$export$76a6a7e968d921fe = {
    prefix: 'fab',
    iconName: 'bity',
    icon: [
        496,
        512,
        [],
        "f37a",
        "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
    ]
};
var $42ee1027226cd96e$export$a14b012b76f98910 = {
    prefix: 'fab',
    iconName: 'stackpath',
    icon: [
        448,
        512,
        [],
        "f842",
        "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
    ]
};
var $42ee1027226cd96e$export$6c0bc096306cebf8 = {
    prefix: 'fab',
    iconName: 'buysellads',
    icon: [
        448,
        512,
        [],
        "f20d",
        "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
    ]
};
var $42ee1027226cd96e$export$e0a21844bf49ca8e = {
    prefix: 'fab',
    iconName: 'first-order',
    icon: [
        448,
        512,
        [],
        "f2b0",
        "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
    ]
};
var $42ee1027226cd96e$export$fb06254b4488a5b6 = {
    prefix: 'fab',
    iconName: 'modx',
    icon: [
        448,
        512,
        [],
        "f285",
        "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
    ]
};
var $42ee1027226cd96e$export$b6ff6f33a85ee805 = {
    prefix: 'fab',
    iconName: 'guilded',
    icon: [
        448,
        512,
        [],
        "e07e",
        "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
    ]
};
var $42ee1027226cd96e$export$13bd8782a2ce17e7 = {
    prefix: 'fab',
    iconName: 'vnv',
    icon: [
        640,
        512,
        [],
        "f40b",
        "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
    ]
};
var $42ee1027226cd96e$export$c989752ecb8b3fae = {
    prefix: 'fab',
    iconName: 'square-js',
    icon: [
        448,
        512,
        [
            "js-square"
        ],
        "f3b9",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM180.9 444.9c-33.7 0-53.2-17.4-63.2-38.5L152 385.7c6.6 11.7 12.6 21.6 27.1 21.6c13.8 0 22.6-5.4 22.6-26.5V237.7h42.1V381.4c0 43.6-25.6 63.5-62.9 63.5zm85.8-43L301 382.1c9 14.7 20.8 25.6 41.5 25.6c17.4 0 28.6-8.7 28.6-20.8c0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5c0-31.6 24.1-55.6 61.6-55.6c26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18c-12.3 0-20.1 7.8-20.1 18c0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2c0 37.8-29.8 58.6-69.7 58.6c-39.1 0-64.4-18.6-76.7-43z"
    ]
};
var $42ee1027226cd96e$export$d9bf3211f885d573 = $42ee1027226cd96e$export$c989752ecb8b3fae;
var $42ee1027226cd96e$export$b3b8195c77f1f877 = {
    prefix: 'fab',
    iconName: 'microsoft',
    icon: [
        448,
        512,
        [],
        "f3ca",
        "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
    ]
};
var $42ee1027226cd96e$export$39d59e523abf051d = {
    prefix: 'fab',
    iconName: 'qq',
    icon: [
        448,
        512,
        [],
        "f1d6",
        "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
    ]
};
var $42ee1027226cd96e$export$9bf8457cc97dd02e = {
    prefix: 'fab',
    iconName: 'orcid',
    icon: [
        512,
        512,
        [],
        "f8d2",
        "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
    ]
};
var $42ee1027226cd96e$export$25a84a6ff654acd1 = {
    prefix: 'fab',
    iconName: 'java',
    icon: [
        384,
        512,
        [],
        "f4e4",
        "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
    ]
};
var $42ee1027226cd96e$export$6e249797a4721568 = {
    prefix: 'fab',
    iconName: 'invision',
    icon: [
        448,
        512,
        [],
        "f7b0",
        "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
    ]
};
var $42ee1027226cd96e$export$d93ab92a56e88ce6 = {
    prefix: 'fab',
    iconName: 'creative-commons-pd-alt',
    icon: [
        496,
        512,
        [],
        "f4ed",
        "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
    ]
};
var $42ee1027226cd96e$export$961762d5b3aedd8d = {
    prefix: 'fab',
    iconName: 'centercode',
    icon: [
        512,
        512,
        [],
        "f380",
        "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
    ]
};
var $42ee1027226cd96e$export$91d5526742c32d42 = {
    prefix: 'fab',
    iconName: 'glide-g',
    icon: [
        448,
        512,
        [],
        "f2a6",
        "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
    ]
};
var $42ee1027226cd96e$export$51e679e8d2e3f8c1 = {
    prefix: 'fab',
    iconName: 'drupal',
    icon: [
        448,
        512,
        [],
        "f1a9",
        "M303.973,108.136C268.2,72.459,234.187,38.35,224.047,0c-9.957,38.35-44.25,72.459-80.019,108.136C90.467,161.7,29.716,222.356,29.716,313.436c-2.337,107.3,82.752,196.18,190.053,198.517S415.948,429.2,418.285,321.9q.091-4.231,0-8.464C418.285,222.356,357.534,161.7,303.973,108.136Zm-174.326,223a130.282,130.282,0,0,0-15.211,24.153,4.978,4.978,0,0,1-3.319,2.766h-1.659c-4.333,0-9.219-8.481-9.219-8.481h0c-1.29-2.028-2.489-4.149-3.687-6.361l-.83-1.752c-11.247-25.72-1.475-62.318-1.475-62.318h0a160.585,160.585,0,0,1,23.231-49.873A290.8,290.8,0,0,1,138.5,201.613l9.219,9.219,43.512,44.434a4.979,4.979,0,0,1,0,6.638L145.78,312.33h0Zm96.612,127.311a67.2,67.2,0,0,1-49.781-111.915c14.2-16.871,31.528-33.464,50.334-55.313,22.309,23.785,36.875,40.1,51.164,57.986a28.413,28.413,0,0,1,2.95,4.425,65.905,65.905,0,0,1,11.984,37.981,66.651,66.651,0,0,1-66.466,66.836ZM352.371,351.6h0a7.743,7.743,0,0,1-6.176,5.347H344.9a11.249,11.249,0,0,1-6.269-5.07h0a348.21,348.21,0,0,0-39.456-48.952L281.387,284.49,222.3,223.185a497.888,497.888,0,0,1-35.4-36.322,12.033,12.033,0,0,0-.922-1.382,35.4,35.4,0,0,1-4.7-9.219V174.51a31.346,31.346,0,0,1,9.218-27.656c11.432-11.431,22.955-22.954,33.833-34.939,11.984,13.275,24.8,26,37.428,38.627h0a530.991,530.991,0,0,1,69.6,79.1,147.494,147.494,0,0,1,27.011,83.8A134.109,134.109,0,0,1,352.371,351.6Z"
    ]
};
var $42ee1027226cd96e$export$66507f26cc60b31e = {
    prefix: 'fab',
    iconName: 'hire-a-helper',
    icon: [
        512,
        512,
        [],
        "f3b0",
        "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
    ]
};
var $42ee1027226cd96e$export$5040b13190e5beb7 = {
    prefix: 'fab',
    iconName: 'creative-commons-by',
    icon: [
        496,
        512,
        [],
        "f4e7",
        "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
    ]
};
var $42ee1027226cd96e$export$72fd5838af249737 = {
    prefix: 'fab',
    iconName: 'unity',
    icon: [
        448,
        512,
        [],
        "e049",
        "M243.583 91.6027L323.695 138.384C326.575 140.026 326.68 144.583 323.695 146.225L228.503 201.854C225.623 203.55 222.22 203.444 219.549 201.854L124.357 146.225C121.425 144.636 121.373 139.973 124.357 138.384L204.417 91.6027V0L0 119.417V358.252L78.3843 312.477V218.914C78.3319 215.576 82.2066 213.192 85.0865 214.993L180.279 270.622C183.159 272.318 184.782 275.338 184.782 278.464V389.669C184.834 393.007 180.959 395.391 178.079 393.589L97.9673 346.808L19.583 392.583L224 512L428.417 392.583L350.033 346.808L269.921 393.589C267.093 395.338 263.114 393.06 263.218 389.669V278.464C263.218 275.126 265.051 272.159 267.721 270.622L362.914 214.993C365.741 213.245 369.72 215.47 369.616 218.914V312.477L448 358.252V119.417L243.583 0V91.6027Z"
    ]
};
var $42ee1027226cd96e$export$4d4f65ec2f52482 = {
    prefix: 'fab',
    iconName: 'whmcs',
    icon: [
        448,
        512,
        [],
        "f40d",
        "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
    ]
};
var $42ee1027226cd96e$export$193ac2f517f63e63 = {
    prefix: 'fab',
    iconName: 'rocketchat',
    icon: [
        576,
        512,
        [],
        "f3e8",
        "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
    ]
};
var $42ee1027226cd96e$export$a6bf4d62e541f988 = {
    prefix: 'fab',
    iconName: 'vk',
    icon: [
        448,
        512,
        [],
        "f189",
        "M31.4907 63.4907C0 94.9813 0 145.671 0 247.04V264.96C0 366.329 0 417.019 31.4907 448.509C62.9813 480 113.671 480 215.04 480H232.96C334.329 480 385.019 480 416.509 448.509C448 417.019 448 366.329 448 264.96V247.04C448 145.671 448 94.9813 416.509 63.4907C385.019 32 334.329 32 232.96 32H215.04C113.671 32 62.9813 32 31.4907 63.4907ZM75.6 168.267H126.747C128.427 253.76 166.133 289.973 196 297.44V168.267H244.16V242C273.653 238.827 304.64 205.227 315.093 168.267H363.253C359.313 187.435 351.46 205.583 340.186 221.579C328.913 237.574 314.461 251.071 297.733 261.227C316.41 270.499 332.907 283.63 346.132 299.751C359.357 315.873 369.01 334.618 374.453 354.747H321.44C316.555 337.262 306.614 321.61 292.865 309.754C279.117 297.899 262.173 290.368 244.16 288.107V354.747H238.373C136.267 354.747 78.0267 284.747 75.6 168.267Z"
    ]
};
var $42ee1027226cd96e$export$f1679625ed434576 = {
    prefix: 'fab',
    iconName: 'untappd',
    icon: [
        640,
        512,
        [],
        "f405",
        "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
    ]
};
var $42ee1027226cd96e$export$da9f5a873e107292 = {
    prefix: 'fab',
    iconName: 'mailchimp',
    icon: [
        448,
        512,
        [],
        "f59e",
        "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
    ]
};
var $42ee1027226cd96e$export$928cd5ee6ccd55c0 = {
    prefix: 'fab',
    iconName: 'css3-alt',
    icon: [
        384,
        512,
        [],
        "f38b",
        "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
    ]
};
var $42ee1027226cd96e$export$307bcbd032fbb8d3 = {
    prefix: 'fab',
    iconName: 'square-reddit',
    icon: [
        448,
        512,
        [
            "reddit-square"
        ],
        "f1a2",
        "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM305.9 166.4c20.6 0 37.3-16.7 37.3-37.3s-16.7-37.3-37.3-37.3c-18 0-33.1 12.8-36.6 29.8c-30.2 3.2-53.8 28.8-53.8 59.9l0 .2c-32.8 1.4-62.8 10.7-86.6 25.5c-8.8-6.8-19.9-10.9-32-10.9c-28.9 0-52.3 23.4-52.3 52.3c0 21 12.3 39 30.1 47.4c1.7 60.7 67.9 109.6 149.3 109.6s147.6-48.9 149.3-109.7c17.7-8.4 29.9-26.4 29.9-47.3c0-28.9-23.4-52.3-52.3-52.3c-12 0-23 4-31.9 10.8c-24-14.9-54.3-24.2-87.5-25.4l0-.1c0-22.2 16.5-40.7 37.9-43.7l0 0c3.9 16.5 18.7 28.7 36.3 28.7zM155 248.1c14.6 0 25.8 15.4 25 34.4s-11.8 25.9-26.5 25.9s-27.5-7.7-26.6-26.7s13.5-33.5 28.1-33.5zm166.4 33.5c.9 19-12 26.7-26.6 26.7s-25.6-6.9-26.5-25.9c-.9-19 10.3-34.4 25-34.4s27.3 14.6 28.1 33.5zm-42.1 49.6c-9 21.5-30.3 36.7-55.1 36.7s-46.1-15.1-55.1-36.7c-1.1-2.6 .7-5.4 3.4-5.7c16.1-1.6 33.5-2.5 51.7-2.5s35.6 .9 51.7 2.5c2.7 .3 4.5 3.1 3.4 5.7z"
    ]
};
var $42ee1027226cd96e$export$f8480c75bb6acc77 = $42ee1027226cd96e$export$307bcbd032fbb8d3;
var $42ee1027226cd96e$export$2ea137a3f22bc61 = {
    prefix: 'fab',
    iconName: 'vimeo-v',
    icon: [
        448,
        512,
        [],
        "f27d",
        "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
    ]
};
var $42ee1027226cd96e$export$d023cd407bbc3cab = {
    prefix: 'fab',
    iconName: 'contao',
    icon: [
        512,
        512,
        [],
        "f26d",
        "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
    ]
};
var $42ee1027226cd96e$export$128da80f2cbe244a = {
    prefix: 'fab',
    iconName: 'square-font-awesome',
    icon: [
        448,
        512,
        [],
        "e5ad",
        "M384.5,32.5h-320c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64v-320 C448.5,61.2,419.8,32.5,384.5,32.5z M336.5,312.5c-31.6,11.2-41.2,16-59.8,16c-31.4,0-43.2-16-74.6-16c-10.2,0-18.2,1.6-25.6,4v-32 c7.4-2.2,15.4-4,25.6-4c31.2,0,43.2,16,74.6,16c10.2,0,17.8-1.4,27.8-4.6v-96c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.2-16-74.6-16 c-25.4,0-37.4,10.4-57.6,14.4v153.6c0,8.8-7.2,16-16,16c-8.8,0-16-7.2-16-16v-192c0-8.8,7.2-16,16-16c8.8,0,16,7.2,16,16v6.4 c20.2-4,32.2-14.4,57.6-14.4c31.2,0,43.2,16,74.6,16c18.6,0,28.2-4.8,59.8-16V312.5z"
    ]
};
var $42ee1027226cd96e$export$9005bf63ad3e3083 = {
    prefix: 'fab',
    iconName: 'deskpro',
    icon: [
        480,
        512,
        [],
        "f38f",
        "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
    ]
};
var $42ee1027226cd96e$export$ec6cecf928f83afa = {
    prefix: 'fab',
    iconName: 'brave',
    icon: [
        448,
        512,
        [],
        "e63c",
        "M145.5 0H224h78.5l44.7 50.8s39.3-10.9 57.8 7.6s33.8 34.9 33.8 34.9l-12 29.5 15.3 43.7s-44.9 170.2-50.1 191c-10.4 40.9-17.4 56.8-46.9 77.5s-82.9 56.8-91.6 62.2c-1.9 1.2-3.9 2.5-5.9 3.9c-7.5 5.1-15.8 10.8-23.5 10.8l0 0 0 0c-7.7 0-16.1-5.7-23.5-10.8c-2-1.4-4-2.8-5.9-3.9c-8.7-5.5-62.1-41.5-91.6-62.2s-36.5-36.6-46.9-77.5c-5.3-20.8-50.1-191-50.1-191l15.3-43.7L9.2 93.3s15.3-16.4 33.8-34.9s57.8-7.6 57.8-7.6L145.5 0zM224 407.6l0 0c3.7 0 8.9-4.7 13-8.4c.6-.5 1.2-1.1 1.7-1.5c4.2-3.7 47.8-37.5 51-39.8s5.4-6.5 1.9-8.7c-2.8-1.7-10-5.5-20.3-10.8c-3-1.6-6.3-3.2-9.7-5c-15.4-8-34.5-14.7-37.5-14.7l0 0 0 0c-3 0-22.1 6.8-37.5 14.7c-3.5 1.8-6.7 3.5-9.7 5c-10.3 5.3-17.6 9.1-20.3 10.8c-3.6 2.2-1.4 6.4 1.9 8.7s46.8 36.1 51 39.8c.5 .5 1.1 1 1.7 1.5c4.1 3.7 9.3 8.4 13 8.4l0 0zm0-165.7l0 0c4.7 0 17.6-3 26.4-5l0 0 2-.5c7.8-1.8 7.3-6.3 6.4-13c-.1-.8-.2-1.6-.3-2.4c-.6-6.1-5.8-33.1-9.1-50.3c-1.1-5.8-2-10.5-2.4-12.9c-1.5-8.1-.6-9.4 .7-11.3c.2-.3 .5-.7 .7-1.1c1.4-2.3 16-6.2 27.9-9.5l0 0c2.5-.7 4.8-1.3 6.9-1.9c10.6-3 32.4-.6 44.2 .6c1.8 .2 3.4 .4 4.7 .5c9.6 .9 10.4 2.3 7.2 3.8c-2.3 1.1-16.2 6.3-28.7 10.9l0 0 0 0c-4.7 1.8-9.2 3.5-12.8 4.8c-1.5 .5-3 1.1-4.5 1.7c-12.5 4.6-27.2 10-28.9 19.4c-1.5 8.3 5.2 19.9 11.3 30.3l0 0c1.6 2.8 3.2 5.5 4.6 8.1c6.3 11.9 6.5 13.3 6.1 18.1c-.4 3.9-14.5 12.7-22.4 17.6l0 0c-1.8 1.1-3.3 2.1-4.2 2.7c-.8 .5-2.1 1.4-3.8 2.4c-8.6 5.2-26.3 16-26.3 22.5c0 7.8 24.6 28.1 32.4 33.2s28.9 16.1 37.9 17.8s23-8.5 31.2-23.8c7.7-14.4 1.7-28.5-3.2-40l-.9-2.2c-4.5-10.6 1.9-17 6.2-21.3l0 0c.5-.5 1-1 1.4-1.4L377.7 194c1.3-1.3 2.5-2.6 3.7-3.8l0 0c5.8-5.7 10.8-10.5 10.8-22.8c0-14.9-57.5-84.5-57.5-84.5s-48.5 9.3-55.1 9.3c-5.2 0-15.3-3.5-25.8-7.1l0 0c-2.7-.9-5.4-1.9-8-2.7C232.8 78.1 224 78 224 78l0 0 0 0s-8.7 0-21.8 4.4c-2.7 .9-5.4 1.8-8 2.7l0 0c-10.5 3.6-20.6 7.1-25.8 7.1c-6.5 0-55.1-9.3-55.1-9.3s-57.5 69.6-57.5 84.5c0 12.3 4.9 17.1 10.8 22.8l0 0c1.2 1.2 2.5 2.4 3.7 3.8l43.1 45.8c.4 .5 .9 .9 1.4 1.4l0 0c4.3 4.3 10.6 10.7 6.2 21.3l-.9 2.2c-4.9 11.5-11 25.6-3.2 40c8.2 15.3 22.2 25.5 31.2 23.8s30.1-12.7 37.9-17.8s32.4-25.4 32.4-33.2c0-6.5-17.7-17.3-26.3-22.5c-1.7-1-3.1-1.9-3.8-2.4c-.9-.6-2.4-1.5-4.2-2.7c-7.9-4.9-22-13.7-22.4-17.6c-.4-4.8-.3-6.2 6.1-18.1c1.3-2.5 2.9-5.3 4.6-8.1c6-10.4 12.8-22 11.3-30.3c-1.7-9.4-16.4-14.8-28.9-19.4c-1.6-.6-3.1-1.1-4.5-1.7c-3.6-1.4-8.1-3.1-12.8-4.8l-.1 0c-12.5-4.7-26.4-9.9-28.7-10.9c-3.2-1.5-2.3-2.8 7.2-3.8c1.3-.1 2.9-.3 4.7-.5c11.8-1.3 33.6-3.6 44.2-.6c2.1 .6 4.4 1.2 6.9 1.9c11.9 3.2 26.5 7.2 27.9 9.5c.2 .4 .5 .7 .7 1.1c1.3 1.9 2.2 3.2 .7 11.3c-.4 2.4-1.3 7.1-2.4 12.9c-3.3 17.2-8.5 44.2-9.1 50.3c-.1 .8-.2 1.7-.3 2.4c-.8 6.7-1.4 11.2 6.4 13l2 .5 0 0c8.8 2 21.8 5 26.4 5l0 0z"
    ]
};
var $42ee1027226cd96e$export$36ca6be2e064d2cd = {
    prefix: 'fab',
    iconName: 'sistrix',
    icon: [
        448,
        512,
        [],
        "f3ee",
        "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
    ]
};
var $42ee1027226cd96e$export$526087fb4de86dae = {
    prefix: 'fab',
    iconName: 'square-instagram',
    icon: [
        448,
        512,
        [
            "instagram-square"
        ],
        "e055",
        "M194.4 211.7a53.3 53.3 0 1 0 59.3 88.7 53.3 53.3 0 1 0 -59.3-88.7zm142.3-68.4c-5.2-5.2-11.5-9.3-18.4-12c-18.1-7.1-57.6-6.8-83.1-6.5c-4.1 0-7.9 .1-11.2 .1c-3.3 0-7.2 0-11.4-.1c-25.5-.3-64.8-.7-82.9 6.5c-6.9 2.7-13.1 6.8-18.4 12s-9.3 11.5-12 18.4c-7.1 18.1-6.7 57.7-6.5 83.2c0 4.1 .1 7.9 .1 11.1s0 7-.1 11.1c-.2 25.5-.6 65.1 6.5 83.2c2.7 6.9 6.8 13.1 12 18.4s11.5 9.3 18.4 12c18.1 7.1 57.6 6.8 83.1 6.5c4.1 0 7.9-.1 11.2-.1c3.3 0 7.2 0 11.4 .1c25.5 .3 64.8 .7 82.9-6.5c6.9-2.7 13.1-6.8 18.4-12s9.3-11.5 12-18.4c7.2-18 6.8-57.4 6.5-83c0-4.2-.1-8.1-.1-11.4s0-7.1 .1-11.4c.3-25.5 .7-64.9-6.5-83l0 0c-2.7-6.9-6.8-13.1-12-18.4zm-67.1 44.5A82 82 0 1 1 178.4 324.2a82 82 0 1 1 91.1-136.4zm29.2-1.3c-3.1-2.1-5.6-5.1-7.1-8.6s-1.8-7.3-1.1-11.1s2.6-7.1 5.2-9.8s6.1-4.5 9.8-5.2s7.6-.4 11.1 1.1s6.5 3.9 8.6 7s3.2 6.8 3.2 10.6c0 2.5-.5 5-1.4 7.3s-2.4 4.4-4.1 6.2s-3.9 3.2-6.2 4.2s-4.8 1.5-7.3 1.5l0 0c-3.8 0-7.5-1.1-10.6-3.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM357 389c-18.7 18.7-41.4 24.6-67 25.9c-26.4 1.5-105.6 1.5-132 0c-25.6-1.3-48.3-7.2-67-25.9s-24.6-41.4-25.8-67c-1.5-26.4-1.5-105.6 0-132c1.3-25.6 7.1-48.3 25.8-67s41.5-24.6 67-25.8c26.4-1.5 105.6-1.5 132 0c25.6 1.3 48.3 7.1 67 25.8s24.6 41.4 25.8 67c1.5 26.3 1.5 105.4 0 131.9c-1.3 25.6-7.1 48.3-25.8 67z"
    ]
};
var $42ee1027226cd96e$export$ccb1f25058292a04 = $42ee1027226cd96e$export$526087fb4de86dae;
var $42ee1027226cd96e$export$fb3fd8e112e1fa28 = {
    prefix: 'fab',
    iconName: 'battle-net',
    icon: [
        512,
        512,
        [],
        "f835",
        "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
    ]
};
var $42ee1027226cd96e$export$daa019c708da49e9 = {
    prefix: 'fab',
    iconName: 'the-red-yeti',
    icon: [
        512,
        512,
        [],
        "f69d",
        "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
    ]
};
var $42ee1027226cd96e$export$ca115ee475bced67 = {
    prefix: 'fab',
    iconName: 'square-hacker-news',
    icon: [
        448,
        512,
        [
            "hacker-news-square"
        ],
        "f3af",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM21 229.2c0 0 .1-.1 .1-.2s.1-.2 .2-.2c0 .1 0 .3-.1 .4H21zM239.2 384H207.8V281.3L128 128h37.3c41.5 77.7 48.1 95.8 54.1 112c1.6 4.3 3.1 8.5 5.2 13.6c3.2-7 5.1-11.9 7.1-17.3c5.9-15.3 12.8-33.2 53.5-108.3H320L239.2 283.1V384z"
    ]
};
var $42ee1027226cd96e$export$310b7424f1f97fc = $42ee1027226cd96e$export$ca115ee475bced67;
var $42ee1027226cd96e$export$9c65bd68cbc68ec9 = {
    prefix: 'fab',
    iconName: 'edge',
    icon: [
        512,
        512,
        [],
        "f282",
        "M120.1 37.44C161.1 12.23 207.7-.7753 255 .0016C423 .0016 512 123.8 512 219.5C511.9 252.2 499 283.4 476.1 306.7C453.2 329.9 422.1 343.2 389.4 343.7C314.2 343.7 297.9 320.6 297.9 311.7C297.9 307.9 299.1 305.5 302.7 302.3L303.7 301.1L304.1 299.5C314.6 288 320 273.3 320 257.9C320 179.2 237.8 115.2 136 115.2C98.46 114.9 61.46 124.1 28.48 142.1C55.48 84.58 111.2 44.5 119.8 38.28C120.6 37.73 120.1 37.44 120.1 37.44V37.44zM135.7 355.5C134.3 385.5 140.3 415.5 152.1 442.7C165.7 469.1 184.8 493.7 208.6 512C149.1 500.5 97.11 468.1 59.2 422.7C21.12 376.3 0 318.4 0 257.9C0 206.7 62.4 163.5 136 163.5C172.6 162.9 208.4 174.4 237.8 196.2L234.2 197.4C182.7 215 135.7 288.1 135.7 355.5V355.5zM469.8 400L469.1 400.1C457.3 418.9 443.2 435.2 426.9 449.6C396.1 477.6 358.8 495.1 318.1 499.5C299.5 499.8 281.3 496.3 264.3 488.1C238.7 477.8 217.2 458.1 202.7 435.1C188.3 411.2 181.6 383.4 183.7 355.5C183.1 335.4 189.1 315.2 198.7 297.3C212.6 330.4 236.2 358.6 266.3 378.1C296.4 397.6 331.8 407.6 367.7 406.7C398.7 407 429.8 400 457.9 386.2L459.8 385.3C463.7 383 467.5 381.4 471.4 385.3C475.9 390.2 473.2 394.5 470.2 399.3C470 399.5 469.9 399.8 469.8 400V400z"
    ]
};
var $42ee1027226cd96e$export$2a1c6a809b4fdc7f = {
    prefix: 'fab',
    iconName: 'threads',
    icon: [
        448,
        512,
        [],
        "e618",
        "M331.5 235.7c2.2 .9 4.2 1.9 6.3 2.8c29.2 14.1 50.6 35.2 61.8 61.4c15.7 36.5 17.2 95.8-30.3 143.2c-36.2 36.2-80.3 52.5-142.6 53h-.3c-70.2-.5-124.1-24.1-160.4-70.2c-32.3-41-48.9-98.1-49.5-169.6V256v-.2C17 184.3 33.6 127.2 65.9 86.2C102.2 40.1 156.2 16.5 226.4 16h.3c70.3 .5 124.9 24 162.3 69.9c18.4 22.7 32 50 40.6 81.7l-40.4 10.8c-7.1-25.8-17.8-47.8-32.2-65.4c-29.2-35.8-73-54.2-130.5-54.6c-57 .5-100.1 18.8-128.2 54.4C72.1 146.1 58.5 194.3 58 256c.5 61.7 14.1 109.9 40.3 143.3c28 35.6 71.2 53.9 128.2 54.4c51.4-.4 85.4-12.6 113.7-40.9c32.3-32.2 31.7-71.8 21.4-95.9c-6.1-14.2-17.1-26-31.9-34.9c-3.7 26.9-11.8 48.3-24.7 64.8c-17.1 21.8-41.4 33.6-72.7 35.3c-23.6 1.3-46.3-4.4-63.9-16c-20.8-13.8-33-34.8-34.3-59.3c-2.5-48.3 35.7-83 95.2-86.4c21.1-1.2 40.9-.3 59.2 2.8c-2.4-14.8-7.3-26.6-14.6-35.2c-10-11.7-25.6-17.7-46.2-17.8H227c-16.6 0-39 4.6-53.3 26.3l-34.4-23.6c19.2-29.1 50.3-45.1 87.8-45.1h.8c62.6 .4 99.9 39.5 103.7 107.7l-.2 .2zm-156 68.8c1.3 25.1 28.4 36.8 54.6 35.3c25.6-1.4 54.6-11.4 59.5-73.2c-13.2-2.9-27.8-4.4-43.4-4.4c-4.8 0-9.6 .1-14.4 .4c-42.9 2.4-57.2 23.2-56.2 41.8l-.1 .1z"
    ]
};
var $42ee1027226cd96e$export$29d678db44edc00 = {
    prefix: 'fab',
    iconName: 'napster',
    icon: [
        496,
        512,
        [],
        "f3d2",
        "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
    ]
};
var $42ee1027226cd96e$export$8176f1a0ece4380c = {
    prefix: 'fab',
    iconName: 'square-snapchat',
    icon: [
        448,
        512,
        [
            "snapchat-square"
        ],
        "f2ad",
        "M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32Zm-3.907,319.309-.083.1a32.364,32.364,0,0,1-8.717,6.823,90.26,90.26,0,0,1-20.586,8.2,12.694,12.694,0,0,0-3.852,1.76c-2.158,1.909-2.1,4.64-4.4,8.55a23.137,23.137,0,0,1-6.84,7.471c-6.707,4.632-14.244,4.923-22.23,5.23-7.214.274-15.39.581-24.729,3.669-3.761,1.245-7.753,3.694-12.377,6.533-11.265,6.9-26.68,16.353-52.3,16.353s-40.925-9.4-52.106-16.279c-4.657-2.888-8.675-5.362-12.543-6.64-9.339-3.08-17.516-3.4-24.729-3.67-7.986-.307-15.523-.6-22.231-5.229a23.085,23.085,0,0,1-6.01-6.11c-3.2-4.632-2.855-7.8-5.254-9.895a13.428,13.428,0,0,0-4.1-1.834,89.986,89.986,0,0,1-20.313-8.127,32.905,32.905,0,0,1-8.3-6.284c-6.583-6.757-8.276-14.776-5.686-21.824,3.436-9.338,11.571-12.111,19.4-16.262,14.776-8.027,26.348-18.055,34.433-29.884a68.236,68.236,0,0,0,5.985-10.567c.789-2.158.772-3.329.241-4.416a7.386,7.386,0,0,0-2.208-2.217c-2.532-1.676-5.113-3.353-6.882-4.5-3.27-2.141-5.868-3.818-7.529-4.98-6.267-4.383-10.65-9.04-13.4-14.245a28.4,28.4,0,0,1-1.369-23.584c4.134-10.924,14.469-17.706,26.978-17.706a37.141,37.141,0,0,1,7.845.83c.689.15,1.37.307,2.042.482-.108-7.43.058-15.357.722-23.119,2.358-27.261,11.912-41.589,21.874-52.994a86.836,86.836,0,0,1,22.28-17.931C188.254,100.383,205.312,96,224,96s35.828,4.383,50.944,13.016a87.169,87.169,0,0,1,22.239,17.9c9.961,11.406,19.516,25.709,21.874,52.995a231.194,231.194,0,0,1,.713,23.118c.673-.174,1.362-.332,2.051-.481a37.131,37.131,0,0,1,7.844-.83c12.5,0,22.82,6.782,26.971,17.706a28.37,28.37,0,0,1-1.4,23.559c-2.74,5.2-7.123,9.861-13.39,14.244-1.668,1.187-4.258,2.864-7.529,4.981-1.835,1.187-4.541,2.947-7.164,4.682a6.856,6.856,0,0,0-1.951,2.034c-.506,1.046-.539,2.191.166,4.208a69.015,69.015,0,0,0,6.085,10.792c8.268,12.1,20.188,22.313,35.454,30.407,1.486.772,2.98,1.5,4.441,2.258.722.332,1.569.763,2.491,1.3,4.9,2.723,9.2,6.01,11.455,12.153C387.821,336.915,386.269,344.7,380.093,351.309Zm-16.719-18.461c-50.313-24.314-58.332-61.918-58.689-64.749-.431-3.379-.921-6.035,2.806-9.472,3.594-3.328,19.541-13.19,23.965-16.278,7.33-5.114,10.534-10.219,8.16-16.495-1.66-4.316-5.686-5.976-9.961-5.976a18.5,18.5,0,0,0-3.993.448c-8.035,1.743-15.838,5.769-20.354,6.857a7.1,7.1,0,0,1-1.66.224c-2.408,0-3.279-1.071-3.088-3.968.564-8.783,1.759-25.925.373-41.937-1.884-22.032-8.99-32.948-17.432-42.6-4.051-4.624-23.135-24.654-59.536-24.654S168.53,134.359,164.479,139c-8.434,9.654-15.531,20.57-17.432,42.6-1.386,16.013-.141,33.147.373,41.937.166,2.756-.68,3.968-3.088,3.968a7.1,7.1,0,0,1-1.66-.224c-4.507-1.087-12.31-5.113-20.346-6.856a18.494,18.494,0,0,0-3.993-.449c-4.25,0-8.3,1.636-9.961,5.977-2.374,6.276.847,11.381,8.168,16.494,4.425,3.088,20.371,12.958,23.966,16.279,3.719,3.437,3.237,6.093,2.805,9.471-.356,2.79-8.384,40.394-58.689,64.749-2.946,1.428-7.96,4.45.88,9.331,13.88,7.628,23.111,6.807,30.3,11.43,6.093,3.927,2.5,12.394,6.923,15.449,5.454,3.76,21.583-.266,42.335,6.6,17.433,5.744,28.116,22.015,58.963,22.015s41.788-16.3,58.938-21.973c20.795-6.865,36.89-2.839,42.336-6.6,4.433-3.055.822-11.522,6.923-15.448,7.181-4.624,16.411-3.8,30.3-11.472C371.36,337.355,366.346,334.333,363.374,332.848Z"
    ]
};
var $42ee1027226cd96e$export$20f908cf15afb04b = $42ee1027226cd96e$export$8176f1a0ece4380c;
var $42ee1027226cd96e$export$74ebd8f5ac37d070 = {
    prefix: 'fab',
    iconName: 'google-plus-g',
    icon: [
        640,
        512,
        [],
        "f0d5",
        "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
    ]
};
var $42ee1027226cd96e$export$4fb55b03537dc8e3 = {
    prefix: 'fab',
    iconName: 'artstation',
    icon: [
        512,
        512,
        [],
        "f77a",
        "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
    ]
};
var $42ee1027226cd96e$export$4401a9960e402a1c = {
    prefix: 'fab',
    iconName: 'markdown',
    icon: [
        640,
        512,
        [],
        "f60f",
        "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
    ]
};
var $42ee1027226cd96e$export$fd6b8582f52b208a = {
    prefix: 'fab',
    iconName: 'sourcetree',
    icon: [
        448,
        512,
        [],
        "f7d3",
        "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
    ]
};
var $42ee1027226cd96e$export$384e1aaf24320a2d = {
    prefix: 'fab',
    iconName: 'google-plus',
    icon: [
        512,
        512,
        [],
        "f2b3",
        "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
    ]
};
var $42ee1027226cd96e$export$f59fd74fa97e6ae5 = {
    prefix: 'fab',
    iconName: 'diaspora',
    icon: [
        512,
        512,
        [],
        "f791",
        "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
    ]
};
var $42ee1027226cd96e$export$b14039dbb12386bc = {
    prefix: 'fab',
    iconName: 'foursquare',
    icon: [
        368,
        512,
        [],
        "f180",
        "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
    ]
};
var $42ee1027226cd96e$export$2c0cf6f85294daec = {
    prefix: 'fab',
    iconName: 'stack-overflow',
    icon: [
        384,
        512,
        [],
        "f16c",
        "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
    ]
};
var $42ee1027226cd96e$export$edfa6885dbf62839 = {
    prefix: 'fab',
    iconName: 'github-alt',
    icon: [
        480,
        512,
        [],
        "f113",
        "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
    ]
};
var $42ee1027226cd96e$export$699e806dfe31d90b = {
    prefix: 'fab',
    iconName: 'phoenix-squadron',
    icon: [
        512,
        512,
        [],
        "f511",
        "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
    ]
};
var $42ee1027226cd96e$export$e4b095fb96bd3e1 = {
    prefix: 'fab',
    iconName: 'pagelines',
    icon: [
        384,
        512,
        [],
        "f18c",
        "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
    ]
};
var $42ee1027226cd96e$export$8819d592a12ec37e = {
    prefix: 'fab',
    iconName: 'algolia',
    icon: [
        512,
        512,
        [],
        "f36c",
        "M256 0C116.1 0 2 112.7 0 252.1C-2 393.6 112.9 510.8 254.5 511.6c43.7 .3 85.9-10.4 123.3-30.7c3.6-2 4.2-7 1.1-9.7l-24-21.2c-4.9-4.3-11.8-5.5-17.8-3c-26.1 11.1-54.5 16.8-83.7 16.4C139 461.9 46.5 366.8 48.3 252.4C50.1 139.5 142.6 48.2 256 48.2H463.7V417.2L345.9 312.5c-3.8-3.4-9.7-2.7-12.7 1.3c-18.9 25-49.7 40.6-83.9 38.2c-47.5-3.3-85.9-41.5-89.5-88.9c-4.2-56.6 40.6-103.9 96.3-103.9c50.4 0 91.9 38.8 96.2 88c.4 4.4 2.4 8.5 5.7 11.4l30.7 27.2c3.5 3.1 9 1.2 9.9-3.4c2.2-11.8 3-24.2 2.1-36.8c-4.9-72-63.3-130-135.4-134.4c-82.7-5.1-151.8 59.5-154 140.6c-2.1 78.9 62.6 147 141.6 148.7c33 .7 63.6-9.6 88.3-27.6L495 509.4c6.6 5.8 17 1.2 17-7.7V9.7c0-5.4-4.4-9.7-9.7-9.7H256z"
    ]
};
var $42ee1027226cd96e$export$1052bcfc0bf56d5d = {
    prefix: 'fab',
    iconName: 'red-river',
    icon: [
        448,
        512,
        [],
        "f3e3",
        "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
    ]
};
var $42ee1027226cd96e$export$976ebfab93ea9362 = {
    prefix: 'fab',
    iconName: 'creative-commons-sa',
    icon: [
        496,
        512,
        [],
        "f4ef",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
    ]
};
var $42ee1027226cd96e$export$3fbc2591308fa490 = {
    prefix: 'fab',
    iconName: 'safari',
    icon: [
        512,
        512,
        [],
        "f267",
        "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
    ]
};
var $42ee1027226cd96e$export$4675affbae76524d = {
    prefix: 'fab',
    iconName: 'google',
    icon: [
        488,
        512,
        [],
        "f1a0",
        "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
    ]
};
var $42ee1027226cd96e$export$dda4448112663ba = {
    prefix: 'fab',
    iconName: 'square-font-awesome-stroke',
    icon: [
        448,
        512,
        [
            "font-awesome-alt"
        ],
        "f35c",
        "M201.6,152c-25.4,0-37.4,10.4-57.6,14.4V160c0-8.8-7.2-16-16-16s-16,7.2-16,16v192c0,0.8,0.1,1.6,0.2,2.4 c0.1,0.4,0.1,0.8,0.2,1.2c1.6,7.1,8,12.4,15.6,12.4s14-5.3,15.6-12.4c0.1-0.4,0.2-0.8,0.2-1.2c0.1-0.8,0.2-1.6,0.2-2.4V198.4 c4-0.8,7.7-1.8,11.2-3c14.3-4.7,26-11.4,46.4-11.4c31.4,0,43.2,16,74.6,16c8.9,0,15.9-1.1,24.2-3.5c1.2-0.3,2.4-0.7,3.6-1.1v96 c-10,3.2-17.6,4.6-27.8,4.6c-31.4,0-43.4-16-74.6-16c-10.2,0-18.2,1.8-25.6,4v32c7.4-2.4,15.4-4,25.6-4c31.4,0,43.2,16,74.6,16 c18.6,0,28.2-4.8,59.8-16V152c-31.6,11.2-41.2,16-59.8,16C244.8,168,232.8,152,201.6,152z M384,32H64C28.7,32,0,60.7,0,96v320 c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V96C448,60.7,419.3,32,384,32z M416,416c0,17.6-14.4,32-32,32H64 c-17.6,0-32-14.4-32-32V96c0-17.6,14.4-32,32-32h320c17.6,0,32,14.4,32,32V416z"
    ]
};
var $42ee1027226cd96e$export$85f790d14ecf253e = $42ee1027226cd96e$export$dda4448112663ba;
var $42ee1027226cd96e$export$f200be919c1eaf0d = {
    prefix: 'fab',
    iconName: 'atlassian',
    icon: [
        512,
        512,
        [],
        "f77b",
        "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
    ]
};
var $42ee1027226cd96e$export$ed0a679f653cc1ec = {
    prefix: 'fab',
    iconName: 'linkedin-in',
    icon: [
        448,
        512,
        [],
        "f0e1",
        "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    ]
};
var $42ee1027226cd96e$export$c5c4219467aa9953 = {
    prefix: 'fab',
    iconName: 'digital-ocean',
    icon: [
        512,
        512,
        [],
        "f391",
        "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
    ]
};
var $42ee1027226cd96e$export$3f240983de3f5d10 = {
    prefix: 'fab',
    iconName: 'nimblr',
    icon: [
        384,
        512,
        [],
        "f5a8",
        "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
    ]
};
var $42ee1027226cd96e$export$8d89e361d79b386e = {
    prefix: 'fab',
    iconName: 'chromecast',
    icon: [
        512,
        512,
        [],
        "f838",
        "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
    ]
};
var $42ee1027226cd96e$export$acd6dee6975fc503 = {
    prefix: 'fab',
    iconName: 'evernote',
    icon: [
        384,
        512,
        [],
        "f839",
        "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
    ]
};
var $42ee1027226cd96e$export$5d439911ece032d6 = {
    prefix: 'fab',
    iconName: 'hacker-news',
    icon: [
        448,
        512,
        [],
        "f1d4",
        "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
    ]
};
var $42ee1027226cd96e$export$e443cc965f82dd02 = {
    prefix: 'fab',
    iconName: 'creative-commons-sampling',
    icon: [
        496,
        512,
        [],
        "f4f0",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
    ]
};
var $42ee1027226cd96e$export$1a30438e2bd95428 = {
    prefix: 'fab',
    iconName: 'adversal',
    icon: [
        512,
        512,
        [],
        "f36a",
        "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
    ]
};
var $42ee1027226cd96e$export$cf9c9b2132d3672c = {
    prefix: 'fab',
    iconName: 'creative-commons',
    icon: [
        496,
        512,
        [],
        "f25e",
        "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
    ]
};
var $42ee1027226cd96e$export$17b7e34aba803644 = {
    prefix: 'fab',
    iconName: 'watchman-monitoring',
    icon: [
        512,
        512,
        [],
        "e087",
        "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
    ]
};
var $42ee1027226cd96e$export$324e0175b7ef27f7 = {
    prefix: 'fab',
    iconName: 'fonticons',
    icon: [
        448,
        512,
        [],
        "f280",
        "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
    ]
};
var $42ee1027226cd96e$export$5c0c3408fef47d33 = {
    prefix: 'fab',
    iconName: 'weixin',
    icon: [
        576,
        512,
        [],
        "f1d7",
        "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
    ]
};
var $42ee1027226cd96e$export$621d1ced1e254c1c = {
    prefix: 'fab',
    iconName: 'shirtsinbulk',
    icon: [
        448,
        512,
        [],
        "f214",
        "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
    ]
};
var $42ee1027226cd96e$export$f02422936d21d2f4 = {
    prefix: 'fab',
    iconName: 'codepen',
    icon: [
        512,
        512,
        [],
        "f1cb",
        "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
    ]
};
var $42ee1027226cd96e$export$9ce7fda0737f89e7 = {
    prefix: 'fab',
    iconName: 'git-alt',
    icon: [
        448,
        512,
        [],
        "f841",
        "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
    ]
};
var $42ee1027226cd96e$export$c2221e2ed2fea622 = {
    prefix: 'fab',
    iconName: 'lyft',
    icon: [
        512,
        512,
        [],
        "f3c3",
        "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
    ]
};
var $42ee1027226cd96e$export$344ccb7aebcc7cfa = {
    prefix: 'fab',
    iconName: 'rev',
    icon: [
        448,
        512,
        [],
        "f5b2",
        "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
    ]
};
var $42ee1027226cd96e$export$b138356c7d4344fd = {
    prefix: 'fab',
    iconName: 'windows',
    icon: [
        448,
        512,
        [],
        "f17a",
        "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
    ]
};
var $42ee1027226cd96e$export$2c1079aeb76cd815 = {
    prefix: 'fab',
    iconName: 'wizards-of-the-coast',
    icon: [
        640,
        512,
        [],
        "f730",
        "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
    ]
};
var $42ee1027226cd96e$export$d20d4c95d5790834 = {
    prefix: 'fab',
    iconName: 'square-viadeo',
    icon: [
        448,
        512,
        [
            "viadeo-square"
        ],
        "f2aa",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM118.3 381.2c-68-73.6-19.8-196.1 81.2-196.1c13.3 0 26.6 2.1 39.1 6.7c-4.3 8.4-7.3 17.6-8.4 27.1c-9.7-4.1-20.2-6-30.7-6c-48.8 0-84.6 41.7-84.6 88.9c0 43 28.5 78.7 69.5 85.9c61.5-24 72.9-117.6 72.9-175v0c0-7.3 0-14.8-.6-22.1c-11.2-32.9-26.6-64.6-44.2-94.5c27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70c0 54.1-21.9 99-68.3 128.2l-2.4 .2c50 1 86.2-38.6 86.2-87.2c0-12.2-2.1-24.3-6.9-35.7c9.5-1.9 18.5-5.6 26.4-10.5c15.3 36.6 12.6 87.3-22.8 125.6c-42.4 46.2-120 46.6-162.4 0zM274.6 217.6c21.9-12 49.6-30.7 62.3-53c1.5-3 4.1-8.6 4.5-12c-12.5 27.9-44.2 49.8-73.9 56.7c-4.7-7.3-7.5-15.5-7.5-24.3c0-10.3 5.2-24.1 12.9-31.6c8.3-7.9 18-10.9 27.9-14.1c16-5.1 32.5-10.3 44.5-35.9c32.5 46.2 13.1 130.3-36.3 130.3c-13.3 0-25.1-7.1-34.4-16.1z"
    ]
};
var $42ee1027226cd96e$export$46c94e3313db0253 = $42ee1027226cd96e$export$d20d4c95d5790834;
var $42ee1027226cd96e$export$61e6f6fcefd81d6e = {
    prefix: 'fab',
    iconName: 'meetup',
    icon: [
        512,
        512,
        [],
        "f2e0",
        "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
    ]
};
var $42ee1027226cd96e$export$47b9420154e916ca = {
    prefix: 'fab',
    iconName: 'centos',
    icon: [
        448,
        512,
        [],
        "f789",
        "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
    ]
};
var $42ee1027226cd96e$export$64d8cc39326ee7a8 = {
    prefix: 'fab',
    iconName: 'adn',
    icon: [
        496,
        512,
        [],
        "f170",
        "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
    ]
};
var $42ee1027226cd96e$export$616a6b084ab35801 = {
    prefix: 'fab',
    iconName: 'cloudsmith',
    icon: [
        512,
        512,
        [],
        "f384",
        "M512 227.6v56.9L284.4 512H227.6L0 284.4V227.6L227.6 0h56.9L512 227.6zm-256 162a133.6 133.6 0 1 0 0-267.1 133.6 133.6 0 1 0 0 267.1z"
    ]
};
var $42ee1027226cd96e$export$d668d8d9da44b43e = {
    prefix: 'fab',
    iconName: 'opensuse',
    icon: [
        640,
        512,
        [],
        "e62b",
        "M471.1 102.7s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3c-51.9-1.8-122.8-4.3-223 57.3c-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.1 307 7 335.1c3.3 12.8 8.9 24.9 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4c44.4 3.9 78.1-16 90-53.3c8.2-25.8 0-63.6-31.5-82.9c-25.6-15.7-53.3-12.1-69.2-1.6c-13.9 9.2-21.8 23.5-21.6 39.2c.3 27.8 24.3 42.6 41.5 42.6c5.4 0 10.7-.9 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9c0-12.1-11.6-14.8-16.8-13.9c-2.9 .5-4.5 2-11.8 2.4c-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9c32.3 2.8 47.7 40.7 28.5 65.7C135 388.5 76.7 388 53.6 344.4c-26-49.2 12.7-111.2 87-98.4c33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3c56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8c5.6-33.8 39.7-18.4 82.4-17.4c66.5 .4 102.1-27 103.1-28c3.7-3.1 6.5-15.8 7-17.7c1.3-5.1-3.2-2.4-3.2-2.4c-8.7 5.2-30.5 15.2-50.9 15.6c-25.3 .5-76.2-25.4-81.6-28.2c-.3-.4 .1 1.2-11-25.5c88.4 58.3 118.3 40.5 145.2 21.7c.8-.6 4.3-2.9 3.6-5.7c-13.8-48.1-22.4-62.7-34.5-69.6c-37-21.6-125-34.7-129.2-35.3c.1-.1-.9-.3-.9 .7l0 0zm135.6 75.4a37.6 37.6 0 1 1 -75.2-2.6 37.6 37.6 0 1 1 75.2 2.6zm-36.6-27.9a26.3 26.3 0 1 0 -1.7 52.5 26.3 26.3 0 1 0 1.7-52.5zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.6 0 15.6v0z"
    ]
};
var $42ee1027226cd96e$export$ef7de58d3fe843ba = {
    prefix: 'fab',
    iconName: 'pied-piper-alt',
    icon: [
        576,
        512,
        [],
        "f1a8",
        "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
    ]
};
var $42ee1027226cd96e$export$fc95d67ac3aa8c53 = {
    prefix: 'fab',
    iconName: 'square-dribbble',
    icon: [
        448,
        512,
        [
            "dribbble-square"
        ],
        "f397",
        "M165.9 132.5c-38.3 18-66.8 53.3-75.7 95.7c6.1 .1 62.4 .3 126.4-16.7c-22.7-40.2-47.1-74.1-50.7-79zm26.1-9.1c3.8 5.1 28.6 38.9 51 80c48.6-18.3 69.1-45.9 71.6-49.4C281 124.2 235.3 112.9 192 123.4zM277.4 382c-2-12-10-53.8-29.2-103.6c-55.1 18.8-93.8 56.4-108.1 85.6c40.5 31.6 93.3 36.7 137.3 18zM227.8 232.6C159.6 253 93.4 252.2 87.4 252c0 .7 0 1.4 0 2.1s0 1.4 0 2.1c0 35.1 13.3 67.1 35.1 91.4c22.2-37.9 67.1-77.9 116.5-91.8c-3.4-7.8-7.2-15.5-11.1-23.2zm72.5 136.9c30.7-20.7 52.5-53.6 58.6-91.6c-4.6-1.5-42.3-12.7-85.1-5.8c17.9 49.1 25.1 89.1 26.5 97.4zm-34.8-119c45.5-5.7 90.7 3.4 95.2 4.4c-.3-32.3-11.8-61.9-30.9-85.1c-2.9 3.9-25.8 33.2-76.3 53.9c4.8 9.8 8.3 17.8 12 26.8zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 416a160 160 0 1 1 0-320 160 160 0 1 1 0 320z"
    ]
};
var $42ee1027226cd96e$export$ff55221913bb3cd0 = $42ee1027226cd96e$export$fc95d67ac3aa8c53;
var $42ee1027226cd96e$export$248fddd2c856e8cc = {
    prefix: 'fab',
    iconName: 'codiepie',
    icon: [
        472,
        512,
        [],
        "f284",
        "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
    ]
};
var $42ee1027226cd96e$export$4c16416edc1f091a = {
    prefix: 'fab',
    iconName: 'node',
    icon: [
        640,
        512,
        [],
        "f419",
        "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
    ]
};
var $42ee1027226cd96e$export$4176cb98e090fc09 = {
    prefix: 'fab',
    iconName: 'mix',
    icon: [
        448,
        512,
        [],
        "f3cb",
        "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
    ]
};
var $42ee1027226cd96e$export$7c80ad2689275b29 = {
    prefix: 'fab',
    iconName: 'steam',
    icon: [
        496,
        512,
        [],
        "f1b6",
        "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
    ]
};
var $42ee1027226cd96e$export$37af1170a8e0c21b = {
    prefix: 'fab',
    iconName: 'cc-apple-pay',
    icon: [
        576,
        512,
        [],
        "f416",
        "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
    ]
};
var $42ee1027226cd96e$export$d271dfaa2c63aec5 = {
    prefix: 'fab',
    iconName: 'scribd',
    icon: [
        384,
        512,
        [],
        "f28a",
        "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
    ]
};
var $42ee1027226cd96e$export$b30079bac9ebcf2a = {
    prefix: 'fab',
    iconName: 'debian',
    icon: [
        448,
        512,
        [],
        "e60b",
        "M380.2 245.6c3-7.6 5.5-14 5.2-24.4l-4.3 9c4.4-13.2 4-27.1 3.6-40.4c-.2-6-.3-11.8 0-17.4l-1.8-.5c-1.5-45.2-40.6-93.1-75.3-109.4c-30-13.8-76.1-16.2-97.3-5.8c1.3-1.1 4.2-2 6.8-2.7l.3-.1c3.3-1 6-1.7 4-2.9c-19.2 1.9-24.9 5.5-31.1 9.4l-.1 0c-4.6 2.9-9.5 6-20.3 8.7c-3.5 3.4 1.7 2 5.8 .9l0 0c4.1-1.1 7.2-1.9-.1 2.4c-3.5 1-6.6 1.3-9.6 1.6l-.1 0c-8.3 .8-15.8 1.6-30.7 17c.8 1.3 3.4-.2 5.3-1.3l.1-.1c2.3-1.4 3.4-2-1.7 4.4c-19.1-2.4-60.3 43.7-69.1 59l4.6 .8c-3.2 8-6.8 14.8-10 20.8c-4.3 8.1-7.9 14.9-8.7 21.3c-.3 5.1-1 11-1.7 17.3l0 0c-.1 1-.2 2-.3 3l-.1 .6c-3 27.3-6.7 60.8 3.9 73l-1.3 13c.6 1.2 1.1 2.3 1.6 3.5c.2 .4 .4 .8 .5 1.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c1 2.1 2 4.2 3.3 6.2l-3 .2c7 22.1 10.8 22.5 15.1 22.9l0 0c4.4 .4 9.3 .9 18.7 24.2c-2.7-.9-5.5-1.9-9.4-7.2c-.5 4.1 5.8 16.3 13.1 25.8l-3.1 3.6c2.1 3.7 4.8 6.2 7.6 8.8l0 0 0 0c1 .9 2.1 1.9 3.1 2.9c-11.9-6.5 3.2 13.7 11.9 25.2c.8 1.1 1.5 2 2.2 2.9l0 0 0 0 0 0 0 0 0 0c1.4 1.9 2.5 3.4 2.9 4.1l2.4-4.2c-.3 6.1 4.3 13.9 13.1 24.7l7.3-.3c3 6 14 16.7 20.7 17.2l-4.4 5.8c8.1 2.6 10.3 4.3 12.7 6.2c2.6 2.1 5.4 4.3 16.1 8.1l-4.2-7.4c3.5 3 6.2 5.9 8.8 8.7l.1 .1c5.2 5.6 9.9 10.6 19.7 15.3c10.7 3.7 16.6 4.7 22.7 5.8c.3 0 .6 .1 .9 .1c5.4 .8 11.2 1.8 20.8 4.5c-1.1-.1-2.2-.1-3.3-.1h0c-2.3-.1-4.7-.1-7-.1l0 0 0 0 0 0 0 0 0 0 0 0 0 0c-14.4-.2-29.2-.4-42.7-5.2C107.8 480.5 19.5 367.2 26 250.6c-.6-9.9-.3-20.9 0-30.7c.4-13.5 .7-24.8-1.6-28.3l1-3.1c5.3-17.4 11.7-38.2 23.8-62.8l-.1-.2v-.1c.4 .4 3.4 3.4 8.8-5.8c.8-1.8 1.6-3.7 2.4-5.6c.5-1.1 .9-2.2 1.4-3.2c2.5-6.1 5.1-12.3 8.4-17.9l2.6-.6c1.7-10.1 17-23.8 29.8-35.2l1.1-1c5.7-5.1 10.7-9.7 13.6-13.1l.7 4.4c17-15.9 44.6-27.5 65.6-36.4l.5-.2c4.8-2 9.3-3.9 13.3-5.7c-3.4 3.8 2.2 2.7 10 1c4.8-1 10.4-2.1 15.3-2.4l-3.9 2.1c-2.7 1.4-5.4 2.8-8 4.6c8.1-2 11.7-1.4 15.7-.8l.3 0c3.5 .6 7.3 1.2 14.6 .2c-5.6 .8-12.3 3-11.2 3.8c7.9 .9 12.8-.1 17.2-1l.2 0c5.5-1.1 10.3-2 19.3 .9l-1-4.8c7.3 2.6 12.7 4.3 17.5 5.8l.5 .1c10 3 17.6 5.3 34.2 14.1c3.2 .2 5.3-.5 7.4-1.2l.1 0c3.6-1.1 7-2.1 15.2 1.2c.3 .5 .5 1 .7 1.4c.1 .2 .2 .5 .3 .7l0 .1c1 2.6 1.8 4.6 14.6 12.1c1.7-.7-2.7-4.7-6.4-8.2c0 0 0 0-.1-.1c-.2-.1-.3-.3-.5-.4c32.2 17.3 67.3 54.1 78 93.5c-6-11.1-5.2-5.5-4.3 .5c.6 4 1.2 8.1-.2 7.5c4.5 12.1 8.1 24.5 10.4 37.4l-.8-2.9-.1-.3c-3.3-11.9-9.6-34.3-19.9-49.3c-.4 4.3-2.8 3.9-5.2 3.5l-.1 0 0 0c-3.3-.6-6.2-1.1-1.9 12.6c2.6 3.8 3.1 2.4 3.5 1.1l0 0c.5-1.5 .9-2.7 4.7 5.2c.1 4.1 1 8.2 2.1 12.7l0 0 0 0 .1 .6c.1 .3 .1 .5 .2 .8l.1 .6c.6 2.6 1.3 5.4 1.8 8.4c-1.1-.2-2.3-2.2-3.4-4.2c-1.4-2.4-2.8-4.7-3.7-3.2c2.4 11.5 6.5 17.4 8 18.3c-.3 .6-.6 .7-1.1 .7c-.8 0-1.8 .1-1.9 5.3c.7 13.7 3.3 12.5 5.3 11.6l0 0c.6-.3 1.2-.6 1.7-.4c-.6 2.5-1.6 5.1-2.7 7.9c-2.8 7.1-6 15.4-3.4 26.1c-.8-3-2-6-3.1-8.9l-.1-.4c-.2-.5-.4-1-.6-1.5l0 0c-.3-.8-.6-1.6-.9-2.3c-.6 4.4-.3 7.7-.1 10.6c0 .2 0 .5 0 .7c.4 5.3 .7 10-3 19.9c4.3-14.2 3.8-26.9-.2-20.8c1 10.9-3.7 20.4-8 28.9l-.1 .2c-3.6 7.1-6.8 13.5-5.9 19.3l-5.2-7.1c-7.5 10.9-7 13.3-6.5 15.5l0 .1c.5 1.9 1 3.8-3.4 10.8c1.7-2.9 1.3-3.6 1-4.2l0 0c-.4-.8-.7-1.5 1.7-5.1c-1.6 .1-5.5 3.9-10.1 8.5c-3.9 3.9-8.5 8.4-12.8 11.8c-37.5 30.1-82.3 34-125.6 17.8c.2-1-.2-2.1-3.1-4.1c-36.8-28.2-58.5-52.1-50.9-107.5c2.1-1.6 3.6-5.8 5.3-10.8l0 0 0 0 .2-.4 .1-.3 0-.1c2.9-8.4 6.5-18.8 14.3-23.8c7.8-17.3 31.3-33.3 56.4-33.7c25.6-1.4 47.2 13.7 58.1 27.9c-19.8-18.4-52.1-24-79.7-10.4c-28.2 12.7-45 43.8-42.5 74.7c.3-.4 .6-.6 .9-.8l0 0s0 0 0 0c0 0 .1-.1 .1-.1l.1-.1c.6-.5 1.1-.9 1.4-3.3c-.9 60.2 64.8 104.3 112.1 82l.6 1.3c12.7-3.5 15.9-6.5 20.3-10.7l.1-.1 0 0c2.2-2.1 4.7-4.5 8.9-7.3c-.3 .7-1.3 1.7-2.4 2.7c-2.2 2.1-4.6 4.5-1.6 4.6c5-1.3 18.5-13.4 28.5-22.3l0 0 0 0c.6-.5 1.2-1 1.7-1.5c1.5-1.3 2.8-2.5 4-3.6l0 0 .3-.3c1.9-4.2 1.6-5.6 1.3-7l0-.1c-.4-1.6-.8-3.3 2.4-9.6l7.3-3.7c.8-2.1 1.5-4.1 2.2-6c.2-.6 .5-1.2 .7-1.8l-.4-.2zM349.3 34.3l-.2-.1 .2 .1 0 0zM247.8 334.1c-6-3-13.7-8.9-14.8-11.4l-.4 .3c-.3 .6-.5 1.3-.2 2.2c-12.2-5.7-23.4-14.3-32.6-24.9c4.9 7.1 10.1 14.1 17 19.5c-6.9-2.3-15.1-11.8-21.6-19.3l-.1-.1c-4.3-5-7.9-9.1-9.7-9.5c19.8 35.5 80.5 62.3 112.3 49c-14.7 .5-33.4 .3-49.9-5.8zm79.3-119.7l-.1-.2c-.5-1.5-1.1-3.1-1.7-3.4c1.4-5.8 5.4-10.7 4.4 4.6c-1 3.8-1.8 1.5-2.6-1zm-4.2 22.2c-1.3 7.9-5 15.5-10.1 22.5c.2-2-1.2-2.4-2.6-2.8l0 0c-2.9-.8-5.9-1.6 5.6-16.1c-.5 1.9-2.1 4.6-3.7 7.3l0 0 0 0-.3 .4c-3.6 5.9-6.7 11 4 4.3l1-1.8c2.6-4.5 5-8.8 6-13.8h.1zm-55.6 33.9c7.1 .6 14.1 .6 21-1.1c-2.5 2.4-5.2 4.8-8.3 7.2c-11.1-1.7-21.2-6-12.7-6.1zm-92.6 11.6c3.6 7.1 6.4 11.5 9 15.7l.1 .2c2.3 3.7 4.4 7.1 6.8 11.7c-5.1-4.2-8.7-9.5-12.5-15l-.3-.5c-1.4-2.1-2.8-4.2-4.4-6.2l1.2-5.9h.1zm7.5-9.6c1.6 3.3 3.2 6.4 5.7 9.1l2.6 7.7-1.3-2.1c-3.2-5.3-6.3-10.6-8-16.7l.8 1.6 .2 .4zm238.9-41.6c-2.3 17.4-7.7 34.6-16 50.3c7.6-14.9 12.5-30.9 14.8-47.2l1.2-3.1zM35.6 110.6c.4 .8 1.4 .5 2.3 .3c1.9-.5 3.6-.9-.1 7.6c-.5 .3-1 .7-1.5 1l0 0 0 0c-1.4 .9-2.8 1.9-3.9 3c1.9-3.8 3.5-7.4 3.2-11.9zM25.3 152.3c-.7 3.7-1.5 7.9-3.4 13.9c.2-1.9 0-3.5-.2-4.9l0-.1c-.4-3.4-.7-6.3 4.3-12.8c-.3 1.2-.5 2.5-.7 3.8v.1z"
    ]
};
var $42ee1027226cd96e$export$b2dcd141e150a391 = {
    prefix: 'fab',
    iconName: 'openid',
    icon: [
        448,
        512,
        [],
        "f19b",
        "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
    ]
};
var $42ee1027226cd96e$export$792bea9ca32c60da = {
    prefix: 'fab',
    iconName: 'instalod',
    icon: [
        512,
        512,
        [],
        "e081",
        "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
    ]
};
var $42ee1027226cd96e$export$fe553f3645c5aefa = {
    prefix: 'fab',
    iconName: 'expeditedssl',
    icon: [
        496,
        512,
        [],
        "f23e",
        "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
    ]
};
var $42ee1027226cd96e$export$23a4f18e8bd9f913 = {
    prefix: 'fab',
    iconName: 'sellcast',
    icon: [
        448,
        512,
        [],
        "f2da",
        "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
    ]
};
var $42ee1027226cd96e$export$58fc652e3c488143 = {
    prefix: 'fab',
    iconName: 'square-twitter',
    icon: [
        448,
        512,
        [
            "twitter-square"
        ],
        "f081",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM351.3 199.3v0c0 86.7-66 186.6-186.6 186.6c-37.2 0-71.7-10.8-100.7-29.4c5.3 .6 10.4 .8 15.8 .8c30.7 0 58.9-10.4 81.4-28c-28.8-.6-53-19.5-61.3-45.5c10.1 1.5 19.2 1.5 29.6-1.2c-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3c-9-6-16.4-14.1-21.5-23.6s-7.8-20.2-7.7-31c0-12.2 3.2-23.4 8.9-33.1c32.3 39.8 80.8 65.8 135.2 68.6c-9.3-44.5 24-80.6 64-80.6c18.9 0 35.9 7.9 47.9 20.7c14.8-2.8 29-8.3 41.6-15.8c-4.9 15.2-15.2 28-28.8 36.1c13.2-1.4 26-5.1 37.8-10.2c-8.9 13.1-20.1 24.7-32.9 34c.2 2.8 .2 5.7 .2 8.5z"
    ]
};
var $42ee1027226cd96e$export$270370f3feaf6b90 = $42ee1027226cd96e$export$58fc652e3c488143;
var $42ee1027226cd96e$export$f9a04980ef22b6b0 = {
    prefix: 'fab',
    iconName: 'r-project',
    icon: [
        581,
        512,
        [],
        "f4f7",
        "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
    ]
};
var $42ee1027226cd96e$export$fc15ee5b2eab0af4 = {
    prefix: 'fab',
    iconName: 'delicious',
    icon: [
        448,
        512,
        [],
        "f1a5",
        "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
    ]
};
var $42ee1027226cd96e$export$1fa830857b3a4dc7 = {
    prefix: 'fab',
    iconName: 'freebsd',
    icon: [
        448,
        512,
        [],
        "f3a4",
        "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
    ]
};
var $42ee1027226cd96e$export$3e0cc9b4555f8145 = {
    prefix: 'fab',
    iconName: 'vuejs',
    icon: [
        448,
        512,
        [],
        "f41f",
        "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
    ]
};
var $42ee1027226cd96e$export$233214294e90ff53 = {
    prefix: 'fab',
    iconName: 'accusoft',
    icon: [
        640,
        512,
        [],
        "f369",
        "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
    ]
};
var $42ee1027226cd96e$export$d11e9e62a1442448 = {
    prefix: 'fab',
    iconName: 'ioxhost',
    icon: [
        640,
        512,
        [],
        "f208",
        "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
    ]
};
var $42ee1027226cd96e$export$e6a0ac478bf76bf2 = {
    prefix: 'fab',
    iconName: 'fonticons-fi',
    icon: [
        384,
        512,
        [],
        "f3a2",
        "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
    ]
};
var $42ee1027226cd96e$export$500760921a1e1f4e = {
    prefix: 'fab',
    iconName: 'app-store',
    icon: [
        512,
        512,
        [],
        "f36f",
        "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
    ]
};
var $42ee1027226cd96e$export$dd0d0d0b3b519db5 = {
    prefix: 'fab',
    iconName: 'cc-mastercard',
    icon: [
        576,
        512,
        [],
        "f1f1",
        "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
    ]
};
var $42ee1027226cd96e$export$a0c8448ba3e387bc = {
    prefix: 'fab',
    iconName: 'itunes-note',
    icon: [
        384,
        512,
        [],
        "f3b5",
        "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
    ]
};
var $42ee1027226cd96e$export$36cd41563937ec03 = {
    prefix: 'fab',
    iconName: 'golang',
    icon: [
        640,
        512,
        [],
        "e40f",
        "M400.1 194.8C389.2 197.6 380.2 199.1 371 202.4C363.7 204.3 356.3 206.3 347.8 208.5L347.2 208.6C343 209.8 342.6 209.9 338.7 205.4C334 200.1 330.6 196.7 324.1 193.5C304.4 183.9 285.4 186.7 267.7 198.2C246.5 211.9 235.6 232.2 235.9 257.4C236.2 282.4 253.3 302.9 277.1 306.3C299.1 309.1 316.9 301.7 330.9 285.8C333 283.2 334.9 280.5 337 277.5V277.5L337 277.5C337.8 276.5 338.5 275.4 339.3 274.2H279.2C272.7 274.2 271.1 270.2 273.3 264.9C277.3 255.2 284.8 239 289.2 230.9C290.1 229.1 292.3 225.1 296.1 225.1H397.2C401.7 211.7 409 198.2 418.8 185.4C441.5 155.5 468.1 139.9 506 133.4C537.8 127.8 567.7 130.9 594.9 149.3C619.5 166.1 634.7 188.9 638.8 218.8C644.1 260.9 631.9 295.1 602.1 324.4C582.4 345.3 557.2 358.4 528.2 364.3C522.6 365.3 517.1 365.8 511.7 366.3C508.8 366.5 506 366.8 503.2 367.1C474.9 366.5 449 358.4 427.2 339.7C411.9 326.4 401.3 310.1 396.1 291.2C392.4 298.5 388.1 305.6 382.1 312.3C360.5 341.9 331.2 360.3 294.2 365.2C263.6 369.3 235.3 363.4 210.3 344.7C187.3 327.2 174.2 304.2 170.8 275.5C166.7 241.5 176.7 210.1 197.2 184.2C219.4 155.2 248.7 136.8 284.5 130.3C313.8 124.1 341.8 128.4 367.1 145.6C383.6 156.5 395.4 171.4 403.2 189.5C405.1 192.3 403.8 193.9 400.1 194.8zM48.3 200.4C47.05 200.4 46.74 199.8 47.36 198.8L53.91 190.4C54.53 189.5 56.09 188.9 57.34 188.9H168.6C169.8 188.9 170.1 189.8 169.5 190.7L164.2 198.8C163.6 199.8 162 200.7 161.1 200.7L48.3 200.4zM1.246 229.1C0 229.1-.3116 228.4 .3116 227.5L6.855 219.1C7.479 218.2 9.037 217.5 10.28 217.5H152.4C153.6 217.5 154.2 218.5 153.9 219.4L151.4 226.9C151.1 228.1 149.9 228.8 148.6 228.8L1.246 229.1zM75.72 255.9C75.1 256.8 75.41 257.7 76.65 257.7L144.6 258C145.5 258 146.8 257.1 146.8 255.9L147.4 248.4C147.4 247.1 146.8 246.2 145.5 246.2H83.2C81.95 246.2 80.71 247.1 80.08 248.1L75.72 255.9zM577.2 237.9C577 235.3 576.9 233.1 576.5 230.9C570.9 200.1 542.5 182.6 512.9 189.5C483.9 196 465.2 214.4 458.4 243.7C452.8 268 464.6 292.6 487 302.6C504.2 310.1 521.3 309.2 537.8 300.7C562.4 287.1 575.8 268 577.4 241.2C577.3 240 577.3 238.9 577.2 237.9z"
    ]
};
var $42ee1027226cd96e$export$f06b8625c0ebb13a = {
    prefix: 'fab',
    iconName: 'kickstarter',
    icon: [
        448,
        512,
        [],
        "f3bb",
        "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
    ]
};
var $42ee1027226cd96e$export$fdcdacf548a335ed = {
    prefix: 'fab',
    iconName: 'grav',
    icon: [
        512,
        512,
        [],
        "f2d6",
        "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
    ]
};
var $42ee1027226cd96e$export$75bd846ccb390b1e = {
    prefix: 'fab',
    iconName: 'weibo',
    icon: [
        512,
        512,
        [],
        "f18a",
        "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
    ]
};
var $42ee1027226cd96e$export$e1cced2e7ea20eff = {
    prefix: 'fab',
    iconName: 'uncharted',
    icon: [
        448,
        512,
        [],
        "e084",
        "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
    ]
};
var $42ee1027226cd96e$export$44a54556e145bddf = {
    prefix: 'fab',
    iconName: 'firstdraft',
    icon: [
        384,
        512,
        [],
        "f3a1",
        "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
    ]
};
var $42ee1027226cd96e$export$1082b39fc1076b43 = {
    prefix: 'fab',
    iconName: 'square-youtube',
    icon: [
        448,
        512,
        [
            61798,
            "youtube-square"
        ],
        "f431",
        "M282 256.2l-95.2-54.1V310.3L282 256.2zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zm14.4 136.1c7.6 28.6 7.6 88.2 7.6 88.2s0 59.6-7.6 88.1c-4.2 15.8-16.5 27.7-32.2 31.9C337.9 384 224 384 224 384s-113.9 0-142.2-7.6c-15.7-4.2-28-16.1-32.2-31.9C42 315.9 42 256.3 42 256.3s0-59.7 7.6-88.2c4.2-15.8 16.5-28.2 32.2-32.4C110.1 128 224 128 224 128s113.9 0 142.2 7.7c15.7 4.2 28 16.6 32.2 32.4z"
    ]
};
var $42ee1027226cd96e$export$8992da42b645c563 = $42ee1027226cd96e$export$1082b39fc1076b43;
var $42ee1027226cd96e$export$6657c749288c4042 = {
    prefix: 'fab',
    iconName: 'wikipedia-w',
    icon: [
        640,
        512,
        [],
        "f266",
        "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
    ]
};
var $42ee1027226cd96e$export$66f88c21efa6f12d = {
    prefix: 'fab',
    iconName: 'wpressr',
    icon: [
        496,
        512,
        [
            "rendact"
        ],
        "f3e4",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
    ]
};
var $42ee1027226cd96e$export$d06b08e37a8aaaec = $42ee1027226cd96e$export$66f88c21efa6f12d;
var $42ee1027226cd96e$export$65f66dc47afb97bd = {
    prefix: 'fab',
    iconName: 'angellist',
    icon: [
        448,
        512,
        [],
        "f209",
        "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
    ]
};
var $42ee1027226cd96e$export$ba5a2dfe23db8bb6 = {
    prefix: 'fab',
    iconName: 'galactic-republic',
    icon: [
        496,
        512,
        [],
        "f50c",
        "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
    ]
};
var $42ee1027226cd96e$export$d637dd7b404459cf = {
    prefix: 'fab',
    iconName: 'nfc-directional',
    icon: [
        512,
        512,
        [],
        "e530",
        "M211.8 488.6C213.4 491.1 213.9 494.2 213.2 497.1C212.6 500 210.8 502.6 208.3 504.2C205.7 505.8 202.7 506.3 199.7 505.7C138.3 491.8 84.1 455.8 47.53 404.5C10.97 353.2-5.395 290.3 1.57 227.7C8.536 165 38.34 107.2 85.29 65.21C132.2 23.2 193-.0131 256 0C257.5 0 258.1 .2931 260.3 .8627C261.7 1.432 262.1 2.267 264 3.319C265.1 4.371 265.9 5.619 266.5 6.993C267 8.367 267.3 9.839 267.3 11.32V112.3L291.8 86.39C292.8 85.31 294 84.44 295.4 83.84C296.7 83.23 298.2 82.9 299.7 82.86C301.2 82.81 302.6 83.06 304 83.59C305.4 84.12 306.7 84.92 307.8 85.94C308.8 86.96 309.7 88.18 310.3 89.54C310.9 90.89 311.3 92.35 311.3 93.84C311.3 95.32 311.1 96.8 310.6 98.18C310 99.57 309.2 100.8 308.2 101.9L264.2 148.5C263.1 149.6 261.9 150.5 260.5 151.1C259 151.7 257.5 152 255.1 152C254.5 152 252.9 151.7 251.5 151.1C250.1 150.5 248.8 149.6 247.8 148.5L203.7 101.9C201.7 99.74 200.6 96.83 200.7 93.84C200.7 90.84 202 87.1 204.2 85.94C206.4 83.88 209.3 82.77 212.3 82.86C215.3 82.94 218.1 84.21 220.2 86.39L244.7 112.4V22.89C188.3 25.64 134.9 48.73 94.23 87.87C53.58 127 28.49 179.6 23.61 235.8C18.73 292 34.38 348.1 67.68 393.7C100.1 439.2 149.7 471.2 204.7 483.6C207.6 484.3 210.2 486.1 211.8 488.6L211.8 488.6zM171.4 126.1C170.6 127.4 169.5 128.5 168.3 129.3C147.8 143.2 131.1 161.9 119.5 183.8C107.9 205.7 101.8 230.1 101.8 254.9C101.8 279.7 107.9 304.1 119.5 325.1C131.1 347.9 147.8 366.6 168.3 380.5C170.8 382.2 172.5 384.8 173 387.8C173.6 390.7 172.1 393.8 171.3 396.2C169.6 398.7 166.1 400.4 164 400.1C161.1 401.5 158 400.9 155.6 399.2C132 383.2 112.8 361.7 99.46 336.5C86.15 311.4 79.19 283.4 79.19 254.9C79.19 226.5 86.15 198.4 99.46 173.3C112.8 148.1 132 126.6 155.6 110.6C156.8 109.8 158.2 109.2 159.6 108.8C161.1 108.5 162.6 108.5 164.1 108.8C165.5 109 166.9 109.6 168.2 110.4C169.5 111.2 170.5 112.3 171.4 113.5C172.2 114.7 172.8 116.1 173.1 117.6C173.4 119.1 173.4 120.6 173.1 122C172.8 123.5 172.3 124.9 171.4 126.1H171.4zM340.9 383.5C341.7 382.3 342.8 381.2 343.1 380.4V380.3C364.4 366.3 381.1 347.6 392.7 325.7C404.2 303.9 410.2 279.5 410.2 254.8C410.2 230.1 404.2 205.7 392.7 183.8C381.1 161.1 364.4 143.3 343.1 129.3C342.8 128.5 341.7 127.4 340.9 126.2C340.1 124.9 339.5 123.5 339.3 122.1C338.1 120.6 339 119.1 339.3 117.7C339.6 116.2 340.2 114.8 341 113.6C341.9 112.4 342.1 111.3 344.2 110.5C345.4 109.7 346.8 109.2 348.3 108.9C349.8 108.6 351.2 108.6 352.7 108.9C354.2 109.2 355.5 109.8 356.8 110.7C380.2 126.7 399.5 148.2 412.7 173.3C426 198.4 432.1 226.4 432.1 254.8C432.1 283.3 426 311.3 412.7 336.4C399.5 361.5 380.2 383 356.8 399C355.5 399.9 354.2 400.5 352.7 400.8C351.2 401.1 349.8 401.1 348.3 400.8C346.8 400.5 345.4 399.1 344.2 399.2C342.1 398.4 341.9 397.3 341 396.1C340.2 394.9 339.6 393.5 339.3 392C339 390.6 338.1 389.1 339.3 387.6C339.5 386.2 340.1 384.8 340.9 383.5V383.5zM312.3 6.307C368.5 19.04 418.7 50.28 455 95.01C485.4 132.6 504.6 178 510.3 226C515.9 274 507.9 322.7 487.1 366.3C466.2 409.9 433.5 446.8 392.6 472.6C351.7 498.3 304.4 512 256 512C254.5 512 253.1 511.7 251.7 511.1C250.3 510.6 249.1 509.7 248 508.7C246.1 507.6 246.1 506.4 245.6 505C245 503.6 244.7 502.2 244.7 500.7V401.5L220.2 427.5C218.1 429.7 215.3 430.1 212.3 431.1C209.3 431.2 206.4 430 204.2 427.1C202 425.9 200.7 423.1 200.7 420.1C200.6 417.1 201.7 414.2 203.7 412L247.8 365.4C249.1 363.2 252.9 362 255.1 362C259.1 362 262 363.2 264.2 365.4L308.2 412C310.3 414.2 311.4 417.1 311.3 420.1C311.2 423.1 309.9 425.9 307.8 427.1C305.6 430 302.7 431.2 299.7 431.1C296.7 430.1 293.8 429.7 291.8 427.5L267.3 401.6V489.1C323.7 486.3 377.1 463.3 417.8 424.1C458.5 384.1 483.6 332.4 488.5 276.2C493.3 219.1 477.7 163.9 444.4 118.3C411.1 72.75 362.4 40.79 307.4 28.36C305.9 28.03 304.6 27.42 303.3 26.57C302.1 25.71 301.1 24.63 300.3 23.37C299.5 22.12 298.1 20.72 298.7 19.26C298.5 17.8 298.5 16.3 298.8 14.85C299.2 13.41 299.8 12.04 300.6 10.82C301.5 9.61 302.6 8.577 303.8 7.784C305.1 6.99 306.5 6.451 307.9 6.198C309.4 5.945 310.9 5.982 312.3 6.307L312.3 6.307zM353.1 256.1C353.1 287.5 335.6 317.2 303.8 339.6C301.7 341.1 299 341.9 296.4 341.6C293.7 341.4 291.2 340.3 289.4 338.4L219.3 268.6C217.1 266.5 215.1 263.6 215.9 260.6C215.9 257.6 217.1 254.7 219.2 252.6C221.4 250.5 224.2 249.3 227.2 249.3C230.2 249.3 233.1 250.5 235.2 252.6L298.3 315.4C319.1 298.3 330.5 277.5 330.5 256.1C330.5 232.2 316.4 209.1 290.8 191C288.3 189.3 286.7 186.7 286.2 183.7C285.7 180.8 286.3 177.7 288.1 175.3C289.8 172.8 292.4 171.2 295.4 170.7C298.3 170.2 301.4 170.8 303.8 172.6C335.6 195 353.1 224.7 353.1 256.1V256.1zM216.7 341.5C213.7 342 210.7 341.3 208.2 339.6C176.5 317.2 158.1 287.5 158.1 256.1C158.1 224.7 176.5 195 208.2 172.6C210.4 171 213.1 170.3 215.7 170.5C218.4 170.8 220.8 171.9 222.7 173.8L292.8 243.6C294.9 245.7 296.1 248.6 296.1 251.6C296.1 254.6 294.1 257.4 292.8 259.6C290.7 261.7 287.8 262.9 284.9 262.9C281.9 262.9 278.1 261.7 276.9 259.6L213.8 196.7C192.9 214 181.6 234.7 181.6 256.1C181.6 279.1 195.7 303.1 221.3 321.1C223.7 322.9 225.4 325.5 225.9 328.5C226.4 331.4 225.7 334.4 224 336.9C222.3 339.3 219.6 341 216.7 341.5L216.7 341.5z"
    ]
};
var $42ee1027226cd96e$export$78370b1b91348c9e = {
    prefix: 'fab',
    iconName: 'skype',
    icon: [
        448,
        512,
        [],
        "f17e",
        "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
    ]
};
var $42ee1027226cd96e$export$ae307621d0877ba2 = {
    prefix: 'fab',
    iconName: 'joget',
    icon: [
        496,
        512,
        [],
        "f3b7",
        "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
    ]
};
var $42ee1027226cd96e$export$8cf9f3ca16e668b0 = {
    prefix: 'fab',
    iconName: 'fedora',
    icon: [
        448,
        512,
        [],
        "f798",
        "M.0413 255.8C.1219 132.2 100.3 32 224 32C347.7 32 448 132.3 448 256C448 379.7 347.8 479.9 224.1 480H50.93C22.84 480 .0832 457.3 .0416 429.2H0V255.8H.0413zM342.6 192.7C342.6 153 307 124.2 269.4 124.2C234.5 124.2 203.6 150.5 199.3 184.1C199.1 187.9 198.9 189.1 198.9 192.6C198.8 213.7 198.9 235.4 198.1 257C199 283.1 199.1 309.1 198.1 333.6C198.1 360.7 178.7 379.1 153.4 379.1C128.1 379.1 107.6 358.9 107.6 333.6C108.1 305.9 130.2 288.3 156.1 287.5H156.3L182.6 287.3V250L156.3 250.2C109.2 249.8 71.72 286.7 70.36 333.6C70.36 379.2 107.9 416.5 153.4 416.5C196.4 416.5 232.1 382.9 236 340.9L236.2 287.4L268.8 287.1C294.1 287.3 293.8 249.3 268.6 249.8L236.2 250.1C236.2 243.7 236.3 237.3 236.3 230.9C236.4 218.2 236.4 205.5 236.2 192.7C236.3 176.2 252 161.5 269.4 161.5C286.9 161.5 305.3 170.2 305.3 192.7C305.3 195.9 305.2 197.8 305 199C303.1 209.5 310.2 219.4 320.7 220.9C331.3 222.4 340.9 214.8 341.9 204.3C342.5 200.1 342.6 196.4 342.6 192.7H342.6z"
    ]
};
var $42ee1027226cd96e$export$4823078d958b443a = {
    prefix: 'fab',
    iconName: 'stripe-s',
    icon: [
        384,
        512,
        [],
        "f42a",
        "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
    ]
};
var $42ee1027226cd96e$export$75b94550e27ccec5 = {
    prefix: 'fab',
    iconName: 'meta',
    icon: [
        640,
        512,
        [],
        "e49b",
        "M640 317.9C640 409.2 600.6 466.4 529.7 466.4C467.1 466.4 433.9 431.8 372.8 329.8L341.4 277.2C333.1 264.7 326.9 253 320.2 242.2C300.1 276 273.1 325.2 273.1 325.2C206.1 441.8 168.5 466.4 116.2 466.4C43.42 466.4 0 409.1 0 320.5C0 177.5 79.78 42.4 183.9 42.4C234.1 42.4 277.7 67.08 328.7 131.9C365.8 81.8 406.8 42.4 459.3 42.4C558.4 42.4 640 168.1 640 317.9H640zM287.4 192.2C244.5 130.1 216.5 111.7 183 111.7C121.1 111.7 69.22 217.8 69.22 321.7C69.22 370.2 87.7 397.4 118.8 397.4C149 397.4 167.8 378.4 222 293.6C222 293.6 246.7 254.5 287.4 192.2V192.2zM531.2 397.4C563.4 397.4 578.1 369.9 578.1 322.5C578.1 198.3 523.8 97.08 454.9 97.08C421.7 97.08 393.8 123 360 175.1C369.4 188.9 379.1 204.1 389.3 220.5L426.8 282.9C485.5 377 500.3 397.4 531.2 397.4L531.2 397.4z"
    ]
};
var $42ee1027226cd96e$export$bfe42001388ccf42 = {
    prefix: 'fab',
    iconName: 'laravel',
    icon: [
        512,
        512,
        [],
        "f3bd",
        "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
    ]
};
var $42ee1027226cd96e$export$d309e8b75a17a518 = {
    prefix: 'fab',
    iconName: 'hotjar',
    icon: [
        512,
        512,
        [],
        "f3b1",
        "M361.5 0c0 131.6-80.7 176.8-140.2 209.4c-.6 .3-1.1 .6-1.6 .9c-53.8 30.2-88.7 49.8-89.6 122H32C32 200.8 112.7 155.6 172.2 123C227 93.2 262.5 73 262.5 0h98.9zM301 302.6c54.8-29.8 90.3-50 90.3-123h98c0 131.6-80.7 176.7-140.2 209.4c-54.8 29.8-90.3 50-90.3 123h-98c0-131.6 80.7-176.8 140.2-209.4z"
    ]
};
var $42ee1027226cd96e$export$ad4174fe3fc4abe2 = {
    prefix: 'fab',
    iconName: 'bluetooth-b',
    icon: [
        320,
        512,
        [],
        "f294",
        "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
    ]
};
var $42ee1027226cd96e$export$628b421165d7d11a = {
    prefix: 'fab',
    iconName: 'square-letterboxd',
    icon: [
        448,
        512,
        [],
        "e62e",
        "M384 32c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H384zM105.1 187C66.4 187 35 218.3 35 257s31.4 70 70.1 70c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1c-12.4-19.8-34.4-32.9-59.5-32.9zM224 187c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1C176.9 313.8 198.9 327 224 327c24.8 0 46.5-12.8 59-32.2l.5-.7-.4-.6c-6.5-10.6-10.2-23.1-10.2-36.5c0-13.6 3.9-26.3 10.6-37.1C271.1 200.2 249.1 187 224 187zm118.9 0c-24.8 0-46.5 12.8-59 32.2l-.5 .7 .4 .6c6.5 10.6 10.2 23.1 10.2 36.5c0 13.6-3.9 26.3-10.6 37.1c12.4 19.8 34.4 32.9 59.5 32.9c38.7 0 70.1-31.3 70.1-70s-31.4-70-70.1-70z"
    ]
};
var $42ee1027226cd96e$export$439612f87b462a40 = {
    prefix: 'fab',
    iconName: 'sticker-mule',
    icon: [
        576,
        512,
        [],
        "f3f7",
        "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
    ]
};
var $42ee1027226cd96e$export$72df0aea6a5da9de = {
    prefix: 'fab',
    iconName: 'creative-commons-zero',
    icon: [
        496,
        512,
        [],
        "f4f3",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
    ]
};
var $42ee1027226cd96e$export$51de6451f4c7b107 = {
    prefix: 'fab',
    iconName: 'hips',
    icon: [
        640,
        512,
        [],
        "f452",
        "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
    ]
};
var $42ee1027226cd96e$export$907c17a7f1d6a0d3 = {
    prefix: 'fab',
    iconName: 'behance',
    icon: [
        576,
        512,
        [],
        "f1b4",
        "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
    ]
};
var $42ee1027226cd96e$export$97dd0b04d798af1a = {
    prefix: 'fab',
    iconName: 'reddit',
    icon: [
        512,
        512,
        [],
        "f1a1",
        "M0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256L37.1 512c-13.7 0-20.5-16.5-10.9-26.2L75 437C28.7 390.7 0 326.7 0 256zM349.6 153.6c23.6 0 42.7-19.1 42.7-42.7s-19.1-42.7-42.7-42.7c-20.6 0-37.8 14.6-41.8 34c-34.5 3.7-61.4 33-61.4 68.4l0 .2c-37.5 1.6-71.8 12.3-99 29.1c-10.1-7.8-22.8-12.5-36.5-12.5c-33 0-59.8 26.8-59.8 59.8c0 24 14.1 44.6 34.4 54.1c2 69.4 77.6 125.2 170.6 125.2s168.7-55.9 170.6-125.3c20.2-9.6 34.1-30.2 34.1-54c0-33-26.8-59.8-59.8-59.8c-13.7 0-26.3 4.6-36.4 12.4c-27.4-17-62.1-27.7-100-29.1l0-.2c0-25.4 18.9-46.5 43.4-49.9l0 0c4.4 18.8 21.3 32.8 41.5 32.8zM177.1 246.9c16.7 0 29.5 17.6 28.5 39.3s-13.5 29.6-30.3 29.6s-31.4-8.8-30.4-30.5s15.4-38.3 32.1-38.3zm190.1 38.3c1 21.7-13.7 30.5-30.4 30.5s-29.3-7.9-30.3-29.6c-1-21.7 11.8-39.3 28.5-39.3s31.2 16.6 32.1 38.3zm-48.1 56.7c-10.3 24.6-34.6 41.9-63 41.9s-52.7-17.3-63-41.9c-1.2-2.9 .8-6.2 3.9-6.5c18.4-1.9 38.3-2.9 59.1-2.9s40.7 1 59.1 2.9c3.1 .3 5.1 3.6 3.9 6.5z"
    ]
};
var $42ee1027226cd96e$export$c8d4525a5e9ad3ad = {
    prefix: 'fab',
    iconName: 'discord',
    icon: [
        640,
        512,
        [],
        "f392",
        "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
    ]
};
var $42ee1027226cd96e$export$430df45ec2fae593 = {
    prefix: 'fab',
    iconName: 'chrome',
    icon: [
        512,
        512,
        [],
        "f268",
        "M0 256C0 209.4 12.47 165.6 34.27 127.1L144.1 318.3C166 357.5 207.9 384 256 384C270.3 384 283.1 381.7 296.8 377.4L220.5 509.6C95.9 492.3 0 385.3 0 256zM365.1 321.6C377.4 302.4 384 279.1 384 256C384 217.8 367.2 183.5 340.7 160H493.4C505.4 189.6 512 222.1 512 256C512 397.4 397.4 511.1 256 512L365.1 321.6zM477.8 128H256C193.1 128 142.3 172.1 130.5 230.7L54.19 98.47C101 38.53 174 0 256 0C350.8 0 433.5 51.48 477.8 128V128zM168 256C168 207.4 207.4 168 256 168C304.6 168 344 207.4 344 256C344 304.6 304.6 344 256 344C207.4 344 168 304.6 168 256z"
    ]
};
var $42ee1027226cd96e$export$e36cec8e481a3a4b = {
    prefix: 'fab',
    iconName: 'app-store-ios',
    icon: [
        448,
        512,
        [],
        "f370",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
    ]
};
var $42ee1027226cd96e$export$4a929e0a1abf7e41 = {
    prefix: 'fab',
    iconName: 'cc-discover',
    icon: [
        576,
        512,
        [],
        "f1f2",
        "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
    ]
};
var $42ee1027226cd96e$export$a24323c111493948 = {
    prefix: 'fab',
    iconName: 'wpbeginner',
    icon: [
        512,
        512,
        [],
        "f297",
        "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
    ]
};
var $42ee1027226cd96e$export$259f76b402dd445f = {
    prefix: 'fab',
    iconName: 'confluence',
    icon: [
        512,
        512,
        [],
        "f78d",
        "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
    ]
};
var $42ee1027226cd96e$export$b4e2b27ee3ee1821 = {
    prefix: 'fab',
    iconName: 'shoelace',
    icon: [
        512,
        512,
        [],
        "e60c",
        "M404.9 331c2.2-1.1 4.4-2.3 6.5-3.7l8.3-4.8c1.5-1.1 4.4-3.4 8.7-6.7l.5-.5c3.4-3.4 7.2-5 11.3-4.9c1.8 0 3.9 .5 6.4 1.5l31-27.5c.9-.7 1.7-1.3 2.6-1.8h.2c3.3-1.9 6-1.8 8.2 .4c3.9 2.1 4.2 5.6 .9 10.6L456.9 322c.2 .5 .4 1 .4 1.5c.5 2.2 .3 4.4-.5 6.6c-.7 1.5-1.8 2.9-3.1 4.2c-1.4 1.4-2.7 2.8-4.2 4.2l-18.8 13.7c-1.7 1.2-3.4 2.3-5.1 3.3c-2.1 1.3-4.3 2.5-6.6 3.6c-1 .4-1.9 .9-2.9 1.3c-5.9 2.5-11.9 4.2-18.2 5c-2.9 24.5-11.3 47.1-25.1 67.8c-17.5 25.7-41.4 45.4-71.8 58.8c-30.2 13.5-63 20.2-98.2 20.2c-48.6-.5-88-11.4-118.2-32.8C49.5 454.4 32 421.5 32 380.3v-5.6c1.2-28.1 9.5-54.6 24.8-79.8c15.1-24.9 37.1-41.7 66.1-50.5c14.9-4.4 29.9-6.6 45-6.6c15.5 0 31.6 2.9 48.1 8.6s35.2 15.5 55.9 29.5L326 312.2c15.1 9.8 28.8 16.5 41.2 20c-2.6-25.1-11.7-46.6-27.3-64.5c-15.7-18.1-35.6-31.3-59.9-39.7l-23.3-8c-21.4-7.5-37.3-14.9-47.7-22.2c-28.2-19.1-43.8-45.2-47-78.5l-.5-9.8c0-32.1 13-58.9 39-80.5C223.5 9.7 251.1 0 283 0c24 0 45.6 6.9 64.7 20.8c19.2 14 30.1 33.8 32.6 59.4l.5 10c0 18.6-4.8 34.5-14.4 47.7c-9.8 13.2-18.5 19.9-26 19.9c-1.6-.1-3.1-.3-4.5-.6l-34 32c-5.5 3-9.2 2.5-11.1-1.6c-1.9-2.2-1.8-4.9 .5-8.2l.2-.2c.5-.7 1.2-1.5 2-2.4l31.6-30c-.4-1.5-.6-3.1-.6-4.8c0-4.1 1.6-7.6 4.9-10.4c13.8-12.4 20.8-26.7 20.8-42.8c0-16-6.1-29.5-18.2-40.4s-28.7-16.5-49.7-16.8c-26.2 0-47.8 7.9-64.7 23.7S192.3 89.9 192.3 112c0 17.8 6.9 33.9 20.6 48.3c13.6 14.2 34.6 25.4 63 33.5c39.8 11.5 70.2 31 91.3 58.3c18.7 24.2 29.1 51.3 31.3 81.4c2.2-.7 4.3-1.5 6.5-2.6zM294.1 178.7c0 1.1 .6 1.6 1.8 1.6c.1 0 9.7-8.9 28.8-26.6c0-2.4-5.1 .9-15.3 10c-10.2 9.2-15.3 14.2-15.3 14.9zm8 6.4c0-1-.5-1.5-1.5-1.5c-1.1 0-2.1 .5-2.9 1.6c-1.9-.1-3.3 .1-4.2 .7c-.4 .2-.5 .5-.5 .7c0 .7 .5 1.3 1.5 1.6h3.3c2.9-1.1 4.4-2.2 4.4-3.3zm22.6-19.9c0-2.8-1.6-2.8-4.9 0c-1.6 1.5-3.6 3.5-6 6.2c-.8 .6-2.6 2.2-5.3 4.9c-2.8 2.9-4.2 4.7-4.2 5.3l.2 1.3c.7 .2 1.2 .4 1.5 .4c.1 0 3.3-2.9 9.5-8.7s9.3-8.9 9.3-9.3zm159.7 120l-30.6 27c1.8 1 3.2 2.4 4 4.2l30.2-27c.2-1.2 .1-2.2-.5-2.9c-.6-.5-1.6-.9-3.1-1.3zm-1.6-.9l-.7-.7-27 21.9 1.6 2 26-23.1zM366.6 363.9c-8-2.1-15.4-4.6-22.2-7.5c-15.3-6.2-34.3-17-57-32.4L250 298.7c-15.8-10.1-30.2-17.6-43.2-22.6c-13.1-4.9-26-7.3-38.6-7.3h-5.5c-32.2 1.7-57.2 13.8-75 36.2c-16.6 20.8-25 45.3-25 73.6c0 31.8 12.8 56.7 38.2 74.7c25.4 18.1 60.2 27.1 104.4 27.1c34.7 0 64-6.2 87.8-18.6c23.7-12.4 42.1-28.8 55.2-49.2c9.8-15.5 15.9-31.8 18.2-48.8z"
    ]
};
var $42ee1027226cd96e$export$7add95166ef0248a = {
    prefix: 'fab',
    iconName: 'mdb',
    icon: [
        576,
        512,
        [],
        "f8ca",
        "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
    ]
};
var $42ee1027226cd96e$export$81d728fa770edbe1 = {
    prefix: 'fab',
    iconName: 'dochub',
    icon: [
        416,
        512,
        [],
        "f394",
        "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
    ]
};
var $42ee1027226cd96e$export$3c152d640f62968e = {
    prefix: 'fab',
    iconName: 'accessible-icon',
    icon: [
        448,
        512,
        [
            62107
        ],
        "f368",
        "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
    ]
};
var $42ee1027226cd96e$export$ddb611ff59fc9802 = {
    prefix: 'fab',
    iconName: 'ebay',
    icon: [
        640,
        512,
        [],
        "f4f4",
        "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
    ]
};
var $42ee1027226cd96e$export$ebc1e565fd80a447 = {
    prefix: 'fab',
    iconName: 'amazon',
    icon: [
        448,
        512,
        [],
        "f270",
        "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
    ]
};
var $42ee1027226cd96e$export$3997191a5880488f = {
    prefix: 'fab',
    iconName: 'unsplash',
    icon: [
        448,
        512,
        [],
        "e07c",
        "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
    ]
};
var $42ee1027226cd96e$export$a67629e1d516967d = {
    prefix: 'fab',
    iconName: 'yarn',
    icon: [
        496,
        512,
        [],
        "f7e3",
        "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
    ]
};
var $42ee1027226cd96e$export$c334a5e9c1f73381 = {
    prefix: 'fab',
    iconName: 'square-steam',
    icon: [
        448,
        512,
        [
            "steam-square"
        ],
        "f1b7",
        "M165.6 309.1c18.6 7.7 27.3 28.9 19.6 47.4s-29 27.2-47.6 19.4l-28.5-11.8c5 10.6 13.8 19.4 25.4 24.2c25.2 10.5 54.1-1.4 64.6-26.5c5.1-12.1 5.1-25.5 .1-37.7c-5.1-12.1-14.5-21.6-26.7-26.7c-12.1-5-25-4.8-36.4-.5l29.5 12.2zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V240.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8c-31.8 0-58.5-22.7-64.5-52.7L0 319.2V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM241.9 196.2a58.4 58.4 0 1 0 116.8 0 58.4 58.4 0 1 0 -116.8 0zm14.6-.1a43.9 43.9 0 1 1 87.8 0 43.9 43.9 0 1 1 -87.8 0z"
    ]
};
var $42ee1027226cd96e$export$b0e9b012d636da0a = $42ee1027226cd96e$export$c334a5e9c1f73381;
var $42ee1027226cd96e$export$4adb509bb23593b0 = {
    prefix: 'fab',
    iconName: '500px',
    icon: [
        448,
        512,
        [],
        "f26e",
        "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
    ]
};
var $42ee1027226cd96e$export$8974793285f35ac8 = {
    prefix: 'fab',
    iconName: 'square-vimeo',
    icon: [
        448,
        512,
        [
            "vimeo-square"
        ],
        "f194",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM318.5 309.5C275 366 238.2 394.3 208.1 394.3c-18.7 0-34.4-17.2-47.3-51.6c-3.8-13.9-7.3-26.9-10.5-39c-18.2-68.3-28.6-107.4-46.2-107.4c-2.4 0-10.8 5-25.1 15.1L64 192c7-6.1 13.9-12.4 20.6-18.5c29.1-26.3 55.6-50.3 73.5-51.9c24.9-2.4 40.2 14.6 46 51.1c20.5 129.6 29.6 149.2 66.8 90.5c13.4-21.2 20.6-37.2 21.5-48.3c3.4-32.8-25.6-30.6-45.2-22.2c15.7-51.5 45.8-76.5 90.1-75.1c32.9 1 48.4 22.4 46.5 64c-1.4 31.1-23.2 73.8-65.3 127.9z"
    ]
};
var $42ee1027226cd96e$export$78628c2da1e685b5 = $42ee1027226cd96e$export$8974793285f35ac8;
var $42ee1027226cd96e$export$50ef858a08ddd1e5 = {
    prefix: 'fab',
    iconName: 'asymmetrik',
    icon: [
        576,
        512,
        [],
        "f372",
        "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
    ]
};
var $42ee1027226cd96e$export$aa4baaed1c60f58d = {
    prefix: 'fab',
    iconName: 'font-awesome',
    icon: [
        448,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M448 48V384C385 407 366 416 329 416C266 416 242 384 179 384C159 384 143 388 128 392V328C143 324 159 320 179 320C242 320 266 352 329 352C349 352 364 349 384 343V135C364 141 349 144 329 144C266 144 242 112 179 112C128 112 104 133 64 141V448C64 466 50 480 32 480S0 466 0 448V64C0 46 14 32 32 32S64 46 64 64V77C104 69 128 48 179 48C242 48 266 80 329 80C366 80 385 71 448 48Z"
    ]
};
var $42ee1027226cd96e$export$102c25fde54d4843 = $42ee1027226cd96e$export$aa4baaed1c60f58d;
var $42ee1027226cd96e$export$6e20d421a2e0f320 = $42ee1027226cd96e$export$aa4baaed1c60f58d;
var $42ee1027226cd96e$export$cf1aa567b9609235 = {
    prefix: 'fab',
    iconName: 'gratipay',
    icon: [
        496,
        512,
        [],
        "f184",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
    ]
};
var $42ee1027226cd96e$export$a649d390c50fd6df = {
    prefix: 'fab',
    iconName: 'apple',
    icon: [
        384,
        512,
        [],
        "f179",
        "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
    ]
};
var $42ee1027226cd96e$export$f5cdac644000a430 = {
    prefix: 'fab',
    iconName: 'hive',
    icon: [
        512,
        512,
        [],
        "e07f",
        "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
    ]
};
var $42ee1027226cd96e$export$cd2223c7b77bd41c = {
    prefix: 'fab',
    iconName: 'gitkraken',
    icon: [
        592,
        512,
        [],
        "f3a6",
        "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
    ]
};
var $42ee1027226cd96e$export$c80d8749c6106849 = {
    prefix: 'fab',
    iconName: 'keybase',
    icon: [
        448,
        512,
        [],
        "f4f5",
        "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
    ]
};
var $42ee1027226cd96e$export$fbfbf4eeb373a6ab = {
    prefix: 'fab',
    iconName: 'apple-pay',
    icon: [
        640,
        512,
        [],
        "f415",
        "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
    ]
};
var $42ee1027226cd96e$export$369427eba18eb826 = {
    prefix: 'fab',
    iconName: 'padlet',
    icon: [
        640,
        512,
        [],
        "e4a0",
        "M297.9 0L298 .001C305.6 .1078 312.4 4.72 315.5 11.78L447.5 320.3L447.8 320.2L448 320.6L445.2 330.6L402.3 488.6C398.6 504.8 382.6 514.9 366.5 511.2L298.1 495.6L229.6 511.2C213.5 514.9 197.5 504.8 193.8 488.6L150.9 330.6L148.2 320.6L148.3 320.2L280.4 11.78C283.4 4.797 290.3 .1837 297.9 .0006L297.9 0zM160.1 322.1L291.1 361.2L298 483.7L305.9 362.2L436.5 322.9L436.7 322.8L305.7 347.9L297.1 27.72L291.9 347.9L160.1 322.1zM426 222.6L520.4 181.6H594.2L437.2 429.2L468.8 320.2L426 222.6zM597.5 181.4L638.9 257.6C642.9 265.1 635 273.5 627.3 269.8L579.7 247.1L597.5 181.4zM127.3 318.5L158.7 430L1.61 154.5C-4.292 144.1 7.128 132.5 17.55 138.3L169.4 222.5L127.3 318.5z"
    ]
};
var $42ee1027226cd96e$export$448eb0f9d8323c85 = {
    prefix: 'fab',
    iconName: 'amazon-pay',
    icon: [
        640,
        512,
        [],
        "f42c",
        "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
    ]
};
var $42ee1027226cd96e$export$be5db653ba5b5871 = {
    prefix: 'fab',
    iconName: 'square-github',
    icon: [
        448,
        512,
        [
            "github-square"
        ],
        "f092",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM265.8 407.7c0-1.8 0-6 .1-11.6c.1-11.4 .1-28.8 .1-43.7c0-15.6-5.2-25.5-11.3-30.7c37-4.1 76-9.2 76-73.1c0-18.2-6.5-27.3-17.1-39c1.7-4.3 7.4-22-1.7-45c-13.9-4.3-45.7 17.9-45.7 17.9c-13.2-3.7-27.5-5.6-41.6-5.6s-28.4 1.9-41.6 5.6c0 0-31.8-22.2-45.7-17.9c-9.1 22.9-3.5 40.6-1.7 45c-10.6 11.7-15.6 20.8-15.6 39c0 63.6 37.3 69 74.3 73.1c-4.8 4.3-9.1 11.7-10.6 22.3c-9.5 4.3-33.8 11.7-48.3-13.9c-9.1-15.8-25.5-17.1-25.5-17.1c-16.2-.2-1.1 10.2-1.1 10.2c10.8 5 18.4 24.2 18.4 24.2c9.7 29.7 56.1 19.7 56.1 19.7c0 9 .1 21.7 .1 30.6c0 4.8 .1 8.6 .1 10c0 4.3-3 9.5-11.5 8C106 393.6 59.8 330.8 59.8 257.4c0-91.8 70.2-161.5 162-161.5s166.2 69.7 166.2 161.5c.1 73.4-44.7 136.3-110.7 158.3c-8.4 1.5-11.5-3.7-11.5-8zm-90.5-54.8c-.2-1.5 1.1-2.8 3-3.2c1.9-.2 3.7 .6 3.9 1.9c.3 1.3-1 2.6-3 3c-1.9 .4-3.7-.4-3.9-1.7zm-9.1 3.2c-2.2 .2-3.7-.9-3.7-2.4c0-1.3 1.5-2.4 3.5-2.4c1.9-.2 3.7 .9 3.7 2.4c0 1.3-1.5 2.4-3.5 2.4zm-14.3-2.2c-1.9-.4-3.2-1.9-2.8-3.2s2.4-1.9 4.1-1.5c2 .6 3.3 2.1 2.8 3.4c-.4 1.3-2.4 1.9-4.1 1.3zm-12.5-7.3c-1.5-1.3-1.9-3.2-.9-4.1c.9-1.1 2.8-.9 4.3 .6c1.3 1.3 1.8 3.3 .9 4.1c-.9 1.1-2.8 .9-4.3-.6zm-8.5-10c-1.1-1.5-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3c1.1 1.5 1.1 3.3 0 4.1c-.9 .6-2.6 0-3.7-1.5zm-6.3-8.8c-1.1-1.3-1.3-2.8-.4-3.5c.9-.9 2.4-.4 3.5 .6c1.1 1.3 1.3 2.8 .4 3.5c-.9 .9-2.4 .4-3.5-.6zm-6-6.4c-1.3-.6-1.9-1.7-1.5-2.6c.4-.6 1.5-.9 2.8-.4c1.3 .7 1.9 1.8 1.5 2.6c-.4 .9-1.7 1.1-2.8 .4z"
    ]
};
var $42ee1027226cd96e$export$5fe0a956971aa3c2 = $42ee1027226cd96e$export$be5db653ba5b5871;
var $42ee1027226cd96e$export$7872bf6ac6945976 = {
    prefix: 'fab',
    iconName: 'stumbleupon',
    icon: [
        512,
        512,
        [],
        "f1a4",
        "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
    ]
};
var $42ee1027226cd96e$export$c9127779112e2ff8 = {
    prefix: 'fab',
    iconName: 'fedex',
    icon: [
        640,
        512,
        [],
        "f797",
        "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
    ]
};
var $42ee1027226cd96e$export$3d9357caf53f9b59 = {
    prefix: 'fab',
    iconName: 'phoenix-framework',
    icon: [
        640,
        512,
        [],
        "f3dc",
        "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
    ]
};
var $42ee1027226cd96e$export$c18d8940c93637ce = {
    prefix: 'fab',
    iconName: 'shopify',
    icon: [
        448,
        512,
        [],
        "e057",
        "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
    ]
};
var $42ee1027226cd96e$export$a38c2efcceaf5a01 = {
    prefix: 'fab',
    iconName: 'neos',
    icon: [
        512,
        512,
        [],
        "f612",
        "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
    ]
};
var $42ee1027226cd96e$export$75f15eb229650b3a = {
    prefix: 'fab',
    iconName: 'square-threads',
    icon: [
        448,
        512,
        [],
        "e619",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"
    ]
};
var $42ee1027226cd96e$export$5fb7eeed7d5e4dea = {
    prefix: 'fab',
    iconName: 'hackerrank',
    icon: [
        512,
        512,
        [],
        "f5f7",
        "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
    ]
};
var $42ee1027226cd96e$export$5c5693a4f82cd9eb = {
    prefix: 'fab',
    iconName: 'researchgate',
    icon: [
        448,
        512,
        [],
        "f4f8",
        "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
    ]
};
var $42ee1027226cd96e$export$dcdf312747bb3471 = {
    prefix: 'fab',
    iconName: 'swift',
    icon: [
        448,
        512,
        [],
        "f8e1",
        "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
    ]
};
var $42ee1027226cd96e$export$9df3e2a7a3f59b3b = {
    prefix: 'fab',
    iconName: 'angular',
    icon: [
        448,
        512,
        [],
        "f420",
        "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
    ]
};
var $42ee1027226cd96e$export$90ae1a3824ece6f2 = {
    prefix: 'fab',
    iconName: 'speakap',
    icon: [
        448,
        512,
        [],
        "f3f3",
        "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
    ]
};
var $42ee1027226cd96e$export$a9e7bf021125ee89 = {
    prefix: 'fab',
    iconName: 'angrycreative',
    icon: [
        640,
        512,
        [],
        "f36e",
        "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
    ]
};
var $42ee1027226cd96e$export$9ee2f35ed1fe0fd4 = {
    prefix: 'fab',
    iconName: 'y-combinator',
    icon: [
        448,
        512,
        [],
        "f23b",
        "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
    ]
};
var $42ee1027226cd96e$export$c966a5d80266ef06 = {
    prefix: 'fab',
    iconName: 'empire',
    icon: [
        496,
        512,
        [],
        "f1d1",
        "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
    ]
};
var $42ee1027226cd96e$export$9e2c7c55d2fddd0 = {
    prefix: 'fab',
    iconName: 'envira',
    icon: [
        448,
        512,
        [],
        "f299",
        "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
    ]
};
var $42ee1027226cd96e$export$ed92c068824a8084 = {
    prefix: 'fab',
    iconName: 'google-scholar',
    icon: [
        512,
        512,
        [],
        "e63b",
        "M390.9 298.5c0 0 0 .1 .1 .1c9.2 19.4 14.4 41.1 14.4 64C405.3 445.1 338.5 512 256 512s-149.3-66.9-149.3-149.3c0-22.9 5.2-44.6 14.4-64h0c1.7-3.6 3.6-7.2 5.6-10.7c4.4-7.6 9.4-14.7 15-21.3c27.4-32.6 68.5-53.3 114.4-53.3c33.6 0 64.6 11.1 89.6 29.9c9.1 6.9 17.4 14.7 24.8 23.5c5.6 6.6 10.6 13.8 15 21.3c2 3.4 3.8 7 5.5 10.5zm26.4-18.8c-30.1-58.4-91-98.4-161.3-98.4s-131.2 40-161.3 98.4L0 202.7 256 0 512 202.7l-94.7 77.1z"
    ]
};
var $42ee1027226cd96e$export$1c14974e1904bc76 = {
    prefix: 'fab',
    iconName: 'square-gitlab',
    icon: [
        448,
        512,
        [
            "gitlab-square"
        ],
        "e5ae",
        "M0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96zm337.5 12.5l44.6 116.4 .4 1.2c5.6 16.8 7.2 35.2 2.3 52.5c-5 17.2-15.4 32.4-29.8 43.3l-.2 .1-68.4 51.2-54.1 40.9c-.5 .2-1.1 .5-1.7 .8c-2 1-4.4 2-6.7 2c-3 0-6.8-1.8-8.3-2.8l-54.2-40.9L93.5 322.3l-.4-.3-.2-.1c-14.3-10.8-24.8-26-29.7-43.3s-4.2-35.7 2.2-52.5l.5-1.2 44.7-116.4c.9-2.3 2.5-4.3 4.5-5.6c1.6-1 3.4-1.6 5.2-1.8c1.3-.7 2.1-.4 3.4 .1c.6 .2 1.2 .5 2 .7c1 .4 1.6 .9 2.4 1.5c.6 .4 1.2 1 2.1 1.5c1.2 1.4 2.2 3 2.7 4.8l29.2 92.2H285l30.2-92.2c.5-1.8 1.4-3.4 2.6-4.8s2.8-2.4 4.5-3.1c1.7-.6 3.6-.9 5.4-.7s3.6 .8 5.2 1.8c2 1.3 3.7 3.3 4.6 5.6z"
    ]
};
var $42ee1027226cd96e$export$4459a47a802afa29 = $42ee1027226cd96e$export$1c14974e1904bc76;
var $42ee1027226cd96e$export$9d71d8f56add75cb = {
    prefix: 'fab',
    iconName: 'studiovinari',
    icon: [
        512,
        512,
        [],
        "f3f8",
        "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
    ]
};
var $42ee1027226cd96e$export$13581f4cc240d7d9 = {
    prefix: 'fab',
    iconName: 'pied-piper',
    icon: [
        480,
        512,
        [],
        "f2ae",
        "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
    ]
};
var $42ee1027226cd96e$export$8898e76262ada01d = {
    prefix: 'fab',
    iconName: 'wordpress',
    icon: [
        512,
        512,
        [],
        "f19a",
        "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
    ]
};
var $42ee1027226cd96e$export$91dcff48b72c75ce = {
    prefix: 'fab',
    iconName: 'product-hunt',
    icon: [
        512,
        512,
        [],
        "f288",
        "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
    ]
};
var $42ee1027226cd96e$export$53a067e7149deea9 = {
    prefix: 'fab',
    iconName: 'firefox',
    icon: [
        512,
        512,
        [],
        "f269",
        "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
    ]
};
var $42ee1027226cd96e$export$fcbc58842fe8e217 = {
    prefix: 'fab',
    iconName: 'linode',
    icon: [
        448,
        512,
        [],
        "f2b8",
        "M366.036,186.867l-59.5,36.871-.838,36.871-29.329-19.273-39.384,24.3c2.238,55.211,2.483,59.271,2.51,59.5l-97.2,65.359L127.214,285.748l108.1-62.01L195.09,197.761l-75.417,38.547L98.723,93.015,227.771,43.574,136.432,0,10.737,39.385,38.39,174.3l41.9,32.681L48.445,222.062,69.394,323.457,98.723,351.11,77.774,363.679l16.76,78.769L160.733,512c-10.8-74.842-11.658-78.641-11.725-78.773l77.925-55.3c16.759-12.57,15.083-10.894,15.083-10.894l.838,24.3,33.519,28.491-.838-77.093,46.927-33.519,26.815-18.435-2.514,36.033,25.139,17.6,6.7-74.579,58.657-43.575Z"
    ]
};
var $42ee1027226cd96e$export$cc058e4fd428aead = {
    prefix: 'fab',
    iconName: 'goodreads',
    icon: [
        448,
        512,
        [],
        "f3a8",
        "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
    ]
};
var $42ee1027226cd96e$export$df58e66e423b11a0 = {
    prefix: 'fab',
    iconName: 'square-odnoklassniki',
    icon: [
        448,
        512,
        [
            "odnoklassniki-square"
        ],
        "f264",
        "M224 137.1a39.9 39.9 0 1 0 0 79.7 39.9 39.9 0 1 0 0-79.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM224 95.9A81 81 0 1 1 224 258a81 81 0 1 1 0-162.1zm59.3 168.3c16.8-13.2 29.5-5.5 34.1 3.6c7.8 16-1.1 23.7-21.5 37c-17.1 10.9-40.7 15.2-56.2 16.8l13 12.9 47.7 47.7c17.4 17.9-11 45.8-28.6 28.6c-12-12.2-29.5-29.7-47.7-47.9l0 0-47.7 47.9c-17.7 17.2-46-11-28.4-28.6c3.7-3.7 7.9-7.9 12.5-12.5c10.4-10.4 22.6-22.7 35.2-35.2l12.9-12.9c-15.4-1.6-39.3-5.7-56.6-16.8c-20.3-13.3-29.3-20.9-21.4-37c4.6-9.1 17.3-16.8 34.1-3.6c0 0 22.7 18 59.3 18s59.3-18 59.3-18z"
    ]
};
var $42ee1027226cd96e$export$8bab3f1c73ff1d0 = $42ee1027226cd96e$export$df58e66e423b11a0;
var $42ee1027226cd96e$export$49c67105b922997 = {
    prefix: 'fab',
    iconName: 'jsfiddle',
    icon: [
        576,
        512,
        [],
        "f1cc",
        "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
    ]
};
var $42ee1027226cd96e$export$6b9a61f04a3c9eb4 = {
    prefix: 'fab',
    iconName: 'sith',
    icon: [
        448,
        512,
        [],
        "f512",
        "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
    ]
};
var $42ee1027226cd96e$export$9ce81750a9f73ac4 = {
    prefix: 'fab',
    iconName: 'themeisle',
    icon: [
        512,
        512,
        [],
        "f2b2",
        "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
    ]
};
var $42ee1027226cd96e$export$e504e93b36693690 = {
    prefix: 'fab',
    iconName: 'page4',
    icon: [
        496,
        512,
        [],
        "f3d7",
        "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
    ]
};
var $42ee1027226cd96e$export$459e822cce028974 = {
    prefix: 'fab',
    iconName: 'hashnode',
    icon: [
        512,
        512,
        [],
        "e499",
        "M35.19 171.1C-11.72 217.1-11.72 294 35.19 340.9L171.1 476.8C217.1 523.7 294 523.7 340.9 476.8L476.8 340.9C523.7 294 523.7 217.1 476.8 171.1L340.9 35.19C294-11.72 217.1-11.72 171.1 35.19L35.19 171.1zM315.5 315.5C282.6 348.3 229.4 348.3 196.6 315.5C163.7 282.6 163.7 229.4 196.6 196.6C229.4 163.7 282.6 163.7 315.5 196.6C348.3 229.4 348.3 282.6 315.5 315.5z"
    ]
};
var $42ee1027226cd96e$export$e62f4d94322d112c = {
    prefix: 'fab',
    iconName: 'react',
    icon: [
        512,
        512,
        [],
        "f41b",
        "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
    ]
};
var $42ee1027226cd96e$export$c4a0e7e817efc4de = {
    prefix: 'fab',
    iconName: 'cc-paypal',
    icon: [
        576,
        512,
        [],
        "f1f4",
        "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
    ]
};
var $42ee1027226cd96e$export$c1ba640907c93eb6 = {
    prefix: 'fab',
    iconName: 'squarespace',
    icon: [
        512,
        512,
        [],
        "f5be",
        "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
    ]
};
var $42ee1027226cd96e$export$235ca29d6ed8f50f = {
    prefix: 'fab',
    iconName: 'cc-stripe',
    icon: [
        576,
        512,
        [],
        "f1f5",
        "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
    ]
};
var $42ee1027226cd96e$export$82bc9680d7d55560 = {
    prefix: 'fab',
    iconName: 'creative-commons-share',
    icon: [
        496,
        512,
        [],
        "f4f2",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
    ]
};
var $42ee1027226cd96e$export$7bb8936d912f16ef = {
    prefix: 'fab',
    iconName: 'bitcoin',
    icon: [
        512,
        512,
        [],
        "f379",
        "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
    ]
};
var $42ee1027226cd96e$export$644ebffaf375bd06 = {
    prefix: 'fab',
    iconName: 'keycdn',
    icon: [
        512,
        512,
        [],
        "f3ba",
        "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
    ]
};
var $42ee1027226cd96e$export$76e4000ae88923a5 = {
    prefix: 'fab',
    iconName: 'opera',
    icon: [
        496,
        512,
        [],
        "f26a",
        "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
    ]
};
var $42ee1027226cd96e$export$4ec4278290df08a8 = {
    prefix: 'fab',
    iconName: 'itch-io',
    icon: [
        512,
        512,
        [],
        "f83a",
        "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
    ]
};
var $42ee1027226cd96e$export$b92d594113fd14c4 = {
    prefix: 'fab',
    iconName: 'umbraco',
    icon: [
        510,
        512,
        [],
        "f8e8",
        "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
    ]
};
var $42ee1027226cd96e$export$85ca259eee71d856 = {
    prefix: 'fab',
    iconName: 'galactic-senate',
    icon: [
        512,
        512,
        [],
        "f50d",
        "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
    ]
};
var $42ee1027226cd96e$export$188bec0355fe7cb3 = {
    prefix: 'fab',
    iconName: 'ubuntu',
    icon: [
        576,
        512,
        [],
        "f7df",
        "M469.2 75A75.6 75.6 0 1 0 317.9 75a75.6 75.6 0 1 0 151.2 0zM154.2 240.7A75.6 75.6 0 1 0 3 240.7a75.6 75.6 0 1 0 151.2 0zM57 346C75.6 392.9 108 433 150 461.1s91.5 42.6 142 41.7c-14.7-18.6-22.9-41.5-23.2-65.2c-6.8-.9-13.3-2.1-19.5-3.4c-26.8-5.7-51.9-17.3-73.6-34s-39.3-38.1-51.7-62.5c-20.9 9.9-44.5 12.8-67.1 8.2zm395.1 89.8a75.6 75.6 0 1 0 -151.2 0 75.6 75.6 0 1 0 151.2 0zM444 351.6c18.5 14.8 31.6 35.2 37.2 58.2c33.3-41.3 52.6-92.2 54.8-145.2s-12.5-105.4-42.2-149.4c-8.6 21.5-24 39.6-43.8 51.6c15.4 28.6 22.9 60.8 21.9 93.2s-10.7 64-28 91.6zM101.1 135.4c12.4 2.7 24.3 7.5 35.1 14.3c16.6-24.2 38.9-44.1 64.8-58S255.8 70.4 285.2 70c.2-5.9 .9-11.9 2-17.7c3.6-16.7 11.1-32.3 21.8-45.5c-47.7-3.8-95.4 6-137.6 28.5S94.3 91.7 70.8 133.4c2.7-.2 5.3-.3 8-.3c7.5 0 15 .8 22.4 2.3z"
    ]
};
var $42ee1027226cd96e$export$89aeef49dacedf59 = {
    prefix: 'fab',
    iconName: 'draft2digital',
    icon: [
        480,
        512,
        [],
        "f396",
        "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
    ]
};
var $42ee1027226cd96e$export$4124a45a674b7b36 = {
    prefix: 'fab',
    iconName: 'stripe',
    icon: [
        640,
        512,
        [],
        "f429",
        "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
    ]
};
var $42ee1027226cd96e$export$f5c2efa520323804 = {
    prefix: 'fab',
    iconName: 'houzz',
    icon: [
        448,
        512,
        [],
        "f27c",
        "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
    ]
};
var $42ee1027226cd96e$export$5b7cd580ca5d0c32 = {
    prefix: 'fab',
    iconName: 'gg',
    icon: [
        512,
        512,
        [],
        "f260",
        "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
    ]
};
var $42ee1027226cd96e$export$f3f333bdcc61afcd = {
    prefix: 'fab',
    iconName: 'dhl',
    icon: [
        640,
        512,
        [],
        "f790",
        "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
    ]
};
var $42ee1027226cd96e$export$bfa4536fab29fa25 = {
    prefix: 'fab',
    iconName: 'square-pinterest',
    icon: [
        448,
        512,
        [
            "pinterest-square"
        ],
        "f0d3",
        "M384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h72.6l-2.2-.8c-5.4-48.1-3.1-57.5 15.7-134.7c3.9-16 8.5-35 13.9-57.9c0 0-7.3-14.8-7.3-36.5c0-70.7 75.5-78 75.5-25c0 13.5-5.4 31.1-11.2 49.8c-3.3 10.6-6.6 21.5-9.1 32c-5.7 24.5 12.3 44.4 36.4 44.4c43.7 0 77.2-46 77.2-112.4c0-58.8-42.3-99.9-102.6-99.9C153 139 112 191.4 112 245.6c0 21.1 8.2 43.7 18.3 56c2 2.4 2.3 4.5 1.7 7c-1.1 4.7-3.1 12.9-4.7 19.2c-1 4-1.8 7.3-2.1 8.6c-1.1 4.5-3.5 5.5-8.2 3.3c-30.6-14.3-49.8-59.1-49.8-95.1C67.2 167.1 123.4 96 229.4 96c85.2 0 151.4 60.7 151.4 141.8c0 84.6-53.3 152.7-127.4 152.7c-24.9 0-48.3-12.9-56.3-28.2c0 0-12.3 46.9-15.3 58.4c-5 19.3-17.6 42.9-27.4 59.3H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
    ]
};
var $42ee1027226cd96e$export$67aa35027cc046c7 = $42ee1027226cd96e$export$bfa4536fab29fa25;
var $42ee1027226cd96e$export$28ff226a626fb008 = {
    prefix: 'fab',
    iconName: 'xing',
    icon: [
        384,
        512,
        [],
        "f168",
        "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
    ]
};
var $42ee1027226cd96e$export$11c2ed8ca6d46555 = {
    prefix: 'fab',
    iconName: 'blackberry',
    icon: [
        512,
        512,
        [],
        "f37b",
        "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
    ]
};
var $42ee1027226cd96e$export$10c9e6deac1c2eeb = {
    prefix: 'fab',
    iconName: 'creative-commons-pd',
    icon: [
        496,
        512,
        [],
        "f4ec",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
    ]
};
var $42ee1027226cd96e$export$6fcce83c026197c = {
    prefix: 'fab',
    iconName: 'playstation',
    icon: [
        576,
        512,
        [],
        "f3df",
        "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
    ]
};
var $42ee1027226cd96e$export$1079c541f45f51d0 = {
    prefix: 'fab',
    iconName: 'quinscape',
    icon: [
        512,
        512,
        [],
        "f459",
        "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
    ]
};
var $42ee1027226cd96e$export$df0a28abd4a08bff = {
    prefix: 'fab',
    iconName: 'less',
    icon: [
        640,
        512,
        [],
        "f41d",
        "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
    ]
};
var $42ee1027226cd96e$export$fb78f7bb43feec45 = {
    prefix: 'fab',
    iconName: 'blogger-b',
    icon: [
        448,
        512,
        [],
        "f37d",
        "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
    ]
};
var $42ee1027226cd96e$export$b1b65e1549fc9915 = {
    prefix: 'fab',
    iconName: 'opencart',
    icon: [
        640,
        512,
        [],
        "f23d",
        "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
    ]
};
var $42ee1027226cd96e$export$ff24f295c905f144 = {
    prefix: 'fab',
    iconName: 'vine',
    icon: [
        384,
        512,
        [],
        "f1ca",
        "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
    ]
};
var $42ee1027226cd96e$export$95b71ec8a2f59bf0 = {
    prefix: 'fab',
    iconName: 'signal-messenger',
    icon: [
        512,
        512,
        [],
        "e663",
        "M194.6 7.5l5.8 23.3C177.7 36.3 156 45.3 136 57.4L123.7 36.8c22-13.3 45.9-23.2 70.9-29.3zm122.9 0l-5.8 23.3C334.3 36.3 356 45.3 376 57.4l12.4-20.6c-22-13.3-46-23.2-71-29.3zM36.8 123.7c-13.3 22-23.2 45.9-29.3 70.9l23.3 5.8C36.3 177.7 45.3 156 57.4 136L36.8 123.7zM24 256c0-11.6 .9-23.3 2.6-34.8L2.9 217.6c-3.8 25.4-3.8 51.3 0 76.7l23.7-3.6C24.9 279.3 24 267.6 24 256zM388.3 475.2L376 454.6c-20 12.1-41.6 21-64.2 26.6l5.8 23.3c24.9-6.2 48.8-16 70.8-29.3zM488 256c0 11.6-.9 23.3-2.6 34.8l23.7 3.6c3.8-25.4 3.8-51.3 0-76.7l-23.7 3.6c1.7 11.5 2.6 23.1 2.6 34.8zm16.5 61.4l-23.3-5.8c-5.6 22.7-14.5 44.3-26.6 64.3l20.6 12.4c13.3-22 23.2-46 29.3-71zm-213.8 168c-23 3.5-46.5 3.5-69.5 0l-3.6 23.7c25.4 3.8 51.3 3.8 76.7 0l-3.6-23.7zm152-91.8c-13.8 18.7-30.4 35.3-49.2 49.1l14.2 19.3c20.7-15.2 39-33.4 54.2-54.1l-19.3-14.4zM393.6 69.2c18.8 13.8 35.3 30.4 49.2 49.2L462.1 104C446.9 83.4 428.6 65.1 408 49.9L393.6 69.2zM69.2 118.4c13.8-18.8 30.4-35.3 49.2-49.2L104 49.9C83.4 65.1 65.1 83.4 49.9 104l19.3 14.4zm406 5.3L454.6 136c12.1 20 21 41.6 26.6 64.2l23.3-5.8c-6.2-24.9-16-48.8-29.3-70.8zm-254-97.1c23-3.5 46.5-3.5 69.5 0l3.6-23.7C268.9-1 243.1-1 217.6 2.9l3.6 23.7zM81.6 468.4L32 480l11.6-49.6L20.2 425 8.6 474.5c-.9 4-.8 8.1 .3 12.1s3.2 7.5 6.1 10.4s6.5 5 10.4 6.1s8.1 1.2 12.1 .3L87 492l-5.4-23.6zM25.2 403.6L48.6 409l8-34.4c-11.7-19.6-20.4-40.8-25.8-63L7.5 317.4c5.2 21.2 13.2 41.7 23.6 60.8l-5.9 25.3zm112 52l-34.4 8 5.4 23.4 25.3-5.9c19.2 10.4 39.6 18.4 60.8 23.6l5.8-23.3c-22.1-5.5-43.3-14.3-62.8-26l-.2 .2zM256 48c-37.2 0-73.6 10-105.6 28.9s-58.4 46-76.3 78.6s-26.9 69.3-25.8 106.4s12 73.3 31.8 104.8L60 452l85.3-20c27.3 17.2 58.2 27.8 90.3 31s64.5-1.1 94.6-12.6s57.2-29.8 79-53.6s37.8-52.2 46.8-83.2s10.5-63.6 4.7-95.3s-19-61.6-38.4-87.4s-44.5-46.7-73.4-61S288.3 48 256 48z"
    ]
};
var $42ee1027226cd96e$export$1aaa7b292157aaf7 = {
    prefix: 'fab',
    iconName: 'paypal',
    icon: [
        384,
        512,
        [],
        "f1ed",
        "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
    ]
};
var $42ee1027226cd96e$export$bc1566dfb0a3651b = {
    prefix: 'fab',
    iconName: 'gitlab',
    icon: [
        512,
        512,
        [],
        "f296",
        "M503.5 204.6L502.8 202.8L433.1 21.02C431.7 17.45 429.2 14.43 425.9 12.38C423.5 10.83 420.8 9.865 417.9 9.57C415 9.275 412.2 9.653 409.5 10.68C406.8 11.7 404.4 13.34 402.4 15.46C400.5 17.58 399.1 20.13 398.3 22.9L351.3 166.9H160.8L113.7 22.9C112.9 20.13 111.5 17.59 109.6 15.47C107.6 13.35 105.2 11.72 102.5 10.7C99.86 9.675 96.98 9.295 94.12 9.587C91.26 9.878 88.51 10.83 86.08 12.38C82.84 14.43 80.33 17.45 78.92 21.02L9.267 202.8L8.543 204.6C-1.484 230.8-2.72 259.6 5.023 286.6C12.77 313.5 29.07 337.3 51.47 354.2L51.74 354.4L52.33 354.8L158.3 434.3L210.9 474L242.9 498.2C246.6 500.1 251.2 502.5 255.9 502.5C260.6 502.5 265.2 500.1 268.9 498.2L300.9 474L353.5 434.3L460.2 354.4L460.5 354.1C482.9 337.2 499.2 313.5 506.1 286.6C514.7 259.6 513.5 230.8 503.5 204.6z"
    ]
};
var $42ee1027226cd96e$export$26fe3ad1dc9d4c5b = {
    prefix: 'fab',
    iconName: 'typo3',
    icon: [
        448,
        512,
        [],
        "f42b",
        "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
    ]
};
var $42ee1027226cd96e$export$9fbf70587b6b0dcc = {
    prefix: 'fab',
    iconName: 'reddit-alien',
    icon: [
        512,
        512,
        [],
        "f281",
        "M373 138.6c-25.2 0-46.3-17.5-51.9-41l0 0c-30.6 4.3-54.2 30.7-54.2 62.4l0 .2c47.4 1.8 90.6 15.1 124.9 36.3c12.6-9.7 28.4-15.5 45.5-15.5c41.3 0 74.7 33.4 74.7 74.7c0 29.8-17.4 55.5-42.7 67.5c-2.4 86.8-97 156.6-213.2 156.6S45.5 410.1 43 323.4C17.6 311.5 0 285.7 0 255.7c0-41.3 33.4-74.7 74.7-74.7c17.2 0 33 5.8 45.7 15.6c34-21.1 76.8-34.4 123.7-36.4l0-.3c0-44.3 33.7-80.9 76.8-85.5C325.8 50.2 347.2 32 373 32c29.4 0 53.3 23.9 53.3 53.3s-23.9 53.3-53.3 53.3zM157.5 255.3c-20.9 0-38.9 20.8-40.2 47.9s17.1 38.1 38 38.1s36.6-9.8 37.8-36.9s-14.7-49.1-35.7-49.1zM395 303.1c-1.2-27.1-19.2-47.9-40.2-47.9s-36.9 22-35.7 49.1c1.2 27.1 16.9 36.9 37.8 36.9s39.3-11 38-38.1zm-60.1 70.8c1.5-3.6-1-7.7-4.9-8.1c-23-2.3-47.9-3.6-73.8-3.6s-50.8 1.3-73.8 3.6c-3.9 .4-6.4 4.5-4.9 8.1c12.9 30.8 43.3 52.4 78.7 52.4s65.8-21.6 78.7-52.4z"
    ]
};
var $42ee1027226cd96e$export$d0632e92ebe1197f = {
    prefix: 'fab',
    iconName: 'yahoo',
    icon: [
        512,
        512,
        [],
        "f19e",
        "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
    ]
};
var $42ee1027226cd96e$export$9743e7788f64058a = {
    prefix: 'fab',
    iconName: 'dailymotion',
    icon: [
        448,
        512,
        [],
        "e052",
        "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
    ]
};
var $42ee1027226cd96e$export$c40f060084205fb6 = {
    prefix: 'fab',
    iconName: 'affiliatetheme',
    icon: [
        512,
        512,
        [],
        "f36b",
        "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
    ]
};
var $42ee1027226cd96e$export$96d17626187f6e34 = {
    prefix: 'fab',
    iconName: 'pied-piper-pp',
    icon: [
        448,
        512,
        [],
        "f1a7",
        "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
    ]
};
var $42ee1027226cd96e$export$3de8f256f5aadacf = {
    prefix: 'fab',
    iconName: 'bootstrap',
    icon: [
        576,
        512,
        [],
        "f836",
        "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
    ]
};
var $42ee1027226cd96e$export$f31d1294fef45f = {
    prefix: 'fab',
    iconName: 'odnoklassniki',
    icon: [
        320,
        512,
        [],
        "f263",
        "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
    ]
};
var $42ee1027226cd96e$export$a64aa05b0287bdaf = {
    prefix: 'fab',
    iconName: 'nfc-symbol',
    icon: [
        576,
        512,
        [],
        "e531",
        "M392.9 32.43C400.6 31.1 408.6 32.89 414.1 37.41C498.2 96.14 544 173.7 544 255.1C544 338.2 498.2 415.9 414.1 474.6C409.3 478.6 402.4 480.5 395.5 479.9C388.5 479.3 382 476.3 377.1 471.4L193.7 288.7C188.1 283.2 185 275.7 184.1 267.8C184.1 260 188.1 252.5 193.6 246.9C199.2 241.4 206.7 238.2 214.5 238.2C222.4 238.2 229.9 241.3 235.4 246.8L400.5 411.2C455.1 366.5 484.8 312 484.8 255.1C484.8 193.5 447.9 132.9 380.9 85.76C374.5 81.24 370.1 74.35 368.8 66.62C367.4 58.89 369.2 50.94 373.8 44.53C378.3 38.12 385.2 33.77 392.9 32.43V32.43zM186.9 479.6C179.2 480.9 171.3 479.1 164.8 474.6C81.67 415.9 35.84 338.2 35.84 255.1C35.84 173.7 81.67 96.14 164.8 37.41C170.5 33.4 177.4 31.53 184.4 32.12C191.3 32.71 197.8 35.72 202.7 40.63L386.1 223.3C391.7 228.8 394.8 236.3 394.8 244.2C394.9 251.1 391.8 259.5 386.2 265.1C380.7 270.6 373.2 273.8 365.3 273.8C357.5 273.8 349.1 270.7 344.4 265.2L179.3 100.7C124.7 145.9 95.03 199.9 95.03 255.1C95.03 318.5 131.9 379.1 198.1 426.2C205.4 430.8 209.7 437.6 211.1 445.4C212.4 453.1 210.6 461.1 206.1 467.5C201.6 473.9 194.7 478.2 186.9 479.6V479.6z"
    ]
};
var $42ee1027226cd96e$export$1aeaa8a5ac0e3463 = {
    prefix: 'fab',
    iconName: 'mintbit',
    icon: [
        512,
        512,
        [],
        "e62f",
        "M73.2 512V438.9H365.7V365.7h73.2V219.4H512V0H292.6V73.1H146.3v73.2H73.2V438.9H0V512H73.2zm73.1-219.4h73.2v73.1H146.3V292.6zm73.2-73.1h73.1v73.1H219.4V219.4zm73.1 0V146.3h73.2v73.1H292.6zM365.7 73.1h73.2v73.2H365.7V73.1z"
    ]
};
var $42ee1027226cd96e$export$b5ebb163fdb5edfd = {
    prefix: 'fab',
    iconName: 'ethereum',
    icon: [
        320,
        512,
        [],
        "f42e",
        "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
    ]
};
var $42ee1027226cd96e$export$7c461c4ee7c07c19 = {
    prefix: 'fab',
    iconName: 'speaker-deck',
    icon: [
        512,
        512,
        [],
        "f83c",
        "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
    ]
};
var $42ee1027226cd96e$export$bcf1858bdc40caa3 = {
    prefix: 'fab',
    iconName: 'creative-commons-nc-eu',
    icon: [
        496,
        512,
        [],
        "f4e9",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
    ]
};
var $42ee1027226cd96e$export$a4dfebb823a477ff = {
    prefix: 'fab',
    iconName: 'patreon',
    icon: [
        512,
        512,
        [],
        "f3d9",
        "M489.7 153.8c-.1-65.4-51-119-110.7-138.3C304.8-8.5 207-5 136.1 28.4C50.3 68.9 23.3 157.7 22.3 246.2C21.5 319 28.7 510.6 136.9 512c80.3 1 92.3-102.5 129.5-152.3c26.4-35.5 60.5-45.5 102.4-55.9c72-17.8 121.1-74.7 121-150z"
    ]
};
var $42ee1027226cd96e$export$862396e708985a99 = {
    prefix: 'fab',
    iconName: 'avianex',
    icon: [
        512,
        512,
        [],
        "f374",
        "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
    ]
};
var $42ee1027226cd96e$export$e644e4a8cae83fb3 = {
    prefix: 'fab',
    iconName: 'ello',
    icon: [
        496,
        512,
        [],
        "f5f1",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
    ]
};
var $42ee1027226cd96e$export$380164e9d6cdbec2 = {
    prefix: 'fab',
    iconName: 'gofore',
    icon: [
        400,
        512,
        [],
        "f3a7",
        "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
    ]
};
var $42ee1027226cd96e$export$a219f36955efe01a = {
    prefix: 'fab',
    iconName: 'bimobject',
    icon: [
        448,
        512,
        [],
        "f378",
        "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
    ]
};
var $42ee1027226cd96e$export$3d9997b304f32d18 = {
    prefix: 'fab',
    iconName: 'brave-reverse',
    icon: [
        448,
        512,
        [],
        "e63d",
        "M298 0c3 0 5.8 1.3 7.8 3.6l38.1 44c.5-.1 1-.2 1.5-.3c9.2-1.6 18.6-2.2 27.7-1.2c11.6 1.4 21.5 5.4 28.9 12.9c7.7 7.8 15.4 15.8 22.6 23.6c2.5 2.7 4.9 5.2 6.9 7.4c.7 .8 1.4 1.5 1.9 2c3.4 3.7 4.2 8.1 2.7 11.9l-9.8 24.6 13.1 38.1c.7 2 .8 4.1 .2 6.2c-.1 .4-.1 .4-.5 2.1c-.6 2.3-.6 2.3-1.5 5.8c-1.6 6.3-3.5 13.3-5.4 20.9c-5.6 21.6-11.2 43.2-16.4 63.4c-12.9 49.9-21.4 82.7-23.4 90.9c-11.1 44.5-19.9 60-48.3 80.3c-24.9 17.8-76.8 53.6-86.8 60c-1 .6-2 1.3-3.4 2.3c-.5 .4-3.2 2.2-3.9 2.7c-4.9 3.3-8.3 5.5-12.1 7.3c-4.7 2.2-9.3 3.5-13.9 3.5s-9.1-1.2-13.9-3.5c-3.7-1.8-7.2-3.9-12.1-7.3c-.8-.5-3.4-2.4-3.9-2.7c-1.4-1-2.5-1.7-3.4-2.3c-10-6.4-61.9-42.1-86.8-60c-28.4-20.4-37.2-35.8-48.3-80.3c-2-8.2-10.5-41-23.3-90.5c-5.3-20.6-10.9-42.2-16.5-63.8c-2-7.6-3.8-14.6-5.4-20.9c-.9-3.5-.9-3.5-1.5-5.8c-.4-1.7-.4-1.7-.5-2.1c-.5-2-.4-4.2 .2-6.2l13.1-38.1L11.8 104c-1.5-3.8-.7-8.2 2-11.2c1.2-1.3 1.8-2 2.6-2.8c2-2.2 4.4-4.7 6.9-7.4C30.6 74.9 38.3 66.9 46 59.1c7.4-7.5 17.3-11.6 28.9-12.9c9.1-1.1 18.5-.5 27.7 1.2c.5 .1 1 .2 1.5 .3l38.1-44C144.2 1.3 147 0 150 0H298zm-4.7 21.1H154.7L115.6 66.2c-2.6 3-6.7 4.3-10.6 3.2c-.2-.1-.7-.2-1.5-.4c-1.3-.3-2.9-.6-4.5-.9c-7.4-1.3-14.9-1.8-21.7-1C70 68 64.3 70.3 60.7 74c-7.6 7.7-15.2 15.6-22.3 23.3c-1.7 1.8-3.3 3.5-4.8 5.1l8.8 22c1 2.4 1 5 .2 7.5L29.2 170.6c.4 1.4 .5 1.9 1.2 4.8c1.6 6.3 3.5 13.3 5.4 20.9c5.6 21.6 11.2 43.2 16.4 63.4c12.9 50 21.4 82.8 23.4 91C85.7 390.8 92 402 115.8 419c24.6 17.6 76.3 53.2 85.9 59.3c1.2 .8 2.5 1.6 4 2.7c.6 .4 3.2 2.2 3.9 2.7c4 2.8 6.7 4.4 9.2 5.6c2.2 1 3.9 1.5 5.1 1.5s2.9-.5 5.1-1.5c2.5-1.2 5.2-2.8 9.2-5.6c.7-.5 3.3-2.3 3.9-2.7c1.6-1.1 2.8-1.9 4-2.7c9.6-6.1 61.3-41.7 85.9-59.3c23.8-17.1 30.2-28.2 40.1-68.3c2.1-8.3 10.5-41.1 23.3-90.7c5.3-20.6 10.9-42.2 16.5-63.8c2-7.6 3.8-14.6 5.4-20.9c.7-2.9 .9-3.4 1.2-4.8l-13.3-38.8c-.8-2.4-.8-5.1 .2-7.5l8.8-22c-1.5-1.6-3.1-3.3-4.8-5.1c-7.2-7.6-14.7-15.5-22.3-23.3c-3.7-3.7-9.3-6-16.6-6.9c-6.8-.8-14.4-.3-21.7 1c-1.7 .3-3.2 .6-4.5 .9c-.8 .2-1.3 .3-1.5 .4c-3.8 1.1-7.9-.2-10.6-3.2L293.3 21.1zM224 316c2.8 0 20.9 6.5 35.4 14.1s25 13 28.3 15.2s1.3 6.2-1.7 8.4s-44.1 34.6-48.1 38.2s-9.8 9.5-13.8 9.5s-9.8-5.9-13.8-9.5s-45.1-36-48.1-38.2s-5.1-6.2-1.7-8.4s13.9-7.5 28.3-15.2s32.5-14.1 35.4-14.1zm.1-230.7c.7 0 8.8 .2 20.5 4.2c12.3 4.2 25.7 9.4 31.9 9.4s51.9-8.9 51.9-8.9s54.2 66.7 54.2 81s-6.8 18-13.7 25.4s-36.8 39.8-40.7 43.9s-11.9 10.5-7.1 21.8s11.7 25.8 3.9 40.4s-21 24.4-29.4 22.8s-28.4-12.2-35.7-17.1s-30.5-24.3-30.5-31.8s24-20.8 28.4-23.9s24.7-14.8 25.1-19.4s.3-6-5.7-17.4s-16.7-26.7-14.9-36.8s19.1-15.4 31.5-20.2s36.2-13.7 39.2-15.1s2.2-2.7-6.8-3.6s-34.6-4.3-46.1-1.1s-31.2 8.2-32.8 10.9s-3 2.7-1.4 11.8s10.1 52.8 10.9 60.6s2.4 12.9-5.8 14.8s-22.1 5.2-26.8 5.2s-18.6-3.3-26.8-5.2s-6.6-7-5.8-14.8s9.3-51.5 10.9-60.6s.2-9.2-1.4-11.8s-21.3-7.6-32.8-10.9s-37.1 .2-46.1 1.1s-9.8 2.2-6.8 3.6s26.8 10.4 39.2 15.1s29.7 10 31.5 20.2s-9 25.4-14.9 36.8s-6.1 12.8-5.7 17.4s20.6 16.4 25.1 19.4s28.4 16.4 28.4 23.9s-23.2 27-30.5 31.8s-27.2 15.4-35.7 17.1s-21.7-8.2-29.4-22.8s-.8-29.1 3.9-40.4s-3.3-17.7-7.1-21.8s-33.8-36.5-40.7-43.9s-13.7-11.2-13.7-25.4s54.2-81 54.2-81s45.8 8.9 51.9 8.9s19.5-5.2 31.9-9.4s20.6-4.2 20.6-4.2l.1 0z"
    ]
};
var $42ee1027226cd96e$export$890714bb00316cc = {
    prefix: 'fab',
    iconName: 'facebook-f',
    icon: [
        320,
        512,
        [],
        "f39e",
        "M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"
    ]
};
var $42ee1027226cd96e$export$e94511deb1df63ce = {
    prefix: 'fab',
    iconName: 'square-google-plus',
    icon: [
        448,
        512,
        [
            "google-plus-square"
        ],
        "f0d4",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM64 256c0-55.3 44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4c-34.1 0-61.9 28.2-61.9 63.2c0 34.9 27.8 63.2 61.9 63.2c39.6 0 54.4-28.5 56.8-43.1H164V241.8h94.4c1 5 1.6 10.1 1.6 16.6c0 57.1-38.3 97.6-96 97.6c-55.3 0-100-44.7-100-100zm291 18.2v29H325.8v-29h-29V245h29V216H355v29h29v29.2H355z"
    ]
};
var $42ee1027226cd96e$export$d546947149d9505a = $42ee1027226cd96e$export$e94511deb1df63ce;
var $42ee1027226cd96e$export$2a745e3ef2838c53 = {
    prefix: 'fab',
    iconName: 'mandalorian',
    icon: [
        448,
        512,
        [],
        "f50f",
        "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
    ]
};
var $42ee1027226cd96e$export$ea0bc2cd8d60b806 = {
    prefix: 'fab',
    iconName: 'first-order-alt',
    icon: [
        496,
        512,
        [],
        "f50a",
        "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
    ]
};
var $42ee1027226cd96e$export$89cf1df24c6f1e2 = {
    prefix: 'fab',
    iconName: 'osi',
    icon: [
        512,
        512,
        [],
        "f41a",
        "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
    ]
};
var $42ee1027226cd96e$export$6fd7b581d1a20a14 = {
    prefix: 'fab',
    iconName: 'google-wallet',
    icon: [
        448,
        512,
        [],
        "f1ee",
        "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
    ]
};
var $42ee1027226cd96e$export$8ffeba28c1feff0d = {
    prefix: 'fab',
    iconName: 'd-and-d-beyond',
    icon: [
        640,
        512,
        [],
        "f6ca",
        "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
    ]
};
var $42ee1027226cd96e$export$10deb29d7dbf2418 = {
    prefix: 'fab',
    iconName: 'periscope',
    icon: [
        448,
        512,
        [],
        "f3da",
        "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
    ]
};
var $42ee1027226cd96e$export$beb89eeaf726c65a = {
    prefix: 'fab',
    iconName: 'fulcrum',
    icon: [
        320,
        512,
        [],
        "f50b",
        "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
    ]
};
var $42ee1027226cd96e$export$fdf6053d73314ca6 = {
    prefix: 'fab',
    iconName: 'cloudscale',
    icon: [
        448,
        512,
        [],
        "f383",
        "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
    ]
};
var $42ee1027226cd96e$export$e4fb88a0423b6fee = {
    prefix: 'fab',
    iconName: 'forumbee',
    icon: [
        448,
        512,
        [],
        "f211",
        "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
    ]
};
var $42ee1027226cd96e$export$e6a3c752190fa3cb = {
    prefix: 'fab',
    iconName: 'mizuni',
    icon: [
        496,
        512,
        [],
        "f3cc",
        "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
    ]
};
var $42ee1027226cd96e$export$3f1891b85805675f = {
    prefix: 'fab',
    iconName: 'schlix',
    icon: [
        448,
        512,
        [],
        "f3ea",
        "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
    ]
};
var $42ee1027226cd96e$export$ca49464b0602c8ef = {
    prefix: 'fab',
    iconName: 'square-xing',
    icon: [
        448,
        512,
        [
            "xing-square"
        ],
        "f169",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM93.8 320.2c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6 .2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2c-3.5 6.2-7.7 9.1-12.6 9.1H93.8zm163.5-33.4v.2l65.5 119c2.8 5.1 .1 10.1-6 10.1H270.2c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c1.8-3.2 22.9-40.4 63.3-111.6c11.7-20.7 25.1-44.3 40.1-70.8c3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10L257.3 286.8z"
    ]
};
var $42ee1027226cd96e$export$3f616d72d818a1a6 = $42ee1027226cd96e$export$ca49464b0602c8ef;
var $42ee1027226cd96e$export$cf8fa465ef81d073 = {
    prefix: 'fab',
    iconName: 'bandcamp',
    icon: [
        512,
        512,
        [],
        "f2d5",
        "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
    ]
};
var $42ee1027226cd96e$export$f70eba4216b4419a = {
    prefix: 'fab',
    iconName: 'wpforms',
    icon: [
        448,
        512,
        [],
        "f298",
        "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
    ]
};
var $42ee1027226cd96e$export$623057fac7dabd52 = {
    prefix: 'fab',
    iconName: 'cloudversify',
    icon: [
        616,
        512,
        [],
        "f385",
        "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
    ]
};
var $42ee1027226cd96e$export$216644b0c66e66a5 = {
    prefix: 'fab',
    iconName: 'usps',
    icon: [
        576,
        512,
        [],
        "f7e1",
        "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
    ]
};
var $42ee1027226cd96e$export$e7e4dbda4df6110f = {
    prefix: 'fab',
    iconName: 'megaport',
    icon: [
        496,
        512,
        [],
        "f5a3",
        "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
    ]
};
var $42ee1027226cd96e$export$9b8374b50472190d = {
    prefix: 'fab',
    iconName: 'magento',
    icon: [
        448,
        512,
        [],
        "f3c4",
        "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
    ]
};
var $42ee1027226cd96e$export$8218f3fbb2f89724 = {
    prefix: 'fab',
    iconName: 'spotify',
    icon: [
        496,
        512,
        [],
        "f1bc",
        "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
    ]
};
var $42ee1027226cd96e$export$5247a00f0c0b93a3 = {
    prefix: 'fab',
    iconName: 'optin-monster',
    icon: [
        576,
        512,
        [],
        "f23c",
        "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
    ]
};
var $42ee1027226cd96e$export$cfbbba1261e4e2d2 = {
    prefix: 'fab',
    iconName: 'fly',
    icon: [
        384,
        512,
        [],
        "f417",
        "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
    ]
};
var $42ee1027226cd96e$export$f731696770842fd2 = {
    prefix: 'fab',
    iconName: 'aviato',
    icon: [
        640,
        512,
        [],
        "f421",
        "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
    ]
};
var $42ee1027226cd96e$export$5f69a5b38e12c984 = {
    prefix: 'fab',
    iconName: 'itunes',
    icon: [
        448,
        512,
        [],
        "f3b4",
        "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
    ]
};
var $42ee1027226cd96e$export$883d4844d275b117 = {
    prefix: 'fab',
    iconName: 'cuttlefish',
    icon: [
        440,
        512,
        [],
        "f38c",
        "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
    ]
};
var $42ee1027226cd96e$export$eba2747efc67a397 = {
    prefix: 'fab',
    iconName: 'blogger',
    icon: [
        448,
        512,
        [],
        "f37c",
        "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
    ]
};
var $42ee1027226cd96e$export$4fc2e88e3ac2b091 = {
    prefix: 'fab',
    iconName: 'flickr',
    icon: [
        448,
        512,
        [],
        "f16e",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
    ]
};
var $42ee1027226cd96e$export$c16cb0c14aa5beed = {
    prefix: 'fab',
    iconName: 'viber',
    icon: [
        512,
        512,
        [],
        "f409",
        "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
    ]
};
var $42ee1027226cd96e$export$5803ef8c86f9786d = {
    prefix: 'fab',
    iconName: 'soundcloud',
    icon: [
        640,
        512,
        [],
        "f1be",
        "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
    ]
};
var $42ee1027226cd96e$export$1902312a1701467c = {
    prefix: 'fab',
    iconName: 'digg',
    icon: [
        512,
        512,
        [],
        "f1a6",
        "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
    ]
};
var $42ee1027226cd96e$export$9ea61fa1ff3225c6 = {
    prefix: 'fab',
    iconName: 'tencent-weibo',
    icon: [
        384,
        512,
        [],
        "f1d5",
        "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
    ]
};
var $42ee1027226cd96e$export$3d0320148c8ebcd6 = {
    prefix: 'fab',
    iconName: 'letterboxd',
    icon: [
        640,
        512,
        [],
        "e62d",
        "M521.3 128C586.9 128 640 181.1 640 246.6s-53.1 118.6-118.7 118.6c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zM320 128c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0c-42.5 0-79.7-22.3-100.7-55.8c11.4-18.2 18-39.7 18-62.8s-6.6-44.6-18-62.8l0 0 .8-1.2c20.8-32.3 56.8-53.9 97.9-54.6l2 0zm-201.3 0c42.5 0 79.7 22.3 100.7 55.8c-11.4 18.2-18 39.7-18 62.8s6.6 44.6 18 62.8l0 0-.8 1.2c-20.8 32.3-56.8 53.9-97.9 54.6l-2 0C53.1 365.1 0 312.1 0 246.6S53.1 128 118.7 128z"
    ]
};
var $42ee1027226cd96e$export$5420457350c35845 = {
    prefix: 'fab',
    iconName: 'symfony',
    icon: [
        512,
        512,
        [],
        "f83d",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
    ]
};
var $42ee1027226cd96e$export$a33f03bc723e6603 = {
    prefix: 'fab',
    iconName: 'maxcdn',
    icon: [
        512,
        512,
        [],
        "f136",
        "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
    ]
};
var $42ee1027226cd96e$export$c7956780474e39de = {
    prefix: 'fab',
    iconName: 'etsy',
    icon: [
        384,
        512,
        [],
        "f2d7",
        "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
    ]
};
var $42ee1027226cd96e$export$6c28dada3398f534 = {
    prefix: 'fab',
    iconName: 'facebook-messenger',
    icon: [
        512,
        512,
        [],
        "f39f",
        "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
    ]
};
var $42ee1027226cd96e$export$83a2d14204e40d9a = {
    prefix: 'fab',
    iconName: 'audible',
    icon: [
        640,
        512,
        [],
        "f373",
        "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
    ]
};
var $42ee1027226cd96e$export$4c12ad86c5e9c2a9 = {
    prefix: 'fab',
    iconName: 'think-peaks',
    icon: [
        576,
        512,
        [],
        "f731",
        "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
    ]
};
var $42ee1027226cd96e$export$34797550194301d4 = {
    prefix: 'fab',
    iconName: 'bilibili',
    icon: [
        512,
        512,
        [],
        "e3d9",
        "M488.6 104.1C505.3 122.2 513 143.8 511.9 169.8V372.2C511.5 398.6 502.7 420.3 485.4 437.3C468.2 454.3 446.3 463.2 419.9 464H92.02C65.57 463.2 43.81 454.2 26.74 436.8C9.682 419.4 .7667 396.5 0 368.2V169.8C.7667 143.8 9.682 122.2 26.74 104.1C43.81 87.75 65.57 78.77 92.02 78H121.4L96.05 52.19C90.3 46.46 87.42 39.19 87.42 30.4C87.42 21.6 90.3 14.34 96.05 8.603C101.8 2.868 109.1 0 117.9 0C126.7 0 134 2.868 139.8 8.603L213.1 78H301.1L375.6 8.603C381.7 2.868 389.2 0 398 0C406.8 0 414.1 2.868 419.9 8.603C425.6 14.34 428.5 21.6 428.5 30.4C428.5 39.19 425.6 46.46 419.9 52.19L394.6 78L423.9 78C450.3 78.77 471.9 87.75 488.6 104.1H488.6zM449.8 173.8C449.4 164.2 446.1 156.4 439.1 150.3C433.9 144.2 425.1 140.9 416.4 140.5H96.05C86.46 140.9 78.6 144.2 72.47 150.3C66.33 156.4 63.07 164.2 62.69 173.8V368.2C62.69 377.4 65.95 385.2 72.47 391.7C78.99 398.2 86.85 401.5 96.05 401.5H416.4C425.6 401.5 433.4 398.2 439.7 391.7C446 385.2 449.4 377.4 449.8 368.2L449.8 173.8zM185.5 216.5C191.8 222.8 195.2 230.6 195.6 239.7V273C195.2 282.2 191.9 289.9 185.8 296.2C179.6 302.5 171.8 305.7 162.2 305.7C152.6 305.7 144.7 302.5 138.6 296.2C132.5 289.9 129.2 282.2 128.8 273V239.7C129.2 230.6 132.6 222.8 138.9 216.5C145.2 210.2 152.1 206.9 162.2 206.5C171.4 206.9 179.2 210.2 185.5 216.5H185.5zM377 216.5C383.3 222.8 386.7 230.6 387.1 239.7V273C386.7 282.2 383.4 289.9 377.3 296.2C371.2 302.5 363.3 305.7 353.7 305.7C344.1 305.7 336.3 302.5 330.1 296.2C323.1 289.9 320.7 282.2 320.4 273V239.7C320.7 230.6 324.1 222.8 330.4 216.5C336.7 210.2 344.5 206.9 353.7 206.5C362.9 206.9 370.7 210.2 377 216.5H377z"
    ]
};
var $42ee1027226cd96e$export$c6087bbc62da6f90 = {
    prefix: 'fab',
    iconName: 'erlang',
    icon: [
        640,
        512,
        [],
        "f39d",
        "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
    ]
};
var $42ee1027226cd96e$export$fd0513a3aa908a67 = {
    prefix: 'fab',
    iconName: 'x-twitter',
    icon: [
        512,
        512,
        [],
        "e61b",
        "M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
    ]
};
var $42ee1027226cd96e$export$8fc0685430a4202e = {
    prefix: 'fab',
    iconName: 'cotton-bureau',
    icon: [
        512,
        512,
        [],
        "f89e",
        "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
    ]
};
var $42ee1027226cd96e$export$fc2c1db4698b6c91 = {
    prefix: 'fab',
    iconName: 'dashcube',
    icon: [
        448,
        512,
        [],
        "f210",
        "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
    ]
};
var $42ee1027226cd96e$export$a02285afcee8b3ba = {
    prefix: 'fab',
    iconName: '42-group',
    icon: [
        640,
        512,
        [
            "innosoft"
        ],
        "e080",
        "M320 96V416C341.011 416 361.818 411.861 381.23 403.821C400.641 395.78 418.28 383.995 433.138 369.138C447.995 354.28 459.78 336.641 467.821 317.23C475.861 297.818 480 277.011 480 256C480 234.989 475.861 214.182 467.821 194.771C459.78 175.359 447.995 157.72 433.138 142.863C418.28 128.005 400.641 116.22 381.23 108.179C361.818 100.139 341.011 96 320 96ZM0 256L160.002 416L320.003 256L160.002 96L0 256ZM480 256C480 277.011 484.138 297.818 492.179 317.23C500.219 336.643 512.005 354.28 526.862 369.138C541.72 383.995 559.357 395.781 578.77 403.821C598.182 411.862 618.989 416 640 416V96C597.565 96 556.869 112.858 526.862 142.863C496.857 172.869 480 213.565 480 256Z"
    ]
};
var $42ee1027226cd96e$export$da8db9965333c744 = $42ee1027226cd96e$export$a02285afcee8b3ba;
var $42ee1027226cd96e$export$d511b4edf7fbac5a = {
    prefix: 'fab',
    iconName: 'stack-exchange',
    icon: [
        448,
        512,
        [],
        "f18d",
        "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
    ]
};
var $42ee1027226cd96e$export$66726053c0c0ec32 = {
    prefix: 'fab',
    iconName: 'elementor',
    icon: [
        512,
        512,
        [],
        "f430",
        "M.361 256C.361 397 114 511 255 511C397 511 511 397 511 256C511 116 397 2.05 255 2.05C114 2.05 .361 116 .361 256zM192 150V363H149V150H192zM234 150H362V193H234V150zM362 235V278H234V235H362zM234 320H362V363H234V320z"
    ]
};
var $42ee1027226cd96e$export$9d16a5780aab9cd3 = {
    prefix: 'fab',
    iconName: 'square-pied-piper',
    icon: [
        448,
        512,
        [
            "pied-piper-square"
        ],
        "e01e",
        "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
    ]
};
var $42ee1027226cd96e$export$95ddae6b65597c6e = $42ee1027226cd96e$export$9d16a5780aab9cd3;
var $42ee1027226cd96e$export$157e4276d9138bda = {
    prefix: 'fab',
    iconName: 'creative-commons-nd',
    icon: [
        496,
        512,
        [],
        "f4eb",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
    ]
};
var $42ee1027226cd96e$export$a226dd96512e144 = {
    prefix: 'fab',
    iconName: 'palfed',
    icon: [
        576,
        512,
        [],
        "f3d8",
        "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
    ]
};
var $42ee1027226cd96e$export$349f4fc9997a1bf0 = {
    prefix: 'fab',
    iconName: 'superpowers',
    icon: [
        448,
        512,
        [],
        "f2dd",
        "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
    ]
};
var $42ee1027226cd96e$export$e73a6c635a57ef10 = {
    prefix: 'fab',
    iconName: 'resolving',
    icon: [
        496,
        512,
        [],
        "f3e7",
        "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
    ]
};
var $42ee1027226cd96e$export$2c743c09f4269e9c = {
    prefix: 'fab',
    iconName: 'xbox',
    icon: [
        512,
        512,
        [],
        "f412",
        "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
    ]
};
var $42ee1027226cd96e$export$e72de9688042e327 = {
    prefix: 'fab',
    iconName: 'searchengin',
    icon: [
        460,
        512,
        [],
        "f3eb",
        "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
    ]
};
var $42ee1027226cd96e$export$f310e79ae35a251f = {
    prefix: 'fab',
    iconName: 'tiktok',
    icon: [
        448,
        512,
        [],
        "e07b",
        "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
    ]
};
var $42ee1027226cd96e$export$8545d76ecd01ec19 = {
    prefix: 'fab',
    iconName: 'square-facebook',
    icon: [
        448,
        512,
        [
            "facebook-square"
        ],
        "f082",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64h98.2V334.2H109.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H255V480H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
    ]
};
var $42ee1027226cd96e$export$cd6ab8ed6a9ec7a4 = $42ee1027226cd96e$export$8545d76ecd01ec19;
var $42ee1027226cd96e$export$36a9439e8de2df70 = {
    prefix: 'fab',
    iconName: 'renren',
    icon: [
        512,
        512,
        [],
        "f18b",
        "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
    ]
};
var $42ee1027226cd96e$export$5cb68a24a0b7bdf6 = {
    prefix: 'fab',
    iconName: 'linux',
    icon: [
        448,
        512,
        [],
        "f17c",
        "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
    ]
};
var $42ee1027226cd96e$export$c4c84939b8784e10 = {
    prefix: 'fab',
    iconName: 'glide',
    icon: [
        448,
        512,
        [],
        "f2a5",
        "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
    ]
};
var $42ee1027226cd96e$export$b38fbe0cd1e4c67d = {
    prefix: 'fab',
    iconName: 'linkedin',
    icon: [
        448,
        512,
        [],
        "f08c",
        "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
    ]
};
var $42ee1027226cd96e$export$418b99079caf9b9b = {
    prefix: 'fab',
    iconName: 'hubspot',
    icon: [
        512,
        512,
        [],
        "f3b2",
        "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
    ]
};
var $42ee1027226cd96e$export$bd9dbf3c3b0bdc5e = {
    prefix: 'fab',
    iconName: 'deploydog',
    icon: [
        512,
        512,
        [],
        "f38e",
        "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
    ]
};
var $42ee1027226cd96e$export$154857d90d308f7c = {
    prefix: 'fab',
    iconName: 'twitch',
    icon: [
        512,
        512,
        [],
        "f1e8",
        "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
    ]
};
var $42ee1027226cd96e$export$cab2db22e59af947 = {
    prefix: 'fab',
    iconName: 'ravelry',
    icon: [
        512,
        512,
        [],
        "f2d9",
        "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
    ]
};
var $42ee1027226cd96e$export$83d047b1c09d253 = {
    prefix: 'fab',
    iconName: 'mixer',
    icon: [
        512,
        512,
        [],
        "e056",
        "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
    ]
};
var $42ee1027226cd96e$export$37794c0b0ffc1e44 = {
    prefix: 'fab',
    iconName: 'square-lastfm',
    icon: [
        448,
        512,
        [
            "lastfm-square"
        ],
        "f203",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM210.7 280.8c-1.8-5.5-3.4-10.8-5-15.9c-12.9-41.9-21-68.4-58-68.4c-22.4 0-45.1 16.1-45.1 61.2c0 35.2 18 57.2 43.3 57.2c28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8c0-57.9 28.6-92 82.5-92c67.9 0 79.3 35.3 96.4 88.4c1.4 4.4 2.9 8.9 4.4 13.5c8.8 26.8 24.2 46.2 61.2 46.2c24.9 0 38.1-5.5 38.1-19.1c0-17.5-16.9-21.2-40-26.4c-3.2-.7-6.5-1.4-9.9-2.2c-30.4-7.3-42.5-23.1-42.5-48c0-40 32.3-52.4 65.2-52.4c37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4c-16.1 0-26 7.3-26 19.8c0 11 4.8 17.6 20.9 21.3c2.2 .5 4.5 1 6.7 1.4c31.1 6.5 65.1 13.7 65.1 56.1c.1 36.7-30.7 50.6-76.1 50.6c-63.4 0-85.4-28.6-97.1-64.1z"
    ]
};
var $42ee1027226cd96e$export$c2f59587d6a3a574 = $42ee1027226cd96e$export$37794c0b0ffc1e44;
var $42ee1027226cd96e$export$b73c31bd90a3782e = {
    prefix: 'fab',
    iconName: 'vimeo',
    icon: [
        448,
        512,
        [],
        "f40a",
        "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
    ]
};
var $42ee1027226cd96e$export$a580d86d20b50be3 = {
    prefix: 'fab',
    iconName: 'mendeley',
    icon: [
        640,
        512,
        [],
        "f7b3",
        "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
    ]
};
var $42ee1027226cd96e$export$6fb93399039178f9 = {
    prefix: 'fab',
    iconName: 'uniregistry',
    icon: [
        384,
        512,
        [],
        "f404",
        "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
    ]
};
var $42ee1027226cd96e$export$e71a35e82f13ad7f = {
    prefix: 'fab',
    iconName: 'figma',
    icon: [
        384,
        512,
        [],
        "f799",
        "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
    ]
};
var $42ee1027226cd96e$export$c02c848648d47b55 = {
    prefix: 'fab',
    iconName: 'creative-commons-remix',
    icon: [
        496,
        512,
        [],
        "f4ee",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
    ]
};
var $42ee1027226cd96e$export$3f0dada7ec074193 = {
    prefix: 'fab',
    iconName: 'cc-amazon-pay',
    icon: [
        576,
        512,
        [],
        "f42d",
        "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
    ]
};
var $42ee1027226cd96e$export$e4589d83245ae1b2 = {
    prefix: 'fab',
    iconName: 'dropbox',
    icon: [
        528,
        512,
        [],
        "f16b",
        "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
    ]
};
var $42ee1027226cd96e$export$8256451a9905291a = {
    prefix: 'fab',
    iconName: 'instagram',
    icon: [
        448,
        512,
        [],
        "f16d",
        "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
    ]
};
var $42ee1027226cd96e$export$f4e59d0d43aeb784 = {
    prefix: 'fab',
    iconName: 'cmplid',
    icon: [
        640,
        512,
        [],
        "e360",
        "M226.119,388.165a3.816,3.816,0,0,0-2.294-3.5,3.946,3.946,0,0,0-1.629-.385L72.6,384.3a19.243,19.243,0,0,1-17.924-26.025L81.585,255.692a35.72,35.72,0,0,1,32.373-26H262.525a7.07,7.07,0,0,0,6.392-5.194l10.769-41.131a3.849,3.849,0,0,0-2.237-4.937,3.755,3.755,0,0,0-1.377-.261c-.063,0-.126,0-.189.005H127.38a106.8,106.8,0,0,0-96.99,77.1L3.483,358.824A57.469,57.469,0,0,0,57.314,436q1.43,0,2.86-.072H208.742a7.131,7.131,0,0,0,6.391-5.193L225.839,389.6A3.82,3.82,0,0,0,226.119,388.165ZM306.658,81.2a3.861,3.861,0,0,0,.251-1.367A3.813,3.813,0,0,0,303.079,76c-.064,0-.128,0-.192,0h-41A7.034,7.034,0,0,0,255.5,81.2l-21.347,80.915h51.131ZM180.364,368.249H231.5L263.452,245.69H212.321ZM511.853,79.723a3.809,3.809,0,0,0-3.8-3.661c-.058,0-.137,0-.23.007h-41a7.1,7.1,0,0,0-6.584,5.129L368.91,430.634a3.54,3.54,0,0,0-.262,1.335,3.873,3.873,0,0,0,3.864,3.863c.056,0,.112,0,.169,0h41a7.068,7.068,0,0,0,6.392-5.193L511.533,81.2A3.624,3.624,0,0,0,511.853,79.723ZM324.649,384.47h-41a7.2,7.2,0,0,0-6.392,5.194L266.52,430.8a3.662,3.662,0,0,0-.268,1.374A3.783,3.783,0,0,0,270.023,436c.06,0,.166,0,.3-.012h40.905a7.036,7.036,0,0,0,6.391-5.193l10.769-41.131a3.75,3.75,0,0,0-3.445-5.208c-.108,0-.217,0-.326.014Zm311.324-308.4h-41a7.066,7.066,0,0,0-6.392,5.129l-91.46,349.436a4.073,4.073,0,0,0-.229,1.347,3.872,3.872,0,0,0,3.863,3.851c.056,0,.112,0,.169,0h40.968a7.1,7.1,0,0,0,6.392-5.193L639.68,81.2a3.624,3.624,0,0,0,.32-1.475,3.841,3.841,0,0,0-3.821-3.564c-.068,0-.137,0-.206.006ZM371.562,225.236l10.8-41.1a4.369,4.369,0,0,0,.227-1.388,3.869,3.869,0,0,0-3.861-3.842c-.057,0-.113,0-.169,0h-41.1a7.292,7.292,0,0,0-6.391,5.226l-10.834,41.1a4.417,4.417,0,0,0-.26,1.493c0,.069,0,.138,0,.206a3.776,3.776,0,0,0,3.757,3.507c.076,0,.18,0,.3-.012h41.129A7.034,7.034,0,0,0,371.562,225.236Z"
    ]
};
var $42ee1027226cd96e$export$f32e8672931b41ff = {
    prefix: 'fab',
    iconName: 'upwork',
    icon: [
        448,
        512,
        [],
        "e641",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM270.8 274.3c5.2 8.4 23.6 29.9 51.5 29.9v0c25.2 0 44.9-20.2 44.9-49.7s-19.4-49.7-44.9-49.7s-44.9 16.7-51.5 69.5zm-26.7-41.8c7.3-30.5 32.7-60.1 78.2-60.1l0 0c45.1 0 80.9 35.2 80.9 82.2s-35.9 81.9-80.9 81.9c-.6 0-1.1 0-1.7 0c-.5 0-1.1 0-1.6 0h-.1c-14.5-.5-28.7-4.8-40.9-12.6c-4.7-2.8-9.1-6-13.4-9.5l-12.8 78.4H214.9l19.4-110.6c-20.8-29.1-31.6-62.4-36.2-79.7V255c0 48-30.5 81.5-74.2 81.5c-22 0-41-8-54.8-23.3c-13.4-14.8-20.8-35.5-20.8-58.3V176.8H84.5l-.3 78.2c0 28.4 14.5 49.3 39.8 49.3s38.2-20.9 38.2-49.3V176.8h62.8c4.8 19.3 10.9 40.1 19.2 55.6z"
    ]
};
var $42ee1027226cd96e$export$86108d0b79007794 = {
    prefix: 'fab',
    iconName: 'facebook',
    icon: [
        512,
        512,
        [
            62000
        ],
        "f09a",
        "M512 256C512 114.6 397.4 0 256 0S0 114.6 0 256C0 376 82.7 476.8 194.2 504.5V334.2H141.4V256h52.8V222.3c0-87.1 39.4-127.5 125-127.5c16.2 0 44.2 3.2 55.7 6.4V172c-6-.6-16.5-1-29.6-1c-42 0-58.2 15.9-58.2 57.2V256h83.6l-14.4 78.2H287V510.1C413.8 494.8 512 386.9 512 256h0z"
    ]
};
var $42ee1027226cd96e$export$957b7296da5b4490 = {
    prefix: 'fab',
    iconName: 'gripfire',
    icon: [
        384,
        512,
        [],
        "f3ac",
        "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
    ]
};
var $42ee1027226cd96e$export$3a376d0f2ecfb7d0 = {
    prefix: 'fab',
    iconName: 'jedi-order',
    icon: [
        448,
        512,
        [],
        "f50e",
        "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
    ]
};
var $42ee1027226cd96e$export$27afc16078b5f3ac = {
    prefix: 'fab',
    iconName: 'uikit',
    icon: [
        448,
        512,
        [],
        "f403",
        "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
    ]
};
var $42ee1027226cd96e$export$a5097e0b1bb080b7 = {
    prefix: 'fab',
    iconName: 'fort-awesome-alt',
    icon: [
        512,
        512,
        [],
        "f3a3",
        "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
    ]
};
var $42ee1027226cd96e$export$cc29519275365076 = {
    prefix: 'fab',
    iconName: 'phabricator',
    icon: [
        496,
        512,
        [],
        "f3db",
        "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
    ]
};
var $42ee1027226cd96e$export$d0ceedb643a91662 = {
    prefix: 'fab',
    iconName: 'ussunnah',
    icon: [
        482,
        512,
        [],
        "f407",
        "M481.9 268.1A240.9 240.9 0 1 1 .1 268a240.9 240.9 0 1 1 481.9 0zM24.5 268a216.5 216.5 0 1 0 432.9 0A216.5 216.5 0 1 0 24.5 268zm385.9 63.3c-12.7 0-21.6-1.9-26.7-5.9c-5.5-4.3-8.2-12.3-8.2-23.8V205.1c0-6.5-5.2-20.2-15.7-41.2c7 0 17-9.1 30-27.2V284.5c0 11 2.4 19.4 7 25.3c3.7 4.7 10.1 8.9 19 12.6c1.2 .4 2.6 .9 4.1 1.4c2.9 .9 6.3 2.1 10.3 3.5c-1.8 2.7-8.3 4-19.9 4zm-219 0c-1.3 2.4-3.6 5.5-6.8 9.4l-18.5 22.5c-1-6.1-4-13-9.3-20.6s-9.7-11.4-13.4-11.4h-8.3H53.6c3.3-5.3 4.9-8.8 4.9-10.8c0-2-.8-5.3-2.4-9.7c-1.5-4.4-2.4-8.5-2.4-12.4c0-7.4 2.1-13.9 6.3-19.3L80 253.4l-7.1-17.7L89 215.9l6.7 16.8 8-10.3c-1.8 6.4-2.6 12.3-2.6 17.7c0 4.2 2.8 13.3 8.3 27.3l16.2 40.7H135h8 .3c2.8 .4 7.7 5 14.6 13.9c1.8 2.4 4.3 5.8 7.7 10.2c1.4 1.9 2.9 3.9 4.6 6.1c1.3-2.3 2-4.6 2-7.1c0-2-1.3-6.6-4-13.4L163 304.1c-4-10.6-6.1-17.7-6.1-21.3c0-6.3 1.9-12.3 5.8-17.9c.5-.6 1-1.3 1.5-1.9c4.4-5.6 8.8-11.1 13.3-16.5c-1.1 4.6-1.7 8.7-1.7 12c0 3.7 1.7 9.9 5.1 18.8l7.9 20.4c1.9 4.7 3 8.2 3.7 10.3h17.6 8.3l-.9-2.6c-1.4-3.9-4-7-7.7-9.3l15.6-20.1 12.3 32h13.4L245 292.2c-1.5-3.9-4-7-7.7-9.3L253 262.8 270.3 308h13.4l-11.4-29.4c-1.5-3.9-4-7-7.7-9.3l15.6-20L302.6 308h10.3 8.3 7.6c1.5 0 3-1.1 4.5-3.1s2.2-4.1 2.2-6.3V205.1c0-6.5-4.5-20.3-13.7-41.2c5.4 0 14.1-9.1 26.2-27.2V300.2c0 7.2 .6 12 1.7 14.6c1.6 3.4 5.3 6.2 11.1 8.2c-3.9 5.6-8.7 8.5-14.5 8.5H321.1h-8.3H210.5h-19zM93.4 287.3c-2.7-6.7-4-11.7-4-15c-.6 1.2-2.4 3.7-5.4 7.6c-1.4 1.9-2.2 3.7-2.2 5.3c0 2.6 .8 5.7 2.2 9.3l5.6 13.9h0c5 0 9 0 11.9-.1l-8.2-20.9zm13.5-72.4c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm-27.6 0c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3zm87 27.5c-3-5.2-7-9.3-11.9-11.9c-3.5-1.9-5.3-4.3-5.3-7.4c0-2.4 4.6-8.6 14-18.3c.2 3.8 1.9 7.6 4.9 11.2c3.1 3.6 4.6 7 4.6 10.1c0 2.6-2.1 8-6.2 16.3z"
    ]
};
var $42ee1027226cd96e$export$c30a6352a2a5e8ea = {
    prefix: 'fab',
    iconName: 'earlybirds',
    icon: [
        480,
        512,
        [],
        "f39a",
        "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
    ]
};
var $42ee1027226cd96e$export$83b68077d321f3ad = {
    prefix: 'fab',
    iconName: 'trade-federation',
    icon: [
        496,
        512,
        [],
        "f513",
        "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
    ]
};
var $42ee1027226cd96e$export$2ea4e300aa12cd0a = {
    prefix: 'fab',
    iconName: 'autoprefixer',
    icon: [
        640,
        512,
        [],
        "f41c",
        "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
    ]
};
var $42ee1027226cd96e$export$45bdf388845cdf99 = {
    prefix: 'fab',
    iconName: 'whatsapp',
    icon: [
        448,
        512,
        [],
        "f232",
        "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    ]
};
var $42ee1027226cd96e$export$4dcd48fd9c0bdd2d = {
    prefix: 'fab',
    iconName: 'slideshare',
    icon: [
        512,
        512,
        [],
        "f1e7",
        "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
    ]
};
var $42ee1027226cd96e$export$cfa707f90d6b79ec = {
    prefix: 'fab',
    iconName: 'google-play',
    icon: [
        512,
        512,
        [],
        "f3ab",
        "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
    ]
};
var $42ee1027226cd96e$export$6f9febfcc8ac97d4 = {
    prefix: 'fab',
    iconName: 'viadeo',
    icon: [
        448,
        512,
        [],
        "f2a9",
        "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
    ]
};
var $42ee1027226cd96e$export$c5b04bbf0f48913a = {
    prefix: 'fab',
    iconName: 'line',
    icon: [
        512,
        512,
        [],
        "f3c0",
        "M311 196.8v81.3c0 2.1-1.6 3.7-3.7 3.7h-13c-1.3 0-2.4-.7-3-1.5l-37.3-50.3v48.2c0 2.1-1.6 3.7-3.7 3.7h-13c-2.1 0-3.7-1.6-3.7-3.7V196.9c0-2.1 1.6-3.7 3.7-3.7h12.9c1.1 0 2.4 .6 3 1.6l37.3 50.3V196.9c0-2.1 1.6-3.7 3.7-3.7h13c2.1-.1 3.8 1.6 3.8 3.5zm-93.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 2.1 1.6 3.7 3.7 3.7h13c2.1 0 3.7-1.6 3.7-3.7V196.8c0-1.9-1.6-3.7-3.7-3.7zm-31.4 68.1H150.3V196.8c0-2.1-1.6-3.7-3.7-3.7h-13c-2.1 0-3.7 1.6-3.7 3.7v81.3c0 1 .3 1.8 1 2.5c.7 .6 1.5 1 2.5 1h52.2c2.1 0 3.7-1.6 3.7-3.7v-13c0-1.9-1.6-3.7-3.5-3.7zm193.7-68.1H327.3c-1.9 0-3.7 1.6-3.7 3.7v81.3c0 1.9 1.6 3.7 3.7 3.7h52.2c2.1 0 3.7-1.6 3.7-3.7V265c0-2.1-1.6-3.7-3.7-3.7H344V247.7h35.5c2.1 0 3.7-1.6 3.7-3.7V230.9c0-2.1-1.6-3.7-3.7-3.7H344V213.5h35.5c2.1 0 3.7-1.6 3.7-3.7v-13c-.1-1.9-1.7-3.7-3.7-3.7zM512 93.4V419.4c-.1 51.2-42.1 92.7-93.4 92.6H92.6C41.4 511.9-.1 469.8 0 418.6V92.6C.1 41.4 42.2-.1 93.4 0H419.4c51.2 .1 92.7 42.1 92.6 93.4zM441.6 233.5c0-83.4-83.7-151.3-186.4-151.3s-186.4 67.9-186.4 151.3c0 74.7 66.3 137.4 155.9 149.3c21.8 4.7 19.3 12.7 14.4 42.1c-.8 4.7-3.8 18.4 16.1 10.1s107.3-63.2 146.5-108.2c27-29.7 39.9-59.8 39.9-93.1z"
    ]
};
var $42ee1027226cd96e$export$631c05505a17faa8 = {
    prefix: 'fab',
    iconName: 'google-drive',
    icon: [
        512,
        512,
        [],
        "f3aa",
        "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
    ]
};
var $42ee1027226cd96e$export$c2417738aeefe7e6 = {
    prefix: 'fab',
    iconName: 'servicestack',
    icon: [
        496,
        512,
        [],
        "f3ec",
        "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
    ]
};
var $42ee1027226cd96e$export$8b48c2e6e01a12e0 = {
    prefix: 'fab',
    iconName: 'simplybuilt',
    icon: [
        512,
        512,
        [],
        "f215",
        "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
    ]
};
var $42ee1027226cd96e$export$de75f8fcf71dfed9 = {
    prefix: 'fab',
    iconName: 'bitbucket',
    icon: [
        512,
        512,
        [
            61810
        ],
        "f171",
        "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
    ]
};
var $42ee1027226cd96e$export$c85bcd118a7a17ff = {
    prefix: 'fab',
    iconName: 'imdb',
    icon: [
        448,
        512,
        [],
        "f2d8",
        "M89.5 323.6H53.93V186.2H89.5V323.6zM156.1 250.5L165.2 186.2H211.5V323.6H180.5V230.9L167.1 323.6H145.8L132.8 232.9L132.7 323.6H101.5V186.2H147.6C148.1 194.5 150.4 204.3 151.9 215.6L156.1 250.5zM223.7 323.6V186.2H250.3C267.3 186.2 277.3 187.1 283.3 188.6C289.4 190.3 294 192.8 297.2 196.5C300.3 199.8 302.3 203.1 303 208.5C303.9 212.9 304.4 221.6 304.4 234.7V282.9C304.4 295.2 303.7 303.4 302.5 307.6C301.4 311.7 299.4 315 296.5 317.3C293.7 319.7 290.1 321.4 285.8 322.3C281.6 323.1 275.2 323.6 266.7 323.6H223.7zM259.2 209.7V299.1C264.3 299.1 267.5 298.1 268.6 296.8C269.7 294.8 270.4 289.2 270.4 280.1V226.8C270.4 220.6 270.3 216.6 269.7 214.8C269.4 213 268.5 211.8 267.1 210.1C265.7 210.1 263 209.7 259.2 209.7V209.7zM316.5 323.6V186.2H350.6V230.1C353.5 227.7 356.7 225.2 360.1 223.5C363.7 222 368.9 221.1 372.9 221.1C377.7 221.1 381.8 221.9 385.2 223.3C388.6 224.8 391.2 226.8 393.2 229.5C394.9 232.1 395.9 234.8 396.3 237.3C396.7 239.9 396.1 245.3 396.1 253.5V292.1C396.1 300.3 396.3 306.4 395.3 310.5C394.2 314.5 391.5 318.1 387.5 320.1C383.4 324 378.6 325.4 372.9 325.4C368.9 325.4 363.7 324.5 360.2 322.9C356.7 321.1 353.5 318.4 350.6 314.9L348.5 323.6L316.5 323.6zM361.6 302.9C362.3 301.1 362.6 296.9 362.6 290.4V255C362.6 249.4 362.3 245.5 361.5 243.8C360.8 241.9 357.8 241.1 355.7 241.1C353.7 241.1 352.3 241.9 351.6 243.4C351 244.9 350.6 248.8 350.6 255V291.4C350.6 297.5 351 301.4 351.8 303C352.4 304.7 353.9 305.5 355.9 305.5C358.1 305.5 360.1 304.7 361.6 302.9L361.6 302.9zM418.4 32.04C434.1 33.27 447.1 47.28 447.1 63.92V448.1C447.1 464.5 435.2 478.5 418.9 479.1C418.6 479.1 418.4 480 418.1 480H29.88C29.6 480 29.32 479.1 29.04 479.9C13.31 478.5 1.093 466.1 0 449.7L.0186 61.78C1.081 45.88 13.82 33.09 30.26 31.1H417.7C417.9 31.1 418.2 32.01 418.4 32.04L418.4 32.04zM30.27 41.26C19 42.01 10.02 51.01 9.257 62.4V449.7C9.63 455.1 11.91 460.2 15.7 464C19.48 467.9 24.51 470.3 29.89 470.7H418.1C429.6 469.7 438.7 459.1 438.7 448.1V63.91C438.7 58.17 436.6 52.65 432.7 48.45C428.8 44.24 423.4 41.67 417.7 41.26L30.27 41.26z"
    ]
};
var $42ee1027226cd96e$export$17ab471305a2654c = {
    prefix: 'fab',
    iconName: 'deezer',
    icon: [
        576,
        512,
        [],
        "e077",
        "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
    ]
};
var $42ee1027226cd96e$export$910e018904f54b08 = {
    prefix: 'fab',
    iconName: 'raspberry-pi',
    icon: [
        407,
        512,
        [],
        "f7bb",
        "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
    ]
};
var $42ee1027226cd96e$export$78c2aea9064d90bd = {
    prefix: 'fab',
    iconName: 'jira',
    icon: [
        496,
        512,
        [],
        "f7b1",
        "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
    ]
};
var $42ee1027226cd96e$export$b29e4ebead927988 = {
    prefix: 'fab',
    iconName: 'docker',
    icon: [
        640,
        512,
        [],
        "f395",
        "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
    ]
};
var $42ee1027226cd96e$export$63c4c3c3c5975c3e = {
    prefix: 'fab',
    iconName: 'screenpal',
    icon: [
        512,
        512,
        [],
        "e570",
        "M233.5 22.49C233.5 10.07 243.6 0 256 0C268.4 0 278.5 10.07 278.5 22.49C278.5 34.91 268.4 44.98 256 44.98C243.6 44.98 233.5 34.91 233.5 22.49zM313.4 259C313.4 290.7 287.7 316.4 256 316.4C224.3 316.4 198.6 290.7 198.6 259C198.6 227.3 224.3 201.6 256 201.6C287.7 201.6 313.4 227.3 313.4 259zM337.2 350C359.5 330.1 373.7 302.7 377.1 273H496.6C493.1 334.4 466.2 392.2 421.4 434.4C376.7 476.6 317.5 500.2 256 500.2C194.5 500.2 135.3 476.6 90.56 434.4C45.83 392.2 18.94 334.4 15.39 273H135.1C138.5 302.7 152.7 330.1 175 350C197.3 369.9 226.2 380.9 256.1 380.9C285.1 380.9 314.8 369.9 337.2 350zM73.14 140.3C73.54 152.7 63.81 163.1 51.39 163.5C38.97 163.9 28.59 154.2 28.18 141.8C27.78 129.3 37.52 118.9 49.94 118.5C62.35 118.1 72.74 127.9 73.14 140.3zM438.9 141C438.9 128.6 448.9 118.5 461.4 118.5C473.8 118.5 483.8 128.6 483.8 141C483.8 153.5 473.8 163.5 461.4 163.5C448.9 163.5 438.9 153.5 438.9 141zM317.9 95.27C300.6 109.1 278.7 118.1 256 118.1C233.3 118.1 211.4 109.1 194.1 95.27C176.8 80.55 165.3 60.18 161.7 37.78C176.8 31.37 192.5 26.52 208.6 23.31C208.6 35.88 213.6 47.93 222.5 56.82C231.4 65.7 243.4 70.7 256 70.7C268.6 70.7 280.6 65.7 289.5 56.82C298.4 47.93 303.4 35.88 303.4 23.31C319.5 26.52 335.2 31.37 350.3 37.78C346.7 60.18 335.2 80.55 317.9 95.27H317.9zM82.78 231C61.42 238.6 38.06 238.4 16.86 230.4C18.82 214.1 22.46 198.1 27.71 182.5C33.1 185.6 39.05 187.6 45.22 188.5C51.39 189.3 57.67 188.9 63.68 187.3C69.69 185.6 75.33 182.9 80.27 179.1C85.21 175.3 89.36 170.6 92.47 165.2C95.58 159.8 97.61 153.8 98.42 147.7C99.23 141.5 98.83 135.2 97.22 129.2C95.61 123.2 92.83 117.6 89.04 112.6C85.25 107.7 80.53 103.5 75.14 100.4C85.96 88.11 98.01 76.94 111.1 67.07C128.7 81.42 140.6 101.6 144.7 123.9C148.8 146.2 144.8 169.3 133.5 188.9C122.1 208.5 104.1 223.4 82.78 231V231zM429.2 231.1C407.9 223.5 389.9 208.5 378.5 188.9C367.2 169.3 363.3 146.2 367.4 123.9C371.5 101.7 383.4 81.54 400.9 67.19C414 77.04 426.1 88.21 436.9 100.5C426.2 106.9 418.5 117.2 415.4 129.3C412.2 141.3 413.1 154.1 420.2 164.9C426.4 175.7 436.6 183.6 448.6 186.9C460.6 190.2 473.5 188.6 484.3 182.6C489.6 198.1 493.2 214.2 495.2 230.4C473.1 238.5 450.6 238.7 429.2 231.1L429.2 231.1z"
    ]
};
var $42ee1027226cd96e$export$f77d9ddfdff1e2a7 = {
    prefix: 'fab',
    iconName: 'bluetooth',
    icon: [
        448,
        512,
        [],
        "f293",
        "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
    ]
};
var $42ee1027226cd96e$export$56aff378d7858517 = {
    prefix: 'fab',
    iconName: 'gitter',
    icon: [
        384,
        512,
        [],
        "f426",
        "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
    ]
};
var $42ee1027226cd96e$export$8fb5b89b3d7583de = {
    prefix: 'fab',
    iconName: 'd-and-d',
    icon: [
        576,
        512,
        [],
        "f38d",
        "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
    ]
};
var $42ee1027226cd96e$export$d5808a1a9747be4c = {
    prefix: 'fab',
    iconName: 'microblog',
    icon: [
        448,
        512,
        [],
        "e01a",
        "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
    ]
};
var $42ee1027226cd96e$export$e24e559a44f492e1 = {
    prefix: 'fab',
    iconName: 'cc-diners-club',
    icon: [
        576,
        512,
        [],
        "f24c",
        "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
    ]
};
var $42ee1027226cd96e$export$6d2eed3a88c7ed1a = {
    prefix: 'fab',
    iconName: 'gg-circle',
    icon: [
        512,
        512,
        [],
        "f261",
        "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
    ]
};
var $42ee1027226cd96e$export$238a02799aabf743 = {
    prefix: 'fab',
    iconName: 'pied-piper-hat',
    icon: [
        640,
        512,
        [],
        "f4e5",
        "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
    ]
};
var $42ee1027226cd96e$export$36ebae5de28f5e9e = {
    prefix: 'fab',
    iconName: 'kickstarter-k',
    icon: [
        384,
        512,
        [],
        "f3bc",
        "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
    ]
};
var $42ee1027226cd96e$export$d51f17330f9046ea = {
    prefix: 'fab',
    iconName: 'yandex',
    icon: [
        256,
        512,
        [],
        "f413",
        "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
    ]
};
var $42ee1027226cd96e$export$7dcb0372cc290c0e = {
    prefix: 'fab',
    iconName: 'readme',
    icon: [
        576,
        512,
        [],
        "f4d5",
        "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
    ]
};
var $42ee1027226cd96e$export$d1a4948b9a07ae7c = {
    prefix: 'fab',
    iconName: 'html5',
    icon: [
        384,
        512,
        [],
        "f13b",
        "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
    ]
};
var $42ee1027226cd96e$export$cb60511a0f837c82 = {
    prefix: 'fab',
    iconName: 'sellsy',
    icon: [
        640,
        512,
        [],
        "f213",
        "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
    ]
};
var $42ee1027226cd96e$export$5afc94dc87b38719 = {
    prefix: 'fab',
    iconName: 'sass',
    icon: [
        640,
        512,
        [],
        "f41e",
        "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
    ]
};
var $42ee1027226cd96e$export$304e26e1efc5b1a4 = {
    prefix: 'fab',
    iconName: 'wirsindhandwerk',
    icon: [
        512,
        512,
        [
            "wsh"
        ],
        "e2d0",
        "M50.77161,479.81213h83.36071V367.84741l-83.36071,47.009Zm329.04675,0h82.35022V414.85645l-82.35022-47.009Zm.00568-448V251.568L256.1759,179.1861,134.50378,251.568V31.81213H50.77161V392.60565L256.1759,270.31909,462.16858,392.60565V31.81213Z"
    ]
};
var $42ee1027226cd96e$export$c6d19319c89c1ce4 = $42ee1027226cd96e$export$304e26e1efc5b1a4;
var $42ee1027226cd96e$export$25d99c8ee7e610e5 = {
    prefix: 'fab',
    iconName: 'buromobelexperte',
    icon: [
        448,
        512,
        [],
        "f37f",
        "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
    ]
};
var $42ee1027226cd96e$export$fb5e089c1f25c80c = {
    prefix: 'fab',
    iconName: 'salesforce',
    icon: [
        640,
        512,
        [],
        "f83b",
        "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
    ]
};
var $42ee1027226cd96e$export$4a726382b32e57cc = {
    prefix: 'fab',
    iconName: 'octopus-deploy',
    icon: [
        512,
        512,
        [],
        "e082",
        "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
    ]
};
var $42ee1027226cd96e$export$86efffc3e85d2a9 = {
    prefix: 'fab',
    iconName: 'medapps',
    icon: [
        320,
        512,
        [],
        "f3c6",
        "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
    ]
};
var $42ee1027226cd96e$export$ffa3f5d32fe6bc0e = {
    prefix: 'fab',
    iconName: 'ns8',
    icon: [
        640,
        512,
        [],
        "f3d5",
        "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
    ]
};
var $42ee1027226cd96e$export$e1681fe8211dd475 = {
    prefix: 'fab',
    iconName: 'pinterest-p',
    icon: [
        384,
        512,
        [],
        "f231",
        "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
    ]
};
var $42ee1027226cd96e$export$aa79881dfcf87a16 = {
    prefix: 'fab',
    iconName: 'apper',
    icon: [
        640,
        512,
        [],
        "f371",
        "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
    ]
};
var $42ee1027226cd96e$export$c2ee281dce8eb9d5 = {
    prefix: 'fab',
    iconName: 'fort-awesome',
    icon: [
        512,
        512,
        [],
        "f286",
        "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
    ]
};
var $42ee1027226cd96e$export$8d560f87da34bcc1 = {
    prefix: 'fab',
    iconName: 'waze',
    icon: [
        512,
        512,
        [],
        "f83f",
        "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
    ]
};
var $42ee1027226cd96e$export$4f0eff72b7493340 = {
    prefix: 'fab',
    iconName: 'cc-jcb',
    icon: [
        576,
        512,
        [],
        "f24b",
        "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
    ]
};
var $42ee1027226cd96e$export$3770724b51125ef1 = {
    prefix: 'fab',
    iconName: 'snapchat',
    icon: [
        512,
        512,
        [
            62124,
            "snapchat-ghost"
        ],
        "f2ab",
        "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"
    ]
};
var $42ee1027226cd96e$export$e6e855f745e10958 = $42ee1027226cd96e$export$3770724b51125ef1;
var $42ee1027226cd96e$export$318074701514e1 = {
    prefix: 'fab',
    iconName: 'fantasy-flight-games',
    icon: [
        512,
        512,
        [],
        "f6dc",
        "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
    ]
};
var $42ee1027226cd96e$export$8a8ef141dcbeda7b = {
    prefix: 'fab',
    iconName: 'rust',
    icon: [
        512,
        512,
        [],
        "e07a",
        "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
    ]
};
var $42ee1027226cd96e$export$423f2efa0d73b5f9 = {
    prefix: 'fab',
    iconName: 'wix',
    icon: [
        640,
        512,
        [],
        "f5cf",
        "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
    ]
};
var $42ee1027226cd96e$export$3a09eb8c07c8379f = {
    prefix: 'fab',
    iconName: 'square-behance',
    icon: [
        448,
        512,
        [
            "behance-square"
        ],
        "f1b5",
        "M155.3 318.4c17.2 0 31.2-6.1 31.2-25.4c0-19.7-11.7-27.4-30.3-27.5h-46v52.9h45.1zm-5.4-129.6H110.3v44.8H153c15.1 0 25.8-6.6 25.8-22.9c0-17.7-13.7-21.9-28.9-21.9zm129.5 74.8h62.2c-1.7-18.5-11.3-29.7-30.5-29.7c-18.3 0-30.5 11.4-31.7 29.7zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM349.5 185H271.7V166.1h77.8V185zM193.7 243.7c23.6 6.7 35 27.5 35 51.6c0 39-32.7 55.7-67.6 55.9H68v-192h90.5c32.9 0 61.4 9.3 61.4 47.5c0 19.3-9 28.8-26.2 37zm118.7-38.6c43.5 0 67.6 34.3 67.6 75.4c0 1.6-.1 3.3-.2 5c0 .8-.1 1.5-.1 2.2H279.5c0 22.2 11.7 35.3 34.1 35.3c11.6 0 26.5-6.2 30.2-18.1h33.7c-10.4 31.9-31.9 46.8-65.1 46.8c-43.8 0-71.1-29.7-71.1-73c0-41.8 28.7-73.6 71.1-73.6z"
    ]
};
var $42ee1027226cd96e$export$bb4b7fb598656746 = $42ee1027226cd96e$export$3a09eb8c07c8379f;
var $42ee1027226cd96e$export$9be373796460fb80 = {
    prefix: 'fab',
    iconName: 'supple',
    icon: [
        640,
        512,
        [],
        "f3f9",
        "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
    ]
};
var $42ee1027226cd96e$export$b4c5293ffb331d6a = {
    prefix: 'fab',
    iconName: 'webflow',
    icon: [
        640,
        512,
        [],
        "e65c",
        "M640 64L435.8 463.2H244l85.5-165.5h-3.8C255.1 389.3 149.9 449.5 0 463.2V300.1s95.9-5.7 152.3-64.9H0V64H171.1V204.8l3.8 0L244.9 64H374.3V203.9l3.8 0L450.7 64H640z"
    ]
};
var $42ee1027226cd96e$export$50bb8725ea3b3e34 = {
    prefix: 'fab',
    iconName: 'rebel',
    icon: [
        512,
        512,
        [],
        "f1d0",
        "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
    ]
};
var $42ee1027226cd96e$export$f32e22910f9b44 = {
    prefix: 'fab',
    iconName: 'css3',
    icon: [
        512,
        512,
        [],
        "f13c",
        "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
    ]
};
var $42ee1027226cd96e$export$ffbc7f79ed77f082 = {
    prefix: 'fab',
    iconName: 'staylinked',
    icon: [
        440,
        512,
        [],
        "f3f5",
        "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
    ]
};
var $42ee1027226cd96e$export$a03842279a704aae = {
    prefix: 'fab',
    iconName: 'kaggle',
    icon: [
        320,
        512,
        [],
        "f5fa",
        "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
    ]
};
var $42ee1027226cd96e$export$1aecd37105f38798 = {
    prefix: 'fab',
    iconName: 'space-awesome',
    icon: [
        512,
        512,
        [],
        "e5ac",
        "M96 256H128V512H0V352H32V320H64V288H96V256zM512 352V512H384V256H416V288H448V320H480V352H512zM320 64H352V448H320V416H192V448H160V64H192V32H224V0H288V32H320V64zM288 128H224V192H288V128z"
    ]
};
var $42ee1027226cd96e$export$36a61c57a904744e = {
    prefix: 'fab',
    iconName: 'deviantart',
    icon: [
        320,
        512,
        [],
        "f1bd",
        "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
    ]
};
var $42ee1027226cd96e$export$4b1cbad29e4915c6 = {
    prefix: 'fab',
    iconName: 'cpanel',
    icon: [
        640,
        512,
        [],
        "f388",
        "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
    ]
};
var $42ee1027226cd96e$export$659cd0fc2157d001 = {
    prefix: 'fab',
    iconName: 'goodreads-g',
    icon: [
        384,
        512,
        [],
        "f3a9",
        "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
    ]
};
var $42ee1027226cd96e$export$ccce513bbd3bef1d = {
    prefix: 'fab',
    iconName: 'square-git',
    icon: [
        448,
        512,
        [
            "git-square"
        ],
        "f1d2",
        "M120.8 335.5c-5.9-.4-12.6-.8-20.2-1.3c-3.3 4.1-6.6 8.4-6.6 13.5c0 18.5 65.5 18.5 65.5-1.5c0-8.3-7.4-8.7-38.8-10.7zm7.8-117.9c-32.3 0-33.7 44.5-.7 44.5c32.5 0 31.7-44.5 .7-44.5zM384 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64zM243.9 172.2c-14.5 0-22.9-8.4-22.9-22.9c0-14.5 8.4-22.3 22.9-22.3c14.7 0 23.1 7.8 23.1 22.3s-8.4 22.9-23.1 22.9zM149.6 195h49.5l0 21.6-23.4 1.8c4.6 5.8 9.4 14 9.4 25.7c0 48.7-57.2 47.2-74.2 42.4l-8.4 13.4c5 .3 9.8 .6 14.3 .8c56.3 3.2 80.5 4.6 80.5 38.5c0 29.2-25.7 45.7-69.9 45.7c-46 0-63.5-11.6-63.5-31.7c0-11.4 5.1-17.5 14-25.9c-8.4-3.5-11.2-9.9-11.2-16.8c0-9.6 7.4-16.3 23-30.6l.2-.2c-12.4-6.1-21.8-19.3-21.8-38.1c0-51.6 56.6-53.3 81.6-46.8zM270.5 303.1l13 1.8 0 20.1H211.1V304.9c2.7-.4 5-.7 6.9-.9c9.9-1.2 10.1-1.3 10.1-6V223.3c0-4.4-.9-4.7-10.1-7.8c-1.9-.7-4.2-1.4-6.9-2.4l2.8-20.6h52.6V298c0 4.1 .2 4.6 4.1 5.1zm106.6-10.4L384 315c-10.9 5.4-26.9 10.2-41.4 10.2c-30.2 0-41.7-12.2-41.7-40.9V217.7c0-.8 0-1.4-.2-1.8c-.8-1.2-4.2-.7-19.6-.7V192.6c22.3-2.5 31.2-13.7 34-41.4h24.2c0 33.3-.6 38 .7 38.6c.3 .1 .7 0 1.3 0h35.8v25.4H339.3v60.7c0 .2 0 .5 0 .9c-.2 6.3-.9 30.4 37.9 15.9z"
    ]
};
var $42ee1027226cd96e$export$545247d36a0c2435 = $42ee1027226cd96e$export$ccce513bbd3bef1d;
var $42ee1027226cd96e$export$b22e93e631701aa0 = {
    prefix: 'fab',
    iconName: 'square-tumblr',
    icon: [
        448,
        512,
        [
            "tumblr-square"
        ],
        "f174",
        "M448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM256.8 416c-75.5 0-91.9-55.5-91.9-87.9v-90H135.2c-3.4 0-6.2-2.8-6.2-6.2V189.4c0-4.5 2.8-8.5 7.1-10c38.8-13.7 50.9-47.5 52.7-73.2c.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2H249.1V321c0 21.4 14.8 33.5 42.5 22.4c3-1.2 5.6-2 8-1.4c2.2 .5 3.6 2.1 4.6 4.9L318 387.1c1 3.2 2 6.7-.3 9.1c-8.5 9.1-31.2 19.8-60.9 19.8z"
    ]
};
var $42ee1027226cd96e$export$b3979340ece626fe = $42ee1027226cd96e$export$b22e93e631701aa0;
var $42ee1027226cd96e$export$33a1efa865dd0849 = {
    prefix: 'fab',
    iconName: 'trello',
    icon: [
        448,
        512,
        [],
        "f181",
        "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
    ]
};
var $42ee1027226cd96e$export$e119d42c61b568e2 = {
    prefix: 'fab',
    iconName: 'creative-commons-nc-jp',
    icon: [
        496,
        512,
        [],
        "f4ea",
        "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
    ]
};
var $42ee1027226cd96e$export$17e9384897437d5a = {
    prefix: 'fab',
    iconName: 'get-pocket',
    icon: [
        448,
        512,
        [],
        "f265",
        "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
    ]
};
var $42ee1027226cd96e$export$53e7f606db333d60 = {
    prefix: 'fab',
    iconName: 'perbyte',
    icon: [
        448,
        512,
        [],
        "e083",
        "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
    ]
};
var $42ee1027226cd96e$export$b84863db58925c09 = {
    prefix: 'fab',
    iconName: 'grunt',
    icon: [
        384,
        512,
        [],
        "f3ad",
        "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
    ]
};
var $42ee1027226cd96e$export$33e64266c9adb232 = {
    prefix: 'fab',
    iconName: 'weebly',
    icon: [
        512,
        512,
        [],
        "f5cc",
        "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
    ]
};
var $42ee1027226cd96e$export$38091cf7f8c68318 = {
    prefix: 'fab',
    iconName: 'connectdevelop',
    icon: [
        576,
        512,
        [],
        "f20e",
        "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
    ]
};
var $42ee1027226cd96e$export$c6c358b395e9032d = {
    prefix: 'fab',
    iconName: 'leanpub',
    icon: [
        576,
        512,
        [],
        "f212",
        "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
    ]
};
var $42ee1027226cd96e$export$161a3454c1d6abdb = {
    prefix: 'fab',
    iconName: 'black-tie',
    icon: [
        448,
        512,
        [],
        "f27e",
        "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
    ]
};
var $42ee1027226cd96e$export$ec9cce37001091c7 = {
    prefix: 'fab',
    iconName: 'themeco',
    icon: [
        448,
        512,
        [],
        "f5c6",
        "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
    ]
};
var $42ee1027226cd96e$export$15d5df18b87754e3 = {
    prefix: 'fab',
    iconName: 'python',
    icon: [
        448,
        512,
        [],
        "f3e2",
        "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
    ]
};
var $42ee1027226cd96e$export$d3988148e7ca3c41 = {
    prefix: 'fab',
    iconName: 'android',
    icon: [
        576,
        512,
        [],
        "f17b",
        "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
    ]
};
var $42ee1027226cd96e$export$d367d9d00bf47408 = {
    prefix: 'fab',
    iconName: 'bots',
    icon: [
        640,
        512,
        [],
        "e340",
        "M86.344,197.834a51.767,51.767,0,0,0-41.57,20.058V156.018a8.19,8.19,0,0,0-8.19-8.19H8.19A8.19,8.19,0,0,0,0,156.018V333.551a8.189,8.189,0,0,0,8.19,8.189H36.584a8.189,8.189,0,0,0,8.19-8.189v-8.088c11.628,13.373,25.874,19.769,41.573,19.769,34.6,0,61.922-26.164,61.922-73.843C148.266,225.452,121.229,197.834,86.344,197.834ZM71.516,305.691c-9.593,0-21.221-4.942-26.745-12.5V250.164c5.528-7.558,17.152-12.791,26.745-12.791,17.734,0,31.107,13.082,31.107,34.013C102.623,292.609,89.25,305.691,71.516,305.691Zm156.372-59.032a17.4,17.4,0,1,0,17.4,17.4A17.4,17.4,0,0,0,227.888,246.659ZM273.956,156.7V112.039a13.308,13.308,0,1,0-10.237,0V156.7a107.49,107.49,0,1,0,10.237,0Zm85.993,107.367c0,30.531-40.792,55.281-91.112,55.281s-91.111-24.75-91.111-55.281,40.792-55.281,91.111-55.281S359.949,233.532,359.949,264.062Zm-50.163,17.4a17.4,17.4,0,1,0-17.4-17.4h0A17.4,17.4,0,0,0,309.786,281.466ZM580.7,250.455c-14.828-2.617-22.387-3.78-22.387-9.885,0-5.523,7.268-9.884,17.735-9.884a65.56,65.56,0,0,1,34.484,10.1,8.171,8.171,0,0,0,11.288-2.468c.07-.11.138-.221.2-.333l8.611-14.886a8.2,8.2,0,0,0-2.867-11.123,99.863,99.863,0,0,0-52.014-14.138c-38.956,0-60.179,21.514-60.179,46.225,0,36.342,33.725,41.864,57.563,45.642,13.373,2.326,24.13,4.361,24.13,11.048,0,6.4-5.523,10.757-18.9,10.757-13.552,0-30.994-6.222-42.623-13.579a8.206,8.206,0,0,0-11.335,2.491c-.035.054-.069.108-.1.164l-10.2,16.891a8.222,8.222,0,0,0,2.491,11.066c15.224,10.3,37.663,16.692,59.441,16.692,40.409,0,63.957-19.769,63.957-46.515C640,260.63,604.537,254.816,580.7,250.455Zm-95.928,60.787a8.211,8.211,0,0,0-9.521-5.938,23.168,23.168,0,0,1-4.155.387c-7.849,0-12.5-6.106-12.5-14.245V240.28h20.349a8.143,8.143,0,0,0,8.141-8.143V209.466a8.143,8.143,0,0,0-8.141-8.143H458.594V171.091a8.143,8.143,0,0,0-8.143-8.143H422.257a8.143,8.143,0,0,0-8.143,8.143h0v30.232H399a8.143,8.143,0,0,0-8.143,8.143h0v22.671A8.143,8.143,0,0,0,399,240.28h15.115v63.667c0,27.037,15.408,41.282,43.9,41.282,12.183,0,21.383-2.2,27.6-5.446a8.161,8.161,0,0,0,4.145-9.278Z"
    ]
};
var $42ee1027226cd96e$export$8190ad5ab3a607e2 = {
    prefix: 'fab',
    iconName: 'free-code-camp',
    icon: [
        576,
        512,
        [],
        "f2c5",
        "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
    ]
};
var $42ee1027226cd96e$export$906602f6a1e50bdd = {
    prefix: 'fab',
    iconName: 'hornbill',
    icon: [
        512,
        512,
        [],
        "f592",
        "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
    ]
};
var $42ee1027226cd96e$export$530d32089c3347d5 = {
    prefix: 'fab',
    iconName: 'js',
    icon: [
        448,
        512,
        [],
        "f3b8",
        "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
    ]
};
var $42ee1027226cd96e$export$4ee0aea9bb537f01 = {
    prefix: 'fab',
    iconName: 'ideal',
    icon: [
        576,
        512,
        [],
        "e013",
        "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
    ]
};
var $42ee1027226cd96e$export$61f81190d1a8b4b = {
    prefix: 'fab',
    iconName: 'git',
    icon: [
        512,
        512,
        [],
        "f1d3",
        "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
    ]
};
var $42ee1027226cd96e$export$dad56877d4f4a953 = {
    prefix: 'fab',
    iconName: 'dev',
    icon: [
        448,
        512,
        [],
        "f6cc",
        "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
    ]
};
var $42ee1027226cd96e$export$e999ee7aa7883e37 = {
    prefix: 'fab',
    iconName: 'sketch',
    icon: [
        512,
        512,
        [],
        "f7c6",
        "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
    ]
};
var $42ee1027226cd96e$export$6bf616a61d0b7bf3 = {
    prefix: 'fab',
    iconName: 'yandex-international',
    icon: [
        320,
        512,
        [],
        "f414",
        "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
    ]
};
var $42ee1027226cd96e$export$2bcb24672b4bf6e6 = {
    prefix: 'fab',
    iconName: 'cc-amex',
    icon: [
        576,
        512,
        [],
        "f1f3",
        "M0 432c0 26.5 21.5 48 48 48H528c26.5 0 48-21.5 48-48v-1.1H514.3l-31.9-35.1-31.9 35.1H246.8V267.1H181L262.7 82.4h78.6l28.1 63.2V82.4h97.2L483.5 130l17-47.6H576V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80V432zm440.4-21.7L482.6 364l42 46.3H576l-68-72.1 68-72.1H525.4l-42 46.7-41.5-46.7H390.5L458 338.6l-67.4 71.6V377.1h-83V354.9h80.9V322.6H307.6V300.2h83V267.1h-122V410.3H440.4zm96.3-72L576 380.2V296.9l-39.3 41.4zm-36.3-92l36.9-100.6V246.3H576V103H515.8l-32.2 89.3L451.7 103H390.5V246.1L327.3 103H276.1L213.7 246.3h43l11.9-28.7h65.9l12 28.7h82.7V146L466 246.3h34.4zM282 185.4l19.5-46.9 19.4 46.9H282z"
    ]
};
var $42ee1027226cd96e$export$2b557426f8d6820b = {
    prefix: 'fab',
    iconName: 'uber',
    icon: [
        448,
        512,
        [],
        "f402",
        "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
    ]
};
var $42ee1027226cd96e$export$64e4bc4b496fbbdf = {
    prefix: 'fab',
    iconName: 'github',
    icon: [
        496,
        512,
        [],
        "f09b",
        "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
    ]
};
var $42ee1027226cd96e$export$e1ae2a8de48825fb = {
    prefix: 'fab',
    iconName: 'php',
    icon: [
        640,
        512,
        [],
        "f457",
        "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
    ]
};
var $42ee1027226cd96e$export$994c329bc073af57 = {
    prefix: 'fab',
    iconName: 'alipay',
    icon: [
        448,
        512,
        [],
        "f642",
        "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
    ]
};
var $42ee1027226cd96e$export$2373b132177332f8 = {
    prefix: 'fab',
    iconName: 'youtube',
    icon: [
        576,
        512,
        [
            61802
        ],
        "f167",
        "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
    ]
};
var $42ee1027226cd96e$export$b2254aecfa43ac3e = {
    prefix: 'fab',
    iconName: 'skyatlas',
    icon: [
        640,
        512,
        [],
        "f216",
        "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
    ]
};
var $42ee1027226cd96e$export$db16178b6453c842 = {
    prefix: 'fab',
    iconName: 'firefox-browser',
    icon: [
        512,
        512,
        [],
        "e007",
        "M130.22 127.548C130.38 127.558 130.3 127.558 130.22 127.548V127.548ZM481.64 172.898C471.03 147.398 449.56 119.898 432.7 111.168C446.42 138.058 454.37 165.048 457.4 185.168C457.405 185.306 457.422 185.443 457.45 185.578C429.87 116.828 383.098 89.1089 344.9 28.7479C329.908 5.05792 333.976 3.51792 331.82 4.08792L331.7 4.15792C284.99 30.1109 256.365 82.5289 249.12 126.898C232.503 127.771 216.219 131.895 201.19 139.035C199.838 139.649 198.736 140.706 198.066 142.031C197.396 143.356 197.199 144.87 197.506 146.323C197.7 147.162 198.068 147.951 198.586 148.639C199.103 149.327 199.76 149.899 200.512 150.318C201.264 150.737 202.096 150.993 202.954 151.071C203.811 151.148 204.676 151.045 205.491 150.768L206.011 150.558C221.511 143.255 238.408 139.393 255.541 139.238C318.369 138.669 352.698 183.262 363.161 201.528C350.161 192.378 326.811 183.338 304.341 187.248C392.081 231.108 368.541 381.784 246.951 376.448C187.487 373.838 149.881 325.467 146.421 285.648C146.421 285.648 157.671 243.698 227.041 243.698C234.541 243.698 255.971 222.778 256.371 216.698C256.281 214.698 213.836 197.822 197.281 181.518C188.434 172.805 184.229 168.611 180.511 165.458C178.499 163.75 176.392 162.158 174.201 160.688C168.638 141.231 168.399 120.638 173.51 101.058C148.45 112.468 128.96 130.508 114.8 146.428H114.68C105.01 134.178 105.68 93.7779 106.25 85.3479C106.13 84.8179 99.022 89.0159 98.1 89.6579C89.5342 95.7103 81.5528 102.55 74.26 110.088C57.969 126.688 30.128 160.242 18.76 211.318C14.224 231.701 12 255.739 12 263.618C12 398.318 121.21 507.508 255.92 507.508C376.56 507.508 478.939 420.281 496.35 304.888C507.922 228.192 481.64 173.82 481.64 172.898Z"
    ]
};
var $42ee1027226cd96e$export$a51c205a2c2f1780 = {
    prefix: 'fab',
    iconName: 'replyd',
    icon: [
        448,
        512,
        [],
        "f3e6",
        "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
    ]
};
var $42ee1027226cd96e$export$fd2c25240484ff41 = {
    prefix: 'fab',
    iconName: 'suse',
    icon: [
        640,
        512,
        [],
        "f7d6",
        "M593.1 192.6A10.4 10.4 0 1 1 604.5 210a10.4 10.4 0 1 1 -11.4-17.4zm-47.1 12.2a38.5 38.5 0 1 1 75-17.6 38.5 38.5 0 1 1 -75 17.6zM433.7 336.7c3.2 4.6 5.8 9 7.3 13.4c1 3.1 2.4 7.3 5.5 8.9c.2 .1 .3 .2 .5 .2c5.7 2.1 20.3 1.7 20.3 1.7h26.8c2.3 0 22.4 0 21.9-2.3c-2.4-10.8-14.9-12.7-24.4-18.3c-8.7-5.2-17-11.1-20.8-21.3c-2-5.2-.8-17.4 2.6-21.8c2.5-3.2 6.1-5.3 10-6.2c4.3-.9 8.8-.1 13.1 .3c5.3 .5 10.6 1.5 15.9 2.2c10.3 1.3 20.6 1.9 31 1.6c17.1-.5 34.2-3.2 50.4-8.7c11.3-3.8 22.4-8.9 32-16.1c10.9-8.1 8.1-7.4-3-6.2c-13.3 1.4-26.6 1.6-39.9 .8c-12.4-.7-24.7-2.2-35.9-7.9c-8.8-4.6-16.4-9.1-23.4-16.2c-1-1.1-1.7-4.2 .2-6.2c1.9-1.9 5.8-.8 7 .2c12.2 10.2 30.5 18.6 49.3 19.5c10.2 .5 20.1 .7 30.4 .3c5.1-.2 12.8-.2 17.9-.3c2.6 0 9.8 .7 11.2-2.1c.4-.8 .4-1.8 .3-2.7c-1.5-40.9-4.5-86.9-47.3-106.5c-31.9-14.6-79.7-37.2-99.9-46.6c-4.7-2.2-10.2 1.3-10.2 6.5c0 13.6 .7 33.3 .7 51.1c-9.7-9.9-26-16.1-38.4-21.8c-14.1-6.5-28.7-12-43.5-16.6c-29.8-9.2-60.7-14.9-91.7-18c-35.2-3.5-71-1.8-105.7 5.3C147 115.1 90.8 142.6 48.2 182.7C22.1 207.3 1.6 242.4 .2 277.9c-2 50.3 12.1 77.3 38 105.2c41.3 44.4 130.2 50.6 166.2-2c16.2-23.7 19.7-55.8 8-82c-11.8-26.2-38.8-45.1-67.4-46c-22.2-.7-45.9 10.6-54.5 31.1c-6.5 15.7-2.8 35.1 9 47.3c4.6 4.8 10.9 8.7 17.7 7.1c4-.9 7.4-3.9 8-8c.9-6-4.4-9.9-7.6-14.5c-5.8-8.3-4.7-20.9 2.7-27.9c6.2-6 15.3-7.8 23.9-7.7c8 0 16.2 1.4 23.1 5.5c9.7 5.7 16.2 16.2 18.4 27.2c6.7 33-20.2 59.9-56.6 62c-18.6 1.1-37.6-3.8-52.1-15.5C40.1 329.9 31.1 269.4 73.2 237c40-30.7 90.4-22.8 120.2-6.8c23.8 12.8 41.5 33.6 55 56.7c6.7 11.6 12.5 23.7 17.8 36.1c5.1 11.8 9.9 23.8 20.2 32.5c6.8 5.8 15.2 5.6 24.1 5.6h50.8c6.9 0 5.2-4.6 2.2-7.7c-6.7-6.9-16.4-8.4-25.4-10.9c-20.5-5.6-18.4-32.8-12.7-32.8c18.3 0 18.9 .6 34.9 .3c23.2-.3 30.2-1.7 48.3 5c9.7 3.6 19 13.1 25.1 21.7z"
    ]
};
var $42ee1027226cd96e$export$595f8e07121dc03e = {
    prefix: 'fab',
    iconName: 'jenkins',
    icon: [
        512,
        512,
        [],
        "f3b6",
        "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
    ]
};
var $42ee1027226cd96e$export$ca61170983a00686 = {
    prefix: 'fab',
    iconName: 'twitter',
    icon: [
        512,
        512,
        [],
        "f099",
        "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
    ]
};
var $42ee1027226cd96e$export$b86b24e51d58f6b5 = {
    prefix: 'fab',
    iconName: 'rockrms',
    icon: [
        496,
        512,
        [],
        "f3e9",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
    ]
};
var $42ee1027226cd96e$export$d42c613d35559431 = {
    prefix: 'fab',
    iconName: 'pinterest',
    icon: [
        496,
        512,
        [],
        "f0d2",
        "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
    ]
};
var $42ee1027226cd96e$export$de04abdf8e0bcc15 = {
    prefix: 'fab',
    iconName: 'buffer',
    icon: [
        448,
        512,
        [],
        "f837",
        "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
    ]
};
var $42ee1027226cd96e$export$2002216d2d7747f0 = {
    prefix: 'fab',
    iconName: 'npm',
    icon: [
        576,
        512,
        [],
        "f3d4",
        "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
    ]
};
var $42ee1027226cd96e$export$a5122f6c6ec2779c = {
    prefix: 'fab',
    iconName: 'yammer',
    icon: [
        512,
        512,
        [],
        "f840",
        "M500.676,159.486a12.779,12.779,0,0,0-6.4-8.282,13.954,13.954,0,0,0-10.078-1.125L457.8,156.7l-.043-.2-22.3,5.785-1.243.333-.608-2.17A369.037,369.037,0,0,0,347.538,4.289a14.1,14.1,0,0,0-19.784-.463l-102.9,102.747H24.947A24.9,24.9,0,0,0,0,131.417V380.38a24.963,24.963,0,0,0,24.918,24.9H224.986L328.072,508a13.667,13.667,0,0,0,19.327,0c.126-.126.249-.255.37-.385a368.025,368.025,0,0,0,69.577-107.374,403.45,403.45,0,0,0,17.3-50.8v-.028l20.406,5.336.029-.073L483.345,362a20.253,20.253,0,0,0,2.619.5,13.359,13.359,0,0,0,4.139-.072,13.5,13.5,0,0,0,10.515-9.924,415.855,415.855,0,0,0,.058-193.013ZM337.125,24.65l.013.014h-.013Zm-110.2,165.161L174.311,281.1a11.338,11.338,0,0,0-1.489,5.655v46.189a22.04,22.04,0,0,1-22.041,22h-3.4A22.068,22.068,0,0,1,125.3,332.962V287.294a11.532,11.532,0,0,0-1.388-5.51l-51.6-92.2a21.988,21.988,0,0,1,19.264-32.726h3.268a22.059,22.059,0,0,1,19.611,11.916l36.357,70.281,37.515-70.512a22.066,22.066,0,0,1,38.556-.695,21.7,21.7,0,0,1,0,21.967ZM337.145,24.673a348.147,348.147,0,0,1,75.8,141.335l.564,1.952-114.134,29.6V131.417a25.006,25.006,0,0,0-24.947-24.9H255.067Zm60.5,367.305v-.043l-.014.014a347.19,347.19,0,0,1-60.177,95.227l-82.2-81.893h19.177a24.978,24.978,0,0,0,24.947-24.9v-66.2l114.6,29.862A385.191,385.191,0,0,1,397.648,391.978Zm84-52.45.015.014-50.618-13.131L299.379,292.1V219.572l119.746-30.99,4.468-1.157,39.54-10.253,18.511-4.816A393,393,0,0,1,481.644,339.528Z"
    ]
};
var $42ee1027226cd96e$export$fcf54005da871608 = {
    prefix: 'fab',
    iconName: 'btc',
    icon: [
        384,
        512,
        [],
        "f15a",
        "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
    ]
};
var $42ee1027226cd96e$export$657a51e82ea8ac80 = {
    prefix: 'fab',
    iconName: 'dribbble',
    icon: [
        512,
        512,
        [],
        "f17d",
        "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
    ]
};
var $42ee1027226cd96e$export$ef143c65b9462290 = {
    prefix: 'fab',
    iconName: 'stumbleupon-circle',
    icon: [
        496,
        512,
        [],
        "f1a3",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
    ]
};
var $42ee1027226cd96e$export$26bd7ea5833d2643 = {
    prefix: 'fab',
    iconName: 'internet-explorer',
    icon: [
        512,
        512,
        [],
        "f26b",
        "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
    ]
};
var $42ee1027226cd96e$export$28d0d3c268c6e8c2 = {
    prefix: 'fab',
    iconName: 'stubber',
    icon: [
        448,
        512,
        [],
        "e5c7",
        "M136.5 294.2l58.8 22.9c9.1-36.8 25.4-61.1 55-61.1c49.4 0 71.4 63.6 142.4 63.6c15.6 0 35.9-2.8 55.3-13.3V368c0 61.8-50.4 112-112.3 112H0l41.8-56L0 368l41.7-56L0 256.1l41.8-56L0 144.1 41.8 88 0 32H335.7C397.6 32 448 82.3 448 144.1v51.3c-9.2 36.3-25.9 60.6-55 60.6c-49.6 0-71.6-63.5-142.4-63.5c-35.9 0-95.2 14.6-114.1 101.6h0z"
    ]
};
var $42ee1027226cd96e$export$b508fd54409de914 = {
    prefix: 'fab',
    iconName: 'telegram',
    icon: [
        496,
        512,
        [
            62462,
            "telegram-plane"
        ],
        "f2c6",
        "M248,8C111.033,8,0,119.033,0,256S111.033,504,248,504,496,392.967,496,256,384.967,8,248,8ZM362.952,176.66c-3.732,39.215-19.881,134.378-28.1,178.3-3.476,18.584-10.322,24.816-16.948,25.425-14.4,1.326-25.338-9.517-39.287-18.661-21.827-14.308-34.158-23.215-55.346-37.177-24.485-16.135-8.612-25,5.342-39.5,3.652-3.793,67.107-61.51,68.335-66.746.153-.655.3-3.1-1.154-4.384s-3.59-.849-5.135-.5q-3.283.746-104.608,69.142-14.845,10.194-26.894,9.934c-8.855-.191-25.888-5.006-38.551-9.123-15.531-5.048-27.875-7.717-26.8-16.291q.84-6.7,18.45-13.7,108.446-47.248,144.628-62.3c68.872-28.647,83.183-33.623,92.511-33.789,2.052-.034,6.639.474,9.61,2.885a10.452,10.452,0,0,1,3.53,6.716A43.765,43.765,0,0,1,362.952,176.66Z"
    ]
};
var $42ee1027226cd96e$export$dd32dc1ad06228ec = $42ee1027226cd96e$export$b508fd54409de914;
var $42ee1027226cd96e$export$39ef7a19d18012df = {
    prefix: 'fab',
    iconName: 'old-republic',
    icon: [
        496,
        512,
        [],
        "f510",
        "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
    ]
};
var $42ee1027226cd96e$export$4001fe5db20c0fd2 = {
    prefix: 'fab',
    iconName: 'odysee',
    icon: [
        512,
        512,
        [],
        "e5c6",
        "M406.7 463c-42.3 30.8-94.4 49-150.7 49C144.9 512 50.3 441.2 14.9 342.2c2.4 1.7 5.9 3.6 7.9 4.4c16.3 7.4 40.1-5.4 62.9-28.7c6.9-6.9 14.4-12.4 22.8-17.3c18.3-11.9 37.6-20.8 58.4-27.2c0 0 22.3 34.2 43.1 74.8s-22.3 54-27.2 54c-.3 0-.8 0-1.5-.1c-11-.5-70-3-56 51.1c14.9 57.4 97.5 36.6 139.6 8.9s31.7-118.3 31.7-118.3c41.1-6.4 54 37.1 57.9 59.4c.8 4.6 1.1 9.9 1.4 15.5c1.1 21.2 2.3 45.6 35.3 46.4c5.3 0 10.6-.8 15.5-2zm-95.3-23.7c-2-.5-3.5-2.5-3-5c1-2.5 3-3.5 5-3s3.5 3 3 5s-2.5 3.5-5 3zm-207-95.6c1.5-.5 3.5 1 4 3c0 2-1 4-3 4c-1.5 .5-3.5-1-4-3c-.5-1.5 1-3.5 3-4zM451.8 421C489.3 376.4 512 318.8 512 256c0-67.5-26.1-128.9-68.8-174.7c-.1 23.5-6.1 48.2-16.8 69.2c-11.9 20.3-49 58.9-69.8 78.7c-.7 .3-1.1 .9-1.5 1.4c-.2 .2-.3 .4-.5 .6c-5 6.9-4 16.8 3 21.8c21.3 15.8 56.4 45.6 59.4 72.8c3.5 34.9 27.9 75.6 34.2 86.2l0 0c.8 1.3 1.3 2.1 1.4 2.4c0 2.2-.4 4.3-.8 6.5zM390.7 251c-.5 3 1 5.9 4 6.4s5.9-1 6.4-4s-1-5.9-4-6.4c-3-1-5.9 1-6.4 4zm61.4-60.9l-11.4 5.4-3 12.9-5.4-11.4-12.9-3 11.4-5.4 3-12.9 5.4 11.4 12.9 3zM395.5 41.3c-16.2 8.2-22.1 32.8-29 61.4l0 0c-.3 1.4-.7 2.8-1 4.2c-9.5 38.5-30.6 37.6-41.7 37.2c-1.1 0-2-.1-2.9-.1c-5.1 0-6-4-8.9-17.1c-2.6-12.1-6.9-32-17.9-63.6C271.4-2.5 211.4 13.9 165.9 41.1C110.6 74.2 131.5 143 146.1 190.5c.7 2.2 1.4 4.4 2 6.6c-4 4-13.8 7.5-26 11.9c-12.1 4.3-26.6 9.5-40.3 16.9C47.9 243.9 11.5 274.9 2 288.5C.7 277.8 0 267 0 256C0 114.6 114.6 0 256 0c51.4 0 99.4 15.2 139.5 41.3zM58.9 189.6c-1.5-2-4.5-3-6.4-1.5s-3 4.5-1.5 6.4s4.5 3 6.4 1.5c2.5-1.5 3-4.5 1.5-6.4zM327.3 64.9c2-1.5 5-.5 6.4 1.5c1.5 2.5 1 5.4-1.5 6.4c-2 1.5-5 .5-6.4-1.5s-.5-5 1.5-6.4zM95.1 105c-.5 1.5 .5 3 2 3c1.5 .5 3-.5 3-2c.5-1.5-.5-3-2-3s-3 .5-3 2zm84.7-.5c-3.5-43.1 37.1-54 37.1-54c44.1-15.4 56 5.9 66.4 37.6s3 42.6-38.6 58.9s-61.9-4.5-64.9-42.6zm89.6 14.9h1c2.5 0 5-2 5-5c2-6.9 1-14.4-2-20.8c-1.5-2-4-3.5-6.4-2.5c-3 1-4.5 4-3.5 6.9c2 4.5 3 9.9 1.5 14.9c-.5 3 1.5 5.9 4.5 6.4zm-9.9-41.6c-2 0-4-1-5-3s-2-3.5-3-5c-2-2-2-5.4 0-7.4s5.4-2 7.4 0c2 2.5 3.5 5 5 7.4s.5 5.9-2.5 7.4c-.6 0-1 .2-1.3 .3c-.2 .1-.4 .2-.6 .2z"
    ]
};
var $42ee1027226cd96e$export$ee0c07b824da892f = {
    prefix: 'fab',
    iconName: 'square-whatsapp',
    icon: [
        448,
        512,
        [
            "whatsapp-square"
        ],
        "f40c",
        "M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"
    ]
};
var $42ee1027226cd96e$export$6fd1d044d66a938d = $42ee1027226cd96e$export$ee0c07b824da892f;
var $42ee1027226cd96e$export$ad65a356f9456393 = {
    prefix: 'fab',
    iconName: 'node-js',
    icon: [
        448,
        512,
        [],
        "f3d3",
        "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
    ]
};
var $42ee1027226cd96e$export$68bace18bdcdfc53 = {
    prefix: 'fab',
    iconName: 'edge-legacy',
    icon: [
        512,
        512,
        [],
        "e078",
        "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
    ]
};
var $42ee1027226cd96e$export$c597531345e00f14 = {
    prefix: 'fab',
    iconName: 'slack',
    icon: [
        448,
        512,
        [
            62447,
            "slack-hash"
        ],
        "f198",
        "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
    ]
};
var $42ee1027226cd96e$export$46ef626e3b64d22 = $42ee1027226cd96e$export$c597531345e00f14;
var $42ee1027226cd96e$export$2d7cd04bce6afc11 = {
    prefix: 'fab',
    iconName: 'medrt',
    icon: [
        544,
        512,
        [],
        "f3c8",
        "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
    ]
};
var $42ee1027226cd96e$export$701b05aa394c8392 = {
    prefix: 'fab',
    iconName: 'usb',
    icon: [
        640,
        512,
        [],
        "f287",
        "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
    ]
};
var $42ee1027226cd96e$export$ae279e8a7a5b9476 = {
    prefix: 'fab',
    iconName: 'tumblr',
    icon: [
        320,
        512,
        [],
        "f173",
        "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
    ]
};
var $42ee1027226cd96e$export$f796d2c05c7c6dbd = {
    prefix: 'fab',
    iconName: 'vaadin',
    icon: [
        448,
        512,
        [],
        "f408",
        "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
    ]
};
var $42ee1027226cd96e$export$e9b10b4b8b90dca5 = {
    prefix: 'fab',
    iconName: 'quora',
    icon: [
        448,
        512,
        [],
        "f2c4",
        "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
    ]
};
var $42ee1027226cd96e$export$e42e88e46d22eb98 = {
    prefix: 'fab',
    iconName: 'square-x-twitter',
    icon: [
        448,
        512,
        [],
        "e61a",
        "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm297.1 84L257.3 234.6 379.4 396H283.8L209 298.1 123.3 396H75.8l111-126.9L69.7 116h98l67.7 89.5L313.6 116h47.5zM323.3 367.6L153.4 142.9H125.1L296.9 367.6h26.3z"
    ]
};
var $42ee1027226cd96e$export$1bc30ca2ce539d7f = {
    prefix: 'fab',
    iconName: 'reacteurope',
    icon: [
        576,
        512,
        [],
        "f75d",
        "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
    ]
};
var $42ee1027226cd96e$export$c1f031b95dadaa21 = {
    prefix: 'fab',
    iconName: 'medium',
    icon: [
        640,
        512,
        [
            62407,
            "medium-m"
        ],
        "f23a",
        "M180.5,74.262C80.813,74.262,0,155.633,0,256S80.819,437.738,180.5,437.738,361,356.373,361,256,280.191,74.262,180.5,74.262Zm288.25,10.646c-49.845,0-90.245,76.619-90.245,171.095s40.406,171.1,90.251,171.1,90.251-76.619,90.251-171.1H559C559,161.5,518.6,84.908,468.752,84.908Zm139.506,17.821c-17.526,0-31.735,68.628-31.735,153.274s14.2,153.274,31.735,153.274S640,340.631,640,256C640,171.351,625.785,102.729,608.258,102.729Z"
    ]
};
var $42ee1027226cd96e$export$a29b11db7eed2052 = $42ee1027226cd96e$export$c1f031b95dadaa21;
var $42ee1027226cd96e$export$2ffb27c42275836a = {
    prefix: 'fab',
    iconName: 'amilia',
    icon: [
        448,
        512,
        [],
        "f36d",
        "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
    ]
};
var $42ee1027226cd96e$export$642f133169ca9ebe = {
    prefix: 'fab',
    iconName: 'mixcloud',
    icon: [
        640,
        512,
        [],
        "f289",
        "M212.98 346.566H179.789V195.114L185.973 173.47H175.262L137.127 346.566H76.1069L37.7323 173.47H27.276L33.1913 195.114V346.566H0V165H65.6506L102.248 338.096H110.747L147.329 165H212.98L212.98 346.566ZM544.459 283.589L458.434 345.655V307.534L531.329 255.776L458.434 204.017V165.896L544.459 228.231H553.721L640 165.896V204.017L566.866 255.776L640 307.549V345.655L553.721 283.589H544.459ZM430.157 272.311H248.113V239.255H430.157V272.311Z"
    ]
};
var $42ee1027226cd96e$export$5193bd9feb923609 = {
    prefix: 'fab',
    iconName: 'flipboard',
    icon: [
        448,
        512,
        [],
        "f44d",
        "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
    ]
};
var $42ee1027226cd96e$export$e75485903cf50ab7 = {
    prefix: 'fab',
    iconName: 'viacoin',
    icon: [
        384,
        512,
        [],
        "f237",
        "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
    ]
};
var $42ee1027226cd96e$export$19d8e57a729f8d94 = {
    prefix: 'fab',
    iconName: 'critical-role',
    icon: [
        448,
        512,
        [],
        "f6c9",
        "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
    ]
};
var $42ee1027226cd96e$export$b431c4dc6e2095fc = {
    prefix: 'fab',
    iconName: 'sitrox',
    icon: [
        448,
        512,
        [],
        "e44a",
        "M212.439 0.00846128V0H448V128H64C64 57.6008 141.755 0.475338 212.439 0.00846128ZM237.256 192V192.007C307.135 192.475 384 249.6 384 320H210.809V319.995C140.915 319.563 64 262.424 64 192H237.256ZM235.565 511.993C306.251 511.521 384 454.399 384 384H0V512H235.565V511.993Z"
    ]
};
var $42ee1027226cd96e$export$5311546a7fb29bad = {
    prefix: 'fab',
    iconName: 'discourse',
    icon: [
        448,
        512,
        [],
        "f393",
        "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
    ]
};
var $42ee1027226cd96e$export$4c7981055454786f = {
    prefix: 'fab',
    iconName: 'joomla',
    icon: [
        448,
        512,
        [],
        "f1aa",
        "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
    ]
};
var $42ee1027226cd96e$export$1dd6c03244d1cf01 = {
    prefix: 'fab',
    iconName: 'mastodon',
    icon: [
        448,
        512,
        [],
        "f4f6",
        "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
    ]
};
var $42ee1027226cd96e$export$a8bcb0976aa786fb = {
    prefix: 'fab',
    iconName: 'airbnb',
    icon: [
        448,
        512,
        [],
        "f834",
        "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
    ]
};
var $42ee1027226cd96e$export$568095dca08f5ff3 = {
    prefix: 'fab',
    iconName: 'wolf-pack-battalion',
    icon: [
        512,
        512,
        [],
        "f514",
        "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
    ]
};
var $42ee1027226cd96e$export$e08e0c43c651f28e = {
    prefix: 'fab',
    iconName: 'buy-n-large',
    icon: [
        576,
        512,
        [],
        "f8a6",
        "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
    ]
};
var $42ee1027226cd96e$export$100b84dda223030b = {
    prefix: 'fab',
    iconName: 'gulp',
    icon: [
        256,
        512,
        [],
        "f3ae",
        "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
    ]
};
var $42ee1027226cd96e$export$f7edf083e5c27672 = {
    prefix: 'fab',
    iconName: 'creative-commons-sampling-plus',
    icon: [
        496,
        512,
        [],
        "f4f1",
        "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
    ]
};
var $42ee1027226cd96e$export$7ea49f2cb08b52c1 = {
    prefix: 'fab',
    iconName: 'strava',
    icon: [
        384,
        512,
        [],
        "f428",
        "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
    ]
};
var $42ee1027226cd96e$export$c09ea58a6f21cb3c = {
    prefix: 'fab',
    iconName: 'ember',
    icon: [
        640,
        512,
        [],
        "f423",
        "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
    ]
};
var $42ee1027226cd96e$export$c9a287a4ab49306f = {
    prefix: 'fab',
    iconName: 'canadian-maple-leaf',
    icon: [
        512,
        512,
        [],
        "f785",
        "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
    ]
};
var $42ee1027226cd96e$export$619d787387e2c15e = {
    prefix: 'fab',
    iconName: 'teamspeak',
    icon: [
        576,
        512,
        [],
        "f4f9",
        "M152.8 37.2c-32.2 38.1-56.1 82.6-69.9 130.5c0 .2-.1 .3-.1 .5C43.5 184.4 16 223 16 268c0 59.6 48.4 108 108 108s108-48.4 108-108c0-53.5-38.9-97.9-90-106.5c15.7-41.8 40.4-79.6 72.3-110.7c1.8-1.6 4-2.6 6.3-3.1c37.2-11.5 76.7-13.3 114.8-5.2C454.7 67.6 534 180.7 517.1 301.3c-8.4 62.6-38.6 112.7-87.7 151.4c-50.1 39.7-107.5 54.3-170.2 52.2l-24-1c12.4 2.8 25 4.9 37.6 6.3c40.7 4.2 81.4 2.1 120.1-12.5c94-35.5 149.3-102.3 162.9-202.5c4.8-52.6-5.8-105.4-30.8-152C454.6 11.3 290.8-38.4 159 32c-2.4 1.4-4.5 3.1-6.3 5.2zM309.4 433.9c-2.1 11.5-4.2 21.9-14.6 31.3c53.2-1 123.2-29.2 161.8-97.1c39.7-69.9 37.6-139.9-6.3-207.8C413.8 105 360.5 77.9 293.7 73.7c1.5 2.3 3.2 4.4 5.2 6.3l5.2 6.3c25.1 31.3 37.6 67.9 42.8 107.5c2.1 15.7-1 30.3-13.6 41.8c-4.2 3.1-5.2 6.3-4.2 10.4l7.3 17.7L365.7 318c5.2 11.5 4.2 19.8-6.3 28.2c-3.2 2.5-6.7 4.6-10.4 6.3l-18.8 8.4 3.1 13.6c3.1 6.3 1 12.5-3.1 17.7c-2.5 2.4-3.8 5.9-3.1 9.4c2.1 11.5-2.1 19.8-12.5 25.1c-2.1 1-4.2 5.2-5.2 7.3zm-133.6-3.1c16.7 11.5 34.5 20.9 53.2 26.1c24 5.2 41.8-6.3 44.9-30.3c1-8.4 5.2-14.6 12.5-17.7c7.3-4.2 8.4-7.3 2.1-13.6l-9.4-8.4 13.6-4.2c6.3-2.1 7.3-5.2 5.2-11.5c-1.4-3-2.4-6.2-3.1-9.4c-3.1-14.6-2.1-15.7 11.5-18.8c8.4-3.1 15.7-6.3 21.9-12.5c3.1-2.1 3.1-4.2 1-8.4l-16.7-30.3c-1-1.9-2.1-3.8-3.1-5.7c-6.4-11.7-13-23.6-15.7-37.1c-2.1-9.4-1-17.7 8.4-24c5.2-4.2 8.4-9.4 8.4-16.7c-.4-10.1-1.5-20.3-3.1-30.3c-6.3-37.6-23-68.9-51.2-95c-5.2-4.2-9.4-6.3-16.7-4.2L203.9 91.5c2 1.2 4 2.4 6 3.6l0 0c6.3 3.7 12.2 7.3 17 12.1c30.3 26.1 41.8 61.6 45.9 100.2c1 8.4 0 16.7-7.3 21.9c-8.4 5.2-10.4 12.5-7.3 20.9c4.9 13.2 10.4 26 16.7 38.6L291.6 318c-6.3 8.4-13.6 11.5-21.9 14.6c-12.5 3.1-14.6 7.3-10.4 20.9c.6 1.5 1.4 2.8 2.1 4.2c2.1 5.2 1 8.4-4.2 10.4l-12.5 3.1 5.2 4.2 4.2 4.2c4.2 5.2 4.2 8.4-2.1 10.4c-7.3 4.2-11.5 9.4-11.5 17.7c0 12.5-7.3 19.8-18.8 24c-3.8 1-7.6 1.5-11.5 1l-34.5-2.1z"
    ]
};
var $42ee1027226cd96e$export$72c88c198f2680b = {
    prefix: 'fab',
    iconName: 'pushed',
    icon: [
        432,
        512,
        [],
        "f3e1",
        "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
    ]
};
var $42ee1027226cd96e$export$1e35be7b9c7acc1f = {
    prefix: 'fab',
    iconName: 'wordpress-simple',
    icon: [
        512,
        512,
        [],
        "f411",
        "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
    ]
};
var $42ee1027226cd96e$export$cb3944b58accd310 = {
    prefix: 'fab',
    iconName: 'nutritionix',
    icon: [
        400,
        512,
        [],
        "f3d6",
        "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
    ]
};
var $42ee1027226cd96e$export$d30ca94800bf542b = {
    prefix: 'fab',
    iconName: 'wodu',
    icon: [
        640,
        512,
        [],
        "e088",
        "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
    ]
};
var $42ee1027226cd96e$export$6d89c09f17c54b19 = {
    prefix: 'fab',
    iconName: 'google-pay',
    icon: [
        640,
        512,
        [],
        "e079",
        "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
    ]
};
var $42ee1027226cd96e$export$fd8d76c5b86b3d2b = {
    prefix: 'fab',
    iconName: 'intercom',
    icon: [
        448,
        512,
        [],
        "f7af",
        "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
    ]
};
var $42ee1027226cd96e$export$16e69e0d77404518 = {
    prefix: 'fab',
    iconName: 'zhihu',
    icon: [
        640,
        512,
        [],
        "f63f",
        "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
    ]
};
var $42ee1027226cd96e$export$80de216c9d46bac = {
    prefix: 'fab',
    iconName: 'korvue',
    icon: [
        446,
        512,
        [],
        "f42f",
        "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
    ]
};
var $42ee1027226cd96e$export$4fe14f0ab3be9a3 = {
    prefix: 'fab',
    iconName: 'pix',
    icon: [
        512,
        512,
        [],
        "e43a",
        "M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
    ]
};
var $42ee1027226cd96e$export$c2ce1e5693cbcd01 = {
    prefix: 'fab',
    iconName: 'steam-symbol',
    icon: [
        448,
        512,
        [],
        "f3f6",
        "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
    ]
};
var $42ee1027226cd96e$export$3fa11687d7bc6a48 = {
    faMonero: $42ee1027226cd96e$export$155bdf1ceac204e7,
    faHooli: $42ee1027226cd96e$export$3a040ca24382cf1c,
    faYelp: $42ee1027226cd96e$export$2de47f03337052b6,
    faCcVisa: $42ee1027226cd96e$export$acc882c0b0e9e801,
    faLastfm: $42ee1027226cd96e$export$8226e5267dd86de3,
    faShopware: $42ee1027226cd96e$export$c0b2d6cff425a846,
    faCreativeCommonsNc: $42ee1027226cd96e$export$e36098165f3fc869,
    faAws: $42ee1027226cd96e$export$a4ddb2c7f767be70,
    faRedhat: $42ee1027226cd96e$export$d65557a7abc2c5dc,
    faYoast: $42ee1027226cd96e$export$73b6ef60226f6801,
    faCloudflare: $42ee1027226cd96e$export$7a31e37b2189232c,
    faUps: $42ee1027226cd96e$export$c6f6a1beb6102ac,
    faPixiv: $42ee1027226cd96e$export$b64ce7c5d150db12,
    faWpexplorer: $42ee1027226cd96e$export$9ab35a48e8f904bf,
    faDyalog: $42ee1027226cd96e$export$1661cbacae81932b,
    faBity: $42ee1027226cd96e$export$76a6a7e968d921fe,
    faStackpath: $42ee1027226cd96e$export$a14b012b76f98910,
    faBuysellads: $42ee1027226cd96e$export$6c0bc096306cebf8,
    faFirstOrder: $42ee1027226cd96e$export$e0a21844bf49ca8e,
    faModx: $42ee1027226cd96e$export$fb06254b4488a5b6,
    faGuilded: $42ee1027226cd96e$export$b6ff6f33a85ee805,
    faVnv: $42ee1027226cd96e$export$13bd8782a2ce17e7,
    faSquareJs: $42ee1027226cd96e$export$c989752ecb8b3fae,
    faJsSquare: $42ee1027226cd96e$export$d9bf3211f885d573,
    faMicrosoft: $42ee1027226cd96e$export$b3b8195c77f1f877,
    faQq: $42ee1027226cd96e$export$39d59e523abf051d,
    faOrcid: $42ee1027226cd96e$export$9bf8457cc97dd02e,
    faJava: $42ee1027226cd96e$export$25a84a6ff654acd1,
    faInvision: $42ee1027226cd96e$export$6e249797a4721568,
    faCreativeCommonsPdAlt: $42ee1027226cd96e$export$d93ab92a56e88ce6,
    faCentercode: $42ee1027226cd96e$export$961762d5b3aedd8d,
    faGlideG: $42ee1027226cd96e$export$91d5526742c32d42,
    faDrupal: $42ee1027226cd96e$export$51e679e8d2e3f8c1,
    faHireAHelper: $42ee1027226cd96e$export$66507f26cc60b31e,
    faCreativeCommonsBy: $42ee1027226cd96e$export$5040b13190e5beb7,
    faUnity: $42ee1027226cd96e$export$72fd5838af249737,
    faWhmcs: $42ee1027226cd96e$export$4d4f65ec2f52482,
    faRocketchat: $42ee1027226cd96e$export$193ac2f517f63e63,
    faVk: $42ee1027226cd96e$export$a6bf4d62e541f988,
    faUntappd: $42ee1027226cd96e$export$f1679625ed434576,
    faMailchimp: $42ee1027226cd96e$export$da9f5a873e107292,
    faCss3Alt: $42ee1027226cd96e$export$928cd5ee6ccd55c0,
    faSquareReddit: $42ee1027226cd96e$export$307bcbd032fbb8d3,
    faRedditSquare: $42ee1027226cd96e$export$f8480c75bb6acc77,
    faVimeoV: $42ee1027226cd96e$export$2ea137a3f22bc61,
    faContao: $42ee1027226cd96e$export$d023cd407bbc3cab,
    faSquareFontAwesome: $42ee1027226cd96e$export$128da80f2cbe244a,
    faDeskpro: $42ee1027226cd96e$export$9005bf63ad3e3083,
    faBrave: $42ee1027226cd96e$export$ec6cecf928f83afa,
    faSistrix: $42ee1027226cd96e$export$36ca6be2e064d2cd,
    faSquareInstagram: $42ee1027226cd96e$export$526087fb4de86dae,
    faInstagramSquare: $42ee1027226cd96e$export$ccb1f25058292a04,
    faBattleNet: $42ee1027226cd96e$export$fb3fd8e112e1fa28,
    faTheRedYeti: $42ee1027226cd96e$export$daa019c708da49e9,
    faSquareHackerNews: $42ee1027226cd96e$export$ca115ee475bced67,
    faHackerNewsSquare: $42ee1027226cd96e$export$310b7424f1f97fc,
    faEdge: $42ee1027226cd96e$export$9c65bd68cbc68ec9,
    faThreads: $42ee1027226cd96e$export$2a1c6a809b4fdc7f,
    faNapster: $42ee1027226cd96e$export$29d678db44edc00,
    faSquareSnapchat: $42ee1027226cd96e$export$8176f1a0ece4380c,
    faSnapchatSquare: $42ee1027226cd96e$export$20f908cf15afb04b,
    faGooglePlusG: $42ee1027226cd96e$export$74ebd8f5ac37d070,
    faArtstation: $42ee1027226cd96e$export$4fb55b03537dc8e3,
    faMarkdown: $42ee1027226cd96e$export$4401a9960e402a1c,
    faSourcetree: $42ee1027226cd96e$export$fd6b8582f52b208a,
    faGooglePlus: $42ee1027226cd96e$export$384e1aaf24320a2d,
    faDiaspora: $42ee1027226cd96e$export$f59fd74fa97e6ae5,
    faFoursquare: $42ee1027226cd96e$export$b14039dbb12386bc,
    faStackOverflow: $42ee1027226cd96e$export$2c0cf6f85294daec,
    faGithubAlt: $42ee1027226cd96e$export$edfa6885dbf62839,
    faPhoenixSquadron: $42ee1027226cd96e$export$699e806dfe31d90b,
    faPagelines: $42ee1027226cd96e$export$e4b095fb96bd3e1,
    faAlgolia: $42ee1027226cd96e$export$8819d592a12ec37e,
    faRedRiver: $42ee1027226cd96e$export$1052bcfc0bf56d5d,
    faCreativeCommonsSa: $42ee1027226cd96e$export$976ebfab93ea9362,
    faSafari: $42ee1027226cd96e$export$3fbc2591308fa490,
    faGoogle: $42ee1027226cd96e$export$4675affbae76524d,
    faSquareFontAwesomeStroke: $42ee1027226cd96e$export$dda4448112663ba,
    faFontAwesomeAlt: $42ee1027226cd96e$export$85f790d14ecf253e,
    faAtlassian: $42ee1027226cd96e$export$f200be919c1eaf0d,
    faLinkedinIn: $42ee1027226cd96e$export$ed0a679f653cc1ec,
    faDigitalOcean: $42ee1027226cd96e$export$c5c4219467aa9953,
    faNimblr: $42ee1027226cd96e$export$3f240983de3f5d10,
    faChromecast: $42ee1027226cd96e$export$8d89e361d79b386e,
    faEvernote: $42ee1027226cd96e$export$acd6dee6975fc503,
    faHackerNews: $42ee1027226cd96e$export$5d439911ece032d6,
    faCreativeCommonsSampling: $42ee1027226cd96e$export$e443cc965f82dd02,
    faAdversal: $42ee1027226cd96e$export$1a30438e2bd95428,
    faCreativeCommons: $42ee1027226cd96e$export$cf9c9b2132d3672c,
    faWatchmanMonitoring: $42ee1027226cd96e$export$17b7e34aba803644,
    faFonticons: $42ee1027226cd96e$export$324e0175b7ef27f7,
    faWeixin: $42ee1027226cd96e$export$5c0c3408fef47d33,
    faShirtsinbulk: $42ee1027226cd96e$export$621d1ced1e254c1c,
    faCodepen: $42ee1027226cd96e$export$f02422936d21d2f4,
    faGitAlt: $42ee1027226cd96e$export$9ce7fda0737f89e7,
    faLyft: $42ee1027226cd96e$export$c2221e2ed2fea622,
    faRev: $42ee1027226cd96e$export$344ccb7aebcc7cfa,
    faWindows: $42ee1027226cd96e$export$b138356c7d4344fd,
    faWizardsOfTheCoast: $42ee1027226cd96e$export$2c1079aeb76cd815,
    faSquareViadeo: $42ee1027226cd96e$export$d20d4c95d5790834,
    faViadeoSquare: $42ee1027226cd96e$export$46c94e3313db0253,
    faMeetup: $42ee1027226cd96e$export$61e6f6fcefd81d6e,
    faCentos: $42ee1027226cd96e$export$47b9420154e916ca,
    faAdn: $42ee1027226cd96e$export$64d8cc39326ee7a8,
    faCloudsmith: $42ee1027226cd96e$export$616a6b084ab35801,
    faOpensuse: $42ee1027226cd96e$export$d668d8d9da44b43e,
    faPiedPiperAlt: $42ee1027226cd96e$export$ef7de58d3fe843ba,
    faSquareDribbble: $42ee1027226cd96e$export$fc95d67ac3aa8c53,
    faDribbbleSquare: $42ee1027226cd96e$export$ff55221913bb3cd0,
    faCodiepie: $42ee1027226cd96e$export$248fddd2c856e8cc,
    faNode: $42ee1027226cd96e$export$4c16416edc1f091a,
    faMix: $42ee1027226cd96e$export$4176cb98e090fc09,
    faSteam: $42ee1027226cd96e$export$7c80ad2689275b29,
    faCcApplePay: $42ee1027226cd96e$export$37af1170a8e0c21b,
    faScribd: $42ee1027226cd96e$export$d271dfaa2c63aec5,
    faDebian: $42ee1027226cd96e$export$b30079bac9ebcf2a,
    faOpenid: $42ee1027226cd96e$export$b2dcd141e150a391,
    faInstalod: $42ee1027226cd96e$export$792bea9ca32c60da,
    faExpeditedssl: $42ee1027226cd96e$export$fe553f3645c5aefa,
    faSellcast: $42ee1027226cd96e$export$23a4f18e8bd9f913,
    faSquareTwitter: $42ee1027226cd96e$export$58fc652e3c488143,
    faTwitterSquare: $42ee1027226cd96e$export$270370f3feaf6b90,
    faRProject: $42ee1027226cd96e$export$f9a04980ef22b6b0,
    faDelicious: $42ee1027226cd96e$export$fc15ee5b2eab0af4,
    faFreebsd: $42ee1027226cd96e$export$1fa830857b3a4dc7,
    faVuejs: $42ee1027226cd96e$export$3e0cc9b4555f8145,
    faAccusoft: $42ee1027226cd96e$export$233214294e90ff53,
    faIoxhost: $42ee1027226cd96e$export$d11e9e62a1442448,
    faFonticonsFi: $42ee1027226cd96e$export$e6a0ac478bf76bf2,
    faAppStore: $42ee1027226cd96e$export$500760921a1e1f4e,
    faCcMastercard: $42ee1027226cd96e$export$dd0d0d0b3b519db5,
    faItunesNote: $42ee1027226cd96e$export$a0c8448ba3e387bc,
    faGolang: $42ee1027226cd96e$export$36cd41563937ec03,
    faKickstarter: $42ee1027226cd96e$export$f06b8625c0ebb13a,
    faGrav: $42ee1027226cd96e$export$fdcdacf548a335ed,
    faWeibo: $42ee1027226cd96e$export$75bd846ccb390b1e,
    faUncharted: $42ee1027226cd96e$export$e1cced2e7ea20eff,
    faFirstdraft: $42ee1027226cd96e$export$44a54556e145bddf,
    faSquareYoutube: $42ee1027226cd96e$export$1082b39fc1076b43,
    faYoutubeSquare: $42ee1027226cd96e$export$8992da42b645c563,
    faWikipediaW: $42ee1027226cd96e$export$6657c749288c4042,
    faWpressr: $42ee1027226cd96e$export$66f88c21efa6f12d,
    faRendact: $42ee1027226cd96e$export$d06b08e37a8aaaec,
    faAngellist: $42ee1027226cd96e$export$65f66dc47afb97bd,
    faGalacticRepublic: $42ee1027226cd96e$export$ba5a2dfe23db8bb6,
    faNfcDirectional: $42ee1027226cd96e$export$d637dd7b404459cf,
    faSkype: $42ee1027226cd96e$export$78370b1b91348c9e,
    faJoget: $42ee1027226cd96e$export$ae307621d0877ba2,
    faFedora: $42ee1027226cd96e$export$8cf9f3ca16e668b0,
    faStripeS: $42ee1027226cd96e$export$4823078d958b443a,
    faMeta: $42ee1027226cd96e$export$75b94550e27ccec5,
    faLaravel: $42ee1027226cd96e$export$bfe42001388ccf42,
    faHotjar: $42ee1027226cd96e$export$d309e8b75a17a518,
    faBluetoothB: $42ee1027226cd96e$export$ad4174fe3fc4abe2,
    faSquareLetterboxd: $42ee1027226cd96e$export$628b421165d7d11a,
    faStickerMule: $42ee1027226cd96e$export$439612f87b462a40,
    faCreativeCommonsZero: $42ee1027226cd96e$export$72df0aea6a5da9de,
    faHips: $42ee1027226cd96e$export$51de6451f4c7b107,
    faBehance: $42ee1027226cd96e$export$907c17a7f1d6a0d3,
    faReddit: $42ee1027226cd96e$export$97dd0b04d798af1a,
    faDiscord: $42ee1027226cd96e$export$c8d4525a5e9ad3ad,
    faChrome: $42ee1027226cd96e$export$430df45ec2fae593,
    faAppStoreIos: $42ee1027226cd96e$export$e36cec8e481a3a4b,
    faCcDiscover: $42ee1027226cd96e$export$4a929e0a1abf7e41,
    faWpbeginner: $42ee1027226cd96e$export$a24323c111493948,
    faConfluence: $42ee1027226cd96e$export$259f76b402dd445f,
    faShoelace: $42ee1027226cd96e$export$b4e2b27ee3ee1821,
    faMdb: $42ee1027226cd96e$export$7add95166ef0248a,
    faDochub: $42ee1027226cd96e$export$81d728fa770edbe1,
    faAccessibleIcon: $42ee1027226cd96e$export$3c152d640f62968e,
    faEbay: $42ee1027226cd96e$export$ddb611ff59fc9802,
    faAmazon: $42ee1027226cd96e$export$ebc1e565fd80a447,
    faUnsplash: $42ee1027226cd96e$export$3997191a5880488f,
    faYarn: $42ee1027226cd96e$export$a67629e1d516967d,
    faSquareSteam: $42ee1027226cd96e$export$c334a5e9c1f73381,
    faSteamSquare: $42ee1027226cd96e$export$b0e9b012d636da0a,
    fa500px: $42ee1027226cd96e$export$4adb509bb23593b0,
    faSquareVimeo: $42ee1027226cd96e$export$8974793285f35ac8,
    faVimeoSquare: $42ee1027226cd96e$export$78628c2da1e685b5,
    faAsymmetrik: $42ee1027226cd96e$export$50ef858a08ddd1e5,
    faFontAwesome: $42ee1027226cd96e$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $42ee1027226cd96e$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $42ee1027226cd96e$export$6e20d421a2e0f320,
    faGratipay: $42ee1027226cd96e$export$cf1aa567b9609235,
    faApple: $42ee1027226cd96e$export$a649d390c50fd6df,
    faHive: $42ee1027226cd96e$export$f5cdac644000a430,
    faGitkraken: $42ee1027226cd96e$export$cd2223c7b77bd41c,
    faKeybase: $42ee1027226cd96e$export$c80d8749c6106849,
    faApplePay: $42ee1027226cd96e$export$fbfbf4eeb373a6ab,
    faPadlet: $42ee1027226cd96e$export$369427eba18eb826,
    faAmazonPay: $42ee1027226cd96e$export$448eb0f9d8323c85,
    faSquareGithub: $42ee1027226cd96e$export$be5db653ba5b5871,
    faGithubSquare: $42ee1027226cd96e$export$5fe0a956971aa3c2,
    faStumbleupon: $42ee1027226cd96e$export$7872bf6ac6945976,
    faFedex: $42ee1027226cd96e$export$c9127779112e2ff8,
    faPhoenixFramework: $42ee1027226cd96e$export$3d9357caf53f9b59,
    faShopify: $42ee1027226cd96e$export$c18d8940c93637ce,
    faNeos: $42ee1027226cd96e$export$a38c2efcceaf5a01,
    faSquareThreads: $42ee1027226cd96e$export$75f15eb229650b3a,
    faHackerrank: $42ee1027226cd96e$export$5fb7eeed7d5e4dea,
    faResearchgate: $42ee1027226cd96e$export$5c5693a4f82cd9eb,
    faSwift: $42ee1027226cd96e$export$dcdf312747bb3471,
    faAngular: $42ee1027226cd96e$export$9df3e2a7a3f59b3b,
    faSpeakap: $42ee1027226cd96e$export$90ae1a3824ece6f2,
    faAngrycreative: $42ee1027226cd96e$export$a9e7bf021125ee89,
    faYCombinator: $42ee1027226cd96e$export$9ee2f35ed1fe0fd4,
    faEmpire: $42ee1027226cd96e$export$c966a5d80266ef06,
    faEnvira: $42ee1027226cd96e$export$9e2c7c55d2fddd0,
    faGoogleScholar: $42ee1027226cd96e$export$ed92c068824a8084,
    faSquareGitlab: $42ee1027226cd96e$export$1c14974e1904bc76,
    faGitlabSquare: $42ee1027226cd96e$export$4459a47a802afa29,
    faStudiovinari: $42ee1027226cd96e$export$9d71d8f56add75cb,
    faPiedPiper: $42ee1027226cd96e$export$13581f4cc240d7d9,
    faWordpress: $42ee1027226cd96e$export$8898e76262ada01d,
    faProductHunt: $42ee1027226cd96e$export$91dcff48b72c75ce,
    faFirefox: $42ee1027226cd96e$export$53a067e7149deea9,
    faLinode: $42ee1027226cd96e$export$fcbc58842fe8e217,
    faGoodreads: $42ee1027226cd96e$export$cc058e4fd428aead,
    faSquareOdnoklassniki: $42ee1027226cd96e$export$df58e66e423b11a0,
    faOdnoklassnikiSquare: $42ee1027226cd96e$export$8bab3f1c73ff1d0,
    faJsfiddle: $42ee1027226cd96e$export$49c67105b922997,
    faSith: $42ee1027226cd96e$export$6b9a61f04a3c9eb4,
    faThemeisle: $42ee1027226cd96e$export$9ce81750a9f73ac4,
    faPage4: $42ee1027226cd96e$export$e504e93b36693690,
    faHashnode: $42ee1027226cd96e$export$459e822cce028974,
    faReact: $42ee1027226cd96e$export$e62f4d94322d112c,
    faCcPaypal: $42ee1027226cd96e$export$c4a0e7e817efc4de,
    faSquarespace: $42ee1027226cd96e$export$c1ba640907c93eb6,
    faCcStripe: $42ee1027226cd96e$export$235ca29d6ed8f50f,
    faCreativeCommonsShare: $42ee1027226cd96e$export$82bc9680d7d55560,
    faBitcoin: $42ee1027226cd96e$export$7bb8936d912f16ef,
    faKeycdn: $42ee1027226cd96e$export$644ebffaf375bd06,
    faOpera: $42ee1027226cd96e$export$76e4000ae88923a5,
    faItchIo: $42ee1027226cd96e$export$4ec4278290df08a8,
    faUmbraco: $42ee1027226cd96e$export$b92d594113fd14c4,
    faGalacticSenate: $42ee1027226cd96e$export$85ca259eee71d856,
    faUbuntu: $42ee1027226cd96e$export$188bec0355fe7cb3,
    faDraft2digital: $42ee1027226cd96e$export$89aeef49dacedf59,
    faStripe: $42ee1027226cd96e$export$4124a45a674b7b36,
    faHouzz: $42ee1027226cd96e$export$f5c2efa520323804,
    faGg: $42ee1027226cd96e$export$5b7cd580ca5d0c32,
    faDhl: $42ee1027226cd96e$export$f3f333bdcc61afcd,
    faSquarePinterest: $42ee1027226cd96e$export$bfa4536fab29fa25,
    faPinterestSquare: $42ee1027226cd96e$export$67aa35027cc046c7,
    faXing: $42ee1027226cd96e$export$28ff226a626fb008,
    faBlackberry: $42ee1027226cd96e$export$11c2ed8ca6d46555,
    faCreativeCommonsPd: $42ee1027226cd96e$export$10c9e6deac1c2eeb,
    faPlaystation: $42ee1027226cd96e$export$6fcce83c026197c,
    faQuinscape: $42ee1027226cd96e$export$1079c541f45f51d0,
    faLess: $42ee1027226cd96e$export$df0a28abd4a08bff,
    faBloggerB: $42ee1027226cd96e$export$fb78f7bb43feec45,
    faOpencart: $42ee1027226cd96e$export$b1b65e1549fc9915,
    faVine: $42ee1027226cd96e$export$ff24f295c905f144,
    faSignalMessenger: $42ee1027226cd96e$export$95b71ec8a2f59bf0,
    faPaypal: $42ee1027226cd96e$export$1aaa7b292157aaf7,
    faGitlab: $42ee1027226cd96e$export$bc1566dfb0a3651b,
    faTypo3: $42ee1027226cd96e$export$26fe3ad1dc9d4c5b,
    faRedditAlien: $42ee1027226cd96e$export$9fbf70587b6b0dcc,
    faYahoo: $42ee1027226cd96e$export$d0632e92ebe1197f,
    faDailymotion: $42ee1027226cd96e$export$9743e7788f64058a,
    faAffiliatetheme: $42ee1027226cd96e$export$c40f060084205fb6,
    faPiedPiperPp: $42ee1027226cd96e$export$96d17626187f6e34,
    faBootstrap: $42ee1027226cd96e$export$3de8f256f5aadacf,
    faOdnoklassniki: $42ee1027226cd96e$export$f31d1294fef45f,
    faNfcSymbol: $42ee1027226cd96e$export$a64aa05b0287bdaf,
    faMintbit: $42ee1027226cd96e$export$1aeaa8a5ac0e3463,
    faEthereum: $42ee1027226cd96e$export$b5ebb163fdb5edfd,
    faSpeakerDeck: $42ee1027226cd96e$export$7c461c4ee7c07c19,
    faCreativeCommonsNcEu: $42ee1027226cd96e$export$bcf1858bdc40caa3,
    faPatreon: $42ee1027226cd96e$export$a4dfebb823a477ff,
    faAvianex: $42ee1027226cd96e$export$862396e708985a99,
    faEllo: $42ee1027226cd96e$export$e644e4a8cae83fb3,
    faGofore: $42ee1027226cd96e$export$380164e9d6cdbec2,
    faBimobject: $42ee1027226cd96e$export$a219f36955efe01a,
    faBraveReverse: $42ee1027226cd96e$export$3d9997b304f32d18,
    faFacebookF: $42ee1027226cd96e$export$890714bb00316cc,
    faSquareGooglePlus: $42ee1027226cd96e$export$e94511deb1df63ce,
    faGooglePlusSquare: $42ee1027226cd96e$export$d546947149d9505a,
    faMandalorian: $42ee1027226cd96e$export$2a745e3ef2838c53,
    faFirstOrderAlt: $42ee1027226cd96e$export$ea0bc2cd8d60b806,
    faOsi: $42ee1027226cd96e$export$89cf1df24c6f1e2,
    faGoogleWallet: $42ee1027226cd96e$export$6fd7b581d1a20a14,
    faDAndDBeyond: $42ee1027226cd96e$export$8ffeba28c1feff0d,
    faPeriscope: $42ee1027226cd96e$export$10deb29d7dbf2418,
    faFulcrum: $42ee1027226cd96e$export$beb89eeaf726c65a,
    faCloudscale: $42ee1027226cd96e$export$fdf6053d73314ca6,
    faForumbee: $42ee1027226cd96e$export$e4fb88a0423b6fee,
    faMizuni: $42ee1027226cd96e$export$e6a3c752190fa3cb,
    faSchlix: $42ee1027226cd96e$export$3f1891b85805675f,
    faSquareXing: $42ee1027226cd96e$export$ca49464b0602c8ef,
    faXingSquare: $42ee1027226cd96e$export$3f616d72d818a1a6,
    faBandcamp: $42ee1027226cd96e$export$cf8fa465ef81d073,
    faWpforms: $42ee1027226cd96e$export$f70eba4216b4419a,
    faCloudversify: $42ee1027226cd96e$export$623057fac7dabd52,
    faUsps: $42ee1027226cd96e$export$216644b0c66e66a5,
    faMegaport: $42ee1027226cd96e$export$e7e4dbda4df6110f,
    faMagento: $42ee1027226cd96e$export$9b8374b50472190d,
    faSpotify: $42ee1027226cd96e$export$8218f3fbb2f89724,
    faOptinMonster: $42ee1027226cd96e$export$5247a00f0c0b93a3,
    faFly: $42ee1027226cd96e$export$cfbbba1261e4e2d2,
    faAviato: $42ee1027226cd96e$export$f731696770842fd2,
    faItunes: $42ee1027226cd96e$export$5f69a5b38e12c984,
    faCuttlefish: $42ee1027226cd96e$export$883d4844d275b117,
    faBlogger: $42ee1027226cd96e$export$eba2747efc67a397,
    faFlickr: $42ee1027226cd96e$export$4fc2e88e3ac2b091,
    faViber: $42ee1027226cd96e$export$c16cb0c14aa5beed,
    faSoundcloud: $42ee1027226cd96e$export$5803ef8c86f9786d,
    faDigg: $42ee1027226cd96e$export$1902312a1701467c,
    faTencentWeibo: $42ee1027226cd96e$export$9ea61fa1ff3225c6,
    faLetterboxd: $42ee1027226cd96e$export$3d0320148c8ebcd6,
    faSymfony: $42ee1027226cd96e$export$5420457350c35845,
    faMaxcdn: $42ee1027226cd96e$export$a33f03bc723e6603,
    faEtsy: $42ee1027226cd96e$export$c7956780474e39de,
    faFacebookMessenger: $42ee1027226cd96e$export$6c28dada3398f534,
    faAudible: $42ee1027226cd96e$export$83a2d14204e40d9a,
    faThinkPeaks: $42ee1027226cd96e$export$4c12ad86c5e9c2a9,
    faBilibili: $42ee1027226cd96e$export$34797550194301d4,
    faErlang: $42ee1027226cd96e$export$c6087bbc62da6f90,
    faXTwitter: $42ee1027226cd96e$export$fd0513a3aa908a67,
    faCottonBureau: $42ee1027226cd96e$export$8fc0685430a4202e,
    faDashcube: $42ee1027226cd96e$export$fc2c1db4698b6c91,
    fa42Group: $42ee1027226cd96e$export$a02285afcee8b3ba,
    faInnosoft: $42ee1027226cd96e$export$da8db9965333c744,
    faStackExchange: $42ee1027226cd96e$export$d511b4edf7fbac5a,
    faElementor: $42ee1027226cd96e$export$66726053c0c0ec32,
    faSquarePiedPiper: $42ee1027226cd96e$export$9d16a5780aab9cd3,
    faPiedPiperSquare: $42ee1027226cd96e$export$95ddae6b65597c6e,
    faCreativeCommonsNd: $42ee1027226cd96e$export$157e4276d9138bda,
    faPalfed: $42ee1027226cd96e$export$a226dd96512e144,
    faSuperpowers: $42ee1027226cd96e$export$349f4fc9997a1bf0,
    faResolving: $42ee1027226cd96e$export$e73a6c635a57ef10,
    faXbox: $42ee1027226cd96e$export$2c743c09f4269e9c,
    faSearchengin: $42ee1027226cd96e$export$e72de9688042e327,
    faTiktok: $42ee1027226cd96e$export$f310e79ae35a251f,
    faSquareFacebook: $42ee1027226cd96e$export$8545d76ecd01ec19,
    faFacebookSquare: $42ee1027226cd96e$export$cd6ab8ed6a9ec7a4,
    faRenren: $42ee1027226cd96e$export$36a9439e8de2df70,
    faLinux: $42ee1027226cd96e$export$5cb68a24a0b7bdf6,
    faGlide: $42ee1027226cd96e$export$c4c84939b8784e10,
    faLinkedin: $42ee1027226cd96e$export$b38fbe0cd1e4c67d,
    faHubspot: $42ee1027226cd96e$export$418b99079caf9b9b,
    faDeploydog: $42ee1027226cd96e$export$bd9dbf3c3b0bdc5e,
    faTwitch: $42ee1027226cd96e$export$154857d90d308f7c,
    faRavelry: $42ee1027226cd96e$export$cab2db22e59af947,
    faMixer: $42ee1027226cd96e$export$83d047b1c09d253,
    faSquareLastfm: $42ee1027226cd96e$export$37794c0b0ffc1e44,
    faLastfmSquare: $42ee1027226cd96e$export$c2f59587d6a3a574,
    faVimeo: $42ee1027226cd96e$export$b73c31bd90a3782e,
    faMendeley: $42ee1027226cd96e$export$a580d86d20b50be3,
    faUniregistry: $42ee1027226cd96e$export$6fb93399039178f9,
    faFigma: $42ee1027226cd96e$export$e71a35e82f13ad7f,
    faCreativeCommonsRemix: $42ee1027226cd96e$export$c02c848648d47b55,
    faCcAmazonPay: $42ee1027226cd96e$export$3f0dada7ec074193,
    faDropbox: $42ee1027226cd96e$export$e4589d83245ae1b2,
    faInstagram: $42ee1027226cd96e$export$8256451a9905291a,
    faCmplid: $42ee1027226cd96e$export$f4e59d0d43aeb784,
    faUpwork: $42ee1027226cd96e$export$f32e8672931b41ff,
    faFacebook: $42ee1027226cd96e$export$86108d0b79007794,
    faGripfire: $42ee1027226cd96e$export$957b7296da5b4490,
    faJediOrder: $42ee1027226cd96e$export$3a376d0f2ecfb7d0,
    faUikit: $42ee1027226cd96e$export$27afc16078b5f3ac,
    faFortAwesomeAlt: $42ee1027226cd96e$export$a5097e0b1bb080b7,
    faPhabricator: $42ee1027226cd96e$export$cc29519275365076,
    faUssunnah: $42ee1027226cd96e$export$d0ceedb643a91662,
    faEarlybirds: $42ee1027226cd96e$export$c30a6352a2a5e8ea,
    faTradeFederation: $42ee1027226cd96e$export$83b68077d321f3ad,
    faAutoprefixer: $42ee1027226cd96e$export$2ea4e300aa12cd0a,
    faWhatsapp: $42ee1027226cd96e$export$45bdf388845cdf99,
    faSlideshare: $42ee1027226cd96e$export$4dcd48fd9c0bdd2d,
    faGooglePlay: $42ee1027226cd96e$export$cfa707f90d6b79ec,
    faViadeo: $42ee1027226cd96e$export$6f9febfcc8ac97d4,
    faLine: $42ee1027226cd96e$export$c5b04bbf0f48913a,
    faGoogleDrive: $42ee1027226cd96e$export$631c05505a17faa8,
    faServicestack: $42ee1027226cd96e$export$c2417738aeefe7e6,
    faSimplybuilt: $42ee1027226cd96e$export$8b48c2e6e01a12e0,
    faBitbucket: $42ee1027226cd96e$export$de75f8fcf71dfed9,
    faImdb: $42ee1027226cd96e$export$c85bcd118a7a17ff,
    faDeezer: $42ee1027226cd96e$export$17ab471305a2654c,
    faRaspberryPi: $42ee1027226cd96e$export$910e018904f54b08,
    faJira: $42ee1027226cd96e$export$78c2aea9064d90bd,
    faDocker: $42ee1027226cd96e$export$b29e4ebead927988,
    faScreenpal: $42ee1027226cd96e$export$63c4c3c3c5975c3e,
    faBluetooth: $42ee1027226cd96e$export$f77d9ddfdff1e2a7,
    faGitter: $42ee1027226cd96e$export$56aff378d7858517,
    faDAndD: $42ee1027226cd96e$export$8fb5b89b3d7583de,
    faMicroblog: $42ee1027226cd96e$export$d5808a1a9747be4c,
    faCcDinersClub: $42ee1027226cd96e$export$e24e559a44f492e1,
    faGgCircle: $42ee1027226cd96e$export$6d2eed3a88c7ed1a,
    faPiedPiperHat: $42ee1027226cd96e$export$238a02799aabf743,
    faKickstarterK: $42ee1027226cd96e$export$36ebae5de28f5e9e,
    faYandex: $42ee1027226cd96e$export$d51f17330f9046ea,
    faReadme: $42ee1027226cd96e$export$7dcb0372cc290c0e,
    faHtml5: $42ee1027226cd96e$export$d1a4948b9a07ae7c,
    faSellsy: $42ee1027226cd96e$export$cb60511a0f837c82,
    faSass: $42ee1027226cd96e$export$5afc94dc87b38719,
    faWirsindhandwerk: $42ee1027226cd96e$export$304e26e1efc5b1a4,
    faWsh: $42ee1027226cd96e$export$c6d19319c89c1ce4,
    faBuromobelexperte: $42ee1027226cd96e$export$25d99c8ee7e610e5,
    faSalesforce: $42ee1027226cd96e$export$fb5e089c1f25c80c,
    faOctopusDeploy: $42ee1027226cd96e$export$4a726382b32e57cc,
    faMedapps: $42ee1027226cd96e$export$86efffc3e85d2a9,
    faNs8: $42ee1027226cd96e$export$ffa3f5d32fe6bc0e,
    faPinterestP: $42ee1027226cd96e$export$e1681fe8211dd475,
    faApper: $42ee1027226cd96e$export$aa79881dfcf87a16,
    faFortAwesome: $42ee1027226cd96e$export$c2ee281dce8eb9d5,
    faWaze: $42ee1027226cd96e$export$8d560f87da34bcc1,
    faCcJcb: $42ee1027226cd96e$export$4f0eff72b7493340,
    faSnapchat: $42ee1027226cd96e$export$3770724b51125ef1,
    faSnapchatGhost: $42ee1027226cd96e$export$e6e855f745e10958,
    faFantasyFlightGames: $42ee1027226cd96e$export$318074701514e1,
    faRust: $42ee1027226cd96e$export$8a8ef141dcbeda7b,
    faWix: $42ee1027226cd96e$export$423f2efa0d73b5f9,
    faSquareBehance: $42ee1027226cd96e$export$3a09eb8c07c8379f,
    faBehanceSquare: $42ee1027226cd96e$export$bb4b7fb598656746,
    faSupple: $42ee1027226cd96e$export$9be373796460fb80,
    faWebflow: $42ee1027226cd96e$export$b4c5293ffb331d6a,
    faRebel: $42ee1027226cd96e$export$50bb8725ea3b3e34,
    faCss3: $42ee1027226cd96e$export$f32e22910f9b44,
    faStaylinked: $42ee1027226cd96e$export$ffbc7f79ed77f082,
    faKaggle: $42ee1027226cd96e$export$a03842279a704aae,
    faSpaceAwesome: $42ee1027226cd96e$export$1aecd37105f38798,
    faDeviantart: $42ee1027226cd96e$export$36a61c57a904744e,
    faCpanel: $42ee1027226cd96e$export$4b1cbad29e4915c6,
    faGoodreadsG: $42ee1027226cd96e$export$659cd0fc2157d001,
    faSquareGit: $42ee1027226cd96e$export$ccce513bbd3bef1d,
    faGitSquare: $42ee1027226cd96e$export$545247d36a0c2435,
    faSquareTumblr: $42ee1027226cd96e$export$b22e93e631701aa0,
    faTumblrSquare: $42ee1027226cd96e$export$b3979340ece626fe,
    faTrello: $42ee1027226cd96e$export$33a1efa865dd0849,
    faCreativeCommonsNcJp: $42ee1027226cd96e$export$e119d42c61b568e2,
    faGetPocket: $42ee1027226cd96e$export$17e9384897437d5a,
    faPerbyte: $42ee1027226cd96e$export$53e7f606db333d60,
    faGrunt: $42ee1027226cd96e$export$b84863db58925c09,
    faWeebly: $42ee1027226cd96e$export$33e64266c9adb232,
    faConnectdevelop: $42ee1027226cd96e$export$38091cf7f8c68318,
    faLeanpub: $42ee1027226cd96e$export$c6c358b395e9032d,
    faBlackTie: $42ee1027226cd96e$export$161a3454c1d6abdb,
    faThemeco: $42ee1027226cd96e$export$ec9cce37001091c7,
    faPython: $42ee1027226cd96e$export$15d5df18b87754e3,
    faAndroid: $42ee1027226cd96e$export$d3988148e7ca3c41,
    faBots: $42ee1027226cd96e$export$d367d9d00bf47408,
    faFreeCodeCamp: $42ee1027226cd96e$export$8190ad5ab3a607e2,
    faHornbill: $42ee1027226cd96e$export$906602f6a1e50bdd,
    faJs: $42ee1027226cd96e$export$530d32089c3347d5,
    faIdeal: $42ee1027226cd96e$export$4ee0aea9bb537f01,
    faGit: $42ee1027226cd96e$export$61f81190d1a8b4b,
    faDev: $42ee1027226cd96e$export$dad56877d4f4a953,
    faSketch: $42ee1027226cd96e$export$e999ee7aa7883e37,
    faYandexInternational: $42ee1027226cd96e$export$6bf616a61d0b7bf3,
    faCcAmex: $42ee1027226cd96e$export$2bcb24672b4bf6e6,
    faUber: $42ee1027226cd96e$export$2b557426f8d6820b,
    faGithub: $42ee1027226cd96e$export$64e4bc4b496fbbdf,
    faPhp: $42ee1027226cd96e$export$e1ae2a8de48825fb,
    faAlipay: $42ee1027226cd96e$export$994c329bc073af57,
    faYoutube: $42ee1027226cd96e$export$2373b132177332f8,
    faSkyatlas: $42ee1027226cd96e$export$b2254aecfa43ac3e,
    faFirefoxBrowser: $42ee1027226cd96e$export$db16178b6453c842,
    faReplyd: $42ee1027226cd96e$export$a51c205a2c2f1780,
    faSuse: $42ee1027226cd96e$export$fd2c25240484ff41,
    faJenkins: $42ee1027226cd96e$export$595f8e07121dc03e,
    faTwitter: $42ee1027226cd96e$export$ca61170983a00686,
    faRockrms: $42ee1027226cd96e$export$b86b24e51d58f6b5,
    faPinterest: $42ee1027226cd96e$export$d42c613d35559431,
    faBuffer: $42ee1027226cd96e$export$de04abdf8e0bcc15,
    faNpm: $42ee1027226cd96e$export$2002216d2d7747f0,
    faYammer: $42ee1027226cd96e$export$a5122f6c6ec2779c,
    faBtc: $42ee1027226cd96e$export$fcf54005da871608,
    faDribbble: $42ee1027226cd96e$export$657a51e82ea8ac80,
    faStumbleuponCircle: $42ee1027226cd96e$export$ef143c65b9462290,
    faInternetExplorer: $42ee1027226cd96e$export$26bd7ea5833d2643,
    faStubber: $42ee1027226cd96e$export$28d0d3c268c6e8c2,
    faTelegram: $42ee1027226cd96e$export$b508fd54409de914,
    faTelegramPlane: $42ee1027226cd96e$export$dd32dc1ad06228ec,
    faOldRepublic: $42ee1027226cd96e$export$39ef7a19d18012df,
    faOdysee: $42ee1027226cd96e$export$4001fe5db20c0fd2,
    faSquareWhatsapp: $42ee1027226cd96e$export$ee0c07b824da892f,
    faWhatsappSquare: $42ee1027226cd96e$export$6fd1d044d66a938d,
    faNodeJs: $42ee1027226cd96e$export$ad65a356f9456393,
    faEdgeLegacy: $42ee1027226cd96e$export$68bace18bdcdfc53,
    faSlack: $42ee1027226cd96e$export$c597531345e00f14,
    faSlackHash: $42ee1027226cd96e$export$46ef626e3b64d22,
    faMedrt: $42ee1027226cd96e$export$2d7cd04bce6afc11,
    faUsb: $42ee1027226cd96e$export$701b05aa394c8392,
    faTumblr: $42ee1027226cd96e$export$ae279e8a7a5b9476,
    faVaadin: $42ee1027226cd96e$export$f796d2c05c7c6dbd,
    faQuora: $42ee1027226cd96e$export$e9b10b4b8b90dca5,
    faSquareXTwitter: $42ee1027226cd96e$export$e42e88e46d22eb98,
    faReacteurope: $42ee1027226cd96e$export$1bc30ca2ce539d7f,
    faMedium: $42ee1027226cd96e$export$c1f031b95dadaa21,
    faMediumM: $42ee1027226cd96e$export$a29b11db7eed2052,
    faAmilia: $42ee1027226cd96e$export$2ffb27c42275836a,
    faMixcloud: $42ee1027226cd96e$export$642f133169ca9ebe,
    faFlipboard: $42ee1027226cd96e$export$5193bd9feb923609,
    faViacoin: $42ee1027226cd96e$export$e75485903cf50ab7,
    faCriticalRole: $42ee1027226cd96e$export$19d8e57a729f8d94,
    faSitrox: $42ee1027226cd96e$export$b431c4dc6e2095fc,
    faDiscourse: $42ee1027226cd96e$export$5311546a7fb29bad,
    faJoomla: $42ee1027226cd96e$export$4c7981055454786f,
    faMastodon: $42ee1027226cd96e$export$1dd6c03244d1cf01,
    faAirbnb: $42ee1027226cd96e$export$a8bcb0976aa786fb,
    faWolfPackBattalion: $42ee1027226cd96e$export$568095dca08f5ff3,
    faBuyNLarge: $42ee1027226cd96e$export$e08e0c43c651f28e,
    faGulp: $42ee1027226cd96e$export$100b84dda223030b,
    faCreativeCommonsSamplingPlus: $42ee1027226cd96e$export$f7edf083e5c27672,
    faStrava: $42ee1027226cd96e$export$7ea49f2cb08b52c1,
    faEmber: $42ee1027226cd96e$export$c09ea58a6f21cb3c,
    faCanadianMapleLeaf: $42ee1027226cd96e$export$c9a287a4ab49306f,
    faTeamspeak: $42ee1027226cd96e$export$619d787387e2c15e,
    faPushed: $42ee1027226cd96e$export$72c88c198f2680b,
    faWordpressSimple: $42ee1027226cd96e$export$1e35be7b9c7acc1f,
    faNutritionix: $42ee1027226cd96e$export$cb3944b58accd310,
    faWodu: $42ee1027226cd96e$export$d30ca94800bf542b,
    faGooglePay: $42ee1027226cd96e$export$6d89c09f17c54b19,
    faIntercom: $42ee1027226cd96e$export$fd8d76c5b86b3d2b,
    faZhihu: $42ee1027226cd96e$export$16e69e0d77404518,
    faKorvue: $42ee1027226cd96e$export$80de216c9d46bac,
    faPix: $42ee1027226cd96e$export$4fe14f0ab3be9a3,
    faSteamSymbol: $42ee1027226cd96e$export$c2ce1e5693cbcd01
};


// For all FontAwesome imports
// 1. Use library to load icon with treeshaking
// 2. Use icon using the "string name" with <FontAwesomeIcon icon={[family, name]} />
(0, $82f622ad5caaffb5$export$b839f963c7dc0e34).add((0, $42ee1027226cd96e$export$a649d390c50fd6df), (0, $42ee1027226cd96e$export$d3988148e7ca3c41));
const $e0de785befddd5e2$export$8afed21ef5c2afa5 = (0, $974649a7879a5b6d$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$9ca09caa9c849d9c = (0, $2539fd7e092dd147$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$f1a507b991affc46 = (0, $077c554dc738a4e7$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$1c939d3c9b6931b = (0, $c5f9d04dfd1bd9b2$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$73a4c78a4a00962 = (0, $8484b39f982e716b$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$7d1b8b90f61377d1 = (0, $5a8507055084759e$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$5fda1783bb83f57b = (0, $825cadbc85a89039$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$2ad141e9e3d81b82 = (0, $cdd6dd2b11084245$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$10862138e9169702 = (0, $3f8e68bcf6ff6e0f$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$45097e3fcfc06744 = (0, $9cce2377d82ad02c$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$6382847193091a26 = (0, $4e76a2997dcc5e78$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$1ae95d1a7411cb7b = (0, $1a0bf4c1ef962d88$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$ee5a85dc020ac4a6 = (0, $6247d194571a5310$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$7dd004358974b05d = (0, $28ef1a36654d3a19$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$79e71d77d4eb0b38 = (0, $692d0667ec40027c$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$f713256e8ad1586 = (0, $41a7a7521a465f27$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$65604a0fb57b04f4 = (0, $151289adaee6f070$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$82eafebb825fc23f = (0, $17ae2fe7272e9982$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$f7dc499a72baa103 = (0, $fda9e85e7649b2f6$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$6940787f97640fd = ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8dcedd691ebf60a0$export$2b9260d4a45c8710), {
        icon: [
            'fab',
            'apple'
        ]
    });
const $e0de785befddd5e2$export$ab2f0aaabb79022e = ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8dcedd691ebf60a0$export$2b9260d4a45c8710), {
        icon: [
            'fab',
            'android'
        ]
    });
const $e0de785befddd5e2$export$2957fc44b3d2481 = (0, $6229b32327934950$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$e718407ce256549d = (0, $4d3c66d4b09ff42b$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$15dc7213e90d1fda = (0, $98c6a9e2e789f511$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$850d4fe20b3fbaee = (0, $e540febb9d2f6e13$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$ac4e8b8ca2b79f39 = (0, $6a9f4bf1f76c2bc1$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$45a25e33c6871670 = (0, $bc1d02098d076a94$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$bbc9410078004e71 = (0, $a7a011be8cb58dcb$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$a409e2da4a3967b = (0, $2c655d9e70ebd20e$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$ecf5f5308bcbb05e = (0, $578b3a666305a9d8$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$ffac63b363808810 = (0, $5787a2d40ce8921c$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$164e414f2cfd5f62 = (0, $ac09c55bd3bfbf82$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$6e75112b03731134 = $e0de785befddd5e2$export$79e71d77d4eb0b38;
const $e0de785befddd5e2$export$5f977870ae3cdbf1 = (0, $e3404f2a2f59579e$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$615cc43b5aa59fc6 = (0, $786dfe9e4308f029$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$87cd4f2a4da4427e = (0, $e3404f2a2f59579e$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$881d644e093d956f = (0, $cd99054e880ce1a7$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$e6bbbb3e7ab26126 = $e0de785befddd5e2$export$e718407ce256549d;
const $e0de785befddd5e2$export$cfa96dd21be274a9 = $e0de785befddd5e2$export$881d644e093d956f;
const $e0de785befddd5e2$export$7a838bc26f0582fd = $e0de785befddd5e2$export$5f977870ae3cdbf1;
const $e0de785befddd5e2$export$e019fa8422296e1c = $e0de785befddd5e2$export$615cc43b5aa59fc6;
const $e0de785befddd5e2$export$54eeba26dc8b99cf = (0, $fc76df2565052bd3$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$793424bfec4768af = $e0de785befddd5e2$export$f7dc499a72baa103;
const $e0de785befddd5e2$export$5b66a47e297ca640 = (0, $ac09c55bd3bfbf82$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$516fd7364fa08290 = $e0de785befddd5e2$export$79e71d77d4eb0b38;
const $e0de785befddd5e2$export$1c9647edca77a47b = $e0de785befddd5e2$export$7dd004358974b05d;
const $e0de785befddd5e2$export$be5191e773a73beb = (0, $644da22e3067df9b$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$e179803dfaf69dff = $e0de785befddd5e2$export$f7dc499a72baa103;
const $e0de785befddd5e2$export$e17e1b71210ffee9 = $e0de785befddd5e2$export$79e71d77d4eb0b38;
const $e0de785befddd5e2$export$569b372fb40e020b = $e0de785befddd5e2$export$7dd004358974b05d;
const $e0de785befddd5e2$export$b4449344c7a79712 = (0, $ac09c55bd3bfbf82$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$ddf80f27ca83567b = (0, $9ebd0210d45a1cac$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$9ff5547afd06adf7 = (0, $a326b8f6e31ceb86$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$27bab811bde8f944 = (0, $a4b021b8cd9c67c7$export$2e2bcd8739ae039);
const $e0de785befddd5e2$export$1b490aa7069a487b = (0, $7a33237a6165cbf3$export$2e2bcd8739ae039);


const $958169f76e3379dd$var$FormField = ({ help: help, label: label, children: children, error: error, required: required, htmlFor: htmlFor, info: info })=>{
    const [showInfo, setShowInfo] = (0, $3ZYaX.useState)(false);
    const classNames = [];
    if (required) classNames.push('is-required');
    if (error) classNames.push('is-error');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
        className: classNames.join(' '),
        children: [
            label && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Label, {
                htmlFor: htmlFor,
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "danger",
                        textWeight: "bold",
                        renderAs: "span",
                        "data-tooltip": "Ce champ est requis",
                        children: [
                            ' ',
                            "*"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                children: children
            }),
            error && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($958169f76e3379dd$export$1834f1a788ceaae3, {
                error: error
            }),
            help && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                children: help
            }),
            info && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mt: 2,
                children: [
                    showInfo && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "info",
                        mt: 2,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: info
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "a",
                        onClick: ()=>setShowInfo(!showInfo),
                        style: {
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem'
                        },
                        textColor: "link",
                        textSize: 7,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {
                                    width: 14,
                                    height: 14
                                })
                            }),
                            showInfo ? 'Masquer les informations' : 'Afficher les informations'
                        ]
                    })
                ]
            })
        ]
    });
};
var $958169f76e3379dd$export$2e2bcd8739ae039 = $958169f76e3379dd$var$FormField;
const $958169f76e3379dd$export$1834f1a788ceaae3 = ({ error: error })=>{
    if (error) {
        const errors = Array.isArray(error) ? error : [
            error
        ];
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            textColor: "danger",
            mt: 1,
            textWeight: "bold",
            children: errors.map((e, i)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "span",
                    children: [
                        e,
                        " ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                    ]
                }, e + i))
        });
    }
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};




function $5b787919ebf82645$export$2e2bcd8739ae039(input, hint) {
    if ((0, $143ffd39167373a2$export$2e2bcd8739ae039)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $143ffd39167373a2$export$2e2bcd8739ae039)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}


function $bb746f9ebb1e36ee$export$2e2bcd8739ae039(arg) {
    var key = (0, $5b787919ebf82645$export$2e2bcd8739ae039)(arg, "string");
    return (0, $143ffd39167373a2$export$2e2bcd8739ae039)(key) === "symbol" ? key : String(key);
}


function $400f8bc2acfb090b$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $bb746f9ebb1e36ee$export$2e2bcd8739ae039)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $8cf2596bd3c04d14$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cf2596bd3c04d14$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cf2596bd3c04d14$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cf2596bd3c04d14$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $00dbdd82ffce5458$export$2e2bcd8739ae039() {
    $00dbdd82ffce5458$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $00dbdd82ffce5458$export$2e2bcd8739ae039.apply(this, arguments);
}



var $3ZYaX = parcelRequire("3ZYaX");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $01f1c23bc93991d9$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $01f1c23bc93991d9$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $01f1c23bc93991d9$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($01f1c23bc93991d9$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $01f1c23bc93991d9$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $e9f65c5656358a7d$export$71ad59f2e432cfe8 = "-ms-";
var $e9f65c5656358a7d$export$2c0f367103c8d01c = "-moz-";
var $e9f65c5656358a7d$export$39dfd62a25e0fe93 = "-webkit-";
var $e9f65c5656358a7d$export$a29989082612d0d9 = "comm";
var $e9f65c5656358a7d$export$aa3a2e812ca8570d = "rule";
var $e9f65c5656358a7d$export$527d108ccf083c2b = "decl";
var $e9f65c5656358a7d$export$d3d35020fa5b54f0 = "@page";
var $e9f65c5656358a7d$export$500415a86c544f73 = "@media";
var $e9f65c5656358a7d$export$a763edbf796b780a = "@import";
var $e9f65c5656358a7d$export$2790aeb8b4e5c826 = "@charset";
var $e9f65c5656358a7d$export$1cc683e23b84b133 = "@viewport";
var $e9f65c5656358a7d$export$9447a5efea57e862 = "@supports";
var $e9f65c5656358a7d$export$ef011b4e114b1fba = "@document";
var $e9f65c5656358a7d$export$6aad947bda0f3f46 = "@namespace";
var $e9f65c5656358a7d$export$b44a8529a35fcb60 = "@keyframes";
var $e9f65c5656358a7d$export$2c16de31893252e6 = "@font-face";
var $e9f65c5656358a7d$export$3d846dd52e150c6f = "@counter-style";
var $e9f65c5656358a7d$export$22314bfbb57653fe = "@font-feature-values";
var $e9f65c5656358a7d$export$d773506282b3cfe6 = "@layer";
var $e9f65c5656358a7d$export$2335f513bbd82c6d = Math.abs;
var $e9f65c5656358a7d$export$6788812c4e6611e6 = String.fromCharCode;
var $e9f65c5656358a7d$export$e6e34fd1f2686227 = Object.assign;
function $e9f65c5656358a7d$export$d6af199866bfb566(e, r) {
    return $e9f65c5656358a7d$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $e9f65c5656358a7d$export$a9db5e087081082d(e, 0)) << 2 ^ $e9f65c5656358a7d$export$a9db5e087081082d(e, 1)) << 2 ^ $e9f65c5656358a7d$export$a9db5e087081082d(e, 2)) << 2 ^ $e9f65c5656358a7d$export$a9db5e087081082d(e, 3) : 0;
}
function $e9f65c5656358a7d$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $e9f65c5656358a7d$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $e9f65c5656358a7d$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $e9f65c5656358a7d$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $e9f65c5656358a7d$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $e9f65c5656358a7d$export$36776f635604f274(e) {
    return e.length;
}
function $e9f65c5656358a7d$export$f9084667e487ed46(e) {
    return e.length;
}
function $e9f65c5656358a7d$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $e9f65c5656358a7d$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $e9f65c5656358a7d$export$53f1d5ea8de3d7c = 1;
var $e9f65c5656358a7d$export$4e0c71f277ca26b3 = 1;
var $e9f65c5656358a7d$export$f24224f1c91d8156 = 0;
var $e9f65c5656358a7d$export$5880b8b5730aff45 = 0;
var $e9f65c5656358a7d$export$c0306caf338ac095 = 0;
var $e9f65c5656358a7d$export$30a86d91af8ff6e6 = "";
function $e9f65c5656358a7d$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $e9f65c5656358a7d$export$53f1d5ea8de3d7c,
        column: $e9f65c5656358a7d$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $e9f65c5656358a7d$export$784d13d8ee351f07(e, r) {
    return $e9f65c5656358a7d$export$e6e34fd1f2686227($e9f65c5656358a7d$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $e9f65c5656358a7d$export$eba6f6f03b0a92e7() {
    return $e9f65c5656358a7d$export$c0306caf338ac095;
}
function $e9f65c5656358a7d$export$232faf9add678146() {
    $e9f65c5656358a7d$export$c0306caf338ac095 = $e9f65c5656358a7d$export$5880b8b5730aff45 > 0 ? $e9f65c5656358a7d$export$a9db5e087081082d($e9f65c5656358a7d$export$30a86d91af8ff6e6, --$e9f65c5656358a7d$export$5880b8b5730aff45) : 0;
    if ($e9f65c5656358a7d$export$4e0c71f277ca26b3--, $e9f65c5656358a7d$export$c0306caf338ac095 === 10) $e9f65c5656358a7d$export$4e0c71f277ca26b3 = 1, $e9f65c5656358a7d$export$53f1d5ea8de3d7c--;
    return $e9f65c5656358a7d$export$c0306caf338ac095;
}
function $e9f65c5656358a7d$export$48cfd1e771a65c4f() {
    $e9f65c5656358a7d$export$c0306caf338ac095 = $e9f65c5656358a7d$export$5880b8b5730aff45 < $e9f65c5656358a7d$export$f24224f1c91d8156 ? $e9f65c5656358a7d$export$a9db5e087081082d($e9f65c5656358a7d$export$30a86d91af8ff6e6, $e9f65c5656358a7d$export$5880b8b5730aff45++) : 0;
    if ($e9f65c5656358a7d$export$4e0c71f277ca26b3++, $e9f65c5656358a7d$export$c0306caf338ac095 === 10) $e9f65c5656358a7d$export$4e0c71f277ca26b3 = 1, $e9f65c5656358a7d$export$53f1d5ea8de3d7c++;
    return $e9f65c5656358a7d$export$c0306caf338ac095;
}
function $e9f65c5656358a7d$export$4d3fb11e950abb9e() {
    return $e9f65c5656358a7d$export$a9db5e087081082d($e9f65c5656358a7d$export$30a86d91af8ff6e6, $e9f65c5656358a7d$export$5880b8b5730aff45);
}
function $e9f65c5656358a7d$export$e88cb2efb12ae807() {
    return $e9f65c5656358a7d$export$5880b8b5730aff45;
}
function $e9f65c5656358a7d$export$58adb3bec8346d0f(e, r) {
    return $e9f65c5656358a7d$export$2f35ab04d2335697($e9f65c5656358a7d$export$30a86d91af8ff6e6, e, r);
}
function $e9f65c5656358a7d$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e9f65c5656358a7d$export$2de70f21292aac9e(e) {
    return $e9f65c5656358a7d$export$53f1d5ea8de3d7c = $e9f65c5656358a7d$export$4e0c71f277ca26b3 = 1, $e9f65c5656358a7d$export$f24224f1c91d8156 = $e9f65c5656358a7d$export$36776f635604f274($e9f65c5656358a7d$export$30a86d91af8ff6e6 = e), $e9f65c5656358a7d$export$5880b8b5730aff45 = 0, [];
}
function $e9f65c5656358a7d$export$45918ac1574455b1(e) {
    return $e9f65c5656358a7d$export$30a86d91af8ff6e6 = "", e;
}
function $e9f65c5656358a7d$export$410ac95b9ec204b8(e) {
    return $e9f65c5656358a7d$export$87c2784dc9fc4ab($e9f65c5656358a7d$export$58adb3bec8346d0f($e9f65c5656358a7d$export$5880b8b5730aff45 - 1, $e9f65c5656358a7d$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $e9f65c5656358a7d$export$660b2ee2d4fb4eff(e) {
    return $e9f65c5656358a7d$export$45918ac1574455b1($e9f65c5656358a7d$export$5f8c09e3ae6f64e1($e9f65c5656358a7d$export$2de70f21292aac9e(e)));
}
function $e9f65c5656358a7d$export$7af1228ff777d175(e) {
    while($e9f65c5656358a7d$export$c0306caf338ac095 = $e9f65c5656358a7d$export$4d3fb11e950abb9e())if ($e9f65c5656358a7d$export$c0306caf338ac095 < 33) $e9f65c5656358a7d$export$48cfd1e771a65c4f();
    else break;
    return $e9f65c5656358a7d$export$9e1725a4cfeada27(e) > 2 || $e9f65c5656358a7d$export$9e1725a4cfeada27($e9f65c5656358a7d$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $e9f65c5656358a7d$export$5f8c09e3ae6f64e1(e) {
    while($e9f65c5656358a7d$export$48cfd1e771a65c4f())switch($e9f65c5656358a7d$export$9e1725a4cfeada27($e9f65c5656358a7d$export$c0306caf338ac095)){
        case 0:
            $e9f65c5656358a7d$export$10d8903dec122b9d($e9f65c5656358a7d$export$c2ab62c7bf24634($e9f65c5656358a7d$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $e9f65c5656358a7d$export$10d8903dec122b9d($e9f65c5656358a7d$export$410ac95b9ec204b8($e9f65c5656358a7d$export$c0306caf338ac095), e);
            break;
        default:
            $e9f65c5656358a7d$export$10d8903dec122b9d($e9f65c5656358a7d$export$6788812c4e6611e6($e9f65c5656358a7d$export$c0306caf338ac095), e);
    }
    return e;
}
function $e9f65c5656358a7d$export$955ba06d119e085e(e, r) {
    while(--r && $e9f65c5656358a7d$export$48cfd1e771a65c4f())if ($e9f65c5656358a7d$export$c0306caf338ac095 < 48 || $e9f65c5656358a7d$export$c0306caf338ac095 > 102 || $e9f65c5656358a7d$export$c0306caf338ac095 > 57 && $e9f65c5656358a7d$export$c0306caf338ac095 < 65 || $e9f65c5656358a7d$export$c0306caf338ac095 > 70 && $e9f65c5656358a7d$export$c0306caf338ac095 < 97) break;
    return $e9f65c5656358a7d$export$58adb3bec8346d0f(e, $e9f65c5656358a7d$export$e88cb2efb12ae807() + (r < 6 && $e9f65c5656358a7d$export$4d3fb11e950abb9e() == 32 && $e9f65c5656358a7d$export$48cfd1e771a65c4f() == 32));
}
function $e9f65c5656358a7d$export$c889f2fcc19dbf12(e) {
    while($e9f65c5656358a7d$export$48cfd1e771a65c4f())switch($e9f65c5656358a7d$export$c0306caf338ac095){
        case e:
            return $e9f65c5656358a7d$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $e9f65c5656358a7d$export$c889f2fcc19dbf12($e9f65c5656358a7d$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $e9f65c5656358a7d$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $e9f65c5656358a7d$export$48cfd1e771a65c4f();
            break;
    }
    return $e9f65c5656358a7d$export$5880b8b5730aff45;
}
function $e9f65c5656358a7d$export$4254d4e2b3745c4c(e, r) {
    while($e9f65c5656358a7d$export$48cfd1e771a65c4f())if (e + $e9f65c5656358a7d$export$c0306caf338ac095 === 57) break;
    else if (e + $e9f65c5656358a7d$export$c0306caf338ac095 === 84 && $e9f65c5656358a7d$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $e9f65c5656358a7d$export$58adb3bec8346d0f(r, $e9f65c5656358a7d$export$5880b8b5730aff45 - 1) + "*" + $e9f65c5656358a7d$export$6788812c4e6611e6(e === 47 ? e : $e9f65c5656358a7d$export$48cfd1e771a65c4f());
}
function $e9f65c5656358a7d$export$c2ab62c7bf24634(e) {
    while(!$e9f65c5656358a7d$export$9e1725a4cfeada27($e9f65c5656358a7d$export$4d3fb11e950abb9e()))$e9f65c5656358a7d$export$48cfd1e771a65c4f();
    return $e9f65c5656358a7d$export$58adb3bec8346d0f(e, $e9f65c5656358a7d$export$5880b8b5730aff45);
}
function $e9f65c5656358a7d$export$ef7acd7185315e22(e) {
    return $e9f65c5656358a7d$export$45918ac1574455b1($e9f65c5656358a7d$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $e9f65c5656358a7d$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $e9f65c5656358a7d$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $e9f65c5656358a7d$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $e9f65c5656358a7d$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($e9f65c5656358a7d$export$f8e21b1e77979a08(j += $e9f65c5656358a7d$export$77ad94ebf1c2b9ed($e9f65c5656358a7d$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $e9f65c5656358a7d$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $e9f65c5656358a7d$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $e9f65c5656358a7d$export$955ba06d119e085e($e9f65c5656358a7d$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($e9f65c5656358a7d$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $e9f65c5656358a7d$export$10d8903dec122b9d($e9f65c5656358a7d$export$4a34f930e789283c($e9f65c5656358a7d$export$4254d4e2b3745c4c($e9f65c5656358a7d$export$48cfd1e771a65c4f(), $e9f65c5656358a7d$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $e9f65c5656358a7d$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $e9f65c5656358a7d$export$36776f635604f274(j) - l) $e9f65c5656358a7d$export$10d8903dec122b9d(p > 32 ? $e9f65c5656358a7d$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $e9f65c5656358a7d$export$f8483753829ec8f3($e9f65c5656358a7d$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $e9f65c5656358a7d$export$10d8903dec122b9d(y = $e9f65c5656358a7d$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $e9f65c5656358a7d$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $e9f65c5656358a7d$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $e9f65c5656358a7d$export$98e6a39c04603d36(e, y, y, n && $e9f65c5656358a7d$export$10d8903dec122b9d($e9f65c5656358a7d$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $e9f65c5656358a7d$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $e9f65c5656358a7d$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $e9f65c5656358a7d$export$232faf9add678146() == 125) continue;
            }
            switch(j += $e9f65c5656358a7d$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($e9f65c5656358a7d$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($e9f65c5656358a7d$export$4d3fb11e950abb9e() === 45) j += $e9f65c5656358a7d$export$410ac95b9ec204b8($e9f65c5656358a7d$export$48cfd1e771a65c4f());
                    v = $e9f65c5656358a7d$export$4d3fb11e950abb9e(), o = l = $e9f65c5656358a7d$export$36776f635604f274(g = j += $e9f65c5656358a7d$export$c2ab62c7bf24634($e9f65c5656358a7d$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $e9f65c5656358a7d$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $e9f65c5656358a7d$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $e9f65c5656358a7d$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $e9f65c5656358a7d$export$2f35ab04d2335697(e, v + 1, v = $e9f65c5656358a7d$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $e9f65c5656358a7d$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $e9f65c5656358a7d$export$35059013cd4a06db(e, r, a, s === 0 ? $e9f65c5656358a7d$export$aa3a2e812ca8570d : i, f, o, l);
}
function $e9f65c5656358a7d$export$4a34f930e789283c(e, r, a) {
    return $e9f65c5656358a7d$export$35059013cd4a06db(e, r, a, $e9f65c5656358a7d$export$a29989082612d0d9, $e9f65c5656358a7d$export$6788812c4e6611e6($e9f65c5656358a7d$export$eba6f6f03b0a92e7()), $e9f65c5656358a7d$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $e9f65c5656358a7d$export$f8483753829ec8f3(e, r, a, n) {
    return $e9f65c5656358a7d$export$35059013cd4a06db(e, r, a, $e9f65c5656358a7d$export$527d108ccf083c2b, $e9f65c5656358a7d$export$2f35ab04d2335697(e, 0, n), $e9f65c5656358a7d$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $e9f65c5656358a7d$export$82e9f45cca5ba907(n, c, s) {
    switch($e9f65c5656358a7d$export$d6af199866bfb566(n, c)){
        case 5103:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $e9f65c5656358a7d$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$2c0f367103c8d01c + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($e9f65c5656358a7d$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "box-$1$2" + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "flex-item-" + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$e9f65c5656358a7d$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "grid-row-" + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "flex-line-pack" + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "box-" + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "-grow", "") + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $e9f65c5656358a7d$export$39dfd62a25e0fe93 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed($e9f65c5656358a7d$export$77ad94ebf1c2b9ed($e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed($e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "box-pack:$3" + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$e9f65c5656358a7d$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "grid-column-align" + $e9f65c5656358a7d$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $e9f65c5656358a7d$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$e9f65c5656358a7d$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$e9f65c5656358a7d$export$f8e21b1e77979a08(s, "span") ? $e9f65c5656358a7d$export$4659b591c19bdf3d(s, /\d+/) : +$e9f65c5656358a7d$export$4659b591c19bdf3d(s, /\d+/) - +$e9f65c5656358a7d$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $e9f65c5656358a7d$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $e9f65c5656358a7d$export$71ad59f2e432cfe8 + $e9f65c5656358a7d$export$77ad94ebf1c2b9ed($e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($e9f65c5656358a7d$export$36776f635604f274(n) - 1 - c > 6) switch($e9f65c5656358a7d$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($e9f65c5656358a7d$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $e9f65c5656358a7d$export$2c0f367103c8d01c + ($e9f65c5656358a7d$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$e9f65c5656358a7d$export$f8e21b1e77979a08(n, "stretch") ? $e9f65c5656358a7d$export$82e9f45cca5ba907($e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $e9f65c5656358a7d$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $e9f65c5656358a7d$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($e9f65c5656358a7d$export$a9db5e087081082d(n, c + 6) === 121) return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, ":", ":" + $e9f65c5656358a7d$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($e9f65c5656358a7d$export$a9db5e087081082d(n, $e9f65c5656358a7d$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + ($e9f65c5656358a7d$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, ":", ":" + $e9f65c5656358a7d$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $e9f65c5656358a7d$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $e9f65c5656358a7d$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $e9f65c5656358a7d$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $e9f65c5656358a7d$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $e9f65c5656358a7d$export$a763edbf796b780a:
        case $e9f65c5656358a7d$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $e9f65c5656358a7d$export$a29989082612d0d9:
            return "";
        case $e9f65c5656358a7d$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $e9f65c5656358a7d$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $e9f65c5656358a7d$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $e9f65c5656358a7d$export$36776f635604f274(a = $e9f65c5656358a7d$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $e9f65c5656358a7d$export$5a7767152ae0305f(e) {
    var r = $e9f65c5656358a7d$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $e9f65c5656358a7d$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $e9f65c5656358a7d$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $e9f65c5656358a7d$export$527d108ccf083c2b:
                n.return = $e9f65c5656358a7d$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $e9f65c5656358a7d$export$b44a8529a35fcb60:
                return $e9f65c5656358a7d$export$dfdc1655ccc5b9cb([
                    $e9f65c5656358a7d$export$784d13d8ee351f07(n, {
                        value: $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $e9f65c5656358a7d$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $e9f65c5656358a7d$export$aa3a2e812ca8570d:
                if (n.length) return $e9f65c5656358a7d$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($e9f65c5656358a7d$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $e9f65c5656358a7d$export$dfdc1655ccc5b9cb([
                                $e9f65c5656358a7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $e9f65c5656358a7d$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $e9f65c5656358a7d$export$dfdc1655ccc5b9cb([
                                $e9f65c5656358a7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e9f65c5656358a7d$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $e9f65c5656358a7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $e9f65c5656358a7d$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $e9f65c5656358a7d$export$784d13d8ee351f07(n, {
                                    props: [
                                        $e9f65c5656358a7d$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $e9f65c5656358a7d$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $e9f65c5656358a7d$export$76a88f7de6507443(e) {
    switch(e.type){
        case $e9f65c5656358a7d$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $e9f65c5656358a7d$export$1be1fc439b849fdf($e9f65c5656358a7d$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($e9f65c5656358a7d$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $e9f65c5656358a7d$export$2f35ab04d2335697(r, 1, $e9f65c5656358a7d$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $e9f65c5656358a7d$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $e9f65c5656358a7d$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $e9f65c5656358a7d$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $895929f4c661a494$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $65ae90d3498e0dc3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $6db6ea46e2b48da7$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $e9f65c5656358a7d$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $e9f65c5656358a7d$export$9e1725a4cfeada27)(character)) break;
        (0, $e9f65c5656358a7d$export$48cfd1e771a65c4f)();
    }
    return (0, $e9f65c5656358a7d$export$58adb3bec8346d0f)(begin, (0, $e9f65c5656358a7d$export$5880b8b5730aff45));
};
var $6db6ea46e2b48da7$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $e9f65c5656358a7d$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $e9f65c5656358a7d$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $6db6ea46e2b48da7$var$identifierWithPointTracking((0, $e9f65c5656358a7d$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $e9f65c5656358a7d$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $e9f65c5656358a7d$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $e9f65c5656358a7d$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $e9f65c5656358a7d$export$48cfd1e771a65c4f)());
    return parsed;
};
var $6db6ea46e2b48da7$var$getRules = function getRules(value, points) {
    return (0, $e9f65c5656358a7d$export$45918ac1574455b1)($6db6ea46e2b48da7$var$toRules((0, $e9f65c5656358a7d$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $6db6ea46e2b48da7$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $6db6ea46e2b48da7$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$6db6ea46e2b48da7$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $6db6ea46e2b48da7$var$fixedElements.set(element, true);
    var points = [];
    var rules = $6db6ea46e2b48da7$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $6db6ea46e2b48da7$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $6db6ea46e2b48da7$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $6db6ea46e2b48da7$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($6db6ea46e2b48da7$var$ignoreFlag) > -1;
};
var $6db6ea46e2b48da7$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($6db6ea46e2b48da7$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $6db6ea46e2b48da7$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $6db6ea46e2b48da7$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$6db6ea46e2b48da7$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $6db6ea46e2b48da7$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $6db6ea46e2b48da7$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$6db6ea46e2b48da7$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $6db6ea46e2b48da7$var$nullifyElement(element);
    } else if ($6db6ea46e2b48da7$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $6db6ea46e2b48da7$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $6db6ea46e2b48da7$var$prefix(value, length) {
    switch((0, $e9f65c5656358a7d$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$2c0f367103c8d01c) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + 'box-' + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)((0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)((0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)((0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $e9f65c5656358a7d$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e9f65c5656358a7d$export$2c0f367103c8d01c) + ((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $e9f65c5656358a7d$export$f8e21b1e77979a08)(value, 'stretch') ? $6db6ea46e2b48da7$var$prefix((0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, (0, $e9f65c5656358a7d$export$36776f635604f274)(value) - 3 - (~(0, $e9f65c5656358a7d$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + ((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $e9f65c5656358a7d$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + value + (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $6db6ea46e2b48da7$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e9f65c5656358a7d$export$527d108ccf083c2b:
                element["return"] = $6db6ea46e2b48da7$var$prefix(element.value, element.length);
                break;
            case 0, $e9f65c5656358a7d$export$b44a8529a35fcb60:
                return (0, $e9f65c5656358a7d$export$dfdc1655ccc5b9cb)([
                    (0, $e9f65c5656358a7d$export$784d13d8ee351f07)(element, {
                        value: (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e9f65c5656358a7d$export$aa3a2e812ca8570d:
                if (element.length) return (0, $e9f65c5656358a7d$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $e9f65c5656358a7d$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $e9f65c5656358a7d$export$dfdc1655ccc5b9cb)([
                                (0, $e9f65c5656358a7d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e9f65c5656358a7d$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $e9f65c5656358a7d$export$dfdc1655ccc5b9cb)([
                                (0, $e9f65c5656358a7d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e9f65c5656358a7d$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $e9f65c5656358a7d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e9f65c5656358a7d$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $e9f65c5656358a7d$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $e9f65c5656358a7d$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e9f65c5656358a7d$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $6db6ea46e2b48da7$var$defaultStylisPlugins = [
    $6db6ea46e2b48da7$var$prefixer
];
var $6db6ea46e2b48da7$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $6db6ea46e2b48da7$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $6db6ea46e2b48da7$var$compat,
        $6db6ea46e2b48da7$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $e9f65c5656358a7d$export$fac44ee5b035f737),
        (0, $e9f65c5656358a7d$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $e9f65c5656358a7d$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $e9f65c5656358a7d$export$dfdc1655ccc5b9cb)((0, $e9f65c5656358a7d$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $01f1c23bc93991d9$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};





var $6fGvd = parcelRequire("6fGvd");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $18b70d2dd62e9559$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($6fGvd)))(targetComponent, sourceComponent);
};


var $1b59b3eb711ecd3b$var$isBrowser = true;
function $1b59b3eb711ecd3b$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $1b59b3eb711ecd3b$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1b59b3eb711ecd3b$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1b59b3eb711ecd3b$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1b59b3eb711ecd3b$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $473da582d699f1af$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $56aec9a601b0cfa3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $db275d06fffa83cf$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $db275d06fffa83cf$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $db275d06fffa83cf$var$hyphenateRegex = /[A-Z]|^ms/g;
var $db275d06fffa83cf$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $db275d06fffa83cf$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $db275d06fffa83cf$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $db275d06fffa83cf$var$processStyleName = /* #__PURE__ */ (0, $65ae90d3498e0dc3$export$2e2bcd8739ae039)(function(styleName) {
    return $db275d06fffa83cf$var$isCustomProperty(styleName) ? styleName : styleName.replace($db275d06fffa83cf$var$hyphenateRegex, '-$&').toLowerCase();
});
var $db275d06fffa83cf$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($db275d06fffa83cf$var$animationRegex, function(match, p1, p2) {
                $db275d06fffa83cf$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $db275d06fffa83cf$var$cursor
                };
                return p1;
            });
    }
    if ((0, $56aec9a601b0cfa3$export$2e2bcd8739ae039)[key] !== 1 && !$db275d06fffa83cf$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $db275d06fffa83cf$var$contentValuePattern, $db275d06fffa83cf$var$contentValues, $db275d06fffa83cf$var$oldProcessStyleValue, $db275d06fffa83cf$var$msPattern, $db275d06fffa83cf$var$hyphenPattern, $db275d06fffa83cf$var$hyphenatedCache;
var $db275d06fffa83cf$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $db275d06fffa83cf$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $db275d06fffa83cf$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $db275d06fffa83cf$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $db275d06fffa83cf$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $db275d06fffa83cf$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $db275d06fffa83cf$var$cursor;
                var result = interpolation(mergedProps);
                $db275d06fffa83cf$var$cursor = previousCursor;
                return $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $db275d06fffa83cf$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($db275d06fffa83cf$var$isProcessableValue(value)) string += $db275d06fffa83cf$var$processStyleName(_key) + ":" + $db275d06fffa83cf$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($db275d06fffa83cf$var$isProcessableValue(value[_i])) string += $db275d06fffa83cf$var$processStyleName(_key) + ":" + $db275d06fffa83cf$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case 'animation':
                case 'animationName':
                    string += $db275d06fffa83cf$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $db275d06fffa83cf$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $db275d06fffa83cf$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $db275d06fffa83cf$var$cursor;
var $db275d06fffa83cf$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $db275d06fffa83cf$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $db275d06fffa83cf$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $db275d06fffa83cf$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $db275d06fffa83cf$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $473da582d699f1af$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $db275d06fffa83cf$var$cursor
    };
};



var $3ZYaX = parcelRequire("3ZYaX");
var $586b729812886d22$var$syncFallback = function syncFallback(create) {
    return create();
};
var $586b729812886d22$var$useInsertionEffect = $3ZYaX.useInsertionEffect ? $3ZYaX.useInsertionEffect : false;
var $586b729812886d22$export$db21c7ffa21794e7 = $586b729812886d22$var$useInsertionEffect || $586b729812886d22$var$syncFallback;
var $586b729812886d22$export$811a713a7276cb9d = $586b729812886d22$var$useInsertionEffect || $3ZYaX.useLayoutEffect;


var $e18b585dd2832fc3$export$23f2a1d2818174ef = true;
var $e18b585dd2832fc3$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $e18b585dd2832fc3$var$EmotionCacheContext = /* #__PURE__ */ $3ZYaX.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $6db6ea46e2b48da7$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $e18b585dd2832fc3$export$e7094788287c5e9b = $e18b585dd2832fc3$var$EmotionCacheContext.Provider;
var $e18b585dd2832fc3$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $3ZYaX.useContext)($e18b585dd2832fc3$var$EmotionCacheContext);
};
var $e18b585dd2832fc3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $3ZYaX.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $3ZYaX.useContext)($e18b585dd2832fc3$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$e18b585dd2832fc3$export$23f2a1d2818174ef) $e18b585dd2832fc3$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $3ZYaX.useContext)($e18b585dd2832fc3$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $6db6ea46e2b48da7$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $3ZYaX.createElement($e18b585dd2832fc3$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $e18b585dd2832fc3$export$971d5caa766a69d7 = /* #__PURE__ */ $3ZYaX.createContext({});
var $e18b585dd2832fc3$export$3b14a55fb2447963 = function useTheme() {
    return $3ZYaX.useContext($e18b585dd2832fc3$export$971d5caa766a69d7);
};
var $e18b585dd2832fc3$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $e18b585dd2832fc3$var$createCacheWithTheme = /* #__PURE__ */ (0, $895929f4c661a494$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $895929f4c661a494$export$2e2bcd8739ae039)(function(theme) {
        return $e18b585dd2832fc3$var$getTheme(outerTheme, theme);
    });
});
var $e18b585dd2832fc3$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $3ZYaX.useContext($e18b585dd2832fc3$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $e18b585dd2832fc3$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $3ZYaX.createElement($e18b585dd2832fc3$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $e18b585dd2832fc3$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $3ZYaX.useContext($e18b585dd2832fc3$export$971d5caa766a69d7);
        return /*#__PURE__*/ $3ZYaX.createElement(Component, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $3ZYaX.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $18b70d2dd62e9559$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $e18b585dd2832fc3$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $e18b585dd2832fc3$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $e18b585dd2832fc3$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $e18b585dd2832fc3$var$getLastPart(match[1]);
    return undefined;
};
var $e18b585dd2832fc3$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $e18b585dd2832fc3$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $e18b585dd2832fc3$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $e18b585dd2832fc3$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($e18b585dd2832fc3$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $e18b585dd2832fc3$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $e18b585dd2832fc3$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $e18b585dd2832fc3$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $e18b585dd2832fc3$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($e18b585dd2832fc3$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$e18b585dd2832fc3$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $e18b585dd2832fc3$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1b59b3eb711ecd3b$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $586b729812886d22$export$db21c7ffa21794e7)(function() {
        return (0, $1b59b3eb711ecd3b$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $e18b585dd2832fc3$var$Emotion = /* #__PURE__ */ $e18b585dd2832fc3$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$e18b585dd2832fc3$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $1b59b3eb711ecd3b$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $db275d06fffa83cf$export$6321afa313b251b5)(registeredStyles, undefined, $3ZYaX.useContext($e18b585dd2832fc3$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($e18b585dd2832fc3$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $e18b585dd2832fc3$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, /*#__PURE__*/ $3ZYaX.createElement($e18b585dd2832fc3$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $3ZYaX.createElement(WrappedComponent, newProps));
});
var $e18b585dd2832fc3$export$a9c23c6ac3fc3eca = $e18b585dd2832fc3$var$Emotion;



var $3ZYaX = parcelRequire("3ZYaX");




var $1aa62d6adfbd0364$exports = {};
function $1aa62d6adfbd0364$var$_extends() {
    $1aa62d6adfbd0364$exports = $1aa62d6adfbd0364$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, $1aa62d6adfbd0364$exports.__esModule = true, $1aa62d6adfbd0364$exports["default"] = $1aa62d6adfbd0364$exports;
    return $1aa62d6adfbd0364$var$_extends.apply(this, arguments);
}
$1aa62d6adfbd0364$exports = $1aa62d6adfbd0364$var$_extends, $1aa62d6adfbd0364$exports.__esModule = true, $1aa62d6adfbd0364$exports["default"] = $1aa62d6adfbd0364$exports;




parcelRequire("6fGvd");
var $3704582a1888f853$var$pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $3704582a1888f853$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $e18b585dd2832fc3$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return $3ZYaX.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $e18b585dd2832fc3$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $e18b585dd2832fc3$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $3ZYaX.createElement.apply(null, createElementArgArray);
};
var $3704582a1888f853$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3704582a1888f853$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $e18b585dd2832fc3$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $db275d06fffa83cf$export$6321afa313b251b5)([
        styles
    ], undefined, $3ZYaX.useContext((0, $e18b585dd2832fc3$export$971d5caa766a69d7)));
    if (!(0, $e18b585dd2832fc3$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $3ZYaX.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $3ZYaX.useRef();
    (0, $586b729812886d22$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $586b729812886d22$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1b59b3eb711ecd3b$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3704582a1888f853$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $db275d06fffa83cf$export$6321afa313b251b5)(args);
}
var $3704582a1888f853$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $3704582a1888f853$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $3704582a1888f853$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3704582a1888f853$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1b59b3eb711ecd3b$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3704582a1888f853$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $586b729812886d22$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1b59b3eb711ecd3b$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $3704582a1888f853$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $e18b585dd2832fc3$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $db275d06fffa83cf$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1b59b3eb711ecd3b$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3704582a1888f853$var$merge(cache.registered, css, $3704582a1888f853$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $3ZYaX.useContext((0, $e18b585dd2832fc3$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $3ZYaX.createElement($3ZYaX.Fragment, null, /*#__PURE__*/ $3ZYaX.createElement($3704582a1888f853$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $3704582a1888f853$var$isBrowser, $3704582a1888f853$var$isTestEnv, $3704582a1888f853$var$globalContext, $3704582a1888f853$var$globalKey;


function $844a554fb85e7057$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}


function $5df1713e51bd5205$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $dbb7452b3da79ecc$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $aae924f7e2151cb9$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $dbb7452b3da79ecc$export$2e2bcd8739ae039)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $dbb7452b3da79ecc$export$2e2bcd8739ae039)(o, minLen);
}


function $5204d48353dcd5ba$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e352b643f6267c8a$export$2e2bcd8739ae039(arr, i) {
    return (0, $844a554fb85e7057$export$2e2bcd8739ae039)(arr) || (0, $5df1713e51bd5205$export$2e2bcd8739ae039)(arr, i) || (0, $aae924f7e2151cb9$export$2e2bcd8739ae039)(arr, i) || (0, $5204d48353dcd5ba$export$2e2bcd8739ae039)();
}


function $ec4d20ddd5cc9c41$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $73caaffdd544ad23$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $ec4d20ddd5cc9c41$export$2e2bcd8739ae039)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



function $97286e9c74b67e31$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}




var $3ZYaX = parcelRequire("3ZYaX");

var $1rKN8 = parcelRequire("1rKN8");
const $b90afd6b02c70060$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $b90afd6b02c70060$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $b90afd6b02c70060$export$803cd8101b6c182b = /*#__PURE__*/ $b90afd6b02c70060$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $b90afd6b02c70060$export$27b07d8a310ed8b5[0], side + "-" + $b90afd6b02c70060$export$27b07d8a310ed8b5[1]), []);
const $b90afd6b02c70060$export$96ec731ed4dcb222 = Math.min;
const $b90afd6b02c70060$export$8960430cfd85939f = Math.max;
const $b90afd6b02c70060$export$2077e0241d6afd3c = Math.round;
const $b90afd6b02c70060$export$a3fe094919f356fd = Math.floor;
const $b90afd6b02c70060$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $b90afd6b02c70060$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $b90afd6b02c70060$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $b90afd6b02c70060$export$7d15b64cf5a3a4c4(start, value, end) {
    return $b90afd6b02c70060$export$8960430cfd85939f(start, $b90afd6b02c70060$export$96ec731ed4dcb222(value, end));
}
function $b90afd6b02c70060$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $b90afd6b02c70060$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $b90afd6b02c70060$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $b90afd6b02c70060$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $b90afd6b02c70060$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $b90afd6b02c70060$export$f28e8f882010718a(placement) {
    return [
        'top',
        'bottom'
    ].includes($b90afd6b02c70060$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $b90afd6b02c70060$export$2b57e0052a6d6d4c(placement) {
    return $b90afd6b02c70060$export$8a000a963141ac32($b90afd6b02c70060$export$f28e8f882010718a(placement));
}
function $b90afd6b02c70060$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $b90afd6b02c70060$export$f0989780f32bfcda(placement);
    const alignmentAxis = $b90afd6b02c70060$export$2b57e0052a6d6d4c(placement);
    const length = $b90afd6b02c70060$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $b90afd6b02c70060$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $b90afd6b02c70060$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $b90afd6b02c70060$export$496432a3699e50b1(placement) {
    const oppositePlacement = $b90afd6b02c70060$export$9c5e28bad23365fa(placement);
    return [
        $b90afd6b02c70060$export$2b182c584985588b(placement),
        oppositePlacement,
        $b90afd6b02c70060$export$2b182c584985588b(oppositePlacement)
    ];
}
function $b90afd6b02c70060$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$b90afd6b02c70060$var$oppositeAlignmentMap[alignment]);
}
function $b90afd6b02c70060$var$getSideList(side, isStart, rtl) {
    const lr = [
        'left',
        'right'
    ];
    const rl = [
        'right',
        'left'
    ];
    const tb = [
        'top',
        'bottom'
    ];
    const bt = [
        'bottom',
        'top'
    ];
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case 'left':
        case 'right':
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $b90afd6b02c70060$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $b90afd6b02c70060$export$f0989780f32bfcda(placement);
    let list = $b90afd6b02c70060$var$getSideList($b90afd6b02c70060$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($b90afd6b02c70060$export$2b182c584985588b));
    }
    return list;
}
function $b90afd6b02c70060$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$b90afd6b02c70060$var$oppositeSideMap[side]);
}
function $b90afd6b02c70060$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $b90afd6b02c70060$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $b90afd6b02c70060$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $b90afd6b02c70060$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $f27009ded7edd82a$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $b90afd6b02c70060$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $b90afd6b02c70060$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $b90afd6b02c70060$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $f27009ded7edd82a$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $f27009ded7edd82a$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $f27009ded7edd82a$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $f27009ded7edd82a$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $b90afd6b02c70060$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $b90afd6b02c70060$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $b90afd6b02c70060$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f27009ded7edd82a$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $b90afd6b02c70060$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $b90afd6b02c70060$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $b90afd6b02c70060$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $b90afd6b02c70060$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = (0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset + alignmentOffset
                }
            };
        }
    });
function $f27009ded7edd82a$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $b90afd6b02c70060$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $f27009ded7edd82a$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $b90afd6b02c70060$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $b90afd6b02c70060$export$803cd8101b6c182b) ? $f27009ded7edd82a$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $b90afd6b02c70060$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $b90afd6b02c70060$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $b90afd6b02c70060$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $b90afd6b02c70060$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $f27009ded7edd82a$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const side = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $b90afd6b02c70060$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $b90afd6b02c70060$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== 'none') fallbackPlacements.push(...(0, $b90afd6b02c70060$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $b90afd6b02c70060$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $f27009ded7edd82a$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $f27009ded7edd82a$var$isAnySideFullyClipped(overflow) {
    return (0, $b90afd6b02c70060$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $f27009ded7edd82a$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $f27009ded7edd82a$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $f27009ded7edd82a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $f27009ded7edd82a$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $f27009ded7edd82a$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $f27009ded7edd82a$var$getBoundingRect(rects) {
    const minX = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $b90afd6b02c70060$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $b90afd6b02c70060$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $f27009ded7edd82a$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $b90afd6b02c70060$export$ee05aea0aeecbad4)($f27009ded7edd82a$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $f27009ded7edd82a$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $f27009ded7edd82a$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $b90afd6b02c70060$export$ee05aea0aeecbad4)($f27009ded7edd82a$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $b90afd6b02c70060$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $b90afd6b02c70060$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $b90afd6b02c70060$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $f27009ded7edd82a$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $b90afd6b02c70060$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = [
        'left',
        'top'
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $f27009ded7edd82a$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $f27009ded7edd82a$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $f27009ded7edd82a$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $b90afd6b02c70060$export$f28e8f882010718a)((0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $b90afd6b02c70060$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $b90afd6b02c70060$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $b90afd6b02c70060$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $f27009ded7edd82a$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $b90afd6b02c70060$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $b90afd6b02c70060$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = [
                    'top',
                    'left'
                ].includes((0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $f27009ded7edd82a$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $b90afd6b02c70060$export$fef61f332f2c0afc)(options, state);
            const overflow = await $f27009ded7edd82a$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $b90afd6b02c70060$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $b90afd6b02c70060$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $b90afd6b02c70060$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $b90afd6b02c70060$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $589b79dfcfd55785$export$651544f548703224(node) {
    if ($589b79dfcfd55785$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $589b79dfcfd55785$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $589b79dfcfd55785$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($589b79dfcfd55785$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $589b79dfcfd55785$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $589b79dfcfd55785$export$38b2d434cce3ea22(value).Node;
}
function $589b79dfcfd55785$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $589b79dfcfd55785$export$38b2d434cce3ea22(value).Element;
}
function $589b79dfcfd55785$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $589b79dfcfd55785$export$38b2d434cce3ea22(value).HTMLElement;
}
function $589b79dfcfd55785$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $589b79dfcfd55785$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $589b79dfcfd55785$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $589b79dfcfd55785$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        'inline',
        'contents'
    ].includes(display);
}
function $589b79dfcfd55785$export$71535ffaa902797f(element) {
    return [
        'table',
        'td',
        'th'
    ].includes($589b79dfcfd55785$export$651544f548703224(element));
}
function $589b79dfcfd55785$export$d6c4e8150c35fed1(element) {
    const webkit = $589b79dfcfd55785$export$78551043582a6a98();
    const css = $589b79dfcfd55785$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
        'transform',
        'perspective',
        'filter'
    ].some((value)=>(css.willChange || '').includes(value)) || [
        'paint',
        'layout',
        'strict',
        'content'
    ].some((value)=>(css.contain || '').includes(value));
}
function $589b79dfcfd55785$export$940d8225183e1404(element) {
    let currentNode = $589b79dfcfd55785$export$4e12058fc4d51d56(element);
    while($589b79dfcfd55785$export$1b3bfaa9684536aa(currentNode) && !$589b79dfcfd55785$export$d1162fb0b6d4cd51(currentNode)){
        if ($589b79dfcfd55785$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $589b79dfcfd55785$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $589b79dfcfd55785$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
function $589b79dfcfd55785$export$d1162fb0b6d4cd51(node) {
    return [
        'html',
        'body',
        '#document'
    ].includes($589b79dfcfd55785$export$651544f548703224(node));
}
function $589b79dfcfd55785$export$3735103072e4a80(element) {
    return $589b79dfcfd55785$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $589b79dfcfd55785$export$dc8fc79fa2800137(element) {
    if ($589b79dfcfd55785$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $589b79dfcfd55785$export$4e12058fc4d51d56(node) {
    if ($589b79dfcfd55785$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $589b79dfcfd55785$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $589b79dfcfd55785$export$e495491855dc5418(node);
    return $589b79dfcfd55785$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $589b79dfcfd55785$export$7cd01a57c8ca906c(node) {
    const parentNode = $589b79dfcfd55785$export$4e12058fc4d51d56(node);
    if ($589b79dfcfd55785$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($589b79dfcfd55785$export$1b3bfaa9684536aa(parentNode) && $589b79dfcfd55785$export$989e911fa9af580a(parentNode)) return parentNode;
    return $589b79dfcfd55785$export$7cd01a57c8ca906c(parentNode);
}
function $589b79dfcfd55785$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    const scrollableAncestor = $589b79dfcfd55785$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $589b79dfcfd55785$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $589b79dfcfd55785$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement ? $589b79dfcfd55785$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $589b79dfcfd55785$export$3b57c1601291186b(scrollableAncestor));
}


function $21d616caefb5ec7a$var$getCssDimensions(element) {
    const css = (0, $589b79dfcfd55785$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $b90afd6b02c70060$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $b90afd6b02c70060$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $21d616caefb5ec7a$var$unwrapElement(element) {
    return !(0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $21d616caefb5ec7a$var$getScale(element) {
    const domElement = $21d616caefb5ec7a$var$unwrapElement(element);
    if (!(0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(domElement)) return (0, $b90afd6b02c70060$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $21d616caefb5ec7a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $b90afd6b02c70060$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $b90afd6b02c70060$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $21d616caefb5ec7a$var$noOffsets = /*#__PURE__*/ (0, $b90afd6b02c70060$export$a397704b5e280835)(0);
function $21d616caefb5ec7a$var$getVisualOffsets(element) {
    const win = (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(element);
    if (!(0, $589b79dfcfd55785$export$78551043582a6a98)() || !win.visualViewport) return $21d616caefb5ec7a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $21d616caefb5ec7a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $21d616caefb5ec7a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $21d616caefb5ec7a$var$unwrapElement(element);
    let scale = (0, $b90afd6b02c70060$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(offsetParent)) scale = $21d616caefb5ec7a$var$getScale(offsetParent);
        } else scale = $21d616caefb5ec7a$var$getScale(element);
    }
    const visualOffsets = $21d616caefb5ec7a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $21d616caefb5ec7a$var$getVisualOffsets(domElement) : (0, $b90afd6b02c70060$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $21d616caefb5ec7a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $589b79dfcfd55785$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $b90afd6b02c70060$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $21d616caefb5ec7a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $589b79dfcfd55785$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $b90afd6b02c70060$export$a397704b5e280835)(1);
    const offsets = (0, $b90afd6b02c70060$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== 'fixed') {
        if ((0, $589b79dfcfd55785$export$651544f548703224)(offsetParent) !== 'body' || (0, $589b79dfcfd55785$export$989e911fa9af580a)(documentElement)) scroll = (0, $589b79dfcfd55785$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $21d616caefb5ec7a$var$getBoundingClientRect(offsetParent);
            scale = $21d616caefb5ec7a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $21d616caefb5ec7a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $21d616caefb5ec7a$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $21d616caefb5ec7a$var$getBoundingClientRect((0, $589b79dfcfd55785$export$e495491855dc5418)(element)).left + (0, $589b79dfcfd55785$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $21d616caefb5ec7a$var$getDocumentRect(element) {
    const html = (0, $589b79dfcfd55785$export$e495491855dc5418)(element);
    const scroll = (0, $589b79dfcfd55785$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $b90afd6b02c70060$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $b90afd6b02c70060$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $21d616caefb5ec7a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $589b79dfcfd55785$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $b90afd6b02c70060$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $21d616caefb5ec7a$var$getViewportRect(element, strategy) {
    const win = (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(element);
    const html = (0, $589b79dfcfd55785$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $589b79dfcfd55785$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $21d616caefb5ec7a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $21d616caefb5ec7a$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(element) ? $21d616caefb5ec7a$var$getScale(element) : (0, $b90afd6b02c70060$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $21d616caefb5ec7a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $21d616caefb5ec7a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $21d616caefb5ec7a$var$getDocumentRect((0, $589b79dfcfd55785$export$e495491855dc5418)(element));
    else if ((0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $21d616caefb5ec7a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $21d616caefb5ec7a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $b90afd6b02c70060$export$ee05aea0aeecbad4)(rect);
}
function $21d616caefb5ec7a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $589b79dfcfd55785$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(parentNode) || (0, $589b79dfcfd55785$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $589b79dfcfd55785$export$3735103072e4a80)(parentNode).position === 'fixed' || $21d616caefb5ec7a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $21d616caefb5ec7a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $589b79dfcfd55785$export$3b57c1601291186b)(element).filter((el)=>(0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(el) && (0, $589b79dfcfd55785$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $589b79dfcfd55785$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $589b79dfcfd55785$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $589b79dfcfd55785$export$45a5e7f76e0caa8d)(currentNode) && !(0, $589b79dfcfd55785$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $589b79dfcfd55785$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $589b79dfcfd55785$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
            'absolute',
            'fixed'
        ].includes(currentContainingBlockComputedStyle.position) || (0, $589b79dfcfd55785$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $21d616caefb5ec7a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $589b79dfcfd55785$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $21d616caefb5ec7a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? $21d616caefb5ec7a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $21d616caefb5ec7a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $b90afd6b02c70060$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $b90afd6b02c70060$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $21d616caefb5ec7a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $21d616caefb5ec7a$var$getDimensions(element) {
    return $21d616caefb5ec7a$var$getCssDimensions(element);
}
function $21d616caefb5ec7a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $589b79dfcfd55785$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $21d616caefb5ec7a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $b90afd6b02c70060$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $589b79dfcfd55785$export$651544f548703224)(offsetParent) !== 'body' || (0, $589b79dfcfd55785$export$989e911fa9af580a)(documentElement)) scroll = (0, $589b79dfcfd55785$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $21d616caefb5ec7a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $21d616caefb5ec7a$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $21d616caefb5ec7a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(element) || (0, $589b79dfcfd55785$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $21d616caefb5ec7a$var$getOffsetParent(element, polyfill) {
    const window = (0, $589b79dfcfd55785$export$38b2d434cce3ea22)(element);
    if (!(0, $589b79dfcfd55785$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $21d616caefb5ec7a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $589b79dfcfd55785$export$71535ffaa902797f)(offsetParent) && (0, $589b79dfcfd55785$export$3735103072e4a80)(offsetParent).position === 'static')offsetParent = $21d616caefb5ec7a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $589b79dfcfd55785$export$651544f548703224)(offsetParent) === 'html' || (0, $589b79dfcfd55785$export$651544f548703224)(offsetParent) === 'body' && (0, $589b79dfcfd55785$export$3735103072e4a80)(offsetParent).position === 'static' && !(0, $589b79dfcfd55785$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $589b79dfcfd55785$export$940d8225183e1404)(element) || window;
}
const $21d616caefb5ec7a$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $21d616caefb5ec7a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $21d616caefb5ec7a$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $21d616caefb5ec7a$var$isRTL(element) {
    return (0, $589b79dfcfd55785$export$3735103072e4a80)(element).direction === 'rtl';
}
const $21d616caefb5ec7a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $21d616caefb5ec7a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $589b79dfcfd55785$export$e495491855dc5418,
    getClippingRect: $21d616caefb5ec7a$var$getClippingRect,
    getOffsetParent: $21d616caefb5ec7a$var$getOffsetParent,
    getElementRects: $21d616caefb5ec7a$var$getElementRects,
    getClientRects: $21d616caefb5ec7a$var$getClientRects,
    getDimensions: $21d616caefb5ec7a$var$getDimensions,
    getScale: $21d616caefb5ec7a$var$getScale,
    isElement: $589b79dfcfd55785$export$45a5e7f76e0caa8d,
    isRTL: $21d616caefb5ec7a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $21d616caefb5ec7a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $589b79dfcfd55785$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $b90afd6b02c70060$export$a3fe094919f356fd)(top);
        const insetRight = (0, $b90afd6b02c70060$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $b90afd6b02c70060$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $b90afd6b02c70060$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $b90afd6b02c70060$export$8960430cfd85939f)(0, (0, $b90afd6b02c70060$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $21d616caefb5ec7a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $21d616caefb5ec7a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $589b79dfcfd55785$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $589b79dfcfd55785$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $21d616caefb5ec7a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $21d616caefb5ec7a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $21d616caefb5ec7a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $21d616caefb5ec7a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $21d616caefb5ec7a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $f27009ded7edd82a$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $3ZYaX = parcelRequire("3ZYaX");
var $7a32f83835be847b$var$index = (0, $3ZYaX.useLayoutEffect);
var $7a32f83835be847b$export$2e2bcd8739ae039 = $7a32f83835be847b$var$index;


var $a837bdaa510c8cc6$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $a837bdaa510c8cc6$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $a837bdaa510c8cc6$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $a837bdaa510c8cc6$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($a837bdaa510c8cc6$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $a837bdaa510c8cc6$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($a837bdaa510c8cc6$var$isArray(value)) return value.filter(Boolean);
    if ((0, $143ffd39167373a2$export$2e2bcd8739ae039)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $a837bdaa510c8cc6$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(props, $a837bdaa510c8cc6$var$_excluded$4);
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $a837bdaa510c8cc6$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $a837bdaa510c8cc6$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $a837bdaa510c8cc6$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $a837bdaa510c8cc6$var$normalizedHeight(el) {
    if ($a837bdaa510c8cc6$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $a837bdaa510c8cc6$var$getScrollTop(el) {
    if ($a837bdaa510c8cc6$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $a837bdaa510c8cc6$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($a837bdaa510c8cc6$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $a837bdaa510c8cc6$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $a837bdaa510c8cc6$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $a837bdaa510c8cc6$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $a837bdaa510c8cc6$export$b4171a6734a65d42;
    var start = $a837bdaa510c8cc6$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $a837bdaa510c8cc6$var$easeOutCubic(currentTime, start, change, duration);
        $a837bdaa510c8cc6$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $a837bdaa510c8cc6$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $a837bdaa510c8cc6$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $a837bdaa510c8cc6$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $a837bdaa510c8cc6$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $a837bdaa510c8cc6$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $a837bdaa510c8cc6$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $a837bdaa510c8cc6$var$passiveOptionAccessed = false;
var $a837bdaa510c8cc6$var$options = {
    get passive () {
        return $a837bdaa510c8cc6$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $a837bdaa510c8cc6$var$w = typeof window !== 'undefined' ? window : {};
if ($a837bdaa510c8cc6$var$w.addEventListener && $a837bdaa510c8cc6$var$w.removeEventListener) {
    $a837bdaa510c8cc6$var$w.addEventListener('p', $a837bdaa510c8cc6$export$b4171a6734a65d42, $a837bdaa510c8cc6$var$options);
    $a837bdaa510c8cc6$var$w.removeEventListener('p', $a837bdaa510c8cc6$export$b4171a6734a65d42, false);
}
var $a837bdaa510c8cc6$export$2408f22a0fab9ae5 = $a837bdaa510c8cc6$var$passiveOptionAccessed;
function $a837bdaa510c8cc6$export$3466f893ebf79586(item) {
    return item != null;
}
function $a837bdaa510c8cc6$var$isArray(arg) {
    return Array.isArray(arg);
}
function $a837bdaa510c8cc6$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $a837bdaa510c8cc6$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $a837bdaa510c8cc6$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $a837bdaa510c8cc6$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $a837bdaa510c8cc6$var$_excluded$3 = [
    "children",
    "innerProps"
], $a837bdaa510c8cc6$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $a837bdaa510c8cc6$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $a837bdaa510c8cc6$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $a837bdaa510c8cc6$var$normalizedHeight(scrollParent);
    var scrollTop = $a837bdaa510c8cc6$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a837bdaa510c8cc6$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $a837bdaa510c8cc6$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $a837bdaa510c8cc6$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $a837bdaa510c8cc6$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $a837bdaa510c8cc6$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $a837bdaa510c8cc6$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $a837bdaa510c8cc6$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $a837bdaa510c8cc6$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((_objectSpread2 = {
        label: 'menu'
    }, (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(_objectSpread2, $a837bdaa510c8cc6$var$alignToControl(placement), '100%'), (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(_objectSpread2, "position", 'absolute'), (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(_objectSpread2, "width", '100%'), (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $a837bdaa510c8cc6$var$PortalPlacementContext = /*#__PURE__*/ (0, $3ZYaX.createContext)(null);
// NOTE: internal only
var $a837bdaa510c8cc6$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $3ZYaX.useContext)($a837bdaa510c8cc6$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $3ZYaX.useRef)(null);
    var _useState = (0, $3ZYaX.useState)(maxMenuHeight), _useState2 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $3ZYaX.useState)(null), _useState4 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $7a32f83835be847b$export$2e2bcd8739ae039)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $a837bdaa510c8cc6$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, props), {}, {
            placement: placement || $a837bdaa510c8cc6$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $a837bdaa510c8cc6$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $a837bdaa510c8cc6$var$Menu$1 = $a837bdaa510c8cc6$var$Menu;
// ==============================
// Menu List
// ==============================
var $a837bdaa510c8cc6$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $a837bdaa510c8cc6$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $a837bdaa510c8cc6$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $a837bdaa510c8cc6$export$3b14a55fb2447963 = $a837bdaa510c8cc6$var$noticeCSS;
var $a837bdaa510c8cc6$export$342063e11d6c3cad = $a837bdaa510c8cc6$var$noticeCSS;
var $a837bdaa510c8cc6$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref6, $a837bdaa510c8cc6$var$_excluded$3);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $a837bdaa510c8cc6$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref7, $a837bdaa510c8cc6$var$_excluded2$1);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $a837bdaa510c8cc6$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $a837bdaa510c8cc6$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $3ZYaX.useRef)(null);
    var cleanupRef = (0, $3ZYaX.useRef)(null);
    var _useState5 = (0, $3ZYaX.useState)($a837bdaa510c8cc6$var$coercePlacement(menuPlacement)), _useState6 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $3ZYaX.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $3ZYaX.useState)(null), _useState8 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $3ZYaX.useCallback)(function() {
        if (!controlElement) return;
        var rect = $a837bdaa510c8cc6$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $7a32f83835be847b$export$2e2bcd8739ae039)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $3ZYaX.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $21d616caefb5ec7a$export$deee3a793edee05f)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $7a32f83835be847b$export$2e2bcd8739ae039)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $3ZYaX.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        ref: setMenuPortalElement
    }, $a837bdaa510c8cc6$var$getStyleProps((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $1rKN8.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $a837bdaa510c8cc6$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $a837bdaa510c8cc6$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $a837bdaa510c8cc6$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $a837bdaa510c8cc6$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $a837bdaa510c8cc6$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $a837bdaa510c8cc6$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $a837bdaa510c8cc6$var$_templateObject;
var $a837bdaa510c8cc6$var$_excluded$2 = [
    "size"
], $a837bdaa510c8cc6$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $a837bdaa510c8cc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $a837bdaa510c8cc6$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $a837bdaa510c8cc6$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref, $a837bdaa510c8cc6$var$_excluded$2);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("svg", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $a837bdaa510c8cc6$var$_ref2
    }, props));
};
var $a837bdaa510c8cc6$var$CrossIcon = function CrossIcon(props) {
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$Svg, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $a837bdaa510c8cc6$var$DownChevron = function DownChevron(props) {
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$Svg, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        size: 20
    }, props), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $a837bdaa510c8cc6$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $a837bdaa510c8cc6$export$f1e1789686576879 = $a837bdaa510c8cc6$var$baseCSS;
var $a837bdaa510c8cc6$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$DownChevron, null));
};
var $a837bdaa510c8cc6$export$407448d2b89b1813 = $a837bdaa510c8cc6$var$baseCSS;
var $a837bdaa510c8cc6$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $a837bdaa510c8cc6$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $a837bdaa510c8cc6$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, innerProps, $a837bdaa510c8cc6$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $a837bdaa510c8cc6$var$loadingDotAnimations = (0, $3704582a1888f853$export$d25ddfdf17c3ad3e)($a837bdaa510c8cc6$var$_templateObject || ($a837bdaa510c8cc6$var$_templateObject = (0, $97286e9c74b67e31$export$2e2bcd8739ae039)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $a837bdaa510c8cc6$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $a837bdaa510c8cc6$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", {
        css: /*#__PURE__*/ (0, $3704582a1888f853$export$dbf350e5966cf602)({
            animation: "".concat($a837bdaa510c8cc6$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $a837bdaa510c8cc6$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref7, $a837bdaa510c8cc6$var$_excluded2);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $a837bdaa510c8cc6$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $a837bdaa510c8cc6$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        ref: innerRef
    }, $a837bdaa510c8cc6$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $a837bdaa510c8cc6$var$Control$1 = $a837bdaa510c8cc6$var$Control;
var $a837bdaa510c8cc6$var$_excluded$1 = [
    "data"
];
var $a837bdaa510c8cc6$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $a837bdaa510c8cc6$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $3704582a1888f853$export$c8a8987d4410bf2d)(Heading, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", null, children));
};
var $a837bdaa510c8cc6$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $a837bdaa510c8cc6$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $a837bdaa510c8cc6$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_cleanCommonProps, $a837bdaa510c8cc6$var$_excluded$1);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $a837bdaa510c8cc6$var$Group$1 = $a837bdaa510c8cc6$var$Group;
var $a837bdaa510c8cc6$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $a837bdaa510c8cc6$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $a837bdaa510c8cc6$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $a837bdaa510c8cc6$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $a837bdaa510c8cc6$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $a837bdaa510c8cc6$var$spacingStyle)
};
var $a837bdaa510c8cc6$var$inputStyle = function inputStyle(isHidden) {
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $a837bdaa510c8cc6$var$spacingStyle);
};
var $a837bdaa510c8cc6$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $a837bdaa510c8cc6$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_cleanCommonProps, $a837bdaa510c8cc6$var$_excluded);
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("input", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $a837bdaa510c8cc6$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $a837bdaa510c8cc6$var$Input$1 = $a837bdaa510c8cc6$var$Input;
var $a837bdaa510c8cc6$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $a837bdaa510c8cc6$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $a837bdaa510c8cc6$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $a837bdaa510c8cc6$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", innerProps, children);
};
var $a837bdaa510c8cc6$var$MultiValueContainer = $a837bdaa510c8cc6$var$MultiValueGeneric;
var $a837bdaa510c8cc6$var$MultiValueLabel = $a837bdaa510c8cc6$var$MultiValueGeneric;
function $a837bdaa510c8cc6$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        role: "button"
    }, innerProps), children || (0, $3704582a1888f853$export$c8a8987d4410bf2d)($a837bdaa510c8cc6$var$CrossIcon, {
        size: 14
    }));
}
var $a837bdaa510c8cc6$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)(Container, {
        data: data,
        innerProps: (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $3704582a1888f853$export$c8a8987d4410bf2d)(Label, {
        data: data,
        innerProps: (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $3704582a1888f853$export$c8a8987d4410bf2d)(Remove, {
        data: data,
        innerProps: (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $a837bdaa510c8cc6$var$MultiValue$1 = $a837bdaa510c8cc6$var$MultiValue;
var $a837bdaa510c8cc6$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $a837bdaa510c8cc6$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $a837bdaa510c8cc6$var$Option$1 = $a837bdaa510c8cc6$var$Option;
var $a837bdaa510c8cc6$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a837bdaa510c8cc6$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $a837bdaa510c8cc6$var$Placeholder$1 = $a837bdaa510c8cc6$var$Placeholder;
var $a837bdaa510c8cc6$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $a837bdaa510c8cc6$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $a837bdaa510c8cc6$var$SingleValue$1 = $a837bdaa510c8cc6$var$SingleValue;
var $a837bdaa510c8cc6$export$db3b6bfb95261072 = {
    ClearIndicator: $a837bdaa510c8cc6$var$ClearIndicator,
    Control: $a837bdaa510c8cc6$var$Control$1,
    DropdownIndicator: $a837bdaa510c8cc6$var$DropdownIndicator,
    DownChevron: $a837bdaa510c8cc6$var$DownChevron,
    CrossIcon: $a837bdaa510c8cc6$var$CrossIcon,
    Group: $a837bdaa510c8cc6$var$Group$1,
    GroupHeading: $a837bdaa510c8cc6$var$GroupHeading,
    IndicatorsContainer: $a837bdaa510c8cc6$var$IndicatorsContainer,
    IndicatorSeparator: $a837bdaa510c8cc6$var$IndicatorSeparator,
    Input: $a837bdaa510c8cc6$var$Input$1,
    LoadingIndicator: $a837bdaa510c8cc6$var$LoadingIndicator,
    Menu: $a837bdaa510c8cc6$var$Menu$1,
    MenuList: $a837bdaa510c8cc6$var$MenuList,
    MenuPortal: $a837bdaa510c8cc6$var$MenuPortal,
    LoadingMessage: $a837bdaa510c8cc6$var$LoadingMessage,
    NoOptionsMessage: $a837bdaa510c8cc6$var$NoOptionsMessage,
    MultiValue: $a837bdaa510c8cc6$var$MultiValue$1,
    MultiValueContainer: $a837bdaa510c8cc6$var$MultiValueContainer,
    MultiValueLabel: $a837bdaa510c8cc6$var$MultiValueLabel,
    MultiValueRemove: $a837bdaa510c8cc6$var$MultiValueRemove,
    Option: $a837bdaa510c8cc6$var$Option$1,
    Placeholder: $a837bdaa510c8cc6$var$Placeholder$1,
    SelectContainer: $a837bdaa510c8cc6$var$SelectContainer,
    SingleValue: $a837bdaa510c8cc6$var$SingleValue$1,
    ValueContainer: $a837bdaa510c8cc6$var$ValueContainer
};
var $a837bdaa510c8cc6$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $a837bdaa510c8cc6$export$db3b6bfb95261072), props.components);
};





var $3ZYaX = parcelRequire("3ZYaX");
var $29c765b91408f8b0$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $29c765b91408f8b0$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref, $29c765b91408f8b0$var$_excluded);
    var _useState = (0, $3ZYaX.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $3ZYaX.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $3ZYaX.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $e352b643f6267c8a$export$2e2bcd8739ae039)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $3ZYaX.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $3ZYaX.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $3ZYaX.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $3ZYaX.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}




var $3ZYaX = parcelRequire("3ZYaX");


function $7fd886c94dd8d074$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



function $c42b4f5f03eb3eda$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $bb746f9ebb1e36ee$export$2e2bcd8739ae039)(descriptor.key), descriptor);
    }
}
function $c42b4f5f03eb3eda$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $c42b4f5f03eb3eda$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c42b4f5f03eb3eda$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


function $d0b60058bdf2ec04$export$2e2bcd8739ae039(o, p) {
    $d0b60058bdf2ec04$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d0b60058bdf2ec04$export$2e2bcd8739ae039(o, p);
}


function $687ec183e6b89631$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $d0b60058bdf2ec04$export$2e2bcd8739ae039)(subClass, superClass);
}


function $a6f792dafaf91859$export$2e2bcd8739ae039(o) {
    $a6f792dafaf91859$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a6f792dafaf91859$export$2e2bcd8739ae039(o);
}


function $cc9d1154fe649742$export$2e2bcd8739ae039() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $3cb931c9622cfb2b$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $1d23bde76431db9b$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $143ffd39167373a2$export$2e2bcd8739ae039)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(self);
}


function $c20a72ef48ff22ef$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $cc9d1154fe649742$export$2e2bcd8739ae039)();
    return function _createSuperInternal() {
        var Super = (0, $a6f792dafaf91859$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a6f792dafaf91859$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $1d23bde76431db9b$export$2e2bcd8739ae039)(this, result);
    };
}



function $6c2a8d019b6a991c$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $dbb7452b3da79ecc$export$2e2bcd8739ae039)(arr);
}


function $2e21d69a344cf34e$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}



function $26112d14f37d613f$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $a748acfea1e72416$export$2e2bcd8739ae039(arr) {
    return (0, $6c2a8d019b6a991c$export$2e2bcd8739ae039)(arr) || (0, $2e21d69a344cf34e$export$2e2bcd8739ae039)(arr) || (0, $aae924f7e2151cb9$export$2e2bcd8739ae039)(arr) || (0, $26112d14f37d613f$export$2e2bcd8739ae039)();
}



var $3ZYaX = parcelRequire("3ZYaX");


var $0e2e558e98ad0c4d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $0e2e558e98ad0c4d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($0e2e558e98ad0c4d$var$safeIsNaN(first) && $0e2e558e98ad0c4d$var$safeIsNaN(second)) return true;
    return false;
}
function $0e2e558e98ad0c4d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$0e2e558e98ad0c4d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $0e2e558e98ad0c4d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $0e2e558e98ad0c4d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



function $36db34250d735787$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $36db34250d735787$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $36db34250d735787$var$A11yText = function A11yText(props) {
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        css: $36db34250d735787$var$_ref
    }, props));
};
var $36db34250d735787$var$A11yText$1 = $36db34250d735787$var$A11yText;
var $36db34250d735787$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $36db34250d735787$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $3ZYaX.useMemo)(function() {
        return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $36db34250d735787$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $3ZYaX.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $3ZYaX.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $3ZYaX.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $3ZYaX.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $3704582a1888f853$export$c8a8987d4410bf2d)((0, $3ZYaX.Fragment), null, (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", {
        id: "aria-results"
    }, ariaResults), (0, $3704582a1888f853$export$c8a8987d4410bf2d)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)((0, $3ZYaX.Fragment), null, (0, $3704582a1888f853$export$c8a8987d4410bf2d)($36db34250d735787$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $3704582a1888f853$export$c8a8987d4410bf2d)($36db34250d735787$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $36db34250d735787$var$LiveRegion$1 = $36db34250d735787$var$LiveRegion;
var $36db34250d735787$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $36db34250d735787$var$anyDiacritic = new RegExp('[' + $36db34250d735787$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $36db34250d735787$var$diacriticToBase = {};
for(var $36db34250d735787$var$i = 0; $36db34250d735787$var$i < $36db34250d735787$var$diacritics.length; $36db34250d735787$var$i++){
    var $36db34250d735787$var$diacritic = $36db34250d735787$var$diacritics[$36db34250d735787$var$i];
    for(var $36db34250d735787$var$j = 0; $36db34250d735787$var$j < $36db34250d735787$var$diacritic.letters.length; $36db34250d735787$var$j++)$36db34250d735787$var$diacriticToBase[$36db34250d735787$var$diacritic.letters[$36db34250d735787$var$j]] = $36db34250d735787$var$diacritic.base;
}
var $36db34250d735787$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($36db34250d735787$var$anyDiacritic, function(match) {
        return $36db34250d735787$var$diacriticToBase[match];
    });
};
var $36db34250d735787$var$memoizedStripDiacriticsForInput = (0, $0e2e558e98ad0c4d$export$2e2bcd8739ae039)($36db34250d735787$var$stripDiacritics);
var $36db34250d735787$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $36db34250d735787$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $36db34250d735787$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $36db34250d735787$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $36db34250d735787$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $36db34250d735787$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $36db34250d735787$var$memoizedStripDiacriticsForInput(input);
            candidate = $36db34250d735787$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $36db34250d735787$var$_excluded = [
    "innerRef"
];
function $36db34250d735787$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref, $36db34250d735787$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $a837bdaa510c8cc6$export$43caf9889c228507)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("input", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $3704582a1888f853$export$dbf350e5966cf602)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $36db34250d735787$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $36db34250d735787$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $3ZYaX.useRef)(false);
    var isTop = (0, $3ZYaX.useRef)(false);
    var touchStart = (0, $3ZYaX.useRef)(0);
    var scrollTarget = (0, $3ZYaX.useRef)(null);
    var handleEventDelta = (0, $3ZYaX.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $36db34250d735787$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $3ZYaX.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $3ZYaX.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $3ZYaX.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $3ZYaX.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $a837bdaa510c8cc6$export$2408f22a0fab9ae5) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $3ZYaX.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $36db34250d735787$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $36db34250d735787$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $36db34250d735787$var$preventTouchMove(e) {
    e.preventDefault();
}
function $36db34250d735787$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $36db34250d735787$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $36db34250d735787$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $36db34250d735787$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $36db34250d735787$var$activeScrollLocks = 0;
var $36db34250d735787$var$listenerOptions = {
    capture: false,
    passive: false
};
function $36db34250d735787$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $3ZYaX.useRef)({});
    var scrollTarget = (0, $3ZYaX.useRef)(null);
    var addScrollLock = (0, $3ZYaX.useCallback)(function(touchScrollTarget) {
        if (!$36db34250d735787$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $36db34250d735787$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $36db34250d735787$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($36db34250d735787$var$LOCK_STYLES).forEach(function(key) {
                var val = $36db34250d735787$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $36db34250d735787$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $36db34250d735787$var$preventTouchMove, $36db34250d735787$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $36db34250d735787$var$preventInertiaScroll, $36db34250d735787$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $36db34250d735787$var$allowTouchMove, $36db34250d735787$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $36db34250d735787$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $3ZYaX.useCallback)(function(touchScrollTarget) {
        if (!$36db34250d735787$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $36db34250d735787$var$activeScrollLocks = Math.max($36db34250d735787$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $36db34250d735787$var$activeScrollLocks < 1) $36db34250d735787$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $36db34250d735787$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $36db34250d735787$var$preventTouchMove, $36db34250d735787$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $36db34250d735787$var$preventInertiaScroll, $36db34250d735787$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $36db34250d735787$var$allowTouchMove, $36db34250d735787$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $3ZYaX.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $36db34250d735787$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $36db34250d735787$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $36db34250d735787$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $36db34250d735787$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $36db34250d735787$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $36db34250d735787$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)((0, $3ZYaX.Fragment), null, lockEnabled && (0, $3704582a1888f853$export$c8a8987d4410bf2d)("div", {
        onClick: $36db34250d735787$var$blurSelectInput,
        css: $36db34250d735787$var$_ref2$1
    }), children(targetRef));
}
function $36db34250d735787$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $36db34250d735787$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $36db34250d735787$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $3704582a1888f853$export$c8a8987d4410bf2d)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $36db34250d735787$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $36db34250d735787$var$RequiredInput$1 = $36db34250d735787$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $36db34250d735787$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $36db34250d735787$var$isIPhone() {
    return $36db34250d735787$var$testPlatform(/^iPhone/i);
}
function $36db34250d735787$var$isMac() {
    return $36db34250d735787$var$testPlatform(/^Mac/i);
}
function $36db34250d735787$var$isIPad() {
    return $36db34250d735787$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $36db34250d735787$var$isMac() && navigator.maxTouchPoints > 1;
}
function $36db34250d735787$var$isIOS() {
    return $36db34250d735787$var$isIPhone() || $36db34250d735787$var$isIPad();
}
function $36db34250d735787$var$isAppleDevice() {
    return $36db34250d735787$var$isMac() || $36db34250d735787$var$isIOS();
}
var $36db34250d735787$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $36db34250d735787$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $36db34250d735787$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $36db34250d735787$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $36db34250d735787$var$defaultStyles = {
    clearIndicator: (0, $a837bdaa510c8cc6$export$407448d2b89b1813),
    container: (0, $a837bdaa510c8cc6$export$8b22cf2602fb60ce),
    control: (0, $a837bdaa510c8cc6$export$4368d992c4eafac0),
    dropdownIndicator: (0, $a837bdaa510c8cc6$export$f1e1789686576879),
    group: (0, $a837bdaa510c8cc6$export$39b482c5e57630a8),
    groupHeading: (0, $a837bdaa510c8cc6$export$2d1720544b23b823),
    indicatorsContainer: (0, $a837bdaa510c8cc6$export$23f2a1d2818174ef),
    indicatorSeparator: (0, $a837bdaa510c8cc6$export$dda1d9f60106f0e9),
    input: (0, $a837bdaa510c8cc6$export$35e795649ee09318),
    loadingIndicator: (0, $a837bdaa510c8cc6$export$882b5998b3b9117c),
    loadingMessage: (0, $a837bdaa510c8cc6$export$342063e11d6c3cad),
    menu: (0, $a837bdaa510c8cc6$export$953cecd6e717a553),
    menuList: (0, $a837bdaa510c8cc6$export$7ccc53e8f1e7dfc5),
    menuPortal: (0, $a837bdaa510c8cc6$export$ae1af26003f05816),
    multiValue: (0, $a837bdaa510c8cc6$export$ffb5f4729a158638),
    multiValueLabel: (0, $a837bdaa510c8cc6$export$9e5f44173e64f162),
    multiValueRemove: (0, $a837bdaa510c8cc6$export$625550452a3fa3ec),
    noOptionsMessage: (0, $a837bdaa510c8cc6$export$3b14a55fb2447963),
    option: (0, $a837bdaa510c8cc6$export$90a7f3efeed30595),
    placeholder: (0, $a837bdaa510c8cc6$export$efccba1c4a2ef57b),
    singleValue: (0, $a837bdaa510c8cc6$export$d141bba7fdc215a3),
    valueContainer: (0, $a837bdaa510c8cc6$export$4a5767248b18ef41)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $36db34250d735787$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $36db34250d735787$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $36db34250d735787$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $36db34250d735787$var$baseUnit = 4;
// The minimum height of the control
var $36db34250d735787$var$controlHeight = 38;
// The amount of space between the control and menu */
var $36db34250d735787$var$menuGutter = $36db34250d735787$var$baseUnit * 2;
var $36db34250d735787$var$spacing = {
    baseUnit: $36db34250d735787$var$baseUnit,
    controlHeight: $36db34250d735787$var$controlHeight,
    menuGutter: $36db34250d735787$var$menuGutter
};
var $36db34250d735787$export$4368d992c4eafac0 = {
    borderRadius: $36db34250d735787$var$borderRadius,
    colors: $36db34250d735787$var$colors,
    spacing: $36db34250d735787$var$spacing
};
var $36db34250d735787$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $a837bdaa510c8cc6$export$df995fae86a55f06)(),
    captureMenuScroll: !(0, $a837bdaa510c8cc6$export$df995fae86a55f06)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $36db34250d735787$export$db3b6bfb95261072(),
    formatGroupLabel: $36db34250d735787$var$formatGroupLabel,
    getOptionLabel: $36db34250d735787$export$8b22cf2602fb60ce,
    getOptionValue: $36db34250d735787$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $36db34250d735787$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $a837bdaa510c8cc6$export$ebd11618f299a286)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $36db34250d735787$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $36db34250d735787$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $36db34250d735787$var$_isOptionSelected(props, option, selectValue);
    var label = $36db34250d735787$var$getOptionLabel(props, option);
    var value = $36db34250d735787$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $36db34250d735787$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $36db34250d735787$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $36db34250d735787$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $36db34250d735787$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $36db34250d735787$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $a837bdaa510c8cc6$export$3466f893ebf79586));
}
function $36db34250d735787$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $a748acfea1e72416$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $36db34250d735787$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $a748acfea1e72416$export$2e2bcd8739ae039)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $36db34250d735787$var$buildFocusableOptions(props, selectValue) {
    return $36db34250d735787$var$buildFocusableOptionsFromCategorizedOptions($36db34250d735787$var$buildCategorizedOptions(props, selectValue));
}
function $36db34250d735787$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$36db34250d735787$var$shouldHideSelectedOptions(props) || !isSelected) && $36db34250d735787$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $36db34250d735787$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $36db34250d735787$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $36db34250d735787$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $36db34250d735787$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $36db34250d735787$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $36db34250d735787$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $36db34250d735787$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $36db34250d735787$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $36db34250d735787$var$getOptionValue(props, i) === candidate;
    });
}
function $36db34250d735787$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $36db34250d735787$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $36db34250d735787$var$instanceId = 1;
var $36db34250d735787$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(Select, _Component);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $36db34250d735787$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $a837bdaa510c8cc6$export$ef35774e6d314e91)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $a837bdaa510c8cc6$export$ef35774e6d314e91)([].concat((0, $a748acfea1e72416$export$2e2bcd8739ae039)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $a837bdaa510c8cc6$export$e7094788287c5e9b)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $a837bdaa510c8cc6$export$e7094788287c5e9b)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $a837bdaa510c8cc6$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $a837bdaa510c8cc6$export$96f57966bedc81b4)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $a837bdaa510c8cc6$export$96f57966bedc81b4)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $36db34250d735787$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $36db34250d735787$var$buildFocusableOptionsWithIds($36db34250d735787$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $a837bdaa510c8cc6$export$a9c23c6ac3fc3eca).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $36db34250d735787$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $36db34250d735787$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $36db34250d735787$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $a837bdaa510c8cc6$export$d66501df72047452)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $36db34250d735787$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $36db34250d735787$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $a837bdaa510c8cc6$export$2329c99376c9d0a4)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $36db34250d735787$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$36db34250d735787$var$instanceId);
        _this.state.selectValue = (0, $a837bdaa510c8cc6$export$7f8ddf7c7c20b3cd)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $36db34250d735787$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $a837bdaa510c8cc6$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $a837bdaa510c8cc6$export$9bb611d729802a56)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $36db34250d735787$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($36db34250d735787$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, $36db34250d735787$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $36db34250d735787$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $36db34250d735787$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $36db34250d735787$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $3ZYaX.createElement($36db34250d735787$var$DummyInput, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $a837bdaa510c8cc6$export$b4171a6734a65d42),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $3ZYaX.createElement(Input, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $3ZYaX.createElement(Placeholder, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $3ZYaX.createElement(MultiValue, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $3ZYaX.createElement(SingleValue, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3ZYaX.createElement(ClearIndicator, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3ZYaX.createElement(LoadingIndicator, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $3ZYaX.createElement(IndicatorSeparator, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $3ZYaX.createElement(DropdownIndicator, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $3ZYaX.createElement(Option, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $3ZYaX.createElement(Group, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $3ZYaX.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $3ZYaX.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $3ZYaX.createElement((0, $a837bdaa510c8cc6$export$3a1a48c8f6ef640e), (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $3ZYaX.createElement(Menu, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $3ZYaX.createElement($36db34250d735787$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $3ZYaX.createElement(MenuList, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $3ZYaX.createElement(MenuPortal, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $3ZYaX.createElement($36db34250d735787$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $3ZYaX.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $3ZYaX.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $3ZYaX.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $3ZYaX.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $3ZYaX.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $3ZYaX.createElement($36db34250d735787$var$LiveRegion$1, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $3ZYaX.createElement(SelectContainer, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $3ZYaX.createElement(Control, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $3ZYaX.createElement(ValueContainer, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $3ZYaX.createElement(IndicatorsContainer, (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $a837bdaa510c8cc6$export$7f8ddf7c7c20b3cd)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $36db34250d735787$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $36db34250d735787$var$buildFocusableOptionsWithIds($36db34250d735787$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $36db34250d735787$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $36db34250d735787$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $36db34250d735787$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $a837bdaa510c8cc6$export$96f57966bedc81b4)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $3ZYaX.Component));
$36db34250d735787$export$25ce5a424b770e84.defaultProps = $36db34250d735787$export$407448d2b89b1813;





var $fc08818016ab411d$exports = {};
var $b3654956c254532f$exports = {};
var $e64bb4f8eee4a21d$exports = {};
var $a2dcb1277f4b9726$exports = {};
function $a2dcb1277f4b9726$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a2dcb1277f4b9726$exports = $a2dcb1277f4b9726$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a2dcb1277f4b9726$exports.__esModule = true, $a2dcb1277f4b9726$exports["default"] = $a2dcb1277f4b9726$exports, $a2dcb1277f4b9726$var$_typeof(o);
}
$a2dcb1277f4b9726$exports = $a2dcb1277f4b9726$var$_typeof, $a2dcb1277f4b9726$exports.__esModule = true, $a2dcb1277f4b9726$exports["default"] = $a2dcb1277f4b9726$exports;


var $e64bb4f8eee4a21d$var$_typeof = $a2dcb1277f4b9726$exports.default;
var $b09a0263f715a48a$exports = {};

var $b09a0263f715a48a$var$_typeof = $a2dcb1277f4b9726$exports.default;
function $b09a0263f715a48a$var$_toPrimitive(input, hint) {
    if ($b09a0263f715a48a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($b09a0263f715a48a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
$b09a0263f715a48a$exports = $b09a0263f715a48a$var$_toPrimitive, $b09a0263f715a48a$exports.__esModule = true, $b09a0263f715a48a$exports["default"] = $b09a0263f715a48a$exports;


function $e64bb4f8eee4a21d$var$_toPropertyKey(arg) {
    var key = $b09a0263f715a48a$exports(arg, "string");
    return $e64bb4f8eee4a21d$var$_typeof(key) === "symbol" ? key : String(key);
}
$e64bb4f8eee4a21d$exports = $e64bb4f8eee4a21d$var$_toPropertyKey, $e64bb4f8eee4a21d$exports.__esModule = true, $e64bb4f8eee4a21d$exports["default"] = $e64bb4f8eee4a21d$exports;


function $b3654956c254532f$var$_defineProperty(obj, key, value) {
    key = $e64bb4f8eee4a21d$exports(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$b3654956c254532f$exports = $b3654956c254532f$var$_defineProperty, $b3654956c254532f$exports.__esModule = true, $b3654956c254532f$exports["default"] = $b3654956c254532f$exports;


function $fc08818016ab411d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fc08818016ab411d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fc08818016ab411d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b3654956c254532f$exports(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fc08818016ab411d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
$fc08818016ab411d$exports = $fc08818016ab411d$var$_objectSpread2, $fc08818016ab411d$exports.__esModule = true, $fc08818016ab411d$exports["default"] = $fc08818016ab411d$exports;


var $ed9278a0627cdf46$exports = {};
var $9a5f210b1227343f$exports = {};
function $9a5f210b1227343f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
$9a5f210b1227343f$exports = $9a5f210b1227343f$var$_arrayWithHoles, $9a5f210b1227343f$exports.__esModule = true, $9a5f210b1227343f$exports["default"] = $9a5f210b1227343f$exports;


var $29c034ab9755a1d5$exports = {};
function $29c034ab9755a1d5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$29c034ab9755a1d5$exports = $29c034ab9755a1d5$var$_iterableToArrayLimit, $29c034ab9755a1d5$exports.__esModule = true, $29c034ab9755a1d5$exports["default"] = $29c034ab9755a1d5$exports;


var $1c18a5564b043e0e$exports = {};
var $f2b2e12eb0f6722a$exports = {};
function $f2b2e12eb0f6722a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$f2b2e12eb0f6722a$exports = $f2b2e12eb0f6722a$var$_arrayLikeToArray, $f2b2e12eb0f6722a$exports.__esModule = true, $f2b2e12eb0f6722a$exports["default"] = $f2b2e12eb0f6722a$exports;


function $1c18a5564b043e0e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f2b2e12eb0f6722a$exports(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f2b2e12eb0f6722a$exports(o, minLen);
}
$1c18a5564b043e0e$exports = $1c18a5564b043e0e$var$_unsupportedIterableToArray, $1c18a5564b043e0e$exports.__esModule = true, $1c18a5564b043e0e$exports["default"] = $1c18a5564b043e0e$exports;


var $9bd34006b8ea063d$exports = {};
function $9bd34006b8ea063d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$9bd34006b8ea063d$exports = $9bd34006b8ea063d$var$_nonIterableRest, $9bd34006b8ea063d$exports.__esModule = true, $9bd34006b8ea063d$exports["default"] = $9bd34006b8ea063d$exports;


function $ed9278a0627cdf46$var$_slicedToArray(arr, i) {
    return $9a5f210b1227343f$exports(arr) || $29c034ab9755a1d5$exports(arr, i) || $1c18a5564b043e0e$exports(arr, i) || $9bd34006b8ea063d$exports();
}
$ed9278a0627cdf46$exports = $ed9278a0627cdf46$var$_slicedToArray, $ed9278a0627cdf46$exports.__esModule = true, $ed9278a0627cdf46$exports["default"] = $ed9278a0627cdf46$exports;


var $93f6a389213fd5f9$exports = {};
var $972ad561d3873856$exports = {};
function $972ad561d3873856$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
$972ad561d3873856$exports = $972ad561d3873856$var$_objectWithoutPropertiesLoose, $972ad561d3873856$exports.__esModule = true, $972ad561d3873856$exports["default"] = $972ad561d3873856$exports;


function $93f6a389213fd5f9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $972ad561d3873856$exports(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
$93f6a389213fd5f9$exports = $93f6a389213fd5f9$var$_objectWithoutProperties, $93f6a389213fd5f9$exports.__esModule = true, $93f6a389213fd5f9$exports["default"] = $93f6a389213fd5f9$exports;


var $e3269de6da3a10d2$exports = {};
function $e3269de6da3a10d2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$e3269de6da3a10d2$exports = $e3269de6da3a10d2$var$_classCallCheck, $e3269de6da3a10d2$exports.__esModule = true, $e3269de6da3a10d2$exports["default"] = $e3269de6da3a10d2$exports;


var $4227f7808755bb7e$exports = {};

function $4227f7808755bb7e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e64bb4f8eee4a21d$exports(descriptor.key), descriptor);
    }
}
function $4227f7808755bb7e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4227f7808755bb7e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4227f7808755bb7e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
$4227f7808755bb7e$exports = $4227f7808755bb7e$var$_createClass, $4227f7808755bb7e$exports.__esModule = true, $4227f7808755bb7e$exports["default"] = $4227f7808755bb7e$exports;


var $b7b26674b04053b3$exports = {};
var $14fe4e34a827eb02$exports = {};
function $14fe4e34a827eb02$var$_setPrototypeOf(o, p) {
    $14fe4e34a827eb02$exports = $14fe4e34a827eb02$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, $14fe4e34a827eb02$exports.__esModule = true, $14fe4e34a827eb02$exports["default"] = $14fe4e34a827eb02$exports;
    return $14fe4e34a827eb02$var$_setPrototypeOf(o, p);
}
$14fe4e34a827eb02$exports = $14fe4e34a827eb02$var$_setPrototypeOf, $14fe4e34a827eb02$exports.__esModule = true, $14fe4e34a827eb02$exports["default"] = $14fe4e34a827eb02$exports;


function $b7b26674b04053b3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $14fe4e34a827eb02$exports(subClass, superClass);
}
$b7b26674b04053b3$exports = $b7b26674b04053b3$var$_inherits, $b7b26674b04053b3$exports.__esModule = true, $b7b26674b04053b3$exports["default"] = $b7b26674b04053b3$exports;


var $9ffe2581605944ab$exports = {};
var $ec04cfe036dbee44$exports = {};
function $ec04cfe036dbee44$var$_getPrototypeOf(o) {
    $ec04cfe036dbee44$exports = $ec04cfe036dbee44$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, $ec04cfe036dbee44$exports.__esModule = true, $ec04cfe036dbee44$exports["default"] = $ec04cfe036dbee44$exports;
    return $ec04cfe036dbee44$var$_getPrototypeOf(o);
}
$ec04cfe036dbee44$exports = $ec04cfe036dbee44$var$_getPrototypeOf, $ec04cfe036dbee44$exports.__esModule = true, $ec04cfe036dbee44$exports["default"] = $ec04cfe036dbee44$exports;


var $09a982dea3904c98$exports = {};
function $09a982dea3904c98$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
$09a982dea3904c98$exports = $09a982dea3904c98$var$_isNativeReflectConstruct, $09a982dea3904c98$exports.__esModule = true, $09a982dea3904c98$exports["default"] = $09a982dea3904c98$exports;


var $4b8ec19fc32beeda$exports = {};

var $4b8ec19fc32beeda$var$_typeof = $a2dcb1277f4b9726$exports.default;
var $997fc5772ac9cf17$exports = {};
function $997fc5772ac9cf17$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$997fc5772ac9cf17$exports = $997fc5772ac9cf17$var$_assertThisInitialized, $997fc5772ac9cf17$exports.__esModule = true, $997fc5772ac9cf17$exports["default"] = $997fc5772ac9cf17$exports;


function $4b8ec19fc32beeda$var$_possibleConstructorReturn(self, call) {
    if (call && ($4b8ec19fc32beeda$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $997fc5772ac9cf17$exports(self);
}
$4b8ec19fc32beeda$exports = $4b8ec19fc32beeda$var$_possibleConstructorReturn, $4b8ec19fc32beeda$exports.__esModule = true, $4b8ec19fc32beeda$exports["default"] = $4b8ec19fc32beeda$exports;


function $9ffe2581605944ab$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $09a982dea3904c98$exports();
    return function _createSuperInternal() {
        var Super = $ec04cfe036dbee44$exports(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ec04cfe036dbee44$exports(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $4b8ec19fc32beeda$exports(this, result);
    };
}
$9ffe2581605944ab$exports = $9ffe2581605944ab$var$_createSuper, $9ffe2581605944ab$exports.__esModule = true, $9ffe2581605944ab$exports["default"] = $9ffe2581605944ab$exports;


var $becb4202d2056ab1$exports = {};
var $e814cee13ec3618b$exports = {};

function $e814cee13ec3618b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f2b2e12eb0f6722a$exports(arr);
}
$e814cee13ec3618b$exports = $e814cee13ec3618b$var$_arrayWithoutHoles, $e814cee13ec3618b$exports.__esModule = true, $e814cee13ec3618b$exports["default"] = $e814cee13ec3618b$exports;


var $4aadc730f87c2fd9$exports = {};
function $4aadc730f87c2fd9$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$4aadc730f87c2fd9$exports = $4aadc730f87c2fd9$var$_iterableToArray, $4aadc730f87c2fd9$exports.__esModule = true, $4aadc730f87c2fd9$exports["default"] = $4aadc730f87c2fd9$exports;



var $7dad82c3d9828af9$exports = {};
function $7dad82c3d9828af9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$7dad82c3d9828af9$exports = $7dad82c3d9828af9$var$_nonIterableSpread, $7dad82c3d9828af9$exports.__esModule = true, $7dad82c3d9828af9$exports["default"] = $7dad82c3d9828af9$exports;


function $becb4202d2056ab1$var$_toConsumableArray(arr) {
    return $e814cee13ec3618b$exports(arr) || $4aadc730f87c2fd9$exports(arr) || $1c18a5564b043e0e$exports(arr) || $7dad82c3d9828af9$exports();
}
$becb4202d2056ab1$exports = $becb4202d2056ab1$var$_toConsumableArray, $becb4202d2056ab1$exports.__esModule = true, $becb4202d2056ab1$exports["default"] = $becb4202d2056ab1$exports;




var $ef8218723e5f7dcb$exports = {};
function $ef8218723e5f7dcb$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
$ef8218723e5f7dcb$exports = $ef8218723e5f7dcb$var$_taggedTemplateLiteral, $ef8218723e5f7dcb$exports.__esModule = true, $ef8218723e5f7dcb$exports["default"] = $ef8218723e5f7dcb$exports;



parcelRequire("1rKN8");


var $950556e92d8df5c6$var$StateManagedSelect = /*#__PURE__*/ (0, $3ZYaX.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $29c765b91408f8b0$export$3b14a55fb2447963)(props);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $36db34250d735787$export$25ce5a424b770e84), (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        ref: ref
    }, baseSelectProps));
});
var $950556e92d8df5c6$export$2e2bcd8739ae039 = $950556e92d8df5c6$var$StateManagedSelect;
var $950556e92d8df5c6$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $3ZYaX.useMemo)(function() {
        return (0, $6db6ea46e2b48da7$export$2e2bcd8739ae039)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $e18b585dd2832fc3$export$e7094788287c5e9b), {
        value: emotionCache
    }, children);
};


const $c90ab88e1e4f22ae$var$TextOption = (props)=>{
    props.innerProps['data-test'] = `${props.innerProps['data-test']}-${props.data.value}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a837bdaa510c8cc6$export$db3b6bfb95261072).Option, {
        ...props,
        children: props.data.label
    });
};
const $c90ab88e1e4f22ae$var$ClearIndicator = (props)=>{
    props.innerProps['data-test'] = `${props.innerProps['data-test']}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a837bdaa510c8cc6$export$db3b6bfb95261072).ClearIndicator, {
        ...props
    });
};
const $c90ab88e1e4f22ae$var$addDataTest = (Component, innerProps)=>(props)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(Component, {
            ...props,
            innerProps: Object.assign({}, props.innerProps, innerProps)
        });
const $c90ab88e1e4f22ae$var$MultiSelectField = (props)=>{
    const { field: field, form: form, options: options, help: help, ...rest } = props;
    const { required: required, disabled: isDisabled } = rest;
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return (field.value || []).map((v)=>options.find((o)=>o.value === v)).filter(Boolean);
    }, [
        options,
        field.value
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: props.label,
        error: form.errors[field.name],
        required: required,
        help: help,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $950556e92d8df5c6$export$2e2bcd8739ae039), {
            value: value,
            isMulti: true,
            name: field.name,
            options: options,
            className: "basic-multi-select",
            classNamePrefix: "select",
            placeholder: "Choisir un ou plusieurs...",
            id: `multi-select-${field.name}`,
            components: {
                Option: $c90ab88e1e4f22ae$var$addDataTest($c90ab88e1e4f22ae$var$TextOption, {
                    'data-test': `multi-select-option-${field.name}`
                }),
                ClearIndicator: $c90ab88e1e4f22ae$var$addDataTest($c90ab88e1e4f22ae$var$ClearIndicator, {
                    'data-test': `multi-select-clear-${field.name}`
                })
            },
            inputId: `multi-select-input-${field.name}`,
            closeMenuOnSelect: false,
            onInputChange: (value)=>{
                props.inputFieldName && form.setFieldValue(props.inputFieldName, value);
                props.onInputChange && props.onInputChange(value);
            },
            filterOption: props.disableDefaultFilter ? ()=>true : undefined,
            onChange: (v)=>form.setFieldValue(field.name, v.map((i)=>i.value)),
            classNames: {
                control: (state)=>state.hasValue ? 'is-not-empty' : 'is-empty'
            },
            isDisabled: isDisabled,
            ...rest
        })
    });
};
var $c90ab88e1e4f22ae$export$2e2bcd8739ae039 = $c90ab88e1e4f22ae$var$MultiSelectField;



var $45f4984a8ab83b0b$var$n = class g {
    static initParams(r, i) {
        return [
            r.replace(/\s+/g, "").toLowerCase(),
            i.replace(/\s+/g, "").toLowerCase()
        ];
    }
    static checkThanosType(r) {
        if (typeof r != "string") throw new Error("first argument should be a string");
    }
    static checkRivalType(r) {
        if (typeof r != "string") throw new Error("second argument should be a string");
    }
    static checkAvengersType(r) {
        if (!Array.isArray(r)) throw new Error("second argument should be an array of strings");
        if (r.find((i)=>typeof i != "string")) throw new Error("second argument should be an array of strings");
    }
    sortMatch(r, i) {
        return g.checkThanosType(r), g.checkAvengersType(i), i.map((t, e)=>({
                member: t,
                index: e,
                rating: this.similarity(r, t)
            })).sort((t, e)=>t.rating - e.rating);
    }
};
var $45f4984a8ab83b0b$var$p = class extends $45f4984a8ab83b0b$var$n {
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        if (!t.length && !e.length) return 1;
        if (!t.length || !e.length) return 0;
        if (t === e) return 1;
        let a = Array.from(new Set(t.split("").concat(e.split("")))), c = this.stringVectorization(t.split(""), a), l = this.stringVectorization(e.split(""), a), [h, s, o] = [
            0,
            0,
            0
        ];
        for(let m = 0; m < c.length; ++m)h += c[m] * l[m], s += c[m] * c[m], o += l[m] * l[m];
        return s = Math.sqrt(s), o = Math.sqrt(o), Number(h) / (s * o);
    }
    distance(r, i) {
        return 1 - this.similarity(r, i);
    }
    stringVectorization(r, i) {
        return i.map((t)=>r.includes(t) ? 1 : 0);
    }
};
var $45f4984a8ab83b0b$var$y = class extends $45f4984a8ab83b0b$var$n {
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i), [a, c] = [
            t.length,
            e.length
        ];
        if (!t.length && !e.length || t === e) return 1;
        if (a < 2 || c < 2) return 0;
        let l = new Map;
        for(let s = 0; s < a - 1; s++){
            let o = t.slice(s, s + 2), m = l.has(o) ? l.get(o) + 1 : 1;
            l.set(o, m);
        }
        let h = 0;
        for(let s = 0; s < c - 1; s++){
            let o = e.slice(s, s + 2), m = l.has(o) ? l.get(o) : 0;
            m > 0 && (l.set(o, m - 1), ++h);
        }
        return 2 * h / (a + c - 2);
    }
    distance(r, i) {
        return 1 - this.similarity(r, i);
    }
};
var $45f4984a8ab83b0b$var$b = class extends $45f4984a8ab83b0b$var$n {
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        if (!t.length && !e.length || t === e) return 1;
        let a = new Set(t.split("").concat(e.split(""))), c = new Set(t.split("").filter((l)=>new Set(e).has(l)));
        return Number(c.size) / a.size;
    }
    distance(r, i) {
        return 1 - this.similarity(r, i);
    }
};
var $45f4984a8ab83b0b$var$d = class extends $45f4984a8ab83b0b$var$n {
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        return !t.length && !e.length ? 1 : 1 - Number(this.distance(t, e)) / Math.max(t.length, e.length);
    }
    distance(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        if (t === e) return 0;
        let [a, c] = [
            t.length,
            e.length
        ];
        if (!a) return c;
        if (!c) return a;
        let l = [
            ...Array(a + 1)
        ].map(()=>Array(c + 1).fill(0));
        for(let s = 0; s <= a; ++s)l[s][0] = s;
        for(let s = 0; s <= c; ++s)l[0][s] = s;
        let h;
        for(let s = 1; s <= a; ++s)for(let o = 1; o <= c; ++o)h = t[s - 1] === e[o - 1] ? 0 : 1, l[s][o] = Math.min(l[s - 1][o] + 1, l[s][o - 1] + 1, l[s - 1][o - 1] + h);
        return l[a][c];
    }
};
var $45f4984a8ab83b0b$var$T = class g extends $45f4984a8ab83b0b$var$n {
    static lcsLength(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i), [a, c] = [
            t.length,
            e.length
        ], l = [
            ...Array(a + 1)
        ].map(()=>Array(c + 1).fill(0));
        for(let h = 1; h <= a; ++h)for(let s = 1; s <= c; ++s)l[h][s] = t[h - 1] === e[s - 1] ? l[h - 1][s - 1] + 1 : Math.max(l[h][s - 1], l[h - 1][s]);
        return l[a][c];
    }
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        return !t.length && !e.length || t === e ? 1 : 2 * g.lcsLength(t, e) / (t.length + e.length);
    }
    distance(r, i) {
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        return t.length + e.length - 2 * g.lcsLength(t, e);
    }
};
var $45f4984a8ab83b0b$var$k = class g extends $45f4984a8ab83b0b$var$n {
    static lcsLength(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = [
            r.length,
            i.length
        ], a = [
            ...Array(t + 1)
        ].map(()=>Array(e + 1).fill(0));
        for(let c = 1; c <= t; ++c)for(let l = 1; l <= e; ++l)a[c][l] = r[c - 1] === i[l - 1] ? a[c - 1][l - 1] + 1 : Math.max(a[c][l - 1], a[c - 1][l]);
        return a[t][e];
    }
    similarity(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        return !t.length && !e.length || t === e ? 1 : Number(g.lcsLength(t, e)) / Math.max(t.length, e.length);
    }
    distance(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        return t === e ? 0 : 1 - this.similarity(t, e);
    }
};
var $45f4984a8ab83b0b$var$x = class extends $45f4984a8ab83b0b$var$n {
    distance(r, i) {
        $45f4984a8ab83b0b$var$n.checkThanosType(r), $45f4984a8ab83b0b$var$n.checkRivalType(i);
        let [t, e] = $45f4984a8ab83b0b$var$n.initParams(r, i);
        if (!t.length && !e.length) return 1;
        if (!t.length || !e.length) return 0;
        if (t === e || t === e) return 1;
        let a = t.length, c = e.length;
        if (a === 0 || c === 0) return 0;
        let l = Math.floor(Math.max(a, c) / 2) - 1, h = 0, s = new Array(t.length).fill(0), o = new Array(e.length).fill(0);
        for(let u = 0; u < a; u++)for(let f = Math.max(0, u - l); f < Math.min(c, u + l + 1); f++)if (t[u] === e[f] && o[f] === 0) {
            s[u] = 1, o[f] = 1, h++;
            break;
        }
        if (h === 0) return 0;
        let m = 0, w = 0;
        for(let u = 0; u < a; u++)if (s[u] === 1) {
            for(; o[w] === 0;)w++;
            t[u] !== e[w++] && m++;
        }
        return m /= 2, (h / a + h / c + (h - m) / h) / 3;
    }
    similarity(r, i) {
        let t = this.distance(r, i);
        if (t > .7) {
            let e = 0;
            for(let a = 0; a < Math.min(r.length, i.length) && r[a] === i[a]; a++)e++;
            e = Math.min(4, e), t += .1 * e * (1 - t);
        }
        return t;
    }
};
var $45f4984a8ab83b0b$var$S = new $45f4984a8ab83b0b$var$p, $45f4984a8ab83b0b$var$A = new $45f4984a8ab83b0b$var$y, $45f4984a8ab83b0b$var$P = new $45f4984a8ab83b0b$var$b, $45f4984a8ab83b0b$var$j = new $45f4984a8ab83b0b$var$d, $45f4984a8ab83b0b$var$M = new $45f4984a8ab83b0b$var$T, $45f4984a8ab83b0b$var$L = $45f4984a8ab83b0b$var$M, $45f4984a8ab83b0b$var$v = new $45f4984a8ab83b0b$var$k, $45f4984a8ab83b0b$var$R = $45f4984a8ab83b0b$var$v, $45f4984a8ab83b0b$var$z = new $45f4984a8ab83b0b$var$x, $45f4984a8ab83b0b$var$C = {
    cosine: $45f4984a8ab83b0b$var$S,
    diceCoefficient: $45f4984a8ab83b0b$var$A,
    jaccardIndex: $45f4984a8ab83b0b$var$P,
    levenshtein: $45f4984a8ab83b0b$var$j,
    lcs: $45f4984a8ab83b0b$var$M,
    longestCommonSubsequence: $45f4984a8ab83b0b$var$L,
    mlcs: $45f4984a8ab83b0b$var$v,
    metricLcs: $45f4984a8ab83b0b$var$R,
    jaroWinkler: $45f4984a8ab83b0b$var$z
}, $45f4984a8ab83b0b$export$2e2bcd8739ae039 = $45f4984a8ab83b0b$var$C;




var $2KSUA = parcelRequire("2KSUA");

/**
 * Calculates a relevance rating for a worker based on search query
 * Uses multiple matching strategies with weighted scoring:
 * - Exact prefix matches get highest priority
 * - Levenshtein similarity for fuzzy matching
 * - Different weights for first name, last name, and full label
 */ const $1fe0f8cc717c9c0f$var$calculateRating = (worker, search, currentOrganization)=>{
    if (!search || search.trim().length === 0) return 0;
    const searchTerm = search.trim().toLowerCase();
    const firstName = worker.firstName.toLowerCase();
    const lastName = worker.lastName.toLowerCase();
    const fullLabel = (0, $25ffbf4bca475b04$export$9a57c514c234d759)(worker).toLowerCase();
    const fullName = `${firstName} ${lastName}`.toLowerCase();
    const internalRef = (0, $25ffbf4bca475b04$export$8e03f956ff6d1de8)(worker, currentOrganization);
    // Exact prefix matches get highest scores
    const firstNameExactPrefix = firstName.startsWith(searchTerm) ? 1.0 : 0;
    const lastNameExactPrefix = lastName.startsWith(searchTerm) ? 1.0 : 0;
    // Fuzzy matching with Levenshtein for non-exact matches
    const firstNameFuzzy = firstNameExactPrefix === 0 ? (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).levenshtein.similarity(searchTerm, firstName) : 0;
    const lastNameFuzzy = lastNameExactPrefix === 0 ? (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).levenshtein.similarity(searchTerm, lastName) : 0;
    const fullNameFuzzy = (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).levenshtein.similarity(searchTerm, fullName);
    // Full label similarity for broader context
    const fullLabelFuzzy = (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).levenshtein.similarity(searchTerm, fullLabel);
    // Internal ref similarity for internal ref matches
    const internalRefFuzzy = internalRef ? (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).levenshtein.similarity(searchTerm, internalRef) : 0;
    // Weighted scoring system
    const weights = {
        internalRef: 3.0,
        firstNameExact: 3.0,
        lastNameExact: 3.0,
        firstNameFuzzy: 1.5,
        lastNameFuzzy: 1.5,
        fullNameFuzzy: 2.8,
        fullLabel: 0.8
    };
    // Calculate weighted score
    const score = firstNameExactPrefix * weights.firstNameExact + lastNameExactPrefix * weights.lastNameExact + firstNameFuzzy * weights.firstNameFuzzy + lastNameFuzzy * weights.lastNameFuzzy + fullNameFuzzy * weights.fullNameFuzzy + fullLabelFuzzy * weights.fullLabel + internalRefFuzzy * weights.internalRef;
    // Normalize score to 0-1 range and apply bonus for shorter search terms
    const normalizedScore = Math.min(score / Object.values(weights).reduce((sum, w)=>sum + w, 0), 1.0);
    // Bonus for shorter search terms (more specific matches)
    const lengthBonus = searchTerm.length <= 2 ? 0.1 : 0;
    return Math.min(normalizedScore + lengthBonus, 1.0);
};
const $1fe0f8cc717c9c0f$var$useWorkersSearch = (search, queryOptions, params)=>{
    const workersQuery = (0, $e607e015ac40917d$export$ad43217ee1485bda)(params || {}, {
        staleTime: 180000,
        ...queryOptions || {}
    });
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session?.currentOrganization);
    const fetchedWorkers = workersQuery.data || [];
    const workersWithMatchRating = (0, $2KSUA.sortBy)(fetchedWorkers.map((worker)=>({
            value: worker._id,
            label: (0, $2KSUA.upperFirst)((0, $25ffbf4bca475b04$export$9a57c514c234d759)(worker)),
            rating: $1fe0f8cc717c9c0f$var$calculateRating(worker, search, currentOrganization)
        })), search ? 'rating' : 'label');
    // If no search, return all workers sorted alphabetically
    if (!search) return workersWithMatchRating;
    // For search results, sort by rating (highest first) and filter by relevance
    workersWithMatchRating.reverse();
    // Get the best rating to establish a relevance threshold
    const bestRating = workersWithMatchRating[0]?.rating || 0;
    // Apply intelligent filtering based on search length and relevance
    const limited = workersWithMatchRating.slice(0, 8) // Show more results for better UX
    .filter((match)=>{
        // For very short searches (1-2 chars), be more permissive
        if (search.length <= 2) return match.rating > 0.1 // Accept any meaningful match
        ;
        // For longer searches, require higher relevance
        const relevanceThreshold = bestRating * 0.3 // 30% of best match
        ;
        return match.rating >= relevanceThreshold;
    });
    return limited;
};
var $1fe0f8cc717c9c0f$export$2e2bcd8739ae039 = $1fe0f8cc717c9c0f$var$useWorkersSearch;



parcelRequire("3ZYaX");


var $1005558fe5194d2d$export$f3d0370676bde028 = /*#__PURE__*/ function(OrganizationTypeEnum) {
    OrganizationTypeEnum["interimAgency"] = "interimAgency";
    OrganizationTypeEnum["employer"] = "employer";
    return OrganizationTypeEnum;
}({});
const $1005558fe5194d2d$var$POPULATE = [
    'associations.interimAgency',
    'associations.invitedBy'
];
const $1005558fe5194d2d$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/organizations',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $1005558fe5194d2d$var$POPULATE,
            ...params || {}
        }
    });
const $1005558fe5194d2d$export$85b9a36db797e02b = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/organizations/count',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $1005558fe5194d2d$var$POPULATE,
            ...params || {}
        }
    });
const $1005558fe5194d2d$export$3988ae62b71be9a3 = async (params)=>{
    const { id: id, ...rest } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/organizations/${id}`,
        method: 'get',
        params: {
            populate: [
                'associations.interimAgency',
                'associations.invitedBy'
            ],
            ...rest
        }
    });
};
const $1005558fe5194d2d$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/organizations',
        method: 'post',
        params: params
    });
const $1005558fe5194d2d$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/organizations/${id}`,
        method: 'put',
        params: payload
    });
};
const $1005558fe5194d2d$export$fcc1e1dc79c25712 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/organizations/${params.employerId}/associations`,
        method: 'post',
        params: params
    });
const $1005558fe5194d2d$export$9feaf61c98cee22d = async (params)=>{
    const { employerId: employerId, associationId: associationId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/organizations/${employerId}/associations/${associationId}`,
        method: 'put',
        params: payload
    });
};


const $aa91c600f51fee77$var$WorkerLabel = ({ plural: plural, potentialPlural: potentialPlural, label: label, lowercase: lowercase })=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    let text = label || (currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency ? "Int\xe9rimaire" : 'Travailleur');
    if (plural) text += 's';
    else if (potentialPlural) text += '(s)';
    if (lowercase) text = text.toLowerCase();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: text
    });
};
var $aa91c600f51fee77$export$2e2bcd8739ae039 = $aa91c600f51fee77$var$WorkerLabel;


const $992ecbd31670e2eb$var$WorkersFilterField = ({ disabledQueries: disabledQueries })=>{
    const [workersSearchString, setWorkersSearchString] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('');
    const workers = (0, $1fe0f8cc717c9c0f$export$2e2bcd8739ae039)(workersSearchString, {
        enabled: !disabledQueries
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {
                plural: true
            }),
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            name: "user",
            onInputChange: setWorkersSearchString,
            options: workers,
            disableDefaultFilter: true
        })
    });
};
var $992ecbd31670e2eb$export$2e2bcd8739ae039 = $992ecbd31670e2eb$var$WorkersFilterField;



parcelRequire("3ZYaX");

parcelRequire("3ZYaX");


const $d612776067feeeac$var$InputField = (props)=>{
    const { field: field, form: form, label: label, help: help, ...rest } = props;
    if (props.field.value === undefined) props.field.value = '';
    const { required: required } = rest;
    // Prevent form submission on Enter key press
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter') e.preventDefault();
    };
    const id = `${field.name}-input`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        help: help,
        error: form.errors[field.name],
        required: required,
        htmlFor: id,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
            ...field,
            ...rest,
            "data-test": props.dataTest ?? rest['data-test'],
            onKeyDown: handleKeyDown,
            onWheel: (e)=>rest.type === 'number' && e.currentTarget.blur(),
            id: id
        })
    });
};
var $d612776067feeeac$export$2e2bcd8739ae039 = $d612776067feeeac$var$InputField;




var $31tXu = parcelRequire("31tXu");
const $ba4a55bdb1b56879$var$WeekFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Semaine",
            name: "week",
            type: "date",
            component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
        })
    });
};
var $ba4a55bdb1b56879$export$2e2bcd8739ae039 = $ba4a55bdb1b56879$var$WeekFilterField;




parcelRequire("3ZYaX");





var $2KSUA = parcelRequire("2KSUA");
/**
 * Wrapper component for filters that adds a reset button
 * @param resource - The resource type for the filters
 * @param children - The filter components to wrap
 * @param preservedFields - Fields to keep at their current value when resetting
 */ const $e05847321a0fbdec$var$FiltersWrapper = ({ resource: resource, children: children, preservedFields: preservedFields = [] })=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)(resource);
    /**
   * Resets the filters to their initial state from the store
   */ const handleReset = ()=>{
        const initialFilterValues = (0, $7093b8da8664ce76$export$6ca32c220786ee65)[resource];
        const currentFilterValues = filters;
        // Keep ignored fields at their current value
        const resetValues = {
            ...initialFilterValues,
            ...preservedFields.reduce((acc, field)=>{
                acc[field] = currentFilterValues[field];
                return acc;
            }, {})
        };
        setFilters(resource, resetValues);
    };
    /**
   * Checks if all non-preserved fields are at their initial values
   * @returns true if all non-preserved fields match their initial values
   */ const isCurrentValueIsInitial = Object.keys(filters).every((field)=>{
        // Skip preserved fields in the comparison
        if (preservedFields.includes(field)) return true;
        return (0, $2KSUA.isEqual)(filters[field], (0, $7093b8da8664ce76$export$6ca32c220786ee65)[resource][field]);
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        style: {
            position: 'relative',
            width: '100%'
        },
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                style: {
                    width: '100%'
                },
                children: children
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                style: {
                    position: 'absolute',
                    right: 0,
                    top: 6
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                    onClick: handleReset,
                    "data-test": "reset-filters-button",
                    size: "small",
                    disabled: isCurrentValueIsInitial,
                    color: isCurrentValueIsInitial ? 'default' : 'primary',
                    outlined: !isCurrentValueIsInitial,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            children: "R\xe9initialiser les filtres"
                        })
                    ]
                })
            })
        ]
    });
};
var $e05847321a0fbdec$export$2e2bcd8739ae039 = $e05847321a0fbdec$var$FiltersWrapper;


const $e11b6f75fdbe3ac4$var$ClockingsFilters = ({})=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).clockings);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...filters,
            week: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(filters.start ? new Date(filters.start) : new Date())
        },
        onSubmit: (values)=>{
            if (values.week) {
                const dates = (0, $74f17ceb9b5a08a5$export$217584d147ca6846)(values.week);
                if (dates) values = {
                    ...values,
                    ...dates
                };
            }
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).clockings, values);
        },
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).clockings,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ba4a55bdb1b56879$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $992ecbd31670e2eb$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $e11b6f75fdbe3ac4$export$2e2bcd8739ae039 = $e11b6f75fdbe3ac4$var$ClockingsFilters;





parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

const $bb3d4b045c8b02e8$var$PageTitle = ({ title: title, subTitle: subTitle, children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            title && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 3,
                        textWeight: "bold",
                        "data-test": "page-title-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        subtitle: true,
                        size: 6,
                        "data-test": "page-title-subtitle",
                        children: subTitle
                    })
                ]
            }),
            children && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mt: 2,
                children: children
            })
        ]
    });
};
var $bb3d4b045c8b02e8$export$2e2bcd8739ae039 = $bb3d4b045c8b02e8$var$PageTitle;



parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");
function $4b2651edb550ad92$var$LoginIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
    }));
}
const $4b2651edb550ad92$var$ForwardRef = $3ZYaX.forwardRef($4b2651edb550ad92$var$LoginIcon);
var $4b2651edb550ad92$export$2e2bcd8739ae039 = $4b2651edb550ad92$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $caeeafb1d4a1f971$var$LogoutIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    }));
}
const $caeeafb1d4a1f971$var$ForwardRef = $3ZYaX.forwardRef($caeeafb1d4a1f971$var$LogoutIcon);
var $caeeafb1d4a1f971$export$2e2bcd8739ae039 = $caeeafb1d4a1f971$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $d0a62919ab5d714a$var$SparklesIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
    }));
}
const $d0a62919ab5d714a$var$ForwardRef = $3ZYaX.forwardRef($d0a62919ab5d714a$var$SparklesIcon);
var $d0a62919ab5d714a$export$2e2bcd8739ae039 = $d0a62919ab5d714a$var$ForwardRef;




var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");

const $9e4f6dc667a577f4$export$c5bd0e29fdd0ade0 = ()=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const pendingEmployerInvitationsCount = (0, $3ZYaX.useMemo)(()=>{
        if (!currentOrganization || currentOrganization.type !== 'employer') return 0;
        const organization = currentOrganization;
        return organization.associations.reduce((acc, association)=>{
            if (association.status === 'pending') return acc + 1;
            return acc;
        }, 0);
    }, [
        currentOrganization
    ]);
    return pendingEmployerInvitationsCount;
};



var $3ZYaX = parcelRequire("3ZYaX");

const $8cf00e93f034ffc8$export$160ed609bc8ffc2b = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const pendingInvitationsCount = (0, $3ZYaX.useMemo)(()=>{
        if (!currentUser) return 0;
        return currentUser.roles.reduce((acc, role)=>{
            if (role.status === 'pending' && role.kind !== 'worker') return acc + 1;
            return acc;
        }, 0) + currentUser.associations.reduce((acc, role)=>{
            if (role.status === 'pending') return acc + 1;
            return acc;
        }, 0);
    }, [
        currentUser
    ]);
    return pendingInvitationsCount;
};


var $dc4d8e29ac375220$exports = {};
$dc4d8e29ac375220$exports = new URL("team-tim-avatar.53775525.webp", import.meta.url).toString();


//TODO: To be transformed into namespaces when using an i18n lib
var $327d1e69b5a090c1$export$2e2bcd8739ae039 = {
    users: {
        roles: {
            superAdmin: 'Super Admin',
            worker: 'Travailleur',
            interimAgencyMember: "Gestionnaire",
            employerMember: "Gestionnaire"
        }
    },
    organizations: {
        type: {
            interimAgency: "Agence d'Int\xe9rim",
            employer: 'Employeur'
        }
    },
    clockings: {
        theoritical: "L'Heure Th\xe9orique",
        clocking: 'Le Pointage'
    },
    resources: {
        missions: 'Missions',
        workersRequests: 'Demandes de Personnel',
        preBillings: "Pr\xe9-facturations",
        periodSummaries: "Pr\xe9-facturations",
        clockings: 'Pointages',
        workers: 'Travailleurs'
    }
};



const $1188dab5edd92185$var$roleColorHandles = {
    superAdmin: 'super-admin',
    interimAgencyMember: 'interim-agency',
    interimAgency: 'interim-agency',
    worker: 'worker',
    employerMember: 'employer',
    employer: 'employer'
};
const $1188dab5edd92185$export$92ca3e0143f2ea33 = (role)=>{
    return $1188dab5edd92185$var$roleColorHandles[role];
};




var $3ZYaX = parcelRequire("3ZYaX");


var $08de374e827f3ad7$exports = {};
var $fd5568a8241be73a$exports = {};
var $b8e7b46153274434$exports = {};
var $e444dedd49ee0489$exports = {};
var $39cc8fdcacbfee68$exports = {};
var $9f936cd24433b096$exports = {};
var $d94782b233b4e8fa$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $d94782b233b4e8fa$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$d94782b233b4e8fa$exports = $d94782b233b4e8fa$var$listCacheClear;


var $296c340148c0571c$exports = {};
var $9906ce3cb6b449d1$exports = {};
var $8b43bb409bcd8608$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $8b43bb409bcd8608$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$8b43bb409bcd8608$exports = $8b43bb409bcd8608$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $9906ce3cb6b449d1$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($8b43bb409bcd8608$exports(array[length][0], key)) return length;
    }
    return -1;
}
$9906ce3cb6b449d1$exports = $9906ce3cb6b449d1$var$assocIndexOf;


/** Used for built-in method references. */ var $296c340148c0571c$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $296c340148c0571c$var$splice = $296c340148c0571c$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $296c340148c0571c$var$listCacheDelete(key) {
    var data = this.__data__, index = $9906ce3cb6b449d1$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $296c340148c0571c$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$296c340148c0571c$exports = $296c340148c0571c$var$listCacheDelete;


var $5fe3972882c7ebc9$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5fe3972882c7ebc9$var$listCacheGet(key) {
    var data = this.__data__, index = $9906ce3cb6b449d1$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$5fe3972882c7ebc9$exports = $5fe3972882c7ebc9$var$listCacheGet;


var $794628d581168d5b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $794628d581168d5b$var$listCacheHas(key) {
    return $9906ce3cb6b449d1$exports(this.__data__, key) > -1;
}
$794628d581168d5b$exports = $794628d581168d5b$var$listCacheHas;


var $0a77044ad9f527c5$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a77044ad9f527c5$var$listCacheSet(key, value) {
    var data = this.__data__, index = $9906ce3cb6b449d1$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0a77044ad9f527c5$exports = $0a77044ad9f527c5$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9f936cd24433b096$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$9f936cd24433b096$var$ListCache.prototype.clear = $d94782b233b4e8fa$exports;
$9f936cd24433b096$var$ListCache.prototype['delete'] = $296c340148c0571c$exports;
$9f936cd24433b096$var$ListCache.prototype.get = $5fe3972882c7ebc9$exports;
$9f936cd24433b096$var$ListCache.prototype.has = $794628d581168d5b$exports;
$9f936cd24433b096$var$ListCache.prototype.set = $0a77044ad9f527c5$exports;
$9f936cd24433b096$exports = $9f936cd24433b096$var$ListCache;


var $5781727751490a5b$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $5781727751490a5b$var$stackClear() {
    this.__data__ = new $9f936cd24433b096$exports;
    this.size = 0;
}
$5781727751490a5b$exports = $5781727751490a5b$var$stackClear;


var $3c4fef44089c4d79$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3c4fef44089c4d79$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$3c4fef44089c4d79$exports = $3c4fef44089c4d79$var$stackDelete;


var $ee4cd0317cae6b35$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ee4cd0317cae6b35$var$stackGet(key) {
    return this.__data__.get(key);
}
$ee4cd0317cae6b35$exports = $ee4cd0317cae6b35$var$stackGet;


var $93de97fff9261881$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $93de97fff9261881$var$stackHas(key) {
    return this.__data__.has(key);
}
$93de97fff9261881$exports = $93de97fff9261881$var$stackHas;


var $0bc4d2b053f412e8$exports = {};

var $e3a1d6376add8530$exports = {};
var $d6249531a9dae064$exports = {};
var $6ced41ba77c12a67$exports = {};
var $08f69a989e3c33aa$exports = {};
var $9310747326fde40a$exports = {};
var $a9c2ecb930b20196$exports = {};

var $UeyW6 = parcelRequire("UeyW6");
/** Built-in value references. */ var $a9c2ecb930b20196$var$Symbol = $UeyW6.Symbol;
$a9c2ecb930b20196$exports = $a9c2ecb930b20196$var$Symbol;


var $5a298c31b07b4560$exports = {};

/** Used for built-in method references. */ var $5a298c31b07b4560$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $5a298c31b07b4560$var$hasOwnProperty = $5a298c31b07b4560$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5a298c31b07b4560$var$nativeObjectToString = $5a298c31b07b4560$var$objectProto.toString;
/** Built-in value references. */ var $5a298c31b07b4560$var$symToStringTag = $a9c2ecb930b20196$exports ? $a9c2ecb930b20196$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $5a298c31b07b4560$var$getRawTag(value) {
    var isOwn = $5a298c31b07b4560$var$hasOwnProperty.call(value, $5a298c31b07b4560$var$symToStringTag), tag = value[$5a298c31b07b4560$var$symToStringTag];
    try {
        value[$5a298c31b07b4560$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $5a298c31b07b4560$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$5a298c31b07b4560$var$symToStringTag] = tag;
        else delete value[$5a298c31b07b4560$var$symToStringTag];
    }
    return result;
}
$5a298c31b07b4560$exports = $5a298c31b07b4560$var$getRawTag;


var $416ac9bdd99c9af7$exports = {};
/** Used for built-in method references. */ var $416ac9bdd99c9af7$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $416ac9bdd99c9af7$var$nativeObjectToString = $416ac9bdd99c9af7$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $416ac9bdd99c9af7$var$objectToString(value) {
    return $416ac9bdd99c9af7$var$nativeObjectToString.call(value);
}
$416ac9bdd99c9af7$exports = $416ac9bdd99c9af7$var$objectToString;


/** `Object#toString` result references. */ var $9310747326fde40a$var$nullTag = '[object Null]', $9310747326fde40a$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $9310747326fde40a$var$symToStringTag = $a9c2ecb930b20196$exports ? $a9c2ecb930b20196$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $9310747326fde40a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $9310747326fde40a$var$undefinedTag : $9310747326fde40a$var$nullTag;
    return $9310747326fde40a$var$symToStringTag && $9310747326fde40a$var$symToStringTag in Object(value) ? $5a298c31b07b4560$exports(value) : $416ac9bdd99c9af7$exports(value);
}
$9310747326fde40a$exports = $9310747326fde40a$var$baseGetTag;


var $2f639ab8f1a63700$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2f639ab8f1a63700$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$2f639ab8f1a63700$exports = $2f639ab8f1a63700$var$isObject;


/** `Object#toString` result references. */ var $08f69a989e3c33aa$var$asyncTag = '[object AsyncFunction]', $08f69a989e3c33aa$var$funcTag = '[object Function]', $08f69a989e3c33aa$var$genTag = '[object GeneratorFunction]', $08f69a989e3c33aa$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $08f69a989e3c33aa$var$isFunction(value) {
    if (!$2f639ab8f1a63700$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $9310747326fde40a$exports(value);
    return tag == $08f69a989e3c33aa$var$funcTag || tag == $08f69a989e3c33aa$var$genTag || tag == $08f69a989e3c33aa$var$asyncTag || tag == $08f69a989e3c33aa$var$proxyTag;
}
$08f69a989e3c33aa$exports = $08f69a989e3c33aa$var$isFunction;


var $0ce78e4d5f9759b2$exports = {};
var $1a4efaeb3a1c37f6$exports = {};

var $UeyW6 = parcelRequire("UeyW6");
/** Used to detect overreaching core-js shims. */ var $1a4efaeb3a1c37f6$var$coreJsData = $UeyW6["__core-js_shared__"];
$1a4efaeb3a1c37f6$exports = $1a4efaeb3a1c37f6$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $0ce78e4d5f9759b2$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($1a4efaeb3a1c37f6$exports && $1a4efaeb3a1c37f6$exports.keys && $1a4efaeb3a1c37f6$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $0ce78e4d5f9759b2$var$isMasked(func) {
    return !!$0ce78e4d5f9759b2$var$maskSrcKey && $0ce78e4d5f9759b2$var$maskSrcKey in func;
}
$0ce78e4d5f9759b2$exports = $0ce78e4d5f9759b2$var$isMasked;



var $3d444b4e73e3ca1c$exports = {};
/** Used for built-in method references. */ var $3d444b4e73e3ca1c$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3d444b4e73e3ca1c$var$funcToString = $3d444b4e73e3ca1c$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3d444b4e73e3ca1c$var$toSource(func) {
    if (func != null) {
        try {
            return $3d444b4e73e3ca1c$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$3d444b4e73e3ca1c$exports = $3d444b4e73e3ca1c$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6ced41ba77c12a67$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6ced41ba77c12a67$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $6ced41ba77c12a67$var$funcProto = Function.prototype, $6ced41ba77c12a67$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6ced41ba77c12a67$var$funcToString = $6ced41ba77c12a67$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6ced41ba77c12a67$var$hasOwnProperty = $6ced41ba77c12a67$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $6ced41ba77c12a67$var$reIsNative = RegExp('^' + $6ced41ba77c12a67$var$funcToString.call($6ced41ba77c12a67$var$hasOwnProperty).replace($6ced41ba77c12a67$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6ced41ba77c12a67$var$baseIsNative(value) {
    if (!$2f639ab8f1a63700$exports(value) || $0ce78e4d5f9759b2$exports(value)) return false;
    var pattern = $08f69a989e3c33aa$exports(value) ? $6ced41ba77c12a67$var$reIsNative : $6ced41ba77c12a67$var$reIsHostCtor;
    return pattern.test($3d444b4e73e3ca1c$exports(value));
}
$6ced41ba77c12a67$exports = $6ced41ba77c12a67$var$baseIsNative;


var $8278bad5841c642b$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8278bad5841c642b$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$8278bad5841c642b$exports = $8278bad5841c642b$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $d6249531a9dae064$var$getNative(object, key) {
    var value = $8278bad5841c642b$exports(object, key);
    return $6ced41ba77c12a67$exports(value) ? value : undefined;
}
$d6249531a9dae064$exports = $d6249531a9dae064$var$getNative;



var $UeyW6 = parcelRequire("UeyW6");
/* Built-in method references that are verified to be native. */ var $e3a1d6376add8530$var$Map = $d6249531a9dae064$exports($UeyW6, 'Map');
$e3a1d6376add8530$exports = $e3a1d6376add8530$var$Map;


var $f7a9c1de4c7dfddc$exports = {};
var $6a2ce057e5371809$exports = {};
var $37d035a60ddf1968$exports = {};
var $fb732ebdb34eae32$exports = {};
var $ca5ad8cf3f7bda00$exports = {};

/* Built-in method references that are verified to be native. */ var $ca5ad8cf3f7bda00$var$nativeCreate = $d6249531a9dae064$exports(Object, 'create');
$ca5ad8cf3f7bda00$exports = $ca5ad8cf3f7bda00$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $fb732ebdb34eae32$var$hashClear() {
    this.__data__ = $ca5ad8cf3f7bda00$exports ? $ca5ad8cf3f7bda00$exports(null) : {};
    this.size = 0;
}
$fb732ebdb34eae32$exports = $fb732ebdb34eae32$var$hashClear;


var $a813d84cec3e8113$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a813d84cec3e8113$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$a813d84cec3e8113$exports = $a813d84cec3e8113$var$hashDelete;


var $7ae6cd3a586eb21c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $7ae6cd3a586eb21c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $7ae6cd3a586eb21c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7ae6cd3a586eb21c$var$hasOwnProperty = $7ae6cd3a586eb21c$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7ae6cd3a586eb21c$var$hashGet(key) {
    var data = this.__data__;
    if ($ca5ad8cf3f7bda00$exports) {
        var result = data[key];
        return result === $7ae6cd3a586eb21c$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7ae6cd3a586eb21c$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$7ae6cd3a586eb21c$exports = $7ae6cd3a586eb21c$var$hashGet;


var $1d01883ae43090b2$exports = {};

/** Used for built-in method references. */ var $1d01883ae43090b2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1d01883ae43090b2$var$hasOwnProperty = $1d01883ae43090b2$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1d01883ae43090b2$var$hashHas(key) {
    var data = this.__data__;
    return $ca5ad8cf3f7bda00$exports ? data[key] !== undefined : $1d01883ae43090b2$var$hasOwnProperty.call(data, key);
}
$1d01883ae43090b2$exports = $1d01883ae43090b2$var$hashHas;


var $90904fa02495a61c$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $90904fa02495a61c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $90904fa02495a61c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $ca5ad8cf3f7bda00$exports && value === undefined ? $90904fa02495a61c$var$HASH_UNDEFINED : value;
    return this;
}
$90904fa02495a61c$exports = $90904fa02495a61c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $37d035a60ddf1968$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$37d035a60ddf1968$var$Hash.prototype.clear = $fb732ebdb34eae32$exports;
$37d035a60ddf1968$var$Hash.prototype['delete'] = $a813d84cec3e8113$exports;
$37d035a60ddf1968$var$Hash.prototype.get = $7ae6cd3a586eb21c$exports;
$37d035a60ddf1968$var$Hash.prototype.has = $1d01883ae43090b2$exports;
$37d035a60ddf1968$var$Hash.prototype.set = $90904fa02495a61c$exports;
$37d035a60ddf1968$exports = $37d035a60ddf1968$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $6a2ce057e5371809$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $37d035a60ddf1968$exports,
        'map': new ($e3a1d6376add8530$exports || $9f936cd24433b096$exports),
        'string': new $37d035a60ddf1968$exports
    };
}
$6a2ce057e5371809$exports = $6a2ce057e5371809$var$mapCacheClear;


var $4c141b0329ba782f$exports = {};
var $475304b3582b0104$exports = {};
var $04135af7e3ed893a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $04135af7e3ed893a$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$04135af7e3ed893a$exports = $04135af7e3ed893a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $475304b3582b0104$var$getMapData(map, key) {
    var data = map.__data__;
    return $04135af7e3ed893a$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$475304b3582b0104$exports = $475304b3582b0104$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4c141b0329ba782f$var$mapCacheDelete(key) {
    var result = $475304b3582b0104$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$4c141b0329ba782f$exports = $4c141b0329ba782f$var$mapCacheDelete;


var $abf60b6f5ffd1155$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $abf60b6f5ffd1155$var$mapCacheGet(key) {
    return $475304b3582b0104$exports(this, key).get(key);
}
$abf60b6f5ffd1155$exports = $abf60b6f5ffd1155$var$mapCacheGet;


var $3c74074aa779c9f9$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3c74074aa779c9f9$var$mapCacheHas(key) {
    return $475304b3582b0104$exports(this, key).has(key);
}
$3c74074aa779c9f9$exports = $3c74074aa779c9f9$var$mapCacheHas;


var $fe4e5ab95eb05c3e$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $fe4e5ab95eb05c3e$var$mapCacheSet(key, value) {
    var data = $475304b3582b0104$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$fe4e5ab95eb05c3e$exports = $fe4e5ab95eb05c3e$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f7a9c1de4c7dfddc$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$f7a9c1de4c7dfddc$var$MapCache.prototype.clear = $6a2ce057e5371809$exports;
$f7a9c1de4c7dfddc$var$MapCache.prototype['delete'] = $4c141b0329ba782f$exports;
$f7a9c1de4c7dfddc$var$MapCache.prototype.get = $abf60b6f5ffd1155$exports;
$f7a9c1de4c7dfddc$var$MapCache.prototype.has = $3c74074aa779c9f9$exports;
$f7a9c1de4c7dfddc$var$MapCache.prototype.set = $fe4e5ab95eb05c3e$exports;
$f7a9c1de4c7dfddc$exports = $f7a9c1de4c7dfddc$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $0bc4d2b053f412e8$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $0bc4d2b053f412e8$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $9f936cd24433b096$exports) {
        var pairs = data.__data__;
        if (!$e3a1d6376add8530$exports || pairs.length < $0bc4d2b053f412e8$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $f7a9c1de4c7dfddc$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$0bc4d2b053f412e8$exports = $0bc4d2b053f412e8$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $39cc8fdcacbfee68$var$Stack(entries) {
    var data = this.__data__ = new $9f936cd24433b096$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$39cc8fdcacbfee68$var$Stack.prototype.clear = $5781727751490a5b$exports;
$39cc8fdcacbfee68$var$Stack.prototype['delete'] = $3c4fef44089c4d79$exports;
$39cc8fdcacbfee68$var$Stack.prototype.get = $ee4cd0317cae6b35$exports;
$39cc8fdcacbfee68$var$Stack.prototype.has = $93de97fff9261881$exports;
$39cc8fdcacbfee68$var$Stack.prototype.set = $0bc4d2b053f412e8$exports;
$39cc8fdcacbfee68$exports = $39cc8fdcacbfee68$var$Stack;


var $8a270d35cff2ca21$exports = {};
var $61847a7ffe48df71$exports = {};

var $5797770fbe187ecf$exports = {};
var $96bfc597cf68cce0$exports = {};

var $77d4d1414357e807$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $77d4d1414357e807$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $77d4d1414357e807$var$setCacheAdd(value) {
    this.__data__.set(value, $77d4d1414357e807$var$HASH_UNDEFINED);
    return this;
}
$77d4d1414357e807$exports = $77d4d1414357e807$var$setCacheAdd;


var $0e648e7b1e4ac5e7$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $0e648e7b1e4ac5e7$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$0e648e7b1e4ac5e7$exports = $0e648e7b1e4ac5e7$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $96bfc597cf68cce0$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $f7a9c1de4c7dfddc$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$96bfc597cf68cce0$var$SetCache.prototype.add = $96bfc597cf68cce0$var$SetCache.prototype.push = $77d4d1414357e807$exports;
$96bfc597cf68cce0$var$SetCache.prototype.has = $0e648e7b1e4ac5e7$exports;
$96bfc597cf68cce0$exports = $96bfc597cf68cce0$var$SetCache;


var $22a09eb4a0106163$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $22a09eb4a0106163$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$22a09eb4a0106163$exports = $22a09eb4a0106163$var$arraySome;


var $5a41fde6b7f933f8$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5a41fde6b7f933f8$var$cacheHas(cache, key) {
    return cache.has(key);
}
$5a41fde6b7f933f8$exports = $5a41fde6b7f933f8$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $5797770fbe187ecf$var$COMPARE_PARTIAL_FLAG = 1, $5797770fbe187ecf$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $5797770fbe187ecf$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $5797770fbe187ecf$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $5797770fbe187ecf$var$COMPARE_UNORDERED_FLAG ? new $96bfc597cf68cce0$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$22a09eb4a0106163$exports(other, function(othValue, othIndex) {
                if (!$5a41fde6b7f933f8$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$5797770fbe187ecf$exports = $5797770fbe187ecf$var$equalArrays;


var $2104ad7f568fe00f$exports = {};

var $d147b00cce633c67$exports = {};

var $UeyW6 = parcelRequire("UeyW6");
/** Built-in value references. */ var $d147b00cce633c67$var$Uint8Array = $UeyW6.Uint8Array;
$d147b00cce633c67$exports = $d147b00cce633c67$var$Uint8Array;




var $097c35194438596f$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $097c35194438596f$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$097c35194438596f$exports = $097c35194438596f$var$mapToArray;


var $b1f7cc87ea6ad030$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $b1f7cc87ea6ad030$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$b1f7cc87ea6ad030$exports = $b1f7cc87ea6ad030$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $2104ad7f568fe00f$var$COMPARE_PARTIAL_FLAG = 1, $2104ad7f568fe00f$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $2104ad7f568fe00f$var$boolTag = '[object Boolean]', $2104ad7f568fe00f$var$dateTag = '[object Date]', $2104ad7f568fe00f$var$errorTag = '[object Error]', $2104ad7f568fe00f$var$mapTag = '[object Map]', $2104ad7f568fe00f$var$numberTag = '[object Number]', $2104ad7f568fe00f$var$regexpTag = '[object RegExp]', $2104ad7f568fe00f$var$setTag = '[object Set]', $2104ad7f568fe00f$var$stringTag = '[object String]', $2104ad7f568fe00f$var$symbolTag = '[object Symbol]';
var $2104ad7f568fe00f$var$arrayBufferTag = '[object ArrayBuffer]', $2104ad7f568fe00f$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $2104ad7f568fe00f$var$symbolProto = $a9c2ecb930b20196$exports ? $a9c2ecb930b20196$exports.prototype : undefined, $2104ad7f568fe00f$var$symbolValueOf = $2104ad7f568fe00f$var$symbolProto ? $2104ad7f568fe00f$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2104ad7f568fe00f$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $2104ad7f568fe00f$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $2104ad7f568fe00f$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $d147b00cce633c67$exports(object), new $d147b00cce633c67$exports(other))) return false;
            return true;
        case $2104ad7f568fe00f$var$boolTag:
        case $2104ad7f568fe00f$var$dateTag:
        case $2104ad7f568fe00f$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $8b43bb409bcd8608$exports(+object, +other);
        case $2104ad7f568fe00f$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $2104ad7f568fe00f$var$regexpTag:
        case $2104ad7f568fe00f$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $2104ad7f568fe00f$var$mapTag:
            var convert = $097c35194438596f$exports;
        case $2104ad7f568fe00f$var$setTag:
            var isPartial = bitmask & $2104ad7f568fe00f$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $b1f7cc87ea6ad030$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $2104ad7f568fe00f$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $5797770fbe187ecf$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $2104ad7f568fe00f$var$symbolTag:
            if ($2104ad7f568fe00f$var$symbolValueOf) return $2104ad7f568fe00f$var$symbolValueOf.call(object) == $2104ad7f568fe00f$var$symbolValueOf.call(other);
    }
    return false;
}
$2104ad7f568fe00f$exports = $2104ad7f568fe00f$var$equalByTag;


var $2dd87b63905438f9$exports = {};
var $3411b8dc6427c2f8$exports = {};
var $0cf474ec21767bc4$exports = {};
var $1ff569082bd1ea92$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $1ff569082bd1ea92$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$1ff569082bd1ea92$exports = $1ff569082bd1ea92$var$arrayPush;


var $135874bbc3d3a66a$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $135874bbc3d3a66a$var$isArray = Array.isArray;
$135874bbc3d3a66a$exports = $135874bbc3d3a66a$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $0cf474ec21767bc4$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $135874bbc3d3a66a$exports(object) ? result : $1ff569082bd1ea92$exports(result, symbolsFunc(object));
}
$0cf474ec21767bc4$exports = $0cf474ec21767bc4$var$baseGetAllKeys;


var $b0becd008b5b9d81$exports = {};
var $cb8f738c0e9a54bd$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cb8f738c0e9a54bd$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$cb8f738c0e9a54bd$exports = $cb8f738c0e9a54bd$var$arrayFilter;


var $a9bebc9dfc7085c3$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $a9bebc9dfc7085c3$var$stubArray() {
    return [];
}
$a9bebc9dfc7085c3$exports = $a9bebc9dfc7085c3$var$stubArray;


/** Used for built-in method references. */ var $b0becd008b5b9d81$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b0becd008b5b9d81$var$propertyIsEnumerable = $b0becd008b5b9d81$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b0becd008b5b9d81$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b0becd008b5b9d81$var$getSymbols = !$b0becd008b5b9d81$var$nativeGetSymbols ? $a9bebc9dfc7085c3$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $cb8f738c0e9a54bd$exports($b0becd008b5b9d81$var$nativeGetSymbols(object), function(symbol) {
        return $b0becd008b5b9d81$var$propertyIsEnumerable.call(object, symbol);
    });
};
$b0becd008b5b9d81$exports = $b0becd008b5b9d81$var$getSymbols;


var $e8b01e96a369de63$exports = {};
var $a5a913c044f9cddc$exports = {};
var $095a2c8e2650054c$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $095a2c8e2650054c$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$095a2c8e2650054c$exports = $095a2c8e2650054c$var$baseTimes;


var $dcc72e78add79d6a$exports = {};
var $f61cd8254c573b6a$exports = {};

var $4c68ed1e6cc4dd3d$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4c68ed1e6cc4dd3d$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$4c68ed1e6cc4dd3d$exports = $4c68ed1e6cc4dd3d$var$isObjectLike;


/** `Object#toString` result references. */ var $f61cd8254c573b6a$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $f61cd8254c573b6a$var$baseIsArguments(value) {
    return $4c68ed1e6cc4dd3d$exports(value) && $9310747326fde40a$exports(value) == $f61cd8254c573b6a$var$argsTag;
}
$f61cd8254c573b6a$exports = $f61cd8254c573b6a$var$baseIsArguments;



/** Used for built-in method references. */ var $dcc72e78add79d6a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dcc72e78add79d6a$var$hasOwnProperty = $dcc72e78add79d6a$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dcc72e78add79d6a$var$propertyIsEnumerable = $dcc72e78add79d6a$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dcc72e78add79d6a$var$isArguments = $f61cd8254c573b6a$exports(function() {
    return arguments;
}()) ? $f61cd8254c573b6a$exports : function(value) {
    return $4c68ed1e6cc4dd3d$exports(value) && $dcc72e78add79d6a$var$hasOwnProperty.call(value, 'callee') && !$dcc72e78add79d6a$var$propertyIsEnumerable.call(value, 'callee');
};
$dcc72e78add79d6a$exports = $dcc72e78add79d6a$var$isArguments;




var $i1hPd = parcelRequire("i1hPd");
var $b2e9ef4ce3991fa5$exports = {};
/** Used as references for various `Number` constants. */ var $b2e9ef4ce3991fa5$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $b2e9ef4ce3991fa5$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $b2e9ef4ce3991fa5$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $b2e9ef4ce3991fa5$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $b2e9ef4ce3991fa5$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$b2e9ef4ce3991fa5$exports = $b2e9ef4ce3991fa5$var$isIndex;


var $1dd6641c609c15cb$exports = {};
var $3bb01c5dae96c033$exports = {};

var $82d3410776484dcb$exports = {};
/** Used as references for various `Number` constants. */ var $82d3410776484dcb$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $82d3410776484dcb$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $82d3410776484dcb$var$MAX_SAFE_INTEGER;
}
$82d3410776484dcb$exports = $82d3410776484dcb$var$isLength;



/** `Object#toString` result references. */ var $3bb01c5dae96c033$var$argsTag = '[object Arguments]', $3bb01c5dae96c033$var$arrayTag = '[object Array]', $3bb01c5dae96c033$var$boolTag = '[object Boolean]', $3bb01c5dae96c033$var$dateTag = '[object Date]', $3bb01c5dae96c033$var$errorTag = '[object Error]', $3bb01c5dae96c033$var$funcTag = '[object Function]', $3bb01c5dae96c033$var$mapTag = '[object Map]', $3bb01c5dae96c033$var$numberTag = '[object Number]', $3bb01c5dae96c033$var$objectTag = '[object Object]', $3bb01c5dae96c033$var$regexpTag = '[object RegExp]', $3bb01c5dae96c033$var$setTag = '[object Set]', $3bb01c5dae96c033$var$stringTag = '[object String]', $3bb01c5dae96c033$var$weakMapTag = '[object WeakMap]';
var $3bb01c5dae96c033$var$arrayBufferTag = '[object ArrayBuffer]', $3bb01c5dae96c033$var$dataViewTag = '[object DataView]', $3bb01c5dae96c033$var$float32Tag = '[object Float32Array]', $3bb01c5dae96c033$var$float64Tag = '[object Float64Array]', $3bb01c5dae96c033$var$int8Tag = '[object Int8Array]', $3bb01c5dae96c033$var$int16Tag = '[object Int16Array]', $3bb01c5dae96c033$var$int32Tag = '[object Int32Array]', $3bb01c5dae96c033$var$uint8Tag = '[object Uint8Array]', $3bb01c5dae96c033$var$uint8ClampedTag = '[object Uint8ClampedArray]', $3bb01c5dae96c033$var$uint16Tag = '[object Uint16Array]', $3bb01c5dae96c033$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $3bb01c5dae96c033$var$typedArrayTags = {};
$3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$float32Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$float64Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$int8Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$int16Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$int32Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$uint8Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$uint8ClampedTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$uint16Tag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$uint32Tag] = true;
$3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$argsTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$arrayTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$arrayBufferTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$boolTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$dataViewTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$dateTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$errorTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$funcTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$mapTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$numberTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$objectTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$regexpTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$setTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$stringTag] = $3bb01c5dae96c033$var$typedArrayTags[$3bb01c5dae96c033$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $3bb01c5dae96c033$var$baseIsTypedArray(value) {
    return $4c68ed1e6cc4dd3d$exports(value) && $82d3410776484dcb$exports(value.length) && !!$3bb01c5dae96c033$var$typedArrayTags[$9310747326fde40a$exports(value)];
}
$3bb01c5dae96c033$exports = $3bb01c5dae96c033$var$baseIsTypedArray;


var $aaeddef65e996a0f$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $aaeddef65e996a0f$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$aaeddef65e996a0f$exports = $aaeddef65e996a0f$var$baseUnary;



var $8PRF0 = parcelRequire("8PRF0");
/* Node.js helper references. */ var $1dd6641c609c15cb$var$nodeIsTypedArray = $8PRF0 && $8PRF0.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $1dd6641c609c15cb$var$isTypedArray = $1dd6641c609c15cb$var$nodeIsTypedArray ? $aaeddef65e996a0f$exports($1dd6641c609c15cb$var$nodeIsTypedArray) : $3bb01c5dae96c033$exports;
$1dd6641c609c15cb$exports = $1dd6641c609c15cb$var$isTypedArray;


/** Used for built-in method references. */ var $a5a913c044f9cddc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5a913c044f9cddc$var$hasOwnProperty = $a5a913c044f9cddc$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $a5a913c044f9cddc$var$arrayLikeKeys(value, inherited) {
    var isArr = $135874bbc3d3a66a$exports(value), isArg = !isArr && $dcc72e78add79d6a$exports(value), isBuff = !isArr && !isArg && $i1hPd(value), isType = !isArr && !isArg && !isBuff && $1dd6641c609c15cb$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $095a2c8e2650054c$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $a5a913c044f9cddc$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $b2e9ef4ce3991fa5$exports(key, length)))) result.push(key);
    return result;
}
$a5a913c044f9cddc$exports = $a5a913c044f9cddc$var$arrayLikeKeys;


var $0535cff3f184b780$exports = {};
var $e223e8709466f95c$exports = {};
/** Used for built-in method references. */ var $e223e8709466f95c$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $e223e8709466f95c$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $e223e8709466f95c$var$objectProto;
    return value === proto;
}
$e223e8709466f95c$exports = $e223e8709466f95c$var$isPrototype;


var $d7ffe7e8a5c0fd49$exports = {};
var $322d541d8967a885$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $322d541d8967a885$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$322d541d8967a885$exports = $322d541d8967a885$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $d7ffe7e8a5c0fd49$var$nativeKeys = $322d541d8967a885$exports(Object.keys, Object);
$d7ffe7e8a5c0fd49$exports = $d7ffe7e8a5c0fd49$var$nativeKeys;


/** Used for built-in method references. */ var $0535cff3f184b780$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0535cff3f184b780$var$hasOwnProperty = $0535cff3f184b780$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $0535cff3f184b780$var$baseKeys(object) {
    if (!$e223e8709466f95c$exports(object)) return $d7ffe7e8a5c0fd49$exports(object);
    var result = [];
    for(var key in Object(object))if ($0535cff3f184b780$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$0535cff3f184b780$exports = $0535cff3f184b780$var$baseKeys;


var $b4272727fa799bca$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b4272727fa799bca$var$isArrayLike(value) {
    return value != null && $82d3410776484dcb$exports(value.length) && !$08f69a989e3c33aa$exports(value);
}
$b4272727fa799bca$exports = $b4272727fa799bca$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $e8b01e96a369de63$var$keys(object) {
    return $b4272727fa799bca$exports(object) ? $a5a913c044f9cddc$exports(object) : $0535cff3f184b780$exports(object);
}
$e8b01e96a369de63$exports = $e8b01e96a369de63$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3411b8dc6427c2f8$var$getAllKeys(object) {
    return $0cf474ec21767bc4$exports(object, $e8b01e96a369de63$exports, $b0becd008b5b9d81$exports);
}
$3411b8dc6427c2f8$exports = $3411b8dc6427c2f8$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $2dd87b63905438f9$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $2dd87b63905438f9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2dd87b63905438f9$var$hasOwnProperty = $2dd87b63905438f9$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2dd87b63905438f9$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $2dd87b63905438f9$var$COMPARE_PARTIAL_FLAG, objProps = $3411b8dc6427c2f8$exports(object), objLength = objProps.length, othProps = $3411b8dc6427c2f8$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $2dd87b63905438f9$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$2dd87b63905438f9$exports = $2dd87b63905438f9$var$equalObjects;


var $95eccd62fdb905a0$exports = {};
var $9b092ba619e895f2$exports = {};


var $UeyW6 = parcelRequire("UeyW6");
/* Built-in method references that are verified to be native. */ var $9b092ba619e895f2$var$DataView = $d6249531a9dae064$exports($UeyW6, 'DataView');
$9b092ba619e895f2$exports = $9b092ba619e895f2$var$DataView;



var $2fe38fa5d5bec22d$exports = {};


var $UeyW6 = parcelRequire("UeyW6");
/* Built-in method references that are verified to be native. */ var $2fe38fa5d5bec22d$var$Promise = $d6249531a9dae064$exports($UeyW6, 'Promise');
$2fe38fa5d5bec22d$exports = $2fe38fa5d5bec22d$var$Promise;


var $3e6e5fcf88f2181a$exports = {};


var $UeyW6 = parcelRequire("UeyW6");
/* Built-in method references that are verified to be native. */ var $3e6e5fcf88f2181a$var$Set = $d6249531a9dae064$exports($UeyW6, 'Set');
$3e6e5fcf88f2181a$exports = $3e6e5fcf88f2181a$var$Set;


var $eb74c41220f51592$exports = {};


var $UeyW6 = parcelRequire("UeyW6");
/* Built-in method references that are verified to be native. */ var $eb74c41220f51592$var$WeakMap = $d6249531a9dae064$exports($UeyW6, 'WeakMap');
$eb74c41220f51592$exports = $eb74c41220f51592$var$WeakMap;




/** `Object#toString` result references. */ var $95eccd62fdb905a0$var$mapTag = '[object Map]', $95eccd62fdb905a0$var$objectTag = '[object Object]', $95eccd62fdb905a0$var$promiseTag = '[object Promise]', $95eccd62fdb905a0$var$setTag = '[object Set]', $95eccd62fdb905a0$var$weakMapTag = '[object WeakMap]';
var $95eccd62fdb905a0$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $95eccd62fdb905a0$var$dataViewCtorString = $3d444b4e73e3ca1c$exports($9b092ba619e895f2$exports), $95eccd62fdb905a0$var$mapCtorString = $3d444b4e73e3ca1c$exports($e3a1d6376add8530$exports), $95eccd62fdb905a0$var$promiseCtorString = $3d444b4e73e3ca1c$exports($2fe38fa5d5bec22d$exports), $95eccd62fdb905a0$var$setCtorString = $3d444b4e73e3ca1c$exports($3e6e5fcf88f2181a$exports), $95eccd62fdb905a0$var$weakMapCtorString = $3d444b4e73e3ca1c$exports($eb74c41220f51592$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $95eccd62fdb905a0$var$getTag = $9310747326fde40a$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($9b092ba619e895f2$exports && $95eccd62fdb905a0$var$getTag(new $9b092ba619e895f2$exports(new ArrayBuffer(1))) != $95eccd62fdb905a0$var$dataViewTag || $e3a1d6376add8530$exports && $95eccd62fdb905a0$var$getTag(new $e3a1d6376add8530$exports) != $95eccd62fdb905a0$var$mapTag || $2fe38fa5d5bec22d$exports && $95eccd62fdb905a0$var$getTag($2fe38fa5d5bec22d$exports.resolve()) != $95eccd62fdb905a0$var$promiseTag || $3e6e5fcf88f2181a$exports && $95eccd62fdb905a0$var$getTag(new $3e6e5fcf88f2181a$exports) != $95eccd62fdb905a0$var$setTag || $eb74c41220f51592$exports && $95eccd62fdb905a0$var$getTag(new $eb74c41220f51592$exports) != $95eccd62fdb905a0$var$weakMapTag) $95eccd62fdb905a0$var$getTag = function(value) {
    var result = $9310747326fde40a$exports(value), Ctor = result == $95eccd62fdb905a0$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $3d444b4e73e3ca1c$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $95eccd62fdb905a0$var$dataViewCtorString:
            return $95eccd62fdb905a0$var$dataViewTag;
        case $95eccd62fdb905a0$var$mapCtorString:
            return $95eccd62fdb905a0$var$mapTag;
        case $95eccd62fdb905a0$var$promiseCtorString:
            return $95eccd62fdb905a0$var$promiseTag;
        case $95eccd62fdb905a0$var$setCtorString:
            return $95eccd62fdb905a0$var$setTag;
        case $95eccd62fdb905a0$var$weakMapCtorString:
            return $95eccd62fdb905a0$var$weakMapTag;
    }
    return result;
};
$95eccd62fdb905a0$exports = $95eccd62fdb905a0$var$getTag;




var $i1hPd = parcelRequire("i1hPd");

/** Used to compose bitmasks for value comparisons. */ var $61847a7ffe48df71$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $61847a7ffe48df71$var$argsTag = '[object Arguments]', $61847a7ffe48df71$var$arrayTag = '[object Array]', $61847a7ffe48df71$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $61847a7ffe48df71$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $61847a7ffe48df71$var$hasOwnProperty = $61847a7ffe48df71$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $61847a7ffe48df71$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $135874bbc3d3a66a$exports(object), othIsArr = $135874bbc3d3a66a$exports(other), objTag = objIsArr ? $61847a7ffe48df71$var$arrayTag : $95eccd62fdb905a0$exports(object), othTag = othIsArr ? $61847a7ffe48df71$var$arrayTag : $95eccd62fdb905a0$exports(other);
    objTag = objTag == $61847a7ffe48df71$var$argsTag ? $61847a7ffe48df71$var$objectTag : objTag;
    othTag = othTag == $61847a7ffe48df71$var$argsTag ? $61847a7ffe48df71$var$objectTag : othTag;
    var objIsObj = objTag == $61847a7ffe48df71$var$objectTag, othIsObj = othTag == $61847a7ffe48df71$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $i1hPd(object)) {
        if (!$i1hPd(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $39cc8fdcacbfee68$exports);
        return objIsArr || $1dd6641c609c15cb$exports(object) ? $5797770fbe187ecf$exports(object, other, bitmask, customizer, equalFunc, stack) : $2104ad7f568fe00f$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $61847a7ffe48df71$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $61847a7ffe48df71$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $61847a7ffe48df71$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $39cc8fdcacbfee68$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $39cc8fdcacbfee68$exports);
    return $2dd87b63905438f9$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$61847a7ffe48df71$exports = $61847a7ffe48df71$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $8a270d35cff2ca21$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4c68ed1e6cc4dd3d$exports(value) && !$4c68ed1e6cc4dd3d$exports(other)) return value !== value && other !== other;
    return $61847a7ffe48df71$exports(value, other, bitmask, customizer, $8a270d35cff2ca21$var$baseIsEqual, stack);
}
$8a270d35cff2ca21$exports = $8a270d35cff2ca21$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $e444dedd49ee0489$var$COMPARE_PARTIAL_FLAG = 1, $e444dedd49ee0489$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $e444dedd49ee0489$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $39cc8fdcacbfee68$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $8a270d35cff2ca21$exports(srcValue, objValue, $e444dedd49ee0489$var$COMPARE_PARTIAL_FLAG | $e444dedd49ee0489$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$e444dedd49ee0489$exports = $e444dedd49ee0489$var$baseIsMatch;


var $09e1f251cdd1fcff$exports = {};
var $9f38ce58670cc4e3$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9f38ce58670cc4e3$var$isStrictComparable(value) {
    return value === value && !$2f639ab8f1a63700$exports(value);
}
$9f38ce58670cc4e3$exports = $9f38ce58670cc4e3$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $09e1f251cdd1fcff$var$getMatchData(object) {
    var result = $e8b01e96a369de63$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9f38ce58670cc4e3$exports(value)
        ];
    }
    return result;
}
$09e1f251cdd1fcff$exports = $09e1f251cdd1fcff$var$getMatchData;


var $10f1b28983f5cf41$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $10f1b28983f5cf41$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$10f1b28983f5cf41$exports = $10f1b28983f5cf41$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $b8e7b46153274434$var$baseMatches(source) {
    var matchData = $09e1f251cdd1fcff$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $10f1b28983f5cf41$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $e444dedd49ee0489$exports(object, source, matchData);
    };
}
$b8e7b46153274434$exports = $b8e7b46153274434$var$baseMatches;


var $afea2cac18a2d140$exports = {};

var $369c3fcd3a6c1c7c$exports = {};
var $033f926066b43cc0$exports = {};
var $2c532cb4a076ff14$exports = {};

var $51b8738eeee2fabd$exports = {};

var $5f14550a5524d769$exports = {};


/** `Object#toString` result references. */ var $5f14550a5524d769$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5f14550a5524d769$var$isSymbol(value) {
    return typeof value == 'symbol' || $4c68ed1e6cc4dd3d$exports(value) && $9310747326fde40a$exports(value) == $5f14550a5524d769$var$symbolTag;
}
$5f14550a5524d769$exports = $5f14550a5524d769$var$isSymbol;


/** Used to match property names within property paths. */ var $51b8738eeee2fabd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $51b8738eeee2fabd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $51b8738eeee2fabd$var$isKey(value, object) {
    if ($135874bbc3d3a66a$exports(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $5f14550a5524d769$exports(value)) return true;
    return $51b8738eeee2fabd$var$reIsPlainProp.test(value) || !$51b8738eeee2fabd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$51b8738eeee2fabd$exports = $51b8738eeee2fabd$var$isKey;


var $34367083047372a1$exports = {};
var $f79cc3c7e5a3c32f$exports = {};
var $c2360c18b5aae2f0$exports = {};

/** Error message constants. */ var $c2360c18b5aae2f0$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c2360c18b5aae2f0$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($c2360c18b5aae2f0$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c2360c18b5aae2f0$var$memoize.Cache || $f7a9c1de4c7dfddc$exports);
    return memoized;
}
// Expose `MapCache`.
$c2360c18b5aae2f0$var$memoize.Cache = $f7a9c1de4c7dfddc$exports;
$c2360c18b5aae2f0$exports = $c2360c18b5aae2f0$var$memoize;


/** Used as the maximum memoize cache size. */ var $f79cc3c7e5a3c32f$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $f79cc3c7e5a3c32f$var$memoizeCapped(func) {
    var result = $c2360c18b5aae2f0$exports(func, function(key) {
        if (cache.size === $f79cc3c7e5a3c32f$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$f79cc3c7e5a3c32f$exports = $f79cc3c7e5a3c32f$var$memoizeCapped;


/** Used to match property names within property paths. */ var $34367083047372a1$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $34367083047372a1$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $34367083047372a1$var$stringToPath = $f79cc3c7e5a3c32f$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($34367083047372a1$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($34367083047372a1$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
$34367083047372a1$exports = $34367083047372a1$var$stringToPath;


var $49bc11cf50521e0b$exports = {};
var $0bd5d1478be299a0$exports = {};

var $77bc8b86d18dfde8$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $77bc8b86d18dfde8$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$77bc8b86d18dfde8$exports = $77bc8b86d18dfde8$var$arrayMap;




/** Used as references for various `Number` constants. */ var $0bd5d1478be299a0$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0bd5d1478be299a0$var$symbolProto = $a9c2ecb930b20196$exports ? $a9c2ecb930b20196$exports.prototype : undefined, $0bd5d1478be299a0$var$symbolToString = $0bd5d1478be299a0$var$symbolProto ? $0bd5d1478be299a0$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0bd5d1478be299a0$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($135874bbc3d3a66a$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $77bc8b86d18dfde8$exports(value, $0bd5d1478be299a0$var$baseToString) + '';
    if ($5f14550a5524d769$exports(value)) return $0bd5d1478be299a0$var$symbolToString ? $0bd5d1478be299a0$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$0bd5d1478be299a0$var$INFINITY ? '-0' : result;
}
$0bd5d1478be299a0$exports = $0bd5d1478be299a0$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $49bc11cf50521e0b$var$toString(value) {
    return value == null ? '' : $0bd5d1478be299a0$exports(value);
}
$49bc11cf50521e0b$exports = $49bc11cf50521e0b$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $2c532cb4a076ff14$var$castPath(value, object) {
    if ($135874bbc3d3a66a$exports(value)) return value;
    return $51b8738eeee2fabd$exports(value, object) ? [
        value
    ] : $34367083047372a1$exports($49bc11cf50521e0b$exports(value));
}
$2c532cb4a076ff14$exports = $2c532cb4a076ff14$var$castPath;


var $a657e945d0a84989$exports = {};

/** Used as references for various `Number` constants. */ var $a657e945d0a84989$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $a657e945d0a84989$var$toKey(value) {
    if (typeof value == 'string' || $5f14550a5524d769$exports(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$a657e945d0a84989$var$INFINITY ? '-0' : result;
}
$a657e945d0a84989$exports = $a657e945d0a84989$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $033f926066b43cc0$var$baseGet(object, path) {
    path = $2c532cb4a076ff14$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$a657e945d0a84989$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$033f926066b43cc0$exports = $033f926066b43cc0$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $369c3fcd3a6c1c7c$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $033f926066b43cc0$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$369c3fcd3a6c1c7c$exports = $369c3fcd3a6c1c7c$var$get;


var $e9c4d69ed8a37c32$exports = {};
var $22e5a65af56f7918$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $22e5a65af56f7918$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$22e5a65af56f7918$exports = $22e5a65af56f7918$var$baseHasIn;


var $13a4d7c66c79a19a$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $13a4d7c66c79a19a$var$hasPath(object, path, hasFunc) {
    path = $2c532cb4a076ff14$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $a657e945d0a84989$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $82d3410776484dcb$exports(length) && $b2e9ef4ce3991fa5$exports(key, length) && ($135874bbc3d3a66a$exports(object) || $dcc72e78add79d6a$exports(object));
}
$13a4d7c66c79a19a$exports = $13a4d7c66c79a19a$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e9c4d69ed8a37c32$var$hasIn(object, path) {
    return object != null && $13a4d7c66c79a19a$exports(object, path, $22e5a65af56f7918$exports);
}
$e9c4d69ed8a37c32$exports = $e9c4d69ed8a37c32$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $afea2cac18a2d140$var$COMPARE_PARTIAL_FLAG = 1, $afea2cac18a2d140$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $afea2cac18a2d140$var$baseMatchesProperty(path, srcValue) {
    if ($51b8738eeee2fabd$exports(path) && $9f38ce58670cc4e3$exports(srcValue)) return $10f1b28983f5cf41$exports($a657e945d0a84989$exports(path), srcValue);
    return function(object) {
        var objValue = $369c3fcd3a6c1c7c$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $e9c4d69ed8a37c32$exports(object, path) : $8a270d35cff2ca21$exports(srcValue, objValue, $afea2cac18a2d140$var$COMPARE_PARTIAL_FLAG | $afea2cac18a2d140$var$COMPARE_UNORDERED_FLAG);
    };
}
$afea2cac18a2d140$exports = $afea2cac18a2d140$var$baseMatchesProperty;


var $9129b7f4ca819b48$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $9129b7f4ca819b48$var$identity(value) {
    return value;
}
$9129b7f4ca819b48$exports = $9129b7f4ca819b48$var$identity;



var $e45993ba559a0ca6$exports = {};
var $5c1c8cfa59875669$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $5c1c8cfa59875669$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$5c1c8cfa59875669$exports = $5c1c8cfa59875669$var$baseProperty;


var $563eda26e5ab1f63$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $563eda26e5ab1f63$var$basePropertyDeep(path) {
    return function(object) {
        return $033f926066b43cc0$exports(object, path);
    };
}
$563eda26e5ab1f63$exports = $563eda26e5ab1f63$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $e45993ba559a0ca6$var$property(path) {
    return $51b8738eeee2fabd$exports(path) ? $5c1c8cfa59875669$exports($a657e945d0a84989$exports(path)) : $563eda26e5ab1f63$exports(path);
}
$e45993ba559a0ca6$exports = $e45993ba559a0ca6$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $fd5568a8241be73a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $9129b7f4ca819b48$exports;
    if (typeof value == 'object') return $135874bbc3d3a66a$exports(value) ? $afea2cac18a2d140$exports(value[0], value[1]) : $b8e7b46153274434$exports(value);
    return $e45993ba559a0ca6$exports(value);
}
$fd5568a8241be73a$exports = $fd5568a8241be73a$var$baseIteratee;


var $8b85706afd21a5c2$exports = {};

var $713e941379900b72$exports = {};
var $6aa3f4d3407af2fa$exports = {};
var $33b713957d44895f$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $33b713957d44895f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$33b713957d44895f$exports = $33b713957d44895f$var$baseFindIndex;


var $9bcbc96ef5dc08da$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $9bcbc96ef5dc08da$var$baseIsNaN(value) {
    return value !== value;
}
$9bcbc96ef5dc08da$exports = $9bcbc96ef5dc08da$var$baseIsNaN;


var $2e952e7f1bf2b936$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2e952e7f1bf2b936$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$2e952e7f1bf2b936$exports = $2e952e7f1bf2b936$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $6aa3f4d3407af2fa$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $2e952e7f1bf2b936$exports(array, value, fromIndex) : $33b713957d44895f$exports(array, $9bcbc96ef5dc08da$exports, fromIndex);
}
$6aa3f4d3407af2fa$exports = $6aa3f4d3407af2fa$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $713e941379900b72$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $6aa3f4d3407af2fa$exports(array, value, 0) > -1;
}
$713e941379900b72$exports = $713e941379900b72$var$arrayIncludes;


var $feff66c702fb07d1$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $feff66c702fb07d1$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$feff66c702fb07d1$exports = $feff66c702fb07d1$var$arrayIncludesWith;



var $7ae5e4cdcbf9b10c$exports = {};

var $e2bb95ea3ee83620$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e2bb95ea3ee83620$var$noop() {
// No operation performed.
}
$e2bb95ea3ee83620$exports = $e2bb95ea3ee83620$var$noop;



/** Used as references for various `Number` constants. */ var $7ae5e4cdcbf9b10c$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $7ae5e4cdcbf9b10c$var$createSet = !($3e6e5fcf88f2181a$exports && 1 / $b1f7cc87ea6ad030$exports(new $3e6e5fcf88f2181a$exports([
    ,
    -0
]))[1] == $7ae5e4cdcbf9b10c$var$INFINITY) ? $e2bb95ea3ee83620$exports : function(values) {
    return new $3e6e5fcf88f2181a$exports(values);
};
$7ae5e4cdcbf9b10c$exports = $7ae5e4cdcbf9b10c$var$createSet;



/** Used as the size to enable large array optimizations. */ var $8b85706afd21a5c2$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $8b85706afd21a5c2$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $713e941379900b72$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $feff66c702fb07d1$exports;
    } else if (length >= $8b85706afd21a5c2$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $7ae5e4cdcbf9b10c$exports(array);
        if (set) return $b1f7cc87ea6ad030$exports(set);
        isCommon = false;
        includes = $5a41fde6b7f933f8$exports;
        seen = new $96bfc597cf68cce0$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$8b85706afd21a5c2$exports = $8b85706afd21a5c2$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $08de374e827f3ad7$var$uniqBy(array, iteratee) {
    return array && array.length ? $8b85706afd21a5c2$exports(array, $fd5568a8241be73a$exports(iteratee, 2)) : [];
}
$08de374e827f3ad7$exports = $08de374e827f3ad7$var$uniqBy;


const $16a49d1992c78b37$var$Avatar = ({ user: user, small: small, backgroundColor: backgroundColor, onClick: onClick, dataTest: dataTest })=>{
    const { firstName: firstName, lastName: lastName } = user;
    const [initials, fullName] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            `${lastName?.charAt(0)}${firstName?.charAt(0)}`,
            (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user)
        ], [
        firstName,
        lastName
    ]);
    if (small) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: onClick ? 'button' : 'span',
        backgroundColor: backgroundColor || `primary-dark`,
        textColor: "primary-light",
        style: {
            borderRadius: 999,
            padding: '0.5rem'
        },
        "data-tooltip": fullName,
        className: "has-tooltip-bottom",
        onClick: onClick ? ()=>onClick(user) : undefined,
        "data-test": dataTest,
        children: initials
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: fullName
    });
};
var $16a49d1992c78b37$export$2e2bcd8739ae039 = $16a49d1992c78b37$var$Avatar;
const $16a49d1992c78b37$export$b205e4eb1a83adbd = /*#__PURE__*/ (0, $3ZYaX.memo)(({ users: users, ...rest })=>{
    const unique = (0, (/*@__PURE__*/$parcel$interopDefault($08de374e827f3ad7$exports)))(users, (u)=>u._id);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: unique.map((u)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($16a49d1992c78b37$var$Avatar, {
                user: u,
                ...rest
            }))
    });
});



parcelRequire("3ZYaX");








const $58f46cb3f921014b$export$6bc6640ee85e2402 = (id, type, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('organizations', (0, $1005558fe5194d2d$export$3988ae62b71be9a3), id, {
        type: type
    }, {
        ...options,
        onSuccess (data) {
            const { session: session } = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState();
            // For Super Admin logged as organization
            // we update the currently stored organization if the fecthed is the stored one
            if (session.isSuperAdmin && session.loggedAs?.organization?._id && data._id === session.loggedAs.organization._id) session.initializeSession(session.currentUser, session.jwt, session.currentUserRole, data, session.currentOrganizationRole);
        }
    });
const $58f46cb3f921014b$export$98cc8fc48c6a548b = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('organizations', (0, $1005558fe5194d2d$export$e7aa7bc5c1b3cfb3), filters, options);
const $58f46cb3f921014b$export$f085fe041f5f596a = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('organizations/count', (0, $1005558fe5194d2d$export$85b9a36db797e02b), filters, options);
const $58f46cb3f921014b$export$3a621c77e84e6f17 = (options)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentOrganization;
    const currentOrganizationType = currentOrganization.type;
    return (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('organizations', (0, $1005558fe5194d2d$export$e7aa7bc5c1b3cfb3), {
        type: currentOrganizationType === 'employer' ? 'interimAgency' : 'employer'
    }, {
        ...options || {},
        select (res) {
            return res.data.filter((organization)=>{
                const employer = currentOrganizationType === 'employer' ? currentOrganization : organization;
                const interimAgency = currentOrganizationType === 'interimAgency' ? currentOrganization : organization;
                return employer.associations.some((a)=>a.status === 'accepted' && (0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(a.interimAgency, interimAgency));
            });
        }
    });
};
//Mutations
const $58f46cb3f921014b$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'users'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'organizations'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries((0, $e607e015ac40917d$export$94e9afb1b933cd1a)());
};
const $58f46cb3f921014b$export$4a6f974b4208311 = ()=>[
        'organizations',
        'create'
    ];
const $58f46cb3f921014b$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1005558fe5194d2d$export$185802fd694ee1f5), {
        mutationKey: $58f46cb3f921014b$export$4a6f974b4208311()
    });
const $58f46cb3f921014b$export$a6fe4df8bec26327 = ()=>[
        'organizations',
        'update'
    ];
const $58f46cb3f921014b$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1005558fe5194d2d$export$722fbec263ad908a), {
        mutationKey: $58f46cb3f921014b$export$a6fe4df8bec26327(),
        onSuccess: $58f46cb3f921014b$var$onMutationSuccess
    });
const $58f46cb3f921014b$var$useCreateAssociationMutationKey = ()=>[
        'organizations',
        'associations',
        'create'
    ];
const $58f46cb3f921014b$export$12ac715909ba00ff = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1005558fe5194d2d$export$fcc1e1dc79c25712), {
        mutationKey: $58f46cb3f921014b$var$useCreateAssociationMutationKey(),
        onSuccess: $58f46cb3f921014b$var$onMutationSuccess
    });
const $58f46cb3f921014b$var$useUpdateAssociationMutationKey = ()=>[
        'organizations',
        'associations',
        'update'
    ];
const $58f46cb3f921014b$export$6fd574ee93f5aab = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1005558fe5194d2d$export$9feaf61c98cee22d), {
        mutationKey: $58f46cb3f921014b$var$useUpdateAssociationMutationKey(),
        onSuccess: $58f46cb3f921014b$var$onMutationSuccess
    });



const $45db3b5cb5fbc0ed$var$LoginAs = ({ onSelect: onSelect })=>{
    const employersQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        sort: 'name',
        type: 'employer'
    });
    const interimAgencyQyery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        sort: 'name',
        type: 'interimAgency'
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        mx: 3,
        my: 3,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($45db3b5cb5fbc0ed$var$LoginAsList, {
                        organizations: interimAgencyQyery.data || [],
                        onSelect: onSelect,
                        texts: {
                            title: "Agences d'Int\xe9rim",
                            createNew: "Cr\xe9er une Agence d'Int\xe9rim",
                            noResult: "Aucune Agence d'Int\xe9rim"
                        },
                        createNewPath: "/agencies/new",
                        role: "interimAgencyMember"
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($45db3b5cb5fbc0ed$var$LoginAsList, {
                        organizations: employersQuery.data || [],
                        onSelect: onSelect,
                        texts: {
                            title: 'Employeurs',
                            createNew: "Cr\xe9er un Employeur",
                            noResult: 'Aucun Employeur'
                        },
                        createNewPath: "/employer/new",
                        role: "employerMember"
                    })
                })
            ]
        })
    });
};
const $45db3b5cb5fbc0ed$var$LoginAsList = ({ organizations: organizations, onSelect: onSelect, texts: texts, createNewPath: createNewPath, role: role })=>{
    const loginAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.loginAs);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                ml: 4,
                children: texts.title
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "ul",
                children: organizations[0] ? organizations.map((organization)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "li",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "ghost",
                            onClick: ()=>{
                                onSelect();
                                loginAs(role, organization, 'admin');
                            },
                            children: organization.name
                        })
                    }, organization._id)) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "li",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                to: createNewPath,
                                children: texts.createNew
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "li",
                            textColor: "grey",
                            textSize: 6,
                            ml: 4,
                            mt: 3,
                            children: texts.noResult
                        })
                    ]
                })
            })
        ]
    });
};
var $45db3b5cb5fbc0ed$export$2e2bcd8739ae039 = $45db3b5cb5fbc0ed$var$LoginAs;




var $3ZYaX = parcelRequire("3ZYaX");

const $6d829f16d3c4ab1d$var$Modal = ({ title: title, children: children, footer: footer, actions: actions, maxWidth: maxWidth, dataTest: dataTest })=>{
    const { isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed } = actions;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
        showClose: true,
        show: isDisplayed,
        onClose: ()=>setIsDisplayed(false),
        closeOnBlur: true,
        closeOnEsc: true,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Modal).Card, {
            style: {
                maxWidth: maxWidth,
                width: maxWidth
            },
            "data-test": dataTest,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Header, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Title, {
                        children: title && title
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Body, {
                    children: children
                }),
                footer && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Footer, {
                    children: footer
                })
            ]
        })
    });
};
var $6d829f16d3c4ab1d$export$2e2bcd8739ae039 = $6d829f16d3c4ab1d$var$Modal;
const $6d829f16d3c4ab1d$export$33ffd74ebf07f060 = (options)=>{
    const [isDisplayed, setIsDisplayed] = (0, $3ZYaX.useState)(options?.isDisplayedDefaultValue || false);
    const [autoCloseIsActive, setAutoCloseIsActive] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        setAutoCloseIsActive(Boolean(options?.autoClose?.on));
    }, [
        options?.autoClose?.on
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!options?.autoClose) return;
        let timeout;
        if (autoCloseIsActive && options?.autoClose?.delay) timeout = setTimeout(()=>autoCloseIsActive && setIsDisplayed(false), options.autoClose.delay || 0);
        else if (autoCloseIsActive) setIsDisplayed(false);
        return ()=>timeout && clearTimeout(timeout);
    }, [
        options?.autoClose,
        autoCloseIsActive
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (options?.autoClose && isDisplayed) setAutoCloseIsActive(false);
    }, [
        isDisplayed
    ]);
    return {
        isDisplayed: isDisplayed,
        setIsDisplayed: setIsDisplayed
    };
};




const $58602f0dc5094d54$export$a595528b3e00ccc = ()=>{
    const { hostname: hostname } = window.location;
    if (hostname === 'app.teamtim.fr') return false;
    if (hostname === 'app.team-tim.fr') return false;
    return true;
};


const $b0ebfbdfe7f43b20$var$config = {
    missions: {
        /** Number of weeks ahead the materialization cron guarantees real work periods. */ rollingWindowWeeks: 4
    },
    mobileApps: {
        apple: {
            store: {
                url: 'https://apps.apple.com/be/app/teamtim/id6449463217'
            }
        },
        android: {
            store: {
                url: 'https://play.google.com/store/apps/details?id=fr.teamtim.app'
            }
        }
    },
    currentPrivacyPolicyVersion: '1.0.1',
    currentTermsOfUseVersion: '1.0.1',
    notifications: {
        admins: [
            'dev@codefathers.be',
            'support@teamtim.fr'
        ],
        sender: 'notifications@teamtim.fr'
    },
    passwordValidation: {
        // Password Validation Rules
        // The below element pattern(regular expression) will be applied to password field.
        // (?=.*\d) -> at least one numeric value(0-9).
        // (?=.*[a-z]) -> at least one lowercase letter(a - z).
        // (?=.*[A-Z]) -> at least one uppercase letter(A - Z).
        //(?=.*[^a-zA-Z0-9]) -> at least one character which is not of the three above !(a-z) || !(A-Z) || !(d)
        // {8,} -> the total length should be greater than or equal to 8.
        rule: new RegExp(/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/),
        message: "Le mot de passe doit avoir une longueur minimum de 8 caract\xe8res comprenant 1 lettre minuscule, 1 lettre majuscule, 1 chiffre et 1 caract\xe8re sp\xe9cial."
    },
    workersRequests: {
        recourseCases: {
            reasons: {
                remplacement_d_un_salarie: "Remplacement d'un Salari\xe9",
                accroissement_temporaire_d_activite: "Accroissement temporaire d'activit\xe9",
                emploi_saisonnier_ou_d_usage_constant: "Emploi saisonnier ou d'usage constant",
                remplacement_d_un_non_salarie: "Remplacement d'un non salari\xe9",
                complement_de_formation: "Compl\xe9ment de formation",
                Personne_en_situation_de_handicap: 'Personne en situation de handicap',
                apprentissage: 'Apprentissage'
            }
        }
    }
};
var $b0ebfbdfe7f43b20$export$2e2bcd8739ae039 = $b0ebfbdfe7f43b20$var$config;


const $05aa31a7e1e0b1e2$var$config = {
    ...(0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039)
};
var $05aa31a7e1e0b1e2$export$2e2bcd8739ae039 = $05aa31a7e1e0b1e2$var$config;



parcelRequire("3ZYaX");
const $fb0f7382abab45fe$export$3a4049fd60e61ed0 = (text, trimIfLongerThan)=>{
    return text && text.length > trimIfLongerThan ? text.substring(0, trimIfLongerThan) + '..' : text;
};
const $fb0f7382abab45fe$export$f458b3f21d0860 = ({ children: children, ifIsLongerThan: ifIsLongerThan })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
        "data-tooltip": children,
        children: $fb0f7382abab45fe$export$3a4049fd60e61ed0(children, ifIsLongerThan)
    });
};



parcelRequire("3ZYaX");


var $2KSUA = parcelRequire("2KSUA");
const $194abd50ec8a5014$export$4d17dfdb53784ff6 = (options)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039).getState().session.currentOrganization;
    const optionToCheck = currentOrganization && options.find((o)=>o.organizationType === currentOrganization?.type);
    //@ts-ignore
    return !optionToCheck || (0, $2KSUA.get)(currentOrganization.appOptions, optionToCheck.option);
};
const $194abd50ec8a5014$var$OrganizationOptionProtected = ({ children: children, options: options })=>{
    if ($194abd50ec8a5014$export$4d17dfdb53784ff6(options)) return children;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
var $194abd50ec8a5014$export$2e2bcd8739ae039 = $194abd50ec8a5014$var$OrganizationOptionProtected;


const $d31d8fe330ea4953$var$Header = ()=>{
    const [displayMenu, setDisplayMenu] = (0, $3ZYaX.useState)(false);
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const changeCurrentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.changeCurrentRole);
    const logout = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.logout);
    const loggedAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.loggedAs);
    const pendingInvitationsCount = (0, $8cf00e93f034ffc8$export$160ed609bc8ffc2b)();
    const pendingEmployerInvitationsCount = (0, $9e4f6dc667a577f4$export$c5bd0e29fdd0ade0)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const isDevEnvironment = (0, $58602f0dc5094d54$export$a595528b3e00ccc)();
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const realUserRole = loggedAs?.organization?.type ? 'superAdmin' : currentUserRole;
    const changeCurrentRole = (role)=>{
        navigate('/');
        changeCurrentUserRole(role);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "header",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar), {
                active: displayMenu,
                fixed: "top",
                "data-test": "header-menu",
                backgroundColor: realUserRole === 'superAdmin' ? 'super-admin-light' : 'primary-light',
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    breakpoint: 'fluid',
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Brand, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                    renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                    to: "/",
                                    p: 1,
                                    children: isDevEnvironment ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                        color: 'warning',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                            children: "DEV"
                                        })
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("img", {
                                        src: $dc4d8e29ac375220$exports,
                                        alt: "TeamTim"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                    renderAs: "div",
                                    children: !loggedAs ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        textColor: `primary`,
                                        textWeight: "bold",
                                        children: currentOrganization?.name ?? realUserRole === 'worker' ? (0, $fb0f7382abab45fe$export$3a4049fd60e61ed0)(currentUser?.firstName + ' ' + currentUser?.lastName, 20) : (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[realUserRole]
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$LoggedAsStatusItem, {
                                        changeCurrentRole: changeCurrentRole
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                    roles: [
                                        'employerMember',
                                        'interimAgencyMember',
                                        'superAdmin'
                                    ],
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                        to: "/whatsnew",
                                        "data-tooltip": "Nouveaut\xe9s",
                                        className: "has-tooltip-bottom",
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            textColor: "danger",
                                            children: "\u2728"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "button",
                                    role: "button",
                                    className: "navbar-burger",
                                    onClick: ()=>setDisplayMenu(!displayMenu),
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                            "aria-hidden": "true"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Menu, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Container, {
                                align: "right",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'worker'
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                href: (0, $05aa31a7e1e0b1e2$export$2e2bcd8739ae039).mobileApps.apple.store.url,
                                                "data-tooltip": "App mobile Apple",
                                                className: "has-tooltip-bottom",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    size: 'small',
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6940787f97640fd), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                href: (0, $05aa31a7e1e0b1e2$export$2e2bcd8739ae039).mobileApps.android.store.url,
                                                "data-tooltip": "App mobile Android",
                                                className: "has-tooltip-bottom",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    size: 'small',
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ab2f0aaabb79022e), {})
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'superAdmin',
                                            'worker',
                                            'interimAgencyMember',
                                            'employerMember'
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                bold: true,
                                                label: "Tableau de Bord",
                                                to: "/"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                roles: [
                                                    'employerMember',
                                                    'interimAgencyMember'
                                                ],
                                                action: {
                                                    resource: 'missions',
                                                    name: 'read'
                                                },
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                    bold: true,
                                                    label: "R\xe9capitulatif",
                                                    to: "/summary"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                roles: [
                                                    'employerMember',
                                                    'interimAgencyMember'
                                                ],
                                                action: {
                                                    resource: 'workersRequests',
                                                    name: 'read'
                                                },
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                    bold: true,
                                                    label: "Demandes d'Int\xe9rimaires",
                                                    to: "/workers-requests"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$MobileNavbarSeparator, {}),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                roles: [
                                                    'employerMember',
                                                    'interimAgencyMember',
                                                    'superAdmin'
                                                ],
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                    hoverable: true,
                                                    "data-test": "organization-submenu",
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Link, {
                                                            textWeight: "bold",
                                                            children: currentOrganization?.type === 'employer' ? 'Mon Entreprise' : currentOrganization?.type === 'interimAgency' ? 'Mon Agence' : (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[realUserRole]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Dropdown, {
                                                            right: true,
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                    roles: [
                                                                        'employerMember',
                                                                        'interimAgencyMember'
                                                                    ],
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                            label: "Missions"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'employerMember',
                                                                                'interimAgencyMember'
                                                                            ],
                                                                            action: {
                                                                                resource: 'missions',
                                                                                name: 'read'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                label: "Missions",
                                                                                to: "/missions"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'employerMember'
                                                                            ],
                                                                            action: {
                                                                                resource: 'missions',
                                                                                name: 'read'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                label: "Journ\xe9es de travail",
                                                                                to: "/work-periods"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'employerMember'
                                                                            ],
                                                                            action: {
                                                                                resource: 'clockings',
                                                                                name: 'read'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                label: "Pointage",
                                                                                to: "/clockings"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                            label: "Finances"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'employerMember',
                                                                                'interimAgencyMember'
                                                                            ],
                                                                            action: {
                                                                                resource: 'periodSummaries',
                                                                                name: 'read'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                label: "Pr\xe9-Facturation",
                                                                                to: "/pre-billings"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'employerMember'
                                                                            ],
                                                                            action: {
                                                                                resource: 'missions',
                                                                                name: 'read'
                                                                            },
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $194abd50ec8a5014$export$2e2bcd8739ae039), {
                                                                                options: [
                                                                                    {
                                                                                        organizationType: 'employer',
                                                                                        option: 'biPart'
                                                                                    }
                                                                                ],
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                    label: "Paie",
                                                                                    to: "/payroll"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                    roles: [
                                                                        'superAdmin'
                                                                    ],
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                            label: "Organisations"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                            label: "Agences d'Int\xe9rim",
                                                                            to: "/agencies"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                            label: "Employeurs",
                                                                            to: "/employers"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                            label: "Bornes de Pointage"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                            label: "Bornes de Pointage",
                                                                            to: "/terminals"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                                                                            touch: {
                                                                                display: 'hidden'
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                                            onClick: ()=>modal.setIsDisplayed(!modal.isDisplayed),
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                                                                flexWrap: "nowrap",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                                        color: "grey",
                                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4b2651edb550ad92$export$2e2bcd8739ae039), {})
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                        renderAs: "span",
                                                                                        children: "Me connecter en tant que..."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                                                                            touch: {
                                                                                display: 'hidden'
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                    roles: [
                                                                        'superAdmin'
                                                                    ],
                                                                    atLeastOneAction: [
                                                                        {
                                                                            resource: 'users',
                                                                            name: 'create'
                                                                        }
                                                                    ],
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                            label: "Utilisateurs"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                            roles: [
                                                                                'superAdmin'
                                                                            ],
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                                label: "Super Admins",
                                                                                to: "/super-admins",
                                                                                "data-test": "organization-submenu"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                roles: [
                                                    'employerMember',
                                                    'interimAgencyMember'
                                                ],
                                                action: {
                                                    resource: 'organizations',
                                                    name: 'update'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                        to: "/settings",
                                                        icon: (0, $e0de785befddd5e2$export$ac4e8b8ca2b79f39),
                                                        info: "Param\xe8tres"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        style: {
                                                            position: 'relative'
                                                        },
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$PendingInvationsTag, {
                                                            count: pendingEmployerInvitationsCount,
                                                            style: {
                                                                position: 'absolute',
                                                                top: 2,
                                                                right: 0
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            !loggedAs ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$MobileNavbarSeparator, {}),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                        hoverable: true,
                                                        "data-test": "user-submenu",
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Link, {
                                                                textWeight: "bold",
                                                                children: [
                                                                    currentUser && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                className: "is-hidden-touch",
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                                                                    user: currentUser,
                                                                                    small: true
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                className: "is-hidden-desktop",
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                                                                    user: currentUser,
                                                                                    small: false
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$PendingInvationsTag, {
                                                                        count: pendingInvitationsCount,
                                                                        style: {
                                                                            position: 'absolute',
                                                                            top: 2,
                                                                            right: 30
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Dropdown, {
                                                                right: true,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$UserRoles, {
                                                                        user: currentUser,
                                                                        currentRole: currentUserRole,
                                                                        currentOrganization: currentOrganization,
                                                                        changeCurrentRole: changeCurrentRole
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                        label: "Mes Relations"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                        label: "Mes Relations",
                                                                        to: "/me/organizations",
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                            renderAs: "span",
                                                                            ml: 1,
                                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$PendingInvationsTag, {
                                                                                count: pendingInvitationsCount
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                                                                        touch: {
                                                                            display: 'hidden'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                                                                        label: "Param\xe8tres"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                        label: "Mes Informations",
                                                                        to: "/me"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                        label: "Notifications",
                                                                        to: "/me/notifications"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                                                                        touch: {
                                                                            display: 'hidden'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                        to: "/help",
                                                                        label: "Aide",
                                                                        icon: (0, $e0de785befddd5e2$export$f713256e8ad1586)
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                        roles: [
                                                                            'employerMember',
                                                                            'interimAgencyMember',
                                                                            'superAdmin'
                                                                        ],
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                                            to: "/whatsnew",
                                                                            label: "Nouveaut\xe9s",
                                                                            icon: (0, $d0a62919ab5d714a$export$2e2bcd8739ae039)
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                                                                        touch: {
                                                                            display: 'hidden'
                                                                        }
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                                        "data-test": "user-logout",
                                                                        onClick: ()=>logout(),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                                color: "primary-dark",
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $caeeafb1d4a1f971$export$2e2bcd8739ae039), {})
                                                                            }),
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                renderAs: "span",
                                                                                children: "D\xe9connexion"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    !loggedAs && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                        roles: [
                                                            'superAdmin'
                                                        ],
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                            onClick: ()=>modal.setIsDisplayed(!modal.isDisplayed),
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                color: 'primary',
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                                                    flexWrap: "nowrap",
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4b2651edb550ad92$export$2e2bcd8739ae039), {})
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                                                touch: {
                                                    display: 'hidden'
                                                },
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$LoggedAsStatusItem, {
                                                    changeCurrentRole: changeCurrentRole,
                                                    size: "smallest"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'guest'
                                        ],
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                bold: true,
                                                label: "Connexion",
                                                to: "/login"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItem, {
                                                bold: true,
                                                label: "Kiosque",
                                                to: "/kiosk"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                    title: "Me connecter en tant que...",
                    actions: modal,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $45db3b5cb5fbc0ed$export$2e2bcd8739ae039), {
                        onSelect: ()=>modal.setIsDisplayed(false)
                    })
                })
            })
        ]
    });
};
const $d31d8fe330ea4953$var$LoggedAsStatusItem = ({ size: size = 'normal', changeCurrentRole: changeCurrentRole })=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const loggedAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.loggedAs);
    const loggedAsColorHandle = loggedAs?.organization?.type && (0, $1188dab5edd92185$export$92ca3e0143f2ea33)(currentUserRole);
    if (loggedAs?.organization?.name) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
        color: loggedAsColorHandle,
        size: size === 'smallest' ? 'small' : size,
        onClick: ()=>{
            const superAdminRole = currentUser?.roles.find((role)=>role.kind === 'superAdmin');
            superAdminRole && changeCurrentRole(superAdminRole);
        },
        children: [
            size !== 'smallest' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                textWeight: "bold",
                textColor: `${loggedAsColorHandle}-light`,
                children: loggedAs?.organization?.name
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                textColor: `${loggedAsColorHandle}-light`,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4e76a2997dcc5e78$export$2e2bcd8739ae039), {})
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
const $d31d8fe330ea4953$var$PendingInvationsTag = ({ count: count, style: style })=>{
    if (count === 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
        color: 'warning',
        style: style,
        title: `${count} invitation(s) en attente`,
        "data-test": 'pending-invitations-notification',
        children: count
    });
};
const $d31d8fe330ea4953$var$HeaderItemTitle = ({ label: label })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
        textWeight: "bold",
        renderAs: "div",
        children: label
    });
const $d31d8fe330ea4953$var$HeaderItem = ({ label: label, bold: bold = false, to: to, href: href, icon: icon, children: children, info: info, ...rest })=>{
    const CustomIcon = icon;
    const RenderAs = to ? (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a) : 'a';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Navbar).Item, {
        renderAs: RenderAs,
        ...to ? {
            to: to
        } : undefined,
        ...href ? {
            href: href
        } : undefined,
        ...bold ? {
            textWeight: 'bold'
        } : {},
        title: info,
        ...rest,
        children: [
            CustomIcon ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        color: "primary-dark",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(CustomIcon, {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: label
                    })
                ]
            }) : label,
            children
        ]
    });
};
const $d31d8fe330ea4953$var$UserRoles = ({ user: user, currentRole: currentRole, changeCurrentRole: changeCurrentRole, currentOrganization: currentOrganization })=>{
    const { commonRoles: commonRoles, organizationsRoles: organizationsRoles } = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!user) return {
            commonRoles: [],
            organizationsRoles: []
        };
        return {
            commonRoles: user.roles.filter((role)=>(role.kind === 'worker' || role.kind === 'superAdmin') && role.status === 'accepted'),
            organizationsRoles: user.roles.filter((role)=>(role.kind === 'interimAgencyMember' || role.kind === 'employerMember') && role.status === 'accepted')
        };
    }, [
        user,
        currentRole
    ]);
    if (commonRoles.length + organizationsRoles.length <= 1) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            (commonRoles[0] || organizationsRoles[0]) && commonRoles.length + organizationsRoles.length > 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d31d8fe330ea4953$var$HeaderItemTitle, {
                        label: "Changer de profil"
                    }),
                    commonRoles.map((role)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                            onClick: ()=>changeCurrentRole(role),
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                flexWrap: "nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        mr: 1,
                                        color: `${(0, $1188dab5edd92185$export$92ca3e0143f2ea33)(role.kind)}-dark`,
                                        backgroundColor: `${(0, $1188dab5edd92185$export$92ca3e0143f2ea33)(role.kind)}-light`,
                                        children: currentRole === role.kind ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $28ef1a36654d3a19$export$2e2bcd8739ae039), {}) : ''
                                    }),
                                    (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[role.kind]
                                ]
                            })
                        }, role._id)),
                    organizationsRoles.map((role)=>{
                        const organization = role.organization;
                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Navbar).Item, {
                            onClick: ()=>changeCurrentRole(role),
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                flexWrap: "nowrap",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        mr: 1,
                                        color: `${(0, $1188dab5edd92185$export$92ca3e0143f2ea33)(organization.type)}-dark`,
                                        backgroundColor: `${(0, $1188dab5edd92185$export$92ca3e0143f2ea33)(organization.type)}-light`,
                                        children: currentOrganization && currentOrganization._id === organization._id ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $28ef1a36654d3a19$export$2e2bcd8739ae039), {}) : ''
                                    }),
                                    organization.name
                                ]
                            })
                        }, role._id);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Divider, {
                touch: {
                    display: 'hidden'
                }
            })
        ]
    });
};
var $d31d8fe330ea4953$export$2e2bcd8739ae039 = $d31d8fe330ea4953$var$Header;
const $d31d8fe330ea4953$var$MobileNavbarSeparator = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "hr",
        my: 1,
        desktop: {
            display: 'hidden'
        }
    });
};






var $3ZYaX = parcelRequire("3ZYaX");



const $a3a830dde501b91e$export$f3e56218687c0d4f = ()=>{
    const appNeedsUpdateHelpers = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>({
            appNeedsUpdate: state.app.appNeedsUpdate,
            setAppNeedsUpdateUpdate: state.app.setAppNeedsUpdate
        }), (0, $b46b478a1bec4671$exports.shallow));
    return appNeedsUpdateHelpers;
};





var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");
const $58f73d374db62abb$var$minCountBackSeconds = 0;
const $58f73d374db62abb$var$maxCountBackSeconds = 60;
const $58f73d374db62abb$var$defaultCountBackSeconds = 3;
const $58f73d374db62abb$export$efe1f832d7526cc6 = (seconds = $58f73d374db62abb$var$defaultCountBackSeconds, cb)=>{
    const [countBack, setCountBack] = (0, $3ZYaX.useState)(seconds);
    if (seconds < $58f73d374db62abb$var$minCountBackSeconds || seconds > $58f73d374db62abb$var$maxCountBackSeconds) throw new Error(`Please provide a positive integer time value between ${$58f73d374db62abb$var$minCountBackSeconds} and ${$58f73d374db62abb$var$maxCountBackSeconds}  for useCountBack hook, provided : ${seconds}`);
    (0, $3ZYaX.useEffect)(()=>{
        let timeout;
        if (countBack > 0) timeout = setTimeout(()=>setCountBack((cB)=>cB - 1), 1000);
        return ()=>clearTimeout(timeout);
    }, [
        countBack
    ]);
    if (countBack === 0 && cb) (0, $2KSUA.once)(cb)();
    return countBack;
};
const $58f73d374db62abb$export$7400b11770f383d6 = ({ seconds: seconds = $58f73d374db62abb$var$defaultCountBackSeconds, cb: cb, children: children })=>{
    const countBack = $58f73d374db62abb$export$efe1f832d7526cc6(seconds, cb);
    if (countBack > 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
const $58f73d374db62abb$export$15cef08a1ebd9933 = ({ seconds: seconds = $58f73d374db62abb$var$defaultCountBackSeconds, cb: cb })=>{
    const countBack = $58f73d374db62abb$export$efe1f832d7526cc6(seconds, cb);
    return countBack;
};


const $9cc7e87f95314026$var$autoUpdateTimeout = 5000;
const $9cc7e87f95314026$export$b36f5fd6487f6854 = ()=>{
    const { appNeedsUpdate: appNeedsUpdate } = (0, $a3a830dde501b91e$export$f3e56218687c0d4f)();
    const { pathname: pathname } = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const isScannerOrKioskPage = pathname.includes('/laser-scanner') || pathname.includes('/qr-scanner');
    (0, $3ZYaX.useEffect)(()=>{
        if (!appNeedsUpdate) return;
        if (!isScannerOrKioskPage) return;
        // We are on a scanner/kiosk page, we want scanners/kiosks to be always up to date
        // Without even even asking user confirmation
        const timeout = setTimeout($9cc7e87f95314026$var$forceHardRefresh, $9cc7e87f95314026$var$autoUpdateTimeout);
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        appNeedsUpdate,
        isScannerOrKioskPage
    ]);
    if (!appNeedsUpdate) return;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
        closeOnBlur: false,
        closeOnEsc: false,
        show: true,
        showClose: false,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Content, {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                color: 'warning',
                backgroundColor: "warning-light",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                        children: "Nouvelle version disponible"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                        m: 0,
                        p: 3,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 3,
                                children: "Une nouvelle version de la plateforme est disponible."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                color: 'warning',
                                onClick: $9cc7e87f95314026$var$forceHardRefresh,
                                children: isScannerOrKioskPage ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        "Mise \xe0 jour automatique dans ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58f73d374db62abb$export$15cef08a1ebd9933), {
                                            seconds: $9cc7e87f95314026$var$autoUpdateTimeout / 1000
                                        }),
                                        ' ',
                                        "secondes"
                                    ]
                                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: "Appliquer la mise \xe0 jour"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $9cc7e87f95314026$var$forceHardRefresh = ()=>{
    // We first fetch the url in the background by explicitly not caching it in headers
    // Then do a "hard reload"
    // This is a combination of 2 methods talked in
    // https://stackoverflow.com/questions/2099201/javascript-hard-refresh-of-current-page
    const url = new URL(window.location.href);
    fetch(url, {
        headers: {
            Pragma: 'no-cache',
            Expires: '-1',
            'Cache-Control': 'no-cache'
        }
    })// @ts-expect-error
    // See https://developer.mozilla.org/en-US/docs/Web/API/Location/reload
    // Firefox accepts a forceReload boolean parameter
    // Other browsers will just discard the parameter
    .then((ok)=>window.location.reload(true)).catch((err)=>{
        console.error('Unexpected error when trying to prefetch before force hard refresh', err);
        // Refresh anyway
        // @ts-expect-error, see above
        window.location.reload(true);
    });
};



parcelRequire("3ZYaX");






const $296e32cfeffcd833$export$a06f1c675e846f6f = ()=>{
    const isDevEnvironment = (0, $58602f0dc5094d54$export$a595528b3e00ccc)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Footer), {
            textAlign: 'center',
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    textSize: 6,
                    mt: 3,
                    mb: 3,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                            centered: true,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                narrow: true,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                    to: "/help",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f713256e8ad1586), {})
                                            }),
                                            "Contactez le support"
                                        ]
                                    })
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    textSize: 7,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            centered: true,
                            py: 3,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    py: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                        to: "/privacy-policy",
                                        children: "Politique de Confidentialit\xe9"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    py: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                        to: "/terms-of-use",
                                        children: "Conditions G\xe9n\xe9rales d'Utilisation"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                    roles: [
                                        'worker'
                                    ],
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            narrow: true,
                                            py: 1,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                                href: (0, $05aa31a7e1e0b1e2$export$2e2bcd8739ae039).mobileApps.apple.store.url,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6940787f97640fd), {})
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            narrow: true,
                                            py: 1,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                                href: (0, $05aa31a7e1e0b1e2$export$2e2bcd8739ae039).mobileApps.android.store.url,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ab2f0aaabb79022e), {})
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                isDevEnvironment && "277e83e744ab7890a8aa594a13c5b5487b3f9631" && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                    mt: 3,
                    color: 'warning',
                    display: "inline-block",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                        textSize: 7,
                        children: [
                            "Environnement de d\xe9veloppement ",
                            "277e83e744ab7890a8aa594a13c5b5487b3f9631"
                        ]
                    })
                })
            ]
        })
    });
};


const $334d6d5468272b41$var$Layout = ({ children: children, hideHeader: hideHeader, hideFooter: hideFooter })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
        children: [
            !hideHeader && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d31d8fe330ea4953$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9cc7e87f95314026$export$b36f5fd6487f6854), {}),
            children,
            !hideFooter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {}),
            !hideFooter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $296e32cfeffcd833$export$a06f1c675e846f6f), {})
        ]
    });
};
var $334d6d5468272b41$export$2e2bcd8739ae039 = $334d6d5468272b41$var$Layout;


/**
 * Composant de mise en page réutilisable pour les pages de type liste
 */ const $f71db929d54fcb96$var$ListPageLayout = ({ title: title, subtitle: subtitle, action: action, filters: filters, children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "center",
                        mb: 4,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
                                    title: title,
                                    subTitle: subtitle
                                })
                            }),
                            action && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: action
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                        children: [
                            filters && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 6,
                                children: filters
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mt: filters ? 6 : 0,
                                children: children
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $f71db929d54fcb96$export$2e2bcd8739ae039 = $f71db929d54fcb96$var$ListPageLayout;




const $9758083a3d76fd58$var$ClockingsList = ()=>{
    const { filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).clockings);
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const clockingsQuery = (0, $d19e678f97a3d4d6$export$556810fba3a25e86)({
        limit: 300,
        start: filters.start,
        end: filters.end,
        user: filters.user?.[0] ? filters.user : undefined,
        start: (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()), 7)
    }, {
        refetchInterval: 10000,
        enabled: Boolean(filters?.start)
    });
    const tableColumns = $9758083a3d76fd58$var$useListTableColumns(clockingsQuery.data || [], currentUserRole);
    const action = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
        roles: [
            'employerMember'
        ],
        action: {
            resource: 'clockings',
            name: 'create'
        },
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
            renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
            to: "/qr-scanner",
            outlined: true,
            color: "primary",
            size: "small",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $49ec271fdb2fbc83$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                    children: "Pointer"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71db929d54fcb96$export$2e2bcd8739ae039), {
        title: "Liste des derniers pointages",
        subtitle: "Affiche les pointages les plus r\xe9cents",
        action: action,
        filters: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e11b6f75fdbe3ac4$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
            columns: tableColumns,
            data: clockingsQuery.data || [],
            noDataMessage: "Aucun pointage \xe0 afficher"
        })
    });
};
var $9758083a3d76fd58$export$2e2bcd8739ae039 = $9758083a3d76fd58$var$ClockingsList;
const $9758083a3d76fd58$var$useListTableColumns = (data, currentUserRole)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            currentUserRole !== 'worker' && {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                accessor: 'user',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    return (0, $25ffbf4bca475b04$export$9a57c514c234d759)(clocking.user);
                }
            },
            {
                Header: 'Pointage',
                accessor: 'createdAt',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    return new Date(clocking.createdAt).toLocaleString();
                }
            },
            currentUserRole !== 'interimAgencyMember' && {
                Header: 'Agence',
                accessor: 'interimAgency',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    return clocking.mission?.interimAgency?.name || '';
                }
            },
            currentUserRole !== 'employerMember' && {
                Header: 'Employeur',
                accessor: 'employer',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    return clocking?.employer?.name || '';
                }
            },
            {
                Header: 'Type',
                accessor: 'entry',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    const status = (0, $2d012ef836db6bd8$export$b70265791d2079d4)(clocking);
                    return status;
                }
            },
            currentUserRole !== 'worker' && {
                Header: "Journ\xe9e",
                accessor: 'workPeriod',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    //TODO: helper
                    return clocking.type && clocking.mission && clocking.workPeriod ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                        to: `/missions/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(clocking.mission)}/work-periods/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(clocking.workPeriod)}`,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $24f98ff5b23495eb$export$2e2bcd8739ae039), {})
                        })
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        disabled: true,
                        color: "ghost",
                        size: "small",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $692d0667ec40027c$export$2e2bcd8739ae039), {})
                        })
                    });
                }
            },
            currentUserRole !== 'worker' && {
                Header: 'Mission',
                accessor: 'mission',
                Cell: (data)=>{
                    const clocking = data.cell.row.original;
                    return clocking.mission ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                        to: `/missions/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(clocking.mission)}`,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e9ef9c9c47c5e10d$export$2e2bcd8739ae039), {})
                        })
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        disabled: true,
                        color: "ghost",
                        size: "small",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $692d0667ec40027c$export$2e2bcd8739ae039), {})
                        })
                    });
                }
            }
        ].filter((c)=>c), [
        data,
        currentUserRole
    ]);
};




var $3ZYaX = parcelRequire("3ZYaX");




var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");



const { passwordValidation: { rule: $d92bced011ae5ac2$var$rule, message: $d92bced011ae5ac2$var$message } } = (0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039);
const $d92bced011ae5ac2$var$regex = new RegExp($d92bced011ae5ac2$var$rule);
const $d92bced011ae5ac2$export$65ed9482db2257fa = (props)=>{
    // State for password field: change type
    const [showPassword, setShowPassword] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    // Input type: password by default, text if password is visible to the user
    const inputType = showPassword ? 'text' : 'password';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                required: true,
                autoComplete: "current-password",
                ...props,
                type: inputType
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                    checked: showPassword,
                    onClick: ()=>setShowPassword(!showPassword),
                    tabIndex: -1,
                    children: "Afficher le mot de passe"
                })
            })
        ]
    });
};
const $d92bced011ae5ac2$export$4c8fbcc76e8879d0 = (props)=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d92bced011ae5ac2$export$65ed9482db2257fa, {
        validate: $d92bced011ae5ac2$export$e36e0bbf46ae5cf3,
        autoComplete: "new-password",
        ...props
    });
};
const $d92bced011ae5ac2$export$e36e0bbf46ae5cf3 = (value)=>{
    if (value.length > 0 && !$d92bced011ae5ac2$var$regex.test(value)) return $d92bced011ae5ac2$var$message;
    return false;
};




var $3ZYaX = parcelRequire("3ZYaX");
function $6e566d8f24c5fdea$var$DotsHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z"
    }));
}
const $6e566d8f24c5fdea$var$ForwardRef = $3ZYaX.forwardRef($6e566d8f24c5fdea$var$DotsHorizontalIcon);
var $6e566d8f24c5fdea$export$2e2bcd8739ae039 = $6e566d8f24c5fdea$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $7f7682b42edc1d4e$var$ExclamationCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $7f7682b42edc1d4e$var$ForwardRef = $3ZYaX.forwardRef($7f7682b42edc1d4e$var$ExclamationCircleIcon);
var $7f7682b42edc1d4e$export$2e2bcd8739ae039 = $7f7682b42edc1d4e$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");

const $d1bed00ffa1df582$var$defaultDelay = 5000;
const $d1bed00ffa1df582$var$getRequestColor = (status)=>{
    let color = 'info';
    if (status === 'error') color = 'danger';
    else if (status === 'success') color = 'success';
    return color;
};
const $d1bed00ffa1df582$export$b24c9e445714b301 = ({ mutation: mutation, children: children, delay: delay, ...rest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
        ...rest,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                children: children
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d1bed00ffa1df582$var$RequestIcon, {
                mutation: mutation,
                delay: delay
            })
        ]
    });
};
const $d1bed00ffa1df582$var$useRequestComponent = (delay, mutation)=>{
    const [displayRequestStatus, setDisplayRequestStatus] = (0, $3ZYaX.useState)('idle');
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (mutation) {
            let timeout;
            if (delay !== 0) {
                setDisplayRequestStatus(mutation.status);
                timeout = setTimeout(()=>{
                    setDisplayRequestStatus('idle');
                }, delay);
            }
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        }
    }, [
        mutation?.status
    ]);
    return displayRequestStatus;
};
const $d1bed00ffa1df582$var$RequestIcon = ({ mutation: mutation, delay: delay = $d1bed00ffa1df582$var$defaultDelay })=>{
    const status = $d1bed00ffa1df582$var$useRequestComponent(delay, mutation);
    const color = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>$d1bed00ffa1df582$var$getRequestColor(status), [
        status
    ]);
    if (status === 'idle') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon), {
        color: color,
        children: [
            status === 'error' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7f7682b42edc1d4e$export$2e2bcd8739ae039), {}),
            status === 'success' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e3404f2a2f59579e$export$2e2bcd8739ae039), {}),
            status === 'loading' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6e566d8f24c5fdea$export$2e2bcd8739ae039), {})
        ]
    });
};
const $d1bed00ffa1df582$export$aa069c2f85e0ca51 = ({ mutation: mutation, delay: delay = $d1bed00ffa1df582$var$defaultDelay, displayOn: displayOn })=>{
    const displayOnDefaultConfig = {
        error: true,
        success: false,
        inProgress: false
    };
    const on = Object.assign(displayOnDefaultConfig, displayOn);
    const status = $d1bed00ffa1df582$var$useRequestComponent(delay, mutation);
    const color = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>$d1bed00ffa1df582$var$getRequestColor(status), [
        status
    ]);
    if (!status) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    const isError = status === 'error' && on.error;
    const isInProgress = status === 'loading' && on.inProgress;
    const isSuccess = status === 'success' && on.success;
    const displayMessage = isError || isInProgress || isSuccess;
    const errorMessage = isError && on.error && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
        children: [
            mutation?.error?.response?.data?.message,
            mutation?.error?.response?.data?.data?.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                children: mutation?.error?.response?.data?.data?.map((errorDetail)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                        children: errorDetail?.message
                    }))
            })
        ]
    });
    if (displayMessage) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        textColor: color,
        children: [
            isError && (typeof isError === 'string' ? isError : errorMessage),
            isInProgress && (typeof isInProgress === 'string' ? isInProgress : 'Envoi en cours...'),
            isSuccess && (typeof isSuccess === 'string' ? isSuccess : "Op\xe9ration r\xe9alis\xe9e avec succ\xe8s")
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
const $d1bed00ffa1df582$export$e799877f097d0fa1 = ({ mutation: mutation, delay: delay = $d1bed00ffa1df582$var$defaultDelay, displayOn: displayOn })=>{
    const status = $d1bed00ffa1df582$var$useRequestComponent(delay, mutation);
    if (status === 'idle' || !mutation) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d1bed00ffa1df582$var$RequestIcon, {
                mutation: mutation
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d1bed00ffa1df582$export$aa069c2f85e0ca51, {
                mutation: mutation,
                displayOn: displayOn
            })
        ]
    });
};



const $cb38d915bad6f3af$var$LoginForm = ({ loginAsQrScannerForEmployerId: loginAsQrScannerForEmployerId })=>{
    const authMutation = (0, $e607e015ac40917d$export$7d483d5f301dc18f)();
    const initialValues = {
        email: '',
        password: ''
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
            initialValues: initialValues,
            enableReinitialize: true,
            validate: (values)=>{
                const errors = {};
                if (!values.email) errors.email = 'Champ requis';
                if (!values.password) errors.password = 'Champ requis';
                return errors;
            },
            onSubmit: (values)=>{
                const payload = values;
                if (loginAsQrScannerForEmployerId) payload['loginAsQrScannerForEmployerId'] = loginAsQrScannerForEmployerId;
                authMutation.mutate(payload);
            },
            children: ()=>{
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Email",
                                    name: "email",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    type: "email",
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$65ed9482db2257fa), {
                                    label: "Mot de passe",
                                    name: "password",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mt: 5,
                                    textAlign: "center",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$e799877f097d0fa1), {
                                        mutation: authMutation,
                                        displayOn: {
                                            error: 'Email ou mot de passe inconnu'
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                            mt: 5,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        color: "ghost",
                                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                        to: "/request-new-password",
                                        children: "Mot de passe perdu ?"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                        color: "primary",
                                        type: "submit",
                                        mutation: authMutation,
                                        children: "Se connecter"
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
var $cb38d915bad6f3af$export$2e2bcd8739ae039 = $cb38d915bad6f3af$var$LoginForm;





var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");


var $3ZYaX = parcelRequire("3ZYaX");
function $8247dfea1489559e$var$RefreshIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z",
        clipRule: "evenodd"
    }));
}
const $8247dfea1489559e$var$ForwardRef = $3ZYaX.forwardRef($8247dfea1489559e$var$RefreshIcon);
var $8247dfea1489559e$export$2e2bcd8739ae039 = $8247dfea1489559e$var$ForwardRef;




var $3ZYaX = parcelRequire("3ZYaX");
function $6eaf6428dd466039$var$CheckCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $6eaf6428dd466039$var$ForwardRef = $3ZYaX.forwardRef($6eaf6428dd466039$var$CheckCircleIcon);
var $6eaf6428dd466039$export$2e2bcd8739ae039 = $6eaf6428dd466039$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");

const $8097e9f30a7d1ddb$export$f38e41fee9d4dd51 = ()=>{
    const [navigatorOnline, setNavigatorOnline] = (0, $3ZYaX.useState)(navigator.onLine);
    const checkAppVersionQuery = (0, $d19e678f97a3d4d6$export$6e1909113a21f5d2)(60000);
    (0, $3ZYaX.useEffect)(()=>{
        const handleOnline = ()=>setNavigatorOnline(true);
        const handleOffline = ()=>setNavigatorOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return ()=>{
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);
    const serverReachable = checkAppVersionQuery.dataUpdatedAt > 0 && checkAppVersionQuery.isFetched;
    const isOnline = navigatorOnline && serverReachable;
    return {
        isOnline: isOnline
    };
};




var $3ZYaX = parcelRequire("3ZYaX");
var $f617f1ff23601f7d$exports = {};
"use strict";
function $f617f1ff23601f7d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f617f1ff23601f7d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f617f1ff23601f7d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f617f1ff23601f7d$var$_typeof(obj);
}
var $f617f1ff23601f7d$var$_class, $f617f1ff23601f7d$var$_temp;
function $f617f1ff23601f7d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f617f1ff23601f7d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f617f1ff23601f7d$var$ownKeys(Object(source), true).forEach(function(key) {
            $f617f1ff23601f7d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f617f1ff23601f7d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f617f1ff23601f7d$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $f617f1ff23601f7d$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $f617f1ff23601f7d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f617f1ff23601f7d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f617f1ff23601f7d$var$_arrayLikeToArray(o, minLen);
}
function $f617f1ff23601f7d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f617f1ff23601f7d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f617f1ff23601f7d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f617f1ff23601f7d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f617f1ff23601f7d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f617f1ff23601f7d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f617f1ff23601f7d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f617f1ff23601f7d$var$_setPrototypeOf(subClass, superClass);
}
function $f617f1ff23601f7d$var$_setPrototypeOf(o, p) {
    $f617f1ff23601f7d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f617f1ff23601f7d$var$_setPrototypeOf(o, p);
}
function $f617f1ff23601f7d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f617f1ff23601f7d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f617f1ff23601f7d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f617f1ff23601f7d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f617f1ff23601f7d$var$_possibleConstructorReturn(this, result);
    };
}
function $f617f1ff23601f7d$var$_possibleConstructorReturn(self, call) {
    if (call && ($f617f1ff23601f7d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $f617f1ff23601f7d$var$_assertThisInitialized(self);
}
function $f617f1ff23601f7d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f617f1ff23601f7d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f617f1ff23601f7d$var$_getPrototypeOf(o) {
    $f617f1ff23601f7d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f617f1ff23601f7d$var$_getPrototypeOf(o);
}
function $f617f1ff23601f7d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $3ZYaX = parcelRequire("3ZYaX");
var $f617f1ff23601f7d$var$Component = $3ZYaX.Component;

var $9C0qR = parcelRequire("9C0qR");
var $a70d5e29c38384aa$exports = {};
"use strict";
var $6509167ee2fbc1f5$exports = {};
"use strict";
function $6509167ee2fbc1f5$var$NoVideoInputDevicesError() {
    this.name = 'NoVideoInputDevicesError';
    this.message = 'No video input devices found';
}
$6509167ee2fbc1f5$var$NoVideoInputDevicesError.prototype = new Error();
$6509167ee2fbc1f5$exports = {
    NoVideoInputDevicesError: $6509167ee2fbc1f5$var$NoVideoInputDevicesError
};


var $a70d5e29c38384aa$var$NoVideoInputDevicesError = $6509167ee2fbc1f5$exports.NoVideoInputDevicesError;
function $a70d5e29c38384aa$var$defaultDeviceIdChooser(filteredDevices, videoDevices, facingMode) {
    if (filteredDevices.length > 0) return filteredDevices[0].deviceId;
    if (videoDevices.length == 1 || facingMode == 'user') return videoDevices[0].deviceId;
    return videoDevices[1].deviceId;
}
var $a70d5e29c38384aa$var$getFacingModePattern = function getFacingModePattern(facingMode) {
    return facingMode == 'environment' ? /rear|back|environment/ig : /front|user|face/ig;
};
function $a70d5e29c38384aa$var$getDeviceId(facingMode) {
    var chooseDeviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a70d5e29c38384aa$var$defaultDeviceIdChooser;
    // Get manual deviceId from available devices.
    return new Promise(function(resolve, reject) {
        var enumerateDevices;
        try {
            enumerateDevices = navigator.mediaDevices.enumerateDevices();
        } catch (err) {
            reject(new $a70d5e29c38384aa$var$NoVideoInputDevicesError());
        }
        enumerateDevices.then(function(devices) {
            // Filter out non-videoinputs
            var videoDevices = devices.filter(function(device) {
                return device.kind == 'videoinput';
            });
            if (videoDevices.length < 1) {
                reject(new $a70d5e29c38384aa$var$NoVideoInputDevicesError());
                return;
            }
            var pattern = $a70d5e29c38384aa$var$getFacingModePattern(facingMode); // Filter out video devices without the pattern
            var filteredDevices = videoDevices.filter(function(_ref) {
                var label = _ref.label;
                return pattern.test(label);
            });
            resolve(chooseDeviceId(filteredDevices, videoDevices, facingMode));
        });
    });
}
$a70d5e29c38384aa$exports = {
    getDeviceId: $a70d5e29c38384aa$var$getDeviceId,
    getFacingModePattern: $a70d5e29c38384aa$var$getFacingModePattern
};


var $f617f1ff23601f7d$var$getDeviceId = $a70d5e29c38384aa$exports.getDeviceId;
var $31a52e240c35fd59$exports = {};
"use strict";
$31a52e240c35fd59$exports = function havePropsChanged(prevProps, nextProps, keys) {
    var changedProps = [];
    keys.forEach(function(key) {
        if (prevProps[key] != nextProps[key]) changedProps.push(key);
    });
    return changedProps;
};


var $1c5c038bd064fe7d$exports = {};
"use strict";
/**
 * From https://gist.github.com/nolanlawson/10340255
 */ $1c5c038bd064fe7d$exports = function createBlob(parts, properties) {
    parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== "TypeError") throw e;
        var BlobBuilder = window.BlobBuilder || window.MSBlobBuilder || window.MozBlobBuilder || window.WebKitBlobBuilder;
        var builder = new BlobBuilder();
        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
        return builder.getBlob(properties.type);
    }
};


// eslint-disable-next-line
var $f617f1ff23601f7d$var$workerBlob = $1c5c038bd064fe7d$exports([
    "class BitMatrix{constructor(e,o){this.width=o,this.height=e.length/o,this.data=e}static createEmpty(e,o){return new BitMatrix(new Uint8ClampedArray(e*o),e)}get(e,o){return!(e<0||e>=this.width||o<0||o>=this.height)&&!!this.data[o*this.width+e]}set(e,o,r){this.data[o*this.width+e]=r?1:0}setRegion(r,e,t,s,c){for(let o=e;o<e+s;o++)for(let e=r;e<r+t;e++)this.set(e,o,!!c)}}const REGION_SIZE=8,MIN_DYNAMIC_RANGE=24;function numBetween(e,o,r){return e<o?o:r<e?r:e}class Matrix{constructor(e,o,r){o=(this.width=e)*o;if(r&&r.length!==o)throw new Error(\"Wrong buffer size\");this.data=r||new Uint8ClampedArray(o)}get(e,o){return this.data[o*this.width+e]}set(e,o,r){this.data[o*this.width+e]=r}}function binarize(r,t,e,c,s,o){var d=t*e;if(r.length!==4*d)throw new Error(\"Malformed data passed to binarizer.\");let a=0,l;o&&(l=new Uint8ClampedArray(r.buffer,a,d),a+=d);const n=new Matrix(t,e,l);if(s.useIntegerApproximation)for(let o=0;o<e;o++)for(let e=0;e<t;e++){var i=4*(o*t+e),B=r[i],k=r[1+i],i=r[2+i];n.set(e,o,s.red*B+s.green*k+s.blue*i+128>>8)}else for(let o=0;o<e;o++)for(let e=0;e<t;e++){var u=4*(o*t+e),m=r[u],C=r[1+u],u=r[2+u];n.set(e,o,s.red*m+s.green*C+s.blue*u)}var w=Math.ceil(t/REGION_SIZE),P=Math.ceil(e/REGION_SIZE),f=w*P;let h;o&&(h=new Uint8ClampedArray(r.buffer,a,f),a+=f);const v=new Matrix(w,P,h);for(let c=0;c<P;c++)for(let s=0;s<w;s++){let r=1/0,t=0;for(let o=0;o<REGION_SIZE;o++)for(let e=0;e<REGION_SIZE;e++){var b=n.get(s*REGION_SIZE+e,c*REGION_SIZE+o);r=Math.min(r,b),t=Math.max(t,b)}let e=(r+t)/2;var g;e=Math.min(255,1.11*e),t-r<=MIN_DYNAMIC_RANGE&&(e=r/2,0<c&&0<s&&(g=(v.get(s,c-1)+2*v.get(s-1,c)+v.get(s-1,c-1))/4,r<g&&(e=g))),v.set(s,c,e)}let y;y=o?(f=new Uint8ClampedArray(r.buffer,a,d),a+=d,new BitMatrix(f,t)):BitMatrix.createEmpty(t,e);let p=null;c&&(p=o?(d=new Uint8ClampedArray(r.buffer,a,d),new BitMatrix(d,t)):BitMatrix.createEmpty(t,e));for(let s=0;s<P;s++)for(let t=0;t<w;t++){var M=numBetween(t,2,w-3),x=numBetween(s,2,P-3);let r=0;for(let o=-2;o<=2;o++)for(let e=-2;e<=2;e++)r+=v.get(M+o,x+e);var L=r/25;for(let o=0;o<REGION_SIZE;o++)for(let e=0;e<REGION_SIZE;e++){var A=t*REGION_SIZE+o,I=s*REGION_SIZE+e,N=n.get(A,I);y.set(A,I,N<=L),c&&p.set(A,I,!(N<=L))}}return c?{binarized:y,inverted:p}:{binarized:y}}class BitStream{constructor(e){this.byteOffset=0,this.bitOffset=0,this.bytes=e}readBits(e){if(e<1||32<e||e>this.available())throw new Error(\"Cannot read \"+e.toString()+\" bits\");let o=0;var r,t;if(0<this.bitOffset&&(r=(r=8-this.bitOffset)-(t=e<r?e:r),o=(this.bytes[this.byteOffset]&255>>8-t<<r)>>r,e-=t,this.bitOffset+=t,8===this.bitOffset&&(this.bitOffset=0,this.byteOffset++)),0<e){for(;8<=e;)o=o<<8|255&this.bytes[this.byteOffset],this.byteOffset++,e-=8;0<e&&(t=8-e,o=o<<e|(this.bytes[this.byteOffset]&255>>t<<t)>>t,this.bitOffset+=e)}return o}available(){return 8*(this.bytes.length-this.byteOffset)-this.bitOffset}}var Mode,ModeByte;function decodeNumeric(e,o){const r=[];let t=\"\";let s=e.readBits([10,12,14][o]);for(;3<=s;){var c=e.readBits(10);if(1e3<=c)throw new Error(\"Invalid numeric value above 999\");const d=Math.floor(c/100),a=Math.floor(c/10)%10,l=c%10;r.push(48+d,48+a,48+l),t+=d.toString()+a.toString()+l.toString(),s-=3}if(2===s){o=e.readBits(7);if(100<=o)throw new Error(\"Invalid numeric value above 99\");const n=Math.floor(o/10),i=o%10;r.push(48+n,48+i),t+=n.toString()+i.toString()}else if(1===s){const B=e.readBits(4);if(10<=B)throw new Error(\"Invalid numeric value above 9\");r.push(48+B),t+=B.toString()}return{bytes:r,text:t}}!function(e){e.Numeric=\"numeric\",e.Alphanumeric=\"alphanumeric\",e.Byte=\"byte\",e.Kanji=\"kanji\",e.ECI=\"eci\",e.StructuredAppend=\"structuredappend\"}(Mode=Mode||{}),function(e){e[e.Terminator=0]=\"Terminator\",e[e.Numeric=1]=\"Numeric\",e[e.Alphanumeric=2]=\"Alphanumeric\",e[e.Byte=4]=\"Byte\",e[e.Kanji=8]=\"Kanji\",e[e.ECI=7]=\"ECI\",e[e.StructuredAppend=3]=\"StructuredAppend\"}(ModeByte=ModeByte||{});const AlphanumericCharacterCodes=[\"0\",\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\" \",\"$\",\"%\",\"*\",\"+\",\"-\",\".\",\"/\",\":\"];function decodeAlphanumeric(e,o){const r=[];let t=\"\";let s=e.readBits([9,11,13][o]);for(;2<=s;){var c=e.readBits(11),d=Math.floor(c/45),c=c%45;r.push(AlphanumericCharacterCodes[d].charCodeAt(0),AlphanumericCharacterCodes[c].charCodeAt(0)),t+=AlphanumericCharacterCodes[d]+AlphanumericCharacterCodes[c],s-=2}return 1===s&&(o=e.readBits(6),r.push(AlphanumericCharacterCodes[o].charCodeAt(0)),t+=AlphanumericCharacterCodes[o]),{bytes:r,text:t}}function decodeByte(o,e){const r=[];let t=\"\";var s=o.readBits([8,16,16][e]);for(let e=0;e<s;e++){var c=o.readBits(8);r.push(c)}try{t+=decodeURIComponent(r.map(e=>`%${(\"0\"+e.toString(16)).substr(-2)}`).join(\"\"))}catch(e){}return{bytes:r,text:t}}function decodeKanji(o,e){const r=[];var t=o.readBits([8,10,12][e]);for(let e=0;e<t;e++){var s=o.readBits(13);let e=Math.floor(s/192)<<8|s%192;e<7936?e+=33088:e+=49472,r.push(e>>8,255&e)}e=new TextDecoder(\"shift-jis\").decode(Uint8Array.from(r));return{bytes:r,text:e}}function decode$2(e,o){const r=new BitStream(e);var t=o<=9?0:o<=26?1:2;const s={text:\"\",bytes:[],chunks:[],version:o};for(;4<=r.available();){var c,d,a=r.readBits(4);if(a===ModeByte.Terminator)return s;a===ModeByte.ECI?0===r.readBits(1)?s.chunks.push({type:Mode.ECI,assignmentNumber:r.readBits(7)}):0===r.readBits(1)?s.chunks.push({type:Mode.ECI,assignmentNumber:r.readBits(14)}):0===r.readBits(1)?s.chunks.push({type:Mode.ECI,assignmentNumber:r.readBits(21)}):s.chunks.push({type:Mode.ECI,assignmentNumber:-1}):a===ModeByte.Numeric?(c=decodeNumeric(r,t),s.text+=c.text,s.bytes.push(...c.bytes),s.chunks.push({type:Mode.Numeric,text:c.text})):a===ModeByte.Alphanumeric?(c=decodeAlphanumeric(r,t),s.text+=c.text,s.bytes.push(...c.bytes),s.chunks.push({type:Mode.Alphanumeric,text:c.text})):a===ModeByte.Byte?(d=decodeByte(r,t),s.text+=d.text,s.bytes.push(...d.bytes),s.chunks.push({type:Mode.Byte,bytes:d.bytes,text:d.text})):a===ModeByte.Kanji?(d=decodeKanji(r,t),s.text+=d.text,s.bytes.push(...d.bytes),s.chunks.push({type:Mode.Kanji,bytes:d.bytes,text:d.text})):a===ModeByte.StructuredAppend&&s.chunks.push({type:Mode.StructuredAppend,currentSequence:r.readBits(4),totalSequence:r.readBits(4),parity:r.readBits(8)})}if(0===r.available()||0===r.readBits(r.available()))return s}class GenericGFPoly{constructor(e,r){if(0===r.length)throw new Error(\"No coefficients.\");this.field=e;var t=r.length;if(1<t&&0===r[0]){let o=1;for(;o<t&&0===r[o];)o++;if(o===t)this.coefficients=e.zero.coefficients;else{this.coefficients=new Uint8ClampedArray(t-o);for(let e=0;e<this.coefficients.length;e++)this.coefficients[e]=r[o+e]}}else this.coefficients=r}degree(){return this.coefficients.length-1}isZero(){return 0===this.coefficients[0]}getCoefficient(e){return this.coefficients[this.coefficients.length-1-e]}addOrSubtract(e){if(this.isZero())return e;if(e.isZero())return this;let o=this.coefficients,r=e.coefficients;o.length>r.length&&([o,r]=[r,o]);const t=new Uint8ClampedArray(r.length);var s=r.length-o.length;for(let e=0;e<s;e++)t[e]=r[e];for(let e=s;e<r.length;e++)t[e]=addOrSubtractGF(o[e-s],r[e]);return new GenericGFPoly(this.field,t)}multiply(o){if(0===o)return this.field.zero;if(1===o)return this;var r=this.coefficients.length;const t=new Uint8ClampedArray(r);for(let e=0;e<r;e++)t[e]=this.field.multiply(this.coefficients[e],o);return new GenericGFPoly(this.field,t)}multiplyPoly(e){if(this.isZero()||e.isZero())return this.field.zero;var r=this.coefficients,t=r.length,s=e.coefficients,c=s.length;const d=new Uint8ClampedArray(t+c-1);for(let o=0;o<t;o++){var a=r[o];for(let e=0;e<c;e++)d[o+e]=addOrSubtractGF(d[o+e],this.field.multiply(a,s[e]))}return new GenericGFPoly(this.field,d)}multiplyByMonomial(e,o){if(e<0)throw new Error(\"Invalid degree less than 0\");if(0===o)return this.field.zero;var r=this.coefficients.length;const t=new Uint8ClampedArray(r+e);for(let e=0;e<r;e++)t[e]=this.field.multiply(this.coefficients[e],o);return new GenericGFPoly(this.field,t)}evaluateAt(o){let r=0;if(0===o)return this.getCoefficient(0);var t=this.coefficients.length;if(1===o)return this.coefficients.forEach(e=>{r=addOrSubtractGF(r,e)}),r;r=this.coefficients[0];for(let e=1;e<t;e++)r=addOrSubtractGF(this.field.multiply(o,r),this.coefficients[e]);return r}}function addOrSubtractGF(e,o){return e^o}class GenericGF{constructor(e,o,r){this.primitive=e,this.size=o,this.generatorBase=r,this.expTable=new Array(this.size),this.logTable=new Array(this.size);let t=1;for(let e=0;e<this.size;e++)this.expTable[e]=t,t*=2,t>=this.size&&(t=(t^this.primitive)&this.size-1);for(let e=0;e<this.size-1;e++)this.logTable[this.expTable[e]]=e;this.zero=new GenericGFPoly(this,Uint8ClampedArray.from([0])),this.one=new GenericGFPoly(this,Uint8ClampedArray.from([1]))}multiply(e,o){return 0===e||0===o?0:this.expTable[(this.logTable[e]+this.logTable[o])%(this.size-1)]}inverse(e){if(0===e)throw new Error(\"Can't invert 0\");return this.expTable[this.size-this.logTable[e]-1]}buildMonomial(e,o){if(e<0)throw new Error(\"Invalid monomial degree less than 0\");if(0===o)return this.zero;const r=new Uint8ClampedArray(e+1);return r[0]=o,new GenericGFPoly(this,r)}log(e){if(0===e)throw new Error(\"Can't take log(0)\");return this.logTable[e]}exp(e){return this.expTable[e]}}function runEuclideanAlgorithm(o,e,r,t){e.degree()<r.degree()&&([e,r]=[r,e]);let s=e,c=r,d=o.zero,a=o.one;for(;c.degree()>=t/2;){var l=s,n=d;if(s=c,d=a,s.isZero())return null;c=l;let e=o.zero;for(var l=s.getCoefficient(s.degree()),i=o.inverse(l);c.degree()>=s.degree()&&!c.isZero();){var B=c.degree()-s.degree(),k=o.multiply(c.getCoefficient(c.degree()),i);e=e.addOrSubtract(o.buildMonomial(B,k)),c=c.addOrSubtract(s.multiplyByMonomial(B,k))}if(a=e.multiplyPoly(d).addOrSubtract(n),c.degree()>=s.degree())return null}r=a.getCoefficient(0);if(0===r)return null;r=o.inverse(r);return[a.multiply(r),c.multiply(r)]}function findErrorLocations(o,r){var t=r.degree();if(1===t)return[r.getCoefficient(1)];const s=new Array(t);let c=0;for(let e=1;e<o.size&&c<t;e++)0===r.evaluateAt(e)&&(s[c]=o.inverse(e),c++);return c!==t?null:s}function findErrorMagnitudes(t,e,s){var c=s.length;const d=new Array(c);for(let r=0;r<c;r++){var a=t.inverse(s[r]);let o=1;for(let e=0;e<c;e++)r!==e&&(o=t.multiply(o,addOrSubtractGF(1,t.multiply(s[e],a))));d[r]=t.multiply(e.evaluateAt(a),t.inverse(o)),0!==t.generatorBase&&(d[r]=t.multiply(d[r],a))}return d}function decode$1(e,o){const r=new Uint8ClampedArray(e.length);r.set(e);const t=new GenericGF(285,256,0),s=new GenericGFPoly(t,r),c=new Uint8ClampedArray(o);let d=!1;for(let e=0;e<o;e++){var a=s.evaluateAt(t.exp(e+t.generatorBase));0!==(c[c.length-1-e]=a)&&(d=!0)}if(!d)return r;e=new GenericGFPoly(t,c),e=runEuclideanAlgorithm(t,t.buildMonomial(o,1),e,o);if(null===e)return null;var l=findErrorLocations(t,e[0]);if(null==l)return null;var n=findErrorMagnitudes(t,e[1],l);for(let e=0;e<l.length;e++){var i=r.length-1-t.log(l[e]);if(i<0)return null;r[i]=addOrSubtractGF(r[i],n[e])}return r}const VERSIONS=[{infoBits:null,versionNumber:1,alignmentPatternCenters:[],errorCorrectionLevels:[{ecCodewordsPerBlock:7,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:13,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:13}]},{ecCodewordsPerBlock:17,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:2,alignmentPatternCenters:[6,18],errorCorrectionLevels:[{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:34}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:28}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]}]},{infoBits:null,versionNumber:3,alignmentPatternCenters:[6,22],errorCorrectionLevels:[{ecCodewordsPerBlock:15,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:55}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:13}]}]},{infoBits:null,versionNumber:4,alignmentPatternCenters:[6,26],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:80}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:32}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:5,alignmentPatternCenters:[6,30],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:43}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:11},{numBlocks:2,dataCodewordsPerBlock:12}]}]},{infoBits:null,versionNumber:6,alignmentPatternCenters:[6,34],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:27}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:31892,versionNumber:7,alignmentPatternCenters:[6,22,38],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:78}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:31}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:13},{numBlocks:1,dataCodewordsPerBlock:14}]}]},{infoBits:34236,versionNumber:8,alignmentPatternCenters:[6,24,42],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:97}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:38},{numBlocks:2,dataCodewordsPerBlock:39}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:18},{numBlocks:2,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:14},{numBlocks:2,dataCodewordsPerBlock:15}]}]},{infoBits:39577,versionNumber:9,alignmentPatternCenters:[6,26,46],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:12},{numBlocks:4,dataCodewordsPerBlock:13}]}]},{infoBits:42195,versionNumber:10,alignmentPatternCenters:[6,28,50],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68},{numBlocks:2,dataCodewordsPerBlock:69}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:43},{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]}]},{infoBits:48118,versionNumber:11,alignmentPatternCenters:[6,30,54],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:81}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:50},{numBlocks:4,dataCodewordsPerBlock:51}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:22},{numBlocks:4,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:12},{numBlocks:8,dataCodewordsPerBlock:13}]}]},{infoBits:51042,versionNumber:12,alignmentPatternCenters:[6,32,58],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:92},{numBlocks:2,dataCodewordsPerBlock:93}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:20},{numBlocks:6,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:55367,versionNumber:13,alignmentPatternCenters:[6,34,62],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:37},{numBlocks:1,dataCodewordsPerBlock:38}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:20},{numBlocks:4,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:11},{numBlocks:4,dataCodewordsPerBlock:12}]}]},{infoBits:58893,versionNumber:14,alignmentPatternCenters:[6,26,46,66],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:40},{numBlocks:5,dataCodewordsPerBlock:41}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:16},{numBlocks:5,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:5,dataCodewordsPerBlock:13}]}]},{infoBits:63784,versionNumber:15,alignmentPatternCenters:[6,26,48,70],errorCorrectionLevels:[{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:87},{numBlocks:1,dataCodewordsPerBlock:88}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:41},{numBlocks:5,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:7,dataCodewordsPerBlock:13}]}]},{infoBits:68472,versionNumber:16,alignmentPatternCenters:[6,26,50,74],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:98},{numBlocks:1,dataCodewordsPerBlock:99}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:70749,versionNumber:17,alignmentPatternCenters:[6,30,54,78],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:1,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22},{numBlocks:15,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:17,dataCodewordsPerBlock:15}]}]},{infoBits:76311,versionNumber:18,alignmentPatternCenters:[6,30,56,82],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:120},{numBlocks:1,dataCodewordsPerBlock:121}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:43},{numBlocks:4,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:1,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:19,dataCodewordsPerBlock:15}]}]},{infoBits:79154,versionNumber:19,alignmentPatternCenters:[6,30,58,86],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:113},{numBlocks:4,dataCodewordsPerBlock:114}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:44},{numBlocks:11,dataCodewordsPerBlock:45}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:21},{numBlocks:4,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:13},{numBlocks:16,dataCodewordsPerBlock:14}]}]},{infoBits:84390,versionNumber:20,alignmentPatternCenters:[6,34,62,90],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:41},{numBlocks:13,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:5,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:15},{numBlocks:10,dataCodewordsPerBlock:16}]}]},{infoBits:87683,versionNumber:21,alignmentPatternCenters:[6,28,50,72,94],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:116},{numBlocks:4,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:16},{numBlocks:6,dataCodewordsPerBlock:17}]}]},{infoBits:92361,versionNumber:22,alignmentPatternCenters:[6,26,50,74,98],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:111},{numBlocks:7,dataCodewordsPerBlock:112}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:13}]}]},{infoBits:96236,versionNumber:23,alignmentPatternCenters:[6,30,54,74,102],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:121},{numBlocks:5,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:47},{numBlocks:14,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:16,dataCodewordsPerBlock:15},{numBlocks:14,dataCodewordsPerBlock:16}]}]},{infoBits:102084,versionNumber:24,alignmentPatternCenters:[6,28,54,80,106],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:45},{numBlocks:14,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:30,dataCodewordsPerBlock:16},{numBlocks:2,dataCodewordsPerBlock:17}]}]},{infoBits:102881,versionNumber:25,alignmentPatternCenters:[6,32,58,84,110],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:106},{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:47},{numBlocks:13,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:110507,versionNumber:26,alignmentPatternCenters:[6,30,58,86,114],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:114},{numBlocks:2,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:46},{numBlocks:4,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:28,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:33,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]}]},{infoBits:110734,versionNumber:27,alignmentPatternCenters:[6,34,62,90,118],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:23},{numBlocks:26,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:117786,versionNumber:28,alignmentPatternCenters:[6,26,50,74,98,122],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:117},{numBlocks:10,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:45},{numBlocks:23,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:24},{numBlocks:31,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:31,dataCodewordsPerBlock:16}]}]},{infoBits:119615,versionNumber:29,alignmentPatternCenters:[6,30,54,78,102,126],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:116},{numBlocks:7,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:21,dataCodewordsPerBlock:45},{numBlocks:7,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:23},{numBlocks:37,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:26,dataCodewordsPerBlock:16}]}]},{infoBits:126325,versionNumber:30,alignmentPatternCenters:[6,26,52,78,104,130],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:115},{numBlocks:10,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:47},{numBlocks:10,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:25,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:25,dataCodewordsPerBlock:16}]}]},{infoBits:127568,versionNumber:31,alignmentPatternCenters:[6,30,56,82,108,134],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:3,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:46},{numBlocks:29,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:24},{numBlocks:1,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:133589,versionNumber:32,alignmentPatternCenters:[6,34,60,86,112,138],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:24},{numBlocks:35,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:35,dataCodewordsPerBlock:16}]}]},{infoBits:136944,versionNumber:33,alignmentPatternCenters:[6,30,58,86,114,142],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:21,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:24},{numBlocks:19,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:141498,versionNumber:34,alignmentPatternCenters:[6,34,62,90,118,146],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:6,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:44,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:59,dataCodewordsPerBlock:16},{numBlocks:1,dataCodewordsPerBlock:17}]}]},{infoBits:145311,versionNumber:35,alignmentPatternCenters:[6,30,54,78,102,126,150],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:121},{numBlocks:7,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:47},{numBlocks:26,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:39,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:41,dataCodewordsPerBlock:16}]}]},{infoBits:150283,versionNumber:36,alignmentPatternCenters:[6,24,50,76,102,128,154],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:121},{numBlocks:14,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:47},{numBlocks:34,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:46,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:64,dataCodewordsPerBlock:16}]}]},{infoBits:152622,versionNumber:37,alignmentPatternCenters:[6,28,54,80,106,132,158],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:46},{numBlocks:14,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:49,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:24,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:158308,versionNumber:38,alignmentPatternCenters:[6,32,58,84,110,136,162],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:122},{numBlocks:18,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:46},{numBlocks:32,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:48,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:15},{numBlocks:32,dataCodewordsPerBlock:16}]}]},{infoBits:161089,versionNumber:39,alignmentPatternCenters:[6,26,54,82,110,138,166],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:40,dataCodewordsPerBlock:47},{numBlocks:7,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:43,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:15},{numBlocks:67,dataCodewordsPerBlock:16}]}]},{infoBits:167017,versionNumber:40,alignmentPatternCenters:[6,30,58,86,114,142,170],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:118},{numBlocks:6,dataCodewordsPerBlock:119}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:18,dataCodewordsPerBlock:47},{numBlocks:31,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:24},{numBlocks:34,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:15},{numBlocks:61,dataCodewordsPerBlock:16}]}]}];function numBitsDiffering(e,o){let r=e^o,t=0;for(;r;)t++,r&=r-1;return t}function pushBit(e,o){return o<<1|e}const FORMAT_INFO_TABLE=[{bits:21522,formatInfo:{errorCorrectionLevel:1,dataMask:0}},{bits:20773,formatInfo:{errorCorrectionLevel:1,dataMask:1}},{bits:24188,formatInfo:{errorCorrectionLevel:1,dataMask:2}},{bits:23371,formatInfo:{errorCorrectionLevel:1,dataMask:3}},{bits:17913,formatInfo:{errorCorrectionLevel:1,dataMask:4}},{bits:16590,formatInfo:{errorCorrectionLevel:1,dataMask:5}},{bits:20375,formatInfo:{errorCorrectionLevel:1,dataMask:6}},{bits:19104,formatInfo:{errorCorrectionLevel:1,dataMask:7}},{bits:30660,formatInfo:{errorCorrectionLevel:0,dataMask:0}},{bits:29427,formatInfo:{errorCorrectionLevel:0,dataMask:1}},{bits:32170,formatInfo:{errorCorrectionLevel:0,dataMask:2}},{bits:30877,formatInfo:{errorCorrectionLevel:0,dataMask:3}},{bits:26159,formatInfo:{errorCorrectionLevel:0,dataMask:4}},{bits:25368,formatInfo:{errorCorrectionLevel:0,dataMask:5}},{bits:27713,formatInfo:{errorCorrectionLevel:0,dataMask:6}},{bits:26998,formatInfo:{errorCorrectionLevel:0,dataMask:7}},{bits:5769,formatInfo:{errorCorrectionLevel:3,dataMask:0}},{bits:5054,formatInfo:{errorCorrectionLevel:3,dataMask:1}},{bits:7399,formatInfo:{errorCorrectionLevel:3,dataMask:2}},{bits:6608,formatInfo:{errorCorrectionLevel:3,dataMask:3}},{bits:1890,formatInfo:{errorCorrectionLevel:3,dataMask:4}},{bits:597,formatInfo:{errorCorrectionLevel:3,dataMask:5}},{bits:3340,formatInfo:{errorCorrectionLevel:3,dataMask:6}},{bits:2107,formatInfo:{errorCorrectionLevel:3,dataMask:7}},{bits:13663,formatInfo:{errorCorrectionLevel:2,dataMask:0}},{bits:12392,formatInfo:{errorCorrectionLevel:2,dataMask:1}},{bits:16177,formatInfo:{errorCorrectionLevel:2,dataMask:2}},{bits:14854,formatInfo:{errorCorrectionLevel:2,dataMask:3}},{bits:9396,formatInfo:{errorCorrectionLevel:2,dataMask:4}},{bits:8579,formatInfo:{errorCorrectionLevel:2,dataMask:5}},{bits:11994,formatInfo:{errorCorrectionLevel:2,dataMask:6}},{bits:11245,formatInfo:{errorCorrectionLevel:2,dataMask:7}}],DATA_MASKS=[e=>(e.y+e.x)%2==0,e=>e.y%2==0,e=>e.x%3==0,e=>(e.y+e.x)%3==0,e=>(Math.floor(e.y/2)+Math.floor(e.x/3))%2==0,e=>e.x*e.y%2+e.x*e.y%3==0,e=>(e.y*e.x%2+e.y*e.x%3)%2==0,e=>((e.y+e.x)%2+e.y*e.x%3)%2==0];function buildFunctionPatternMask(e){var o=17+4*e.versionNumber;const r=BitMatrix.createEmpty(o,o);r.setRegion(0,0,9,9,!0),r.setRegion(o-8,0,8,9,!0),r.setRegion(0,o-8,9,8,!0);for(const t of e.alignmentPatternCenters)for(const s of e.alignmentPatternCenters)6===t&&6===s||6===t&&s===o-7||t===o-7&&6===s||r.setRegion(t-2,s-2,5,5,!0);return r.setRegion(6,9,1,o-17,!0),r.setRegion(9,6,o-17,1,!0),6<e.versionNumber&&(r.setRegion(o-11,0,3,6,!0),r.setRegion(0,o-11,6,3,!0)),r}function readCodewords(r,e,o){const t=DATA_MASKS[o.dataMask];var s=r.height;const c=buildFunctionPatternMask(e),d=[];let a=0,l=0,n=!0;for(let o=s-1;0<o;o-=2){6===o&&o--;for(let e=0;e<s;e++){var i=n?s-1-e:e;for(let e=0;e<2;e++){var B=o-e;if(!c.get(B,i)){l++;let e=r.get(B,i);t({y:i,x:B})&&(e=!e),a=pushBit(e,a),8===l&&(d.push(a),l=0,a=0)}}}n=!n}return d}function readVersion(r){var t=r.height,e=Math.floor((t-17)/4);if(e<=6)return VERSIONS[e-1];let s=0;for(let o=5;0<=o;o--)for(let e=t-9;e>=t-11;e--)s=pushBit(r.get(e,o),s);let c=0;for(let o=5;0<=o;o--)for(let e=t-9;e>=t-11;e--)c=pushBit(r.get(o,e),c);let o=1/0,d;for(const a of VERSIONS){if(a.infoBits===s||a.infoBits===c)return a;let e=numBitsDiffering(s,a.infoBits);e<o&&(d=a,o=e),e=numBitsDiffering(c,a.infoBits),e<o&&(d=a,o=e)}return o<=3?d:void 0}function readFormatInformation(o){let r=0;for(let e=0;e<=8;e++)6!==e&&(r=pushBit(o.get(e,8),r));for(let e=7;0<=e;e--)6!==e&&(r=pushBit(o.get(8,e),r));var t,s,c=o.height;let d=0;for(let e=c-1;e>=c-7;e--)d=pushBit(o.get(8,e),d);for(let e=c-8;e<c;e++)d=pushBit(o.get(e,8),d);let a=1/0,l=null;for({bits:t,formatInfo:s}of FORMAT_INFO_TABLE){if(t===r||t===d)return s;let e=numBitsDiffering(r,t);e<a&&(l=s,a=e),r!==d&&(e=numBitsDiffering(d,t),e<a&&(l=s,a=e))}return a<=3?l:null}function getDataBlocks(o,e,r){const t=e.errorCorrectionLevels[r],s=[];let c=0;if(t.ecBlocks.forEach(o=>{for(let e=0;e<o.numBlocks;e++)s.push({numDataCodewords:o.dataCodewordsPerBlock,codewords:[]}),c+=o.dataCodewordsPerBlock+t.ecCodewordsPerBlock}),o.length<c)return null;o=o.slice(0,c);var d=t.ecBlocks[0].dataCodewordsPerBlock;for(let e=0;e<d;e++)for(const n of s)n.codewords.push(o.shift());if(1<t.ecBlocks.length){var a=t.ecBlocks[0].numBlocks,l=t.ecBlocks[1].numBlocks;for(let e=0;e<l;e++)s[a+e].codewords.push(o.shift())}for(;0<o.length;)for(const i of s)i.codewords.push(o.shift());return s}function decodeMatrix(e){var o=readVersion(e);if(!o)return null;var r=readFormatInformation(e);if(!r)return null;const t=getDataBlocks(readCodewords(e,o,r),o,r.errorCorrectionLevel);if(!t)return null;r=t.reduce((e,o)=>e+o.numDataCodewords,0);const s=new Uint8ClampedArray(r);let c=0;for(const a of t){var d=decode$1(a.codewords,a.codewords.length-a.numDataCodewords);if(!d)return null;for(let e=0;e<a.numDataCodewords;e++)s[c++]=d[e]}try{return decode$2(s,o.versionNumber)}catch(e){return null}}function decode(r){if(null==r)return null;var e=decodeMatrix(r);if(e)return e;for(let o=0;o<r.width;o++)for(let e=o+1;e<r.height;e++)r.get(o,e)!==r.get(e,o)&&(r.set(o,e,!r.get(o,e)),r.set(e,o,!r.get(e,o)));return decodeMatrix(r)}function squareToQuadrilateral(e,o,r,t){var s=e.x-o.x+r.x-t.x,c=e.y-o.y+r.y-t.y;if(0==s&&0==c)return{a11:o.x-e.x,a12:o.y-e.y,a13:0,a21:r.x-o.x,a22:r.y-o.y,a23:0,a31:e.x,a32:e.y,a33:1};var d=o.x-r.x,a=t.x-r.x,l=o.y-r.y,n=t.y-r.y,r=d*n-a*l,a=(s*n-a*c)/r,r=(d*c-s*l)/r;return{a11:o.x-e.x+a*o.x,a12:o.y-e.y+a*o.y,a13:a,a21:t.x-e.x+r*t.x,a22:t.y-e.y+r*t.y,a23:r,a31:e.x,a32:e.y,a33:1}}function quadrilateralToSquare(e,o,r,t){t=squareToQuadrilateral(e,o,r,t);return{a11:t.a22*t.a33-t.a23*t.a32,a12:t.a13*t.a32-t.a12*t.a33,a13:t.a12*t.a23-t.a13*t.a22,a21:t.a23*t.a31-t.a21*t.a33,a22:t.a11*t.a33-t.a13*t.a31,a23:t.a13*t.a21-t.a11*t.a23,a31:t.a21*t.a32-t.a22*t.a31,a32:t.a12*t.a31-t.a11*t.a32,a33:t.a11*t.a22-t.a12*t.a21}}function times(e,o){return{a11:e.a11*o.a11+e.a21*o.a12+e.a31*o.a13,a12:e.a12*o.a11+e.a22*o.a12+e.a32*o.a13,a13:e.a13*o.a11+e.a23*o.a12+e.a33*o.a13,a21:e.a11*o.a21+e.a21*o.a22+e.a31*o.a23,a22:e.a12*o.a21+e.a22*o.a22+e.a32*o.a23,a23:e.a13*o.a21+e.a23*o.a22+e.a33*o.a23,a31:e.a11*o.a31+e.a21*o.a32+e.a31*o.a33,a32:e.a12*o.a31+e.a22*o.a32+e.a32*o.a33,a33:e.a13*o.a31+e.a23*o.a32+e.a33*o.a33}}function extract(r,t){var e=quadrilateralToSquare({x:3.5,y:3.5},{x:t.dimension-3.5,y:3.5},{x:t.dimension-6.5,y:t.dimension-6.5},{x:3.5,y:t.dimension-3.5});const s=times(squareToQuadrilateral(t.topLeft,t.topRight,t.alignmentPattern,t.bottomLeft),e),c=BitMatrix.createEmpty(t.dimension,t.dimension);var d=(e,o)=>{var r=s.a13*e+s.a23*o+s.a33;return{x:(s.a11*e+s.a21*o+s.a31)/r,y:(s.a12*e+s.a22*o+s.a32)/r}};for(let o=0;o<t.dimension;o++)for(let e=0;e<t.dimension;e++){var a=d(e+.5,o+.5);c.set(e,o,r.get(Math.floor(a.x),Math.floor(a.y)))}return{matrix:c,mappingFunction:d}}const MAX_FINDERPATTERNS_TO_SEARCH=5,MIN_QUAD_RATIO=.5,MAX_QUAD_RATIO=1.5,distance=(e,o)=>Math.sqrt(Math.pow(o.x-e.x,2)+Math.pow(o.y-e.y,2));function sum(e){return e.reduce((e,o)=>e+o)}function reorderFinderPatterns(e,o,r){var t=distance(e,o),s=distance(o,r),c=distance(e,r);let d,a,l;return[d,a,l]=t<=s&&c<=s?[o,e,r]:s<=c&&t<=c?[e,o,r]:[e,r,o],(l.x-a.x)*(d.y-a.y)-(l.y-a.y)*(d.x-a.x)<0&&([d,l]=[l,d]),{bottomLeft:d,topLeft:a,topRight:l}}function computeDimension(e,o,r,t){t=(sum(countBlackWhiteRun(e,r,t,5))/7+sum(countBlackWhiteRun(e,o,t,5))/7+sum(countBlackWhiteRun(r,e,t,5))/7+sum(countBlackWhiteRun(o,e,t,5))/7)/4;if(t<1)throw new Error(\"Invalid module size\");o=Math.round(distance(e,o)/t),r=Math.round(distance(e,r)/t);let s=Math.floor((o+r)/2)+7;switch(s%4){case 0:s++;break;case 2:s--}return{dimension:s,moduleSize:t}}function countBlackWhiteRunTowardsPoint(e,o,r,t){const s=[{x:Math.floor(e.x),y:Math.floor(e.y)}];var c=Math.abs(o.y-e.y)>Math.abs(o.x-e.x);let d,a,l,n;n=c?(d=Math.floor(e.y),a=Math.floor(e.x),l=Math.floor(o.y),Math.floor(o.x)):(d=Math.floor(e.x),a=Math.floor(e.y),l=Math.floor(o.x),Math.floor(o.y));var i=Math.abs(l-d),B=Math.abs(n-a);let k=Math.floor(-i/2);var u=d<l?1:-1,m=a<n?1:-1;let C=!0;for(let e=d,o=a;e!==l+u;e+=u){var w=c?o:e,P=c?e:o;if(r.get(w,P)!==C&&(C=!C,s.push({x:w,y:P}),s.length===t+1))break;if(k+=B,0<k){if(o===n)break;o+=m,k-=i}}const f=[];for(let e=0;e<t;e++)s[e]&&s[e+1]?f.push(distance(s[e],s[e+1])):f.push(0);return f}function countBlackWhiteRun(e,o,r,t){var s=o.y-e.y,c=o.x-e.x;const d=countBlackWhiteRunTowardsPoint(e,o,r,Math.ceil(t/2)),a=countBlackWhiteRunTowardsPoint(e,{x:e.x-c,y:e.y-s},r,Math.ceil(t/2));t=d.shift()+a.shift()-1;return a.concat(t).concat(...d)}function scoreBlackWhiteRun(r,e){const t=sum(r)/sum(e);let s=0;return e.forEach((e,o)=>{s+=Math.pow(r[o]-e*t,2)}),{averageSize:t,error:s}}function scorePattern(e,o,r){try{var t=countBlackWhiteRun(e,{x:-1,y:e.y},r,o.length),s=countBlackWhiteRun(e,{x:e.x,y:-1},r,o.length),c=countBlackWhiteRun(e,{x:Math.max(0,e.x-e.y)-1,y:Math.max(0,e.y-e.x)-1},r,o.length),d=countBlackWhiteRun(e,{x:Math.min(r.width,e.x+e.y)+1,y:Math.min(r.height,e.y+e.x)+1},r,o.length),a=scoreBlackWhiteRun(t,o),l=scoreBlackWhiteRun(s,o),n=scoreBlackWhiteRun(c,o),i=scoreBlackWhiteRun(d,o),B=Math.sqrt(a.error*a.error+l.error*l.error+n.error*n.error+i.error*i.error),k=(a.averageSize+l.averageSize+n.averageSize+i.averageSize)/4;return B+(Math.pow(a.averageSize-k,2)+Math.pow(l.averageSize-k,2)+Math.pow(n.averageSize-k,2)+Math.pow(i.averageSize-k,2))/k}catch(e){return 1/0}}function recenterLocation(e,o){let r=Math.round(o.x);for(;e.get(r,Math.round(o.y));)r--;let t=Math.round(o.x);for(;e.get(t,Math.round(o.y));)t++;var s=(r+t)/2;let c=Math.round(o.y);for(;e.get(Math.round(s),c);)c--;let d=Math.round(o.y);for(;e.get(Math.round(s),d);)d++;return{x:s,y:(c+d)/2}}function locate(c){const e=[];let d=[];const a=[];let l=[];for(let s=0;s<=c.height;s++){let o=0,r=!1,t=[0,0,0,0,0];for(let e=-1;e<=c.width;e++){var n=c.get(e,s);if(n===r)o++;else{t=[t[1],t[2],t[3],t[4],o],o=1,r=n;var i=sum(t)/7,B=Math.abs(t[0]-i)<i&&Math.abs(t[1]-i)<i&&Math.abs(t[2]-3*i)<3*i&&Math.abs(t[3]-i)<i&&Math.abs(t[4]-i)<i&&!n,i=sum(t.slice(-3))/3,n=Math.abs(t[2]-i)<i&&Math.abs(t[3]-i)<i&&Math.abs(t[4]-i)<i&&n;if(B){const v=e-t[3]-t[4],b=v-t[2];B={startX:b,endX:v,y:s};const g=d.filter(e=>b>=e.bottom.startX&&b<=e.bottom.endX||v>=e.bottom.startX&&b<=e.bottom.endX||b<=e.bottom.startX&&v>=e.bottom.endX&&t[2]/(e.bottom.endX-e.bottom.startX)<MAX_QUAD_RATIO&&t[2]/(e.bottom.endX-e.bottom.startX)>MIN_QUAD_RATIO);0<g.length?g[0].bottom=B:d.push({top:B,bottom:B})}if(n){const y=e-t[4],p=y-t[3];n={startX:p,y:s,endX:y};const M=l.filter(e=>p>=e.bottom.startX&&p<=e.bottom.endX||y>=e.bottom.startX&&p<=e.bottom.endX||p<=e.bottom.startX&&y>=e.bottom.endX&&t[2]/(e.bottom.endX-e.bottom.startX)<MAX_QUAD_RATIO&&t[2]/(e.bottom.endX-e.bottom.startX)>MIN_QUAD_RATIO);0<M.length?M[0].bottom=n:l.push({top:n,bottom:n})}}}e.push(...d.filter(e=>e.bottom.y!==s&&2<=e.bottom.y-e.top.y)),d=d.filter(e=>e.bottom.y===s),a.push(...l.filter(e=>e.bottom.y!==s)),l=l.filter(e=>e.bottom.y===s)}e.push(...d.filter(e=>2<=e.bottom.y-e.top.y)),a.push(...l);const o=[];for(const x of e){var r,t,s,k;x.bottom.y-x.top.y<2||(r=(x.top.startX+x.top.endX+x.bottom.startX+x.bottom.endX)/4,t=(x.top.y+x.bottom.y+1)/2,c.get(Math.round(r),Math.round(t))&&(s=sum(k=[x.top.endX-x.top.startX,x.bottom.endX-x.bottom.startX,x.bottom.y-x.top.y+1])/k.length,k=scorePattern({x:Math.round(r),y:Math.round(t)},[1,1,3,1,1],c),o.push({score:k,x:r,y:t,size:s})))}if(o.length<3)return null;o.sort((e,o)=>e.score-o.score);const u=[];for(let e=0;e<Math.min(o.length,MAX_FINDERPATTERNS_TO_SEARCH);++e){var m=o[e];const L=[];for(const A of o)A!==m&&L.push(Object.assign(Object.assign({},A),{score:A.score+Math.pow(A.size-m.size,2)/m.size}));L.sort((e,o)=>e.score-o.score),u.push({points:[m,L[0],L[1]],score:m.score+L[0].score+L[1].score})}u.sort((e,o)=>e.score-o.score);var{topRight:C,topLeft:w,bottomLeft:P}=reorderFinderPatterns(...u[0].points),f=findAlignmentPattern(c,a,C,w,P);const h=[];f&&h.push({alignmentPattern:{x:f.alignmentPattern.x,y:f.alignmentPattern.y},bottomLeft:{x:P.x,y:P.y},dimension:f.dimension,topLeft:{x:w.x,y:w.y},topRight:{x:C.x,y:C.y}});f=recenterLocation(c,C),C=recenterLocation(c,w),w=recenterLocation(c,P),P=findAlignmentPattern(c,a,f,C,w);return P&&h.push({alignmentPattern:{x:P.alignmentPattern.x,y:P.alignmentPattern.y},bottomLeft:{x:w.x,y:w.y},topLeft:{x:C.x,y:C.y},topRight:{x:f.x,y:f.y},dimension:P.dimension}),0===h.length?null:h}function findAlignmentPattern(r,e,o,t,s){let c,d;try{({dimension:c,moduleSize:d}=computeDimension(t,o,s,r))}catch(e){return null}const a=o.x-t.x+s.x,l=o.y-t.y+s.y;s=(distance(t,s)+distance(t,o))/2/d,o=1-3/s;const n={x:t.x+o*(a-t.x),y:t.y+o*(l-t.y)};e=e.map(e=>{var o=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,e=(e.top.y+e.bottom.y+1)/2;if(r.get(Math.floor(o),Math.floor(e)))return{x:o,y:e,score:scorePattern({x:Math.floor(o),y:Math.floor(e)},[1,1,1],r)+distance({x:o,y:e},n)}}).filter(e=>!!e).sort((e,o)=>e.score-o.score);return{alignmentPattern:15<=s&&e.length?e[0]:n,dimension:c}}function scan(e){var o=locate(e);if(!o)return null;for(const t of o){const s=extract(e,t);var r=decode(s.matrix);if(r)return{binaryData:r.bytes,data:r.text,chunks:r.chunks,version:r.version,location:{topRightCorner:s.mappingFunction(t.dimension,0),topLeftCorner:s.mappingFunction(0,0),bottomRightCorner:s.mappingFunction(t.dimension,t.dimension),bottomLeftCorner:s.mappingFunction(0,t.dimension),topRightFinderPattern:t.topRight,topLeftFinderPattern:t.topLeft,bottomLeftFinderPattern:t.bottomLeft,bottomRightAlignmentPattern:t.alignmentPattern},matrix:s.matrix}}return null}const defaultOptions={inversionAttempts:\"attemptBoth\",greyScaleWeights:{red:.2126,green:.7152,blue:.0722,useIntegerApproximation:!1},canOverwriteImage:!0};function mergeObject(o,r){Object.keys(r).forEach(e=>{o[e]=r[e]})}function jsQR(e,o,r,t={}){var s=Object.create(null);mergeObject(s,defaultOptions),mergeObject(s,t);var t=\"onlyInvert\"===s.inversionAttempts||\"invertFirst\"===s.inversionAttempts,{binarized:o,inverted:r}=binarize(e,o,r,\"attemptBoth\"===s.inversionAttempts||t,s.greyScaleWeights,s.canOverwriteImage);let c=scan(t?r:o);return c||\"attemptBoth\"!==s.inversionAttempts&&\"invertFirst\"!==s.inversionAttempts||(c=scan(t?o:r)),c}jsQR.default=jsQR,self.addEventListener(\"message\",function(e){e=jsQR(e.data.data,e.data.width,e.data.height);e?postMessage(e.data):postMessage(null)});"
], {
    type: 'application/javascript'
}); // Props that are allowed to change dynamicly
var $f617f1ff23601f7d$var$propsKeys = [
    'delay',
    'legacyMode',
    'facingMode'
];
$f617f1ff23601f7d$exports = ($f617f1ff23601f7d$var$_temp = $f617f1ff23601f7d$var$_class = /*#__PURE__*/ function(_Component) {
    $f617f1ff23601f7d$var$_inherits(Reader, _Component);
    var _super = $f617f1ff23601f7d$var$_createSuper(Reader);
    function Reader(props) {
        var _this;
        $f617f1ff23601f7d$var$_classCallCheck(this, Reader);
        _this = _super.call(this, props);
        $f617f1ff23601f7d$var$_defineProperty($f617f1ff23601f7d$var$_assertThisInitialized(_this), "els", {});
        _this.state = {
            mirrorVideo: false
        }; // Bind function to the class
        _this.initiate = _this.initiate.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.initiateLegacyMode = _this.initiateLegacyMode.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.check = _this.check.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.handleVideo = _this.handleVideo.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.handleLoadStart = _this.handleLoadStart.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.handleInputChange = _this.handleInputChange.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.clearComponent = _this.clearComponent.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.handleReaderLoad = _this.handleReaderLoad.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.openImageDialog = _this.openImageDialog.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.handleWorkerMessage = _this.handleWorkerMessage.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        _this.setRefFactory = _this.setRefFactory.bind($f617f1ff23601f7d$var$_assertThisInitialized(_this));
        return _this;
    }
    $f617f1ff23601f7d$var$_createClass(Reader, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // Initiate web worker execute handler according to mode.
                this.worker = new Worker(URL.createObjectURL($f617f1ff23601f7d$var$workerBlob));
                this.worker.onmessage = this.handleWorkerMessage;
                if (!this.props.legacyMode) this.initiate();
                else this.initiateLegacyMode();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                // React according to change in props
                var changedProps = $31a52e240c35fd59$exports(this.props, prevProps, $f617f1ff23601f7d$var$propsKeys);
                var _iterator = $f617f1ff23601f7d$var$_createForOfIteratorHelper(changedProps), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var prop = _step.value;
                        if (prop == 'facingMode') {
                            this.clearComponent();
                            this.initiate(this.props);
                            break;
                        } else if (prop == 'delay') {
                            if (prevProps.delay == false && !this.props.legacyMode) this.timeout = setTimeout(this.check, this.props.delay);
                            if (this.props.delay == false) clearTimeout(this.timeout);
                        } else if (prop == 'legacyMode') {
                            if (prevProps.legacyMode && !this.props.legacyMode) {
                                this.clearComponent();
                                this.initiate(this.props);
                            } else {
                                this.clearComponent();
                                this.componentDidUpdate = this.initiateLegacyMode;
                            }
                            break;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (nextState !== this.state) return true;
                 // Only render when the `propsKeys` have changed.
                var changedProps = $31a52e240c35fd59$exports(this.props, nextProps, $f617f1ff23601f7d$var$propsKeys);
                return changedProps.length > 0;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                // Stop web-worker and clear the component
                if (this.worker) {
                    this.worker.terminate();
                    this.worker = undefined;
                }
                this.clearComponent();
            }
        },
        {
            key: "clearComponent",
            value: function clearComponent() {
                // Remove all event listeners and variables
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = undefined;
                }
                if (this.stopCamera) this.stopCamera();
                if (this.reader) this.reader.removeEventListener('load', this.handleReaderLoad);
                if (this.els.img) this.els.img.removeEventListener('load', this.check);
            }
        },
        {
            key: "initiate",
            value: function initiate() {
                var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var onError = props.onError, facingMode = props.facingMode; // Check browser facingMode constraint support
                // Firefox ignores facingMode or deviceId constraints
                var isFirefox = /firefox/i.test(navigator.userAgent);
                var supported = {};
                if (navigator.mediaDevices && typeof navigator.mediaDevices.getSupportedConstraints === 'function') supported = navigator.mediaDevices.getSupportedConstraints();
                var constraints = {};
                if (supported.facingMode) constraints.facingMode = {
                    ideal: facingMode
                };
                if (supported.frameRate) constraints.frameRate = {
                    ideal: 25,
                    min: 10
                };
                var vConstraintsPromise = supported.facingMode || isFirefox ? Promise.resolve(props.constraints || constraints) : $f617f1ff23601f7d$var$getDeviceId(facingMode).then(function(deviceId) {
                    return Object.assign({}, {
                        deviceId: deviceId
                    }, props.constraints);
                });
                vConstraintsPromise.then(function(video) {
                    return navigator.mediaDevices.getUserMedia({
                        video: video
                    });
                }).then(this.handleVideo)["catch"](onError);
            }
        },
        {
            key: "handleVideo",
            value: function handleVideo(stream) {
                var preview = this.els.preview;
                var facingMode = this.props.facingMode; // Preview element hasn't been rendered so wait for it.
                if (!preview) return setTimeout(this.handleVideo, 200, stream);
                 // Handle different browser implementations of MediaStreams as src
                if ((preview || {}).srcObject !== undefined) preview.srcObject = stream;
                else if (preview.mozSrcObject !== undefined) preview.mozSrcObject = stream;
                else if (window.URL.createObjectURL) preview.src = window.URL.createObjectURL(stream);
                else if (window.webkitURL) preview.src = window.webkitURL.createObjectURL(stream);
                else preview.src = stream;
                 // IOS play in fullscreen
                preview.playsInline = true;
                var streamTrack = stream.getTracks()[0]; // Assign `stopCamera` so the track can be stopped once component is cleared
                this.stopCamera = streamTrack.stop.bind(streamTrack);
                preview.addEventListener('loadstart', this.handleLoadStart);
                this.setState({
                    mirrorVideo: facingMode == 'user',
                    streamLabel: streamTrack.label
                });
            }
        },
        {
            key: "handleLoadStart",
            value: function handleLoadStart() {
                var _this$props = this.props, delay = _this$props.delay, onLoad = _this$props.onLoad;
                var _this$state = this.state, mirrorVideo = _this$state.mirrorVideo, streamLabel = _this$state.streamLabel;
                var preview = this.els.preview;
                preview.play();
                if (typeof onLoad == 'function') onLoad({
                    mirrorVideo: mirrorVideo,
                    streamLabel: streamLabel
                });
                if (typeof delay == 'number') this.timeout = setTimeout(this.check, delay);
                 // Some browsers call loadstart continuously
                preview.removeEventListener('loadstart', this.handleLoadStart);
            }
        },
        {
            key: "check",
            value: function check() {
                var _this$props2 = this.props, legacyMode = _this$props2.legacyMode, resolution = _this$props2.resolution, delay = _this$props2.delay;
                var _this$els = this.els, preview = _this$els.preview, canvas = _this$els.canvas, img = _this$els.img; // Get image/video dimensions
                var width = Math.floor(legacyMode ? img.naturalWidth : preview.videoWidth);
                var height = Math.floor(legacyMode ? img.naturalHeight : preview.videoHeight); // Canvas draw offsets
                var hozOffset = 0;
                var vertOffset = 0; // Scale image to correct resolution
                if (legacyMode) {
                    // Keep image aspect ratio
                    var greatestSize = width > height ? width : height;
                    var ratio = resolution / greatestSize;
                    height = ratio * height;
                    width = ratio * width;
                    canvas.width = width;
                    canvas.height = height;
                } else {
                    // Crop image to fit 1:1 aspect ratio
                    var smallestSize = width < height ? width : height;
                    var _ratio = resolution / smallestSize;
                    height = _ratio * height;
                    width = _ratio * width;
                    vertOffset = (height - resolution) / 2 * -1;
                    hozOffset = (width - resolution) / 2 * -1;
                    canvas.width = resolution;
                    canvas.height = resolution;
                }
                var previewIsPlaying = preview && preview.readyState === preview.HAVE_ENOUGH_DATA;
                if (legacyMode || previewIsPlaying) {
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(legacyMode ? img : preview, hozOffset, vertOffset, width, height);
                    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height); // Send data to web-worker
                    this.worker.postMessage(imageData);
                } else // Preview not ready -> check later
                this.timeout = setTimeout(this.check, delay);
            }
        },
        {
            key: "handleWorkerMessage",
            value: function handleWorkerMessage(e) {
                var _this$props3 = this.props, onScan = _this$props3.onScan, legacyMode = _this$props3.legacyMode, delay = _this$props3.delay;
                var decoded = e.data;
                onScan(decoded || null);
                if (!legacyMode && typeof delay == 'number' && this.worker) this.timeout = setTimeout(this.check, delay);
            }
        },
        {
            key: "initiateLegacyMode",
            value: function initiateLegacyMode() {
                this.reader = new FileReader();
                this.reader.addEventListener('load', this.handleReaderLoad);
                this.els.img.addEventListener('load', this.check, false); // Reset componentDidUpdate
                this.componentDidUpdate = undefined;
                if (typeof this.props.onLoad == 'function') this.props.onLoad();
            }
        },
        {
            key: "handleInputChange",
            value: function handleInputChange(e) {
                var selectedImg = e.target.files[0];
                this.reader.readAsDataURL(selectedImg);
            }
        },
        {
            key: "handleReaderLoad",
            value: function handleReaderLoad(e) {
                // Set selected image blob as img source
                this.els.img.src = e.target.result;
            }
        },
        {
            key: "openImageDialog",
            value: function openImageDialog() {
                // Function to be executed by parent in user action context to trigger img file uploader
                this.els.input.click();
            }
        },
        {
            key: "setRefFactory",
            value: function setRefFactory(key) {
                var _this2 = this;
                return function(element) {
                    _this2.els[key] = element;
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, style = _this$props4.style, className = _this$props4.className, onImageLoad = _this$props4.onImageLoad, legacyMode = _this$props4.legacyMode, showViewFinder = _this$props4.showViewFinder, facingMode = _this$props4.facingMode;
                var containerStyle = {
                    overflow: 'hidden',
                    position: 'relative',
                    width: '100%',
                    paddingTop: '100%'
                };
                var hiddenStyle = {
                    display: 'none'
                };
                var previewStyle = {
                    top: 0,
                    left: 0,
                    display: 'block',
                    position: 'absolute',
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%'
                };
                var videoPreviewStyle = $f617f1ff23601f7d$var$_objectSpread($f617f1ff23601f7d$var$_objectSpread({}, previewStyle), {}, {
                    objectFit: 'cover',
                    transform: this.state.mirrorVideo ? 'scaleX(-1)' : undefined
                });
                var imgPreviewStyle = $f617f1ff23601f7d$var$_objectSpread($f617f1ff23601f7d$var$_objectSpread({}, previewStyle), {}, {
                    objectFit: 'scale-down'
                });
                var viewFinderStyle = {
                    top: 0,
                    left: 0,
                    zIndex: 1,
                    boxSizing: 'border-box',
                    border: '50px solid rgba(0, 0, 0, 0.3)',
                    boxShadow: 'inset 0 0 0 5px rgba(255, 0, 0, 0.5)',
                    position: 'absolute',
                    width: '100%',
                    height: '100%'
                };
                return /*#__PURE__*/ $3ZYaX.createElement("section", {
                    className: className,
                    style: style
                }, /*#__PURE__*/ $3ZYaX.createElement("section", {
                    style: containerStyle
                }, !legacyMode && showViewFinder ? /*#__PURE__*/ $3ZYaX.createElement("div", {
                    style: viewFinderStyle
                }) : null, legacyMode ? /*#__PURE__*/ $3ZYaX.createElement("input", {
                    style: hiddenStyle,
                    type: "file",
                    accept: "image/*",
                    ref: this.setRefFactory('input'),
                    onChange: this.handleInputChange
                }) : null, legacyMode ? /*#__PURE__*/ $3ZYaX.createElement("img", {
                    style: imgPreviewStyle,
                    ref: this.setRefFactory('img'),
                    onLoad: onImageLoad
                }) : /*#__PURE__*/ $3ZYaX.createElement("video", {
                    style: videoPreviewStyle,
                    ref: this.setRefFactory('preview')
                }), /*#__PURE__*/ $3ZYaX.createElement("canvas", {
                    style: hiddenStyle,
                    ref: this.setRefFactory('canvas')
                })));
            }
        }
    ]);
    return Reader;
}($f617f1ff23601f7d$var$Component), $f617f1ff23601f7d$var$_defineProperty($f617f1ff23601f7d$var$_class, "propTypes", {
    onScan: $9C0qR.func.isRequired,
    onError: $9C0qR.func.isRequired,
    onLoad: $9C0qR.func,
    onImageLoad: $9C0qR.func,
    delay: $9C0qR.oneOfType([
        $9C0qR.number,
        $9C0qR.bool
    ]),
    facingMode: $9C0qR.oneOf([
        'user',
        'environment'
    ]),
    legacyMode: $9C0qR.bool,
    resolution: $9C0qR.number,
    showViewFinder: $9C0qR.bool,
    style: $9C0qR.any,
    className: $9C0qR.string,
    constraints: $9C0qR.object
}), $f617f1ff23601f7d$var$_defineProperty($f617f1ff23601f7d$var$_class, "defaultProps", {
    delay: 500,
    resolution: 600,
    facingMode: 'environment',
    showViewFinder: true,
    constraints: null
}), $f617f1ff23601f7d$var$_temp);



const $0d4f60665e91cba2$var$QrScannerField = (props)=>{
    const { field: field, form: form, label: label, facingMode: facingMode, hideVideo: hideVideo, setQrReaderError: setQrReaderError } = props;
    const [qrData, setQrData] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    const [lastScan, setLastScan] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(0);
    const handleChange = (value)=>{
        if (value === null) return;
        if (!qrData || qrData !== value || new Date().getTime() > lastScan + 5000) {
            setQrData(value);
            setLastScan(new Date().getTime());
            props.form.setFieldValue(field.name, value || '');
        }
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        error: form.errors[field.name],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f617f1ff23601f7d$exports))), {
            delay: 500,
            onError: (errorData)=>setQrReaderError('Error loading and enabling video device : ' + JSON.stringify(errorData)),
            onScan: handleChange,
            resolution: 1200,
            facingMode: facingMode,
            style: hideVideo ? {
                display: 'none'
            } : {}
        })
    });
};
var $0d4f60665e91cba2$export$2e2bcd8739ae039 = $0d4f60665e91cba2$var$QrScannerField;



var $10342581bddc3ce7$exports = {};
$10342581bddc3ce7$exports = new URL("beep.c98e88f2.mp3", import.meta.url).toString();






function $ef2e6760f3e9e6fc$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $d94c5f7b694ddfdc$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $d94c5f7b694ddfdc$var$defaultRoundingMethod = 'trunc';
function $d94c5f7b694ddfdc$export$b6474a47258c1211(method) {
    return method ? $d94c5f7b694ddfdc$var$roundingMap[method] : $d94c5f7b694ddfdc$var$roundingMap[$d94c5f7b694ddfdc$var$defaultRoundingMethod];
}


function $e535dc0fd49418c6$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $ef2e6760f3e9e6fc$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $d94c5f7b694ddfdc$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}




const $c93d76b9aedf6493$var$beep = new Audio($10342581bddc3ce7$exports);
const $c93d76b9aedf6493$var$usePlayBeep = ()=>{
    (0, $3ZYaX.useEffect)(()=>{
        $c93d76b9aedf6493$var$beep.play();
        return ()=>{
            $c93d76b9aedf6493$var$beep.pause();
        };
    }, []);
};
const $c93d76b9aedf6493$var$Beep = ()=>{
    $c93d76b9aedf6493$var$usePlayBeep();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
const $c93d76b9aedf6493$var$StatusTag = ({ isOnline: isOnline })=>{
    const statusText = isOnline ? 'online' : 'offline';
    const statusColor = isOnline ? 'success' : 'danger';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
        size: "small",
        color: statusColor,
        children: statusText
    });
};
var $14136dd123febc9f$exports = {};
$14136dd123febc9f$exports = new URL("pages/qr-scanner/service-worker.js", import.meta.url).toString();


const $c93d76b9aedf6493$var$QrScannerPage = ({ scanner: scanner })=>{
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const mutation = (0, $d19e678f97a3d4d6$export$a25726670bb41cb)();
    const { isOnline: isOnline } = (0, $8097e9f30a7d1ddb$export$f38e41fee9d4dd51)();
    const [qrReaderError, setQrReaderError] = (0, $3ZYaX.useState)();
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentOrganization);
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentUser);
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentUserRole);
    const logout = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.logout);
    const [searchParams] = (0, $d7b8f401c6bc9326$export$f1a78c17382fe22a)();
    // @ts-expect-error -> fix this
    const isSystemUser = currentUser?.appAccess === 'system';
    const [camera, setCamera] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('environment');
    const [mode, setMode] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('kiosk');
    const [lastQrSent, setLastQrSent] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        value: '',
        time: 0
    });
    if (isSystemUser) {
        if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then((registrations)=>{
            if (registrations.length > 0) console.info('Service Worker already registered');
            else navigator.serviceWorker.register($14136dd123febc9f$exports).then(()=>{
                console.info('Service Worker registered');
            }).catch((error)=>{
                console.error('Service Worker registration failed:', error);
            });
        });
    }
    (0, $3ZYaX.useEffect)(()=>{
        if (!isSystemUser) return;
        const onlyInteractiveOrButtonClicks = (event)=>{
            if (event.target instanceof HTMLElement && event.target.closest('button')) return; // Do nothing and let the event continue
            event.preventDefault();
            event.stopImmediatePropagation();
        };
        const noClicks = (e)=>{
            e.preventDefault();
            e.stopImmediatePropagation();
        };
        const disableContextMenu = (e)=>{
            // prevent the right-click menu from appearing
            e.preventDefault();
        };
        // Prevent zoom-in out with fingers in kiosks
        const preventGesture = (e)=>e.preventDefault();
        const preventWheel = (e)=>{
            if (e.ctrlKey) e.preventDefault() // blocks pinch-to-zoom on Chrome/Android
            ;
        };
        document.addEventListener('contextmenu', disableContextMenu);
        document.addEventListener('click', onlyInteractiveOrButtonClicks);
        document.addEventListener('dragstart', noClicks);
        document.addEventListener('selectstart', noClicks);
        document.addEventListener('gesturestart', preventGesture);
        document.addEventListener('gesturechange', preventGesture);
        document.addEventListener('gestureend', preventGesture);
        document.addEventListener('wheel', preventWheel, {
            passive: false
        });
        return ()=>{
            document.removeEventListener('contextmenu', disableContextMenu);
            document.removeEventListener('click', onlyInteractiveOrButtonClicks);
            document.removeEventListener('dragstart', noClicks);
            document.removeEventListener('selectstart', noClicks);
            document.removeEventListener('gesturestart', preventGesture);
            document.removeEventListener('gesturechange', preventGesture);
            document.removeEventListener('gestureend', preventGesture);
            document.removeEventListener('wheel', preventWheel);
        };
    }, [
        isSystemUser
    ]) // Empty dependency array to run the effect only once when the component mounts
    ;
    if (currentUserRole === 'superAdmin') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: "Vous devez \xeatre connect\xe9 en tant qu'Employeur pour pouvoir scanner"
        })
    });
    // Remove this later, we still support /qr-scanner?laser=true url scheme
    // Has been replaced with /kiosk and /laser-scanner
    if (scanner === 'camera' && searchParams.get('laser')) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/laser-scanner"
    });
    const clockingResultColor = mutation.isSuccess && mutation.data.data.mission ? 'success' : mutation.isIdle ? 'white' : mutation.isError || mutation.isSuccess && !mutation.data.data.mission || qrReaderError ? 'danger' : 'white';
    /**
   * When logged in as a system user
   * Admins have to click exit button -> logo -> exit button -> logo -> exit button in a row
   * To validate logout
   * This prevents abuse from kiosk users
   */ const secureExitClicked = [
        false,
        false,
        false,
        false
    ];
    const handleExitScannerPage = (from)=>{
        if (isSystemUser) {
            if (secureExitClicked.every((value)=>value === true)) // The sequence is okay, exit
            logout();
            const currentStep = secureExitClicked.findIndex((value)=>value === false);
            if (from === 'exit-button' && (currentStep === 0 || currentStep === 2)) {
                // exit button can only be clicked in a valid sequence position
                secureExitClicked[currentStep] = true;
                return;
            }
            if (from === 'logo' && (currentStep === 1 || currentStep === 3)) {
                // logo button can only be clicked in a valid sequence position
                secureExitClicked[currentStep] = true;
                return;
            }
            // The sequence is invalid, reset
            secureExitClicked[0] = false;
            secureExitClicked[1] = false;
            secureExitClicked[2] = false;
            secureExitClicked[3] = false;
        } else if (from === 'exit-button') navigate('/');
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        hideHeader: true,
        hideFooter: true,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
            initialValues: {
                qr: ''
            },
            onSubmit: async (values, { resetForm: resetForm })=>{
                if (!isOnline) return;
                const now = new Date().getTime();
                if (values.qr) {
                    if (JSON.stringify(values.qr) === JSON.stringify(lastQrSent.value) && (0, $e535dc0fd49418c6$export$2e2bcd8739ae039)(now, lastQrSent.time) < 5) return;
                    try {
                        const hash = JSON.parse(values.qr);
                        if (hash.content && hash.iv) await mutation.mutateAsync({
                            hash: JSON.parse(values.qr)
                        }, {
                            onSuccess: ()=>{
                                setLastQrSent({
                                    value: values.qr,
                                    time: now
                                });
                            }
                        }).catch((e)=>e);
                    } catch (err) {
                        setQrReaderError("Ce QR Code n'est pas valide");
                    }
                    resetForm({
                        values: {
                            qr: ''
                        }
                    });
                }
            },
            children: (props)=>{
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Hero), {
                    size: 'fullheight',
                    color: clockingResultColor,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Hero).Header, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                centered: true,
                                breakpoint: 'mobile',
                                mx: 3,
                                mt: 2,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        textAlign: 'left',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("button", {
                                            "data-test": "logo-exit-button",
                                            onClick: ()=>handleExitScannerPage('logo'),
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("img", {
                                                src: $dc4d8e29ac375220$exports,
                                                alt: "TeamTim",
                                                width: 80
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        textAlign: 'center',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("label", {
                                            className: "label has-text-centered",
                                            children: currentOrganization?.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        textAlign: 'right',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$var$StatusTag, {
                                            isOnline: isOnline
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Hero).Body, {
                            justifyContent: "center",
                            className: "p-0",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                centered: true,
                                className: "is-mobile",
                                style: {
                                    flexBasis: 'min(70vw, 70vh)'
                                },
                                vCentered: true,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    textSize: 4,
                                    textWeight: "bold",
                                    children: [
                                        qrReaderError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $58f73d374db62abb$export$7400b11770f383d6), {
                                            cb: ()=>setQrReaderError(undefined),
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$var$Beep, {}),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                    color: clockingResultColor,
                                                    mb: 3,
                                                    textSize: 5,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                        py: 3,
                                                        children: [
                                                            qrReaderError,
                                                            " (",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58f73d374db62abb$export$15cef08a1ebd9933), {}),
                                                            ")"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        mutation.isSuccess && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $58f73d374db62abb$export$7400b11770f383d6), {
                                            cb: ()=>mutation.reset(),
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$var$Beep, {}),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                    color: clockingResultColor,
                                                    mb: 3,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                        py: 3,
                                                        textSize: 5,
                                                        children: [
                                                            mutation.data.data.mission ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                children: [
                                                                    "Pointage enregistr\xe9 \xe0 ",
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                                    " ",
                                                                    (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(mutation.data.data.date)
                                                                ]
                                                            }) : 'Aucune mission en cours',
                                                            "\xa0(",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58f73d374db62abb$export$15cef08a1ebd9933), {}),
                                                            ")"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        mutation.isError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $58f73d374db62abb$export$7400b11770f383d6), {
                                            cb: ()=>mutation.reset(),
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$var$Beep, {}),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                    color: clockingResultColor,
                                                    mb: 3,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                        py: 3,
                                                        textSize: 5,
                                                        children: [
                                                            "Pas autoris\xe9 (",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58f73d374db62abb$export$15cef08a1ebd9933), {}),
                                                            ")"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        !qrReaderError && !mutation.isSuccess && !mutation.isError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                            color: isOnline ? clockingResultColor : 'danger',
                                            mb: 3,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                textAlign: 'center',
                                                py: 3,
                                                textSize: 5,
                                                children: isOnline ? 'Scannez votre QR' : 'Temporairement indisponible'
                                            })
                                        }),
                                        isOnline && (scanner === 'laser' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$export$c866784032d8a2cc, {
                                            formikProps: props
                                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($c93d76b9aedf6493$export$fe6539e4f49d25af, {
                                            camera: camera,
                                            setCamera: setCamera,
                                            mode: mode,
                                            setMode: setMode,
                                            setQrReaderError: setQrReaderError,
                                            formikProps: props
                                        }))
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Hero).Footer, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                mx: 5,
                                mb: 3,
                                breakpoint: "mobile",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: isSystemUser ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                textSize: 7,
                                                textColor: "grey",
                                                children: "Mode kiosque"
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                size: "small",
                                                onClick: ()=>navigate('/kiosk'),
                                                outlined: true,
                                                textColor: "grey",
                                                pull: "right",
                                                backgroundColor: "white",
                                                children: "Cr\xe9er un kiosque"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            size: "small",
                                            onClick: ()=>handleExitScannerPage('exit-button'),
                                            color: 'ghost',
                                            "data-test": "exit-qr-scanner",
                                            textColor: "grey",
                                            textWeight: "bold",
                                            style: {
                                                textDecoration: 'none'
                                            },
                                            children: "x"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        })
    });
};
var $c93d76b9aedf6493$export$2e2bcd8739ae039 = $c93d76b9aedf6493$var$QrScannerPage;
const $c93d76b9aedf6493$export$c866784032d8a2cc = ({ formikProps: formikProps })=>{
    const inputRef = (0, $3ZYaX.useRef)('');
    const { setFieldValue: setFieldValue, submitForm: submitForm } = formikProps;
    (0, $3ZYaX.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === 'Enter') {
                if (inputRef.current === '') return;
                setFieldValue('qr', inputRef.current);
                submitForm();
                inputRef.current = '';
            } else {
                if (event.key.length !== 1) return;
                inputRef.current = inputRef.current + event.key // Update input as keys are pressed
                ;
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
const $c93d76b9aedf6493$export$fe6539e4f49d25af = ({ mode: mode, setMode: setMode, setQrReaderError: setQrReaderError, camera: camera, setCamera: setCamera, formikProps: formikProps })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            style: {
                                transform: mode === 'kiosk' ? 'scaleX(-1)' : ''
                            },
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: "qr",
                                component: (0, $0d4f60665e91cba2$export$2e2bcd8739ae039),
                                setQrReaderError: setQrReaderError,
                                required: true,
                                facingMode: camera,
                                "data-test": "camera-scanner-input-field"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            px: 2,
                            mt: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tabs), {
                                                size: 'small',
                                                type: "toggle-rounded",
                                                color: "primary",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                                        active: mode === 'kiosk',
                                                        onClick: ()=>setMode('kiosk'),
                                                        backgroundColor: mode !== 'kiosk' ? 'light' : undefined,
                                                        children: [
                                                            mode === 'kiosk' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6eaf6428dd466039$export$2e2bcd8739ae039), {
                                                                    color: "success"
                                                                })
                                                            }),
                                                            "Kiosque"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                                        active: mode === 'mobile',
                                                        onClick: ()=>setMode('mobile'),
                                                        backgroundColor: mode !== 'mobile' ? 'light' : undefined,
                                                        children: [
                                                            mode === 'mobile' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6eaf6428dd466039$export$2e2bcd8739ae039), {})
                                                            }),
                                                            "Mobile"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                                            size: "small",
                                            type: "toggle-rounded",
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                                backgroundColor: "white",
                                                onClick: ()=>setCamera(camera === 'user' ? 'environment' : 'user'),
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    color: "primary",
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8247dfea1489559e$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("input", {
                type: "text",
                name: "qr",
                onChange: formikProps.handleChange,
                value: formikProps.values.qr,
                style: {
                    border: 0,
                    boxShadow: 'none',
                    color: 'transparent',
                    backgroundColor: 'transparent'
                }
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                values: formikProps.values,
                submitForm: formikProps.submitForm
            })
        ]
    });
};




const $f47344a125f16c1f$var$QrLoginForm = ({ loginAsQrScannerForEmployerId: loginAsQrScannerForEmployerId })=>{
    const authMutation = (0, $e607e015ac40917d$export$7d483d5f301dc18f)();
    const laserScannerInitialValues = {
        qr: ''
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
            initialValues: laserScannerInitialValues,
            onSubmit: async (values, { resetForm: resetForm })=>{
                if (values.qr) {
                    try {
                        const hash = JSON.parse(values.qr);
                        if (hash.content && hash.iv) authMutation.mutate({
                            qr: JSON.parse(values.qr),
                            loginAsQrScannerForEmployerId: loginAsQrScannerForEmployerId
                        });
                    } catch (err) {
                        console.error(err);
                    }
                    resetForm({
                        values: {
                            qr: ''
                        }
                    });
                }
            },
            children: (props)=>{
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textAlign: 'center',
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                size: 'large',
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a326b8f6e31ceb86$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 6,
                                children: "Scannez votre QR"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c93d76b9aedf6493$export$c866784032d8a2cc), {
                                formikProps: props
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {
                                display: "inline-block"
                            })
                        ]
                    })
                });
            }
        })
    });
};
var $f47344a125f16c1f$export$2e2bcd8739ae039 = $f47344a125f16c1f$var$QrLoginForm;


const $aeb9e0714ba9107e$var$Login = ()=>{
    const { state: state } = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const message = state?.message;
    const isKioskLogin = state?.isKioskLogin;
    const [loginMethod, setLoginMethod] = (0, $3ZYaX.useState)('qrLogin');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: "medium",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    centered: true,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 4,
                        children: [
                            message && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                                color: message.color,
                                children: [
                                    message.header && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                                        children: message.header
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                        children: message.body
                                    })
                                ]
                            }),
                            isKioskLogin ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        children: "Cr\xe9er un Kiosque"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tabs), {
                                        type: "boxed",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                                active: loginMethod === 'emailLogin',
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "ghost",
                                                    textColor: loginMethod === 'emailLogin' ? 'primary' : 'grey',
                                                    onClick: ()=>setLoginMethod('emailLogin'),
                                                    children: "Par Email"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                                active: loginMethod === 'qrLogin',
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "ghost",
                                                    textColor: loginMethod === 'qrLogin' ? 'primary' : 'grey',
                                                    onClick: ()=>setLoginMethod('qrLogin'),
                                                    children: "Par Qr Code"
                                                })
                                            })
                                        ]
                                    }),
                                    loginMethod === 'emailLogin' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb38d915bad6f3af$export$2e2bcd8739ae039), {})
                                    }),
                                    loginMethod === 'qrLogin' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f47344a125f16c1f$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        children: "Login"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb38d915bad6f3af$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $aeb9e0714ba9107e$export$2e2bcd8739ae039 = $aeb9e0714ba9107e$var$Login;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");

// Get resource id in url and check if id is equal to know if we are on a resource creation page
const $63c662283bf01ad2$var$useUrlId = (options)=>{
    const { pathname: pathname } = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const urlId = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)()[(options || {}).idName || 'id'];
    const isNew = Boolean(pathname.match(/new$/));
    const isEdit = Boolean(pathname.match(/edit$/));
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>({
            id: urlId === 'new' ? undefined : urlId,
            isNew: isNew,
            isEdit: isEdit
        }), [
        urlId,
        pathname,
        options
    ]);
};
var $63c662283bf01ad2$export$2e2bcd8739ae039 = $63c662283bf01ad2$var$useUrlId;








const $95b615b9836b813c$var$POPULATE = [
    'workPeriods.events.item',
    'workPeriods.start.clocking',
    'workPeriods.start.comments.user',
    'workPeriods.end.comments.user',
    'workPeriods.end.clocking',
    'workPeriods.service',
    'workPeriods.tags',
    'user',
    'employer',
    'interimAgency',
    'jobTitle',
    'service',
    'tags'
];
/**
 * Builds fetch params for missions list/count.
 * When both start and end are set (week range), returns missions that overlap the week
 * or have no end date: start <= end of week AND (end >= start of week OR end === null).
 */ const $95b615b9836b813c$var$buildFetchParams = (params)=>{
    const { start: start, end: end, 'workPeriods.periodSummary': periodSummary, ...rest } = params;
    const res = {
        sort: 'user.lastName',
        summary: true,
        populate: $95b615b9836b813c$var$POPULATE,
        ...rest
    };
    if (periodSummary?.length === 1 && (periodSummary[0] === 'true' || periodSummary[0] === true)) res['workPeriods.periodSummary'] = '';
    else if (periodSummary?.length === 1 && (periodSummary[0] === 'false' || periodSummary[0] === false)) res['!workPeriods.periodSummary'] = '';
    else if (periodSummary?.length === 1) res['workPeriods.periodSummary'] = periodSummary[0];
    // Week range [start, end]: missions that overlap the week or have no end (end === null).
    // Overlap = mission starts before or during the week AND (mission ends after or during the week OR end is null).
    if (start != null && end != null) res.filter = JSON.stringify({
        start: {
            $lte: end
        },
        $or: [
            {
                end: {
                    $gte: start
                }
            },
            {
                end: null
            }
        ]
    });
    else {
        res['end>'] = start ? (0, $bf358204eecbb5df$export$2e2bcd8739ae039)(start, 1) : undefined;
        res['start<'] = end ? (0, $5cd07d7a10c54769$export$2e2bcd8739ae039)(end, 1) : undefined;
    }
    return res;
};
const $95b615b9836b813c$var$buildFetchSummaryParams = (params)=>{
    const res = $95b615b9836b813c$var$buildFetchParams(params);
    delete res['start>'];
    delete res['start<'];
    res.week = params.week || (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(new Date(params.start));
    res.year = params.year || (0, $74f17ceb9b5a08a5$export$12d572480ceb6e58)(new Date(params.start));
    return res;
};
const $95b615b9836b813c$var$buildFetchSummariesParams = (params)=>{
    const res = $95b615b9836b813c$var$buildFetchParams(params);
    delete res.week;
    delete res.year;
    return res;
};
const $95b615b9836b813c$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions',
        method: 'get',
        params: $95b615b9836b813c$var$buildFetchParams(params)
    });
const $95b615b9836b813c$export$85b9a36db797e02b = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions/count',
        method: 'get',
        params: $95b615b9836b813c$var$buildFetchParams(params)
    });
const $95b615b9836b813c$export$8b7ef877fdfca70b = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions/summary',
        method: 'get',
        params: $95b615b9836b813c$var$buildFetchSummaryParams(params)
    });
const $95b615b9836b813c$export$d3a096e2feff9e33 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions/weeks-summary',
        method: 'get',
        params: $95b615b9836b813c$var$buildFetchSummariesParams(params)
    });
const $95b615b9836b813c$export$3b2f9b8e2a32ffc2 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions/weeks-summary/status',
        method: 'get',
        params: $95b615b9836b813c$var$buildFetchSummariesParams(params)
    });
const $95b615b9836b813c$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${id}`,
        method: 'get',
        params: {
            populate: $95b615b9836b813c$var$POPULATE,
            summary: true
        }
    });
const $95b615b9836b813c$export$41d6d423d3b11438 = async (params)=>{
    const { start: start, end: end, type: type, ...rest } = params;
    const res = await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions/summary/export',
        method: 'get',
        params: {
            sort: 'user.lastName',
            ...$95b615b9836b813c$var$buildFetchParams(rest),
            from: start,
            to: end,
            type: type
        }
    });
    return res;
};
const $95b615b9836b813c$export$185802fd694ee1f5 = async (params)=>{
    if (params.workPeriods) params.workPeriods = params.workPeriods.filter((w)=>w);
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/missions',
        method: 'post',
        params: params
    });
};
const $95b615b9836b813c$export$722fbec263ad908a = async (params)=>{
    const { _id: _id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${_id}`,
        method: 'put',
        params: payload
    });
};
const $95b615b9836b813c$export$f60d5bdd5fa5931f = async (data)=>{
    const { missionId: missionId } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/unabandon`,
        method: 'put'
    });
};







const $9f1d1731544630ca$export$3988ae62b71be9a3 = async (idOrParams)=>{
    const id = typeof idOrParams === 'string' ? idOrParams : idOrParams.id;
    const summary = typeof idOrParams === 'string' ? undefined : idOrParams.summary;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-periods/${id}`,
        method: 'get',
        params: {
            ...summary ? {
                summary: true
            } : {}
        }
    });
};
const $9f1d1731544630ca$export$e7aa7bc5c1b3cfb3 = async (data)=>{
    const { start: start, end: end, events: events, 'events!': excludedEvents, ...rest } = data || {};
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/work-periods',
        method: 'get',
        params: {
            ...rest,
            // Map start/end to MongoDB date range on start.date.
            // Use end as-is (e.g. endOfWeek) so the upper bound is strictly before next day;
            // adding 1ms would send Monday 00:00:00 and can include the next week's Monday due to timezone/serialization.
            ...start ? {
                'start.date>': (0, $bf358204eecbb5df$export$2e2bcd8739ae039)(start, 1)
            } : {},
            ...end ? {
                'start.date<': end
            } : {},
            // Map events shorthand to the actual nested field (events.item)
            ...events ? {
                'events.item': events
            } : {},
            // Map events negation to the nested field (events.item!)
            ...excludedEvents ? {
                'events.item!': excludedEvents
            } : {}
        }
    });
};
const $9f1d1731544630ca$export$185802fd694ee1f5 = async (data)=>{
    const { missionId: missionId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods`,
        method: 'post',
        params: payload
    });
};
const $9f1d1731544630ca$export$722fbec263ad908a = async (data)=>{
    const { missionId: missionId, workPeriodId: workPeriodId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/${workPeriodId}`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$a22775fa5e2eebd9 = async (data)=>{
    const { workPeriodId: workPeriodId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-periods/${workPeriodId}/validate`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$a9cb8a9ea653e7a6 = async (data)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-periods/validate-many`,
        method: 'put',
        params: data
    });
};
const $9f1d1731544630ca$export$70b61ad426ddbe54 = async (data)=>{
    const { missionId: missionId, workPeriodId: workPeriodId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/${workPeriodId}/cancel`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$e13a8ecb7e617ab4 = async (data)=>{
    const { missionId: missionId, workPeriodId: workPeriodId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/${workPeriodId}/abandon`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$b1b765a27734f4ea = async (data)=>{
    const { missionId: missionId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/add-events`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$cd7f480d6b8286c3 = async (data)=>{
    const { missionId: missionId, workPeriodId: workPeriodId } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/${workPeriodId}`,
        method: 'delete'
    });
};
const $9f1d1731544630ca$export$105029ea37fa4379 = async (data)=>{
    const { workPeriodId: workPeriodId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-periods/${workPeriodId}/tags`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$aea21ec796f38ddf = async (data)=>{
    const { missionId: missionId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/work-periods/add-tags`,
        method: 'put',
        params: payload
    });
};
const $9f1d1731544630ca$export$3ac30800c7892425 = async (data)=>{
    const { missionId: missionId, ...payload } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/missions/${missionId}/materialize-day`,
        method: 'post',
        params: payload
    });
};






const $0d8be5600290f391$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/work-period-events',
        method: 'get',
        params: {
            sort: 'code',
            ...params || {}
        }
    });
const $0d8be5600290f391$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-period-events/${id}`,
        method: 'get'
    });
const $0d8be5600290f391$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/work-period-events',
        method: 'post',
        params: params
    });
const $0d8be5600290f391$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-period-events/${id}`,
        method: 'put',
        params: payload
    });
};


//Queries
const $70137e1130a90c1c$var$useWorkPeriodEventQuery = (id)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('work-period-events', (0, $0d8be5600290f391$export$3988ae62b71be9a3), id);
const $70137e1130a90c1c$export$141fa2cdeb74f02a = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('work-period-events', (0, $0d8be5600290f391$export$e7aa7bc5c1b3cfb3), filters, options);
//Mutations
const $70137e1130a90c1c$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'work-period-events'
    ]);
};
const $70137e1130a90c1c$export$4a6f974b4208311 = ()=>[
        'work-period-events',
        'create'
    ];
const $70137e1130a90c1c$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $0d8be5600290f391$export$185802fd694ee1f5), {
        mutationKey: $70137e1130a90c1c$export$4a6f974b4208311(),
        onSuccess: $70137e1130a90c1c$var$onMutationSuccess
    });
const $70137e1130a90c1c$export$a6fe4df8bec26327 = ()=>[
        'work-period-events',
        'update'
    ];
const $70137e1130a90c1c$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $0d8be5600290f391$export$722fbec263ad908a), {
        mutationKey: $70137e1130a90c1c$export$a6fe4df8bec26327(),
        onSuccess: $70137e1130a90c1c$var$onMutationSuccess
    });



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");


var $2KSUA = parcelRequire("2KSUA");

var $2KSUA = parcelRequire("2KSUA");
const $b31fa4978015d2ce$export$14ce5b0f6fbe4001 = (arr, fromIndex, toIndex)=>{
    const element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
};
/**
 * Normalizes a string by removing accents and converting to lowercase
 * Example: "Éléphant" => "elephant"
 * @param str - The string to normalize
 * @returns The normalized string
 */ const $b31fa4978015d2ce$var$normalizeString = (str)=>{
    return str.normalize('NFD') // Decompose characters (é => e + ́)
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .toLowerCase();
};
const $b31fa4978015d2ce$export$c70f2fe738210bdf = (array, key)=>(0, $2KSUA.orderBy)(array, [
        (item)=>$b31fa4978015d2ce$var$normalizeString((0, $2KSUA.get)(item || {}, key) || '')
    ]);
const $b31fa4978015d2ce$export$863d7151f7b1a894 = (array, key)=>{
    return array.filter((item, index, self)=>index === self.findIndex((i)=>i[key] === item[key]));
};


const $7fcb743e4eebb394$export$f97653d8ee55c674 = (list, options)=>{
    if (!options) options = {};
    const { blank: blank, sortBy: sortBy } = options;
    if (blank && !blank.value) blank.value = '';
    const items = list.map((listItem)=>{
        const sanitized = {
            value: typeof listItem === 'string' ? listItem : (0, $2KSUA.get)(listItem, options?.valueKeyPath || '_id'),
            label: typeof listItem === 'string' ? listItem : options?.labelBuilder ? options.labelBuilder(listItem) : (0, $2KSUA.get)(listItem, options?.labelKeyPath || 'name'),
            item: listItem,
            renderedLabel: options?.renderLabel && options.renderLabel(listItem),
            disabled: options?.disabled ? options.disabled(listItem) : false
        };
        return sanitized;
    });
    const itemsToReturn = [
        ...blank ? [
            blank
        ] : [],
        ...items
    ];
    if (sortBy === null) return itemsToReturn;
    return (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(itemsToReturn, sortBy ? sortBy : 'label');
};



/**
 * Sentinel values for synthetic filter options
 */ const $e2afd48e3c6e79e0$export$7b3ce4e0dde6175e = '__all_absences__';
const $e2afd48e3c6e79e0$export$f7198e19fe8231ab = '__all_presences__';
/**
 * Component for filtering events in a multi-select field
 * Uses work period events data from the API
 * Includes synthetic options for filtering by absence/presence patterns
 */ const $e2afd48e3c6e79e0$var$EventsFilterField = ({ disabledQueries: disabledQueries, queriesStaleTime: queriesStaleTime, labels: labels })=>{
    const eventsQuery = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)({}, {
        enabled: !disabledQueries,
        staleTime: queriesStaleTime
    });
    // Build synthetic options for absence/presence filtering
    const syntheticOptions = [
        {
            value: $e2afd48e3c6e79e0$export$7b3ce4e0dde6175e,
            label: labels?.allAbsences || 'Toutes les absences'
        },
        {
            value: $e2afd48e3c6e79e0$export$f7198e19fe8231ab,
            label: labels?.allPresences || "Toutes les pr\xe9sences"
        }
    ];
    // Build real event options
    const realEventOptions = (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(eventsQuery.data || [], {
        labelKeyPath: 'title'
    });
    // Combine synthetic options with real events (synthetic options appear first)
    const allOptions = [
        ...syntheticOptions,
        ...realEventOptions
    ];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "\xc9v\xe9nements",
            name: "events",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: allOptions
        })
    });
};
var $e2afd48e3c6e79e0$export$2e2bcd8739ae039 = $e2afd48e3c6e79e0$var$EventsFilterField;


const $c088e82ce699198f$export$d36d763408d7462f = (events)=>{
    // Fetch all absence events from the API
    const workperiodEventsQuery = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)({
        indicatesAbsence: true
    }, {
        staleTime: 300000
    });
    // Initialize result object
    const result = {};
    // If no events provided, return empty result
    if (!events || events.length === 0) return result;
    // Create a Set from the events array for efficient lookups
    const eventsSet = new Set(events);
    const excludedEvents = [];
    const allAbsences = workperiodEventsQuery.data || [];
    // Check if sentinel values are present
    const hasAllAbsencesOption = eventsSet.has((0, $e2afd48e3c6e79e0$export$7b3ce4e0dde6175e));
    const hasAllPresencesOption = eventsSet.has((0, $e2afd48e3c6e79e0$export$f7198e19fe8231ab));
    // If ALL_PRESENCES_SENTINEL is present, exclude all absence events
    if (hasAllPresencesOption) excludedEvents.push(...allAbsences.map((absence)=>absence._id));
    // If ALL_ABSENCES_SENTINEL is present, add all absence event IDs to the events set
    if (hasAllAbsencesOption) allAbsences.forEach((absence)=>eventsSet.add(absence._id));
    // Add excluded events to result if any
    if (excludedEvents.length > 0) result['events!'] = excludedEvents;
    // Filter out sentinel values and non-string values, then add to result
    if (eventsSet.size > 0) result.events = Array.from(eventsSet).filter((event)=>event !== (0, $e2afd48e3c6e79e0$export$7b3ce4e0dde6175e) && event !== (0, $e2afd48e3c6e79e0$export$f7198e19fe8231ab) && typeof event === 'string');
    return result;
};


const $7040c29cc25c4df6$export$3886f9d4f8d33b01 = (id, params, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('work-periods', (0, $9f1d1731544630ca$export$3988ae62b71be9a3), id, params, options);
const $7040c29cc25c4df6$export$89c7b6e8405078f3 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('work-periods', (0, $9f1d1731544630ca$export$3988ae62b71be9a3), id, {
        summary: true
    }, options);
const $7040c29cc25c4df6$export$57d45acb75ee0b10 = (filters, options)=>{
    // Normalize events filters (transform sentinels to actual event IDs)
    const normalizedEvents = (0, $c088e82ce699198f$export$d36d763408d7462f)(filters?.events);
    // Merge normalized events into filters
    const normalizedFilters = {
        ...filters,
        ...normalizedEvents
    };
    return (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('work-periods', (0, $9f1d1731544630ca$export$e7aa7bc5c1b3cfb3), normalizedFilters, options);
};
//Mutations
const $7040c29cc25c4df6$var$useUpdateMutationKey = ()=>[
        'missions',
        'work-periods',
        'update'
    ];
const $7040c29cc25c4df6$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$722fbec263ad908a), {
        mutationKey: $7040c29cc25c4df6$var$useUpdateMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$var$useCreateWorkPeriodMutationKey = ()=>[
        'missions',
        'work-periods',
        'create'
    ];
const $7040c29cc25c4df6$export$3e7a0a94c435902d = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$185802fd694ee1f5), {
        mutationKey: $7040c29cc25c4df6$var$useCreateWorkPeriodMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$var$useValidateMutationKey = ()=>[
        'missions',
        'work-periods',
        'validate'
    ];
const $7040c29cc25c4df6$export$6cbf757d2bdf6301 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$a22775fa5e2eebd9), {
        mutationKey: $7040c29cc25c4df6$var$useValidateMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$var$useCancelMutationKey = ()=>[
        'missions',
        'work-periods',
        'cancel'
    ];
const $7040c29cc25c4df6$export$24d81c65f1ba5310 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$70b61ad426ddbe54), {
        mutationKey: $7040c29cc25c4df6$var$useCancelMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$var$useAbandonMutationKey = ()=>[
        'missions',
        'work-periods',
        'abandon'
    ];
const $7040c29cc25c4df6$export$94ce31c9ab479ad = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$e13a8ecb7e617ab4), {
        mutationKey: $7040c29cc25c4df6$var$useAbandonMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$var$useRemoveWorkPeriodMutationKey = ()=>[
        'missions',
        'work-periods',
        'remove'
    ];
const $7040c29cc25c4df6$export$8b43aa0b788b22a8 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$cd7f480d6b8286c3), {
        mutationKey: $7040c29cc25c4df6$var$useRemoveWorkPeriodMutationKey(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$107150c86003ba27 = ()=>[
        'missions',
        'work-periods',
        'add-events'
    ];
const $7040c29cc25c4df6$export$c2dc3ab22a878005 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$b1b765a27734f4ea), {
        mutationKey: $7040c29cc25c4df6$export$107150c86003ba27(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$96c13d66bd25ec81 = ()=>[
        'missions',
        'work-periods',
        'validate-many'
    ];
const $7040c29cc25c4df6$export$15cde0eec5c3d0b0 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$a9cb8a9ea653e7a6), {
        mutationKey: $7040c29cc25c4df6$export$96c13d66bd25ec81(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$1fbab0e105764121 = ()=>[
        'work-periods',
        'update-tags'
    ];
const $7040c29cc25c4df6$export$3bdf6f6f236d25ce = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$105029ea37fa4379), {
        mutationKey: $7040c29cc25c4df6$export$1fbab0e105764121(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$5cc3207d9e01eb71 = ()=>[
        'missions',
        'work-periods',
        'add-tags'
    ];
const $7040c29cc25c4df6$export$f0a10b473a0614fd = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$aea21ec796f38ddf), {
        mutationKey: $7040c29cc25c4df6$export$5cc3207d9e01eb71(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$8241eff6aaa06e28 = ()=>[
        'missions',
        'work-periods',
        'materialize-day'
    ];
const $7040c29cc25c4df6$export$8f6c4d8eb9ae77b1 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $9f1d1731544630ca$export$3ac30800c7892425), {
        mutationKey: $7040c29cc25c4df6$export$8241eff6aaa06e28(),
        onSuccess: ()=>{
            $7040c29cc25c4df6$export$bf6adb4ca12dd654();
            (0, $e409591b67738e56$export$6cbba9eced1790c7)();
        }
    });
const $7040c29cc25c4df6$export$bf6adb4ca12dd654 = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'work-periods'
    ]);
};






function $aa33e773084f22af$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    return day;
}


const $e409591b67738e56$export$8940e75313b372c9 = (id)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('missions', (0, $95b615b9836b813c$export$3988ae62b71be9a3), id);
const $e409591b67738e56$export$73e9dd07495d29c8 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('missions/count', (0, $95b615b9836b813c$export$85b9a36db797e02b), filters || (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions]), options);
const $e409591b67738e56$export$6ae450315cbb235e = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('missions', (0, $95b615b9836b813c$export$e7aa7bc5c1b3cfb3), filters || (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions]), options);
const $e409591b67738e56$export$3c54b31350a650f7 = (filters, options)=>{
    const allFilters = filters || (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions]);
    // Extract and exclude summaryMinimalMode and displayDay from filters
    // These are UI-specific and should not be sent to the API
    const { summaryMinimalMode: summaryMinimalMode, displayDay: displayDay, ...params } = allFilters;
    // Normalize events filters (transform sentinels to actual event IDs)
    const normalizedEvents = (0, $c088e82ce699198f$export$d36d763408d7462f)(params?.events);
    // Merge normalized events into params
    const normalizedParams = {
        ...params,
        ...normalizedEvents,
        days: displayDay ? [
            (0, $74f17ceb9b5a08a5$export$a155f41bf7aedf47)((0, $aa33e773084f22af$export$2e2bcd8739ae039)(new Date(displayDay)))
        ] : undefined
    };
    return (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('missions/summary', (0, $95b615b9836b813c$export$8b7ef877fdfca70b), normalizedParams, options);
};
const $e409591b67738e56$export$9a76bd0612b2790c = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('missions/weeks-summary', (0, $95b615b9836b813c$export$d3a096e2feff9e33), filters, options);
const $e409591b67738e56$export$e84704a7c7ffcb81 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('missions/weeks-summary/status', (0, $95b615b9836b813c$export$3b2f9b8e2a32ffc2), filters, options);
//Mutations
const $e409591b67738e56$var$useCreateMutationKey = ()=>[
        'missions',
        'create'
    ];
const $e409591b67738e56$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $95b615b9836b813c$export$185802fd694ee1f5), {
        mutationKey: $e409591b67738e56$var$useCreateMutationKey(),
        onSuccess: ()=>{
            $e409591b67738e56$export$6cbba9eced1790c7();
            (0, $7040c29cc25c4df6$export$bf6adb4ca12dd654)();
        }
    });
const $e409591b67738e56$export$a6fe4df8bec26327 = ()=>[
        'missions',
        'update'
    ];
const $e409591b67738e56$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $95b615b9836b813c$export$722fbec263ad908a), {
        mutationKey: $e409591b67738e56$export$a6fe4df8bec26327(),
        onSuccess: ()=>{
            $e409591b67738e56$export$6cbba9eced1790c7();
            (0, $7040c29cc25c4df6$export$bf6adb4ca12dd654)();
        }
    });
const $e409591b67738e56$var$useExportSummaryMutationKey = ()=>[
        'missions',
        'csv'
    ];
const $e409591b67738e56$export$3f810d32a533726c = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $95b615b9836b813c$export$41d6d423d3b11438), {
        mutationKey: $e409591b67738e56$var$useExportSummaryMutationKey()
    });
const $e409591b67738e56$export$47b6499a1647bdd6 = ()=>[
        'missions',
        'unAbandon'
    ];
const $e409591b67738e56$export$798c00a2090f5996 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $95b615b9836b813c$export$f60d5bdd5fa5931f), {
        mutationKey: $e409591b67738e56$export$47b6499a1647bdd6(),
        onSuccess: ()=>{
            $e409591b67738e56$export$6cbba9eced1790c7();
            (0, $7040c29cc25c4df6$export$bf6adb4ca12dd654)();
        }
    });
const $e409591b67738e56$export$6cbba9eced1790c7 = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'missions'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'missions/summary'
    ]);
};



parcelRequire("3ZYaX");



parcelRequire("3ZYaX");

const $044c47f4b5e1e1ae$var$Message = ({ color: color, icon: icon, iconColor: iconColor, text: text, 'data-test': dataTest, small: small = false, type: type = 'message' })=>{
    const bulmaSize = small ? 'small' : undefined;
    if (type === 'icon') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
        color: iconColor,
        "data-tooltip": text,
        size: bulmaSize,
        "data-test": dataTest,
        className: "has-tooltip-left",
        children: icon
    });
    if (type === 'tag') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tag), {
            color: color,
            size: small ? 'small' : 'medium',
            "data-tooltip": small ? text : undefined,
            "data-test": dataTest,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    color: iconColor,
                    children: icon
                }),
                !small && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                    style: {
                        whiteSpace: 'pre-wrap'
                    },
                    children: text
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
        color: iconColor ?? color,
        mr: 3,
        mb: 3,
        display: small ? 'inline-block' : 'block',
        "data-test": dataTest,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
            "data-tooltip": small ? text : undefined,
            className: "has-tooltip-left",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                flexWrap: "nowrap",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon), {
                        color: iconColor,
                        children: [
                            " ",
                            icon
                        ]
                    }),
                    !small && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        children: text
                    })
                ]
            })
        })
    });
};
var $044c47f4b5e1e1ae$export$2e2bcd8739ae039 = $044c47f4b5e1e1ae$var$Message;




var $f1533a9d55778507$export$2e2bcd8739ae039 = {
    types: {
        informative: "Ev\xe9nement Informatif",
        benefit: "Ev\xe9nement Prestation"
    }
};


const $a58cd4802ae2892e$export$8cdd78f580711f43 = (event, hideType = false)=>`${event.code} - ${event.title} ${hideType ? '' : `- (${(0, $f1533a9d55778507$export$2e2bcd8739ae039).types[event.type]})`}`;



var $2KSUA = parcelRequire("2KSUA");


const $dda2f26c3659cf93$export$f611ca713280ca2d = (workPeriod)=>typeof workPeriod._id === 'string' && workPeriod._id.startsWith('virtual-');
const $dda2f26c3659cf93$export$53785d8c3b1ae6dc = (workPeriods, date)=>workPeriods.find((workPeriod)=>(0, $d989ae9468b066a3$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), date));
const $dda2f26c3659cf93$export$1003465f9cabc75e = (start, end, breakRule)=>{
    if (!start || !end || !breakRule) return 0;
    const oneHour = 3600000;
    const breakDuration = oneHour * breakRule.breakDuration / 60;
    const breakGoalDuration = oneHour * breakRule.breakAllowedAfter / 60;
    let diff = (0, $ef2e6760f3e9e6fc$export$2e2bcd8739ae039)(new Date(end), new Date(start));
    if (diff >= breakGoalDuration) diff -= breakDuration;
    return diff;
};
const $dda2f26c3659cf93$export$cead3b29a17b1754 = (workPeriods, breakRule)=>{
    const totalDuration = workPeriods.reduce((duration, workPeriod)=>{
        if (workPeriod.start && workPeriod.end) return duration + $dda2f26c3659cf93$export$1003465f9cabc75e(new Date(workPeriod.start.date), new Date(workPeriod.end.date), breakRule);
        else return duration;
    }, 0);
    return totalDuration;
};
/**
 * Duration in ms for a single day slot (startHour/endHour in 0–24).
 * Handles overnight slots (endHour < startHour). Does not apply break.
 */ const $dda2f26c3659cf93$var$slotDurationMs = (startHour, endHour)=>{
    const hours = endHour >= startHour ? endHour - startHour : 24 - startHour + endHour;
    return hours * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59);
};
const $dda2f26c3659cf93$export$5d71c5150f0e4651 = (weekPattern, breakRule)=>{
    const breakDurationMs = breakRule ? (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) * breakRule.breakDuration / 60 : 0;
    const breakGoalMs = breakRule ? (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) * breakRule.breakAllowedAfter / 60 : 0;
    let total = 0;
    const days = weekPattern.days ? Object.entries(weekPattern.days) : [];
    for (const [, slot] of days){
        if (!slot || typeof slot.startHour !== 'number' || typeof slot.endHour !== 'number') continue;
        let diff = $dda2f26c3659cf93$var$slotDurationMs(slot.startHour, slot.endHour);
        if (breakRule && diff >= breakGoalMs) diff -= breakDurationMs;
        total += diff;
    }
    return total;
};
const $dda2f26c3659cf93$export$5b59c196c141a4e5 = (mission, week, year)=>{
    const weekWorkPeriods = mission.workPeriods.filter((w)=>w.year === year && w.week === week);
    return weekWorkPeriods[0]?.periodSummary;
};
const $dda2f26c3659cf93$var$buildEventLabel = (event)=>(0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event.item);
const $dda2f26c3659cf93$export$72df6793a37420b0 = (events)=>(0, $2KSUA.sortBy)(events, 'item.code').map($dda2f26c3659cf93$var$buildEventLabel).join('\n');
const $dda2f26c3659cf93$export$5b362db52df0b67c = (workPeriods, eventId)=>workPeriods.filter((w)=>w.events.some((e)=>e.item._id === eventId));
const $dda2f26c3659cf93$export$111b4710bc90997 = (workPeriod)=>workPeriod.events.some((e)=>e.item.type === 'benefit');
const $dda2f26c3659cf93$export$e36670b33a845a88 = (workPeriod, eventType)=>workPeriod.events.filter((e)=>e.item.type === eventType);
const $dda2f26c3659cf93$export$3e79e33023df6cfe = (workPeriod, elementType)=>{
    // Benefit events are always blue
    if ($dda2f26c3659cf93$export$111b4710bc90997(workPeriod) && elementType === 'event') return 'info';
    // For breaks
    if (elementType === 'break' && workPeriod.manualBreak) return 'danger';
    // For start/end times
    if (elementType === 'start' || elementType === 'end') {
        const time = elementType === 'start' ? workPeriod.start : workPeriod.end;
        const counted = (0, $2KSUA.get)(workPeriod.summary, `${elementType}.counted`);
        const clockingRule = workPeriod.clockingRules.rules[elementType];
        // Manual correction is red
        if (counted === 'manual') return 'danger';
        // Clocking with theoretical time is green
        if (time.clocking && counted === 'theoretical') return 'success';
        // Clocking with clocked time is yellow
        if (time.clocking && counted === 'clocked') return 'warning';
        /**
     * Late arrivals or departures, outpassing the clocking rule are yellow
     * Only for not validated work periods
     */ if (!workPeriod.isValidated) {
            if (clockingRule.late.mode === 'theoritical') {
                // The clocking rule has no tolerance, warning is shown after theoritical time is passed
                if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(), new Date(time.date))) return 'warning';
            } else {
                // The clocking rule has tolerance, warning is shown taking tolerance into account
                if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(), (0, $5cd07d7a10c54769$export$2e2bcd8739ae039)(new Date(time.date), clockingRule.late.tolerance))) return 'warning';
            }
        }
    }
    return undefined;
};
const $dda2f26c3659cf93$export$820ff448dbc5a915 = (workPeriod, type)=>{
    const color = $dda2f26c3659cf93$export$3e79e33023df6cfe(workPeriod, type);
    const tooltipId = `${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission)}:${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod)}:${type}`;
    let date = null;
    if (type !== 'break') {
        const counted = workPeriod.summary[type].counted;
        date = counted ? workPeriod.summary[type][counted] : null;
    }
    return {
        color: color,
        tooltipId: tooltipId,
        date: date
    };
};


const $3b854228d56ab86b$export$87c7eb6b45e704ed = ({ mission: mission, ...rest })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (!mission.isCancelled) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return mission.isCancelled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: "danger",
        text: "Mission Interrompue",
        "data-test": "mission-cancelled",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$881d644e093d956f), {}),
        ...rest
    });
};
const $3b854228d56ab86b$export$54eb6f08aa91b890 = ({ mission: mission, ...rest })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (!mission.isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Mission Valid\xe9e",
        "data-test": "mission-validated",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5f977870ae3cdbf1), {}),
        iconColor: "success",
        ...rest
    });
};
const $3b854228d56ab86b$export$34068b40256a87f7 = ({ mission: mission, ...rest })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (!mission.weekIsValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Semaine Valid\xe9e",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$87cd4f2a4da4427e), {}),
        iconColor: "success",
        "data-test": "week-validated",
        ...rest
    });
};
const $3b854228d56ab86b$export$85bccb7844ae00fa = ({ mission: mission, force: force, week: week, year: year, ...rest })=>{
    const preBillingId = mission && week && year && (0, $dda2f26c3659cf93$export$5b59c196c141a4e5)(mission, week, year);
    if (!force && (!mission || !preBillingId)) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: mission && (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
        to: `/pre-billings/${preBillingId}`,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
            text: "Semaine Pr\xe9-factur\xe9e",
            icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ddf80f27ca83567b), {}),
            iconColor: "success",
            "data-test": "week-pre-billed",
            ...rest
        })
    });
};
const $3b854228d56ab86b$var$MissionCannotBeUpdatedMessage = ({ mission: mission, ...rest })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (mission.__actions.canBeUpdated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Mission ne peut plus \xeatre mise \xe0 jour",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$164e414f2cfd5f62), {}),
        ...rest
    });
};
const $3b854228d56ab86b$export$ddd1eb3f2daca47d = ({ mission: mission, ...rest })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (!mission.isAbandoned) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: 'danger',
        text: "Mission en Abandon de Poste",
        "data-test": "mission-abandoned",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6e75112b03731134), {}),
        ...rest
    });
};
const $3b854228d56ab86b$var$MissionMessages = (props)=>{
    if (!props.mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "flex",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($3b854228d56ab86b$export$54eb6f08aa91b890, {
                ...props
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($3b854228d56ab86b$export$ddd1eb3f2daca47d, {
                ...props
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($3b854228d56ab86b$export$87c7eb6b45e704ed, {
                ...props
            })
        ]
    });
};
var $3b854228d56ab86b$export$2e2bcd8739ae039 = $3b854228d56ab86b$var$MissionMessages;



parcelRequire("3ZYaX");


const $46990718fa364fdf$var$Breadcrumbs = ({ items: items })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Breadcrumb), {
        children: items.map((item, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Breadcrumb).Item, {
                children: item.to ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                    to: item.to,
                    children: item.label
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "span",
                    px: 3,
                    textWeight: index === items.length - 1 ? 'bold' : 'semibold',
                    children: item.label
                })
            }, item.label))
    });
};
var $46990718fa364fdf$export$2e2bcd8739ae039 = $46990718fa364fdf$var$Breadcrumbs;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");

var $9C0qR = parcelRequire("9C0qR");
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $9f280768f72ad412$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
var $9f280768f72ad412$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $9f280768f72ad412$export$2e2bcd8739ae039() {
    if (!$9f280768f72ad412$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    return $9f280768f72ad412$var$getRandomValues($9f280768f72ad412$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $e20db712385f8d91$var$byteToHex = [];
for(var $e20db712385f8d91$var$i = 0; $e20db712385f8d91$var$i < 256; ++$e20db712385f8d91$var$i)$e20db712385f8d91$var$byteToHex[$e20db712385f8d91$var$i] = ($e20db712385f8d91$var$i + 0x100).toString(16).substr(1);
function $e20db712385f8d91$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $e20db712385f8d91$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
var $e20db712385f8d91$export$2e2bcd8739ae039 = $e20db712385f8d91$var$bytesToUuid;


function $3d293832bafa5554$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $9f280768f72ad412$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $e20db712385f8d91$export$2e2bcd8739ae039)(rnds);
}
var $3d293832bafa5554$export$2e2bcd8739ae039 = $3d293832bafa5554$var$v4;


function $af72022a2115e300$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $af72022a2115e300$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $af72022a2115e300$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            $af72022a2115e300$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $af72022a2115e300$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $af72022a2115e300$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $af72022a2115e300$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $af72022a2115e300$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $af72022a2115e300$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $af72022a2115e300$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $af72022a2115e300$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $af72022a2115e300$var$_extends() {
    $af72022a2115e300$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $af72022a2115e300$var$_extends.apply(this, arguments);
}
function $af72022a2115e300$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $af72022a2115e300$var$_setPrototypeOf(subClass, superClass);
}
function $af72022a2115e300$var$_getPrototypeOf(o) {
    $af72022a2115e300$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $af72022a2115e300$var$_getPrototypeOf(o);
}
function $af72022a2115e300$var$_setPrototypeOf(o, p) {
    $af72022a2115e300$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $af72022a2115e300$var$_setPrototypeOf(o, p);
}
function $af72022a2115e300$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $af72022a2115e300$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $af72022a2115e300$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $af72022a2115e300$var$_assertThisInitialized(self1);
}
function $af72022a2115e300$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $af72022a2115e300$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $af72022a2115e300$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $af72022a2115e300$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $af72022a2115e300$var$_possibleConstructorReturn(this, result);
    };
}
function $af72022a2115e300$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af72022a2115e300$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af72022a2115e300$var$_arrayLikeToArray(o, minLen);
}
function $af72022a2115e300$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af72022a2115e300$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $af72022a2115e300$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = it.call(o);
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $af72022a2115e300$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $af72022a2115e300$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $af72022a2115e300$var$global$a = // eslint-disable-next-line es/no-global-this -- safe
$af72022a2115e300$var$check(typeof globalThis == 'object' && globalThis) || $af72022a2115e300$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$af72022a2115e300$var$check(typeof self == 'object' && self) || $af72022a2115e300$var$check(typeof $af72022a2115e300$var$commonjsGlobal == 'object' && $af72022a2115e300$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();
var $af72022a2115e300$var$objectGetOwnPropertyDescriptor = {};
var $af72022a2115e300$var$fails$9 = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $af72022a2115e300$var$fails$8 = $af72022a2115e300$var$fails$9;
// Detect IE8's incomplete defineProperty implementation
var $af72022a2115e300$var$descriptors = !$af72022a2115e300$var$fails$8(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $af72022a2115e300$var$fails$7 = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$functionBindNative = !$af72022a2115e300$var$fails$7(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});
var $af72022a2115e300$var$NATIVE_BIND$2 = $af72022a2115e300$var$functionBindNative;
var $af72022a2115e300$var$call$4 = Function.prototype.call;
var $af72022a2115e300$var$functionCall = $af72022a2115e300$var$NATIVE_BIND$2 ? $af72022a2115e300$var$call$4.bind($af72022a2115e300$var$call$4) : function() {
    return $af72022a2115e300$var$call$4.apply($af72022a2115e300$var$call$4, arguments);
};
var $af72022a2115e300$var$objectPropertyIsEnumerable = {};
var $af72022a2115e300$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $af72022a2115e300$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $af72022a2115e300$var$NASHORN_BUG = $af72022a2115e300$var$getOwnPropertyDescriptor$1 && !$af72022a2115e300$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$af72022a2115e300$var$objectPropertyIsEnumerable.f = $af72022a2115e300$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $af72022a2115e300$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $af72022a2115e300$var$$propertyIsEnumerable;
var $af72022a2115e300$var$createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $af72022a2115e300$var$NATIVE_BIND$1 = $af72022a2115e300$var$functionBindNative;
var $af72022a2115e300$var$FunctionPrototype$1 = Function.prototype;
var $af72022a2115e300$var$call$3 = $af72022a2115e300$var$FunctionPrototype$1.call;
var $af72022a2115e300$var$uncurryThisWithBind = $af72022a2115e300$var$NATIVE_BIND$1 && $af72022a2115e300$var$FunctionPrototype$1.bind.bind($af72022a2115e300$var$call$3, $af72022a2115e300$var$call$3);
var $af72022a2115e300$var$functionUncurryThisRaw = function(fn) {
    return $af72022a2115e300$var$NATIVE_BIND$1 ? $af72022a2115e300$var$uncurryThisWithBind(fn) : function() {
        return $af72022a2115e300$var$call$3.apply(fn, arguments);
    };
};
var $af72022a2115e300$var$uncurryThisRaw$1 = $af72022a2115e300$var$functionUncurryThisRaw;
var $af72022a2115e300$var$toString$1 = $af72022a2115e300$var$uncurryThisRaw$1({}.toString);
var $af72022a2115e300$var$stringSlice = $af72022a2115e300$var$uncurryThisRaw$1(''.slice);
var $af72022a2115e300$var$classofRaw$2 = function(it) {
    return $af72022a2115e300$var$stringSlice($af72022a2115e300$var$toString$1(it), 8, -1);
};
var $af72022a2115e300$var$classofRaw$1 = $af72022a2115e300$var$classofRaw$2;
var $af72022a2115e300$var$uncurryThisRaw = $af72022a2115e300$var$functionUncurryThisRaw;
var $af72022a2115e300$var$functionUncurryThis = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($af72022a2115e300$var$classofRaw$1(fn) === 'Function') return $af72022a2115e300$var$uncurryThisRaw(fn);
};
var $af72022a2115e300$var$uncurryThis$9 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$fails$6 = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$classof$3 = $af72022a2115e300$var$classofRaw$2;
var $af72022a2115e300$var$$Object$3 = Object;
var $af72022a2115e300$var$split = $af72022a2115e300$var$uncurryThis$9(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $af72022a2115e300$var$indexedObject = $af72022a2115e300$var$fails$6(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$af72022a2115e300$var$$Object$3('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $af72022a2115e300$var$classof$3(it) == 'String' ? $af72022a2115e300$var$split(it, '') : $af72022a2115e300$var$$Object$3(it);
} : $af72022a2115e300$var$$Object$3;
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var $af72022a2115e300$var$isNullOrUndefined$2 = function(it) {
    return it === null || it === undefined;
};
var $af72022a2115e300$var$isNullOrUndefined$1 = $af72022a2115e300$var$isNullOrUndefined$2;
var $af72022a2115e300$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $af72022a2115e300$var$requireObjectCoercible$2 = function(it) {
    if ($af72022a2115e300$var$isNullOrUndefined$1(it)) throw $af72022a2115e300$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $af72022a2115e300$var$IndexedObject$1 = $af72022a2115e300$var$indexedObject;
var $af72022a2115e300$var$requireObjectCoercible$1 = $af72022a2115e300$var$requireObjectCoercible$2;
var $af72022a2115e300$var$toIndexedObject$4 = function(it) {
    return $af72022a2115e300$var$IndexedObject$1($af72022a2115e300$var$requireObjectCoercible$1(it));
};
var $af72022a2115e300$var$documentAll$2 = typeof document == 'object' && document.all;
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $af72022a2115e300$var$IS_HTMLDDA = typeof $af72022a2115e300$var$documentAll$2 == 'undefined' && $af72022a2115e300$var$documentAll$2 !== undefined;
var $af72022a2115e300$var$documentAll_1 = {
    all: $af72022a2115e300$var$documentAll$2,
    IS_HTMLDDA: $af72022a2115e300$var$IS_HTMLDDA
};
var $af72022a2115e300$var$$documentAll$1 = $af72022a2115e300$var$documentAll_1;
var $af72022a2115e300$var$documentAll$1 = $af72022a2115e300$var$$documentAll$1.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $af72022a2115e300$var$isCallable$c = $af72022a2115e300$var$$documentAll$1.IS_HTMLDDA ? function(argument) {
    return typeof argument == 'function' || argument === $af72022a2115e300$var$documentAll$1;
} : function(argument) {
    return typeof argument == 'function';
};
var $af72022a2115e300$var$isCallable$b = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$$documentAll = $af72022a2115e300$var$documentAll_1;
var $af72022a2115e300$var$documentAll = $af72022a2115e300$var$$documentAll.all;
var $af72022a2115e300$var$isObject$6 = $af72022a2115e300$var$$documentAll.IS_HTMLDDA ? function(it) {
    return typeof it == 'object' ? it !== null : $af72022a2115e300$var$isCallable$b(it) || it === $af72022a2115e300$var$documentAll;
} : function(it) {
    return typeof it == 'object' ? it !== null : $af72022a2115e300$var$isCallable$b(it);
};
var $af72022a2115e300$var$global$9 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$isCallable$a = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$aFunction = function(argument) {
    return $af72022a2115e300$var$isCallable$a(argument) ? argument : undefined;
};
var $af72022a2115e300$var$getBuiltIn$5 = function(namespace, method) {
    return arguments.length < 2 ? $af72022a2115e300$var$aFunction($af72022a2115e300$var$global$9[namespace]) : $af72022a2115e300$var$global$9[namespace] && $af72022a2115e300$var$global$9[namespace][method];
};
var $af72022a2115e300$var$uncurryThis$8 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$objectIsPrototypeOf = $af72022a2115e300$var$uncurryThis$8({}.isPrototypeOf);
var $af72022a2115e300$var$getBuiltIn$4 = $af72022a2115e300$var$getBuiltIn$5;
var $af72022a2115e300$var$engineUserAgent = $af72022a2115e300$var$getBuiltIn$4('navigator', 'userAgent') || '';
var $af72022a2115e300$var$global$8 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$userAgent = $af72022a2115e300$var$engineUserAgent;
var $af72022a2115e300$var$process = $af72022a2115e300$var$global$8.process;
var $af72022a2115e300$var$Deno = $af72022a2115e300$var$global$8.Deno;
var $af72022a2115e300$var$versions = $af72022a2115e300$var$process && $af72022a2115e300$var$process.versions || $af72022a2115e300$var$Deno && $af72022a2115e300$var$Deno.version;
var $af72022a2115e300$var$v8 = $af72022a2115e300$var$versions && $af72022a2115e300$var$versions.v8;
var $af72022a2115e300$var$match, $af72022a2115e300$var$version;
if ($af72022a2115e300$var$v8) {
    $af72022a2115e300$var$match = $af72022a2115e300$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $af72022a2115e300$var$version = $af72022a2115e300$var$match[0] > 0 && $af72022a2115e300$var$match[0] < 4 ? 1 : +($af72022a2115e300$var$match[0] + $af72022a2115e300$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$af72022a2115e300$var$version && $af72022a2115e300$var$userAgent) {
    $af72022a2115e300$var$match = $af72022a2115e300$var$userAgent.match(/Edge\/(\d+)/);
    if (!$af72022a2115e300$var$match || $af72022a2115e300$var$match[1] >= 74) {
        $af72022a2115e300$var$match = $af72022a2115e300$var$userAgent.match(/Chrome\/(\d+)/);
        if ($af72022a2115e300$var$match) $af72022a2115e300$var$version = +$af72022a2115e300$var$match[1];
    }
}
var $af72022a2115e300$var$engineV8Version = $af72022a2115e300$var$version;
/* eslint-disable es/no-symbol -- required for testing */ var $af72022a2115e300$var$V8_VERSION = $af72022a2115e300$var$engineV8Version;
var $af72022a2115e300$var$fails$5 = $af72022a2115e300$var$fails$9;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $af72022a2115e300$var$symbolConstructorDetection = !!Object.getOwnPropertySymbols && !$af72022a2115e300$var$fails$5(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $af72022a2115e300$var$V8_VERSION && $af72022a2115e300$var$V8_VERSION < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $af72022a2115e300$var$NATIVE_SYMBOL$1 = $af72022a2115e300$var$symbolConstructorDetection;
var $af72022a2115e300$var$useSymbolAsUid = $af72022a2115e300$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == 'symbol';
var $af72022a2115e300$var$getBuiltIn$3 = $af72022a2115e300$var$getBuiltIn$5;
var $af72022a2115e300$var$isCallable$9 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$isPrototypeOf = $af72022a2115e300$var$objectIsPrototypeOf;
var $af72022a2115e300$var$USE_SYMBOL_AS_UID$1 = $af72022a2115e300$var$useSymbolAsUid;
var $af72022a2115e300$var$$Object$2 = Object;
var $af72022a2115e300$var$isSymbol$2 = $af72022a2115e300$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $af72022a2115e300$var$getBuiltIn$3('Symbol');
    return $af72022a2115e300$var$isCallable$9($Symbol) && $af72022a2115e300$var$isPrototypeOf($Symbol.prototype, $af72022a2115e300$var$$Object$2(it));
};
var $af72022a2115e300$var$$String$1 = String;
var $af72022a2115e300$var$tryToString$1 = function(argument) {
    try {
        return $af72022a2115e300$var$$String$1(argument);
    } catch (error) {
        return 'Object';
    }
};
var $af72022a2115e300$var$isCallable$8 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$tryToString = $af72022a2115e300$var$tryToString$1;
var $af72022a2115e300$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $af72022a2115e300$var$aCallable$2 = function(argument) {
    if ($af72022a2115e300$var$isCallable$8(argument)) return argument;
    throw $af72022a2115e300$var$$TypeError$4($af72022a2115e300$var$tryToString(argument) + ' is not a function');
};
var $af72022a2115e300$var$aCallable$1 = $af72022a2115e300$var$aCallable$2;
var $af72022a2115e300$var$isNullOrUndefined = $af72022a2115e300$var$isNullOrUndefined$2;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $af72022a2115e300$var$getMethod$1 = function(V, P) {
    var func = V[P];
    return $af72022a2115e300$var$isNullOrUndefined(func) ? undefined : $af72022a2115e300$var$aCallable$1(func);
};
var $af72022a2115e300$var$call$2 = $af72022a2115e300$var$functionCall;
var $af72022a2115e300$var$isCallable$7 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$isObject$5 = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $af72022a2115e300$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $af72022a2115e300$var$isCallable$7(fn = input.toString) && !$af72022a2115e300$var$isObject$5(val = $af72022a2115e300$var$call$2(fn, input))) return val;
    if ($af72022a2115e300$var$isCallable$7(fn = input.valueOf) && !$af72022a2115e300$var$isObject$5(val = $af72022a2115e300$var$call$2(fn, input))) return val;
    if (pref !== 'string' && $af72022a2115e300$var$isCallable$7(fn = input.toString) && !$af72022a2115e300$var$isObject$5(val = $af72022a2115e300$var$call$2(fn, input))) return val;
    throw $af72022a2115e300$var$$TypeError$3("Can't convert object to primitive value");
};
var $af72022a2115e300$var$shared$3 = {
    exports: {}
};
var $af72022a2115e300$var$global$7 = $af72022a2115e300$var$global$a;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $af72022a2115e300$var$defineProperty$2 = Object.defineProperty;
var $af72022a2115e300$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $af72022a2115e300$var$defineProperty$2($af72022a2115e300$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $af72022a2115e300$var$global$7[key] = value;
    }
    return value;
};
var $af72022a2115e300$var$global$6 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$defineGlobalProperty$2 = $af72022a2115e300$var$defineGlobalProperty$3;
var $af72022a2115e300$var$SHARED = '__core-js_shared__';
var $af72022a2115e300$var$store$3 = $af72022a2115e300$var$global$6[$af72022a2115e300$var$SHARED] || $af72022a2115e300$var$defineGlobalProperty$2($af72022a2115e300$var$SHARED, {});
var $af72022a2115e300$var$sharedStore = $af72022a2115e300$var$store$3;
var $af72022a2115e300$var$store$2 = $af72022a2115e300$var$sharedStore;
($af72022a2115e300$var$shared$3.exports = function(key, value) {
    return $af72022a2115e300$var$store$2[key] || ($af72022a2115e300$var$store$2[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: '3.25.5',
    mode: 'global',
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.25.5/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});
var $af72022a2115e300$var$requireObjectCoercible = $af72022a2115e300$var$requireObjectCoercible$2;
var $af72022a2115e300$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $af72022a2115e300$var$toObject$2 = function(argument) {
    return $af72022a2115e300$var$$Object$1($af72022a2115e300$var$requireObjectCoercible(argument));
};
var $af72022a2115e300$var$uncurryThis$7 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$toObject$1 = $af72022a2115e300$var$toObject$2;
var $af72022a2115e300$var$hasOwnProperty = $af72022a2115e300$var$uncurryThis$7({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var $af72022a2115e300$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $af72022a2115e300$var$hasOwnProperty($af72022a2115e300$var$toObject$1(it), key);
};
var $af72022a2115e300$var$uncurryThis$6 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$id = 0;
var $af72022a2115e300$var$postfix = Math.random();
var $af72022a2115e300$var$toString = $af72022a2115e300$var$uncurryThis$6(1.0.toString);
var $af72022a2115e300$var$uid$2 = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $af72022a2115e300$var$toString(++$af72022a2115e300$var$id + $af72022a2115e300$var$postfix, 36);
};
var $af72022a2115e300$var$global$5 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$shared$2 = $af72022a2115e300$var$shared$3.exports;
var $af72022a2115e300$var$hasOwn$6 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$uid$1 = $af72022a2115e300$var$uid$2;
var $af72022a2115e300$var$NATIVE_SYMBOL = $af72022a2115e300$var$symbolConstructorDetection;
var $af72022a2115e300$var$USE_SYMBOL_AS_UID = $af72022a2115e300$var$useSymbolAsUid;
var $af72022a2115e300$var$WellKnownSymbolsStore = $af72022a2115e300$var$shared$2('wks');
var $af72022a2115e300$var$Symbol$1 = $af72022a2115e300$var$global$5.Symbol;
var $af72022a2115e300$var$symbolFor = $af72022a2115e300$var$Symbol$1 && $af72022a2115e300$var$Symbol$1['for'];
var $af72022a2115e300$var$createWellKnownSymbol = $af72022a2115e300$var$USE_SYMBOL_AS_UID ? $af72022a2115e300$var$Symbol$1 : $af72022a2115e300$var$Symbol$1 && $af72022a2115e300$var$Symbol$1.withoutSetter || $af72022a2115e300$var$uid$1;
var $af72022a2115e300$var$wellKnownSymbol$5 = function(name) {
    if (!$af72022a2115e300$var$hasOwn$6($af72022a2115e300$var$WellKnownSymbolsStore, name) || !($af72022a2115e300$var$NATIVE_SYMBOL || typeof $af72022a2115e300$var$WellKnownSymbolsStore[name] == 'string')) {
        var description = 'Symbol.' + name;
        if ($af72022a2115e300$var$NATIVE_SYMBOL && $af72022a2115e300$var$hasOwn$6($af72022a2115e300$var$Symbol$1, name)) $af72022a2115e300$var$WellKnownSymbolsStore[name] = $af72022a2115e300$var$Symbol$1[name];
        else if ($af72022a2115e300$var$USE_SYMBOL_AS_UID && $af72022a2115e300$var$symbolFor) $af72022a2115e300$var$WellKnownSymbolsStore[name] = $af72022a2115e300$var$symbolFor(description);
        else $af72022a2115e300$var$WellKnownSymbolsStore[name] = $af72022a2115e300$var$createWellKnownSymbol(description);
    }
    return $af72022a2115e300$var$WellKnownSymbolsStore[name];
};
var $af72022a2115e300$var$call$1 = $af72022a2115e300$var$functionCall;
var $af72022a2115e300$var$isObject$4 = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$isSymbol$1 = $af72022a2115e300$var$isSymbol$2;
var $af72022a2115e300$var$getMethod = $af72022a2115e300$var$getMethod$1;
var $af72022a2115e300$var$ordinaryToPrimitive = $af72022a2115e300$var$ordinaryToPrimitive$1;
var $af72022a2115e300$var$wellKnownSymbol$4 = $af72022a2115e300$var$wellKnownSymbol$5;
var $af72022a2115e300$var$$TypeError$2 = TypeError;
var $af72022a2115e300$var$TO_PRIMITIVE = $af72022a2115e300$var$wellKnownSymbol$4('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $af72022a2115e300$var$toPrimitive$1 = function(input, pref) {
    if (!$af72022a2115e300$var$isObject$4(input) || $af72022a2115e300$var$isSymbol$1(input)) return input;
    var exoticToPrim = $af72022a2115e300$var$getMethod(input, $af72022a2115e300$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $af72022a2115e300$var$call$1(exoticToPrim, input, pref);
        if (!$af72022a2115e300$var$isObject$4(result) || $af72022a2115e300$var$isSymbol$1(result)) return result;
        throw $af72022a2115e300$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $af72022a2115e300$var$ordinaryToPrimitive(input, pref);
};
var $af72022a2115e300$var$toPrimitive = $af72022a2115e300$var$toPrimitive$1;
var $af72022a2115e300$var$isSymbol = $af72022a2115e300$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $af72022a2115e300$var$toPropertyKey$2 = function(argument) {
    var key = $af72022a2115e300$var$toPrimitive(argument, 'string');
    return $af72022a2115e300$var$isSymbol(key) ? key : key + '';
};
var $af72022a2115e300$var$global$4 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$isObject$3 = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$document$1 = $af72022a2115e300$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $af72022a2115e300$var$EXISTS$1 = $af72022a2115e300$var$isObject$3($af72022a2115e300$var$document$1) && $af72022a2115e300$var$isObject$3($af72022a2115e300$var$document$1.createElement);
var $af72022a2115e300$var$documentCreateElement$1 = function(it) {
    return $af72022a2115e300$var$EXISTS$1 ? $af72022a2115e300$var$document$1.createElement(it) : {};
};
var $af72022a2115e300$var$DESCRIPTORS$7 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$fails$4 = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$createElement = $af72022a2115e300$var$documentCreateElement$1;
// Thanks to IE8 for its funny defineProperty
var $af72022a2115e300$var$ie8DomDefine = !$af72022a2115e300$var$DESCRIPTORS$7 && !$af72022a2115e300$var$fails$4(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($af72022a2115e300$var$createElement('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $af72022a2115e300$var$DESCRIPTORS$6 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$call = $af72022a2115e300$var$functionCall;
var $af72022a2115e300$var$propertyIsEnumerableModule = $af72022a2115e300$var$objectPropertyIsEnumerable;
var $af72022a2115e300$var$createPropertyDescriptor$1 = $af72022a2115e300$var$createPropertyDescriptor$2;
var $af72022a2115e300$var$toIndexedObject$3 = $af72022a2115e300$var$toIndexedObject$4;
var $af72022a2115e300$var$toPropertyKey$1 = $af72022a2115e300$var$toPropertyKey$2;
var $af72022a2115e300$var$hasOwn$5 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$IE8_DOM_DEFINE$1 = $af72022a2115e300$var$ie8DomDefine;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $af72022a2115e300$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$af72022a2115e300$var$objectGetOwnPropertyDescriptor.f = $af72022a2115e300$var$DESCRIPTORS$6 ? $af72022a2115e300$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $af72022a2115e300$var$toIndexedObject$3(O);
    P = $af72022a2115e300$var$toPropertyKey$1(P);
    if ($af72022a2115e300$var$IE8_DOM_DEFINE$1) try {
        return $af72022a2115e300$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($af72022a2115e300$var$hasOwn$5(O, P)) return $af72022a2115e300$var$createPropertyDescriptor$1(!$af72022a2115e300$var$call($af72022a2115e300$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $af72022a2115e300$var$objectDefineProperty = {};
var $af72022a2115e300$var$DESCRIPTORS$5 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$fails$3 = $af72022a2115e300$var$fails$9;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $af72022a2115e300$var$v8PrototypeDefineBug = $af72022a2115e300$var$DESCRIPTORS$5 && $af72022a2115e300$var$fails$3(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $af72022a2115e300$var$isObject$2 = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$$String = String;
var $af72022a2115e300$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $af72022a2115e300$var$anObject$4 = function(argument) {
    if ($af72022a2115e300$var$isObject$2(argument)) return argument;
    throw $af72022a2115e300$var$$TypeError$1($af72022a2115e300$var$$String(argument) + ' is not an object');
};
var $af72022a2115e300$var$DESCRIPTORS$4 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$IE8_DOM_DEFINE = $af72022a2115e300$var$ie8DomDefine;
var $af72022a2115e300$var$V8_PROTOTYPE_DEFINE_BUG$1 = $af72022a2115e300$var$v8PrototypeDefineBug;
var $af72022a2115e300$var$anObject$3 = $af72022a2115e300$var$anObject$4;
var $af72022a2115e300$var$toPropertyKey = $af72022a2115e300$var$toPropertyKey$2;
var $af72022a2115e300$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $af72022a2115e300$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $af72022a2115e300$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $af72022a2115e300$var$ENUMERABLE = 'enumerable';
var $af72022a2115e300$var$CONFIGURABLE$1 = 'configurable';
var $af72022a2115e300$var$WRITABLE = 'writable';
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$af72022a2115e300$var$objectDefineProperty.f = $af72022a2115e300$var$DESCRIPTORS$4 ? $af72022a2115e300$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $af72022a2115e300$var$anObject$3(O);
    P = $af72022a2115e300$var$toPropertyKey(P);
    $af72022a2115e300$var$anObject$3(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $af72022a2115e300$var$WRITABLE in Attributes && !Attributes[$af72022a2115e300$var$WRITABLE]) {
        var current = $af72022a2115e300$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$af72022a2115e300$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $af72022a2115e300$var$CONFIGURABLE$1 in Attributes ? Attributes[$af72022a2115e300$var$CONFIGURABLE$1] : current[$af72022a2115e300$var$CONFIGURABLE$1],
                enumerable: $af72022a2115e300$var$ENUMERABLE in Attributes ? Attributes[$af72022a2115e300$var$ENUMERABLE] : current[$af72022a2115e300$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $af72022a2115e300$var$$defineProperty(O, P, Attributes);
} : $af72022a2115e300$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $af72022a2115e300$var$anObject$3(O);
    P = $af72022a2115e300$var$toPropertyKey(P);
    $af72022a2115e300$var$anObject$3(Attributes);
    if ($af72022a2115e300$var$IE8_DOM_DEFINE) try {
        return $af72022a2115e300$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw $af72022a2115e300$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};
var $af72022a2115e300$var$DESCRIPTORS$3 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$definePropertyModule$3 = $af72022a2115e300$var$objectDefineProperty;
var $af72022a2115e300$var$createPropertyDescriptor = $af72022a2115e300$var$createPropertyDescriptor$2;
var $af72022a2115e300$var$createNonEnumerableProperty$2 = $af72022a2115e300$var$DESCRIPTORS$3 ? function(object, key, value) {
    return $af72022a2115e300$var$definePropertyModule$3.f(object, key, $af72022a2115e300$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $af72022a2115e300$var$makeBuiltIn$2 = {
    exports: {}
};
var $af72022a2115e300$var$DESCRIPTORS$2 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$hasOwn$4 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $af72022a2115e300$var$getDescriptor = $af72022a2115e300$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $af72022a2115e300$var$EXISTS = $af72022a2115e300$var$hasOwn$4($af72022a2115e300$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $af72022a2115e300$var$PROPER = $af72022a2115e300$var$EXISTS && (function something() {}).name === 'something';
var $af72022a2115e300$var$CONFIGURABLE = $af72022a2115e300$var$EXISTS && (!$af72022a2115e300$var$DESCRIPTORS$2 || $af72022a2115e300$var$DESCRIPTORS$2 && $af72022a2115e300$var$getDescriptor($af72022a2115e300$var$FunctionPrototype, 'name').configurable);
var $af72022a2115e300$var$functionName = {
    EXISTS: $af72022a2115e300$var$EXISTS,
    PROPER: $af72022a2115e300$var$PROPER,
    CONFIGURABLE: $af72022a2115e300$var$CONFIGURABLE
};
var $af72022a2115e300$var$uncurryThis$5 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$isCallable$6 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$store$1 = $af72022a2115e300$var$sharedStore;
var $af72022a2115e300$var$functionToString = $af72022a2115e300$var$uncurryThis$5(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$af72022a2115e300$var$isCallable$6($af72022a2115e300$var$store$1.inspectSource)) $af72022a2115e300$var$store$1.inspectSource = function(it) {
    return $af72022a2115e300$var$functionToString(it);
};
var $af72022a2115e300$var$inspectSource$2 = $af72022a2115e300$var$store$1.inspectSource;
var $af72022a2115e300$var$global$3 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$isCallable$5 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$WeakMap$1 = $af72022a2115e300$var$global$3.WeakMap;
var $af72022a2115e300$var$weakMapBasicDetection = $af72022a2115e300$var$isCallable$5($af72022a2115e300$var$WeakMap$1) && /native code/.test(String($af72022a2115e300$var$WeakMap$1));
var $af72022a2115e300$var$shared$1 = $af72022a2115e300$var$shared$3.exports;
var $af72022a2115e300$var$uid = $af72022a2115e300$var$uid$2;
var $af72022a2115e300$var$keys = $af72022a2115e300$var$shared$1('keys');
var $af72022a2115e300$var$sharedKey$2 = function(key) {
    return $af72022a2115e300$var$keys[key] || ($af72022a2115e300$var$keys[key] = $af72022a2115e300$var$uid(key));
};
var $af72022a2115e300$var$hiddenKeys$4 = {};
var $af72022a2115e300$var$NATIVE_WEAK_MAP = $af72022a2115e300$var$weakMapBasicDetection;
var $af72022a2115e300$var$global$2 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$isObject$1 = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$createNonEnumerableProperty$1 = $af72022a2115e300$var$createNonEnumerableProperty$2;
var $af72022a2115e300$var$hasOwn$3 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$shared = $af72022a2115e300$var$sharedStore;
var $af72022a2115e300$var$sharedKey$1 = $af72022a2115e300$var$sharedKey$2;
var $af72022a2115e300$var$hiddenKeys$3 = $af72022a2115e300$var$hiddenKeys$4;
var $af72022a2115e300$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $af72022a2115e300$var$TypeError$1 = $af72022a2115e300$var$global$2.TypeError;
var $af72022a2115e300$var$WeakMap = $af72022a2115e300$var$global$2.WeakMap;
var $af72022a2115e300$var$set, $af72022a2115e300$var$get, $af72022a2115e300$var$has;
var $af72022a2115e300$var$enforce = function(it) {
    return $af72022a2115e300$var$has(it) ? $af72022a2115e300$var$get(it) : $af72022a2115e300$var$set(it, {});
};
var $af72022a2115e300$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$af72022a2115e300$var$isObject$1(it) || (state = $af72022a2115e300$var$get(it)).type !== TYPE) throw $af72022a2115e300$var$TypeError$1('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($af72022a2115e300$var$NATIVE_WEAK_MAP || $af72022a2115e300$var$shared.state) {
    var $af72022a2115e300$var$store = $af72022a2115e300$var$shared.state || ($af72022a2115e300$var$shared.state = new $af72022a2115e300$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $af72022a2115e300$var$store.get = $af72022a2115e300$var$store.get;
    $af72022a2115e300$var$store.has = $af72022a2115e300$var$store.has;
    $af72022a2115e300$var$store.set = $af72022a2115e300$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $af72022a2115e300$var$set = function(it, metadata) {
        if ($af72022a2115e300$var$store.has(it)) throw $af72022a2115e300$var$TypeError$1($af72022a2115e300$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $af72022a2115e300$var$store.set(it, metadata);
        return metadata;
    };
    $af72022a2115e300$var$get = function(it) {
        return $af72022a2115e300$var$store.get(it) || {};
    };
    $af72022a2115e300$var$has = function(it) {
        return $af72022a2115e300$var$store.has(it);
    };
} else {
    var $af72022a2115e300$var$STATE = $af72022a2115e300$var$sharedKey$1('state');
    $af72022a2115e300$var$hiddenKeys$3[$af72022a2115e300$var$STATE] = true;
    $af72022a2115e300$var$set = function(it, metadata) {
        if ($af72022a2115e300$var$hasOwn$3(it, $af72022a2115e300$var$STATE)) throw $af72022a2115e300$var$TypeError$1($af72022a2115e300$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $af72022a2115e300$var$createNonEnumerableProperty$1(it, $af72022a2115e300$var$STATE, metadata);
        return metadata;
    };
    $af72022a2115e300$var$get = function(it) {
        return $af72022a2115e300$var$hasOwn$3(it, $af72022a2115e300$var$STATE) ? it[$af72022a2115e300$var$STATE] : {};
    };
    $af72022a2115e300$var$has = function(it) {
        return $af72022a2115e300$var$hasOwn$3(it, $af72022a2115e300$var$STATE);
    };
}
var $af72022a2115e300$var$internalState = {
    set: $af72022a2115e300$var$set,
    get: $af72022a2115e300$var$get,
    has: $af72022a2115e300$var$has,
    enforce: $af72022a2115e300$var$enforce,
    getterFor: $af72022a2115e300$var$getterFor
};
var $af72022a2115e300$var$fails$2 = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$isCallable$4 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$hasOwn$2 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$DESCRIPTORS$1 = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$CONFIGURABLE_FUNCTION_NAME = $af72022a2115e300$var$functionName.CONFIGURABLE;
var $af72022a2115e300$var$inspectSource$1 = $af72022a2115e300$var$inspectSource$2;
var $af72022a2115e300$var$InternalStateModule = $af72022a2115e300$var$internalState;
var $af72022a2115e300$var$enforceInternalState = $af72022a2115e300$var$InternalStateModule.enforce;
var $af72022a2115e300$var$getInternalState = $af72022a2115e300$var$InternalStateModule.get;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $af72022a2115e300$var$defineProperty$1 = Object.defineProperty;
var $af72022a2115e300$var$CONFIGURABLE_LENGTH = $af72022a2115e300$var$DESCRIPTORS$1 && !$af72022a2115e300$var$fails$2(function() {
    return $af72022a2115e300$var$defineProperty$1(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $af72022a2115e300$var$TEMPLATE = String(String).split('String');
var $af72022a2115e300$var$makeBuiltIn$1 = $af72022a2115e300$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === 'Symbol(') name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$af72022a2115e300$var$hasOwn$2(value, 'name') || $af72022a2115e300$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($af72022a2115e300$var$DESCRIPTORS$1) $af72022a2115e300$var$defineProperty$1(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($af72022a2115e300$var$CONFIGURABLE_LENGTH && options && $af72022a2115e300$var$hasOwn$2(options, 'arity') && value.length !== options.arity) $af72022a2115e300$var$defineProperty$1(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $af72022a2115e300$var$hasOwn$2(options, 'constructor') && options.constructor) {
            if ($af72022a2115e300$var$DESCRIPTORS$1) $af72022a2115e300$var$defineProperty$1(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $af72022a2115e300$var$enforceInternalState(value);
    if (!$af72022a2115e300$var$hasOwn$2(state, 'source')) state.source = $af72022a2115e300$var$TEMPLATE.join(typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $af72022a2115e300$var$makeBuiltIn$1(function toString() {
    return $af72022a2115e300$var$isCallable$4(this) && $af72022a2115e300$var$getInternalState(this).source || $af72022a2115e300$var$inspectSource$1(this);
}, 'toString');
var $af72022a2115e300$var$isCallable$3 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$definePropertyModule$2 = $af72022a2115e300$var$objectDefineProperty;
var $af72022a2115e300$var$makeBuiltIn = $af72022a2115e300$var$makeBuiltIn$2.exports;
var $af72022a2115e300$var$defineGlobalProperty$1 = $af72022a2115e300$var$defineGlobalProperty$3;
var $af72022a2115e300$var$defineBuiltIn$1 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($af72022a2115e300$var$isCallable$3(value)) $af72022a2115e300$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $af72022a2115e300$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $af72022a2115e300$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $af72022a2115e300$var$objectGetOwnPropertyNames = {};
var $af72022a2115e300$var$ceil = Math.ceil;
var $af72022a2115e300$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var $af72022a2115e300$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $af72022a2115e300$var$floor : $af72022a2115e300$var$ceil)(n);
};
var $af72022a2115e300$var$trunc = $af72022a2115e300$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $af72022a2115e300$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $af72022a2115e300$var$trunc(number);
};
var $af72022a2115e300$var$toIntegerOrInfinity$1 = $af72022a2115e300$var$toIntegerOrInfinity$2;
var $af72022a2115e300$var$max = Math.max;
var $af72022a2115e300$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $af72022a2115e300$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $af72022a2115e300$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $af72022a2115e300$var$max(integer + length, 0) : $af72022a2115e300$var$min$1(integer, length);
};
var $af72022a2115e300$var$toIntegerOrInfinity = $af72022a2115e300$var$toIntegerOrInfinity$2;
var $af72022a2115e300$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $af72022a2115e300$var$toLength$1 = function(argument) {
    return argument > 0 ? $af72022a2115e300$var$min($af72022a2115e300$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $af72022a2115e300$var$toLength = $af72022a2115e300$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $af72022a2115e300$var$lengthOfArrayLike$2 = function(obj) {
    return $af72022a2115e300$var$toLength(obj.length);
};
var $af72022a2115e300$var$toIndexedObject$2 = $af72022a2115e300$var$toIndexedObject$4;
var $af72022a2115e300$var$toAbsoluteIndex = $af72022a2115e300$var$toAbsoluteIndex$1;
var $af72022a2115e300$var$lengthOfArrayLike$1 = $af72022a2115e300$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $af72022a2115e300$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $af72022a2115e300$var$toIndexedObject$2($this);
        var length = $af72022a2115e300$var$lengthOfArrayLike$1(O);
        var index = $af72022a2115e300$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $af72022a2115e300$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $af72022a2115e300$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $af72022a2115e300$var$createMethod$1(false)
};
var $af72022a2115e300$var$uncurryThis$4 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$hasOwn$1 = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$toIndexedObject$1 = $af72022a2115e300$var$toIndexedObject$4;
var $af72022a2115e300$var$indexOf = $af72022a2115e300$var$arrayIncludes.indexOf;
var $af72022a2115e300$var$hiddenKeys$2 = $af72022a2115e300$var$hiddenKeys$4;
var $af72022a2115e300$var$push$1 = $af72022a2115e300$var$uncurryThis$4([].push);
var $af72022a2115e300$var$objectKeysInternal = function(object, names) {
    var O = $af72022a2115e300$var$toIndexedObject$1(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$af72022a2115e300$var$hasOwn$1($af72022a2115e300$var$hiddenKeys$2, key) && $af72022a2115e300$var$hasOwn$1(O, key) && $af72022a2115e300$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($af72022a2115e300$var$hasOwn$1(O, key = names[i++])) ~$af72022a2115e300$var$indexOf(result, key) || $af72022a2115e300$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $af72022a2115e300$var$enumBugKeys$3 = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];
var $af72022a2115e300$var$internalObjectKeys$1 = $af72022a2115e300$var$objectKeysInternal;
var $af72022a2115e300$var$enumBugKeys$2 = $af72022a2115e300$var$enumBugKeys$3;
var $af72022a2115e300$var$hiddenKeys$1 = $af72022a2115e300$var$enumBugKeys$2.concat('length', 'prototype');
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
$af72022a2115e300$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $af72022a2115e300$var$internalObjectKeys$1(O, $af72022a2115e300$var$hiddenKeys$1);
};
var $af72022a2115e300$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
$af72022a2115e300$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $af72022a2115e300$var$getBuiltIn$2 = $af72022a2115e300$var$getBuiltIn$5;
var $af72022a2115e300$var$uncurryThis$3 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$getOwnPropertyNamesModule = $af72022a2115e300$var$objectGetOwnPropertyNames;
var $af72022a2115e300$var$getOwnPropertySymbolsModule = $af72022a2115e300$var$objectGetOwnPropertySymbols;
var $af72022a2115e300$var$anObject$2 = $af72022a2115e300$var$anObject$4;
var $af72022a2115e300$var$concat = $af72022a2115e300$var$uncurryThis$3([].concat);
// all object keys, includes non-enumerable and symbols
var $af72022a2115e300$var$ownKeys$1 = $af72022a2115e300$var$getBuiltIn$2('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $af72022a2115e300$var$getOwnPropertyNamesModule.f($af72022a2115e300$var$anObject$2(it));
    var getOwnPropertySymbols = $af72022a2115e300$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $af72022a2115e300$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $af72022a2115e300$var$hasOwn = $af72022a2115e300$var$hasOwnProperty_1;
var $af72022a2115e300$var$ownKeys = $af72022a2115e300$var$ownKeys$1;
var $af72022a2115e300$var$getOwnPropertyDescriptorModule = $af72022a2115e300$var$objectGetOwnPropertyDescriptor;
var $af72022a2115e300$var$definePropertyModule$1 = $af72022a2115e300$var$objectDefineProperty;
var $af72022a2115e300$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $af72022a2115e300$var$ownKeys(source);
    var defineProperty = $af72022a2115e300$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $af72022a2115e300$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$af72022a2115e300$var$hasOwn(target, key) && !(exceptions && $af72022a2115e300$var$hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $af72022a2115e300$var$fails$1 = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$isCallable$2 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$replacement = /#|\.prototype\./;
var $af72022a2115e300$var$isForced$1 = function(feature, detection) {
    var value = $af72022a2115e300$var$data[$af72022a2115e300$var$normalize(feature)];
    return value == $af72022a2115e300$var$POLYFILL ? true : value == $af72022a2115e300$var$NATIVE ? false : $af72022a2115e300$var$isCallable$2(detection) ? $af72022a2115e300$var$fails$1(detection) : !!detection;
};
var $af72022a2115e300$var$normalize = $af72022a2115e300$var$isForced$1.normalize = function(string) {
    return String(string).replace($af72022a2115e300$var$replacement, '.').toLowerCase();
};
var $af72022a2115e300$var$data = $af72022a2115e300$var$isForced$1.data = {};
var $af72022a2115e300$var$NATIVE = $af72022a2115e300$var$isForced$1.NATIVE = 'N';
var $af72022a2115e300$var$POLYFILL = $af72022a2115e300$var$isForced$1.POLYFILL = 'P';
var $af72022a2115e300$var$isForced_1 = $af72022a2115e300$var$isForced$1;
var $af72022a2115e300$var$global$1 = $af72022a2115e300$var$global$a;
var $af72022a2115e300$var$getOwnPropertyDescriptor = $af72022a2115e300$var$objectGetOwnPropertyDescriptor.f;
var $af72022a2115e300$var$createNonEnumerableProperty = $af72022a2115e300$var$createNonEnumerableProperty$2;
var $af72022a2115e300$var$defineBuiltIn = $af72022a2115e300$var$defineBuiltIn$1;
var $af72022a2115e300$var$defineGlobalProperty = $af72022a2115e300$var$defineGlobalProperty$3;
var $af72022a2115e300$var$copyConstructorProperties = $af72022a2115e300$var$copyConstructorProperties$1;
var $af72022a2115e300$var$isForced = $af72022a2115e300$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $af72022a2115e300$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $af72022a2115e300$var$global$1;
    else if (STATIC) target = $af72022a2115e300$var$global$1[TARGET] || $af72022a2115e300$var$defineGlobalProperty(TARGET, {});
    else target = ($af72022a2115e300$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $af72022a2115e300$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $af72022a2115e300$var$isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $af72022a2115e300$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $af72022a2115e300$var$createNonEnumerableProperty(sourceProperty, 'sham', true);
        $af72022a2115e300$var$defineBuiltIn(target, key, sourceProperty, options);
    }
};
var $af72022a2115e300$var$uncurryThis$2 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$aCallable = $af72022a2115e300$var$aCallable$2;
var $af72022a2115e300$var$NATIVE_BIND = $af72022a2115e300$var$functionBindNative;
var $af72022a2115e300$var$bind$1 = $af72022a2115e300$var$uncurryThis$2($af72022a2115e300$var$uncurryThis$2.bind);
// optional / simple context binding
var $af72022a2115e300$var$functionBindContext = function(fn, that) {
    $af72022a2115e300$var$aCallable(fn);
    return that === undefined ? fn : $af72022a2115e300$var$NATIVE_BIND ? $af72022a2115e300$var$bind$1(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $af72022a2115e300$var$classof$2 = $af72022a2115e300$var$classofRaw$2;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $af72022a2115e300$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $af72022a2115e300$var$classof$2(argument) == 'Array';
};
var $af72022a2115e300$var$wellKnownSymbol$3 = $af72022a2115e300$var$wellKnownSymbol$5;
var $af72022a2115e300$var$TO_STRING_TAG$1 = $af72022a2115e300$var$wellKnownSymbol$3('toStringTag');
var $af72022a2115e300$var$test = {};
$af72022a2115e300$var$test[$af72022a2115e300$var$TO_STRING_TAG$1] = 'z';
var $af72022a2115e300$var$toStringTagSupport = String($af72022a2115e300$var$test) === '[object z]';
var $af72022a2115e300$var$TO_STRING_TAG_SUPPORT = $af72022a2115e300$var$toStringTagSupport;
var $af72022a2115e300$var$isCallable$1 = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$classofRaw = $af72022a2115e300$var$classofRaw$2;
var $af72022a2115e300$var$wellKnownSymbol$2 = $af72022a2115e300$var$wellKnownSymbol$5;
var $af72022a2115e300$var$TO_STRING_TAG = $af72022a2115e300$var$wellKnownSymbol$2('toStringTag');
var $af72022a2115e300$var$$Object = Object;
// ES3 wrong here
var $af72022a2115e300$var$CORRECT_ARGUMENTS = $af72022a2115e300$var$classofRaw(function() {
    return arguments;
}()) == 'Arguments';
// fallback for IE11 Script Access Denied error
var $af72022a2115e300$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $af72022a2115e300$var$classof$1 = $af72022a2115e300$var$TO_STRING_TAG_SUPPORT ? $af72022a2115e300$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $af72022a2115e300$var$tryGet(O = $af72022a2115e300$var$$Object(it), $af72022a2115e300$var$TO_STRING_TAG)) == 'string' ? tag : $af72022a2115e300$var$CORRECT_ARGUMENTS ? $af72022a2115e300$var$classofRaw(O) : (result = $af72022a2115e300$var$classofRaw(O)) == 'Object' && $af72022a2115e300$var$isCallable$1(O.callee) ? 'Arguments' : result;
};
var $af72022a2115e300$var$uncurryThis$1 = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$fails = $af72022a2115e300$var$fails$9;
var $af72022a2115e300$var$isCallable = $af72022a2115e300$var$isCallable$c;
var $af72022a2115e300$var$classof = $af72022a2115e300$var$classof$1;
var $af72022a2115e300$var$getBuiltIn$1 = $af72022a2115e300$var$getBuiltIn$5;
var $af72022a2115e300$var$inspectSource = $af72022a2115e300$var$inspectSource$2;
var $af72022a2115e300$var$noop = function() {};
var $af72022a2115e300$var$empty = [];
var $af72022a2115e300$var$construct = $af72022a2115e300$var$getBuiltIn$1('Reflect', 'construct');
var $af72022a2115e300$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $af72022a2115e300$var$exec = $af72022a2115e300$var$uncurryThis$1($af72022a2115e300$var$constructorRegExp.exec);
var $af72022a2115e300$var$INCORRECT_TO_STRING = !$af72022a2115e300$var$constructorRegExp.exec($af72022a2115e300$var$noop);
var $af72022a2115e300$var$isConstructorModern = function isConstructor(argument) {
    if (!$af72022a2115e300$var$isCallable(argument)) return false;
    try {
        $af72022a2115e300$var$construct($af72022a2115e300$var$noop, $af72022a2115e300$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $af72022a2115e300$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$af72022a2115e300$var$isCallable(argument)) return false;
    switch($af72022a2115e300$var$classof(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $af72022a2115e300$var$INCORRECT_TO_STRING || !!$af72022a2115e300$var$exec($af72022a2115e300$var$constructorRegExp, $af72022a2115e300$var$inspectSource(argument));
    } catch (error) {
        return true;
    }
};
$af72022a2115e300$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $af72022a2115e300$var$isConstructor$1 = !$af72022a2115e300$var$construct || $af72022a2115e300$var$fails(function() {
    var called;
    return $af72022a2115e300$var$isConstructorModern($af72022a2115e300$var$isConstructorModern.call) || !$af72022a2115e300$var$isConstructorModern(Object) || !$af72022a2115e300$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $af72022a2115e300$var$isConstructorLegacy : $af72022a2115e300$var$isConstructorModern;
var $af72022a2115e300$var$isArray = $af72022a2115e300$var$isArray$1;
var $af72022a2115e300$var$isConstructor = $af72022a2115e300$var$isConstructor$1;
var $af72022a2115e300$var$isObject = $af72022a2115e300$var$isObject$6;
var $af72022a2115e300$var$wellKnownSymbol$1 = $af72022a2115e300$var$wellKnownSymbol$5;
var $af72022a2115e300$var$SPECIES = $af72022a2115e300$var$wellKnownSymbol$1('species');
var $af72022a2115e300$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $af72022a2115e300$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($af72022a2115e300$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($af72022a2115e300$var$isConstructor(C) && (C === $af72022a2115e300$var$$Array || $af72022a2115e300$var$isArray(C.prototype))) C = undefined;
        else if ($af72022a2115e300$var$isObject(C)) {
            C = C[$af72022a2115e300$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $af72022a2115e300$var$$Array : C;
};
var $af72022a2115e300$var$arraySpeciesConstructor = $af72022a2115e300$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $af72022a2115e300$var$arraySpeciesCreate$1 = function(originalArray, length) {
    return new ($af72022a2115e300$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $af72022a2115e300$var$bind = $af72022a2115e300$var$functionBindContext;
var $af72022a2115e300$var$uncurryThis = $af72022a2115e300$var$functionUncurryThis;
var $af72022a2115e300$var$IndexedObject = $af72022a2115e300$var$indexedObject;
var $af72022a2115e300$var$toObject = $af72022a2115e300$var$toObject$2;
var $af72022a2115e300$var$lengthOfArrayLike = $af72022a2115e300$var$lengthOfArrayLike$2;
var $af72022a2115e300$var$arraySpeciesCreate = $af72022a2115e300$var$arraySpeciesCreate$1;
var $af72022a2115e300$var$push = $af72022a2115e300$var$uncurryThis([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $af72022a2115e300$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $af72022a2115e300$var$toObject($this);
        var self1 = $af72022a2115e300$var$IndexedObject(O);
        var boundFunction = $af72022a2115e300$var$bind(callbackfn, that);
        var length = $af72022a2115e300$var$lengthOfArrayLike(self1);
        var index = 0;
        var create = specificCreate || $af72022a2115e300$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $af72022a2115e300$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $af72022a2115e300$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $af72022a2115e300$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $af72022a2115e300$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $af72022a2115e300$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $af72022a2115e300$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $af72022a2115e300$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $af72022a2115e300$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $af72022a2115e300$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $af72022a2115e300$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $af72022a2115e300$var$createMethod(7)
};
var $af72022a2115e300$var$objectDefineProperties = {};
var $af72022a2115e300$var$internalObjectKeys = $af72022a2115e300$var$objectKeysInternal;
var $af72022a2115e300$var$enumBugKeys$1 = $af72022a2115e300$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $af72022a2115e300$var$objectKeys$1 = Object.keys || function keys(O) {
    return $af72022a2115e300$var$internalObjectKeys(O, $af72022a2115e300$var$enumBugKeys$1);
};
var $af72022a2115e300$var$DESCRIPTORS = $af72022a2115e300$var$descriptors;
var $af72022a2115e300$var$V8_PROTOTYPE_DEFINE_BUG = $af72022a2115e300$var$v8PrototypeDefineBug;
var $af72022a2115e300$var$definePropertyModule = $af72022a2115e300$var$objectDefineProperty;
var $af72022a2115e300$var$anObject$1 = $af72022a2115e300$var$anObject$4;
var $af72022a2115e300$var$toIndexedObject = $af72022a2115e300$var$toIndexedObject$4;
var $af72022a2115e300$var$objectKeys = $af72022a2115e300$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
$af72022a2115e300$var$objectDefineProperties.f = $af72022a2115e300$var$DESCRIPTORS && !$af72022a2115e300$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $af72022a2115e300$var$anObject$1(O);
    var props = $af72022a2115e300$var$toIndexedObject(Properties);
    var keys = $af72022a2115e300$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$af72022a2115e300$var$definePropertyModule.f(O, key = keys[index++], props[key]);
    return O;
};
var $af72022a2115e300$var$getBuiltIn = $af72022a2115e300$var$getBuiltIn$5;
var $af72022a2115e300$var$html$1 = $af72022a2115e300$var$getBuiltIn('document', 'documentElement');
/* global ActiveXObject -- old IE, WSH */ var $af72022a2115e300$var$anObject = $af72022a2115e300$var$anObject$4;
var $af72022a2115e300$var$definePropertiesModule = $af72022a2115e300$var$objectDefineProperties;
var $af72022a2115e300$var$enumBugKeys = $af72022a2115e300$var$enumBugKeys$3;
var $af72022a2115e300$var$hiddenKeys = $af72022a2115e300$var$hiddenKeys$4;
var $af72022a2115e300$var$html = $af72022a2115e300$var$html$1;
var $af72022a2115e300$var$documentCreateElement = $af72022a2115e300$var$documentCreateElement$1;
var $af72022a2115e300$var$sharedKey = $af72022a2115e300$var$sharedKey$2;
var $af72022a2115e300$var$GT = '>';
var $af72022a2115e300$var$LT = '<';
var $af72022a2115e300$var$PROTOTYPE = 'prototype';
var $af72022a2115e300$var$SCRIPT = 'script';
var $af72022a2115e300$var$IE_PROTO = $af72022a2115e300$var$sharedKey('IE_PROTO');
var $af72022a2115e300$var$EmptyConstructor = function() {};
var $af72022a2115e300$var$scriptTag = function(content) {
    return $af72022a2115e300$var$LT + $af72022a2115e300$var$SCRIPT + $af72022a2115e300$var$GT + content + $af72022a2115e300$var$LT + '/' + $af72022a2115e300$var$SCRIPT + $af72022a2115e300$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $af72022a2115e300$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($af72022a2115e300$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $af72022a2115e300$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $af72022a2115e300$var$documentCreateElement('iframe');
    var JS = 'java' + $af72022a2115e300$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $af72022a2115e300$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($af72022a2115e300$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $af72022a2115e300$var$activeXDocument;
var $af72022a2115e300$var$NullProtoObject = function() {
    try {
        $af72022a2115e300$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $af72022a2115e300$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $af72022a2115e300$var$activeXDocument ? $af72022a2115e300$var$NullProtoObjectViaActiveX($af72022a2115e300$var$activeXDocument) // old IE
     : $af72022a2115e300$var$NullProtoObjectViaIFrame() : $af72022a2115e300$var$NullProtoObjectViaActiveX($af72022a2115e300$var$activeXDocument); // WSH
    var length = $af72022a2115e300$var$enumBugKeys.length;
    while(length--)delete $af72022a2115e300$var$NullProtoObject[$af72022a2115e300$var$PROTOTYPE][$af72022a2115e300$var$enumBugKeys[length]];
    return $af72022a2115e300$var$NullProtoObject();
};
$af72022a2115e300$var$hiddenKeys[$af72022a2115e300$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var $af72022a2115e300$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $af72022a2115e300$var$EmptyConstructor[$af72022a2115e300$var$PROTOTYPE] = $af72022a2115e300$var$anObject(O);
        result = new $af72022a2115e300$var$EmptyConstructor();
        $af72022a2115e300$var$EmptyConstructor[$af72022a2115e300$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$af72022a2115e300$var$IE_PROTO] = O;
    } else result = $af72022a2115e300$var$NullProtoObject();
    return Properties === undefined ? result : $af72022a2115e300$var$definePropertiesModule.f(result, Properties);
};
var $af72022a2115e300$var$wellKnownSymbol = $af72022a2115e300$var$wellKnownSymbol$5;
var $af72022a2115e300$var$create = $af72022a2115e300$var$objectCreate;
var $af72022a2115e300$var$defineProperty = $af72022a2115e300$var$objectDefineProperty.f;
var $af72022a2115e300$var$UNSCOPABLES = $af72022a2115e300$var$wellKnownSymbol('unscopables');
var $af72022a2115e300$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($af72022a2115e300$var$ArrayPrototype[$af72022a2115e300$var$UNSCOPABLES] == undefined) $af72022a2115e300$var$defineProperty($af72022a2115e300$var$ArrayPrototype, $af72022a2115e300$var$UNSCOPABLES, {
    configurable: true,
    value: $af72022a2115e300$var$create(null)
});
// add a key to Array.prototype[@@unscopables]
var $af72022a2115e300$var$addToUnscopables$1 = function(key) {
    $af72022a2115e300$var$ArrayPrototype[$af72022a2115e300$var$UNSCOPABLES][key] = true;
};
var $af72022a2115e300$var$$ = $af72022a2115e300$var$_export;
var $af72022a2115e300$var$$find = $af72022a2115e300$var$arrayIteration.find;
var $af72022a2115e300$var$addToUnscopables = $af72022a2115e300$var$addToUnscopables$1;
var $af72022a2115e300$var$FIND = 'find';
var $af72022a2115e300$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($af72022a2115e300$var$FIND in []) Array(1)[$af72022a2115e300$var$FIND](function() {
    $af72022a2115e300$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$af72022a2115e300$var$$({
    target: 'Array',
    proto: true,
    forced: $af72022a2115e300$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $af72022a2115e300$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$af72022a2115e300$var$addToUnscopables($af72022a2115e300$var$FIND);
var $af72022a2115e300$var$CONSTANT = {
    GLOBAL: {
        HIDE: '__react_tooltip_hide_event',
        REBUILD: '__react_tooltip_rebuild_event',
        SHOW: '__react_tooltip_show_event'
    }
};
/**
 * Static methods for react-tooltip
 */ var $af72022a2115e300$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === 'function') event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $af72022a2115e300$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $af72022a2115e300$var$dispatchGlobalEvent($af72022a2115e300$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $af72022a2115e300$var$dispatchGlobalEvent($af72022a2115e300$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $af72022a2115e300$var$dispatchGlobalEvent($af72022a2115e300$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $af72022a2115e300$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false);
        // ReactTooltip.rebuild
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false);
        // ReactTooltip.show
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false);
        // Resize
        if (resizeHide) {
            window.removeEventListener('resize', this.onWindowResize);
            window.addEventListener('resize', this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($af72022a2115e300$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener('resize', this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $af72022a2115e300$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute('currentItem');
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === 'true') {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute('currentItem', 'true');
        $af72022a2115e300$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $af72022a2115e300$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute('currentItem', 'false');
    else targetArray[i].setAttribute('currentItem', 'true');
};
var $af72022a2115e300$var$customListeners = {
    id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $af72022a2115e300$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $af72022a2115e300$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute('data-event');
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute('data-event') || event;
        var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
        dataEvent.split(' ').forEach(function(event) {
            ele.removeEventListener(event, $af72022a2115e300$var$customListeners.get(ele, event));
            var customListener = $af72022a2115e300$var$checkStatus.bind(_this, dataEventOff);
            $af72022a2115e300$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(' ').forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute('data-event');
        var dataEventOff = eventOff || ele.getAttribute('data-event-off');
        ele.removeEventListener(dataEvent, $af72022a2115e300$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $af72022a2115e300$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $af72022a2115e300$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute('data-effect');
        return dataEffect || this.props.effect || 'float';
    };
}
/**
 * Util method to get effect
 */ var $af72022a2115e300$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === 'function') proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $af72022a2115e300$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = null;
    var forId;
    var target = e.target;
    var lastTarget;
    // walk up parent chain until tip is found
    // there is no match if parent visible area is matched by mouse position, so some corner cases might not work as expected
    while(tip === null && target !== null){
        lastTarget = target;
        tip = target.getAttribute('data-tip') || null;
        forId = target.getAttribute('data-for') || null;
        target = target.parentElement;
    }
    target = lastTarget || e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
        var proxy = $af72022a2115e300$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $af72022a2115e300$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(' ').forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $af72022a2115e300$var$getBody = function getBody() {
    return document.getElementsByTagName('body')[0];
};
function $af72022a2115e300$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $af72022a2115e300$var$getBody();
        var customEvents = $af72022a2115e300$var$findCustomEvents(targetArray, 'data-event');
        var customEventsOff = $af72022a2115e300$var$findCustomEvents(targetArray, 'data-event-off');
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(' ').forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(' ').forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $af72022a2115e300$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $af72022a2115e300$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $af72022a2115e300$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $af72022a2115e300$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
            $af72022a2115e300$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $af72022a2115e300$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $af72022a2115e300$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $af72022a2115e300$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $af72022a2115e300$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $af72022a2115e300$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $af72022a2115e300$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $af72022a2115e300$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $af72022a2115e300$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $af72022a2115e300$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $af72022a2115e300$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $af72022a2115e300$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $af72022a2115e300$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft;
    // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    };
    //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    };
    // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placeIsInside = {
        top: inside('top'),
        bottom: inside('bottom'),
        left: inside('left'),
        right: inside('right')
    };
    function choose() {
        var allPlaces = desiredPlace.split(',').concat(place, [
            'top',
            'bottom',
            'left',
            'right'
        ]);
        var _iterator = $af72022a2115e300$var$_createForOfIteratorHelper(allPlaces), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var d = _step.value;
                if (placeIsInside[d]) return d;
            }
        // if nothing is inside, just use the old place.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return place;
    }
    var chosen = choose();
    var isNewState = false;
    var newPlace;
    if (chosen && chosen !== place) {
        isNewState = true;
        newPlace = chosen;
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $af72022a2115e300$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
};
// Get current mouse offset
var $af72022a2115e300$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $af72022a2115e300$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === 'float') return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
};
// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $af72022a2115e300$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === 'float') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === 'solid') {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
};
// Consider additional offset into position calculation
var $af72022a2115e300$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === '[object String]') offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === 'top') extraOffsetY -= parseInt(offset[key], 10);
        else if (key === 'bottom') extraOffsetY += parseInt(offset[key], 10);
        else if (key === 'left') extraOffsetX -= parseInt(offset[key], 10);
        else if (key === 'right') extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
};
// Get the offset of the parent elements
var $af72022a2115e300$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent);
        // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue('transform') !== 'none' || computedStyle.getPropertyValue('will-change') === 'transform') break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $af72022a2115e300$var$TipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === 'false' || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
    // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $af72022a2115e300$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $af72022a2115e300$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $af72022a2115e300$var$generateUUID() {
    return 't' + (0, $3d293832bafa5554$export$2e2bcd8739ae039)();
}
var $af72022a2115e300$var$baseCss = ".__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: \"\";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  bottom: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-bottom::before {\n  top: 0;\n  left: 50%;\n  margin-left: -11px;\n}\n.__react_component_tooltip.place-left::before {\n  right: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip.place-right::before {\n  left: 0;\n  top: 50%;\n  margin-top: -9px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}";
/**
 * Default pop-up style values (text color, background color).
 */ var $af72022a2115e300$var$defaultColors = {
    dark: {
        text: '#fff',
        background: '#222',
        border: 'transparent',
        arrow: '#222'
    },
    success: {
        text: '#fff',
        background: '#8DC572',
        border: 'transparent',
        arrow: '#8DC572'
    },
    warning: {
        text: '#fff',
        background: '#F0AD4E',
        border: 'transparent',
        arrow: '#F0AD4E'
    },
    error: {
        text: '#fff',
        background: '#BE6464',
        border: 'transparent',
        arrow: '#BE6464'
    },
    info: {
        text: '#fff',
        background: '#337AB7',
        border: 'transparent',
        arrow: '#337AB7'
    },
    light: {
        text: '#222',
        background: '#fff',
        border: 'transparent',
        arrow: '#fff'
    }
};
function $af72022a2115e300$var$getDefaultPopupColors(type) {
    return $af72022a2115e300$var$defaultColors[type] ? $af72022a2115e300$var$_objectSpread2({}, $af72022a2115e300$var$defaultColors[type]) : undefined;
}
var $af72022a2115e300$var$DEFAULT_PADDING = '8px 21px';
var $af72022a2115e300$var$DEFAULT_RADIUS = {
    tooltip: 3,
    arrow: 0
};
/**
 * Generates the specific tooltip style for use on render.
 */ function $af72022a2115e300$var$generateTooltipStyle(uuid, customColors, type, hasBorder, padding, radius) {
    return $af72022a2115e300$var$generateStyle(uuid, $af72022a2115e300$var$getPopupColors(customColors, type, hasBorder), padding, radius);
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $af72022a2115e300$var$generateStyle(uuid, colors) {
    var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $af72022a2115e300$var$DEFAULT_PADDING;
    var radius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $af72022a2115e300$var$DEFAULT_RADIUS;
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    var arrowRadius = radius.arrow;
    var tooltipRadius = radius.tooltip;
    return "\n  \t.".concat(uuid, " {\n\t    color: ").concat(textColor, ";\n\t    background: ").concat(backgroundColor, ";\n\t    border: 1px solid ").concat(borderColor, ";\n\t    border-radius: ").concat(tooltipRadius, "px;\n\t    padding: ").concat(padding, ";\n  \t}\n\n  \t.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: 2;\n        width: 20px;\n        height: 12px;\n    }\n    .").concat(uuid, ".place-top::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(135deg);\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 18px;\n        height: 10px;\n    }\n    .").concat(uuid, ".place-bottom::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        top: -6px;\n        left: 50%;\n        margin-left: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-left::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        right: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(45deg);\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        content: \"\";\n        background-color: inherit;\n        position: absolute;\n        z-index: -1;\n        width: 10px;\n        height: 18px;\n    }\n    .").concat(uuid, ".place-right::after {\n        content: \"\";\n        position: absolute;\n        width: 10px;\n        height: 10px;\n        border-top-right-radius: ").concat(arrowRadius, "px;\n        border: 1px solid ").concat(borderColor, ";\n        background-color: ").concat(arrowColor, ";\n        z-index: -2;\n        left: -6px;\n        top: 50%;\n        margin-top: -6px;\n        transform: rotate(-135deg);\n    }\n  ");
}
function $af72022a2115e300$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $af72022a2115e300$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === 'light' ? 'black' : 'white';
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $af72022a2115e300$var$_class, $af72022a2115e300$var$_class2;
/* Polyfill */ var $af72022a2115e300$export$2e2bcd8739ae039 = $af72022a2115e300$var$staticMethods($af72022a2115e300$var$_class = $af72022a2115e300$var$windowListener($af72022a2115e300$var$_class = $af72022a2115e300$var$customEvent($af72022a2115e300$var$_class = $af72022a2115e300$var$isCapture($af72022a2115e300$var$_class = $af72022a2115e300$var$getEffect($af72022a2115e300$var$_class = $af72022a2115e300$var$bodyMode($af72022a2115e300$var$_class = $af72022a2115e300$var$trackRemoval($af72022a2115e300$var$_class = ($af72022a2115e300$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $af72022a2115e300$var$_inherits(ReactTooltip, _React$Component);
    var _super = $af72022a2115e300$var$_createSuper(ReactTooltip);
    function ReactTooltip(props) {
        var _this;
        $af72022a2115e300$var$_classCallCheck(this, ReactTooltip);
        _this = _super.call(this, props);
        _this.state = {
            uuid: props.uuid || $af72022a2115e300$var$generateUUID(),
            place: props.place || 'top',
            // Direction of tooltip
            desiredPlace: props.place || 'top',
            type: props.type || 'dark',
            // Color theme of tooltip
            effect: props.effect || 'float',
            // float or fixed
            show: false,
            border: false,
            borderClass: 'border',
            customColors: {},
            customRadius: {},
            offset: {},
            padding: props.padding,
            extraClass: '',
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $af72022a2115e300$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || '',
            possibleCustomEventsOff: props.possibleCustomEventsOff || '',
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            'showTooltip',
            'updateTooltip',
            'hideTooltip',
            'hideTooltipOnScroll',
            'getTooltipContent',
            'globalRebuild',
            'globalShow',
            'globalHide',
            'onWindowResize',
            'mouseOnToolTip'
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $af72022a2115e300$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props;
                _this$props.insecure;
                var resizeHide = _this$props.resizeHide, disableInternalStyle = _this$props.disableInternalStyle;
                this.mount = true;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                if (!disableInternalStyle) this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case 'Document':
                    case 'HTMLDocument':
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case 'ShadowRoot':
                    default:
                        domRoot = parentNode;
                        break;
                }
                // Prevent styles duplication.
                if (!domRoot.querySelector('style[data-react-tooltip]')) {
                    var style = document.createElement('style');
                    style.textContent = $af72022a2115e300$var$baseCss;
                    style.setAttribute('data-react-tooltip', 'true');
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(':hover');
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = '[data-tip]:not([data-for])';
                else {
                    var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
                    selector = "[data-tip][data-for=\"".concat(escaped, "\"]");
                }
                // Scan document for shadow DOM elements
                $af72022a2115e300$var$nodeListToArray(document.getElementsByTagName('*')).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($af72022a2115e300$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($af72022a2115e300$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute('currentItem') === null) target.setAttribute('currentItem', 'false');
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
                    target.addEventListener('focus', _this3.showTooltip, isCaptureMode);
                    if (effect === 'float') target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
                    target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
                    target.addEventListener('blur', _this3.hideTooltip, isCaptureMode);
                });
                // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                }
                // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
                target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
                target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children;
                // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $af72022a2115e300$var$TipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                }
                // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute('data-tip');
                var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
                // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
                // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute('data-scroll-hide')) scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute('aria-describedby', this.props.id || this.state.uuid);
                // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
                var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
                var result = $af72022a2115e300$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace.split(',')[0], desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace.split(',')[0];
                // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute('data-type') || self1.props.type || 'dark',
                        customColors: {
                            text: target.getAttribute('data-text-color') || self1.props.textColor || null,
                            background: target.getAttribute('data-background-color') || self1.props.backgroundColor || null,
                            border: target.getAttribute('data-border-color') || self1.props.borderColor || null,
                            arrow: target.getAttribute('data-arrow-color') || self1.props.arrowColor || null
                        },
                        customRadius: {
                            tooltip: target.getAttribute('data-tooltip-radius') || self1.props.tooltipRadius || '3',
                            arrow: target.getAttribute('data-arrow-radius') || self1.props.arrowRadius || '0'
                        },
                        effect: effect,
                        offset: offset,
                        padding: target.getAttribute('data-padding') || self1.props.padding,
                        html: (target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self1.props.html) || false,
                        delayShow: target.getAttribute('data-delay-show') || self1.props.delayShow || 0,
                        delayHide: target.getAttribute('data-delay-hide') || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute('data-delay-update') || self1.props.delayUpdate || 0,
                        border: (target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self1.props.border) || false,
                        borderClass: target.getAttribute('data-border-class') || self1.props.borderClass || 'border',
                        extraClass: target.getAttribute('data-class') || self1.props["class"] || self1.props.className || '',
                        disable: (target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $af72022a2115e300$var$TipContent(originTooltip, '', _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                };
                // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var _this$props6 = this.props, afterShow = _this$props6.afterShow, disableProp = _this$props6.disable;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target;
                // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable || disableProp) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition(function() {
                                if (isInvisible && afterShow) afterShow(e);
                            });
                        });
                    }
                };
                if (this.delayShowLoop) clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else {
                    this.delayShowLoop = null;
                    updateState();
                }
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var _this$props7 = this.props, afterHide = _this$props7.afterHide, disableProp = _this$props7.disable;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable || disableProp) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                }
                // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute('aria-describedby');
                var resetState = function resetState() {
                    var isVisible = _this6.state.show;
                    // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "updatePosition",
            value: function updatePosition(callbackAfter) {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $af72022a2115e300$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition(callbackAfter);
                });
                if (callbackAfter && typeof callbackAfter === 'function') callbackAfter();
                // Set tooltip position
                node.style.left = result.position.left + 'px';
                node.style.top = result.position.top + 'px';
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                if (this.delayShowLoop) {
                    clearTimeout(this.delayShowLoop);
                    this.delayShowLoop = null;
                }
                if (this.delayHideLoop) {
                    clearTimeout(this.delayHideLoop);
                    this.delayHideLoop = null;
                }
                if (this.delayReshow) {
                    clearTimeout(this.delayReshow);
                    this.delayReshow = null;
                }
                if (this.intervalUpdateContent) {
                    clearInterval(this.intervalUpdateContent);
                    this.intervalUpdateContent = null;
                }
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== 'border' && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors['border']);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = this.props.disableInternalStyle ? '' : $af72022a2115e300$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border, this.state.padding, this.state.customRadius);
                var tooltipClass = '__react_component_tooltip' + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? ' show' : '') + (this.state.border ? ' ' + this.state.borderClass : '') + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? 'custom' : this.state.type) + // dark, success, warning, error, info, light, custom
                (this.props.delayUpdate ? ' allow_hover' : '') + (this.props.clickable ? ' allow_click' : '');
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(' ');
                if (html) {
                    var htmlContent = "".concat(content).concat(style ? "\n<style aria-hidden=\"true\">".concat(style, "</style>") : '');
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createElement(Wrapper, $af72022a2115e300$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createElement(Wrapper, $af72022a2115e300$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), style && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
                    padding: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    borderClass: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    arrowRadius: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    tooltipRadius: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
                    disableInternalStyle: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $af72022a2115e300$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $af72022a2115e300$var$_objectSpread2($af72022a2115e300$var$_objectSpread2({}, prevState), {}, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Component), $af72022a2115e300$var$_defineProperty($af72022a2115e300$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: 'div',
    clickable: false
}), $af72022a2115e300$var$_defineProperty($af72022a2115e300$var$_class2, "supportedWrappers", [
    'div',
    'span'
]), $af72022a2115e300$var$_defineProperty($af72022a2115e300$var$_class2, "displayName", 'ReactTooltip'), $af72022a2115e300$var$_class2)) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class) || $af72022a2115e300$var$_class;



const $23348fff11010b14$var$ButtonWithTooltip = (props)=>{
    const { tooltip: tooltip, children: children, ...buttonProps } = props;
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>tooltip.id || (Math.random() * 1e32).toString(36), [
        tooltip.id
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        "data-for": id,
        "data-tip": true,
        children: [
            tooltip.show !== false && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                id: id,
                effect: "solid",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    textAlign: 'center',
                    children: tooltip.text
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                ...buttonProps,
                children: children
            })
        ]
    });
};
var $23348fff11010b14$export$2e2bcd8739ae039 = $23348fff11010b14$var$ButtonWithTooltip;








var $3ZYaX = parcelRequire("3ZYaX");






var $3ZYaX = parcelRequire("3ZYaX");

const $70ea9d7f0e6c7fb1$var$ConfirmationModal = ({ content: content, children: children, onConfirm: onConfirm, onCancel: onCancel, confirmButtonLabel: confirmButtonLabel, confirmButtonProps: confirmButtonProps, cancelButtonLabel: cancelButtonLabel, show: show, title: title, rememberStoreKey: rememberStoreKey })=>{
    const [remember, setRemember] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const handlerConfirm = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback(()=>{
        if (rememberStoreKey && remember) localStorage.setItem(rememberStoreKey, 'yes');
        onConfirm();
    }, [
        onConfirm,
        rememberStoreKey,
        remember
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (show && rememberStoreKey && localStorage.getItem(rememberStoreKey)) onConfirm();
    }, [
        show,
        rememberStoreKey
    ]);
    if (show && rememberStoreKey && localStorage.getItem(rememberStoreKey)) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
        show: show,
        onClose: onCancel,
        closeOnEsc: true,
        closeOnBlur: true,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Modal).Card, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Header, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Card.Title, {
                        children: title || 'Confirmation requise'
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Modal).Card.Body, {
                    children: [
                        content || children,
                        rememberStoreKey && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                                        onChange: (e)=>setRemember(e.target.checked),
                                        children: "Ne plus demander"
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Modal).Card.Footer, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "danger",
                            textColor: "white",
                            onClick: handlerConfirm,
                            ...confirmButtonProps,
                            "data-test": "confirm-action",
                            children: confirmButtonLabel || 'OK'
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            onClick: onCancel,
                            children: cancelButtonLabel || 'Annuler'
                        })
                    ]
                })
            ]
        })
    });
};
var $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039 = $70ea9d7f0e6c7fb1$var$ConfirmationModal;



const $01cb729370e7429b$var$MissionCancelConfirmation = ({ show: show, hide: hide, mission: mission, workPeriod: workPeriod })=>{
    const cancelWorkPeriodMutation = (0, $7040c29cc25c4df6$export$24d81c65f1ba5310)();
    const [replaceWorkersRequestPost, setReplaceWorkersRequestPost] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const onConfirm = async ()=>{
        await cancelWorkPeriodMutation.mutateAsync({
            missionId: mission._id,
            workPeriodId: workPeriod._id,
            isCancelled: true,
            isReplaceable: replaceWorkersRequestPost
        });
        hide();
    };
    const canBeReplaced = mission.workPeriods.some((w)=>w.__actions.canBeReplaced);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
        onConfirm: onConfirm,
        show: show,
        onCancel: hide,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                children: [
                    "\xcates vous certain de vouloir interrompre la mission de",
                    ' ',
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: mission.user
                        })
                    }),
                    ' ',
                    "? ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "Les Journ\xe9es de Travail \xe0 partir du ",
                    (0, $74f17ceb9b5a08a5$export$1b92b828e6214ca1)(workPeriod.start.date),
                    "\xa0",
                    (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workPeriod.start.date),
                    " seront annul\xe9es."
                ]
            }),
            canBeReplaced && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "hr"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "ul",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: "Au moins une Journ\xe9e de Travail n'a pas \xe9t\xe9 prest\xe9e et est rempla\xe7able."
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: [
                                        "Vous pouvez demander \xe0 l'Agence ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("b", {
                                            children: [
                                                " ",
                                                mission.interimAgency?.name
                                            ]
                                        }),
                                        " un rempla\xe7ant."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                            mt: 3,
                            checked: replaceWorkersRequestPost,
                            onChange: ()=>setReplaceWorkersRequestPost(!replaceWorkersRequestPost),
                            "data-test": "cancel-and-ask-for-a-replacement",
                            children: "Demander un rempla\xe7ant"
                        })
                    ]
                })
            })
        ]
    });
};
var $01cb729370e7429b$export$2e2bcd8739ae039 = $01cb729370e7429b$var$MissionCancelConfirmation;



parcelRequire("3ZYaX");








function $d7a1bf3b1f196c36$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var time = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var startTime = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.start).getTime();
    var endTime = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}




function $410057b58fa5bc28$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $c468ed5e889a430e$export$2e2bcd8739ae039)(dirtyDate, -amount);
}


const $3e6d8a4591828c3c$export$1784415d77596c64 = (mission, workPeriodId)=>mission.workPeriods.find((workPeriod)=>workPeriod._id === workPeriodId);
const $3e6d8a4591828c3c$export$be41908217fc7380 = (mission, workPeriodId)=>{
    const currentWorkPeriodIndex = mission.workPeriods.findIndex((workPeriod)=>workPeriod._id === workPeriodId);
    if (currentWorkPeriodIndex === 0) return undefined;
    return mission.workPeriods[currentWorkPeriodIndex - 1];
};
const $3e6d8a4591828c3c$export$772cd301688dff26 = (mission, start, end)=>mission.workPeriods.filter((workPeriod)=>(0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), {
            start: start,
            end: (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(end)
        }));
const $3e6d8a4591828c3c$export$12467b2222ec76cb = (mission, workPeriodId)=>{
    const currentWorkPeriodIndex = mission.workPeriods.findIndex((workPeriod)=>workPeriod._id === workPeriodId);
    if (currentWorkPeriodIndex === mission.workPeriods.length - 1) return undefined;
    return mission.workPeriods[currentWorkPeriodIndex + 1];
};
const $3e6d8a4591828c3c$export$afa4ebc2747d812f = (workPeriods, workPeriodId)=>{
    const idx = workPeriods.findIndex((wp)=>wp._id === workPeriodId);
    if (idx <= 0) return undefined;
    return workPeriods[idx - 1];
};
const $3e6d8a4591828c3c$export$a6586751c389f696 = (workPeriods, workPeriodId)=>{
    const idx = workPeriods.findIndex((wp)=>wp._id === workPeriodId);
    if (idx < 0 || idx === workPeriods.length - 1) return undefined;
    return workPeriods[idx + 1];
};
const $3e6d8a4591828c3c$export$43d193eba235ec60 = (mission)=>mission.workPeriods[mission.workPeriods.length - 1];
const $3e6d8a4591828c3c$export$81164c7a0c34c239 = (mission)=>mission.workPeriods.every((workPeriod)=>(workPeriod.start.manualClocking || workPeriod.start.clocking) && (workPeriod.end.manualClocking || workPeriod.end.clocking));
const $3e6d8a4591828c3c$export$6f7a9f6e5fbee2a6 = (mission)=>{
    const now = new Date();
    const next24h = (0, $c468ed5e889a430e$export$2e2bcd8739ae039)(now, 24);
    const last4h = (0, $410057b58fa5bc28$export$2e2bcd8739ae039)(now, 48);
    return mission.workPeriods.filter((wp)=>{
        const startDate = new Date(wp.start.date);
        const endDate = new Date(wp.end.date);
        return(// Work period en cours
        (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(now, {
            start: startDate,
            end: endDate
        }) || // Work period dans les prochaines 24h
        (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(startDate, {
            start: now,
            end: next24h
        }) || // Work period terminée dans les 4 dernières heures
        (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(endDate, {
            start: last4h,
            end: now
        }));
    }).sort((a, b)=>new Date(a.start.date).getTime() - new Date(b.start.date).getTime())[0];
};



const $ccb078862c2a5bd6$var$MissionValidateConfirmation = ({ mission: mission, hide: hide })=>{
    const mutation = (0, $e409591b67738e56$export$cac0b33e6f13c8ec)();
    const workPeriods = mission.workPeriods;
    const lastWorkPeriod = workPeriods[workPeriods.length - 1];
    const onConfirm = async ()=>{
        await mutation.mutate({
            _id: mission._id,
            isValidated: true
        });
        hide();
    };
    const hasNotStartedWorkPeriod = lastWorkPeriod && (0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(lastWorkPeriod.start.date), new Date());
    const hasNotAllWorkPeriodsClocked = !(0, $3e6d8a4591828c3c$export$81164c7a0c34c239)({
        ...mission,
        workPeriods: workPeriods
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
        show: Boolean(mission),
        onConfirm: onConfirm,
        onCancel: hide,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        mb: 3,
                        children: [
                            "Valider l'enti\xe8ret\xe9 de la Mission : ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                        ]
                    }),
                    workPeriods[0] && lastWorkPeriod && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                user: mission.user
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Du ",
                            (0, $74f17ceb9b5a08a5$export$9f679dbcb5959c9b)(workPeriods[0].start.date),
                            " au",
                            ' ',
                            (0, $74f17ceb9b5a08a5$export$9f679dbcb5959c9b)(lastWorkPeriod.end.date)
                        ]
                    })
                ]
            }),
            (hasNotStartedWorkPeriod || hasNotAllWorkPeriodsClocked) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mt: 4,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                textWeight: "bold",
                                children: "Attention"
                            })
                        ]
                    }),
                    hasNotStartedWorkPeriod && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "La semaine n'est pas encore termin\xe9e"
                    }),
                    hasNotAllWorkPeriodsClocked && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Toutes les journ\xe9es de travail n'ont pas \xe9t\xe9 point\xe9es"
                    })
                ]
            })
        ]
    });
};
var $ccb078862c2a5bd6$export$2e2bcd8739ae039 = $ccb078862c2a5bd6$var$MissionValidateConfirmation;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");







function $6b601cb106cd3f71$export$3ef1799cbda7de2c(start, end) {
    const result = {};
    if (start === undefined || start === null) result.startDate = "L'heure de d\xe9but n'est pas pr\xe9cis\xe9e";
    if (end === undefined || end === null) result.endDate = "L'heure de fin n'est pas pr\xe9cis\xe9e";
    if (start && end) {
        if ((0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(end, start) || (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(end, start)) result.endDate = "L'heure de fin doit \xeatre apr\xe8s l'heure de d\xe9but";
        else if ((0, $ef2e6760f3e9e6fc$export$2e2bcd8739ae039)(end, start) > 24 * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59)) result.endDate = "La p\xe9riode ne peut pas d\xe9passer 24 heures";
    }
    return result;
}


function $ecc673cccc6aa338$export$c03fb07d8c17458d(dayIso, startTime, endTime) {
    if (!startTime || !endTime) return null;
    const dayDate = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(dayIso);
    const startDate = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(dayDate, startTime);
    if (!startDate) return null;
    const endDateSameDay = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(dayDate, endTime);
    if (!endDateSameDay) return null;
    const endDate = endDateSameDay > startDate ? endDateSameDay : (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(dayDate, 1), endTime);
    if (!endDate) return null;
    return {
        startDate: startDate,
        endDate: endDate
    };
}
/**
 * Form to add a single work period: one day + start time + end time.
 * Same pattern as mission-form WorkPeriodsEditor. No modal wrapper.
 * Uses children render prop to expose handleSubmit and content (for modal or inline use).
 */ const $ecc673cccc6aa338$var$AddWorkPeriodForm = ({ mission: mission, onSubmit: onSubmit, mutation: mutation, formKey: formKey, children: children })=>{
    const missionStart = new Date(mission.start);
    const missionEnd = mission.end ? new Date(mission.end) : undefined;
    const minDate = (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(missionStart);
    const maxDate = missionEnd ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(missionEnd) : undefined;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            day: minDate,
            startTime: '08:00',
            endTime: '17:00'
        },
        validate: (values)=>{
            const errors = {};
            if (!values.day) errors.day = 'Champ requis';
            if (!values.startTime) errors.startTime = "L'heure de d\xe9but est requise";
            if (!values.endTime) errors.endTime = "L'heure de fin est requise";
            const built = $ecc673cccc6aa338$export$c03fb07d8c17458d(values.day, values.startTime, values.endTime);
            if (built) {
                const rangeErrors = (0, $6b601cb106cd3f71$export$3ef1799cbda7de2c)(built.startDate, built.endDate);
                if (rangeErrors.startDate) errors.startTime = rangeErrors.startDate;
                if (rangeErrors.endDate) errors.endTime = rangeErrors.endDate;
            }
            return errors;
        },
        onSubmit: (values)=>{
            const built = $ecc673cccc6aa338$export$c03fb07d8c17458d(values.day, values.startTime, values.endTime);
            if (!built) return;
            onSubmit({
                start: {
                    date: built.startDate
                },
                end: {
                    date: built.endDate
                }
            });
        },
        children: ({ handleSubmit: handleSubmit })=>children({
                handleSubmit: handleSubmit,
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 3,
                            children: [
                                "Choisissez un jour dans la plage de la mission (du",
                                ' ',
                                missionStart.toLocaleDateString('fr-FR'),
                                missionEnd ? ` au ${missionEnd.toLocaleDateString('fr-FR')}` : '',
                                ") et les horaires de la journ\xe9e."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: "Jour"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        name: "day",
                                        type: "date",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        min: minDate,
                                        max: maxDate,
                                        required: true,
                                        "data-test": "add-work-period-day"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: "Heure de d\xe9but"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        name: "startTime",
                                        type: "time",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        required: true,
                                        "data-test": "add-work-period-start-time"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: "Heure de fin"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        name: "endTime",
                                        type: "time",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        required: true,
                                        "data-test": "add-work-period-end-time"
                                    })
                                })
                            ]
                        }),
                        mutation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                            mutation: mutation
                        })
                    ]
                })
            })
    }, formKey);
};
var $ecc673cccc6aa338$export$2e2bcd8739ae039 = $ecc673cccc6aa338$var$AddWorkPeriodForm;



/**
 * Modal that wraps AddWorkPeriodForm in a confirmation dialog.
 * Handles create mutation and closes on success.
 */ const $5c199742b03e1866$var$AddWorkPeriodModal = ({ show: show, hide: hide, mission: mission })=>{
    const createWorkPeriodMutation = (0, $7040c29cc25c4df6$export$3e7a0a94c435902d)();
    const handleSubmit = (payload)=>{
        createWorkPeriodMutation.mutate({
            missionId: mission._id,
            start: payload.start,
            end: payload.end
        }, {
            onSuccess: ()=>hide()
        });
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ecc673cccc6aa338$export$2e2bcd8739ae039), {
        mission: mission,
        onSubmit: handleSubmit,
        mutation: createWorkPeriodMutation,
        formKey: show ? 'open' : 'closed',
        children: ({ handleSubmit: formHandleSubmit, content: content })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: show,
                onCancel: hide,
                onConfirm: ()=>formHandleSubmit(),
                confirmButtonLabel: "Ajouter",
                cancelButtonLabel: "Annuler",
                confirmButtonProps: {
                    disabled: createWorkPeriodMutation.isLoading
                },
                children: content
            })
    });
};
var $5c199742b03e1866$export$2e2bcd8739ae039 = $5c199742b03e1866$var$AddWorkPeriodModal;




parcelRequire("3ZYaX");

/**
 * Component to display a list of actions for a resource
 */ const $dd1d1753cdfb51cf$var$ResourceActions = ({ actions: actions })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: actions.map((action, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: index !== actions.length - 1 ? 5 : 0,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mb: 2,
                        children: action.title
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 2,
                        children: action.description
                    }),
                    action.content,
                    index !== actions.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "hr",
                        my: 5
                    })
                ]
            }, index))
    });
};
var $dd1d1753cdfb51cf$export$2e2bcd8739ae039 = $dd1d1753cdfb51cf$var$ResourceActions;


const $df9437b988a4a000$var$MissionActions = ({ mission: mission })=>{
    const actions = $df9437b988a4a000$var$useActions(mission);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dd1d1753cdfb51cf$export$2e2bcd8739ae039), {
        actions: actions
    });
};
var $df9437b988a4a000$export$2e2bcd8739ae039 = $df9437b988a4a000$var$MissionActions;
const $df9437b988a4a000$var$useActions = (mission)=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const addWorkPeriodModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    //Validate mission confirmation state
    const [currentMissionToValidate, setCurrentMissionToValidate] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    //Mutations
    const updateWorkPeriodMutation = (0, $7040c29cc25c4df6$export$cac0b33e6f13c8ec)();
    const firstCancellableWorkPeriod = mission.workPeriods.find((workPeriod)=>workPeriod.__actions.canBeCancelled);
    const missionIsCancellable = firstCancellableWorkPeriod !== undefined;
    //TODO: duplicate of backend check (found  a solution to avoid duplicate code)
    const missionCanBeValidated = mission.workPeriods.every((w)=>w.__actions.canBeValidated);
    // TODO: refactor using workPeriod.__action.canBeCancelled
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ], {
                resource: 'missions',
                name: 'validate'
            }) && {
                title: "Valider l'enti\xe8ret\xe9 de la Mission",
                description: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        "Vous pouvez valider l'enti\xe8ret\xe9 d'une mission si l'ensemble de ses Journ\xe9es de Travail ne sont pas vides.",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "Chaque journ\xe9e doit avoir au moins l'une des informations suivantes :",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Soit un pointage de d\xe9but et de fin"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Soit un \xe9v\xe9nement"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Soit \xeatre en Abandon de Poste"
                                })
                            ]
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'employerMember'
                    ],
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            mission.isValidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$54eb6f08aa91b890), {
                                    mission: mission
                                })
                            }),
                            !mission.isValidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                narrow: true,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $23348fff11010b14$export$2e2bcd8739ae039), {
                                        type: "button",
                                        color: 'primary',
                                        onClick: ()=>setCurrentMissionToValidate(mission),
                                        disabled: !Boolean(missionCanBeValidated),
                                        tooltip: {
                                            text: "Cette Mission ne peut \xeatre valid\xe9e",
                                            show: !missionCanBeValidated
                                        },
                                        "data-test": "validate-mission",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5f977870ae3cdbf1), {})
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                children: "Valider"
                                            })
                                        ]
                                    }),
                                    missionCanBeValidated && currentMissionToValidate && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ccb078862c2a5bd6$export$2e2bcd8739ae039), {
                                        show: modal.isDisplayed,
                                        hide: ()=>modal.setIsDisplayed(false),
                                        mission: mission
                                    })
                                ]
                            })
                        ]
                    })
                })
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember',
                'interimAgencyMember'
            ], {
                resource: 'missions',
                name: 'cancel'
            }) && {
                title: 'Interrompre le reste de la Mission',
                description: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        "L'Interruption d'une Mission a pour effet de",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Pr\xe9server les Journ\xe9es de Travail pass\xe9es et en cours"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Supprimer toutes les Journ\xe9es de Travail \xe0 venir"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "- Notifier l'Employeur de l'Interruption"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                    children: [
                                        "- Si le ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                        " est employ\xe9 par une Entreprise de Travail Temporaire vous pourrez demander un rempla\xe7ant",
                                        ' '
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                    children: [
                                        "- Le ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                        " sera disponible \xe0 l'issue de sa derni\xe8re Journ\xe9e de Travail pr\xe9serv\xe9e"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'interimAgencyMember',
                        'employerMember'
                    ],
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            mission.isCancelled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                                    mission: mission
                                })
                            }),
                            !mission.isCancelled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                narrow: true,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $23348fff11010b14$export$2e2bcd8739ae039), {
                                        type: "button",
                                        color: 'danger',
                                        onClick: ()=>firstCancellableWorkPeriod && modal.setIsDisplayed(true),
                                        disabled: !Boolean(firstCancellableWorkPeriod),
                                        tooltip: {
                                            text: "Cette Mission n'est pas interruptible",
                                            show: !missionIsCancellable
                                        },
                                        "data-test": "cancel-mission",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$881d644e093d956f), {})
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                children: "Interrompre"
                                            })
                                        ]
                                    }),
                                    missionIsCancellable && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $01cb729370e7429b$export$2e2bcd8739ae039), {
                                        show: modal.isDisplayed,
                                        hide: ()=>modal.setIsDisplayed(false),
                                        mission: mission,
                                        workPeriod: firstCancellableWorkPeriod
                                    })
                                ]
                            })
                        ]
                    })
                })
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ], {
                resource: 'missions',
                name: 'createWorkPeriod'
            }) && !mission.scheduleTemplate && mission.__actions?.canBeUpdated && {
                title: "Ajouter une journ\xe9e de travail",
                description: "Cr\xe9ez une nouvelle journ\xe9e de travail dans la plage de dates de la mission. Les dates ne doivent pas chevaucher une journ\xe9e existante.",
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                            color: "primary",
                            onClick: ()=>addWorkPeriodModal.setIsDisplayed(true),
                            "data-test": "add-work-period-button",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e718407ce256549d), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "span",
                                    children: "Ajouter une journ\xe9e"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5c199742b03e1866$export$2e2bcd8739ae039), {
                            show: addWorkPeriodModal.isDisplayed,
                            hide: ()=>addWorkPeriodModal.setIsDisplayed(false),
                            mission: mission
                        })
                    ]
                })
            }
        ].filter((v)=>v), [
        mission,
        firstCancellableWorkPeriod,
        updateWorkPeriodMutation,
        modal,
        addWorkPeriodModal
    ]);
};



parcelRequire("3ZYaX");






const $a3fff9dbe3c5b2d1$var$MissionPageTitle = ({ mission: mission, organizationType: organizationType, children: children })=>{
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: "Nouvelle Mission Interne"
    });
    else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(mission.user),
        subTitle: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    "data-test": "mission-details-service-name",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$bbc9410078004e71), {})
                        }),
                        mission.service.name
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    "data-test": "mission-details-job-title-name",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$a409e2da4a3967b), {})
                        }),
                        mission.jobTitle.name
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    "data-test": "mission-details-interim-agency-name",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ecf5f5308bcbb05e), {})
                        }),
                        mission?.[organizationType]?.name
                    ]
                })
            ]
        }),
        children: children
    });
};
var $a3fff9dbe3c5b2d1$export$2e2bcd8739ae039 = $a3fff9dbe3c5b2d1$var$MissionPageTitle;
const $a3fff9dbe3c5b2d1$export$9eb9467136ef56ff = ({ mission: mission })=>{
    // const modal = useModal()
    if (!mission) return;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'update'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                    color: 'link',
                    outlined: true,
                    renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                    size: "small",
                    to: `/missions/${mission._id}/edit`,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                        }),
                        "Modifier la mission"
                    ]
                })
            }),
            mission.interimAgency ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                    color: 'link',
                    outlined: true,
                    renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                    size: "small",
                    to: `/workers-requests/new?missionTemplate=${mission._id}`,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$10862138e9169702), {})
                        }),
                        "Utiliser pour une nouvelle Demande"
                    ]
                })
            }) : null
        ]
    });
};





var $2KSUA = parcelRequire("2KSUA");



const $ed41299eecb4da8a$var$POPULATE = [
    'employer',
    'interimAgency',
    'posts.missions',
    'posts.missions.user',
    'posts.desiredWorkers',
    'posts.jobTitle',
    'posts.tags',
    'missionData.service',
    'history.by',
    'history.missions',
    'history.missions.user'
];
//TODO : review this
const $ed41299eecb4da8a$var$buildFetchParams = (params)=>{
    const { service: service, isExpired: isExpired, jobTitle: jobTitle, start: start, end: end, ...rest } = params;
    const expiredParams = {};
    if (isExpired) expiredParams['missionsEnd>'] = isExpired;
    return {
        sort: '-missionsStart',
        ...expiredParams,
        'missionsStart>': start,
        'missionsStart<': end,
        'missionData.service': service,
        'posts.jobTitle': jobTitle,
        ...rest
    };
};
const $ed41299eecb4da8a$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/workers-requests',
        method: 'get',
        params: {
            populate: params.populate || $ed41299eecb4da8a$var$POPULATE,
            ...$ed41299eecb4da8a$var$buildFetchParams(params) || {}
        }
    });
};
const $ed41299eecb4da8a$export$85b9a36db797e02b = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/workers-requests/count',
        method: 'get',
        params: {
            ...$ed41299eecb4da8a$var$buildFetchParams(params) || {}
        }
    });
};
const $ed41299eecb4da8a$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${id}`,
        params: {
            populate: $ed41299eecb4da8a$var$POPULATE
        },
        method: 'get'
    });
const $ed41299eecb4da8a$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/workers-requests',
        method: 'post',
        params: params
    });
const $ed41299eecb4da8a$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${id}`,
        method: 'put',
        params: payload
    });
};
const $ed41299eecb4da8a$export$e1bef8d96c7ba086 = async (params)=>{
    const { workersRequestId: workersRequestId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${workersRequestId}/posts`,
        method: 'post',
        params: payload
    });
};
const $ed41299eecb4da8a$export$431458ae9af46678 = async (params)=>{
    const { workersRequestId: workersRequestId, postId: postId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${workersRequestId}/posts/${postId}`,
        method: 'put',
        params: payload
    });
};
const $ed41299eecb4da8a$export$6ca2c30598d1bf61 = async (params)=>{
    const { workersRequestId: workersRequestId, postId: postId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${workersRequestId}/posts/${postId}`,
        method: 'delete',
        params: payload
    });
};
const $ed41299eecb4da8a$export$45dfd5ddc6d95240 = async (params)=>{
    const { workersRequestId: workersRequestId, postId: postId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${workersRequestId}/posts/${postId}/assign`,
        method: 'put',
        params: payload
    });
};
const $ed41299eecb4da8a$export$e6f8ed4e12814dab = async (params)=>{
    const { workersRequestId: workersRequestId, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/workers-requests/${workersRequestId}/posts/assign`,
        method: 'put',
        params: payload
    });
};




const $b8c6247768bd4102$export$1a75acd08b8f614 = (id)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('workers-requests', (0, $ed41299eecb4da8a$export$3988ae62b71be9a3), id);
const $b8c6247768bd4102$export$5dbb5ce56c96c45c = (missionId)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('workers-requests', (0, $ed41299eecb4da8a$export$e7aa7bc5c1b3cfb3), {
        'posts.missions': missionId
    });
const $b8c6247768bd4102$export$3227f9c6a08d0d97 = (filters, options)=>{
    return (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('workers-requests/count', (0, $ed41299eecb4da8a$export$85b9a36db797e02b), filters || (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).workersRequests]), options);
};
const $b8c6247768bd4102$export$5084421b5a71fe52 = (filters, options)=>{
    return (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('workers-requests', (0, $ed41299eecb4da8a$export$e7aa7bc5c1b3cfb3), filters || (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).workersRequests]), options);
};
//Mutations
const $b8c6247768bd4102$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'workers-requests'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'workers'
    ]);
};
const $b8c6247768bd4102$export$4a6f974b4208311 = ()=>[
        'workers-requests',
        'create'
    ];
const $b8c6247768bd4102$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$185802fd694ee1f5), {
        mutationKey: $b8c6247768bd4102$export$4a6f974b4208311(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useUpdateMutationKey = ()=>[
        'workers-requests',
        'update'
    ];
const $b8c6247768bd4102$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$722fbec263ad908a), {
        mutationKey: $b8c6247768bd4102$var$useUpdateMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useCreatePostMutationKey = ()=>[
        'workers-requests',
        'create-post'
    ];
const $b8c6247768bd4102$export$d52fd328f9b799ac = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$e1bef8d96c7ba086), {
        mutationKey: $b8c6247768bd4102$var$useCreatePostMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useUpdatePostMutationKey = ()=>[
        'workers-requests',
        'update-post'
    ];
const $b8c6247768bd4102$export$86ce95a609069de6 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$431458ae9af46678), {
        mutationKey: $b8c6247768bd4102$var$useUpdatePostMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useDeletePostMutationKey = ()=>[
        'workers-requests',
        'delete-post'
    ];
const $b8c6247768bd4102$export$98e17e10429f9256 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$6ca2c30598d1bf61), {
        mutationKey: $b8c6247768bd4102$var$useDeletePostMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useAssignWorkerToPostMutationKey = ()=>[
        'workers-requests',
        'update-post'
    ];
const $b8c6247768bd4102$export$19edf282e3e6d35b = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$45dfd5ddc6d95240), {
        mutationKey: $b8c6247768bd4102$var$useAssignWorkerToPostMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });
const $b8c6247768bd4102$var$useAssignWorkersToPostsMutationKey = ()=>[
        'workers-requests',
        'assign-workers-to-posts'
    ];
const $b8c6247768bd4102$export$3aab0d82fc583c26 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $ed41299eecb4da8a$export$e6f8ed4e12814dab), {
        mutationKey: $b8c6247768bd4102$var$useAssignWorkersToPostsMutationKey(),
        onSuccess: $b8c6247768bd4102$var$onMutationSuccess
    });



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");






var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");






const $a9a2c4fb8e82caed$var$POPULATE = [
    'employer'
];
const $a9a2c4fb8e82caed$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/services',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $a9a2c4fb8e82caed$var$POPULATE,
            ...params || {}
        }
    });
const $a9a2c4fb8e82caed$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/services/${id}`,
        method: 'get',
        params: {
            populate: $a9a2c4fb8e82caed$var$POPULATE
        }
    });
const $a9a2c4fb8e82caed$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/services',
        method: 'post',
        params: params
    });
const $a9a2c4fb8e82caed$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/services/${id}`,
        method: 'put',
        params: payload
    });
};


const $3d856666402e8eec$export$647a21ab65df9f13 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('services', (0, $a9a2c4fb8e82caed$export$3988ae62b71be9a3), id, undefined, options);
const $3d856666402e8eec$export$a870673e4b33fcfb = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('services', (0, $a9a2c4fb8e82caed$export$e7aa7bc5c1b3cfb3), filters, options);
// Mutation success handler
const $3d856666402e8eec$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'services'
    ]);
};
const $3d856666402e8eec$export$4a6f974b4208311 = ()=>[
        'services',
        'create'
    ];
const $3d856666402e8eec$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $a9a2c4fb8e82caed$export$185802fd694ee1f5), {
        mutationKey: $3d856666402e8eec$export$4a6f974b4208311(),
        onSuccess: $3d856666402e8eec$var$onMutationSuccess
    });
const $3d856666402e8eec$export$a6fe4df8bec26327 = ()=>[
        'services',
        'update'
    ];
const $3d856666402e8eec$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $a9a2c4fb8e82caed$export$722fbec263ad908a), {
        mutationKey: $3d856666402e8eec$export$a6fe4df8bec26327(),
        onSuccess: $3d856666402e8eec$var$onMutationSuccess
    });


const $d9f38b67410ce68a$var$isIsoDate = (value)=>{
    if (isNaN(Date.parse(value))) return false;
    if (new Date(value).toISOString() === value) return true;
    return false;
};
const $d9f38b67410ce68a$var$isNumber = (value)=>{
    if (parseInt(value).toString() === value) return true;
    return false;
};
const $d9f38b67410ce68a$var$displayChange = (value)=>{
    if (value === undefined) return value;
    if (value === 'true') return 'Oui';
    if (value === 'false') return 'Non';
    if ($d9f38b67410ce68a$var$isNumber(value)) return value // Before dates parsing ! Numbers are valid date constructors !
    ;
    if ((0, $c157c1756df385fe$export$2e2bcd8739ae039)(value) || $d9f38b67410ce68a$var$isIsoDate(value)) return (0, $2KSUA.upperFirst)((0, $74f17ceb9b5a08a5$export$9f679dbcb5959c9b)(new Date(value)));
    return value;
};
const $d9f38b67410ce68a$var$HistoryChange = ({ change: _change, locales: locales })=>{
    /* Services are stored as id's
   To avoid deep populate
   Or just storing service names which can deprecate
   We resolve the names dynamically, only if needed
   */ const change = structuredClone(_change);
    const oldServiceId = change.attribute === 'missionData.service' ? change.oldValue : undefined;
    const newServiceId = change.attribute === 'missionData.service' ? change.newValue : undefined;
    const oldService = (0, $3d856666402e8eec$export$647a21ab65df9f13)(oldServiceId)?.data;
    const newService = (0, $3d856666402e8eec$export$647a21ab65df9f13)(newServiceId)?.data;
    if (oldService) change.oldValue = oldService.name;
    if (newService) change.newValue = newService.name;
    const iconParentElement = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if ((change.oldValue?.length || 0) >= 30 || (change.newValue?.length || 0) >= 30) return 'div';
        return 'span';
    }, [
        change
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        mt: 3,
        ml: 3,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 6,
                mb: 3,
                children: locales?.changesTitle?.[change.attribute] || change.attribute
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                style: {
                    whiteSpace: 'pre-line'
                },
                children: [
                    change.oldValue && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: iconParentElement,
                        children: [
                            $d9f38b67410ce68a$var$displayChange(change.oldValue),
                            ' ',
                            change.newValue && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        style: {
                                            verticalAlign: 'top'
                                        },
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$9ca09caa9c849d9c), {})
                                    }),
                                    ' '
                                ]
                            })
                        ]
                    }),
                    $d9f38b67410ce68a$var$displayChange(change.newValue)
                ]
            })
        ]
    }, change._id);
};
var $d9f38b67410ce68a$export$2e2bcd8739ae039 = $d9f38b67410ce68a$var$HistoryChange;


const $2dc117e06078deed$var$HistoryItem = ({ item: item, locales: locales, renderCustomContent: renderCustomContent })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Panel).Block, {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("details", {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("summary", {
                    role: "button",
                    children: [
                        item.by && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: item.by,
                            small: true
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            ml: 3,
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            className: "is-size-7-mobile",
                            children: (0, $74f17ceb9b5a08a5$export$d9576bc52e3509f3)(item.date)
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            ml: 3,
                            style: {
                                whiteSpace: 'nowrap'
                            },
                            children: locales?.title?.[item.action] || item.action
                        })
                    ]
                }),
                item.changes && item.changes[0] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    children: item.changes.map((change)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d9f38b67410ce68a$export$2e2bcd8739ae039), {
                            change: change,
                            locales: locales
                        }, change._id))
                }),
                renderCustomContent && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    my: 3,
                    ml: 3,
                    children: renderCustomContent(item, locales)
                })
            ]
        })
    });
};
var $2dc117e06078deed$export$2e2bcd8739ae039 = $2dc117e06078deed$var$HistoryItem;


const $d21fe120a7200937$var$History = ({ items: items, locales: locales, renderCustomContent: renderCustomContent })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel), {
        children: [
            items.length === 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Panel).Block, {
                justifyContent: "center",
                children: "Rien \xe0 afficher"
            }),
            items.map((historyItem)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2dc117e06078deed$export$2e2bcd8739ae039), {
                    item: historyItem,
                    locales: locales,
                    renderCustomContent: renderCustomContent
                }, historyItem._id.toString()))
        ]
    });
};
var $d21fe120a7200937$export$2e2bcd8739ae039 = $d21fe120a7200937$var$History;


var $ab3fa70a0ca06441$export$2e2bcd8739ae039 = {
    history: {
        title: {
            missionCreated: "Mission cr\xe9\xe9e",
            missionUpdated: "Mission mise \xe0 jour",
            missionValidated: "Mission valid\xe9e",
            missionUnValidated: "Mission d\xe9-valid\xe9e",
            missionCancelled: 'Mission interrompue',
            missionAbandoned: 'Abandon de Poste',
            clockingRegistered: "Pointage enregistr\xe9",
            workPeriodCreated: "Journ\xe9e de travail ajout\xe9e",
            workPeriodUpdated: "Journ\xe9e de travail mise \xe0 jour",
            workPeriodRemoved: "Journ\xe9e de travail supprim\xe9e",
            preBillingRegistered: "Mission pr\xe9-factur\xe9e",
            workPeriodsUpdated: "Journ\xe9es de Travail mises \xe0 jour"
        },
        changesTitle: {
            'workPeriodCreated': 'Ajout',
            'workPeriodRemoved': 'Suppression',
            'workPeriodUpdated': "Mise \xe0 jour de la journ\xe9e de travail",
            'workPeriod.start.date': "Heure de d\xe9but",
            'workPeriod.end.date': 'Heure de fin',
            'workPeriod.isValidated': "Journ\xe9e de travail valid\xe9e",
            'workPeriod.start.manualClocking': "Pointage forc\xe9 ajout\xe9 pour l'entr\xe9e",
            'workPeriod.end.manualClocking': "Pointage forc\xe9 ajout\xe9 pour la sortie",
            'mission.isAbandoned': 'Abandon de Poste',
            'mission.isCancelled': 'Mission interrompue',
            'mission.start': "Heure de D\xe9but de Mission",
            'mission.end': 'Heure de Fin de Mission',
            isValidated: ' ',
            isAbandoned: ' ',
            'workPeriod.service': 'Service'
        }
    }
};



parcelRequire("3ZYaX");


const $6fa2fec5ba94be96$export$c1fc27c145fcfcb9 = ({ data: data, keys: keys, omitKeys: omitKeys = [], columns: columns, noDataMessage: noDataMessage = "Aucune donn\xe9e \xe0 afficher" })=>{
    if (data === undefined) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    const keyedColumns = keys?.filter((key)=>!omitKeys.includes(key)).map((key)=>({
            ...columns[key],
            id: key
        })) ?? [];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        //@ts-expect-error
        columns: keyedColumns,
        data: data,
        noDataMessage: noDataMessage
    });
};



parcelRequire("3ZYaX");










parcelRequire("3ZYaX");




const $2b10bcffad1c8580$export$b89ed0bd7f7384f6 = ({ workPeriod: workPeriod, ...rest })=>{
    if (!workPeriod.isAbandoned) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: "danger",
        text: "Journ\xe9e de Travail en Abandon de Poste",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6e75112b03731134), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$42e76898d8f52841 = ({ workPeriod: workPeriod, ...rest })=>{
    if (!workPeriod.isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    let text = "Journ\xe9e de travail Valid\xe9e";
    if (workPeriod.summary?.validatedBy) text = `${text} par ${(0, $25ffbf4bca475b04$export$9a57c514c234d759)(workPeriod.summary.validatedBy, {
        hideOfflineInfo: true
    })}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: text,
        iconColor: "success",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7a838bc26f0582fd), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$58c7b6261f2de560 = ({ workPeriod: workPeriod, ...rest })=>{
    if (workPeriod.isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Journ\xe9e de travail non Valid\xe9e",
        iconColor: "info",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e019fa8422296e1c), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$8f26e58ed3dcd649 = ({ workPeriod: workPeriod, ...rest })=>{
    if (workPeriod.__actions.canBeValidated || workPeriod.isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Journ\xe9e de travail incompl\xe8te",
        iconColor: "warning",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$793424bfec4768af), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$62c533d39ecbd200 = ({ workPeriod: workPeriod, ...rest })=>{
    if (workPeriod.tags.length === 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    const text = workPeriod.tags.map((tag)=>tag.name).join(', ');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: text,
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1b490aa7069a487b), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$var$WorkPeriodNonEditableMessage = ({ workPeriod: workPeriod, ...rest })=>{
    if (!workPeriod.isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Journ\xe9e de Travail non \xe9ditable",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$164e414f2cfd5f62), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$18721b912cdbc3ff = ({ workPeriod: workPeriod, ...rest })=>{
    if (!workPeriod.isCancelled) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: 'danger',
        text: "Journ\xe9e de Travail interrompue",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$cfa96dd21be274a9), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$export$8d6fc50e3f3f6bf5 = ({ workPeriod: workPeriod, ...rest })=>{
    if (workPeriod.events[0] === undefined) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    const hasBenefitEvent = workPeriod.events.some((e)=>e.item.type === 'benefit');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: hasBenefitEvent ? 'info' : undefined,
        text: (0, $dda2f26c3659cf93$export$72df6793a37420b0)(workPeriod.events),
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$54eeba26dc8b99cf), {}),
        ...rest
    });
};
const $2b10bcffad1c8580$var$WorkPeriodMessages = ({ workPeriod: workPeriod, ...rest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2b10bcffad1c8580$export$b89ed0bd7f7384f6, {
                workPeriod: workPeriod,
                ...rest
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2b10bcffad1c8580$export$42e76898d8f52841, {
                workPeriod: workPeriod,
                ...rest
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2b10bcffad1c8580$export$18721b912cdbc3ff, {
                workPeriod: workPeriod,
                ...rest
            })
        ]
    });
};
var $2b10bcffad1c8580$export$2e2bcd8739ae039 = $2b10bcffad1c8580$var$WorkPeriodMessages;



parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $ed7782a4176045fd$var$DotsHorizontalIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
    }));
}
const $ed7782a4176045fd$var$ForwardRef = $3ZYaX.forwardRef($ed7782a4176045fd$var$DotsHorizontalIcon);
var $ed7782a4176045fd$export$2e2bcd8739ae039 = $ed7782a4176045fd$var$ForwardRef;



const $801415e870a9139e$var$WorkPeriodValidateButton = ({ label: label, cancelLabel: cancelLabel, onClick: onClick, workPeriod: workPeriod, size: size, type: type })=>{
    if (!workPeriod.isValidated) {
        const actionDisabled = !workPeriod.__actions.canBeValidated;
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "span",
            "data-tooltip": actionDisabled ? "Impossible de valider la journ\xe9e de travail" : "Valider la journ\xe9e de travail",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                style: size === 'smallest' ? {
                    height: '1.5rem'
                } : {},
                size: size === 'smallest' ? 'small' : size,
                type: type,
                color: actionDisabled ? '' : 'link',
                onClick: ()=>onClick(workPeriod),
                disabled: actionDisabled,
                "data-test": "work-period-validate-action",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: actionDisabled ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7782a4176045fd$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5f977870ae3cdbf1), {})
                    }),
                    label && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        children: label
                    })
                ]
            })
        });
    } else if (workPeriod.__actions.canBeInvalidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
            style: size === 'smallest' ? {
                height: '1.5rem'
            } : {},
            size: size === 'smallest' ? 'small' : size,
            type: type,
            color: cancelLabel ? undefined : 'ghost',
            onClick: ()=>onClick(workPeriod),
            "data-test": "work-period-invalidate-action",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    size: 'small',
                    "data-tooltip": workPeriod.summary?.validatedBy ? `Journ\xe9e de travail valid\xe9e par ${(0, $25ffbf4bca475b04$export$9a57c514c234d759)(workPeriod.summary?.validatedBy, {
                        hideOfflineInfo: true
                    })}` : "Journ\xe9e de travail valid\xe9e",
                    color: "grey-light",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$164e414f2cfd5f62), {})
                }),
                cancelLabel && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                    children: cancelLabel
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
var $801415e870a9139e$export$2e2bcd8739ae039 = $801415e870a9139e$var$WorkPeriodValidateButton;






var $3ZYaX = parcelRequire("3ZYaX");




var $2KSUA = parcelRequire("2KSUA");
const $0798496ba66df318$export$e370a7ddaa2f579a = (cost)=>(cost ? /*round(cost, 3)*/ cost : '0') + "\u20AC";
const $0798496ba66df318$export$d0d40d105bf15201 = (value, currency = "\u20AC")=>{
    if (value === undefined) return `0${currency}`;
    return `${(0, $2KSUA.round)(value, 4)}${currency}`;
};


const $d455a59192b91e87$export$8b453797f8abdd1d = ({ children: children, tooltipContent: tooltipContent, tooltipId: tooltipId, textColor: textColor })=>{
    const hasTooltip = Boolean(tooltipContent && tooltipId);
    const [isOver, setIsOver] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            hasTooltip && isOver && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                id: tooltipId,
                place: "bottom",
                children: tooltipContent
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textColor: textColor || 'dark',
                textWeight: textColor ? 'bold' : 'normal',
                "data-tip": true,
                "data-for": tooltipId,
                onMouseOver: hasTooltip ? ()=>setIsOver(true) : undefined,
                onMouseOut: hasTooltip ? ()=>setIsOver(false) : undefined,
                children: children
            })
        ]
    });
};
const $d455a59192b91e87$export$a489e25971764706 = ({ duration: duration, fallbackText: fallbackText = '- h -', tooltipContent: tooltipContent, tooltipId: tooltipId, textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d455a59192b91e87$export$8b453797f8abdd1d, {
        tooltipContent: tooltipContent,
        tooltipId: tooltipId,
        textColor: textColor,
        children: !duration ? fallbackText : (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(duration)
    });
};
const $d455a59192b91e87$export$f09ee714f6c36863 = ({ date: date, fallbackText: fallbackText = '- h -', textColor: textColor, tooltipContent: tooltipContent, tooltipId: tooltipId })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d455a59192b91e87$export$8b453797f8abdd1d, {
        tooltipContent: tooltipContent,
        tooltipId: tooltipId,
        textColor: textColor,
        children: date ? (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(date) : fallbackText
    });
};
const $d455a59192b91e87$export$7d82fffd1945abd0 = ({ cost: cost, fallbackText: fallbackText = "0\u20AC", textColor: textColor, tooltipContent: tooltipContent, tooltipId: tooltipId, noCostAvailable: noCostAvailable })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d455a59192b91e87$export$8b453797f8abdd1d, {
        tooltipContent: tooltipContent,
        tooltipId: tooltipId,
        textColor: textColor,
        children: cost && !noCostAvailable ? (0, $0798496ba66df318$export$e370a7ddaa2f579a)(cost) : noCostAvailable ? '-' : fallbackText
    });
};
const $d455a59192b91e87$export$da27302eef6199ea = ({ number: number, fallbackText: fallbackText = '0', tooltipContent: tooltipContent, tooltipId: tooltipId, textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($d455a59192b91e87$export$8b453797f8abdd1d, {
        tooltipContent: tooltipContent,
        tooltipId: tooltipId,
        textColor: textColor,
        children: number ? number : fallbackText
    });
};
const $d455a59192b91e87$export$1d20afe38ad9e2c7 = ({ employerRule: employerRule, value: value, textColor: textColor, fallbackTexts: fallbackTexts })=>{
    const Component = employerRule.kind === 'goal' ? $d455a59192b91e87$export$da27302eef6199ea : $d455a59192b91e87$export$a489e25971764706;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(Component, {
        number: value,
        duration: value,
        textColor: textColor,
        fallbackText: fallbackTexts?.[employerRule.kind]
    });
};



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $2KSUA = parcelRequire("2KSUA");
const $4627fcfc0cdb41bc$export$7c96a28adcb64b44 = 1;
const $4627fcfc0cdb41bc$export$c1bc350165fd7d8c = 60;
const $4627fcfc0cdb41bc$export$de2580df8201c8a7 = (clockingRules, converter)=>{
    // Immutability, we don't transform foreign data
    const converted = (0, $2KSUA.cloneDeep)(clockingRules);
    const { start: start, end: end } = converted.rules;
    start.early.tolerance = converter(start.early.tolerance);
    start.late.tolerance = converter(start.late.tolerance);
    end.early.tolerance = converter(end.early.tolerance);
    end.late.tolerance = converter(end.late.tolerance);
    return converted;
};
const $4627fcfc0cdb41bc$export$7c3d324c2bbd48ec = (tolerance)=>{
    return tolerance ? tolerance / 60 / 1000 : 0;
};
const $4627fcfc0cdb41bc$export$9530ed502f35fef4 = (tolerance)=>tolerance ? tolerance * 60000 : 0;
const $4627fcfc0cdb41bc$var$defaultInitialValues = {
    name: '',
    description: '',
    rules: {
        start: {
            early: {
                mode: 'theoritical',
                tolerance: $4627fcfc0cdb41bc$export$7c96a28adcb64b44
            },
            late: {
                mode: 'theoritical',
                tolerance: $4627fcfc0cdb41bc$export$7c96a28adcb64b44
            }
        },
        end: {
            early: {
                mode: 'theoritical',
                tolerance: $4627fcfc0cdb41bc$export$7c96a28adcb64b44
            },
            late: {
                mode: 'theoritical',
                tolerance: $4627fcfc0cdb41bc$export$7c96a28adcb64b44
            }
        }
    },
    workPeriodMatchRange: {
        start: 120,
        end: 240
    },
    break: {
        breakAllowedAfter: 240,
        breakDuration: 30,
        clockingsTolerance: {
            early: 0,
            late: 0
        }
    }
};
const $4627fcfc0cdb41bc$export$634221161cc87802 = (clockingRules)=>{
    let existingClockingRules;
    // We are editing an existing Clocking Rule
    if (clockingRules) {
        // No need for employer and _id
        const { employer: employer, _id: _id, ...rest } = clockingRules //eslint-disable-line
        ;
        // Immutability, we don't transform foreign data
        existingClockingRules = (0, $2KSUA.cloneDeep)(rest);
        // Clocking Rule object has time in milliseconds, the forms works with minutes
        existingClockingRules = $4627fcfc0cdb41bc$export$de2580df8201c8a7(existingClockingRules, $4627fcfc0cdb41bc$export$7c3d324c2bbd48ec);
    }
    const initialValues = Object.assign({}, // Immutability, we don't transform foreign data
    (0, $2KSUA.cloneDeep)($4627fcfc0cdb41bc$var$defaultInitialValues), existingClockingRules);
    return initialValues;
};


const $e22e0a62f76978b8$var$ClockingRulesDescription = ({ clockingRules: clockingRules, type: type, small: small })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
        style: {
            whiteSpace: 'nowrap'
        },
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                children: [
                    small ? 'En avance' : 'Je suis en avance, on prend en compte :',
                    ' ',
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                        children: (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).clockings[clockingRules.rules[type].early.mode]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    clockingRules.rules[type].early.tolerance !== 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\u2937 ",
                            small ? "Tol\xe9rance" : 'Sauf si avance de moins de',
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("b", {
                                children: [
                                    (0, $4627fcfc0cdb41bc$export$7c3d324c2bbd48ec)(clockingRules.rules[type].early.tolerance),
                                    " min"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                children: [
                    small ? 'En retard' : 'Je suis en retard, on prend en compte :',
                    ' ',
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                        children: (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).clockings[clockingRules.rules[type].late.mode]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    clockingRules.rules[type].late.tolerance !== 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\u2937 ",
                            small ? "Tol\xe9rance" : 'Sauf si retard de moins de',
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("b", {
                                children: [
                                    (0, $4627fcfc0cdb41bc$export$7c3d324c2bbd48ec)(clockingRules.rules[type].late.tolerance),
                                    " min"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e22e0a62f76978b8$export$2e2bcd8739ae039 = $e22e0a62f76978b8$var$ClockingRulesDescription;





var $3ZYaX = parcelRequire("3ZYaX");
function $f94c5f99d3da5dc6$var$UserCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
        clipRule: "evenodd"
    }));
}
const $f94c5f99d3da5dc6$var$ForwardRef = $3ZYaX.forwardRef($f94c5f99d3da5dc6$var$UserCircleIcon);
var $f94c5f99d3da5dc6$export$2e2bcd8739ae039 = $f94c5f99d3da5dc6$var$ForwardRef;



const $308c1cd63178b19b$var$countedLabels = {
    theoretical: "Th\xe9orique",
    clocked: 'Pointage',
    manual: "Corrig\xe9"
};
/**
 * Composant pour afficher un commentaire de période de travail avec l'avatar de l'utilisateur
 */ const $308c1cd63178b19b$var$WorkPeriodComment = ({ comment: comment })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            comment?.message,
            " ",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
            comment?.user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: "small",
                        style: {
                            verticalAlign: 'middle'
                        },
                        mr: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f94c5f99d3da5dc6$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                        user: comment.user
                    })
                ]
            })
        ]
    });
/**
 * Composant pour afficher une valeur formatée ou un placeholder
 */ const $308c1cd63178b19b$var$FormattedValue = ({ value: value, formatter: formatter })=>{
    if (!value) return '/';
    return formatter ? formatter(value) : String(value);
};
const $308c1cd63178b19b$export$98d2b46eb2bc391a = ({ workPeriod: workPeriod, type: type })=>{
    const benefitEvents = (0, $dda2f26c3659cf93$export$e36670b33a845a88)(workPeriod, 'benefit');
    const workPeriodHasBenefitEvent = Boolean(benefitEvents.length);
    const summary = workPeriod.summary[type];
    const items = [
        {
            label: "Calcul\xe9",
            value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($308c1cd63178b19b$var$FormattedValue, {
                value: summary.counted,
                formatter: (v)=>$308c1cd63178b19b$var$countedLabels[v]
            })
        },
        {
            label: 'Pointage',
            value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($308c1cd63178b19b$var$FormattedValue, {
                value: summary.clocked,
                formatter: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)
            })
        },
        {
            label: "Corrig\xe9",
            value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($308c1cd63178b19b$var$FormattedValue, {
                value: summary.manual,
                formatter: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)
            })
        },
        {
            label: "Th\xe9orique",
            value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($308c1cd63178b19b$var$FormattedValue, {
                value: summary.theoretical,
                formatter: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)
            })
        },
        {
            label: 'Commentaire',
            value: summary.lastComment ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($308c1cd63178b19b$var$WorkPeriodComment, {
                comment: summary.lastComment
            }) : '/'
        }
    ];
    if (workPeriodHasBenefitEvent) items.push({
        label: "Ev\xe9n. Prestation",
        value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            textWeight: "bold",
            children: benefitEvents.map((e)=>e.item.code).join(', ')
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            items.map((item)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    py: 1,
                    style: {
                        display: 'table-row'
                    },
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            style: {
                                display: 'table-cell'
                            },
                            px: 1,
                            children: item.label
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            style: {
                                display: 'table-cell'
                            },
                            px: 1,
                            children: item.value
                        })
                    ]
                }, item.label)),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mt: 3,
                textWeight: "bold",
                children: workPeriod.clockingRules.name
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                clockingRules: workPeriod.clockingRules,
                type: type
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mt: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        textWeight: "bold",
                        children: "Affectation :"
                    }),
                    ' ',
                    workPeriod.service?.name
                ]
            })
        ]
    });
};





var $3ZYaX = parcelRequire("3ZYaX");





/**
 * Reusable link component for work periods.
 *
 * - Real WP: renders a standard <Link> to the detail page.
 * - Virtual WP: on click, calls materializeSingleDay to persist the WP,
 *   then navigates to the newly created WP's detail page.
 *   If the backend returns null (no slot for that day), does nothing.
 */ const $86213dc9c75e3746$var$WorkPeriodLink = ({ workPeriod: workPeriod, children: children, className: className, style: style, textColor: textColor = 'dark' })=>{
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const materialize = (0, $7040c29cc25c4df6$export$8f6c4d8eb9ae77b1)();
    const missionId = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission);
    /** Build the detail page URL for a given (real) work period ID. */ const buildUrl = (wpId)=>`/missions/${missionId}/work-periods/${wpId}`;
    /** Handle click on a virtual work period: materialize then navigate. */ const handleVirtualClick = (0, $3ZYaX.useCallback)(async (e)=>{
        e.preventDefault();
        console.log('handleVirtualClick', e);
        if (materialize.isLoading) return;
        const result = await materialize.mutateAsync({
            missionId: missionId,
            date: new Date(workPeriod.start.date).toISOString()
        });
        // The API response is unwrapped by the query client select: result is the data directly
        const materializedWp = result?.data;
        if (materializedWp) navigate(buildUrl((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(materializedWp)));
    }, [
        missionId,
        workPeriod.start.date,
        materialize,
        navigate
    ]);
    // Virtual work period: render a clickable element that materializes on click
    if ((0, $dda2f26c3659cf93$export$f611ca713280ca2d)(workPeriod)) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "a",
        textColor: textColor,
        className: className,
        style: {
            cursor: materialize.isLoading ? 'wait' : 'pointer',
            ...style
        },
        onClick: handleVirtualClick,
        children: children
    });
    // Real work period: standard router Link
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
        to: buildUrl((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod)),
        textColor: textColor,
        className: className,
        style: style,
        children: children
    });
};
var $86213dc9c75e3746$export$2e2bcd8739ae039 = $86213dc9c75e3746$var$WorkPeriodLink;


const $2ac56eaf11a5826b$var$WorkPeriodList = ({ workPeriods: workPeriods, keys: keys = [
    'user',
    'day',
    'dates',
    'counted',
    'events',
    'interimAgency',
    'employer',
    'service',
    'jobTitle',
    'mission.dates',
    'isValidated',
    'isAbandoned',
    'validateAction'
], omitKeys: omitKeys = [] })=>{
    const columns = $2ac56eaf11a5826b$export$30d7ff70e98dac80();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fa2fec5ba94be96$export$c1fc27c145fcfcb9), {
        columns: columns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(workPeriods, 'mission.user.lastName'),
        keys: keys,
        omitKeys: omitKeys,
        noDataMessage: "Aucune journ\xe9e de travail \xe0 afficher"
    });
};
const $2ac56eaf11a5826b$export$30d7ff70e98dac80 = ()=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentUserRole);
    const workPeriodValidateMutation = (0, $7040c29cc25c4df6$export$6cbf757d2bdf6301)();
    const columns = {
        user: {
            Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
            accessor: (data)=>data.clockingRules._id,
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                    to: `/workers/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.user)}`,
                    textColor: "primary",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        style: {
                            whiteSpace: 'nowrap'
                        },
                        children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(workPeriod.user)
                    })
                });
            }
        },
        day: {
            Header: 'Jour',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                            roles: [
                                'employerMember'
                            ],
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $86213dc9c75e3746$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod,
                                textColor: "primary",
                                children: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(new Date(workPeriod.start.date))
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                            roles: [
                                'worker',
                                'interimAgencyMember'
                            ],
                            children: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(new Date(workPeriod.start.date))
                        })
                    ]
                });
            }
        },
        dates: {
            Header: 'Horaire',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            textColor: "dark",
                            children: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(new Date(workPeriod.start.date))
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            textColor: "dark",
                            children: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(new Date(workPeriod.end.date))
                        })
                    ]
                });
            },
            width: 1
        },
        counted: {
            Header: "Prest\xe9",
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                const startCellData = (0, $dda2f26c3659cf93$export$820ff448dbc5a915)(workPeriod, 'start');
                const endCellData = (0, $dda2f26c3659cf93$export$820ff448dbc5a915)(workPeriod, 'end');
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$f09ee714f6c36863), {
                            date: startCellData.date,
                            textColor: startCellData.color,
                            tooltipId: startCellData.tooltipId,
                            tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $308c1cd63178b19b$export$98d2b46eb2bc391a), {
                                workPeriod: workPeriod,
                                type: "start"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$f09ee714f6c36863), {
                            date: endCellData.date,
                            textColor: endCellData.color,
                            tooltipId: endCellData.tooltipId,
                            tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $308c1cd63178b19b$export$98d2b46eb2bc391a), {
                                workPeriod: workPeriod,
                                type: "end"
                            })
                        })
                    ]
                });
            },
            width: 1
        },
        interimAgency: currentUserRole !== 'interimAgencyMember' ? {
            Header: 'Agence',
            id: 'interimAgency',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return workPeriod.mission.interimAgency?.name ?? null;
            }
        } : null,
        employer: currentUserRole !== 'employerMember' ? {
            Header: 'EU',
            id: 'employer',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return workPeriod.mission.employer?.name || ' ';
            }
        } : null,
        service: {
            Header: 'Affectation',
            id: 'service',
            accessor: 'service.name'
        },
        jobTitle: {
            Header: "M\xe9tier",
            id: 'jobTitle',
            accessor: 'mission.jobTitle.name'
        },
        isValidated: {
            Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$42e76898d8f52841), {
                workPeriod: {
                    isValidated: true
                },
                type: "icon",
                small: true,
                iconColor: 'dark'
            }),
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$42e76898d8f52841), {
                        workPeriod: workPeriod,
                        type: "icon",
                        small: true
                    })
                });
            },
            width: 1
        },
        isAbandoned: {
            Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$b89ed0bd7f7384f6), {
                workPeriod: {
                    isAbandoned: true
                },
                type: "icon",
                small: true,
                iconColor: 'dark'
            }),
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$b89ed0bd7f7384f6), {
                    workPeriod: workPeriod,
                    type: "icon",
                    small: true
                });
            },
            width: 1
        },
        isCancelled: {
            Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$18721b912cdbc3ff), {
                workPeriod: {
                    isCancelled: true
                },
                type: "icon",
                small: true,
                iconColor: 'dark'
            }),
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$18721b912cdbc3ff), {
                    workPeriod: workPeriod,
                    type: "icon",
                    small: true
                });
            },
            width: 1
        },
        'mission.dates': {
            Header: 'Mission',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workPeriod.mission.start),
                        "\xa0-\xa0",
                        workPeriod.mission.end ? (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workPeriod.mission.end) : '/'
                    ]
                });
            }
        },
        events: {
            Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$8d6fc50e3f3f6bf5), {
                workPeriod: {
                    events: [
                        {
                            //@ts-expect-error force display
                            item: {}
                        }
                    ]
                },
                type: "icon",
                small: true,
                iconColor: 'dark',
                text: "Ev\xe8nements"
            }),
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$8d6fc50e3f3f6bf5), {
                        workPeriod: workPeriod,
                        type: "icon",
                        small: true
                    })
                });
            }
        },
        validateAction: {
            Header: 'Valider',
            Cell: (data)=>{
                const workPeriod = data.cell.row.original;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'employerMember'
                    ],
                    action: {
                        resource: 'missions',
                        name: 'validateWorkPeriod'
                    },
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $801415e870a9139e$export$2e2bcd8739ae039), {
                        workPeriod: workPeriod,
                        size: "smallest",
                        onClick: ()=>{
                            workPeriodValidateMutation.mutate({
                                workPeriodId: workPeriod._id,
                                isValidated: !workPeriod.isValidated
                            });
                        }
                    })
                });
            }
        }
    };
    return columns;
};
var $2ac56eaf11a5826b$export$2e2bcd8739ae039 = $2ac56eaf11a5826b$var$WorkPeriodList;





const $7c4f4480d5176db2$var$MissionDetails = ()=>{
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: mission } = (0, $e409591b67738e56$export$8940e75313b372c9)(id);
    const isInterimAgencyMission = Boolean(mission !== undefined && 'interimAgency' in mission);
    const { data: workersRequest } = (0, $b8c6247768bd4102$export$5084421b5a71fe52)({
        'posts.missions': mission?._id
    }, {
        enabled: Boolean(isInterimAgencyMission)
    });
    const workPeriodsDefinition = (0, $2ac56eaf11a5826b$export$30d7ff70e98dac80)();
    /** Selected week for the work periods list (IsoDate = any day in the week). Defaults to first week of mission. */ const [selectedWeekIso, setSelectedWeekIso] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('');
    const linkedWorkersRequestId = workersRequest?.[0]?._id;
    const effectiveWeekIso = mission ? selectedWeekIso || (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(mission.start)) : undefined;
    const weekRange = effectiveWeekIso ? (0, $74f17ceb9b5a08a5$export$217584d147ca6846)(effectiveWeekIso) : null;
    const { data: workPeriods } = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)({
        mission: id,
        summary: true,
        ...weekRange ? {
            start: weekRange.start,
            end: weekRange.end
        } : {}
    }, {
        enabled: Boolean(id) && Boolean(mission)
    });
    const breadcrumbs = $7c4f4480d5176db2$var$useBreadcrumbs(id);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (isNew) navigate('/') // TODO: TEMP quickfix to prevent going to the mission creation page
        ;
    }, [
        isNew
    ]);
    const historyItems = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return (0, $2KSUA.sortBy)(mission?.history || [], 'createdAt').reverse();
    }, [
        mission
    ]);
    const hasCancelledEndDate = mission?.isCancelled && mission?.history?.find((h)=>h.action === 'missionCancelled')?.changes?.find((c)=>c.attribute === 'mission.end')?.oldValue;
    if (!mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    max: true,
                    breakpoint: "widescreen",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                        items: breadcrumbs
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    align: "right",
                                    children: !isNew && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a3fff9dbe3c5b2d1$export$9eb9467136ef56ff), {
                                        mission: mission
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                            alignItems: "flex-start",
                            mb: 6,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a3fff9dbe3c5b2d1$export$2e2bcd8739ae039), {
                                        mission: mission,
                                        organizationType: isInterimAgencyMission ? 'interimAgency' : 'employer'
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    align: "right",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$2e2bcd8739ae039), {
                                            mission: mission,
                                            type: "tag"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                            roles: [
                                'interimAgencyMember',
                                'employerMember'
                            ],
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 4,
                                    children: "Actions"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $df9437b988a4a000$export$2e2bcd8739ae039), {
                                                mission: mission
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textAlign: 'right',
                                    mt: 2,
                                    children: linkedWorkersRequestId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                        to: `/workers/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(mission.user)}`,
                                        children: "Voir la fiche du travailleur"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                            mt: 6,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        size: 5,
                                        children: `Du ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(mission.start)} ${mission.end ? `au ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(mission.end)}` : ''}`
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                                        mb: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                            children: "Semaine"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                                type: "date",
                                                                value: effectiveWeekIso,
                                                                onChange: (e)=>setSelectedWeekIso(e.target.value || ''),
                                                                min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(mission.start),
                                                                max: mission.end && (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(mission.end),
                                                                name: "week"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fa2fec5ba94be96$export$c1fc27c145fcfcb9), {
                                        columns: workPeriodsDefinition,
                                        data: workPeriods ?? [],
                                        keys: [
                                            'day',
                                            'dates',
                                            'counted',
                                            'events',
                                            'isAbandoned',
                                            'isValidated',
                                            'validateAction'
                                        ],
                                        noDataMessage: "Aucune journ\xe9e de travail pour cette semaine"
                                    }),
                                    hasCancelledEndDate && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        textColor: "grey",
                                        textAlign: 'center',
                                        children: [
                                            "Cette mission a \xe9t\xe9 interrompue, elle \xe9tait initialement pr\xe9vue jusqu'au",
                                            ' ',
                                            (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(hasCancelledEndDate)
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            textAlign: 'right',
                            mt: 2,
                            children: linkedWorkersRequestId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                to: `/workers-requests/${linkedWorkersRequestId}`,
                                children: "Voir la demande"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    max: true,
                    breakpoint: "desktop",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                            size: 4,
                            mt: 5,
                            children: "Historique"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d21fe120a7200937$export$2e2bcd8739ae039), {
                            items: historyItems,
                            locales: (0, $ab3fa70a0ca06441$export$2e2bcd8739ae039).history
                        })
                    ]
                })
            })
        ]
    });
};
var $7c4f4480d5176db2$export$2e2bcd8739ae039 = $7c4f4480d5176db2$var$MissionDetails;
const $7c4f4480d5176db2$var$useBreadcrumbs = (missionId)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: 'Liste des missions',
                to: '/missions'
            },
            {
                label: `Mission`,
                to: `/missions/${missionId}`
            }
        ], [
        missionId
    ]);



parcelRequire("3ZYaX");




var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");







parcelRequire("3ZYaX");


const $757b38d3bc5e98e6$var$CheckboxField = (props)=>{
    const { field: field, form: form, label: label, help: help, info: info, ...rest } = props;
    if (props.field.value === undefined) props.field.value = '';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        help: help,
        error: form.errors[field.name],
        info: info,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
            ...field,
            ...rest,
            checked: props.field.value,
            children: props.text
        })
    });
};
var $757b38d3bc5e98e6$export$2e2bcd8739ae039 = $757b38d3bc5e98e6$var$CheckboxField;



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

parcelRequire("3ZYaX");


const $c7f97019e02e0444$var$SelectField = (props)=>{
    const { field: field, form: form, options: options, selectDefaultChooseOptionLabel: selectDefaultChooseOptionLabel, ...rest } = props;
    const { required: required } = rest;
    // Force la réinitialisation en utilisant une clé unique basée sur la valeur
    const selectKey = field?.value || 'empty';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: props.label,
        error: form?.errors[field?.name],
        help: props.help,
        required: required,
        info: props.info,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
            ...field || {},
            ...rest,
            value: field?.value || '',
            className: field?.value ? 'is-not-empty' : 'is-empty',
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                    style: {
                        display: 'none'
                    },
                    value: "",
                    children: selectDefaultChooseOptionLabel ?? 'Choisir une option'
                }),
                options.map((option)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                        value: option.value,
                        children: option.label
                    }, option.value))
            ]
        }, selectKey)
    });
};
var $c7f97019e02e0444$export$2e2bcd8739ae039 = $c7f97019e02e0444$var$SelectField;



const $e42b7b92e62c9bf4$var$DisplayedDaysFilterField = ({ start: start, end: end })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Jour affich\xe9",
            name: "displayDay",
            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
            options: (0, $74f17ceb9b5a08a5$export$5d73a3fd931619b8)((0, $74f17ceb9b5a08a5$export$df05c8d7c056b9c6)(start, end))
        })
    });
};
var $e42b7b92e62c9bf4$export$2e2bcd8739ae039 = $e42b7b92e62c9bf4$var$DisplayedDaysFilterField;




parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");




const $d6ff98716203f8d8$var$ServiceFilterField = ({ disabledQueries: disabledQueries, queriesStaleTime: queriesStaleTime, employerIds: employerIds, tooltip: tooltip })=>{
    const servicesQuery = (0, $3d856666402e8eec$export$a870673e4b33fcfb)({
        employer: employerIds
    }, {
        enabled: !disabledQueries,
        staleTime: queriesStaleTime
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            "data-tooltip": tooltip,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                label: "Affectation",
                name: "service",
                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(servicesQuery.data || []),
                disabled: !servicesQuery.data || !servicesQuery.data[0]
            })
        })
    });
};
var $d6ff98716203f8d8$export$2e2bcd8739ae039 = $d6ff98716203f8d8$var$ServiceFilterField;



parcelRequire("3ZYaX");




var $31tXu = parcelRequire("31tXu");




const $f0afbbe4db390668$var$OrganizationFilterField = ({ type: type, disabledQueries: disabledQueries, queriesStaleTime: queriesStaleTime, singleSelect: singleSelect, doNotShowCurrentOrganization: doNotShowCurrentOrganization, label: label })=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const organizationsQuery = (0, $58f46cb3f921014b$export$3a621c77e84e6f17)({
        enabled: !disabledQueries,
        staleTime: queriesStaleTime
    });
    const options = (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(organizationsQuery.data || []);
    if (currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer && !doNotShowCurrentOrganization) options.push({
        label: currentOrganization.name,
        value: null
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: label || (type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'Entreprises Utilisatrices' : 'Employeur'),
            name: type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'employer' : 'interimAgency',
            component: singleSelect ? (0, $c7f97019e02e0444$export$2e2bcd8739ae039) : (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: options
        })
    });
};
var $f0afbbe4db390668$export$2e2bcd8739ae039 = $f0afbbe4db390668$var$OrganizationFilterField;




parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");




const $6a4ee754151158e4$var$POPULATE = [
    'employer',
    'clockingRule'
];
const $6a4ee754151158e4$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/job-titles',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $6a4ee754151158e4$var$POPULATE,
            ...params || {}
        }
    });
const $6a4ee754151158e4$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/job-titles/${id}`,
        method: 'get'
    });
const $6a4ee754151158e4$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/job-titles',
        method: 'post',
        params: params
    });
const $6a4ee754151158e4$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/job-titles/${id}`,
        method: 'put',
        params: payload
    });
};


const $b5014031ea60dfe7$export$15dd7c0b0ff20c77 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('job-titles', (0, $6a4ee754151158e4$export$3988ae62b71be9a3), id, undefined, options);
const $b5014031ea60dfe7$export$76743b414a2ccf63 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('job-titles', (0, $6a4ee754151158e4$export$e7aa7bc5c1b3cfb3), filters, options);
//Mutations
const $b5014031ea60dfe7$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'job-titles'
    ]);
};
const $b5014031ea60dfe7$export$4a6f974b4208311 = ()=>[
        'job-titles',
        'create'
    ];
const $b5014031ea60dfe7$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $6a4ee754151158e4$export$185802fd694ee1f5), {
        mutationKey: $b5014031ea60dfe7$export$4a6f974b4208311(),
        onSuccess: $b5014031ea60dfe7$var$onMutationSuccess
    });
const $b5014031ea60dfe7$export$a6fe4df8bec26327 = ()=>[
        'job-titles',
        'update'
    ];
const $b5014031ea60dfe7$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $6a4ee754151158e4$export$722fbec263ad908a), {
        mutationKey: $b5014031ea60dfe7$export$a6fe4df8bec26327(),
        onSuccess: $b5014031ea60dfe7$var$onMutationSuccess
    });





const $a91952dde0b07a58$var$JobTitleFilterField = ({ disabledQueries: disabledQueries, queriesStaleTime: queriesStaleTime, employerIds: employerIds, tooltip: tooltip })=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)(currentUserRole === 'interimAgencyMember' ? {
        employer: employerIds
    } : {}, {
        enabled: !disabledQueries && (currentUserRole === 'employerMember' || Boolean(employerIds)),
        staleTime: queriesStaleTime || 120000
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            "data-tooltip": tooltip,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                label: "M\xe9tier",
                name: "jobTitle",
                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                disabled: !jobTitlesQuery.data || !jobTitlesQuery.data[0],
                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(jobTitlesQuery.data || [])
            })
        })
    });
};
var $a91952dde0b07a58$export$2e2bcd8739ae039 = $a91952dde0b07a58$var$JobTitleFilterField;





parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $6b26f08d92179eff$var$IsCancelledFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Annul\xe9e",
            name: "isCancelled",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: [
                {
                    label: 'Oui',
                    value: true
                },
                {
                    label: 'Non',
                    value: false
                }
            ]
        })
    });
};
var $6b26f08d92179eff$export$2e2bcd8739ae039 = $6b26f08d92179eff$var$IsCancelledFilterField;



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $648b3f982a9c45a8$var$IsPrebilledFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Pr\xe9-Factur\xe9",
            name: "periodSummary",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: [
                {
                    label: 'Oui',
                    value: true
                },
                {
                    label: 'Non',
                    value: false
                }
            ]
        })
    });
};
var $648b3f982a9c45a8$export$2e2bcd8739ae039 = $648b3f982a9c45a8$var$IsPrebilledFilterField;





parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");





const $3796b000fb1eb723$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/work-period-tags',
        method: 'get',
        params: {
            sort: '-createdAt',
            ...params || {}
        }
    });
const $3796b000fb1eb723$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-period-tags/${id}`,
        method: 'get'
    });
const $3796b000fb1eb723$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/work-period-tags',
        method: 'post',
        params: params
    });
const $3796b000fb1eb723$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/work-period-tags/${id}`,
        method: 'put',
        params: payload
    });
};


const $b9e4dc58c86ce67a$export$ba92cb2035b0c508 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('work-period-tags', (0, $3796b000fb1eb723$export$3988ae62b71be9a3), id, undefined, options);
const $b9e4dc58c86ce67a$export$9a06e401dcb665a = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('work-period-tags', (0, $3796b000fb1eb723$export$e7aa7bc5c1b3cfb3), filters, options);
//Mutations
const $b9e4dc58c86ce67a$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'work-period-tags'
    ]);
};
const $b9e4dc58c86ce67a$export$4a6f974b4208311 = ()=>[
        'work-period-tags',
        'create'
    ];
const $b9e4dc58c86ce67a$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $3796b000fb1eb723$export$185802fd694ee1f5), {
        mutationKey: $b9e4dc58c86ce67a$export$4a6f974b4208311(),
        onSuccess: $b9e4dc58c86ce67a$var$onMutationSuccess
    });
const $b9e4dc58c86ce67a$export$a6fe4df8bec26327 = ()=>[
        'work-period-tags',
        'update'
    ];
const $b9e4dc58c86ce67a$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $3796b000fb1eb723$export$722fbec263ad908a), {
        mutationKey: $b9e4dc58c86ce67a$export$a6fe4df8bec26327(),
        onSuccess: $b9e4dc58c86ce67a$var$onMutationSuccess
    });
const $b9e4dc58c86ce67a$export$ae1bb9b0051ee212 = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'work-period-tags'
    ]);
};



/**
 * Component for filtering work period tags in a multi-select field
 * Uses work period tags data from the API
 */ const $2cec1859b1e37596$var$WorkPeriodTagsFilterField = ({ disabledQueries: disabledQueries, queriesStaleTime: queriesStaleTime, employerIds: employerIds, disabled: disabled, tooltip: tooltip })=>{
    const tagsQuery = (0, $b9e4dc58c86ce67a$export$9a06e401dcb665a)({
        employer: employerIds
    }, {
        enabled: !disabledQueries,
        staleTime: queriesStaleTime
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            "data-tooltip": tooltip,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                label: "Cat\xe9gories",
                name: "tags",
                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(tagsQuery.data || [], {
                    labelKeyPath: 'name'
                }),
                disabled: disabled
            })
        })
    });
};
var $2cec1859b1e37596$export$2e2bcd8739ae039 = $2cec1859b1e37596$var$WorkPeriodTagsFilterField;


const $efaf9714fbe282ce$var$MissionsFilters = ({ showDayFilter: showDayFilter, showSummaryMinimalModeFilter: showSummaryMinimalModeFilter, showEventsFilter: showEventsFilter, disabledQueries: disabledQueries })=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions);
    const queriesStaleTime = 120000 // 2 min
    ;
    const { start: start, end: end, ...missionFilters } = filters;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...missionFilters,
            week: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(filters.start)
        },
        onSubmit: (values)=>{
            const { week: week, displayDay: displayDayFormValue, ...missionFilters } = values;
            const { start: start, end: end } = (0, $74f17ceb9b5a08a5$export$217584d147ca6846)(week);
            let displayDay = displayDayFormValue;
            if (week !== (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(filters.start)) // We reset the filter on week change
            // if not, the view is stuck with an invalid displayDay value
            displayDay = undefined;
            if ((0, $8403deec6a28521e$export$6025088343704f9f)([
                'interimAgencyMember'
            ])) {
                if (filters.employer?.length !== 1) {
                    missionFilters.jobTitle = [];
                    missionFilters.service = [];
                    missionFilters.tags = [];
                }
            }
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions, {
                ...missionFilters,
                start: start,
                end: end,
                displayDay: displayDay
            });
        },
        enableReinitialize: true,
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions,
                preservedFields: [
                    'summaryMinimalMode'
                ],
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ba4a55bdb1b56879$export$2e2bcd8739ae039), {}),
                            showDayFilter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e42b7b92e62c9bf4$export$2e2bcd8739ae039), {
                                start: filters.start,
                                end: filters.end
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember',
                                    'interimAgencyMember'
                                ],
                                children: showSummaryMinimalModeFilter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: 'Mode compact',
                                        text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "small",
                                            children: "Donn\xe9es r\xe9sum\xe9es"
                                        }),
                                        name: "summaryMinimalMode",
                                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                        "data-test": "summaryMinimalModeCheckbox"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember',
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $992ecbd31670e2eb$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime,
                                    type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime,
                                    employerIds: filters.employer
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {
                                    disabledQueries: Boolean(disabledQueries || filters.employer?.length !== 1),
                                    queriesStaleTime: queriesStaleTime,
                                    employerIds: filters.employer,
                                    tooltip: filters.employer?.length !== 1 ? 'Selectionnez un seul employeur pour pouvoir utiliser ce filtre' : undefined
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime,
                                    type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime,
                                    employerIds: filters.employer
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {
                                    disabledQueries: Boolean(disabledQueries || filters.employer?.length !== 1),
                                    queriesStaleTime: queriesStaleTime,
                                    employerIds: filters.employer,
                                    tooltip: filters.employer?.length !== 1 ? 'Selectionnez un seul employeur pour pouvoir utiliser ce filtre' : undefined
                                })
                            }),
                            showEventsFilter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e2afd48e3c6e79e0$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime,
                                    labels: {
                                        allAbsences: 'Avec absence',
                                        allPresences: "Avec pr\xe9sence"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2cec1859b1e37596$export$2e2bcd8739ae039), {
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2cec1859b1e37596$export$2e2bcd8739ae039), {
                                    disabledQueries: Boolean(disabledQueries || filters.employer?.length !== 1),
                                    queriesStaleTime: queriesStaleTime,
                                    employerIds: filters.employer,
                                    disabled: filters.employer?.length !== 1,
                                    tooltip: filters.employer?.length !== 1 ? 'Selectionnez un seul employeur pour pouvoir utiliser ce filtre' : undefined
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember',
                                    'interimAgencyMember'
                                ],
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $648b3f982a9c45a8$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6b26f08d92179eff$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $efaf9714fbe282ce$export$2e2bcd8739ae039 = $efaf9714fbe282ce$var$MissionsFilters;











var $3ZYaX = parcelRequire("3ZYaX");








/**
 * Component to display a list of missions in a table
 */ const $02d12f0e24347738$var$MissionsList = ({ missions: missions })=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const tableColumns = $02d12f0e24347738$var$useListTableColumns(missions, currentUserRole);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: missions,
        noDataMessage: "Aucune mission \xe0 afficher"
    });
};
// Hook pour les colonnes du tableau
const $02d12f0e24347738$var$useListTableColumns = (missions, currentUserRole)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const columns = [
            {
                Header: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                id: 'user',
                accessor: (mission)=>mission.user.firstName,
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember',
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                    to: `/missions/${mission._id}`,
                                    children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(mission.user)
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'worker'
                                ],
                                children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(mission.user)
                            })
                        ]
                    });
                }
            },
            currentUserRole !== 'interimAgencyMember' && {
                Header: 'Agence',
                accessor: 'interimAgency',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    if ('interimAgency' in mission) return mission.interimAgency?.name;
                    else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: "Non"
                    });
                }
            },
            currentUserRole !== 'employerMember' && {
                Header: 'Employeur',
                accessor: 'employer',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return mission.employer?.name || ' ';
                }
            },
            {
                Header: 'Affectation',
                accessor: 'service',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return mission.service.name || ' ';
                }
            },
            {
                Header: "M\xe9tier",
                accessor: (mission)=>mission.jobTitle.name
            },
            {
                Header: "D\xe9but",
                accessor: 'start',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(mission.start);
                }
            },
            {
                Header: 'Fin',
                accessor: 'end',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return mission.end ? (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(mission.end) : '/';
                }
            },
            currentUserRole !== 'worker' && {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$54eb6f08aa91b890), {
                    mission: {
                        isValidated: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: 'dark'
                }),
                accessor: 'isValidated',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$54eb6f08aa91b890), {
                        mission: mission,
                        type: "icon",
                        small: true
                    });
                },
                width: 1
            },
            currentUserRole !== 'worker' && {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                    mission: {
                        isAbandoned: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: 'dark'
                }),
                accessor: 'isAbandoned',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                        mission: mission,
                        type: "icon",
                        small: true
                    });
                },
                width: 1
            },
            currentUserRole !== 'worker' && {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                    mission: {
                        isCancelled: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: 'dark'
                }),
                accessor: 'isCancelled',
                Cell: (data)=>{
                    const mission = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                        mission: mission,
                        type: "icon",
                        small: true
                    });
                },
                width: 1
            }
        ];
        // .filter(c => c) not working with TS inference
        return columns.flatMap((c)=>c ? [
                c
            ] : []);
    }, [
        missions,
        currentUserRole
    ]);
var $02d12f0e24347738$export$2e2bcd8739ae039 = $02d12f0e24347738$var$MissionsList;


const $4357da94769bbff7$var$MissionsList = ()=>{
    const { filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions);
    const query = (0, $e409591b67738e56$export$6ae450315cbb235e)({
        ...filters,
        populate: [
            'user',
            'employer',
            'interimAgency',
            'jobTitle',
            'tags',
            'service'
        ],
        summary: null
    });
    const action = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
        roles: [
            'employerMember'
        ],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $194abd50ec8a5014$export$2e2bcd8739ae039), {
            options: [
                {
                    organizationType: 'employer',
                    option: 'biPart'
                }
            ],
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                to: "/missions/new",
                color: "primary",
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e6bbbb3e7ab26126), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        children: "Nouvelle Mission Interne"
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71db929d54fcb96$export$2e2bcd8739ae039), {
        title: "Liste des Missions",
        subtitle: "Liste de toutes les missions tri\xe9es par semaine",
        action: action,
        filters: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $efaf9714fbe282ce$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $02d12f0e24347738$export$2e2bcd8739ae039), {
            missions: query.data || []
        })
    });
};
var $4357da94769bbff7$export$2e2bcd8739ae039 = $4357da94769bbff7$var$MissionsList;





var $3ZYaX = parcelRequire("3ZYaX");
function $a6ba75b56dc677fb$var$DocumentAddIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm5 6a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V8z",
        clipRule: "evenodd"
    }));
}
const $a6ba75b56dc677fb$var$ForwardRef = $3ZYaX.forwardRef($a6ba75b56dc677fb$var$DocumentAddIcon);
var $a6ba75b56dc677fb$export$2e2bcd8739ae039 = $a6ba75b56dc677fb$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");

const $8f82d3bbdc504683$var$ComponentHeader = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
        mb: 5,
        ...rest,
        children: children
    });
const $8f82d3bbdc504683$var$Left = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        children: children
    });
const $8f82d3bbdc504683$var$Right = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        narrow: true,
        children: children
    });
$8f82d3bbdc504683$var$ComponentHeader.Left = $8f82d3bbdc504683$var$Left;
$8f82d3bbdc504683$var$ComponentHeader.Right = $8f82d3bbdc504683$var$Right;
var $8f82d3bbdc504683$export$2e2bcd8739ae039 = $8f82d3bbdc504683$var$ComponentHeader;



parcelRequire("3ZYaX");

const $ef5abab7d7fe89ed$var$PageHeading = ({ title: title, subtitle: subtitle, ...rest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
        size: 'small',
        ...rest,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    textColor: "primary",
                    children: title
                }),
                subtitle && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    subtitle: true,
                    renderAs: "p",
                    children: subtitle
                })
            ]
        })
    });
};
var $ef5abab7d7fe89ed$export$2e2bcd8739ae039 = $ef5abab7d7fe89ed$var$PageHeading;







parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");







var $3ZYaX = parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");



const $09fb06a5ea2f8067$export$3e2fc1eaa5ec0e7e = ()=>{
    const { values: { addresses: addresses }, errors: errors, validate: validate } = (0, $31tXu.useFormikContext)();
    const [newAddress, setNewAddress] = (0, $3ZYaX.useState)('');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                mt: 6,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                        children: "Adresses"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                        mb: 2,
                        children: "La premi\xe8re adresse de la liste est l'adresse par d\xe9faut"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                            name: "addresses",
                            children: ({ swap: swap, push: push, remove: remove })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        addresses.map((address, index)=>{
                                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                kind: "addons",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        fullwidth: true,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            name: `addresses[${index}]`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            required: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            type: "button",
                                                            disabled: index === 0,
                                                            onClick: ()=>swap(index - 1, index),
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f1a507b991affc46), {})
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            type: "button",
                                                            disabled: index === addresses.length - 1,
                                                            onClick: ()=>swap(index, index + 1),
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1c939d3c9b6931b), {})
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            type: "button",
                                                            onClick: ()=>remove(index),
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, index);
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                            kind: "addons",
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                    fullwidth: true,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                        name: "address",
                                                        value: newAddress,
                                                        onChange: (e)=>setNewAddress(e.target.value)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                        onClick: ()=>{
                                                            push(newAddress);
                                                            setNewAddress('');
                                                        },
                                                        disabled: !newAddress,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                            children: "Ajouter"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                textSize: 6,
                color: 'danger',
                children: errors.addresses
            })
        ]
    });
};


const $d811c3042d321ad2$var$AgencyInfosForm = ({ interimAgency: interimAgency })=>{
    const createMutation = (0, $58f46cb3f921014b$export$a25726670bb41cb)();
    const updateMutation = (0, $58f46cb3f921014b$export$cac0b33e6f13c8ec)();
    const currentMutation = interimAgency ? updateMutation : createMutation;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            name: interimAgency?.name || '',
            addresses: interimAgency?.addresses ?? []
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name) errors.name = 'Champ requis';
            if (values.addresses.length === 0) errors.addresses = "Au moins une adresse doit \xeatre renseign\xe9e";
            return errors;
        },
        onSubmit: (values)=>{
            const payload = {
                ...values,
                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
            };
            if (!interimAgency) createMutation.mutate(payload);
            else updateMutation.mutate({
                id: interimAgency._id,
                ...payload
            });
        },
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: "Nom",
                    name: "name",
                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                    required: true
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $09fb06a5ea2f8067$export$3e2fc1eaa5ec0e7e), {}),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                    mutation: currentMutation
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                color: "primary",
                                type: "submit",
                                mutation: currentMutation,
                                children: interimAgency ? "Mettre \xe0 jour les informations de l'Agence" : "Cr\xe9er une Nouvelle Agence"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $d811c3042d321ad2$export$2e2bcd8739ae039 = $d811c3042d321ad2$var$AgencyInfosForm;



const $9e985edbe8da8f5c$var$AgenciesList = ()=>{
    const interimAgencyQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        sort: 'name',
        type: 'interimAgency'
    });
    const tableColumns = $9e985edbe8da8f5c$var$useListTableColumns(interimAgencyQuery.data || []);
    const createInterimAgencyMutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $58f46cb3f921014b$export$4a6f974b4208311)());
    const newAgencyModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (createInterimAgencyMutationState?.status === 'success') {
            newAgencyModal.setIsDisplayed(false);
            interimAgencyQuery.refetch();
        }
    }, [
        createInterimAgencyMutationState
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Liste des Agences d'Int\xe9rim"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                            children: "\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Control, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                    onClick: ()=>newAgencyModal.setIsDisplayed(true),
                                                    outlined: true,
                                                    color: "primary",
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a6ba75b56dc677fb$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                            children: "Nouvelle agence"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                            title: "Cr\xe9er une Agence d'Int\xe9rim",
                            actions: newAgencyModal,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d811c3042d321ad2$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                            columns: tableColumns,
                            data: interimAgencyQuery.data || [],
                            noDataMessage: "Aucune agence \xe0 afficher"
                        })
                    ]
                })
            })
        ]
    });
};
var $9e985edbe8da8f5c$export$2e2bcd8739ae039 = $9e985edbe8da8f5c$var$AgenciesList;
const $9e985edbe8da8f5c$var$useListTableColumns = (organizations)=>{
    const loginAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.loginAs);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/agencies/${organization._id}`,
                        children: organization.name
                    });
                }
            },
            {
                Header: '',
                accessor: 'loginAs',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        onClick: ()=>loginAs('interimAgencyMember', organization, 'admin'),
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4b2651edb550ad92$export$2e2bcd8739ae039), {})
                        })
                    });
                }
            }
        ], [
        organizations
    ]);
};





var $3ZYaX = parcelRequire("3ZYaX");







var $3ZYaX = parcelRequire("3ZYaX");








const $2c0862ce7edc2ba9$export$3988ae62b71be9a3 = async (date)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/smic`,
        method: 'GET',
        params: {
            date: date
        }
    });
};


const $b5b5022de31b86b5$export$9c9998b370b83a7d = (date, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('pre-billings', (0, $2c0862ce7edc2ba9$export$3988ae62b71be9a3), date, {
        staleTime: 3600000,
        ...options || {}
    });




var $2KSUA = parcelRequire("2KSUA");
const $38062497b70ee6aa$var$SummaryInfoPanel = ({ title: title, data: data })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel), {
        style: {
            minWidth: 200,
            boxShadow: 'none'
        },
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Panel).Header, {
                textSize: 6,
                backgroundColor: 'white',
                textColor: "black",
                children: title
            }),
            data.map(({ label: label, value: value }, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Panel).Block, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Control, {
                        display: "flex",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textWeight: "bold",
                                textSize: 7,
                                mr: 3,
                                children: label
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textSize: 7,
                                children: value
                            })
                        ]
                    })
                }, label + value + index))
        ]
    });
};
const $38062497b70ee6aa$var$SummaryHeader = ({ startOfWeek: startOfWeek, endOfWeek: endOfWeek, interimAgencyId: interimAgencyId, totals: // service,
totals, forceCompleteMode: // jobTitle,
forceCompleteMode, currentDay: currentDay, missionsCount: missionsCount, showEmployerCosts: showEmployerCosts, employerRules: employerRules })=>{
    const organizationsQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'interimAgency'
    }, {
        staleTime: 120000
    });
    const [isSmallMode, setIsSmallMode] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(forceCompleteMode ? false : true);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const currentInterimAgency = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>currentOrganization && currentOrganization.type === 'interimAgency' ? currentOrganization : (organizationsQuery.data || []).find((current)=>current._id === interimAgencyId), [
        organizationsQuery.data,
        interimAgencyId
    ]);
    const { data: data } = (0, $b5b5022de31b86b5$export$9c9998b370b83a7d)(new Date(startOfWeek), {
        enabled: Boolean(startOfWeek) && !isSmallMode
    });
    const baseLaborHourlyCost = data?.value || 0;
    const endOfWeekSmicQuery = (0, $b5b5022de31b86b5$export$9c9998b370b83a7d)(new Date(endOfWeek), {
        enabled: Boolean(endOfWeek) && !isSmallMode
    });
    const ChangeModeButton = ()=>{
        if (forceCompleteMode) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            textAlign: 'right',
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "a",
                onClick: ()=>setIsSmallMode(!isSmallMode),
                textSize: 7,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    size: 'small',
                    children: [
                        isSmallMode ? "Afficher les d\xe9tails" : "Masquer les d\xe9tails",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: isSmallMode ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8484b39f982e716b$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5a8507055084759e$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        });
    };
    const periodInfoPanelData = [
        {
            label: currentDay ? 'Le' : 'Du',
            value: currentDay ? currentDay.label.toLowerCase() : (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(startOfWeek)
        },
        {
            label: 'Semaine',
            value: (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(startOfWeek)
        },
        {
            label: 'Agence',
            value: currentInterimAgency ? currentInterimAgency.name : 'tous'
        },
        {
            label: 'SMIC',
            value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                textAlign: 'right',
                children: [
                    baseLaborHourlyCost,
                    "\u20AC",
                    ' ',
                    endOfWeekSmicQuery.data?.value && endOfWeekSmicQuery.data.value !== baseLaborHourlyCost ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            endOfWeekSmicQuery.data.value,
                            "\u20AC au",
                            ' ',
                            (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(new Date(endOfWeekSmicQuery.data.from))
                        ]
                    }) : ''
                ]
            })
        },
        {
            label: 'Nbr de missions',
            value: missionsCount || 0
        }
    ];
    if (!currentDay) periodInfoPanelData.splice(1, 0, {
        label: 'Au',
        value: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(endOfWeek)
    });
    const employerCostData = totals?.employerData?.costs && showEmployerCosts ? (0, $2KSUA.sortBy)(Object.keys(totals.employerData.costs).map((ruleId)=>{
        const rule = employerRules?.find((r)=>r.ruleId === ruleId);
        return {
            label: rule?.name || ruleId,
            value: (0, $0798496ba66df318$export$e370a7ddaa2f579a)(totals?.employerData.costs[ruleId])
        };
    }), 'label') : [];
    if (isSmallMode) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 4,
                m: "auto",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "strong",
                    children: currentDay ? currentDay.label : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "Semaine ",
                            (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(startOfWeek),
                            " - Du ",
                            (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(startOfWeek),
                            " au",
                            ' ',
                            (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(endOfWeek)
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 4,
                textAlign: 'center'
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 4,
                textAlign: 'right',
                children: [
                    !currentDay && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "TOTAL HT:",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "strong",
                                children: [
                                    " ",
                                    (0, $0798496ba66df318$export$e370a7ddaa2f579a)(totals?.costs?.total)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(ChangeModeButton, {})
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
        breakpoint: 'fluid',
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Left, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            backgroundColor: "white-bis",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($38062497b70ee6aa$var$SummaryInfoPanel, {
                                        title: "Informations",
                                        data: periodInfoPanelData
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: currentDay ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($38062497b70ee6aa$var$SummaryInfoPanel, {
                                        title: currentDay.label,
                                        data: [
                                            // Groupe 1 : Heures travaillées
                                            {
                                                label: "Heures travaill\xe9es",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(currentDay.durations.worked.total)
                                            },
                                            {
                                                label: "\u2514 Jour",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(currentDay.durations.worked?.day)
                                            },
                                            {
                                                label: "\u2514 Nuit",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(currentDay.durations.worked?.night)
                                            },
                                            // Groupe 2 : Heures comptabilisées
                                            {
                                                label: "Heures d\u2019\xe9v\xe8nements",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(currentDay.durations.benefit)
                                            },
                                            // Total général
                                            {
                                                label: "Total journ\xe9e",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(currentDay.durations.total?.total)
                                            }
                                        ]
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($38062497b70ee6aa$var$SummaryInfoPanel, {
                                        title: 'Totaux heures',
                                        data: [
                                            // Groupe 1 : Heures travaillées
                                            {
                                                label: "Travaill\xe9es",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(totals?.durations?.worked.total || 0)
                                            },
                                            {
                                                label: "\u2514 Jour",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(totals?.durations?.worked.day || 0)
                                            },
                                            {
                                                label: "\u2514 Nuit",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(totals?.durations?.worked.night || 0)
                                            },
                                            {
                                                label: "Heures d\u2019\xe9v\xe8nements",
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(totals?.durations?.benefit || 0)
                                            },
                                            {
                                                label: 'Total',
                                                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(totals?.durations?.total.total || 0)
                                            }
                                        ]
                                    })
                                }),
                                !currentDay && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($38062497b70ee6aa$var$SummaryInfoPanel, {
                                        title: "Totaux co\xfbts",
                                        data: [
                                            {
                                                label: 'Heures jour base 35',
                                                value: (0, $0798496ba66df318$export$e370a7ddaa2f579a)(totals?.costs?.worked?.day)
                                            },
                                            {
                                                label: 'Heures nuit',
                                                value: (0, $0798496ba66df318$export$e370a7ddaa2f579a)(totals?.costs?.worked?.night)
                                            },
                                            ...employerCostData,
                                            {
                                                label: 'Total HT',
                                                value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    renderAs: "strong",
                                                    children: (0, $0798496ba66df318$export$e370a7ddaa2f579a)(totals?.costs?.total)
                                                })
                                            }
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(ChangeModeButton, {})
        ]
    });
};
var $38062497b70ee6aa$export$2e2bcd8739ae039 = $38062497b70ee6aa$var$SummaryHeader;






var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $026aaf685abe0fe8$var$DownloadIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
    }));
}
const $026aaf685abe0fe8$var$ForwardRef = $3ZYaX.forwardRef($026aaf685abe0fe8$var$DownloadIcon);
var $026aaf685abe0fe8$export$2e2bcd8739ae039 = $026aaf685abe0fe8$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");
var $68d1bea69237f5ab$exports = {};
$68d1bea69237f5ab$exports = function(data, filename, mime, bom) {
    var blobData = typeof bom !== 'undefined' ? [
        bom,
        data
    ] : [
        data
    ];
    var blob = new Blob(blobData, {
        type: mime || 'application/octet-stream'
    });
    if (typeof window.navigator.msSaveBlob !== 'undefined') // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename);
    else {
        var blobURL = window.URL && window.URL.createObjectURL ? window.URL.createObjectURL(blob) : window.webkitURL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = blobURL;
        tempLink.setAttribute('download', filename);
        // Safari thinks _blank anchor are pop ups. We only want to set _blank
        // target if the browser does not support the HTML5 download attribute.
        // This allows you to download files in desktop safari if pop up blocking
        // is enabled.
        if (typeof tempLink.download === 'undefined') tempLink.setAttribute('target', '_blank');
        document.body.appendChild(tempLink);
        tempLink.click();
        // Fixes "webkit blob resource error 1"
        setTimeout(function() {
            document.body.removeChild(tempLink);
            window.URL.revokeObjectURL(blobURL);
        }, 200);
    }
};


// Trigger file browser file download when data exist & change
const $c7d4f219eb05f8a2$var$useFileDownload = (fileName, data)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        data && (0, (/*@__PURE__*/$parcel$interopDefault($68d1bea69237f5ab$exports)))(data, fileName);
    }, [
        data
    ]);
};
var $c7d4f219eb05f8a2$export$2e2bcd8739ae039 = $c7d4f219eb05f8a2$var$useFileDownload;



var $3ZYaX = parcelRequire("3ZYaX");

const $9087b87eb2c915c8$var$useXlsxDownload = (fileName, data)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (data) {
            const run = async ()=>{
                const XLSX = await (parcelRequire("aoNgk"));
                const worksheet = XLSX.utils.json_to_sheet(data.content);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, data.sheet);
                XLSX.writeFile(workbook, fileName || `${new Date()}.xlsx`);
            };
            run();
        }
    }, [
        data
    ]);
};
var $9087b87eb2c915c8$export$2e2bcd8739ae039 = $9087b87eb2c915c8$var$useXlsxDownload;




var $31tXu = parcelRequire("31tXu");




const $b2d8c51042f4efd0$var$MAX_EXPORT_RANGE_DAYS = 62;
/**
 * Determine whether the selected date interval aligns with full Monday-to-Sunday weeks.
 * Missing dates are treated as aligned to avoid blocking the user before they finish their input.
 * @param from - ISO date string representing the start date chosen by the user
 * @param to - ISO date string representing the end date chosen by the user
 * @returns true if both dates align with the beginning and end of the corresponding weeks
 */ const $b2d8c51042f4efd0$var$areDatesAlignedWithFullWeeks = (from, to)=>{
    // Ensure the start date matches the Monday of its week when provided
    const fromIsMonday = !from || (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(new Date(from))) === from;
    // Ensure the end date matches the Sunday of its week when provided
    const toIsSunday = !to || (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)(new Date(to))) === to;
    return fromIsMonday && toIsSunday;
};
const $b2d8c51042f4efd0$var$ExportButton = ({ filters: filters, hideCustom: hideCustom = false })=>{
    const exportSummaryMutation = (0, $e409591b67738e56$export$3f810d32a533726c)();
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const [exportType, setExportType] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (exportType && exportType !== 'custom') exportSummaryMutation.mutate({
            ...filters,
            type: exportType,
            //@ts-expect-error
            start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(new Date(filters.start))),
            //@ts-expect-error
            end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)(new Date(filters.start)))
        });
    }, [
        exportType
    ]);
    //hook to download csv query result (if export type === csv)
    (0, $c7d4f219eb05f8a2$export$2e2bcd8739ae039)(`teamtim-export.csv`, exportSummaryMutation.variables?.type === 'csv' ? exportSummaryMutation.data?.data : undefined);
    //hook to download xls query result (if export type === xls)
    (0, $9087b87eb2c915c8$export$2e2bcd8739ae039)(`teamtim-export.xlsx`, //@ts-expect-error
    exportSummaryMutation.variables?.type === 'xls' ? exportSummaryMutation.data?.data : undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (exportSummaryMutation.status === 'success') {
            setExportType(undefined);
            exportSummaryMutation.reset();
        }
    }, [
        exportSummaryMutation.status
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                actions: modal,
                title: "Export personnalis\xe9",
                dataTest: "export-custom-modal",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                    initialValues: {
                        from: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(filters.start ? new Date(filters.start) : new Date())),
                        to: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)(filters.start ? new Date(filters.start) : new Date())),
                        type: ''
                    },
                    onSubmit: (values)=>{
                        exportSummaryMutation.mutate({
                            ...filters,
                            type: values.type,
                            //@ts-expect-error - API expects ISO strings even though typing mentions Date
                            start: values.from,
                            //@ts-expect-error - API expects ISO strings even though typing mentions Date
                            end: values.to
                        });
                    },
                    validate: (values)=>{
                        const errors = {};
                        // Basic required field checks
                        if (!values.type) errors.type = 'Champ requis';
                        if (!values.from) errors.from = 'Champ requis';
                        if (!values.to) errors.to = 'Champ requis';
                        return errors;
                    },
                    children: (props)=>{
                        const selectedStartDate = props.values.from ? new Date(props.values.from) : undefined;
                        const selectedEndDate = props.values.to ? new Date(props.values.to) : undefined;
                        // Check if the selected interval covers complete weeks (Monday to Sunday)
                        const isAlignedWithFullWeeks = $b2d8c51042f4efd0$var$areDatesAlignedWithFullWeeks(props.values.from, props.values.to);
                        const hasSelectedRange = Boolean(selectedStartDate && selectedEndDate);
                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Du",
                                                name: "from",
                                                type: "date",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                max: props.values.to && (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(props.values.to)),
                                                min: selectedEndDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(selectedEndDate.getTime() - ($b2d8c51042f4efd0$var$MAX_EXPORT_RANGE_DAYS - 1) * (0, $74f17ceb9b5a08a5$export$9137ac55187b996d))) : undefined,
                                                help: `2 mois maximum`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Au",
                                                name: "to",
                                                type: "date",
                                                min: props.values.from && (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(props.values.from)),
                                                max: selectedStartDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(selectedStartDate.getTime() + ($b2d8c51042f4efd0$var$MAX_EXPORT_RANGE_DAYS - 1) * (0, $74f17ceb9b5a08a5$export$9137ac55187b996d))) : undefined,
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            label: "Type de fichier",
                                            name: "type",
                                            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                            options: [
                                                {
                                                    value: 'xls',
                                                    label: 'Excel'
                                                },
                                                {
                                                    value: 'csv',
                                                    label: 'CSV'
                                                }
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: [
                                            hasSelectedRange && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                mb: 4,
                                                color: "info",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                    children: [
                                                        "Export du ",
                                                        selectedStartDate ? (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(selectedStartDate) : '',
                                                        ' au ',
                                                        selectedEndDate ? (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(selectedEndDate) : ''
                                                    ]
                                                })
                                            }),
                                            !isAlignedWithFullWeeks && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                color: "warning",
                                                mb: 4,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                renderAs: "strong",
                                                                children: "Attention"
                                                            }),
                                                            " : les dates s\xe9lectionn\xe9es ne couvrent pas des semaines compl\xe8tes du lundi au dimanche. Le calcul des r\xe8gles employeurs \xe0 la semaine peut \xeatre tronqu\xe9 si des jours manquent."
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                color: "primary",
                                                mutation: exportSummaryMutation,
                                                disabled: exportSummaryMutation.isLoading,
                                                children: "Exporter"
                                            }),
                                            exportSummaryMutation.isError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                textColor: "danger",
                                                children: "Aucune donn\xe9e \xe0 exporter"
                                            })
                                        ]
                                    })
                                })
                            ]
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Dropdown), {
                closeOnSelect: true,
                color: "primary",
                icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $026aaf685abe0fe8$export$2e2bcd8739ae039), {})
                }),
                label: "Export",
                onChange: (type)=>{
                    if (type === 'custom') modal.setIsDisplayed(true);
                    else setExportType(type);
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                        renderAs: "a",
                        value: "csv",
                        children: "CSV"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                        renderAs: 'a',
                        value: "xls",
                        children: "Excel"
                    }),
                    !hideCustom ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                        renderAs: "a",
                        value: "custom",
                        children: "Dates personnalis\xe9es"
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {})
                ]
            })
        ]
    });
};
var $b2d8c51042f4efd0$export$2e2bcd8739ae039 = $b2d8c51042f4efd0$var$ExportButton;




parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

const $c288541aa0d2549e$var$DescriptionList = ({ items: items, labelColumnWidth: labelColumnWidth, valueColumnWidth: valueColumnWidth })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Table), {
        className: "is-fullwidth",
        bordered: false,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "tbody",
            children: items.map((item)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "tr",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "td",
                            style: {
                                border: 'none',
                                width: labelColumnWidth,
                                paddingLeft: '0px'
                            },
                            children: item.label
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "td",
                            style: {
                                border: 'none',
                                width: valueColumnWidth,
                                paddingLeft: '0px'
                            },
                            textWeight: "bold",
                            children: item.value
                        })
                    ]
                }, `${item.value}_${item.label}`))
        })
    });
};
var $c288541aa0d2549e$export$2e2bcd8739ae039 = $c288541aa0d2549e$var$DescriptionList;









const $1bbcc840ecfc7367$var$POPULATE = [
    'employer',
    'interimAgency',
    'createdBy'
];
const $1bbcc840ecfc7367$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    if (params?.invoiceRef?.length === 1 && params.invoiceRef[0]) params.invoiceRef = '';
    else if (params?.invoiceRef?.length === 1 && !params.invoiceRef[0]) params['!invoiceRef'] = '';
    else if (params?.invoiceRef) params.invoiceRef = undefined;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/period-summaries',
        method: 'get',
        params: {
            populate: $1bbcc840ecfc7367$var$POPULATE,
            ...params || {}
        }
    });
};
const $1bbcc840ecfc7367$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/period-summaries/${id}`,
        method: 'get',
        params: {
            populate: $1bbcc840ecfc7367$var$POPULATE
        }
    });
const $1bbcc840ecfc7367$export$8bf79c831efa562a = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/period-summaries/three-parties/simulate',
        method: 'get',
        params: params
    });
const $1bbcc840ecfc7367$export$d2003e96a464a01b = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/period-summaries/two-parties/simulate',
        method: 'get',
        params: params
    });
const $1bbcc840ecfc7367$export$d94678ffd1007cf0 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/period-summaries/two-parties',
        method: 'post',
        params: params
    });
const $1bbcc840ecfc7367$export$9685b966cf9f6d6 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/period-summaries/three-parties',
        method: 'post',
        params: params
    });
const $1bbcc840ecfc7367$export$722fbec263ad908a = async (data)=>{
    const { id: id, ...params } = data;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/period-summaries/${id}`,
        method: 'put',
        params: params
    });
};


const $1517f26b22db4237$export$36ab29ab626f4c93 = (id)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('period-summaries', (0, $1bbcc840ecfc7367$export$3988ae62b71be9a3), id);
const $1517f26b22db4237$export$b81cd8e3169f70dc = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('period-summaries', (0, $1bbcc840ecfc7367$export$e7aa7bc5c1b3cfb3), filters || {}, options);
const $1517f26b22db4237$export$7f703548194bbf32 = (params, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('period-summaries', (0, $1bbcc840ecfc7367$export$8bf79c831efa562a), params, options);
const $1517f26b22db4237$export$fa70538e6fc79fa0 = (params, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('period-summaries', (0, $1bbcc840ecfc7367$export$d2003e96a464a01b), params, options);
// Mutations
/**
 * Hook pour créer un period summary à deux parties
 */ const $1517f26b22db4237$var$useCreateTwoPartiesMutationKey = ()=>[
        'period-summaries',
        'two-parties',
        'create'
    ];
const $1517f26b22db4237$export$460193833a3294e6 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1bbcc840ecfc7367$export$d94678ffd1007cf0), {
        mutationKey: $1517f26b22db4237$var$useCreateTwoPartiesMutationKey(),
        onSuccess: ()=>{
            $1517f26b22db4237$export$5b17c484cf30524e();
        }
    });
/**
 * Hook pour créer un period summary à trois parties
 */ const $1517f26b22db4237$var$useCreateThreePartiesMutationKey = ()=>[
        'period-summaries',
        'three-parties',
        'create'
    ];
const $1517f26b22db4237$export$145f77ce5580494a = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1bbcc840ecfc7367$export$9685b966cf9f6d6), {
        mutationKey: $1517f26b22db4237$var$useCreateThreePartiesMutationKey(),
        onSuccess: ()=>{
            $1517f26b22db4237$export$5b17c484cf30524e();
        }
    });
const $1517f26b22db4237$export$5b17c484cf30524e = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'period-summaries'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'missions/weeks-summary'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'missions/weeks-summary/status'
    ]);
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'worker-counters'
    ]);
};
const $1517f26b22db4237$var$useUpdateMutationKey = ()=>[
        'period-summaries',
        'update'
    ];
const $1517f26b22db4237$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $1bbcc840ecfc7367$export$722fbec263ad908a), {
        mutationKey: $1517f26b22db4237$var$useUpdateMutationKey(),
        onSuccess: ()=>{
            $1517f26b22db4237$export$5b17c484cf30524e();
        }
    });


const $64c9177e448713e6$var$CreatePreBilling = ({ interimAgencyId: interimAgencyId, jobTitle: jobTitle, service: service, start: start })=>{
    // Pre billing mutation
    const mutation = (0, $1517f26b22db4237$export$145f77ce5580494a)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const [isConfirmed, setIsConfirmed] = (0, $3ZYaX.useState)(false);
    const newPreBillingParams = {
        week: (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(new Date(start)),
        year: (0, $74f17ceb9b5a08a5$export$12d572480ceb6e58)(new Date(start)),
        interimAgency: interimAgencyId,
        jobTitle: jobTitle,
        service: service
    };
    const simulateQuery = (0, $1517f26b22db4237$export$7f703548194bbf32)(newPreBillingParams, {
        enabled: Boolean(interimAgencyId)
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (mutation.isSuccess) navigate(`/pre-billings/${mutation.data.data._id}`);
    }, [
        mutation.isSuccess
    ]);
    if (simulateQuery.isLoading || !simulateQuery.data) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        children: "Chargement en cours"
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            simulateQuery.data?.missions.readyForSummary === 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                color: "danger",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        textWeight: "bold",
                        children: "Pas de Mission \xe9ligible pour la Pr\xe9-Facturation"
                    })
                })
            }),
            simulateQuery.data?.missions.count !== simulateQuery.data?.missions.readyForSummary && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                color: "warning",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "p",
                            textWeight: "bold",
                            mb: 3,
                            children: [
                                simulateQuery.data?.missions.notReadyForSummary,
                                " Mission(s) non prises en compte"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            className: "content",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "ul",
                                textSize: 7,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: "Uniquement les missions valid\xe9es sont prise en compte"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: [
                                            "Toutes les missions pour un m\xeame ",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                            " doivent \xeatre pr\xe9-factur\xe9es en m\xeame temps"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: "Uniquement les missions correspondantes aux filtres s\xe9lectionn\xe9s sont prise en compte"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: "Les missions d\xe9j\xe0 pr\xe9-factur\xe9es ne sont pas prise en compte"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c288541aa0d2549e$export$2e2bcd8739ae039), {
                items: [
                    {
                        label: "Missions concern\xe9es",
                        value: `${simulateQuery.data?.missions.readyForSummary} / ${simulateQuery.data?.missions.count}`
                    },
                    {
                        label: 'Du',
                        value: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(simulateQuery.data.from)
                    },
                    {
                        label: 'Au',
                        value: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(simulateQuery.data.to)
                    },
                    {
                        label: 'Agence',
                        value: simulateQuery.data.interimAgencyName
                    },
                    {
                        label: "M\xe9tier",
                        value: simulateQuery.data.jobTitles?.[0] ? simulateQuery.data.jobTitles.join(', ') : 'Tous'
                    },
                    {
                        label: 'Affectation',
                        value: simulateQuery.data.services?.[0] ? simulateQuery.data.services.join(', ') : 'Tous'
                    },
                    {
                        label: 'Montant total',
                        value: (0, $0798496ba66df318$export$e370a7ddaa2f579a)(simulateQuery.data.totals?.costs?.total)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                mt: 5,
                mb: 3,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                        required: true,
                        textWeight: "bold",
                        checked: isConfirmed,
                        onChange: ()=>setIsConfirmed(!isConfirmed),
                        name: "confirm-create-pre-billing",
                        "data-test": "confirm-create-pre-billing",
                        disabled: !simulateQuery.data?.missions.readyForSummary,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            textWeight: "bold",
                            children: "Je comprends que cette action est irr\xe9versible"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                fullwidth: true,
                color: 'info',
                onClick: ()=>{
                    simulateQuery.data.missions.readyForSummary >= 1 && mutation.mutate(newPreBillingParams);
                },
                disabled: !simulateQuery.data?.missions.readyForSummary || mutation.isLoading || mutation.isSuccess || !isConfirmed,
                children: [
                    "G\xe9n\xe9rer la pr\xe9-facturation de",
                    ' ',
                    `${simulateQuery.data?.missions.readyForSummary} / ${simulateQuery.data?.missions.count}`,
                    ' ',
                    "Mission(s)"
                ]
            })
        ]
    });
};
var $64c9177e448713e6$export$2e2bcd8739ae039 = $64c9177e448713e6$var$CreatePreBilling;


const $712e01e4a589fb70$var$CreatePreBillingModal = ({ isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed, ...rest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        actions: {
            isDisplayed: isDisplayed,
            setIsDisplayed: setIsDisplayed
        },
        title: "G\xe9n\xe9rer une pr\xe9-facturation",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $64c9177e448713e6$export$2e2bcd8739ae039), {
            ...rest
        })
    });
};
var $712e01e4a589fb70$export$2e2bcd8739ae039 = $712e01e4a589fb70$var$CreatePreBillingModal;






var $2KSUA = parcelRequire("2KSUA");

parcelRequire("3ZYaX");

const $ff34a0a5311d1f6e$var$SummaryPagination = ({ currentPage: currentPage, missionsPerPage: missionsPerPage, missionsCount: missionsCount, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        my: 4,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Pagination), {
                    current: currentPage,
                    showFirstLast: true,
                    total: Math.ceil(missionsCount / missionsPerPage),
                    onChange: onChange,
                    next: "Suivant",
                    previous: "Pr\xe9c\xe9dent",
                    size: 'small'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                textSize: 7,
                mt: 1,
                children: [
                    missionsPerPage,
                    " travailleurs par page - ",
                    missionsCount,
                    " travailleurs en tout"
                ]
            })
        ]
    });
};
var $ff34a0a5311d1f6e$export$2e2bcd8739ae039 = $ff34a0a5311d1f6e$var$SummaryPagination;






var $3ZYaX = parcelRequire("3ZYaX");





parcelRequire("3ZYaX");

// Fonction utilitaire pour créer une colonne
const $c271cdd7b21eaa77$var$createColumn = ({ header: header, accessor: accessor, className: className, shouldMerge: shouldMerge, render: render, id: id })=>{
    const column = {
        Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            mt: 1,
            children: header
        }),
        ...accessor && {
            accessor: accessor
        },
        ...render && {
            Cell: $c271cdd7b21eaa77$export$a19f2b5bc152a233(render)
        },
        id: id
    };
    if (className) column.className = typeof className === 'function' ? className() : className;
    if (shouldMerge) {
        column.isHidden = (cell)=>!cell.row.original.rowGroupOptions.isFirstMission;
        column.getRowSpan = (cell, data)=>{
            if (!cell.row.original.rowGroupOptions.isFirstMission) return 1;
            return cell.row.original.rowGroupOptions.rowSpan;
        };
    }
    return column;
};
const $c271cdd7b21eaa77$export$5570d3b32630dd60 = (columns)=>{
    return columns.filter((column)=>!column.isHidden).map((column)=>$c271cdd7b21eaa77$var$createColumn(column));
};
const $c271cdd7b21eaa77$export$a19f2b5bc152a233 = (render)=>{
    return ({ cell: cell })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            style: {
                whiteSpace: 'nowrap'
            },
            display: "flex",
            alignItems: "center",
            children: render(cell.row.original)
        });
};
const $c271cdd7b21eaa77$export$eb1e781dd8518b2 = (columns, group)=>{
    columns.push({
        Header: group.Header,
        id: group.id,
        className: group.className,
        columns: group.columns
    });
};



parcelRequire("3ZYaX");




const $477360998adbd69d$var$workerColumnGroup = ()=>({
        Header: ' ',
        id: 'user',
        className: 'sticky has-background-white',
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: 'Nom',
                id: 'user.name',
                className: 'sticky table-section-start-2x table-section-end',
                shouldMerge: true,
                render: ({ user: user })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textWeight: "bold",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                            to: `/workers/${user._id}`,
                            textColor: "primary",
                            children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user)
                        })
                    })
            }
        ])
    });
var $477360998adbd69d$export$2e2bcd8739ae039 = $477360998adbd69d$var$workerColumnGroup;




parcelRequire("3ZYaX");



const $2f81c272f786e7d0$var$weekStateColumnGroup = ({ start: start, minimalMode: minimalMode })=>({
        Header: `Semaine`,
        id: 'week',
        className: 'sticky has-background-white',
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: "\u20AC/h",
                id: 'week.rate',
                shouldMerge: true,
                isHidden: minimalMode,
                className: 'sticky',
                render: ({ totals: totals, mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$7d82fffd1945abd0), {
                        cost: totals.costs.hourly,
                        noCostAvailable: mission.contractModel === 'twoParties'
                    })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$34068b40256a87f7), {
                    mission: {
                        weekIsValidated: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: "dark"
                }),
                id: 'week.validation',
                className: 'sticky',
                shouldMerge: true,
                render: ({ weekIsValidated: weekIsValidated })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$34068b40256a87f7), {
                        mission: {
                            weekIsValidated: weekIsValidated
                        },
                        type: "icon",
                        small: true
                    })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$85bccb7844ae00fa), {
                    force: true,
                    type: "icon",
                    iconColor: "dark",
                    small: true
                }),
                id: 'week.preBilled',
                className: 'sticky table-section-end-2x',
                shouldMerge: true,
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$85bccb7844ae00fa), {
                        mission: mission,
                        type: "icon",
                        small: true,
                        week: (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(start),
                        year: (0, $74f17ceb9b5a08a5$export$12d572480ceb6e58)(start)
                    })
            }
        ])
    });
var $2f81c272f786e7d0$export$2e2bcd8739ae039 = $2f81c272f786e7d0$var$weekStateColumnGroup;



parcelRequire("3ZYaX");





var $2KSUA = parcelRequire("2KSUA");



var $3ZYaX = parcelRequire("3ZYaX");
function $46be1ebbec881da5$var$ChevronDownIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
        clipRule: "evenodd"
    }));
}
const $46be1ebbec881da5$var$ForwardRef = $3ZYaX.forwardRef($46be1ebbec881da5$var$ChevronDownIcon);
var $46be1ebbec881da5$export$2e2bcd8739ae039 = $46be1ebbec881da5$var$ForwardRef;



const $824c96a0314d7a3e$var$missionDetailsColumnGroup = ({ currentUserRole: currentUserRole, minimalMode: minimalMode, setExcludeGroupKeys: setExcludeGroupKeys, excludeGroupKeys: excludeGroupKeys })=>({
        Header: 'Mission',
        id: 'mission.details',
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: currentUserRole === 'employerMember' ? 'Employeur' : 'Client',
                id: 'mission.employer',
                shouldMerge: true,
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: 'span',
                        textColor: "dark",
                        textWeight: "semibold",
                        children: currentUserRole === 'employerMember' ? mission.interimAgency?.name ?? mission.employer.name : mission.employer.name
                    })
            },
            {
                header: 'Affectation',
                id: 'mission.service',
                isHidden: minimalMode,
                render: ({ mission: mission })=>{
                    const serviceNames = [];
                    mission.workPeriods.forEach((wp)=>{
                        const serviceName = wp.service?.name;
                        if (serviceName && !serviceNames.includes(serviceName)) serviceNames.push(serviceName);
                    });
                    const hasMultipleServices = serviceNames.length > 1;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: 'span',
                                textColor: "dark",
                                textWeight: "semibold",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fb0f7382abab45fe$export$f458b3f21d0860), {
                                    ifIsLongerThan: 20,
                                    children: (0, $2KSUA.upperFirst)(mission.service.name)
                                })
                            }),
                            hasMultipleServices && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                size: "small",
                                color: "grey-light",
                                "data-tooltip": `Des journ\xe9es de travail sont li\xe9es \xe0 plusieurs affectations : ${serviceNames.join(', ')}`,
                                ml: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
                            })
                        ]
                    });
                }
            },
            {
                header: "M\xe9tier",
                id: 'mission.jobTitle',
                isHidden: minimalMode,
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: 'span',
                        textColor: "dark",
                        textWeight: "semibold",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fb0f7382abab45fe$export$f458b3f21d0860), {
                            ifIsLongerThan: 20,
                            children: (0, $2KSUA.upperFirst)(mission.jobTitle.name)
                        })
                    })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    "data-tooltip": 'Voir la mission',
                    className: "has-tooltip-left",
                    size: "small",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9cce2377d82ad02c$export$2e2bcd8739ae039), {})
                }),
                id: 'mission.link',
                render: ({ mission: mission, rowGroupOptions: rowGroupOptions })=>{
                    if (mission.groupedMissions.length > 1) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: 'span',
                        textColor: "dark",
                        textWeight: "semibold",
                        className: "table-section-start",
                        "data-test": "expand-summary-mission",
                        onClick: ()=>setExcludeGroupKeys([
                                ...excludeGroupKeys,
                                mission.groupedKey
                            ]),
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon), {
                            "data-tooltip": `${mission.groupedMissions.length} missions.\nCliquer pour afficher une ligne par mission`,
                            className: "has-tooltip-left",
                            color: "link",
                            children: [
                                mission.groupedMissions.length,
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46be1ebbec881da5$export$2e2bcd8739ae039), {})
                            ]
                        })
                    });
                    const isInExcludeGroupKeys = mission.groupedKey && mission.groupedKey.includes(mission._id) // TODO: improve this
                    ;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                to: `/missions/${mission._id}`,
                                textWeight: "bold",
                                "data-test": "go-to-mission-details-action",
                                mt: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    "data-tooltip": 'Voir la mission',
                                    className: "has-tooltip-left",
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9cce2377d82ad02c$export$2e2bcd8739ae039), {})
                                })
                            }),
                            isInExcludeGroupKeys ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                onClick: ()=>setExcludeGroupKeys(excludeGroupKeys.filter((key)=>key !== mission.groupedKey.replace(`_${mission._id}`, ''))),
                                renderAs: 'span',
                                mt: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    "data-tooltip": `Cette mission peut \xeatre regroup\xe9e avec d'autres missions.
Cliquer pour regrouper en une ligne`,
                                    className: "has-tooltip-left",
                                    "data-test": "group-summary-mission",
                                    color: "link",
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5a8507055084759e$export$2e2bcd8739ae039), {})
                                })
                            }) : null
                        ]
                    });
                }
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$54eb6f08aa91b890), {
                    mission: {
                        isValidated: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: "dark"
                }),
                id: 'mission.validation',
                isHidden: minimalMode,
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$54eb6f08aa91b890), {
                        mission: mission,
                        type: "icon",
                        small: true,
                        iconColor: 'primary'
                    })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                    mission: {
                        isAbandoned: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: "dark"
                }),
                id: 'mission.abandoned',
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                        mission: mission,
                        type: "icon",
                        small: true
                    })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                    mission: {
                        isCancelled: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: "dark"
                }),
                id: 'mission.cancelled',
                render: ({ mission: mission })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                        mission: mission,
                        type: "icon",
                        small: true
                    })
            }
        ])
    });
var $824c96a0314d7a3e$export$2e2bcd8739ae039 = $824c96a0314d7a3e$var$missionDetailsColumnGroup;



parcelRequire("3ZYaX");





var $2KSUA = parcelRequire("2KSUA");

const $3efaddb4d035b821$var$buildEmployerRulesColumns = (rule, minimalMode, index, totalsEmployerRulesCount)=>({
        header: rule.shortName,
        id: `durations.${rule.name}`,
        shouldMerge: true,
        isHidden: minimalMode,
        render: (data)=>{
            const value = data.totals.employerData.durations[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)] || data.totals.employerData.goals[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)] || data.totals.employerData.costs[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)];
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$1d20afe38ad9e2c7), {
                employerRule: rule,
                value: value ?? null,
                fallbackTexts: {
                    goal: '0',
                    multiply: '00h00',
                    add: '00h00'
                }
            });
        },
        className: (0, $2KSUA.isNumber)(totalsEmployerRulesCount) && index === totalsEmployerRulesCount - 1 ? 'table-section-end' : ''
    });
const $3efaddb4d035b821$var$TotalsDurationsColumnsGroup = ({ hideActions: hideActions, minimalMode: minimalMode, employerRules: employerRules })=>{
    const totalsEmployerRules = employerRules.filter((rule)=>rule.addToWorkedTotal && rule.display.summary.totals);
    const otherEmployerRules = employerRules.filter((rule)=>!rule.addToWorkedTotal && rule.display.summary.totals);
    const employerRulesColumns = otherEmployerRules.map((rule, index)=>$3efaddb4d035b821$var$buildEmployerRulesColumns(rule, minimalMode ?? false, index, otherEmployerRules.length));
    const totalsEmployerRulesColumns = totalsEmployerRules.map((rule, index)=>$3efaddb4d035b821$var$buildEmployerRulesColumns(rule, minimalMode ?? false, index));
    return {
        Header: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                children: [
                    "Totaux",
                    ' ',
                    !hideActions && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: "small",
                        color: "primary",
                        "data-tooltip": "Ce total est bas\xe9 sur les filtres utilis\xe9s. Il peut ne pas \xeatre repr\xe9sentatif du total complet de la semaine.",
                        className: "has-tooltip-multiline has-tooltip-bottom",
                        ml: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
                    })
                ]
            }),
        id: 'Totaux',
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: 'Jour',
                id: 'totals.durations.worked.day',
                isHidden: minimalMode,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: data.durations.worked.day,
                        fallbackText: "00h00"
                    }),
                shouldMerge: true,
                className: !minimalMode ? 'table-section-start' : ''
            },
            {
                header: 'Nuit',
                id: 'totals.durations.worked.night',
                isHidden: minimalMode,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: data.durations.worked.night,
                        fallbackText: "00h00"
                    }),
                shouldMerge: true
            },
            {
                header: "Travaill\xe9",
                id: 'totals.durations.worked.total',
                isHidden: minimalMode,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: data.durations.worked.total,
                        fallbackText: "00h00"
                    }),
                shouldMerge: true
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    "data-tooltip": "Dur\xe9e total du travail non effectif, journ\xe9es avec \xe9v\xe8nements prestations",
                    children: "N.Effectif"
                }),
                id: 'totals.durations.benefit',
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: data.durations.benefit,
                        fallbackText: "00h00"
                    }),
                isHidden: minimalMode,
                shouldMerge: true
            },
            ...totalsEmployerRulesColumns,
            {
                header: 'Total',
                id: 'totals.durations.total.total',
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: data.durations.total.total,
                        fallbackText: "00h00"
                    }),
                shouldMerge: true,
                className: minimalMode ? 'table-section-start table-section-end' : !employerRulesColumns[0] ? 'table-section-end' : ''
            },
            //{
            //  header: 'Supp',
            //  id: 'totals.durations.overtime.total',
            //  isHidden: minimalMode,
            //  render: (data: TableRowData) => (
            //    <DurationCell duration={data.durations.overtime.total} fallbackText="00h00" />
            //  ),
            //  shouldMerge: true,
            //  className: !employerRulesColumns[0] ? 'table-section-end' : '',
            //},
            ...employerRulesColumns
        ])
    };
};
var $3efaddb4d035b821$export$2e2bcd8739ae039 = $3efaddb4d035b821$var$TotalsDurationsColumnsGroup;



parcelRequire("3ZYaX");





const $d64fc256c69e47ea$var$costsColumnsGroup = ({ hideActions: hideActions, minimalMode: minimalMode, employerRules: employerRules })=>{
    const employerRulesColumns = employerRules.filter((rule)=>rule.display.summary.costs).map((rule)=>({
            header: rule.shortName,
            id: `costs.${rule.name}`,
            shouldMerge: true,
            isHidden: minimalMode,
            render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$7d82fffd1945abd0), {
                    cost: data.employerData.costs[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)],
                    noCostAvailable: data.mission.contractModel === 'twoParties'
                })
        }));
    return {
        Header: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                children: [
                    "Co\xfbts",
                    !hideActions && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: "small",
                        color: "primary",
                        "data-tooltip": "Ce total est bas\xe9 sur les filtres utilis\xe9s. Il peut ne pas \xeatre repr\xe9sentatif du total complet de la semaine.",
                        className: "has-tooltip-multiline has-tooltip-bottom",
                        ml: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
                    })
                ]
            }),
        id: "Co\xfbts",
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: 'Jour',
                id: 'costs.worked.day',
                isHidden: minimalMode,
                shouldMerge: true,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$7d82fffd1945abd0), {
                        cost: data.costs.worked.day,
                        noCostAvailable: data.mission.contractModel === 'twoParties'
                    })
            },
            {
                header: 'Nuit',
                id: 'costs.worked.night',
                isHidden: minimalMode,
                shouldMerge: true,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$7d82fffd1945abd0), {
                        cost: data.costs.worked.night,
                        noCostAvailable: data.mission.contractModel === 'twoParties'
                    })
            },
            ...employerRulesColumns,
            {
                header: 'Total',
                id: 'costs.total',
                className: 'table-section-end',
                shouldMerge: true,
                render: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$7d82fffd1945abd0), {
                        cost: data.costs.total,
                        noCostAvailable: data.mission.contractModel === 'twoParties'
                    })
            }
        ])
    };
};
var $d64fc256c69e47ea$export$2e2bcd8739ae039 = $d64fc256c69e47ea$var$costsColumnsGroup;



parcelRequire("3ZYaX");













parcelRequire("3ZYaX");


const $f3af7e3d169ca270$export$6127403115f642b4 = ({ workPeriod: workPeriod })=>{
    const items = [];
    if (workPeriod.manualBreak) items.push({
        label: "Pause forc\xe9e",
        value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workPeriod.summary.durations.breaks)
    });
    else if (workPeriod.summary.breaks.length > 0) workPeriod.summary.breaks.forEach((break_, index)=>{
        items.push({
            label: `D\xe9but pause ${index + 1}`,
            value: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(break_.start)
        }, {
            label: `Fin pause ${index + 1}`,
            value: (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(break_.end)
        }, {
            label: `Dur\xe9e pause ${index + 1}`,
            value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(break_.duration)
        });
    });
    else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        children: "Aucune pause"
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: items.map((item)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                style: {
                    display: 'table-row'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        style: {
                            display: 'table-cell'
                        },
                        px: 1,
                        children: item.label
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        style: {
                            display: 'table-cell'
                        },
                        px: 1,
                        children: item.value
                    })
                ]
            }, item.label))
    });
};



var $3ZYaX = parcelRequire("3ZYaX");
function $f97462e081ce77a7$var$UserRemoveIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"
    }));
}
const $f97462e081ce77a7$var$ForwardRef = $3ZYaX.forwardRef($f97462e081ce77a7$var$UserRemoveIcon);
var $f97462e081ce77a7$export$2e2bcd8739ae039 = $f97462e081ce77a7$var$ForwardRef;


/**
 * Utility function to safely get work period data
 * @param data - The row data containing mission information
 * @param dayIndex - The index of the day to get work period for
 * @returns The work period if it exists, null otherwise
 */ const $a38928329aae9141$var$getWorkPeriod = (data, day)=>{
    const workPeriod = (0, $dda2f26c3659cf93$export$53785d8c3b1ae6dc)(data.mission.workPeriods, day);
    return workPeriod || null;
};
/**
 * Creates a render function for work period cells.
 *
 * For employer members the cell is wrapped in a WorkPeriodLink that handles
 * both real and virtual (template-based) work periods. Virtual WPs are
 * materialized on click before navigating to the detail page.
 *
 * @param day - The calendar day this column represents
 * @param renderFn - Function to render the cell content
 * @returns A render function for the cell
 */ const $a38928329aae9141$var$renderWorkPeriodCell = (day, renderFn)=>{
    return (data)=>{
        const workPeriod = $a38928329aae9141$var$getWorkPeriod(data, day);
        if (!workPeriod) return null;
        const strikethroughStyle = workPeriod.isCancelled || workPeriod.isAbandoned ? {
            textDecoration: 'line-through',
            textDecorationThickness: '1px'
        } : {};
        // Employer members get a clickable link (handles virtual WP materialization)
        if ((0, $8403deec6a28521e$export$6025088343704f9f)([
            'employerMember'
        ])) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $86213dc9c75e3746$export$2e2bcd8739ae039), {
            workPeriod: workPeriod,
            textColor: "dark",
            style: strikethroughStyle,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                children: renderFn(workPeriod, data)
            })
        });
        // Other roles: plain text, no link
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "span",
            textColor: "dark",
            style: strikethroughStyle,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                children: renderFn(workPeriod, data)
            })
        });
    };
};
const $a38928329aae9141$var$createWorkPeriodColumnsGroup = ({ day: day, dayIndex: dayIndex, handleValidation: handleValidation, hideActions: hideActions, minimalMode: minimalMode, employerRules: employerRules, isDayWithoutWorkPeriods: isDayWithoutWorkPeriods, specialPeriods: specialPeriods })=>{
    const specialPeriodsNames = specialPeriods?.map((specialPeriod)=>specialPeriod.name).join(', ');
    const header = specialPeriodsNames ? `${(0, $74f17ceb9b5a08a5$export$a7f242eff11c1345)(day)} (${specialPeriodsNames})` : (0, $74f17ceb9b5a08a5$export$a7f242eff11c1345)(day);
    const buildClassName = (className = '')=>{
        if (specialPeriodsNames) className += ' has-background-primary-light';
        return className;
    };
    const employerRulesColumns = employerRules.map((rule)=>({
            header: rule.shortName,
            id: `day-${dayIndex}-${rule.name}-${rule.ruleId}`,
            isHidden: minimalMode,
            className: buildClassName(),
            render: (data)=>{
                const workPeriod = $a38928329aae9141$var$getWorkPeriod(data, day);
                const weekDayNumber = (0, $74f17ceb9b5a08a5$export$a155f41bf7aedf47)((0, $aa33e773084f22af$export$2e2bcd8739ae039)(day));
                const value = rule.kind === 'goal' ? data.totals.days[weekDayNumber]?.employerData.goals[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)] ?? null : data.totals.days[weekDayNumber]?.employerData.durations[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(rule.ruleId)] ?? null;
                if (!workPeriod && !value) return null;
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$1d20afe38ad9e2c7), {
                    employerRule: rule,
                    value: value,
                    textColor: workPeriod ? (0, $dda2f26c3659cf93$export$3e79e33023df6cfe)(workPeriod, 'other') : ''
                });
            }
        }));
    if (isDayWithoutWorkPeriods) return {
        Header: (0, $74f17ceb9b5a08a5$export$a7f242eff11c1345)(day),
        id: `day-${dayIndex}`,
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        "data-tooltip": "Jour sans p\xe9riodes de travail",
                        size: "small",
                        color: "grey",
                        style: {
                            marginRight: '2.0rem'
                        },
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f97462e081ce77a7$export$2e2bcd8739ae039), {})
                    })
                }),
                id: `day-${dayIndex}-no-work-periods`,
                className: 'table-section-start'
            }
        ])
    };
    return {
        Header: header,
        id: `day-${dayIndex}`,
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: "D\xe9but",
                id: `day-${dayIndex}-start`,
                className: buildClassName('table-section-start'),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const cellData = (0, $dda2f26c3659cf93$export$820ff448dbc5a915)(workPeriod, 'start');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$f09ee714f6c36863), {
                        date: cellData.date,
                        textColor: cellData.color,
                        tooltipId: cellData.tooltipId,
                        tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $308c1cd63178b19b$export$98d2b46eb2bc391a), {
                            workPeriod: workPeriod,
                            type: "start"
                        })
                    });
                })
            },
            {
                header: 'Fin',
                id: `day-${dayIndex}-end`,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const cellData = (0, $dda2f26c3659cf93$export$820ff448dbc5a915)(workPeriod, 'end');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$f09ee714f6c36863), {
                        date: cellData.date,
                        textColor: cellData.color,
                        tooltipId: cellData.tooltipId,
                        tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $308c1cd63178b19b$export$98d2b46eb2bc391a), {
                            workPeriod: workPeriod,
                            type: "end"
                        })
                    });
                })
            },
            {
                header: 'Pause',
                id: `day-${dayIndex}-break`,
                isHidden: minimalMode,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const cellData = (0, $dda2f26c3659cf93$export$820ff448dbc5a915)(workPeriod, 'break');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: workPeriod.summary.durations.breaks,
                        tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f3af7e3d169ca270$export$6127403115f642b4), {
                            workPeriod: workPeriod
                        }),
                        tooltipId: cellData.tooltipId,
                        textColor: cellData.color
                    });
                })
            },
            {
                header: 'Jour',
                id: `day-${dayIndex}-day`,
                isHidden: minimalMode,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const color = (0, $dda2f26c3659cf93$export$3e79e33023df6cfe)(workPeriod, 'other');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: workPeriod.summary.durations.worked.day,
                        textColor: color
                    });
                })
            },
            {
                header: 'Nuit',
                id: `day-${dayIndex}-night`,
                isHidden: minimalMode,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const color = (0, $dda2f26c3659cf93$export$3e79e33023df6cfe)(workPeriod, 'other');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: workPeriod.summary.durations.worked.night,
                        textColor: color
                    });
                })
            },
            {
                header: 'N.Effectif',
                id: `day-${dayIndex}-benefit`,
                isHidden: minimalMode,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const color = (0, $dda2f26c3659cf93$export$3e79e33023df6cfe)(workPeriod, 'event');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d455a59192b91e87$export$a489e25971764706), {
                        duration: workPeriod.summary.durations.benefit,
                        textColor: color
                    });
                })
            },
            ...employerRulesColumns,
            {
                header: // @ts-expect-error
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$62c533d39ecbd200), {
                    workPeriod: {
                        tags: [
                            {}
                        ]
                    },
                    type: "icon",
                    small: true,
                    text: "Cat\xe9gories"
                }),
                id: `day-${dayIndex}-tags`,
                isHidden: minimalMode,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$62c533d39ecbd200), {
                            workPeriod: workPeriod,
                            type: "icon",
                            small: true
                        })
                    });
                })
            },
            {
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$b89ed0bd7f7384f6), {
                    workPeriod: {
                        isAbandoned: true
                    },
                    type: "icon",
                    small: true,
                    iconColor: "dark"
                }),
                id: `day-${dayIndex}-interruption`,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$b89ed0bd7f7384f6), {
                        workPeriod: workPeriod,
                        type: "icon",
                        small: true
                    }))
            },
            {
                id: `day-${dayIndex}-events`,
                header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$8d6fc50e3f3f6bf5), {
                    workPeriod: {
                        events: [
                            {
                                item: {
                                    type: 'benefit',
                                    _id: 'benefit',
                                    code: 'label',
                                    title: 'info',
                                    employer: '_id',
                                    indicatesAbsence: true
                                },
                                comment: ''
                            }
                        ]
                    },
                    text: "Ev\xe8nements",
                    type: "icon",
                    small: true,
                    iconColor: 'dark'
                }),
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod)=>{
                    const color = (0, $dda2f26c3659cf93$export$3e79e33023df6cfe)(workPeriod, 'event');
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$8d6fc50e3f3f6bf5), {
                            workPeriod: workPeriod,
                            type: "icon",
                            small: true,
                            iconColor: color
                        })
                    });
                })
            },
            {
                header: 'Valider',
                id: `day-${dayIndex}-validated`,
                isHidden: hideActions,
                className: buildClassName(),
                render: $a38928329aae9141$var$renderWorkPeriodCell(day, (workPeriod, data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        action: {
                            resource: 'missions',
                            name: 'validateWorkPeriod'
                        },
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            onClick: (e)=>e.preventDefault(),
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $801415e870a9139e$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod,
                                label: "",
                                type: "button",
                                size: "smallest",
                                onClick: (workPeriod)=>handleValidation && handleValidation({
                                        ...workPeriod,
                                        mission: {
                                            ...data.mission,
                                            _id: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission)
                                        }
                                    })
                            })
                        })
                    }))
            }
        ])
    };
};
var $a38928329aae9141$export$2e2bcd8739ae039 = $a38928329aae9141$var$createWorkPeriodColumnsGroup;



var $3ZYaX = parcelRequire("3ZYaX");
/**
 * Checks if two work periods overlap on the same day
 */ const $9c09fd157bf6e399$var$workPeriodsOverlapSameDay = (wp1, wp2)=>{
    const date1 = new Date(wp1.start.date).setHours(0, 0, 0, 0);
    const date2 = new Date(wp2.start.date).setHours(0, 0, 0, 0);
    return date1 === date2;
};
/**
 * Groups similar missions based on common characteristics
 * Merge missions with the same characteristics into one mission for one row
 * @param missions - Array of missions to group
 * @param excludeGroupKeys - Optional array of groupKeys to exclude from grouping
 */ const $9c09fd157bf6e399$var$mergeSimilarMissionsAsOneRow = (missions, excludeGroupKeys = [])=>{
    const missionGroups = missions.reduce((groups, mission)=>{
        const key = [
            mission.user?._id,
            mission.interimAgency?._id || 'noAgency',
            mission.employer._id,
            mission.service._id,
            mission.jobTitle._id
        ].join('_');
        // Si la clé est dans excludeGroupKeys, on crée un groupe unique pour cette mission
        const keyIsInExcludeGroupKeys = excludeGroupKeys.includes(key);
        const groupKey = keyIsInExcludeGroupKeys ? `${key}_${mission._id}` : key;
        if (!groups[groupKey]) groups[groupKey] = [];
        // Find or create a compatible subgroup
        let foundCompatibleGroup = false;
        for (const subgroup of groups[groupKey]){
            const workPeriodsOverlap = mission.workPeriods.some((wp1)=>subgroup.workPeriods.some((wp2)=>$9c09fd157bf6e399$var$workPeriodsOverlapSameDay(wp1, wp2)));
            if (!workPeriodsOverlap) {
                // Add to existing compatible subgroup
                subgroup.workPeriods.push(...mission.workPeriods);
                subgroup.groupedMissions.push(mission);
                subgroup.start = new Date(Math.min(new Date(subgroup.start).getTime(), new Date(mission.start).getTime()));
                subgroup.end = new Date(Math.max(new Date(subgroup.end).getTime(), new Date(mission.end).getTime()));
                subgroup.forceNotGrouped = keyIsInExcludeGroupKeys;
                subgroup.groupedKey = groupKey;
                subgroup.mainGroupKey = key;
                foundCompatibleGroup = true;
                break;
            }
        }
        if (!foundCompatibleGroup) // Create new subgroup
        groups[groupKey].push({
            ...mission,
            workPeriods: [
                ...mission.workPeriods
            ],
            groupedMissions: [
                mission
            ],
            groupedKey: groupKey,
            mainGroupKey: key,
            forceNotGrouped: keyIsInExcludeGroupKeys
        });
        return groups;
    }, {});
    // Flatten all subgroups
    return Object.values(missionGroups).flat().sort((a, b)=>new Date(a.start).getTime() - new Date(b.start).getTime());
};
/**
 * Transforme les données de WeekSummary en format TableRowData
 * et les trie par nom et prénom de l'utilisateur
 * @param data - Les données de résumé de la semaine
 * @returns Un tableau trié de TableRowData
 */ const $9c09fd157bf6e399$var$useTableData = (users, excludeGroupKeys)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const rows = users.flatMap((userSummary, index)=>{
            const mergedSimilairMissionsToOneRow = $9c09fd157bf6e399$var$mergeSimilarMissionsAsOneRow(//@ts-ignore
            userSummary.missions, excludeGroupKeys);
            const userMissionCount = userSummary.missions.length;
            const userMissionCountAfterMerge = mergedSimilairMissionsToOneRow.length;
            // On calcule le nombre de lignes à fusionner
            return mergedSimilairMissionsToOneRow.map((mission, index)=>{
                const rowSpan = index === 0 ? userMissionCount - (userMissionCount - userMissionCountAfterMerge) : 1;
                return {
                    user: userSummary.user,
                    mission: mission,
                    weekIsValidated: userSummary.weekIsValidated,
                    interimAgencyOrEmployerId: userSummary.interimAgencyOrEmployerId.toString(),
                    costs: userSummary.totals.costs,
                    durations: userSummary.totals.durations,
                    employerData: userSummary.totals.employerData,
                    totals: userSummary.totals,
                    rowGroupOptions: {
                        groupedKey: mission.groupedKey,
                        isFirstMission: index === 0,
                        totalMissions: mission.groupedMissions.length,
                        rowSpan: rowSpan
                    },
                    userMissionsCount: userMissionCount
                };
            });
        });
        return rows;
    }, [
        users,
        excludeGroupKeys
    ]);
var $9c09fd157bf6e399$export$2e2bcd8739ae039 = $9c09fd157bf6e399$var$useTableData;




parcelRequire("3ZYaX");


parcelRequire("3ZYaX");



const $a513a452a4a0f831$var$MissionWeekValidateButton = ({ label: label, onClick: onClick, mission: mission, size: size, type: type })=>{
    const { _id: _id } = mission;
    const tooltipId = `validate-mission-${_id}`;
    const weekCanBeValidated = mission.__actions.weekCanBeValidated;
    if (weekCanBeValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        "data-tip": !weekCanBeValidated,
        "data-for": tooltipId,
        children: [
            !weekCanBeValidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                id: tooltipId,
                effect: "solid",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    textAlign: 'center',
                    children: [
                        "Validation impossible",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "Une journ\xe9e avec pointage d'entr\xe9e",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "ne contient pas de pointage de sortie."
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                style: size === 'smallest' ? {
                    height: '1.5rem'
                } : {},
                size: size === 'smallest' ? 'small' : size,
                type: type,
                color: weekCanBeValidated ? 'link' : '',
                onClick: ()=>onClick(mission),
                disabled: !weekCanBeValidated,
                "data-test": "validate-week",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7a838bc26f0582fd), {})
                    }),
                    label && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        children: label
                    })
                ]
            })
        ]
    });
    else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};
var $a513a452a4a0f831$export$2e2bcd8739ae039 = $a513a452a4a0f831$var$MissionWeekValidateButton;






/**
 * Creates a column group for week-level actions
 * @param props Component props
 * @returns Column group definition
 */ const $5b4613b64392c0d6$var$weekActionsColumnsGroup = ()=>{
    return {
        Header: 'Actions',
        id: 'week-actions',
        columns: (0, $c271cdd7b21eaa77$export$5570d3b32630dd60)([
            {
                header: 'Valider',
                id: 'week-validate',
                className: 'table-section-end',
                shouldMerge: true,
                isHidden: !(0, $8403deec6a28521e$export$6025088343704f9f)([
                    'employerMember'
                ]),
                render: (data)=>{
                    const mutation = (0, $7040c29cc25c4df6$export$15cde0eec5c3d0b0)();
                    const isCurrentMutation = mutation.variables?.workPeriodsIds.includes((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(data.mission.workPeriods[0]));
                    if (isCurrentMutation && mutation.status === 'loading') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
                    if (isCurrentMutation && mutation.status === 'success') return null;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a513a452a4a0f831$export$2e2bcd8739ae039), {
                        mission: data.mission,
                        onClick: ()=>mutation.mutate({
                                workPeriodsIds: data.mission.workPeriods.filter((wp)=>wp.isValidated === false).map((wp)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(wp)),
                                isValidated: true
                            }),
                        size: "smallest"
                    });
                }
            }
        ])
    };
};
var $5b4613b64392c0d6$export$2e2bcd8739ae039 = $5b4613b64392c0d6$var$weekActionsColumnsGroup;





const $d1d9c847571156fe$var$SummaryTableV2 = ({ data: data, displayDay: displayDay, start: start, end: end, hideActions: hideActions, minimalMode: minimalMode, forceEmployerRules: forceEmployerRules })=>{
    const [excludeGroupKeys, setExcludeGroupKeys] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState([]);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentOrganization);
    const summaryFilters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions]) // TODO: refactor => acces to filters is not good
    ;
    const daysWithoutWorkPeriods = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!minimalMode) return [];
        // On crée un tableau avec tous les jours de la semaine (0-6)
        const allWeekDays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        // On filtre pour ne garder que les jours qui n'ont pas de périodes de travail
        return allWeekDays.filter((weekDay)=>{
            // On crée une date pour ce jour de la semaine
            const dayDate = new Date(start);
            dayDate.setDate(dayDate.getDate() + weekDay);
            // On vérifie si le jour a des périodes de travail
            const hasWorkPeriods = data.users.some((user)=>user.missions.some((mission)=>mission.workPeriods.some((workPeriod)=>new Date(workPeriod.start.date).toDateString() === dayDate.toDateString())));
            // On retourne true si le jour n'a pas de périodes de travail
            return !hasWorkPeriods;
        });
    }, [
        data,
        start
    ]);
    // Détermine les jours à afficher
    const days = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (displayDay) return [
            new Date(displayDay)
        ];
        return (0, $74f17ceb9b5a08a5$export$df05c8d7c056b9c6)(new Date(start), new Date(end));
    }, [
        displayDay,
        start,
        end
    ]);
    let employerRules = data.employerRules;
    if (currentOrganization.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency && summaryFilters.employer.length !== 1 && !forceEmployerRules) employerRules = [];
    let specialPeriods = data.specialPeriods;
    if (currentOrganization.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency && summaryFilters.employer.length !== 1 && !forceEmployerRules) specialPeriods = data.specialPeriods.filter((specialPeriod)=>{
        return (0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(specialPeriod.employer, currentOrganization._id);
    });
    const tableColumns = $d1d9c847571156fe$var$useColumns(start, end, employerRules, setExcludeGroupKeys, excludeGroupKeys, days, daysWithoutWorkPeriods, displayDay, hideActions, minimalMode, specialPeriods);
    const tableData = (0, $9c09fd157bf6e399$export$2e2bcd8739ae039)(data.users, excludeGroupKeys);
    // Handle sticky first sections (worker & week state)
    const tableRef = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useRef(null);
    const summaryPagination = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.filters.pagination.summary);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!tableRef.current) return;
        const updateStickyColumns = ()=>{
            const rows = tableRef.current?.querySelectorAll('tr');
            if (!rows) return;
            rows.forEach((row)=>{
                let offset = 0;
                const cols = row.querySelectorAll('.sticky');
                cols.forEach((col)=>{
                    col.style.left = `${offset}px`;
                    offset += col.offsetWidth;
                });
            });
        };
        // Initial update
        updateStickyColumns();
        // Add resize listener
        window.addEventListener('resize', updateStickyColumns);
        // Cleanup
        return ()=>{
            window.removeEventListener('resize', updateStickyColumns);
        };
    }, [
        tableRef,
        summaryFilters,
        summaryPagination,
        excludeGroupKeys
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: tableData,
        noDataMessage: "Aucune mission \xe0 afficher",
        className: "ml-2",
        tableRef: tableRef,
        dataTest: "summary-table"
    });
};
const $d1d9c847571156fe$var$useColumns = (start, end, employerRules, setExcludeGroupKeys, excludeGroupKeys, days, daysWithoutWorkPeriods, displayDay, hideActions, minimalMode, specialPeriods)=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const workPeriodValidateMutation = (0, $7040c29cc25c4df6$export$6cbf757d2bdf6301)();
    const handleValidation = (workPeriod)=>{
        workPeriodValidateMutation.mutate({
            workPeriodId: workPeriod._id,
            isValidated: !workPeriod.isValidated
        });
    };
    const daysEmployerRules = employerRules.filter((rule)=>rule.display.summary.days);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const summaryColumns = [];
        //User name section
        (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $477360998adbd69d$export$2e2bcd8739ae039)());
        //Week state section
        (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $2f81c272f786e7d0$export$2e2bcd8739ae039)({
            start: start,
            minimalMode: minimalMode
        }));
        // Mission section
        (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $824c96a0314d7a3e$export$2e2bcd8739ae039)({
            currentUserRole: currentUserRole,
            minimalMode: minimalMode,
            setExcludeGroupKeys: setExcludeGroupKeys,
            excludeGroupKeys: excludeGroupKeys
        }));
        // Days section
        days.forEach((day, dayIndex)=>{
            const isDayWithoutWorkPeriods = days.length !== 1 && daysWithoutWorkPeriods.includes(dayIndex);
            const employerRulesForDay = daysEmployerRules.filter((rule)=>rule.daysOfWeek?.includes(dayIndex));
            const specialPeriodsForDay = specialPeriods.filter((specialPeriod)=>{
                return (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(day, {
                    start: new Date(specialPeriod.startDate),
                    end: new Date(specialPeriod.endDate)
                });
            });
            (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $a38928329aae9141$export$2e2bcd8739ae039)({
                day: day,
                dayIndex: dayIndex,
                handleValidation: handleValidation,
                hideActions: hideActions,
                minimalMode: minimalMode,
                employerRules: employerRulesForDay,
                isDayWithoutWorkPeriods: isDayWithoutWorkPeriods,
                specialPeriods: specialPeriodsForDay
            }));
        });
        if (!displayDay) {
            // Total durations section
            (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $3efaddb4d035b821$export$2e2bcd8739ae039)({
                hideActions: hideActions,
                minimalMode: minimalMode,
                employerRules: employerRules
            }));
            // Costs section
            (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $d64fc256c69e47ea$export$2e2bcd8739ae039)({
                hideActions: hideActions,
                minimalMode: minimalMode,
                employerRules: employerRules
            }));
        }
        if (!hideActions) (0, $c271cdd7b21eaa77$export$eb1e781dd8518b2)(summaryColumns, (0, $5b4613b64392c0d6$export$2e2bcd8739ae039)());
        return summaryColumns;
    }, [
        start,
        end,
        currentUserRole,
        displayDay,
        workPeriodValidateMutation,
        hideActions,
        minimalMode,
        setExcludeGroupKeys,
        excludeGroupKeys,
        employerRules,
        daysWithoutWorkPeriods
    ]);
};
var $d1d9c847571156fe$export$2e2bcd8739ae039 = $d1d9c847571156fe$var$SummaryTableV2;


const $3b05ff530aceedcc$var$Summary = ()=>{
    const filters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions]);
    const { start: start, end: end, displayDay: displayDay, summaryMinimalMode: summaryMinimalMode } = filters;
    const pagination = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters.pagination.summary);
    const setPagination = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.filters.setPagination);
    const summaryQuery = (0, $e409591b67738e56$export$3c54b31350a650f7)();
    const summaryData = summaryQuery.data ? {
        ...summaryQuery.data,
        users: (0, $2KSUA.chunk)((0, $2KSUA.sortBy)(summaryQuery.data.users || [], [
            (item)=>(item.user.lastName || '').toLowerCase(),
            (item)=>(item.user.firstName || '').toLowerCase(),
            'user._id',
            'interimAgencyOrEmployerId'
        ]), pagination.itemsPerPage)[pagination.currentPage - 1] || []
    } : null;
    const missionsCount = summaryQuery.data?.users?.length || 0;
    const totals = summaryQuery.data?.totals;
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        // TODO: maybe managed by table component?
        const summaryItemsCount = summaryQuery.data?.users?.length || 1;
        if (summaryItemsCount / pagination.itemsPerPage < pagination.currentPage - 1) setPagination('summary', {
            currentPage: 1,
            itemsPerPage: pagination.itemsPerPage
        });
    }, [
        pagination.currentPage,
        summaryQuery.data
    ]);
    //Pre billing modal state
    const preBillingModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const preBillingDisabled = filters.interimAgency?.length !== 1;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            !preBillingDisabled && filters.interimAgency?.[0] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $712e01e4a589fb70$export$2e2bcd8739ae039), {
                ...preBillingModal,
                interimAgencyId: filters.interimAgency[0],
                start: start,
                end: end,
                service: filters.service,
                jobTitle: filters.jobTitle
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                pb: 2,
                px: 1,
                pt: 5,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    breakpoint: 'fluid',
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                        mb: 3,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Left, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    backgroundColor: "primary-light",
                                    style: {
                                        borderRadius: '5px'
                                    },
                                    p: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $efaf9714fbe282ce$export$2e2bcd8739ae039), {
                                        showDayFilter: true,
                                        showSummaryMinimalModeFilter: true,
                                        showEventsFilter: true,
                                        disabledQueries: summaryQuery.isLoading
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "span",
                                                mr: 2,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b2d8c51042f4efd0$export$2e2bcd8739ae039), {
                                                    filters: {
                                                        ...filters,
                                                        start: filters.start && (0, $74f17ceb9b5a08a5$export$dcb6c460bf415cf3)(filters.start),
                                                        end: filters.end && (0, $74f17ceb9b5a08a5$export$dcb6c460bf415cf3)(filters.end)
                                                    }
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'employerMember'
                                        ],
                                        action: {
                                            resource: 'periodSummaries',
                                            name: 'create'
                                        },
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $23348fff11010b14$export$2e2bcd8739ae039), {
                                            fullwidth: true,
                                            onClick: ()=>preBillingModal.setIsDisplayed(true),
                                            color: 'primary',
                                            disabled: preBillingDisabled,
                                            tooltip: {
                                                text: "S\xe9l\xe9ctionner une seule agence d'int\xe9rim pour cr\xe9er une pr\xe9-facturation",
                                                show: preBillingDisabled,
                                                id: 'pre-billing-action'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ddf80f27ca83567b), {})
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                    children: "Pr\xe9-facturation"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                breakpoint: 'fluid',
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                        p: 4,
                        backgroundColor: "white-bis",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $38062497b70ee6aa$export$2e2bcd8739ae039), {
                            startOfWeek: start,
                            endOfWeek: end,
                            interimAgencyId: filters.interimAgency?.length === 1 ? filters.interimAgency[0] : undefined,
                            currentDay: displayDay && totals && {
                                label: `${(0, $2KSUA.upperFirst)((0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(displayDay))}`,
                                ...totals.days[(0, $74f17ceb9b5a08a5$export$a155f41bf7aedf47)((0, $aa33e773084f22af$export$2e2bcd8739ae039)(new Date(displayDay)))]
                            },
                            totals: totals,
                            missionsCount: missionsCount,
                            showEmployerCosts: Boolean((0, $8403deec6a28521e$export$6025088343704f9f)([
                                'employerMember'
                            ]) || (0, $8403deec6a28521e$export$6025088343704f9f)([
                                'interimAgencyMember'
                            ]) && filters.employer?.length === 1),
                            employerRules: summaryQuery.data?.employerRules
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Section), {
                        className: "summary-table",
                        style: {
                            padding: 0
                        },
                        children: [
                            !summaryQuery.isLoading && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ff34a0a5311d1f6e$export$2e2bcd8739ae039), {
                                currentPage: pagination.currentPage,
                                missionsPerPage: pagination.itemsPerPage,
                                missionsCount: missionsCount,
                                onChange: (currentPage)=>setPagination('summary', {
                                        currentPage: currentPage,
                                        itemsPerPage: pagination.itemsPerPage
                                    })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                                breakpoint: 'fluid',
                                style: {
                                    padding: 0
                                },
                                mt: 5,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textSize: 7,
                                    children: !summaryQuery.isLoading && summaryData ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1d9c847571156fe$export$2e2bcd8739ae039), {
                                        data: summaryData,
                                        start: start,
                                        end: end,
                                        minimalMode: summaryMinimalMode,
                                        displayDay: displayDay
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        display: "flex",
                                        justifyContent: "center",
                                        flexDirection: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                textSize: 5,
                                                display: "flex",
                                                justifyContent: "center",
                                                my: 5,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {
                                                            mr: 5
                                                        }),
                                                        "Mise \xe0 jour des donn\xe9es du r\xe9capitulatif"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                                                breakpoint: 'widescreen',
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Progress), {
                                                    color: "primary",
                                                    size: 'small',
                                                    px: 6
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            !summaryQuery.isLoading && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ff34a0a5311d1f6e$export$2e2bcd8739ae039), {
                                currentPage: pagination.currentPage,
                                missionsPerPage: pagination.itemsPerPage,
                                missionsCount: missionsCount,
                                onChange: (currentPage)=>setPagination('summary', {
                                        currentPage: currentPage,
                                        itemsPerPage: pagination.itemsPerPage
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3b05ff530aceedcc$export$2e2bcd8739ae039 = $3b05ff530aceedcc$var$Summary;



parcelRequire("3ZYaX");






var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");

var $2KSUA = parcelRequire("2KSUA");



parcelRequire("3ZYaX");

const $dc5e1e1bff7b8284$var$ComponentFooter = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
        mt: 5,
        ...rest,
        children: children
    });
const $dc5e1e1bff7b8284$var$Left = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        children: children
    });
const $dc5e1e1bff7b8284$var$Right = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        narrow: true,
        children: children
    });
$dc5e1e1bff7b8284$var$ComponentFooter.Left = $dc5e1e1bff7b8284$var$Left;
$dc5e1e1bff7b8284$var$ComponentFooter.Right = $dc5e1e1bff7b8284$var$Right;
var $dc5e1e1bff7b8284$export$2e2bcd8739ae039 = $dc5e1e1bff7b8284$var$ComponentFooter;




const $bd6fa291827fb0f7$var$UpdateEmail = ({ user: user })=>{
    const mutation = (0, $e607e015ac40917d$export$5cd4fe36d9d62971)();
    const newEmail = (0, $3ZYaX.useRef)('');
    const initialValues = {
        email: user.email
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        //TODO: validation?!
        onSubmit: (values)=>{
            newEmail.current = values.email;
            mutation.mutate(values.email);
        },
        children: ({ values: values })=>{
            const submitDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($2KSUA))).isEqual(initialValues, values);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: "Mettre \xe0 jour l'adresse email"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Adresse email",
                                                name: "email",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                type: "email",
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                            color: "primary",
                                                            type: "submit",
                                                            mutation: mutation,
                                                            disabled: submitDisabled,
                                                            children: "Mettre \xe0 jour les Informations"
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                textWeight: "bold",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                    mutation: mutation,
                                                    displayOn: {
                                                        success: `Votre demande a \xe9t\xe9 envoy\xe9e, merci de v\xe9rifier votre boite mail \xe0 l'adresse ${newEmail?.current}`
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Left, {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Right, {})
                        ]
                    })
                ]
            });
        }
    });
};
var $bd6fa291827fb0f7$export$2e2bcd8739ae039 = $bd6fa291827fb0f7$var$UpdateEmail;




var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");

var $2KSUA = parcelRequire("2KSUA");






const $1e91cc064e42489f$var$UpdateCommonInformations = ({ user: user })=>{
    const mutation = (0, $e607e015ac40917d$export$cac0b33e6f13c8ec)();
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((store)=>store.session.currentUserRole);
    const isDisabled = currentUserRole === 'worker';
    const initialValues = {
        firstName: user.firstName,
        lastName: user.lastName
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        onSubmit: (values)=>{
            mutation.mutate({
                ...values,
                id: user._id
            });
        },
        children: ({ values: values })=>{
            const submitDisabled = (0, (/*@__PURE__*/$parcel$interopDefault($2KSUA))).isEqual(initialValues, values);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: "Informations de base"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Nom de Naissance",
                                                name: "lastName",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                disabled: isDisabled
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Pr\xe9nom",
                                                name: "firstName",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                disabled: isDisabled
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                                mutation: mutation,
                                                                displayOn: {
                                                                    success: "Mise \xe0 jour effectu\xe9e"
                                                                }
                                                            }),
                                                            "\xa0"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                            color: "primary",
                                                            type: "submit",
                                                            mutation: mutation,
                                                            disabled: submitDisabled || isDisabled,
                                                            children: "Mettre \xe0 jour les Informations"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    isDisabled ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        mb: 6,
                        color: "warning",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: "Contactez votre Employeur pour mettre \xe0 jour vos Informations de base"
                        })
                    }) : undefined,
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039), {})
                ]
            });
        }
    });
};
var $1e91cc064e42489f$export$2e2bcd8739ae039 = $1e91cc064e42489f$var$UpdateCommonInformations;




var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");







const $5557e4e5ba6fb044$var$UpdatePassword = ({ user: user })=>{
    const mutation = (0, $e607e015ac40917d$export$cac0b33e6f13c8ec)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const logout = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.logout);
    if (mutation.isSuccess) {
        logout();
        navigate('/login', {
            state: {
                message: {
                    color: 'success',
                    header: "Mot de passe mis \xe0 jour",
                    body: 'Vouss pouvez maintenant vous reconnecter avec votre nouveau mot de passe'
                }
            }
        });
    }
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            currentPassword: '',
            newPassword: '',
            confirmNewPassword: ''
        },
        validate: (values)=>{
            const errors = {};
            if (!values.currentPassword) errors.currentPassword = 'Champ requis';
            if (!values.newPassword) errors.newPassword = 'Champ requis';
            if (!values.confirmNewPassword) errors.confirmNewPassword = 'Champ requis';
            if (values.newPassword !== values.confirmNewPassword) errors.confirmNewPassword = "Les deux mots de passe doivent \xeatre similaires";
            return errors;
        },
        onSubmit: (values)=>{
            const { currentPassword: oldPassword, newPassword: password } = values;
            mutation.mutate({
                oldPassword: oldPassword,
                password: password,
                id: user._id
            });
        },
        children: ({ values: values })=>{
            const submitDisabled = values.currentPassword.length === 0 || values.newPassword.length === 0 || values.confirmNewPassword.length === 0 || (0, $d92bced011ae5ac2$export$e36e0bbf46ae5cf3)(values.newPassword) || (0, $d92bced011ae5ac2$export$e36e0bbf46ae5cf3)(values.confirmNewPassword);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: "Changer le mot de passe"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$65ed9482db2257fa), {
                                                label: "Ancien mot de passe",
                                                name: "currentPassword"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    mb: 5,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                                        label: "Nouveau mot de passe",
                                                        name: "newPassword"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                                    label: "Confirmez le nouveau mot de passe",
                                                    name: "confirmNewPassword"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: [
                                                            "\xa0",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                                mutation: mutation,
                                                                displayOn: {
                                                                    error: 'Ancien mot de passe incorrect'
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                            color: "primary",
                                                            type: "submit",
                                                            mutation: mutation,
                                                            disabled: submitDisabled,
                                                            children: "Mettre \xe0 jour les Informations"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Left, {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Right, {})
                        ]
                    })
                ]
            });
        }
    });
};
var $5557e4e5ba6fb044$export$2e2bcd8739ae039 = $5557e4e5ba6fb044$var$UpdatePassword;





var $3ZYaX = parcelRequire("3ZYaX");
function $c6feac4c9f59e4b8$var$ExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
        clipRule: "evenodd"
    }));
}
const $c6feac4c9f59e4b8$var$ForwardRef = $3ZYaX.forwardRef($c6feac4c9f59e4b8$var$ExclamationIcon);
var $c6feac4c9f59e4b8$export$2e2bcd8739ae039 = $c6feac4c9f59e4b8$var$ForwardRef;


var $3ZYaX = parcelRequire("3ZYaX");
function $2a731cd08302011a$var$PrinterIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z",
        clipRule: "evenodd"
    }));
}
const $2a731cd08302011a$var$ForwardRef = $3ZYaX.forwardRef($2a731cd08302011a$var$PrinterIcon);
var $2a731cd08302011a$export$2e2bcd8739ae039 = $2a731cd08302011a$var$ForwardRef;


parcelRequire("3ZYaX");



parcelRequire("3ZYaX");




const $b634a08b3d46907e$var$RegenerateQrConfirmation = ({ show: show, hide: hide, user: user })=>{
    const regenerateUserQrCodeMutation = (0, $e607e015ac40917d$export$6b880607631b4612)();
    const onConfirm = ()=>{
        regenerateUserQrCodeMutation.mutate(user._id);
        hide();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
        onConfirm: onConfirm,
        show: show,
        onCancel: hide,
        confirmButtonLabel: "G\xe9n\xe9rer un nouveau QR Code",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "p",
                mb: 3,
                children: [
                    "Si vous g\xe9n\xe9rez un nouveau QR Code pour",
                    ' ',
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: user
                        })
                    }),
                    ' ',
                    ": ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                checked: true,
                children: "Le QR code g\xe9n\xe9r\xe9 pr\xe9c\xe9demment ne sera plus utilisable."
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                checked: true,
                children: "Cette op\xe9ration est irr\xe9versible !"
            })
        ]
    });
};
var $b634a08b3d46907e$export$2e2bcd8739ae039 = $b634a08b3d46907e$var$RegenerateQrConfirmation;



/**
 * Get the QR code of a user
 * @param userId - The id of the user to get the QR code of
 * @param isExternalWorker - Whether the user is an external worker
 * @returns The QR code of the user
 */ const $ca4535f1fdcf3410$var$useQrCode = (userId, isExternalWorker, forceDisabled)=>{
    const currentQrQuery = (0, $e607e015ac40917d$export$f6b80d8903d7979c)(userId, {
        enabled: !isExternalWorker && !forceDisabled
    });
    const currentWorkerQrQuery = (0, $e607e015ac40917d$export$2be68f8f4faaddde)(userId, {
        enabled: isExternalWorker && !forceDisabled
    });
    return currentQrQuery.data || currentWorkerQrQuery.data;
};
var $ca4535f1fdcf3410$export$2e2bcd8739ae039 = $ca4535f1fdcf3410$var$useQrCode;


const $68bb88384b952b03$var$UserQrCode = ({ user: user, print: print, canRegenerate: canRegenerate, isExternalWorker: isExternalWorker })=>{
    const qrCode = (0, $ca4535f1fdcf3410$export$2e2bcd8739ae039)(user._id, isExternalWorker);
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    if (!qrCode) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "p",
            children: "Aucun QR code trouv\xe9"
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "inline-block",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("img", {
                "data-test": "user-qr-code",
                src: `data:image/png;base64, ${qrCode}`
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button).Group, {
                px: 4,
                justifyContent: "space-between",
                children: [
                    print && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        renderAs: 'a',
                        href: `/print-qr/${user._id}`,
                        target: "_blank",
                        color: 'primary',
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2a731cd08302011a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                children: "Imprimer"
                            })
                        ]
                    }),
                    canRegenerate && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        color: "primary",
                        onClick: ()=>modal.setIsDisplayed(true),
                        "data-test": `regenerate-qr-code-${user._id}`,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c6feac4c9f59e4b8$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                children: "G\xe9n\xe9rer un Nouveau QR Code"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b634a08b3d46907e$export$2e2bcd8739ae039), {
                show: modal.isDisplayed,
                hide: ()=>modal.setIsDisplayed(false),
                user: user
            })
        ]
    });
};
var $68bb88384b952b03$export$2e2bcd8739ae039 = $68bb88384b952b03$var$UserQrCode;






var $3ZYaX = parcelRequire("3ZYaX");






parcelRequire("3ZYaX");

/**
 * Composant réutilisable pour la confirmation de suppression par recopie
 * Affiche un champ de saisie où l'utilisateur doit recopier une valeur exacte pour confirmer
 */ const $e9fc0357e5dc9c3f$var$ConfirmDeleteInput = ({ value: value, expectedValue: expectedValue, onChange: onChange, label: label, placeholder: placeholder, name: name })=>{
    const isValid = value === expectedValue;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        mt: 4,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                    children: label || /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "Pour confirmer, veuillez saisir ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                children: expectedValue
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                        value: value,
                        name: name || 'confirm-delete',
                        onChange: (e)=>onChange(e.target.value),
                        placeholder: placeholder || `Saisir "${expectedValue}"`,
                        color: value ? isValid ? 'success' : 'danger' : undefined,
                        style: {
                            color: 'black'
                        }
                    })
                })
            ]
        })
    });
};
var $e9fc0357e5dc9c3f$export$2e2bcd8739ae039 = $e9fc0357e5dc9c3f$var$ConfirmDeleteInput;


const $5ab25be900970cc2$export$25438b77c0613244 = ({ user: user })=>{
    const logout = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.logout);
    const deleteAccountMutation = (0, $e607e015ac40917d$export$94986b58b70e2d42)();
    const [displayModal, setDisplayModal] = (0, $3ZYaX.useState)(false);
    const [confirmTextInputValue, setConfirmTextInputValue] = (0, $3ZYaX.useState)('');
    const confirmText = user.email;
    const confirmTextIsValid = confirmTextInputValue === confirmText;
    if (deleteAccountMutation.isSuccess) logout();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                onClick: ()=>setDisplayModal(true),
                color: "danger",
                "data-test": "delete-my-account",
                size: 'small',
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c6feac4c9f59e4b8$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        children: "Supprimer d\xe9finitivement mon compte"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                onConfirm: ()=>{
                    if (!confirmTextIsValid) console.error('oops, button should not be clickable');
                    else deleteAccountMutation.mutate(user._id);
                },
                onCancel: ()=>setDisplayModal(false),
                title: "Supprimer d\xe9finitivement mon compte",
                show: displayModal,
                confirmButtonLabel: "Supprimer d\xe9finitivement mon compte",
                confirmButtonProps: {
                    disabled: confirmTextIsValid ? false : true
                },
                children: [
                    "Vous allez ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("u", {
                        children: "supprimer d\xe9finitivement"
                    }),
                    " le compte li\xe9 \xe0 l'adresse :",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        m: 3,
                        p: 3,
                        textAlign: 'center',
                        style: {
                            fontFamily: 'monospace'
                        },
                        children: user.email
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Content), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Vous ne pourrez plus vous connecter"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Vos donn\xe9es seront d\xe9finitivement effac\xe9es"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Vous ne recevrez plus de notifications"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                    children: [
                                        "Cette action est ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("u", {
                                            children: "irr\xe9versible"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e9fc0357e5dc9c3f$export$2e2bcd8739ae039), {
                        value: confirmTextInputValue,
                        expectedValue: confirmText,
                        onChange: setConfirmTextInputValue,
                        label: "Veuillez retaper votre adresse email ci-dessous pour confirmer la suppression d\xe9finitive de votre compte",
                        name: "confirm-delete-my-account"
                    })
                ]
            })
        ]
    });
};


const $ceb5ab6e94f2b9d0$var$UserDetails = ()=>{
    const user = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const userQuery = (0, $e607e015ac40917d$export$68dae0b0cacaa18a)(user?._id);
    if (!user || !userQuery.data) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                    title: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                        user: user
                    }),
                    subtitle: `D\xe9tail pour l'Utilisateur`
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Left, {}),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1e91cc064e42489f$export$2e2bcd8739ae039), {
                                            user: userQuery.data
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bd6fa291827fb0f7$export$2e2bcd8739ae039), {
                                            user: userQuery.data
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5557e4e5ba6fb044$export$2e2bcd8739ae039), {
                                            user: userQuery.data
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                            renderAs: "h2",
                                            size: 4,
                                            children: "Mon QR Code"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $68bb88384b952b03$export$2e2bcd8739ae039), {
                                            user: user,
                                            canRegenerate: true,
                                            print: true
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textAlign: 'center',
                                            backgroundColor: "danger-light",
                                            p: 3,
                                            py: 5,
                                            mt: 6,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5ab25be900970cc2$export$25438b77c0613244), {
                                                user: user
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $ceb5ab6e94f2b9d0$export$2e2bcd8739ae039 = $ceb5ab6e94f2b9d0$var$UserDetails;




var $3ZYaX = parcelRequire("3ZYaX");






parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $779a11b92f76b06d$var$UserAddIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
    }));
}
const $779a11b92f76b06d$var$ForwardRef = $3ZYaX.forwardRef($779a11b92f76b06d$var$UserAddIcon);
var $779a11b92f76b06d$export$2e2bcd8739ae039 = $779a11b92f76b06d$var$ForwardRef;



parcelRequire("3ZYaX");


// Export main component


var $3ZYaX = parcelRequire("3ZYaX");




var $31tXu = parcelRequire("31tXu");





var $39a46fa8815c50cd$export$2e2bcd8739ae039 = {
    roles: {
        status: {
            accepted: "Accept\xe9",
            pending: 'En attente',
            rejected: "Refus\xe9",
            discontinued: 'Interrompu'
        }
    },
    notifications: {
        settings: {
            missions: {
                updated: "Mission mise \xe0 jour",
                abandoned: "Mission abandon\xe9e",
                created: "Mission cr\xe9\xe9e",
                cancelled: "Mission annul\xe9e"
            },
            clockings: {
                created: 'Confirmation pointage'
            },
            workersRequests: {
                completed: "Demande compl\xe8te",
                postReplaced: "Remplacement effectu\xe9",
                created: 'Nouvelle demande',
                cancelled: "Demande annul\xe9e",
                updated: "Demande mise \xe0 jour",
                postNeedsReplacement: "Remplacement demand\xe9",
                postReOpened: "Poste r\xe9ouvert",
                postClosed: "Poste ferm\xe9"
            },
            periodSummaries: {
                created: "Nouvelle pr\xe9-facturation"
            },
            workers: {
                discontinued: 'Relation interrompue avec un travailleur'
            }
        }
    },
    organizationRoles: {
        'admin': 'Admin',
        'teamLeader': "Chef d'\xe9quipe",
        'clocker': 'Pointage uniquement'
    }
};





var $3ZYaX = parcelRequire("3ZYaX");



var $2KSUA = parcelRequire("2KSUA");





const $dc0a4f8b2c36ae1e$export$4a91a4c1a4184ce5 = (timeSlot)=>{
    return typeof timeSlot.startHour === 'number' && !isNaN(timeSlot.startHour) && typeof timeSlot.endHour === 'number' && !isNaN(timeSlot.endHour);
};
/**
 * Check if a time slot has at least one hour filled
 */ const $dc0a4f8b2c36ae1e$var$hasTimeSlotAnyHour = (timeSlot)=>{
    const hasStartHour = typeof timeSlot.startHour === 'number' && !isNaN(timeSlot.startHour);
    const hasEndHour = typeof timeSlot.endHour === 'number' && !isNaN(timeSlot.endHour);
    return hasStartHour || hasEndHour;
};
const $dc0a4f8b2c36ae1e$export$46d3bf96442dfbe0 = (timeSlot, index, dayName, scheduleIndex)=>{
    const errors = {};
    const basePath = `contractualSchedules.${scheduleIndex}.schedule.${dayName}.timeSlots.${index}`;
    // If both startHour and endHour are empty, the slot is considered empty and will be ignored
    // No validation error in this case
    const hasAnyHour = $dc0a4f8b2c36ae1e$var$hasTimeSlotAnyHour(timeSlot);
    if (!hasAnyHour) return errors // Empty slot, no validation needed
    ;
    // If at least one hour is filled, the other becomes required
    const hasStartHour = typeof timeSlot.startHour === 'number' && !isNaN(timeSlot.startHour);
    const hasEndHour = typeof timeSlot.endHour === 'number' && !isNaN(timeSlot.endHour);
    // Validate startHour (required if endHour is filled)
    if (!hasStartHour) errors[`${basePath}.startHour`] = "Heure de d\xe9but requise";
    else if (timeSlot.startHour < 0 || timeSlot.startHour > 24) errors[`${basePath}.startHour`] = "L'heure de d\xe9but doit \xeatre entre 0 et 24";
    // Validate endHour (required if startHour is filled)
    if (!hasEndHour) errors[`${basePath}.endHour`] = 'Heure de fin requise';
    else if (timeSlot.endHour < 0 || timeSlot.endHour > 24) errors[`${basePath}.endHour`] = "L'heure de fin doit \xeatre entre 0 et 24";
    // Validate that startHour and endHour are not equal (only if both are filled)
    if ($dc0a4f8b2c36ae1e$export$4a91a4c1a4184ce5(timeSlot) && timeSlot.startHour === timeSlot.endHour) errors[`${basePath}.endHour`] = "L'heure de fin ne peut pas \xeatre \xe9gale \xe0 l'heure de d\xe9but";
    return errors;
};
const $dc0a4f8b2c36ae1e$export$67b1ffa1998df9cb = (daySchedule, dayName, scheduleIndex)=>{
    const errors = {};
    const basePath = `contractualSchedules.${scheduleIndex}.schedule.${dayName}`;
    if (!daySchedule.timeSlots || !Array.isArray(daySchedule.timeSlots)) return errors;
    // Validate each time slot
    daySchedule.timeSlots.forEach((timeSlot, index)=>{
        const slotErrors = $dc0a4f8b2c36ae1e$export$46d3bf96442dfbe0(timeSlot, index, dayName, scheduleIndex);
        Object.assign(errors, slotErrors);
    });
    // Check for overlapping time slots and ensure chronological order
    // Only consider complete slots (with both startHour and endHour)
    const completeSlots = daySchedule.timeSlots.map((slot, index)=>({
            slot: slot,
            index: index
        })).filter(({ slot: slot })=>$dc0a4f8b2c36ae1e$export$4a91a4c1a4184ce5(slot)).map(({ slot: slot, index: index })=>{
        const startHour = slot.startHour;
        const endHour = slot.endHour;
        // Normalize end hour so overnight slots (end < start) extend into the next day
        const normalizedEnd = endHour >= startHour ? endHour : endHour + 24;
        return {
            slot: slot,
            originalIndex: index,
            normalizedStart: startHour,
            normalizedEnd: normalizedEnd
        };
    });
    if (completeSlots.length > 0) {
        const sortedSlots = [
            ...completeSlots
        ].sort((a, b)=>a.normalizedStart - b.normalizedStart);
        // Check if slots are in chronological order
        for(let i = 0; i < completeSlots.length; i++){
            const sortedSlot = sortedSlots[i];
            const currentSlot = completeSlots[i];
            if (sortedSlot && currentSlot && currentSlot.originalIndex !== sortedSlot.originalIndex) {
                errors[`${basePath}.timeSlots.${currentSlot.originalIndex}.startHour`] = "Les cr\xe9neaux doivent \xeatre tri\xe9s par ordre chronologique";
                break;
            }
        }
        // Check for overlaps (only between complete slots)
        for(let i = 0; i < sortedSlots.length - 1; i++){
            const currentSlot = sortedSlots[i];
            const nextSlot = sortedSlots[i + 1];
            if (!currentSlot || !nextSlot) continue;
            if (currentSlot.normalizedEnd > nextSlot.normalizedStart) {
                errors[`${basePath}.timeSlots.${currentSlot.originalIndex}.endHour`] = "Ce cr\xe9neau chevauche le cr\xe9neau suivant";
                break;
            }
        }
    }
    return errors;
};
const $dc0a4f8b2c36ae1e$export$362c0f8447e929c6 = (schedules)=>{
    const errors = {};
    if (!schedules || schedules.length === 0) return errors;
    // Sort schedules by effectiveFrom to make validation easier
    const sortedSchedules = [
        ...schedules
    ].sort((a, b)=>new Date(a.effectiveFrom).getTime() - new Date(b.effectiveFrom).getTime());
    // Check that periods follow each other exactly (Monday to Sunday, then next Monday to Sunday, etc.)
    for(let i = 0; i < sortedSchedules.length - 1; i++){
        const currentSchedule = sortedSchedules[i];
        const nextSchedule = sortedSchedules[i + 1];
        if (!currentSchedule || !nextSchedule) continue;
        // Only validate continuity if current period has an end date (is not active)
        if (currentSchedule.effectiveTo) {
            // Calculate the Monday following the Sunday end date of current period
            const currentEndDate = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(currentSchedule.effectiveTo);
            const expectedNextStartDate = (0, $ffff430a208564ac$export$2e2bcd8739ae039)(currentEndDate, 1);
            const expectedNextStartDateString = (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(expectedNextStartDate);
            // Check if next period starts exactly on the expected Monday
            if (nextSchedule.effectiveFrom !== expectedNextStartDateString) {
                const originalIndex = schedules.indexOf(nextSchedule);
                if (originalIndex !== -1) errors[`contractualSchedules.${originalIndex}.effectiveFrom`] = `La p\xe9riode doit commencer le lundi suivant le dimanche de la p\xe9riode pr\xe9c\xe9dente (${expectedNextStartDateString})`;
            }
        }
    // If current period has no effectiveTo (is active), it's the last period, so no continuity check needed
    }
    // Check if we have more than one active entry (effectiveTo = null)
    const activeEntries = schedules.filter((s)=>!s.effectiveTo);
    if (activeEntries.length > 1) activeEntries.forEach((entry)=>{
        const index = schedules.indexOf(entry);
        if (index !== -1) errors[`contractualSchedules.${index}.effectiveTo`] = "Une seule p\xe9riode peut \xeatre active (sans date de fin)";
    });
    // Check if the active entry is the most recent one (last in sorted array)
    const activeEntryIndex = sortedSchedules.findIndex((s)=>!s.effectiveTo);
    if (activeEntryIndex !== -1 && activeEntryIndex !== sortedSchedules.length - 1) {
        const activeEntry = sortedSchedules[activeEntryIndex];
        if (activeEntry) {
            const originalIndex = schedules.indexOf(activeEntry);
            if (originalIndex !== -1) errors[`contractualSchedules.${originalIndex}.effectiveTo`] = "La p\xe9riode active doit \xeatre la plus r\xe9cente (en derni\xe8re position)";
        }
    }
    // Validate each schedule entry
    schedules.forEach((schedule, scheduleIndex)=>{
        // Validate effectiveFrom
        if (!schedule.effectiveFrom) errors[`contractualSchedules.${scheduleIndex}.effectiveFrom`] = "Date de d\xe9but requise";
        else {
            const fromDate = new Date(schedule.effectiveFrom);
            if (fromDate.toString() === 'Invalid Date') errors[`contractualSchedules.${scheduleIndex}.effectiveFrom`] = 'Date invalide';
            else {
                // Validate that effectiveFrom is a Monday (getDay() === 1, where Sunday = 0, Monday = 1)
                const dayOfWeek = fromDate.getDay();
                if (dayOfWeek !== 1) errors[`contractualSchedules.${scheduleIndex}.effectiveFrom`] = "La date de d\xe9but doit \xeatre un lundi";
            }
        }
        // Validate effectiveTo
        if (schedule.effectiveTo) {
            const toDate = new Date(schedule.effectiveTo);
            if (toDate.toString() === 'Invalid Date') errors[`contractualSchedules.${scheduleIndex}.effectiveTo`] = 'Date invalide';
            else {
                // Validate that effectiveTo is a Sunday (getDay() === 0) or null
                const dayOfWeek = toDate.getDay();
                if (dayOfWeek !== 0) errors[`contractualSchedules.${scheduleIndex}.effectiveTo`] = "La date de fin doit \xeatre un dimanche";
                else if (schedule.effectiveFrom && toDate <= new Date(schedule.effectiveFrom)) errors[`contractualSchedules.${scheduleIndex}.effectiveTo`] = "La date de fin doit \xeatre post\xe9rieure \xe0 la date de d\xe9but";
            }
        }
        // Validate weeklyHoursWorked (required)
        if (schedule.weeklyHoursWorked === undefined || schedule.weeklyHoursWorked === null || typeof schedule.weeklyHoursWorked !== 'number' || isNaN(schedule.weeklyHoursWorked)) errors[`contractualSchedules.${scheduleIndex}.weeklyHoursWorked`] = 'Heures/semaine requises';
        // Validate monthlyHoursWorked (required)
        if (schedule.monthlyHoursWorked === undefined || schedule.monthlyHoursWorked === null || typeof schedule.monthlyHoursWorked !== 'number' || isNaN(schedule.monthlyHoursWorked)) errors[`contractualSchedules.${scheduleIndex}.monthlyHoursWorked`] = 'Heures/mois requises';
        // Validate that total hours from time slots equals weeklyHoursWorked only if useTimeSlots is true
        // Note: schedule.schedule est toujours présent dans le formulaire (même si vide), donc on peut l'utiliser directement
        if (schedule.useTimeSlots !== false && typeof schedule.weeklyHoursWorked === 'number' && !isNaN(schedule.weeklyHoursWorked) && schedule.schedule // Vérifier que schedule existe (devrait toujours être le cas dans le formulaire)
        ) {
            const totalHoursFromSlots = (0, $44391656266f978a$export$21df59b13e8f1baf)(schedule.schedule);
            // Use a small epsilon for floating point comparison
            if (Math.abs(totalHoursFromSlots - schedule.weeklyHoursWorked) > 0.01) // Store error on schedule.totalMismatch to display it in the total row instead of on the weeklyHoursWorked field
            errors[`contractualSchedules.${scheduleIndex}.schedule.totalMismatch`] = `Le total des heures des cr\xe9neaux (${(0, $74f17ceb9b5a08a5$export$3c074bd11f21ecb1)(totalHoursFromSlots)}) doit \xeatre \xe9gal aux heures/semaine (${(0, $74f17ceb9b5a08a5$export$3c074bd11f21ecb1)(schedule.weeklyHoursWorked)})`;
        }
        // Validate each day of the week only if useTimeSlots is true (or undefined, default true)
        // Note: schedule.schedule est toujours présent dans le formulaire (même si vide), donc on peut l'utiliser directement
        if (schedule.useTimeSlots !== false && schedule.schedule) {
            const days = [
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday'
            ];
            days.forEach((dayName)=>{
                const dayErrors = $dc0a4f8b2c36ae1e$export$67b1ffa1998df9cb(schedule.schedule[dayName], dayName, scheduleIndex);
                Object.assign(errors, dayErrors);
            });
        }
    });
    // Check for overlapping periods
    for(let i = 0; i < sortedSchedules.length - 1; i++){
        const currentSchedule = sortedSchedules[i];
        const nextSchedule = sortedSchedules[i + 1];
        if (!currentSchedule || !nextSchedule) continue;
        const currentEndDate = currentSchedule.effectiveTo ? new Date(currentSchedule.effectiveTo) : null;
        const nextStartDate = new Date(nextSchedule.effectiveFrom);
        // If current period has no end date, it automatically overlaps with all subsequent periods
        if (!currentEndDate) {
            const originalIndex = schedules.indexOf(currentSchedule);
            if (originalIndex !== -1) errors[`contractualSchedules.${originalIndex}.effectiveTo`] = "Cette p\xe9riode chevauche les p\xe9riodes suivantes";
            break;
        }
        // If current period's end date is after or equal to next period's start date
        if (currentEndDate >= nextStartDate) {
            const originalIndex = schedules.indexOf(currentSchedule);
            if (originalIndex !== -1) errors[`contractualSchedules.${originalIndex}.effectiveTo`] = "Cette p\xe9riode chevauche la p\xe9riode suivante";
            break;
        }
    }
    return errors;
};


const $44391656266f978a$export$65b98c304a80dbb2 = (timeSlots)=>{
    return timeSlots.reduce((acc, slot)=>{
        if (typeof slot.startHour !== 'number' || typeof slot.endHour !== 'number' || isNaN(slot.startHour) || isNaN(slot.endHour)) return acc;
        let duration = slot.endHour - slot.startHour;
        // Handle slots that cross midnight
        if (duration < 0) duration = duration + 24;
        return acc + duration;
    }, 0);
};
const $44391656266f978a$export$21df59b13e8f1baf = (schedule)=>{
    if (!schedule) return 0;
    const daysOfWeek = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    return daysOfWeek.reduce((acc, dayName)=>{
        const timeSlots = schedule[dayName]?.timeSlots || [];
        const dayTotal = $44391656266f978a$export$65b98c304a80dbb2(timeSlots);
        return acc + dayTotal;
    }, 0);
};
const $44391656266f978a$export$e04f7165466326f4 = (schedules)=>{
    if (!schedules || schedules.length === 0) return [];
    return schedules.map((schedule)=>{
        // Vérifier si schedule existe et si des créneaux existent
        const hasTimeSlots = schedule.schedule !== null && schedule.schedule !== undefined && Object.values(schedule.schedule).some((daySchedule)=>daySchedule.timeSlots && daySchedule.timeSlots.length > 0);
        // Si schedule est null, créer un schedule vide pour le formulaire
        const formSchedule = schedule.schedule || $44391656266f978a$export$42fc53fa12b32eb3();
        return {
            effectiveFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(schedule.effectiveFrom)),
            effectiveTo: schedule.effectiveTo ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(schedule.effectiveTo)) : null,
            schedule: formSchedule,
            weeklyHoursWorked: schedule.weeklyHoursWorked ?? 0,
            monthlyHoursWorked: schedule.monthlyHoursWorked ?? 0,
            useTimeSlots: hasTimeSlots
        };
    });
};
/**
 * Transforms contractual schedules from form format (string dates) to API format (Date objects)
 * @param schedules - Contractual schedules from form
 * @returns Contractual schedules in API format
 */ /**
 * Filter out incomplete time slots (slots without both startHour and endHour)
 */ const $44391656266f978a$var$filterCompleteTimeSlots = (daySchedule)=>{
    return {
        ...daySchedule,
        timeSlots: daySchedule.timeSlots.filter((0, $dc0a4f8b2c36ae1e$export$4a91a4c1a4184ce5))
    };
};
const $44391656266f978a$export$76cf14d2b2649bf0 = (schedules)=>{
    return schedules.map((schedule)=>{
        // Si useTimeSlots est false, envoyer schedule: null
        let scheduleToSend = null;
        if (schedule.useTimeSlots !== false && schedule.schedule) // Filter out incomplete time slots before sending to API
        scheduleToSend = {
            monday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.monday),
            tuesday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.tuesday),
            wednesday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.wednesday),
            thursday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.thursday),
            friday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.friday),
            saturday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.saturday),
            sunday: $44391656266f978a$var$filterCompleteTimeSlots(schedule.schedule.sunday)
        };
        return {
            effectiveFrom: (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(schedule.effectiveFrom),
            effectiveTo: schedule.effectiveTo ? (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(schedule.effectiveTo) : null,
            schedule: scheduleToSend,
            weeklyHoursWorked: schedule.weeklyHoursWorked ?? 0,
            monthlyHoursWorked: schedule.monthlyHoursWorked ?? 0
        };
    });
};
const $44391656266f978a$export$42fc53fa12b32eb3 = ()=>{
    return {
        monday: {
            timeSlots: [
                $44391656266f978a$export$b1b0960eaf63ab73()
            ]
        },
        tuesday: {
            timeSlots: [
                $44391656266f978a$export$b1b0960eaf63ab73()
            ]
        },
        wednesday: {
            timeSlots: [
                $44391656266f978a$export$b1b0960eaf63ab73()
            ]
        },
        thursday: {
            timeSlots: [
                $44391656266f978a$export$b1b0960eaf63ab73()
            ]
        },
        friday: {
            timeSlots: [
                $44391656266f978a$export$b1b0960eaf63ab73()
            ]
        },
        saturday: {
            timeSlots: []
        },
        sunday: {
            timeSlots: []
        }
    };
};
const $44391656266f978a$export$11d7e77375792302 = (effectiveFrom, weeklyHoursWorked, monthlyHoursWorked, useTimeSlots)=>{
    const fromDate = effectiveFrom || new Date();
    return {
        effectiveFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(fromDate)),
        effectiveTo: null,
        schedule: $44391656266f978a$export$42fc53fa12b32eb3(),
        weeklyHoursWorked: weeklyHoursWorked ?? undefined,
        monthlyHoursWorked: monthlyHoursWorked ?? undefined,
        useTimeSlots: useTimeSlots ?? true
    };
};
const $44391656266f978a$export$b1b0960eaf63ab73 = ()=>{
    // Empty time slot by default (use undefined for required fields so validation works)
    return {
        startHour: undefined,
        endHour: undefined
    };
};
const $44391656266f978a$export$bd6b488620991bf1 = (userAssociation)=>{
    if (!userAssociation?.contractualSchedules || userAssociation.contractualSchedules.length === 0) return false;
    // Check if any period has at least one day with at least one non-empty time slot
    return userAssociation.contractualSchedules.some((entry)=>{
        // Vérifier que schedule existe avant d'accéder aux timeSlots
        if (!entry.schedule) return false;
        return Object.values(entry.schedule).some((daySchedule)=>{
            return daySchedule.timeSlots && daySchedule.timeSlots.length > 0 && daySchedule.timeSlots.some((slot)=>typeof slot.startHour === 'number' && !isNaN(slot.startHour) && typeof slot.endHour === 'number' && !isNaN(slot.endHour));
        });
    });
};
const $44391656266f978a$export$f3568defbb2e461f = (user, schedule, organization)=>{
    // Get worker association with the organization
    const association = (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, organization);
    // Check if worker has an active association
    if (!association) return {
        applicable: false,
        reason: "Le travailleur n'a pas d'association active avec cet employeur"
    };
    // Check if worker has any schedule entry with schedule (non-null)
    // If yes, NOT applicable for bulk modification
    // Rules for bulk modification:
    // - If worker has at least one schedule entry with schedule (non-null), NOT applicable
    // - If worker has no schedule entries with schedule (all null or none exist), can be replaced
    if (association.contractualSchedules) {
        const hasScheduleWithTimeSlots = association.contractualSchedules.some((entry)=>entry.schedule);
        if (hasScheduleWithTimeSlots) return {
            applicable: false,
            reason: "Le travailleur a d\xe9j\xe0 un horaire avec cr\xe9neaux horaires d\xe9taill\xe9s"
        };
    }
    return {
        applicable: true
    };
};





// Function to convert dotted keys to nested objects
function $149f9dde4d8605df$var$convertToNestedObject(data) {
    return data.map((row)=>{
        const result = {};
        for(const key in row)//@ts-ignore
        (0, (/*@__PURE__*/$parcel$interopDefault($2KSUA))).set(result, key, row[key]);
        return result;
    });
}
function $149f9dde4d8605df$var$validateEmail(value) {
    const input = document.createElement('input');
    input.type = 'email';
    input.required = true;
    input.value = value;
    return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(value);
}

const $149f9dde4d8605df$export$3fd221666f2971b3 = ({ onSuccess: onSuccess, model: model })=>{
    const [fileList, setFileList] = (0, $3ZYaX.useState)(null);
    const [list, setList] = (0, $3ZYaX.useState)();
    const [error, setError] = (0, $3ZYaX.useState)('');
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentOrganization);
    const existingWorkersQuery = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        appAccess: 'full'
    });
    const fileReader = new FileReader();
    const file = fileList?.[0];
    const step = fileList === null ? 1 : list ? 3 : 2;
    const validList = list?.filter((u)=>u.status === 'valid') ?? [];
    const validTotal = list ? validList.length : undefined;
    const existingTotal = list ? list.filter((u)=>u.status === 'existing').length : undefined;
    const invalidTotal = list ? list.filter((u)=>u.status === 'invalid').length : undefined;
    const handleUpload = (e)=>{
        setError('');
        setList(undefined);
        setFileList(e.target.files);
    };
    const handleFileProcessing = async ()=>{
        const { read: read, utils: utils } = await (parcelRequire("aoNgk"));
        if (file) {
            fileReader.onload = function(e) {
                if (!e.target) {
                    setError('#1 - Lecture du fichier impossible');
                    return;
                }
                const csvFile = e.target.result;
                // Convert CSV to JSON array
                const workbook = read(csvFile, {
                    type: 'string',
                    raw: true
                });
                const firstSheetName = workbook.SheetNames[0];
                if (!firstSheetName) {
                    setError('#2 - Lecture du fichier impossible');
                    return;
                }
                const worksheet = workbook.Sheets[firstSheetName];
                if (!worksheet) {
                    setError('#3 - Lecture du fichier impossible');
                    return;
                }
                const dottedJsonArray = utils.sheet_to_json(worksheet);
                const jsonArray = $149f9dde4d8605df$var$convertToNestedObject(dottedJsonArray);
                if (!jsonArray[0]) {
                    setError('#4 - Le fichier est vide');
                    return;
                }
                const missingHeaders = [];
                const requiredHeaders = [
                    'email',
                    'firstName',
                    'lastName'
                ];
                requiredHeaders.forEach((requiredHeader)=>{
                    const hasHeaderData = jsonArray.some((item)=>item[requiredHeader]);
                    if (!hasHeaderData) missingHeaders.push(requiredHeader);
                });
                if (missingHeaders[0]) {
                    setError(`#5 - en-t\xeate(s) '${missingHeaders.join(' & ')}' absent(s)`);
                    return;
                }
                if (jsonArray.length < 1) {
                    setError("#6 - Pas d'entr\xe9es dans le fichier");
                    return;
                }
                if (existingWorkersQuery.data === undefined) {
                    setError("#7 - Impossible de charger la liste d'uilitsateurs existants");
                    return;
                }
                const internalRefs = existingWorkersQuery.data.map((u)=>u.associations.find((a)=>a.organization.toString() === currentOrganization?._id.toString())?.internalRef).filter((v)=>v !== undefined);
                const emails = [];
                const validated = jsonArray.map((_user)=>{
                    const user = _user;
                    user.status = 'invalid';
                    user.errors = {};
                    const { email: email, firstName: firstName, lastName: lastName, internalRef: internalRef } = user;
                    if (!email) user.errors.email = 'Adresse email manquante';
                    else if (!$149f9dde4d8605df$var$validateEmail(email)) user.errors.email = 'Adresse email incorrect';
                    else if (emails.some((_email)=>_email === email)) user.errors.email = "Email d\xe9j\xe0 pr\xe9sent dans une autre ligne";
                    else emails.push(email);
                    if (!firstName) user.errors.firstName = "Pr\xe9nom manquant";
                    if (!lastName) user.errors.lastName = 'Nom manquant';
                    if (internalRef) {
                        if (internalRefs.some((ref)=>ref === internalRef)) user.errors.internalRef = "Matricule interne d\xe9j\xe0 pr\xe9sent dans une autre ligne";
                        else internalRefs.push(internalRef);
                    }
                    const validateScheduleData = (attribute)=>{
                        const hoursWorked = user.schedule?.[attribute].toString();
                        const messageLabel = attribute === 'monthlyHoursWorked' ? 'mois' : 'semaine';
                        if (hoursWorked?.includes(',')) user.errors[`schedule.${attribute}`] = `Heures \xe0 prester par ${messageLabel} incorrect - les d\xe9cimals doivent utiliser le point comme s\xe9parateur`;
                        else if (hoursWorked && typeof parseFloat(hoursWorked) !== 'number') user.errors[`schedule.${attribute}`] = `Heures \xe0 prester par ${messageLabel} incorrect`;
                        else if (hoursWorked && user.schedule) user.schedule[attribute] = parseFloat(hoursWorked);
                    };
                    if (user?.schedule?.monthlyHoursWorked) validateScheduleData('monthlyHoursWorked');
                    if (user?.schedule?.weeklyHoursWorked) validateScheduleData('weeklyHoursWorked');
                    // All provided data is valid
                    const userAlreadyInvited = existingWorkersQuery.data.some((existingWorker)=>existingWorker.email === email);
                    if (userAlreadyInvited) {
                        user.status = 'existing';
                        user.errors.email = "Adresse email d\xe9j\xe0 utilis\xe9e";
                        return user;
                    }
                    // This worker is valid to create
                    if (!Object.keys(user.errors)[0]) user.status = 'valid';
                    return user;
                });
                setList(validated);
            };
            fileReader.readAsText(file);
        }
    };
    const csvKeys = {
        email: 'Adresse email -> obligatoire',
        firstName: "Pr\xe9nom -> obligatoire",
        lastName: 'Nom de Naissance -> obligatoire',
        internalRef: "Matricule interne -> g\xe9n\xe9r\xe9 automatiquement si absent",
        'schedule.monthlyHoursWorked': "Heures \xe0 prester par semaine, utiliser un point pour la virgule -> 0 si absent",
        'schedule.weeklyHoursWorked': "Heures \xe0 prester par mois, utiliser un point pour la virgule -> 0 si absent",
        schedule: '',
        internalComment: 'Commentaire -> optionnel',
        internalInformation: 'Information -> optionnel'
    };
    const csvTemplateFileData = 'data:text/csv;charset=utf-8,' + Object.keys(csvKeys).filter((key)=>key !== 'schedule' && model.includes(key)).join(',') + '\n';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                mb: 0,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: "Le fichier CSV doit reprendre les en-t\xeates suivants :"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        display: "flex",
                                        justifyContent: "end",
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            size: "small",
                                            color: 'success',
                                            renderAs: "a",
                                            href: csvTemplateFileData,
                                            download: 'import-teamtim-workers.csv',
                                            children: "T\xe9l\xe9charger le masque"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("table", {
                                className: "table",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                                    children: "En-t\xeate"
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                                    children: "Description"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tbody", {
                                        children: model.flatMap((key)=>{
                                            const value = csvKeys[key];
                                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                            children: key
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                        children: value
                                                    })
                                                ]
                                            }, key);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).InputFile, {
                        onChange: handleUpload,
                        //@ts-expect-error fuck react-bulma-components
                        inputProps: {
                            accept: '.csv'
                        },
                        id: 'csvFileInput',
                        accept: '.csv',
                        label: '1. Choisir un fichier',
                        value: fileList ?? undefined,
                        filename: file?.name ?? undefined,
                        fullwidth: true,
                        "data-test": "upload-file-action"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        type: "button",
                        disabled: step === 1,
                        onClick: handleFileProcessing,
                        "data-test": "process-file-action",
                        children: "2. Controler le fichier"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    error && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "danger",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: [
                                "Erreur : ",
                                error
                            ]
                        })
                    }),
                    list && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "success",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: [
                                        "Entr\xe9es Valides : ",
                                        validTotal
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "warning",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: [
                                        "Entr\xe9es Existantes : ",
                                        existingTotal
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "danger",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: [
                                        "Entr\xe9es Invalides : ",
                                        invalidTotal
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        type: "button",
                        disabled: step < 3 || Boolean(error) || validList.length === 0,
                        onClick: ()=>{
                            // Transform schedule.weeklyHoursWorked and schedule.monthlyHoursWorked
                            // into contractualSchedules with empty time slots
                            // Check if this is an employer worker (has schedule fields in model)
                            const isEmployerWorker = model.includes('schedule.weeklyHoursWorked') || model.includes('schedule.monthlyHoursWorked');
                            const transformedList = validList.map((user)=>{
                                // Always create contractualSchedules for employer workers
                                if (isEmployerWorker) {
                                    // Get values from schedule, defaulting to 0 if not present
                                    const weeklyHoursWorked = user.schedule?.weeklyHoursWorked !== undefined ? user.schedule.weeklyHoursWorked : 0;
                                    const monthlyHoursWorked = user.schedule?.monthlyHoursWorked !== undefined ? user.schedule.monthlyHoursWorked : 0;
                                    const newEntry = (0, $44391656266f978a$export$11d7e77375792302)((0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(new Date()), weeklyHoursWorked, monthlyHoursWorked, false);
                                    return {
                                        ...user,
                                        contractualSchedules: [
                                            newEntry
                                        ]
                                    };
                                }
                                return user;
                            });
                            onSuccess(transformedList);
                        },
                        "data-test": "submit-list-action",
                        children: [
                            "3. Pr\xe9parer ",
                            validList.length,
                            " invitations"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("hr", {}),
            list && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Table).Container, {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Table), {
                    size: "narrow",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Statut"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Pr\xe9nom"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Nom"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Matricule"
                                    }),
                                    model.includes('schedule.weeklyHoursWorked') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "H/Sem"
                                    }),
                                    model.includes('schedule.monthlyHoursWorked') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "H/Mois"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Commentaire"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                        children: "Information"
                                    })
                                ]
                            })
                        }),
                        list.map((item, index)=>{
                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "tr",
                                backgroundColor: item.status === 'valid' ? 'success-light' : item.status === 'existing' ? 'warning-light' : 'danger-light',
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                        children: index + 2
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                        children: item.status === 'valid' ? 'Valide' : item.status === 'existing' ? 'Existant' : 'Invalide'
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "email"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "firstName"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "lastName"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "internalRef"
                                    }),
                                    model.includes('schedule.weeklyHoursWorked') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "schedule.weeklyHoursWorked"
                                    }),
                                    model.includes('schedule.monthlyHoursWorked') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "schedule.monthlyHoursWorked"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "internalComment"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($149f9dde4d8605df$var$UserCell, {
                                        item: item,
                                        attribute: "internalInformation"
                                    })
                                ]
                            }, index);
                        })
                    ]
                })
            })
        ]
    });
};
const $149f9dde4d8605df$var$UserCell = ({ item: item, attribute: attribute })=>{
    if (!item) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            display: "inline-flex",
            "data-tooltip": item.errors[attribute],
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    mr: 1,
                    children: item.errors[attribute] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    children: (0, $2KSUA.get)(item, attribute) ?? '[vide]'
                })
            ]
        })
    });
};










parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");








parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");






var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");
const $16df5e427bb274d8$var$createClipboardContext = (0, $2KSUA.once)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createContext({
        copy: ()=>{
            return;
        },
        isEqualTo: ()=>false,
        value: undefined,
        isEmpty: true
    }));
const $16df5e427bb274d8$export$b580fba9cc8d3a5 = ()=>(0, $3ZYaX.useContext)($16df5e427bb274d8$var$createClipboardContext());
const $16df5e427bb274d8$export$278c12d137e20d5c = ({ children: children })=>{
    const [clipboard, setClipboard] = (0, $3ZYaX.useState)();
    const StateContext = $16df5e427bb274d8$var$createClipboardContext();
    const isEqualTo = (value)=>{
        if (clipboard === undefined) return false;
        return JSON.stringify(value) === JSON.stringify(clipboard);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(StateContext.Provider, {
        value: {
            copy: setClipboard,
            isEqualTo: isEqualTo,
            value: clipboard,
            isEmpty: clipboard === undefined
        },
        children: children
    });
};



parcelRequire("3ZYaX");

const $f34d443174db4caf$var$EmptyTd = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "td",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "span",
            textSize: 7,
            children: children
        })
    });
const $f34d443174db4caf$export$7a9a31a911eb9a20 = ({ label: label, right: right, children: children, empty: empty = false, tdClassName: tdClassName = 'px-2', tdStyle: tdStyle })=>{
    if (empty) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($f34d443174db4caf$var$EmptyTd, {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "td",
        className: tdClassName,
        style: tdStyle,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                justifyContent: "space-between",
                mb: 2,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: label != null && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            textSize: 6,
                            textWeight: "bold",
                            renderAs: "span",
                            mr: 1,
                            children: label
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: right
                    })
                ]
            }),
            children
        ]
    });
};



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");
function $7ebbc441168a9a93$var$ClipboardCopyIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"
    }));
}
const $7ebbc441168a9a93$var$ForwardRef = $3ZYaX.forwardRef($7ebbc441168a9a93$var$ClipboardCopyIcon);
var $7ebbc441168a9a93$export$2e2bcd8739ae039 = $7ebbc441168a9a93$var$ForwardRef;



parcelRequire("3ZYaX");

const $c1d985c847089e32$export$3cf411a3da00f391 = (props)=>{
    const extraSmall = props.size === 'extra-small' ? {
        fontSize: '0.6rem'
    } : {};
    const { style: style } = props;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
        type: "button",
        color: "ghost",
        ...props,
        style: {
            ...extraSmall,
            ...style
        },
        children: props.children
    });
};


const $3745c86609aa5090$export$4f2558dd25106ae2 = (props)=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c1d985c847089e32$export$3cf411a3da00f391), {
        "data-tooltip": "Copier",
        ...props,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
            color: "primary",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7ebbc441168a9a93$export$2e2bcd8739ae039), {})
        })
    });
};



parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");
function $a17072950df4a9a9$var$ClipboardCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    }));
}
const $a17072950df4a9a9$var$ForwardRef = $3ZYaX.forwardRef($a17072950df4a9a9$var$ClipboardCheckIcon);
var $a17072950df4a9a9$export$2e2bcd8739ae039 = $a17072950df4a9a9$var$ForwardRef;



const $c0588247d50e0fa8$export$503f97e1b40d97c7 = (props)=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c1d985c847089e32$export$3cf411a3da00f391), {
        "data-tooltip": "Coller",
        ...props,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
            color: "primary",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a17072950df4a9a9$export$2e2bcd8739ae039), {})
        })
    });
};




const $b223c1ff107a4419$export$134dc3efcee9d6ac = ({ onCopy: onCopy, onPaste: onPaste, onRemove: onRemove, copyDisabled: copyDisabled, pasteDisabled: pasteDisabled, removeDisabled: removeDisabled = false, dataTestPrefix: dataTestPrefix, removeDataTest: removeDataTest })=>{
    const copyDataTest = dataTestPrefix !== undefined ? `day-copy-action-${dataTestPrefix}` : 'day-copy-action';
    const pasteDataTest = dataTestPrefix !== undefined ? `day-paste-action-${dataTestPrefix}` : 'day-paste-action';
    const defaultRemoveDataTest = dataTestPrefix !== undefined ? `day-remove-action-${dataTestPrefix}` : 'remove-action';
    const removeTest = removeDataTest ?? defaultRemoveDataTest;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button).Group, {
        hasAddons: true,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3745c86609aa5090$export$4f2558dd25106ae2), {
                size: "extra-small",
                "data-test": copyDataTest,
                disabled: copyDisabled,
                onClick: onCopy
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c0588247d50e0fa8$export$503f97e1b40d97c7), {
                size: "extra-small",
                "data-test": pasteDataTest,
                disabled: pasteDisabled,
                onClick: onPaste
            }),
            onRemove != null && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c1d985c847089e32$export$3cf411a3da00f391), {
                size: "extra-small",
                "data-test": removeTest,
                disabled: removeDisabled,
                onClick: onRemove,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                })
            })
        ]
    });
};



parcelRequire("3ZYaX");


var $2KSUA = parcelRequire("2KSUA");


/**
 * Native time input (type="time") with label and error display.
 * Value is always a string in "HH:mm" format; the parent must convert to/from
 * decimal hours, Date, or other formats.
 */ const $5ee0982b08b14659$var$TimePicker = ({ value: value, onChange: onChange, onBlur: onBlur, label: label, error: error, required: required, help: help, htmlFor: htmlFor, disabled: disabled = false, size: size = 'small', name: name, dataTest: dataTest, dataFor: dataFor, inputStyle: inputStyle, textWeight: textWeight, textColor: textColor })=>{
    const handleChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        error: error,
        required: required,
        help: help,
        htmlFor: htmlFor,
        dataTest: dataTest,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
            type: "time",
            size: size,
            value: value,
            onChange: handleChange,
            onBlur: onBlur,
            disabled: disabled,
            name: name,
            style: inputStyle,
            textWeight: textWeight,
            textColor: textColor,
            ...dataTest ? {
                'data-test': dataTest
            } : {},
            ...dataFor ? {
                'data-tip': true,
                'data-for': dataFor
            } : {}
        })
    });
};
var $5ee0982b08b14659$export$2e2bcd8739ae039 = $5ee0982b08b14659$var$TimePicker;
const $5ee0982b08b14659$export$c9a16f439c043c12 = (props)=>{
    const { field: field, form: form, label: label, help: help, required: required } = props;
    const value = (0, $2KSUA.isNumber)(field.value) ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(field.value) : '';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($5ee0982b08b14659$var$TimePicker, {
        label: label,
        value: value,
        onChange: (value)=>{
            const hours = (0, $74f17ceb9b5a08a5$export$e7f31853fa46457)(value);
            if (hours !== undefined) {
                form.setFieldValue(field.name, hours);
                form.setFieldTouched(field.name, true, false);
            }
        },
        onBlur: ()=>form.setFieldTouched(field.name, true, false),
        error: form.errors[field.name],
        required: required,
        help: help
    });
};


/**
 * Helper function to get nested value from touched object
 * Formik stores touched values in nested structure
 */ const $ae3d7033cd1c5b60$var$getNestedTouched = (path, touchedObj)=>{
    const parts = path.split('.');
    let current = touchedObj;
    for (const part of parts){
        if (current === undefined || current === null) return false;
        current = current[part];
    }
    return current === true;
};
/**
 * Helper function to check if an error should be displayed
 * Only show error if field is touched or form has been submitted
 */ const $ae3d7033cd1c5b60$var$shouldShowError = (fieldName, touched, submitCount, errors)=>{
    const fieldTouched = touched || $ae3d7033cd1c5b60$var$getNestedTouched(fieldName, touched);
    const formSubmitted = submitCount > 0;
    if (fieldTouched || formSubmitted) return errors[fieldName];
    return undefined;
};
/**
 * Component for a day column in the week view
 */ const $ae3d7033cd1c5b60$var$DayColumn = ({ basePath: basePath, scheduleIndex: scheduleIndex, dayName: dayName, dayLabel: dayLabel })=>{
    const baseName = `${basePath}.${scheduleIndex}.schedule.${dayName}`;
    const { setFieldValue: setFieldValue } = (0, $31tXu.useFormikContext)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ae3d7033cd1c5b60$var$Clipboard, {
        children: (clipboard)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                name: `${baseName}.timeSlots`,
                children: ({ remove: remove, push: push, form: form })=>{
                    // Parse the basePath to get the values from form.values
                    const pathParts = basePath.split('.');
                    let currentValue = form.values;
                    for (const part of pathParts)if (part.match(/^\d+$/)) currentValue = currentValue?.[parseInt(part)];
                    else currentValue = currentValue?.[part];
                    const currentTimeSlots = currentValue?.[scheduleIndex]?.schedule?.[dayName]?.timeSlots || [];
                    const hasTimeSlots = currentTimeSlots.length > 0;
                    const addTimeSlot = ()=>{
                        push((0, $44391656266f978a$export$b1b0960eaf63ab73)());
                    };
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f34d443174db4caf$export$7a9a31a911eb9a20), {
                        label: dayLabel,
                        right: hasTimeSlots ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b223c1ff107a4419$export$134dc3efcee9d6ac), {
                            onCopy: ()=>{
                                if (currentTimeSlots.length > 0) clipboard.copy(currentTimeSlots);
                            },
                            onPaste: ()=>{
                                if (!clipboard.value || !$ae3d7033cd1c5b60$var$isClipboardDay(clipboard.value)) return;
                                setFieldValue(`${baseName}.timeSlots`, clipboard.value);
                            },
                            copyDisabled: clipboard.isEqualTo(currentTimeSlots),
                            pasteDisabled: clipboard.isEmpty || clipboard.isEqualTo(currentTimeSlots) || !$ae3d7033cd1c5b60$var$isClipboardDay(clipboard.value),
                            dataTestPrefix: dayName
                        }) : undefined,
                        tdStyle: {
                            verticalAlign: 'top',
                            padding: '0.5rem',
                            width: '150px'
                        },
                        children: currentTimeSlots.length === 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                            size: "small",
                            onClick: addTimeSlot,
                            color: "primary",
                            outlined: true,
                            type: "button",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e718407ce256549d), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "span",
                                    children: "Cr\xe9neau"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            flexDirection: "column",
                            style: {
                                gap: '0.5rem'
                            },
                            children: [
                                currentTimeSlots.map((timeSlot, index)=>{
                                    const slotBaseName = `${basePath}.${scheduleIndex}.schedule.${dayName}.timeSlots.${index}`;
                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        mb: 2,
                                        style: {
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: '4px',
                                            padding: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                style: {
                                                    flex: '1 1 120px',
                                                    minWidth: '100px'
                                                },
                                                mb: 2,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: `${slotBaseName}.startHour`,
                                                    component: (0, $5ee0982b08b14659$export$c9a16f439c043c12)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                style: {
                                                    flex: '1 1 120px',
                                                    minWidth: '100px'
                                                },
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: `${slotBaseName}.endHour`,
                                                    component: (0, $5ee0982b08b14659$export$c9a16f439c043c12)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                display: "flex",
                                                justifyContent: "flex-end",
                                                mt: 1,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "primary",
                                                    outlined: true,
                                                    size: "small",
                                                    onClick: ()=>remove(index),
                                                    type: "button",
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        size: "small",
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                                    })
                                                })
                                            })
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                    size: "small",
                                    onClick: addTimeSlot,
                                    color: "primary",
                                    outlined: true,
                                    type: "button",
                                    style: {
                                        marginTop: '0.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e718407ce256549d), {})
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            children: "Cr\xe9neau"
                                        })
                                    ]
                                })
                            ]
                        })
                    });
                }
            });
        }
    });
};
const $ae3d7033cd1c5b60$export$fe61d607b174ba = ({ basePath: basePath, scheduleIndex: scheduleIndex })=>{
    const { values: values, errors: errors, submitCount: submitCount } = (0, $31tXu.useFormikContext)();
    const daysOfWeek = [
        {
            name: 'monday',
            label: 'Lun'
        },
        {
            name: 'tuesday',
            label: 'Mar'
        },
        {
            name: 'wednesday',
            label: 'Mer'
        },
        {
            name: 'thursday',
            label: 'Jeu'
        },
        {
            name: 'friday',
            label: 'Ven'
        },
        {
            name: 'saturday',
            label: 'Sam'
        },
        {
            name: 'sunday',
            label: 'Dim'
        }
    ];
    // Calculate totals for all days
    const pathParts = basePath.split('.');
    let currentValue = values;
    for (const part of pathParts)if (part.match(/^\d+$/)) currentValue = currentValue?.[parseInt(part)];
    else currentValue = currentValue?.[part];
    const schedule = currentValue?.[scheduleIndex]?.schedule;
    const weekTotal = schedule ? (0, $44391656266f978a$export$21df59b13e8f1baf)(schedule) : 0;
    // Get error for total mismatch to display in total row
    const totalMismatchErrorPath = `${basePath}.${scheduleIndex}.schedule.totalMismatch`;
    const totalMismatchError = $ae3d7033cd1c5b60$var$shouldShowError(totalMismatchErrorPath, true, submitCount, errors);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16df5e427bb274d8$export$278c12d137e20d5c), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Table), {
            bordered: true,
            size: "fullwidth",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                        children: daysOfWeek.map((day)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ae3d7033cd1c5b60$var$DayColumn, {
                                basePath: basePath,
                                scheduleIndex: scheduleIndex,
                                dayName: day.name,
                                dayLabel: day.label
                            }, day.name))
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "td",
                            colSpan: daysOfWeek.length,
                            textWeight: "bold",
                            style: {
                                padding: '0.5rem',
                                backgroundColor: '#e8e8e8',
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "Total Semaine:"
                                    }),
                                    " ",
                                    (0, $74f17ceb9b5a08a5$export$3c074bd11f21ecb1)(weekTotal),
                                    totalMismatchError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "div",
                                        textColor: "danger",
                                        textSize: 7,
                                        mt: 1,
                                        style: {
                                            fontWeight: 'normal'
                                        },
                                        children: totalMismatchError
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
// Helper component to access clipboard context
const $ae3d7033cd1c5b60$var$Clipboard = ({ children: children })=>{
    const clipboard = (0, $16df5e427bb274d8$export$b580fba9cc8d3a5)();
    return children(clipboard);
};
// Helper to check if clipboard value is a day (array) or week (object)
const $ae3d7033cd1c5b60$var$isClipboardDay = (clipboardValue)=>{
    if (!clipboardValue) return false;
    return Array.isArray(clipboardValue);
};


/**
 * Main component for editing contractual schedules
 */ const $4eec54641b63ade8$var$ContractualSchedulesSection = ({ name: name, hasWorkerEverHadTimeSlots: hasWorkerEverHadTimeSlots = false })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $31tXu.useFormikContext)();
    // Support both nested (newUsers.0.contractualSchedules) and direct (contractualSchedules) paths
    const schedules = values.newUsers?.[0]?.contractualSchedules || values.contractualSchedules || [];
    const addNewSchedule = ()=>{
        // Close the current active entry if it exists
        const activeIndex = schedules.findIndex((s)=>!s.effectiveTo);
        if (activeIndex !== -1) {
            const activeSchedule = schedules[activeIndex];
            if (activeSchedule) {
                const newEffectiveFrom = new Date();
                const previousDay = (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)(newEffectiveFrom, 1);
                setFieldValue(`${name}.${activeIndex}.effectiveTo`, (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(previousDay));
            }
        }
        // Add new active entry
        const newSchedule = (0, $44391656266f978a$export$11d7e77375792302)();
        setFieldValue(`${name}`, [
            ...schedules,
            newSchedule
        ]);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                mb: 4,
                children: "Horaires Contractuels"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textSize: 7,
                mb: 4,
                children: "D\xe9finissez les horaires de travail contractuels pour ce travailleur. Vous pouvez cr\xe9er plusieurs p\xe9riodes pour g\xe9rer l'historique des changements d'horaires."
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                name: name,
                children: ({ remove: remove })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            schedules.map((schedule, scheduleIndex)=>{
                                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                    mb: 5,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                            mb: 4,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 4,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Date de d\xe9but",
                                                        name: `${name}.${scheduleIndex}.effectiveFrom`,
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "date",
                                                        required: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 4,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: `Date de fin (optionnel - p\xe9riode active)`,
                                                        name: `${name}.${scheduleIndex}.effectiveTo`,
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "date"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 2,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Heures/semaine",
                                                        name: `${name}.${scheduleIndex}.weeklyHoursWorked`,
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "number",
                                                        required: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 2,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Heures/mois",
                                                        name: `${name}.${scheduleIndex}.monthlyHoursWorked`,
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "number",
                                                        required: true
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                            mb: 4,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                size: 12,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                                    label: "Utiliser les cr\xe9neaux horaires",
                                                    name: `${name}.${scheduleIndex}.useTimeSlots`,
                                                    disabled: hasWorkerEverHadTimeSlots
                                                })
                                            })
                                        }),
                                        schedule.useTimeSlots !== false ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 4,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ae3d7033cd1c5b60$export$fe61d607b174ba), {
                                                basePath: name,
                                                scheduleIndex: scheduleIndex
                                            })
                                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                            color: "warning",
                                            mb: 4,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                        children: "Attention :"
                                                    }),
                                                    " Sans cr\xe9neaux horaires, les journ\xe9es de travail avec \xe9v\xe9nement prestation (ex: cong\xe9 pay\xe9) seront calcul\xe9es sur la base de l'horaire th\xe9orique de la journ\xe9e de travail et non pas sur le contrat.",
                                                    ' ',
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                                                ]
                                            })
                                        }),
                                        schedules.length > 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            mt: 3,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                color: "danger",
                                                size: "small",
                                                onClick: ()=>remove(scheduleIndex),
                                                type: "button",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {
                                                            color: "white"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "span",
                                                        ml: 1,
                                                        children: "Supprimer la p\xe9riode"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, scheduleIndex);
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                onClick: addNewSchedule,
                                color: "primary",
                                outlined: true,
                                type: "button",
                                children: "Ajouter une p\xe9riode"
                            })
                        ]
                    })
            })
        ]
    });
};
var $4eec54641b63ade8$export$2e2bcd8739ae039 = $4eec54641b63ade8$var$ContractualSchedulesSection;


const $8271524579384dc6$var$UserForm = ({ user: user, role: role, noAppAccess: noAppAccess })=>{
    const createMutation = (0, $e607e015ac40917d$export$a25726670bb41cb)();
    const updateMutation = (0, $e607e015ac40917d$export$504dd55109c39a47)();
    const updateUserOrganizationRole = (0, $e607e015ac40917d$export$f917a4c1de87afb7)();
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const userAssociation = user && currentOrganization && (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, currentOrganization);
    const userRole = user && currentOrganization && role === 'employerMember' ? (0, $25ffbf4bca475b04$export$c33a4269214e2ec4)(user, role, currentOrganization._id) : undefined;
    const importCsvModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)({});
    const associatedEmployerQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    }, {
        enabled: (0, $8403deec6a28521e$export$6025088343704f9f)([
            'interimAgencyMember'
        ])
    });
    /* TODO: Review this in v5*/ const description = $8271524579384dc6$var$useDescription(role, currentOrganization?.type);
    const initalLaborCostCoefficients = userAssociation?.laborCostCoefficients.reduce((formValue, coef)=>{
        if (!formValue) formValue = {};
        formValue[coef.employer.toString()] = {
            isManagement: coef.kind === 'management'
        };
        return formValue;
    }, {});
    const initialContractualSchedules = userAssociation?.contractualSchedules ? (0, $44391656266f978a$export$e04f7165466326f4)(userAssociation.contractualSchedules) : role === 'worker' && !user && currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? [
        (0, $44391656266f978a$export$11d7e77375792302)()
    ] : undefined;
    // Get active contractual schedule entry to initialize schedule for compatibility
    const activeContractualSchedule = userAssociation ? (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(userAssociation) : undefined;
    const emailCanBeUpdated = (!user || user && !user.isCompleted && !user.associations[1]) && !noAppAccess;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            newUsers: [
                {
                    email: user?.email && emailCanBeUpdated ? user?.email : '',
                    firstName: user?.firstName || '',
                    lastName: user?.lastName || '',
                    internalRef: userAssociation?.internalRef,
                    internalInformation: userAssociation?.internalInformation,
                    internalComment: userAssociation?.internalComment,
                    organizationRole: userRole && userRole.organizationRole,
                    schedule: {
                        weeklyHoursWorked: activeContractualSchedule?.weeklyHoursWorked || 0,
                        monthlyHoursWorked: activeContractualSchedule?.monthlyHoursWorked || 0
                    },
                    laborCostCoefficients: initalLaborCostCoefficients,
                    contractualSchedules: initialContractualSchedules
                }
            ]
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {
                newUsers: {}
            };
            let index = 0;
            for (const newUser of values.newUsers){
                if (emailCanBeUpdated && !newUser.email) errors.newUsers[index] = {
                    ...errors.newUsers[index],
                    email: 'Champ requis'
                };
                if (role === 'worker' && !user) {
                    if (!newUser.firstName) errors.newUsers[index] = {
                        ...errors.newUsers[index],
                        firstName: 'Champ requis'
                    };
                    if (!newUser.lastName) errors.newUsers[index] = {
                        ...errors.newUsers[index],
                        lastName: 'Champ requis'
                    };
                } else if (role === 'worker' && user) {
                    if (!newUser.internalRef) errors.newUsers[index] = {
                        ...errors.newUsers[index],
                        internalRef: 'Champ requis'
                    };
                }
                if (role === 'employerMember') {
                    if (!newUser.organizationRole) errors.newUsers[index] = {
                        ...errors.newUsers[index],
                        organizationRole: 'Champ requis'
                    };
                }
                // Validate contractual schedules if they exist
                if (role === 'worker' && currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer && newUser.contractualSchedules) {
                    const contractualSchedulesErrors = (0, $dc0a4f8b2c36ae1e$export$362c0f8447e929c6)(newUser.contractualSchedules);
                    // Merge validation errors into form errors
                    Object.keys(contractualSchedulesErrors).forEach((errorKey)=>{
                        const errorMessage = contractualSchedulesErrors[errorKey];
                        if (errorMessage) {
                            // Convert error key from "contractualSchedules.X.Y" to "newUsers.0.contractualSchedules.X.Y"
                            const fullErrorKey = `newUsers.${index}.${errorKey}`;
                            if (!errors.newUsers[index]) errors.newUsers[index] = {};
                            errors[fullErrorKey] = errorMessage;
                        }
                    });
                }
                index++;
            }
            console.log('errors', errors);
            if (Object.keys(errors.newUsers).length > 0) return errors;
            return {};
        },
        onSubmit: async (values)=>{
            const { newUsers: newUsers } = values;
            for (const newUser of newUsers){
                const { email: email, firstName: firstName, lastName: lastName, schedule: schedule, internalRef: internalRef, internalComment: internalComment, internalInformation: internalInformation, organizationRole: organizationRole, laborCostCoefficients: laborCostCoefficients, contractualSchedules: contractualSchedules } = newUser;
                if (!user) {
                    const payload = {
                        firstName: firstName,
                        lastName: lastName,
                        role: {
                            kind: role
                        },
                        appAccess: noAppAccess ? 'none' : 'full'
                    };
                    if (role === 'worker' && currentOrganization) {
                        payload.association = currentOrganization._id;
                        payload.internalRef = internalRef;
                        payload.internalComment = internalComment;
                        payload.internalInformation = internalInformation;
                        if (currentOrganization.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer) {
                            // Create contractualSchedules entry from schedule or use existing contractualSchedules
                            if (contractualSchedules && contractualSchedules.length > 0) payload.contractualSchedules = (0, $44391656266f978a$export$76cf14d2b2649bf0)(contractualSchedules);
                            else if (schedule.weeklyHoursWorked || schedule.monthlyHoursWorked) {
                                // Create a new entry from schedule values if contractualSchedules is empty
                                const newEntry = (0, $44391656266f978a$export$11d7e77375792302)(new Date(), schedule.weeklyHoursWorked, schedule.monthlyHoursWorked);
                                payload.contractualSchedules = (0, $44391656266f978a$export$76cf14d2b2649bf0)([
                                    newEntry
                                ]);
                            }
                        }
                    }
                    if (!noAppAccess) payload.email = email;
                    if ((role === 'interimAgencyMember' || role === 'employerMember') && currentOrganization) {
                        payload.role.organization = currentOrganization._id;
                        payload.role.organizationRole = organizationRole || 'admin';
                    }
                    await createMutation.mutateAsync(payload).then((res)=>new Promise((resolve)=>{
                            setTimeout(()=>{
                                resolve(res);
                            }, 250);
                        }));
                } else if (role === 'employerMember') {
                    if (organizationRole) updateUserOrganizationRole.mutate({
                        userId: user._id,
                        organizationRole: organizationRole
                    });
                } else {
                    const payload = {
                        id: user._id
                    };
                    if (role === 'worker') {
                        payload.internalRef = internalRef;
                        payload.internalComment = internalComment;
                        payload.internalInformation = internalInformation;
                        payload.firstName = firstName;
                        payload.lastName = lastName;
                        if (emailCanBeUpdated) payload.email = email;
                        if (currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency && laborCostCoefficients) payload.laborCostCoefficients = Object.keys(laborCostCoefficients).map((employerId)=>({
                                employer: employerId,
                                kind: laborCostCoefficients[employerId]?.isManagement ? 'management' : 'delegation'
                            }));
                    }
                    if (currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer) {
                        // Use contractualSchedules if they exist, otherwise create from schedule
                        if (contractualSchedules && contractualSchedules.length > 0) payload.contractualSchedules = (0, $44391656266f978a$export$76cf14d2b2649bf0)(contractualSchedules);
                        else if (schedule.weeklyHoursWorked || schedule.monthlyHoursWorked) {
                            // Create a new entry from schedule values if contractualSchedules is empty
                            const newEntry = (0, $44391656266f978a$export$11d7e77375792302)(new Date(), schedule.weeklyHoursWorked, schedule.monthlyHoursWorked);
                            payload.contractualSchedules = (0, $44391656266f978a$export$76cf14d2b2649bf0)([
                                newEntry
                            ]);
                        }
                    }
                    updateMutation.mutate(payload);
                }
            }
        },
        children: ({ values: values, setFieldValue: setFieldValue, isSubmitting: isSubmitting })=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: !user && !noAppAccess && description
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                            title: "Importer depuis un fichier CSV",
                            actions: importCsvModal,
                            maxWidth: 1080,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $149f9dde4d8605df$export$3fd221666f2971b3), {
                                onSuccess: (newUsers)=>{
                                    setFieldValue('newUsers', newUsers);
                                    importCsvModal.setIsDisplayed(false);
                                },
                                model: currentOrganization?.type === 'interimAgency' ? [
                                    'email',
                                    'firstName',
                                    'lastName',
                                    'internalRef',
                                    'internalComment',
                                    'internalInformation'
                                ] : [
                                    'email',
                                    'firstName',
                                    'lastName',
                                    'internalRef',
                                    'schedule.weeklyHoursWorked',
                                    'schedule.monthlyHoursWorked',
                                    'internalComment',
                                    'internalInformation'
                                ]
                            })
                        }),
                        isSubmitting && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                            title: "Invitation en cours...",
                            actions: {
                                isDisplayed: true,
                                setIsDisplayed: ()=>{
                                    return;
                                }
                            },
                            children: [
                                "Invitation en cours : ",
                                createMutation.data?.data.email
                            ]
                        }),
                        values.newUsers.length > 1 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                            color: "info",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Header, {
                                    children: [
                                        values.newUsers.length,
                                        " invitations sont pr\xeates \xe0 \xeatre envoy\xe9es !"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: "Ne fermez pas votre navigateur durant l'op\xe9ration"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                            name: "newUsers",
                            children: ()=>{
                                return values.newUsers.map((newUser, index)=>{
                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        children: [
                                            emailCanBeUpdated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: `newUsers.${index}.email`,
                                                label: "Email",
                                                type: "email",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                placeholder: "adresse@email.com"
                                            }),
                                            role === 'employerMember' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "R\xf4le",
                                                name: `newUsers.${index}.organizationRole`,
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                options: [
                                                    {
                                                        value: 'admin',
                                                        label: (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).organizationRoles['admin']
                                                    },
                                                    {
                                                        value: 'teamLeader',
                                                        label: (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).organizationRoles['teamLeader']
                                                    },
                                                    {
                                                        value: 'clocker',
                                                        label: (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).organizationRoles['clocker']
                                                    }
                                                ]
                                            }),
                                            role === 'worker' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 6,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Nom de Naissance",
                                                            name: `newUsers.${index}.lastName`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            required: true,
                                                            placeholder: "Nom..."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 6,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Pr\xe9nom",
                                                            name: `newUsers.${index}.firstName`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            required: true,
                                                            placeholder: "Pr\xe9nom..."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 6,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Matricule Interne",
                                                            name: `newUsers.${index}.internalRef`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                children: [
                                                                    "Uniquement visible par les collaborateurs de",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                                        children: currentOrganization?.name
                                                                    }),
                                                                    ".",
                                                                    !user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                                            "Un matricule sera g\xe9n\xe9r\xe9 automatiquement si ce champ n'est pas rempli."
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 12,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Information Interne",
                                                            name: `newUsers.${index}.internalInformation`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                children: [
                                                                    "Uniquement visible par les collaborateurs de",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                                        children: currentOrganization?.name
                                                                    }),
                                                                    "."
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 12,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Commentaire Interne",
                                                            name: `newUsers.${index}.internalComment`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                children: [
                                                                    "Uniquement visible par les collaborateurs de",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                                        children: currentOrganization?.name
                                                                    }),
                                                                    "."
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    role === 'worker' && currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                        roles: [
                                                            'employerMember'
                                                        ],
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 12,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                mt: 5,
                                                                "data-test": "contractual-schedules-section",
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4eec54641b63ade8$export$2e2bcd8739ae039), {
                                                                    name: `newUsers.${index}.contractualSchedules`,
                                                                    hasWorkerEverHadTimeSlots: (0, $44391656266f978a$export$bd6b488620991bf1)(userAssociation)
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                        roles: [
                                                            'interimAgencyMember'
                                                        ],
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                                    size: 5,
                                                                    mb: 1,
                                                                    mt: 5,
                                                                    children: "Gestion / D\xe9l\xe9gation"
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                    textSize: 7,
                                                                    mb: 4,
                                                                    children: 'Si "gestion" est s\xe9lectionn\xe9 pour le travailleur et l\'Entreprises Utilisatrices, le coefficient gestion du m\xe9tier sera pris en compte pour le calcul du c\xf4ut horaire. Sinon, le coefficient d\xe9l\xe9gation sera utilis\xe9.'
                                                                }),
                                                                (associatedEmployerQuery.data || []).map((employer)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                            component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                                                            label: employer.name,
                                                                            text: 'Gestion',
                                                                            name: `newUsers.${index}.laborCostCoefficients[${employer._id}].isManagement`
                                                                        })
                                                                    }, employer._id))
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Left, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'interimAgencyMember',
                                            'employerMember'
                                        ],
                                        children: !noAppAccess && !user && role === 'worker' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            onClick: ()=>importCsvModal.setIsDisplayed(true),
                                            color: "primary",
                                            outlined: true,
                                            "data-test": "import-from-csv-action",
                                            children: "Import depuis un fichier CSV"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Right, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                            color: "primary",
                                            type: "submit",
                                            "data-test": "submit-invite-user",
                                            mutation: user ? role === 'employerMember' ? updateUserOrganizationRole : updateMutation : createMutation,
                                            children: user ? "Mettre \xe0 jour" : noAppAccess ? "Cr\xe9er un utilisateur Offline" : 'Inviter'
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                            mutation: user ? updateMutation : createMutation
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            });
        }
    });
};
var $8271524579384dc6$export$2e2bcd8739ae039 = $8271524579384dc6$var$UserForm;
const $8271524579384dc6$var$useDescription = (role, organizationType)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        switch(role){
            case 'worker':
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        "Invitez un ",
                        organizationType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'nouveau' : 'nouvel',
                        ' ',
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {
                            lowercase: true
                        }),
                        " \xe0 collaborer avec votre Agence.",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "Il devra accepter votre invitation en se connectant :",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            className: "content",
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Soit via l'app mobile TeamTim (compatible Android et iOS)"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Soit via la plateforme web TeamTim"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 3,
                            children: "S'il s'agit de la premi\xe8re fois qu'il utilise TeamTim, il devra compl\xe9ter son profil avant d'accepter l'invitation."
                        })
                    ]
                });
            case 'interimAgencyMember':
            case 'employerMember':
                return "Inviter un Nouvel Utilisateur. Cette personne pourra g\xe9rer l'agence au m\xeame titre que vous.";
            default:
                return "Inviter un Nouveau Super Administrateur de la plateforme. Cette personne aura les m\xeames droits que vous.";
        }
    }, [
        role
    ]);







const $3ac29d3051d7ddde$var$OfflineUserFormModal = ({ modalActions: modalActions })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        title: "Cr\xe9er un Utilisateur Offline",
        actions: modalActions,
        maxWidth: 1080,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Content), {
                className: "mb-3",
                renderAs: "p",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("details", {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("summary", {
                            children: "Afficher les d\xe9tails d'un Utilisateur Offline"
                        }),
                        "Un ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                            children: "Utilisateur Offline"
                        }),
                        " a les restrictions suivantes :",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("dialog", {}),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Ne peut pas se connecter \xe0 la plateforme"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Est exclusivement li\xe9 \xe0 l'Agence d'Int\xe9rim qui l'a cr\xe9\xe9"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Ne re\xe7oit pas de notifications"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: "Pointe via le QR Code fourni par son Agence d'Int\xe9rim"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8271524579384dc6$export$2e2bcd8739ae039), {
                role: "worker",
                noAppAccess: true
            })
        ]
    });
};
var $3ac29d3051d7ddde$export$2e2bcd8739ae039 = $3ac29d3051d7ddde$var$OfflineUserFormModal;





const $532af375c44b1e9c$var$CreateOfflineWorkerButton = ({})=>{
    const createMutationStatus = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $e607e015ac40917d$export$4a6f974b4208311)());
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)({
        autoClose: {
            on: Boolean(createMutationStatus?.status === 'success'),
            delay: 1500
        }
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                onClick: ()=>modal.setIsDisplayed(true),
                color: "primary",
                "data-test": "invite-offline-user",
                className: "mr-2",
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $779a11b92f76b06d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: [
                            "Cr\xe9er un ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                            " ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "strong",
                                children: "Offline"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3ac29d3051d7ddde$export$2e2bcd8739ae039), {
                modalActions: modal
            })
        ]
    });
};
var $532af375c44b1e9c$export$2e2bcd8739ae039 = $532af375c44b1e9c$var$CreateOfflineWorkerButton;



parcelRequire("3ZYaX");







const $67b845dc01493173$var$InviteUserButton = ({ userRoleKind: userRoleKind, label: label, modalTitle: modalTitle })=>{
    const createMutationStatus = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $e607e015ac40917d$export$4a6f974b4208311)());
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)({
        autoClose: {
            on: Boolean(createMutationStatus?.status === 'success'),
            delay: 1500
        }
    });
    const usersRoleLabel = (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[userRoleKind];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                onClick: ()=>modal.setIsDisplayed(true),
                color: "primary",
                "data-test": "invite-user",
                size: "small",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $779a11b92f76b06d$export$2e2bcd8739ae039), {})
                    }),
                    label ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: label
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: [
                            "Inviter un ",
                            usersRoleLabel
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                title: modalTitle || `Inviter un nouvel utilisateur`,
                actions: modal,
                dataTest: "worker-modal",
                maxWidth: 1080,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8271524579384dc6$export$2e2bcd8739ae039), {
                    role: userRoleKind
                })
            })
        ]
    });
};
var $67b845dc01493173$export$2e2bcd8739ae039 = $67b845dc01493173$var$InviteUserButton;




parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");



const $561daf7ffa20c908$var$INVITATION_STATUS_COLORS = {
    //TODO: move in to config file?
    accepted: 'success',
    pending: 'info',
    rejected: 'danger',
    discontinued: 'dark'
};
const $561daf7ffa20c908$var$RoleStatus = ({ role: role, showDate: showDate, text: text })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        "data-tooltip": showDate && role.updatedAt && (0, $74f17ceb9b5a08a5$export$9f679dbcb5959c9b)(role.updatedAt),
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                color: $561daf7ffa20c908$var$INVITATION_STATUS_COLORS[role.status],
                children: (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).roles.status[role.status]
            }),
            ' ',
            text
        ]
    });
};
var $561daf7ffa20c908$export$2e2bcd8739ae039 = $561daf7ffa20c908$var$RoleStatus;




parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");
function $851f24d5739c3050$var$PaperAirplaneIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
    }));
}
const $851f24d5739c3050$var$ForwardRef = $3ZYaX.forwardRef($851f24d5739c3050$var$PaperAirplaneIcon);
var $851f24d5739c3050$export$2e2bcd8739ae039 = $851f24d5739c3050$var$ForwardRef;


const $df2573771c2749ff$var$ResendUserInvitationButton = ({ userEmail: userEmail, roleKind: roleKind, organization: organization, color: color })=>{
    const createUserMutation = (0, $e607e015ac40917d$export$a25726670bb41cb)();
    const mutate = ()=>{
        const mutationPayload = {
            email: userEmail,
            appAccess: 'full',
            role: {
                kind: roleKind
            }
        };
        if (roleKind === 'employerMember' || roleKind === 'interimAgencyMember') {
            mutationPayload.role.organizationRole = 'admin';
            mutationPayload.role.organization = organization._id;
        } else if (roleKind === 'worker') mutationPayload.association = organization._id;
        createUserMutation.mutate(mutationPayload);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
        size: 'small',
        onClick: mutate,
        disabled: createUserMutation.isSuccess,
        mr: '2',
        mutation: createUserMutation,
        color: color,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("span", {
            className: "is-flex is-align-items-center",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    mr: 1,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $851f24d5739c3050$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                    children: "R\xe9-envoyer l'invitation"
                })
            ]
        })
    });
};
var $df2573771c2749ff$export$2e2bcd8739ae039 = $df2573771c2749ff$var$ResendUserInvitationButton;



parcelRequire("3ZYaX");







var $3ZYaX = parcelRequire("3ZYaX");
function $f7a86316dcf479ec$var$StopIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"
    }));
}
const $f7a86316dcf479ec$var$ForwardRef = $3ZYaX.forwardRef($f7a86316dcf479ec$var$StopIcon);
var $f7a86316dcf479ec$export$2e2bcd8739ae039 = $f7a86316dcf479ec$var$ForwardRef;


const $2cdd0a2d0aa6b53d$var$DiscontinueAssociationButton = ({ user: user, roleKind: roleKind, organization: organization, color: color })=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const discontinueUserOrganizationRoleMutation = (0, $e607e015ac40917d$export$4583ff801616e47d)();
    const discontinueWorkerAssociationMutation = (0, $e607e015ac40917d$export$c190e6a5197102e6)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                size: 'small',
                variant: "danger",
                onClick: ()=>modal.setIsDisplayed(true),
                mutation: discontinueUserOrganizationRoleMutation,
                color: color,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("span", {
                    className: "is-flex is-align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            size: "small",
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f7a86316dcf479ec$export$2e2bcd8739ae039), {
                                className: "h-4 w-4"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                            children: "Interrompre la collaboration"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: modal.isDisplayed,
                onCancel: ()=>modal.setIsDisplayed(false),
                onConfirm: ()=>{
                    if (roleKind === 'worker') discontinueWorkerAssociationMutation.mutate({
                        workerId: user._id
                    });
                    else discontinueUserOrganizationRoleMutation.mutate({
                        userId: user._id
                    });
                    modal.setIsDisplayed(false);
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        mb: 3,
                        children: [
                            "\xcates-vous certain de vouloir arr\xeater la collaboration avec",
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "strong",
                                children: user.firstName && user.lastName ? (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user) : user.email
                            }),
                            "?"
                        ]
                    }),
                    roleKind === 'worker' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Vous ne pourrez plus lui attribuer de Missions."
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Il ne pourra plus acc\xe9der \xe0 l'espace TeamTim de ",
                            organization.name,
                            "."
                        ]
                    })
                ]
            })
        ]
    });
};
var $2cdd0a2d0aa6b53d$export$2e2bcd8739ae039 = $2cdd0a2d0aa6b53d$var$DiscontinueAssociationButton;



parcelRequire("3ZYaX");




parcelRequire("3ZYaX");




const $bfc7605e46fe8a66$var$UpdateUserModal = ({ user: user, modalActions: modalActions, userRole: userRole })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        title: `Modifier les donn\xe9es de ${(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user)}`,
        actions: modalActions,
        maxWidth: 1080,
        dataTest: "worker-modal",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8271524579384dc6$export$2e2bcd8739ae039), {
                role: userRole,
                user: user,
                noAppAccess: user?.appAccess === 'none'
            })
        })
    });
};
var $bfc7605e46fe8a66$export$2e2bcd8739ae039 = $bfc7605e46fe8a66$var$UpdateUserModal;


const $8d20ace6564ce308$var$EditUserButton = ({ user: user, userRoleKind: userRoleKind, label: label, color: color })=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                size: "small",
                color: color,
                mr: '2',
                onClick: ()=>{
                    modal.setIsDisplayed(true);
                },
                "data-test": "edit-worker-btn",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        mr: label ? 1 : 0,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                    }),
                    label
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bfc7605e46fe8a66$export$2e2bcd8739ae039), {
                user: user,
                modalActions: modal,
                userRole: userRoleKind
            })
        ]
    });
};
var $8d20ace6564ce308$export$2e2bcd8739ae039 = $8d20ace6564ce308$var$EditUserButton;



parcelRequire("3ZYaX");




parcelRequire("3ZYaX");



const $ab090275a5b9074f$var$UserQrCodeModal = ({ user: user, modalActions: modalActions, canRegenerate: canRegenerate = true, isExternalWorker: isExternalWorker = false })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        title: `QR Code de  ${user?.firstName} ${user?.lastName}`,
        actions: modalActions,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            textAlign: "center",
            children: user?._id && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $68bb88384b952b03$export$2e2bcd8739ae039), {
                user: user,
                print: true,
                canRegenerate: canRegenerate,
                isExternalWorker: isExternalWorker
            })
        })
    });
};
var $ab090275a5b9074f$export$2e2bcd8739ae039 = $ab090275a5b9074f$var$UserQrCodeModal;


const $f96e282bde6594fa$var$ShowQrCodeButton = ({ user: user, canRegenerate: canRegenerate = true, color: color = 'default', label: label, isExternalWorker: isExternalWorker = false })=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                size: "small",
                onClick: ()=>{
                    modal.setIsDisplayed(true);
                },
                "data-test": `show-qr-code-${user._id}`,
                color: color,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a326b8f6e31ceb86$export$2e2bcd8739ae039), {})
                    }),
                    label && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ab090275a5b9074f$export$2e2bcd8739ae039), {
                modalActions: modal,
                user: user,
                canRegenerate: canRegenerate,
                isExternalWorker: isExternalWorker
            })
        ]
    });
};
var $f96e282bde6594fa$export$2e2bcd8739ae039 = $f96e282bde6594fa$var$ShowQrCodeButton;






var $3ZYaX = parcelRequire("3ZYaX");
function $523de3ca49b298c8$var$ArrowDownIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 14l-7 7m0 0l-7-7m7 7V3"
    }));
}
const $523de3ca49b298c8$var$ForwardRef = $3ZYaX.forwardRef($523de3ca49b298c8$var$ArrowDownIcon);
var $523de3ca49b298c8$export$2e2bcd8739ae039 = $523de3ca49b298c8$var$ForwardRef;



parcelRequire("3ZYaX");






const $eee0ba1dd40ac560$var$DeleteAssociationButton = ({ user: user, roleKind: roleKind, color: color })=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    //const deleteUserOrganizationRoleMutation = useDeleteUserOrganizationRoleMutation()
    const deleteWorkerAssociationMutation = (0, $e607e015ac40917d$export$2637f30f510c81e4)(user._id);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                size: 'small',
                variant: "danger",
                onClick: ()=>modal.setIsDisplayed(true),
                mutation: deleteWorkerAssociationMutation,
                color: color,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "span",
                    textColor: "danger",
                    textWeight: "bold",
                    children: "Supprimer"
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: modal.isDisplayed,
                onCancel: ()=>modal.setIsDisplayed(false),
                onConfirm: async ()=>{
                    if (roleKind === 'worker') {
                        await deleteWorkerAssociationMutation.mutateAsync({
                            workerId: user._id
                        }).catch((e)=>e);
                        if (deleteWorkerAssociationMutation.isSuccess) modal.setIsDisplayed(false);
                    //else discontinueUserOrganizationRoleMutation.mutate({ userId: user._id })
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        mb: 3,
                        children: [
                            "\xcates-vous certain de vouloir supprimer compl\xe8tement votre association avec",
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "strong",
                                children: user.firstName && user.lastName ? (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user) : user.email
                            }),
                            "?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        mb: 3,
                        children: "Cette op\xe9ration ne fonctionnera que si vous n'avez aucun historique de Mission ou Demande avec cette personne"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: deleteWorkerAssociationMutation
                    })
                ]
            })
        ]
    });
};
var $eee0ba1dd40ac560$export$2e2bcd8739ae039 = $eee0ba1dd40ac560$var$DeleteAssociationButton;



parcelRequire("3ZYaX");

const $d02addba8eace897$export$3c0c9559fbad40ef = ({ resource: resource, path: path, label: label })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$b0d92dbee9b5b60d), {
        to: `${path}${resource._id}`,
        children: label
    });
};



const $3226404e876ea62d$var$useUsersTableData = (users, roleKind, columns, enableSelection = false, selectedUserIds = [], onSelectionChange)=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const handleSelectAll = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback(()=>{
        if (!onSelectionChange) return;
        const allUserIds = (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(users, 'lastName').map((user)=>user._id);
        if (selectedUserIds.length === allUserIds.length) onSelectionChange([]);
        else onSelectionChange(allUserIds);
    }, [
        users,
        selectedUserIds,
        onSelectionChange
    ]);
    const handleSelectRow = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback((userId)=>{
        if (!onSelectionChange) return;
        if (selectedUserIds.includes(userId)) onSelectionChange(selectedUserIds.filter((id)=>id !== userId));
        else onSelectionChange([
            ...selectedUserIds,
            userId
        ]);
    }, [
        selectedUserIds,
        onSelectionChange
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const usersAsRows = (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(users, 'lastName').map((user)=>({
                ...$3226404e876ea62d$var$mapUserToRowData(user, currentOrganization, roleKind, currentUser),
                userId: user._id,
                select: enableSelection ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                    checked: selectedUserIds.includes(user._id),
                    onChange: ()=>handleSelectRow(user._id)
                }) : undefined
            }));
        const tableColumns = $3226404e876ea62d$var$buildColumns(columns, enableSelection, handleSelectAll, selectedUserIds, users.length);
        return {
            users: usersAsRows,
            columns: tableColumns
        };
    }, [
        users,
        currentOrganization,
        roleKind,
        currentUser,
        enableSelection,
        selectedUserIds,
        handleSelectRow,
        handleSelectAll
    ]);
};
var $3226404e876ea62d$export$2e2bcd8739ae039 = $3226404e876ea62d$var$useUsersTableData;
const $3226404e876ea62d$var$buildColumns = (requestedColumns, enableSelection = false, onSelectAll, selectedUserIds = [], totalUsers = 0)=>{
    const columns = [];
    // Ajouter la colonne de sélection en premier si activée
    if (enableSelection) columns.push({
        Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
            checked: totalUsers > 0 && selectedUserIds.length === totalUsers,
            onChange: onSelectAll
        }),
        accessor: 'select',
        id: 'select',
        width: 50
    });
    // Ajouter les autres colonnes
    requestedColumns.forEach((column)=>{
        const tableColumn = $3226404e876ea62d$var$allColumns.find((c)=>c.accessor === column);
        if (tableColumn) columns.push(tableColumn);
    });
    return columns;
};
const $3226404e876ea62d$var$mapUserToRowData = (user, organization, roleKind, currentUser)=>{
    const association = roleKind === 'worker' ? (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, organization) : undefined;
    const realUserRoleKind = roleKind === 'offlineWorker' || roleKind === 'employerWorker' ? 'worker' : roleKind;
    const userRole = (0, $25ffbf4bca475b04$export$c33a4269214e2ec4)(user, realUserRoleKind, organization?._id);
    const availability = roleKind === 'worker' && (0, $25ffbf4bca475b04$export$f5327d6ba0b1c3bb)(user, organization);
    const associationOrRoleStatus = roleKind === 'worker' ? association?.status : userRole?.status;
    const canAssociationBeDiscontinuedOrDeleted = associationOrRoleStatus && roleKind !== 'superAdmin' && user._id !== currentUser._id;
    const canAssociationBeDiscontinued = canAssociationBeDiscontinuedOrDeleted && (associationOrRoleStatus === 'accepted' || associationOrRoleStatus === 'pending');
    const canAssociationBeDeleted = canAssociationBeDiscontinuedOrDeleted && roleKind === 'worker' && (associationOrRoleStatus === 'rejected' || associationOrRoleStatus === 'discontinued');
    const canShowQrCode = association?.status === 'accepted' || association?.status === 'pending';
    const canUpdateUserInformation = roleKind !== 'interimAgencyMember' && (associationOrRoleStatus === 'accepted' || associationOrRoleStatus === 'pending') && currentUser._id !== user._id;
    const canRegenerateQrCode = user.appAccess === 'none' || user._id === currentUser._id;
    return {
        lastName: roleKind !== 'worker' ? user.lastName : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
            resource: user,
            path: `/workers/`,
            label: user.lastName
        }),
        firstName: roleKind !== 'worker' ? user.firstName : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
            resource: user,
            path: `/workers/`,
            label: user.firstName
        }),
        email: user.email,
        internalRef: association?.internalRef,
        internalComment: association?.internalComment && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            "data-tooltip": association.internalComment,
            "data-test": `internal-comment-${user._id}`,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                size: "auto",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
            })
        }),
        internalInformation: association?.internalInformation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            "data-tooltip": association.internalInformation,
            "data-test": `internal-information-${user._id}`,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                size: "auto",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
            })
        }),
        createdAt: (0, $74f17ceb9b5a08a5$export$9f679dbcb5959c9b)(user.createdAt),
        organizationRole: userRole?.organizationRole && (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).organizationRoles[userRole.organizationRole],
        associationStatus: association && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
            role: association,
            showDate: true
        }),
        roleStatus: userRole ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
            role: userRole,
            showDate: true
        }) : '',
        availability: availability && availability.absentFrom && (!availability.absentTo || (0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(availability.absentTo), new Date())) ? (0, $25ffbf4bca475b04$export$12c731bd2c9aa69b)(availability, user, true) : '',
        weeklyHoursWorked: roleKind === 'worker' && association ? (()=>{
            const weeklyHours = (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association)?.weeklyHoursWorked;
            const hasSchedule = (0, $25ffbf4bca475b04$export$85e20ba768953e2a)(association);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                alignItems: "center",
                style: {
                    gap: '0.5rem'
                },
                children: [
                    weeklyHours !== undefined ? weeklyHours : '',
                    hasSchedule && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: 'small',
                        "data-tooltip": "Horaire avec cr\xe9neaux horaires",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5fda1783bb83f57b), {})
                    })
                ]
            });
        })() : undefined,
        qrCode: canShowQrCode ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f96e282bde6594fa$export$2e2bcd8739ae039), {
            user: user,
            canRegenerate: canRegenerateQrCode
        }) : '',
        actions: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Dropdown), {
            right: true,
            icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $523de3ca49b298c8$export$2e2bcd8739ae039), {}),
            label: "Actions",
            "data-test": `user-actions-${user._id}`,
            className: "is-small",
            children: [
                canUpdateUserInformation ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                    renderAs: "div",
                    "data-test": `edit-user-${user._id}`,
                    value: `${user._id}_edit`,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8d20ace6564ce308$export$2e2bcd8739ae039), {
                        user: user,
                        userRoleKind: realUserRoleKind,
                        label: "Modifier les informations",
                        color: 'ghost'
                    })
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {}),
                associationOrRoleStatus && associationOrRoleStatus !== 'accepted' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                    renderAs: "div",
                    "data-test": `resend-invitation-${user._id}`,
                    value: `${user._id}_resend`,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $df2573771c2749ff$export$2e2bcd8739ae039), {
                        userEmail: user.email,
                        organization: organization,
                        roleKind: realUserRoleKind,
                        color: 'ghost'
                    })
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {}),
                canAssociationBeDiscontinued ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                    renderAs: "div",
                    "data-test": `discontinue-association-${user._id}`,
                    value: `${user._id}_discontinue`,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2cdd0a2d0aa6b53d$export$2e2bcd8739ae039), {
                        user: user,
                        organization: organization,
                        roleKind: realUserRoleKind,
                        color: 'ghost'
                    })
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {}),
                canAssociationBeDeleted ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Dropdown).Item, {
                    renderAs: "div",
                    "data-test": `discontinue-association-${user._id}`,
                    value: `${user._id}_discontinue`,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $eee0ba1dd40ac560$export$2e2bcd8739ae039), {
                        user: user,
                        roleKind: roleKind,
                        color: 'ghost'
                    }, user._id)
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {})
            ]
        })
    };
};
const $3226404e876ea62d$var$allColumns = [
    {
        Header: "Pr\xe9nom",
        accessor: 'firstName'
    },
    {
        Header: 'Nom',
        accessor: 'lastName'
    },
    {
        Header: 'Email',
        accessor: 'email'
    },
    {
        Header: 'Matricule',
        accessor: 'internalRef'
    },
    {
        Header: 'Com.',
        accessor: 'internalComment'
    },
    {
        Header: 'Info.',
        accessor: 'internalInformation'
    },
    {
        Header: "Cr\xe9\xe9 le",
        accessor: 'createdAt'
    },
    {
        Header: "R\xf4le",
        accessor: 'organizationRole'
    },
    {
        Header: 'Statut',
        accessor: 'associationStatus'
    },
    {
        Header: 'Statut',
        accessor: 'roleStatus'
    },
    {
        Header: 'Indisponi.',
        accessor: 'availability'
    },
    {
        Header: 'H / Sem.',
        accessor: 'weeklyHoursWorked'
    },
    {
        Header: 'QR',
        accessor: 'qrCode'
    },
    {
        Header: ' ',
        accessor: 'actions'
    }
];



const $5459a4afa6ab5673$var$UsersTable = ({ users: users, roleKind: roleKind, selectedUserIds: selectedUserIds = [], onSelectionChange: onSelectionChange, enableSelection: enableSelection = false })=>{
    const { columns: columns, users: usersAsRows } = (0, $3226404e876ea62d$export$2e2bcd8739ae039)(users, roleKind === 'offlineWorker' ? 'worker' : roleKind, $5459a4afa6ab5673$var$columnsByRoles[roleKind], enableSelection, selectedUserIds, onSelectionChange);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: columns,
        data: usersAsRows,
        noDataMessage: "Aucun Utilisateur \xe0 afficher",
        tableClassName: "overflow-visible",
        className: "overflow-visible",
        dataTest: "users-table"
    });
};
var $5459a4afa6ab5673$export$2e2bcd8739ae039 = $5459a4afa6ab5673$var$UsersTable;
const $5459a4afa6ab5673$var$columnsByRoles = {
    worker: [
        'lastName',
        'firstName',
        'internalRef',
        'weeklyHoursWorked',
        //'internalComment',
        //'internalInformation',
        'email',
        'associationStatus',
        //'availability',
        'qrCode',
        //'editUser',
        //'resendInvitation',
        //'discontinueAssociation',
        'actions'
    ],
    employerWorker: [
        'lastName',
        'firstName',
        'qrCode'
    ],
    offlineWorker: [
        'lastName',
        'firstName',
        'internalRef',
        'weeklyHoursWorked',
        'qrCode',
        //'editUser',
        //'discontinueAssociation',
        'actions'
    ],
    employerMember: [
        'lastName',
        'firstName',
        'email',
        'organizationRole',
        'roleStatus',
        //'editUser',
        //'resendInvitation',
        //'discontinueAssociation',
        'actions'
    ],
    interimAgencyMember: [
        'lastName',
        'firstName',
        'email',
        'roleStatus',
        //'resendInvitation',
        //'discontinueAssociation',
        'actions'
    ],
    superAdmin: [
        'lastName',
        'firstName',
        'email',
        'actions'
    ]
};



const $b90bbdefdce036cd$var$UsersList = ({})=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        // TODO: refactor using filters in store and in http requests
        status: [
            'accepted',
            'pending'
        ]
    });
    const [currentAppAccessTab, setCurrentAppAccessTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('full');
    /* TODO: Review this in v5 */ const usersRole = $b90bbdefdce036cd$var$useUsersRoleByPathname();
    const query = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': usersRole,
        appAccess: usersRole === 'worker' ? currentAppAccessTab : undefined
    });
    const tabs = [
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Connect\xe9"
                ]
            }),
            value: 'full'
        },
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Offline'"
                ]
            }),
            value: 'none'
        }
    ];
    const users = (query.data || []).filter((user)=>{
        // TODO: refactor using filters in store and in http requests
        const roleOrAssociationStatus = (0, $25ffbf4bca475b04$export$472a3a1acf73db3a)(user, usersRole, currentOrganization);
        return !filters.status || !filters.status[0] || !roleOrAssociationStatus || filters.status.includes(roleOrAssociationStatus);
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                        children: "\xa0"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Control, {
                        children: [
                            usersRole === 'worker' && currentAppAccessTab === 'none' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $532af375c44b1e9c$export$2e2bcd8739ae039), {}),
                            currentAppAccessTab !== 'none' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $67b845dc01493173$export$2e2bcd8739ae039), {
                                userRoleKind: usersRole
                            })
                        ]
                    })
                ]
            }),
            usersRole === 'worker' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                children: tabs.map((tab)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                        active: currentAppAccessTab === tab.value,
                        onClick: ()=>setCurrentAppAccessTab(tab.value),
                        "data-test": `workers-list-tab-${tab.value}`,
                        children: tab.label
                    }, tab.value))
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5459a4afa6ab5673$export$2e2bcd8739ae039), {
                users: users,
                roleKind: usersRole === 'worker' && currentAppAccessTab === 'none' ? 'offlineWorker' : usersRole
            })
        ]
    });
};
var $b90bbdefdce036cd$export$2e2bcd8739ae039 = $b90bbdefdce036cd$var$UsersList;
const $b90bbdefdce036cd$var$useUsersRoleByPathname = ()=>{
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (location.pathname.match('workers')) return 'worker';
        else if (location.pathname.match('interim-agency-members')) return 'interimAgencyMember';
        else if (location.pathname.match('employer-members')) return 'employerMember';
        return 'superAdmin';
    }, [
        location.pathname
    ]);
};




var $3ZYaX = parcelRequire("3ZYaX");










const $30ec2b5d5f16d47d$var$UserOrganizations = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    // Query - get user
    const userQuery = (0, $e607e015ac40917d$export$68dae0b0cacaa18a)(currentUser._id);
    const user = userQuery.data;
    // Mutations
    const updateRoleMutation = (0, $e607e015ac40917d$export$757b8024a8e3c75e)();
    const updateAssociationMutation = (0, $e607e015ac40917d$export$f85487c66297925e)();
    // Discontinue associaiton confirmation modal state
    const [currentAssociationToDiscontinue, setCurrentAssociationToDiscontinue] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    // Build columns
    const rolesColumns = $30ec2b5d5f16d47d$var$useRolesListTable(user?.roles || [], (params)=>updateRoleMutation.mutate({
            roleId: params.itemId,
            status: params.status
        }), 'roles');
    const associationsColumns = $30ec2b5d5f16d47d$var$useRolesListTable(user?.associations || [], (params)=>updateAssociationMutation.mutate({
            associationId: params.itemId,
            status: params.status
        }), 'associations', setCurrentAssociationToDiscontinue);
    // Check if user is worker (usefull to display or not associations)
    const isWorker = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return user?.roles.some((role)=>role.kind === 'worker') || false;
    }, [
        user
    ]);
    const isOnlyWorker = isWorker && user?.roles.length === 1;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            !isOnlyWorker && user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                        title: "Mes Profils",
                        subtitle: ""
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                                columns: rolesColumns,
                                data: user?.roles,
                                noDataMessage: "Aucune relation \xe0 afficher"
                            })
                        })
                    })
                ]
            }),
            isWorker && user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mt: 5,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                        title: "Mes Relations",
                        subtitle: "Liste de mes partenaires avec qui je travaille"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                                columns: associationsColumns,
                                data: user.associations,
                                noDataMessage: "Aucune relation \xe0 afficher"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                onConfirm: ()=>{
                    if (currentAssociationToDiscontinue) {
                        updateAssociationMutation.mutate({
                            associationId: currentAssociationToDiscontinue._id,
                            status: 'discontinued'
                        });
                        setCurrentAssociationToDiscontinue(undefined);
                    }
                },
                show: Boolean(currentAssociationToDiscontinue),
                onCancel: ()=>setCurrentAssociationToDiscontinue(undefined),
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        "\xcates vous certain de vouloir interrompre votre collaboration avec",
                        ' ',
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            textWeight: "bold",
                            children: currentAssociationToDiscontinue?.organization.name
                        }),
                        "? ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "L'agence ne pourra plus entrer vous attribuer des missions avec vous."
                    ]
                })
            })
        ]
    });
};
var $30ec2b5d5f16d47d$export$2e2bcd8739ae039 = $30ec2b5d5f16d47d$var$UserOrganizations;
const $30ec2b5d5f16d47d$var$useRolesListTable = (roles, respondToInvitation, type, setCurrentAssociationToDiscontinue)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            type === 'roles' ? {
                Header: 'Type',
                accessor: 'kind',
                Cell: (cell)=>{
                    const role = cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[role.kind],
                            ' ',
                            role.organization && `- ${role.organization.name}`
                        ]
                    }) //Todo: Refactor ... i18N?
                    ;
                }
            } : {
                Header: 'Agence',
                accessor: 'organization',
                Cell: ({ value: value })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: value.name
                    })
            },
            {
                Header: "Statut de l'invitation",
                accessor: 'status',
                Cell: (data)=>{
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                        role: data.cell.row.original,
                        showDate: true
                    });
                }
            },
            {
                Header: "Invit\xe9 par",
                accessor: 'invitedBy',
                Cell: ({ value: value })=>{
                    return value ? (0, $25ffbf4bca475b04$export$9a57c514c234d759)(value) : '';
                }
            },
            {
                Header: 'Action',
                accessor: '__actions',
                Cell: (data)=>{
                    const role = data.cell.row.original;
                    //TODO: Improve
                    //@ts-ignore
                    if (role.status === 'pending' && role.kind !== 'worker') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                size: 'small',
                                color: "success",
                                "data-test": "accept-invitation",
                                mr: 1,
                                onClick: ()=>respondToInvitation({
                                        itemId: role._id,
                                        status: 'accepted'
                                    }),
                                children: "Accepter"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                size: 'small',
                                color: "danger",
                                "data-test": "reject-invitation",
                                onClick: ()=>respondToInvitation({
                                        itemId: role._id,
                                        status: 'rejected'
                                    }),
                                children: "Refuser"
                            })
                        ]
                    });
                    if (role.status === 'accepted' && setCurrentAssociationToDiscontinue) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: 'small',
                        color: "danger",
                        "data-test": "discontinue-association",
                        onClick: ()=>setCurrentAssociationToDiscontinue(role),
                        children: "Se retirer"
                    });
                    return '';
                }
            }
        ], [
        roles,
        respondToInvitation,
        type
    ]);



parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $ce48c6296f76f7cc$var$ViewListIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    }));
}
const $ce48c6296f76f7cc$var$ForwardRef = $3ZYaX.forwardRef($ce48c6296f76f7cc$var$ViewListIcon);
var $ce48c6296f76f7cc$export$2e2bcd8739ae039 = $ce48c6296f76f7cc$var$ForwardRef;








var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");










parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");
const $ed7e5934a172a7ff$var$DateFilterField = ({ name: name, label: label, min: min, max: max })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: label,
            name: name || 'date',
            type: "date",
            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
            min: min,
            max: max
        })
    });
};
var $ed7e5934a172a7ff$export$2e2bcd8739ae039 = $ed7e5934a172a7ff$var$DateFilterField;




parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $01a86b74e7e073a3$var$IsAbandonedFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Abandon de Poste",
            name: "isAbandoned",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: [
                {
                    label: 'Oui',
                    value: true
                },
                {
                    label: 'Non',
                    value: false
                }
            ]
        })
    });
};
var $01a86b74e7e073a3$export$2e2bcd8739ae039 = $01a86b74e7e073a3$var$IsAbandonedFilterField;



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $37d0496fb25a3de5$var$IsValidatedFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Valid\xe9e",
            name: "isValidated",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: [
                {
                    label: 'Oui',
                    value: true
                },
                {
                    label: 'Non',
                    value: false
                }
            ]
        })
    });
};
var $37d0496fb25a3de5$export$2e2bcd8739ae039 = $37d0496fb25a3de5$var$IsValidatedFilterField;






const $e8d720daf990b168$export$7395418bd2a007ce = ({ display: display })=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods);
    if (display === false) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    const queriesStaleTime = 120000 // 2 min
    ;
    const filterConfigs = [
        {
            key: 'start',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                name: "start",
                label: "Date"
            }),
            defaultValue: filters.start
        },
        {
            key: 'user',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $992ecbd31670e2eb$export$2e2bcd8739ae039), {}),
            roles: [
                'employerMember',
                'interimAgencyMember'
            ],
            defaultValue: filters.user || []
        },
        {
            key: 'interimAgency',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                queriesStaleTime: queriesStaleTime,
                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
            }),
            roles: [
                'employerMember'
            ],
            defaultValue: filters.interimAgency || []
        },
        {
            key: 'employer',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                queriesStaleTime: queriesStaleTime,
                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer
            }),
            roles: [
                'interimAgencyMember'
            ],
            defaultValue: filters.employer || []
        },
        {
            key: 'jobTitle',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {
                queriesStaleTime: queriesStaleTime,
                employerIds: filters.employer
            }),
            roles: [
                'employerMember'
            ],
            defaultValue: filters.jobTitle || []
        },
        {
            key: 'service',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {
                queriesStaleTime: queriesStaleTime,
                employerIds: filters.employer
            }),
            roles: [
                'employerMember'
            ],
            defaultValue: filters.service || []
        },
        {
            key: 'events',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e2afd48e3c6e79e0$export$2e2bcd8739ae039), {}),
            roles: [
                'employerMember',
                'interimAgencyMember'
            ],
            defaultValue: filters.events || []
        },
        {
            key: 'tags',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2cec1859b1e37596$export$2e2bcd8739ae039), {
                queriesStaleTime: queriesStaleTime
            }),
            roles: [
                'employerMember'
            ],
            defaultValue: filters.tags || []
        },
        {
            key: 'isCancelled',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6b26f08d92179eff$export$2e2bcd8739ae039), {}),
            roles: [
                'employerMember',
                'interimAgencyMember'
            ],
            defaultValue: filters.isCancelled
        },
        {
            key: 'isAbandoned',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $01a86b74e7e073a3$export$2e2bcd8739ae039), {}),
            roles: [
                'employerMember',
                'interimAgencyMember'
            ],
            defaultValue: filters.isAbandoned
        },
        {
            key: 'isValidated',
            component: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37d0496fb25a3de5$export$2e2bcd8739ae039), {}),
            roles: [
                'employerMember',
                'interimAgencyMember'
            ],
            defaultValue: filters.isValidated
        }
    ];
    const initialValues = filterConfigs.reduce((acc, { key: key, defaultValue: defaultValue })=>({
            ...acc,
            [key]: defaultValue,
            end: filters.end
        }), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        onSubmit: (values)=>{
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods, values);
        },
        children: (props)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                    gap: 3,
                    children: [
                        filterConfigs.map(({ key: key, component: component, roles: roles })=>{
                            const isDisplayed = display?.includes(key) ?? true;
                            if (!isDisplayed) return null;
                            const filterComponent = roles ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: roles,
                                children: component
                            }) : component;
                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                                children: filterComponent
                            }, key);
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                            values: props.values,
                            submitForm: props.submitForm
                        })
                    ]
                })
            })
    });
};





const $058de93c047aef33$var$WorkPeriodsList = ()=>{
    const { filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods);
    console.log(filters.start);
    const query = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)({
        ...filters,
        start: (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(filters.start)),
        end: (0, $e94c78fdddee0309$export$2e2bcd8739ae039)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(filters.start)),
        summary: true
    });
    const action = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
        to: "/missions/",
        outlined: true,
        color: "primary",
        size: "small",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ce48c6296f76f7cc$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                children: "Liste des Missions"
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71db929d54fcb96$export$2e2bcd8739ae039), {
        title: "Liste des Journ\xe9es de Travail",
        subtitle: (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(filters.start),
        action: action,
        filters: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e8d720daf990b168$export$7395418bd2a007ce), {}),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2ac56eaf11a5826b$export$2e2bcd8739ae039), {
            workPeriods: query.data ?? []
        })
    });
};
var $058de93c047aef33$export$2e2bcd8739ae039 = $058de93c047aef33$var$WorkPeriodsList;



parcelRequire("3ZYaX");





var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");

parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");


const $b8f4896add0fe658$var$FormError = ({ data: data, message: message, title: title, autoClearTimeOut: autoClearTimeOut })=>{
    const [isDisplayed, setIsDisplayed] = (0, $3ZYaX.useState)(true);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
        show: isDisplayed,
        closeOnEsc: true,
        closeOnBlur: true,
        onClose: ()=>setIsDisplayed(false),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Content, {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Block), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Notification), {
                    color: "danger",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                            size: 5,
                            children: title || data?.message || 'Error'
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: message ? message : data?.code === 422 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "ul",
                                children: data?.data?.map((validationError, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: validationError.message
                                    }, index))
                            }) : data?.message
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                onClick: ()=>setIsDisplayed(false),
                                size: "small",
                                children: [
                                    "Fermer",
                                    ' ',
                                    autoClearTimeOut !== undefined && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58f73d374db62abb$export$15cef08a1ebd9933), {
                                        seconds: autoClearTimeOut,
                                        cb: ()=>setIsDisplayed(false)
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $b8f4896add0fe658$export$2e2bcd8739ae039 = $b8f4896add0fe658$var$FormError;



parcelRequire("3ZYaX");

const $1e9a7ef7e37465ec$var$FormProgess = ({ body: body })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
        show: true,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Content, {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Notification), {
                color: "warning",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        children: "Envoi en cours..."
                    }),
                    body && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 5,
                        children: body
                    })
                ]
            })
        })
    });
var $1e9a7ef7e37465ec$export$2e2bcd8739ae039 = $1e9a7ef7e37465ec$var$FormProgess;




var $3ZYaX = parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");
function $a22ae0aa54284c2c$var$BadgeCheckIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        fillRule: "evenodd",
        d: "M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
        clipRule: "evenodd"
    }));
}
const $a22ae0aa54284c2c$var$ForwardRef = $3ZYaX.forwardRef($a22ae0aa54284c2c$var$BadgeCheckIcon);
var $a22ae0aa54284c2c$export$2e2bcd8739ae039 = $a22ae0aa54284c2c$var$ForwardRef;



const $9b8e238277deea89$var$FormSuccess = ({ title: title, body: body, reset: reset, data: data })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        return ()=>reset && reset();
    }, []);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                color: 'success',
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a22ae0aa54284c2c$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        children: title
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                        px: 5,
                        py: 4,
                        children: [
                            body?.description && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                children: body.description
                            }),
                            body?.render && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                children: body.render(data)
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mt: 4,
                                children: body?.actions?.map((action, index)=>action.to ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                        to: action.to,
                                        mr: 2,
                                        children: action.label
                                    }, index) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        onClick: ()=>{
                                            reset && reset();
                                        },
                                        mr: 2,
                                        children: action.label
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $9b8e238277deea89$export$2e2bcd8739ae039 = $9b8e238277deea89$var$FormSuccess;


const $ab62f7d1f6a57e2e$var$RequestStatus = ({ status: status, successProps: successProps, loadingProps: loadingProps, errorProps: errorProps, reset: reset })=>{
    switch(status){
        case 'success':
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b8e238277deea89$export$2e2bcd8739ae039), {
                ...successProps,
                reset: reset
            });
        case 'loading':
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1e9a7ef7e37465ec$export$2e2bcd8739ae039), {
                ...loadingProps
            });
        case 'error':
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b8f4896add0fe658$export$2e2bcd8739ae039), {
                ...errorProps
            });
        default:
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    }
};
var $ab62f7d1f6a57e2e$export$2e2bcd8739ae039 = $ab62f7d1f6a57e2e$var$RequestStatus;


const $9b908348a81c2565$var$FormWrapper = (props)=>{
    const [showForm, setShowForm] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(true);
    const [showStatus, setShowStatus] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (props.status === 'success') setShowForm(false);
        if (props.status && props.status !== 'idle') setShowStatus(true);
    }, [
        props.status
    ]);
    if (props.disabled) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: props.children
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            showStatus && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ab62f7d1f6a57e2e$export$2e2bcd8739ae039), {
                ...props,
                reset: ()=>{
                    setShowForm(true);
                    setShowStatus(false);
                }
            }),
            showForm && props.children
        ]
    });
};
var $9b908348a81c2565$export$2e2bcd8739ae039 = $9b908348a81c2565$var$FormWrapper;





var $3ZYaX = parcelRequire("3ZYaX");
const $1993f4b353339a80$export$46e69a1ed5a53805 = (props, mutation, disabled)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>({
            status: mutation?.status,
            ...props,
            disabled: disabled,
            successProps: {
                ...props.successProps || {},
                data: mutation?.data
            },
            errorProps: {
                ...props.errorProps || {},
                data: mutation?.error?.response?.data
            }
        }), [
        props,
        mutation
    ]);


function $d6539e345b1b67ba$var$e(e) {
    this.message = e;
}
$d6539e345b1b67ba$var$e.prototype = new Error, $d6539e345b1b67ba$var$e.prototype.name = "InvalidCharacterError";
var $d6539e345b1b67ba$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $d6539e345b1b67ba$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $d6539e345b1b67ba$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($d6539e345b1b67ba$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $d6539e345b1b67ba$var$r(t);
    }
}
function $d6539e345b1b67ba$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $d6539e345b1b67ba$var$o(e, r) {
    if ("string" != typeof e) throw new $d6539e345b1b67ba$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($d6539e345b1b67ba$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $d6539e345b1b67ba$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$d6539e345b1b67ba$export$b9721ef022f71a68.prototype = new Error, $d6539e345b1b67ba$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $d6539e345b1b67ba$export$2e2bcd8739ae039 = $d6539e345b1b67ba$var$o;



const $ec10b1db3ff8ab2c$export$b66334e2c73a3eca = (searchParamName)=>{
    const [searchParams] = (0, $d7b8f401c6bc9326$export$f1a78c17382fe22a)();
    const token = searchParams.get(searchParamName || 'token') || undefined;
    try {
        const decoded = token && (0, $d6539e345b1b67ba$export$2e2bcd8739ae039)(token);
        return {
            token: token,
            decoded: decoded
        };
    } catch (err) {
        return {
            token: undefined,
            decoded: undefined
        };
    }
};




const $fd67fb6f4ff2d44e$var$CompleteProfileform = ({})=>{
    const { token: token, decoded: decoded } = (0, $ec10b1db3ff8ab2c$export$b66334e2c73a3eca)();
    const mutation = (0, $e607e015ac40917d$export$cfcf74bf9df36337)();
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($fd67fb6f4ff2d44e$var$formWrapperBaseProps, mutation);
    if (!decoded || !token) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
        children: "Le lien que vous avez utilis\xe9 est expir\xe9 ou erron\xe9."
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            email: decoded.data.email,
            id: decoded._id,
            token: token,
            firstName: decoded.data?.firstName ?? '',
            lastName: decoded.data?.lastName ?? '',
            newPassword: '',
            confirmNewPassword: '',
            confirmPrivacyPolicy: false,
            confirmTermsOfUse: false,
            confirmAssociations: false
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.email) errors.email = 'Champ requis';
            if (!values.firstName) errors.firstName = 'Champ requis';
            if (!values.lastName) errors.lastName = 'Champ requis';
            if (!values.newPassword) errors.newPassword = 'Champ requis';
            if (!values.confirmNewPassword) errors.confirmNewPassword = 'Champ requis';
            if (values.newPassword !== values.confirmNewPassword) errors.confirmNewPassword = "Les deux mots de passe doivent \xeatre similaires";
            if (values.confirmPrivacyPolicy === false) errors.confirmPrivacyPolicy = "Vous devez accepter la Politique de Confidentialit\xe9";
            if (values.confirmTermsOfUse === false) errors.confirmTermsOfUse = "Vous devez accepter les Conditions G\xe9n\xe9rales d'Utilisation";
            if (values.confirmAssociations === false) errors.confirmAssociations = "Vous devez accepter de travailler avec les employeurs vous ayant invit\xe9 sur la plateforme";
            return errors;
        },
        onSubmit: (values)=>{
            // No need for confirmNewPassword, we already know it's similar to newPassword with validation
            // No need for confirmPrivacyPolicy, by completing the profile we know it is accepted
            // No need for confirmTermsOfUse, by completing the profile we know it is accepted
            const { newPassword: password, confirmNewPassword: confirmNewPassword, confirmPrivacyPolicy: confirmPrivacyPolicy, confirmTermsOfUse: confirmTermsOfUse, confirmAssociations: confirmAssociations, ...data } = values;
            mutation.mutate({
                ...data,
                password: password
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                ...formWrapperProps,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "p",
                            mb: 6,
                            children: [
                                "Bienvenue !",
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                "Compl\xe9tez votre profil pour pouvoir vous connecter \xe0 la plateforme."
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 6,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Email",
                                    name: "email",
                                    type: "email",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    required: true,
                                    disabled: true
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Nom",
                                    name: "lastName",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    required: true
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Pr\xe9nom",
                                    name: "firstName",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                label: "Nouveau mot de passe",
                                name: "newPassword",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                label: "Confirmez le mot de passe",
                                name: "confirmNewPassword",
                                required: true
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 6,
                            mt: 6,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                label: "Conditions G\xe9n\xe9rales d'Utilisation",
                                name: "confirmTermsOfUse",
                                "data-test": "confirmTermsOfUse",
                                required: true,
                                text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        "J'accepte les",
                                        ' ',
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                            to: '/terms-of-use',
                                            target: "_blank",
                                            children: "Conditions G\xe9n\xe9rales d'Utilisation de la plateforme"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 6,
                            mt: 6,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                label: "Politique de Confidentialit\xe9",
                                name: "confirmPrivacyPolicy",
                                "data-test": "confirmPrivacyPolicy",
                                required: true,
                                text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        "J'accepte la",
                                        ' ',
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                            to: '/privacy-policy',
                                            target: "_blank",
                                            children: "Politique de Confidentialit\xe9"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 6,
                            mt: 6,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                label: "Employeurs m'ayant invit\xe9 sur la plateforme",
                                name: "confirmAssociations",
                                "data-test": "confirmAssociations",
                                required: true,
                                text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: "J'accepte de travailler avec les employeurs m'ayant invit\xe9 sur la plateforme"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                            mb: 6,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mt: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                    color: "primary",
                                    type: "submit",
                                    mutation: mutation,
                                    children: "Rejoindre"
                                })
                            })
                        })
                    ]
                })
            });
        }
    });
};
const $fd67fb6f4ff2d44e$var$formWrapperBaseProps = {
    loadingProps: {
        body: "Enregistrement de vos donn\xe9es..."
    },
    successProps: {
        title: "Compte cr\xe9\xe9 et valid\xe9",
        body: {
            description: "Vous pouvez maintenant vous connecter \xe0 la plateforme",
            actions: [
                {
                    label: 'Se connecter',
                    to: '/login'
                }
            ]
        }
    }
};
var $fd67fb6f4ff2d44e$export$2e2bcd8739ae039 = $fd67fb6f4ff2d44e$var$CompleteProfileform;


const $ec4c0c4a79db7ca6$var$UserCompleteProfile = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Compl\xe9tez votre profil"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    max: true,
                    breakpoint: 'desktop',
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fd67fb6f4ff2d44e$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $ec4c0c4a79db7ca6$export$2e2bcd8739ae039 = $ec4c0c4a79db7ca6$var$UserCompleteProfile;




var $3ZYaX = parcelRequire("3ZYaX");





var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");



const $f5f085cded95376e$var$RequestNewPasswordForm = ({})=>{
    const mutation = (0, $e607e015ac40917d$export$ed9d7b7ba2731b5a)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            email: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.email) errors.email = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            mutation.mutate(values);
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            label: "Votre adresse email",
                            name: "email",
                            type: "email",
                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                            required: true
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "primary",
                            type: "submit",
                            children: "Envoyer"
                        })
                    ]
                })
            });
        }
    });
};
var $f5f085cded95376e$export$2e2bcd8739ae039 = $f5f085cded95376e$var$RequestNewPasswordForm;






const $0c8722c9b7e06421$var$UserRequestNewPassword = ({})=>{
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $e607e015ac40917d$export$1c1c8631916ac0e4)());
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)({
        loadingProps: {
            body: "V\xe9rification en cours..."
        },
        errorProps: {
            title: 'Une erreur est survenue',
            message: 'Email inconnu'
        }
    }, mutationState);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (mutationState?.status === 'success' && mutationState?.data?.data) navigate(`/reset-password?token=${mutationState?.data?.data}`);
    }, [
        mutationState?.status,
        mutationState?.data?.data
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: 'large',
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                centered: true,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                            children: "Demande de nouveau mot de passe"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                            ...formWrapperProps,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f5f085cded95376e$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    });
};
var $0c8722c9b7e06421$export$2e2bcd8739ae039 = $0c8722c9b7e06421$var$UserRequestNewPassword;



parcelRequire("3ZYaX");







var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");




const $9b7c436803ecfb9a$var$ResetPasswordForm = ({ token: token })=>{
    const mutation = (0, $e607e015ac40917d$export$3177acf383c684f6)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            newPassword: '',
            confirmNewPassword: '',
            validationCode: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.newPassword) errors.password = 'Champ requis';
            if (!values.validationCode) errors.password = 'Champ requis';
            if (!values.confirmNewPassword) errors.password = 'Champ requis';
            if (values.newPassword !== values.confirmNewPassword) errors.confirmNewPassword = "Les deux mots de passe doivent \xeatre similaires";
            return errors;
        },
        onSubmit: (values)=>{
            const { newPassword: password, validationCode: validationCode } = values;
            token && mutation.mutate({
                password: password,
                token: token,
                validationCode: Number(validationCode)
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            label: "Code de v\xe9rification",
                            help: "Entrez ici le code \xe0 4 chiffres que vous avez re\xe7u par email.",
                            name: "validationCode",
                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                            required: true
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                label: "Votre nouveau mot de passe",
                                name: "newPassword"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d92bced011ae5ac2$export$4c8fbcc76e8879d0), {
                                label: "Confirmez le mot de passe",
                                name: "confirmNewPassword"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "primary",
                            type: "submit",
                            children: "Mettre \xe0 jour"
                        })
                    ]
                })
            });
        }
    });
};
var $9b7c436803ecfb9a$export$2e2bcd8739ae039 = $9b7c436803ecfb9a$var$ResetPasswordForm;







const $829c3c82953b9eca$var$UserResetPassword = ({})=>{
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $e607e015ac40917d$export$f805b1fed8a2f078)());
    const [searchParams] = (0, $d7b8f401c6bc9326$export$f1a78c17382fe22a)();
    const isMobileRequest = Boolean(searchParams.get('isMobileRequest'));
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($829c3c82953b9eca$var$formWrapperBaseProps(isMobileRequest), mutationState);
    const { token: token, decoded: decoded } = (0, $ec10b1db3ff8ab2c$export$b66334e2c73a3eca)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Section), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    centered: true,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 6,
                        textAlign: "center",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                            title: "Modifier votre mot de passe"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    centered: true,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 4,
                        children: !decoded.data.isCompleted ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textAlign: 'center',
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        color: "warning",
                                        size: 'large',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {
                                            color: "warning"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "p",
                                    mb: 5,
                                    textAlign: 'center',
                                    children: [
                                        "Votre compte n'a pas encore \xe9t\xe9 compl\xe9t\xe9 et valid\xe9. ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        "Un email vous a \xe9t\xe9 envoy\xe9 avec un lien vers le formulaire de validation de compte."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textAlign: 'center',
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        color: "success",
                                        size: 'large',
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {
                                            color: "success"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "p",
                                    mb: 5,
                                    textAlign: 'center',
                                    children: [
                                        "Un email vous a \xe9t\xe9 envoy\xe9 avec un code v\xe9rification. ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        "Merci d'utiliser ce code ici. \uD83D\uDC47"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                                    ...formWrapperProps,
                                    children: [
                                        isMobileRequest && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 3,
                                            children: "Vous avez fait une demande de nouveau mot de passe depuis l'application mobile. Entrez ici votre nouveau mot de passe."
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b7c436803ecfb9a$export$2e2bcd8739ae039), {
                                            token: token
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $829c3c82953b9eca$export$2e2bcd8739ae039 = $829c3c82953b9eca$var$UserResetPassword;
const $829c3c82953b9eca$var$formWrapperBaseProps = (isMobileRequest)=>({
        loadingProps: {
            body: "V\xe9rification en cours..."
        },
        successProps: {
            title: "Mot de passe modifi\xe9",
            body: {
                description: isMobileRequest ? "Vous pouvez retourner dans l'application mobile et utiliser votre nouveau mot de passe pour vous connecter." : "Vous pouvez d\xe8s \xe0 pr\xe9sent utiliser votre nouveau mot de passe pour vous connecter.",
                actions: !isMobileRequest ? [
                    {
                        label: 'Se connecter',
                        to: '/login'
                    }
                ] : []
            }
        },
        errorProps: {
            title: 'Une erreur est survenue',
            message: "Le code de v\xe9rification n'existe pas, a expir\xe9 ou est incorrect. Veuillez consulter vos emails pour obtenir le code ou recommencer la proc\xe9dure."
        }
    });




var $3ZYaX = parcelRequire("3ZYaX");








const $03b0d7bfb7bf5f57$var$UserValidateNewEmail = ({})=>{
    const { token: token } = (0, $ec10b1db3ff8ab2c$export$b66334e2c73a3eca)();
    const mutation = (0, $e607e015ac40917d$export$8008a84964b77b35)();
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)({
        loadingProps: {
            body: "V\xe9rification en cours..."
        },
        successProps: {
            title: "Adresse email modifi\xe9e",
            body: {
                description: "Votre ancienne adresse email n'est plus utilisable sur la plateforme.",
                actions: [
                    {
                        label: 'Ok',
                        to: currentUser ? '/' : '/login'
                    }
                ]
            }
        }
    }, mutation);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        token && mutation.mutate(token);
    }, []);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Validation de votre nouvelle adresse email"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                        ...formWrapperProps,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {})
                    })
                })
            })
        ]
    });
};
var $03b0d7bfb7bf5f57$export$2e2bcd8739ae039 = $03b0d7bfb7bf5f57$var$UserValidateNewEmail;




var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");



const $4fe9b4e9d5785309$var$Error404 = ({ redirect: redirect })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                textAlign: "center",
                className: "content is-vcentered has-text-centered",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 2,
                        mt: 6,
                        children: "404"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        subtitle: true,
                        renderAs: "p",
                        children: "La resource demand\xe9e n'existe pas."
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                        to: '/',
                        children: "Retour \xe0 l'\xe9cran d'accueil"
                    }),
                    redirect && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                        to: redirect.to,
                        ml: 2,
                        children: redirect.label
                    })
                ]
            })
        })
    });
var $4fe9b4e9d5785309$export$2e2bcd8739ae039 = $4fe9b4e9d5785309$var$Error404;



// Composants principaux


var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");







var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");

var $d1b5189acab1f57c$export$2e2bcd8739ae039 = function useLatest(value) {
    var ref = $3ZYaX.useRef(value);
    (0, $7a32f83835be847b$export$2e2bcd8739ae039)(function() {
        ref.current = value;
    });
    return ref;
};



var $3ZYaX = parcelRequire("3ZYaX");
var $b21d00a1857cd6ca$var$updateRef = function updateRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    ref.current = value;
};
var $b21d00a1857cd6ca$var$useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, $3ZYaX.useRef)();
    return (0, $3ZYaX.useCallback)(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) $b21d00a1857cd6ca$var$updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        $b21d00a1857cd6ca$var$updateRef(userRef, instance);
    }, [
        userRef
    ]);
};
var $b21d00a1857cd6ca$export$2e2bcd8739ae039 = $b21d00a1857cd6ca$var$useComposedRef;


var $b756ef4ee3daf852$var$HIDDEN_TEXTAREA_STYLE = {
    'min-height': '0',
    'max-height': 'none',
    height: '0',
    visibility: 'hidden',
    overflow: 'hidden',
    position: 'absolute',
    'z-index': '-1000',
    top: '0',
    right: '0'
};
var $b756ef4ee3daf852$var$forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys($b756ef4ee3daf852$var$HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, $b756ef4ee3daf852$var$HIDDEN_TEXTAREA_STYLE[key], 'important');
    });
};
var $b756ef4ee3daf852$var$forceHiddenStyles$1 = $b756ef4ee3daf852$var$forceHiddenStyles;
// TODO: use labelled tuples once they are avaiable:
//   export type CalculatedNodeHeights = [height: number, rowHeight: number];
// https://github.com/microsoft/TypeScript/issues/28259
var $b756ef4ee3daf852$var$hiddenTextarea = null;
var $b756ef4ee3daf852$var$getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function $b756ef4ee3daf852$var$calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!$b756ef4ee3daf852$var$hiddenTextarea) {
        $b756ef4ee3daf852$var$hiddenTextarea = document.createElement('textarea');
        $b756ef4ee3daf852$var$hiddenTextarea.setAttribute('tabindex', '-1');
        $b756ef4ee3daf852$var$hiddenTextarea.setAttribute('aria-hidden', 'true');
        $b756ef4ee3daf852$var$forceHiddenStyles$1($b756ef4ee3daf852$var$hiddenTextarea);
    }
    if ($b756ef4ee3daf852$var$hiddenTextarea.parentNode === null) document.body.appendChild($b756ef4ee3daf852$var$hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        $b756ef4ee3daf852$var$hiddenTextarea.style[key] = sizingStyle[key];
    });
    $b756ef4ee3daf852$var$forceHiddenStyles$1($b756ef4ee3daf852$var$hiddenTextarea);
    $b756ef4ee3daf852$var$hiddenTextarea.value = value;
    var height = $b756ef4ee3daf852$var$getHeight($b756ef4ee3daf852$var$hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    $b756ef4ee3daf852$var$hiddenTextarea.value = value;
    height = $b756ef4ee3daf852$var$getHeight($b756ef4ee3daf852$var$hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    $b756ef4ee3daf852$var$hiddenTextarea.value = 'x';
    var rowHeight = $b756ef4ee3daf852$var$hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var $b756ef4ee3daf852$var$noop = function noop() {};
var $b756ef4ee3daf852$var$pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var $b756ef4ee3daf852$var$SIZING_STYLE = [
    'borderBottomWidth',
    'borderLeftWidth',
    'borderRightWidth',
    'borderTopWidth',
    'boxSizing',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    // non-standard
    'tabSize',
    'textIndent',
    // non-standard
    'textRendering',
    'textTransform',
    'width',
    'wordBreak'
];
var $b756ef4ee3daf852$var$isIE = !!document.documentElement.currentStyle;
var $b756ef4ee3daf852$var$getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = $b756ef4ee3daf852$var$pick($b756ef4ee3daf852$var$SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === '') return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if ($b756ef4ee3daf852$var$isIE && boxSizing === 'border-box') sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var $b756ef4ee3daf852$var$getSizingData$1 = $b756ef4ee3daf852$var$getSizingData;
function $b756ef4ee3daf852$var$useListener(target, type, listener) {
    var latestListener = (0, $d1b5189acab1f57c$export$2e2bcd8739ae039)(listener);
    $3ZYaX.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var $b756ef4ee3daf852$var$useWindowResizeListener = function useWindowResizeListener(listener) {
    $b756ef4ee3daf852$var$useListener(window, 'resize', listener);
};
var $b756ef4ee3daf852$var$useFontsLoadedListener = function useFontsLoadedListener(listener) {
    $b756ef4ee3daf852$var$useListener(document.fonts, 'loadingdone', listener);
};
var $b756ef4ee3daf852$var$_excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var $b756ef4ee3daf852$var$TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? $b756ef4ee3daf852$var$noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? $b756ef4ee3daf852$var$noop : _ref$onHeightChange, props = (0, $ec4d20ddd5cc9c41$export$2e2bcd8739ae039)(_ref, $b756ef4ee3daf852$var$_excluded);
    var isControlled = props.value !== undefined;
    var libRef = $3ZYaX.useRef(null);
    var ref = (0, $b21d00a1857cd6ca$export$2e2bcd8739ae039)(libRef, userRef);
    var heightRef = $3ZYaX.useRef(0);
    var measurementsCacheRef = $3ZYaX.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : $b756ef4ee3daf852$var$getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = $b756ef4ee3daf852$var$calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty('height', height + "px", 'important');
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    $3ZYaX.useLayoutEffect(resizeTextarea);
    $b756ef4ee3daf852$var$useWindowResizeListener(resizeTextarea);
    $b756ef4ee3daf852$var$useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ $3ZYaX.createElement("textarea", (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var $b756ef4ee3daf852$export$2e2bcd8739ae039 = /* #__PURE__ */ $3ZYaX.forwardRef($b756ef4ee3daf852$var$TextareaAutosize);



const $3f63467ecce9325b$var$TextareaField = (props)=>{
    const { field: field, form: form, ...rest } = props;
    if (props.field.value === undefined) props.field.value = '';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: props.label,
        error: form.errors[field.name],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b756ef4ee3daf852$export$2e2bcd8739ae039), {
            ...field,
            ...rest,
            className: "textarea"
        })
    });
};
var $3f63467ecce9325b$export$2e2bcd8739ae039 = $3f63467ecce9325b$var$TextareaField;




var $3ZYaX = parcelRequire("3ZYaX");
function $5591fb484a4ebad6$var$UserCircleIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $5591fb484a4ebad6$var$ForwardRef = $3ZYaX.forwardRef($5591fb484a4ebad6$var$UserCircleIcon);
var $5591fb484a4ebad6$export$2e2bcd8739ae039 = $5591fb484a4ebad6$var$ForwardRef;


parcelRequire("3ZYaX");


const $79579c12c65688d1$var$Quote = ({ message: message, sender: sender })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "blockquote",
                backgroundColor: "light",
                p: 3,
                pl: 4,
                style: {
                    borderLeft: '4px solid #dbdbdb'
                },
                children: message
            }),
            sender && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textAlign: "right",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("i", {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            size: "small",
                            style: {
                                verticalAlign: 'middle'
                            },
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5591fb484a4ebad6$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: sender
                        })
                    ]
                })
            })
        ]
    });
};
var $79579c12c65688d1$export$2e2bcd8739ae039 = $79579c12c65688d1$var$Quote;





const $e6bcf76b5d1d8091$var$ManualClockingFieldHelp = ({ manualClockingDate: manualClockingDate, manualClockingUpdated: manualClockingUpdated, disabled: disabled, onEditManualClockingDay: onEditManualClockingDay, isNotInRange: isNotInRange })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            manualClockingDate && manualClockingUpdated && !disabled ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                onClick: ()=>onEditManualClockingDay(),
                renderAs: manualClockingUpdated ? 'a' : 'span',
                textColor: "grey",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        manualClockingUpdated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            size: "small",
                            mt: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                        }),
                        (0, $74f17ceb9b5a08a5$export$28ab905ff7c66dbe)(manualClockingDate)
                    ]
                })
            }) : manualClockingDate && (0, $74f17ceb9b5a08a5$export$28ab905ff7c66dbe)(manualClockingDate),
            isNotInRange === true && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                pull: "right",
                color: "warning",
                style: {
                    height: '20px',
                    width: '20px'
                },
                "data-tooltip": "La date de pointage exc\xe8de de plus de 4 heures la plage horaire de la p\xe9riode de travail",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
            })
        ]
    });
};
/**
 * Theoretical time: read-only display with edit pencil, or time input when editing.
 */ const $e6bcf76b5d1d8091$var$TheoreticalTimeField = ({ clockingTime: clockingTime, displayValue: displayValue, disabled: disabled })=>{
    const [isEditing, setIsEditing] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    if (isEditing) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
        type: "time",
        name: `workPeriod.${clockingTime}.date`,
        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
        dataTest: `work-period-${clockingTime}-theoretical`,
        disabled: disabled
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        onClick: ()=>!disabled && setIsEditing(true),
        style: {
            cursor: disabled ? undefined : 'pointer'
        },
        "data-test": `work-period-${clockingTime}-theoretical-display`,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
            children: [
                !disabled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    size: "small",
                    mt: 1,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                }),
                displayValue
            ]
        })
    });
};
/**
 * Composant pour afficher et gérer les détails de pointage (début ou fin).
 * Affiche les informations théoriques (éditables au clic sur le crayon), pointées et permet la correction manuelle.
 */ const $e6bcf76b5d1d8091$var$WorkPeriodClockingTimeDetails = ({ workPeriod: workPeriod, clockingTime: clockingTime, formManualClockingValue: formManualClockingValue, formTheoreticalValue: formTheoreticalValue, manualClockingDate: manualClockingDate, onEditManualClockingDay: onEditManualClockingDay, displayManualClockingDay: displayManualClockingDay, manualClockingUpdated: manualClockingUpdated, disabled: disabled })=>{
    const clockingData = workPeriod[clockingTime];
    const comment = clockingData && clockingData.manualClocking && clockingData.comments[clockingData.comments.length - 1];
    const inputFieldDisabled = !workPeriod.__actions.canBeManualClocked || !(0, $8403deec6a28521e$export$6025088343704f9f)([
        'employerMember'
    ], {
        resource: 'missions',
        name: 'updateWorkPeriodManualClocking'
    });
    /** Theoretical hours can be edited when the work period is updatable (same permission as updateWorkPeriod). */ const theoreticalFieldDisabled = !workPeriod.__actions.canBeUpdated || !(0, $8403deec6a28521e$export$6025088343704f9f)([
        'employerMember'
    ], {
        resource: 'missions',
        name: 'updateWorkPeriod'
    });
    const isManualClockingValueModified = formManualClockingValue && formManualClockingValue !== (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(clockingData.manualClocking);
    const isInRange = manualClockingDate && (0, $74f17ceb9b5a08a5$export$5eefd315c24a8505)(manualClockingDate, (0, $410057b58fa5bc28$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), 4), (0, $c468ed5e889a430e$export$2e2bcd8739ae039)(new Date(workPeriod.end.date), 4));
    const theoreticalDisplayValue = formTheoreticalValue ?? (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(clockingData.date);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c288541aa0d2549e$export$2e2bcd8739ae039), {
        labelColumnWidth: '20%',
        items: [
            {
                label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    size: 4,
                    children: clockingTime === 'start' ? "D\xe9but" : 'Fin'
                }),
                value: ' '
            },
            {
                label: "Th\xe9orique",
                value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($e6bcf76b5d1d8091$var$TheoreticalTimeField, {
                    clockingTime: clockingTime,
                    displayValue: theoreticalDisplayValue,
                    disabled: theoreticalFieldDisabled
                })
            },
            {
                label: "Point\xe9 \xe0",
                value: clockingData.clocking ? (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(clockingData.clocking.date) : '/'
            },
            {
                label: "Corrig\xe9",
                value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        displayManualClockingDay && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            type: "date",
                            name: `workPeriod.${clockingTime}.manualClockingDay`,
                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                            disabled: inputFieldDisabled,
                            min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $410057b58fa5bc28$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), 12)),
                            max: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $c468ed5e889a430e$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), 12))
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            type: "time",
                            name: `workPeriod.${clockingTime}.manualClocking`,
                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                            dataTest: `work-period-${clockingTime}-manual-clocking`,
                            disabled: inputFieldDisabled,
                            help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($e6bcf76b5d1d8091$var$ManualClockingFieldHelp, {
                                manualClockingDate: manualClockingDate,
                                manualClockingUpdated: manualClockingUpdated,
                                disabled: disabled,
                                onEditManualClockingDay: onEditManualClockingDay,
                                isNotInRange: isInRange === false
                            }),
                            min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $410057b58fa5bc28$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), 12)),
                            max: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $c468ed5e889a430e$export$2e2bcd8739ae039)(new Date(workPeriod.start.date), 12))
                        })
                    ]
                })
            },
            {
                label: 'Commentaire',
                value: // Show field when textarea field value is modified
                isManualClockingValueModified ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039),
                    name: `workPeriod.${clockingTime}.comment`,
                    "data-test": `work-period-${clockingTime}-comment`
                }) : comment ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $79579c12c65688d1$export$2e2bcd8739ae039), {
                    message: comment.message,
                    sender: comment.user
                }) : '/'
            }
        ]
    });
};
var $e6bcf76b5d1d8091$export$2e2bcd8739ae039 = $e6bcf76b5d1d8091$var$WorkPeriodClockingTimeDetails;



parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");





/**
 * Composant pour gérer les pauses manuelles d'une période de travail
 * Affiche les informations sur les pauses théoriques, pointées et permet la correction
 */ const $691e7334e4488b34$var$WorkPeriodManualBreak = ({ workPeriod: workPeriod })=>{
    const { breakAllowedAfter: breakAllowedAfter } = workPeriod.clockingRules.break;
    const inputFieldDisabled = !workPeriod.__actions.canBeManualClocked || !(0, $8403deec6a28521e$export$6025088343704f9f)([
        'employerMember'
    ], {
        resource: 'missions',
        name: 'updateWorkPeriodManualBreak'
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c288541aa0d2549e$export$2e2bcd8739ae039), {
        labelColumnWidth: '30%',
        items: [
            {
                label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    size: 4,
                    children: "Pause"
                }),
                value: ' '
            },
            {
                label: "Th\xe9orique",
                value: `${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workPeriod.summary.durations.theoreticalBreaks)}`
            },
            {
                label: "Apr\xe8s",
                value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(breakAllowedAfter * 60000)
            },
            ...workPeriod.clockingRules.break.clocked ? [
                {
                    label: "Point\xe9es",
                    value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workPeriod.summary.durations.clockedBreaks)
                },
                {
                    label: "Comptabilis\xe9",
                    value: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workPeriod.summary.durations.breaks)
                }
            ] : [],
            {
                label: "Corrig\xe9",
                value: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    type: "number",
                    min: 0,
                    max: 1440,
                    step: 1,
                    name: `workPeriod.manualBreak`,
                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                    dataTest: "work-period-manual-break",
                    disabled: inputFieldDisabled,
                    help: "Sp\xe9cifier une valeur en minutes"
                })
            }
        ]
    });
};
var $691e7334e4488b34$export$2e2bcd8739ae039 = $691e7334e4488b34$var$WorkPeriodManualBreak;






const $e9b69a14fab579eb$export$cf4e7647d616df88 = (workPeriod, inputValues)=>{
    if (!inputValues) return undefined;
    // Explicit nulls so submit can send manualClocking: null to the API (clear stored manual times).
    if (!inputValues.startManualClocking && !inputValues.endManualClocking) return {
        start: null,
        end: null
    };
    const workPeriodStartDate = new Date(workPeriod.start.date);
    const workPeriodEndDate = new Date(workPeriod.end.date);
    const isMultiDayPeriod = !(0, $d989ae9468b066a3$export$2e2bcd8739ae039)(workPeriodStartDate, workPeriodEndDate);
    // Convertir les heures saisies en dates
    const startInputDate = inputValues.startManualClocking ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(workPeriod.start.date, inputValues.startManualClocking) : null;
    const endInputDate = inputValues.endManualClocking ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(workPeriod.end.date, inputValues.endManualClocking) : null;
    // Si aucune date valide n'a pu être créée
    if (!startInputDate && !endInputDate) return undefined;
    const result = {
        start: null,
        end: null
    };
    // Traitement du start manual clocking
    if (startInputDate) {
        const isStartInRange = (0, $74f17ceb9b5a08a5$export$8f2f015a4a2c7583)(startInputDate, workPeriodStartDate, workPeriodEndDate);
        if (isStartInRange && isMultiDayPeriod) {
            const inputHour = startInputDate.getHours() * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) + startInputDate.getMinutes() * (0, $74f17ceb9b5a08a5$export$2fccde50bde2ee57);
            const endHour = workPeriodEndDate.getHours() * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) + workPeriodEndDate.getMinutes() * (0, $74f17ceb9b5a08a5$export$2fccde50bde2ee57);
            const midnightHour = 0;
            // Cas 2: Entre minuit et end date - ajuster vers le jour de fin
            if (inputHour >= midnightHour && inputHour <= endHour) {
                const adjustedDate = new Date(startInputDate);
                adjustedDate.setFullYear(workPeriodEndDate.getFullYear());
                adjustedDate.setMonth(workPeriodEndDate.getMonth());
                adjustedDate.setDate(workPeriodEndDate.getDate());
                result.start = adjustedDate;
            } else // Cas 1: Entre start date et minuit - garder le jour original
            result.start = startInputDate;
        } else // Plage normale ou hors plage - garder la date originale
        result.start = startInputDate;
    }
    // Traitement du end manual clocking
    if (endInputDate) {
        const isEndInRange = (0, $74f17ceb9b5a08a5$export$8f2f015a4a2c7583)(endInputDate, workPeriodStartDate, workPeriodEndDate);
        if (isEndInRange && isMultiDayPeriod) {
            const inputHour = endInputDate.getHours() * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) + endInputDate.getMinutes() * (0, $74f17ceb9b5a08a5$export$2fccde50bde2ee57);
            const endHour = workPeriodEndDate.getHours() * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) + workPeriodEndDate.getMinutes() * (0, $74f17ceb9b5a08a5$export$2fccde50bde2ee57);
            const midnightHour = 0;
            // Cas 2: Entre minuit et end date - ajuster vers le jour de fin
            if (inputHour >= midnightHour && inputHour <= endHour) {
                const adjustedDate = new Date(endInputDate);
                result.end = adjustedDate;
            } else {
                // Cas 1: Entre start date et minuit - garder le jour original
                const adjustedDate = new Date(endInputDate);
                adjustedDate.setFullYear(workPeriodStartDate.getFullYear());
                adjustedDate.setMonth(workPeriodStartDate.getMonth());
                adjustedDate.setDate(workPeriodStartDate.getDate());
                result.end = adjustedDate;
            }
        } else // Plage normale ou hors plage - garder la date originale
        result.end = endInputDate;
    }
    // Appliquer les jours forcés si fournis
    if (inputValues.forcedStartDay && result.start) result.start = new Date(new Date(inputValues.forcedStartDay).setHours(result.start.getHours(), result.start.getMinutes()));
    if (inputValues.forcedEndDay && result.end) result.end = new Date(new Date(inputValues.forcedEndDay).setHours(result.end.getHours(), result.end.getMinutes()));
    return result;
};
const $e9b69a14fab579eb$export$bc9083fce39566f = (workPeriod, values)=>{
    return $e9b69a14fab579eb$export$cf4e7647d616df88(workPeriod, {
        startManualClocking: values.workPeriod.start.manualClocking,
        endManualClocking: values.workPeriod.end.manualClocking,
        forcedStartDay: values.workPeriod.start.isCustomDay ? values.workPeriod.start.manualClockingDay : workPeriod.start.manualClocking && (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(workPeriod.start.manualClocking),
        forcedEndDay: values.workPeriod.end.isCustomDay ? values.workPeriod.end.manualClockingDay : workPeriod.end.manualClocking && (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(workPeriod.end.manualClocking)
    });
};
const $e9b69a14fab579eb$export$7d2a457b68a717e8 = (workPeriod)=>{
    return {
        user: {
            ...workPeriod.user,
            email: workPeriod.user.appAccess === 'none' ? 'offline' : workPeriod.user.email
        },
        workPeriod: {
            start: {
                date: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.start.date),
                clocking: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.start.clocking && workPeriod.start.clocking.date),
                manualClocking: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.start.manualClocking && workPeriod.start.manualClocking),
                manualClockingDay: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(workPeriod.start.manualClocking || workPeriod.start.date)),
                isCustomDay: false,
                comment: workPeriod.start.comments[workPeriod.start.comments.length - 1]?.message || ''
            },
            end: {
                date: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.end.date),
                clocking: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.end.clocking && workPeriod.end.clocking.date),
                manualClocking: (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(workPeriod.end.manualClocking && workPeriod.end.manualClocking),
                manualClockingDay: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(workPeriod.end.manualClocking || workPeriod.end.date)),
                isCustomDay: false,
                comment: workPeriod.end.comments[workPeriod.end.comments.length - 1]?.message || ''
            },
            manualBreak: workPeriod.manualBreak || null
        }
    };
};
/**
 * Build theoretical start/end Date from form time values and work period calendar days.
 * Used for validation and submit payload.
 * Returns null for start/end when the form field is empty so required validation can run.
 */ const $e9b69a14fab579eb$var$theoreticalDatesFromFormValues = (workPeriod, values)=>{
    const startDate = values.workPeriod.start.date ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(workPeriod.start.date, values.workPeriod.start.date) : null;
    let endDate = values.workPeriod.end.date ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(workPeriod.start.date, values.workPeriod.end.date) : null;
    if (startDate && endDate && (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(endDate, startDate)) endDate = (0, $ffff430a208564ac$export$2e2bcd8739ae039)(endDate, 1);
    return {
        start: startDate || null,
        end: endDate || null
    };
};
const $e9b69a14fab579eb$export$22be11368b300b4f = (workPeriod, values)=>{
    const errors = {};
    const theoretical = $e9b69a14fab579eb$var$theoreticalDatesFromFormValues(workPeriod, values);
    const rangeErrors = (0, $6b601cb106cd3f71$export$3ef1799cbda7de2c)(theoretical.start ?? undefined, theoretical.end ?? undefined);
    if (rangeErrors.startDate) errors['workPeriod.start.date'] = rangeErrors.startDate;
    if (rangeErrors.endDate) errors['workPeriod.end.date'] = rangeErrors.endDate;
    const clockingDates = $e9b69a14fab579eb$export$bc9083fce39566f(workPeriod, values);
    if (clockingDates) {
        const { start: startManualClocking, end: endManualClocking } = clockingDates;
        if (startManualClocking && endManualClocking && ((0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(startManualClocking, endManualClocking) || (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(endManualClocking, startManualClocking))) errors['workPeriod.start.manualClocking'] = "La date de d\xe9but ne peut \xeatre apr\xe8s la date de fin";
        // Require comment only when manual clocking is actually being updated (not when only theoretical times changed)
        const serverStartManual = workPeriod.start.manualClocking ? new Date(workPeriod.start.manualClocking) : null;
        const serverEndManual = workPeriod.end.manualClocking ? new Date(workPeriod.end.manualClocking) : null;
        const isValidDate = (d)=>d != null && !Number.isNaN(d.getTime());
        const startManualChanged = !serverStartManual || !isValidDate(serverStartManual) || startManualClocking == null && serverStartManual != null || startManualClocking != null && serverStartManual != null && !(0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(startManualClocking, serverStartManual);
        const endManualChanged = !serverEndManual || !isValidDate(serverEndManual) || endManualClocking == null && serverEndManual != null || endManualClocking != null && serverEndManual != null && !(0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(endManualClocking, serverEndManual);
        const isStartManualClockingUpdated = startManualClocking && startManualChanged;
        const isEndManualClockingUpdated = endManualClocking && endManualChanged;
        if (isStartManualClockingUpdated && values.workPeriod.start.manualClocking && !values.workPeriod.start.comment) errors['workPeriod.start.comment'] = 'Champ requis';
        if (isEndManualClockingUpdated && values.workPeriod.end.manualClocking && !values.workPeriod.end.comment) errors['workPeriod.end.comment'] = 'Champ requis';
        if (startManualClocking && endManualClocking && (0, $ef2e6760f3e9e6fc$export$2e2bcd8739ae039)(endManualClocking, startManualClocking) > 24 * (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59)) errors['workPeriod.end.manualClocking'] = "La date de fin ne peut pas \xeatre plus grande que 24 heures apr\xe8s la date de d\xe9but";
    }
    return errors;
};
const $e9b69a14fab579eb$export$fc980fbdbba68aab = (workPeriod, values)=>{
    const clockingDates = $e9b69a14fab579eb$export$bc9083fce39566f(workPeriod, values);
    const theoretical = $e9b69a14fab579eb$var$theoreticalDatesFromFormValues(workPeriod, values);
    const newStartDate = {
        date: theoretical.start ?? workPeriod.start.date,
        manualClocking: null
    };
    if (clockingDates?.start != null) {
        newStartDate.manualClocking = clockingDates.start;
        newStartDate.comment = values.workPeriod.start.comment;
    } else if (clockingDates === undefined && workPeriod.start.manualClocking) {
        // Calculator could not derive dates (edge case); keep server value.
        newStartDate.manualClocking = workPeriod.start.manualClocking;
        newStartDate.comment = workPeriod.start.comments[workPeriod.start.comments.length - 1]?.message || '';
    }
    const newEndDate = {
        date: theoretical.end ?? workPeriod.end.date,
        manualClocking: null
    };
    if (clockingDates?.end != null) {
        newEndDate.manualClocking = clockingDates.end;
        newEndDate.comment = values.workPeriod.end.comment;
    } else if (clockingDates === undefined && workPeriod.end.manualClocking) {
        newEndDate.manualClocking = workPeriod.end.manualClocking;
        newEndDate.comment = workPeriod.end.comments[workPeriod.end.comments.length - 1]?.message || '';
    }
    const manualBreak = //@ts-expect-error when the field is cleared it's value is empty string ""
    values.workPeriod.manualBreak === '' ? null : values.workPeriod.manualBreak;
    return {
        missionId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission),
        workPeriodId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod),
        start: newStartDate,
        end: newEndDate,
        manualBreak: manualBreak
    };
};
/**
 * True when computed manual clocking (including explicit null) differs from server state.
 */ const $e9b69a14fab579eb$var$manualClockingDiffersFromServer = (computed, server)=>{
    const c = computed ?? null;
    const s = server ?? null;
    if (c == null && s == null) return false;
    if (c instanceof Date && s instanceof Date) return c.getTime() !== s.getTime();
    return true;
};
const $e9b69a14fab579eb$export$eee834c0dbb0cea4 = (workPeriod, values)=>{
    const clockingDates = $e9b69a14fab579eb$export$bc9083fce39566f(workPeriod, values);
    return $e9b69a14fab579eb$var$manualClockingDiffersFromServer(clockingDates?.start, workPeriod.start.manualClocking) || $e9b69a14fab579eb$var$manualClockingDiffersFromServer(clockingDates?.end, workPeriod.end.manualClocking);
};


/**
 * Composant principal pour la gestion des dates de période de travail
 * Permet la modification des heures de début/fin et des pauses manuelles
 */ const $c31e4eb09f1e0bff$var$WorkPeriodDatesForm = ({ workPeriod: workPeriod, disabled: disabled })=>{
    // Mutations
    const updateWorkPeriodMutation = (0, $7040c29cc25c4df6$export$cac0b33e6f13c8ec)();
    const handleSubmit = (values)=>{
        const payload = (0, $e9b69a14fab579eb$export$fc980fbdbba68aab)(workPeriod, values);
        updateWorkPeriodMutation.mutate(payload);
    };
    const initialValues = (0, $e9b69a14fab579eb$export$7d2a457b68a717e8)(workPeriod);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        validate: (values)=>(0, $e9b69a14fab579eb$export$22be11368b300b4f)(workPeriod, values),
        onSubmit: handleSubmit,
        children: (props)=>{
            const clockingDates = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>(0, $e9b69a14fab579eb$export$bc9083fce39566f)(workPeriod, props.values), [
                props.values
            ]);
            const setManualClockingDay = (clockingTime)=>{
                const currentValue = props.values?.workPeriod[clockingTime].isCustomDay;
                props.setFieldValue(`workPeriod.${clockingTime}.isCustomDay`, !currentValue);
                if (!currentValue) props.setFieldValue(`workPeriod.${clockingTime}.manualClockingDay`, (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(clockingDates?.[clockingTime] || workPeriod[clockingTime].date)));
            };
            const manualClockingUpdated = (0, $e9b69a14fab579eb$export$eee834c0dbb0cea4)(workPeriod, props.values);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e6bcf76b5d1d8091$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod,
                                clockingTime: "start",
                                formManualClockingValue: props.values?.workPeriod.start.manualClocking,
                                formTheoreticalValue: props.values?.workPeriod.start.date,
                                manualClockingDate: clockingDates?.start,
                                onEditManualClockingDay: ()=>setManualClockingDay('start'),
                                manualClockingUpdated: manualClockingUpdated,
                                displayManualClockingDay: props.values?.workPeriod.start.isCustomDay,
                                disabled: disabled
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e6bcf76b5d1d8091$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod,
                                clockingTime: "end",
                                formManualClockingValue: props.values?.workPeriod.end.manualClocking,
                                formTheoreticalValue: props.values?.workPeriod.end.date,
                                manualClockingDate: clockingDates?.end,
                                onEditManualClockingDay: ()=>setManualClockingDay('end'),
                                manualClockingUpdated: manualClockingUpdated,
                                displayManualClockingDay: props.values?.workPeriod.end.isCustomDay,
                                disabled: disabled
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $691e7334e4488b34$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: props.dirty && workPeriod.__actions.canBeUpdated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                        mutation: updateWorkPeriodMutation,
                                        color: "primary",
                                        type: "submit",
                                        mr: 3,
                                        style: {
                                            width: '100%'
                                        },
                                        "data-test": "work-period-dates-form-submit",
                                        children: [
                                            "Modifier la journ\xe9e ",
                                            props.status
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                        mutation: updateWorkPeriodMutation
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
    });
};
var $c31e4eb09f1e0bff$export$2e2bcd8739ae039 = $c31e4eb09f1e0bff$var$WorkPeriodDatesForm;










var $3ZYaX = parcelRequire("3ZYaX");













var $3ZYaX = parcelRequire("3ZYaX");





const $2e807891940c55ac$var$AbandonConfirmation = ({ show: show, hide: hide, mission: mission, workPeriod: workPeriod })=>{
    const abandonWorkPeriodMutation = (0, $7040c29cc25c4df6$export$94ce31c9ab479ad)();
    const [replaceWorkersRequestPost, setReplaceWorkersRequestPost] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const onConfirm = ()=>{
        abandonWorkPeriodMutation.mutate({
            missionId: mission._id,
            workPeriodId: workPeriod._id,
            isAbandoned: true,
            isReplaceable: replaceWorkersRequestPost
        });
        hide();
    };
    const canBeReplaced = mission.workPeriods.some((w)=>w.__actions.canBeReplaced);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
        onConfirm: onConfirm,
        show: show,
        onCancel: hide,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                children: [
                    "\xcates vous certain de vouloir abandonner la mission de\xa0",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: mission.user
                        })
                    }),
                    "? ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                ]
            }),
            canBeReplaced && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "hr"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "ul",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "li",
                                children: [
                                    "Vous pouvez demander \xe0 l'Agence ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("b", {
                                        children: [
                                            " ",
                                            mission.interimAgency?.name
                                        ]
                                    }),
                                    " un rempla\xe7ant."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                            mt: 3,
                            checked: replaceWorkersRequestPost,
                            onChange: ()=>setReplaceWorkersRequestPost(!replaceWorkersRequestPost),
                            "data-test": "cancel-and-ask-for-a-replacement",
                            children: "Demander un rempla\xe7ant"
                        })
                    ]
                })
            })
        ]
    });
};
var $2e807891940c55ac$export$2e2bcd8739ae039 = $2e807891940c55ac$var$AbandonConfirmation;






var $2b3509163a685877$exports = {};
var $a39fdf7de8d4b46c$exports = {};
var $e6067bfbb555c1c7$exports = {};
var $469cd8ad3eb7f1ce$exports = {};
var $506d44ddc1d90677$exports = {};
var $cb10ec25ed314580$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb10ec25ed314580$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$cb10ec25ed314580$exports = $cb10ec25ed314580$var$listCacheClear;


var $282369324dd437e9$exports = {};
var $17f2d7ff9730c050$exports = {};
var $ec7e1ca26951058a$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $ec7e1ca26951058a$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$ec7e1ca26951058a$exports = $ec7e1ca26951058a$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $17f2d7ff9730c050$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($ec7e1ca26951058a$exports(array[length][0], key)) return length;
    }
    return -1;
}
$17f2d7ff9730c050$exports = $17f2d7ff9730c050$var$assocIndexOf;


/** Used for built-in method references. */ var $282369324dd437e9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $282369324dd437e9$var$splice = $282369324dd437e9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $282369324dd437e9$var$listCacheDelete(key) {
    var data = this.__data__, index = $17f2d7ff9730c050$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $282369324dd437e9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$282369324dd437e9$exports = $282369324dd437e9$var$listCacheDelete;


var $78cde41dddb0e07c$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $78cde41dddb0e07c$var$listCacheGet(key) {
    var data = this.__data__, index = $17f2d7ff9730c050$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$78cde41dddb0e07c$exports = $78cde41dddb0e07c$var$listCacheGet;


var $39e0eb2084b7fe2b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $39e0eb2084b7fe2b$var$listCacheHas(key) {
    return $17f2d7ff9730c050$exports(this.__data__, key) > -1;
}
$39e0eb2084b7fe2b$exports = $39e0eb2084b7fe2b$var$listCacheHas;


var $6ba67f02b3594b4d$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $6ba67f02b3594b4d$var$listCacheSet(key, value) {
    var data = this.__data__, index = $17f2d7ff9730c050$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$6ba67f02b3594b4d$exports = $6ba67f02b3594b4d$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $506d44ddc1d90677$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$506d44ddc1d90677$var$ListCache.prototype.clear = $cb10ec25ed314580$exports;
$506d44ddc1d90677$var$ListCache.prototype['delete'] = $282369324dd437e9$exports;
$506d44ddc1d90677$var$ListCache.prototype.get = $78cde41dddb0e07c$exports;
$506d44ddc1d90677$var$ListCache.prototype.has = $39e0eb2084b7fe2b$exports;
$506d44ddc1d90677$var$ListCache.prototype.set = $6ba67f02b3594b4d$exports;
$506d44ddc1d90677$exports = $506d44ddc1d90677$var$ListCache;


var $3017027ab77c11c2$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $3017027ab77c11c2$var$stackClear() {
    this.__data__ = new $506d44ddc1d90677$exports;
    this.size = 0;
}
$3017027ab77c11c2$exports = $3017027ab77c11c2$var$stackClear;


var $175cdc43ebebada1$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $175cdc43ebebada1$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
$175cdc43ebebada1$exports = $175cdc43ebebada1$var$stackDelete;


var $806bac3857446eae$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $806bac3857446eae$var$stackGet(key) {
    return this.__data__.get(key);
}
$806bac3857446eae$exports = $806bac3857446eae$var$stackGet;


var $785cb49d451c74ef$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $785cb49d451c74ef$var$stackHas(key) {
    return this.__data__.has(key);
}
$785cb49d451c74ef$exports = $785cb49d451c74ef$var$stackHas;


var $5ce1443dfca0d3f3$exports = {};

var $74863592e7c59f35$exports = {};
var $bb1f58fbbde092b1$exports = {};
var $c53623b3850a3974$exports = {};
var $08c123a90ef17cd1$exports = {};
var $fdf97b0a973d8a11$exports = {};
var $2672bfbb2636a2d1$exports = {};

var $jEjAi = parcelRequire("jEjAi");
/** Built-in value references. */ var $2672bfbb2636a2d1$var$Symbol = $jEjAi.Symbol;
$2672bfbb2636a2d1$exports = $2672bfbb2636a2d1$var$Symbol;


var $f231b95b6f0dcc1f$exports = {};

/** Used for built-in method references. */ var $f231b95b6f0dcc1f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f231b95b6f0dcc1f$var$hasOwnProperty = $f231b95b6f0dcc1f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f231b95b6f0dcc1f$var$nativeObjectToString = $f231b95b6f0dcc1f$var$objectProto.toString;
/** Built-in value references. */ var $f231b95b6f0dcc1f$var$symToStringTag = $2672bfbb2636a2d1$exports ? $2672bfbb2636a2d1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f231b95b6f0dcc1f$var$getRawTag(value) {
    var isOwn = $f231b95b6f0dcc1f$var$hasOwnProperty.call(value, $f231b95b6f0dcc1f$var$symToStringTag), tag = value[$f231b95b6f0dcc1f$var$symToStringTag];
    try {
        value[$f231b95b6f0dcc1f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f231b95b6f0dcc1f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f231b95b6f0dcc1f$var$symToStringTag] = tag;
        else delete value[$f231b95b6f0dcc1f$var$symToStringTag];
    }
    return result;
}
$f231b95b6f0dcc1f$exports = $f231b95b6f0dcc1f$var$getRawTag;


var $fce58fe0c05d5fa7$exports = {};
/** Used for built-in method references. */ var $fce58fe0c05d5fa7$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $fce58fe0c05d5fa7$var$nativeObjectToString = $fce58fe0c05d5fa7$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $fce58fe0c05d5fa7$var$objectToString(value) {
    return $fce58fe0c05d5fa7$var$nativeObjectToString.call(value);
}
$fce58fe0c05d5fa7$exports = $fce58fe0c05d5fa7$var$objectToString;


/** `Object#toString` result references. */ var $fdf97b0a973d8a11$var$nullTag = '[object Null]', $fdf97b0a973d8a11$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $fdf97b0a973d8a11$var$symToStringTag = $2672bfbb2636a2d1$exports ? $2672bfbb2636a2d1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $fdf97b0a973d8a11$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $fdf97b0a973d8a11$var$undefinedTag : $fdf97b0a973d8a11$var$nullTag;
    return $fdf97b0a973d8a11$var$symToStringTag && $fdf97b0a973d8a11$var$symToStringTag in Object(value) ? $f231b95b6f0dcc1f$exports(value) : $fce58fe0c05d5fa7$exports(value);
}
$fdf97b0a973d8a11$exports = $fdf97b0a973d8a11$var$baseGetTag;


var $d6037d1c164be800$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d6037d1c164be800$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$d6037d1c164be800$exports = $d6037d1c164be800$var$isObject;


/** `Object#toString` result references. */ var $08c123a90ef17cd1$var$asyncTag = '[object AsyncFunction]', $08c123a90ef17cd1$var$funcTag = '[object Function]', $08c123a90ef17cd1$var$genTag = '[object GeneratorFunction]', $08c123a90ef17cd1$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $08c123a90ef17cd1$var$isFunction(value) {
    if (!$d6037d1c164be800$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $fdf97b0a973d8a11$exports(value);
    return tag == $08c123a90ef17cd1$var$funcTag || tag == $08c123a90ef17cd1$var$genTag || tag == $08c123a90ef17cd1$var$asyncTag || tag == $08c123a90ef17cd1$var$proxyTag;
}
$08c123a90ef17cd1$exports = $08c123a90ef17cd1$var$isFunction;


var $b101b5b683a17f5b$exports = {};
var $3e04be19301c90db$exports = {};

var $jEjAi = parcelRequire("jEjAi");
/** Used to detect overreaching core-js shims. */ var $3e04be19301c90db$var$coreJsData = $jEjAi["__core-js_shared__"];
$3e04be19301c90db$exports = $3e04be19301c90db$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $b101b5b683a17f5b$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($3e04be19301c90db$exports && $3e04be19301c90db$exports.keys && $3e04be19301c90db$exports.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b101b5b683a17f5b$var$isMasked(func) {
    return !!$b101b5b683a17f5b$var$maskSrcKey && $b101b5b683a17f5b$var$maskSrcKey in func;
}
$b101b5b683a17f5b$exports = $b101b5b683a17f5b$var$isMasked;



var $331b66bb4283ac4b$exports = {};
/** Used for built-in method references. */ var $331b66bb4283ac4b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $331b66bb4283ac4b$var$funcToString = $331b66bb4283ac4b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $331b66bb4283ac4b$var$toSource(func) {
    if (func != null) {
        try {
            return $331b66bb4283ac4b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
$331b66bb4283ac4b$exports = $331b66bb4283ac4b$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $c53623b3850a3974$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $c53623b3850a3974$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $c53623b3850a3974$var$funcProto = Function.prototype, $c53623b3850a3974$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c53623b3850a3974$var$funcToString = $c53623b3850a3974$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c53623b3850a3974$var$hasOwnProperty = $c53623b3850a3974$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $c53623b3850a3974$var$reIsNative = RegExp('^' + $c53623b3850a3974$var$funcToString.call($c53623b3850a3974$var$hasOwnProperty).replace($c53623b3850a3974$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $c53623b3850a3974$var$baseIsNative(value) {
    if (!$d6037d1c164be800$exports(value) || $b101b5b683a17f5b$exports(value)) return false;
    var pattern = $08c123a90ef17cd1$exports(value) ? $c53623b3850a3974$var$reIsNative : $c53623b3850a3974$var$reIsHostCtor;
    return pattern.test($331b66bb4283ac4b$exports(value));
}
$c53623b3850a3974$exports = $c53623b3850a3974$var$baseIsNative;


var $6d4f782c80464f88$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6d4f782c80464f88$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$6d4f782c80464f88$exports = $6d4f782c80464f88$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $bb1f58fbbde092b1$var$getNative(object, key) {
    var value = $6d4f782c80464f88$exports(object, key);
    return $c53623b3850a3974$exports(value) ? value : undefined;
}
$bb1f58fbbde092b1$exports = $bb1f58fbbde092b1$var$getNative;



var $jEjAi = parcelRequire("jEjAi");
/* Built-in method references that are verified to be native. */ var $74863592e7c59f35$var$Map = $bb1f58fbbde092b1$exports($jEjAi, 'Map');
$74863592e7c59f35$exports = $74863592e7c59f35$var$Map;


var $8780a49c6d3a3186$exports = {};
var $2c40e374251ac429$exports = {};
var $d92fa95a9155c65d$exports = {};
var $1e5a9c8d839af55d$exports = {};
var $d9a533834d793171$exports = {};

/* Built-in method references that are verified to be native. */ var $d9a533834d793171$var$nativeCreate = $bb1f58fbbde092b1$exports(Object, 'create');
$d9a533834d793171$exports = $d9a533834d793171$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $1e5a9c8d839af55d$var$hashClear() {
    this.__data__ = $d9a533834d793171$exports ? $d9a533834d793171$exports(null) : {};
    this.size = 0;
}
$1e5a9c8d839af55d$exports = $1e5a9c8d839af55d$var$hashClear;


var $ceacbfb8be661c62$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ceacbfb8be661c62$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$ceacbfb8be661c62$exports = $ceacbfb8be661c62$var$hashDelete;


var $3ac37ebe953811f6$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $3ac37ebe953811f6$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $3ac37ebe953811f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3ac37ebe953811f6$var$hasOwnProperty = $3ac37ebe953811f6$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3ac37ebe953811f6$var$hashGet(key) {
    var data = this.__data__;
    if ($d9a533834d793171$exports) {
        var result = data[key];
        return result === $3ac37ebe953811f6$var$HASH_UNDEFINED ? undefined : result;
    }
    return $3ac37ebe953811f6$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$3ac37ebe953811f6$exports = $3ac37ebe953811f6$var$hashGet;


var $15bb506ccc050c09$exports = {};

/** Used for built-in method references. */ var $15bb506ccc050c09$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15bb506ccc050c09$var$hasOwnProperty = $15bb506ccc050c09$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $15bb506ccc050c09$var$hashHas(key) {
    var data = this.__data__;
    return $d9a533834d793171$exports ? data[key] !== undefined : $15bb506ccc050c09$var$hasOwnProperty.call(data, key);
}
$15bb506ccc050c09$exports = $15bb506ccc050c09$var$hashHas;


var $85ffef7e25c76d93$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $85ffef7e25c76d93$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $85ffef7e25c76d93$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $d9a533834d793171$exports && value === undefined ? $85ffef7e25c76d93$var$HASH_UNDEFINED : value;
    return this;
}
$85ffef7e25c76d93$exports = $85ffef7e25c76d93$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d92fa95a9155c65d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$d92fa95a9155c65d$var$Hash.prototype.clear = $1e5a9c8d839af55d$exports;
$d92fa95a9155c65d$var$Hash.prototype['delete'] = $ceacbfb8be661c62$exports;
$d92fa95a9155c65d$var$Hash.prototype.get = $3ac37ebe953811f6$exports;
$d92fa95a9155c65d$var$Hash.prototype.has = $15bb506ccc050c09$exports;
$d92fa95a9155c65d$var$Hash.prototype.set = $85ffef7e25c76d93$exports;
$d92fa95a9155c65d$exports = $d92fa95a9155c65d$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $2c40e374251ac429$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $d92fa95a9155c65d$exports,
        'map': new ($74863592e7c59f35$exports || $506d44ddc1d90677$exports),
        'string': new $d92fa95a9155c65d$exports
    };
}
$2c40e374251ac429$exports = $2c40e374251ac429$var$mapCacheClear;


var $428c24f69de110ff$exports = {};
var $871cd6b70ebd6979$exports = {};
var $0eebfda29068bde0$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $0eebfda29068bde0$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
$0eebfda29068bde0$exports = $0eebfda29068bde0$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $871cd6b70ebd6979$var$getMapData(map, key) {
    var data = map.__data__;
    return $0eebfda29068bde0$exports(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
$871cd6b70ebd6979$exports = $871cd6b70ebd6979$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $428c24f69de110ff$var$mapCacheDelete(key) {
    var result = $871cd6b70ebd6979$exports(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
$428c24f69de110ff$exports = $428c24f69de110ff$var$mapCacheDelete;


var $2e1f815897acc6ad$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2e1f815897acc6ad$var$mapCacheGet(key) {
    return $871cd6b70ebd6979$exports(this, key).get(key);
}
$2e1f815897acc6ad$exports = $2e1f815897acc6ad$var$mapCacheGet;


var $41ab13638aa4b3b4$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $41ab13638aa4b3b4$var$mapCacheHas(key) {
    return $871cd6b70ebd6979$exports(this, key).has(key);
}
$41ab13638aa4b3b4$exports = $41ab13638aa4b3b4$var$mapCacheHas;


var $e1dcfd5c002b770d$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $e1dcfd5c002b770d$var$mapCacheSet(key, value) {
    var data = $871cd6b70ebd6979$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$e1dcfd5c002b770d$exports = $e1dcfd5c002b770d$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8780a49c6d3a3186$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$8780a49c6d3a3186$var$MapCache.prototype.clear = $2c40e374251ac429$exports;
$8780a49c6d3a3186$var$MapCache.prototype['delete'] = $428c24f69de110ff$exports;
$8780a49c6d3a3186$var$MapCache.prototype.get = $2e1f815897acc6ad$exports;
$8780a49c6d3a3186$var$MapCache.prototype.has = $41ab13638aa4b3b4$exports;
$8780a49c6d3a3186$var$MapCache.prototype.set = $e1dcfd5c002b770d$exports;
$8780a49c6d3a3186$exports = $8780a49c6d3a3186$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $5ce1443dfca0d3f3$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $5ce1443dfca0d3f3$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $506d44ddc1d90677$exports) {
        var pairs = data.__data__;
        if (!$74863592e7c59f35$exports || pairs.length < $5ce1443dfca0d3f3$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $8780a49c6d3a3186$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$5ce1443dfca0d3f3$exports = $5ce1443dfca0d3f3$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $469cd8ad3eb7f1ce$var$Stack(entries) {
    var data = this.__data__ = new $506d44ddc1d90677$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$469cd8ad3eb7f1ce$var$Stack.prototype.clear = $3017027ab77c11c2$exports;
$469cd8ad3eb7f1ce$var$Stack.prototype['delete'] = $175cdc43ebebada1$exports;
$469cd8ad3eb7f1ce$var$Stack.prototype.get = $806bac3857446eae$exports;
$469cd8ad3eb7f1ce$var$Stack.prototype.has = $785cb49d451c74ef$exports;
$469cd8ad3eb7f1ce$var$Stack.prototype.set = $5ce1443dfca0d3f3$exports;
$469cd8ad3eb7f1ce$exports = $469cd8ad3eb7f1ce$var$Stack;


var $47de37ed582c6743$exports = {};
var $d0e1405990bb74c2$exports = {};

var $9ab1483bc66cf99d$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $9ab1483bc66cf99d$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $9ab1483bc66cf99d$var$setCacheAdd(value) {
    this.__data__.set(value, $9ab1483bc66cf99d$var$HASH_UNDEFINED);
    return this;
}
$9ab1483bc66cf99d$exports = $9ab1483bc66cf99d$var$setCacheAdd;


var $a04a4f181202cc81$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $a04a4f181202cc81$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$a04a4f181202cc81$exports = $a04a4f181202cc81$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $d0e1405990bb74c2$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $8780a49c6d3a3186$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$d0e1405990bb74c2$var$SetCache.prototype.add = $d0e1405990bb74c2$var$SetCache.prototype.push = $9ab1483bc66cf99d$exports;
$d0e1405990bb74c2$var$SetCache.prototype.has = $a04a4f181202cc81$exports;
$d0e1405990bb74c2$exports = $d0e1405990bb74c2$var$SetCache;


var $a02450c36e608dc8$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a02450c36e608dc8$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$a02450c36e608dc8$exports = $a02450c36e608dc8$var$arraySome;


var $de98545faabbfef3$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $de98545faabbfef3$var$cacheHas(cache, key) {
    return cache.has(key);
}
$de98545faabbfef3$exports = $de98545faabbfef3$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $47de37ed582c6743$var$COMPARE_PARTIAL_FLAG = 1, $47de37ed582c6743$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $47de37ed582c6743$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $47de37ed582c6743$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $47de37ed582c6743$var$COMPARE_UNORDERED_FLAG ? new $d0e1405990bb74c2$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$a02450c36e608dc8$exports(other, function(othValue, othIndex) {
                if (!$de98545faabbfef3$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
$47de37ed582c6743$exports = $47de37ed582c6743$var$equalArrays;


var $c18ead51fce0e2f5$exports = {};

var $cd1932deec87124b$exports = {};

var $jEjAi = parcelRequire("jEjAi");
/** Built-in value references. */ var $cd1932deec87124b$var$Uint8Array = $jEjAi.Uint8Array;
$cd1932deec87124b$exports = $cd1932deec87124b$var$Uint8Array;




var $32438a528c822b6d$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $32438a528c822b6d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$32438a528c822b6d$exports = $32438a528c822b6d$var$mapToArray;


var $f290e44619123de7$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $f290e44619123de7$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$f290e44619123de7$exports = $f290e44619123de7$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $c18ead51fce0e2f5$var$COMPARE_PARTIAL_FLAG = 1, $c18ead51fce0e2f5$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $c18ead51fce0e2f5$var$boolTag = '[object Boolean]', $c18ead51fce0e2f5$var$dateTag = '[object Date]', $c18ead51fce0e2f5$var$errorTag = '[object Error]', $c18ead51fce0e2f5$var$mapTag = '[object Map]', $c18ead51fce0e2f5$var$numberTag = '[object Number]', $c18ead51fce0e2f5$var$regexpTag = '[object RegExp]', $c18ead51fce0e2f5$var$setTag = '[object Set]', $c18ead51fce0e2f5$var$stringTag = '[object String]', $c18ead51fce0e2f5$var$symbolTag = '[object Symbol]';
var $c18ead51fce0e2f5$var$arrayBufferTag = '[object ArrayBuffer]', $c18ead51fce0e2f5$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $c18ead51fce0e2f5$var$symbolProto = $2672bfbb2636a2d1$exports ? $2672bfbb2636a2d1$exports.prototype : undefined, $c18ead51fce0e2f5$var$symbolValueOf = $c18ead51fce0e2f5$var$symbolProto ? $c18ead51fce0e2f5$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c18ead51fce0e2f5$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $c18ead51fce0e2f5$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $c18ead51fce0e2f5$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $cd1932deec87124b$exports(object), new $cd1932deec87124b$exports(other))) return false;
            return true;
        case $c18ead51fce0e2f5$var$boolTag:
        case $c18ead51fce0e2f5$var$dateTag:
        case $c18ead51fce0e2f5$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $ec7e1ca26951058a$exports(+object, +other);
        case $c18ead51fce0e2f5$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $c18ead51fce0e2f5$var$regexpTag:
        case $c18ead51fce0e2f5$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $c18ead51fce0e2f5$var$mapTag:
            var convert = $32438a528c822b6d$exports;
        case $c18ead51fce0e2f5$var$setTag:
            var isPartial = bitmask & $c18ead51fce0e2f5$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $f290e44619123de7$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $c18ead51fce0e2f5$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $47de37ed582c6743$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $c18ead51fce0e2f5$var$symbolTag:
            if ($c18ead51fce0e2f5$var$symbolValueOf) return $c18ead51fce0e2f5$var$symbolValueOf.call(object) == $c18ead51fce0e2f5$var$symbolValueOf.call(other);
    }
    return false;
}
$c18ead51fce0e2f5$exports = $c18ead51fce0e2f5$var$equalByTag;


var $8fa11bc7fdbf7240$exports = {};
var $5eb254b69da0efa4$exports = {};
var $68bcc2f6815d5f8f$exports = {};
var $d3c8d8ca80495646$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $d3c8d8ca80495646$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$d3c8d8ca80495646$exports = $d3c8d8ca80495646$var$arrayPush;


var $24c4f6982fb97155$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $24c4f6982fb97155$var$isArray = Array.isArray;
$24c4f6982fb97155$exports = $24c4f6982fb97155$var$isArray;


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $68bcc2f6815d5f8f$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $24c4f6982fb97155$exports(object) ? result : $d3c8d8ca80495646$exports(result, symbolsFunc(object));
}
$68bcc2f6815d5f8f$exports = $68bcc2f6815d5f8f$var$baseGetAllKeys;


var $3074a94df3c2f012$exports = {};
var $afd2a41f025c782d$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $afd2a41f025c782d$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$afd2a41f025c782d$exports = $afd2a41f025c782d$var$arrayFilter;


var $adf3dff3c39fcae6$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $adf3dff3c39fcae6$var$stubArray() {
    return [];
}
$adf3dff3c39fcae6$exports = $adf3dff3c39fcae6$var$stubArray;


/** Used for built-in method references. */ var $3074a94df3c2f012$var$objectProto = Object.prototype;
/** Built-in value references. */ var $3074a94df3c2f012$var$propertyIsEnumerable = $3074a94df3c2f012$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3074a94df3c2f012$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3074a94df3c2f012$var$getSymbols = !$3074a94df3c2f012$var$nativeGetSymbols ? $adf3dff3c39fcae6$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $afd2a41f025c782d$exports($3074a94df3c2f012$var$nativeGetSymbols(object), function(symbol) {
        return $3074a94df3c2f012$var$propertyIsEnumerable.call(object, symbol);
    });
};
$3074a94df3c2f012$exports = $3074a94df3c2f012$var$getSymbols;


var $65d3bddbde62122a$exports = {};
var $10f5649afefd079c$exports = {};
var $386ad7bcb6e31d15$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $386ad7bcb6e31d15$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$386ad7bcb6e31d15$exports = $386ad7bcb6e31d15$var$baseTimes;


var $41c03c755d1e73af$exports = {};
var $1708e62f2a53fc2f$exports = {};

var $3ec008f979429b65$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3ec008f979429b65$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$3ec008f979429b65$exports = $3ec008f979429b65$var$isObjectLike;


/** `Object#toString` result references. */ var $1708e62f2a53fc2f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $1708e62f2a53fc2f$var$baseIsArguments(value) {
    return $3ec008f979429b65$exports(value) && $fdf97b0a973d8a11$exports(value) == $1708e62f2a53fc2f$var$argsTag;
}
$1708e62f2a53fc2f$exports = $1708e62f2a53fc2f$var$baseIsArguments;



/** Used for built-in method references. */ var $41c03c755d1e73af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41c03c755d1e73af$var$hasOwnProperty = $41c03c755d1e73af$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $41c03c755d1e73af$var$propertyIsEnumerable = $41c03c755d1e73af$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $41c03c755d1e73af$var$isArguments = $1708e62f2a53fc2f$exports(function() {
    return arguments;
}()) ? $1708e62f2a53fc2f$exports : function(value) {
    return $3ec008f979429b65$exports(value) && $41c03c755d1e73af$var$hasOwnProperty.call(value, 'callee') && !$41c03c755d1e73af$var$propertyIsEnumerable.call(value, 'callee');
};
$41c03c755d1e73af$exports = $41c03c755d1e73af$var$isArguments;




var $6HyT4 = parcelRequire("6HyT4");
var $9e170d1c1ebfcaaa$exports = {};
/** Used as references for various `Number` constants. */ var $9e170d1c1ebfcaaa$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9e170d1c1ebfcaaa$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9e170d1c1ebfcaaa$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9e170d1c1ebfcaaa$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $9e170d1c1ebfcaaa$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$9e170d1c1ebfcaaa$exports = $9e170d1c1ebfcaaa$var$isIndex;


var $4b12051e021b9995$exports = {};
var $387210416681c2e5$exports = {};

var $626215c7c433626c$exports = {};
/** Used as references for various `Number` constants. */ var $626215c7c433626c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $626215c7c433626c$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $626215c7c433626c$var$MAX_SAFE_INTEGER;
}
$626215c7c433626c$exports = $626215c7c433626c$var$isLength;



/** `Object#toString` result references. */ var $387210416681c2e5$var$argsTag = '[object Arguments]', $387210416681c2e5$var$arrayTag = '[object Array]', $387210416681c2e5$var$boolTag = '[object Boolean]', $387210416681c2e5$var$dateTag = '[object Date]', $387210416681c2e5$var$errorTag = '[object Error]', $387210416681c2e5$var$funcTag = '[object Function]', $387210416681c2e5$var$mapTag = '[object Map]', $387210416681c2e5$var$numberTag = '[object Number]', $387210416681c2e5$var$objectTag = '[object Object]', $387210416681c2e5$var$regexpTag = '[object RegExp]', $387210416681c2e5$var$setTag = '[object Set]', $387210416681c2e5$var$stringTag = '[object String]', $387210416681c2e5$var$weakMapTag = '[object WeakMap]';
var $387210416681c2e5$var$arrayBufferTag = '[object ArrayBuffer]', $387210416681c2e5$var$dataViewTag = '[object DataView]', $387210416681c2e5$var$float32Tag = '[object Float32Array]', $387210416681c2e5$var$float64Tag = '[object Float64Array]', $387210416681c2e5$var$int8Tag = '[object Int8Array]', $387210416681c2e5$var$int16Tag = '[object Int16Array]', $387210416681c2e5$var$int32Tag = '[object Int32Array]', $387210416681c2e5$var$uint8Tag = '[object Uint8Array]', $387210416681c2e5$var$uint8ClampedTag = '[object Uint8ClampedArray]', $387210416681c2e5$var$uint16Tag = '[object Uint16Array]', $387210416681c2e5$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $387210416681c2e5$var$typedArrayTags = {};
$387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$float32Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$float64Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$int8Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$int16Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$int32Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$uint8Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$uint8ClampedTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$uint16Tag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$uint32Tag] = true;
$387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$argsTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$arrayTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$arrayBufferTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$boolTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$dataViewTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$dateTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$errorTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$funcTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$mapTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$numberTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$objectTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$regexpTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$setTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$stringTag] = $387210416681c2e5$var$typedArrayTags[$387210416681c2e5$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $387210416681c2e5$var$baseIsTypedArray(value) {
    return $3ec008f979429b65$exports(value) && $626215c7c433626c$exports(value.length) && !!$387210416681c2e5$var$typedArrayTags[$fdf97b0a973d8a11$exports(value)];
}
$387210416681c2e5$exports = $387210416681c2e5$var$baseIsTypedArray;


var $8e4a60431c6a0553$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $8e4a60431c6a0553$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$8e4a60431c6a0553$exports = $8e4a60431c6a0553$var$baseUnary;



var $e2zM3 = parcelRequire("e2zM3");
/* Node.js helper references. */ var $4b12051e021b9995$var$nodeIsTypedArray = $e2zM3 && $e2zM3.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $4b12051e021b9995$var$isTypedArray = $4b12051e021b9995$var$nodeIsTypedArray ? $8e4a60431c6a0553$exports($4b12051e021b9995$var$nodeIsTypedArray) : $387210416681c2e5$exports;
$4b12051e021b9995$exports = $4b12051e021b9995$var$isTypedArray;


/** Used for built-in method references. */ var $10f5649afefd079c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $10f5649afefd079c$var$hasOwnProperty = $10f5649afefd079c$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $10f5649afefd079c$var$arrayLikeKeys(value, inherited) {
    var isArr = $24c4f6982fb97155$exports(value), isArg = !isArr && $41c03c755d1e73af$exports(value), isBuff = !isArr && !isArg && $6HyT4(value), isType = !isArr && !isArg && !isBuff && $4b12051e021b9995$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $386ad7bcb6e31d15$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $10f5649afefd079c$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $9e170d1c1ebfcaaa$exports(key, length)))) result.push(key);
    return result;
}
$10f5649afefd079c$exports = $10f5649afefd079c$var$arrayLikeKeys;


var $f5f5a0b4e8e6f33e$exports = {};
var $f7cc679c208d820b$exports = {};
/** Used for built-in method references. */ var $f7cc679c208d820b$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $f7cc679c208d820b$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $f7cc679c208d820b$var$objectProto;
    return value === proto;
}
$f7cc679c208d820b$exports = $f7cc679c208d820b$var$isPrototype;


var $e8a30f7046c8b9e6$exports = {};
var $0012ece8882efe9c$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0012ece8882efe9c$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$0012ece8882efe9c$exports = $0012ece8882efe9c$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $e8a30f7046c8b9e6$var$nativeKeys = $0012ece8882efe9c$exports(Object.keys, Object);
$e8a30f7046c8b9e6$exports = $e8a30f7046c8b9e6$var$nativeKeys;


/** Used for built-in method references. */ var $f5f5a0b4e8e6f33e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f5f5a0b4e8e6f33e$var$hasOwnProperty = $f5f5a0b4e8e6f33e$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f5f5a0b4e8e6f33e$var$baseKeys(object) {
    if (!$f7cc679c208d820b$exports(object)) return $e8a30f7046c8b9e6$exports(object);
    var result = [];
    for(var key in Object(object))if ($f5f5a0b4e8e6f33e$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
$f5f5a0b4e8e6f33e$exports = $f5f5a0b4e8e6f33e$var$baseKeys;


var $dbd80982dfef4f71$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $dbd80982dfef4f71$var$isArrayLike(value) {
    return value != null && $626215c7c433626c$exports(value.length) && !$08c123a90ef17cd1$exports(value);
}
$dbd80982dfef4f71$exports = $dbd80982dfef4f71$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $65d3bddbde62122a$var$keys(object) {
    return $dbd80982dfef4f71$exports(object) ? $10f5649afefd079c$exports(object) : $f5f5a0b4e8e6f33e$exports(object);
}
$65d3bddbde62122a$exports = $65d3bddbde62122a$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $5eb254b69da0efa4$var$getAllKeys(object) {
    return $68bcc2f6815d5f8f$exports(object, $65d3bddbde62122a$exports, $3074a94df3c2f012$exports);
}
$5eb254b69da0efa4$exports = $5eb254b69da0efa4$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $8fa11bc7fdbf7240$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $8fa11bc7fdbf7240$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8fa11bc7fdbf7240$var$hasOwnProperty = $8fa11bc7fdbf7240$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $8fa11bc7fdbf7240$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $8fa11bc7fdbf7240$var$COMPARE_PARTIAL_FLAG, objProps = $5eb254b69da0efa4$exports(object), objLength = objProps.length, othProps = $5eb254b69da0efa4$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $8fa11bc7fdbf7240$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
$8fa11bc7fdbf7240$exports = $8fa11bc7fdbf7240$var$equalObjects;


var $c9538a997e2cc81f$exports = {};
var $bed2a19b37027416$exports = {};


var $jEjAi = parcelRequire("jEjAi");
/* Built-in method references that are verified to be native. */ var $bed2a19b37027416$var$DataView = $bb1f58fbbde092b1$exports($jEjAi, 'DataView');
$bed2a19b37027416$exports = $bed2a19b37027416$var$DataView;



var $bbce848e8f98ce4e$exports = {};


var $jEjAi = parcelRequire("jEjAi");
/* Built-in method references that are verified to be native. */ var $bbce848e8f98ce4e$var$Promise = $bb1f58fbbde092b1$exports($jEjAi, 'Promise');
$bbce848e8f98ce4e$exports = $bbce848e8f98ce4e$var$Promise;


var $338f75a00215478f$exports = {};


var $jEjAi = parcelRequire("jEjAi");
/* Built-in method references that are verified to be native. */ var $338f75a00215478f$var$Set = $bb1f58fbbde092b1$exports($jEjAi, 'Set');
$338f75a00215478f$exports = $338f75a00215478f$var$Set;


var $47677aeec113edda$exports = {};


var $jEjAi = parcelRequire("jEjAi");
/* Built-in method references that are verified to be native. */ var $47677aeec113edda$var$WeakMap = $bb1f58fbbde092b1$exports($jEjAi, 'WeakMap');
$47677aeec113edda$exports = $47677aeec113edda$var$WeakMap;




/** `Object#toString` result references. */ var $c9538a997e2cc81f$var$mapTag = '[object Map]', $c9538a997e2cc81f$var$objectTag = '[object Object]', $c9538a997e2cc81f$var$promiseTag = '[object Promise]', $c9538a997e2cc81f$var$setTag = '[object Set]', $c9538a997e2cc81f$var$weakMapTag = '[object WeakMap]';
var $c9538a997e2cc81f$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $c9538a997e2cc81f$var$dataViewCtorString = $331b66bb4283ac4b$exports($bed2a19b37027416$exports), $c9538a997e2cc81f$var$mapCtorString = $331b66bb4283ac4b$exports($74863592e7c59f35$exports), $c9538a997e2cc81f$var$promiseCtorString = $331b66bb4283ac4b$exports($bbce848e8f98ce4e$exports), $c9538a997e2cc81f$var$setCtorString = $331b66bb4283ac4b$exports($338f75a00215478f$exports), $c9538a997e2cc81f$var$weakMapCtorString = $331b66bb4283ac4b$exports($47677aeec113edda$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $c9538a997e2cc81f$var$getTag = $fdf97b0a973d8a11$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($bed2a19b37027416$exports && $c9538a997e2cc81f$var$getTag(new $bed2a19b37027416$exports(new ArrayBuffer(1))) != $c9538a997e2cc81f$var$dataViewTag || $74863592e7c59f35$exports && $c9538a997e2cc81f$var$getTag(new $74863592e7c59f35$exports) != $c9538a997e2cc81f$var$mapTag || $bbce848e8f98ce4e$exports && $c9538a997e2cc81f$var$getTag($bbce848e8f98ce4e$exports.resolve()) != $c9538a997e2cc81f$var$promiseTag || $338f75a00215478f$exports && $c9538a997e2cc81f$var$getTag(new $338f75a00215478f$exports) != $c9538a997e2cc81f$var$setTag || $47677aeec113edda$exports && $c9538a997e2cc81f$var$getTag(new $47677aeec113edda$exports) != $c9538a997e2cc81f$var$weakMapTag) $c9538a997e2cc81f$var$getTag = function(value) {
    var result = $fdf97b0a973d8a11$exports(value), Ctor = result == $c9538a997e2cc81f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $331b66bb4283ac4b$exports(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $c9538a997e2cc81f$var$dataViewCtorString:
            return $c9538a997e2cc81f$var$dataViewTag;
        case $c9538a997e2cc81f$var$mapCtorString:
            return $c9538a997e2cc81f$var$mapTag;
        case $c9538a997e2cc81f$var$promiseCtorString:
            return $c9538a997e2cc81f$var$promiseTag;
        case $c9538a997e2cc81f$var$setCtorString:
            return $c9538a997e2cc81f$var$setTag;
        case $c9538a997e2cc81f$var$weakMapCtorString:
            return $c9538a997e2cc81f$var$weakMapTag;
    }
    return result;
};
$c9538a997e2cc81f$exports = $c9538a997e2cc81f$var$getTag;




var $6HyT4 = parcelRequire("6HyT4");

/** Used to compose bitmasks for value comparisons. */ var $e6067bfbb555c1c7$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e6067bfbb555c1c7$var$argsTag = '[object Arguments]', $e6067bfbb555c1c7$var$arrayTag = '[object Array]', $e6067bfbb555c1c7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $e6067bfbb555c1c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e6067bfbb555c1c7$var$hasOwnProperty = $e6067bfbb555c1c7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e6067bfbb555c1c7$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $24c4f6982fb97155$exports(object), othIsArr = $24c4f6982fb97155$exports(other), objTag = objIsArr ? $e6067bfbb555c1c7$var$arrayTag : $c9538a997e2cc81f$exports(object), othTag = othIsArr ? $e6067bfbb555c1c7$var$arrayTag : $c9538a997e2cc81f$exports(other);
    objTag = objTag == $e6067bfbb555c1c7$var$argsTag ? $e6067bfbb555c1c7$var$objectTag : objTag;
    othTag = othTag == $e6067bfbb555c1c7$var$argsTag ? $e6067bfbb555c1c7$var$objectTag : othTag;
    var objIsObj = objTag == $e6067bfbb555c1c7$var$objectTag, othIsObj = othTag == $e6067bfbb555c1c7$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $6HyT4(object)) {
        if (!$6HyT4(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $469cd8ad3eb7f1ce$exports);
        return objIsArr || $4b12051e021b9995$exports(object) ? $47de37ed582c6743$exports(object, other, bitmask, customizer, equalFunc, stack) : $c18ead51fce0e2f5$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e6067bfbb555c1c7$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e6067bfbb555c1c7$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $e6067bfbb555c1c7$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $469cd8ad3eb7f1ce$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $469cd8ad3eb7f1ce$exports);
    return $8fa11bc7fdbf7240$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$e6067bfbb555c1c7$exports = $e6067bfbb555c1c7$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a39fdf7de8d4b46c$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$3ec008f979429b65$exports(value) && !$3ec008f979429b65$exports(other)) return value !== value && other !== other;
    return $e6067bfbb555c1c7$exports(value, other, bitmask, customizer, $a39fdf7de8d4b46c$var$baseIsEqual, stack);
}
$a39fdf7de8d4b46c$exports = $a39fdf7de8d4b46c$var$baseIsEqual;


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function $2b3509163a685877$var$isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? $a39fdf7de8d4b46c$exports(value, other, undefined, customizer) : !!result;
}
$2b3509163a685877$exports = $2b3509163a685877$var$isEqualWith;


const $f863b8d5c2f84d59$export$e695d2c5d105ff4a = (workPeriods)=>workPeriods.map((wp)=>({
            start: wp.start.date,
            end: wp.end.date
        }));
const $f863b8d5c2f84d59$export$6850e4b3969fec48 = (workPeriods, workPeriodsToCheck)=>(0, (/*@__PURE__*/$parcel$interopDefault($2b3509163a685877$exports)))($f863b8d5c2f84d59$export$e695d2c5d105ff4a(workPeriods), $f863b8d5c2f84d59$export$e695d2c5d105ff4a(workPeriodsToCheck));
const $f863b8d5c2f84d59$export$84f30a092e754953 = (workPeriods)=>workPeriods.reduce((result, workPeriod)=>result += `${new Date(workPeriod.start.date).toLocaleDateString('fr-FR', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            timeZone: 'Europe/Paris'
        })} de ${new Date(workPeriod.start.date).toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Europe/Paris'
        })} \xe0 ${new Date(workPeriod.end.date).toLocaleTimeString('fr-FR', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: 'Europe/Paris'
        })}\n`, '');
const $f863b8d5c2f84d59$export$f19e810d38326859 = (workPeriod)=>{
    const startClocking = workPeriod.start.clocking?.date || workPeriod.start.manualClocking;
    const endClocking = workPeriod.end.clocking?.date || workPeriod.end.manualClocking;
    return !Boolean(!startClocking && !endClocking || startClocking && endClocking);
};
const $f863b8d5c2f84d59$export$911e8f8c3608f541 = (workPeriod)=>{
    if (workPeriod.start.clocking?.date || workPeriod.start.manualClocking) return true;
    if (workPeriod.end.clocking?.date || workPeriod.end.manualClocking) return true;
    return false;
};
const $f863b8d5c2f84d59$export$43302f6a09ecd26 = (breaksClockings)=>{
    const sanitizedBreaks = [];
    breaksClockings.forEach((breakClocking, index)=>{
        if (index % 2 === 0) sanitizedBreaks.push({
            start: breakClocking,
            end: breaksClockings[index + 1]
        });
    });
    return sanitizedBreaks;
};


const $86a53490471b161f$export$12e6eb457c26b96c = (doc, docToCompare)=>{
    const docId = doc?._id ? doc?._id.toString() : doc?.toString();
    const docIdToCompare = docToCompare?._id ? docToCompare?._id.toString() : docToCompare?.toString();
    return docId === docIdToCompare;
};
const $86a53490471b161f$export$f7ab4a0ab72c2665 = (docOrId)=>{
    if (typeof docOrId === 'string') return docOrId;
    if ('_id' in docOrId && docOrId._id) return docOrId._id.toString();
    return docOrId.toString();
};
const $86a53490471b161f$export$aa8bd8529a122928 = (embeddedDocs, docOrId)=>embeddedDocs.find((doc)=>$86a53490471b161f$export$12e6eb457c26b96c(doc, docOrId));


const $31a4d969185a2555$export$87e82b96f053e224 = (mission)=>mission.workPeriods.every((w)=>w.isValidated);
const $31a4d969185a2555$export$3d4b1f3c00282f2b = (missions)=>missions.every($31a4d969185a2555$export$87e82b96f053e224);
const $31a4d969185a2555$export$4a446b76db87ddfb = (mission)=>mission.workPeriods.some((w)=>(0, $f863b8d5c2f84d59$export$f19e810d38326859)(w));
const $31a4d969185a2555$export$59c28d15dd5a2a1c = (workPeriods, week, year)=>workPeriods.filter((workPeriod)=>workPeriod.year.toString() === year.toString() && workPeriod.week.toString() === week.toString());
const $31a4d969185a2555$export$afb762267a1d0898 = (mission, worker, employer)=>(0, $86a53490471b161f$export$12e6eb457c26b96c)(mission.user, worker) && (!mission.interimAgency ? (0, $86a53490471b161f$export$12e6eb457c26b96c)(mission.employer, employer) : (0, $86a53490471b161f$export$12e6eb457c26b96c)(mission.interimAgency, employer));
const $31a4d969185a2555$export$749026d23233543c = (missions, worker, employer)=>{
    //@ts-ignore
    return missions.filter((mission)=>$31a4d969185a2555$export$afb762267a1d0898(mission, worker, employer));
};
const $31a4d969185a2555$export$11bbf821be82ed4a = (missions)=>{
    return missions.reduce((groupedMissions, mission)=>{
        // Clé unique pour chaque combinaison worker/employer
        const employerId = (0, $86a53490471b161f$export$f7ab4a0ab72c2665)(mission.interimAgency || mission.employer);
        const workerId = (0, $86a53490471b161f$export$f7ab4a0ab72c2665)(mission.user);
        const groupKey = `${workerId}_${employerId}`;
        if (!groupedMissions[groupKey]) groupedMissions[groupKey] = [];
        groupedMissions[groupKey].push(mission);
        return groupedMissions;
    }, {});
};




const $cf16adc16c4b6005$var$WorkPeriodActions = ({ mission: mission, workPeriod: workPeriod })=>{
    const actions = $cf16adc16c4b6005$var$useActions(workPeriod, mission);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dd1d1753cdfb51cf$export$2e2bcd8739ae039), {
        actions: actions
    });
};
var $cf16adc16c4b6005$export$2e2bcd8739ae039 = $cf16adc16c4b6005$var$WorkPeriodActions;
/**
 * Determine if a mission can be abandoned on the client side.
 * Mirrors backend logic to prevent UI desyncs.
 * @param mission Full mission object including status flags and work periods
 * @param workPeriods Optional work periods list if already fetched elsewhere
 * @returns true when the mission is eligible for abandonment
 */ // TODO: duplicate of backend check (found  a solution to avoid duplicate code)
const $cf16adc16c4b6005$var$canMissionBeAbandoned = (mission, workPeriods)=>{
    // Block when mission already validated, abandoned or cancelled
    if (mission.isValidated || mission.isAbandoned || mission.isCancelled) return false;
    // Use provided work periods, fall back to mission payload or empty list
    const workPeriodsToCheck = workPeriods || mission.workPeriods || [];
    const now = new Date();
    // Filter future periods only
    const nextWorkPeriods = workPeriodsToCheck.filter((wP)=>(0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(wP.start.date), now));
    // If future periods exist, ensure all are abandonable
    if (nextWorkPeriods.length > 0 && nextWorkPeriods.some((wP)=>wP.__actions?.canBeAbandoned === false)) return false;
    // All checks passed, mission is abandonable
    return true;
};
const $cf16adc16c4b6005$var$useActions = (workPeriod, mission)=>{
    //Mutations
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const validateWorkPeriodMutation = (0, $7040c29cc25c4df6$export$6cbf757d2bdf6301)();
    const removeWorkPeriodMutation = (0, $7040c29cc25c4df6$export$8b43aa0b788b22a8)();
    const missionUpdateMutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $e409591b67738e56$export$a6fe4df8bec26327)());
    const unAbandonMissionMutation = (0, $e409591b67738e56$export$798c00a2090f5996)();
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const removeModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const missionCanBeAbandoned = $cf16adc16c4b6005$var$canMissionBeAbandoned(mission);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ], {
                resource: 'missions',
                name: 'validateWorkPeriod'
            }) && {
                title: "Valider la Journ\xe9e de Travail",
                description: "Une fois valid\xe9e, la Journ\xe9e de Travail ne peut plus \xeatre modifi\xe9e et plus aucun pointage ne sera pris en compte. Cette action est r\xe9versible.",
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                    children: [
                        workPeriod.__actions.canBeInvalidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$42e76898d8f52841), {
                                workPeriod: workPeriod
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            narrow: true,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $801415e870a9139e$export$2e2bcd8739ae039), {
                                workPeriod: workPeriod,
                                label: "Valider",
                                cancelLabel: "Annuler",
                                type: "button",
                                onClick: ()=>validateWorkPeriodMutation.mutate({
                                        workPeriodId: workPeriod._id,
                                        isValidated: !workPeriod.isValidated
                                    })
                            })
                        })
                    ]
                })
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ], {
                resource: 'missions',
                name: 'abandon'
            }) && {
                title: "Abandonner la Mission \xe0 partir de ce jour",
                description: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        "Le ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                        " ne pourra plus pointer aucune entr\xe9e et sortie pour cette Journ\xe9e de Travail et le restant de la Mission.\\ Il sera remis \xe0 disposition de l'Agence d'Int\xe9rim."
                    ]
                }),
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            children: [
                                workPeriod.isAbandoned && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$b89ed0bd7f7384f6), {
                                                    workPeriod: workPeriod
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                    mutation: missionUpdateMutationState
                                                })
                                            ]
                                        }),
                                        mission.__actions.canBeUnAbandoned && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            narrow: true,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                textColor: "grey",
                                                mutation: unAbandonMissionMutation,
                                                onClick: ()=>unAbandonMissionMutation.mutate({
                                                        missionId: mission._id
                                                    }),
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6e75112b03731134), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            renderAs: "span",
                                                            children: "Annuler"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                !workPeriod.isAbandoned && mission.isAbandoned && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                                            mission: mission
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button).Group, {
                                        children: !workPeriod.isAbandoned && !mission.isAbandoned && workPeriod.__actions.canBeAbandoned && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $23348fff11010b14$export$2e2bcd8739ae039), {
                                            type: "button",
                                            color: "danger",
                                            onClick: ()=>modal.setIsDisplayed(true),
                                            disabled: !missionCanBeAbandoned,
                                            tooltip: {
                                                text: (0, $31a4d969185a2555$export$4a446b76db87ddfb)(mission) ? "Une journ\xe9e de travail a un pointage d'entr\xe9e mais pas de sortie" : "Mission interrompue ou Journ\xe9e de Travail Valid\xe9e",
                                                show: !missionCanBeAbandoned,
                                                id: `${mission._id}-cancel-abandonment`
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    mr: 1,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6e75112b03731134), {})
                                                }),
                                                'Abandon'
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2e807891940c55ac$export$2e2bcd8739ae039), {
                            show: modal.isDisplayed,
                            hide: ()=>modal.setIsDisplayed(false),
                            mission: mission,
                            workPeriod: workPeriod
                        })
                    ]
                })
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ], {
                resource: 'missions',
                name: 'deleteWorkPeriod'
            }) && workPeriod.__actions.canBeRemoved && {
                title: "Supprimer la journ\xe9e de travail",
                description: "La journ\xe9e de travail sera d\xe9finitivement supprim\xe9e de la mission. Cette action est possible uniquement s'il n'y a aucun pointage, aucun \xe9v\xe9nement, et que la journ\xe9e n'est pas valid\xe9e.",
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                            color: "danger",
                            onClick: ()=>removeModal.setIsDisplayed(true),
                            "data-test": "remove-work-period-button",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    mr: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1ae95d1a7411cb7b), {})
                                }),
                                "Supprimer la journ\xe9e"
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                            show: removeModal.isDisplayed,
                            onCancel: ()=>removeModal.setIsDisplayed(false),
                            onConfirm: ()=>{
                                removeWorkPeriodMutation.mutate({
                                    missionId: mission._id,
                                    workPeriodId: workPeriod._id
                                }, {
                                    onSuccess: ()=>{
                                        removeModal.setIsDisplayed(false);
                                        navigate(`/missions/${mission._id}`);
                                    }
                                });
                            },
                            confirmButtonLabel: "Supprimer",
                            confirmButtonProps: {
                                disabled: removeWorkPeriodMutation.isLoading
                            },
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                children: "\xcates-vous s\xfbr de vouloir supprimer cette journ\xe9e de travail ? Elle sera d\xe9finitivement retir\xe9e de la mission."
                            })
                        })
                    ]
                })
            }
        ].filter((v)=>v), [
        mission,
        workPeriod,
        validateWorkPeriodMutation,
        missionCanBeAbandoned,
        removeWorkPeriodMutation,
        navigate
    ]);
};




var $2KSUA = parcelRequire("2KSUA");
parcelRequire("3ZYaX");





const $898c03e80810a32a$var$WorkPeriodPageTitle = ({ workPeriod: workPeriod, children: children, onServiceEdit: onServiceEdit })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: (0, $2KSUA.upperFirst)((0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(workPeriod.start.date)),
        subTitle: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        mr: 5,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: workPeriod.user,
                            dataTest: "work-period-details-worker-name"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$bbc9410078004e71), {})
                        }),
                        onServiceEdit ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "a",
                            onClick: onServiceEdit,
                            "data-test": "work-period-details-service-name",
                            children: workPeriod.service.name
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            "data-test": "work-period-details-service-name",
                            renderAs: "span",
                            children: workPeriod.service.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$a409e2da4a3967b), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            "data-test": "work-period-details-job-title-name",
                            renderAs: "span",
                            children: workPeriod.mission.jobTitle.name
                        })
                    ]
                })
            ]
        }),
        children: children
    });
var $898c03e80810a32a$export$2e2bcd8739ae039 = $898c03e80810a32a$var$WorkPeriodPageTitle;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");



const $48ca4087ad4be311$var$buildLinkContent = (label, direction)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
        flexWrap: "nowrap",
        children: [
            direction === 'previous' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$8afed21ef5c2afa5), {})
                    }),
                    "\xa0"
                ]
            }),
            label,
            direction === 'next' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    "\xa0",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$9ca09caa9c849d9c), {})
                    })
                ]
            })
        ]
    });
const $48ca4087ad4be311$export$f9942b7fbbaad25e = ({ items: [previous, next], linkBuilder: linkBuilder, labelBuilder: labelBuilder, renderLink: renderLink })=>{
    const previousLabel = previous ? labelBuilder(previous) : undefined;
    const nextLabel = next ? labelBuilder(next) : undefined;
    const previousContent = previous ? renderLink ? renderLink(previous, $48ca4087ad4be311$var$buildLinkContent(previousLabel, 'previous'), {
        direction: 'previous'
    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
        to: linkBuilder(previous),
        "data-test": "page-navigation-previous",
        children: $48ca4087ad4be311$var$buildLinkContent(previousLabel, 'previous')
    }) : null;
    const nextContent = next ? renderLink ? renderLink(next, $48ca4087ad4be311$var$buildLinkContent(nextLabel, 'next'), {
        direction: 'next'
    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
        to: linkBuilder(next),
        "data-test": "page-navigation-next",
        children: $48ca4087ad4be311$var$buildLinkContent(nextLabel, 'next')
    }) : null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "flex",
        justifyContent: "space-between",
        children: [
            previousContent ?? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {}),
            previousContent && nextContent && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                children: "\u2022"
            }),
            nextContent
        ]
    });
};



const $7e0e62be69635d53$export$e91bd532fd89cdb4 = ({ missionId: missionId, previousWorkPeriod: previousWorkPeriod, nextWorkPeriod: nextWorkPeriod })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $48ca4087ad4be311$export$f9942b7fbbaad25e), {
        items: [
            previousWorkPeriod,
            nextWorkPeriod
        ],
        labelBuilder: (wp)=>(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(wp.start.date),
        linkBuilder: (wp)=>`/missions/${missionId}/work-periods/${wp._id}`,
        renderLink: (wp, content, { direction: direction })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                "data-test": `page-navigation-${direction}`,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $86213dc9c75e3746$export$2e2bcd8739ae039), {
                    workPeriod: wp,
                    style: {
                        display: 'inline-flex'
                    },
                    textColor: "link",
                    children: content
                })
            })
    });




var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");





var $2KSUA = parcelRequire("2KSUA");




parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");







parcelRequire("3ZYaX");

const $f27050f1c1a92245$var$WorkPeriodEventInformativeDescription = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                textColor: textColor,
                children: "Ev\xe9nement Informatif"
            }),
            ' ',
            ": il est indicatif, il n\u2019a pas d\u2019incidence sur des calculs. ",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "i",
                children: "Exemple : Une Absence Autoris\xe9e, un Grand D\xe9placement"
            })
        ]
    });
};
var $f27050f1c1a92245$export$2e2bcd8739ae039 = $f27050f1c1a92245$var$WorkPeriodEventInformativeDescription;



parcelRequire("3ZYaX");

const $cb7b9831917edb90$var$WorkPeriodEventBenefitDescription = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                textSize: 7,
                textColor: textColor,
                children: "Ev\xe9nement Prestation"
            }),
            ' ',
            ": il va affecter positivement les Heures Totales Prest\xe9es pour un Jour, quand bien m\xeame l\u2019 Employ\xe9 n\u2019a pas prest\xe9 r\xe9ellement ce Jour l\xe0.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "i",
                children: "Exemple : Un Cong\xe9 Pay\xe9"
            })
        ]
    });
};
var $cb7b9831917edb90$export$2e2bcd8739ae039 = $cb7b9831917edb90$var$WorkPeriodEventBenefitDescription;




parcelRequire("3ZYaX");

const $6f21e816b0bbea04$var$WorkPeriodEventIndicatesAbsenceDescription = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        textColor: textColor,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                textSize: 7,
                textColor: textColor,
                children: "Indique absence"
            }),
            ' ',
            ": si coch\xe9, une journ\xe9e avec cet \xe9v\xe8nement sera consid\xe9r\xe9e comme une absence pour l'affichage des personnes pr\xe9sentes mais n'influe pas sur le calcul des heures de travail."
        ]
    });
};
var $6f21e816b0bbea04$export$2e2bcd8739ae039 = $6f21e816b0bbea04$var$WorkPeriodEventIndicatesAbsenceDescription;



const $125d99df407900ba$var$WorkPeriodEventForm = ({ workPeriodEvent: workPeriodEvent })=>{
    const createMutation = (0, $70137e1130a90c1c$export$a25726670bb41cb)();
    const updateMutation = (0, $70137e1130a90c1c$export$cac0b33e6f13c8ec)();
    const isSuperAdmin = (0, $8403deec6a28521e$export$6025088343704f9f)([
        'superAdmin'
    ]);
    const isEditMode = Boolean(workPeriodEvent);
    const canEdit = !isEditMode || isSuperAdmin;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: workPeriodEvent || {
            code: '',
            title: '',
            type: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.code) errors.code = 'Champ requis';
            if (!values.title) errors.title = 'Champ requis';
            if (!values.type) errors.type = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            if (!canEdit) return;
            workPeriodEvent ? updateMutation.mutate({
                ...values,
                id: workPeriodEvent._id.toString()
            }) : createMutation.mutate(values);
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Code",
                        name: "code",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        disabled: !canEdit
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Intitul\xe9",
                        name: "title",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        disabled: !canEdit
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Type",
                                    name: "type",
                                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                    options: [
                                        {
                                            value: 'informative',
                                            label: (0, $f1533a9d55778507$export$2e2bcd8739ae039).types.informative
                                        },
                                        {
                                            value: 'benefit',
                                            label: (0, $f1533a9d55778507$export$2e2bcd8739ae039).types.benefit
                                        }
                                    ],
                                    disabled: !canEdit
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Indique absence",
                                    name: "indicatesAbsence",
                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                    disabled: !canEdit
                                })
                            })
                        ]
                    }),
                    !canEdit && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        textSize: 7,
                        textColor: "grey",
                        mb: 2,
                        children: "Pour toute modification des \xe9v\xe8nements, veuillez en faire la demande \xe0 support@teamtim.fr"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: 'info',
                        textSize: 7,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f713256e8ad1586), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f27050f1c1a92245$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb7b9831917edb90$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6f21e816b0bbea04$export$2e2bcd8739ae039), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: workPeriodEvent ? updateMutation : createMutation,
                        "data-test": "save-work-period-events",
                        disabled: !canEdit,
                        children: workPeriodEvent ? "Mettre \xe0 jour l'\xc9v\xe8nement" : "Nouvel \xc9v\xe8nement"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: workPeriodEvent ? updateMutation : createMutation
                    })
                ]
            });
        }
    });
};
var $125d99df407900ba$export$2e2bcd8739ae039 = $125d99df407900ba$var$WorkPeriodEventForm;


const $8a4190b80ffba83f$var$WorkPeriodEventModalForm = ({ isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed, workPeriodEvent: workPeriodEvent })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        actions: {
            isDisplayed: isDisplayed,
            setIsDisplayed: setIsDisplayed
        },
        title: workPeriodEvent ? "Modifier un \xc9v\xe8nement" : "Cr\xe9er un nouvel \xc9v\xe8nement",
        dataTest: "work-period-event-modal",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $125d99df407900ba$export$2e2bcd8739ae039), {
            workPeriodEvent: workPeriodEvent
        })
    });
};
var $8a4190b80ffba83f$export$2e2bcd8739ae039 = $8a4190b80ffba83f$var$WorkPeriodEventModalForm;






var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");












const $4d4952385d51de60$var$WorkPeriodDateToDateEventForm = ({ defaultFromDate: defaultFromDate, defaultToDate: defaultToDate, mission: mission, onSuccess: onSuccess })=>{
    const addEventsToWorkPeriodsMutation = (0, $7040c29cc25c4df6$export$c2dc3ab22a878005)();
    const workPeriodEventsQuery = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)();
    const [showWorkPeriodEventForm, setShowWorkPeriodEventForm] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8a4190b80ffba83f$export$2e2bcd8739ae039), {
                setIsDisplayed: setShowWorkPeriodEventForm,
                isDisplayed: showWorkPeriodEventForm
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                initialValues: {
                    from: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(defaultFromDate),
                    to: defaultToDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(defaultToDate) : '',
                    event: {},
                    addDuplicate: false
                },
                enableReinitialize: true,
                validate: (values)=>{
                    const errors = {};
                    if (!values.from) errors.from = 'Champ requis';
                    if (!values.to) errors.to = 'Champ requis';
                    if (!values.event?.item) errors['event.item'] = 'Champs requis';
                    return errors;
                },
                onSubmit: (values)=>{
                    const from = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.from);
                    const to = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.to);
                    addEventsToWorkPeriodsMutation.mutate({
                        missionId: mission._id,
                        from: from,
                        to: to,
                        events: [
                            values.event
                        ]
                    });
                    onSuccess?.();
                },
                children: ({ values: values, submitForm: submitForm })=>{
                    const workPeriodsInInterval = values.from && values.to && (0, $3e6d8a4591828c3c$export$772cd301688dff26)(mission, (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.from), (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.to));
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                mb: 1,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: `from`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(mission.start)),
                                            max: values.to ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(values.to)) : undefined,
                                            label: "Du",
                                            type: "date"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: `to`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(values.from || mission.start)),
                                            max: mission.end ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(mission.end)) : undefined,
                                            label: "Au",
                                            type: "date"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        mb: 3,
                                        size: 5,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: `event.item`,
                                            label: "\xc9v\xe8nement",
                                            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                            options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(workPeriodEventsQuery.data || [], {
                                                labelBuilder: (0, $a58cd4802ae2892e$export$8cdd78f580711f43),
                                                sortBy: 'code'
                                            }),
                                            help: !values.event?.item && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "a",
                                                onClick: ()=>setShowWorkPeriodEventForm(true),
                                                children: "Cr\xe9er un nouvel \xe9v\xe8nement"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 7,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: `event.comment`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            label: "Commentaire"
                                        })
                                    })
                                ]
                            }),
                            workPeriodsInInterval && values.event?.item && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($4d4952385d51de60$var$WorkPeriodsHasAlreadyEventWarn, {
                                        workPeriods: workPeriodsInInterval,
                                        eventId: values.event?.item
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                        type: "button",
                                        color: 'primary',
                                        onClick: ()=>submitForm(),
                                        mutation: addEventsToWorkPeriodsMutation,
                                        children: "Enregistrer"
                                    })
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $4d4952385d51de60$export$2e2bcd8739ae039 = $4d4952385d51de60$var$WorkPeriodDateToDateEventForm;
const $4d4952385d51de60$var$WorkPeriodsHasAlreadyEventWarn = ({ workPeriods: workPeriods, eventId: eventId })=>{
    const workPeriodsWithEvent = (0, $dda2f26c3659cf93$export$5b362db52df0b67c)(workPeriods, eventId);
    if (!workPeriodsWithEvent[0]) return '';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
        name: `addDuplicate`,
        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
        text: "Oui, je veux dupliquer l'\xe9n\xe8nement",
        label: `Cet \xe9v\xe8nement est d\xe9j\xe0 attribu\xe9 \xe0 ${workPeriodsWithEvent.length} journ\xe9e(s) de travail dans la
        plage s\xe9lectionn\xe9e. Voulez-vous dupliquer l'\xe8v\xe8nement pour ces journ\xe9e(s) de travail?`
    });
};



const $6387a60f69cec18b$var$WorkPeriodEventsForm = ({ workPeriod: workPeriod, mission: mission, disabled: disabled })=>{
    const workPeriodEventsQuery = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)();
    const updateWorkPeriodMutation = (0, $7040c29cc25c4df6$export$cac0b33e6f13c8ec)();
    const [showWorkPeriodEventForm, setShowWorkPeriodEventForm] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const addEventModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const initialEvents = (workPeriod.events || []).map((e)=>({
            ...e,
            item: e.item._id
        }));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            !disabled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8a4190b80ffba83f$export$2e2bcd8739ae039), {
                setIsDisplayed: setShowWorkPeriodEventForm,
                isDisplayed: showWorkPeriodEventForm
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                initialValues: {
                    events: initialEvents
                },
                enableReinitialize: true,
                onSubmit: (values)=>{
                    updateWorkPeriodMutation.mutate({
                        workPeriodId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod),
                        missionId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission),
                        events: values.events
                    });
                },
                children: ({ values: values, submitForm: submitForm })=>{
                    const isModified = !(0, $2KSUA.isEqual)(values.events.filter((event)=>event.item), initialEvents);
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                            name: "events",
                            render: (arrayHelpers)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    children: [
                                        values.events?.[0] ? values.events.map((event, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        mb: 3,
                                                        size: 4,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            name: `events.${index}.item`,
                                                            label: "\xc9v\xe8nement",
                                                            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                            options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(workPeriodEventsQuery.data || [], {
                                                                labelBuilder: (0, $a58cd4802ae2892e$export$8cdd78f580711f43),
                                                                sortBy: 'code'
                                                            }),
                                                            disabled: disabled,
                                                            help: !values.events?.[index]?.item && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                renderAs: "a",
                                                                onClick: ()=>setShowWorkPeriodEventForm(true),
                                                                children: "Cr\xe9er un nouvel \xe9v\xe8nement"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 7,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            name: `events.${index}.comment`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            label: "Commentaire",
                                                            disabled: disabled
                                                        })
                                                    }),
                                                    !disabled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        mb: 3,
                                                        size: 1,
                                                        pt: 5,
                                                        textAlign: 'center',
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            mt: 5,
                                                            size: 'small',
                                                            onClick: arrayHelpers.handleRemove(index),
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                                            })
                                                        })
                                                    }, index)
                                                ]
                                            }, index)) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: "Aucun \xe9v\xe8nement li\xe9 \xe0 la Journ\xe9e de Travail"
                                        }),
                                        !disabled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    type: "button",
                                                    onClick: ()=>addEventModal.setIsDisplayed(true),
                                                    mr: 2,
                                                    children: "Ajouter un \xe9v\xe8nement"
                                                }),
                                                isModified && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                    type: "button",
                                                    color: 'primary',
                                                    onClick: ()=>submitForm(),
                                                    mutation: updateWorkPeriodMutation?.variables?.events && updateWorkPeriodMutation,
                                                    "data-test": "save-events-button",
                                                    children: "Enregistrer"
                                                })
                                            ]
                                        })
                                    ]
                                })
                        })
                    });
                }
            }),
            !disabled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                actions: addEventModal,
                title: "Ajouter un \xe9v\xe8nement",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4d4952385d51de60$export$2e2bcd8739ae039), {
                    mission: mission,
                    defaultFromDate: new Date(workPeriod.start.date),
                    defaultToDate: new Date(workPeriod.start.date),
                    onSuccess: ()=>addEventModal.setIsDisplayed(false)
                })
            })
        ]
    });
};
var $6387a60f69cec18b$export$2e2bcd8739ae039 = $6387a60f69cec18b$var$WorkPeriodEventsForm;







parcelRequire("3ZYaX");


var $b8df297ae17ce4ed$var$defaultFormat = [
    'years',
    'months',
    'weeks',
    'days',
    'hours',
    'minutes',
    'seconds'
];
function $b8df297ae17ce4ed$export$2e2bcd8739ae039(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9bf1fd7b116fa75d$export$2e2bcd8739ae039);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : $b8df297ae17ce4ed$var$defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
    if (!locale.formatDistance) return '';
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === 'number' && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}


const $239d0c4f69d06a71$var$ClockingRulesBreakDescription = ({ clockingRules: clockingRules })=>{
    if (!clockingRules.break.clocked) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            (0, $b8df297ae17ce4ed$export$2e2bcd8739ae039)({
                minutes: clockingRules.break.breakDuration
            }),
            " apr\xe8s",
            ' ',
            (0, $b8df297ae17ce4ed$export$2e2bcd8739ae039)({
                minutes: clockingRules.break.breakAllowedAfter
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: "Les pauses sont point\xe9es"
    });
};
var $239d0c4f69d06a71$export$2e2bcd8739ae039 = $239d0c4f69d06a71$var$ClockingRulesBreakDescription;



parcelRequire("3ZYaX");


var $2KSUA = parcelRequire("2KSUA");



const $89ac160dcbe6dfd3$var$WorkPeriodClockings = ({ workPeriod: workPeriod })=>{
    const clockingsQuery = (0, $d19e678f97a3d4d6$export$556810fba3a25e86)({
        workPeriod: workPeriod._id
    });
    const clockings = (0, $2KSUA.sortBy)(clockingsQuery.data || [], 'createdAt');
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: clockings.map((clocking, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($89ac160dcbe6dfd3$var$WorkPeriodClocking, {
                clocking: clocking,
                workPeriod: workPeriod,
                isFirst: index === 0,
                isLast: index === clockings.length - 1
            }, clocking._id))
    });
};
const $89ac160dcbe6dfd3$var$WorkPeriodClocking = ({ workPeriod: workPeriod, clocking: clocking, isFirst: isFirst, isLast: isLast })=>{
    const isEnd = clocking._id === workPeriod.end.clocking?.item;
    let label = isFirst ? "Entr\xe9e" : isEnd ? 'Sortie' : "Interm\xe9diaire";
    if (workPeriod.clockingRules.break.clocked && !isFirst) {
        const indexOfBreakClocking = workPeriod.breaksClockings.findIndex((bc)=>bc.item === clocking._id);
        if (indexOfBreakClocking !== -1 && indexOfBreakClocking % 2 === 0) label = "D\xe9but pause";
        else if (indexOfBreakClocking !== -1) label = 'Fin pause';
    }
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        display: "inline-block",
        mr: 2,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "span",
                    children: [
                        label,
                        " \xe0\xa0",
                        (0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(clocking.date)
                    ]
                }),
                !isEnd && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$9ca09caa9c849d9c), {})
                        }),
                        isLast && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: "\xa0\xa0..."
                        })
                    ]
                })
            ]
        })
    });
};
var $89ac160dcbe6dfd3$export$2e2bcd8739ae039 = $89ac160dcbe6dfd3$var$WorkPeriodClockings;



parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");






/**
 * Form component for editing work period service
 * @param workPeriodId - The ID of the work period to update
 * @param missionId - The ID of the mission
 * @param initialServiceId - The initial service ID if editing
 */ const $fb00d2a73edc376d$var$WorkPeriodServiceForm = ({ workPeriod: workPeriod })=>{
    const updateMutation = (0, $7040c29cc25c4df6$export$cac0b33e6f13c8ec)();
    const servicesQuery = (0, $3d856666402e8eec$export$a870673e4b33fcfb)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            service: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.service) || ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.service) errors.service = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            const payload = {
                missionId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission),
                workPeriodId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod),
                service: values.service
            };
            updateMutation.mutate(payload);
        },
        children: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Affectation",
                        name: "service",
                        component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                        options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(servicesQuery.data || [])
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: updateMutation,
                        children: "Mettre \xe0 jour l'Affectation"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: updateMutation
                    })
                ]
            })
    });
};
var $fb00d2a73edc376d$export$2e2bcd8739ae039 = $fb00d2a73edc376d$var$WorkPeriodServiceForm;




var $3ZYaX = parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");




var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");






var $3ZYaX = parcelRequire("3ZYaX");


var $732b76d1350a1c02$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $732b76d1350a1c02$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $732b76d1350a1c02$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $732b76d1350a1c02$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $732b76d1350a1c02$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $732b76d1350a1c02$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $732b76d1350a1c02$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $732b76d1350a1c02$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $732b76d1350a1c02$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $73caaffdd544ad23$export$2e2bcd8739ae039)(_ref, $732b76d1350a1c02$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $36db34250d735787$export$39b482c5e57630a8) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $36db34250d735787$export$8b22cf2602fb60ce) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $3ZYaX.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $a837bdaa510c8cc6$export$7f8ddf7c7c20b3cd)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $3ZYaX.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $a748acfea1e72416$export$2e2bcd8739ae039)(propsOptions)) : [].concat((0, $a748acfea1e72416$export$2e2bcd8739ae039)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $3ZYaX.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $a837bdaa510c8cc6$export$96f57966bedc81b4)(isMulti, [].concat((0, $a748acfea1e72416$export$2e2bcd8739ae039)((0, $a837bdaa510c8cc6$export$7f8ddf7c7c20b3cd)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)((0, $8cf2596bd3c04d14$export$2e2bcd8739ae039)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}















parcelRequire("1rKN8");



var $897c60afbd2eb796$var$CreatableSelect = /*#__PURE__*/ (0, $3ZYaX.forwardRef)(function(props, ref) {
    var creatableProps = (0, $29c765b91408f8b0$export$3b14a55fb2447963)(props);
    var selectProps = (0, $732b76d1350a1c02$export$3b14a55fb2447963)(creatableProps);
    return /*#__PURE__*/ $3ZYaX.createElement((0, $36db34250d735787$export$25ce5a424b770e84), (0, $00dbdd82ffce5458$export$2e2bcd8739ae039)({
        ref: ref
    }, selectProps));
});
var $897c60afbd2eb796$export$2e2bcd8739ae039 = $897c60afbd2eb796$var$CreatableSelect;



const $f9f17b8c8768dfab$var$TextOption = (props)=>{
    props.innerProps['data-test'] = `${props.innerProps['data-test']}-${props.data.value}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a837bdaa510c8cc6$export$db3b6bfb95261072).Option, {
        ...props,
        children: props.data.label
    });
};
const $f9f17b8c8768dfab$var$ClearIndicator = (props)=>{
    props.innerProps['data-test'] = `${props.innerProps['data-test']}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a837bdaa510c8cc6$export$db3b6bfb95261072).ClearIndicator, {
        ...props
    });
};
const $f9f17b8c8768dfab$var$addDataTest = (Component, innerProps)=>(props)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(Component, {
            ...props,
            innerProps: Object.assign({}, props.innerProps, innerProps)
        });
/**
 * Multi-select field with ability to create new options
 * Extends MultiSelectField with creatable functionality
 */ const $f9f17b8c8768dfab$var$MultiSelectCreatableField = (props)=>{
    const { field: field, form: form, options: options, help: help, onCreateOption: onCreateOption, isLoading: isLoading, selectRef: selectRef, isMulti: isMulti = true, ...rest } = props;
    const { required: required, disabled: isDisabled } = rest;
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (isMulti) return (field.value || []).map((v)=>options.find((o)=>o.value === v)).filter(Boolean);
        else // Single select mode
        return options.find((o)=>o.value === field.value) || null;
    }, [
        options,
        field.value,
        isMulti
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: props.label,
        error: form.errors[field.name],
        required: required,
        help: help,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $897c60afbd2eb796$export$2e2bcd8739ae039), {
            ref: selectRef,
            value: value,
            isMulti: isMulti,
            name: field.name,
            options: options,
            className: "basic-multi-select",
            classNamePrefix: "select",
            placeholder: isMulti ? "Choisir ou cr\xe9er des cat\xe9gories..." : "Choisir ou cr\xe9er une cat\xe9gorie...",
            id: `multi-select-creatable-${field.name}`,
            components: {
                Option: $f9f17b8c8768dfab$var$addDataTest($f9f17b8c8768dfab$var$TextOption, {
                    'data-test': `multi-select-option-${field.name}`
                }),
                ClearIndicator: $f9f17b8c8768dfab$var$addDataTest($f9f17b8c8768dfab$var$ClearIndicator, {
                    'data-test': `multi-select-clear-${field.name}`
                })
            },
            closeMenuOnSelect: !isMulti,
            onInputChange: (value)=>{
                if (props.inputFieldName) form.setFieldValue(props.inputFieldName, value);
                if (props.onInputChange) props.onInputChange(value);
            },
            filterOption: props.disableDefaultFilter ? ()=>true : undefined,
            onChange: (v)=>{
                if (isMulti) form.setFieldValue(field.name, v.map((i)=>i.value));
                else form.setFieldValue(field.name, v?.value || '');
            },
            onCreateOption: onCreateOption,
            classNames: {
                control: (state)=>state.hasValue ? 'is-not-empty' : 'is-empty'
            },
            isDisabled: isDisabled,
            isLoading: isLoading,
            formatCreateLabel: (inputValue)=>`Cr\xe9er "${inputValue}"`,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                menu: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body,
            ...rest
        })
    });
};
var $f9f17b8c8768dfab$export$2e2bcd8739ae039 = $f9f17b8c8768dfab$var$MultiSelectCreatableField;







const $a46f3ef3dc3a3232$export$843a2267b6e7d6ef = (newTagName, availableTags, threshold = 0.8)=>{
    const normalizedNewTag = newTagName.toLowerCase().trim();
    for (const tag of availableTags){
        const normalizedExistingTag = tag.name.toLowerCase().trim();
        const similarity = (0, $45f4984a8ab83b0b$export$2e2bcd8739ae039).cosine.similarity(normalizedNewTag, normalizedExistingTag);
        if (similarity >= threshold) return {
            similarTag: tag.name,
            similarity: Math.round(similarity * 100)
        };
    }
    return null;
};
const $a46f3ef3dc3a3232$export$79c5cf584cfa640f = (tags)=>{
    return tags.map((tag)=>({
            value: tag._id,
            label: tag.name
        }));
};
const $a46f3ef3dc3a3232$export$22be11368b300b4f = ()=>{
    const errors = {};
    // Add validation logic if needed
    return errors;
};
const $a46f3ef3dc3a3232$export$20f763fbf05d142a = (inputValue, availableTags, onConfirmationNeeded, onFocusOut)=>{
    if (!inputValue.trim()) return;
    const trimmedValue = inputValue.trim();
    const similarityCheck = $a46f3ef3dc3a3232$export$843a2267b6e7d6ef(trimmedValue, availableTags);
    // Focus out du champ
    onFocusOut();
    // Afficher une confirmation même si pas de similarité
    onConfirmationNeeded({
        newTag: trimmedValue,
        similarTagWarning: similarityCheck ? {
            newTag: trimmedValue,
            similarTag: similarityCheck.similarTag,
            similarity: similarityCheck.similarity
        } : undefined
    });
};
const $a46f3ef3dc3a3232$export$d08a879951e959cc = (mission, startDate, endDate)=>{
    const workPeriodsInRange = (0, $3e6d8a4591828c3c$export$772cd301688dff26)(mission, startDate, endDate);
    return workPeriodsInRange.filter((w)=>w.__actions.canBeUpdated).map((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665));
};



parcelRequire("3ZYaX");

/**
 * Component for displaying tag creation confirmation or similarity warning
 * Shows a warning when a similar tag exists, or a confirmation when creating a new tag
 */ const $a5ad73a971003ca5$var$CreateTagConfirmationComponent = ({ createTagConfirmation: createTagConfirmation, isLoading: isLoading, onCancel: onCancel, onConfirmCreate: onConfirmCreate })=>{
    const { similarTagWarning: similarTagWarning } = createTagConfirmation || {};
    // Render warning message for similar tags
    if (similarTagWarning) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
        color: "warning",
        mt: 3,
        "data-test": "create-similar-tag-confirmation-message",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                            children: "Attention :"
                        }),
                        ' Le tag "',
                        similarTagWarning.newTag,
                        '" est tr\xe8s similaire au tag existant "',
                        similarTagWarning.similarTag,
                        '".'
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    children: "Voulez-vous vraiment cr\xe9er ce nouveau tag ?"
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "light",
                            onClick: onCancel,
                            mr: 2,
                            "data-test": "create-tag-confirmation-cancel-button",
                            children: "Annuler"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "warning",
                            type: "button",
                            onClick: onConfirmCreate,
                            loading: isLoading,
                            "data-test": "create-tag-confirmation-button",
                            children: "Cr\xe9er quand m\xeame"
                        })
                    ]
                })
            ]
        })
    });
    // Render confirmation message for new tags
    if (createTagConfirmation) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
        color: "info",
        mt: 3,
        "data-test": "create-tag-confirmation-message",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        'Voulez-vous cr\xe9er le nouveau tag "',
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "strong",
                            children: createTagConfirmation.newTag
                        }),
                        '" ?'
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "light",
                            onClick: onCancel,
                            mr: 2,
                            "data-test": "create-tag-confirmation-cancel-button",
                            children: "Annuler"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "primary",
                            type: "button",
                            onClick: onConfirmCreate,
                            loading: isLoading,
                            "data-test": "create-tag-confirmation-button",
                            children: "Cr\xe9er le tag"
                        })
                    ]
                })
            ]
        })
    });
    // Return null if no confirmation or warning is needed
    return null;
};
var $a5ad73a971003ca5$export$2e2bcd8739ae039 = $a5ad73a971003ca5$var$CreateTagConfirmationComponent;




/**
 * Form component for applying tags to multiple work periods in a date range
 * Allows adding tags one by one and applying them to multiple work periods
 */ const $473b826693cc4a98$var$ApplyTagsToMultipleForm = ({ tags: tags, onSubmit: onSubmit, onCancel: onCancel, defaultFormDate: defaultFormDate, defaultToDate: defaultToDate, minDate: minDate, maxDate: maxDate, dateRange: dateRange })=>{
    const addTagsToWorkPeriodsMutation = (0, $7040c29cc25c4df6$export$f0a10b473a0614fd)();
    const createTagMutation = (0, $b9e4dc58c86ce67a$export$a25726670bb41cb)();
    const { data: tagsData, isLoading: isLoadingTags } = (0, $b9e4dc58c86ce67a$export$9a06e401dcb665a)();
    const selectRef = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useRef(null);
    const [createTagConfirmation, setCreateTagConfirmation] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const [addedTags, setAddedTags] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        addedTagIds: tags || []
    });
    const availableTags = tagsData || [];
    /**
   * Handle adding a tag to the session list
   */ const handleAddTag = (tag)=>{
        if (!addedTags.addedTagIds.find((t)=>t._id === tag._id)) setAddedTags((prev)=>({
                addedTagIds: [
                    ...prev.addedTagIds,
                    tag
                ]
            }));
    };
    /**
   * Handle removing a tag from the session list
   */ const handleRemoveTag = (tag)=>{
        setAddedTags((prev)=>({
                addedTagIds: prev.addedTagIds.filter((t)=>t._id !== tag._id)
            }));
    };
    /**
   * Handle tag selection/creation
   */ const handleTagSelect = async (values, setFieldValue)=>{
        if (!values.tagToApply) return;
        // Handle both string and object values from MultiSelectCreatableField
        const tagValue = typeof values.tagToApply === 'string' ? values.tagToApply : values.tagToApply.value || values.tagToApply;
        const selectedTag = availableTags.find((tag)=>tag._id === tagValue);
        if (selectedTag) {
            // Existing tag selected
            handleAddTag(selectedTag);
            setFieldValue('tagToApply', '') // Clear the field
            ;
        } else // New tag creation needed
        (0, $a46f3ef3dc3a3232$export$20f763fbf05d142a)(typeof tagValue === 'string' ? tagValue : tagValue.value, availableTags, setCreateTagConfirmation, ()=>selectRef.current?.blur());
    };
    /**
   * Handle form submission - apply all session tags to selected work periods
   */ const handleSubmit = async (values)=>{
        onSubmit({
            form: values.applyToOthersDateFrom ? (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(values.applyToOthersDateFrom)) : (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()),
            to: values.applyToOthersDateTo ? (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(new Date(values.applyToOthersDateTo)) : (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(new Date()),
            tags: addedTags.addedTagIds
        });
    };
    /**
   * Handle creation of a new tag with similarity check
   */ const handleCreateTag = async (inputValue)=>{
        (0, $a46f3ef3dc3a3232$export$20f763fbf05d142a)(inputValue, availableTags, setCreateTagConfirmation, ()=>selectRef.current?.blur());
    };
    /**
   * Confirm creation of new tag
   */ const confirmCreateTag = async ()=>{
        if (!createTagConfirmation) return;
        createTagMutation.mutate({
            name: createTagConfirmation.newTag
        }, {
            onSuccess: (response)=>{
                const newTag = response.data;
                handleAddTag(newTag);
                setCreateTagConfirmation(null);
                selectRef.current?.blur();
                (0, $b9e4dc58c86ce67a$export$ae1bb9b0051ee212)();
            }
        });
    };
    const initialValues = {
        tagToApply: '',
        applyToOthersDateFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(defaultFormDate || new Date())),
        applyToOthersDateTo: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(defaultToDate || new Date()))
    };
    const tagOptions = (0, $a46f3ef3dc3a3232$export$79c5cf584cfa640f)(availableTags);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        mb: 5,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
            initialValues: initialValues,
            onSubmit: handleSubmit,
            validate: ()=>{
                const errors = {};
                return errors;
            },
            children: ({ values: values, setFieldValue: setFieldValue, isValid: isValid })=>{
                const workPeriodsIds = values.applyToOthersDateFrom && values.applyToOthersDateTo && dateRange ? `${(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(new Date(values.applyToOthersDateFrom))} - ${(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(new Date(values.applyToOthersDateTo))}` : '';
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                    children: [
                        addedTags.addedTagIds.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 3,
                            "data-test": "tags-to-add",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 2,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "Cat\xe9gorie(s) \xe0 ajouter :"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                    children: addedTags.addedTagIds.map((tag)=>{
                                        return tag ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tag), {
                                            size: "medium",
                                            children: [
                                                tag.name,
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    size: "small",
                                                    color: "ghost",
                                                    onClick: ()=>handleRemoveTag(tag),
                                                    pr: 1,
                                                    children: "\xd7"
                                                })
                                            ]
                                        }, tag._id) : null;
                                    })
                                })
                            ]
                        }),
                        !createTagConfirmation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "Ajouter une cat\xe9gorie",
                                        name: "tagToApply",
                                        component: (0, $f9f17b8c8768dfab$export$2e2bcd8739ae039),
                                        options: tagOptions,
                                        isMulti: false,
                                        onCreateOption: (inputValue)=>handleCreateTag(inputValue),
                                        isLoading: isLoadingTags || createTagMutation.isLoading,
                                        selectRef: selectRef,
                                        help: "S\xe9lectionnez une cat\xe9gorie existante ou cr\xe9ez-en une nouvelle en tapant son nom",
                                        onChange: (value)=>{
                                            if (value) {
                                                const tagValue = typeof value === 'string' ? value : value.value;
                                                handleTagSelect({
                                                    ...values,
                                                    tagToApply: tagValue
                                                }, setFieldValue);
                                            }
                                        }
                                    })
                                }),
                                dateRange && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: "applyToOthersDateFrom",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                label: "Du",
                                                type: "date",
                                                min: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(minDate || new Date()),
                                                max: values.applyToOthersDateTo || (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(maxDate || new Date())
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: "applyToOthersDateTo",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                label: "Au",
                                                type: "date",
                                                min: values.applyToOthersDateFrom || (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(minDate || new Date()),
                                                max: maxDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(maxDate) : undefined
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        values.applyToOthersDateFrom && values.applyToOthersDateTo && dateRange && !createTagConfirmation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 2,
                            children: (()=>{
                                const startDate = new Date(values.applyToOthersDateFrom);
                                const endDate = new Date(values.applyToOthersDateTo);
                                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                    color: "info",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: dateRange ? `${(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(startDate)} - ${(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(endDate)}` : ''
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                            " Les cat\xe9goies peuvent \xeatre appliqu\xe9es uniquement \xe0 des journ\xe9es de travail non valid\xe9es."
                                        ]
                                    })
                                });
                            })()
                        }),
                        createTagConfirmation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a5ad73a971003ca5$export$2e2bcd8739ae039), {
                            createTagConfirmation: createTagConfirmation,
                            isLoading: createTagMutation.isLoading,
                            onCancel: ()=>{
                                setCreateTagConfirmation(null);
                            },
                            onConfirmCreate: confirmCreateTag
                        }),
                        !createTagConfirmation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            justifyContent: "flex-end",
                            mt: 4,
                            children: [
                                onCancel && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    color: "light",
                                    onClick: onCancel,
                                    mr: 2,
                                    children: "Annuler"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                    color: "primary",
                                    type: "submit",
                                    disabled: !isValid || workPeriodsIds.length === 0 && dateRange || addedTags.addedTagIds.length === 0,
                                    isLoading: addTagsToWorkPeriodsMutation.isLoading,
                                    "data-test": "submit-add-tags-to-work-periods",
                                    children: "Ajouter"
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
var $473b826693cc4a98$export$2e2bcd8739ae039 = $473b826693cc4a98$var$ApplyTagsToMultipleForm;





/**
 * Component to display work period tags
 * Shows tags in a Tag.Group with info color and medium size
 * Displays "Aucun tag" when no tags are present
 * When isEditable=true, shows an edit button and allows tag deletion with confirmation
 * Manages the edit modal internally when isEditable is true
 */ const $6fc203fc1bcc1621$var$WorkPeriodTags = ({ tags: tags, isEditable: isEditable = false, onTagDelete: onTagDelete, formProps: formProps, size: size = 'medium', hideEmptyMessage: hideEmptyMessage = false })=>{
    const [pendingDeleteTagId, setPendingDeleteTagId] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const [hoveredTagId, setHoveredTagId] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const editTagsModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const hasTags = tags.length > 0;
    const canDeleteTags = isEditable && onTagDelete;
    const handleEditClick = ()=>{
        if (isEditable) editTagsModal.setIsDisplayed(true);
    };
    /**
   * Handle form cancellation - close the modal
   */ const handleCancel = ()=>{
        editTagsModal.setIsDisplayed(false);
    };
    const handleTagClick = (tagId)=>{
        if (!canDeleteTags) return;
        if (pendingDeleteTagId === tagId) {
            // Second click: confirm deletion
            onTagDelete?.(tagId);
            setPendingDeleteTagId(null);
        } else // First click: show confirmation
        setPendingDeleteTagId(tagId);
    };
    // Reset pending delete when clicking outside
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        const handleClickOutside = ()=>{
            setPendingDeleteTagId(null);
        };
        if (pendingDeleteTagId) {
            document.addEventListener('click', handleClickOutside);
            return ()=>document.removeEventListener('click', handleClickOutside);
        }
        return undefined;
    }, [
        pendingDeleteTagId
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        style: {
            position: 'relative',
            display: 'inline-block'
        },
        "data-test": "work-period-tags-container",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tag).Group, {
                children: [
                    !hasTags && !hideEmptyMessage && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                        textColor: "grey",
                        size: size,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    size: "small",
                                    mt: 1,
                                    mr: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textColor: "grey",
                                    renderAs: "i",
                                    children: "Aucune cat\xe9gorie"
                                })
                            ]
                        })
                    }),
                    hasTags && tags.map((tag)=>{
                        const isPendingDelete = pendingDeleteTagId === tag._id;
                        const isHovered = hoveredTagId === tag._id && canDeleteTags && !isPendingDelete;
                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                            size: size,
                            color: isPendingDelete ? 'danger' : undefined,
                            style: {
                                cursor: canDeleteTags ? 'pointer' : 'default',
                                opacity: isPendingDelete ? 0.7 : 1,
                                transition: 'background-color 0.2s'
                            },
                            onClick: (e)=>{
                                e.stopPropagation();
                                handleTagClick(tag._id);
                            },
                            onMouseEnter: ()=>setHoveredTagId(tag._id),
                            onMouseLeave: ()=>setHoveredTagId(null),
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    isHovered && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        size: "small",
                                        mt: 1,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1ae95d1a7411cb7b), {})
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        size: "small",
                                        mt: 1,
                                        mr: 1,
                                        children: isPendingDelete ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1ae95d1a7411cb7b), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1b490aa7069a487b), {})
                                    }),
                                    isPendingDelete ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "i",
                                            children: [
                                                "Cliquer pour confirmer la suppression de",
                                                ' ',
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    renderAs: "strong",
                                                    textColor: "black",
                                                    children: tag.name
                                                })
                                            ]
                                        })
                                    }) : tag.name
                                ]
                            })
                        }, tag._id);
                    }),
                    isEditable && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "medium",
                        color: "ghost",
                        textSize: 7,
                        py: 4,
                        onClick: handleEditClick,
                        style: {
                            cursor: 'pointer'
                        },
                        textColor: "link",
                        "data-test": "work-period-add-tags-button",
                        type: "button",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    size: "small",
                                    mt: 1,
                                    mr: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "i",
                                    children: "Ajouter"
                                })
                            ]
                        })
                    })
                ]
            }),
            isEditable && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                title: "Ajouter des cat\xe9gories",
                actions: editTagsModal,
                maxWidth: 600,
                children: editTagsModal.isDisplayed && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $473b826693cc4a98$export$2e2bcd8739ae039), {
                    ...formProps,
                    tags: tags,
                    onSubmit: (params)=>{
                        formProps?.onSubmit(params);
                        editTagsModal.setIsDisplayed(false);
                    },
                    onCancel: handleCancel
                })
            })
        ]
    });
};
var $6fc203fc1bcc1621$export$2e2bcd8739ae039 = $6fc203fc1bcc1621$var$WorkPeriodTags;





var $3ZYaX = parcelRequire("3ZYaX");




/** Size of the nav range in weeks; aligned to week boundaries so same week = same query = cache hit. */ const $a6175159f583f497$var$NAV_RANGE_WEEKS = 1;
function $a6175159f583f497$export$aa95277ea19d859d(missionId, workPeriod, workPeriodId) {
    const navDateRange = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!workPeriod) return undefined;
        const date = new Date(workPeriod.start.date);
        const blockStart = (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)((0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(date, $a6175159f583f497$var$NAV_RANGE_WEEKS));
        const blockEnd = (0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)((0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(date, $a6175159f583f497$var$NAV_RANGE_WEEKS));
        return {
            start: blockStart,
            end: blockEnd
        };
    // Dependency on block start time so same week = same range = same query key (cache hit)
    }, [
        workPeriod ? (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(new Date(workPeriod.start.date)).getTime() : undefined
    ]);
    const { data: workPeriodsForNav } = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)(missionId && navDateRange ? {
        mission: missionId,
        start: navDateRange.start,
        end: navDateRange.end
    } : undefined, {
        enabled: Boolean(missionId && navDateRange)
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!workPeriodsForNav || !workPeriodId) return {
            previousWorkPeriod: undefined,
            nextWorkPeriod: undefined
        };
        return {
            previousWorkPeriod: (0, $3e6d8a4591828c3c$export$afa4ebc2747d812f)(workPeriodsForNav, workPeriodId),
            nextWorkPeriod: (0, $3e6d8a4591828c3c$export$a6586751c389f696)(workPeriodsForNav, workPeriodId)
        };
    }, [
        workPeriodsForNav,
        workPeriodId
    ]);
}


const $27fe9c3618eab2a3$var$WorkPeriodDetails = ()=>{
    //Get mission and work period
    const { missionId: missionId, workPeriodId: workPeriodId } = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)();
    const { data: workPeriod, status: status } = (0, $7040c29cc25c4df6$export$3886f9d4f8d33b01)(workPeriodId, {
        summary: true
    });
    const { data: mission } = (0, $e409591b67738e56$export$8940e75313b372c9)(missionId);
    const editServiceModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const updateTagsMutation = (0, $7040c29cc25c4df6$export$3bdf6f6f236d25ce)();
    const addTagsToWorkPeriodsMutation = (0, $7040c29cc25c4df6$export$f0a10b473a0614fd)();
    const [showClockingRules, setShowClockingRules] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const { previousWorkPeriod: previousWorkPeriod, nextWorkPeriod: nextWorkPeriod } = (0, $a6175159f583f497$export$aa95277ea19d859d)(missionId, workPeriod ?? undefined, workPeriodId);
    const breadcrumbs = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: "R\xe9capitulatif",
                to: '/summary'
            },
            {
                label: "Journ\xe9e de travail"
            }
        ], []);
    if (!workPeriod && !mission && status !== 'loading') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4fe9b4e9d5785309$export$2e2bcd8739ae039), {});
    else if (!workPeriod || !mission) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                breakpoint: "widescreen",
                max: true,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                    items: breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                style: {
                                    minWidth: 250
                                },
                                display: "block",
                                align: "right",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7e0e62be69635d53$export$e91bd532fd89cdb4), {
                                    missionId: missionId,
                                    previousWorkPeriod: previousWorkPeriod,
                                    nextWorkPeriod: nextWorkPeriod
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "flex-start",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $898c03e80810a32a$export$2e2bcd8739ae039), {
                                            workPeriod: workPeriod,
                                            onServiceEdit: (0, $8403deec6a28521e$export$6025088343704f9f)([
                                                {
                                                    role: 'employerMember',
                                                    action: {
                                                        resource: 'missions',
                                                        name: 'updateWorkPeriod'
                                                    }
                                                }
                                            ]) && workPeriod.__actions.canBeUpdated ? ()=>{
                                                editServiceModal.setIsDisplayed(true);
                                            } : undefined
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'employerMember'
                                        ],
                                        action: {
                                            resource: 'missions',
                                            name: 'updateWorkPeriod'
                                        },
                                        children: workPeriodId && missionId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                                            actions: editServiceModal,
                                            title: "Modifier l'affectation de la journ\xe9e de travail",
                                            dataTest: "work-period-edit-service-modal",
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                        mb: 2,
                                                        children: [
                                                            "Vous pouvez modifier l'affectation de la journ\xe9e de travail. ",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                            "L'affectation li\xe9e \xe0 la mission et aux autres journ\xe9es de travail de la mission seront conserv\xe9es."
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fb00d2a73edc376d$export$2e2bcd8739ae039), {
                                                        workPeriod: workPeriod
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                align: "right",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2b10bcffad1c8580$export$2e2bcd8739ae039), {
                                        workPeriod: workPeriod,
                                        type: "tag"
                                    })
                                })
                            })
                        ]
                    }),
                    mission && workPeriod && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 5,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 4,
                                children: "Horaire de la Journ\xe9e de Travail"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                mb: 2,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c31e4eb09f1e0bff$export$2e2bcd8739ae039), {
                                        workPeriod: workPeriod,
                                        disabled: !workPeriod.__actions.canBeManualClocked
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textAlign: 'right',
                                mt: 2,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                    to: `/missions/${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission)}`,
                                    children: "Voir la mission"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        size: 4,
                                        mt: 2,
                                        mb: 1,
                                        children: "Cat\xe9gories"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                        mt: 2,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fc203fc1bcc1621$export$2e2bcd8739ae039), {
                                            tags: workPeriod?.tags || [],
                                            formProps: {
                                                onSubmit: async (params)=>{
                                                    addTagsToWorkPeriodsMutation.mutate({
                                                        missionId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriod.mission),
                                                        from: params.form,
                                                        to: params.to,
                                                        tags: params.tags.map((tag)=>tag._id)
                                                    });
                                                },
                                                onCancel: ()=>{},
                                                defaultFormDate: new Date(workPeriod.start.date),
                                                defaultToDate: new Date(workPeriod.end.date),
                                                minDate: new Date(workPeriod.mission.start),
                                                maxDate: workPeriod.mission.end ? new Date(workPeriod.mission.end) : undefined,
                                                dateRange: true
                                            },
                                            isEditable: workPeriod.__actions.canBeUpdated,
                                            onTagDelete: (tagId)=>{
                                                if (workPeriod) {
                                                    const currentTagIds = workPeriod.tags?.map((tag)=>tag._id) || [];
                                                    const updatedTagIds = currentTagIds.filter((id)=>id !== tagId);
                                                    updateTagsMutation.mutate({
                                                        workPeriodId: workPeriod._id,
                                                        tags: updatedTagIds
                                                    });
                                                }
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                action: {
                                    resource: 'missions',
                                    name: 'updateWorkPeriodEvents'
                                },
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 5,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                            size: 4,
                                            children: "\xc9v\xe8nements"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6387a60f69cec18b$export$2e2bcd8739ae039), {
                                                    mission: mission,
                                                    workPeriod: workPeriod,
                                                    disabled: !workPeriod.__actions.canBeUpdated
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 4,
                                mt: 2,
                                children: "Pointages"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                mb: 2,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: workPeriod.start.clocking ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $89ac160dcbe6dfd3$export$2e2bcd8739ae039), {
                                                workPeriod: workPeriod
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                textColor: "grey",
                                                children: "Aucun pointage"
                                            })
                                        }),
                                        showClockingRules && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            mt: 3,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    renderAs: "hr",
                                                    mb: 4
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                                    size: 6,
                                                                    mb: 1,
                                                                    children: "Entr\xe9e"
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                                                                    clockingRules: workPeriod.clockingRules,
                                                                    type: "start"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                                    size: 6,
                                                                    mb: 1,
                                                                    children: "Sortie"
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                                                                    clockingRules: workPeriod.clockingRules,
                                                                    type: "end"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                                    size: 6,
                                                                    mb: 1,
                                                                    children: "Pauses"
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $239d0c4f69d06a71$export$2e2bcd8739ae039), {
                                                                    clockingRules: workPeriod.clockingRules
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textAlign: 'right',
                                style: {
                                    cursor: 'pointer'
                                },
                                textColor: "link",
                                "data-test": "show-clocking-rules-button",
                                onClick: ()=>{
                                    setShowClockingRules(!showClockingRules);
                                },
                                children: showClockingRules ? "Masquer la r\xe8gle de pointage" : "Afficher la r\xe8gle de pointage"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 5,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 4,
                                children: "Actions"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cf16adc16c4b6005$export$2e2bcd8739ae039), {
                                            mission: mission,
                                            workPeriod: workPeriod
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $27fe9c3618eab2a3$export$2e2bcd8739ae039 = $27fe9c3618eab2a3$var$WorkPeriodDetails;




var $3ZYaX = parcelRequire("3ZYaX");






const $d4dff6d6beed9e8a$export$3988ae62b71be9a3 = async ()=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/config`,
        method: 'get'
    });


const $ce5c6fedccfb7858$export$a8f49489fd1f338f = ()=>(0, $407df0c050c02c45$export$dd0a697e1782aedd)([
        'app-config',
        'get'
    ], async ()=>(0, $d4dff6d6beed9e8a$export$3988ae62b71be9a3)(), {
        staleTime: 600000
    });



const $159097eb2ce85c11$var$useUserLegalConditionsVersionsStatus = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const { data: config } = (0, $ce5c6fedccfb7858$export$a8f49489fd1f338f)();
    const getStatus = (userValue, configValue)=>!userValue || !configValue || userValue === configValue ? 'upToDate' : 'outdated';
    return {
        termsOfUse: getStatus(currentUser?.lastTermsOfUseVersionRead, config?.versions.termsOfUse),
        privacyPolicy: getStatus(currentUser?.lastPrivacyPolicyVersionRead, config?.versions.privacyPolicy)
    };
};
var $159097eb2ce85c11$export$2e2bcd8739ae039 = $159097eb2ce85c11$var$useUserLegalConditionsVersionsStatus;





var $3ZYaX = parcelRequire("3ZYaX");

const $2cbc32d0015d2986$var$useSoftReload = ()=>{
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback((path)=>{
        if (!path) path = location.pathname;
        navigate(path);
        navigate(0);
    }, [
        location.pathname,
        navigate
    ]);
};
var $2cbc32d0015d2986$export$2e2bcd8739ae039 = $2cbc32d0015d2986$var$useSoftReload;


const $cb3505f3ee5948df$var$Authenticated = ({ children: children, roles: roles, action: action, organizationOptions: organizationOptions })=>{
    const softReload = (0, $2cbc32d0015d2986$export$2e2bcd8739ae039)();
    const legalConditionsStatus = (0, $159097eb2ce85c11$export$2e2bcd8739ae039)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const [isAuthenticated, currentUserRole, currentOrganization, currentUser] = (0, $d6640a748633e476$export$2e2bcd8739ae039)(({ session: session })=>[
            session.isAuthenticated,
            session.currentUserRole,
            session.currentOrganization,
            session.currentUser
        ], (0, $b46b478a1bec4671$exports.shallow));
    //Reload app when current user role change (change of profile, organization, login as...)
    const firstRender = (0, $ad8d7b81ff84d54a$export$c5623aa1c38918b6)();
    (0, $3ZYaX.useEffect)(()=>{
        if (!firstRender) softReload('/');
    }, [
        currentUserRole,
        currentOrganization?._id
    ]);
    // Listen session data to check if current user can access to current route
    if (!isAuthenticated) {
        if (location.pathname.includes('/kiosk')) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
            to: "/login?redirect=/kiosk",
            state: {
                isKioskLogin: true,
                message: {
                    color: 'warning',
                    header: "Cr\xe9ation d'une Borne de Scan",
                    body: "Connectez-vous en tant qu'Employeur pour bloquer cet appareil comme Borne de Scan"
                }
            }
        });
        else {
            if (location.pathname.includes('/login')) return children;
            else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
                to: "/login"
            });
        }
    }
    // User is authenticated !
    //Redirect to privacy policy page when user has not yet accepted the latest version
    if (legalConditionsStatus.privacyPolicy === 'outdated') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/privacy-policy"
    });
    //Redirect to privacy policy page when user has not yet accepted the latest version
    if (legalConditionsStatus.termsOfUse === 'outdated') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/terms-of-use"
    });
    //Redirect to / when current user is authenticated but does not have the authorized role to access the current route
    if (roles && (0, $8403deec6a28521e$export$3b37f8ef36140010)(roles, action)) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/"
    });
    if (organizationOptions && !(0, $194abd50ec8a5014$export$4d17dfdb53784ff6)(organizationOptions)) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/"
    });
    if (currentUserRole === 'guest') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/errors/no-active-role"
    });
    //@ts-expect-error fix appAccess types...
    if (currentUser?.appAccess === 'system') {
        const path = location.pathname;
        if (!path.includes('/laser-scanner') && !path.includes('/qr-scanner') && !path.includes('/kiosk')) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
            to: "/kiosk"
        });
    }
    // All is ok
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: currentUser && children
    });
};
var $cb3505f3ee5948df$export$2e2bcd8739ae039 = $cb3505f3ee5948df$var$Authenticated;




var $3ZYaX = parcelRequire("3ZYaX");


const $022fb11b099c3478$var$Guest = ({ children: children })=>{
    const isAuthenticated = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.isAuthenticated);
    const [searchParams] = (0, $d7b8f401c6bc9326$export$f1a78c17382fe22a)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const redirect = searchParams.get('redirect');
    // Listen session data to check if current user can access to current route
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        //Redirect to / if current user is authenticated
        if (isAuthenticated) {
            if (redirect) navigate(redirect);
            else navigate('/');
        }
    }, [
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: children
    });
};
var $022fb11b099c3478$export$2e2bcd8739ae039 = $022fb11b099c3478$var$Guest;



parcelRequire("3ZYaX");








const $dfd33536f4faad9d$var$WorkerDashboard = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const pendingInvitationsCount = (0, $8cf00e93f034ffc8$export$160ed609bc8ffc2b)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Section), {
            children: [
                pendingInvitationsCount > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    mb: 5,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                        color: 'worker',
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                                children: "Invitations en attente"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "p",
                                        mb: 3,
                                        textColor: "dark",
                                        children: "Vous avez une ou plusieurs invitations en attente de validation"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        renderAs: (0, $d7b8f401c6bc9326$export$b0d92dbee9b5b60d),
                                        to: "/me/organizations",
                                        children: "Voir les invitations"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Left, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "span",
                                                textWeight: "light",
                                                children: [
                                                    "Bonjour",
                                                    ' '
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "span",
                                                textWeight: "bold",
                                                children: [
                                                    currentUser?.firstName,
                                                    " ",
                                                    currentUser?.lastName
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        subtitle: true,
                                        spaced: true,
                                        children: "Installez et connectez-vous via l'app mobile :"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button).Group, {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                renderAs: "a",
                                                href: (0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039).mobileApps.apple.store.url,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        size: 'large',
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6940787f97640fd), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                        children: "Apple Store"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                renderAs: "a",
                                                href: (0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039).mobileApps.apple.store.url,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        size: 'large',
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ab2f0aaabb79022e), {})
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                        children: "Android Store"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                text: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {})
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $dfd33536f4faad9d$export$2e2bcd8739ae039 = $dfd33536f4faad9d$var$WorkerDashboard;






var $3ZYaX = parcelRequire("3ZYaX");








const $f71d69d0ae36cfc9$var$EmployersList = ()=>{
    const employersQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        sort: 'name',
        type: 'employer'
    });
    const tableColumns = $f71d69d0ae36cfc9$var$useListTableColumns(employersQuery.data || []);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Liste des Employeurs"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Left, {}),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                children: "\xa0"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                                        to: "/employers/new",
                                                        outlined: true,
                                                        color: "primary",
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a6ba75b56dc677fb$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                                children: "Nouvel Employeur"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {})
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                            columns: tableColumns,
                            data: employersQuery.data || [],
                            noDataMessage: "Aucune soci\xe9t\xe9 \xe0 afficher"
                        })
                    ]
                })
            })
        ]
    });
};
var $f71d69d0ae36cfc9$export$2e2bcd8739ae039 = $f71d69d0ae36cfc9$var$EmployersList;
const $f71d69d0ae36cfc9$var$useListTableColumns = (organizations)=>{
    const loginAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.loginAs);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/employers/${organization._id}/info`,
                        children: organization.name
                    });
                }
            },
            {
                Header: '',
                accessor: 'loginAs',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        onClick: ()=>loginAs('employerMember', organization, 'admin'),
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4b2651edb550ad92$export$2e2bcd8739ae039), {})
                        })
                    });
                }
            }
        ], [
        organizations
    ]);
};




var $3ZYaX = parcelRequire("3ZYaX");










const $3276e789a859c4c6$var$AssociationsList = ()=>{
    const organizationsQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    });
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const tableColumns = $3276e789a859c4c6$var$useListTableColumns(organizationsQuery.data || [], currentOrganization);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Liste de mes Entreprises Utilisatrices partenaires"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                        columns: tableColumns,
                        data: (organizationsQuery.data || []).filter((organization)=>organization?.associations?.some((association)=>{
                                const interimAgency = association.interimAgency;
                                return currentOrganization && interimAgency._id === currentOrganization._id;
                            })),
                        noDataMessage: "Aucune EU \xe0 afficher"
                    })
                })
            })
        ]
    });
};
var $3276e789a859c4c6$export$2e2bcd8739ae039 = $3276e789a859c4c6$var$AssociationsList;
const $3276e789a859c4c6$var$useListTableColumns = (organizations, currentOrganization)=>{
    const getAssociation = (employer)=>{
        return employer.associations.find((association)=>{
            const interimAgency = association.interimAgency;
            return interimAgency._id === currentOrganization._id;
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return (0, $8403deec6a28521e$export$6025088343704f9f)([
                        'interimAgencyMember'
                    ]) ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/employers/${organization._id}/info`,
                        children: organization.name
                    }) : organization.name;
                }
            },
            {
                Header: "Statut de l'invitation",
                accessor: 'status',
                Cell: (data)=>{
                    const association = getAssociation(data.cell.row.original);
                    //TODO: refactor component and type
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                        role: association,
                        showDate: true
                    });
                }
            },
            {
                Header: "Invit\xe9 le",
                accessor: 'createdAt',
                Cell: (data)=>{
                    const association = getAssociation(data.cell.row.original);
                    return (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(association?.createdAt);
                }
            }
        ], [
        organizations
    ]);
};



parcelRequire("3ZYaX");






var $3ZYaX = parcelRequire("3ZYaX");


const $bfb5326f26f58717$export$444ac08f60757df7 = (worker, organization)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const targetOrganization = organization || currentOrganization;
    return (0, $3ZYaX.useMemo)(()=>{
        if (!worker || !targetOrganization) return {
            isInternalWorker: false,
            association: undefined
        };
        const association = (0, $25ffbf4bca475b04$export$91d1acdd7472079)(worker, targetOrganization);
        const isInternalWorker = Boolean(association);
        return {
            isInternalWorker: isInternalWorker,
            association: association
        };
    }, [
        worker,
        targetOrganization
    ]);
};




const $3bec4a3b5bb6331c$var$QrPrintPage = ()=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const { id: id } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)({
        idName: 'userId'
    });
    const { data: user } = (0, $e607e015ac40917d$export$1884facae6ee36d8)(id);
    const { isInternalWorker: isInternalWorker } = (0, $bfb5326f26f58717$export$444ac08f60757df7)(user);
    // A worker is external if the organization is an employer AND the worker is not internal
    const isExternalWorker = currentOrganization?.type === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer && !isInternalWorker;
    const qrCode = (0, $ca4535f1fdcf3410$export$2e2bcd8739ae039)(id, isExternalWorker, !user);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: qrCode && user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            className: "is-flex is-flex-direction-column is-align-items-flex-start",
            p: 5,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("img", {
                    "data-test": "user-qr-code",
                    src: `data:image/png;base64, ${qrCode}`,
                    style: {
                        maxWidth: 200,
                        maxHeight: 200
                    },
                    onLoad: ()=>window.print()
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    style: {
                        fontSize: 18
                    },
                    pl: 2,
                    children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user, {
                        hideOfflineInfo: true
                    })
                })
            ]
        })
    });
};
var $3bec4a3b5bb6331c$export$2e2bcd8739ae039 = $3bec4a3b5bb6331c$var$QrPrintPage;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");



/**
 * Composant réutilisable pour les en-têtes de page avec titre et bouton d'action optionnel
 * @param title - Titre de la page
 * @param onButtonClick - Fonction appelée lors du clic sur le bouton d'ajout
 * @param addButtonLabel - Texte du bouton d'ajout
 * @param ButtonIcon - Composant icône à afficher dans le bouton
 * @param help - Contenu d'aide à afficher dans une infobulle
 */ const $b3d69f70afbcca0d$var$SidebarContentTitle = ({ title: title, onButtonClick: onButtonClick, addButtonLabel: addButtonLabel, ButtonIcon: ButtonIcon, ActionButton: ActionButton, help: help, buttonDataTestId: buttonDataTestId })=>{
    const tooltipId = `help-tooltip-${title}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 4,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        style: {
                            marginBottom: 0
                        },
                        children: title
                    }),
                    help && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                ml: 2,
                                style: {
                                    cursor: 'help'
                                },
                                "data-tip": true,
                                "data-for": tooltipId,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $41a7a7521a465f27$export$2e2bcd8739ae039), {
                                    width: 20
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                                id: tooltipId,
                                effect: "solid",
                                place: "bottom",
                                className: "custom-tooltip-width",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: help
                                })
                            })
                        ]
                    })
                ]
            }),
            ActionButton,
            onButtonClick && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                color: "primary",
                onClick: onButtonClick,
                size: "small",
                "data-test": buttonDataTestId,
                children: [
                    ButtonIcon && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(ButtonIcon, {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: addButtonLabel
                    })
                ]
            })
        ]
    });
};
var $b3d69f70afbcca0d$export$2e2bcd8739ae039 = $b3d69f70afbcca0d$var$SidebarContentTitle;





var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");









const $50b2fafe80d774bf$export$3988ae62b71be9a3 = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/clocking-rules/${id}`,
        method: 'get',
        params: {
            sort: '-createdAt'
        }
    });
};
const $50b2fafe80d774bf$export$e7aa7bc5c1b3cfb3 = async ()=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/clocking-rules',
        method: 'get',
        params: {
            sort: 'name'
        }
    });
};
const $50b2fafe80d774bf$export$185802fd694ee1f5 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/clocking-rules',
        method: 'post',
        params: params
    });
};
const $50b2fafe80d774bf$export$722fbec263ad908a = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/clocking-rules/${params._id}`,
        method: 'put',
        params: params
    });
};


const $e8692bc7fe3a6d6c$export$4e261945e999792f = (//filters?: FetchClockingsParams,
options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('clocking-rules', (0, $50b2fafe80d774bf$export$e7aa7bc5c1b3cfb3), /* filters || */ {}, options);
const $e8692bc7fe3a6d6c$export$f84d30a4bcf4a548 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('clocking-rules', (0, $50b2fafe80d774bf$export$3988ae62b71be9a3), id, undefined, options);
const $e8692bc7fe3a6d6c$var$resourceQueryKey = 'clocking-rules';
const $e8692bc7fe3a6d6c$export$4a6f974b4208311 = ()=>[
        $e8692bc7fe3a6d6c$var$resourceQueryKey,
        'create'
    ];
const $e8692bc7fe3a6d6c$export$a6fe4df8bec26327 = ()=>[
        $e8692bc7fe3a6d6c$var$resourceQueryKey,
        'update'
    ];
const $e8692bc7fe3a6d6c$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $50b2fafe80d774bf$export$185802fd694ee1f5), {
        mutationKey: $e8692bc7fe3a6d6c$export$4a6f974b4208311(),
        onSuccess: ()=>{
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                $e8692bc7fe3a6d6c$var$resourceQueryKey
            ]);
        }
    });
const $e8692bc7fe3a6d6c$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $50b2fafe80d774bf$export$722fbec263ad908a), {
        mutationKey: $e8692bc7fe3a6d6c$export$a6fe4df8bec26327(),
        onSuccess: ()=>{
            (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
                $e8692bc7fe3a6d6c$var$resourceQueryKey
            ]);
        }
    });






var $2KSUA = parcelRequire("2KSUA");


const $beefaf9ffadbec4d$var$JobTitleForm = ({ jobTitle: jobTitle })=>{
    const createMutation = (0, $b5014031ea60dfe7$export$a25726670bb41cb)();
    const updateMutation = (0, $b5014031ea60dfe7$export$cac0b33e6f13c8ec)();
    const clockingRulesQuery = (0, $e8692bc7fe3a6d6c$export$4e261945e999792f)();
    const currentClockingRule = jobTitle && clockingRulesQuery.data?.find((c)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(c._id, jobTitle?.clockingRule));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: jobTitle ? {
            ...jobTitle,
            interimAgencySettings: undefined
        } : {
            name: '',
            description: '',
            complementaryInformations: '',
            clockingRule: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name) errors.name = 'Champ requis';
            if (!values.clockingRule) errors.clockingRule = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            jobTitle ? updateMutation.mutate({
                ...values,
                id: jobTitle._id.toString()
            }) : createMutation.mutate(values);
        },
        children: ({ values: values })=>{
            const clockingRules = values.clockingRule && clockingRulesQuery.data?.find && clockingRulesQuery.data.find((clockingRules)=>clockingRules._id === values.clockingRule);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 4,
                        mb: 5,
                        children: "Informations de base"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom ",
                        name: "name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        name: "description",
                        component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039),
                        label: "Description interne"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
                        label: "Informations compl\xe9mentaires pour les Travailleurs",
                        help: "Ces informations seront syst\xe9matiquement transmises aux Travailleurs recevant une mission pour ce M\xe9tier",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            name: "complementaryInformations",
                            component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 5,
                        mt: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 5,
                                mb: 5,
                                children: "Coefficients de main d'oeuvre"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "info",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: [
                                        "Les coefficients de main d'oeuvre sont g\xe9r\xe9s individuellement pour chaque agence d'int\xe9rim.",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        'Vous pouvez les configurer depuis la section "',
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                            href: "/settings/labor-costs-coefficients",
                                            children: "Coefficients Agences d'Int\xe9rim"
                                        }),
                                        '".'
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 5,
                        mt: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 5,
                                mb: 5,
                                children: "R\xe8gles de pointage"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: "clockingRule",
                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                options: clockingRulesQuery.data ? (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(clockingRulesQuery.data) : []
                            }),
                            clockingRules && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                        mb: 3,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    textWeight: "bold",
                                                    mb: 3,
                                                    children: "R\xe8gle \xe0 l'Entr\xe9e"
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                                                    clockingRules: clockingRules,
                                                    type: "start"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                        mb: 3,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    textWeight: "bold",
                                                    mb: 3,
                                                    children: "R\xe8gle \xe0 la Sortie"
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                                                    clockingRules: clockingRules,
                                                    type: "end"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    jobTitle && clockingRules && currentClockingRule && !(0, $2KSUA.isEqual)(values.clockingRule, jobTitle.clockingRule) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 4,
                                mt: 5,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            mr: 1,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {
                                                color: "red"
                                            })
                                        }),
                                        "Modification des journ\xe9es de travail en cours",
                                        ' '
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                                        color: "warning",
                                        p: 2,
                                        children: [
                                            "Vous avez modifi\xe9 la r\xe8gle de pointage du m\xe9tier",
                                            ' ',
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: jobTitle.name
                                            }),
                                            " (anciennement",
                                            ' ',
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: currentClockingRule.name
                                            }),
                                            ").",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                            "En s\xe9lectionnant une date, la nouvelle r\xe8gle de pointage (",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: clockingRules.name
                                            }),
                                            ") sera appliqu\xe9e \xe0 toutes les journ\xe9es de travail:",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                className: "content",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                            children: "Non valid\xe9es"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                            children: "Commen\xe7ant \xe0 partir de la date s\xe9lectionn\xe9e"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                children: "Sans date s\xe9lectionn\xe9e, la nouvelle r\xe8gle ne s'appliquera qu'aux futures missions. Les missions et journ\xe9es de travail existantes conserveront l'ancienne r\xe8gle."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        name: "updateExistingWorkPeriodsFrom",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "date",
                                        label: "Modifier les journ\xe9es de travail \xe0 partir du",
                                        help: "Si aucune date n'est choisie, aucune journ\xe9e de travail ne sera modifi\xe9e"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: updateMutation,
                        mt: 6,
                        children: jobTitle ? "Mettre \xe0 jour le M\xe9tier" : "Nouveau M\xe9tier"
                    })
                ]
            });
        }
    });
};
var $beefaf9ffadbec4d$export$2e2bcd8739ae039 = $beefaf9ffadbec4d$var$JobTitleForm;



parcelRequire("3ZYaX");

const $1bf7c8ffbb54dd51$var$JobTitleExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Le m\xe9tier est un \xe9l\xe9ment central qui d\xe9finit les caract\xe9ristiques d'un poste de travail. Chaque mission doit obligatoirement \xeatre associ\xe9e \xe0 un m\xe9tier qui d\xe9termine :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les R\xe8gles de Pointage"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Chaque m\xe9tier est associ\xe9 \xe0 une r\xe8gle de pointage qui d\xe9finit comment sont trait\xe9s les pointages (retards, avances, pauses) pour toutes les journ\xe9es de travail sur ce poste."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Informations Compl\xe9mentaires"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Description du poste, comp\xe9tences souhait\xe9es, certifications n\xe9cessaires... Ces informations facilitent la recherche et l'attribution des missions."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Le Coefficient de Main d'\u0152uvre"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Pour le travail temporaire, le coefficient de facturation est d\xe9fini par agence d'int\xe9rim sur chaque m\xe9tier. Ce coefficient est utilis\xe9 pour le calcul des co\xfbts de mission."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Ces param\xe8tres sont automatiquement appliqu\xe9s \xe0 toutes les missions cr\xe9\xe9es avec ce m\xe9tier."
                })
            })
        ]
    });
};
var $1bf7c8ffbb54dd51$export$2e2bcd8739ae039 = $1bf7c8ffbb54dd51$var$JobTitleExplanation;







parcelRequire("3ZYaX");




/**
 * Composant pour gérer les actions dangereuses sur un job title
 * comme la désactivation/réactivation
 */ const $980e3b56d05af1a5$var$JobTitleDangerZone = ({ jobTitle: jobTitle })=>{
    const updateMutation = (0, $b5014031ea60dfe7$export$cac0b33e6f13c8ec)();
    const { isDisplayed: isConfirmationDisplayed, setIsDisplayed: setIsConfirmationDisplayed } = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const isJobTitleInactive = jobTitle.isInactive;
    const handleToggleStatus = async ()=>{
        await updateMutation.mutateAsync({
            id: jobTitle._id.toString(),
            isInactive: !isJobTitleInactive
        });
        setIsConfirmationDisplayed(false);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                mt: 5,
                pt: 2,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    className: "is-flex is-justify-content-space-between is-align-items-center",
                    mt: 2,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textWeight: "bold",
                                    children: isJobTitleInactive ? "R\xe9activer ce m\xe9tier" : "D\xe9sactiver ce m\xe9tier"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textSize: 7,
                                    textColor: "grey",
                                    children: isJobTitleInactive ? "Une fois r\xe9activ\xe9, le m\xe9tier sera \xe0 nouveau disponible pour les missions et les demandes" : "Une fois d\xe9sactiv\xe9, vous pourrez le r\xe9activer plus tard"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: isJobTitleInactive ? 'success' : 'danger',
                            onClick: ()=>setIsConfirmationDisplayed(true),
                            "data-test": "disable-job-title-button",
                            size: "small",
                            children: isJobTitleInactive ? "R\xe9activer le m\xe9tier" : "D\xe9sactiver le m\xe9tier"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: isConfirmationDisplayed,
                onConfirm: handleToggleStatus,
                onCancel: ()=>setIsConfirmationDisplayed(false),
                title: isJobTitleInactive ? "R\xe9activer le m\xe9tier" : "D\xe9sactiver le m\xe9tier",
                confirmButtonLabel: isJobTitleInactive ? "R\xe9activer" : "D\xe9sactiver",
                confirmButtonProps: {
                    color: isJobTitleInactive ? 'success' : 'danger',
                    disabled: false
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: isJobTitleInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir r\xe9activer ce m\xe9tier ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Le m\xe9tier sera \xe0 nouveau disponible pour les missions et les demandes."
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir d\xe9sactiver ce m\xe9tier ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Les missions utilisant ce m\xe9tier ne seront pas impact\xe9es et conserveront leur historique.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textWeight: "bold",
                                children: "Le m\xe9tier ne sera plus visible dans les filtres et ne pourra plus \xeatre s\xe9lectionn\xe9 pour la cr\xe9ation de nouvelles missions et de nouvelles demandes."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $980e3b56d05af1a5$export$2e2bcd8739ae039 = $980e3b56d05af1a5$var$JobTitleDangerZone;



/**
 * Composant pour afficher et éditer les détails d'un métier
 */ const $ac4d47821c950761$var$JobTitleDetails = ()=>{
    //const { employer } = useOutletContext<OutletContext>()
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: jobTitle } = (0, $b5014031ea60dfe7$export$15dd7c0b0ff20c77)(id, {
        enabled: Boolean(id)
    });
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)(isNew ? (0, $b5014031ea60dfe7$export$4a6f974b4208311)() : (0, $b5014031ea60dfe7$export$a6fe4df8bec26327)());
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($ac4d47821c950761$var$formWrapperBaseProps, //@ts-ignore
    mutationState, !isNew);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: isNew ? "Nouveau m\xe9tier" : `D\xe9tails du m\xe9tier ${jobTitle?.name}`,
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1bf7c8ffbb54dd51$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            jobTitle?.isInactive && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                color: "warning",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                            }),
                            "Ce m\xe9tier est actuellement inactif et ne peut pas \xeatre utilis\xe9 pour de nouvelles missions."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                ...formWrapperProps,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $beefaf9ffadbec4d$export$2e2bcd8739ae039), {
                            jobTitle: jobTitle
                        })
                    }),
                    !isNew && jobTitle && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $980e3b56d05af1a5$export$2e2bcd8739ae039), {
                        jobTitle: jobTitle
                    })
                ]
            })
        ]
    });
};
var $ac4d47821c950761$export$2e2bcd8739ae039 = $ac4d47821c950761$var$JobTitleDetails;
const $ac4d47821c950761$var$formWrapperBaseProps = {
    loadingProps: {
        body: "Enregistrement du m\xe9tier..."
    },
    successProps: {
        title: "M\xe9tier cr\xe9\xe9",
        body: {
            description: "Le m\xe9tier a \xe9t\xe9 cr\xe9\xe9",
            actions: [
                {
                    label: "Nouveau M\xe9tier"
                },
                {
                    label: "Retourner \xe0 la liste",
                    to: '/settings/job-titles'
                }
            ]
        }
    }
};



parcelRequire("3ZYaX");




parcelRequire("3ZYaX");

const $25a02e46d3857783$var$ClockingRulesExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les r\xe8gles de pointage sont associ\xe9es \xe0 un m\xe9tier et d\xe9finissent comment sont trait\xe9s les pointages des employ\xe9s sur ce m\xe9tier. Elles permettent de param\xe9trer :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Retards et Avances"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Comment sont comptabilis\xe9s les pointages en avance ou en retard par rapport \xe0 l'horaire pr\xe9vu. Une tol\xe9rance en minutes peut \xeatre d\xe9finie pour chaque cas."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Pauses"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Deux modes possibles :",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Pause fixe : dur\xe9e d\xe9finie, d\xe9compt\xe9e apr\xe8s un certain temps de travail"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Pause point\xe9e : l'employ\xe9 pointe ses pauses, avec une tol\xe9rance possible sur la dur\xe9e totale"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Ces r\xe8gles s'appliquent automatiquement \xe0 toutes les journ\xe9es de travail associ\xe9es au m\xe9tier correspondant et d\xe9terminent le calcul final des heures."
                })
            })
        ]
    });
};
var $25a02e46d3857783$export$2e2bcd8739ae039 = $25a02e46d3857783$var$ClockingRulesExplanation;





var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");











parcelRequire("3ZYaX");

const $5456cc28780f73a6$var$ClockingsRulesClockedBreaksDescription = ({ rules: rules })=>{
    if (!rules.clockingsTolerance.early && !rules.clockingsTolerance.late) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            "La dur\xe9e totale de pause sera de",
            ' ',
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                children: [
                    rules.breakDuration,
                    " minutes"
                ]
            }),
            " si le temps total des pauses point\xe9es est entre",
            ' ',
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                children: [
                    rules.breakDuration - rules.clockingsTolerance.early,
                    " et",
                    ' ',
                    rules.breakDuration + rules.clockingsTolerance.late,
                    " minutes"
                ]
            }),
            "."
        ]
    });
};
var $5456cc28780f73a6$export$2e2bcd8739ae039 = $5456cc28780f73a6$var$ClockingsRulesClockedBreaksDescription;


const $8ae403a4d151d691$var$ClockingsRulesForm = ({ clockingRules: clockingRules })=>{
    const isUpdateForm = clockingRules && clockingRules._id;
    const createMutation = (0, $e8692bc7fe3a6d6c$export$a25726670bb41cb)();
    const updateMutation = (0, $e8692bc7fe3a6d6c$export$cac0b33e6f13c8ec)();
    const currentMutation = isUpdateForm ? updateMutation : createMutation;
    const initialValues = (0, $3ZYaX.useMemo)(()=>(0, $4627fcfc0cdb41bc$export$634221161cc87802)(clockingRules), [
        clockingRules?._id
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            // Name field is required
            if (!values.name) errors.name = 'Champ requis';
            // Tolerance has to be between a Min and Max if ruleMode is set to 'clocking'
            const rules = values.rules;
            const toleranceRuleError = `Tol\xe9rance doit \xeatre entre ${(0, $4627fcfc0cdb41bc$export$7c96a28adcb64b44)} et ${(0, $4627fcfc0cdb41bc$export$c1bc350165fd7d8c)} minutes`;
            const toleranceValidation = (startOrEnd, earlyOrLate)=>{
                const rule = rules[startOrEnd][earlyOrLate];
                if (rule.mode === 'clocking' && (rule.tolerance < (0, $4627fcfc0cdb41bc$export$7c96a28adcb64b44) || rule.tolerance > (0, $4627fcfc0cdb41bc$export$c1bc350165fd7d8c))) // @ts-expect-error No typing here :-()
                errors[`rules.${startOrEnd}.${earlyOrLate}.tolerance`] = toleranceRuleError;
            };
            toleranceValidation('start', 'early');
            toleranceValidation('start', 'late');
            toleranceValidation('end', 'early');
            toleranceValidation('end', 'late');
            // Validation for workPeriodMatchRange
            const minWorkPeriodTolerance = 1;
            const maxWorkPeriodTolerance = 480 // 8 hours in minutes
            ;
            if (values.workPeriodMatchRange?.start && (values.workPeriodMatchRange.start < minWorkPeriodTolerance || values.workPeriodMatchRange.start > maxWorkPeriodTolerance)) // @ts-expect-error No typing here :-()
            errors['workPeriodMatchRange.start'] = `La valeur doit \xeatre entre ${minWorkPeriodTolerance} et ${maxWorkPeriodTolerance} minutes (8 heures)`;
            if (values.workPeriodMatchRange?.end && (values.workPeriodMatchRange.end < minWorkPeriodTolerance || values.workPeriodMatchRange.end > maxWorkPeriodTolerance)) // @ts-expect-error No typing here :-()
            errors['workPeriodMatchRange.end'] = `La valeur doit \xeatre entre ${minWorkPeriodTolerance} et ${maxWorkPeriodTolerance} minutes (8 heures)`;
            return errors;
        },
        onSubmit: (values)=>{
            const converted = (0, $4627fcfc0cdb41bc$export$de2580df8201c8a7)(values, (0, $4627fcfc0cdb41bc$export$9530ed502f35fef4));
            if (!isUpdateForm) createMutation.mutate(converted);
            else updateMutation.mutate({
                _id: clockingRules._id,
                ...converted,
                updateExistingMissionsFrom: values.updateExistingMissionsFrom ? (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.updateExistingMissionsFrom) : undefined
            });
        },
        children: (formik)=>{
            const breaksAreClocked = formik.values.break.clocked;
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 12,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    mb: 5,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Nom",
                                                name: "name",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Description",
                                                name: "description",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 4,
                                    children: "D\xe9but de Journ\xe9e"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($8ae403a4d151d691$var$ClockingRuleField, {
                                                    startOrEnd: 'start',
                                                    earlyOrLate: 'early'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($8ae403a4d151d691$var$ClockingRuleField, {
                                                    startOrEnd: 'start',
                                                    earlyOrLate: 'late'
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 4,
                                    children: "Fin de Journ\xe9e"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($8ae403a4d151d691$var$ClockingRuleField, {
                                                    startOrEnd: 'end',
                                                    earlyOrLate: 'early'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($8ae403a4d151d691$var$ClockingRuleField, {
                                                    startOrEnd: 'end',
                                                    earlyOrLate: 'late'
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 4,
                                    children: "Pause"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                size: 12,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: "break.clocked",
                                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                                    label: "Les pauses sont point\xe9es"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                size: 6,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: "break.breakDuration",
                                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                    type: "number",
                                                    min: 0,
                                                    max: 240,
                                                    label: breaksAreClocked ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                        children: [
                                                            ' ',
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                            "La dur\xe9e de pause th\xe9orique est de"
                                                        ]
                                                    }) : "La dur\xe9e de pause est de",
                                                    help: "Sp\xe9cifier une valeur en minutes"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                size: 6,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: "break.breakAllowedAfter",
                                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                    disabled: formik.values.break.breakDuration === 0,
                                                    type: "number",
                                                    min: 0,
                                                    max: 720,
                                                    label: breaksAreClocked ? "Si pas de pointage de pauses, attribuer la pause automatiquement apr\xe8s" : "apr\xe8s une dur\xe9e de prestation de minimum",
                                                    help: "Sp\xe9cifier une valeur en minutes"
                                                })
                                            }),
                                            breaksAreClocked && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 6,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            name: "break.clockingsTolerance.early",
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            disabled: formik.values.break.breakDuration === 0,
                                                            type: "number",
                                                            min: 0,
                                                            max: 720,
                                                            label: "Attribuer le temps de pause th\xe9orique si la pause point\xe9e est plus courte de",
                                                            help: "Sp\xe9cifier une valeur en minutes"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 6,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            name: "break.clockingsTolerance.late",
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            disabled: formik.values.break.breakDuration === 0,
                                                            type: "number",
                                                            min: 0,
                                                            max: 720,
                                                            label: "Attribuer le temps de pause th\xe9orique si la pause point\xe9e est plus longue de",
                                                            help: "Sp\xe9cifier une valeur en minutes"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 12,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5456cc28780f73a6$export$2e2bcd8739ae039), {
                                                            rules: formik.values.break
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 4,
                                    children: "Fen\xeatre de pointage"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 4,
                                            children: "D\xe9finissez la p\xe9riode pendant laquelle un pointage peut \xeatre associ\xe9 \xe0 la journ\xe9e de travail. Ces valeurs d\xe9terminent \xe0 quel point un pointage peut \xeatre effectu\xe9 avant le d\xe9but ou apr\xe8s la fin de la journ\xe9e de travail th\xe9orique."
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 6,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        name: "workPeriodMatchRange.start",
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "number",
                                                        min: 1,
                                                        max: 480,
                                                        label: "Pointage possible avant le d\xe9but de la journ\xe9e",
                                                        help: formik.values.workPeriodMatchRange?.start ? `Valeur en minutes | Temps maximum avant le d\xe9but de la p\xe9riode : ${(0, $74f17ceb9b5a08a5$export$5f5c3edd8240baca)(formik.values.workPeriodMatchRange.start)}` : "Sp\xe9cifier une valeur en minutes (min: 1, max: 480)",
                                                        placeholder: "120"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                    size: 6,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        name: "workPeriodMatchRange.end",
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        type: "number",
                                                        min: 1,
                                                        max: 480,
                                                        label: "Pointage possible apr\xe8s la fin de la journ\xe9e",
                                                        help: formik.values.workPeriodMatchRange?.end ? `Valeur en minutes | Temps maximum apr\xe8s la fin de la p\xe9riode : ${(0, $74f17ceb9b5a08a5$export$5f5c3edd8240baca)(formik.values.workPeriodMatchRange.end)}` : "Sp\xe9cifier une valeur en minutes (min: 1, max: 480)",
                                                        placeholder: "240"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                clockingRules /*&& !isEqual(formik.values, initialValues)*/  && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                            size: 4,
                                            mt: 5,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        mr: 1,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {
                                                            color: "red"
                                                        })
                                                    }),
                                                    "Modification des journ\xe9es de travail en cours",
                                                    ' '
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                                                    color: "warning",
                                                    p: 2,
                                                    children: [
                                                        "Vous modifiez la r\xe8gle de pointage",
                                                        ' ',
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            renderAs: "strong",
                                                            children: formik.values.name
                                                        }),
                                                        ".",
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                        "En s\xe9lectionnant une date, cette modification s'appliquera \xe0 toutes les journ\xe9es de travail utilisant cette r\xe8gle:",
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            className: "content",
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                                                        children: [
                                                                            "Qui ne sont ",
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                renderAs: "strong",
                                                                                children: "pas valid\xe9es"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                                                        children: [
                                                                            "Qui commencent \xe0 partir de",
                                                                            ' ',
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                renderAs: "strong",
                                                                                children: "la date s\xe9lectionn\xe9e"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            children: "Sans date s\xe9lectionn\xe9e, la nouvelle version de la r\xe8gle ne s'appliquera qu'aux futures missions. Les missions et journ\xe9es de travail existantes conserveront la version actuelle de la r\xe8gle."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    name: "updateExistingMissionsFrom",
                                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                    type: "date",
                                                    label: "Modifier les journ\xe9es de travail \xe0 partir du",
                                                    help: "Si aucune date n'est choisie, aucune journ\xe9e de travail ne sera modifi\xe9e"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 4,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                        mutation: currentMutation
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                    color: "primary",
                                    type: "submit",
                                    mutation: currentMutation,
                                    children: clockingRules ? "Mettre \xe0 jour les R\xe8gles de Pointage" : "Cr\xe9er des Nouvelles R\xe8gles de Pointage"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $8ae403a4d151d691$export$2e2bcd8739ae039 = $8ae403a4d151d691$var$ClockingsRulesForm;
const $8ae403a4d151d691$var$ClockingRuleField = ({ startOrEnd: startOrEnd, earlyOrLate: earlyOrLate })=>{
    const { values: values } = (0, $31tXu.useFormikContext)();
    const startOrEndLabel = {
        start: "D\xe9but",
        end: 'Fin'
    };
    const earlyOrLateLabels = {
        early: 'avance',
        late: 'retard'
    };
    const options = (startOrEnd)=>[
            {
                name: `L'heure de ${startOrEndLabel[startOrEnd]} de Journ\xe9e`,
                _id: 'theoritical'
            },
            {
                name: 'Le Pointage',
                _id: 'clocking'
            }
        ];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                children: [
                    "Je pointe en ",
                    earlyOrLateLabels[earlyOrLate]
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                label: 'On tient compte de : ' + (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(options(startOrEnd)).find((option)=>option.value === values.rules[startOrEnd][earlyOrLate].mode)?.label,
                name: `rules.${startOrEnd}.${earlyOrLate}.mode`,
                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(options(startOrEnd)),
                type: "number",
                required: true
            }),
            values['rules'][startOrEnd][earlyOrLate].mode === 'clocking' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                label: `Sauf si ${earlyOrLateLabels[earlyOrLate]} de moins de ${values.rules[startOrEnd][earlyOrLate].tolerance} minutes`,
                name: `rules.${startOrEnd}.${earlyOrLate}.tolerance`,
                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                type: "number",
                required: true,
                min: (0, $4627fcfc0cdb41bc$export$7c96a28adcb64b44),
                max: (0, $4627fcfc0cdb41bc$export$c1bc350165fd7d8c),
                step: 1,
                help: `Tol\xe9rance : de ${(0, $4627fcfc0cdb41bc$export$7c96a28adcb64b44)} \xe0 ${(0, $4627fcfc0cdb41bc$export$c1bc350165fd7d8c)} minutes`
            })
        ]
    });
};





/**
 * Composant pour afficher et éditer les détails d'une règle de pointage
 */ const $ec19c1e625e43b58$var$ClockingRuleDetails = ()=>{
    //const { employer } = useOutletContext<OutletContext>()
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: clockingRule } = (0, $e8692bc7fe3a6d6c$export$f84d30a4bcf4a548)(id, {
        enabled: Boolean(id)
    });
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)(isNew ? (0, $e8692bc7fe3a6d6c$export$4a6f974b4208311)() : (0, $e8692bc7fe3a6d6c$export$a6fe4df8bec26327)());
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($ec19c1e625e43b58$var$formWrapperBaseProps, //@ts-ignore
    mutationState, !isNew);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: isNew ? "Nouvelle r\xe8gle de pointage" : `D\xe9tails de la r\xe8gle de pointage ${clockingRule?.name}`,
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $25a02e46d3857783$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                ...formWrapperProps,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8ae403a4d151d691$export$2e2bcd8739ae039), {
                        clockingRules: clockingRule
                    })
                })
            })
        ]
    });
};
var $ec19c1e625e43b58$export$2e2bcd8739ae039 = $ec19c1e625e43b58$var$ClockingRuleDetails;
const $ec19c1e625e43b58$var$formWrapperBaseProps = {
    loadingProps: {
        body: "Enregistrement des R\xe8gles de Pointage..."
    },
    successProps: {
        title: "R\xe8gles de Pointages cr\xe9\xe9es",
        body: {
            description: "Les R\xe8gles de Pointage ont \xe9t\xe9 cr\xe9\xe9es",
            actions: [
                {
                    label: "Nouvelles R\xe8gles de Pointage"
                },
                {
                    label: "Retourner \xe0 la liste",
                    to: '/settings/clocking-rules'
                }
            ]
        }
    }
};




parcelRequire("3ZYaX");



parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");
const $97a9e9f5b9c67d9e$var$allThemeNames = [
    'superAdmin-theme',
    'employerMember-theme',
    'worker-theme',
    'interimAgencyMember-theme',
    'guest-theme'
];
const $97a9e9f5b9c67d9e$export$296a15be2355ae75 = {
    interimAgencyMember: 'interim-agency',
    employerMember: 'employer',
    worker: 'worker',
    superAdmin: 'super-admin'
};
const $97a9e9f5b9c67d9e$export$c6b39cbe012e4c9 = {
    interimAgency: 'interim-agency',
    employer: 'employer'
};
// Set className on <html> according current user role
const $97a9e9f5b9c67d9e$var$useThemeSwitcher = (currentUserRole)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        const currentThemeClassName = currentUserRole + '-theme';
        $97a9e9f5b9c67d9e$var$allThemeNames.forEach((themeName)=>{
            if (document.getElementsByTagName('html')[0].classList.contains(themeName)) document.getElementsByTagName('html')[0].classList.remove(themeName);
        });
        document.getElementsByTagName('html')[0].classList.add(currentThemeClassName);
    }, [
        currentUserRole
    ]);
};
var $97a9e9f5b9c67d9e$export$2e2bcd8739ae039 = $97a9e9f5b9c67d9e$var$useThemeSwitcher;




parcelRequire("3ZYaX");


const $9c62bd87ffe54c5d$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;


const $37250c8da4feaf0c$export$f9f3c19554479b2b = ({ title: title, mainStat: { value: value, label: label }, secondaryStat: secondaryStat, color: color, to: to, queryStatus: queryStatus })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9c62bd87ffe54c5d$export$39aecc95f0365819), {
            condition: Boolean(to),
            // We know that 'to' is defined in the wrapper because it's status of the condition Boolean(to)
            wrapper: (children)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                    to: to,
                    children: children
                }),
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                children: [
                    title !== undefined && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        textColor: "grey",
                        renderAs: "h3",
                        size: 6,
                        textWeight: "bold",
                        mb: 3,
                        children: title
                    }),
                    queryStatus === 'success' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textAlign: 'center',
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                textSize: 1,
                                textWeight: "bold",
                                textColor: color ? color : 'primary',
                                children: [
                                    value,
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        textSize: 3,
                                        style: {
                                            whiteSpace: 'nowrap'
                                        },
                                        children: label
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textColor: "grey",
                                renderAs: "span",
                                textSize: 6,
                                textWeight: "bold",
                                style: {
                                    whiteSpace: 'nowrap'
                                },
                                children: secondaryStat ?? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: "\xa0"
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {})
                ]
            })
        })
    });
};


const $ecaa115283e9511f$var$labels = {
    employer: {
        title: 'EMPLOYEURS',
        mainStat: {
            label: 'Employeurs',
            value: 0
        }
    },
    interimAgency: {
        title: "AGENCES D'INT\xc9RIM",
        mainStat: {
            label: 'Agences',
            value: 0
        }
    }
};
const $ecaa115283e9511f$export$24a4b1c92d6e4993 = ({ type: type })=>{
    const organizationsQuery = (0, $58f46cb3f921014b$export$f085fe041f5f596a)({
        populate: [
            ''
        ],
        fields: [
            '_id',
            'type'
        ],
        type: type
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
            title: $ecaa115283e9511f$var$labels[type].title,
            mainStat: {
                value: organizationsQuery.data ?? 0,
                label: $ecaa115283e9511f$var$labels[type].mainStat.label
            },
            color: (0, $97a9e9f5b9c67d9e$export$c6b39cbe012e4c9)[type],
            queryStatus: organizationsQuery.status
        })
    });
};



parcelRequire("3ZYaX");





const $8784736e06e629c7$var$labels = {
    worker: {
        title: "INT\xc9RIM",
        mainStat: {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {
                plural: true
            }),
            value: 0
        },
        to: '/settings/workers'
    },
    interimAgencyMember: {
        title: "AGENCES D'INT\xc9RIM",
        mainStat: {
            label: 'Agents',
            value: 0
        }
    },
    employerMember: {
        title: 'EMPLOYEURS',
        mainStat: {
            label: "Employ\xe9s",
            value: 0
        }
    },
    superAdmin: {
        title: 'SUPER ADMINS',
        mainStat: {
            label: 'Super Admins',
            value: 0
        }
    },
    users: {
        title: 'PLATEFORME',
        mainStat: {
            label: 'Utilisateurs',
            value: 0
        }
    }
};
const $8784736e06e629c7$export$5e31a4a3357b9e74 = ({ userRoleKind: userRoleKind })=>{
    const usersQuery = (0, $e607e015ac40917d$export$e37258df366467dd)({
        'roles.kind': userRoleKind,
        populate: [
            ''
        ],
        fields: [
            '_id'
        ]
    });
    const type = userRoleKind ?? 'users';
    const totalUsers = usersQuery.data ?? 0;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        className: "has-text-employer",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
            title: $8784736e06e629c7$var$labels[type].title,
            mainStat: {
                value: totalUsers,
                label: $8784736e06e629c7$var$labels[type].mainStat.label
            },
            color: userRoleKind ? (0, $97a9e9f5b9c67d9e$export$296a15be2355ae75)[userRoleKind] : undefined,
            to: $8784736e06e629c7$var$labels[type].to,
            queryStatus: usersQuery.status
        })
    });
};






const $0aac2f78455cfee7$var$SuperAdminDashboard = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: currentUser ? (0, $25ffbf4bca475b04$export$9a57c514c234d759)(currentUser) : '...',
                subtitle: "Super Admin"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {
                                        userRoleKind: "superAdmin"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ecaa115283e9511f$export$24a4b1c92d6e4993), {
                                        type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {
                                        userRoleKind: "employerMember"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ecaa115283e9511f$export$24a4b1c92d6e4993), {
                                        type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {
                                        userRoleKind: "interimAgencyMember"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {
                                    userRoleKind: "worker"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $0aac2f78455cfee7$export$2e2bcd8739ae039 = $0aac2f78455cfee7$var$SuperAdminDashboard;



parcelRequire("3ZYaX");






parcelRequire("3ZYaX");



const $ef7a6deeb765690c$export$d5eefcb5ac47e6fe = ()=>{
    const queriesCommonParams = {
        start: (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(new Date()),
        end: (0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)(new Date())
    };
    const missionsCountQuery = (0, $e409591b67738e56$export$73e9dd07495d29c8)(queriesCommonParams);
    const validatedMissionsCountQuery = (0, $e409591b67738e56$export$73e9dd07495d29c8)({
        ...queriesCommonParams,
        isValidated: true
    });
    const totalMissions = missionsCountQuery?.data ?? 0;
    const totalMissionsValidated = validatedMissionsCountQuery?.data ?? 0;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
        title: 'CETTE SEMAINE',
        mainStat: {
            value: totalMissions,
            label: 'Missions'
        },
        secondaryStat: totalMissionsValidated + ' / ' + totalMissions + " Valid\xe9es",
        to: '/missions',
        queryStatus: validatedMissionsCountQuery.status
    });
};



parcelRequire("3ZYaX");



const $cac0ca66b153a177$export$2d6fe44bce0904df = ()=>{
    const workersRequestsQuery = (0, $b8c6247768bd4102$export$5084421b5a71fe52)({
        isExpired: (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()), 3),
        isComplete: false,
        isCancelled: false,
        fields: [
            '_id',
            'stats'
        ],
        populate: []
    });
    const activeWorkersRequests = workersRequestsQuery?.data || [];
    const totalActiveWorkersRequests = activeWorkersRequests?.length ?? 0;
    const totalWorkersNotAssigned = activeWorkersRequests?.reduce((acc, curr)=>{
        return acc + curr.stats.notAssigned;
    }, 0) ?? 0;
    /* const totalWorkersRequested =
    activeWorkersRequests?.reduce((acc, curr) => {
      return acc + curr.stats.notAssigned
    }, 0) ?? 0 */ return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
            title: 'DEMANDES EN COURS',
            mainStat: {
                value: totalActiveWorkersRequests,
                label: 'Demandes'
            },
            secondaryStat: totalWorkersNotAssigned + /* ' / ' + totalWorkersRequested + */ ' Postes Vacants',
            to: `/workers-requests`,
            queryStatus: workersRequestsQuery.status
        })
    });
};



const $1bd9ad95b1a12976$var$InterimAgencyDashboard = ()=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: currentOrganization?.name ? currentOrganization.name : '',
                subtitle: currentOrganization?.type ? (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).organizations.type[currentOrganization?.type] : ''
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef7a6deeb765690c$export$d5eefcb5ac47e6fe), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cac0ca66b153a177$export$2d6fe44bce0904df), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8784736e06e629c7$export$5e31a4a3357b9e74), {
                                    userRoleKind: "worker"
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $1bd9ad95b1a12976$export$2e2bcd8739ae039 = $1bd9ad95b1a12976$var$InterimAgencyDashboard;




var $3ZYaX = parcelRequire("3ZYaX");
function $8ed0b2eeef0c2e65$var$DocumentAddIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
    }));
}
const $8ed0b2eeef0c2e65$var$ForwardRef = $3ZYaX.forwardRef($8ed0b2eeef0c2e65$var$DocumentAddIcon);
var $8ed0b2eeef0c2e65$export$2e2bcd8739ae039 = $8ed0b2eeef0c2e65$var$ForwardRef;



var $3ZYaX = parcelRequire("3ZYaX");





parcelRequire("3ZYaX");



const $0f4dda08c3931adc$export$329533581a5ab8d8 = ({ workersRequest: workersRequest, iconColor: iconColor = 'success', ...rest })=>{
    if (!workersRequest.isComplete) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        iconColor: iconColor,
        text: "Demande compl\xe8te",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1c9647edca77a47b), {}),
        ...rest
    });
};
const $0f4dda08c3931adc$export$49281bdda008ebc = ({ workersRequest: workersRequest, ...rest })=>{
    if (!workersRequest.isClosed) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Demande clotur\xe9e",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5b66a47e297ca640), {}),
        ...rest
    });
};
const $0f4dda08c3931adc$export$988f707fd3fbd677 = ({ workersRequest: workersRequest, ...rest })=>{
    if (!workersRequest.isCancelled) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        text: "Demande annul\xe9e",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$516fd7364fa08290), {}),
        ...rest
    });
};
const $0f4dda08c3931adc$var$WorkersRequestsMessages = ({ workersRequest: workersRequest, ...rest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "flex",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0f4dda08c3931adc$export$329533581a5ab8d8, {
                workersRequest: workersRequest,
                ...rest
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0f4dda08c3931adc$export$49281bdda008ebc, {
                workersRequest: workersRequest,
                ...rest
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0f4dda08c3931adc$export$988f707fd3fbd677, {
                workersRequest: workersRequest,
                ...rest
            })
        ]
    });
};
var $0f4dda08c3931adc$export$2e2bcd8739ae039 = $0f4dda08c3931adc$var$WorkersRequestsMessages;






var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");









parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $570aaabae9e1869c$var$IsExpiredFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Expir\xe9e apr\xe8s le",
            name: "isExpired",
            type: "date",
            component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
        })
    });
};
var $570aaabae9e1869c$export$2e2bcd8739ae039 = $570aaabae9e1869c$var$IsExpiredFilterField;



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

const $984a92fd8920e05b$var$IsCompleteFilterField = ({})=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: "Compl\xe8te",
            name: "isComplete",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: [
                {
                    label: 'Oui',
                    value: true
                },
                {
                    label: 'Non',
                    value: false
                }
            ]
        })
    });
};
var $984a92fd8920e05b$export$2e2bcd8739ae039 = $984a92fd8920e05b$var$IsCompleteFilterField;








var $2KSUA = parcelRequire("2KSUA");

const $5bc7647252e97352$var$WorkersRequestsFilters = ({ disabledQueries: disabledQueries })=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workersRequests);
    const queriesStaleTime = 120000 // 2 min
    ;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...filters,
            isExpired: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $2KSUA.isArray)(filters.isExpired) ? (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()), 3) : filters.isExpired)
        },
        onSubmit: (values)=>{
            if (values.week) {
                const dates = (0, $74f17ceb9b5a08a5$export$217584d147ca6846)(values.week);
                if (dates) values = {
                    ...values,
                    ...dates
                };
            }
            if (values.isExpired) {
                const date = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.isExpired);
                if (date) values = {
                    ...values,
                    isExpired: date
                };
            }
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workersRequests, values);
        },
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).workersRequests,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ba4a55bdb1b56879$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                    type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency,
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {
                                    employerIds: filters.employer,
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                    type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer,
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {
                                    employerIds: filters.employer,
                                    disabledQueries: disabledQueries,
                                    queriesStaleTime: queriesStaleTime
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $570aaabae9e1869c$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $984a92fd8920e05b$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6b26f08d92179eff$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $5bc7647252e97352$export$2e2bcd8739ae039 = $5bc7647252e97352$var$WorkersRequestsFilters;




const $207d7f53b8127018$var$WorkersRequestsList = ()=>{
    const query = (0, $b8c6247768bd4102$export$5084421b5a71fe52)();
    const columns = $207d7f53b8127018$var$useListTableColumns();
    const action = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
        roles: [
            'employerMember'
        ],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
            renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
            to: "/workers-requests/new",
            color: "primary",
            size: "small",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8ed0b2eeef0c2e65$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "span",
                    children: "Nouvelle demande d'Int\xe9rimaires"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71db929d54fcb96$export$2e2bcd8739ae039), {
        title: "Liste des Demandes d'Int\xe9rimaires",
        subtitle: "Toutes les Demandes d'Int\xe9rimaires aupr\xe8s des Agences partenaires",
        action: action,
        filters: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5bc7647252e97352$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
            columns: columns,
            data: query.data || [],
            noDataMessage: "Aucune Demande de Personnel \xe0 afficher"
        })
    });
};
var $207d7f53b8127018$export$2e2bcd8739ae039 = $207d7f53b8127018$var$WorkersRequestsList;
const $207d7f53b8127018$var$useListTableColumns = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: ' ',
                accessor: 'show',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/workers-requests/${workersRequest._id}`,
                        "data-test": "workers-request-link",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9cce2377d82ad02c$export$2e2bcd8739ae039), {})
                        })
                    });
                },
                width: '40px'
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ]) ? {
                Header: '  ',
                accessor: 'duplicate',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/workers-requests/new?workersRequestTemplate=${workersRequest._id}`,
                        "data-test": "workers-request-duplicate-link",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$10862138e9169702), {})
                        })
                    });
                },
                width: '40px'
            } : {
                accessor: 'duplicate'
            },
            {
                Header: 'Employeur',
                accessor: 'employer',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: workersRequest.employer.name
                    });
                }
            },
            {
                Header: "Agence d'int\xe9rim",
                accessor: 'interimAgency',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: workersRequest.interimAgency.name
                    });
                }
            },
            {
                Header: 'Postes',
                id: 'stats',
                accessor: 'stats',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                        to: `/workers-requests/${workersRequest._id}`,
                        children: [
                            workersRequest.stats.assigned,
                            "\xa0/\xa0",
                            workersRequest.stats.assigned + workersRequest.stats.notAssigned
                        ]
                    });
                }
            },
            {
                Header: "D\xe9but",
                accessor: 'missionsStart',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workersRequest.missionsStart);
                }
            },
            {
                Header: 'Fin',
                accessor: 'missionsEnd',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workersRequest.missionsEnd);
                }
            },
            {
                Header: 'Affectation',
                accessor: 'missionData.service.name'
            },
            {
                Header: "Cat\xe9gories",
                id: 'tags',
                accessor: 'posts',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    // Récupérer tous les tags de tous les posts
                    const allTags = workersRequest.posts.flatMap((post)=>post.tags || []);
                    // Éliminer les doublons par _id
                    const uniqueTags = allTags.filter((tag, index, self)=>index === self.findIndex((t)=>t._id === tag._id));
                    if (uniqueTags.length === 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "grey-light",
                        children: "-"
                    });
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: uniqueTags.map((tag)=>tag.name).join(', ')
                    });
                }
            },
            /* {
          Header: (
            <WorkersRequestClosedMessage workersRequest={{ isClosed: true }} type="icon" small />
          ),
          accessor: 'isClosed',
          Cell: (data: CellProps<WorkersRequest>) => {
            const workersRequest = data.cell.row.original
            return <WorkersRequestClosedMessage workersRequest={workersRequest} type="icon" small />
          },
          width: '40px',
        }, */ {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$329533581a5ab8d8), {
                    workersRequest: {
                        isComplete: true
                    },
                    type: "icon",
                    small: true
                }),
                accessor: 'isComplete',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$329533581a5ab8d8), {
                        workersRequest: workersRequest,
                        type: "icon",
                        small: true
                    });
                },
                width: '40px'
            },
            {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$988f707fd3fbd677), {
                    workersRequest: {
                        isCancelled: true
                    },
                    type: "icon",
                    small: true
                }),
                accessor: 'isCancelled',
                Cell: (data)=>{
                    const workersRequest = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$988f707fd3fbd677), {
                        workersRequest: workersRequest,
                        type: "icon",
                        small: true
                    });
                },
                width: '40px'
            }
        ], []);
};




var $3ZYaX = parcelRequire("3ZYaX");












parcelRequire("3ZYaX");






parcelRequire("3ZYaX");




const $4cde4ef5f1194541$var$WorkersRequestCancelConfirmationModal = ({ show: show, hide: hide, workersRequest: workersRequest })=>{
    const mutation = (0, $b8c6247768bd4102$export$cac0b33e6f13c8ec)();
    const onConfirm = ()=>{
        mutation.mutate({
            id: workersRequest._id,
            isCancelled: true
        });
        hide();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
        show: show,
        onConfirm: onConfirm,
        onCancel: hide,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            children: [
                "\xcates vous certain de vouloir annuler cette Demande de Personnel ?",
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "strong",
                    children: [
                        "L'Agence d'Int\xe9rim ne pourra plus ajouter de ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                        " \xe0 cette demande et toutes les missions d\xe9j\xe0 assign\xe9es seront interrompues"
                    ]
                }),
                ' '
            ]
        })
    });
};
var $4cde4ef5f1194541$export$2e2bcd8739ae039 = $4cde4ef5f1194541$var$WorkersRequestCancelConfirmationModal;



const $81fea641c7a956af$var$WorkersRequestPageTitle = ({ workersRequest: workersRequest, organizationType: organizationType })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: workersRequest[organizationType].name + ' / ' + (workersRequest.missionData?.service?.name || ''),
        subTitle: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
            size: 5,
            children: [
                "Postes restant \xe0 pourvoir : ",
                workersRequest.stats.notAssigned,
                " /",
                ' ',
                workersRequest.stats.notAssigned + workersRequest.stats.assigned
            ]
        })
    });
};
var $81fea641c7a956af$export$2e2bcd8739ae039 = $81fea641c7a956af$var$WorkersRequestPageTitle;
const $81fea641c7a956af$export$9eb9467136ef56ff = ({ workersRequest: workersRequest })=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'update'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        mr: 2,
                        size: "small",
                        color: 'danger',
                        onClick: ()=>modal.setIsDisplayed(true),
                        disabled: !workersRequest.__actions.canBeCancelled,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                mr: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$516fd7364fa08290), {})
                            }),
                            "Annuler"
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4cde4ef5f1194541$export$2e2bcd8739ae039), {
                        show: modal.isDisplayed,
                        hide: ()=>modal.setIsDisplayed(false),
                        workersRequest: workersRequest
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        color: 'link',
                        outlined: true,
                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                        size: "small",
                        to: `/workers-requests/new?workersRequestTemplate=${workersRequest._id}`,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                mr: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$10862138e9169702), {})
                            }),
                            "Dupliquer"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                    color: 'link',
                    outlined: true,
                    renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                    size: "small",
                    to: `/workers-requests/${workersRequest._id}/edit`,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {})
                        }),
                        "Modifier"
                    ]
                })
            })
        ]
    });
};
const $81fea641c7a956af$export$152934dff5a4cf0 = ({ workersRequest: workersRequest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
        roles: [
            'employerMember'
        ],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
            color: 'link',
            outlined: true,
            renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
            size: "small",
            to: `/workers-requests/${workersRequest._id}`,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    mr: 1,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$45097e3fcfc06744), {})
                }),
                "Voir la demande"
            ]
        })
    });
};



var $2KSUA = parcelRequire("2KSUA");

var $130e8fd2d93b50ce$export$2e2bcd8739ae039 = {
    history: {
        title: {
            workersRequestCreated: "Demande cr\xe9\xe9e",
            workersRequestUpdated: "Demande mise \xe0 jour",
            workersRequestCancelled: "Demande annul\xe9e",
            missionCreated: (0, $ab3fa70a0ca06441$export$2e2bcd8739ae039).history.title.missionCreated,
            missionCancelled: (0, $ab3fa70a0ca06441$export$2e2bcd8739ae039).history.title.missionCancelled,
            missionReplaced: "Mission remplac\xe9e",
            postUpdated: "Poste mis \xe0 jour",
            postDeleted: "Poste supprim\xe9",
            postCreated: "Poste ajout\xe9"
        },
        changesTitle: {
            'missionData.workPeriods': "Horaire modifi\xe9",
            'missionData.service': "Service modifi\xe9",
            'missionData.jobTitle': "Intitul\xe9 de poste modifi\xe9",
            'jobTitle': "Intitul\xe9 de poste modifi\xe9",
            desiredWorkers: "Travailleurs demand\xe9s",
            recourseCases: 'Cas de Recours',
            recourseCase: 'Cas de Recours',
            'recourseCase.justification': 'Cas de Recours - justification',
            'recourseCase.reason': 'Cas de Recours',
            'posts': "Poste(s) cr\xe9\xe9(s)",
            'isReplaceable': 'Poste ouvert'
        }
    }
};




parcelRequire("3ZYaX");


const $70314483a0c6c85a$var$WorkersRequestHistoryItemCustomContent = ({ historyItem: historyItem })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: historyItem?.missions?.[0] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            mt: 4,
            children: historyItem.missions?.map((mission, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "ul",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "li",
                        style: {
                            textDecoration: historyItem.action === 'missionReplaced' && index !== historyItem.missions.length - 1 ? 'line-through' : 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                user: mission.user
                            }),
                            ' '
                        ]
                    }, mission._id)
                }, index))
        })
    });
};
var $70314483a0c6c85a$export$2e2bcd8739ae039 = $70314483a0c6c85a$var$WorkersRequestHistoryItemCustomContent;




var $2KSUA = parcelRequire("2KSUA");
parcelRequire("3ZYaX");


const $57aebf4ebcb27eee$var$WorkPeriodsDatesDescriptionList = ({ workPeriods: workPeriods })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c288541aa0d2549e$export$2e2bcd8739ae039), {
        items: [
            ...workPeriods.map((workPeriod)=>({
                    label: (0, $2KSUA.upperFirst)((0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(workPeriod.start.date)),
                    value: `${(0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(workPeriod.start.date)} - ${(0, $74f17ceb9b5a08a5$export$3203edd9e5edd663)(workPeriod.end.date)}`
                }))
        ]
    });
};
var $57aebf4ebcb27eee$export$2e2bcd8739ae039 = $57aebf4ebcb27eee$var$WorkPeriodsDatesDescriptionList;





var $3ZYaX = parcelRequire("3ZYaX");






function $30e36549ded1db27$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}



function $41500622c442f1a1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $30e36549ded1db27$export$2e2bcd8739ae039)(dirtyDate, -amount);
}




var $2KSUA = parcelRequire("2KSUA");
/**
 * Finds suggested posts for a workers request
 * @param workersRequest - The workers request
 * @param existingMissions - The existing missions for the workers request
 * @returns The suggested posts for the workers request by order of priority:
 * - Desired workers
 * - Workers with corresponding missions
 * - Available workers
 * - Complete suggested posts
 */ const $dc7a2efd11d26aa1$var$useWorkersRequestPostsSuggestions = ({ workersRequest: workersRequest, correspondingMissions: correspondingMissions = {
    maxMonths: 2
} })=>{
    // Récupérer les posts remplaçables
    const posts = (workersRequest?.posts || []).filter((post)=>post.isReplaceable);
    const hasReplaceablePosts = posts.length > 0;
    // Récupérer les workers disponibles
    const availableWorkersQuery = (0, $e607e015ac40917d$export$c8b4a8759ad58195)({
        workersRequestId: workersRequest?._id
    }, {
        enabled: Boolean(workersRequest) && (0, $8403deec6a28521e$export$6025088343704f9f)([
            'interimAgencyMember'
        ]) && hasReplaceablePosts
    });
    const availableWorkers = (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(availableWorkersQuery.data || [], 'lastName');
    // Récupérer les missions correspondant au poste et à l'employeur
    const jobTitllesIds = new Set(posts.map((post)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(post.jobTitle)));
    const missionsQuery = (0, $e409591b67738e56$export$6ae450315cbb235e)({
        jobTitle: Array.from(jobTitllesIds),
        employer: workersRequest?.employer?._id ? [
            workersRequest?.employer?._id
        ] : [],
        start: (0, $41500622c442f1a1$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()), correspondingMissions.maxMonths || 300),
        //@ts-expect-error
        summary: null,
        populate: [
            'user'
        ]
    }, {
        enabled: Boolean(workersRequest) && Boolean(workersRequest?.employer) && (0, $8403deec6a28521e$export$6025088343704f9f)([
            'interimAgencyMember'
        ]) && posts.length > 0
    });
    const existingMissions = missionsQuery.data || [];
    const allJobTitles = (0, $3ZYaX.useMemo)(()=>{
        return (0, $b31fa4978015d2ce$export$863d7151f7b1a894)(posts.map((post)=>post.jobTitle), '_id');
    }, [
        posts
    ]);
    // Memoize the complete result to avoid recalculating when dependencies haven't changed
    const workers = (0, $3ZYaX.useMemo)(()=>{
        const workers = [];
        availableWorkers.forEach((availableWorker)=>{
            // Récupérer les job titles des posts où le worker est marqué comme désiré
            const desiredJobTitles = new Set(posts.filter((post)=>post.desiredWorkers.some((worker)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(worker, availableWorker))).map((post)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(post.jobTitle)));
            const workerMissions = (0, $2KSUA.sortBy)(existingMissions.filter((mission)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(mission.user, availableWorker)), 'start');
            // Récupérer les job titles des missions correspondant au worker
            const missionCorrespondingJobTitles = new Set(workerMissions.map((mission)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(mission.jobTitle)));
            // Récupérer si le worker est inactif avec l'employeur lié à la demande
            const relationWithEmployer = workersRequest?.employer && availableWorker.employerRelations.find((relation)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(relation.employer, workersRequest.employer));
            const isInactiveWithEmployer = relationWithEmployer?.collaboration?.isInactive || false;
            workers.push({
                ...availableWorker,
                desiredJobTitleIds: Array.from(desiredJobTitles),
                missionCorrespondingJobTitleIds: Array.from(missionCorrespondingJobTitles),
                lastMissionStartDate: workerMissions[0]?.start || null,
                isInactiveWithEmployer: isInactiveWithEmployer
            });
        });
        return workers;
    }, [
        posts,
        availableWorkers,
        existingMissions
    ]);
    return {
        jobTitles: allJobTitles,
        workers: workers,
        availablePosts: posts
    };
};
var $dc7a2efd11d26aa1$export$2e2bcd8739ae039 = $dc7a2efd11d26aa1$var$useWorkersRequestPostsSuggestions;





var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");



var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");





parcelRequire("3ZYaX");




var $2KSUA = parcelRequire("2KSUA");

/**
 * React component that generates a formatted label for a worker in the context of a specific post and workers request
 */ const $e40d2297f3afab1f$var$WorkerInputLabel = ({ user: user, post: post, workersRequest: workersRequest, isDesiredWorker: isDesiredWorker, lastMissionStartDate: lastMissionStartDate })=>{
    const userLabel = (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user);
    const isAvailableForWorkersRequest = (0, $25ffbf4bca475b04$export$38c9d1ec7c4cfeb)(new Date(workersRequest.missionsStart), new Date(workersRequest.missionsEnd), user.availability);
    const absentLabel = !isAvailableForWorkersRequest && (0, $25ffbf4bca475b04$export$12c731bd2c9aa69b)(user.availability, user, true);
    const laborCostCoefficientKind = user.laborCostCoefficients.find((coef)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(coef.employer, workersRequest.employer))?.kind === 'management' ? 'Gestion' : "D\xe9l\xe9gation";
    const employerRelation = user.employerRelations.find((relation)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(relation.employer, workersRequest.employer));
    const isEmployerCollaborationInactive = employerRelation?.collaboration?.isInactive;
    const isDesired = isDesiredWorker || post && post.desiredWorkers?.some((desiredWorker)=>desiredWorker?._id === user._id);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: [
            userLabel,
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "small",
                children: [
                    " - ",
                    laborCostCoefficientKind
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                textSize: 7,
                children: [
                    isDesired && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "success",
                        children: "D\xe9sir\xe9 pour ce poste par l'EU"
                    }),
                    isEmployerCollaborationInactive && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "danger",
                        children: "L'employeur a indiqu\xe9 qu'il ne voulait plus travailler avec cet int\xe9rimaire"
                    }),
                    absentLabel && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "warning",
                        children: [
                            "Absent ",
                            absentLabel.toLowerCase()
                        ]
                    }),
                    lastMissionStartDate && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "grey",
                        children: [
                            "Derni\xe8re mission pour ce poste le ",
                            (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(lastMissionStartDate)
                        ]
                    }),
                    user.internalComment && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: (0, $2KSUA.truncate)(user.internalComment, {
                            length: 70
                        })
                    }),
                    user.internalInformation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: (0, $2KSUA.truncate)(user.internalInformation, {
                            length: 70
                        })
                    })
                ]
            })
        ]
    });
};
var $e40d2297f3afab1f$export$2e2bcd8739ae039 = $e40d2297f3afab1f$var$WorkerInputLabel;


const $22fae21353699bed$var$SelectButton = ({ onClick: onClick, label: label, dataTest: dataTest })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
        size: "small",
        color: "secondary",
        onClick: onClick,
        mr: 2,
        type: "button",
        "data-test": dataTest,
        children: label
    });
};
const $22fae21353699bed$var$SelectPostsList = ({ suggestions: suggestions, workersRequest: workersRequest, currentJobTile: currentJobTile, submitButton: submitButton })=>{
    const { values: values, setFieldValue: setFieldValue } = (0, $31tXu.useFormikContext)();
    const currentWorkersData = suggestions.workers;
    const selectedPostsCount = values.selectedWorkerIds.filter((id)=>id).length;
    // Gérer la sélection de tous les travailleurs
    const handleSelectAll = ()=>{
        const workersCount = currentWorkersData?.length || 0;
        const postsCount = suggestions.availablePosts.length;
        const selectedWorkerIds = [];
        for(let i = 0; i < workersCount; i++){
            const worker = currentWorkersData[i];
            if (selectedWorkerIds.filter(Boolean).length >= postsCount) break;
            if (worker) {
                const workerRelationWithEmployer = worker.employerRelations.find((relation)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(relation.employer, workersRequest.employer));
                const isAvailable = (0, $25ffbf4bca475b04$export$38c9d1ec7c4cfeb)(new Date(workersRequest.missionsStart), new Date(workersRequest.missionsEnd), worker.availability);
                if (workerRelationWithEmployer?.collaboration?.isInactive || !isAvailable) selectedWorkerIds.push(undefined);
                else selectedWorkerIds.push(worker._id);
            }
        }
        setFieldValue('selectedWorkerIds', selectedWorkerIds);
    };
    // Gérer la désélection de tous les travailleurs
    const handleDeselectAll = ()=>{
        setFieldValue('selectedWorkerIds', currentWorkersData?.map(()=>undefined) || []);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        handleDeselectAll();
    }, [
        currentJobTile
    ]);
    if (!currentWorkersData) return null;
    const isMaxSelected = selectedPostsCount === suggestions.availablePosts.length;
    const selectAllCount = suggestions.workers.length < suggestions.availablePosts.length ? suggestions.workers.length : suggestions.availablePosts.length;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: currentWorkersData.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            textSize: 7,
                            textColor: 'grey',
                            children: [
                                `${currentWorkersData?.length} candidats disponibles pour ${suggestions.availablePosts.length} poste(s)`,
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "span",
                                    textColor: selectedPostsCount === 0 ? 'danger' : 'grey',
                                    children: `${selectedPostsCount} s\xe9lectionn\xe9(s)`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            children: [
                                submitButton && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    type: "submit",
                                    color: "primary",
                                    loading: submitButton.loading,
                                    disabled: submitButton.disabled,
                                    fullwidth: true,
                                    "data-test": "auto-assign-posts-form-button",
                                    size: "small",
                                    mr: 2,
                                    children: submitButton.label
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($22fae21353699bed$var$SelectButton, {
                                    onClick: handleSelectAll,
                                    label: `S\xe9lectionner ${selectAllCount} poste(s)`,
                                    dataTest: "select-all-posts"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($22fae21353699bed$var$SelectButton, {
                                    onClick: handleDeselectAll,
                                    label: "D\xe9s\xe9lectionner",
                                    dataTest: "deselect-all-posts"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                name: "selectedWorkerIds",
                children: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            !currentWorkersData.length && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textSize: 6,
                                textAlign: "center",
                                mt: 6,
                                mb: 4,
                                textColor: "grey",
                                children: "Aucun int\xe9rimaire \xe0 afficher"
                            }),
                            currentWorkersData.map((worker, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                    py: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                        name: `selectedWorkerIds.${index}`,
                                        type: "checkbox",
                                        disabled: isMaxSelected && !values.selectedWorkerIds.includes(worker._id) || worker.isInactiveWithEmployer,
                                        text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e40d2297f3afab1f$export$2e2bcd8739ae039), {
                                                user: worker,
                                                post: suggestions.availablePosts[index],
                                                workersRequest: workersRequest,
                                                isDesiredWorker: currentJobTile && worker.desiredJobTitleIds.includes(currentJobTile),
                                                lastMissionStartDate: worker.lastMissionStartDate
                                            })
                                        }),
                                        onChange: (e)=>{
                                            const newSelectedWorkerIds = [
                                                ...values.selectedWorkerIds
                                            ];
                                            if (e.target.checked) {
                                                newSelectedWorkerIds[index] = worker._id;
                                                setFieldValue('selectedWorkerIds', newSelectedWorkerIds);
                                            } else {
                                                newSelectedWorkerIds[index] = '';
                                                setFieldValue('selectedWorkerIds', newSelectedWorkerIds);
                                            }
                                        }
                                    })
                                }, worker._id))
                        ]
                    })
            })
        ]
    });
};
var $22fae21353699bed$export$2e2bcd8739ae039 = $22fae21353699bed$var$SelectPostsList;




parcelRequire("3ZYaX");

/**
 * Full-screen overlay loader component
 * Covers the entire application with a semi-transparent background
 * and displays a centered loading spinner with optional text
 * Uses only React Bulma components and utility classes
 */ const $b3901842d4037f23$var$OverlayLoader = ({ isLoading: isLoading, text: text = 'Chargement...', className: className = '' })=>{
    if (!isLoading) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        className: `is-overlay ${className}`,
        style: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.4)'
        },
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            className: "has-text-centered",
            style: {
                minWidth: '200px',
                minHeight: '150px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem'
            },
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                    className: "mb-4",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: "large",
                        className: "has-text-primary",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                            className: "fas fa-spinner fa-spin"
                        })
                    })
                }),
                text && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    className: "has-text-weight-medium",
                    textSize: 5,
                    textColor: "white",
                    children: text
                })
            ]
        })
    });
};
var $b3901842d4037f23$export$2e2bcd8739ae039 = $b3901842d4037f23$var$OverlayLoader;


const $d478b175b1f712f7$var$TABS = [
    {
        label: "Int\xe9rimaires d\xe9sir\xe9s par l'EU",
        value: 'desired',
        explanation: "Liste des int\xe9rimaires disponibles et d\xe9sir\xe9s par l'EU pour ce poste."
    },
    {
        label: 'Missions correspondantes',
        value: 'corresponding',
        explanation: "Liste des int\xe9rimaires disponibles et ayant une mission correspondante dans les 2 derniers mois."
    },
    {
        label: 'Disponibles',
        value: 'available',
        explanation: "Liste des int\xe9rimaires disponibles pour ce poste."
    }
];
const $d478b175b1f712f7$var$MultipleAssignsForm = ({ onAutoAssign: onAutoAssign, suggestions: suggestions, workersRequest: workersRequest })=>{
    // État local pour l'onglet actif
    const [activeTab, setActiveTab] = (0, $3ZYaX.useState)('desired');
    // Initialiser les données du formulaire
    const initialValues = {
        selectedWorkerIds: [],
        currentJobTile: suggestions.jobTitles[0]?._id || ''
    };
    // Fonction de validation native Formik
    const validate = (values)=>{
        const errors = {};
        const selectedCount = values.selectedWorkerIds.filter((id)=>id).length;
        const maxCount = suggestions.availablePosts.length;
        if (selectedCount === 0) errors.selectedWorkerIds = "Veuillez s\xe9lectionner au moins un post \xe0 auto-assigner";
        else if (selectedCount > maxCount) errors.selectedWorkerIds = `Vous ne pouvez pas s\xe9lectionner plus de ${maxCount} poste(s)`;
        return errors;
    };
    const handleSubmit = async (values, formikHelpers)=>{
        try {
            const selectedWorkerIds = values.selectedWorkerIds.filter(Boolean);
            await onAutoAssign(selectedWorkerIds, suggestions.availablePosts);
            formikHelpers.resetForm();
        } catch (error) {
            console.error('Error during auto-assignation:', error);
        }
    };
    // Filtrer les travailleurs selon l'onglet actif
    const getCurrentWorkersData = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback((type, currentJobTileId)=>{
        const counts = {
            desired: 0,
            corresponding: 0,
            available: suggestions.workers.length
        };
        let workers = suggestions.workers.map((worker)=>{
            const isDesired = Boolean(currentJobTileId) && worker.desiredJobTitleIds.includes(currentJobTileId);
            const hasCorrespondingMission = Boolean(currentJobTileId) && worker.missionCorrespondingJobTitleIds.includes(currentJobTileId);
            if (isDesired) counts.desired++;
            if (hasCorrespondingMission) counts.corresponding++;
            return {
                ...worker,
                isDesired: isDesired,
                hasCorrespondingMission: hasCorrespondingMission,
                isMarkedAsAvailable: true
            };
        });
        if (type !== 'available') workers = workers.filter((worker)=>{
            if (type === 'desired') return worker.isDesired;
            else if (type === 'corresponding') return worker.hasCorrespondingMission;
            return true;
        });
        return {
            workers: workers,
            counts: counts
        };
    }, [
        suggestions.workers
    ]);
    const getCurrentPosts = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback((currentJobTileId)=>{
        return suggestions.availablePosts.filter((post)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(post.jobTitle, currentJobTileId));
    }, [
        suggestions.availablePosts
    ]);
    const currentTab = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return $d478b175b1f712f7$var$TABS.find((tab)=>tab.value === activeTab);
    }, [
        activeTab
    ]);
    const availablePostsByJobTitle = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return suggestions.availablePosts.reduce((acc, post)=>{
            const jobTitleId = post.jobTitle._id;
            if (!acc[jobTitleId]) acc[jobTitleId] = 0;
            acc[jobTitleId]++;
            return acc;
        }, {});
    }, [
        suggestions.availablePosts
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        validate: validate,
        onSubmit: handleSubmit,
        children: ({ isSubmitting: isSubmitting, values: values, setValues: setValues })=>{
            const selectedPostsCount = values.selectedWorkerIds.filter((id)=>id).length;
            const workersData = getCurrentWorkersData(activeTab, values.currentJobTile);
            const workersFilteredByJobTitle = workersData.workers;
            const availablePostsFilteredByJobTitle = getCurrentPosts(values.currentJobTile);
            const submitButtonLabel = isSubmitting ? "Cr\xe9ation des missions en cours..." : `Cr\xe9er ${selectedPostsCount} mission(s)`;
            const submitButtonDisabled = isSubmitting || selectedPostsCount === 0;
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                label: `Choisir le m\xe9tier`,
                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                fullwidth: true,
                                name: "currentJobTile",
                                options: suggestions.jobTitles.map((jobTitle)=>({
                                        label: `${jobTitle.name} - ${availablePostsByJobTitle[jobTitle._id]} poste(s) \xe0 pourvoir`,
                                        value: jobTitle._id
                                    })),
                                help: `La cr\xe9ation de missions multiples est possible uniquement pour un m\xeame m\xe9tier.`
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                            className: "mb-4",
                            children: $d478b175b1f712f7$var$TABS.map((tab)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                    active: activeTab === tab.value,
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        setValues({
                                            ...values,
                                            selectedWorkerIds: []
                                        });
                                        setActiveTab(tab.value);
                                    },
                                    "data-test": `assign-posts-tab-${tab.value}`,
                                    children: [
                                        tab.label,
                                        " (",
                                        workersData.counts[tab.value],
                                        ")"
                                    ]
                                }, tab.value))
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            textColor: "grey",
                            mt: 2,
                            textSize: 7,
                            children: currentTab?.explanation
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $22fae21353699bed$export$2e2bcd8739ae039), {
                            suggestions: {
                                workers: workersFilteredByJobTitle,
                                availablePosts: availablePostsFilteredByJobTitle,
                                jobTitles: suggestions.jobTitles
                            },
                            workersRequest: workersRequest,
                            currentJobTile: values.currentJobTile,
                            submitButton: {
                                label: submitButtonLabel,
                                loading: isSubmitting,
                                disabled: submitButtonDisabled
                            }
                        }),
                        workersFilteredByJobTitle.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                type: "submit",
                                color: "primary",
                                loading: isSubmitting,
                                disabled: submitButtonDisabled,
                                fullwidth: true,
                                "data-test": "auto-assign-posts-form-button",
                                children: submitButtonLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3901842d4037f23$export$2e2bcd8739ae039), {
                            isLoading: isSubmitting,
                            text: `Cr\xe9ation de ${selectedPostsCount} missions en cours...`
                        })
                    ]
                })
            });
        }
    });
};
var $d478b175b1f712f7$export$2e2bcd8739ae039 = $d478b175b1f712f7$var$MultipleAssignsForm;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");



var $3ZYaX = parcelRequire("3ZYaX");



var $9C0qR = parcelRequire("9C0qR");

var $3ZYaX = parcelRequire("3ZYaX");
var $c85ba24bd10adbe3$exports = {};
'use strict';

$c85ba24bd10adbe3$exports = (parcelRequire("lDJSj"));


function $f92d8e7101370c7f$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $f92d8e7101370c7f$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $f92d8e7101370c7f$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $f92d8e7101370c7f$var$e(r.overflowY, n) || $f92d8e7101370c7f$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $f92d8e7101370c7f$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
function $f92d8e7101370c7f$export$2e2bcd8739ae039(e, i) {
    var o = window, l = i.scrollMode, d = i.block, u = i.inline, h = i.boundary, a = i.skipOverflowHiddenElements, c = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$f92d8e7101370c7f$var$t(e)) throw new TypeError("Invalid target");
    for(var f = document.scrollingElement || document.documentElement, s = [], p = e; $f92d8e7101370c7f$var$t(p) && c(p);){
        if ((p = p.parentElement) === f) {
            s.push(p);
            break;
        }
        null != p && p === document.body && $f92d8e7101370c7f$var$n(p) && !$f92d8e7101370c7f$var$n(document.documentElement) || null != p && $f92d8e7101370c7f$var$n(p, a) && s.push(p);
    }
    for(var m = o.visualViewport ? o.visualViewport.width : innerWidth, g = o.visualViewport ? o.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, v = window.scrollY || pageYOffset, W = e.getBoundingClientRect(), b = W.height, H = W.width, y = W.top, E = W.right, M = W.bottom, V = W.left, x = "start" === d || "nearest" === d ? y : "end" === d ? M : y + b / 2, I = "center" === u ? V + H / 2 : "end" === u ? E : V, C = [], T = 0; T < s.length; T++){
        var k = s[T], B = k.getBoundingClientRect(), D = B.height, O = B.width, R = B.top, X = B.right, Y = B.bottom, L = B.left;
        if ("if-needed" === l && y >= 0 && V >= 0 && M <= g && E <= m && y >= R && M <= Y && V >= L && E <= X) return C;
        var S = getComputedStyle(k), j = parseInt(S.borderLeftWidth, 10), q = parseInt(S.borderTopWidth, 10), z = parseInt(S.borderRightWidth, 10), A = parseInt(S.borderBottomWidth, 10), F = 0, G = 0, J = "offsetWidth" in k ? k.offsetWidth - k.clientWidth - j - z : 0, K = "offsetHeight" in k ? k.offsetHeight - k.clientHeight - q - A : 0;
        if (f === k) F = "start" === d ? x : "end" === d ? x - g : "nearest" === d ? $f92d8e7101370c7f$var$r(v, v + g, g, q, A, v + x, v + x + b, b) : x - g / 2, G = "start" === u ? I : "center" === u ? I - m / 2 : "end" === u ? I - m : $f92d8e7101370c7f$var$r(w, w + m, m, j, z, w + I, w + I + H, H), F = Math.max(0, F + v), G = Math.max(0, G + w);
        else {
            F = "start" === d ? x - R - q : "end" === d ? x - Y + A + K : "nearest" === d ? $f92d8e7101370c7f$var$r(R, Y, D, q, A + K, x, x + b, b) : x - (R + D / 2) + K / 2, G = "start" === u ? I - L - j : "center" === u ? I - (L + O / 2) + J / 2 : "end" === u ? I - X + z + J : $f92d8e7101370c7f$var$r(L, X, O, j, z + J, I, I + H, H);
            var N = k.scrollLeft, P = k.scrollTop;
            x += P - (F = Math.max(0, Math.min(P + F, k.scrollHeight - D + K))), I += N - (G = Math.max(0, Math.min(N + G, k.scrollWidth - O + J)));
        }
        C.push({
            el: k,
            top: F,
            left: G
        });
    }
    return C;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $c30f8c0d825001f1$var$extendStatics = function(d, b) {
    $c30f8c0d825001f1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $c30f8c0d825001f1$var$extendStatics(d, b);
};
function $c30f8c0d825001f1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $c30f8c0d825001f1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $c30f8c0d825001f1$export$18ce0697a983be9b = function() {
    $c30f8c0d825001f1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c30f8c0d825001f1$export$18ce0697a983be9b.apply(this, arguments);
};
function $c30f8c0d825001f1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $c30f8c0d825001f1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $c30f8c0d825001f1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $c30f8c0d825001f1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $c30f8c0d825001f1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $c30f8c0d825001f1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $c30f8c0d825001f1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $c30f8c0d825001f1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $c30f8c0d825001f1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c30f8c0d825001f1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $c30f8c0d825001f1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $c30f8c0d825001f1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $c30f8c0d825001f1$export$45d3717a4c69092e(o, m, p);
}
function $c30f8c0d825001f1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $c30f8c0d825001f1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $c30f8c0d825001f1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($c30f8c0d825001f1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $c30f8c0d825001f1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $c30f8c0d825001f1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $c30f8c0d825001f1$export$10c90e4f7922046c(v) {
    return this instanceof $c30f8c0d825001f1$export$10c90e4f7922046c ? (this.v = v, this) : new $c30f8c0d825001f1$export$10c90e4f7922046c(v);
}
function $c30f8c0d825001f1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $c30f8c0d825001f1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $c30f8c0d825001f1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $c30f8c0d825001f1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $c30f8c0d825001f1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $c30f8c0d825001f1$export$19a8beecd37a4c45 === "function" ? $c30f8c0d825001f1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $c30f8c0d825001f1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $c30f8c0d825001f1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $c30f8c0d825001f1$var$ownKeys = function(o) {
    $c30f8c0d825001f1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $c30f8c0d825001f1$var$ownKeys(o);
};
function $c30f8c0d825001f1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $c30f8c0d825001f1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $c30f8c0d825001f1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $c30f8c0d825001f1$var$__setModuleDefault(result, mod);
    return result;
}
function $c30f8c0d825001f1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $c30f8c0d825001f1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $c30f8c0d825001f1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $c30f8c0d825001f1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $c30f8c0d825001f1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $c30f8c0d825001f1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $c30f8c0d825001f1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $c30f8c0d825001f1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $c30f8c0d825001f1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $c30f8c0d825001f1$export$2e2bcd8739ae039 = {
    __extends: $c30f8c0d825001f1$export$a8ba968b8961cb8a,
    __assign: $c30f8c0d825001f1$export$18ce0697a983be9b,
    __rest: $c30f8c0d825001f1$export$3c9a16f847548506,
    __decorate: $c30f8c0d825001f1$export$29e00dfd3077644b,
    __param: $c30f8c0d825001f1$export$d5ad3fd78186038f,
    __esDecorate: $c30f8c0d825001f1$export$3a84e1ae4e97e9b0,
    __runInitializers: $c30f8c0d825001f1$export$d831c04e792af3d,
    __propKey: $c30f8c0d825001f1$export$6a2a36740a146cb8,
    __setFunctionName: $c30f8c0d825001f1$export$d1a06452d3489bc7,
    __metadata: $c30f8c0d825001f1$export$f1db080c865becb9,
    __awaiter: $c30f8c0d825001f1$export$1050f835b63b671e,
    __generator: $c30f8c0d825001f1$export$67ebef60e6f28a6,
    __createBinding: $c30f8c0d825001f1$export$45d3717a4c69092e,
    __exportStar: $c30f8c0d825001f1$export$f33643c0debef087,
    __values: $c30f8c0d825001f1$export$19a8beecd37a4c45,
    __read: $c30f8c0d825001f1$export$8d051b38c9118094,
    __spread: $c30f8c0d825001f1$export$afc72e2116322959,
    __spreadArrays: $c30f8c0d825001f1$export$6388937ca91ccae8,
    __spreadArray: $c30f8c0d825001f1$export$1216008129fb82ed,
    __await: $c30f8c0d825001f1$export$10c90e4f7922046c,
    __asyncGenerator: $c30f8c0d825001f1$export$e427f37a30a4de9b,
    __asyncDelegator: $c30f8c0d825001f1$export$bbd80228419bb833,
    __asyncValues: $c30f8c0d825001f1$export$e3b29a3d6162315f,
    __makeTemplateObject: $c30f8c0d825001f1$export$4fb47efe1390b86f,
    __importStar: $c30f8c0d825001f1$export$c21735bcef00d192,
    __importDefault: $c30f8c0d825001f1$export$da59b14a69baef04,
    __classPrivateFieldGet: $c30f8c0d825001f1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $c30f8c0d825001f1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $c30f8c0d825001f1$export$81fdc39f203e4e04,
    __addDisposableResource: $c30f8c0d825001f1$export$88ac25d8e944e405,
    __disposeResources: $c30f8c0d825001f1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $c30f8c0d825001f1$export$889dfb5d17574b0b
};


let $4c1212f0703a6b7d$var$idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */ function $4c1212f0703a6b7d$var$cbToCb(cb) {
    return typeof cb === 'function' ? cb : $4c1212f0703a6b7d$var$noop;
}
function $4c1212f0703a6b7d$var$noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */ function $4c1212f0703a6b7d$var$scrollIntoView(node, menuNode) {
    if (!node) return;
    const actions = (0, $f92d8e7101370c7f$export$2e2bcd8739ae039)(node, {
        boundary: menuNode,
        block: 'nearest',
        scrollMode: 'if-needed'
    });
    actions.forEach((_ref)=>{
        let { el: el, top: top, left: left } = _ref;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */ function $4c1212f0703a6b7d$var$isOrContainsNode(parent, child, environment) {
    const result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
    return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */ function $4c1212f0703a6b7d$var$debounce(fn, time) {
    let timeoutId;
    function cancel() {
        if (timeoutId) clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        cancel();
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            fn(...args);
        }, time);
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */ function $4c1212f0703a6b7d$var$callAllEventHandlers() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return fns.some((fn)=>{
            if (fn) fn(event, ...args);
            return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
        });
    };
}
function $4c1212f0703a6b7d$var$handleRefs() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return (node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(node);
            else if (ref) ref.current = node;
        });
    };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */ function $4c1212f0703a6b7d$var$generateId() {
    return String($4c1212f0703a6b7d$var$idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */ function $4c1212f0703a6b7d$export$4fba683129f6ab1e() {
    $4c1212f0703a6b7d$var$idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $4c1212f0703a6b7d$var$getA11yStatusMessage$1(_ref2) {
    let { isOpen: isOpen, resultCount: resultCount, previousResultCount: previousResultCount } = _ref2;
    if (!isOpen) return '';
    if (!resultCount) return 'No results are available.';
    if (resultCount !== previousResultCount) return `${resultCount} result${resultCount === 1 ? ' is' : 's are'} available, use up and down arrow keys to navigate. Press Enter key to select.`;
    return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */ function $4c1212f0703a6b7d$var$unwrapArray(arg, defaultValue) {
    arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */ arg[0] : arg;
    if (!arg && defaultValue) return defaultValue;
    else return arg;
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */ function $4c1212f0703a6b7d$var$isDOMElement(element) {
    return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */ function $4c1212f0703a6b7d$var$getElementProps(element) {
    return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */ function $4c1212f0703a6b7d$var$requiredProp(fnName, propName) {
    // eslint-disable-next-line no-console
    console.error(`The property "${propName}" is required in "${fnName}"`);
}
const $4c1212f0703a6b7d$var$stateKeys = [
    'highlightedIndex',
    'inputValue',
    'isOpen',
    'selectedItem',
    'type'
];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */ function $4c1212f0703a6b7d$var$pickState(state) {
    if (state === void 0) state = {};
    const result = {};
    $4c1212f0703a6b7d$var$stateKeys.forEach((k)=>{
        if (state.hasOwnProperty(k)) result[k] = state[k];
    });
    return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */ function $4c1212f0703a6b7d$var$getState(state, props) {
    return Object.keys(state).reduce((prevState, key)=>{
        prevState[key] = $4c1212f0703a6b7d$var$isControlledProp(props, key) ? props[key] : state[key];
        return prevState;
    }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */ function $4c1212f0703a6b7d$var$isControlledProp(props, key) {
    return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */ function $4c1212f0703a6b7d$var$normalizeArrowKey(event) {
    const { key: key, keyCode: keyCode } = event;
    /* istanbul ignore next (ie) */ if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) return `Arrow${key}`;
    return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */ function $4c1212f0703a6b7d$var$isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */ function $4c1212f0703a6b7d$var$getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    if (circular === void 0) circular = true;
    if (itemCount === 0) return -1;
    const itemsLastIndex = itemCount - 1;
    if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    let newIndex = baseIndex + moveAmount;
    if (newIndex < 0) newIndex = circular ? itemsLastIndex : 0;
    else if (newIndex > itemsLastIndex) newIndex = circular ? 0 : itemsLastIndex;
    const nonDisabledNewIndex = $4c1212f0703a6b7d$var$getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
    if (nonDisabledNewIndex === -1) return baseIndex >= itemCount ? -1 : baseIndex;
    return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */ function $4c1212f0703a6b7d$var$getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    const currentElementNode = getItemNodeFromIndex(baseIndex);
    if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) return baseIndex;
    if (moveAmount > 0) for(let index = baseIndex + 1; index < itemCount; index++){
        if (!getItemNodeFromIndex(index).hasAttribute('disabled')) return index;
    }
    else for(let index = baseIndex - 1; index >= 0; index--){
        if (!getItemNodeFromIndex(index).hasAttribute('disabled')) return index;
    }
    if (circular) return moveAmount > 0 ? $4c1212f0703a6b7d$var$getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : $4c1212f0703a6b7d$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
    return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */ function $4c1212f0703a6b7d$var$targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
    if (checkActiveElement === void 0) checkActiveElement = true;
    return downshiftElements.some((contextNode)=>contextNode && ($4c1212f0703a6b7d$var$isOrContainsNode(contextNode, target, environment) || checkActiveElement && $4c1212f0703a6b7d$var$isOrContainsNode(contextNode, environment.document.activeElement, environment)));
} // eslint-disable-next-line import/no-mutable-exports
let $4c1212f0703a6b7d$var$validateControlledUnchanged = $4c1212f0703a6b7d$var$noop;
var $4c1212f0703a6b7d$var$state, $4c1212f0703a6b7d$var$prevProps, $4c1212f0703a6b7d$var$nextProps, $4c1212f0703a6b7d$var$propKey;
const $4c1212f0703a6b7d$var$cleanupStatus = $4c1212f0703a6b7d$var$debounce((documentProp)=>{
    $4c1212f0703a6b7d$var$getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */ function $4c1212f0703a6b7d$var$setStatus(status, documentProp) {
    const div = $4c1212f0703a6b7d$var$getStatusDiv(documentProp);
    if (!status) return;
    div.textContent = status;
    $4c1212f0703a6b7d$var$cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */ function $4c1212f0703a6b7d$var$getStatusDiv(documentProp) {
    if (documentProp === void 0) documentProp = document;
    let statusDiv = documentProp.getElementById('a11y-status-message');
    if (statusDiv) return statusDiv;
    statusDiv = documentProp.createElement('div');
    statusDiv.setAttribute('id', 'a11y-status-message');
    statusDiv.setAttribute('role', 'status');
    statusDiv.setAttribute('aria-live', 'polite');
    statusDiv.setAttribute('aria-relevant', 'additions text');
    Object.assign(statusDiv.style, {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        width: '1px'
    });
    documentProp.body.appendChild(statusDiv);
    return statusDiv;
}
const $4c1212f0703a6b7d$var$unknown = 0;
const $4c1212f0703a6b7d$var$mouseUp = 1;
const $4c1212f0703a6b7d$var$itemMouseEnter = 2;
const $4c1212f0703a6b7d$var$keyDownArrowUp = 3;
const $4c1212f0703a6b7d$var$keyDownArrowDown = 4;
const $4c1212f0703a6b7d$var$keyDownEscape = 5;
const $4c1212f0703a6b7d$var$keyDownEnter = 6;
const $4c1212f0703a6b7d$var$keyDownHome = 7;
const $4c1212f0703a6b7d$var$keyDownEnd = 8;
const $4c1212f0703a6b7d$var$clickItem = 9;
const $4c1212f0703a6b7d$var$blurInput = 10;
const $4c1212f0703a6b7d$var$changeInput = 11;
const $4c1212f0703a6b7d$var$keyDownSpaceButton = 12;
const $4c1212f0703a6b7d$var$clickButton = 13;
const $4c1212f0703a6b7d$var$blurButton = 14;
const $4c1212f0703a6b7d$var$controlledPropUpdatedSelectedItem = 15;
const $4c1212f0703a6b7d$var$touchEnd = 16;
var $4c1212f0703a6b7d$var$stateChangeTypes$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    unknown: $4c1212f0703a6b7d$var$unknown,
    mouseUp: $4c1212f0703a6b7d$var$mouseUp,
    itemMouseEnter: $4c1212f0703a6b7d$var$itemMouseEnter,
    keyDownArrowUp: $4c1212f0703a6b7d$var$keyDownArrowUp,
    keyDownArrowDown: $4c1212f0703a6b7d$var$keyDownArrowDown,
    keyDownEscape: $4c1212f0703a6b7d$var$keyDownEscape,
    keyDownEnter: $4c1212f0703a6b7d$var$keyDownEnter,
    keyDownHome: $4c1212f0703a6b7d$var$keyDownHome,
    keyDownEnd: $4c1212f0703a6b7d$var$keyDownEnd,
    clickItem: $4c1212f0703a6b7d$var$clickItem,
    blurInput: $4c1212f0703a6b7d$var$blurInput,
    changeInput: $4c1212f0703a6b7d$var$changeInput,
    keyDownSpaceButton: $4c1212f0703a6b7d$var$keyDownSpaceButton,
    clickButton: $4c1212f0703a6b7d$var$clickButton,
    blurButton: $4c1212f0703a6b7d$var$blurButton,
    controlledPropUpdatedSelectedItem: $4c1212f0703a6b7d$var$controlledPropUpdatedSelectedItem,
    touchEnd: $4c1212f0703a6b7d$var$touchEnd
});
/* eslint camelcase:0 */ const $4c1212f0703a6b7d$var$Downshift = /*#__PURE__*/ (()=>{
    class Downshift extends (0, $3ZYaX.Component) {
        /**
     * Clear all running timeouts
     */ internalClearTimeouts() {
            this.timeoutIds.forEach((id)=>{
                clearTimeout(id);
            });
            this.timeoutIds = [];
        }
        /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */ getState(stateToMerge) {
            if (stateToMerge === void 0) stateToMerge = this.state;
            return $4c1212f0703a6b7d$var$getState(stateToMerge, this.props);
        }
        getItemCount() {
            // things read better this way. They're in priority order:
            // 1. `this.itemCount`
            // 2. `this.props.itemCount`
            // 3. `this.items.length`
            let itemCount = this.items.length;
            if (this.itemCount != null) itemCount = this.itemCount;
            else if (this.props.itemCount !== undefined) itemCount = this.props.itemCount;
            return itemCount;
        }
        getItemNodeFromIndex(index) {
            return this.props.environment.document.getElementById(this.getItemId(index));
        }
        scrollHighlightedItemIntoView() {
            /* istanbul ignore else (react-native) */ {
                const node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
                this.props.scrollIntoView(node, this._menuNode);
            }
        }
        moveHighlightedIndex(amount, otherStateToSet) {
            const itemCount = this.getItemCount();
            const { highlightedIndex: highlightedIndex } = this.getState();
            if (itemCount > 0) {
                const nextHighlightedIndex = $4c1212f0703a6b7d$var$getNextWrappingIndex(amount, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
            }
        }
        getStateAndHelpers() {
            const { highlightedIndex: highlightedIndex, inputValue: inputValue, selectedItem: selectedItem, isOpen: isOpen } = this.getState();
            const { itemToString: itemToString } = this.props;
            const { id: id } = this;
            const { getRootProps: getRootProps, getToggleButtonProps: getToggleButtonProps, getLabelProps: getLabelProps, getMenuProps: getMenuProps, getInputProps: getInputProps, getItemProps: getItemProps, openMenu: openMenu, closeMenu: closeMenu, toggleMenu: toggleMenu, selectItem: selectItem, selectItemAtIndex: selectItemAtIndex, selectHighlightedItem: selectHighlightedItem, setHighlightedIndex: setHighlightedIndex, clearSelection: clearSelection, clearItems: clearItems, reset: reset, setItemCount: setItemCount, unsetItemCount: unsetItemCount, internalSetState: setState } = this;
            return {
                getRootProps: // prop getters
                getRootProps,
                getToggleButtonProps: getToggleButtonProps,
                getLabelProps: getLabelProps,
                getMenuProps: getMenuProps,
                getInputProps: getInputProps,
                getItemProps: getItemProps,
                reset: // actions
                reset,
                openMenu: openMenu,
                closeMenu: closeMenu,
                toggleMenu: toggleMenu,
                selectItem: selectItem,
                selectItemAtIndex: selectItemAtIndex,
                selectHighlightedItem: selectHighlightedItem,
                setHighlightedIndex: setHighlightedIndex,
                clearSelection: clearSelection,
                clearItems: clearItems,
                setItemCount: setItemCount,
                unsetItemCount: unsetItemCount,
                setState: setState,
                itemToString: // props
                itemToString,
                id: // derived
                id,
                highlightedIndex: // state
                highlightedIndex,
                inputValue: inputValue,
                isOpen: isOpen,
                selectedItem: selectedItem
            };
        }
        componentDidMount() {
            /* istanbul ignore if (react-native) */ {
                // this.isMouseDown helps us track whether the mouse is currently held down.
                // This is useful when the user clicks on an item in the list, but holds the mouse
                // down long enough for the list to disappear (because the blur event fires on the input)
                // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
                // trigger hiding the menu.
                const onMouseDown = ()=>{
                    this.isMouseDown = true;
                };
                const onMouseUp = (event)=>{
                    this.isMouseDown = false; // if the target element or the activeElement is within a downshift node
                    // then we don't want to reset downshift
                    const contextWithinDownshift = $4c1212f0703a6b7d$var$targetWithinDownshift(event.target, [
                        this._rootNode,
                        this._menuNode
                    ], this.props.environment);
                    if (!contextWithinDownshift && this.getState().isOpen) this.reset({
                        type: $4c1212f0703a6b7d$var$mouseUp
                    }, ()=>this.props.onOuterClick(this.getStateAndHelpers()));
                }; // Touching an element in iOS gives focus and hover states, but touching out of
                // the element will remove hover, and persist the focus state, resulting in the
                // blur event not being triggered.
                // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
                // If the user taps outside of Downshift, the component should be reset,
                // but not if the user is swiping
                const onTouchStart = ()=>{
                    this.isTouchMove = false;
                };
                const onTouchMove = ()=>{
                    this.isTouchMove = true;
                };
                const onTouchEnd = (event)=>{
                    const contextWithinDownshift = $4c1212f0703a6b7d$var$targetWithinDownshift(event.target, [
                        this._rootNode,
                        this._menuNode
                    ], this.props.environment, false);
                    if (!this.isTouchMove && !contextWithinDownshift && this.getState().isOpen) this.reset({
                        type: $4c1212f0703a6b7d$var$touchEnd
                    }, ()=>this.props.onOuterClick(this.getStateAndHelpers()));
                };
                const { environment: environment } = this.props;
                environment.addEventListener('mousedown', onMouseDown);
                environment.addEventListener('mouseup', onMouseUp);
                environment.addEventListener('touchstart', onTouchStart);
                environment.addEventListener('touchmove', onTouchMove);
                environment.addEventListener('touchend', onTouchEnd);
                this.cleanup = ()=>{
                    this.internalClearTimeouts();
                    this.updateStatus.cancel();
                    environment.removeEventListener('mousedown', onMouseDown);
                    environment.removeEventListener('mouseup', onMouseUp);
                    environment.removeEventListener('touchstart', onTouchStart);
                    environment.removeEventListener('touchmove', onTouchMove);
                    environment.removeEventListener('touchend', onTouchEnd);
                };
            }
        }
        shouldScroll(prevState, prevProps) {
            const { highlightedIndex: currentHighlightedIndex } = this.props.highlightedIndex === undefined ? this.getState() : this.props;
            const { highlightedIndex: prevHighlightedIndex } = prevProps.highlightedIndex === undefined ? prevState : prevProps;
            const scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
            const scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
            return scrollWhenOpen || scrollWhenNavigating;
        }
        componentDidUpdate(prevProps, prevState) {
            if ($4c1212f0703a6b7d$var$isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) this.internalSetState({
                type: $4c1212f0703a6b7d$var$controlledPropUpdatedSelectedItem,
                inputValue: this.props.itemToString(this.props.selectedItem)
            });
            if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) this.scrollHighlightedItemIntoView();
            this.updateStatus();
        }
        componentWillUnmount() {
            this.cleanup(); // avoids memory leak
        }
        render() {
            const children = $4c1212f0703a6b7d$var$unwrapArray(this.props.children, $4c1212f0703a6b7d$var$noop); // because the items are rerendered every time we call the children
            // we clear this out each render and it will be populated again as
            // getItemProps is called.
            this.clearItems(); // we reset this so we know whether the user calls getRootProps during
            // this render. If they do then we don't need to do anything,
            // if they don't then we need to clone the element they return and
            // apply the props for them.
            this.getRootProps.called = false;
            this.getRootProps.refKey = undefined;
            this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps
            this.getMenuProps.called = false;
            this.getMenuProps.refKey = undefined;
            this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps
            this.getLabelProps.called = false; // and something similar for getInputProps
            this.getInputProps.called = false;
            const element = $4c1212f0703a6b7d$var$unwrapArray(children(this.getStateAndHelpers()));
            if (!element) return null;
            if (this.getRootProps.called || this.props.suppressRefError) return element;
            else if ($4c1212f0703a6b7d$var$isDOMElement(element)) // they didn't apply the root props, but we can clone
            // this and apply the props ourselves
            return /*#__PURE__*/ (0, $3ZYaX.cloneElement)(element, this.getRootProps($4c1212f0703a6b7d$var$getElementProps(element)));
            /* istanbul ignore next */ return undefined;
        }
        constructor(_props){
            var _this;
            super(_props);
            _this = this;
            this.id = this.props.id || `downshift-${$4c1212f0703a6b7d$var$generateId()}`;
            this.menuId = this.props.menuId || `${this.id}-menu`;
            this.labelId = this.props.labelId || `${this.id}-label`;
            this.inputId = this.props.inputId || `${this.id}-input`;
            this.getItemId = this.props.getItemId || ((index)=>`${this.id}-item-${index}`);
            this.input = null;
            this.items = [];
            this.itemCount = null;
            this.previousResultCount = 0;
            this.timeoutIds = [];
            this.internalSetTimeout = (fn, time)=>{
                const id = setTimeout(()=>{
                    this.timeoutIds = this.timeoutIds.filter((i)=>i !== id);
                    fn();
                }, time);
                this.timeoutIds.push(id);
            };
            this.setItemCount = (count)=>{
                this.itemCount = count;
            };
            this.unsetItemCount = ()=>{
                this.itemCount = null;
            };
            this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
                if (highlightedIndex === void 0) highlightedIndex = _this.props.defaultHighlightedIndex;
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $4c1212f0703a6b7d$var$pickState(otherStateToSet);
                _this.internalSetState({
                    highlightedIndex: highlightedIndex,
                    ...otherStateToSet
                });
            };
            this.clearSelection = (cb)=>{
                this.internalSetState({
                    selectedItem: null,
                    inputValue: '',
                    highlightedIndex: this.props.defaultHighlightedIndex,
                    isOpen: this.props.defaultIsOpen
                }, cb);
            };
            this.selectItem = (item, otherStateToSet, cb)=>{
                otherStateToSet = $4c1212f0703a6b7d$var$pickState(otherStateToSet);
                this.internalSetState({
                    isOpen: this.props.defaultIsOpen,
                    highlightedIndex: this.props.defaultHighlightedIndex,
                    selectedItem: item,
                    inputValue: this.props.itemToString(item),
                    ...otherStateToSet
                }, cb);
            };
            this.selectItemAtIndex = (itemIndex, otherStateToSet, cb)=>{
                const item = this.items[itemIndex];
                if (item == null) return;
                this.selectItem(item, otherStateToSet, cb);
            };
            this.selectHighlightedItem = (otherStateToSet, cb)=>{
                return this.selectItemAtIndex(this.getState().highlightedIndex, otherStateToSet, cb);
            };
            this.internalSetState = (stateToSet, cb)=>{
                let isItemSelected, onChangeArg;
                const onStateChangeArg = {};
                const isStateToSetFunction = typeof stateToSet === 'function'; // we want to call `onInputValueChange` before the `setState` call
                // so someone controlling the `inputValue` state gets notified of
                // the input change as soon as possible. This avoids issues with
                // preserving the cursor position.
                // See https://github.com/downshift-js/downshift/issues/217 for more info.
                if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) this.props.onInputValueChange(stateToSet.inputValue, {
                    ...this.getStateAndHelpers(),
                    ...stateToSet
                });
                return this.setState((state)=>{
                    state = this.getState(state);
                    let newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.
                    newStateToSet = this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
                    // what was selected before
                    // used to determine if onSelect and onChange callbacks should be called
                    isItemSelected = newStateToSet.hasOwnProperty('selectedItem'); // this keeps track of the object we want to call with setState
                    const nextState = {}; // this is just used to tell whether the state changed
                    // and we're trying to update that state. OR if the selection has changed and we're
                    // trying to update the selection
                    if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) onChangeArg = newStateToSet.selectedItem;
                    newStateToSet.type = newStateToSet.type || $4c1212f0703a6b7d$var$unknown;
                    Object.keys(newStateToSet).forEach((key)=>{
                        // onStateChangeArg should only have the state that is
                        // actually changing
                        if (state[key] !== newStateToSet[key]) onStateChangeArg[key] = newStateToSet[key];
                         // the type is useful for the onStateChangeArg
                        // but we don't actually want to set it in internal state.
                        // this is an undocumented feature for now... Not all internalSetState
                        // calls support it and I'm not certain we want them to yet.
                        // But it enables users controlling the isOpen state to know when
                        // the isOpen state changes due to mouseup events which is quite handy.
                        if (key === 'type') return;
                        newStateToSet[key]; // if it's coming from props, then we don't care to set it internally
                        if (!$4c1212f0703a6b7d$var$isControlledProp(this.props, key)) nextState[key] = newStateToSet[key];
                    }); // if stateToSet is a function, then we weren't able to call onInputValueChange
                    // earlier, so we'll call it now that we know what the inputValue state will be.
                    if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) this.props.onInputValueChange(newStateToSet.inputValue, {
                        ...this.getStateAndHelpers(),
                        ...newStateToSet
                    });
                    return nextState;
                }, ()=>{
                    // call the provided callback if it's a function
                    $4c1212f0703a6b7d$var$cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
                    // we have relevant information to pass them.
                    const hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
                    if (hasMoreStateThanType) this.props.onStateChange(onStateChangeArg, this.getStateAndHelpers());
                    if (isItemSelected) this.props.onSelect(stateToSet.selectedItem, this.getStateAndHelpers());
                    if (onChangeArg !== undefined) this.props.onChange(onChangeArg, this.getStateAndHelpers());
                     // this is currently undocumented and therefore subject to change
                    // We'll try to not break it, but just be warned.
                    this.props.onUserAction(onStateChangeArg, this.getStateAndHelpers());
                });
            };
            this.rootRef = (node)=>this._rootNode = node;
            this.getRootProps = function(_temp, _temp2) {
                let { refKey: refKey = 'ref', ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
                let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
                // this is used in the render to know whether the user has called getRootProps.
                // It uses that to know whether to apply the props automatically
                _this.getRootProps.called = true;
                _this.getRootProps.refKey = refKey;
                _this.getRootProps.suppressRefError = suppressRefError;
                const { isOpen: isOpen } = _this.getState();
                return {
                    [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, _this.rootRef),
                    role: 'combobox',
                    'aria-expanded': isOpen,
                    'aria-haspopup': 'listbox',
                    'aria-owns': isOpen ? _this.menuId : null,
                    'aria-labelledby': _this.labelId,
                    ...rest
                };
            };
            this.keyDownHandlers = {
                ArrowDown (event) {
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        const amount = event.shiftKey ? 5 : 1;
                        this.moveHighlightedIndex(amount, {
                            type: $4c1212f0703a6b7d$var$keyDownArrowDown
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $4c1212f0703a6b7d$var$keyDownArrowDown
                    }, ()=>{
                        const itemCount = this.getItemCount();
                        if (itemCount > 0) {
                            const { highlightedIndex: highlightedIndex } = this.getState();
                            const nextHighlightedIndex = $4c1212f0703a6b7d$var$getNextWrappingIndex(1, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                            this.setHighlightedIndex(nextHighlightedIndex, {
                                type: $4c1212f0703a6b7d$var$keyDownArrowDown
                            });
                        }
                    });
                },
                ArrowUp (event) {
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        const amount = event.shiftKey ? -5 : -1;
                        this.moveHighlightedIndex(amount, {
                            type: $4c1212f0703a6b7d$var$keyDownArrowUp
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $4c1212f0703a6b7d$var$keyDownArrowUp
                    }, ()=>{
                        const itemCount = this.getItemCount();
                        if (itemCount > 0) {
                            const { highlightedIndex: highlightedIndex } = this.getState();
                            const nextHighlightedIndex = $4c1212f0703a6b7d$var$getNextWrappingIndex(-1, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                            this.setHighlightedIndex(nextHighlightedIndex, {
                                type: $4c1212f0703a6b7d$var$keyDownArrowUp
                            });
                        }
                    });
                },
                Enter (event) {
                    if (event.which === 229) return;
                    const { isOpen: isOpen, highlightedIndex: highlightedIndex } = this.getState();
                    if (isOpen && highlightedIndex != null) {
                        event.preventDefault();
                        const item = this.items[highlightedIndex];
                        const itemNode = this.getItemNodeFromIndex(highlightedIndex);
                        if (item == null || itemNode && itemNode.hasAttribute('disabled')) return;
                        this.selectHighlightedItem({
                            type: $4c1212f0703a6b7d$var$keyDownEnter
                        });
                    }
                },
                Escape (event) {
                    event.preventDefault();
                    this.reset({
                        type: $4c1212f0703a6b7d$var$keyDownEscape,
                        ...!this.state.isOpen && {
                            selectedItem: null,
                            inputValue: ''
                        }
                    });
                }
            };
            this.buttonKeyDownHandlers = {
                ...this.keyDownHandlers,
                ' ' (event) {
                    event.preventDefault();
                    this.toggleMenu({
                        type: $4c1212f0703a6b7d$var$keyDownSpaceButton
                    });
                }
            };
            this.inputKeyDownHandlers = {
                ...this.keyDownHandlers,
                Home (event) {
                    const { isOpen: isOpen } = this.getState();
                    if (!isOpen) return;
                    event.preventDefault();
                    const itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                     // get next non-disabled starting downwards from 0 if that's disabled.
                    const newHighlightedIndex = $4c1212f0703a6b7d$var$getNextNonDisabledIndex(1, 0, itemCount, (index)=>this.getItemNodeFromIndex(index), false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $4c1212f0703a6b7d$var$keyDownHome
                    });
                },
                End (event) {
                    const { isOpen: isOpen } = this.getState();
                    if (!isOpen) return;
                    event.preventDefault();
                    const itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                     // get next non-disabled starting upwards from last index if that's disabled.
                    const newHighlightedIndex = $4c1212f0703a6b7d$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, (index)=>this.getItemNodeFromIndex(index), false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $4c1212f0703a6b7d$var$keyDownEnd
                    });
                }
            };
            this.getToggleButtonProps = function(_temp3) {
                let { onClick: onClick, onPress: onPress, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onBlur: onBlur, ...rest } = _temp3 === void 0 ? {} : _temp3;
                const { isOpen: isOpen } = _this.getState();
                const enabledEventHandlers = {
                    onClick: $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, _this.buttonHandleClick),
                    onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
                    onKeyUp: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
                    onBlur: $4c1212f0703a6b7d$var$callAllEventHandlers(onBlur, _this.buttonHandleBlur)
                };
                const eventHandlers = rest.disabled ? {} : enabledEventHandlers;
                return {
                    type: 'button',
                    role: 'button',
                    'aria-label': isOpen ? 'close menu' : 'open menu',
                    'aria-haspopup': true,
                    'data-toggle': true,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.buttonHandleKeyUp = (event)=>{
                // Prevent click event from emitting in Firefox
                event.preventDefault();
            };
            this.buttonHandleKeyDown = (event)=>{
                const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
                if (this.buttonKeyDownHandlers[key]) this.buttonKeyDownHandlers[key].call(this, event);
            };
            this.buttonHandleClick = (event)=>{
                event.preventDefault(); // handle odd case for Safari and Firefox which
                // don't give the button the focus properly.
                /* istanbul ignore if (can't reasonably test this) */ if (this.props.environment.document.activeElement === this.props.environment.document.body) event.target.focus();
                 // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
                // Ensure that toggle of menu occurs after the potential blur event in iOS
                this.internalSetTimeout(()=>this.toggleMenu({
                        type: $4c1212f0703a6b7d$var$clickButton
                    }));
            };
            this.buttonHandleBlur = (event)=>{
                const blurTarget = event.target; // Save blur target for comparison with activeElement later
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
                this.internalSetTimeout(()=>{
                    if (!this.isMouseDown && (this.props.environment.document.activeElement == null || this.props.environment.document.activeElement.id !== this.inputId) && this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
                    ) this.reset({
                        type: $4c1212f0703a6b7d$var$blurButton
                    });
                });
            };
            this.getLabelProps = (props)=>{
                return {
                    htmlFor: this.inputId,
                    id: this.labelId,
                    ...props
                };
            };
            this.getInputProps = function(_temp4) {
                let { onKeyDown: onKeyDown, onBlur: onBlur, onChange: onChange, onInput: onInput, onChangeText: onChangeText, ...rest } = _temp4 === void 0 ? {} : _temp4;
                let onChangeKey;
                let eventHandlers = {};
                onChangeKey = 'onChange';
                const { inputValue: inputValue, isOpen: isOpen, highlightedIndex: highlightedIndex } = _this.getState();
                if (!rest.disabled) eventHandlers = {
                    [onChangeKey]: $4c1212f0703a6b7d$var$callAllEventHandlers(onChange, onInput, _this.inputHandleChange),
                    onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown),
                    onBlur: $4c1212f0703a6b7d$var$callAllEventHandlers(onBlur, _this.inputHandleBlur)
                };
                return {
                    'aria-autocomplete': 'list',
                    'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
                    'aria-controls': isOpen ? _this.menuId : null,
                    'aria-labelledby': _this.labelId,
                    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                    // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
                    autoComplete: 'off',
                    value: inputValue,
                    id: _this.inputId,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.inputHandleKeyDown = (event)=>{
                const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
                if (key && this.inputKeyDownHandlers[key]) this.inputKeyDownHandlers[key].call(this, event);
            };
            this.inputHandleChange = (event)=>{
                this.internalSetState({
                    type: $4c1212f0703a6b7d$var$changeInput,
                    isOpen: true,
                    inputValue: event.target.value,
                    highlightedIndex: this.props.defaultHighlightedIndex
                });
            };
            this.inputHandleBlur = ()=>{
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
                this.internalSetTimeout(()=>{
                    const downshiftButtonIsActive = this.props.environment.document && !!this.props.environment.document.activeElement && !!this.props.environment.document.activeElement.dataset && this.props.environment.document.activeElement.dataset.toggle && this._rootNode && this._rootNode.contains(this.props.environment.document.activeElement);
                    if (!this.isMouseDown && !downshiftButtonIsActive) this.reset({
                        type: $4c1212f0703a6b7d$var$blurInput
                    });
                });
            };
            this.menuRef = (node)=>{
                this._menuNode = node;
            };
            this.getMenuProps = function(_temp5, _temp6) {
                let { refKey: refKey = 'ref', ref: ref, ...props } = _temp5 === void 0 ? {} : _temp5;
                let { suppressRefError: suppressRefError = false } = _temp6 === void 0 ? {} : _temp6;
                _this.getMenuProps.called = true;
                _this.getMenuProps.refKey = refKey;
                _this.getMenuProps.suppressRefError = suppressRefError;
                return {
                    [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, _this.menuRef),
                    role: 'listbox',
                    'aria-labelledby': props && props['aria-label'] ? null : _this.labelId,
                    id: _this.menuId,
                    ...props
                };
            };
            this.getItemProps = function(_temp7) {
                let { onMouseMove: onMouseMove, onMouseDown: onMouseDown, onClick: onClick, onPress: onPress, index: index, item: item, ...rest } = _temp7 === void 0 ? {} : _temp7;
                if (index === undefined) {
                    _this.items.push(item);
                    index = _this.items.indexOf(item);
                } else _this.items[index] = item;
                const onSelectKey = 'onClick';
                const customClickHandler = onClick;
                const enabledEventHandlers = {
                    // onMouseMove is used over onMouseEnter here. onMouseMove
                    // is only triggered on actual mouse movement while onMouseEnter
                    // can fire on DOM changes, interrupting keyboard navigation
                    onMouseMove: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseMove, ()=>{
                        if (index === _this.getState().highlightedIndex) return;
                        _this.setHighlightedIndex(index, {
                            type: $4c1212f0703a6b7d$var$itemMouseEnter
                        }); // We never want to manually scroll when changing state based
                        // on `onMouseMove` because we will be moving the element out
                        // from under the user which is currently scrolling/moving the
                        // cursor
                        _this.avoidScrolling = true;
                        _this.internalSetTimeout(()=>_this.avoidScrolling = false, 250);
                    }),
                    onMouseDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseDown, (event)=>{
                        // This prevents the activeElement from being changed
                        // to the item so it can remain with the current activeElement
                        // which is a more common use case.
                        event.preventDefault();
                    }),
                    [onSelectKey]: $4c1212f0703a6b7d$var$callAllEventHandlers(customClickHandler, ()=>{
                        _this.selectItemAtIndex(index, {
                            type: $4c1212f0703a6b7d$var$clickItem
                        });
                    })
                }; // Passing down the onMouseDown handler to prevent redirect
                // of the activeElement if clicking on disabled items
                const eventHandlers = rest.disabled ? {
                    onMouseDown: enabledEventHandlers.onMouseDown
                } : enabledEventHandlers;
                return {
                    id: _this.getItemId(index),
                    role: 'option',
                    'aria-selected': _this.getState().highlightedIndex === index,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.clearItems = ()=>{
                this.items = [];
            };
            this.reset = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $4c1212f0703a6b7d$var$pickState(otherStateToSet);
                _this.internalSetState((_ref)=>{
                    let { selectedItem: selectedItem } = _ref;
                    return {
                        isOpen: _this.props.defaultIsOpen,
                        highlightedIndex: _this.props.defaultHighlightedIndex,
                        inputValue: _this.props.itemToString(selectedItem),
                        ...otherStateToSet
                    };
                }, cb);
            };
            this.toggleMenu = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $4c1212f0703a6b7d$var$pickState(otherStateToSet);
                _this.internalSetState((_ref2)=>{
                    let { isOpen: isOpen } = _ref2;
                    return {
                        isOpen: !isOpen,
                        ...isOpen && {
                            highlightedIndex: _this.props.defaultHighlightedIndex
                        },
                        ...otherStateToSet
                    };
                }, ()=>{
                    const { isOpen: isOpen, highlightedIndex: highlightedIndex } = _this.getState();
                    if (isOpen) {
                        if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
                    }
                    $4c1212f0703a6b7d$var$cbToCb(cb)();
                });
            };
            this.openMenu = (cb)=>{
                this.internalSetState({
                    isOpen: true
                }, cb);
            };
            this.closeMenu = (cb)=>{
                this.internalSetState({
                    isOpen: false
                }, cb);
            };
            this.updateStatus = $4c1212f0703a6b7d$var$debounce(()=>{
                const state = this.getState();
                const item = this.items[state.highlightedIndex];
                const resultCount = this.getItemCount();
                const status = this.props.getA11yStatusMessage({
                    itemToString: this.props.itemToString,
                    previousResultCount: this.previousResultCount,
                    resultCount: resultCount,
                    highlightedItem: item,
                    ...state
                });
                this.previousResultCount = resultCount;
                $4c1212f0703a6b7d$var$setStatus(status, this.props.environment.document);
            }, 200);
            // fancy destructuring + defaults + aliases
            // this basically says each value of state should either be set to
            // the initial value or the default value if the initial value is not provided
            const { defaultHighlightedIndex: defaultHighlightedIndex, initialHighlightedIndex: _highlightedIndex = defaultHighlightedIndex, defaultIsOpen: defaultIsOpen, initialIsOpen: _isOpen = defaultIsOpen, initialInputValue: _inputValue = '', initialSelectedItem: _selectedItem = null } = this.props;
            const _state = this.getState({
                highlightedIndex: _highlightedIndex,
                isOpen: _isOpen,
                inputValue: _inputValue,
                selectedItem: _selectedItem
            });
            if (_state.selectedItem != null && this.props.initialInputValue === undefined) _state.inputValue = this.props.itemToString(_state.selectedItem);
            this.state = _state;
        }
    }
    Downshift.defaultProps = {
        defaultHighlightedIndex: null,
        defaultIsOpen: false,
        getA11yStatusMessage: $4c1212f0703a6b7d$var$getA11yStatusMessage$1,
        itemToString: (i)=>{
            if (i == null) return '';
            return String(i);
        },
        onStateChange: $4c1212f0703a6b7d$var$noop,
        onInputValueChange: $4c1212f0703a6b7d$var$noop,
        onUserAction: $4c1212f0703a6b7d$var$noop,
        onChange: $4c1212f0703a6b7d$var$noop,
        onSelect: $4c1212f0703a6b7d$var$noop,
        onOuterClick: $4c1212f0703a6b7d$var$noop,
        selectedItemChanged: (prevItem, item)=>prevItem !== item,
        environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' ? {} : window,
        stateReducer: (state, stateToSet)=>stateToSet,
        suppressRefError: false,
        scrollIntoView: $4c1212f0703a6b7d$var$scrollIntoView
    };
    Downshift.stateChangeTypes = $4c1212f0703a6b7d$var$stateChangeTypes$3;
    return Downshift;
})();
var $4c1212f0703a6b7d$export$2e2bcd8739ae039 = $4c1212f0703a6b7d$var$Downshift;
function $4c1212f0703a6b7d$var$validateGetMenuPropsCalledCorrectly(node, _ref3) {
    let { refKey: refKey } = _ref3;
    if (!node) // eslint-disable-next-line no-console
    console.error(`downshift: The ref prop "${refKey}" from getMenuProps was not applied correctly on your menu element.`);
}
function $4c1212f0703a6b7d$var$validateGetRootPropsCalledCorrectly(element, _ref4) {
    let { refKey: refKey } = _ref4;
    const refKeySpecified = refKey !== 'ref';
    const isComposite = !$4c1212f0703a6b7d$var$isDOMElement(element);
    if (isComposite && !refKeySpecified && !(0, $c85ba24bd10adbe3$exports.isForwardRef)(element)) // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
    else if (!isComposite && refKeySpecified) // eslint-disable-next-line no-console
    console.error(`downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "${refKey}"`);
    if (!(0, $c85ba24bd10adbe3$exports.isForwardRef)(element) && !$4c1212f0703a6b7d$var$getElementProps(element)[refKey]) // eslint-disable-next-line no-console
    console.error(`downshift: You must apply the ref prop "${refKey}" from getRootProps onto your root element.`);
}
const $4c1212f0703a6b7d$var$dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: false,
    selectedItem: null,
    inputValue: ''
};
function $4c1212f0703a6b7d$var$callOnChangeProps(action, state, newState) {
    const { props: props, type: type } = action;
    const changes = {};
    Object.keys(state).forEach((key)=>{
        $4c1212f0703a6b7d$var$invokeOnChangeHandler(key, action, state, newState);
        if (newState[key] !== state[key]) changes[key] = newState[key];
    });
    if (props.onStateChange && Object.keys(changes).length) props.onStateChange({
        type: type,
        ...changes
    });
}
function $4c1212f0703a6b7d$var$invokeOnChangeHandler(key, action, state, newState) {
    const { props: props, type: type } = action;
    const handler = `on${$4c1212f0703a6b7d$var$capitalizeString(key)}Change`;
    if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) props[handler]({
        type: type,
        ...newState
    });
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */ function $4c1212f0703a6b7d$var$stateReducer(s, a) {
    return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $4c1212f0703a6b7d$var$getA11ySelectionMessage(selectionParameters) {
    const { selectedItem: selectedItem, itemToString: itemToStringLocal } = selectionParameters;
    return selectedItem ? `${itemToStringLocal(selectedItem)} has been selected.` : '';
}
/**
 * Debounced call for updating the a11y message.
 */ const $4c1212f0703a6b7d$var$updateA11yStatus = $4c1212f0703a6b7d$var$debounce((getA11yMessage, document1)=>{
    $4c1212f0703a6b7d$var$setStatus(getA11yMessage(), document1);
}, 200); // istanbul ignore next
const $4c1212f0703a6b7d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $3ZYaX.useLayoutEffect) : (0, $3ZYaX.useEffect);
function $4c1212f0703a6b7d$var$useElementIds(_ref) {
    let { id: id = `downshift-${$4c1212f0703a6b7d$var$generateId()}`, labelId: labelId, menuId: menuId, getItemId: getItemId, toggleButtonId: toggleButtonId, inputId: inputId } = _ref;
    const elementIdsRef = (0, $3ZYaX.useRef)({
        labelId: labelId || `${id}-label`,
        menuId: menuId || `${id}-menu`,
        getItemId: getItemId || ((index)=>`${id}-item-${index}`),
        toggleButtonId: toggleButtonId || `${id}-toggle-button`,
        inputId: inputId || `${id}-input`
    });
    return elementIdsRef.current;
}
function $4c1212f0703a6b7d$var$getItemIndex(index, item, items) {
    if (index !== undefined) return index;
    if (items.length === 0) return -1;
    return items.indexOf(item);
}
function $4c1212f0703a6b7d$var$itemToString(item) {
    return item ? String(item) : '';
}
function $4c1212f0703a6b7d$var$isAcceptedCharacterKey(key) {
    return /^\S{1}$/.test(key);
}
function $4c1212f0703a6b7d$var$capitalizeString(string) {
    return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
}
function $4c1212f0703a6b7d$var$useLatestRef(val) {
    const ref = (0, $3ZYaX.useRef)(val); // technically this is not "concurrent mode safe" because we're manipulating
    // the value during render (so it's not idempotent). However, the places this
    // hook is used is to support memoizing callbacks which will be called
    // *during* render, so we need the latest values *during* render.
    // If not for this, then we'd probably want to use useLayoutEffect instead.
    ref.current = val;
    return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $4c1212f0703a6b7d$var$useEnhancedReducer(reducer, initialState, props) {
    const prevStateRef = (0, $3ZYaX.useRef)();
    const actionRef = (0, $3ZYaX.useRef)();
    const enhancedReducer = (0, $3ZYaX.useCallback)((state, action)=>{
        actionRef.current = action;
        state = $4c1212f0703a6b7d$var$getState(state, action.props);
        const changes = reducer(state, action);
        const newState = action.props.stateReducer(state, {
            ...action,
            changes: changes
        });
        return newState;
    }, [
        reducer
    ]);
    const [state, dispatch] = (0, $3ZYaX.useReducer)(enhancedReducer, initialState);
    const propsRef = $4c1212f0703a6b7d$var$useLatestRef(props);
    const dispatchWithProps = (0, $3ZYaX.useCallback)((action)=>dispatch({
            props: propsRef.current,
            ...action
        }), [
        propsRef
    ]);
    const action = actionRef.current;
    (0, $3ZYaX.useEffect)(()=>{
        if (action && prevStateRef.current && prevStateRef.current !== state) $4c1212f0703a6b7d$var$callOnChangeProps(action, $4c1212f0703a6b7d$var$getState(prevStateRef.current, action.props), state);
        prevStateRef.current = state;
    }, [
        state,
        props,
        action
    ]);
    return [
        state,
        dispatchWithProps
    ];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $4c1212f0703a6b7d$var$useControlledReducer$1(reducer, initialState, props) {
    const [state, dispatch] = $4c1212f0703a6b7d$var$useEnhancedReducer(reducer, initialState, props);
    return [
        $4c1212f0703a6b7d$var$getState(state, props),
        dispatch
    ];
}
const $4c1212f0703a6b7d$var$defaultProps$3 = {
    itemToString: $4c1212f0703a6b7d$var$itemToString,
    stateReducer: $4c1212f0703a6b7d$var$stateReducer,
    getA11ySelectionMessage: $4c1212f0703a6b7d$var$getA11ySelectionMessage,
    scrollIntoView: $4c1212f0703a6b7d$var$scrollIntoView,
    circularNavigation: false,
    environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' ? {} : window
};
function $4c1212f0703a6b7d$var$getDefaultValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $4c1212f0703a6b7d$var$dropdownDefaultStateValues;
    const defaultValue = props[`default${$4c1212f0703a6b7d$var$capitalizeString(propKey)}`];
    if (defaultValue !== undefined) return defaultValue;
    return defaultStateValues[propKey];
}
function $4c1212f0703a6b7d$var$getInitialValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $4c1212f0703a6b7d$var$dropdownDefaultStateValues;
    const value = props[propKey];
    if (value !== undefined) return value;
    const initialValue = props[`initial${$4c1212f0703a6b7d$var$capitalizeString(propKey)}`];
    if (initialValue !== undefined) return initialValue;
    return $4c1212f0703a6b7d$var$getDefaultValue$1(props, propKey, defaultStateValues);
}
function $4c1212f0703a6b7d$var$getInitialState$2(props) {
    const selectedItem = $4c1212f0703a6b7d$var$getInitialValue$1(props, 'selectedItem');
    const isOpen = $4c1212f0703a6b7d$var$getInitialValue$1(props, 'isOpen');
    const highlightedIndex = $4c1212f0703a6b7d$var$getInitialValue$1(props, 'highlightedIndex');
    const inputValue = $4c1212f0703a6b7d$var$getInitialValue$1(props, 'inputValue');
    return {
        highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
function $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
    const { items: items, initialHighlightedIndex: initialHighlightedIndex, defaultHighlightedIndex: defaultHighlightedIndex } = props;
    const { selectedItem: selectedItem, highlightedIndex: highlightedIndex } = state;
    if (items.length === 0) return -1;
     // initialHighlightedIndex will give value to highlightedIndex on initial state only.
    if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) return initialHighlightedIndex;
    if (defaultHighlightedIndex !== undefined) return defaultHighlightedIndex;
    if (selectedItem) {
        if (offset === 0) return items.indexOf(selectedItem);
        return $4c1212f0703a6b7d$var$getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
    }
    if (offset === 0) return -1;
    return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */ function $4c1212f0703a6b7d$var$useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
    const mouseAndTouchTrackersRef = (0, $3ZYaX.useRef)({
        isMouseDown: false,
        isTouchMove: false
    });
    (0, $3ZYaX.useEffect)(()=>{
        // The same strategy for checking if a click occurred inside or outside downsift
        // as in downshift.js.
        const onMouseDown = ()=>{
            mouseAndTouchTrackersRef.current.isMouseDown = true;
        };
        const onMouseUp = (event)=>{
            mouseAndTouchTrackersRef.current.isMouseDown = false;
            if (isOpen && !$4c1212f0703a6b7d$var$targetWithinDownshift(event.target, downshiftElementRefs.map((ref)=>ref.current), environment)) handleBlur();
        };
        const onTouchStart = ()=>{
            mouseAndTouchTrackersRef.current.isTouchMove = false;
        };
        const onTouchMove = ()=>{
            mouseAndTouchTrackersRef.current.isTouchMove = true;
        };
        const onTouchEnd = (event)=>{
            if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !$4c1212f0703a6b7d$var$targetWithinDownshift(event.target, downshiftElementRefs.map((ref)=>ref.current), environment, false)) handleBlur();
        };
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);
        return function cleanup() {
            environment.removeEventListener('mousedown', onMouseDown);
            environment.removeEventListener('mouseup', onMouseUp);
            environment.removeEventListener('touchstart', onTouchStart);
            environment.removeEventListener('touchmove', onTouchMove);
            environment.removeEventListener('touchend', onTouchEnd);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        environment
    ]);
    return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */ // eslint-disable-next-line import/no-mutable-exports
let $4c1212f0703a6b7d$var$useGetterPropsCalledChecker = ()=>$4c1212f0703a6b7d$var$noop;
function $4c1212f0703a6b7d$var$useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
    let { isInitialMount: isInitialMount, highlightedIndex: highlightedIndex, items: items, environment: environment, ...rest } = _ref2;
    // Sets a11y status message on changes in state.
    (0, $3ZYaX.useEffect)(()=>{
        if (isInitialMount || false) return;
        $4c1212f0703a6b7d$var$updateA11yStatus(()=>getA11yMessage({
                highlightedIndex: highlightedIndex,
                highlightedItem: items[highlightedIndex],
                resultCount: items.length,
                ...rest
            }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);
}
function $4c1212f0703a6b7d$var$useScrollIntoView(_ref3) {
    let { highlightedIndex: highlightedIndex, isOpen: isOpen, itemRefs: itemRefs, getItemNodeFromIndex: getItemNodeFromIndex, menuElement: menuElement, scrollIntoView: scrollIntoViewProp } = _ref3;
    // used not to scroll on highlight by mouse.
    const shouldScrollRef = (0, $3ZYaX.useRef)(true); // Scroll on highlighted item if change comes from keyboard.
    $4c1212f0703a6b7d$var$useIsomorphicLayoutEffect(()=>{
        if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) return;
        if (shouldScrollRef.current === false) shouldScrollRef.current = true;
        else scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightedIndex
    ]);
    return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports
let $4c1212f0703a6b7d$var$useControlPropsValidator = $4c1212f0703a6b7d$var$noop;
var $4c1212f0703a6b7d$var$_ref4;
/* eslint-disable complexity */ function $4c1212f0703a6b7d$var$downshiftCommonReducer(state, action, stateChangeTypes) {
    const { type: type, props: props } = action;
    let changes;
    switch(type){
        case stateChangeTypes.ItemMouseMove:
            changes = {
                highlightedIndex: action.disabled ? -1 : action.index
            };
            break;
        case stateChangeTypes.MenuMouseLeave:
            changes = {
                highlightedIndex: -1
            };
            break;
        case stateChangeTypes.ToggleButtonClick:
        case stateChangeTypes.FunctionToggleMenu:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionOpenMenu:
            changes = {
                isOpen: true,
                highlightedIndex: $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionCloseMenu:
            changes = {
                isOpen: false
            };
            break;
        case stateChangeTypes.FunctionSetHighlightedIndex:
            changes = {
                highlightedIndex: action.highlightedIndex
            };
            break;
        case stateChangeTypes.FunctionSetInputValue:
            changes = {
                inputValue: action.inputValue
            };
            break;
        case stateChangeTypes.FunctionReset:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                isOpen: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'isOpen'),
                selectedItem: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'selectedItem'),
                inputValue: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'inputValue')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ function $4c1212f0703a6b7d$var$getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for(var index = 0; index < items.length; index++){
        var offsetIndex = (index + highlightedIndex + 1) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined && itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute('disabled'))) return offsetIndex;
        }
    }
    return highlightedIndex;
}
var $4c1212f0703a6b7d$var$propTypes$2 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    circularNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $4c1212f0703a6b7d$var$getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) return '';
    if (!resultCount) return 'No results are available.';
    if (resultCount !== previousResultCount) return "".concat(resultCount, " result").concat(resultCount === 1 ? ' is' : 's are', " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
    return '';
}
var $4c1212f0703a6b7d$var$defaultProps$2 = (0, $c30f8c0d825001f1$export$18ce0697a983be9b)((0, $c30f8c0d825001f1$export$18ce0697a983be9b)({}, $4c1212f0703a6b7d$var$defaultProps$3), {
    getA11yStatusMessage: $4c1212f0703a6b7d$var$getA11yStatusMessage
});
// eslint-disable-next-line import/no-mutable-exports
var $4c1212f0703a6b7d$var$validatePropTypes$2 = $4c1212f0703a6b7d$var$noop;
const $4c1212f0703a6b7d$var$MenuKeyDownArrowDown = 0;
const $4c1212f0703a6b7d$var$MenuKeyDownArrowUp = 1;
const $4c1212f0703a6b7d$var$MenuKeyDownEscape = 2;
const $4c1212f0703a6b7d$var$MenuKeyDownHome = 3;
const $4c1212f0703a6b7d$var$MenuKeyDownEnd = 4;
const $4c1212f0703a6b7d$var$MenuKeyDownEnter = 5;
const $4c1212f0703a6b7d$var$MenuKeyDownSpaceButton = 6;
const $4c1212f0703a6b7d$var$MenuKeyDownCharacter = 7;
const $4c1212f0703a6b7d$var$MenuBlur = 8;
const $4c1212f0703a6b7d$var$MenuMouseLeave$1 = 9;
const $4c1212f0703a6b7d$var$ItemMouseMove$1 = 10;
const $4c1212f0703a6b7d$var$ItemClick$1 = 11;
const $4c1212f0703a6b7d$var$ToggleButtonClick$1 = 12;
const $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowDown = 13;
const $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowUp = 14;
const $4c1212f0703a6b7d$var$ToggleButtonKeyDownCharacter = 15;
const $4c1212f0703a6b7d$var$FunctionToggleMenu$1 = 16;
const $4c1212f0703a6b7d$var$FunctionOpenMenu$1 = 17;
const $4c1212f0703a6b7d$var$FunctionCloseMenu$1 = 18;
const $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex$1 = 19;
const $4c1212f0703a6b7d$var$FunctionSelectItem$1 = 20;
const $4c1212f0703a6b7d$var$FunctionSetInputValue$1 = 21;
const $4c1212f0703a6b7d$var$FunctionReset$2 = 22;
var $4c1212f0703a6b7d$var$stateChangeTypes$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MenuKeyDownArrowDown: $4c1212f0703a6b7d$var$MenuKeyDownArrowDown,
    MenuKeyDownArrowUp: $4c1212f0703a6b7d$var$MenuKeyDownArrowUp,
    MenuKeyDownEscape: $4c1212f0703a6b7d$var$MenuKeyDownEscape,
    MenuKeyDownHome: $4c1212f0703a6b7d$var$MenuKeyDownHome,
    MenuKeyDownEnd: $4c1212f0703a6b7d$var$MenuKeyDownEnd,
    MenuKeyDownEnter: $4c1212f0703a6b7d$var$MenuKeyDownEnter,
    MenuKeyDownSpaceButton: $4c1212f0703a6b7d$var$MenuKeyDownSpaceButton,
    MenuKeyDownCharacter: $4c1212f0703a6b7d$var$MenuKeyDownCharacter,
    MenuBlur: $4c1212f0703a6b7d$var$MenuBlur,
    MenuMouseLeave: $4c1212f0703a6b7d$var$MenuMouseLeave$1,
    ItemMouseMove: $4c1212f0703a6b7d$var$ItemMouseMove$1,
    ItemClick: $4c1212f0703a6b7d$var$ItemClick$1,
    ToggleButtonClick: $4c1212f0703a6b7d$var$ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown: $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp: $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter: $4c1212f0703a6b7d$var$ToggleButtonKeyDownCharacter,
    FunctionToggleMenu: $4c1212f0703a6b7d$var$FunctionToggleMenu$1,
    FunctionOpenMenu: $4c1212f0703a6b7d$var$FunctionOpenMenu$1,
    FunctionCloseMenu: $4c1212f0703a6b7d$var$FunctionCloseMenu$1,
    FunctionSetHighlightedIndex: $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex$1,
    FunctionSelectItem: $4c1212f0703a6b7d$var$FunctionSelectItem$1,
    FunctionSetInputValue: $4c1212f0703a6b7d$var$FunctionSetInputValue$1,
    FunctionReset: $4c1212f0703a6b7d$var$FunctionReset$2
});
/* eslint-disable complexity */ function $4c1212f0703a6b7d$var$downshiftSelectReducer(state, action) {
    const { type: type, props: props, shiftKey: shiftKey } = action;
    let changes;
    switch(type){
        case $4c1212f0703a6b7d$var$ItemClick$1:
            changes = {
                isOpen: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                selectedItem: props.items[action.index]
            };
            break;
        case $4c1212f0703a6b7d$var$ToggleButtonKeyDownCharacter:
            {
                const lowercasedKey = action.key;
                const inputValue = `${state.inputValue}${lowercasedKey}`;
                const itemIndex = $4c1212f0703a6b7d$var$getItemIndexByCharacterKey({
                    keysSoFar: inputValue,
                    highlightedIndex: state.selectedItem ? props.items.indexOf(state.selectedItem) : -1,
                    items: props.items,
                    itemToString: props.itemToString,
                    getItemNodeFromIndex: action.getItemNodeFromIndex
                });
                changes = {
                    inputValue: inputValue,
                    ...itemIndex >= 0 && {
                        selectedItem: props.items[itemIndex]
                    }
                };
            }
            break;
        case $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowDown:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
                isOpen: true
            };
            break;
        case $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowUp:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
                isOpen: true
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownEnter:
        case $4c1212f0703a6b7d$var$MenuKeyDownSpaceButton:
            changes = {
                isOpen: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                ...state.highlightedIndex >= 0 && {
                    selectedItem: props.items[state.highlightedIndex]
                }
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownHome:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownEnd:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $4c1212f0703a6b7d$var$MenuBlur:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownCharacter:
            {
                const lowercasedKey = action.key;
                const inputValue = `${state.inputValue}${lowercasedKey}`;
                const highlightedIndex = $4c1212f0703a6b7d$var$getItemIndexByCharacterKey({
                    keysSoFar: inputValue,
                    highlightedIndex: state.highlightedIndex,
                    items: props.items,
                    itemToString: props.itemToString,
                    getItemNodeFromIndex: action.getItemNodeFromIndex
                });
                changes = {
                    inputValue: inputValue,
                    ...highlightedIndex >= 0 && {
                        highlightedIndex: highlightedIndex
                    }
                };
            }
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownArrowDown:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            break;
        case $4c1212f0703a6b7d$var$MenuKeyDownArrowUp:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            break;
        case $4c1212f0703a6b7d$var$FunctionSelectItem$1:
            changes = {
                selectedItem: action.selectedItem
            };
            break;
        default:
            return $4c1212f0703a6b7d$var$downshiftCommonReducer(state, action, $4c1212f0703a6b7d$var$stateChangeTypes$2);
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ /* eslint-disable max-statements */ $4c1212f0703a6b7d$export$e64b2f635402ca43.stateChangeTypes = $4c1212f0703a6b7d$var$stateChangeTypes$2;
function $4c1212f0703a6b7d$export$e64b2f635402ca43(userProps) {
    if (userProps === void 0) userProps = {};
    $4c1212f0703a6b7d$var$validatePropTypes$2(userProps, $4c1212f0703a6b7d$export$e64b2f635402ca43); // Props defaults and destructuring.
    const props = {
        ...$4c1212f0703a6b7d$var$defaultProps$2,
        ...userProps
    };
    const { items: items, scrollIntoView: scrollIntoView, environment: environment, initialIsOpen: initialIsOpen, defaultIsOpen: defaultIsOpen, itemToString: itemToString, getA11ySelectionMessage: getA11ySelectionMessage, getA11yStatusMessage: getA11yStatusMessage } = props; // Initial state depending on controlled props.
    const initialState = $4c1212f0703a6b7d$var$getInitialState$2(props);
    const [state, dispatch] = $4c1212f0703a6b7d$var$useControlledReducer$1($4c1212f0703a6b7d$var$downshiftSelectReducer, initialState, props);
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, selectedItem: selectedItem, inputValue: inputValue } = state; // Element efs.
    const toggleButtonRef = (0, $3ZYaX.useRef)(null);
    const menuRef = (0, $3ZYaX.useRef)(null);
    const itemRefs = (0, $3ZYaX.useRef)({}); // used not to trigger menu blur action in some scenarios.
    const shouldBlurRef = (0, $3ZYaX.useRef)(true); // used to keep the inputValue clearTimeout object between renders.
    const clearTimeoutRef = (0, $3ZYaX.useRef)(null); // prevent id re-generation between renders.
    const elementIds = $4c1212f0703a6b7d$var$useElementIds(props); // used to keep track of how many items we had on previous cycle.
    const previousResultCountRef = (0, $3ZYaX.useRef)();
    const isInitialMountRef = (0, $3ZYaX.useRef)(true); // utility callback to get item element.
    const latest = $4c1212f0703a6b7d$var$useLatestRef({
        state: state,
        props: props
    }); // Some utils.
    const getItemNodeFromIndex = (0, $3ZYaX.useCallback)((index)=>itemRefs.current[elementIds.getItemId(index)], [
        elementIds
    ]); // Effects.
    // Sets a11y status message on changes in state.
    $4c1212f0703a6b7d$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Sets a11y status message on changes in selectedItem.
    $4c1212f0703a6b7d$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Scroll on highlighted item if change comes from keyboard.
    const shouldScrollRef = $4c1212f0703a6b7d$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    }); // Sets cleanup for the keysSoFar callback, debounded after 500ms.
    (0, $3ZYaX.useEffect)(()=>{
        // init the clean function here as we need access to dispatch.
        clearTimeoutRef.current = $4c1212f0703a6b7d$var$debounce((outerDispatch)=>{
            outerDispatch({
                type: $4c1212f0703a6b7d$var$FunctionSetInputValue$1,
                inputValue: ''
            });
        }, 500); // Cancel any pending debounced calls on mount
        return ()=>{
            clearTimeoutRef.current.cancel();
        };
    }, []); // Invokes the keysSoFar callback set up above.
    (0, $3ZYaX.useEffect)(()=>{
        if (!inputValue) return;
        clearTimeoutRef.current(dispatch);
    }, [
        dispatch,
        inputValue
    ]);
    $4c1212f0703a6b7d$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    /* Controls the focus on the menu or the toggle button. */ (0, $3ZYaX.useEffect)(()=>{
        // Don't focus menu on first render.
        if (isInitialMountRef.current) {
            // Unless it was initialised as open.
            if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) menuRef.current.focus();
            return;
        } // Focus menu on open.
        if (isOpen) {
            // istanbul ignore else
            if (menuRef.current) menuRef.current.focus();
            return;
        } // Focus toggleButton on close, but not if it was closed with (Shift+)Tab.
        if (environment.document.activeElement === menuRef.current) // istanbul ignore else
        {
            if (toggleButtonRef.current) {
                shouldBlurRef.current = false;
                toggleButtonRef.current.focus();
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    (0, $3ZYaX.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    }); // Add mouse/touch events to document.
    const mouseAndTouchTrackersRef = $4c1212f0703a6b7d$var$useMouseAndTouchTracker(isOpen, [
        menuRef,
        toggleButtonRef
    ], environment, ()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$MenuBlur
        });
    });
    const setGetterPropCallInfo = $4c1212f0703a6b7d$var$useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps'); // Make initial ref false.
    (0, $3ZYaX.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Reset itemRefs on close.
    (0, $3ZYaX.useEffect)(()=>{
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]); // Event handler functions.
    const toggleButtonKeyDownHandlers = (0, $3ZYaX.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowDown,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$ToggleButtonKeyDownArrowUp,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            }
        }), [
        dispatch,
        getItemNodeFromIndex
    ]);
    const menuKeyDownHandlers = (0, $3ZYaX.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownArrowDown,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownArrowUp,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            Home (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape () {
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownEscape
                });
            },
            Enter (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownEnter
                });
            },
            ' ' (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuKeyDownSpaceButton
                });
            }
        }), [
        dispatch,
        getItemNodeFromIndex
    ]); // Action functions.
    const toggleMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionToggleMenu$1
        });
    }, [
        dispatch
    ]);
    const closeMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionCloseMenu$1
        });
    }, [
        dispatch
    ]);
    const openMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionOpenMenu$1
        });
    }, [
        dispatch
    ]);
    const setHighlightedIndex = (0, $3ZYaX.useCallback)((newHighlightedIndex)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex$1,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    const selectItem = (0, $3ZYaX.useCallback)((newSelectedItem)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSelectItem$1,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    const reset = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionReset$2
        });
    }, [
        dispatch
    ]);
    const setInputValue = (0, $3ZYaX.useCallback)((newInputValue)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetInputValue$1,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]); // Getter functions.
    const getLabelProps = (0, $3ZYaX.useCallback)((labelProps)=>({
            id: elementIds.labelId,
            htmlFor: elementIds.toggleButtonId,
            ...labelProps
        }), [
        elementIds
    ]);
    const getMenuProps = (0, $3ZYaX.useCallback)(function(_temp, _temp2) {
        let { onMouseLeave: onMouseLeave, refKey: refKey = 'ref', onKeyDown: onKeyDown, onBlur: onBlur, ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
        let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
        const latestState = latest.current.state;
        const menuHandleKeyDown = (event)=>{
            const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
            if (key && menuKeyDownHandlers[key]) menuKeyDownHandlers[key](event);
            else if ($4c1212f0703a6b7d$var$isAcceptedCharacterKey(key)) dispatch({
                type: $4c1212f0703a6b7d$var$MenuKeyDownCharacter,
                key: key,
                getItemNodeFromIndex: getItemNodeFromIndex
            });
        };
        const menuHandleBlur = ()=>{
            // if the blur was a result of selection, we don't trigger this action.
            if (shouldBlurRef.current === false) {
                shouldBlurRef.current = true;
                return;
            }
            const shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
            /* istanbul ignore else */ if (shouldBlur) dispatch({
                type: $4c1212f0703a6b7d$var$MenuBlur
            });
        };
        const menuHandleMouseLeave = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$MenuMouseLeave$1
            });
        };
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (menuNode)=>{
                menuRef.current = menuNode;
            }),
            id: elementIds.menuId,
            role: 'listbox',
            'aria-labelledby': elementIds.labelId,
            tabIndex: -1,
            ...latestState.isOpen && latestState.highlightedIndex > -1 && {
                'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
            },
            onMouseLeave: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
            onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, menuHandleKeyDown),
            onBlur: $4c1212f0703a6b7d$var$callAllEventHandlers(onBlur, menuHandleBlur),
            ...rest
        };
    }, [
        dispatch,
        latest,
        menuKeyDownHandlers,
        mouseAndTouchTrackersRef,
        setGetterPropCallInfo,
        elementIds,
        getItemNodeFromIndex
    ]);
    const getToggleButtonProps = (0, $3ZYaX.useCallback)(function(_temp3, _temp4) {
        let { onClick: onClick, onKeyDown: onKeyDown, refKey: refKey = 'ref', ref: ref, ...rest } = _temp3 === void 0 ? {} : _temp3;
        let { suppressRefError: suppressRefError = false } = _temp4 === void 0 ? {} : _temp4;
        const toggleButtonHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$ToggleButtonClick$1
            });
        };
        const toggleButtonHandleKeyDown = (event)=>{
            const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
            if (key && toggleButtonKeyDownHandlers[key]) toggleButtonKeyDownHandlers[key](event);
            else if ($4c1212f0703a6b7d$var$isAcceptedCharacterKey(key)) dispatch({
                type: $4c1212f0703a6b7d$var$ToggleButtonKeyDownCharacter,
                key: key,
                getItemNodeFromIndex: getItemNodeFromIndex
            });
        };
        const toggleProps = {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (toggleButtonNode)=>{
                toggleButtonRef.current = toggleButtonNode;
            }),
            id: elementIds.toggleButtonId,
            'aria-haspopup': 'listbox',
            'aria-expanded': latest.current.state.isOpen,
            'aria-labelledby': `${elementIds.labelId} ${elementIds.toggleButtonId}`,
            ...rest
        };
        if (!rest.disabled) {
            toggleProps.onClick = $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, toggleButtonHandleClick);
            toggleProps.onKeyDown = $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
        }
        setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
        return toggleProps;
    }, [
        dispatch,
        latest,
        toggleButtonKeyDownHandlers,
        setGetterPropCallInfo,
        elementIds,
        getItemNodeFromIndex
    ]);
    const getItemProps = (0, $3ZYaX.useCallback)(function(_temp5) {
        let { item: item, index: index, onMouseMove: onMouseMove, onClick: onClick, refKey: refKey = 'ref', ref: ref, disabled: disabled, ...rest } = _temp5 === void 0 ? {} : _temp5;
        const { state: latestState, props: latestProps } = latest.current;
        const itemHandleMouseMove = ()=>{
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $4c1212f0703a6b7d$var$ItemMouseMove$1,
                index: index,
                disabled: disabled
            });
        };
        const itemHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$ItemClick$1,
                index: index
            });
        };
        const itemIndex = $4c1212f0703a6b7d$var$getItemIndex(index, item, latestProps.items);
        if (itemIndex < 0) throw new Error('Pass either item or item index in getItemProps!');
        const itemProps = {
            disabled: disabled,
            role: 'option',
            'aria-selected': `${itemIndex === latestState.highlightedIndex}`,
            id: elementIds.getItemId(itemIndex),
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (itemNode)=>{
                if (itemNode) itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
            }),
            ...rest
        };
        if (!disabled) itemProps.onClick = $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, itemHandleClick);
        itemProps.onMouseMove = $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove);
        return itemProps;
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    return {
        getToggleButtonProps: // prop getters.
        getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        toggleMenu: // actions.
        toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        selectItem: selectItem,
        reset: reset,
        setInputValue: setInputValue,
        highlightedIndex: // state.
        highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
const $4c1212f0703a6b7d$var$InputKeyDownArrowDown = 0;
const $4c1212f0703a6b7d$var$InputKeyDownArrowUp = 1;
const $4c1212f0703a6b7d$var$InputKeyDownEscape = 2;
const $4c1212f0703a6b7d$var$InputKeyDownHome = 3;
const $4c1212f0703a6b7d$var$InputKeyDownEnd = 4;
const $4c1212f0703a6b7d$var$InputKeyDownEnter = 5;
const $4c1212f0703a6b7d$var$InputChange = 6;
const $4c1212f0703a6b7d$var$InputBlur = 7;
const $4c1212f0703a6b7d$var$MenuMouseLeave = 8;
const $4c1212f0703a6b7d$var$ItemMouseMove = 9;
const $4c1212f0703a6b7d$var$ItemClick = 10;
const $4c1212f0703a6b7d$var$ToggleButtonClick = 11;
const $4c1212f0703a6b7d$var$FunctionToggleMenu = 12;
const $4c1212f0703a6b7d$var$FunctionOpenMenu = 13;
const $4c1212f0703a6b7d$var$FunctionCloseMenu = 14;
const $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex = 15;
const $4c1212f0703a6b7d$var$FunctionSelectItem = 16;
const $4c1212f0703a6b7d$var$FunctionSetInputValue = 17;
const $4c1212f0703a6b7d$var$FunctionReset$1 = 18;
const $4c1212f0703a6b7d$var$ControlledPropUpdatedSelectedItem = 19;
var $4c1212f0703a6b7d$var$stateChangeTypes$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: $4c1212f0703a6b7d$var$InputKeyDownArrowDown,
    InputKeyDownArrowUp: $4c1212f0703a6b7d$var$InputKeyDownArrowUp,
    InputKeyDownEscape: $4c1212f0703a6b7d$var$InputKeyDownEscape,
    InputKeyDownHome: $4c1212f0703a6b7d$var$InputKeyDownHome,
    InputKeyDownEnd: $4c1212f0703a6b7d$var$InputKeyDownEnd,
    InputKeyDownEnter: $4c1212f0703a6b7d$var$InputKeyDownEnter,
    InputChange: $4c1212f0703a6b7d$var$InputChange,
    InputBlur: $4c1212f0703a6b7d$var$InputBlur,
    MenuMouseLeave: $4c1212f0703a6b7d$var$MenuMouseLeave,
    ItemMouseMove: $4c1212f0703a6b7d$var$ItemMouseMove,
    ItemClick: $4c1212f0703a6b7d$var$ItemClick,
    ToggleButtonClick: $4c1212f0703a6b7d$var$ToggleButtonClick,
    FunctionToggleMenu: $4c1212f0703a6b7d$var$FunctionToggleMenu,
    FunctionOpenMenu: $4c1212f0703a6b7d$var$FunctionOpenMenu,
    FunctionCloseMenu: $4c1212f0703a6b7d$var$FunctionCloseMenu,
    FunctionSetHighlightedIndex: $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex,
    FunctionSelectItem: $4c1212f0703a6b7d$var$FunctionSelectItem,
    FunctionSetInputValue: $4c1212f0703a6b7d$var$FunctionSetInputValue,
    FunctionReset: $4c1212f0703a6b7d$var$FunctionReset$1,
    ControlledPropUpdatedSelectedItem: $4c1212f0703a6b7d$var$ControlledPropUpdatedSelectedItem
});
function $4c1212f0703a6b7d$var$getInitialState$1(props) {
    const initialState = $4c1212f0703a6b7d$var$getInitialState$2(props);
    const { selectedItem: selectedItem } = initialState;
    let { inputValue: inputValue } = initialState;
    if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) inputValue = props.itemToString(selectedItem);
    return {
        ...initialState,
        inputValue: inputValue
    };
}
const $4c1212f0703a6b7d$var$propTypes$1 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    circularNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
    inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    defaultInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    initialInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onInputValueChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any
        })
    })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $4c1212f0703a6b7d$var$useControlledReducer(reducer, initialState, props) {
    const previousSelectedItemRef = (0, $3ZYaX.useRef)();
    const [state, dispatch] = $4c1212f0703a6b7d$var$useEnhancedReducer(reducer, initialState, props); // ToDo: if needed, make same approach as selectedItemChanged from Downshift.
    (0, $3ZYaX.useEffect)(()=>{
        if ($4c1212f0703a6b7d$var$isControlledProp(props, 'selectedItem')) {
            if (previousSelectedItemRef.current !== props.selectedItem) dispatch({
                type: $4c1212f0703a6b7d$var$ControlledPropUpdatedSelectedItem,
                inputValue: props.itemToString(props.selectedItem)
            });
            previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
        }
    });
    return [
        $4c1212f0703a6b7d$var$getState(state, props),
        dispatch
    ];
} // eslint-disable-next-line import/no-mutable-exports
let $4c1212f0703a6b7d$var$validatePropTypes$1 = $4c1212f0703a6b7d$var$noop;
var $4c1212f0703a6b7d$var$options, $4c1212f0703a6b7d$var$caller;
const $4c1212f0703a6b7d$var$defaultProps$1 = {
    ...$4c1212f0703a6b7d$var$defaultProps$3,
    getA11yStatusMessage: $4c1212f0703a6b7d$var$getA11yStatusMessage$1,
    circularNavigation: true
};
/* eslint-disable complexity */ function $4c1212f0703a6b7d$var$downshiftUseComboboxReducer(state, action) {
    const { type: type, props: props, shiftKey: shiftKey } = action;
    let changes;
    switch(type){
        case $4c1212f0703a6b7d$var$ItemClick:
            changes = {
                isOpen: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                selectedItem: props.items[action.index],
                inputValue: props.itemToString(props.items[action.index])
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownArrowDown:
            if (state.isOpen) changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            else changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownArrowUp:
            if (state.isOpen) changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            else changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownEnter:
            changes = {
                ...state.isOpen && state.highlightedIndex >= 0 && {
                    selectedItem: props.items[state.highlightedIndex],
                    isOpen: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'isOpen'),
                    highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                    inputValue: props.itemToString(props.items[state.highlightedIndex])
                }
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1,
                ...!state.isOpen && {
                    selectedItem: null,
                    inputValue: ''
                }
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownHome:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $4c1212f0703a6b7d$var$InputKeyDownEnd:
            changes = {
                highlightedIndex: $4c1212f0703a6b7d$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $4c1212f0703a6b7d$var$InputBlur:
            changes = {
                isOpen: false,
                highlightedIndex: -1,
                ...state.highlightedIndex >= 0 && action.selectItem && {
                    selectedItem: props.items[state.highlightedIndex],
                    inputValue: props.itemToString(props.items[state.highlightedIndex])
                }
            };
            break;
        case $4c1212f0703a6b7d$var$InputChange:
            changes = {
                isOpen: true,
                highlightedIndex: $4c1212f0703a6b7d$var$getDefaultValue$1(props, 'highlightedIndex'),
                inputValue: action.inputValue
            };
            break;
        case $4c1212f0703a6b7d$var$FunctionSelectItem:
            changes = {
                selectedItem: action.selectedItem,
                inputValue: props.itemToString(action.selectedItem)
            };
            break;
        case $4c1212f0703a6b7d$var$ControlledPropUpdatedSelectedItem:
            changes = {
                inputValue: action.inputValue
            };
            break;
        default:
            return $4c1212f0703a6b7d$var$downshiftCommonReducer(state, action, $4c1212f0703a6b7d$var$stateChangeTypes$1);
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ /* eslint-disable max-statements */ $4c1212f0703a6b7d$export$7a023a466c03eb3d.stateChangeTypes = $4c1212f0703a6b7d$var$stateChangeTypes$1;
function $4c1212f0703a6b7d$export$7a023a466c03eb3d(userProps) {
    if (userProps === void 0) userProps = {};
    $4c1212f0703a6b7d$var$validatePropTypes$1(userProps, $4c1212f0703a6b7d$export$7a023a466c03eb3d); // Props defaults and destructuring.
    const props = {
        ...$4c1212f0703a6b7d$var$defaultProps$1,
        ...userProps
    };
    const { initialIsOpen: initialIsOpen, defaultIsOpen: defaultIsOpen, items: items, scrollIntoView: scrollIntoView, environment: environment, getA11yStatusMessage: getA11yStatusMessage, getA11ySelectionMessage: getA11ySelectionMessage, itemToString: itemToString } = props; // Initial state depending on controlled props.
    const initialState = $4c1212f0703a6b7d$var$getInitialState$1(props);
    const [state, dispatch] = $4c1212f0703a6b7d$var$useControlledReducer($4c1212f0703a6b7d$var$downshiftUseComboboxReducer, initialState, props);
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, selectedItem: selectedItem, inputValue: inputValue } = state; // Element refs.
    const menuRef = (0, $3ZYaX.useRef)(null);
    const itemRefs = (0, $3ZYaX.useRef)({});
    const inputRef = (0, $3ZYaX.useRef)(null);
    const toggleButtonRef = (0, $3ZYaX.useRef)(null);
    const comboboxRef = (0, $3ZYaX.useRef)(null);
    const isInitialMountRef = (0, $3ZYaX.useRef)(true); // prevent id re-generation between renders.
    const elementIds = $4c1212f0703a6b7d$var$useElementIds(props); // used to keep track of how many items we had on previous cycle.
    const previousResultCountRef = (0, $3ZYaX.useRef)(); // utility callback to get item element.
    const latest = $4c1212f0703a6b7d$var$useLatestRef({
        state: state,
        props: props
    });
    const getItemNodeFromIndex = (0, $3ZYaX.useCallback)((index)=>itemRefs.current[elementIds.getItemId(index)], [
        elementIds
    ]); // Effects.
    // Sets a11y status message on changes in state.
    $4c1212f0703a6b7d$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Sets a11y status message on changes in selectedItem.
    $4c1212f0703a6b7d$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Scroll on highlighted item if change comes from keyboard.
    const shouldScrollRef = $4c1212f0703a6b7d$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    $4c1212f0703a6b7d$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    }); // Focus the input on first render if required.
    (0, $3ZYaX.useEffect)(()=>{
        const focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
        if (focusOnOpen && inputRef.current) inputRef.current.focus();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $3ZYaX.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    }); // Add mouse/touch events to document.
    const mouseAndTouchTrackersRef = $4c1212f0703a6b7d$var$useMouseAndTouchTracker(isOpen, [
        comboboxRef,
        menuRef,
        toggleButtonRef
    ], environment, ()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$InputBlur,
            selectItem: false
        });
    });
    const setGetterPropCallInfo = $4c1212f0703a6b7d$var$useGetterPropsCalledChecker('getInputProps', 'getComboboxProps', 'getMenuProps'); // Make initial ref false.
    (0, $3ZYaX.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Reset itemRefs on close.
    (0, $3ZYaX.useEffect)(()=>{
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    /* Event handler functions */ const inputKeyDownHandlers = (0, $3ZYaX.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$InputKeyDownArrowDown,
                    shiftKey: event.shiftKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$InputKeyDownArrowUp,
                    shiftKey: event.shiftKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Home (event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$InputKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End (event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$InputKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape (event) {
                const latestState = latest.current.state;
                if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
                    event.preventDefault();
                    dispatch({
                        type: $4c1212f0703a6b7d$var$InputKeyDownEscape
                    });
                }
            },
            Enter (event) {
                const latestState = latest.current.state; // if closed or no highlighted index, do nothing.
                if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 // if IME composing, wait for next Enter keydown event.
                ) return;
                event.preventDefault();
                dispatch({
                    type: $4c1212f0703a6b7d$var$InputKeyDownEnter,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            }
        }), [
        dispatch,
        latest,
        getItemNodeFromIndex
    ]); // Getter props.
    const getLabelProps = (0, $3ZYaX.useCallback)((labelProps)=>({
            id: elementIds.labelId,
            htmlFor: elementIds.inputId,
            ...labelProps
        }), [
        elementIds
    ]);
    const getMenuProps = (0, $3ZYaX.useCallback)(function(_temp, _temp2) {
        let { onMouseLeave: onMouseLeave, refKey: refKey = 'ref', ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
        let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (menuNode)=>{
                menuRef.current = menuNode;
            }),
            id: elementIds.menuId,
            role: 'listbox',
            'aria-labelledby': elementIds.labelId,
            onMouseLeave: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseLeave, ()=>{
                dispatch({
                    type: $4c1212f0703a6b7d$var$MenuMouseLeave
                });
            }),
            ...rest
        };
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    const getItemProps = (0, $3ZYaX.useCallback)(function(_temp3) {
        let { item: item, index: index, refKey: refKey = 'ref', ref: ref, onMouseMove: onMouseMove, onMouseDown: onMouseDown, onClick: onClick, onPress: onPress, disabled: disabled, ...rest } = _temp3 === void 0 ? {} : _temp3;
        const { props: latestProps, state: latestState } = latest.current;
        const itemIndex = $4c1212f0703a6b7d$var$getItemIndex(index, item, latestProps.items);
        if (itemIndex < 0) throw new Error('Pass either item or item index in getItemProps!');
        const onSelectKey = 'onClick';
        const customClickHandler = onClick;
        const itemHandleMouseMove = ()=>{
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $4c1212f0703a6b7d$var$ItemMouseMove,
                index: index,
                disabled: disabled
            });
        };
        const itemHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$ItemClick,
                index: index
            });
        };
        const itemHandleMouseDown = (e)=>e.preventDefault();
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (itemNode)=>{
                if (itemNode) itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
            }),
            disabled: disabled,
            role: 'option',
            'aria-selected': `${itemIndex === latestState.highlightedIndex}`,
            id: elementIds.getItemId(itemIndex),
            ...!disabled && {
                [onSelectKey]: $4c1212f0703a6b7d$var$callAllEventHandlers(customClickHandler, itemHandleClick)
            },
            onMouseMove: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove),
            onMouseDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown),
            ...rest
        };
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    const getToggleButtonProps = (0, $3ZYaX.useCallback)(function(_temp4) {
        let { onClick: onClick, onPress: onPress, refKey: refKey = 'ref', ref: ref, ...rest } = _temp4 === void 0 ? {} : _temp4;
        const toggleButtonHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$ToggleButtonClick
            });
            if (!latest.current.state.isOpen && inputRef.current) inputRef.current.focus();
        };
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (toggleButtonNode)=>{
                toggleButtonRef.current = toggleButtonNode;
            }),
            id: elementIds.toggleButtonId,
            tabIndex: -1,
            ...!rest.disabled && {
                onClick: $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, toggleButtonHandleClick)
            },
            ...rest
        };
    }, [
        dispatch,
        latest,
        elementIds
    ]);
    const getInputProps = (0, $3ZYaX.useCallback)(function(_temp5, _temp6) {
        let { onKeyDown: onKeyDown, onChange: onChange, onInput: onInput, onBlur: onBlur, onChangeText: onChangeText, refKey: refKey = 'ref', ref: ref, ...rest } = _temp5 === void 0 ? {} : _temp5;
        let { suppressRefError: suppressRefError = false } = _temp6 === void 0 ? {} : _temp6;
        setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
        const latestState = latest.current.state;
        const inputHandleKeyDown = (event)=>{
            const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
            if (key && inputKeyDownHandlers[key]) inputKeyDownHandlers[key](event);
        };
        const inputHandleChange = (event)=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$InputChange,
                inputValue: event.target.value
            });
        };
        const inputHandleBlur = ()=>{
            /* istanbul ignore else */ if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) dispatch({
                type: $4c1212f0703a6b7d$var$InputBlur,
                selectItem: true
            });
        };
        /* istanbul ignore next (preact) */ const onChangeKey = 'onChange';
        let eventHandlers = {};
        if (!rest.disabled) eventHandlers = {
            [onChangeKey]: $4c1212f0703a6b7d$var$callAllEventHandlers(onChange, onInput, inputHandleChange),
            onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, inputHandleKeyDown),
            onBlur: $4c1212f0703a6b7d$var$callAllEventHandlers(onBlur, inputHandleBlur)
        };
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (inputNode)=>{
                inputRef.current = inputNode;
            }),
            id: elementIds.inputId,
            'aria-autocomplete': 'list',
            'aria-controls': elementIds.menuId,
            ...latestState.isOpen && latestState.highlightedIndex > -1 && {
                'aria-activedescendant': elementIds.getItemId(latestState.highlightedIndex)
            },
            'aria-labelledby': elementIds.labelId,
            // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
            autoComplete: 'off',
            value: latestState.inputValue,
            ...eventHandlers,
            ...rest
        };
    }, [
        dispatch,
        inputKeyDownHandlers,
        latest,
        mouseAndTouchTrackersRef,
        setGetterPropCallInfo,
        elementIds
    ]);
    const getComboboxProps = (0, $3ZYaX.useCallback)(function(_temp7, _temp8) {
        let { refKey: refKey = 'ref', ref: ref, ...rest } = _temp7 === void 0 ? {} : _temp7;
        let { suppressRefError: suppressRefError = false } = _temp8 === void 0 ? {} : _temp8;
        setGetterPropCallInfo('getComboboxProps', suppressRefError, refKey, comboboxRef);
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (comboboxNode)=>{
                comboboxRef.current = comboboxNode;
            }),
            role: 'combobox',
            'aria-haspopup': 'listbox',
            'aria-owns': elementIds.menuId,
            'aria-expanded': latest.current.state.isOpen,
            ...rest
        };
    }, [
        latest,
        setGetterPropCallInfo,
        elementIds
    ]); // returns
    const toggleMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionToggleMenu
        });
    }, [
        dispatch
    ]);
    const closeMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionCloseMenu
        });
    }, [
        dispatch
    ]);
    const openMenu = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionOpenMenu
        });
    }, [
        dispatch
    ]);
    const setHighlightedIndex = (0, $3ZYaX.useCallback)((newHighlightedIndex)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetHighlightedIndex,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    const selectItem = (0, $3ZYaX.useCallback)((newSelectedItem)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSelectItem,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    const setInputValue = (0, $3ZYaX.useCallback)((newInputValue)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetInputValue,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    const reset = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionReset$1
        });
    }, [
        dispatch
    ]);
    return {
        getItemProps: // prop getters.
        getItemProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getComboboxProps: getComboboxProps,
        getToggleButtonProps: getToggleButtonProps,
        toggleMenu: // actions.
        toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        setInputValue: setInputValue,
        selectItem: selectItem,
        reset: reset,
        highlightedIndex: // state.
        highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
const $4c1212f0703a6b7d$var$defaultStateValues = {
    activeIndex: -1,
    selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $4c1212f0703a6b7d$var$getInitialValue(props, propKey) {
    return $4c1212f0703a6b7d$var$getInitialValue$1(props, propKey, $4c1212f0703a6b7d$var$defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $4c1212f0703a6b7d$var$getDefaultValue(props, propKey) {
    return $4c1212f0703a6b7d$var$getDefaultValue$1(props, propKey, $4c1212f0703a6b7d$var$defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */ function $4c1212f0703a6b7d$var$getInitialState(props) {
    const activeIndex = $4c1212f0703a6b7d$var$getInitialValue(props, 'activeIndex');
    const selectedItems = $4c1212f0703a6b7d$var$getInitialValue(props, 'selectedItems');
    return {
        activeIndex: activeIndex,
        selectedItems: selectedItems
    };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */ function $4c1212f0703a6b7d$var$isKeyDownOperationPermitted(event) {
    if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return false;
    const element = event.target;
    if (element instanceof HTMLInputElement && // if element is a text input
    element.value !== '' && // and cursor is either not at the start or is currently highlighting text.
    (element.selectionStart !== 0 || element.selectionEnd !== 0)) return false;
    return true;
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $4c1212f0703a6b7d$var$getA11yRemovalMessage(selectionParameters) {
    const { removedSelectedItem: removedSelectedItem, itemToString: itemToStringLocal } = selectionParameters;
    return `${itemToStringLocal(removedSelectedItem)} has been removed.`;
}
const $4c1212f0703a6b7d$var$propTypes = {
    selectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
    initialSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
    defaultSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    getA11yRemovalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    initialActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    onActiveIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    onSelectedItemsChange: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    keyNavigationNext: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    keyNavigationPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).any
        })
    })
};
const $4c1212f0703a6b7d$var$defaultProps = {
    itemToString: $4c1212f0703a6b7d$var$defaultProps$3.itemToString,
    stateReducer: $4c1212f0703a6b7d$var$defaultProps$3.stateReducer,
    environment: $4c1212f0703a6b7d$var$defaultProps$3.environment,
    getA11yRemovalMessage: $4c1212f0703a6b7d$var$getA11yRemovalMessage,
    keyNavigationNext: 'ArrowRight',
    keyNavigationPrevious: 'ArrowLeft'
}; // eslint-disable-next-line import/no-mutable-exports
let $4c1212f0703a6b7d$var$validatePropTypes = $4c1212f0703a6b7d$var$noop;
var $4c1212f0703a6b7d$var$options1, $4c1212f0703a6b7d$var$caller1;
const $4c1212f0703a6b7d$var$SelectedItemClick = 0;
const $4c1212f0703a6b7d$var$SelectedItemKeyDownDelete = 1;
const $4c1212f0703a6b7d$var$SelectedItemKeyDownBackspace = 2;
const $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationNext = 3;
const $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationPrevious = 4;
const $4c1212f0703a6b7d$var$DropdownKeyDownNavigationPrevious = 5;
const $4c1212f0703a6b7d$var$DropdownKeyDownBackspace = 6;
const $4c1212f0703a6b7d$var$DropdownClick = 7;
const $4c1212f0703a6b7d$var$FunctionAddSelectedItem = 8;
const $4c1212f0703a6b7d$var$FunctionRemoveSelectedItem = 9;
const $4c1212f0703a6b7d$var$FunctionSetSelectedItems = 10;
const $4c1212f0703a6b7d$var$FunctionSetActiveIndex = 11;
const $4c1212f0703a6b7d$var$FunctionReset = 12;
var $4c1212f0703a6b7d$var$stateChangeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    SelectedItemClick: $4c1212f0703a6b7d$var$SelectedItemClick,
    SelectedItemKeyDownDelete: $4c1212f0703a6b7d$var$SelectedItemKeyDownDelete,
    SelectedItemKeyDownBackspace: $4c1212f0703a6b7d$var$SelectedItemKeyDownBackspace,
    SelectedItemKeyDownNavigationNext: $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious: $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationPrevious,
    DropdownKeyDownNavigationPrevious: $4c1212f0703a6b7d$var$DropdownKeyDownNavigationPrevious,
    DropdownKeyDownBackspace: $4c1212f0703a6b7d$var$DropdownKeyDownBackspace,
    DropdownClick: $4c1212f0703a6b7d$var$DropdownClick,
    FunctionAddSelectedItem: $4c1212f0703a6b7d$var$FunctionAddSelectedItem,
    FunctionRemoveSelectedItem: $4c1212f0703a6b7d$var$FunctionRemoveSelectedItem,
    FunctionSetSelectedItems: $4c1212f0703a6b7d$var$FunctionSetSelectedItems,
    FunctionSetActiveIndex: $4c1212f0703a6b7d$var$FunctionSetActiveIndex,
    FunctionReset: $4c1212f0703a6b7d$var$FunctionReset
});
/* eslint-disable complexity */ function $4c1212f0703a6b7d$var$downshiftMultipleSelectionReducer(state, action) {
    const { type: type, index: index, props: props, selectedItem: selectedItem } = action;
    const { activeIndex: activeIndex, selectedItems: selectedItems } = state;
    let changes;
    switch(type){
        case $4c1212f0703a6b7d$var$SelectedItemClick:
            changes = {
                activeIndex: index
            };
            break;
        case $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationPrevious:
            changes = {
                activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
            };
            break;
        case $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationNext:
            changes = {
                activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
            };
            break;
        case $4c1212f0703a6b7d$var$SelectedItemKeyDownBackspace:
        case $4c1212f0703a6b7d$var$SelectedItemKeyDownDelete:
            {
                let newActiveIndex = activeIndex;
                if (selectedItems.length === 1) newActiveIndex = -1;
                else if (activeIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
                changes = {
                    selectedItems: [
                        ...selectedItems.slice(0, activeIndex),
                        ...selectedItems.slice(activeIndex + 1)
                    ],
                    activeIndex: newActiveIndex
                };
                break;
            }
        case $4c1212f0703a6b7d$var$DropdownKeyDownNavigationPrevious:
            changes = {
                activeIndex: selectedItems.length - 1
            };
            break;
        case $4c1212f0703a6b7d$var$DropdownKeyDownBackspace:
            changes = {
                selectedItems: selectedItems.slice(0, selectedItems.length - 1)
            };
            break;
        case $4c1212f0703a6b7d$var$FunctionAddSelectedItem:
            changes = {
                selectedItems: [
                    ...selectedItems,
                    selectedItem
                ]
            };
            break;
        case $4c1212f0703a6b7d$var$DropdownClick:
            changes = {
                activeIndex: -1
            };
            break;
        case $4c1212f0703a6b7d$var$FunctionRemoveSelectedItem:
            {
                let newActiveIndex = activeIndex;
                const selectedItemIndex = selectedItems.indexOf(selectedItem);
                if (selectedItemIndex >= 0) {
                    if (selectedItems.length === 1) newActiveIndex = -1;
                    else if (selectedItemIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
                    changes = {
                        selectedItems: [
                            ...selectedItems.slice(0, selectedItemIndex),
                            ...selectedItems.slice(selectedItemIndex + 1)
                        ],
                        activeIndex: newActiveIndex
                    };
                }
                break;
            }
        case $4c1212f0703a6b7d$var$FunctionSetSelectedItems:
            {
                const { selectedItems: newSelectedItems } = action;
                changes = {
                    selectedItems: newSelectedItems
                };
                break;
            }
        case $4c1212f0703a6b7d$var$FunctionSetActiveIndex:
            {
                const { activeIndex: newActiveIndex } = action;
                changes = {
                    activeIndex: newActiveIndex
                };
                break;
            }
        case $4c1212f0703a6b7d$var$FunctionReset:
            changes = {
                activeIndex: $4c1212f0703a6b7d$var$getDefaultValue(props, 'activeIndex'),
                selectedItems: $4c1212f0703a6b7d$var$getDefaultValue(props, 'selectedItems')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return {
        ...state,
        ...changes
    };
}
$4c1212f0703a6b7d$export$134e7e7faed1473a.stateChangeTypes = $4c1212f0703a6b7d$var$stateChangeTypes;
function $4c1212f0703a6b7d$export$134e7e7faed1473a(userProps) {
    if (userProps === void 0) userProps = {};
    $4c1212f0703a6b7d$var$validatePropTypes(userProps, $4c1212f0703a6b7d$export$134e7e7faed1473a); // Props defaults and destructuring.
    const props = {
        ...$4c1212f0703a6b7d$var$defaultProps,
        ...userProps
    };
    const { getA11yRemovalMessage: getA11yRemovalMessage, itemToString: itemToString, environment: environment, keyNavigationNext: keyNavigationNext, keyNavigationPrevious: keyNavigationPrevious } = props; // Reducer init.
    const [state, dispatch] = $4c1212f0703a6b7d$var$useControlledReducer$1($4c1212f0703a6b7d$var$downshiftMultipleSelectionReducer, $4c1212f0703a6b7d$var$getInitialState(props), props);
    const { activeIndex: activeIndex, selectedItems: selectedItems } = state; // Refs.
    const isInitialMountRef = (0, $3ZYaX.useRef)(true);
    const dropdownRef = (0, $3ZYaX.useRef)(null);
    const previousSelectedItemsRef = (0, $3ZYaX.useRef)(selectedItems);
    const selectedItemRefs = (0, $3ZYaX.useRef)();
    selectedItemRefs.current = [];
    const latest = $4c1212f0703a6b7d$var$useLatestRef({
        state: state,
        props: props
    }); // Effects.
    /* Sets a11y status message on changes in selectedItem. */ (0, $3ZYaX.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        if (selectedItems.length < previousSelectedItemsRef.current.length) {
            const removedSelectedItem = previousSelectedItemsRef.current.find((item)=>selectedItems.indexOf(item) < 0);
            $4c1212f0703a6b7d$var$setStatus(getA11yRemovalMessage({
                itemToString: itemToString,
                resultCount: selectedItems.length,
                removedSelectedItem: removedSelectedItem,
                activeIndex: activeIndex,
                activeSelectedItem: selectedItems[activeIndex]
            }), environment.document);
        }
        previousSelectedItemsRef.current = selectedItems; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedItems.length
    ]); // Sets focus on active item.
    (0, $3ZYaX.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        if (activeIndex === -1 && dropdownRef.current) dropdownRef.current.focus();
        else if (selectedItemRefs.current[activeIndex]) selectedItemRefs.current[activeIndex].focus();
    }, [
        activeIndex
    ]);
    $4c1212f0703a6b7d$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    const setGetterPropCallInfo = $4c1212f0703a6b7d$var$useGetterPropsCalledChecker('getDropdownProps'); // Make initial ref false.
    (0, $3ZYaX.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Event handler functions.
    const selectedItemKeyDownHandlers = (0, $3ZYaX.useMemo)(()=>({
            [keyNavigationPrevious] () {
                dispatch({
                    type: $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationPrevious
                });
            },
            [keyNavigationNext] () {
                dispatch({
                    type: $4c1212f0703a6b7d$var$SelectedItemKeyDownNavigationNext
                });
            },
            Delete () {
                dispatch({
                    type: $4c1212f0703a6b7d$var$SelectedItemKeyDownDelete
                });
            },
            Backspace () {
                dispatch({
                    type: $4c1212f0703a6b7d$var$SelectedItemKeyDownBackspace
                });
            }
        }), [
        dispatch,
        keyNavigationNext,
        keyNavigationPrevious
    ]);
    const dropdownKeyDownHandlers = (0, $3ZYaX.useMemo)(()=>({
            [keyNavigationPrevious] (event) {
                if ($4c1212f0703a6b7d$var$isKeyDownOperationPermitted(event)) dispatch({
                    type: $4c1212f0703a6b7d$var$DropdownKeyDownNavigationPrevious
                });
            },
            Backspace (event) {
                if ($4c1212f0703a6b7d$var$isKeyDownOperationPermitted(event)) dispatch({
                    type: $4c1212f0703a6b7d$var$DropdownKeyDownBackspace
                });
            }
        }), [
        dispatch,
        keyNavigationPrevious
    ]); // Getter props.
    const getSelectedItemProps = (0, $3ZYaX.useCallback)(function(_temp) {
        let { refKey: refKey = 'ref', ref: ref, onClick: onClick, onKeyDown: onKeyDown, selectedItem: selectedItem, index: index, ...rest } = _temp === void 0 ? {} : _temp;
        const { state: latestState } = latest.current;
        const itemIndex = $4c1212f0703a6b7d$var$getItemIndex(index, selectedItem, latestState.selectedItems);
        if (itemIndex < 0) throw new Error('Pass either selectedItem or index in getSelectedItemProps!');
        const selectedItemHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$SelectedItemClick,
                index: index
            });
        };
        const selectedItemHandleKeyDown = (event)=>{
            const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
            if (key && selectedItemKeyDownHandlers[key]) selectedItemKeyDownHandlers[key](event);
        };
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (selectedItemNode)=>{
                if (selectedItemNode) selectedItemRefs.current.push(selectedItemNode);
            }),
            tabIndex: index === latestState.activeIndex ? 0 : -1,
            onClick: $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, selectedItemHandleClick),
            onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown),
            ...rest
        };
    }, [
        dispatch,
        latest,
        selectedItemKeyDownHandlers
    ]);
    const getDropdownProps = (0, $3ZYaX.useCallback)(function(_temp2, _temp3) {
        let { refKey: refKey = 'ref', ref: ref, onKeyDown: onKeyDown, onClick: onClick, preventKeyAction: preventKeyAction = false, ...rest } = _temp2 === void 0 ? {} : _temp2;
        let { suppressRefError: suppressRefError = false } = _temp3 === void 0 ? {} : _temp3;
        setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);
        const dropdownHandleKeyDown = (event)=>{
            const key = $4c1212f0703a6b7d$var$normalizeArrowKey(event);
            if (key && dropdownKeyDownHandlers[key]) dropdownKeyDownHandlers[key](event);
        };
        const dropdownHandleClick = ()=>{
            dispatch({
                type: $4c1212f0703a6b7d$var$DropdownClick
            });
        };
        return {
            [refKey]: $4c1212f0703a6b7d$var$handleRefs(ref, (dropdownNode)=>{
                if (dropdownNode) dropdownRef.current = dropdownNode;
            }),
            ...!preventKeyAction && {
                onKeyDown: $4c1212f0703a6b7d$var$callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
                onClick: $4c1212f0703a6b7d$var$callAllEventHandlers(onClick, dropdownHandleClick)
            },
            ...rest
        };
    }, [
        dispatch,
        dropdownKeyDownHandlers,
        setGetterPropCallInfo
    ]); // returns
    const addSelectedItem = (0, $3ZYaX.useCallback)((selectedItem)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionAddSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    const removeSelectedItem = (0, $3ZYaX.useCallback)((selectedItem)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionRemoveSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    const setSelectedItems = (0, $3ZYaX.useCallback)((newSelectedItems)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetSelectedItems,
            selectedItems: newSelectedItems
        });
    }, [
        dispatch
    ]);
    const setActiveIndex = (0, $3ZYaX.useCallback)((newActiveIndex)=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionSetActiveIndex,
            activeIndex: newActiveIndex
        });
    }, [
        dispatch
    ]);
    const reset = (0, $3ZYaX.useCallback)(()=>{
        dispatch({
            type: $4c1212f0703a6b7d$var$FunctionReset
        });
    }, [
        dispatch
    ]);
    return {
        getSelectedItemProps: getSelectedItemProps,
        getDropdownProps: getDropdownProps,
        addSelectedItem: addSelectedItem,
        removeSelectedItem: removeSelectedItem,
        setSelectedItems: setSelectedItems,
        setActiveIndex: setActiveIndex,
        reset: reset,
        selectedItems: selectedItems,
        activeIndex: activeIndex
    };
}



var $2KSUA = parcelRequire("2KSUA");

const $12289d5dc80d8270$var$AutocompleteField = ({ field: field, form: form, items: items, label: label, disabled: disabled = false, help: help, required: required, onlySelect: onlySelect, placeholder: placeholder, clearOnSelect: clearOnSelect, showItemsAfterSelect: showItemsAfterSelect, initialInputValue: initialInputValue })=>{
    const inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useRef(null);
    const { isOpen: isOpen, getMenuProps: getMenuProps, getInputProps: getInputProps, getComboboxProps: getComboboxProps, getItemProps: getItemProps, openMenu: openMenu, reset: reset, highlightedIndex: highlightedIndex, setInputValue: setInputValue, inputValue: inputValue } = (0, $4c1212f0703a6b7d$export$7a023a466c03eb3d)({
        items: items || [],
        defaultInputValue: (items || []).find((item)=>item.value === (0, $2KSUA.get)(form.initialValues, field.name))?.label || initialInputValue || (0, $2KSUA.get)(form.initialValues, field.name),
        onSelectedItemChange: (changes)=>{
            const selectedItem = filteredItems[highlightedIndex];
            form.setFieldValue(field.name, selectedItem?.value || !onlySelect && changes.inputValue);
            if (clearOnSelect) setInputValue('');
            else setInputValue(selectedItem?.label || '');
            if (showItemsAfterSelect) {
                inputRef?.current?.blur();
                inputRef?.current?.focus();
            }
        },
        itemToString: (item)=>item ? item.label : '',
        onInputValueChange ({ inputValue: inputValue }) {
            if (!onlySelect) form.setFieldValue(field.name, inputValue);
        }
    });
    const inputProps = {
        className: 'input',
        onFocus: ()=>!isOpen && (items || [])[0] && openMenu()
    };
    (0, $3ZYaX.useEffect)(()=>{
        reset();
    }, [
        form.initialValues
    ]);
    const filteredItems = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>(items || []).filter((item)=>!inputValue || item.label?.toLowerCase().includes(inputValue?.toLowerCase?.() || '')), [
        items,
        inputValue
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        error: form.errors[field.name],
        required: required,
        help: help,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                align: "left",
                p: 2,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$82eafebb825fc23f), {})
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                ...getComboboxProps(),
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("input", {
                    ...getInputProps({
                        ...inputProps,
                        disabled: disabled,
                        ref: inputRef,
                        required: required
                    }),
                    placeholder: placeholder,
                    name: field.name,
                    "data-lpignore": "true",
                    "data-form-type": "other",
                    className: "input",
                    autoComplete: "off",
                    autoCorrect: "off",
                    autoCapitalize: "off",
                    spellCheck: "false"
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                ...getMenuProps(),
                children: isOpen && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                    style: {
                        maxHeight: `250px`,
                        overflow: `scroll`,
                        position: `absolute`,
                        zIndex: 10,
                        width: `100%`
                    },
                    className: "filter-dropdown",
                    children: filteredItems.map((item)=>{
                        const filteredItemIndex = filteredItems.findIndex((i)=>i.value === item.value);
                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                            ...getItemProps({
                                item: item,
                                index: filteredItemIndex,
                                disabled: item.disabled,
                                className: [
                                    `py-2 has-text-left pl-2 pr-1`,
                                    highlightedIndex === filteredItemIndex ? `has-background-primary` : `has-background-white`,
                                    item.disabled ? `has-background-grey-lighter` : ''
                                ].join(' ')
                            }),
                            children: item.renderedLabel || item.label
                        }, `${item.value}-${item.field}-${item.count}`);
                    })
                })
            })
        ]
    });
};
var $12289d5dc80d8270$export$2e2bcd8739ae039 = $12289d5dc80d8270$var$AutocompleteField;











parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");








var $573f2027ee8ef88f$var$MILLISECONDS_IN_DAY = 86400000;
function $573f2027ee8ef88f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $bc6257ff1cff4410$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $bc6257ff1cff4410$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $573f2027ee8ef88f$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $46e6b7724aa17953$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $46e6b7724aa17953$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $46e6b7724aa17953$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $573f2027ee8ef88f$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($46e6b7724aa17953$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $a3b55745b4eb7229$export$2e2bcd8739ae039(date, day) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var delta = day - (0, $aa33e773084f22af$export$2e2bcd8739ae039)(date);
    if (delta <= 0) delta += 7;
    return (0, $ffff430a208564ac$export$2e2bcd8739ae039)(date, delta);
}



function $4bb47b500c9001ee$export$2e2bcd8739ae039(date) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $a3b55745b4eb7229$export$2e2bcd8739ae039)(date, 0);
}












parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");




function $41fed520b9a3cbfc$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}



function $e9a938c5524deff7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    return month;
}



function $24b0abd2ba7191fe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getFullYear();
}



function $e583237d813f9e77$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 5;
}



function $280106f93de60a05$export$2e2bcd8739ae039(date) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(date).getDay() === 1;
}



function $609e0853d535025b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 6;
}



function $4b5cc329e7644414$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 0;
}



function $c788d6710bcaf89b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 4;
}



function $e4d05b06668d3b6c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 2;
}



function $90264a0e1472ee09$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate).getDay() === 3;
}



var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");

const $52e2cf4c073cab74$var$getCalendarInitialState = ()=>({
        calendar: {},
        startDate: '',
        endDate: '',
        getDay: ()=>null,
        getWeek: ()=>null,
        getWeekDays: ()=>[]
    });
const $52e2cf4c073cab74$var$createCalendarContext = (0, $2KSUA.once)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).createContext($52e2cf4c073cab74$var$getCalendarInitialState()));
const $52e2cf4c073cab74$var$context = $52e2cf4c073cab74$var$getCalendarInitialState();
const $52e2cf4c073cab74$export$a4e6a44ee6f2e968 = ()=>(0, $3ZYaX.useContext)($52e2cf4c073cab74$var$createCalendarContext());
const $52e2cf4c073cab74$export$8b341ed8ff2f3a22 = ({ children: children, startDateISO: startDateISO, endDateISO: endDateISO, select: select, metadata: metadata, data: data })=>{
    const StateContext = $52e2cf4c073cab74$var$createCalendarContext();
    const lastCalendar = (0, $3ZYaX.useRef)();
    const getCalendarDay = (isoDate)=>{
        const date = new Date(isoDate);
        return fullCalendar.calendar?.[(0, $ac69c6a7c3af73c1$export$2e2bcd8739ae039)(date)]?.[(0, $3cbe7fa53b58a992$export$2e2bcd8739ae039)(date)]?.find((d)=>d?.isoDate === isoDate) ?? null;
    };
    const getCalendarWeek = (isoDate)=>{
        const date = new Date(isoDate);
        return fullCalendar.calendar?.[(0, $ac69c6a7c3af73c1$export$2e2bcd8739ae039)(date)]?.[(0, $3cbe7fa53b58a992$export$2e2bcd8739ae039)(date)] ?? null;
    };
    const getCalendarWeekDays = (isoWeekDay)=>{
        const days = (0, $a1d8421bf1d3b65c$export$2e2bcd8739ae039)({
            start: new Date(startDateISO),
            end: new Date(endDateISO)
        }).filter($52e2cf4c073cab74$var$isWeekDayMethods[isoWeekDay]).map((day)=>(0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(day)).map((isoDate)=>getCalendarDay(isoDate)).filter((d)=>!!d);
        return days;
    };
    const fullCalendar = (0, $3ZYaX.useMemo)(()=>{
        try {
            const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(startDateISO);
            const endDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(endDateISO);
            if (((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(startDate, endDate) || (0, $b7e820f063c8ba7a$export$2e2bcd8739ae039)(startDate, endDate)) && (0, $46e6b7724aa17953$export$2e2bcd8739ae039)(endDate, startDate) <= 400) {
                const calendar = {
                    calendar: $52e2cf4c073cab74$var$getWeeksListCalendar(startDateISO, endDateISO, data, select, metadata),
                    startDate: startDateISO,
                    endDate: endDateISO,
                    getDay: getCalendarDay,
                    getWeek: getCalendarWeek,
                    getWeekDays: getCalendarWeekDays
                };
                lastCalendar.current = calendar;
                return calendar;
            } else return lastCalendar.current ?? $52e2cf4c073cab74$var$getCalendarInitialState();
        } catch (err) {
            console.error(err);
        }
        return lastCalendar.current;
    }, [
        startDateISO,
        endDateISO,
        data,
        select,
        metadata
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(StateContext.Provider, {
        value: fullCalendar,
        children: children
    });
};
const $52e2cf4c073cab74$export$17080c2550cc1370 = ({ children: children })=>{
    const calendar = $52e2cf4c073cab74$export$a4e6a44ee6f2e968();
    return children(calendar);
};
/**
 * Generates a calendar on a date given interval
 * @param {string} startDate - date format YYYY-mm-dd, lower than or equal to @endDate
 * @param {string} endDate - date format YYYY--mm-dd, higher than or equal to @endDate
 * @returns {{year: {week: Day}}} - an object keyed by year / week / CalendarDay
 */ const $52e2cf4c073cab74$var$getWeeksListCalendar = (startDateISO, endDateISO, data, select, metadata)=>{
    if (!startDateISO) return {};
    if (!endDateISO) return {};
    try {
        // eachDayOfInterval will fail with a RangeError if endDate < startDate
        // form validation prevents this too
        const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(startDateISO);
        const endDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(endDateISO);
        const years = (0, $a1d8421bf1d3b65c$export$2e2bcd8739ae039)({
            start: startDate,
            end: endDate
        }).map((date)=>{
            const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
            const dayData = select.day(data, (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date));
            const calendarDay = {
                weekDay: (0, $aa33e773084f22af$export$2e2bcd8739ae039)(date),
                week: (0, $3cbe7fa53b58a992$export$2e2bcd8739ae039)(date),
                weekYear: (0, $ac69c6a7c3af73c1$export$2e2bcd8739ae039)(date),
                month: (0, $e9a938c5524deff7$export$2e2bcd8739ae039)(date),
                year: (0, $24b0abd2ba7191fe$export$2e2bcd8739ae039)(date),
                isoDate: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date),
                isoTime: (0, $77f154409ac96cff$export$2e2bcd8739ae039)(date, {
                    representation: 'time'
                }),
                isoFullDate: (0, $77f154409ac96cff$export$2e2bcd8739ae039)(date),
                day: (0, $41fed520b9a3cbfc$export$2e2bcd8739ae039)(date),
                data: dayData,
                metadata: dayData ? metadata.day(dayData, isoDate) : null
            };
            return calendarDay;
        }).reduce((years, day)=>{
            (0, $2KSUA.setWith)(years, [
                day.weekYear,
                day.week
            ], [
                ...years?.[day.weekYear]?.[day.week] ?? [],
                day
            ], Object);
            return years;
        }, {});
        Object.entries(years).map(([yearNumber, weeks])=>Object.entries(weeks).map(([weekNumber, week])=>{
                if (week.length < 7 && week[0]) {
                    const firstWeekDay = week[0].weekDay;
                    const lastWeekDay = (week[week.length - 1] ?? week[0]).weekDay;
                    // If firstWeekDay is sunday (=== 0) we convert it to 7 to handle counting back to 1
                    for(let weekDay = firstWeekDay === 0 ? 7 : firstWeekDay; weekDay !== 1; weekDay--)week.unshift(null);
                    if (lastWeekDay !== 0) for(let weekDay = lastWeekDay; weekDay <= 6; weekDay++)week.push(null);
                }
            }));
        return years;
    } catch (error) {
        console.error(error);
        return {};
    }
};
const $52e2cf4c073cab74$var$isWeekDayMethods = [
    (0, $4b5cc329e7644414$export$2e2bcd8739ae039),
    (0, $280106f93de60a05$export$2e2bcd8739ae039),
    (0, $e4d05b06668d3b6c$export$2e2bcd8739ae039),
    (0, $90264a0e1472ee09$export$2e2bcd8739ae039),
    (0, $c788d6710bcaf89b$export$2e2bcd8739ae039),
    (0, $e583237d813f9e77$export$2e2bcd8739ae039),
    (0, $609e0853d535025b$export$2e2bcd8739ae039)
];





parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


const $593fa3fac006133c$export$2bb5d243bf881350 = ({ startDate: startDate, calendarWeek: calendarWeek })=>{
    const firstDay = calendarWeek.find((d)=>d != null);
    const lastDay = calendarWeek[calendarWeek.length - 1];
    if (!firstDay) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (!lastDay) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    const isFirstCalendarWeek = (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(new Date(startDate), {
        start: new Date(firstDay.isoDate),
        end: new Date(lastDay.isoDate)
    });
    const isNextMonth = firstDay.month !== lastDay.month || firstDay.day === 1;
    if (isNextMonth || isFirstCalendarWeek) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
            colSpan: 8,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                my: 3,
                size: 3,
                children: [
                    ' ',
                    (0, $b3177a4462e15523$export$2e2bcd8739ae039)(new Date(lastDay.isoDate), 'MMMM yyyy')
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
};


const $0bc0ef7c1b53552e$export$fca4f8121099df57 = ({ children: children, calendarWeek: calendarWeek, startDate: startDate })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            calendarWeek != null && startDate != null && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $593fa3fac006133c$export$2bb5d243bf881350), {
                calendarWeek: calendarWeek,
                startDate: startDate
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                children: children
            })
        ]
    });
};
const $0bc0ef7c1b53552e$var$Header = ({ week: week, left: left, right: right, children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: left ? left : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            textWeight: "bold",
                            children: [
                                "S",
                                week
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: right
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: children
            })
        ]
    });
};
$0bc0ef7c1b53552e$export$fca4f8121099df57.Header = $0bc0ef7c1b53552e$var$Header;



parcelRequire("3ZYaX");

const $dac6dc0cea4f2daf$var$weekDays = [
    1,
    2,
    3,
    4,
    5,
    6,
    0
];
const $dac6dc0cea4f2daf$var$weekDayNames = [
    'Di.',
    'Lu.',
    'Ma.',
    'Me.',
    'Je.',
    'Ve.',
    'Sa.'
];
const $dac6dc0cea4f2daf$export$8425047b6f53f78b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Table), {
        bordered: true,
        size: "fullwidth",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tbody", {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                children: children
            })
        })
    });
};
const $dac6dc0cea4f2daf$var$Header = ({ left: left, right: right })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "td",
                    textWeight: "bold",
                    children: "Semaine"
                }),
                $dac6dc0cea4f2daf$var$weekDays.map((wD)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            justifyContent: "space-between",
                            children: [
                                left ? left(wD) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textWeight: "bold",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                        children: $dac6dc0cea4f2daf$var$weekDayNames[wD]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    children: right ? right(wD) : undefined
                                })
                            ]
                        })
                    }, wD))
            ]
        })
    });
};
$dac6dc0cea4f2daf$export$8425047b6f53f78b.Header = $dac6dc0cea4f2daf$var$Header;








var $2KSUA = parcelRequire("2KSUA");


const $cf0e3868e71e81cf$export$3f15a818b2d516e4 = (workPeriods, isoDate, value)=>{
    const existingWorkPeriodIndex = $cf0e3868e71e81cf$var$getExistingWorkPeriodIndex(workPeriods, isoDate);
    const existingWorkPeriod = existingWorkPeriodIndex === -1 ? undefined : (0, $2KSUA.cloneDeep)(workPeriods[existingWorkPeriodIndex]);
    const newWorkPeriod = existingWorkPeriod || {};
    const startDate = value.start?.date;
    const endDate = value.end?.date;
    if (startDate) newWorkPeriod.start = {
        date: startDate
    };
    if (endDate) newWorkPeriod.end = {
        date: endDate
    };
    if (newWorkPeriod.end?.date && newWorkPeriod.start?.date) {
        if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(newWorkPeriod.end.date, newWorkPeriod.start.date)) newWorkPeriod.end = {
            date: (0, $ffff430a208564ac$export$2e2bcd8739ae039)(newWorkPeriod.end.date, 1)
        };
        if ((0, $46e6b7724aa17953$export$2e2bcd8739ae039)(newWorkPeriod.end.date, newWorkPeriod.start.date) > 0) newWorkPeriod.end = {
            date: (0, $f85dee25334cb4c9$export$2e2bcd8739ae039)(newWorkPeriod.end.date, 1)
        };
    }
    const newWorkPeriods = (0, $2KSUA.cloneDeep)(workPeriods);
    if (existingWorkPeriod) newWorkPeriods[existingWorkPeriodIndex] = newWorkPeriod;
    else newWorkPeriods.push(newWorkPeriod);
    return newWorkPeriods.sort((a, b)=>{
        const wP1Date = a.start?.date ?? a.end?.date;
        const wP2Date = b.start?.date ?? b.end?.date;
        return wP1Date.getTime() - wP2Date.getTime();
    });
};
const $cf0e3868e71e81cf$export$af94e4826200cf89 = (workPeriods, isoDate)=>{
    const newWorkPeriods = (0, $2KSUA.cloneDeep)(workPeriods);
    return newWorkPeriods.filter((wP)=>{
        const wPDate = wP.start?.date ?? wP.end?.date;
        const wPDateISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(wPDate));
        if (wPDateISO === isoDate) return false;
        return true;
    }).sort((a, b)=>{
        const wP1Date = a.start?.date ?? a.end?.date;
        const wP2Date = b.start?.date ?? b.end?.date;
        return wP1Date.getTime() - wP2Date.getTime();
    });
};
const $cf0e3868e71e81cf$export$a65030a57052e482 = (workPeriods, isoDates, values)=>{
    let newWorkPeriods = (0, $2KSUA.cloneDeep)(workPeriods);
    let index = 0;
    for (const isoDate of isoDates){
        const value = values[index];
        if (value === undefined) newWorkPeriods = $cf0e3868e71e81cf$export$af94e4826200cf89(newWorkPeriods, isoDate);
        else newWorkPeriods = $cf0e3868e71e81cf$export$3f15a818b2d516e4(newWorkPeriods, isoDate, value);
        index++;
    }
    return newWorkPeriods;
};
const $cf0e3868e71e81cf$var$getExistingWorkPeriodIndex = (workPeriods, isoDate)=>{
    const existingWorkPeriodIndex = workPeriods.findIndex((wP)=>{
        const date = wP.start?.date ?? wP.end?.date;
        if (!date) return false;
        const wPDateISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(date));
        return wPDateISO === isoDate;
    });
    return existingWorkPeriodIndex;
};
const $cf0e3868e71e81cf$export$d44871b6f8c2ac6f = (workPeriods, isoDate)=>{
    const index = $cf0e3868e71e81cf$var$getExistingWorkPeriodIndex(workPeriods, isoDate);
    if (index === undefined) return undefined;
    return workPeriods[index];
};
const $cf0e3868e71e81cf$export$e2a72d0df5666864 = (workPeriods, days, clipboardDayValue)=>{
    const [startTime, endTime] = clipboardDayValue;
    const daysISO = days.map((d)=>d.isoDate);
    const values = days.map(({ isoDate: isoDate })=>{
        const startDate = startTime ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), startTime) : undefined;
        const endDate = endTime ? (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), endTime) : undefined;
        return {
            start: startDate ? {
                date: startDate
            } : undefined,
            end: endDate ? {
                date: endDate
            } : undefined
        };
    });
    return $cf0e3868e71e81cf$export$a65030a57052e482(workPeriods, daysISO, values);
};
const $cf0e3868e71e81cf$export$c63b0b134c3c38c6 = (week)=>{
    return week.map((day)=>{
        if (!day) return null;
        const startDate = day?.data?.start?.date;
        const endDate = day?.data?.end?.date;
        if (!startDate || !endDate) return null;
        return [
            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(startDate),
            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(endDate)
        ];
    });
};
const $cf0e3868e71e81cf$export$d776eb73499cb2 = (workPeriods, week, clipboardWeek)=>{
    const res = clipboardWeek.map((clipboardDay, index)=>{
        const dayInWeek = week[index];
        if (!dayInWeek) return null;
        const { isoDate: isoDate } = dayInWeek;
        if (clipboardDay === null) return {
            isoDate: isoDate,
            value: undefined
        };
        const [start, end] = clipboardDay;
        const startDate = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), start);
        const endDate = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), end);
        if (!startDate || !endDate) return {
            isoDate: isoDate,
            value: undefined
        };
        return {
            isoDate: isoDate,
            value: {
                start: {
                    date: startDate
                },
                end: {
                    date: endDate
                }
            }
        };
    }).filter((v)=>v !== null);
    const daysISO = res.map((d)=>d.isoDate);
    const values = res.map((d)=>d.value);
    return $cf0e3868e71e81cf$export$a65030a57052e482(workPeriods, daysISO, values);
};
const $cf0e3868e71e81cf$export$a6bf9e6b07f9f5b0 = (day)=>{
    if (!day) return null;
    const startDate = day.data?.start?.date;
    const endDate = day.data?.end?.date;
    if (!startDate || !endDate) return null;
    return [
        (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(startDate),
        (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(endDate)
    ];
};
const $cf0e3868e71e81cf$export$8dc66215d230baa8 = (workPeriods, isoDate, clipboardDayValue)=>{
    const [startTime, endTime] = clipboardDayValue;
    const startDate = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), startTime);
    const endDate = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), endTime);
    return $cf0e3868e71e81cf$export$3f15a818b2d516e4(workPeriods, isoDate, {
        ...startDate ? {
            start: {
                date: startDate
            }
        } : {},
        ...endDate ? {
            end: {
                date: endDate
            }
        } : {}
    });
};




var $3ZYaX = parcelRequire("3ZYaX");








function $d662c19c80f1ebbc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $ef2e6760f3e9e6fc$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $43fc9b1fade34ef5$export$7f72910d6dfd237a);
    return (0, $d94c5f7b694ddfdc$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


parcelRequire("3ZYaX");

const $32184023aadc71a6$var$Duration = ({ duration: duration })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: duration ? `${String((0, $d662c19c80f1ebbc$export$2e2bcd8739ae039)(duration, new Date(0))).padStart(2, '0')}h${String((0, $80bdff59a66cc285$export$2e2bcd8739ae039)(duration)).padStart(2, '0')}` : '--:--'
    });
};
var $32184023aadc71a6$export$2e2bcd8739ae039 = $32184023aadc71a6$var$Duration;




var $3ZYaX = parcelRequire("3ZYaX");






function $b8561e530ff0425c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $0848d9b2b2c44333$export$2e2bcd8739ae039(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = (0, $aae924f7e2151cb9$export$2e2bcd8739ae039)(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it["return"] != null) it["return"]();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}





function $53ca38d1ad572ad0$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}













var $6005a43b34c2ec62$var$TIMEZONE_UNIT_PRIORITY = 10;
var $6005a43b34c2ec62$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Setter);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $6005a43b34c2ec62$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($6005a43b34c2ec62$export$81d53e3678089a6);
var $6005a43b34c2ec62$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this2), "priority", $6005a43b34c2ec62$var$TIMEZONE_UNIT_PRIORITY);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($6005a43b34c2ec62$export$81d53e3678089a6);












var $c203ba349fe30b2a$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Parser);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $6005a43b34c2ec62$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $88e9be5469d19acc$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $fc0915c441b1416e$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $fc0915c441b1416e$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $aed7fbba9846640d$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $aed7fbba9846640d$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $aed7fbba9846640d$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $43fc9b1fade34ef5$export$7f72910d6dfd237a) + minutes * (0, $43fc9b1fade34ef5$export$91246f0b9bd9beff) + seconds * (0, $43fc9b1fade34ef5$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $aed7fbba9846640d$export$d931c43c4608a164(dateString) {
    return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $aed7fbba9846640d$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $aed7fbba9846640d$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388((0, $fc0915c441b1416e$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $aed7fbba9846640d$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $aed7fbba9846640d$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $aed7fbba9846640d$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $aed7fbba9846640d$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $d3d9f76d4e023226$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aed7fbba9846640d$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));












var $24200bb24accf0da$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $cd0cbe88f0dad20f$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $aed7fbba9846640d$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $3b0e493a0f171243$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $4320bd52a4f7977c$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $aed7fbba9846640d$export$2c9307b2e29c533c)(4, dateString);
                return (0, $aed7fbba9846640d$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $003d5903100bf7b9$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $aed7fbba9846640d$export$2c9307b2e29c533c)(4, dateString);
                return (0, $aed7fbba9846640d$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $956b718f1de806c7$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $dd1f911c583ec7fb$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $75efbbb1504b632d$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $368f6804bd247b77$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));















function $ee8093f58f1025c5$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $f7f10b8c1779482c$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $e92c3cf1dd4c8b79$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $3b0e493a0f171243$export$2e2bcd8739ae039)((0, $ee8093f58f1025c5$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));















function $58ec185e942f061e$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $31538da948800fca$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $5b5f49fa804256d4$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $01500e4e6887ae6d$export$2e2bcd8739ae039)((0, $58ec185e942f061e$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $6a237eed194d4126$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6a237eed194d4126$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $6a237eed194d4126$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aed7fbba9846640d$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $6a237eed194d4126$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $6a237eed194d4126$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $a85f9e49928bb329$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $aed7fbba9846640d$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));













function $59cccc04d86f7475$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $2c728c6ef3df23f0$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $59cccc04d86f7475$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $5503ae9495e9be91$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $59cccc04d86f7475$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $5756f2ebf877ac46$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $59cccc04d86f7475$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));













function $97a08d6bb141e657$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $31342e0d23cb8328$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $97a08d6bb141e657$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $5d26ecdad06b9d53$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aed7fbba9846640d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $caefa8bfb994df30$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aed7fbba9846640d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $d43436d6dd42cbd6$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $aed7fbba9846640d$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $3d8ac61f841bf905$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $76df87affcb9f15b$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $f91ee1291d6bac7a$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $95b709516ede2907$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $91af1444a043e049$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $251981a5a24c2f2f$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $aed7fbba9846640d$export$cc7cc9e2a3ff9388)((0, $fc0915c441b1416e$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $62dcb798e58b2b84$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $aed7fbba9846640d$export$4f84e3a82c7b538)((0, $aed7fbba9846640d$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $24fcc4d9c5eea87b$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));











var $0d0de3b7a0f0918b$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $aed7fbba9846640d$export$6497f4c0ecdfba8e)((0, $fc0915c441b1416e$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $245d89f56ac90a96$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aed7fbba9846640d$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));










var $b2e85a47f4ca8ed1$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $687ec183e6b89631$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $c20a72ef48ff22ef$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $7fd886c94dd8d074$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $400f8bc2acfb090b$export$2e2bcd8739ae039)((0, $3cb931c9622cfb2b$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $c42b4f5f03eb3eda$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $aed7fbba9846640d$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $c203ba349fe30b2a$export$7acfa6ed01010e37));


var $e6be4c58938e37d4$export$19131010e7fd8373 = {
    G: new (0, $88e9be5469d19acc$export$8e5a1d3f85a9688)(),
    y: new (0, $d3d9f76d4e023226$export$48d352de7cd4a988)(),
    Y: new (0, $24200bb24accf0da$export$b8ef38dfcf05d5db)(),
    R: new (0, $4320bd52a4f7977c$export$951d1df011fde06f)(),
    u: new (0, $003d5903100bf7b9$export$bad9d2ea38e8f1a)(),
    Q: new (0, $956b718f1de806c7$export$5cb0f701186dde1d)(),
    q: new (0, $dd1f911c583ec7fb$export$300c0c2990e20e6d)(),
    M: new (0, $75efbbb1504b632d$export$400dd8b40ef138a3)(),
    L: new (0, $368f6804bd247b77$export$1d7eaa53eaa5deba)(),
    w: new (0, $e92c3cf1dd4c8b79$export$c4005ffc174e07c0)(),
    I: new (0, $5b5f49fa804256d4$export$6fc8dbedd560a6af)(),
    d: new (0, $6a237eed194d4126$export$e8d4b28a20981dd2)(),
    D: new (0, $a85f9e49928bb329$export$6cfe0d613455f615)(),
    E: new (0, $2c728c6ef3df23f0$export$1b03c8b76262f7bd)(),
    e: new (0, $5503ae9495e9be91$export$44d1c127ab42c480)(),
    c: new (0, $5756f2ebf877ac46$export$e447a647caaaec1d)(),
    i: new (0, $31342e0d23cb8328$export$693fb1e525095b2a)(),
    a: new (0, $5d26ecdad06b9d53$export$8d1e08492351df91)(),
    b: new (0, $caefa8bfb994df30$export$73ca2bd0a17d273)(),
    B: new (0, $d43436d6dd42cbd6$export$bb9212adf05373db)(),
    h: new (0, $3d8ac61f841bf905$export$8a04050a727a1756)(),
    H: new (0, $76df87affcb9f15b$export$e56f4dea2c3e56dd)(),
    K: new (0, $f91ee1291d6bac7a$export$cbbe855312f87d77)(),
    k: new (0, $95b709516ede2907$export$6008046d2b34b6a5)(),
    m: new (0, $91af1444a043e049$export$2b52670d9e2be53)(),
    s: new (0, $251981a5a24c2f2f$export$94d46d540cf1366a)(),
    S: new (0, $62dcb798e58b2b84$export$b8e6f8b2d70893b1)(),
    X: new (0, $24fcc4d9c5eea87b$export$104d901d49fea29b)(),
    x: new (0, $0d0de3b7a0f0918b$export$12910e5204b52b9)(),
    t: new (0, $245d89f56ac90a96$export$2cd8bf877a05e96)(),
    T: new (0, $b2e85a47f4ca8ed1$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3c2beeee8a85aa7a$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3c2beeee8a85aa7a$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3c2beeee8a85aa7a$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3c2beeee8a85aa7a$var$doubleQuoteRegExp = /''/g;
var $3c2beeee8a85aa7a$var$notWhitespaceRegExp = /\S/;
var $3c2beeee8a85aa7a$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3c2beeee8a85aa7a$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $337760cc38e3625f$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $9bf1fd7b116fa75d$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $6005a43b34c2ec62$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($3c2beeee8a85aa7a$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $2d527a05a01a79d3$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $2d527a05a01a79d3$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($3c2beeee8a85aa7a$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $0848d9b2b2c44333$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $47d0602003c48d0a$export$c6b49d6dceb604a1)(token)) (0, $47d0602003c48d0a$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $47d0602003c48d0a$export$c6cc36aa33304772)(token)) (0, $47d0602003c48d0a$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $e6be4c58938e37d4$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($3c2beeee8a85aa7a$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $3c2beeee8a85aa7a$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $143ffd39167373a2$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $3c2beeee8a85aa7a$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $39028f7a2e9d41b1$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $bf358204eecbb5df$export$2e2bcd8739ae039)(date, (0, $bc6257ff1cff4410$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $0848d9b2b2c44333$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $53ca38d1ad572ad0$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $3c2beeee8a85aa7a$var$cleanEscapedString(input) {
    return input.match($3c2beeee8a85aa7a$var$escapedStringRegExp)[1].replace($3c2beeee8a85aa7a$var$doubleQuoteRegExp, "'");
}



var $2KSUA = parcelRequire("2KSUA");
const $979d61d174fb9293$export$aff9f73b476315e2 = (start, end, breakRule)=>{
    const workPeriodDuration = (0, $3ZYaX.useMemo)(()=>(0, $dda2f26c3659cf93$export$1003465f9cabc75e)(start, end, breakRule), [
        start,
        end,
        breakRule
    ]);
    return workPeriodDuration;
};
const $979d61d174fb9293$export$aa2440293bce371b = (workPeriods, breakRule, userId, period)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const usersQuery = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        filter: JSON.stringify({
            associations: {
                $elemMatch: {
                    organization: currentOrganization._id,
                    status: [
                        'accepted',
                        'pending'
                    ]
                }
            }
        })
    });
    const currentWorker = userId && usersQuery.data?.find((u)=>u._id === userId);
    const currentWorkerAssociation = currentWorker && currentWorker.associations ? (0, $25ffbf4bca475b04$export$91d1acdd7472079)(currentWorker, currentOrganization) : undefined;
    const activeContractualSchedule = currentWorkerAssociation && workPeriods[0]?.start?.date ? (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(currentWorkerAssociation, new Date(workPeriods[0].start?.date)) : undefined;
    const workPeriodsDuration = (0, $3ZYaX.useMemo)(()=>{
        let weekDate;
        let monthDate;
        let startDate;
        let endDate;
        let expected;
        let filteredWorkPeriods = (0, $2KSUA.cloneDeep)(workPeriods);
        if (period) {
            try {
                weekDate = (0, $3c2beeee8a85aa7a$export$2e2bcd8739ae039)(period, "RRRR-'W'II", new Date());
                expected = (activeContractualSchedule?.weeklyHoursWorked ?? 0) * 3600000;
                startDate = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(weekDate);
                endDate = (0, $d9677f7cca086b20$export$2e2bcd8739ae039)(weekDate);
            } catch  {
            // ignore
            }
            try {
                monthDate = (0, $3c2beeee8a85aa7a$export$2e2bcd8739ae039)(period, 'YYYY-MM', new Date());
                expected = (activeContractualSchedule?.monthlyHoursWorked ?? 0) * 3600000;
                startDate = (0, $9d8683737c4c4df2$export$2e2bcd8739ae039)(monthDate);
                endDate = (0, $b8561e530ff0425c$export$2e2bcd8739ae039)(monthDate);
            } catch  {
            // ignore
            }
            filteredWorkPeriods = filteredWorkPeriods.filter((wP)=>{
                if (!wP.start?.date || !wP.end?.date) return false;
                return (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(wP.start?.date, {
                    start: startDate,
                    end: endDate
                });
            });
        }
        const totalDuration = (0, $dda2f26c3659cf93$export$cead3b29a17b1754)(filteredWorkPeriods, breakRule);
        return {
            total: totalDuration,
            expected: expected
        };
    }, [
        workPeriods,
        breakRule,
        userId,
        period
    ]);
    return workPeriodsDuration;
};
const $979d61d174fb9293$export$8b5216453c9cb741 = (userId, referenceDate)=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const usersQuery = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        filter: JSON.stringify({
            associations: {
                $elemMatch: {
                    organization: currentOrganization._id,
                    status: [
                        'accepted',
                        'pending'
                    ]
                }
            }
        })
    });
    return (0, $3ZYaX.useMemo)(()=>{
        if (!userId || !referenceDate) return undefined;
        const worker = usersQuery.data?.find((u)=>u._id === userId);
        const association = worker?.associations ? (0, $25ffbf4bca475b04$export$91d1acdd7472079)(worker, currentOrganization) : undefined;
        const schedule = association ? (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association, new Date(referenceDate)) : undefined;
        const hours = schedule?.weeklyHoursWorked ?? 0;
        return hours * 3600000;
    }, [
        userId,
        referenceDate,
        usersQuery.data,
        currentOrganization
    ]);
};






const $7ef0e1ac200e2c38$export$37cb960cdb8535a5 = ({ isoDate: isoDate, workPeriods: workPeriods, jobTitle: jobTitle, initialWorkPeriods: initialWorkPeriods, resource: resource, setWorkPeriods: setWorkPeriods, errors: errors })=>{
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)();
    const currentClockingRule = jobTitle ? jobTitlesQuery.data?.find((jT)=>jobTitle.toString() === jT._id.toString())?.clockingRule : undefined;
    const existingWorkPeriod = (0, $cf0e3868e71e81cf$export$d44871b6f8c2ac6f)(workPeriods, isoDate);
    const workPeriodDuration = (0, $979d61d174fb9293$export$aff9f73b476315e2)(existingWorkPeriod?.start?.date, existingWorkPeriod?.end?.date, currentClockingRule?.break);
    const startValue = (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(existingWorkPeriod?.start?.date);
    const endValue = (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(existingWorkPeriod?.end?.date);
    const [initialStartValue, initialEndValue, initialWorkPeriodValue] = (0, $3ZYaX.useMemo)(()=>{
        const initialExistingWorkPeriod = (0, $cf0e3868e71e81cf$export$d44871b6f8c2ac6f)(initialWorkPeriods, isoDate);
        return [
            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(initialExistingWorkPeriod?.start?.date),
            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(initialExistingWorkPeriod?.end?.date),
            initialExistingWorkPeriod
        ];
    }, [
        initialWorkPeriods,
        isoDate
    ]);
    const workPeriodErrorFieldIdentifier = `workPeriod-${isoDate}`;
    const formErrors = errors[workPeriodErrorFieldIdentifier];
    const resourceIsDisabled = (0, $dcd93683234494f9$export$da2ac25f073bcdf5)(resource);
    const workPeriodIsDisabled = (0, $dcd93683234494f9$export$f8ecf111d8353055)(isoDate, resource, existingWorkPeriod);
    const isDisabled = resourceIsDisabled || workPeriodIsDisabled;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            formErrors && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                id: isoDate,
                type: "light",
                border: true,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                    error: formErrors
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                textColor: workPeriodDuration === 0 ? 'grey' : undefined,
                textSize: 7,
                children: [
                    "Dur\xe9e ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $32184023aadc71a6$export$2e2bcd8739ae039), {
                        duration: workPeriodDuration
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                my: 2,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5ee0982b08b14659$export$2e2bcd8739ae039), {
                    value: startValue,
                    onChange: (value)=>{
                        const datetime = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), value);
                        if (datetime) setWorkPeriods((0, $cf0e3868e71e81cf$export$3f15a818b2d516e4)(workPeriods, isoDate, {
                            start: {
                                date: datetime
                            }
                        }));
                    },
                    disabled: isDisabled,
                    dataTest: `work-period-start-input-${isoDate}`,
                    dataFor: isoDate,
                    name: "start",
                    inputStyle: {
                        borderColor: formErrors?.[0] ? 'red' : startValue !== initialStartValue ? 'green' : startValue === '' ? '#ccc' : undefined
                    },
                    textWeight: startValue !== '' ? 'bold' : undefined,
                    textColor: startValue === '' ? 'grey-light' : undefined
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5ee0982b08b14659$export$2e2bcd8739ae039), {
                value: endValue,
                onChange: (value)=>{
                    const datetime = (0, $74f17ceb9b5a08a5$export$52abf2da991b9a1c)(new Date(isoDate), value);
                    if (datetime) setWorkPeriods((0, $cf0e3868e71e81cf$export$3f15a818b2d516e4)(workPeriods, isoDate, {
                        end: {
                            date: datetime
                        }
                    }));
                },
                disabled: isDisabled,
                dataTest: `work-period-end-input-${isoDate}`,
                dataFor: isoDate,
                name: "end",
                inputStyle: {
                    borderColor: formErrors?.[0] ? 'red' : endValue !== initialEndValue ? 'green' : endValue === '' ? '#ccc' : undefined
                },
                textWeight: endValue !== '' ? 'bold' : undefined,
                textColor: endValue === '' ? 'grey-light' : undefined
            }),
            resource && (startValue !== initialStartValue || endValue !== initialEndValue) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                color: "link",
                type: "button",
                size: "small",
                "data-test": "cancel-edit-action",
                onClick: ()=>{
                    if (initialWorkPeriodValue) {
                        const newWorkPeriods = (0, $cf0e3868e71e81cf$export$3f15a818b2d516e4)(workPeriods, isoDate, initialWorkPeriodValue);
                        setWorkPeriods(newWorkPeriods);
                    } else {
                        const newWorkPeriods = (0, $cf0e3868e71e81cf$export$af94e4826200cf89)(workPeriods, isoDate);
                        setWorkPeriods(newWorkPeriods);
                    }
                },
                children: "Annuler"
            })
        ]
    });
};




parcelRequire("3ZYaX");

parcelRequire("3ZYaX");


const $f6a5ae756a86ced7$var$MissionWeekDuration = ({ duration: duration, expectedDuration: expectedDuration })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $32184023aadc71a6$export$2e2bcd8739ae039), {
                duration: duration
            }),
            expectedDuration ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    "\xa0/\xa0",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $32184023aadc71a6$export$2e2bcd8739ae039), {
                        duration: expectedDuration
                    })
                ]
            }) : undefined
        ]
    });
};
const $f6a5ae756a86ced7$export$ccb9110fa312629f = ({ total: total, expected: expected })=>{
    const durationMismatch = expected !== undefined && total !== expected;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        textColor: total === 0 ? 'grey' : durationMismatch ? 'danger' : undefined,
        "data-tooltip": durationMismatch ? "La dur\xe9e ne respecte pas le contrat." : undefined,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($f6a5ae756a86ced7$var$MissionWeekDuration, {
            duration: total,
            expectedDuration: durationMismatch ? expected : undefined
        })
    });
};




const $68831b1f047ffe2c$export$6e0437d0f9940d1 = ({ workPeriods: workPeriods, breakRule: breakRule, userId: userId, period: period, year: year, week: week })=>{
    const workPeriodsOfWeek = workPeriods.filter((wP)=>wP.start?.date && (0, $74f17ceb9b5a08a5$export$12d572480ceb6e58)(new Date(wP.start?.date)) === year && (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(new Date(wP.start?.date)) === week);
    const { total: total, expected: expected } = (0, $979d61d174fb9293$export$aa2440293bce371b)(workPeriodsOfWeek, breakRule, userId, period);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f6a5ae756a86ced7$export$ccb9110fa312629f), {
        total: total ?? 0,
        expected: expected
    });
};





const $dcd93683234494f9$export$da2ac25f073bcdf5 = (resource)=>{
    if (!resource) return false;
    if (resource.__actions.canBeUpdated) return false;
    return true;
};
const $dcd93683234494f9$export$f8ecf111d8353055 = (isoDate, resource, workPeriod)=>{
    if (isoDate === null) return true // out of range cell
    ;
    // if no mission we are in a create state,
    // Nothing is disabled
    if (!resource) return false;
    // Here starts update state
    if (!workPeriod) {
        // Cannot update in the past, at all
        if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(new Date(isoDate), new Date())) return true;
    } else {
        if (workPeriod.__actions?.canBeUpdated === false) return true;
    }
    return false;
};
const $dcd93683234494f9$export$1c4614b036aef1a = ({ workPeriods: workPeriods, jobTitle: jobTitle, initialWorkPeriods: initialWorkPeriods, resource: resource, user: user, setWorkPeriods: setWorkPeriods, errors: errors, startDate: startDate, endDate: endDate })=>{
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)();
    const currentClockingRule = jobTitle ? jobTitlesQuery.data?.find((jT)=>jobTitle.toString() === jT._id.toString())?.clockingRule : undefined;
    const dateRangeError = Boolean(errors.meta?.startDate) || Boolean(errors.meta?.endDate);
    const minEndDate = resource ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date()) : undefined;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $52e2cf4c073cab74$export$8b341ed8ff2f3a22), {
        startDateISO: startDate,
        endDateISO: endDate,
        select: {
            day: (wPs, isoDate)=>(0, $cf0e3868e71e81cf$export$d44871b6f8c2ac6f)(wPs, isoDate) ?? null
        },
        metadata: {
            day: (wP, isoDate)=>({
                    duration: (0, $dda2f26c3659cf93$export$1003465f9cabc75e)(wP?.start?.date, wP?.end?.date),
                    isDisabled: $dcd93683234494f9$export$f8ecf111d8353055(isoDate, resource, wP)
                })
        },
        data: workPeriods,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16df5e427bb274d8$export$278c12d137e20d5c), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($dcd93683234494f9$var$Clipboard, {
                children: (clipboard)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $52e2cf4c073cab74$export$17080c2550cc1370), {
                        children: ({ calendar: calendar, getDay: getDay, getWeekDays: getWeekDays })=>{
                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Date de d\xe9but",
                                                        name: "meta.startDate",
                                                        type: "date",
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        dataTest: `start-date-input-${startDate}`,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                                                        error: errors.meta?.startDate
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Date de fin",
                                                        name: "meta.endDate",
                                                        type: "date",
                                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                        dataTest: `end-date-input-${endDate}`,
                                                        min: minEndDate,
                                                        required: true
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                                                        error: errors.meta?.endDate
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !dateRangeError && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dac6dc0cea4f2daf$export$8425047b6f53f78b), {
                                        children: [
                                            errors.workPeriods && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    colSpan: 8,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                                                        error: errors.workPeriods
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dac6dc0cea4f2daf$export$8425047b6f53f78b).Header, {
                                                right: (isoWeekDay)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c0588247d50e0fa8$export$503f97e1b40d97c7), {
                                                        size: "extra-small",
                                                        "data-test": `weekday-paste-action-${isoWeekDay}`,
                                                        disabled: clipboard.isEmpty || $dcd93683234494f9$export$da2ac25f073bcdf5(resource) || !$dcd93683234494f9$var$isClipboardDay(clipboard.value),
                                                        onClick: ()=>{
                                                            if (isoWeekDay === null) return;
                                                            if (clipboard.isEmpty || !$dcd93683234494f9$var$isClipboardDay(clipboard.value)) return;
                                                            const [start, end] = clipboard.value ?? [];
                                                            if (start === undefined && end === undefined) return;
                                                            const days = getWeekDays(isoWeekDay).filter((d)=>!d.metadata?.isDisabled);
                                                            setWorkPeriods((0, $cf0e3868e71e81cf$export$e2a72d0df5666864)(workPeriods, days, [
                                                                start,
                                                                end
                                                            ]));
                                                        }
                                                    })
                                            }),
                                            Object.entries(calendar).map(([yearNumber, weeks])=>Object.entries(weeks).map(([weekNumber, week])=>{
                                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $0bc0ef7c1b53552e$export$fca4f8121099df57), {
                                                        week: parseInt(weekNumber),
                                                        weekYear: parseInt(yearNumber),
                                                        calendarWeek: week,
                                                        startDate: startDate,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0bc0ef7c1b53552e$export$fca4f8121099df57).Header, {
                                                                week: parseInt(weekNumber),
                                                                weekYear: parseInt(yearNumber),
                                                                right: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3745c86609aa5090$export$4f2558dd25106ae2), {
                                                                            size: "extra-small",
                                                                            disabled: $dcd93683234494f9$export$da2ac25f073bcdf5(resource),
                                                                            "data-test": `week-copy-action`,
                                                                            onClick: ()=>{
                                                                                clipboard.copy((0, $cf0e3868e71e81cf$export$c63b0b134c3c38c6)(week));
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c0588247d50e0fa8$export$503f97e1b40d97c7), {
                                                                            size: "extra-small",
                                                                            "data-test": `week-paste-action`,
                                                                            disabled: clipboard.isEmpty || $dcd93683234494f9$export$da2ac25f073bcdf5(resource) || $dcd93683234494f9$var$isClipboardDay(clipboard.value) || week.some((d)=>d?.metadata?.isDisabled),
                                                                            onClick: ()=>{
                                                                                if (clipboard.isEmpty || !clipboard.value || $dcd93683234494f9$var$isClipboardDay(clipboard.value)) return;
                                                                                setWorkPeriods((0, $cf0e3868e71e81cf$export$d776eb73499cb2)(workPeriods, week, clipboard.value));
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                    textSize: 7,
                                                                    mt: 1,
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $68831b1f047ffe2c$export$6e0437d0f9940d1), {
                                                                        workPeriods: workPeriods,
                                                                        breakRule: currentClockingRule?.break,
                                                                        userId: user,
                                                                        period: `${parseInt(yearNumber)}-W${parseInt(weekNumber)}`,
                                                                        year: parseInt(yearNumber),
                                                                        week: parseInt(weekNumber)
                                                                    })
                                                                })
                                                            }),
                                                            week.map((day)=>{
                                                                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f34d443174db4caf$export$7a9a31a911eb9a20), {
                                                                    label: day?.isoDate ? getDay(day.isoDate)?.day : undefined,
                                                                    empty: !day?.isoDate,
                                                                    right: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b223c1ff107a4419$export$134dc3efcee9d6ac), {
                                                                        onCopy: ()=>{
                                                                            const payload = day ? (0, $cf0e3868e71e81cf$export$a6bf9e6b07f9f5b0)(day) : null;
                                                                            if (payload) clipboard.copy(payload);
                                                                        },
                                                                        onPaste: ()=>{
                                                                            if (!clipboard.value || !day?.isoDate || !$dcd93683234494f9$var$isClipboardDay(clipboard.value)) return;
                                                                            setWorkPeriods((0, $cf0e3868e71e81cf$export$8dc66215d230baa8)(workPeriods, day.isoDate, clipboard.value));
                                                                        },
                                                                        onRemove: ()=>{
                                                                            if (!day?.isoDate) return;
                                                                            setWorkPeriods((0, $cf0e3868e71e81cf$export$af94e4826200cf89)(workPeriods, day.isoDate));
                                                                        },
                                                                        copyDisabled: !day?.data?.start?.date || !day?.data?.end?.date || $dcd93683234494f9$export$da2ac25f073bcdf5(resource),
                                                                        pasteDisabled: clipboard.isEmpty || clipboard.isEqualTo([
                                                                            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(day?.data?.start?.date),
                                                                            (0, $74f17ceb9b5a08a5$export$4bfe88362359942c)(day?.data?.end?.date)
                                                                        ]) || $dcd93683234494f9$export$da2ac25f073bcdf5(resource) || !!day?.metadata?.isDisabled || !$dcd93683234494f9$var$isClipboardDay(clipboard.value),
                                                                        removeDisabled: $dcd93683234494f9$export$da2ac25f073bcdf5(resource) || !!day?.metadata?.isDisabled,
                                                                        removeDataTest: "remove-work-period-action"
                                                                    }),
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7ef0e1ac200e2c38$export$37cb960cdb8535a5), {
                                                                        //@ts-expect-error
                                                                        isoDate: day?.isoDate,
                                                                        workPeriods: workPeriods,
                                                                        jobTitle: jobTitle,
                                                                        initialWorkPeriods: initialWorkPeriods,
                                                                        resource: resource,
                                                                        setWorkPeriods: setWorkPeriods,
                                                                        errors: errors
                                                                    })
                                                                });
                                                            })
                                                        ]
                                                    }, yearNumber + '' + weekNumber);
                                                })),
                                            errors.workPeriods && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("tr", {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    colSpan: 8,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                                                        error: errors.workPeriods
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            });
                        }
                    })
            })
        })
    });
};
const $dcd93683234494f9$var$Clipboard = ({ children: children })=>{
    const clipboard = (0, $16df5e427bb274d8$export$b580fba9cc8d3a5)();
    return children(clipboard);
};
const $dcd93683234494f9$var$isClipboardDay = (clipboardValue)=>{
    if (clipboardValue && clipboardValue.length === 2) return true;
    return false;
};



var $2KSUA = parcelRequire("2KSUA");




parcelRequire("3ZYaX");


/**
 * Composant pour gérer un groupe de boutons radio
 * S'intègre avec Formik comme les autres champs
 */ const $94dd48ff55f5e1f0$var$RadioField = ({ field: field, form: form, label: label, help: help, options: options, name: name, value: value, onChange: onChange, disabled: disabled = false, ...rest })=>{
    // Utilise la valeur de Formik si disponible, sinon la prop value
    const currentValue = field?.value || value;
    const handleChange = (optionValue)=>{
        if (field) form.setFieldValue(field.name, optionValue);
        if (onChange) onChange(optionValue);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        help: help,
        error: form?.errors[field?.name],
        required: rest.required,
        disabled: disabled,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem'
            },
            children: options.map((option)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("label", {
                    style: {
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '0.5rem',
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        opacity: disabled ? 0.6 : 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("input", {
                            type: "radio",
                            name: name,
                            value: option.value,
                            checked: currentValue === option.value,
                            onChange: ()=>handleChange(option.value),
                            disabled: disabled || option.disabled,
                            style: {
                                marginTop: '0.25rem'
                            },
                            "data-test": `radio-${option.value}`
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "span",
                                    textWeight: "semibold",
                                    children: option.label
                                }),
                                option.description && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "div",
                                    textSize: "small",
                                    textColor: "grey",
                                    children: option.description
                                })
                            ]
                        })
                    ]
                }, option.value))
        })
    });
};
var $94dd48ff55f5e1f0$export$2e2bcd8739ae039 = $94dd48ff55f5e1f0$var$RadioField;








var $3ZYaX = parcelRequire("3ZYaX");













/** Type guard for pasted clipboard value (day slot). */ function $f59194ec5cac7347$var$isMissionScheduleDaySlot(v) {
    return v != null && typeof v.startHour === 'number' && typeof v.endHour === 'number';
}
/** Day labels (0 = Monday … 6 = Sunday). */ const $f59194ec5cac7347$var$DAY_LABELS = {
    0: 'Lundi',
    1: 'Mardi',
    2: 'Mercredi',
    3: 'Jeudi',
    4: 'Vendredi',
    5: 'Samedi',
    6: 'Dimanche'
};
const $f59194ec5cac7347$var$DAY_KEYS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6
];
/**
 * Displays total hours per week for a schedule template week pattern (with break rule applied).
 * When userId and referenceDate are provided, shows expected from contract and status icon (same as work-periods editor).
 */ const $f59194ec5cac7347$var$ScheduleTemplateWeekDuration = ({ weekPattern: weekPattern, breakRule: breakRule, userId: userId, referenceDate: referenceDate })=>{
    const total = (0, $dda2f26c3659cf93$export$5d71c5150f0e4651)(weekPattern, breakRule);
    const expected = (0, $979d61d174fb9293$export$8b5216453c9cb741)(userId, referenceDate);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f6a5ae756a86ced7$export$ccb9110fa312629f), {
        total: total,
        expected: expected
    });
};
function $f59194ec5cac7347$export$5379f5aa11e17eb() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = {};
    return {
        start: today,
        end: null,
        weekPatterns: [
            {
                days: days
            }
        ]
    };
}
/**
 * Table of week patterns with copy/paste per day cell.
 * Uses useClipboardContext<MissionScheduleDaySlot>; must be rendered inside ClipboardProvider.
 */ const $f59194ec5cac7347$var$ScheduleTemplateTable = ({ scheduleTemplate: scheduleTemplate, setDaySlot: setDaySlot, removeWeekPattern: removeWeekPattern, addWeekPattern: addWeekPattern, disabled: disabled, breakRule: breakRule, userId: userId })=>{
    const clipboard = (0, $16df5e427bb274d8$export$b580fba9cc8d3a5)();
    const referenceDate = scheduleTemplate.start ? new Date(scheduleTemplate.start) : undefined;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dac6dc0cea4f2daf$export$8425047b6f53f78b), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dac6dc0cea4f2daf$export$8425047b6f53f78b).Header, {
                        left: (wD)=>$f59194ec5cac7347$var$DAY_LABELS[wD === 0 ? 6 : wD - 1]
                    }),
                    scheduleTemplate.weekPatterns.map((pattern, patternIndex)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $0bc0ef7c1b53552e$export$fca4f8121099df57), {
                            week: patternIndex,
                            weekYear: 0,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0bc0ef7c1b53552e$export$fca4f8121099df57).Header, {
                                    week: patternIndex,
                                    weekYear: 0,
                                    left: `S${patternIndex}`,
                                    right: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textSize: 7,
                                            mt: 1,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($f59194ec5cac7347$var$ScheduleTemplateWeekDuration, {
                                                weekPattern: pattern,
                                                breakRule: breakRule,
                                                userId: userId,
                                                referenceDate: referenceDate
                                            })
                                        })
                                    }),
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        mt: 3,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            size: "small",
                                            color: "danger",
                                            onClick: ()=>removeWeekPattern(patternIndex),
                                            disabled: disabled || scheduleTemplate.weekPatterns.length <= 1,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                            })
                                        })
                                    })
                                }),
                                $f59194ec5cac7347$var$DAY_KEYS.map((day)=>{
                                    const slot = pattern.days[day];
                                    const startValue = slot && slot.startHour ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(slot.startHour) : '';
                                    const endValue = slot && slot.endHour ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(slot.endHour) : '';
                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f34d443174db4caf$export$7a9a31a911eb9a20), {
                                        right: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b223c1ff107a4419$export$134dc3efcee9d6ac), {
                                            onCopy: ()=>{
                                                if (slot) clipboard.copy(slot);
                                            },
                                            onPaste: ()=>{
                                                if (!clipboard.value || !$f59194ec5cac7347$var$isMissionScheduleDaySlot(clipboard.value)) return;
                                                setDaySlot(patternIndex, day, clipboard.value);
                                            },
                                            onRemove: slot ? ()=>setDaySlot(patternIndex, day, null) : undefined,
                                            copyDisabled: !slot || disabled || clipboard.isEqualTo(slot),
                                            pasteDisabled: clipboard.isEmpty || slot && clipboard.isEqualTo(slot) || !$f59194ec5cac7347$var$isMissionScheduleDaySlot(clipboard.value),
                                            removeDisabled: !slot || disabled,
                                            dataTestPrefix: `s${patternIndex}-d${day}`
                                        }),
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            display: "flex",
                                            flexDirection: "column",
                                            style: {
                                                gap: '0.5rem'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5ee0982b08b14659$export$2e2bcd8739ae039), {
                                                    value: startValue,
                                                    onChange: (value)=>{
                                                        const h = (0, $74f17ceb9b5a08a5$export$e7f31853fa46457)(value);
                                                        if (h !== undefined) setDaySlot(patternIndex, day, {
                                                            startHour: h,
                                                            endHour: slot?.endHour ?? undefined
                                                        });
                                                        else setDaySlot(patternIndex, day, null);
                                                    },
                                                    disabled: disabled,
                                                    dataTest: `schedule-template-s${patternIndex}-d${day}-start`
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5ee0982b08b14659$export$2e2bcd8739ae039), {
                                                    value: endValue,
                                                    onChange: (value)=>{
                                                        const h = (0, $74f17ceb9b5a08a5$export$e7f31853fa46457)(value);
                                                        if (h !== undefined) setDaySlot(patternIndex, day, {
                                                            startHour: slot?.startHour ?? undefined,
                                                            endHour: h
                                                        });
                                                        else setDaySlot(patternIndex, day, null);
                                                    },
                                                    disabled: disabled,
                                                    dataTest: `schedule-template-s${patternIndex}-d${day}-end`
                                                })
                                            ]
                                        })
                                    }, day);
                                })
                            ]
                        }, patternIndex))
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                size: "small",
                type: "button",
                onClick: addWeekPattern,
                disabled: disabled,
                className: "mt-3",
                children: "Ajouter une semaine (alternance, ex. quinzaine)"
            })
        ]
    });
};
const $f59194ec5cac7347$export$14568d5b74d8da27 = ({ scheduleTemplate: scheduleTemplate, setScheduleTemplate: setScheduleTemplate, errors: errors, disabled: disabled = false, breakRule: breakRule, userId: userId })=>{
    /** Patches top-level template fields (start, end, weekPatterns). */ const updateTemplate = (0, $3ZYaX.useCallback)((patch)=>{
        setScheduleTemplate({
            ...scheduleTemplate,
            ...patch
        });
    }, [
        scheduleTemplate,
        setScheduleTemplate
    ]);
    /** Updates a specific week pattern inside the template. */ const updateWeekPattern = (0, $3ZYaX.useCallback)((patternIndex, patch)=>{
        const patterns = [
            ...scheduleTemplate.weekPatterns
        ];
        const current = patterns[patternIndex];
        patterns[patternIndex] = {
            days: {},
            ...current,
            ...patch
        };
        updateTemplate({
            weekPatterns: patterns
        });
    }, [
        scheduleTemplate,
        updateTemplate
    ]);
    /** Sets or removes a day slot in a specific week pattern. */ const setDaySlot = (0, $3ZYaX.useCallback)((patternIndex, day, slot)=>{
        const pattern = scheduleTemplate.weekPatterns[patternIndex];
        if (!pattern) return;
        const days = {
            ...pattern.days
        };
        if (slot) days[day] = slot;
        else delete days[day];
        updateWeekPattern(patternIndex, {
            days: days
        });
    }, [
        scheduleTemplate,
        updateWeekPattern
    ]);
    /** Adds an empty week pattern to the template. */ const addWeekPattern = (0, $3ZYaX.useCallback)(()=>{
        updateTemplate({
            weekPatterns: [
                ...scheduleTemplate.weekPatterns,
                {
                    days: {}
                }
            ]
        });
    }, [
        scheduleTemplate,
        updateTemplate
    ]);
    /** Removes a week pattern by index (minimum 1 pattern must remain). */ const removeWeekPattern = (0, $3ZYaX.useCallback)((patternIndex)=>{
        if (scheduleTemplate.weekPatterns.length <= 1) return;
        updateTemplate({
            weekPatterns: scheduleTemplate.weekPatterns.filter((_, i)=>i !== patternIndex)
        });
    }, [
        scheduleTemplate,
        updateTemplate
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            errors && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$1834f1a788ceaae3), {
                    error: errors
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: "\xc0 partir du"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                    type: "date",
                                    value: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(scheduleTemplate.start),
                                    onChange: (e)=>{
                                        const v = e.target.value;
                                        if (!v) return;
                                        const d = new Date(v);
                                        d.setHours(0, 0, 0, 0);
                                        updateTemplate({
                                            start: d
                                        });
                                    },
                                    disabled: disabled,
                                    required: true,
                                    "data-test": "schedule-template-start"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("input", {
                                            type: "checkbox",
                                            checked: scheduleTemplate.end === null,
                                            onChange: (e)=>{
                                                updateTemplate({
                                                    end: e.target.checked ? null : new Date()
                                                });
                                            },
                                            disabled: disabled
                                        }),
                                        ' ',
                                        "Pas de date de fin (mission sans \xe9ch\xe9ance)"
                                    ]
                                }),
                                scheduleTemplate.end !== null && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                    type: "date",
                                    value: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(scheduleTemplate.end),
                                    onChange: (e)=>{
                                        const v = e.target.value;
                                        if (!v) return;
                                        const d = new Date(v);
                                        d.setHours(23, 59, 59, 999);
                                        updateTemplate({
                                            end: d
                                        });
                                    },
                                    disabled: disabled
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                renderAs: "h3",
                className: "mt-4 mb-3",
                children: "Masque \xe0 utiliser"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16df5e427bb274d8$export$278c12d137e20d5c), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($f59194ec5cac7347$var$ScheduleTemplateTable, {
                    scheduleTemplate: scheduleTemplate,
                    setDaySlot: setDaySlot,
                    removeWeekPattern: removeWeekPattern,
                    addWeekPattern: addWeekPattern,
                    disabled: disabled,
                    breakRule: breakRule,
                    userId: userId
                })
            })
        ]
    });
};


/**
 * Validates a single scheduleTemplate for recurring mode: start date required,
 * end > start if set, at least one week pattern, at least one day per pattern,
 * hours 0–24 and startHour < endHour.
 */ function $ea7328dad92e2051$var$validateScheduleTemplateForm(scheduleTemplate) {
    if (!scheduleTemplate) return 'Renseignez le planning.';
    if (!scheduleTemplate.start) return "Indiquez \xe0 partir de quelle date le planning s\u2019applique.";
    if (scheduleTemplate.end && (0, $379899354a78c3bb$export$2e2bcd8739ae039)(scheduleTemplate.start, scheduleTemplate.end)) return "La date de fin doit \xeatre apr\xe8s la date de d\xe9but.";
    if (!scheduleTemplate.weekPatterns?.length) return "Indiquez au moins un jour travaill\xe9.";
    for(let pi = 0; pi < scheduleTemplate.weekPatterns.length; pi++){
        const p = scheduleTemplate.weekPatterns[pi];
        if (!p) continue;
        const days = p.days ? Object.keys(p.days) : [];
        if (days.length === 0) return `Indiquez au moins un jour travaill\xe9.`;
        for (const dayKey of days){
            const slot = p.days[dayKey];
            if (!slot) continue;
            const { startHour: startHour, endHour: endHour } = slot;
            const hasStart = typeof startHour === 'number';
            const hasEnd = typeof endHour === 'number';
            if (hasStart !== hasEnd) return `Chaque jour travaill\xe9 doit avoir une heure de d\xe9but et une heure de fin.`;
            if (!hasStart) continue;
            const start = startHour;
            const end = endHour;
            if (start < 0 || start > 24 || end < 0 || end > 24) return "Les heures doivent \xeatre comprises entre 0 h et 24 h.";
            // Allow overnight schedules (e.g. 22h–6h) where startHour > endHour.
            // Only reject when start and end are exactly equal (zero-length slot).
            if (start === end) return "L\u2019heure de d\xe9but et l\u2019heure de fin ne peuvent pas \xeatre identiques.";
        }
    }
    return undefined;
}
const $ea7328dad92e2051$var$MissionForm = ({ mission: mission, readOnly: readOnly = false })=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const organizationQuery = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(currentOrganization._id, currentOrganization.type);
    const employerId = mission?.employer?._id.toString() || currentOrganization._id.toString();
    //Is new mission or mission edition
    const isMissionEditForm = Boolean(mission);
    const isNewMissionForm = !isMissionEditForm;
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)({
        employer: employerId
    }, {
        enabled: Boolean(employerId)
    });
    const servicesQuery = (0, $3d856666402e8eec$export$a870673e4b33fcfb)();
    const usersQuery = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        filter: JSON.stringify({
            associations: {
                $elemMatch: {
                    organization: currentOrganization._id,
                    status: [
                        'accepted',
                        'pending'
                    ]
                }
            }
        })
    });
    const missionNotEditable = Boolean(mission && !mission.__actions.canBeUpdated || readOnly);
    const missionEditable = !missionNotEditable;
    const createMutation = (0, $e409591b67738e56$export$a25726670bb41cb)();
    const updateMutation = (0, $e409591b67738e56$export$cac0b33e6f13c8ec)();
    const currentMutation = mission ? updateMutation : createMutation;
    const formWrapperBaseProps = isNewMissionForm ? $ea7328dad92e2051$var$formWrapperBaseCreateProps : $ea7328dad92e2051$var$formWrapperBaseUpdateProps;
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)(formWrapperBaseProps, currentMutation);
    let usersList;
    let servicesList;
    if (missionNotEditable) {
        usersList = mission?.user ? [
            mission.user
        ] : [];
        servicesList = mission?.service ? [
            mission.service
        ] : [];
    } else {
        usersList = usersQuery?.data || [];
        servicesList = servicesQuery?.data || [];
    }
    // start and end dates stored as ISO dates YYYY-mm-dd
    // we always display at least 3 days
    const now = new Date();
    const today = now;
    const todayISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(now);
    const sunday = (0, $4bb47b500c9001ee$export$2e2bcd8739ae039)(now);
    const end = (0, $46e6b7724aa17953$export$2e2bcd8739ae039)(sunday, today) <= 3 ? (0, $ffff430a208564ac$export$2e2bcd8739ae039)(sunday, 7) : sunday;
    const endISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(end);
    const startDateISO = mission?.start ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(mission.start)) : todayISO;
    const lastWorkPeriodStartDate = mission?.workPeriods[mission.workPeriods.length - 1]?.start.date;
    const endDateISO = lastWorkPeriodStartDate ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(lastWorkPeriodStartDate)) : endISO;
    if (!servicesQuery.isFetched || !jobTitlesQuery.isFetched || !usersQuery.isFetched) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
        ...formWrapperProps,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
            initialValues: {
                meta: {
                    startDate: startDateISO,
                    endDate: endDateISO,
                    users: usersList,
                    resource: mission
                },
                scheduleMode: !mission ? 'recurring' : mission?.scheduleTemplate?.weekPatterns?.length ? 'recurring' : 'fixed',
                user: mission?.user?._id || '',
                employer: mission?.employer?._id.toString() || currentOrganization._id.toString(),
                address: mission?.address ?? '',
                workPeriods: mission?.workPeriods.map((wP)=>({
                        ...wP,
                        start: {
                            date: new Date(wP.start.date)
                        },
                        end: {
                            date: new Date(wP.end.date)
                        }
                    })) ?? [],
                scheduleTemplate: mission?.scheduleTemplate ? {
                    start: new Date(mission.scheduleTemplate.start),
                    end: mission.scheduleTemplate.end ? new Date(mission.scheduleTemplate.end) : null,
                    weekPatterns: mission.scheduleTemplate.weekPatterns.map((p)=>({
                            days: {
                                ...p.days
                            }
                        }))
                } : (0, $f59194ec5cac7347$export$5379f5aa11e17eb)(),
                isValidated: false,
                service: mission?.service?._id || '',
                jobTitle: mission?.jobTitle?._id || '',
                lastWeek: '',
                tags: mission?.tags || []
            },
            enableReinitialize: true,
            validate: (values)=>{
                const errors = {};
                if (!values.user) errors['user'] = 'Champ requis';
                if (!values.service) errors['service'] = 'Champ requis';
                if (!values.employer) errors['employer'] = 'Champ requis';
                if (!values.jobTitle) errors['jobTitle'] = 'Champ requis';
                if (!values.address) errors.address = 'Champ requis';
                const scheduleMode = values.scheduleMode ?? 'fixed';
                const isRecurring = scheduleMode === 'recurring';
                if (isRecurring) {
                    const scheduleErr = $ea7328dad92e2051$var$validateScheduleTemplateForm(values.scheduleTemplate);
                    if (scheduleErr) errors['scheduleTemplate'] = scheduleErr;
                } else // Mode dates fixes: require workPeriods and meta dates
                if (!values.workPeriods || values.workPeriods.length === 0) errors['workPeriods'] = "Pas d'horaire de mission";
                const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.meta.startDate);
                const endDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.meta.endDate);
                const worker = usersQuery.data?.find((u)=>u._id === values.user);
                // Dates and workPeriods validation only for fixed mode
                if (!isRecurring) {
                    if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(startDate, endDate)) {
                        if (errors.meta === undefined) errors.meta = {};
                        errors.meta['startDate'] = "La date de d\xe9but doit \xeatre avant la date de fin";
                    }
                    if (Math.abs((0, $46e6b7724aa17953$export$2e2bcd8739ae039)(startDate, endDate)) > 365) {
                        if (errors.meta === undefined) errors.meta = {};
                        errors.meta['endDate'] = 'Une mission doit durer maximum 1 an';
                    }
                }
                if (!isRecurring && values.workPeriods?.length) for(let index = 0; index <= values.workPeriods.length; index++){
                    const workPeriod = values.workPeriods[index];
                    const nextWorkPeriod = values.workPeriods[index + 1];
                    const firstWorkPeriodStartDate = workPeriod && workPeriod.start ? workPeriod.start.date : undefined;
                    const firstWorkPeriodEndDate = workPeriod && workPeriod.end ? workPeriod.end.date : undefined;
                    const nextWorkPeriodStartDate = nextWorkPeriod && nextWorkPeriod.start ? nextWorkPeriod.start.date : undefined;
                    // If the end of a workPeriod overlaps the start of the next workPeriod
                    if (firstWorkPeriodStartDate && firstWorkPeriodEndDate && nextWorkPeriodStartDate) {
                        if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(nextWorkPeriodStartDate, firstWorkPeriodEndDate) || (0, $2KSUA.isEqual)(firstWorkPeriodEndDate, nextWorkPeriodStartDate)) {
                            const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(firstWorkPeriodStartDate);
                            const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(firstWorkPeriodStartDate);
                            const error = `${niceDate} : L'heure de fin ne peut \xeatre plus grande ou \xe9gale \xe0 l'heure du d\xe9but du jour suivant`;
                            errors['workPeriods'] = error;
                            (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                        }
                    }
                    // If a workPeriod has no start date set
                    if (firstWorkPeriodStartDate === undefined && firstWorkPeriodEndDate) {
                        const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                        const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date);
                        const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
                        const error = `${niceDate} : L'heure de d\xe9but n'est pas pr\xe9cis\xe9e`;
                        errors['workPeriods'] = error;
                        (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                    }
                    // If a workPeriod has no end date set
                    if (firstWorkPeriodStartDate && firstWorkPeriodEndDate === undefined) {
                        const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                        const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date);
                        const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
                        const error = `${niceDate} : L'heure de fin n'est pas pr\xe9cis\xe9e`;
                        errors['workPeriods'] = error;
                        (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                    }
                    // Theoretical range: end after start (date-aware), duration <= 24h
                    const rangeErrors = workPeriod && (0, $6b601cb106cd3f71$export$3ef1799cbda7de2c)(workPeriod?.start?.date, workPeriod?.end?.date);
                    if (rangeErrors && (rangeErrors.startDate || rangeErrors.endDate)) {
                        const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                        const niceDate = date ? (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date) : '';
                        const isoDate = date ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date) : '';
                        const error = `${niceDate} : ${rangeErrors.startDate ?? rangeErrors.endDate}`;
                        errors['workPeriods'] = error;
                        if (isoDate) (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                    }
                    const workerIsAvailable = workPeriod?.start?.date && workPeriod?.end?.date && worker && (0, $25ffbf4bca475b04$export$5935d3a9b1050649)(new Date(workPeriod.start.date), worker, currentOrganization);
                    if (!mission && firstWorkPeriodStartDate && worker && workPeriod?.start?.date && workPeriod?.end?.date && !workerIsAvailable) {
                        errors['workPeriods'] = (0, $25ffbf4bca475b04$export$991c4a8cc675d611)(worker, currentOrganization);
                        const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(firstWorkPeriodStartDate);
                        if (firstWorkPeriodStartDate) (errors[`workPeriod-${isoDate}`] ??= []).push((0, $25ffbf4bca475b04$export$991c4a8cc675d611)(worker, currentOrganization));
                    }
                }
                return errors;
            },
            onSubmit: async (values)=>{
                if (missionNotEditable) return;
                if (mission) {
                    const { service: service, address: address } = values;
                    const { startDate: startDate, endDate: endDate } = values.meta;
                    const missionStartDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(startDate);
                    const missionEndDate = (0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(endDate), 1);
                    const workPeriods = (0, $2KSUA.cloneDeep)(values.workPeriods).filter((wP)=>(0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(wP.start.date, {
                            start: missionStartDate,
                            end: missionEndDate
                        })).map((wP)=>({
                            start: {
                                date: wP.start.date
                            },
                            end: {
                                date: wP.end.date
                            }
                        }));
                    updateMutation.mutate({
                        _id: mission._id,
                        service: service,
                        address: address,
                        workPeriods: workPeriods
                    });
                    return;
                }
                // Create: send either workPeriods (fixed) or scheduleTemplate (recurring)
                const { service: service, jobTitle: jobTitle, user: user, address: address, tags: tags } = values;
                const isRecurring = values.scheduleMode === 'recurring';
                if (isRecurring) createMutation.mutate({
                    user: user,
                    jobTitle: jobTitle,
                    service: service,
                    address: address,
                    tags: tags?.map((tag)=>tag._id),
                    scheduleTemplate: values.scheduleTemplate
                });
                else {
                    const { startDate: startDate, endDate: endDate } = values.meta;
                    const missionStartDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(startDate);
                    const missionEndDate = (0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(endDate), 1);
                    const workPeriods = (0, $2KSUA.cloneDeep)(values.workPeriods).filter((wP)=>(0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(wP.start.date, {
                            start: missionStartDate,
                            end: missionEndDate
                        })).map((wP)=>({
                            start: {
                                date: wP.start.date
                            },
                            end: {
                                date: wP.end.date
                            }
                        }));
                    createMutation.mutate({
                        user: user,
                        jobTitle: jobTitle,
                        service: service,
                        workPeriods: workPeriods,
                        address: address,
                        tags: tags?.map((tag)=>tag._id)
                    });
                }
            },
            children: (props)=>{
                const selectedUser = usersList.find((u)=>u._id.toString() === props.values.user);
                const selectedJobTitle = jobTitlesQuery.data?.find((jT)=>props.values.jobTitle.toString() === jT._id.toString());
                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 6,
                            mt: 5,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: [
                                        "Informations du ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        !mission && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                                    name: "user",
                                                    component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                    required: true,
                                                    fullwidth: true,
                                                    onlySelect: true,
                                                    items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(usersList, {
                                                        labelBuilder: (user)=>(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
                                                        renderLabel: (user)=>$ea7328dad92e2051$export$bb2085cd9e63676d({
                                                                user: user,
                                                                organization: currentOrganization
                                                            })
                                                    }),
                                                    selectDefaultChooseOptionLabel: "Choisir l'int\xe9rimaire",
                                                    disabled: missionNotEditable || isMissionEditForm
                                                }),
                                                props.values.user && selectedUser && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header.Title, {
                                                                children: "Travailleur s\xe9lectionn\xe9"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ea7328dad92e2051$export$bb2085cd9e63676d, {
                                                                user: selectedUser,
                                                                organization: currentOrganization
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                    label: "M\xe9tier",
                                                    name: "jobTitle",
                                                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                    required: true,
                                                    fullwidth: true,
                                                    options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(jobTitlesQuery.data || []),
                                                    selectDefaultChooseOptionLabel: props.values.employer ? "Choisir le M\xe9tier" : "S\xe9lectionnez d'abord un Employeur",
                                                    disabled: missionNotEditable || !props.values.employer || isMissionEditForm
                                                }),
                                                props.values.jobTitle && selectedJobTitle?.complementaryInformations ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header.Title, {
                                                                children: "Ces infos seront transmises"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                            children: selectedJobTitle?.complementaryInformations
                                                        })
                                                    ]
                                                }) : undefined
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Affectation",
                                                name: "service",
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                required: true,
                                                items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(servicesList),
                                                disabled: missionNotEditable || !props.values.employer,
                                                onlySelect: true,
                                                multiple: false
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 5,
                            mb: 5,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: "Cat\xe9gories"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fc203fc1bcc1621$export$2e2bcd8739ae039), {
                                    tags: props.values.tags || [],
                                    formProps: {
                                        onSubmit: (params)=>{
                                            props.setFieldValue('tags', params.tags);
                                        },
                                        onCancel: ()=>{},
                                        dateRange: false
                                    },
                                    onTagDelete: (tagId)=>{
                                        props.setFieldValue('tags', props.values.tags?.filter((tag)=>tag._id !== tagId));
                                    },
                                    isEditable: isNewMissionForm
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 5,
                            mb: 5,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    renderAs: "h2",
                                    size: 4,
                                    children: "Horaire"
                                }),
                                isNewMissionForm && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 5,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: "scheduleMode",
                                                label: "Type d'horaire",
                                                component: (0, $94dd48ff55f5e1f0$export$2e2bcd8739ae039),
                                                options: [
                                                    {
                                                        value: 'recurring',
                                                        label: "R\xe9p\xe9ter un masque semaine par semaine (r\xe9currence automatique)"
                                                    },
                                                    {
                                                        value: 'fixed',
                                                        label: 'Saisir les horaires manuellement jour par jour (maximum 1 an)'
                                                    }
                                                ],
                                                disabled: missionNotEditable
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "hr",
                                            mb: 5
                                        }),
                                        props.values.scheduleMode === 'recurring' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f59194ec5cac7347$export$14568d5b74d8da27), {
                                            scheduleTemplate: props.values.scheduleTemplate,
                                            setScheduleTemplate: (v)=>props.setFieldValue('scheduleTemplate', v),
                                            errors: typeof props.errors.scheduleTemplate === 'string' ? props.errors.scheduleTemplate : undefined,
                                            disabled: missionNotEditable,
                                            breakRule: selectedJobTitle?.clockingRule?.break,
                                            userId: props.values.user
                                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dcd93683234494f9$export$1c4614b036aef1a), {
                                            workPeriods: props.values.workPeriods,
                                            jobTitle: props.values.jobTitle,
                                            initialWorkPeriods: props.initialValues.workPeriods,
                                            resource: mission,
                                            user: props.values.user,
                                            setWorkPeriods: (wPs)=>props.setFieldValue('workPeriods', wPs),
                                            errors: props.errors,
                                            startDate: props.values.meta.startDate,
                                            endDate: props.values.meta.endDate
                                        })
                                    ]
                                }),
                                isMissionEditForm && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: mission?.scheduleTemplate?.start ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                        className: "mt-5",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                size: 5,
                                                renderAs: "h3",
                                                className: "mb-3",
                                                children: "Semaine(s) type (lecture seule)"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f59194ec5cac7347$export$14568d5b74d8da27), {
                                                scheduleTemplate: props.values.scheduleTemplate,
                                                setScheduleTemplate: ()=>{},
                                                disabled: true,
                                                breakRule: selectedJobTitle?.clockingRule?.break,
                                                userId: props.values.user
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dcd93683234494f9$export$1c4614b036aef1a), {
                                        workPeriods: props.values.workPeriods,
                                        jobTitle: props.values.jobTitle,
                                        initialWorkPeriods: props.initialValues.workPeriods,
                                        resource: mission,
                                        user: props.values.user,
                                        setWorkPeriods: (wPs)=>props.setFieldValue('workPeriods', wPs),
                                        errors: props.errors,
                                        startDate: props.values.meta.startDate,
                                        endDate: props.values.meta.endDate
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 5,
                            mb: 5,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: "address",
                                label: "Adresse de la prestation",
                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                required: true,
                                items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(organizationQuery.data?.addresses ?? []),
                                disabled: missionNotEditable || !props.values.employer
                            })
                        }),
                        mission?.complementaryInformations ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                mt: 5,
                                mb: 5,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        renderAs: "h2",
                                        size: 4,
                                        children: "Informations compl\xe9mentaires"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        name: "complementaryInformations",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        disabled: mission
                                    })
                                ]
                            })
                        }) : undefined,
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Left, {
                                    children: (isNewMissionForm || missionEditable) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                type: "submit",
                                                color: "primary",
                                                title: "submit",
                                                "data-test": "submit-mission-form",
                                                mutation: currentMutation,
                                                children: mission ? "Mettre \xe0 jour les donn\xe9es de la Mission" : "Cr\xe9er une Nouvelle Mission"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                mutation: currentMutation
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dc5e1e1bff7b8284$export$2e2bcd8739ae039).Right, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {})
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
var $ea7328dad92e2051$export$2e2bcd8739ae039 = $ea7328dad92e2051$var$MissionForm;
const $ea7328dad92e2051$var$formWrapperBaseCreateProps = {
    loadingProps: {
        body: "Cr\xe9ation de la Mission..."
    },
    successProps: {
        title: "Mission cr\xe9\xe9e",
        body: {
            actions: [
                {
                    label: 'Liste des Missions',
                    to: '/missions'
                },
                {
                    label: "Cr\xe9er une Nouvelle Mission Interne",
                    to: '/missions'
                }
            ]
        }
    }
};
const $ea7328dad92e2051$var$formWrapperBaseUpdateProps = {
    loadingProps: {
        body: "Mise \xe0 jour de la Mission..."
    },
    successProps: {
        title: "Mission mise \xe0 jour",
        body: {
            actions: [
                {
                    label: 'Liste des Missions',
                    to: '/missions'
                },
                {
                    label: 'Voir la Mission'
                }
            ]
        }
    }
};
const $ea7328dad92e2051$export$bb2085cd9e63676d = ({ user: user, organization: organization })=>{
    const userLabel = (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user);
    const availability = 'availability' in user ? user.availability : (0, $25ffbf4bca475b04$export$f5327d6ba0b1c3bb)(user, organization);
    const internalComment = 'availability' in user ? user.internalComment : (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, organization)?.internalComment;
    const internalInformation = 'availability' in user ? user.internalInformation : (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, organization)?.internalInformation;
    const absentLabel = availability && (!availability.absentTo || (0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(availability.absentTo), new Date())) && (0, $25ffbf4bca475b04$export$12c731bd2c9aa69b)(availability, user, true);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            userLabel,
            absentLabel && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "small",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                children: "Absent:"
                            }),
                            " ",
                            absentLabel.toLowerCase()
                        ]
                    })
                ]
            }),
            internalComment && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "small",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                            children: "Infos:"
                        }),
                        " ",
                        (0, $2KSUA.truncate)(internalComment, {
                            length: 70
                        })
                    ]
                })
            }),
            internalInformation && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "small",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                            children: "Commentaires:"
                        }),
                        " ",
                        (0, $2KSUA.truncate)(internalInformation, {
                            length: 70
                        })
                    ]
                })
            })
        ]
    });
};






const $4f6da5f31d5ddc59$export$2c8fdbe9d2375d3b = (post, workersRequest)=>{
    return post.jobTitle.interimAgencySettings.find((setting)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(setting.interimAgency, workersRequest.interimAgency));
};
const $4f6da5f31d5ddc59$export$ce51b0cf36791b5d = (post, workersRequest)=>{
    const interimAgencySettings = $4f6da5f31d5ddc59$export$2c8fdbe9d2375d3b(post, workersRequest);
    return !interimAgencySettings?.hourlyRateSettings.useSmic;
};
const $4f6da5f31d5ddc59$export$cbaec7e6b193276c = (worker, availableWorkers)=>{
    return availableWorkers.some((availableWorker)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(availableWorker, worker));
};



const $d6a0365fc379f506$var$AssignWorkerForm = ({ workersRequest: workersRequest, postId: postId })=>{
    const { currentUserRole: currentUserRole, currentUser: currentUser, currentOrganization: currentOrganization } = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session);
    const availableWorkers = (0, $e607e015ac40917d$export$c8b4a8759ad58195)({
        workersRequestId: workersRequest._id
    }, {
        enabled: currentUserRole === 'interimAgencyMember'
    });
    const assignWorkerToPostMutation = (0, $b8c6247768bd4102$export$19edf282e3e6d35b)();
    const post = workersRequest.posts.find((post)=>post._id === postId);
    if (!currentUser) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    if (!post) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: "Something went wrong"
    });
    const interimAgencySettings = (0, $4f6da5f31d5ddc59$export$2c8fdbe9d2375d3b)(post, workersRequest);
    const mustAddCustomHourlyCost = !interimAgencySettings?.hourlyRateSettings.useSmic;
    const smicQuery = (0, $b5b5022de31b86b5$export$9c9998b370b83a7d)(workersRequest.missionsStart, {
        enabled: mustAddCustomHourlyCost
    });
    const smicValue = smicQuery.data?.value;
    const minHourlyCost = smicValue && smicValue > (interimAgencySettings?.hourlyRateSettings.min ?? 0) ? smicValue : interimAgencySettings?.hourlyRateSettings.min;
    const maxHourlyCost = smicValue && smicValue > (interimAgencySettings?.hourlyRateSettings.max ?? 0) ? smicValue : interimAgencySettings?.hourlyRateSettings.max;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            userId: '',
            postId: postId,
            workersRequestId: workersRequest._id.toString(),
            updatedBy: currentUser._id.toString(),
            hourlyCost: undefined
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.userId) errors.userId = 'Champ requis';
            else {
                const worker = availableWorkers.data?.find((w)=>w._id === values.userId);
                const workerIsAvailable = worker && (0, $25ffbf4bca475b04$export$38c9d1ec7c4cfeb)(new Date(workersRequest.missionsStart), new Date(workersRequest.missionsEnd), worker.availability);
                if (!workerIsAvailable && worker && currentOrganization) errors.userId = (0, $25ffbf4bca475b04$export$12c731bd2c9aa69b)(worker.availability, worker);
            }
            // Validation du coût horaire si nécessaire
            if (mustAddCustomHourlyCost) {
                if (!values.hourlyCost) errors.hourlyCost = "Le co\xfbt horaire est requis";
                else {
                    if (minHourlyCost != null && values.hourlyCost < minHourlyCost) errors.hourlyCost = `Le co\xfbt horaire doit \xeatre sup\xe9rieur ou \xe9gal \xe0 ${minHourlyCost}\u{20AC}`;
                    else if (maxHourlyCost != null && values.hourlyCost > maxHourlyCost) errors.hourlyCost = `Le co\xfbt horaire doit \xeatre inf\xe9rieur ou \xe9gal \xe0 ${maxHourlyCost}\u{20AC}`;
                }
            }
            return errors;
        },
        onSubmit: (values)=>{
            return assignWorkerToPostMutation.mutate(values);
        },
        children: (props)=>{
            const selectedWorker = availableWorkers.data?.find((w)=>w._id.toString() === props.values.userId);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    availableWorkers.data && availableWorkers.data[0] ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: "userId",
                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                autoComplete: "off",
                                required: true,
                                onlySelect: true,
                                placeholder: "Rechercher",
                                items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(availableWorkers.data || [], {
                                    labelBuilder: (user)=>(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
                                    renderLabel: (user)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e40d2297f3afab1f$export$2e2bcd8739ae039), {
                                            user: user,
                                            post: post,
                                            workersRequest: workersRequest
                                        }),
                                    sortBy: (item)=>typeof item.renderedLabel === 'string',
                                    disabled: (user)=>{
                                        const employerRelation = user.employerRelations.find((relation)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(relation.employer, workersRequest.employer));
                                        return Boolean(employerRelation?.collaboration?.isInactive);
                                    }
                                }),
                                disabled: !availableWorkers.data || !availableWorkers.data[0] || !workersRequest.__actions.missionsCanBeCreated,
                                mb: 0
                            }),
                            mustAddCustomHourlyCost && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: "hourlyCost",
                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                label: "Co\xfbt horaire",
                                type: "number",
                                placeholder: "Co\xfbt horaire",
                                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        "L'EU \xe0 indiqu\xe9 que le co\xfbt horaire doit \xeatre sp\xe9cifi\xe9 entre",
                                        ' ',
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("strong", {
                                            children: [
                                                minHourlyCost,
                                                "\u20AC"
                                            ]
                                        }),
                                        " et ",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("strong", {
                                            children: [
                                                maxHourlyCost,
                                                "\u20AC"
                                            ]
                                        })
                                    ]
                                }),
                                required: true,
                                min: minHourlyCost,
                                max: maxHourlyCost,
                                step: 0.01
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        italic: true,
                        backgroundColor: "light",
                        textColor: "grey",
                        py: 2,
                        px: 5,
                        style: {
                            borderRadius: 4
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: [
                                    "Aucun ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                    " disponible"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: [
                                    "Aucun ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                                    " assign\xe9"
                                ]
                            })
                        ]
                    }),
                    props.values.userId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            currentOrganization && selectedWorker && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ea7328dad92e2051$export$bb2085cd9e63676d), {
                                        user: selectedWorker,
                                        organization: currentOrganization
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                mutation: assignWorkerToPostMutation,
                                type: "submit",
                                "data-test": "assign-worker-submit-btn",
                                disabled: assignWorkerToPostMutation.isLoading,
                                children: "Assigner"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var $d6a0365fc379f506$export$2e2bcd8739ae039 = $d6a0365fc379f506$var$AssignWorkerForm;





parcelRequire("3ZYaX");



const $9fe602c577e1bbf1$var$WorkersRequestPostIsOpened = ({ post: post, ...rest })=>{
    if (!post) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (post.isReplaceable === false) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        "data-test": "workers-request-post-is-opened",
        iconColor: "warning",
        text: "Demande en cours",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$be5191e773a73beb), {}),
        ...rest
    });
};
const $9fe602c577e1bbf1$var$WorkersRequestPostIsClosed = ({ post: post, ...rest })=>{
    if (!post) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (post.isReplaceable === true) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
        "data-test": "workers-request-post-is-closed",
        iconColor: "primary",
        text: "Poste ferm\xe9",
        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$b4449344c7a79712), {}),
        ...rest
    });
};
const $9fe602c577e1bbf1$var$WorkersRequestPostMessages = (props)=>{
    if (!props.post) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        display: "flex",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($9fe602c577e1bbf1$var$WorkersRequestPostIsOpened, {
                ...props
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($9fe602c577e1bbf1$var$WorkersRequestPostIsClosed, {
                ...props
            })
        ]
    });
};
var $9fe602c577e1bbf1$export$2e2bcd8739ae039 = $9fe602c577e1bbf1$var$WorkersRequestPostMessages;




parcelRequire("3ZYaX");


const $88148a7b669f8e32$var$allRecourseCasesReasons = (0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039).workersRequests.recourseCases.reasons;
const $88148a7b669f8e32$export$3b9a5a62809de709 = ({ recourseCase: recourseCase })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: [
            $88148a7b669f8e32$var$allRecourseCasesReasons[recourseCase.reason],
            " "
        ]
    });
};
const $88148a7b669f8e32$export$8695e30e344144a9 = ({ recourseCase: recourseCase })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: [
            recourseCase.justification,
            " "
        ]
    });
};





var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");


const $b66f454d70681184$var$WorkersRequestPostDesiredWorker = ({ workersRequest: workersRequest, worker: worker, availableWorkers: availableWorkers, onClick: onClick, isAvailable: isAvailable })=>{
    const isAlreadyAssigned = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return workersRequest.posts.find((post)=>!post.isReplaceable && post.missions[post.missions.length - 1]?.user._id === worker._id);
    }, [
        workersRequest,
        worker
    ]);
    const tooltipText = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (isAlreadyAssigned) return "D\xe9j\xe0 assign\xe9 \xe0 la demande";
        else if (isAvailable) return 'Disponible';
        else if (availableWorkers) return 'Non disponible';
        return;
    }, [
        isAlreadyAssigned,
        isAvailable
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: isAvailable && onClick ? 'a' : 'span',
        onClick: ()=>isAvailable && onClick?.(worker),
        "data-tooltip": tooltipText,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
            user: worker
        })
    });
};
var $b66f454d70681184$export$2e2bcd8739ae039 = $b66f454d70681184$var$WorkersRequestPostDesiredWorker;





const $be7c1b4386312981$var$MAX_WORKERS_WITH_MISSION_DISPLAYED = 3;
/**
 * Component that displays suggested workers for a post
 * Shows the list of desired workers with assignment functionality for interim agency members
 */ const $be7c1b4386312981$var$PostSuggestions = ({ post: post, workersRequest: workersRequest, availableWorkers: availableWorkers, workersWithMissionCorrespondingToPost: workersWithMissionCorrespondingToPost })=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const assignWorkerToPostMutation = (0, $b8c6247768bd4102$export$19edf282e3e6d35b)();
    // State to manage expanded view for workers with mission correspondence
    const [showAllWorkersWithMission, setShowAllWorkersWithMission] = (0, $3ZYaX.useState)(false);
    const availableAndDesiredWorkers = availableWorkers?.filter((worker)=>post.desiredWorkers.some((desiredWorker)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(desiredWorker, worker))) || [];
    // Only show suggestions if there are desired workers and no active mission
    if (!post.desiredWorkers[0] && !workersWithMissionCorrespondingToPost?.length) return null;
    // Limit workers display to 8 initially
    const displayedWorkersWithMission = showAllWorkersWithMission ? workersWithMissionCorrespondingToPost : workersWithMissionCorrespondingToPost?.slice(0, $be7c1b4386312981$var$MAX_WORKERS_WITH_MISSION_DISPLAYED);
    const remainingWorkersCount = (workersWithMissionCorrespondingToPost?.length || 0) - $be7c1b4386312981$var$MAX_WORKERS_WITH_MISSION_DISPLAYED;
    const displayDesiredWorkers = Boolean(availableAndDesiredWorkers.length || !workersWithMissionCorrespondingToPost?.length);
    const displayWorkersWithMission = Boolean(workersWithMissionCorrespondingToPost?.length);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        textSize: 7,
        textAlign: "right",
        children: [
            displayDesiredWorkers && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textWeight: "bold",
                        mr: 1,
                        children: "Suggestions de l'EU :"
                    }),
                    availableAndDesiredWorkers.map((worker)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                            ml: 1,
                            mb: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b66f454d70681184$export$2e2bcd8739ae039), {
                                worker: worker,
                                workersRequest: workersRequest,
                                post: post,
                                isAvailable: availableAndDesiredWorkers.some((availableWorker)=>availableWorker._id === worker._id),
                                availableWorkers: currentUserRole === 'interimAgencyMember' ? availableWorkers || [] : undefined,
                                onClick: currentUserRole === 'interimAgencyMember' ? ()=>assignWorkerToPostMutation.mutate({
                                        workersRequestId: workersRequest._id,
                                        postId: post._id,
                                        userId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(worker)
                                    }) : undefined
                            })
                        }, (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(worker)))
                ]
            }),
            displayWorkersWithMission && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                ml: 1,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        textWeight: "bold",
                        mr: 1,
                        children: [
                            "Int\xe9rimaires ayant eu une mission correspondante au cours des 2 derniers mois",
                            ' ',
                            availableAndDesiredWorkers.length ? "(non sugg\xe9r\xe9s par l\u2019UE)" : '',
                            ":"
                        ]
                    }),
                    displayedWorkersWithMission?.map((worker)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                            ml: 1,
                            mb: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b66f454d70681184$export$2e2bcd8739ae039), {
                                worker: worker,
                                workersRequest: workersRequest,
                                post: post,
                                isAvailable: true,
                                onClick: ()=>{
                                    assignWorkerToPostMutation.mutate({
                                        workersRequestId: workersRequest._id,
                                        postId: post._id,
                                        userId: worker._id
                                    });
                                }
                            })
                        }, worker._id)),
                    remainingWorkersCount > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
                        ml: 1,
                        style: {
                            cursor: 'pointer'
                        },
                        textColor: "link",
                        onClick: ()=>setShowAllWorkersWithMission(!showAllWorkersWithMission),
                        children: showAllWorkersWithMission ? 'Voir moins' : `Voir plus (${workersWithMissionCorrespondingToPost?.length || 0})...`
                    })
                ]
            })
        ]
    });
};
var $be7c1b4386312981$export$2e2bcd8739ae039 = $be7c1b4386312981$var$PostSuggestions;




parcelRequire("3ZYaX");
const $c5025698526f6ad2$var$WorkerLaborCostCoefficientKindLabel = ({ laborCostCoefficientKind: laborCostCoefficientKind })=>{
    if (laborCostCoefficientKind === 'delegation') return "D\xe9l\xe9gation";
    return 'Gestion';
};
var $c5025698526f6ad2$export$2e2bcd8739ae039 = $c5025698526f6ad2$var$WorkerLaborCostCoefficientKindLabel;



var $3ZYaX = parcelRequire("3ZYaX");
const $1ee55a4f2a82deaf$export$2271e07b17a755d3 = ({ children: children })=>{
    const [isFirstClick, setIsFirstClick] = (0, $3ZYaX.useState)(true);
    if (isFirstClick) return /*#__PURE__*/ (0, $3ZYaX.cloneElement)(children, {
        onClick: ()=>setIsFirstClick(false)
    });
    return /*#__PURE__*/ (0, $3ZYaX.cloneElement)(children, {
        color: 'danger',
        outlined: false,
        'data-tooltip': "Cliquez \xe0 nouveau pour confirmer l'action"
    });
};



const $b129d7bacb3cfb1b$var$WorkersRequestPostListItem = ({ post: post, workersRequest: workersRequest, count: count, suggestions: suggestions })=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const postUpdateMutation = (0, $b8c6247768bd4102$export$86ce95a609069de6)();
    const workersWithMissionCorrespondingToPost = suggestions.workers.filter((worker)=>worker.missionCorrespondingJobTitleIds.includes(post.jobTitle._id));
    const activeMission = post?.missions.find((mission)=>!mission?.isCancelled && !mission?.isAbandoned);
    const showPostCloseOpenAction = currentUserRole === 'interimAgencyMember' && post.isReplaceable === true || currentUserRole === 'employerMember' && post.isReplaceable === false;
    const postMissions = [
        ...post?.missions || []
    ];
    if (!activeMission) postMissions.push(undefined);
    const baseHourlyCost = activeMission?.costs.baseHourlyCost;
    const officialHourlyCost = activeMission?.costs.officialHourlyCost;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
        mb: 5,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
            pb: 3,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 3,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                    size: 5,
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            children: [
                                                "#",
                                                count?.current,
                                                " ",
                                                post.jobTitle.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            ml: 2,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fc203fc1bcc1621$export$2e2bcd8739ae039), {
                                                tags: post.tags || [],
                                                isEditable: false,
                                                hideEmptyMessage: true,
                                                size: "small",
                                                formProps: {
                                                    onSubmit: ()=>{},
                                                    onCancel: ()=>{},
                                                    dateRange: false
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9fe602c577e1bbf1$export$2e2bcd8739ae039), {
                                    post: post,
                                    type: "tag"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            textSize: 7,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    py: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 1,
                                            textWeight: "bold",
                                            children: "Description de la Demande"
                                        }),
                                        post.description || 'N/A'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    py: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 1,
                                            textWeight: "bold",
                                            children: "Informations compl\xe9mentaires pour l'Int\xe9rimaire"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                            children: [
                                                post.jobTitle.complementaryInformations ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: post.jobTitle.complementaryInformations
                                                }) : undefined,
                                                workersRequest.missionData.complementaryInformations ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: workersRequest.missionData.complementaryInformations
                                                }) : undefined,
                                                !post.jobTitle.complementaryInformations && !workersRequest.missionData.complementaryInformations && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: "N/A"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                activeMission && activeMission.costs.interimAgencyCostCoefficient && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    py: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 1,
                                            textWeight: "bold",
                                            children: "Co\xfbt horaire de base"
                                        }),
                                        baseHourlyCost ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            children: [
                                                baseHourlyCost,
                                                " \u20AC/h"
                                            ]
                                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            children: [
                                                officialHourlyCost,
                                                " \u20AC/h",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    renderAs: "small",
                                                    children: " (SMIC)"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    py: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            mb: 1,
                                            textWeight: "bold",
                                            children: "Cas de recours et justification"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $88148a7b669f8e32$export$3b9a5a62809de709), {
                                            recourseCase: post.recourseCase
                                        }),
                                        " (",
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $88148a7b669f8e32$export$8695e30e344144a9), {
                                            recourseCase: post.recourseCase
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                postMissions.map((mission, index)=>{
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: index === postMissions.length - 1 ? undefined : 3,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($b129d7bacb3cfb1b$var$PostMission, {
                            post: post,
                            mission: mission,
                            workersRequest: workersRequest
                        }, mission?._id || 'new')
                    }, mission?._id || index);
                }),
                !activeMission && showPostCloseOpenAction && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1ee55a4f2a82deaf$export$2271e07b17a755d3), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        mt: 4,
                        "data-test": "action-switch-isReplaceable",
                        color: 'primary',
                        outlined: true,
                        size: 'small',
                        fullwidth: true,
                        onClick: ()=>{
                            postUpdateMutation.mutate({
                                postId: post._id,
                                workersRequestId: workersRequest._id,
                                isReplaceable: !post.isReplaceable
                            });
                        },
                        children: post.isReplaceable ? 'Pas de candidat pour ce poste' : "R\xe9ouvrir le poste et demander un candidat"
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                !activeMission && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $be7c1b4386312981$export$2e2bcd8739ae039), {
                    post: post,
                    workersRequest: workersRequest,
                    availableWorkers: currentUserRole === 'interimAgencyMember' ? suggestions.workers || [] : undefined,
                    workersWithMissionCorrespondingToPost: currentUserRole === 'interimAgencyMember' ? workersWithMissionCorrespondingToPost : undefined
                })
            ]
        })
    });
};
var $b129d7bacb3cfb1b$export$2e2bcd8739ae039 = $b129d7bacb3cfb1b$var$WorkersRequestPostListItem;
const $b129d7bacb3cfb1b$var$PostMission = ({ mission: mission, workersRequest: workersRequest, post: post })=>{
    const laborCostCoefficientKind = mission?.user && (0, $25ffbf4bca475b04$export$1a30e0a3340758be)(mission.user, workersRequest.interimAgency, workersRequest.employer) || 'delegation';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            mission?.user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mr: 2,
                renderAs: "span",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                    user: mission.user,
                    small: true
                })
            }),
            mission ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($b129d7bacb3cfb1b$var$PostMissionLink, {
                        mission: mission
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "small",
                        children: [
                            ' ',
                            "/",
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c5025698526f6ad2$export$2e2bcd8739ae039), {
                                laborCostCoefficientKind: laborCostCoefficientKind
                            })
                        ]
                    })
                ]
            }) : post.isReplaceable && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6a0365fc379f506$export$2e2bcd8739ae039), {
                workersRequest: workersRequest,
                postId: post?._id
            })
        ]
    }, mission?._id || 'new');
};
const $b129d7bacb3cfb1b$var$PostMissionLink = ({ mission: mission })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "span",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
            to: `/missions/${mission._id}`,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                children: [
                    mission.isCancelled && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$87c7eb6b45e704ed), {
                        mission: mission,
                        type: "icon"
                    }),
                    mission.isAbandoned && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$ddd1eb3f2daca47d), {
                        mission: mission,
                        type: "icon"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                        style: mission.isCancelled || mission.isAbandoned ? {
                            textDecoration: 'line-through'
                        } : {},
                        children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(mission.user)
                    })
                ]
            })
        })
    });
};




const $b29163ef76d8b0e3$var$WorkersRequestsDetails = ({})=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $b8c6247768bd4102$export$4a6f974b4208311)());
    const assignWorkersToPostsMutation = (0, $b8c6247768bd4102$export$3aab0d82fc583c26)();
    const [displayMode, setDisplayMode] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('individualAssign');
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: workersRequest } = (0, $b8c6247768bd4102$export$1a75acd08b8f614)(id);
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($b29163ef76d8b0e3$var$formWrapperBaseProps, //@ts-expect-error
    mutationState, !isNew);
    const breadcrumbs = $b29163ef76d8b0e3$var$useBreadcrumbs();
    const historyRef = (0, $3ZYaX.useRef)(null);
    const scrollToHistory = ()=>historyRef.current?.scrollIntoView();
    const historyItems = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return (0, $2KSUA.sortBy)(workersRequest?.history || [], 'createdAt').reverse();
    }, [
        workersRequest
    ]);
    const data = (0, $dc7a2efd11d26aa1$export$2e2bcd8739ae039)({
        workersRequest: workersRequest
    });
    const showMultipleAssignForm = !Boolean(workersRequest?.isComplete || workersRequest?.isCancelled);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!showMultipleAssignForm && displayMode === 'multipleAssign') setDisplayMode('individualAssign');
    }, [
        showMultipleAssignForm
    ]);
    const assignWorkersToPosts = async (selectedWorkerIds, posts)=>{
        if (!workersRequest?._id) return;
        const postsWithSelectedWorkerIds = posts.map((post, index)=>({
                postId: post._id,
                userId: selectedWorkerIds[index]
            })).filter((post)=>post.userId && post.postId);
        await assignWorkersToPostsMutation.mutateAsync({
            workersRequestId: workersRequest?._id,
            posts: postsWithSelectedWorkerIds
        });
    };
    const author = workersRequest?.history?.[0]?.by;
    if (!workersRequest) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                ...formWrapperProps,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        breakpoint: "desktop",
                        max: true,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                            items: breadcrumbs
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        align: "right",
                                        children: !isNew && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $81fea641c7a956af$export$9eb9467136ef56ff), {
                                            workersRequest: workersRequest
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                alignItems: "flex-start",
                                mb: 6,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $81fea641c7a956af$export$2e2bcd8739ae039), {
                                            workersRequest: workersRequest,
                                            organizationType: currentUserRole === 'interimAgencyMember' ? 'employer' : 'interimAgency'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                        align: "right",
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$2e2bcd8739ae039), {
                                                workersRequest: workersRequest,
                                                type: "tag"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            mb: 1,
                                            size: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                                        size: 5,
                                                                        children: `Du ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workersRequest.missionsStart)} au ${(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(workersRequest.missionsEnd)}`
                                                                    }),
                                                                    author && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                                                            size: 6,
                                                                            subtitle: true,
                                                                            textWeight: "bold",
                                                                            children: [
                                                                                "Par ",
                                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                                                                    user: author
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                color: 'ghost',
                                                                onClick: scrollToHistory,
                                                                children: "Historique de la Demande\xa0\u2193"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                                    mb: 6,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        mb: 2,
                                                                        textWeight: "bold",
                                                                        children: "Adresse"
                                                                    }),
                                                                    workersRequest.missionData.address
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                                                children: "Horaire"
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $57aebf4ebcb27eee$export$2e2bcd8739ae039), {
                                                                workPeriods: workersRequest.missionData.workPeriods
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 12,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                                    size: 5,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                            children: [
                                                                "Postes demand\xe9s (",
                                                                workersRequest.stats.assigned,
                                                                "\xa0/\xa0",
                                                                workersRequest.stats.assigned + workersRequest.stats.notAssigned,
                                                                ")"
                                                            ]
                                                        }),
                                                        showMultipleAssignForm && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                                roles: [
                                                                    'interimAgencyMember'
                                                                ],
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                        size: "small",
                                                                        color: displayMode === 'individualAssign' ? 'primary' : 'ghost',
                                                                        onClick: ()=>setDisplayMode('individualAssign'),
                                                                        "data-test": "individual-assign-posts-tab",
                                                                        children: "Assignation individuelle"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                        size: "small",
                                                                        color: displayMode === 'multipleAssign' ? 'primary' : 'ghost',
                                                                        onClick: ()=>setDisplayMode('multipleAssign'),
                                                                        "data-test": "multiple-assign-posts-tab",
                                                                        children: "Assignation multiple"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                    children: [
                                                        displayMode === 'multipleAssign' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d478b175b1f712f7$export$2e2bcd8739ae039), {
                                                                onAutoAssign: async (selectedWorkerIds, posts)=>{
                                                                    await assignWorkersToPosts(selectedWorkerIds, posts);
                                                                },
                                                                suggestions: data,
                                                                workersRequest: workersRequest
                                                            })
                                                        }),
                                                        displayMode === 'individualAssign' && workersRequest.posts.map((post)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b129d7bacb3cfb1b$export$2e2bcd8739ae039), {
                                                                    post: post,
                                                                    workersRequest: workersRequest,
                                                                    count: {
                                                                        current: workersRequest.posts.findIndex((p)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(p, post)) + 1,
                                                                        total: workersRequest.stats.posts.total
                                                                    },
                                                                    suggestions: data
                                                                })
                                                            }, post._id)),
                                                        workersRequest.posts.length === 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            textSize: 7,
                                                            textAlign: "center",
                                                            children: "Aucun poste \xe0 afficher"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                mb: 5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        breakpoint: "desktop",
                        max: true,
                        pt: 5,
                        domRef: historyRef,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 5,
                                pt: 5,
                                children: "Historique"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d21fe120a7200937$export$2e2bcd8739ae039), {
                                //@ts-expect-error
                                items: historyItems,
                                locales: (0, $130e8fd2d93b50ce$export$2e2bcd8739ae039).history,
                                renderCustomContent: (item)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70314483a0c6c85a$export$2e2bcd8739ae039), {
                                        historyItem: historyItems.find((i)=>i._id === item._id)
                                    }, item._id)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $b29163ef76d8b0e3$export$2e2bcd8739ae039 = $b29163ef76d8b0e3$var$WorkersRequestsDetails;
const $b29163ef76d8b0e3$var$formWrapperBaseProps = {
    loadingProps: {
        body: 'Enregistrement de la Demande...'
    },
    successProps: {
        title: "Demande cr\xe9\xe9e",
        body: {
            description: "La Demande a \xe9t\xe9 cr\xe9\xe9e, l'Agence d'Int\xe9rim a \xe9t\xe9 notifi\xe9e.",
            actions: [
                {
                    label: 'Nouvelle Demande'
                },
                {
                    label: "Retourner \xe0 la liste",
                    to: '/workers-requests'
                }
            ]
        }
    }
};
const $b29163ef76d8b0e3$var$useBreadcrumbs = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: 'Demandes de Personnel',
                to: '/workers-requests'
            },
            {
                label: `Demande de Personnel`
            }
        ], []);




var $3ZYaX = parcelRequire("3ZYaX");





parcelRequire("3ZYaX");


const $bb022a992405465d$var$WorkersRequestFormTitle = ({ workersRequest: workersRequest, isNew: isNew })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: isNew ? `Nouvelle Demande d'Int\xe9rimaires` : `Demande d'Int\xe9rimaires`,
        subTitle: workersRequest && workersRequest.employer.name,
        subTitleLight: workersRequest && `du ${(0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(workersRequest.missionsStart)} au ${(0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(workersRequest.missionsEnd)}`
    });
};
var $bb022a992405465d$export$2e2bcd8739ae039 = $bb022a992405465d$var$WorkersRequestFormTitle;






var $31tXu = parcelRequire("31tXu");

var $3ZYaX = parcelRequire("3ZYaX");










var $2KSUA = parcelRequire("2KSUA");




parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");

var $1rKN8 = parcelRequire("1rKN8");
function $ec3d010f3e8b9596$export$5d49d615ad5ea2b0(array, from, to) {
    array = array.slice();
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
    return array;
}
function $ec3d010f3e8b9596$export$30a014203d0d7e4f(array, index) {
    array = array.slice();
    array.splice(index, 1);
    return array;
}
function $ec3d010f3e8b9596$export$78480c5a3e5b001d(element) {
    const style = window.getComputedStyle(element);
    return Math.max(parseInt(style['margin-top'], 10), parseInt(style['margin-bottom'], 10)) + element.getBoundingClientRect().height;
}
function $ec3d010f3e8b9596$export$c4dfce035d43d1e0(event) {
    return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function $ec3d010f3e8b9596$export$ef3b10464ff5e4ec(element, offsetY = 0, offsetX = 0) {
    if (!element) return;
    if (offsetY === null || offsetX === null) {
        element.style.removeProperty('transform');
        return;
    }
    element.style.transform = `translate(${offsetX}px, ${offsetY}px)`;
}
function $ec3d010f3e8b9596$export$12700167ba3f1e75(element) {
    return !!element.style.transform;
}
function $ec3d010f3e8b9596$export$32acb4a609310329(element, duration, timing) {
    if (element) element.style['transition'] = `transform ${duration}ms${timing ? ` ${timing}` : ''}`;
}
function $ec3d010f3e8b9596$export$2e0ae67339d5f1ac(array, targetValue) {
    let min = 0;
    let max = array.length - 1;
    let guess;
    while(min <= max){
        guess = Math.floor((max + min) / 2);
        if (!array[guess + 1] || array[guess] <= targetValue && array[guess + 1] >= targetValue) return guess;
        else if (array[guess] < targetValue && array[guess + 1] < targetValue) min = guess + 1;
        else max = guess - 1;
    }
    return -1;
}
const $ec3d010f3e8b9596$export$e6870ddd02bba492 = (fn)=>{
    let lastArgs = [];
    let frameId = null;
    const wrapperFn = (...args)=>{
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn(...lastArgs);
        });
    };
    wrapperFn.cancel = ()=>{
        if (frameId) cancelAnimationFrame(frameId);
    };
    return wrapperFn;
};
function $ec3d010f3e8b9596$export$cae3b4c58e57a48a(target, rootElement) {
    const DISABLED_ELEMENTS = [
        'input',
        'textarea',
        'select',
        'option',
        'optgroup',
        'video',
        'audio',
        'button',
        'a'
    ];
    const DISABLED_ROLES = [
        'button',
        'link',
        'checkbox',
        'tab'
    ];
    while(target !== rootElement){
        if (target.getAttribute('data-movable-handle')) return false;
        if (DISABLED_ELEMENTS.includes(target.tagName.toLowerCase())) return true;
        const role = target.getAttribute('role');
        if (role && DISABLED_ROLES.includes(role.toLowerCase())) return true;
        if (target.tagName.toLowerCase() === 'label' && target.hasAttribute('for')) return true;
        if (target.tagName) target = target.parentElement;
    }
    return false;
}


const $4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET = 200;
const $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO = 10;
const $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD = 10;
class $4e8836368d5231cd$var$List extends $3ZYaX.Component {
    componentDidMount() {
        this.calculateOffsets();
        document.addEventListener('touchstart', this.onMouseOrTouchStart, {
            passive: false,
            capture: false
        });
        document.addEventListener('mousedown', this.onMouseOrTouchStart);
    }
    componentDidUpdate(_prevProps, prevState) {
        if (prevState.scrollingSpeed !== this.state.scrollingSpeed && prevState.scrollingSpeed === 0) this.doScrolling();
    }
    componentWillUnmount() {
        document.removeEventListener('touchstart', this.onMouseOrTouchStart);
        document.removeEventListener('mousedown', this.onMouseOrTouchStart);
        if (this.dropTimeout) window.clearTimeout(this.dropTimeout);
        this.schdOnMouseMove.cancel();
        this.schdOnTouchMove.cancel();
        this.schdOnEnd.cancel();
    }
    render() {
        const baseStyle = {
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            boxSizing: 'border-box',
            position: 'relative'
        };
        const ghostStyle = {
            ...baseStyle,
            top: this.state.targetY,
            left: this.state.targetX,
            width: this.state.targetWidth,
            height: this.state.targetHeight,
            position: 'fixed',
            marginTop: 0
        };
        return $3ZYaX.createElement($3ZYaX.Fragment, null, this.props.renderList({
            children: this.props.values.map((value, index)=>{
                const isHidden = index === this.state.itemDragged;
                const isSelected = index === this.state.selectedItem;
                const isDisabled = // @ts-ignore
                this.props.values[index] && this.props.values[index].disabled;
                const props = {
                    key: index,
                    tabIndex: isDisabled ? -1 : 0,
                    'aria-roledescription': this.props.voiceover.item(index + 1),
                    onKeyDown: this.onKeyDown,
                    style: {
                        ...baseStyle,
                        visibility: isHidden ? 'hidden' : undefined,
                        zIndex: isSelected ? 5000 : 0
                    }
                };
                return this.props.renderItem({
                    value: value,
                    props: props,
                    index: index,
                    isDragged: false,
                    isSelected: isSelected,
                    isOutOfBounds: false
                });
            }),
            isDragged: this.state.itemDragged > -1,
            props: {
                ref: this.listRef
            }
        }), this.state.itemDragged > -1 && $1rKN8.createPortal(this.props.renderItem({
            value: this.props.values[this.state.itemDragged],
            props: {
                ref: this.ghostRef,
                style: ghostStyle,
                onWheel: this.onWheel
            },
            index: this.state.itemDragged,
            isDragged: true,
            isSelected: false,
            isOutOfBounds: this.state.itemDraggedOutOfBounds > -1
        }), this.props.container || document.body), $3ZYaX.createElement("div", {
            "aria-live": "assertive",
            role: "log",
            "aria-atomic": "true",
            style: {
                position: 'absolute',
                width: '1px',
                height: '1px',
                margin: '-1px',
                border: '0px',
                padding: '0px',
                overflow: 'hidden',
                clip: 'rect(0px, 0px, 0px, 0px)',
                clipPath: 'inset(100%)'
            }
        }, this.state.liveText));
    }
    constructor(props){
        super(props);
        this.listRef = $3ZYaX.createRef();
        this.ghostRef = $3ZYaX.createRef();
        this.topOffsets = [];
        this.itemTranslateOffsets = [];
        this.initialYOffset = 0;
        this.lastScroll = 0;
        this.lastYOffset = 0;
        this.lastListYOffset = 0;
        this.needle = -1;
        this.afterIndex = -2;
        this.state = {
            itemDragged: -1,
            itemDraggedOutOfBounds: -1,
            selectedItem: -1,
            initialX: 0,
            initialY: 0,
            targetX: 0,
            targetY: 0,
            targetHeight: 0,
            targetWidth: 0,
            liveText: '',
            scrollingSpeed: 0,
            scrollWindow: false
        };
        this.doScrolling = ()=>{
            const { scrollingSpeed: scrollingSpeed, scrollWindow: scrollWindow } = this.state;
            const listEl = this.listRef.current;
            window.requestAnimationFrame(()=>{
                if (scrollWindow) window.scrollTo(window.pageXOffset, window.pageYOffset + scrollingSpeed * 1.5);
                else listEl.scrollTop += scrollingSpeed;
                if (scrollingSpeed !== 0) this.doScrolling();
            });
        };
        this.getChildren = ()=>{
            if (this.listRef && this.listRef.current) return Array.from(this.listRef.current.children);
            console.warn('No items found in the List container. Did you forget to pass & spread the `props` param in renderList?');
            return [];
        };
        this.calculateOffsets = ()=>{
            this.topOffsets = this.getChildren().map((item)=>item.getBoundingClientRect().top);
            this.itemTranslateOffsets = this.getChildren().map((item)=>(0, $ec3d010f3e8b9596$export$78480c5a3e5b001d)(item));
        };
        this.getTargetIndex = (e)=>{
            return this.getChildren().findIndex((child)=>child === e.target || child.contains(e.target));
        };
        this.onMouseOrTouchStart = (e)=>{
            if (this.dropTimeout && this.state.itemDragged > -1) {
                window.clearTimeout(this.dropTimeout);
                this.finishDrop();
            }
            const isTouch = (0, $ec3d010f3e8b9596$export$c4dfce035d43d1e0)(e);
            if (!isTouch && e.button !== 0) return;
            const index = this.getTargetIndex(e);
            if (index === -1 || // @ts-ignore
            this.props.values[index] && this.props.values[index].disabled) {
                if (this.state.selectedItem !== -1) {
                    this.setState({
                        selectedItem: -1
                    });
                    this.finishDrop();
                }
                return;
            }
            const listItemTouched = this.getChildren()[index];
            const handle = listItemTouched.querySelector('[data-movable-handle]');
            if (handle && !handle.contains(e.target)) return;
            if ((0, $ec3d010f3e8b9596$export$cae3b4c58e57a48a)(e.target, listItemTouched)) return;
            e.preventDefault();
            this.props.beforeDrag && this.props.beforeDrag({
                elements: this.getChildren(),
                index: index
            });
            if (isTouch) {
                const opts = {
                    passive: false
                };
                listItemTouched.style.touchAction = 'none';
                document.addEventListener('touchend', this.schdOnEnd, opts);
                document.addEventListener('touchmove', this.schdOnTouchMove, opts);
                document.addEventListener('touchcancel', this.schdOnEnd, opts);
            } else {
                document.addEventListener('mousemove', this.schdOnMouseMove);
                document.addEventListener('mouseup', this.schdOnEnd);
                const listItemDragged = this.getChildren()[this.state.itemDragged];
                if (listItemDragged && listItemDragged.style) listItemDragged.style.touchAction = '';
            }
            this.onStart(listItemTouched, isTouch ? e.touches[0].clientX : e.clientX, isTouch ? e.touches[0].clientY : e.clientY, index);
        };
        this.getYOffset = ()=>{
            const listScroll = this.listRef.current ? this.listRef.current.scrollTop : 0;
            return window.pageYOffset + listScroll;
        };
        this.onStart = (target, clientX, clientY, index)=>{
            if (this.state.selectedItem > -1) {
                this.setState({
                    selectedItem: -1
                });
                this.needle = -1;
            }
            const targetRect = target.getBoundingClientRect();
            const targetStyles = window.getComputedStyle(target);
            this.calculateOffsets();
            this.initialYOffset = this.getYOffset();
            this.lastYOffset = window.pageYOffset;
            this.lastListYOffset = this.listRef.current.scrollTop;
            this.setState({
                itemDragged: index,
                targetX: targetRect.left - parseInt(targetStyles['margin-left'], 10),
                targetY: targetRect.top - parseInt(targetStyles['margin-top'], 10),
                targetHeight: targetRect.height,
                targetWidth: targetRect.width,
                initialX: clientX,
                initialY: clientY
            });
        };
        this.onMouseMove = (e)=>{
            e.cancelable && e.preventDefault();
            this.onMove(e.clientX, e.clientY);
        };
        this.onTouchMove = (e)=>{
            e.cancelable && e.preventDefault();
            this.onMove(e.touches[0].clientX, e.touches[0].clientY);
        };
        this.onWheel = (e)=>{
            if (this.state.itemDragged < 0) return;
            this.lastScroll = this.listRef.current.scrollTop += e.deltaY;
            this.moveOtherItems();
        };
        this.onMove = (clientX, clientY)=>{
            if (this.state.itemDragged === -1) return null;
            (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(this.ghostRef.current, clientY - this.state.initialY, this.props.lockVertically ? 0 : clientX - this.state.initialX);
            this.autoScrolling(clientY, clientY - this.state.initialY);
            this.moveOtherItems();
        };
        this.moveOtherItems = ()=>{
            const targetRect = this.ghostRef.current.getBoundingClientRect();
            const itemVerticalCenter = targetRect.top + targetRect.height / 2;
            const offset = (0, $ec3d010f3e8b9596$export$78480c5a3e5b001d)(this.getChildren()[this.state.itemDragged]);
            const currentYOffset = this.getYOffset();
            // adjust offsets if scrolling happens during the item movement
            if (this.initialYOffset !== currentYOffset) {
                this.topOffsets = this.topOffsets.map((offset)=>offset - (currentYOffset - this.initialYOffset));
                this.initialYOffset = currentYOffset;
            }
            if (this.isDraggedItemOutOfBounds() && this.props.removableByMove) this.afterIndex = this.topOffsets.length + 1;
            else this.afterIndex = (0, $ec3d010f3e8b9596$export$2e0ae67339d5f1ac)(this.topOffsets, itemVerticalCenter);
            this.animateItems(this.afterIndex === -1 ? 0 : this.afterIndex, this.state.itemDragged, offset);
        };
        this.autoScrolling = (clientY, delta)=>{
            const { top: top, bottom: bottom, height: height } = this.listRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            // autoscrolling for the window (down)
            if (bottom > viewportHeight && viewportHeight - clientY < $4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET && delta > $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) this.setState({
                scrollingSpeed: Math.min(Math.round(($4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET - (viewportHeight - clientY)) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO), Math.round((delta - $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO)),
                scrollWindow: true
            });
            else if (top < 0 && clientY < $4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET && delta < -$4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) this.setState({
                scrollingSpeed: Math.max(Math.round(($4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET - clientY) / -$4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO), Math.round((delta + $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO)),
                scrollWindow: true
            });
            else {
                if (this.state.scrollWindow && this.state.scrollingSpeed !== 0) this.setState({
                    scrollingSpeed: 0,
                    scrollWindow: false
                });
                // autoscrolling for containers with overflow
                if (height + 20 < this.listRef.current.scrollHeight) {
                    let scrollingSpeed = 0;
                    // (up)
                    if (clientY - top < $4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET && delta < -$4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) scrollingSpeed = Math.max(Math.round(($4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET - (clientY - top)) / -$4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO), Math.round((delta + $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO));
                    else if (bottom - clientY < $4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET && delta > $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) scrollingSpeed = Math.min(Math.round(($4e8836368d5231cd$var$AUTOSCROLL_ACTIVE_OFFSET - (bottom - clientY)) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO), Math.round((delta - $4e8836368d5231cd$var$AUTOSCROLL_DELTA_THRESHOLD) / $4e8836368d5231cd$var$AUTOSCROLL_SPEED_RATIO));
                    if (this.state.scrollingSpeed !== scrollingSpeed) this.setState({
                        scrollingSpeed: scrollingSpeed
                    });
                }
            }
        };
        this.animateItems = (needle, movedItem, offset, animateMovedItem = false)=>{
            this.getChildren().forEach((item, i)=>{
                (0, $ec3d010f3e8b9596$export$32acb4a609310329)(item, this.props.transitionDuration);
                if (movedItem === i && animateMovedItem) {
                    if (movedItem === needle) return (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, null);
                    (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, movedItem < needle ? this.itemTranslateOffsets.slice(movedItem + 1, needle + 1).reduce((a, b)=>a + b, 0) : this.itemTranslateOffsets.slice(needle, movedItem).reduce((a, b)=>a + b, 0) * -1);
                } else if (movedItem < needle && i > movedItem && i <= needle) (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, -offset);
                else if (i < movedItem && movedItem > needle && i >= needle) (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, offset);
                else (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, null);
            });
        };
        this.isDraggedItemOutOfBounds = ()=>{
            const initialRect = this.getChildren()[this.state.itemDragged].getBoundingClientRect();
            const targetRect = this.ghostRef.current.getBoundingClientRect();
            if (Math.abs(initialRect.left - targetRect.left) > targetRect.width) {
                if (this.state.itemDraggedOutOfBounds === -1) this.setState({
                    itemDraggedOutOfBounds: this.state.itemDragged
                });
                return true;
            }
            if (this.state.itemDraggedOutOfBounds > -1) this.setState({
                itemDraggedOutOfBounds: -1
            });
            return false;
        };
        this.onEnd = (e)=>{
            e.cancelable && e.preventDefault();
            document.removeEventListener('mousemove', this.schdOnMouseMove);
            document.removeEventListener('touchmove', this.schdOnTouchMove);
            document.removeEventListener('mouseup', this.schdOnEnd);
            document.removeEventListener('touchup', this.schdOnEnd);
            document.removeEventListener('touchcancel', this.schdOnEnd);
            const removeItem = this.props.removableByMove && this.isDraggedItemOutOfBounds();
            if (!removeItem && this.props.transitionDuration > 0 && this.afterIndex !== -2) // animate drop
            (0, $ec3d010f3e8b9596$export$e6870ddd02bba492)(()=>{
                (0, $ec3d010f3e8b9596$export$32acb4a609310329)(this.ghostRef.current, this.props.transitionDuration, 'cubic-bezier(.2,1,.1,1)');
                if (this.afterIndex < 1 && this.state.itemDragged === 0) (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(this.ghostRef.current, 0, 0);
                else (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(this.ghostRef.current, // compensate window scroll
                -(window.pageYOffset - this.lastYOffset) + // compensate container scroll
                -(this.listRef.current.scrollTop - this.lastListYOffset) + (this.state.itemDragged < this.afterIndex ? this.itemTranslateOffsets.slice(this.state.itemDragged + 1, this.afterIndex + 1).reduce((a, b)=>a + b, 0) : this.itemTranslateOffsets.slice(this.afterIndex < 0 ? 0 : this.afterIndex, this.state.itemDragged).reduce((a, b)=>a + b, 0) * -1), 0);
            })();
            this.dropTimeout = window.setTimeout(this.finishDrop, removeItem || this.afterIndex === -2 ? 0 : this.props.transitionDuration);
        };
        this.finishDrop = ()=>{
            const removeItem = this.props.removableByMove && this.isDraggedItemOutOfBounds();
            if (removeItem || this.afterIndex > -2 && this.state.itemDragged !== this.afterIndex) this.props.onChange({
                oldIndex: this.state.itemDragged,
                newIndex: removeItem ? -1 : Math.max(this.afterIndex, 0),
                targetRect: this.ghostRef.current.getBoundingClientRect()
            });
            this.getChildren().forEach((item)=>{
                (0, $ec3d010f3e8b9596$export$32acb4a609310329)(item, 0);
                (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, null);
                item.style.touchAction = '';
            });
            this.setState({
                itemDragged: -1,
                scrollingSpeed: 0
            });
            this.afterIndex = -2;
            // sometimes the scroll gets messed up after the drop, fix:
            if (this.lastScroll > 0) {
                this.listRef.current.scrollTop = this.lastScroll;
                this.lastScroll = 0;
            }
        };
        this.onKeyDown = (e)=>{
            const selectedItem = this.state.selectedItem;
            const index = this.getTargetIndex(e);
            if ((0, $ec3d010f3e8b9596$export$cae3b4c58e57a48a)(e.target, e.currentTarget)) return;
            if (index === -1) return;
            if (e.key === ' ') {
                e.preventDefault();
                if (selectedItem === index) {
                    if (selectedItem !== this.needle) {
                        this.getChildren().forEach((item)=>{
                            (0, $ec3d010f3e8b9596$export$32acb4a609310329)(item, 0);
                            (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, null);
                        });
                        this.props.onChange({
                            oldIndex: selectedItem,
                            newIndex: this.needle,
                            targetRect: this.getChildren()[this.needle].getBoundingClientRect()
                        });
                        this.getChildren()[this.needle].focus();
                    }
                    this.setState({
                        selectedItem: -1,
                        liveText: this.props.voiceover.dropped(selectedItem + 1, this.needle + 1)
                    });
                    this.needle = -1;
                } else {
                    this.setState({
                        selectedItem: index,
                        liveText: this.props.voiceover.lifted(index + 1)
                    });
                    this.needle = index;
                    this.calculateOffsets();
                }
            }
            if ((e.key === 'ArrowDown' || e.key === 'j') && selectedItem > -1 && this.needle < this.props.values.length - 1) {
                e.preventDefault();
                const offset = (0, $ec3d010f3e8b9596$export$78480c5a3e5b001d)(this.getChildren()[selectedItem]);
                this.needle++;
                this.animateItems(this.needle, selectedItem, offset, true);
                this.setState({
                    liveText: this.props.voiceover.moved(this.needle + 1, false)
                });
            }
            if ((e.key === 'ArrowUp' || e.key === 'k') && selectedItem > -1 && this.needle > 0) {
                e.preventDefault();
                const offset = (0, $ec3d010f3e8b9596$export$78480c5a3e5b001d)(this.getChildren()[selectedItem]);
                this.needle--;
                this.animateItems(this.needle, selectedItem, offset, true);
                this.setState({
                    liveText: this.props.voiceover.moved(this.needle + 1, true)
                });
            }
            if (e.key === 'Escape' && selectedItem > -1) {
                this.getChildren().forEach((item)=>{
                    (0, $ec3d010f3e8b9596$export$32acb4a609310329)(item, 0);
                    (0, $ec3d010f3e8b9596$export$ef3b10464ff5e4ec)(item, null);
                });
                this.setState({
                    selectedItem: -1,
                    liveText: this.props.voiceover.canceled(selectedItem + 1)
                });
                this.needle = -1;
            }
            if ((e.key === 'Tab' || e.key === 'Enter') && selectedItem > -1) e.preventDefault();
        };
        this.schdOnMouseMove = (0, $ec3d010f3e8b9596$export$e6870ddd02bba492)(this.onMouseMove);
        this.schdOnTouchMove = (0, $ec3d010f3e8b9596$export$e6870ddd02bba492)(this.onTouchMove);
        this.schdOnEnd = (0, $ec3d010f3e8b9596$export$e6870ddd02bba492)(this.onEnd);
    }
}
$4e8836368d5231cd$var$List.defaultProps = {
    transitionDuration: 300,
    lockVertically: false,
    removableByMove: false,
    voiceover: {
        item: (position)=>`You are currently at a draggable item at position ${position}. Press space bar to lift.`,
        lifted: (position)=>`You have lifted item at position ${position}. Press j to move down, k to move up, space bar to drop and escape to cancel.`,
        moved: (position, up)=>`You have moved the lifted item ${up ? 'up' : 'down'} to position ${position}. Press j to move down, k to move up, space bar to drop and escape to cancel.`,
        dropped: (from, to)=>`You have dropped the item. It has moved from position ${from} to ${to}.`,
        canceled: (position)=>`You have cancelled the movement. The item has returned to its starting position of ${position}.`
    }
};
var $4e8836368d5231cd$export$2e2bcd8739ae039 = $4e8836368d5231cd$var$List;





const $eda4e6b49e9c7d38$var$ListField = ({ label: label, form: form, field: field, items: items })=>{
    const { name: fieldName } = field;
    const fieldValue = field.value;
    const setFieldValue = form.setFieldValue;
    const removeItemFromList = (itemValue)=>{
        setFieldValue(fieldName, fieldValue.filter((fV)=>fV !== itemValue));
    };
    const moveItemInList = (itemIndex, moveTo)=>{
        setFieldValue(fieldName, (0, $b31fa4978015d2ce$export$14ce5b0f6fbe4001)([
            ...fieldValue
        ], itemIndex, moveTo));
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        error: form.errors[fieldName],
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "ul",
            mb: 3,
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4e8836368d5231cd$export$2e2bcd8739ae039), {
                values: items,
                onChange: ({ oldIndex: oldIndex, newIndex: newIndex })=>{
                    moveItemInList(oldIndex, newIndex);
                },
                renderList: ({ children: children, props: props })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                        ...props,
                        children: children
                    }),
                renderItem: ({ value: value, props: props, isDragged: isDragged })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                        ...props,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            p: 1,
                            py: 2,
                            backgroundColor: isDragged ? 'light' : undefined,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    color: "primary",
                                    outlined: true,
                                    type: "button",
                                    onClick: ()=>removeItemFromList(value.value),
                                    size: "small",
                                    "data-tooltip": "Supprimer de la liste",
                                    style: {
                                        marginTop: -3
                                    },
                                    mr: 3,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                    style: {
                                        cursor: isDragged ? 'grabbing' : 'grab'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            "data-tooltip": "R\xe9ordonnez la liste par glisser-d\xe9poser",
                                            color: "grey-light",
                                            style: {
                                                cursor: isDragged ? 'grabbing' : 'grab'
                                            },
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$65604a0fb57b04f4), {})
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            ml: 2,
                                            children: value.renderedLabel || value.label
                                        })
                                    ]
                                })
                            ]
                        })
                    })
            })
        })
    });
};
var $eda4e6b49e9c7d38$export$2e2bcd8739ae039 = $eda4e6b49e9c7d38$var$ListField;












const $7bee40b68b806398$export$c3d8453eccce451d = (jobTilte, interimAgency)=>jobTilte.interimAgencySettings.find((l)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(l.interimAgency, interimAgency));





const $f629a449d8e7cdad$export$b0494023060b42ff = Object.freeze({
    count: 1,
    jobTitle: '',
    recourseCase: {
        reason: '',
        justification: ''
    },
    desiredWorkers: [],
    description: '',
    tags: []
});
const $f629a449d8e7cdad$export$313a1c509ccffdd1 = (props)=>{
    const { workersRequest: workersRequest, fromTemplate: fromTemplate } = props;
    // start and end dates stored as ISO dates YYYY-mm-dd
    // we always display at least 3 days
    const now = new Date();
    const today = now;
    const todayISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(now);
    const sunday = (0, $4bb47b500c9001ee$export$2e2bcd8739ae039)(now);
    const end = (0, $46e6b7724aa17953$export$2e2bcd8739ae039)(sunday, today) <= 3 ? (0, $ffff430a208564ac$export$2e2bcd8739ae039)(sunday, 7) : sunday;
    const endISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(end);
    if (workersRequest) {
        // We will update an existing workers request
        const firstWorkPeriodStartDate = workersRequest.missionsStart;
        const startDateISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(firstWorkPeriodStartDate));
        const lastWorkPeriodStartDate = workersRequest.missionsEnd;
        const endDateISO = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(new Date(lastWorkPeriodStartDate));
        const initialValues = {
            meta: {
                startDate: startDateISO,
                endDate: endDateISO,
                resource: workersRequest
            },
            interimAgency: workersRequest.interimAgency._id,
            missionData: {
                workPeriods: workersRequest.missionData.workPeriods.map((wP)=>({
                        ...wP,
                        start: {
                            date: new Date(wP.start.date)
                        },
                        end: {
                            date: new Date(wP.end.date)
                        }
                    })),
                service: workersRequest?.missionData.service?._id ?? '',
                address: workersRequest?.missionData.address,
                complementaryInformations: workersRequest.missionData.complementaryInformations ?? ''
            },
            posts: workersRequest.posts.map((post)=>{
                return {
                    ...post,
                    desiredWorkers: post.desiredWorkers.map((dW)=>dW._id.toString()),
                    jobTitle: post.jobTitle._id,
                    count: 1,
                    tags: post.tags || []
                };
            })
        };
        return initialValues;
    }
    if (fromTemplate?.mission) {
        // We create a new workers request and use an existing mission as template
        const { mission: mission } = fromTemplate;
        const startDateISO = todayISO;
        const endDateISO = endISO;
        const initialValues = {
            meta: {
                startDate: startDateISO,
                endDate: endDateISO,
                resource: undefined
            },
            interimAgency: mission.interimAgency?._id ?? '',
            missionData: {
                /* workPeriods: mission.workPeriods.map(wP => ({
          ...wP,
          start: { date: new Date(wP.start.date) },
          end: { date: new Date(wP.end.date) },
        })), */ workPeriods: [],
                service: mission.service?._id ?? '',
                address: mission.address,
                complementaryInformations: mission.complementaryInformations ?? ''
            },
            posts: [
                {
                    ...$f629a449d8e7cdad$export$b0494023060b42ff,
                    jobTitle: mission.jobTitle._id.toString(),
                    recourseCase: mission.workersRequestOfMission.postOfMission.recourseCase,
                    description: mission.workersRequestOfMission.postOfMission.description,
                    desiredWorkers: [
                        mission.user._id
                    ],
                    tags: mission.workersRequestOfMission.postOfMission.tags || []
                }
            ]
        };
        return initialValues;
    }
    if (fromTemplate?.workersRequest) {
        // We create a new workers request and use an existing workers request as template
        const { workersRequest: workersRequest } = fromTemplate;
        const startDateISO = todayISO;
        const endDateISO = endISO;
        const posts = workersRequest.posts// Mandatory to only keep needed parameters
        // The TS interface guarantees completeness
        .map((p)=>{
            const post = {
                count: 1,
                desiredWorkers: p.desiredWorkers.map((dW)=>dW._id.toString()),
                jobTitle: p.jobTitle._id,
                recourseCase: p.recourseCase,
                description: p.description ?? '',
                tags: p.tags || []
            };
            const lastMissionOfPost = p.missions?.[p.missions.length - 1];
            if (lastMissionOfPost && !lastMissionOfPost.isCancelled && !lastMissionOfPost.isAbandoned) post.desiredWorkers.push(lastMissionOfPost.user._id.toString());
            return post;
        })// Fold together posts that are the same
        .reduce((acc, current)=>{
            const previous = structuredClone(acc.pop());
            if (previous) {
                const { count: _drop1, desiredWorkers: previousDesiredWorkers, ...previousWithoutCount } = previous;
                const { count: _drop2, desiredWorkers: currentDesiredWorkers, ...currentWithoutCount } = current;
                if (JSON.stringify(previousWithoutCount) === JSON.stringify(currentWithoutCount)) {
                    previous.count = previous.count + 1;
                    previous.desiredWorkers = [
                        ...previousDesiredWorkers,
                        ...currentDesiredWorkers
                    ].filter((id)=>!!id).filter((id, index, all)=>{
                        return all.indexOf(id) === index;
                    });
                    return [
                        ...acc,
                        previous
                    ];
                } else {
                    previous.desiredWorkers = [
                        ...previousDesiredWorkers
                    ].filter((id)=>!!id).filter((id, index, all)=>{
                        return all.indexOf(id) === index;
                    });
                    current.desiredWorkers = [
                        ...currentDesiredWorkers
                    ].filter((id)=>!!id).filter((id, index, all)=>{
                        return all.indexOf(id) === index;
                    });
                    return [
                        ...acc,
                        previous,
                        current
                    ];
                }
            } else {
                current.desiredWorkers = [
                    ...current.desiredWorkers
                ].filter((id)=>!!id).filter((id, index, all)=>{
                    return all.indexOf(id) === index;
                });
                return [
                    current
                ];
            }
        }, []);
        const initialValues = {
            meta: {
                startDate: startDateISO,
                endDate: endDateISO,
                resource: undefined
            },
            interimAgency: workersRequest.interimAgency._id,
            missionData: {
                /* workPeriods: workersRequest.missionData.workPeriods.map(wP => ({
          ...wP,
          start: { date: new Date(wP.start.date) },
          end: { date: new Date(wP.end.date) },
        })), */ workPeriods: [],
                service: workersRequest.missionData.service?._id ?? '',
                address: workersRequest.missionData.address,
                complementaryInformations: workersRequest.missionData.complementaryInformations
            },
            posts: posts
        };
        return initialValues;
    }
    // We send blank default initial values
    const initialValues = {
        meta: {
            startDate: todayISO,
            endDate: endISO,
            resource: undefined
        },
        interimAgency: '',
        missionData: {
            workPeriods: [],
            service: '',
            address: '',
            complementaryInformations: ''
        },
        posts: [
            $f629a449d8e7cdad$export$b0494023060b42ff
        ]
    };
    return initialValues;
};



var $3ZYaX = parcelRequire("3ZYaX");
const $b3207b9421765213$var$FormikObserver = ({ onChange: onChange, values: values })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        onChange && onChange(values);
    }, [
        values
    ]);
    return null;
};
var $b3207b9421765213$export$2e2bcd8739ae039 = $b3207b9421765213$var$FormikObserver;




const $ad160ad756e27304$var$allRecourseCasesReasons = (0, $b0ebfbdfe7f43b20$export$2e2bcd8739ae039).workersRequests.recourseCases.reasons;
const $ad160ad756e27304$var$allRecourseCasesReasonsAsInputOptions = Object.entries($ad160ad756e27304$var$allRecourseCasesReasons).map(([key, value])=>({
        value: key,
        label: value
    }));
const $ad160ad756e27304$var$WorkersRequestForm = (props)=>{
    const { workersRequest: workersRequest, fromTemplate: fromTemplate } = props;
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const organizationQuery = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(currentOrganization._id, currentOrganization.type);
    // Local states
    const [currentJobTitle, setCurrentJobTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(undefined);
    // Resources queries
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)({});
    const servicesQuery = (0, $3d856666402e8eec$export$a870673e4b33fcfb)();
    const interimAgenciesQuery = (0, $58f46cb3f921014b$export$3a621c77e84e6f17)();
    // Workers Request Mutations
    const createWorkersRequestMutation = (0, $b8c6247768bd4102$export$a25726670bb41cb)();
    const updateWorkersRequestMutation = (0, $b8c6247768bd4102$export$cac0b33e6f13c8ec)();
    // Posts Mutations
    const createPostMutation = (0, $b8c6247768bd4102$export$d52fd328f9b799ac)();
    const updatePostMutation = (0, $b8c6247768bd4102$export$86ce95a609069de6)();
    const deletePostMutation = (0, $b8c6247768bd4102$export$98e17e10429f9256)();
    // Derived states
    const isNewWorkersRequest = workersRequest === undefined;
    const isExistingWorkersRequest = !isNewWorkersRequest;
    const isSubmitDisabled = workersRequest && !workersRequest.__actions.canBeUpdated && !workersRequest.__actions.requestedWorkersCanBeUpdated;
    const isPostValuesUpdated = {} // Will be updated on each render
    ;
    const initialValues = (0, $f629a449d8e7cdad$export$313a1c509ccffdd1)(props);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            // Interim Agency
            if (!values.interimAgency) errors['interimAgency'] = 'Champ requis';
            // Mission Data : Service
            if (!values.missionData?.service) {
                if (!errors.missionData) errors.missionData = {};
                //@ts-expect-error
                errors.missionData.service = 'Champ requis';
            }
            // Mission Data : Address
            if (!values.missionData?.address) {
                if (!errors.missionData) errors.missionData = {};
                errors.missionData.address = 'Champ requis';
            }
            // Mission Data : WorkPeriods
            const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.meta.startDate);
            const endDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.meta.endDate);
            // If no workPeriod at all
            if (!values.missionData.workPeriods || values.missionData.workPeriods.length === 0) {
                if (!errors.missionData) errors.missionData = {};
                errors.missionData.workPeriods = "Pas d'horaire de mission";
            }
            // If startDate is after endDate, this is not gonna work..
            if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(startDate, endDate)) {
                if (errors.meta === undefined) errors.meta = {};
                errors.meta['startDate'] = "La date de d\xe9but doit \xeatre avant la date de fin";
            }
            // If startDate<>endDate length is > 365 days, this is not allowed
            if (Math.abs((0, $46e6b7724aa17953$export$2e2bcd8739ae039)(startDate, endDate)) > 365) {
                if (errors.meta === undefined) errors.meta = {};
                errors.meta['endDate'] = 'Une mission doit durer maximum 1 an';
            }
            for(let index = 0; index <= values.missionData.workPeriods.length; index++){
                const workPeriod = values.missionData.workPeriods[index];
                const nextWorkPeriod = values.missionData.workPeriods[index + 1];
                const firstWorkPeriodStartDate = workPeriod && workPeriod.start ? workPeriod.start.date : undefined;
                const firstWorkPeriodEndDate = workPeriod && workPeriod.end ? workPeriod.end.date : undefined;
                const nextWorkPeriodStartDate = nextWorkPeriod && nextWorkPeriod.start ? nextWorkPeriod.start.date : undefined;
                // If the end of a workPeriod overlaps the start of the next workPeriod
                if (firstWorkPeriodStartDate && firstWorkPeriodEndDate && nextWorkPeriodStartDate) {
                    if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(nextWorkPeriodStartDate, firstWorkPeriodEndDate) || (0, $2KSUA.isEqual)(firstWorkPeriodEndDate, nextWorkPeriodStartDate)) {
                        const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(firstWorkPeriodStartDate);
                        const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(firstWorkPeriodStartDate);
                        const error = `${niceDate} : L'heure de fin ne peut \xeatre plus grande ou \xe9gale \xe0 l'heure du d\xe9but du jour suivant`;
                        if (!errors.missionData) errors.missionData = {};
                        errors.missionData.workPeriods = error;
                        (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                    }
                }
                // If a workPeriod has no start date set
                if (firstWorkPeriodStartDate === undefined && firstWorkPeriodEndDate) {
                    const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                    const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date);
                    const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
                    const error = `${niceDate} : L'heure de d\xe9but n'est pas pr\xe9cis\xe9e`;
                    if (!errors.missionData) errors.missionData = {};
                    errors.missionData.workPeriods = error;
                    (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                }
                // If a workPeriod has no end date set
                if (firstWorkPeriodStartDate && firstWorkPeriodEndDate === undefined) {
                    const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                    const niceDate = (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date);
                    const isoDate = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
                    const error = `${niceDate} : L'heure de fin n'est pas pr\xe9cis\xe9e`;
                    if (!errors.missionData) errors.missionData = {};
                    errors.missionData.workPeriods = error;
                    (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                }
                // Theoretical range: end after start (date-aware), duration <= 24h
                const rangeErrors = workPeriod && (0, $6b601cb106cd3f71$export$3ef1799cbda7de2c)(workPeriod?.start?.date, workPeriod?.end?.date);
                if (rangeErrors && (rangeErrors.startDate || rangeErrors.endDate)) {
                    const date = firstWorkPeriodStartDate ?? firstWorkPeriodEndDate;
                    const niceDate = date ? (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date) : '';
                    const isoDate = date ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date) : '';
                    const error = `${niceDate} : ${rangeErrors.startDate ?? rangeErrors.endDate}`;
                    if (!errors.missionData) errors.missionData = {};
                    errors.missionData.workPeriods = error;
                    if (isoDate) (errors[`workPeriod-${isoDate}`] ??= []).push(error);
                }
            }
            // Posts
            if (values.posts.length === 0) errors['posts'] = "Merci de remplir au moins un poste \xe0 pourvoir";
            for(let index = 0; index < values.posts.length; index++){
                const post = values.posts[index];
                // Post Job Title
                if (!post?.jobTitle) //@ts-expect-error
                errors[`posts.${index}.jobTitle`] = "Veuillez choisir un m\xe9tier";
                else if (post?.jobTitle) {
                    const jobTitle = (0, $ff82e5b471ec35cc$export$9625e2739149ea7e)(jobTitlesQuery.data || [], post.jobTitle);
                    if (jobTitle && values.interimAgency) {
                        const laborCoefficient = (0, $7bee40b68b806398$export$c3d8453eccce451d)(jobTitle, values.interimAgency);
                        if (!laborCoefficient || laborCoefficient.coefficients.delegationValue === null || laborCoefficient.coefficients.managementValue === null) //@ts-expect-error
                        errors[`posts.${index}.jobTitle`] = `Le coefficient main d'oeuvre n'est pas configur\xe9 entre ce poste et l'agence.`;
                    }
                }
                // Post Recourse Case Reason
                if (!post?.recourseCase.reason) //@ts-expect-error
                errors[`posts.${index}.recourseCase.reason`] = 'Veuillez choisir un Cas de Recours';
                // Post Recourse Case Justification
                if (!post?.recourseCase.justification) //@ts-expect-error
                errors[`posts.${index}.recourseCase.justification`] = 'Veuillez remplir une Justification pour le Cas de Recours';
            }
            return errors;
        },
        onSubmit: (values)=>{
            const { startDate: startDate, endDate: endDate } = values.meta;
            const missionStartDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(startDate);
            const missionEndDate = (0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(endDate), 1);
            // The form is validated, we know that each workPeriod is complete and valid
            const workPeriods = (0, $2KSUA.cloneDeep)(values.missionData.workPeriods)// We remove all existing work-periods before and after startDate/endDate
            .filter((wP)=>(0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(wP.start.date, {
                    start: missionStartDate,
                    end: missionEndDate
                }))// only start and end dates are needed
            .map((wP)=>{
                return {
                    start: {
                        date: wP.start.date
                    },
                    end: {
                        date: wP.end.date
                    }
                };
            });
            if (isExistingWorkersRequest) {
                if (workersRequest && workersRequest.__actions.canBeUpdated) {
                    // Workers Requests global values have been updated
                    const { missionData: missionData } = values;
                    updateWorkersRequestMutation.mutate({
                        id: workersRequest._id,
                        missionData: {
                            workPeriods: workPeriods,
                            service: missionData.service,
                            address: missionData.address
                        }
                    });
                }
                if (workersRequest && workersRequest.__actions.requestedWorkersCanBeUpdated) // Maybe a post has been updated
                Object.entries(isPostValuesUpdated).forEach(([postId, isUpdated])=>{
                    if (isUpdated) {
                        const updatedPost = values.posts.find((post)=>'_id' in post && post._id === postId);
                        if (updatedPost) {
                            const { desiredWorkers: desiredWorkers, recourseCase: recourseCase, jobTitle: jobTitle, description: description, tags: tags } = updatedPost;
                            updatePostMutation.mutate({
                                workersRequestId: workersRequest._id.toString(),
                                postId: postId,
                                desiredWorkers: desiredWorkers,
                                recourseCase: recourseCase,
                                jobTitleId: jobTitle,
                                description: description,
                                tags: tags?.map((tag)=>tag._id) || []
                            });
                        } else console.error("Couldn't find updated post, should not happen");
                    }
                });
                if (workersRequest && workersRequest.__actions.requestedWorkersCanBeUpdated) {
                    const draftPosts = values.posts.filter((post)=>!('_id' in post));
                    // Maybe a post has been created
                    const postsPayload = draftPosts.reduce((all, current)=>{
                        const { count: count, ...post } = current;
                        for(let i = 0; i < count; i++)all.push(post);
                        return all;
                    }, []);
                    postsPayload.forEach((post)=>{
                        const { desiredWorkers: desiredWorkers, recourseCase: recourseCase, jobTitle: jobTitle, description: description, tags: tags } = post;
                        createPostMutation.mutate({
                            workersRequestId: workersRequest._id.toString(),
                            desiredWorkers: desiredWorkers,
                            recourseCase: recourseCase,
                            jobTitle: jobTitle,
                            description: description,
                            tags: tags?.map((tag)=>tag._id) || []
                        });
                    });
                }
            } else if (isNewWorkersRequest) {
                const { posts: posts, interimAgency: interimAgency, missionData: missionData } = values;
                const postsPayload = posts.reduce((acc, curr)=>{
                    const updated = acc;
                    const { count: count, tags: tags, ...post } = curr;
                    for(let i = 0; i < count; i++)updated.push({
                        ...post,
                        tags: tags?.map((tag)=>tag._id) || []
                    });
                    return updated;
                }, []);
                // We create a new workers request
                createWorkersRequestMutation.mutate({
                    interimAgency: interimAgency,
                    missionData: {
                        ...missionData,
                        workPeriods: workPeriods
                    },
                    posts: postsPayload
                });
            }
        },
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Agence d'int\xe9rim concern\xe9e",
                                                name: "interimAgency",
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                required: true,
                                                fullwidth: "true",
                                                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(interimAgenciesQuery.data || []),
                                                selectDefaultChooseOptionLabel: "Agence d'Int\xe9rim...",
                                                disabled: Boolean(workersRequest)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Affectation",
                                                name: "missionData.service",
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                placeholder: "Affectation...",
                                                onlySelect: true,
                                                required: true,
                                                initialInputValue: fromTemplate?.mission?.service?.name || fromTemplate?.workersRequest?.missionData?.service?.name || workersRequest?.missionData?.service?.name,
                                                items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(servicesQuery.data || []),
                                                fullwidth: "true",
                                                selectDefaultChooseOptionLabel: "Choisir l'Affectation",
                                                disabled: workersRequest && !workersRequest.__actions.canBeUpdated
                                            }, workersRequest?.missionData?.service?._id)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: "missionData.address",
                                                label: "Adresse de la prestation",
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                required: true,
                                                items: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(organizationQuery.data?.addresses ?? []),
                                                disabled: workersRequest && !workersRequest.__actions.canBeUpdated
                                            }, workersRequest?.missionData?.address)
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                name: "missionData.complementaryInformations",
                                                label: "Informations compl\xe9mentaires pour l'Int\xe9rimaire",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                disabled: workersRequest
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 4,
                        children: "Horaire type de la prestation"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dcd93683234494f9$export$1c4614b036aef1a), {
                                        workPeriods: props.values.missionData.workPeriods,
                                        initialWorkPeriods: props.initialValues.missionData.workPeriods,
                                        resource: workersRequest,
                                        setWorkPeriods: (wPs)=>props.setFieldValue('missionData.workPeriods', wPs),
                                        errors: {
                                            ...props.errors,
                                            workPeriods: props.errors.missionData?.workPeriods
                                        },
                                        startDate: props.values.meta.startDate,
                                        endDate: props.values.meta.endDate,
                                        jobTitle: currentJobTitle?._id.toString()
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                        mt: 5,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {}),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            renderAs: "span",
                                                            textWeight: "bold",
                                                            children: "Simuler le calcul d'horaire pour"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
                                                            onChange: (e)=>{
                                                                setCurrentJobTitle(jobTitlesQuery.data?.find((jT)=>jT._id === e.target.value));
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                                    style: {
                                                                        display: 'none'
                                                                    },
                                                                    value: undefined,
                                                                    children: "Choisir un M\xe9tier"
                                                                }),
                                                                jobTitlesQuery.data?.map((jobTitle)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                                        value: jobTitle._id,
                                                                        children: jobTitlesQuery.data?.find((jT)=>jobTitle._id === jT._id)?.name
                                                                    }, jobTitle._id))
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isExistingWorkersRequest && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer.Item, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                    mutation: updateWorkersRequestMutation,
                                                    displayOn: {
                                                        success: "La demande a \xe9t\xe9 mise \xe0 jour"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                mutation: updateWorkersRequestMutation,
                                                color: "primary",
                                                type: "submit",
                                                disabled: isSubmitDisabled,
                                                "data-test": "submit-workers-request-form",
                                                children: "Mettre \xe0 jour la Demande"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 4,
                        mt: 6,
                        children: "Postes \xe0 Pourvoir"
                    }),
                    props.errors.posts && typeof props.errors.posts === 'string' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "danger",
                        children: props.errors.posts
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                        name: "posts",
                        render: (arrayHelpers)=>{
                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: props.values.posts.map((post, index, allPosts)=>{
                                    const isExistingPost = '_id' in post;
                                    const isDraftPost = !('_id' in post);
                                    const existingPost = isExistingPost ? post : undefined;
                                    const key = isExistingPost ? post._id : index;
                                    const existingPostInitialValues = existingPost && initialValues.posts.find((p)=>'_id' in p && p._id === existingPost._id);
                                    const isPostUpdated = existingPostInitialValues && !(0, $2KSUA.isEqual)(existingPostInitialValues, existingPost);
                                    if (existingPost) isPostValuesUpdated[existingPost._id] = Boolean(isPostUpdated);
                                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card), {
                                                mb: 5,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Header, {
                                                        p: 3,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Header.Title, {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        renderAs: "span",
                                                                        textColor: "primary",
                                                                        textSize: 5,
                                                                        children: post.count && post.jobTitle ? post.count + ' x ' + jobTitlesQuery.data?.find((jT)=>post.jobTitle === jT._id.toString())?.name : undefined
                                                                    }),
                                                                    post.recourseCase.reason ? //@ts-expect-error
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                        children: [
                                                                            "\xa0 | ",
                                                                            $ad160ad756e27304$var$allRecourseCasesReasons[post.recourseCase.reason]
                                                                        ]
                                                                    }) : '',
                                                                    post.recourseCase.justification ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                        children: [
                                                                            "\xa0 | ",
                                                                            post.recourseCase.justification
                                                                        ]
                                                                    }) : ''
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header.Icon, {
                                                                children: // Display "delete post" button only IF
                                                                // The post is already created (existing workers request) BUT empty
                                                                (existingPost && existingPost.missions.length === 0 && allPosts.length > 1 || // OR
                                                                // The post is added (draft post) on an existing workers request
                                                                isDraftPost && !isNewWorkersRequest || // OR
                                                                // The post is from a workers request which is not created (draft)
                                                                isNewWorkersRequest && allPosts.length > 1) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                                                                    className: "field",
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                                        color: "danger",
                                                                        size: 'small',
                                                                        onClick: ()=>{
                                                                            if (isExistingWorkersRequest && isExistingPost) // We are updating an existing workers request, the post already exists
                                                                            deletePostMutation.mutate({
                                                                                workersRequestId: workersRequest._id,
                                                                                postId: post._id
                                                                            });
                                                                            else // We are creating a new workers request, the post doesn't already exist
                                                                            // We only remove it from the form state
                                                                            arrayHelpers.remove(index);
                                                                        },
                                                                        type: "button",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {})
                                                                            }),
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                renderAs: "span",
                                                                                children: "Supprimer ce Poste"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                        pt: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                                children: [
                                                                    isDraftPost && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                        size: 2,
                                                                        children: isDraftPost && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                            label: 'Nombre',
                                                                            name: `posts.${index}.count`,
                                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                            min: 1,
                                                                            type: "number",
                                                                            required: true,
                                                                            fullwidth: "true"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                                label: "M\xe9tier",
                                                                                name: `posts.${index}.jobTitle`,
                                                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                                                required: true,
                                                                                fullwidth: "true",
                                                                                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(jobTitlesQuery.data || []),
                                                                                selectDefaultChooseOptionLabel: "M\xe9tier...",
                                                                                disabled: workersRequest && !workersRequest.__actions.requestedWorkersCanBeUpdated
                                                                            }),
                                                                            props.values.posts[index]?.jobTitle && jobTitlesQuery.data?.find((jT)=>jT._id.toString() === props.values.posts[index]?.jobTitle)?.complementaryInformations ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card), {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header, {
                                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Header.Title, {
                                                                                            children: "Infos transmises"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                                                        children: jobTitlesQuery.data.find((jT)=>jT._id.toString() === props.values.posts[index]?.jobTitle)?.complementaryInformations
                                                                                    })
                                                                                ]
                                                                            }) : undefined
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                            label: 'Cas de Recours',
                                                                            name: `posts.${index}.recourseCase.reason`,
                                                                            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                                            required: true,
                                                                            fullwidth: "true",
                                                                            // The actual value of the field is part of the available options
                                                                            options: $ad160ad756e27304$var$allRecourseCasesReasonsAsInputOptions,
                                                                            selectDefaultChooseOptionLabel: "Choisir un Cas de Recours",
                                                                            disabled: workersRequest && !workersRequest.__actions.requestedWorkersCanBeUpdated
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                            label: 'Justification',
                                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                            name: `posts.${index}.recourseCase.justification`,
                                                                            required: true,
                                                                            fullwidth: "true",
                                                                            disabled: workersRequest && !workersRequest.__actions.requestedWorkersCanBeUpdated
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                                        mb: 3,
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                mb: 2,
                                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                                    renderAs: "label",
                                                                                    className: "label",
                                                                                    children: "Cat\xe9gories"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fc203fc1bcc1621$export$2e2bcd8739ae039), {
                                                                                tags: props.values.posts[index]?.tags || [],
                                                                                formProps: {
                                                                                    onSubmit: (params)=>{
                                                                                        props.setFieldValue(`posts.${index}.tags`, params.tags);
                                                                                    },
                                                                                    onCancel: ()=>{},
                                                                                    dateRange: false
                                                                                },
                                                                                onTagDelete: (tagId)=>{
                                                                                    props.setFieldValue(`posts.${index}.tags`, props.values.posts[index]?.tags?.filter((tag)=>tag._id !== tagId));
                                                                                },
                                                                                isEditable: !workersRequest || workersRequest.__actions.requestedWorkersCanBeUpdated
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                        label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                            children: "Description du Poste pour l'Agence d'Int\xe9rim"
                                                                        }),
                                                                        component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039),
                                                                        name: `posts.${index}.description`,
                                                                        fullwidth: "true",
                                                                        disabled: workersRequest && !workersRequest.__actions.requestedWorkersCanBeUpdated
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ad160ad756e27304$var$DesiredWorkersField, {
                                                                        index: index,
                                                                        fieldName: `posts.${index}.desiredWorkers`,
                                                                        fieldValue: props.values.posts[index]?.desiredWorkers ?? [],
                                                                        employer: currentOrganization
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    isExistingPost && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer.Item, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                                            mutation: updatePostMutation,
                                                                            displayOn: {
                                                                                success: "Le poste a \xe9t\xe9 mis \xe0 jour"
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                                        mutation: updatePostMutation,
                                                                        color: "primary",
                                                                        type: "submit",
                                                                        disabled: isSubmitDisabled || !isPostUpdated,
                                                                        "data-test": `submit-workers-request-post-update-${index}-form`,
                                                                        children: "Mettre \xe0 jour le Poste"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    isExistingWorkersRequest && isDraftPost && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Footer.Item, {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                                                            mutation: createPostMutation,
                                                                            displayOn: {
                                                                                success: "Le poste a \xe9t\xe9 cr\xe9\xe9"
                                                                            }
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                                                        mutation: createPostMutation,
                                                                        color: "primary",
                                                                        type: "submit",
                                                                        disabled: isSubmitDisabled,
                                                                        "data-test": `submit-workers-request-post-create-${index}-form`,
                                                                        children: "Cr\xe9er le Poste"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            index === allPosts.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                        textAlign: "right",
                                                        color: "primary",
                                                        outlined: true,
                                                        onClick: ()=>{
                                                            arrayHelpers.push(structuredClone((0, $f629a449d8e7cdad$export$b0494023060b42ff)));
                                                        },
                                                        type: "button",
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$e718407ce256549d), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                renderAs: "span",
                                                                children: "Ajouter un Poste \xe0 Pourvoir"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }, key);
                                })
                            });
                        }
                    }),
                    isNewWorkersRequest && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                    mutation: createWorkersRequestMutation
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                mutation: createWorkersRequestMutation,
                                color: "primary",
                                type: "submit",
                                mr: 3,
                                style: {
                                    width: '100%'
                                },
                                disabled: isSubmitDisabled,
                                "data-test": "submit-workers-request-form",
                                children: 'Envoyer la Demande'
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var $ad160ad756e27304$export$2e2bcd8739ae039 = $ad160ad756e27304$var$WorkersRequestForm;
const $ad160ad756e27304$var$DesiredWorkersField = ({ index: index, fieldName: fieldName, fieldValue: fieldValue, employer: employer })=>{
    const { values: { interimAgency: interimAgency, meta: { resource: workersRequest } }, setFieldValue: setFieldValue } = (0, $31tXu.useFormikContext)();
    const workersQuery = (0, $e607e015ac40917d$export$ad43217ee1485bda)({
        interimAgency: interimAgency
    }, {
        enabled: Boolean(interimAgency)
    });
    const allWorkers = (workersQuery.data || []).filter((w)=>!(0, $25ffbf4bca475b04$export$a0936ca7c9219b40)(w, employer));
    const selectedWorkers = fieldValue.map((dWId)=>allWorkers?.find((w)=>w._id === dWId)).filter((w)=>!!w);
    const selectedItems = (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(selectedWorkers ?? [], {
        labelBuilder: (user)=>(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
        renderLabel: (user)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ad160ad756e27304$var$InputUserLabel, {
                user: user,
                employer: employer,
                interimAgencyId: interimAgency
            }),
        sortBy: null
    });
    const selectableWorkers = allWorkers?.filter((w)=>!fieldValue.some((dWId)=>dWId === w._id));
    const selectableItems = (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(selectableWorkers ?? [], {
        labelBuilder: (user)=>(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
        renderLabel: (user)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ad160ad756e27304$var$InputUserLabel, {
                user: user,
                employer: employer,
                interimAgencyId: interimAgency
            })
    });
    if (!interimAgency) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
        color: "warning",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
            children: "Vous n'avez pas encore s\xe9lectionn\xe9 une Agence d'Int\xe9rim."
        })
    });
    if (workersQuery.isFetched && !workersQuery.data?.[0]) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
        color: "warning",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("b", {
                    children: [
                        "Aucun ",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                        " \xe0 sugg\xe9rer"
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                "Vous n'avez pas encore collabor\xe9 avec des ",
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {
                    plural: true
                }),
                " via l'Agence d'Int\xe9rim s\xe9lectionn\xe9e"
            ]
        })
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                component: (0, $eda4e6b49e9c7d38$export$2e2bcd8739ae039),
                label: "Int\xe9rimaire(s) sugg\xe9r\xe9(s) pour ce poste",
                required: true,
                name: fieldName,
                items: selectedItems,
                fullwidth: "true",
                disabled: workersRequest && !workersRequest.__actions.canBeUpdated
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                initialValues: {
                    posts: Array.from({
                        length: index + 1
                    }).map(()=>({
                            desiredWorkers: undefined
                        }))
                },
                onSubmit: ()=>undefined,
                children: (props)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3207b9421765213$export$2e2bcd8739ae039), {
                                values: props.values.posts[index].desiredWorkers,
                                onChange: (desiredWorker)=>{
                                    if (desiredWorker) setFieldValue(fieldName, [
                                        ...fieldValue,
                                        desiredWorker
                                    ]);
                                }
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                items: selectableItems,
                                onlySelect: true,
                                name: fieldName,
                                clearOnSelect: true,
                                showItemsAfterSelect: true,
                                placeholder: "Choisir..."
                            })
                        ]
                    })
            })
        ]
    });
};
const $ad160ad756e27304$var$InputUserLabel = ({ user: user, employer: employer, interimAgencyId: interimAgencyId })=>{
    const laborCostCoefficientKind = interimAgencyId && (0, $25ffbf4bca475b04$export$1a30e0a3340758be)(user, interimAgencyId, employer);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
            laborCostCoefficientKind && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "small",
                children: [
                    ' ',
                    "-",
                    ' ',
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c5025698526f6ad2$export$2e2bcd8739ae039), {
                        laborCostCoefficientKind: laborCostCoefficientKind
                    })
                ]
            })
        ]
    });
};









const $3a1e90befefe2939$var$WorkersRequestsEdition = ({})=>{
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)((0, $b8c6247768bd4102$export$4a6f974b4208311)());
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const [searchParams] = (0, $d7b8f401c6bc9326$export$f1a78c17382fe22a)();
    const missionTemplateId = searchParams.get('missionTemplate') ?? undefined;
    const workersRequestTemplateId = searchParams.get('workersRequestTemplate') ?? undefined;
    const workersRequestId = Boolean(id) && !isNew && id || undefined;
    const { data: workersRequest } = (0, $b8c6247768bd4102$export$1a75acd08b8f614)(workersRequestId);
    const { data: missionTemplate } = (0, $e409591b67738e56$export$8940e75313b372c9)(missionTemplateId);
    const [workersRequestOfMissionTemplate] = (0, $b8c6247768bd4102$export$5dbb5ce56c96c45c)(missionTemplateId)?.data ?? [];
    const postOfWorkersRequestOfMissionTemplate = workersRequestOfMissionTemplate?.posts.find((p)=>p.missions.find((m)=>m._id === missionTemplateId));
    const { data: workersRequestTemplate } = (0, $b8c6247768bd4102$export$1a75acd08b8f614)(workersRequestTemplateId);
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($3a1e90befefe2939$var$formWrapperBaseProps, mutationState, !isNew);
    const breadcrumbs = $3a1e90befefe2939$var$useBreadcrumbs(isNew, id);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                ...formWrapperProps,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    breakpoint: 'desktop',
                    max: true,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                        items: breadcrumbs
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    align: "right",
                                    children: workersRequest && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $81fea641c7a956af$export$152934dff5a4cf0), {
                                        workersRequest: workersRequest
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                            alignItems: "flex-start",
                            mb: 6,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb022a992405465d$export$2e2bcd8739ae039), {
                                        workersRequest: workersRequest,
                                        isNew: isNew
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                    align: "right",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                        children: workersRequest && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0f4dda08c3931adc$export$2e2bcd8739ae039), {
                                            workersRequest: workersRequest,
                                            type: "tag"
                                        })
                                    })
                                })
                            ]
                        }),
                        workersRequest ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ad160ad756e27304$export$2e2bcd8739ae039), {
                            workersRequest: workersRequest
                        }) : missionTemplate && workersRequestOfMissionTemplate && postOfWorkersRequestOfMissionTemplate ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ad160ad756e27304$export$2e2bcd8739ae039), {
                            fromTemplate: {
                                mission: {
                                    ...missionTemplate,
                                    workersRequestOfMission: {
                                        ...workersRequestOfMissionTemplate,
                                        postOfMission: postOfWorkersRequestOfMissionTemplate
                                    }
                                }
                            }
                        }) : workersRequestTemplate ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ad160ad756e27304$export$2e2bcd8739ae039), {
                            fromTemplate: {
                                workersRequest: workersRequestTemplate
                            }
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ad160ad756e27304$export$2e2bcd8739ae039), {})
                    ]
                })
            })
        })
    });
};
var $3a1e90befefe2939$export$2e2bcd8739ae039 = $3a1e90befefe2939$var$WorkersRequestsEdition;
const $3a1e90befefe2939$var$formWrapperBaseProps = {
    loadingProps: {
        body: 'Enregistrement de la Demande...'
    },
    successProps: {
        title: "Demande cr\xe9\xe9e",
        body: {
            description: "La Demande a \xe9t\xe9 cr\xe9\xe9e, l'Agence d'int\xe9rim a \xe9t\xe9 Notifi\xe9e.",
            actions: [
                {
                    label: 'Nouvelle Demande'
                },
                {
                    label: "Retourner \xe0 la liste",
                    to: '/workers-requests'
                }
            ]
        }
    }
};
const $3a1e90befefe2939$var$useBreadcrumbs = (isNew, id)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const breadcrumbs = [
            {
                label: "Demandes d'Int\xe9rimaires",
                to: '/workers-requests'
            },
            {
                label: isNew ? "Nouvelle Demande d'Int\xe9rimaires" : `Modifier`
            }
        ];
        if (!isNew && id) breadcrumbs.splice(1, 0, {
            label: "Demande d'Int\xe9rimaires",
            to: `/workers-requests/${id}`
        });
        return breadcrumbs;
    }, [
        isNew,
        id
    ]);



parcelRequire("3ZYaX");








const $50d4fd76d5361237$var$MissionEdition = ()=>{
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: mission, isFetched: isFetched } = (0, $e409591b67738e56$export$8940e75313b372c9)(id);
    const breadcrumbs = $50d4fd76d5361237$var$useBreadcrumbs();
    if (!isNew && !isFetched) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: "desktop",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                    items: breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                align: "right"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "flex-start",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a3fff9dbe3c5b2d1$export$2e2bcd8739ae039), {
                                    mission: mission,
                                    organizationType: 'employer'
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                align: "right",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag).Group, {
                                    children: !isNew && mission !== undefined && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$2e2bcd8739ae039), {
                                        mission: mission,
                                        type: "tag"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ea7328dad92e2051$export$2e2bcd8739ae039), {
                                mission: mission
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $50d4fd76d5361237$export$2e2bcd8739ae039 = $50d4fd76d5361237$var$MissionEdition;
const $50d4fd76d5361237$var$useBreadcrumbs = ()=>{
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const baseCrumb = Object.freeze([
        {
            label: 'Liste des missions',
            to: '/missions'
        }
    ]);
    if (isNew) return [
        ...baseCrumb,
        {
            label: 'Nouvelle Mission Interne'
        }
    ];
    else return [
        ...baseCrumb,
        {
            label: `Mission`,
            to: `/missions/${id}`
        },
        {
            label: `Modifier`
        }
    ];
};




var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $abedb678041d2693$var$ClipboardCopyIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M8 2a1 1 0 000 2h2a1 1 0 100-2H8z"
    }), /*#__PURE__*/ $3ZYaX.createElement("path", {
        d: "M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5zM15 11h2a1 1 0 110 2h-2v-2z"
    }));
}
const $abedb678041d2693$var$ForwardRef = $3ZYaX.forwardRef($abedb678041d2693$var$ClipboardCopyIcon);
var $abedb678041d2693$export$2e2bcd8739ae039 = $abedb678041d2693$var$ForwardRef;



const $3b35b9893d35ab6f$export$b6953bf6479305bd = ()=>{
    const [copy, setCopy] = (0, $3ZYaX.useState)(false);
    (0, $3ZYaX.useEffect)(()=>{
        if (copy === true) navigator.clipboard.writeText('support@team-tim.fr');
    }, [
        copy
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: "medium",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: 'desktop',
                textAlign: 'center',
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        textColor: "primary",
                        children: "Un probl\xe8me avec TeamTim ?"
                    }),
                    "Notre support r\xe9pond dans les meilleurs d\xe9lais \xe0 vos demandes et questions.",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "TeamTim est une plateforme vivante, qui s'am\xe9liore chaque jour.",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "Tout retour de nos utilisateurs est pr\xe9cieux.",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                        pb: 5,
                        children: [
                            "Vous pouvez nous contacter via",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                centered: true,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                        kind: "addons",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                    type: "text",
                                                    value: "support@teamtim.fr",
                                                    textColor: "primary",
                                                    textWeight: "bold"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: 'primary',
                                                    onClick: ()=>setCopy(true),
                                                    children: copy ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                                children: "Copi\xe9"
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $abedb678041d2693$export$2e2bcd8739ae039), {})
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                                children: "Copier"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $3ZYaX = parcelRequire("3ZYaX");







parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");









const $87b77b69733dd3a2$var$PreBillingsFilters = ({})=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).preBillings);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...filters,
            start: filters.start ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(filters.start)) : undefined,
            end: filters.end ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(filters.end)) : undefined
        },
        onSubmit: (values)=>{
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).preBillings, {
                ...values,
                start: values.start ? (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.start) : undefined,
                end: values.end ? (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.end) : undefined
            });
        },
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).preBillings,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        pb: 1,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                name: "start",
                                label: "Du"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                name: "end",
                                label: "Au"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "R\xe9f\xe9rences de Facturation",
                                    name: "invoiceRef",
                                    component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                    options: [
                                        {
                                            label: 'Oui',
                                            value: true
                                        },
                                        {
                                            label: 'Non',
                                            value: false
                                        }
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $87b77b69733dd3a2$export$2e2bcd8739ae039 = $87b77b69733dd3a2$var$PreBillingsFilters;





const $d3de4d777df3a8ad$var$PreBillingsList = ()=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)(({ session: session })=>session.currentUserRole);
    const { filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).preBillings);
    const tableColumns = $d3de4d777df3a8ad$var$useListTableColumns(currentUserRole);
    const periodSummariesQuery = (0, $1517f26b22db4237$export$b81cd8e3169f70dc)({
        'createdAt>': filters.start || null,
        'createdAt<': filters.end || null,
        contractModel: 'threeParties',
        invoiceRef: filters.invoiceRef,
        interimAgency: filters.interimAgency,
        sort: '-createdAt'
    });
    const preBillings = periodSummariesQuery.data || [];
    const totalCost = preBillings.reduce((total, preBilling)=>total += preBilling.data.costs.total, 0);
    const action = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        textSize: 5,
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                children: "Total : "
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                children: [
                    "\xa0",
                    totalCost.toFixed(2),
                    " \u20AC"
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71db929d54fcb96$export$2e2bcd8739ae039), {
        title: "Liste des Pr\xe9-Facturations",
        subtitle: "Un Employeur g\xe9n\xe8re une Pr\xe9-facturation via son R\xe9capitulatif",
        action: action,
        filters: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $87b77b69733dd3a2$export$2e2bcd8739ae039), {}),
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
            columns: tableColumns,
            data: preBillings,
            noDataMessage: "Aucune pr\xe9-facturation \xe0 afficher"
        })
    });
};
var $d3de4d777df3a8ad$export$2e2bcd8739ae039 = $d3de4d777df3a8ad$var$PreBillingsList;
const $d3de4d777df3a8ad$var$useListTableColumns = (currentUserRole)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: '#',
                accessor: 'identifier',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                        resource: data.row.original,
                        path: "/pre-billings/",
                        label: data.row.original.identifier
                    })
            },
            {
                Header: currentUserRole === 'interimAgencyMember' ? 'Employeur' : 'Agence',
                accessor: currentUserRole === 'interimAgencyMember' ? 'employer' : 'interimAgency',
                Cell: (data)=>currentUserRole === 'interimAgencyMember' ? data.row.original.employer.name : data.row.original.interimAgency.name
            },
            {
                Header: "N\xb0 Facture",
                //@ts-ignore
                accessor: 'invoiceRef'
            },
            {
                Header: 'Semaine',
                //@ts-ignore
                accessor: 'period.week'
            },
            {
                Header: "Cr\xe9\xe9 le",
                accessor: 'createdAt',
                Cell: (data)=>(0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(data.row.original.createdAt)
            },
            {
                Header: "Co\xfbt",
                //@ts-ignore
                accessor: 'data.costs.total',
                //@ts-ignore
                Cell: (data)=>`${data.row.original.data.costs.total} \u{20AC}`
            }
        ], []);
};




var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");
function $bd85f1feb9b5c82a$var$UserIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    }));
}
const $bd85f1feb9b5c82a$var$ForwardRef = $3ZYaX.forwardRef($bd85f1feb9b5c82a$var$UserIcon);
var $bd85f1feb9b5c82a$export$2e2bcd8739ae039 = $bd85f1feb9b5c82a$var$ForwardRef;





const $2f888066d5badcfa$var$PreBillingPageTitle = ({ preBilling: preBilling, onInvoiceRefClick: onInvoiceRefClick })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
        title: preBilling.identifier,
        subTitle: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$45a25e33c6871670), {})
                        }),
                        preBilling.employer.name
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$ecf5f5308bcbb05e), {})
                        }),
                        preBilling.interimAgency.name
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5fda1783bb83f57b), {})
                        }),
                        (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(preBilling.createdAt)
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    mr: 5,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            mr: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bd85f1feb9b5c82a$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                            user: preBilling.createdBy
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        {
                            role: 'employerMember',
                            action: {
                                resource: 'periodSummaries',
                                name: 'create'
                            }
                        }
                    ],
                    children: preBilling.invoiceRef && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                        mr: 5,
                        renderAs: "a",
                        textColor: "link",
                        onClick: ()=>onInvoiceRefClick && onInvoiceRefClick(),
                        "data-tooltip": "Num\xe9ro de facture renseign\xe9",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                mr: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$15dc7213e90d1fda), {})
                            }),
                            preBilling.invoiceRef
                        ]
                    })
                })
            ]
        })
    });
};
var $2f888066d5badcfa$export$2e2bcd8739ae039 = $2f888066d5badcfa$var$PreBillingPageTitle;








var $2KSUA = parcelRequire("2KSUA");

var $3ZYaX = parcelRequire("3ZYaX");
//Start: the date of start of earliest work period
//End: the date of start of lastest work period
const $5b6469877cd21e8e$var$useMissionsStartAndEndDates = (missions)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const sortedDates = (0, $2KSUA.sortBy)(missions.flatMap((mission)=>mission.workPeriods.map((wp)=>wp.start.date)));
        return {
            start: sortedDates[0] || new Date(),
            end: sortedDates[sortedDates.length - 1] || new Date()
        };
    }, [
        missions
    ]);
var $5b6469877cd21e8e$export$2e2bcd8739ae039 = $5b6469877cd21e8e$var$useMissionsStartAndEndDates;




var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");



const $4d329df2d397885a$var$PreBillingEditForm = ({ preBilling: preBilling })=>{
    const updateMutation = (0, $1517f26b22db4237$export$cac0b33e6f13c8ec)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: preBilling,
        enableReinitialize: true,
        onSubmit: (values)=>{
            updateMutation.mutate({
                invoiceRef: values.invoiceRef,
                id: preBilling._id.toString()
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Num\xe9ro de facture",
                        name: "invoiceRef",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: updateMutation,
                        children: "Modifier"
                    })
                ]
            });
        }
    });
};
var $4d329df2d397885a$export$2e2bcd8739ae039 = $4d329df2d397885a$var$PreBillingEditForm;




/*
  TEMP HOOK: to be deleted when the summary table will be refactored and use directly data
  provided by sumlmary query
*/ 
var $3ZYaX = parcelRequire("3ZYaX");
var $259356633bc59fe3$exports = {};
var $b7271d72ee9493d6$exports = {};

var $6e57db185cdbc1fc$exports = {};



/** Built-in value references. */ var $6e57db185cdbc1fc$var$spreadableSymbol = $a9c2ecb930b20196$exports ? $a9c2ecb930b20196$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $6e57db185cdbc1fc$var$isFlattenable(value) {
    return $135874bbc3d3a66a$exports(value) || $dcc72e78add79d6a$exports(value) || !!($6e57db185cdbc1fc$var$spreadableSymbol && value && value[$6e57db185cdbc1fc$var$spreadableSymbol]);
}
$6e57db185cdbc1fc$exports = $6e57db185cdbc1fc$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b7271d72ee9493d6$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $6e57db185cdbc1fc$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b7271d72ee9493d6$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $1ff569082bd1ea92$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b7271d72ee9493d6$exports = $b7271d72ee9493d6$var$baseFlatten;


var $b7ab1f644785f0a7$exports = {};



var $69e07f482a6c22e7$exports = {};
var $110b552d224ddcf4$exports = {};
var $1e8e46a0ea81c201$exports = {};
var $0456685b5ea3394b$exports = {};
var $a3ad73ff446916e5$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $a3ad73ff446916e5$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$a3ad73ff446916e5$exports = $a3ad73ff446916e5$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0456685b5ea3394b$var$baseFor = $a3ad73ff446916e5$exports();
$0456685b5ea3394b$exports = $0456685b5ea3394b$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $1e8e46a0ea81c201$var$baseForOwn(object, iteratee) {
    return object && $0456685b5ea3394b$exports(object, iteratee, $e8b01e96a369de63$exports);
}
$1e8e46a0ea81c201$exports = $1e8e46a0ea81c201$var$baseForOwn;


var $2758ff4033870275$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $2758ff4033870275$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$b4272727fa799bca$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$2758ff4033870275$exports = $2758ff4033870275$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $110b552d224ddcf4$var$baseEach = $2758ff4033870275$exports($1e8e46a0ea81c201$exports);
$110b552d224ddcf4$exports = $110b552d224ddcf4$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $69e07f482a6c22e7$var$baseMap(collection, iteratee) {
    var index = -1, result = $b4272727fa799bca$exports(collection) ? Array(collection.length) : [];
    $110b552d224ddcf4$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$69e07f482a6c22e7$exports = $69e07f482a6c22e7$var$baseMap;


var $9063ef4957b6930f$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9063ef4957b6930f$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$9063ef4957b6930f$exports = $9063ef4957b6930f$var$baseSortBy;



var $7461859116724c80$exports = {};
var $5bb9ff6e5673cb64$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $5bb9ff6e5673cb64$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $5f14550a5524d769$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $5f14550a5524d769$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$5bb9ff6e5673cb64$exports = $5bb9ff6e5673cb64$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $7461859116724c80$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $5bb9ff6e5673cb64$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$7461859116724c80$exports = $7461859116724c80$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $b7ab1f644785f0a7$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $77bc8b86d18dfde8$exports(iteratees, function(iteratee) {
        if ($135874bbc3d3a66a$exports(iteratee)) return function(value) {
            return $033f926066b43cc0$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $9129b7f4ca819b48$exports
    ];
    var index = -1;
    iteratees = $77bc8b86d18dfde8$exports(iteratees, $aaeddef65e996a0f$exports($fd5568a8241be73a$exports));
    var result = $69e07f482a6c22e7$exports(collection, function(value, key, collection) {
        var criteria = $77bc8b86d18dfde8$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9063ef4957b6930f$exports(result, function(object, other) {
        return $7461859116724c80$exports(object, other, orders);
    });
}
$b7ab1f644785f0a7$exports = $b7ab1f644785f0a7$var$baseOrderBy;


var $3a44e1c37a075144$exports = {};

var $c20bf8b90a90431e$exports = {};
var $14ed7855010fe92a$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $14ed7855010fe92a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$14ed7855010fe92a$exports = $14ed7855010fe92a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c20bf8b90a90431e$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c20bf8b90a90431e$var$overRest(func, start, transform) {
    start = $c20bf8b90a90431e$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c20bf8b90a90431e$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $14ed7855010fe92a$exports(func, this, otherArgs);
    };
}
$c20bf8b90a90431e$exports = $c20bf8b90a90431e$var$overRest;


var $c3920ceeae3c9c8f$exports = {};
var $ce7e636d9dddb37c$exports = {};
var $ec895d4d4fe73e57$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $ec895d4d4fe73e57$var$constant(value) {
    return function() {
        return value;
    };
}
$ec895d4d4fe73e57$exports = $ec895d4d4fe73e57$var$constant;


var $af5ed0ae6bf53d5a$exports = {};

var $af5ed0ae6bf53d5a$var$defineProperty = function() {
    try {
        var func = $d6249531a9dae064$exports(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
$af5ed0ae6bf53d5a$exports = $af5ed0ae6bf53d5a$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ce7e636d9dddb37c$var$baseSetToString = !$af5ed0ae6bf53d5a$exports ? $9129b7f4ca819b48$exports : function(func, string) {
    return $af5ed0ae6bf53d5a$exports(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $ec895d4d4fe73e57$exports(string),
        'writable': true
    });
};
$ce7e636d9dddb37c$exports = $ce7e636d9dddb37c$var$baseSetToString;


var $4cd673128d5337cc$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $4cd673128d5337cc$var$HOT_COUNT = 800, $4cd673128d5337cc$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4cd673128d5337cc$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $4cd673128d5337cc$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $4cd673128d5337cc$var$nativeNow(), remaining = $4cd673128d5337cc$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $4cd673128d5337cc$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$4cd673128d5337cc$exports = $4cd673128d5337cc$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $c3920ceeae3c9c8f$var$setToString = $4cd673128d5337cc$exports($ce7e636d9dddb37c$exports);
$c3920ceeae3c9c8f$exports = $c3920ceeae3c9c8f$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3a44e1c37a075144$var$baseRest(func, start) {
    return $c3920ceeae3c9c8f$exports($c20bf8b90a90431e$exports(func, start, $9129b7f4ca819b48$exports), func + '');
}
$3a44e1c37a075144$exports = $3a44e1c37a075144$var$baseRest;


var $575bc90426cea3f6$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $575bc90426cea3f6$var$isIterateeCall(value, index, object) {
    if (!$2f639ab8f1a63700$exports(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $b4272727fa799bca$exports(object) && $b2e9ef4ce3991fa5$exports(index, object.length) : type == 'string' && index in object) return $8b43bb409bcd8608$exports(object[index], value);
    return false;
}
$575bc90426cea3f6$exports = $575bc90426cea3f6$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $259356633bc59fe3$var$sortBy = $3a44e1c37a075144$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $575bc90426cea3f6$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $575bc90426cea3f6$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $b7ab1f644785f0a7$exports(collection, $b7271d72ee9493d6$exports(iteratees, 1), []);
});
$259356633bc59fe3$exports = $259356633bc59fe3$var$sortBy;




/**
 * Checks if two work periods overlap on the same day
 */ const $cf4ed91fec0f2e21$var$workPeriodsOverlapSameDay = (wp1, wp2)=>{
    const date1 = new Date(wp1.start.date).setHours(0, 0, 0, 0);
    const date2 = new Date(wp2.start.date).setHours(0, 0, 0, 0);
    return date1 === date2;
};
const $cf4ed91fec0f2e21$export$edf151c789a1deb4 = (missions)=>{
    const missionGroups = missions.reduce((groups, mission)=>{
        const key = [
            mission.user?._id,
            mission.interimAgency?._id || 'noAgency',
            mission.employer._id
        ].join('_');
        if (!groups[key]) groups[key] = [];
        // Find or create a compatible subgroup
        let foundCompatibleGroup = false;
        for (const subgroup of groups[key]){
            const workPeriodsOverlap = mission.workPeriods.some((wp1)=>subgroup.workPeriods.some((wp2)=>$cf4ed91fec0f2e21$var$workPeriodsOverlapSameDay(wp1, wp2)));
            if (!workPeriodsOverlap) {
                // Add to existing compatible subgroup
                subgroup.workPeriods.push(...mission.workPeriods);
                subgroup.start = new Date(Math.min(new Date(subgroup.start).getTime(), new Date(mission.start).getTime()));
                subgroup.end = new Date(Math.max(new Date(subgroup.end).getTime(), new Date(mission.end).getTime()));
                subgroup.summary.weeks = {
                    ...subgroup.summary.weeks,
                    ...mission.summary.weeks
                };
                foundCompatibleGroup = true;
                break;
            }
        }
        if (!foundCompatibleGroup) // Create new subgroup
        groups[key].push({
            ...mission,
            workPeriods: [
                ...mission.workPeriods
            ]
        });
        return groups;
    }, {});
    // Flatten all subgroups
    return Object.values(missionGroups).flat().sort((a, b)=>new Date(a.start).getTime() - new Date(b.start).getTime());
};
const $cf4ed91fec0f2e21$var$useMissionsFromSummaryQuery = (data)=>{
    const summaryMinimalMode = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions].summaryMinimalMode);
    const missionsWithSummaries = (0, $3ZYaX.useMemo)(()=>{
        //@ts-ignore
        const reducedMissions = data.reduce(//@ts-ignore
        (missions, summaryItem)=>{
            if (summaryItem) return [
                ...missions,
                ...summaryItem.missions.map((mission)=>({
                        ...mission,
                        summary: summaryItem.totals,
                        weekSummary: summaryItem
                    }))
            ];
            return missions;
        }, []);
        if (summaryMinimalMode) return $cf4ed91fec0f2e21$export$edf151c789a1deb4(reducedMissions);
        else return reducedMissions;
    }, [
        data,
        summaryMinimalMode
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($259356633bc59fe3$exports)))(missionsWithSummaries, 'start') // TODO: refactor table to use summary data correctly
    ;
};
var $cf4ed91fec0f2e21$export$2e2bcd8739ae039 = $cf4ed91fec0f2e21$var$useMissionsFromSummaryQuery;



const $99caba60ef1a7ba9$var$PreBillingDetails = ({})=>{
    const { id: id } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const periodSummaryQuery = (0, $1517f26b22db4237$export$36ab29ab626f4c93)(id);
    const preBilling = periodSummaryQuery.data;
    const formModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const summaryQuery = (0, $e409591b67738e56$export$3c54b31350a650f7)({
        'workPeriods.periodSummary': id ? [
            id
        ] : [],
        week: preBilling?.period.week,
        year: preBilling?.period.year
    }, {
        enabled: Boolean(preBilling)
    });
    const missions = (0, $cf4ed91fec0f2e21$export$2e2bcd8739ae039)(summaryQuery.data?.users || []);
    const [tableCompactMode, setTableCompactMode] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(true);
    const { start: start, end: end } = (0, $5b6469877cd21e8e$export$2e2bcd8739ae039)(missions);
    const breadcrumbs = $99caba60ef1a7ba9$var$useBreadcrumbs();
    if (!preBilling) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                    items: breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level).Side, {
                                align: "right",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            {
                                                role: 'employerMember',
                                                action: {
                                                    resource: 'periodSummaries',
                                                    name: 'create'
                                                }
                                            }
                                        ],
                                        children: !preBilling.invoiceRef && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            color: 'success',
                                            mr: 2,
                                            onClick: ()=>formModal.setIsDisplayed(true),
                                            children: "Ajouter un num\xe9ro de facture"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b2d8c51042f4efd0$export$2e2bcd8739ae039), {
                                        filters: {
                                            'workPeriods.periodSummary': id ? [
                                                id
                                            ] : [],
                                            start: start,
                                            end: end
                                        },
                                        hideCustom: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "flex-start",
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2f888066d5badcfa$export$2e2bcd8739ae039), {
                                preBilling: preBilling,
                                onInvoiceRefClick: ()=>formModal.setIsDisplayed(true)
                            })
                        })
                    }),
                    preBilling && start && end && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $38062497b70ee6aa$export$2e2bcd8739ae039), {
                        startOfWeek: start,
                        endOfWeek: end,
                        interimAgencyId: preBilling.interimAgency._id,
                        totals: preBilling.data,
                        forceCompleteMode: true,
                        showEmployerCosts: true,
                        employerRules: summaryQuery.data?.employerRules
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                        className: "summary-table",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Card).Content, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                    onClick: ()=>setTableCompactMode(!tableCompactMode),
                                    mb: 2,
                                    size: 'small',
                                    children: [
                                        "Passer en mode ",
                                        tableCompactMode ? 'complet' : 'compact'
                                    ]
                                }),
                                summaryQuery.data && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1d9c847571156fe$export$2e2bcd8739ae039), {
                                    data: summaryQuery.data,
                                    start: start,
                                    end: end,
                                    displayDay: undefined,
                                    minimalMode: tableCompactMode,
                                    hideActions: true,
                                    forceEmployerRules: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            {
                                role: 'employerMember',
                                action: {
                                    resource: 'periodSummaries',
                                    name: 'create'
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                            actions: formModal,
                            title: `Ajouter un num\xe9ro de facture`,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4d329df2d397885a$export$2e2bcd8739ae039), {
                                preBilling: preBilling
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $99caba60ef1a7ba9$export$2e2bcd8739ae039 = $99caba60ef1a7ba9$var$PreBillingDetails;
const $99caba60ef1a7ba9$var$useBreadcrumbs = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: "Pr\xe9-Facturations",
                to: '/pre-billings'
            },
            {
                label: `Pr\xe9-Facturation`
            }
        ], []);




var $3ZYaX = parcelRequire("3ZYaX");



parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");





const $040c27da2bef4dd5$var$AcceptNewConditionForm = ({ type: type })=>{
    const mutation = (0, $e607e015ac40917d$export$cac0b33e6f13c8ec)();
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const { data: config } = (0, $ce5c6fedccfb7858$export$a8f49489fd1f338f)();
    const labels = {
        termsOfUse: {
            validation: "Merci d'accepter nos Conditions G\xe9n\xe9rales d'Utilisation.",
            fieldText: "Accepter les Conditions G\xe9n\xe9rales d'Utilisation."
        },
        privacyPolicy: {
            validation: "Merci d'accepter notre Politique de Confidentialit\xe9",
            fieldText: "Accepter la Politique de Confidentialit\xe9"
        }
    };
    const onSubmit = ()=>{
        if (!currentUser || !config) return;
        const payload = {
            id: currentUser?._id
        };
        if (type === 'termsOfUse') payload.lastTermsOfUseVersionRead = config.versions.termsOfUse;
        if (type === 'privacyPolicy') payload.lastPrivacyPolicyVersionRead = config.versions.privacyPolicy;
        mutation.mutate(payload);
    };
    if (!currentUser) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            accepted: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.accepted) errors.accepted = labels[type].validation;
            return errors;
        },
        onSubmit: onSubmit,
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 5,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            text: labels[type].fieldText,
                            name: "accepted",
                            component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                            options: [
                                {
                                    label: 'Accepter'
                                }
                            ],
                            "data-test": "accept",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                        mt: 5,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                    mutation: mutation
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                    color: "primary",
                                    type: "submit",
                                    mutation: mutation,
                                    children: "Accepter"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $040c27da2bef4dd5$export$2e2bcd8739ae039 = $040c27da2bef4dd5$var$AcceptNewConditionForm;



const $05851b9543b5f38b$export$d5a29154259e944d = ()=>{
    const legalConditionsState = (0, $159097eb2ce85c11$export$2e2bcd8739ae039)();
    const privacyPolicyIsOutdated = legalConditionsState.privacyPolicy === 'outdated';
    const [showPrivacyPolicyIsOutdatedBanner, setShowPrivacyPolicyIsOutdatedBanner] = (0, $3ZYaX.useState)(false);
    (0, $3ZYaX.useEffect)(()=>{
        if (privacyPolicyIsOutdated === true) setShowPrivacyPolicyIsOutdatedBanner(true);
    }, [
        privacyPolicyIsOutdated
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        hideHeader: privacyPolicyIsOutdated,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: "medium",
            mobile: {
                textSize: 7
            },
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: 'desktop',
                children: [
                    showPrivacyPolicyIsOutdatedBanner && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
                        show: true,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Content, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                                color: 'warning',
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                                        children: "La Politique de Confidentialit\xe9 de TeamTim a \xe9t\xe9 mise \xe0 jour."
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                        p: 5,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "p",
                                            children: [
                                                "Merci de la consulter et de l'accepter pour continuer \xe0 utiliser TeamTim.",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    textAlign: 'center',
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                        "data-test": "continue",
                                                        type: "button",
                                                        color: 'primary',
                                                        mt: 5,
                                                        onClick: ()=>setShowPrivacyPolicyIsOutdatedBanner(false),
                                                        children: "Continuer"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        textColor: "primary",
                        children: "Politique de confidentialit\xe9"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        className: "content",
                        my: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "La pr\xe9sente Politique de confidentialit\xe9 vous informe sur la mani\xe8re dont",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " collecte et traite via son site ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "app.teamtim.fr"
                                    }),
                                    ' ',
                                    "et l'application iOS et Android ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "TeamTIM"
                                    }),
                                    " les donn\xe9es personnelles vous concernant en qualit\xe9 de responsable de traitement au sens des dispositions du R\xe8glement G\xe9n\xe9ral sur la Protection des Donn\xe9es personnelles n\xb02016/679 du 27 avril 2016 (\xab ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "RGPD"
                                    }),
                                    " \xbb) et la loi dite ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                        children: "informatique et libert\xe9s"
                                    }),
                                    ' ',
                                    "n\xb078-17 du 6 janvier 1978 (ci-apr\xe8s d\xe9nomm\xe9s ensemble la \xab",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "R\xe8glementation"
                                    }),
                                    " \xbb)."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Les D\xe9finitions issues du RGPD"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Les d\xe9finitions suivantes sont celles issues du R\xe8glement G\xe9n\xe9ral sur la Protection des Donn\xe9es n\xb02016/679 du 27 avril 2016 (RGPD) et de la Loi dite \xab Informatique et Libert\xe9s \xbb n\xb078-17 du 6 janvier 1978."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "DONN\xc9E PERSONNELLE"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Une donn\xe9e personnelle est toute information se rapportant \xe0 une personne physique identifi\xe9e ou identifiable. Cette personne peut \xeatre identifi\xe9e directement (exemple : nom et pr\xe9nom) ou indirectement (exemple : par un num\xe9ro de t\xe9l\xe9phone ou de plaque d\u2019immatriculation, un identifiant tel que le num\xe9ro de s\xe9curit\xe9 sociale, une adresse postale ou courriel, mais aussi la voix ou l\u2019image), gr\xe2ce \xe0 une seule donn\xe9e ou au croisement de plusieurs d\u2019entre elles (exemple : une femme vivant \xe0 telle adresse, n\xe9e tel jour et membre dans telle association)."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "DESTINATAIRE"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "La personne physique ou morale, l\u2019autorit\xe9 publique, le service ou tout autre organisme habilit\xe9 \xe0 obtenir communication de donn\xe9es enregistr\xe9es dans un fichier ou un traitement en raison de ses fonctions."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "FICHIER"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Un fichier est un traitement de donn\xe9es qui s'organise dans un ensemble stable et structur\xe9 de donn\xe9es. Les donn\xe9es d'un fichier sont accessibles selon des crit\xe8res d\xe9termin\xe9s."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "RESPONSABLE DE TRAITEMENT"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Le responsable de traitement est la personne morale (entreprise, commune, etc.) ou physique qui d\xe9termine les finalit\xe9s et les moyens d\u2019un traitement, c\u2019est \xe0 dire l\u2019objectif et la fa\xe7on de le r\xe9aliser. En pratique et en g\xe9n\xe9ral, il s\u2019agit de la personne morale incarn\xe9e par son repr\xe9sentant l\xe9gal."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "SOUS-TRAITANT"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Le sous-traitant est la personne physique ou morale (entreprise ou organisme public) qui traite des donn\xe9es pour le compte d\u2019un autre organisme (\xab le responsable de traitement \xbb), dans le cadre d\u2019un service ou d\u2019une prestation."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "TRAITEMENT"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Un traitement de donn\xe9es personnelles est une op\xe9ration, ou ensemble d\u2019op\xe9rations, portant sur des donn\xe9es personnelles, quel que soit le proc\xe9d\xe9 utilis\xe9 (collecte, enregistrement organisation, conservation, adaptation, modification, extraction consultation, utilisation, communication par transmission ou diffusion ou toute autre forme de mise \xe0 disposition, rapprochement)."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Un traitement de donn\xe9es personnelles n\u2019est pas n\xe9cessairement informatis\xe9 : les fichiers papier sont \xe9galement concern\xe9s et doivent \xeatre prot\xe9g\xe9s dans les m\xeames conditions."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Un traitement de donn\xe9es doit avoir un objectif, une finalit\xe9 d\xe9termin\xe9e pr\xe9alablement au recueil des donn\xe9es et \xe0 leur exploitation."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Qui est responsable des traitements des donn\xe9es personnelles effectu\xe9s au moyen du Site ?"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Il s\u2019agit de la soci\xe9t\xe9 ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " (ci-apr\xe8s \xab\u202F",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    "\u202F\xbb ou la \xab\u202FSoci\xe9t\xe9\u202F\xbb ou \xab\u202FNous\u202F\xbb), est une soci\xe9t\xe9 par actions simplifi\xe9e dont le si\xe8ge social est situ\xe9 : ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "70 rue Elie CARTAN, 62220 CARVIN"
                                    }),
                                    ", repr\xe9sent\xe9e par",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "Christophe FANDI"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "A chaque fois que ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " aura d\xe9termin\xe9 les finalit\xe9s de traitement de vos donn\xe9es personnelles ainsi que les moyens de traitement utilis\xe9s, elle sera qualifi\xe9e de responsable de traitement et endossera l\u2019ensemble des obligations que la R\xe8glementation met \xe0 sa charge."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Un interlocuteur privil\xe9gi\xe9 en mati\xe8re de protection des donn\xe9es peut \xeatre contacter \xe0 l\u2019adresse suivante\u202F: ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "support@teamtim.fr"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Comment vos donn\xe9es personnelles sont-elles collect\xe9es\u202F? "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Nous collectons les Donn\xe9es personnelles que vous Nous communiquez directement"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Il s\u2019agit des Donn\xe9es personnelles que vous Nous communiquez directement en r\xe9pondant \xe0 nos formulaires de collecte, notamment ceux disponibles en ligne sur notre Site (notamment\u202F: nom, adresse mail\u2026). Il s\u2019agit de Donn\xe9es de contact ainsi que toute autre information que vous souhaitez porter \xe0 notre connaissance."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Il peut \xe9galement s\u2019agir des donn\xe9es que vous nous communiquez spontan\xe9ment en prenant contact avec nos \xe9quipes."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Enfin, nous traitons \xe9galement les donn\xe9es que vous Nous communiquez \xe0 l\u2019occasion de nos \xe9changes (au cours d\u2019un \xe9change t\xe9l\xe9phonique au lors d\u2019une d\xe9monstration de notre logiciel par exemple)."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Les donn\xe9es ainsi collect\xe9es par ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " sont soit obligatoires soit facultatives. Le caract\xe8re obligatoire est identifi\xe9 au sein de chacun des formulaires par un ast\xe9risque pour chacun des champs concern\xe9s. Lorsque les donn\xe9es sont collect\xe9es oralement, nous vous pr\xe9ciserons le caract\xe8re obligatoire ou facultatif des informations. L\u2019ensemble des donn\xe9es que vous Nous communiquez spontan\xe9ment sont, par d\xe9finition, facultatives."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Nous collectons certaines de vos Donn\xe9es personnelles de mani\xe8re automatique :"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Lorsque vous consultez le Site, des donn\xe9es sont enregistr\xe9es automatiquement\u202Fvia vos traces de navigation sur notre Site soit\u202F:"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Indirectement par le biais de cookies tiers,",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Directement au moyen des journaux d\u2019\xe9v\xe8nements du serveur (les fichiers log) par les personnes en charge de la gestion du Site (soit au sein de la Soci\xe9t\xe9 soit en qualit\xe9 de prestataire informatique). ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Il s\u2019agit de vos Donn\xe9es de navigation. "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Lorsque la collecte de ces Donn\xe9es de navigation a un caract\xe8re obligatoire, elles sont collect\xe9es afin d\u2019assurer la mise \xe0 disposition du Site, son am\xe9lioration et le maintien d\u2019un environnement s\xe9curis\xe9."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Lorsque la collecte est facultative, votre accord est pr\xe9alablement recueilli pour les Donn\xe9es de navigation utilis\xe9es",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                        children: "(liste \xe0 modifier en fonction des cookies effectivement utilis\xe9s sur le site et leur finalit\xe9)"
                                    }),
                                    ' ',
                                    "pour mesurer l\u2019audience de notre Site et la performance de nos campagnes, optimiser la gestion des prospects, analyser votre comportement d\u2019internaute et/ou pour augmenter l\u2019interactivit\xe9 de notre Site et vous proposer de la publicit\xe9 cibl\xe9e."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Il peut s\u2019agir notamment : "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                        children: "Des donn\xe9es relatives \xe0 votre connexion au Site :"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Par exemple, votre adresse IP, l\u2019adresse du site internet que vous visitez, votre moteur de recherche ainsi que ses param\xe8tres, la date et l\u2019heure de la connexion, la mani\xe8re dont vous naviguez sur le Site ainsi que toutes les autres donn\xe9es de suivi de l\u2019utilisation que vous faites du Site."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                        children: [
                                            "Des donn\xe9es relatives \xe0 l\u2019\xe9quipement qui vous permet d\u2019acc\xe9der au Site :",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: " "
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Selon l\u2019\xe9quipement que vous utilisez et les param\xe8tres activ\xe9s, les donn\xe9es suivantes peuvent notamment \xeatre collect\xe9es : le type d\u2019\xe9quipement (t\xe9l\xe9phone mobile, tablette, PC, MAC, etc.) et le syst\xe8me d\u2019exploitation que vous utilisez ainsi que leurs param\xe8tres."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Dans quel but et pendant combien de temps utilisons-nous vos donn\xe9es personnelles ?"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Nous utilisons vos Donn\xe9es pour les finalit\xe9s suivantes expos\xe9es au sein du tableau ci-dessous."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Ces Donn\xe9es sont collect\xe9es dans l\u2019un des cas pr\xe9vus par la R\xe9glementation \xe0 savoir les bases l\xe9gales suivantes :"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "L\u2019ex\xe9cution d\u2019un contrat auquel vous \xeates partie ou de mesures pr\xe9contractuelles vous concernant,"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Le respect d\u2019une obligation l\xe9gale, "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Votre consentement \xe0 l\u2019utilisation de vos Donn\xe9es, "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Notre int\xe9r\xeat l\xe9gitime \xe0 utiliser vos Donn\xe9es."
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous trouverez ci-dessous les informations d\xe9taill\xe9es concernant les traitements r\xe9alis\xe9s via le Site",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                        children: "(il s\u2019agit d\u2019une liste indicative, \xe0 adapter en fonction des donn\xe9es collect\xe9es sur le site)"
                                    }),
                                    ' ',
                                    ":"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                                className: "table-container",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("table", {
                                    className: "table",
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                            children: "Nom du traitement"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                            children: "Finalit\xe9s"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                            children: "Base(s) l\xe9gale(s)"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                            children: "Donn\xe9es concern\xe9es"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                            children: "Dur\xe9e de conservation"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Formulaires du Site "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Traiter votre demande et vous fournir les informations ou les services demand\xe9s."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "Le traitement est n\xe9cessaire \xe0 la poursuite de l\u2019int\xe9r\xeat l\xe9gitime de",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "FANDI"
                                                            }),
                                                            " \xe0 g\xe9rer ses interactions avec le public (clients et prospects) et lui permettre de r\xe9pondre aux demandes qui lui sont adress\xe9es."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es relatives \xe0 la vie professionnelle\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Autre (contenu des correspondances par exemple). "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 3 ans \xe0 compter du dernier contact en base active puis archiv\xe9es \xe0 titre probatoire pendant 5 ans."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                                children: "Recrutement"
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                                children: " "
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "\xc9tudier et g\xe9rer les candidatures."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "Le traitement est n\xe9cessaire \xe0 l\u2019ex\xe9cution des mesures pr\xe9contractuelles et \xe0 l\u2019\xe9tablissement de la relation contractuelle entre ",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "FANDI"
                                                            }),
                                                            " et les candidats \xe0 un emploi ou \xe0 un stage."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Informations figurant dans le curriculum vitae, courriers et courriels transmis par les candidats, dates d\u2019entretiens, positionnement salarial, suites donn\xe9es \xe0 la candidature, type et dur\xe9e de contrat propos\xe9."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 2 ans \xe0 compter du dernier contact. "
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Organisation d\u2019\xe9v\xe8nements "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Gestion de l\u2019organisation d\u2019\xe9v\xe8nements en ce compris l\u2019envoi d\u2019invitations, suivi des inscriptions, suivi de la satisfaction, gestion des questions et demandes formul\xe9es au cours des \xe9v\xe8nements."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "Le traitement est n\xe9cessaire \xe0 la poursuite de l\u2019int\xe9r\xeat l\xe9gitime de",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "FANDI"
                                                            }),
                                                            " \xe0 promouvoir et am\xe9liorer ses \xe9v\xe8nements aupr\xe8s d\u2019un public de professionnels et d\u2019organiser ces \xe9v\xe8nements."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es relatives \xe0 l\u2019inscription et \xe0 la participation aux \xe9v\xe8nements ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "\xc9changes relatifs \xe0 l\u2019organisation des interventions et \xe9v\xe8nements."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 3 ans \xe0 compter du dernier contact en base active puis archiv\xe9es \xe0 titre probatoire pendant 5 ans."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("i", {
                                                            children: [
                                                                "Gestion du site internet de ",
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                    children: "FANDI"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Administration technique du Site (maintenance, h\xe9bergement,)\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "S\xe9curisation du Site\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Am\xe9lioration de l\u2019exp\xe9rience utilisateur ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Production de statistiques d\u2019audience et d\u2019utilisation des services."
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: " "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                            children: [
                                                                "Le traitement est n\xe9cessaire \xe0 la poursuite de l\u2019int\xe9r\xeat l\xe9gitime de",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                    children: "FANDI"
                                                                }),
                                                                " de g\xe9rer son site vitrine et le mettre \xe0 disposition de mani\xe8re s\xe9curis\xe9e ;"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Consentement pour les cookies tiers."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es relatives \xe0 la navigation sur le site (horodatage, adresse IP, donn\xe9es techniques relatives \xe0 l\u2019\xe9quipement et au navigateur utilis\xe9s, cookies) et sur les plateformes num\xe9riques via des boutons de partage et des m\xe9dias (cookies et autres traceurs) ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es relatives \xe0 la gestion des contacts (horodatage et objet de la demande, suivi, suites apport\xe9es, statistiques) ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Statistiques d\u2019audience."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "13 mois "
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Gestion de la prospection "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Gestion d\u2019op\xe9rations techniques de prospection\u202F; "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "S\xe9lection de personnes pour r\xe9aliser des actions de fid\xe9lisation, de prospection, de sondage, de test produit et de promotion\u202F;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "R\xe9alisation d\u2019op\xe9rations de sollicitations\u202F; "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "Le traitement est n\xe9cessaire \xe0 la poursuite d\u2019un int\xe9r\xeat l\xe9gitime de",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "FANDI"
                                                            }),
                                                            " \xe0 promouvoir son activit\xe9 et ses services aupr\xe8s de professionnels."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es relatives \xe0 la vie professionnelle."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 3 ans \xe0 compter du dernier contact en base active puis archiv\xe9es \xe0 titre probatoire pendant 5 ans."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Gestion de la communication "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "R\xe9aliser les campagnes d\u2019information au sujet des actualit\xe9s de",
                                                            ' ',
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "FANDI"
                                                            }),
                                                            " (\xe9volution des produits, mises \xe0 jour, \xe9v\xe8nements, distinction)."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                            children: [
                                                                "Int\xe9r\xeat l\xe9gitime (communiquer \xe0 propos des services et produits de",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                    children: "FANDI"
                                                                }),
                                                                ", \xe9tendre sa client\xe8le)."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: " "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Donn\xe9es d\u2019identit\xe9 et de contact."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 3 ans \xe0 compter du dernier contact en base active puis archiv\xe9es \xe0 titre probatoire pendant 5 ans."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Fichier clients "
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Gestion de la relation commerciale avec les clients concernant les contrats ; les devis\u202F; les commandes ; les factures ; la comptabilit\xe9 et en particulier la gestion des comptes clients ; le suivi de la relation client tel que la r\xe9alisation d\u2019enqu\xeates de satisfaction, la gestion des r\xe9clamations et du service apr\xe8s-vente ; la s\xe9lection de clients pour r\xe9aliser des \xe9tudes, sondages et tests produits."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                            children: [
                                                                "Le traitement est n\xe9cessaire \xe0 la poursuite de l\u2019int\xe9r\xeat l\xe9gitime de",
                                                                ' ',
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                    children: "FANDI"
                                                                }),
                                                                " \xe0 g\xe9rer son activit\xe9 et ses relations contractuelles et commerciales."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                            children: [
                                                                "Lorsque le professionnel est une personne physique assimil\xe9e \xe0 un consommateur au regard du droit de la consommation, le traitement est fond\xe9 sur l\u2019ex\xe9cution du contrat entre ",
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                    children: "FANDI"
                                                                }),
                                                                " et ce professionnel ou \xe0 la prise de mesures pr\xe9contractuelles \xe0 sa demande."
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("td", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es d\u2019identit\xe9 et de contact ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Informations relatives \xe0 la vie professionnelles ;"
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Donn\xe9es \xe9conomiques et financi\xe8res."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Les donn\xe9es sont conserv\xe9es 3 ans \xe0 compter de la fin de la relation contractuelle en base active puis archiv\xe9es \xe0 titre probatoire pendant 5 ans."
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("i", {
                                                            children: "Gestion newsletter"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Adresser r\xe9guli\xe8rement la newsletter aux inscrits."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Consentement"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Adresse mail"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                        children: "Le temps de l\u2019inscription de la personne \xe0 la newsletter (d\xe9sinscription possible via le lien de d\xe9sinscription int\xe9gr\xe9 aux newsletters)."
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Si vous avez d\xe9pos\xe9 une candidature spontan\xe9e sur le Site et que celle-ci n\u2019a pas \xe9t\xe9 retenue, nous vous contacterons afin de vous demander si vous souhaitez que nous conservions vos donn\xe9es personnelles en vue de vous proposer ult\xe9rieurement un autre poste ou si vous souhaitez que ces derni\xe8res soient d\xe9truites. En tout \xe9tat de cause, vos donn\xe9es personnelles seront automatiquement d\xe9truites 2 ans apr\xe8s votre dernier contact avec ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Les donn\xe9es concernant les pi\xe8ces d\u2019identit\xe9 relatives \xe0 l\u2019exercice des droits d\u2019acc\xe8s, de rectification, de suppression, de limitation, d\u2019effacement et de portabilit\xe9 sont conserv\xe9es durant 1 an \xe0 compter de leur r\xe9ception."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Dans l\u2019hypoth\xe8se d\u2019une proc\xe9dure judiciaire, les donn\xe9es personnelles vous concernant seront conserv\xe9es afin de permettre \xe0 ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " d\u2019assurer la d\xe9fense de ses int\xe9r\xeats."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "A qui sont destin\xe9es vos donn\xe9es personnelles\u202F? "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Au sein de FANDI"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Que ce soit sous forme individuelle ou agr\xe9g\xe9e, vos Donn\xe9es personnelles sont trait\xe9es par les collaborateurs de ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Dans tous les cas, seules les donn\xe9es strictement n\xe9cessaires \xe0 la r\xe9alisation du traitement vis\xe9 sont transmises aux seuls collaborateurs habilit\xe9s \xe0 en conna\xeetre du fait de leurs fonctions. Toutes les personnes susceptibles d\u2019avoir acc\xe8s \xe0 vos Donn\xe9es personnelles sont soumises par contrat \xe0 une obligation de confidentialit\xe9."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Au cas particulier, ont seuls acc\xe8s \xe0 vos Donn\xe9es personnelles\u202F: "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Les repr\xe9sentant l\xe9gaux de ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "FANDI"
                                                }),
                                                "\u202F;"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Le responsable commercial de ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "FANDI"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Votre gestionnaire de compte client\u202F; "
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Les membres de ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "FANDI"
                                                }),
                                                " en charge d\u2019op\xe9rations techniques li\xe9es \xe0 l\u2019exercice des droits des personnes."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Transferts hors FANDI"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Plusieurs cat\xe9gories de tiers vis\xe9s ci-dessous sont susceptibles d\u2019avoir acc\xe8s \xe0 vos Donn\xe9es personnelles. Seules les Donn\xe9es personnelles strictement n\xe9cessaires leurs sont transmises pour la ou les finalit\xe9s poursuivies par le traitement envisag\xe9."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Les sous-traitants dont notamment nos Prestataires : "
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                            children: "Informatiques : "
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                                        children: "En charge de l\u2019administration, de l\u2019h\xe9bergement et de la maintenance du Site"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                                        children: [
                                                                            "MICROSOFT pour l\u2019utilisation d\u2019Office 365 en ce compris les prestations de messagerie informatique (",
                                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                                                                href: "https://privacy.microsoft.com/fr-fr/privacystatement",
                                                                                children: "https://privacy.microsoft.com/fr-fr/privacystatement"
                                                                            }),
                                                                            "),"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                                        children: "De fourniture de solution CRM "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                                        children: "De fourniture d\u2019outils d\u2019analyse et de publicit\xe9 (Google Analytics)"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                                        children: [
                                                            "Prestataires ",
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                                children: "marketing"
                                                            }),
                                                            " (agence marketing et gestion de r\xe9f\xe9rencement, solution d\u2019enrichissement et de validation de contacts professionnels)"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Nous nous assurons qu\u2019en mati\xe8re de Donn\xe9es personnelles, ces sous-traitants s\u2019engagent contractuellement \xe0 mettre en \u0153uvre des niveaux de protection \xe9quivalents aux n\xf4tres et en tout \xe9tat de cause, conformes \xe0 la R\xe9glementation."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: "Les soci\xe9t\xe9s fournissant les cookies tiers auxquels vous donnez votre consentement pour leur installation (cf politique de cookies)."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "De mani\xe8re exceptionnelle, les autorit\xe9s comp\xe9tentes (administratives, judiciaires, de police) en raison d\u2019une obligation l\xe9gale ou pour garantir les droits, les biens ou la s\xe9curit\xe9 de ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "FANDI"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " s\u2019engage \xe0 ne pas transmettre vos Donn\xe9es personnelles \xe0 des tiers sauf si :"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ol", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                        children: "Vous avez donn\xe9 votre accord pr\xe9alable pour le partage de vos Donn\xe9es personnelles avec des tiers,"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ol", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                        children: "Le partage de vos Donn\xe9es personnelles avec ledit tiers est n\xe9cessaire \xe0 la fourniture des produits ou services sollicit\xe9s,"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ol", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                        children: [
                                            "Une autorit\xe9 judiciaire ou administrative comp\xe9tente exige que",
                                            ' ',
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "FANDI"
                                            }),
                                            " lui communique lesdites Donn\xe9es personnelles."
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Transfert hors UE"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "A ce jour, Nous n\u2019op\xe9rons aucun transfert de vos Donn\xe9es en dehors de l\u2019Union europ\xe9enne."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Toutefois, soucieux de la s\xe9curit\xe9 et de la confidentialit\xe9 de vos Donn\xe9es, Nous vous informons que dans l\u2019\xe9ventualit\xe9 o\xf9 vos Donn\xe9es seraient transf\xe9r\xe9es hors UE, nous nous engageons \xe0 soumettre tous nos prestataires \xe0 une obligation de confidentialit\xe9 et \xe0 ce que tous les \xe9ventuels transferts s\u2019effectuent \xe0 destination :"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Soit d\u2019un pays reconnu par la Commission europ\xe9enne comme assurant un niveau de protection ad\xe9quat\u202F;",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Soit vers un pays n\u2019offrant pas de protection ad\xe9quate mais dont le transfert est permis en application de la r\xe9glementation applicable notamment car encadr\xe9 par les clauses contractuelles types de la Commission europ\xe9enne dont la CNIL a pr\xe9alablement reconnu qu'elles permettent de garantir un niveau de protection suffisant de la vie priv\xe9e et des droits fondamentaux des personnes.",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Quels sont vos droits concernant vos donn\xe9es personnelles\u202F?"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit d\u2019acc\xe8s "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous avez le droit d\u2019obtenir de ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " la confirmation que des donn\xe9es personnelles vous concernant sont ou ne sont pas trait\xe9es. Dans l\u2019hypoth\xe8se, o\xf9 les donn\xe9es sont trait\xe9es, vous avez un droit d\u2019acc\xe8s \xe0 ces donn\xe9es et aux informations suivantes :"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "a. les finalit\xe9s du traitement ; "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "b. les cat\xe9gories de donn\xe9es personnelles concern\xe9es ; "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "c. les destinataires ou cat\xe9gories de destinataires auxquels les donn\xe9es ont \xe9t\xe9 communiqu\xe9es ou vont \xeatre communiqu\xe9es ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "d. la dur\xe9e de conservation envisag\xe9e des donn\xe9es si cela est possible, ou lorsque ce n\u2019est pas possible, les crit\xe8res utilis\xe9s pour d\xe9terminer cette dur\xe9e ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "e. le droit de demander \xe0 ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " la rectification ou l\u2019effacement des donn\xe9es vous concernant, la limitation du traitement ou le droit de vous opposer au traitement"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "f. le droit d\u2019introduire une r\xe9clamation aupr\xe8s de la CNIL ; "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "g. lorsque les donn\xe9es personnelles ne sont pas collect\xe9es aupr\xe8s de vous directement, toute information disponible sur la source ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "h. l\u2019existence d\u2019une prise de d\xe9cision automatis\xe9e, y compris le profilage et, au moins en pareils cas, des informations utiles concernant la logique sous-jacente, ainsi que l\u2019importance et les cons\xe9quences pr\xe9vues de ce traitement pour vous."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Enfin lorsque les donn\xe9es personnelles sont transf\xe9r\xe9es vers un pays tiers ou une organisation internationale, vous avez le droit d\u2019\xeatre inform\xe9 des garanties appropri\xe9es concernant le transfert."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " vous fournira sur demande une copie des donn\xe9es faisant l\u2019objet du traitement. Elle pourra exiger le paiement de frais raisonnables bas\xe9s sur les co\xfbts administratifs de toute copie suppl\xe9mentaire que vous demanderiez."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Si vous demandez une copie des donn\xe9es par la voie \xe9lectronique,",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " les fournira sous une forme \xe9lectronique d\u2019usage courant \xe0 moins que vous demandiez qu\u2019il en soit autrement. Enfin, le droit d\u2019obtenir une copie des donn\xe9es personnelles ne doit pas porter atteinte aux droits et libert\xe9s d\u2019autrui."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit de rectification "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous disposez de la facult\xe9 de demander \xe0 ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " de rectifier vos donn\xe9es qui seraient inexactes, dans les meilleurs d\xe9lais. Vous disposez aussi de la facult\xe9 d\u2019obtenir que les donn\xe9es personnelles incompl\xe8tes vous concernant soient compl\xe9t\xe9es y compris en fournissant une d\xe9claration suppl\xe9mentaire."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit \xe0 l\u2019effacement "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous disposez du droit \xe0 l\u2019effacement de vos donn\xe9es personnelles dans les meilleurs d\xe9lais lorsque l\u2019un des motifs suivants s\u2019applique :"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "a. Les donn\xe9es personnelles ne sont plus n\xe9cessaires au regard des finalit\xe9s pour lesquelles elles ont \xe9t\xe9 collect\xe9es ou trait\xe9es d\u2019une autre mani\xe8re ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "b. Vous retirez votre consentement sur lequel est fond\xe9 le traitement et il n\u2019existe pas d\u2019autre fondement juridique au traitement concern\xe9. Le retrait du consentement vaut pour l\u2019avenir ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "c. Vous exercez votre droit d\u2019opposition et il n\u2019existe pas de motif l\xe9gitime imp\xe9rieux pour le traitement ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "d. Les donn\xe9es personnelles ont fait l\u2019objet d\u2019un traitement illicite ; "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "e. Les donn\xe9es personnelles doivent \xeatre effac\xe9es pour respecter une obligation l\xe9gale\u202F;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "f. Les donn\xe9es personnelles \xe9taient facultatives. "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous \xeates inform\xe9 que le droit \xe0 l\u2019effacement peut ne pas s\u2019appliquer si le traitement est n\xe9cessaire\u202F:"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "Pour respecter une obligation l\xe9gale,",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                "\xc0 la constatation, \xe0 l\u2019exercice ou \xe0 la d\xe9fense de droits en justice.",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: " "
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit \xe0 la limitation du traitement "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous disposez de la facult\xe9 de demander la limitation du traitement de vos donn\xe9es personnelles lorsque l\u2019un des \xe9l\xe9ments suivants s\u2019applique :"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "a. Une v\xe9rification de vos donn\xe9es est n\xe9cessaire apr\xe8s une contestation de votre part sur l\u2019exactitude de vos donn\xe9es personnelles ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "b. Le traitement est illicite et vous vous opposez \xe0 l\u2019effacement de vos donn\xe9es personnelles et exigez la limitation de leur utilisation ;"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "c. ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " n\u2019a plus besoin des donn\xe9es personnelles vous concernant pour le traitement mais les donn\xe9es sont n\xe9cessaires pour vous pour la constatation, l\u2019exercice ou la d\xe9fense de droits en justice ;"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "d. Vous vous \xeates oppos\xe9s au traitement et ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " v\xe9rifie si les motifs l\xe9gitimes poursuivis par elle pr\xe9valent sur vos motifs l\xe9gitimes."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit \xe0 la portabilit\xe9 "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous avez la facult\xe9 de recevoir les donn\xe9es personnelles que vous avez fournies \xe0",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " dans un format structur\xe9, couramment utilis\xe9 et lisible par machine lorsque, de mani\xe8re cumulative :"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "a. Le traitement est fond\xe9 sur le consentement ou sur un contrat ; "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "b. Le traitement est effectu\xe9 \xe0 l\u2019aide de proc\xe9d\xe9s automatis\xe9s. "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Dans le cadre de l\u2019exercice de ce droit, vous avez le droit d\u2019obtenir de",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " que vos donn\xe9es personnelles soient transmises directement par",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " \xe0 un autre responsable de traitement lorsque cela est techniquement possible."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Le droit \xe0 la portabilit\xe9 ne doit pas porter atteinte aux droits et libert\xe9s de tiers."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Droit d\u2019opposition "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "En application du droit d\u2019opposition, vous disposez du droit de vous opposer \xe0 tout moment, pour des raisons tenant \xe0 votre situation particuli\xe8re, \xe0 un traitement de donn\xe9es personnelles fond\xe9 sur les int\xe9r\xeats l\xe9gitimes de ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " ne traitera plus vos donn\xe9es personnelles sauf si elle d\xe9montre que des motifs l\xe9gitimes et imp\xe9rieux pour le traitement existent et pr\xe9valent sur vos int\xe9r\xeats et vos droits et libert\xe9s ou pour la constatation, l\u2019exercice ou la d\xe9fense de vos droits en justice."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous avez le droit de vous opposer \xe0 tout moment au traitement de vos donn\xe9es personnelles \xe0 des fins de prospection. Pour ce faire, vous pouvez de mani\xe8re totalement gratuite soit\u202F:"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                        children: [
                                            "Cliquer sur le lien figurant dans le mail qui vous a \xe9t\xe9 adress\xe9 par",
                                            ' ',
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "FANDI"
                                            }),
                                            ","
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                        children: [
                                            "Envoyer \xe0 ",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "FANDI"
                                            }),
                                            " un courriel \xe0 l\u2019adresse mail suivante :",
                                            ' ',
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "support@teamtim.fr"
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Sort des donn\xe9es personnelles post-mortem "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "En application de la loi, vous disposez de la facult\xe9 de d\xe9finir vos directives relatives \xe0 la conservation, \xe0 l\u2019effacement et \xe0 la communication de vos donn\xe9es personnelles en cas de d\xe9c\xe8s."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous pouvez nous communiquer vos directives ou bien les enregistrer aupr\xe8s d\u2019un tiers de confiance num\xe9rique certifi\xe9. Vous pouvez d\xe9signer la personne de votre choix qui sera charg\xe9e d\u2019ex\xe9cuter vos directives. A d\xe9faut, il s\u2019agira de vos h\xe9ritiers."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "En mati\xe8re de consentement "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Plusieurs traitements de vos donn\xe9es personnelles sont conditionn\xe9s par votre consentement. C\u2019est le cas par exemple lorsque vous sollicitez des renseignements via le formulaire de contact du Site."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous pouvez \xe0 tout moment retirer votre consentement. Il suffit pour cela d\u2019envoyer un email \xe0 l\u2019adresse suivante : ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "support@teamtim.fr."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Ce retrait de consentement est sans incidence sur la l\xe9galit\xe9 d\u2019un traitement de Donn\xe9es personnelles effectu\xe9 sur la base de votre consentement avant son retrait."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Veuillez noter par ailleurs que les Donn\xe9es personnelles dont le traitement est rendu obligatoire pour r\xe9pondre \xe0 vos demandes ou fournir les services demand\xe9s sont assorties d\u2019un ast\xe9risque sur le formulaire de collecte. Sans ces informations,",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " ne pourra pas \xeatre en mesure de r\xe9pondre \xe0 vos demandes ou de fournir les produits ou services sollicit\xe9s."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "Comment exercer ses droits\u202F?"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Modalit\xe9s d\u2019exercice des droits "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vous pouvez adresser vos demandes aux adresses suivantes : "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "FANDI"
                                                }),
                                                ", ",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "70 rue Elie CARTAN, 62220 CARVIN"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "support@teamtim.fr"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Pour exercer vos droits sur les donn\xe9es vous concernant, merci de joindre la copie d'une pi\xe8ce d'identit\xe9 en cours de validit\xe9 (carte d'identit\xe9 ou passeport), sauf si les \xe9l\xe9ments communiqu\xe9s dans le cadre de votre demande permettent de vous identifier de fa\xe7on certaine."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Pour vous aider dans votre d\xe9marche, vous trouverez en utilisant le lien suivant un mod\xe8le de courrier \xe9labor\xe9 par la Commission Nationale de l\u2019Informatique et des Libert\xe9s (la \xab CNIL \xbb) :",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                        href: "https://www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces",
                                        children: "https://www.cnil.fr/fr/modele/courrier/exercer-son-droit-dacces"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "D\xe9lai de r\xe9ponse "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " dispose d\u2019un d\xe9lai d\u2019un (1) mois pour vous r\xe9pondre \xe0 compter de la r\xe9ception de votre demande. Ce d\xe9lai peut \xeatre prolong\xe9 de deux mois en raison de la complexit\xe9 de votre demande et du nombre de demandes qui lui sont faites.",
                                    ' ',
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    " vous informera la personne dans le mois de sa demande."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Concernant les offres commerciales adress\xe9es par voie \xe9lectronique, vous disposez de la facult\xe9 de vous d\xe9sabonner \xe0 tout moment en cliquant sur le lien hypertexte disponible dans chacun des mails adress\xe9s par ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                        children: "FANDI"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                                children: [
                                    "Vous disposez en outre du droit d\u2019introduire une r\xe9clamation aupr\xe8s de la CNIL, autorit\xe9 de contr\xf4le (",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                                        href: "http://www.cnil.fr/",
                                        children: "www.cnil.fr"
                                    }),
                                    ")."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h2", {
                                children: "L\u2019usage de vos donn\xe9es par des plateformes tierces "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Le Site peut contenir des liens vers d\u2019autres sites. De m\xeame d\u2019autres sites peuvent faire r\xe9f\xe9rence ou contenir un lien vers notre Site. Nous n\u2019avons aucun contr\xf4le sur ces autres domaines et sites Web. Nous invitons nos utilisateurs \xe0 lire les politiques de confidentialit\xe9 de chaque site Web et de chaque application avec lesquels ils sont susceptibles d\u2019interagir. Nous n\u2019adh\xe9rons, ne v\xe9rifions ni n\u2019approuvons, ni ne sommes responsables des pratiques en mati\xe8re de confidentialit\xe9 ou du contenu de tels sites Web ou applications. Si vous visitez les autres sites Web ou applications concern\xe9es, vous le faites \xe0 vos propres risques et vous \xeates soumis \xe0 leur politique de confidentialit\xe9."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h3", {
                                children: "Les plugs in r\xe9seaux sociaux"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Notre Site utilise des plug-in (modules d\u2019extension) \xe9dit\xe9s par des soci\xe9t\xe9s tierces (par ex. Facebook, twitter, google + etc.)."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Si vous interagissez au moyen des plug-ins en cliquant sur les ic\xf4nes disponibles sur nos pages, certaines de vos donn\xe9es personnelles et notamment vos donn\xe9es techniques et de navigation seront transmises et enregistr\xe9es sur un serveur de la soci\xe9t\xe9 tierce exploitant le r\xe9seau social correspondant \xe0 l\u2019ic\xf4ne sur lequel vous avez cliqu\xe9. Ces donn\xe9es seront ensuite trait\xe9es par cette soci\xe9t\xe9 tierce conform\xe9ment \xe0 ses conditions et au param\xe9trage de votre compte ouvert au sein de ce r\xe9seau social."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Vos donn\xe9es sont \xe0 ce titre susceptibles d\u2019\xeatre h\xe9berg\xe9es hors de l\u2019Union Europ\xe9enne et notamment aux \xc9tats-Unis."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "Si vous ne souhaitez pas qu\u2019une soci\xe9t\xe9 tierce exploitant un r\xe9seau social relie les donn\xe9es personnelles collect\xe9es par l'interm\xe9diaire du Site \xe0 votre compte utilisateur ouvert au sein du r\xe9seau social consid\xe9r\xe9, vous devez vous d\xe9connecter de ce r\xe9seau social avant de visiter le Site."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                children: "En tout \xe9tat de cause, l'utilisation de ces plugs in est g\xe9r\xe9e par les soci\xe9t\xe9s tierces \xe9ditrices de r\xe9seaux sociaux et est exclusivement r\xe9gie par les conditions vous liant au r\xe9seau social dont vous \xeates membre. Nous vous invitons \xe0 prendre connaissance des conditions appliqu\xe9es par ces soci\xe9t\xe9s tierces \xe9ditrices de r\xe9seaux sociaux."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        id: 'accept',
                        children: privacyPolicyIsOutdated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $040c27da2bef4dd5$export$2e2bcd8739ae039), {
                            type: "privacyPolicy"
                        })
                    })
                ]
            })
        })
    });
};




var $3ZYaX = parcelRequire("3ZYaX");



parcelRequire("3ZYaX");


const $90ab68b609469a3d$export$639b7803bce79dc0 = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        className: "content",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$26f9e26c50d7e934), {
                children: "Conditions G\xe9n\xe9rales d'Utilisation pour les Employeurs"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "1. Acceptation des Conditions G\xe9n\xe9rales d'Utilisation"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "1.1 Acceptation des CGU :"
            }),
            " En utilisant l'application TeamTIM, vous acceptez les pr\xe9sentes Conditions G\xe9n\xe9rales d'Utilisation et vous vous engagez \xe0 les respecter.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "2. Inscription et Utilisation de l'Application"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.1 Processus d'Inscription :"
            }),
            " Les employeurs peuvent s'inscrire sur l'application par invitation d'une agence d'int\xe9rim ou en envoyant une demande de cr\xe9ation de compte \xe0 l'\xe9quipe de support de TeamTIM via l'adresse e-mail support@teamtim.fr. ",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.2 Informations d'Inscription :"
            }),
            " Les employeurs doivent fournir leurs nom, pr\xe9nom et adresse e-mail lors de leur inscription. Ils ont \xe9galement la possibilit\xe9 d'inviter d'autres personnes au sein de leur entit\xe9 employeur.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "3. Relations avec les Agences d'Int\xe9rim"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.1 Mise en Relation avec une Agence :"
            }),
            " Si un employeur est invit\xe9 par une agence d'int\xe9rim, il doit accepter la mise en relation pour pouvoir interagir avec cette agence. L'employeur peut r\xe9voquer cette relation \xe0 tout moment, ce qui emp\xeachera la possibilit\xe9 de faire des demandes de mission \xe0 cette agence.",
            ' ',
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.2 Cr\xe9ation des Demandes de Mission :"
            }),
            " Les employeurs peuvent utiliser l'application pour cr\xe9er des demandes de mission en remplissant un formulaire. Ces demandes sont ensuite soumises \xe0 l'agence d'int\xe9rim associ\xe9e s\xe9lectionn\xe9e par l'employeur.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "4. Gestion des Missions et des Int\xe9rimaires"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.1 S\xe9lection des Int\xe9rimaires :"
            }),
            " Les agences d'int\xe9rim sont responsables de la s\xe9lection des int\xe9rimaires de leur agence pour r\xe9pondre aux demandes de personnel des missions cr\xe9\xe9es par les employeurs. Les employeurs peuvent v\xe9rifier les int\xe9rimaires affect\xe9s \xe0 la mission une fois que ceux-ci ont \xe9t\xe9 s\xe9lectionn\xe9s et valid\xe9s par l'agence.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "5. Communication et Notifications"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "5.1 Communication Hors de l'Application :"
            }),
            " Les employeurs et les agences d'int\xe9rim communiquent en dehors de l'application. Les modifications apport\xe9es aux missions ou aux contrats d'int\xe9rimaires sont notifi\xe9es par e-mail. Les employeurs doivent consulter leurs e-mails pour \xeatre inform\xe9s des changements importants.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "6. Politique de Confidentialit\xe9"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "6.1 Protection des Donn\xe9es :"
            }),
            " Les employeurs sont invit\xe9s \xe0 consulter la politique de confidentialit\xe9 disponible sur l'application pour comprendre comment leurs donn\xe9es personnelles sont collect\xe9es, utilis\xe9es et partag\xe9es dans le cadre de l'utilisation de l'application.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "7. Suppression du Compte"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.1 Suppression du Compte :"
            }),
            " Les employeurs peuvent supprimer leur compte \xe0 tout moment. Lors de la suppression du compte, toutes les informations personnelles de l'employeur sont supprim\xe9es, \xe0 l'exception de l'historique de l'activit\xe9 qui est conserv\xe9 pendant 1 an \xe0 des fins de suivi et de s\xe9curit\xe9."
        ]
    });
};



parcelRequire("3ZYaX");


const $873d18b25e6147be$export$60ee3a35b3080b8e = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        className: "content",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$26f9e26c50d7e934), {
                children: "Conditions G\xe9n\xe9rales d'Utilisation pour les Agences d'Int\xe9rim"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "1. Acceptation des Conditions G\xe9n\xe9rales d'Utilisation"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "1.1 Acceptation des CGU : "
            }),
            "En utilisant l'application [nom de l'application], vous acceptez les pr\xe9sentes Conditions G\xe9n\xe9rales d'Utilisation et vous vous engagez \xe0 les respecter.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "2. Inscription et Utilisation de l'Application"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.1 Processus d'Inscription : "
            }),
            "Les agences d'int\xe9rim doivent s'inscrire sur l'application en fournissant les informations n\xe9cessaires pour cr\xe9er un compte d'agence.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.2 Acc\xe8s \xe0 l'Application :"
            }),
            " Une fois inscrites, les agences d'int\xe9rim peuvent acc\xe9der \xe0 l'application en utilisant leurs identifiants de connexion.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "3. Gestion des Int\xe9rimaires et des Missions"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.1 Ajout des Int\xe9rimaires :"
            }),
            " Les agences d'int\xe9rim peuvent ajouter les int\xe9rimaires associ\xe9s \xe0 leur agence dans l'application en fournissant leurs noms, pr\xe9noms et adresses e-mail. Les agences sont responsables de l'obtention du consentement des int\xe9rimaires pour l'utilisation de leurs donn\xe9es personnelles dans l'application.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.2 Liaison Agence/Int\xe9rimaire : "
            }),
            "Les agences d'int\xe9rim doivent informer et obtenir l'approbation des int\xe9rimaires concernant leur ajout dans l'application. Les int\xe9rimaires doivent accepter la liaison avec l'agence pour recevoir des missions et utiliser les fonctionnalit\xe9s de l'application.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.3 Cr\xe9ation et Gestion des Missions : "
            }),
            "Les agences d'int\xe9rim peuvent cr\xe9er et g\xe9rer les missions propos\xe9es aux int\xe9rimaires sur l'application. Les agences sont responsables de la validation des missions cr\xe9\xe9es par les employeurs et accept\xe9es par les int\xe9rimaires.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "4. Acc\xe8s aux Donn\xe9es des Int\xe9rimaires et des Missions"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.1 Acc\xe8s aux Donn\xe9es des int\xe9rimaires : "
            }),
            "Les agences d'int\xe9rim ont acc\xe8s aux informations des int\xe9rimaires associ\xe9s \xe0 leur agence, telles que les noms, pr\xe9noms et heures de pointage, dans le respect des lois et r\xe9glementations applicables en mati\xe8re de confidentialit\xe9 des donn\xe9es.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.2 Acc\xe8s aux Donn\xe9es des Missions : "
            }),
            "Les agences d'int\xe9rim ont acc\xe8s aux informations des missions cr\xe9\xe9es sur l'application, telles que les d\xe9tails des employeurs et les actions associ\xe9es aux missions, comme les arr\xeats de mission.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.3 La communication entre les agences et les int\xe9rimaires se fait en dehors de l'application."
            }),
            "TeamTIM ne peut \xeatre tenu responsable du contenu ou de la gestion de ces communications.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.4 Les agences d'int\xe9rim sont responsables de toutes les obligations l\xe9gales, contractuelles ou r\xe9glementaires li\xe9es \xe0 l'emploi des int\xe9rimaires, y compris les conditions de travail, les salaires, les avantages sociaux, etc."
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "5. Communication avec les Int\xe9rimaires"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "5.1 Communication Hors de l'Application :"
            }),
            " Les agences d'int\xe9rim communiquent directement avec les int\xe9rimaires en dehors de l'application. Les agences sont responsables de la gestion de ces communications et de l'information des int\xe9rimaires concernant les mises \xe0 jour et les changements li\xe9s aux missions.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "6. Support Client et Assistance"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "6.1 Contact du Support :"
            }),
            " Pour toute question ou probl\xe8me li\xe9 \xe0 l'application, les agences d'int\xe9rim peuvent contacter le support client par e-mail \xe0 support@teamtim.fr.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "7. Politique de Confidentialit\xe9"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.1 Protection des Donn\xe9es :"
            }),
            " Les agences d'int\xe9rim s'engagent \xe0 traiter les donn\xe9es personnelles des int\xe9rimaires conform\xe9ment aux lois et r\xe9glementations applicables en mati\xe8re de protection des donn\xe9es. Les d\xe9tails sur la collecte, l'utilisation et le partage des donn\xe9es sont d\xe9crits en d\xe9tail dans la politique de confidentialit\xe9 disponible sur l'application.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.2 Conservation des Donn\xe9es :"
            }),
            " Les donn\xe9es des int\xe9rimaires et des missions sont conserv\xe9es conform\xe9ment aux dur\xe9es l\xe9gales requises, ainsi qu'aux obligations de facturation et de conservation des donn\xe9es. Les agences d'int\xe9rim doivent respecter les dispositions l\xe9gales en mati\xe8re de conservation et de suppression des donn\xe9es.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.3 S\xe9curit\xe9 des Donn\xe9es :"
            }),
            " Les agences d'int\xe9rim mettent en place des mesures de s\xe9curit\xe9 appropri\xe9es pour prot\xe9ger les donn\xe9es des int\xe9rimaires et des missions contre tout acc\xe8s, utilisation ou divulgation non autoris\xe9. Cela comprend des mesures techniques, administratives et physiques pour pr\xe9venir les violations de donn\xe9es et garantir la confidentialit\xe9 des informations.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.4 Partage de Donn\xe9es :"
            }),
            " Les agences d'int\xe9rim s'engagent \xe0 ne pas partager les donn\xe9es des int\xe9rimaires avec des tiers non autoris\xe9s, sauf dans les cas pr\xe9vus par la loi ou avec le consentement des int\xe9rimaires. Les donn\xe9es peuvent \xeatre partag\xe9es avec les employeurs concern\xe9s dans le cadre de la gestion des missions, conform\xe9ment aux autorisations accord\xe9es par les int\xe9rimaires.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "7.5 Droits des Int\xe9rimaires :"
            }),
            " Les int\xe9rimaires ont des droits sur leurs donn\xe9es personnelles, y compris le droit d'acc\xe9der, de rectifier, de limiter l'utilisation, de s'opposer et de supprimer leurs donn\xe9es. Les agences d'int\xe9rim doivent fournir aux int\xe9rimaires les moyens appropri\xe9s pour exercer ces droits et r\xe9pondre \xe0 leurs demandes."
        ]
    });
};



parcelRequire("3ZYaX");


const $fba73321b2df0e17$export$38d8234cd47e4636 = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        className: "content",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$26f9e26c50d7e934), {
                children: "Conditions G\xe9n\xe9rales d'Utilisation pour les Int\xe9rimaires"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "1. Acceptation des Conditions G\xe9n\xe9rales d'Utilisation"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "1.1 Acceptation des CGU :"
            }),
            " En utilisant l'application TeamTIM, vous acceptez les pr\xe9sentes Conditions G\xe9n\xe9rales d'Utilisation et vous vous engagez \xe0 les respecter.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "2. Inscription et Utilisation de l'Application"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.1 Processus d'Inscription :"
            }),
            "Les int\xe9rimaires doivent \xeatre inscrits par une agence d'int\xe9rim associ\xe9e pour acc\xe9der \xe0 l'application. Un e-mail d'inscription sera envoy\xe9 \xe0 l'int\xe9rimaire pour cr\xe9er son compte.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "2.2 Acc\xe8s \xe0 l'Application :"
            }),
            " Les int\xe9rimaires peuvent t\xe9l\xe9charger l'application depuis l'App Store (iOS) ou le Play Store (Android) et se connecter \xe0 leur compte en utilisant les identifiants fournis lors de l'inscription..",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "3. Pointage des Heures de Travail"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.1 QR-Code de Pointage :"
            }),
            " Chaque int\xe9rimaire dispose d'un QR-code unique dans son profil. Ce QR-code doit \xeatre scann\xe9 sur les bornes de pointage des entreprises pour enregistrer les heures de travail lorsqu'une mission a \xe9t\xe9 cr\xe9\xe9e et valid\xe9e par l'employeur, l'agence d'int\xe9rim et l'int\xe9rimaire. .",
            ' ',
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "3.2 Cr\xe9ation des Demandes de Mission :"
            }),
            " Les employeurs peuvent utiliser l'application pour cr\xe9er des demandes de mission en remplissant un formulaire. Ces demandes sont ensuite soumises \xe0 l'agence d'int\xe9rim associ\xe9e s\xe9lectionn\xe9e par l'employeur.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "4. Gestion du Profil et des Donn\xe9es Personnelles"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.1 S\xe9lection des Int\xe9rimaires :"
            }),
            " Les int\xe9rimaires peuvent acc\xe9der \xe0 leur profil et modifier leur mot de passe, leur adresse e-mail et d'autres informations personnelles.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "4.2 Suppression du Compte :"
            }),
            "Les int\xe9rimaires ont la possibilit\xe9 de supprimer leur compte \xe0 tout moment. Cela entra\xeenera la suppression de toutes les donn\xe9es de pointage et ils cesseront de recevoir des e-mails li\xe9s \xe0 l'application. Il est possible de revenir sur la suppression d'un compte pendant une dur\xe9e 1 mois si l'utilisateur le souhaite en contactant le Support.",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "5. Support Client et Assistance"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "5.1 Contact du Support :"
            }),
            " Pour toute question ou probl\xe8me li\xe9 \xe0 l'application, les int\xe9rimaires peuvent contacter le support client par e-mail \xe0 support@teamtim.fr",
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$18c6ceb02bf55d4), {
                children: "6. Politique de Confidentialit\xe9"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$8ad37072cd3f2725), {
                children: "6.1 Protection des Donn\xe9es :"
            }),
            " Les informations personnelles des int\xe9rimaires sont trait\xe9es conform\xe9ment aux lois applicables en mati\xe8re de protection des donn\xe9es. Les d\xe9tails sur la collecte, l'utilisation et le partage des donn\xe9es sont d\xe9crits en d\xe9tail dans la politique de confidentialit\xe9 disponible sur l'application."
        ]
    });
};




const $77ccf7d3ada90b83$export$3b099986889b4c15 = ()=>{
    const legalConditionsStatus = (0, $159097eb2ce85c11$export$2e2bcd8739ae039)();
    const termsOfUseAreOutdated = legalConditionsStatus.termsOfUse === 'outdated';
    const [showTermsOfUseAreOutdatedBanner, setShowTermsOfUseAreOutdatedBanner] = (0, $3ZYaX.useState)(false);
    (0, $3ZYaX.useEffect)(()=>{
        if (termsOfUseAreOutdated === true) setShowTermsOfUseAreOutdatedBanner(true);
    }, [
        termsOfUseAreOutdated
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        hideHeader: termsOfUseAreOutdated,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: "medium",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: 'desktop',
                children: [
                    showTermsOfUseAreOutdatedBanner && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal), {
                        show: true,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Modal).Content, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message), {
                                color: 'warning',
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Header, {
                                        children: "Les Conditions G\xe9n\xe9rales d'Utilisation de TeamTim ont \xe9t\xe9 mises \xe0 jour."
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                        p: 5,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "p",
                                            children: [
                                                "Merci de les consulter et de les accepter pour continuer \xe0 utiliser TeamTim.",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    textAlign: 'center',
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                        "data-test": "continue",
                                                        type: "button",
                                                        color: 'primary',
                                                        mt: 5,
                                                        onClick: ()=>setShowTermsOfUseAreOutdatedBanner(false),
                                                        children: "Continuer"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        textColor: "primary",
                        mb: 6,
                        children: "Conditions G\xe9n\xe9rales d'Utilisation de TeamTim"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $90ab68b609469a3d$export$639b7803bce79dc0), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $873d18b25e6147be$export$60ee3a35b3080b8e), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fba73321b2df0e17$export$38d8234cd47e4636), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        id: 'accept',
                        children: termsOfUseAreOutdated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $040c27da2bef4dd5$export$2e2bcd8739ae039), {
                            type: "termsOfUse"
                        })
                    })
                ]
            })
        })
    });
};
const $77ccf7d3ada90b83$export$26f9e26c50d7e934 = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
        renderAs: "h2",
        size: 4,
        children: children
    });
const $77ccf7d3ada90b83$export$18c6ceb02bf55d4 = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
        renderAs: "h3",
        size: 5,
        children: children
    });
const $77ccf7d3ada90b83$export$8ad37072cd3f2725 = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
        renderAs: "h4",
        size: 6,
        mt: 3,
        mb: 3,
        children: children
    });




var $3ZYaX = parcelRequire("3ZYaX");







parcelRequire("3ZYaX");

const $68d79748772dd073$var$NotificationsSettings = ({ resource: resource, settings: settings, title: title, locales: locales, onItemChange: onItemChange, disabledFields: disabledFields })=>{
    if (!settings) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 6,
                children: title
            }),
            Object.keys(settings).map((actionName)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                    my: 1,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 4,
                            py: 1,
                            children: locales[actionName]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 4,
                            py: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                                        checked: settings[actionName]?.email,
                                        onChange: ()=>onItemChange(actionName, !settings[actionName]?.email, 'email'),
                                        disabled: disabledFields && disabledFields.includes(actionName),
                                        children: "Email"
                                    })
                                })
                            })
                        })
                    ]
                }, `${resource}_${actionName}`))
        ]
    });
};
var $68d79748772dd073$export$2e2bcd8739ae039 = $68d79748772dd073$var$NotificationsSettings;




const $080f05119e7532be$var$UserNotificationsSettings = ({})=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUser);
    const mutation = (0, $e607e015ac40917d$export$a9f1384167413475)();
    const [userRoleId, setUserRoleId] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(currentUser.roles[0]._id);
    const [userRole, setUserRole] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(currentUser.roles[0]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        setUserRole(currentUser.roles.find((role)=>role._id === userRoleId));
    }, [
        userRoleId,
        currentUser
    ]);
    const mutationSuccessText = mutation.variables && `Param\xe8tre "${(0, $39a46fa8815c50cd$export$2e2bcd8739ae039).notifications.settings[mutation.variables?.notificationResource][mutation.variables?.notificationAction]}" modifi\xe9 avec succ\xe8s`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                breakpoint: "desktop",
                max: true,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
                        title: `Param\xe8tres de notifications`,
                        subTitle: "G\xe9rer les notifications TeamTim."
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 5,
                        children: [
                            currentUser.roles[1] && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                                children: currentUser.roles.map((role)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                        onClick: ()=>setUserRoleId(role._id),
                                        active: userRoleId === role._id,
                                        children: role.organization ? role.organization.name : (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).users.roles[role.kind]
                                    }, role._id))
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                mt: 3,
                                mb: 5,
                                children: [
                                    userRole.notificationsSettings ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                        mt: 3,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                            children: Object.keys(userRole.notificationsSettings).map((resource)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    mb: 5,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $68d79748772dd073$export$2e2bcd8739ae039), {
                                                        title: (0, $327d1e69b5a090c1$export$2e2bcd8739ae039).resources[resource],
                                                        resource: resource,
                                                        //@ts-ignore
                                                        settings: userRole.notificationsSettings[resource],
                                                        locales: (0, $39a46fa8815c50cd$export$2e2bcd8739ae039).notifications.settings[resource],
                                                        disabledFields: userRole.kind === 'worker' && resource === 'missions' ? [
                                                            'created',
                                                            'updated',
                                                            'abandoned',
                                                            'cancelled'
                                                        ] : [],
                                                        onItemChange: (actionName, value, notificationType)=>{
                                                            mutation.mutate({
                                                                roleId: userRole._id,
                                                                notificationType: notificationType,
                                                                //@ts-ignore
                                                                notificationResource: resource,
                                                                notificationAction: actionName,
                                                                value: value
                                                            });
                                                        }
                                                    }, resource)
                                                }, resource))
                                        })
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        children: "Aucun param\xe8tre disponible pour ce profil"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        mt: 3,
                                        children: mutation.variables?.roleId === userRoleId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                            mutation: mutation,
                                            displayOn: {
                                                success: mutationSuccessText
                                            }
                                        })
                                    })
                                ]
                            }, userRole._id)
                        ]
                    })
                ]
            })
        })
    });
};
var $080f05119e7532be$export$2e2bcd8739ae039 = $080f05119e7532be$var$UserNotificationsSettings;



parcelRequire("3ZYaX");

parcelRequire("3ZYaX");


const $5f5847b2c95a3fab$var$ErrorLayout = ({ children: children })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
            breakpoint: 'tablet',
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    vCentered: true,
                    centered: true,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 6,
                        children: children
                    })
                })
            })
        })
    });
};
var $5f5847b2c95a3fab$export$2e2bcd8739ae039 = $5f5847b2c95a3fab$var$ErrorLayout;




var $3ZYaX = parcelRequire("3ZYaX");
function $34481298a5a37083$var$ExclamationIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
    }));
}
const $34481298a5a37083$var$ForwardRef = $3ZYaX.forwardRef($34481298a5a37083$var$ExclamationIcon);
var $34481298a5a37083$export$2e2bcd8739ae039 = $34481298a5a37083$var$ForwardRef;




const $eeaf532277850094$var$NoActiveRole = ({})=>{
    const logout = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.logout);
    const naviguate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $5f5847b2c95a3fab$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                textAlign: "center",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        size: 'large',
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $34481298a5a37083$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textSize: 3,
                        textAlign: "center",
                        children: "Vous ne faites partie d'aucune organisation"
                    }),
                    "Votre compte TeamTim n'est plus li\xe9 \xe0 aucune organisation. Veuillez contacter votre responsable pour en savoir plus."
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                onClick: ()=>{
                    logout();
                    naviguate('/login');
                },
                mt: 5,
                textAlign: "center",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                    children: "Se d\xe9connecter"
                })
            })
        ]
    });
};
var $eeaf532277850094$export$2e2bcd8739ae039 = $eeaf532277850094$var$NoActiveRole;




var $3ZYaX = parcelRequire("3ZYaX");




parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");











var $3ZYaX = parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");








/**
 * Internal workers filter field component
 * Filters workers that are associated with the current organization
 * Uses the same query logic as the payroll generation form
 */ const $01ca78e78580c6fc$var$InternalWorkersFilterField = ()=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    // Query internal workers for the current organization
    const usersQuery = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        filter: JSON.stringify({
            associations: {
                $elemMatch: {
                    organization: currentOrganization._id,
                    status: [
                        'accepted',
                        'pending'
                    ]
                }
            }
        })
    });
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        return (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(usersQuery?.data || [], {
            labelBuilder: (user)=>(0, $25ffbf4bca475b04$export$9a57c514c234d759)(user),
            renderLabel: (user)=>(0, $ea7328dad92e2051$export$bb2085cd9e63676d)({
                    user: user,
                    organization: currentOrganization
                })
        });
    }, [
        usersQuery?.data
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {
                label: "Salari\xe9(s)"
            }),
            name: "user",
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: items,
            selectDefaultChooseOptionLabel: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    "Choisir le ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {})
                ]
            }),
            isLoading: usersQuery.isLoading
        })
    });
};
var $01ca78e78580c6fc$export$2e2bcd8739ae039 = $01ca78e78580c6fc$var$InternalWorkersFilterField;




parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");


/**
 * Options pour le multiselect des statuts de clôture des semaines
 */ const $74b319e27b2c476f$var$WEEK_STATUS_OPTIONS = [
    {
        value: 'closed',
        label: "Cl\xf4tur\xe9es"
    },
    {
        value: 'readyToClose',
        label: "\xc0 cl\xf4turer"
    },
    {
        value: 'needsValidation',
        label: 'Validation requise'
    }
];
/**
 * Composant de filtre multiselect pour les statuts de clôture des semaines de paie
 * Permet de filtrer les workers selon le statut de leurs semaines :
 * - Clôturées : toutes les semaines sont enregistrées
 * - À clôturer : toutes les semaines sont validées mais pas encore enregistrées
 * - Validation requise : certaines semaines ne sont pas validées
 */ const $74b319e27b2c476f$var$WeekStatusFilterField = ({ name: name, label: label = 'Statut des semaines' })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3d077e8ec4003af2$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
            label: label,
            name: name,
            component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
            options: $74b319e27b2c476f$var$WEEK_STATUS_OPTIONS,
            placeholder: "Choisir les statuts..."
        })
    });
};
var $74b319e27b2c476f$export$2e2bcd8739ae039 = $74b319e27b2c476f$var$WeekStatusFilterField;


/**
 * Payroll filters component that allows filtering by user and date range
 * Uses the global filters store to maintain state across component re-renders
 */ const $33e364db3955ee56$var$PayrollFilters = ()=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).payroll);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...filters,
            start: filters.start ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(filters.start)) : undefined,
            end: filters.end ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(filters.end)) : undefined,
            weekStatuses: filters.weekStatuses || []
        },
        onSubmit: (values)=>{
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).payroll, {
                ...values,
                start: values.start ? (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.start)) : undefined,
                end: values.end ? (0, $d9677f7cca086b20$export$2e2bcd8739ae039)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.end)) : undefined,
                weekStatuses: values.weekStatuses
            });
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.start) errors.start = 'Champ requis';
            if (!values.end) errors.end = 'Champ requis';
            // Validate that the selected range does not exceed 1 year and 1 month (13 months)
            if (values.start && values.end) {
                const start = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.start);
                const end = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.end);
                const maxEnd = (0, $30e36549ded1db27$export$2e2bcd8739ae039)(start, 13);
                const minStart = (0, $41500622c442f1a1$export$2e2bcd8739ae039)(end, 13);
                // End must be on/after start
                if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(start, end)) errors.end = "La date de fin doit \xeatre post\xe9rieure ou \xe9gale \xe0 la date de d\xe9but";
                // End must be within 13 months after start
                if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(end, maxEnd)) errors.end = "La plage ne peut pas d\xe9passer 1 an et 1 mois";
                // Start must be within 13 months before end
                if ((0, $379899354a78c3bb$export$2e2bcd8739ae039)(minStart, start)) errors.start = "La plage ne peut pas d\xe9passer 1 an et 1 mois";
            }
            return errors;
        },
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).payroll,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                    name: "start",
                                    label: "Date de d\xe9but",
                                    // Limit start to be not earlier than (end - 13 months) and not after end
                                    min: props.values.end ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $41500622c442f1a1$export$2e2bcd8739ae039)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(props.values.end), 13)) : undefined,
                                    max: props.values.end ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(props.values.end)) : undefined
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                    name: "end",
                                    label: "Date de fin",
                                    min: props.values.start ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(props.values.start)) : undefined,
                                    // Limit end to be not later than (start + 13 months)
                                    max: props.values.start ? (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $30e36549ded1db27$export$2e2bcd8739ae039)((0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(props.values.start), 13)) : undefined
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $74b319e27b2c476f$export$2e2bcd8739ae039), {
                                    name: "weekStatuses",
                                    label: "Statut des semaines"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        pb: 1,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $01ca78e78580c6fc$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 3,
                                py: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $33e364db3955ee56$export$2e2bcd8739ae039 = $33e364db3955ee56$var$PayrollFilters;




parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");



parcelRequire("3ZYaX");





const $2484e49dd3ad316b$var$POPULATE_FIELDS = [
    'worker',
    'employer',
    'template',
    'lastIncrementedBy'
];
const $2484e49dd3ad316b$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/worker-counters',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $2484e49dd3ad316b$var$POPULATE_FIELDS,
            ...params
        }
    });
};
const $2484e49dd3ad316b$export$3988ae62b71be9a3 = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counters/${id}`,
        method: 'GET',
        params: {
            populate: $2484e49dd3ad316b$var$POPULATE_FIELDS
        }
    });
};
const $2484e49dd3ad316b$export$234c45b355edd85b = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counters/${id}/activate`,
        method: 'put'
    });
};
const $2484e49dd3ad316b$export$e96c1edfdaf2d1db = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counters/${id}/deactivate`,
        method: 'put'
    });
};
const $2484e49dd3ad316b$export$ff6234cce16df9d2 = async ({ id: id, value: value })=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counters/${id}/adjust-value`,
        method: 'put',
        params: {
            value: value
        }
    });
};
const $2484e49dd3ad316b$export$da79c7a367bbb63c = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/worker-counters/create-or-get',
        method: 'post',
        params: params
    });
};


const $8e9b7320493de555$export$ec101cf448daac1 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('worker-counters', (0, $2484e49dd3ad316b$export$e7aa7bc5c1b3cfb3), filters || {}, options);
const $8e9b7320493de555$export$7240c3017e8ad1a1 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('worker-counters', (0, $2484e49dd3ad316b$export$3988ae62b71be9a3), id, undefined, options);
/**
 * Callback function to invalidate worker counters cache on mutation success
 */ const $8e9b7320493de555$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'worker-counters'
    ]);
};
/**
 * Mutation hook to activate a worker counter
 */ const $8e9b7320493de555$var$useActivateMutationKey = ()=>[
        'worker-counters',
        'activate'
    ];
const $8e9b7320493de555$export$50405211ba4ea214 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2484e49dd3ad316b$export$234c45b355edd85b), {
        mutationKey: $8e9b7320493de555$var$useActivateMutationKey(),
        onSuccess: $8e9b7320493de555$var$onMutationSuccess
    });
/**
 * Mutation hook to deactivate a worker counter
 */ const $8e9b7320493de555$var$useDeactivateMutationKey = ()=>[
        'worker-counters',
        'deactivate'
    ];
const $8e9b7320493de555$export$7e43107ad70e3dbb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2484e49dd3ad316b$export$e96c1edfdaf2d1db), {
        mutationKey: $8e9b7320493de555$var$useDeactivateMutationKey(),
        onSuccess: $8e9b7320493de555$var$onMutationSuccess
    });
/**
 * Mutation hook to adjust the value of a worker counter
 */ const $8e9b7320493de555$var$useAdjustValueMutationKey = ()=>[
        'worker-counters',
        'adjust-value'
    ];
const $8e9b7320493de555$export$1e7541f5fdb5f40c = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2484e49dd3ad316b$export$ff6234cce16df9d2), {
        mutationKey: $8e9b7320493de555$var$useAdjustValueMutationKey(),
        onSuccess: $8e9b7320493de555$var$onMutationSuccess
    });
/**
 * Mutation hook to create or get a counter for an organization
 */ const $8e9b7320493de555$var$useCreateOrGetMutationKey = ()=>[
        'worker-counters',
        'create-or-get'
    ];
const $8e9b7320493de555$export$ca93ef397853eaa8 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2484e49dd3ad316b$export$da79c7a367bbb63c), {
        mutationKey: $8e9b7320493de555$var$useCreateOrGetMutationKey(),
        onSuccess: $8e9b7320493de555$var$onMutationSuccess
    });






var $31tXu = parcelRequire("31tXu");

var $2KSUA = parcelRequire("2KSUA");
/**
 * Composant pour ajuster la valeur d'un compteur de travailleur
 * Permet d'ajouter, soustraire ou forcer une nouvelle valeur
 */ const $58cb785571ed9e66$var$WorkerCounterAdjustForm = ({ workerCounter: workerCounter })=>{
    const adjustValueMutation = (0, $8e9b7320493de555$export$1e7541f5fdb5f40c)();
    /**
   * Calcule la valeur finale et l'ajustement pour un type d'opération donné
   * @param adjustmentType - Type d'ajustement ('add', 'subtract', 'force')
   * @param valueInMs - Valeur d'entrée en millisecondes
   * @returns Objet contenant l'ajustement à envoyer à l'API et la valeur finale
   */ const calculateAdjustment = (adjustmentType, valueInMs)=>{
        const currentValueInMs = workerCounter.currentValue;
        let adjustmentValue;
        let finalValueInMs;
        switch(adjustmentType){
            case 'add':
                adjustmentValue = valueInMs;
                finalValueInMs = currentValueInMs + valueInMs;
                break;
            case 'subtract':
                adjustmentValue = -valueInMs;
                finalValueInMs = currentValueInMs - valueInMs;
                break;
            case 'force':
                adjustmentValue = valueInMs - currentValueInMs;
                finalValueInMs = valueInMs;
                break;
            default:
                throw new Error(`Type d'ajustement invalide: ${adjustmentType}`);
        }
        return {
            adjustmentValue: adjustmentValue,
            finalValueInMs: finalValueInMs
        };
    };
    /**
   * Validation Formik pour le formulaire d'ajustement
   */ const validateForm = (values)=>{
        const errors = {};
        // Vérification des champs vides
        if (!values.hours && !values.minutes) {
            errors.hours = "La dur\xe9e est requise";
            return errors;
        }
        // Conversion des valeurs
        const hours = parseInt(values.hours || '0', 10);
        const minutes = parseInt(values.minutes || '0', 10);
        if (isNaN(hours) || hours < 0) errors.hours = 'Heures invalides';
        if (isNaN(minutes) || minutes < 0 || minutes > 59) errors.minutes = 'Minutes invalides (0-59)';
        const valueInMs = (hours * 60 + minutes) * 60000;
        if (valueInMs <= 0) errors.hours = "La dur\xe9e doit \xeatre sup\xe9rieure \xe0 0";
        return errors;
    };
    /**
   * Gère la soumission du formulaire d'ajustement
   */ const handleAdjustValue = async (values)=>{
        try {
            const hours = parseInt(values.hours || '0', 10);
            const minutes = parseInt(values.minutes || '0', 10);
            const valueInMs = (hours * 60 + minutes) * 60000;
            if (valueInMs > 0) {
                const { adjustmentValue: adjustmentValue } = calculateAdjustment(values.adjustmentType, valueInMs);
                await adjustValueMutation.mutateAsync({
                    id: workerCounter._id,
                    value: adjustmentValue
                });
            }
        } catch (error) {
            console.error("Erreur lors de l'ajustement:", error);
        }
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                mb: 3,
                children: "Ajuster la valeur"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                initialValues: {
                    hours: '',
                    minutes: '0',
                    adjustmentType: 'subtract'
                },
                onSubmit: handleAdjustValue,
                validate: validateForm,
                enableReinitialize: true,
                children: ({ values: values, setFieldValue: setFieldValue, isSubmitting: isSubmitting, errors: errors, touched: touched })=>{
                    let valueInMs;
                    let finalValueInMs;
                    try {
                        const hours = parseInt(values.hours || '0', 10);
                        const minutes = parseInt(values.minutes || '0', 10);
                        if (!isNaN(hours) && hours >= 0 && !isNaN(minutes) && minutes >= 0 && minutes < 60) {
                            valueInMs = (hours * 60 + minutes) * 60000;
                            if (valueInMs > 0) {
                                const { finalValueInMs: calculatedFinalValue } = calculateAdjustment(values.adjustmentType, valueInMs);
                                finalValueInMs = calculatedFinalValue;
                            }
                        }
                    } catch (error) {
                    // Valeur invalide, on ignore
                    }
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: "adjustmentType",
                                            component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                            label: "Type d'ajustement",
                                            options: [
                                                {
                                                    value: 'add',
                                                    label: 'Ajouter +'
                                                },
                                                {
                                                    value: 'subtract',
                                                    label: 'Diminuer -'
                                                },
                                                {
                                                    value: 'force',
                                                    label: 'Forcer une valeur'
                                                }
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: "hours",
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            label: "Heures",
                                            type: "number",
                                            min: 0,
                                            step: 1,
                                            placeholder: "0",
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            name: "minutes",
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            label: "Minutes",
                                            type: "number",
                                            min: 0,
                                            max: 59,
                                            step: 1,
                                            placeholder: "00",
                                            required: true
                                        })
                                    })
                                ]
                            }),
                            Boolean(!!values.hours || !!values.minutes) && (0, $2KSUA.isNumber)(valueInMs) && valueInMs > 0 && !errors.hours && !errors.minutes && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    className: `notification ${errors.hours || errors.minutes ? 'is-danger' : 'is-info'} is-light`,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "R\xe9sultat :"
                                        }),
                                        ' ',
                                        errors.hours || errors.minutes ? errors.hours || errors.minutes : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                            children: [
                                                values.adjustmentType === 'add' && `${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workerCounter.currentValue)} + ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(valueInMs)} = ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(finalValueInMs)}`,
                                                values.adjustmentType === 'subtract' && `${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workerCounter.currentValue)} - ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(valueInMs)} = ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(finalValueInMs)}`,
                                                values.adjustmentType === 'force' && `${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(valueInMs)}`
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                request: adjustValueMutation,
                                type: "submit",
                                disabled: isSubmitting || !values.hours && !values.minutes || !valueInMs || valueInMs <= 0 || !!errors.hours || !!errors.minutes,
                                color: "primary",
                                children: [
                                    values.adjustmentType === 'add' && 'Ajouter',
                                    values.adjustmentType === 'subtract' && 'Soustraire',
                                    values.adjustmentType === 'force' && 'Forcer la valeur'
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $58cb785571ed9e66$export$2e2bcd8739ae039 = $58cb785571ed9e66$var$WorkerCounterAdjustForm;




var $485add63182c5926$export$2e2bcd8739ae039 = {
    history: {
        title: {
            workerCounterCreated: "Compteur cr\xe9\xe9",
            workerCounterUpdated: "Compteur mis \xe0 jour",
            workerCounterActivated: "Compteur activ\xe9",
            workerCounterDeactivated: "Compteur d\xe9sactiv\xe9",
            workerCounterValueAdjusted: "Valeur du compteur ajust\xe9e"
        },
        changesTitle: {
            currentValue: 'Valeur du compteur'
        }
    }
};


/**
 * Composant pour afficher les détails d'un compteur de travailleur
 * Affiche la valeur actuelle de façon évidente et permet d'ajuster la valeur
 */ const $a688b54624156caa$var$WorkerCounterDetails = ({ workerCounterId: workerCounterId })=>{
    const { data: workerCounter } = (0, $8e9b7320493de555$export$7240c3017e8ad1a1)(workerCounterId);
    const [showHistory, setShowHistory] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    if (!workerCounter) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                alignItems: "center",
                mb: 4,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 4,
                        children: [
                            workerCounter.template.name,
                            workerCounter.template.description && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 6,
                                subtitle: true,
                                children: workerCounter.template.description
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                mb: 4,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    textAlign: "center",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 1,
                        textColor: "success",
                        children: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workerCounter.currentValue)
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $58cb785571ed9e66$export$2e2bcd8739ae039), {
                workerCounter: workerCounter
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textAlign: "right",
                mb: 2,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("a", {
                    onClick: ()=>setShowHistory((v)=>!v),
                    style: {
                        cursor: 'pointer'
                    },
                    "data-test": "worker-counter-history-link",
                    children: showHistory ? "Masquer l'historique" : "Afficher l'historique"
                })
            }),
            showHistory && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d21fe120a7200937$export$2e2bcd8739ae039), {
                items: workerCounter.history,
                locales: (0, $485add63182c5926$export$2e2bcd8739ae039).history
            })
        ]
    });
};
var $a688b54624156caa$export$2e2bcd8739ae039 = $a688b54624156caa$var$WorkerCounterDetails;


/**
 * Composant modal pour afficher les détails d'un compteur de travailleur
 * Utilise le composant WorkerCounterDetails pour afficher les informations
 */ const $97bb431efbba50b5$var$WorkerCounterModal = ({ workerCounter: workerCounter, isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        actions: {
            isDisplayed: isDisplayed,
            setIsDisplayed: setIsDisplayed
        },
        title: workerCounter ? `D\xe9tails du compteur ${workerCounter.template.name}` : "D\xe9tails du compteur",
        maxWidth: 800,
        children: workerCounter && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a688b54624156caa$export$2e2bcd8739ae039), {
            workerCounterId: workerCounter._id
        })
    });
};
var $97bb431efbba50b5$export$2e2bcd8739ae039 = $97bb431efbba50b5$var$WorkerCounterModal;







parcelRequire("3ZYaX");






/**
 * Composant pour afficher la liste des travailleurs avec leur statut de validation
 *
 * Affiche chaque travailleur avec son avatar et une icône de validation
 * si toutes les semaines sont enregistrées.
 */ const $f47c2cf2a2e778cf$var$WorkersList = ({ workers: workers, weeksSummaryStatus: weeksSummaryStatus, onWorkerSelect: onWorkerSelect, activeWorkerId: activeWorkerId, isLoading: isLoading, showOnlyUnrecordedWeeks: showOnlyUnrecordedWeeks = false })=>{
    const sortedWorkers = (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(workers, 'lastName');
    // Filtrer les workers selon le critère showOnlyUnrecordedWeeks
    const filteredWorkers = showOnlyUnrecordedWeeks ? sortedWorkers.filter((worker)=>{
        const statusForWorker = weeksSummaryStatus?.users?.find((u)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(u.user, worker));
        // Afficher seulement les workers qui ont des semaines non enregistrées
        return statusForWorker && statusForWorker.recordedWeeks < statusForWorker.weeks.length;
    }) : sortedWorkers;
    if (isLoading) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    if (filteredWorkers.length === 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        mt: 5,
        textAlign: 'center',
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$79e71d77d4eb0b38), {})
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textSize: 7,
                children: "Aucun salari\xe9 correspondant aux filtres"
            })
        ]
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: filteredWorkers?.map((worker)=>{
            // Récupérer le statut des semaines pour ce travailleur via WeeksSummaryStatus
            const statusForWorker = weeksSummaryStatus?.users?.find((u)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(u.user, worker));
            // Calculer les agrégats d'état
            const allRecorded = statusForWorker?.recordedWeeks === statusForWorker?.weeks.length;
            const allValidated = statusForWorker?.validatedWeeks === statusForWorker?.weeks.length;
            const weeksToValidate = (statusForWorker?.totalWeeks || 0) - (statusForWorker?.validatedWeeks || 0);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                py: 3,
                onClick: ()=>onWorkerSelect(worker),
                style: {
                    cursor: 'pointer',
                    borderBottom: '1px solid #e0e0e0'
                },
                backgroundColor: activeWorkerId === worker._id ? 'light' : 'transparent',
                "data-test": `workers-list-item-${worker._id}`,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    pl: 2,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            textWeight: "semibold",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                user: worker
                            })
                        }),
                        allRecorded && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                    color: "success",
                                    size: "small",
                                    mt: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$87cd4f2a4da4427e), {})
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    textSize: 7,
                                    children: "P\xe9riode clotur\xe9e"
                                })
                            ]
                        }),
                        !allRecorded && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    textSize: 7,
                                    children: [
                                        statusForWorker?.recordedWeeks,
                                        "/",
                                        statusForWorker?.weeks.length,
                                        " semaine(s) clotur\xe9e(s)"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                    children: [
                                        !allValidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    color: "danger",
                                                    size: "small",
                                                    mt: 1,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                    textSize: 7,
                                                    children: [
                                                        weeksToValidate,
                                                        " semaine(s) \xe0 valider avant cloture"
                                                    ]
                                                })
                                            ]
                                        }),
                                        allValidated && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                    color: "warning",
                                                    size: "small",
                                                    mt: 1,
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6eaf6428dd466039$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    textSize: 7,
                                                    children: "P\xe9riode pr\xeate \xe0 \xeatre cl\xf4tur\xe9e"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }, worker._id);
        })
    });
};
var $f47c2cf2a2e778cf$export$2e2bcd8739ae039 = $f47c2cf2a2e778cf$var$WorkersList;




var $3ZYaX = parcelRequire("3ZYaX");



/**
 * Composant pour afficher les statistiques des périodes de paie
 *
 * Affiche le nombre de travailleurs dans chaque état :
 * - Clôturées (toutes les semaines enregistrées)
 * - Prêtes à être clôturées (toutes validées mais pas encore enregistrées)
 * - Avec validation manquante (semaines non validées)
 */ const $5e95748863ba0958$var$PayrollStats = ({ weeksSummaryStatus: weeksSummaryStatus, totalWorkers: totalWorkers })=>{
    // Calculer les statistiques à partir des données
    const stats = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!weeksSummaryStatus?.users) return {
            closed: 0,
            readyToClose: 0,
            needsValidation: 0
        };
        let closed = 0;
        let readyToClose = 0;
        let needsValidation = 0;
        weeksSummaryStatus.users.forEach((userStatus)=>{
            const allRecorded = userStatus.recordedWeeks === userStatus.weeks.length;
            const allValidated = userStatus.validatedWeeks === userStatus.weeks.length;
            if (allRecorded) closed++;
            else if (allValidated) readyToClose++;
            else needsValidation++;
        });
        return {
            closed: closed,
            readyToClose: readyToClose,
            needsValidation: needsValidation
        };
    }, [
        weeksSummaryStatus
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        "data-test": "payroll-workers-list-stats",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 1,
                renderAs: "span",
                mr: 1,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            color: "success",
                            size: "small",
                            mt: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$87cd4f2a4da4427e), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            textSize: 7,
                            "data-test": "payroll-workers-list-stats-closed",
                            children: [
                                stats.closed,
                                " cl\xf4tur\xe9e(s)"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 1,
                renderAs: "span",
                mr: 1,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            color: "warning",
                            size: "small",
                            mt: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6eaf6428dd466039$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            textSize: 7,
                            "data-test": "payroll-workers-list-stats-ready-to-close",
                            children: [
                                stats.readyToClose,
                                " \xe0 cl\xf4turer"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 1,
                renderAs: "span",
                mr: 1,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            color: "danger",
                            size: "small",
                            mt: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            textSize: 7,
                            "data-test": "payroll-workers-list-stats-needs-validation",
                            children: [
                                stats.needsValidation,
                                " \xe0 valider"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $5e95748863ba0958$export$2e2bcd8739ae039 = $5e95748863ba0958$var$PayrollStats;






var $3ZYaX = parcelRequire("3ZYaX");









const $2c246fb177fe9551$export$f277181e65de46c7 = (valuesInTime)=>valuesInTime.find((vt)=>!vt.effectiveTo || new Date(vt.effectiveTo) > new Date())?.value;
const $2c246fb177fe9551$export$1e2c8d86c7262067 = (employerRules, summary, durationFormatter)=>employerRules.reduce((rules, employerRule)=>{
        const ruleKey = `rule_${employerRule.ruleId}`;
        if (employerRule.kind === 'goal') rules[ruleKey] = summary?.employerData?.goals?.[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(employerRule.ruleId)] || 0;
        else {
            const duration = summary?.employerData?.durations?.[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(employerRule.ruleId)] || 0;
            rules[ruleKey] = durationFormatter ? durationFormatter(duration) : (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(duration);
        }
        return rules;
    }, {});
const $2c246fb177fe9551$export$a645549e48a5412d = (formula)=>{
    if ('op' in formula) return formula.args.flatMap($2c246fb177fe9551$export$a645549e48a5412d);
    if ('type' in formula && formula.type === 'eventPath') return formula.workPeriodEventIds;
    return [];
};
function $2c246fb177fe9551$export$3d16ca0231757188(employerRules) {
    const map = new Map();
    for (const rule of employerRules){
        const eventIds = $2c246fb177fe9551$export$a645549e48a5412d(rule.interval.inputFormula);
        for (const id of eventIds){
            const existing = map.get(id) || [];
            existing.push(rule.shortName || rule.name);
            map.set(id, existing);
        }
    }
    return map;
}



parcelRequire("3ZYaX");


/**
 * Composant pour les en-têtes de colonnes
 */ const $2528183c082d0ad9$var$ColumnHeader = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "div",
        textColor: "white",
        style: {
            fontWeight: 'bold',
            padding: '4px 8px',
            textAlign: 'center'
        },
        children: children
    });
/**
 * Composant pour les cellules de données
 */ const $2528183c082d0ad9$var$DataCell = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "div",
        style: {
            padding: '2px 8px',
            textAlign: 'center'
        },
        children: children
    });
/**
 * Composant pour les lignes de données
 */ const $2528183c082d0ad9$var$DataRow = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "div",
        style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '2px 0'
        },
        children: children
    });
const $2528183c082d0ad9$export$e51287a45280f8f7 = ({ counters: counters, templateNamesMap: templateNamesMap })=>{
    if (!counters || typeof counters !== 'object') return null;
    try {
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "div",
            style: {
                minWidth: '200px'
            },
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)($2528183c082d0ad9$var$DataRow, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$ColumnHeader, {
                            children: "Compteur"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$ColumnHeader, {
                            children: "Vers compteurs"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$ColumnHeader, {
                            children: "Vers semaine"
                        })
                    ]
                }),
                Object.keys(counters).map((counterTemplateId)=>{
                    const counter = counters[counterTemplateId];
                    const toCounter = (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(counter?.allocation.toCounter || 0);
                    const toPeriod = (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(counter?.allocation.toPeriod || 0);
                    // Prefer API name, then map from worker counters, then fallback to template id
                    const displayName = counter?.workerCounter?.template?.name ?? templateNamesMap?.[counterTemplateId] ?? counterTemplateId;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)($2528183c082d0ad9$var$DataRow, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$DataCell, {
                                children: displayName
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$DataCell, {
                                children: toCounter
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($2528183c082d0ad9$var$DataCell, {
                                children: toPeriod
                            })
                        ]
                    }, counterTemplateId);
                })
            ]
        });
    } catch  {
        return null;
    }
};
var $2528183c082d0ad9$export$2e2bcd8739ae039 = $2528183c082d0ad9$export$e51287a45280f8f7;




//TODO: too many code repetitionn => refactor with helpers
//TODO: row builder return a mix of React.ReactNode and string/number/boolean/Date => use a proper type / approach
/**
 * Calcule les heures pour une date donnée en utilisant le contractual schedule ou les heures théoriques du workPeriod
 * @param date - Date concernée
 * @param workPeriod - WorkPeriod correspondant à cette date (depuis UserWeekSummary)
 * @param association - Association du worker (contient les contractual schedules)
 * @returns Nombre d'heures en millisecondes
 */ const $211eb3c50c25e8c2$var$getHoursForDate = (date, workPeriod, association)=>{
    // Essayer d'obtenir le contractual schedule actif pour cette date
    if (association?.contractualSchedules) {
        const activeSchedule = (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association, date);
        if (activeSchedule?.schedule) {
            const dayName = (0, $25ffbf4bca475b04$export$3ef3aade8b3d4986)(date);
            const daySchedule = activeSchedule.schedule[dayName];
            // Si le schedule a des time slots pour ce jour, calculer les heures
            if (daySchedule?.timeSlots && daySchedule.timeSlots.length > 0) {
                const hoursInDay = (0, $44391656266f978a$export$65b98c304a80dbb2)(daySchedule.timeSlots);
                // Convertir les heures en millisecondes (heures * 60 * 60 * 1000)
                return hoursInDay * 3600000;
            }
        }
    }
    // Fallback : utiliser les heures théoriques du workPeriod
    return workPeriod.summary?.durations?.worked.theoretical || 0;
};
/**
 * Helper pour créer une CellValue avec gestion des valeurs par défaut
 */ const $211eb3c50c25e8c2$var$createCellValue = (value, decimal, isNA = false, color)=>({
        value: value || '---',
        decimal: decimal || undefined,
        isNA: isNA,
        color: color
    });
/**
 * Helper pour calculer et formater une différence de durée (comme DurationDiff)
 */ const $211eb3c50c25e8c2$var$createDurationDiffCellValue = (duration, showZero = false, durationFormatter = (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a), decimalFormatter = (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73))=>{
    const diff = duration || 0;
    let color = undefined;
    let formattedValue = showZero && !diff ? '0' : diff ? durationFormatter(diff) : '';
    let formattedDecimal = showZero && !diff ? '0' : diff ? decimalFormatter(diff) : undefined;
    if (diff > 0.1) {
        // TODO: use a proper value => 0.1 is a temporary value
        formattedValue = `+${formattedValue}`;
        formattedDecimal = `+${formattedDecimal}`;
        color = 'warning';
    } else if (diff < 0) color = 'danger';
    return $211eb3c50c25e8c2$var$createCellValue(formattedValue, formattedDecimal, undefined, color);
};
/**
 * Crée la structure de base commune pour WeekRowData
 */ const $211eb3c50c25e8c2$var$createBaseWeekRowData = (week, worker, employerRules, events)=>{
    const weekNumber = (0, $74f17ceb9b5a08a5$export$efe19b760242b2fc)(week);
    const year = (0, $74f17ceb9b5a08a5$export$12d572480ceb6e58)(week);
    return {
        weekNumber: `S${weekNumber}`,
        workerId: worker._id,
        year: `${year}`,
        weekNumberValue: weekNumber,
        yearValue: year,
        weekStart: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(week),
        weekStartDate: (0, $74f17ceb9b5a08a5$export$42c81a444fbfb5d4)(week),
        weekEndDate: (0, $74f17ceb9b5a08a5$export$ef8b6d9133084f4e)(week),
        weekEnd: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(new Date(week.getTime() + 518400000)),
        // Nouvelles structures CellValue
        contractHours: $211eb3c50c25e8c2$var$createCellValue('---'),
        worked: $211eb3c50c25e8c2$var$createCellValue('---'),
        nonEffective: $211eb3c50c25e8c2$var$createCellValue('---'),
        accounted: $211eb3c50c25e8c2$var$createCellValue('---', undefined, true),
        sentToCounters: $211eb3c50c25e8c2$var$createCellValue('---'),
        contractDiff: $211eb3c50c25e8c2$var$createCellValue('---'),
        contractDiffDecimal: $211eb3c50c25e8c2$var$createCellValue('---'),
        // Composants React complexes
        informativeEvents: '---',
        // États
        isRecorded: false,
        isValidated: false,
        isTotalRow: false,
        // Employer rules avec valeurs par défaut
        ...employerRules.reduce((acc, rule)=>{
            acc[`rule_${rule.ruleId}`] = '---';
            acc[`rule_${rule.ruleId}_decimal`] = '---';
            return acc;
        }, {}),
        // Benefit events avec valeurs par défaut
        ...events.filter((e)=>e.type === 'benefit').reduce((acc, event)=>{
            acc[`event_${event.code}`] = '---';
            return acc;
        }, {})
    };
};
const $211eb3c50c25e8c2$export$486e5878dd6b6a25 = (week, worker, events, employerRules)=>{
    // Trouver le résumé de semaine correspondant
    const weekSummary = worker.weeksSummary?.weeks.find((w)=>w.missions[0]?.workPeriods[0] && (0, $5676184ed61a60f3$export$2e2bcd8739ae039)(week, new Date(w.missions[0]?.workPeriods[0].start.date), {
            locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
            weekStartsOn: 1
        }));
    // Structure de base commune
    const baseData = $211eb3c50c25e8c2$var$createBaseWeekRowData(week, worker, employerRules, events);
    // Si pas de weekSummary, retourner avec les valeurs par défaut
    if (!weekSummary) return baseData;
    // Récupérer les valeurs des employer rules pour cette semaine (formatées et décimales)
    const employerRulesValues = weekSummary?.totals && employerRules ? (0, $2c246fb177fe9551$export$1e2c8d86c7262067)(employerRules, weekSummary.totals) : {};
    const employerRulesDecimalValues = weekSummary?.totals && employerRules ? (0, $2c246fb177fe9551$export$1e2c8d86c7262067)(employerRules, weekSummary.totals, (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)) : {};
    // Récupérer les benefit events pour cette semaine
    const benefitEvents = events.filter((e)=>e.type === 'benefit').reduce((eventsAcc, event)=>{
        // Collecter les dates et workPeriods qui contiennent cet événement
        const eventData = [];
        const eventCount = weekSummary?.missions.reduce((totalCount, mission)=>{
            return totalCount + mission.workPeriods.reduce((missionCount, workPeriod)=>{
                const matchingEvents = workPeriod.events.filter((we)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(we.item) === (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event));
                // Si cet événement est présent dans ce workPeriod, ajouter la date et le workPeriod
                if (matchingEvents.length > 0) eventData.push({
                    date: new Date(workPeriod.start.date),
                    workPeriod: workPeriod
                });
                return missionCount + matchingEvents.length;
            }, 0);
        }, 0) || 0;
        // Construire le tooltip avec le label de l'événement et les dates concernées avec leurs heures
        const tooltipLabel = (0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event, true);
        const sortedEventData = eventData.sort((a, b)=>a.date.getTime() - b.date.getTime());
        const benefitTooltipId = `benefit-${event.code}-${worker._id}-${week.getTime()}`;
        eventsAcc[`event_${event.code}`] = eventCount > 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    "data-tip": true,
                    "data-for": benefitTooltipId,
                    children: eventCount
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                    id: benefitTooltipId,
                    effect: "solid",
                    place: "bottom",
                    children: [
                        tooltipLabel,
                        sortedEventData.map(({ date: date, workPeriod: workPeriod })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date),
                                    " (",
                                    (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)($211eb3c50c25e8c2$var$getHoursForDate(date, workPeriod, worker.association)),
                                    ")"
                                ]
                            }, date.getTime()))
                    ]
                })
            ]
        }) : '';
        return eventsAcc;
    }, {});
    // Récupérer les informative events pour cette semaine (count + tooltip détaillé date/durée)
    /** Occurrences d’events informatifs avec date et workPeriod pour le tooltip (date + durée par jour) */ const informativeEventData = [];
    weekSummary?.missions.forEach((mission)=>mission.workPeriods.forEach((workPeriod)=>{
            workPeriod.events.forEach((we)=>{
                const eventItem = we.item;
                if (eventItem.type !== 'informative') return;
                informativeEventData.push({
                    date: new Date(workPeriod.start.date),
                    workPeriod: workPeriod,
                    event: eventItem
                });
            });
        }));
    const informativeCount = informativeEventData.length;
    /** Regroupe par event (même doc) : label une fois + liste des dates/durées en dessous */ const informativeByEvent = informativeEventData.reduce((acc, { date: date, workPeriod: workPeriod, event: event })=>{
        const id = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event);
        const existing = acc.get(id);
        const occ = {
            date: date,
            workPeriod: workPeriod
        };
        if (existing) existing.occurrences.push(occ);
        else acc.set(id, {
            event: event,
            occurrences: [
                occ
            ]
        });
        return acc;
    }, new Map());
    // Trier les occurrences de chaque groupe par date
    informativeByEvent.forEach((group)=>{
        group.occurrences.sort((a, b)=>a.date.getTime() - b.date.getTime());
    });
    const informativeTooltip = informativeByEvent.size > 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: Array.from(informativeByEvent.entries()).map(([eventId, { event: event, occurrences: occurrences }], groupIndex, entries)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                children: [
                    (0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event, true),
                    occurrences.length > 1 ? ` (x${occurrences.length})` : '',
                    occurrences.map(({ date: date, workPeriod: workPeriod })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(date),
                                " (",
                                (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)($211eb3c50c25e8c2$var$getHoursForDate(date, workPeriod, worker.association)),
                                ")"
                            ]
                        }, date.getTime())),
                    groupIndex < entries.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                ]
            }, eventId))
    }) : '';
    // Construire le tooltip détaillé pour les compteurs (si disponible dans employerData)
    // templateNamesMap permet d'afficher le nom du template au lieu de l'_id quand l'API ne renvoie pas workerCounter.template
    const countersTooltip = (()=>{
        const counters = weekSummary?.totals?.employerData?.counters;
        if (!counters || typeof counters !== 'object') return undefined;
        const templateNamesMap = worker.workerCounters?.reduce((acc, wc)=>{
            const id = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(wc.template);
            if (id && wc.template?.name) acc[id] = wc.template.name;
            return acc;
        }, {}) ?? {};
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2528183c082d0ad9$export$e51287a45280f8f7), {
            counters: counters,
            templateNamesMap: templateNamesMap
        });
    })();
    return {
        ...baseData,
        // Nouvelles structures CellValue
        contractHours: $211eb3c50c25e8c2$var$createCellValue(weekSummary?.totals.durations.contract.total ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.contract.total) : '00h00'),
        worked: $211eb3c50c25e8c2$var$createCellValue(weekSummary?.totals.durations.worked.total ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.worked.total) : '0h00', weekSummary?.totals.durations.worked.total ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.worked.total) : '0'),
        nonEffective: $211eb3c50c25e8c2$var$createCellValue(weekSummary?.totals.durations.benefit ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.benefit) : '00h00', weekSummary?.totals.durations.benefit ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.benefit) : '0'),
        accounted: $211eb3c50c25e8c2$var$createCellValue(!weekSummary?.weekIsRecorded ? 'N/A' : (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.accounted || 0), weekSummary?.weekIsRecorded ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.accounted || 0) : undefined, !weekSummary?.weekIsRecorded),
        sentToCounters: $211eb3c50c25e8c2$var$createCellValue(weekSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined, weekSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined),
        // Structures CellValue pour les écarts (on affiche uniquement si l'écart est négatif)
        contractDiff: weekSummary?.totals?.durations?.worked?.contract?.diff < 0 ? $211eb3c50c25e8c2$var$createDurationDiffCellValue(weekSummary?.totals?.durations?.worked?.contract?.diff || 0.1, true) : $211eb3c50c25e8c2$var$createDurationDiffCellValue(0.1, true),
        contractDiffDecimal: $211eb3c50c25e8c2$var$createDurationDiffCellValue(weekSummary?.totals?.durations?.worked?.contract?.diff || 0.1, true, (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73), (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)),
        accountedHoursDecimal: weekSummary?.weekIsRecorded && (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.accounted || 0),
        accountedSentToCounters: weekSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(weekSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined,
        accountedSentToCountersDecimal: weekSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(weekSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined,
        // Tooltip détaillant la répartition par compteur
        accountedSentToCountersTooltip: countersTooltip,
        isRecorded: weekSummary?.weekIsRecorded || false,
        isValidated: weekSummary?.weekIsValidated || false,
        informativeEvents: informativeCount > 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    "data-tip": true,
                    "data-for": `informative-${worker._id}-${week.getTime()}`,
                    children: informativeCount
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                    id: `informative-${worker._id}-${week.getTime()}`,
                    effect: "solid",
                    place: "bottom",
                    children: informativeTooltip
                })
            ]
        }) : '',
        // Override les employer rules avec les vraies valeurs
        ...employerRulesValues,
        ...Object.keys(employerRulesDecimalValues).reduce((acc, key)=>{
            acc[`${key}_decimal`] = employerRulesDecimalValues[key] || '';
            return acc;
        }, {}),
        // Override les benefit events avec les vraies valeurs
        ...benefitEvents
    };
};
const $211eb3c50c25e8c2$export$db4f04e054a3ecf9 = (data, worker, totalEmployerRulesValues, totalEmployerRulesDecimalValues, totalBenefitEvents, totalInformativeEvents, totalInformativeEventsByEvent, events, negativeContractDiff)=>{
    const informativeEventsTotalNode = totalInformativeEvents > 0 ? (()=>{
        const tooltipId = `informative-total-${worker._id}`;
        const breakdownEntries = events.filter((e)=>e.type === 'informative').map((e)=>({
                event: e,
                count: totalInformativeEventsByEvent[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(e)] || 0
            })).filter(({ count: count })=>count > 0);
        const tooltipContent = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
            children: breakdownEntries.map(({ event: event, count: count }, i)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                    children: [
                        i > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        (0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event, true),
                        " x",
                        count
                    ]
                }, (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event)))
        });
        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    "data-tip": true,
                    "data-for": tooltipId,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                        children: totalInformativeEvents
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                    id: tooltipId,
                    effect: "solid",
                    place: "bottom",
                    children: tooltipContent
                })
            ]
        });
    })() : '';
    return {
        weekNumber: 'TOTAL',
        year: '',
        weekStart: data[0]?.weekStart || '',
        weekEnd: data[data.length - 1]?.weekEnd || '',
        weekStartDate: data[0]?.weekStartDate,
        weekEndDate: data[data.length - 1]?.weekEndDate,
        workerId: '',
        // Nouvelles structures CellValue pour les totaux
        contractHours: $211eb3c50c25e8c2$var$createCellValue(worker.weeksSummary?.totals.durations.contract.total ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(worker.weeksSummary.totals.durations.contract.total) : '0h'),
        worked: $211eb3c50c25e8c2$var$createCellValue(worker.weeksSummary?.totals.durations.worked.total ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(worker.weeksSummary.totals.durations.worked.total) : '0h', worker.weeksSummary?.totals.durations.worked.total ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(worker.weeksSummary.totals.durations.worked.total) : '0'),
        nonEffective: $211eb3c50c25e8c2$var$createCellValue(worker.weeksSummary?.totals.durations.benefit ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(worker.weeksSummary.totals.durations.benefit) : '0h', worker.weeksSummary?.totals.durations.benefit ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(worker.weeksSummary.totals.durations.benefit) : '0'),
        accounted: $211eb3c50c25e8c2$var$createCellValue(worker.weeksSummary?.totals.durations.accounted >= 0 ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(worker.weeksSummary.totals.durations.accounted) : undefined, worker.weeksSummary?.totals.durations.accounted >= 0 ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(worker.weeksSummary.totals.durations.accounted) : undefined),
        sentToCounters: $211eb3c50c25e8c2$var$createCellValue(worker.weeksSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(worker.weeksSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined, worker.weeksSummary?.totals.durations.counters ? (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)(worker.weeksSummary.totals.durations.counters.totalSendToCountersFromAccountedCounters) : undefined),
        // Structures CellValue pour les écarts
        contractDiff: $211eb3c50c25e8c2$var$createDurationDiffCellValue(negativeContractDiff || 0.1),
        contractDiffDecimal: $211eb3c50c25e8c2$var$createDurationDiffCellValue(negativeContractDiff || 0.1, false, (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73), (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)),
        isRecorded: false,
        isValidated: false,
        isTotalRow: true,
        informativeEvents: informativeEventsTotalNode,
        // Utiliser directement les valeurs déjà formatées par getRuleValuesFromSummary
        ...totalEmployerRulesValues,
        ...Object.keys(totalEmployerRulesDecimalValues).reduce((acc, key)=>{
            acc[`${key}_decimal`] = totalEmployerRulesDecimalValues[key] || '';
            return acc;
        }, {}),
        ...Object.keys(totalBenefitEvents).reduce((acc, key)=>{
            acc[key] = totalBenefitEvents[key] && totalBenefitEvents[key] > 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                    children: totalBenefitEvents[key]
                })
            }) : '';
            return acc;
        }, {})
    };
};




var $3ZYaX = parcelRequire("3ZYaX");










parcelRequire("3ZYaX");


/**
 * Composant générique pour les cellules et headers du tableau des semaines
 *
 * Gère l'affichage standardisé avec :
 * - Valeur décimale (heures décimales) en gras
 * - Valeur principale (heures:minutes) en petit en dessous
 * - État "N/A" en gris
 * - Tooltip optionnel
 * - Support pour headers simples et custom
 *
 * @param props - Props du composant
 * @returns Cellule ou header avec affichage standardisé
 */ const $dbd41c50f1dd7a8c$var$GenericCell = ({ cellValue: cellValue, title: title, tooltipContent: tooltipContent, showDecimal: showDecimal = true, children: children, tooltipId: tooltipId })=>{
    const id = tooltipId || `tooltip-${Math.random().toString(36).substr(2, 9)}`;
    // Déterminer le contenu à afficher
    let content;
    if (cellValue) {
        const { value: value, decimal: decimal, isNA: isNA, color: color } = cellValue;
        if (isNA) content = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            textColor: color || 'grey',
            children: value
        });
        else content = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            children: [
                showDecimal && decimal && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "strong",
                            textColor: color || 'black',
                            children: decimal
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "small",
                    children: value
                })
            ]
        });
    } else content = children || title;
    // Si pas de tooltip, retourner directement le contenu
    if (!tooltipContent) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        children: content
    });
    // Avec tooltip
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                "data-tip": true,
                "data-for": id,
                children: content
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $af72022a2115e300$export$2e2bcd8739ae039), {
                id: id,
                effect: "solid",
                place: "bottom",
                children: tooltipContent
            })
        ]
    });
};
var $dbd41c50f1dd7a8c$export$2e2bcd8739ae039 = $dbd41c50f1dd7a8c$var$GenericCell;


const $9e2ce1766db52c85$export$87f55aade528b252 = (weeklyHoursWorked, employerRules = [], events = [], hasInformativeEvents = false, onCloseWeek)=>{
    const benefitEvents = events.filter((e)=>e.type === 'benefit');
    const { setFilters: setFilters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions);
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const naviguateToSummary = (data)=>{
        const { weekStartDate: weekStartDate, weekEndDate: weekEndDate, workerId: workerId } = data;
        setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions, {
            ...(0, $7093b8da8664ce76$export$6ca32c220786ee65)[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).missions],
            start: new Date(weekStartDate || new Date()),
            end: new Date(weekEndDate || new Date()),
            user: [
                (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workerId)
            ],
            summaryMinimalMode: false
        });
        navigate('/summary');
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Sem.',
                accessor: 'weekNumber',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            row.original.isTotalRow ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "strong",
                                children: row.original.weekNumber
                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "a",
                                onClick: ()=>naviguateToSummary(row.original),
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "strong",
                                    children: row.original.weekNumber
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "small",
                                textColor: "grey",
                                children: row.original.year
                            })
                        ]
                    })
            },
            {
                Header: "P\xe9riode",
                accessor: 'weekStart',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            row.original.weekStart,
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            row.original.weekEnd
                        ]
                    })
            },
            {
                Header: 'Contrat',
                accessor: 'contractHours',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            row.original.contractHours.value,
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "small",
                                textColor: "grey",
                                children: row.original.contractHours.value ? 'h/sem' : ''
                            })
                        ]
                    })
            },
            {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                    title: "Travaill\xe9",
                    tooltipContent: "Heures r\xe9ellement travaill\xe9es pendant la semaine."
                }),
                accessor: 'worked',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                        cellValue: row.original.worked
                    })
            },
            {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                    title: "A d\xe9duire",
                    tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "A d\xe9duire entre les heures du contrat et la somme des heures travaill\xe9es",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " et des heures non effectives.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "small",
                                children: "(heures travaill\xe9es + heures non effectives) - heures contractuelles."
                            })
                        ]
                    })
                }),
                accessor: 'contractDiff',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                        cellValue: row.original.contractDiff
                    })
            },
            // Colonnes dynamiques pour les employer rules
            ...employerRules.map((rule)=>({
                    Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: rule.shortName
                    }),
                    accessor: `rule_${rule.ruleId}`,
                    Cell: ({ row: row })=>{
                        const formattedValue = row.original[`rule_${rule.ruleId}`];
                        const decimalValue = row.original[`rule_${rule.ruleId}_decimal`];
                        // Créer une CellValue pour cette règle
                        const cellValue = {
                            value: formattedValue,
                            decimal: rule.kind !== 'goal' ? decimalValue : undefined
                        };
                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                            cellValue: cellValue
                        });
                    }
                })),
            // Colonnes pour les benefit events
            ...benefitEvents.map((event)=>({
                    Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        title: (0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event),
                        children: event.code
                    }),
                    accessor: `event_${event.code}`
                })),
            // Colonne pour les évènements informatifs (seulement si il y en a)
            ...hasInformativeEvents ? [
                {
                    Header: "Ev\xe8n. Info",
                    accessor: 'informativeEvents'
                }
            ] : [],
            {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                    title: "Compteurs",
                    tooltipContent: "Impact total sur les compteurs suite \xe0 la cloture de la semaine."
                }),
                accessor: 'sentToCounters',
                Cell: ({ row: row })=>{
                    const isTotalRow = row.original.isTotalRow;
                    const isRecorded = row.original.isRecorded;
                    if (!isTotalRow && !isRecorded) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "grey",
                        children: "N/A"
                    });
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                        cellValue: row.original.sentToCounters,
                        tooltipContent: row.original.accountedSentToCountersTooltip
                    });
                }
            },
            {
                Header: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                    title: "Compta.",
                    tooltipContent: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "Heures comptabilis\xe9es suite \xe0 la cloture de la semaine. ",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Heures travaill\xe9es + heures prises ou envoy\xe9es aux compteurs."
                        ]
                    })
                }),
                accessor: 'accounted',
                Cell: ({ row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                        cellValue: row.original.accounted
                    })
            },
            {
                Header: 'Statut',
                accessor: 'isValidated',
                Cell: ({ row: row })=>{
                    const { isValidated: isValidated, isRecorded: isRecorded, weekNumberValue: weekNumberValue, yearValue: yearValue, contractHours: contractHours } = row.original;
                    const canOpen = Boolean(onCloseWeek && weekNumberValue && yearValue);
                    // Si pas de données (contractHours === '---'), afficher "Pas de mission"
                    if (contractHours.value === '---' || row.original.isTotalRow) return null;
                    if (!isValidated) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $044c47f4b5e1e1ae$export$2e2bcd8739ae039), {
                        text: `Journ\xe9e(s) non valid\xe9e(s)`,
                        icon: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {}),
                        iconColor: "danger",
                        "data-test": "week-not-validated",
                        small: true
                    });
                    if (isValidated && !isRecorded) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dbd41c50f1dd7a8c$export$2e2bcd8739ae039), {
                        tooltipContent: "Cl\xf4turer la semaine",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            color: "primary",
                            disabled: !canOpen,
                            "data-test": `close-week-button-${weekNumberValue}-${yearValue}`,
                            onClick: ()=>canOpen && onCloseWeek && onCloseWeek(weekNumberValue, yearValue),
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                            })
                        })
                    });
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textColor: "success",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b854228d56ab86b$export$34068b40256a87f7), {
                            mission: {
                                weekIsValidated: true
                            },
                            text: "Semaine Cl\xf4tur\xe9e",
                            small: true
                        })
                    });
                }
            }
        ], [
        weeklyHoursWorked,
        employerRules,
        events,
        hasInformativeEvents,
        onCloseWeek
    ]);
};







const $0087ac585dbae144$export$866c2f476e8577f3 = (weeks, worker, events, employerRules)=>{
    // Comptage global des benefit events sur l'ensemble des semaines pour filtrer les colonnes
    const totalBenefitEvents = weeks.reduce((totals, week)=>{
        const weekSummary = worker.weeksSummary?.weeks.find((w)=>w.missions[0]?.workPeriods[0] && (0, $5676184ed61a60f3$export$2e2bcd8739ae039)(week, new Date(w.missions[0]?.workPeriods[0].start.date), {
                locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
                weekStartsOn: 1
            }));
        events.filter((e)=>e.type === 'benefit').forEach((event)=>{
            const eventCount = weekSummary?.missions.reduce((totalCount, mission)=>{
                return totalCount + mission.workPeriods.reduce((missionCount, workPeriod)=>{
                    return missionCount + workPeriod.events.filter((we)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(we.item) === (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event)).length;
                }, 0);
            }, 0) || 0;
            totals[`event_${event.code}`] = (totals[`event_${event.code}`] || 0) + eventCount;
        });
        return totals;
    }, {});
    // Total des évènements informatifs et détail par event (pour la colonne + popover totaux)
    const totalInformativeEventsByEvent = weeks.reduce((totals, week)=>{
        const weekSummary = worker.weeksSummary?.weeks.find((w)=>w.missions[0]?.workPeriods[0] && (0, $5676184ed61a60f3$export$2e2bcd8739ae039)(week, new Date(w.missions[0]?.workPeriods[0].start.date), {
                locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
                weekStartsOn: 1
            }));
        events.filter((e)=>e.type === 'informative').forEach((event)=>{
            const eventCount = weekSummary?.missions.reduce((totalCount, mission)=>{
                return totalCount + mission.workPeriods.reduce((missionCount, workPeriod)=>{
                    return missionCount + workPeriod.events.filter((we)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(we.item) === (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event)).length;
                }, 0);
            }, 0) || 0;
            const id = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event);
            totals[id] = (totals[id] || 0) + eventCount;
        });
        return totals;
    }, {});
    const totalInformativeEvents = Object.values(totalInformativeEventsByEvent).reduce((sum, n)=>sum + n, 0);
    // Utiliser les totaux de UserSummaries.totals
    const totalEmployerRulesValues = worker.weeksSummary?.totals && employerRules ? (0, $2c246fb177fe9551$export$1e2c8d86c7262067)(employerRules, worker.weeksSummary.totals) : {};
    const totalEmployerRulesDecimalValues = worker.weeksSummary?.totals && employerRules ? (0, $2c246fb177fe9551$export$1e2c8d86c7262067)(employerRules, worker.weeksSummary.totals, (0, $74f17ceb9b5a08a5$export$f3e3e7d660379b73)) : {};
    // Le backend ne calcule pas le total des écarts négatifs => on le calcule manuellement pour l'instant
    const negativeContractDiff = worker.weeksSummary?.weeks.reduce((acc, week)=>{
        const value = week.totals?.durations?.worked?.contract?.diff < 0 ? week.totals?.durations?.worked?.contract?.diff : 0;
        return acc + value;
    }, 0);
    return {
        totalBenefitEvents: totalBenefitEvents,
        totalInformativeEvents: totalInformativeEvents,
        totalInformativeEventsByEvent: totalInformativeEventsByEvent,
        totalEmployerRulesValues: totalEmployerRulesValues,
        totalEmployerRulesDecimalValues: totalEmployerRulesDecimalValues,
        negativeContractDiff: negativeContractDiff
    };
};
const $0087ac585dbae144$export$1cd7756835cfb66b = (events, totalBenefitEvents)=>{
    const allBenefitEvents = events.filter((e)=>e.type === 'benefit');
    const visibleBenefitEvents = allBenefitEvents.filter((e)=>(totalBenefitEvents[`event_${e.code}`] || 0) > 0);
    const hiddenBenefitEvents = allBenefitEvents.filter((e)=>(totalBenefitEvents[`event_${e.code}`] || 0) === 0);
    return {
        visibleBenefitEvents: visibleBenefitEvents,
        hiddenBenefitEvents: hiddenBenefitEvents
    };
};




var $3ZYaX = parcelRequire("3ZYaX");



var $2KSUA = parcelRequire("2KSUA");
/**
 * Composant pour afficher les données de paie par semaine pour un worker
 *
 * Affiche un tableau avec une ligne par semaine contenant :
 * - Numéro de semaine et année
 * - Période de la semaine
 * - Heures contractuelles vs travaillées
 * - Heures supplémentaires
 * - Pauses
 * - Statut de validation et enregistrement
 */ const $0481f5de9e903de7$var$PayrollWeeksTable = ({ worker: worker, weeks: weeks, events: events, onCloseWeek: onCloseWeek })=>{
    // Récupérer les employer rules depuis la première semaine disponible
    const employerRules = (0, $2KSUA.uniqBy)(worker.weeksSummary?.weeks.flatMap((w)=>w.employerRules) || [], 'ruleId');
    // Calculer les totaux
    const { totalBenefitEvents: totalBenefitEvents, totalInformativeEvents: totalInformativeEvents, totalInformativeEventsByEvent: totalInformativeEventsByEvent, totalEmployerRulesValues: totalEmployerRulesValues, totalEmployerRulesDecimalValues: totalEmployerRulesDecimalValues, negativeContractDiff: negativeContractDiff } = (0, $0087ac585dbae144$export$866c2f476e8577f3)(weeks, worker, events, employerRules);
    // Filtrer les events par occurrence
    const { visibleBenefitEvents: visibleBenefitEvents } = (0, $0087ac585dbae144$export$1cd7756835cfb66b)(events, totalBenefitEvents);
    const hasInformativeEvents = totalInformativeEvents > 0;
    const tableColumns = (0, $9e2ce1766db52c85$export$87f55aade528b252)(worker.weeklyHoursWorked, employerRules, visibleBenefitEvents, hasInformativeEvents, onCloseWeek);
    // Transformation des données en lignes de tableau
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>weeks.map((week)=>(0, $211eb3c50c25e8c2$export$486e5878dd6b6a25)(week, worker, events, employerRules)), [
        weeks,
        worker,
        events,
        employerRules
    ]);
    // Ajouter la ligne de totaux
    data.push((0, $211eb3c50c25e8c2$export$db4f04e054a3ecf9)(data, worker, totalEmployerRulesValues, totalEmployerRulesDecimalValues, totalBenefitEvents, totalInformativeEvents, totalInformativeEventsByEvent, events, negativeContractDiff));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
            columns: tableColumns,
            data: data,
            noDataMessage: "Aucune semaine \xe0 afficher",
            dataTest: "payroll-weeks-table"
        })
    });
};
var $0481f5de9e903de7$export$2e2bcd8739ae039 = $0481f5de9e903de7$var$PayrollWeeksTable;






var $3ZYaX = parcelRequire("3ZYaX");


var $2KSUA = parcelRequire("2KSUA");






/** Layout: label and count stay side-by-side (readable on wide cards). */ const $ddd57932c1a15880$var$SUMMARY_LINE_STYLE = {
    display: 'inline-flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    gap: '0.35rem'
};
const $ddd57932c1a15880$var$LIST_STYLE = {
    margin: 0,
    paddingLeft: '1.25rem'
};
const $ddd57932c1a15880$var$DETAIL_LIST_STYLE = {
    margin: '0.35rem 0 0 0',
    paddingLeft: '1.25rem',
    listStyleType: 'circle'
};
/**
 * Resolves the week summary row for a calendar week (same matching as payroll totals).
 */ const $ddd57932c1a15880$var$findWeekSummaryForDisplayedWeek = (worker, week)=>{
    return worker.weeksSummary?.weeks.find((w)=>w.missions[0]?.workPeriods[0] && (0, $74f17ceb9b5a08a5$export$6ea683876c36b8d2)(week, new Date(w.missions[0].workPeriods[0].start.date)));
};
/**
 * Collects every occurrence date (work period start day) per work-period-event definition id,
 * limited to the displayed weeks interval.
 */ const $ddd57932c1a15880$var$collectOccurrenceDatesByEventId = (worker, weeks)=>{
    const result = new Map();
    for (const week of weeks){
        const weekSummary = $ddd57932c1a15880$var$findWeekSummaryForDisplayedWeek(worker, week);
        if (!weekSummary) continue;
        for (const mission of weekSummary.missions)for (const workPeriod of mission.workPeriods){
            const dayStart = new Date(workPeriod.start.date);
            for (const we of workPeriod.events){
                const eventDefId = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(we.item);
                const list = result.get(eventDefId) ?? [];
                list.push(dayStart);
                result.set(eventDefId, list);
            }
        }
    }
    return result;
};
/**
 * Groups raw occurrence timestamps by calendar day, sorted chronologically.
 */ const $ddd57932c1a15880$var$groupOccurrencesByCalendarDay = (dates)=>{
    if (dates.length === 0) return [];
    const counts = new Map();
    for (const d of dates){
        const k = (0, $b3177a4462e15523$export$2e2bcd8739ae039)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(d), 'yyyy-MM-dd');
        counts.set(k, (counts.get(k) || 0) + 1);
    }
    return [
        ...counts.entries()
    ].sort(([a], [b])=>a.localeCompare(b)).map(([dayKey, count])=>({
            label: (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(`${dayKey}T12:00:00`)),
            count: count
        }));
};
/**
 * Filters by event type, maps to counts, drops zero counts, sorts by code (case/accent insensitive).
 */ const $ddd57932c1a15880$var$buildPayrollEventSummaryRows = (events, eventType, getCount)=>{
    const withCode = events.filter((e)=>e.type === eventType).map((event)=>({
            event: event,
            count: getCount(event),
            code: event.code
        })).filter((r)=>r.count > 0);
    return (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(withCode, 'code').map(({ event: event, count: count })=>({
            event: event,
            count: count
        }));
};
/**
 * One section: title, optional link toggle, list of events with counts; expanded shows dates per event.
 */ const $ddd57932c1a15880$var$PayrollEventsSummarySection = ({ title: title, rows: rows, kind: kind, occurrenceDatesByEventId: occurrenceDatesByEventId, sectionId: sectionId, emptyMessage: emptyMessage })=>{
    const [detailsExpanded, setDetailsExpanded] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const detailsIdPrefix = `payroll-events-summary-details-${sectionId}`;
    const controlledIds = rows.map((r)=>`${detailsIdPrefix}-${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(r.event)}`).join(' ');
    if (rows.length === 0) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        textColor: "grey",
        textSize: 6,
        children: emptyMessage
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                mb: 2,
                style: {
                    gap: '0.75rem'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textWeight: "semibold",
                        textSize: 6,
                        mb: 0,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        type: "button",
                        text: true,
                        color: "link",
                        size: "small",
                        className: "p-0",
                        style: {
                            height: 'auto',
                            textDecoration: 'underline'
                        },
                        "aria-expanded": detailsExpanded,
                        "aria-controls": detailsExpanded ? controlledIds : undefined,
                        "data-test": `payroll-events-summary-toggle-${sectionId}`,
                        onClick: ()=>setDetailsExpanded((v)=>!v),
                        children: detailsExpanded ? "Masquer les d\xe9tails" : "Afficher les d\xe9tails"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "ul",
                style: $ddd57932c1a15880$var$LIST_STYLE,
                children: rows.map(({ event: event, count: count })=>{
                    const rowKey = kind === 'benefit' ? event.code : (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event);
                    const eventId = (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event);
                    const rawDates = occurrenceDatesByEventId.get(eventId) ?? [];
                    const dayGroups = $ddd57932c1a15880$var$groupOccurrencesByCalendarDay(rawDates);
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "li",
                        "data-test": `payroll-events-summary-${kind}-${event.code}`,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                style: $ddd57932c1a15880$var$SUMMARY_LINE_STYLE,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        children: (0, $a58cd4802ae2892e$export$8cdd78f580711f43)(event, true)
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        textColor: "grey",
                                        textSize: 6,
                                        children: [
                                            "\xd7 ",
                                            count
                                        ]
                                    })
                                ]
                            }),
                            detailsExpanded && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "ul",
                                id: `${detailsIdPrefix}-${eventId}`,
                                style: $ddd57932c1a15880$var$DETAIL_LIST_STYLE,
                                "data-test": `payroll-events-summary-dates-${kind}-${event.code}`,
                                children: dayGroups.length === 0 ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        textColor: "grey",
                                        textSize: 7,
                                        children: "Aucune date d\xe9taill\xe9e"
                                    })
                                }) : dayGroups.map(({ label: label, count: dayCount })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "li",
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textSize: 7,
                                            children: dayCount > 1 ? `${label} (\xd7 ${dayCount})` : label
                                        })
                                    }, `${event.code}-${label}`))
                            })
                        ]
                    }, rowKey);
                })
            })
        ]
    });
};
/**
 * Lists work period events with counts on displayed weeks; each section can expand to show dates.
 */ const $ddd57932c1a15880$var$PayrollEventsSummary = ({ worker: worker, weeks: weeks, events: events })=>{
    const employerRules = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>(0, $2KSUA.uniqBy)(worker.weeksSummary?.weeks.flatMap((w)=>w.employerRules) || [], 'ruleId'), [
        worker.weeksSummary?.weeks
    ]);
    const { totalBenefitEvents: totalBenefitEvents, totalInformativeEventsByEvent: totalInformativeEventsByEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>(0, $0087ac585dbae144$export$866c2f476e8577f3)(weeks, worker, events, employerRules), [
        weeks,
        worker,
        events,
        employerRules
    ]);
    const occurrenceDatesByEventId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>$ddd57932c1a15880$var$collectOccurrenceDatesByEventId(worker, weeks), [
        worker,
        weeks
    ]);
    const benefitRows = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>$ddd57932c1a15880$var$buildPayrollEventSummaryRows(events, 'benefit', (e)=>totalBenefitEvents[`event_${e.code}`] || 0), [
        events,
        totalBenefitEvents
    ]);
    const informativeRows = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>$ddd57932c1a15880$var$buildPayrollEventSummaryRows(events, 'informative', (e)=>totalInformativeEventsByEvent[(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(e)] || 0), [
        events,
        totalInformativeEventsByEvent
    ]);
    const hasAny = benefitRows.length > 0 || informativeRows.length > 0;
    if (weeks.length === 0) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
        mt: 4,
        "data-test": "payroll-events-summary",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 6,
                mb: 3,
                children: "R\xe9sum\xe9 des \xe9v\xe9nements"
            }),
            !hasAny ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                textColor: "grey",
                textSize: 6,
                children: "Aucun \xe9v\xe9nement prestation ou informatif sur cette p\xe9riode pour ce salari\xe9."
            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                display: "flex",
                flexDirection: "column",
                style: {
                    gap: '1rem'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ddd57932c1a15880$var$PayrollEventsSummarySection, {
                        title: "\xc9v\xe9nements prestation",
                        rows: benefitRows,
                        kind: "benefit",
                        occurrenceDatesByEventId: occurrenceDatesByEventId,
                        sectionId: "benefit",
                        emptyMessage: "Aucun \xe9v\xe9nement prestation sur cette p\xe9riode pour ce salari\xe9."
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($ddd57932c1a15880$var$PayrollEventsSummarySection, {
                        title: "\xc9v\xe9nements informatifs",
                        rows: informativeRows,
                        kind: "informative",
                        occurrenceDatesByEventId: occurrenceDatesByEventId,
                        sectionId: "informative",
                        emptyMessage: "Aucun \xe9v\xe9nement informatif sur cette p\xe9riode pour ce salari\xe9."
                    })
                ]
            })
        ]
    });
};
var $ddd57932c1a15880$export$2e2bcd8739ae039 = $ddd57932c1a15880$var$PayrollEventsSummary;



var $3ZYaX = parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");


function $f43429588e550a3f$export$de33605a69190f59(start, end) {
    return (0, $3ZYaX.useMemo)(()=>{
        if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return undefined;
        try {
            return (0, $9b8ab39a46fc8509$export$2e2bcd8739ae039)({
                start: start,
                end: end
            }, {
                locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039),
                weekStartsOn: 1
            });
        } catch  {
            return undefined;
        }
    }, [
        start,
        end
    ]);
}








var $3ZYaX = parcelRequire("3ZYaX");

function $86a7ad3c6b2ce5b8$export$ed14f2d7b37d4a12(workers, currentWorkerId) {
    // Build the navigable subset according to the provided filter
    const navigableWorkers = workers;
    // Compute the current index within the navigable subset
    const currentIndex = (0, $3ZYaX.useMemo)(()=>{
        if (!currentWorkerId) return -1;
        return navigableWorkers.findIndex((w)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(w) === currentWorkerId);
    }, [
        currentWorkerId,
        navigableWorkers
    ]);
    // Navigation availability when the current item is not part of the navigable list
    const hasPrev = currentIndex > 0 || currentIndex === -1 && navigableWorkers.length > 0;
    const hasNext = currentIndex >= 0 && currentIndex < navigableWorkers.length - 1 || currentIndex === -1 && navigableWorkers.length > 1;
    // Compute navigation targets (pure, no side-effects)
    const goPrev = (0, $3ZYaX.useCallback)(()=>{
        if (!hasPrev) return undefined;
        if (currentIndex === -1) return navigableWorkers[0] ? (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[0]) : undefined;
        return (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[currentIndex - 1]);
    }, [
        hasPrev,
        currentIndex,
        navigableWorkers
    ]);
    const goNext = (0, $3ZYaX.useCallback)(()=>{
        if (!hasNext) return undefined;
        if (currentIndex === -1) {
            if (navigableWorkers[1]) return (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[1]);
            return navigableWorkers[0] ? (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[0]) : undefined;
        }
        return (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[currentIndex + 1]);
    }, [
        hasNext,
        currentIndex,
        navigableWorkers
    ]);
    // Resolve current worker and navigable worker references
    const currentWorker = (0, $3ZYaX.useMemo)(()=>{
        if (!currentWorkerId) return undefined;
        return workers.find((w)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(w) === currentWorkerId);
    }, [
        currentWorkerId,
        workers
    ]);
    const currentNavigableWorker = (0, $3ZYaX.useMemo)(()=>{
        if (!currentWorkerId) return undefined;
        return navigableWorkers.find((w)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(w) === currentWorkerId);
    }, [
        currentWorkerId,
        navigableWorkers
    ]);
    // Resolve a safe current id within the navigable subset when needed
    const resolvedCurrentWorkerId = (0, $3ZYaX.useMemo)(()=>{
        if (!currentWorkerId && navigableWorkers.length > 0) return (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[0]);
        if (currentWorkerId) {
            const stillExists = navigableWorkers.some((w)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(w) === currentWorkerId);
            if (!stillExists && navigableWorkers.length > 0) {
                const boundedIndex = Math.min(Math.max(currentIndex, 0), navigableWorkers.length - 1);
                return (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(navigableWorkers[boundedIndex]);
            }
        }
        return undefined;
    }, [
        currentWorkerId,
        navigableWorkers,
        currentIndex
    ]);
    return {
        navigableWorkers: navigableWorkers,
        currentIndex: currentIndex,
        hasPrev: hasPrev,
        hasNext: hasNext,
        currentWorker: currentWorker,
        currentNavigableWorker: currentNavigableWorker,
        resolvedCurrentWorkerId: resolvedCurrentWorkerId,
        goPrev: goPrev,
        goNext: goNext
    };
}



var $2KSUA = parcelRequire("2KSUA");
/**
 * Détermine le statut de clôture d'un worker basé sur ses semaines
 * @param weeksSummary - Résumé des semaines du worker
 * @returns Le statut de clôture du worker
 */ const $1a56d15249f8c039$var$getWorkerWeekStatus = (weeksSummary)=>{
    if (!weeksSummary) return 'needsValidation';
    const { recordedWeeks: recordedWeeks, validatedWeeks: validatedWeeks, totalWeeks: totalWeeks } = weeksSummary;
    // Si toutes les semaines sont enregistrées (clôturées)
    if (recordedWeeks === totalWeeks) return 'closed';
    // Si toutes les semaines sont validées mais pas encore enregistrées
    if (validatedWeeks === totalWeeks) return 'readyToClose';
    // Sinon, il y a des semaines qui nécessitent une validation
    return 'needsValidation';
};
const $1a56d15249f8c039$export$9b590e1e4b5e556b = (currentOrganization, filters, currentWorkerId)=>{
    // Query pour récupérer tous les workers de l'organisation
    const workersQuery = (0, $e607e015ac40917d$export$ad43217ee1485bda)({
        // Narrow the literal type to match MissionContractModel
        contractModel: [
            'twoParties'
        ],
        service: filters?.service,
        'start<': filters?.end,
        'end>': filters?.start,
        user: filters?.user,
        jobTitle: filters?.jobTitle
    });
    // Query pour récupérer tous les événements de période de travail
    const allWorkPeriodEvents = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)();
    // Query pour récupérer le statut des semaines
    const weeksSummaryStatusQuery = (0, $e409591b67738e56$export$e84704a7c7ffcb81)({
        from: filters?.start,
        to: filters?.end,
        user: (workersQuery.data || []).map((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)),
        contractModel: [
            'twoParties'
        ]
    }, {
        enabled: Boolean(filters?.start && filters?.end && workersQuery.data?.[0] && !workersQuery.isLoading)
    });
    // Calcul des semaines dans la période sélectionnée (hook dédié)
    const weeks = (0, $f43429588e550a3f$export$de33605a69190f59)(filters?.start, filters?.end);
    // Tableau unifié des workers avec toutes leurs données agrégées
    const payrollWorkers = (0, $3ZYaX.useMemo)(()=>{
        if (!workersQuery.data || !weeksSummaryStatusQuery.data) return [];
        let res = (0, $2KSUA.sortBy)(workersQuery.data.map((worker)=>{
            const association = (0, $25ffbf4bca475b04$export$91d1acdd7472079)(worker, currentOrganization);
            const weeksSummaryStatus = weeksSummaryStatusQuery.data.users.find((summary)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(summary.user, worker));
            return {
                ...worker,
                association: association,
                weeksSummary: weeksSummaryStatus,
                workerCounters: undefined,
                weeklyHoursWorked: association ? (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association)?.weeklyHoursWorked : undefined
            };
        }), 'lastName');
        // Appliquer les filtres de statut des semaines
        const weekStatuses = filters.weekStatuses;
        res = !weekStatuses?.length ? res : res.filter((worker)=>{
            const workerStatus = $1a56d15249f8c039$var$getWorkerWeekStatus(worker.weeksSummary);
            return weekStatuses.includes(workerStatus);
        });
        return res;
    }, [
        workersQuery.data,
        weeksSummaryStatusQuery.data,
        currentOrganization,
        filters.weekStatuses
    ]);
    // Navigation extraite dans un hook dédié
    const { navigableWorkers: navigableWorkers, currentIndex: currentIndex, hasPrev: hasPrev, hasNext: hasNext, currentWorker: currentWorker, currentNavigableWorker: currentNavigableWorker, resolvedCurrentWorkerId: resolvedCurrentWorkerId, goPrev: goPrev, goNext: goNext } = (0, $86a7ad3c6b2ce5b8$export$ed14f2d7b37d4a12)(payrollWorkers, currentWorkerId);
    // Deprecated path: kept for backward compatibility during migration (returns undefined)
    const currentWorkerWithWeeksSummary = undefined;
    return {
        payrollWorkers: // Données principales
        payrollWorkers,
        allWorkPeriodEvents: allWorkPeriodEvents.data || [],
        weeks: weeks,
        weeksSummaryStatus: weeksSummaryStatusQuery.data,
        currentWorkerWithWeeksSummary: currentWorkerWithWeeksSummary,
        // États de chargement
        isLoading: workersQuery.isLoading || allWorkPeriodEvents.isLoading,
        navigableWorkers: // Navigation
        navigableWorkers,
        currentIndex: currentIndex,
        hasPrev: hasPrev,
        hasNext: hasNext,
        currentWorker: currentWorker,
        currentNavigableWorker: currentNavigableWorker,
        resolvedCurrentWorkerId: resolvedCurrentWorkerId,
        goPrev: goPrev,
        goNext: goNext
    };
};





var $3ZYaX = parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");




const $22f91b9654599cb0$export$e7aa7bc5c1b3cfb3 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/worker-counter-templates',
        method: 'get',
        params: {
            sort: '-createdAt name',
            populate: [
                'employer',
                'employerRules'
            ],
            ...params
        }
    });
};
const $22f91b9654599cb0$export$3988ae62b71be9a3 = async (id)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counter-templates/${id}`,
        method: 'GET',
        params: {
            populate: [
                'employer',
                'employerRules'
            ]
        }
    });
};
const $22f91b9654599cb0$export$185802fd694ee1f5 = async (params)=>{
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/worker-counter-templates',
        method: 'post',
        params: params
    });
};
const $22f91b9654599cb0$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...rest } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/worker-counter-templates/${id}`,
        method: 'put',
        params: rest
    });
};


const $ac19d08459c4c77e$export$b7549eebff4322c5 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('worker-counter-templates', (0, $22f91b9654599cb0$export$e7aa7bc5c1b3cfb3), filters || {}, options);
const $ac19d08459c4c77e$export$ef6e414138634c4d = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('worker-counter-templates', (0, $22f91b9654599cb0$export$3988ae62b71be9a3), id, undefined, {
        enabled: Boolean(id),
        ...options
    });
/**
 * Callback function to invalidate related queries after mutations
 */ const $ac19d08459c4c77e$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'worker-counter-templates'
    ]);
};
const $ac19d08459c4c77e$export$4328fc3aacfdc2d9 = ()=>[
        'worker-counter-templates',
        'create'
    ];
const $ac19d08459c4c77e$export$a6551c95c842696d = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $22f91b9654599cb0$export$185802fd694ee1f5), {
        mutationKey: $ac19d08459c4c77e$export$4328fc3aacfdc2d9(),
        onSuccess: $ac19d08459c4c77e$var$onMutationSuccess
    });
const $ac19d08459c4c77e$export$e2d968ca0a037d08 = ()=>[
        'worker-counter-templates',
        'update'
    ];
const $ac19d08459c4c77e$export$86e695b3e640295f = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $22f91b9654599cb0$export$722fbec263ad908a), {
        mutationKey: $ac19d08459c4c77e$export$e2d968ca0a037d08(),
        onSuccess: $ac19d08459c4c77e$var$onMutationSuccess
    });



const $8af009542d963d6d$export$5b20dd6cf8d65056 = (workerId, organizationId)=>{
    // Fetch worker-specific counters
    const workerQuery = (0, $8e9b7320493de555$export$ec101cf448daac1)({
        employer: organizationId,
        worker: workerId
    }, {
        enabled: Boolean(workerId && organizationId)
    });
    // Fetch employer templates to know which counters should exist
    const templatesQuery = (0, $ac19d08459c4c77e$export$b7549eebff4322c5)({
        employer: organizationId
    }, {
        enabled: Boolean(organizationId)
    });
    // Mutation to create or get missing counters
    const createOrGetMutation = (0, $8e9b7320493de555$export$ca93ef397853eaa8)();
    // Side effect: for any template that is missing, trigger a create-or-get
    (0, $3ZYaX.useEffect)(()=>{
        const workerCounters = workerQuery.data || [];
        const templates = templatesQuery.data || [];
        if (!workerId || !organizationId || templates.length === 0) return;
        for (const tmpl of templates){
            const existingCounter = workerCounters.some((c)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(c.template, tmpl));
            if (existingCounter) continue;
            createOrGetMutation.mutateAsync({
                employer: organizationId,
                worker: workerId,
                template: tmpl._id
            });
        }
    }, [
        workerId,
        organizationId,
        workerQuery.data,
        templatesQuery.data
    ]);
    // Re-expose the workerQuery result object to keep query state/methods stable
    // but override its data with our merged list.
    return {
        ...workerQuery,
        data: workerQuery.data
    };
};


const $6bac687dfd77cb01$export$9655bc489a4afcbb = (currentOrganization, filters, currentWorkerId)=>{
    const workersQuery = (0, $e607e015ac40917d$export$ad43217ee1485bda)({
        contractModel: [
            'twoParties'
        ],
        service: filters?.service,
        'start<': filters?.end,
        'end>': filters?.start,
        user: currentWorkerId ? [
            currentWorkerId
        ] : filters?.user
    });
    const currentWorkerWeeksSummaryQuery = (0, $e409591b67738e56$export$9a76bd0612b2790c)({
        from: filters?.start,
        to: filters?.end,
        user: currentWorkerId ? [
            currentWorkerId
        ] : undefined,
        contractModel: [
            'twoParties'
        ]
    }, {
        enabled: Boolean(currentWorkerId && filters?.start && filters?.end)
    });
    const workerCountersQuery = (0, $8af009542d963d6d$export$5b20dd6cf8d65056)(currentWorkerId, currentOrganization?._id);
    return (0, $3ZYaX.useMemo)(()=>{
        if (!currentWorkerId || !workersQuery.data || !currentWorkerWeeksSummaryQuery.data) return undefined;
        const worker = workersQuery.data.find((w)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(w) === currentWorkerId);
        if (!worker) return undefined;
        const association = (0, $25ffbf4bca475b04$export$91d1acdd7472079)(worker, currentOrganization);
        const weeksSummaryForWorker = currentWorkerWeeksSummaryQuery.data.find((summary)=>(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(summary.user) === (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(worker));
        if (!weeksSummaryForWorker) return undefined;
        return {
            ...worker,
            association: association,
            weeksSummary: weeksSummaryForWorker,
            workerCounters: workerCountersQuery.data ?? undefined,
            weeklyHoursWorked: association ? (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association)?.weeklyHoursWorked : undefined
        };
    }, [
        currentWorkerId,
        workersQuery.data,
        currentWorkerWeeksSummaryQuery.data,
        currentOrganization,
        workerCountersQuery.data
    ]);
};








parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");




const $778c83e80a04c032$export$a967f4bbd98241d4 = (formValues, counters)=>{
    return Object.entries(formValues.counters).map(([counterId, counter])=>{
        // Calcul de l'adjustment selon le mode choisi
        let adjustment = 0;
        const calculatedHours = counters[counterId]?.ruleBasedIncrement || 0;
        switch(counter.mode){
            case 'toCounter':
                // Tout vers le compteur : on ajoute toute la durée calculée dans le compteur
                adjustment = calculatedHours;
                break;
            case 'toWeek':
                // Tout dans la semaine : on n'ajoute rien dans le compteur
                // Si on récupère des heures depuis le compteur, on retire la durée récupérée du compteur
                adjustment = -(counter.recoveryFromCounter || 0);
                break;
            case 'split':
                // Répartition partielle : on ajoute la partie qui va dans le compteur (splitToCounter)
                adjustment = counter.splitToCounter || 0;
                break;
            default:
                adjustment = 0;
        }
        return {
            counterTemplateId: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(counters[counterId]?.workerCounter?.template),
            adjustment: adjustment
        };
    });
};




var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");


parcelRequire("3ZYaX");


/**
 * Composant pour saisir des heures et minutes séparément
 * Gère automatiquement la conversion timestamp ↔ heures/minutes
 * S'intègre avec Formik comme les autres champs
 */ const $10ac5e99cbb8af09$var$TimeInputField = ({ field: field, form: form, label: label, hoursLabel: hoursLabel = 'Heures', minutesLabel: minutesLabel = 'Minutes', maxHours: maxHours, maxMinutes: maxMinutes = 59, disabled: disabled = false, help: help, required: required })=>{
    // Conversion du timestamp en heures et minutes
    const timestampToHoursMinutes = (timestamp)=>{
        if (!timestamp || timestamp <= 0) return {
            hours: '',
            minutes: ''
        };
        const totalMinutes = Math.floor(timestamp / 60000);
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return {
            hours: hours.toString(),
            minutes: minutes.toString().padStart(2, '0')
        };
    };
    // Conversion des heures et minutes en timestamp
    const hoursMinutesToTimestamp = (hours, minutes)=>{
        const hoursNum = parseInt(hours || '0', 10);
        const minutesNum = parseInt(minutes || '0', 10);
        if (isNaN(hoursNum) || isNaN(minutesNum) || hoursNum < 0 || minutesNum < 0) return 0;
        return (hoursNum * 60 + minutesNum) * 60000;
    };
    // Valeurs actuelles converties depuis le timestamp
    const { hours: currentHours, minutes: currentMinutes } = timestampToHoursMinutes(field.value || 0);
    // Gestion des erreurs
    const hoursError = form.errors[`${field.name}_hours`];
    const minutesError = form.errors[`${field.name}_minutes`];
    const hasError = hoursError || minutesError;
    const error = hasError ? [
        hoursError,
        minutesError
    ].filter(Boolean).join(', ') : undefined;
    // Mise à jour du timestamp quand les heures ou minutes changent
    const updateTimestamp = (hours, minutes)=>{
        const timestamp = hoursMinutesToTimestamp(hours, minutes);
        form.setFieldValue(field.name, timestamp);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        error: error,
        help: help,
        required: required,
        disabled: disabled,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "label",
                                textSize: "small",
                                textWeight: "semibold",
                                children: hoursLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                            type: "number",
                            min: 0,
                            max: maxHours,
                            step: 1,
                            placeholder: '0',
                            value: currentHours,
                            "data-test": `time-input-hours-${field.name}`,
                            onChange: (e)=>{
                                const newHours = e.target.value;
                                const newMinutes = currentMinutes;
                                updateTimestamp(newHours, newMinutes);
                            },
                            disabled: disabled,
                            className: hoursError ? 'is-danger' : ''
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            mb: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "label",
                                textSize: "small",
                                textWeight: "semibold",
                                children: minutesLabel
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                            type: "number",
                            min: 0,
                            max: maxMinutes,
                            step: 1,
                            placeholder: '00',
                            value: currentMinutes,
                            "data-test": `time-input-minutes-${field.name}`,
                            onChange: (e)=>{
                                const newHours = currentHours;
                                const newMinutes = e.target.value;
                                updateTimestamp(newHours, newMinutes);
                            },
                            disabled: disabled,
                            className: minutesError ? 'is-danger' : ''
                        })
                    ]
                })
            ]
        })
    });
};
var $10ac5e99cbb8af09$export$2e2bcd8739ae039 = $10ac5e99cbb8af09$var$TimeInputField;



/**
 * Component that displays counter information and allows editing
 */ const $5896b7f817cf0a24$var$CounterFormSection = ({ counterId: counterId, simulatedData: simulatedData, accountedDuration: accountedDuration, workedDuration: workedDuration })=>{
    const { values: values } = (0, $31tXu.useFormikContext)();
    const calculatedHours = simulatedData?.ruleBasedIncrement || 0;
    // Calculs pour l'affichage selon le mode
    const getCalculatedToCounterMs = ()=>{
        switch(values.counters[counterId]?.mode){
            case 'toCounter':
                return calculatedHours;
            case 'toWeek':
                return 0;
            case 'split':
                return values.counters[counterId]?.splitToCounter || 0;
            default:
                return 0;
        }
    };
    const getCalculatedToWeekMs = ()=>{
        switch(values.counters[counterId]?.mode){
            case 'toCounter':
                return 0;
            case 'toWeek':
                return calculatedHours;
            case 'split':
                return values.counters[counterId]?.splitToWeek || 0;
            default:
                return 0;
        }
    };
    const calculatedToCounterMs = getCalculatedToCounterMs();
    const calculatedToWeekMs = getCalculatedToWeekMs();
    // Validation de la répartition partielle
    const isSplitValid = values.counters[counterId]?.mode !== 'split' || Math.abs(calculatedToCounterMs + calculatedToWeekMs - (simulatedData?.ruleBasedIncrement || 0)) < 1000 // Tolérance de 1 seconde
    ;
    const hasRuleBasedIncrement = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>simulatedData?.ruleBasedIncrement, [
        simulatedData
    ]);
    // Use the counter template name if available, otherwise fallback to the ID
    const counterDisplayName = simulatedData?.workerCounter?.template?.name || counterId;
    if (!simulatedData?.counter.affectsPeriodSummaryAccounted) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        p: 4,
        backgroundColor: "light",
        style: {
            borderRadius: '4px',
            border: '1px solid #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                mb: 3,
                children: [
                    "Compteur ",
                    counterDisplayName,
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "small",
                        textColor: "grey",
                        ml: 1,
                        children: [
                            "- ",
                            (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.ruleBasedIncrement || 0),
                            " calcul\xe9es pour cette semaine"
                        ]
                    })
                ]
            }),
            "Le compteur ",
            counterDisplayName,
            " n'affecte pas les heures comptabilis\xe9es de la semaine.",
            ' ',
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
            "Les heures sont donc automatiquement ajout\xe9es au compteur."
        ]
    });
    const adjustedValue = simulatedData?.counter.adjustedValue || 0;
    const displayAdjustedValue = adjustedValue > 0 ? `- ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(adjustedValue)}` : `+ ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(adjustedValue * -1)}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        p: 4,
        backgroundColor: "light",
        style: {
            borderRadius: '4px',
            border: '1px solid #dee2e6'
        },
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                size: 5,
                mb: 3,
                children: [
                    "Compteur ",
                    counterDisplayName,
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "small",
                        textColor: "grey",
                        ml: 1,
                        children: [
                            "- ",
                            (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.ruleBasedIncrement || 0),
                            " calcul\xe9es pour cette semaine"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 4,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        name: `counters.${counterId}.mode`,
                        component: (0, $94dd48ff55f5e1f0$export$2e2bcd8739ae039),
                        options: [
                            {
                                value: 'toCounter',
                                label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: !hasRuleBasedIncrement ? 's' : 'span',
                                    children: [
                                        "Ajouter les ",
                                        (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.ruleBasedIncrement || 0),
                                        " au compteur"
                                    ]
                                }),
                                disabled: !hasRuleBasedIncrement
                            },
                            {
                                value: 'toWeek',
                                label: `Compter les ${(0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.ruleBasedIncrement || 0)} dans la semaine`,
                                description: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "small",
                                    children: "Reprendre des heures du compteur si n\xe9cessaire"
                                })
                            }
                        ]
                    }),
                    values.counters[counterId]?.mode === 'toWeek' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 4,
                        p: 3,
                        backgroundColor: "light",
                        style: {
                            borderRadius: '4px',
                            border: '1px solid #dee2e6'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "R\xe9cup\xe9ration d'heures depuis le compteur"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 2,
                                textColor: "grey",
                                textSize: 7,
                                children: "R\xe9cup\xe9rez des heures du compteur pour les ajouter \xe0 la semaine (optionnel)"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                name: `counters.${counterId}.recoveryFromCounter`,
                                component: (0, $10ac5e99cbb8af09$export$2e2bcd8739ae039)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        name: `counters.${counterId}.mode`,
                        component: (0, $94dd48ff55f5e1f0$export$2e2bcd8739ae039),
                        options: [
                            {
                                value: 'split',
                                label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: !hasRuleBasedIncrement ? 's' : 'span',
                                    children: "Divisez les heures entre compteur et semaine"
                                }),
                                disabled: !hasRuleBasedIncrement
                            }
                        ]
                    }),
                    values.counters[counterId]?.mode === 'split' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                        style: {
                            padding: '1rem',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '4px',
                            border: '1px solid #dee2e6'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 2,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Configuration de la r\xe9partition"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Heures vers le compteur",
                                    name: `counters.${counterId}.splitToCounter`,
                                    component: (0, $10ac5e99cbb8af09$export$2e2bcd8739ae039),
                                    maxHours: Math.floor(calculatedHours / 3600000),
                                    hoursHelp: `Heures vers le compteur (max: ${Math.floor(calculatedHours / 3600000)}h)`,
                                    minutesHelp: "Minutes vers le compteur"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Heures dans la semaine",
                                    name: `counters.${counterId}.splitToWeek`,
                                    component: (0, $10ac5e99cbb8af09$export$2e2bcd8739ae039),
                                    maxHours: Math.floor(calculatedHours / 3600000),
                                    hoursHelp: `Heures dans la semaine (max: ${Math.floor(calculatedHours / 3600000)}h)`,
                                    minutesHelp: "Minutes dans la semaine"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "small",
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "strong",
                                            children: "Total :"
                                        }),
                                        ' ',
                                        (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(calculatedToCounterMs + calculatedToWeekMs),
                                        !isSplitValid && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "small",
                                            textColor: "danger",
                                            children: [
                                                ' ',
                                                "- Doit faire exactement ",
                                                (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.ruleBasedIncrement || 0)
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            values.counters[counterId]?.mode && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                backgroundColor: "success-light",
                mt: 1,
                p: 3,
                style: {
                    borderRadius: '4px',
                    border: '1px solid #c8e6c9'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 6,
                        textColor: "success",
                        mb: 2,
                        children: "R\xe9sum\xe9 des impacts"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                children: "Total heures comptabilis\xe9es dans la semaine : "
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                "data-test": "week-preview-duration",
                                children: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(accountedDuration || 0)
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "small",
                                textColor: "grey",
                                ml: 1,
                                "data-test": "week-preview-calculation",
                                children: [
                                    "(",
                                    (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(workedDuration || 0),
                                    " ",
                                    displayAdjustedValue,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                children: "Nouveau solde du compteur :"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "span",
                                "data-test": "counter-preview-duration",
                                children: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.counter.newValue || 0)
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "small",
                                textColor: "grey",
                                ml: 1,
                                "data-test": "counter-preview-calculation",
                                children: [
                                    "(",
                                    (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.counter.previousValue || 0),
                                    " +",
                                    ' ',
                                    (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(simulatedData?.counter.adjustedValue || 0),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $5896b7f817cf0a24$export$2e2bcd8739ae039 = $5896b7f817cf0a24$var$CounterFormSection;


/**
 * Form component for closing a payroll week
 * Handles counter configuration and form submission
 */ const $ecf82284227a6a09$var$CloseWeekForm = ({ weekNumber: weekNumber, year: year, worker: worker, onSubmit: onSubmit, onCancel: onCancel })=>{
    const [countersParams, setCountersParams] = (0, $3ZYaX.useState)([]);
    const [isFormChanging, setIsFormChanging] = (0, $3ZYaX.useState)(false);
    const timeoutRef = (0, $3ZYaX.useRef)();
    // Requête initiale avec les paramètres de base (sans compteurs)
    const initialQuery = (0, $1517f26b22db4237$export$fa70538e6fc79fa0)({
        week: Number(weekNumber),
        year: Number(year),
        worker: worker._id,
        counters: []
    });
    // Requête de simulation seulement quand le formulaire n'est pas en train de changer
    const simulateQuery = (0, $1517f26b22db4237$export$fa70538e6fc79fa0)({
        week: Number(weekNumber),
        year: Number(year),
        worker: worker._id,
        counters: countersParams
    }, {
        enabled: !isFormChanging && (countersParams?.length || 0) > 0
    });
    // Utiliser les données de simulation si disponibles, sinon les données initiales
    const counters = simulateQuery.data?.data?.employerData?.counters || initialQuery.data?.data?.employerData?.counters || {};
    const accountedDuration = simulateQuery.data?.data?.durations.accounted || initialQuery.data?.data?.durations.accounted || 0;
    const workedDuration = simulateQuery.data?.data?.durations.worked.total || initialQuery.data?.data?.durations.worked.total || 0;
    // Cleanup du timeout au démontage du composant
    (0, $3ZYaX.useEffect)(()=>{
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, []);
    /**
   * Handle form submission
   */ const handleSubmit = ()=>{
        // Prepare parameters for API call using the extracted calculation function
        const params = {
            week: Number(weekNumber),
            year: Number(year),
            worker: worker._id,
            counters: countersParams
        };
        onSubmit(params);
    };
    /**
   * Handle form values change with debouncing to prevent flickering (maybe a refactor is needed)
   */ const handleFormChange = (values)=>{
        setIsFormChanging(true) // Marquer qu'on est en train de changer
        ;
        const newParams = (0, $778c83e80a04c032$export$a967f4bbd98241d4)(values, counters);
        setCountersParams(newParams);
        // Nettoyer le timeout précédent
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Après un délai, permettre la nouvelle requête
        timeoutRef.current = setTimeout(()=>{
            setIsFormChanging(false);
        }, 500) // 500ms de délai
        ;
    };
    const countersIds = Object.keys(counters);
    const counterCount = countersIds.length;
    const countersWithAffectsPeriodSummaryAccounted = countersIds.filter((counterId)=>counters[counterId]?.counter.affectsPeriodSummaryAccounted);
    const accountedCounterCount = countersWithAffectsPeriodSummaryAccounted.length;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                color: "info",
                mb: 5,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                    children: [
                        "Cloturer la semaine ",
                        weekNumber,
                        " de ",
                        year,
                        " pour",
                        ' ',
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "strong",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                user: worker
                            })
                        }),
                        ".",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                        "Les journ\xe9es de travail de la semaine ne pourront plus \xeatre point\xe9es ou modifi\xe9es."
                    ]
                })
            }),
            counterCount !== 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 4,
                textWeight: "bold",
                children: "Ajustez les valeurs des compteurs avant de cl\xf4turer la semaine :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                initialValues: {
                    counters: {}
                },
                onSubmit: handleSubmit,
                validate: (values)=>{
                    const errors = {};
                    const counterInValues = [];
                    // Validation des compteurs en mode split
                    Object.entries(values.counters).forEach(([counterId, counter])=>{
                        counterInValues.push(counterId);
                        if (counter && !counter.mode) errors[`counters.${counterId}.mode`] = true;
                        else if (counter && counter.mode === 'split') {
                            const simulatedCounter = counters[counterId];
                            const ruleBasedIncrement = simulatedCounter?.ruleBasedIncrement || 0;
                            const totalSplit = (counter.splitToCounter || 0) + (counter.splitToWeek || 0);
                            // Vérifier que la somme des répartitions est égale à ruleBasedIncrement
                            if (Math.abs(totalSplit - ruleBasedIncrement) > 1000) {
                                // Tolérance de 1 seconde
                                errors[`time-input-hours-counters.${counterId}.splitToCounter`] = true;
                                errors[`time-input-hours-counters.${counterId}.splitToWeek`] = true;
                            }
                        }
                    });
                    const allCountersWithAffectsPeriodSummaryAccounted = countersWithAffectsPeriodSummaryAccounted.every((cId)=>counterInValues.includes(cId));
                    if (!allCountersWithAffectsPeriodSummaryAccounted) errors.counters = true;
                    return errors;
                },
                children: ({ values: values, isValid: isValid, dirty: dirty })=>{
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 2,
                                children: countersIds.map((counterId)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        mb: 4,
                                        "data-test": `counter-form-${counterId}`,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5896b7f817cf0a24$export$2e2bcd8739ae039), {
                                            counterId: counterId,
                                            simulatedData: counters[counterId],
                                            accountedDuration: accountedDuration,
                                            workedDuration: workedDuration
                                        })
                                    }, counterId))
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                display: "flex",
                                justifyContent: "flex-end",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        color: "light",
                                        onClick: onCancel,
                                        mr: 2,
                                        children: "Annuler"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        color: "success",
                                        type: "submit",
                                        disabled: !isValid || !dirty && accountedCounterCount !== 0,
                                        "data-test": "close-week-form-submit",
                                        children: "Cl\xf4turer la semaine"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3207b9421765213$export$2e2bcd8739ae039), {
                                onChange: handleFormChange,
                                values: values
                            })
                        ]
                    });
                }
            })
        ]
    });
};
var $ecf82284227a6a09$export$2e2bcd8739ae039 = $ecf82284227a6a09$var$CloseWeekForm;


/**
 * Modal component for confirming the closure of a payroll week
 * Uses CloseWeekForm component for the form logic
 */ const $7336c8a16feac379$var$ClosePayrollWeekModal = ({ show: show, hide: hide, weekNumber: weekNumber, year: year, worker: worker, onSubmit: onSubmit })=>{
    /**
   * Handle form submission
   */ const handleSubmit = (values)=>{
        onSubmit(values);
        hide();
    };
    /**
   * Handle form cancellation
   */ const handleCancel = ()=>{
        hide();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        title: `Cl\xf4turer la semaine ${weekNumber} de ${year}`,
        actions: {
            isDisplayed: show || false,
            setIsDisplayed: hide
        },
        maxWidth: 1000,
        children: show && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ecf82284227a6a09$export$2e2bcd8739ae039), {
            weekNumber: weekNumber,
            year: year,
            worker: worker,
            onSubmit: handleSubmit,
            onCancel: handleCancel
        })
    });
};
var $7336c8a16feac379$export$2e2bcd8739ae039 = $7336c8a16feac379$var$ClosePayrollWeekModal;



parcelRequire("3ZYaX");


/**
 * Composant pour afficher les détails d'un travailleur dans la section paie
 *
 * Affiche les informations contractuelles, les heures travaillées et les compteurs
 * sous forme de liste de description.
 */ const $3dd8825a99ceb1c7$var$PayrollWorkerPeriodDetails = ({ workerCounters: workerCounters, onWorkerCounterClick: onWorkerCounterClick })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "strong",
        "data-test": "worker-counters-details",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "span",
                children: "Compteurs"
            }),
            workerCounters?.map((counter, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "a",
                            ml: 2,
                            style: {
                                cursor: 'pointer',
                                textDecoration: 'none'
                            },
                            onClick: ()=>onWorkerCounterClick?.(counter),
                            "data-test": `worker-counter-${counter.template._id}`,
                            children: [
                                counter.template.name,
                                ": ",
                                (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(counter.currentValue)
                            ]
                        }),
                        index < workerCounters.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            ml: 2,
                            children: "-"
                        })
                    ]
                }))
        ]
    });
};
var $3dd8825a99ceb1c7$export$2e2bcd8739ae039 = $3dd8825a99ceb1c7$var$PayrollWorkerPeriodDetails;



var $3ZYaX = parcelRequire("3ZYaX");
function $e6211f411d1e2e80$export$2b86bedf890eab8() {
    const elementRef = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useRef(null);
    const [size, setSize] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        width: 0,
        height: 0
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        const element = elementRef.current;
        if (!element) return;
        // Initialize with current size
        const rect = element.getBoundingClientRect();
        setSize({
            width: rect.width,
            height: rect.height
        });
        // Observe future size changes
        const observer = new ResizeObserver((entries)=>{
            for (const entry of entries){
                const cr = entry.contentRect;
                setSize({
                    width: cr.width,
                    height: cr.height
                });
            }
        });
        observer.observe(element);
        return ()=>observer.disconnect();
    }, []);
    return [
        elementRef,
        size
    ];
}


const $c0b959f361e26c0d$var$PayrollDetails = ()=>{
    // Measure right column height to sync left column container height
    const [rightColRef, rightColSize] = (0, $e6211f411d1e2e80$export$2b86bedf890eab8)();
    const { filters: filters, setFilters: setFilters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).payroll);
    const [selectedWorkerCounter, setSelectedWorkerCounter] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    // Use currentWorkerId from filters instead of local state
    const currentWorkerId = filters.currentWorkerId;
    const setCurrentWorkerId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback((workerId)=>{
        if (workerId === filters.currentWorkerId) return;
        setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).payroll, {
            ...filters,
            currentWorkerId: workerId
        });
    }, [
        filters,
        setFilters
    ]);
    // Utilisation du hook pour récupérer les workers avec toutes leurs données agrégées
    const { payrollWorkers: payrollWorkers, allWorkPeriodEvents: allWorkPeriodEvents, weeks: weeks, weeksSummaryStatus: weeksSummaryStatus, isLoading: isLoading, hasPrev: hasPrev, hasNext: hasNext, goPrev: goPrev, goNext: goNext, currentWorker: currentWorker, resolvedCurrentWorkerId: resolvedCurrentWorkerId } = (0, $1a56d15249f8c039$export$9b590e1e4b5e556b)(currentOrganization, filters, currentWorkerId);
    // Full weeks summary for selected worker (separate hook)
    const currentWorkerWithWeeksSummary = (0, $6bac687dfd77cb01$export$9655bc489a4afcbb)(currentOrganization, filters, currentWorkerId);
    /**
   * Go to previous/next worker using hook-provided navigation ids
   */ const onPrev = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback(()=>{
        const prevId = goPrev();
        if (prevId) setCurrentWorkerId(prevId);
    }, [
        goPrev
    ]);
    const onNext = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useCallback(()=>{
        const nextId = goNext();
        if (nextId) setCurrentWorkerId(nextId);
    }, [
        goNext
    ]);
    /**
   * Ensure current selection stays valid when the list changes
   */ (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (resolvedCurrentWorkerId) setCurrentWorkerId(resolvedCurrentWorkerId);
    }, [
        resolvedCurrentWorkerId
    ]);
    const closeWeekModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const [currentWeekData, setCurrentWeekData] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const createTwoPartiesMutation = (0, $1517f26b22db4237$export$460193833a3294e6)();
    const workerCounterModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    // Réinitialiser le worker counter sélectionné quand la modale se ferme
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!workerCounterModal.isDisplayed) setSelectedWorkerCounter(null);
    }, [
        workerCounterModal.isDisplayed
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    max: true,
                    breakpoint: 'fluid',
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
                            title: "Donn\xe9es pour paie",
                            subTitle: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: "Analysez et cl\xf4turez les heures travaill\xe9es de vos salari\xe9s sur la p\xe9riode s\xe9lectionn\xe9e."
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                            mt: 4,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $33e364db3955ee56$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 2,
                                        style: {
                                            borderRight: '1px solid #e0e0e0',
                                            padding: 0
                                        },
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            style: {
                                                position: 'sticky',
                                                top: 0,
                                                // Match right column measured height; fallback to viewport height
                                                maxHeight: rightColSize.height ? `${rightColSize.height + 34}px` : '100vh',
                                                overflowY: 'auto'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    p: 2,
                                                    style: {
                                                        borderBottom: '1px solid #e0e0e0'
                                                    },
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5e95748863ba0958$export$2e2bcd8739ae039), {
                                                        weeksSummaryStatus: weeksSummaryStatus,
                                                        totalWorkers: payrollWorkers.length
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                    "data-test": "workers-list",
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f47c2cf2a2e778cf$export$2e2bcd8739ae039), {
                                                        workers: payrollWorkers,
                                                        weeksSummaryStatus: weeksSummaryStatus,
                                                        onWorkerSelect: (worker)=>{
                                                            setCurrentWorkerId((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(worker));
                                                        },
                                                        activeWorkerId: currentWorkerId,
                                                        isLoading: isLoading
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 10,
                                        pt: 1,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                                            ref: rightColRef,
                                            style: {
                                                minHeight: '60vh'
                                            },
                                            children: currentWorkerWithWeeksSummary && filters?.start && filters?.end && allWorkPeriodEvents && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                                        size: 4,
                                                        mb: 6,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                                                            user: currentWorkerWithWeeksSummary
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button).Group, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                                    size: "small",
                                                                                    color: "light",
                                                                                    disabled: !hasPrev,
                                                                                    onClick: onPrev,
                                                                                    children: "\u2190 Pr\xe9c\xe9dent"
                                                                                }),
                                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                                                    size: "small",
                                                                                    color: "light",
                                                                                    disabled: !hasNext,
                                                                                    onClick: onNext,
                                                                                    children: "Suivant \u2192"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                textColor: "grey",
                                                                textSize: 6,
                                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3dd8825a99ceb1c7$export$2e2bcd8739ae039), {
                                                                    workerCounters: currentWorkerWithWeeksSummary?.workerCounters,
                                                                    onWorkerCounterClick: (counter)=>{
                                                                        setSelectedWorkerCounter(counter);
                                                                        workerCounterModal.setIsDisplayed(true);
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0481f5de9e903de7$export$2e2bcd8739ae039), {
                                                        worker: currentWorkerWithWeeksSummary,
                                                        weeks: weeks || [],
                                                        events: allWorkPeriodEvents,
                                                        onCloseWeek: (weekNumber, year)=>{
                                                            setCurrentWeekData({
                                                                weekNumber: weekNumber,
                                                                year: year
                                                            });
                                                            closeWeekModal.setIsDisplayed(true);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ddd57932c1a15880$export$2e2bcd8739ae039), {
                                                        worker: currentWorkerWithWeeksSummary,
                                                        weeks: weeks || [],
                                                        events: allWorkPeriodEvents
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97bb431efbba50b5$export$2e2bcd8739ae039), {
                workerCounter: selectedWorkerCounter || undefined,
                isDisplayed: workerCounterModal.isDisplayed,
                setIsDisplayed: workerCounterModal.setIsDisplayed
            }),
            currentWeekData && currentWorker && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7336c8a16feac379$export$2e2bcd8739ae039), {
                show: closeWeekModal.isDisplayed,
                hide: ()=>closeWeekModal.setIsDisplayed(false),
                weekNumber: currentWeekData.weekNumber,
                year: currentWeekData.year,
                worker: currentWorker,
                onSubmit: createTwoPartiesMutation.mutate
            })
        ]
    });
};
var $c0b959f361e26c0d$export$2e2bcd8739ae039 = $c0b959f361e26c0d$var$PayrollDetails;



parcelRequire("3ZYaX");





const $4bbda65e3b4062e8$var$POPULATE = [
    'employer'
];
const $4bbda65e3b4062e8$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/employer-rules',
        method: 'get',
        params: {
            sort: 'name',
            populate: $4bbda65e3b4062e8$var$POPULATE,
            ...params || {}
        }
    });
const $4bbda65e3b4062e8$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/employer-rules/${id}`,
        method: 'get'
    });
const $4bbda65e3b4062e8$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/employer-rules',
        method: 'post',
        params: params
    });
const $4bbda65e3b4062e8$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/employer-rules/${id}`,
        method: 'put',
        params: payload
    });
};


const $52dfa770bdcaf9bf$export$473d39c76a4326c9 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('employer-rules', (0, $4bbda65e3b4062e8$export$3988ae62b71be9a3), id, undefined, options);
const $52dfa770bdcaf9bf$export$86c10eec7ad727f4 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('employer-rules', (0, $4bbda65e3b4062e8$export$e7aa7bc5c1b3cfb3), filters, options);
//Mutations
const $52dfa770bdcaf9bf$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'employer-rules'
    ]);
};
const $52dfa770bdcaf9bf$export$4a6f974b4208311 = ()=>[
        'employer-rules',
        'create'
    ];
const $52dfa770bdcaf9bf$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $4bbda65e3b4062e8$export$185802fd694ee1f5), {
        mutationKey: $52dfa770bdcaf9bf$export$4a6f974b4208311(),
        onSuccess: $52dfa770bdcaf9bf$var$onMutationSuccess
    });
const $52dfa770bdcaf9bf$export$a6fe4df8bec26327 = ()=>[
        'employer-rules',
        'update'
    ];
const $52dfa770bdcaf9bf$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $4bbda65e3b4062e8$export$722fbec263ad908a), {
        mutationKey: $52dfa770bdcaf9bf$export$a6fe4df8bec26327(),
        onSuccess: $52dfa770bdcaf9bf$var$onMutationSuccess
    });


// Export main component


var $3ZYaX = parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");





parcelRequire("3ZYaX");


/**
 * Composant pour gérer un groupe de checkboxes multiples
 * Gère un tableau de valeurs sélectionnées
 * S'intègre avec Formik comme les autres champs
 */ const $1330dd4361837ef2$var$CheckboxesField = ({ field: field, form: form, label: label, help: help, options: options, columns: columns = true, columnSize: columnSize = 'narrow', required: required, disabled: disabled = false, info: info })=>{
    // Valeur actuelle : tableau de valeurs sélectionnées
    const selectedValues = field?.value || [];
    /**
   * Gère le changement d'une checkbox
   */ const handleChange = (optionValue, checked)=>{
        if (!field) return;
        const newValues = checked ? [
            ...selectedValues,
            optionValue
        ] : selectedValues.filter((val)=>val !== optionValue);
        form.setFieldValue(field.name, newValues);
    };
    /**
   * Vérifie si une option est sélectionnée
   */ const isChecked = (optionValue)=>{
        return selectedValues.includes(optionValue);
    };
    // Rendu des checkboxes
    const checkboxes = options.map((option)=>{
        const checked = isChecked(option.value);
        const optionDisabled = disabled || option.disabled;
        const checkbox = /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
            checked: checked,
            disabled: optionDisabled,
            onChange: (e)=>handleChange(option.value, e.target.checked),
            children: option.label
        }, option.value);
        if (columns) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
            size: columnSize,
            children: checkbox
        }, option.value);
        return checkbox;
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: label,
        help: help,
        error: form?.errors[field?.name],
        required: required,
        disabled: disabled,
        info: info,
        children: columns ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
            multiline: true,
            children: checkboxes
        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
            children: checkboxes
        })
    });
};
var $1330dd4361837ef2$export$2e2bcd8739ae039 = $1330dd4361837ef2$var$CheckboxesField;




parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");


/**
 * Utility functions and type guards for InputFormula AST manipulation
 */ const $2c13cbeb1b6b26aa$var$employerRulesLocales = {
    inputs: {
        week: {
            'durations.worked.night': "Heures travaill\xe9es la nuit",
            'durations.worked.day': "Heures travaill\xe9es la journ\xe9e",
            'durations.worked.total': "Heures totale travaill\xe9es (Jour & Nuit)",
            'durations.worked.theoretical': "Heures th\xe9oriques \xe0 travailler (pause d\xe9duite)",
            'durations.contract.total': "Heures th\xe9oriques contractuelles",
            'durations.benefit': 'Heures travail Non Effetif',
            'durations.total.total': "Heures totales (avec \xe9v\xe9nement prestation & r\xe8gles employeur)"
        },
        day: {
            'durations.worked.night': "Heures travaill\xe9es la nuit",
            'durations.worked.day': "Heures travaill\xe9es la journ\xe9e",
            'durations.worked.total': "Heures totale travaill\xe9es (Jour & Nuit)",
            'durations.worked.theoretical': "Heures th\xe9oriques \xe0 travailler (pause d\xe9duite)",
            'durations.contract.total': "Heures th\xe9oriques contractuelles",
            'durations.benefit': 'Heures travail Non Effetif',
            'durations.total.total': "Heures totales (avec \xe9v\xe9nement prestation & r\xe8gles employeur)"
        }
    }
};
var $2c13cbeb1b6b26aa$export$2e2bcd8739ae039 = $2c13cbeb1b6b26aa$var$employerRulesLocales;


const $ac4edf06975cab12$export$a2ad70a35dfad71f = (formula)=>{
    return 'type' in formula && formula.type === 'path';
};
const $ac4edf06975cab12$export$f45642963264dfc6 = (formula)=>{
    return 'op' in formula;
};
const $ac4edf06975cab12$export$51ebb8e3da2c7f13 = (formula)=>{
    return 'type' in formula && formula.type === 'rule';
};
const $ac4edf06975cab12$export$5acca4084d818d0e = (formula)=>{
    return 'type' in formula && formula.type === 'eventPath';
};
const $ac4edf06975cab12$export$de86c3ff14650fb7 = (path)=>{
    return {
        type: 'path',
        path: path
    };
};
const $ac4edf06975cab12$export$ea54e50380c56fca = (period, mode)=>{
    if (mode === 'timeRange') return [];
    if (period === 'week') return Object.keys((0, $2c13cbeb1b6b26aa$export$2e2bcd8739ae039).inputs.week).map((key)=>({
            value: key,
            label: (0, $2c13cbeb1b6b26aa$export$2e2bcd8739ae039).inputs.week[key]
        }));
    if (period === 'day') return Object.keys((0, $2c13cbeb1b6b26aa$export$2e2bcd8739ae039).inputs.day).map((key)=>({
            value: key,
            label: (0, $2c13cbeb1b6b26aa$export$2e2bcd8739ae039).inputs.day[key]
        }));
    return [];
};
const $ac4edf06975cab12$export$6f5fe4aace25440d = (period, mode)=>{
    return $ac4edf06975cab12$export$ea54e50380c56fca(period, mode).map((option)=>option.value);
};


/**
 * Returns true when the element is an operand (path/rule).
 */ function $c5b170440733c861$var$isOperandElement(el) {
    return el.type === 'path' || el.type === 'rule' || el.type === 'eventPath';
}
/**
 * Validates the "linear editor" representation of the formula.
 *
 * The editor expects an alternating sequence:
 * - operand / operator / operand / ...
 *
 * This is separate from validating the AST itself (which is handled elsewhere).
 * Here we validate that the UI state can be converted to a sane AST and provide
 * a user-facing message to explain what's wrong.
 */ function $c5b170440733c861$var$validateFormulaElements(els, availablePaths, availableRules) {
    // Empty is a valid starting state: user must add an operand first.
    if (els.length === 0) return {
        status: 'incomplete',
        expectedNext: 'operand'
    };
    const availablePathValues = new Set(availablePaths.map((p)=>p.value));
    const availableRuleValues = new Set(availableRules.map((r)=>r.value));
    // Validate structural alternation by position.
    for(let i = 0; i < els.length; i++){
        const el = els[i];
        if (!el) // Defensive guard (noUncheckedIndexedAccess).
        return {
            status: 'invalid',
            expectedNext: i % 2 === 0 ? 'operand' : 'operator',
            message: 'La formule est invalide.'
        };
        const shouldBeOperand = i % 2 === 0;
        if (shouldBeOperand && el.type === 'operator') return {
            status: 'invalid',
            expectedNext: 'operand',
            message: i === 0 ? "La formule ne peut pas commencer par un op\xe9rateur. Ajoutez d'abord un \xe9l\xe9ment (path, r\xe8gle)." : "Un \xe9l\xe9ment (path, r\xe8gle) est requis apr\xe8s un op\xe9rateur. Supprimez l'\xe9l\xe9ment en trop pour corriger."
        };
        if (!shouldBeOperand && el.type !== 'operator') return {
            status: 'invalid',
            expectedNext: 'operator',
            message: "Un op\xe9rateur est requis entre chaque \xe9l\xe9ment. Supprimez l'\xe9l\xe9ment en trop pour corriger."
        };
        // Validate operand content (helps avoid silently producing null).
        if ($c5b170440733c861$var$isOperandElement(el)) {
            if (el.type === 'path') {
                if (!el.path) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: "Le path ne peut pas \xeatre vide."
                };
                if (availablePathValues.size > 0 && !availablePathValues.has(el.path)) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: `Le path "${el.path}" n'est pas valide pour ce contexte.`
                };
            }
            if (el.type === 'rule') {
                if (!el.ruleId) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: "La r\xe8gle r\xe9f\xe9renc\xe9e ne peut pas \xeatre vide."
                };
                if (availableRuleValues.size > 0 && !availableRuleValues.has(el.ruleId)) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: `La r\xe8gle "${el.ruleId}" n'est pas disponible.`
                };
            }
            if (el.type === 'eventPath') {
                if (!el.path) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: "Le path de l'\xe9v\xe9nement ne peut pas \xeatre vide."
                };
                if (availablePathValues.size > 0 && !availablePathValues.has(el.path)) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: `Le path "${el.path}" n'est pas valide pour ce contexte.`
                };
                if (!el.workPeriodEventIds || el.workPeriodEventIds.length === 0) return {
                    status: 'invalid',
                    expectedNext: 'operator',
                    message: "Au moins un \xe9v\xe9nement doit \xeatre s\xe9lectionn\xe9."
                };
            }
        }
    }
    // If the sequence length is even, we end with an operator → incomplete but structurally OK.
    const expectedNext = els.length % 2 === 0 ? 'operand' : 'operator';
    if (expectedNext === 'operand') return {
        status: 'incomplete',
        expectedNext: expectedNext,
        message: "La formule est incompl\xe8te. Ajoutez un \xe9l\xe9ment (path, r\xe8gle) apr\xe8s l'op\xe9rateur."
    };
    return {
        status: 'valid',
        expectedNext: expectedNext
    };
}
/**
 * Converts one operand element to its AST representation.
 * Returns null when the element is not a valid operand.
 */ function $c5b170440733c861$var$operandElementToFormula(el) {
    if (el.type === 'path') return {
        type: 'path',
        path: el.path
    };
    if (el.type === 'rule') return {
        type: 'rule',
        ruleId: el.ruleId
    };
    if (el.type === 'eventPath') {
        const formula = {
            type: 'eventPath',
            path: el.path,
            workPeriodEventIds: el.workPeriodEventIds
        };
        if (el.excludeIfWorked) formula.excludeIfWorked = true;
        return formula;
    }
    return null;
}
/**
 * Converts a validated linear sequence into an AST.
 *
 * Implementation notes:
 * - We use a left-fold to support mixed '+' and '-' (e.g. "a + b - c")
 * - We keep n-ary operations for consecutive identical operators (e.g. "a + b + c")
 */ function $c5b170440733c861$var$linearElementsToFormula(els) {
    if (els.length === 0) return null;
    // We only convert if the sequence is complete (ends with an operand).
    if (els.length % 2 === 0) return null;
    const firstEl = els[0];
    if (!firstEl) return null;
    const first = $c5b170440733c861$var$operandElementToFormula(firstEl);
    if (!first) return null;
    let result = first;
    for(let i = 1; i < els.length; i += 2){
        const operatorEl = els[i];
        const operandEl = els[i + 1];
        if (!operatorEl || operatorEl.type !== 'operator' || !operandEl) return null;
        const nextOperand = $c5b170440733c861$var$operandElementToFormula(operandEl);
        if (!nextOperand) return null;
        // If we already have the same operation, append to keep the tree shallow.
        if ((0, $ac4edf06975cab12$export$f45642963264dfc6)(result) && result.op === operatorEl.op) {
            result = {
                op: result.op,
                args: [
                    ...result.args,
                    nextOperand
                ]
            };
            continue;
        }
        // Otherwise, create a nested binary operation.
        result = {
            op: operatorEl.op,
            args: [
                result,
                nextOperand
            ]
        };
    }
    return result;
}
/**
 * FormulaBuilder component - Visual builder for complex formulas
 * Provides both simple and advanced modes for formula creation
 */ const $c5b170440733c861$var$FormulaBuilder = ({ value: value, onChange: onChange, availablePaths: availablePaths, availableRules: availableRules = [], availableEvents: availableEvents = [], disabled: disabled = false, error: error })=>{
    /**
   * We default to advanced mode when an existing formula is NOT a simple path.
   * This avoids showing the "simple path select" empty when loading an existing complex formula.
   */ const [advancedMode, setAdvancedMode] = (0, $3ZYaX.useState)(()=>Boolean(value && !(0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(value)));
    const [elements, setElements] = (0, $3ZYaX.useState)(()=>{
        // Initialize editor state from the incoming formula (if any).
        return value ? formulaToElements(value) : [];
    });
    // Check if current formula is simple (just a path)
    const isSimpleFormula = value && (0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(value);
    /**
   * Validate the linear editor state to:
   * - drive button enable/disable logic
   * - provide a clear message when the formula is incomplete/invalid
   */ const elementsValidation = (0, $3ZYaX.useMemo)(()=>$c5b170440733c861$var$validateFormulaElements(elements, availablePaths, availableRules), [
        elements,
        availablePaths,
        availableRules
    ]);
    /**
   * Keep the UI mode in sync when the form loads an existing rule asynchronously.
   *
   * Typical scenario:
   * - component mounts with value = null
   * - later, formik sets value to a complex InputFormula (operation/rule)
   * Without this effect, the UI stays in simple mode and shows an empty select.
   */ (0, $3ZYaX.useEffect)(()=>{
        if (!value) return;
        // Auto-switch to advanced mode for non-path formulas.
        if (!advancedMode && !(0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(value)) {
            setAdvancedMode(true);
            setElements(formulaToElements(value));
        }
    }, [
        value,
        advancedMode
    ]);
    /**
   * Converts InputFormula to array of FormulaElements for editing
   */ function formulaToElements(formula) {
        const result = [];
        if ((0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(formula)) result.push({
            type: 'path',
            path: formula.path
        });
        else if ((0, $ac4edf06975cab12$export$51ebb8e3da2c7f13)(formula)) result.push({
            type: 'rule',
            ruleId: formula.ruleId
        });
        else if ((0, $ac4edf06975cab12$export$5acca4084d818d0e)(formula)) result.push({
            type: 'eventPath',
            path: formula.path,
            workPeriodEventIds: formula.workPeriodEventIds,
            excludeIfWorked: formula.excludeIfWorked
        });
        else if ((0, $ac4edf06975cab12$export$f45642963264dfc6)(formula)) formula.args.forEach((arg, index)=>{
            if (index > 0) result.push({
                type: 'operator',
                op: formula.op
            });
            const argElements = formulaToElements(arg);
            result.push(...argElements);
        });
        return result;
    }
    /**
   * Converts array of FormulaElements to InputFormula AST
   */ function elementsToFormula(els) {
        // Gate conversion behind the linear validation to avoid silently returning null.
        // Note: we re-validate here because this function is also called from event handlers.
        const validation = $c5b170440733c861$var$validateFormulaElements(els, availablePaths, availableRules);
        if (validation.status !== 'valid') return null;
        return $c5b170440733c861$var$linearElementsToFormula(els);
    }
    /**
   * Handles simple mode change (single path selection)
   */ const handleSimpleModeChange = (path)=>{
        if (!path) onChange(null);
        else onChange((0, $ac4edf06975cab12$export$de86c3ff14650fb7)(path));
    };
    /**
   * Handles switching to advanced mode
   */ const handleSwitchToAdvanced = ()=>{
        setAdvancedMode(true);
        // Initialize elements from current value
        if (value) setElements(formulaToElements(value));
        else setElements([]);
    };
    /**
   * Handles switching back to simple mode
   */ const handleSwitchToSimple = ()=>{
        setAdvancedMode(false);
        // Clear elements and reset to simple path if applicable
        if (value && (0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(value)) ;
        else onChange(null);
    };
    /**
   * Adds a new element to the formula
   */ const handleAddElement = (elementType)=>{
        const newElements = [
            ...elements
        ];
        const expectsOperand = elementsValidation.expectedNext === 'operand';
        const expectsOperator = elementsValidation.expectedNext === 'operator';
        if (elementType === 'operator' && !expectsOperator) return;
        if (elementType !== 'operator' && !expectsOperand) return;
        if (elementType === 'path') newElements.push({
            type: 'path',
            path: availablePaths[0]?.value || ''
        });
        else if (elementType === 'rule') {
            if (availableRules.length === 0) return;
            newElements.push({
                type: 'rule',
                ruleId: availableRules[0]?.value || ''
            });
        } else if (elementType === 'eventPath') {
            if (availableEvents.length === 0) return;
            newElements.push({
                type: 'eventPath',
                path: availablePaths[0]?.value || '',
                workPeriodEventIds: [],
                excludeIfWorked: false
            });
        } else if (elementType === 'operator') newElements.push({
            type: 'operator',
            op: 'add'
        });
        setElements(newElements);
        onChange(elementsToFormula(newElements));
    };
    /**
   * Updates an element at a specific index
   */ const handleUpdateElement = (index, updatedElement)=>{
        const newElements = [
            ...elements
        ];
        newElements[index] = updatedElement;
        setElements(newElements);
        onChange(elementsToFormula(newElements));
    };
    /**
   * Removes an element at a specific index
   */ const handleRemoveElement = (index)=>{
        const newElements = elements.filter((_, idx)=>idx !== index);
        setElements(newElements);
        onChange(elementsToFormula(newElements));
    };
    // Render Simple Mode
    if (!advancedMode) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                        children: "Formule d'input (mode simple)"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
                            value: isSimpleFormula && value ? value.path : '',
                            onChange: (e)=>handleSimpleModeChange(e.target.value),
                            disabled: disabled,
                            className: error ? 'is-danger' : '',
                            "data-test": "input-formula-simple-select",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                    value: "",
                                    children: "S\xe9lectionner un path"
                                }),
                                availablePaths.map((pathOption)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                        value: pathOption.value,
                                        children: pathOption.label
                                    }, pathOption.value))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                        className: "help",
                        children: "S\xe9lectionnez un path simple pour l'input de la r\xe8gle"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                size: "small",
                onClick: handleSwitchToAdvanced,
                disabled: disabled,
                "data-test": "input-formula-switch-advanced",
                children: "\uD83D\uDD27 Passer en mode avanc\xe9"
            })
        ]
    });
    // Render Advanced Mode
    const advancedMessageColor = error || elementsValidation.status === 'invalid' ? 'danger' : 'warning';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "div",
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                        children: "Formule d'input (mode avanc\xe9)"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        onClick: handleSwitchToSimple,
                        disabled: disabled,
                        "data-test": "input-formula-switch-simple",
                        children: "\u2B05\uFE0F Retour au mode simple"
                    })
                ]
            }),
            (error || elementsValidation.message) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                color: advancedMessageColor,
                mb: 3,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                    children: [
                        error && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Erreur :"
                                }),
                                " ",
                                error
                            ]
                        }),
                        elementsValidation.message && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                    children: "Validation :"
                                }),
                                " ",
                                elementsValidation.message
                            ]
                        })
                    ]
                })
            }),
            elements.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                backgroundColor: "light",
                mb: 3,
                children: elements.map((element, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        vCentered: true,
                        mb: 2,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "strong",
                                    style: {
                                        fontSize: '1.2em'
                                    },
                                    children: element.type === 'operator' ? element.op === 'add' ? '+' : '-' : index === 0 ? '' : ''
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: [
                                    element.type === 'path' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Select, {
                                        value: element.path,
                                        onChange: (e)=>handleUpdateElement(index, {
                                                type: 'path',
                                                path: e.target.value
                                            }),
                                        disabled: disabled,
                                        "data-test": `input-formula-path-${index}`,
                                        children: availablePaths.map((pathOption)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                value: pathOption.value,
                                                children: pathOption.label
                                            }, pathOption.value))
                                    }),
                                    element.type === 'rule' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
                                        value: element.ruleId,
                                        onChange: (e)=>handleUpdateElement(index, {
                                                type: 'rule',
                                                ruleId: e.target.value
                                            }),
                                        disabled: disabled,
                                        "data-test": `input-formula-rule-${index}`,
                                        children: [
                                            availableRules.length === 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                value: "",
                                                children: "Aucune r\xe8gle disponible"
                                            }),
                                            availableRules.map((rule)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("option", {
                                                    value: rule.value,
                                                    children: [
                                                        "\uD83D\uDCCB ",
                                                        rule.label
                                                    ]
                                                }, rule.value))
                                        ]
                                    }),
                                    element.type === 'eventPath' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                        style: {
                                            padding: '0.75rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        size: "small",
                                                        children: "Valeur"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Select, {
                                                        value: element.path,
                                                        onChange: (e)=>handleUpdateElement(index, {
                                                                ...element,
                                                                path: e.target.value
                                                            }),
                                                        disabled: disabled,
                                                        "data-test": `input-formula-eventpath-path-${index}`,
                                                        children: availablePaths.map((p)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                                value: p.value,
                                                                children: p.label
                                                            }, p.value))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        size: "small",
                                                        children: "\xc9v\xe9nements"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                                                        "data-test": `input-formula-eventpath-events-${index}`,
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $950556e92d8df5c6$export$2e2bcd8739ae039), {
                                                            isMulti: true,
                                                            isDisabled: disabled,
                                                            classNamePrefix: "select",
                                                            value: availableEvents.filter((ev)=>element.workPeriodEventIds.includes(ev.value)).map((ev)=>({
                                                                    value: ev.value,
                                                                    label: ev.label
                                                                })),
                                                            onChange: (selected)=>{
                                                                const ids = (selected || []).map((s)=>s.value);
                                                                handleUpdateElement(index, {
                                                                    ...element,
                                                                    workPeriodEventIds: ids
                                                                });
                                                            },
                                                            options: availableEvents.map((ev)=>({
                                                                    value: ev.value,
                                                                    label: ev.label
                                                                })),
                                                            placeholder: "S\xe9lectionner les \xe9v\xe9nements...",
                                                            noOptionsMessage: ()=>"Aucun \xe9v\xe9nement disponible"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("label", {
                                                    className: "checkbox",
                                                    style: {
                                                        fontSize: '0.85rem'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            checked: element.excludeIfWorked || false,
                                                            disabled: disabled,
                                                            onChange: (e)=>handleUpdateElement(index, {
                                                                    ...element,
                                                                    excludeIfWorked: e.target.checked
                                                                }),
                                                            "data-test": `input-formula-eventpath-exclude-${index}`,
                                                            style: {
                                                                marginRight: '0.5rem'
                                                            }
                                                        }),
                                                        "Exclure si temps travaill\xe9 sur la journ\xe9e"
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    element.type === 'operator' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
                                        value: element.op,
                                        onChange: (e)=>handleUpdateElement(index, {
                                                type: 'operator',
                                                op: e.target.value
                                            }),
                                        disabled: disabled,
                                        "data-test": `input-formula-operator-${index}`,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                value: "add",
                                                children: "+ Addition"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                value: "sub",
                                                children: "- Soustraction"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    color: "danger",
                                    size: "small",
                                    onClick: ()=>handleRemoveElement(index),
                                    disabled: disabled,
                                    "data-test": `input-formula-remove-${index}`,
                                    children: "\u2715"
                                })
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            size: "small",
                            onClick: ()=>handleAddElement('path'),
                            disabled: disabled || elementsValidation.expectedNext !== 'operand',
                            fullwidth: true,
                            "data-test": "input-formula-add-path",
                            children: "\uD83D\uDCCD Ajouter une valeur fixe"
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            size: "small",
                            onClick: ()=>handleAddElement('rule'),
                            disabled: disabled || availableRules.length === 0 || elementsValidation.expectedNext !== 'operand',
                            fullwidth: true,
                            title: availableRules.length === 0 ? "Aucune r\xe8gle disponible (cr\xe9ez d'abord d'autres r\xe8gles)" : "Ajouter une r\xe9f\xe9rence \xe0 une autre r\xe8gle",
                            "data-test": "input-formula-add-rule",
                            children: "\uD83D\uDCCB Ajouter une R\xe8gle Employeur"
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            size: "small",
                            onClick: ()=>handleAddElement('eventPath'),
                            disabled: disabled || availableEvents.length === 0 || elementsValidation.expectedNext !== 'operand',
                            fullwidth: true,
                            title: availableEvents.length === 0 ? "Aucun \xe9v\xe9nement prestation disponible (cr\xe9ez d'abord des \xe9v\xe9nements de type prestation)" : "Ajouter une valeur filtr\xe9e par \xe9v\xe9nement prestation",
                            "data-test": "input-formula-add-event-path",
                            children: "\uD83C\uDFF7\uFE0F Ajouter un \xc9v\xe9nement"
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            size: "small",
                            onClick: ()=>handleAddElement('operator'),
                            disabled: disabled || elementsValidation.expectedNext !== 'operator',
                            fullwidth: true,
                            title: elementsValidation.expectedNext !== 'operator' ? "Ajoutez d'abord un \xe9l\xe9ment (path ou r\xe8gle) puis ajoutez un op\xe9rateur." : "Ajouter un op\xe9rateur entre deux \xe9l\xe9ments",
                            "data-test": "input-formula-add-operator",
                            children: "\u2795 Ajouter un Op\xe9rateur"
                        })
                    })
                ]
            })
        ]
    });
};
var $c5b170440733c861$export$2e2bcd8739ae039 = $c5b170440733c861$var$FormulaBuilder;


/**
 * Formik-compatible field component for InputFormula
 * Wraps the FormulaBuilder component with Formik integration
 */ const $b48a3cffd193d921$var$InputFormulaField = (props)=>{
    const { field: field, form: form, availablePaths: availablePaths, availableRules: availableRules, availableEvents: availableEvents, disabled: disabled, ...rest } = props;
    const handleChange = (formula)=>{
        form.setFieldValue(field.name, formula);
    };
    const error = form?.errors[field?.name];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $958169f76e3379dd$export$2e2bcd8739ae039), {
        label: props.label,
        error: error,
        help: props.help,
        required: rest.required,
        info: props.info,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c5b170440733c861$export$2e2bcd8739ae039), {
            value: field.value,
            onChange: handleChange,
            availablePaths: availablePaths,
            availableRules: availableRules,
            availableEvents: availableEvents,
            disabled: disabled,
            error: error
        })
    });
};
var $b48a3cffd193d921$export$2e2bcd8739ae039 = $b48a3cffd193d921$var$InputFormulaField;






const $dd781467c0405f1e$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/special-periods',
        method: 'get',
        params: {
            sort: '-startDate',
            ...params || {}
        }
    });
const $dd781467c0405f1e$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/special-periods/${id}`,
        method: 'get',
        params: {
            _id: id
        }
    });
const $dd781467c0405f1e$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/special-periods',
        method: 'post',
        params: params
    });
const $dd781467c0405f1e$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/special-periods/${id}`,
        method: 'put',
        params: {
            _id: id,
            ...payload
        }
    });
};
const $dd781467c0405f1e$export$8bcfb5d02a3c6f75 = async (employerId)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/special-periods/types',
        method: 'get',
        params: {
            employer: employerId
        }
    });


const $f61e9610046189fb$export$44a92886d8b209ab = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('special-periods', (0, $dd781467c0405f1e$export$3988ae62b71be9a3), id, undefined, options);
const $f61e9610046189fb$export$d42b482b9d053a4 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('special-periods', (0, $dd781467c0405f1e$export$e7aa7bc5c1b3cfb3), filters || {}, options);
/**
 * Mutation success handler - invalidates special periods queries
 */ const $f61e9610046189fb$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'special-periods'
    ]);
};
const $f61e9610046189fb$export$4a6f974b4208311 = ()=>[
        'special-periods',
        'create'
    ];
const $f61e9610046189fb$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $dd781467c0405f1e$export$185802fd694ee1f5), {
        mutationKey: $f61e9610046189fb$export$4a6f974b4208311(),
        onSuccess: $f61e9610046189fb$var$onMutationSuccess
    });
const $f61e9610046189fb$export$a6fe4df8bec26327 = ()=>[
        'special-periods',
        'update'
    ];
const $f61e9610046189fb$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $dd781467c0405f1e$export$722fbec263ad908a), {
        mutationKey: $f61e9610046189fb$export$a6fe4df8bec26327(),
        onSuccess: $f61e9610046189fb$var$onMutationSuccess
    });
const $f61e9610046189fb$export$d711a26219da8f20 = ()=>[
        'special-periods',
        'delete'
    ];
const $f61e9610046189fb$export$6eb0b72d5a868fd7 = (employerId, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('special-periods-types', (0, $dd781467c0405f1e$export$8bcfb5d02a3c6f75), employerId, undefined, options);








const $7618c882fbf65d57$export$5f2295de277ec1be = (values)=>{
    const errors = {};
    // Skip validation if no values
    if (!values?.length) {
        errors['valuesInTime'] = "Au moins une p\xe9riode est requise";
        return errors;
    }
    // Sort valuesInTime by start date to make validation easier
    const sortedValues = [
        ...values
    ].sort((a, b)=>new Date(a.effectiveFrom).getTime() - new Date(b.effectiveFrom).getTime());
    // Check if we have more than one period without end date
    const periodsWithoutEndDate = values.filter((vt)=>!vt.effectiveTo);
    if (periodsWithoutEndDate.length > 1) periodsWithoutEndDate.forEach((period)=>{
        const index = values.indexOf(period);
        errors[`valuesInTime.${index}.effectiveTo`] = "Une seule p\xe9riode peut \xeatre sans date de fin";
    });
    // Check if the entry without end date is the most recent one
    const nullEndDateIndex = sortedValues.findIndex((vt)=>!vt.effectiveTo);
    if (nullEndDateIndex !== -1 && nullEndDateIndex !== sortedValues.length - 1) {
        const periodToCheck = sortedValues[nullEndDateIndex];
        if (periodToCheck) {
            const originalIndex = values.indexOf(periodToCheck);
            if (originalIndex !== -1) errors[`valuesInTime.${originalIndex}.effectiveTo`] = "La p\xe9riode sans date de fin doit \xeatre la plus r\xe9cente";
        }
    }
    // Check for overlaps and other validations
    sortedValues.forEach((vt, index)=>{
        const periodToCheck = sortedValues[index];
        if (!periodToCheck) return;
        const currentIndex = values.indexOf(periodToCheck);
        if (currentIndex === -1) return;
        // Basic required field validations with better type checking
        if (isNaN(Number(vt.value)) || Number(vt.value) > 0 && Number(vt.value) < 1) errors[`valuesInTime.${currentIndex}.value`] = "Valeur num\xe9rique requise";
        if (!vt.effectiveFrom) errors[`valuesInTime.${currentIndex}.effectiveFrom`] = "Date de d\xe9but requise";
        else {
            // Validate date format
            const fromDate = new Date(vt.effectiveFrom);
            if (fromDate.toString() === 'Invalid Date') errors[`valuesInTime.${currentIndex}.effectiveFrom`] = 'Date invalide';
        }
        if (vt.effectiveTo) {
            // Validate date format
            const toDate = new Date(vt.effectiveTo);
            if (toDate.toString() === 'Invalid Date') errors[`valuesInTime.${currentIndex}.effectiveTo`] = 'Date invalide';
            // Check if end date is after start date
            if (vt.effectiveFrom && vt.effectiveTo < vt.effectiveFrom) errors[`valuesInTime.${currentIndex}.effectiveTo`] = "La date de fin doit \xeatre apr\xe8s la date de d\xe9but";
        }
        // Check for overlaps with subsequent periods
        for(let j = index + 1; j < sortedValues.length; j++){
            const nextVt = sortedValues[j];
            if (!nextVt) continue;
            const currentEndDate = vt.effectiveTo ? new Date(vt.effectiveTo) : null;
            const nextStartDate = new Date(nextVt.effectiveFrom);
            // If current period has no end date, it automatically overlaps with all subsequent periods
            if (!currentEndDate) {
                errors[`valuesInTime.${currentIndex}.effectiveTo`] = "Cette p\xe9riode chevauche les p\xe9riodes suivantes";
                break;
            }
            // If current period's end date is after or equal to next period's start date
            if (currentEndDate >= nextStartDate) {
                errors[`valuesInTime.${currentIndex}.effectiveTo`] = "Cette p\xe9riode chevauche la p\xe9riode suivante";
                break;
            }
        }
    });
    return errors;
};
const $7618c882fbf65d57$export$51e58a02740fe411 = (interval)=>{
    const errors = {};
    // Min bounds validation
    if (interval.minBoundsMode === 'fixed') {
        if (interval.min) {
            const minValue = Number(interval.min);
            if (!isNaN(minValue) && minValue < 0) errors['interval.min'] = "La valeur minimale doit \xeatre positive";
        }
    } else if (interval.minBoundsMode === 'dynamic') {
        if (!interval.minPath) errors['interval.minPath'] = 'Le chemin pour la valeur minimale est obligatoire';
        //if (!isNumber(interval.minFallback)) {
        //  errors['interval.minFallback'] = 'La valeur de fallback pour min est obligatoire'
        //}
        if (interval.minFallback) {
            const minFallbackValue = Number(interval.minFallback);
            if (!isNaN(minFallbackValue) && minFallbackValue < 0) errors['interval.minFallback'] = "La valeur de fallback pour min doit \xeatre positive ou nulle";
        }
    }
    // Max bounds validation
    if (interval.maxBoundsMode === 'fixed') {
        if (interval.max) {
            const maxValue = Number(interval.max);
            if (!isNaN(maxValue) && maxValue < 0) errors['interval.max'] = "La valeur maximale doit \xeatre positive";
        }
    } else if (interval.maxBoundsMode === 'dynamic') {
        if (!interval.maxPath) errors['interval.maxPath'] = 'Le chemin pour la valeur maximale est obligatoire';
        if (!interval.maxFallback) errors['interval.maxFallback'] = 'La valeur de fallback pour max est obligatoire';
        if (interval.maxFallback) {
            const maxFallbackValue = Number(interval.maxFallback);
            if (!isNaN(maxFallbackValue) && maxFallbackValue < 0) errors['interval.maxFallback'] = "La valeur de fallback pour max doit \xeatre positive ou nulle";
        }
    }
    return errors;
};
const $7618c882fbf65d57$export$7921405327bd91a2 = (values)=>{
    const errors = {};
    // Cross-validation: max must be greater than min
    const minValue = values.interval.minBoundsMode === 'fixed' ? Number(values.interval.min) : Number(values.interval.minFallback);
    const maxValue = values.interval.maxBoundsMode === 'fixed' ? Number(values.interval.max) : Number(values.interval.maxFallback);
    if (values.interval.min && values.interval.max && !isNaN(minValue) && !isNaN(maxValue) && maxValue <= minValue) errors['interval.max'] = "La valeur maximale doit \xeatre sup\xe9rieure \xe0 la valeur minimale";
    return errors;
};
const $7618c882fbf65d57$export$ad7b0da7c4e86059 = (interval)=>{
    const errors = {};
    // Validate daysOfWeek when period is 'day' or 'week'
    if (!interval.daysOfWeek || interval.daysOfWeek.length === 0) errors['interval.daysOfWeek'] = "Au moins un jour de la semaine doit \xeatre s\xe9lectionn\xe9";
    return errors;
};
const $7618c882fbf65d57$export$682d27946dc28da0 = (specialPeriods)=>{
    const errors = {};
    if (!specialPeriods) // specialPeriods is optional, no error if not provided
    return errors;
    // Validate types array
    if (specialPeriods.types) {
        if (!Array.isArray(specialPeriods.types)) errors['specialPeriods.types'] = "Les types doivent \xeatre un tableau";
        else {
            // Check for duplicates
            const uniqueTypes = new Set(specialPeriods.types);
            if (uniqueTypes.size !== specialPeriods.types.length) errors['specialPeriods.types'] = 'Les types ne doivent pas contenir de doublons';
        }
    }
    return errors;
};
const $7618c882fbf65d57$export$d9c06132ce56cf6 = (formula, period, mode)=>{
    const errors = {};
    // If timeRange mode, inputFormula is not required (handled automatically)
    if (mode === 'timeRange') return errors;
    // For duration mode, inputFormula is required
    if (mode === 'duration' && !formula) {
        errors['interval.inputFormula'] = "La formule d'input est requise en mode dur\xe9e";
        return errors;
    }
    if (!formula) return errors;
    /**
   * Backend no longer supports constants inside inputFormula.
   * We keep a defensive runtime check here to:
   * - avoid crashing if existing data still contains a legacy constant formula
   * - show a clear validation message so the user can update the rule
   */ const legacyFormulaType = formula?.type;
    if (legacyFormulaType === 'constant') {
        errors['interval.inputFormula'] = "Les constantes ne sont plus support\xe9es dans la formule d'input. Remplacez-la par un path ou une r\xe9f\xe9rence \xe0 une r\xe8gle.";
        return errors;
    }
    // Get available path values for current context
    const availablePaths = (0, $ac4edf06975cab12$export$6f5fe4aace25440d)(period || '', mode);
    // Validate based on formula type
    if ((0, $ac4edf06975cab12$export$a2ad70a35dfad71f)(formula)) {
        // Validate path exists in available paths
        if (!formula.path) errors['interval.inputFormula'] = "Le path ne peut pas \xeatre vide";
        else if (availablePaths.length > 0 && !availablePaths.includes(formula.path)) errors['interval.inputFormula'] = `Le path "${formula.path}" n'est pas valide pour ce contexte`;
    } else if ((0, $ac4edf06975cab12$export$51ebb8e3da2c7f13)(formula)) // Validate rule ID is present (cannot validate existence without access to rules list)
    {
        if (!formula.ruleId) errors['interval.inputFormula'] = "L'ID de la r\xe8gle r\xe9f\xe9renc\xe9e ne peut pas \xeatre vide";
    } else if ((0, $ac4edf06975cab12$export$5acca4084d818d0e)(formula)) {
        if (!formula.path) errors['interval.inputFormula'] = "Le path de l'\xe9v\xe9nement ne peut pas \xeatre vide";
        else if (availablePaths.length > 0 && !availablePaths.includes(formula.path)) errors['interval.inputFormula'] = `Le path "${formula.path}" n'est pas valide pour ce contexte`;
        if (!formula.workPeriodEventIds || formula.workPeriodEventIds.length === 0) errors['interval.inputFormula'] = errors['interval.inputFormula'] || "Au moins un \xe9v\xe9nement doit \xeatre s\xe9lectionn\xe9";
    } else if ((0, $ac4edf06975cab12$export$f45642963264dfc6)(formula)) {
        // Validate operation has at least 2 arguments
        if (!formula.args || formula.args.length < 2) errors['interval.inputFormula'] = "Une op\xe9ration doit avoir au moins 2 arguments";
        else // Recursively validate each argument
        formula.args.forEach((arg, index)=>{
            const argErrors = $7618c882fbf65d57$export$d9c06132ce56cf6(arg, period, mode);
            if (Object.keys(argErrors).length > 0) errors['interval.inputFormula'] = `Erreur dans l'argument ${index + 1} de l'op\xe9ration`;
        });
    } else errors['interval.inputFormula'] = 'Type de formule invalide';
    return errors;
};
const $7618c882fbf65d57$export$fe9c56255827c054 = (values)=>{
    const errors = {};
    // Validate valuesInTime
    const valuesInTimeErrors = $7618c882fbf65d57$export$5f2295de277ec1be(values.valuesInTime);
    Object.assign(errors, valuesInTimeErrors);
    // Validate bounds
    const boundsErrors = $7618c882fbf65d57$export$51e58a02740fe411(values.interval);
    Object.assign(errors, boundsErrors);
    // Validate cross-fields
    const crossFieldErrors = $7618c882fbf65d57$export$7921405327bd91a2(values);
    Object.assign(errors, crossFieldErrors);
    // Validate daysOfWeek
    const daysOfWeekErrors = $7618c882fbf65d57$export$ad7b0da7c4e86059(values.interval);
    Object.assign(errors, daysOfWeekErrors);
    // Validate specialPeriods
    const specialPeriodsErrors = $7618c882fbf65d57$export$682d27946dc28da0(values.specialPeriods);
    Object.assign(errors, specialPeriodsErrors);
    // Validate inputFormula
    const inputFormulaErrors = $7618c882fbf65d57$export$d9c06132ce56cf6(values.interval.inputFormula, values.interval.period, values.interval.mode);
    Object.assign(errors, inputFormulaErrors);
    return errors;
};





const $b2c6278bb08ffd81$export$3ba56a41bc5cdf07 = (employerRule, employerId)=>{
    if (employerRule) {
        const hasSpecialPeriodsTypes = employerRule.specialPeriods && Array.isArray(employerRule.specialPeriods.types) ? employerRule.specialPeriods.types.length > 0 : false;
        return {
            ...employerRule,
            interval: {
                ...employerRule.interval,
                min: employerRule.interval.min ? employerRule.interval.min / 60000 : 0,
                max: employerRule.interval.max ? employerRule.interval.max / 60000 : 0,
                minPath: employerRule.interval.minPath || '',
                minFallback: employerRule.interval.minFallback ? employerRule.interval.minFallback / 60000 : '',
                maxPath: employerRule.interval.maxPath || '',
                maxFallback: employerRule.interval.maxFallback ? employerRule.interval.maxFallback / 60000 : '',
                minBoundsMode: employerRule.interval.minPath ? 'dynamic' : 'fixed',
                maxBoundsMode: employerRule.interval.maxPath ? 'dynamic' : 'fixed',
                mode: employerRule.interval.period === 'week' ? 'duration' : employerRule.interval.mode || 'duration',
                daysOfWeek: 'daysOfWeek' in employerRule.interval && employerRule.interval.daysOfWeek ? employerRule.interval.daysOfWeek : [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ],
                useCalendarDays: 'useCalendarDays' in employerRule.interval ? employerRule.interval.useCalendarDays : false,
                // Handle inputFormula - it should already be in the correct format from backend
                inputFormula: 'inputFormula' in employerRule.interval ? employerRule.interval.inputFormula : null
            },
            valuesInTime: employerRule.valuesInTime.map((vt)=>({
                    value: vt.value,
                    effectiveFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(vt.effectiveFrom)),
                    effectiveTo: vt.effectiveTo ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)((0, $410057b58fa5bc28$export$2e2bcd8739ae039)(new Date(vt.effectiveTo), 4)) : undefined
                })),
            employerDataOptions: employerRule.employerDataOptions,
            // Initialize special periods filters from existing rule
            specialPeriods: employerRule.specialPeriods ? {
                types: employerRule.specialPeriods.types || []
            } : {
                types: []
            },
            // Enable the UI toggle when existing rule already has special periods configured
            useSpecialPeriodsFilters: hasSpecialPeriodsTypes
        };
    }
    // Default values for new rule
    return {
        name: '',
        employer: employerId || '',
        employerDataOptions: {
            setDurationAsProportional: false,
            addToWorkedTotal: false
        },
        kind: 'add',
        valuesInTime: [
            {
                value: '',
                effectiveFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date()),
                effectiveTo: ''
            }
        ],
        interval: {
            name: '',
            period: '',
            inputFormula: null,
            min: '',
            max: '',
            minPath: '',
            minFallback: '',
            maxPath: '',
            maxFallback: '',
            minBoundsMode: 'fixed',
            maxBoundsMode: 'fixed',
            mode: 'duration',
            originOffset: undefined,
            daysOfWeek: [
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ],
            useCalendarDays: false
        },
        display: {
            summary: {
                totals: true,
                costs: true,
                days: true
            },
            payroll: true
        },
        // By default, special periods filters are disabled on new rule
        useSpecialPeriodsFilters: false,
        specialPeriods: {
            types: []
        }
    };
};
const $b2c6278bb08ffd81$export$2907f8bb30f24268 = (values)=>{
    // Destructure to avoid sending UI-only fields like useSpecialPeriodsFilters directly
    const { interval: interval, valuesInTime: valuesInTime, specialPeriods: specialPeriods, useSpecialPeriodsFilters: useSpecialPeriodsFilters, ...rest } = values;
    const payload = {
        ...rest,
        interval: {
            ...interval,
            name: values.name,
            useCalendarDays: interval.useCalendarDays,
            daysOfWeek: interval.daysOfWeek,
            // Handle inputFormula - send to backend as-is if present
            inputFormula: interval.inputFormula || undefined,
            // Handle bounds based on individual modes
            // Min bounds
            ...interval.minBoundsMode === 'fixed' ? {
                min: interval.min ? Number(interval.min) * 60000 : undefined
            } : {
                minPath: interval.minPath || undefined,
                minFallback: interval.minFallback ? Number(interval.minFallback) * 60000 : undefined
            },
            // Max bounds
            ...interval.maxBoundsMode === 'fixed' ? {
                max: interval.max ? Number(interval.max) * 60000 : undefined
            } : {
                maxPath: interval.maxPath || undefined,
                maxFallback: interval.maxFallback ? Number(interval.maxFallback) * 60000 : undefined
            },
            originOffset: interval.period === 'week' && interval.originOffset?.type ? interval.originOffset.type === 'none' ? {
                type: 'fixed',
                value: 0
            } : interval.originOffset.type === 'contract' ? {
                type: 'summaryPath',
                path: 'durations.contract.total'
            } : undefined : undefined
        },
        valuesInTime: valuesInTime.map((vt)=>({
                value: Number(vt.value),
                effectiveFrom: (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(vt.effectiveFrom),
                effectiveTo: vt.effectiveTo ? (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(vt.effectiveTo) : undefined
            })),
        // Apply specialPeriods filters only when explicitly enabled in the UI
        specialPeriods: {
            types: useSpecialPeriodsFilters && specialPeriods?.types ? specialPeriods.types : []
        }
    };
    // For timeRange mode, set a default inputFormula pointing to durations.accounted
    if (values.interval.mode === 'timeRange') payload.interval.inputFormula = (0, $ac4edf06975cab12$export$de86c3ff14650fb7)('durations.accounted');
    return payload;
};



parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");




/**
 * Component that handles the valuesInTime FieldArray section
 * Manages adding, removing, and displaying time periods
 */ const $f1d08a77ea8cd8db$var$ValuesInTimeSection = ({ values: values })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
            name: "valuesInTime",
            children: ({ push: push, remove: remove })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 12,
                    children: [
                        values.map((_, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 3,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            label: "Valeur",
                                            name: `valuesInTime.${index}.value`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            type: "number",
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            label: "Date de d\xe9but",
                                            name: `valuesInTime.${index}.effectiveFrom`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            type: "date",
                                            required: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 4,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            label: `Date de fin ${index === values.length - 1 ? '(optionnel)' : ''}`,
                                            name: `valuesInTime.${index}.effectiveTo`,
                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                            type: "date"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 1,
                                        children: values.length > 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            color: "danger",
                                            size: "small",
                                            onClick: ()=>remove(index),
                                            style: {
                                                marginTop: '2.2rem'
                                            },
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {
                                                    color: "white"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }, index)),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                            onClick: ()=>push({
                                    value: '',
                                    effectiveFrom: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date()),
                                    effectiveTo: ''
                                }),
                            children: "Ajouter une p\xe9riode"
                        })
                    ]
                })
        })
    });
};
var $f1d08a77ea8cd8db$export$2e2bcd8739ae039 = $f1d08a77ea8cd8db$var$ValuesInTimeSection;



parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");



/**
 * Component that handles bounds configuration (min or max)
 * Manages fixed vs dynamic modes and conditional fields
 */ const $beffa4f94cc0cb0f$var$BoundsConfigSection = ({ boundsType: boundsType, values: values })=>{
    const isMin = boundsType === 'min';
    const boundsMode = isMin ? values.minBoundsMode : values.maxBoundsMode;
    const modeFieldName = isMin ? 'interval.minBoundsMode' : 'interval.maxBoundsMode';
    const valueFieldName = isMin ? 'interval.min' : 'interval.max';
    const pathFieldName = isMin ? 'interval.minPath' : 'interval.maxPath';
    const fallbackFieldName = isMin ? 'interval.minFallback' : 'interval.maxFallback';
    const label = isMin ? 'Valeur minimale' : 'Valeur maximale';
    const valueLabel = isMin ? "R\xe8gle appliqu\xe9e \xe0 partir de (minutes)" : "R\xe8gle appliqu\xe9e jusqu'\xe0 (minutes)";
    const pathLabel = isMin ? 'Chemin pour la valeur minimale' : 'Chemin pour la valeur maximale';
    const fallbackLabel = isMin ? 'Valeur de fallback pour min (minutes)' : 'Valeur de fallback pour max (minutes)';
    const pathHelp = "Chemin vers une valeur dans les donn\xe9es de r\xe9sum\xe9";
    const fallbackHelp = "Valeur utilis\xe9e si le chemin retourne 0 ou n'existe pas";
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 12,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    size: 6,
                    children: label
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 6,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: "Mode de d\xe9finition",
                    name: modeFieldName,
                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                    options: [
                        {
                            value: 'fixed',
                            label: 'Valeur fixe'
                        },
                        {
                            value: 'dynamic',
                            label: 'Valeur dynamique'
                        }
                    ],
                    required: true,
                    fullwidth: true
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 6,
                children: boundsMode === 'fixed' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: valueLabel,
                    name: valueFieldName,
                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                    type: "number",
                    required: isMin
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: pathLabel,
                    name: pathFieldName,
                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                    options: [
                        {
                            value: 'durations.contract.total',
                            label: "Dur\xe9e totale du contrat"
                        },
                        {
                            value: 'durations.contract.remainingAfterBenefit',
                            label: "Dur\xe9e restante du contrat apr\xe8s \xe9v\xe8nements prestations"
                        }
                    ],
                    required: true,
                    help: pathHelp
                })
            }),
            boundsMode === 'dynamic' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                size: 6,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: fallbackLabel,
                    name: fallbackFieldName,
                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                    type: "number",
                    help: fallbackHelp
                })
            })
        ]
    });
};
var $beffa4f94cc0cb0f$export$2e2bcd8739ae039 = $beffa4f94cc0cb0f$var$BoundsConfigSection;



/**
 * Main EmployerRulesForm component
 * Handles form state, validation, and submission for employer rules
 */ const $f82795e84deeb7f6$var$EmployerRulesForm = ({ employerRule: employerRule, employerId: employerId })=>{
    const createMutation = (0, $52dfa770bdcaf9bf$export$a25726670bb41cb)();
    const updateMutation = (0, $52dfa770bdcaf9bf$export$cac0b33e6f13c8ec)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    // Determine base path from current location
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employerId}` : '/settings';
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (createMutation.isSuccess) navigate(`${basePath}/employer-rules/${createMutation.data.data._id}`);
    }, [
        createMutation.isSuccess,
        basePath,
        navigate
    ]);
    const initialValues = (0, $b2c6278bb08ffd81$export$3ba56a41bc5cdf07)(employerRule, employerId);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues,
        enableReinitialize: true,
        validate: (0, $7618c882fbf65d57$export$fe9c56255827c054),
        onSubmit: (values)=>{
            const payload = (0, $b2c6278bb08ffd81$export$2907f8bb30f24268)(values);
            if (!employerRule) createMutation.mutate(payload);
            else updateMutation.mutate({
                id: employerRule._id,
                ...payload
            });
        },
        children: ({ values: values })=>{
            // Days of the week configuration (Lundi = 0, Dimanche = 6)
            const daysOfWeekOptions = [
                {
                    value: 0,
                    label: 'Lundi'
                },
                {
                    value: 1,
                    label: 'Mardi'
                },
                {
                    value: 2,
                    label: 'Mercredi'
                },
                {
                    value: 3,
                    label: 'Jeudi'
                },
                {
                    value: 4,
                    label: 'Vendredi'
                },
                {
                    value: 5,
                    label: 'Samedi'
                },
                {
                    value: 6,
                    label: 'Dimanche'
                }
            ];
            // Fetch special period types for the employer
            const specialPeriodTypesQuery = (0, $f61e9610046189fb$export$6eb0b72d5a868fd7)(employerId);
            // Fetch all employer rules for the employer (for formula references)
            const employerRulesQuery = (0, $52dfa770bdcaf9bf$export$86c10eec7ad727f4)({
                employer: employerId
            });
            // Prepare options for special period types
            const specialPeriodTypesOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
                if (!specialPeriodTypesQuery.data) return [];
                return (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(specialPeriodTypesQuery.data);
            }, [
                specialPeriodTypesQuery.data
            ]);
            // Prepare options for employer rules (for formula references)
            // Filter out the current rule to prevent self-reference
            const availableRulesOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
                if (!employerRulesQuery.data) return [];
                // Only allow referencing rules with the same period as the current rule.
                // Notes:
                // - when building a 'day' formula, only show 'day' rules
                // - when building a 'week' formula, we allow both 'week' and 'day' rules
                const currentPeriod = values.interval?.period;
                return employerRulesQuery.data.filter((rule)=>!employerRule || rule._id !== employerRule._id).filter((rule)=>{
                    if (!currentPeriod) return true;
                    const rulePeriod = rule.interval?.period;
                    if (currentPeriod === 'week') return rulePeriod === 'week' || rulePeriod === 'day';
                    return rulePeriod === currentPeriod;
                }).map((rule)=>({
                        value: rule._id,
                        label: `${rule.name} (${rule.shortName || rule.name})`
                    }));
            }, [
                employerRulesQuery.data,
                employerRule,
                values.interval?.period
            ]);
            // Fetch work period events for the employer (for eventPath formula)
            const workPeriodEventsQuery = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)({
                employer: employerId
            });
            const availableEventsOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
                if (!workPeriodEventsQuery.data) return [];
                return workPeriodEventsQuery.data.map((event)=>({
                        value: event._id,
                        label: `${event.code} - ${event.title} (${event.type === 'benefit' ? 'Prestation' : 'Informatif'})`
                    }));
            }, [
                workPeriodEventsQuery.data
            ]);
            // Determine if any filter is applied
            const hasSpecialPeriodFilter = (values.specialPeriods?.types?.length || 0) > 0;
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Informations de base"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Nom ",
                                    name: "name",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    required: true,
                                    disabled: Boolean(employerRule),
                                    help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "strong",
                                        children: "Ne peut pas \xeatre modifi\xe9 apr\xe8s la cr\xe9ation"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Nom court",
                                    name: "shortName",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    required: true,
                                    help: "Utilis\xe9 pour les ent\xeates des colonnes dans les r\xe9capitulatifs"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Donn\xe9es pour le calcul"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "P\xe9riode compl\xe8te ou jour s\xe9par\xe9",
                                    name: "interval.period",
                                    fullwidth: true,
                                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                    options: [
                                        {
                                            value: 'day',
                                            label: 'Calcul par jour'
                                        },
                                        {
                                            value: 'week',
                                            label: "Calcul par semaine / p\xe9riode"
                                        }
                                    ],
                                    required: true,
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Calcul par jour :"
                                                    }),
                                                    " La prime est calcul\xe9e s\xe9par\xe9ment pour chaque jour qui correspond aux crit\xe8res de la r\xe8gle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: "Exemple : Si une prime de 2\u20AC par heure est appliqu\xe9e le lundi et le mardi, chaque jour est calcul\xe9 ind\xe9pendamment. 8h le lundi = 16\u20AC, 8h le mardi = 16\u20AC, total = 32\u20AC."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Calcul par semaine / p\xe9riode :"
                                                    }),
                                                    " La prime est calcul\xe9e sur l'ensemble de la p\xe9riode en fonction des crit\xe8res d\xe9finis."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: "Exemple : Si une prime de 50\u20AC est appliqu\xe9e quand l'objectif de 40 heures est atteint sur la semaine, la prime est calcul\xe9e une seule fois pour toute la semaine si l'objectif est atteint, et non pas jour par jour."
                                            })
                                        ]
                                    })
                                })
                            }),
                            (values.interval.period === 'day' || values.interval.period === 'week') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Jours de la semaine",
                                    name: "interval.daysOfWeek",
                                    component: (0, $1330dd4361837ef2$export$2e2bcd8739ae039),
                                    options: daysOfWeekOptions,
                                    required: true,
                                    columnSize: "narrow",
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: "S\xe9lectionnez les jours de la semaine o\xf9 cette r\xe8gle de prime doit s'appliquer."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: 'Exemple : Si vous s\xe9lectionnez uniquement "Lundi" et "Mardi", la prime sera calcul\xe9e uniquement pour ces deux jours de la semaine, et non pour les autres jours.'
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Calcul par jour :"
                                                    }),
                                                    " La prime est appliqu\xe9e s\xe9par\xe9ment pour chaque jour s\xe9lectionn\xe9."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Calcul par semaine :"
                                                    }),
                                                    " La prime est appliqu\xe9e sur l'ensemble de la semaine si les jours s\xe9lectionn\xe9s sont concern\xe9s."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Utiliser les jours calendaires",
                                    name: "interval.useCalendarDays",
                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Si coch\xe9 :"
                                                    }),
                                                    " Prend uniquement en compte la dur\xe9e concern\xe9e entre 00h00 et 23h59 du jour de la r\xe8gle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: "Exemple : Si un travailleur commence \xe0 22h le lundi et finit \xe0 6h le mardi, seules les heures entre 0h et 6h du mardi seront prises en compte pour le calcul de la prime du mardi."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Si non coch\xe9 :"
                                                    }),
                                                    " Prend en compte les heures comptabilis\xe9es sur la journ\xe9e de travail."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: "Exemple : Si un travailleur commence \xe0 22h le lundi et finit \xe0 6h le mardi, toutes les heures travaill\xe9es sur la journ\xe9e de travail seront prises en compte pour le calcul de la prime du lundi."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Mode de calcul de la prime",
                                    name: "kind",
                                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                    options: [
                                        {
                                            value: 'add',
                                            label: "Ajout d'une valeur fixe pour chaque heure"
                                        },
                                        {
                                            value: 'multiply',
                                            label: "Multiplication du co\xfbt horaire (pourcentage) pour chaque heure"
                                        },
                                        {
                                            value: 'goal',
                                            label: "Prime - valeur ajout\xe9e quand l'objectif est atteint"
                                        }
                                    ],
                                    required: true,
                                    fullwidth: true,
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Ajout d'une valeur fixe :"
                                                    }),
                                                    " Une valeur fixe est ajout\xe9e pour chaque heure travaill\xe9e."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: "Exemple : Si la valeur est 2\u20AC, 8 heures travaill\xe9es = 8 \xd7 2\u20AC = 16\u20AC de prime."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Multiplication du co\xfbt horaire :"
                                                    }),
                                                    " Le co\xfbt horaire est multipli\xe9 par un pourcentage pour chaque heure."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: "Exemple : Si le co\xfbt horaire est 10\u20AC et le multiplicateur 1.5 (150%), chaque heure co\xfbte 15\u20AC (10\u20AC + 5\u20AC de prime). Pour 8 heures : 8 \xd7 15\u20AC = 120\u20AC (40\u20AC de prime)."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Prime quand l'objectif est atteint :"
                                                    }),
                                                    ' ',
                                                    "Une prime fixe est ajout\xe9e uniquement si l'objectif d\xe9fini est atteint."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: "Exemple : Si l'objectif est de 40 heures et la prime de 50\u20AC, la prime de 50\u20AC est ajout\xe9e si les 40 heures sont atteintes."
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                    backgroundColor: "light",
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                            size: 5,
                                            mt: 1,
                                            children: [
                                                "Valeurs appliqu\xe9es",
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                                    className: "help mb-4",
                                                    children: "Les p\xe9riodes doivent \xeatre continues et sans chevauchement. Si une p\xe9riode est sans date de fin, elle doit \xeatre la plus r\xe9cente."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f1d08a77ea8cd8db$export$2e2bcd8739ae039), {
                                            values: values.valuesInTime
                                        })
                                    ]
                                })
                            }),
                            values.interval.period === 'day' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Mode de calcul de l'intervalle",
                                    name: "interval.mode",
                                    component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                    options: [
                                        {
                                            value: 'duration',
                                            label: "Dur\xe9e"
                                        },
                                        {
                                            value: 'timeRange',
                                            label: 'Plage horaire'
                                        }
                                    ],
                                    required: true,
                                    fullwidth: true,
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Dur\xe9e :"
                                                    }),
                                                    " Calcule directement sur la dur\xe9e totale travaill\xe9e, sans tenir compte des plages horaires sp\xe9cifiques de chaque p\xe9riode."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 4,
                                                children: "Exemple : Si l'intervalle est d\xe9fini entre 8h et 18h et qu'un travailleur a travaill\xe9 de 7h \xe0 10h puis de 12h \xe0 20h, la dur\xe9e totale travaill\xe9e (3h + 8h = 11h) sera utilis\xe9e pour le calcul, ind\xe9pendamment de l'intervalle d\xe9fini."
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Plage horaire :"
                                                    }),
                                                    " Ne prend en compte que les heures travaill\xe9es qui se trouvent dans l'intervalle d\xe9fini (entre min et max)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: "Exemple : Si l'intervalle est d\xe9fini entre 8h et 18h et qu'un travailleur a travaill\xe9 de 7h \xe0 10h puis de 12h \xe0 20h, seules les heures entre 8h et 18h seront prises en compte : 2h (de 8h \xe0 10h) + 6h (de 12h \xe0 18h) = 8h pour le calcul de la prime."
                                            })
                                        ]
                                    })
                                })
                            }),
                            values.interval?.mode === 'duration' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Formule d'input - Valeur prise en compte",
                                    name: "interval.inputFormula",
                                    component: (0, $b48a3cffd193d921$export$2e2bcd8739ae039),
                                    availablePaths: (0, $ac4edf06975cab12$export$ea54e50380c56fca)(values.interval.period || '', values.interval.mode),
                                    availableRules: availableRulesOptions,
                                    availableEvents: availableEventsOptions,
                                    disabled: !values.interval?.period,
                                    required: true,
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Formule d'input :"
                                                    }),
                                                    " D\xe9finit quelle valeur doit \xeatre utilis\xe9e comme base pour le calcul de cette r\xe8gle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Mode simple :"
                                                    }),
                                                    " S\xe9lectionnez un path unique parmi les options disponibles (ex: durations.worked.total pour les heures totales travaill\xe9es)."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Mode avanc\xe9 :"
                                                    }),
                                                    " Composez des formules complexes en combinant plusieurs paths ou r\xe9f\xe9rences \xe0 d'autres r\xe8gles avec des op\xe9rations (addition, soustraction)."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Bornes de l'intervalle"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $beffa4f94cc0cb0f$export$2e2bcd8739ae039), {
                        boundsType: "min",
                        values: values.interval
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $beffa4f94cc0cb0f$export$2e2bcd8739ae039), {
                        boundsType: "max",
                        values: values.interval
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Application pendant les p\xe9riodes sp\xe9ciales"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        text: "Appliquer la r\xe8gle \xe0 des p\xe9riodes sp\xe9ciales",
                        name: "useSpecialPeriodsFilters",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                    }),
                    values.useSpecialPeriodsFilters && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 12,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "info",
                                mb: 0,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: !hasSpecialPeriodFilter ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "strong",
                                        children: "Aucune p\xe9riode sp\xe9ciale s\xe9lectionn\xe9e : la r\xe8gle s'applique aux journ\xe9es normales"
                                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "strong",
                                        children: "La r\xe8gle s'applique uniquement pendant les p\xe9riodes sp\xe9ciales correspondantes"
                                    })
                                })
                            })
                        })
                    }),
                    values.useSpecialPeriodsFilters && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 12,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                label: "Types de p\xe9riodes sp\xe9ciales",
                                name: "specialPeriods.types",
                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                options: specialPeriodTypesOptions,
                                info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "p",
                                            children: "S\xe9lectionnez un ou plusieurs types de p\xe9riodes sp\xe9ciales. La r\xe8gle s'appliquera si une p\xe9riode sp\xe9ciale correspond \xe0 l'un des types s\xe9lectionn\xe9s."
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "p",
                                            children: "Exemple : Si vous s\xe9lectionnez \"Jour f\xe9ri\xe9\", la r\xe8gle s'appliquera pour tous les jours f\xe9ri\xe9s de l'employeur."
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            values.kind === 'multiply' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                mt: 4,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Enregistrer la dur\xe9e comme diff\xe9rence de la multiplication",
                                    name: "employerDataOptions.setDurationAsProportional",
                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                    help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                                        children: [
                                            "Exemple",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                            "Non: La dur\xe9e enregistr\xe9e est \xe9gale \xe0 la dur\xe9e travaill\xe9e dans la p\xe9riode de la r\xe8gle.",
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                            "Oui: Une heure * ",
                                            values.valuesInTime[0]?.value || '1.5',
                                            " =",
                                            ' ',
                                            (((0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59) * (Number(values.valuesInTime[0]?.value) || 1.5) - (0, $74f17ceb9b5a08a5$export$3d8caa708e1aba59)) / 1000 / 60).toFixed(2),
                                            ' ',
                                            "minutes"
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                mt: 4,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    text: "Ajouter la dur\xe9e calcul\xe9e \xe0 la dur\xe9e totale travaill\xe9e",
                                    name: "employerDataOptions.addToWorkedTotal",
                                    component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                    info: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                mb: 2,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "D\xe9sactiv\xe9e : "
                                                    }),
                                                    "La dur\xe9e calcul\xe9e n'est pas ajout\xe9e au total des heures travaill\xe9es. Elle sert uniquement \xe0 d\xe9terminer la dur\xe9e prise en pour l'application de la r\xe8gle."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                        renderAs: "strong",
                                                        children: "Activ\xe9e : "
                                                    }),
                                                    "La dur\xe9e calcul\xe9e par cette r\xe8gle sera ajout\xe9e au total des heures comptabilis\xe9es dans la semaine."
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Param\xe8tres d'affichage"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        text: "Afficher dans les totaux du r\xe9capitulatif",
                        name: "display.summary.totals",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        text: "Afficher dans les co\xfbts du r\xe9capitulatif",
                        name: "display.summary.costs",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                    }),
                    values.interval.period === 'day' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        text: "Afficher dans les journ\xe9es du r\xe9capitulatif",
                        name: "display.summary.days",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        text: "Visible dans la vue Paie",
                        name: "display.payroll",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: !employerRule ? createMutation : updateMutation,
                        mt: 6,
                        children: employerRule ? "Mettre \xe0 jour" : "Cr\xe9er"
                    })
                ]
            });
        }
    });
};
var $f82795e84deeb7f6$export$2e2bcd8739ae039 = $f82795e84deeb7f6$var$EmployerRulesForm;












/**
 * Component for managing employer rule details in settings
 * Uses outlet context to get employer and displays the form with sidebar
 */ const $1f6947e60bd29be4$var$EmployerRuleDetailsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)({
        idName: 'employerRuleId'
    });
    const { data: employerRule } = (0, $52dfa770bdcaf9bf$export$473d39c76a4326c9)(id, {
        enabled: Boolean(id && !isNew)
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: isNew ? "Nouvelle R\xe8gle Employeur" : `R\xe8gle ${employerRule?.name || ''}`
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f82795e84deeb7f6$export$2e2bcd8739ae039), {
                    employerRule: employerRule,
                    employerId: employer._id
                })
            })
        ]
    });
};
var $1f6947e60bd29be4$export$2e2bcd8739ae039 = $1f6947e60bd29be4$var$EmployerRuleDetailsSettings;



parcelRequire("3ZYaX");







var $31tXu = parcelRequire("31tXu");
const $e3a4562d17ac3ce9$var$LoginAsQrScannerUserPage = ()=>{
    const currentUser = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentUser);
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentUserRole);
    const isSuperAdmin = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.isSuperAdmin);
    const loggedAs = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.loggedAs);
    const changeCurrentRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.changeCurrentRole);
    const allEmployers = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)()?.data?.filter((o)=>o.type === 'employer');
    const authMutation = (0, $e607e015ac40917d$export$7d483d5f301dc18f)();
    const notAuthorized = allEmployers?.length === 0;
    const isSystemUser = currentUser?.appAccess === 'system';
    // First but first, we are already loggged, all terminals point to /kiosk
    // -> For login
    // -> But also for scan
    // If already logged as system user, we just forward to the laser
    if (isSystemUser) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/laser-scanner"
    });
    // Here we are configuring a terminal
    // Due to the way sessions initialize, Super Admins user might have their
    // current user role set to an organization they are part of
    // Super Admins need the full employers list, so we force change current role
    // The only case allowed is being a Super Admin and using the "login as" feature
    if (isSuperAdmin && !loggedAs && currentUserRole !== 'superAdmin') {
        const superAdminRole = currentUser?.roles.find((role)=>role.kind === 'superAdmin');
        superAdminRole && changeCurrentRole(superAdminRole);
    }
    if (allEmployers === undefined) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: 'large',
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    centered: true,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 4,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                children: "Cr\xe9er une Borne de Scan"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: notAuthorized ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: "Vous n'\xeates pas autoris\xe9 \xe0 cr\xe9er une Borne de Scan"
                                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                                        my: 5,
                                        mb: 6,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                                            initialValues: {
                                                loginAsQrScannerForEmployerId: allEmployers?.[0]?._id
                                            },
                                            enableReinitialize: true,
                                            onSubmit: async ({ loginAsQrScannerForEmployerId: loginAsQrScannerForEmployerId })=>{
                                                authMutation.mutate({
                                                    loginAsQrScannerForEmployerId: loginAsQrScannerForEmployerId
                                                });
                                            },
                                            children: (props)=>{
                                                return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                            children: [
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                                    children: "Employeur pour la Borne de Scan ?"
                                                                }),
                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                                    children: allEmployers?.map((e)=>{
                                                                        return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Radio, {
                                                                                    name: e._id,
                                                                                    checked: props.values.loginAsQrScannerForEmployerId === e._id,
                                                                                    value: e._id,
                                                                                    onChange: ()=>props.setFieldValue('loginAsQrScannerForEmployerId', e._id),
                                                                                    children: e.name
                                                                                }, e._id),
                                                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                                                                            ]
                                                                        });
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            type: "submit",
                                                            mt: 5,
                                                            children: "Cr\xe9er un Kiosque"
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $e3a4562d17ac3ce9$export$2e2bcd8739ae039 = $e3a4562d17ac3ce9$var$LoginAsQrScannerUserPage;



parcelRequire("3ZYaX");








const $de104446ac90b824$var$BillingDashboard = ()=>{
    const thisMonth = (0, $9d8683737c4c4df2$export$2e2bcd8739ae039)(new Date());
    const thisMonthWortkPeriods = $de104446ac90b824$var$useWorkPeriodsCount(thisMonth, (0, $b8561e530ff0425c$export$2e2bcd8739ae039)(thisMonth));
    const previousMonth = (0, $41500622c442f1a1$export$2e2bcd8739ae039)(thisMonth, 1);
    const previousMonthWorkPeriods = $de104446ac90b824$var$useWorkPeriodsCount(previousMonth, (0, $b8561e530ff0425c$export$2e2bcd8739ae039)(previousMonth));
    const employers = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    })?.data;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: 'Billing'
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("table", {
                                className: "table",
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("thead", {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                                    children: "Date"
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                                    children: "Total"
                                                }),
                                                employers?.map((e)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                                        children: e.name
                                                    }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                children: (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(previousMonth)
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                children: previousMonthWorkPeriods?.length
                                            }),
                                            employers?.map((e)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: previousMonthWorkPeriods?.filter((wP)=>wP.employer === e._id).length
                                                }))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                children: (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(thisMonth)
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                children: thisMonthWortkPeriods?.length
                                            }),
                                            employers?.map((e)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                                    children: thisMonthWortkPeriods?.filter((wP)=>wP.employer === e._id).length
                                                }))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                        ]
                    })
                })
            })
        ]
    });
};
var $de104446ac90b824$export$2e2bcd8739ae039 = $de104446ac90b824$var$BillingDashboard;
const $de104446ac90b824$var$useWorkPeriodsCount = (start, end)=>{
    const workPeriodsQuery = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)({
        start: start,
        end: end,
        fields: [
            'employer',
            'start',
            'end'
        ]
    });
    return workPeriodsQuery.data;
};





parcelRequire("3ZYaX");









const $c36e8a02d3a8c4bf$export$160aa3c6cabe487f = (query)=>{
    return JSON.stringify(query);
};


const $ec117dea2333c8af$export$f722f744b7d3e151 = (filters)=>{
    const { start: start, end: end, interimAgency: interimAgency, employer: employer, user: user, service: service, jobTitle: jobTitle, events: events, tags: tags } = filters;
    const startDate = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(start));
    const endDate = (0, $e94c78fdddee0309$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(end));
    const workPeriodsQuery = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)({
        populate: [
            'start.clocking',
            'end.clocking'
        ],
        start: startDate,
        end: endDate,
        interimAgency: interimAgency,
        employer: employer,
        user: user,
        events: events,
        jobTitle: jobTitle,
        service: service,
        tags: tags
    }, {
        staleTime: 60000
    });
    const query = {
        filter: (0, $c36e8a02d3a8c4bf$export$160aa3c6cabe487f)({
            'missionData.workPeriods': {
                $elemMatch: {
                    'start.date': {
                        $lte: (0, $e94c78fdddee0309$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(end)),
                        $gte: (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(start))
                    }
                }
            }
        }),
        // @ts-expect-error
        interimAgency: interimAgency,
        'posts.jobTitle': jobTitle,
        'posts.desiredWorkers': user,
        //@ts-expect-error
        'missionData.service': service,
        populate: [
            'posts.missions'
        ]
    };
    const workersRequestsQuery = (0, $b8c6247768bd4102$export$5084421b5a71fe52)(query, {
        staleTime: 60000
    });
    const posts = workersRequestsQuery.data?.reduce((posts, current)=>{
        for (const post of current.posts)posts.push({
            ...post,
            workersRequest: current
        });
        return posts;
    }, []) ?? [];
    const workPeriods = workPeriodsQuery.data ?? [];
    const stats = {
        start: start,
        end: end,
        workPeriods: {
            combine: (stats, statIds)=>{
                const all = statIds.map((statId)=>stats[statId]);
                const result = all.reduce((common, currentArray)=>{
                    const currentIds = currentArray.map((obj)=>obj._id);
                    return common.filter((obj)=>currentIds.some((_id)=>_id === obj._id));
                }, all[0] ?? []);
                return result;
            },
            total: workPeriods,
            expected: workPeriods.filter((wP)=>!wP.isAbandoned && !wP.isCancelled),
            notExpected: workPeriods.filter((wP)=>wP.isAbandoned || wP.isCancelled),
            cancelled: workPeriods.filter((wP)=>wP.isCancelled),
            notCancelled: workPeriods.filter((wP)=>!wP.isCancelled),
            abandoned: workPeriods.filter((wP)=>wP.isAbandoned),
            notAbandoned: workPeriods.filter((wP)=>!wP.isAbandoned),
            validated: workPeriods.filter((wP)=>wP.isValidated),
            notValidated: workPeriods.filter((wP)=>!wP.isValidated),
            clocked: workPeriods.filter((wP)=>wP.start.clocking?.date || wP.start.manualClocking),
            notClocked: workPeriods.filter((wP)=>!wP.start.clocking?.date && !wP.start.manualClocking),
            clockedIn: workPeriods.filter((wP)=>wP.start.clocking?.date || wP.start.manualClocking),
            clockedInNotOut: workPeriods.filter((wP)=>(wP.start.clocking?.date || wP.start.manualClocking) && !(wP.end.clocking?.date || wP.end.manualClocking)),
            clockedOut: workPeriods.filter((wP)=>wP.end.clocking?.date || wP.end.manualClocking),
            late: workPeriods.filter((wP)=>{
                const isLate = (0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(wP.start.clocking?.date || wP.start.manualClocking || new Date()), new Date(wP.start.date));
                return isLate;
            }),
            notLate: workPeriods.filter((wP)=>!(0, $379899354a78c3bb$export$2e2bcd8739ae039)(new Date(wP.start.clocking?.date || wP.start.manualClocking || new Date()), new Date(wP.start.date)))
        },
        posts: {
            combine: (stats, statIds)=>{
                const all = statIds.map((statId)=>stats[statId]);
                const result = all.reduce((common, currentArray)=>{
                    const currentIds = currentArray.map((obj)=>obj._id);
                    return common.filter((obj)=>currentIds.some((_id)=>_id === obj._id));
                }, all[0] ?? []);
                return result;
            },
            total: posts,
            cancelled: posts.filter((p)=>p.workersRequest.isCancelled),
            notCancelled: posts.filter((p)=>!p.workersRequest.isCancelled),
            filled: posts.filter((p)=>p.missions.length > 0 && !p.__actions.canBeUpdated),
            missing: posts.filter((p)=>p.missions.length === 0 && p.__actions.canBeUpdated)
        }
    };
    return stats;
};




parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $3ZYaX = parcelRequire("3ZYaX");

var $3ZYaX = parcelRequire("3ZYaX");

var $9C0qR = parcelRequire("9C0qR");

var $3ZYaX = parcelRequire("3ZYaX");
// src/index.ts
// src/hooks/useChain.ts
// src/index.ts
var $29408370dcd41a17$var$updateQueue = $29408370dcd41a17$var$makeQueue();
var $29408370dcd41a17$export$27f233d61a9e2fa4 = (fn)=>$29408370dcd41a17$var$schedule(fn, $29408370dcd41a17$var$updateQueue);
var $29408370dcd41a17$var$writeQueue = $29408370dcd41a17$var$makeQueue();
$29408370dcd41a17$export$27f233d61a9e2fa4.write = (fn)=>$29408370dcd41a17$var$schedule(fn, $29408370dcd41a17$var$writeQueue);
var $29408370dcd41a17$var$onStartQueue = $29408370dcd41a17$var$makeQueue();
$29408370dcd41a17$export$27f233d61a9e2fa4.onStart = (fn)=>$29408370dcd41a17$var$schedule(fn, $29408370dcd41a17$var$onStartQueue);
var $29408370dcd41a17$var$onFrameQueue = $29408370dcd41a17$var$makeQueue();
$29408370dcd41a17$export$27f233d61a9e2fa4.onFrame = (fn)=>$29408370dcd41a17$var$schedule(fn, $29408370dcd41a17$var$onFrameQueue);
var $29408370dcd41a17$var$onFinishQueue = $29408370dcd41a17$var$makeQueue();
$29408370dcd41a17$export$27f233d61a9e2fa4.onFinish = (fn)=>$29408370dcd41a17$var$schedule(fn, $29408370dcd41a17$var$onFinishQueue);
var $29408370dcd41a17$var$timeouts = [];
$29408370dcd41a17$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $29408370dcd41a17$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $29408370dcd41a17$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $29408370dcd41a17$var$timeouts.splice(i, 1);
        $29408370dcd41a17$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $29408370dcd41a17$var$timeouts.splice($29408370dcd41a17$var$findTimeout(time), 0, timeout);
    $29408370dcd41a17$var$pendingCount += 1;
    $29408370dcd41a17$var$start();
    return timeout;
};
var $29408370dcd41a17$var$findTimeout = (time)=>~(~$29408370dcd41a17$var$timeouts.findIndex((t)=>t.time > time) || ~$29408370dcd41a17$var$timeouts.length);
$29408370dcd41a17$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $29408370dcd41a17$var$onStartQueue.delete(fn);
    $29408370dcd41a17$var$onFrameQueue.delete(fn);
    $29408370dcd41a17$var$onFinishQueue.delete(fn);
    $29408370dcd41a17$var$updateQueue.delete(fn);
    $29408370dcd41a17$var$writeQueue.delete(fn);
};
$29408370dcd41a17$export$27f233d61a9e2fa4.sync = (fn)=>{
    $29408370dcd41a17$var$sync = true;
    $29408370dcd41a17$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $29408370dcd41a17$var$sync = false;
};
$29408370dcd41a17$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $29408370dcd41a17$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $29408370dcd41a17$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $29408370dcd41a17$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$29408370dcd41a17$export$27f233d61a9e2fa4.use = (impl)=>$29408370dcd41a17$var$nativeRaf = impl;
$29408370dcd41a17$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$29408370dcd41a17$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$29408370dcd41a17$export$27f233d61a9e2fa4.catch = console.error;
$29408370dcd41a17$export$27f233d61a9e2fa4.frameLoop = "always";
$29408370dcd41a17$export$27f233d61a9e2fa4.advance = ()=>{
    if ($29408370dcd41a17$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $29408370dcd41a17$var$update();
};
var $29408370dcd41a17$var$ts = -1;
var $29408370dcd41a17$var$pendingCount = 0;
var $29408370dcd41a17$var$sync = false;
function $29408370dcd41a17$var$schedule(fn, queue) {
    if ($29408370dcd41a17$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $29408370dcd41a17$var$start();
    }
}
function $29408370dcd41a17$var$start() {
    if ($29408370dcd41a17$var$ts < 0) {
        $29408370dcd41a17$var$ts = 0;
        if ($29408370dcd41a17$export$27f233d61a9e2fa4.frameLoop !== "demand") $29408370dcd41a17$var$nativeRaf($29408370dcd41a17$var$loop);
    }
}
function $29408370dcd41a17$var$stop() {
    $29408370dcd41a17$var$ts = -1;
}
function $29408370dcd41a17$var$loop() {
    if (~$29408370dcd41a17$var$ts) {
        $29408370dcd41a17$var$nativeRaf($29408370dcd41a17$var$loop);
        $29408370dcd41a17$export$27f233d61a9e2fa4.batchedUpdates($29408370dcd41a17$var$update);
    }
}
function $29408370dcd41a17$var$update() {
    const prevTs = $29408370dcd41a17$var$ts;
    $29408370dcd41a17$var$ts = $29408370dcd41a17$export$27f233d61a9e2fa4.now();
    const count = $29408370dcd41a17$var$findTimeout($29408370dcd41a17$var$ts);
    if (count) {
        $29408370dcd41a17$var$eachSafely($29408370dcd41a17$var$timeouts.splice(0, count), (t)=>t.handler());
        $29408370dcd41a17$var$pendingCount -= count;
    }
    if (!$29408370dcd41a17$var$pendingCount) {
        $29408370dcd41a17$var$stop();
        return;
    }
    $29408370dcd41a17$var$onStartQueue.flush();
    $29408370dcd41a17$var$updateQueue.flush(prevTs ? Math.min(64, $29408370dcd41a17$var$ts - prevTs) : 16.667);
    $29408370dcd41a17$var$onFrameQueue.flush();
    $29408370dcd41a17$var$writeQueue.flush();
    $29408370dcd41a17$var$onFinishQueue.flush();
}
function $29408370dcd41a17$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $29408370dcd41a17$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $29408370dcd41a17$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $29408370dcd41a17$var$pendingCount -= current.size;
                $29408370dcd41a17$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $29408370dcd41a17$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $29408370dcd41a17$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $29408370dcd41a17$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $29408370dcd41a17$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $29408370dcd41a17$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $29408370dcd41a17$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $29408370dcd41a17$var$ts = -1;
        $29408370dcd41a17$var$timeouts = [];
        $29408370dcd41a17$var$onStartQueue = $29408370dcd41a17$var$makeQueue();
        $29408370dcd41a17$var$updateQueue = $29408370dcd41a17$var$makeQueue();
        $29408370dcd41a17$var$onFrameQueue = $29408370dcd41a17$var$makeQueue();
        $29408370dcd41a17$var$writeQueue = $29408370dcd41a17$var$makeQueue();
        $29408370dcd41a17$var$onFinishQueue = $29408370dcd41a17$var$makeQueue();
        $29408370dcd41a17$var$pendingCount = 0;
    }
};



var $3ZYaX = parcelRequire("3ZYaX");
var $d49437e914453600$var$__defProp = Object.defineProperty;
var $d49437e914453600$var$__export = (target, all)=>{
    for(var name in all)$d49437e914453600$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $d49437e914453600$export$cceeabf822b64fc0 = {};
$d49437e914453600$var$__export($d49437e914453600$export$cceeabf822b64fc0, {
    assign: ()=>$d49437e914453600$var$assign,
    colors: ()=>$d49437e914453600$var$colors,
    createStringInterpolator: ()=>$d49437e914453600$var$createStringInterpolator,
    skipAnimation: ()=>$d49437e914453600$var$skipAnimation,
    to: ()=>$d49437e914453600$var$to,
    willAdvance: ()=>$d49437e914453600$var$willAdvance
});
// src/helpers.ts
function $d49437e914453600$export$8793edee2d425525() {}
var $d49437e914453600$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $d49437e914453600$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $d49437e914453600$export$248d38f6296296c5(a, b) {
    if ($d49437e914453600$export$226b3eccf92c9ed9.arr(a)) {
        if (!$d49437e914453600$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $d49437e914453600$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $d49437e914453600$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($d49437e914453600$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $d49437e914453600$export$45b10814cc054894 = (a)=>$d49437e914453600$export$226b3eccf92c9ed9.und(a) ? [] : $d49437e914453600$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $d49437e914453600$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $d49437e914453600$export$79b2f7037acddd43(items, iterator);
    }
}
var $d49437e914453600$export$7ba486852759e806 = (queue, ...args)=>$d49437e914453600$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $d49437e914453600$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $d49437e914453600$var$createStringInterpolator;
var $d49437e914453600$var$to;
var $d49437e914453600$var$colors = null;
var $d49437e914453600$var$skipAnimation = false;
var $d49437e914453600$var$willAdvance = $d49437e914453600$export$8793edee2d425525;
var $d49437e914453600$var$assign = (globals)=>{
    if (globals.to) $d49437e914453600$var$to = globals.to;
    if (globals.now) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $d49437e914453600$var$colors = globals.colors;
    if (globals.skipAnimation != null) $d49437e914453600$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $d49437e914453600$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $d49437e914453600$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $d49437e914453600$var$startQueue = /* @__PURE__ */ new Set();
var $d49437e914453600$var$currentFrame = [];
var $d49437e914453600$var$prevFrame = [];
var $d49437e914453600$var$priority = 0;
var $d49437e914453600$export$a57f5080a3bcc90a = {
    get idle () {
        return !$d49437e914453600$var$startQueue.size && !$d49437e914453600$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($d49437e914453600$var$priority > animation.priority) {
            $d49437e914453600$var$startQueue.add(animation);
            (0, $29408370dcd41a17$export$27f233d61a9e2fa4).onStart($d49437e914453600$var$flushStartQueue);
        } else {
            $d49437e914453600$var$startSafely(animation);
            (0, $29408370dcd41a17$export$27f233d61a9e2fa4)($d49437e914453600$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $d49437e914453600$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($d49437e914453600$var$priority) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).onFrame(()=>$d49437e914453600$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $d49437e914453600$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $d49437e914453600$var$currentFrame.splice(prevIndex, 1);
                $d49437e914453600$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $d49437e914453600$var$currentFrame = [];
        $d49437e914453600$var$startQueue.clear();
    }
};
function $d49437e914453600$var$flushStartQueue() {
    $d49437e914453600$var$startQueue.forEach($d49437e914453600$var$startSafely);
    $d49437e914453600$var$startQueue.clear();
    (0, $29408370dcd41a17$export$27f233d61a9e2fa4)($d49437e914453600$var$advance);
}
function $d49437e914453600$var$startSafely(animation) {
    if (!$d49437e914453600$var$currentFrame.includes(animation)) $d49437e914453600$var$startUnsafely(animation);
}
function $d49437e914453600$var$startUnsafely(animation) {
    $d49437e914453600$var$currentFrame.splice($d49437e914453600$var$findIndex($d49437e914453600$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $d49437e914453600$var$advance(dt) {
    const nextFrame = $d49437e914453600$var$prevFrame;
    for(let i = 0; i < $d49437e914453600$var$currentFrame.length; i++){
        const animation = $d49437e914453600$var$currentFrame[i];
        $d49437e914453600$var$priority = animation.priority;
        if (!animation.idle) {
            $d49437e914453600$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $d49437e914453600$var$priority = 0;
    $d49437e914453600$var$prevFrame = $d49437e914453600$var$currentFrame;
    $d49437e914453600$var$prevFrame.length = 0;
    $d49437e914453600$var$currentFrame = nextFrame;
    return $d49437e914453600$var$currentFrame.length > 0;
}
function $d49437e914453600$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $d49437e914453600$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $d49437e914453600$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $d49437e914453600$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $d49437e914453600$var$PERCENTAGE = $d49437e914453600$var$NUMBER + "%";
function $d49437e914453600$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $d49437e914453600$export$8972dc0e6ad9238f = new RegExp("rgb" + $d49437e914453600$var$call($d49437e914453600$var$NUMBER, $d49437e914453600$var$NUMBER, $d49437e914453600$var$NUMBER));
var $d49437e914453600$export$4e46ac54fc82cf3b = new RegExp("rgba" + $d49437e914453600$var$call($d49437e914453600$var$NUMBER, $d49437e914453600$var$NUMBER, $d49437e914453600$var$NUMBER, $d49437e914453600$var$NUMBER));
var $d49437e914453600$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $d49437e914453600$var$call($d49437e914453600$var$NUMBER, $d49437e914453600$var$PERCENTAGE, $d49437e914453600$var$PERCENTAGE));
var $d49437e914453600$export$810b04175080204c = new RegExp("hsla" + $d49437e914453600$var$call($d49437e914453600$var$NUMBER, $d49437e914453600$var$PERCENTAGE, $d49437e914453600$var$PERCENTAGE, $d49437e914453600$var$NUMBER));
var $d49437e914453600$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $d49437e914453600$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $d49437e914453600$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $d49437e914453600$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $d49437e914453600$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $d49437e914453600$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($d49437e914453600$var$colors && $d49437e914453600$var$colors[color] !== void 0) return $d49437e914453600$var$colors[color];
    if (match = $d49437e914453600$export$8972dc0e6ad9238f.exec(color)) return ($d49437e914453600$var$parse255(match[1]) << 24 | // r
    $d49437e914453600$var$parse255(match[2]) << 16 | // g
    $d49437e914453600$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $d49437e914453600$export$4e46ac54fc82cf3b.exec(color)) return ($d49437e914453600$var$parse255(match[1]) << 24 | // r
    $d49437e914453600$var$parse255(match[2]) << 16 | // g
    $d49437e914453600$var$parse255(match[3]) << 8 | // b
    $d49437e914453600$var$parse1(match[4])) >>> // a
    0;
    if (match = $d49437e914453600$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $d49437e914453600$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $d49437e914453600$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $d49437e914453600$export$8f4a7c0bb78e6ea8.exec(color)) return ($d49437e914453600$var$hslToRgb($d49437e914453600$var$parse360(match[1]), // h
    $d49437e914453600$var$parsePercentage(match[2]), // s
    $d49437e914453600$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $d49437e914453600$export$810b04175080204c.exec(color)) return ($d49437e914453600$var$hslToRgb($d49437e914453600$var$parse360(match[1]), // h
    $d49437e914453600$var$parsePercentage(match[2]), // s
    $d49437e914453600$var$parsePercentage(match[3])) | $d49437e914453600$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $d49437e914453600$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $d49437e914453600$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $d49437e914453600$var$hue2rgb(p, q, h + 1 / 3);
    const g = $d49437e914453600$var$hue2rgb(p, q, h);
    const b = $d49437e914453600$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $d49437e914453600$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $d49437e914453600$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $d49437e914453600$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $d49437e914453600$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $d49437e914453600$export$61db176b839af1f(input) {
    let int32Color = $d49437e914453600$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $d49437e914453600$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($d49437e914453600$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($d49437e914453600$export$226b3eccf92c9ed9.arr(range)) return $d49437e914453600$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($d49437e914453600$export$226b3eccf92c9ed9.str(range.output[0])) return $d49437e914453600$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $d49437e914453600$var$findRange(input, inputRange);
        return $d49437e914453600$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $d49437e914453600$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $d49437e914453600$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $d49437e914453600$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $d49437e914453600$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $d49437e914453600$var$c1 = 1.70158;
var $d49437e914453600$var$c2 = $d49437e914453600$var$c1 * 1.525;
var $d49437e914453600$var$c3 = $d49437e914453600$var$c1 + 1;
var $d49437e914453600$var$c4 = 2 * Math.PI / 3;
var $d49437e914453600$var$c5 = 2 * Math.PI / 4.5;
var $d49437e914453600$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $d49437e914453600$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$d49437e914453600$var$c3 * x * x * x - $d49437e914453600$var$c1 * x * x,
    easeOutBack: (x)=>1 + $d49437e914453600$var$c3 * Math.pow(x - 1, 3) + $d49437e914453600$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($d49437e914453600$var$c2 + 1) * 2 * x - $d49437e914453600$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($d49437e914453600$var$c2 + 1) * (x * 2 - 2) + $d49437e914453600$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $d49437e914453600$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $d49437e914453600$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $d49437e914453600$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $d49437e914453600$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $d49437e914453600$var$bounceOut(1 - x),
    easeOutBounce: $d49437e914453600$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $d49437e914453600$var$bounceOut(1 - 2 * x)) / 2 : (1 + $d49437e914453600$var$bounceOut(2 * x - 1)) / 2,
    steps: $d49437e914453600$var$steps
};
// src/fluids.ts
var $d49437e914453600$var$$get = Symbol.for("FluidValue.get");
var $d49437e914453600$var$$observers = Symbol.for("FluidValue.observers");
var $d49437e914453600$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$d49437e914453600$var$$get]);
var $d49437e914453600$export$e37b7520edd66839 = (arg)=>arg && arg[$d49437e914453600$var$$get] ? arg[$d49437e914453600$var$$get]() : arg;
var $d49437e914453600$export$133f54e9f7cf1796 = (target)=>target[$d49437e914453600$var$$observers] || null;
function $d49437e914453600$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $d49437e914453600$export$31752c40a5fab62a(target, event) {
    const observers = target[$d49437e914453600$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $d49437e914453600$export$8cbca1207adce0c0(observer2, event);
    });
}
var $d49437e914453600$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $d49437e914453600$export$a3b4618659637aa3(this, get);
    }
};
$d49437e914453600$var$$get, $d49437e914453600$var$$observers;
var $d49437e914453600$export$a3b4618659637aa3 = (target, get)=>$d49437e914453600$var$setHidden(target, $d49437e914453600$var$$get, get);
function $d49437e914453600$export$72d604e3f8d000a5(target, observer2) {
    if (target[$d49437e914453600$var$$get]) {
        let observers = target[$d49437e914453600$var$$observers];
        if (!observers) $d49437e914453600$var$setHidden(target, $d49437e914453600$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $d49437e914453600$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$d49437e914453600$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$d49437e914453600$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $d49437e914453600$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $d49437e914453600$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $d49437e914453600$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $d49437e914453600$var$unitRegex = new RegExp(`(${$d49437e914453600$var$numberRegex.source})(%|[a-z]+)`, "i");
var $d49437e914453600$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $d49437e914453600$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $d49437e914453600$var$variableToRgba = (input)=>{
    const [token, fallback] = $d49437e914453600$var$parseCSSVariable(input);
    if (!token || $d49437e914453600$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $d49437e914453600$var$cssVariableRegex.test(fallback)) return $d49437e914453600$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $d49437e914453600$var$parseCSSVariable = (current)=>{
    const match = $d49437e914453600$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $d49437e914453600$var$namedColorRegex;
var $d49437e914453600$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $d49437e914453600$export$4759a013d387347a = (config)=>{
    if (!$d49437e914453600$var$namedColorRegex) $d49437e914453600$var$namedColorRegex = $d49437e914453600$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($d49437e914453600$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $d49437e914453600$export$e37b7520edd66839(value).replace($d49437e914453600$var$cssVariableRegex, $d49437e914453600$var$variableToRgba).replace($d49437e914453600$var$colorRegex, $d49437e914453600$export$61db176b839af1f).replace($d49437e914453600$var$namedColorRegex, $d49437e914453600$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($d49437e914453600$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$d49437e914453600$export$b12af43b97697ef5({
            ...config,
            output: output2
        }));
    return (input)=>{
        const missingUnit = !$d49437e914453600$var$unitRegex.test(output[0]) && output.find((value)=>$d49437e914453600$var$unitRegex.test(value))?.replace($d49437e914453600$var$numberRegex, "");
        let i = 0;
        return output[0].replace($d49437e914453600$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($d49437e914453600$var$rgbaRegex, $d49437e914453600$var$rgbaRound);
    };
};
// src/deprecations.ts
var $d49437e914453600$export$82e9f45cca5ba907 = "react-spring: ";
var $d49437e914453600$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$d49437e914453600$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $d49437e914453600$var$warnInterpolate = $d49437e914453600$export$d2de3aaeafa91619(console.warn);
function $d49437e914453600$export$2abfcde8ae218ba8() {
    $d49437e914453600$var$warnInterpolate(`${$d49437e914453600$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $d49437e914453600$var$warnDirectCall = $d49437e914453600$export$d2de3aaeafa91619(console.warn);
function $d49437e914453600$export$d99d974913ad3b12() {
    $d49437e914453600$var$warnDirectCall(`${$d49437e914453600$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $d49437e914453600$export$75bed621f62abfa9(value) {
    return $d49437e914453600$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$d49437e914453600$export$48d7c418edadb60c() && $d49437e914453600$var$cssVariableRegex.test(value) || value in ($d49437e914453600$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $d49437e914453600$var$observer;
var $d49437e914453600$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $d49437e914453600$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        return $d49437e914453600$var$resizeHandlers.get(target)?.forEach((handler)=>handler(contentRect));
    });
function $d49437e914453600$var$resizeElement(handler, target) {
    if (!$d49437e914453600$var$observer) {
        if (typeof ResizeObserver !== "undefined") $d49437e914453600$var$observer = new ResizeObserver($d49437e914453600$var$handleObservation);
    }
    let elementHandlers = $d49437e914453600$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $d49437e914453600$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($d49437e914453600$var$observer) $d49437e914453600$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $d49437e914453600$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $d49437e914453600$var$observer) $d49437e914453600$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $d49437e914453600$var$listeners = /* @__PURE__ */ new Set();
var $d49437e914453600$var$cleanupWindowResizeHandler;
var $d49437e914453600$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $d49437e914453600$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $d49437e914453600$var$resizeWindow = (callback)=>{
    $d49437e914453600$var$listeners.add(callback);
    if (!$d49437e914453600$var$cleanupWindowResizeHandler) $d49437e914453600$var$cleanupWindowResizeHandler = $d49437e914453600$var$createResizeHandler();
    return ()=>{
        $d49437e914453600$var$listeners.delete(callback);
        if (!$d49437e914453600$var$listeners.size && $d49437e914453600$var$cleanupWindowResizeHandler) {
            $d49437e914453600$var$cleanupWindowResizeHandler();
            $d49437e914453600$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $d49437e914453600$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $d49437e914453600$var$resizeWindow(callback);
    else return $d49437e914453600$var$resizeElement(callback, container);
};
// src/progress.ts
var $d49437e914453600$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $d49437e914453600$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $d49437e914453600$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $d49437e914453600$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $d49437e914453600$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $d49437e914453600$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $d49437e914453600$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $d49437e914453600$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $d49437e914453600$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $d49437e914453600$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $d49437e914453600$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $d49437e914453600$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $d49437e914453600$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$d49437e914453600$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers?.forEach((handler)=>handler.advance());
            return true;
        };
        $d49437e914453600$var$scrollListeners.set(container, listener);
        const target = $d49437e914453600$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $d49437e914453600$var$resizeListeners.set(container, $d49437e914453600$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $d49437e914453600$var$scrollListeners.get(container);
    (0, $29408370dcd41a17$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $29408370dcd41a17$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $d49437e914453600$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $d49437e914453600$var$scrollListeners.get(container);
        $d49437e914453600$var$scrollListeners.delete(container);
        if (listener) {
            $d49437e914453600$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            $d49437e914453600$var$resizeListeners.get(container)?.();
        }
    };
};
function $d49437e914453600$export$fe4300aa8eebea86(init) {
    const ref = (0, $3ZYaX.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $d49437e914453600$export$700979bc83e7db82 = $d49437e914453600$export$48d7c418edadb60c() ? (0, $3ZYaX.useEffect) : (0, $3ZYaX.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $d49437e914453600$var$useIsMounted = ()=>{
    const isMounted = (0, $3ZYaX.useRef)(false);
    $d49437e914453600$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $d49437e914453600$export$91db9bc4f8ac944a() {
    const update = (0, $3ZYaX.useState)()[1];
    const isMounted = $d49437e914453600$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $d49437e914453600$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $3ZYaX.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $3ZYaX.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $d49437e914453600$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $3ZYaX.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $d49437e914453600$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $d49437e914453600$export$392544347a18b6ea = (effect)=>(0, $3ZYaX.useEffect)(effect, $d49437e914453600$var$emptyDeps);
var $d49437e914453600$var$emptyDeps = [];
function $d49437e914453600$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $3ZYaX.useRef)();
    (0, $3ZYaX.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $d49437e914453600$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $3ZYaX.useState)(null);
    $d49437e914453600$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $d49437e914453600$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $3ZYaX = parcelRequire("3ZYaX");
// src/Animated.ts


var $3ZYaX = parcelRequire("3ZYaX");
var $82e41a3dee81bfcd$var$$node = Symbol.for("Animated:node");
var $82e41a3dee81bfcd$export$3df5e165e801a70f = (value)=>!!value && value[$82e41a3dee81bfcd$var$$node] === value;
var $82e41a3dee81bfcd$export$6b63995194a3a9e4 = (owner)=>owner && owner[$82e41a3dee81bfcd$var$$node];
var $82e41a3dee81bfcd$export$b553cb5b22b81b04 = (owner, node)=>(0, $d49437e914453600$export$5c74248ea0e35446)(owner, $82e41a3dee81bfcd$var$$node, node);
var $82e41a3dee81bfcd$export$ccab2b64c5d440 = (owner)=>owner && owner[$82e41a3dee81bfcd$var$$node] && owner[$82e41a3dee81bfcd$var$$node].getPayload();
var $82e41a3dee81bfcd$export$31627395a3b18e54 = class {
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
    constructor(){
        $82e41a3dee81bfcd$export$b553cb5b22b81b04(this, this);
    }
};
var $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5 = class extends $82e41a3dee81bfcd$export$31627395a3b18e54 {
    /** @internal */ static create(value) {
        return new $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
};
var $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93 = class extends $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5 {
    /** @internal */ static create(value) {
        return new $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $d49437e914453600$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $d49437e914453600$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
};
// src/context.ts
var $82e41a3dee81bfcd$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $82e41a3dee81bfcd$export$f1b0b9e366a6e2d4 = class extends $82e41a3dee81bfcd$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $d49437e914453600$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($82e41a3dee81bfcd$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $d49437e914453600$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $d49437e914453600$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $d49437e914453600$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $d49437e914453600$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($82e41a3dee81bfcd$var$TreeContext.dependencies && (0, $d49437e914453600$export$57ea7e3a7f6280c7)(source)) $82e41a3dee81bfcd$var$TreeContext.dependencies.add(source);
        const payload = $82e41a3dee81bfcd$export$ccab2b64c5d440(source);
        if (payload) (0, $d49437e914453600$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
};
// src/AnimatedArray.ts
var $82e41a3dee81bfcd$export$ede394683406942d = class extends $82e41a3dee81bfcd$export$f1b0b9e366a6e2d4 {
    /** @internal */ static create(source) {
        return new $82e41a3dee81bfcd$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($82e41a3dee81bfcd$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
};
function $82e41a3dee81bfcd$var$makeAnimated(value) {
    const nodeType = (0, $d49437e914453600$export$75bed621f62abfa9)(value) ? $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93 : $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $82e41a3dee81bfcd$export$e6b77ddbe47b132e(value) {
    const parentNode = $82e41a3dee81bfcd$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(value) ? $82e41a3dee81bfcd$export$ede394683406942d : (0, $d49437e914453600$export$75bed621f62abfa9)(value) ? $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93 : $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5;
}
var $82e41a3dee81bfcd$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $d49437e914453600$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $3ZYaX.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $3ZYaX.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $3ZYaX.useCallback)((value)=>{
            instanceRef.current = $82e41a3dee81bfcd$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $82e41a3dee81bfcd$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $d49437e914453600$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $82e41a3dee81bfcd$var$PropsObserver(callback, deps);
        const observerRef = (0, $3ZYaX.useRef)();
        (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $d49437e914453600$export$79b2f7037acddd43)(deps, (dep)=>(0, $d49437e914453600$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $d49437e914453600$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $d49437e914453600$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $29408370dcd41a17$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $3ZYaX.useEffect)(callback, []);
        (0, $d49437e914453600$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $d49437e914453600$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $d49437e914453600$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $3ZYaX.createElement(Component, {
            ...usedProps,
            ref: ref
        });
    });
};
var $82e41a3dee81bfcd$var$PropsObserver = class {
    eventObserved(event) {
        if (event.type == "change") (0, $29408370dcd41a17$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
};
function $82e41a3dee81bfcd$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $82e41a3dee81bfcd$var$TreeContext.dependencies = dependencies;
    if (props.style) props = {
        ...props,
        style: host.createAnimatedStyle(props.style)
    };
    props = new $82e41a3dee81bfcd$export$f1b0b9e366a6e2d4(props);
    $82e41a3dee81bfcd$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $82e41a3dee81bfcd$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $82e41a3dee81bfcd$var$cacheKey = Symbol.for("AnimatedComponent");
var $82e41a3dee81bfcd$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $82e41a3dee81bfcd$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $82e41a3dee81bfcd$var$getDisplayName(Component) || "Anonymous";
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $82e41a3dee81bfcd$var$withAnimated(Component, hostConfig));
        else Component = Component[$82e41a3dee81bfcd$var$cacheKey] || (Component[$82e41a3dee81bfcd$var$cacheKey] = $82e41a3dee81bfcd$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $d49437e914453600$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).arr(components)) key = $82e41a3dee81bfcd$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $82e41a3dee81bfcd$var$getDisplayName = (arg)=>(0, $d49437e914453600$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $d49437e914453600$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $834b5d10f96ce272$export$b24b633b1364b94b = class {
};


function $775dc606f38f6e3f$var$callProp(value, ...args) {
    return (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $775dc606f38f6e3f$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $d49437e914453600$export$45b10814cc054894)(value).includes(key)));
var $775dc606f38f6e3f$var$resolveProp = (prop, key)=>(0, $d49437e914453600$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $775dc606f38f6e3f$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $775dc606f38f6e3f$var$noopTransform = (value)=>value;
var $775dc606f38f6e3f$var$getDefaultProps = (props, transform = $775dc606f38f6e3f$var$noopTransform)=>{
    let keys = $775dc606f38f6e3f$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $775dc606f38f6e3f$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $775dc606f38f6e3f$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $775dc606f38f6e3f$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $d49437e914453600$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$775dc606f38f6e3f$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $775dc606f38f6e3f$export$b971039a739bf227(props) {
    const to2 = $775dc606f38f6e3f$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $d49437e914453600$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return {
        ...props
    };
}
function $775dc606f38f6e3f$var$computeGoal(value) {
    value = (0, $d49437e914453600$export$e37b7520edd66839)(value);
    return (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(value) ? value.map($775dc606f38f6e3f$var$computeGoal) : (0, $d49437e914453600$export$75bed621f62abfa9)(value) ? (0, $d49437e914453600$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $775dc606f38f6e3f$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $775dc606f38f6e3f$var$isAsyncTo(to2) {
    return (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(to2) || (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(to2) && (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $775dc606f38f6e3f$var$detachRefs(ctrl, ref) {
    ctrl.ref?.delete(ctrl);
    ref?.delete(ctrl);
}
function $775dc606f38f6e3f$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        ctrl.ref?.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $775dc606f38f6e3f$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $d49437e914453600$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $d49437e914453600$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $d49437e914453600$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $775dc606f38f6e3f$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $d49437e914453600$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $d49437e914453600$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $d49437e914453600$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $775dc606f38f6e3f$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $775dc606f38f6e3f$var$defaults = {
    ...$775dc606f38f6e3f$export$e506a1d27d1eaa20.default,
    mass: 1,
    damping: 1,
    easing: (0, $d49437e914453600$export$15a0bf1b4bbacad8).linear,
    clamp: false
};
var $775dc606f38f6e3f$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $775dc606f38f6e3f$var$defaults);
    }
};
function $775dc606f38f6e3f$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = {
            ...defaultConfig
        };
        $775dc606f38f6e3f$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = {
            ...defaultConfig,
            ...newConfig
        };
    }
    $775dc606f38f6e3f$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $775dc606f38f6e3f$var$defaults)if (config2[key] == null) config2[key] = $775dc606f38f6e3f$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $775dc606f38f6e3f$var$sanitizeConfig(config2, props) {
    if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.tension) || !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.damping) || !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $775dc606f38f6e3f$var$emptyArray = [];
var $775dc606f38f6e3f$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $775dc606f38f6e3f$var$emptyArray;
        this.toValues = null;
        this.fromValues = $775dc606f38f6e3f$var$emptyArray;
        this.config = new $775dc606f38f6e3f$var$AnimationConfig();
        this.immediate = false;
    }
};
function $775dc606f38f6e3f$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        let cancel = $775dc606f38f6e3f$var$matchProp(props.cancel ?? defaultProps?.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $775dc606f38f6e3f$var$matchProp(props.pause, key);
            let pause = defaultProps?.pause;
            if (pause !== true) pause = state.paused || $775dc606f38f6e3f$var$matchProp(pause, key);
            delay = $775dc606f38f6e3f$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $29408370dcd41a17$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $d49437e914453600$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $29408370dcd41a17$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start({
                    ...props,
                    callId: callId,
                    cancel: cancel
                }, resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $775dc606f38f6e3f$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $775dc606f38f6e3f$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $775dc606f38f6e3f$var$getNoopResult(target.get()) : $775dc606f38f6e3f$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $775dc606f38f6e3f$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $775dc606f38f6e3f$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $775dc606f38f6e3f$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $775dc606f38f6e3f$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $775dc606f38f6e3f$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $775dc606f38f6e3f$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $775dc606f38f6e3f$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $775dc606f38f6e3f$export$d362d093fa99dc7();
            const skipAnimationSignal = new $775dc606f38f6e3f$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $d49437e914453600$export$cceeabf822b64fc0).skipAnimation) {
                    $775dc606f38f6e3f$var$stopAsync(state);
                    skipAnimationSignal.result = $775dc606f38f6e3f$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(arg1) ? {
                    ...arg1
                } : {
                    ...arg2,
                    to: arg1
                };
                props2.parentId = callId;
                (0, $d49437e914453600$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $d49437e914453600$export$cceeabf822b64fc0).skipAnimation) {
            $775dc606f38f6e3f$var$stopAsync(state);
            return $775dc606f38f6e3f$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $d49437e914453600$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $775dc606f38f6e3f$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $775dc606f38f6e3f$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $775dc606f38f6e3f$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(onRest)) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $775dc606f38f6e3f$var$stopAsync(state, cancelId) {
    (0, $d49437e914453600$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $775dc606f38f6e3f$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $775dc606f38f6e3f$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $775dc606f38f6e3f$var$isFrameValue = (value)=>value instanceof $775dc606f38f6e3f$export$8229896f80e2495e;
var $775dc606f38f6e3f$var$nextId = 1;
var $775dc606f38f6e3f$export$8229896f80e2495e = class extends (0, $d49437e914453600$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $d49437e914453600$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $d49437e914453600$export$2abfcde8ae218ba8)();
        return (0, $d49437e914453600$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $d49437e914453600$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $d49437e914453600$export$a57f5080a3bcc90a).sort(this);
        (0, $d49437e914453600$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(){
        super(...arguments);
        this.id = $775dc606f38f6e3f$var$nextId++;
        this._priority = 0;
    }
};
// src/SpringPhase.ts
var $775dc606f38f6e3f$var$$P = Symbol.for("SpringPhase");
var $775dc606f38f6e3f$var$HAS_ANIMATED = 1;
var $775dc606f38f6e3f$var$IS_ANIMATING = 2;
var $775dc606f38f6e3f$var$IS_PAUSED = 4;
var $775dc606f38f6e3f$var$hasAnimated = (target)=>(target[$775dc606f38f6e3f$var$$P] & $775dc606f38f6e3f$var$HAS_ANIMATED) > 0;
var $775dc606f38f6e3f$var$isAnimating = (target)=>(target[$775dc606f38f6e3f$var$$P] & $775dc606f38f6e3f$var$IS_ANIMATING) > 0;
var $775dc606f38f6e3f$var$isPaused = (target)=>(target[$775dc606f38f6e3f$var$$P] & $775dc606f38f6e3f$var$IS_PAUSED) > 0;
var $775dc606f38f6e3f$var$setActiveBit = (target, active)=>active ? target[$775dc606f38f6e3f$var$$P] |= $775dc606f38f6e3f$var$IS_ANIMATING | $775dc606f38f6e3f$var$HAS_ANIMATED : target[$775dc606f38f6e3f$var$$P] &= ~$775dc606f38f6e3f$var$IS_ANIMATING;
var $775dc606f38f6e3f$var$setPausedBit = (target, paused)=>paused ? target[$775dc606f38f6e3f$var$$P] |= $775dc606f38f6e3f$var$IS_PAUSED : target[$775dc606f38f6e3f$var$$P] &= ~$775dc606f38f6e3f$var$IS_PAUSED;
// src/SpringValue.ts
var $775dc606f38f6e3f$export$5854d13427d5a954 = class extends $775dc606f38f6e3f$export$8229896f80e2495e {
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($775dc606f38f6e3f$var$isAnimating(this) || this._state.asyncTo) || $775dc606f38f6e3f$var$isPaused(this);
    }
    get goal() {
        return (0, $d49437e914453600$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $82e41a3dee81bfcd$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $775dc606f38f6e3f$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $775dc606f38f6e3f$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $775dc606f38f6e3f$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $82e41a3dee81bfcd$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $d49437e914453600$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $d49437e914453600$export$45b10814cc054894)((0, $d49437e914453600$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $d49437e914453600$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($775dc606f38f6e3f$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(to2) ? to2 : {
                ...arg2,
                to: to2
            }
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$775dc606f38f6e3f$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $775dc606f38f6e3f$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $775dc606f38f6e3f$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$775dc606f38f6e3f$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $d49437e914453600$export$e37b7520edd66839)(from);
            if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update({ ...props }, isLoop) {
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $775dc606f38f6e3f$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $775dc606f38f6e3f$var$resolveProp(value, key) : value));
        $775dc606f38f6e3f$var$mergeActiveFn(this, props, "onProps");
        $775dc606f38f6e3f$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $775dc606f38f6e3f$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$775dc606f38f6e3f$var$isPaused(this)) {
                        $775dc606f38f6e3f$var$setPausedBit(this, true);
                        (0, $d49437e914453600$export$7ba486852759e806)(state.pauseQueue);
                        $775dc606f38f6e3f$var$sendEvent(this, "onPause", $775dc606f38f6e3f$var$getFinishedResult(this, $775dc606f38f6e3f$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($775dc606f38f6e3f$var$isPaused(this)) {
                        $775dc606f38f6e3f$var$setPausedBit(this, false);
                        if ($775dc606f38f6e3f$var$isAnimating(this)) this._resume();
                        (0, $d49437e914453600$export$7ba486852759e806)(state.resumeQueue);
                        $775dc606f38f6e3f$var$sendEvent(this, "onResume", $775dc606f38f6e3f$var$getFinishedResult(this, $775dc606f38f6e3f$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $775dc606f38f6e3f$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($775dc606f38f6e3f$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($775dc606f38f6e3f$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $d49437e914453600$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $d49437e914453600$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $d49437e914453600$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $d49437e914453600$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $775dc606f38f6e3f$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $775dc606f38f6e3f$var$mergeConfig(config2, $775dc606f38f6e3f$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $775dc606f38f6e3f$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
        if (!node || (0, $d49437e914453600$export$226b3eccf92c9ed9).und(to2)) return resolve($775dc606f38f6e3f$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(from) && $775dc606f38f6e3f$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $775dc606f38f6e3f$var$computeGoal(to2);
        const isAnimatable = (0, $d49437e914453600$export$226b3eccf92c9ed9).num(goal) || (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(goal) || (0, $d49437e914453600$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $775dc606f38f6e3f$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $82e41a3dee81bfcd$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $d49437e914453600$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$775dc606f38f6e3f$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $d49437e914453600$export$248d38f6296296c5)($775dc606f38f6e3f$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $d49437e914453600$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $d49437e914453600$export$248d38f6296296c5)(config2.decay, decay) || !(0, $d49437e914453600$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $775dc606f38f6e3f$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $d49437e914453600$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $d49437e914453600$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $82e41a3dee81bfcd$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $d49437e914453600$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $d49437e914453600$export$79b2f7037acddd43)($775dc606f38f6e3f$var$ACTIVE_EVENTS, (type)=>$775dc606f38f6e3f$var$mergeActiveFn(this, props, type));
                const result = $775dc606f38f6e3f$var$getFinishedResult(this, $775dc606f38f6e3f$var$checkFinished(this, prevTo));
                (0, $d49437e914453600$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    anim.changed = !reset;
                    onRest?.(result, this);
                    if (reset) $775dc606f38f6e3f$var$callProp(defaultProps.onRest, result);
                    else anim.onStart?.(result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($775dc606f38f6e3f$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($775dc606f38f6e3f$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($775dc606f38f6e3f$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $d49437e914453600$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $d49437e914453600$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $d49437e914453600$export$57ea7e3a7f6280c7)(to2)) {
            (0, $d49437e914453600$export$72d604e3f8d000a5)(to2, this);
            if ($775dc606f38f6e3f$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $d49437e914453600$export$57ea7e3a7f6280c7)(to2)) (0, $d49437e914453600$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $d49437e914453600$export$e37b7520edd66839)(arg);
        if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $d49437e914453600$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $82e41a3dee81bfcd$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $82e41a3dee81bfcd$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $775dc606f38f6e3f$var$sendEvent(this, "onStart", $775dc606f38f6e3f$var$getFinishedResult(this, $775dc606f38f6e3f$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $775dc606f38f6e3f$var$callProp(this.animation.onChange, value, this);
        }
        $775dc606f38f6e3f$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this).reset((0, $d49437e914453600$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$775dc606f38f6e3f$var$isAnimating(this)) {
            $775dc606f38f6e3f$var$setActiveBit(this, true);
            if (!$775dc606f38f6e3f$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $d49437e914453600$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $d49437e914453600$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($775dc606f38f6e3f$var$isAnimating(this)) {
            $775dc606f38f6e3f$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $d49437e914453600$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $d49437e914453600$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $775dc606f38f6e3f$var$getCancelledResult(this.get()) : $775dc606f38f6e3f$var$getFinishedResult(this.get(), $775dc606f38f6e3f$var$checkFinished(this, goal ?? anim.to));
            (0, $d49437e914453600$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $775dc606f38f6e3f$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $775dc606f38f6e3f$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(arg1) || !(0, $d49437e914453600$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(arg1) ? {
                ...arg1
            } : {
                ...arg2,
                from: arg1
            };
            if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
};
function $775dc606f38f6e3f$var$checkFinished(target, to2) {
    const goal = $775dc606f38f6e3f$var$computeGoal(to2);
    const value = $775dc606f38f6e3f$var$computeGoal(target.get());
    return (0, $d49437e914453600$export$248d38f6296296c5)(value, goal);
}
function $775dc606f38f6e3f$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $775dc606f38f6e3f$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $775dc606f38f6e3f$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $775dc606f38f6e3f$var$createUpdate({
            ...props,
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $775dc606f38f6e3f$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset,
            // The "loop" prop can return a "useSpring" props object to
            // override any of the original props.
            ...overrides
        });
    }
}
function $775dc606f38f6e3f$var$createUpdate(props) {
    const { to: to2, from: from } = props = $775dc606f38f6e3f$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).obj(to2)) $775dc606f38f6e3f$var$findDefined(to2, keys);
    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).obj(from)) $775dc606f38f6e3f$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $775dc606f38f6e3f$var$declareUpdate(props) {
    const update2 = $775dc606f38f6e3f$var$createUpdate(props);
    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $775dc606f38f6e3f$var$getDefaultProps(update2);
    return update2;
}
function $775dc606f38f6e3f$var$findDefined(values, keys) {
    (0, $d49437e914453600$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $775dc606f38f6e3f$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $775dc606f38f6e3f$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $775dc606f38f6e3f$var$getDefaultProp(props, type) ? $775dc606f38f6e3f$var$resolveProp(props[type], target.key) : void 0;
}
function $775dc606f38f6e3f$var$sendEvent(target, type, ...args) {
    target.animation[type]?.(...args);
    target.defaultProps[type]?.(...args);
}
var $775dc606f38f6e3f$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $775dc606f38f6e3f$var$nextId2 = 1;
var $775dc606f38f6e3f$export$bd0bf19f25da8474 = class {
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($775dc606f38f6e3f$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $d49437e914453600$export$45b10814cc054894)(props).map($775dc606f38f6e3f$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $775dc606f38f6e3f$var$prepareKeys(this, queue);
        return $775dc606f38f6e3f$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $775dc606f38f6e3f$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $d49437e914453600$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $d49437e914453600$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $d49437e914453600$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $d49437e914453600$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $29408370dcd41a17$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush3){
        this.id = $775dc606f38f6e3f$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start({
            default: true,
            ...props
        });
    }
};
function $775dc606f38f6e3f$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$775dc606f38f6e3f$var$flushUpdate(ctrl, props))).then((results)=>$775dc606f38f6e3f$var$getCombinedResult(ctrl, results));
}
async function $775dc606f38f6e3f$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(to2) || (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $d49437e914453600$export$79b2f7037acddd43)($775dc606f38f6e3f$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $d49437e914453600$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $775dc606f38f6e3f$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($775dc606f38f6e3f$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $d49437e914453600$export$8793edee2d425525),
            resume: (0, $d49437e914453600$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $775dc606f38f6e3f$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($775dc606f38f6e3f$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($775dc606f38f6e3f$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $775dc606f38f6e3f$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $775dc606f38f6e3f$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $775dc606f38f6e3f$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $775dc606f38f6e3f$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $775dc606f38f6e3f$var$getSprings(ctrl, props) {
    const springs = {
        ...ctrl.springs
    };
    if (props) (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $775dc606f38f6e3f$var$createUpdate(props2);
        if (!(0, $d49437e914453600$export$226b3eccf92c9ed9).obj(props2.to)) props2 = {
            ...props2,
            to: void 0
        };
        $775dc606f38f6e3f$var$prepareSprings(springs, props2, (key)=>{
            return $775dc606f38f6e3f$var$createSpring(key);
        });
    });
    $775dc606f38f6e3f$var$setSprings(ctrl, springs);
    return springs;
}
function $775dc606f38f6e3f$var$setSprings(ctrl, springs) {
    (0, $d49437e914453600$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $d49437e914453600$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $775dc606f38f6e3f$var$createSpring(key, observer) {
    const spring = new $775dc606f38f6e3f$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $d49437e914453600$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $775dc606f38f6e3f$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $d49437e914453600$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $775dc606f38f6e3f$var$prepareKeys(ctrl, queue) {
    (0, $d49437e914453600$export$79b2f7037acddd43)(queue, (props)=>{
        $775dc606f38f6e3f$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $775dc606f38f6e3f$var$createSpring(key, ctrl);
        });
    });
}
var $775dc606f38f6e3f$export$f12a216ec50d2cf1 = ({ children: children, ...props })=>{
    const inherited = (0, $3ZYaX.useContext)($775dc606f38f6e3f$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $d49437e914453600$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $775dc606f38f6e3f$var$ctx;
    return /* @__PURE__ */ $3ZYaX.createElement(Provider, {
        value: props
    }, children);
};
var $775dc606f38f6e3f$var$ctx = $775dc606f38f6e3f$var$makeContext($775dc606f38f6e3f$export$f12a216ec50d2cf1, {});
$775dc606f38f6e3f$export$f12a216ec50d2cf1.Provider = $775dc606f38f6e3f$var$ctx.Provider;
$775dc606f38f6e3f$export$f12a216ec50d2cf1.Consumer = $775dc606f38f6e3f$var$ctx.Consumer;
function $775dc606f38f6e3f$var$makeContext(target, init) {
    Object.assign(target, $3ZYaX.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $775dc606f38f6e3f$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $d49437e914453600$export$d99d974913ad3b12)();
        const results = [];
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $d49437e914453600$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $775dc606f38f6e3f$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $3ZYaX.useMemo)(()=>propsFn || arguments.length == 3 ? $775dc606f38f6e3f$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $3ZYaX.useRef)(0);
    const forceUpdate = (0, $d49437e914453600$export$91db9bc4f8ac944a)();
    const state = (0, $3ZYaX.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $775dc606f38f6e3f$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $775dc606f38f6e3f$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $775dc606f38f6e3f$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($775dc606f38f6e3f$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $3ZYaX.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $d49437e914453600$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $3ZYaX.useMemo)(()=>{
        (0, $d49437e914453600$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $775dc606f38f6e3f$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $3ZYaX.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $775dc606f38f6e3f$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $775dc606f38f6e3f$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$775dc606f38f6e3f$var$getSprings(ctrl, updates[i]));
    const context = (0, $3ZYaX.useContext)($775dc606f38f6e3f$export$f12a216ec50d2cf1);
    const prevContext = (0, $d49437e914453600$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $775dc606f38f6e3f$var$hasProps(context);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $d49437e914453600$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $d49437e914453600$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref?.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $775dc606f38f6e3f$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $d49437e914453600$export$392544347a18b6ea)(()=>()=>{
            (0, $d49437e914453600$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>({
            ...x
        }));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $775dc606f38f6e3f$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $775dc606f38f6e3f$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $775dc606f38f6e3f$var$initSpringRef = ()=>$775dc606f38f6e3f$export$2471ae76e2946684();
var $775dc606f38f6e3f$export$564bff9c23cad2ca = ()=>(0, $3ZYaX.useState)($775dc606f38f6e3f$var$initSpringRef)[0];
var $775dc606f38f6e3f$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $d49437e914453600$export$fe4300aa8eebea86)(()=>new $775dc606f38f6e3f$export$5854d13427d5a954(initial, props));
    (0, $d49437e914453600$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $775dc606f38f6e3f$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $775dc606f38f6e3f$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        (0, $d49437e914453600$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $775dc606f38f6e3f$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef ?? result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $775dc606f38f6e3f$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $3ZYaX.useMemo)(()=>propsFn || arguments.length == 3 ? $775dc606f38f6e3f$export$2471ae76e2946684() : void 0, []);
    const items = (0, $d49437e914453600$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $3ZYaX.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $d49437e914453600$export$392544347a18b6ea)(()=>{
        (0, $d49437e914453600$export$79b2f7037acddd43)(transitions, (t)=>{
            ref?.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $d49437e914453600$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $775dc606f38f6e3f$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $775dc606f38f6e3f$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>(0, $d49437e914453600$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $775dc606f38f6e3f$var$detachRefs(ctrl, ref);
            $775dc606f38f6e3f$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $d49437e914453600$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $d49437e914453600$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $775dc606f38f6e3f$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $d49437e914453600$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = {
                    ...t,
                    item: items[keyIndex]
                };
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $d49437e914453600$export$91db9bc4f8ac944a)();
    const defaultProps = $775dc606f38f6e3f$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $3ZYaX.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $3ZYaX.useRef)(false);
    (0, $d49437e914453600$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $775dc606f38f6e3f$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $775dc606f38f6e3f$var$callProp(to2, t.item, i);
        to2 = (0, $d49437e914453600$export$226b3eccf92c9ed9).obj(to2) ? $775dc606f38f6e3f$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $775dc606f38f6e3f$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = {
            ...defaultProps,
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false,
            // Merge any phase-specific props.
            ...to2
        };
        if (phase == "enter" /* ENTER */  && (0, $d49437e914453600$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $d49437e914453600$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $775dc606f38f6e3f$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $775dc606f38f6e3f$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $775dc606f38f6e3f$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $775dc606f38f6e3f$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $3ZYaX.useContext)($775dc606f38f6e3f$export$f12a216ec50d2cf1);
    const prevContext = (0, $d49437e914453600$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $775dc606f38f6e3f$var$hasProps(context);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $d49437e914453600$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $d49437e914453600$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        (0, $d49437e914453600$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref?.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $775dc606f38f6e3f$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $3ZYaX.createElement($3ZYaX.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render({
                ...springs
            }, t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $3ZYaX.createElement(elem.type, {
                ...elem.props,
                key: (0, $d49437e914453600$export$226b3eccf92c9ed9).str(t.key) || (0, $d49437e914453600$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            }) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $775dc606f38f6e3f$var$nextKey = 1;
function $775dc606f38f6e3f$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $775dc606f38f6e3f$var$nextKey++;
        });
    }
    return (0, $d49437e914453600$export$226b3eccf92c9ed9).und(keys) ? items : (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $d49437e914453600$export$45b10814cc054894)(keys);
}
var $775dc606f38f6e3f$export$d928051c8cd740b = ({ container: container, ...springOptions } = {})=>{
    const [scrollValues, api] = $775dc606f38f6e3f$export$c4af9125706c4d30(()=>({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0,
            ...springOptions
        }), []);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $d49437e914453600$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $d49437e914453600$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $775dc606f38f6e3f$export$e8b771555dc4a003 = ({ container: container, ...springOptions })=>{
    const [sizeValues, api] = $775dc606f38f6e3f$export$c4af9125706c4d30(()=>({
            width: 0,
            height: 0,
            ...springOptions
        }), []);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $d49437e914453600$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: container?.current || void 0
        });
        return ()=>{
            (0, $d49437e914453600$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $775dc606f38f6e3f$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $775dc606f38f6e3f$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $3ZYaX.useState)(false);
    const ref = (0, $3ZYaX.useRef)();
    const propsFn = (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {}, ...restSpringProps } = springsProps;
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $775dc606f38f6e3f$export$c4af9125706c4d30(()=>({
            from: from,
            ...restSpringProps
        }), []);
    (0, $d49437e914453600$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const { root: root, once: once, amount: amount = "any", ...restArgs } = intersectionArguments ?? {};
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $d49437e914453600$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, {
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $775dc606f38f6e3f$var$defaultThresholdOptions[amount],
            ...restArgs
        });
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $775dc606f38f6e3f$export$a500e5b516cedfc({ children: children, ...props }) {
    return children($775dc606f38f6e3f$export$c4af9125706c4d30(props));
}
function $775dc606f38f6e3f$export$3b8b9d47fbf8fd2b({ items: items, children: children, ...props }) {
    const trails = $775dc606f38f6e3f$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $d49437e914453600$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $775dc606f38f6e3f$export$be58926105124dd4({ items: items, children: children, ...props }) {
    return $775dc606f38f6e3f$export$7b286972b8d8ccbf(items, props)(children);
}
var $775dc606f38f6e3f$export$b0cc4f9860136880 = class extends $775dc606f38f6e3f$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $d49437e914453600$export$248d38f6296296c5)(value, oldValue)) {
            (0, $82e41a3dee81bfcd$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $775dc606f38f6e3f$var$checkIdle(this._active)) $775dc606f38f6e3f$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $d49437e914453600$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $d49437e914453600$export$e37b7520edd66839)) : (0, $d49437e914453600$export$45b10814cc054894)((0, $d49437e914453600$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$775dc606f38f6e3f$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $d49437e914453600$export$79b2f7037acddd43)((0, $82e41a3dee81bfcd$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $d49437e914453600$export$cceeabf822b64fc0).skipAnimation) {
                (0, $29408370dcd41a17$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $775dc606f38f6e3f$var$becomeIdle(this);
            } else (0, $d49437e914453600$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $d49437e914453600$export$57ea7e3a7f6280c7)(source)) (0, $d49437e914453600$export$72d604e3f8d000a5)(source, this);
            if ($775dc606f38f6e3f$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $d49437e914453600$export$79b2f7037acddd43)((0, $d49437e914453600$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $d49437e914453600$export$57ea7e3a7f6280c7)(source)) (0, $d49437e914453600$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $775dc606f38f6e3f$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $d49437e914453600$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($775dc606f38f6e3f$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $d49437e914453600$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $82e41a3dee81bfcd$export$e6b77ddbe47b132e)(value);
        (0, $82e41a3dee81bfcd$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
};
function $775dc606f38f6e3f$var$isIdle(source) {
    return source.idle !== false;
}
function $775dc606f38f6e3f$var$checkIdle(active) {
    return !active.size || Array.from(active).every($775dc606f38f6e3f$var$isIdle);
}
function $775dc606f38f6e3f$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $d49437e914453600$export$79b2f7037acddd43)((0, $82e41a3dee81bfcd$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $d49437e914453600$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $775dc606f38f6e3f$export$2c618a4308a30424 = (source, ...args)=>new $775dc606f38f6e3f$export$b0cc4f9860136880(source, args);
var $775dc606f38f6e3f$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $d49437e914453600$export$2abfcde8ae218ba8)(), new $775dc606f38f6e3f$export$b0cc4f9860136880(source, args));
(0, $d49437e914453600$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $d49437e914453600$export$4759a013d387347a,
    to: (source, args)=>new $775dc606f38f6e3f$export$b0cc4f9860136880(source, args)
});
var $775dc606f38f6e3f$export$722fbec263ad908a = (0, $d49437e914453600$export$a57f5080a3bcc90a).advance;



var $1rKN8 = parcelRequire("1rKN8");


// src/applyAnimatedValues.ts
var $9a653e146f5ceb1c$var$isCustomPropRE = /^--/;
function $9a653e146f5ceb1c$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$9a653e146f5ceb1c$var$isCustomPropRE.test(name) && !($9a653e146f5ceb1c$var$isUnitlessNumber.hasOwnProperty(name) && $9a653e146f5ceb1c$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $9a653e146f5ceb1c$var$attributeCache = {};
function $9a653e146f5ceb1c$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox, ...attributes } = props;
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $9a653e146f5ceb1c$var$attributeCache[name] || ($9a653e146f5ceb1c$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $9a653e146f5ceb1c$var$dangerousStyleValue(name, style[name]);
        if ($9a653e146f5ceb1c$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $9a653e146f5ceb1c$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $9a653e146f5ceb1c$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $9a653e146f5ceb1c$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$9a653e146f5ceb1c$var$isUnitlessNumber = Object.keys($9a653e146f5ceb1c$var$isUnitlessNumber).reduce((acc, prop)=>{
    $9a653e146f5ceb1c$var$prefixes.forEach((prefix)=>acc[$9a653e146f5ceb1c$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $9a653e146f5ceb1c$var$isUnitlessNumber);
var $9a653e146f5ceb1c$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $9a653e146f5ceb1c$var$pxTransforms = /^(translate)/;
var $9a653e146f5ceb1c$var$degTransforms = /^(rotate|skew)/;
var $9a653e146f5ceb1c$var$addUnit = (value, unit)=>(0, $d49437e914453600$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $9a653e146f5ceb1c$var$isValueIdentity = (value, id)=>(0, $d49437e914453600$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$9a653e146f5ceb1c$var$isValueIdentity(v, id)) : (0, $d49437e914453600$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $9a653e146f5ceb1c$var$AnimatedStyle = class extends (0, $82e41a3dee81bfcd$export$f1b0b9e366a6e2d4) {
    constructor({ x: x, y: y, z: z, ...style }){
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$9a653e146f5ceb1c$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $9a653e146f5ceb1c$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $d49437e914453600$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($9a653e146f5ceb1c$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $d49437e914453600$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $9a653e146f5ceb1c$var$pxTransforms.test(key) ? "px" : $9a653e146f5ceb1c$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $d49437e914453600$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$9a653e146f5ceb1c$var$addUnit(deg, unit)})`,
                        $9a653e146f5ceb1c$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$9a653e146f5ceb1c$var$addUnit(v, unit)).join(",")})`,
                        $9a653e146f5ceb1c$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $9a653e146f5ceb1c$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $9a653e146f5ceb1c$var$FluidTransform = class extends (0, $d49437e914453600$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $d49437e914453600$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $d49437e914453600$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $d49437e914453600$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $d49437e914453600$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $d49437e914453600$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $d49437e914453600$export$79b2f7037acddd43)(input, (value)=>(0, $d49437e914453600$export$57ea7e3a7f6280c7)(value) && (0, $d49437e914453600$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $d49437e914453600$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $d49437e914453600$export$79b2f7037acddd43)(input, (value)=>(0, $d49437e914453600$export$57ea7e3a7f6280c7)(value) && (0, $d49437e914453600$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $d49437e914453600$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
};
// src/primitives.ts
var $9a653e146f5ceb1c$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $d49437e914453600$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $1rKN8.unstable_batchedUpdates),
    createStringInterpolator: $d49437e914453600$export$4759a013d387347a,
    colors: $d49437e914453600$export$8f45430ccf837300
});
var $9a653e146f5ceb1c$var$host = (0, $82e41a3dee81bfcd$export$4ee5c78f6dcbcef)($9a653e146f5ceb1c$var$primitives, {
    applyAnimatedValues: $9a653e146f5ceb1c$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $9a653e146f5ceb1c$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: ({ scrollTop: scrollTop, scrollLeft: scrollLeft, ...props })=>props
});
var $9a653e146f5ceb1c$export$407448d2b89b1813 = $9a653e146f5ceb1c$var$host.animated;




function $881f54acd386f31e$var$v() {
    return $881f54acd386f31e$var$v = Object.assign ? Object.assign.bind() : function(t) {
        for(var i = 1; i < arguments.length; i++){
            var o = arguments[i];
            for(var n in o)Object.prototype.hasOwnProperty.call(o, n) && (t[n] = o[n]);
        }
        return t;
    }, $881f54acd386f31e$var$v.apply(this, arguments);
}
var $881f54acd386f31e$var$x = {
    pointerEvents: "none",
    position: "absolute",
    zIndex: 10,
    top: 0,
    left: 0
}, $881f54acd386f31e$var$m = function(t, i) {
    return "translate(" + t + "px, " + i + "px)";
}, $881f54acd386f31e$export$57a09c4864b20b90 = (0, $3ZYaX.memo)(function(t) {
    var o, n = t.position, r = t.anchor, e = t.children, l = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), d = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), y = d.animate, f = d.config, b = (0, $15b6b5b56080a0cd$export$e295b0c537d32d7d)(), g = b[0], w = b[1], T = (0, $3ZYaX.useRef)(!1), C = void 0, E = !1, P = w.width > 0 && w.height > 0, j = Math.round(n[0]), N = Math.round(n[1]);
    P && ("top" === r ? (j -= w.width / 2, N -= w.height + 14) : "right" === r ? (j += 14, N -= w.height / 2) : "bottom" === r ? (j -= w.width / 2, N += 14) : "left" === r ? (j -= w.width + 14, N -= w.height / 2) : "center" === r && (j -= w.width / 2, N -= w.height / 2), C = {
        transform: $881f54acd386f31e$var$m(j, N)
    }, T.current || (E = !0), T.current = [
        j,
        N
    ]);
    var O = (0, $775dc606f38f6e3f$export$c4af9125706c4d30)({
        to: C,
        config: f,
        immediate: !y || E
    }), V = $881f54acd386f31e$var$v({}, $881f54acd386f31e$var$x, l.tooltip.wrapper, {
        transform: null != (o = O.transform) ? o : $881f54acd386f31e$var$m(j, N),
        opacity: O.transform ? 1 : 0
    });
    return (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).div, {
        ref: g,
        style: V,
        children: e
    });
});
$881f54acd386f31e$export$57a09c4864b20b90.displayName = "TooltipWrapper";
var $881f54acd386f31e$export$5a7f9a6004988d01 = (0, $3ZYaX.memo)(function(t) {
    var i = t.size, o = void 0 === i ? 12 : i, n = t.color, r = t.style;
    return (0, $4801813bf62cee3c$exports.jsx)("span", {
        style: $881f54acd386f31e$var$v({
            display: "block",
            width: o,
            height: o,
            background: n
        }, void 0 === r ? {} : r)
    });
}), $881f54acd386f31e$export$d5f52d71198e271a = (0, $3ZYaX.memo)(function(t) {
    var i, o = t.id, n = t.value, r = t.format, e = t.enableChip, l = void 0 !== e && e, a = t.color, c = t.renderContent, h = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), u = (0, $15b6b5b56080a0cd$export$422f9765e6971fdf)(r);
    if ("function" == typeof c) i = c();
    else {
        var f = n;
        void 0 !== u && void 0 !== f && (f = u(f)), i = (0, $4801813bf62cee3c$exports.jsxs)("div", {
            style: h.tooltip.basic,
            children: [
                l && (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$export$5a7f9a6004988d01, {
                    color: a,
                    style: h.tooltip.chip
                }),
                void 0 !== f ? (0, $4801813bf62cee3c$exports.jsxs)("span", {
                    children: [
                        o,
                        ": ",
                        (0, $4801813bf62cee3c$exports.jsx)("strong", {
                            children: "" + f
                        })
                    ]
                }) : o
            ]
        });
    }
    return (0, $4801813bf62cee3c$exports.jsx)("div", {
        style: h.tooltip.container,
        children: i
    });
}), $881f54acd386f31e$var$T = {
    width: "100%",
    borderCollapse: "collapse"
}, $881f54acd386f31e$export$4b779126465c60ce = (0, $3ZYaX.memo)(function(t) {
    var i, o = t.title, n = t.rows, r = void 0 === n ? [] : n, e = t.renderContent, l = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)();
    return r.length ? (i = "function" == typeof e ? e() : (0, $4801813bf62cee3c$exports.jsxs)("div", {
        children: [
            o && o,
            (0, $4801813bf62cee3c$exports.jsx)("table", {
                style: $881f54acd386f31e$var$v({}, $881f54acd386f31e$var$T, l.tooltip.table),
                children: (0, $4801813bf62cee3c$exports.jsx)("tbody", {
                    children: r.map(function(t, i) {
                        return (0, $4801813bf62cee3c$exports.jsx)("tr", {
                            children: t.map(function(t, i) {
                                return (0, $4801813bf62cee3c$exports.jsx)("td", {
                                    style: l.tooltip.tableCell,
                                    children: t
                                }, i);
                            })
                        }, i);
                    })
                })
            })
        ]
    }), (0, $4801813bf62cee3c$exports.jsx)("div", {
        style: l.tooltip.container,
        children: i
    })) : null;
});
$881f54acd386f31e$export$4b779126465c60ce.displayName = "TableTooltip";
var $881f54acd386f31e$var$E = (0, $3ZYaX.memo)(function(t) {
    var i = t.x0, n = t.x1, r = t.y0, e = t.y1, l = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), u = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), d = u.animate, y = u.config, f = (0, $3ZYaX.useMemo)(function() {
        return $881f54acd386f31e$var$v({}, l.crosshair.line, {
            pointerEvents: "none"
        });
    }, [
        l.crosshair.line
    ]), x = (0, $775dc606f38f6e3f$export$c4af9125706c4d30)({
        x1: i,
        x2: n,
        y1: r,
        y2: e,
        config: y,
        immediate: !d
    });
    return (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).line, $881f54acd386f31e$var$v({}, x, {
        fill: "none",
        style: f
    }));
});
$881f54acd386f31e$var$E.displayName = "CrosshairLine";
var $881f54acd386f31e$export$2a195a185c8aa9e = (0, $3ZYaX.memo)(function(t) {
    var i, o, n = t.width, r = t.height, e = t.type, l = t.x, a = t.y;
    return "cross" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    }, o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }) : "top-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "top" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    } : "top-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: a
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "right" === e ? o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    } : "bottom-right" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: l,
        x1: n,
        y0: a,
        y1: a
    }) : "bottom" === e ? i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    } : "bottom-left" === e ? (i = {
        x0: l,
        x1: l,
        y0: a,
        y1: r
    }, o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    }) : "left" === e ? o = {
        x0: 0,
        x1: l,
        y0: a,
        y1: a
    } : "x" === e ? i = {
        x0: l,
        x1: l,
        y0: 0,
        y1: r
    } : "y" === e && (o = {
        x0: 0,
        x1: n,
        y0: a,
        y1: a
    }), (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            i && (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$var$E, {
                x0: i.x0,
                x1: i.x1,
                y0: i.y0,
                y1: i.y1
            }),
            o && (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$var$E, {
                x0: o.x0,
                x1: o.x1,
                y0: o.y0,
                y1: o.y1
            })
        ]
    });
});
$881f54acd386f31e$export$2a195a185c8aa9e.displayName = "Crosshair";
var $881f54acd386f31e$export$d344f0e974db1e2e = (0, $3ZYaX.createContext)({
    showTooltipAt: function() {},
    showTooltipFromEvent: function() {},
    hideTooltip: function() {}
}), $881f54acd386f31e$export$3a517200cf5bfc1b = {
    isVisible: !1,
    position: [
        null,
        null
    ],
    content: null,
    anchor: null
}, $881f54acd386f31e$export$c7027a64d546bf1d = (0, $3ZYaX.createContext)($881f54acd386f31e$export$3a517200cf5bfc1b), $881f54acd386f31e$export$85cc26a2c4544aaa = function(t) {
    var i = (0, $3ZYaX.useState)($881f54acd386f31e$export$3a517200cf5bfc1b), n = i[0], l = i[1], a = (0, $3ZYaX.useCallback)(function(t, i, o) {
        var n = i[0], r = i[1];
        void 0 === o && (o = "top"), l({
            isVisible: !0,
            position: [
                n,
                r
            ],
            anchor: o,
            content: t
        });
    }, [
        l
    ]), c = (0, $3ZYaX.useCallback)(function(i, o, n) {
        void 0 === n && (n = "top");
        var r = t.current.getBoundingClientRect(), e = t.current.offsetWidth, a = e === r.width ? 1 : e / r.width, c = "touches" in o ? o.touches[0] : o, s = c.clientX, h = c.clientY, u = (s - r.left) * a, d = (h - r.top) * a;
        "left" !== n && "right" !== n || (n = u < r.width / 2 ? "right" : "left"), l({
            isVisible: !0,
            position: [
                u,
                d
            ],
            anchor: n,
            content: i
        });
    }, [
        t,
        l
    ]), s = (0, $3ZYaX.useCallback)(function() {
        l($881f54acd386f31e$export$3a517200cf5bfc1b);
    }, [
        l
    ]);
    return {
        actions: (0, $3ZYaX.useMemo)(function() {
            return {
                showTooltipAt: a,
                showTooltipFromEvent: c,
                hideTooltip: s
            };
        }, [
            a,
            c,
            s
        ]),
        state: n
    };
}, $881f54acd386f31e$export$1c4b08e0eca38426 = function() {
    var t = (0, $3ZYaX.useContext)($881f54acd386f31e$export$d344f0e974db1e2e);
    if (void 0 === t) throw new Error("useTooltip must be used within a TooltipProvider");
    return t;
}, $881f54acd386f31e$export$b6b30c61d706ffee = function() {
    var t = (0, $3ZYaX.useContext)($881f54acd386f31e$export$c7027a64d546bf1d);
    if (void 0 === t) throw new Error("useTooltipState must be used within a TooltipProvider");
    return t;
}, $881f54acd386f31e$export$dd4f39ed288d94c9 = function(t) {
    return t.isVisible;
}, $881f54acd386f31e$export$28c660c63b792dea = function() {
    var t = $881f54acd386f31e$export$b6b30c61d706ffee();
    return $881f54acd386f31e$export$dd4f39ed288d94c9(t) ? (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$export$57a09c4864b20b90, {
        position: t.position,
        anchor: t.anchor,
        children: t.content
    }) : null;
}, $881f54acd386f31e$export$f78649fb9ca566b8 = function(t) {
    var i = t.container, o = t.children, n = $881f54acd386f31e$export$85cc26a2c4544aaa(i), r = n.actions, e = n.state;
    return (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$export$d344f0e974db1e2e.Provider, {
        value: r,
        children: (0, $4801813bf62cee3c$exports.jsx)($881f54acd386f31e$export$c7027a64d546bf1d.Provider, {
            value: e,
            children: o
        })
    });
};


var $5e4719d79b0501b4$exports = {};
var $35d2323f568f3528$exports = {};

var $d9917d62d492d2b5$exports = {};
var $c0a947aaefa1d5a5$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $c0a947aaefa1d5a5$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $af5ed0ae6bf53d5a$exports) $af5ed0ae6bf53d5a$exports(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
$c0a947aaefa1d5a5$exports = $c0a947aaefa1d5a5$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d9917d62d492d2b5$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$8b43bb409bcd8608$exports(object[key], value) || value === undefined && !(key in object)) $c0a947aaefa1d5a5$exports(object, key, value);
}
$d9917d62d492d2b5$exports = $d9917d62d492d2b5$var$assignMergeValue;



var $b596b31d72ecb5fb$exports = {};


var $feCW9 = parcelRequire("feCW9");
var $f20c00cf8be7256a$exports = {};
var $5b02f5d7f5460ecb$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $5b02f5d7f5460ecb$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $d147b00cce633c67$exports(result).set(new $d147b00cce633c67$exports(arrayBuffer));
    return result;
}
$5b02f5d7f5460ecb$exports = $5b02f5d7f5460ecb$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $f20c00cf8be7256a$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $5b02f5d7f5460ecb$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$f20c00cf8be7256a$exports = $f20c00cf8be7256a$var$cloneTypedArray;


var $d7f47cb2245d0ed5$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $d7f47cb2245d0ed5$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$d7f47cb2245d0ed5$exports = $d7f47cb2245d0ed5$var$copyArray;


var $4832db9e9830895e$exports = {};
var $dc63cfe57c606ba6$exports = {};

/** Built-in value references. */ var $dc63cfe57c606ba6$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $dc63cfe57c606ba6$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$2f639ab8f1a63700$exports(proto)) return {};
        if ($dc63cfe57c606ba6$var$objectCreate) return $dc63cfe57c606ba6$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$dc63cfe57c606ba6$exports = $dc63cfe57c606ba6$var$baseCreate;


var $9024aebf5a7a050c$exports = {};

/** Built-in value references. */ var $9024aebf5a7a050c$var$getPrototype = $322d541d8967a885$exports(Object.getPrototypeOf, Object);
$9024aebf5a7a050c$exports = $9024aebf5a7a050c$var$getPrototype;



/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4832db9e9830895e$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$e223e8709466f95c$exports(object) ? $dc63cfe57c606ba6$exports($9024aebf5a7a050c$exports(object)) : {};
}
$4832db9e9830895e$exports = $4832db9e9830895e$var$initCloneObject;




var $918f7153cc6b68ec$exports = {};


/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $918f7153cc6b68ec$var$isArrayLikeObject(value) {
    return $4c68ed1e6cc4dd3d$exports(value) && $b4272727fa799bca$exports(value);
}
$918f7153cc6b68ec$exports = $918f7153cc6b68ec$var$isArrayLikeObject;



var $i1hPd = parcelRequire("i1hPd");


var $7df273079235e60a$exports = {};



/** `Object#toString` result references. */ var $7df273079235e60a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $7df273079235e60a$var$funcProto = Function.prototype, $7df273079235e60a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $7df273079235e60a$var$funcToString = $7df273079235e60a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $7df273079235e60a$var$hasOwnProperty = $7df273079235e60a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $7df273079235e60a$var$objectCtorString = $7df273079235e60a$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $7df273079235e60a$var$isPlainObject(value) {
    if (!$4c68ed1e6cc4dd3d$exports(value) || $9310747326fde40a$exports(value) != $7df273079235e60a$var$objectTag) return false;
    var proto = $9024aebf5a7a050c$exports(value);
    if (proto === null) return true;
    var Ctor = $7df273079235e60a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $7df273079235e60a$var$funcToString.call(Ctor) == $7df273079235e60a$var$objectCtorString;
}
$7df273079235e60a$exports = $7df273079235e60a$var$isPlainObject;



var $64d2716c23be3ded$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $64d2716c23be3ded$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
$64d2716c23be3ded$exports = $64d2716c23be3ded$var$safeGet;


var $660c18137a13b867$exports = {};
var $6824d973e80e65d6$exports = {};
var $a36eafac82009df9$exports = {};


/** Used for built-in method references. */ var $a36eafac82009df9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a36eafac82009df9$var$hasOwnProperty = $a36eafac82009df9$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a36eafac82009df9$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($a36eafac82009df9$var$hasOwnProperty.call(object, key) && $8b43bb409bcd8608$exports(objValue, value)) || value === undefined && !(key in object)) $c0a947aaefa1d5a5$exports(object, key, value);
}
$a36eafac82009df9$exports = $a36eafac82009df9$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $6824d973e80e65d6$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $c0a947aaefa1d5a5$exports(object, key, newValue);
        else $a36eafac82009df9$exports(object, key, newValue);
    }
    return object;
}
$6824d973e80e65d6$exports = $6824d973e80e65d6$var$copyObject;


var $849d9cd769657956$exports = {};

var $da0a0d47e95c31e4$exports = {};


var $9d9cc3147e8d5098$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $9d9cc3147e8d5098$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$9d9cc3147e8d5098$exports = $9d9cc3147e8d5098$var$nativeKeysIn;


/** Used for built-in method references. */ var $da0a0d47e95c31e4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da0a0d47e95c31e4$var$hasOwnProperty = $da0a0d47e95c31e4$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $da0a0d47e95c31e4$var$baseKeysIn(object) {
    if (!$2f639ab8f1a63700$exports(object)) return $9d9cc3147e8d5098$exports(object);
    var isProto = $e223e8709466f95c$exports(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$da0a0d47e95c31e4$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$da0a0d47e95c31e4$exports = $da0a0d47e95c31e4$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $849d9cd769657956$var$keysIn(object) {
    return $b4272727fa799bca$exports(object) ? $a5a913c044f9cddc$exports(object, true) : $da0a0d47e95c31e4$exports(object);
}
$849d9cd769657956$exports = $849d9cd769657956$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $660c18137a13b867$var$toPlainObject(value) {
    return $6824d973e80e65d6$exports(value, $849d9cd769657956$exports(value));
}
$660c18137a13b867$exports = $660c18137a13b867$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $b596b31d72ecb5fb$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $64d2716c23be3ded$exports(object, key), srcValue = $64d2716c23be3ded$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $d9917d62d492d2b5$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $135874bbc3d3a66a$exports(srcValue), isBuff = !isArr && $i1hPd(srcValue), isTyped = !isArr && !isBuff && $1dd6641c609c15cb$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($135874bbc3d3a66a$exports(objValue)) newValue = objValue;
            else if ($918f7153cc6b68ec$exports(objValue)) newValue = $d7f47cb2245d0ed5$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $feCW9(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $f20c00cf8be7256a$exports(srcValue, true);
            } else newValue = [];
        } else if ($7df273079235e60a$exports(srcValue) || $dcc72e78add79d6a$exports(srcValue)) {
            newValue = objValue;
            if ($dcc72e78add79d6a$exports(objValue)) newValue = $660c18137a13b867$exports(objValue);
            else if (!$2f639ab8f1a63700$exports(objValue) || $08f69a989e3c33aa$exports(objValue)) newValue = $4832db9e9830895e$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $d9917d62d492d2b5$exports(object, key, newValue);
}
$b596b31d72ecb5fb$exports = $b596b31d72ecb5fb$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $35d2323f568f3528$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $0456685b5ea3394b$exports(source, function(srcValue, key) {
        stack || (stack = new $39cc8fdcacbfee68$exports);
        if ($2f639ab8f1a63700$exports(srcValue)) $b596b31d72ecb5fb$exports(object, source, key, srcIndex, $35d2323f568f3528$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($64d2716c23be3ded$exports(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $d9917d62d492d2b5$exports(object, key, newValue);
        }
    }, $849d9cd769657956$exports);
}
$35d2323f568f3528$exports = $35d2323f568f3528$var$baseMerge;


var $2911351d137e6470$exports = {};


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $2911351d137e6470$var$createAssigner(assigner) {
    return $3a44e1c37a075144$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $575bc90426cea3f6$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$2911351d137e6470$exports = $2911351d137e6470$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $5e4719d79b0501b4$var$merge = $2911351d137e6470$exports(function(object, source, srcIndex) {
    $35d2323f568f3528$exports(object, source, srcIndex);
});
$5e4719d79b0501b4$exports = $5e4719d79b0501b4$var$merge;



var $4fc3640d3c2238e3$exports = {};
var $ebb8b30015809e94$exports = {};





/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $ebb8b30015809e94$var$baseSet(object, path, value, customizer) {
    if (!$2f639ab8f1a63700$exports(object)) return object;
    path = $2c532cb4a076ff14$exports(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $a657e945d0a84989$exports(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $2f639ab8f1a63700$exports(objValue) ? objValue : $b2e9ef4ce3991fa5$exports(path[index + 1]) ? [] : {};
        }
        $a36eafac82009df9$exports(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
$ebb8b30015809e94$exports = $ebb8b30015809e94$var$baseSet;


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $4fc3640d3c2238e3$var$set(object, path, value) {
    return object == null ? object : $ebb8b30015809e94$exports(object, path, value);
}
$4fc3640d3c2238e3$exports = $4fc3640d3c2238e3$var$set;


function $470cf3c6636bf1f9$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}


var $ee4f21d867ccc1fa$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $ee4f21d867ccc1fa$var$reB = new RegExp($ee4f21d867ccc1fa$var$reA.source, "g");
function $ee4f21d867ccc1fa$var$zero(b) {
    return function() {
        return b;
    };
}
function $ee4f21d867ccc1fa$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $ee4f21d867ccc1fa$export$2e2bcd8739ae039(a, b) {
    var bi = $ee4f21d867ccc1fa$var$reA.lastIndex = $ee4f21d867ccc1fa$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $ee4f21d867ccc1fa$var$reA.exec(a)) && (bm = $ee4f21d867ccc1fa$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $470cf3c6636bf1f9$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $ee4f21d867ccc1fa$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $ee4f21d867ccc1fa$var$one(q[0].x) : $ee4f21d867ccc1fa$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}



var $357bf21b0f7327af$exports = {};



/** `Object#toString` result references. */ var $357bf21b0f7327af$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $357bf21b0f7327af$var$isString(value) {
    return typeof value == 'string' || !$135874bbc3d3a66a$exports(value) && $4c68ed1e6cc4dd3d$exports(value) && $9310747326fde40a$exports(value) == $357bf21b0f7327af$var$stringTag;
}
$357bf21b0f7327af$exports = $357bf21b0f7327af$var$isString;



var $f971a3288c675058$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $f971a3288c675058$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$f971a3288c675058$exports = $f971a3288c675058$var$last;



class $87323652abcee4c0$export$dcc6fb7d82b5bc7b extends Map {
    get(key) {
        return super.get($87323652abcee4c0$var$intern_get(this, key));
    }
    has(key) {
        return super.has($87323652abcee4c0$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($87323652abcee4c0$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($87323652abcee4c0$var$intern_delete(this, key));
    }
    constructor(entries, key = $87323652abcee4c0$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
}
class $87323652abcee4c0$export$55278c3294239828 extends Set {
    has(value) {
        return super.has($87323652abcee4c0$var$intern_get(this, value));
    }
    add(value) {
        return super.add($87323652abcee4c0$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($87323652abcee4c0$var$intern_delete(this, value));
    }
    constructor(values, key = $87323652abcee4c0$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
}
function $87323652abcee4c0$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $87323652abcee4c0$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $87323652abcee4c0$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $87323652abcee4c0$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}


function $d015fa4d4e8746f2$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $d015fa4d4e8746f2$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


const $089e671e2a2205fb$export$e4f898ab14d9d460 = Symbol("implicit");
function $089e671e2a2205fb$export$2e2bcd8739ae039() {
    var index = new (0, $87323652abcee4c0$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $089e671e2a2205fb$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $089e671e2a2205fb$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $87323652abcee4c0$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $089e671e2a2205fb$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}

function $ddb2669912a6d36e$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $501633703020a885$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $501633703020a885$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $501633703020a885$var$ascendingComparator(f) {
    return (d, x)=>(0, $ddb2669912a6d36e$export$2e2bcd8739ae039)(f(d), x);
}


function $05fd41dc18c549b2$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $05fd41dc18c549b2$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $5529c8c181db0546$var$ascendingBisect = (0, $501633703020a885$export$2e2bcd8739ae039)((0, $ddb2669912a6d36e$export$2e2bcd8739ae039));
const $5529c8c181db0546$export$4d945ad3ad5751b0 = $5529c8c181db0546$var$ascendingBisect.right;
const $5529c8c181db0546$export$df7d25c84ebd12a5 = $5529c8c181db0546$var$ascendingBisect.left;
const $5529c8c181db0546$export$c1cb828b1117c77b = (0, $501633703020a885$export$2e2bcd8739ae039)((0, $05fd41dc18c549b2$export$2e2bcd8739ae039)).center;
var $5529c8c181db0546$export$2e2bcd8739ae039 = $5529c8c181db0546$export$4d945ad3ad5751b0;


var $c3c5d4ea02a79cf4$var$e10 = Math.sqrt(50), $c3c5d4ea02a79cf4$var$e5 = Math.sqrt(10), $c3c5d4ea02a79cf4$var$e2 = Math.sqrt(2);
function $c3c5d4ea02a79cf4$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $c3c5d4ea02a79cf4$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $c3c5d4ea02a79cf4$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $c3c5d4ea02a79cf4$var$e10 ? 10 : error >= $c3c5d4ea02a79cf4$var$e5 ? 5 : error >= $c3c5d4ea02a79cf4$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $c3c5d4ea02a79cf4$var$e10 ? 10 : error >= $c3c5d4ea02a79cf4$var$e5 ? 5 : error >= $c3c5d4ea02a79cf4$var$e2 ? 2 : 1);
}
function $c3c5d4ea02a79cf4$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $c3c5d4ea02a79cf4$var$e10) step1 *= 10;
    else if (error >= $c3c5d4ea02a79cf4$var$e5) step1 *= 5;
    else if (error >= $c3c5d4ea02a79cf4$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}




var $dIr8n = parcelRequire("dIr8n");

var $dIr8n = parcelRequire("dIr8n");
function $5da8e26a9750ec48$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $5da8e26a9750ec48$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $5da8e26a9750ec48$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $0afc8ae8b4e3deed$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $5da8e26a9750ec48$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $349da5eae28fbd81$export$2e2bcd8739ae039 = (x)=>()=>x;


function $228ae9c91f6d0558$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $228ae9c91f6d0558$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $228ae9c91f6d0558$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $228ae9c91f6d0558$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $349da5eae28fbd81$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $228ae9c91f6d0558$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $228ae9c91f6d0558$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $228ae9c91f6d0558$var$exponential(a, b, y) : (0, $349da5eae28fbd81$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $228ae9c91f6d0558$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $228ae9c91f6d0558$var$linear(a, d) : (0, $349da5eae28fbd81$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $9e4a53314c629d6b$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $228ae9c91f6d0558$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $dIr8n.rgb)(start)).r, (end = (0, $dIr8n.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $228ae9c91f6d0558$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $9e4a53314c629d6b$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $dIr8n.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $9e4a53314c629d6b$export$2c0e28f2e2852d3f = $9e4a53314c629d6b$var$rgbSpline((0, $5da8e26a9750ec48$export$2e2bcd8739ae039));
var $9e4a53314c629d6b$export$53d5214f625ccd4c = $9e4a53314c629d6b$var$rgbSpline((0, $0afc8ae8b4e3deed$export$2e2bcd8739ae039));



function $73ba5f48a0b435bc$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $73ba5f48a0b435bc$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $5ad544fe66d0906f$export$2e2bcd8739ae039(a, b) {
    return ((0, $73ba5f48a0b435bc$export$5cd576d1827d40c8)(b) ? (0, $73ba5f48a0b435bc$export$2e2bcd8739ae039) : $5ad544fe66d0906f$export$15d09067c6a5ee49)(a, b);
}
function $5ad544fe66d0906f$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $479e0f1de0f3b04d$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $a1adc3b493a50c9f$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}




function $6bd5955ab061bf43$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $479e0f1de0f3b04d$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}





function $479e0f1de0f3b04d$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $349da5eae28fbd81$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $470cf3c6636bf1f9$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $dIr8n.default)(b)) ? (b = c, $9e4a53314c629d6b$export$2e2bcd8739ae039) : (0, $ee4f21d867ccc1fa$export$2e2bcd8739ae039) : b instanceof (0, $dIr8n.default) ? (0, $9e4a53314c629d6b$export$2e2bcd8739ae039) : b instanceof Date ? (0, $a1adc3b493a50c9f$export$2e2bcd8739ae039) : (0, $73ba5f48a0b435bc$export$5cd576d1827d40c8)(b) ? (0, $73ba5f48a0b435bc$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $5ad544fe66d0906f$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $6bd5955ab061bf43$export$2e2bcd8739ae039) : (0, $470cf3c6636bf1f9$export$2e2bcd8739ae039))(a, b);
}

function $d38a559bfa965ec4$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $301b0733a120fe55$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $a23f1dac5cde5e1e$export$2e2bcd8739ae039(x) {
    return +x;
}


var $29550db44feecbe6$var$unit = [
    0,
    1
];
function $29550db44feecbe6$export$f0954fd7d5368655(x) {
    return x;
}
function $29550db44feecbe6$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $301b0733a120fe55$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $29550db44feecbe6$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $29550db44feecbe6$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $29550db44feecbe6$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $29550db44feecbe6$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $29550db44feecbe6$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $29550db44feecbe6$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $5529c8c181db0546$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $29550db44feecbe6$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $29550db44feecbe6$export$6b468dcfb64c653c() {
    var domain = $29550db44feecbe6$var$unit, range = $29550db44feecbe6$var$unit, interpolate = (0, $479e0f1de0f3b04d$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $29550db44feecbe6$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $29550db44feecbe6$export$f0954fd7d5368655) clamp = $29550db44feecbe6$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $29550db44feecbe6$var$polymap : $29550db44feecbe6$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $470cf3c6636bf1f9$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $a23f1dac5cde5e1e$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $d38a559bfa965ec4$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $29550db44feecbe6$export$f0954fd7d5368655, rescale()) : clamp !== $29550db44feecbe6$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $29550db44feecbe6$export$2e2bcd8739ae039() {
    return $29550db44feecbe6$export$6b468dcfb64c653c()($29550db44feecbe6$export$f0954fd7d5368655, $29550db44feecbe6$export$f0954fd7d5368655);
}




function $2ac7b1a96a124f86$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $2ac7b1a96a124f86$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $3dc42fdef82dec00$export$2e2bcd8739ae039(x) {
    return x = (0, $2ac7b1a96a124f86$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $36fdbce016ecf789$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $a64d86cd1cf87908$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $9c4e93d57dcac686$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $9c4e93d57dcac686$export$2e2bcd8739ae039(specifier) {
    if (!(match = $9c4e93d57dcac686$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $9c4e93d57dcac686$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$9c4e93d57dcac686$export$2e2bcd8739ae039.prototype = $9c4e93d57dcac686$export$963aac351db36ed4.prototype; // instanceof
function $9c4e93d57dcac686$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$9c4e93d57dcac686$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $c1d90ce6c37375ad$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $eb0a3f16c8cf7a65$export$6863724d9a42263;
function $eb0a3f16c8cf7a65$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2ac7b1a96a124f86$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($eb0a3f16c8cf7a65$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $2ac7b1a96a124f86$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $c9b130e6fa578d4e$export$2e2bcd8739ae039(x, p) {
    var d = (0, $2ac7b1a96a124f86$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $af5f7550ce1f97b6$export$2e2bcd8739ae039 = {
    "%": function(x, p) {
        return (x * 100).toFixed(p);
    },
    "b": function(x) {
        return Math.round(x).toString(2);
    },
    "c": function(x) {
        return x + "";
    },
    "d": (0, $2ac7b1a96a124f86$export$2e2bcd8739ae039),
    "e": function(x, p) {
        return x.toExponential(p);
    },
    "f": function(x, p) {
        return x.toFixed(p);
    },
    "g": function(x, p) {
        return x.toPrecision(p);
    },
    "o": function(x) {
        return Math.round(x).toString(8);
    },
    "p": function(x, p) {
        return (0, $c9b130e6fa578d4e$export$2e2bcd8739ae039)(x * 100, p);
    },
    "r": (0, $c9b130e6fa578d4e$export$2e2bcd8739ae039),
    "s": (0, $eb0a3f16c8cf7a65$export$2e2bcd8739ae039),
    "X": function(x) {
        return Math.round(x).toString(16).toUpperCase();
    },
    "x": function(x) {
        return Math.round(x).toString(16);
    }
};



function $c848c47a7e41c318$export$2e2bcd8739ae039(x) {
    return x;
}


var $5fc3f669e1cbbc9d$var$map = Array.prototype.map, $5fc3f669e1cbbc9d$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $5fc3f669e1cbbc9d$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $c848c47a7e41c318$export$2e2bcd8739ae039) : (0, $36fdbce016ecf789$export$2e2bcd8739ae039)($5fc3f669e1cbbc9d$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $c848c47a7e41c318$export$2e2bcd8739ae039) : (0, $a64d86cd1cf87908$export$2e2bcd8739ae039)($5fc3f669e1cbbc9d$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "-" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $9c4e93d57dcac686$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $af5f7550ce1f97b6$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $af5f7550ce1f97b6$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $c1d90ce6c37375ad$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $5fc3f669e1cbbc9d$var$prefixes[8 + (0, $eb0a3f16c8cf7a65$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $9c4e93d57dcac686$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $5fc3f669e1cbbc9d$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $a3518d7e1fb7157d$var$locale;
var $a3518d7e1fb7157d$export$d9468344d3651243;
var $a3518d7e1fb7157d$export$8d85692a469dde6f;
$a3518d7e1fb7157d$export$2e2bcd8739ae039({
    decimal: ".",
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ],
    minus: "-"
});
function $a3518d7e1fb7157d$export$2e2bcd8739ae039(definition) {
    $a3518d7e1fb7157d$var$locale = (0, $5fc3f669e1cbbc9d$export$2e2bcd8739ae039)(definition);
    $a3518d7e1fb7157d$export$d9468344d3651243 = $a3518d7e1fb7157d$var$locale.format;
    $a3518d7e1fb7157d$export$8d85692a469dde6f = $a3518d7e1fb7157d$var$locale.formatPrefix;
    return $a3518d7e1fb7157d$var$locale;
}


function $b813f802568f1e92$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $1adb18093aa3539d$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $664e67d24c167448$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(max) - (0, $3dc42fdef82dec00$export$2e2bcd8739ae039)(step)) + 1;
}


function $19c7e5a0da17726b$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $c3c5d4ea02a79cf4$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $9c4e93d57dcac686$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1adb18093aa3539d$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $a3518d7e1fb7157d$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $664e67d24c167448$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $b813f802568f1e92$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $a3518d7e1fb7157d$export$d9468344d3651243)(specifier);
}


function $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $19c7e5a0da17726b$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $c3c5d4ea02a79cf4$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $b8b10d1c6ef9e3db$export$2e2bcd8739ae039() {
    var scale = (0, $29550db44feecbe6$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $29550db44feecbe6$export$784d13d8ee351f07)(scale, $b8b10d1c6ef9e3db$export$2e2bcd8739ae039());
    };
    (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d(scale);
}



function $f78bcf83d712ddfc$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $5529c8c181db0546$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $f78bcf83d712ddfc$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply((0, $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d)(scale), arguments);
}







function $0f802dceb674c0b3$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $49a5ecde9396b9b6$var$transformLog(x) {
    return Math.log(x);
}
function $49a5ecde9396b9b6$var$transformExp(x) {
    return Math.exp(x);
}
function $49a5ecde9396b9b6$var$transformLogn(x) {
    return -Math.log(-x);
}
function $49a5ecde9396b9b6$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $49a5ecde9396b9b6$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $49a5ecde9396b9b6$var$powp(base) {
    return base === 10 ? $49a5ecde9396b9b6$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $49a5ecde9396b9b6$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $49a5ecde9396b9b6$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $49a5ecde9396b9b6$export$860836db074028f0(transform) {
    const scale = transform($49a5ecde9396b9b6$var$transformLog, $49a5ecde9396b9b6$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $49a5ecde9396b9b6$var$logp(base), pows = $49a5ecde9396b9b6$var$powp(base);
        if (domain()[0] < 0) {
            logs = $49a5ecde9396b9b6$var$reflect(logs), pows = $49a5ecde9396b9b6$var$reflect(pows);
            transform($49a5ecde9396b9b6$var$transformLogn, $49a5ecde9396b9b6$var$transformExpn);
        } else transform($49a5ecde9396b9b6$var$transformLog, $49a5ecde9396b9b6$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $9c4e93d57dcac686$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $a3518d7e1fb7157d$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $0f802dceb674c0b3$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $49a5ecde9396b9b6$export$2e2bcd8739ae039() {
    const scale = $49a5ecde9396b9b6$export$860836db074028f0((0, $29550db44feecbe6$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $29550db44feecbe6$export$784d13d8ee351f07)(scale, $49a5ecde9396b9b6$export$2e2bcd8739ae039()).base(scale.base());
    (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $0db6e7d96266c5bc$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $0db6e7d96266c5bc$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $0db6e7d96266c5bc$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($0db6e7d96266c5bc$var$transformSymlog(c), $0db6e7d96266c5bc$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($0db6e7d96266c5bc$var$transformSymlog(c = +_), $0db6e7d96266c5bc$var$transformSymexp(c)) : c;
    };
    return (0, $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d)(scale);
}
function $0db6e7d96266c5bc$export$2e2bcd8739ae039() {
    var scale = $0db6e7d96266c5bc$export$4602684e614eba38((0, $29550db44feecbe6$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $29550db44feecbe6$export$784d13d8ee351f07)(scale, $0db6e7d96266c5bc$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $06ef6a63aa890067$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $06ef6a63aa890067$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $06ef6a63aa890067$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $06ef6a63aa890067$export$34695211ec403a46(transform) {
    var scale = transform((0, $29550db44feecbe6$export$f0954fd7d5368655), (0, $29550db44feecbe6$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $29550db44feecbe6$export$f0954fd7d5368655), (0, $29550db44feecbe6$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($06ef6a63aa890067$var$transformSqrt, $06ef6a63aa890067$var$transformSquare) : transform($06ef6a63aa890067$var$transformPow(exponent), $06ef6a63aa890067$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d)(scale);
}
function $06ef6a63aa890067$export$2e2bcd8739ae039() {
    var scale = $06ef6a63aa890067$export$34695211ec403a46((0, $29550db44feecbe6$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $29550db44feecbe6$export$784d13d8ee351f07)(scale, $06ef6a63aa890067$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $d015fa4d4e8746f2$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $06ef6a63aa890067$export$eba8049fb5020b81() {
    return $06ef6a63aa890067$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $50dd1fa50091df50$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $29550db44feecbe6$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $479e0f1de0f3b04d$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $d38a559bfa965ec4$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $50dd1fa50091df50$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $50dd1fa50091df50$export$2e2bcd8739ae039() {
    var scale = (0, $b8b10d1c6ef9e3db$export$16a5d4b4a61a274d)($50dd1fa50091df50$var$transformer()((0, $29550db44feecbe6$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $50dd1fa50091df50$export$784d13d8ee351f07(scale, $50dd1fa50091df50$export$2e2bcd8739ae039());
    };
    return (0, $d015fa4d4e8746f2$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50dd1fa50091df50$export$6843e08bf2ff981f() {
    var scale = (0, $49a5ecde9396b9b6$export$860836db074028f0)($50dd1fa50091df50$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $50dd1fa50091df50$export$784d13d8ee351f07(scale, $50dd1fa50091df50$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $d015fa4d4e8746f2$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50dd1fa50091df50$export$9d4af4de62c81941() {
    var scale = (0, $0db6e7d96266c5bc$export$4602684e614eba38)($50dd1fa50091df50$var$transformer());
    scale.copy = function() {
        return $50dd1fa50091df50$export$784d13d8ee351f07(scale, $50dd1fa50091df50$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $d015fa4d4e8746f2$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50dd1fa50091df50$export$de9f78581b4f2405() {
    var scale = (0, $06ef6a63aa890067$export$34695211ec403a46)($50dd1fa50091df50$var$transformer());
    scale.copy = function() {
        return $50dd1fa50091df50$export$784d13d8ee351f07(scale, $50dd1fa50091df50$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $d015fa4d4e8746f2$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $50dd1fa50091df50$export$413d935127ed466e() {
    return $50dd1fa50091df50$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}


function $969754e2723a4743$export$2e2bcd8739ae039(specifier) {
    var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
    while(i < n)colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
    return colors;
}



var $f4Y7W = parcelRequire("f4Y7W");
function $636732855b720794$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $636732855b720794$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $636732855b720794$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $a95739e867be551f$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $636732855b720794$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $38f7fbbba02c20c1$export$2e2bcd8739ae039 = (x)=>()=>x;


function $ef5e504b188371cc$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $ef5e504b188371cc$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $ef5e504b188371cc$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $ef5e504b188371cc$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $38f7fbbba02c20c1$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $ef5e504b188371cc$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $ef5e504b188371cc$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $ef5e504b188371cc$var$exponential(a, b, y) : (0, $38f7fbbba02c20c1$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $ef5e504b188371cc$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $ef5e504b188371cc$var$linear(a, d) : (0, $38f7fbbba02c20c1$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $f39bcde308170c65$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $ef5e504b188371cc$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $f4Y7W.rgb)(start)).r, (end = (0, $f4Y7W.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $ef5e504b188371cc$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $f39bcde308170c65$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $f4Y7W.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $f39bcde308170c65$export$2c0e28f2e2852d3f = $f39bcde308170c65$var$rgbSpline((0, $636732855b720794$export$2e2bcd8739ae039));
var $f39bcde308170c65$export$53d5214f625ccd4c = $f39bcde308170c65$var$rgbSpline((0, $a95739e867be551f$export$2e2bcd8739ae039));


var $b4dfd6a75d419f03$export$2e2bcd8739ae039 = (scheme)=>(0, $f39bcde308170c65$export$2c0e28f2e2852d3f)(scheme[scheme.length - 1]);


var $8eac7426bb1c0fbe$export$3005042704f95a69 = new Array(3).concat("deebf79ecae13182bd", "eff3ffbdd7e76baed62171b5", "eff3ffbdd7e76baed63182bd08519c", "eff3ffc6dbef9ecae16baed63182bd08519c", "eff3ffc6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594", "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $8eac7426bb1c0fbe$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($8eac7426bb1c0fbe$export$3005042704f95a69);



var $eede694b8fbd97fa$export$3005042704f95a69 = new Array(3).concat("d8b365f5f5f55ab4ac", "a6611adfc27d80cdc1018571", "a6611adfc27df5f5f580cdc1018571", "8c510ad8b365f6e8c3c7eae55ab4ac01665e", "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e", "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e", "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e", "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30", "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $eede694b8fbd97fa$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($eede694b8fbd97fa$export$3005042704f95a69);



var $fbc38117fdd97bd3$export$3005042704f95a69 = new Array(3).concat("e5f5f999d8c92ca25f", "edf8fbb2e2e266c2a4238b45", "edf8fbb2e2e266c2a42ca25f006d2c", "edf8fbccece699d8c966c2a42ca25f006d2c", "edf8fbccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824", "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $fbc38117fdd97bd3$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($fbc38117fdd97bd3$export$3005042704f95a69);



var $dafaca52a0f61b65$export$3005042704f95a69 = new Array(3).concat("e0ecf49ebcda8856a7", "edf8fbb3cde38c96c688419d", "edf8fbb3cde38c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68856a7810f7c", "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b", "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $dafaca52a0f61b65$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($dafaca52a0f61b65$export$3005042704f95a69);


var $1iwiL = parcelRequire("1iwiL");

var $f4Y7W = parcelRequire("f4Y7W");
const $cb01cfca7c53740c$export$8449e153fbd325fc = Math.PI / 180;
const $cb01cfca7c53740c$export$41fc368e1a942b97 = 180 / Math.PI;


var $f420561438b739e5$var$A = -0.14861, $f420561438b739e5$var$B = 1.78277, $f420561438b739e5$var$C = -0.29227, $f420561438b739e5$var$D = -0.90649, $f420561438b739e5$var$E = 1.97294, $f420561438b739e5$var$ED = $f420561438b739e5$var$E * $f420561438b739e5$var$D, $f420561438b739e5$var$EB = $f420561438b739e5$var$E * $f420561438b739e5$var$B, $f420561438b739e5$var$BC_DA = $f420561438b739e5$var$B * $f420561438b739e5$var$C - $f420561438b739e5$var$D * $f420561438b739e5$var$A;
function $f420561438b739e5$var$cubehelixConvert(o) {
    if (o instanceof $f420561438b739e5$export$57ed4bde61a1e2f2) return new $f420561438b739e5$export$57ed4bde61a1e2f2(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof (0, $f4Y7W.Rgb))) o = (0, $f4Y7W.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($f420561438b739e5$var$BC_DA * b + $f420561438b739e5$var$ED * r - $f420561438b739e5$var$EB * g) / ($f420561438b739e5$var$BC_DA + $f420561438b739e5$var$ED - $f420561438b739e5$var$EB), bl = b - l, k = ($f420561438b739e5$var$E * (g - l) - $f420561438b739e5$var$C * bl) / $f420561438b739e5$var$D, s = Math.sqrt(k * k + bl * bl) / ($f420561438b739e5$var$E * l * (1 - l)), h = s ? Math.atan2(k, bl) * (0, $cb01cfca7c53740c$export$41fc368e1a942b97) - 120 : NaN;
    return new $f420561438b739e5$export$57ed4bde61a1e2f2(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $f420561438b739e5$export$2e2bcd8739ae039(h, s, l, opacity) {
    return arguments.length === 1 ? $f420561438b739e5$var$cubehelixConvert(h) : new $f420561438b739e5$export$57ed4bde61a1e2f2(h, s, l, opacity == null ? 1 : opacity);
}
function $f420561438b739e5$export$57ed4bde61a1e2f2(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $1iwiL.default)($f420561438b739e5$export$57ed4bde61a1e2f2, $f420561438b739e5$export$2e2bcd8739ae039, (0, $1iwiL.extend)((0, $f4Y7W.Color), {
    brighter: function(k) {
        k = k == null ? (0, $f4Y7W.brighter) : Math.pow((0, $f4Y7W.brighter), k);
        return new $f420561438b739e5$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? (0, $f4Y7W.darker) : Math.pow((0, $f4Y7W.darker), k);
        return new $f420561438b739e5$export$57ed4bde61a1e2f2(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * (0, $cb01cfca7c53740c$export$8449e153fbd325fc), l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new (0, $f4Y7W.Rgb)(255 * (l + a * ($f420561438b739e5$var$A * cosh + $f420561438b739e5$var$B * sinh)), 255 * (l + a * ($f420561438b739e5$var$C * cosh + $f420561438b739e5$var$D * sinh)), 255 * (l + a * ($f420561438b739e5$var$E * cosh)), this.opacity);
    }
}));




function $e72b049790853cc4$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $f420561438b739e5$export$2e2bcd8739ae039)(start)).h, (end = (0, $f420561438b739e5$export$2e2bcd8739ae039)(end)).h), s = (0, $ef5e504b188371cc$export$2e2bcd8739ae039)(start.s, end.s), l = (0, $ef5e504b188371cc$export$2e2bcd8739ae039)(start.l, end.l), opacity = (0, $ef5e504b188371cc$export$2e2bcd8739ae039)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $e72b049790853cc4$export$2e2bcd8739ae039 = $e72b049790853cc4$var$cubehelix((0, $ef5e504b188371cc$export$97d7b0c7ddb78dcf));
var $e72b049790853cc4$export$934fa09ad474a1b4 = $e72b049790853cc4$var$cubehelix((0, $ef5e504b188371cc$export$2e2bcd8739ae039));


var $a23cc9a70ba6fdc1$export$fc70efcec537be98 = (0, $e72b049790853cc4$export$934fa09ad474a1b4)((0, $f420561438b739e5$export$2e2bcd8739ae039)(-100, 0.75, 0.35), (0, $f420561438b739e5$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $a23cc9a70ba6fdc1$export$c5cedbc1ab3be2c3 = (0, $e72b049790853cc4$export$934fa09ad474a1b4)((0, $f420561438b739e5$export$2e2bcd8739ae039)(260, 0.75, 0.35), (0, $f420561438b739e5$export$2e2bcd8739ae039)(80, 1.50, 0.8));
var $a23cc9a70ba6fdc1$var$c = (0, $f420561438b739e5$export$2e2bcd8739ae039)();
function $a23cc9a70ba6fdc1$export$2e2bcd8739ae039(t) {
    if (t < 0 || t > 1) t -= Math.floor(t);
    var ts = Math.abs(t - 0.5);
    $a23cc9a70ba6fdc1$var$c.h = 360 * t - 100;
    $a23cc9a70ba6fdc1$var$c.s = 1.5 - 1.5 * ts;
    $a23cc9a70ba6fdc1$var$c.l = 0.8 - 0.9 * ts;
    return $a23cc9a70ba6fdc1$var$c + "";
}



var $cb10b1dc3ee7f4d6$export$2e2bcd8739ae039 = (0, $e72b049790853cc4$export$934fa09ad474a1b4)((0, $f420561438b739e5$export$2e2bcd8739ae039)(300, 0.5, 0.0), (0, $f420561438b739e5$export$2e2bcd8739ae039)(-240, 0.5, 1.0));



var $129b5c18f7a8ae7a$export$3005042704f95a69 = new Array(3).concat("e0f3dba8ddb543a2ca", "f0f9e8bae4bc7bccc42b8cbe", "f0f9e8bae4bc7bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac", "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e", "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $129b5c18f7a8ae7a$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($129b5c18f7a8ae7a$export$3005042704f95a69);



var $5712a7d039aa5c8c$export$3005042704f95a69 = new Array(3).concat("e5f5e0a1d99b31a354", "edf8e9bae4b374c476238b45", "edf8e9bae4b374c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47631a354006d2c", "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32", "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $5712a7d039aa5c8c$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($5712a7d039aa5c8c$export$3005042704f95a69);



var $538975531d7fe164$export$3005042704f95a69 = new Array(3).concat("f0f0f0bdbdbd636363", "f7f7f7cccccc969696525252", "f7f7f7cccccc969696636363252525", "f7f7f7d9d9d9bdbdbd969696636363252525", "f7f7f7d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525", "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $538975531d7fe164$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($538975531d7fe164$export$3005042704f95a69);


function $5a16eba5e642ed9e$var$ramp(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}
var $5a16eba5e642ed9e$export$2e2bcd8739ae039 = $5a16eba5e642ed9e$var$ramp((0, $969754e2723a4743$export$2e2bcd8739ae039)("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
var $5a16eba5e642ed9e$export$c41e69203f572e8d = $5a16eba5e642ed9e$var$ramp((0, $969754e2723a4743$export$2e2bcd8739ae039)("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
var $5a16eba5e642ed9e$export$ad0c8285c8ea6dbd = $5a16eba5e642ed9e$var$ramp((0, $969754e2723a4743$export$2e2bcd8739ae039)("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
var $5a16eba5e642ed9e$export$6664860a633d9daf = $5a16eba5e642ed9e$var$ramp((0, $969754e2723a4743$export$2e2bcd8739ae039)("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));



var $7fa6de3aadb892af$export$3005042704f95a69 = new Array(3).concat("fee6cefdae6be6550d", "feeddefdbe85fd8d3cd94701", "feeddefdbe85fd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3ce6550da63603", "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04", "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $7fa6de3aadb892af$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($7fa6de3aadb892af$export$3005042704f95a69);



var $6917e6e2a5a7088c$export$3005042704f95a69 = new Array(3).concat("fee8c8fdbb84e34a33", "fef0d9fdcc8afc8d59d7301f", "fef0d9fdcc8afc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59e34a33b30000", "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000", "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $6917e6e2a5a7088c$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($6917e6e2a5a7088c$export$3005042704f95a69);



var $4a0a1aa2c9e33d36$export$3005042704f95a69 = new Array(3).concat("e9a3c9f7f7f7a1d76a", "d01c8bf1b6dab8e1864dac26", "d01c8bf1b6daf7f7f7b8e1864dac26", "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221", "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221", "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221", "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221", "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419", "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $4a0a1aa2c9e33d36$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($4a0a1aa2c9e33d36$export$3005042704f95a69);



var $f06e3fa878b00054$export$3005042704f95a69 = new Array(3).concat("af8dc3f7f7f77fbf7b", "7b3294c2a5cfa6dba0008837", "7b3294c2a5cff7f7f7a6dba0008837", "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837", "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837", "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837", "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837", "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b", "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $f06e3fa878b00054$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($f06e3fa878b00054$export$3005042704f95a69);



var $b9d08442206bc992$export$3005042704f95a69 = new Array(3).concat("ece7f2a6bddb2b8cbe", "f1eef6bdc9e174a9cf0570b0", "f1eef6bdc9e174a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d", "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b", "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $b9d08442206bc992$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($b9d08442206bc992$export$3005042704f95a69);



var $85d9ddb09589164a$export$3005042704f95a69 = new Array(3).concat("ece2f0a6bddb1c9099", "f6eff7bdc9e167a9cf02818a", "f6eff7bdc9e167a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf1c9099016c59", "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450", "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $85d9ddb09589164a$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($85d9ddb09589164a$export$3005042704f95a69);



var $db9a96c98816e1e1$export$3005042704f95a69 = new Array(3).concat("998ec3f7f7f7f1a340", "5e3c99b2abd2fdb863e66101", "5e3c99b2abd2f7f7f7fdb863e66101", "542788998ec3d8daebfee0b6f1a340b35806", "542788998ec3d8daebf7f7f7fee0b6f1a340b35806", "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806", "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806", "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08", "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $db9a96c98816e1e1$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($db9a96c98816e1e1$export$3005042704f95a69);



var $23ff18ca5e2841c9$export$3005042704f95a69 = new Array(3).concat("e7e1efc994c7dd1c77", "f1eef6d7b5d8df65b0ce1256", "f1eef6d7b5d8df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0dd1c77980043", "f1eef6d4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f", "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $23ff18ca5e2841c9$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($23ff18ca5e2841c9$export$3005042704f95a69);



var $89408989815f99bb$export$3005042704f95a69 = new Array(3).concat("efedf5bcbddc756bb1", "f2f0f7cbc9e29e9ac86a51a3", "f2f0f7cbc9e29e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8756bb154278f", "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486", "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $89408989815f99bb$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($89408989815f99bb$export$3005042704f95a69);



var $80b920bb3bd138ee$export$3005042704f95a69 = new Array(3).concat("ef8a62f7f7f767a9cf", "ca0020f4a58292c5de0571b0", "ca0020f4a582f7f7f792c5de0571b0", "b2182bef8a62fddbc7d1e5f067a9cf2166ac", "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac", "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac", "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac", "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061", "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $80b920bb3bd138ee$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($80b920bb3bd138ee$export$3005042704f95a69);



var $0748c3d6a1d8f5a1$export$3005042704f95a69 = new Array(3).concat("ef8a62ffffff999999", "ca0020f4a582bababa404040", "ca0020f4a582ffffffbababa404040", "b2182bef8a62fddbc7e0e0e09999994d4d4d", "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d", "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d", "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d", "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a", "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $0748c3d6a1d8f5a1$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($0748c3d6a1d8f5a1$export$3005042704f95a69);



var $e53086e466926f17$export$3005042704f95a69 = new Array(3).concat("fde0ddfa9fb5c51b8a", "feebe2fbb4b9f768a1ae017e", "feebe2fbb4b9f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177", "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177", "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $e53086e466926f17$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($e53086e466926f17$export$3005042704f95a69);



var $dc745901f819a395$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91bfdb", "d7191cfdae61abd9e92c7bb6", "d7191cfdae61ffffbfabd9e92c7bb6", "d73027fc8d59fee090e0f3f891bfdb4575b4", "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4", "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4", "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4", "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695", "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $dc745901f819a395$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($dc745901f819a395$export$3005042704f95a69);



var $3954e80259b1086a$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf91cf60", "d7191cfdae61a6d96a1a9641", "d7191cfdae61ffffbfa6d96a1a9641", "d73027fc8d59fee08bd9ef8b91cf601a9850", "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850", "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850", "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850", "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837", "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $3954e80259b1086a$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($3954e80259b1086a$export$3005042704f95a69);



var $cd6af02d2b8fa278$export$3005042704f95a69 = new Array(3).concat("fee0d2fc9272de2d26", "fee5d9fcae91fb6a4acb181d", "fee5d9fcae91fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4ade2d26a50f15", "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d", "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $cd6af02d2b8fa278$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($cd6af02d2b8fa278$export$3005042704f95a69);


var $f4Y7W = parcelRequire("f4Y7W");
var $f8d313dfc649d49f$var$c = (0, $f4Y7W.rgb)(), $f8d313dfc649d49f$var$pi_1_3 = Math.PI / 3, $f8d313dfc649d49f$var$pi_2_3 = Math.PI * 2 / 3;
function $f8d313dfc649d49f$export$2e2bcd8739ae039(t) {
    var x;
    t = (0.5 - t) * Math.PI;
    $f8d313dfc649d49f$var$c.r = 255 * (x = Math.sin(t)) * x;
    $f8d313dfc649d49f$var$c.g = 255 * (x = Math.sin(t + $f8d313dfc649d49f$var$pi_1_3)) * x;
    $f8d313dfc649d49f$var$c.b = 255 * (x = Math.sin(t + $f8d313dfc649d49f$var$pi_2_3)) * x;
    return $f8d313dfc649d49f$var$c + "";
}



var $840a1f4d659e1adf$export$3005042704f95a69 = new Array(3).concat("fc8d59ffffbf99d594", "d7191cfdae61abdda42b83ba", "d7191cfdae61ffffbfabdda42b83ba", "d53e4ffc8d59fee08be6f59899d5943288bd", "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd", "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd", "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd", "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2", "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $840a1f4d659e1adf$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($840a1f4d659e1adf$export$3005042704f95a69);



var $9c18e672d008ef2c$export$3005042704f95a69 = new Array(3).concat("f7fcb9addd8e31a354", "ffffccc2e69978c679238443", "ffffccc2e69978c67931a354006837", "ffffccd9f0a3addd8e78c67931a354006837", "ffffccd9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32", "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $9c18e672d008ef2c$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($9c18e672d008ef2c$export$3005042704f95a69);



var $cb3216358e5f6293$export$3005042704f95a69 = new Array(3).concat("edf8b17fcdbb2c7fb8", "ffffcca1dab441b6c4225ea8", "ffffcca1dab441b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c42c7fb8253494", "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84", "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $cb3216358e5f6293$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($cb3216358e5f6293$export$3005042704f95a69);



var $585775c54f992d79$export$3005042704f95a69 = new Array(3).concat("fff7bcfec44fd95f0e", "ffffd4fed98efe9929cc4c02", "ffffd4fed98efe9929d95f0e993404", "ffffd4fee391fec44ffe9929d95f0e993404", "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04", "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $585775c54f992d79$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($585775c54f992d79$export$3005042704f95a69);



var $72f57c5a39e6e9c4$export$3005042704f95a69 = new Array(3).concat("ffeda0feb24cf03b20", "ffffb2fecc5cfd8d3ce31a1c", "ffffb2fecc5cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cf03b20bd0026", "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026", "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026").map((0, $969754e2723a4743$export$2e2bcd8739ae039));
var $72f57c5a39e6e9c4$export$2e2bcd8739ae039 = (0, $b4dfd6a75d419f03$export$2e2bcd8739ae039)($72f57c5a39e6e9c4$export$3005042704f95a69);


var $91fc4d3b8d970552$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");


var $8f9d266932040a3a$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");


var $5d57b67a6661fdd1$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");


var $4a11a5048e84430a$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");


var $9f44f629df67427a$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");


var $33d34e32ce8d9c70$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");


var $e624048300e1f2c1$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");


var $a50a18047a45604b$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");


var $61fe95369fdf3a6e$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");



var $97fe6e7fd9f82755$exports = {};
var $796570b986222a32$exports = {};






/** Used as the size to enable large array optimizations. */ var $796570b986222a32$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $796570b986222a32$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $713e941379900b72$exports, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $77bc8b86d18dfde8$exports(values, $aaeddef65e996a0f$exports(iteratee));
    if (comparator) {
        includes = $feff66c702fb07d1$exports;
        isCommon = false;
    } else if (values.length >= $796570b986222a32$var$LARGE_ARRAY_SIZE) {
        includes = $5a41fde6b7f933f8$exports;
        isCommon = false;
        values = new $96bfc597cf68cce0$exports(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
$796570b986222a32$exports = $796570b986222a32$var$baseDifference;




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $97fe6e7fd9f82755$var$without = $3a44e1c37a075144$exports(function(array, values) {
    return $918f7153cc6b68ec$exports(array) ? $796570b986222a32$exports(array, values) : [];
});
$97fe6e7fd9f82755$exports = $97fe6e7fd9f82755$var$without;


function $fe02b4b44be9786b$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $fe02b4b44be9786b$export$957f7263e89bedd2(context) {
    this._context = context;
}
$fe02b4b44be9786b$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $fe02b4b44be9786b$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $fe02b4b44be9786b$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $fe02b4b44be9786b$export$2e2bcd8739ae039(context) {
    return new $fe02b4b44be9786b$export$957f7263e89bedd2(context);
}

function $04a83942e8af0236$export$2e2bcd8739ae039() {}



function $73da4f290d3003a2$var$BasisClosed(context) {
    this._context = context;
}
$73da4f290d3003a2$var$BasisClosed.prototype = {
    areaStart: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    areaEnd: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $fe02b4b44be9786b$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $73da4f290d3003a2$export$2e2bcd8739ae039(context) {
    return new $73da4f290d3003a2$var$BasisClosed(context);
}


function $9963d1a3aea513bc$var$BasisOpen(context) {
    this._context = context;
}
$9963d1a3aea513bc$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $fe02b4b44be9786b$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9963d1a3aea513bc$export$2e2bcd8739ae039(context) {
    return new $9963d1a3aea513bc$var$BasisOpen(context);
}


function $d8722c23ec6195b7$var$Bundle(context, beta) {
    this._basis = new (0, $fe02b4b44be9786b$export$957f7263e89bedd2)(context);
    this._beta = beta;
}
$d8722c23ec6195b7$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $d8722c23ec6195b7$export$2e2bcd8739ae039 = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new (0, $fe02b4b44be9786b$export$957f7263e89bedd2)(context) : new $d8722c23ec6195b7$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);


var $50FzM = parcelRequire("50FzM");

var $50FzM = parcelRequire("50FzM");
function $6d6c59bd6cfd4c7c$export$da3940d7e9162858(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$6d6c59bd6cfd4c7c$export$da3940d7e9162858.prototype = {
    areaStart: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    areaEnd: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $50FzM.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $6d6c59bd6cfd4c7c$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $6d6c59bd6cfd4c7c$export$da3940d7e9162858(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $50FzM = parcelRequire("50FzM");
function $d9d12d71d91b9ead$export$cd7d1a617282f2f1(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$d9d12d71d91b9ead$export$cd7d1a617282f2f1.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $50FzM.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $d9d12d71d91b9ead$export$2e2bcd8739ae039 = function custom(tension) {
    function cardinal(context) {
        return new $d9d12d71d91b9ead$export$cd7d1a617282f2f1(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);


var $zZpsM = parcelRequire("zZpsM");


var $zZpsM = parcelRequire("zZpsM");
function $4a7bb6c9a871c7ec$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$4a7bb6c9a871c7ec$var$CatmullRomClosed.prototype = {
    areaStart: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    areaEnd: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $zZpsM.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $4a7bb6c9a871c7ec$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $4a7bb6c9a871c7ec$var$CatmullRomClosed(context, alpha) : new (0, $6d6c59bd6cfd4c7c$export$da3940d7e9162858)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);



var $zZpsM = parcelRequire("zZpsM");
function $ff222ca0bcffc495$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$ff222ca0bcffc495$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $zZpsM.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $ff222ca0bcffc495$export$2e2bcd8739ae039 = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $ff222ca0bcffc495$var$CatmullRomOpen(context, alpha) : new (0, $d9d12d71d91b9ead$export$cd7d1a617282f2f1)(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

function $29637b867fa40047$var$Linear(context) {
    this._context = context;
}
$29637b867fa40047$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $29637b867fa40047$export$2e2bcd8739ae039(context) {
    return new $29637b867fa40047$var$Linear(context);
}


function $dbba7ad96b6c72db$var$LinearClosed(context) {
    this._context = context;
}
$dbba7ad96b6c72db$var$LinearClosed.prototype = {
    areaStart: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    areaEnd: (0, $04a83942e8af0236$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $dbba7ad96b6c72db$export$2e2bcd8739ae039(context) {
    return new $dbba7ad96b6c72db$var$LinearClosed(context);
}

function $e4a0c9c150855704$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $e4a0c9c150855704$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($e4a0c9c150855704$var$sign(s0) + $e4a0c9c150855704$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $e4a0c9c150855704$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $e4a0c9c150855704$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $e4a0c9c150855704$var$MonotoneX(context) {
    this._context = context;
}
$e4a0c9c150855704$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $e4a0c9c150855704$var$point(this, this._t0, $e4a0c9c150855704$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $e4a0c9c150855704$var$point(this, $e4a0c9c150855704$var$slope2(this, t1 = $e4a0c9c150855704$var$slope3(this, x, y)), t1);
                break;
            default:
                $e4a0c9c150855704$var$point(this, this._t0, t1 = $e4a0c9c150855704$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $e4a0c9c150855704$var$MonotoneY(context) {
    this._context = new $e4a0c9c150855704$var$ReflectContext(context);
}
($e4a0c9c150855704$var$MonotoneY.prototype = Object.create($e4a0c9c150855704$var$MonotoneX.prototype)).point = function(x, y) {
    $e4a0c9c150855704$var$MonotoneX.prototype.point.call(this, y, x);
};
function $e4a0c9c150855704$var$ReflectContext(context) {
    this._context = context;
}
$e4a0c9c150855704$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $e4a0c9c150855704$export$99563b5420dbdc55(context) {
    return new $e4a0c9c150855704$var$MonotoneX(context);
}
function $e4a0c9c150855704$export$8b5360456d6bdb88(context) {
    return new $e4a0c9c150855704$var$MonotoneY(context);
}

function $9c3d7a1aa4df4a84$var$Natural(context) {
    this._context = context;
}
$9c3d7a1aa4df4a84$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $9c3d7a1aa4df4a84$var$controlPoints(x), py = $9c3d7a1aa4df4a84$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $9c3d7a1aa4df4a84$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $9c3d7a1aa4df4a84$export$2e2bcd8739ae039(context) {
    return new $9c3d7a1aa4df4a84$var$Natural(context);
}

function $e393b2ff4420df68$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$e393b2ff4420df68$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $e393b2ff4420df68$export$2e2bcd8739ae039(context) {
    return new $e393b2ff4420df68$var$Step(context, 0.5);
}
function $e393b2ff4420df68$export$10eafa5b7478b343(context) {
    return new $e393b2ff4420df68$var$Step(context, 0);
}
function $e393b2ff4420df68$export$793b3db073781cbb(context) {
    return new $e393b2ff4420df68$var$Step(context, 1);
}

function $97ef0146f6a1761b$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

function $6cb4b3cae0648cc2$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $4c856770f96a5fc0$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $6cb4b3cae0648cc2$export$2e2bcd8739ae039)(series, order);
}


function $e55f6fbc0d2809b2$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $6cb4b3cae0648cc2$export$2e2bcd8739ae039)(series, order);
}


function $6b8485d70f5a6e6a$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $6cb4b3cae0648cc2$export$2e2bcd8739ae039)(series, order);
}

function $e765b516aaff54b4$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $3f24cebd610b7fa9$export$2e2bcd8739ae039(series) {
    var sums = series.map($3f24cebd610b7fa9$export$8a63f25cc62965f1);
    return (0, $e765b516aaff54b4$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $3f24cebd610b7fa9$export$8a63f25cc62965f1(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}


function $08a4ceedcd18d452$export$2e2bcd8739ae039(series) {
    return (0, $3f24cebd610b7fa9$export$2e2bcd8739ae039)(series).reverse();
}


function $c2ba3ce6fa2f2809$export$2e2bcd8739ae039(series) {
    var peaks = series.map($c2ba3ce6fa2f2809$var$peak);
    return (0, $e765b516aaff54b4$export$2e2bcd8739ae039)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $c2ba3ce6fa2f2809$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}



function $cee6095964093d01$export$2e2bcd8739ae039(series) {
    var n = series.length, i, j, sums = series.map((0, $3f24cebd610b7fa9$export$8a63f25cc62965f1)), order = (0, $c2ba3ce6fa2f2809$export$2e2bcd8739ae039)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}


function $76f58d82050c9fc4$export$2e2bcd8739ae039(series) {
    return (0, $e765b516aaff54b4$export$2e2bcd8739ae039)(series).reverse();
}



var $7b359ba84e3a6546$var$t0 = new Date, $7b359ba84e3a6546$var$t1 = new Date;
function $7b359ba84e3a6546$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $7b359ba84e3a6546$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $7b359ba84e3a6546$var$t0.setTime(+start), $7b359ba84e3a6546$var$t1.setTime(+end);
            floori($7b359ba84e3a6546$var$t0), floori($7b359ba84e3a6546$var$t1);
            return Math.floor(count($7b359ba84e3a6546$var$t0, $7b359ba84e3a6546$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $502b6a0d50d0ccff$export$79ef0e34099623dc = 1000;
const $502b6a0d50d0ccff$export$683905d551c33fa9 = $502b6a0d50d0ccff$export$79ef0e34099623dc * 60;
const $502b6a0d50d0ccff$export$4157bf0c8e241659 = $502b6a0d50d0ccff$export$683905d551c33fa9 * 60;
const $502b6a0d50d0ccff$export$353686095f4fbf45 = $502b6a0d50d0ccff$export$4157bf0c8e241659 * 24;
const $502b6a0d50d0ccff$export$c241eb88520d5016 = $502b6a0d50d0ccff$export$353686095f4fbf45 * 7;
const $502b6a0d50d0ccff$export$ab95684df7020b26 = $502b6a0d50d0ccff$export$353686095f4fbf45 * 30;
const $502b6a0d50d0ccff$export$61f8ee2d834c6959 = $502b6a0d50d0ccff$export$353686095f4fbf45 * 365;


var $df8d47b2eaa66b7f$var$day = (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $502b6a0d50d0ccff$export$683905d551c33fa9)) / (0, $502b6a0d50d0ccff$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $df8d47b2eaa66b7f$export$2e2bcd8739ae039 = $df8d47b2eaa66b7f$var$day;
var $df8d47b2eaa66b7f$export$3cf5dda4201cc0f2 = $df8d47b2eaa66b7f$var$day.range;



function $543d04f3eda7b5a7$var$weekday(i) {
    return (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $502b6a0d50d0ccff$export$683905d551c33fa9)) / (0, $502b6a0d50d0ccff$export$c241eb88520d5016);
    });
}
var $543d04f3eda7b5a7$export$fb3ee18ed410cc21 = $543d04f3eda7b5a7$var$weekday(0);
var $543d04f3eda7b5a7$export$6416afaab03bc9b8 = $543d04f3eda7b5a7$var$weekday(1);
var $543d04f3eda7b5a7$export$cb8f040f5d17ac7b = $543d04f3eda7b5a7$var$weekday(2);
var $543d04f3eda7b5a7$export$347581849975dfc8 = $543d04f3eda7b5a7$var$weekday(3);
var $543d04f3eda7b5a7$export$2f2b56683a3e5629 = $543d04f3eda7b5a7$var$weekday(4);
var $543d04f3eda7b5a7$export$59b8c2ccd931d806 = $543d04f3eda7b5a7$var$weekday(5);
var $543d04f3eda7b5a7$export$478ceadebff4d377 = $543d04f3eda7b5a7$var$weekday(6);
var $543d04f3eda7b5a7$export$e8daabaa40641211 = $543d04f3eda7b5a7$export$fb3ee18ed410cc21.range;
var $543d04f3eda7b5a7$export$74e5b559c235c00e = $543d04f3eda7b5a7$export$6416afaab03bc9b8.range;
var $543d04f3eda7b5a7$export$e7d6aa4fb107bc56 = $543d04f3eda7b5a7$export$cb8f040f5d17ac7b.range;
var $543d04f3eda7b5a7$export$fcd5880b20bb06a8 = $543d04f3eda7b5a7$export$347581849975dfc8.range;
var $543d04f3eda7b5a7$export$682716b7bbe33641 = $543d04f3eda7b5a7$export$2f2b56683a3e5629.range;
var $543d04f3eda7b5a7$export$482924968ca86084 = $543d04f3eda7b5a7$export$59b8c2ccd931d806.range;
var $543d04f3eda7b5a7$export$7d755172c9cda9d2 = $543d04f3eda7b5a7$export$478ceadebff4d377.range;


var $a4f043cc814c2305$var$year = (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$a4f043cc814c2305$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $a4f043cc814c2305$export$2e2bcd8739ae039 = $a4f043cc814c2305$var$year;
var $a4f043cc814c2305$export$6fda41c7fb23acf9 = $a4f043cc814c2305$var$year.range;



var $d563f39f932e6831$var$utcDay = (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $502b6a0d50d0ccff$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $d563f39f932e6831$export$2e2bcd8739ae039 = $d563f39f932e6831$var$utcDay;
var $d563f39f932e6831$export$d277e198508549a1 = $d563f39f932e6831$var$utcDay.range;



function $74ba25fa6db9dee0$var$utcWeekday(i) {
    return (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $502b6a0d50d0ccff$export$c241eb88520d5016);
    });
}
var $74ba25fa6db9dee0$export$4898b06303a92011 = $74ba25fa6db9dee0$var$utcWeekday(0);
var $74ba25fa6db9dee0$export$9cfc53b9cfafd080 = $74ba25fa6db9dee0$var$utcWeekday(1);
var $74ba25fa6db9dee0$export$2a6d545f77eceb15 = $74ba25fa6db9dee0$var$utcWeekday(2);
var $74ba25fa6db9dee0$export$a5c25d8ed64433c4 = $74ba25fa6db9dee0$var$utcWeekday(3);
var $74ba25fa6db9dee0$export$1db08111baec2f53 = $74ba25fa6db9dee0$var$utcWeekday(4);
var $74ba25fa6db9dee0$export$29265e34dd5921f7 = $74ba25fa6db9dee0$var$utcWeekday(5);
var $74ba25fa6db9dee0$export$85b74dad05049604 = $74ba25fa6db9dee0$var$utcWeekday(6);
var $74ba25fa6db9dee0$export$6f3e1c2b0f7d7880 = $74ba25fa6db9dee0$export$4898b06303a92011.range;
var $74ba25fa6db9dee0$export$1d2d8b858bb366f9 = $74ba25fa6db9dee0$export$9cfc53b9cfafd080.range;
var $74ba25fa6db9dee0$export$1d5f6785fc7f30f8 = $74ba25fa6db9dee0$export$2a6d545f77eceb15.range;
var $74ba25fa6db9dee0$export$7a75faf0e37ef4af = $74ba25fa6db9dee0$export$a5c25d8ed64433c4.range;
var $74ba25fa6db9dee0$export$417eb959611b2f2f = $74ba25fa6db9dee0$export$1db08111baec2f53.range;
var $74ba25fa6db9dee0$export$59d308db7af08c64 = $74ba25fa6db9dee0$export$29265e34dd5921f7.range;
var $74ba25fa6db9dee0$export$a124108a0a7f34c8 = $74ba25fa6db9dee0$export$85b74dad05049604.range;


var $fa014790840a87a6$var$utcYear = (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$fa014790840a87a6$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $7b359ba84e3a6546$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $fa014790840a87a6$export$2e2bcd8739ae039 = $fa014790840a87a6$var$utcYear;
var $fa014790840a87a6$export$3e24d311e17f5802 = $fa014790840a87a6$var$utcYear.range;


function $a30468600ebbc458$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $a30468600ebbc458$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $a30468600ebbc458$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $a30468600ebbc458$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $a30468600ebbc458$var$formatRe(locale_periods), periodLookup = $a30468600ebbc458$var$formatLookup(locale_periods), weekdayRe = $a30468600ebbc458$var$formatRe(locale_weekdays), weekdayLookup = $a30468600ebbc458$var$formatLookup(locale_weekdays), shortWeekdayRe = $a30468600ebbc458$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $a30468600ebbc458$var$formatLookup(locale_shortWeekdays), monthRe = $a30468600ebbc458$var$formatRe(locale_months), monthLookup = $a30468600ebbc458$var$formatLookup(locale_months), shortMonthRe = $a30468600ebbc458$var$formatRe(locale_shortMonths), shortMonthLookup = $a30468600ebbc458$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $a30468600ebbc458$var$formatDayOfMonth,
        "e": $a30468600ebbc458$var$formatDayOfMonth,
        "f": $a30468600ebbc458$var$formatMicroseconds,
        "g": $a30468600ebbc458$var$formatYearISO,
        "G": $a30468600ebbc458$var$formatFullYearISO,
        "H": $a30468600ebbc458$var$formatHour24,
        "I": $a30468600ebbc458$var$formatHour12,
        "j": $a30468600ebbc458$var$formatDayOfYear,
        "L": $a30468600ebbc458$var$formatMilliseconds,
        "m": $a30468600ebbc458$var$formatMonthNumber,
        "M": $a30468600ebbc458$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $a30468600ebbc458$var$formatUnixTimestamp,
        "s": $a30468600ebbc458$var$formatUnixTimestampSeconds,
        "S": $a30468600ebbc458$var$formatSeconds,
        "u": $a30468600ebbc458$var$formatWeekdayNumberMonday,
        "U": $a30468600ebbc458$var$formatWeekNumberSunday,
        "V": $a30468600ebbc458$var$formatWeekNumberISO,
        "w": $a30468600ebbc458$var$formatWeekdayNumberSunday,
        "W": $a30468600ebbc458$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $a30468600ebbc458$var$formatYear,
        "Y": $a30468600ebbc458$var$formatFullYear,
        "Z": $a30468600ebbc458$var$formatZone,
        "%": $a30468600ebbc458$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $a30468600ebbc458$var$formatUTCDayOfMonth,
        "e": $a30468600ebbc458$var$formatUTCDayOfMonth,
        "f": $a30468600ebbc458$var$formatUTCMicroseconds,
        "g": $a30468600ebbc458$var$formatUTCYearISO,
        "G": $a30468600ebbc458$var$formatUTCFullYearISO,
        "H": $a30468600ebbc458$var$formatUTCHour24,
        "I": $a30468600ebbc458$var$formatUTCHour12,
        "j": $a30468600ebbc458$var$formatUTCDayOfYear,
        "L": $a30468600ebbc458$var$formatUTCMilliseconds,
        "m": $a30468600ebbc458$var$formatUTCMonthNumber,
        "M": $a30468600ebbc458$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $a30468600ebbc458$var$formatUnixTimestamp,
        "s": $a30468600ebbc458$var$formatUnixTimestampSeconds,
        "S": $a30468600ebbc458$var$formatUTCSeconds,
        "u": $a30468600ebbc458$var$formatUTCWeekdayNumberMonday,
        "U": $a30468600ebbc458$var$formatUTCWeekNumberSunday,
        "V": $a30468600ebbc458$var$formatUTCWeekNumberISO,
        "w": $a30468600ebbc458$var$formatUTCWeekdayNumberSunday,
        "W": $a30468600ebbc458$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $a30468600ebbc458$var$formatUTCYear,
        "Y": $a30468600ebbc458$var$formatUTCFullYear,
        "Z": $a30468600ebbc458$var$formatUTCZone,
        "%": $a30468600ebbc458$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $a30468600ebbc458$var$parseDayOfMonth,
        "e": $a30468600ebbc458$var$parseDayOfMonth,
        "f": $a30468600ebbc458$var$parseMicroseconds,
        "g": $a30468600ebbc458$var$parseYear,
        "G": $a30468600ebbc458$var$parseFullYear,
        "H": $a30468600ebbc458$var$parseHour24,
        "I": $a30468600ebbc458$var$parseHour24,
        "j": $a30468600ebbc458$var$parseDayOfYear,
        "L": $a30468600ebbc458$var$parseMilliseconds,
        "m": $a30468600ebbc458$var$parseMonthNumber,
        "M": $a30468600ebbc458$var$parseMinutes,
        "p": parsePeriod,
        "q": $a30468600ebbc458$var$parseQuarter,
        "Q": $a30468600ebbc458$var$parseUnixTimestamp,
        "s": $a30468600ebbc458$var$parseUnixTimestampSeconds,
        "S": $a30468600ebbc458$var$parseSeconds,
        "u": $a30468600ebbc458$var$parseWeekdayNumberMonday,
        "U": $a30468600ebbc458$var$parseWeekNumberSunday,
        "V": $a30468600ebbc458$var$parseWeekNumberISO,
        "w": $a30468600ebbc458$var$parseWeekdayNumberSunday,
        "W": $a30468600ebbc458$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $a30468600ebbc458$var$parseYear,
        "Y": $a30468600ebbc458$var$parseFullYear,
        "Z": $a30468600ebbc458$var$parseZone,
        "%": $a30468600ebbc458$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $a30468600ebbc458$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $a30468600ebbc458$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $a30468600ebbc458$var$utcDate($a30468600ebbc458$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $74ba25fa6db9dee0$export$9cfc53b9cfafd080).ceil(week) : (0, $74ba25fa6db9dee0$export$9cfc53b9cfafd080)(week);
                    week = (0, $d563f39f932e6831$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $a30468600ebbc458$var$localDate($a30468600ebbc458$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $543d04f3eda7b5a7$export$6416afaab03bc9b8).ceil(week) : (0, $543d04f3eda7b5a7$export$6416afaab03bc9b8)(week);
                    week = (0, $df8d47b2eaa66b7f$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $a30468600ebbc458$var$utcDate($a30468600ebbc458$var$newDate(d.y, 0, 1)).getUTCDay() : $a30468600ebbc458$var$localDate($a30468600ebbc458$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $a30468600ebbc458$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $a30468600ebbc458$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $a30468600ebbc458$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $a30468600ebbc458$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $a30468600ebbc458$var$numberRe = /^\s*\d+/, $a30468600ebbc458$var$percentRe = /^%/, $a30468600ebbc458$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $a30468600ebbc458$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $a30468600ebbc458$var$requote(s) {
    return s.replace($a30468600ebbc458$var$requoteRe, "\\$&");
}
function $a30468600ebbc458$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($a30468600ebbc458$var$requote).join("|") + ")", "i");
}
function $a30468600ebbc458$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $a30468600ebbc458$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseWeekNumberSunday(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseWeekNumberISO(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseWeekNumberMonday(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseFullYear(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseYear(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseQuarter(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseMonthNumber(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseDayOfMonth(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseDayOfYear(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseHour24(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseMinutes(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseSeconds(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseMilliseconds(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseMicroseconds(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseLiteralPercent(d, string, i) {
    var n = $a30468600ebbc458$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $a30468600ebbc458$var$parseUnixTimestamp(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $a30468600ebbc458$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $a30468600ebbc458$var$formatDayOfMonth(d, p) {
    return $a30468600ebbc458$var$pad(d.getDate(), p, 2);
}
function $a30468600ebbc458$var$formatHour24(d, p) {
    return $a30468600ebbc458$var$pad(d.getHours(), p, 2);
}
function $a30468600ebbc458$var$formatHour12(d, p) {
    return $a30468600ebbc458$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $a30468600ebbc458$var$formatDayOfYear(d, p) {
    return $a30468600ebbc458$var$pad(1 + (0, $df8d47b2eaa66b7f$export$2e2bcd8739ae039).count((0, $a4f043cc814c2305$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $a30468600ebbc458$var$formatMilliseconds(d, p) {
    return $a30468600ebbc458$var$pad(d.getMilliseconds(), p, 3);
}
function $a30468600ebbc458$var$formatMicroseconds(d, p) {
    return $a30468600ebbc458$var$formatMilliseconds(d, p) + "000";
}
function $a30468600ebbc458$var$formatMonthNumber(d, p) {
    return $a30468600ebbc458$var$pad(d.getMonth() + 1, p, 2);
}
function $a30468600ebbc458$var$formatMinutes(d, p) {
    return $a30468600ebbc458$var$pad(d.getMinutes(), p, 2);
}
function $a30468600ebbc458$var$formatSeconds(d, p) {
    return $a30468600ebbc458$var$pad(d.getSeconds(), p, 2);
}
function $a30468600ebbc458$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $a30468600ebbc458$var$formatWeekNumberSunday(d, p) {
    return $a30468600ebbc458$var$pad((0, $543d04f3eda7b5a7$export$fb3ee18ed410cc21).count((0, $a4f043cc814c2305$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $a30468600ebbc458$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $543d04f3eda7b5a7$export$2f2b56683a3e5629)(d) : (0, $543d04f3eda7b5a7$export$2f2b56683a3e5629).ceil(d);
}
function $a30468600ebbc458$var$formatWeekNumberISO(d, p) {
    d = $a30468600ebbc458$var$dISO(d);
    return $a30468600ebbc458$var$pad((0, $543d04f3eda7b5a7$export$2f2b56683a3e5629).count((0, $a4f043cc814c2305$export$2e2bcd8739ae039)(d), d) + ((0, $a4f043cc814c2305$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $a30468600ebbc458$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $a30468600ebbc458$var$formatWeekNumberMonday(d, p) {
    return $a30468600ebbc458$var$pad((0, $543d04f3eda7b5a7$export$6416afaab03bc9b8).count((0, $a4f043cc814c2305$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $a30468600ebbc458$var$formatYear(d, p) {
    return $a30468600ebbc458$var$pad(d.getFullYear() % 100, p, 2);
}
function $a30468600ebbc458$var$formatYearISO(d, p) {
    d = $a30468600ebbc458$var$dISO(d);
    return $a30468600ebbc458$var$pad(d.getFullYear() % 100, p, 2);
}
function $a30468600ebbc458$var$formatFullYear(d, p) {
    return $a30468600ebbc458$var$pad(d.getFullYear() % 10000, p, 4);
}
function $a30468600ebbc458$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $543d04f3eda7b5a7$export$2f2b56683a3e5629)(d) : (0, $543d04f3eda7b5a7$export$2f2b56683a3e5629).ceil(d);
    return $a30468600ebbc458$var$pad(d.getFullYear() % 10000, p, 4);
}
function $a30468600ebbc458$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $a30468600ebbc458$var$pad(z / 60 | 0, "0", 2) + $a30468600ebbc458$var$pad(z % 60, "0", 2);
}
function $a30468600ebbc458$var$formatUTCDayOfMonth(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCDate(), p, 2);
}
function $a30468600ebbc458$var$formatUTCHour24(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCHours(), p, 2);
}
function $a30468600ebbc458$var$formatUTCHour12(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $a30468600ebbc458$var$formatUTCDayOfYear(d, p) {
    return $a30468600ebbc458$var$pad(1 + (0, $d563f39f932e6831$export$2e2bcd8739ae039).count((0, $fa014790840a87a6$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $a30468600ebbc458$var$formatUTCMilliseconds(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $a30468600ebbc458$var$formatUTCMicroseconds(d, p) {
    return $a30468600ebbc458$var$formatUTCMilliseconds(d, p) + "000";
}
function $a30468600ebbc458$var$formatUTCMonthNumber(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $a30468600ebbc458$var$formatUTCMinutes(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCMinutes(), p, 2);
}
function $a30468600ebbc458$var$formatUTCSeconds(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCSeconds(), p, 2);
}
function $a30468600ebbc458$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $a30468600ebbc458$var$formatUTCWeekNumberSunday(d, p) {
    return $a30468600ebbc458$var$pad((0, $74ba25fa6db9dee0$export$4898b06303a92011).count((0, $fa014790840a87a6$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $a30468600ebbc458$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $74ba25fa6db9dee0$export$1db08111baec2f53)(d) : (0, $74ba25fa6db9dee0$export$1db08111baec2f53).ceil(d);
}
function $a30468600ebbc458$var$formatUTCWeekNumberISO(d, p) {
    d = $a30468600ebbc458$var$UTCdISO(d);
    return $a30468600ebbc458$var$pad((0, $74ba25fa6db9dee0$export$1db08111baec2f53).count((0, $fa014790840a87a6$export$2e2bcd8739ae039)(d), d) + ((0, $fa014790840a87a6$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $a30468600ebbc458$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $a30468600ebbc458$var$formatUTCWeekNumberMonday(d, p) {
    return $a30468600ebbc458$var$pad((0, $74ba25fa6db9dee0$export$9cfc53b9cfafd080).count((0, $fa014790840a87a6$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $a30468600ebbc458$var$formatUTCYear(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $a30468600ebbc458$var$formatUTCYearISO(d, p) {
    d = $a30468600ebbc458$var$UTCdISO(d);
    return $a30468600ebbc458$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $a30468600ebbc458$var$formatUTCFullYear(d, p) {
    return $a30468600ebbc458$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $a30468600ebbc458$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $74ba25fa6db9dee0$export$1db08111baec2f53)(d) : (0, $74ba25fa6db9dee0$export$1db08111baec2f53).ceil(d);
    return $a30468600ebbc458$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $a30468600ebbc458$var$formatUTCZone() {
    return "+0000";
}
function $a30468600ebbc458$var$formatLiteralPercent() {
    return "%";
}
function $a30468600ebbc458$var$formatUnixTimestamp(d) {
    return +d;
}
function $a30468600ebbc458$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $ac9d04405cfc6b52$var$locale;
var $ac9d04405cfc6b52$export$94f4d87fad5dcf9a;
var $ac9d04405cfc6b52$export$32b9cd16e1b8c8d2;
var $ac9d04405cfc6b52$export$1a08fe38f63ebbbb;
var $ac9d04405cfc6b52$export$3edae9cf8e233729;
$ac9d04405cfc6b52$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $ac9d04405cfc6b52$export$2e2bcd8739ae039(definition) {
    $ac9d04405cfc6b52$var$locale = (0, $a30468600ebbc458$export$2e2bcd8739ae039)(definition);
    $ac9d04405cfc6b52$export$94f4d87fad5dcf9a = $ac9d04405cfc6b52$var$locale.format;
    $ac9d04405cfc6b52$export$32b9cd16e1b8c8d2 = $ac9d04405cfc6b52$var$locale.parse;
    $ac9d04405cfc6b52$export$1a08fe38f63ebbbb = $ac9d04405cfc6b52$var$locale.utcFormat;
    $ac9d04405cfc6b52$export$3edae9cf8e233729 = $ac9d04405cfc6b52$var$locale.utcParse;
    return $ac9d04405cfc6b52$var$locale;
}



var $4885b46746cf9742$exports = {};
var $8970f122dd6511cc$exports = {};
var $4341b018e88d5698$exports = {};



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4341b018e88d5698$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $033f926066b43cc0$exports(object, path);
        if (predicate(value, path)) $ebb8b30015809e94$exports(result, $2c532cb4a076ff14$exports(path, object), value);
    }
    return result;
}
$4341b018e88d5698$exports = $4341b018e88d5698$var$basePickBy;



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $8970f122dd6511cc$var$basePick(object, paths) {
    return $4341b018e88d5698$exports(object, paths, function(value, path) {
        return $e9c4d69ed8a37c32$exports(object, path);
    });
}
$8970f122dd6511cc$exports = $8970f122dd6511cc$var$basePick;


var $bb049a112b9ea601$exports = {};
var $b7d067f219c83bbc$exports = {};

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $b7d067f219c83bbc$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $b7271d72ee9493d6$exports(array, 1) : [];
}
$b7d067f219c83bbc$exports = $b7d067f219c83bbc$var$flatten;




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $bb049a112b9ea601$var$flatRest(func) {
    return $c3920ceeae3c9c8f$exports($c20bf8b90a90431e$exports(func, undefined, $b7d067f219c83bbc$exports), func + '');
}
$bb049a112b9ea601$exports = $bb049a112b9ea601$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $4885b46746cf9742$var$pick = $bb049a112b9ea601$exports(function(object, paths) {
    return object == null ? {} : $8970f122dd6511cc$exports(object, paths);
});
$4885b46746cf9742$exports = $4885b46746cf9742$var$pick;


var $c717ad574f54a357$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $c717ad574f54a357$var$isEqual(value, other) {
    return $8a270d35cff2ca21$exports(value, other);
}
$c717ad574f54a357$exports = $c717ad574f54a357$var$isEqual;


var $15b6b5b56080a0cd$export$164de7ab8df77ef0 = {
    background: "transparent",
    text: {
        fontFamily: "sans-serif",
        fontSize: 11,
        fill: "#333333",
        outlineWidth: 0,
        outlineColor: "transparent",
        outlineOpacity: 1
    },
    axis: {
        domain: {
            line: {
                stroke: "transparent",
                strokeWidth: 1
            }
        },
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {}
        },
        legend: {
            text: {
                fontSize: 12
            }
        }
    },
    grid: {
        line: {
            stroke: "#dddddd",
            strokeWidth: 1
        }
    },
    legends: {
        hidden: {
            symbol: {
                fill: "#333333",
                opacity: .6
            },
            text: {
                fill: "#333333",
                opacity: .6
            }
        },
        text: {},
        ticks: {
            line: {
                stroke: "#777777",
                strokeWidth: 1
            },
            text: {
                fontSize: 10
            }
        },
        title: {
            text: {}
        }
    },
    labels: {
        text: {}
    },
    markers: {
        lineColor: "#000000",
        lineStrokeWidth: 1,
        text: {}
    },
    dots: {
        text: {}
    },
    tooltip: {
        container: {
            background: "white",
            color: "inherit",
            fontSize: "inherit",
            borderRadius: "2px",
            boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
            padding: "5px 9px"
        },
        basic: {
            whiteSpace: "pre",
            display: "flex",
            alignItems: "center"
        },
        chip: {
            marginRight: 7
        },
        table: {},
        tableCell: {
            padding: "3px 5px"
        },
        tableCellValue: {
            fontWeight: "bold"
        }
    },
    crosshair: {
        line: {
            stroke: "#000000",
            strokeWidth: 1,
            strokeOpacity: .75,
            strokeDasharray: "6 6"
        }
    },
    annotations: {
        text: {
            fontSize: 13,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        link: {
            stroke: "#000000",
            strokeWidth: 1,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        outline: {
            fill: "none",
            stroke: "#000000",
            strokeWidth: 2,
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        },
        symbol: {
            fill: "#000000",
            outlineWidth: 2,
            outlineColor: "#ffffff",
            outlineOpacity: 1
        }
    }
};
function $15b6b5b56080a0cd$var$jr() {
    return $15b6b5b56080a0cd$var$jr = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = arguments[r];
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }
        return e;
    }, $15b6b5b56080a0cd$var$jr.apply(this, arguments);
}
function $15b6b5b56080a0cd$var$Sr(e, r) {
    return $15b6b5b56080a0cd$var$Sr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, r) {
        return e.__proto__ = r, e;
    }, $15b6b5b56080a0cd$var$Sr(e, r);
}
function $15b6b5b56080a0cd$var$Br(e, r) {
    if (null == e) return {};
    var t, n, i = {}, o = Object.keys(e);
    for(n = 0; n < o.length; n++)t = o[n], r.indexOf(t) >= 0 || (i[t] = e[t]);
    return i;
}
var $15b6b5b56080a0cd$var$Gr = [
    "axis.ticks.text",
    "axis.legend.text",
    "legends.title.text",
    "legends.text",
    "legends.ticks.text",
    "legends.title.text",
    "labels.text",
    "dots.text",
    "markers.text",
    "annotations.text"
], $15b6b5b56080a0cd$export$3c296778d829b724 = function(e, r) {
    return $15b6b5b56080a0cd$var$jr({}, r, e);
}, $15b6b5b56080a0cd$export$582fa4e2a9b13dde = function(e, r) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($5e4719d79b0501b4$exports)))({}, e, r);
    return $15b6b5b56080a0cd$var$Gr.forEach(function(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4fc3640d3c2238e3$exports)))(t, e, $15b6b5b56080a0cd$export$3c296778d829b724((0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(t, e), t.text));
    }), t;
}, $15b6b5b56080a0cd$export$1855e60b4fae8997 = (0, $3ZYaX.createContext)(), $15b6b5b56080a0cd$export$465303079ec41f9d = {
    animate: !0,
    config: "default"
}, $15b6b5b56080a0cd$export$e9d875263f86dcb4 = function(e) {
    var t = e.children, n = e.animate, i = void 0 === n || n, o = e.config, l = void 0 === o ? "default" : o, a = (0, $3ZYaX.useMemo)(function() {
        var e = (0, (/*@__PURE__*/$parcel$interopDefault($357bf21b0f7327af$exports)))(l) ? (0, $775dc606f38f6e3f$export$e506a1d27d1eaa20)[l] : l;
        return {
            animate: i,
            config: e
        };
    }, [
        i,
        l
    ]);
    return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$1855e60b4fae8997.Provider, {
        value: a,
        children: t
    });
}, $15b6b5b56080a0cd$export$99a092eaa44be1c8 = {
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf(Object.keys((0, $775dc606f38f6e3f$export$e506a1d27d1eaa20))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
            mass: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            tension: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            friction: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            clamp: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
            precision: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            velocity: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            duration: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            easing: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func
        })
    ])
};
$15b6b5b56080a0cd$export$e9d875263f86dcb4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).node.isRequired,
    animate: $15b6b5b56080a0cd$export$99a092eaa44be1c8.animate,
    config: $15b6b5b56080a0cd$export$99a092eaa44be1c8.motionConfig
};
var $15b6b5b56080a0cd$export$72acc3dc9629d75d = function() {
    return (0, $3ZYaX.useContext)($15b6b5b56080a0cd$export$1855e60b4fae8997);
}, $15b6b5b56080a0cd$export$6b8391a1442f2172 = function(e) {
    var t = $15b6b5b56080a0cd$export$72acc3dc9629d75d(), o = t.animate, l = t.config, a = function(e) {
        var r = (0, $3ZYaX.useRef)();
        return (0, $3ZYaX.useEffect)(function() {
            r.current = e;
        }, [
            e
        ]), r.current;
    }(e), d = (0, $3ZYaX.useMemo)(function() {
        return (0, $ee4f21d867ccc1fa$export$2e2bcd8739ae039)(a, e);
    }, [
        a,
        e
    ]), s = (0, $775dc606f38f6e3f$export$c4af9125706c4d30)({
        from: {
            value: 0
        },
        to: {
            value: 1
        },
        reset: !0,
        config: l,
        immediate: !o
    }).value;
    return (0, $775dc606f38f6e3f$export$2c618a4308a30424)(s, d);
}, $15b6b5b56080a0cd$export$77ddf829b5125d20 = {
    nivo: [
        "#d76445",
        "#f47560",
        "#e8c1a0",
        "#97e3d5",
        "#61cdbb",
        "#00b0a7"
    ],
    BrBG: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $eede694b8fbd97fa$export$3005042704f95a69)),
    PRGn: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $f06e3fa878b00054$export$3005042704f95a69)),
    PiYG: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $4a0a1aa2c9e33d36$export$3005042704f95a69)),
    PuOr: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $db9a96c98816e1e1$export$3005042704f95a69)),
    RdBu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $80b920bb3bd138ee$export$3005042704f95a69)),
    RdGy: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $0748c3d6a1d8f5a1$export$3005042704f95a69)),
    RdYlBu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $dc745901f819a395$export$3005042704f95a69)),
    RdYlGn: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $3954e80259b1086a$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $840a1f4d659e1adf$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $8eac7426bb1c0fbe$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $5712a7d039aa5c8c$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $538975531d7fe164$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $7fa6de3aadb892af$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $89408989815f99bb$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $cd6af02d2b8fa278$export$3005042704f95a69)),
    BuGn: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $fbc38117fdd97bd3$export$3005042704f95a69)),
    BuPu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $dafaca52a0f61b65$export$3005042704f95a69)),
    GnBu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $129b5c18f7a8ae7a$export$3005042704f95a69)),
    OrRd: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $6917e6e2a5a7088c$export$3005042704f95a69)),
    PuBuGn: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $85d9ddb09589164a$export$3005042704f95a69)),
    PuBu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $b9d08442206bc992$export$3005042704f95a69)),
    PuRd: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $23ff18ca5e2841c9$export$3005042704f95a69)),
    RdPu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $e53086e466926f17$export$3005042704f95a69)),
    YlGnBu: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $cb3216358e5f6293$export$3005042704f95a69)),
    YlGn: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $9c18e672d008ef2c$export$3005042704f95a69)),
    YlOrBr: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $585775c54f992d79$export$3005042704f95a69)),
    YlOrRd: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $72f57c5a39e6e9c4$export$3005042704f95a69))
}, $15b6b5b56080a0cd$export$6dc823b35197e3c3 = Object.keys($15b6b5b56080a0cd$export$77ddf829b5125d20), $15b6b5b56080a0cd$export$8d3d36a98ebb26b6 = function(e) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(e)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(e.domain)) throw new Error("Provided colors should be a valid quantize scale providing a 'domain()' function");
        return e;
    }
    if ($15b6b5b56080a0cd$export$77ddf829b5125d20[e]) return (0, $f78bcf83d712ddfc$export$2e2bcd8739ae039)().range($15b6b5b56080a0cd$export$77ddf829b5125d20[e]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($135874bbc3d3a66a$exports)))(e)) return (0, $f78bcf83d712ddfc$export$2e2bcd8739ae039)().range(e);
    throw new Error("Unable to guess quantize color scale from '" + e + "',\nmust be a function or one of:\n'" + $15b6b5b56080a0cd$export$6dc823b35197e3c3.join("', '") + "'");
}, $15b6b5b56080a0cd$var$Kr = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $8f9d266932040a3a$export$2e2bcd8739ae039),
    accent: (0, $91fc4d3b8d970552$export$2e2bcd8739ae039),
    dark2: (0, $5d57b67a6661fdd1$export$2e2bcd8739ae039),
    paired: (0, $4a11a5048e84430a$export$2e2bcd8739ae039),
    pastel1: (0, $9f44f629df67427a$export$2e2bcd8739ae039),
    pastel2: (0, $33d34e32ce8d9c70$export$2e2bcd8739ae039),
    set1: (0, $e624048300e1f2c1$export$2e2bcd8739ae039),
    set2: (0, $a50a18047a45604b$export$2e2bcd8739ae039),
    set3: (0, $61fe95369fdf3a6e$export$2e2bcd8739ae039),
    brown_blueGreen: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $eede694b8fbd97fa$export$3005042704f95a69)),
    purpleRed_green: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $f06e3fa878b00054$export$3005042704f95a69)),
    pink_yellowGreen: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $4a0a1aa2c9e33d36$export$3005042704f95a69)),
    purple_orange: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $db9a96c98816e1e1$export$3005042704f95a69)),
    red_blue: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $80b920bb3bd138ee$export$3005042704f95a69)),
    red_grey: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $0748c3d6a1d8f5a1$export$3005042704f95a69)),
    red_yellow_blue: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $dc745901f819a395$export$3005042704f95a69)),
    red_yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $3954e80259b1086a$export$3005042704f95a69)),
    spectral: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $840a1f4d659e1adf$export$3005042704f95a69)),
    blues: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $8eac7426bb1c0fbe$export$3005042704f95a69)),
    greens: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $5712a7d039aa5c8c$export$3005042704f95a69)),
    greys: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $538975531d7fe164$export$3005042704f95a69)),
    oranges: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $7fa6de3aadb892af$export$3005042704f95a69)),
    purples: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $89408989815f99bb$export$3005042704f95a69)),
    reds: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $cd6af02d2b8fa278$export$3005042704f95a69)),
    blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $fbc38117fdd97bd3$export$3005042704f95a69)),
    blue_purple: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $dafaca52a0f61b65$export$3005042704f95a69)),
    green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $129b5c18f7a8ae7a$export$3005042704f95a69)),
    orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $6917e6e2a5a7088c$export$3005042704f95a69)),
    purple_blue_green: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $85d9ddb09589164a$export$3005042704f95a69)),
    purple_blue: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $b9d08442206bc992$export$3005042704f95a69)),
    purple_red: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $23ff18ca5e2841c9$export$3005042704f95a69)),
    red_purple: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $e53086e466926f17$export$3005042704f95a69)),
    yellow_green_blue: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $cb3216358e5f6293$export$3005042704f95a69)),
    yellow_green: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $9c18e672d008ef2c$export$3005042704f95a69)),
    yellow_orange_brown: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $585775c54f992d79$export$3005042704f95a69)),
    yellow_orange_red: (0, (/*@__PURE__*/$parcel$interopDefault($f971a3288c675058$exports)))((0, $72f57c5a39e6e9c4$export$3005042704f95a69))
}, $15b6b5b56080a0cd$export$b48661626a811234 = [
    "nivo",
    "category10",
    "accent",
    "dark2",
    "paired",
    "pastel1",
    "pastel2",
    "set1",
    "set2",
    "set3",
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red"
], $15b6b5b56080a0cd$export$6638ab0298ebe095 = {
    brown_blueGreen: (0, $eede694b8fbd97fa$export$2e2bcd8739ae039),
    purpleRed_green: (0, $f06e3fa878b00054$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $4a0a1aa2c9e33d36$export$2e2bcd8739ae039),
    purple_orange: (0, $db9a96c98816e1e1$export$2e2bcd8739ae039),
    red_blue: (0, $80b920bb3bd138ee$export$2e2bcd8739ae039),
    red_grey: (0, $0748c3d6a1d8f5a1$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $dc745901f819a395$export$2e2bcd8739ae039),
    red_yellow_green: (0, $3954e80259b1086a$export$2e2bcd8739ae039),
    spectral: (0, $840a1f4d659e1adf$export$2e2bcd8739ae039),
    blues: (0, $8eac7426bb1c0fbe$export$2e2bcd8739ae039),
    greens: (0, $5712a7d039aa5c8c$export$2e2bcd8739ae039),
    greys: (0, $538975531d7fe164$export$2e2bcd8739ae039),
    oranges: (0, $7fa6de3aadb892af$export$2e2bcd8739ae039),
    purples: (0, $89408989815f99bb$export$2e2bcd8739ae039),
    reds: (0, $cd6af02d2b8fa278$export$2e2bcd8739ae039),
    viridis: (0, $5a16eba5e642ed9e$export$2e2bcd8739ae039),
    inferno: (0, $5a16eba5e642ed9e$export$ad0c8285c8ea6dbd),
    magma: (0, $5a16eba5e642ed9e$export$c41e69203f572e8d),
    plasma: (0, $5a16eba5e642ed9e$export$6664860a633d9daf),
    warm: (0, $a23cc9a70ba6fdc1$export$fc70efcec537be98),
    cool: (0, $a23cc9a70ba6fdc1$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $cb10b1dc3ee7f4d6$export$2e2bcd8739ae039),
    blue_green: (0, $fbc38117fdd97bd3$export$2e2bcd8739ae039),
    blue_purple: (0, $dafaca52a0f61b65$export$2e2bcd8739ae039),
    green_blue: (0, $129b5c18f7a8ae7a$export$2e2bcd8739ae039),
    orange_red: (0, $6917e6e2a5a7088c$export$2e2bcd8739ae039),
    purple_blue_green: (0, $85d9ddb09589164a$export$2e2bcd8739ae039),
    purple_blue: (0, $b9d08442206bc992$export$2e2bcd8739ae039),
    purple_red: (0, $23ff18ca5e2841c9$export$2e2bcd8739ae039),
    red_purple: (0, $e53086e466926f17$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $cb3216358e5f6293$export$2e2bcd8739ae039),
    yellow_green: (0, $9c18e672d008ef2c$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $585775c54f992d79$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $72f57c5a39e6e9c4$export$2e2bcd8739ae039),
    rainbow: (0, $a23cc9a70ba6fdc1$export$2e2bcd8739ae039),
    sinebow: (0, $f8d313dfc649d49f$export$2e2bcd8739ae039)
}, $15b6b5b56080a0cd$export$277274330ffd2780 = [
    "brown_blueGreen",
    "purpleRed_green",
    "pink_yellowGreen",
    "purple_orange",
    "red_blue",
    "red_grey",
    "red_yellow_blue",
    "red_yellow_green",
    "spectral",
    "blues",
    "greens",
    "greys",
    "oranges",
    "purples",
    "reds",
    "viridis",
    "inferno",
    "magma",
    "plasma",
    "warm",
    "cool",
    "cubehelixDefault",
    "blue_green",
    "blue_purple",
    "green_blue",
    "orange_red",
    "purple_blue_green",
    "purple_blue",
    "purple_red",
    "red_purple",
    "yellow_green_blue",
    "yellow_green",
    "yellow_orange_brown",
    "yellow_orange_red",
    "rainbow",
    "sinebow"
], $15b6b5b56080a0cd$export$cec134b1a1fa53dd = function() {
    return (0, $089e671e2a2205fb$export$2e2bcd8739ae039)([
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ]);
}, $15b6b5b56080a0cd$export$75f9af112506f7de = function(e, r) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($357bf21b0f7327af$exports)))(e)) {
        var t = $15b6b5b56080a0cd$var$Kr[e];
        if (void 0 !== t) {
            var n = (0, $089e671e2a2205fb$export$2e2bcd8739ae039)(t);
            return n.type = "ordinal", n;
        }
        if (void 0 !== r && 0 === e.indexOf("seq:")) {
            var i = $15b6b5b56080a0cd$export$6638ab0298ebe095[e.slice(4)];
            if (void 0 !== i) {
                var o = (0, $50dd1fa50091df50$export$2e2bcd8739ae039)(i).domain(r.domain());
                return o.type = "sequential", o;
            }
        }
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($135874bbc3d3a66a$exports)))(e)) {
        var l = (0, $089e671e2a2205fb$export$2e2bcd8739ae039)(e);
        return l.type = "ordinal", l;
    }
    return function() {
        return e;
    };
}, $15b6b5b56080a0cd$export$51f2761e5fe5ca10 = (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf($15b6b5b56080a0cd$export$6dc823b35197e3c3),
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string)
]), $15b6b5b56080a0cd$export$3794d272a0540747 = {
    basis: (0, $fe02b4b44be9786b$export$2e2bcd8739ae039),
    basisClosed: (0, $73da4f290d3003a2$export$2e2bcd8739ae039),
    basisOpen: (0, $9963d1a3aea513bc$export$2e2bcd8739ae039),
    bundle: (0, $d8722c23ec6195b7$export$2e2bcd8739ae039),
    cardinal: (0, $50FzM.default),
    cardinalClosed: (0, $6d6c59bd6cfd4c7c$export$2e2bcd8739ae039),
    cardinalOpen: (0, $d9d12d71d91b9ead$export$2e2bcd8739ae039),
    catmullRom: (0, $zZpsM.default),
    catmullRomClosed: (0, $4a7bb6c9a871c7ec$export$2e2bcd8739ae039),
    catmullRomOpen: (0, $ff222ca0bcffc495$export$2e2bcd8739ae039),
    linear: (0, $29637b867fa40047$export$2e2bcd8739ae039),
    linearClosed: (0, $dbba7ad96b6c72db$export$2e2bcd8739ae039),
    monotoneX: (0, $e4a0c9c150855704$export$99563b5420dbdc55),
    monotoneY: (0, $e4a0c9c150855704$export$8b5360456d6bdb88),
    natural: (0, $9c3d7a1aa4df4a84$export$2e2bcd8739ae039),
    step: (0, $e393b2ff4420df68$export$2e2bcd8739ae039),
    stepAfter: (0, $e393b2ff4420df68$export$793b3db073781cbb),
    stepBefore: (0, $e393b2ff4420df68$export$10eafa5b7478b343)
}, $15b6b5b56080a0cd$export$a2965cde22c100c0 = Object.keys($15b6b5b56080a0cd$export$3794d272a0540747), $15b6b5b56080a0cd$export$2a904d581bf09f5e = $15b6b5b56080a0cd$export$a2965cde22c100c0.filter(function(e) {
    return e.endsWith("Closed");
}), $15b6b5b56080a0cd$export$66e85fc6ea12b97e = (0, (/*@__PURE__*/$parcel$interopDefault($97fe6e7fd9f82755$exports)))($15b6b5b56080a0cd$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $15b6b5b56080a0cd$export$6d32fc0bcd3f8555 = (0, (/*@__PURE__*/$parcel$interopDefault($97fe6e7fd9f82755$exports)))($15b6b5b56080a0cd$export$a2965cde22c100c0, "bundle", "basisClosed", "basisOpen", "cardinalClosed", "cardinalOpen", "catmullRomClosed", "catmullRomOpen", "linearClosed"), $15b6b5b56080a0cd$export$99f526a753d63ebe = function(e) {
    if (!$15b6b5b56080a0cd$export$3794d272a0540747[e]) throw new TypeError("'" + e + "', is not a valid curve interpolator identifier.");
    return $15b6b5b56080a0cd$export$3794d272a0540747[e];
}, $15b6b5b56080a0cd$export$9c0ef4eef492d11d = {
    ascending: (0, $3f24cebd610b7fa9$export$2e2bcd8739ae039),
    descending: (0, $08a4ceedcd18d452$export$2e2bcd8739ae039),
    insideOut: (0, $cee6095964093d01$export$2e2bcd8739ae039),
    none: (0, $e765b516aaff54b4$export$2e2bcd8739ae039),
    reverse: (0, $76f58d82050c9fc4$export$2e2bcd8739ae039)
}, $15b6b5b56080a0cd$export$a8ec30103cd71280 = Object.keys($15b6b5b56080a0cd$export$9c0ef4eef492d11d), $15b6b5b56080a0cd$export$1d5443ca84f6d0f0 = function(e) {
    return $15b6b5b56080a0cd$export$9c0ef4eef492d11d[e];
}, $15b6b5b56080a0cd$export$ab3c04d5a3b28998 = {
    expand: (0, $4c856770f96a5fc0$export$2e2bcd8739ae039),
    diverging: (0, $97ef0146f6a1761b$export$2e2bcd8739ae039),
    none: (0, $6cb4b3cae0648cc2$export$2e2bcd8739ae039),
    silhouette: (0, $e55f6fbc0d2809b2$export$2e2bcd8739ae039),
    wiggle: (0, $6b8485d70f5a6e6a$export$2e2bcd8739ae039)
}, $15b6b5b56080a0cd$export$31340e546ce1c184 = Object.keys($15b6b5b56080a0cd$export$ab3c04d5a3b28998), $15b6b5b56080a0cd$export$5c9f4d1b003c0909 = function(e) {
    return $15b6b5b56080a0cd$export$ab3c04d5a3b28998[e];
}, $15b6b5b56080a0cd$export$5d66dd569e74301b = (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
    top: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
    left: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number
}).isRequired, $15b6b5b56080a0cd$export$34f44898ffea24c3 = [
    "normal",
    "multiply",
    "screen",
    "overlay",
    "darken",
    "lighten",
    "color-dodge",
    "color-burn",
    "hard-light",
    "soft-light",
    "difference",
    "exclusion",
    "hue",
    "saturation",
    "color",
    "luminosity"
], $15b6b5b56080a0cd$export$6da2372f044c5e36 = (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf($15b6b5b56080a0cd$export$34f44898ffea24c3), $15b6b5b56080a0cd$export$1db72d8ab19b94d9 = function(e) {
    return (0, $3ZYaX.useMemo)(function() {
        return $15b6b5b56080a0cd$export$99f526a753d63ebe(e);
    }, [
        e
    ]);
}, $15b6b5b56080a0cd$export$2785d5ef2943fe58 = !0, $15b6b5b56080a0cd$export$a4dcb37d1b87cf96 = $15b6b5b56080a0cd$export$cec134b1a1fa53dd, $15b6b5b56080a0cd$export$1570875fb8f3b023 = (0, $089e671e2a2205fb$export$2e2bcd8739ae039)((0, $61fe95369fdf3a6e$export$2e2bcd8739ae039)), $15b6b5b56080a0cd$export$6728fea658cfb92e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $15b6b5b56080a0cd$export$d04af0e501fb729f = function(e, t, n) {
    return void 0 === n && (n = {}), (0, $3ZYaX.useMemo)(function() {
        var r = $15b6b5b56080a0cd$var$jr({}, $15b6b5b56080a0cd$export$6728fea658cfb92e, n);
        return {
            margin: r,
            innerWidth: e - r.left - r.right,
            innerHeight: t - r.top - r.bottom,
            outerWidth: e,
            outerHeight: t
        };
    }, [
        e,
        t,
        n.top,
        n.right,
        n.bottom,
        n.left
    ]);
}, $15b6b5b56080a0cd$export$e295b0c537d32d7d = function() {
    var e = (0, $3ZYaX.useRef)(null), r = (0, $3ZYaX.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0
    }), t = r[0], l = r[1], a = (0, $3ZYaX.useState)(function() {
        return "undefined" == typeof ResizeObserver ? null : new ResizeObserver(function(e) {
            var r = e[0];
            return l(r.contentRect);
        });
    })[0];
    return (0, $3ZYaX.useEffect)(function() {
        return e.current && null !== a && a.observe(e.current), function() {
            null !== a && a.disconnect();
        };
    }, []), [
        e,
        t
    ];
}, $15b6b5b56080a0cd$export$7394831711fe34f = function(e) {
    return (0, $3ZYaX.useMemo)(function() {
        return $15b6b5b56080a0cd$export$582fa4e2a9b13dde($15b6b5b56080a0cd$export$164de7ab8df77ef0, e);
    }, [
        e
    ]);
}, $15b6b5b56080a0cd$export$f037bf6aad5a4e75 = function(e) {
    return "function" == typeof e ? e : "string" == typeof e ? 0 === e.indexOf("time:") ? (0, $ac9d04405cfc6b52$export$94f4d87fad5dcf9a)(e.slice("5")) : (0, $a3518d7e1fb7157d$export$d9468344d3651243)(e) : function(e) {
        return "" + e;
    };
}, $15b6b5b56080a0cd$export$422f9765e6971fdf = function(e) {
    return (0, $3ZYaX.useMemo)(function() {
        return $15b6b5b56080a0cd$export$f037bf6aad5a4e75(e);
    }, [
        e
    ]);
}, $15b6b5b56080a0cd$export$84c6f02482759c25 = (0, $3ZYaX.createContext)(), $15b6b5b56080a0cd$var$Ct = {}, $15b6b5b56080a0cd$export$d8964aec282183a3 = function(e) {
    var r = e.theme, t = void 0 === r ? $15b6b5b56080a0cd$var$Ct : r, n = e.children, i = $15b6b5b56080a0cd$export$7394831711fe34f(t);
    return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$84c6f02482759c25.Provider, {
        value: i,
        children: n
    });
};
$15b6b5b56080a0cd$export$d8964aec282183a3.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).node.isRequired,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object
};
var $15b6b5b56080a0cd$export$93d4e7f90805808f = function() {
    return (0, $3ZYaX.useContext)($15b6b5b56080a0cd$export$84c6f02482759c25);
}, $15b6b5b56080a0cd$var$Tt = [
    "outlineWidth",
    "outlineColor",
    "outlineOpacity"
], $15b6b5b56080a0cd$export$c30625df7c8afdb5 = function(e) {
    return e.outlineWidth, e.outlineColor, e.outlineOpacity, $15b6b5b56080a0cd$var$Br(e, $15b6b5b56080a0cd$var$Tt);
}, $15b6b5b56080a0cd$var$Pt = function(e) {
    var r = e.children, t = e.condition, n = e.wrapper;
    return t ? (0, $3ZYaX.cloneElement)(n, {}, r) : r;
};
$15b6b5b56080a0cd$var$Pt.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).node.isRequired,
    condition: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool.isRequired,
    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).element.isRequired
};
var $15b6b5b56080a0cd$var$jt = {
    position: "relative"
}, $15b6b5b56080a0cd$export$42a852a2b6b56249 = function(e) {
    var r = e.children, t = e.theme, i = e.renderWrapper, o = void 0 === i || i, l = e.isInteractive, a = void 0 === l || l, d = e.animate, s = e.motionConfig, u = (0, $3ZYaX.useRef)(null);
    return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$d8964aec282183a3, {
        theme: t,
        children: (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$e9d875263f86dcb4, {
            animate: d,
            config: s,
            children: (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$f78649fb9ca566b8), {
                container: u,
                children: (0, $4801813bf62cee3c$exports.jsxs)($15b6b5b56080a0cd$var$Pt, {
                    condition: o,
                    wrapper: (0, $4801813bf62cee3c$exports.jsx)("div", {
                        style: $15b6b5b56080a0cd$var$jt,
                        ref: u
                    }),
                    children: [
                        r,
                        a && (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$28c660c63b792dea), {})
                    ]
                })
            })
        })
    });
};
$15b6b5b56080a0cd$export$42a852a2b6b56249.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).element.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
        $15b6b5b56080a0cd$export$99a092eaa44be1c8.motionConfig
    ])
};
var $15b6b5b56080a0cd$export$8793edee2d425525 = function() {}, $15b6b5b56080a0cd$var$Gt = {
    position: "relative"
}, $15b6b5b56080a0cd$export$c2b4ab1564fcaab4 = function(e) {
    var t = e.children, i = e.theme, o = e.isInteractive, l = void 0 === o || o, d = e.renderWrapper, s = void 0 === d || d, u = e.animate, c = e.motionConfig, f = (0, $3ZYaX.useRef)(null), m = (0, $881f54acd386f31e$export$85cc26a2c4544aaa)(f), y = m.actions, v = m.state, _ = (0, $3ZYaX.useCallback)(function(e, r) {
        return y.showTooltipFromEvent(e, r);
    }, [
        y.showTooltipFromEvent
    ]), w = (0, $3ZYaX.useMemo)(function() {
        return {
            showTooltip: l ? _ : $15b6b5b56080a0cd$export$8793edee2d425525,
            hideTooltip: l ? y.hideTooltip : $15b6b5b56080a0cd$export$8793edee2d425525
        };
    }, [
        y.hideTooltip,
        l,
        _
    ]);
    return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$d8964aec282183a3, {
        theme: i,
        children: (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$e9d875263f86dcb4, {
            animate: u,
            config: c,
            children: (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$d344f0e974db1e2e).Provider, {
                value: y,
                children: (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$c7027a64d546bf1d).Provider, {
                    value: v,
                    children: (0, $4801813bf62cee3c$exports.jsxs)($15b6b5b56080a0cd$var$Pt, {
                        condition: s,
                        wrapper: (0, $4801813bf62cee3c$exports.jsx)("div", {
                            style: $15b6b5b56080a0cd$var$Gt,
                            ref: f
                        }),
                        children: [
                            t(w),
                            l && (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$28c660c63b792dea), {})
                        ]
                    })
                })
            })
        })
    });
};
$15b6b5b56080a0cd$export$c2b4ab1564fcaab4.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func.isRequired,
    isInteractive: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    renderWrapper: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    theme: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object.isRequired,
    animate: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool.isRequired,
    motionConfig: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
        $15b6b5b56080a0cd$export$99a092eaa44be1c8.motionConfig
    ])
};
var $15b6b5b56080a0cd$export$fa6e408d6a7d6214 = function(e) {
    var r = e.children, t = $15b6b5b56080a0cd$export$e295b0c537d32d7d(), n = t[0], i = t[1], o = i.width > 0 && i.height > 0;
    return (0, $4801813bf62cee3c$exports.jsx)("div", {
        ref: n,
        style: {
            width: "100%",
            height: "100%"
        },
        children: o && r({
            width: i.width,
            height: i.height
        })
    });
};
$15b6b5b56080a0cd$export$fa6e408d6a7d6214.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func.isRequired
};
var $15b6b5b56080a0cd$var$Yt = [
    "id",
    "colors"
], $15b6b5b56080a0cd$export$39a41c7169757633 = function(e) {
    var r = e.id, t = e.colors, n = $15b6b5b56080a0cd$var$Br(e, $15b6b5b56080a0cd$var$Yt);
    return (0, $4801813bf62cee3c$exports.jsx)("linearGradient", $15b6b5b56080a0cd$var$jr({
        id: r,
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 1
    }, n, {
        children: t.map(function(e) {
            var r = e.offset, t = e.color, n = e.opacity;
            return (0, $4801813bf62cee3c$exports.jsx)("stop", {
                offset: r + "%",
                stopColor: t,
                stopOpacity: void 0 !== n ? n : 1
            }, r);
        })
    }));
};
$15b6b5b56080a0cd$export$39a41c7169757633.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        offset: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
        color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
        opacity: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number
    })).isRequired,
    gradientTransform: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string
};
var $15b6b5b56080a0cd$export$78f14b2164360f92 = function(e, r, t) {
    return void 0 === t && (t = {}), $15b6b5b56080a0cd$var$jr({
        id: e,
        type: "linearGradient",
        colors: r
    }, t);
}, $15b6b5b56080a0cd$export$a3bca081a57901da = {
    linearGradient: $15b6b5b56080a0cd$export$39a41c7169757633
}, $15b6b5b56080a0cd$export$10b6027261f7f537 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $15b6b5b56080a0cd$export$5e799d98c1ab7521 = (0, $3ZYaX.memo)(function(e) {
    var r = e.id, t = e.background, n = void 0 === t ? $15b6b5b56080a0cd$export$10b6027261f7f537.background : t, i = e.color, o = void 0 === i ? $15b6b5b56080a0cd$export$10b6027261f7f537.color : i, l = e.size, a = void 0 === l ? $15b6b5b56080a0cd$export$10b6027261f7f537.size : l, d = e.padding, s = void 0 === d ? $15b6b5b56080a0cd$export$10b6027261f7f537.padding : d, u = e.stagger, c = void 0 === u ? $15b6b5b56080a0cd$export$10b6027261f7f537.stagger : u, f = a + s, p = a / 2, h = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $4801813bf62cee3c$exports.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: f,
                height: f,
                fill: n
            }),
            (0, $4801813bf62cee3c$exports.jsx)("circle", {
                cx: h + p,
                cy: h + p,
                r: p,
                fill: o
            }),
            c && (0, $4801813bf62cee3c$exports.jsx)("circle", {
                cx: 1.5 * s + a + p,
                cy: 1.5 * s + a + p,
                r: p,
                fill: o
            })
        ]
    });
});
$15b6b5b56080a0cd$export$5e799d98c1ab7521.displayName = "PatternDots", $15b6b5b56080a0cd$export$5e799d98c1ab7521.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool.isRequired
};
var $15b6b5b56080a0cd$export$27feaeda534cb3 = function(e, r) {
    return void 0 === r && (r = {}), $15b6b5b56080a0cd$var$jr({
        id: e,
        type: "patternDots"
    }, r);
}, $15b6b5b56080a0cd$export$6eec49b1a6289c4e = 2 * Math.PI, $15b6b5b56080a0cd$export$c9fcf1a7df975d78 = function(e) {
    return e * Math.PI / 180;
}, $15b6b5b56080a0cd$export$c41dd2a8460d3196 = function(e) {
    return 180 * e / Math.PI;
}, $15b6b5b56080a0cd$export$61f3799bad189d2e = function(e) {
    return e.startAngle + (e.endAngle - e.startAngle) / 2;
}, $15b6b5b56080a0cd$export$2e16b01652730550 = function(e, r) {
    return {
        x: Math.cos(e) * r,
        y: Math.sin(e) * r
    };
}, $15b6b5b56080a0cd$export$c2f0a4925e526958 = function(e) {
    var r = e % 360;
    return r < 0 && (r += 360), r;
}, $15b6b5b56080a0cd$export$c2bacc09869b390f = function(e) {
    return e - $15b6b5b56080a0cd$export$6eec49b1a6289c4e * Math.floor((e + Math.PI) / $15b6b5b56080a0cd$export$6eec49b1a6289c4e);
}, $15b6b5b56080a0cd$export$e3df76cf4464bc81 = function(e) {
    return e < 0 ? 360 - -e % 360 : e % 360;
}, $15b6b5b56080a0cd$export$a9f93668da7e35c9 = function(e, r, t) {
    void 0 === t && (t = 360);
    var n = r;
    return Math.abs(r - e) > t && (n = e + (r > e ? t : -t)), [
        e,
        n
    ];
}, $15b6b5b56080a0cd$export$1abb91cfca1e2069 = {
    svg: {
        align: {
            left: "start",
            center: "middle",
            right: "end",
            start: "start",
            middle: "middle",
            end: "end"
        },
        baseline: {
            top: "text-before-edge",
            center: "central",
            bottom: "alphabetic"
        }
    },
    canvas: {
        align: {
            left: "left",
            center: "center",
            right: "right",
            start: "left",
            middle: "center",
            end: "right"
        },
        baseline: {
            top: "top",
            center: "middle",
            bottom: "bottom"
        }
    }
}, $15b6b5b56080a0cd$export$60f5dce4201c524 = function(e, r, t, n) {
    void 0 === n && (n = "svg");
    var i = $15b6b5b56080a0cd$export$1abb91cfca1e2069[n], o = $15b6b5b56080a0cd$export$2e16b01652730550(r - Math.PI / 2, e), l = o.x, a = o.y, d = $15b6b5b56080a0cd$export$c41dd2a8460d3196(r), s = i.align.center, u = i.baseline.bottom;
    return t > 0 ? (s = i.align.right, u = i.baseline.center) : t < 0 && (s = i.align.left, u = i.baseline.center), 0 !== t && d > 180 && (d -= 180, s = s === i.align.right ? i.align.left : i.align.right), {
        x: l,
        y: a,
        rotate: d += t,
        align: s,
        baseline: u
    };
}, $15b6b5b56080a0cd$export$ab8a77d3b63d684d = {
    spacing: 5,
    rotation: 0,
    background: "#000000",
    color: "#ffffff",
    lineWidth: 2
}, $15b6b5b56080a0cd$export$ace8c9d56fb83ed1 = (0, $3ZYaX.memo)(function(e) {
    var r = e.id, t = e.spacing, n = void 0 === t ? $15b6b5b56080a0cd$export$ab8a77d3b63d684d.spacing : t, i = e.rotation, o = void 0 === i ? $15b6b5b56080a0cd$export$ab8a77d3b63d684d.rotation : i, l = e.background, a = void 0 === l ? $15b6b5b56080a0cd$export$ab8a77d3b63d684d.background : l, d = e.color, s = void 0 === d ? $15b6b5b56080a0cd$export$ab8a77d3b63d684d.color : d, u = e.lineWidth, c = void 0 === u ? $15b6b5b56080a0cd$export$ab8a77d3b63d684d.lineWidth : u, f = Math.round(o) % 360, p = Math.abs(n);
    f > 180 ? f -= 360 : f > 90 ? f -= 180 : f < -180 ? f += 360 : f < -90 && (f += 180);
    var h, g = p, b = p;
    return 0 === f ? h = "\n                M 0 0 L " + g + " 0\n                M 0 " + b + " L " + g + " " + b + "\n            " : 90 === f ? h = "\n                M 0 0 L 0 " + b + "\n                M " + g + " 0 L " + g + " " + b + "\n            " : (g = Math.abs(p / Math.sin($15b6b5b56080a0cd$export$c9fcf1a7df975d78(f))), b = p / Math.sin($15b6b5b56080a0cd$export$c9fcf1a7df975d78(90 - f)), h = f > 0 ? "\n                    M 0 " + -b + " L " + 2 * g + " " + b + "\n                    M " + -g + " " + -b + " L " + g + " " + b + "\n                    M " + -g + " 0 L " + g + " " + 2 * b + "\n                " : "\n                    M " + -g + " " + b + " L " + g + " " + -b + "\n                    M " + -g + " " + 2 * b + " L " + 2 * g + " " + -b + "\n                    M 0 " + 2 * b + " L " + 2 * g + " 0\n                "), (0, $4801813bf62cee3c$exports.jsxs)("pattern", {
        id: r,
        width: g,
        height: b,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: g,
                height: b,
                fill: a,
                stroke: "rgba(255, 0, 0, 0.1)",
                strokeWidth: 0
            }),
            (0, $4801813bf62cee3c$exports.jsx)("path", {
                d: h,
                strokeWidth: c,
                stroke: s,
                strokeLinecap: "square"
            })
        ]
    });
});
$15b6b5b56080a0cd$export$ace8c9d56fb83ed1.displayName = "PatternLines", $15b6b5b56080a0cd$export$ace8c9d56fb83ed1.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    spacing: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    rotation: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    lineWidth: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired
};
var $15b6b5b56080a0cd$export$5487da9d0b1282d9 = function(e, r) {
    return void 0 === r && (r = {}), $15b6b5b56080a0cd$var$jr({
        id: e,
        type: "patternLines"
    }, r);
}, $15b6b5b56080a0cd$export$412f5384ba9b0c31 = {
    color: "#000000",
    background: "#ffffff",
    size: 4,
    padding: 4,
    stagger: !1
}, $15b6b5b56080a0cd$export$e9fa09500a728054 = (0, $3ZYaX.memo)(function(e) {
    var r = e.id, t = e.color, n = void 0 === t ? $15b6b5b56080a0cd$export$412f5384ba9b0c31.color : t, i = e.background, o = void 0 === i ? $15b6b5b56080a0cd$export$412f5384ba9b0c31.background : i, l = e.size, a = void 0 === l ? $15b6b5b56080a0cd$export$412f5384ba9b0c31.size : l, d = e.padding, s = void 0 === d ? $15b6b5b56080a0cd$export$412f5384ba9b0c31.padding : d, u = e.stagger, c = void 0 === u ? $15b6b5b56080a0cd$export$412f5384ba9b0c31.stagger : u, f = a + s, p = s / 2;
    return !0 === c && (f = 2 * a + 2 * s), (0, $4801813bf62cee3c$exports.jsxs)("pattern", {
        id: r,
        width: f,
        height: f,
        patternUnits: "userSpaceOnUse",
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: f,
                height: f,
                fill: o
            }),
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                x: p,
                y: p,
                width: a,
                height: a,
                fill: n
            }),
            c && (0, $4801813bf62cee3c$exports.jsx)("rect", {
                x: 1.5 * s + a,
                y: 1.5 * s + a,
                width: a,
                height: a,
                fill: n
            })
        ]
    });
});
$15b6b5b56080a0cd$export$e9fa09500a728054.displayName = "PatternSquares", $15b6b5b56080a0cd$export$e9fa09500a728054.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    background: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    padding: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    stagger: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool.isRequired
};
var $15b6b5b56080a0cd$export$1b1d9cb2f82cf47f = function(e, r) {
    return void 0 === r && (r = {}), $15b6b5b56080a0cd$var$jr({
        id: e,
        type: "patternSquares"
    }, r);
}, $15b6b5b56080a0cd$export$691ec77bd278f3b0 = {
    patternDots: $15b6b5b56080a0cd$export$5e799d98c1ab7521,
    patternLines: $15b6b5b56080a0cd$export$ace8c9d56fb83ed1,
    patternSquares: $15b6b5b56080a0cd$export$e9fa09500a728054
}, $15b6b5b56080a0cd$var$cn = [
    "type"
], $15b6b5b56080a0cd$var$fn = $15b6b5b56080a0cd$var$jr({}, $15b6b5b56080a0cd$export$a3bca081a57901da, $15b6b5b56080a0cd$export$691ec77bd278f3b0), $15b6b5b56080a0cd$var$pn = function(e) {
    var r = e.defs;
    return !r || r.length < 1 ? null : (0, $4801813bf62cee3c$exports.jsx)("defs", {
        "aria-hidden": !0,
        children: r.map(function(e) {
            var r = e.type, t = $15b6b5b56080a0cd$var$Br(e, $15b6b5b56080a0cd$var$cn);
            return $15b6b5b56080a0cd$var$fn[r] ? (0, $3ZYaX.createElement)($15b6b5b56080a0cd$var$fn[r], $15b6b5b56080a0cd$var$jr({
                key: t.id
            }, t)) : null;
        })
    });
};
$15b6b5b56080a0cd$var$pn.propTypes = {
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        type: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf(Object.keys($15b6b5b56080a0cd$var$fn)).isRequired,
        id: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired
    }))
};
var $15b6b5b56080a0cd$export$b2bdceae9588b42d = (0, $3ZYaX.memo)($15b6b5b56080a0cd$var$pn), $15b6b5b56080a0cd$export$21d9f1931ef75b56 = function(e) {
    var r = e.width, t = e.height, n = e.margin, i = e.defs, o = e.children, l = e.role, a = e.ariaLabel, d = e.ariaLabelledBy, s = e.ariaDescribedBy, u = e.isFocusable, c = $15b6b5b56080a0cd$export$93d4e7f90805808f();
    return (0, $4801813bf62cee3c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: r,
        height: t,
        role: l,
        "aria-label": a,
        "aria-labelledby": d,
        "aria-describedby": s,
        focusable: u,
        tabIndex: u ? 0 : void 0,
        children: [
            (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$b2bdceae9588b42d, {
                defs: i
            }),
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: r,
                height: t,
                fill: c.background
            }),
            (0, $4801813bf62cee3c$exports.jsx)("g", {
                transform: "translate(" + n.left + "," + n.top + ")",
                children: o
            })
        ]
    });
};
$15b6b5b56080a0cd$export$21d9f1931ef75b56.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    margin: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        top: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
        left: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired
    }).isRequired,
    defs: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).node
    ]).isRequired,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    isFocusable: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).bool,
    ariaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    ariaLabelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    ariaDescribedBy: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string
};
var $15b6b5b56080a0cd$var$bn = function(e) {
    var r = e.size, t = e.color, n = e.borderWidth, i = e.borderColor;
    return (0, $4801813bf62cee3c$exports.jsx)("circle", {
        r: r / 2,
        fill: t,
        stroke: i,
        strokeWidth: n,
        style: {
            pointerEvents: "none"
        }
    });
};
$15b6b5b56080a0cd$var$bn.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired
};
var $15b6b5b56080a0cd$var$mn = (0, $3ZYaX.memo)($15b6b5b56080a0cd$var$bn), $15b6b5b56080a0cd$var$yn = function(e) {
    var r = e.x, t = e.y, n = e.symbol, i = void 0 === n ? $15b6b5b56080a0cd$var$mn : n, o = e.size, l = e.datum, a = e.color, d = e.borderWidth, u = e.borderColor, c = e.label, f = e.labelTextAnchor, p = void 0 === f ? "middle" : f, h = e.labelYOffset, g = void 0 === h ? -12 : h, b = $15b6b5b56080a0cd$export$93d4e7f90805808f(), m = $15b6b5b56080a0cd$export$72acc3dc9629d75d(), y = m.animate, v = m.config, _ = (0, $775dc606f38f6e3f$export$c4af9125706c4d30)({
        transform: "translate(" + r + ", " + t + ")",
        config: v,
        immediate: !y
    });
    return (0, $4801813bf62cee3c$exports.jsxs)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).g, {
        transform: _.transform,
        style: {
            pointerEvents: "none"
        },
        children: [
            (0, $3ZYaX.createElement)(i, {
                size: o,
                color: a,
                datum: l,
                borderWidth: d,
                borderColor: u
            }),
            c && (0, $4801813bf62cee3c$exports.jsx)("text", {
                textAnchor: p,
                y: g,
                style: $15b6b5b56080a0cd$export$c30625df7c8afdb5(b.dots.text),
                children: c
            })
        ]
    });
};
$15b6b5b56080a0cd$var$yn.propTypes = {
    x: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    y: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    datum: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object.isRequired,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    borderWidth: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
    symbol: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object
    ]),
    label: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number
    ]),
    labelTextAnchor: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        "start",
        "middle",
        "end"
    ]),
    labelYOffset: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number
};
var $15b6b5b56080a0cd$export$ca30f0ad55489a87 = (0, $3ZYaX.memo)($15b6b5b56080a0cd$var$yn), $15b6b5b56080a0cd$var$_n = function(e) {
    var r = e.width, t = e.height, n = e.axis, i = e.scale, o = e.value, l = e.lineStyle, a = e.textStyle, d = e.legend, s = e.legendNode, u = e.legendPosition, c = void 0 === u ? "top-right" : u, f = e.legendOffsetX, p = void 0 === f ? 14 : f, h = e.legendOffsetY, g = void 0 === h ? 14 : h, b = e.legendOrientation, m = void 0 === b ? "horizontal" : b, y = $15b6b5b56080a0cd$export$93d4e7f90805808f(), v = 0, _ = 0, w = 0, k = 0;
    if ("y" === n ? (w = i(o), _ = r) : (v = i(o), k = t), d && !s) {
        var R = function(e) {
            var r = e.axis, t = e.width, n = e.height, i = e.position, o = e.offsetX, l = e.offsetY, a = e.orientation, d = 0, s = 0, u = "vertical" === a ? -90 : 0, c = "start";
            if ("x" === r) switch(i){
                case "top-left":
                    d = -o, s = l, c = "end";
                    break;
                case "top":
                    s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "right":
                    d = o, s = n / 2, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = o, s = n - l, c = "start";
                    break;
                case "bottom":
                    s = n + l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    s = n - l, d = -o, c = "horizontal" === a ? "end" : "start";
                    break;
                case "left":
                    d = -o, s = n / 2, c = "horizontal" === a ? "end" : "middle";
            }
            else switch(i){
                case "top-left":
                    d = o, s = -l, c = "start";
                    break;
                case "top":
                    d = t / 2, s = -l, c = "horizontal" === a ? "middle" : "start";
                    break;
                case "top-right":
                    d = t - o, s = -l, c = "horizontal" === a ? "end" : "start";
                    break;
                case "right":
                    d = t + o, c = "horizontal" === a ? "start" : "middle";
                    break;
                case "bottom-right":
                    d = t - o, s = l, c = "end";
                    break;
                case "bottom":
                    d = t / 2, s = l, c = "horizontal" === a ? "middle" : "end";
                    break;
                case "bottom-left":
                    d = o, s = l, c = "horizontal" === a ? "start" : "end";
                    break;
                case "left":
                    d = -o, c = "horizontal" === a ? "end" : "middle";
            }
            return {
                x: d,
                y: s,
                rotation: u,
                textAnchor: c
            };
        }({
            axis: n,
            width: r,
            height: t,
            position: c,
            offsetX: p,
            offsetY: g,
            orientation: m
        });
        s = (0, $4801813bf62cee3c$exports.jsx)("text", {
            transform: "translate(" + R.x + ", " + R.y + ") rotate(" + R.rotation + ")",
            textAnchor: R.textAnchor,
            dominantBaseline: "central",
            style: a,
            children: d
        });
    }
    return (0, $4801813bf62cee3c$exports.jsxs)("g", {
        transform: "translate(" + v + ", " + w + ")",
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("line", {
                x1: 0,
                x2: _,
                y1: 0,
                y2: k,
                stroke: y.markers.lineColor,
                strokeWidth: y.markers.lineStrokeWidth,
                style: l
            }),
            s
        ]
    });
};
$15b6b5b56080a0cd$var$_n.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    axis: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        "x",
        "y"
    ]).isRequired,
    scale: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).instanceOf(Date)
    ]).isRequired,
    lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
    textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
    legend: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    legendPosition: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        "top-left",
        "top",
        "top-right",
        "right",
        "bottom-right",
        "bottom",
        "bottom-left",
        "left"
    ]),
    legendOffsetX: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    legendOffsetY: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    legendOrientation: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
        "horizontal",
        "vertical"
    ]).isRequired
};
var $15b6b5b56080a0cd$export$2b29c35b9bad49e4 = (0, $3ZYaX.memo)($15b6b5b56080a0cd$var$_n), $15b6b5b56080a0cd$var$kn = function(e) {
    var r = e.markers, t = e.width, n = e.height, i = e.xScale, o = e.yScale;
    return r && 0 !== r.length ? r.map(function(e, r) {
        return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$2b29c35b9bad49e4, $15b6b5b56080a0cd$var$jr({}, e, {
            width: t,
            height: n,
            scale: "y" === e.axis ? o : i
        }), r);
    }) : null;
};
$15b6b5b56080a0cd$var$kn.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number.isRequired,
    xScale: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func.isRequired,
    yScale: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func.isRequired,
    markers: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        axis: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOf([
            "x",
            "y"
        ]).isRequired,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).instanceOf(Date)
        ]).isRequired,
        lineStyle: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object,
        textStyle: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).object
    }))
};
var $15b6b5b56080a0cd$export$81759e11f9e58ea4 = (0, $3ZYaX.memo)($15b6b5b56080a0cd$var$kn), $15b6b5b56080a0cd$var$xn = [
    "theme",
    "renderWrapper",
    "animate",
    "motionConfig"
], $15b6b5b56080a0cd$export$4cbbe0314aa930ae = function(e) {
    return function(r) {
        var t, n;
        function i() {
            return r.apply(this, arguments) || this;
        }
        return n = r, (t = i).prototype = Object.create(n.prototype), t.prototype.constructor = t, $15b6b5b56080a0cd$var$Sr(t, n), i.prototype.render = function() {
            var r = this.props, t = r.theme, n = r.renderWrapper, i = r.animate, o = r.motionConfig, l = $15b6b5b56080a0cd$var$Br(r, $15b6b5b56080a0cd$var$xn);
            return (0, $4801813bf62cee3c$exports.jsx)($15b6b5b56080a0cd$export$42a852a2b6b56249, {
                theme: t,
                renderWrapper: n,
                isInteractive: l.isInteractive,
                animate: i,
                motionConfig: o,
                children: (0, $4801813bf62cee3c$exports.jsx)(e, $15b6b5b56080a0cd$var$jr({}, l))
            });
        }, i;
    }((0, $3ZYaX.Component));
}, $15b6b5b56080a0cd$export$192dc59ac6f86c95 = function(e, r) {
    var t, n = (0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, e);
    };
    return r && (t = (0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(r) ? r : (0, $a3518d7e1fb7157d$export$d9468344d3651243)(r)), t ? function(e) {
        return t(n(e));
    } : n;
}, $15b6b5b56080a0cd$export$3cc9373c3cf93eff = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(e) ? e : function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, e);
    };
}, $15b6b5b56080a0cd$export$2d590546cbb7e3ad = function(e) {
    return (0, $3ZYaX.useMemo)(function() {
        return $15b6b5b56080a0cd$export$3cc9373c3cf93eff(e);
    }, [
        e
    ]);
}, $15b6b5b56080a0cd$export$605481d5cadc9728 = [
    "center",
    "top-left",
    "top",
    "top-right",
    "right",
    "bottom-right",
    "bottom",
    "bottom-left",
    "left"
], $15b6b5b56080a0cd$export$d3a11e7b798643fd = function(e, r, t) {
    var n = r.width - e.width, i = r.height - e.height, o = 0, l = 0;
    return "center" === t && (o = n / 2, l = i / 2), "top" === t && (o = n / 2), "top-right" === t && (o = n), "right" === t && (o = n, l = i / 2), "bottom-right" === t && (o = n, l = i), "bottom" === t && (o = n / 2, l = i), "bottom-left" === t && (l = i), "left" === t && (l = i / 2), [
        o,
        l
    ];
}, $15b6b5b56080a0cd$export$79376507b09a66f = function(e, r, t, n) {
    var i = t - e, o = n - r;
    return i *= i, o *= o, Math.sqrt(i + o);
}, $15b6b5b56080a0cd$export$b363da9ded343252 = function(e, r, t, n) {
    var i = Math.atan2(n - r, t - e) - Math.PI / 2;
    return i > 0 ? i : 2 * Math.PI + i;
}, $15b6b5b56080a0cd$export$be302859f014f482 = function(e, r, t, n, i, o) {
    return e <= i && i <= e + t && r <= o && o <= r + n;
}, $15b6b5b56080a0cd$export$2396fb9a7906fd81 = function(e, r) {
    var t, n = "touches" in r ? r.touches[0] : r, i = n.clientX, o = n.clientY, l = e.getBoundingClientRect(), a = (t = void 0 !== e.getBBox ? e.getBBox() : {
        width: e.offsetWidth || 0,
        height: e.offsetHeight || 0
    }).width === l.width ? 1 : t.width / l.width;
    return [
        (i - l.left) * a,
        (o - l.top) * a
    ];
}, $15b6b5b56080a0cd$var$Bn = Object.keys($15b6b5b56080a0cd$export$a3bca081a57901da), $15b6b5b56080a0cd$var$Gn = Object.keys($15b6b5b56080a0cd$export$691ec77bd278f3b0), $15b6b5b56080a0cd$export$468af463e7cc9c6f = function(e, r, t) {
    if ("*" === e) return !0;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($08f69a989e3c33aa$exports)))(e)) return e(r);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7df273079235e60a$exports)))(e)) {
        var n = t ? (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, t) : r;
        return (0, (/*@__PURE__*/$parcel$interopDefault($c717ad574f54a357$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4885b46746cf9742$exports)))(n, Object.keys(e)), e);
    }
    return !1;
}, $15b6b5b56080a0cd$export$dc35cf769e3afe34 = function(e, r, t, n) {
    var i = void 0 === n ? {} : n, o = i.dataKey, l = i.colorKey, a = void 0 === l ? "color" : l, d = i.targetKey, s = void 0 === d ? "fill" : d, u = [], c = {};
    return e.length && r.length && (u = [].concat(e), r.forEach(function(r) {
        for(var n = function() {
            var n = t[i], l = n.id, d = n.match;
            if ($15b6b5b56080a0cd$export$468af463e7cc9c6f(d, r, o)) {
                var f = e.find(function(e) {
                    return e.id === l;
                });
                if (f) {
                    if ($15b6b5b56080a0cd$var$Gn.includes(f.type)) {
                        if ("inherit" === f.background || "inherit" === f.color) {
                            var p = (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, a), h = f.background, g = f.color, b = l;
                            "inherit" === f.background && (b = b + ".bg." + p, h = p), "inherit" === f.color && (b = b + ".fg." + p, g = p), (0, (/*@__PURE__*/$parcel$interopDefault($4fc3640d3c2238e3$exports)))(r, s, "url(#" + b + ")"), c[b] || (u.push($15b6b5b56080a0cd$var$jr({}, f, {
                                id: b,
                                background: h,
                                color: g
                            })), c[b] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($4fc3640d3c2238e3$exports)))(r, s, "url(#" + l + ")");
                    } else if ($15b6b5b56080a0cd$var$Bn.includes(f.type)) {
                        if (f.colors.map(function(e) {
                            return e.color;
                        }).includes("inherit")) {
                            var m = (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, a), _ = l, w = $15b6b5b56080a0cd$var$jr({}, f, {
                                colors: f.colors.map(function(e, r) {
                                    return "inherit" !== e.color ? e : (_ = _ + "." + r + "." + m, $15b6b5b56080a0cd$var$jr({}, e, {
                                        color: "inherit" === e.color ? m : e.color
                                    }));
                                })
                            });
                            w.id = _, (0, (/*@__PURE__*/$parcel$interopDefault($4fc3640d3c2238e3$exports)))(r, s, "url(#" + _ + ")"), c[_] || (u.push(w), c[_] = 1);
                        } else (0, (/*@__PURE__*/$parcel$interopDefault($4fc3640d3c2238e3$exports)))(r, s, "url(#" + l + ")");
                    }
                }
                return "break";
            }
        }, i = 0; i < t.length; i++){
            if ("break" === n()) break;
        }
    })), u;
};






var $3ZYaX = parcelRequire("3ZYaX");
function $e379559b5ad1ab56$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", " + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", " + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67))))))) + ")";
}

function $62b7c488ec4e3342$export$2e2bcd8739ae039(t) {
    t = Math.max(0, Math.min(1, t));
    return "rgb(" + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", " + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", " + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66))))))) + ")";
}


var $570e3d76233b2a4f$export$2e2bcd8739ae039 = (0, $969754e2723a4743$export$2e2bcd8739ae039)("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");



var $3ZYaX = parcelRequire("3ZYaX");



var $81X7f = parcelRequire("81X7f");

var $9C0qR = parcelRequire("9C0qR");

var $f4Y7W = parcelRequire("f4Y7W");


function $37dfb133b3f78f9c$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $37dfb133b3f78f9c$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $29efe7775b4434f7$export$2e2bcd8739ae039(a, b) {
    return ((0, $37dfb133b3f78f9c$export$5cd576d1827d40c8)(b) ? (0, $37dfb133b3f78f9c$export$2e2bcd8739ae039) : $29efe7775b4434f7$export$15d09067c6a5ee49)(a, b);
}
function $29efe7775b4434f7$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $927ebd1811035250$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $5028917d0d2b0bdc$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $7872d4c3789d5642$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $6438ca4cf54726d3$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $927ebd1811035250$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $b145a0ea118b6a81$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $b145a0ea118b6a81$var$reB = new RegExp($b145a0ea118b6a81$var$reA.source, "g");
function $b145a0ea118b6a81$var$zero(b) {
    return function() {
        return b;
    };
}
function $b145a0ea118b6a81$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $b145a0ea118b6a81$export$2e2bcd8739ae039(a, b) {
    var bi = $b145a0ea118b6a81$var$reA.lastIndex = $b145a0ea118b6a81$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $b145a0ea118b6a81$var$reA.exec(a)) && (bm = $b145a0ea118b6a81$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $7872d4c3789d5642$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $b145a0ea118b6a81$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $b145a0ea118b6a81$var$one(q[0].x) : $b145a0ea118b6a81$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $927ebd1811035250$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $38f7fbbba02c20c1$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $7872d4c3789d5642$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $f4Y7W.default)(b)) ? (b = c, $f39bcde308170c65$export$2e2bcd8739ae039) : (0, $b145a0ea118b6a81$export$2e2bcd8739ae039) : b instanceof (0, $f4Y7W.default) ? (0, $f39bcde308170c65$export$2e2bcd8739ae039) : b instanceof Date ? (0, $5028917d0d2b0bdc$export$2e2bcd8739ae039) : (0, $37dfb133b3f78f9c$export$5cd576d1827d40c8)(b) ? (0, $37dfb133b3f78f9c$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $29efe7775b4434f7$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $6438ca4cf54726d3$export$2e2bcd8739ae039) : (0, $7872d4c3789d5642$export$2e2bcd8739ae039))(a, b);
}

function $2936309b90bf2fa2$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $392bfbb4bd950e49$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $927ebd1811035250$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}




function $571e040330f9001a$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $38bb5952b49f4d64$export$2e2bcd8739ae039(x) {
    return +x;
}


var $7d2a4da1ea1975ee$var$unit = [
    0,
    1
];
function $7d2a4da1ea1975ee$export$f0954fd7d5368655(x) {
    return x;
}
function $7d2a4da1ea1975ee$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $571e040330f9001a$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $7d2a4da1ea1975ee$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $7d2a4da1ea1975ee$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $7d2a4da1ea1975ee$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $7d2a4da1ea1975ee$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $7d2a4da1ea1975ee$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $7d2a4da1ea1975ee$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $5529c8c181db0546$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $7d2a4da1ea1975ee$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $7d2a4da1ea1975ee$export$6b468dcfb64c653c() {
    var domain = $7d2a4da1ea1975ee$var$unit, range = $7d2a4da1ea1975ee$var$unit, interpolate = (0, $927ebd1811035250$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $7d2a4da1ea1975ee$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $7d2a4da1ea1975ee$export$f0954fd7d5368655) clamp = $7d2a4da1ea1975ee$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $7d2a4da1ea1975ee$var$polymap : $7d2a4da1ea1975ee$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $7872d4c3789d5642$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $38bb5952b49f4d64$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $2936309b90bf2fa2$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $7d2a4da1ea1975ee$export$f0954fd7d5368655, rescale()) : clamp !== $7d2a4da1ea1975ee$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $7d2a4da1ea1975ee$export$2e2bcd8739ae039() {
    return $7d2a4da1ea1975ee$export$6b468dcfb64c653c()($7d2a4da1ea1975ee$export$f0954fd7d5368655, $7d2a4da1ea1975ee$export$f0954fd7d5368655);
}


function $bf90a744ea7f11d7$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $bf90a744ea7f11d7$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}






function $0a9d9949eed6ac4f$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $0a9d9949eed6ac4f$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $3b53aa10caa667a1$export$2e2bcd8739ae039(x) {
    return x = (0, $0a9d9949eed6ac4f$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $0eaf788be3f2f279$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $ffca598bbb084377$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $4e65bfc12433d4f2$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $4e65bfc12433d4f2$export$2e2bcd8739ae039(specifier) {
    if (!(match = $4e65bfc12433d4f2$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $4e65bfc12433d4f2$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$4e65bfc12433d4f2$export$2e2bcd8739ae039.prototype = $4e65bfc12433d4f2$export$963aac351db36ed4.prototype; // instanceof
function $4e65bfc12433d4f2$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$4e65bfc12433d4f2$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $7041456702aa5bbf$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $39a62d9f0b20f852$export$6863724d9a42263;
function $39a62d9f0b20f852$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0a9d9949eed6ac4f$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($39a62d9f0b20f852$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $0a9d9949eed6ac4f$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $ec5539e097eb8cd3$export$2e2bcd8739ae039(x, p) {
    var d = (0, $0a9d9949eed6ac4f$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $827f848b955edbf2$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $0a9d9949eed6ac4f$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $ec5539e097eb8cd3$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $ec5539e097eb8cd3$export$2e2bcd8739ae039),
    "s": (0, $39a62d9f0b20f852$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $04d18682be73b612$export$2e2bcd8739ae039(x) {
    return x;
}


var $3cc674c29a9460c5$var$map = Array.prototype.map, $3cc674c29a9460c5$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $3cc674c29a9460c5$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $04d18682be73b612$export$2e2bcd8739ae039) : (0, $0eaf788be3f2f279$export$2e2bcd8739ae039)($3cc674c29a9460c5$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $04d18682be73b612$export$2e2bcd8739ae039) : (0, $ffca598bbb084377$export$2e2bcd8739ae039)($3cc674c29a9460c5$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $4e65bfc12433d4f2$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $827f848b955edbf2$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $827f848b955edbf2$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $7041456702aa5bbf$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $3cc674c29a9460c5$var$prefixes[8 + (0, $39a62d9f0b20f852$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $4e65bfc12433d4f2$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $3cc674c29a9460c5$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $6e6e94f7d2536c6c$var$locale;
var $6e6e94f7d2536c6c$export$d9468344d3651243;
var $6e6e94f7d2536c6c$export$8d85692a469dde6f;
$6e6e94f7d2536c6c$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $6e6e94f7d2536c6c$export$2e2bcd8739ae039(definition) {
    $6e6e94f7d2536c6c$var$locale = (0, $3cc674c29a9460c5$export$2e2bcd8739ae039)(definition);
    $6e6e94f7d2536c6c$export$d9468344d3651243 = $6e6e94f7d2536c6c$var$locale.format;
    $6e6e94f7d2536c6c$export$8d85692a469dde6f = $6e6e94f7d2536c6c$var$locale.formatPrefix;
    return $6e6e94f7d2536c6c$var$locale;
}


function $1751f3d94e8875e5$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $34cd9214f940bfb1$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $00607fd966a341e7$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(max) - (0, $3b53aa10caa667a1$export$2e2bcd8739ae039)(step)) + 1;
}


function $148f4d2b72f92264$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $c3c5d4ea02a79cf4$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $4e65bfc12433d4f2$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $34cd9214f940bfb1$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $6e6e94f7d2536c6c$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $00607fd966a341e7$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $1751f3d94e8875e5$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $6e6e94f7d2536c6c$export$d9468344d3651243)(specifier);
}


function $294706b466fe183e$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $148f4d2b72f92264$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $c3c5d4ea02a79cf4$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $294706b466fe183e$export$2e2bcd8739ae039() {
    var scale = (0, $7d2a4da1ea1975ee$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $7d2a4da1ea1975ee$export$784d13d8ee351f07)(scale, $294706b466fe183e$export$2e2bcd8739ae039());
    };
    (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $294706b466fe183e$export$16a5d4b4a61a274d(scale);
}




function $1ae9cef0e7f58cad$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $e116ca9fa91a3a6f$var$transformLog(x) {
    return Math.log(x);
}
function $e116ca9fa91a3a6f$var$transformExp(x) {
    return Math.exp(x);
}
function $e116ca9fa91a3a6f$var$transformLogn(x) {
    return -Math.log(-x);
}
function $e116ca9fa91a3a6f$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $e116ca9fa91a3a6f$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $e116ca9fa91a3a6f$var$powp(base) {
    return base === 10 ? $e116ca9fa91a3a6f$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $e116ca9fa91a3a6f$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $e116ca9fa91a3a6f$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $e116ca9fa91a3a6f$export$860836db074028f0(transform) {
    const scale = transform($e116ca9fa91a3a6f$var$transformLog, $e116ca9fa91a3a6f$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $e116ca9fa91a3a6f$var$logp(base), pows = $e116ca9fa91a3a6f$var$powp(base);
        if (domain()[0] < 0) {
            logs = $e116ca9fa91a3a6f$var$reflect(logs), pows = $e116ca9fa91a3a6f$var$reflect(pows);
            transform($e116ca9fa91a3a6f$var$transformLogn, $e116ca9fa91a3a6f$var$transformExpn);
        } else transform($e116ca9fa91a3a6f$var$transformLog, $e116ca9fa91a3a6f$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $4e65bfc12433d4f2$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $6e6e94f7d2536c6c$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $1ae9cef0e7f58cad$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $e116ca9fa91a3a6f$export$2e2bcd8739ae039() {
    const scale = $e116ca9fa91a3a6f$export$860836db074028f0((0, $7d2a4da1ea1975ee$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $7d2a4da1ea1975ee$export$784d13d8ee351f07)(scale, $e116ca9fa91a3a6f$export$2e2bcd8739ae039()).base(scale.base());
    (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}










function $83a100f0eb05d452$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $83a100f0eb05d452$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $83a100f0eb05d452$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($83a100f0eb05d452$var$transformSymlog(c), $83a100f0eb05d452$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($83a100f0eb05d452$var$transformSymlog(c = +_), $83a100f0eb05d452$var$transformSymexp(c)) : c;
    };
    return (0, $294706b466fe183e$export$16a5d4b4a61a274d)(scale);
}
function $83a100f0eb05d452$export$2e2bcd8739ae039() {
    var scale = $83a100f0eb05d452$export$4602684e614eba38((0, $7d2a4da1ea1975ee$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $7d2a4da1ea1975ee$export$784d13d8ee351f07)(scale, $83a100f0eb05d452$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $75a21cff10cb8b1b$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $75a21cff10cb8b1b$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $75a21cff10cb8b1b$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $75a21cff10cb8b1b$export$34695211ec403a46(transform) {
    var scale = transform((0, $7d2a4da1ea1975ee$export$f0954fd7d5368655), (0, $7d2a4da1ea1975ee$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $7d2a4da1ea1975ee$export$f0954fd7d5368655), (0, $7d2a4da1ea1975ee$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($75a21cff10cb8b1b$var$transformSqrt, $75a21cff10cb8b1b$var$transformSquare) : transform($75a21cff10cb8b1b$var$transformPow(exponent), $75a21cff10cb8b1b$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $294706b466fe183e$export$16a5d4b4a61a274d)(scale);
}
function $75a21cff10cb8b1b$export$2e2bcd8739ae039() {
    var scale = $75a21cff10cb8b1b$export$34695211ec403a46((0, $7d2a4da1ea1975ee$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $7d2a4da1ea1975ee$export$784d13d8ee351f07)(scale, $75a21cff10cb8b1b$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $75a21cff10cb8b1b$export$eba8049fb5020b81() {
    return $75a21cff10cb8b1b$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}


function $66c384aec4760e32$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $7d2a4da1ea1975ee$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $927ebd1811035250$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $2936309b90bf2fa2$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $66c384aec4760e32$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $66c384aec4760e32$export$2e2bcd8739ae039() {
    var scale = (0, $294706b466fe183e$export$16a5d4b4a61a274d)($66c384aec4760e32$var$transformer()((0, $7d2a4da1ea1975ee$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $66c384aec4760e32$export$784d13d8ee351f07(scale, $66c384aec4760e32$export$2e2bcd8739ae039());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $66c384aec4760e32$export$6843e08bf2ff981f() {
    var scale = (0, $e116ca9fa91a3a6f$export$860836db074028f0)($66c384aec4760e32$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $66c384aec4760e32$export$784d13d8ee351f07(scale, $66c384aec4760e32$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $66c384aec4760e32$export$9d4af4de62c81941() {
    var scale = (0, $83a100f0eb05d452$export$4602684e614eba38)($66c384aec4760e32$var$transformer());
    scale.copy = function() {
        return $66c384aec4760e32$export$784d13d8ee351f07(scale, $66c384aec4760e32$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $66c384aec4760e32$export$de9f78581b4f2405() {
    var scale = (0, $75a21cff10cb8b1b$export$34695211ec403a46)($66c384aec4760e32$var$transformer());
    scale.copy = function() {
        return $66c384aec4760e32$export$784d13d8ee351f07(scale, $66c384aec4760e32$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $66c384aec4760e32$export$413d935127ed466e() {
    return $66c384aec4760e32$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}




function $b49a48c3959cf2c6$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $7d2a4da1ea1975ee$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $392bfbb4bd950e49$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $927ebd1811035250$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $2936309b90bf2fa2$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b49a48c3959cf2c6$export$2e2bcd8739ae039() {
    var scale = (0, $294706b466fe183e$export$16a5d4b4a61a274d)($b49a48c3959cf2c6$var$transformer()((0, $7d2a4da1ea1975ee$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $66c384aec4760e32$export$784d13d8ee351f07)(scale, $b49a48c3959cf2c6$export$2e2bcd8739ae039());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b49a48c3959cf2c6$export$5f0266a9159c47fb() {
    var scale = (0, $e116ca9fa91a3a6f$export$860836db074028f0)($b49a48c3959cf2c6$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $66c384aec4760e32$export$784d13d8ee351f07)(scale, $b49a48c3959cf2c6$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b49a48c3959cf2c6$export$50b3da713cf557c6() {
    var scale = (0, $83a100f0eb05d452$export$4602684e614eba38)($b49a48c3959cf2c6$var$transformer());
    scale.copy = function() {
        return (0, $66c384aec4760e32$export$784d13d8ee351f07)(scale, $b49a48c3959cf2c6$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b49a48c3959cf2c6$export$d6cedcc63bf26e7e() {
    var scale = (0, $75a21cff10cb8b1b$export$34695211ec403a46)($b49a48c3959cf2c6$var$transformer());
    scale.copy = function() {
        return (0, $66c384aec4760e32$export$784d13d8ee351f07)(scale, $b49a48c3959cf2c6$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $bf90a744ea7f11d7$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $b49a48c3959cf2c6$export$33ddefb5c4ab9e9c() {
    return $b49a48c3959cf2c6$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}



const $0f6786c9d8da9e4c$export$e4f898ab14d9d460 = Symbol("implicit");
function $0f6786c9d8da9e4c$export$2e2bcd8739ae039() {
    var index = new (0, $87323652abcee4c0$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $0f6786c9d8da9e4c$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $0f6786c9d8da9e4c$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $87323652abcee4c0$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $0f6786c9d8da9e4c$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}




function $4ccf0f06260ea9f5$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $5529c8c181db0546$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $4ccf0f06260ea9f5$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $bf90a744ea7f11d7$export$23c7bb9e6558da2a).apply((0, $294706b466fe183e$export$16a5d4b4a61a274d)(scale), arguments);
}


function $cd313104b6eabfcc$var$qe() {
    return $cd313104b6eabfcc$var$qe = Object.assign ? Object.assign.bind() : function(e) {
        for(var r = 1; r < arguments.length; r++){
            var n = arguments[r];
            for(var t in n)Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
        }
        return e;
    }, $cd313104b6eabfcc$var$qe.apply(this, arguments);
}
function $cd313104b6eabfcc$var$Ce(e, r) {
    (null == r || r > e.length) && (r = e.length);
    for(var n = 0, t = new Array(r); n < r; n++)t[n] = e[n];
    return t;
}
function $cd313104b6eabfcc$var$Ge(e, r) {
    var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (n) return (n = n.call(e)).next.bind(n);
    if (Array.isArray(e) || (n = function(e, r) {
        if (e) {
            if ("string" == typeof e) return $cd313104b6eabfcc$var$Ce(e, r);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $cd313104b6eabfcc$var$Ce(e, r) : void 0;
        }
    }(e)) || r && e && "number" == typeof e.length) {
        n && (e = n);
        var t = 0;
        return function() {
            return t >= e.length ? {
                done: !0
            } : {
                done: !1,
                value: e[t++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $cd313104b6eabfcc$export$8382cb219651957d = {
    nivo: [
        "#e8c1a0",
        "#f47560",
        "#f1e15b",
        "#e8a838",
        "#61cdbb",
        "#97e3d5"
    ],
    category10: (0, $8f9d266932040a3a$export$2e2bcd8739ae039),
    accent: (0, $91fc4d3b8d970552$export$2e2bcd8739ae039),
    dark2: (0, $5d57b67a6661fdd1$export$2e2bcd8739ae039),
    paired: (0, $4a11a5048e84430a$export$2e2bcd8739ae039),
    pastel1: (0, $9f44f629df67427a$export$2e2bcd8739ae039),
    pastel2: (0, $33d34e32ce8d9c70$export$2e2bcd8739ae039),
    set1: (0, $e624048300e1f2c1$export$2e2bcd8739ae039),
    set2: (0, $a50a18047a45604b$export$2e2bcd8739ae039),
    set3: (0, $61fe95369fdf3a6e$export$2e2bcd8739ae039),
    tableau10: (0, $570e3d76233b2a4f$export$2e2bcd8739ae039)
}, $cd313104b6eabfcc$export$480d437bf98751ba = Object.keys($cd313104b6eabfcc$export$8382cb219651957d), $cd313104b6eabfcc$export$b42e9133a3bfc0c2 = {
    brown_blueGreen: (0, $eede694b8fbd97fa$export$3005042704f95a69),
    purpleRed_green: (0, $f06e3fa878b00054$export$3005042704f95a69),
    pink_yellowGreen: (0, $4a0a1aa2c9e33d36$export$3005042704f95a69),
    purple_orange: (0, $db9a96c98816e1e1$export$3005042704f95a69),
    red_blue: (0, $80b920bb3bd138ee$export$3005042704f95a69),
    red_grey: (0, $0748c3d6a1d8f5a1$export$3005042704f95a69),
    red_yellow_blue: (0, $dc745901f819a395$export$3005042704f95a69),
    red_yellow_green: (0, $3954e80259b1086a$export$3005042704f95a69),
    spectral: (0, $840a1f4d659e1adf$export$3005042704f95a69)
}, $cd313104b6eabfcc$export$63357c6d2f7b8781 = Object.keys($cd313104b6eabfcc$export$b42e9133a3bfc0c2), $cd313104b6eabfcc$export$d9c06f2af83aa27b = {
    brown_blueGreen: (0, $eede694b8fbd97fa$export$2e2bcd8739ae039),
    purpleRed_green: (0, $f06e3fa878b00054$export$2e2bcd8739ae039),
    pink_yellowGreen: (0, $4a0a1aa2c9e33d36$export$2e2bcd8739ae039),
    purple_orange: (0, $db9a96c98816e1e1$export$2e2bcd8739ae039),
    red_blue: (0, $80b920bb3bd138ee$export$2e2bcd8739ae039),
    red_grey: (0, $0748c3d6a1d8f5a1$export$2e2bcd8739ae039),
    red_yellow_blue: (0, $dc745901f819a395$export$2e2bcd8739ae039),
    red_yellow_green: (0, $3954e80259b1086a$export$2e2bcd8739ae039),
    spectral: (0, $840a1f4d659e1adf$export$2e2bcd8739ae039)
}, $cd313104b6eabfcc$export$db45d8c654873588 = {
    blues: (0, $8eac7426bb1c0fbe$export$3005042704f95a69),
    greens: (0, $5712a7d039aa5c8c$export$3005042704f95a69),
    greys: (0, $538975531d7fe164$export$3005042704f95a69),
    oranges: (0, $7fa6de3aadb892af$export$3005042704f95a69),
    purples: (0, $89408989815f99bb$export$3005042704f95a69),
    reds: (0, $cd6af02d2b8fa278$export$3005042704f95a69),
    blue_green: (0, $fbc38117fdd97bd3$export$3005042704f95a69),
    blue_purple: (0, $dafaca52a0f61b65$export$3005042704f95a69),
    green_blue: (0, $129b5c18f7a8ae7a$export$3005042704f95a69),
    orange_red: (0, $6917e6e2a5a7088c$export$3005042704f95a69),
    purple_blue_green: (0, $85d9ddb09589164a$export$3005042704f95a69),
    purple_blue: (0, $b9d08442206bc992$export$3005042704f95a69),
    purple_red: (0, $23ff18ca5e2841c9$export$3005042704f95a69),
    red_purple: (0, $e53086e466926f17$export$3005042704f95a69),
    yellow_green_blue: (0, $cb3216358e5f6293$export$3005042704f95a69),
    yellow_green: (0, $9c18e672d008ef2c$export$3005042704f95a69),
    yellow_orange_brown: (0, $585775c54f992d79$export$3005042704f95a69),
    yellow_orange_red: (0, $72f57c5a39e6e9c4$export$3005042704f95a69)
}, $cd313104b6eabfcc$export$6c6944263c7cbb3b = Object.keys($cd313104b6eabfcc$export$db45d8c654873588), $cd313104b6eabfcc$export$21dd087678fc5202 = {
    blues: (0, $8eac7426bb1c0fbe$export$2e2bcd8739ae039),
    greens: (0, $5712a7d039aa5c8c$export$2e2bcd8739ae039),
    greys: (0, $538975531d7fe164$export$2e2bcd8739ae039),
    oranges: (0, $7fa6de3aadb892af$export$2e2bcd8739ae039),
    purples: (0, $89408989815f99bb$export$2e2bcd8739ae039),
    reds: (0, $cd6af02d2b8fa278$export$2e2bcd8739ae039),
    turbo: (0, $62b7c488ec4e3342$export$2e2bcd8739ae039),
    viridis: (0, $5a16eba5e642ed9e$export$2e2bcd8739ae039),
    inferno: (0, $5a16eba5e642ed9e$export$ad0c8285c8ea6dbd),
    magma: (0, $5a16eba5e642ed9e$export$c41e69203f572e8d),
    plasma: (0, $5a16eba5e642ed9e$export$6664860a633d9daf),
    cividis: (0, $e379559b5ad1ab56$export$2e2bcd8739ae039),
    warm: (0, $a23cc9a70ba6fdc1$export$fc70efcec537be98),
    cool: (0, $a23cc9a70ba6fdc1$export$c5cedbc1ab3be2c3),
    cubehelixDefault: (0, $cb10b1dc3ee7f4d6$export$2e2bcd8739ae039),
    blue_green: (0, $fbc38117fdd97bd3$export$2e2bcd8739ae039),
    blue_purple: (0, $dafaca52a0f61b65$export$2e2bcd8739ae039),
    green_blue: (0, $129b5c18f7a8ae7a$export$2e2bcd8739ae039),
    orange_red: (0, $6917e6e2a5a7088c$export$2e2bcd8739ae039),
    purple_blue_green: (0, $85d9ddb09589164a$export$2e2bcd8739ae039),
    purple_blue: (0, $b9d08442206bc992$export$2e2bcd8739ae039),
    purple_red: (0, $23ff18ca5e2841c9$export$2e2bcd8739ae039),
    red_purple: (0, $e53086e466926f17$export$2e2bcd8739ae039),
    yellow_green_blue: (0, $cb3216358e5f6293$export$2e2bcd8739ae039),
    yellow_green: (0, $9c18e672d008ef2c$export$2e2bcd8739ae039),
    yellow_orange_brown: (0, $585775c54f992d79$export$2e2bcd8739ae039),
    yellow_orange_red: (0, $72f57c5a39e6e9c4$export$2e2bcd8739ae039)
}, $cd313104b6eabfcc$export$2ad73d393c16f81c = $cd313104b6eabfcc$var$qe({}, $cd313104b6eabfcc$export$8382cb219651957d, $cd313104b6eabfcc$export$b42e9133a3bfc0c2, $cd313104b6eabfcc$export$db45d8c654873588), $cd313104b6eabfcc$export$b48661626a811234 = Object.keys($cd313104b6eabfcc$export$2ad73d393c16f81c), $cd313104b6eabfcc$export$9f49cca6c7d1dda4 = function(e) {
    return $cd313104b6eabfcc$export$480d437bf98751ba.includes(e);
}, $cd313104b6eabfcc$export$4d028a51ab424d0b = function(e) {
    return $cd313104b6eabfcc$export$63357c6d2f7b8781.includes(e);
}, $cd313104b6eabfcc$export$166c33132082d11d = function(e) {
    return $cd313104b6eabfcc$export$6c6944263c7cbb3b.includes(e);
}, $cd313104b6eabfcc$export$66bec3b8446aaf18 = {
    rainbow: (0, $a23cc9a70ba6fdc1$export$2e2bcd8739ae039),
    sinebow: (0, $f8d313dfc649d49f$export$2e2bcd8739ae039)
}, $cd313104b6eabfcc$export$6638ab0298ebe095 = $cd313104b6eabfcc$var$qe({}, $cd313104b6eabfcc$export$d9c06f2af83aa27b, $cd313104b6eabfcc$export$21dd087678fc5202, $cd313104b6eabfcc$export$66bec3b8446aaf18), $cd313104b6eabfcc$export$277274330ffd2780 = Object.keys($cd313104b6eabfcc$export$6638ab0298ebe095), $cd313104b6eabfcc$export$acb96d3092c0904 = function(e, r) {
    if ("function" == typeof e) return e;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7df273079235e60a$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.theme;
        }(e)) {
            if (void 0 === r) throw new Error("Unable to use color from theme as no theme was provided");
            var n = (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, e.theme);
            if (void 0 === n) throw new Error("Color from theme is undefined at path: '" + e.theme + "'");
            return function() {
                return n;
            };
        }
        if (function(e) {
            return void 0 !== e.from;
        }(e)) {
            var t = function(r) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, e.from);
            };
            if (Array.isArray(e.modifiers)) {
                for(var o, i = [], u = function() {
                    var e = o.value, r = e[0], n = e[1];
                    if ("brighter" === r) i.push(function(e) {
                        return e.brighter(n);
                    });
                    else if ("darker" === r) i.push(function(e) {
                        return e.darker(n);
                    });
                    else {
                        if ("opacity" !== r) throw new Error("Invalid color modifier: '" + r + "', must be one of: 'brighter', 'darker', 'opacity'");
                        i.push(function(e) {
                            return e.opacity = n, e;
                        });
                    }
                }, a = $cd313104b6eabfcc$var$Ge(e.modifiers); !(o = a()).done;)u();
                return 0 === i.length ? t : function(e) {
                    return i.reduce(function(e, r) {
                        return r(e);
                    }, (0, $81X7f.rgb)(t(e))).toString();
                };
            }
            return t;
        }
        throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
    }
    return function() {
        return e;
    };
}, $cd313104b6eabfcc$export$2a9e363116151414 = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$acb96d3092c0904(e, r);
    }, [
        e,
        r
    ]);
}, $cd313104b6eabfcc$export$5f5a386483e6fff5 = (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        theme: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).shape({
        from: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).string.isRequired,
        modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($9C0qR))).array)
    })
]), $cd313104b6eabfcc$export$30c0b047d59c1130 = {
    scheme: "turbo"
}, $cd313104b6eabfcc$export$3c410d9d0181bae0 = function(e, r) {
    var n = e.minValue, t = e.maxValue, o = void 0 !== n ? n : r.min, i = void 0 !== t ? t : r.max, u = (0, $66c384aec4760e32$export$2e2bcd8739ae039)().domain([
        o,
        i
    ]).clamp(!0);
    if ("colors" in e) u.range(e.colors);
    else if ("interpolator" in e) u.interpolator(e.interpolator);
    else {
        var a, l = null != (a = e.scheme) ? a : $cd313104b6eabfcc$export$30c0b047d59c1130.scheme;
        u.interpolator($cd313104b6eabfcc$export$6638ab0298ebe095[l]);
    }
    return u;
}, $cd313104b6eabfcc$export$13bad8adfa9d5e5 = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$3c410d9d0181bae0(e, r);
    }, [
        e,
        r
    ]);
}, $cd313104b6eabfcc$export$83a83df24724477a = {
    scheme: "red_yellow_blue",
    divergeAt: .5
}, $cd313104b6eabfcc$export$d2925809ff5420bc = function(e, r) {
    var n, t = e.minValue, o = e.maxValue, i = void 0 !== t ? t : r.min, u = void 0 !== o ? o : r.max, a = [
        i,
        i + (u - i) / 2,
        u
    ], l = .5 - (null != (n = e.divergeAt) ? n : $cd313104b6eabfcc$export$83a83df24724477a.divergeAt), c = (0, $b49a48c3959cf2c6$export$2e2bcd8739ae039)().domain(a).clamp(!0), s = function(e) {
        return String(e);
    };
    if ("colors" in e) s = (0, $b49a48c3959cf2c6$export$2e2bcd8739ae039)().domain(a.map(function(e) {
        return e - l * (u - i);
    })).range(e.colors).interpolator();
    else if ("interpolator" in e) s = e.interpolator;
    else {
        var f, p = null != (f = e.scheme) ? f : $cd313104b6eabfcc$export$83a83df24724477a.scheme;
        s = $cd313104b6eabfcc$export$6638ab0298ebe095[p];
    }
    return c.interpolator(function(e) {
        return s(e + l);
    });
}, $cd313104b6eabfcc$export$92d4d3b6e140b0d1 = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$d2925809ff5420bc(e, r);
    }, [
        e,
        r
    ]);
}, $cd313104b6eabfcc$export$19b16327818185cf = {
    scheme: "turbo",
    steps: 7
}, $cd313104b6eabfcc$export$8442947f078400fb = function(e, r) {
    var n = (0, $4ccf0f06260ea9f5$export$2e2bcd8739ae039)().domain(e.domain || [
        r.min,
        r.max
    ]).nice();
    if ("colors" in e) n.range(e.colors);
    else {
        var t = e.scheme || $cd313104b6eabfcc$export$19b16327818185cf.scheme, o = void 0 === e.steps ? $cd313104b6eabfcc$export$19b16327818185cf.steps : e.steps, i = $cd313104b6eabfcc$export$6638ab0298ebe095[t], u = Array.from({
            length: o
        }).map(function(e, r) {
            return i(r * (1 / (o - 1)));
        });
        n.range(u);
    }
    return n;
}, $cd313104b6eabfcc$export$aeb5c6e1cabe7efa = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$8442947f078400fb(e, r);
    }, [
        e,
        r
    ]);
}, $cd313104b6eabfcc$export$351e3420d10d6780 = function(e, r) {
    if (function(e) {
        return "sequential" === e.type;
    }(e)) return $cd313104b6eabfcc$export$3c410d9d0181bae0(e, r);
    if (function(e) {
        return "diverging" === e.type;
    }(e)) return $cd313104b6eabfcc$export$d2925809ff5420bc(e, r);
    if (function(e) {
        return "quantize" === e.type;
    }(e)) return $cd313104b6eabfcc$export$8442947f078400fb(e, r);
    throw new Error("Invalid continuous color scale config");
}, $cd313104b6eabfcc$export$4796b471538d60f8 = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$351e3420d10d6780(e, r);
    }, [
        e,
        r
    ]);
}, $cd313104b6eabfcc$export$f6ca0f82846310a7 = function(e, r) {
    void 0 === r && (r = 16);
    var n = e.domain();
    if ("thresholds" in e) {
        var t = [], o = (0, $294706b466fe183e$export$2e2bcd8739ae039)().domain(n).range([
            0,
            1
        ]);
        return e.range().forEach(function(r, n) {
            var i = e.invertExtent(r), u = i[0], a = i[1];
            t.push({
                key: n + ".0",
                offset: o(u),
                stopColor: r
            }), t.push({
                key: n + ".1",
                offset: o(a),
                stopColor: r
            });
        }), t;
    }
    var i = e.copy();
    return 2 === n.length ? i.domain([
        0,
        1
    ]) : 3 === n.length && i.domain([
        0,
        .5,
        1
    ]), i.ticks(r).map(function(e) {
        return {
            key: "" + e,
            offset: e,
            stopColor: "" + i(e)
        };
    });
}, $cd313104b6eabfcc$export$c3ea10dbbf6bbab3 = function(e, r) {
    if ("function" == typeof e) return e;
    var n = "function" == typeof r ? r : function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(e, r);
    };
    if (Array.isArray(e)) {
        var t = (0, $0f6786c9d8da9e4c$export$2e2bcd8739ae039)(e), o = function(e) {
            return t(n(e));
        };
        return o.scale = t, o;
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7df273079235e60a$exports)))(e)) {
        if (function(e) {
            return void 0 !== e.datum;
        }(e)) return function(r) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($369c3fcd3a6c1c7c$exports)))(r, e.datum);
        };
        if (function(e) {
            return void 0 !== e.scheme;
        }(e)) {
            if ($cd313104b6eabfcc$export$9f49cca6c7d1dda4(e.scheme)) {
                var i = (0, $0f6786c9d8da9e4c$export$2e2bcd8739ae039)($cd313104b6eabfcc$export$2ad73d393c16f81c[e.scheme]), u = function(e) {
                    return i(n(e));
                };
                return u.scale = i, u;
            }
            if ($cd313104b6eabfcc$export$4d028a51ab424d0b(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 11)) throw new Error("Invalid size '" + e.size + "' for diverging color scheme '" + e.scheme + "', must be between 3~11");
                var a = (0, $0f6786c9d8da9e4c$export$2e2bcd8739ae039)($cd313104b6eabfcc$export$2ad73d393c16f81c[e.scheme][e.size || 11]), l = function(e) {
                    return a(n(e));
                };
                return l.scale = a, l;
            }
            if ($cd313104b6eabfcc$export$166c33132082d11d(e.scheme)) {
                if (void 0 !== e.size && (e.size < 3 || e.size > 9)) throw new Error("Invalid size '" + e.size + "' for sequential color scheme '" + e.scheme + "', must be between 3~9");
                var c = (0, $0f6786c9d8da9e4c$export$2e2bcd8739ae039)($cd313104b6eabfcc$export$2ad73d393c16f81c[e.scheme][e.size || 9]), s = function(e) {
                    return c(n(e));
                };
                return s.scale = c, s;
            }
        }
        throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
    }
    return function() {
        return e;
    };
}, $cd313104b6eabfcc$export$47939777be1516f5 = function(e, r) {
    return (0, $3ZYaX.useMemo)(function() {
        return $cd313104b6eabfcc$export$c3ea10dbbf6bbab3(e, r);
    }, [
        e,
        r
    ]);
};


function $d8921c707c0bb43d$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


const $ceb358c6ec0d6c34$export$2335f513bbd82c6d = Math.abs;
const $ceb358c6ec0d6c34$export$b8b770ee6a0d9760 = Math.atan2;
const $ceb358c6ec0d6c34$export$50d414a77b60d802 = Math.cos;
const $ceb358c6ec0d6c34$export$8960430cfd85939f = Math.max;
const $ceb358c6ec0d6c34$export$96ec731ed4dcb222 = Math.min;
const $ceb358c6ec0d6c34$export$5de3937cb4b592ed = Math.sin;
const $ceb358c6ec0d6c34$export$eba8049fb5020b81 = Math.sqrt;
const $ceb358c6ec0d6c34$export$6c421550c66a327d = 1e-12;
const $ceb358c6ec0d6c34$export$18c7bea995a110f = Math.PI;
const $ceb358c6ec0d6c34$export$e51408a300e8929a = $ceb358c6ec0d6c34$export$18c7bea995a110f / 2;
const $ceb358c6ec0d6c34$export$a4b4b4d4d776fe92 = 2 * $ceb358c6ec0d6c34$export$18c7bea995a110f;
function $ceb358c6ec0d6c34$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $ceb358c6ec0d6c34$export$18c7bea995a110f : Math.acos(x);
}
function $ceb358c6ec0d6c34$export$41726bdb1fc63f(x) {
    return x >= 1 ? $ceb358c6ec0d6c34$export$e51408a300e8929a : x <= -1 ? -$ceb358c6ec0d6c34$export$e51408a300e8929a : Math.asin(x);
}


const $806e3a56c5ecb512$var$pi = Math.PI, $806e3a56c5ecb512$var$tau = 2 * $806e3a56c5ecb512$var$pi, $806e3a56c5ecb512$var$epsilon = 1e-6, $806e3a56c5ecb512$var$tauEpsilon = $806e3a56c5ecb512$var$tau - $806e3a56c5ecb512$var$epsilon;
function $806e3a56c5ecb512$var$append(strings) {
    this._ += strings[0];
    for(let i = 1, n = strings.length; i < n; ++i)this._ += arguments[i] + strings[i];
}
function $806e3a56c5ecb512$var$appendRound(digits) {
    let d = Math.floor(digits);
    if (!(d >= 0)) throw new Error(`invalid digits: ${digits}`);
    if (d > 15) return $806e3a56c5ecb512$var$append;
    const k = 10 ** d;
    return function(strings) {
        this._ += strings[0];
        for(let i = 1, n = strings.length; i < n; ++i)this._ += Math.round(arguments[i] * k) / k + strings[i];
    };
}
class $806e3a56c5ecb512$export$4b2950bdac9b6ee9 {
    moveTo(x, y) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}`;
    }
    closePath() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._append`Z`;
        }
    }
    lineTo(x, y) {
        this._append`L${this._x1 = +x},${this._y1 = +y}`;
    }
    quadraticCurveTo(x1, y1, x, y) {
        this._append`Q${+x1},${+y1},${this._x1 = +x},${this._y1 = +y}`;
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x},${this._y1 = +y}`;
    }
    arcTo(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._append`M${this._x1 = x1},${this._y1 = y1}`;
        else if (!(l01_2 > $806e3a56c5ecb512$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $806e3a56c5ecb512$var$epsilon) || !r) this._append`L${this._x1 = x1},${this._y1 = y1}`;
        else {
            let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($806e3a56c5ecb512$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $806e3a56c5ecb512$var$epsilon) this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
            this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
        }
    }
    arc(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        // Is the radius negative? Error.
        if (r < 0) throw new Error(`negative radius: ${r}`);
        let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._append`M${x0},${y0}`;
        else if (Math.abs(this._x1 - x0) > $806e3a56c5ecb512$var$epsilon || Math.abs(this._y1 - y0) > $806e3a56c5ecb512$var$epsilon) this._append`L${x0},${y0}`;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $806e3a56c5ecb512$var$tau + $806e3a56c5ecb512$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $806e3a56c5ecb512$var$tauEpsilon) this._append`A${r},${r},0,1,${cw},${x - dx},${y - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
        else if (da > $806e3a56c5ecb512$var$epsilon) this._append`A${r},${r},0,${+(da >= $806e3a56c5ecb512$var$pi)},${cw},${this._x1 = x + r * Math.cos(a1)},${this._y1 = y + r * Math.sin(a1)}`;
    }
    rect(x, y, w, h) {
        this._append`M${this._x0 = this._x1 = +x},${this._y0 = this._y1 = +y}h${w = +w}v${+h}h${-w}Z`;
    }
    toString() {
        return this._;
    }
    constructor(digits){
        this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
        this._ = "";
        this._append = digits == null ? $806e3a56c5ecb512$var$append : $806e3a56c5ecb512$var$appendRound(digits);
    }
}
function $806e3a56c5ecb512$export$bb654e07daaf8c3a() {
    return new $806e3a56c5ecb512$export$4b2950bdac9b6ee9;
}
// Allow instanceof d3.path
$806e3a56c5ecb512$export$bb654e07daaf8c3a.prototype = $806e3a56c5ecb512$export$4b2950bdac9b6ee9.prototype;
function $806e3a56c5ecb512$export$e181c6ece8d9cc5f(digits = 3) {
    return new $806e3a56c5ecb512$export$4b2950bdac9b6ee9(+digits);
}


function $a7d3b1fedfcade6f$export$fb6e83118a5dcd45(shape) {
    let digits = 3;
    shape.digits = function(_) {
        if (!arguments.length) return digits;
        if (_ == null) digits = null;
        else {
            const d = Math.floor(_);
            if (!(d >= 0)) throw new RangeError(`invalid digits: ${_}`);
            digits = d;
        }
        return shape;
    };
    return ()=>new (0, $806e3a56c5ecb512$export$4b2950bdac9b6ee9)(digits);
}


function $59581444d4e99a1a$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $59581444d4e99a1a$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $59581444d4e99a1a$var$arcStartAngle(d) {
    return d.startAngle;
}
function $59581444d4e99a1a$var$arcEndAngle(d) {
    return d.endAngle;
}
function $59581444d4e99a1a$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $59581444d4e99a1a$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $59581444d4e99a1a$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)((0, $ceb358c6ec0d6c34$export$8960430cfd85939f)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $59581444d4e99a1a$export$2e2bcd8739ae039() {
    var innerRadius = $59581444d4e99a1a$var$arcInnerRadius, outerRadius = $59581444d4e99a1a$var$arcOuterRadius, cornerRadius = (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(0), padRadius = null, startAngle = $59581444d4e99a1a$var$arcStartAngle, endAngle = $59581444d4e99a1a$var$arcEndAngle, padAngle = $59581444d4e99a1a$var$arcPadAngle, context = null, path = (0, $a7d3b1fedfcade6f$export$fb6e83118a5dcd45)(arc);
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - (0, $ceb358c6ec0d6c34$export$e51408a300e8929a), a1 = endAngle.apply(this, arguments) - (0, $ceb358c6ec0d6c34$export$e51408a300e8929a), da = (0, $ceb358c6ec0d6c34$export$2335f513bbd82c6d)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = path();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d))) context.moveTo(0, 0);
        else if (da > (0, $ceb358c6ec0d6c34$export$a4b4b4d4d776fe92) - (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
            context.moveTo(r1 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a0), r1 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
                context.moveTo(r0 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a1), r0 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d) && (padRadius ? +padRadius.apply(this, arguments) : (0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)(r0 * r0 + r1 * r1)), rc = (0, $ceb358c6ec0d6c34$export$96ec731ed4dcb222)((0, $ceb358c6ec0d6c34$export$2335f513bbd82c6d)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
                var p0 = (0, $ceb358c6ec0d6c34$export$41726bdb1fc63f)(rp / r0 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(ap)), p1 = (0, $ceb358c6ec0d6c34$export$41726bdb1fc63f)(rp / r1 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(ap));
                if ((da0 -= p0 * 2) > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a01), y01 = r1 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a01), x10 = r0 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a10), y10 = r0 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a10);
            // Apply rounded corners?
            if (rc > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
                var x11 = r1 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a11), y11 = r1 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a11), x00 = r0 * (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a00), y00 = r0 * (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a00), oc;
                // Restrict the corner radius according to the sector angle. If this
                // intersection fails, it’s probably because the arc is too small, so
                // disable the corner radius entirely.
                if (da < (0, $ceb358c6ec0d6c34$export$18c7bea995a110f)) {
                    if (oc = $59581444d4e99a1a$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
                        var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)((0, $ceb358c6ec0d6c34$export$fd6306be3fde5b04)((ax * bx + ay * by) / ((0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)(ax * ax + ay * ay) * (0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)(bx * bx + by * by))) / 2), lc = (0, $ceb358c6ec0d6c34$export$eba8049fb5020b81)(oc[0] * oc[0] + oc[1] * oc[1]);
                        rc0 = (0, $ceb358c6ec0d6c34$export$96ec731ed4dcb222)(rc, (r0 - lc) / (kc - 1));
                        rc1 = (0, $ceb358c6ec0d6c34$export$96ec731ed4dcb222)(rc, (r1 - lc) / (kc + 1));
                    } else rc0 = rc1 = 0;
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d))) context.moveTo(x01, y01);
            else if (rc1 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
                t0 = $59581444d4e99a1a$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $59581444d4e99a1a$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) || !(da0 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d))) context.lineTo(x10, y10);
            else if (rc0 > (0, $ceb358c6ec0d6c34$export$6c421550c66a327d)) {
                t0 = $59581444d4e99a1a$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $59581444d4e99a1a$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y01, t0.x01), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y11, t1.x11), (0, $ceb358c6ec0d6c34$export$b8b770ee6a0d9760)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - (0, $ceb358c6ec0d6c34$export$18c7bea995a110f) / 2;
        return [
            (0, $ceb358c6ec0d6c34$export$50d414a77b60d802)(a) * r,
            (0, $ceb358c6ec0d6c34$export$5de3937cb4b592ed)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

var $3061546511b965ef$export$58adb3bec8346d0f = Array.prototype.slice;
function $3061546511b965ef$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}



function $8a4c7904b09e8386$var$Linear(context) {
    this._context = context;
}
$8a4c7904b09e8386$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $8a4c7904b09e8386$export$2e2bcd8739ae039(context) {
    return new $8a4c7904b09e8386$var$Linear(context);
}



function $b88f00f26745ea5b$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $b88f00f26745ea5b$export$4a5767248b18ef41(p) {
    return p[1];
}


function $07705769dfefb1c4$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(true), context = null, curve = (0, $8a4c7904b09e8386$export$2e2bcd8739ae039), output = null, path = (0, $a7d3b1fedfcade6f$export$fb6e83118a5dcd45)(line);
    x = typeof x === "function" ? x : x === undefined ? (0, $b88f00f26745ea5b$export$d141bba7fdc215a3) : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $b88f00f26745ea5b$export$4a5767248b18ef41) : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $3061546511b965ef$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = path());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $d8921c707c0bb43d$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}


function $be8ea372f8f49f58$var$M() {
    return $be8ea372f8f49f58$var$M = Object.assign ? Object.assign.bind() : function(t) {
        for(var n = 1; n < arguments.length; n++){
            var e = arguments[n];
            for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
        }
        return t;
    }, $be8ea372f8f49f58$var$M.apply(this, arguments);
}
var $be8ea372f8f49f58$var$k = {
    pointerEvents: "none"
}, $be8ea372f8f49f58$var$b = function(n) {
    var e = n.label, r = n.style, a = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)();
    return (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).g, {
        transform: r.transform,
        opacity: r.progress,
        style: $be8ea372f8f49f58$var$k,
        children: (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).text, {
            textAnchor: "middle",
            dominantBaseline: "central",
            style: $be8ea372f8f49f58$var$M({}, a.labels.text, {
                fill: r.textColor
            }),
            children: e
        })
    });
}, $be8ea372f8f49f58$var$C = function(t) {
    var n = t % (2 * Math.PI);
    return n < 0 && (n += 2 * Math.PI), n;
}, $be8ea372f8f49f58$var$L = function(t, n) {
    return t.filter(function(t) {
        return Math.abs((0, $15b6b5b56080a0cd$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= n;
    });
}, $be8ea372f8f49f58$var$O = function(t, n, e, r, i) {
    return [
        "A",
        t,
        t,
        0,
        n,
        e,
        r,
        i
    ].join(" ");
}, $be8ea372f8f49f58$export$d2a093ad2bac157 = [
    "startAngle",
    "middleAngle",
    "endAngle",
    "innerRadius",
    "centerRadius",
    "outerRadius",
    "pushIn",
    "pushOut"
], $be8ea372f8f49f58$export$81e64a3650c150c1 = {
    startAngle: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                endAngle: t.startAngle
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                startAngle: t.endAngle
            });
        }
    },
    middleAngle: {
        enter: function(t) {
            var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
            return $be8ea372f8f49f58$var$M({}, t, {
                startAngle: n,
                endAngle: n
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            var n = t.startAngle + (t.endAngle - t.startAngle) / 2;
            return $be8ea372f8f49f58$var$M({}, t, {
                startAngle: n,
                endAngle: n
            });
        }
    },
    endAngle: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                startAngle: t.endAngle
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                endAngle: t.startAngle
            });
        }
    },
    innerRadius: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                outerRadius: t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.outerRadius
            });
        }
    },
    centerRadius: {
        enter: function(t) {
            var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: n,
                outerRadius: n
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            var n = t.innerRadius + (t.outerRadius - t.innerRadius) / 2;
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: n,
                outerRadius: n
            });
        }
    },
    outerRadius: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.outerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                outerRadius: t.innerRadius
            });
        }
    },
    pushIn: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
                outerRadius: t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.outerRadius,
                outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
            });
        }
    },
    pushOut: {
        enter: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.outerRadius,
                outerRadius: t.outerRadius + t.outerRadius - t.innerRadius
            });
        },
        update: function(t) {
            return t;
        },
        leave: function(t) {
            return $be8ea372f8f49f58$var$M({}, t, {
                innerRadius: t.innerRadius - t.outerRadius + t.innerRadius,
                outerRadius: t.innerRadius
            });
        }
    }
}, $be8ea372f8f49f58$export$a313c3952fef8fc3 = function(t, n) {
    return (0, $3ZYaX.useMemo)(function() {
        var e = $be8ea372f8f49f58$export$81e64a3650c150c1[t];
        return {
            enter: function(t) {
                return $be8ea372f8f49f58$var$M({
                    progress: 0
                }, e.enter(t.arc), n ? n.enter(t) : {});
            },
            update: function(t) {
                return $be8ea372f8f49f58$var$M({
                    progress: 1
                }, e.update(t.arc), n ? n.update(t) : {});
            },
            leave: function(t) {
                return $be8ea372f8f49f58$var$M({
                    progress: 0
                }, e.leave(t.arc), n ? n.leave(t) : {});
            }
        };
    }, [
        t,
        n
    ]);
}, $be8ea372f8f49f58$export$f7b13546106819e8 = function(t, n) {
    var e = (0, $15b6b5b56080a0cd$export$61f3799bad189d2e)(t) - Math.PI / 2, r = t.innerRadius + (t.outerRadius - t.innerRadius) * n;
    return (0, $15b6b5b56080a0cd$export$2e16b01652730550)(e, r);
}, $be8ea372f8f49f58$export$aee1f2bb11698da9 = function(t) {
    return function(e, r, i, a) {
        return (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
            e,
            r,
            i,
            a
        ], function(n, e, r, i) {
            var a = $be8ea372f8f49f58$export$f7b13546106819e8({
                startAngle: n,
                endAngle: e,
                innerRadius: r,
                outerRadius: i
            }, t);
            return "translate(" + a.x + "," + a.y + ")";
        });
    };
}, $be8ea372f8f49f58$export$e64eb3d94f48a98e = function(t, n, r, i) {
    void 0 === n && (n = .5), void 0 === r && (r = "innerRadius");
    var a = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), o = a.animate, u = a.config, l = $be8ea372f8f49f58$export$a313c3952fef8fc3(r, i);
    return {
        transition: (0, $775dc606f38f6e3f$export$7b286972b8d8ccbf)(t, {
            keys: function(t) {
                return t.id;
            },
            initial: l.update,
            from: l.enter,
            enter: l.update,
            update: l.update,
            leave: l.leave,
            config: u,
            immediate: !o
        }),
        interpolate: $be8ea372f8f49f58$export$aee1f2bb11698da9(n)
    };
}, $be8ea372f8f49f58$export$92aaf3f031db9626 = function(t) {
    var n = t.data, e = t.offset, r = void 0 === e ? .5 : e, i = t.skipAngle, a = void 0 === i ? 0 : i, o = t.computeExtraProps, u = void 0 === o ? function() {
        return {};
    } : o;
    return (0, $3ZYaX.useMemo)(function() {
        return $be8ea372f8f49f58$var$L(n, a).map(function(t) {
            var n = $be8ea372f8f49f58$export$f7b13546106819e8(t.arc, r);
            return $be8ea372f8f49f58$var$M({}, u(t), {
                x: n.x,
                y: n.y,
                data: t
            });
        });
    }, [
        n,
        r,
        a,
        u
    ]);
}, $be8ea372f8f49f58$export$6aed5a877c5fc8a1 = function(t) {
    var n = t.center, e = t.data, r = t.transitionMode, o = t.label, u = t.radiusOffset, l = t.skipAngle, s = t.textColor, f = t.component, c = void 0 === f ? $be8ea372f8f49f58$var$b : f, g = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(o), h = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), x = (0, $cd313104b6eabfcc$export$2a9e363116151414)(s, h), m = (0, $3ZYaX.useMemo)(function() {
        return e.filter(function(t) {
            return Math.abs((0, $15b6b5b56080a0cd$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= l;
        });
    }, [
        e,
        l
    ]), y = $be8ea372f8f49f58$export$e64eb3d94f48a98e(m, u, r), k = y.transition, C = y.interpolate, L = c;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: k(function(t, n) {
            return (0, $3ZYaX.createElement)(L, {
                key: n.id,
                datum: n,
                label: g(n),
                style: $be8ea372f8f49f58$var$M({}, t, {
                    transform: C(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
                    textColor: x(n)
                })
            });
        })
    });
}, $be8ea372f8f49f58$export$3162ce2b4ca97f8a = function(t, n, e) {
    t.textAlign = "center", t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function(n) {
        t.fillStyle = n.textColor, t.fillText("" + n.label, n.x, n.y);
    });
}, $be8ea372f8f49f58$export$13804dbea81a51a5 = function(t) {
    var n = t.data, e = t.offset, r = t.skipAngle, a = t.label, o = t.textColor, u = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(a), l = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), s = (0, $cd313104b6eabfcc$export$2a9e363116151414)(o, l), f = (0, $3ZYaX.useCallback)(function(t) {
        return {
            label: u(t),
            textColor: s(t)
        };
    }, [
        u,
        s
    ]);
    return $be8ea372f8f49f58$export$92aaf3f031db9626({
        data: n,
        offset: e,
        skipAngle: r,
        computeExtraProps: f
    });
}, $be8ea372f8f49f58$export$6749c13ec724bdf8 = $be8ea372f8f49f58$var$b, $be8ea372f8f49f58$var$G = function(n) {
    var e = n.label, r = n.style, a = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)();
    return (0, $4801813bf62cee3c$exports.jsxs)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).g, {
        opacity: r.opacity,
        children: [
            (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).path, {
                fill: "none",
                stroke: r.linkColor,
                strokeWidth: r.thickness,
                d: r.path
            }),
            (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).text, {
                transform: r.textPosition,
                textAnchor: r.textAnchor,
                dominantBaseline: "central",
                style: $be8ea372f8f49f58$var$M({}, a.labels.text, {
                    fill: r.textColor
                }),
                children: e
            })
        ]
    });
}, $be8ea372f8f49f58$export$248385da08f607e = function(t) {
    var n = $be8ea372f8f49f58$var$C(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2);
    return n < Math.PI / 2 || n > 1.5 * Math.PI ? "start" : "end";
}, $be8ea372f8f49f58$export$67742f271c0ba17f = function(t, n, e, r) {
    var i, a, u = $be8ea372f8f49f58$var$C(t.startAngle + (t.endAngle - t.startAngle) / 2 - Math.PI / 2), l = (0, $15b6b5b56080a0cd$export$2e16b01652730550)(u, t.outerRadius + n), s = (0, $15b6b5b56080a0cd$export$2e16b01652730550)(u, t.outerRadius + n + e);
    return u < Math.PI / 2 || u > 1.5 * Math.PI ? (i = "after", a = {
        x: s.x + r,
        y: s.y
    }) : (i = "before", a = {
        x: s.x - r,
        y: s.y
    }), {
        side: i,
        points: [
            l,
            s,
            a
        ]
    };
}, $be8ea372f8f49f58$var$H = (0, $07705769dfefb1c4$export$2e2bcd8739ae039)().x(function(t) {
    return t.x;
}).y(function(t) {
    return t.y;
}), $be8ea372f8f49f58$var$J = function(t, e, r, i, a, o, u) {
    return (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
        t,
        e,
        r,
        i,
        a,
        o,
        u
    ], function(t, n, e, r, i, a, o) {
        var u = $be8ea372f8f49f58$export$67742f271c0ba17f({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        }, i, a, o).points;
        return $be8ea372f8f49f58$var$H(u);
    });
}, $be8ea372f8f49f58$var$K = function(t, e, r, i) {
    return (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
        t,
        e,
        r,
        i
    ], function(t, n, e, r) {
        return $be8ea372f8f49f58$export$248385da08f607e({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        });
    });
}, $be8ea372f8f49f58$var$N = function(t, e, r, i, a, o, u, l) {
    return (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
        t,
        e,
        r,
        i,
        a,
        o,
        u,
        l
    ], function(t, n, e, r, i, a, o, u) {
        var l = $be8ea372f8f49f58$export$67742f271c0ba17f({
            startAngle: t,
            endAngle: n,
            innerRadius: e,
            outerRadius: r
        }, i, a, o), s = l.points, d = l.side, f = s[2];
        return "before" === d ? f.x -= u : f.x += u, "translate(" + f.x + "," + f.y + ")";
    });
}, $be8ea372f8f49f58$export$5a16238ff9674f1b = function(t) {
    var n = t.data, r = t.offset, a = void 0 === r ? 0 : r, o = t.diagonalLength, u = t.straightLength, l = t.skipAngle, d = void 0 === l ? 0 : l, f = t.textOffset, c = t.linkColor, g = t.textColor, p = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), h = p.animate, A = p.config, x = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), m = (0, $cd313104b6eabfcc$export$2a9e363116151414)(c, x), y = (0, $cd313104b6eabfcc$export$2a9e363116151414)(g, x), M = function(t, n) {
        return (0, $3ZYaX.useMemo)(function() {
            return $be8ea372f8f49f58$var$L(t, n);
        }, [
            t,
            n
        ]);
    }(n, d), k = function(t) {
        var n = t.offset, e = t.diagonalLength, r = t.straightLength, i = t.textOffset, a = t.getLinkColor, o = t.getTextColor;
        return (0, $3ZYaX.useMemo)(function() {
            return {
                enter: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 0
                    };
                },
                update: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: e,
                        straightLength: r,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 1
                    };
                },
                leave: function(t) {
                    return {
                        startAngle: t.arc.startAngle,
                        endAngle: t.arc.endAngle,
                        innerRadius: t.arc.innerRadius,
                        outerRadius: t.arc.outerRadius,
                        offset: n,
                        diagonalLength: 0,
                        straightLength: 0,
                        textOffset: i,
                        linkColor: a(t),
                        textColor: o(t),
                        opacity: 0
                    };
                }
            };
        }, [
            e,
            r,
            i,
            a,
            o,
            n
        ]);
    }({
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: f,
        getLinkColor: m,
        getTextColor: y
    });
    return {
        transition: (0, $775dc606f38f6e3f$export$7b286972b8d8ccbf)(M, {
            keys: function(t) {
                return t.id;
            },
            initial: k.update,
            from: k.enter,
            enter: k.update,
            update: k.update,
            leave: k.leave,
            config: A,
            immediate: !h
        }),
        interpolateLink: $be8ea372f8f49f58$var$J,
        interpolateTextAnchor: $be8ea372f8f49f58$var$K,
        interpolateTextPosition: $be8ea372f8f49f58$var$N
    };
}, $be8ea372f8f49f58$export$ea70f6ffe59d94b1 = function(t) {
    var n = t.center, e = t.data, r = t.label, i = t.skipAngle, a = t.offset, o = t.diagonalLength, u = t.straightLength, l = t.strokeWidth, s = t.textOffset, f = t.textColor, c = t.linkColor, g = t.component, h = void 0 === g ? $be8ea372f8f49f58$var$G : g, v = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(r), x = $be8ea372f8f49f58$export$5a16238ff9674f1b({
        data: e,
        skipAngle: i,
        offset: a,
        diagonalLength: o,
        straightLength: u,
        textOffset: s,
        linkColor: c,
        textColor: f
    }), R = x.transition, m = x.interpolateLink, y = x.interpolateTextAnchor, k = x.interpolateTextPosition, b = h;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: R(function(t, n) {
            return (0, $3ZYaX.createElement)(b, {
                key: n.id,
                datum: n,
                label: v(n),
                style: $be8ea372f8f49f58$var$M({}, t, {
                    thickness: l,
                    path: m(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength),
                    textAnchor: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius),
                    textPosition: k(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, t.offset, t.diagonalLength, t.straightLength, t.textOffset)
                })
            });
        })
    });
}, $be8ea372f8f49f58$export$3aacf153e19c708d = function(t, n, e, r) {
    t.textBaseline = "middle", t.font = e.labels.text.fontSize + "px " + e.labels.text.fontFamily, n.forEach(function(n) {
        t.fillStyle = n.textColor, t.textAlign = (0, $15b6b5b56080a0cd$export$1abb91cfca1e2069).canvas.align[n.textAnchor], t.fillText("" + n.label, n.x, n.y), t.beginPath(), t.strokeStyle = n.linkColor, t.lineWidth = r, n.points.forEach(function(n, e) {
            0 === e ? t.moveTo(n.x, n.y) : t.lineTo(n.x, n.y);
        }), t.stroke();
    });
}, $be8ea372f8f49f58$export$1b7846c545dc3357 = function(t) {
    var n = t.data, e = t.skipAngle, r = void 0 === e ? 0 : e, i = t.offset, o = void 0 === i ? .5 : i, u = t.diagonalLength, l = t.straightLength, s = t.computeExtraProps, d = void 0 === s ? function() {
        return {};
    } : s, f = (0, $3ZYaX.useMemo)(function() {
        return n.filter(function(t) {
            return Math.abs((0, $15b6b5b56080a0cd$export$c41dd2a8460d3196)(t.arc.endAngle - t.arc.startAngle)) >= r;
        }).map(function(t) {
            return $be8ea372f8f49f58$var$M({}, $be8ea372f8f49f58$export$67742f271c0ba17f(t.arc, o, u, l), {
                data: t
            });
        });
    }, [
        n,
        r,
        o,
        u,
        l
    ]);
    return (0, $3ZYaX.useMemo)(function() {
        return f.map(function(t) {
            return $be8ea372f8f49f58$var$M({}, d(t), t);
        });
    }, [
        f,
        d
    ]);
}, $be8ea372f8f49f58$export$a2fecac67fe4140c = function(t) {
    var n = t.data, e = t.skipAngle, r = t.offset, a = t.diagonalLength, o = t.straightLength, u = t.textOffset, l = void 0 === u ? 0 : u, s = t.label, f = t.linkColor, c = t.textColor, g = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(s), p = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), h = (0, $cd313104b6eabfcc$export$2a9e363116151414)(f, p), v = (0, $cd313104b6eabfcc$export$2a9e363116151414)(c, p), A = (0, $3ZYaX.useCallback)(function(t) {
        var n, e = {
            x: t.points[2].x,
            y: t.points[2].y
        };
        return "before" === t.side ? (e.x -= l, n = "end") : (e.x += l, n = "start"), $be8ea372f8f49f58$var$M({}, e, {
            label: g(t.data),
            linkColor: h(t.data),
            textAnchor: n,
            textColor: v(t.data)
        });
    }, [
        g,
        h,
        v,
        l
    ]);
    return $be8ea372f8f49f58$export$1b7846c545dc3357({
        data: n,
        skipAngle: e,
        offset: r,
        diagonalLength: a,
        straightLength: o,
        computeExtraProps: A
    });
}, $be8ea372f8f49f58$export$da1cc05ae2b05876 = $be8ea372f8f49f58$var$G, $be8ea372f8f49f58$var$$ = [
    "animated"
], $be8ea372f8f49f58$export$7f622f5e9941ffc5 = function(e) {
    var r = e.animated, i = function(t, n) {
        if (null == t) return {};
        var e, r, i = {}, a = Object.keys(t);
        for(r = 0; r < a.length; r++)e = a[r], n.indexOf(e) >= 0 || (i[e] = t[e]);
        return i;
    }(e, $be8ea372f8f49f58$var$$);
    return (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).path, $be8ea372f8f49f58$var$M({
        d: (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
            r.radius,
            r.startAngle,
            r.endAngle
        ], function(t, n, e) {
            return function(t, n, e) {
                var r = Math.min(n, e), i = Math.max(n, e), a = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(i), t), l = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(r), t);
                if (i - r >= 360) {
                    var s = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(r + 180), t);
                    return [
                        "M " + a.x + " " + a.y,
                        $be8ea372f8f49f58$var$O(t, 1, 1, s.x, s.y),
                        "M " + a.x + " " + a.y,
                        $be8ea372f8f49f58$var$O(t, 1, 0, s.x, s.y)
                    ].join(" ");
                }
                var d = i - r <= 180 ? 0 : 1;
                return [
                    "M " + a.x + " " + a.y,
                    $be8ea372f8f49f58$var$O(t, d, 0, l.x, l.y)
                ].join(" ");
            }(t, n, e);
        })
    }, i));
}, $be8ea372f8f49f58$export$a259dbdc51948277 = function(n) {
    var e = n.datum, r = n.style, i = n.onClick, a = n.onMouseEnter, o = n.onMouseMove, u = n.onMouseLeave, l = (0, $3ZYaX.useCallback)(function(t) {
        return null == i ? void 0 : i(e, t);
    }, [
        i,
        e
    ]), s = (0, $3ZYaX.useCallback)(function(t) {
        return null == a ? void 0 : a(e, t);
    }, [
        a,
        e
    ]), d = (0, $3ZYaX.useCallback)(function(t) {
        return null == o ? void 0 : o(e, t);
    }, [
        o,
        e
    ]), f = (0, $3ZYaX.useCallback)(function(t) {
        return null == u ? void 0 : u(e, t);
    }, [
        u,
        e
    ]);
    return (0, $4801813bf62cee3c$exports.jsx)((0, $9a653e146f5ceb1c$export$407448d2b89b1813).path, {
        d: r.path,
        opacity: r.opacity,
        fill: e.fill || r.color,
        stroke: r.borderColor,
        strokeWidth: r.borderWidth,
        onClick: i ? l : void 0,
        onMouseEnter: a ? s : void 0,
        onMouseMove: o ? d : void 0,
        onMouseLeave: u ? f : void 0
    });
}, $be8ea372f8f49f58$export$c01f32ffac6cf6f5 = function(t, e, r, i, a) {
    return (0, $775dc606f38f6e3f$export$2c618a4308a30424)([
        t,
        e,
        r,
        i
    ], function(t, n, e, r) {
        return a({
            startAngle: t,
            endAngle: n,
            innerRadius: Math.max(0, e),
            outerRadius: Math.max(0, r)
        });
    });
}, $be8ea372f8f49f58$export$36567afd66e798ad = function(t, n, r) {
    void 0 === n && (n = "innerRadius");
    var i = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), a = i.animate, o = i.config, u = $be8ea372f8f49f58$export$a313c3952fef8fc3(n, r);
    return {
        transition: (0, $775dc606f38f6e3f$export$7b286972b8d8ccbf)(t, {
            keys: function(t) {
                return t.id;
            },
            initial: u.update,
            from: u.enter,
            enter: u.update,
            update: u.update,
            leave: u.leave,
            config: o,
            immediate: !a
        }),
        interpolate: $be8ea372f8f49f58$export$c01f32ffac6cf6f5
    };
}, $be8ea372f8f49f58$export$aa2d92ba89b625ed = function(t) {
    var n = t.center, e = t.data, r = t.arcGenerator, a = t.borderWidth, o = t.borderColor, u = t.onClick, l = t.onMouseEnter, s = t.onMouseMove, d = t.onMouseLeave, f = t.transitionMode, c = t.component, g = void 0 === c ? $be8ea372f8f49f58$export$a259dbdc51948277 : c, h = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), v = (0, $cd313104b6eabfcc$export$2a9e363116151414)(o, h), x = $be8ea372f8f49f58$export$36567afd66e798ad(e, f, {
        enter: function(t) {
            return {
                opacity: 0,
                color: t.color,
                borderColor: v(t)
            };
        },
        update: function(t) {
            return {
                opacity: 1,
                color: t.color,
                borderColor: v(t)
            };
        },
        leave: function(t) {
            return {
                opacity: 0,
                color: t.color,
                borderColor: v(t)
            };
        }
    }), m = x.transition, y = x.interpolate, k = g;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + n[0] + "," + n[1] + ")",
        children: m(function(t, n) {
            return (0, $3ZYaX.createElement)(k, {
                key: n.id,
                datum: n,
                style: $be8ea372f8f49f58$var$M({}, t, {
                    borderWidth: a,
                    path: y(t.startAngle, t.endAngle, t.innerRadius, t.outerRadius, r)
                }),
                onClick: u,
                onMouseEnter: l,
                onMouseMove: s,
                onMouseLeave: d
            });
        })
    });
}, $be8ea372f8f49f58$export$ac350cdccf8fe5e4 = function(t, n, e, r, i, a) {
    void 0 === a && (a = !0);
    var l = [], s = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(r), e);
    l.push([
        s.x,
        s.y
    ]);
    var d = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(i), e);
    l.push([
        d.x,
        d.y
    ]);
    for(var f = Math.round(Math.min(r, i)); f <= Math.round(Math.max(r, i)); f++)if (f % 90 == 0) {
        var c = (0, $15b6b5b56080a0cd$export$2e16b01652730550)((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(f), e);
        l.push([
            c.x,
            c.y
        ]);
    }
    l = l.map(function(e) {
        var r = e[0], i = e[1];
        return [
            t + r,
            n + i
        ];
    }), a && l.push([
        t,
        n
    ]);
    var g = l.map(function(t) {
        return t[0];
    }), p = l.map(function(t) {
        return t[1];
    }), h = Math.min.apply(Math, g), v = Math.max.apply(Math, g), A = Math.min.apply(Math, p);
    return {
        points: l,
        x: h,
        y: A,
        width: v - h,
        height: Math.max.apply(Math, p) - A
    };
}, $be8ea372f8f49f58$export$c1d34fa0d5d8e0e2 = function(t, n, e, r, i, a) {
    var o = (0, $15b6b5b56080a0cd$export$79376507b09a66f)(i, a, t, n);
    return o < e && o > r;
}, $be8ea372f8f49f58$export$f797b637b9988726 = function(t, n, e, r, i, a, o) {
    if ($be8ea372f8f49f58$export$c1d34fa0d5d8e0e2(t, n, e, r, a, o)) {
        var u = (0, $15b6b5b56080a0cd$export$b363da9ded343252)(a, o, t, n);
        return i.find(function(t) {
            var n = t.startAngle, e = t.endAngle;
            return u >= n && u < e;
        });
    }
}, $be8ea372f8f49f58$export$7b66ccfb3ae3d569 = function(t, n) {
    var e = (0, $15b6b5b56080a0cd$export$72acc3dc9629d75d)(), i = e.animate, a = e.config, o = (0, $775dc606f38f6e3f$export$c4af9125706c4d30)({
        startAngle: t.arc.startAngle,
        endAngle: t.arc.endAngle,
        innerRadius: t.arc.innerRadius,
        outerRadius: t.arc.outerRadius,
        config: a,
        immediate: !i
    });
    return $be8ea372f8f49f58$var$M({}, o, {
        path: $be8ea372f8f49f58$export$c01f32ffac6cf6f5(o.startAngle, o.endAngle, o.innerRadius, o.outerRadius, n)
    });
}, $be8ea372f8f49f58$export$9dba50da1768ab65 = function(t) {
    var n = void 0 === t ? {} : t, e = n.cornerRadius, r = void 0 === e ? 0 : e, i = n.padAngle, a = void 0 === i ? 0 : i;
    return (0, $3ZYaX.useMemo)(function() {
        return (0, $59581444d4e99a1a$export$2e2bcd8739ae039)().innerRadius(function(t) {
            return t.innerRadius;
        }).outerRadius(function(t) {
            return t.outerRadius;
        }).cornerRadius(r).padAngle(a);
    }, [
        r,
        a
    ]);
};






function $1f79e6c86c2dca33$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $3157057526e1c80b$export$2e2bcd8739ae039(x) {
    return +x;
}


var $a49bce27aab19626$var$unit = [
    0,
    1
];
function $a49bce27aab19626$export$f0954fd7d5368655(x) {
    return x;
}
function $a49bce27aab19626$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $1f79e6c86c2dca33$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $a49bce27aab19626$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $a49bce27aab19626$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $a49bce27aab19626$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $a49bce27aab19626$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $a49bce27aab19626$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $a49bce27aab19626$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $5529c8c181db0546$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $a49bce27aab19626$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $a49bce27aab19626$export$6b468dcfb64c653c() {
    var domain = $a49bce27aab19626$var$unit, range = $a49bce27aab19626$var$unit, interpolate = (0, $927ebd1811035250$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $a49bce27aab19626$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $a49bce27aab19626$export$f0954fd7d5368655) clamp = $a49bce27aab19626$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $a49bce27aab19626$var$polymap : $a49bce27aab19626$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $7872d4c3789d5642$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $3157057526e1c80b$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $2936309b90bf2fa2$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $a49bce27aab19626$export$f0954fd7d5368655, rescale()) : clamp !== $a49bce27aab19626$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $a49bce27aab19626$export$2e2bcd8739ae039() {
    return $a49bce27aab19626$export$6b468dcfb64c653c()($a49bce27aab19626$export$f0954fd7d5368655, $a49bce27aab19626$export$f0954fd7d5368655);
}


function $9a6e5dfe8febfa23$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $9a6e5dfe8febfa23$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}




function $f112ab4d098abacc$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $c3c5d4ea02a79cf4$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $4e65bfc12433d4f2$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $34cd9214f940bfb1$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $6e6e94f7d2536c6c$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $00607fd966a341e7$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $1751f3d94e8875e5$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $6e6e94f7d2536c6c$export$d9468344d3651243)(specifier);
}


function $a2c759207210997a$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $c3c5d4ea02a79cf4$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $f112ab4d098abacc$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $c3c5d4ea02a79cf4$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $a2c759207210997a$export$2e2bcd8739ae039() {
    var scale = (0, $a49bce27aab19626$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $a49bce27aab19626$export$784d13d8ee351f07)(scale, $a2c759207210997a$export$2e2bcd8739ae039());
    };
    (0, $9a6e5dfe8febfa23$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $a2c759207210997a$export$16a5d4b4a61a274d(scale);
}





var $3ZYaX = parcelRequire("3ZYaX");
var $4333f5b515403c5a$export$15925baccc9f07fd = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $4801813bf62cee3c$exports.jsx)("circle", {
        r: o / 2,
        cx: i + o / 2,
        cy: n + o / 2,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        style: {
            pointerEvents: "none"
        }
    });
}, $4333f5b515403c5a$export$b7efc3c73c701547 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $4801813bf62cee3c$exports.jsx)("path", {
            d: "\n                    M" + o / 2 + " 0\n                    L" + .8 * o + " " + o / 2 + "\n                    L" + o / 2 + " " + o + "\n                    L" + .2 * o + " " + o / 2 + "\n                    L" + o / 2 + " 0\n                ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
}, $4333f5b515403c5a$export$2a536501e4a376d8 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $4801813bf62cee3c$exports.jsx)("rect", {
        x: i,
        y: n,
        fill: r,
        opacity: a,
        strokeWidth: d,
        stroke: void 0 === s ? "transparent" : s,
        width: o,
        height: o,
        style: {
            pointerEvents: "none"
        }
    });
}, $4333f5b515403c5a$export$57cb77afe634ca82 = function(e) {
    var i = e.x, n = e.y, o = e.size, r = e.fill, l = e.opacity, a = void 0 === l ? 1 : l, c = e.borderWidth, d = void 0 === c ? 0 : c, s = e.borderColor;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + i + "," + n + ")",
        children: (0, $4801813bf62cee3c$exports.jsx)("path", {
            d: "\n                M" + o / 2 + " 0\n                L" + o + " " + o + "\n                L0 " + o + "\n                L" + o / 2 + " 0\n            ",
            fill: r,
            opacity: a,
            strokeWidth: d,
            stroke: void 0 === s ? "transparent" : s,
            style: {
                pointerEvents: "none"
            }
        })
    });
};
function $4333f5b515403c5a$var$p() {
    return $4333f5b515403c5a$var$p = Object.assign ? Object.assign.bind() : function(t) {
        for(var e = 1; e < arguments.length; e++){
            var i = arguments[e];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        }
        return t;
    }, $4333f5b515403c5a$var$p.apply(this, arguments);
}
var $4333f5b515403c5a$export$7dcc0eed76218746 = {
    length: 200,
    thickness: 16,
    direction: "row",
    tickPosition: "after",
    tickSize: 4,
    tickSpacing: 3,
    tickOverlap: !1,
    tickFormat: function(t) {
        return "" + t;
    },
    titleAlign: "start",
    titleOffset: 4
}, $4333f5b515403c5a$var$k = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
}, $4333f5b515403c5a$export$158851e184613239 = function(t) {
    var e, i = t.direction, n = t.itemsSpacing, o = t.padding, r = t.itemCount, l = t.itemWidth, a = t.itemHeight;
    if ("number" != typeof o && ("object" != typeof (e = o) || Array.isArray(e) || null === e)) throw new Error("Invalid property padding, must be one of: number, object");
    var c = "number" == typeof o ? {
        top: o,
        right: o,
        bottom: o,
        left: o
    } : $4333f5b515403c5a$var$p({}, $4333f5b515403c5a$var$k, o), d = c.left + c.right, s = c.top + c.bottom, h = l + d, g = a + s, f = (r - 1) * n;
    return "row" === i ? h = l * r + f + d : "column" === i && (g = a * r + f + s), {
        width: h,
        height: g,
        padding: c
    };
}, $4333f5b515403c5a$export$d54b250266589d82 = function(t) {
    var e = t.anchor, i = t.translateX, n = t.translateY, o = t.containerWidth, r = t.containerHeight, l = t.width, a = t.height, c = i, d = n;
    switch(e){
        case "top":
            c += (o - l) / 2;
            break;
        case "top-right":
            c += o - l;
            break;
        case "right":
            c += o - l, d += (r - a) / 2;
            break;
        case "bottom-right":
            c += o - l, d += r - a;
            break;
        case "bottom":
            c += (o - l) / 2, d += r - a;
            break;
        case "bottom-left":
            d += r - a;
            break;
        case "left":
            d += (r - a) / 2;
            break;
        case "center":
            c += (o - l) / 2, d += (r - a) / 2;
    }
    return {
        x: c,
        y: d
    };
}, $4333f5b515403c5a$export$42c02dc685323e86 = function(t) {
    var e, i, n, o, r, l, a = t.direction, c = t.justify, d = t.symbolSize, s = t.symbolSpacing, h = t.width, g = t.height;
    switch(a){
        case "left-to-right":
            e = 0, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = h, r = "end") : (n = d + s, r = "start");
            break;
        case "right-to-left":
            e = h - d, i = (g - d) / 2, o = g / 2, l = "central", c ? (n = 0, r = "start") : (n = h - d - s, r = "end");
            break;
        case "top-to-bottom":
            e = (h - d) / 2, i = 0, n = h / 2, r = "middle", c ? (o = g, l = "alphabetic") : (o = d + s, l = "text-before-edge");
            break;
        case "bottom-to-top":
            e = (h - d) / 2, i = g - d, n = h / 2, r = "middle", c ? (o = 0, l = "text-before-edge") : (o = g - d - s, l = "alphabetic");
    }
    return {
        symbolX: e,
        symbolY: i,
        labelX: n,
        labelY: o,
        labelAnchor: r,
        labelAlignment: l
    };
}, $4333f5b515403c5a$export$92bd5bd2fa4d30f9 = function(t) {
    var e, o = t.scale, r = t.ticks, l = t.length, c = void 0 === l ? $4333f5b515403c5a$export$7dcc0eed76218746.length : l, d = t.thickness, s = void 0 === d ? $4333f5b515403c5a$export$7dcc0eed76218746.thickness : d, h = t.direction, g = void 0 === h ? $4333f5b515403c5a$export$7dcc0eed76218746.direction : h, f = t.tickPosition, m = void 0 === f ? $4333f5b515403c5a$export$7dcc0eed76218746.tickPosition : f, v = t.tickSize, u = void 0 === v ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSize : v, p = t.tickSpacing, k = void 0 === p ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSpacing : p, x = t.tickOverlap, b = void 0 === x ? $4333f5b515403c5a$export$7dcc0eed76218746.tickOverlap : x, S = t.tickFormat, A = void 0 === S ? $4333f5b515403c5a$export$7dcc0eed76218746.tickFormat : S, W = t.title, z = t.titleAlign, C = void 0 === z ? $4333f5b515403c5a$export$7dcc0eed76218746.titleAlign : z, w = t.titleOffset, X = void 0 === w ? $4333f5b515403c5a$export$7dcc0eed76218746.titleOffset : w, Y = "column" === g ? [].concat(o.domain()).reverse() : o.domain(), O = (0, $a2c759207210997a$export$2e2bcd8739ae039)().domain(Y);
    2 === Y.length ? O.range([
        0,
        c
    ]) : 3 === Y.length && O.range([
        0,
        c / 2,
        c
    ]), e = "thresholds" in o ? [
        Y[0]
    ].concat(o.thresholds(), [
        Y[1]
    ]) : Array.isArray(r) ? r : o.ticks(r);
    var B, H, E, j, L, M, F = (0, $cd313104b6eabfcc$export$f6ca0f82846310a7)(o, 32), T = (0, $15b6b5b56080a0cd$export$f037bf6aad5a4e75)(A), P = [], V = 0, R = 0;
    if ("row" === g) {
        var D, q, G;
        B = c, H = s, R = 1;
        var I;
        L = 0, E = "start" === C ? 0 : "middle" === C ? c / 2 : c, "before" === m ? (D = -u, q = b ? s : 0, G = -u - k, I = "alphabetic", j = s + X, M = "hanging") : (D = b ? 0 : s, G = (q = s + u) + k, I = "hanging", j = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: e,
                y1: D,
                x2: e,
                y2: q,
                text: T(t),
                textX: e,
                textY: G,
                textHorizontalAlign: "middle",
                textVerticalAlign: I
            });
        });
    } else {
        var N, _, J, K;
        B = s, H = c, V = 1;
        L = -90, j = "start" === C ? c : "middle" === C ? c / 2 : 0, "before" === m ? (_ = b ? s : 0, J = (N = -u) - k, K = "end", E = s + X, M = "hanging") : (N = b ? 0 : s, J = (_ = s + u) + k, K = "start", E = -X, M = "alphabetic"), e.forEach(function(t) {
            var e = O(t);
            P.push({
                x1: N,
                y1: e,
                x2: _,
                y2: e,
                text: T(t),
                textX: J,
                textY: e,
                textHorizontalAlign: K,
                textVerticalAlign: "central"
            });
        });
    }
    return {
        width: B,
        height: H,
        gradientX1: 0,
        gradientY1: V,
        gradientX2: R,
        gradientY2: 0,
        colorStops: F,
        ticks: P,
        titleText: W,
        titleX: E,
        titleY: j,
        titleRotation: L,
        titleHorizontalAlign: C,
        titleVerticalAlign: M
    };
}, $4333f5b515403c5a$export$75a7f8b459abeba9 = function(i) {
    var n = i.scale, r = i.ticks, l = i.length, a = void 0 === l ? $4333f5b515403c5a$export$7dcc0eed76218746.length : l, c = i.thickness, s = void 0 === c ? $4333f5b515403c5a$export$7dcc0eed76218746.thickness : c, h = i.direction, g = void 0 === h ? $4333f5b515403c5a$export$7dcc0eed76218746.direction : h, f = i.tickPosition, m = void 0 === f ? $4333f5b515403c5a$export$7dcc0eed76218746.tickPosition : f, v = i.tickSize, u = void 0 === v ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSize : v, k = i.tickSpacing, x = void 0 === k ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSpacing : k, b = i.tickOverlap, S = void 0 === b ? $4333f5b515403c5a$export$7dcc0eed76218746.tickOverlap : b, W = i.tickFormat, z = void 0 === W ? $4333f5b515403c5a$export$7dcc0eed76218746.tickFormat : W, C = i.title, w = i.titleAlign, X = void 0 === w ? $4333f5b515403c5a$export$7dcc0eed76218746.titleAlign : w, Y = i.titleOffset, O = $4333f5b515403c5a$export$92bd5bd2fa4d30f9({
        scale: n,
        ticks: r,
        length: a,
        thickness: s,
        direction: g,
        tickPosition: m,
        tickSize: u,
        tickSpacing: x,
        tickOverlap: S,
        tickFormat: z,
        title: C,
        titleAlign: X,
        titleOffset: void 0 === Y ? $4333f5b515403c5a$export$7dcc0eed76218746.titleOffset : Y
    }), B = O.width, H = O.height, E = O.gradientX1, j = O.gradientY1, L = O.gradientX2, M = O.gradientY2, F = O.ticks, T = O.colorStops, P = O.titleText, V = O.titleX, R = O.titleY, D = O.titleRotation, q = O.titleVerticalAlign, G = O.titleHorizontalAlign, I = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), N = "ContinuousColorsLegendSvgGradient." + g + "." + T.map(function(t) {
        return t.offset;
    }).join("_");
    return (0, $4801813bf62cee3c$exports.jsxs)("g", {
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("defs", {
                children: (0, $4801813bf62cee3c$exports.jsx)("linearGradient", {
                    id: N,
                    x1: E,
                    y1: j,
                    x2: L,
                    y2: M,
                    children: T.map(function(e) {
                        return (0, $4801813bf62cee3c$exports.jsx)("stop", $4333f5b515403c5a$var$p({}, e));
                    })
                })
            }),
            P && (0, $4801813bf62cee3c$exports.jsx)("text", {
                transform: "translate(" + V + ", " + R + ") rotate(" + D + ")",
                textAnchor: G,
                dominantBaseline: q,
                style: I.legends.title.text,
                children: P
            }),
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: B,
                height: H,
                fill: "url(#" + N
            }),
            F.map(function(i, n) {
                return (0, $4801813bf62cee3c$exports.jsxs)((0, $3ZYaX.Fragment), {
                    children: [
                        (0, $4801813bf62cee3c$exports.jsx)("line", {
                            x1: i.x1,
                            y1: i.y1,
                            x2: i.x2,
                            y2: i.y2,
                            style: I.legends.ticks.line
                        }),
                        (0, $4801813bf62cee3c$exports.jsx)("text", {
                            x: i.textX,
                            y: i.textY,
                            textAnchor: i.textHorizontalAlign,
                            dominantBaseline: i.textVerticalAlign,
                            style: I.legends.ticks.text,
                            children: i.text
                        })
                    ]
                }, n);
            })
        ]
    });
}, $4333f5b515403c5a$var$z = [
    "containerWidth",
    "containerHeight",
    "anchor",
    "translateX",
    "translateY",
    "length",
    "thickness",
    "direction"
], $4333f5b515403c5a$export$b3a69bafe074dddd = function(e) {
    var i, n, o = e.containerWidth, r = e.containerHeight, l = e.anchor, a = e.translateX, c = void 0 === a ? 0 : a, d = e.translateY, s = void 0 === d ? 0 : d, h = e.length, g = void 0 === h ? $4333f5b515403c5a$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $4333f5b515403c5a$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $4333f5b515403c5a$export$7dcc0eed76218746.direction : v, k = function(t, e) {
        if (null == t) return {};
        var i, n, o = {}, r = Object.keys(t);
        for(n = 0; n < r.length; n++)i = r[n], e.indexOf(i) >= 0 || (o[i] = t[i]);
        return o;
    }(e, $4333f5b515403c5a$var$z);
    "row" === u ? (i = g, n = m) : (i = m, n = g);
    var x = $4333f5b515403c5a$export$d54b250266589d82({
        anchor: l,
        translateX: c,
        translateY: s,
        containerWidth: o,
        containerHeight: r,
        width: i,
        height: n
    }), S = x.x, A = x.y;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + S + ", " + A + ")",
        children: (0, $4801813bf62cee3c$exports.jsx)($4333f5b515403c5a$export$75a7f8b459abeba9, $4333f5b515403c5a$var$p({
            length: g,
            thickness: m,
            direction: u
        }, k))
    });
}, $4333f5b515403c5a$var$w = {
    circle: $4333f5b515403c5a$export$15925baccc9f07fd,
    diamond: $4333f5b515403c5a$export$b7efc3c73c701547,
    square: $4333f5b515403c5a$export$2a536501e4a376d8,
    triangle: $4333f5b515403c5a$export$57cb77afe634ca82
}, $4333f5b515403c5a$export$cfc3a318dc419256 = function(i) {
    var n, l, a, d, g, f, m, v, u, y, k, x = i.x, b = i.y, A = i.width, W = i.height, z = i.data, C = i.direction, X = void 0 === C ? "left-to-right" : C, Y = i.justify, O = void 0 !== Y && Y, B = i.textColor, H = i.background, E = void 0 === H ? "transparent" : H, j = i.opacity, L = void 0 === j ? 1 : j, M = i.symbolShape, F = void 0 === M ? "square" : M, T = i.symbolSize, P = void 0 === T ? 16 : T, V = i.symbolSpacing, R = void 0 === V ? 8 : V, D = i.symbolBorderWidth, q = void 0 === D ? 0 : D, G = i.symbolBorderColor, I = void 0 === G ? "transparent" : G, N = i.onClick, _ = i.onMouseEnter, J = i.onMouseLeave, K = i.toggleSerie, Q = i.effects, U = (0, $3ZYaX.useState)({}), Z = U[0], $ = U[1], tt = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), et = (0, $3ZYaX.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" === t.on;
            }).reduce(function(t, e) {
                return $4333f5b515403c5a$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == _ || _(z, t);
    }, [
        _,
        z,
        Q
    ]), it = (0, $3ZYaX.useCallback)(function(t) {
        if (Q) {
            var e = Q.filter(function(t) {
                return "hover" !== t.on;
            }).reduce(function(t, e) {
                return $4333f5b515403c5a$var$p({}, t, e.style);
            }, {});
            $(e);
        }
        null == J || J(z, t);
    }, [
        J,
        z,
        Q
    ]), nt = $4333f5b515403c5a$export$42c02dc685323e86({
        direction: X,
        justify: O,
        symbolSize: null != (n = Z.symbolSize) ? n : P,
        symbolSpacing: R,
        width: A,
        height: W
    }), ot = nt.symbolX, rt = nt.symbolY, lt = nt.labelX, at = nt.labelY, ct = nt.labelAnchor, dt = nt.labelAlignment, st = [
        N,
        _,
        J,
        K
    ].some(function(t) {
        return void 0 !== t;
    }), ht = "function" == typeof F ? F : $4333f5b515403c5a$var$w[F];
    return (0, $4801813bf62cee3c$exports.jsxs)("g", {
        transform: "translate(" + x + "," + b + ")",
        style: {
            opacity: null != (l = Z.itemOpacity) ? l : L
        },
        children: [
            (0, $4801813bf62cee3c$exports.jsx)("rect", {
                width: A,
                height: W,
                fill: null != (a = Z.itemBackground) ? a : E,
                style: {
                    cursor: st ? "pointer" : "auto"
                },
                onClick: function(t) {
                    null == N || N(z, t), null == K || K(z.id);
                },
                onMouseEnter: et,
                onMouseLeave: it
            }),
            $3ZYaX.createElement(ht, $4333f5b515403c5a$var$p({
                id: z.id,
                x: ot,
                y: rt,
                size: null != (d = Z.symbolSize) ? d : P,
                fill: null != (g = null != (f = z.fill) ? f : z.color) ? g : "black",
                borderWidth: null != (m = Z.symbolBorderWidth) ? m : q,
                borderColor: null != (v = Z.symbolBorderColor) ? v : I
            }, z.hidden ? tt.legends.hidden.symbol : void 0)),
            (0, $4801813bf62cee3c$exports.jsx)("text", {
                textAnchor: ct,
                style: $4333f5b515403c5a$var$p({}, (0, $15b6b5b56080a0cd$export$c30625df7c8afdb5)(tt.legends.text), {
                    fill: null != (u = null != (y = null != (k = Z.itemTextColor) ? k : B) ? y : tt.legends.text.fill) ? u : "black",
                    dominantBaseline: dt,
                    pointerEvents: "none",
                    userSelect: "none"
                }, z.hidden ? tt.legends.hidden.text : void 0),
                x: lt,
                y: at,
                children: z.label
            })
        ]
    });
}, $4333f5b515403c5a$export$31ce35324c7aa71 = function(e) {
    var i = e.data, n = e.x, o = e.y, r = e.direction, l = e.padding, a = void 0 === l ? 0 : l, c = e.justify, d = e.effects, s = e.itemWidth, h = e.itemHeight, g = e.itemDirection, f = void 0 === g ? "left-to-right" : g, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemTextColor, p = e.itemBackground, y = void 0 === p ? "transparent" : p, k = e.itemOpacity, b = void 0 === k ? 1 : k, S = e.symbolShape, A = e.symbolSize, W = e.symbolSpacing, z = e.symbolBorderWidth, C = e.symbolBorderColor, w = e.onClick, Y = e.onMouseEnter, O = e.onMouseLeave, B = e.toggleSerie, H = $4333f5b515403c5a$export$158851e184613239({
        itemCount: i.length,
        itemWidth: s,
        itemHeight: h,
        itemsSpacing: v,
        direction: r,
        padding: a
    }).padding, E = "row" === r ? s + v : 0, j = "column" === r ? h + v : 0;
    return (0, $4801813bf62cee3c$exports.jsx)("g", {
        transform: "translate(" + n + "," + o + ")",
        children: i.map(function(e, i) {
            return (0, $4801813bf62cee3c$exports.jsx)($4333f5b515403c5a$export$cfc3a318dc419256, {
                data: e,
                x: i * E + H.left,
                y: i * j + H.top,
                width: s,
                height: h,
                direction: f,
                justify: c,
                effects: d,
                textColor: u,
                background: y,
                opacity: b,
                symbolShape: S,
                symbolSize: A,
                symbolSpacing: W,
                symbolBorderWidth: z,
                symbolBorderColor: C,
                onClick: w,
                onMouseEnter: Y,
                onMouseLeave: O,
                toggleSerie: B
            }, i);
        })
    });
}, $4333f5b515403c5a$export$238a2f791d4948f7 = function(e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = e.itemsSpacing, v = void 0 === m ? 0 : m, u = e.itemWidth, p = e.itemHeight, y = e.itemDirection, k = e.itemTextColor, S = e.itemBackground, A = e.itemOpacity, W = e.symbolShape, z = e.symbolSize, C = e.symbolSpacing, w = e.symbolBorderWidth, X = e.symbolBorderColor, O = e.onClick, B = e.onMouseEnter, H = e.onMouseLeave, E = e.toggleSerie, j = e.effects, L = $4333f5b515403c5a$export$158851e184613239({
        itemCount: i.length,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        direction: s,
        padding: g
    }), M = L.width, F = L.height, T = $4333f5b515403c5a$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: M,
        height: F
    }), P = T.x, V = T.y;
    return (0, $4801813bf62cee3c$exports.jsx)($4333f5b515403c5a$export$31ce35324c7aa71, {
        data: i,
        x: P,
        y: V,
        direction: s,
        padding: g,
        justify: f,
        effects: j,
        itemsSpacing: v,
        itemWidth: u,
        itemHeight: p,
        itemDirection: y,
        itemTextColor: k,
        itemBackground: S,
        itemOpacity: A,
        symbolShape: W,
        symbolSize: z,
        symbolSpacing: C,
        symbolBorderWidth: w,
        symbolBorderColor: X,
        onClick: O,
        onMouseEnter: B,
        onMouseLeave: H,
        toggleSerie: "boolean" == typeof E ? void 0 : E
    });
}, $4333f5b515403c5a$var$B = {
    start: "left",
    middle: "center",
    end: "right"
}, $4333f5b515403c5a$export$28c0156604402604 = function(t, e) {
    var i = e.data, n = e.containerWidth, o = e.containerHeight, r = e.translateX, l = void 0 === r ? 0 : r, a = e.translateY, c = void 0 === a ? 0 : a, d = e.anchor, s = e.direction, h = e.padding, g = void 0 === h ? 0 : h, f = e.justify, m = void 0 !== f && f, v = e.itemsSpacing, u = void 0 === v ? 0 : v, p = e.itemWidth, y = e.itemHeight, k = e.itemDirection, A = void 0 === k ? "left-to-right" : k, W = e.itemTextColor, z = e.symbolSize, C = void 0 === z ? 16 : z, w = e.symbolSpacing, X = void 0 === w ? 8 : w, Y = e.theme, O = $4333f5b515403c5a$export$158851e184613239({
        itemCount: i.length,
        itemWidth: p,
        itemHeight: y,
        itemsSpacing: u,
        direction: s,
        padding: g
    }), H = O.width, E = O.height, j = O.padding, L = $4333f5b515403c5a$export$d54b250266589d82({
        anchor: d,
        translateX: l,
        translateY: c,
        containerWidth: n,
        containerHeight: o,
        width: H,
        height: E
    }), M = L.x, F = L.y, T = "row" === s ? p + u : 0, P = "column" === s ? y + u : 0;
    t.save(), t.translate(M, F), t.font = Y.legends.text.fontSize + "px " + (Y.legends.text.fontFamily || "sans-serif"), i.forEach(function(e, i) {
        var n, o, r = i * T + j.left, l = i * P + j.top, a = $4333f5b515403c5a$export$42c02dc685323e86({
            direction: A,
            justify: m,
            symbolSize: C,
            symbolSpacing: X,
            width: p,
            height: y
        }), c = a.symbolX, d = a.symbolY, s = a.labelX, h = a.labelY, g = a.labelAnchor, f = a.labelAlignment;
        t.fillStyle = null != (n = e.color) ? n : "black", t.fillRect(r + c, l + d, C, C), t.textAlign = $4333f5b515403c5a$var$B[g], "central" === f && (t.textBaseline = "middle"), t.fillStyle = null != (o = null != W ? W : Y.legends.text.fill) ? o : "black", t.fillText(String(e.label), r + s, l + h);
    }), t.restore();
}, $4333f5b515403c5a$export$d0f8bf7e3d86bbb5 = function(t, e) {
    var i = e.containerWidth, n = e.containerHeight, o = e.anchor, r = e.translateX, a = void 0 === r ? 0 : r, c = e.translateY, d = void 0 === c ? 0 : c, s = e.scale, h = e.length, g = void 0 === h ? $4333f5b515403c5a$export$7dcc0eed76218746.length : h, f = e.thickness, m = void 0 === f ? $4333f5b515403c5a$export$7dcc0eed76218746.thickness : f, v = e.direction, u = void 0 === v ? $4333f5b515403c5a$export$7dcc0eed76218746.direction : v, p = e.ticks, k = e.tickPosition, x = void 0 === k ? $4333f5b515403c5a$export$7dcc0eed76218746.tickPosition : k, S = e.tickSize, W = void 0 === S ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSize : S, z = e.tickSpacing, C = void 0 === z ? $4333f5b515403c5a$export$7dcc0eed76218746.tickSpacing : z, w = e.tickOverlap, X = void 0 === w ? $4333f5b515403c5a$export$7dcc0eed76218746.tickOverlap : w, Y = e.tickFormat, O = void 0 === Y ? $4333f5b515403c5a$export$7dcc0eed76218746.tickFormat : Y, B = e.title, H = e.titleAlign, E = void 0 === H ? $4333f5b515403c5a$export$7dcc0eed76218746.titleAlign : H, j = e.titleOffset, L = void 0 === j ? $4333f5b515403c5a$export$7dcc0eed76218746.titleOffset : j, M = e.theme, F = $4333f5b515403c5a$export$92bd5bd2fa4d30f9({
        scale: s,
        ticks: p,
        length: g,
        thickness: m,
        direction: u,
        tickPosition: x,
        tickSize: W,
        tickSpacing: C,
        tickOverlap: X,
        tickFormat: O,
        title: B,
        titleAlign: E,
        titleOffset: L
    }), T = F.width, P = F.height, V = F.gradientX1, R = F.gradientY1, D = F.gradientX2, q = F.gradientY2, G = F.colorStops, I = F.ticks, N = F.titleText, _ = F.titleX, J = F.titleY, K = F.titleRotation, Q = F.titleVerticalAlign, U = F.titleHorizontalAlign, Z = $4333f5b515403c5a$export$d54b250266589d82({
        anchor: o,
        translateX: a,
        translateY: d,
        containerWidth: i,
        containerHeight: n,
        width: T,
        height: P
    }), $ = Z.x, tt = Z.y, et = {
        font: t.font,
        textAlign: t.textAlign,
        textBaseline: t.textBaseline
    };
    t.save(), t.translate($, tt);
    var it = t.createLinearGradient(V * T, R * P, D * T, q * P);
    G.forEach(function(t) {
        it.addColorStop(t.offset, t.stopColor);
    }), t.fillStyle = it, t.fillRect(0, 0, T, P), t.font = (M.legends.ticks.text.fontWeight ? M.legends.ticks.text.fontWeight + " " : "") + M.legends.ticks.text.fontSize + "px " + M.legends.ticks.text.fontFamily, I.forEach(function(e) {
        var i;
        (null != (i = M.legends.ticks.line.strokeWidth) ? i : 0) > 0 && (t.lineWidth = Number(M.axis.ticks.line.strokeWidth), M.axis.ticks.line.stroke && (t.strokeStyle = M.axis.ticks.line.stroke), t.lineCap = "square", t.beginPath(), t.moveTo(e.x1, e.y1), t.lineTo(e.x2, e.y2), t.stroke()), M.legends.ticks.text.fill && (t.fillStyle = M.legends.ticks.text.fill), t.textAlign = "middle" === e.textHorizontalAlign ? "center" : e.textHorizontalAlign, t.textBaseline = "central" === e.textVerticalAlign ? "middle" : e.textVerticalAlign, t.fillText(e.text, e.textX, e.textY);
    }), N && (t.save(), t.translate(_, J), t.rotate((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(K)), t.font = (M.legends.title.text.fontWeight ? M.legends.title.text.fontWeight + " " : "") + M.legends.title.text.fontSize + "px " + M.legends.title.text.fontFamily, M.legends.title.text.fill && (t.fillStyle = M.legends.title.text.fill), t.textAlign = "middle" === U ? "center" : U, t.textBaseline = Q, t.fillText(N, 0, 0), t.restore()), t.restore(), t.font = et.font, t.textAlign = et.textAlign, t.textBaseline = et.textBaseline;
}, $4333f5b515403c5a$export$419bf2ab46804c4 = function(t) {
    var e = t.scale, i = t.domain, n = t.reverse, o = void 0 !== n && n, r = t.valueFormat, l = void 0 === r ? function(t) {
        return t;
    } : r, a = t.separator, c = void 0 === a ? " - " : a;
    return (0, $3ZYaX.useMemo)(function() {
        var t = (null != i ? i : e.range()).map(function(t, i) {
            var n = e.invertExtent(t), o = n[0], r = n[1];
            return {
                id: t,
                index: i,
                extent: [
                    o,
                    r
                ],
                label: "" + l(o) + c + l(r),
                value: e(o),
                color: t
            };
        });
        return o && t.reverse(), t;
    }, [
        i,
        e,
        o,
        c,
        l
    ]);
};



var $9c44b8bec1e4814d$export$58adb3bec8346d0f = Array.prototype.slice;
function $9c44b8bec1e4814d$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $d7a441413b1b98db$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $ce87b2e3800f5129$export$2e2bcd8739ae039(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}


function $4af6327d73353aa5$export$2e2bcd8739ae039(d) {
    return d;
}


const $3e8145779bd8018c$export$2335f513bbd82c6d = Math.abs;
const $3e8145779bd8018c$export$b8b770ee6a0d9760 = Math.atan2;
const $3e8145779bd8018c$export$50d414a77b60d802 = Math.cos;
const $3e8145779bd8018c$export$8960430cfd85939f = Math.max;
const $3e8145779bd8018c$export$96ec731ed4dcb222 = Math.min;
const $3e8145779bd8018c$export$5de3937cb4b592ed = Math.sin;
const $3e8145779bd8018c$export$eba8049fb5020b81 = Math.sqrt;
const $3e8145779bd8018c$export$6c421550c66a327d = 1e-12;
const $3e8145779bd8018c$export$18c7bea995a110f = Math.PI;
const $3e8145779bd8018c$export$e51408a300e8929a = $3e8145779bd8018c$export$18c7bea995a110f / 2;
const $3e8145779bd8018c$export$a4b4b4d4d776fe92 = 2 * $3e8145779bd8018c$export$18c7bea995a110f;
function $3e8145779bd8018c$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $3e8145779bd8018c$export$18c7bea995a110f : Math.acos(x);
}
function $3e8145779bd8018c$export$41726bdb1fc63f(x) {
    return x >= 1 ? $3e8145779bd8018c$export$e51408a300e8929a : x <= -1 ? -$3e8145779bd8018c$export$e51408a300e8929a : Math.asin(x);
}


function $eba0d5f1452d3e10$export$2e2bcd8739ae039() {
    var value = (0, $4af6327d73353aa5$export$2e2bcd8739ae039), sortValues = (0, $ce87b2e3800f5129$export$2e2bcd8739ae039), sort = null, startAngle = (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(0), endAngle = (0, $d7a441413b1b98db$export$2e2bcd8739ae039)((0, $3e8145779bd8018c$export$a4b4b4d4d776fe92)), padAngle = (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(0);
    function pie(data) {
        var i, n = (data = (0, $9c44b8bec1e4814d$export$2e2bcd8739ae039)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min((0, $3e8145779bd8018c$export$a4b4b4d4d776fe92), Math.max(-(0, $3e8145779bd8018c$export$a4b4b4d4d776fe92), endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $d7a441413b1b98db$export$2e2bcd8739ae039)(+_), pie) : padAngle;
    };
    return pie;
}




function $3c37c0e2656b4083$var$E() {
    return $3c37c0e2656b4083$var$E = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var i = arguments[t];
            for(var n in i)Object.prototype.hasOwnProperty.call(i, n) && (e[n] = i[n]);
        }
        return e;
    }, $3c37c0e2656b4083$var$E.apply(this, arguments);
}
function $3c37c0e2656b4083$var$F(e, t) {
    if (null == e) return {};
    var i, n, a = {}, r = Object.keys(e);
    for(n = 0; n < r.length; n++)i = r[n], t.indexOf(i) >= 0 || (a[i] = e[i]);
    return a;
}
var $3c37c0e2656b4083$var$H, $3c37c0e2656b4083$var$X = function(e) {
    var t = e.width, i = e.height, n = e.legends, a = e.data, r = e.toggleSerie;
    return (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: n.map(function(e, n) {
            var o;
            return (0, $4801813bf62cee3c$exports.jsx)((0, $4333f5b515403c5a$export$238a2f791d4948f7), $3c37c0e2656b4083$var$E({}, e, {
                containerWidth: t,
                containerHeight: i,
                data: null != (o = e.data) ? o : a,
                toggleSerie: e.toggleSerie ? r : void 0
            }), n);
        })
    });
}, $3c37c0e2656b4083$export$9c21a3269931e1e6 = {
    id: "id",
    value: "value",
    sortByValue: !1,
    innerRadius: 0,
    padAngle: 0,
    cornerRadius: 0,
    layers: [
        "arcs",
        "arcLinkLabels",
        "arcLabels",
        "legends"
    ],
    startAngle: 0,
    endAngle: 360,
    fit: !0,
    activeInnerRadiusOffset: 0,
    activeOuterRadiusOffset: 0,
    borderWidth: 0,
    borderColor: {
        from: "color",
        modifiers: [
            [
                "darker",
                1
            ]
        ]
    },
    enableArcLabels: !0,
    arcLabel: "formattedValue",
    arcLabelsSkipAngle: 0,
    arcLabelsRadiusOffset: .5,
    arcLabelsTextColor: {
        theme: "labels.text.fill"
    },
    enableArcLinkLabels: !0,
    arcLinkLabel: "id",
    arcLinkLabelsSkipAngle: 0,
    arcLinkLabelsOffset: 0,
    arcLinkLabelsDiagonalLength: 16,
    arcLinkLabelsStraightLength: 24,
    arcLinkLabelsThickness: 1,
    arcLinkLabelsTextOffset: 6,
    arcLinkLabelsTextColor: {
        theme: "labels.text.fill"
    },
    arcLinkLabelsColor: {
        theme: "axis.ticks.line.stroke"
    },
    colors: {
        scheme: "nivo"
    },
    defs: [],
    fill: [],
    isInteractive: !0,
    animate: !0,
    motionConfig: "gentle",
    transitionMode: "innerRadius",
    tooltip: function(e) {
        var t = e.datum;
        return (0, $4801813bf62cee3c$exports.jsx)((0, $881f54acd386f31e$export$d5f52d71198e271a), {
            id: t.id,
            value: t.formattedValue,
            enableChip: !0,
            color: t.color
        });
    },
    legends: [],
    role: "img",
    pixelRatio: "undefined" != typeof window && null != ($3c37c0e2656b4083$var$H = window.devicePixelRatio) ? $3c37c0e2656b4083$var$H : 1
}, $3c37c0e2656b4083$var$j = [
    "points"
], $3c37c0e2656b4083$export$dcf407681f3a467d = function(t) {
    var i = t.data, n = t.id, a = void 0 === n ? $3c37c0e2656b4083$export$9c21a3269931e1e6.id : n, r = t.value, o = void 0 === r ? $3c37c0e2656b4083$export$9c21a3269931e1e6.value : r, s = t.valueFormat, c = t.colors, u = void 0 === c ? $3c37c0e2656b4083$export$9c21a3269931e1e6.colors : c, v = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(a), f = (0, $15b6b5b56080a0cd$export$2d590546cbb7e3ad)(o), g = (0, $15b6b5b56080a0cd$export$422f9765e6971fdf)(s), L = (0, $cd313104b6eabfcc$export$47939777be1516f5)(u, "id");
    return (0, $3ZYaX.useMemo)(function() {
        return i.map(function(e) {
            var t, i = v(e), n = f(e), a = {
                id: i,
                label: null != (t = e.label) ? t : i,
                hidden: !1,
                value: n,
                formattedValue: g(n),
                data: e
            };
            return $3c37c0e2656b4083$var$E({}, a, {
                color: L(a)
            });
        });
    }, [
        i,
        v,
        f,
        g,
        L
    ]);
}, $3c37c0e2656b4083$export$b3e3150fa43f236d = function(n) {
    var a = n.data, r = n.startAngle, o = n.endAngle, d = n.innerRadius, l = n.outerRadius, u = n.padAngle, v = n.sortByValue, f = n.activeId, g = n.activeInnerRadiusOffset, L = n.activeOuterRadiusOffset, h = n.hiddenIds, b = n.forwardLegendData, A = (0, $3ZYaX.useMemo)(function() {
        var e = (0, $eba0d5f1452d3e10$export$2e2bcd8739ae039)().value(function(e) {
            return e.value;
        }).startAngle((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(r)).endAngle((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(o)).padAngle((0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(u));
        return v || e.sortValues(null), e;
    }, [
        r,
        o,
        u,
        v
    ]), p = (0, $3ZYaX.useMemo)(function() {
        var e = a.filter(function(e) {
            return !h.includes(e.id);
        });
        return {
            dataWithArc: A(e).map(function(e) {
                var t = Math.abs(e.endAngle - e.startAngle);
                return $3c37c0e2656b4083$var$E({}, e.data, {
                    arc: {
                        index: e.index,
                        startAngle: e.startAngle,
                        endAngle: e.endAngle,
                        innerRadius: f === e.data.id ? d - g : d,
                        outerRadius: f === e.data.id ? l + L : l,
                        thickness: l - d,
                        padAngle: e.padAngle,
                        angle: t,
                        angleDeg: (0, $15b6b5b56080a0cd$export$c41dd2a8460d3196)(t)
                    }
                });
            }),
            legendData: a.map(function(e) {
                return {
                    id: e.id,
                    label: e.label,
                    color: e.color,
                    hidden: h.includes(e.id),
                    data: e
                };
            })
        };
    }, [
        A,
        a,
        h,
        f,
        d,
        g,
        l,
        L
    ]), k = p.legendData, I = (0, $3ZYaX.useRef)(b);
    return (0, $3ZYaX.useEffect)(function() {
        "function" == typeof I.current && I.current(k);
    }, [
        I,
        k
    ]), p;
}, $3c37c0e2656b4083$var$z = function(e) {
    var t = e.activeId, i = e.onActiveIdChange, r = e.defaultActiveId, o = void 0 !== t, d = (0, $3ZYaX.useState)(o ? null : void 0 === r ? null : r), l = d[0], s = d[1];
    return {
        activeId: o ? t : l,
        setActiveId: (0, $3ZYaX.useCallback)(function(e) {
            i && i(e), o || s(e);
        }, [
            o,
            i,
            s
        ])
    };
}, $3c37c0e2656b4083$export$2eb91d8e84ccbdd0 = function(e) {
    var t = e.data, i = e.radius, r = e.innerRadius, o = e.startAngle, d = void 0 === o ? $3c37c0e2656b4083$export$9c21a3269931e1e6.startAngle : o, l = e.endAngle, c = void 0 === l ? $3c37c0e2656b4083$export$9c21a3269931e1e6.endAngle : l, u = e.padAngle, v = void 0 === u ? $3c37c0e2656b4083$export$9c21a3269931e1e6.padAngle : u, f = e.sortByValue, g = void 0 === f ? $3c37c0e2656b4083$export$9c21a3269931e1e6.sortByValue : f, L = e.cornerRadius, h = void 0 === L ? $3c37c0e2656b4083$export$9c21a3269931e1e6.cornerRadius : L, b = e.activeInnerRadiusOffset, p = void 0 === b ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeInnerRadiusOffset : b, k = e.activeOuterRadiusOffset, I = void 0 === k ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeOuterRadiusOffset : k, R = e.activeId, m = e.onActiveIdChange, O = e.defaultActiveId, C = e.forwardLegendData, x = $3c37c0e2656b4083$var$z({
        activeId: R,
        onActiveIdChange: m,
        defaultActiveId: O
    }), w = x.activeId, M = x.setActiveId, y = (0, $3ZYaX.useState)([]), W = y[0], S = y[1], T = $3c37c0e2656b4083$export$b3e3150fa43f236d({
        data: t,
        startAngle: d,
        endAngle: c,
        innerRadius: r,
        outerRadius: i,
        padAngle: v,
        sortByValue: g,
        activeId: w,
        activeInnerRadiusOffset: p,
        activeOuterRadiusOffset: I,
        hiddenIds: W,
        forwardLegendData: C
    }), D = (0, $3ZYaX.useCallback)(function(e) {
        S(function(t) {
            return t.indexOf(e) > -1 ? t.filter(function(t) {
                return t !== e;
            }) : [].concat(t, [
                e
            ]);
        });
    }, []);
    return $3c37c0e2656b4083$var$E({}, T, {
        arcGenerator: (0, $be8ea372f8f49f58$export$9dba50da1768ab65)({
            cornerRadius: h,
            padAngle: (0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(v)
        }),
        setActiveId: M,
        toggleSerie: D
    });
}, $3c37c0e2656b4083$export$eae94ae087ae8903 = function(t) {
    var i = t.data, r = t.width, o = t.height, d = t.innerRadius, l = void 0 === d ? $3c37c0e2656b4083$export$9c21a3269931e1e6.innerRadius : d, c = t.startAngle, u = void 0 === c ? $3c37c0e2656b4083$export$9c21a3269931e1e6.startAngle : c, v = t.endAngle, f = void 0 === v ? $3c37c0e2656b4083$export$9c21a3269931e1e6.endAngle : v, g = t.padAngle, L = void 0 === g ? $3c37c0e2656b4083$export$9c21a3269931e1e6.padAngle : g, h = t.sortByValue, b = void 0 === h ? $3c37c0e2656b4083$export$9c21a3269931e1e6.sortByValue : h, k = t.cornerRadius, I = void 0 === k ? $3c37c0e2656b4083$export$9c21a3269931e1e6.cornerRadius : k, R = t.fit, m = void 0 === R ? $3c37c0e2656b4083$export$9c21a3269931e1e6.fit : R, O = t.activeInnerRadiusOffset, C = void 0 === O ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeInnerRadiusOffset : O, x = t.activeOuterRadiusOffset, w = void 0 === x ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeOuterRadiusOffset : x, M = t.activeId, y = t.onActiveIdChange, W = t.defaultActiveId, S = t.forwardLegendData, T = $3c37c0e2656b4083$var$z({
        activeId: M,
        onActiveIdChange: y,
        defaultActiveId: W
    }), D = T.activeId, V = T.setActiveId, B = (0, $3ZYaX.useState)([]), G = B[0], H = B[1], X = (0, $3ZYaX.useMemo)(function() {
        var e, t = Math.min(r, o) / 2, i = t * Math.min(l, 1), n = r / 2, a = o / 2;
        if (m) {
            var d = (0, $be8ea372f8f49f58$export$ac350cdccf8fe5e4)(n, a, t, u - 90, f - 90), s = d.points, c = $3c37c0e2656b4083$var$F(d, $3c37c0e2656b4083$var$j), v = Math.min(r / c.width, o / c.height), g = {
                width: c.width * v,
                height: c.height * v
            };
            g.x = (r - g.width) / 2, g.y = (o - g.height) / 2, n = (n - c.x) / c.width * c.width * v + g.x, a = (a - c.y) / c.height * c.height * v + g.y, e = {
                box: c,
                ratio: v,
                points: s
            }, t *= v, i *= v;
        }
        return {
            centerX: n,
            centerY: a,
            radius: t,
            innerRadius: i,
            debug: e
        };
    }, [
        r,
        o,
        l,
        u,
        f,
        m
    ]), P = $3c37c0e2656b4083$export$b3e3150fa43f236d({
        data: i,
        startAngle: u,
        endAngle: f,
        innerRadius: X.innerRadius,
        outerRadius: X.radius,
        padAngle: L,
        sortByValue: b,
        activeId: D,
        activeInnerRadiusOffset: C,
        activeOuterRadiusOffset: w,
        hiddenIds: G,
        forwardLegendData: S
    }), J = (0, $3ZYaX.useCallback)(function(e) {
        H(function(t) {
            return t.indexOf(e) > -1 ? t.filter(function(t) {
                return t !== e;
            }) : [].concat(t, [
                e
            ]);
        });
    }, []);
    return $3c37c0e2656b4083$var$E({
        arcGenerator: (0, $be8ea372f8f49f58$export$9dba50da1768ab65)({
            cornerRadius: I,
            padAngle: (0, $15b6b5b56080a0cd$export$c9fcf1a7df975d78)(L)
        }),
        activeId: D,
        setActiveId: V,
        toggleSerie: J
    }, P, X);
}, $3c37c0e2656b4083$export$f0ce867b70c00d2a = function(t) {
    var i = t.dataWithArc, n = t.arcGenerator, a = t.centerX, r = t.centerY, o = t.radius, d = t.innerRadius;
    return (0, $3ZYaX.useMemo)(function() {
        return {
            dataWithArc: i,
            arcGenerator: n,
            centerX: a,
            centerY: r,
            radius: o,
            innerRadius: d
        };
    }, [
        i,
        n,
        a,
        r,
        o,
        d
    ]);
}, $3c37c0e2656b4083$var$Q = function(t) {
    var i = t.center, n = t.data, a = t.arcGenerator, o = t.borderWidth, d = t.borderColor, l = t.isInteractive, s = t.onClick, c = t.onMouseEnter, u = t.onMouseMove, v = t.onMouseLeave, f = t.setActiveId, g = t.tooltip, L = t.transitionMode, h = (0, $881f54acd386f31e$export$1c4b08e0eca38426)(), b = h.showTooltipFromEvent, A = h.hideTooltip, p = (0, $3ZYaX.useMemo)(function() {
        if (l) return function(e, t) {
            null == s || s(e, t);
        };
    }, [
        l,
        s
    ]), I = (0, $3ZYaX.useMemo)(function() {
        if (l) return function(e, t) {
            b((0, $3ZYaX.createElement)(g, {
                datum: e
            }), t), f(e.id), null == c || c(e, t);
        };
    }, [
        l,
        b,
        f,
        c,
        g
    ]), R = (0, $3ZYaX.useMemo)(function() {
        if (l) return function(e, t) {
            b((0, $3ZYaX.createElement)(g, {
                datum: e
            }), t), null == u || u(e, t);
        };
    }, [
        l,
        b,
        u,
        g
    ]), m = (0, $3ZYaX.useMemo)(function() {
        if (l) return function(e, t) {
            A(), f(null), null == v || v(e, t);
        };
    }, [
        l,
        A,
        f,
        v
    ]);
    return (0, $4801813bf62cee3c$exports.jsx)((0, $be8ea372f8f49f58$export$aa2d92ba89b625ed), {
        center: i,
        data: n,
        arcGenerator: a,
        borderWidth: o,
        borderColor: d,
        transitionMode: L,
        onClick: p,
        onMouseEnter: I,
        onMouseMove: R,
        onMouseLeave: m
    });
}, $3c37c0e2656b4083$var$U = [
    "isInteractive",
    "animate",
    "motionConfig",
    "theme",
    "renderWrapper"
], $3c37c0e2656b4083$var$Z = function(e) {
    var t = e.data, i = e.id, n = void 0 === i ? $3c37c0e2656b4083$export$9c21a3269931e1e6.id : i, a = e.value, d = void 0 === a ? $3c37c0e2656b4083$export$9c21a3269931e1e6.value : a, l = e.valueFormat, s = e.sortByValue, c = void 0 === s ? $3c37c0e2656b4083$export$9c21a3269931e1e6.sortByValue : s, u = e.layers, L = void 0 === u ? $3c37c0e2656b4083$export$9c21a3269931e1e6.layers : u, h = e.startAngle, b = void 0 === h ? $3c37c0e2656b4083$export$9c21a3269931e1e6.startAngle : h, A = e.endAngle, p = void 0 === A ? $3c37c0e2656b4083$export$9c21a3269931e1e6.endAngle : A, k = e.padAngle, m = void 0 === k ? $3c37c0e2656b4083$export$9c21a3269931e1e6.padAngle : k, O = e.fit, C = void 0 === O ? $3c37c0e2656b4083$export$9c21a3269931e1e6.fit : O, x = e.innerRadius, w = void 0 === x ? $3c37c0e2656b4083$export$9c21a3269931e1e6.innerRadius : x, M = e.cornerRadius, y = void 0 === M ? $3c37c0e2656b4083$export$9c21a3269931e1e6.cornerRadius : M, S = e.activeInnerRadiusOffset, T = void 0 === S ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeInnerRadiusOffset : S, D = e.activeOuterRadiusOffset, V = void 0 === D ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeOuterRadiusOffset : D, B = e.width, G = e.height, E = e.margin, F = e.colors, H = void 0 === F ? $3c37c0e2656b4083$export$9c21a3269931e1e6.colors : F, j = e.borderWidth, q = void 0 === j ? $3c37c0e2656b4083$export$9c21a3269931e1e6.borderWidth : j, z = e.borderColor, J = void 0 === z ? $3c37c0e2656b4083$export$9c21a3269931e1e6.borderColor : z, U = e.enableArcLabels, Z = void 0 === U ? $3c37c0e2656b4083$export$9c21a3269931e1e6.enableArcLabels : U, $ = e.arcLabel, _ = void 0 === $ ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabel : $, ee = e.arcLabelsSkipAngle, te = void 0 === ee ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsSkipAngle : ee, ie = e.arcLabelsTextColor, ne = void 0 === ie ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsTextColor : ie, ae = e.arcLabelsRadiusOffset, re = void 0 === ae ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsRadiusOffset : ae, oe = e.arcLabelsComponent, de = e.enableArcLinkLabels, le = void 0 === de ? $3c37c0e2656b4083$export$9c21a3269931e1e6.enableArcLinkLabels : de, se = e.arcLinkLabel, ce = void 0 === se ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabel : se, ue = e.arcLinkLabelsSkipAngle, ve = void 0 === ue ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsSkipAngle : ue, fe = e.arcLinkLabelsOffset, ge = void 0 === fe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsOffset : fe, Le = e.arcLinkLabelsDiagonalLength, he = void 0 === Le ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsDiagonalLength : Le, be = e.arcLinkLabelsStraightLength, Ae = void 0 === be ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsStraightLength : be, pe = e.arcLinkLabelsThickness, ke = void 0 === pe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsThickness : pe, Ie = e.arcLinkLabelsTextOffset, Re = void 0 === Ie ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsTextOffset : Ie, me = e.arcLinkLabelsTextColor, Oe = void 0 === me ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsTextColor : me, Ce = e.arcLinkLabelsColor, xe = void 0 === Ce ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsColor : Ce, we = e.arcLinkLabelComponent, Me = e.defs, ye = void 0 === Me ? $3c37c0e2656b4083$export$9c21a3269931e1e6.defs : Me, We = e.fill, Se = void 0 === We ? $3c37c0e2656b4083$export$9c21a3269931e1e6.fill : We, Te = e.isInteractive, De = void 0 === Te ? $3c37c0e2656b4083$export$9c21a3269931e1e6.isInteractive : Te, Ve = e.onClick, Be = e.onMouseEnter, Ge = e.onMouseMove, Ee = e.onMouseLeave, Fe = e.tooltip, He = void 0 === Fe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.tooltip : Fe, Xe = e.activeId, Ye = e.onActiveIdChange, je = e.defaultActiveId, Pe = e.transitionMode, qe = void 0 === Pe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.transitionMode : Pe, ze = e.legends, Je = void 0 === ze ? $3c37c0e2656b4083$export$9c21a3269931e1e6.legends : ze, Ke = e.forwardLegendData, Ne = e.role, Qe = void 0 === Ne ? $3c37c0e2656b4083$export$9c21a3269931e1e6.role : Ne, Ue = (0, $15b6b5b56080a0cd$export$d04af0e501fb729f)(B, G, E), Ze = Ue.outerWidth, $e = Ue.outerHeight, _e = Ue.margin, et = Ue.innerWidth, tt = Ue.innerHeight, it = $3c37c0e2656b4083$export$dcf407681f3a467d({
        data: t,
        id: n,
        value: d,
        valueFormat: l,
        colors: H
    }), nt = $3c37c0e2656b4083$export$eae94ae087ae8903({
        data: it,
        width: et,
        height: tt,
        fit: C,
        innerRadius: w,
        startAngle: b,
        endAngle: p,
        padAngle: m,
        sortByValue: c,
        cornerRadius: y,
        activeInnerRadiusOffset: T,
        activeOuterRadiusOffset: V,
        activeId: Xe,
        onActiveIdChange: Ye,
        defaultActiveId: je,
        forwardLegendData: Ke
    }), at = nt.dataWithArc, rt = nt.legendData, ot = nt.arcGenerator, dt = nt.centerX, lt = nt.centerY, st = nt.radius, ct = nt.innerRadius, ut = nt.setActiveId, vt = nt.toggleSerie, ft = (0, $15b6b5b56080a0cd$export$dc35cf769e3afe34)(ye, at, Se), gt = {
        arcs: null,
        arcLinkLabels: null,
        arcLabels: null,
        legends: null
    };
    L.includes("arcs") && (gt.arcs = (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$var$Q, {
        center: [
            dt,
            lt
        ],
        data: at,
        arcGenerator: ot,
        borderWidth: q,
        borderColor: J,
        isInteractive: De,
        onClick: Ve,
        onMouseEnter: Be,
        onMouseMove: Ge,
        onMouseLeave: Ee,
        setActiveId: ut,
        tooltip: He,
        transitionMode: qe
    }, "arcs")), le && L.includes("arcLinkLabels") && (gt.arcLinkLabels = (0, $4801813bf62cee3c$exports.jsx)((0, $be8ea372f8f49f58$export$ea70f6ffe59d94b1), {
        center: [
            dt,
            lt
        ],
        data: at,
        label: ce,
        skipAngle: ve,
        offset: ge,
        diagonalLength: he,
        straightLength: Ae,
        strokeWidth: ke,
        textOffset: Re,
        textColor: Oe,
        linkColor: xe,
        component: we
    }, "arcLinkLabels")), Z && L.includes("arcLabels") && (gt.arcLabels = (0, $4801813bf62cee3c$exports.jsx)((0, $be8ea372f8f49f58$export$6aed5a877c5fc8a1), {
        center: [
            dt,
            lt
        ],
        data: at,
        label: _,
        radiusOffset: re,
        skipAngle: te,
        textColor: ne,
        transitionMode: qe,
        component: oe
    }, "arcLabels")), Je.length > 0 && L.includes("legends") && (gt.legends = (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$var$X, {
        width: et,
        height: tt,
        data: rt,
        legends: Je,
        toggleSerie: vt
    }, "legends"));
    var Lt = $3c37c0e2656b4083$export$f0ce867b70c00d2a({
        dataWithArc: at,
        arcGenerator: ot,
        centerX: dt,
        centerY: lt,
        radius: st,
        innerRadius: ct
    });
    return (0, $4801813bf62cee3c$exports.jsx)((0, $15b6b5b56080a0cd$export$21d9f1931ef75b56), {
        width: Ze,
        height: $e,
        margin: _e,
        defs: ft,
        role: Qe,
        children: L.map(function(e, t) {
            return void 0 !== gt[e] ? gt[e] : "function" == typeof e ? (0, $4801813bf62cee3c$exports.jsx)((0, $3ZYaX.Fragment), {
                children: (0, $3ZYaX.createElement)(e, Lt)
            }, t) : null;
        })
    });
}, $3c37c0e2656b4083$export$2ae8800cf67c848c = function(e) {
    var t = e.isInteractive, i = void 0 === t ? $3c37c0e2656b4083$export$9c21a3269931e1e6.isInteractive : t, n = e.animate, a = void 0 === n ? $3c37c0e2656b4083$export$9c21a3269931e1e6.animate : n, r = e.motionConfig, o = void 0 === r ? $3c37c0e2656b4083$export$9c21a3269931e1e6.motionConfig : r, d = e.theme, l = e.renderWrapper, s = $3c37c0e2656b4083$var$F(e, $3c37c0e2656b4083$var$U);
    return (0, $4801813bf62cee3c$exports.jsx)((0, $15b6b5b56080a0cd$export$42a852a2b6b56249), {
        animate: a,
        isInteractive: i,
        motionConfig: o,
        renderWrapper: l,
        theme: d,
        children: (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$var$Z, $3c37c0e2656b4083$var$E({
            isInteractive: i
        }, s))
    });
}, $3c37c0e2656b4083$export$7da90bf8925efdaf = function(e) {
    return (0, $4801813bf62cee3c$exports.jsx)((0, $15b6b5b56080a0cd$export$fa6e408d6a7d6214), {
        children: function(t) {
            var i = t.width, n = t.height;
            return (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$export$2ae8800cf67c848c, $3c37c0e2656b4083$var$E({
                width: i,
                height: n
            }, e));
        }
    });
}, $3c37c0e2656b4083$var$ee = [
    "isInteractive",
    "theme",
    "renderWrapper"
], $3c37c0e2656b4083$var$te = function(n) {
    var a = n.data, o = n.id, d = void 0 === o ? $3c37c0e2656b4083$export$9c21a3269931e1e6.id : o, l = n.value, s = void 0 === l ? $3c37c0e2656b4083$export$9c21a3269931e1e6.value : l, c = n.valueFormat, u = n.sortByValue, f = void 0 === u ? $3c37c0e2656b4083$export$9c21a3269931e1e6.sortByValue : u, g = n.startAngle, L = void 0 === g ? $3c37c0e2656b4083$export$9c21a3269931e1e6.startAngle : g, A = n.endAngle, p = void 0 === A ? $3c37c0e2656b4083$export$9c21a3269931e1e6.endAngle : A, k = n.padAngle, I = void 0 === k ? $3c37c0e2656b4083$export$9c21a3269931e1e6.padAngle : k, R = n.fit, M = void 0 === R ? $3c37c0e2656b4083$export$9c21a3269931e1e6.fit : R, S = n.innerRadius, T = void 0 === S ? $3c37c0e2656b4083$export$9c21a3269931e1e6.innerRadius : S, D = n.cornerRadius, B = void 0 === D ? $3c37c0e2656b4083$export$9c21a3269931e1e6.cornerRadius : D, F = n.activeInnerRadiusOffset, H = void 0 === F ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeInnerRadiusOffset : F, X = n.activeOuterRadiusOffset, j = void 0 === X ? $3c37c0e2656b4083$export$9c21a3269931e1e6.activeOuterRadiusOffset : X, q = n.width, z = n.height, J = n.margin, N = n.pixelRatio, Q = void 0 === N ? $3c37c0e2656b4083$export$9c21a3269931e1e6.pixelRatio : N, U = n.colors, Z = void 0 === U ? $3c37c0e2656b4083$export$9c21a3269931e1e6.colors : U, $ = n.borderWidth, _ = void 0 === $ ? $3c37c0e2656b4083$export$9c21a3269931e1e6.borderWidth : $, ee = n.borderColor, te = void 0 === ee ? $3c37c0e2656b4083$export$9c21a3269931e1e6.borderColor : ee, ie = n.enableArcLabels, ne = void 0 === ie ? $3c37c0e2656b4083$export$9c21a3269931e1e6.enableArcLabels : ie, ae = n.arcLabel, re = void 0 === ae ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabel : ae, oe = n.arcLabelsSkipAngle, de = void 0 === oe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsSkipAngle : oe, le = n.arcLabelsTextColor, se = void 0 === le ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsTextColor : le, ce = n.arcLabelsRadiusOffset, ue = void 0 === ce ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLabelsRadiusOffset : ce, ve = n.enableArcLinkLabels, fe = void 0 === ve ? $3c37c0e2656b4083$export$9c21a3269931e1e6.enableArcLinkLabels : ve, ge = n.arcLinkLabel, Le = void 0 === ge ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabel : ge, he = n.arcLinkLabelsSkipAngle, be = void 0 === he ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsSkipAngle : he, Ae = n.arcLinkLabelsOffset, pe = void 0 === Ae ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsOffset : Ae, ke = n.arcLinkLabelsDiagonalLength, Ie = void 0 === ke ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsDiagonalLength : ke, Re = n.arcLinkLabelsStraightLength, me = void 0 === Re ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsStraightLength : Re, Oe = n.arcLinkLabelsThickness, Ce = void 0 === Oe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsThickness : Oe, xe = n.arcLinkLabelsTextOffset, we = void 0 === xe ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsTextOffset : xe, Me = n.arcLinkLabelsTextColor, ye = void 0 === Me ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsTextColor : Me, We = n.arcLinkLabelsColor, Se = void 0 === We ? $3c37c0e2656b4083$export$9c21a3269931e1e6.arcLinkLabelsColor : We, Te = n.isInteractive, De = void 0 === Te ? $3c37c0e2656b4083$export$9c21a3269931e1e6.isInteractive : Te, Ve = n.onClick, Be = n.onMouseMove, Ge = n.tooltip, Ee = void 0 === Ge ? $3c37c0e2656b4083$export$9c21a3269931e1e6.tooltip : Ge, Fe = n.activeId, He = n.onActiveIdChange, Xe = n.defaultActiveId, Ye = n.legends, je = void 0 === Ye ? $3c37c0e2656b4083$export$9c21a3269931e1e6.legends : Ye, Pe = n.forwardLegendData, qe = (0, $3ZYaX.useRef)(null), ze = (0, $15b6b5b56080a0cd$export$93d4e7f90805808f)(), Je = (0, $15b6b5b56080a0cd$export$d04af0e501fb729f)(q, z, J), Ke = Je.margin, Ne = Je.innerWidth, Qe = Je.innerHeight, Ue = Je.outerWidth, Ze = Je.outerHeight, $e = $3c37c0e2656b4083$export$dcf407681f3a467d({
        data: a,
        id: d,
        value: s,
        valueFormat: c,
        colors: Z
    }), _e = $3c37c0e2656b4083$export$eae94ae087ae8903({
        data: $e,
        width: Ne,
        height: Qe,
        fit: M,
        innerRadius: T,
        startAngle: L,
        endAngle: p,
        padAngle: I,
        sortByValue: f,
        cornerRadius: B,
        activeInnerRadiusOffset: H,
        activeOuterRadiusOffset: j,
        activeId: Fe,
        onActiveIdChange: He,
        defaultActiveId: Xe,
        forwardLegendData: Pe
    }), et = _e.dataWithArc, tt = _e.arcGenerator, it = _e.centerX, nt = _e.centerY, at = _e.radius, rt = _e.innerRadius, ot = _e.setActiveId, dt = (0, $cd313104b6eabfcc$export$2a9e363116151414)(te, ze), lt = (0, $be8ea372f8f49f58$export$13804dbea81a51a5)({
        data: et,
        label: re,
        skipAngle: de,
        offset: ue,
        textColor: se
    }), st = (0, $be8ea372f8f49f58$export$a2fecac67fe4140c)({
        data: et,
        skipAngle: be,
        offset: pe,
        diagonalLength: Ie,
        straightLength: me,
        label: Le,
        linkColor: Se,
        textOffset: we,
        textColor: ye
    });
    (0, $3ZYaX.useEffect)(function() {
        if (qe.current) {
            qe.current.width = Ue * Q, qe.current.height = Ze * Q;
            var e = qe.current.getContext("2d");
            e.scale(Q, Q), e.fillStyle = ze.background, e.fillRect(0, 0, Ue, Ze), e.save(), e.translate(Ke.left, Ke.top), tt.context(e), e.save(), e.translate(it, nt), et.forEach(function(t) {
                e.beginPath(), e.fillStyle = t.color, e.strokeStyle = dt(t), e.lineWidth = _, tt(t.arc), e.fill(), _ > 0 && e.stroke();
            }), !0 === fe && (0, $be8ea372f8f49f58$export$3aacf153e19c708d)(e, st, ze, Ce), !0 === ne && (0, $be8ea372f8f49f58$export$3162ce2b4ca97f8a)(e, lt, ze), e.restore(), je.forEach(function(t) {
                (0, $4333f5b515403c5a$export$28c0156604402604)(e, $3c37c0e2656b4083$var$E({}, t, {
                    data: et,
                    containerWidth: Ne,
                    containerHeight: Qe,
                    theme: ze
                }));
            });
        }
    }, [
        qe,
        Ne,
        Qe,
        Ue,
        Ze,
        Ke.top,
        Ke.left,
        Q,
        it,
        nt,
        tt,
        et,
        _,
        dt,
        ne,
        lt,
        fe,
        st,
        Ce,
        je,
        ze
    ]);
    var ct = (0, $3ZYaX.useMemo)(function() {
        return et.map(function(e) {
            return $3c37c0e2656b4083$var$E({
                id: e.id
            }, e.arc);
        });
    }, [
        et
    ]), ut = function(e) {
        if (!qe.current) return null;
        var t = (0, $15b6b5b56080a0cd$export$2396fb9a7906fd81)(qe.current, e), i = t[0], n = t[1], a = (0, $be8ea372f8f49f58$export$f797b637b9988726)(Ke.left + it, Ke.top + nt, at, rt, ct, i, n);
        return a ? et.find(function(e) {
            return e.id === a.id;
        }) : null;
    }, vt = (0, $881f54acd386f31e$export$1c4b08e0eca38426)(), ft = vt.showTooltipFromEvent, gt = vt.hideTooltip, Lt = function(e) {
        var t = ut(e);
        t ? (null == Be || Be(t, e), ot(t.id), ft((0, $3ZYaX.createElement)(Ee, {
            datum: t
        }), e)) : (ot(null), gt());
    };
    return (0, $4801813bf62cee3c$exports.jsx)("canvas", {
        ref: qe,
        width: Ue * Q,
        height: Ze * Q,
        style: {
            width: Ue,
            height: Ze,
            cursor: De ? "auto" : "normal"
        },
        onMouseEnter: De ? Lt : void 0,
        onMouseMove: De ? Lt : void 0,
        onMouseLeave: De ? function() {
            gt();
        } : void 0,
        onClick: De ? function(e) {
            if (Ve) {
                var t = ut(e);
                t && Ve(t, e);
            }
        } : void 0
    });
}, $3c37c0e2656b4083$export$62d6f587c9843e29 = function(e) {
    var t = e.isInteractive, i = void 0 === t ? $3c37c0e2656b4083$export$9c21a3269931e1e6.isInteractive : t, n = e.theme, a = e.renderWrapper, r = $3c37c0e2656b4083$var$F(e, $3c37c0e2656b4083$var$ee);
    return (0, $4801813bf62cee3c$exports.jsx)((0, $15b6b5b56080a0cd$export$42a852a2b6b56249), {
        isInteractive: i,
        renderWrapper: a,
        theme: n,
        children: (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$var$te, $3c37c0e2656b4083$var$E({
            isInteractive: i
        }, r))
    });
}, $3c37c0e2656b4083$export$b683bd2ce105ce17 = function(e) {
    return (0, $4801813bf62cee3c$exports.jsx)((0, $15b6b5b56080a0cd$export$fa6e408d6a7d6214), {
        children: function(t) {
            var i = t.width, n = t.height;
            return (0, $4801813bf62cee3c$exports.jsx)($3c37c0e2656b4083$export$62d6f587c9843e29, $3c37c0e2656b4083$var$E({
                width: i,
                height: n
            }, e));
        }
    });
};


const $1367280b4ce75c80$export$11ddcbd06247fc36 = ({ title: title, data: data, detailIndex: detailIndex })=>{
    const noData = data[0].value === 0 && data[1].value === 0;
    const theOtherIndex = detailIndex === 0 ? 1 : 0;
    const success = data[1].value === 0;
    const fail = data[0].value === 0;
    const percentage = Math.floor(data[detailIndex].value / (data[detailIndex].value + data[theOtherIndex].value) * 100);
    if (success) {
        data[0].color = 'var(--bulma-success)';
        data[1].color = 'var(--bulma-success)';
    }
    if (fail) {
        data[0].color = 'var(--bulma-danger)';
        data[1].color = 'var(--bulma-danger)';
    }
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        textAlign: 'center',
        display: "flex",
        justifyContent: "center",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            textAlign: 'center',
            children: [
                title && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    size: 4,
                    textAlign: 'center',
                    children: title
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    style: {
                        height: 100,
                        width: 150
                    },
                    display: "inline-block",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3c37c0e2656b4083$export$7da90bf8925efdaf), {
                        enableArcLabels: false,
                        enableArcLinkLabels: false,
                        colors: [
                            data[0].color,
                            data[1].color
                        ],
                        data: data,
                        innerRadius: 0.5,
                        startAngle: -90,
                        endAngle: 90,
                        margin: {
                            top: 15,
                            left: 15,
                            right: 15,
                            bottom: 0
                        }
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                            size: 4,
                            mb: 1,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                style: {
                                    whiteSpace: 'nowrap',
                                    display: 'block'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        style: {
                                            background: noData ? 'grey' : data[detailIndex].color
                                        },
                                        mr: 3,
                                        size: 'small'
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        renderAs: "span",
                                        children: [
                                            noData ? '' : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    percentage,
                                                    "%"
                                                ]
                                            }),
                                            " ",
                                            data[detailIndex].id
                                        ]
                                    })
                                ]
                            })
                        }),
                        noData ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                            children: "Pas de donn\xe9es"
                        }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                data[detailIndex].value,
                                " / ",
                                data[detailIndex].value + data[theOtherIndex].value
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


const $6fcf1363a30adc87$export$5d98cafc998b2cc = ({ stats: stats })=>{
    const workPeriods = stats.workPeriods;
    const combine = stats.workPeriods.combine;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
            vCentered: true,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1367280b4ce75c80$export$11ddcbd06247fc36), {
                        data: [
                            {
                                id: 'Validation',
                                value: stats.workPeriods.validated.length,
                                color: 'var(--bulma-info)'
                            },
                            {
                                id: "Non Valid\xe9es",
                                value: stats.workPeriods.notValidated.length,
                                color: 'orange'
                            }
                        ],
                        detailIndex: 0
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1367280b4ce75c80$export$11ddcbd06247fc36), {
                        data: [
                            {
                                id: "Pr\xe9sence",
                                value: combine(workPeriods, [
                                    'validated',
                                    'expected',
                                    'clocked'
                                ]).length,
                                color: 'var(--bulma-info)'
                            },
                            {
                                id: 'Absents',
                                value: combine(workPeriods, [
                                    'validated',
                                    'expected',
                                    'notClocked'
                                ]).length,
                                color: 'orange'
                            }
                        ],
                        detailIndex: 1
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1367280b4ce75c80$export$11ddcbd06247fc36), {
                        data: [
                            {
                                id: "\xc0 Temps",
                                value: combine(workPeriods, [
                                    'validated',
                                    'expected',
                                    'clocked',
                                    'notLate'
                                ]).length,
                                color: 'var(--bulma-info)'
                            },
                            {
                                id: 'Retard',
                                value: combine(workPeriods, [
                                    'validated',
                                    'expected',
                                    'clocked',
                                    'late'
                                ]).length,
                                color: 'orange'
                            }
                        ],
                        detailIndex: 1
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    offset: 1,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1367280b4ce75c80$export$11ddcbd06247fc36), {
                        data: [
                            {
                                id: 'Sans Abandon',
                                value: combine(workPeriods, [
                                    'validated',
                                    'notAbandoned'
                                ]).length,
                                color: 'var(--bulma-info)'
                            },
                            {
                                id: 'Abandons',
                                value: combine(workPeriods, [
                                    'validated',
                                    'abandoned'
                                ]).length,
                                color: 'orange'
                            }
                        ],
                        detailIndex: 1
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 4,
                    offset: 1,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1367280b4ce75c80$export$11ddcbd06247fc36), {
                        data: [
                            {
                                id: 'Pas interrompus',
                                value: combine(workPeriods, [
                                    'validated',
                                    'notCancelled'
                                ]).length,
                                color: 'var(--bulma-info)'
                            },
                            {
                                id: 'Interrompus',
                                value: combine(workPeriods, [
                                    'validated',
                                    'cancelled'
                                ]).length,
                                color: 'orange'
                            }
                        ],
                        detailIndex: 1
                    })
                })
            ]
        })
    });
};





const $0b845de638b8eeaa$var$NewEmployerDashboard = ()=>{
    const currentOrganizationRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganizationRole);
    const { filters: filters, setFilters: setFilters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods);
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const todayStart = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date());
    const todayEnd = (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(new Date());
    const thisWeekStart = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(todayStart);
    const thisWeekEnd = (0, $d9677f7cca086b20$export$2e2bcd8739ae039)(todayEnd);
    const pastWeekStart = (0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(thisWeekStart, 1);
    const pastWeekEnd = (0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(thisWeekEnd, 1);
    const pastWeekStartIso = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(pastWeekStart);
    const pastWeekEndIso = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(pastWeekEnd);
    const stats = (0, $ec117dea2333c8af$export$f722f744b7d3e151)({
        start: pastWeekStartIso,
        end: pastWeekEndIso
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: currentOrganizationRole === 'clocker' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                        size: 3,
                                        children: "Aujourd'hui"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0b845de638b8eeaa$var$EmployerStat, {
                                        start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(todayStart),
                                        end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(todayEnd)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                    size: 3,
                                                    children: "Semaine Pass\xe9e"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "primary",
                                                    outlined: true,
                                                    onClick: ()=>navigate('/kpi'),
                                                    textWeight: "bold",
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$850d4fe20b3fbaee), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                            children: "Explorer les Statistiques"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fcf1363a30adc87$export$5d98cafc998b2cc), {
                                        stats: stats
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 3,
                        children: "Planning"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e8d720daf990b168$export$7395418bd2a007ce), {
                        display: [
                            'interimAgency',
                            'employer',
                            'jobTitle',
                            'service',
                            'user',
                            'tags',
                            'events'
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0b845de638b8eeaa$export$9e8bb359191306c8, {
                        filters: filters,
                        setFilters: setFilters
                    })
                ]
            })
        })
    });
};
var $0b845de638b8eeaa$export$2e2bcd8739ae039 = $0b845de638b8eeaa$var$NewEmployerDashboard;
const $0b845de638b8eeaa$export$9e8bb359191306c8 = ({ filters: filters, setFilters: setFilters })=>{
    const todayStart = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date());
    const todayEnd = (0, $e94c78fdddee0309$export$2e2bcd8739ae039)(new Date());
    const thisWeekStart = (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(todayStart);
    const thisWeekEnd = (0, $d9677f7cca086b20$export$2e2bcd8739ae039)(todayEnd);
    const pastWeekStart = (0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(thisWeekStart, 1);
    const pastWeekEnd = (0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)(thisWeekEnd, 1);
    const nextWeekStart = (0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(thisWeekStart, 1);
    const nextWeekEnd = (0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)(thisWeekEnd, 1);
    const thisWeek = [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((day)=>({
            start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(thisWeekStart, day)),
            end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $e94c78fdddee0309$export$2e2bcd8739ae039)(thisWeekStart), day))
        }));
    const pastWeek = [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((day)=>({
            start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(pastWeekStart, day)),
            end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $e94c78fdddee0309$export$2e2bcd8739ae039)(pastWeekStart), day))
        }));
    const nextWeek = [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((day)=>({
            start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(nextWeekStart, day)),
            end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)((0, $e94c78fdddee0309$export$2e2bcd8739ae039)(nextWeekStart), day))
        }));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Table), {
        size: "fullwidth",
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {}),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Lundi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Mardi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Mercredi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Jeudi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Vendredi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Samedi"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                            children: "Dimanche"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tbody", {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                children: "Semaine Prochaine"
                            }),
                            nextWeek.map(({ start: start, end: end })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                    style: {
                                        backgroundColor: filters.start === start && filters.end === end ? 'lavender' : undefined
                                    },
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0b845de638b8eeaa$var$PlanningCardItem, {
                                        isoDate: start
                                    })
                                }, start))
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                        style: {
                            backgroundColor: filters.start === (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(thisWeekStart) && filters.end === (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(thisWeekEnd) ? 'lavender' : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                children: "Cette Semaine"
                            }),
                            thisWeek.map(({ start: start, end: end })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                    style: {
                                        backgroundColor: filters.start === start && filters.end === end ? 'lavender' : undefined
                                    },
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0b845de638b8eeaa$var$PlanningCardItem, {
                                        isoDate: start
                                    })
                                }, start))
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("tr", {
                        style: {
                            backgroundColor: filters.start === (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(pastWeekStart) && filters.end === (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(pastWeekEnd) ? 'lavender' : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("th", {
                                children: "Semaine Pass\xe9e"
                            }),
                            pastWeek.map(({ start: start, end: end })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("td", {
                                    style: {
                                        backgroundColor: filters.start === start && filters.end === end ? 'lavender' : undefined
                                    },
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($0b845de638b8eeaa$var$PlanningCardItem, {
                                        isoDate: start
                                    })
                                }, start))
                        ]
                    })
                ]
            })
        ]
    });
};
const $0b845de638b8eeaa$var$PlanningCardItem = ({ isoDate: isoDate })=>{
    const filters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.filters[(0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods]);
    const setFilters = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.filters.setFilters);
    const stats = (0, $ec117dea2333c8af$export$f722f744b7d3e151)({
        ...filters,
        start: isoDate,
        end: isoDate
    });
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const date = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(isoDate);
    const isInThePast = (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(date, (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date()));
    const isInThePastOrToday = isInThePast || (0, $ec8d0215c60e3f6d$export$2e2bcd8739ae039)(date);
    const isInTheFuture = !isInThePast;
    const isInTheFutureOrToday = isInTheFuture || (0, $ec8d0215c60e3f6d$export$2e2bcd8739ae039)(date);
    const isPastWeek = (0, $2d2bd3707ace1804$export$2e2bcd8739ae039)(date, (0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(new Date()));
    const workPeriodsNotValidated = stats.workPeriods.notValidated.length > 0;
    const ongoingDemands = stats.posts.combine(stats.posts, [
        'missing',
        'notCancelled'
    ]).length > 0;
    const displayWorkPeriodsNotValidated = isInThePastOrToday && workPeriodsNotValidated;
    const displayOngoingDemands = isInTheFutureOrToday && ongoingDemands;
    const allOk = !displayOngoingDemands && !displayWorkPeriodsNotValidated;
    const warningColor = isPastWeek ? 'danger-80' : 'warning-80';
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "ul",
            p: 2,
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                    children: [
                        stats.workPeriods.expected.length,
                        " Travailleurs"
                    ]
                }),
                allOk ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            color: "success-70",
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                                        }),
                                        "OK"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                children: "\xa0"
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                            children: displayWorkPeriodsNotValidated ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                backgroundColor: warningColor,
                                children: [
                                    stats.workPeriods.notValidated.length,
                                    " \xe0 Valider !"
                                ]
                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                children: "\xa0"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                            children: displayOngoingDemands ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                backgroundColor: warningColor,
                                children: [
                                    stats.posts.missing.length,
                                    " Demandes !"
                                ]
                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                p: 1,
                                mt: 1,
                                children: "\xa0"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                    mt: 3,
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                size: 'small',
                                onClick: ()=>{
                                    setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods, {
                                        ...filters,
                                        start: isoDate,
                                        end: isoDate
                                    });
                                    navigate('/work-periods');
                                },
                                children: "D\xe9tail"
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: (0, $ec8d0215c60e3f6d$export$2e2bcd8739ae039)(date) ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                size: "small",
                                color: 'dark',
                                "data-tooltip": "Aujourd'hui",
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$5fda1783bb83f57b), {})
                            }) : null
                        })
                    ]
                })
            ]
        })
    });
};
const $0b845de638b8eeaa$var$EmployerStat = ({ start: start, end: end })=>{
    const stats = (0, $ec117dea2333c8af$export$f722f744b7d3e151)({
        start: start,
        end: end
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
                        mainStat: {
                            value: stats.workPeriods.combine(stats.workPeriods, [
                                'expected'
                            ]).length,
                            label: 'Missions'
                        },
                        secondaryStat: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                "+ ",
                                stats.workPeriods.combine(stats.workPeriods, [
                                    'notExpected'
                                ]).length,
                                ' ',
                                "interruptions ou abandons"
                            ]
                        }),
                        queryStatus: 'success'
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
                        mainStat: {
                            value: stats.workPeriods.combine(stats.workPeriods, [
                                'expected',
                                'clockedInNotOut'
                            ]).length,
                            label: "Pr\xe9sents"
                        },
                        secondaryStat: "ont point\xe9 leur entr\xe9e",
                        queryStatus: 'success'
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
                        mainStat: {
                            value: stats.workPeriods.combine(stats.workPeriods, [
                                'expected',
                                'late'
                            ]).length,
                            label: 'En retard'
                        },
                        secondaryStat: `dont ${stats.workPeriods.combine(stats.workPeriods, [
                            'expected',
                            'late',
                            'notClocked'
                        ]).length} pas encore arriv\xe9s`,
                        queryStatus: 'success'
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                    size: 6,
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $37250c8da4feaf0c$export$f9f3c19554479b2b), {
                        mainStat: {
                            value: stats.workPeriods.combine(stats.workPeriods, [
                                'expected',
                                'clockedOut'
                            ]).length,
                            label: "Termin\xe9s"
                        },
                        secondaryStat: "ont point\xe9 leur sortie",
                        queryStatus: 'success'
                    })
                })
            ]
        })
    });
} /* 
export const ValidationProgress = ({
  start,
  end,
  size = 'normal',
}: {
  start: IsoDate
  end: IsoDate
  size?: Size
}): ReactNode => {
  const stats = useEmployerStats(start, end)
  const value = (stats.workPeriods.validated.length / stats.workPeriods.total.length) * 100

  let color: string
  switch (true) {
    case value < 50:
      color = 'danger'
      break
    case value >= 50 && value < 100:
      color = 'warning'
      break
    case value === 100:
      color = 'success'
      break
    default:
      color = 'info'
  }

  return (
    <>
      <ReactTooltip id="validation-progress" backgroundColor={`var(--bulma-${color}-dark)`}>
        <Element textWeight="bold">État de la Validation : {Math.floor(value)}%</Element>
      </ReactTooltip>
      <Element data-tip data-for="validation-progress">
        <Progress size={size} value={value} max={100} color={color} />
      </Element>
    </>
  )
}
 */ ;



parcelRequire("3ZYaX");



parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");











function $7c6cb632f764cef8$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $30e36549ded1db27$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}



function $b3666afccc3ef867$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $ae3f0819e3372146$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $b057e3b44276ba44$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $7c6cb632f764cef8$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





const $0b6a2bbf63e49b80$var$KPIFilters = ({})=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI);
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentOrganization);
    const oneYearAgo = (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $b3666afccc3ef867$export$2e2bcd8739ae039)(new Date(), 1));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            ...filters,
            start: filters.start,
            end: filters.end
        },
        enableReinitialize: true,
        validate: (values)=>{
            if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.start), (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(oneYearAgo))) return {
                start: "Vous pouvez retourner maximum un an en arri\xe8re"
            };
            if ((0, $2d2bd3707ace1804$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.end), (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.start))) return {
                start: 'Intervalle de dates invalide'
            };
            if ((0, $46e6b7724aa17953$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.end), (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(values.start)) > 93) return {
                start: "Maximum 3 mois d'intervalle"
            };
            return {};
        },
        onSubmit: (values)=>{
            const payload = {
                ...values,
                start: values.start,
                end: values.end
            };
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, payload);
        },
        children: (props)=>{
            const startDate = (0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)(filters.start);
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $e05847321a0fbdec$export$2e2bcd8739ae039), {
                resource: (0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 7,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        display: "flex",
                                        justifyContent: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                                name: "start",
                                                label: "Date d\xe9but",
                                                max: filters.end,
                                                min: oneYearAgo
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ed7e5934a172a7ff$export$2e2bcd8739ae039), {
                                                name: "end",
                                                label: "Date fin",
                                                min: filters.start
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        display: "flex",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $992ecbd31670e2eb$export$2e2bcd8739ae039), {}),
                                            currentOrganization?.type === 'employer' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6ff98716203f8d8$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                                    centered: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                children: "Naviguer par p\xe9riode"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                kind: "addons",
                                                justifyContent: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $f85dee25334cb4c9$export$2e2bcd8739ae039)(startDate, 1)),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $f85dee25334cb4c9$export$2e2bcd8739ae039)(startDate, 1))
                                                                }),
                                                            children: "Jour pr\xe9c\xe9dent"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'primary',
                                                            textColor: "dark",
                                                            outlined: true,
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date())),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $e94c78fdddee0309$export$2e2bcd8739ae039)(new Date()))
                                                                }),
                                                            children: "Aujourd'hui"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(startDate, 1)),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(startDate, 1))
                                                                }),
                                                            children: "Jour suivant"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                kind: "addons",
                                                justifyContent: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)((0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(startDate), 1)),
                                                                    //start: subWeeks(startOfWeek(filters.start), 1),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $ddab2dd0c5e3aa81$export$2e2bcd8739ae039)((0, $d9677f7cca086b20$export$2e2bcd8739ae039)(startDate), 1))
                                                                }),
                                                            children: "Semaine Pr\xe9c\xe9dente"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'primary',
                                                            textColor: "dark",
                                                            outlined: true,
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(new Date())),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $d9677f7cca086b20$export$2e2bcd8739ae039)(new Date()))
                                                                }),
                                                            children: "Cette Semaine"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)((0, $63a6eac007c76fc6$export$2e2bcd8739ae039)(startDate), 1)),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $7f0edb3b96fe70cc$export$2e2bcd8739ae039)((0, $d9677f7cca086b20$export$2e2bcd8739ae039)(startDate), 1))
                                                                }),
                                                            children: "Semaine Suivante"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                kind: "addons",
                                                justifyContent: "center",
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $41500622c442f1a1$export$2e2bcd8739ae039)((0, $9d8683737c4c4df2$export$2e2bcd8739ae039)(startDate), 1)),
                                                                    //start: subWeeks(startOfWeek(filters.start), 1),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $41500622c442f1a1$export$2e2bcd8739ae039)((0, $b8561e530ff0425c$export$2e2bcd8739ae039)(startDate), 1))
                                                                }),
                                                            children: "Mois Pr\xe9c\xe9dent"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'primary',
                                                            outlined: true,
                                                            textColor: "dark",
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $9d8683737c4c4df2$export$2e2bcd8739ae039)(new Date())),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $b8561e530ff0425c$export$2e2bcd8739ae039)(new Date()))
                                                                }),
                                                            children: "Ce mois"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                            color: 'ghost',
                                                            onClick: ()=>setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI, {
                                                                    ...filters,
                                                                    start: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $30e36549ded1db27$export$2e2bcd8739ae039)((0, $9d8683737c4c4df2$export$2e2bcd8739ae039)(startDate), 1)),
                                                                    end: (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)((0, $30e36549ded1db27$export$2e2bcd8739ae039)((0, $b8561e530ff0425c$export$2e2bcd8739ae039)(startDate), 1))
                                                                }),
                                                            children: "Mois Suivant"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        errors: props.errors,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $0b6a2bbf63e49b80$export$2e2bcd8739ae039 = $0b6a2bbf63e49b80$var$KPIFilters;











const $c646ea6e9b05f349$export$8266bebc0b1985a1 = ()=>{
    const { filters: { start: start, end: end, user: user, interimAgency: interimAgency, employer: employer, service: service } } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).kPI);
    const stats = (0, $ec117dea2333c8af$export$f722f744b7d3e151)({
        start: start,
        end: end,
        interimAgency: interimAgency,
        employer: employer,
        user: user,
        service: service
    });
    const interimAgenciesQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'interimAgency'
    }).data ?? [];
    const employersQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    }).data ?? [];
    const workersQuery = (0, $e607e015ac40917d$export$ad43217ee1485bda)().data ?? [];
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((s)=>s.session.currentOrganization);
    const contextualDateRange = (0, $74f17ceb9b5a08a5$export$98482d4a281b28ea)(start, end);
    const dateRange = (0, $74f17ceb9b5a08a5$export$98482d4a281b28ea)(start, end, false);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    textAlign: 'center',
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0b6a2bbf63e49b80$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                            size: 3,
                            mt: 5,
                            textAlign: 'center',
                            children: [
                                "Statistiques de ",
                                currentOrganization?.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                            size: 5,
                            textAlign: 'center',
                            textColor: "primary",
                            children: [
                                contextualDateRange,
                                " ",
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                contextualDateRange !== dateRange && dateRange,
                                interimAgency && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                            children: interimAgency.map((iA)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: interimAgenciesQuery.find((o)=>o._id === iA)?.name ?? ''
                                                }, iA))
                                        })
                                    ]
                                }),
                                employer && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                            children: employer.map((e)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: employersQuery.find((o)=>o._id === e)?.name ?? ''
                                                }, e))
                                        })
                                    ]
                                }),
                                user && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                            children: user.map((u)=>{
                                                const worker = workersQuery.find((w)=>w._id === u);
                                                if (worker) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                                    children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(worker)
                                                }, u);
                                                else return '';
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fcf1363a30adc87$export$5d98cafc998b2cc), {
                        stats: stats
                    })
                })
            })
        ]
    });
};



parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");
function $66fc2642466e214b$var$UserGroupIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    }));
}
const $66fc2642466e214b$var$ForwardRef = $3ZYaX.forwardRef($66fc2642466e214b$var$UserGroupIcon);
var $66fc2642466e214b$export$2e2bcd8739ae039 = $66fc2642466e214b$var$ForwardRef;





parcelRequire("3ZYaX");




parcelRequire("3ZYaX");



parcelRequire("3ZYaX");

/**
 * Reusable component to display a notification badge
 * Used in header and sidebar for pending items
 */ const $fd22dac9b59f9f6a$var$NotificationBadge = ({ count: count, getTitle: getTitle = (count)=>`${count} item${count > 1 ? 's' : ''}` })=>{
    if (!count) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tag), {
        color: "warning",
        size: "small",
        "data-tooltip": getTitle(count),
        children: count
    });
};
var $fd22dac9b59f9f6a$export$2e2bcd8739ae039 = $fd22dac9b59f9f6a$var$NotificationBadge;


/**
 * Menu item component for the sidebar
 * Displays an icon, label and optional badge
 */ const $10b875e0065cf2d7$var$SidebarMenuItem = ({ path: path, label: label, icon: IconComponent, badgeCount: badgeCount, isActive: isActive, basePath: basePath })=>{
    const fullPath = `${basePath}/${path}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Menu).List.Item, {
        active: isActive,
        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
        to: fullPath,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            renderAs: "span",
            className: "is-flex is-align-items-center is-justify-content-space-between w-100",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    className: "is-flex is-align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            size: "small",
                            className: "mr-2",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)(IconComponent, {})
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "span",
                            children: label
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fd22dac9b59f9f6a$export$2e2bcd8739ae039), {
                    count: badgeCount || 0
                })
            ]
        })
    });
};
var $10b875e0065cf2d7$export$2e2bcd8739ae039 = $10b875e0065cf2d7$var$SidebarMenuItem;



/**
 * Generic layout component for pages with a sidebar menu
 * @template T - Type of the outlet context
 */ function $2611524601c1153f$var$SidebarLayout({ basePath: basePath, menu: menu, outletContext: outletContext, menuTitle: menuTitle }) {
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const getCurrentSection = ()=>{
        for (const group of Object.values(menu)){
            const section = group.sections.find((section)=>location.pathname.includes(section.path));
            if (section) return section;
        }
        return undefined;
    };
    const currentSection = getCurrentSection();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 3,
                            children: [
                                menuTitle && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                    className: "title",
                                    size: 5,
                                    mb: 3,
                                    px: 2,
                                    textColor: "primary",
                                    children: menuTitle
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Menu), {
                                        children: Object.entries(menu).map(([groupKey, group])=>{
                                            return group.sections[0] ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Menu).List, {
                                                title: group.title,
                                                children: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(group.sections, 'label').map((section)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $10b875e0065cf2d7$export$2e2bcd8739ae039), {
                                                        ...section,
                                                        isActive: Boolean(currentSection?.path === section.path),
                                                        basePath: basePath
                                                    }, section.path))
                                            }, groupKey) : null;
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 9,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$910ae8079b2c2852), {
                                context: outletContext
                            })
                        })
                    ]
                })
            })
        })
    });
}
var $2611524601c1153f$export$2e2bcd8739ae039 = $2611524601c1153f$var$SidebarLayout;




const $567c8e31102994db$var$InterimAgencySettingsWrapper = ({ mode: mode })=>{
    const { id: id } = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const { data: data } = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(id, 'interimAgency', {
        enabled: mode !== 'currentOrganization'
    });
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    let interimAgency;
    if (mode === 'currentOrganization') interimAgency = currentOrganization;
    else interimAgency = data;
    const menu = {
        missionsAndWorkPeriods: {
            title: "Missions & Journ\xe9es de Travail",
            sections: [
                {
                    path: 'workers',
                    label: "Int\xe9rimaires",
                    icon: (0, $e0de785befddd5e2$export$ffac63b363808810)
                }
            ]
        },
        collaboration: {
            title: 'Collaboration',
            sections: [
                {
                    path: 'partner-employers',
                    label: 'Entreprises Partenaires',
                    icon: (0, $e0de785befddd5e2$export$45a25e33c6871670)
                }
            ]
        },
        subscriptions: {
            title: 'Abonnements et consommations',
            sections: [
                {
                    path: 'app-subscription-periods/new',
                    label: 'En cours',
                    icon: (0, $e0de785befddd5e2$export$ddf80f27ca83567b)
                },
                {
                    path: 'app-subscription-periods',
                    label: 'Historique',
                    icon: (0, $ce48c6296f76f7cc$export$2e2bcd8739ae039)
                }
            ]
        },
        settings: {
            title: "Param\xe8tres",
            sections: [
                {
                    path: 'info',
                    label: "D\xe9tails de l'Agence",
                    icon: (0, $66fc2642466e214b$export$2e2bcd8739ae039)
                },
                {
                    path: 'terminals',
                    label: 'Bornes de Pointage',
                    icon: (0, $e0de785befddd5e2$export$9ff5547afd06adf7)
                }
            ]
        }
    };
    if (!(0, $8403deec6a28521e$export$6025088343704f9f)([
        'interimAgencyMember'
    ])) menu.missionsAndWorkPeriods.sections = [];
    if ((0, $8403deec6a28521e$export$6025088343704f9f)([
        'interimAgencyMember'
    ])) menu.collaboration.sections.push({
        path: 'members',
        label: 'Gestionnaires de mon agence',
        icon: (0, $66fc2642466e214b$export$2e2bcd8739ae039)
    });
    if ((0, $8403deec6a28521e$export$6025088343704f9f)([
        'superAdmin'
    ])) menu.settings.sections.push({
        path: 'app-subscription-options',
        label: "Co\xfbts d'abonnement",
        icon: (0, $9ebd0210d45a1cac$export$2e2bcd8739ae039)
    });
    if (!interimAgency) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (location.pathname === '/settings') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/settings/info",
        replace: true
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2611524601c1153f$export$2e2bcd8739ae039), {
        basePath: mode === 'currentOrganization' ? '/settings' : `/agencies/${id}`,
        menu: menu,
        outletContext: {
            interimAgency: interimAgency
        },
        menuTitle: (0, $8403deec6a28521e$export$6025088343704f9f)([
            'superAdmin'
        ]) ? interimAgency.name : undefined
    });
};
var $567c8e31102994db$export$2e2bcd8739ae039 = $567c8e31102994db$var$InterimAgencySettingsWrapper;



parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");





/**
 * Composant affichant la liste des associations entre entreprises utilisatrices et agences d'intérim
 */ const $e3a4be91692bb6fd$var$AssociationsTable = ({ organizations: organizations, interimAgency: interimAgency, itemPath: itemPath })=>{
    const tableColumns = $e3a4be91692bb6fd$var$useListTableColumns(organizations, interimAgency, itemPath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: organizations.filter((organization)=>organization?.associations?.some((association)=>{
                const interimAgency = association.interimAgency;
                return interimAgency && interimAgency._id === interimAgency._id;
            })),
        noDataMessage: "Aucune EU \xe0 afficher"
    });
};
var $e3a4be91692bb6fd$export$2e2bcd8739ae039 = $e3a4be91692bb6fd$var$AssociationsTable;
// Hook déplacé dans le même fichier
const $e3a4be91692bb6fd$var$useListTableColumns = (organizations, interimAgency, itemPath)=>{
    const getAssociation = (employer)=>{
        return employer.associations.find((association)=>{
            return (0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(association.interimAgency, interimAgency);
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>{
                    const organization = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                        resource: organization,
                        path: itemPath || '/job-titles/',
                        label: organization.name
                    });
                }
            },
            {
                Header: "Statut de l'invitation",
                accessor: 'status',
                Cell: (data)=>{
                    const association = getAssociation(data.cell.row.original);
                    //TODO: refactor component and type
                    return association ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                        role: association,
                        showDate: true
                    }) : null;
                }
            },
            {
                Header: "Invit\xe9 le",
                accessor: 'createdAt',
                Cell: (data)=>{
                    const association = getAssociation(data.cell.row.original);
                    return (0, $74f17ceb9b5a08a5$export$5c1c558c67b268ff)(association?.createdAt);
                }
            }
        ], [
        organizations
    ]);
};






var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");





const $fdf75f69b4370173$var$AssociationForm = ({ employers: employers, interimAgency: interimAgency })=>{
    const createAssociationMutation = (0, $58f46cb3f921014b$export$12ac715909ba00ff)();
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            employerId: '',
            interimAgencyId: interimAgency._id
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.employerId) errors.employerId = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            createAssociationMutation.mutate(values);
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                            size: 12,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        "Inviter un Employeur \xe0 collaborer avec ",
                                        interimAgency.name
                                    ]
                                }),
                                name: "employerId",
                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                type: "number",
                                min: 0,
                                step: 0.001,
                                required: true,
                                options: employers.filter((employer)=>!employer.associations.some((association)=>association.interimAgency._id === currentOrganization?._id)).map((employer)=>({
                                        label: employer.name,
                                        value: employer._id
                                    }))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            mt: 6,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 1,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                        mutation: createAssociationMutation
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                    color: "primary",
                                    type: "submit",
                                    mutation: createAssociationMutation,
                                    "data-test": "submit-new-association-form",
                                    children: "Inviter la soci\xe9t\xe9"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    });
};
var $fdf75f69b4370173$export$2e2bcd8739ae039 = $fdf75f69b4370173$var$AssociationForm;






parcelRequire("3ZYaX");

const $d320d508020ad161$var$EmployerAgencyExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "L'association entre un employeur et une agence permet de commander et d'effectuer des missions d'int\xe9rim. Une fois l'association valid\xe9e, elle d\xe9termine :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Missions d'Int\xe9rim"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "L'employeur peut cr\xe9er des demandes de mission aupr\xe8s de l'agence qui pourra y affecter ses int\xe9rimaires. Les missions sont ensuite suivies par les deux parties."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Coefficients de Main d'\u0152uvre"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Pour chaque m\xe9tier, un coefficient de facturation sp\xe9cifique est d\xe9fini. Ce coefficient est utilis\xe9 pour calculer le co\xfbt des missions d'int\xe9rim."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Ces param\xe8tres sont utilis\xe9s automatiquement lors de la cr\xe9ation et du suivi des missions d'int\xe9rim entre l'employeur et l'agence."
                })
            })
        ]
    });
};
var $d320d508020ad161$export$2e2bcd8739ae039 = $d320d508020ad161$var$EmployerAgencyExplanation;


const $e63ef777e185c0cc$var$PartnerEmployers = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const organizationsQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    }, {
        enabled: (0, $8403deec6a28521e$export$6025088343704f9f)([
            'superAdmin'
        ])
    });
    const associatiedEmployersQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer',
        'associations.interimAgency': interimAgency?._id
    });
    const associatiedEmployers = associatiedEmployersQuery.data || [];
    const inviteEmployerModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const employers = organizationsQuery.data || [];
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    className: "is-flex is-justify-content-flex-end",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        outlined: true,
                        color: "primary",
                        onClick: ()=>inviteEmployerModal.setIsDisplayed(true),
                        mr: 2,
                        size: "small",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8ed0b2eeef0c2e65$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                children: "Ajouter un Employeur Paternaire"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Entreprises Utilisatrices Partenaires",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d320d508020ad161$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: interimAgency && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e3a4be91692bb6fd$export$2e2bcd8739ae039), {
                    organizations: associatiedEmployers,
                    interimAgency: interimAgency,
                    itemPath: `/settings/partner-employers/`
                })
            }),
            interimAgency && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                title: "Inviter un Nouvel Employeur",
                actions: inviteEmployerModal,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fdf75f69b4370173$export$2e2bcd8739ae039), {
                    employers: employers,
                    interimAgency: interimAgency
                })
            })
        ]
    });
};
var $e63ef777e185c0cc$export$2e2bcd8739ae039 = $e63ef777e185c0cc$var$PartnerEmployers;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");





const $94599e4859858fd7$var$AgencySubscriptionForm = ({ interimAgency: interimAgency })=>{
    const updateMutation = (0, $58f46cb3f921014b$export$cac0b33e6f13c8ec)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            appSubscriptionOptions: interimAgency?.appSubscriptionOptions || {
                licenseFee: 0,
                tiers: [
                    {
                        workersRange: {
                            min: 1,
                            max: null
                        },
                        workPeriodCost: 10
                    }
                ]
            }
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (values.appSubscriptionOptions.licenseFee < 0) errors.appSubscriptionOptions = {
                licenseFee: "Le montant doit \xeatre positif"
            };
            // Validation des tiers
            const { tiers: tiers } = values.appSubscriptionOptions;
            if (tiers.length === 0) errors['appSubscriptionOptions.tiers'] = 'Au moins un palier est requis';
            else tiers.forEach((tier, index)=>{
                // Validation du min
                if (tier.workersRange.min < 0) errors[`appSubscriptionOptions.tiers.${index}.workersRange.min`] = "Le nombre minimum doit \xeatre positif";
                // Validation de la continuité des tiers
                if (index > 0) {
                    const previousTier = tiers[index - 1];
                    if (tier.workersRange.min !== (previousTier?.workersRange.max || 0) + 1) errors[`appSubscriptionOptions.tiers.${index}.workersRange.min`] = "Le minimum doit \xeatre \xe9gal au maximum du palier pr\xe9c\xe9dent + 1";
                } else if (tier.workersRange.min !== 1) errors[`appSubscriptionOptions.tiers.0.workersRange.min`] = "Le minimum du premier palier doit \xeatre \xe9gal \xe0 1";
                // Validation du max (sauf pour le dernier tier)
                if (index < tiers.length - 1) {
                    if (!tier.workersRange.max) errors[`appSubscriptionOptions.tiers.${index}.workersRange.max`] = "Seul le dernier palier doit avoir une valeur maximum non d\xe9finie";
                    else if (tier.workersRange.max <= tier.workersRange.min) errors[`appSubscriptionOptions.tiers.${index}.workersRange.max`] = "Le maximum doit \xeatre sup\xe9rieur au minimum";
                }
                // Validation du coût
                if (tier.workPeriodCost < 0) errors[`appSubscriptionOptions.tiers.${index}.workPeriodCost`] = "Le co\xfbt doit \xeatre positif";
            });
            return errors;
        },
        onSubmit: (values)=>{
            const tiers = values.appSubscriptionOptions.tiers;
            if (tiers.length) tiers[tiers.length - 1].workersRange.max = undefined;
            if (interimAgency) updateMutation.mutate({
                id: interimAgency._id,
                appSubscriptionOptions: values.appSubscriptionOptions
            });
        },
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                        size: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                            label: "Frais de licence de base",
                            name: "appSubscriptionOptions.licenseFee",
                            help: "Cout licence par semaine",
                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                            type: "number",
                            min: 0,
                            required: true,
                            step: 0.01
                        })
                    })
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($94599e4859858fd7$var$SubscriptionTiersForm, {}),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                    mutation: updateMutation
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                color: "primary",
                                type: "submit",
                                mutation: updateMutation,
                                children: "Mettre \xe0 jour les options d'abonnement"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $94599e4859858fd7$export$2e2bcd8739ae039 = $94599e4859858fd7$var$AgencySubscriptionForm;
const $94599e4859858fd7$var$SubscriptionTiersForm = ()=>{
    const { values: values } = (0, $31tXu.useFormikContext)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
        name: "appSubscriptionOptions.tiers",
        render: (arrayHelpers)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                children: [
                    values.appSubscriptionOptions.tiers.map((tier, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            vCentered: true,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "Travailleurs min",
                                        name: `appSubscriptionOptions.tiers.${index}.workersRange.min`,
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "number",
                                        min: 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "Travailleurs max",
                                        name: `appSubscriptionOptions.tiers.${index}.workersRange.max`,
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "number",
                                        min: 0
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "Prix par travailleur",
                                        name: `appSubscriptionOptions.tiers.${index}.workPeriodCost`,
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "number",
                                        min: 0,
                                        step: 0.0001
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    narrow: true,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        onClick: ()=>arrayHelpers.remove(index),
                                        style: {
                                            marginTop: '1.8rem'
                                        },
                                        size: 'small',
                                        type: "button",
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1a0bf4c1ef962d88$export$2e2bcd8739ae039), {})
                                        })
                                    })
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                        outlined: true,
                        color: "primary",
                        size: "small",
                        type: "button",
                        onClick: ()=>arrayHelpers.push({
                                workersRange: {
                                    min: (values.appSubscriptionOptions.tiers[values.appSubscriptionOptions.tiers.length - 1]?.workersRange.max || 0) + 1,
                                    max: 0
                                },
                                workPeriodCost: 0
                            }),
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4d3c66d4b09ff42b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                children: "Ajouter un palier"
                            })
                        ]
                    })
                ]
            })
    });
};




const $f5b861c8e469154f$var$AppSubscriptionOptions = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Options d'abonnement"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $94599e4859858fd7$export$2e2bcd8739ae039), {
                    interimAgency: interimAgency
                })
            })
        ]
    });
};
var $f5b861c8e469154f$export$2e2bcd8739ae039 = $f5b861c8e469154f$var$AppSubscriptionOptions;



parcelRequire("3ZYaX");




const $3e71c0ff5f0f49f1$var$AgencyInfo = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Informations de l'agence"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d811c3042d321ad2$export$2e2bcd8739ae039), {
                    interimAgency: interimAgency
                })
            })
        ]
    });
};
var $3e71c0ff5f0f49f1$export$2e2bcd8739ae039 = $3e71c0ff5f0f49f1$var$AgencyInfo;



parcelRequire("3ZYaX");




const $5aebcdd7709738ce$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/app-subscription-periods',
        method: 'get',
        params: {
            sort: '-periodEnd',
            populate: [
                'interimAgency',
                'employer'
            ],
            ...params || {}
        }
    });
const $5aebcdd7709738ce$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/app-subscription-periods/${id}`,
        method: 'get',
        params: {
            populate: [
                'interimAgency',
                'employer'
            ]
        }
    });
const $5aebcdd7709738ce$export$22bb49e9093bcc95 = async (params)=>{
    const { interimAgencyId: interimAgencyId, periodNumber: periodNumber, periodYear: periodYear } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/app-subscription-periods/interim-agency/${interimAgencyId}/totals`,
        method: 'get',
        params: {
            periodNumber: periodNumber,
            periodYear: periodYear
        }
    });
};
const $5aebcdd7709738ce$export$11d7b7a9e5cd2d94 = async (interimAgencyId)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/app-subscription-periods/interim-agency/${interimAgencyId}/periods`,
        method: 'get'
    });
const $5aebcdd7709738ce$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/app-subscription-periods',
        method: 'post',
        params: params
    });
const $5aebcdd7709738ce$export$722fbec263ad908a = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/app-subscription-periods/${params._id}`,
        method: 'put',
        params: params
    });
const $5aebcdd7709738ce$export$ff85883383a8062f = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/app-subscription-periods/interim-agency/${params.interimAgencyId}/employer/${params.employerId}/year/${params.periodYear}/period/${params.periodNumber}`,
        method: 'get'
    });



const $97348b8b26814c7c$export$77a87b9eb9feddcc = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('app-subscription-periods', (0, $5aebcdd7709738ce$export$3988ae62b71be9a3), id, undefined, options);
const $97348b8b26814c7c$export$9f67595e2899d7ca = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('app-subscription-periods', (0, $5aebcdd7709738ce$export$e7aa7bc5c1b3cfb3), filters, options);
const $97348b8b26814c7c$export$7b6f7e7feca2614e = (params, options)=>// Important: use a params-based cache key so changes like employerId trigger refetch
    (0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('app-subscription-periods-by-period', (0, $5aebcdd7709738ce$export$ff85883383a8062f), params, options);
const $97348b8b26814c7c$export$4743e4c5c222fe74 = (params, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('app-subscription-periods-totals', (0, $5aebcdd7709738ce$export$22bb49e9093bcc95), undefined, params, {
        ...options,
        enabled: !!params?.interimAgencyId
    });
const $97348b8b26814c7c$export$d3f207b9b79e0436 = (interimAgencyId, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)(`app-subscription-periods-all-periods`, (0, $5aebcdd7709738ce$export$11d7b7a9e5cd2d94), interimAgencyId, undefined, {
        ...options,
        enabled: !!interimAgencyId
    });
// Mutations
const $97348b8b26814c7c$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'app-subscription-periods'
    ]);
};
const $97348b8b26814c7c$export$cf655a09c5129234 = ()=>[
        'app-subscription-periods',
        'create'
    ];
const $97348b8b26814c7c$export$7a1f02de24e0e756 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $5aebcdd7709738ce$export$185802fd694ee1f5), {
        mutationKey: $97348b8b26814c7c$export$cf655a09c5129234(),
        onSuccess: $97348b8b26814c7c$var$onMutationSuccess
    });
const $97348b8b26814c7c$export$77a82aedbfb8bd5d = (appSubscriptionPeriodsInterimAgencyTotal)=>{
    const mutation = $97348b8b26814c7c$export$7a1f02de24e0e756();
    const create = async (params)=>{
        const res = await Promise.all(appSubscriptionPeriodsInterimAgencyTotal.employerDetails.map(async (employer)=>(await mutation.mutateAsync({
                ...params,
                employer: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(employer.employer),
                periodNumber: appSubscriptionPeriodsInterimAgencyTotal.period.periodNumber,
                periodYear: appSubscriptionPeriodsInterimAgencyTotal.period.year,
                interimAgency: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(appSubscriptionPeriodsInterimAgencyTotal.interimAgency)
            })).data));
        (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
            'app-subscription-periods-totals'
        ]);
        return res;
    };
    return create;
};
const $97348b8b26814c7c$export$e94e48b3f216b815 = ()=>[
        'app-subscription-periods',
        'update'
    ];
const $97348b8b26814c7c$export$a5257ee9f5bf4945 = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $5aebcdd7709738ce$export$722fbec263ad908a), {
        mutationKey: $97348b8b26814c7c$export$e94e48b3f216b815(),
        onSuccess: $97348b8b26814c7c$var$onMutationSuccess
    });
const $97348b8b26814c7c$export$8f46ee73af251482 = (appSubscriptionPeriodsInterimAgencyTotal)=>{
    const mutation = $97348b8b26814c7c$export$a5257ee9f5bf4945();
    const update = async (params)=>{
        const res = await Promise.all(appSubscriptionPeriodsInterimAgencyTotal.employerDetails.map(async (employer)=>(await mutation.mutateAsync({
                ...params,
                _id: employer.appSubscriptionPeriodId
            })).data));
        (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
            'app-subscription-periods-totals'
        ]);
        return res;
    };
    return update;
};




var $3ZYaX = parcelRequire("3ZYaX");



var $2KSUA = parcelRequire("2KSUA");



/**
 * Parse une chaîne de caractères au format "YYYY_WW" en objet contenant l'année et la semaine
 * @param periodString - Chaîne au format "YYYY_WW" (ex: "2024_12")
 * @returns {Object} Objet contenant year et week
 */ const $f3712d580909ae24$export$64c7f6fc3424e212 = (periodString)=>{
    const [yearStr, weekStr] = periodString.split('_');
    if (!yearStr || !weekStr) throw new Error('Format de p\xe9riode invalide. Attendu: "YYYY_WW"');
    const periodYear = parseInt(yearStr, 10);
    const periodNumber = parseInt(weekStr, 10);
    if (isNaN(periodYear) || isNaN(periodNumber)) throw new Error('Format de p\xe9riode invalide. Attendu: "YYYY_WW"');
    return {
        periodYear: periodYear,
        periodNumber: periodNumber
    };
};
const $f3712d580909ae24$export$ce535c4efa3d8d22 = (periodYear, periodNumber)=>{
    return `${periodYear}_${periodNumber.toString().padStart(2, '0')}`;
};




/**
 * Composant pour afficher les périodes d'abonnement d'une agence d'intérim
 * @param data - Liste des périodes d'abonnement de l'agence
 */ const $f3b605e7216fbd4d$var$AppSubscriptionPeriodsAgencyList = ({ data: data, itemPath: itemPath })=>{
    const tableColumns = $f3b605e7216fbd4d$var$useAgencyPeriodsTableColumns(itemPath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $2KSUA.sortBy)(data, 'from').reverse(),
        noDataMessage: "Aucune p\xe9riode d'abonnement \xe0 afficher pour cette agence"
    });
};
/**
 * Hook pour définir les colonnes du tableau des périodes d'une agence
 */ const $f3b605e7216fbd4d$var$useAgencyPeriodsTableColumns = (itemPath)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const columns = [
            {
                Header: "P\xe9riode",
                accessor: 'identifier',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                        resource: {
                            ...data.row.original,
                            _id: `${data.row.original.year}_${data.row.original.periodNumber}`
                        },
                        path: itemPath || '/app-subscription-periods/',
                        label: (0, $f3712d580909ae24$export$ce535c4efa3d8d22)(data.row.original.year, data.row.original.periodNumber)
                    })
            },
            {
                Header: "N\xb0 de facture",
                accessor: 'invoiceRef'
            },
            {
                Header: 'Du',
                accessor: 'from',
                Cell: ({ value: value })=>(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(value)
            },
            {
                Header: 'Au',
                accessor: 'to',
                Cell: ({ value: value })=>(0, $74f17ceb9b5a08a5$export$7d98027883de41f3)(value.toString())
            },
            {
                Header: 'Total HT',
                accessor: 'totalAmount',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$e370a7ddaa2f579a)(value)
            }
        ];
        if ((0, $8403deec6a28521e$export$6025088343704f9f)([
            'superAdmin'
        ])) columns.splice(columns.length - 1, 0, {
            Header: "Valid\xe9e",
            accessor: 'status',
            Cell: ({ value: value })=>value === 'validated' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {})
        });
        return columns;
    }, [
        itemPath
    ]);
};
var $f3b605e7216fbd4d$export$2e2bcd8739ae039 = $f3b605e7216fbd4d$var$AppSubscriptionPeriodsAgencyList;





const $19605edf5f74c759$var$AppSubscriptionPeriods = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { data: allPeriods } = (0, $97348b8b26814c7c$export$d3f207b9b79e0436)(interimAgency._id, {
        enabled: Boolean(interimAgency)
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "P\xe9riodes d'abonnement"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f3b605e7216fbd4d$export$2e2bcd8739ae039), {
                    data: allPeriods || [],
                    itemPath: (0, $8403deec6a28521e$export$6025088343704f9f)([
                        'superAdmin'
                    ]) ? `/agencies/${interimAgency._id}/app-subscription-periods/` : '/settings/app-subscription-periods/'
                })
            })
        ]
    });
};
var $19605edf5f74c759$export$2e2bcd8739ae039 = $19605edf5f74c759$var$AppSubscriptionPeriods;




var $3ZYaX = parcelRequire("3ZYaX");







var $3ZYaX = parcelRequire("3ZYaX");




var $2KSUA = parcelRequire("2KSUA");

/**
 * Tableau détaillant les tarifs et coûts d'une période d'abonnement
 */ const $89a58928770a2177$var$AppSubscriptionPeriodTable = ({ period: period, activeEmployer: activeEmployer, onTerminalDetailsClick: onTerminalDetailsClick })=>{
    const columns = (0, $3ZYaX.useMemo)(()=>{
        const baseColumns = [
            {
                Header: 'Tarifs',
                accessor: 'name'
            },
            {
                Header: 'Prix unitaire HT',
                accessor: 'unitPrice',
                Cell: ({ value: value })=>value && (0, $2KSUA.isNumber)(value) ? (0, $0798496ba66df318$export$d0d40d105bf15201)(value) : value || ''
            },
            {
                Header: "Unit\xe9",
                accessor: 'unitType'
            },
            {
                Header: "Quantit\xe9",
                accessor: 'quantity'
            },
            {
                Header: 'Total HT',
                accessor: 'total',
                Cell: ({ value: value })=>value ? (0, $0798496ba66df318$export$d0d40d105bf15201)(value) : "0\u20AC"
            }
        ];
        return baseColumns;
    }, [
        period,
        onTerminalDetailsClick,
        activeEmployer
    ]);
    const tableData = (0, $3ZYaX.useMemo)(()=>{
        const rows = [
            {
                name: "Licence d'utilisation par EU",
                unitPrice: period.pricing.licenseFee,
                unitType: 'Semaine',
                quantity: period.metrics.licenseCount,
                total: period.fees.totalLicenseFees
            },
            {
                name: 'Location des bornes',
                unitPrice: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                    onClick: ()=>onTerminalDetailsClick?.(),
                    color: "ghost",
                    size: "small",
                    p: 1,
                    "data-test": "app-subscription-period-terminal-details-button",
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2957fc44b3d2481), {})
                    })
                }),
                unitType: 'Semaine',
                quantity: period.metrics.weeklyTerminalsCumulative,
                total: period.fees.totalTerminalFees
            },
            ...period.pricing.tiers.map((tier, index)=>({
                    name: `Utilisation de ${tier.workersRange.min} \xe0 ${tier.workersRange.max || "\u221E"} salari\xe9s`,
                    unitPrice: tier.workPeriodCost,
                    unitType: "Salari\xe9 / jour",
                    quantity: period.fees.tierTotals[index]?.workPeriodsCount || 0,
                    total: period.fees.tierTotals[index]?.totalCost || 0
                })),
            {
                name: 'Total HT',
                unitPrice: undefined,
                unitType: '',
                quantity: undefined,
                total: period.fees.total
            }
        ];
        return rows;
    }, [
        period,
        onTerminalDetailsClick,
        activeEmployer
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: columns,
        data: tableData,
        className: "is-bordered",
        dataTest: "app-subscription-period-table"
    });
};
var $89a58928770a2177$export$2e2bcd8739ae039 = $89a58928770a2177$var$AppSubscriptionPeriodTable;




var $3ZYaX = parcelRequire("3ZYaX");



/**
 * Tableau détaillant les totaux pour une agence d'intérim
 */ const $dead6d073746346a$var$AgencyTotalsTable = ({ totals: totals, onEmployerClick: onEmployerClick })=>{
    const columns = (0, $3ZYaX.useMemo)(()=>[
            {
                Header: 'Employeur',
                accessor: 'name'
            },
            {
                Header: 'Abonnement',
                accessor: 'licenseFees',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$d0d40d105bf15201)(value)
            },
            {
                Header: 'Bornes',
                accessor: 'terminalFees',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$d0d40d105bf15201)(value)
            },
            {
                Header: 'Consommation',
                accessor: 'workPeriodsFees',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$d0d40d105bf15201)(value)
            },
            {
                Header: 'Total HT',
                accessor: 'total',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$d0d40d105bf15201)(value)
            }
        ], []);
    const tableData = (0, $3ZYaX.useMemo)(()=>{
        const employerRows = totals.employerDetails.map((detail)=>({
                name: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "a",
                    onClick: ()=>onEmployerClick && onEmployerClick(detail.employer),
                    children: detail.employer.name
                }),
                workPeriods: detail.metrics.workPeriodsCount,
                uniqueWorkers: detail.metrics.uniqueWorkersCount,
                withoutClockings: detail.metrics.workPeriodsWithoutClockingsCount,
                licenseFees: detail.fees.licenseFees,
                workPeriodsFees: detail.fees.workPeriodsFees,
                terminalFees: detail.fees.terminalFees,
                adjustments: detail.fees.adjustmentsAmount,
                total: detail.fees.total
            }));
        // Ligne des totaux
        const totalRow = {
            name: 'Total HT',
            workPeriods: totals.totalWorkPeriods,
            uniqueWorkers: totals.totalUniqueWorkers,
            withoutClockings: totals.totalWorkPeriodsWithoutClockings,
            licenseFees: totals.totalLicenseFees,
            workPeriodsFees: totals.totalWorkPeriodsFees,
            terminalFees: totals.totalTerminalFees,
            adjustments: totals.totalAdjustments,
            total: totals.totalAmount
        };
        return [
            ...employerRows,
            totalRow
        ];
    }, [
        totals
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: columns,
        data: tableData,
        className: "is-bordered",
        noDataMessage: "Aucun total \xe0 afficher"
    });
};
var $dead6d073746346a$export$2e2bcd8739ae039 = $dead6d073746346a$var$AgencyTotalsTable;




var $3ZYaX = parcelRequire("3ZYaX");



/**
 * Composant affichant les métriques journalières d'une période d'abonnement
 */ const $509e4b5396968a23$var$AppSubscriptionPeriodDailyDetails = ({ period: period })=>{
    const columns = (0, $3ZYaX.useMemo)(()=>{
        const baseColumns = [
            {
                Header: 'Date',
                accessor: 'date'
            },
            {
                Header: "P\xe9riodes de travail",
                accessor: 'workPeriodsCount'
            }
        ];
        // Ajout dynamique des colonnes pour chaque tier
        period.pricing.tiers.forEach((tier, index)=>{
            baseColumns.push({
                Header: `Palier ${index + 1} (${tier.workersRange.min}-${tier.workersRange.max || "\u221E"})`,
                accessor: `tier${index}Count`
            });
        });
        return baseColumns;
    }, [
        period.pricing.tiers
    ]);
    const tableData = (0, $3ZYaX.useMemo)(()=>{
        // Calculer d'abord les données journalières
        const dailyData = period.metrics.dailyMetrics.map((metric)=>{
            const dailyPricing = period.pricing.dailyPricing.find((dp)=>dp.date.toString() === metric.date.toString());
            const tierCounts = period.pricing.tiers.reduce((acc, _, index)=>({
                    ...acc,
                    [`tier${index}Count`]: dailyPricing?.workPeriodsDistribution[index]?.workPeriodsCount || 0
                }), {});
            return {
                ...metric,
                ...tierCounts,
                date: (0, $74f17ceb9b5a08a5$export$d30d8547ed0ef255)(metric.date)
            };
        });
        // Calculer la ligne des totaux
        const totalsRow = {
            date: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                children: "Total"
            }),
            workPeriodsCount: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "strong",
                children: period.metrics.workPeriodsCount
            }),
            ...period.pricing.tiers.reduce((acc, _, index)=>({
                    ...acc,
                    [`tier${index}Count`]: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        children: dailyData.reduce(//@ts-ignore
                        (sum, day)=>sum + (day[`tier${index}Count`] || 0), 0)
                    })
                }), {})
        };
        // Retourner le tableau avec la ligne des totaux en première position
        return [
            totalsRow,
            ...dailyData
        ];
    }, [
        period
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                size: 6,
                className: "mb-4",
                children: "D\xe9tails journaliers"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
                columns: columns,
                data: tableData,
                className: "is-bordered is-striped is-narrow",
                noDataMessage: "Aucune donn\xe9e journali\xe8re disponible",
                dataTest: "app-subscription-period-daily-details"
            })
        ]
    });
};
var $509e4b5396968a23$export$2e2bcd8739ae039 = $509e4b5396968a23$var$AppSubscriptionPeriodDailyDetails;







var $3ZYaX = parcelRequire("3ZYaX");




const $89725ac98ef36824$var$AppSubscriptionPeriodTerminalsTable = ({ weeklyTerminalFees: weeklyTerminalFees, totalTerminalFees: totalTerminalFees })=>{
    const columns = (0, $3ZYaX.useMemo)(()=>[
            {
                Header: 'Semaine',
                accessor: 'weekNumber'
            },
            {
                Header: 'Terminal',
                accessor: 'deviceName'
            },
            {
                Header: "N\xb0 de s\xe9rie",
                accessor: 'serialNumber'
            },
            {
                Header: "Co\xfbt HT",
                accessor: 'rentalCost',
                Cell: ({ value: value })=>(0, $0798496ba66df318$export$d0d40d105bf15201)(value)
            }
        ], []);
    const tableData = (0, $3ZYaX.useMemo)(()=>{
        const detailRows = weeklyTerminalFees.flatMap((week)=>week.terminals.map((terminal)=>({
                    weekNumber: week.weekNumber,
                    period: `${(0, $b3177a4462e15523$export$2e2bcd8739ae039)(new Date(week.startDate), 'dd/MM/yyyy', {
                        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
                    })} - ${(0, $b3177a4462e15523$export$2e2bcd8739ae039)(new Date(week.endDate), 'dd/MM/yyyy', {
                        locale: (0, $b6ba373da694181e$export$2e2bcd8739ae039)
                    })}`,
                    deviceName: terminal.deviceName,
                    serialNumber: terminal.serialNumber,
                    rentalCost: terminal.rentalCost
                })));
        const totalRow = {
            weekNumber: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                children: "TOTAL"
            }),
            period: '',
            deviceName: '',
            serialNumber: '',
            rentalCost: totalTerminalFees
        };
        return [
            ...detailRows,
            totalRow
        ];
    }, [
        weeklyTerminalFees,
        totalTerminalFees
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: columns,
        data: tableData,
        className: "is-bordered is-striped is-narrow is-fullwidth",
        dataTest: "app-subscription-period-terminals-table"
    });
};
var $89725ac98ef36824$export$2e2bcd8739ae039 = $89725ac98ef36824$var$AppSubscriptionPeriodTerminalsTable;






var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");




const $757a7e81bdda72b5$var$AppSubscriptionPeriodValidationForm = ({ periodTotal: periodTotal, onSuccess: onSuccess })=>{
    const createMutation = (0, $97348b8b26814c7c$export$77a82aedbfb8bd5d)(periodTotal);
    const updateMutation = (0, $97348b8b26814c7c$export$8f46ee73af251482)(periodTotal);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            invoiceRef: periodTotal.invoiceRef,
            comment: periodTotal.comment
        },
        onSubmit: async (values)=>{
            if (periodTotal.employerDetails[0]?.appSubscriptionPeriodId) await updateMutation(values);
            else await createMutation(values);
            onSuccess?.();
        },
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: "R\xe9f\xe9rence de facture",
                    name: "invoiceRef",
                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                    label: "Commentaire",
                    name: "comment",
                    component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039)
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                    color: "primary",
                    type: "submit",
                    mt: 4,
                    children: "Valider la p\xe9riode"
                })
            ]
        })
    });
};
var $757a7e81bdda72b5$export$2e2bcd8739ae039 = $757a7e81bdda72b5$var$AppSubscriptionPeriodValidationForm;


var $c248da1c89654e0d$export$2e2bcd8739ae039 = {
    status: {
        draft: 'En attente de facturation',
        validated: "P\xe9riode termin\xe9e et factur\xe9e",
        inProgress: "P\xe9riode en cours"
    }
};


const $afd09a869d7c7d4c$var$AppSubscriptionPeriod = ()=>{
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)({
        idName: 'appSubscriptionPeriodId'
    });
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [activeEmployer, setActiveEmployer] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const [showDailyDetails, setShowDailyDetails] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const terminalModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const validationModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    let periodYear;
    let periodNumber;
    if (id && !isNew) {
        const parsedPeriod = (0, $f3712d580909ae24$export$64c7f6fc3424e212)(id);
        periodYear = parsedPeriod.periodYear;
        periodNumber = parsedPeriod.periodNumber;
    }
    const appSubscriptionPeriodTotalsQuery = (0, $97348b8b26814c7c$export$4743e4c5c222fe74)({
        interimAgencyId: interimAgency._id,
        periodNumber: periodNumber,
        periodYear: periodYear
    });
    const { data: period } = (0, $97348b8b26814c7c$export$7b6f7e7feca2614e)({
        //@ts-ignore
        periodNumber: appSubscriptionPeriodTotalsQuery.data?.period.periodNumber,
        //@ts-ignore
        periodYear: appSubscriptionPeriodTotalsQuery.data?.period.year,
        interimAgencyId: interimAgency._id,
        employerId: activeEmployer?._id || ''
    }, {
        enabled: Boolean(activeEmployer) && Boolean(appSubscriptionPeriodTotalsQuery.data)
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        appSubscriptionPeriodTotalsQuery.refetch();
        setActiveEmployer(null);
        terminalModal.setIsDisplayed(false);
    }, [
        id,
        isNew
    ]);
    const appSubscriptionPeriodTotal = appSubscriptionPeriodTotalsQuery.data;
    const employer = period?.employer;
    if (!appSubscriptionPeriodTotal) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "D\xe9tails de la p\xe9riode d'abonnement"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            mb: 1,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "Ref Client:"
                                        }),
                                        " ",
                                        interimAgency?.name
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "N\xb0 de P\xe9riode:"
                                        }),
                                        " ",
                                        appSubscriptionPeriodTotal.period.identifier
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            mb: 1,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "P\xe9riode:"
                                        }),
                                        " du ",
                                        (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(appSubscriptionPeriodTotal.period?.from),
                                        " au",
                                        ' ',
                                        (0, $74f17ceb9b5a08a5$export$7d98027883de41f3)(appSubscriptionPeriodTotal.period?.to.toString())
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                                        className: "d-flex align-items-center gap-2",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                children: "Status:"
                                            }),
                                            " ",
                                            (0, $c248da1c89654e0d$export$2e2bcd8739ae039).status[appSubscriptionPeriodTotal.status],
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                                roles: [
                                                    'superAdmin'
                                                ],
                                                children: appSubscriptionPeriodTotal.status === 'draft' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    onClick: ()=>validationModal.setIsDisplayed(true),
                                                    size: "small",
                                                    ml: 5,
                                                    pull: "right",
                                                    color: 'success',
                                                    textColor: "white",
                                                    children: "Valider la p\xe9riode"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            mb: 1,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "N\xb0 de Facture:"
                                        }),
                                        " ",
                                        appSubscriptionPeriodTotal.invoiceRef || 'N/A',
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                            roles: [
                                                'superAdmin'
                                            ],
                                            children: appSubscriptionPeriodTotal.employerDetails[0]?.appSubscriptionPeriodId && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                onClick: ()=>validationModal.setIsDisplayed(true),
                                                size: "small",
                                                ml: 5,
                                                pull: "right",
                                                color: 'ghost',
                                                children: "Modifier"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    size: 6,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                            children: "Commentaire:"
                                        }),
                                        " ",
                                        appSubscriptionPeriodTotal.comment || 'N/A'
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dead6d073746346a$export$2e2bcd8739ae039), {
                            totals: appSubscriptionPeriodTotal,
                            onEmployerClick: (employer)=>{
                                setActiveEmployer(null);
                                setActiveEmployer(employer);
                            }
                        }),
                        activeEmployer && period && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    className: "is-flex is-justify-content-space-between is-align-items-center mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                            size: 5,
                                            children: [
                                                "D\xe9tails co\xfbts ",
                                                activeEmployer.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                            remove: true,
                                            onClick: ()=>setActiveEmployer(null),
                                            "aria-label": "close"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "Ref Client:"
                                                }),
                                                " ",
                                                interimAgency?.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "N\xb0 de P\xe9riode:"
                                                }),
                                                " ",
                                                period.identifier || "P\xe9riode en cours"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "Entreprise Utilisatrice:"
                                                }),
                                                " ",
                                                employer?.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 6,
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                                    children: "P\xe9riode:"
                                                }),
                                                " du ",
                                                (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.periodStart),
                                                " au",
                                                ' ',
                                                (0, $74f17ceb9b5a08a5$export$7d98027883de41f3)(period.periodEnd.toString())
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $89a58928770a2177$export$2e2bcd8739ae039), {
                                    period: period,
                                    activeEmployer: activeEmployer._id,
                                    onTerminalDetailsClick: ()=>terminalModal.setIsDisplayed(true)
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    className: "is-flex is-justify-content-flex-end",
                                    style: {
                                        marginTop: -30
                                    },
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                        onClick: ()=>setShowDailyDetails(!showDailyDetails),
                                        size: "small",
                                        color: "ghost",
                                        renderAs: "a",
                                        className: "mt-n4",
                                        "data-test": "app-subscription-period-daily-details-button",
                                        children: [
                                            "D\xe9tails journaliers -\xa0",
                                            showDailyDetails ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    "Masquer ",
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f1a507b991affc46), {
                                                        className: "ml-1",
                                                        width: 16,
                                                        height: 16
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    "Afficher ",
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$1c939d3c9b6931b), {
                                                        className: "ml-1",
                                                        width: 16,
                                                        height: 16
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                showDailyDetails && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    mt: 2,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $509e4b5396968a23$export$2e2bcd8739ae039), {
                                        period: period
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                                    actions: terminalModal,
                                    title: "D\xe9tails des bornes de pointage",
                                    maxWidth: 1000,
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $89725ac98ef36824$export$2e2bcd8739ae039), {
                                        weeklyTerminalFees: period.fees.weeklyTerminalFees,
                                        totalTerminalFees: period.fees.totalTerminalFees
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                actions: validationModal,
                title: "Validation de la p\xe9riode",
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $757a7e81bdda72b5$export$2e2bcd8739ae039), {
                    periodTotal: appSubscriptionPeriodTotal,
                    onSuccess: ()=>validationModal.setIsDisplayed(false)
                })
            })
        ]
    });
};
var $afd09a869d7c7d4c$export$2e2bcd8739ae039 = $afd09a869d7c7d4c$var$AppSubscriptionPeriod;



parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");
function $4a4ee52eb948b017$var$ClockIcon(props, svgRef) {
    return /*#__PURE__*/ $3ZYaX.createElement("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        strokeWidth: 2,
        stroke: "currentColor",
        "aria-hidden": "true",
        ref: svgRef
    }, props), /*#__PURE__*/ $3ZYaX.createElement("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    }));
}
const $4a4ee52eb948b017$var$ForwardRef = $3ZYaX.forwardRef($4a4ee52eb948b017$var$ClockIcon);
var $4a4ee52eb948b017$export$2e2bcd8739ae039 = $4a4ee52eb948b017$var$ForwardRef;







const $57c4ccd637758f10$var$EmployerSettingsWrapper = ({ mode: mode = 'currentOrganization' })=>{
    const { id: id } = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const currentEmployer = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const { data: employerData } = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(mode === 'currentOrganization' ? currentEmployer._id : id, 'employer');
    const pendingEmployerInvitationsCount = (0, $9e4f6dc667a577f4$export$c5bd0e29fdd0ade0)();
    const employer = employerData;
    const menu = {
        missionsAndWorkPeriods: {
            title: "Missions & Journ\xe9es de Travail",
            sections: (()=>{
                const sections = [];
                if ((0, $8403deec6a28521e$export$6025088343704f9f)([
                    'employerMember'
                ])) sections.push({
                    path: 'services',
                    label: 'Affectations',
                    icon: (0, $e0de785befddd5e2$export$bbc9410078004e71)
                }, {
                    path: 'work-period-tags',
                    label: "Cat\xe9gories",
                    icon: (0, $e0de785befddd5e2$export$1b490aa7069a487b)
                }, {
                    path: 'job-titles',
                    label: "M\xe9tiers",
                    icon: (0, $e0de785befddd5e2$export$a409e2da4a3967b)
                }, {
                    path: 'clocking-rules',
                    label: "R\xe8gles de Pointage",
                    icon: (0, $4a4ee52eb948b017$export$2e2bcd8739ae039)
                });
                sections.push({
                    path: 'work-period-events',
                    label: "\xc9v\xe8nements",
                    icon: (0, $e0de785befddd5e2$export$54eeba26dc8b99cf)
                });
                return sections;
            })()
        },
        finances: {
            title: 'Finances',
            sections: (()=>{
                const sections = [];
                if ((0, $8403deec6a28521e$export$6025088343704f9f)([
                    'employerMember'
                ])) sections.push({
                    path: 'labor-costs-coefficients',
                    label: "Coefficients Agences d'Int\xe9rim",
                    icon: ()=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                            children: "%"
                        })
                });
                sections.push({
                    path: 'employer-rules',
                    label: "R\xe8gles employeur",
                    icon: (0, $9ebd0210d45a1cac$export$2e2bcd8739ae039)
                });
                if ((0, $8403deec6a28521e$export$6025088343704f9f)([
                    'superAdmin'
                ])) sections.push({
                    path: 'worker-counters',
                    label: 'Compteurs',
                    icon: (0, $e0de785befddd5e2$export$27bab811bde8f944)
                });
                return sections;
            })()
        },
        collaboration: {
            title: 'Collaboration',
            sections: (()=>{
                const sections = [];
                if ((0, $8403deec6a28521e$export$6025088343704f9f)([
                    'employerMember'
                ])) sections.push({
                    path: 'partners-agencies',
                    label: 'Agences Partenaires',
                    icon: (0, $e0de785befddd5e2$export$ecf5f5308bcbb05e),
                    badgeCount: pendingEmployerInvitationsCount
                }, {
                    path: 'members',
                    label: 'Gestionnaires de mon entreprise',
                    icon: (0, $66fc2642466e214b$export$2e2bcd8739ae039)
                });
                return sections;
            })()
        },
        settings: {
            title: "Param\xe8tres",
            sections: [
                {
                    path: 'terminals',
                    label: 'Bornes de Pointage',
                    icon: (0, $e0de785befddd5e2$export$9ff5547afd06adf7)
                },
                {
                    path: 'info',
                    label: "Informations de l'Entreprise",
                    icon: (0, $e0de785befddd5e2$export$45a25e33c6871670)
                },
                ...(0, $8403deec6a28521e$export$6025088343704f9f)([
                    'superAdmin'
                ]) ? [
                    {
                        path: 'special-periods',
                        label: "P\xe9riodes Sp\xe9ciales",
                        icon: (0, $e0de785befddd5e2$export$5fda1783bb83f57b)
                    }
                ] : []
            ]
        }
    };
    if ((0, $8403deec6a28521e$export$6025088343704f9f)([
        'employerMember'
    ]) && (0, $194abd50ec8a5014$export$4d17dfdb53784ff6)([
        {
            organizationType: 'employer',
            option: 'biPart'
        }
    ])) {
        menu.missionsAndWorkPeriods.sections.push({
            path: 'workers',
            label: "Salari\xe9s",
            icon: (0, $e0de785befddd5e2$export$ffac63b363808810)
        });
        menu.finances.sections.splice(1, 0, {
            path: 'worker-counters',
            label: 'Compteurs',
            icon: (0, $e0de785befddd5e2$export$27bab811bde8f944)
        });
    }
    if (!employer) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {});
    if (location.pathname === '/settings') return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: "/settings/info",
        replace: true
    });
    if (mode === 'urlId' && location.pathname === `/employers/${id}`) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $39b0bf07af9c8a3f$export$444b3ab0cb9aec40), {
        to: `/employers/${id}/info`,
        replace: true
    });
    const basePath = mode === 'currentOrganization' ? '/settings' : `/employers/${id}`;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2611524601c1153f$export$2e2bcd8739ae039), {
        basePath: basePath,
        menu: menu,
        outletContext: {
            employer: employer
        },
        menuTitle: (0, $8403deec6a28521e$export$6025088343704f9f)([
            'superAdmin'
        ]) ? `${employer?.name} (EU)` : undefined
    });
};
var $57c4ccd637758f10$export$2e2bcd8739ae039 = $57c4ccd637758f10$var$EmployerSettingsWrapper;



parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");





const $efff859c5e02ed3e$var$ClockingRulesList = ({ data: data, itemPath: itemPath })=>{
    const tableColumns = $efff859c5e02ed3e$var$useListTableColumns(data, itemPath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: data,
        noDataMessage: "Aucune R\xe8gle de Pointage \xe0 afficher"
    });
};
var $efff859c5e02ed3e$export$2e2bcd8739ae039 = $efff859c5e02ed3e$var$ClockingRulesList;
const $efff859c5e02ed3e$var$useListTableColumns = (clockingRules, itemPath)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: ({ row: row })=>{
                    const { original: clockingRules } = row;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("b", {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                    to: `${itemPath}${clockingRules._id}`,
                                    children: clockingRules.name
                                })
                            }),
                            clockingRules?.description && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fb0f7382abab45fe$export$f458b3f21d0860), {
                                        ifIsLongerThan: 120,
                                        children: clockingRules.description
                                    })
                                ]
                            })
                        ]
                    });
                }
            },
            {
                Header: "En D\xe9but de Journ\xe9e",
                accessor: (row)=>row.rules.start,
                Cell: ({ row: row })=>{
                    const { original: clockingRules } = row;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                        clockingRules: clockingRules,
                        type: "start",
                        small: true
                    });
                }
            },
            {
                Header: "En Fin de Journ\xe9e",
                accessor: (row)=>row.rules.start,
                Cell: ({ row: row })=>{
                    const { original: clockingRules } = row;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e22e0a62f76978b8$export$2e2bcd8739ae039), {
                        clockingRules: clockingRules,
                        type: "end",
                        small: true
                    });
                }
            },
            {
                Header: 'Pause',
                accessor: (row)=>row.break,
                Cell: ({ row: row })=>{
                    const { original: clockingRules } = row;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $239d0c4f69d06a71$export$2e2bcd8739ae039), {
                        clockingRules: clockingRules,
                        small: true
                    });
                }
            }
        ], [
        clockingRules,
        itemPath
    ]);







const $15da81b9bb1f5579$var$ClockingRulesSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const { data: clockingRules } = (0, $e8692bc7fe3a6d6c$export$4e261945e999792f)({
        enabled: Boolean(employer),
        sort: 'title'
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "R\xe8gles de pointage",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $25a02e46d3857783$export$2e2bcd8739ae039), {
                    textColor: 'white'
                }),
                onButtonClick: ()=>{
                    navigate('/settings/clocking-rules/new');
                },
                addButtonLabel: "Nouvelle R\xe8gle de Pointage",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d)
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $efff859c5e02ed3e$export$2e2bcd8739ae039), {
                    data: clockingRules || [],
                    itemPath: `/settings/clocking-rules/`
                })
            })
        ]
    });
};
var $15da81b9bb1f5579$export$2e2bcd8739ae039 = $15da81b9bb1f5579$var$ClockingRulesSettings;



parcelRequire("3ZYaX");



var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");










const $4de84fd4014af675$var$EmployerForm = ({ organization: organization })=>{
    const createMutation = (0, $58f46cb3f921014b$export$a25726670bb41cb)();
    const updateMutation = (0, $58f46cb3f921014b$export$cac0b33e6f13c8ec)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            name: organization?.name || '',
            type: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer,
            rules: {
                missions: {
                    abandonmentPayments: organization?.rules?.missions.abandonmentPayments ? 'paid' : 'notPaid',
                    dayStartHour: organization ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(organization.rules.missions.dayStartHour) : '',
                    nightStartHour: organization ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(organization.rules.missions.nightStartHour) : ''
                }
            },
            addresses: organization?.addresses || [],
            appOptions: organization?.appOptions
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name) errors.name = 'Champ requis';
            if (values.addresses.length === 0) errors.addresses = "Au moins une adresse doit \xeatre renseign\xe9e";
            if (!values.rules?.missions.nightStartHour) errors['rules.missions.nightStartHour'] = 'Champ requis';
            if (!values.rules?.missions.dayStartHour) errors['rules.missions.dayStartHour'] = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            if (values.rules?.missions.dayStartHour) //@ts-expect-error: todo fix it
            values.rules.missions.dayStartHour = (0, $74f17ceb9b5a08a5$export$e7f31853fa46457)(values.rules.missions.dayStartHour);
            if (values.rules?.missions.nightStartHour) //@ts-expect-error: todo fix it
            values.rules.missions.nightStartHour = (0, $74f17ceb9b5a08a5$export$e7f31853fa46457)(values.rules.missions.nightStartHour);
            //@ts-expect-error: todo fix it
            values.rules.missions.abandonmentPayments = Boolean(values.rules.missions.abandonmentPayments === 'paid');
            if (!organization) createMutation.mutate(values);
            else updateMutation.mutate({
                id: organization._id.toString(),
                ...values
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 12,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "Nom de l'Employeur",
                                        name: "name",
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        required: true
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $09fb06a5ea2f8067$export$3e2fc1eaa5ec0e7e), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'superAdmin'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 12,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Les Abandons de Poste sont",
                                                name: "rules.missions.abandonmentPayments",
                                                component: (0, $94dd48ff55f5e1f0$export$2e2bcd8739ae039),
                                                options: [
                                                    {
                                                        value: 'paid',
                                                        label: "Pay\xe9s"
                                                    },
                                                    {
                                                        value: 'notPaid',
                                                        label: "Non Pay\xe9s"
                                                    }
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 3,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Heure d\xe9but jour",
                                                name: "rules.missions.dayStartHour",
                                                type: "time",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                help: "La modification ne sera appliqu\xe9e qu'aux nouvelles missions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                            size: 3,
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                label: "Heure d\xe9but nuit",
                                                name: "rules.missions.nightStartHour",
                                                type: "time",
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                            roles: [
                                                'superAdmin'
                                            ],
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                size: 12,
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                                        size: 4,
                                                        mt: 5,
                                                        children: "Fonctionnalit\xe9s disponibles"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                        label: "Bi-parti",
                                                        name: "appOptions.biPart",
                                                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039)
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                mb: 1,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                                    mutation: updateMutation
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                color: "primary",
                                type: "submit",
                                mutation: updateMutation,
                                children: organization ? "Mettre \xe0 jour les donn\xe9es de l'Employeur" : "Cr\xe9er un Nouvel Employeur"
                            })
                        ]
                    })
                ]
            });
        }
    });
};
var $4de84fd4014af675$export$2e2bcd8739ae039 = $4de84fd4014af675$var$EmployerForm;






var $3ZYaX = parcelRequire("3ZYaX");


const $dd21d85958cb32aa$var$EmployerMissionsRulesListDescription = ({ rules: rules, labelColumnWidth: labelColumnWidth = 300 })=>{
    const items = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: 'Paiement des abandons de poste',
                value: rules?.abandonmentPayments ? 'Oui' : 'Non'
            },
            {
                label: "Heure de d\xe9but de journ\xe9e",
                value: rules?.dayStartHour ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(rules.dayStartHour) : '-'
            },
            {
                label: "Heure de d\xe9but de nuit",
                value: rules?.nightStartHour ? (0, $74f17ceb9b5a08a5$export$ecfc70c568cd6116)(rules.nightStartHour) : '-'
            }
        ], [
        rules
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c288541aa0d2549e$export$2e2bcd8739ae039), {
        items: items,
        labelColumnWidth: labelColumnWidth
    });
};
var $dd21d85958cb32aa$export$2e2bcd8739ae039 = $dd21d85958cb32aa$var$EmployerMissionsRulesListDescription;



const $bf29aada97ac0cac$var$EmployerInfoSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Informations de l'entreprise"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4de84fd4014af675$export$2e2bcd8739ae039), {
                    organization: employer
                })
            }),
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'employerMember'
            ]) && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                        title: "R\xe8gles internes"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dd21d85958cb32aa$export$2e2bcd8739ae039), {
                                rules: employer?.rules.missions
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textSize: 7,
                                textColor: "grey",
                                children: "Pour toute modification des r\xe8gles internes, veuillez en faire la demande \xe0 support@teamtim.fr"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $bf29aada97ac0cac$export$2e2bcd8739ae039 = $bf29aada97ac0cac$var$EmployerInfoSettings;



parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");





const $9e96e17f8af8547a$var$EmployerRulesList = ({ employerRules: employerRules, employer: employer })=>{
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employer?._id}` : '/settings';
    const tableColumns = $9e96e17f8af8547a$var$useRulesTableColumns(basePath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(employerRules, 'name'),
        noDataMessage: "Aucune R\xe8gle employeur \xe0 afficher"
    });
};
const $9e96e17f8af8547a$var$useRulesTableColumns = (basePath)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'superAdmin'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                                    resource: data.row.original,
                                    path: `${basePath}/employer-rules/`,
                                    label: data.row.original.name
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: data.row.original.name
                            })
                        ]
                    })
            }
        ], [
        basePath
    ]);
};
var $9e96e17f8af8547a$export$2e2bcd8739ae039 = $9e96e17f8af8547a$var$EmployerRulesList;





parcelRequire("3ZYaX");

const $4b67dec842fad351$var$EmployerRulesExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les r\xe8gles employeur permettent de param\xe9trer des majorations ou des primes qui seront automatiquement appliqu\xe9es selon certaines conditions de travail :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Majorations"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Augmentation du taux horaire (en pourcentage ou montant fixe) selon des crit\xe8res comme :",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Travail de nuit"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Heures suppl\xe9mentaires"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Heures entre des plages horaires sp\xe9cifiques"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Primes"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Montant fixe attribu\xe9 lorsqu'un objectif est atteint, par exemple :",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Prime de panier"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Prime de transport"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Prime d'objectif"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Ces r\xe8gles sont appliqu\xe9es automatiquement lors du calcul des co\xfbts de mission et apparaissent sur les relev\xe9s d'heures."
                })
            })
        ]
    });
};
var $4b67dec842fad351$export$2e2bcd8739ae039 = $4b67dec842fad351$var$EmployerRulesExplanation;




/**
 * Component for managing employer financial rules
 */ const $d8ce95e92ae5a829$var$EmployerRulesSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const employerRulesQuery = (0, $52dfa770bdcaf9bf$export$86c10eec7ad727f4)({
        employer: employer._id
    });
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employer._id}` : '/settings';
    const isSuperAdmin = (0, $8403deec6a28521e$export$6025088343704f9f)([
        'superAdmin'
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "R\xe8gles employeur",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4b67dec842fad351$export$2e2bcd8739ae039), {
                    textColor: 'white'
                }),
                onButtonClick: isSuperAdmin ? ()=>navigate(`${basePath}/employer-rules/new`) : undefined,
                addButtonLabel: "Nouvelle r\xe8gle",
                buttonDataTestId: "new-employer-rule",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d)
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                mb: 1,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9e96e17f8af8547a$export$2e2bcd8739ae039), {
                    employerRules: employerRulesQuery.data || [],
                    employer: employer
                })
            }),
            !isSuperAdmin && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "p",
                textColor: "grey",
                children: "Pour toute modification ou ajout de r\xe8gles employeur, veuillez en faire la demande \xe0 support@teamtim.fr."
            })
        ]
    });
};
var $d8ce95e92ae5a829$export$2e2bcd8739ae039 = $d8ce95e92ae5a829$var$EmployerRulesSettings;



parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");








var $2KSUA = parcelRequire("2KSUA");
/**
 * Composant générique pour afficher les associations entre organisations
 * @param associations - Liste des associations à afficher
 * @param viewType - Perspective de vue (employer pour voir les agences, agency pour voir les employeurs)
 * @param onAcceptInvitation - Callback optionnel pour accepter une invitation
 */ const $e3d8f392dd1ec7af$var$OrganizationAssociationsList = ({ associations: associations, viewType: viewType, onAcceptInvitation: onAcceptInvitation })=>{
    const tableColumns = $e3d8f392dd1ec7af$var$useAssociationsListColumns({
        viewType: viewType,
        onAcceptInvitation: onAcceptInvitation
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $2KSUA.sortBy)(associations, 'interimAgency.name'),
        noDataMessage: `Aucun${viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'e agence' : ' employeur'} \xe0 afficher`
    });
};
const $e3d8f392dd1ec7af$var$useAssociationsListColumns = ({ viewType: viewType, onAcceptInvitation: onAcceptInvitation })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? "Agence d'int\xe9rim" : 'Employeur',
                accessor: viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'interimAgency.name' : 'employer.name',
                Cell: (data)=>{
                    const association = data.row.original;
                    const organization = viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? association.interimAgency : association.employer;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'interimAgencyMember' : 'employerMember'
                                ],
                                children: association.status === 'accepted' && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a), {
                                    to: `/${viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'agencies' : 'employers'}/${organization._id}`,
                                    children: organization.name
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    viewType === (0, $1005558fe5194d2d$export$f3d0370676bde028).employer ? 'employerMember' : 'interimAgencyMember'
                                ],
                                children: organization.name
                            })
                        ]
                    });
                }
            },
            {
                Header: "Statut de l'invitation",
                accessor: 'status',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                        role: data.row.original,
                        showDate: true
                    })
            },
            {
                Header: "Invit\xe9 par",
                accessor: 'invitedBy',
                Cell: (data)=>{
                    const user = data.row.original.invitedBy;
                    return user ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                        user: user
                    }) : null;
                }
            },
            {
                Header: 'Actions',
                accessor: '__actions',
                Cell: (data)=>{
                    const association = data.row.original;
                    if (association.status === 'pending' && onAcceptInvitation) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        size: "small",
                        color: "success",
                        onClick: ()=>onAcceptInvitation(association._id),
                        children: "Accepter"
                    });
                    return null;
                }
            }
        ], [
        viewType,
        onAcceptInvitation
    ]);
};
var $e3d8f392dd1ec7af$export$2e2bcd8739ae039 = $e3d8f392dd1ec7af$var$OrganizationAssociationsList;






/**
 * Component for managing partner agencies
 */ const $5db47c9cb3d3d718$var$PartnersAgenciesSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const updateAssociationMutation = (0, $58f46cb3f921014b$export$6fd574ee93f5aab)();
    const handleAcceptInvitation = (associationId)=>{
        updateAssociationMutation.mutate({
            employerId: employer._id,
            associationId: associationId,
            status: 'accepted'
        });
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Agences d'Interim Partenaires",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d320d508020ad161$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                mb: 1,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e3d8f392dd1ec7af$export$2e2bcd8739ae039), {
                    associations: employer.associations,
                    viewType: (0, $1005558fe5194d2d$export$f3d0370676bde028).employer,
                    onAcceptInvitation: handleAcceptInvitation
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                renderAs: "p",
                textColor: "grey",
                children: "Pour ajouter une agence partenaire, veuillez en faire la demande \xe0 support@teamtim.fr"
            })
        ]
    });
};
var $5db47c9cb3d3d718$export$2e2bcd8739ae039 = $5db47c9cb3d3d718$var$PartnersAgenciesSettings;




var $3ZYaX = parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");





/**
 * Displays a table of work period events with their code, title and type.
 * When employerRules is provided, an extra column shows which rules reference each event.
 */ const $5443af0b505b64ee$var$WorkPeriodEventsList = ({ workPeriodEvents: workPeriodEvents, employerRules: employerRules, onEventClick: onEventClick, mutation: mutation })=>{
    const eventRulesMap = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>employerRules ? (0, $2c246fb177fe9551$export$3d16ca0231757188)(employerRules) : undefined, [
        employerRules
    ]);
    const tableColumns = $5443af0b505b64ee$var$useWorkPeriodEventsColumns(workPeriodEvents, onEventClick, mutation, eventRulesMap);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: workPeriodEvents,
        noDataMessage: "Aucune donn\xe9e"
    });
};
const $5443af0b505b64ee$var$useWorkPeriodEventsColumns = (workPeriodEvents, onClick, mutation, eventRulesMap)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const columns = [
            {
                Header: 'Code',
                accessor: 'code'
            },
            {
                Header: "Intitul\xe9",
                accessor: 'title',
                Cell: (data)=>{
                    const workPeriodEvent = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "ghost",
                        onClick: ()=>onClick?.(workPeriodEvent),
                        "date-test": `edit-work-period-event-${(0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(workPeriodEvent)}`,
                        size: 'small',
                        disabled: !onClick,
                        //@ts-ignore
                        mutation: mutation?.data?.data?._id === workPeriodEvent._id ? mutation : undefined,
                        children: workPeriodEvent.title
                    });
                }
            },
            {
                Header: 'Type',
                accessor: 'type',
                Cell: (data)=>{
                    const workPeriodEvent = data.cell.row.original;
                    return (0, $f1533a9d55778507$export$2e2bcd8739ae039).types[workPeriodEvent.type];
                }
            },
            {
                Header: 'Indique absence',
                accessor: 'indicatesAbsence',
                Cell: (data)=>data.value ? 'Oui' : 'Non'
            }
        ];
        if (eventRulesMap) columns.push({
            Header: "R\xe8gles employeur",
            id: 'employerRules',
            Cell: (data)=>{
                const event = data.cell.row.original;
                const ruleNames = eventRulesMap.get((0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(event)) || [];
                if (ruleNames.length === 0) return '-';
                return ruleNames.join(', ');
            }
        });
        return columns;
    }, [
        workPeriodEvents,
        mutation,
        onClick,
        eventRulesMap
    ]);
};
var $5443af0b505b64ee$export$2e2bcd8739ae039 = $5443af0b505b64ee$var$WorkPeriodEventsList;






parcelRequire("3ZYaX");



const $bb6611ffa34f1ce8$var$WorkPeriodEventExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: [
                    "Les \xe9v\xe9nements peuvent \xeatre attach\xe9s aux journ\xe9es de travail pour indiquer des situations particuli\xe8res (absences, cong\xe9s, d\xe9placements...). ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "Il en existe deux types :"
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb7b9831917edb90$export$2e2bcd8739ae039), {
                    textColor: textColor
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f27050f1c1a92245$export$2e2bcd8739ae039), {
                    textColor: textColor
                })
            })
        ]
    });
};
var $bb6611ffa34f1ce8$export$2e2bcd8739ae039 = $bb6611ffa34f1ce8$var$WorkPeriodEventExplanation;




/**
 * Component for managing employer work period events
 * Receives employer from outlet context and passes it to the list
 * All users can create work period events, but only super admin can update them
 */ const $a1bd6ea7ba5875a1$var$WorkPeriodEventsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { data: events } = (0, $70137e1130a90c1c$export$141fa2cdeb74f02a)({
        enabled: Boolean(employer),
        employer: employer?._id
    });
    const { data: employerRules } = (0, $52dfa770bdcaf9bf$export$86c10eec7ad727f4)({
        employer: employer?._id
    });
    const [currentWorkPeriodEvent, setCurrentWorkPeriodEvent] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Ev\xe8nements",
                onButtonClick: (0, $8403deec6a28521e$export$6025088343704f9f)([
                    'employerMember'
                ]) ? ()=>setCurrentWorkPeriodEvent('new') : undefined,
                addButtonLabel: "Nouvel \xe9v\xe8nement",
                buttonDataTestId: "new-work-period-event",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d),
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb6611ffa34f1ce8$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5443af0b505b64ee$export$2e2bcd8739ae039), {
                    workPeriodEvents: events || [],
                    employerRules: employerRules,
                    onEventClick: (workPeriodEvent)=>setCurrentWorkPeriodEvent(workPeriodEvent)
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8a4190b80ffba83f$export$2e2bcd8739ae039), {
                isDisplayed: Boolean(currentWorkPeriodEvent),
                setIsDisplayed: ()=>setCurrentWorkPeriodEvent(undefined),
                workPeriodEvent: currentWorkPeriodEvent === 'new' ? undefined : currentWorkPeriodEvent
            })
        ]
    });
};
var $a1bd6ea7ba5875a1$export$2e2bcd8739ae039 = $a1bd6ea7ba5875a1$var$WorkPeriodEventsSettings;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");



/**
 * Component that displays a table of job titles
 */ const $2ef6ce604a18e947$var$JobTitlesList = ({ data: data, itemPath: itemPath })=>{
    const tableColumns = $2ef6ce604a18e947$var$useListTableColumns(itemPath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(data, 'name'),
        noDataMessage: "Aucun M\xe9tier \xe0 afficher"
    });
};
const $2ef6ce604a18e947$var$useListTableColumns = (itemPath)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                        resource: data.row.original,
                        path: itemPath || '/job-titles/',
                        label: data.row.original.name
                    })
            },
            {
                Header: "R\xe8gles de pointage",
                accessor: 'clockingRule',
                Cell: ({ value: value })=>value.name
            }
        ], []);
};
var $2ef6ce604a18e947$export$2e2bcd8739ae039 = $2ef6ce604a18e947$var$JobTitlesList;






/**
 * Component for managing employer job titles
 */ const $2318d4709c8d8838$var$JobTitlesSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [showInactive, setShowInactive] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const query = {};
    if (showInactive) query.isInactive = true;
    const { data: jobTitles } = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)(query, {
        enabled: Boolean(employer)
    });
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "M\xe9tiers",
                onButtonClick: ()=>navigate('/settings/job-titles/new'),
                addButtonLabel: "Nouveau M\xe9tier",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d),
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1bf7c8ffbb54dd51$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    showInactive && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "info",
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                    }),
                                    "Vous affichez uniquement les m\xe9tiers inactifs.",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    " Ces m\xe9tiers ne sont plus utilis\xe9s dans les missions et les demandes. Vous pouvez les r\xe9activer en les modifiant."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2ef6ce604a18e947$export$2e2bcd8739ae039), {
                        data: jobTitles || [],
                        itemPath: `/settings/job-titles/`
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textAlign: 'right',
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                                    checked: showInactive,
                                    onChange: (e)=>setShowInactive(e.target.checked),
                                    "data-test": "show-inactive-job-titles-checkbox",
                                    children: "Afficher les m\xe9tiers inactifs"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $2318d4709c8d8838$export$2e2bcd8739ae039 = $2318d4709c8d8838$var$JobTitlesSettings;




var $3ZYaX = parcelRequire("3ZYaX");





var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");




const $97662361ab0857b9$var$UsersFilters = ({ onChange: onChange, initialValues: initialValues })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: initialValues || {
            status: []
        },
        onSubmit: onChange,
        children: (props)=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($97662361ab0857b9$var$FieldColumn, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                label: "Statut",
                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                name: "status",
                                options: [
                                    {
                                        value: 'pending',
                                        label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                                            role: {
                                                status: 'pending'
                                            }
                                        })
                                    },
                                    {
                                        value: 'accepted',
                                        label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                                            role: {
                                                status: 'accepted'
                                            }
                                        })
                                    },
                                    {
                                        value: 'rejected',
                                        label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                                            role: {
                                                status: 'rejected'
                                            }
                                        })
                                    },
                                    {
                                        value: 'discontinued',
                                        label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                                            role: {
                                                status: 'discontinued'
                                            }
                                        })
                                    }
                                ],
                                disableDefaultFilter: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            });
        }
    });
};
var $97662361ab0857b9$export$2e2bcd8739ae039 = $97662361ab0857b9$var$UsersFilters;
const $97662361ab0857b9$var$FieldColumn = ({ children: children })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
        narrow: true,
        style: {
            minWidth: 220
        },
        children: children
    });







parcelRequire("3ZYaX");

const $f2aa55e71479330d$var$EmployerWorkerExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les salari\xe9s internes sont directement rattach\xe9s \xe0 l'entreprise et acc\xe8dent \xe0 leurs donn\xe9es via l'application mobile TeamTim pour :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Le Pointage"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Chaque salari\xe9 dispose d'un QR code unique dans son profil qui lui permet de pointer sur les bornes de l'entreprise au d\xe9but et \xe0 la fin de sa journ\xe9e de travail."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Horaires"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Le salari\xe9 peut consulter sur son mobile ses horaires de travail pr\xe9vus et suivre ses pointages r\xe9els, incluant :",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Les heures d'arriv\xe9e et de d\xe9part"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Les pauses"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Les \xe9ventuels retards ou d\xe9parts anticip\xe9s"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Relev\xe9s d'Heures"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Acc\xe8s via l'application \xe0 l'historique des pointages et aux relev\xe9s d'heures d\xe9taill\xe9s, incluant les heures travaill\xe9es et les \xe9ventuelles majorations selon les r\xe8gles de l'entreprise."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Les r\xe8gles de pointage et les majorations sont d\xe9finies par l'entreprise et s'appliquent automatiquement selon le m\xe9tier du salari\xe9."
                })
            })
        ]
    });
};
var $f2aa55e71479330d$export$2e2bcd8739ae039 = $f2aa55e71479330d$var$EmployerWorkerExplanation;





parcelRequire("3ZYaX");

/**
 * Button component for bulk actions on selected workers
 */ const $2dd0326fc77bfa3d$var$BulkActionsButton = ({ selectedCount: selectedCount, onModifyContractualSchedules: onModifyContractualSchedules })=>{
    const isDisabled = selectedCount === 0;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
        color: "primary",
        onClick: onModifyContractualSchedules,
        disabled: isDisabled,
        size: "small",
        children: [
            "Attribuer horaire contractuel (",
            selectedCount,
            ")"
        ]
    });
};
var $2dd0326fc77bfa3d$export$2e2bcd8739ae039 = $2dd0326fc77bfa3d$var$BulkActionsButton;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");








/**
 * Form component for applying contractual schedules to multiple workers
 */ const $134a8c407d645ab3$var$BulkContractualSchedulesForm = ({ users: users, organization: organization, onSuccess: onSuccess })=>{
    const updateMutation = (0, $e607e015ac40917d$export$504dd55109c39a47)();
    // Check applicability for each worker
    const getApplicabilityStatus = (user, schedule)=>{
        return (0, $44391656266f978a$export$f3568defbb2e461f)(user, schedule, organization);
    };
    const handleSubmit = async (values)=>{
        const { contractualSchedules: contractualSchedules } = values;
        if (!contractualSchedules || contractualSchedules.length === 0) return;
        const scheduleToApply = contractualSchedules[0] // Use first schedule entry
        ;
        if (!scheduleToApply) return;
        // Get applicable workers
        const applicableWorkers = users.filter((user)=>{
            const status = getApplicabilityStatus(user, scheduleToApply);
            return status.applicable;
        });
        // Apply schedule to each applicable worker
        // Replace existing entry for workers without schedule (applicable workers)
        const updatePromises = applicableWorkers.map(async (user)=>{
            const association = (0, $25ffbf4bca475b04$export$91d1acdd7472079)(user, organization);
            if (!association) return;
            // Transform the new schedule to API format
            const newScheduleEntry = (0, $44391656266f978a$export$76cf14d2b2649bf0)([
                scheduleToApply
            ])[0];
            if (!newScheduleEntry) return;
            // Replace the existing entry (if any) with the new one
            // Since applicable workers don't have schedule entries with schedule !== null,
            // we can simply replace all entries with the new one
            const allSchedules = [
                newScheduleEntry
            ];
            return updateMutation.mutateAsync({
                id: user._id,
                contractualSchedules: allSchedules
            });
        });
        await Promise.all(updatePromises);
        if (onSuccess) onSuccess();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            contractualSchedules: [
                (0, $44391656266f978a$export$11d7e77375792302)()
            ]
        },
        validate: (values)=>{
            const errors = {};
            if (values.contractualSchedules) {
                const scheduleErrors = (0, $dc0a4f8b2c36ae1e$export$362c0f8447e929c6)(values.contractualSchedules);
                Object.assign(errors, scheduleErrors);
            }
            return errors;
        },
        onSubmit: handleSubmit,
        children: ({ values: values, isSubmitting: isSubmitting })=>{
            const schedule = values.contractualSchedules?.[0];
            const applicabilityStatuses = users.map((user)=>({
                    user: user,
                    status: schedule ? getApplicabilityStatus(user, schedule) : {
                        applicable: false
                    }
                }));
            const applicableCount = applicabilityStatuses.filter((s)=>s.status.applicable).length;
            const nonApplicableCount = users.length - applicableCount;
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 4,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 6,
                                mb: 3,
                                children: [
                                    "Travailleurs s\xe9lectionn\xe9s (",
                                    users.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                style: {
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    border: '1px solid #e8e8e8',
                                    borderRadius: '4px',
                                    padding: '0.75rem'
                                },
                                children: applicabilityStatuses.map(({ user: user, status: status })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        display: "flex",
                                        alignItems: "center",
                                        mb: 2,
                                        style: {
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            status.applicable ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                color: "success",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                color: "danger",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$79e71d77d4eb0b38), {})
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "span",
                                                style: {
                                                    flex: 1
                                                },
                                                children: (0, $25ffbf4bca475b04$export$9a57c514c234d759)(user)
                                            }),
                                            !status.applicable && status.reason && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "span",
                                                textSize: 7,
                                                textColor: "grey",
                                                children: status.reason
                                            })
                                        ]
                                    }, user._id))
                            }),
                            nonApplicableCount > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                color: "warning",
                                mt: 3,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                    children: [
                                        nonApplicableCount,
                                        " travailleur",
                                        nonApplicableCount > 1 ? 's' : '',
                                        " ne",
                                        nonApplicableCount > 1 ? ' peuvent' : ' peut',
                                        " pas recevoir cet horaire.",
                                        applicableCount > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("span", {
                                            children: [
                                                ' ',
                                                "L'horaire sera appliqu\xe9 uniquement aux ",
                                                applicableCount,
                                                " travailleur",
                                                applicableCount > 1 ? 's' : '',
                                                " applicable",
                                                applicableCount > 1 ? 's' : '',
                                                "."
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 4,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4eec54641b63ade8$export$2e2bcd8739ae039), {
                            name: "contractualSchedules",
                            hasWorkerEverHadTimeSlots: false
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        display: "flex",
                        justifyContent: "flex-end",
                        style: {
                            gap: '0.5rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                onClick: ()=>{
                                // Close modal - handled by parent
                                },
                                type: "button",
                                children: "Annuler"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                color: "primary",
                                type: "submit",
                                mutation: updateMutation,
                                disabled: applicableCount === 0 || isSubmitting,
                                children: [
                                    "Appliquer (",
                                    applicableCount,
                                    ")"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: updateMutation
                    })
                ]
            });
        }
    });
};
var $134a8c407d645ab3$export$2e2bcd8739ae039 = $134a8c407d645ab3$var$BulkContractualSchedulesForm;


/**
 * Modal for applying contractual schedules to multiple workers
 */ const $6c1a089374e09508$var$BulkContractualSchedulesModal = ({ users: users, organization: organization, modalActions: modalActions, onSuccess: onSuccess })=>{
    const handleSuccess = ()=>{
        if (onSuccess) onSuccess();
        modalActions.setIsDisplayed(false);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        title: "Modifier les horaires contractuels",
        actions: modalActions,
        maxWidth: 1200,
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $134a8c407d645ab3$export$2e2bcd8739ae039), {
            users: users,
            organization: organization,
            onSuccess: handleSuccess
        })
    });
};
var $6c1a089374e09508$export$2e2bcd8739ae039 = $6c1a089374e09508$var$BulkContractualSchedulesModal;



/**
 * Component for managing employer workers
 */ const $db3c1357fa19f5ef$var$WorkersSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        // TODO: refactor using filters in store and in http requests
        status: [
            'accepted',
            'pending'
        ]
    });
    const [currentAppAccessTab, setCurrentAppAccessTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('full');
    const [selectedUserIds, setSelectedUserIds] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState([]);
    const bulkContractualSchedulesModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)({});
    // Réinitialiser la sélection quand on change d'onglet
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        setSelectedUserIds([]);
    }, [
        currentAppAccessTab
    ]);
    const query = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        appAccess: currentAppAccessTab
    });
    const tabs = [
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Connect\xe9"
                ]
            }),
            value: 'full'
        },
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Offline"
                ]
            }),
            value: 'none'
        }
    ];
    const users = (query.data || []).filter((user)=>{
        // TODO: refactor using filters in store and in http requests
        const roleOrAssociationStatus = (0, $25ffbf4bca475b04$export$472a3a1acf73db3a)(user, 'worker', employer);
        return !filters.status || !filters.status[0] || !roleOrAssociationStatus || filters.status.includes(roleOrAssociationStatus);
    });
    const selectedUsers = users.filter((user)=>selectedUserIds.includes(user._id));
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Salari\xe9s",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f2aa55e71479330d$export$2e2bcd8739ae039), {
                    textColor: "white"
                }),
                ActionButton: currentAppAccessTab === 'none' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $532af375c44b1e9c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $67b845dc01493173$export$2e2bcd8739ae039), {
                    userRoleKind: 'worker',
                    label: "Ajouter un travailleur",
                    modalTitle: "Inviter un nouveau travailleur"
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97662361ab0857b9$export$2e2bcd8739ae039), {
                        onChange: setFilters,
                        initialValues: {
                            status: [
                                'accepted',
                                'pending'
                            ]
                        }
                    }),
                    currentAppAccessTab === 'full' && selectedUserIds.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 3,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2dd0326fc77bfa3d$export$2e2bcd8739ae039), {
                            selectedCount: selectedUserIds.length,
                            onModifyContractualSchedules: ()=>bulkContractualSchedulesModal.setIsDisplayed(true)
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                        children: tabs.map((tab)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                active: currentAppAccessTab === tab.value,
                                onClick: ()=>setCurrentAppAccessTab(tab.value),
                                "data-test": `workers-list-tab-${tab.value}`,
                                children: tab.label
                            }, tab.value))
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5459a4afa6ab5673$export$2e2bcd8739ae039), {
                        users: users,
                        roleKind: currentAppAccessTab === 'none' ? 'offlineWorker' : 'worker',
                        enableSelection: currentAppAccessTab === 'full',
                        selectedUserIds: selectedUserIds,
                        onSelectionChange: setSelectedUserIds
                    }),
                    employer && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6c1a089374e09508$export$2e2bcd8739ae039), {
                        users: selectedUsers,
                        organization: employer,
                        modalActions: bulkContractualSchedulesModal,
                        onSuccess: ()=>{
                            setSelectedUserIds([]);
                        }
                    })
                ]
            })
        ]
    });
};
var $db3c1357fa19f5ef$export$2e2bcd8739ae039 = $db3c1357fa19f5ef$var$WorkersSettings;




var $3ZYaX = parcelRequire("3ZYaX");






parcelRequire("3ZYaX");

const $fae58f7d98f24680$var$EmployerMemberExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les gestionnaires de votre entreprise sont les utilisateurs qui ont acc\xe8s \xe0 votre espace entreprise sur la plateforme. Chaque membre poss\xe8de un r\xf4le qui d\xe9finit ses permissions :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Administrateur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Acc\xe8s complet \xe0 toutes les fonctionnalit\xe9s de la plateforme. Peut g\xe9rer les gestionnaires de l'entreprise, les missions, et modifier les param\xe8tres de l'entreprise."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Gestionnaire"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Peut g\xe9rer les missions et les \xe9quipes au quotidien. A acc\xe8s aux fonctionnalit\xe9s op\xe9rationnelles mais ne peut pas modifier les param\xe8tres de l'entreprise."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Profil Pointage"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Acc\xe8s limit\xe9 \xe0 la fonctionnalit\xe9 de pointage uniquement. Ne peut pas acc\xe9der aux autres fonctionnalit\xe9s de la plateforme."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "La modification des r\xf4les des gestionnaires ne peut \xeatre effectu\xe9e que par un administrateur de l'entreprise."
                })
            })
        ]
    });
};
var $fae58f7d98f24680$export$2e2bcd8739ae039 = $fae58f7d98f24680$var$EmployerMemberExplanation;





/**
 * Component for managing employer team members
 * Displays a list of members with their roles and permissions
 */ const $f9b2829b063503d1$var$MembersSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        // TODO: refactor using filters in store and in http requests
        status: [
            'accepted',
            'pending'
        ]
    });
    // Query to fetch employer members
    const query = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'employerMember'
    });
    const users = (query.data || []).filter((user)=>{
        // TODO: refactor using filters in store and in http requests
        const roleOrAssociationStatus = (0, $25ffbf4bca475b04$export$472a3a1acf73db3a)(user, 'employerMember', employer);
        return !filters.status || !filters.status[0] || !roleOrAssociationStatus || filters.status.includes(roleOrAssociationStatus);
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Gestionnaires de mon entreprise",
                ActionButton: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $67b845dc01493173$export$2e2bcd8739ae039), {
                    userRoleKind: 'employerMember'
                }),
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fae58f7d98f24680$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97662361ab0857b9$export$2e2bcd8739ae039), {
                        onChange: setFilters,
                        initialValues: {
                            status: [
                                'accepted',
                                'pending'
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5459a4afa6ab5673$export$2e2bcd8739ae039), {
                        users: users,
                        roleKind: "employerMember"
                    })
                ]
            })
        ]
    });
};
var $f9b2829b063503d1$export$2e2bcd8739ae039 = $f9b2829b063503d1$var$MembersSettings;



parcelRequire("3ZYaX");




const $2ee5b6e159be9c11$var$POPULATE = [
    'usagePeriods.employer',
    'usagePeriods.interimAgency'
];
var $2ee5b6e159be9c11$export$27053cbd45f02aa7 = /*#__PURE__*/ function(TerminalStatusEnum) {
    TerminalStatusEnum["shipping"] = "shipping";
    TerminalStatusEnum["active"] = "active";
    TerminalStatusEnum["inactive"] = "inactive";
    return TerminalStatusEnum;
}({});
const $2ee5b6e159be9c11$export$e7aa7bc5c1b3cfb3 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/terminals',
        method: 'get',
        params: {
            sort: '-createdAt',
            populate: $2ee5b6e159be9c11$var$POPULATE,
            ...params || {}
        }
    });
const $2ee5b6e159be9c11$export$3988ae62b71be9a3 = async (id)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/terminals/${id}`,
        method: 'get',
        params: {
            populate: $2ee5b6e159be9c11$var$POPULATE
        }
    });
const $2ee5b6e159be9c11$export$185802fd694ee1f5 = async (params)=>await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: '/terminals',
        method: 'post',
        params: params
    });
const $2ee5b6e159be9c11$export$722fbec263ad908a = async (params)=>{
    const { id: id, ...payload } = params;
    return await (0, $64d0fc040ea287e7$export$2e2bcd8739ae039)({
        endpoint: `/terminals/${id}`,
        method: 'put',
        params: payload
    });
};


const $d9947576038765e2$export$b9260e603a469536 = (id, options)=>(0, $9dc9b58c4343865b$export$9f6abfd74295843b)('terminals', (0, $2ee5b6e159be9c11$export$3988ae62b71be9a3), id, undefined, options);
const $d9947576038765e2$export$f13bda81a6b78543 = (filters, options)=>(0, $9dc9b58c4343865b$export$4e85cc9b40c906e6)('terminals', (0, $2ee5b6e159be9c11$export$e7aa7bc5c1b3cfb3), filters, options);
// Mutations
const $d9947576038765e2$var$onMutationSuccess = ()=>{
    (0, $9dc9b58c4343865b$export$7c07b633a151f9c5).invalidateQueries([
        'terminals'
    ]);
};
const $d9947576038765e2$export$4a6f974b4208311 = ()=>[
        'terminals',
        'create'
    ];
const $d9947576038765e2$export$a25726670bb41cb = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2ee5b6e159be9c11$export$185802fd694ee1f5), {
        mutationKey: $d9947576038765e2$export$4a6f974b4208311(),
        onSuccess: $d9947576038765e2$var$onMutationSuccess
    });
const $d9947576038765e2$export$a6fe4df8bec26327 = ()=>[
        'terminals',
        'update'
    ];
const $d9947576038765e2$export$cac0b33e6f13c8ec = ()=>(0, $1daf076503e453a3$export$609860bf8b0084c)((0, $2ee5b6e159be9c11$export$722fbec263ad908a), {
        mutationKey: $d9947576038765e2$export$a6fe4df8bec26327(),
        onSuccess: $d9947576038765e2$var$onMutationSuccess
    });




var $3ZYaX = parcelRequire("3ZYaX");




const $9256e93469b10458$export$1199fe7bcb544bf0 = (terminal)=>{
    if (!terminal.usagePeriods?.length) return null;
    const today = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date());
    // Find the period that includes today's date
    return terminal.usagePeriods.find((period)=>{
        const startDate = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(period.startDate));
        if (!period.endDate) return startDate <= today;
        return (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(today, {
            start: startDate,
            end: (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(period.endDate))
        });
    }) || null;
};
const $9256e93469b10458$export$b91a5fa241a7e63d = (terminal)=>{
    if (!terminal.usagePeriods?.length) return [];
    const today = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date());
    // Find all periods that include today's date
    return terminal.usagePeriods.filter((period)=>{
        const startDate = (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(period.startDate));
        if (!period.endDate) return startDate <= today;
        return (0, $d7a1bf3b1f196c36$export$2e2bcd8739ae039)(today, {
            start: startDate,
            end: (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)(new Date(period.endDate))
        });
    });
};
const $9256e93469b10458$export$29573cd2a7ae639 = (terminal, organizationType)=>{
    const currentPeriod = $9256e93469b10458$export$1199fe7bcb544bf0(terminal);
    return currentPeriod?.[organizationType];
};
const $9256e93469b10458$export$60c188b0dece3449 = (terminal)=>{
    return $9256e93469b10458$export$29573cd2a7ae639(terminal, 'employer');
};
const $9256e93469b10458$export$eddf5ee4d479d1c9 = (terminal)=>{
    return $9256e93469b10458$export$29573cd2a7ae639(terminal, 'interimAgency');
};




/**
 * Component qui affiche un tableau des bornes de pointage
 */ const $3efac8b4daed7a99$var$TerminalsList = ({ data: data, onTerminalClick: onTerminalClick })=>{
    const tableColumns = $3efac8b4daed7a99$var$useListTableColumns(data, onTerminalClick);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: data,
        noDataMessage: "Aucune borne de pointage \xe0 afficher"
    });
};
const $3efac8b4daed7a99$var$useListTableColumns = (terminals, onTerminalClick)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: "Mod\xe8le",
                accessor: 'device.name',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    if (!onTerminalClick) return terminal.device.name;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        onClick: ()=>onTerminalClick(terminal),
                        color: "ghost",
                        className: "has-text-left p-0",
                        children: terminal.device.name
                    });
                }
            },
            {
                Header: "N\xb0 de s\xe9rie",
                accessor: 'device.serialNumber'
            },
            {
                Header: 'Agence / Client',
                accessor: 'interimAgency',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    const currentPeriods = (0, $9256e93469b10458$export$b91a5fa241a7e63d)(terminal);
                    return currentPeriods.length > 0 ? currentPeriods.map((period)=>period.interimAgency?.name || "Non assign\xe9").map((name, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                name,
                                index < currentPeriods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index)) : "Non assign\xe9";
                }
            },
            {
                Header: 'Employeur',
                accessor: 'employer',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    const currentPeriods = (0, $9256e93469b10458$export$b91a5fa241a7e63d)(terminal);
                    return currentPeriods.length > 0 ? currentPeriods.map((period)=>period.employer?.name || "Non assign\xe9").map((name, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                name,
                                index < currentPeriods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index)) : "Non assign\xe9";
                }
            },
            (0, $8403deec6a28521e$export$6025088343704f9f)([
                'interimAgencyMember',
                'superAdmin'
            ]) && {
                Header: 'Cout actuel',
                accessor: 'rentalCost',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    const currentPeriods = (0, $9256e93469b10458$export$b91a5fa241a7e63d)(terminal);
                    return currentPeriods.length > 0 ? currentPeriods.map((period)=>`${(0, $0798496ba66df318$export$e370a7ddaa2f579a)(period.rentalCost)} / semaine`).map((cost, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                cost,
                                index < currentPeriods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index)) : "Non assign\xe9";
                }
            },
            {
                Header: "D\xe9but location",
                accessor: 'startDate',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    const currentPeriods = (0, $9256e93469b10458$export$b91a5fa241a7e63d)(terminal);
                    return currentPeriods.length > 0 ? currentPeriods.map((period)=>(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.startDate)).map((date, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                date,
                                index < currentPeriods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index)) : "Non assign\xe9";
                }
            },
            {
                Header: 'Fin location',
                accessor: 'endDate',
                Cell: (data)=>{
                    const terminal = data.cell.row.original;
                    const currentPeriods = (0, $9256e93469b10458$export$b91a5fa241a7e63d)(terminal);
                    return currentPeriods.length > 0 ? currentPeriods.map((period)=>period.endDate ? (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.endDate) : 'N/A').map((date, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                date,
                                index < currentPeriods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index)) : "Non assign\xe9";
                }
            }
        ].filter(Boolean), [
        terminals,
        onTerminalClick
    ]);
};
var $3efac8b4daed7a99$export$2e2bcd8739ae039 = $3efac8b4daed7a99$var$TerminalsList;






parcelRequire("3ZYaX");

const $02ca199e87e86cf5$var$TerminalExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les bornes de pointage sont des dispositifs physiques install\xe9s sur vos sites qui permettent aux int\xe9rimaires d'enregistrer leurs heures de travail. Chaque borne dispose de plusieurs fonctionnalit\xe9s :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Pointage QR Code"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Les int\xe9rimaires peuvent pointer leur arriv\xe9e et leur d\xe9part en scannant leur QR code personnel. Le syst\xe8me v\xe9rifie automatiquement que l'int\xe9rimaire est bien affect\xe9 \xe0 une mission sur le site."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "L'installation et la maintenance des bornes sont assur\xe9es par l'\xe9quipe technique TeamTim. Pour toute demande, contactez votre administrateur."
                })
            })
        ]
    });
};
var $02ca199e87e86cf5$export$2e2bcd8739ae039 = $02ca199e87e86cf5$var$TerminalExplanation;


const $9e82a3db7aacefe3$var$TerminalsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { data: terminals } = (0, $d9947576038765e2$export$f13bda81a6b78543)({
        'usagePeriods.employer': employer._id
    }, {
        enabled: Boolean(employer)
    });
    //TODO: handle that in the backend and remove this filter
    const terminalsForEmployer = terminals?.map((terminal)=>{
        terminal.usagePeriods = terminal.usagePeriods.filter((usagePeriod)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(usagePeriod.employer, employer));
        return terminal;
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Bornes de Pointage",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $02ca199e87e86cf5$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3efac8b4daed7a99$export$2e2bcd8739ae039), {
                    data: terminalsForEmployer || []
                })
            })
        ]
    });
};
var $9e82a3db7aacefe3$export$2e2bcd8739ae039 = $9e82a3db7aacefe3$var$TerminalsSettings;




var $3ZYaX = parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");



const $fff8b746a09f5fa4$var$LaborCostsCoefficientsTable = ({ jobTitles: jobTitles, interimAgency: interimAgency, onEdit: onEdit })=>{
    const tableColumns = $fff8b746a09f5fa4$var$useTableColumns(interimAgency, onEdit);
    const tableData = jobTitles.map((jobTitle)=>{
        const coefficient = jobTitle.interimAgencySettings.find((c)=>c.interimAgency === interimAgency._id);
        return {
            jobTitle: jobTitle,
            _id: jobTitle._id,
            managementValue: coefficient?.coefficients.managementValue ?? '-',
            delegationValue: coefficient?.coefficients.delegationValue ?? '-',
            hourlyRateSettings: coefficient?.hourlyRateSettings
        };
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: tableData,
        noDataMessage: "Aucun m\xe9tier \xe0 afficher"
    });
};
const $fff8b746a09f5fa4$var$useTableColumns = (interimAgency, onEdit)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: `M\xe9tier / ${interimAgency.name}`,
                accessor: 'jobTitle',
                Cell: ({ value: jobTitle })=>jobTitle.name
            },
            {
                Header: "D\xe9l\xe9gation",
                accessor: 'delegationValue',
                className: 'has-text-centered'
            },
            {
                Header: 'Gestion',
                accessor: 'managementValue',
                className: 'has-text-centered'
            },
            {
                Header: 'Cout horaire',
                accessor: 'hourlyRateSettings',
                className: 'has-text-centered',
                Cell: ({ value: hourlyRateSettings })=>{
                    if (!hourlyRateSettings) return 'N/A';
                    if (hourlyRateSettings.useSmic) return 'SMIC';
                    return `${hourlyRateSettings.min} \u{20AC} - ${hourlyRateSettings.max} \u{20AC}`;
                }
            },
            onEdit && {
                Header: '',
                id: 'actions',
                accessor: 'jobTitle',
                Cell: ({ value: jobTitle, row: row })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                        onClick: ()=>onEdit?.(jobTitle._id, interimAgency._id, row.original),
                        color: "primary",
                        outlined: true,
                        size: "small",
                        "data-test": `edit-job-title-${jobTitle._id}`,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$2ad141e9e3d81b82), {
                                className: "h-5 w-5"
                            })
                        })
                    }),
                className: 'has-text-right'
            }
        ].filter(Boolean), [
        interimAgency,
        onEdit
    ]);
};
var $fff8b746a09f5fa4$export$2e2bcd8739ae039 = $fff8b746a09f5fa4$var$LaborCostsCoefficientsTable;




parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");







const $7426ef3939e05545$var$LaborCostsCoefficientsFilters = ()=>{
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).laborCostsCoefficients);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            interimAgency: filters.interimAgency || undefined,
            jobTitle: filters.jobTitle || undefined
        },
        onSubmit: (values)=>{
            setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).laborCostsCoefficients, values);
        },
        children: (props)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        mb: "0",
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0afbbe4db390668$export$2e2bcd8739ae039), {
                                type: (0, $1005558fe5194d2d$export$f3d0370676bde028).interimAgency,
                                singleSelect: true,
                                doNotShowCurrentOrganization: true,
                                label: "Agences d'Int\xe9rim"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a91952dde0b07a58$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d6e87a2602347968$export$2e2bcd8739ae039), {
                        values: props.values,
                        submitForm: props.submitForm
                    })
                ]
            })
    });
};
var $7426ef3939e05545$export$2e2bcd8739ae039 = $7426ef3939e05545$var$LaborCostsCoefficientsFilters;









var $31tXu = parcelRequire("31tXu");
parcelRequire("3ZYaX");








const $49cd96ff6b820e0b$var$JobTitleLaborCoefficientForm = ({ jobTitle: jobTitle, interimAgency: interimAgency })=>{
    const updateMutation = (0, $b5014031ea60dfe7$export$cac0b33e6f13c8ec)();
    const smicQuery = (0, $b5b5022de31b86b5$export$9c9998b370b83a7d)(new Date(new Date().setHours(12, 0, 0, 0)));
    const interimAgencySettings = (0, $7bee40b68b806398$export$c3d8453eccce451d)(jobTitle, interimAgency);
    const currentSmicValue = smicQuery.data?.value;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            delegationValue: interimAgencySettings?.coefficients.delegationValue,
            managementValue: interimAgencySettings?.coefficients.managementValue,
            hourlyRateSettings: interimAgencySettings?.hourlyRateSettings || {
                min: null,
                max: null,
                useSmic: true
            }
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.delegationValue) errors.delegationValue = 'Champ requis';
            if (!values.managementValue) errors.managementValue = 'Champ requis';
            // Validation des taux horaires
            if (!values.hourlyRateSettings.useSmic) {
                if (!values.hourlyRateSettings.min) errors['hourlyRateSettings.min'] = 'Champ requis';
                else if (values.hourlyRateSettings.min < (currentSmicValue || 0)) errors['hourlyRateSettings.min'] = `Le minimum doit \xeatre sup\xe9rieur \xe0 ${currentSmicValue} \u{20AC}`;
                if (!values.hourlyRateSettings.max) errors['hourlyRateSettings.max'] = 'Champ requis';
                if (values.hourlyRateSettings.min && values.hourlyRateSettings.max && values.hourlyRateSettings.min > values.hourlyRateSettings.max) errors['hourlyRateSettings.min'] = "Le minimum doit \xeatre inf\xe9rieur au maximum";
            }
            return errors;
        },
        onSubmit: (values)=>{
            const isNewInterimAgencySettings = jobTitle.interimAgencySettings.find((l)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(l.interimAgency, interimAgency));
            const updatedInterimAgencySettings = jobTitle.interimAgencySettings.map((l)=>{
                if ((0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(l.interimAgency, interimAgency)) return {
                    ...l,
                    coefficients: {
                        delegationValue: values.delegationValue,
                        managementValue: values.managementValue
                    },
                    hourlyRateSettings: values.hourlyRateSettings
                };
                return l;
            });
            if (!isNewInterimAgencySettings) updatedInterimAgencySettings.push({
                interimAgency: (0, $ff82e5b471ec35cc$export$f7ab4a0ab72c2665)(interimAgency),
                coefficients: {
                    delegationValue: values.delegationValue,
                    managementValue: values.managementValue
                },
                hourlyRateSettings: values.hourlyRateSettings
            });
            updateMutation.mutate({
                id: jobTitle._id,
                interimAgencySettings: updatedInterimAgencySettings
            });
        },
        children: ({ values: values })=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 4,
                        mb: 5,
                        children: [
                            jobTitle.name,
                            " / ",
                            interimAgency.name
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mb: 2,
                        children: "Coefficients de main d'oeuvre"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: "D\xe9l\xe9gation",
                                        name: `delegationValue`,
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "number",
                                        required: true,
                                        step: "0.1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                        label: 'Gestion',
                                        name: `managementValue`,
                                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                        type: "number",
                                        required: true,
                                        step: "0.1"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 4,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 5,
                                mb: 2,
                                children: "Taux horaire"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                            text: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: "Utiliser le SMIC"
                                            }),
                                            name: `hourlyRateSettings.useSmic`,
                                            component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                                            type: "checkbox",
                                            options: [
                                                {
                                                    label: 'Oui',
                                                    value: true
                                                },
                                                {
                                                    label: 'Non',
                                                    value: false
                                                }
                                            ]
                                        })
                                    }),
                                    values.hourlyRateSettings.useSmic && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                        color: "info",
                                        mt: 2,
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "p",
                                                children: [
                                                    "Le cout horaire de base des journ\xe9es de travail sera le SMIC du jour.",
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                                    "SMIC actuel : ",
                                                    currentSmicValue,
                                                    " \u20AC"
                                                ]
                                            })
                                        })
                                    }),
                                    !values.hourlyRateSettings.useSmic && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                        mt: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                                                color: "info",
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Message).Body, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                                            renderAs: "p",
                                                            children: [
                                                                "Le minimum doit \xeatre sup\xe9rieur au SMIC actuel (",
                                                                currentSmicValue,
                                                                " \u20AC)."
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                            renderAs: "p",
                                                            children: "Le smic \xe9volue dans le temps, il est donc possible que le minimum devienne inf\xe9rieur au SMIC. Dans ce cas, le co\xfbt horaire sera calcul\xe9 avec le SMIC du jour."
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Minimum \u20AC",
                                                            name: `hourlyRateSettings.min`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            type: "number",
                                                            required: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                            label: "Maximum \u20AC",
                                                            name: `hourlyRateSettings.max`,
                                                            component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                            type: "number",
                                                            required: true
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mt: 5,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                            color: "primary",
                            type: "submit",
                            mutation: updateMutation,
                            children: "Mettre \xe0 jour"
                        })
                    })
                ]
            });
        }
    });
};
var $49cd96ff6b820e0b$export$2e2bcd8739ae039 = $49cd96ff6b820e0b$var$JobTitleLaborCoefficientForm;



parcelRequire("3ZYaX");

const $0b7d0e237e715dab$var$JobTitleInterimAgencySettingsInformations = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: [
                    "Les Coefficients Agences d'Int\xe9rim sont des multiplicateurs appliqu\xe9s au taux horaire de base (SMIC) pour d\xe9terminer le co\xfbt final d'une journ\xe9e de travail.",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    " Ces coefficients sont d\xe9finis pour chaque m\xe9tier et par association entre une agence d'int\xe9rim et un employeur."
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mt: 4,
                mb: 3,
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                    size: 6,
                    textColor: textColor,
                    mb: 2,
                    children: "Coefficients Agences d'Int\xe9rim"
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Coefficient D\xe9l\xe9gation"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Appliqu\xe9 lorsque l'agence d'int\xe9rim s'occupe du recrutement complet : recherche de candidats, s\xe9lection et gestion administrative.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " Ce coefficient est g\xe9n\xe9ralement plus \xe9lev\xe9 car il inclut la prestation de sourcing."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Coefficient Gestion"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Appliqu\xe9 lorsque l'entreprise propose directement le candidat \xe0 l'agence d'int\xe9rim, qui ne s'occupe alors que de la gestion administrative.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " Ce coefficient est plus faible car il n'inclut pas la partie recrutement."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                mt: 5,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 6,
                        textColor: textColor,
                        mb: 2,
                        children: "Gestion du co\xfbt horaire"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Pour chaque m\xe9tier, vous pouvez d\xe9finir le co\xfbt horaire de deux mani\xe8res :"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Utilisation du SMIC"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "En cochant cette option, le SMIC en vigueur sera utilis\xe9 comme base de calcul pour le co\xfbt horaire.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " Les coefficients de d\xe9l\xe9gation et gestion seront alors appliqu\xe9s sur cette base."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Plage de co\xfbt horaire personnalis\xe9e"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Si vous ne souhaitez pas utiliser le SMIC, vous pouvez d\xe9finir une plage de co\xfbt horaire personnalis\xe9e avec un minimum et un maximum.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            " Cette plage permet de :"
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        className: "content",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "ul",
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: "Garantir un co\xfbt minimum pour le m\xe9tier"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: "Limiter le co\xfbt maximum pour \xe9viter les d\xe9passements"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                    renderAs: "li",
                                    children: "Offrir une flexibilit\xe9 dans la n\xe9gociation des taux"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "i",
                            textSize: 7,
                            children: [
                                "C'est l'agence d'int\xe9rim qui d\xe9finira le co\xfbt horaire exact (dans la plage de co\xfbt horaire personnalis\xe9e) lors de l'attribution d'un int\xe9rimaire au m\xe9tier.",
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                "Le co\xfbt horaire final est calcul\xe9 en appliquant les coefficients de d\xe9l\xe9gation ou gestion sur le taux horaire de base (SMIC ou plage personnalis\xe9e)."
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $0b7d0e237e715dab$export$2e2bcd8739ae039 = $0b7d0e237e715dab$var$JobTitleInterimAgencySettingsInformations;


/**
 * Composant pour gérer les coefficients de coûts de travail temporaire
 */ const $97f0cbc7882544d0$var$LaborCostsCoefficients = ()=>{
    //const { employer: _employer } = useOutletContext<OutletContext>()
    const { filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).laborCostsCoefficients);
    const { data: interimAgencies } = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'interimAgency'
    });
    const { data: allJobTitles } = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)({
        populate: [
            'laborCostCoefficients.intermAgency'
        ],
        sort: 'name'
    });
    const [currentJobTitle, setCurrentJobTitle] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    const interimAgency = interimAgencies?.find((agency)=>agency._id === filters.interimAgency);
    const jobTitles = !filters.jobTitle?.[0] ? allJobTitles : allJobTitles?.filter((jobTitle)=>filters.jobTitle?.includes(jobTitle._id));
    const hasMissingCoefficients = interimAgency && jobTitles?.some((jobTitle)=>{
        const jobTitleCoefficients = (0, $7bee40b68b806398$export$c3d8453eccce451d)(jobTitle, interimAgency);
        return !jobTitleCoefficients?.coefficients.managementValue || !jobTitleCoefficients?.coefficients.delegationValue;
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Coefficients Agences d'Int\xe9rim",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0b7d0e237e715dab$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7426ef3939e05545$export$2e2bcd8739ae039), {}),
                    hasMissingCoefficients && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "warning",
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                    }),
                                    "Attention : certains postes n'ont pas de coefficients d\xe9finis"
                                ]
                            })
                        })
                    }),
                    interimAgency ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fff8b746a09f5fa4$export$2e2bcd8739ae039), {
                        interimAgency: interimAgency,
                        jobTitles: jobTitles || [],
                        onEdit: (jobTitleId)=>{
                            setCurrentJobTitle(jobTitles?.find((jobTitle)=>jobTitle._id === jobTitleId) || null);
                        }
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "info",
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                    }),
                                    "Veuillez s\xe9lectionner une Agence d'Int\xe9rim pour visualiser les coefficients"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                        actions: {
                            isDisplayed: Boolean(interimAgency && currentJobTitle),
                            setIsDisplayed: ()=>setCurrentJobTitle(null)
                        },
                        title: "Modifier les coefficients",
                        children: interimAgency && currentJobTitle && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $49cd96ff6b820e0b$export$2e2bcd8739ae039), {
                            interimAgency: interimAgency,
                            jobTitle: currentJobTitle
                        })
                    })
                ]
            })
        ]
    });
};
var $97f0cbc7882544d0$export$2e2bcd8739ae039 = $97f0cbc7882544d0$var$LaborCostsCoefficients;


// src/pages/interim-agency-settings/partner-employer-details.tsx

parcelRequire("3ZYaX");







/**
 * Component for displaying details of a partner employer for an interim agency
 */ const $de925e806d0bdd64$var$PartnerEmployerDetails = ()=>{
    const { id: id } = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)();
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    // Fetch employer details
    const { data: employer } = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(id, 'employer');
    const jobTitlesQuery = (0, $b5014031ea60dfe7$export$76743b414a2ccf63)({
        employer: id
    });
    const jobTitles = (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(jobTitlesQuery.data || [], 'name');
    if (!employer) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: `Partenariat avec ${employer.name}`
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                        title: "M\xe9tiers & Coefficients main d'oeuvre"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fff8b746a09f5fa4$export$2e2bcd8739ae039), {
                        jobTitles: jobTitles,
                        interimAgency: interimAgency
                    })
                ]
            })
        ]
    });
};
var $de925e806d0bdd64$export$2e2bcd8739ae039 = $de925e806d0bdd64$var$PartnerEmployerDetails;




var $3ZYaX = parcelRequire("3ZYaX");











parcelRequire("3ZYaX");

const $a0f5f6fc7d3c9fa0$var$WorkerExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les int\xe9rimaires sont inscrits par leur agence d'int\xe9rim et acc\xe8dent \xe0 leurs donn\xe9es via l'application mobile TeamTim pour :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Le Pointage"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Chaque int\xe9rimaire dispose d'un QR code unique dans son profil mobile qui lui permet de pointer sur les bornes de l'entreprise au d\xe9but et \xe0 la fin de sa journ\xe9e de travail."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Missions"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "L'int\xe9rimaire peut consulter sur son mobile ses missions en cours et \xe0 venir, avec les informations essentielles comme :",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Les horaires de travail"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "Le lieu de la mission"
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("li", {
                                        children: "L'intitul\xe9 du poste"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Les Relev\xe9s d'Heures"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Acc\xe8s via l'application \xe0 l'historique des pointages et aux relev\xe9s d'heures d\xe9taill\xe9s, incluant les heures travaill\xe9es et les \xe9ventuelles majorations."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "La communication avec l'agence d'int\xe9rim se fait en dehors de l'application. Pour toute question sur vos missions, contactez directement votre agence."
                })
            })
        ]
    });
};
var $a0f5f6fc7d3c9fa0$export$2e2bcd8739ae039 = $a0f5f6fc7d3c9fa0$var$WorkerExplanation;


/**
 * Component for managing employer workers
 */ const $6fe40cbdf6880d16$var$WorkersSettings = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        // TODO: refactor using filters in store and in http requests
        status: [
            'accepted',
            'pending'
        ]
    });
    const [currentAppAccessTab, setCurrentAppAccessTab] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState('full');
    const query = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'worker',
        appAccess: currentAppAccessTab
    });
    const tabs = [
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Connect\xe9"
                ]
            }),
            value: 'full'
        },
        {
            label: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aa91c600f51fee77$export$2e2bcd8739ae039), {}),
                    " Offline"
                ]
            }),
            value: 'none'
        }
    ];
    const users = (query.data || []).filter((user)=>{
        // TODO: refactor using filters in store and in http requests
        const roleOrAssociationStatus = (0, $25ffbf4bca475b04$export$472a3a1acf73db3a)(user, 'worker', interimAgency);
        return !filters.status || !filters.status[0] || !roleOrAssociationStatus || filters.status.includes(roleOrAssociationStatus);
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Int\xe9rimaires",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a0f5f6fc7d3c9fa0$export$2e2bcd8739ae039), {
                    textColor: "white"
                }),
                ActionButton: currentAppAccessTab === 'none' ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $532af375c44b1e9c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $67b845dc01493173$export$2e2bcd8739ae039), {
                    userRoleKind: 'worker',
                    label: "Ajouter un int\xe9rimaire",
                    modalTitle: "Inviter un nouvel int\xe9rimaire"
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97662361ab0857b9$export$2e2bcd8739ae039), {
                        onChange: setFilters,
                        initialValues: {
                            status: [
                                'accepted',
                                'pending'
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs), {
                        children: tabs.map((tab)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Tabs).Tab, {
                                active: currentAppAccessTab === tab.value,
                                onClick: ()=>setCurrentAppAccessTab(tab.value),
                                "data-test": `workers-list-tab-${tab.value}`,
                                children: tab.label
                            }, tab.value))
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5459a4afa6ab5673$export$2e2bcd8739ae039), {
                        users: users,
                        roleKind: currentAppAccessTab === 'none' ? 'offlineWorker' : 'worker'
                    })
                ]
            })
        ]
    });
};
var $6fe40cbdf6880d16$export$2e2bcd8739ae039 = $6fe40cbdf6880d16$var$WorkersSettings;




var $3ZYaX = parcelRequire("3ZYaX");









parcelRequire("3ZYaX");

const $f73acf0c9704dfc7$var$InterimAgencyMemberExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: "Les gestionnaires de votre agence sont les utilisateurs qui ont acc\xe8s \xe0 votre espace agence sur la plateforme. Ils peuvent :"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "G\xe9rer les Int\xe9rimaires"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Inviter et g\xe9rer les int\xe9rimaires de l'agence, suivre leurs missions et leurs pointages, et acc\xe9der \xe0 leurs relev\xe9s d'heures d\xe9taill\xe9s."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "G\xe9rer les Missions"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Cr\xe9er et suivre les missions d'int\xe9rim, affecter les int\xe9rimaires aux missions, et g\xe9rer les demandes des entreprises partenaires."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "G\xe9rer les Partenariats"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "\xc9tablir et g\xe9rer les relations avec les entreprises clientes, d\xe9finir les coefficients de facturation par poste, et suivre les conditions de collaboration."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Tous les gestionnaires de l'agence ont les m\xeames droits d'acc\xe8s aux fonctionnalit\xe9s de la plateforme."
                })
            })
        ]
    });
};
var $f73acf0c9704dfc7$export$2e2bcd8739ae039 = $f73acf0c9704dfc7$var$InterimAgencyMemberExplanation;


/**
 * Component for managing employer team members
 * Displays a list of members with their roles and permissions
 */ const $b27717c726d3e72d$var$MembersSettings = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [filters, setFilters] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState({
        // TODO: refactor using filters in store and in http requests
        status: [
            'accepted',
            'pending'
        ]
    });
    // Query to fetch employer members
    const query = (0, $e607e015ac40917d$export$7427a5686c370135)({
        'roles.kind': 'interimAgencyMember'
    });
    const users = (query.data || []).filter((user)=>{
        // TODO: refactor using filters in store and in http requests
        const roleOrAssociationStatus = (0, $25ffbf4bca475b04$export$472a3a1acf73db3a)(user, 'interimAgencyMember', interimAgency);
        return !filters.status || !filters.status[0] || !roleOrAssociationStatus || filters.status.includes(roleOrAssociationStatus);
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Gestionnaires de mon Agence",
                ActionButton: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $67b845dc01493173$export$2e2bcd8739ae039), {
                    userRoleKind: 'interimAgencyMember'
                }),
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f73acf0c9704dfc7$export$2e2bcd8739ae039), {
                    textColor: 'white'
                })
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97662361ab0857b9$export$2e2bcd8739ae039), {
                        onChange: setFilters,
                        initialValues: {
                            status: [
                                'accepted',
                                'pending'
                            ]
                        }
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5459a4afa6ab5673$export$2e2bcd8739ae039), {
                        users: users,
                        roleKind: "interimAgencyMember"
                    })
                ]
            })
        ]
    });
};
var $b27717c726d3e72d$export$2e2bcd8739ae039 = $b27717c726d3e72d$var$MembersSettings;



parcelRequire("3ZYaX");






/**
 * Displays the list of terminals for an interim agency
 */ const $2a141b65bd87c583$var$TerminalsSettings = ()=>{
    const { interimAgency: interimAgency } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { data: terminals } = (0, $d9947576038765e2$export$f13bda81a6b78543)({
        'usagePeriods.interimAgency': interimAgency?._id
    }, {
        enabled: Boolean(interimAgency)
    });
    //TODO: handle that in the backend and remove this filter
    const terminalsForInterimAgency = terminals?.map((terminal)=>{
        terminal.usagePeriods = terminal.usagePeriods.filter((usagePeriod)=>(0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(usagePeriod.interimAgency, interimAgency));
        return terminal;
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Bornes de Pointage"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3efac8b4daed7a99$export$2e2bcd8739ae039), {
                    data: terminalsForInterimAgency || []
                })
            })
        ]
    });
};
var $2a141b65bd87c583$export$2e2bcd8739ae039 = $2a141b65bd87c583$var$TerminalsSettings;



parcelRequire("3ZYaX");




var $31tXu = parcelRequire("31tXu");



const $cc45be437717052c$var$initialErrors = {
    error: "D\xe9tail de l'erreur",
    multiError: [
        "D\xe9tail de l'erreur"
    ]
};
const $cc45be437717052c$export$8f902583ed89d9ba = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
                        initialValues: {
                            value: 'value',
                            empty: '',
                            multiValue: [
                                'value'
                            ],
                            error: 'value',
                            multiError: [
                                'value'
                            ]
                        },
                        initialErrors: $cc45be437717052c$var$initialErrors,
                        validate: ()=>$cc45be437717052c$var$initialErrors,
                        onSubmit: ()=>{
                            return;
                        },
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Form), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Disabled"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Empty"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Value"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Required + Empty"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Required + Valid"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                                        children: "\xa0"
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Input, {
                                                            disabled: true,
                                                            value: "Required + Error"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Help, {
                                                        children: "\xa0"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                value: "",
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires",
                                                disabled: true
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                value: "",
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                value: "value",
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                value: "",
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                value: "value",
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                required: true,
                                                label: "Texte",
                                                help: "Informations suppl\xe9mentaires",
                                                name: "error"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                name: "empty",
                                                options: [
                                                    {
                                                        value: 'something',
                                                        label: 'something'
                                                    }
                                                ],
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires",
                                                disabled: true
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                name: "empty",
                                                options: [
                                                    {
                                                        value: 'something',
                                                        label: 'something'
                                                    }
                                                ],
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                name: "value",
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                options: [],
                                                name: "empty",
                                                required: true,
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                name: "value",
                                                required: true,
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                name: "error",
                                                required: true,
                                                label: 'Select',
                                                help: "Informations suppl\xe9mentaires"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "empty",
                                                value: undefined,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires zadd",
                                                disabled: true
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "empty",
                                                value: undefined,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "multiValue",
                                                value: undefined,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "empty",
                                                required: true,
                                                value: undefined,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "multiValue",
                                                required: true,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                                                name: "multiError",
                                                required: true,
                                                options: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'MultiSelect',
                                                help: "Informations suppl\xe9mentaires"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        narrow: true,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "empty",
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires",
                                                disabled: true
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "empty",
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "value",
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "empty",
                                                required: true,
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "value",
                                                required: true,
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires"
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                                                name: "error",
                                                required: true,
                                                items: [
                                                    {
                                                        value: 'value',
                                                        label: 'value'
                                                    }
                                                ],
                                                label: 'AutoComplete',
                                                help: "Informations suppl\xe9mentaires"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};




var $3ZYaX = parcelRequire("3ZYaX");








parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");

var $261e990b13f4d766$export$27053cbd45f02aa7 = /*#__PURE__*/ function(TerminalStatusEnum) {
    TerminalStatusEnum["active"] = "active";
    TerminalStatusEnum["inactive"] = "inactive";
    return TerminalStatusEnum;
}({});
var $261e990b13f4d766$export$73e9712b89ba40c2 = /*#__PURE__*/ function(TerminalConnectionStatusEnum) {
    TerminalConnectionStatusEnum["online"] = "online";
    TerminalConnectionStatusEnum["offline"] = "offline";
    return TerminalConnectionStatusEnum;
}({});










const $5f0317bf79c770f7$var$initialValues = {
    device: {
        name: '',
        serialNumber: ''
    },
    status: (0, $261e990b13f4d766$export$27053cbd45f02aa7).inactive,
    usagePeriods: [
        {
            startDate: new Date(),
            employer: '',
            interimAgency: '',
            rentalCost: 0
        }
    ]
};
const $5f0317bf79c770f7$var$TerminalForm = ({ terminal: terminal, onSuccess: onSuccess })=>{
    const createMutation = (0, $d9947576038765e2$export$a25726670bb41cb)();
    const updateMutation = (0, $d9947576038765e2$export$cac0b33e6f13c8ec)();
    const agenciesQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'interimAgency'
    });
    const employersQuery = (0, $58f46cb3f921014b$export$98cc8fc48c6a548b)({
        type: 'employer'
    });
    // Get associated employers for the selected agency
    const getAssociatedEmployers = (interimAgencyId)=>{
        if (!employersQuery.data || !interimAgencyId) return [];
        return employersQuery.data.filter((employer)=>employer.associations.some((a)=>a.status === 'accepted' && (0, $ff82e5b471ec35cc$export$12e6eb457c26b96c)(a.interimAgency, interimAgencyId)));
    };
    const validate = (values)=>{
        const errors = {};
        if (!values.device?.name) {
            errors.device = errors.device || {};
            errors.device.name = "Le nom de l'appareil est requis";
        }
        if (!values.device?.serialNumber) {
            errors.device = errors.device || {};
            errors.device.serialNumber = "Le num\xe9ro de s\xe9rie est requis";
        } else if (!/^[A-Za-z0-9-]+$/.test(values.device.serialNumber)) {
            errors.device = errors.device || {};
            errors.device.serialNumber = 'Format invalide (lettres, chiffres et tirets uniquement)';
        }
        // Usage periods validation
        if (!values.usagePeriods) values.usagePeriods = [];
        // Sort periods by start date to make validation easier
        const sortedPeriods = [
            ...values.usagePeriods
        ].sort((a, b)=>new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
        // Check overlaps and other validations
        sortedPeriods.forEach((period, index)=>{
            const currentIndex = (values.usagePeriods || []).indexOf(period);
            if (!period.startDate) errors[`usagePeriods.${currentIndex}.startDate`] = "Date de d\xe9but requise";
            if (!period.employer) errors[`usagePeriods.${currentIndex}.employer`] = 'Employeur requis';
            if (!period.interimAgency) errors[`usagePeriods.${currentIndex}.interimAgency`] = "Agence d'int\xe9rim requise";
            if (typeof period.rentalCost !== 'number' || period.rentalCost < 0) errors[`usagePeriods.${currentIndex}.rentalCost`] = 'Cout de location requis';
            // Check if end date is after start date
            if (period.endDate && period.startDate && new Date(period.endDate) < new Date(period.startDate)) errors[`usagePeriods.${currentIndex}.endDate`] = "La date de fin doit \xeatre apr\xe8s la date de d\xe9but";
            // Check overlapping periods have the same employer
            sortedPeriods.forEach((otherPeriod, otherIndex)=>{
                if (index !== otherIndex) {
                    const currentStart = new Date(period.startDate);
                    const currentEnd = period.endDate ? new Date(period.endDate) : new Date('9999-12-31');
                    const otherStart = new Date(otherPeriod.startDate);
                    const otherEnd = otherPeriod.endDate ? new Date(otherPeriod.endDate) : new Date('9999-12-31');
                    // Check if periods overlap
                    if (currentStart <= otherEnd && currentEnd >= otherStart && period.employer !== otherPeriod.employer) {
                        const originalIndex = (values.usagePeriods || []).indexOf(period);
                        errors[`usagePeriods.${originalIndex}.employer`] = "Les p\xe9riodes qui se chevauchent doivent avoir le m\xeame employeur";
                    }
                    // Check if periods with same employer and agency overlap
                    if (currentStart <= otherEnd && currentEnd >= otherStart && period.employer === otherPeriod.employer && period.interimAgency === otherPeriod.interimAgency) {
                        const originalIndex = (values.usagePeriods || []).indexOf(period);
                        errors[`usagePeriods.${originalIndex}.startDate`] = "Les p\xe9riodes pour le m\xeame employeur et la m\xeame agence ne peuvent pas se chevaucher";
                    }
                }
            });
        });
        return errors;
    };
    const handleSubmit = async (values)=>{
        // Ensure endDate is undefined if empty string (input returns empty string if empty and api expects undefined)
        if (values.usagePeriods) values.usagePeriods = values.usagePeriods.map((element)=>({
                ...element,
                endDate: element.endDate || undefined
            }));
        try {
            if (terminal) await updateMutation.mutateAsync({
                ...values,
                id: terminal._id
            });
            else await createMutation.mutateAsync({
                ...values
            });
            onSuccess?.();
        } catch (error) {
            console.error("Erreur lors de la cr\xe9ation du terminal:", error);
        }
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        //@ts-ignore
        initialValues: terminal ? {
            ...terminal,
            usagePeriods: terminal.usagePeriods.map((usagePeriod)=>({
                    ...usagePeriod,
                    startDate: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(usagePeriod.startDate)),
                    endDate: usagePeriod.endDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(usagePeriod.endDate)) : undefined,
                    employer: usagePeriod.employer._id,
                    interimAgency: usagePeriod.interimAgency._id
                }))
        } : $5f0317bf79c770f7$var$initialValues,
        validate: validate,
        onSubmit: handleSubmit,
        children: ({ values: values })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom de l'appareil",
                        name: "device.name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        placeholder: "NewLand Nquire 500...",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Num\xe9ro de s\xe9rie",
                        name: "device.serialNumber",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        placeholder: "TERM-001-XYZ...",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: [
                            "P\xe9riodes d'utilisation",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                className: "help mb-4",
                                children: "Les p\xe9riodes d'utilisation peuvent se chevaucher. Une p\xe9riode sans date de fin est consid\xe9r\xe9e comme active."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                        name: "usagePeriods",
                        children: ({ push: push, remove: remove })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                                children: [
                                    values.usagePeriods?.map((_, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                            style: {
                                                position: 'relative'
                                            },
                                            children: [
                                                values.usagePeriods && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "danger",
                                                    size: "small",
                                                    onClick: ()=>remove(index),
                                                    style: {
                                                        position: 'absolute',
                                                        top: '1rem',
                                                        right: '1rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {
                                                            color: "white"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                    mt: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 4,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Date de d\xe9but",
                                                                name: `usagePeriods.${index}.startDate`,
                                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                type: "date",
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 4,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Date de fin",
                                                                name: `usagePeriods.${index}.endDate`,
                                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                min: values.usagePeriods?.[index]?.startDate,
                                                                type: "date"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 4,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Co\xfbt de location",
                                                                name: `usagePeriods.${index}.rentalCost`,
                                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                type: "number",
                                                                min: "0",
                                                                step: "0.01",
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Agence d'int\xe9rim",
                                                                name: `usagePeriods.${index}.interimAgency`,
                                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(agenciesQuery.data || []),
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Employeur",
                                                                name: `usagePeriods.${index}.employer`,
                                                                component: (0, $c7f97019e02e0444$export$2e2bcd8739ae039),
                                                                options: (0, $7fcb743e4eebb394$export$f97653d8ee55c674)(getAssociatedEmployers(String(values.usagePeriods?.[index]?.interimAgency)) || []),
                                                                disabled: !values.usagePeriods?.[index]?.interimAgency,
                                                                required: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index)),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        onClick: ()=>push({
                                                startDate: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date()),
                                                employer: '',
                                                interimAgency: ''
                                            }),
                                        size: "small",
                                        children: "Ajouter une p\xe9riode"
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                        kind: "group",
                        mt: 5,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                                color: "primary",
                                type: "submit",
                                mutation: terminal ? updateMutation : createMutation,
                                children: terminal ? "Mettre \xe0 jour la borne de pointage" : "Cr\xe9er la borne de pointage"
                            })
                        })
                    })
                ]
            })
    });
};
var $5f0317bf79c770f7$export$2e2bcd8739ae039 = $5f0317bf79c770f7$var$TerminalForm;



const $b7840217f2173893$var$TerminalsListPage = ()=>{
    const terminalsQuery = (0, $d9947576038765e2$export$f13bda81a6b78543)();
    const [currentTerminal, setCurrentTerminal] = (0, $3ZYaX.useState)(null);
    const newTerminalModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        newTerminalModal.setIsDisplayed(Boolean(currentTerminal));
    }, [
        currentTerminal
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!newTerminalModal.isDisplayed) setCurrentTerminal(null);
    }, [
        newTerminalModal.isDisplayed
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ef5abab7d7fe89ed$export$2e2bcd8739ae039), {
                title: "Liste des Bornes de Pointage"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8f82d3bbdc504683$export$2e2bcd8739ae039).Right, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                            children: "\xa0"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Control, {
                                            children: [
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                                    onClick: ()=>{
                                                        setCurrentTerminal(null);
                                                        newTerminalModal.setIsDisplayed(true);
                                                    },
                                                    outlined: true,
                                                    color: "primary",
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a6ba75b56dc677fb$export$2e2bcd8739ae039), {})
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                            children: "Nouvelle borne de pointage"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {})
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                            title: currentTerminal ? 'Modifier une Borne de Pointage' : "Cr\xe9er une Borne de Pointage",
                            actions: newTerminalModal,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5f0317bf79c770f7$export$2e2bcd8739ae039), {
                                terminal: currentTerminal || undefined
                            })
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3efac8b4daed7a99$export$2e2bcd8739ae039), {
                            data: terminalsQuery.data || [],
                            onTerminalClick: setCurrentTerminal
                        })
                    ]
                })
            })
        ]
    });
};
var $b7840217f2173893$export$2e2bcd8739ae039 = $b7840217f2173893$var$TerminalsListPage;



parcelRequire("3ZYaX");




const $dae377ae4cc3971e$var$TerminalDetails = ()=>{
    const { id: id } = (0, $39b0bf07af9c8a3f$export$99eaa27ddbbb95ef)();
    const { data: terminal, isLoading: isLoading } = (0, $d9947576038765e2$export$b9260e603a469536)(id);
    if (isLoading) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
        children: "Chargement..."
    });
    if (!terminal) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
        children: "Terminal non trouv\xe9"
    });
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("h1", {
                className: "title",
                children: "D\xe9tails de la borne de pointage"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel).Block, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                className: "mr-2",
                                children: "ID:"
                            }),
                            " ",
                            terminal._id
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel).Block, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                className: "mr-2",
                                children: "Cr\xe9\xe9 le:"
                            }),
                            (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(terminal.createdAt)
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel).Block, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                className: "mr-2",
                                children: "Employeur actuel:"
                            }),
                            terminal.usagePeriods?.[0]?.employer?.name || "Non assign\xe9"
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Panel).Block, {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("strong", {
                                className: "mr-2",
                                children: "Historique d'utilisation:"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("ul", {
                                children: terminal.usagePeriods?.map((period, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("li", {
                                        children: [
                                            period.employer?.name,
                                            " - Du ",
                                            (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.startedAt),
                                            period.endedAt ? ` au ${(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.endedAt)}` : ' (en cours)'
                                        ]
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $dae377ae4cc3971e$export$2e2bcd8739ae039 = $dae377ae4cc3971e$var$TerminalDetails;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");



const $b625d956c49fa226$var$ServicesList = ({ data: data, itemPath: itemPath, onServiceClick: onServiceClick })=>{
    const tableColumns = $b625d956c49fa226$var$useListTableColumns(itemPath, onServiceClick);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(data, 'name'),
        noDataMessage: "Aucune Affectation \xe0 afficher",
        dataTest: "services-list"
    });
};
const $b625d956c49fa226$var$useListTableColumns = (itemPath, onServiceClick)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "a",
                        color: "ghost",
                        onClick: ()=>onServiceClick?.(data.row.original),
                        children: data.row.original.name
                    })
            },
            {
                Header: 'Description',
                accessor: 'description',
                Cell: ({ value: value })=>value || '-'
            }
        ], [
        itemPath
    ]);
};
var $b625d956c49fa226$export$2e2bcd8739ae039 = $b625d956c49fa226$var$ServicesList;






parcelRequire("3ZYaX");

const $013d46899c00602d$var$ServiceExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
            mb: 2,
            children: "L'affectation est une unit\xe9 organisationnelle qui permet de regrouper et cat\xe9goriser les missions au sein de votre entreprise."
        })
    });
};
var $013d46899c00602d$export$2e2bcd8739ae039 = $013d46899c00602d$var$ServiceExplanation;



parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");



const $ad02b35aeab66c01$var$ServiceForm = ({ service: service })=>{
    const createMutation = (0, $3d856666402e8eec$export$a25726670bb41cb)();
    const updateMutation = (0, $3d856666402e8eec$export$cac0b33e6f13c8ec)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: service || {
            name: '',
            description: ''
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name) errors.name = 'Champ requis';
            return errors;
        },
        onSubmit: (values)=>{
            service ? updateMutation.mutate({
                ...values,
                id: service._id
            }) : createMutation.mutate({
                ...values
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom",
                        name: "name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        placeholder: "Ex: Production, Logistique, Administration..."
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Description",
                        name: "description",
                        component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039),
                        placeholder: "Description de l'affectation (optionnelle)"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: service ? updateMutation : createMutation,
                        "data-test": "submit-service-form",
                        children: service ? "Mettre \xe0 jour l'Affectation" : 'Nouvelle Affectation'
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: service ? updateMutation : createMutation
                    })
                ]
            });
        }
    });
};
var $ad02b35aeab66c01$export$2e2bcd8739ae039 = $ad02b35aeab66c01$var$ServiceForm;





const $f218f59ea2797ef1$var$ServiceModalForm = ({ isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed, service: service })=>{
    const updateMutation = (0, $3d856666402e8eec$export$cac0b33e6f13c8ec)();
    const { isDisplayed: isConfirmationDisplayed, setIsDisplayed: setIsConfirmationDisplayed } = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const isServiceInactive = service?.isInactive;
    const handleToggleStatus = async ()=>{
        if (!service?._id) return;
        await updateMutation.mutateAsync({
            id: service._id,
            isInactive: !isServiceInactive
        });
        setIsDisplayed(false);
        setIsConfirmationDisplayed(false);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                actions: {
                    isDisplayed: isDisplayed,
                    setIsDisplayed: setIsDisplayed
                },
                title: service ? "Modifier l'Affectation" : "Cr\xe9er une nouvelle Affectation",
                dataTest: "service-modal",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ad02b35aeab66c01$export$2e2bcd8739ae039), {
                            service: service
                        })
                    }),
                    service && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        pt: 2,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            className: "is-flex is-justify-content-space-between is-align-items-center",
                            mt: 2,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textWeight: "bold",
                                            children: isServiceInactive ? "R\xe9activer cette affectation" : "D\xe9sactiver cette affectation"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textSize: 7,
                                            textColor: "grey",
                                            children: isServiceInactive ? "Une fois r\xe9activ\xe9, l'affectation sera \xe0 nouveau disponible pour les missions et les demandes" : "Une fois d\xe9sactiv\xe9, vous pourrez la r\xe9activer plus tard"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    color: isServiceInactive ? 'success' : 'danger',
                                    onClick: ()=>setIsConfirmationDisplayed(true),
                                    "data-test": "disable-service-button",
                                    size: "small",
                                    children: isServiceInactive ? "R\xe9activer l'affectation" : "D\xe9sactiver l'affectation"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: isConfirmationDisplayed,
                onConfirm: handleToggleStatus,
                onCancel: ()=>setIsConfirmationDisplayed(false),
                title: isServiceInactive ? "R\xe9activer l'affectation" : "D\xe9sactiver l'affectation",
                confirmButtonLabel: isServiceInactive ? "R\xe9activer" : "D\xe9sactiver",
                confirmButtonProps: {
                    color: isServiceInactive ? 'success' : 'danger',
                    disabled: false
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: isServiceInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir r\xe9activer cette affectation ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "L'affectation sera \xe0 nouveau disponible pour les missions et les demandes."
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir d\xe9sactiver cette affectation ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Les missions utilisant cette affectation ne seront pas impact\xe9es et conserveront leur historique.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textWeight: "bold",
                                children: "L'affectation ne sera plus visible dans les filtres et ne pourra plus \xeatre s\xe9lectionn\xe9e pour la cr\xe9ation de nouvelles missions et de nouvelles demandes."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $f218f59ea2797ef1$export$2e2bcd8739ae039 = $f218f59ea2797ef1$var$ServiceModalForm;


/**
 * Component for managing employer services
 */ const $740256d448e7d59e$var$ServicesSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [showInactive, setShowInactive] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const query = {};
    if (showInactive) query.isInactive = true;
    const { data: services } = (0, $3d856666402e8eec$export$a870673e4b33fcfb)(query, {
        enabled: Boolean(employer)
    });
    const [currentService, setCurrentService] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Affectations",
                onButtonClick: ()=>setCurrentService('new'),
                addButtonLabel: "Nouvelle affectation",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d),
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $013d46899c00602d$export$2e2bcd8739ae039), {
                    textColor: 'white'
                }),
                buttonDataTestId: "create-service-button"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    showInactive && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "info",
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                    }),
                                    "Vous affichez uniquement les affectations inactives.",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    " Ces affectations ne sont plus utilis\xe9es dans les missions et les demandes. Vous pouvez les r\xe9activer en les modifiant."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b625d956c49fa226$export$2e2bcd8739ae039), {
                        data: services || [],
                        onServiceClick: (service)=>setCurrentService(service)
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textAlign: 'right',
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                                    checked: showInactive,
                                    onChange: (e)=>setShowInactive(e.target.checked),
                                    "data-test": "show-inactive-services-checkbox",
                                    children: "Afficher les affectations inactives"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f218f59ea2797ef1$export$2e2bcd8739ae039), {
                isDisplayed: Boolean(currentService),
                setIsDisplayed: ()=>setCurrentService(undefined),
                service: currentService === 'new' ? undefined : currentService
            })
        ]
    });
};
var $740256d448e7d59e$export$2e2bcd8739ae039 = $740256d448e7d59e$var$ServicesSettings;



parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");






/**
 * Composant pour afficher la liste des modèles de compteurs de travailleurs
 * Affiche un tableau avec les informations des compteurs pour un employeur donné
 */ const $6630fbe05a50e4f6$var$WorkerCounterTemplatesList = ({ employerId: employerId, workerCounterTemplates: workerCounterTemplates, noDataMessage: noDataMessage = "Aucun compteur \xe0 afficher" })=>{
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employerId}` : '/settings';
    // Configuration des colonnes du tableau
    const tableColumns = $6630fbe05a50e4f6$var$useWorkerCounterTemplatesTableColumns(basePath);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(workerCounterTemplates || [], 'name'),
        noDataMessage: noDataMessage
    });
};
/**
 * Hook pour configurer les colonnes du tableau des modèles de compteurs
 * @param basePath - Base path pour les liens de navigation
 * @returns Configuration des colonnes du tableau
 */ const $6630fbe05a50e4f6$var$useWorkerCounterTemplatesTableColumns = (basePath)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'superAdmin'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d02addba8eace897$export$3c0c9559fbad40ef), {
                                    resource: data.row.original,
                                    path: `${basePath}/worker-counters/`,
                                    label: data.row.original.name
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: data.row.original.name
                            })
                        ]
                    })
            },
            {
                Header: 'Description',
                accessor: 'description',
                Cell: (data)=>data.row.original.description || '-'
            },
            {
                Header: "R\xe8gles comptabilis\xe9es",
                accessor: 'employerRules',
                Cell: (data)=>{
                    const rules = data.row.original.employerRules;
                    if (!rules || rules.length === 0) return '0';
                    return rules.map((rule)=>rule.name).join(' | ');
                }
            },
            {
                Header: "D\xe9but p\xe9riode",
                accessor: 'usagePeriods',
                Cell: (data)=>{
                    const periods = data.row.original.usagePeriods;
                    if (!periods || periods.length === 0) return "Non d\xe9fini";
                    return periods.map((period)=>(0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.startDate)).map((date, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                date,
                                index < periods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index));
                }
            },
            {
                Header: "Fin p\xe9riode",
                // @ts-expect-error: react-table type
                accessor: 'usagePeriods.endDate',
                Cell: (data)=>{
                    const periods = data.row.original.usagePeriods;
                    if (!periods || periods.length === 0) return "Non d\xe9fini";
                    return periods.map((period)=>period.endDate ? (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(period.endDate) : 'N/A').map((date, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).Fragment, {
                            children: [
                                date,
                                index < periods.length - 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {})
                            ]
                        }, index));
                }
            }
        ], [
        basePath
    ]);
};
var $6630fbe05a50e4f6$export$2e2bcd8739ae039 = $6630fbe05a50e4f6$var$WorkerCounterTemplatesList;



parcelRequire("3ZYaX");

/**
 * Composant d'explication pour les compteurs de travailleurs
 * Explique le concept et l'utilisation des compteurs dans l'application
 */ const $22bcdfb6dc2ffa85$var$WorkerCountersExplanation = ({ textColor: textColor })=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 2,
                children: [
                    "Les compteurs permettent de suivre et d'agr\xe9ger automatiquement les dur\xe9es li\xe9es aux activit\xe9s des employ\xe9s. ",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "Ils sont bas\xe9s sur les r\xe8gles employeur et s'appliquent uniquement aux salari\xe9s internes.",
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                    "Ils agr\xe8gent les dur\xe9es lors de la validation d'une semaine d'un salari\xe9 dans la vue Paie."
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Modification manuelle"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        children: "Les membres de l'employeur peuvent ajuster manuellement les valeurs des compteurs."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                mb: 3,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "strong",
                        textColor: textColor,
                        children: "Exemple : Suivi des heures suppl\xe9mentaires"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        children: [
                            "Comptabiliser automatiquement les heures suppl\xe9mentaires effectu\xe9es par un employ\xe9 par semaine, en se basant sur les r\xe8gles employeur de calcul d\xe9finies.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "La modification manuelle peut \xeatre utilis\xe9e pour d\xe9duire les r\xe9cup\xe9rations RTT."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    renderAs: "i",
                    textSize: 7,
                    children: "Pour toute modification ou ajout de compteurs, veuillez contacter votre administrateur TeamTim."
                })
            })
        ]
    });
};
var $22bcdfb6dc2ffa85$export$2e2bcd8739ae039 = $22bcdfb6dc2ffa85$var$WorkerCountersExplanation;






/**
 * Page pour gérer les compteurs de travailleurs dans les paramètres employeur
 * Affiche la liste des modèles de compteurs disponibles
 */ const $791ab37cee9044dc$var$WorkerCountersSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { data: workerCounterTemplates } = (0, $ac19d08459c4c77e$export$b7549eebff4322c5)({
        employer: employer._id
    }, {
        enabled: Boolean(employer._id)
    });
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employer._id}` : '/settings';
    const isSuperAdmin = (0, $8403deec6a28521e$export$6025088343704f9f)([
        'superAdmin'
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Compteurs",
                help: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $22bcdfb6dc2ffa85$export$2e2bcd8739ae039), {
                    textColor: 'white'
                }),
                onButtonClick: isSuperAdmin ? ()=>navigate(`${basePath}/worker-counters/new`) : undefined,
                addButtonLabel: "Nouveau compteur",
                buttonDataTestId: "new-worker-counter",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d)
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6630fbe05a50e4f6$export$2e2bcd8739ae039), {
                    employerId: employer._id,
                    workerCounterTemplates: workerCounterTemplates || [],
                    noDataMessage: "Aucun compteur de travailleur configur\xe9"
                })
            })
        ]
    });
};
var $791ab37cee9044dc$export$2e2bcd8739ae039 = $791ab37cee9044dc$var$WorkerCountersSettings;



parcelRequire("3ZYaX");





var $3ZYaX = parcelRequire("3ZYaX");

var $31tXu = parcelRequire("31tXu");











/**
 * Formulaire pour créer ou modifier un modèle de compteur de travailleur
 * Permet de configurer un modèle réutilisable pour les compteurs
 */ const $fffa54234cbec65d$var$WorkerCounterTemplatesForm = ({ workerCounterTemplate: workerCounterTemplate, employerId: employerId })=>{
    const createMutation = (0, $ac19d08459c4c77e$export$a6551c95c842696d)();
    const updateMutation = (0, $ac19d08459c4c77e$export$86e695b3e640295f)();
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const location = (0, $39b0bf07af9c8a3f$export$45d76561a5302f2b)();
    // Determine base path from current location
    const basePath = location.pathname.includes('/employers/') ? `/employers/${employerId}` : '/settings';
    // Récupérer les règles de l'employeur pour la sélection
    const { data: employerRules } = (0, $52dfa770bdcaf9bf$export$86c10eec7ad727f4)({
        employer: employerId
    }, {
        enabled: Boolean(employerId)
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (createMutation.isSuccess) navigate(`${basePath}/worker-counters/${createMutation.data.data._id}`);
    }, [
        createMutation.isSuccess,
        navigate,
        employerId,
        basePath
    ]);
    if (!employerRules?.[0]) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: workerCounterTemplate ? {
            name: workerCounterTemplate.name,
            description: workerCounterTemplate.description || '',
            employer: employerId,
            employerRules: workerCounterTemplate.employerRules.map((rule)=>typeof rule === 'string' ? rule : rule._id),
            aggregationMethod: workerCounterTemplate.aggregationMethod,
            affectsPeriodSummaryAccounted: workerCounterTemplate.affectsPeriodSummaryAccounted,
            usagePeriods: workerCounterTemplate.usagePeriods?.map((period)=>({
                    startDate: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(period.startDate)),
                    endDate: period.endDate ? (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date(period.endDate)) : undefined
                })) || []
        } : {
            name: '',
            description: '',
            employer: employerId,
            employerRules: [],
            aggregationMethod: 'sum',
            affectsPeriodSummaryAccounted: false,
            usagePeriods: [
                {
                    startDate: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date()),
                    endDate: undefined
                }
            ]
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name?.trim()) errors.name = 'Le nom est requis';
            if (!values.employerRules?.length) errors.employerRules = "Au moins une r\xe8gle est requise";
            // Usage periods validation
            if (!values.usagePeriods) values.usagePeriods = [];
            // Sort periods by start date to make validation easier
            const sortedPeriods = [
                ...values.usagePeriods
            ].sort((a, b)=>new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
            // Check overlaps and other validations
            sortedPeriods.forEach((period, index)=>{
                const currentIndex = (values.usagePeriods || []).indexOf(period);
                if (!period.startDate) errors[`usagePeriods.${currentIndex}.startDate`] = "Date de d\xe9but requise";
                // Check if end date is after start date
                if (period.endDate && period.startDate && new Date(period.endDate) < new Date(period.startDate)) errors[`usagePeriods.${currentIndex}.endDate`] = "La date de fin doit \xeatre apr\xe8s la date de d\xe9but";
                // Check for overlaps with subsequent periods
                for(let j = index + 1; j < sortedPeriods.length; j++){
                    const nextPeriod = sortedPeriods[j];
                    if (!nextPeriod) continue;
                    const currentEndDate = period.endDate ? new Date(period.endDate) : null;
                    const nextStartDate = new Date(nextPeriod.startDate);
                    // If current period has no end date, it automatically overlaps with all subsequent periods
                    if (!currentEndDate) {
                        errors[`usagePeriods.${currentIndex}.endDate`] = "Cette p\xe9riode chevauche les p\xe9riodes suivantes";
                        break;
                    }
                    // If current period's end date is after or equal to next period's start date
                    if (currentEndDate >= nextStartDate) {
                        errors[`usagePeriods.${currentIndex}.endDate`] = "Cette p\xe9riode chevauche la p\xe9riode suivante";
                        break;
                    }
                }
            });
            return errors;
        },
        onSubmit: (values)=>{
            const payload = {
                ...values,
                name: values.name.trim(),
                description: values.description?.trim() || undefined,
                employerRules: values.employerRules || [],
                employer: employerId,
                aggregationMethod: values.aggregationMethod || 'sum',
                usagePeriods: values.usagePeriods?.map((period)=>({
                        startDate: new Date(period.startDate),
                        endDate: period.endDate ? new Date(period.endDate) : undefined
                    })) || []
            };
            if (workerCounterTemplate) updateMutation.mutate({
                id: workerCounterTemplate._id,
                ...payload
            });
            else createMutation.mutate(payload);
        },
        children: ({ values: values, setFieldValue: setFieldValue })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom du compteur",
                        name: "name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        required: true,
                        disabled: Boolean(workerCounterTemplate),
                        help: "Nom unique pour identifier ce compteur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Description",
                        name: "description",
                        component: (0, $3f63467ecce9325b$export$2e2bcd8739ae039),
                        minRows: 2,
                        maxRows: 4,
                        help: "Description optionnelle du compteur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: "Configuration du compteur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "R\xe8gles utilis\xe9es",
                        name: "employerRules",
                        component: (0, $c90ab88e1e4f22ae$export$2e2bcd8739ae039),
                        options: employerRules.map((rule)=>({
                                value: rule._id,
                                label: `${rule.name} (${rule.shortName})`
                            })) || [],
                        required: true,
                        help: "S\xe9lectionnez les r\xe8gles employeur qui seront utilis\xe9es pour calculer la valeur du compteur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Affecte les heures comptabilis\xe9es de la semaines",
                        name: "affectsPeriodSummaryAccounted",
                        component: (0, $757b38d3bc5e98e6$export$2e2bcd8739ae039),
                        help: "Si activ\xe9, les heures comptabilis\xe9es de la semaines seront affect\xe9es \xe0 ce compteur"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        mt: 5,
                        children: [
                            "P\xe9riodes d'utilisation",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("p", {
                                className: "help mb-4",
                                children: "D\xe9finissez les p\xe9riodes pendant lesquelles ce compteur sera actif. Une p\xe9riode sans date de fin est consid\xe9r\xe9e comme active."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.FieldArray), {
                        name: "usagePeriods",
                        children: ({ push: push, remove: remove })=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)("div", {
                                children: [
                                    values.usagePeriods?.map((_, index)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                                            style: {
                                                position: 'relative'
                                            },
                                            children: [
                                                values.usagePeriods && values.usagePeriods.length > 1 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                                    color: "danger",
                                                    size: "small",
                                                    onClick: ()=>remove(index),
                                                    style: {
                                                        position: 'absolute',
                                                        top: '1rem',
                                                        right: '1rem'
                                                    },
                                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$6382847193091a26), {
                                                            color: "white"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                                    mt: 2,
                                                    children: [
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Date de d\xe9but",
                                                                name: `usagePeriods.${index}.startDate`,
                                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                type: "date",
                                                                required: true
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                            size: 6,
                                                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                                                label: "Date de fin",
                                                                name: `usagePeriods.${index}.endDate`,
                                                                component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                                                min: values.usagePeriods?.[index]?.startDate,
                                                                type: "date",
                                                                help: index === values.usagePeriods.length - 1 ? "Optionnel pour la p\xe9riode active" : "Requis pour \xe9viter les chevauchements"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, index)),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                        onClick: ()=>push({
                                                startDate: (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(new Date()),
                                                endDate: undefined
                                            }),
                                        size: "small",
                                        children: "Ajouter une p\xe9riode"
                                    })
                                ]
                            })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: workerCounterTemplate ? updateMutation : createMutation,
                        mt: 6,
                        children: workerCounterTemplate ? "Mettre \xe0 jour" : "Cr\xe9er"
                    })
                ]
            })
    });
};
var $fffa54234cbec65d$export$2e2bcd8739ae039 = $fffa54234cbec65d$var$WorkerCounterTemplatesForm;




/**
 * Component for managing worker counter template details in settings
 * Uses outlet context to get employer and displays the form with sidebar
 */ const $b40f6a42735823bc$var$WorkerCounterDetailsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)({
        idName: 'workerCounterTemplateId'
    });
    const { data: workerCounterTemplate } = (0, $ac19d08459c4c77e$export$ef6e414138634c4d)(id, {
        enabled: Boolean(id && !isNew)
    });
    if (!isNew && !workerCounterTemplate) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: isNew ? 'Nouveau Compteur' : `Compteur ${workerCounterTemplate?.name || ''}`
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $fffa54234cbec65d$export$2e2bcd8739ae039), {
                    workerCounterTemplate: workerCounterTemplate,
                    employerId: employer._id
                })
            })
        ]
    });
};
var $b40f6a42735823bc$export$2e2bcd8739ae039 = $b40f6a42735823bc$var$WorkerCounterDetailsSettings;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");



/**
 * Component that displays a table of work period tags
 */ const $597c8a82c05dcceb$var$WorkPeriodTagsList = ({ data: data, onTagClick: onTagClick })=>{
    const tableColumns = $597c8a82c05dcceb$var$useListTableColumns(onTagClick);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: (0, $b31fa4978015d2ce$export$c70f2fe738210bdf)(data, 'name'),
        noDataMessage: "Aucune cat\xe9gorie \xe0 afficher",
        dataTest: "work-period-tags-list"
    });
};
const $597c8a82c05dcceb$var$useListTableColumns = (onTagClick)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "a",
                        color: "ghost",
                        onClick: ()=>onTagClick?.(data.row.original),
                        "data-test": `work-period-tag-${data.row.original._id}-link`,
                        children: data.row.original.name
                    })
            }
        ], [
        onTagClick
    ]);
};
var $597c8a82c05dcceb$export$2e2bcd8739ae039 = $597c8a82c05dcceb$var$WorkPeriodTagsList;






parcelRequire("3ZYaX");


parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");


/**
 * Form component for creating or editing work period tags
 * Includes a name field and isInactive checkbox
 */ const $b5b4c7af6f9a32ae$var$WorkPeriodTagForm = ({ tag: tag, onSuccess: onSuccess })=>{
    const createMutation = (0, $b9e4dc58c86ce67a$export$a25726670bb41cb)();
    const updateMutation = (0, $b9e4dc58c86ce67a$export$cac0b33e6f13c8ec)();
    const handleSuccess = ()=>{
        if (onSuccess) onSuccess();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: tag || {
            name: '',
            isInactive: false
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            if (!values.name) errors.name = 'Champ requis';
            return errors;
        },
        onSubmit: async (values)=>{
            if (tag) await updateMutation.mutateAsync({
                ...values,
                id: tag._id
            });
            else await createMutation.mutateAsync({
                ...values
            });
            handleSuccess();
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom",
                        name: "name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        placeholder: "Ex: Journ\xe9e normale, Journ\xe9e de repos, Cong\xe9..."
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: tag ? updateMutation : createMutation,
                        "data-test": "submit-work-period-tag-form",
                        children: tag ? "Mettre \xe0 jour la cat\xe9gorie" : "Cr\xe9er la cat\xe9gorie"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: tag ? updateMutation : createMutation
                    })
                ]
            });
        }
    });
};
var $b5b4c7af6f9a32ae$export$2e2bcd8739ae039 = $b5b4c7af6f9a32ae$var$WorkPeriodTagForm;





/**
 * Modal form component for creating or editing work period tags
 * Includes form fields and a button to activate/deactivate the tag
 */ const $e34884df2411d80a$var$WorkPeriodTagModalForm = ({ isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed, tag: tag, onSuccess: onSuccess })=>{
    const updateMutation = (0, $b9e4dc58c86ce67a$export$cac0b33e6f13c8ec)();
    const { isDisplayed: isConfirmationDisplayed, setIsDisplayed: setIsConfirmationDisplayed } = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const isTagInactive = tag?.isInactive;
    const handleToggleStatus = async ()=>{
        if (!tag?._id) return;
        await updateMutation.mutateAsync({
            id: tag._id,
            isInactive: !isTagInactive
        });
        setIsDisplayed(false);
        setIsConfirmationDisplayed(false);
    };
    const handleFormSuccess = ()=>{
        setIsDisplayed(false);
        if (onSuccess) onSuccess();
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
                actions: {
                    isDisplayed: isDisplayed,
                    setIsDisplayed: setIsDisplayed
                },
                title: tag ? "Modifier la cat\xe9gorie" : "Cr\xe9er une nouvelle cat\xe9gorie",
                dataTest: "work-period-tag-modal",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b5b4c7af6f9a32ae$export$2e2bcd8739ae039), {
                            tag: tag,
                            onSuccess: handleFormSuccess
                        })
                    }),
                    tag && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        pt: 2,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mt: 2,
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textWeight: "bold",
                                            children: isTagInactive ? "R\xe9activer cette cat\xe9gorie" : "D\xe9sactiver cette cat\xe9gorie"
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            textSize: 7,
                                            textColor: "grey",
                                            children: isTagInactive ? "Une fois r\xe9activ\xe9e, la cat\xe9gorie sera \xe0 nouveau disponible pour les journ\xe9es de travail" : "Une fois d\xe9sactiv\xe9e, vous pourrez la r\xe9activer plus tard"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Button), {
                                    color: isTagInactive ? 'success' : 'danger',
                                    onClick: ()=>setIsConfirmationDisplayed(true),
                                    "data-test": "disable-work-period-tag-button",
                                    size: "small",
                                    children: isTagInactive ? "R\xe9activer la cat\xe9gorie" : "D\xe9sactiver la cat\xe9gorie"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: isConfirmationDisplayed,
                onConfirm: handleToggleStatus,
                onCancel: ()=>setIsConfirmationDisplayed(false),
                title: isTagInactive ? "R\xe9activer la cat\xe9gorie" : "D\xe9sactiver la cat\xe9gorie",
                confirmButtonLabel: isTagInactive ? "R\xe9activer" : "D\xe9sactiver",
                confirmButtonProps: {
                    color: isTagInactive ? 'success' : 'danger',
                    disabled: false
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: isTagInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir r\xe9activer cette cat\xe9gorie ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "La cat\xe9gorie sera \xe0 nouveau disponible pour les journ\xe9es de travail."
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            "\xcates-vous s\xfbr de vouloir d\xe9sactiver cette cat\xe9gorie ?",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            "Les journ\xe9es de travail utilisant cette cat\xe9gorie ne seront pas impact\xe9es et conserveront leur cat\xe9gorie.",
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                textWeight: "bold",
                                children: "La cat\xe9gorie ne sera plus visible dans les filtres et ne pourra plus \xeatre s\xe9lectionn\xe9e pour les nouvelles journ\xe9es de travail."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var $e34884df2411d80a$export$2e2bcd8739ae039 = $e34884df2411d80a$var$WorkPeriodTagModalForm;


/**
 * Component for managing employer work period tags
 * Displays a list of tags with ability to create, edit and activate/deactivate them
 */ const $5f8ab0e785410125$var$WorkPeriodTagsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const [showInactive, setShowInactive] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(false);
    const query = {};
    if (showInactive) query.isInactive = true;
    const { data: tags } = (0, $b9e4dc58c86ce67a$export$9a06e401dcb665a)(query, {
        enabled: Boolean(employer)
    });
    const [currentTag, setCurrentTag] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "Cat\xe9gories",
                onButtonClick: ()=>setCurrentTag('new'),
                addButtonLabel: "Nouvelle cat\xe9gorie",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d),
                buttonDataTestId: "create-work-period-tag-button"
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    showInactive && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message), {
                        color: "info",
                        className: "mb-4",
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Message).Body, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$f7dc499a72baa103), {})
                                    }),
                                    "Vous affichez uniquement les cat\xe9gories inactives.",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    " Ces cat\xe9gories ne sont plus utilis\xe9es dans les journ\xe9es de travail. Vous pouvez les r\xe9activer en les modifiant."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $597c8a82c05dcceb$export$2e2bcd8739ae039), {
                        data: tags || [],
                        onTagClick: (tag)=>setCurrentTag(tag)
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        textAlign: 'right',
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Control, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Checkbox, {
                                    checked: showInactive,
                                    onChange: (e)=>setShowInactive(e.target.checked),
                                    "data-test": "display-inactive-work-period-tags-checkbox",
                                    children: "Afficher les cat\xe9gories inactives"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e34884df2411d80a$export$2e2bcd8739ae039), {
                isDisplayed: Boolean(currentTag),
                setIsDisplayed: ()=>setCurrentTag(undefined),
                tag: currentTag === 'new' ? undefined : currentTag
            })
        ]
    });
};
var $5f8ab0e785410125$export$2e2bcd8739ae039 = $5f8ab0e785410125$var$WorkPeriodTagsSettings;




var $3ZYaX = parcelRequire("3ZYaX");




var $3ZYaX = parcelRequire("3ZYaX");




/**
 * Displays a table of special periods with their details
 */ const $da9d087afde4311b$var$SpecialPeriodsList = ({ specialPeriods: specialPeriods, onPeriodClick: onPeriodClick, showEmployer: showEmployer = false })=>{
    const tableColumns = $da9d087afde4311b$var$useSpecialPeriodsColumns(specialPeriods, onPeriodClick, showEmployer);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $318802042539b948$export$2e2bcd8739ae039), {
        columns: tableColumns,
        data: specialPeriods,
        noDataMessage: "Aucune p\xe9riode sp\xe9ciale \xe0 afficher"
    });
};
const $da9d087afde4311b$var$useSpecialPeriodsColumns = (specialPeriods, onClick, showEmployer)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const columns = [
            {
                Header: 'Nom',
                accessor: 'name',
                Cell: (data)=>{
                    const specialPeriod = data.cell.row.original;
                    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "a",
                        color: "ghost",
                        onClick: ()=>onClick?.(specialPeriod),
                        "data-test": `edit-special-period-${specialPeriod._id}`,
                        style: {
                            cursor: onClick ? 'pointer' : 'default'
                        },
                        children: specialPeriod.name
                    });
                }
            },
            {
                Header: 'Type',
                accessor: 'type',
                Cell: (data)=>{
                    const specialPeriod = data.cell.row.original;
                    return specialPeriod.type;
                }
            },
            {
                Header: "Date de d\xe9but",
                accessor: 'startDate',
                Cell: (data)=>{
                    const date = typeof data.value === 'string' ? new Date(data.value) : data.value;
                    return (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(date);
                }
            },
            {
                Header: 'Date de fin',
                accessor: 'endDate',
                Cell: (data)=>{
                    const date = typeof data.value === 'string' ? new Date(data.value) : data.value;
                    return (0, $74f17ceb9b5a08a5$export$3ae94a2503e890a1)(date);
                }
            },
            {
                Header: "Dur\xe9e",
                id: 'duration',
                Cell: (data)=>{
                    const specialPeriod = data.cell.row.original;
                    const startDate = typeof specialPeriod.startDate === 'string' ? new Date(specialPeriod.startDate) : specialPeriod.startDate;
                    const endDate = typeof specialPeriod.endDate === 'string' ? new Date(specialPeriod.endDate) : specialPeriod.endDate;
                    const days = (0, $46e6b7724aa17953$export$2e2bcd8739ae039)(endDate, startDate) + 1;
                    return `${days} jour${days > 1 ? 's' : ''}`;
                }
            }
        ];
        // Add employer column if needed
        if (showEmployer) columns.splice(1, 0, {
            Header: 'Employeur',
            accessor: 'employer',
            Cell: (data)=>{
                const specialPeriod = data.cell.row.original;
                const employer = typeof specialPeriod.employer === 'string' ? null : specialPeriod.employer;
                return employer ? employer.name : '-';
            }
        });
        return columns;
    }, [
        specialPeriods,
        onClick,
        showEmployer
    ]);
};
var $da9d087afde4311b$export$2e2bcd8739ae039 = $da9d087afde4311b$var$SpecialPeriodsList;




var $3ZYaX = parcelRequire("3ZYaX");



var $3ZYaX = parcelRequire("3ZYaX");


var $31tXu = parcelRequire("31tXu");





/**
 * Form component for creating and editing special periods
 * employerId is required and comes from the context (no employer selection field)
 * existingTypes provides suggestions for custom type values
 */ const $8aad66f7074a76b5$var$SpecialPeriodForm = ({ specialPeriod: specialPeriod, employerId: employerId, existingTypes: existingTypes = [], onSuccess: onSuccess })=>{
    const createMutation = (0, $f61e9610046189fb$export$a25726670bb41cb)();
    const updateMutation = (0, $f61e9610046189fb$export$cac0b33e6f13c8ec)();
    const handleSuccess = ()=>{
        if (onSuccess) onSuccess();
    };
    // Convert date from API (ISO string or Date) to HTML date input format (YYYY-MM-DD)
    const getInitialDate = (date)=>{
        if (!date) return '';
        const dateObj = typeof date === 'string' ? new Date(date) : date;
        return (0, $74f17ceb9b5a08a5$export$97b9b3427470347a)(dateObj);
    };
    // Convert HTML date input value to ISO 8601 string for API
    const dateInputToISO = (dateInput)=>{
        if (!dateInput) return '';
        const date = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(dateInput);
        return (0, $74f17ceb9b5a08a5$export$fb9f91b434a357bf)(date);
    };
    // Convert existing types to autocomplete items, including "Jour férié"
    const typeSuggestions = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        const allTypes = new Set();
        // Add all existing types
        existingTypes.forEach((type)=>{
            if (type) allTypes.add(type);
        });
        return Array.from(allTypes).map((type)=>({
                value: type,
                label: type
            }));
    }, [
        existingTypes
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Formik), {
        initialValues: {
            type: specialPeriod?.type || '',
            name: specialPeriod?.name || '',
            startDate: getInitialDate(specialPeriod?.startDate),
            endDate: getInitialDate(specialPeriod?.endDate)
        },
        enableReinitialize: true,
        validate: (values)=>{
            const errors = {};
            // Type validation
            if (!values.type) errors.type = 'Le type est requis';
            else if (values.type.length < 1 || values.type.length > 255) errors.type = "Le type doit contenir entre 1 et 255 caract\xe8res";
            // Name validation
            if (!values.name) errors.name = 'Le nom est requis';
            else if (values.name.length < 1 || values.name.length > 255) errors.name = "Le nom doit contenir entre 1 et 255 caract\xe8res";
            // Start date validation
            if (!values.startDate) errors.startDate = "La date de d\xe9but est requise";
            // End date validation
            if (!values.endDate) errors.endDate = 'La date de fin est requise';
            // Date range validation
            if (values.startDate && values.endDate) {
                const startDate = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.startDate);
                const endDate = (0, $74f17ceb9b5a08a5$export$7331dca2d8430ff9)(values.endDate);
                if (startDate > endDate) errors.endDate = "La date de d\xe9but doit \xeatre ant\xe9rieure ou \xe9gale \xe0 la date de fin";
            }
            return errors;
        },
        onSubmit: (values)=>{
            const payload = {
                employer: employerId,
                type: values.type,
                name: values.name,
                startDate: dateInputToISO(values.startDate),
                endDate: dateInputToISO(values.endDate)
            };
            if (specialPeriod) updateMutation.mutate({
                id: specialPeriod._id,
                ...payload
            }, {
                onSuccess: handleSuccess
            });
            else createMutation.mutate(payload, {
                onSuccess: handleSuccess
            });
        },
        children: ()=>{
            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $31tXu.Form), {
                autoComplete: "off",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Nom",
                        name: "name",
                        component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                        placeholder: "Ex: No\xebl, Fermeture ao\xfbt, Jour de l'an...",
                        required: true
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                        label: "Type",
                        name: "type",
                        component: (0, $12289d5dc80d8270$export$2e2bcd8739ae039),
                        items: typeSuggestions,
                        placeholder: "Ex: Jour f\xe9ri\xe9, Fermeture estivale, Journ\xe9e sp\xe9ciale...",
                        required: true,
                        type: "text"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Date de d\xe9but",
                                    name: "startDate",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    type: "date",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                size: 6,
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $31tXu.Field), {
                                    label: "Date de fin",
                                    name: "endDate",
                                    component: (0, $d612776067feeeac$export$2e2bcd8739ae039),
                                    type: "date",
                                    required: true
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$b24c9e445714b301), {
                        color: "primary",
                        type: "submit",
                        mutation: specialPeriod ? updateMutation : createMutation,
                        "data-test": "save-special-period",
                        children: specialPeriod ? "Mettre \xe0 jour la p\xe9riode sp\xe9ciale" : "Cr\xe9er une p\xe9riode sp\xe9ciale"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d1bed00ffa1df582$export$aa069c2f85e0ca51), {
                        mutation: specialPeriod ? updateMutation : createMutation
                    })
                ]
            });
        }
    });
};
var $8aad66f7074a76b5$export$2e2bcd8739ae039 = $8aad66f7074a76b5$var$SpecialPeriodForm;



/**
 * Modal wrapper for the special period form
 * Automatically closes the modal on successful create/update
 */ const $658b3afadcbbf0db$var$SpecialPeriodModalForm = ({ isDisplayed: isDisplayed, setIsDisplayed: setIsDisplayed, specialPeriod: specialPeriod, employerId: employerId, existingTypes: existingTypes })=>{
    const createMutation = (0, $f61e9610046189fb$export$a25726670bb41cb)();
    const updateMutation = (0, $f61e9610046189fb$export$cac0b33e6f13c8ec)();
    const currentMutation = specialPeriod ? updateMutation : createMutation;
    // Close modal on successful mutation
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (currentMutation.isSuccess && isDisplayed) {
            setIsDisplayed(false);
            // Reset mutation state
            currentMutation.reset();
        }
    }, [
        currentMutation.isSuccess,
        isDisplayed,
        setIsDisplayed,
        currentMutation
    ]);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6d829f16d3c4ab1d$export$2e2bcd8739ae039), {
        actions: {
            isDisplayed: isDisplayed,
            setIsDisplayed: setIsDisplayed
        },
        title: specialPeriod ? "Modifier une p\xe9riode sp\xe9ciale" : "Cr\xe9er une p\xe9riode sp\xe9ciale",
        dataTest: "special-period-modal",
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8aad66f7074a76b5$export$2e2bcd8739ae039), {
            specialPeriod: specialPeriod,
            employerId: employerId,
            existingTypes: existingTypes,
            onSuccess: ()=>{
                setIsDisplayed(false);
            }
        })
    });
};
var $658b3afadcbbf0db$export$2e2bcd8739ae039 = $658b3afadcbbf0db$var$SpecialPeriodModalForm;






/**
 * Component for managing special periods for a specific employer
 * Only accessible to superAdmin
 * Uses the employer from the outlet context (no filters, no employer selection)
 */ const $f6c7708134c5b82d$var$SpecialPeriodsSettings = ()=>{
    const { employer: employer } = (0, $39b0bf07af9c8a3f$export$4138103a3ae699cc)();
    const isSuperAdmin = (0, $8403deec6a28521e$export$6025088343704f9f)([
        'superAdmin'
    ]);
    // Query special periods for the current employer
    const { data: allSpecialPeriods, isLoading: isLoading } = (0, $f61e9610046189fb$export$d42b482b9d053a4)({
        employer: employer?._id
    }, {
        enabled: Boolean(employer)
    });
    // Year filter state (default to current year)
    const currentYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(currentYear);
    // Extract available years from special periods
    const availableYears = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!allSpecialPeriods) return [];
        const years = new Set();
        allSpecialPeriods.forEach((period)=>{
            const startDate = typeof period.startDate === 'string' ? new Date(period.startDate) : period.startDate;
            const endDate = typeof period.endDate === 'string' ? new Date(period.endDate) : period.endDate;
            years.add(startDate.getFullYear());
            years.add(endDate.getFullYear());
        });
        return Array.from(years).sort((a, b)=>b - a) // Sort descending (most recent first)
        ;
    }, [
        allSpecialPeriods
    ]);
    // Extract existing custom types for autocomplete suggestions
    const existingTypes = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!allSpecialPeriods) return [];
        return allSpecialPeriods.map((period)=>period.type).filter((type)=>Boolean(type));
    }, [
        allSpecialPeriods
    ]);
    // Filter and sort special periods by selected year (sorted by start date, oldest first)
    const specialPeriods = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>{
        if (!allSpecialPeriods) return [];
        let filtered = allSpecialPeriods;
        if (selectedYear !== null) filtered = allSpecialPeriods.filter((period)=>{
            const startDate = typeof period.startDate === 'string' ? new Date(period.startDate) : period.startDate;
            const endDate = typeof period.endDate === 'string' ? new Date(period.endDate) : period.endDate;
            return startDate.getFullYear() === selectedYear || endDate.getFullYear() === selectedYear;
        });
        // Sort by start date (oldest first)
        return [
            ...filtered
        ].sort((a, b)=>{
            const startDateA = typeof a.startDate === 'string' ? new Date(a.startDate).getTime() : a.startDate.getTime();
            const startDateB = typeof b.startDate === 'string' ? new Date(b.startDate).getTime() : b.startDate.getTime();
            return startDateA - startDateB;
        });
    }, [
        allSpecialPeriods,
        selectedYear
    ]);
    const [currentSpecialPeriod, setCurrentSpecialPeriod] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b3d69f70afbcca0d$export$2e2bcd8739ae039), {
                title: "P\xe9riodes Sp\xe9ciales",
                onButtonClick: isSuperAdmin ? ()=>setCurrentSpecialPeriod('new') : undefined,
                addButtonLabel: "Cr\xe9er une p\xe9riode sp\xe9ciale",
                buttonDataTestId: "new-special-period",
                ButtonIcon: (0, $e0de785befddd5e2$export$e718407ce256549d)
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Box), {
                children: [
                    !isLoading && availableYears.length > 0 && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        mb: 4,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Field, {
                            children: [
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Form).Label, {
                                    children: "Ann\xe9e"
                                }),
                                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Form).Select, {
                                    value: selectedYear || '',
                                    onChange: (e)=>{
                                        const year = e.target.value ? parseInt(e.target.value, 10) : null;
                                        setSelectedYear(year);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                            value: "",
                                            children: "Toutes les ann\xe9es"
                                        }),
                                        availableYears.map((year)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("option", {
                                                value: year,
                                                children: year
                                            }, year))
                                    ]
                                })
                            ]
                        })
                    }),
                    isLoading ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: "Chargement..."
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $da9d087afde4311b$export$2e2bcd8739ae039), {
                        specialPeriods: specialPeriods || [],
                        onPeriodClick: (period)=>setCurrentSpecialPeriod(period)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $658b3afadcbbf0db$export$2e2bcd8739ae039), {
                isDisplayed: Boolean(currentSpecialPeriod),
                setIsDisplayed: ()=>setCurrentSpecialPeriod(undefined),
                specialPeriod: currentSpecialPeriod === 'new' ? undefined : currentSpecialPeriod,
                employerId: employer?._id,
                existingTypes: existingTypes
            })
        ]
    });
};
var $f6c7708134c5b82d$export$2e2bcd8739ae039 = $f6c7708134c5b82d$var$SpecialPeriodsSettings;



parcelRequire("3ZYaX");


var $363d00eaf6c013fb$export$2e2bcd8739ae039 = '<h1 id="quoi-de-neuf-teamtim-">Quoi de neuf TeamTim ?</h1>\n<p>Ce document reprend de fa\xe7on chronologique les mises \xe0 jour r\xe9centes de la plateforme TeamTim</p>\n<h2 id="25-mars-2026">25 Mars 2026</h2>\n<h5 id="r\xe8gles-employeur">R\xe8gles employeur</h5>\n<ul>\n<li>Les formules de calcul des r\xe8gles employeur peuvent d\xe9sormais cibler des \xe9v\xe9nements sp\xe9cifiques. Cela permet, par exemple, de ne comptabiliser une dur\xe9e (prestation, absence\u2026) que sur les jours associ\xe9s \xe0 un \xe9v\xe9nement donn\xe9.</li>\n<li>La liste des \xe9v\xe9nements affiche d\xe9sormais une colonne R\xe8gles employeur indiquant quelles r\xe8gles r\xe9f\xe9rencent chaque \xe9v\xe9nement.</li>\n</ul>\n<hr>\n<h2 id="20-mars-2026">20 Mars 2026</h2>\n<h5 id="missions-internes-\xe0-partir-dun-horaire-type-planning-r\xe9current">Missions internes \xe0 partir d&#39;un horaire type (planning r\xe9current)</h5>\n<ul>\n<li>Cr\xe9ation de missions internes \xe0 partir d&#39;un horaire type qui se r\xe9p\xe8te semaine apr\xe8s semaine, sans saisir chaque journ\xe9e \xe0 la main.</li>\n<li>Possibilit\xe9 de d\xe9finir une date de fin (mission \xe0 dur\xe9e d\xe9termin\xe9e) ou de laisser la mission sans date de fin (mission sans \xe9ch\xe9ance).</li>\n<li>Les journ\xe9es de travail \xe0 venir sont g\xe9n\xe9r\xe9es automatiquement \xe0 partir du masque hebdomadaire </li>\n<li>Vous pouvez toujours saisir les horaires manuellement jour par jour si vous pr\xe9f\xe9rez (limit\xe9 \xe0 1 an).</li>\n</ul>\n<hr>\n<h2 id="10-mars-2026">10 Mars 2026</h2>\n<h5 id="jours-f\xe9ri\xe9s-et-p\xe9riodes-sp\xe9cifiques">Jours f\xe9ri\xe9s et p\xe9riodes sp\xe9cifiques</h5>\n<ul>\n<li>Param\xe9trage des p\xe9riodes sp\xe9cifiques (jours f\xe9ri\xe9s, fermetures exceptionnelles, etc.) par EU</li>\n<li>Les jours f\xe9ri\xe9s fran\xe7ais sont pr\xe9-remplis par d\xe9faut ; possibilit\xe9 d&#39;ajouter des p\xe9riodes personnalis\xe9es</li>\n<li>Affichage des p\xe9riodes sp\xe9cifiques dans le r\xe9capitulatif : le nom des jours concern\xe9s appara\xeet dans l&#39;en-t\xeate de colonne de chaque jour (ex. \xab Lundi (1er janvier) \xbb)</li>\n</ul>\n<h5 id="r\xe8gles-employeur-1">R\xe8gles employeur</h5>\n<ul>\n<li>Les totaux du r\xe9capitulatif peuvent d\xe9sormais inclure certaines dur\xe9es selon la configuration des r\xe8gles (g\xe9r\xe9e par votre ETT). Les r\xe8gles peuvent aussi \xeatre limit\xe9es aux jours f\xe9ri\xe9s ou autres p\xe9riodes sp\xe9cifiques.</li>\n</ul>\n<hr>\n<h2 id="05-mars-2026">05 Mars 2026</h2>\n<ul>\n<li>Correction d\u2019un bug qui emp\xeachait l\u2019affichage de tous les int\xe9rimaires disponibles lors de l\u2019assignation \xe0 une demande.</li>\n</ul>\n<hr>\n<h2 id="25-f\xe9vrier-2026">25 F\xe9vrier 2026</h2>\n<h5 id="vue-paie">Vue Paie</h5>\n<ul>\n<li>Correction des tooltips tronqu\xe9s dans le tableau des semaines</li>\n</ul>\n<hr>\n<h2 id="29-janvier-2026">29 Janvier 2026</h2>\n<ul>\n<li>Am\xe9lioration du formulaire d&#39;ajout d&#39;\xe9v\xe9nements de date \xe0 date pour les journ\xe9es de travail</li>\n<li>Correction d&#39;un bug qui perturbait l&#39;ajout ou la modification d&#39;adresse dans les param\xe8tres d&#39;une EU</li>\n</ul>\n<hr>\n<h2 id="28-janvier-2026">28 Janvier 2026</h2>\n<h5 id="vue-paie-1">Vue Paie</h5>\n<ul>\n<li>Inversion de l&#39;ordre d&#39;affichage : heures d\xe9cimales en haut (en gras), heures au format HH:MM en bas</li>\n<li>Correction du tri de la liste des salari\xe9</li>\n<li>Renommage de la colonne \xab \xc9cart \xbb en \xab A d\xe9duire \xbb avec affichage uniquement des heures manquantes par rapport au contrat</li>\n</ul>\n<hr>\n<h2 id="26-janvier-2026">26 Janvier 2026</h2>\n<h5 id="demande-dint\xe9rimaires">Demande d&#39;int\xe9rimaires</h5>\n<ul>\n<li>L&#39;EU peut ajouter des cat\xe9gories aux postes d&#39;une demande d&#39;int\xe9rimaires</li>\n<li>L&#39;ETT a acc\xe8s aux cat\xe9gories sur les missions, journ\xe9es de travail et le r\xe9capitulatif</li>\n</ul>\n<hr>\n<h2 id="13-janvier-2026">13 Janvier 2026</h2>\n<h5 id="qr-code">Qr Code</h5>\n<ul>\n<li>Correction d&#39;un bug qui emp\xeachait d&#39;imprimer le QR code d&#39;un salari\xe9</li>\n</ul>\n<hr>\n<h2 id="8-janvier-2026">8 Janvier 2026</h2>\n<h5 id="application-mobile">Application mobile</h5>\n<ul>\n<li>Correction d&#39;un bug qui emp\xeachait de consulter la liste des notifications dans l&#39;application mobile</li>\n</ul>\n<hr>\n<h2 id="18-d\xe9cembre-2025">18 D\xe9cembre 2025</h2>\n<h5 id="r\xe8gle-de-pointage">R\xe8gle de pointage</h5>\n<ul>\n<li>Ajout d&#39;une option &quot;Fen\xeatre de pointage&quot; sur les r\xe8gles de pointage qui d\xe9termine \xe0 quel point un pointage peut \xeatre effectu\xe9 avant le d\xe9but ou apr\xe8s la fin de la journ\xe9e de travail th\xe9orique.</li>\n</ul>\n<h5 id="r\xe9capitulatif">R\xe9capitulatif</h5>\n<ul>\n<li>Ajout de la colonne \xab Travaill\xe9 \xbb dans les totaux du r\xe9capitulatif.</li>\n</ul>\n<hr>\n<h2 id="16-d\xe9cembre-2025">16 D\xe9cembre 2025</h2>\n<h5 id="r\xe8gles-employeur-2">R\xe8gles employeur</h5>\n<ul>\n<li>Possibilit\xe9 de limiter la p\xe9riode prise en compte par une r\xe8gle afin de l\u2019appliquer uniquement \xe0 certains jours de la semaine</li>\n</ul>\n<hr>\n<h2 id="26-novembre-2025">26 Novembre 2025</h2>\n<h5 id="horaires-contractuels-pour-les-salari\xe9s">Horaires contractuels pour les salari\xe9s</h5>\n<ul>\n<li>Possibilit\xe9 d&#39;ajouter les horaires contractuels aux salari\xe9s</li>\n<li>Utilisation de la dur\xe9e d\xe9finie dans le contrat afin de d\xe9terminer combien d&#39;heures doivent \xeatre comptabilis\xe9es pour une journ\xe9e de travail avec un \xe9v\xe9nement de type prestation</li>\n<li>Si l&#39;horaire n&#39;est pas configur\xe9, la dur\xe9e th\xe9orique de la journ\xe9e de travail est utilis\xe9e pour le calcul des journ\xe9es de travail avec \xe9v\xe9nements de type prestation</li>\n</ul>\n<hr>\n<h2 id="18-novembre-2025">18 Novembre 2025</h2>\n<h5 id="r\xe9capitulatif-1">R\xe9capitulatif</h5>\n<ul>\n<li>L&#39;export de date \xe0 date fonctionne d\xe9sormais sans la limitation aux semaines compl\xe8tes</li>\n</ul>\n<h5 id="liste-des-missions">Liste des missions</h5>\n<ul>\n<li>Am\xe9lioration de la vitesse de chargement de la liste des missions</li>\n</ul>\n<hr>\n<h2 id="10-novembre-2025">10 Novembre 2025</h2>\n<h5 id="vue-paie-2">Vue Paie</h5>\n<ul>\n<li>Suppression de colonnes inutiles pour faciliter la compr\xe9hension de l&#39;affichage</li>\n<li>Possibilit\xe9 de voir les jours concern\xe9s par les \xe9v\xe9nements prestations en survolant le total</li>\n<li>Correction d&#39;un bug o\xf9 le total &quot;\xc9cart&quot; n&#39;\xe9tait pas toujours correct</li>\n<li>Les \xe9carts sont affich\xe9s de fa\xe7on plus visible gr\xe2ce \xe0 un code couleur</li>\n</ul>\n<h5 id="d\xe9tails-journ\xe9e-de-travail">D\xe9tails journ\xe9e de travail</h5>\n<ul>\n<li>Pour all\xe9ger la page, les r\xe8gles de pointage sont masqu\xe9es par d\xe9faut</li>\n</ul>\n<h5 id="gestion-\xe9v\xe9nements">Gestion \xe9v\xe9nements</h5>\n<ul>\n<li>Les \xe9v\xe9nements ne peuvent plus \xeatre directement modifi\xe9s par les EU afin d&#39;\xe9viter des manipulations erron\xe9es qui affecteraient les co\xfbts.</li>\n<li>Correction du texte explicatif</li>\n</ul>\n<h5 id="r\xe9capitulatif-2">R\xe9capitulatif</h5>\n<ul>\n<li>Correction d&#39;un bug avec les absences et pr\xe9sences dans le filtre \xc9v\xe9nements</li>\n</ul>\n<hr>\n<h2 id="04-novembre-2025">04 Novembre 2025</h2>\n<h5 id="cat\xe9gorisation-des-journ\xe9es-de-travail">Cat\xe9gorisation des journ\xe9es de travail</h5>\n<ul>\n<li>Les cat\xe9gories peuvent <ul>\n<li>\xeatre ajout\xe9es de date \xe0 date pour les journ\xe9es de travail non valid\xe9es pour une m\xeame mission</li>\n<li>\xeatre ajout\xe9es lors de la cr\xe9ation d&#39;une mission d&#39;un salari\xe9 et seront appliqu\xe9es \xe0 toutes les journ\xe9es de la mission</li>\n<li>\xeatre cr\xe9\xe9es directement depuis la page journ\xe9es de travail ou cr\xe9ation de mission</li>\n</ul>\n</li>\n<li>Les administrateurs des EU peuvent g\xe9rer les cat\xe9gories dans la section des param\xe8tres</li>\n<li>Les cat\xe9gories sont visibles dans le r\xe9capitulatif et dans l&#39;export</li>\n</ul>\n<hr>\n<h2 id="03-novembre-2025">03 Novembre 2025</h2>\n<ul>\n<li>Modification du tri de la liste des journ\xe9es de travail</li>\n<li>Correction d&#39;un bug o\xf9 certains mails concernant les demandes d&#39;int\xe9rimaires \xe9taient envoy\xe9s aux profils &quot;Pointeur uniquement&quot;</li>\n<li>Affichage du total lors de la simulation d&#39;une pr\xe9facturation \xe0 3 chiffres apr\xe8s la virgule</li>\n</ul>\n<hr>\n<h2 id="28-octobre-2025">28 Octobre 2025</h2>\n<h5 id="r\xe8gles-employeur-3">R\xe8gles employeur</h5>\n<ul>\n<li>Ajout de la possibilit\xe9 d&#39;utiliser les heures du contrat pour calculer les r\xe8gles employeurs</li>\n</ul>\n<hr>\n<h2 id="21-octobre-2025">21 Octobre 2025</h2>\n<h5 id="vue-int\xe9rimaire--salari\xe9">Vue Int\xe9rimaire / Salari\xe9</h5>\n<ul>\n<li>Correction d&#39;un bug o\xf9 les donn\xe9es n&#39;\xe9taient pas rafra\xeechies apr\xe8s mise \xe0 jour</li>\n</ul>\n<h5 id="vue-paie-3">Vue Paie</h5>\n<ul>\n<li>Correction d&#39;un bug o\xf9 les heures pour les journ\xe9es avec \xe9v\xe8nement prestation n&#39;\xe9taient pas correctement affich\xe9es</li>\n<li>Am\xe9lioration de l&#39;affichage</li>\n</ul>\n<hr>\n<h2 id="14-octobre-2025">14 Octobre 2025</h2>\n<h5 id="vue-paie-4">Vue Paie</h5>\n<ul>\n<li>Liste des salari\xe9s avec une visibilit\xe9 claire du statut par rapport \xe0 la p\xe9riode s\xe9lectionn\xe9e (journ\xe9es de travail \xe0 valider, p\xe9riode cl\xf4turable, p\xe9riode cl\xf4tur\xe9e)</li>\n<li>Ajout de filtres pour la liste des salari\xe9s</li>\n<li>Affichage des semaines sous forme de tableau, permettant une visualisation plus simple, surtout pour de longues p\xe9riodes</li>\n</ul>\n<h5 id="interface">Interface</h5>\n<ul>\n<li>Correction du tri par nom de famille pour les listes d&#39;int\xe9rimaires et de salari\xe9s</li>\n<li>Corrections de textes  </li>\n<li>Correction d&#39;un bug d&#39;affichage des co\xfbts d&#39;abonnement</li>\n</ul>\n<hr>\n<h2 id="29-septembre-2025">29 Septembre 2025</h2>\n<h5 id="textes-et-d\xe9nominations">Textes et d\xe9nominations</h5>\n<ul>\n<li>Le terme &quot;Intitul\xe9 de poste&quot; devient &quot;M\xe9tier&quot;</li>\n<li>Le terme &quot;Service&quot; devient &quot;Affectation&quot;</li>\n<li>Corrections d&#39;autres textes pour plus de clart\xe9</li>\n</ul>\n<h5 id="financier">Financier</h5>\n<ul>\n<li>Tous les co\xfbts sont d\xe9sormais affich\xe9s avec trois chiffres apr\xe8s la virgule</li>\n</ul>\n<h5 id="r\xe9capitulatif-3">R\xe9capitulatif</h5>\n<ul>\n<li>Les pointages absents ET en retard selon la r\xe8gle de pointage sont affich\xe9s en orange</li>\n</ul>\n<hr>\n<h2 id="23-septembre-2025">23 Septembre 2025</h2>\n<h5 id="demandes-dint\xe9rimaires---am\xe9liorations">Demandes d&#39;int\xe9rimaires - Am\xe9liorations</h5>\n<ul>\n<li>Les historiques de changements dans les Demandes d&#39;Int\xe9rimaires sont plus complets </li>\n<li>Les intervenants sur une Demande sont identifi\xe9s</li>\n</ul>\n<h5 id="correction--am\xe9liorations-des-pointages-forc\xe9s">Correction &amp; Am\xe9liorations des pointages forc\xe9s</h5>\n<ul>\n<li>Correction d&#39;un bug qui attribuait de fa\xe7on incorrecte l&#39;heure du pointage forc\xe9</li>\n<li>Am\xe9lioration de la gestion des pointages forc\xe9s sur les journ\xe9es de travail chevauchant deux jours</li>\n<li>Affichage et modification plus pr\xe9cis du pointage forc\xe9</li>\n</ul>\n<hr>\n<h2 id="16-septembre-2025">16 Septembre 2025</h2>\n<h5 id="vue-paie-et-compteurs">Vue Paie et compteurs</h5>\n<ul>\n<li>Gestion des compteurs directement lors de la cl\xf4ture d&#39;une semaine<ul>\n<li>Des heures peuvent \xeatre prises dans le compteur et consid\xe9r\xe9es comme pay\xe9es dans la semaine</li>\n<li>Des heures peuvent \xeatre partiellement ou totalement envoy\xe9es vers les compteurs</li>\n</ul>\n</li>\n</ul>\n<hr>\n<h2 id="4-septembre-2025">4 septembre 2025</h2>\n<ul>\n<li>Correction d&#39;un bug qui emp\xeachait de modifier le r\xf4le d&#39;un gestionnaire d&#39;une EU</li>\n</ul>\n<hr>\n<h2 id="20-ao\xfbt-2025">20 Ao\xfbt 2025</h2>\n<ul>\n<li>Correction d&#39;un bug o\xf9 le bouton &quot;Abandon&quot; restait activ\xe9 sur la page d&#39;une journ\xe9e de travail interrompue<ul>\n<li>Il n&#39;est pas possible de mettre en abandon de poste une mission d\xe9j\xe0 interrompue</li>\n</ul>\n</li>\n<li>Affichage des colonnes &quot;Mission interrompue&quot; et &quot;Mission abandonn\xe9e&quot; dans le r\xe9capitulatif m\xeame en mode compact</li>\n</ul>\n<hr>\n<h2 id="19-ao\xfbt-2025">19 Ao\xfbt 2025</h2>\n<h5 id="vue-paie-et-compteurs-1">Vue Paie et compteurs</h5>\n<ul>\n<li>Les compteurs comptabilisent les heures li\xe9es aux r\xe8gles sp\xe9cifiques de l&#39;EU pour un salari\xe9 (ex: compteurs des heures suppl\xe9mentaires)<ul>\n<li>Lorsqu&#39;une semaine est valid\xe9e les compteurs sont incr\xe9ment\xe9s</li>\n<li>Des modifications manuelles peuvent \xeatre appliqu\xe9es aux compteurs</li>\n<li>Un historique complet est enregistr\xe9 pour chaque compteur</li>\n</ul>\n</li>\n<li>Les semaines dans la vue paie (bi parti) peuvent maintenant \xeatre valid\xe9es<ul>\n<li>Les journ\xe9es de travail faisant partie d&#39;une semaine valid\xe9e ne peuvent plus \xeatre d\xe9valid\xe9es et donc modifi\xe9es.</li>\n<li>Les compteurs sont incr\xe9ment\xe9s</li>\n</ul>\n</li>\n</ul>\n<hr>\n<h2 id="14-ao\xfbt-2025">14 Ao\xfbt 2025</h2>\n<h5 id="demandes-dint\xe9rimaires---am\xe9liorations-1">Demandes d&#39;int\xe9rimaires - Am\xe9liorations</h5>\n<ul>\n<li>Ajout de la possibilit\xe9 d&#39;attribuer des int\xe9rimaires \xe0 plusieurs postes simultan\xe9ment</li>\n<li>Ajout de suggestions d&#39;int\xe9rimaires ayant d\xe9j\xe0 effectu\xe9 une mission similaire au poste</li>\n</ul>\n<hr>\n<h2 id="11-ao\xfbt-2025">11 Ao\xfbt 2025</h2>\n<ul>\n<li>Correction d&#39;un bug o\xf9 des emails \xe9taient envoy\xe9 \xe0 de mauvais profils pour les membres des EU</li>\n</ul>\n<hr>\n<h2 id="3-juillet-2025">3 Juillet 2025</h2>\n<ul>\n<li>Correction d&#39;un bug permettant de cr\xe9er une Journ\xe9e de Travail en double pour un m\xeame travailleur</li>\n</ul>\n<hr>\n<h2 id="25-juin-2025">25 Juin 2025</h2>\n<ul>\n<li>Correction du formatage des heures d\xe9cimales pour certains champs des exports Excel et CSV</li>\n</ul>\n<hr>\n<h2 id="20-juin-2025">20 Juin 2025</h2>\n<ul>\n<li>Correction du comportement de certains champs de formulaires : l&#39;utilisation de la touche Entr\xe9e ne soumet plus automatiquement les formulaires</li>\n</ul>\n<h5 id="interruption-de-collaboration-avec-un-travailleur">Interruption de collaboration avec un travailleur</h5>\n<ul>\n<li>Lorsqu&#39;un int\xe9rimaire interrompt sa collaboration avec son ETT, les membres de l&#39;ETT sont notifi\xe9s par email</li>\n<li>Lorsqu&#39;un salari\xe9 interrompt sa collaboration avec son EU, les membres de l&#39;EU sont notifi\xe9s par email</li>\n<li>Les membres des ETT et EU peuvent, depuis les param\xe8tres de notifications, choisir s&#39;ils souhaitent recevoir cet email</li>\n</ul>\n<h5 id="demandes-de-personnel">Demandes de personnel</h5>\n<ul>\n<li>R\xe9organisation de l&#39;affichage des postes de la demande</li>\n<li>Simplification de la liste</li>\n</ul>\n<h5 id="r\xe9capitulatif-4">R\xe9capitulatif</h5>\n<ul>\n<li>Les travailleurs en retard sont affich\xe9s dans le r\xe9capitulatif via le code couleur orange sur la colonne &quot;D\xe9but\xe9&quot;</li>\n</ul>\n<hr>\n<h2 id="10-juin-2025">10 Juin 2025</h2>\n<h5 id="filtre-poste-pour-les-ett">Filtre &quot;Poste&quot; pour les ETT</h5>\n<ul>\n<li>Ajout du filtre &quot;Poste&quot; dans la liste des missions et dans le r\xe9capitulatif des ETT<ul>\n<li>Ce filtre est utilisable uniquement quand une seule EU est s\xe9lectionn\xe9e dans le filtre &quot;Entreprises Utilisatrices&quot;</li>\n</ul>\n</li>\n</ul>\n<h5 id="gestion-du-service-par-journ\xe9e-de-travail">Gestion du service par journ\xe9e de travail</h5>\n<ul>\n<li>Le service peut maintenant \xeatre modifi\xe9 par journ\xe9e de travail</li>\n<li>Le service assign\xe9 \xe0 la mission reste le service assign\xe9 par d\xe9faut aux journ\xe9es de travail de la mission</li>\n<li>Une mission peut donc contenir des journ\xe9es de travail avec des services diff\xe9rents</li>\n</ul>\n<h5 id="email-lors-dune-modification-de-mission">Email lors d&#39;une modification de mission</h5>\n<ul>\n<li>Contient maintenant le d\xe9tail de la modification effectu\xe9e par l&#39;employeur</li>\n</ul>\n<h5 id="r\xe9capitulatif-5">R\xe9capitulatif</h5>\n<ul>\n<li>Affichage du nom de la personne ayant valid\xe9 au survol du bouton de validation d&#39;une journ\xe9e de travail</li>\n</ul>\n<h5 id="correction-bugs">Correction bugs</h5>\n<ul>\n<li>D\xe9sactivation de l&#39;autocompl\xe9tion du navigateur sur les champs de s\xe9lection avec recherche, afin d&#39;\xe9viter les erreurs de manipulation.</li>\n<li>Lors d&#39;une notification de l&#39;application mobile, le badge de notification ne s&#39;affichait pas toujours sur l&#39;icone de TeamTim.</li>\n</ul>\n<hr>\n<h2 id="4-juin-2025">4 Juin 2025</h2>\n<ul>\n<li>Ajout des co\xfbts totaux des r\xe8gles employeurs dans les pr\xe9facturations et le r\xe9capitulatif pour les ETT</li>\n</ul>\n<hr>\n<h2 id="3-juin-2025">3 Juin 2025</h2>\n<ul>\n<li>Correction d&#39;un bug o\xf9 les r\xe8gles employeurs n&#39;\xe9taient plus visibles dans les pr\xe9facturations pour les ETT</li>\n</ul>\n<h5 id="gestion-des-\xe9v\xe9nements-prestations-pour-les-missions-int\xe9rimaires">Gestion des \xe9v\xe9nements prestations pour les missions int\xe9rimaires</h5>\n<ul>\n<li>Valorisation des journ\xe9es de travail avec \xe9v\xe9nements prestation</li>\n<li>Am\xe9lioration de l&#39;affichage du travail non effectif dans le r\xe9capitulatif</li>\n</ul>\n<hr>\n<h2 id="2-juin-2025">2 Juin 2025</h2>\n<ul>\n<li>Nouveau filtre &quot;\xc9v\xe9nements&quot; pour le r\xe9capitulatif, le dashboard EU et la liste des journ\xe9es de travail</li>\n<li>Il est maintenant possible d&#39;annuler un abandon de poste</li>\n</ul>\n<hr>\n<h2 id="28-mai-2025">28 Mai 2025</h2>\n<ul>\n<li>Lorsqu&#39;un travailleur avec un compte d\xe9j\xe0 actif est invit\xe9 par une EU ou ETT, l&#39;association est automatiquement accept\xe9e. Le travailleur peut toujours contr\xf4ler l&#39;association via les param\xe8tres de son compte</li>\n</ul>\n<hr>\n<h2 id="21-mai-2025">21 Mai 2025</h2>\n<h5 id="am\xe9lioration-du-r\xe9capitulatif">Am\xe9lioration du r\xe9capitulatif</h5>\n<ul>\n<li>Ajout d&#39;un bouton pour valider la semaine compl\xe8te d&#39;un travailleur </li>\n<li>Am\xe9lioration de l&#39;affichage pour les travailleurs ayant plusieurs missions sur la semaine</li>\n<li>Les jours ne contenant pas de journ\xe9es de travail sont affich\xe9s de fa\xe7on r\xe9duite en mode compact</li>\n<li>Ajout d&#39;une colonne avec le co\xfbt horaire</li>\n<li>Le matricule a \xe9t\xe9 ajout\xe9 \xe0 l&#39;export</li>\n</ul>\n<h5 id="travailleurs-et-collaborateurs">Travailleurs et collaborateurs</h5>\n<ul>\n<li>Les travailleurs &amp; collaborateurs sont maintenant affich\xe9s avec le nom de famille avant le pr\xe9nom</li>\n</ul>\n<hr>\n<h2 id="19-mai-2025">19 Mai 2025</h2>\n<ul>\n<li>Correction d&#39;un bug qui emp\xeachait, dans certains cas, de modifier les coefficients de co\xfbt travail temporaires</li>\n</ul>\n<hr>\n<h2 id="30-avril-2025">30 avril 2025</h2>\n<ul>\n<li>Correction d&#39;un bug qui affichait de mauvaises donn\xe9es concernant les collaborations dans l&#39;application mobile</li>\n</ul>\n<hr>\n<h2 id="22-avril-2025">22 Avril 2025</h2>\n<h5 id="gestion-des-co\xfbts-horaires-int\xe9rimaires">Gestion des co\xfbts horaires int\xe9rimaires</h5>\n<ul>\n<li>Les EU peuvent d\xe9sormais contr\xf4ler les co\xfbts horaires des int\xe9rimaires par intitul\xe9 de poste en :<ul>\n<li>imposant l&#39;utilisation du SMIC</li>\n<li>d\xe9finissant un co\xfbt horaire minimum et maximum</li>\n</ul>\n</li>\n<li>Les ETT doivent attribuer le co\xfbt horaire au poste lorsque l&#39;EU a sp\xe9cifi\xe9 de ne pas utiliser le SMIC</li>\n</ul>\n<h5 id="filtres">Filtres</h5>\n<ul>\n<li>Ajout d&#39;un bouton de r\xe9initialisation sur tous les filtres</li>\n</ul>\n<h5 id="intitul\xe9-de-poste-et-services">Intitul\xe9 de poste et services</h5>\n<ul>\n<li>Les EU peuvent d\xe9sormais d\xe9sactiver un intitul\xe9 de poste ou un service</li>\n<li>Les \xe9l\xe9ments d\xe9sactiv\xe9s n&#39;apparaissent plus dans les listes de s\xe9lection lors de la cr\xe9ation ou modification d&#39;une mission ou d&#39;une demande d&#39;int\xe9rimaires</li>\n<li>Il est possible de r\xe9activer un intitul\xe9 de poste ou un service \xe0 tout moment</li>\n</ul>\n<h5 id="r\xe9capitulatif-6">R\xe9capitulatif</h5>\n<ul>\n<li>Les travailleurs sont maintenant affich\xe9s par ordre alphab\xe9tique</li>\n</ul>\n<hr>\n<h2 id="15-avril-2025">15 Avril 2025</h2>\n<ul>\n<li>Les EU peuvent imprimer les QR codes des int\xe9rimaires ayant une mission en cours ou devant d\xe9buter dans les trois prochains jours.</li>\n<li>Les EU peuvent g\xe9rer les collaborations avec les int\xe9rimaires ayant d\xe9j\xe0 effectu\xe9 des missions au sein de leur structure.</li>\n<li>Cr\xe9ation d&#39;une nouvelle page pr\xe9sentant les informations des int\xe9rimaires et salari\xe9s, accessibles aux EU et aux ETT.</li>\n</ul>\n<h5 id="demandes-de-personnel-int\xe9rimaires">Demandes de Personnel Int\xe9rimaires</h5>\n<ul>\n<li>Une ETT peut d\xe9sormais d\xe9clarer qu&#39;un Poste dans une Demande ne sera pas pourvu</li>\n<li>Un Poste ferm\xe9 par une ETT est notifi\xe9 \xe0 l&#39;EU ayant \xe9tabli la Demande</li>\n<li>Une EU, en concertation avec l&#39;ETT, peut d\xe9cider de r\xe9ouvrir ce Poste</li>\n<li>Une EU peut d\xe9sormais Interrompre une Mission sans demander de Rempla\xe7ant et puis r\xe9ouvrir le Poste </li>\n<li>Une Demande est d\xe9sormais Compl\xe8te quand tous les Postes sont pourvus, ou ferm\xe9s par l&#39;ETT</li>\n</ul>\n<hr>\n<h2 id="11-avril-2025">11 Avril 2025</h2>\n<ul>\n<li>Correction d&#39;un bug au compteur de Demandes en Cours ETT ne prenant pas en compte certaines Demandes  </li>\n<li>Am\xe9lioration de la page d&#39;aide pour encourager les utilisateurs de la plateforme \xe0 contacter le support</li>\n<li>Le planning de la vue Tableau de Bord est maintenant filtrable</li>\n</ul>\n<hr>\n<h2 id="10-avril-2025">10 Avril 2025</h2>\n<h5 id="interruption-de-mission">Interruption de Mission</h5>\n<ul>\n<li>Les Journ\xe9es de Travail suivant l&#39;interruption sont d\xe9sormais compl\xe8tement supprim\xe9es</li>\n<li>Une Mission Interrompue avant son d\xe9but ne contient donc plus aucune Journ\xe9e de Travail</li>\n<li>L&#39;historique des Missions d\xe9j\xe0 Interrompues a \xe9t\xe9 nettoy\xe9</li>\n</ul>\n<h5 id="abandon-de-poste">Abandon de Poste</h5>\n<ul>\n<li>Les Journ\xe9es de Travail suivant un Abandon de Poste sont d\xe9sormais compl\xe8tement supprim\xe9es</li>\n<li>L&#39;historique des Missions d\xe9j\xe0 en Abandon de Poste a \xe9t\xe9 nettoy\xe9</li>\n</ul>\n<h5 id="vues-d\xe9tails-de-mission-et-journ\xe9es-de-travail">Vues D\xe9tails de Mission et Journ\xe9es de Travail</h5>\n<ul>\n<li>La vue D\xe9tails de Mission a \xe9t\xe9 actualis\xe9e et offre plus de d\xe9tails</li>\n<li>La vue Journ\xe9es de Travail a \xe9t\xe9 actualis\xe9e et offre plus de d\xe9tails</li>\n</ul>\n<hr>\n<h2 id="24-mars-2025">24 Mars 2025</h2>\n<ul>\n<li>Possibilit\xe9 pour les ETT et EU de visualiser et d&#39;imprimer les QR codes de leurs int\xe9rimaires/salari\xe9s</li>\n</ul>\n<hr>\n<h2 id="21-mars-2025">21 Mars 2025</h2>\n<h5 id="am\xe9lioration-de-la-vue-abonnement">Am\xe9lioration de la vue Abonnement</h5>\n<ul>\n<li>Simplification de l&#39;interface</li>\n<li>Renommage des libell\xe9s pour plus de clart\xe9</li>\n</ul>\n<hr>\n<h2 id="20-mars-2025">20 Mars 2025</h2>\n<ul>\n<li>Renforcement de la validation des interactions utilisateur c\xf4t\xe9 serveur</li>\n</ul>\n<hr>\n<h2 id="19-mars-2025">19 Mars 2025</h2>\n<ul>\n<li>Correction d&#39;un bug pour les E.U. qui ne pouvaient sugg\xe9rer dans leurs Demandes un Int\xe9rimaire n&#39;ayant pas compl\xe9t\xe9 son profil</li>\n</ul>\n<hr>\n<h2 id="21-f\xe9vrier-2025">21 F\xe9vrier 2025</h2>\n<h5 id="adaptations-au-r\xe9capitulatif-pour-les-ett-et-eu">Adaptations au R\xe9capitulatif pour les ETT et EU</h5>\n<ul>\n<li>Les colonnes Semaine Valid\xe9e et Semaine Pr\xe9-factur\xe9e sont maintenant fixes</li>\n<li>L&#39;ic\xf4ne pour les \xe9v\xe9nements de type Prestation est bleue</li>\n<li>Correction d&#39;un bug d&#39;affichage lors de l&#39;utilisation conjointe des filtres Semaine/Jour/Compact</li>\n<li>La section Mission renseigne le nom de l&#39;Employeur pour les EU </li>\n<li>La section Mission renseigne le nom du client pour les ETT</li>\n<li>Les boutons pour les Journ\xe9es de Travail non Validables sont plus discrets</li>\n</ul>\n<h5 id="invitation-des-travailleurs">Invitation des Travailleurs</h5>\n<ul>\n<li>Possibilit\xe9 de modifier l&#39;adresse email des travailleurs n&#39;ayant pas encore activ\xe9 leur compte</li>\n</ul>\n<h5 id="vue-paie-5">Vue Paie</h5>\n<ul>\n<li>Affichage des totaux en format d\xe9cimal dans les tableaux de paie</li>\n</ul>\n<hr>\n<h2 id="20-f\xe9vrier-2025">20 F\xe9vrier 2025</h2>\n<ul>\n<li>Correction d&#39;un bug permettant d&#39;ajouter un \xe9v\xe9nement \xe0 une Journ\xe9e de Travail Valid\xe9e</li>\n<li>Ajustement des couleurs et contrastes de certains \xe9l\xe9ments difficilement lisibles</li>\n</ul>\n<hr>\n<h2 id="18-f\xe9vrier-2025">18 F\xe9vrier 2025</h2>\n<h5 id="filtres-1">Filtres</h5>\n<ul>\n<li>Nouveau filtre Employeur qui regroupe les anciens filtres Type de Contrat et Agence</li>\n<li>Le filtre &quot;Pr\xe9-Factur\xe9&quot; n&#39;est plus sur &quot;Non&quot; par d\xe9faut</li>\n</ul>\n<h5 id="validation-des-journ\xe9es-de-travail">Validation des Journ\xe9es de Travail</h5>\n<ul>\n<li>Une Journ\xe9e de Travail <strong>vide</strong> ne peut plus \xeatre valid\xe9e</li>\n<li>Pour \xeatre Validable une Journ\xe9e de Travail doit :<ul>\n<li>soit avoir un pointage d&#39;entr\xe9e et sortie, manuel ou forc\xe9</li>\n<li>soit avoir un Ev\xe9nement de type Informatif</li>\n<li>soit avoir un Ev\xe9nement de type Prestation</li>\n<li>soit \xeatre Interrompue</li>\n<li>soit \xeatre en Abandon de Poste</li>\n</ul>\n</li>\n</ul>\n<hr>\n<h2 id="14-f\xe9vrier-2025">14 F\xe9vrier 2025</h2>\n<h5 id="adaptations-au-r\xe9capitulatif-pour-les-ett-et-eu-1">Adaptations au R\xe9capitulatif pour les ETT et EU</h5>\n<ul>\n<li>En Mode Compact plusieurs missions d&#39;une m\xeame personne peuvent \xeatre compact\xe9es sur une m\xeame ligne</li>\n<li>D\xe9sactiver le Mode Compact affiche le d\xe9tail des missions, une par ligne </li>\n<li>Valider une Journ\xe9e de Travail n&#39;exige plus de double confirmation</li>\n<li>L&#39;indicateur de statut Semaine Valid\xe9e est plus visible</li>\n<li>L&#39;indicateur de statut Semaine Pr\xe9factur\xe9e est plus visible</li>\n<li>Le bouton pour d\xe9valider une Journ\xe9e de Travail est plus discret</li>\n<li>Suppression du raccourci pour Interrompre une Mission</li>\n<li>Suppression du raccourci pour Valider une Semaine</li>\n<li>Filtrer par Journ\xe9e n&#39;affiche plus de lignes vides</li>\n</ul>\n<hr>\n<h2 id="13-f\xe9vrier-2025">13 F\xe9vrier 2025</h2>\n<ul>\n<li>Correction d&#39;un bug li\xe9 \xe0 l&#39;application r\xe9tro-active de R\xe8gles de Pointages sur des Journ\xe9es de Travail existantes</li>\n</ul>\n<hr>\n<h2 id="11-f\xe9vrier-2025">11 F\xe9vrier 2025</h2>\n<ul>\n<li>Une EU peut maintenant configurer ses Services via les Param\xe8tres</li>\n</ul>\n<hr>\n<h2 id="10-f\xe9vrier-2025">10 F\xe9vrier 2025</h2>\n<ul>\n<li>Am\xe9lioration du filtre permettant d&#39;afficher les Demandes d&#39;Int\xe9rimaires expir\xe9es</li>\n</ul>\n<hr>\n<h2 id="7-f\xe9vrier-2025">7 F\xe9vrier 2025</h2>\n<ul>\n<li>Correction d&#39;un bug d&#39;affichage sur des ordinateurs utilisant le mode sombre par d\xe9faut</li>\n<li>Correction d&#39;un bug li\xe9 au param\xe9trage des heures de jour et de nuit pour les EU</li>\n<li>Correction d&#39;un bug d&#39;affichage de l&#39;indicateur de statut de validation d&#39;une Journ\xe9e de Travail</li>\n</ul>\n<hr>\n<h2 id="5-f\xe9vrier-2025">5 F\xe9vrier 2025</h2>\n<ul>\n<li>Les bornes de scan se mettent \xe0 jour de fa\xe7on automatique sans validation</li>\n<li>Correction d&#39;un bug emp\xeachant l&#39;envoi de Demandes impliquant des Int\xe9rimaires n&#39;ayant pas compl\xe9t\xe9 leur profil</li>\n</ul>\n<hr>\n';


const $1ed8238d8466ee53$export$6db44f1e04c7ab18 = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            size: "medium",
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: 'desktop',
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("div", {
                    className: "content",
                    dangerouslySetInnerHTML: {
                        __html: (0, $363d00eaf6c013fb$export$2e2bcd8739ae039)
                    }
                })
            })
        })
    });
};




var $3ZYaX = parcelRequire("3ZYaX");
















var $3ZYaX = parcelRequire("3ZYaX");











parcelRequire("3ZYaX");

const $21fbc4cf82aea7d6$var$RoleStatusDescription = ({ role: role })=>{
    const getDescription = ()=>{
        switch(role.status){
            case 'accepted':
                return "Vous collaborez avec ce travailleur. Des missions peuvent lui \xeatre affect\xe9es.";
            case 'pending':
                return "Vous avez invit\xe9 ce travailleur \xe0 collaborer, mais il n'a pas encore r\xe9pondu \xe0 votre invitation. Cependant, des missions peuvent lui \xeatre affect\xe9es.";
            case 'rejected':
                return "Vous avez invit\xe9 ce travailleur \xe0 collaborer, mais il a refus\xe9 votre invitation. Il ne peut plus \xeatre affect\xe9 \xe0 des missions.";
            case 'discontinued':
                return "Vous avez interrompu la collaboration avec ce travailleur. Il ne peut plus \xeatre affect\xe9 \xe0 des missions.";
            default:
                return '';
        }
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
        renderAs: "p",
        mb: 3,
        children: getDescription()
    });
};
var $21fbc4cf82aea7d6$export$2e2bcd8739ae039 = $21fbc4cf82aea7d6$var$RoleStatusDescription;




parcelRequire("3ZYaX");





const $ffe29775123abb75$var$ActiveEmployerCollaborationButton = ({ user: user, isInactive: isInactive, label: label, color: color = isInactive ? 'primary' : 'danger' })=>{
    const employerCollaborationModal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const setEmployerCollaborationMutation = (0, $e607e015ac40917d$export$99d9b782d7ff82db)();
    const handleActiveEmployerCollaborationToggle = async ()=>{
        if (!user) return;
        await setEmployerCollaborationMutation.mutateAsync({
            workerId: user._id,
            isInactive: !isInactive
        });
        employerCollaborationModal.setIsDisplayed(false);
    };
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                color: color,
                textColor: "white",
                size: "small",
                onClick: ()=>employerCollaborationModal.setIsDisplayed(true),
                "data-test": "active-employer-collaboration-btn",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                        children: isInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$79e71d77d4eb0b38), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "span",
                        children: label || (isInactive ? "R\xe9int\xe9grer" : "Ne plus travailler avec cet int\xe9rimaire")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $70ea9d7f0e6c7fb1$export$2e2bcd8739ae039), {
                show: employerCollaborationModal.isDisplayed,
                onConfirm: handleActiveEmployerCollaborationToggle,
                onCancel: ()=>employerCollaborationModal.setIsDisplayed(false),
                confirmButtonProps: {
                    color: isInactive ? 'primary' : 'danger',
                    disabled: false
                },
                title: isInactive ? "R\xe9int\xe9grer l'int\xe9rimaire" : "Ne plus travailler avec cet int\xe9rimaire",
                confirmButtonLabel: isInactive ? "R\xe9int\xe9grer" : 'Ne plus travailler avec',
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    children: isInactive ? "\xcates-vous s\xfbr de vouloir r\xe9int\xe9grer cet int\xe9rimaire ? Il pourra \xe0 nouveau \xeatre affect\xe9 \xe0 des missions par les agences." : "\xcates-vous s\xfbr de ne plus vouloir travailler avec cet int\xe9rimaire ? Les agences ne pourront plus l'affecter \xe0 vos missions."
                })
            })
        ]
    });
};
var $ffe29775123abb75$export$2e2bcd8739ae039 = $ffe29775123abb75$var$ActiveEmployerCollaborationButton;






/**
 * Component to display actions available for a worker
 */ const $326f04554d61d81d$var$WorkerActions = ({ worker: worker, isEmployerCollaborationInactive: isEmployerCollaborationInactive, isExternalWorker: isExternalWorker, association: association })=>{
    const actions = $326f04554d61d81d$var$useActions(worker, isEmployerCollaborationInactive, isExternalWorker, association);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dd1d1753cdfb51cf$export$2e2bcd8739ae039), {
        actions: actions
    });
};
var $326f04554d61d81d$export$2e2bcd8739ae039 = $326f04554d61d81d$var$WorkerActions;
const $326f04554d61d81d$var$useActions = (worker, isEmployerCollaborationInactive, isExternalWorker, association)=>{
    const modal = (0, $6d829f16d3c4ab1d$export$33ffd74ebf07f060)();
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    const workerCounters = (0, $8e9b7320493de555$export$ec101cf448daac1)({
        worker: worker._id
    }, {
        enabled: Boolean(worker._id)
    });
    const qrCode = (0, $ca4535f1fdcf3410$export$2e2bcd8739ae039)(worker._id, isExternalWorker);
    const workerAssociation = currentOrganization && (0, $25ffbf4bca475b04$export$91d1acdd7472079)(worker, currentOrganization);
    const isActive = workerAssociation?.status === 'accepted';
    // State pour gérer la modale des compteurs
    const [selectedWorkerCounter, setSelectedWorkerCounter] = (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useState(null);
    // Réinitialiser le worker counter sélectionné quand la modale se ferme
    (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useEffect(()=>{
        if (!modal.isDisplayed) setSelectedWorkerCounter(null);
    }, [
        modal.isDisplayed
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            isExternalWorker && {
                title: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon).Text, {
                            children: "Collaboration avec l'int\xe9rimaire"
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                            color: isEmployerCollaborationInactive ? 'danger' : 'success',
                            children: isEmployerCollaborationInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$79e71d77d4eb0b38), {}) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e0de785befddd5e2$export$7dd004358974b05d), {})
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: isEmployerCollaborationInactive ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "p",
                                mb: 3,
                                children: "Vous avez signal\xe9 aux agences que vous ne souhaitez plus travailler avec cet int\xe9rimaire."
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ffe29775123abb75$export$2e2bcd8739ae039), {
                                user: worker,
                                isInactive: true
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "p",
                                mb: 3,
                                children: [
                                    "Si vous ne souhaitez plus travailler avec cet int\xe9rimaire, vous pouvez le signaler aux agences ici.",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    " Vous pourrez le r\xe9int\xe9grer \xe0 tout moment."
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ffe29775123abb75$export$2e2bcd8739ae039), {
                                user: worker,
                                isInactive: false
                            })
                        ]
                    })
                })
            },
            !isExternalWorker && association && {
                title: 'Informations',
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                        renderAs: "p",
                        mb: 3,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns), {
                                mt: 3,
                                children: [
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                        roles: [
                                            'employerMember'
                                        ],
                                        children: (()=>{
                                            const activeSchedule = (0, $25ffbf4bca475b04$export$515cc9cea50b06c3)(association);
                                            return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 3,
                                                        py: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                renderAs: "strong",
                                                                children: "Heures mensuelles: "
                                                            }),
                                                            activeSchedule?.monthlyHoursWorked ?? 'N/A',
                                                            " h/mois"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                                        size: 3,
                                                        py: 1,
                                                        children: [
                                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                                renderAs: "strong",
                                                                children: "Heures hebdomadaires: "
                                                            }),
                                                            activeSchedule?.weeklyHoursWorked ?? 'N/A',
                                                            " h/sem"
                                                        ]
                                                    })
                                                ]
                                            });
                                        })()
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 12,
                                        py: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: "Informations suppl\xe9mentaires: "
                                            }),
                                            association.internalComment || 'N/A'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Columns).Column, {
                                        size: 12,
                                        py: 1,
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                                renderAs: "strong",
                                                children: "Informations interne: "
                                            }),
                                            association.internalInformation || 'N/A'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8d20ace6564ce308$export$2e2bcd8739ae039), {
                                user: worker,
                                userRoleKind: "worker",
                                label: "Modifier",
                                color: 'primary'
                            })
                        ]
                    })
                })
            },
            workerCounters.data?.[0] && !isExternalWorker && {
                title: 'Compteurs',
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "p",
                            mb: 3,
                            children: workerCounters.data?.map((counter)=>/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                    mb: 2,
                                    children: [
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "strong",
                                            children: [
                                                counter.template.name,
                                                ": "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                            renderAs: "span",
                                            style: {
                                                cursor: 'pointer',
                                                textDecoration: 'underline'
                                            },
                                            onClick: ()=>{
                                                setSelectedWorkerCounter(counter);
                                                modal.setIsDisplayed(true);
                                            },
                                            children: (0, $74f17ceb9b5a08a5$export$bc733b0c5cbb3e8a)(counter.currentValue)
                                        })
                                    ]
                                }, counter._id))
                        }),
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97bb431efbba50b5$export$2e2bcd8739ae039), {
                            workerCounter: selectedWorkerCounter || undefined,
                            isDisplayed: modal.isDisplayed,
                            setIsDisplayed: modal.setIsDisplayed
                        })
                    ]
                })
            },
            {
                title: 'Impression QR code',
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "p",
                            mb: 3,
                            children: isExternalWorker && !qrCode ? /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: "Pour les int\xe9rimaires, le QR code n'est disponible que pendant une mission active ou dans les 3 jours pr\xe9c\xe9dant son d\xe9but."
                            }) : /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                                children: [
                                    "Vous pouvez imprimer le QR code du travailleur afin qu'il puisse pointer sans son smartphone. ",
                                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("br", {}),
                                    "Cependant, il est pr\xe9f\xe9rable pour des raisons de s\xe9curit\xe9 et de suivi que les travailleurs utilisent l'application mobile."
                                ]
                            })
                        }),
                        qrCode && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f96e282bde6594fa$export$2e2bcd8739ae039), {
                            user: worker,
                            color: "primary",
                            label: "Afficher le QR code",
                            canRegenerate: false,
                            isExternalWorker: isExternalWorker
                        })
                    ]
                })
            },
            !isExternalWorker && association && {
                title: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Icon).Text, {
                    children: [
                        "Collaboration",
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $561daf7ffa20c908$export$2e2bcd8739ae039), {
                            role: association
                        })
                    ]
                }),
                content: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            renderAs: "p",
                            mb: 3,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $21fbc4cf82aea7d6$export$2e2bcd8739ae039), {
                                role: association
                            })
                        }),
                        (association.status === 'accepted' || association.status === 'pending') && /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2cdd0a2d0aa6b53d$export$2e2bcd8739ae039), {
                            user: worker,
                            color: "danger",
                            roleKind: "worker",
                            organization: currentOrganization
                        })
                    ]
                })
            }
        ].filter((v)=>v), [
        worker,
        modal,
        isActive,
        isExternalWorker,
        isEmployerCollaborationInactive,
        qrCode,
        association
    ]);
};






/**
 * Page de détails d'un travailleur
 * Affiche les informations personnelles, associations, historique etc.
 */ const $cd7aeaa0fbea92d5$var$WorkerDetails = ()=>{
    const currentOrganization = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentOrganization);
    (0, $1fe0f8cc717c9c0f$export$2e2bcd8739ae039)('') // TEMP: Preload workers search to avoid empty workers filter on work periods list
    ;
    const { setFilters: setFilters, filters: filters } = (0, $88915728c129ec8c$export$2e2bcd8739ae039)((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods);
    const navigate = (0, $39b0bf07af9c8a3f$export$9770f232ac06a008)();
    const { id: id } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: worker } = (0, $e607e015ac40917d$export$1884facae6ee36d8)(id);
    const { data: workPeriods } = (0, $7040c29cc25c4df6$export$57d45acb75ee0b10)({
        user: [
            id
        ],
        start: (0, $8b3f11de065b50b0$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(new Date(), -7).toISOString())),
        end: (0, $e94c78fdddee0309$export$2e2bcd8739ae039)((0, $bbf3e9545cdc59c8$export$2e2bcd8739ae039)((0, $ffff430a208564ac$export$2e2bcd8739ae039)(new Date(), 7).toISOString())),
        summary: true
    }, {
        enabled: Boolean(id)
    });
    const { isInternalWorker: isInternalWorker, association: association } = (0, $bfb5326f26f58717$export$444ac08f60757df7)(worker);
    const isExternalWorker = !isInternalWorker;
    const employerRelation = worker && (0, $25ffbf4bca475b04$export$6b3b70a0a244f047)(worker, currentOrganization);
    const breadcrumbs = $cd7aeaa0fbea92d5$var$useBreadcrumbs(id);
    const isEmployerCollaborationInactive = Boolean(employerRelation?.collaboration?.isInactive);
    const handleWorkPeriodsListNavigation = ()=>{
        if (!worker) return;
        setFilters((0, $7093b8da8664ce76$export$d514d78c9201a2e7).workPeriods, {
            ...filters,
            user: [
                worker._id
            ]
        });
        navigate('/work-periods');
    };
    if (!worker) return null;
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $46990718fa364fdf$export$2e2bcd8739ae039), {
                                items: breadcrumbs
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "flex-start",
                        mb: 6,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
                                title: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $16a49d1992c78b37$export$2e2bcd8739ae039), {
                                    user: worker
                                }),
                                subTitle: association?.internalRef
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                        size: 5,
                        children: "Journ\xe9es de travail des 7 derniers et prochains jours"
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        mb: 1,
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2ac56eaf11a5826b$export$2e2bcd8739ae039), {
                            workPeriods: workPeriods ?? [],
                            omitKeys: [
                                'validateAction',
                                'user',
                                'mission.dates'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                            textAlign: 'right',
                            textColor: "link",
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                                renderAs: "a",
                                onClick: ()=>handleWorkPeriodsListNavigation(),
                                children: "Voir plus"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            {
                                role: 'employerMember',
                                action: {
                                    resource: 'users',
                                    name: 'update'
                                }
                            },
                            'interimAgencyMember'
                        ],
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Heading), {
                                size: 5,
                                mt: 6,
                                children: "Informations & Actions"
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card), {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Card).Content, {
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $326f04554d61d81d$export$2e2bcd8739ae039), {
                                        worker: worker,
                                        isEmployerCollaborationInactive: isEmployerCollaborationInactive,
                                        isExternalWorker: isExternalWorker,
                                        association: association
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $cd7aeaa0fbea92d5$export$2e2bcd8739ae039 = $cd7aeaa0fbea92d5$var$WorkerDetails;
// Hooks
const $cd7aeaa0fbea92d5$var$useBreadcrumbs = (workerId)=>(0, (/*@__PURE__*/$parcel$interopDefault($3ZYaX))).useMemo(()=>[
            {
                label: 'Travailleurs',
                to: '/settings/workers'
            },
            {
                label: "D\xe9tails du travailleur"
            }
        ], [
        workerId
    ]);



parcelRequire("3ZYaX");













const $3036ad23542b3691$var$EmployerDetails = ()=>{
    const { id: id, isNew: isNew } = (0, $63c662283bf01ad2$export$2e2bcd8739ae039)();
    const { data: organization } = (0, $58f46cb3f921014b$export$6bc6640ee85e2402)(id, 'employer');
    const mutationState = (0, $9dc9b58c4343865b$export$29ea95f3fea1dc1c)(isNew ? (0, $58f46cb3f921014b$export$4a6f974b4208311)() : (0, $58f46cb3f921014b$export$a6fe4df8bec26327)());
    const formWrapperProps = (0, $1993f4b353339a80$export$46e69a1ed5a53805)($3036ad23542b3691$var$formWrapperBaseProps, //@ts-expect-error
    mutationState, !isNew);
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $334d6d5468272b41$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Section), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Container), {
                max: true,
                breakpoint: "desktop",
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Level), {
                        alignItems: "flex-start",
                        mb: 6,
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bb3d4b045c8b02e8$export$2e2bcd8739ae039), {
                                    title: isNew ? 'Nouvel Employeur' : organization?.name || '',
                                    subTitle: isNew ? "Cr\xe9er un Nouvel Employeur" : "Param\xe8tres et Relations de l'Employeur"
                                })
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Level).Side, {
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                    roles: [
                                        'superAdmin'
                                    ],
                                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Button), {
                                        renderAs: (0, $d7b8f401c6bc9326$export$a6c7ac8248d6e38a),
                                        to: "/employers",
                                        outlined: true,
                                        color: "primary",
                                        size: "small",
                                        children: [
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ce48c6296f76f7cc$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)("span", {
                                                children: "Liste des Employeurs"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9b908348a81c2565$export$2e2bcd8739ae039), {
                            ...formWrapperProps,
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4de84fd4014af675$export$2e2bcd8739ae039), {
                                organization: organization
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Box), {
                            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dd21d85958cb32aa$export$2e2bcd8739ae039), {
                                rules: organization?.rules?.missions
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $3036ad23542b3691$export$2e2bcd8739ae039 = $3036ad23542b3691$var$EmployerDetails;
const $3036ad23542b3691$var$formWrapperBaseProps = {
    loadingProps: {
        body: "Enregistrement de l'Employeur..."
    },
    successProps: {
        title: "Employeur cr\xe9\xe9",
        body: {
            description: "L'Employeur a \xe9t\xe9 cr\xe9\xe9",
            actions: [
                {
                    label: 'Nouvel Employeur'
                },
                {
                    label: "Retourner \xe0 la liste",
                    to: '/employers'
                }
            ]
        }
    }
};


const $9b9500d324c8bc2f$var$useRoute = ()=>{
    return (0, $39b0bf07af9c8a3f$export$5d3fca4a98652595)([
        //Guest
        {
            path: '/complete-profile',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $022fb11b099c3478$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ec4c0c4a79db7ca6$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/request-new-password',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $022fb11b099c3478$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0c8722c9b7e06421$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/reset-password',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $022fb11b099c3478$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $829c3c82953b9eca$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/login',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $022fb11b099c3478$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $aeb9e0714ba9107e$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/privacy-policy',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $05851b9543b5f38b$export$d5a29154259e944d), {})
        },
        {
            path: '/terms-of-use',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $77ccf7d3ada90b83$export$3b099986889b4c15), {})
        },
        //Authenticated
        {
            path: '/qr-scanner',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'superAdmin'
                ],
                action: {
                    resource: 'clockings',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c93d76b9aedf6493$export$2e2bcd8739ae039), {
                    scanner: "camera"
                })
            })
        },
        {
            path: '/laser-scanner',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'superAdmin'
                ],
                action: {
                    resource: 'clockings',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c93d76b9aedf6493$export$2e2bcd8739ae039), {
                    scanner: "laser"
                })
            })
        },
        {
            path: '/kiosk',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'superAdmin'
                ],
                action: {
                    resource: 'clockings',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e3a4562d17ac3ce9$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/errors/no-active-role',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $eeaf532277850094$export$2e2bcd8739ae039), {})
        },
        {
            path: '/help',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b35b9893d35ab6f$export$b6953bf6479305bd), {})
            })
        },
        {
            path: '/whatsnew',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember',
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1ed8238d8466ee53$export$6db44f1e04c7ab18), {})
            })
        },
        {
            path: '/missions/new',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'create'
                },
                organizationOptions: [
                    {
                        organizationType: 'employer',
                        option: 'biPart'
                    }
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $50d4fd76d5361237$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/missions/:id/edit',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'update'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $50d4fd76d5361237$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/missions/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $7c4f4480d5176db2$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/missions',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $4357da94769bbff7$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/missions/:missionId/work-periods/:workPeriodId',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $27fe9c3618eab2a3$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/work-periods',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $058de93c047aef33$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/agencies',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9e985edbe8da8f5c$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/agencies/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $567c8e31102994db$export$2e2bcd8739ae039), {
                    mode: "urlId"
                })
            }),
            children: [
                {
                    path: 'app-subscription-options',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f5b861c8e469154f$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'info',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3e71c0ff5f0f49f1$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'partner-employers',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e63ef777e185c0cc$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'app-subscription-periods/:appSubscriptionPeriodId',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $afd09a869d7c7d4c$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'app-subscription-periods',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $19605edf5f74c759$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'terminals',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2a141b65bd87c583$export$2e2bcd8739ae039), {})
                }
            ]
        },
        {
            path: '/employers/new',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3036ad23542b3691$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/employers',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f71d69d0ae36cfc9$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/employers/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $57c4ccd637758f10$export$2e2bcd8739ae039), {
                    mode: "urlId"
                })
            }),
            children: [
                {
                    path: 'info',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bf29aada97ac0cac$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'employer-rules',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d8ce95e92ae5a829$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'employer-rules/:employerRuleId',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1f6947e60bd29be4$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'work-period-events',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a1bd6ea7ba5875a1$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'terminals',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9e82a3db7aacefe3$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'worker-counters',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $791ab37cee9044dc$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'worker-counters/:workerCounterTemplateId',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b40f6a42735823bc$export$2e2bcd8739ae039), {})
                },
                {
                    path: 'special-periods',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f6c7708134c5b82d$export$2e2bcd8739ae039), {})
                }
            ]
        },
        {
            path: '/workers/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'users',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cd7aeaa0fbea92d5$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/settings',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'organizations',
                    name: 'update'
                },
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $57c4ccd637758f10$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $567c8e31102994db$export$2e2bcd8739ae039), {
                            mode: 'currentOrganization'
                        })
                    })
                ]
            }),
            children: [
                {
                    path: 'info',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $bf29aada97ac0cac$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3e71c0ff5f0f49f1$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                },
                {
                    path: 'clocking-rules/:id',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ec19c1e625e43b58$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'clocking-rules',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $15da81b9bb1f5579$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'employer-rules',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d8ce95e92ae5a829$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'partners-agencies',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5db47c9cb3d3d718$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'work-period-events',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $a1bd6ea7ba5875a1$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'job-titles/:id',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ac4d47821c950761$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'job-titles',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2318d4709c8d8838$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'workers',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $db3c1357fa19f5ef$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $6fe40cbdf6880d16$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                },
                {
                    path: 'members',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f9b2829b063503d1$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b27717c726d3e72d$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                },
                {
                    path: 'labor-costs-coefficients',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $97f0cbc7882544d0$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'app-subscription-periods/:appSubscriptionPeriodId',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $afd09a869d7c7d4c$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'app-subscription-periods',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $19605edf5f74c759$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'partner-employers',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $e63ef777e185c0cc$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'partner-employers/:id',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $de925e806d0bdd64$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'terminals',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $4801813bf62cee3c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'employerMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9e82a3db7aacefe3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                                roles: [
                                    'interimAgencyMember'
                                ],
                                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $2a141b65bd87c583$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                },
                {
                    path: 'services',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $740256d448e7d59e$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'worker-counters',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $791ab37cee9044dc$export$2e2bcd8739ae039), {})
                    })
                },
                {
                    path: 'work-period-tags',
                    element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5f8ab0e785410125$export$2e2bcd8739ae039), {})
                    })
                }
            ]
        },
        {
            path: '/clockings',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'clockings',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $9758083a3d76fd58$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/summary',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3b05ff530aceedcc$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/payroll',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'missions',
                    name: 'read'
                },
                organizationOptions: [
                    {
                        organizationType: 'employer',
                        option: 'biPart'
                    }
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c0b959f361e26c0d$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/super-admins',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b90bbdefdce036cd$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/me/organizations',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $30ec2b5d5f16d47d$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/me',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $ceb5ab6e94f2b9d0$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/me/notifications',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $080f05119e7532be$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/print-qr/:userId',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3bec4a3b5bb6331c$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/associations',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'interimAgencyMember'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3276e789a859c4c6$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/pre-billings',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'periodSummaries',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d3de4d777df3a8ad$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/pre-billings/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'periodSummaries',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $99caba60ef1a7ba9$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/workers-requests',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $207d7f53b8127018$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/workers-requests/new',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3a1e90befefe2939$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/workers-requests/:id/new',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'create'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3a1e90befefe2939$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/workers-requests/:id/edit',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'update'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $3a1e90befefe2939$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/workers-requests/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'employerMember',
                    'interimAgencyMember'
                ],
                action: {
                    resource: 'workersRequests',
                    name: 'read'
                },
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b29163ef76d8b0e3$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'worker'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dfd33536f4faad9d$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'interimAgencyMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $1bd9ad95b1a12976$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'superAdmin'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0aac2f78455cfee7$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                        roles: [
                            'employerMember'
                        ],
                        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $0b845de638b8eeaa$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        },
        {
            path: '/kpi',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'employerMember'
                    ],
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c646ea6e9b05f349$export$8266bebc0b1985a1), {})
                })
            })
        },
        {
            path: '/admin/billing',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'superAdmin'
                    ],
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $de104446ac90b824$export$2e2bcd8739ae039), {})
                })
            })
        },
        {
            path: '/dev/forms',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $8403deec6a28521e$export$2e2bcd8739ae039), {
                    roles: [
                        'superAdmin'
                    ],
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cc45be437717052c$export$8f902583ed89d9ba), {})
                })
            })
        },
        //Common
        {
            path: '/validate-new-email',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $03b0d7bfb7bf5f57$export$2e2bcd8739ae039), {})
        },
        {
            path: '/terminals',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $b7840217f2173893$export$2e2bcd8739ae039), {})
            })
        },
        {
            path: '/terminals/:id',
            element: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $cb3505f3ee5948df$export$2e2bcd8739ae039), {
                roles: [
                    'superAdmin'
                ],
                children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $dae377ae4cc3971e$export$2e2bcd8739ae039), {})
            })
        }
    ]);
};
var $9b9500d324c8bc2f$export$2e2bcd8739ae039 = $9b9500d324c8bc2f$var$useRoute;




parcelRequire("3ZYaX");


const $c80d8aa57d3a0f45$var$NetworkError = ()=>{
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $5f5847b2c95a3fab$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $f0a9601245d0def2$exports.Element), {
            textAlign: "center",
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Icon), {
                    size: 'large',
                    children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $34481298a5a37083$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Element), {
                    textSize: 3,
                    textAlign: "center",
                    children: "Service temporairement indisponible"
                }),
                "Merci de r\xe9essayer dans une minute ou de contacter le service technique si le probl\xe8me persiste"
            ]
        })
    });
};
var $c80d8aa57d3a0f45$export$2e2bcd8739ae039 = $c80d8aa57d3a0f45$var$NetworkError;





const $52886c6a6bd3cde4$var$App = ()=>{
    // Get route by pathname
    const route = (0, $9b9500d324c8bc2f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($52886c6a6bd3cde4$var$NetworkError, {
        children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)($52886c6a6bd3cde4$var$CheckIsAuth, {
            children: [
                /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)($52886c6a6bd3cde4$var$ThemeSwitcher, {}),
                route
            ]
        })
    });
};
var $52886c6a6bd3cde4$export$2e2bcd8739ae039 = $52886c6a6bd3cde4$var$App;
const $52886c6a6bd3cde4$var$CheckIsAuth = ({ children: children })=>{
    const session = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session);
    (0, $e607e015ac40917d$export$9e7b71bcd5abe16a)();
    if (session.isInitialized) return children;
    else return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $f0a9601245d0def2$exports.Loader), {});
};
const $52886c6a6bd3cde4$var$ThemeSwitcher = ()=>{
    const currentUserRole = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>state.session.currentUserRole);
    (0, $97a9e9f5b9c67d9e$export$2e2bcd8739ae039)(currentUserRole);
    return null;
};
const $52886c6a6bd3cde4$var$NetworkError = ({ children: children })=>{
    const [isNetworkOnError] = (0, $d6640a748633e476$export$2e2bcd8739ae039)((state)=>[
            state.session.isNetworkOnError
        ], (0, $b46b478a1bec4671$exports.shallow));
    if (isNetworkOnError) return /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $c80d8aa57d3a0f45$export$2e2bcd8739ae039), {});
    return children;
};




'use client';
const $d23ecd538185ebf1$export$fd1469cb3147d866 = function() {
    return null;
};
const $d23ecd538185ebf1$export$6d64409a8b475869 = function() {
    return null;
};


const $c4c852c10fb562b6$var$container = document.getElementById('app');
const $c4c852c10fb562b6$var$root = (0, $6f672a7ea02fd929$export$882461b6382ed46c)($c4c852c10fb562b6$var$container) // createRoot(container!) if you use TypeScript
;
$c4c852c10fb562b6$var$root.render(/*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsxs)((0, $619931fcf5fffd95$export$45604f0cc8ae667b), {
    client: (0, $9dc9b58c4343865b$export$7c07b633a151f9c5),
    children: [
        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d7b8f401c6bc9326$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $52886c6a6bd3cde4$export$2e2bcd8739ae039), {})
        }),
        /*#__PURE__*/ (0, $4801813bf62cee3c$exports.jsx)((0, $d23ecd538185ebf1$export$fd1469cb3147d866), {})
    ]
}));


//# sourceMappingURL=index.7d4a26f0.js.map
